/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/webpack/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3675);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(726);
} else {
  module.exports = require('./cjs/react.development.js');
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2190)();
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
})(this, function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    var some$1 = some;

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var keys$1 = keys;

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/; //       0 - 9
    var match2 = /\d\d/; //      00 - 99
    var match3 = /\d{3}/; //     000 - 999
    var match4 = /\d{4}/; //    0000 - 9999
    var match6 = /[+-]?\d{6}/; // -999999 - 999999
    var match1to2 = /\d\d?/; //       0 - 99
    var match3to4 = /\d\d\d\d?/; //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/; //       0 - 999
    var match1to4 = /\d{1,4}/; //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf
    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    var indexOf$1 = indexOf;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,

        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays : this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // months
    // week
    // weekdays
    // meridiem
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                __webpack_require__(3597)("./" + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys$1(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];

    // iso time formats and regexes
    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var string, match, dayFormat, dateFormat, timeFormat, tzFormat;
        var timezones = {
            ' GMT': ' +0000',
            ' EDT': ' -0400',
            ' EST': ' -0500',
            ' CDT': ' -0500',
            ' CST': ' -0600',
            ' MDT': ' -0600',
            ' MST': ' -0700',
            ' PDT': ' -0700',
            ' PST': ' -0800'
        };
        var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
        var timezone, timezoneIndex;

        string = config._i.replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
        match = basicRfcRegex.exec(string);

        if (match) {
            dayFormat = match[1] ? 'ddd' + (match[1].length === 5 ? ', ' : ' ') : '';
            dateFormat = 'D MMM ' + (match[2].length > 10 ? 'YYYY ' : 'YY ');
            timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            if (match[1]) {
                // day of week given
                var momentDate = new Date(match[2]);
                var momentDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][momentDate.getDay()];

                if (match[1].substr(0, 3) !== momentDay) {
                    getParsingFlags(config).weekdayMismatch = true;
                    config._isValid = false;
                    return;
                }
            }

            switch (match[5].length) {
                case 2:
                    // military
                    if (timezoneIndex === 0) {
                        timezone = ' +0000';
                    } else {
                        timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                        timezone = (timezoneIndex < 0 ? ' -' : ' +') + ('' + timezoneIndex).replace(/^-?/, '0').match(/..$/)[0] + '00';
                    }
                    break;
                case 4:
                    // Zone
                    timezone = timezones[match[5]];
                    break;
                default:
                    // UT or +/-9999
                    timezone = timezones[' GMT'];
            }
            match[5] = timezone;
            config._i = match.splice(1).join('');
            tzFormat = ' ZZ';
            config._f = dayFormat + dateFormat + timeFormat + tzFormat;
            configFromStringAndFormat(config);
            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    });

    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,

        // matching against regexp is expensive, do it on demand
        match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;val = period;period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) && (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        if (!this.isValid()) {
            return null;
        }
        var m = this.clone().utc();
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            return this.toDate().toISOString();
        }
        return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    function startOf(units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;

    // Year
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;

    // Week Year
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    proto.quarter = proto.quarters = getSetQuarter;

    // Month
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

    // Week
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;

    // Hour
    proto.hour = proto.hours = getSetHour;

    // Minute
    proto.minute = proto.minutes = getSetMinute;

    // Second
    proto.second = proto.seconds = getSetSecond;

    // Millisecond
    proto.millisecond = proto.milliseconds = getSetMillisecond;

    // Offset
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;

    // Timezone
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

    // Deprecations
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    // Month
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;

    // Week
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    // Hours
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asYears = makeAs('y');

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month
        M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    // Deprecations
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.18.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    return hooks;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Relay v1.6.2
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

module.exports = __webpack_require__(2384);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addons_Confirm__ = __webpack_require__(2482);
/* unused harmony reexport Confirm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addons_MountNode__ = __webpack_require__(1275);
/* unused harmony reexport MountNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addons_Pagination__ = __webpack_require__(2490);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Pagination_PaginationItem__ = __webpack_require__(1276);
/* unused harmony reexport PaginationItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Portal__ = __webpack_require__(366);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addons_Portal_PortalInner__ = __webpack_require__(1277);
/* unused harmony reexport PortalInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addons_Radio__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_6__addons_Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addons_Ref__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__addons_Ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addons_Ref_RefFindNode__ = __webpack_require__(1278);
/* unused harmony reexport RefFindNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_Ref_RefForward__ = __webpack_require__(1279);
/* unused harmony reexport RefForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addons_Responsive__ = __webpack_require__(2495);
/* unused harmony reexport Responsive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addons_Select__ = __webpack_require__(1280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__addons_Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__addons_TextArea__ = __webpack_require__(1281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_12__addons_TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__addons_TransitionablePortal__ = __webpack_require__(2500);
/* unused harmony reexport TransitionablePortal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__behaviors_Visibility__ = __webpack_require__(2502);
/* unused harmony reexport Visibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Breadcrumb__ = __webpack_require__(2504);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Breadcrumb_BreadcrumbDivider__ = __webpack_require__(1282);
/* unused harmony reexport BreadcrumbDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Breadcrumb_BreadcrumbSection__ = __webpack_require__(1283);
/* unused harmony reexport BreadcrumbSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__collections_Form__ = __webpack_require__(2506);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormButton__ = __webpack_require__(1284);
/* unused harmony reexport FormButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collections_Form_FormCheckbox__ = __webpack_require__(1285);
/* unused harmony reexport FormCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__collections_Form_FormDropdown__ = __webpack_require__(1286);
/* unused harmony reexport FormDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__collections_Form_FormField__ = __webpack_require__(179);
/* unused harmony reexport FormField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormGroup__ = __webpack_require__(1287);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__collections_Form_FormInput__ = __webpack_require__(1288);
/* unused harmony reexport FormInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__collections_Form_FormRadio__ = __webpack_require__(1289);
/* unused harmony reexport FormRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__collections_Form_FormSelect__ = __webpack_require__(1290);
/* unused harmony reexport FormSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__collections_Form_FormTextArea__ = __webpack_require__(1291);
/* unused harmony reexport FormTextArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__collections_Grid__ = __webpack_require__(2507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_28__collections_Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__collections_Grid_GridColumn__ = __webpack_require__(760);
/* unused harmony reexport GridColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__collections_Grid_GridRow__ = __webpack_require__(1293);
/* unused harmony reexport GridRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__collections_Menu__ = __webpack_require__(1297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_31__collections_Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__collections_Menu_MenuHeader__ = __webpack_require__(1295);
/* unused harmony reexport MenuHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__collections_Menu_MenuItem__ = __webpack_require__(761);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__collections_Menu_MenuMenu__ = __webpack_require__(1296);
/* unused harmony reexport MenuMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__collections_Message__ = __webpack_require__(2509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_35__collections_Message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__collections_Message_MessageContent__ = __webpack_require__(1298);
/* unused harmony reexport MessageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__collections_Message_MessageHeader__ = __webpack_require__(1299);
/* unused harmony reexport MessageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__collections_Message_MessageItem__ = __webpack_require__(762);
/* unused harmony reexport MessageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__collections_Message_MessageList__ = __webpack_require__(1300);
/* unused harmony reexport MessageList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__collections_Table__ = __webpack_require__(2511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_40__collections_Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__collections_Table_TableBody__ = __webpack_require__(1301);
/* unused harmony reexport TableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__collections_Table_TableCell__ = __webpack_require__(482);
/* unused harmony reexport TableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__collections_Table_TableFooter__ = __webpack_require__(1302);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__collections_Table_TableHeader__ = __webpack_require__(763);
/* unused harmony reexport TableHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__collections_Table_TableHeaderCell__ = __webpack_require__(1303);
/* unused harmony reexport TableHeaderCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__collections_Table_TableRow__ = __webpack_require__(1304);
/* unused harmony reexport TableRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__elements_Button_Button__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_47__elements_Button_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__elements_Button_ButtonContent__ = __webpack_require__(1305);
/* unused harmony reexport ButtonContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__elements_Button_ButtonGroup__ = __webpack_require__(1306);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__elements_Button_ButtonOr__ = __webpack_require__(1307);
/* unused harmony reexport ButtonOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__elements_Container__ = __webpack_require__(2513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_51__elements_Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__elements_Divider__ = __webpack_require__(2515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_52__elements_Divider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__elements_Flag__ = __webpack_require__(1308);
/* unused harmony reexport Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__elements_Header__ = __webpack_require__(2518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_54__elements_Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__elements_Header_HeaderContent__ = __webpack_require__(1309);
/* unused harmony reexport HeaderContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__elements_Header_HeaderSubheader__ = __webpack_require__(1310);
/* unused harmony reexport HeaderSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__elements_Icon__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_57__elements_Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__elements_Icon_IconGroup__ = __webpack_require__(1311);
/* unused harmony reexport IconGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__elements_Image__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_59__elements_Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__elements_Image_ImageGroup__ = __webpack_require__(1313);
/* unused harmony reexport ImageGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__elements_Input__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_61__elements_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__elements_Label__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_62__elements_Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__elements_Label_LabelDetail__ = __webpack_require__(1314);
/* unused harmony reexport LabelDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__elements_Label_LabelGroup__ = __webpack_require__(1315);
/* unused harmony reexport LabelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__elements_List__ = __webpack_require__(2521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_65__elements_List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__elements_List_ListContent__ = __webpack_require__(767);
/* unused harmony reexport ListContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__elements_List_ListDescription__ = __webpack_require__(486);
/* unused harmony reexport ListDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__elements_List_ListHeader__ = __webpack_require__(487);
/* unused harmony reexport ListHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__elements_List_ListIcon__ = __webpack_require__(768);
/* unused harmony reexport ListIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__elements_List_ListItem__ = __webpack_require__(1316);
/* unused harmony reexport ListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__elements_List_ListList__ = __webpack_require__(1317);
/* unused harmony reexport ListList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__elements_Loader__ = __webpack_require__(2523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_72__elements_Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__elements_Placeholder__ = __webpack_require__(2525);
/* unused harmony reexport Placeholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__elements_Placeholder_PlaceholderHeader__ = __webpack_require__(1318);
/* unused harmony reexport PlaceholderHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__elements_Placeholder_PlaceholderImage__ = __webpack_require__(1319);
/* unused harmony reexport PlaceholderImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__elements_Placeholder_PlaceholderLine__ = __webpack_require__(1320);
/* unused harmony reexport PlaceholderLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__elements_Placeholder_PlaceholderParagraph__ = __webpack_require__(1321);
/* unused harmony reexport PlaceholderParagraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__elements_Rail__ = __webpack_require__(2527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_78__elements_Rail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__elements_Reveal__ = __webpack_require__(2529);
/* unused harmony reexport Reveal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__elements_Reveal_RevealContent__ = __webpack_require__(1322);
/* unused harmony reexport RevealContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__elements_Segment__ = __webpack_require__(2530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_81__elements_Segment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__elements_Segment_SegmentGroup__ = __webpack_require__(1324);
/* unused harmony reexport SegmentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__elements_Segment_SegmentInline__ = __webpack_require__(1325);
/* unused harmony reexport SegmentInline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__elements_Step__ = __webpack_require__(2531);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__elements_Step_StepContent__ = __webpack_require__(1327);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__elements_Step_StepDescription__ = __webpack_require__(769);
/* unused harmony reexport StepDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__elements_Step_StepGroup__ = __webpack_require__(1328);
/* unused harmony reexport StepGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__elements_Step_StepTitle__ = __webpack_require__(770);
/* unused harmony reexport StepTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__modules_Accordion_Accordion__ = __webpack_require__(2553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_89__modules_Accordion_Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__modules_Accordion_AccordionAccordion__ = __webpack_require__(1331);
/* unused harmony reexport AccordionAccordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__modules_Accordion_AccordionContent__ = __webpack_require__(772);
/* unused harmony reexport AccordionContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__modules_Accordion_AccordionPanel__ = __webpack_require__(773);
/* unused harmony reexport AccordionPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__modules_Accordion_AccordionTitle__ = __webpack_require__(774);
/* unused harmony reexport AccordionTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__modules_Checkbox__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_94__modules_Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__modules_Dimmer__ = __webpack_require__(1334);
/* unused harmony reexport Dimmer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__modules_Dimmer_DimmerDimmable__ = __webpack_require__(1332);
/* unused harmony reexport DimmerDimmable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__modules_Dimmer_DimmerInner__ = __webpack_require__(1333);
/* unused harmony reexport DimmerInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__modules_Dropdown__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_98__modules_Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__modules_Dropdown_DropdownDivider__ = __webpack_require__(1335);
/* unused harmony reexport DropdownDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__modules_Dropdown_DropdownHeader__ = __webpack_require__(1336);
/* unused harmony reexport DropdownHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__modules_Dropdown_DropdownItem__ = __webpack_require__(1337);
/* unused harmony reexport DropdownItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__modules_Dropdown_DropdownMenu__ = __webpack_require__(1338);
/* unused harmony reexport DropdownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__modules_Dropdown_DropdownSearchInput__ = __webpack_require__(1339);
/* unused harmony reexport DropdownSearchInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__modules_Embed__ = __webpack_require__(2558);
/* unused harmony reexport Embed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__modules_Modal__ = __webpack_require__(1344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_105__modules_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__modules_Modal_ModalActions__ = __webpack_require__(1340);
/* unused harmony reexport ModalActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__modules_Modal_ModalContent__ = __webpack_require__(1341);
/* unused harmony reexport ModalContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__modules_Modal_ModalDescription__ = __webpack_require__(1342);
/* unused harmony reexport ModalDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__modules_Modal_ModalHeader__ = __webpack_require__(1343);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__modules_Popup__ = __webpack_require__(2561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_110__modules_Popup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__modules_Popup_PopupContent__ = __webpack_require__(1345);
/* unused harmony reexport PopupContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__modules_Popup_PopupHeader__ = __webpack_require__(1346);
/* unused harmony reexport PopupHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__modules_Progress__ = __webpack_require__(2565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_113__modules_Progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__modules_Rating__ = __webpack_require__(2567);
/* unused harmony reexport Rating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__modules_Rating_RatingIcon__ = __webpack_require__(1347);
/* unused harmony reexport RatingIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__modules_Search__ = __webpack_require__(2569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_116__modules_Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__modules_Search_SearchCategory__ = __webpack_require__(1348);
/* unused harmony reexport SearchCategory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__modules_Search_SearchResult__ = __webpack_require__(1349);
/* unused harmony reexport SearchResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__modules_Search_SearchResults__ = __webpack_require__(1350);
/* unused harmony reexport SearchResults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__modules_Sidebar__ = __webpack_require__(2571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_120__modules_Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__modules_Sidebar_SidebarPushable__ = __webpack_require__(1351);
/* unused harmony reexport SidebarPushable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__modules_Sidebar_SidebarPusher__ = __webpack_require__(1352);
/* unused harmony reexport SidebarPusher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__modules_Sticky__ = __webpack_require__(2573);
/* unused harmony reexport Sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__modules_Tab__ = __webpack_require__(2575);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__modules_Tab_TabPane__ = __webpack_require__(1353);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__modules_Transition__ = __webpack_require__(1356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_126__modules_Transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__modules_Transition_TransitionGroup__ = __webpack_require__(1355);
/* unused harmony reexport TransitionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_Advertisement__ = __webpack_require__(2577);
/* unused harmony reexport Advertisement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_Card_Card__ = __webpack_require__(1357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_129__views_Card_Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_Card_CardContent__ = __webpack_require__(1358);
/* unused harmony reexport CardContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_Card_CardDescription__ = __webpack_require__(775);
/* unused harmony reexport CardDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_Card_CardGroup__ = __webpack_require__(1359);
/* unused harmony reexport CardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_Card_CardHeader__ = __webpack_require__(776);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_Card_CardMeta__ = __webpack_require__(777);
/* unused harmony reexport CardMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_Comment__ = __webpack_require__(2579);
/* unused harmony reexport Comment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Comment_CommentAction__ = __webpack_require__(1360);
/* unused harmony reexport CommentAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_Comment_CommentActions__ = __webpack_require__(1361);
/* unused harmony reexport CommentActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_Comment_CommentAuthor__ = __webpack_require__(1362);
/* unused harmony reexport CommentAuthor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_Comment_CommentAvatar__ = __webpack_require__(1363);
/* unused harmony reexport CommentAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_Comment_CommentContent__ = __webpack_require__(1364);
/* unused harmony reexport CommentContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_Comment_CommentGroup__ = __webpack_require__(1365);
/* unused harmony reexport CommentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_Comment_CommentMetadata__ = __webpack_require__(1366);
/* unused harmony reexport CommentMetadata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_Comment_CommentText__ = __webpack_require__(1367);
/* unused harmony reexport CommentText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_Feed__ = __webpack_require__(2581);
/* unused harmony reexport Feed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_Feed_FeedContent__ = __webpack_require__(778);
/* unused harmony reexport FeedContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_Feed_FeedDate__ = __webpack_require__(491);
/* unused harmony reexport FeedDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__views_Feed_FeedEvent__ = __webpack_require__(1368);
/* unused harmony reexport FeedEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__views_Feed_FeedExtra__ = __webpack_require__(779);
/* unused harmony reexport FeedExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__views_Feed_FeedLabel__ = __webpack_require__(780);
/* unused harmony reexport FeedLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__views_Feed_FeedLike__ = __webpack_require__(781);
/* unused harmony reexport FeedLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__views_Feed_FeedMeta__ = __webpack_require__(782);
/* unused harmony reexport FeedMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__views_Feed_FeedSummary__ = __webpack_require__(783);
/* unused harmony reexport FeedSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__views_Feed_FeedUser__ = __webpack_require__(784);
/* unused harmony reexport FeedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__views_Item__ = __webpack_require__(2582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_154__views_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__views_Item_ItemContent__ = __webpack_require__(1370);
/* unused harmony reexport ItemContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__views_Item_ItemDescription__ = __webpack_require__(785);
/* unused harmony reexport ItemDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__views_Item_ItemExtra__ = __webpack_require__(786);
/* unused harmony reexport ItemExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__views_Item_ItemGroup__ = __webpack_require__(1371);
/* unused harmony reexport ItemGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__views_Item_ItemHeader__ = __webpack_require__(787);
/* unused harmony reexport ItemHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__views_Item_ItemImage__ = __webpack_require__(1372);
/* unused harmony reexport ItemImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__views_Item_ItemMeta__ = __webpack_require__(788);
/* unused harmony reexport ItemMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__views_Statistic__ = __webpack_require__(2583);
/* unused harmony reexport Statistic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__views_Statistic_StatisticGroup__ = __webpack_require__(1374);
/* unused harmony reexport StatisticGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__views_Statistic_StatisticLabel__ = __webpack_require__(1375);
/* unused harmony reexport StatisticLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__views_Statistic_StatisticValue__ = __webpack_require__(1376);
/* unused harmony reexport StatisticValue */
// Addons



























 // Behaviors


 // Collections
































































 // Elements




















































































 // Modules














































































 // Views














































































/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Analytics_Analytics__ = __webpack_require__(3400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Analytics_Analytics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BigCalendar_BigCalendarInTimeZone__ = __webpack_require__(3412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__BigCalendar_BigCalendarInTimeZone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MobileModal_Modal__ = __webpack_require__(3420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__MobileModal_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dthc_DthcContainer__ = __webpack_require__(3417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__Dthc_DthcContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dthc_DthcActions__ = __webpack_require__(3416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__Dthc_DthcActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Drawer_Drawer__ = __webpack_require__(3414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Drawer_Drawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AvailabilityCalendar_AvailabilityCalendarContainer__ = __webpack_require__(3402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__AvailabilityCalendar_AvailabilityCalendarContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AvailabilityChecker_AvailabilityCheckerContainer__ = __webpack_require__(3408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__AvailabilityChecker_AvailabilityCheckerContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Steps_Steps__ = __webpack_require__(3422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__Steps_Steps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dialogs_DeleteConfirmation__ = __webpack_require__(3413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__Dialogs_DeleteConfirmation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TextEditor_TextEditor__ = __webpack_require__(3423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__TextEditor_TextEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Wizard_Wizard__ = __webpack_require__(3424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__Wizard_Wizard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Notifications_Notifications__ = __webpack_require__(3421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__Notifications_Notifications__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__Notifications_Notifications__["b"]; });














/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__ = __webpack_require__(2532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__childMapping__ = __webpack_require__(2534);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__childMapping__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__childMapping__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__childrenUtils__ = __webpack_require__(2535);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__childrenUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__ = __webpack_require__(2536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customPropTypes__ = __webpack_require__(2542);
/* unused harmony reexport customPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventStack__ = __webpack_require__(2544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__eventStack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__factories__ = __webpack_require__(2545);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_6__factories__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getUnhandledProps__ = __webpack_require__(2547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__getUnhandledProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getElementType__ = __webpack_require__(2546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__getElementType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__htmlPropsUtils__ = __webpack_require__(2548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__htmlPropsUtils__["c"]; });
/* unused harmony reexport htmlInputEvents */
/* unused harmony reexport htmlInputProps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_9__htmlPropsUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__htmlPropsUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isBrowser__ = __webpack_require__(2549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__isBrowser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__doesNodeContainClick__ = __webpack_require__(2543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__doesNodeContainClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__leven__ = __webpack_require__(1330);
/* unused harmony reexport leven */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__createPaginationItems__ = __webpack_require__(2538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_13__createPaginationItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SUI__ = __webpack_require__(2533);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_14__SUI__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__numberToWord__ = __webpack_require__(771);
/* unused harmony reexport numberToWordMap */
/* unused harmony reexport numberToWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__normalizeOffset__ = __webpack_require__(2550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_16__normalizeOffset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__normalizeTransitionDuration__ = __webpack_require__(2551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__normalizeTransitionDuration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__objectDiff__ = __webpack_require__(2552);
/* unused harmony reexport objectDiff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__refUtils__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_19__refUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_19__refUtils__["a"]; });

































 // Heads up! We import/export for this module to safely remove it with "babel-plugin-filter-imports"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Relay v1.6.2
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

module.exports = __webpack_require__(748);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(214)) === 'object' && __webpack_require__(214)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Returns the values of field/fragment arguments as an object keyed by argument
 * names. Guaranteed to return a result with stable ordered nested values.
 */

function getArgumentValues(args, variables) {
  var values = {};
  args.forEach(function (arg) {
    if (arg.kind === __webpack_require__(18).VARIABLE) {
      // Variables are provided at runtime and are not guaranteed to be stable.
      values[arg.name] = getStableVariableValue(arg.variableName, variables);
    } else {
      // The Relay compiler generates stable ConcreteArgument values.
      values[arg.name] = arg.value;
    }
  });
  return values;
}

/**
 * Given a handle field and variable values, returns a key that can be used to
 * uniquely identify the combination of the handle name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */
function getHandleStorageKey(handleField, variables) {
  var handle = handleField.handle,
      key = handleField.key,
      name = handleField.name,
      args = handleField.args,
      filters = handleField.filters;

  var handleName = __webpack_require__(249)(handle, key, name);
  if (!args || !filters || args.length === 0 || filters.length === 0) {
    return handleName;
  }
  var filterArgs = args.filter(function (arg) {
    return filters.indexOf(arg.name) > -1;
  });
  return formatStorageKey(handleName, getArgumentValues(filterArgs, variables));
}

/**
 * Given a field and variable values, returns a key that can be used to
 * uniquely identify the combination of the field name and argument values.
 *
 * Note: the word "storage" here refers to the fact this key is primarily used
 * when writing the results of a key in a normalized graph or "store". This
 * name was used in previous implementations of Relay internals and is also
 * used here for consistency.
 */
function getStorageKey(field, variables) {
  if (field.storageKey) {
    // TODO T23663664: Handle nodes do not yet define a static storageKey.
    return field.storageKey;
  }
  var args = field.args,
      name = field.name;

  return args && args.length !== 0 ? formatStorageKey(name, getArgumentValues(args, variables)) : name;
}

/**
 * Given a `name` (eg. "foo") and an object representing argument values
 * (eg. `{orberBy: "name", first: 10}`) returns a unique storage key
 * (ie. `foo{"first":10,"orderBy":"name"}`).
 *
 * This differs from getStorageKey which requires a ConcreteNode where arguments
 * are assumed to already be sorted into a stable order.
 */
function getStableStorageKey(name, args) {
  return formatStorageKey(name, __webpack_require__(178)(args));
}

/**
 * Given a name and argument values, format a storage key.
 *
 * Arguments and the values within them are expected to be ordered in a stable
 * alphabetical ordering.
 */
function formatStorageKey(name, argValues) {
  if (!argValues) {
    return name;
  }
  var values = [];
  for (var _argName in argValues) {
    if (argValues.hasOwnProperty(_argName)) {
      var value = argValues[_argName];
      if (value != null) {
        values.push(_argName + ':' + JSON.stringify(value));
      }
    }
  }
  return values.length === 0 ? name : name + ('(' + values.join(',') + ')');
}

/**
 * Given Variables and a variable name, return a variable value with
 * all values in a stable order.
 */
function getStableVariableValue(name, variables) {
  !variables.hasOwnProperty(name) ?  false ? require('fbjs/lib/invariant')(false, 'getVariableValue(): Undefined variable `%s`.', name) : __webpack_require__(10)(false) : void 0;
  return __webpack_require__(178)(variables[name]);
}

/**
 * Constants shared by all implementations of RecordSource/MutableRecordSource/etc.
 */
var RelayStoreUtils = {
  FRAGMENTS_KEY: '__fragments',
  ID_KEY: '__id',
  REF_KEY: '__ref',
  REFS_KEY: '__refs',
  ROOT_ID: 'client:root',
  ROOT_TYPE: '__Root',
  TYPENAME_KEY: '__typename',
  UNPUBLISH_RECORD_SENTINEL: Object.freeze({ __UNPUBLISH_RECORD_SENTINEL: true }),
  UNPUBLISH_FIELD_SENTINEL: Object.freeze({ __UNPUBLISH_FIELD_SENTINEL: true }),

  getArgumentValues: getArgumentValues,
  getHandleStorageKey: getHandleStorageKey,
  getStorageKey: getStorageKey,
  getStableStorageKey: getStableStorageKey
};

module.exports = RelayStoreUtils;

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fab_Fab__ = __webpack_require__(3243);
/* unused harmony reexport Fab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FloatingLabelInput_FloatingLabelInput__ = __webpack_require__(1479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__FloatingLabelInput_FloatingLabelInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FloatingLabelInput_FloatingLabelSelect__ = __webpack_require__(3248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__FloatingLabelInput_FloatingLabelSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_FloatingLabelTZSelect__ = __webpack_require__(3249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_FloatingLabelTZSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_FloatingLabelDateTimePicker__ = __webpack_require__(3247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_FloatingLabelDateTimePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FloatingLabelInput_FloatingLabelDateTime__ = __webpack_require__(3246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__FloatingLabelInput_FloatingLabelDateTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditableText__ = __webpack_require__(3242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__EditableText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardField_CardCheckbox__ = __webpack_require__(3234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__CardField_CardCheckbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardField_CardInput__ = __webpack_require__(3238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__CardField_CardInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardField_CardSelect__ = __webpack_require__(3239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__CardField_CardSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CardField_CardTZSelect__ = __webpack_require__(3240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_10__CardField_CardTZSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardField_CardTextArea__ = __webpack_require__(3241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_11__CardField_CardTextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardField_CardDateTime__ = __webpack_require__(3235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__CardField_CardDateTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardField_CardDateTimePicker__ = __webpack_require__(3236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_13__CardField_CardDateTimePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardField_CardDescriptionList__ = __webpack_require__(3237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__CardField_CardDescriptionList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FileIcon_FileIcon__ = __webpack_require__(3245);
/* unused harmony reexport FileIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Input_Input__ = __webpack_require__(3250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__Input_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__InputWithSuggestions_InputWithSuggestions__ = __webpack_require__(3251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_17__InputWithSuggestions_InputWithSuggestions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Loader_Loader__ = __webpack_require__(3253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_18__Loader_Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TextArea_TextArea__ = __webpack_require__(3259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_19__TextArea_TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Success_Success__ = __webpack_require__(3255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_20__Success_Success__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SelectableBlock_SelectableBlock__ = __webpack_require__(3254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_21__SelectableBlock_SelectableBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SummaryTotals_SummaryTotals__ = __webpack_require__(3258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_22__SummaryTotals_SummaryTotals__["a"]; });
























/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.4';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,reLeadingDot=/^\./,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',rsOrdUpper='\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */function addMapEntry(map,pair){// Don't return `map.set` because it's not chainable in IE 11.
map.set(pair[0],pair[1]);return map;}/**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */function addSetEntry(set,value){// Don't return `set.add` because it's not chainable in IE 11.
set.add(value);return set;}/**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){}// No operation performed.
/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,baseClone,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(object[key],srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=object[key],srcValue=source[key],stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array==null?0:array.length,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */function cloneMap(map,isDeep,cloneFunc){var array=isDeep?cloneFunc(mapToArray(map),CLONE_DEEP_FLAG):mapToArray(map);return arrayReduce(array,addMapEntry,new map.constructor());}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */function cloneSet(set,isDeep,cloneFunc){var array=isDeep?cloneFunc(setToArray(set),CLONE_DEEP_FLAG):setToArray(set);return arrayReduce(array,addSetEntry,new set.constructor());}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,cloneFunc,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return cloneMap(object,isDeep,cloneFunc);case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return cloneSet(object,isDeep,cloneFunc);case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(typeof value=='number'||reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(reLeadingDot.test(string)){result.push('');}string.replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,result=wait-timeSinceLastCall;return maxing?nativeMin(result,maxWait-timeSinceLastInvoke):result;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(args){args.push(undefined,customDefaultsAssignIn);return apply(assignInWith,undefined,args);});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){}// No operation performed.
/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if("function"=='function'&&_typeof(__webpack_require__(214))=='object'&&__webpack_require__(214)){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else if(freeModule){// Export for Node.js.
(freeModule.exports=_)._=_;// Export for CommonJS support.
freeExports._=_;}else{// Export to the global object.
root._=_;}}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(68)(module)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends3 = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @public
 *
 * Low-level record manipulation methods.
 *
 * A note about perf: we use long-hand property access rather than computed
 * properties in this file for speed ie.
 *
 *    const object = {};
 *    object[KEY] = value;
 *    record[storageKey] = object;
 *
 * instead of:
 *
 *    record[storageKey] = {
 *      [KEY]: value,
 *    };
 *
 * The latter gets transformed by Babel into something like:
 *
 *    function _defineProperty(obj, key, value) {
 *      if (key in obj) {
 *        Object.defineProperty(obj, key, {
 *          value: value,
 *          enumerable: true,
 *          configurable: true,
 *          writable: true,
 *        });
 *      } else {
 *        obj[key] = value;
 *      }
 *      return obj;
 *    }
 *
 *    record[storageKey] = _defineProperty({}, KEY, value);
 *
 * A quick benchmark shows that computed property access is an order of
 * magnitude slower (times in seconds for 100,000 iterations):
 *
 *               best     avg     sd
 *    computed 0.02175 0.02292 0.00113
 *      manual 0.00110 0.00123 0.00008
 */

/**
 * @public
 *
 * Clone a record.
 */
function clone(record) {
  return (0, _extends3['default'])({}, record);
}

/**
 * @public
 *
 * Copies all fields from `source` to `sink`, excluding `__id` and `__typename`.
 *
 * NOTE: This function does not treat `id` specially. To preserve the id,
 * manually reset it after calling this function. Also note that values are
 * copied by reference and not value; callers should ensure that values are
 * copied on write.
 */
function copyFields(source, sink) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      if (key !== __webpack_require__(12).ID_KEY && key !== __webpack_require__(12).TYPENAME_KEY) {
        sink[key] = source[key];
      }
    }
  }
}

/**
 * @public
 *
 * Create a new record.
 */
function create(dataID, typeName) {
  // See perf note above for why we aren't using computed property access.
  var record = {};
  record[__webpack_require__(12).ID_KEY] = dataID;
  record[__webpack_require__(12).TYPENAME_KEY] = typeName;
  return record;
}

/**
 * @public
 *
 * Get the record's `id` if available or the client-generated identifier.
 */
function getDataID(record) {
  return record[__webpack_require__(12).ID_KEY];
}

/**
 * @public
 *
 * Get the concrete type of the record.
 */
function getType(record) {
  return record[__webpack_require__(12).TYPENAME_KEY];
}

/**
 * @public
 *
 * Get a scalar (non-link) field value.
 */
function getValue(record, storageKey) {
  var value = record[storageKey];
  if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    !(!value.hasOwnProperty(__webpack_require__(12).REF_KEY) && !value.hasOwnProperty(__webpack_require__(12).REFS_KEY)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernRecord.getValue(): Expected a scalar (non-link) value for `%s.%s` ' + 'but found %s.', record[require('./RelayStoreUtils').ID_KEY], storageKey, value.hasOwnProperty(require('./RelayStoreUtils').REF_KEY) ? 'a linked record' : 'plural linked records') : __webpack_require__(10)(false) : void 0;
  }
  return value;
}

/**
 * @public
 *
 * Get the value of a field as a reference to another record. Throws if the
 * field has a different type.
 */
function getLinkedRecordID(record, storageKey) {
  var link = record[storageKey];
  if (link == null) {
    return link;
  }
  !((typeof link === 'undefined' ? 'undefined' : _typeof(link)) === 'object' && link && typeof link[__webpack_require__(12).REF_KEY] === 'string') ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernRecord.getLinkedRecordID(): Expected `%s.%s` to be a linked ID, ' + 'was `%s`.', record[require('./RelayStoreUtils').ID_KEY], storageKey, link) : __webpack_require__(10)(false) : void 0;
  return link[__webpack_require__(12).REF_KEY];
}

/**
 * @public
 *
 * Get the value of a field as a list of references to other records. Throws if
 * the field has a different type.
 */
function getLinkedRecordIDs(record, storageKey) {
  var links = record[storageKey];
  if (links == null) {
    return links;
  }
  !((typeof links === 'undefined' ? 'undefined' : _typeof(links)) === 'object' && Array.isArray(links[__webpack_require__(12).REFS_KEY])) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernRecord.getLinkedRecordIDs(): Expected `%s.%s` to contain an array ' + 'of linked IDs, got `%s`.', record[require('./RelayStoreUtils').ID_KEY], storageKey, JSON.stringify(links)) : __webpack_require__(10)(false) : void 0;
  // assume items of the array are ids
  return links[__webpack_require__(12).REFS_KEY];
}

/**
 * @public
 *
 * Compares the fields of a previous and new record, returning either the
 * previous record if all fields are equal or a new record (with merged fields)
 * if any fields have changed.
 */
function update(prevRecord, nextRecord) {
  var updated = void 0;
  var keys = Object.keys(nextRecord);
  for (var ii = 0; ii < keys.length; ii++) {
    var key = keys[ii];
    if (updated || !__webpack_require__(251)(prevRecord[key], nextRecord[key])) {
      updated = updated || (0, _extends3['default'])({}, prevRecord);
      if (nextRecord[key] !== __webpack_require__(12).UNPUBLISH_FIELD_SENTINEL) {
        updated[key] = nextRecord[key];
      } else {
        delete updated[key];
      }
    }
  }
  return updated || prevRecord;
}

/**
 * @public
 *
 * Returns a new record with the contents of the given records. Fields in the
 * second record will overwrite identical fields in the first record.
 */
function merge(record1, record2) {
  return Object.assign({}, record1, record2);
}

/**
 * @public
 *
 * Prevent modifications to the record. Attempts to call `set*` functions on a
 * frozen record will fatal at runtime.
 */
function freeze(record) {
  __webpack_require__(362)(record);
}

/**
 * @public
 *
 * Set the value of a storageKey to a scalar.
 */
function setValue(record, storageKey, value) {
  record[storageKey] = value;
}

/**
 * @public
 *
 * Set the value of a field to a reference to another record.
 */
function setLinkedRecordID(record, storageKey, linkedID) {
  // See perf note above for why we aren't using computed property access.
  var link = {};
  link[__webpack_require__(12).REF_KEY] = linkedID;
  record[storageKey] = link;
}

/**
 * @public
 *
 * Set the value of a field to a list of references other records.
 */
function setLinkedRecordIDs(record, storageKey, linkedIDs) {
  // See perf note above for why we aren't using computed property access.
  var links = {};
  links[__webpack_require__(12).REFS_KEY] = linkedIDs;
  record[storageKey] = links;
}

module.exports = {
  clone: clone,
  copyFields: copyFields,
  create: create,
  freeze: freeze,
  getDataID: getDataID,
  getLinkedRecordID: getLinkedRecordID,
  getLinkedRecordIDs: getLinkedRecordIDs,
  getType: getType,
  getValue: getValue,
  merge: merge,
  setValue: setValue,
  setLinkedRecordID: setLinkedRecordID,
  setLinkedRecordIDs: setLinkedRecordIDs,
  update: update
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Represents a common GraphQL request with `text` (or persisted `id`) can be
 * used to execute it, an `operation` containing information to normalize the
 * results, and a `fragment` derived from that operation to read the response
 * data (masking data from child fragments).
 */

var RelayConcreteNode = {
  BATCH_REQUEST: 'BatchRequest',
  CONDITION: 'Condition',
  DEFERRABLE_FRAGMENT_SPREAD: 'DeferrableFragmentSpread',
  DEFERRABLE_OPERATION: 'DeferrableOperation',
  FRAGMENT: 'Fragment',
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  LINKED_FIELD: 'LinkedField',
  LINKED_HANDLE: 'LinkedHandle',
  LITERAL: 'Literal',
  LOCAL_ARGUMENT: 'LocalArgument',
  OPERATION: 'Operation',
  ROOT_ARGUMENT: 'RootArgument',
  REQUEST: 'Request',
  SCALAR_FIELD: 'ScalarField',
  SCALAR_HANDLE: 'ScalarHandle',
  VARIABLE: 'Variable'
};
/**
 * Represents a single operation used to processing and normalize runtime
 * request results.
 */

/**
 * Argument in the provided operation to be derived via the results of
 * other requests in the batch.
 */

/**
 * An experimental wrapper around many operations to request in a batched
 * network request. The composed indivual GraphQL requests should be submitted
 * as a single networked request, e.g. in the case of deferred nodes or
 * for streaming connections that are represented as distinct compiled concrete
 * operations but are still conceptually tied to one source operation.
 *
 * Individual requests within the batch may contain data describing their
 * dependencies on other requests or themselves.
 */

module.exports = RelayConcreteNode;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(215);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(2784);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var PropTypes = __webpack_require__(1);
var React = global.React || __webpack_require__(0);
var createReactClass = __webpack_require__(274);
var Formsy = {};
var validationRules = __webpack_require__(1874);
var formDataToObject = __webpack_require__(1871);
var utils = __webpack_require__(960);
var Mixin = __webpack_require__(628);
var HOC = __webpack_require__(1873);
var Decorator = __webpack_require__(1872);
var options = {};
var emptyArray = [];

Formsy.Mixin = Mixin;
Formsy.HOC = HOC;
Formsy.Decorator = Decorator;

Formsy.defaults = function (passedOptions) {
  options = passedOptions;
};

Formsy.addValidationRule = function (name, func) {
  validationRules[name] = func;
};

Formsy.Form = createReactClass({
  displayName: 'Formsy',
  getInitialState: function getInitialState() {
    return {
      isValid: true,
      isSubmitting: false,
      canChange: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      onSuccess: function onSuccess() {},
      onError: function onError() {},
      onSubmit: function onSubmit() {},
      onValidSubmit: function onValidSubmit() {},
      onInvalidSubmit: function onInvalidSubmit() {},
      onValid: function onValid() {},
      onInvalid: function onInvalid() {},
      onChange: function onChange() {},
      validationErrors: null,
      preventExternalInvalidation: false
    };
  },

  childContextTypes: {
    formsy: PropTypes.object
  },
  getChildContext: function getChildContext() {
    var _this = this;

    return {
      formsy: {
        attachToForm: this.attachToForm,
        detachFromForm: this.detachFromForm,
        validate: this.validate,
        isFormDisabled: this.isFormDisabled,
        isValidValue: function isValidValue(component, value) {
          return _this.runValidation(component, value).isValid;
        }
      }
    };
  },

  // Add a map to store the inputs of the form, a model to store
  // the values of the form and register child inputs
  componentWillMount: function componentWillMount() {
    this.inputs = [];
  },

  componentDidMount: function componentDidMount() {
    this.validateForm();
  },

  componentWillUpdate: function componentWillUpdate() {
    // Keep a reference to input names before form updates,
    // to check if inputs has changed after render
    this.prevInputNames = this.inputs.map(function (component) {
      return component.props.name;
    });
  },

  componentDidUpdate: function componentDidUpdate() {

    if (this.props.validationErrors && _typeof(this.props.validationErrors) === 'object' && Object.keys(this.props.validationErrors).length > 0) {
      this.setInputValidationErrors(this.props.validationErrors);
    }

    var newInputNames = this.inputs.map(function (component) {
      return component.props.name;
    });
    if (utils.arraysDiffer(this.prevInputNames, newInputNames)) {
      this.validateForm();
    }
  },

  // Allow resetting to specified data
  reset: function reset(data) {
    this.setFormPristine(true);
    this.resetModel(data);
  },

  // Update model, submit to url prop and send the model
  submit: function submit(event) {

    event && event.preventDefault();

    // Trigger form as not pristine.
    // If any inputs have not been touched yet this will make them dirty
    // so validation becomes visible (if based on isPristine)
    this.setFormPristine(false);
    var model = this.getModel();
    this.props.onSubmit(model, this.resetModel, this.updateInputsWithError);
    this.state.isValid ? this.props.onValidSubmit(model, this.resetModel, this.updateInputsWithError) : this.props.onInvalidSubmit(model, this.resetModel, this.updateInputsWithError);
  },

  mapModel: function mapModel(model) {

    if (this.props.mapping) {
      return this.props.mapping(model);
    } else {
      return formDataToObject.toObj(Object.keys(model).reduce(function (mappedModel, key) {

        var keyArray = key.split('.');
        var base = mappedModel;
        while (keyArray.length) {
          var currentKey = keyArray.shift();
          base = base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
        }

        return mappedModel;
      }, {}));
    }
  },

  getModel: function getModel() {
    var currentValues = this.getCurrentValues();
    return this.mapModel(currentValues);
  },

  // Reset each key in the model to the original / initial / specified value
  resetModel: function resetModel(data) {
    this.inputs.forEach(function (component) {
      var name = component.props.name;
      if (data && data.hasOwnProperty(name)) {
        component.setValue(data[name]);
      } else {
        component.resetValue();
      }
    });
    this.validateForm();
  },

  setInputValidationErrors: function setInputValidationErrors(errors) {
    this.inputs.forEach(function (component) {
      var name = component.props.name;
      var args = [{
        _isValid: !(name in errors),
        _validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
      }];
      component.setState.apply(component, args);
    });
  },

  // Checks if the values have changed from their initial value
  isChanged: function isChanged() {
    return !utils.isSame(this.getPristineValues(), this.getCurrentValues());
  },

  getPristineValues: function getPristineValues() {
    return this.inputs.reduce(function (data, component) {
      var name = component.props.name;
      data[name] = component.props.value;
      return data;
    }, {});
  },

  // Go through errors from server and grab the components
  // stored in the inputs map. Change their state to invalid
  // and set the serverError message
  updateInputsWithError: function updateInputsWithError(errors) {
    var _this2 = this;

    Object.keys(errors).forEach(function (name, index) {
      var component = utils.find(_this2.inputs, function (component) {
        return component.props.name === name;
      });
      if (!component) {
        throw new Error('You are trying to update an input that does not exist. ' + 'Verify errors object with input names. ' + JSON.stringify(errors));
      }
      var args = [{
        _isValid: _this2.props.preventExternalInvalidation || false,
        _externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
      }];
      component.setState.apply(component, args);
    });
  },

  isFormDisabled: function isFormDisabled() {
    return this.props.disabled;
  },

  getCurrentValues: function getCurrentValues() {
    return this.inputs.reduce(function (data, component) {
      var name = component.props.name;
      data[name] = component.state._value;
      return data;
    }, {});
  },

  setFormPristine: function setFormPristine(isPristine) {
    this.setState({
      _formSubmitted: !isPristine
    });

    // Iterate through each component and set it as pristine
    // or "dirty".
    this.inputs.forEach(function (component, index) {
      component.setState({
        _formSubmitted: !isPristine,
        _isPristine: isPristine
      });
    });
  },

  // Use the binded values and the actual input value to
  // validate the input and set its state. Then check the
  // state of the form itself
  validate: function validate(component) {

    // Trigger onChange
    if (this.state.canChange) {
      this.props.onChange(this.getCurrentValues(), this.isChanged());
    }

    var validation = this.runValidation(component);
    // Run through the validations, split them up and call
    // the validator IF there is a value or it is required
    component.setState({
      _isValid: validation.isValid,
      _isRequired: validation.isRequired,
      _validationError: validation.error,
      _externalError: null
    }, this.validateForm);
  },

  // Checks validation on current value or a passed value
  runValidation: function runValidation(component, value) {

    var currentValues = this.getCurrentValues();
    var validationErrors = component.props.validationErrors;
    var validationError = component.props.validationError;
    value = arguments.length === 2 ? value : component.state._value;

    var validationResults = this.runRules(value, currentValues, component._validations);
    var requiredResults = this.runRules(value, currentValues, component._requiredValidations);

    // the component defines an explicit validate function
    if (typeof component.validate === "function") {
      validationResults.failed = component.validate() ? [] : ['failed'];
    }

    var isRequired = Object.keys(component._requiredValidations).length ? !!requiredResults.success.length : false;
    var isValid = !validationResults.failed.length && !(this.props.validationErrors && this.props.validationErrors[component.props.name]);

    return {
      isRequired: isRequired,
      isValid: isRequired ? false : isValid,
      error: function () {

        if (isValid && !isRequired) {
          return emptyArray;
        }

        if (validationResults.errors.length) {
          return validationResults.errors;
        }

        if (this.props.validationErrors && this.props.validationErrors[component.props.name]) {
          return typeof this.props.validationErrors[component.props.name] === 'string' ? [this.props.validationErrors[component.props.name]] : this.props.validationErrors[component.props.name];
        }

        if (isRequired) {
          var error = validationErrors[requiredResults.success[0]];
          return error ? [error] : null;
        }

        if (validationResults.failed.length) {
          return validationResults.failed.map(function (failed) {
            return validationErrors[failed] ? validationErrors[failed] : validationError;
          }).filter(function (x, pos, arr) {
            // Remove duplicates
            return arr.indexOf(x) === pos;
          });
        }
      }.call(this)
    };
  },

  runRules: function runRules(value, currentValues, validations) {

    var results = {
      errors: [],
      failed: [],
      success: []
    };
    if (Object.keys(validations).length) {
      Object.keys(validations).forEach(function (validationMethod) {

        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
        }

        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
        }

        if (typeof validations[validationMethod] === 'function') {
          var validation = validations[validationMethod](currentValues, value);
          if (typeof validation === 'string') {
            results.errors.push(validation);
            results.failed.push(validationMethod);
          } else if (!validation) {
            results.failed.push(validationMethod);
          }
          return;
        } else if (typeof validations[validationMethod] !== 'function') {
          var validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);
          if (typeof validation === 'string') {
            results.errors.push(validation);
            results.failed.push(validationMethod);
          } else if (!validation) {
            results.failed.push(validationMethod);
          } else {
            results.success.push(validationMethod);
          }
          return;
        }

        return results.success.push(validationMethod);
      });
    }

    return results;
  },

  // Validate the form by going through all child input components
  // and check their state
  validateForm: function validateForm() {
    var _this3 = this;

    // We need a callback as we are validating all inputs again. This will
    // run when the last component has set its state
    var onValidationComplete = function () {
      var allIsValid = this.inputs.every(function (component) {
        return component.state._isValid;
      });

      this.setState({
        isValid: allIsValid
      });

      if (allIsValid) {
        this.props.onValid();
      } else {
        this.props.onInvalid();
      }

      // Tell the form that it can start to trigger change events
      this.setState({
        canChange: true
      });
    }.bind(this);

    // Run validation again in case affected by other inputs. The
    // last component validated will run the onValidationComplete callback
    this.inputs.forEach(function (component, index) {
      var validation = _this3.runValidation(component);
      if (validation.isValid && component.state._externalError) {
        validation.isValid = false;
      }
      component.setState({
        _isValid: validation.isValid,
        _isRequired: validation.isRequired,
        _validationError: validation.error,
        _externalError: !validation.isValid && component.state._externalError ? component.state._externalError : null
      }, index === _this3.inputs.length - 1 ? onValidationComplete : null);
    });

    // If there are no inputs, set state where form is ready to trigger
    // change event. New inputs might be added later
    if (!this.inputs.length) {
      this.setState({
        canChange: true
      });
    }
  },

  // Method put on each input component to register
  // itself to the form
  attachToForm: function attachToForm(component) {

    if (this.inputs.indexOf(component) === -1) {
      this.inputs.push(component);
    }

    this.validate(component);
  },

  // Method put on each input component to unregister
  // itself from the form
  detachFromForm: function detachFromForm(component) {
    var componentPos = this.inputs.indexOf(component);

    if (componentPos !== -1) {
      this.inputs = this.inputs.slice(0, componentPos).concat(this.inputs.slice(componentPos + 1));
    }

    this.validateForm();
  },
  render: function render() {
    var _props = this.props,
        mapping = _props.mapping,
        validationErrors = _props.validationErrors,
        onSubmit = _props.onSubmit,
        onValid = _props.onValid,
        onValidSubmit = _props.onValidSubmit,
        onInvalid = _props.onInvalid,
        onInvalidSubmit = _props.onInvalidSubmit,
        onChange = _props.onChange,
        reset = _props.reset,
        preventExternalInvalidation = _props.preventExternalInvalidation,
        onSuccess = _props.onSuccess,
        onError = _props.onError,
        nonFormsyProps = _objectWithoutProperties(_props, ['mapping', 'validationErrors', 'onSubmit', 'onValid', 'onValidSubmit', 'onInvalid', 'onInvalidSubmit', 'onChange', 'reset', 'preventExternalInvalidation', 'onSuccess', 'onError']);

    return React.createElement('form', _extends({}, nonFormsyProps, { onSubmit: this.submit }), this.props.children);
  }
});

if (!global.exports && !global.module && (!global.define || !global.define.amd)) {
  global.Formsy = Formsy;
}

module.exports = Formsy;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(214)) === 'object' && __webpack_require__(214)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 29 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1521);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(264);

var assertThisInitialized = __webpack_require__(26);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
    d.__proto__ = b;
} || function (d, b) {
    for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
    }
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}

function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator],
        i = 0;
    if (m) return m.call(o);
    return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
        r,
        ar = [],
        e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    } catch (error) {
        e = { error: error };
    } finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
            if (e) throw e.error;
        }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++) {
        ar = ar.concat(__read(arguments[i]));
    }return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []),
        i,
        q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function (v) {
            return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function () {
        return this;
    }, i;
    function verb(n, f) {
        if (o[n]) i[n] = function (v) {
            return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v;
        };
    }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.withRouter = exports.Route = exports.ResolverUtils = exports.resolver = exports.RedirectException = exports.Redirect = exports.routerShape = exports.matchShape = exports.matcherShape = exports.Matcher = exports.makeRouteConfig = exports.Link = exports.HttpError = exports.hotRouteConfig = exports.getStoreRenderArgs = exports.getRenderArgs = exports.foundReducer = exports.ElementsRenderer = exports.createWithRouter = exports.createRender = exports.createMatchEnhancer = exports.createInitialFarceRouter = exports.createInitialBrowserRouter = exports.createFarceRouter = exports.createElements = exports.createConnectedRouter = exports.createConnectedLink = exports.createBrowserRouter = exports.createBaseRouter = exports.BaseLink = exports.ActionTypes = undefined;

var _PropTypes = __webpack_require__(427);

Object.defineProperty(exports, 'matcherShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes.matcherShape;
  }
});
Object.defineProperty(exports, 'matchShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes.matchShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes.routerShape;
  }
});

var _ActionTypes2 = __webpack_require__(426);

var _ActionTypes3 = _interopRequireDefault(_ActionTypes2);

var _BaseLink2 = __webpack_require__(973);

var _BaseLink3 = _interopRequireDefault(_BaseLink2);

var _createBaseRouter2 = __webpack_require__(977);

var _createBaseRouter3 = _interopRequireDefault(_createBaseRouter2);

var _createBrowserRouter2 = __webpack_require__(1952);

var _createBrowserRouter3 = _interopRequireDefault(_createBrowserRouter2);

var _createConnectedLink2 = __webpack_require__(978);

var _createConnectedLink3 = _interopRequireDefault(_createConnectedLink2);

var _createConnectedRouter2 = __webpack_require__(979);

var _createConnectedRouter3 = _interopRequireDefault(_createConnectedRouter2);

var _createElements2 = __webpack_require__(980);

var _createElements3 = _interopRequireDefault(_createElements2);

var _createFarceRouter2 = __webpack_require__(636);

var _createFarceRouter3 = _interopRequireDefault(_createFarceRouter2);

var _createInitialBrowserRouter2 = __webpack_require__(1953);

var _createInitialBrowserRouter3 = _interopRequireDefault(_createInitialBrowserRouter2);

var _createInitialFarceRouter2 = __webpack_require__(981);

var _createInitialFarceRouter3 = _interopRequireDefault(_createInitialFarceRouter2);

var _createMatchEnhancer2 = __webpack_require__(982);

var _createMatchEnhancer3 = _interopRequireDefault(_createMatchEnhancer2);

var _createRender2 = __webpack_require__(983);

var _createRender3 = _interopRequireDefault(_createRender2);

var _createWithRouter2 = __webpack_require__(637);

var _createWithRouter3 = _interopRequireDefault(_createWithRouter2);

var _ElementsRenderer2 = __webpack_require__(974);

var _ElementsRenderer3 = _interopRequireDefault(_ElementsRenderer2);

var _foundReducer2 = __webpack_require__(984);

var _foundReducer3 = _interopRequireDefault(_foundReducer2);

var _getRenderArgs2 = __webpack_require__(985);

var _getRenderArgs3 = _interopRequireDefault(_getRenderArgs2);

var _getStoreRenderArgs2 = __webpack_require__(986);

var _getStoreRenderArgs3 = _interopRequireDefault(_getStoreRenderArgs2);

var _hotRouteConfig2 = __webpack_require__(1954);

var _hotRouteConfig3 = _interopRequireDefault(_hotRouteConfig2);

var _HttpError2 = __webpack_require__(975);

var _HttpError3 = _interopRequireDefault(_HttpError2);

var _Link2 = __webpack_require__(1950);

var _Link3 = _interopRequireDefault(_Link2);

var _makeRouteConfig2 = __webpack_require__(1955);

var _makeRouteConfig3 = _interopRequireDefault(_makeRouteConfig2);

var _Matcher2 = __webpack_require__(976);

var _Matcher3 = _interopRequireDefault(_Matcher2);

var _Redirect2 = __webpack_require__(1951);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _RedirectException2 = __webpack_require__(635);

var _RedirectException3 = _interopRequireDefault(_RedirectException2);

var _resolver2 = __webpack_require__(638);

var _resolver3 = _interopRequireDefault(_resolver2);

var _ResolverUtils2 = __webpack_require__(428);

var _ResolverUtils = _interopRequireWildcard(_ResolverUtils2);

var _Route2 = __webpack_require__(166);

var _Route3 = _interopRequireDefault(_Route2);

var _withRouter2 = __webpack_require__(990);

var _withRouter3 = _interopRequireDefault(_withRouter2);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.ActionTypes = _ActionTypes3.default;
exports.BaseLink = _BaseLink3.default;
exports.createBaseRouter = _createBaseRouter3.default;
exports.createBrowserRouter = _createBrowserRouter3.default;
exports.createConnectedLink = _createConnectedLink3.default;
exports.createConnectedRouter = _createConnectedRouter3.default;
exports.createElements = _createElements3.default;
exports.createFarceRouter = _createFarceRouter3.default;
exports.createInitialBrowserRouter = _createInitialBrowserRouter3.default;
exports.createInitialFarceRouter = _createInitialFarceRouter3.default;
exports.createMatchEnhancer = _createMatchEnhancer3.default;
exports.createRender = _createRender3.default;
exports.createWithRouter = _createWithRouter3.default;
exports.ElementsRenderer = _ElementsRenderer3.default;
exports.foundReducer = _foundReducer3.default;
exports.getRenderArgs = _getRenderArgs3.default;
exports.getStoreRenderArgs = _getStoreRenderArgs3.default;
exports.hotRouteConfig = _hotRouteConfig3.default;
exports.HttpError = _HttpError3.default;
exports.Link = _Link3.default;
exports.makeRouteConfig = _makeRouteConfig3.default;
exports.Matcher = _Matcher3.default;
exports.Redirect = _Redirect3.default;
exports.RedirectException = _RedirectException3.default;
exports.resolver = _resolver3.default;
exports.ResolverUtils = _ResolverUtils;
exports.Route = _Route3.default;
exports.withRouter = _withRouter3.default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(2602),
    baseRest = __webpack_require__(205);

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

module.exports = invoke;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var intent_1 = __webpack_require__(835);
// modifiers
exports.DARK = "pt-dark";
exports.ACTIVE = "pt-active";
exports.MINIMAL = "pt-minimal";
exports.DISABLED = "pt-disabled";
exports.SMALL = "pt-small";
exports.LARGE = "pt-large";
exports.LOADING = "pt-loading";
exports.INTERACTIVE = "pt-interactive";
exports.ALIGN_LEFT = "pt-align-left";
exports.ALIGN_RIGHT = "pt-align-right";
exports.INLINE = "pt-inline";
exports.FILL = "pt-fill";
exports.FIXED = "pt-fixed";
exports.FIXED_TOP = "pt-fixed-top";
exports.VERTICAL = "pt-vertical";
exports.ROUND = "pt-round";
// text utilities
exports.TEXT_MUTED = "pt-text-muted";
exports.TEXT_OVERFLOW_ELLIPSIS = "pt-text-overflow-ellipsis";
exports.UI_TEXT_LARGE = "pt-ui-text-large";
// components
exports.ALERT = "pt-alert";
exports.ALERT_BODY = "pt-alert-body";
exports.ALERT_CONTENTS = "pt-alert-contents";
exports.ALERT_FOOTER = "pt-alert-footer";
exports.BREADCRUMB = "pt-breadcrumb";
exports.BREADCRUMB_CURRENT = "pt-breadcrumb-current";
exports.BREADCRUMBS = "pt-breadcrumbs";
exports.BREADCRUMBS_COLLAPSED = "pt-breadcrumbs-collapsed";
exports.BUTTON = "pt-button";
exports.BUTTON_GROUP = "pt-button-group";
exports.CALLOUT = "pt-callout";
exports.CARD = "pt-card";
exports.COLLAPSE = "pt-collapse";
exports.COLLAPSIBLE_LIST = "pt-collapse-list";
exports.CONTEXT_MENU = "pt-context-menu";
exports.CONTEXT_MENU_POPOVER_TARGET = "pt-context-menu-popover-target";
exports.CONTROL = "pt-control";
exports.CONTROL_GROUP = "pt-control-group";
exports.CONTROL_INDICATOR = "pt-control-indicator";
exports.DIALOG = "pt-dialog";
exports.DIALOG_CONTAINER = "pt-dialog-container";
exports.DIALOG_BODY = "pt-dialog-body";
exports.DIALOG_CLOSE_BUTTON = "pt-dialog-close-button";
exports.DIALOG_FOOTER = "pt-dialog-footer";
exports.DIALOG_FOOTER_ACTIONS = "pt-dialog-footer-actions";
exports.DIALOG_HEADER = "pt-dialog-header";
exports.EDITABLE_TEXT = "pt-editable-text";
exports.ELEVATION_0 = "pt-elevation-0";
exports.ELEVATION_1 = "pt-elevation-1";
exports.ELEVATION_2 = "pt-elevation-2";
exports.ELEVATION_3 = "pt-elevation-3";
exports.ELEVATION_4 = "pt-elevation-4";
exports.INPUT = "pt-input";
exports.INPUT_GROUP = "pt-input-group";
exports.CHECKBOX = "pt-checkbox";
exports.RADIO = "pt-radio";
exports.SWITCH = "pt-switch";
exports.FILE_UPLOAD = "pt-file-upload";
exports.FILE_UPLOAD_INPUT = "pt-file-upload-input";
exports.INTENT_PRIMARY = "pt-intent-primary";
exports.INTENT_SUCCESS = "pt-intent-success";
exports.INTENT_WARNING = "pt-intent-warning";
exports.INTENT_DANGER = "pt-intent-danger";
exports.LABEL = "pt-label";
exports.FORM_GROUP = "pt-form-group";
exports.FORM_CONTENT = "pt-form-content";
exports.FORM_HELPER_TEXT = "pt-form-helper-text";
exports.MENU = "pt-menu";
exports.MENU_ITEM = "pt-menu-item";
exports.MENU_ITEM_LABEL = "pt-menu-item-label";
exports.MENU_SUBMENU = "pt-submenu";
exports.MENU_DIVIDER = "pt-menu-divider";
exports.MENU_HEADER = "pt-menu-header";
exports.NAVBAR = "pt-navbar";
exports.NAVBAR_GROUP = "pt-navbar-group";
exports.NAVBAR_HEADING = "pt-navbar-heading";
exports.NAVBAR_DIVIDER = "pt-navbar-divider";
exports.NON_IDEAL_STATE = "pt-non-ideal-state";
exports.NON_IDEAL_STATE_ACTION = "pt-non-ideal-state-action";
exports.NON_IDEAL_STATE_DESCRIPTION = "pt-non-ideal-state-description";
exports.NON_IDEAL_STATE_ICON = "pt-non-ideal-state-icon";
exports.NON_IDEAL_STATE_TITLE = "pt-non-ideal-state-title";
exports.NON_IDEAL_STATE_VISUAL = "pt-non-ideal-state-visual";
exports.NUMERIC_INPUT = "pt-numeric-input";
exports.OVERLAY = "pt-overlay";
exports.OVERLAY_BACKDROP = "pt-overlay-backdrop";
exports.OVERLAY_CONTENT = "pt-overlay-content";
exports.OVERLAY_INLINE = "pt-overlay-inline";
exports.OVERLAY_OPEN = "pt-overlay-open";
exports.OVERLAY_SCROLL_CONTAINER = "pt-overlay-scroll-container";
exports.POPOVER = "pt-popover";
exports.POPOVER_ARROW = "pt-popover-arrow";
exports.POPOVER_BACKDROP = "pt-popover-backdrop";
exports.POPOVER_CONTENT = "pt-popover-content";
exports.POPOVER_DISMISS = "pt-popover-dismiss";
exports.POPOVER_DISMISS_OVERRIDE = "pt-popover-dismiss-override";
exports.POPOVER_OPEN = "pt-popover-open";
exports.POPOVER_TARGET = "pt-popover-target";
exports.TRANSITION_CONTAINER = "pt-transition-container";
exports.PROGRESS_BAR = "pt-progress-bar";
exports.PROGRESS_METER = "pt-progress-meter";
exports.PROGRESS_NO_STRIPES = "pt-no-stripes";
exports.PROGRESS_NO_ANIMATION = "pt-no-animation";
exports.PORTAL = "pt-portal";
exports.SELECT = "pt-select";
exports.SKELETON = "pt-skeleton";
exports.SLIDER = "pt-slider";
exports.SLIDER_HANDLE = exports.SLIDER + "-handle";
exports.SLIDER_LABEL = exports.SLIDER + "-label";
exports.RANGE_SLIDER = "pt-range-slider";
exports.SPINNER = "pt-spinner";
exports.SVG_SPINNER = "pt-svg-spinner";
exports.TAB = "pt-tab";
exports.TAB_LIST = "pt-tab-list";
exports.TAB_PANEL = "pt-tab-panel";
exports.TABS = "pt-tabs";
exports.TABLE = "pt-table";
exports.TABLE_CONDENSED = "pt-condensed";
exports.TABLE_STRIPED = "pt-striped";
exports.TABLE_BORDERED = "pt-bordered";
exports.TAG = "pt-tag";
exports.TAG_REMOVABLE = "pt-tag-removable";
exports.TAG_REMOVE = "pt-tag-remove";
exports.TOAST = "pt-toast";
exports.TOAST_CONTAINER = "pt-toast-container";
exports.TOAST_MESSAGE = "pt-toast-message";
exports.TOOLTIP = "pt-tooltip";
exports.TREE = "pt-tree";
exports.TREE_NODE = "pt-tree-node";
exports.TREE_NODE_CARET = "pt-tree-node-caret";
exports.TREE_NODE_CARET_CLOSED = "pt-tree-node-caret-closed";
exports.TREE_NODE_CARET_NONE = "pt-tree-node-caret-none";
exports.TREE_NODE_CARET_OPEN = "pt-tree-node-caret-open";
exports.TREE_NODE_CONTENT = "pt-tree-node-content";
exports.TREE_NODE_EXPANDED = "pt-tree-node-expanded";
exports.TREE_NODE_ICON = "pt-tree-node-icon";
exports.TREE_NODE_LABEL = "pt-tree-node-label";
exports.TREE_NODE_LIST = "pt-tree-node-list";
exports.TREE_NODE_SECONDARY_LABEL = "pt-tree-node-secondary-label";
exports.TREE_NODE_SELECTED = "pt-tree-node-selected";
exports.TREE_ROOT = "pt-tree-root";
exports.ICON = "pt-icon";
exports.ICON_STANDARD = "pt-icon-standard";
exports.ICON_LARGE = "pt-icon-large";
/** Return CSS class for icon, whether or not 'pt-icon-' prefix is included */
function iconClass(iconName) {
    if (iconName == null) {
        return undefined;
    }
    return iconName.indexOf("pt-icon-") === 0 ? iconName : "pt-icon-" + iconName;
}
exports.iconClass = iconClass;
function intentClass(intent) {
    if (intent === void 0) {
        intent = intent_1.Intent.NONE;
    }
    if (intent === intent_1.Intent.NONE || intent_1.Intent[intent] == null) {
        return undefined;
    }
    return "pt-intent-" + intent_1.Intent[intent].toLowerCase();
}
exports.intentClass = intentClass;

//# sourceMappingURL=classes.js.map

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint no-use-before-define: [1, 'nofunc'] */

// Functions are hoisted, so in this case it's ok to override
// eslint since one function needs to reference the other

function nullifyEmptyStringsInObject(obj) {
  // Handle null and undefined values
  if (obj) {
    var keys = Object.keys(obj);
    var newObj = {};
    // Iterate through keys and recursively nullify empty strings
    keys.map(function (key) {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          newObj[key] = nullifyEmptyStringsInArray(obj[key]);
        } else if (_typeof(obj[key]) === 'object') {
          newObj[key] = nullifyEmptyStringsInObject(obj[key]);
        } else if (typeof obj[key] === 'string') {
          newObj[key] = obj[key] === '' ? null : obj[key];
        } else {
          newObj[key] = obj[key];
        }
      }
      return key;
    });
    return newObj;
  }
  return obj;
}

function nullifyEmptyStringsInArray(arr) {
  // Check for null or undefined values
  if (arr) {
    var newArr = [];
    // Iterate through array and recursively nullify strings
    for (var i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        newArr.push(nullifyEmptyStringsInArray(arr[i]));
      } else if (_typeof(arr[i]) === 'object') {
        newArr.push(nullifyEmptyStringsInObject(arr[i]));
      } else if (typeof arr[i] === 'string') {
        newArr.push(arr[i] === '' ? null : arr[i]);
      } else {
        newArr.push(arr[i]);
      }
    }
    return newArr;
  }
  return arr;
}

/* harmony default export */ __webpack_exports__["a"] = (nullifyEmptyStringsInObject);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (specifier) {
  var n = specifier.length / 6 | 0,
      colors = new Array(n),
      i = 0;
  while (i < n) {
    colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  }return colors;
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(545);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(393);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(689);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3544);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Document.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Document.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1388),
    baseRest = __webpack_require__(205),
    isArrayLikeObject = __webpack_require__(376);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function (array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});

module.exports = without;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(2184);
moment.tz.load(__webpack_require__(3596));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



var RelayRecordState = {
  /**
   * Record exists (either fetched from the server or produced by a local,
   * optimistic update).
   */
  EXISTENT: 'EXISTENT',

  /**
   * Record is known not to exist (either as the result of a mutation, or
   * because the server returned `null` when queried for the record).
   */
  NONEXISTENT: 'NONEXISTENT',

  /**
   * Record State is unknown because it has not yet been fetched from the
   * server.
   */
  UNKNOWN: 'UNKNOWN'
};

module.exports = RelayRecordState;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  largeScreenBreakpoint: 1280,
  desktopBreakpoint: 992,
  tabletBreakpoint: 768
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(323);


/* harmony default export */ __webpack_exports__["a"] = (function (scheme) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateRgbBasis"])(scheme[scheme.length - 1]);
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = __webpack_require__(93);
/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
function isNodeEnv(env) {
    return typeof process !== "undefined" && __webpack_require__.i({"NODE_ENV":"production","GOOGLE_API_KEY":"AIzaSyCd8SPvwAkEHZVjufQajz0aL2P1GfPxEmM","BASE_URL":"https://www.cloverbook.com","FILESTACK_API_KEY":"APuzhYdNWQSenbreru4Iuz","SQUARE_APPLICATION_ID":"sq0idp-HR-L29IoCw1mPmEfvop0wg","SPOTIFY_CLIENT_ID":"6bee432e89a046a6927b6d9e824c6511"}) && "production" === env;
}
exports.isNodeEnv = isNodeEnv;
/** Returns whether the value is a function. Acts as a type guard. */
// tslint:disable-next-line:ban-types
function isFunction(value) {
    return typeof value === "function";
}
exports.isFunction = isFunction;
// tslint:disable-next-line:ban-types
function safeInvoke(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isFunction(func)) {
        return func.apply(void 0, args);
    }
}
exports.safeInvoke = safeInvoke;
function elementIsOrContains(element, testElement) {
    return element === testElement || element.contains(testElement);
}
exports.elementIsOrContains = elementIsOrContains;
/**
 * Returns the difference in length between two arrays. A `null` argument is considered an empty list.
 * The return value will be positive if `a` is longer than `b`, negative if the opposite is true,
 * and zero if their lengths are equal.
 */
function arrayLengthCompare(a, b) {
    if (a === void 0) {
        a = [];
    }
    if (b === void 0) {
        b = [];
    }
    return a.length - b.length;
}
exports.arrayLengthCompare = arrayLengthCompare;
/**
 * Returns true if the two numbers are within the given tolerance of each other.
 * This is useful to correct for floating point precision issues, less useful for integers.
 */
function approxEqual(a, b, tolerance) {
    if (tolerance === void 0) {
        tolerance = 0.00001;
    }
    return Math.abs(a - b) <= tolerance;
}
exports.approxEqual = approxEqual;
/** Clamps the given number between min and max values. Returns value if within range, or closest bound. */
function clamp(val, min, max) {
    if (val == null) {
        return val;
    }
    if (max < min) {
        throw new Error(errors_1.CLAMP_MIN_MAX);
    }
    return Math.min(Math.max(val, min), max);
}
exports.clamp = clamp;
/** Returns the number of decimal places in the given number. */
function countDecimalPlaces(num) {
    if (typeof num !== "number" || Math.floor(num) === num) {
        return 0;
    }
    return num.toString().split(".")[1].length;
}
exports.countDecimalPlaces = countDecimalPlaces;
/**
 * Throttle an event on an EventTarget by wrapping it in a `requestAnimationFrame` call.
 * Returns the event handler that was bound to given eventName so you can clean up after yourself.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/scroll
 */
function throttleEvent(target, eventName, newEventName) {
    var throttledFunc = throttleHelper(undefined, undefined, function (event) {
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
exports.throttleEvent = throttleEvent;
;
;
/**
 * Throttle a callback by wrapping it in a `requestAnimationFrame` call. Returns the throttled
 * function.
 * @see https://www.html5rocks.com/en/tutorials/speed/animations/
 */
function throttleReactEventCallback(callback, options) {
    if (options === void 0) {
        options = {};
    }
    var throttledFunc = throttleHelper(function (event2) {
        if (options.preventDefault) {
            event2.preventDefault();
        }
    }, function (event2) {
        // prevent React from reclaiming the event object before we reference it
        event2.persist();
    }, function (event2) {
        var otherArgs2 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            otherArgs2[_i - 1] = arguments[_i];
        }
        callback.apply(void 0, [event2].concat(otherArgs2));
    });
    return throttledFunc;
}
exports.throttleReactEventCallback = throttleReactEventCallback;
function throttleHelper(onBeforeIsRunningCheck, onAfterIsRunningCheck, onAnimationFrameRequested) {
    var isRunning = false;
    var func = function func() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // don't use safeInvoke, because we might have more than its max number of typed params
        if (isFunction(onBeforeIsRunningCheck)) {
            onBeforeIsRunningCheck.apply(void 0, args);
        }
        if (isRunning) {
            return;
        }
        isRunning = true;
        if (isFunction(onAfterIsRunningCheck)) {
            onAfterIsRunningCheck.apply(void 0, args);
        }
        requestAnimationFrame(function () {
            if (isFunction(onAnimationFrameRequested)) {
                onAnimationFrameRequested.apply(void 0, args);
            }
            isRunning = false;
        });
    };
    return func;
}

//# sourceMappingURL=utils.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(339)))

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RootConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__variables__ = __webpack_require__(50);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var RootContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({
  window: { width: window.innerWidth, height: window.innerHeight }
});

var RootConsumer = RootContext.Consumer;

var RootComponent = (_temp = _class = function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root(props) {
    _classCallCheck(this, Root);

    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(Root, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight },
        isMobile: window.innerWidth < __WEBPACK_IMPORTED_MODULE_2__variables__["a" /* default */].tabletBreakpoint,
        isComputer: window.innerWidth >= __WEBPACK_IMPORTED_MODULE_2__variables__["a" /* default */].tabletBreakpoint,
        isLargeScreen: window.innerWidth >= __WEBPACK_IMPORTED_MODULE_2__variables__["a" /* default */].largeScreenBreakpoint
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        RootContext.Provider,
        { value: this.state },
        this.props.children
      );
    }
  }]);

  return Root;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (RootComponent);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(25);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(221)('wks');
var uid = __webpack_require__(161);
var _Symbol = __webpack_require__(64).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var accounting = __webpack_require__(1567);
var assign = __webpack_require__(169);
var localeCurrency = __webpack_require__(2038);
var currencies = __webpack_require__(3594);
var localeFormats = __webpack_require__(3595);

var defaultCurrency = {
  symbol: '',
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};

var defaultLocaleFormat = {};

var formatMapping = [{
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  format: {
    pos: '%s%v',
    neg: '-%s%v',
    zero: '%s%v'
  }
}, {
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  format: {
    pos: '%s %v',
    neg: '-%s %v',
    zero: '%s %v'
  }
}, {
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  format: {
    pos: '%v%s',
    neg: '-%v%s',
    zero: '%v%s'
  }
}, {
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  format: {
    pos: '%v %s',
    neg: '-%v %s',
    zero: '%v %s'
  }
}];

function format(value, options) {
  var code = options.code || options.locale && localeCurrency.getCurrency(options.locale);
  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat;
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat);

  var symbolOnLeft = currency.symbolOnLeft;
  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol;

  var format = formatMapping.filter(function (f) {
    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol;
  })[0].format;

  return accounting.formatMoney(value, {
    symbol: isUndefined(options.symbol) ? currency.symbol : options.symbol,

    decimal: isUndefined(options.decimal) ? currency.decimalSeparator : options.decimal,

    thousand: isUndefined(options.thousand) ? currency.thousandsSeparator : options.thousand,

    precision: typeof options.precision === 'number' ? options.precision : currency.decimalDigits,

    format: ['string', 'object'].indexOf(_typeof(options.format)) > -1 ? options.format : format
  });
}

function findCurrency(currencyCode) {
  return currencies[currencyCode];
}

function isUndefined(val) {
  return typeof val === 'undefined';
}

module.exports = {
  defaultCurrency: defaultCurrency,
  get currencies() {
    // In favor of backwards compatibility, the currencies map is converted to an array here
    return Object.keys(currencies).map(function (key) {
      return currencies[key];
    });
  },
  findCurrency: findCurrency,
  format: format
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2294)();
}

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Félix Girault <felix.girault@gmail.com>
 * @license MIT
 */


var warning = __webpack_require__(1870);
var shallowEqual = __webpack_require__(1869);

/**
 * Tells if a component should update given it's next props
 * and state.
 *
 * @param object nextProps Next props.
 * @param object nextState Next state.
 */
function shouldComponentUpdate(nextProps, nextState) {
  return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
}

/**
 * Returns a text description of the component that can be
 * used to identify it in error messages.
 *
 * @see https://github.com/facebook/react/blob/v15.4.0-rc.3/src/renderers/shared/stack/reconciler/ReactCompositeComponent.js#L1143
 * @param {function} component The component.
 * @return {string} The name of the component.
 */
function getComponentName(component) {
  var constructor = component.prototype && component.prototype.constructor;

  return component.displayName || constructor && constructor.displayName || component.name || constructor && constructor.name || 'a component';
}

/**
 * Makes the given component "pure".
 *
 * @param object component Component.
 */
function pureRenderDecorator(component) {
  if (component.prototype.shouldComponentUpdate !== undefined) {
    // We're not using the condition mecanism of warning()
    // here to avoid useless calls to getComponentName().
    warning(false, 'Cannot decorate `%s` with @pureRenderDecorator, ' + 'because it already implements `shouldComponentUpdate().', getComponentName(component));
  }

  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
  return component;
}

module.exports = pureRenderDecorator;

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(64);
var core = __webpack_require__(45);
var ctx = __webpack_require__(146);
var hide = __webpack_require__(101);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(2719),
    util = __webpack_require__(2721);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180),
    baseIteratee = __webpack_require__(117),
    baseMap = __webpack_require__(1392),
    isArray = __webpack_require__(51);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return negate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return absolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return patch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return apply; });


var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};

var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};

var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};

var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};

var absolute = function absolute(point) {
  return {
    x: Math.abs(point.x),
    y: Math.abs(point.y)
  };
};

var patch = function patch(line, value) {
  var _ref;

  var otherValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};

var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};

var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};

var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(721)();
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MobileHeader = function (_React$Component) {
  _inherits(MobileHeader, _React$Component);

  function MobileHeader() {
    _classCallCheck(this, MobileHeader);

    return _possibleConstructorReturn(this, (MobileHeader.__proto__ || Object.getPrototypeOf(MobileHeader)).apply(this, arguments));
  }

  _createClass(MobileHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
        { className: __WEBPACK_IMPORTED_MODULE_3__App_scss___default.a.mobileHeader },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { only: 'tablet mobile' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'ui top fixed huge menu borderless topNavMobile' },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return MobileHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MobileHeader.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MobileHeader);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



module.exports = __webpack_require__(2443);

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function createFragmentSpecResolver(context, containerName, fragments, props, callback) {
  if (false) {
    var fragmentNames = Object.keys(fragments);
    fragmentNames.forEach(function (fragmentName) {
      var propValue = props[fragmentName];
      process.env.NODE_ENV !== 'production' ? require('fbjs/lib/warning')(propValue !== undefined, 'createFragmentSpecResolver: Expected prop `%s` to be supplied to `%s`, but ' + 'got `undefined`. Pass an explicit `null` if this is intentional.', fragmentName, containerName) : void 0;
    });
  }

  return new (__webpack_require__(734))(context, fragments, props, callback);
}

module.exports = {
  areEqualSelectors: __webpack_require__(85).areEqualSelectors,
  createFragmentSpecResolver: createFragmentSpecResolver,
  createOperationSelector: __webpack_require__(359).createOperationSelector,
  getDataIDsFromObject: __webpack_require__(85).getDataIDsFromObject,
  getFragment: __webpack_require__(116).getFragment,
  getRequest: __webpack_require__(116).getRequest,
  getSelector: __webpack_require__(85).getSelector,
  getSelectorList: __webpack_require__(85).getSelectorList,
  getSelectorsFromObject: __webpack_require__(85).getSelectorsFromObject,
  getVariablesFromObject: __webpack_require__(85).getVariablesFromObject
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



var PREFIX = 'client:';

function generateRelayClientID(id, storageKey, index) {
  var key = id + ':' + storageKey;
  if (index != null) {
    key += ':' + index;
  }
  if (key.indexOf(PREFIX) !== 0) {
    key = PREFIX + key;
  }
  return key;
}

module.exports = generateRelayClientID;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3540);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./App.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./App.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3545);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Form.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Form.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(86);
var IE8_DOM_DEFINE = __webpack_require__(307);
var toPrimitive = __webpack_require__(223);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var RelayPropTypes = {
  Container: function Container(props, propName, componentName) {
    var component = props[propName];
    if (component == null) {
      return new Error(__webpack_require__(114)('Required prop `%s` was not specified in `%s`.', propName, componentName));
    } else if (!__webpack_require__(474)(component)) {
      return new Error(__webpack_require__(114)('Invalid prop `%s` supplied to `%s`, expected a RelayContainer.', propName, componentName));
    }
    return null;
  },
  Environment: function Environment(props, propName, componentName) {
    var context = props[propName];
    if (!__webpack_require__(294)(context) || !__webpack_require__(351)(context)) {
      return new Error(__webpack_require__(114)('Invalid prop/context `%s` supplied to `%s`, expected `%s` to be ' + 'an object conforming to the `RelayEnvironment` interface.', propName, componentName, context));
    }
    return null;
  },

  QueryConfig: __webpack_require__(70).shape({
    name: __webpack_require__(70).string.isRequired,
    params: __webpack_require__(70).object.isRequired,
    queries: __webpack_require__(70).object.isRequired
  }),

  ClassicRelay: function ClassicRelay(props, propName, componentName) {
    var relay = props[propName];
    if (!__webpack_require__(126).isRelayContext(relay) || !__webpack_require__(294)(relay.environment)) {
      return new Error(__webpack_require__(114)('Invalid prop/context `%s` supplied to `%s`, expected `%s` to be ' + 'an object with a classic `environment` implementation and `variables`.', propName, componentName, relay));
    }
    return null;
  },
  Relay: function Relay(props, propName, componentName) {
    var relay = props[propName];
    if (!__webpack_require__(126).isRelayContext(relay)) {
      return new Error(__webpack_require__(114)('Invalid prop/context `%s` supplied to `%s`, expected `%s` to be ' + 'an object with an `environment` and `variables`.', propName, componentName, relay));
    }
    return null;
  }
};

module.exports = RelayPropTypes;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var aStackPool = [];
var bStackPool = [];

/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */
function areEqual(a, b) {
  var aStack = aStackPool.length ? aStackPool.pop() : [];
  var bStack = bStackPool.length ? bStackPool.pop() : [];
  var result = eq(a, b, aStack, bStack);
  aStack.length = 0;
  bStack.length = 0;
  aStackPool.push(aStack);
  bStackPool.push(bStack);
  return result;
}

function eq(a, b, aStack, bStack) {
  if (a === b) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
  }
  if (a == null || b == null) {
    // a or b can be `null` or `undefined`
    return false;
  }
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') {
    return false;
  }
  var objToStr = Object.prototype.toString;
  var className = objToStr.call(a);
  if (className != objToStr.call(b)) {
    return false;
  }
  switch (className) {
    case '[object String]':
      return a == String(b);
    case '[object Number]':
      return isNaN(a) || isNaN(b) ? false : a == Number(b);
    case '[object Date]':
    case '[object Boolean]':
      return +a == +b;
    case '[object RegExp]':
      return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
  }
  // Assume equality for cyclic structures.
  var length = aStack.length;
  while (length--) {
    if (aStack[length] == a) {
      return bStack[length] == b;
    }
  }
  aStack.push(a);
  bStack.push(b);
  var size = 0;
  // Recursively compare objects and arrays.
  if (className === '[object Array]') {
    size = a.length;
    if (size !== b.length) {
      return false;
    }
    // Deep compare the contents, ignoring non-numeric properties.
    while (size--) {
      if (!eq(a[size], b[size], aStack, bStack)) {
        return false;
      }
    }
  } else {
    if (a.constructor !== b.constructor) {
      return false;
    }
    if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) {
      return a.valueOf() == b.valueOf();
    }
    var keys = Object.keys(a);
    if (keys.length != Object.keys(b).length) {
      return false;
    }
    for (var i = 0; i < keys.length; i++) {
      if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) {
        return false;
      }
    }
  }
  aStack.pop();
  bStack.pop();
  return true;
}

module.exports = areEqual;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var CONNECTION = 'connection';

// Per-instance incrementing index used to generate unique edge IDs
var NEXT_EDGE_INDEX = '__connection_next_edge_index';

/**
 * @public
 *
 * A default runtime handler for connection fields that appends newly fetched
 * edges onto the end of a connection, regardless of the arguments used to fetch
 * those edges.
 */
function update(store, payload) {
  var record = store.get(payload.dataID);
  if (!record) {
    return;
  }

  var _RelayConnectionInter = __webpack_require__(84).get(),
      EDGES = _RelayConnectionInter.EDGES,
      END_CURSOR = _RelayConnectionInter.END_CURSOR,
      HAS_NEXT_PAGE = _RelayConnectionInter.HAS_NEXT_PAGE,
      HAS_PREV_PAGE = _RelayConnectionInter.HAS_PREV_PAGE,
      PAGE_INFO = _RelayConnectionInter.PAGE_INFO,
      PAGE_INFO_TYPE = _RelayConnectionInter.PAGE_INFO_TYPE,
      START_CURSOR = _RelayConnectionInter.START_CURSOR;

  var serverConnection = record.getLinkedRecord(payload.fieldKey);
  var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
  if (!serverConnection) {
    record.setValue(null, payload.handleKey);
    return;
  }
  var clientConnection = record.getLinkedRecord(payload.handleKey);
  var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
  if (!clientConnection) {
    // Initial fetch with data: copy fields from the server record
    var connection = store.create(__webpack_require__(76)(record.getDataID(), payload.handleKey), serverConnection.getType());
    connection.setValue(0, NEXT_EDGE_INDEX);
    connection.copyFieldsFrom(serverConnection);
    var serverEdges = serverConnection.getLinkedRecords(EDGES);
    if (serverEdges) {
      serverEdges = serverEdges.map(function (edge) {
        return buildConnectionEdge(store, connection, edge);
      });
      connection.setLinkedRecords(serverEdges, EDGES);
    }
    record.setLinkedRecord(connection, payload.handleKey);

    clientPageInfo = store.create(__webpack_require__(76)(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
    clientPageInfo.setValue(false, HAS_NEXT_PAGE);
    clientPageInfo.setValue(false, HAS_PREV_PAGE);
    clientPageInfo.setValue(null, END_CURSOR);
    clientPageInfo.setValue(null, START_CURSOR);
    if (serverPageInfo) {
      clientPageInfo.copyFieldsFrom(serverPageInfo);
    }
    connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
  } else {
    var _connection = clientConnection;
    // Subsequent fetches:
    // - updated fields on the connection
    // - merge prev/next edges, de-duplicating by node id
    // - synthesize page info fields
    var _serverEdges = serverConnection.getLinkedRecords(EDGES);
    if (_serverEdges) {
      _serverEdges = _serverEdges.map(function (edge) {
        return buildConnectionEdge(store, _connection, edge);
      });
    }
    var prevEdges = _connection.getLinkedRecords(EDGES);
    var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
    _connection.copyFieldsFrom(serverConnection);
    // Reset EDGES and PAGE_INFO fields
    if (prevEdges) {
      _connection.setLinkedRecords(prevEdges, EDGES);
    }
    if (prevPageInfo) {
      _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
    }

    var nextEdges = [];
    var args = payload.args;
    if (prevEdges && _serverEdges) {
      if (args.after != null) {
        // Forward pagination from the end of the connection: append edges
        if (clientPageInfo && args.after === clientPageInfo.getValue(END_CURSOR)) {
          var nodeIDs = new Set();
          mergeEdges(prevEdges, nextEdges, nodeIDs);
          mergeEdges(_serverEdges, nextEdges, nodeIDs);
        } else {
           false ? require('fbjs/lib/warning')(false, 'RelayConnectionHandler: Unexpected after cursor `%s`, edges must ' + 'be fetched from the end of the list (`%s`).', args.after, clientPageInfo && clientPageInfo.getValue(END_CURSOR)) : void 0;
          return;
        }
      } else if (args.before != null) {
        // Backward pagination from the start of the connection: prepend edges
        if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
          var _nodeIDs = new Set();
          mergeEdges(_serverEdges, nextEdges, _nodeIDs);
          mergeEdges(prevEdges, nextEdges, _nodeIDs);
        } else {
           false ? require('fbjs/lib/warning')(false, 'RelayConnectionHandler: Unexpected before cursor `%s`, edges must ' + 'be fetched from the beginning of the list (`%s`).', args.before, clientPageInfo && clientPageInfo.getValue(START_CURSOR)) : void 0;
          return;
        }
      } else {
        // The connection was refetched from the beginning/end: replace edges
        nextEdges = _serverEdges;
      }
    } else if (_serverEdges) {
      nextEdges = _serverEdges;
    } else {
      nextEdges = prevEdges;
    }
    // Update edges only if they were updated, the null check is
    // for Flow (prevEdges could be null).
    if (nextEdges != null && nextEdges !== prevEdges) {
      _connection.setLinkedRecords(nextEdges, EDGES);
    }
    // Page info should be updated even if no new edge were returned.
    if (clientPageInfo && serverPageInfo) {
      if (args.after == null && args.before == null) {
        // The connection was refetched from the beginning/end: replace
        // page_info
        clientPageInfo.copyFieldsFrom(serverPageInfo);
      } else if (args.before != null || args.after == null && args.last) {
        clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
        var startCursor = serverPageInfo.getValue(START_CURSOR);
        if (typeof startCursor === 'string') {
          clientPageInfo.setValue(startCursor, START_CURSOR);
        }
      } else if (args.after != null || args.before == null && args.first) {
        clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
        var endCursor = serverPageInfo.getValue(END_CURSOR);
        if (typeof endCursor === 'string') {
          clientPageInfo.setValue(endCursor, END_CURSOR);
        }
      }
    }
  }
}

/**
 * @public
 *
 * Given a record and the name of the schema field for which a connection was
 * fetched, returns the linked connection record.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * The `friends` connection record can be accessed with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = RelayConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   // Access fields on the connection:
 *   const edges = friends.getLinkedRecords('edges');
 * }
 * ```
 *
 * TODO: t15733312
 * Currently we haven't run into this case yet, but we need to add a `getConnections`
 * that returns an array of the connections under the same `key` regardless of the variables.
 */
function getConnection(record, key, filters) {
  var handleKey = __webpack_require__(249)(CONNECTION, key, null);
  return record.getLinkedRecord(handleKey, filters);
}

/**
 * @public
 *
 * Inserts an edge after the given cursor, or at the end of the list if no
 * cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be appended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = RelayConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   RelayConnectionHandler.insertEdgeAfter(friends, edge);
 * }
 * ```
 */
function insertEdgeAfter(record, newEdge, cursor) {
  var _RelayConnectionInter2 = __webpack_require__(84).get(),
      CURSOR = _RelayConnectionInter2.CURSOR,
      EDGES = _RelayConnectionInter2.EDGES;

  var edges = record.getLinkedRecords(EDGES);
  if (!edges) {
    record.setLinkedRecords([newEdge], EDGES);
    return;
  }
  var nextEdges = void 0;
  if (cursor == null) {
    nextEdges = edges.concat(newEdge);
  } else {
    nextEdges = [];
    var foundCursor = false;
    for (var ii = 0; ii < edges.length; ii++) {
      var edge = edges[ii];
      nextEdges.push(edge);
      if (edge == null) {
        continue;
      }
      var edgeCursor = edge.getValue(CURSOR);
      if (cursor === edgeCursor) {
        nextEdges.push(newEdge);
        foundCursor = true;
      }
    }
    if (!foundCursor) {
      nextEdges.push(newEdge);
    }
  }
  record.setLinkedRecords(nextEdges, EDGES);
}

/**
 * @public
 *
 * Creates an edge for a connection record, given a node and edge type.
 */
function createEdge(store, record, node, edgeType) {
  var _RelayConnectionInter3 = __webpack_require__(84).get(),
      NODE = _RelayConnectionInter3.NODE;

  // An index-based client ID could easily conflict (unless it was
  // auto-incrementing, but there is nowhere to the store the id)
  // Instead, construct a client ID based on the connection ID and node ID,
  // which will only conflict if the same node is added to the same connection
  // twice. This is acceptable since the `insertEdge*` functions ignore
  // duplicates.


  var edgeID = __webpack_require__(76)(record.getDataID(), node.getDataID());
  var edge = store.get(edgeID);
  if (!edge) {
    edge = store.create(edgeID, edgeType);
  }
  edge.setLinkedRecord(node, NODE);
  return edge;
}

/**
 * @public
 *
 * Inserts an edge before the given cursor, or at the beginning of the list if
 * no cursor is provided.
 *
 * Example:
 *
 * Given that data has already been fetched on some user `<id>` on the `friends`
 * field:
 *
 * ```
 * fragment FriendsFragment on User {
 *   friends(first: 10) @connection(key: "FriendsFragment_friends") {
 *    edges {
 *      node {
 *        id
 *        }
 *      }
 *   }
 * }
 * ```
 *
 * An edge can be prepended with:
 *
 * ```
 * store => {
 *   const user = store.get('<id>');
 *   const friends = RelayConnectionHandler.getConnection(user, 'FriendsFragment_friends');
 *   const edge = store.create('<edge-id>', 'FriendsEdge');
 *   RelayConnectionHandler.insertEdgeBefore(friends, edge);
 * }
 * ```
 */
function insertEdgeBefore(record, newEdge, cursor) {
  var _RelayConnectionInter4 = __webpack_require__(84).get(),
      CURSOR = _RelayConnectionInter4.CURSOR,
      EDGES = _RelayConnectionInter4.EDGES;

  var edges = record.getLinkedRecords(EDGES);
  if (!edges) {
    record.setLinkedRecords([newEdge], EDGES);
    return;
  }
  var nextEdges = void 0;
  if (cursor == null) {
    nextEdges = [newEdge].concat(edges);
  } else {
    nextEdges = [];
    var foundCursor = false;
    for (var ii = 0; ii < edges.length; ii++) {
      var edge = edges[ii];
      if (edge != null) {
        var edgeCursor = edge.getValue(CURSOR);
        if (cursor === edgeCursor) {
          nextEdges.push(newEdge);
          foundCursor = true;
        }
      }
      nextEdges.push(edge);
    }
    if (!foundCursor) {
      nextEdges.unshift(newEdge);
    }
  }
  record.setLinkedRecords(nextEdges, EDGES);
}

/**
 * @public
 *
 * Remove any edges whose `node.id` matches the given id.
 */
function deleteNode(record, nodeID) {
  var _RelayConnectionInter5 = __webpack_require__(84).get(),
      EDGES = _RelayConnectionInter5.EDGES,
      NODE = _RelayConnectionInter5.NODE;

  var edges = record.getLinkedRecords(EDGES);
  if (!edges) {
    return;
  }
  var nextEdges = void 0;
  for (var ii = 0; ii < edges.length; ii++) {
    var edge = edges[ii];
    var node = edge && edge.getLinkedRecord(NODE);
    if (node != null && node.getDataID() === nodeID) {
      if (nextEdges === undefined) {
        nextEdges = edges.slice(0, ii);
      }
    } else if (nextEdges !== undefined) {
      nextEdges.push(edge);
    }
  }
  if (nextEdges !== undefined) {
    record.setLinkedRecords(nextEdges, EDGES);
  }
}

/**
 * @internal
 *
 * Creates a copy of an edge with a unique ID based on per-connection-instance
 * incrementing edge index. This is necessary to avoid collisions between edges,
 * which can occur because (edge) client IDs are assigned deterministically
 * based on the path from the nearest node with an id.
 *
 * Example: if the first N edges of the same connection are refetched, the edges
 * from the second fetch will be assigned the same IDs as the first fetch, even
 * though the nodes they point to may be different (or the same and in different
 * order).
 */
function buildConnectionEdge(store, connection, edge) {
  if (edge == null) {
    return edge;
  }

  var _RelayConnectionInter6 = __webpack_require__(84).get(),
      EDGES = _RelayConnectionInter6.EDGES;

  var edgeIndex = connection.getValue(NEXT_EDGE_INDEX);
  !(typeof edgeIndex === 'number') ?  false ? require('fbjs/lib/invariant')(false, 'RelayConnectionHandler: Expected %s to be a number, got `%s`.', NEXT_EDGE_INDEX, edgeIndex) : __webpack_require__(10)(false) : void 0;
  var edgeID = __webpack_require__(76)(connection.getDataID(), EDGES, edgeIndex);
  var connectionEdge = store.create(edgeID, edge.getType());
  connectionEdge.copyFieldsFrom(edge);
  connection.setValue(edgeIndex + 1, NEXT_EDGE_INDEX);
  return connectionEdge;
}

/**
 * @internal
 *
 * Adds the source edges to the target edges, skipping edges with
 * duplicate node ids.
 */
function mergeEdges(sourceEdges, targetEdges, nodeIDs) {
  var _RelayConnectionInter7 = __webpack_require__(84).get(),
      NODE = _RelayConnectionInter7.NODE;

  for (var ii = 0; ii < sourceEdges.length; ii++) {
    var edge = sourceEdges[ii];
    if (!edge) {
      continue;
    }
    var node = edge.getLinkedRecord(NODE);
    var nodeID = node && node.getValue('id');
    if (nodeID) {
      if (nodeIDs.has(nodeID)) {
        continue;
      }
      nodeIDs.add(nodeID);
    }
    targetEdges.push(edge);
  }
}

module.exports = {
  buildConnectionEdge: buildConnectionEdge,
  createEdge: createEdge,
  deleteNode: deleteNode,
  getConnection: getConnection,
  insertEdgeAfter: insertEdgeAfter,
  insertEdgeBefore: insertEdgeBefore,
  update: update
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _defineProperty3 = _interopRequireDefault(__webpack_require__(122));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var CONNECTION_CALLS = {
  after: true,
  before: true,
  find: true,
  first: true,
  last: true,
  surrounds: true
};

var REQUIRED_RANGE_CALLS = {
  find: true,
  first: true,
  last: true
};

var config = {
  CLIENT_MUTATION_ID: 'clientMutationId',
  CURSOR: 'cursor',
  /**
   * Whether `edges` fields are expected to have `source` fields.
   */
  EDGES_HAVE_SOURCE_FIELD: false,
  EDGES: 'edges',
  END_CURSOR: 'endCursor',
  HAS_NEXT_PAGE: 'hasNextPage',
  HAS_PREV_PAGE: 'hasPreviousPage',
  NODE: 'node',
  PAGE_INFO_TYPE: 'PageInfo',
  PAGE_INFO: 'pageInfo',
  START_CURSOR: 'startCursor'
};

/**
 * @internal
 *
 * Defines logic relevant to the informal "Connection" GraphQL interface.
 */
var RelayConnectionInterface = {
  inject: function inject(newConfig) {
    config = newConfig;
  },
  get: function get() {
    return config;
  },

  /**
   * Checks whether a call exists strictly to encode which parts of a connection
   * to fetch. Fields that only differ by connection call values should have the
   * same identity.
   */
  isConnectionCall: function isConnectionCall(call) {
    return CONNECTION_CALLS.hasOwnProperty(call.name);
  },

  /**
   * Checks whether a set of calls on a connection supply enough information to
   * fetch the range fields (i.e. `edges` and `page_info`).
   */
  hasRangeCalls: function hasRangeCalls(calls) {
    return calls.some(function (call) {
      return REQUIRED_RANGE_CALLS.hasOwnProperty(call.name);
    });
  },

  /**
   * Gets a default record representing a connection's `PAGE_INFO`.
   */
  getDefaultPageInfo: function getDefaultPageInfo() {
    var _ref;

    return _ref = {}, (0, _defineProperty3['default'])(_ref, config.END_CURSOR, null), (0, _defineProperty3['default'])(_ref, config.HAS_NEXT_PAGE, false), (0, _defineProperty3['default'])(_ref, config.HAS_PREV_PAGE, false), (0, _defineProperty3['default'])(_ref, config.START_CURSOR, null), _ref;
  }
};

module.exports = RelayConnectionInterface;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * @public
 *
 * Given the result `item` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment for that item.
 *
 * Example:
 *
 * Given two fragments as follows:
 *
 * ```
 * fragment Parent on User {
 *   id
 *   ...Child
 * }
 * fragment Child on User {
 *   name
 * }
 * ```
 *
 * And given some object `parent` that is the results of `Parent` for id "4",
 * the results of `Child` can be accessed by first getting a selector and then
 * using that selector to `lookup()` the results against the environment:
 *
 * ```
 * const childSelector = getSelector(queryVariables, Child, parent);
 * const childData = environment.lookup(childSelector).data;
 * ```
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function getSelector(operationVariables, fragment, item) {
  !((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && !Array.isArray(item)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernSelector: Expected value for fragment `%s` to be an object, got ' + '`%s`.', fragment.name, JSON.stringify(item)) : __webpack_require__(10)(false) : void 0;
  var dataID = item[__webpack_require__(12).ID_KEY];
  var fragments = item[__webpack_require__(12).FRAGMENTS_KEY];
  if (typeof dataID === 'string' && (typeof fragments === 'undefined' ? 'undefined' : _typeof(fragments)) === 'object' && fragments !== null && _typeof(fragments[fragment.name]) === 'object' && fragments[fragment.name] !== null) {
    var argumentVariables = fragments[fragment.name];
    var fragmentVariables = __webpack_require__(243).getFragmentVariables(fragment, operationVariables, argumentVariables);
    return {
      dataID: dataID,
      node: fragment,
      variables: fragmentVariables
    };
  }
   false ? require('fbjs/lib/warning')(false, 'RelayModernSelector: Expected object to contain data for fragment `%s`, got ' + '`%s`. Make sure that the parent operation/fragment included fragment ' + '`...%s` without `@relay(mask: false)`.', fragment.name, JSON.stringify(item), fragment.name) : void 0;
  return null;
}

/**
 * @public
 *
 * Given the result `items` from a parent that fetched `fragment`, creates a
 * selector that can be used to read the results of that fragment on those
 * items. This is similar to `getSelector` but for "plural" fragments that
 * expect an array of results and therefore return an array of selectors.
 */
function getSelectorList(operationVariables, fragment, items) {
  var selectors = null;
  items.forEach(function (item) {
    var selector = item != null ? getSelector(operationVariables, fragment, item) : null;
    if (selector != null) {
      selectors = selectors || [];
      selectors.push(selector);
    }
  });
  return selectors;
}

/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the selectors for those fragments from the results.
 *
 * The canonical use-case for this function is ReactRelayFragmentContainer, which
 * uses this function to convert (props, fragments) into selectors so that it
 * can read the results to pass to the inner component.
 */
function getSelectorsFromObject(operationVariables, fragments, object) {
  var selectors = {};
  for (var _key in fragments) {
    if (fragments.hasOwnProperty(_key)) {
      var fragment = fragments[_key];
      var item = object[_key];
      if (item == null) {
        selectors[_key] = item;
      } else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernSelector: Expected value for key `%s` to be an array, got `%s`. ' + 'Remove `@relay(plural: true)` from fragment `%s` to allow the prop to be an object.', _key, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
        selectors[_key] = getSelectorList(operationVariables, fragment, item);
      } else {
        !!Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernFragmentSpecResolver: Expected value for key `%s` to be an object, got `%s`. ' + 'Add `@relay(plural: true)` to fragment `%s` to allow the prop to be an array of items.', _key, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
        selectors[_key] = getSelector(operationVariables, fragment, item);
      }
    }
  }
  return selectors;
}

/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts a mapping of keys -> id(s) of the results.
 *
 * Similar to `getSelectorsFromObject()`, this function can be useful in
 * determining the "identity" of the props passed to a component.
 */
function getDataIDsFromObject(fragments, object) {
  var ids = {};
  for (var _key2 in fragments) {
    if (fragments.hasOwnProperty(_key2)) {
      var fragment = fragments[_key2];
      var item = object[_key2];
      if (item == null) {
        ids[_key2] = item;
      } else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernSelector: Expected value for key `%s` to be an array, got `%s`. ' + 'Remove `@relay(plural: true)` from fragment `%s` to allow the prop to be an object.', _key2, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
        ids[_key2] = getDataIDs(fragment, item);
      } else {
        !!Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernFragmentSpecResolver: Expected value for key `%s` to be an object, got `%s`. ' + 'Add `@relay(plural: true)` to fragment `%s` to allow the prop to be an array of items.', _key2, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
        ids[_key2] = getDataID(fragment, item);
      }
    }
  }
  return ids;
}

/**
 * @internal
 */
function getDataIDs(fragment, items) {
  var ids = void 0;
  items.forEach(function (item) {
    var id = item != null ? getDataID(fragment, item) : null;
    if (id != null) {
      ids = ids || [];
      ids.push(id);
    }
  });
  return ids || null;
}

/**
 * @internal
 */
function getDataID(fragment, item) {
  !((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && !Array.isArray(item)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernSelector: Expected value for fragment `%s` to be an object, got ' + '`%s`.', fragment.name, JSON.stringify(item)) : __webpack_require__(10)(false) : void 0;
  var dataID = item[__webpack_require__(12).ID_KEY];
  if (typeof dataID === 'string') {
    return dataID;
  }
   false ? require('fbjs/lib/warning')(false, 'RelayModernSelector: Expected object to contain data for fragment `%s`, got ' + '`%s`. Make sure that the parent operation/fragment included fragment ' + '`...%s` without `@relay(mask: false)`.', fragment.name, JSON.stringify(item), fragment.name) : void 0;
  return null;
}

/**
 * @public
 *
 * Given a mapping of keys -> results and a mapping of keys -> fragments,
 * extracts the merged variables that would be in scope for those
 * fragments/results.
 *
 * This can be useful in determing what varaibles were used to fetch the data
 * for a Relay container, for example.
 */
function getVariablesFromObject(operationVariables, fragments, object) {
  var variables = {};
  for (var _key3 in fragments) {
    if (fragments.hasOwnProperty(_key3)) {
      var _ret = function () {
        var fragment = fragments[_key3];
        var item = object[_key3];
        if (item == null) {
          return 'continue';
        } else if (fragment.metadata && fragment.metadata.plural === true) {
          !Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernSelector: Expected value for key `%s` to be an array, got `%s`. ' + 'Remove `@relay(plural: true)` from fragment `%s` to allow the prop to be an object.', _key3, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
          item.forEach(function (value) {
            if (value != null) {
              var itemVariables = getVariables(operationVariables, fragment, value);
              if (itemVariables) {
                Object.assign(variables, itemVariables);
              }
            }
          });
        } else {
          !!Array.isArray(item) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernFragmentSpecResolver: Expected value for key `%s` to be an object, got `%s`. ' + 'Add `@relay(plural: true)` to fragment `%s` to allow the prop to be an array of items.', _key3, JSON.stringify(item), fragment.name) : __webpack_require__(10)(false) : void 0;
          var itemVariables = getVariables(operationVariables, fragment, item);
          if (itemVariables) {
            Object.assign(variables, itemVariables);
          }
        }
      }();

      if (_ret === 'continue') continue;
    }
  }
  return variables;
}

/**
 * @internal
 */
function getVariables(operationVariables, fragment, item) {
  var selector = getSelector(operationVariables, fragment, item);
  return selector ? selector.variables : null;
}

/**
 * @public
 *
 * Determine if two selectors are equal (represent the same selection). Note
 * that this function returns `false` when the two queries/fragments are
 * different objects, even if they select the same fields.
 */
function areEqualSelectors(thisSelector, thatSelector) {
  return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && __webpack_require__(251)(thisSelector.variables, thatSelector.variables);
}

module.exports = {
  areEqualSelectors: areEqualSelectors,
  getDataIDsFromObject: getDataIDsFromObject,
  getSelector: getSelector,
  getSelectorList: getSelectorList,
  getSelectorsFromObject: getSelectorsFromObject,
  getVariablesFromObject: getVariablesFromObject
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(125);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(124)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(308);
var defined = __webpack_require__(216);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
}; /* eslint no-fallthrough: off */

var _dateArithmetic = __webpack_require__(1838);

var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24
};

var MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

var dates = _extends({}, _dateArithmetic2.default, {
  monthsInYear: function monthsInYear(year) {
    var date = new Date(year, 0, 1);

    return MONTHS.map(function (i) {
      return dates.month(date, i);
    });
  },
  firstVisibleDay: function firstVisibleDay(date, culture) {
    var firstOfMonth = dates.startOf(date, 'month');

    return dates.startOf(firstOfMonth, 'week', _localizer2.default.startOfWeek(culture));
  },
  lastVisibleDay: function lastVisibleDay(date, culture) {
    var endOfMonth = dates.endOf(date, 'month');

    return dates.endOf(endOfMonth, 'week', _localizer2.default.startOfWeek(culture));
  },
  visibleDays: function visibleDays(date, culture) {
    var current = dates.firstVisibleDay(date, culture),
        last = dates.lastVisibleDay(date, culture),
        days = [];

    while (dates.lte(current, last, 'day')) {
      days.push(current);
      current = dates.add(current, 1, 'day');
    }

    return days;
  },
  ceil: function ceil(date, unit) {
    var floor = dates.startOf(date, unit);

    return dates.eq(floor, date) ? floor : dates.add(floor, 1, unit);
  },
  range: function range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';

    var current = start,
        days = [];

    while (dates.lte(current, end, unit)) {
      days.push(current);
      current = dates.add(current, 1, unit);
    }

    return days;
  },
  merge: function merge(date, time) {
    if (time == null && date == null) return null;

    if (time == null) time = new Date();
    if (date == null) date = new Date();

    date = dates.startOf(date, 'day');
    date = dates.hours(date, dates.hours(time));
    date = dates.minutes(date, dates.minutes(time));
    date = dates.seconds(date, dates.seconds(time));
    return dates.milliseconds(date, dates.milliseconds(time));
  },
  eqTime: function eqTime(dateA, dateB) {
    return dates.hours(dateA) === dates.hours(dateB) && dates.minutes(dateA) === dates.minutes(dateB) && dates.seconds(dateA) === dates.seconds(dateB);
  },
  isJustDate: function isJustDate(date) {
    return dates.hours(date) === 0 && dates.minutes(date) === 0 && dates.seconds(date) === 0 && dates.milliseconds(date) === 0;
  },
  duration: function duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(dates[unit](start, undefined, firstOfWeek) - dates[unit](end, undefined, firstOfWeek));
  },
  diff: function diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);

    // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+dates.startOf(dateA, unit) / MILLI[unit] - +dates.startOf(dateB, unit) / MILLI[unit]));
  },
  total: function total(date, unit) {
    var ms = date.getTime(),
        div = 1;

    switch (unit) {
      case 'week':
        div *= 7;
      case 'day':
        div *= 24;
      case 'hours':
        div *= 60;
      case 'minutes':
        div *= 60;
      case 'seconds':
        div *= 1000;
    }

    return ms / div;
  },
  week: function week(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
  },
  today: function today() {
    return dates.startOf(new Date(), 'day');
  },
  yesterday: function yesterday() {
    return dates.add(dates.startOf(new Date(), 'day'), -1, 'day');
  },
  tomorrow: function tomorrow() {
    return dates.add(dates.startOf(new Date(), 'day'), 1, 'day');
  }
});

exports.default = dates;
module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });



/***/ }),
/* 91 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(53);
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */
var AbstractComponent = function (_super) {
    tslib_1.__extends(AbstractComponent, _super);
    function AbstractComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        /**
         * Clear all known timeouts.
         */
        _this.clearTimeouts = function () {
            if (_this.timeoutIds.length > 0) {
                for (var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++) {
                    var timeoutId = _a[_i];
                    clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        if (!utils_1.isNodeEnv("production")) {
            _this.validateProps(_this.props);
        }
        return _this;
    }
    AbstractComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (!utils_1.isNodeEnv("production")) {
            this.validateProps(nextProps);
        }
    };
    AbstractComponent.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
    };
    /**
     * Set a timeout and remember its ID.
     * All stored timeouts will be cleared when component unmounts.
     * @returns a "cancel" function that will clear timeout when invoked.
     */
    AbstractComponent.prototype.setTimeout = function (callback, timeout) {
        var handle = setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function () {
            return clearTimeout(handle);
        };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * In contrast to propTypes, these runtime checks are _always_ run, not just in development mode.
     */
    AbstractComponent.prototype.validateProps = function (_) {
        // implement in subclass
    };
    ;
    return AbstractComponent;
}(React.Component);
exports.AbstractComponent = AbstractComponent;

//# sourceMappingURL=abstractComponent.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var ns = "[Blueprint]";
var deprec = ns + " DEPRECATION:";
exports.CLAMP_MIN_MAX = ns + " clamp: max cannot be less than min";
exports.ALERT_WARN_CANCEL_PROPS = ns + " <Alert> cancelButtonText and onCancel should be set together.";
exports.COLLAPSIBLE_LIST_INVALID_CHILD = ns + " <CollapsibleList> children must be <MenuItem>s";
exports.CONTEXTMENU_WARN_DECORATOR_NO_METHOD = ns + " @ContextMenuTarget-decorated class should implement renderContextMenu.";
exports.HOTKEYS_HOTKEY_CHILDREN = ns + " <Hotkeys> only accepts <Hotkey> children.";
exports.MENU_WARN_CHILDREN_SUBMENU_MUTEX = ns + " <MenuItem> children and submenu props are mutually exclusive, with children taking priority.";
exports.NUMERIC_INPUT_MIN_MAX = ns + " <NumericInput> requires min to be strictly less than max if both are defined.";
exports.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires minorStepSize to be strictly less than stepSize.";
exports.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND = ns + " <NumericInput> requires majorStepSize to be strictly greater than stepSize.";
exports.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires minorStepSize to be strictly greater than zero.";
exports.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires majorStepSize to be strictly greater than zero.";
exports.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE = ns + " <NumericInput> requires stepSize to be strictly greater than zero.";
exports.NUMERIC_INPUT_STEP_SIZE_NULL = ns + " <NumericInput> requires stepSize to be defined.";
exports.POPOVER_REQUIRES_TARGET = ns + " <Popover> requires target prop or at least one child element.";
exports.POPOVER_MODAL_INTERACTION = ns + " <Popover isModal={true}> requires interactionKind={PopoverInteractionKind.CLICK}.";
exports.POPOVER_WARN_TOO_MANY_CHILDREN = ns + " <Popover> supports one or two children; additional children are ignored." + " First child is the target, second child is the content. You may instead supply these two as props.";
exports.POPOVER_WARN_DOUBLE_CONTENT = ns + " <Popover> with two children ignores content prop; use either prop or children.";
exports.POPOVER_WARN_DOUBLE_TARGET = ns + " <Popover> with children ignores target prop; use either prop or children.";
exports.POPOVER_WARN_EMPTY_CONTENT = ns + " Disabling <Popover> with empty/whitespace content...";
exports.POPOVER_WARN_MODAL_INLINE = ns + " <Popover inline={true}> ignores isModal";
exports.POPOVER_WARN_DEPRECATED_CONSTRAINTS = deprec + " <Popover> constraints and useSmartPositioning are deprecated. Use tetherOptions directly.";
exports.POPOVER_WARN_INLINE_NO_TETHER = ns + " <Popover inline={true}> ignores tetherOptions, constraints, and useSmartPositioning.";
exports.POPOVER_WARN_UNCONTROLLED_ONINTERACTION = ns + " <Popover> onInteraction is ignored when uncontrolled.";
exports.PORTAL_CONTEXT_CLASS_NAME_STRING = ns + " <Portal> context blueprintPortalClassName must be string";
exports.RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX = ns + " <RadioGroup> children and options prop are mutually exclusive, with options taking priority.";
exports.SLIDER_ZERO_STEP = ns + " <Slider> stepSize must be greater than zero.";
exports.SLIDER_ZERO_LABEL_STEP = ns + " <Slider> labelStepSize must be greater than zero.";
exports.RANGESLIDER_NULL_VALUE = ns + " <RangeSlider> value prop must be an array of two non-null numbers.";
exports.TABS_FIRST_CHILD = ns + " First child of <Tabs> component must be a <TabList>";
exports.TABS_MISMATCH = ns + " Number of <Tab> components must equal number of <TabPanel> components";
exports.TABS_WARN_DEPRECATED = deprec + " <Tabs> is deprecated since v1.11.0; consider upgrading to <Tabs2>." + " https://blueprintjs.com/#components.tabs.js";
exports.TOASTER_WARN_INLINE = ns + " Toaster.create() ignores inline prop as it always creates a new element.";
exports.TOASTER_WARN_LEFT_RIGHT = ns + " Toaster does not support LEFT or RIGHT positions.";
exports.DIALOG_WARN_NO_HEADER_ICON = ns + " <Dialog> iconName is ignored if title is omitted.";
exports.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON = ns + " <Dialog> isCloseButtonShown prop is ignored if title is omitted.";

//# sourceMappingURL=errors.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(593)('wks');
var uid = __webpack_require__(319);
var _Symbol = __webpack_require__(102).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date(),
    t1 = new Date();

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function (date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function (date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function (date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function (start, stop, step) {
    var range = [],
        previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do {
      range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    } while (previous < start && start < stop);
    return range;
  };

  interval.filter = function (test) {
    return newInterval(function (date) {
      if (date >= date) while (floori(date), !test(date)) {
        date.setTime(date - 1);
      }
    }, function (date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function (start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function (step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
        return field(d) % step === 0;
      } : function (d) {
        return interval.count(0, d) % step === 0;
      });
    };
  }

  return interval;
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.set = set;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var localePropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);

function _format(localizer, formatter, value, format, culture) {
  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);

  !(result == null || typeof result === 'string') ?  false ? (0, _invariant2.default)(false, '`localizer format(..)` must return a string, null, or undefined') : (0, _invariant2.default)(false) : void 0;

  return result;
}

var DateLocalizer = function DateLocalizer(spec) {
  var _this = this;

  _classCallCheck(this, DateLocalizer);

  !(typeof spec.format === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `format(..)` must be a function') : (0, _invariant2.default)(false) : void 0;
  !(typeof spec.parse === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `parse(..)` must be a function') : (0, _invariant2.default)(false) : void 0;
  !(typeof spec.firstOfWeek === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `firstOfWeek(..)` must be a function') : (0, _invariant2.default)(false) : void 0;

  this.propType = spec.propType || localePropType;

  this.formats = spec.formats;
  this.startOfWeek = spec.firstOfWeek;

  this.format = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _format.apply(undefined, [_this, spec.format].concat(args));
  };

  this.parse = function (value, format, culture) {
    var result = spec.parse.call(_this, value, format, culture);

    !(result == null || result instanceof Date && !isNaN(result.getTime())) ?  false ? (0, _invariant2.default)(false, 'date localizer `parse(..)` must return a valid Date, null, or undefined') : (0, _invariant2.default)(false) : void 0;

    return result;
  };
};

var localizer = {
  parse: error,
  format: error,
  startOfWeek: error
};

function set(newLocalizer) {
  if (!newLocalizer.__isLocalizer__) {
    newLocalizer = new DateLocalizer(newLocalizer);
    newLocalizer.__isLocalizer__ = true;
  }

  localizer = newLocalizer;
  return localizer;
}

var exp = {
  parse: function parse() {
    var _localizer;

    return (_localizer = localizer).parse.apply(_localizer, arguments);
  },
  format: function format() {
    var _localizer2;

    return (_localizer2 = localizer).format.apply(_localizer2, arguments);
  },
  startOfWeek: function startOfWeek() {
    var _localizer3;

    return (_localizer3 = localizer).startOfWeek.apply(_localizer3, arguments);
  }
};

exports.default = exp;

function error() {
  throw new Error('You have not selected a localization strategy for Big Calendar. ' + 'Please use either of the two included.');
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(1408);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* harmony default export */ __webpack_exports__["a"] = (function (ComposedComponent) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(Authenticate, _React$Component);

    function Authenticate() {
      _classCallCheck(this, Authenticate);

      return _possibleConstructorReturn(this, (Authenticate.__proto__ || Object.getPrototypeOf(Authenticate)).apply(this, arguments));
    }

    _createClass(Authenticate, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.props.viewer) {
          window.location = '/login';
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.props.viewer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent, this.props) : null
        );
      }
    }]);

    return Authenticate;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }, _temp;
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var createDesc = __webpack_require__(129);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initRange;
/* harmony export (immutable) */ __webpack_exports__["a"] = initInterpolator;
function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);break;
    default:
      this.range(range).domain(domain);break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.interpolator(domain);break;
    default:
      this.interpolator(interpolator).domain(domain);break;
  }
  return this;
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(1031);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getLocalDateFromString: function getLocalDateFromString(date) {
    if (date) {
      // Check if value is date only or date + time
      if (date.length === 10) {
        var momentDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date);
        return momentDate.add(new Date().getTimezoneOffset(), 'minutes').toDate();
      }
      return new Date(date);
    }
    return null;
  },
  isoStringToMoment: function isoStringToMoment(date, allDay) {
    var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.guess();

    if (allDay) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date);
    }
    return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).tz(timeZone);
  },
  dateToISOString: function dateToISOString(date, allDay) {
    var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.guess();

    if (allDay) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).format('YYYY-MM-DD');
    }
    return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz(date, timeZone).toISOString();
  },
  omitTimeZoneWithoutTimes: function omitTimeZoneWithoutTimes(eventSegment) {
    if (!(eventSegment.start_at && eventSegment.end_at)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(eventSegment, 'time_zone');
    }
    return eventSegment;
  }
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3590);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-2!./globals.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-2!./globals.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1568);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(312);
var enumBugKeys = __webpack_require__(217);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 110 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var asap = __webpack_require__(305);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (_typeof(this) !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function (onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function () {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(self, new TypeError('A promise cannot be resolved with itself.'));
  }
  if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (then === self.then && newValue instanceof Promise) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

/* harmony default export */ __webpack_exports__["a"] = (function (resultFn) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;

  var lastThis = void 0;
  var lastArgs = [];
  var lastResult = void 0;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    lastResult = resultFn.apply(this, newArgs);
    return lastResult;
  };

  return result;
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.views = exports.dateRangeFormat = exports.dateFormat = exports.accessor = exports.eventComponent = exports.elementType = undefined;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _elementType = __webpack_require__(2358);

var _elementType2 = _interopRequireDefault(_elementType);

var _all = __webpack_require__(2357);

var _all2 = _interopRequireDefault(_all);

var _constants = __webpack_require__(153);

var _createChainableTypeChecker = __webpack_require__(699);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.elementType = _elementType2.default;

// export contextShape = React.PropTypes.shape({
//   formats: React.PropTypes.object.isRequired,
//   messages: React.PropTypes.object.isRequired,
//   accessors: React.PropTypes.shape({
//     titleAccessor: accessor,
//     startAccessor: accessor,
//     endAccessor: accessor,
//     allDayAccessor: accessor,
//   }).isRequired,
// }).isRequired,

var eventComponent = exports.eventComponent = _propTypes2.default.oneOfType([_elementType2.default, _propTypes2.default.shape({
  month: _elementType2.default,
  week: _elementType2.default,
  day: _elementType2.default,
  agenda: _elementType2.default
})]);

var viewNames = Object.keys(_constants.views).map(function (k) {
  return _constants.views[k];
});

var accessor = exports.accessor = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);

var dateFormat = exports.dateFormat = (0, _createChainableTypeChecker2.default)(function () {
  return _localizer2.default.propType && _localizer2.default.propType.apply(_localizer2.default, arguments);
});

var dateRangeFormat = exports.dateRangeFormat = _propTypes2.default.func;

/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */
var views = exports.views = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.oneOf(viewNames)), (0, _all2.default)(_propTypes2.default.object, function (props, name) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var prop = props[name],
      err = void 0;

  Object.keys(prop).every(function (key) {
    var isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';

    return isBuiltinView || !(err = _elementType2.default.apply(undefined, [prop, key].concat(args)));
  });

  return err || null;
})]);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Simple function for formatting strings.
 *
 * Replaces placeholders with values passed as extra arguments
 *
 * @param {string} format the base string
 * @param ...args the values to insert
 * @return {string} the replaced string
 */

function sprintf(format) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var index = 0;
  return format.replace(/%s/g, function (match) {
    return args[index++];
  });
}

module.exports = sprintf;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * An implementation of the `MutableRecordSource` interface (defined in
 * `RelayStoreTypes`) that holds all records in memory.
 */
var RelayInMemoryRecordSource = function () {
  function RelayInMemoryRecordSource(records) {
    (0, _classCallCheck3['default'])(this, RelayInMemoryRecordSource);

    this._records = records || {};
  }

  RelayInMemoryRecordSource.prototype.clear = function clear() {
    this._records = {};
  };

  RelayInMemoryRecordSource.prototype['delete'] = function _delete(dataID) {
    this._records[dataID] = null;
  };

  RelayInMemoryRecordSource.prototype.get = function get(dataID) {
    return this._records[dataID];
  };

  RelayInMemoryRecordSource.prototype.getRecordIDs = function getRecordIDs() {
    return Object.keys(this._records);
  };

  RelayInMemoryRecordSource.prototype.getStatus = function getStatus(dataID) {
    if (!this._records.hasOwnProperty(dataID)) {
      return __webpack_require__(49).UNKNOWN;
    }
    return this._records[dataID] == null ? __webpack_require__(49).NONEXISTENT : __webpack_require__(49).EXISTENT;
  };

  RelayInMemoryRecordSource.prototype.has = function has(dataID) {
    return this._records.hasOwnProperty(dataID);
  };

  RelayInMemoryRecordSource.prototype.load = function load(dataID, callback) {
    callback(null, this.get(dataID));
  };

  RelayInMemoryRecordSource.prototype.remove = function remove(dataID) {
    delete this._records[dataID];
  };

  RelayInMemoryRecordSource.prototype.set = function set(dataID, record) {
    this._records[dataID] = record;
  };

  RelayInMemoryRecordSource.prototype.size = function size() {
    return Object.keys(this._records).length;
  };

  RelayInMemoryRecordSource.prototype.toJSON = function toJSON() {
    return this._records;
  };

  return RelayInMemoryRecordSource;
}();

module.exports = RelayInMemoryRecordSource;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Runtime function to correspond to the `graphql` tagged template function.
 * All calls to this function should be transformed by the plugin.
 */

// The type of a graphql`...` tagged template expression.

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function graphql(strings) {
   true ?  false ? require('fbjs/lib/invariant')(false, 'graphql: Unexpected invocation at runtime. Either the Babel transform ' + 'was not set up, or it failed to identify this call site. Make sure it ' + 'is being used verbatim as `graphql`.') : __webpack_require__(10)(false) : void 0;
}

function getNode(taggedNode) {
  var fn = typeof taggedNode === 'function' ? taggedNode : taggedNode.modern;
  // Support for classic raw nodes (used in test mock)
  if (typeof fn !== 'function') {
    return taggedNode;
  }
  return fn();
}

function getFragment(taggedNode) {
  var fragment = getNode(taggedNode);
  !((typeof fragment === 'undefined' ? 'undefined' : _typeof(fragment)) === 'object' && fragment !== null && fragment.kind === __webpack_require__(18).FRAGMENT) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernGraphQLTag: Expected a fragment, got `%s`.', JSON.stringify(fragment)) : __webpack_require__(10)(false) : void 0;
  return fragment;
}

function getRequest(taggedNode) {
  var request = getNode(taggedNode);
  !((typeof request === 'undefined' ? 'undefined' : _typeof(request)) === 'object' && request !== null && (request.kind === __webpack_require__(18).REQUEST || request.kind === __webpack_require__(18).BATCH_REQUEST)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernGraphQLTag: Expected a request, got `%s`.', JSON.stringify(request)) : __webpack_require__(10)(false) : void 0;
  return request;
}

module.exports = {
  getFragment: getFragment,
  getRequest: getRequest,
  graphql: graphql
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(2614),
    baseMatchesProperty = __webpack_require__(2615),
    identity = __webpack_require__(155),
    isArray = __webpack_require__(51),
    property = __webpack_require__(2760);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1381),
    baseKeys = __webpack_require__(501),
    isArrayLike = __webpack_require__(142);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3571);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Event.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Event.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3589);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Playlist.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Playlist.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(859);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(544);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(543);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Asserts that the input is a matches the `RelayContext` type defined in
 * `RelayEnvironmentTypes` and returns it as that type.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function assertRelayContext(relay) {
  !isRelayContext(relay) ?  false ? require('fbjs/lib/invariant')(false, 'RelayContext: Expected `context.relay` to be an object conforming to ' + 'the `RelayContext` interface, got `%s`.', relay) : __webpack_require__(3)(false) : void 0;
  return relay;
}

/**
 * Determine if the input is a plain object that matches the `RelayContext`
 * type defined in `RelayEnvironmentTypes`.
 */
function isRelayContext(context) {
  return (typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object' && context !== null && !Array.isArray(context) && __webpack_require__(351)(context.environment) && __webpack_require__(475)(context.variables);
}

module.exports = {
  assertRelayContext: assertRelayContext,
  isRelayContext: isRelayContext
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ref__ = __webpack_require__(2493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Ref__["a"]; });



/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var core = __webpack_require__(148);
var hide = __webpack_require__(228);
var redefine = __webpack_require__(230);
var ctx = __webpack_require__(272);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* v0.11.1 */
var DEFAULT_CNAME = "filestackapi.com";var PICKER_VERSION = "0.12.5";var envGetter = function envGetter(cname) {
  return { picker: "https://static." + (cname || DEFAULT_CNAME) + "/picker/v3/picker-" + PICKER_VERSION + ".js" };
};var ENV = { storeApiUrl: "https://www.filestackapi.com/api/store", fileApiUrl: "https://www.filestackapi.com/api/file", uploadApiUrl: "https://upload.filestackapi.com", cloudApiUrl: "https://cloud.filestackapi.com", processApiUrl: "https://process.filestackapi.com", previewApiUrl: "https://cdn.filestackcontent.com" };var isFunction = function isFunction(x) {
  return typeof x === "function";
};var isNil = function isNil(x) {
  return x === null || x === void 0;
};var fail = function fail(message) {
  throw new TypeError("[tcomb] " + message);
};var getFunctionName = function getFunctionName(f) {
  return f.displayName || f.name || "<function" + f.length + ">";
};function replacer(key, value) {
  if (typeof value === "function") {
    return getFunctionName(value);
  }return value;
}var stringify$1 = function stringify(x) {
  try {
    return JSON.stringify(x, replacer, 2);
  } catch (e) {
    return String(x);
  }
};function assert(guard, message) {
  if (guard !== true) {
    if (isFunction(message)) {
      message = message();
    } else if (isNil(message)) {
      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
    }assert.fail(message);
  }
}assert.fail = fail;assert.stringify = stringify$1;var assert_1 = assert;var isString = function isString(x) {
  return typeof x === "string";
};var isArray = function isArray(x) {
  return Array.isArray ? Array.isArray(x) : x instanceof Array;
};var isObject = function isObject(x) {
  return !isNil(x) && (typeof x === "undefined" ? "undefined" : _typeof2(x)) === "object" && !isArray(x);
};var isType = function isType(x) {
  return isFunction(x) && isObject(x.meta);
};var getTypeName = function getTypeName(ctor) {
  if (isType(ctor)) {
    return ctor.displayName;
  }return getFunctionName(ctor);
};var irreducible = function irreducible(name, predicate) {
  function Irreducible(value, path) {
    return value;
  }Irreducible.meta = { kind: "irreducible", name: name, predicate: predicate, identity: true };Irreducible.displayName = name;Irreducible.is = predicate;return Irreducible;
};var Any = irreducible("Any", function () {
  return true;
});var _Array = irreducible("Array", isArray);var isBoolean = function isBoolean(x) {
  return x === true || x === false;
};var _Boolean = irreducible("Boolean", isBoolean);var _Date = irreducible("Date", function (x) {
  return x instanceof Date;
});var _Error = irreducible("Error", function (x) {
  return x instanceof Error;
});var _Function = irreducible("Function", isFunction);var Nil = irreducible("Nil", isNil);var isNumber = function isNumber(x) {
  return typeof x === "number" && isFinite(x) && !isNaN(x);
};var _Number = irreducible("Number", isNumber);var isIdentity = function isIdentity(type) {
  if (isType(type)) {
    return type.meta.identity;
  }return true;
};var create = function create(type, value, path) {
  if (isType(type)) {
    return !type.meta.identity && (typeof value === "undefined" ? "undefined" : _typeof2(value)) === "object" && value !== null ? new type(value, path) : type(value, path);
  }return value;
};var is = function is(x, type) {
  if (isType(type)) {
    return type.is(x);
  }return x instanceof type;
};function getDefaultName(type, predicate) {
  return "{" + getTypeName(type) + " | " + getFunctionName(predicate) + "}";
}function refinement(type, predicate, name) {
  var displayName = name || getDefaultName(type, predicate);var identity = isIdentity(type);function Refinement(value, path) {
    var x = create(type, value, path);return x;
  }Refinement.meta = { kind: "subtype", type: type, predicate: predicate, name: name, identity: identity };Refinement.displayName = displayName;Refinement.is = function (x) {
    return is(x, type) && predicate(x);
  };Refinement.update = function (instance, patch) {
    return Refinement(assert_1.update(instance, patch));
  };return Refinement;
}refinement.getDefaultName = getDefaultName;var refinement_1 = refinement;var Integer = refinement_1(_Number, function (x) {
  return x % 1 === 0;
}, "Integer");var _Object = irreducible("Object", isObject);var _RegExp = irreducible("RegExp", function (x) {
  return x instanceof RegExp;
});var _String = irreducible("String", isString);var Type = irreducible("Type", isType);function getDefaultName$1(domain, codomain) {
  return "{[key: " + getTypeName(domain) + "]: " + getTypeName(codomain) + "}";
}function dict(domain, codomain, name) {
  var displayName = name || getDefaultName$1(domain, codomain);var domainNameCache = getTypeName(domain);var codomainNameCache = getTypeName(codomain);var identity = isIdentity(domain) && isIdentity(codomain);function Dict(value, path) {
    {
      if (identity) {
        return value;
      }
    }var idempotent = true;var ret = {};for (var k in value) {
      if (value.hasOwnProperty(k)) {
        k = create(domain, k, null);var actual = value[k];var instance = create(codomain, actual, null);idempotent = idempotent && actual === instance;ret[k] = instance;
      }
    }if (idempotent) {
      ret = value;
    }return ret;
  }Dict.meta = { kind: "dict", domain: domain, codomain: codomain, name: name, identity: identity };Dict.displayName = displayName;Dict.is = function (x) {
    if (!isObject(x)) {
      return false;
    }for (var k in x) {
      if (x.hasOwnProperty(k)) {
        if (!is(k, domain) || !is(x[k], codomain)) {
          return false;
        }
      }
    }return true;
  };Dict.update = function (instance, patch) {
    return Dict(assert_1.update(instance, patch));
  };return Dict;
}dict.getDefaultName = getDefaultName$1;var dict_1 = dict;var mixin = function mixin(target, source, overwrite) {
  if (isNil(source)) {
    return target;
  }for (var k in source) {
    if (source.hasOwnProperty(k)) {
      if (overwrite !== true) {}target[k] = source[k];
    }
  }return target;
};var isUnion = function isUnion(x) {
  return isType(x) && x.meta.kind === "union";
};var nextDeclareUniqueId = 1;var declare = function declare(name) {
  var type;function Declare(value, path) {
    return type(value, path);
  }Declare.define = function (spec) {
    if (isUnion(spec) && Declare.hasOwnProperty("dispatch")) {
      spec.dispatch = Declare.dispatch;
    }type = spec;mixin(Declare, type, true);if (name) {
      type.displayName = Declare.displayName = name;Declare.meta.name = name;
    }Declare.meta.identity = type.meta.identity;Declare.prototype = type.prototype;return Declare;
  };Declare.displayName = name || getTypeName(Declare) + "$" + nextDeclareUniqueId++;Declare.meta = { identity: false };Declare.prototype = null;return Declare;
};function getDefaultName$2(map) {
  return Object.keys(map).map(function (k) {
    return assert_1.stringify(k);
  }).join(" | ");
}function enums(map, name) {
  var displayName = name || getDefaultName$2(map);function Enums(value, path) {
    return value;
  }Enums.meta = { kind: "enums", map: map, name: name, identity: true };Enums.displayName = displayName;Enums.is = function (x) {
    return map.hasOwnProperty(x);
  };return Enums;
}enums.of = function (keys, name) {
  keys = isString(keys) ? keys.split(" ") : keys;var value = {};keys.forEach(function (k) {
    value[k] = k;
  });return enums(value, name);
};enums.getDefaultName = getDefaultName$2;var enums_1 = enums;function getDefaultName$3(type) {
  return "Array<" + getTypeName(type) + ">";
}function list(type, name) {
  var displayName = name || getDefaultName$3(type);var typeNameCache = getTypeName(type);var identity = isIdentity(type);function List(value, path) {
    {
      if (identity) {
        return value;
      }
    }var idempotent = true;var ret = [];for (var i = 0, len = value.length; i < len; i++) {
      var actual = value[i];var instance = create(type, actual, null);idempotent = idempotent && actual === instance;ret.push(instance);
    }if (idempotent) {
      ret = value;
    }return ret;
  }List.meta = { kind: "list", type: type, name: name, identity: identity };List.displayName = displayName;List.is = function (x) {
    return isArray(x) && x.every(function (e) {
      return is(e, type);
    });
  };List.update = function (instance, patch) {
    return List(assert_1.update(instance, patch));
  };return List;
}list.getDefaultName = getDefaultName$3;var list_1 = list;var isMaybe = function isMaybe(x) {
  return isType(x) && x.meta.kind === "maybe";
};function getDefaultName$4(type) {
  return "?" + getTypeName(type);
}function maybe(type, name) {
  if (isMaybe(type) || type === Any || type === Nil) {
    return type;
  }var displayName = name || getDefaultName$4(type);var identity = isIdentity(type);function Maybe(value, path) {
    return Nil.is(value) ? value : create(type, value, path);
  }Maybe.meta = { kind: "maybe", type: type, name: name, identity: identity };Maybe.displayName = displayName;Maybe.is = function (x) {
    return Nil.is(x) || is(x, type);
  };return Maybe;
}maybe.getDefaultName = getDefaultName$4;var maybe_1 = maybe;function getDefaultInterfaceName(props) {
  return "{" + Object.keys(props).map(function (prop) {
    return prop + ": " + getTypeName(props[prop]);
  }).join(", ") + "}";
}var getDefaultInterfaceName_1 = getDefaultInterfaceName;function isRefinement(type) {
  return isType(type) && type.meta.kind === "subtype";
}function getPredicates(type) {
  return isRefinement(type) ? [type.meta.predicate].concat(getPredicates(type.meta.type)) : [];
}function getUnrefinedType(type) {
  return isRefinement(type) ? getUnrefinedType(type.meta.type) : type;
}function decompose(type) {
  return { predicates: getPredicates(type), unrefinedType: getUnrefinedType(type) };
}var decompose_1 = decompose;function compose(predicates, unrefinedType) {
  return predicates.reduce(function (type, predicate) {
    return refinement_1(type, predicate);
  }, unrefinedType);
}function getProps(type) {
  return isObject(type) ? type : type.meta.props;
}function getDefaultProps(type) {
  return isObject(type) ? null : type.meta.defaultProps;
}function pushAll(arr, elements) {
  Array.prototype.push.apply(arr, elements);
}function extend(combinator, mixins, options) {
  var props = {};var prototype = {};var predicates = [];var defaultProps = {};mixins.forEach(function (x, i) {
    var decomposition = decompose_1(x);var unrefinedType = decomposition.unrefinedType;pushAll(predicates, decomposition.predicates);mixin(props, getProps(unrefinedType));mixin(prototype, unrefinedType.prototype);mixin(defaultProps, getDefaultProps(unrefinedType), true);
  });options = combinator.getOptions(options);options.defaultProps = mixin(defaultProps, options.defaultProps, true);var result = compose(predicates, combinator(props, options));mixin(result.prototype, prototype);return result;
}var extend_1 = extend;function getDefaultName$5(props) {
  return "Struct" + getDefaultInterfaceName_1(props);
}function extendStruct(mixins, name) {
  return extend_1(struct, mixins, name);
}function getOptions(options) {
  if (!isObject(options)) {
    options = isNil(options) ? {} : { name: options };
  }if (!options.hasOwnProperty("strict")) {
    options.strict = struct.strict;
  }if (!options.hasOwnProperty("defaultProps")) {
    options.defaultProps = {};
  }return options;
}function struct(props, options) {
  options = getOptions(options);var name = options.name;var strict = options.strict;var defaultProps = options.defaultProps;var displayName = name || getDefaultName$5(props);function Struct(value, path) {
    if (Struct.is(value)) {
      return value;
    }if (!(this instanceof Struct)) {
      return new Struct(value, path);
    }for (var k in props) {
      if (props.hasOwnProperty(k)) {
        var expected = props[k];var actual = value[k];if (actual === undefined) {
          actual = defaultProps[k];
        }this[k] = create(expected, actual, null);
      }
    }
  }Struct.meta = { kind: "struct", props: props, name: name, identity: false, strict: strict, defaultProps: defaultProps };Struct.displayName = displayName;Struct.is = function (x) {
    return x instanceof Struct;
  };Struct.update = function (instance, patch) {
    return new Struct(assert_1.update(instance, patch));
  };Struct.extend = function (xs, name) {
    return extendStruct([Struct].concat(xs), name);
  };return Struct;
}struct.strict = false;struct.getOptions = getOptions;struct.getDefaultName = getDefaultName$5;struct.extend = extendStruct;var struct_1 = struct;function getDefaultName$6(types) {
  return "[" + types.map(getTypeName).join(", ") + "]";
}function tuple(types, name) {
  var displayName = name || getDefaultName$6(types);var identity = types.every(isIdentity);function Tuple(value, path) {
    {
      if (identity) {
        return value;
      }
    }var idempotent = true;var ret = [];for (var i = 0, len = types.length; i < len; i++) {
      var expected = types[i];var actual = value[i];var instance = create(expected, actual, null);idempotent = idempotent && actual === instance;ret.push(instance);
    }if (idempotent) {
      ret = value;
    }return ret;
  }Tuple.meta = { kind: "tuple", types: types, name: name, identity: identity };Tuple.displayName = displayName;Tuple.is = function (x) {
    return isArray(x) && x.length === types.length && types.every(function (type, i) {
      return is(x[i], type);
    });
  };Tuple.update = function (instance, patch) {
    return Tuple(assert_1.update(instance, patch));
  };return Tuple;
}tuple.getDefaultName = getDefaultName$6;var tuple_1 = tuple;function getDefaultName$7(types) {
  return types.map(getTypeName).join(" | ");
}function union(types, name) {
  var displayName = name || getDefaultName$7(types);var identity = types.every(isIdentity);function Union(value, path) {
    {
      if (identity) {
        return value;
      }
    }var type = Union.dispatch(value);if (!type && Union.is(value)) {
      return value;
    }return create(type, value, path);
  }Union.meta = { kind: "union", types: types, name: name, identity: identity };Union.displayName = displayName;Union.is = function (x) {
    return types.some(function (type) {
      return is(x, type);
    });
  };Union.dispatch = function (x) {
    for (var i = 0, len = types.length; i < len; i++) {
      var type = types[i];if (isUnion(type)) {
        var t = type.dispatch(x);if (!isNil(t)) {
          return t;
        }
      } else if (is(x, type)) {
        return type;
      }
    }
  };Union.update = function (instance, patch) {
    return Union(assert_1.update(instance, patch));
  };return Union;
}union.getDefaultName = getDefaultName$7;var union_1 = union;function getDefaultName$8(domain, codomain) {
  return "(" + domain.map(getTypeName).join(", ") + ") => " + getTypeName(codomain);
}function isInstrumented(f) {
  return _Function.is(f) && isObject(f.instrumentation);
}function getOptionalArgumentsIndex(types) {
  var end = types.length;var areAllMaybes = false;for (var i = end - 1; i >= 0; i--) {
    var type = types[i];if (!isType(type) || type.meta.kind !== "maybe") {
      return i + 1;
    } else {
      areAllMaybes = true;
    }
  }return areAllMaybes ? 0 : end;
}function func(domain, codomain, name) {
  domain = isArray(domain) ? domain : [domain];var displayName = name || getDefaultName$8(domain, codomain);var domainLength = domain.length;var optionalArgumentsIndex = getOptionalArgumentsIndex(domain);function FuncType(value, path) {
    if (!isInstrumented(value)) {
      return FuncType.of(value);
    }return value;
  }FuncType.meta = { kind: "func", domain: domain, codomain: codomain, name: name, identity: true };FuncType.displayName = displayName;FuncType.is = function (x) {
    return isInstrumented(x) && x.instrumentation.domain.length === domainLength && x.instrumentation.domain.every(function (type, i) {
      return type === domain[i];
    }) && x.instrumentation.codomain === codomain;
  };FuncType.of = function (f, curried) {
    if (FuncType.is(f)) {
      return f;
    }function fn() {
      var args = Array.prototype.slice.call(arguments);var argsLength = args.length;if (curried && argsLength < domainLength) {
        var g = Function.prototype.bind.apply(f, [this].concat(args));var newDomain = func(domain.slice(argsLength), codomain);return newDomain.of(g, true);
      } else {
        return create(codomain, f.apply(this, args));
      }
    }fn.instrumentation = { domain: domain, codomain: codomain, f: f };fn.displayName = getFunctionName(f);return fn;
  };return FuncType;
}func.getDefaultName = getDefaultName$8;func.getOptionalArgumentsIndex = getOptionalArgumentsIndex;var func_1 = func;var isIdentity$3 = isIdentity;function getDefaultName$9(types) {
  return types.map(getTypeName).join(" & ");
}function intersection(types, name) {
  var displayName = name || getDefaultName$9(types);var identity = types.every(isIdentity$3);function Intersection(value, path) {
    return value;
  }Intersection.meta = { kind: "intersection", types: types, name: name, identity: identity };Intersection.displayName = displayName;Intersection.is = function (x) {
    return types.every(function (type) {
      return is(x, type);
    });
  };Intersection.update = function (instance, patch) {
    return Intersection(assert_1.update(instance, patch));
  };return Intersection;
}intersection.getDefaultName = getDefaultName$9;var intersection_1 = intersection;function assign(x, y) {
  for (var k in y) {
    if (y.hasOwnProperty(k)) {
      x[k] = y[k];
    }
  }return x;
}var assign_1 = assign;function extendInterface(mixins, name) {
  return extend_1(inter, mixins, name);
}function getOptions$1(options) {
  if (!isObject(options)) {
    options = isNil(options) ? {} : { name: options };
  }if (!options.hasOwnProperty("strict")) {
    options.strict = inter.strict;
  }return options;
}function inter(props, options) {
  options = getOptions$1(options);var name = options.name;var strict = options.strict;var displayName = name || getDefaultInterfaceName_1(props);var identity = Object.keys(props).map(function (prop) {
    return props[prop];
  }).every(isIdentity);function Interface(value, path) {
    {
      if (identity) {
        return value;
      }
    }var idempotent = true;var ret = identity ? {} : assign_1({}, value);for (var prop in props) {
      var expected = props[prop];var actual = value[prop];var instance = create(expected, actual, null);idempotent = idempotent && actual === instance;ret[prop] = instance;
    }if (idempotent) {
      ret = value;
    }return ret;
  }Interface.meta = { kind: "interface", props: props, name: name, identity: identity, strict: strict };Interface.displayName = displayName;Interface.is = function (x) {
    if (isNil(x)) {
      return false;
    }if (strict) {
      for (var k in x) {
        if (!props.hasOwnProperty(k)) {
          return false;
        }
      }
    }for (var prop in props) {
      if (!is(x[prop], props[prop])) {
        return false;
      }
    }return true;
  };Interface.update = function (instance, patch) {
    return Interface(assert_1.update(instance, patch));
  };Interface.extend = function (xs, name) {
    return extendInterface([Interface].concat(xs), name);
  };return Interface;
}inter.strict = false;inter.getOptions = getOptions$1;inter.getDefaultName = getDefaultInterfaceName_1;inter.extend = extendInterface;var _interface = inter;function getShallowCopy(x) {
  if (isObject(x)) {
    if (x instanceof Date || x instanceof RegExp) {
      return x;
    }return assign_1({}, x);
  }if (isArray(x)) {
    return x.concat();
  }return x;
}function isCommand(k) {
  return update.commands.hasOwnProperty(k);
}function getCommand(k) {
  return update.commands[k];
}function update(instance, patch) {
  var value = instance;var isChanged = false;var newValue;for (var k in patch) {
    if (patch.hasOwnProperty(k)) {
      if (isCommand(k)) {
        newValue = getCommand(k)(patch[k], value);if (newValue !== instance) {
          isChanged = true;value = newValue;
        } else {
          value = instance;
        }
      } else {
        if (value === instance) {
          value = getShallowCopy(instance);
        }newValue = update(value[k], patch[k]);isChanged = isChanged || newValue !== value[k];value[k] = newValue;
      }
    }
  }return isChanged ? value : instance;
}function $apply(f, value) {
  return f(value);
}function $push(elements, arr) {
  if (elements.length > 0) {
    return arr.concat(elements);
  }return arr;
}function $remove(keys, obj) {
  if (keys.length > 0) {
    obj = getShallowCopy(obj);for (var i = 0, len = keys.length; i < len; i++) {
      delete obj[keys[i]];
    }
  }return obj;
}function $set(value) {
  return value;
}function $splice(splices, arr) {
  if (splices.length > 0) {
    arr = getShallowCopy(arr);return splices.reduce(function (acc, splice) {
      acc.splice.apply(acc, splice);return acc;
    }, arr);
  }return arr;
}function $swap(config, arr) {
  if (config.from !== config.to) {
    arr = getShallowCopy(arr);var element = arr[config.to];arr[config.to] = arr[config.from];arr[config.from] = element;
  }return arr;
}function $unshift(elements, arr) {
  if (elements.length > 0) {
    return elements.concat(arr);
  }return arr;
}function $merge(whatToMerge, value) {
  var isChanged = false;var result = getShallowCopy(value);for (var k in whatToMerge) {
    if (whatToMerge.hasOwnProperty(k)) {
      result[k] = whatToMerge[k];isChanged = isChanged || result[k] !== value[k];
    }
  }return isChanged ? result : value;
}update.commands = { $apply: $apply, $push: $push, $remove: $remove, $set: $set, $splice: $splice, $swap: $swap, $unshift: $unshift, $merge: $merge };var update_1 = update;var match = function match(x) {
  var type, guard, f, count;for (var i = 1, len = arguments.length; i < len;) {
    type = arguments[i];guard = arguments[i + 1];f = arguments[i + 2];if (isFunction(f) && !isType(f)) {
      i = i + 3;
    } else {
      f = guard;guard = Any.is;i = i + 2;
    }if (type.is(x) && guard(x)) {
      return f(x);
    }
  }assert_1.fail("Match error");
};assert_1.Any = Any;assert_1.Array = _Array;assert_1.Boolean = _Boolean;assert_1.Date = _Date;assert_1.Error = _Error;assert_1.Function = _Function;assert_1.Nil = Nil;assert_1.Number = _Number;assert_1.Integer = Integer;assert_1.IntegerT = assert_1.Integer;assert_1.Object = _Object;assert_1.RegExp = _RegExp;assert_1.String = _String;assert_1.Type = Type;assert_1.TypeT = assert_1.Type;assert_1.Arr = assert_1.Array;assert_1.Bool = assert_1.Boolean;assert_1.Dat = assert_1.Date;assert_1.Err = assert_1.Error;assert_1.Func = assert_1.Function;assert_1.Num = assert_1.Number;assert_1.Obj = assert_1.Object;assert_1.Re = assert_1.RegExp;assert_1.Str = assert_1.String;assert_1.dict = dict_1;assert_1.declare = declare;assert_1.enums = enums_1;assert_1.irreducible = irreducible;assert_1.list = list_1;assert_1.maybe = maybe_1;assert_1.refinement = refinement_1;assert_1.struct = struct_1;assert_1.tuple = tuple_1;assert_1.union = union_1;assert_1.func = func_1;assert_1.intersection = intersection_1;assert_1.subtype = assert_1.refinement;assert_1.inter = _interface;assert_1["interface"] = assert_1.inter;assert_1.assert = assert_1;assert_1.update = update_1;assert_1.mixin = mixin;assert_1.isType = isType;assert_1.is = is;assert_1.getTypeName = getTypeName;assert_1.match = match;var index$1 = assert_1;var stringify = index$1.stringify;var noobj = {};var ValidationError = index$1.struct({ message: index$1.Any, actual: index$1.Any, expected: index$1.Any, path: index$1.list(index$1.union([index$1.String, index$1.Number])) }, "ValidationError");function getDefaultValidationErrorMessage(actual, expected, path) {
  var expectedName = index$1.getTypeName(expected);var to = path.length ? "/" + path.join("/") + ": " + expectedName : expectedName;return "Invalid value " + stringify(actual) + " supplied to " + to;
}function getValidationErrorMessage(actual, expected, path, context) {
  if (index$1.Function.is(expected.getValidationErrorMessage)) {
    return expected.getValidationErrorMessage(actual, path, context);
  } else {
    return getDefaultValidationErrorMessage(actual, expected, path);
  }
}ValidationError.of = function (actual, expected, path, context) {
  return new ValidationError({ message: getValidationErrorMessage(actual, expected, path, context), actual: actual, expected: expected, path: path });
};var ValidationResult = index$1.struct({ errors: index$1.list(ValidationError), value: index$1.Any }, "ValidationResult");ValidationResult.prototype.isValid = function () {
  return !this.errors.length;
};ValidationResult.prototype.firstError = function () {
  return this.isValid() ? null : this.errors[0];
};ValidationResult.prototype.toString = function () {
  if (this.isValid()) {
    return "[ValidationResult, true, " + stringify(this.value) + "]";
  } else {
    return "[ValidationResult, false, (" + this.errors.map(function (err) {
      return stringify(err.message);
    }).join(", ") + ")]";
  }
};function validate(x, type, options) {
  options = options || {};var path = index$1.Array.is(options) ? options : options.path || [];return new ValidationResult(recurse(x, type, path, options));
}function recurse(x, type, path, options) {
  if (index$1.isType(type)) {
    return validators[type.meta.kind](x, type, path, options);
  } else {
    return validators.es6classes(x, type, path, options);
  }
}var validators = validate.validators = {};validators.es6classes = function validateES6Classes(x, type, path, options) {
  return { value: x, errors: x instanceof type ? [] : [ValidationError.of(x, type, path, options.context)] };
};validators.irreducible = validators.enums = function validateIrreducible(x, type, path, options) {
  return { value: x, errors: type.is(x) ? [] : [ValidationError.of(x, type, path, options.context)] };
};validators.list = function validateList(x, type, path, options) {
  if (!index$1.Array.is(x)) {
    return { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
  }var ret = { value: [], errors: [] };for (var i = 0, len = x.length; i < len; i++) {
    var item = recurse(x[i], type.meta.type, path.concat(i), options);ret.value[i] = item.value;ret.errors = ret.errors.concat(item.errors);
  }return ret;
};validators.subtype = function validateSubtype(x, type, path, options) {
  var ret = recurse(x, type.meta.type, path, options);if (ret.errors.length) {
    return ret;
  }if (!type.meta.predicate(ret.value)) {
    ret.errors = [ValidationError.of(x, type, path, options.context)];
  }return ret;
};validators.maybe = function validateMaybe(x, type, path, options) {
  return index$1.Nil.is(x) ? { value: x, errors: [] } : recurse(x, type.meta.type, path, options);
};validators.struct = function validateStruct(x, type, path, options) {
  if (!index$1.Object.is(x)) {
    return { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
  }if (type.is(x)) {
    return { value: x, errors: [] };
  }var ret = { value: {}, errors: [] };var props = type.meta.props;var defaultProps = type.meta.defaultProps || noobj;for (var name in props) {
    if (props.hasOwnProperty(name)) {
      var actual = x[name];if (actual === undefined) {
        actual = defaultProps[name];
      }var prop = recurse(actual, props[name], path.concat(name), options);ret.value[name] = prop.value;ret.errors = ret.errors.concat(prop.errors);
    }
  }var strict = options.hasOwnProperty("strict") ? options.strict : type.meta.strict;if (strict) {
    for (var field in x) {
      if (x.hasOwnProperty(field) && !props.hasOwnProperty(field)) {
        ret.errors.push(ValidationError.of(x[field], index$1.Nil, path.concat(field), options.context));
      }
    }
  }if (!ret.errors.length) {
    ret.value = new type(ret.value);
  }return ret;
};validators.tuple = function validateTuple(x, type, path, options) {
  var types = type.meta.types;var len = types.length;if (!index$1.Array.is(x) || x.length > len) {
    return { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
  }var ret = { value: [], errors: [] };for (var i = 0; i < len; i++) {
    var item = recurse(x[i], types[i], path.concat(i), options);ret.value[i] = item.value;ret.errors = ret.errors.concat(item.errors);
  }return ret;
};validators.dict = function validateDict(x, type, path, options) {
  if (!index$1.Object.is(x)) {
    return { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
  }var ret = { value: {}, errors: [] };for (var k in x) {
    if (x.hasOwnProperty(k)) {
      var subpath = path.concat(k);var key = recurse(k, type.meta.domain, subpath, options);var item = recurse(x[k], type.meta.codomain, subpath, options);ret.value[k] = item.value;ret.errors = ret.errors.concat(key.errors, item.errors);
    }
  }return ret;
};validators.union = function validateUnion(x, type, path, options) {
  var ctor = type.dispatch(x);return index$1.Function.is(ctor) ? recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), options) : { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
};validators.intersection = function validateIntersection(x, type, path, options) {
  var types = type.meta.types;var len = types.length;var ret = { value: x, errors: [] };var nrOfStructs = 0;for (var i = 0; i < len; i++) {
    if (types[i].meta.kind === "struct") {
      nrOfStructs++;
    }var item = recurse(x, types[i], path, options);ret.errors = ret.errors.concat(item.errors);
  }if (nrOfStructs > 1) {
    ret.errors.push(ValidationError.of(x, type, path, options.context));
  }return ret;
};validators["interface"] = function validateInterface(x, type, path, options) {
  if (!index$1.Object.is(x)) {
    return { value: x, errors: [ValidationError.of(x, type, path, options.context)] };
  }var ret = { value: {}, errors: [] };var props = type.meta.props;for (var name in props) {
    var prop = recurse(x[name], props[name], path.concat(name), options);ret.value[name] = prop.value;ret.errors = ret.errors.concat(prop.errors);
  }var strict = options.hasOwnProperty("strict") ? options.strict : type.meta.strict;if (strict) {
    for (var field in x) {
      if (!props.hasOwnProperty(field) && !index$1.Nil.is(x[field])) {
        ret.errors.push(ValidationError.of(x[field], index$1.Nil, path.concat(field), options.context));
      }
    }
  }return ret;
};index$1.mixin(index$1, { ValidationError: ValidationError, ValidationResult: ValidationResult, validate: validate });var index$1$1 = index$1;var commonjsGlobal = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}var index$3 = createCommonjsModule(function (module) {
  {
    module.exports = Emitter;
  }function Emitter(obj) {
    if (obj) return mixin(obj);
  }function mixin(obj) {
    for (var key in Emitter.prototype) {
      obj[key] = Emitter.prototype[key];
    }return obj;
  }Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};(this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);return this;
  };Emitter.prototype.once = function (event, fn) {
    function on() {
      this.off(event, on);fn.apply(this, arguments);
    }on.fn = fn;this.on(event, on);return this;
  };Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};if (0 == arguments.length) {
      this._callbacks = {};return this;
    }var callbacks = this._callbacks["$" + event];if (!callbacks) return this;if (1 == arguments.length) {
      delete this._callbacks["$" + event];return this;
    }var cb;for (var i = 0; i < callbacks.length; i++) {
      cb = callbacks[i];if (cb === fn || cb.fn === fn) {
        callbacks.splice(i, 1);break;
      }
    }return this;
  };Emitter.prototype.emit = function (event) {
    this._callbacks = this._callbacks || {};var args = [].slice.call(arguments, 1),
        callbacks = this._callbacks["$" + event];if (callbacks) {
      callbacks = callbacks.slice(0);for (var i = 0, len = callbacks.length; i < len; ++i) {
        callbacks[i].apply(this, args);
      }
    }return this;
  };Emitter.prototype.listeners = function (event) {
    this._callbacks = this._callbacks || {};return this._callbacks["$" + event] || [];
  };Emitter.prototype.hasListeners = function (event) {
    return !!this.listeners(event).length;
  };
});function isObject$3(obj) {
  return null !== obj && "object" === (typeof obj === "undefined" ? "undefined" : _typeof2(obj));
}var isObject_1 = isObject$3;var requestBase = RequestBase;function RequestBase(obj) {
  if (obj) return mixin$3(obj);
}function mixin$3(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }return obj;
}RequestBase.prototype.clearTimeout = function _clearTimeout() {
  clearTimeout(this._timer);clearTimeout(this._responseTimeoutTimer);delete this._timer;delete this._responseTimeoutTimer;return this;
};RequestBase.prototype.parse = function parse(fn) {
  this._parser = fn;return this;
};RequestBase.prototype.responseType = function (val) {
  this._responseType = val;return this;
};RequestBase.prototype.serialize = function serialize(fn) {
  this._serializer = fn;return this;
};RequestBase.prototype.timeout = function timeout(options) {
  if (!options || "object" !== (typeof options === "undefined" ? "undefined" : _typeof2(options))) {
    this._timeout = options;this._responseTimeout = 0;return this;
  }for (var option in options) {
    switch (option) {case "deadline":
        this._timeout = options.deadline;break;case "response":
        this._responseTimeout = options.response;break;default:
        console.warn("Unknown timeout option", option);}
  }return this;
};RequestBase.prototype.retry = function retry(count, fn) {
  if (arguments.length === 0 || count === true) count = 1;if (count <= 0) count = 0;this._maxRetries = count;this._retries = 0;this._retryCallback = fn;return this;
};var ERROR_CODES = ["ECONNRESET", "ETIMEDOUT", "EADDRINFO", "ESOCKETTIMEDOUT"];RequestBase.prototype._shouldRetry = function (err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);if (override === true) return true;if (override === false) return false;
    } catch (e) {
      console.error(e);
    }
  }if (res && res.status && res.status >= 500 && res.status != 501) return true;if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;if (err.timeout && err.code == "ECONNABORTED") return true;if (err.crossDomain) return true;
  }return false;
};RequestBase.prototype._retry = function () {
  this.clearTimeout();if (this.req) {
    this.req = null;this.req = this.request();
  }this._aborted = false;this.timedout = false;return this._end();
};RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }this._fullfilledPromise = new Promise(function (innerResolve, innerReject) {
      self.end(function (err, res) {
        if (err) innerReject(err);else innerResolve(res);
      });
    });
  }return this._fullfilledPromise.then(resolve, reject);
};RequestBase.prototype.catch = function (cb) {
  return this.then(undefined, cb);
};RequestBase.prototype.use = function use(fn) {
  fn(this);return this;
};RequestBase.prototype.ok = function (cb) {
  if ("function" !== typeof cb) throw Error("Callback required");this._okCallback = cb;return this;
};RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }if (this._okCallback) {
    return this._okCallback(res);
  }return res.status >= 200 && res.status < 300;
};RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};RequestBase.prototype.getHeader = RequestBase.prototype.get;RequestBase.prototype.set = function (field, val) {
  if (isObject_1(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }return this;
  }this._header[field.toLowerCase()] = val;this.header[field] = val;return this;
};RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];delete this.header[field];return this;
};RequestBase.prototype.field = function (name, val) {
  if (null === name || undefined === name) {
    throw new Error(".field(name, val) name can not be empty");
  }if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }if (isObject_1(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }return this;
  }if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }return this;
  }if (null === val || undefined === val) {
    throw new Error(".field(name, val) val can not be empty");
  }if ("boolean" === typeof val) {
    val = "" + val;
  }this._getFormData().append(name, val);return this;
};RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }this._aborted = true;this.xhr && this.xhr.abort();this.req && this.req.abort();this.clearTimeout();this.emit("abort");return this;
};RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {case "basic":
      this.set("Authorization", "Basic " + base64Encoder(user + ":" + pass));break;case "auto":
      this.username = user;this.password = pass;break;case "bearer":
      this.set("Authorization", "Bearer " + user);break;}return this;
};RequestBase.prototype.withCredentials = function (on) {
  if (on == undefined) on = true;this._withCredentials = on;return this;
};RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;return this;
};RequestBase.prototype.maxResponseSize = function (n) {
  if ("number" !== typeof n) {
    throw TypeError("Invalid argument");
  }this._maxResponseSize = n;return this;
};RequestBase.prototype.toJSON = function () {
  return { method: this.method, url: this.url, data: this._data, headers: this._header };
};RequestBase.prototype.send = function (data) {
  var isObj = isObject_1(data);var type = this._header["content-type"];if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }if (isObj && isObject_1(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ("string" == typeof data) {
    if (!type) this.type("form");type = this._header["content-type"];if ("application/x-www-form-urlencoded" == type) {
      this._data = this._data ? this._data + "&" + data : data;
    } else {
      this._data = (this._data || "") + data;
    }
  } else {
    this._data = data;
  }if (!isObj || this._isHost(data)) {
    return this;
  }if (!type) this.type("json");return this;
};RequestBase.prototype.sortQuery = function (sort) {
  this._sort = typeof sort === "undefined" ? true : sort;return this;
};RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join("&");if (query) {
    this.url += (this.url.indexOf("?") >= 0 ? "&" : "?") + query;
  }this._query.length = 0;if (this._sort) {
    var index = this.url.indexOf("?");if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split("&");if ("function" === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }this.url = this.url.substring(0, index) + "?" + queryArr.join("&");
    }
  }
};RequestBase.prototype._appendQueryString = function () {
  console.trace("Unsupported");
};RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }var err = new Error(reason + timeout + "ms exceeded");err.timeout = timeout;err.code = "ECONNABORTED";err.errno = errno;this.timedout = true;this.abort();this.callback(err);
};RequestBase.prototype._setTimeouts = function () {
  var self = this;if (this._timeout && !this._timer) {
    this._timer = setTimeout(function () {
      self._timeoutError("Timeout of ", self._timeout, "ETIME");
    }, this._timeout);
  }if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function () {
      self._timeoutError("Response timeout of ", self._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout);
  }
};var type = function type(str) {
  return str.split(/ *; */).shift();
};var params = function params(str) {
  return str.split(/ *; */).reduce(function (obj, str) {
    var parts = str.split(/ *= */);var key = parts.shift();var val = parts.shift();if (key && val) obj[key] = val;return obj;
  }, {});
};var parseLinks = function parseLinks(str) {
  return str.split(/ *, */).reduce(function (obj, str) {
    var parts = str.split(/ *; */);var url = parts[0].slice(1, -1);var rel = parts[1].split(/ *= */)[1].slice(1, -1);obj[rel] = url;return obj;
  }, {});
};var cleanHeader = function cleanHeader(header, shouldStripCookie) {
  delete header["content-type"];delete header["content-length"];delete header["transfer-encoding"];delete header["host"];if (shouldStripCookie) {
    delete header["cookie"];
  }return header;
};var utils = { type: type, params: params, parseLinks: parseLinks, cleanHeader: cleanHeader };var responseBase = ResponseBase;function ResponseBase(obj) {
  if (obj) return mixin$4(obj);
}function mixin$4(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }return obj;
}ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};ResponseBase.prototype._setHeaderProperties = function (header) {
  var ct = header["content-type"] || "";this.type = utils.type(ct);var params = utils.params(ct);for (var key in params) {
    this[key] = params[key];
  }this.links = {};try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (err) {}
};ResponseBase.prototype._setStatusProperties = function (status) {
  var type = status / 100 | 0;this.status = this.statusCode = status;this.statusType = type;this.info = 1 == type;this.ok = 2 == type;this.redirect = 3 == type;this.clientError = 4 == type;this.serverError = 5 == type;this.error = 4 == type || 5 == type ? this.toError() : false;this.accepted = 202 == status;this.noContent = 204 == status;this.badRequest = 400 == status;this.unauthorized = 401 == status;this.notAcceptable = 406 == status;this.forbidden = 403 == status;this.notFound = 404 == status;
};function Agent() {
  this._defaults = [];
}["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function (fn) {
  Agent.prototype[fn] = function () {
    this._defaults.push({ fn: fn, arguments: arguments });return this;
  };
});Agent.prototype._setDefaults = function (req) {
  this._defaults.forEach(function (def) {
    req[def.fn].apply(req, def.arguments);
  });
};var agentBase = Agent;var client$1 = createCommonjsModule(function (module, exports) {
  var root;if (typeof window !== "undefined") {
    root = window;
  } else if (typeof self !== "undefined") {
    root = self;
  } else {
    console.warn("Using browser-only version of superagent in non-browser environment");root = commonjsGlobal;
  }function noop() {}var request = exports = module.exports = function (method, url) {
    if ("function" == typeof url) {
      return new exports.Request("GET", method).end(url);
    }if (1 == arguments.length) {
      return new exports.Request("GET", method);
    }return new exports.Request(method, url);
  };exports.Request = Request;request.getXHR = function () {
    if (root.XMLHttpRequest && (!root.location || "file:" != root.location.protocol || !root.ActiveXObject)) {
      return new XMLHttpRequest();
    } else {
      try {
        return new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {}try {
        return new ActiveXObject("Msxml2.XMLHTTP.6.0");
      } catch (e) {}try {
        return new ActiveXObject("Msxml2.XMLHTTP.3.0");
      } catch (e) {}try {
        return new ActiveXObject("Msxml2.XMLHTTP");
      } catch (e) {}
    }throw Error("Browser-only version of superagent could not find XHR");
  };var trim = "".trim ? function (s) {
    return s.trim();
  } : function (s) {
    return s.replace(/(^\s*|\s*$)/g, "");
  };function serialize(obj) {
    if (!isObject_1(obj)) return obj;var pairs = [];for (var key in obj) {
      pushEncodedKeyValuePair(pairs, key, obj[key]);
    }return pairs.join("&");
  }function pushEncodedKeyValuePair(pairs, key, val) {
    if (val != null) {
      if (Array.isArray(val)) {
        val.forEach(function (v) {
          pushEncodedKeyValuePair(pairs, key, v);
        });
      } else if (isObject_1(val)) {
        for (var subkey in val) {
          pushEncodedKeyValuePair(pairs, key + "[" + subkey + "]", val[subkey]);
        }
      } else {
        pairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(val));
      }
    } else if (val === null) {
      pairs.push(encodeURIComponent(key));
    }
  }request.serializeObject = serialize;function parseString(str) {
    var obj = {};var pairs = str.split("&");var pair;var pos;for (var i = 0, len = pairs.length; i < len; ++i) {
      pair = pairs[i];pos = pair.indexOf("=");if (pos == -1) {
        obj[decodeURIComponent(pair)] = "";
      } else {
        obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
      }
    }return obj;
  }request.parseString = parseString;request.types = { html: "text/html", json: "application/json", xml: "text/xml", urlencoded: "application/x-www-form-urlencoded", form: "application/x-www-form-urlencoded", "form-data": "application/x-www-form-urlencoded" };request.serialize = { "application/x-www-form-urlencoded": serialize, "application/json": JSON.stringify };request.parse = { "application/x-www-form-urlencoded": parseString, "application/json": JSON.parse };function parseHeader(str) {
    var lines = str.split(/\r?\n/);var fields = {};var index;var line;var field;var val;for (var i = 0, len = lines.length; i < len; ++i) {
      line = lines[i];index = line.indexOf(":");if (index === -1) {
        continue;
      }field = line.slice(0, index).toLowerCase();val = trim(line.slice(index + 1));fields[field] = val;
    }return fields;
  }function isJSON(mime) {
    return (/[\/+]json\b/.test(mime)
    );
  }function Response(req) {
    this.req = req;this.xhr = this.req.xhr;this.text = this.req.method != "HEAD" && (this.xhr.responseType === "" || this.xhr.responseType === "text") || typeof this.xhr.responseType === "undefined" ? this.xhr.responseText : null;this.statusText = this.req.xhr.statusText;var status = this.xhr.status;if (status === 1223) {
      status = 204;
    }this._setStatusProperties(status);this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());this.header["content-type"] = this.xhr.getResponseHeader("content-type");this._setHeaderProperties(this.header);if (null === this.text && req._responseType) {
      this.body = this.xhr.response;
    } else {
      this.body = this.req.method != "HEAD" ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
    }
  }responseBase(Response.prototype);Response.prototype._parseBody = function (str) {
    var parse = request.parse[this.type];if (this.req._parser) {
      return this.req._parser(this, str);
    }if (!parse && isJSON(this.type)) {
      parse = request.parse["application/json"];
    }return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
  };Response.prototype.toError = function () {
    var req = this.req;var method = req.method;var url = req.url;var msg = "cannot " + method + " " + url + " (" + this.status + ")";var err = new Error(msg);err.status = this.status;err.method = method;err.url = url;return err;
  };request.Response = Response;function Request(method, url) {
    var self = this;this._query = this._query || [];this.method = method;this.url = url;this.header = {};this._header = {};this.on("end", function () {
      var err = null;var res = null;try {
        res = new Response(self);
      } catch (e) {
        err = new Error("Parser is unable to parse the response");err.parse = true;err.original = e;if (self.xhr) {
          err.rawResponse = typeof self.xhr.responseType == "undefined" ? self.xhr.responseText : self.xhr.response;err.status = self.xhr.status ? self.xhr.status : null;err.statusCode = err.status;
        } else {
          err.rawResponse = null;err.status = null;
        }return self.callback(err);
      }self.emit("response", res);var new_err;try {
        if (!self._isResponseOK(res)) {
          new_err = new Error(res.statusText || "Unsuccessful HTTP response");
        }
      } catch (custom_err) {
        new_err = custom_err;
      }if (new_err) {
        new_err.original = err;new_err.response = res;new_err.status = res.status;self.callback(new_err, res);
      } else {
        self.callback(null, res);
      }
    });
  }index$3(Request.prototype);requestBase(Request.prototype);Request.prototype.type = function (type) {
    this.set("Content-Type", request.types[type] || type);return this;
  };Request.prototype.accept = function (type) {
    this.set("Accept", request.types[type] || type);return this;
  };Request.prototype.auth = function (user, pass, options) {
    if (1 === arguments.length) pass = "";if ((typeof pass === "undefined" ? "undefined" : _typeof2(pass)) === "object" && pass !== null) {
      options = pass;pass = "";
    }if (!options) {
      options = { type: "function" === typeof btoa ? "basic" : "auto" };
    }var encoder = function encoder(string) {
      if ("function" === typeof btoa) {
        return btoa(string);
      }throw new Error("Cannot use basic auth, btoa is not a function");
    };return this._auth(user, pass, options, encoder);
  };Request.prototype.query = function (val) {
    if ("string" != typeof val) val = serialize(val);if (val) this._query.push(val);return this;
  };Request.prototype.attach = function (field, file, options) {
    if (file) {
      if (this._data) {
        throw Error("superagent can't mix .send() and .attach()");
      }this._getFormData().append(field, file, options || file.name);
    }return this;
  };Request.prototype._getFormData = function () {
    if (!this._formData) {
      this._formData = new root.FormData();
    }return this._formData;
  };Request.prototype.callback = function (err, res) {
    if (this._shouldRetry(err, res)) {
      return this._retry();
    }var fn = this._callback;this.clearTimeout();if (err) {
      if (this._maxRetries) err.retries = this._retries - 1;this.emit("error", err);
    }fn(err, res);
  };Request.prototype.crossDomainError = function () {
    var err = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");err.crossDomain = true;err.status = this.status;err.method = this.method;err.url = this.url;this.callback(err);
  };Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function () {
    console.warn("This is not supported in browser version of superagent");return this;
  };Request.prototype.pipe = Request.prototype.write = function () {
    throw Error("Streaming is not supported in browser version of superagent");
  };Request.prototype._isHost = function _isHost(obj) {
    return obj && "object" === (typeof obj === "undefined" ? "undefined" : _typeof2(obj)) && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== "[object Object]";
  };Request.prototype.end = function (fn) {
    if (this._endCalled) {
      console.warn("Warning: .end() was called twice. This is not supported in superagent");
    }this._endCalled = true;this._callback = fn || noop;this._finalizeQueryString();return this._end();
  };Request.prototype._end = function () {
    var self = this;var xhr = this.xhr = request.getXHR();var data = this._formData || this._data;this._setTimeouts();xhr.onreadystatechange = function () {
      var readyState = xhr.readyState;if (readyState >= 2 && self._responseTimeoutTimer) {
        clearTimeout(self._responseTimeoutTimer);
      }if (4 != readyState) {
        return;
      }var status;try {
        status = xhr.status;
      } catch (e) {
        status = 0;
      }if (!status) {
        if (self.timedout || self._aborted) return;return self.crossDomainError();
      }self.emit("end");
    };var handleProgress = function handleProgress(direction, e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }e.direction = direction;self.emit("progress", e);
    };if (this.hasListeners("progress")) {
      try {
        xhr.onprogress = handleProgress.bind(null, "download");if (xhr.upload) {
          xhr.upload.onprogress = handleProgress.bind(null, "upload");
        }
      } catch (e) {}
    }try {
      if (this.username && this.password) {
        xhr.open(this.method, this.url, true, this.username, this.password);
      } else {
        xhr.open(this.method, this.url, true);
      }
    } catch (err) {
      return this.callback(err);
    }if (this._withCredentials) xhr.withCredentials = true;if (!this._formData && "GET" != this.method && "HEAD" != this.method && "string" != typeof data && !this._isHost(data)) {
      var contentType = this._header["content-type"];var serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];if (!serialize && isJSON(contentType)) {
        serialize = request.serialize["application/json"];
      }if (serialize) data = serialize(data);
    }for (var field in this.header) {
      if (null == this.header[field]) continue;if (this.header.hasOwnProperty(field)) xhr.setRequestHeader(field, this.header[field]);
    }if (this._responseType) {
      xhr.responseType = this._responseType;
    }this.emit("request", this);xhr.send(typeof data !== "undefined" ? data : null);return this;
  };request.agent = function () {
    return new agentBase();
  };["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (method) {
    agentBase.prototype[method.toLowerCase()] = function (url, fn) {
      var req = new request.Request(method, url);this._setDefaults(req);if (fn) {
        req.end(fn);
      }return req;
    };
  });agentBase.prototype.del = agentBase.prototype["delete"];request.get = function (url, data, fn) {
    var req = request("GET", url);if ("function" == typeof data) fn = data, data = null;if (data) req.query(data);if (fn) req.end(fn);return req;
  };request.head = function (url, data, fn) {
    var req = request("HEAD", url);if ("function" == typeof data) fn = data, data = null;if (data) req.query(data);if (fn) req.end(fn);return req;
  };request.options = function (url, data, fn) {
    var req = request("OPTIONS", url);if ("function" == typeof data) fn = data, data = null;if (data) req.send(data);if (fn) req.end(fn);return req;
  };function del(url, data, fn) {
    var req = request("DELETE", url);if ("function" == typeof data) fn = data, data = null;if (data) req.send(data);if (fn) req.end(fn);return req;
  }request["del"] = del;request["delete"] = del;request.patch = function (url, data, fn) {
    var req = request("PATCH", url);if ("function" == typeof data) fn = data, data = null;if (data) req.send(data);if (fn) req.end(fn);return req;
  };request.post = function (url, data, fn) {
    var req = request("POST", url);if ("function" == typeof data) fn = data, data = null;if (data) req.send(data);if (fn) req.end(fn);return req;
  };request.put = function (url, data, fn) {
    var req = request("PUT", url);if ("function" == typeof data) fn = data, data = null;if (data) req.send(data);if (fn) req.end(fn);return req;
  };
});var requestWithSource = function requestWithSource(method, url) {
  return client$1[method](url).set("Filestack-Source", "JS-0.6.0");
};var LANGUAGES = { tr: { regexp: /\u0130|\u0049|\u0049\u0307/g, map: { "İ": "i", I: "ı", "İ": "i" } }, az: { regexp: /[\u0130]/g, map: { "İ": "i", I: "ı", "İ": "i" } }, lt: { regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g, map: { I: "i̇", J: "j̇", "Į": "į̇", "Ì": "i̇̀", "Í": "i̇́", "Ĩ": "i̇̃" } } };var lowerCase = function lowerCase(str, locale) {
  var lang = LANGUAGES[locale];str = str == null ? "" : String(str);if (lang) {
    str = str.replace(lang.regexp, function (m) {
      return lang.map[m];
    });
  }return str.toLowerCase();
};var nonWordRegexp = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;var camelCaseRegexp = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g;var camelCaseUpperRegexp = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]+)([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g;var noCase = function noCase(str, locale, replacement) {
  if (str == null) {
    return "";
  }replacement = typeof replacement !== "string" ? " " : replacement;function replace(match, index, value) {
    if (index === 0 || index === value.length - match.length) {
      return "";
    }return replacement;
  }str = String(str).replace(camelCaseRegexp, "$1 $2").replace(camelCaseUpperRegexp, "$1 $2").replace(nonWordRegexp, replace);return lowerCase(str, locale);
};var snakeCase = function snakeCase(value, locale) {
  return noCase(value, locale, "_");
};var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
};var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};var validate$1 = index$1$1.validate;var checkOptions = function checkOptions(name, allowed, options) {
  var keys = Object.keys(options);var allowedNames = allowed.map(function (a) {
    return a.name;
  });var namesFormatted = allowedNames.join(", ");keys.forEach(function (key) {
    if (allowedNames.indexOf(key) < 0) {
      throw new Error(key + " is not a valid option for " + name + ". Valid options are: " + namesFormatted);
    }
  });allowed.forEach(function (obj) {
    var value = options[obj.name];if (obj.name === "location" && typeof value === "string") {
      value = value.toLowerCase();
    }if (value !== undefined) {
      var result = validate$1(value, obj.type);if (!result.isValid()) {
        throw new Error(result.firstError().message);
      }
    }
  });return keys;
};var removeEmpty = function removeEmpty(obj) {
  var newObj = _extends$1({}, obj);Object.keys(newObj).forEach(function (k) {
    return !newObj[k] && newObj[k] !== undefined && delete newObj[k];
  });return newObj;
};var snakeKeys = function snakeKeys(opts) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";var options = _extends$1({}, opts);return Object.keys(options).reduce(function (prev, curr) {
    prev[snakeCase(prefix + "-" + curr)] = options[curr];delete options[curr];return prev;
  }, {});
};var storeURL = function storeURL(session, url) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var token = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};var storeApiUrl = session.urls.storeApiUrl;if (!url || typeof url !== "string") {
    throw new Error("url is required for storeURL");
  }var allowed = [{ name: "filename", type: index$1$1.String }, { name: "location", type: index$1$1.enums.of("s3 gcs rackspace azure dropbox") }, { name: "mimetype", type: index$1$1.String }, { name: "path", type: index$1$1.String }, { name: "region", type: index$1$1.String }, { name: "container", type: index$1$1.String }, { name: "access", type: index$1$1.enums.of("public private") }];checkOptions("storeURL", allowed, options);var location = options.location || "s3";var newOptions = removeEmpty(options);if (session.policy && session.signature) {
    newOptions.policy = session.policy;newOptions.signature = session.signature;
  }var baseURL = storeApiUrl + "/" + location;var fd = new FormData();fd.append("url", url);return new Promise(function (resolve, reject) {
    var req = client$1.post(baseURL).query({ key: session.apikey }).query(newOptions).send(fd).end(function (err, res) {
      if (err) {
        reject(err);
      } else if (res.body && res.body.url) {
        var handle = res.body.url.split("/").pop();var response = _extends$1({}, res.body, { handle: handle });resolve(response);
      } else {
        resolve(res.body);
      }
    });token.cancel = function () {
      req.abort();reject(new Error("Upload cancelled"));
    };
  });
};var retrieve = function retrieve(session, handle) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var fileApiUrl = session.urls.fileApiUrl;if (!handle || typeof handle !== "string") {
    throw new Error("handle is required for retrieve");
  }var allowed = [{ name: "metadata", type: index$1$1.Boolean }, { name: "head", type: index$1$1.Boolean }, { name: "cache", type: index$1$1.Boolean }, { name: "dl", type: index$1$1.Boolean }, { name: "extension", type: index$1$1.String }];checkOptions("retrieve", allowed, options);var baseURL = fileApiUrl + "/" + handle;var newOptions = removeEmpty(options);if (newOptions.extension) {
    baseURL += "+" + newOptions.extension;delete newOptions.extension;
  }if (newOptions.metadata) {
    baseURL += "/metadata";
  }if (session.policy && session.signature) {
    newOptions.policy = session.policy;newOptions.signature = session.signature;
  }if (newOptions.head) {
    delete newOptions.head;return new Promise(function (resolve, reject) {
      client$1.head(baseURL).query(newOptions).end(function (err, res) {
        if (err) {
          reject(err);
        } else {
          resolve(res.headers);
        }
      });
    });
  }return new Promise(function (resolve, reject) {
    var responseType = newOptions.metadata ? "json" : "blob";delete newOptions.metadata;client$1.get(baseURL).query(newOptions).responseType(responseType).end(function (err, res) {
      if (err) {
        reject(err);
      } else {
        resolve(res.body);
      }
    });
  });
};var remove = function remove(session, handle) {
  var fileApiUrl = session.urls.fileApiUrl;if (!handle || typeof handle !== "string") {
    throw new Error("handle is required for remove");
  }if (!session.policy || !session.signature) {
    throw new Error("security policy and signature are required for remove");
  }var baseURL = fileApiUrl + "/" + handle;return new Promise(function (resolve, reject) {
    client$1.delete(baseURL).query({ key: session.apikey }).query({ policy: session.policy, signature: session.signature }).end(function (err, res) {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
};var overwrite = function overwrite(session, handle) {
  var fileApiUrl = session.urls.fileApiUrl;if (!handle || typeof handle !== "string") {
    throw new Error("handle is required for overwrite");
  }if (!session.policy || !session.signature) {
    throw new Error("security policy and signature are required for overwrite");
  }var baseURL = fileApiUrl + "/" + handle;return new Promise(function (resolve, reject) {
    client$1.post(baseURL).query({ key: session.apikey }).query({ policy: session.policy, signature: session.signature }).end(function (err, res) {
      if (err) {
        reject(err);
      } else {
        var response = _extends$1({}, res.body, { handle: handle });resolve(response);
      }
    });
  });
};var metadata = function metadata(session, handle) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var fileApiUrl = session.urls.fileApiUrl;if (!handle || typeof handle !== "string") {
    throw new Error("handle is required for metadata");
  }var allowed = [{ name: "size", type: index$1$1.Boolean }, { name: "mimetype", type: index$1$1.Boolean }, { name: "filename", type: index$1$1.Boolean }, { name: "width", type: index$1$1.Boolean }, { name: "height", type: index$1$1.Boolean }, { name: "uploaded", type: index$1$1.Boolean }, { name: "writeable", type: index$1$1.Boolean }, { name: "cloud", type: index$1$1.Boolean }, { name: "sourceUrl", type: index$1$1.Boolean }, { name: "md5", type: index$1$1.Boolean }, { name: "sha1", type: index$1$1.Boolean }, { name: "sha224", type: index$1$1.Boolean }, { name: "sha256", type: index$1$1.Boolean }, { name: "sha384", type: index$1$1.Boolean }, { name: "sha512", type: index$1$1.Boolean }, { name: "location", type: index$1$1.Boolean }, { name: "path", type: index$1$1.Boolean }, { name: "container", type: index$1$1.Boolean }, { name: "exif", type: index$1$1.Boolean }];checkOptions("retrieve", allowed, options);var newOptions = removeEmpty(snakeKeys(options));if (session.policy && session.signature) {
    newOptions.policy = session.policy;newOptions.signature = session.signature;
  }var baseURL = fileApiUrl + "/" + handle + "/metadata";return new Promise(function (resolve, reject) {
    client$1.get(baseURL).query(newOptions).end(function (err, res) {
      if (err) {
        reject(err);
      } else {
        resolve(res.body);
      }
    });
  });
};var onOff = { init: function init() {
    window.filestackInternals.logger.working = false;
  }, isWorking: function isWorking() {
    return window.filestackInternals.logger.working;
  }, on: function on() {
    window.filestackInternals.logger.working = true;
  }, off: function off() {
    window.filestackInternals.logger.working = false;
  } };var _typeof$1 = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};var toConsumableArray$1 = function toConsumableArray$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
};var context = function context(contextName, onOff) {
  var api = function log() {
    for (var _len = arguments.length, stuff = Array(_len), _key = 0; _key < _len; _key++) {
      stuff[_key] = arguments[_key];
    }var convertedToStrings = [].concat(stuff).map(function (thing) {
      if ((typeof thing === "undefined" ? "undefined" : _typeof$1(thing)) === "object") {
        return JSON.stringify(thing, function (key, value) {
          if (typeof value === "function") {
            if (key === "json") {
              try {
                return value();
              } catch (err) {}
            }return "[Function]";
          }if (value instanceof File) {
            return "[File name: " + value.name + ", mimetype: " + value.type + ", size: " + value.size + "]";
          }return value;
        }, 2);
      }return thing;
    });if (onOff.isWorking()) {
      var _console;(_console = console).log.apply(_console, ["[" + contextName + "]"].concat(toConsumableArray$1(convertedToStrings)));
    }
  };api.context = function (subContextName) {
    return context(contextName + "][" + subContextName, onOff);
  };api.on = onOff.on;api.off = onOff.off;return api;
};var logger = context("filestack", onOff);var initializeGlobalNamespace = function initializeGlobalNamespace() {
  var namespace = void 0;if ((typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object") {
    namespace = window.filestackInternals;if (!namespace) {
      namespace = {};window.filestackInternals = namespace;
    }if (!namespace.logger) {
      namespace.logger = logger;onOff.init();
    }
  }return namespace;
};initializeGlobalNamespace();var log = logger.context("api-client");var _cloud = function _cloud(session) {
  var cloudApiUrl = session.urls.cloudApiUrl;var list = function list(clouds) {
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};var payload = { apikey: session.apikey, clouds: clouds };if (session.policy && session.signature) {
      payload.policy = session.policy;payload.signature = session.signature;
    }log("cloud.list() called:", payload);return new Promise(function (resolve, reject) {
      var req = client$1.post(cloudApiUrl + "/folder/list").send(payload).withCredentials().end(function (err, response) {
        if (err) {
          reject(err);
        } else {
          log("cloud.list() responded:", response.body);resolve(response.body);
        }
      });token.cancel = function () {
        req.abort();reject(new Error("Cancelled"));
      };
    });
  };var store = function store(name, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var customSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};var token = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};log("cloud.store() called:", name, path, options);var allowed = [{ name: "location", type: index$1$1.enums.of("s3 gcs rackspace azure dropbox") }, { name: "region", type: index$1$1.String }, { name: "path", type: index$1$1.String }, { name: "container", type: index$1$1.String }, { name: "access", type: index$1$1.enums.of("public private") }];checkOptions("cloud.store", allowed, options);if (options.location === undefined) options.location = "s3";var payload = { apikey: session.apikey, clouds: defineProperty({}, name, { path: path, store: _extends$1({}, removeEmpty(options)) }) };if (name === "customsource" && customSource.customSourcePath) {
      payload.clouds.customsource.customSourcePath = customSource.customSourcePath;
    }if (name === "customsource" && customSource.customSourceContainer) {
      payload.clouds.customsource.customSourceContainer = customSource.customSourceContainer;
    }if (session.policy && session.signature) {
      payload.policy = session.policy;payload.signature = session.signature;
    }return new Promise(function (resolve, reject) {
      var req = client$1.post(cloudApiUrl + "/store/").send(payload).withCredentials().end(function (err, response) {
        if (err) {
          reject(err);
        } else {
          log("cloud.store() responded:", response.body);if (response.body[name]) {
            resolve(response.body[name]);
          } else {
            resolve(response.body);
          }
        }
      });token.cancel = function () {
        req.abort();reject(new Error("Cancelled"));
      };
    });
  };var link = function link(name, path) {
    var customSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var token = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};log("cloud.link() called:", name, path);var payload = { apikey: session.apikey, clouds: defineProperty({}, name, { path: path }) };if (name === "customsource" && customSource.customSourcePath) {
      payload.clouds.customsource.customSourcePath = customSource.customSourcePath;
    }if (name === "customsource" && customSource.customSourceContainer) {
      payload.clouds.customsource.customSourceContainer = customSource.customSourceContainer;
    }if (session.policy && session.signature) {
      payload.policy = session.policy;payload.signature = session.signature;
    }return new Promise(function (resolve, reject) {
      var req = client$1.post(cloudApiUrl + "/link/").send(payload).withCredentials().end(function (err, response) {
        if (err) {
          reject(err);
        } else {
          log("cloud.link() responded:", response.body);if (response.body[name]) {
            resolve(response.body[name]);
          } else {
            resolve(response.body);
          }
        }
      });token.cancel = function () {
        req.abort();reject(new Error("Cancelled"));
      };
    });
  };var logout = function logout(name) {
    log("cloud.logout() called:", name);var payload = { apikey: session.apikey };if (name) {
      payload.clouds = defineProperty({}, name, {});
    }return new Promise(function (resolve, reject) {
      client$1.post(cloudApiUrl + "/auth/logout/").send(payload).withCredentials().end(function (err, response) {
        if (err) {
          reject(err);
        } else {
          log("cloud.logout() responded:", response.body);resolve(response.body);
        }
      });
    });
  };var metadata = function metadata(url) {
    var payload = { apikey: session.apikey, url: url };if (session.policy && session.signature) {
      payload.policy = session.policy;payload.signature = session.signature;
    }return new Promise(function (resolve, reject) {
      client$1.post(cloudApiUrl + "/metadata").send(payload).end(function (err, response) {
        if (err) {
          reject(err);
        } else {
          log("cloud.metadata() responded:", response.body);resolve(response.body);
        }
      });
    });
  };var tokInit = function tokInit(type) {
    if (type !== "video" && type !== "audio") {
      throw new Error("Type must be one of video or audio.");
    }return client$1.post(cloudApiUrl + "/recording/" + type + "/init");
  };var tokStart = function tokStart(type, key, sessionId) {
    if (type !== "video" && type !== "audio") {
      throw new Error("Type must be one of video or audio.");
    }var payload = { apikey: key, session_id: sessionId };return client$1.post(cloudApiUrl + "/recording/" + type + "/start").send(payload);
  };var tokStop = function tokStop(type, key, sessionId, archiveId) {
    if (type !== "video" && type !== "audio") {
      throw new Error("Type must be one of video or audio.");
    }var payload = { apikey: key, session_id: sessionId, archive_id: archiveId };return client$1.post(cloudApiUrl + "/recording/" + type + "/stop").send(payload);
  };return { list: list, store: store, link: link, metadata: metadata, logout: logout, tokInit: tokInit, tokStart: tokStart, tokStop: tokStop };
};var prefetch = function prefetch(session) {
  var cloudURL = session.urls.cloudApiUrl;var params = { apikey: session.apikey };return client$1.get(cloudURL + "/prefetch").timeout(5e3).query(params).then(function (res) {
    return res.body;
  });
};var getUrl = function getUrl(session, handle) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var newOptions = _extends$1({}, options);if (!newOptions.policy && !newOptions.signature && session.policy && session.signature) {
    newOptions.policy = session.policy;newOptions.signature = session.signature;
  }var hasSecurity = newOptions.signature && newOptions.policy;var policy = newOptions.policy,
      signature = newOptions.signature;var previewApiUrl = session.urls.previewApiUrl;var params = [];var baseUrl = [previewApiUrl];var cssV1 = options.css;var cssV2 = options.css && encodeURIComponent('"' + options.css + '"');var previewTask = cssV2 ? "preview=css:" + cssV2 : "preview";if (options.v1) {
    baseUrl.push("api/preview");if (options.css) {
      params.push("css=" + cssV1);
    }if (hasSecurity) {
      params.push("policy=" + policy + "&signature=" + signature);
    }
  } else {
    if (handle.indexOf("src:") !== -1) {
      baseUrl.push(session.apikey + "/" + previewTask);
    } else {
      baseUrl.push(previewTask);
    }if (hasSecurity) {
      baseUrl.push("security=policy:" + policy + ",signature:" + signature);
    }
  }baseUrl.push(handle);var url = baseUrl.join("/");if (params.length) {
    var paramString = params.join("&");return url + "?" + paramString;
  }return url;
};var preview = function preview(session, handle) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};if (!handle || typeof handle !== "string") {
    throw new Error("handle or storage alias is required for preview");
  }var allowed = [{ name: "id", type: index$1$1.String }, { name: "css", type: index$1$1.String }, { name: "policy", type: index$1$1.String }, { name: "signature", type: index$1$1.String }, { name: "v1", type: index$1$1.Boolean }];checkOptions("preview", allowed, options);var newOptions = removeEmpty(options);var url = getUrl(session, handle, newOptions);if (newOptions.id) {
    var id = newOptions.id;var iframe = document.createElement("iframe");var domElement = document.getElementById(id);iframe.src = url;iframe.width = "100%";iframe.height = "100%";if (!domElement) {
      throw new Error('DOM Element with id "' + id + '" not found.');
    }return domElement.appendChild(iframe);
  }return window.open(url, handle);
};var numberRange = function numberRange(start, end) {
  return index$1$1.refinement(index$1$1.Number, function (n) {
    return n >= start && n <= end;
  });
};var min = function min(int) {
  return index$1$1.refinement(index$1$1.Integer, function (n) {
    return n >= int;
  });
};var max = function max(int) {
  return index$1$1.refinement(index$1$1.Integer, function (n) {
    return n <= int;
  });
};var range = function range(start, end) {
  return index$1$1.tuple([min(start), max(end)], "range");
};var alignment = index$1$1.enums.of("top left right bottom");var alignPair = index$1$1.refinement(index$1$1.tuple([alignment, alignment]), function (tup) {
  return tup[0] !== tup[1];
}, "pair");var formatOption = function formatOption(op, options) {
  var name = snakeCase(op.name);var value = options[op.name];if (Array.isArray(value)) {
    return name + ":[" + value + "]";
  }return value ? name + ":" + value : null;
};var formatOptions = function formatOptions(name, allowed, options) {
  var fOptions = allowed.map(function (op) {
    return formatOption(op, options);
  }).filter(function (op) {
    return op;
  }).join(",");var snakeName = snakeCase(name);if (fOptions.length) {
    return snakeName + "=" + fOptions;
  }return snakeName;
};var sepia = function sepia() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "tone", type: numberRange(0, 100) }];checkOptions("sepia", allowed, options);var sepiaOptions = formatOptions("sepia", allowed, options);return transforms.concat(sepiaOptions);
};var blackwhite = function blackwhite() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "threshold", type: numberRange(0, 100) }];checkOptions("blackwhite", allowed, options);var blackWhiteOptions = formatOptions("blackwhite", allowed, options);return transforms.concat(blackWhiteOptions);
};var border = function border() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "width", type: numberRange(1, 1e3) }, { name: "color", type: index$1$1.String }, { name: "background", type: index$1$1.String }];checkOptions("border", allowed, options);var borderOptions = formatOptions("border", allowed, options);return transforms.concat(borderOptions);
};var circle = function circle() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "background", type: index$1$1.String }];checkOptions("circle", allowed, options);var circleOptions = formatOptions("circle", allowed, options);return transforms.concat(circleOptions);
};var shadow = function shadow() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "blur", type: numberRange(0, 20) }, { name: "opacity", type: numberRange(0, 100) }, { name: "vector", type: range(-1e3, 1e3) }, { name: "color", type: index$1$1.String }, { name: "background", type: index$1$1.String }];checkOptions("shadow", allowed, options);var shadowOptions = formatOptions("shadow", allowed, options);return transforms.concat(shadowOptions);
};var tornEdges = function tornEdges() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "spread", type: range(1, 1e4) }, { name: "background", type: index$1$1.String }];checkOptions("tornEdges", allowed, options);var tornEdgesOptions = formatOptions("tornEdges", allowed, options);return transforms.concat(tornEdgesOptions);
};var polaroid = function polaroid() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "color", type: index$1$1.String }, { name: "rotate", type: numberRange(0, 359) }, { name: "background", type: index$1$1.String }];checkOptions("polaroid", allowed, options);var polaroidOptions = formatOptions("polaroid", allowed, options);return transforms.concat(polaroidOptions);
};var vignette = function vignette() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "amount", type: numberRange(0, 100) }, { name: "blurmode", type: index$1$1.enums.of("linear gaussian") }, { name: "background", type: index$1$1.String }];checkOptions("vignette", allowed, options);var vignetteOptions = formatOptions("vignette", allowed, options);return transforms.concat(vignetteOptions);
};var roundedCorners = function roundedCorners() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "radius", type: index$1$1.union([numberRange(1, 1e4), index$1$1.enums.of("max")]) }, { name: "blur", type: numberRange(0, 20) }, { name: "background", type: index$1$1.String }];checkOptions("roundedCorners", allowed, options);var roundedCornersOptions = formatOptions("roundedCorners", allowed, options);return transforms.concat(roundedCornersOptions);
};var rotate = function rotate() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "deg", type: index$1$1.union([numberRange(0, 359), index$1$1.enums.of("exif")]) }, { name: "exif", type: index$1$1.Boolean }, { name: "background", type: index$1$1.String }];var keys = checkOptions("rotate", allowed, options);if (keys.length < 1) {
    throw new Error("Rotate options must contain either deg or exif");
  }var rotateOptions = formatOptions("rotate", allowed, options);return transforms.concat(rotateOptions);
};var resize = function resize() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "width", type: numberRange(0, 1e4) }, { name: "height", type: numberRange(0, 1e4) }, { name: "fit", type: index$1$1.enums.of("clip crop scale max") }, { name: "align", type: index$1$1.union([index$1$1.enums.of("center top bottom left right faces"), alignPair]) }];var keys = checkOptions("resize", allowed, options);if (keys.length < 1) {
    throw new Error("Resize options must contain either width, height, fit, or align");
  }var resizeOptions = formatOptions("resize", allowed, options);return transforms.concat(resizeOptions);
};var flip = function flip() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var value = arguments[1];if (typeof value !== "boolean") {
    throw Error("flip must be a Boolean value");
  }return value ? transforms.concat("flip") : transforms;
};var flop = function flop() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var value = arguments[1];if (typeof value !== "boolean") {
    throw Error("flop must be a Boolean value");
  }return value ? transforms.concat("flop") : transforms;
};var monochrome = function monochrome() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var value = arguments[1];if (typeof value !== "boolean") {
    throw Error("monochrome must be a Boolean value");
  }return value ? transforms.concat("monochrome") : transforms;
};var crop = function crop() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "dim", type: index$1$1.struct({ x: index$1$1.Integer, y: index$1$1.Integer, width: index$1$1.Integer, height: index$1$1.Integer }) }];checkOptions("crop", allowed, options);var dim = options.dim;var cropOptions = "crop=dim:[" + dim.x + "," + dim.y + "," + dim.width + "," + dim.height + "]";return transforms.concat(cropOptions);
};var output = function output() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var options = arguments[1];var allowed = [{ name: "format", type: index$1$1.String }, { name: "background", type: index$1$1.String }, { name: "page", type: numberRange(1, 1e4) }, { name: "density", type: numberRange(1, 500) }, { name: "compress", type: index$1$1.Boolean }, { name: "quality", type: index$1$1.union([numberRange(1, 100), index$1$1.enums.of("input")]) }, { name: "input", type: index$1$1.Boolean }, { name: "strip", type: index$1$1.Boolean }, { name: "colorspace", type: index$1$1.enums.of("rgb cmyk input") }, { name: "secure", type: index$1$1.Boolean }, { name: "docinfo", type: index$1$1.Boolean }, { name: "pageformat", type: index$1$1.enums.of("a3 a4 a5 b4 b5 letter legal tabloid") }, { name: "pageorientation", type: index$1$1.enums.of("landscape portrait") }];checkOptions("output", allowed, options);var outputOptions = formatOptions("output", allowed, options);return transforms.concat(outputOptions);
};var transformers = { crop: crop, resize: resize, rotate: rotate, roundedCorners: roundedCorners, vignette: vignette, polaroid: polaroid, tornEdges: tornEdges, shadow: shadow, circle: circle, border: border, flip: flip, flop: flop, blackwhite: blackwhite, monochrome: monochrome, sepia: sepia, output: output };var transform = function transform(session, url, config) {
  var processURL = session.urls.processApiUrl;var allowed = Object.keys(transformers);var keys = Object.keys(config);keys.forEach(function (key) {
    if (allowed.indexOf(key) < 0) {
      throw new Error("Invalid option specified: " + key + " is not a valid transform option.");
    }
  });var construct = function construct() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;if (count === keys.length) {
      return arr;
    }var transformIndex = keys[count];var transformConfig = config[transformIndex];var transformer = transformers[transformIndex];var newCount = count + 1;return construct(transformer(arr, transformConfig), newCount);
  };if (session.policy && session.signature) {
    var secString = "security=policy:" + session.policy + ",signature:" + session.signature;var _baseURL = processURL + "/" + session.apikey + "/" + secString;var transformString = construct().join("/");return _baseURL + "/" + transformString + "/" + url;
  }var baseURL = processURL + "/" + session.apikey;var transforms = construct();if (transforms.length) {
    var _transformString = construct().join("/");return baseURL + "/" + _transformString + "/" + url;
  }return url;
};var bowser = createCommonjsModule(function (module) {
  !function (root, name, definition) {
    if ("object" != "undefined" && module.exports) module.exports = definition();else if (false) undefined(name, definition);else root[name] = definition();
  }(commonjsGlobal, "bowser", function () {
    var t = true;function detect(ua) {
      function getFirstMatch(regex) {
        var match = ua.match(regex);return match && match.length > 1 && match[1] || "";
      }function getSecondMatch(regex) {
        var match = ua.match(regex);return match && match.length > 1 && match[2] || "";
      }var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
          likeAndroid = /like android/i.test(ua),
          android = !likeAndroid && /android/i.test(ua),
          nexusMobile = /nexus\s*[0-6]\s*/i.test(ua),
          nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua),
          chromeos = /CrOS/.test(ua),
          silk = /silk/i.test(ua),
          sailfish = /sailfish/i.test(ua),
          tizen = /tizen/i.test(ua),
          webos = /(web|hpw)os/i.test(ua),
          windowsphone = /windows phone/i.test(ua),
          samsungBrowser = /SamsungBrowser/i.test(ua),
          windows = !windowsphone && /windows/i.test(ua),
          mac = !iosdevice && !silk && /macintosh/i.test(ua),
          linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua),
          edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i),
          versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
          tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua),
          mobile = !tablet && /[^-]mobi/i.test(ua),
          xbox = /xbox/i.test(ua),
          result;if (/opera/i.test(ua)) {
        result = { name: "Opera", opera: t, version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i) };
      } else if (/opr|opios/i.test(ua)) {
        result = { name: "Opera", opera: t, version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier };
      } else if (/SamsungBrowser/i.test(ua)) {
        result = { name: "Samsung Internet for Android", samsungBrowser: t, version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i) };
      } else if (/coast/i.test(ua)) {
        result = { name: "Opera Coast", coast: t, version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i) };
      } else if (/yabrowser/i.test(ua)) {
        result = { name: "Yandex Browser", yandexbrowser: t, version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i) };
      } else if (/ucbrowser/i.test(ua)) {
        result = { name: "UC Browser", ucbrowser: t, version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i) };
      } else if (/mxios/i.test(ua)) {
        result = { name: "Maxthon", maxthon: t, version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i) };
      } else if (/epiphany/i.test(ua)) {
        result = { name: "Epiphany", epiphany: t, version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i) };
      } else if (/puffin/i.test(ua)) {
        result = { name: "Puffin", puffin: t, version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i) };
      } else if (/sleipnir/i.test(ua)) {
        result = { name: "Sleipnir", sleipnir: t, version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i) };
      } else if (/k-meleon/i.test(ua)) {
        result = { name: "K-Meleon", kMeleon: t, version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i) };
      } else if (windowsphone) {
        result = { name: "Windows Phone", windowsphone: t };if (edgeVersion) {
          result.msedge = t;result.version = edgeVersion;
        } else {
          result.msie = t;result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
        }
      } else if (/msie|trident/i.test(ua)) {
        result = { name: "Internet Explorer", msie: t, version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i) };
      } else if (chromeos) {
        result = { name: "Chrome", chromeos: t, chromeBook: t, chrome: t, version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) };
      } else if (/chrome.+? edge/i.test(ua)) {
        result = { name: "Microsoft Edge", msedge: t, version: edgeVersion };
      } else if (/vivaldi/i.test(ua)) {
        result = { name: "Vivaldi", vivaldi: t, version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier };
      } else if (sailfish) {
        result = { name: "Sailfish", sailfish: t, version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i) };
      } else if (/seamonkey\//i.test(ua)) {
        result = { name: "SeaMonkey", seamonkey: t, version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i) };
      } else if (/firefox|iceweasel|fxios/i.test(ua)) {
        result = { name: "Firefox", firefox: t, version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i) };if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
          result.firefoxos = t;
        }
      } else if (silk) {
        result = { name: "Amazon Silk", silk: t, version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i) };
      } else if (/phantom/i.test(ua)) {
        result = { name: "PhantomJS", phantom: t, version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i) };
      } else if (/slimerjs/i.test(ua)) {
        result = { name: "SlimerJS", slimer: t, version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i) };
      } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
        result = { name: "BlackBerry", blackberry: t, version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i) };
      } else if (webos) {
        result = { name: "WebOS", webos: t, version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i) };/touchpad\//i.test(ua) && (result.touchpad = t);
      } else if (/bada/i.test(ua)) {
        result = { name: "Bada", bada: t, version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i) };
      } else if (tizen) {
        result = { name: "Tizen", tizen: t, version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier };
      } else if (/qupzilla/i.test(ua)) {
        result = { name: "QupZilla", qupzilla: t, version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier };
      } else if (/chromium/i.test(ua)) {
        result = { name: "Chromium", chromium: t, version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier };
      } else if (/chrome|crios|crmo/i.test(ua)) {
        result = { name: "Chrome", chrome: t, version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) };
      } else if (android) {
        result = { name: "Android", version: versionIdentifier };
      } else if (/safari|applewebkit/i.test(ua)) {
        result = { name: "Safari", safari: t };if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (iosdevice) {
        result = { name: iosdevice == "iphone" ? "iPhone" : iosdevice == "ipad" ? "iPad" : "iPod" };if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (/googlebot/i.test(ua)) {
        result = { name: "Googlebot", googlebot: t, version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier };
      } else {
        result = { name: getFirstMatch(/^(.*)\/(.*) /), version: getSecondMatch(/^(.*)\/(.*) /) };
      }if (!result.msedge && /(apple)?webkit/i.test(ua)) {
        if (/(apple)?webkit\/537\.36/i.test(ua)) {
          result.name = result.name || "Blink";result.blink = t;
        } else {
          result.name = result.name || "Webkit";result.webkit = t;
        }if (!result.version && versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (!result.opera && /gecko\//i.test(ua)) {
        result.name = result.name || "Gecko";result.gecko = t;result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
      }if (!result.windowsphone && !result.msedge && (android || result.silk)) {
        result.android = t;
      } else if (!result.windowsphone && !result.msedge && iosdevice) {
        result[iosdevice] = t;result.ios = t;
      } else if (mac) {
        result.mac = t;
      } else if (xbox) {
        result.xbox = t;
      } else if (windows) {
        result.windows = t;
      } else if (linux) {
        result.linux = t;
      }function getWindowsVersion(s) {
        switch (s) {case "NT":
            return "NT";case "XP":
            return "XP";case "NT 5.0":
            return "2000";case "NT 5.1":
            return "XP";case "NT 5.2":
            return "2003";case "NT 6.0":
            return "Vista";case "NT 6.1":
            return "7";case "NT 6.2":
            return "8";case "NT 6.3":
            return "8.1";case "NT 10.0":
            return "10";default:
            return undefined;}
      }var osVersion = "";if (result.windows) {
        osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
      } else if (result.windowsphone) {
        osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
      } else if (result.mac) {
        osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);osVersion = osVersion.replace(/[_\s]/g, ".");
      } else if (iosdevice) {
        osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);osVersion = osVersion.replace(/[_\s]/g, ".");
      } else if (android) {
        osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
      } else if (result.webos) {
        osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
      } else if (result.blackberry) {
        osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
      } else if (result.bada) {
        osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
      } else if (result.tizen) {
        osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
      }if (osVersion) {
        result.osversion = osVersion;
      }var osMajorVersion = !result.windows && osVersion.split(".")[0];if (tablet || nexusTablet || iosdevice == "ipad" || android && (osMajorVersion == 3 || osMajorVersion >= 4 && !mobile) || result.silk) {
        result.tablet = t;
      } else if (mobile || iosdevice == "iphone" || iosdevice == "ipod" || android || nexusMobile || result.blackberry || result.webos || result.bada) {
        result.mobile = t;
      }if (result.msedge || result.msie && result.version >= 10 || result.yandexbrowser && result.version >= 15 || result.vivaldi && result.version >= 1 || result.chrome && result.version >= 20 || result.samsungBrowser && result.version >= 4 || result.firefox && result.version >= 20 || result.safari && result.version >= 6 || result.opera && result.version >= 10 || result.ios && result.osversion && result.osversion.split(".")[0] >= 6 || result.blackberry && result.version >= 10.1 || result.chromium && result.version >= 20) {
        result.a = t;
      } else if (result.msie && result.version < 10 || result.chrome && result.version < 20 || result.firefox && result.version < 20 || result.safari && result.version < 6 || result.opera && result.version < 10 || result.ios && result.osversion && result.osversion.split(".")[0] < 6 || result.chromium && result.version < 20) {
        result.c = t;
      } else result.x = t;return result;
    }var bowser = detect(typeof navigator !== "undefined" ? navigator.userAgent || "" : "");bowser.test = function (browserList) {
      for (var i = 0; i < browserList.length; ++i) {
        var browserItem = browserList[i];if (typeof browserItem === "string") {
          if (browserItem in bowser) {
            return true;
          }
        }
      }return false;
    };function getVersionPrecision(version) {
      return version.split(".").length;
    }function map(arr, iterator) {
      var result = [],
          i;if (Array.prototype.map) {
        return Array.prototype.map.call(arr, iterator);
      }for (i = 0; i < arr.length; i++) {
        result.push(iterator(arr[i]));
      }return result;
    }function compareVersions(versions) {
      var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));var chunks = map(versions, function (version) {
        var delta = precision - getVersionPrecision(version);version = version + new Array(delta + 1).join(".0");return map(version.split("."), function (chunk) {
          return new Array(20 - chunk.length).join("0") + chunk;
        }).reverse();
      });while (--precision >= 0) {
        if (chunks[0][precision] > chunks[1][precision]) {
          return 1;
        } else if (chunks[0][precision] === chunks[1][precision]) {
          if (precision === 0) {
            return 0;
          }
        } else {
          return -1;
        }
      }
    }function isUnsupportedBrowser(minVersions, strictMode, ua) {
      var _bowser = bowser;if (typeof strictMode === "string") {
        ua = strictMode;strictMode = void 0;
      }if (strictMode === void 0) {
        strictMode = false;
      }if (ua) {
        _bowser = detect(ua);
      }var version = "" + _bowser.version;for (var browser in minVersions) {
        if (minVersions.hasOwnProperty(browser)) {
          if (_bowser[browser]) {
            if (typeof minVersions[browser] !== "string") {
              throw new Error("Browser version in the minVersion map should be a string: " + browser + ": " + String(minVersions));
            }return compareVersions([version, minVersions[browser]]) < 0;
          }
        }
      }return strictMode;
    }function check(minVersions, strictMode, ua) {
      return !isUnsupportedBrowser(minVersions, strictMode, ua);
    }bowser.isUnsupportedBrowser = isUnsupportedBrowser;bowser.compareVersions = compareVersions;bowser.check = check;bowser._detect = detect;return bowser;
  });
});var sparkMd5 = createCommonjsModule(function (module, exports) {
  (function (factory) {
    {
      module.exports = factory();
    }
  })(function (undefined) {
    "use strict";
    var add32 = function add32(a, b) {
      return a + b & 4294967295;
    },
        hex_chr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];function md5cycle(x, k) {
      var a = x[0],
          b = x[1],
          c = x[2],
          d = x[3];a += (b & c | ~b & d) + k[0] - 680876936 | 0;a = (a << 7 | a >>> 25) + b | 0;d += (a & b | ~a & c) + k[1] - 389564586 | 0;d = (d << 12 | d >>> 20) + a | 0;c += (d & a | ~d & b) + k[2] + 606105819 | 0;c = (c << 17 | c >>> 15) + d | 0;b += (c & d | ~c & a) + k[3] - 1044525330 | 0;b = (b << 22 | b >>> 10) + c | 0;a += (b & c | ~b & d) + k[4] - 176418897 | 0;a = (a << 7 | a >>> 25) + b | 0;d += (a & b | ~a & c) + k[5] + 1200080426 | 0;d = (d << 12 | d >>> 20) + a | 0;c += (d & a | ~d & b) + k[6] - 1473231341 | 0;c = (c << 17 | c >>> 15) + d | 0;b += (c & d | ~c & a) + k[7] - 45705983 | 0;b = (b << 22 | b >>> 10) + c | 0;a += (b & c | ~b & d) + k[8] + 1770035416 | 0;a = (a << 7 | a >>> 25) + b | 0;d += (a & b | ~a & c) + k[9] - 1958414417 | 0;d = (d << 12 | d >>> 20) + a | 0;c += (d & a | ~d & b) + k[10] - 42063 | 0;c = (c << 17 | c >>> 15) + d | 0;b += (c & d | ~c & a) + k[11] - 1990404162 | 0;b = (b << 22 | b >>> 10) + c | 0;a += (b & c | ~b & d) + k[12] + 1804603682 | 0;a = (a << 7 | a >>> 25) + b | 0;d += (a & b | ~a & c) + k[13] - 40341101 | 0;d = (d << 12 | d >>> 20) + a | 0;c += (d & a | ~d & b) + k[14] - 1502002290 | 0;c = (c << 17 | c >>> 15) + d | 0;b += (c & d | ~c & a) + k[15] + 1236535329 | 0;b = (b << 22 | b >>> 10) + c | 0;a += (b & d | c & ~d) + k[1] - 165796510 | 0;a = (a << 5 | a >>> 27) + b | 0;d += (a & c | b & ~c) + k[6] - 1069501632 | 0;d = (d << 9 | d >>> 23) + a | 0;c += (d & b | a & ~b) + k[11] + 643717713 | 0;c = (c << 14 | c >>> 18) + d | 0;b += (c & a | d & ~a) + k[0] - 373897302 | 0;b = (b << 20 | b >>> 12) + c | 0;a += (b & d | c & ~d) + k[5] - 701558691 | 0;a = (a << 5 | a >>> 27) + b | 0;d += (a & c | b & ~c) + k[10] + 38016083 | 0;d = (d << 9 | d >>> 23) + a | 0;c += (d & b | a & ~b) + k[15] - 660478335 | 0;c = (c << 14 | c >>> 18) + d | 0;b += (c & a | d & ~a) + k[4] - 405537848 | 0;b = (b << 20 | b >>> 12) + c | 0;a += (b & d | c & ~d) + k[9] + 568446438 | 0;a = (a << 5 | a >>> 27) + b | 0;d += (a & c | b & ~c) + k[14] - 1019803690 | 0;d = (d << 9 | d >>> 23) + a | 0;c += (d & b | a & ~b) + k[3] - 187363961 | 0;c = (c << 14 | c >>> 18) + d | 0;b += (c & a | d & ~a) + k[8] + 1163531501 | 0;b = (b << 20 | b >>> 12) + c | 0;a += (b & d | c & ~d) + k[13] - 1444681467 | 0;a = (a << 5 | a >>> 27) + b | 0;d += (a & c | b & ~c) + k[2] - 51403784 | 0;d = (d << 9 | d >>> 23) + a | 0;c += (d & b | a & ~b) + k[7] + 1735328473 | 0;c = (c << 14 | c >>> 18) + d | 0;b += (c & a | d & ~a) + k[12] - 1926607734 | 0;b = (b << 20 | b >>> 12) + c | 0;a += (b ^ c ^ d) + k[5] - 378558 | 0;a = (a << 4 | a >>> 28) + b | 0;d += (a ^ b ^ c) + k[8] - 2022574463 | 0;d = (d << 11 | d >>> 21) + a | 0;c += (d ^ a ^ b) + k[11] + 1839030562 | 0;c = (c << 16 | c >>> 16) + d | 0;b += (c ^ d ^ a) + k[14] - 35309556 | 0;b = (b << 23 | b >>> 9) + c | 0;a += (b ^ c ^ d) + k[1] - 1530992060 | 0;a = (a << 4 | a >>> 28) + b | 0;d += (a ^ b ^ c) + k[4] + 1272893353 | 0;d = (d << 11 | d >>> 21) + a | 0;c += (d ^ a ^ b) + k[7] - 155497632 | 0;c = (c << 16 | c >>> 16) + d | 0;b += (c ^ d ^ a) + k[10] - 1094730640 | 0;b = (b << 23 | b >>> 9) + c | 0;a += (b ^ c ^ d) + k[13] + 681279174 | 0;a = (a << 4 | a >>> 28) + b | 0;d += (a ^ b ^ c) + k[0] - 358537222 | 0;d = (d << 11 | d >>> 21) + a | 0;c += (d ^ a ^ b) + k[3] - 722521979 | 0;c = (c << 16 | c >>> 16) + d | 0;b += (c ^ d ^ a) + k[6] + 76029189 | 0;b = (b << 23 | b >>> 9) + c | 0;a += (b ^ c ^ d) + k[9] - 640364487 | 0;a = (a << 4 | a >>> 28) + b | 0;d += (a ^ b ^ c) + k[12] - 421815835 | 0;d = (d << 11 | d >>> 21) + a | 0;c += (d ^ a ^ b) + k[15] + 530742520 | 0;c = (c << 16 | c >>> 16) + d | 0;b += (c ^ d ^ a) + k[2] - 995338651 | 0;b = (b << 23 | b >>> 9) + c | 0;a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;a = (a << 6 | a >>> 26) + b | 0;d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;d = (d << 10 | d >>> 22) + a | 0;c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;c = (c << 15 | c >>> 17) + d | 0;b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;b = (b << 21 | b >>> 11) + c | 0;a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;a = (a << 6 | a >>> 26) + b | 0;d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;d = (d << 10 | d >>> 22) + a | 0;c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;c = (c << 15 | c >>> 17) + d | 0;b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;b = (b << 21 | b >>> 11) + c | 0;a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;a = (a << 6 | a >>> 26) + b | 0;d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;d = (d << 10 | d >>> 22) + a | 0;c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;c = (c << 15 | c >>> 17) + d | 0;b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;b = (b << 21 | b >>> 11) + c | 0;a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;a = (a << 6 | a >>> 26) + b | 0;d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;d = (d << 10 | d >>> 22) + a | 0;c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;c = (c << 15 | c >>> 17) + d | 0;b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;b = (b << 21 | b >>> 11) + c | 0;x[0] = a + x[0] | 0;x[1] = b + x[1] | 0;x[2] = c + x[2] | 0;x[3] = d + x[3] | 0;
    }function md5blk(s) {
      var md5blks = [],
          i;for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
      }return md5blks;
    }function md5blk_array(a) {
      var md5blks = [],
          i;for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
      }return md5blks;
    }function md51(s) {
      var n = s.length,
          state = [1732584193, -271733879, -1732584194, 271733878],
          i,
          length,
          tail,
          tmp,
          lo,
          hi;for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
      }s = s.substring(i - 64);length = s.length;tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
      }tail[i >> 2] |= 128 << (i % 4 << 3);if (i > 55) {
        md5cycle(state, tail);for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }tmp = n * 8;tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);lo = parseInt(tmp[2], 16);hi = parseInt(tmp[1], 16) || 0;tail[14] = lo;tail[15] = hi;md5cycle(state, tail);return state;
    }function md51_array(a) {
      var n = a.length,
          state = [1732584193, -271733879, -1732584194, 271733878],
          i,
          length,
          tail,
          tmp,
          lo,
          hi;for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
      }a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);length = a.length;tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= a[i] << (i % 4 << 3);
      }tail[i >> 2] |= 128 << (i % 4 << 3);if (i > 55) {
        md5cycle(state, tail);for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }tmp = n * 8;tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);lo = parseInt(tmp[2], 16);hi = parseInt(tmp[1], 16) || 0;tail[14] = lo;tail[15] = hi;md5cycle(state, tail);return state;
    }function rhex(n) {
      var s = "",
          j;for (j = 0; j < 4; j += 1) {
        s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
      }return s;
    }function hex(x) {
      var i;for (i = 0; i < x.length; i += 1) {
        x[i] = rhex(x[i]);
      }return x.join("");
    }if (hex(md51("hello")) !== "5d41402abc4b2a76b9719d911017c592") {
      add32 = function add32(x, y) {
        var lsw = (x & 65535) + (y & 65535),
            msw = (x >> 16) + (y >> 16) + (lsw >> 16);return msw << 16 | lsw & 65535;
      };
    }if (typeof ArrayBuffer !== "undefined" && !ArrayBuffer.prototype.slice) {
      (function () {
        function clamp(val, length) {
          val = val | 0 || 0;if (val < 0) {
            return Math.max(val + length, 0);
          }return Math.min(val, length);
        }ArrayBuffer.prototype.slice = function (from, to) {
          var length = this.byteLength,
              begin = clamp(from, length),
              end = length,
              num,
              target,
              targetArray,
              sourceArray;if (to !== undefined) {
            end = clamp(to, length);
          }if (begin > end) {
            return new ArrayBuffer(0);
          }num = end - begin;target = new ArrayBuffer(num);targetArray = new Uint8Array(target);sourceArray = new Uint8Array(this, begin, num);targetArray.set(sourceArray);return target;
        };
      })();
    }function toUtf8(str) {
      if (/[\u0080-\uFFFF]/.test(str)) {
        str = unescape(encodeURIComponent(str));
      }return str;
    }function utf8Str2ArrayBuffer(str, returnUInt8Array) {
      var length = str.length,
          buff = new ArrayBuffer(length),
          arr = new Uint8Array(buff),
          i;for (i = 0; i < length; i += 1) {
        arr[i] = str.charCodeAt(i);
      }return returnUInt8Array ? arr : buff;
    }function arrayBuffer2Utf8Str(buff) {
      return String.fromCharCode.apply(null, new Uint8Array(buff));
    }function concatenateArrayBuffers(first, second, returnUInt8Array) {
      var result = new Uint8Array(first.byteLength + second.byteLength);result.set(new Uint8Array(first));result.set(new Uint8Array(second), first.byteLength);return returnUInt8Array ? result : result.buffer;
    }function hexToBinaryString(hex) {
      var bytes = [],
          length = hex.length,
          x;for (x = 0; x < length - 1; x += 2) {
        bytes.push(parseInt(hex.substr(x, 2), 16));
      }return String.fromCharCode.apply(String, bytes);
    }function SparkMD5() {
      this.reset();
    }SparkMD5.prototype.append = function (str) {
      this.appendBinary(toUtf8(str));return this;
    };SparkMD5.prototype.appendBinary = function (contents) {
      this._buff += contents;this._length += contents.length;var length = this._buff.length,
          i;for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
      }this._buff = this._buff.substring(i - 64);return this;
    };SparkMD5.prototype.end = function (raw) {
      var buff = this._buff,
          length = buff.length,
          i,
          tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          ret;for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
      }this._finish(tail, length);ret = hex(this._hash);if (raw) {
        ret = hexToBinaryString(ret);
      }this.reset();return ret;
    };SparkMD5.prototype.reset = function () {
      this._buff = "";this._length = 0;this._hash = [1732584193, -271733879, -1732584194, 271733878];return this;
    };SparkMD5.prototype.getState = function () {
      return { buff: this._buff, length: this._length, hash: this._hash };
    };SparkMD5.prototype.setState = function (state) {
      this._buff = state.buff;this._length = state.length;this._hash = state.hash;return this;
    };SparkMD5.prototype.destroy = function () {
      delete this._hash;delete this._buff;delete this._length;
    };SparkMD5.prototype._finish = function (tail, length) {
      var i = length,
          tmp,
          lo,
          hi;tail[i >> 2] |= 128 << (i % 4 << 3);if (i > 55) {
        md5cycle(this._hash, tail);for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }tmp = this._length * 8;tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);lo = parseInt(tmp[2], 16);hi = parseInt(tmp[1], 16) || 0;tail[14] = lo;tail[15] = hi;md5cycle(this._hash, tail);
    };SparkMD5.hash = function (str, raw) {
      return SparkMD5.hashBinary(toUtf8(str), raw);
    };SparkMD5.hashBinary = function (content, raw) {
      var hash = md51(content),
          ret = hex(hash);return raw ? hexToBinaryString(ret) : ret;
    };SparkMD5.ArrayBuffer = function () {
      this.reset();
    };SparkMD5.ArrayBuffer.prototype.append = function (arr) {
      var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
          length = buff.length,
          i;this._length += arr.byteLength;for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
      }this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);return this;
    };SparkMD5.ArrayBuffer.prototype.end = function (raw) {
      var buff = this._buff,
          length = buff.length,
          tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          i,
          ret;for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff[i] << (i % 4 << 3);
      }this._finish(tail, length);ret = hex(this._hash);if (raw) {
        ret = hexToBinaryString(ret);
      }this.reset();return ret;
    };SparkMD5.ArrayBuffer.prototype.reset = function () {
      this._buff = new Uint8Array(0);this._length = 0;this._hash = [1732584193, -271733879, -1732584194, 271733878];return this;
    };SparkMD5.ArrayBuffer.prototype.getState = function () {
      var state = SparkMD5.prototype.getState.call(this);state.buff = arrayBuffer2Utf8Str(state.buff);return state;
    };SparkMD5.ArrayBuffer.prototype.setState = function (state) {
      state.buff = utf8Str2ArrayBuffer(state.buff, true);return SparkMD5.prototype.setState.call(this, state);
    };SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;SparkMD5.ArrayBuffer.hash = function (arr, raw) {
      var hash = md51_array(new Uint8Array(arr)),
          ret = hex(hash);return raw ? hexToBinaryString(ret) : ret;
    };return SparkMD5;
  });
});var index$5 = createCommonjsModule(function (module) {
  "use strict";
  module.exports = function (PromiseArgument) {
    var Promise;function throat(size, fn) {
      var queue = new Queue();function run(fn, self, args) {
        if (size) {
          size--;var result = new Promise(function (resolve) {
            resolve(fn.apply(self, args));
          });result.then(release, release);return result;
        } else {
          return new Promise(function (resolve) {
            queue.push(new Delayed(resolve, fn, self, args));
          });
        }
      }function release() {
        size++;if (!queue.isEmpty()) {
          var next = queue.shift();next.resolve(run(next.fn, next.self, next.args));
        }
      }if (typeof size === "function") {
        var temp = fn;fn = size;size = temp;
      }if (typeof size !== "number") {
        throw new TypeError("Expected throat size to be a number but got " + (typeof size === "undefined" ? "undefined" : _typeof2(size)));
      }if (fn !== undefined && typeof fn !== "function") {
        throw new TypeError("Expected throat fn to be a function but got " + (typeof fn === "undefined" ? "undefined" : _typeof2(fn)));
      }if (typeof fn === "function") {
        return function () {
          var args = [];for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }return run(fn, this, args);
        };
      } else {
        return function (fn) {
          if (typeof fn !== "function") {
            throw new TypeError("Expected throat fn to be a function but got " + (typeof fn === "undefined" ? "undefined" : _typeof2(fn)));
          }var args = [];for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
          }return run(fn, this, args);
        };
      }
    }if (arguments.length === 1 && typeof PromiseArgument === "function") {
      Promise = PromiseArgument;return throat;
    } else {
      Promise = module.exports.Promise;if (typeof Promise !== "function") {
        throw new Error("You must provide a Promise polyfill for this library to work in older environments");
      }return throat(arguments[0], arguments[1]);
    }
  };if (typeof Promise === "function") {
    module.exports.Promise = Promise;
  }function Delayed(resolve, fn, self, args) {
    this.resolve = resolve;this.fn = fn;this.self = self || null;this.args = args;
  }function Queue() {
    this._s1 = [];this._s2 = [];
  }Queue.prototype.push = function (value) {
    this._s1.push(value);
  };Queue.prototype.shift = function () {
    var s2 = this._s2;if (s2.length === 0) {
      var s1 = this._s1;if (s1.length === 0) {
        return;
      }this._s1 = s2;s2 = this._s2 = s1.reverse();
    }return s2.pop();
  };Queue.prototype.isEmpty = function () {
    return !this._s1.length && !this._s2.length;
  };
});var INFINITY = 1 / 0;var MAX_SAFE_INTEGER = 9007199254740991;var MAX_INTEGER = 1.7976931348623157e308;var NAN = 0 / 0;var funcTag = "[object Function]";var genTag = "[object GeneratorFunction]";var symbolTag = "[object Symbol]";var reTrim = /^\s+|\s+$/g;var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;var reIsBinary = /^0b[01]+$/i;var reIsOctal = /^0o[0-7]+$/i;var reIsUint = /^(?:0|[1-9]\d*)$/;var freeParseInt = parseInt;var objectProto = Object.prototype;var objectToString = objectProto.toString;var nativeCeil = Math.ceil;var nativeMax = Math.max;function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);while (length--) {
    result[fromRight ? length : ++index] = start;start += step;
  }return result;
}function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }start = toFinite(start);if (end === undefined) {
      end = start;start = 0;
    } else {
      end = toFinite(end);
    }step = step === undefined ? start < end ? 1 : -1 : toFinite(step);return baseRange(start, end, step, fromRight);
  };
}function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}function isIterateeCall(value, index, object) {
  if (!isObject$5(object)) {
    return false;
  }var type = typeof index === "undefined" ? "undefined" : _typeof2(index);if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
    return eq(object[index], value);
  }return false;
}function eq(value, other) {
  return value === other || value !== value && other !== other;
}function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$3(value);
}function isFunction$3(value) {
  var tag = isObject$5(value) ? objectToString.call(value) : "";return tag == funcTag || tag == genTag;
}function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}function isObject$5(value) {
  var type = typeof value === "undefined" ? "undefined" : _typeof2(value);return !!value && (type == "object" || type == "function");
}function isObjectLike(value) {
  return !!value && (typeof value === "undefined" ? "undefined" : _typeof2(value)) == "object";
}function isSymbol(value) {
  return (typeof value === "undefined" ? "undefined" : _typeof2(value)) == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }value = toNumber(value);if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;return sign * MAX_INTEGER;
  }return value === value ? value : 0;
}function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }if (isSymbol(value)) {
    return NAN;
  }if (isObject$5(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;value = isObject$5(other) ? other + "" : other;
  }if (typeof value != "string") {
    return value === 0 ? value : +value;
  }value = value.replace(reTrim, "");var isBinary = reIsBinary.test(value);return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}var range$1 = createRange();var index$6 = range$1;var FUNC_ERROR_TEXT = "Expected a function";var NAN$1 = 0 / 0;var symbolTag$1 = "[object Symbol]";var reTrim$1 = /^\s+|\s+$/g;var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;var reIsBinary$1 = /^0b[01]+$/i;var reIsOctal$1 = /^0o[0-7]+$/i;var freeParseInt$1 = parseInt;var freeGlobal = (typeof commonjsGlobal === "undefined" ? "undefined" : _typeof2(commonjsGlobal)) == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof2(self)) == "object" && self && self.Object === Object && self;var root = freeGlobal || freeSelf || Function("return this")();var objectProto$1 = Object.prototype;var objectToString$1 = objectProto$1.toString;var nativeMax$1 = Math.max;var nativeMin = Math.min;var now = function now() {
  return root.Date.now();
};function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }wait = toNumber$1(wait) || 0;if (isObject$6(options)) {
    leading = !!options.leading;maxing = "maxWait" in options;maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;trailing = "trailing" in options ? !!options.trailing : trailing;
  }function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;lastArgs = lastThis = undefined;lastInvokeTime = time;result = func.apply(thisArg, args);return result;
  }function leadingEdge(time) {
    lastInvokeTime = time;timerId = setTimeout(timerExpired, wait);return leading ? invokeFunc(time) : result;
  }function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }function timerExpired() {
    var time = now();if (shouldInvoke(time)) {
      return trailingEdge(time);
    }timerId = setTimeout(timerExpired, remainingWait(time));
  }function trailingEdge(time) {
    timerId = undefined;if (trailing && lastArgs) {
      return invokeFunc(time);
    }lastArgs = lastThis = undefined;return result;
  }function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }lastInvokeTime = 0;lastArgs = lastCallTime = lastThis = timerId = undefined;
  }function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);lastArgs = arguments;lastThis = this;lastCallTime = time;if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }if (maxing) {
        timerId = setTimeout(timerExpired, wait);return invokeFunc(lastCallTime);
      }
    }if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }return result;
  }debounced.cancel = cancel;debounced.flush = flush;return debounced;
}function throttle(func, wait, options) {
  var leading = true,
      trailing = true;if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }if (isObject$6(options)) {
    leading = "leading" in options ? !!options.leading : leading;trailing = "trailing" in options ? !!options.trailing : trailing;
  }return debounce(func, wait, { leading: leading, maxWait: wait, trailing: trailing });
}function isObject$6(value) {
  var type = typeof value === "undefined" ? "undefined" : _typeof2(value);return !!value && (type == "object" || type == "function");
}function isObjectLike$1(value) {
  return !!value && (typeof value === "undefined" ? "undefined" : _typeof2(value)) == "object";
}function isSymbol$1(value) {
  return (typeof value === "undefined" ? "undefined" : _typeof2(value)) == "symbol" || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }if (isSymbol$1(value)) {
    return NAN$1;
  }if (isObject$6(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;value = isObject$6(other) ? other + "" : other;
  }if (typeof value != "string") {
    return value === 0 ? value : +value;
  }value = value.replace(reTrim$1, "");var isBinary = reIsBinary$1.test(value);return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}var index$7 = throttle;var MIN_CHUNK_SIZE = 32 * 1024;var log$1 = logger.context("api-client");var https = function https(url) {
  return "https://" + url;
};var getLocationURL = function getLocationURL(url) {
  return url && https(url);
};var getName = function getName(file) {
  return file.customName || file.name;
};var isFile = function isFile(file) {
  return file.toString() === "[object File]";
};var isBlob = function isBlob(blob) {
  return isFile(blob) || blob.toString() === "[object Blob]";
};var b64toBlob = function b64toBlob(b64Data) {
  var sliceSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;var byteString = void 0;var contentType = "";if (b64Data.split(",")[0].indexOf("base64") >= 0) {
    byteString = b64Data.split(",")[1];
  }if (byteString !== undefined) {
    contentType = b64Data.split(",")[0].split(":")[1].split(";")[0];b64Data = decodeURI(byteString);
  }var byteCharacters = atob(b64Data);var byteArrays = [];for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);var byteNumbers = new Array(slice.length);for (var i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }var byteArray = new Uint8Array(byteNumbers);byteArrays.push(byteArray);
  }var blob = new Blob(byteArrays, { type: contentType });return blob;
};var getRange = function getRange(file, partNumber, cfg) {
  var start = partNumber * cfg.partSize;var end = Math.min(start + cfg.partSize, file.size);return { start: start, end: end };
};var sliceFile = function sliceFile(file, partNumber, cfg) {
  var slice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;var _getRange = getRange(file, partNumber, cfg),
      start = _getRange.start,
      end = _getRange.end;return slice.call(file, start, end);
};var slicePartIntoChunks = function slicePartIntoChunks(part, size) {
  var offset = 0;var chunks = [];var slice = ArrayBuffer.prototype.slice;while (offset < part.size) {
    var buf = slice.call(part.buffer, offset, offset + size);var chunk = { buf: buf, offset: offset, size: buf.byteLength, part: part };chunks.push(chunk);offset += size;
  }return chunks;
};var readFile = function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = void 0;if (window.File && window.FileReader && window.Blob) {
      reader = new FileReader();
    } else {
      reject(new Error("The File APIs are not fully supported by your browser"));
    }reader.onloadend = resolve;reader.onerror = reject;reader.readAsArrayBuffer(file);
  });
};var calcMD5 = function calcMD5(data) {
  return window.btoa(sparkMd5.ArrayBuffer.hash(data, true));
};var getFormData = function getFormData(fields, cfg) {
  var fd = new FormData();Object.keys(fields).forEach(function (key) {
    fd.append(key, fields[key]);
  });Object.keys(cfg.store).forEach(function (key) {
    fd.append(key, cfg.store[key]);
  });return fd;
};var start = function start(file, cfg) {
  var fields = { apikey: cfg.apikey, filename: getName(file), mimetype: file.type || "application/octet-stream", size: file.size };if (cfg.policy && cfg.signature) {
    fields.policy = cfg.policy;fields.signature = cfg.signature;
  }if (cfg.intelligent) {
    fields.multipart = true;
  }var formData = getFormData(fields, cfg);return requestWithSource("post", cfg.host + "/multipart/start").timeout(cfg.timeout).send(formData);
};var getS3PartData = function getS3PartData(startParams, part, size, md5, cfg, offset) {
  var host = cfg.debug ? cfg.host : getLocationURL(startParams.location_url) || cfg.host;var locationRegion = startParams.location_region;var fields = _extends$1({ apikey: cfg.apikey, part: part.number + 1, size: size, md5: md5 }, startParams);if (cfg.intelligent === true || part.intelligentOverride) {
    fields.multipart = true;fields.offset = offset;
  }var formData = getFormData(fields, cfg);return requestWithSource("post", host + "/multipart/upload").set("Filestack-Upload-Region", locationRegion).timeout(cfg.timeout).send(formData);
};var uploadToS3 = function uploadToS3(part, params, onProgress, cfg) {
  var host = cfg.fakeS3 ? cfg.host + "/fakeS3" : params.url;var timeout = Math.max(cfg.timeout, part.byteLength / 100);var req = client$1.put(host).set(params.headers).timeout(timeout).send(part);if (onProgress) {
    return req.on("progress", onProgress);
  }return req;
};var uploadChunk = function uploadChunk(chunk, startParams, cfg) {
  chunk.buf = new Uint8Array(chunk.buf);var md5 = calcMD5(chunk.buf);return getS3PartData(startParams, chunk.part, chunk.size, md5, cfg, chunk.offset).then(function (res) {
    var onProgress = void 0;if (cfg.onProgress) {
      onProgress = index$7(function (evt) {
        if (evt.loaded > 0) {
          chunk.loaded = evt.loaded;
        }
      }, cfg.progressInterval);
    }delete res.xhr;delete res.req;chunk.request = uploadToS3(chunk.buf, res.body, onProgress, cfg);return chunk.request;
  }).then(function (res) {
    delete chunk.buf;delete chunk.request;delete res.req;delete res.xhr;return res;
  });
};var commitPart = function commitPart(file, part, startParams, cfg) {
  var host = cfg.debug ? cfg.host : getLocationURL(startParams.location_url) || cfg.host;var fields = _extends$1({ apikey: cfg.apikey, part: part.number + 1, size: file.size }, startParams);var formData = getFormData(fields, cfg);return requestWithSource("post", host + "/multipart/commit").timeout(cfg.timeout).send(formData);
};var complete = function complete(file, parts, startParams, cfg) {
  var host = cfg.debug ? cfg.host : getLocationURL(startParams.location_url) || cfg.host;var locationRegion = startParams.location_region;var fields = _extends$1({ apikey: cfg.apikey, size: file.size, filename: file.customName || file.name, mimetype: file.type || "application/octet-stream", parts: parts }, startParams);if (cfg.intelligent) {
    fields.multipart = true;delete fields.parts;
  }var formData = getFormData(fields, cfg);return requestWithSource("post", host + "/multipart/complete").set("Filestack-Upload-Region", locationRegion).timeout(cfg.timeout).send(formData);
};var formatETags = function formatETags(etags) {
  return etags.map(function (tag, idx) {
    return idx + 1 + ":" + tag;
  }).join(";");
};var uploadFile = function uploadFile(file, cfg, token) {
  log$1("calling upload with config:", cfg, "file: ", file);var mkPart = function mkPart(num) {
    return { size: null, number: num, loaded: 0, request: null, intelligentOverride: false, chunks: [], chunkSize: cfg.intelligentChunkSize ? cfg.intelligentChunkSize : bowser.mobile ? 1 * 1024 * 1024 : 8 * 1024 * 1024 };
  };var state = { progressTick: null, paused: false, failed: false, done: false, retries: {} };var totalParts = Math.ceil(file.size / cfg.partSize);var allParts = index$6(0, totalParts).map(mkPart);var sumBytes = function sumBytes(bytes) {
    return bytes.reduce(function (a, b) {
      return a + b;
    }, 0);
  };var percentOfFile = function percentOfFile(bytes) {
    return Math.round(bytes / file.size * 100);
  };var startProgress = function startProgress() {
    if (cfg.onProgress) {
      state.progressTick = setInterval(function () {
        var partsLoaded = allParts.map(function (p) {
          return p.loaded;
        });var chunksLoaded = allParts.map(function (p) {
          return p.chunks;
        }).reduce(function (a, b) {
          return a.concat(b);
        }, []).map(function (c) {
          return c.loaded;
        }).filter(function (n) {
          return n;
        });var loaded = partsLoaded;if (cfg.intelligent === true) {
          loaded = chunksLoaded;
        }if (cfg.intelligent === "fallback") {
          var partsWithoutChunks = allParts.filter(function (p) {
            return !p.intelligentOverride;
          }).map(function (p) {
            return p.loaded;
          });loaded = partsWithoutChunks.concat(chunksLoaded);
        }var totalBytes = sumBytes(loaded);var totalPercent = percentOfFile(totalBytes);var payload = { totalBytes: totalBytes, totalPercent: totalPercent };var prev = state.previousPayload || {};if (totalPercent === 100) {
          clearInterval(state.progressTick);return;
        }if (totalPercent < prev.totalPercent) {
          payload.totalBytes = prev.totalBytes;payload.totalPercent = prev.totalPercent;
        }cfg.onProgress(payload);state.previousPayload = payload;
      }, cfg.progressInterval);
    }
  };var finishProgress = function finishProgress() {
    if (cfg.onProgress) {
      var totalBytes = file.size;var totalPercent = 100;var payload = { totalBytes: totalBytes, totalPercent: totalPercent };cfg.onProgress(payload);clearInterval(state.progressTick);
    }
  };token.pause = function () {
    if (!state.failed && !state.done && !state.paused) {
      log$1("Upload flow paused");state.paused = true;clearInterval(state.progressTick);
    }
  };token.resume = function () {
    if (!state.failed && !state.done && state.paused) {
      log$1("Upload flow resumed");state.paused = false;startProgress();
    }if (state.paused && state.done) {
      state.paused = false;finishProgress();
    }
  };var cancelAllRequests = function cancelAllRequests() {
    allParts.forEach(function (part) {
      if (part.request) part.request.abort();delete part.request;part.chunks.forEach(function (chunk) {
        if (chunk.request) chunk.request.abort();delete chunk.request;
      });
    });
  };var cancel = new Promise(function (resolve, reject) {
    token.cancel = function () {
      if (!state.failed && !state.done) {
        clearInterval(state.progressTick);cancelAllRequests();state.failed = true;reject(new Error("Upload cancelled"));
      }
    };
  });var flowControl = function flowControl(func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }if (state.failed) {
        return Promise.resolve();
      }if (state.paused) {
        return new Promise(function (resolve) {
          var check = function check() {
            if (state.paused) {
              setTimeout(function () {
                return check();
              }, 100);
            } else {
              resolve(func.apply(undefined, args));
            }
          };check();
        });
      }return func.apply(undefined, args);
    };
  };var retry = function retry(location, func, err) {
    var part = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};var attempt = state.retries[location] || 0;var waitTime = Math.min(cfg.retryMaxTime, Math.pow(cfg.retryFactor, attempt) * 1e3);var promise = new Promise(function (resolve, reject) {
      if (attempt === cfg.retry || state.failed || err.status === 400 && err.method !== "PUT" || err.status === 401 || err.status === 403 || err.status === 404 || part.chunkSize <= MIN_CHUNK_SIZE) {
        clearInterval(state.progressTick);state.failed = true;reject(new Error("Upload for " + getName(file) + " failed. " + err.message));
      } else {
        setTimeout(function () {
          if (state.failed) {
            resolve();
          } else if ((cfg.intelligent === true || part.intelligentOverride) && (err.crossDomain && err.method === "PUT" || err.status === 400 && err.method === "PUT" || err.timeout)) {
            if (part.chunkSize <= MIN_CHUNK_SIZE) {
              resolve();
            } else {
              part.chunkSize /= 2;if (cfg.onRetry) {
                cfg.onRetry({ location: location, parts: allParts, filename: getName(file), chunkSize: part.chunkSize });
              }resolve(func());
            }
          } else if (cfg.intelligent === "fallback" && (err.crossDomain && err.method === "PUT" || err.status === 400 && err.method === "PUT" || err.timeout)) {
            part.intelligentOverride = true;if (part.chunkSize === cfg.partSize) {
              part.chunkSize /= 2;
            }if (cfg.onRetry) {
              cfg.onRetry({ location: location, parts: allParts, filename: getName(file), chunkSize: part.chunkSize });
            }resolve(func());
          } else {
            attempt += 1;state.retries[location] = attempt;if (cfg.onRetry) {
              cfg.onRetry({ location: location, parts: allParts, filename: getName(file), attempt: attempt });
            }resolve(func());
          }
        }, waitTime);
      }
    });return Promise.race([cancel, promise]);
  };var sliceAndUpload = function sliceAndUpload(part, startParams) {
    var getPart = readFile(sliceFile(file, part.number, cfg)).then(function (evt) {
      part.buffer = cfg.intelligent === true || part.intelligentOverride ? evt.target.result : new Uint8Array(evt.target.result);part.size = part.buffer.byteLength;if (part.size === 0) {
        state.failed = true;return Promise.reject(new Error("Upload aborted due to empty chunk."));
      }return part;
    });if (cfg.intelligent === true || part.intelligentOverride) {
      return getPart.then(function (part) {
        var go = flowControl(function (chunk) {
          return uploadChunk(chunk, startParams, cfg);
        });part.chunks = slicePartIntoChunks(part, part.chunkSize);return Promise.race([cancel, Promise.all(part.chunks.map(index$5(cfg.concurrency, go)))]).then(function () {
          delete part.buffer;part.loaded = part.size;return commitPart(file, part, startParams, cfg).then(function (res) {
            if (res.status === 206) {
              return Promise.reject(new Error("FII chunks missing"));
            }return res;
          });
        });
      });
    }return getPart.then(function (part) {
      var md5 = calcMD5(part.buffer);part.request = getS3PartData(startParams, part, part.size, md5, cfg);return part.request;
    }).then(function (res) {
      var onProgress = void 0;if (cfg.onProgress) {
        onProgress = index$7(function (evt) {
          if (evt.loaded > 0) {
            part.loaded = evt.loaded;
          }
        }, cfg.progressInterval);
      }part.request = uploadToS3(part.buffer, res.body, onProgress, cfg);return part.request;
    }).then(function (res) {
      delete part.buffer;delete part.request;delete res.req;delete res.xhr;if (res.headers.etag === undefined) {
        state.failed = true;var msg = "Response from S3 is missing ETag header. Please expose it in your bucket CORS config.";return Promise.reject(new Error(msg));
      }return res;
    });
  };var startFlow = function startFlow() {
    return start(file, cfg).catch(function (err) {
      return retry("start", startFlow, err);
    });
  };return Promise.race([cancel, startFlow()]).then(function (res) {
    var startParams = res.body;startProgress();var go = flowControl(function (part) {
      return sliceAndUpload(part, startParams).catch(function (err) {
        part.loaded = 0;part.chunks = [];return retry("upload part " + (part.number + 1), function () {
          return go(part);
        }, err, part);
      });
    });var partsFlow = Promise.all(allParts.map(index$5(cfg.concurrency, go)));return Promise.race([cancel, partsFlow]).then(function (results) {
      var etags = void 0;if (cfg.intelligent !== true) {
        etags = formatETags(results.map(function (res) {
          return res.headers && res.headers.etag;
        }));
      }var go = flowControl(function () {
        return complete(file, etags, startParams, cfg).then(function (res) {
          if (res.status === 202) {
            return new Promise(function (resolve) {
              setTimeout(function () {
                return resolve(go());
              }, 1e3);
            });
          }state.done = true;if (!state.paused) finishProgress();return res.body;
        }).catch(function (err) {
          return retry("complete", go, err);
        });
      });return go();
    });
  });
};var upload = function upload(session, file) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var storeOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};var token = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};if (typeof file === "string") {
    file = b64toBlob(file);
  }if (!file || !isBlob(file)) {
    return Promise.reject(new TypeError("File parameter is not a valid Blob or File instance"));
  }if (file.size !== undefined && file.size === 0) {
    return Promise.reject(new Error("File has a size of 0."));
  }var allowedOptions = [{ name: "host", type: index$1$1.String }, { name: "partSize", type: index$1$1.Number }, { name: "concurrency", type: index$1$1.refinement(index$1$1.Integer, function (n) {
      return n > 0;
    }) }, { name: "onProgress", type: index$1$1.Function }, { name: "progressInterval", type: index$1$1.Integer }, { name: "onRetry", type: index$1$1.Function }, { name: "retry", type: index$1$1.Integer }, { name: "retryFactor", type: index$1$1.Integer }, { name: "retryMaxTime", type: index$1$1.Integer }, { name: "timeout", type: index$1$1.Integer }, { name: "debug", type: index$1$1.Bool }, { name: "intelligent", type: index$1$1.union([index$1$1.Bool, index$1$1.enums.of("fallback")]) }, { name: "intelligentChunkSize", type: index$1$1.Number }, { name: "fakeS3", type: index$1$1.Bool }];var allowedStoreOptions = [{ name: "location", type: index$1$1.enums.of("s3 gcs rackspace azure dropbox") }, { name: "region", type: index$1$1.String }, { name: "path", type: index$1$1.String }, { name: "container", type: index$1$1.String }, { name: "filename", type: index$1$1.String }, { name: "access", type: index$1$1.enums.of("public private") }];checkOptions("upload (options)", allowedOptions, options);checkOptions("upload (storeOptions)", allowedStoreOptions, storeOptions);if (storeOptions.filename) {
    file.customName = storeOptions.filename;
  } else if (file.name === undefined) {
    if (file.type) {
      var ext = file.type.split("/").pop();file.customName = "untitled." + ext;
    } else {
      file.customName = "untitled";
    }
  }delete storeOptions.filename;if (storeOptions.location === undefined) {
    storeOptions.location = "s3";
  }if (options.intelligent) {
    options.partSize = 8 * 1024 * 1024;
  }var snakeOpts = snakeKeys(storeOptions, "store");var config = _extends$1({ host: session.urls.uploadApiUrl, apikey: session.apikey, policy: session.policy, signature: session.signature, partSize: 6 * 1024 * 1024, concurrency: 3, onProgress: null, progressInterval: 1e3, onRetry: null, retry: 10, retryFactor: 2, retryMaxTime: 1e4, store: snakeOpts, timeout: 12e4, debug: false }, options);return uploadFile(file, config, token);
};var init$1 = function init(apikey, security, cname) {
  if (!apikey || typeof apikey !== "string") {
    throw new Error("apikey is required to initialize the Filestack client");
  }var getUrls = function getUrls() {
    var urls = ENV;if (cname) {
      Object.keys(ENV).forEach(function (key) {
        urls[key] = ENV[key].replace("filestackapi.com", cname);
      });
    }return urls;
  };var session = _extends$1({}, security, { apikey: apikey, urls: getUrls() });return { apikey: apikey, cname: cname, getSecurity: function getSecurity() {
      return { policy: session.policy, signature: session.signature };
    }, setSecurity: function setSecurity(sec) {
      if (sec && !(sec.policy && sec.signature)) {
        throw new Error("signature and policy are both required for security");
      }session.policy = sec.policy;session.signature = sec.signature;return session;
    }, storeURL: function storeURL$$1(url, uploadOptions, token) {
      return storeURL(session, url, uploadOptions, token);
    }, retrieve: function retrieve$$1(handle, uploadOptions) {
      return retrieve(session, handle, uploadOptions);
    }, remove: function remove$$1(handle, options) {
      return remove(session, handle, options);
    }, preview: function preview$$1(handle, options) {
      return preview(session, handle, options);
    }, overwrite: function overwrite$$1(handle, options) {
      return overwrite(session, handle, options);
    }, metadata: function metadata$$1(handle, options) {
      return metadata(session, handle, options);
    }, transform: function transform$$1(url, options) {
      return transform(session, url, options);
    }, upload: function upload$$1(file, options, storeOptions, token) {
      return upload(session, file, options, storeOptions, token);
    }, prefetch: function prefetch$$1() {
      return prefetch(session);
    }, cloud: function cloud() {
      return _cloud(session);
    } };
};var client = { version: "0.6.0", init: init$1 };var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};var initializeGlobalNamespace$1 = function initializeGlobalNamespace() {
  var namespace = void 0;if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") {
    namespace = window.filestackInternals;if (!namespace) {
      namespace = {};window.filestackInternals = namespace;
    }if (!namespace.loader) {
      namespace.loader = { modules: {} };
    }
  }return namespace;
};var filestackInternals = initializeGlobalNamespace$1();var modules = filestackInternals && filestackInternals.loader.modules;var loadModule = function loadModule(url, moduleId) {
  var moduleDefinition = modules[url];if (!moduleDefinition) {
    modules[url] = {};moduleDefinition = modules[url];
  }if (moduleDefinition.instance) {
    return Promise.resolve(moduleDefinition.instance);
  }if (moduleDefinition.promise) {
    return moduleDefinition.promise;
  }var promise = new Promise(function (resolve, reject) {
    var embedScript = function embedScript() {
      moduleDefinition.resolvePromise = resolve;var script = document.createElement("script");script.src = url;script.onerror = reject;if (moduleId) script.id = moduleId;document.body.appendChild(script);
    };var checkIfDomReady = function checkIfDomReady() {
      if (document.readyState === "complete") {
        embedScript();
      } else {
        setTimeout(checkIfDomReady, 50);
      }
    };checkIfDomReady();
  });moduleDefinition.promise = promise;return promise;
};var registerReadyModule = function registerReadyModule(instance, moduleId) {
  var thisScript = void 0;if (moduleId && document.getElementById(moduleId)) {
    thisScript = document.getElementById(moduleId);
  } else {
    var scriptTags = document.getElementsByTagName("script");thisScript = scriptTags[scriptTags.length - 1];
  }var url = thisScript.getAttribute("src");var moduleDefinition = modules[url];if (moduleDefinition && moduleDefinition.resolvePromise) {
    moduleDefinition.instance = instance;moduleDefinition.resolvePromise(instance);delete moduleDefinition.promise;delete moduleDefinition.resolvePromise;
  }
};var loadCss = function loadCss(url) {
  var alreadyAddedThisTag = document.querySelector('link[href="' + url + '"]');if (alreadyAddedThisTag !== null) {
    return Promise.resolve();
  }return new Promise(function (resolve) {
    var head = document.getElementsByTagName("head")[0];var link = document.createElement("link");var loaded = function loaded() {
      resolve();link.removeEventListener("load", loaded);
    };link.rel = "stylesheet";link.href = url;link.addEventListener("load", loaded);head.appendChild(link);
  });
};var knownModuleIds = { picker: "__filestack-picker-module" };var index$2 = { registerReadyModule: registerReadyModule, loadModule: loadModule, loadCss: loadCss, knownModuleIds: knownModuleIds };var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};var init = function init(apikey, security, cname) {
  var client$$1 = client.init(apikey, security, cname);var env = envGetter(cname);return { getSecurity: function getSecurity() {
      return client$$1.getSecurity();
    }, setSecurity: function setSecurity(sec) {
      return client$$1.setSecurity(sec);
    }, cropFiles: function cropFiles(_cropFiles, pickOptions) {
      var options = _extends({}, pickOptions, { cropFiles: _cropFiles });return index$2.loadModule(env.picker, index$2.knownModuleIds.picker).then(function (pickerConstructor) {
        return pickerConstructor(client$$1, options);
      });
    }, makeDropPane: function makeDropPane(dropPane, pickOptions) {
      var options = _extends({}, pickOptions, { dropPane: dropPane });index$2.loadModule(env.picker, index$2.knownModuleIds.picker).then(function (pickerConstructor) {
        pickerConstructor(client$$1, options);
      });
    }, pick: function pick(options) {
      return index$2.loadModule(env.picker, index$2.knownModuleIds.picker).then(function (pickerConstructor) {
        return pickerConstructor(client$$1, options);
      });
    }, storeURL: function storeURL(url, options) {
      return client$$1.storeURL(url, options);
    }, transform: function transform(url, options) {
      return client$$1.transform(url, options);
    }, upload: function upload(file, uploadOptions, storeOptions, token) {
      return client$$1.upload(file, uploadOptions, storeOptions, token);
    }, retrieve: function retrieve(handle, options) {
      return client$$1.retrieve(handle, options);
    }, remove: function remove(handle) {
      return client$$1.remove(handle);
    }, metadata: function metadata(handle, options) {
      return client$$1.metadata(handle, options);
    }, preview: function preview(handle, options) {
      return client$$1.preview(handle, options);
    }, logout: function logout() {
      return client$$1.cloud().logout();
    } };
};var index = { version: "0.11.1", init: init };/* harmony default export */ __webpack_exports__["a"] = (index);
//# sourceMappingURL=filestack.es2015.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var MutationTypes = Object.freeze({
  RANGE_ADD: 'RANGE_ADD',
  RANGE_DELETE: 'RANGE_DELETE',
  NODE_DELETE: 'NODE_DELETE',
  FIELDS_CHANGE: 'FIELDS_CHANGE',
  REQUIRED_CHILDREN: 'REQUIRED_CHILDREN'
});

var RangeOperations = Object.freeze({
  APPEND: 'append',
  IGNORE: 'ignore',
  PREPEND: 'prepend',
  REFETCH: 'refetch', // legacy only
  REMOVE: 'remove' // legacy only
});

// Unused in Relay Modern


// Unused in Relay Modern


function convert(configs, request, optimisticUpdater, updater) {
  var configOptimisticUpdates = optimisticUpdater ? [optimisticUpdater] : [];
  var configUpdates = updater ? [updater] : [];
  configs.forEach(function (config) {
    switch (config.type) {
      case 'NODE_DELETE':
        var nodeDeleteResult = nodeDelete(config, request);
        if (nodeDeleteResult) {
          configOptimisticUpdates.push(nodeDeleteResult);
          configUpdates.push(nodeDeleteResult);
        }
        break;
      case 'RANGE_ADD':
        var rangeAddResult = rangeAdd(config, request);
        if (rangeAddResult) {
          configOptimisticUpdates.push(rangeAddResult);
          configUpdates.push(rangeAddResult);
        }
        break;
      case 'RANGE_DELETE':
        var rangeDeleteResult = rangeDelete(config, request);
        if (rangeDeleteResult) {
          configOptimisticUpdates.push(rangeDeleteResult);
          configUpdates.push(rangeDeleteResult);
        }
        break;
    }
  });
  return {
    optimisticUpdater: function optimisticUpdater(store, data) {
      configOptimisticUpdates.forEach(function (eachOptimisticUpdater) {
        eachOptimisticUpdater(store, data);
      });
    },
    updater: function updater(store, data) {
      configUpdates.forEach(function (eachUpdater) {
        eachUpdater(store, data);
      });
    }
  };
}

function nodeDelete(config, request) {
  var deletedIDFieldName = config.deletedIDFieldName;

  var rootField = getRootField(request);
  if (!rootField) {
    return null;
  }
  return function (store, data) {
    var payload = store.getRootField(rootField);
    if (!payload) {
      return;
    }
    var deleteID = payload.getValue(deletedIDFieldName);
    var deleteIDs = Array.isArray(deleteID) ? deleteID : [deleteID];
    deleteIDs.forEach(function (id) {
      if (id && typeof id === 'string') {
        store['delete'](id);
      }
    });
  };
}

function rangeAdd(config, request) {
  var parentID = config.parentID,
      connectionInfo = config.connectionInfo,
      edgeName = config.edgeName;

  if (!parentID) {
     false ? require('fbjs/lib/warning')(false, 'RelayDeclarativeMutationConfig: For mutation config RANGE_ADD ' + 'to work you must include a parentID') : void 0;
    return null;
  }
  var rootField = getRootField(request);
  if (!connectionInfo || !rootField) {
    return null;
  }
  return function (store, data) {
    var parent = store.get(parentID);
    if (!parent) {
      return;
    }
    var payload = store.getRootField(rootField);
    if (!payload) {
      return;
    }
    var serverEdge = payload.getLinkedRecord(edgeName);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = connectionInfo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var info = _step.value;

        if (!serverEdge) {
          continue;
        }
        var connection = __webpack_require__(83).getConnection(parent, info.key, info.filters);
        if (!connection) {
          continue;
        }
        var clientEdge = __webpack_require__(83).buildConnectionEdge(store, connection, serverEdge);
        if (!clientEdge) {
          continue;
        }
        switch (info.rangeBehavior) {
          case 'append':
            __webpack_require__(83).insertEdgeAfter(connection, clientEdge);
            break;
          case 'ignore':
            // Do nothing
            break;
          case 'prepend':
            __webpack_require__(83).insertEdgeBefore(connection, clientEdge);
            break;
          default:
             false ? require('fbjs/lib/warning')(false, 'RelayDeclarativeMutationConfig: RANGE_ADD range behavior `%s` ' + 'will not work as expected in RelayModern, supported range ' + "behaviors are 'append', 'prepend', and 'ignore'.", info.rangeBehavior) : void 0;
            break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
}

function rangeDelete(config, request) {
  var parentID = config.parentID,
      connectionKeys = config.connectionKeys,
      pathToConnection = config.pathToConnection,
      deletedIDFieldName = config.deletedIDFieldName;

  if (!parentID) {
     false ? require('fbjs/lib/warning')(false, 'RelayDeclarativeMutationConfig: For mutation config RANGE_DELETE ' + 'to work you must include a parentID') : void 0;
    return null;
  }
  var rootField = getRootField(request);
  if (!rootField) {
    return null;
  }
  return function (store, data) {
    if (!data) {
      return;
    }
    var deleteIDs = [];
    var deletedIDField = data[rootField];
    if (deletedIDField && Array.isArray(deletedIDFieldName)) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = deletedIDFieldName[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var eachField = _step2.value;

          if (deletedIDField && (typeof deletedIDField === 'undefined' ? 'undefined' : _typeof(deletedIDField)) === 'object') {
            deletedIDField = deletedIDField[eachField];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (Array.isArray(deletedIDField)) {
        deletedIDField.forEach(function (idObject) {
          if (idObject && idObject.id && (typeof idObject === 'undefined' ? 'undefined' : _typeof(idObject)) === 'object' && typeof idObject.id === 'string') {
            deleteIDs.push(idObject.id);
          }
        });
      } else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') {
        deleteIDs.push(deletedIDField.id);
      }
    } else if (deletedIDField && typeof deletedIDFieldName === 'string' && (typeof deletedIDField === 'undefined' ? 'undefined' : _typeof(deletedIDField)) === 'object') {
      deletedIDField = deletedIDField[deletedIDFieldName];
      if (typeof deletedIDField === 'string') {
        deleteIDs.push(deletedIDField);
      } else if (Array.isArray(deletedIDField)) {
        deletedIDField.forEach(function (id) {
          if (typeof id === 'string') {
            deleteIDs.push(id);
          }
        });
      }
    }
    deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
  };
}

function deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
   false ? require('fbjs/lib/warning')(connectionKeys, 'RelayDeclarativeMutationConfig: RANGE_DELETE must provide a ' + 'connectionKeys') : void 0;
  var parent = store.get(parentID);
  if (!parent) {
    return;
  }
  if (pathToConnection.length < 2) {
     false ? require('fbjs/lib/warning')(false, 'RelayDeclarativeMutationConfig: RANGE_DELETE ' + 'pathToConnection must include at least parent and connection') : void 0;
    return;
  }
  var recordProxy = parent;
  for (var i = 1; i < pathToConnection.length - 1; i++) {
    if (recordProxy) {
      recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    }
  }
  // Should never enter loop except edge cases
  if (!connectionKeys || !recordProxy) {
     false ? require('fbjs/lib/warning')(false, 'RelayDeclarativeMutationConfig: RANGE_DELETE ' + 'pathToConnection is incorrect. Unable to find connection with ' + 'parentID: %s and path: %s', parentID, pathToConnection.toString()) : void 0;
    return;
  }
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    var _loop = function _loop() {
      var key = _step3.value;

      var connection = __webpack_require__(83).getConnection(recordProxy, key.key, key.filters);
      if (connection) {
        deleteIDs.forEach(function (deleteID) {
          __webpack_require__(83).deleteNode(connection, deleteID);
        });
      }
    };

    for (var _iterator3 = connectionKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}

function getRootField(request) {
  if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') {
    return request.fragment.selections[0].name;
  }
  return null;
}

module.exports = {
  MutationTypes: MutationTypes,
  RangeOperations: RangeOperations,

  convert: convert
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



function normalizeRelayPayload(selector, payload, errors) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { handleStrippedNulls: false };

  var source = new (__webpack_require__(115))();
  source.set(__webpack_require__(12).ROOT_ID, __webpack_require__(17).create(__webpack_require__(12).ROOT_ID, __webpack_require__(12).ROOT_TYPE));

  var _RelayResponseNormali = __webpack_require__(741).normalize(source, selector, payload, options),
      fieldPayloads = _RelayResponseNormali.fieldPayloads,
      deferrableSelections = _RelayResponseNormali.deferrableSelections;

  return {
    errors: errors,
    fieldPayloads: fieldPayloads,
    deferrableSelections: deferrableSelections,
    source: source
  };
}

module.exports = normalizeRelayPayload;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* jslint unused:false */

if (global.ErrorUtils) {
  module.exports = global.ErrorUtils;
} else {
  var ErrorUtils = {
    applyWithGuard: function applyWithGuard(callback, context, args, onError, name) {
      return callback.apply(context, args);
    },
    guard: function guard(callback, name) {
      return callback;
    }
  };

  module.exports = ErrorUtils;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254),
    getRawTag = __webpack_require__(2660),
    objectToString = __webpack_require__(2690);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(208),
    isLength = __webpack_require__(806);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3560);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./CardField.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./CardField.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1516);

var iterableToArray = __webpack_require__(1517);

var nonIterableSpread = __webpack_require__(1520);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(269);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(227)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(130);
var core = __webpack_require__(148);
var fails = __webpack_require__(227);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(1680);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(1681);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(888);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(889);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(1682);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(1692);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(1693);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(893);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(1684);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(1685);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(1686);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(1687);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(890);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(891);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(1688);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(1689);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(1690);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(1691);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(895);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(896);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(1694);
/* unused harmony reexport zip */




























/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab__ = __webpack_require__(1702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lab", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hcl", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lch", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "gray", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix__ = __webpack_require__(1701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cubehelix", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix__["a"]; });




/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var navigate = exports.navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};

var views = exports.views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function getComponentName(component) {
  return component.displayName || component.name || 'Component';
}

function getContainerName(Component) {
  return 'Relay(' + getComponentName(Component) + ')';
}

module.exports = {
  getComponentName: getComponentName,
  getContainerName: getContainerName
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(503);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var Position;
(function (Position) {
    Position[Position["TOP_LEFT"] = 0] = "TOP_LEFT";
    Position[Position["TOP"] = 1] = "TOP";
    Position[Position["TOP_RIGHT"] = 2] = "TOP_RIGHT";
    Position[Position["RIGHT_TOP"] = 3] = "RIGHT_TOP";
    Position[Position["RIGHT"] = 4] = "RIGHT";
    Position[Position["RIGHT_BOTTOM"] = 5] = "RIGHT_BOTTOM";
    Position[Position["BOTTOM_RIGHT"] = 6] = "BOTTOM_RIGHT";
    Position[Position["BOTTOM"] = 7] = "BOTTOM";
    Position[Position["BOTTOM_LEFT"] = 8] = "BOTTOM_LEFT";
    Position[Position["LEFT_BOTTOM"] = 9] = "LEFT_BOTTOM";
    Position[Position["LEFT"] = 10] = "LEFT";
    Position[Position["LEFT_TOP"] = 11] = "LEFT_TOP";
})(Position = exports.Position || (exports.Position = {}));
function isPositionHorizontal(position) {
    /* istanbul ignore next */
    return position === Position.TOP || position === Position.TOP_LEFT || position === Position.TOP_RIGHT || position === Position.BOTTOM || position === Position.BOTTOM_LEFT || position === Position.BOTTOM_RIGHT;
}
exports.isPositionHorizontal = isPositionHorizontal;
function isPositionVertical(position) {
    /* istanbul ignore next */
    return position === Position.LEFT || position === Position.LEFT_TOP || position === Position.LEFT_BOTTOM || position === Position.RIGHT || position === Position.RIGHT_TOP || position === Position.RIGHT_BOTTOM;
}
exports.isPositionVertical = isPositionVertical;

//# sourceMappingURL=position.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _iterator = __webpack_require__(395);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(306);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(216);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(192);
var IE8_DOM_DEFINE = __webpack_require__(869);
var toPrimitive = __webpack_require__(595);
var dP = Object.defineProperty;

exports.f = __webpack_require__(149) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  INIT: '@@farce/INIT',
  PUSH: '@@farce/PUSH',
  REPLACE: '@@farce/REPLACE',
  TRANSITION: '@@farce/TRANSITION',
  GO: '@@farce/GO',
  CREATE_HREF: '@@farce/CREATE_HREF',
  CREATE_LOCATION: '@@farce/CREATE_LOCATION',
  UPDATE_LOCATION: '@@farce/UPDATE_LOCATION',
  DISPOSE: '@@farce/DISPOSE'
};
module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(964);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(215);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Convenience class for creating normal routes with JSX. When not using JSX,
 * use a POJSO instead of this class.
 */
var Route = function Route(props) {
  (0, _classCallCheck3.default)(this, Route);

  (0, _assign2.default)(this, props);
};

exports.default = Route;

if (false) {
  // Workaround to make React Proxy give me the original class, to allow
  // makeRouteConfig to get the actual class, when using JSX for routes.
  Route.prototype.isReactComponent = {};
}
module.exports = exports["default"];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(993);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279),
    getRawTag = __webpack_require__(2113),
    objectToString = __webpack_require__(2143);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _propTypes = __webpack_require__(2329);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(2325);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
  decimalSeparator: _propTypes2.default.string,
  decimalScale: _propTypes2.default.number,
  fixedDecimalScale: _propTypes2.default.bool,
  displayType: _propTypes2.default.oneOf(['input', 'text']),
  prefix: _propTypes2.default.string,
  suffix: _propTypes2.default.string,
  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  removeFormatting: _propTypes2.default.func,
  mask: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  isNumericString: _propTypes2.default.bool,
  customInput: _propTypes2.default.func,
  allowNegative: _propTypes2.default.bool,
  onValueChange: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['text', 'tel']),
  isAllowed: _propTypes2.default.func,
  renderText: _propTypes2.default.func,
  getInputRef: _propTypes2.default.func
};

var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  isNumericString: false,
  type: 'text',
  onValueChange: _utils.noop,
  onChange: _utils.noop,
  onKeyDown: _utils.noop,
  onMouseUp: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  isAllowed: _utils.returnTrue,
  getInputRef: _utils.noop
};

var NumberFormat = function (_React$Component) {
  _inherits(NumberFormat, _React$Component);

  function NumberFormat(props) {
    _classCallCheck(this, NumberFormat);

    //validate props
    var _this = _possibleConstructorReturn(this, (NumberFormat.__proto__ || Object.getPrototypeOf(NumberFormat)).call(this, props));

    _this.validateProps();

    var formattedValue = _this.formatValueProp();

    _this.state = {
      value: formattedValue,
      numAsString: _this.removeFormatting(formattedValue)
    };

    _this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  _createClass(NumberFormat, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: 'updateValueIfRequired',
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state;

      if (prevProps !== props) {
        //validate props
        this.validateProps();

        var stateValue = state.value;

        var lastNumStr = state.numAsString || '';

        var formattedValue = props.value === undefined ? this.formatNumString(lastNumStr) : this.formatValueProp();

        if (formattedValue !== stateValue) {
          this.setState({
            value: formattedValue,
            numAsString: this.removeFormatting(formattedValue)
          });
        }
      }
    }

    /** Misc methods **/

  }, {
    key: 'getFloatString',
    value: function getFloatString() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _getSeparators = this.getSeparators(),
          decimalSeparator = _getSeparators.decimalSeparator;

      var numRegex = this.getNumberRegex(true);

      //remove negation for regex check
      var hasNegation = num[0] === '-';
      if (hasNegation) num = num.replace('-', '');

      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

      //remove extra decimals
      var firstDecimalIndex = num.indexOf('.');

      if (firstDecimalIndex !== -1) {
        num = num.substring(0, firstDecimalIndex) + '.' + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), '');
      }

      //add negation back
      if (hasNegation) num = '-' + num;

      return num;
    }

    //returned regex assumes decimalSeparator is as per prop

  }, {
    key: 'getNumberRegex',
    value: function getNumberRegex(g, ignoreDecimalSeparator) {
      var _props = this.props,
          format = _props.format,
          decimalScale = _props.decimalScale;

      var _getSeparators2 = this.getSeparators(),
          decimalSeparator = _getSeparators2.decimalSeparator;

      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
    }
  }, {
    key: 'getSeparators',
    value: function getSeparators() {
      var decimalSeparator = this.props.decimalSeparator;
      var thousandSeparator = this.props.thousandSeparator;

      if (thousandSeparator === true) {
        thousandSeparator = ',';
      }

      return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator
      };
    }
  }, {
    key: 'getMaskAtIndex',
    value: function getMaskAtIndex(index) {
      var _props$mask = this.props.mask,
          mask = _props$mask === undefined ? ' ' : _props$mask;

      if (typeof mask === 'string') {
        return mask;
      }

      return mask[index] || ' ';
    }
  }, {
    key: 'validateProps',
    value: function validateProps() {
      var mask = this.props.mask;

      //validate decimalSeparator and thousandSeparator

      var _getSeparators3 = this.getSeparators(),
          decimalSeparator = _getSeparators3.decimalSeparator,
          thousandSeparator = _getSeparators3.thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
      }

      //validate mask
      if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) {
          throw new Error('\n          Mask ' + mask + ' should not contain numeric character;\n        ');
        }
      }
    }
    /** Misc methods end **/

    /** caret specific methods **/

  }, {
    key: 'setPatchedCaretPosition',
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
      (0, _utils.setCaretPosition)(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
      }, 0);
    }

    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: 'correctCaretPosition',
    value: function correctCaretPosition(value, caretPos, direction) {
      var _props2 = this.props,
          prefix = _props2.prefix,
          suffix = _props2.suffix,
          format = _props2.format;

      //caret position should be between 0 and value length

      caretPos = (0, _utils.clamp)(caretPos, 0, value.length);

      //in case of format as number limit between prefix and suffix
      if (!format) {
        var hasNegation = value[0] === '-';
        return (0, _utils.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
      }

      //in case if custom format method don't do anything
      if (typeof format === 'function') return caretPos;

      /* in case format is string find the closest # position from the caret position */

      //in case the caretPos have input value on it don't do anything
      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos;

      //if caretPos is just after input value don't do anything
      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos;

      //find the nearest caret position
      var firstHashPosition = format.indexOf('#');
      var lastHashPosition = format.lastIndexOf('#');

      //limit the cursor between the first # position and the last # position
      caretPos = (0, _utils.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);

      var nextPos = format.substring(caretPos, format.length).indexOf('#');
      var caretLeftBound = caretPos;
      var caretRightBoud = caretPos + (nextPos === -1 ? 0 : nextPos);

      //get the position where the last number is present
      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
        caretLeftBound -= 1;
      }

      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBoud]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBoud - caretPos;

      return goToLeft ? caretLeftBound + 1 : caretRightBoud;
    }
  }, {
    key: 'getCaretPosition',
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      var format = this.props.format;

      var stateValue = this.state.value;
      var numRegex = this.getNumberRegex(true);
      var inputNumber = (inputValue.match(numRegex) || []).join('');
      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
      var j = void 0,
          i = void 0;

      j = 0;

      for (i = 0; i < caretPos; i++) {
        var currentInputChar = inputValue[i] || '';
        var currentFormatChar = formattedValue[j] || '';
        //no need to increase new cursor position if formatted value does not have those characters
        //case inputValue = 1a23 and formattedValue =  123
        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;

        //When we are striping out leading zeros maintain the new cursor position
        //Case inputValue = 00023 and formattedValue = 23;
        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue;

        //we are not using currentFormatChar because j can change here
        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
          j++;
        }j++;
      }

      if (typeof format === 'string' && !stateValue) {
        //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
      }

      //correct caret position if its outside of editable area
      j = this.correctCaretPosition(formattedValue, j);

      return j;
    }
    /** caret specific methods ends **/

    /** methods to remove formattting **/

  }, {
    key: 'removePrefixAndSuffix',
    value: function removePrefixAndSuffix(val) {
      var _props3 = this.props,
          format = _props3.format,
          prefix = _props3.prefix,
          suffix = _props3.suffix;

      //remove prefix and suffix

      if (!format && val) {
        var isNegative = val[0] === '-';

        //remove negation sign
        if (isNegative) val = val.substring(1, val.length);

        //remove prefix
        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

        //remove suffix
        var suffixLastIndex = val.lastIndexOf(suffix);
        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;

        //add negation sign back
        if (isNegative) val = '-' + val;
      }

      return val;
    }
  }, {
    key: 'removePatternFormatting',
    value: function removePatternFormatting(val) {
      var format = this.props.format;

      var formatArray = format.split('#').filter(function (str) {
        return str !== '';
      });
      var start = 0;
      var numStr = '';

      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
        var part = formatArray[i] || '';

        //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
        var index = i === ln ? val.length : val.indexOf(part, start);

        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */
        if (index === -1) {
          numStr = val;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.match(/\d/g) || []).join('');
    }
  }, {
    key: 'removeFormatting',
    value: function removeFormatting(val) {
      var _props4 = this.props,
          format = _props4.format,
          removeFormatting = _props4.removeFormatting;

      if (!val) return val;

      if (!format) {
        val = this.removePrefixAndSuffix(val);
        val = this.getFloatString(val);
      } else if (typeof format === 'string') {
        val = this.removePatternFormatting(val);
      } else if (typeof removeFormatting === 'function') {
        //condition need to be handled if format method is provide,
        val = removeFormatting(val);
      } else {
        val = (val.match(/\d/g) || []).join('');
      }
      return val;
    }
    /** methods to remove formattting end **/

    /*** format specific methods start ***/
    /**
     * Format when # based string is provided
     * @param  {string} numStr Numeric String
     * @return {string}        formatted Value
     */

  }, {
    key: 'formatWithPattern',
    value: function formatWithPattern(numStr) {
      var format = this.props.format;

      var hashCount = 0;
      var formattedNumberAry = format.split('');
      for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === '#') {
          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
          hashCount += 1;
        }
      }
      return formattedNumberAry.join('');
    }
    /**
     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
     * @return {string} formatted Value
     */

  }, {
    key: 'formatAsNumber',
    value: function formatAsNumber(numStr) {
      var _props5 = this.props,
          decimalScale = _props5.decimalScale,
          fixedDecimalScale = _props5.fixedDecimalScale,
          prefix = _props5.prefix,
          suffix = _props5.suffix,
          allowNegative = _props5.allowNegative;

      var _getSeparators4 = this.getSeparators(),
          thousandSeparator = _getSeparators4.thousandSeparator,
          decimalSeparator = _getSeparators4.decimalSeparator;

      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

      var _splitDecimal = (0, _utils.splitDecimal)(numStr, allowNegative),
          beforeDecimal = _splitDecimal.beforeDecimal,
          afterDecimal = _splitDecimal.afterDecimal,
          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const

      //apply decimal precision if its defined


      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

      if (thousandSeparator) {
        beforeDecimal = beforeDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
      }

      //add prefix and suffix
      if (prefix) beforeDecimal = prefix + beforeDecimal;
      if (suffix) afterDecimal = afterDecimal + suffix;

      //restore negation sign
      if (addNegation) beforeDecimal = '-' + beforeDecimal;

      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;

      return numStr;
    }
  }, {
    key: 'formatNumString',
    value: function formatNumString() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format;

      var formattedValue = value;

      if (value === '') {
        formattedValue = '';
      } else if (value === '-' && !format) {
        formattedValue = '-';
        value = '';
      } else if (typeof format === 'string') {
        formattedValue = this.formatWithPattern(formattedValue);
      } else if (typeof format === 'function') {
        formattedValue = format(formattedValue);
      } else {
        formattedValue = this.formatAsNumber(formattedValue);
      }

      return formattedValue;
    }
  }, {
    key: 'formatValueProp',
    value: function formatValueProp() {
      var _props6 = this.props,
          format = _props6.format,
          decimalScale = _props6.decimalScale,
          fixedDecimalScale = _props6.fixedDecimalScale;
      var _props7 = this.props,
          value = _props7.value,
          isNumericString = _props7.isNumericString;

      // if value is not defined return empty string

      if (value === undefined) return '';

      if (typeof value === 'number') {
        value = value.toString();
        isNumericString = true;
      }

      //round the number based on decimalScale
      //format only if non formatted value is provided
      if (isNumericString && !format && typeof decimalScale === 'number') {
        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
      }

      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

      return formattedValue;
    }
  }, {
    key: 'formatNegation',
    value: function formatNegation() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var allowNegative = this.props.allowNegative;

      var negationRegex = new RegExp('(-)');
      var doubleNegationRegex = new RegExp('(-)(.)*(-)');

      // Check number has '-' value
      var hasNegation = negationRegex.test(value);

      // Check number has 2 or more '-' values
      var removeNegation = doubleNegationRegex.test(value);

      //remove negation
      value = value.replace(/-/g, '');

      if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
      }

      return value;
    }
  }, {
    key: 'formatInput',
    value: function formatInput() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format;

      //format negation only if we are formatting as number

      if (!format) {
        value = this.formatNegation(value);
      }

      //remove formatting from number
      value = this.removeFormatting(value);

      return this.formatNumString(value);
    }

    /*** format specific methods end ***/

  }, {
    key: 'isCharacterAFormat',
    value: function isCharacterAFormat(caretPos, value) {
      var _props8 = this.props,
          format = _props8.format,
          prefix = _props8.prefix,
          suffix = _props8.suffix,
          decimalScale = _props8.decimalScale,
          fixedDecimalScale = _props8.fixedDecimalScale;

      var _getSeparators5 = this.getSeparators(),
          decimalSeparator = _getSeparators5.decimalSeparator;

      //check within format pattern


      if (typeof format === 'string' && format[caretPos] !== '#') return true;

      //check in number format
      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'checkIfFormatGotDeleted',
    value: function checkIfFormatGotDeleted(start, end, value) {
      for (var i = start; i < end; i++) {
        if (this.isCharacterAFormat(i, value)) return true;
      }
      return false;
    }

    /**
     * This will check if any formatting got removed by the delete or backspace and reset the value
     * It will also work as fallback if android chome keyDown handler does not work
     **/

  }, {
    key: 'correctInputValue',
    value: function correctInputValue(caretPos, lastValue, value) {
      var _props9 = this.props,
          format = _props9.format,
          decimalSeparator = _props9.decimalSeparator,
          allowNegative = _props9.allowNegative;

      var lastNumStr = this.state.numAsString || '';
      var _selectionBeforeInput = this.selectionBeforeInput,
          selectionStart = _selectionBeforeInput.selectionStart,
          selectionEnd = _selectionBeforeInput.selectionEnd;

      var _findChangedIndex = (0, _utils.findChangedIndex)(lastValue, value),
          start = _findChangedIndex.start,
          end = _findChangedIndex.end;

      /* don't do anyhting if something got added,
       or if value is empty string (when whole input is cleared)
       or whole input is replace with a number
      */

      if (value.length > lastValue.length || !value.length || start === end || start === 0 && end === lastValue.length || selectionStart === 0 && selectionEnd === lastValue.length) {
        return value;
      }

      //if format got deleted reset the value to last value
      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
        value = lastValue;
      }

      //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
      //clear all numbers in such case while keeping the - sign
      if (!format) {
        var numericString = this.removeFormatting(value);

        var _splitDecimal2 = (0, _utils.splitDecimal)(numericString, allowNegative),
            beforeDecimal = _splitDecimal2.beforeDecimal,
            afterDecimal = _splitDecimal2.afterDecimal,
            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const

        //clear only if something got deleted


        var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
        if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
          return addNegation ? '-' : '';
        }
      }

      return value;
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var isAllowed = props.isAllowed;

      var lastValue = state.value || '';

      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);

      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

      var formattedValue = this.formatInput(inputValue) || '';
      var numAsString = this.removeFormatting(formattedValue);

      var valueObj = {
        formattedValue: formattedValue,
        value: numAsString,
        floatValue: parseFloat(numAsString)
      };

      if (!isAllowed(valueObj)) {
        formattedValue = lastValue;
      }

      //set the value imperatively, this is required for IE fix
      el.value = formattedValue;

      //get the caret position
      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);

      //set caret position
      this.setPatchedCaretPosition(el, caretPos, formattedValue);

      //change the state
      if (formattedValue !== lastValue) {
        this.setState({ value: formattedValue, numAsString: numAsString }, function () {
          props.onValueChange(valueObj, e);
          props.onChange(e);
        });
      } else {
        props.onChange(e);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur;
      var numAsString = state.numAsString;

      var lastValue = state.value;
      if (!format) {
        numAsString = (0, _utils.fixLeadingZero)(numAsString);
        var formattedValue = this.formatNumString(numAsString);
        var valueObj = {
          formattedValue: formattedValue,
          value: numAsString,
          floatValue: parseFloat(numAsString)
        };

        //change the state
        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.setState({ value: formattedValue, numAsString: numAsString }, function () {
            props.onValueChange(valueObj, e);
            onBlur(e);
          });
          return;
        }
      }
      onBlur(e);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var el = e.target;
      var key = e.key;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          value = el.value;

      var expectedCaretPosition = void 0;
      var _props10 = this.props,
          decimalScale = _props10.decimalScale,
          fixedDecimalScale = _props10.fixedDecimalScale,
          prefix = _props10.prefix,
          suffix = _props10.suffix,
          format = _props10.format,
          onKeyDown = _props10.onKeyDown;

      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
      var negativeRegex = new RegExp('-');
      var isPatternFormat = typeof format === 'string';

      this.selectionBeforeInput = {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd

        //Handle backspace and delete against non numerical/decimal characters or arrow keys
      };if (key === 'ArrowLeft' || key === 'Backspace') {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === 'ArrowRight') {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === 'Delete') {
        expectedCaretPosition = selectionStart;
      }

      //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle
      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        var direction = key === 'ArrowLeft' ? 'left' : 'right';
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */
      if (e.isUnitTestRun) {
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }

    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: 'onMouseUp',
    value: function onMouseUp(e) {
      var el = e.target;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          value = el.value;

      if (selectionStart === selectionEnd) {
        var caretPostion = this.correctCaretPosition(value, selectionStart);
        if (caretPostion !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPostion, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      var _this2 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            value = el.value;

        var caretPosition = _this2.correctCaretPosition(value, selectionStart);
        if (caretPosition !== selectionStart) {
          _this2.setPatchedCaretPosition(el, caretPosition, value);
        }

        _this2.props.onFocus(e);
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props11 = this.props,
          type = _props11.type,
          displayType = _props11.displayType,
          customInput = _props11.customInput,
          renderText = _props11.renderText,
          getInputRef = _props11.getInputRef;
      var value = this.state.value;

      var otherProps = (0, _utils.omit)(this.props, propTypes);

      var inputProps = _extends({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === 'text') {
        return renderText ? renderText(value) || null : _react2.default.createElement('span', _extends({}, otherProps, { ref: getInputRef }), value);
      } else if (customInput) {
        var CustomInput = customInput;
        return _react2.default.createElement(CustomInput, inputProps);
      }

      return _react2.default.createElement('input', _extends({}, inputProps, {
        ref: getInputRef
      }));
    }
  }]);

  return NumberFormat;
}(_react2.default.Component);

NumberFormat.propTypes = propTypes;
NumberFormat.defaultProps = defaultProps;

module.exports = NumberFormat;

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__(2430);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _sidebar2.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1270);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Converts a FetchFunction into an ExecuteFunction for use by RelayNetwork.
 */

function convertFetch(fn) {
  return function fetch(request, variables, cacheConfig, uploadables) {
    var result = fn(request, variables, cacheConfig, uploadables);
    // Note: We allow FetchFunction to directly return Error to indicate
    // a failure to fetch. To avoid handling this special case throughout the
    // Relay codebase, it is explicitly handled here.
    if (result instanceof Error) {
      return __webpack_require__(176).create(function (sink) {
        return sink.error(result);
      });
    }
    return __webpack_require__(176).from(result).map(function (value) {
      return convertToExecutePayload(request, variables, value);
    });
  };
}

/**
 * Converts a SubscribeFunction into an ExecuteFunction for use by RelayNetwork.
 */
function convertSubscribe(fn) {
  return function subscribe(operation, variables, cacheConfig) {
    return __webpack_require__(176).fromLegacy(function (observer) {
      return fn(operation, variables, cacheConfig, observer);
    }).map(function (value) {
      return convertToExecutePayload(operation, variables, value);
    });
  };
}

/**
 * Given a value which might be a plain GraphQLResponse, coerce to always return
 * an ExecutePayload. A GraphQLResponse may be returned directly from older or
 * simpler Relay Network implementations.
 */
function convertToExecutePayload(request, variables, value) {
  if (!value.data && !value.errors && value.response) {
    if (!value.operation) {
       false ? require('fbjs/lib/warning')(false, 'ConvertToExecuteFunction: execute payload contains response but ' + 'is missing operation.') : void 0;
      return createExecutePayload(request, variables, value.response);
    }
    return value;
  }
  return createExecutePayload(request, variables, value);
}

function createExecutePayload(request, variables, response) {
  if (request.kind === __webpack_require__(18).BATCH_REQUEST) {
    throw new Error('ConvertToExecuteFunction: Batch request must return ExecutePayload.');
  }
  return { operation: request.operation, variables: variables, response: response };
}

module.exports = {
  convertFetch: convertFetch,
  convertSubscribe: convertSubscribe
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * A Subscription object is returned from .subscribe(), which can be
 * unsubscribed or checked to see if the resulting subscription has closed.
 */

/**
 * An Observer is an object of optional callback functions provided to
 * .subscribe(). Each callback function is invoked when that event occurs.
 */

/**
 * A Sink is an object of methods provided by Observable during construction.
 * The methods are to be called to trigger each event. It also contains a closed
 * field to see if the resulting subscription has closed.
 */

/**
 * A Source is the required argument when constructing a new Observable. Similar
 * to a Promise constructor, this is a function which is invoked with a Sink,
 * and may return either a cleanup function or a Subscription instance (for use
 * when composing Observables).
 */

/**
 * A Subscribable is an interface describing any object which can be subscribed.
 *
 * Note: A sink may be passed directly to .subscribe() as its observer,
 * allowing for easily composing Subscribables.
 */

// Note: This should accept Subscribable<T> instead of RelayObservable<T>,
// however Flow cannot yet distinguish it from T.
var hostReportError = swallowError;

/**
 * Limited implementation of ESObservable, providing the limited set of behavior
 * Relay networking requires.
 *
 * Observables retain the benefit of callbacks which can be called
 * synchronously, avoiding any UI jitter, while providing a compositional API,
 * which simplifies logic and prevents mishandling of errors compared to
 * the direct use of callback functions.
 *
 * ESObservable: https://github.com/tc39/proposal-observable
 */

var RelayObservable = function () {
  RelayObservable.create = function create(source) {
    return new RelayObservable(source);
  };

  // Use RelayObservable.create()


  function RelayObservable(source) {
    (0, _classCallCheck3['default'])(this, RelayObservable);

    if (false) {
      // Early runtime errors for ill-formed sources.
      if (!source || typeof source !== 'function') {
        throw new Error('Source must be a Function: ' + String(source));
      }
    }
    this._source = source;
  }

  /**
   * When an emitted error event is not handled by an Observer, it is reported
   * to the host environment (what the ESObservable spec refers to as
   * "HostReportErrors()").
   *
   * The default implementation in development rethrows thrown errors, and
   * logs emitted error events to the console, while in production does nothing
   * (swallowing unhandled errors).
   *
   * Called during application initialization, this method allows
   * application-specific handling of unhandled errors. Allowing, for example,
   * integration with error logging or developer tools.
   *
   * A second parameter `isUncaughtThrownError` is true when the unhandled error
   * was thrown within an Observer handler, and false when the unhandled error
   * was an unhandled emitted event.
   *
   *  - Uncaught thrown errors typically represent avoidable errors thrown from
   *    application code, which should be handled with a try/catch block, and
   *    usually have useful stack traces.
   *
   *  - Unhandled emitted event errors typically represent unavoidable events in
   *    application flow such as network failure, and may not have useful
   *    stack traces.
   */

  RelayObservable.onUnhandledError = function onUnhandledError(callback) {
    hostReportError = callback;
  };

  /**
   * Accepts various kinds of data sources, and always returns a RelayObservable
   * useful for accepting the result of a user-provided FetchFunction.
   */

  RelayObservable.from = function from(obj) {
    return isObservable(obj) ? fromObservable(obj) : __webpack_require__(749)(obj) ? fromPromise(obj) : fromValue(obj);
  };

  /**
   * Creates a RelayObservable, given a function which expects a legacy
   * Relay Observer as the last argument and which returns a Disposable.
   *
   * To support migration to Observable, the function may ignore the
   * legacy Relay observer and directly return an Observable instead.
   */

  RelayObservable.fromLegacy = function fromLegacy(callback) {
    return RelayObservable.create(function (sink) {
      var result = callback({
        onNext: sink.next,
        onError: sink.error,
        onCompleted: sink.complete
      });
      return isObservable(result) ? result.subscribe(sink) : function () {
        return result.dispose();
      };
    });
  };

  /**
   * Similar to promise.catch(), observable.catch() handles error events, and
   * provides an alternative observable to use in it's place.
   *
   * If the catch handler throws a new error, it will appear as an error event
   * on the resulting Observable.
   */

  RelayObservable.prototype['catch'] = function _catch(fn) {
    var _this = this;

    return RelayObservable.create(function (sink) {
      var subscription = void 0;
      _this.subscribe({
        start: function start(sub) {
          subscription = sub;
        },
        next: sink.next,
        complete: sink.complete,
        error: function (_error2) {
          function error(_x) {
            return _error2.apply(this, arguments);
          }

          error.toString = function () {
            return _error2.toString();
          };

          return error;
        }(function (error) {
          try {
            fn(error).subscribe({
              start: function start(sub) {
                subscription = sub;
              },
              next: sink.next,
              complete: sink.complete,
              error: sink.error
            });
          } catch (error2) {
            sink.error(error2, true /* isUncaughtThrownError */);
          }
        })
      });
      return function () {
        return subscription.unsubscribe();
      };
    });
  };

  /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the provided Observer is called to perform a side-effects
   * for all events emitted by the source.
   *
   * Any errors that are thrown in the side-effect Observer are unhandled, and
   * do not affect the source Observable or its Observer.
   *
   * This is useful for when debugging your Observables or performing other
   * side-effects such as logging or performance monitoring.
   */

  RelayObservable.prototype['do'] = function _do(observer) {
    var _this2 = this;

    return RelayObservable.create(function (sink) {
      var both = function both(action) {
        return function () {
          try {
            observer[action] && observer[action].apply(observer, arguments);
          } catch (error) {
            hostReportError(error, true /* isUncaughtThrownError */);
          }
          sink[action] && sink[action].apply(sink, arguments);
        };
      };
      return _this2.subscribe({
        start: both('start'),
        next: both('next'),
        error: both('error'),
        complete: both('complete'),
        unsubscribe: both('unsubscribe')
      });
    });
  };

  /**
   * Returns a new Observable which returns the same values as this one, but
   * modified so that the finally callback is performed after completion,
   * whether normal or due to error or unsubscription.
   *
   * This is useful for cleanup such as resource finalization.
   */

  RelayObservable.prototype['finally'] = function _finally(fn) {
    var _this3 = this;

    return RelayObservable.create(function (sink) {
      var subscription = _this3.subscribe(sink);
      return function () {
        subscription.unsubscribe();
        fn();
      };
    });
  };

  /**
   * Returns a new Observable which is identical to this one, unless this
   * Observable completes before yielding any values, in which case the new
   * Observable will yield the values from the alternate Observable.
   *
   * If this Observable does yield values, the alternate is never subscribed to.
   *
   * This is useful for scenarios where values may come from multiple sources
   * which should be tried in order, i.e. from a cache before a network.
   */

  RelayObservable.prototype.ifEmpty = function ifEmpty(alternate) {
    var _this4 = this;

    return RelayObservable.create(function (sink) {
      var hasValue = false;
      var current = _this4.subscribe({
        next: function next(value) {
          hasValue = true;
          sink.next(value);
        },

        error: sink.error,
        complete: function complete() {
          if (hasValue) {
            sink.complete();
          } else {
            current = alternate.subscribe(sink);
          }
        }
      });
      return function () {
        current.unsubscribe();
      };
    });
  };

  /**
   * Observable's primary API: returns an unsubscribable Subscription to the
   * source of this Observable.
   *
   * Note: A sink may be passed directly to .subscribe() as its observer,
   * allowing for easily composing Observables.
   */

  RelayObservable.prototype.subscribe = function subscribe(observer) {
    if (false) {
      // Early runtime errors for ill-formed observers.
      if (!observer || (typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
        throw new Error('Observer must be an Object with callbacks: ' + String(observer));
      }
    }
    return _subscribe(this._source, observer);
  };

  /**
   * Supports subscription of a legacy Relay Observer, returning a Disposable.
   */

  RelayObservable.prototype.subscribeLegacy = function subscribeLegacy(legacyObserver) {
    var subscription = this.subscribe({
      next: legacyObserver.onNext,
      error: legacyObserver.onError,
      complete: legacyObserver.onCompleted
    });
    return {
      dispose: subscription.unsubscribe
    };
  };

  /**
   * Returns a new Observerable where each value has been transformed by
   * the mapping function.
   */

  RelayObservable.prototype.map = function map(fn) {
    return this.mergeMap(function (value) {
      return fromValue(fn(value));
    });
  };

  /**
   * Returns a new Observable where each value is replaced with a new Observable
   * by the mapping function, the results of which returned as a single
   * merged Observable.
   */

  RelayObservable.prototype.mergeMap = function mergeMap(fn) {
    var _this5 = this;

    return RelayObservable.create(function (sink) {
      var subscriptions = [];

      function start(subscription) {
        this._sub = subscription;
        subscriptions.push(subscription);
      }

      function complete() {
        subscriptions.splice(subscriptions.indexOf(this._sub), 1);
        if (subscriptions.length === 0) {
          sink.complete();
        }
      }

      _this5.subscribe({
        start: start,
        next: function next(value) {
          try {
            if (!sink.closed) {
              RelayObservable.from(fn(value)).subscribe({
                start: start,
                next: sink.next,
                error: sink.error,
                complete: complete
              });
            }
          } catch (error) {
            sink.error(error, true /* isUncaughtThrownError */);
          }
        },

        error: sink.error,
        complete: complete
      });

      return function () {
        subscriptions.forEach(function (sub) {
          return sub.unsubscribe();
        });
        subscriptions.length = 0;
      };
    });
  };

  /**
   * Returns a new Observable which first mirrors this Observable, then when it
   * completes, waits for `pollInterval` milliseconds before re-subscribing to
   * this Observable again, looping in this manner until unsubscribed.
   *
   * The returned Observable never completes.
   */

  RelayObservable.prototype.poll = function poll(pollInterval) {
    var _this6 = this;

    if (false) {
      if (typeof pollInterval !== 'number' || pollInterval <= 0) {
        throw new Error('RelayObservable: Expected pollInterval to be positive, got: ' + pollInterval);
      }
    }
    return RelayObservable.create(function (sink) {
      var subscription = void 0;
      var timeout = void 0;
      var poll = function poll() {
        subscription = _this6.subscribe({
          next: sink.next,
          error: sink.error,
          complete: function complete() {
            timeout = setTimeout(poll, pollInterval);
          }
        });
      };
      poll();
      return function () {
        clearTimeout(timeout);
        subscription.unsubscribe();
      };
    });
  };

  /**
   * Returns a Promise which resolves when this Observable yields a first value
   * or when it completes with no value.
   */

  RelayObservable.prototype.toPromise = function toPromise() {
    var _this7 = this;

    return new Promise(function (resolve, reject) {
      var subscription = void 0;
      _this7.subscribe({
        start: function start(sub) {
          subscription = sub;
        },
        next: function next(val) {
          resolve(val);
          subscription.unsubscribe();
        },

        error: reject,
        complete: resolve
      });
    });
  };

  return RelayObservable;
}();

// Use declarations to teach Flow how to check isObservable.


function isObservable(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && typeof obj.subscribe === 'function';
}

function fromObservable(obj) {
  return obj instanceof RelayObservable ? obj : RelayObservable.create(function (sink) {
    return obj.subscribe(sink);
  });
}

function fromPromise(promise) {
  return RelayObservable.create(function (sink) {
    // Since sink methods do not throw, the resulting Promise can be ignored.
    promise.then(function (value) {
      sink.next(value);
      sink.complete();
    }, sink.error);
  });
}

function fromValue(value) {
  return RelayObservable.create(function (sink) {
    sink.next(value);
    sink.complete();
  });
}

function _subscribe(source, observer) {
  var closed = false;
  var cleanup = void 0;

  // Ideally we would simply describe a `get closed()` method on the Sink and
  // Subscription objects below, however not all flow environments we expect
  // Relay to be used within will support property getters, and many minifier
  // tools still do not support ES5 syntax. Instead, we can use defineProperty.
  var withClosed = function withClosed(obj) {
    return Object.defineProperty(obj, 'closed', { get: function get() {
        return closed;
      } });
  };

  function doCleanup() {
    if (cleanup) {
      if (cleanup.unsubscribe) {
        cleanup.unsubscribe();
      } else {
        try {
          cleanup();
        } catch (error) {
          hostReportError(error, true /* isUncaughtThrownError */);
        }
      }
      cleanup = undefined;
    }
  }

  // Create a Subscription.
  var subscription = withClosed({
    unsubscribe: function unsubscribe() {
      if (!closed) {
        closed = true;

        // Tell Observer that unsubscribe was called.
        try {
          observer.unsubscribe && observer.unsubscribe(subscription);
        } catch (error) {
          hostReportError(error, true /* isUncaughtThrownError */);
        } finally {
          doCleanup();
        }
      }
    }
  });

  // Tell Observer that observation is about to begin.
  try {
    observer.start && observer.start(subscription);
  } catch (error) {
    hostReportError(error, true /* isUncaughtThrownError */);
  }

  // If closed already, don't bother creating a Sink.
  if (closed) {
    return subscription;
  }

  // Create a Sink respecting subscription state and cleanup.
  var sink = withClosed({
    next: function next(value) {
      if (!closed && observer.next) {
        try {
          observer.next(value);
        } catch (error) {
          hostReportError(error, true /* isUncaughtThrownError */);
        }
      }
    },
    error: function (_error3) {
      function error(_x2, _x3) {
        return _error3.apply(this, arguments);
      }

      error.toString = function () {
        return _error3.toString();
      };

      return error;
    }(function (error, isUncaughtThrownError) {
      if (closed || !observer.error) {
        closed = true;
        hostReportError(error, isUncaughtThrownError || false);
        doCleanup();
      } else {
        closed = true;
        try {
          observer.error(error);
        } catch (error2) {
          hostReportError(error2, true /* isUncaughtThrownError */);
        } finally {
          doCleanup();
        }
      }
    }),
    complete: function complete() {
      if (!closed) {
        closed = true;
        try {
          observer.complete && observer.complete();
        } catch (error) {
          hostReportError(error, true /* isUncaughtThrownError */);
        } finally {
          doCleanup();
        }
      }
    }
  });

  // If anything goes wrong during observing the source, handle the error.
  try {
    cleanup = source(sink);
  } catch (error) {
    sink.error(error, true /* isUncaughtThrownError */);
  }

  if (false) {
    // Early runtime errors for ill-formed returned cleanup.
    if (cleanup !== undefined && typeof cleanup !== 'function' && (!cleanup || typeof cleanup.unsubscribe !== 'function')) {
      throw new Error('Returned cleanup function which cannot be called: ' + String(cleanup));
    }
  }

  // If closed before the source function existed, cleanup now.
  if (closed) {
    doCleanup();
  }

  return subscription;
}

function swallowError(_error, _isUncaughtThrownError) {
  // do nothing.
}

if (false) {
  // Default implementation of HostReportErrors() in development builds.
  // Can be replaced by the host application environment.
  RelayObservable.onUnhandledError(function (error, isUncaughtThrownError) {
    if (typeof fail === 'function') {
      // In test environments (Jest), fail() immediately fails the current test.
      fail(String(error));
    } else if (isUncaughtThrownError) {
      // Rethrow uncaught thrown errors on the next frame to avoid breaking
      // current logic.
      setTimeout(function () {
        throw error;
      });
    } else if (typeof console !== 'undefined') {
      // Otherwise, log the unhandled error for visibility.
      // eslint-disable-next-line no-console
      console.error('RelayObservable: Unhandled Error', error);
    }
  });
}

module.exports = RelayObservable;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @internal
 *
 * Wrapper API that is an amalgam of the `RelayModernRecord` API and
 * `MutableRecordSource` interface, implementing copy-on-write semantics for
 * records in a record source. If a `backup` is supplied, the mutator will
 * ensure that the backup contains sufficient information to revert all
 * modifications by publishing the backup.
 *
 * Modifications are applied to fresh copies of records with optional backups
 * created:
 * - Records in `base` are never modified.
 * - Modifications cause a fresh version of a record to be created in `sink`.
 *   These sink records contain only modified fields.
 * - If a `backup` is supplied, any modifications to a record will cause the
 *   sink version of the record to be added to the backup.
 * - Creation of a record causes a sentinel object to be added to the backup
 *   so that the new record can be removed from the store by publishing the
 *   backup.
 */
var RelayRecordSourceMutator = function () {
  function RelayRecordSourceMutator(base, sink, backup) {
    (0, _classCallCheck3['default'])(this, RelayRecordSourceMutator);

    this._backup = backup;
    this._base = base;
    this._sink = sink;
    this.__sources = [sink, base];
  }

  RelayRecordSourceMutator.prototype._createBackupRecord = function _createBackupRecord(dataID) {
    var backup = this._backup;
    if (backup && !backup.has(dataID)) {
      var baseRecord = this._base.get(dataID);
      if (baseRecord != null) {
        backup.set(dataID, baseRecord);
      } else if (baseRecord === null) {
        backup['delete'](dataID);
      }
    }
  };

  RelayRecordSourceMutator.prototype._setSentinelFieldsInBackupRecord = function _setSentinelFieldsInBackupRecord(dataID, record) {
    var backup = this._backup;
    if (backup) {
      var backupRecord = backup.get(dataID);
      if (backupRecord && backupRecord !== __webpack_require__(12).UNPUBLISH_RECORD_SENTINEL) {
        var copy = null;
        for (var key in record) {
          if (record.hasOwnProperty(key)) {
            if (!(key in backupRecord)) {
              copy = copy || (0, _extends3['default'])({}, backupRecord);
              copy[key] = __webpack_require__(12).UNPUBLISH_FIELD_SENTINEL;
            }
          }
        }
        backup.set(dataID, copy || backupRecord);
      }
    }
  };

  RelayRecordSourceMutator.prototype._setSentinelFieldInBackupRecord = function _setSentinelFieldInBackupRecord(dataID, storageKey) {
    var backup = this._backup;
    if (backup) {
      var backupRecord = backup.get(dataID);
      if (backupRecord && backupRecord !== __webpack_require__(12).UNPUBLISH_RECORD_SENTINEL && !(storageKey in backupRecord)) {
        var copy = (0, _extends3['default'])({}, backupRecord);
        __webpack_require__(17).setValue(copy, storageKey, __webpack_require__(12).UNPUBLISH_FIELD_SENTINEL);
        backup.set(dataID, copy);
      }
    }
  };

  RelayRecordSourceMutator.prototype._getSinkRecord = function _getSinkRecord(dataID) {
    var sinkRecord = this._sink.get(dataID);
    if (!sinkRecord) {
      var baseRecord = this._base.get(dataID);
      !baseRecord ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceMutator: Cannot modify non-existent record `%s`.', dataID) : __webpack_require__(10)(false) : void 0;
      sinkRecord = __webpack_require__(17).create(dataID, __webpack_require__(17).getType(baseRecord));
      this._sink.set(dataID, sinkRecord);
    }
    return sinkRecord;
  };

  RelayRecordSourceMutator.prototype.copyFields = function copyFields(sourceID, sinkID) {
    var sinkSource = this._sink.get(sourceID);
    var baseSource = this._base.get(sourceID);
    !(sinkSource || baseSource) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceMutator#copyFields(): Cannot copy fields from ' + 'non-existent record `%s`.', sourceID) : __webpack_require__(10)(false) : void 0;
    this._createBackupRecord(sinkID);
    var sink = this._getSinkRecord(sinkID);
    if (baseSource) {
      __webpack_require__(17).copyFields(baseSource, sink);
    }
    if (sinkSource) {
      __webpack_require__(17).copyFields(sinkSource, sink);
    }
    this._setSentinelFieldsInBackupRecord(sinkID, sink);
  };

  RelayRecordSourceMutator.prototype.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
    this.copyFields(__webpack_require__(17).getDataID(record), sinkID);
    var sink = this._getSinkRecord(sinkID);
    __webpack_require__(17).copyFields(record, sink);
    this._setSentinelFieldsInBackupRecord(sinkID, sink);
  };

  RelayRecordSourceMutator.prototype.create = function create(dataID, typeName) {
    !(this._base.getStatus(dataID) !== __webpack_require__(49).EXISTENT && this._sink.getStatus(dataID) !== __webpack_require__(49).EXISTENT) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceMutator#create(): Cannot create a record with id ' + '`%s`, this record already exists.', dataID) : __webpack_require__(10)(false) : void 0;
    if (this._backup) {
      this._backup.set(dataID, __webpack_require__(12).UNPUBLISH_RECORD_SENTINEL);
    }
    var record = __webpack_require__(17).create(dataID, typeName);
    this._sink.set(dataID, record);
  };

  RelayRecordSourceMutator.prototype['delete'] = function _delete(dataID) {
    this._createBackupRecord(dataID);
    this._sink['delete'](dataID);
  };

  RelayRecordSourceMutator.prototype.getStatus = function getStatus(dataID) {
    return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
  };

  RelayRecordSourceMutator.prototype.getType = function getType(dataID) {
    for (var ii = 0; ii < this.__sources.length; ii++) {
      var record = this.__sources[ii].get(dataID);
      if (record) {
        return __webpack_require__(17).getType(record);
      } else if (record === null) {
        return null;
      }
    }
  };

  RelayRecordSourceMutator.prototype.getValue = function getValue(dataID, storageKey) {
    for (var ii = 0; ii < this.__sources.length; ii++) {
      var record = this.__sources[ii].get(dataID);
      if (record) {
        var value = __webpack_require__(17).getValue(record, storageKey);
        if (value !== undefined) {
          return value;
        }
      } else if (record === null) {
        return null;
      }
    }
  };

  RelayRecordSourceMutator.prototype.setValue = function setValue(dataID, storageKey, value) {
    this._createBackupRecord(dataID);
    var sinkRecord = this._getSinkRecord(dataID);
    __webpack_require__(17).setValue(sinkRecord, storageKey, value);
    this._setSentinelFieldInBackupRecord(dataID, storageKey);
  };

  RelayRecordSourceMutator.prototype.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
    for (var ii = 0; ii < this.__sources.length; ii++) {
      var record = this.__sources[ii].get(dataID);
      if (record) {
        var linkedID = __webpack_require__(17).getLinkedRecordID(record, storageKey);
        if (linkedID !== undefined) {
          return linkedID;
        }
      } else if (record === null) {
        return null;
      }
    }
  };

  RelayRecordSourceMutator.prototype.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
    this._createBackupRecord(dataID);
    var sinkRecord = this._getSinkRecord(dataID);
    __webpack_require__(17).setLinkedRecordID(sinkRecord, storageKey, linkedID);
    this._setSentinelFieldInBackupRecord(dataID, storageKey);
  };

  RelayRecordSourceMutator.prototype.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
    for (var ii = 0; ii < this.__sources.length; ii++) {
      var record = this.__sources[ii].get(dataID);
      if (record) {
        var linkedIDs = __webpack_require__(17).getLinkedRecordIDs(record, storageKey);
        if (linkedIDs !== undefined) {
          return linkedIDs;
        }
      } else if (record === null) {
        return null;
      }
    }
  };

  RelayRecordSourceMutator.prototype.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
    this._createBackupRecord(dataID);
    var sinkRecord = this._getSinkRecord(dataID);
    __webpack_require__(17).setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    this._setSentinelFieldInBackupRecord(dataID, storageKey);
  };

  return RelayRecordSourceMutator;
}();

module.exports = RelayRecordSourceMutator;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Creates a copy of the provided value, ensuring any nested objects have their
 * keys sorted such that equivalent values would have identical JSON.stringify
 * results.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function stableCopy(value) {
  if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(stableCopy);
  }
  var keys = Object.keys(value).sort();
  var stable = {};
  for (var i = 0; i < keys.length; i++) {
    stable[keys[i]] = stableCopy(value[keys[i]]);
  }
  return stable;
}

module.exports = stableCopy;

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Checkbox__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_Radio__ = __webpack_require__(759);










/**
 * A field is a form element containing a label and an input.
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */

function FormField(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      control = props.control,
      disabled = props.disabled,
      error = props.error,
      inline = props.inline,
      label = props.label,
      required = props.required,
      type = props.type,
      width = props.width;
  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(required, 'required'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["f" /* useWidthProp */])(width, 'wide'), 'field', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(FormField, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(FormField, props); // ----------------------------------------
  // No Control
  // ----------------------------------------

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(control)) {
    if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(label)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["D" /* createHTMLLabel */])(label, {
      autoGenerateKey: false
    }));
  } // ----------------------------------------
  // Checkbox/Radio Control
  // ----------------------------------------


  var controlProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, rest, {
    content: content,
    children: children,
    disabled: disabled,
    required: required,
    type: type // wrap HTML checkboxes/radios in the label

  });

  if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
      className: classes
    }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("label", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, controlProps), " ", label));
  } // pass label prop to controls that support it


  if (control === __WEBPACK_IMPORTED_MODULE_8__modules_Checkbox__["a" /* default */] || control === __WEBPACK_IMPORTED_MODULE_9__addons_Radio__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
      className: classes
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, controlProps, {
      label: label
    })));
  } // ----------------------------------------
  // Other Control
  // ----------------------------------------


  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
    className: classes
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["D" /* createHTMLLabel */])(label, {
    defaultProps: {
      htmlFor: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(controlProps, 'id')
    },
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, controlProps));
}

FormField.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "inline", "label", "required", "type", "width"];
FormField.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
   * Extra FormField props are passed to the control component.
   * Mutually exclusive with children.
   */
  control: customPropTypes.some([PropTypes.func, PropTypes.oneOf(['button', 'input', 'select', 'textarea'])]),

  /** Individual fields may be disabled. */
  disabled: PropTypes.bool,

  /** Individual fields may display an error state. */
  error: PropTypes.bool,

  /** A field can have its label next to instead of above it. */
  inline: PropTypes.bool,
  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`

  /** Mutually exclusive with children. */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A field can show that input is mandatory. */
  required: PropTypes.bool,

  /** Passed to the control component (i.e. <input type='password' />) */
  type: customPropTypes.every([customPropTypes.demand(['control'])]),

  /** A field can specify its width in grid columns */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(808);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

module.exports = toInteger;

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var NotFound = function NotFound(_ref) {
  var viewer = _ref.viewer;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'center', marginTop: '120px', fontSize: '1rem' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      null,
      'Page not found'
    ),
    !viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'You may need to ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: '/login' },
        'log in'
      ),
      ' to see this page'
    )
  );
};

NotFound.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_scss__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */






var OptionsMenu = function (_Component) {
  _inherits(OptionsMenu, _Component);

  function OptionsMenu(props) {
    _classCallCheck(this, OptionsMenu);

    var _this = _possibleConstructorReturn(this, (OptionsMenu.__proto__ || Object.getPrototypeOf(OptionsMenu)).call(this, props));

    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.transition = _this.transition.bind(_this);
    return _this;
  }

  _createClass(OptionsMenu, [{
    key: 'getHelp',
    value: function getHelp() {
      // eslint-disable-next-line new-cap
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'transition',
    value: function transition(e) {
      e.preventDefault();
      this.props.router.push(e.target.getAttribute('to') || '/');
    }
  }, {
    key: 'render',
    value: function render() {
      var viewer = this.props.viewer;

      var name = (viewer ? viewer.first_name : '') + ' ' + (viewer ? viewer.last_name : '');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */],
        _defineProperty({
          floating: true,
          icon: 'angle down',
          labeled: true,
          className: 'icon basic',
          text: name
        }, 'className', __WEBPACK_IMPORTED_MODULE_4__App_scss___default.a.grey),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Menu,
          { style: { left: 'auto', right: 0, minWidth: '120px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
            { onClick: this.transition, to: '/templates' },
            'Templates'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
            { onClick: this.transition, to: '/leads' },
            'Lead Capture'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Divider, null),
          (typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
            { onClick: this.getHelp },
            'Help'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
            { onClick: this.transition, to: '/settings' },
            'Settings'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
            { onClick: this.signOut },
            'Sign Out'
          )
        )
      );
    }
  }]);

  return OptionsMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

OptionsMenu.propTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (OptionsMenu);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_logo_png__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */







var Sidebar = function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.transition = _this.transition.bind(_this);
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'getHelp',
    value: function getHelp() {
      // eslint-disable-next-line new-cap
      if (Intercom) Intercom('show');
    }
  }, {
    key: 'transition',
    value: function transition(e) {
      e.preventDefault();
      this.props.router.push(e.target.getAttribute('to') || '/');
      if (this.props.setSidebarOpenState) this.props.setSidebarOpenState(false);
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          style: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%',
            padding: '5em 1.6em 1em 1.6em'
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { flex: 1 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { to: '/', onClick: this.transition },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["e" /* Image */], { src: __WEBPACK_IMPORTED_MODULE_2__assets_logo_png___default.a, className: __WEBPACK_IMPORTED_MODULE_4__App_scss___default.a.logo })
          ),
          this.props.viewer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["o" /* Menu */],
              { text: true, vertical: true, className: __WEBPACK_IMPORTED_MODULE_4__App_scss___default.a.sidebar },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  to: '/',
                  className: ['item', location.pathname.match(/^\/$/) ? 'active' : ''].join(' '),
                  onClick: this.transition
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'folder outline' }),
                '\xA0 All Events'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  to: '/calendar',
                  className: ['item', location.pathname.match(/^\/calendar$/) ? 'active' : ''].join(' '),
                  onClick: this.transition
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'calendar alternate outline' }),
                '\xA0 Calendar'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  to: '/pipelines',
                  className: ['item', location.pathname.match(/^\/pipelines$/) ? 'active' : ''].join(' '),
                  onClick: this.transition
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'arrow alternate circle right outline' }),
                '\xA0 Pipeline'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  to: '/financials',
                  onClick: this.transition,
                  className: ['item', location.pathname.match(/^\/financials(\/(.)*)?$/) ? 'active' : ''].join(' ')
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'dollar' }),
                '\xA0 Financials'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: ['item', location.pathname.match(/^\/leads(\/(.)*)?$/) ? 'active' : ''].join(' '),
                  to: '/leads',
                  onClick: this.transition
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'code' }),
                '\xA0 Lead Capture'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: ['item', location.pathname.match(/^\/templates(\/(.)*)?$/) ? 'active' : ''].join(' '),
                  to: '/templates',
                  onClick: this.transition
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy' }),
                '\xA0 Templates'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
              primary: true,
              content: 'Add Event',
              fluid: true,
              style: { marginTop: '2em' },
              to: '/events/new',
              onClick: this.transition
            })
          ),
          !this.props.viewer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["o" /* Menu */],
            { text: true, vertical: true, className: __WEBPACK_IMPORTED_MODULE_4__App_scss___default.a.sidebar },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["o" /* Menu */].Item,
              { href: '/login' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'sign in' }),
              '\xA0 Sign In'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["o" /* Menu */],
            { vertical: true, text: true, className: __WEBPACK_IMPORTED_MODULE_4__App_scss___default.a.sidebar },
            this.props.viewer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.getHelp },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'help circle' }),
                '\xA0 Help'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', to: '/settings', onClick: this.transition },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'setting' }),
                '\xA0 Settings'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.signOut },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'sign out' }),
                '\xA0 Sign Out'
              )
            )
          )
        )
      );
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Sidebar.propTypes = {
  setSidebarOpenState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1515);

var iterableToArrayLimit = __webpack_require__(1518);

var nonIterableRest = __webpack_require__(1519);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(92));
__export(__webpack_require__(1525));
__export(__webpack_require__(835));
__export(__webpack_require__(157));
__export(__webpack_require__(265));
__export(__webpack_require__(836));
var classes = __webpack_require__(37);
var keys = __webpack_require__(187);
var utils = __webpack_require__(53);
exports.Classes = classes;
exports.Keys = keys;
exports.Utils = utils;
// NOTE: Errors is not exported in public API
var iconClasses_1 = __webpack_require__(1555);
exports.IconClasses = iconClasses_1.IconClasses;
var iconStrings_1 = __webpack_require__(1556);
exports.IconContents = iconStrings_1.IconContents;

//# sourceMappingURL=index.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKSPACE = 8;
exports.TAB = 9;
exports.ENTER = 13;
exports.SHIFT = 16;
exports.ESCAPE = 27;
exports.SPACE = 32;
exports.ARROW_LEFT = 37;
exports.ARROW_UP = 38;
exports.ARROW_RIGHT = 39;
exports.ARROW_DOWN = 40;
exports.DELETE = 46;

//# sourceMappingURL=keys.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var Icon = Icon_1 = function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        if (this.props.iconName == null) {
            return null;
        }
        var _a = this.props,
            className = _a.className,
            iconName = _a.iconName,
            intent = _a.intent,
            _b = _a.iconSize,
            iconSize = _b === void 0 ? Icon_1.SIZE_STANDARD : _b,
            restProps = tslib_1.__rest(_a, ["className", "iconName", "intent", "iconSize"]);
        var classes = classNames(getSizeClass(iconSize), common_1.Classes.iconClass(iconName), common_1.Classes.intentClass(intent), className);
        return React.createElement("span", tslib_1.__assign({ className: classes }, restProps));
    };
    return Icon;
}(React.Component);
Icon.displayName = "Blueprint.Icon";
Icon.SIZE_STANDARD = 16;
Icon.SIZE_LARGE = 20;
Icon.SIZE_INHERIT = "inherit";
Icon = Icon_1 = tslib_1.__decorate([PureRender], Icon);
exports.Icon = Icon;
;
// NOTE: not using a type alias here so the full union will appear in the interface docs
function getSizeClass(size) {
    switch (size) {
        case Icon.SIZE_STANDARD:
            return common_1.Classes.ICON_STANDARD;
        case Icon.SIZE_LARGE:
            return common_1.Classes.ICON_LARGE;
        default:
            return common_1.Classes.ICON;
    }
}
var Icon_1;

//# sourceMappingURL=icon.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1610), __esModule: true };

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(79).f;
var has = __webpack_require__(94);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(870);
var defined = __webpack_require__(584);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformer;
/* harmony export (immutable) */ __webpack_exports__["d"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(914);






var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(isNaN(b) ? NaN : 0.5);
}

function clamper(domain) {
  var a = domain[0],
      b = domain[domain.length - 1],
      t;
  if (a > b) t = a, a = b, b = t;
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0],
      d1 = domain[1],
      r0 = range[0],
      r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function (x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolate"],
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"])))(y)));
  };

  scale.domain = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRound"], rescale();
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
  };

  scale.interpolate = function (_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous(transform, untransform) {
  return transformer()(transform, untransform);
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObject = __webpack_require__(110);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return droppableIdKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dimensionMarshalKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styleContextKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return canLiftContextKey; });

var prefix = function prefix(key) {
  return 'private-react-beautiful-dnd-key-do-not-use-' + key;
};

var storeKey = prefix('store');
var droppableIdKey = prefix('droppable-id');
var dimensionMarshalKey = prefix('dimension-marshal');
var styleContextKey = prefix('style-context');
var canLiftContextKey = prefix('can-lift');

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2254)();
}

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(2467);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(155),
    overRest = __webpack_require__(1421),
    setToString = __webpack_require__(805);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2584),
    Map = __webpack_require__(791),
    Promise = __webpack_require__(2586),
    Set = __webpack_require__(1377),
    WeakMap = __webpack_require__(1379),
    baseGetTag = __webpack_require__(139),
    toSource = __webpack_require__(1427);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(500),
    isArrayLike = __webpack_require__(142),
    isString = __webpack_require__(519),
    toInteger = __webpack_require__(181),
    values = __webpack_require__(379);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}

module.exports = includes;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObject = __webpack_require__(105);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Actions = (_temp = _class = function (_React$Component) {
  _inherits(Actions, _React$Component);

  function Actions() {
    _classCallCheck(this, Actions);

    return _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).apply(this, arguments));
  }

  _createClass(Actions, [{
    key: 'render',
    value: function render() {
      var isLargeScreen = this.props.windowDimensions.width >= 1280;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
          selection: true,
          floated: isLargeScreen ? 'left' : null,
          divided: this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* default */].tabletBreakpoint,
          horizontal: this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* default */].tabletBreakpoint && this.props.windowDimensions.width < 1280,
          relaxed: !isLargeScreen,
          style: { margin: 0 }
        }),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__Document_scss___default.a.mobileActionMenuClose, onClick: this.props.onClose },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'close' }),
          'Close'
        )
      );
    }
  }]);

  return Actions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (Actions);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrandEditDesktop__ = __webpack_require__(3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrandEditMobile__ = __webpack_require__(3102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrandShow__ = __webpack_require__(3103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);







var BrandComponent = function BrandComponent(_ref) {
  var canEdit = _ref.canEdit,
      localBrand = _ref.localBrand,
      onChange = _ref.onChange,
      resetBrand = _ref.resetBrand,
      selectedBrand = _ref.selectedBrand,
      updateBrand = _ref.updateBrand;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Modules__["k" /* Dthc */],
      {
        desktop: __WEBPACK_IMPORTED_MODULE_2__BrandEditDesktop__["a" /* default */],
        mobile: __WEBPACK_IMPORTED_MODULE_3__BrandEditMobile__["a" /* default */],
        reset: resetBrand,
        onChange: onChange,
        commitUpdate: updateBrand,
        localBrand: localBrand,
        selectedBrand: selectedBrand
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BrandShow__["a" /* default */], { selectedBrand: selectedBrand })
    ),
    !canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BrandShow__["a" /* default */], { selectedBrand: selectedBrand, readOnly: true })
  );
};

BrandComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  localBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  resetBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  updateBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (BrandComponent);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LogoImage__ = __webpack_require__(3115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_scss__ = __webpack_require__(3609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Logo_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LogoComponent = function (_Component) {
  _inherits(LogoComponent, _Component);

  function LogoComponent(props) {
    _classCallCheck(this, LogoComponent);

    var _this = _possibleConstructorReturn(this, (LogoComponent.__proto__ || Object.getPrototypeOf(LogoComponent)).call(this, props));

    _this.state = {
      hovering: false
    };
    _this.onMouseOver = _this.onMouseOver.bind(_this);
    _this.onMouseOut = _this.onMouseOut.bind(_this);
    return _this;
  }

  _createClass(LogoComponent, [{
    key: 'onMouseOver',
    value: function onMouseOver() {
      if (!this.state.hovering) this.setState({ hovering: true });
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      if (this.state.hovering) this.setState({ hovering: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          canEdit = _props.canEdit,
          deleteLogo = _props.deleteLogo,
          openPicker = _props.openPicker,
          url = _props.url;
      var hovering = this.state.hovering;

      var editIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], {
        name: 'pencil',
        onClick: openPicker,
        className: __WEBPACK_IMPORTED_MODULE_4__Logo_scss___default.a.logoIcon
      });
      var deleteIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], {
        name: 'trash alternate',
        onClick: deleteLogo,
        className: __WEBPACK_IMPORTED_MODULE_4__Logo_scss___default.a.logoIcon
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        url && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            style: { marginBottom: '0.5em', display: 'flex' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LogoImage__["a" /* default */], { src: url })
          ),
          canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { visibility: hovering ? 'visible' : 'hidden', flex: 1 },
              className: __WEBPACK_IMPORTED_MODULE_4__Logo_scss___default.a.logoActions
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: '1em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Popup */], {
                trigger: editIcon,
                on: 'hover',
                inverted: true,
                content: 'Edit Logo',
                position: 'right center'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Popup */], {
                trigger: deleteIcon,
                on: 'hover',
                inverted: true,
                content: 'Delete Logo',
                position: 'right center'
              })
            )
          )
        ),
        !url && canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: '1em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
            basic: true,
            icon: 'upload',
            content: 'Upload Logo',
            onClick: openPicker
          })
        )
      );
    }
  }]);

  return LogoComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LogoComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  deleteLogo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openPicker: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LogoComponent);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TitleTextArea__ = __webpack_require__(3144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Document_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var TitleComponent = function TitleComponent(_ref) {
  var canEdit = _ref.canEdit,
      localTitle = _ref.localTitle,
      placeholder = _ref.placeholder,
      rightAlign = _ref.rightAlign,
      style = _ref.style,
      title = _ref.title,
      titleChangeHandler = _ref.titleChangeHandler,
      updateTitle = _ref.updateTitle;

  var rightAlignProps = rightAlign ? { textAlign: 'right', iconStyle: { left: '0.5em' } } : {};
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: Object.assign({}, { display: 'inline-block', width: '100%' }, style) },
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
      _extends({
        desktop: __WEBPACK_IMPORTED_MODULE_3__TitleTextArea__["a" /* default */],
        mobile: __WEBPACK_IMPORTED_MODULE_3__TitleTextArea__["a" /* default */],
        placeholder: placeholder,
        title: localTitle,
        onChange: titleChangeHandler,
        commitUpdate: updateTitle
      }, rightAlignProps, {
        iconStyle: { top: 0 }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.titleTextArea },
        title
      )
    ),
    !canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.titleTextArea },
      title
    )
  );
};

TitleComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  localTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  titleChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TitleComponent);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3591);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideDownUpTransition.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideDownUpTransition.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(550), __esModule: true };

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(86);
var dPs = __webpack_require__(567);
var enumBugKeys = __webpack_require__(217);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(270)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(397).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(221)('keys');
var uid = __webpack_require__(161);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(64);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(125);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(64);
var core = __webpack_require__(45);
var LIBRARY = __webpack_require__(190);
var wksExt = __webpack_require__(225);
var defineProperty = __webpack_require__(79).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(570)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(309)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(162);
var createDesc = __webpack_require__(407);
module.exports = __webpack_require__(149) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(878);
var enumBugKeys = __webpack_require__(586);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var hide = __webpack_require__(228);
var has = __webpack_require__(193);
var SRC = __webpack_require__(319)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(148).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(917);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function (count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function (count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */]);

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, linear());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return linearish(scale);
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function constant() {
    return x;
  };
});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  init: function init() {
    return {
      type: _ActionTypes2.default.INIT
    };
  },

  push: function push(location) {
    return {
      type: _ActionTypes2.default.PUSH,
      payload: location
    };
  },

  replace: function replace(location) {
    return {
      type: _ActionTypes2.default.REPLACE,
      payload: location
    };
  },

  go: function go(delta) {
    return {
      type: _ActionTypes2.default.GO,
      payload: delta
    };
  },

  dispose: function dispose() {
    return {
      type: _ActionTypes2.default.DISPOSE
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(2071),
    baseMatchesProperty = __webpack_require__(2072),
    identity = __webpack_require__(335),
    isArray = __webpack_require__(80),
    property = __webpack_require__(2170);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(651),
    baseAssignValue = __webpack_require__(442);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2066),
    getValue = __webpack_require__(2114);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(197),
    isLength = __webpack_require__(664);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.accessor = accessor;
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */
function accessor(data, field) {
  var value = null;

  if (typeof field === 'function') value = field(data);else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null && field in data) value = data[field];

  return value;
}

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Determines the variables that are in scope for a fragment given the variables
 * in scope at the root query as well as any arguments applied at the fragment
 * spread via `@arguments`.
 *
 * Note that this is analagous to determining function arguments given a function call.
 */
function getFragmentVariables(fragment, rootVariables, argumentVariables) {
  var variables = void 0;
  fragment.argumentDefinitions.forEach(function (definition) {
    if (argumentVariables.hasOwnProperty(definition.name)) {
      return;
    }
    variables = variables || (0, _extends3['default'])({}, argumentVariables);
    switch (definition.kind) {
      case 'LocalArgument':
        variables[definition.name] = definition.defaultValue;
        break;
      case 'RootArgument':
        if (!rootVariables.hasOwnProperty(definition.name)) {
          /*
           * A temporary fix to mute false alarm in cases where the root argument is stripped
           * off by the compiler due to a conditional directive, we do not need this argument
           * when tryiny to read the data from the store.
           */
          break;
        }
        variables[definition.name] = rootVariables[definition.name];
        break;
      default:
         true ?  false ? require('fbjs/lib/invariant')(false, 'RelayConcreteVariables: Unexpected node kind `%s` in fragment `%s`.', definition.kind, fragment.name) : __webpack_require__(10)(false) : void 0;
    }
  });
  return variables || argumentVariables;
}

/**
 * Determines the variables that are in scope for a given operation given values
 * for some/all of its arguments. Extraneous input variables are filtered from
 * the output, and missing variables are set to default values (if given in the
 * operation's definition).
 */
function getOperationVariables(operation, variables) {
  var operationVariables = {};
  operation.argumentDefinitions.forEach(function (def) {
    var value = def.defaultValue;
    if (variables[def.name] != null) {
      value = variables[def.name];
    }
    operationVariables[def.name] = value;
    if (false) {
      process.env.NODE_ENV !== 'production' ? require('fbjs/lib/warning')(value != null || def.type[def.type.length - 1] !== '!', 'RelayConcreteVariables: Expected a value for non-nullable variable ' + '`$%s: %s` on operation `%s`, got `%s`. Make sure you supply a ' + 'value for all non-nullable arguments.', def.name, def.type, operation.name, JSON.stringify(value)) : void 0;
    }
  });
  return operationVariables;
}

module.exports = {
  getFragmentVariables: getFragmentVariables,
  getOperationVariables: getOperationVariables
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var aggregateHandlersByName = {
  '*': []
};
var profileHandlersByName = {
  '*': []
};

var NOT_INVOKED = {};
var defaultProfiler = { stop: __webpack_require__(252) };
var shouldInstrument = function shouldInstrument(name) {
  if (false) {
    return true;
  }
  return name.charAt(0) !== '@';
};

/**
 * @public
 *
 * Instruments methods to allow profiling various parts of Relay. Profiling code
 * in Relay consists of three steps:
 *
 *  - Instrument the function to be profiled.
 *  - Attach handlers to the instrumented function.
 *  - Run the code which triggers the handlers.
 *
 * Handlers attached to instrumented methods are called with an instrumentation
 * name and a callback that must be synchronously executed:
 *
 *   instrumentedMethod.attachHandler(function(name, callback) {
 *     const start = performance.now();
 *     callback();
 *     console.log('Duration', performance.now() - start);
 *   });
 *
 * Handlers for profiles are callbacks that return a stop method:
 *
 *   RelayProfiler.attachProfileHandler('profileName', (name, state) => {
 *     const start = performance.now();
 *     return function stop(name, state) {
 *       console.log(`Duration (${name})`, performance.now() - start);
 *     }
 *   });
 *
 * In order to reduce the impact on performance in production, instrumented
 * methods and profilers with names that begin with `@` will only be measured
 * if `__DEV__` is true. This should be used for very hot functions.
 */
var RelayProfiler = {
  /**
   * Instruments methods on a class or object. This re-assigns the method in
   * order to preserve function names in stack traces (which are detected by
   * modern debuggers via heuristics). Example usage:
   *
   *   const RelayStore = { primeCache: function() {...} };
   *   RelayProfiler.instrumentMethods(RelayStore, {
   *     primeCache: 'RelayStore.primeCache'
   *   });
   *
   *   RelayStore.primeCache.attachHandler(...);
   *
   * As a result, the methods will be replaced by wrappers that provide the
   * `attachHandler` and `detachHandler` methods.
   */
  instrumentMethods: function instrumentMethods(object, names) {
    for (var _key in names) {
      if (names.hasOwnProperty(_key)) {
        if (typeof object[_key] === 'function') {
          object[_key] = RelayProfiler.instrument(names[_key], object[_key]);
        }
      }
    }
  },

  /**
   * Wraps the supplied function with one that provides the `attachHandler` and
   * `detachHandler` methods. Example usage:
   *
   *   const printRelayQuery =
   *     RelayProfiler.instrument('printRelayQuery', printRelayQuery);
   *
   *   printRelayQuery.attachHandler(...);
   *
   * NOTE: The instrumentation assumes that no handlers are attached or detached
   * in the course of executing another handler.
   */
  instrument: function instrument(name, originalFunction) {
    if (!shouldInstrument(name)) {
      originalFunction.attachHandler = __webpack_require__(252);
      originalFunction.detachHandler = __webpack_require__(252);
      return originalFunction;
    }
    if (!aggregateHandlersByName.hasOwnProperty(name)) {
      aggregateHandlersByName[name] = [];
    }
    var catchallHandlers = aggregateHandlersByName['*'];
    var aggregateHandlers = aggregateHandlersByName[name];
    var handlers = [];
    var contexts = [];
    var invokeHandlers = function invokeHandlers() {
      var context = contexts[contexts.length - 1];
      if (context[0]) {
        context[0]--;
        catchallHandlers[context[0]](name, invokeHandlers);
      } else if (context[1]) {
        context[1]--;
        aggregateHandlers[context[1]](name, invokeHandlers);
      } else if (context[2]) {
        context[2]--;
        handlers[context[2]](name, invokeHandlers);
      } else {
        context[5] = originalFunction.apply(context[3], context[4]);
      }
    };
    var instrumentedCallback = function instrumentedCallback() {
      var returnValue = void 0;
      if (aggregateHandlers.length === 0 && handlers.length === 0 && catchallHandlers.length === 0) {
        returnValue = originalFunction.apply(this, arguments);
      } else {
        contexts.push([catchallHandlers.length, aggregateHandlers.length, handlers.length, this, arguments, NOT_INVOKED]);
        invokeHandlers();
        var context = contexts.pop();
        returnValue = context[5];
        if (returnValue === NOT_INVOKED) {
          throw new Error('RelayProfiler: Handler did not invoke original function.');
        }
      }
      return returnValue;
    };
    instrumentedCallback.attachHandler = function (handler) {
      handlers.push(handler);
    };
    instrumentedCallback.detachHandler = function (handler) {
      __webpack_require__(253)(handlers, handler);
    };
    instrumentedCallback.displayName = '(instrumented ' + name + ')';
    return instrumentedCallback;
  },

  /**
   * Attaches a handler to all methods instrumented with the supplied name.
   *
   *   function createRenderer() {
   *     return RelayProfiler.instrument('render', function() {...});
   *   }
   *   const renderA = createRenderer();
   *   const renderB = createRenderer();
   *
   *   // Only profiles `renderA`.
   *   renderA.attachHandler(...);
   *
   *   // Profiles both `renderA` and `renderB`.
   *   RelayProfiler.attachAggregateHandler('render', ...);
   *
   */
  attachAggregateHandler: function attachAggregateHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (!aggregateHandlersByName.hasOwnProperty(name)) {
        aggregateHandlersByName[name] = [];
      }
      aggregateHandlersByName[name].push(handler);
    }
  },

  /**
   * Detaches a handler attached via `attachAggregateHandler`.
   */
  detachAggregateHandler: function detachAggregateHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (aggregateHandlersByName.hasOwnProperty(name)) {
        __webpack_require__(253)(aggregateHandlersByName[name], handler);
      }
    }
  },

  /**
   * Instruments profiling for arbitrarily asynchronous code by a name.
   *
   *   const timerProfiler = RelayProfiler.profile('timeout');
   *   setTimeout(function() {
   *     timerProfiler.stop();
   *   }, 1000);
   *
   *   RelayProfiler.attachProfileHandler('timeout', ...);
   *
   * Arbitrary state can also be passed into `profile` as a second argument. The
   * attached profile handlers will receive this as the second argument.
   */
  profile: function profile(name, state) {
    var hasCatchAllHandlers = profileHandlersByName['*'].length > 0;
    var hasNamedHandlers = profileHandlersByName.hasOwnProperty(name);
    if (hasNamedHandlers || hasCatchAllHandlers) {
      var profileHandlers = hasNamedHandlers && hasCatchAllHandlers ? profileHandlersByName[name].concat(profileHandlersByName['*']) : hasNamedHandlers ? profileHandlersByName[name] : profileHandlersByName['*'];
      var stopHandlers = void 0;
      for (var ii = profileHandlers.length - 1; ii >= 0; ii--) {
        var profileHandler = profileHandlers[ii];
        var stopHandler = profileHandler(name, state);
        stopHandlers = stopHandlers || [];
        stopHandlers.unshift(stopHandler);
      }
      return {
        stop: function stop() {
          if (stopHandlers) {
            stopHandlers.forEach(function (stopHandler) {
              return stopHandler();
            });
          }
        }
      };
    }
    return defaultProfiler;
  },

  /**
   * Attaches a handler to profiles with the supplied name. You can also
   * attach to the special name '*' which is a catch all.
   */
  attachProfileHandler: function attachProfileHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (!profileHandlersByName.hasOwnProperty(name)) {
        profileHandlersByName[name] = [];
      }
      profileHandlersByName[name].push(handler);
    }
  },

  /**
   * Detaches a handler attached via `attachProfileHandler`.
   */
  detachProfileHandler: function detachProfileHandler(name, handler) {
    if (shouldInstrument(name)) {
      if (profileHandlersByName.hasOwnProperty(name)) {
        __webpack_require__(253)(profileHandlersByName[name], handler);
      }
    }
  }
};

module.exports = RelayProfiler;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _defineProperty3 = _interopRequireDefault(__webpack_require__(122));

var _extends4 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function read(recordSource, selector) {
  var dataID = selector.dataID,
      node = selector.node,
      variables = selector.variables;

  var reader = new RelayReader(recordSource, variables);
  return reader.read(node, dataID);
}

/**
 * @private
 */

var RelayReader = function () {
  function RelayReader(recordSource, variables) {
    (0, _classCallCheck3['default'])(this, RelayReader);

    this._recordSource = recordSource;
    this._seenRecords = {};
    this._variables = variables;
  }

  RelayReader.prototype.read = function read(node, dataID) {
    var data = this._traverse(node, dataID, null);
    return {
      data: data,
      dataID: dataID,
      node: node,
      seenRecords: this._seenRecords,
      variables: this._variables
    };
  };

  RelayReader.prototype._traverse = function _traverse(node, dataID, prevData) {
    var record = this._recordSource.get(dataID);
    this._seenRecords[dataID] = record;
    if (record == null) {
      return record;
    }
    var data = prevData || {};
    this._traverseSelections(node.selections, record, data);
    return data;
  };

  RelayReader.prototype._getVariableValue = function _getVariableValue(name) {
    !this._variables.hasOwnProperty(name) ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader(): Undefined variable `%s`.', name) : __webpack_require__(10)(false) : void 0;
    return this._variables[name];
  };

  RelayReader.prototype._traverseSelections = function _traverseSelections(selections, record, data) {
    var _this = this;

    selections.forEach(function (selection) {
      if (selection.kind === __webpack_require__(18).SCALAR_FIELD) {
        _this._readScalar(selection, record, data);
      } else if (selection.kind === __webpack_require__(18).LINKED_FIELD) {
        if (selection.plural) {
          _this._readPluralLink(selection, record, data);
        } else {
          _this._readLink(selection, record, data);
        }
      } else if (selection.kind === __webpack_require__(18).CONDITION) {
        var conditionValue = _this._getVariableValue(selection.condition);
        if (conditionValue === selection.passingValue) {
          _this._traverseSelections(selection.selections, record, data);
        }
      } else if (selection.kind === __webpack_require__(18).INLINE_FRAGMENT) {
        var typeName = __webpack_require__(17).getType(record);
        if (typeName != null && typeName === selection.type) {
          _this._traverseSelections(selection.selections, record, data);
        }
      } else if (selection.kind === __webpack_require__(18).FRAGMENT_SPREAD) {
        _this._createFragmentPointer(selection, record, data, _this._variables);
      } else if (selection.kind === __webpack_require__(18).DEFERRABLE_FRAGMENT_SPREAD) {
        _this._createDeferrableFragmentPointer(selection, record, data);
      } else {
         true ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader(): Unexpected ast kind `%s`.', selection.kind) : __webpack_require__(10)(false) : void 0;
      }
    });
  };

  RelayReader.prototype._readScalar = function _readScalar(field, record, data) {
    var applicationName = field.alias || field.name;
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var value = __webpack_require__(17).getValue(record, storageKey);
    data[applicationName] = value;
  };

  RelayReader.prototype._readLink = function _readLink(field, record, data) {
    var applicationName = field.alias || field.name;
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedID = __webpack_require__(17).getLinkedRecordID(record, storageKey);

    if (linkedID == null) {
      data[applicationName] = linkedID;
      return;
    }

    var prevData = data[applicationName];
    !(prevData == null || (typeof prevData === 'undefined' ? 'undefined' : _typeof(prevData)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader(): Expected data for field `%s` on record `%s` ' + 'to be an object, got `%s`.', applicationName, require('./RelayModernRecord').getDataID(record), prevData) : __webpack_require__(10)(false) : void 0;
    data[applicationName] = this._traverse(field, linkedID, prevData);
  };

  RelayReader.prototype._readPluralLink = function _readPluralLink(field, record, data) {
    var _this2 = this;

    var applicationName = field.alias || field.name;
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedIDs = __webpack_require__(17).getLinkedRecordIDs(record, storageKey);

    if (linkedIDs == null) {
      data[applicationName] = linkedIDs;
      return;
    }

    var prevData = data[applicationName];
    !(prevData == null || Array.isArray(prevData)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader(): Expected data for field `%s` on record `%s` ' + 'to be an array, got `%s`.', applicationName, require('./RelayModernRecord').getDataID(record), prevData) : __webpack_require__(10)(false) : void 0;
    var linkedArray = prevData || [];
    linkedIDs.forEach(function (linkedID, nextIndex) {
      if (linkedID == null) {
        linkedArray[nextIndex] = linkedID;
        return;
      }
      var prevItem = linkedArray[nextIndex];
      !(prevItem == null || (typeof prevItem === 'undefined' ? 'undefined' : _typeof(prevItem)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader(): Expected data for field `%s` on record `%s` ' + 'to be an object, got `%s`.', applicationName, require('./RelayModernRecord').getDataID(record), prevItem) : __webpack_require__(10)(false) : void 0;
      var linkedItem = _this2._traverse(field, linkedID, prevItem);
      linkedArray[nextIndex] = linkedItem;
    });
    data[applicationName] = linkedArray;
  };

  RelayReader.prototype._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data, variables) {
    var fragmentPointers = data[__webpack_require__(12).FRAGMENTS_KEY];
    if (!fragmentPointers) {
      fragmentPointers = data[__webpack_require__(12).FRAGMENTS_KEY] = {};
    }
    !((typeof fragmentPointers === 'undefined' ? 'undefined' : _typeof(fragmentPointers)) === 'object' && fragmentPointers) ?  false ? require('fbjs/lib/invariant')(false, 'RelayReader: Expected fragment spread data to be an object, got `%s`.', fragmentPointers) : __webpack_require__(10)(false) : void 0;
    data[__webpack_require__(12).ID_KEY] = data[__webpack_require__(12).ID_KEY] || __webpack_require__(17).getDataID(record);
    fragmentPointers[fragmentSpread.name] = fragmentSpread.args ? __webpack_require__(12).getArgumentValues(fragmentSpread.args, variables) : {};
  };

  RelayReader.prototype._createDeferrableFragmentPointer = function _createDeferrableFragmentPointer(deferrableFragment, record, data) {
    var rootFieldValue = __webpack_require__(17).getValue(record, deferrableFragment.storageKey);
    var variables = (0, _extends4['default'])({}, this._variables, (0, _defineProperty3['default'])({}, deferrableFragment.rootFieldVariable, rootFieldValue));
    this._createFragmentPointer(deferrableFragment, record, data, variables);
  };

  return RelayReader;
}();

module.exports = { read: read };

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @internal
 *
 * A helper for manipulating a `RecordSource` via an imperative/OO-style API.
 */
var RelayRecordSourceProxy = function () {
  function RelayRecordSourceProxy(mutator, handlerProvider) {
    (0, _classCallCheck3['default'])(this, RelayRecordSourceProxy);

    this.__mutator = mutator;
    this._handlerProvider = handlerProvider || null;
    this._proxies = {};
  }

  RelayRecordSourceProxy.prototype.publishSource = function publishSource(source, fieldPayloads) {
    var _this = this;

    var dataIDs = source.getRecordIDs();
    dataIDs.forEach(function (dataID) {
      var status = source.getStatus(dataID);
      if (status === __webpack_require__(49).EXISTENT) {
        var sourceRecord = source.get(dataID);
        if (sourceRecord) {
          if (_this.__mutator.getStatus(dataID) !== __webpack_require__(49).EXISTENT) {
            _this.create(dataID, __webpack_require__(17).getType(sourceRecord));
          }
          _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
          delete _this._proxies[dataID];
        }
      } else if (status === __webpack_require__(49).NONEXISTENT) {
        _this['delete'](dataID);
      }
    });

    if (fieldPayloads && fieldPayloads.length) {
      fieldPayloads.forEach(function (fieldPayload) {
        var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
        !handler ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernEnvironment: Expected a handler to be provided for handle `%s`.', fieldPayload.handle) : __webpack_require__(10)(false) : void 0;
        handler.update(_this, fieldPayload);
      });
    }
  };

  RelayRecordSourceProxy.prototype.commitPayload = function commitPayload(operation, response) {
    if (!response) {
      return new (__webpack_require__(247))(this, operation.fragment);
    }

    var _normalizeRelayPayloa = __webpack_require__(137)(operation.root, response),
        source = _normalizeRelayPayloa.source,
        fieldPayloads = _normalizeRelayPayloa.fieldPayloads;

    this.publishSource(source, fieldPayloads);
    return new (__webpack_require__(247))(this, operation.fragment);
  };

  RelayRecordSourceProxy.prototype.create = function create(dataID, typeName) {
    this.__mutator.create(dataID, typeName);
    delete this._proxies[dataID];
    var record = this.get(dataID);
    // For flow
    !record ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceProxy#create(): Expected the created record to exist.') : __webpack_require__(10)(false) : void 0;
    return record;
  };

  RelayRecordSourceProxy.prototype['delete'] = function _delete(dataID) {
    !(dataID !== __webpack_require__(12).ROOT_ID) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceProxy#delete(): Cannot delete the root record.') : __webpack_require__(10)(false) : void 0;
    delete this._proxies[dataID];
    this.__mutator['delete'](dataID);
  };

  RelayRecordSourceProxy.prototype.get = function get(dataID) {
    if (!this._proxies.hasOwnProperty(dataID)) {
      var status = this.__mutator.getStatus(dataID);
      if (status === __webpack_require__(49).EXISTENT) {
        this._proxies[dataID] = new (__webpack_require__(739))(this, this.__mutator, dataID);
      } else {
        this._proxies[dataID] = status === __webpack_require__(49).NONEXISTENT ? null : undefined;
      }
    }
    return this._proxies[dataID];
  };

  RelayRecordSourceProxy.prototype.getRoot = function getRoot() {
    var root = this.get(__webpack_require__(12).ROOT_ID);
    if (!root) {
      root = this.create(__webpack_require__(12).ROOT_ID, __webpack_require__(12).ROOT_TYPE);
    }
    !(root && root.getType() === __webpack_require__(12).ROOT_TYPE) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceProxy#getRoot(): Expected the source to contain a ' + 'root record.') : __webpack_require__(10)(false) : void 0;
    return root;
  };

  return RelayRecordSourceProxy;
}();

module.exports = RelayRecordSourceProxy;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @internal
 *
 * A subclass of RecordSourceProxy that provides convenience methods for
 * accessing the root fields of a given query/mutation. These fields accept
 * complex arguments and it can be tedious to re-construct the correct sets of
 * arguments to pass to e.g. `getRoot().getLinkedRecord()`.
 */
var RelayRecordSourceSelectorProxy = function () {
  function RelayRecordSourceSelectorProxy(recordSource, readSelector) {
    (0, _classCallCheck3['default'])(this, RelayRecordSourceSelectorProxy);

    this.__recordSource = recordSource;
    this._readSelector = readSelector;
  }

  RelayRecordSourceSelectorProxy.prototype.create = function create(dataID, typeName) {
    return this.__recordSource.create(dataID, typeName);
  };

  RelayRecordSourceSelectorProxy.prototype['delete'] = function _delete(dataID) {
    this.__recordSource['delete'](dataID);
  };

  RelayRecordSourceSelectorProxy.prototype.get = function get(dataID) {
    return this.__recordSource.get(dataID);
  };

  RelayRecordSourceSelectorProxy.prototype.getRoot = function getRoot() {
    return this.__recordSource.getRoot();
  };

  RelayRecordSourceSelectorProxy.prototype._getRootField = function _getRootField(selector, fieldName, plural) {
    var field = selector.node.selections.find(function (selection) {
      return selection.kind === 'LinkedField' && selection.name === fieldName;
    });
    !(field && field.kind === 'LinkedField') ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceSelectorProxy#getRootField(): Cannot find root ' + 'field `%s`, no such field is defined on GraphQL document `%s`.', fieldName, selector.node.name) : __webpack_require__(10)(false) : void 0;
    !(field.plural === plural) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordSourceSelectorProxy#getRootField(): Expected root field ' + '`%s` to be %s.', fieldName, plural ? 'plural' : 'singular') : __webpack_require__(10)(false) : void 0;
    return field;
  };

  RelayRecordSourceSelectorProxy.prototype.getRootField = function getRootField(fieldName) {
    var field = this._getRootField(this._readSelector, fieldName, false);
    var storageKey = __webpack_require__(12).getStorageKey(field, this._readSelector.variables);
    return this.getRoot().getLinkedRecord(storageKey);
  };

  RelayRecordSourceSelectorProxy.prototype.getPluralRootField = function getPluralRootField(fieldName) {
    var field = this._getRootField(this._readSelector, fieldName, true);
    var storageKey = __webpack_require__(12).getStorageKey(field, this._readSelector.variables);
    return this.getRoot().getLinkedRecords(storageKey);
  };

  return RelayRecordSourceSelectorProxy;
}();

module.exports = RelayRecordSourceSelectorProxy;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



function deferrableFragmentKey(dataID, fragmentName, variables) {
  var variablesString = Object.keys(variables).reduce(function (acc, key) {
    return '' + acc + (acc ? ',' : '') + key + ':' + variables[key];
  }, '');
  return 'path:' + dataID + ',key:' + fragmentName + ',request:' + variablesString;
}

module.exports = deferrableFragmentKey;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * @internal
 *
 * Helper to create a unique name for a handle field based on the handle name, handle key and
 * source field.
 */

function getRelayHandleKey(handleName, key, fieldName) {
  if (key && key !== __webpack_require__(357).DEFAULT_HANDLE_KEY) {
    return '__' + key + '_' + handleName;
  }

  !(fieldName != null) ?  false ? require('fbjs/lib/invariant')(false, 'getRelayHandleKey: Expected either `fieldName` or `key` in `handle` to be provided') : __webpack_require__(10)(false) : void 0;
  return '__' + fieldName + '_' + handleName;
}

module.exports = getRelayHandleKey;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Determine if a given value is an object that implements the `Environment`
 * interface defined in `RelayStoreTypes`.
 *
 * Use a sigil for detection to avoid a realm-specific instanceof check, and to
 * aid in module tree-shaking to avoid requiring all of RelayRuntime just to
 * detect its environment.
 */

function isRelayModernEnvironment(environment) {
  return Boolean(environment && environment['@@RelayModernEnvironment']);
}

module.exports = isRelayModernEnvironment;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var aStackPool = [];
var bStackPool = [];

/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */
function areEqual(a, b) {
  var aStack = aStackPool.length ? aStackPool.pop() : [];
  var bStack = bStackPool.length ? bStackPool.pop() : [];
  var result = eq(a, b, aStack, bStack);
  aStack.length = 0;
  bStack.length = 0;
  aStackPool.push(aStack);
  bStackPool.push(bStack);
  return result;
}

function eq(a, b, aStack, bStack) {
  if (a === b) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
  }
  if (a == null || b == null) {
    // a or b can be `null` or `undefined`
    return false;
  }
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') {
    return false;
  }
  var objToStr = Object.prototype.toString;
  var className = objToStr.call(a);
  if (className != objToStr.call(b)) {
    return false;
  }
  switch (className) {
    case '[object String]':
      return a == String(b);
    case '[object Number]':
      return isNaN(a) || isNaN(b) ? false : a == Number(b);
    case '[object Date]':
    case '[object Boolean]':
      return +a == +b;
    case '[object RegExp]':
      return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
  }
  // Assume equality for cyclic structures.
  var length = aStack.length;
  while (length--) {
    if (aStack[length] == a) {
      return bStack[length] == b;
    }
  }
  aStack.push(a);
  bStack.push(b);
  var size = 0;
  // Recursively compare objects and arrays.
  if (className === '[object Array]') {
    size = a.length;
    if (size !== b.length) {
      return false;
    }
    // Deep compare the contents, ignoring non-numeric properties.
    while (size--) {
      if (!eq(a[size], b[size], aStack, bStack)) {
        return false;
      }
    }
  } else {
    if (a.constructor !== b.constructor) {
      return false;
    }
    if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) {
      return a.valueOf() == b.valueOf();
    }
    var keys = Object.keys(a);
    if (keys.length != Object.keys(b).length) {
      return false;
    }
    for (var i = 0; i < keys.length; i++) {
      if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) {
        return false;
      }
    }
  }
  aStack.pop();
  bStack.pop();
  return true;
}

module.exports = areEqual;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Removes an element from an array.
 */

function removeFromArray(array, element) {
  var index = array.indexOf(element);
  if (index !== -1) {
    array.splice(index, 1);
  }
}

module.exports = removeFromArray;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(99);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(498),
    createBaseEach = __webpack_require__(2643);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2608),
    getValue = __webpack_require__(2661);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(259);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayMove;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: function methods(node) {
    /* eslint-disable no-underscore-dangle */
    switch (node.__typename) {
      case 'CashPaymentMethod':
        return 'Cash';
      case 'CheckPaymentMethod':
        return 'Check';
      case 'SquarePaymentMethod':
        return 'Credit Card';
      case 'CustomPaymentMethod':
        return node.label;
      default:
        return null;
    }
  },
  payments: function payments(node) {
    /* eslint-disable no-underscore-dangle */
    switch (node.__typename) {
      case 'CashPayment':
        return 'Cash';
      case 'CheckPayment':
        return 'Check';
      case 'SquarePayment':
        return 'Credit Card';
      case 'CustomPayment':
        return node.label;
      default:
        return null;
    }
  },
  getPaymentMethod: function getPaymentMethod(viewer, paymentMethod) {
    var methods = viewer.payment_methods.edges.filter(
    /* eslint-disable no-underscore-dangle */
    function (method) {
      return method.node.__typename === paymentMethod;
    });
    return methods[0] && methods[0].node ? methods[0].node : null;
  },
  refundedCents: function refundedCents(payment) {
    return payment.refunds.edges.reduce(function (total, _ref) {
      var refund = _ref.node;
      return total + refund.amount_cents;
    }, 0);
  }
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3559);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./TermsBuilder.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./TermsBuilder.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */
var INVALID_PROPS = ["active", "containerRef", "elementRef", "iconName", "inputRef", "intent", "loading", "leftIconName", "onChildrenMount", "onRemove", "rightElement", "rightIconName", "text"];
/**
 * Typically applied to HTMLElements to filter out blacklisted props. When applied to a Component,
 * can filter props from being passed down to the children. Can also filter by a combined list of
 * supplied prop keys and the blacklist (only appropriate for HTMLElements).
 * @param props The original props object to filter down.
 * @param {string[]} invalidProps If supplied, overwrites the default blacklist.
 * @param {boolean} shouldMerge If true, will merge supplied invalidProps and blacklist together.
 */
function removeNonHTMLProps(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) {
        invalidProps = INVALID_PROPS;
    }
    if (shouldMerge === void 0) {
        shouldMerge = false;
    }
    if (shouldMerge) {
        invalidProps = invalidProps.concat(INVALID_PROPS);
    }
    return invalidProps.reduce(function (prev, curr) {
        if (prev.hasOwnProperty(curr)) {
            delete prev[curr];
        }
        return prev;
    }, tslib_1.__assign({}, props));
}
exports.removeNonHTMLProps = removeNonHTMLProps;

//# sourceMappingURL=props.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(44);
var Tether = __webpack_require__(2787);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var PosUtils = __webpack_require__(157);
var TetherUtils = __webpack_require__(836);
var Utils = __webpack_require__(53);
var overlay_1 = __webpack_require__(391);
var tooltip_1 = __webpack_require__(540);
var Arrows = __webpack_require__(1541);
var SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378" + "-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
var SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005" + "c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
var SMART_POSITIONING = {
    attachment: "together",
    to: "scrollParent"
};
var PopoverInteractionKind;
(function (PopoverInteractionKind) {
    PopoverInteractionKind[PopoverInteractionKind["CLICK"] = 0] = "CLICK";
    PopoverInteractionKind[PopoverInteractionKind["CLICK_TARGET_ONLY"] = 1] = "CLICK_TARGET_ONLY";
    PopoverInteractionKind[PopoverInteractionKind["HOVER"] = 2] = "HOVER";
    PopoverInteractionKind[PopoverInteractionKind["HOVER_TARGET_ONLY"] = 3] = "HOVER_TARGET_ONLY";
})(PopoverInteractionKind = exports.PopoverInteractionKind || (exports.PopoverInteractionKind = {}));
var Popover = function (_super) {
    tslib_1.__extends(Popover, _super);
    function Popover(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.hasDarkParent = false;
        // a flag that is set to true while we are waiting for the underlying Portal to complete rendering
        _this.isContentMounting = false;
        _this.refHandlers = {
            popover: function popover(ref) {
                _this.popoverElement = ref;
                _this.updateTether();
                _this.updateArrowPosition();
            },
            target: function target(ref) {
                _this.targetElement = ref;
            }
        };
        _this.handleContentMount = function () {
            if (Utils.isFunction(_this.props.popoverDidOpen) && _this.isContentMounting) {
                _this.props.popoverDidOpen();
                _this.isContentMounting = false;
            }
        };
        _this.handleTargetFocus = function (e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                _this.handleMouseEnter(e);
            }
        };
        _this.handleTargetBlur = function (e) {
            if (_this.props.openOnTargetFocus && _this.isHoverInteractionKind()) {
                // if the next element to receive focus is within the popover, we'll want to leave the
                // popover open. we must do this check *after* the next element focuses, so we use a
                // timeout of 0 to flush the rest of the event queue before proceeding.
                requestAnimationFrame(function () {
                    var popoverElement = _this.popoverElement;
                    if (popoverElement == null || !popoverElement.contains(document.activeElement)) {
                        _this.handleMouseLeave(e);
                    }
                });
            }
        };
        _this.handleMouseEnter = function (e) {
            // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
            // trigger the mouse leave event, as hovering over the popover shouldn't count.
            if (_this.props.inline && _this.isElementInPopover(e.target) && _this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY && !_this.props.openOnTargetFocus) {
                _this.handleMouseLeave(e);
            } else if (!_this.props.isDisabled) {
                // only begin opening popover when it is enabled
                _this.setOpenState(true, e, _this.props.hoverOpenDelay);
            }
        };
        _this.handleMouseLeave = function (e) {
            // user-configurable closing delay is helpful when moving mouse from target to popover
            _this.setOpenState(false, e, _this.props.hoverCloseDelay);
        };
        _this.handlePopoverClick = function (e) {
            var eventTarget = e.target;
            var shouldDismiss = eventTarget.closest("." + Classes.POPOVER_DISMISS) != null;
            var overrideDismiss = eventTarget.closest("." + Classes.POPOVER_DISMISS_OVERRIDE) != null;
            if (shouldDismiss && !overrideDismiss) {
                _this.setOpenState(false, e);
            }
        };
        _this.handleOverlayClose = function (e) {
            var eventTarget = e.target;
            // if click was in target, target event listener will handle things, so don't close
            if (!Utils.elementIsOrContains(_this.targetElement, eventTarget) || e.nativeEvent instanceof KeyboardEvent) {
                _this.setOpenState(false, e);
            }
        };
        _this.handleTargetClick = function (e) {
            // ensure click did not originate from within inline popover before closing
            if (!_this.props.isDisabled && !_this.isElementInPopover(e.target)) {
                if (_this.props.isOpen == null) {
                    _this.setState(function (prevState) {
                        return { isOpen: !prevState.isOpen };
                    });
                } else {
                    _this.setOpenState(!_this.props.isOpen, e);
                }
            }
        };
        var isOpen = props.defaultIsOpen && !props.isDisabled;
        if (props.isOpen != null) {
            isOpen = props.isOpen;
        }
        _this.state = {
            isOpen: isOpen,
            ignoreTargetDimensions: false,
            targetHeight: 0,
            targetWidth: 0
        };
        return _this;
    }
    Popover.prototype.render = function () {
        var className = this.props.className;
        var isOpen = this.state.isOpen;
        var targetProps;
        if (this.isHoverInteractionKind()) {
            targetProps = {
                onBlur: this.handleTargetBlur,
                onFocus: this.handleTargetFocus,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave
            };
            // any one of the CLICK* values
        } else {
            targetProps = {
                onClick: this.handleTargetClick
            };
        }
        targetProps.className = classNames(Classes.POPOVER_TARGET, (_a = {}, _a[Classes.POPOVER_OPEN] = isOpen, _a), className);
        targetProps.ref = this.refHandlers.target;
        var children = this.understandChildren();
        var targetTabIndex = this.props.openOnTargetFocus && this.isHoverInteractionKind() ? 0 : undefined;
        var target = React.cloneElement(children.target,
        // force disable single Tooltip child when popover is open (BLUEPRINT-552)
        isOpen && children.target.type === tooltip_1.Tooltip ? { isDisabled: true, tabIndex: targetTabIndex } : { tabIndex: targetTabIndex });
        var isContentEmpty = children.content == null;
        if (isContentEmpty && !this.props.isDisabled && isOpen !== false && !Utils.isNodeEnv("production")) {
            console.warn(Errors.POPOVER_WARN_EMPTY_CONTENT);
        }
        return React.createElement(this.props.rootElementTag, targetProps, target, React.createElement(overlay_1.Overlay, { autoFocus: this.props.autoFocus, backdropClassName: Classes.POPOVER_BACKDROP, backdropProps: this.props.backdropProps, canEscapeKeyClose: this.props.canEscapeKeyClose, canOutsideClickClose: this.props.interactionKind === PopoverInteractionKind.CLICK, className: this.props.portalClassName, didOpen: this.handleContentMount, enforceFocus: this.props.enforceFocus, hasBackdrop: this.props.isModal, inline: this.props.inline, isOpen: isOpen && !isContentEmpty, lazy: this.props.lazy, onClose: this.handleOverlayClose, transitionDuration: this.props.transitionDuration, transitionName: Classes.POPOVER }, this.renderPopover(children.content)));
        var _a;
    };
    Popover.prototype.componentDidMount = function () {
        this.componentDOMChange();
    };
    Popover.prototype.componentWillReceiveProps = function (nextProps) {
        _super.prototype.componentWillReceiveProps.call(this, nextProps);
        if (nextProps.isOpen == null && nextProps.isDisabled && !this.props.isDisabled) {
            // ok to use setOpenState here because isDisabled and isOpen are mutex.
            this.setOpenState(false);
        } else if (nextProps.isOpen !== this.props.isOpen) {
            // propagate isOpen prop directly to state, circumventing onInteraction callback
            // (which would be invoked if this went through setOpenState)
            this.setState({ isOpen: nextProps.isOpen });
        }
    };
    Popover.prototype.componentWillUpdate = function (_, nextState) {
        if (!this.state.isOpen && nextState.isOpen) {
            this.isContentMounting = true;
            Utils.safeInvoke(this.props.popoverWillOpen);
        } else if (this.state.isOpen && !nextState.isOpen) {
            Utils.safeInvoke(this.props.popoverWillClose);
        }
    };
    Popover.prototype.componentDidUpdate = function () {
        this.componentDOMChange();
    };
    Popover.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.destroyTether();
    };
    Popover.prototype.validateProps = function (props) {
        if (props.useSmartPositioning || props.constraints != null) {
            console.warn(Errors.POPOVER_WARN_DEPRECATED_CONSTRAINTS);
        }
        if (props.isOpen == null && props.onInteraction != null) {
            console.warn(Errors.POPOVER_WARN_UNCONTROLLED_ONINTERACTION);
        }
        if (props.inline && (props.useSmartPositioning || props.constraints != null || props.tetherOptions != null)) {
            console.warn(Errors.POPOVER_WARN_INLINE_NO_TETHER);
        }
        if (props.isModal && props.inline) {
            console.warn(Errors.POPOVER_WARN_MODAL_INLINE);
        }
        if (props.isModal && props.interactionKind !== PopoverInteractionKind.CLICK) {
            throw new Error(Errors.POPOVER_MODAL_INTERACTION);
        }
        var childrenCount = React.Children.count(props.children);
        var hasContentProp = props.content !== undefined;
        var hasTargetProp = props.target !== undefined;
        if (childrenCount === 0 && !hasTargetProp) {
            throw new Error(Errors.POPOVER_REQUIRES_TARGET);
        }
        if (childrenCount > 2) {
            console.warn(Errors.POPOVER_WARN_TOO_MANY_CHILDREN);
        }
        if (childrenCount > 0 && hasTargetProp) {
            console.warn(Errors.POPOVER_WARN_DOUBLE_TARGET);
        }
        if (childrenCount === 2 && hasContentProp) {
            console.warn(Errors.POPOVER_WARN_DOUBLE_CONTENT);
        }
    };
    Popover.prototype.componentDOMChange = function () {
        if (this.props.useSmartArrowPositioning) {
            this.setState({
                targetHeight: this.targetElement.clientHeight,
                targetWidth: this.targetElement.clientWidth
            });
        }
        if (!this.props.inline) {
            this.hasDarkParent = this.targetElement.closest("." + Classes.DARK) != null;
            this.updateTether();
        }
    };
    Popover.prototype.renderPopover = function (content) {
        var _a = this.props,
            inline = _a.inline,
            interactionKind = _a.interactionKind;
        var popoverHandlers = {
            // always check popover clicks for dismiss class
            onClick: this.handlePopoverClick
        };
        if (interactionKind === PopoverInteractionKind.HOVER || inline && interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY) {
            popoverHandlers.onMouseEnter = this.handleMouseEnter;
            popoverHandlers.onMouseLeave = this.handleMouseLeave;
        }
        var positionClasses = TetherUtils.getAttachmentClasses(this.props.position).join(" ");
        var containerClasses = classNames(Classes.TRANSITION_CONTAINER, (_b = {}, _b[positionClasses] = inline, _b));
        var popoverClasses = classNames(Classes.POPOVER, (_c = {}, _c[Classes.DARK] = this.props.inheritDarkTheme && this.hasDarkParent && !inline, _c), this.props.popoverClassName);
        var styles = this.getArrowPositionStyles();
        var transform = { transformOrigin: this.getPopoverTransformOrigin() };
        return React.createElement("div", { className: containerClasses, ref: this.refHandlers.popover, style: styles.container }, React.createElement("div", tslib_1.__assign({ className: popoverClasses, style: transform }, popoverHandlers), React.createElement("div", { className: Classes.POPOVER_ARROW, style: styles.arrow }, React.createElement("svg", { viewBox: "0 0 30 30" }, React.createElement("path", { className: Classes.POPOVER_ARROW + "-border", d: SVG_SHADOW_PATH }), React.createElement("path", { className: Classes.POPOVER_ARROW + "-fill", d: SVG_ARROW_PATH }))), React.createElement("div", { className: Classes.POPOVER_CONTENT }, content)));
        var _b, _c;
    };
    // content and target can be specified as props or as children.
    // this method normalizes the two approaches, preferring child over prop.
    Popover.prototype.understandChildren = function () {
        var _a = this.props,
            children = _a.children,
            contentProp = _a.content,
            targetProp = _a.target;
        // #validateProps asserts that 1 <= children.length <= 2 so content is optional
        var _b = React.Children.toArray(children),
            targetChild = _b[0],
            contentChild = _b[1];
        return {
            content: ensureElement(contentChild == null ? contentProp : contentChild),
            target: ensureElement(targetChild == null ? targetProp : targetChild)
        };
    };
    Popover.prototype.getArrowPositionStyles = function () {
        if (this.props.useSmartArrowPositioning) {
            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
            return Arrows.getArrowPositionStyles(this.props.position, this.props.arrowSize, this.state.ignoreTargetDimensions, dimensions, this.props.inline);
        } else {
            return {};
        }
    };
    Popover.prototype.getPopoverTransformOrigin = function () {
        // if smart positioning is enabled then we must rely on CSS classes to put transform origin
        // on the correct side and cannot override it in JS. (https://github.com/HubSpot/tether/issues/154)
        if (this.props.useSmartArrowPositioning && !this.props.useSmartPositioning) {
            var dimensions = { height: this.state.targetHeight, width: this.state.targetWidth };
            return Arrows.getPopoverTransformOrigin(this.props.position, this.props.arrowSize, dimensions);
        } else {
            return undefined;
        }
    };
    Popover.prototype.updateArrowPosition = function () {
        if (this.popoverElement != null) {
            var arrow = this.popoverElement.getElementsByClassName(Classes.POPOVER_ARROW)[0];
            var centerWidth = (this.state.targetWidth + arrow.clientWidth) / 2;
            var centerHeight = (this.state.targetHeight + arrow.clientHeight) / 2;
            var ignoreWidth = centerWidth > this.popoverElement.clientWidth && PosUtils.isPositionHorizontal(this.props.position);
            var ignoreHeight = centerHeight > this.popoverElement.clientHeight && PosUtils.isPositionVertical(this.props.position);
            if (!this.state.ignoreTargetDimensions && (ignoreWidth || ignoreHeight)) {
                this.setState({ ignoreTargetDimensions: true });
            } else if (this.state.ignoreTargetDimensions && !ignoreWidth && !ignoreHeight) {
                this.setState({ ignoreTargetDimensions: false });
            }
        }
    };
    Popover.prototype.updateTether = function () {
        var _this = this;
        if (this.state.isOpen && !this.props.inline && this.popoverElement != null) {
            var _a = this.props,
                constraints = _a.constraints,
                position = _a.position,
                _b = _a.tetherOptions,
                tetherOptions = _b === void 0 ? {} : _b,
                useSmartPositioning = _a.useSmartPositioning;
            // the .pt-popover-target span we wrap the children in won't always be as big as its children
            // so instead, we'll position tether based off of its first child.
            // NOTE: use findDOMNode(this) directly because this.targetElement may not exist yet
            var target = react_dom_1.findDOMNode(this).childNodes[0];
            // constraints is deprecated but must still be supported through tetherOptions until v2.0
            var options = constraints == null && !useSmartPositioning ? tetherOptions : tslib_1.__assign({}, tetherOptions, { constraints: useSmartPositioning ? [SMART_POSITIONING] : constraints });
            var finalTetherOptions = TetherUtils.createTetherOptions(this.popoverElement, target, position, options);
            if (this.tether == null) {
                this.tether = new Tether(finalTetherOptions);
            } else {
                this.tether.setOptions(finalTetherOptions);
            }
            // if props.position has just changed, Tether unfortunately positions the popover based
            // on the margins from the previous position. delay a frame for styles to catch up.
            setTimeout(function () {
                return _this.tether.position();
            });
        } else {
            this.destroyTether();
        }
    };
    Popover.prototype.destroyTether = function () {
        if (this.tether != null) {
            this.tether.destroy();
        }
    };
    // a wrapper around setState({isOpen}) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    Popover.prototype.setOpenState = function (isOpen, e, timeout) {
        var _this = this;
        // cancel any existing timeout because we have new state
        Utils.safeInvoke(this.cancelOpenTimeout);
        if (timeout > 0) {
            this.cancelOpenTimeout = this.setTimeout(function () {
                return _this.setOpenState(isOpen, e);
            }, timeout);
        } else {
            if (this.props.isOpen == null) {
                this.setState({ isOpen: isOpen });
            } else {
                Utils.safeInvoke(this.props.onInteraction, isOpen);
            }
            if (!isOpen) {
                Utils.safeInvoke(this.props.onClose, e);
            }
        }
    };
    Popover.prototype.isElementInPopover = function (element) {
        return this.popoverElement != null && this.popoverElement.contains(element);
    };
    Popover.prototype.isHoverInteractionKind = function () {
        return this.props.interactionKind === PopoverInteractionKind.HOVER || this.props.interactionKind === PopoverInteractionKind.HOVER_TARGET_ONLY;
    };
    return Popover;
}(abstractComponent_1.AbstractComponent);
Popover.defaultProps = {
    arrowSize: 30,
    className: "",
    defaultIsOpen: false,
    hoverCloseDelay: 300,
    hoverOpenDelay: 150,
    inheritDarkTheme: true,
    inline: false,
    interactionKind: PopoverInteractionKind.CLICK,
    isDisabled: false,
    isModal: false,
    openOnTargetFocus: true,
    popoverClassName: "",
    position: PosUtils.Position.RIGHT,
    rootElementTag: "span",
    transitionDuration: 300,
    useSmartArrowPositioning: true,
    useSmartPositioning: false
};
Popover.displayName = "Blueprint.Popover";
Popover = tslib_1.__decorate([PureRender], Popover);
exports.Popover = Popover;
/**
 * Converts a react child to an element: non-empty strings or numbers are wrapped in `<span>`;
 * empty strings are discarded.
 */
function ensureElement(child) {
    // wrap text in a <span> so children are always elements
    if (typeof child === "string") {
        // cull whitespace strings
        return child.trim().length > 0 ? React.createElement("span", null, child) : undefined;
    } else if (typeof child === "number") {
        return React.createElement("span", null, child);
    } else {
        return child;
    }
}
exports.PopoverFactory = React.createFactory(Popover);

//# sourceMappingURL=popover.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1612), __esModule: true };

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1589);

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(125);
var document = __webpack_require__(64).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(222);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(403);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(319)('meta');
var isObject = __webpack_require__(95);
var has = __webpack_require__(193);
var setDesc = __webpack_require__(162).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(227)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1673);

if (typeof React === 'undefined') {
  throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(907);


function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1894),
    getValue = __webpack_require__(1907);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1972),
    getValue = __webpack_require__(1985);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(104);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(80),
    isKey = __webpack_require__(659),
    stringToPath = __webpack_require__(2155),
    toString = __webpack_require__(2177);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(337);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1008),
    baseKeys = __webpack_require__(2068),
    isArrayLike = __webpack_require__(238);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(112);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(function (droppable, draggables) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(draggables).map(function (id) {
    return draggables[id];
  }).filter(function (draggable) {
    return droppable.descriptor.id === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
}));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);



/* harmony default export */ __webpack_exports__["a"] = (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["c" /* add */])(point, closestScrollable.scroll.diff.displacement);
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.notify = notify;
exports.instanceId = instanceId;
exports.isFirstFocusedRender = isFirstFocusedRender;
var idCount = 0;

function uniqueId(prefix) {
  return '' + ((prefix == null ? '' : prefix) + ++idCount);
}

function notify(handler, args) {
  handler && handler.apply(null, [].concat(args));
}

function instanceId(component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  component.__id || (component.__id = uniqueId('rw_'));
  return (component.props.id || component.__id) + suffix;
}

function isFirstFocusedRender(component) {
  return component._firstFocus || component.state.focused && (component._firstFocus = true);
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Determine if a given value is an object that implements the `RelayEnvironment`
 * interface.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isClassicRelayEnvironment(environment) {
  return (typeof environment === 'undefined' ? 'undefined' : _typeof(environment)) === 'object' && environment !== null && typeof environment.applyMutation === 'function' && typeof environment.sendMutation === 'function' && typeof environment.forceFetch === 'function' && typeof environment.getFragmentResolver === 'function' && typeof environment.getStoreData === 'function' && typeof environment.primeCache === 'function';
}

module.exports = isClassicRelayEnvironment;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _consolidatedEvents = __webpack_require__(1600);

var _propTypes = __webpack_require__(2460);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _computeOffsetPixels = __webpack_require__(2450);

var _computeOffsetPixels2 = _interopRequireDefault(_computeOffsetPixels);

var _constants = __webpack_require__(1268);

var _constants2 = _interopRequireDefault(_constants);

var _debugLog = __webpack_require__(2451);

var _debugLog2 = _interopRequireDefault(_debugLog);

var _ensureChildrenIsSingleDOMElement = __webpack_require__(2452);

var _ensureChildrenIsSingleDOMElement2 = _interopRequireDefault(_ensureChildrenIsSingleDOMElement);

var _getCurrentPosition = __webpack_require__(2453);

var _getCurrentPosition2 = _interopRequireDefault(_getCurrentPosition);

var _onNextTick = __webpack_require__(2455);

var _onNextTick2 = _interopRequireDefault(_onNextTick);

var _resolveScrollableAncestorProp = __webpack_require__(2458);

var _resolveScrollableAncestorProp2 = _interopRequireDefault(_resolveScrollableAncestorProp);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function onEnter() {},
  onLeave: function onLeave() {},
  onPositionChange: function onPositionChange() {},

  fireOnRapidScroll: true
};

/**
 * Calls a function when you scroll to the element.
 */

var Waypoint = function (_React$Component) {
  _inherits(Waypoint, _React$Component);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _ensureChildrenIsSingleDOMElement2.default)(this.props.children);

      if (this.props.scrollableParent) {
        // eslint-disable-line react/prop-types
        throw new Error('The `scrollableParent` prop has changed name to `scrollableAncestor`.');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!Waypoint.getWindow()) {
        return;
      }

      // this._ref may occasionally not be set at this time. To help ensure that
      // this works smoothly, we want to delay the initial execution until the
      // next tick.
      this.cancelInitialTimeout = (0, _onNextTick2.default)(function () {
        _this2._handleScroll = _this2._handleScroll.bind(_this2);
        _this2.scrollableAncestor = _this2._findScrollableAncestor();

        if (false) {
          (0, _debugLog2.default)('scrollableAncestor', _this2.scrollableAncestor);
        }

        _this2.scrollEventListenerUnsubscribe = (0, _consolidatedEvents.addEventListener)(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

        _this2.resizeEventListenerUnsubscribe = (0, _consolidatedEvents.addEventListener)(window, 'resize', _this2._handleScroll, { passive: true });

        _this2._handleScroll(null);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      (0, _ensureChildrenIsSingleDOMElement2.default)(nextProps.children);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!Waypoint.getWindow()) {
        return;
      }

      if (!this.scrollableAncestor) {
        // The Waypoint has not yet initialized.
        return;
      }

      // The element may have moved.
      this._handleScroll(null);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!Waypoint.getWindow()) {
        return;
      }

      if (this.scrollEventListenerUnsubscribe) {
        this.scrollEventListenerUnsubscribe();
      }
      if (this.resizeEventListenerUnsubscribe) {
        this.resizeEventListenerUnsubscribe();
      }

      if (this.cancelInitialTimeout) {
        this.cancelInitialTimeout();
      }
    }

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function _findScrollableAncestor() {
      var _props = this.props,
          horizontal = _props.horizontal,
          scrollableAncestor = _props.scrollableAncestor;

      if (scrollableAncestor) {
        return (0, _resolveScrollableAncestorProp2.default)(scrollableAncestor);
      }

      var node = this._ref;

      while (node.parentNode) {
        node = node.parentNode;

        if (node === document.body) {
          // We've reached all the way to the root node.
          return window;
        }

        var style = window.getComputedStyle(node);
        var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
        var overflow = overflowDirec || style.getPropertyValue('overflow');

        if (overflow === 'auto' || overflow === 'scroll') {
          return node;
        }
      }

      // A scrollable ancestor element was not found, which means that we need to
      // do stuff on window.
      return window;
    }

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function _handleScroll(event) {
      if (!this._ref) {
        // There's a chance we end up here after the component has been unmounted.
        return;
      }

      var bounds = this._getBounds();
      var currentPosition = (0, _getCurrentPosition2.default)(bounds);
      var previousPosition = this._previousPosition;

      if (false) {
        (0, _debugLog2.default)('currentPosition', currentPosition);
        (0, _debugLog2.default)('previousPosition', previousPosition);
      }

      // Save previous position as early as possible to prevent cycles
      this._previousPosition = currentPosition;

      if (previousPosition === currentPosition) {
        // No change since last trigger
        return;
      }

      var callbackArg = {
        currentPosition: currentPosition,
        previousPosition: previousPosition,
        event: event,
        waypointTop: bounds.waypointTop,
        waypointBottom: bounds.waypointBottom,
        viewportTop: bounds.viewportTop,
        viewportBottom: bounds.viewportBottom
      };
      this.props.onPositionChange.call(this, callbackArg);

      if (currentPosition === _constants2.default.inside) {
        this.props.onEnter.call(this, callbackArg);
      } else if (previousPosition === _constants2.default.inside) {
        this.props.onLeave.call(this, callbackArg);
      }

      var isRapidScrollDown = previousPosition === _constants2.default.below && currentPosition === _constants2.default.above;
      var isRapidScrollUp = previousPosition === _constants2.default.above && currentPosition === _constants2.default.below;

      if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
        // If the scroll event isn't fired often enough to occur while the
        // waypoint was visible, we trigger both callbacks anyway.
        this.props.onEnter.call(this, {
          currentPosition: _constants2.default.inside,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
        this.props.onLeave.call(this, {
          currentPosition: currentPosition,
          previousPosition: _constants2.default.inside,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
      }
    }
  }, {
    key: '_getBounds',
    value: function _getBounds() {
      var horizontal = this.props.horizontal;

      var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
          left = _ref$getBoundingClien.left,
          top = _ref$getBoundingClien.top,
          right = _ref$getBoundingClien.right,
          bottom = _ref$getBoundingClien.bottom;

      var waypointTop = horizontal ? left : top;
      var waypointBottom = horizontal ? right : bottom;

      var contextHeight = void 0;
      var contextScrollTop = void 0;
      if (this.scrollableAncestor === window) {
        contextHeight = horizontal ? window.innerWidth : window.innerHeight;
        contextScrollTop = 0;
      } else {
        contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
        contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
      }

      if (false) {
        (0, _debugLog2.default)('waypoint top', waypointTop);
        (0, _debugLog2.default)('waypoint bottom', waypointBottom);
        (0, _debugLog2.default)('scrollableAncestor height', contextHeight);
        (0, _debugLog2.default)('scrollableAncestor scrollTop', contextScrollTop);
      }

      var _props2 = this.props,
          bottomOffset = _props2.bottomOffset,
          topOffset = _props2.topOffset;

      var topOffsetPx = (0, _computeOffsetPixels2.default)(topOffset, contextHeight);
      var bottomOffsetPx = (0, _computeOffsetPixels2.default)(bottomOffset, contextHeight);
      var contextBottom = contextScrollTop + contextHeight;

      return {
        waypointTop: waypointTop,
        waypointBottom: waypointBottom,
        viewportTop: contextScrollTop + topOffsetPx,
        viewportBottom: contextBottom - bottomOffsetPx
      };
    }

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var children = this.props.children;

      if (!children) {
        // We need an element that we can locate in the DOM to determine where it is
        // rendered relative to the top of its context.
        return _react2.default.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
      }

      var ref = function ref(node) {
        _this3.refElement(node);
        if (children.ref) {
          children.ref(node);
        }
      };

      return _react2.default.cloneElement(children, { ref: ref });
    }
  }]);

  return Waypoint;
}(_react2.default.Component);

exports.default = Waypoint;

Waypoint.propTypes = {
  children: _propTypes2.default.element,
  debug: _propTypes2.default.bool,
  onEnter: _propTypes2.default.func,
  onLeave: _propTypes2.default.func,
  onPositionChange: _propTypes2.default.func,
  fireOnRapidScroll: _propTypes2.default.bool,
  scrollableAncestor: _propTypes2.default.any,
  horizontal: _propTypes2.default.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Waypoint.above = _constants2.default.above;
Waypoint.below = _constants2.default.below;
Waypoint.inside = _constants2.default.inside;
Waypoint.invisible = _constants2.default.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';
module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(2785);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(1312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Image__["a"]; });



/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(374),
    isArrayLike = __webpack_require__(142),
    isIndex = __webpack_require__(373),
    isObject = __webpack_require__(105);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(367),
    baseEach = __webpack_require__(255),
    castFunction = __webpack_require__(1399),
    isArray = __webpack_require__(51);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(2597),
    hasPath = __webpack_require__(1413);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(99),
    stubFalse = __webpack_require__(2770);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3578);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Financial.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Financial.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var stack;

if (true) {
  stack = __webpack_require__(1566);
} else {
  stack = require('./cjs/event-stack.development.js');
}

module.exports = stack.default;
module.exports.instance = stack.instance;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.

module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

    // MessageChannels are desirable because they give direct access to the HTML
    // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
    // 11-12, and in web workers in many engines.
    // Although message channels yield to any queued rendering and IO tasks, they
    // would be better than imposing the 4ms delay of timers.
    // However, they do not work reliably in Internet Explorer or Safari.

    // Internet Explorer 10 is the only browser that has setImmediate but does
    // not have MutationObservers.
    // Although setImmediate yields to the browser's renderer, it would be
    // preferrable to falling back to setTimeout since it does not have
    // the minimum 4ms penalty.
    // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
    // Desktop to a lesser extent) that renders both setImmediate and
    // MessageChannel useless for the purposes of ASAP.
    // https://github.com/kriskowal/q/issues/396

    // Timers are implemented universally.
    // We fall back to timers in workers in most engines, and in foreground
    // contexts in the following browsers.
    // However, note that even this simple case requires nuances to operate in a
    // broad spectrum of browsers.
    //
    // - Firefox 3-13
    // - Internet Explorer 6-9
    // - iPad Safari 4.3
    // - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, { characterData: true });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(554), __esModule: true };

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(124)(function () {
  return Object.defineProperty(__webpack_require__(270)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(159);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(190);
var $export = __webpack_require__(63);
var redefine = __webpack_require__(313);
var hide = __webpack_require__(101);
var has = __webpack_require__(94);
var Iterators = __webpack_require__(128);
var $iterCreate = __webpack_require__(561);
var setToStringTag = __webpack_require__(191);
var getPrototypeOf = __webpack_require__(401);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(147);
var createDesc = __webpack_require__(129);
var toIObject = __webpack_require__(88);
var toPrimitive = __webpack_require__(223);
var has = __webpack_require__(94);
var IE8_DOM_DEFINE = __webpack_require__(307);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(87) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(312);
var hiddenKeys = __webpack_require__(217).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(94);
var toIObject = __webpack_require__(88);
var arrayIndexOf = __webpack_require__(557)(false);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(101);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(396);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(128);
module.exports = __webpack_require__(45).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(574);
var global = __webpack_require__(64);
var hide = __webpack_require__(101);
var Iterators = __webpack_require__(128);
var TO_STRING_TAG = __webpack_require__(56)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(162).f;
var has = __webpack_require__(193);
var TAG = __webpack_require__(96)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x === null ? NaN : +x;
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(1703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__ = __webpack_require__(899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed__ = __webpack_require__(1710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__ = __webpack_require__(1711);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound__ = __webpack_require__(1712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound__["a"]; });







/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__basis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__(1736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return __WEBPACK_IMPORTED_MODULE_5__discrete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__(1739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return __WEBPACK_IMPORTED_MODULE_6__hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__(1743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__(911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_10__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__(1745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__(1747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_12__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__(910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__(1738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__(1740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15__lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__(1737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__(1735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__(1741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_18__piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__(1742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_19__quantize__["a"]; });





















/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path__ = __webpack_require__(1748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path__["a"]; });


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["l"] = acos;
/* harmony export (immutable) */ __webpack_exports__["k"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  var n = series.length,
      o = new Array(n);
  while (--n >= 0) {
    o[n] = n;
  }return o;
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat__ = __webpack_require__(935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_2__isoFormat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse__ = __webpack_require__(1823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_3__isoParse__["a"]; });





/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isObject = function isObject(val) {
  return val !== null && !Array.isArray(val) && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
};

var codes = {
  // ----------------------------------------
  // By Code
  // ----------------------------------------
  3: 'Cancel',
  6: 'Help',
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  28: 'Convert',
  29: 'NonConvert',
  30: 'Accept',
  31: 'ModeChange',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  44: 'PrintScreen',
  45: 'Insert',
  46: 'Delete',
  48: ['0', ')'],
  49: ['1', '!'],
  50: ['2', '@'],
  51: ['3', '#'],
  52: ['4', '$'],
  53: ['5', '%'],
  54: ['6', '^'],
  55: ['7', '&'],
  56: ['8', '*'],
  57: ['9', '('],
  91: 'OS',
  93: 'ContextMenu',
  144: 'NumLock',
  145: 'ScrollLock',
  181: 'VolumeMute',
  182: 'VolumeDown',
  183: 'VolumeUp',
  186: [';', ':'],
  187: ['=', '+'],
  188: [',', '<'],
  189: ['-', '_'],
  190: ['.', '>'],
  191: ['/', '?'],
  192: ['`', '~'],
  219: ['[', '{'],
  220: ['\\', '|'],
  221: [']', '}'],
  222: ["'", '"'],
  224: 'Meta',
  225: 'AltGraph',
  246: 'Attn',
  247: 'CrSel',
  248: 'ExSel',
  249: 'EraseEof',
  250: 'Play',
  251: 'ZoomOut'

  // Function Keys (F1-24)
};for (var i = 0; i < 24; i += 1) {
  codes[112 + i] = 'F' + (i + 1);
}

// Alphabet (a-Z)
for (var j = 0; j < 26; j += 1) {
  var n = j + 65;
  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)];
}

var keyboardKey = {
  codes: codes,

  /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */
  getCode: function getCode(eventOrKey) {
    if (isObject(eventOrKey)) {
      return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key];
    }
    return this[eventOrKey];
  },

  /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */
  getKey: function getKey(eventOrCode) {
    var isEvent = isObject(eventOrCode);

    // handle events with a `key` already defined
    if (isEvent && eventOrCode.key) {
      return eventOrCode.key;
    }

    var name = codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode];

    if (Array.isArray(name)) {
      if (isEvent) {
        name = name[eventOrCode.shiftKey ? 1 : 0];
      } else {
        name = name[0];
      }
    }

    return name;
  },

  // ----------------------------------------
  // By Name
  // ----------------------------------------
  // declare these manually for static analysis
  Cancel: 3,
  Help: 6,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Enter: 13,
  Shift: 16,
  Control: 17,
  Alt: 18,
  Pause: 19,
  CapsLock: 20,
  Escape: 27,
  Convert: 28,
  NonConvert: 29,
  Accept: 30,
  ModeChange: 31,
  ' ': 32,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Select: 41,
  Print: 42,
  Execute: 43,
  PrintScreen: 44,
  Insert: 45,
  Delete: 46,
  0: 48,
  ')': 48,
  1: 49,
  '!': 49,
  2: 50,
  '@': 50,
  3: 51,
  '#': 51,
  4: 52,
  $: 52,
  5: 53,
  '%': 53,
  6: 54,
  '^': 54,
  7: 55,
  '&': 55,
  8: 56,
  '*': 56,
  9: 57,
  '(': 57,
  a: 65,
  A: 65,
  b: 66,
  B: 66,
  c: 67,
  C: 67,
  d: 68,
  D: 68,
  e: 69,
  E: 69,
  f: 70,
  F: 70,
  g: 71,
  G: 71,
  h: 72,
  H: 72,
  i: 73,
  I: 73,
  j: 74,
  J: 74,
  k: 75,
  K: 75,
  l: 76,
  L: 76,
  m: 77,
  M: 77,
  n: 78,
  N: 78,
  o: 79,
  O: 79,
  p: 80,
  P: 80,
  q: 81,
  Q: 81,
  r: 82,
  R: 82,
  s: 83,
  S: 83,
  t: 84,
  T: 84,
  u: 85,
  U: 85,
  v: 86,
  V: 86,
  w: 87,
  W: 87,
  x: 88,
  X: 88,
  y: 89,
  Y: 89,
  z: 90,
  Z: 90,
  OS: 91,
  ContextMenu: 93,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NumLock: 144,
  ScrollLock: 145,
  VolumeMute: 181,
  VolumeDown: 182,
  VolumeUp: 183,
  ';': 186,
  ':': 186,
  '=': 187,
  '+': 187,
  ',': 188,
  '<': 188,
  '-': 189,
  _: 189,
  '.': 190,
  '>': 190,
  '/': 191,
  '?': 191,
  '`': 192,
  '~': 192,
  '[': 219,
  '{': 219,
  '\\': 220,
  '|': 220,
  ']': 221,
  '}': 221,
  "'": 222,
  '"': 222,
  Meta: 224,
  AltGraph: 225,
  Attn: 246,
  CrSel: 247,
  ExSel: 248,
  EraseEof: 249,
  Play: 250,
  ZoomOut: 251

  // ----------------------------------------
  // By Alias
  // ----------------------------------------
  // provide dot-notation accessible keys for all key names
};keyboardKey.Spacebar = keyboardKey[' '];
keyboardKey.Digit0 = keyboardKey['0'];
keyboardKey.Digit1 = keyboardKey['1'];
keyboardKey.Digit2 = keyboardKey['2'];
keyboardKey.Digit3 = keyboardKey['3'];
keyboardKey.Digit4 = keyboardKey['4'];
keyboardKey.Digit5 = keyboardKey['5'];
keyboardKey.Digit6 = keyboardKey['6'];
keyboardKey.Digit7 = keyboardKey['7'];
keyboardKey.Digit8 = keyboardKey['8'];
keyboardKey.Digit9 = keyboardKey['9'];
keyboardKey.Tilde = keyboardKey['~'];
keyboardKey.GraveAccent = keyboardKey['`'];
keyboardKey.ExclamationPoint = keyboardKey['!'];
keyboardKey.AtSign = keyboardKey['@'];
keyboardKey.PoundSign = keyboardKey['#'];
keyboardKey.PercentSign = keyboardKey['%'];
keyboardKey.Caret = keyboardKey['^'];
keyboardKey.Ampersand = keyboardKey['&'];
keyboardKey.PlusSign = keyboardKey['+'];
keyboardKey.MinusSign = keyboardKey['-'];
keyboardKey.EqualsSign = keyboardKey['='];
keyboardKey.DivisionSign = keyboardKey['/'];
keyboardKey.MultiplicationSign = keyboardKey['*'];
keyboardKey.Comma = keyboardKey[','];
keyboardKey.Decimal = keyboardKey['.'];
keyboardKey.Colon = keyboardKey[':'];
keyboardKey.Semicolon = keyboardKey[';'];
keyboardKey.Pipe = keyboardKey['|'];
keyboardKey.BackSlash = keyboardKey['\\'];
keyboardKey.QuestionMark = keyboardKey['?'];
keyboardKey.SingleQuote = keyboardKey["'"];
keyboardKey.DoubleQuote = keyboardKey['"'];
keyboardKey.LeftCurlyBrace = keyboardKey['{'];
keyboardKey.RightCurlyBrace = keyboardKey['}'];
keyboardKey.LeftParenthesis = keyboardKey['('];
keyboardKey.RightParenthesis = keyboardKey[')'];
keyboardKey.LeftAngleBracket = keyboardKey['<'];
keyboardKey.RightAngleBracket = keyboardKey['>'];
keyboardKey.LeftSquareBracket = keyboardKey['['];
keyboardKey.RightSquareBracket = keyboardKey[']'];

module.exports = keyboardKey;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(110);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(335),
    overRest = __webpack_require__(1044),
    setToString = __webpack_require__(661);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(282),
    isArrayLike = __webpack_require__(238),
    isIndex = __webpack_require__(333),
    isObject = __webpack_require__(110);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(104),
    stubFalse = __webpack_require__(2174);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1008),
    baseKeysIn = __webpack_require__(2069),
    isArrayLike = __webpack_require__(238);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_displacement_map__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visibility_is_visible__ = __webpack_require__(680);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var id = draggable.descriptor.id;
  var map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_displacement_map__["a" /* default */])(previousImpact.movement.displaced);

  var isVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__visibility_is_visible__["a" /* isPartiallyVisible */])({
    target: draggable.page.marginBox,
    destination: destination,
    viewport: viewport
  });

  var shouldAnimate = function () {
    if (!isVisible) {
      return false;
    }

    var previous = map[id];

    if (!previous) {
      return true;
    }

    return previous.shouldAnimate;
  }();

  var displacement = {
    draggableId: id,
    isVisible: isVisible,
    shouldAnimate: shouldAnimate
  };

  return displacement;
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var source = _ref.source,
      sourceEdge = _ref.sourceEdge,
      destination = _ref.destination,
      destinationEdge = _ref.destinationEdge,
      destinationAxis = _ref.destinationAxis;

  var getCorner = function getCorner(area) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["e" /* patch */])(destinationAxis.line, area[destinationAxis[destinationEdge]], area[destinationAxis.crossAxisStart]);
  };

  var corner = getCorner(destination);

  var centerDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["f" /* absolute */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(source.center, getCorner(source)));

  var signed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["e" /* patch */])(destinationAxis.line, (sourceEdge === 'end' ? -1 : 1) * centerDiff[destinationAxis.line], centerDiff[destinationAxis.crossAxisLine]);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["c" /* add */])(corner, signed);
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offsetByPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return expandByPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expandBySpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shrinkBySpacing; });
/* unused harmony export isEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCorners; });


var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};

var expandByPosition = function expandByPosition(spacing, position) {
  return {
    top: spacing.top - position.y,
    left: spacing.left - position.x,

    right: spacing.right + position.x,
    bottom: spacing.bottom + position.y
  };
};

var expandBySpacing = function expandBySpacing(spacing1, spacing2) {
  return {
    top: spacing1.top - spacing2.top,
    left: spacing1.left - spacing2.left,

    bottom: spacing1.bottom + spacing2.bottom,
    right: spacing1.right + spacing2.right
  };
};

var shrinkBySpacing = function shrinkBySpacing(spacing1, spacing2) {
  return {
    top: spacing1.top + spacing2.top,
    left: spacing1.left + spacing2.left,

    bottom: spacing1.bottom - spacing2.bottom,
    right: spacing1.right - spacing2.right
  };
};

var isEqual = function isEqual(spacing1, spacing2) {
  return spacing1.top === spacing2.top && spacing1.right === spacing2.right && spacing1.bottom === spacing2.bottom && spacing1.left === spacing2.left;
};

var getCorners = function getCorners(spacing) {
  return [{ x: spacing.left, y: spacing.top }, { x: spacing.right, y: spacing.top }, { x: spacing.left, y: spacing.bottom }, { x: spacing.right, y: spacing.bottom }];
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.endOfRange = endOfRange;
exports.eventSegments = eventSegments;
exports.eventLevels = eventLevels;
exports.inRange = inRange;
exports.segsOverlap = segsOverlap;
exports.sortEvents = sortEvents;

var _findIndex = __webpack_require__(1049);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _accessors = __webpack_require__(239);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function endOfRange(dateRange) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';

  return {
    first: dateRange[0],
    last: _dates2.default.add(dateRange[dateRange.length - 1], 1, unit)
  };
}

function eventSegments(event, first, last, _ref, range) {
  var startAccessor = _ref.startAccessor,
      endAccessor = _ref.endAccessor;

  var slots = _dates2.default.diff(first, last, 'day');
  var start = _dates2.default.max(_dates2.default.startOf((0, _accessors.accessor)(event, startAccessor), 'day'), first);
  var end = _dates2.default.min(_dates2.default.ceil((0, _accessors.accessor)(event, endAccessor), 'day'), last);

  var padding = (0, _findIndex2.default)(range, function (x) {
    return _dates2.default.eq(x, start, 'day');
  });
  var span = _dates2.default.diff(start, end, 'day');

  span = Math.min(span, slots);
  span = Math.max(span, 1);

  return {
    event: event,
    span: span,
    left: padding + 1,
    right: Math.max(padding + span, 1)
  };
}

function eventLevels(rowSegments) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  var i = void 0,
      j = void 0,
      seg = void 0,
      levels = [],
      extra = [];

  for (i = 0; i < rowSegments.length; i++) {
    seg = rowSegments[i];

    for (j = 0; j < levels.length; j++) {
      if (!segsOverlap(seg, levels[j])) break;
    }if (j >= limit) {
      extra.push(seg);
    } else {
      ;(levels[j] || (levels[j] = [])).push(seg);
    }
  }

  for (i = 0; i < levels.length; i++) {
    levels[i].sort(function (a, b) {
      return a.left - b.left;
    }); //eslint-disable-line
  }

  return { levels: levels, extra: extra };
}

function inRange(e, start, end, _ref2) {
  var startAccessor = _ref2.startAccessor,
      endAccessor = _ref2.endAccessor;

  var eStart = _dates2.default.startOf((0, _accessors.accessor)(e, startAccessor), 'day');
  var eEnd = (0, _accessors.accessor)(e, endAccessor);

  var startsBeforeEnd = _dates2.default.lte(eStart, end, 'day');
  // when the event is zero duration we need to handle a bit differently
  var endsAfterStart = !_dates2.default.eq(eStart, eEnd, 'minutes') ? _dates2.default.gt(eEnd, start, 'minutes') : _dates2.default.gte(eEnd, start, 'minutes');

  return startsBeforeEnd && endsAfterStart;
}

function segsOverlap(seg, otherSegs) {
  return otherSegs.some(function (otherSeg) {
    return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
  });
}

function sortEvents(evtA, evtB, _ref3) {
  var startAccessor = _ref3.startAccessor,
      endAccessor = _ref3.endAccessor,
      allDayAccessor = _ref3.allDayAccessor;

  var startSort = +_dates2.default.startOf((0, _accessors.accessor)(evtA, startAccessor), 'day') - +_dates2.default.startOf((0, _accessors.accessor)(evtB, startAccessor), 'day');

  var durA = _dates2.default.diff((0, _accessors.accessor)(evtA, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtA, endAccessor), 'day'), 'day');

  var durB = _dates2.default.diff((0, _accessors.accessor)(evtB, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtB, endAccessor), 'day'), 'day');

  return startSort || // sort by start Day first
  Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
  !!(0, _accessors.accessor)(evtB, allDayAccessor) - !!(0, _accessors.accessor)(evtA, allDayAccessor) || // then allDay single day events
  +(0, _accessors.accessor)(evtA, startAccessor) - +(0, _accessors.accessor)(evtB, startAccessor); // then sort by start time
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isSelected = isSelected;
exports.slotWidth = slotWidth;
exports.getCellAtX = getCellAtX;
exports.pointInBox = pointInBox;
exports.dateCellSelection = dateCellSelection;
function isSelected(event, selected) {
  if (!event || selected == null) return false;
  return [].concat(selected).indexOf(event) !== -1;
}

function slotWidth(rowBox, slots) {
  var rowWidth = rowBox.right - rowBox.left;
  var cellWidth = rowWidth / slots;

  return cellWidth;
}

function getCellAtX(rowBox, x, cellWidth, rtl, slots) {
  return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}

function pointInBox(box, _ref) {
  var x = _ref.x,
      y = _ref.y;

  return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}

function dateCellSelection(start, rowBox, box, slots, rtl) {
  var startIdx = -1;
  var endIdx = -1;
  var lastSlotIdx = slots - 1;

  var cellWidth = slotWidth(rowBox, slots);

  // cell under the mouse
  var currentSlot = getCellAtX(rowBox, box.x, cellWidth, rtl, slots);

  // Identify row as either the initial row
  // or the row under the current mouse point
  var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
  var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;

  // this row's position relative to the start point
  var isAboveStart = start.y > rowBox.bottom;
  var isBelowStart = rowBox.top > start.y;
  var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;

  // this row is between the current and start rows, so entirely selected
  if (isBetween) {
    startIdx = 0;
    endIdx = lastSlotIdx;
  }

  if (isCurrentRow) {
    if (isBelowStart) {
      startIdx = 0;
      endIdx = currentSlot;
    } else if (isAboveStart) {
      startIdx = currentSlot;
      endIdx = lastSlotIdx;
    }
  }

  if (isStartRow) {
    // select the cell under the initial point
    startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);

    if (isCurrentRow) {
      if (currentSlot < startIdx) startIdx = currentSlot;else endIdx = currentSlot; //select current range
    } else if (start.y < box.y) {
      // the current row is below start row
      // select cells to the right of the start cell
      endIdx = lastSlotIdx;
    } else {
      // select cells to the left of the start cell
      startIdx = 0;
    }
  }

  return { startIdx: startIdx, endIdx: endIdx };
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(0), __webpack_require__(1216), __webpack_require__(860));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1216), __webpack_require__(860)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["ReactClipboard"] = factory(require("react"), require("prop-types"), require("clipboard"));else root["ReactClipboard"] = factory(root["React"], root["PropTypes"], root["Clipboard"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_42__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};

			/******/ // The require function
			/******/function __webpack_require__(moduleId) {

				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;

				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };

				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

				/******/ // Flag the module as loaded
				/******/module.loaded = true;

				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}

			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;

			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;

			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "";

			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			'use strict';

			var _get = __webpack_require__(1)['default'];

			var _inherits = __webpack_require__(17)['default'];

			var _createClass = __webpack_require__(26)['default'];

			var _classCallCheck = __webpack_require__(29)['default'];

			var _extends = __webpack_require__(30)['default'];

			var _Object$keys = __webpack_require__(36)['default'];

			var _interopRequireDefault = __webpack_require__(39)['default'];

			Object.defineProperty(exports, '__esModule', {
				value: true
			});

			var _react = __webpack_require__(40);

			var _react2 = _interopRequireDefault(_react);

			var _propTypes = __webpack_require__(41);

			var _propTypes2 = _interopRequireDefault(_propTypes);

			var ClipboardButton = function (_React$Component) {
				_inherits(ClipboardButton, _React$Component);

				function ClipboardButton() {
					_classCallCheck(this, ClipboardButton);

					_get(Object.getPrototypeOf(ClipboardButton.prototype), 'constructor', this).apply(this, arguments);
				}

				_createClass(ClipboardButton, [{
					key: 'propsWith',

					/* Returns a object with all props that fulfill a certain naming pattern
      *
      * @param {RegExp} regexp - Regular expression representing which pattern
      *                          you'll be searching for.
      * @param {Boolean} remove - Determines if the regular expression should be
      *                           removed when transmitting the key from the props
      *                           to the new object.
      *
      * e.g:
      *
      * // Considering:
      * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
      *
      * // *RegExps not using // so that this comment doesn't break up
      * this.propsWith(option-*, true); // returns {foo: 1}
      * this.propsWith(on*, true); // returns {Bar: 2}
      * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
      */
					value: function propsWith(regexp) {
						var remove = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

						var object = {};

						_Object$keys(this.props).forEach(function (key) {
							if (key.search(regexp) !== -1) {
								var objectKey = remove ? key.replace(regexp, '') : key;
								object[objectKey] = this.props[key];
							}
						}, this);

						return object;
					}
				}, {
					key: 'componentWillUnmount',
					value: function componentWillUnmount() {
						this.clipboard && this.clipboard.destroy();
					}
				}, {
					key: 'componentDidMount',
					value: function componentDidMount() {
						// Support old API by trying to assign this.props.options first;
						var options = this.props.options || this.propsWith(/^option-/, true);
						var element = _react2['default'].version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.refs.element;
						var Clipboard = __webpack_require__(42);
						this.clipboard = new Clipboard(element, options);

						var callbacks = this.propsWith(/^on/, true);
						_Object$keys(callbacks).forEach(function (callback) {
							this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
						}, this);
					}
				}, {
					key: 'render',
					value: function render() {
						var attributes = _extends({
							type: this.getType(),
							className: this.props.className || '',
							style: this.props.style || {},
							ref: 'element',
							onClick: this.props.onClick
						}, this.propsWith(/^data-/), this.propsWith(/^button-/, true));

						return _react2['default'].createElement(this.getComponent(), attributes, this.props.children);
					}
				}, {
					key: 'getType',
					value: function getType() {
						if (this.getComponent() === 'button' || this.getComponent() === 'input') {
							return this.props.type || 'button';
						} else {
							return undefined;
						}
					}
				}, {
					key: 'getComponent',
					value: function getComponent() {
						return this.props.component || 'button';
					}
				}], [{
					key: 'propTypes',
					value: {
						options: _propTypes2['default'].object,
						type: _propTypes2['default'].string,
						className: _propTypes2['default'].string,
						style: _propTypes2['default'].object,
						component: _propTypes2['default'].string,
						children: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object])
					},
					enumerable: true
				}, {
					key: 'defaultProps',
					value: {
						onClick: function onClick() {}
					},
					enumerable: true
				}]);

				return ClipboardButton;
			}(_react2['default'].Component);

			exports['default'] = ClipboardButton;
			module.exports = exports['default'];

			/***/
		},
		/* 1 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			var _Object$getOwnPropertyDescriptor = __webpack_require__(2)["default"];

			exports["default"] = function get(_x, _x2, _x3) {
				var _again = true;

				_function: while (_again) {
					var object = _x,
					    property = _x2,
					    receiver = _x3;
					_again = false;
					if (object === null) object = Function.prototype;

					var desc = _Object$getOwnPropertyDescriptor(object, property);

					if (desc === undefined) {
						var parent = Object.getPrototypeOf(object);

						if (parent === null) {
							return undefined;
						} else {
							_x = parent;
							_x2 = property;
							_x3 = receiver;
							_again = true;
							desc = parent = undefined;
							continue _function;
						}
					} else if ("value" in desc) {
						return desc.value;
					} else {
						var getter = desc.get;

						if (getter === undefined) {
							return undefined;
						}

						return getter.call(receiver);
					}
				}
			};

			exports.__esModule = true;

			/***/
		},
		/* 2 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(3), __esModule: true };

			/***/
		},
		/* 3 */
		/***/function (module, exports, __webpack_require__) {

			var $ = __webpack_require__(4);
			__webpack_require__(5);
			module.exports = function getOwnPropertyDescriptor(it, key) {
				return $.getDesc(it, key);
			};

			/***/
		},
		/* 4 */
		/***/function (module, exports) {

			var $Object = Object;
			module.exports = {
				create: $Object.create,
				getProto: $Object.getPrototypeOf,
				isEnum: {}.propertyIsEnumerable,
				getDesc: $Object.getOwnPropertyDescriptor,
				setDesc: $Object.defineProperty,
				setDescs: $Object.defineProperties,
				getKeys: $Object.keys,
				getNames: $Object.getOwnPropertyNames,
				getSymbols: $Object.getOwnPropertySymbols,
				each: [].forEach
			};

			/***/
		},
		/* 5 */
		/***/function (module, exports, __webpack_require__) {

			// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
			var toIObject = __webpack_require__(6);

			__webpack_require__(10)('getOwnPropertyDescriptor', function ($getOwnPropertyDescriptor) {
				return function getOwnPropertyDescriptor(it, key) {
					return $getOwnPropertyDescriptor(toIObject(it), key);
				};
			});

			/***/
		},
		/* 6 */
		/***/function (module, exports, __webpack_require__) {

			// to indexed object, toObject with fallback for non-array-like ES3 strings
			var IObject = __webpack_require__(7),
			    defined = __webpack_require__(9);
			module.exports = function (it) {
				return IObject(defined(it));
			};

			/***/
		},
		/* 7 */
		/***/function (module, exports, __webpack_require__) {

			// fallback for non-array-like ES3 and non-enumerable old V8 strings
			var cof = __webpack_require__(8);
			module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
				return cof(it) == 'String' ? it.split('') : Object(it);
			};

			/***/
		},
		/* 8 */
		/***/function (module, exports) {

			var toString = {}.toString;

			module.exports = function (it) {
				return toString.call(it).slice(8, -1);
			};

			/***/
		},
		/* 9 */
		/***/function (module, exports) {

			// 7.2.1 RequireObjectCoercible(argument)
			module.exports = function (it) {
				if (it == undefined) throw TypeError("Can't call method on  " + it);
				return it;
			};

			/***/
		},
		/* 10 */
		/***/function (module, exports, __webpack_require__) {

			// most Object methods by ES6 should accept primitives
			var $export = __webpack_require__(11),
			    core = __webpack_require__(13),
			    fails = __webpack_require__(16);
			module.exports = function (KEY, exec) {
				var fn = (core.Object || {})[KEY] || Object[KEY],
				    exp = {};
				exp[KEY] = exec(fn);
				$export($export.S + $export.F * fails(function () {
					fn(1);
				}), 'Object', exp);
			};

			/***/
		},
		/* 11 */
		/***/function (module, exports, __webpack_require__) {

			var global = __webpack_require__(12),
			    core = __webpack_require__(13),
			    ctx = __webpack_require__(14),
			    PROTOTYPE = 'prototype';

			var $export = function $export(type, name, source) {
				var IS_FORCED = type & $export.F,
				    IS_GLOBAL = type & $export.G,
				    IS_STATIC = type & $export.S,
				    IS_PROTO = type & $export.P,
				    IS_BIND = type & $export.B,
				    IS_WRAP = type & $export.W,
				    exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
				    target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE],
				    key,
				    own,
				    out;
				if (IS_GLOBAL) source = name;
				for (key in source) {
					// contains in native
					own = !IS_FORCED && target && key in target;
					if (own && key in exports) continue;
					// export native or passed
					out = own ? target[key] : source[key];
					// prevent global pollution for namespaces
					exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
					// bind timers to global for call from export context
					: IS_BIND && own ? ctx(out, global)
					// wrap global constructors for prevent change them in library
					: IS_WRAP && target[key] == out ? function (C) {
						var F = function F(param) {
							return this instanceof C ? new C(param) : C(param);
						};
						F[PROTOTYPE] = C[PROTOTYPE];
						return F;
						// make static versions for prototype methods
					}(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
					if (IS_PROTO) (exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
				}
			};
			// type bitmap
			$export.F = 1; // forced
			$export.G = 2; // global
			$export.S = 4; // static
			$export.P = 8; // proto
			$export.B = 16; // bind
			$export.W = 32; // wrap
			module.exports = $export;

			/***/
		},
		/* 12 */
		/***/function (module, exports) {

			// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
			var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
			if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

			/***/
		},
		/* 13 */
		/***/function (module, exports) {

			var core = module.exports = { version: '1.2.6' };
			if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

			/***/
		},
		/* 14 */
		/***/function (module, exports, __webpack_require__) {

			// optional / simple context binding
			var aFunction = __webpack_require__(15);
			module.exports = function (fn, that, length) {
				aFunction(fn);
				if (that === undefined) return fn;
				switch (length) {
					case 1:
						return function (a) {
							return fn.call(that, a);
						};
					case 2:
						return function (a, b) {
							return fn.call(that, a, b);
						};
					case 3:
						return function (a, b, c) {
							return fn.call(that, a, b, c);
						};
				}
				return function () /* ...args */{
					return fn.apply(that, arguments);
				};
			};

			/***/
		},
		/* 15 */
		/***/function (module, exports) {

			module.exports = function (it) {
				if (typeof it != 'function') throw TypeError(it + ' is not a function!');
				return it;
			};

			/***/
		},
		/* 16 */
		/***/function (module, exports) {

			module.exports = function (exec) {
				try {
					return !!exec();
				} catch (e) {
					return true;
				}
			};

			/***/
		},
		/* 17 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			var _Object$create = __webpack_require__(18)["default"];

			var _Object$setPrototypeOf = __webpack_require__(20)["default"];

			exports["default"] = function (subClass, superClass) {
				if (typeof superClass !== "function" && superClass !== null) {
					throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
				}

				subClass.prototype = _Object$create(superClass && superClass.prototype, {
					constructor: {
						value: subClass,
						enumerable: false,
						writable: true,
						configurable: true
					}
				});
				if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
			};

			exports.__esModule = true;

			/***/
		},
		/* 18 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(19), __esModule: true };

			/***/
		},
		/* 19 */
		/***/function (module, exports, __webpack_require__) {

			var $ = __webpack_require__(4);
			module.exports = function create(P, D) {
				return $.create(P, D);
			};

			/***/
		},
		/* 20 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(21), __esModule: true };

			/***/
		},
		/* 21 */
		/***/function (module, exports, __webpack_require__) {

			__webpack_require__(22);
			module.exports = __webpack_require__(13).Object.setPrototypeOf;

			/***/
		},
		/* 22 */
		/***/function (module, exports, __webpack_require__) {

			// 19.1.3.19 Object.setPrototypeOf(O, proto)
			var $export = __webpack_require__(11);
			$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(23).set });

			/***/
		},
		/* 23 */
		/***/function (module, exports, __webpack_require__) {

			// Works with __proto__ only. Old v8 can't work with null proto objects.
			/* eslint-disable no-proto */
			var getDesc = __webpack_require__(4).getDesc,
			    isObject = __webpack_require__(24),
			    anObject = __webpack_require__(25);
			var check = function check(O, proto) {
				anObject(O);
				if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
			};
			module.exports = {
				set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
				function (test, buggy, set) {
					try {
						set = __webpack_require__(14)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
						set(test, []);
						buggy = !(test instanceof Array);
					} catch (e) {
						buggy = true;
					}
					return function setPrototypeOf(O, proto) {
						check(O, proto);
						if (buggy) O.__proto__ = proto;else set(O, proto);
						return O;
					};
				}({}, false) : undefined),
				check: check
			};

			/***/
		},
		/* 24 */
		/***/function (module, exports) {

			module.exports = function (it) {
				return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
			};

			/***/
		},
		/* 25 */
		/***/function (module, exports, __webpack_require__) {

			var isObject = __webpack_require__(24);
			module.exports = function (it) {
				if (!isObject(it)) throw TypeError(it + ' is not an object!');
				return it;
			};

			/***/
		},
		/* 26 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			var _Object$defineProperty = __webpack_require__(27)["default"];

			exports["default"] = function () {
				function defineProperties(target, props) {
					for (var i = 0; i < props.length; i++) {
						var descriptor = props[i];
						descriptor.enumerable = descriptor.enumerable || false;
						descriptor.configurable = true;
						if ("value" in descriptor) descriptor.writable = true;

						_Object$defineProperty(target, descriptor.key, descriptor);
					}
				}

				return function (Constructor, protoProps, staticProps) {
					if (protoProps) defineProperties(Constructor.prototype, protoProps);
					if (staticProps) defineProperties(Constructor, staticProps);
					return Constructor;
				};
			}();

			exports.__esModule = true;

			/***/
		},
		/* 27 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(28), __esModule: true };

			/***/
		},
		/* 28 */
		/***/function (module, exports, __webpack_require__) {

			var $ = __webpack_require__(4);
			module.exports = function defineProperty(it, key, desc) {
				return $.setDesc(it, key, desc);
			};

			/***/
		},
		/* 29 */
		/***/function (module, exports) {

			"use strict";

			exports["default"] = function (instance, Constructor) {
				if (!(instance instanceof Constructor)) {
					throw new TypeError("Cannot call a class as a function");
				}
			};

			exports.__esModule = true;

			/***/
		},
		/* 30 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			var _Object$assign = __webpack_require__(31)["default"];

			exports["default"] = _Object$assign || function (target) {
				for (var i = 1; i < arguments.length; i++) {
					var source = arguments[i];

					for (var key in source) {
						if (Object.prototype.hasOwnProperty.call(source, key)) {
							target[key] = source[key];
						}
					}
				}

				return target;
			};

			exports.__esModule = true;

			/***/
		},
		/* 31 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(32), __esModule: true };

			/***/
		},
		/* 32 */
		/***/function (module, exports, __webpack_require__) {

			__webpack_require__(33);
			module.exports = __webpack_require__(13).Object.assign;

			/***/
		},
		/* 33 */
		/***/function (module, exports, __webpack_require__) {

			// 19.1.3.1 Object.assign(target, source)
			var $export = __webpack_require__(11);

			$export($export.S + $export.F, 'Object', { assign: __webpack_require__(34) });

			/***/
		},
		/* 34 */
		/***/function (module, exports, __webpack_require__) {

			// 19.1.2.1 Object.assign(target, source, ...)
			var $ = __webpack_require__(4),
			    toObject = __webpack_require__(35),
			    IObject = __webpack_require__(7);

			// should work with symbols and should have deterministic property order (V8 bug)
			module.exports = __webpack_require__(16)(function () {
				var a = Object.assign,
				    A = {},
				    B = {},
				    S = Symbol(),
				    K = 'abcdefghijklmnopqrst';
				A[S] = 7;
				K.split('').forEach(function (k) {
					B[k] = k;
				});
				return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
			}) ? function assign(target, source) {
				// eslint-disable-line no-unused-vars
				var T = toObject(target),
				    $$ = arguments,
				    $$len = $$.length,
				    index = 1,
				    getKeys = $.getKeys,
				    getSymbols = $.getSymbols,
				    isEnum = $.isEnum;
				while ($$len > index) {
					var S = IObject($$[index++]),
					    keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
					    length = keys.length,
					    j = 0,
					    key;
					while (length > j) {
						if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
					}
				}
				return T;
			} : Object.assign;

			/***/
		},
		/* 35 */
		/***/function (module, exports, __webpack_require__) {

			// 7.1.13 ToObject(argument)
			var defined = __webpack_require__(9);
			module.exports = function (it) {
				return Object(defined(it));
			};

			/***/
		},
		/* 36 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = { "default": __webpack_require__(37), __esModule: true };

			/***/
		},
		/* 37 */
		/***/function (module, exports, __webpack_require__) {

			__webpack_require__(38);
			module.exports = __webpack_require__(13).Object.keys;

			/***/
		},
		/* 38 */
		/***/function (module, exports, __webpack_require__) {

			// 19.1.2.14 Object.keys(O)
			var toObject = __webpack_require__(35);

			__webpack_require__(10)('keys', function ($keys) {
				return function keys(it) {
					return $keys(toObject(it));
				};
			});

			/***/
		},
		/* 39 */
		/***/function (module, exports) {

			"use strict";

			exports["default"] = function (obj) {
				return obj && obj.__esModule ? obj : {
					"default": obj
				};
			};

			exports.__esModule = true;

			/***/
		},
		/* 40 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_40__;

			/***/
		},
		/* 41 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_41__;

			/***/
		},
		/* 42 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

			/***/
		}]
		/******/)
	);
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(696);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2350)();
}

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Determine if a given value is an object that implements the `Environment`
 * interface defined in `RelayEnvironmentTypes`.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isRelayEnvironment(environment) {
  return (typeof environment === 'undefined' ? 'undefined' : _typeof(environment)) === 'object' && environment !== null &&
  // TODO: add applyMutation/sendMutation once ready in both cores
  typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.sendQuery === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}

module.exports = isRelayEnvironment;

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calculateNodeHeight__ = __webpack_require__(2439);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * <TextareaAutosize />
 */





var noop = function noop() {};

var TextareaAutosize = function (_React$Component) {
  _inherits(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    _classCallCheck(this, TextareaAutosize);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;
      if (_this.props.inputRef) _this.props.inputRef(node);
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }
      var _this$props = _this.props,
          valueLink = _this$props.valueLink,
          onChange = _this$props.onChange;

      if (valueLink) {
        valueLink.requestChange(event.target.value);
      } else {
        onChange(event);
      }
    };

    _this._resizeComponent = function () {
      if (!_this._rootDOMNode) {
        return;
      }

      var _calculateNodeHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__calculateNodeHeight__["a" /* default */])(_this._rootDOMNode, _this.props.useCacheForDOMMeasurements, _this.props.rows || _this.props.minRows, _this.props.maxRows),
          height = _calculateNodeHeight.height,
          minHeight = _calculateNodeHeight.minHeight,
          maxHeight = _calculateNodeHeight.maxHeight;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({ height: height, minHeight: minHeight, maxHeight: maxHeight });
      }
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };

    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  TextareaAutosize.prototype.render = function render() {
    var _props = this.props,
        valueLink = _props.valueLink,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ['valueLink', 'minRows', 'maxRows', 'onHeightChange', 'useCacheForDOMMeasurements', 'inputRef']);

    if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
      props.value = valueLink.value;
    }

    props.style = _extends({}, props.style, {
      height: this.state.height
    });

    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  TextareaAutosize.prototype.componentDidMount = function componentDidMount() {
    this._resizeComponent();
    window.addEventListener('resize', this._resizeComponent);
  };

  TextareaAutosize.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    // Re-render with the new content then recalculate the height as required.
    this._clearNextFrame();
    this._onNextFrameActionId = onNextFrame(this._resizeComponent);
  };

  TextareaAutosize.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // Invoke callback when old height does not equal to new one.
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height);
    }
  };

  TextareaAutosize.prototype.componentWillUnmount = function componentWillUnmount() {
    // Remove any scheduled events to prevent manipulating the node after it's
    // been unmounted.
    this._clearNextFrame();
    window.removeEventListener('resize', this._resizeComponent);
  };

  TextareaAutosize.prototype._clearNextFrame = function _clearNextFrame() {
    if (this._onNextFrameActionId) {
      clearNextFrameAction(this._onNextFrameActionId);
    }
  };

  /**
   * Put focus on a <textarea /> DOM element.
   */
  TextareaAutosize.prototype.focus = function focus() {
    this._rootDOMNode.focus();
  };

  /**
   * Shifts focus away from a <textarea /> DOM element.
   */

  TextareaAutosize.prototype.blur = function blur() {
    this._rootDOMNode.blur();
  };

  _createClass(TextareaAutosize, [{
    key: 'value',

    /**
     * Read the current value of <textarea /> from DOM.
     */
    get: function get() {
      return this._rootDOMNode.value;
    }

    /**
     * Set the current value of <textarea /> DOM node.
     */

    , set: function set(val) {
      this._rootDOMNode.value = val;
    }

    /**
     * Read the current selectionStart of <textarea /> from DOM.
     */

  }, {
    key: 'selectionStart',
    get: function get() {
      return this._rootDOMNode.selectionStart;
    }

    /**
     * Set the current selectionStart of <textarea /> DOM node.
     */

    , set: function set(selectionStart) {
      this._rootDOMNode.selectionStart = selectionStart;
    }

    /**
     * Read the current selectionEnd of <textarea /> from DOM.
     */

  }, {
    key: 'selectionEnd',
    get: function get() {
      return this._rootDOMNode.selectionEnd;
    }

    /**
     * Set the current selectionEnd of <textarea /> DOM node.
     */

    , set: function set(selectionEnd) {
      this._rootDOMNode.selectionEnd = selectionEnd;
    }
  }]);

  return TextareaAutosize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextareaAutosize.propTypes = {
  /**
   * Current textarea value.
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Callback on value change.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback on height changes.
   */
  onHeightChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Try to cache DOM measurements performed by component so that we don't
   * touch DOM when it's not needed.
   *
   * This optimization doesn't work if we dynamically style <textarea />
   * component.
   */
  useCacheForDOMMeasurements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Minimal numbder of rows to show.
   */
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Alias for `rows`.
   */
  minRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum number of rows to show.
   */
  maxRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Allows an owner to retrieve the DOM node.
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};
/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);

function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }
  return window.setTimeout(cb, 1);
}

function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



module.exports = {
  DEFAULT_HANDLE_KEY: ''
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _toConsumableArray3 = _interopRequireDefault(__webpack_require__(123));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @internal
 *
 * Factory methods for constructing errors in Relay.
 */
var RelayError = {
  create: function create(name, format) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return createError('mustfix', name, format, args);
  },
  createWarning: function createWarning(name, format) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return createError('warn', name, format, args);
  }
};

/**
 * @private
 */
function createError(type, name, format, args) {
  var error = new Error(__webpack_require__(755).apply(undefined, [format].concat((0, _toConsumableArray3['default'])(args))));
  error.name = name;
  error.type = type;
  error.framesToPop = 2;
  return error;
}

module.exports = RelayError;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



/**
 * Creates an instance of the `OperationSelector` type defined in
 * `RelayStoreTypes` given an operation and some variables. The input variables
 * are filtered to exclude variables that do not match defined arguments on the
 * operation, and default values are populated for null values.
 */

function createOperationSelector(request, variables, operationFromBatch) {
  var operation = operationFromBatch || (request.kind === __webpack_require__(18).BATCH_REQUEST ? request.requests[0].operation : request.operation);

  var operationVariables = __webpack_require__(243).getOperationVariables(operation, variables);
  var dataID = __webpack_require__(12).ROOT_ID;
  return {
    fragment: {
      dataID: dataID,
      node: request.fragment,
      variables: operationVariables
    },
    node: request,
    root: {
      dataID: dataID,
      node: operation,
      variables: operationVariables
    },
    variables: operationVariables
  };
}

module.exports = {
  createOperationSelector: createOperationSelector
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var VIEWER_ID = __webpack_require__(76)(__webpack_require__(12).ROOT_ID, 'viewer');
var VIEWER_TYPE = 'Viewer';

/**
 * A runtime handler for the `viewer` field. The actual viewer record will
 * *never* be accessed at runtime because all fragments that reference it will
 * delegate to the handle field. So in order to prevent GC from having to check
 * both the original server field *and* the handle field (which would be almost
 * duplicate work), the handler copies server fields and then deletes the server
 * record.
 *
 * NOTE: This means other handles may not be added on viewer, since they may
 * execute after this handle when the server record is already deleted.
 */
function update(store, payload) {
  var record = store.get(payload.dataID);
  if (!record) {
    return;
  }
  var serverViewer = record.getLinkedRecord(payload.fieldKey);
  if (!serverViewer) {
    // If `serverViewer` is null, `viewer` key for `client:root` should already
    // be null, so no need to `setValue` again.
    return;
  }
  // Server data already has viewer data at `client:root:viewer`, so link the
  // handle field to the server viewer record.
  if (serverViewer.getDataID() === VIEWER_ID) {
    record.setValue(null, payload.fieldKey);
    record.setLinkedRecord(serverViewer, payload.handleKey);
    return;
  }
  // Other ways to access viewer such as mutations may have a different id for
  // viewer: synthesize a record at the canonical viewer id, copy its fields
  // from the server record, and delete the server record link to speed up GC.
  var clientViewer = store.get(VIEWER_ID) || store.create(VIEWER_ID, VIEWER_TYPE);
  clientViewer.copyFieldsFrom(serverViewer);
  record.setValue(null, payload.fieldKey);
  record.setLinkedRecord(clientViewer, payload.handleKey);

  // Make sure the root object points to the viewer object as well
  var root = store.getRoot();
  root.setLinkedRecord(clientViewer, payload.handleKey);
}

module.exports = {
  VIEWER_ID: VIEWER_ID,
  update: update
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @private
 *
 * Creates a clone of the supplied `handleField` by finding the original linked
 * field (on which the handle was declared) among the sibling `selections`, and
 * copying its selections into the clone.
 */
function cloneRelayHandleSourceField(handleField, selections, variables) {
  var sourceField = selections.find(function (source) {
    return source.kind === __webpack_require__(18).LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && __webpack_require__(251)(source.args, handleField.args);
  });
  !(sourceField && sourceField.kind === __webpack_require__(18).LINKED_FIELD) ?  false ? require('fbjs/lib/invariant')(false, 'cloneRelayHandleSourceField: Expected a corresponding source field for ' + 'handle `%s`.', handleField.handle) : __webpack_require__(10)(false) : void 0;
  var handleKey = __webpack_require__(12).getHandleStorageKey(handleField, variables);
  var clonedField = (0, _extends3['default'])({}, sourceField, {
    args: null,
    name: handleKey,
    storageKey: handleKey
  });
  return clonedField;
}

module.exports = cloneRelayHandleSourceField;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Recursively "deep" freezes the supplied object.
 *
 * For convenience, and for consistency with the behavior of `Object.freeze`,
 * returns the now-frozen original object.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function deepFreeze(object) {
  Object.freeze(object);
  Object.getOwnPropertyNames(object).forEach(function (name) {
    var property = object[name];
    if (property && (typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object' && !Object.isFrozen(property)) {
      deepFreeze(property);
    }
  });
  return object;
}

module.exports = deepFreeze;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * A fast test to determine if two values are equal scalars:
 * - compares scalars such as booleans, strings, numbers by value
 * - compares functions by identity
 * - returns false for complex values, since these cannot be cheaply tested for
 *   equality (use `areEquals` instead)
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isScalarAndEqual(valueA, valueB) {
  return valueA === valueB && (valueA === null || (typeof valueA === 'undefined' ? 'undefined' : _typeof(valueA)) !== 'object');
}

module.exports = isScalarAndEqual;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function normalizePayload(payload) {
  var operation = payload.operation,
      variables = payload.variables,
      response = payload.response;
  var data = response.data,
      errors = response.errors;

  if (data != null) {
    return __webpack_require__(137)({
      dataID: __webpack_require__(12).ROOT_ID,
      node: operation,
      variables: variables
    }, data, errors, { handleStrippedNulls: true });
  }
  var error = __webpack_require__(358).create('RelayNetwork', 'No data returned for operation `%s`, got error(s):\n%s\n\nSee the error ' + '`source` property for more information.', operation.name, errors ? errors.map(function (_ref) {
    var message = _ref.message;
    return message;
  }).join('\n') : '(No errors)');
  error.source = { errors: errors, operation: operation, variables: variables };
  throw error;
}

module.exports = normalizePayload;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Recycles subtrees from `prevData` by replacing equal subtrees in `nextData`.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function recycleNodesInto(prevData, nextData) {
  if (prevData === nextData || (typeof prevData === 'undefined' ? 'undefined' : _typeof(prevData)) !== 'object' || !prevData || (typeof nextData === 'undefined' ? 'undefined' : _typeof(nextData)) !== 'object' || !nextData) {
    return nextData;
  }
  var canRecycle = false;

  // Assign local variables to preserve Flow type refinement.
  var prevArray = Array.isArray(prevData) ? prevData : null;
  var nextArray = Array.isArray(nextData) ? nextData : null;
  if (prevArray && nextArray) {
    canRecycle = nextArray.reduce(function (wasEqual, nextItem, ii) {
      var prevValue = prevArray[ii];
      var nextValue = recycleNodesInto(prevValue, nextItem);
      if (nextValue !== nextArray[ii]) {
        nextArray[ii] = nextValue;
      }
      return wasEqual && nextArray[ii] === prevArray[ii];
    }, true) && prevArray.length === nextArray.length;
  } else if (!prevArray && !nextArray) {
    // Assign local variables to preserve Flow type refinement.
    var prevObject = prevData;
    var nextObject = nextData;
    var prevKeys = Object.keys(prevObject);
    var nextKeys = Object.keys(nextObject);
    canRecycle = nextKeys.reduce(function (wasEqual, key) {
      var prevValue = prevObject[key];
      var nextValue = recycleNodesInto(prevValue, nextObject[key]);
      if (nextValue !== nextObject[key]) {
        nextObject[key] = nextValue;
      }
      return wasEqual && nextObject[key] === prevObject[key];
    }, true) && prevKeys.length === nextKeys.length;
  }
  return canRecycle ? prevData : nextData;
}

module.exports = recycleNodesInto;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(2491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });



/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1406);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(794),
    isFlattenable = __webpack_require__(2672);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(51),
    isKey = __webpack_require__(804),
    stringToPath = __webpack_require__(1426),
    toString = __webpack_require__(156);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(795),
    baseAssignValue = __webpack_require__(368);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2603),
    isObjectLike = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(142),
    isObjectLike = __webpack_require__(91);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    getPrototype = __webpack_require__(508),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2611),
    baseUnary = __webpack_require__(256),
    nodeUtil = __webpack_require__(512);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(2628),
    keys = __webpack_require__(118);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserPlaylistConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserPlaylistRenderer__ = __webpack_require__(2820);
var _graphql;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var UserPlaylistContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();

var UserPlaylistConsumer = UserPlaylistContext.Consumer;

var UserPlaylistQuery = function UserPlaylistQuery(_ref) {
  var playlistId = _ref.playlistId,
      props = _objectWithoutProperties(_ref, ['playlistId']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    UserPlaylistContext.Provider,
    { value: props },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_relay__["QueryRenderer"], {
      environment: props.relay.environment,
      query: _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2832);
      }),
      variables: {
        id: playlistId,
        query: ''
      },
      render: __WEBPACK_IMPORTED_MODULE_3__UserPlaylistRenderer__["a" /* default */]
    })
  );
};

UserPlaylistQuery.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  playlistId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (UserPlaylistQuery);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardFieldNoValidate__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_formsy_react__);
/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_formsy_react__["HOC"])(__WEBPACK_IMPORTED_MODULE_0__CardFieldNoValidate__["a" /* default */]));

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getLocalityString: function getLocalityString(props) {
    var city = props.city,
        province = props.province,
        postal_code = props.postal_code;

    return '' + (city ? city + ', ' : '') + (province ? province + ' '
    // eslint-disable-next-line camelcase
    : '') + (postal_code ? '' + postal_code : '');
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  formatPhoneNumber: function formatPhoneNumber(number) {
    return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3546);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Invoice.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Invoice.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3580);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Leads.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Leads.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3592);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideTransition.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideTransition.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

(function (self) {
  'use strict';

  if (self.fetch) {
    return;
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && function () {
      try {
        new Blob();
        return true;
      } catch (e) {
        return false;
      }
    }(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  if (support.arrayBuffer) {
    var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

    var isDataView = function isDataView(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj);
    };

    var isArrayBufferView = ArrayBuffer.isView || function (obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function next() {
        var value = items.shift();
        return { done: value === undefined, value: value };
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function (name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ',' + value : value;
  };

  Headers.prototype['delete'] = function (name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items = [];
    this.forEach(function (value) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items = [];
    this.forEach(function (value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'));
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function (resolve, reject) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('');
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function (body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        throw new Error('unsupported BodyInit type');
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return rejected;
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      this.arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    this.text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      this.formData = function () {
        return this.text().then(decode);
      };
    }

    this.json = function () {
      return this.text().then(JSON.parse);
    };

    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read');
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'omit';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function (bytes) {
      if (bytes) {
        var split = bytes.split('=');
        var name = split.shift().replace(/\+/g, ' ');
        var value = split.join('=').replace(/\+/g, ' ');
        form.append(decodeURIComponent(name), decodeURIComponent(value));
      }
    });
    return form;
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    rawHeaders.split(/\r?\n/).forEach(function (line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = 'status' in options ? options.status : 200;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  };

  Response.error = function () {
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    return new Response(null, { status: status, headers: { location: url } });
  };

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function (input, init) {
    return new Promise(function (resolve, reject) {
      var request = new Request(input, init);
      var xhr = new XMLHttpRequest();

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  };
  self.fetch.polyfill = true;
})(typeof self !== 'undefined' ? self : this);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(834);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
// HACKHACK: these components should go in separate files
// tslint:disable max-classes-per-file
var React = __webpack_require__(0);
var props_1 = __webpack_require__(265);
var abstractButton_1 = __webpack_require__(1531);
var Button = function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        return React.createElement("button", tslib_1.__assign({ type: "button" }, props_1.removeNonHTMLProps(this.props), this.getCommonButtonProps()), this.renderChildren());
    };
    return Button;
}(abstractButton_1.AbstractButton);
Button.displayName = "Blueprint.Button";
exports.Button = Button;
exports.ButtonFactory = React.createFactory(Button);
var AnchorButton = function (_super) {
    tslib_1.__extends(AnchorButton, _super);
    function AnchorButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnchorButton.prototype.render = function () {
        var _a = this.props,
            href = _a.href,
            _b = _a.tabIndex,
            tabIndex = _b === void 0 ? 0 : _b;
        var commonProps = this.getCommonButtonProps();
        return React.createElement("a", tslib_1.__assign({ role: "button" }, props_1.removeNonHTMLProps(this.props), commonProps, { href: commonProps.disabled ? undefined : href, tabIndex: commonProps.disabled ? undefined : tabIndex }), this.renderChildren());
    };
    return AnchorButton;
}(abstractButton_1.AbstractButton);
AnchorButton.displayName = "Blueprint.AnchorButton";
exports.AnchorButton = AnchorButton;
exports.AnchorButtonFactory = React.createFactory(AnchorButton);

//# sourceMappingURL=buttons.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var keyCombo_1 = __webpack_require__(844);
var Hotkey = function (_super) {
    tslib_1.__extends(Hotkey, _super);
    function Hotkey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkey.isInstance = function (element) {
        return element != null && element.type === Hotkey;
    };
    Hotkey.prototype.render = function () {
        var _a = this.props,
            label = _a.label,
            spreadableProps = tslib_1.__rest(_a, ["label"]);
        return React.createElement("div", { className: "pt-hotkey" }, React.createElement("div", { className: "pt-hotkey-label" }, label), React.createElement(keyCombo_1.KeyCombo, tslib_1.__assign({}, spreadableProps)));
    };
    Hotkey.prototype.validateProps = function (props) {
        if (props.global !== true && props.group == null) {
            throw new Error("non-global <Hotkey>s must define a group");
        }
    };
    return Hotkey;
}(common_1.AbstractComponent);
Hotkey.defaultProps = {
    allowInInput: false,
    disabled: false,
    global: false,
    preventDefault: false,
    stopPropagation: false
};
exports.Hotkey = Hotkey;

//# sourceMappingURL=hotkey.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var CSSTransitionGroup = __webpack_require__(72);
var Classes = __webpack_require__(37);
var Keys = __webpack_require__(187);
var utils_1 = __webpack_require__(53);
var portal_1 = __webpack_require__(847);
var Overlay = Overlay_1 = function (_super) {
    tslib_1.__extends(Overlay, _super);
    function Overlay(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refHandlers = {
            container: function container(ref) {
                return _this.containerElement = ref;
            }
        };
        _this.handleBackdropMouseDown = function (e) {
            var _a = _this.props,
                backdropProps = _a.backdropProps,
                canOutsideClickClose = _a.canOutsideClickClose,
                enforceFocus = _a.enforceFocus,
                onClose = _a.onClose;
            if (canOutsideClickClose) {
                utils_1.safeInvoke(onClose, e);
            }
            if (enforceFocus) {
                // make sure document.activeElement is updated before bringing the focus back
                _this.bringFocusInsideOverlay();
            }
            utils_1.safeInvoke(backdropProps.onMouseDown, e);
        };
        _this.handleDocumentClick = function (e) {
            var _a = _this.props,
                isOpen = _a.isOpen,
                onClose = _a.onClose;
            var eventTarget = e.target;
            var isClickInOverlay = _this.containerElement != null && _this.containerElement.contains(eventTarget);
            if (isOpen && _this.props.canOutsideClickClose && !isClickInOverlay) {
                // casting to any because this is a native event
                utils_1.safeInvoke(onClose, e);
            }
        };
        _this.handleContentMount = function () {
            if (_this.props.isOpen) {
                utils_1.safeInvoke(_this.props.didOpen);
            }
            if (_this.props.autoFocus) {
                _this.bringFocusInsideOverlay();
            }
        };
        _this.handleDocumentFocus = function (e) {
            if (_this.props.enforceFocus && _this.containerElement != null && !_this.containerElement.contains(e.target)) {
                // prevent default focus behavior (sometimes auto-scrolls the page)
                e.preventDefault();
                e.stopImmediatePropagation();
                _this.bringFocusInsideOverlay();
            }
        };
        _this.handleKeyDown = function (e) {
            var _a = _this.props,
                canEscapeKeyClose = _a.canEscapeKeyClose,
                onClose = _a.onClose;
            if (e.which === Keys.ESCAPE && canEscapeKeyClose) {
                utils_1.safeInvoke(onClose, e);
                // prevent browser-specific escape key behavior (Safari exits fullscreen)
                e.preventDefault();
            }
        };
        _this.state = { hasEverOpened: props.isOpen };
        return _this;
    }
    Overlay.prototype.render = function () {
        // oh snap! no reason to render anything at all if we're being truly lazy
        if (this.props.lazy && !this.state.hasEverOpened) {
            return null;
        }
        var _a = this.props,
            children = _a.children,
            className = _a.className,
            inline = _a.inline,
            isOpen = _a.isOpen,
            transitionDuration = _a.transitionDuration,
            transitionName = _a.transitionName;
        // add a special class to each child that will automatically set the appropriate
        // CSS position mode under the hood. also, make the container focusable so we can
        // trap focus inside it (via `enforceFocus`).
        var decoratedChildren = React.Children.map(children, function (child) {
            return React.cloneElement(child, {
                className: classNames(child.props.className, Classes.OVERLAY_CONTENT),
                tabIndex: 0
            });
        });
        var transitionGroup = React.createElement(CSSTransitionGroup, { transitionAppear: true, transitionAppearTimeout: transitionDuration, transitionEnterTimeout: transitionDuration, transitionLeaveTimeout: transitionDuration, transitionName: transitionName }, this.maybeRenderBackdrop(), isOpen ? decoratedChildren : null);
        var mergedClassName = classNames(Classes.OVERLAY, (_b = {}, _b[Classes.OVERLAY_OPEN] = isOpen, _b[Classes.OVERLAY_INLINE] = inline, _b), className);
        var elementProps = {
            className: mergedClassName,
            onKeyDown: this.handleKeyDown
        };
        if (inline) {
            return React.createElement("span", tslib_1.__assign({}, elementProps, { ref: this.refHandlers.container }), transitionGroup);
        } else {
            return React.createElement(portal_1.Portal, tslib_1.__assign({}, elementProps, { containerRef: this.refHandlers.container, onChildrenMount: this.handleContentMount }), transitionGroup);
        }
        var _b;
    };
    Overlay.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this.overlayWillOpen();
        }
    };
    Overlay.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ hasEverOpened: this.state.hasEverOpened || nextProps.isOpen });
    };
    Overlay.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isOpen && !this.props.isOpen) {
            this.overlayWillClose();
        } else if (!prevProps.isOpen && this.props.isOpen) {
            this.overlayWillOpen();
        }
    };
    Overlay.prototype.componentWillUnmount = function () {
        this.overlayWillClose();
    };
    Overlay.prototype.maybeRenderBackdrop = function () {
        var _a = this.props,
            backdropClassName = _a.backdropClassName,
            backdropProps = _a.backdropProps,
            hasBackdrop = _a.hasBackdrop,
            isOpen = _a.isOpen;
        if (hasBackdrop && isOpen) {
            return React.createElement("div", tslib_1.__assign({}, backdropProps, { className: classNames(Classes.OVERLAY_BACKDROP, backdropClassName, backdropProps.className), onMouseDown: this.handleBackdropMouseDown, tabIndex: this.props.canOutsideClickClose ? 0 : null }));
        } else {
            return undefined;
        }
    };
    Overlay.prototype.overlayWillClose = function () {
        document.removeEventListener("focus", this.handleDocumentFocus, /* useCapture */true);
        document.removeEventListener("mousedown", this.handleDocumentClick);
        var openStack = Overlay_1.openStack;
        var stackIndex = openStack.indexOf(this);
        if (stackIndex !== -1) {
            openStack.splice(stackIndex, 1);
            if (openStack.length > 0) {
                var lastOpenedOverlay = Overlay_1.getLastOpened();
                if (lastOpenedOverlay.props.enforceFocus) {
                    document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */true);
                }
            } else {
                document.body.classList.remove(Classes.OVERLAY_OPEN);
            }
        }
    };
    Overlay.prototype.overlayWillOpen = function () {
        var openStack = Overlay_1.openStack;
        if (openStack.length > 0) {
            document.removeEventListener("focus", Overlay_1.getLastOpened().handleDocumentFocus, /* useCapture */true);
        }
        openStack.push(this);
        if (this.props.canOutsideClickClose && !this.props.hasBackdrop) {
            document.addEventListener("mousedown", this.handleDocumentClick);
        }
        if (this.props.enforceFocus) {
            document.addEventListener("focus", this.handleDocumentFocus, /* useCapture */true);
        }
        if (this.props.inline) {
            utils_1.safeInvoke(this.props.didOpen);
            if (this.props.autoFocus) {
                this.bringFocusInsideOverlay();
            }
        } else if (this.props.hasBackdrop) {
            // add a class to the body to prevent scrolling of content below the overlay
            document.body.classList.add(Classes.OVERLAY_OPEN);
        }
    };
    Overlay.prototype.bringFocusInsideOverlay = function () {
        var _this = this;
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(function () {
            var containerElement = _this.containerElement;
            // container ref may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            if (containerElement == null || document.activeElement == null || !_this.props.isOpen) {
                return;
            }
            var isFocusOutsideModal = !containerElement.contains(document.activeElement);
            if (isFocusOutsideModal) {
                // element marked autofocus has higher priority than the other clowns
                var autofocusElement = containerElement.query("[autofocus]");
                var wrapperElement = containerElement.query("[tabindex]");
                if (autofocusElement != null) {
                    autofocusElement.focus();
                } else if (wrapperElement != null) {
                    wrapperElement.focus();
                }
            }
        });
    };
    return Overlay;
}(React.Component);
Overlay.displayName = "Blueprint.Overlay";
Overlay.defaultProps = {
    autoFocus: true,
    backdropProps: {},
    canEscapeKeyClose: true,
    canOutsideClickClose: true,
    enforceFocus: true,
    hasBackdrop: true,
    inline: false,
    isOpen: false,
    lazy: true,
    transitionDuration: 300,
    transitionName: "pt-overlay"
};
Overlay.openStack = [];
Overlay.getLastOpened = function () {
    return Overlay_1.openStack[Overlay_1.openStack.length - 1];
};
Overlay = Overlay_1 = tslib_1.__decorate([PureRender], Overlay);
exports.Overlay = Overlay;
exports.OverlayFactory = React.createFactory(Overlay);
var Overlay_1;

//# sourceMappingURL=overlay.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1606), __esModule: true };

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(551), __esModule: true };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1608), __esModule: true };

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(159);
var TAG = __webpack_require__(56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(64).document;
module.exports = document && document.documentElement;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(128);
var ITERATOR = __webpack_require__(56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(86);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(94);
var toObject = __webpack_require__(160);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 402 */
/***/ (function(module, exports) {



/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(192);
var dPs = __webpack_require__(874);
var enumBugKeys = __webpack_require__(586);
var IE_PROTO = __webpack_require__(592)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(585)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(868).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 406 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(584);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()

var classof = __webpack_require__(583);
var test = {};
test[__webpack_require__(96)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(230)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(603);


/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a = +a, b -= a, function (t) {
    return a + b * t;
  };
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _point; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Basis;

function _point(that, x, y) {
  that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 3:
        _point(this, this._x1, this._y1); // proceed
      case 2:
        this._context.lineTo(this._x1, this._y1);break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3;this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default:
        _point(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new Basis(context);
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _point; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Cardinal;

function _point(that, x, y) {
  that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);break;
      case 3:
        _point(this, this._x1, this._y1);break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2;this._x1 = x, this._y1 = y;break;
      case 2:
        this._point = 3; // proceed
      default:
        _point(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2; // proceed
      default:
        this._context.lineTo(x, y);break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new Linear(context);
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(619);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(329);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(942);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createPath;
function createPath(_ref) {
    var pathname = _ref.pathname,
        search = _ref.search,
        hash = _ref.hash;

    return "" + pathname + search + hash;
}
module.exports = exports["default"];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = ensureLocation;
function ensureLocation(location) {
  if ((typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object') {
    // Set default values for fields other than pathname.
    return _extends({
      search: '',
      hash: ''
    }, location);
  }

  var remainingPath = location;

  var hashIndex = remainingPath.indexOf('#');
  var hash = void 0;
  if (hashIndex !== -1) {
    hash = remainingPath.slice(hashIndex);
    remainingPath = remainingPath.slice(0, hashIndex);
  } else {
    hash = '';
  }

  var searchIndex = remainingPath.indexOf('?');
  var search = void 0;
  if (searchIndex !== -1) {
    search = remainingPath.slice(searchIndex);
    remainingPath = remainingPath.slice(0, searchIndex);
  } else {
    search = '';
  }

  return {
    pathname: remainingPath,
    search: search,
    hash: hash
  };
}
module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1917),
    listCacheDelete = __webpack_require__(1918),
    listCacheGet = __webpack_require__(1919),
    listCacheHas = __webpack_require__(1920),
    listCacheSet = __webpack_require__(1921);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(966);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(633),
    getRawTag = __webpack_require__(1904),
    objectToString = __webpack_require__(1930);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1914);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  UPDATE_MATCH: '@@found/UPDATE_MATCH',
  RESOLVE_MATCH: '@@found/RESOLVE_MATCH'
};
module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routerShape = exports.matcherShape = exports.matchShape = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// The shape might be different with a custom matcher or history enhancer, but
// the default matcher assumes and provides this shape. As such, this validator
// is purely for user convenience and should not be used internally.
var matchShape = exports.matchShape = _propTypes2.default.shape({
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired,
    query: _propTypes2.default.object.isRequired
  }).isRequired,
  params: _propTypes2.default.object.isRequired
});

// User code generally shouldn't need this, but it doesn't hurt to export here,
// since we use it for routerShape below.
var matcherShape = exports.matcherShape = _propTypes2.default.shape({
  match: _propTypes2.default.func.isRequired,
  getRoutes: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.func.isRequired,
  format: _propTypes2.default.func.isRequired
});

var routerShape = exports.routerShape = _propTypes2.default.shape({
  push: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  go: _propTypes2.default.func.isRequired,

  createHref: _propTypes2.default.func.isRequired,
  createLocation: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.func.isRequired,
  matcher: matcherShape.isRequired,

  addTransitionHook: _propTypes2.default.func.isRequired
});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(1587);

var _values2 = _interopRequireDefault(_values);

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(392);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _setImmediate2 = __webpack_require__(1588);

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

exports.checkResolved = checkResolved;
exports.isResolved = isResolved;
exports.accumulateRouteValues = accumulateRouteValues;
exports.getRouteMatches = getRouteMatches;
exports.getRouteValue = getRouteValue;
exports.getRouteValues = getRouteValues;
exports.getComponents = getComponents;

var _isPromise = __webpack_require__(435);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var UNRESOLVED = {};

function checkResolved(value) {
  if (!(0, _isPromise2.default)(value)) {
    return value;
  }

  return _promise2.default.race([value, new _promise2.default(function (resolve) {
    (0, _setImmediate3.default)(resolve, UNRESOLVED);
  })]);
}

function isResolved(value) {
  return value !== UNRESOLVED;
}

function accumulateRouteValuesImpl(routeValues, routeIndices, callback, initialValue) {
  var accumulated = [];
  var value = initialValue;

  for (var _iterator = routeIndices, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var routeIndex = _ref;

    if ((typeof routeIndex === 'undefined' ? 'undefined' : (0, _typeof3.default)(routeIndex)) === 'object') {
      // eslint-disable-next-line no-loop-func
      (0, _values2.default)(routeIndex).forEach(function (groupRouteIndices) {
        accumulated.push.apply(accumulated, accumulateRouteValuesImpl(routeValues, groupRouteIndices, callback, value));
      });
    } else {
      value = callback(value, routeValues.shift());
      accumulated.push(value);
    }
  }

  return accumulated;
}

function accumulateRouteValues(routeValues, routeIndices, callback, initialValue) {
  return accumulateRouteValuesImpl([].concat(routeValues), routeIndices, callback, initialValue);
}

function getRouteMatches(match) {
  return match.routes.map(function (route, i) {
    return (0, _extends3.default)({}, match, {
      route: route,
      routeParams: match.routeParams[i]
    });
  });
}

function getRouteValue(match, getGetter, getValue) {
  var route = match.route;

  var getter = getGetter(route);
  return getter ? getter.call(route, match) : getValue(route);
}

// This is a little more versatile than if we only passed in keys.
function getRouteValues(routeMatches, getGetter, getValue) {
  return routeMatches.map(function (match) {
    return getRouteValue(match, getGetter, getValue);
  });
}

function getRouteGetComponent(route) {
  return route.getComponent;
}

function getRouteComponent(route) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(route.Component, 'Route with `component` property `%s` has no `Component` ' + 'property. The expected property for the route component ' + 'is `Component`.', route.component.displayName || route.component.name) : void 0;
  }

  return route.Component;
}

// This should be common to most resolvers, so make it available here.
function getComponents(routeMatches) {
  return getRouteValues(routeMatches, getRouteGetComponent, getRouteComponent);
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1995),
    listCacheDelete = __webpack_require__(1996),
    listCacheGet = __webpack_require__(1997),
    listCacheHas = __webpack_require__(1998),
    listCacheSet = __webpack_require__(1999);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(995);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(640),
    getRawTag = __webpack_require__(1982),
    objectToString = __webpack_require__(2008);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1992);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(2047);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2129),
    listCacheDelete = __webpack_require__(2130),
    listCacheGet = __webpack_require__(2131),
    listCacheHas = __webpack_require__(2132),
    listCacheSet = __webpack_require__(2133);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(437),
    stackClear = __webpack_require__(2149),
    stackDelete = __webpack_require__(2150),
    stackGet = __webpack_require__(2151),
    stackHas = __webpack_require__(2152),
    stackSet = __webpack_require__(2153);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(282);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1028);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(280),
    toKey = __webpack_require__(281);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(331),
    isObject = __webpack_require__(110);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function () {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0:
        return new Ctor();
      case 1:
        return new Ctor(args[0]);
      case 2:
        return new Ctor(args[0], args[1]);
      case 3:
        return new Ctor(args[0], args[1], args[2]);
      case 4:
        return new Ctor(args[0], args[1], args[2], args[3]);
      case 5:
        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2126);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1043);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2061),
    isObjectLike = __webpack_require__(135);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    getPrototype = __webpack_require__(448),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2067),
    baseUnary = __webpack_require__(444),
    nodeUtil = __webpack_require__(1042);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(673);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export noSpacing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDraggableDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollDroppable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDroppableDimension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axis__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_area__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spacing__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_max_scroll__ = __webpack_require__(1183);








var origin = { x: 0, y: 0 };

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var getDraggableDimension = function getDraggableDimension(_ref) {
  var descriptor = _ref.descriptor,
      paddingBox = _ref.paddingBox,
      _ref$margin = _ref.margin,
      margin = _ref$margin === undefined ? noSpacing : _ref$margin,
      _ref$windowScroll = _ref.windowScroll,
      windowScroll = _ref$windowScroll === undefined ? origin : _ref$windowScroll;

  var pagePaddingBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(paddingBox, windowScroll);

  var dimension = {
    descriptor: descriptor,
    placeholder: {
      margin: margin,
      paddingBox: paddingBox
    },

    client: {
      paddingBox: paddingBox,
      marginBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["b" /* expandBySpacing */])(paddingBox, margin))
    },

    page: {
      paddingBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(pagePaddingBox),
      marginBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["b" /* expandBySpacing */])(pagePaddingBox, margin))
    }
  };

  return dimension;
};

var clip = function clip(frame, subject) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
};

var scrollDroppable = function scrollDroppable(droppable, newScroll) {
  if (!droppable.viewport.closestScrollable) {
    console.error('Cannot scroll droppble that does not have a closest scrollable');
    return droppable;
  }

  var existingScrollable = droppable.viewport.closestScrollable;

  var frame = existingScrollable.frame;

  var scrollDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__position__["b" /* subtract */])(newScroll, existingScrollable.scroll.initial);

  var scrollDisplacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__position__["a" /* negate */])(scrollDiff);

  var closestScrollable = {
    frame: existingScrollable.frame,
    shouldClipSubject: existingScrollable.shouldClipSubject,
    scroll: {
      initial: existingScrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },

      max: existingScrollable.scroll.max
    }
  };

  var displacedSubject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(droppable.viewport.subject, scrollDisplacement);

  var clipped = closestScrollable.shouldClipSubject ? clip(frame, displacedSubject) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(displacedSubject);

  var viewport = {
    closestScrollable: closestScrollable,
    subject: droppable.viewport.subject,
    clipped: clipped
  };

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, droppable, {
    viewport: viewport
  });
};

var getDroppableDimension = function getDroppableDimension(_ref2) {
  var descriptor = _ref2.descriptor,
      paddingBox = _ref2.paddingBox,
      closest = _ref2.closest,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === undefined ? 'vertical' : _ref2$direction,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === undefined ? noSpacing : _ref2$margin,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === undefined ? noSpacing : _ref2$padding,
      _ref2$windowScroll = _ref2.windowScroll,
      windowScroll = _ref2$windowScroll === undefined ? origin : _ref2$windowScroll,
      _ref2$isEnabled = _ref2.isEnabled,
      isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled;

  var client = {
    paddingBox: paddingBox,
    marginBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["b" /* expandBySpacing */])(paddingBox, margin)),
    contentBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["c" /* shrinkBySpacing */])(paddingBox, padding))
  };
  var page = {
    marginBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(client.marginBox, windowScroll)),
    paddingBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(client.paddingBox, windowScroll)),
    contentBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(client.contentBox, windowScroll))
  };
  var subject = page.marginBox;

  var closestScrollable = function () {
    if (!closest) {
      return null;
    }

    var frame = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["a" /* offsetByPosition */])(closest.framePaddingBox, windowScroll));

    var maxScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_max_scroll__["a" /* default */])({
      scrollHeight: closest.scrollHeight,
      scrollWidth: closest.scrollWidth,
      height: frame.height,
      width: frame.width
    });

    var result = {
      frame: frame,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,

        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };

    return result;
  }();

  var clipped = closestScrollable && closestScrollable.shouldClipSubject ? clip(closestScrollable.frame, subject) : subject;

  var viewport = {
    closestScrollable: closestScrollable,
    subject: subject,
    clipped: clipped
  };

  var dimension = {
    descriptor: descriptor,
    isEnabled: isEnabled,
    axis: direction === 'vertical' ? __WEBPACK_IMPORTED_MODULE_1__axis__["a" /* vertical */] : __WEBPACK_IMPORTED_MODULE_1__axis__["b" /* horizontal */],
    client: client,
    page: page,
    viewport: viewport
  };

  return dimension;
};

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (lowerBound, upperBound) {
  return function (value) {
    return value <= upperBound && value >= lowerBound;
  };
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noMovement; });


var origin = { x: 0, y: 0 };

var noMovement = {
  displaced: [],
  amount: origin,
  isBeyondStartPosition: false
};

var noImpact = {
  movement: noMovement,
  direction: null,
  destination: null
};

/* harmony default export */ __webpack_exports__["a"] = (noImpact);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unbindEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var bindEvents = function bindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sharedOptions, binding.options);

    el.addEventListener(binding.eventName, binding.fn, options);
  });
};

var unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sharedOptions, binding.options);

    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return enter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return escape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return space; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pageUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pageDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return home; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return arrowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return arrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return arrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return arrowDown; });

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.set = set;
exports.default = format;

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function inSame12Hr(start, end) {
  var s = 12 - _dates2.default.hours(start);
  var e = 12 - _dates2.default.hours(end);
  return s <= 0 && e <= 0 || s >= 0 && e >= 0;
}

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'h:mmtt', culture) + ' — ' + local.format(end, inSame12Hr(start, end) ? 'h:mm' : 'h:mmtt', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 'h:mmtt', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 'h:mmtt', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = {
  dateFormat: 'dd',
  dayFormat: 'ddd dd/MM',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 'h:mm tt',

  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'dddd MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM dd',
  agendaTimeFormat: 'hh:mm tt',
  agendaTimeRangeFormat: timeRangeFormat
};

function set(_formats) {
  var _formats2;

  if (arguments.length > 1) _formats = (_formats2 = {}, _formats2[_formats] = arguments[1], _formats2);

  _extends(formats, _formats);
}

function format(fmts) {
  return _extends({}, formats, fmts);
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(288);

var _LocaleUtils = __webpack_require__(463);

var _classNames = __webpack_require__(464);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) {
  return obj && obj.__esModule ? obj['default'] : obj;
}

var _Motion = __webpack_require__(2317);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(2318);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(2319);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(2322);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(1222);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(467);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(2321);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * A higher-order-component for handling onClickOutside for React components.
 */
(function (root) {

  // administrative
  var registeredComponents = [];
  var handlers = [];
  var IGNORE_CLASS = 'ignore-react-onclickoutside';
  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];

  /**
   * Check whether some DOM node is our Component's node.
   */
  var isNodeFound = function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    }
    // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) {
      return current.correspondingElement.classList.contains(ignoreClass);
    }
    return current.classList.contains(ignoreClass);
  };

  /**
   * Try to find our node in a hierarchy of nodes, returning the document
   * node as highest noode if our node is not found in the path up.
   */
  var findHighest = function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    }

    // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    while (current.parentNode) {
      if (isNodeFound(current, componentNode, ignoreClass)) {
        return true;
      }
      current = current.parentNode;
    }
    return current;
  };

  /**
   * Check if the browser scrollbar was clicked
   */
  var clickedScrollbar = function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
  };

  /**
   * Generate the event handler that checks whether a clicked DOM node
   * is inside of, or lives outside of, our Component's node tree.
   */
  var generateOutsideCheck = function generateOutsideCheck(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
    return function (evt) {
      if (preventDefault) {
        evt.preventDefault();
      }
      if (stopPropagation) {
        evt.stopPropagation();
      }
      var current = evt.target;
      if (excludeScrollbar && clickedScrollbar(evt) || findHighest(current, componentNode, ignoreClass) !== document) {
        return;
      }
      eventHandler(evt);
    };
  };

  /**
   * This function generates the HOC function that you'll use
   * in order to impart onOutsideClick listening to an
   * arbitrary component. It gets called at the end of the
   * bootstrapping code to yield an instance of the
   * onClickOutsideHOC function defined inside setupHOC().
   */
  function setupHOC(root, React, ReactDOM, createReactClass) {

    // The actual Component-wrapping HOC:
    return function onClickOutsideHOC(Component, config) {
      var wrapComponentWithOnClickOutsideHandling = createReactClass({
        displayName: 'wrapComponentWithOnClickOutsideHandling',

        statics: {
          /**
           * Access the wrapped Component's class.
           */
          getClass: function getClass() {
            if (Component.getClass) {
              return Component.getClass();
            }
            return Component;
          }
        },

        /**
         * Access the wrapped Component's instance.
         */
        getInstance: function getInstance() {
          return Component.prototype.isReactComponent ? this.refs.instance : this;
        },

        // this is given meaning in componentDidMount
        __outsideClickHandler: function __outsideClickHandler() {},

        getDefaultProps: function getDefaultProps() {
          return {
            excludeScrollbar: config && config.excludeScrollbar
          };
        },

        /**
         * Add click listeners to the current document,
         * linked to this component's state.
         */
        componentDidMount: function componentDidMount() {
          // If we are in an environment without a DOM such
          // as shallow rendering or snapshots then we exit
          // early to prevent any unhandled errors being thrown.
          if (typeof document === 'undefined' || !document.createElement) {
            return;
          }

          var instance = this.getInstance();
          var clickOutsideHandler;

          if (config && typeof config.handleClickOutside === 'function') {
            clickOutsideHandler = config.handleClickOutside(instance);
            if (typeof clickOutsideHandler !== 'function') {
              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
            }
          } else if (typeof instance.handleClickOutside === 'function') {
            if (React.Component.prototype.isPrototypeOf(instance)) {
              clickOutsideHandler = instance.handleClickOutside.bind(instance);
            } else {
              clickOutsideHandler = instance.handleClickOutside;
            }
          } else if (typeof instance.props.handleClickOutside === 'function') {
            clickOutsideHandler = instance.props.handleClickOutside;
          } else {
            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
          }

          var componentNode = ReactDOM.findDOMNode(instance);
          if (componentNode === null) {
            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
            console.warn(['This is typically caused by having a component that starts life with a render function that', 'returns `null` (due to a state or props value), so that the component \'exist\' in the React', 'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the', 'decision of whether or not to show your component is handled by the parent, in their render()', 'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you', 'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:', 'the parent is always responsible for deciding whether or not to render any of its children.', 'It is not the child\'s responsibility to decide whether a render instruction from above should', 'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,', 'that is the signal that it should be rendering its part of the UI. It may in turn decide not to', 'render all of *its* children, but it should never return `null` for itself. It is not responsible', 'for that decision.'].join(' '));
          }

          var fn = this.__outsideClickHandler = generateOutsideCheck(componentNode, instance, clickOutsideHandler, this.props.outsideClickIgnoreClass || IGNORE_CLASS, this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
          this.props.preventDefault || false, this.props.stopPropagation || false);

          var pos = registeredComponents.length;
          registeredComponents.push(this);
          handlers[pos] = fn;

          // If there is a truthy disableOnClickOutside property for this
          // component, don't immediately start listening for outside events.
          if (!this.props.disableOnClickOutside) {
            this.enableOnClickOutside();
          }
        },

        /**
        * Track for disableOnClickOutside props changes and enable/disable click outside
        */
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
            this.enableOnClickOutside();
          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
            this.disableOnClickOutside();
          }
        },

        /**
         * Remove the document's event listeners
         */
        componentWillUnmount: function componentWillUnmount() {
          this.disableOnClickOutside();
          this.__outsideClickHandler = false;
          var pos = registeredComponents.indexOf(this);
          if (pos > -1) {
            // clean up so we don't leak memory
            if (handlers[pos]) {
              handlers.splice(pos, 1);
            }
            registeredComponents.splice(pos, 1);
          }
        },

        /**
         * Can be called to explicitly enable event listening
         * for clicks and touches outside of this element.
         */
        enableOnClickOutside: function enableOnClickOutside() {
          var fn = this.__outsideClickHandler;
          if (typeof document !== 'undefined') {
            var events = this.props.eventTypes || DEFAULT_EVENTS;
            if (!events.forEach) {
              events = [events];
            }
            events.forEach(function (eventName) {
              document.addEventListener(eventName, fn);
            });
          }
        },

        /**
         * Can be called to explicitly disable event listening
         * for clicks and touches outside of this element.
         */
        disableOnClickOutside: function disableOnClickOutside() {
          var fn = this.__outsideClickHandler;
          if (typeof document !== 'undefined') {
            var events = this.props.eventTypes || DEFAULT_EVENTS;
            if (!events.forEach) {
              events = [events];
            }
            events.forEach(function (eventName) {
              document.removeEventListener(eventName, fn);
            });
          }
        },

        /**
         * Pass-through render
         */
        render: function render() {
          var passedProps = this.props;
          var props = {};
          Object.keys(this.props).forEach(function (key) {
            if (key !== 'excludeScrollbar') {
              props[key] = passedProps[key];
            }
          });
          if (Component.prototype.isReactComponent) {
            props.ref = 'instance';
          }
          props.disableOnClickOutside = this.disableOnClickOutside;
          props.enableOnClickOutside = this.enableOnClickOutside;
          return React.createElement(Component, props);
        }
      });

      // Add display name for React devtools
      (function bindWrappedComponentName(c, wrapper) {
        var componentName = c.displayName || c.name || 'Component';
        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
      })(Component, wrapComponentWithOnClickOutsideHandling);

      return wrapComponentWithOnClickOutsideHandling;
    };
  }

  /**
   * This function sets up the library in ways that
   * work with the various modulde loading solutions
   * used in JavaScript land today.
   */
  function setupBinding(root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(44), __webpack_require__(274)], __WEBPACK_AMD_DEFINE_RESULT__ = function (React, ReactDom, createReactClass) {
        if (!createReactClass) createReactClass = React.createClass;
        return factory(root, React, ReactDom, createReactClass);
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
      // Node. Note that this does not work with strict
      // CommonJS, but only CommonJS-like environments
      // that support module.exports
      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
    } else {
      // Browser globals (root is window)
      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
    }
  }

  // Make it all happen
  setupBinding(root, setupHOC);
})(this);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function isRelayContainer(component) {
  return !!(component && component.getFragmentNames && component.getFragment && component.hasFragment && component.hasVariable);
}

module.exports = isRelayContainer;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



/**
 * Determine if the object is a plain object that matches the `Variables` type.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isRelayVariables(variables) {
  return (typeof variables === 'undefined' ? 'undefined' : _typeof(variables)) === 'object' && variables !== null && !Array.isArray(variables);
}

module.exports = isRelayVariables;

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2446)();
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(90);







/**
 * A table row can have cells.
 */

function TableCell(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      content = props.content,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      negative = props.negative,
      positive = props.positive,
      selectable = props.selectable,
      singleLine = props.singleLine,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning,
      width = props.width;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(collapsing, 'collapsing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(selectable, 'selectable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(singleLine, 'single line'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* useWidthProp */])(width, 'wide'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(TableCell, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(TableCell, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon), content);
}

TableCell.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"];
TableCell.defaultProps = {
  as: 'td'
};
TableCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A cell can be active or selected by a user. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A cell can be collapsing so that it only uses as much space as required. */
  collapsing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A cell can be disabled. */
  disabled: PropTypes.bool,

  /** A cell may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon /> */
  icon: customPropTypes.itemShorthand,

  /** A cell may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A cell may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A cell can be selectable. */
  selectable: PropTypes.bool,

  /** A cell can specify that its contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table cell can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table cell can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A cell may warn a user. */
  warning: PropTypes.bool,

  /** A table can specify the width of individual columns independently. */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
TableCell.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(TableCell, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });



/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IconGroup__ = __webpack_require__(1311);
















/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */

var Icon =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Icon, _PureComponent);

  function Icon() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Icon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Icon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Icon, [{
    key: "getIconAriaOptions",
    value: function getIconAriaOptions() {
      var ariaOptions = {};
      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          ariaHidden = _this$props['aria-hidden'];

      if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(ariaLabel)) {
        ariaOptions['aria-hidden'] = 'true';
      } else {
        ariaOptions['aria-label'] = ariaLabel;
      }

      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(ariaHidden)) {
        ariaOptions['aria-hidden'] = ariaHidden;
      }

      return ariaOptions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bordered = _this$props2.bordered,
          circular = _this$props2.circular,
          className = _this$props2.className,
          color = _this$props2.color,
          corner = _this$props2.corner,
          disabled = _this$props2.disabled,
          fitted = _this$props2.fitted,
          flipped = _this$props2.flipped,
          inverted = _this$props2.inverted,
          link = _this$props2.link,
          loading = _this$props2.loading,
          name = _this$props2.name,
          rotated = _this$props2.rotated,
          size = _this$props2.size;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(color, name, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(bordered, 'bordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(fitted, 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* useKeyOrValueAndKey */])(corner, 'corner'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["g" /* useValueAndKey */])(flipped, 'flipped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["g" /* useValueAndKey */])(rotated, 'rotated'), 'icon', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(Icon, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["c" /* getElementType */])(Icon, this.props);
      var ariaOptions = this.getIconAriaOptions();
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onClick: this.handleClick
      }));
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_13_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "Group", __WEBPACK_IMPORTED_MODULE_15__IconGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "handledProps", ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"]);

Icon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Formatted to appear bordered. */
  bordered: PropTypes.bool,

  /** Icon can formatted to appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the icon. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Icons can display a smaller corner icon. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top left', 'top right', 'bottom left', 'bottom right'])]),

  /** Show that the icon is inactive. */
  disabled: PropTypes.bool,

  /** Fitted, without space to left or right of Icon. */
  fitted: PropTypes.bool,

  /** Icon can flipped. */
  flipped: PropTypes.oneOf(['horizontally', 'vertically']),

  /** Formatted to have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** Icon can be formatted as a link. */
  link: PropTypes.bool,

  /** Icon can be used as a simple loader. */
  loading: PropTypes.bool,

  /** Name of the icon. */
  name: customPropTypes.suggest(SUI.ALL_ICONS_IN_ALL_CONTEXTS),

  /** Icon can rotated. */
  rotated: PropTypes.oneOf(['clockwise', 'counterclockwise']),

  /** Size of the icon. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Icon can have an aria label. */
  'aria-hidden': PropTypes.string,

  /** Icon can have an aria label. */
  'aria-label': PropTypes.string
} : {};
Icon.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["e" /* createShorthandFactory */])(Icon, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });



/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A list item can contain a description.
 */

function ListDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'description');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListDescription.handledProps = ["as", "children", "className", "content"];
ListDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListDescription);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A list item can contain a header.
 */

function ListHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListHeader.handledProps = ["as", "children", "className", "content"];
ListHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListHeader);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isRefObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);


/**
 * The function that correctly handles passing refs.
 *
 * @param {Function|Object} ref An ref object or function
 * @param {HTMLElement} node A node that should be passed by ref
 */
var handleRef = function handleRef(ref, node) {
  if (false) {
    if (typeof ref === 'string') {
      throw new Error(['We do not support refs as string, this is a legacy API and will be likely to be removed in', 'one of the future releases of React.'].join(' '));
    }
  }

  if (typeof ref === 'function') {
    ref(node);
    return;
  }

  if (ref !== null && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(ref) === 'object') {
    // The `current` property is defined as readonly, however it's a valid way because `ref` is a mutable object
    // eslint-disable-next-line no-param-reassign
    ref.current = node;
  }
};
var isRefObject = function isRefObject(ref) {
  return (// https://github.com/facebook/react/blob/v16.8.2/packages/react-reconciler/src/ReactFiberCommitWork.js#L665
    // eslint-disable-next-line
    ref !== null && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(ref) === 'object' && ref.hasOwnProperty('current')
  );
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(2554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });



/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(2556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });



/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An event or an event summary can contain a date.
 */

function FeedDate(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('date', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedDate, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedDate, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

FeedDate.handledProps = ["as", "children", "className", "content"];
FeedDate.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedDate);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2676),
    listCacheDelete = __webpack_require__(2677),
    listCacheGet = __webpack_require__(2678),
    listCacheHas = __webpack_require__(2679),
    listCacheSet = __webpack_require__(2680);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(792),
    setCacheAdd = __webpack_require__(2694),
    setCacheHas = __webpack_require__(2695);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(492),
    stackClear = __webpack_require__(2696),
    stackDelete = __webpack_require__(2697),
    stackGet = __webpack_require__(2698),
    stackHas = __webpack_require__(2699),
    stackSet = __webpack_require__(2700);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(500);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(374);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1390),
    keys = __webpack_require__(118);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(371),
    toKey = __webpack_require__(258);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1389),
    baseIsNaN = __webpack_require__(2607),
    strictIndexOf = __webpack_require__(2701);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(510),
    nativeKeys = __webpack_require__(2688);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254),
    arrayMap = __webpack_require__(180),
    isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(259);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 504 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    isObject = __webpack_require__(105);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function () {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0:
        return new Ctor();
      case 1:
        return new Ctor(args[0]);
      case 2:
        return new Ctor(args[0], args[1]);
      case 3:
        return new Ctor(args[0], args[1], args[2]);
      case 4:
        return new Ctor(args[0], args[1], args[2], args[3]);
      case 5:
        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1396),
    createBind = __webpack_require__(2645),
    createCurry = __webpack_require__(2648),
    createHybrid = __webpack_require__(1404),
    createPartial = __webpack_require__(2652),
    getData = __webpack_require__(801),
    mergeData = __webpack_require__(2687),
    setData = __webpack_require__(1423),
    setWrapToString = __webpack_require__(1424),
    toInteger = __webpack_require__(181);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2673);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1420);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;

/***/ }),
/* 510 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(1408);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 513 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(2590),
    hasUnicode = __webpack_require__(509),
    unicodeToArray = __webpack_require__(2704);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

module.exports = stringToArray;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1388),
    baseFlatten = __webpack_require__(370),
    baseRest = __webpack_require__(205),
    isArrayLikeObject = __webpack_require__(376);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function (array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});

module.exports = difference;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1380),
    baseFilter = __webpack_require__(2596),
    baseIteratee = __webpack_require__(117),
    isArray = __webpack_require__(51);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(501),
    getTag = __webpack_require__(206),
    isArguments = __webpack_require__(375),
    isArray = __webpack_require__(51),
    isArrayLike = __webpack_require__(142),
    isBuffer = __webpack_require__(302),
    isPrototype = __webpack_require__(510),
    isTypedArray = __webpack_require__(378);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isArray = __webpack_require__(51),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1381),
    baseKeysIn = __webpack_require__(2612),
    isArrayLike = __webpack_require__(142);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(792);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(2619),
    flatRest = __webpack_require__(800);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(1382),
    baseEach = __webpack_require__(255),
    baseIteratee = __webpack_require__(117),
    baseReduce = __webpack_require__(2623),
    isArray = __webpack_require__(51);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce,
        initAccum = arguments.length < 3;

    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105),
    isSymbol = __webpack_require__(259);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderComponent__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AppContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext({
  window: { width: window.innerWidth, height: window.innerHeight }
});

var AppConsumer = AppContext.Consumer;

var AppComponent = (_temp = _class = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = { sidebarOpen: false };
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
      var viewer = this.props.viewer;

      if (viewer && !viewer.s_time_zone) this.setTimeZone();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'setTimeZone',
    value: function setTimeZone() {
      var onError = function onError(e) {
        // eslint-disable-next-line
        console.error('Error updating user time zone', e);
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2822);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.viewer.id,
            s_time_zone: __WEBPACK_IMPORTED_MODULE_10_moment___default.a.tz.guess()
          }
        },
        onError: onError
      });
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight },
        isMobile: window.innerWidth < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint,
        isComputer: window.innerWidth >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint,
        isLargeScreen: window.innerWidth >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].largeScreenBreakpoint
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6__App_scss___default.a.root },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          AppContext.Provider,
          { value: this.state },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_sidebar___default.a,
            {
              sidebar: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SidebarComponent__["a" /* default */], {
                setSidebarOpenState: this.onSetSidebarOpen,
                router: this.props.router,
                viewer: this.props.viewer
              }),
              sidebarClassName: __WEBPACK_IMPORTED_MODULE_6__App_scss___default.a.mobileSidebar,
              open: this.state.sidebarOpen,
              onSetOpen: this.onSetSidebarOpen,
              touch: false
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HeaderComponent__["a" /* default */], { viewer: this.props.viewer, router: this.props.router }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
              toggleSidebar: this.toggleSidebar,
              sidebarOpen: this.state.sidebarOpen
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: 'desktopModal', className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.desktop }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: 'mobileModal', className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.mobile })
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(AppComponent));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchComponent__ = __webpack_require__(2815);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__SearchComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2828);
  }
}, function () {
  return __webpack_require__(2827);
}));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Share__ = __webpack_require__(3099);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__Share__["a" /* default */], {
  event: function event() {
    return __webpack_require__(3100);
  }
}));

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Library__ = __webpack_require__(3106);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__Library__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3109);
  }
}));

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineItemShow__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineItemsSortable__ = __webpack_require__(3114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LineItemsHeader__ = __webpack_require__(3113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_beautiful_dnd__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LineItemsComponent = function (_React$Component) {
  _inherits(LineItemsComponent, _React$Component);

  function LineItemsComponent(props) {
    _classCallCheck(this, LineItemsComponent);

    var _this = _possibleConstructorReturn(this, (LineItemsComponent.__proto__ || Object.getPrototypeOf(LineItemsComponent)).call(this, props));

    _this.getTotal = _this.getTotal.bind(_this);
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.state = {
      draggingIndex: null
    };
    return _this;
  }

  _createClass(LineItemsComponent, [{
    key: 'onDragEnd',
    value: function onDragEnd(_ref) {
      var source = _ref.source,
          destination = _ref.destination;

      // Check that item is dropped on a valid drop destination
      if (source && destination) {
        this.setState({ draggingIndex: null });
        this.props.moveLineItem(source.index, destination.index);
      }
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(_ref2) {
      var source = _ref2.source;

      this.setState({ draggingIndex: source.index });
    }
  }, {
    key: 'getTotal',
    value: function getTotal(services) {
      var total = 0;
      services.map(function (service) {
        var quantity = service.node.quantity || 1;
        var price = service.node.price_cents || 0;
        total += parseFloat(price * parseInt(quantity, 10) / 100);
        return service;
      });
      return total;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          hideTotal = _props.hideTotal,
          toggleHideTotal = _props.toggleHideTotal;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
        { stackable: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { computer: 16, tablet: 16, mobile: 16 },
            this.props.lineItems.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'This event has no line items'
              )
            ),
            this.props.lineItems.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LineItemsHeader__["a" /* default */], null),
            !this.props.readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_beautiful_dnd__["a" /* DragDropContext */],
              {
                onDragEnd: this.onDragEnd,
                onDragStart: this.onDragStart
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_beautiful_dnd__["b" /* Droppable */],
                { droppableId: 'line_items' },
                function (provided) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      _extends({ ref: provided.innerRef }, provided.droppableProps),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LineItemsSortable__["a" /* default */], {
                        draggingIndex: _this2.state.draggingIndex,
                        lineItems: _this2.props.lineItems,
                        localLineItems: _this2.props.localLineItems,
                        lineItemChangeHandler: _this2.props.lineItemChangeHandler,
                        updateLineItem: _this2.props.updateLineItem,
                        resetEditLineItem: _this2.props.resetEditLineItem,
                        deleteLineItem: _this2.props.deleteLineItem
                      })
                    ),
                    provided.placeholder
                  );
                }
              )
            ),
            this.props.readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.lineItems.map(function (service, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LineItemShow__["a" /* default */], {
                  service: service.node,
                  key: service.node.id || idx,
                  index: idx,
                  readOnly: _this2.props.readOnly
                });
              })
            ),
            this.props.lineItems.length > 0 && !(this.props.hideTotal && this.props.readOnly) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
              { padded: true, relaxed: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["v" /* Divider */], null)
                )
              ),
              !this.props.hideTotal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__Elements__["l" /* SummaryTotals */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["l" /* SummaryTotals */].Row, {
                      label: 'Total',
                      style: this.props.totalPaid ? {} : { fontWeight: 'bold' },
                      value: __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(this.getTotal(this.props.localLineItems), {
                        code: this.props.localLineItems[0].node.price_currency
                      })
                    }),
                    this.props.totalPaid != null && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["l" /* SummaryTotals */].Row, {
                      label: 'Amount Paid',
                      key: 'paymentsMade',
                      minus: true,
                      value: __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(this.props.totalPaid / 100, {
                        code: this.props.localLineItems[0].node.price_currency
                      })
                    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["l" /* SummaryTotals */].Break, { key: 'break' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["l" /* SummaryTotals */].Row, {
                      style: { fontWeight: 'bold' },
                      label: 'Remaining Balance',
                      key: 'remainingBalance',
                      value: __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(this.getTotal(this.props.localLineItems) - this.props.totalPaid / 100, {
                        code: 'USD'
                      })
                    })]
                  )
                )
              ),
              this.props.canHideTotal && !this.props.readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                    content: (hideTotal ? 'Show' : 'Hide') + ' Total',
                    onClick: function onClick() {
                      return toggleHideTotal();
                    },
                    basic: true,
                    negative: !hideTotal,
                    positive: hideTotal,
                    icon: (hideTotal ? 'plus' : 'minus') + ' circle'
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LineItemsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LineItemsComponent.propTypes = {
  canHideTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggleHideTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  localLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  lineItemChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  totalPaid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  moveLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetEditLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsComponent);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Option = function Option(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { marginBottom: '1em' } },
    children
  );
};

Option.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3539);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ExpandCollapseTransition.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ExpandCollapseTransition.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3547);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Proposal.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Proposal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3557);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SignatureBlocks.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SignatureBlocks.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3576);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./ContactStyles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./ContactStyles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodes = {
    8: "backspace",
    9: "tab",
    13: "enter",
    20: "capslock",
    27: "esc",
    32: "space",
    33: "pageup",
    34: "pagedown",
    35: "end",
    36: "home",
    37: "left",
    38: "up",
    39: "right",
    40: "down",
    45: "ins",
    46: "del",
    // number keys
    48: "0",
    49: "1",
    50: "2",
    51: "3",
    52: "4",
    53: "5",
    54: "6",
    55: "7",
    56: "8",
    57: "9",
    // alphabet
    65: "a",
    66: "b",
    67: "c",
    68: "d",
    69: "e",
    70: "f",
    71: "g",
    72: "h",
    73: "i",
    74: "j",
    75: "k",
    76: "l",
    77: "m",
    78: "n",
    79: "o",
    80: "p",
    81: "q",
    82: "r",
    83: "s",
    84: "t",
    85: "u",
    86: "v",
    87: "w",
    88: "x",
    89: "y",
    90: "z",
    // punctuation
    106: "*",
    107: "+",
    109: "-",
    110: ".",
    111: "/",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "\'"
};
exports.Modifiers = {
    16: "shift",
    17: "ctrl",
    18: "alt",
    91: "meta",
    93: "meta",
    224: "meta"
};
exports.ModifierBitMasks = {
    alt: 1,
    ctrl: 2,
    meta: 4,
    shift: 8
};
exports.Aliases = {
    cmd: "meta",
    command: "meta",
    escape: "esc",
    minus: "-",
    mod: typeof navigator !== "undefined" && /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl",
    option: "alt",
    plus: "+",
    return: "enter",
    win: "meta"
};
// alph sorting is unintuitive here
// tslint:disable object-literal-sort-keys
exports.ShiftKeys = {
    "~": "`",
    "!": "1",
    "@": "2",
    "#": "3",
    "$": "4",
    "%": "5",
    "^": "6",
    "&": "7",
    "*": "8",
    "(": "9",
    ")": "0",
    "_": "-",
    "+": "=",
    "{": "[",
    "}": "]",
    "|": "\\",
    ":": ";",
    "\"": "\'",
    "<": ",",
    ">": ".",
    "?": "/"
};
// tslint:enable object-literal-sort-keys
/* tslint:enable:object-literal-key-quotes */
// Function keys
for (var i = 1; i <= 12; ++i) {
    exports.KeyCodes[111 + i] = "f" + i;
}
// Numpad
for (var i = 0; i <= 9; ++i) {
    exports.KeyCodes[96 + i] = "num" + i.toString();
}
function comboMatches(a, b) {
    return a.modifiers === b.modifiers && a.key === b.key;
}
exports.comboMatches = comboMatches;
/**
 * Converts a key combo string into a key combo object. Key combos include
 * zero or more modifier keys, such as `shift` or `alt`, and exactly one
 * action key, such as `A`, `enter`, or `left`.
 *
 * For action keys that require a shift, e.g. `@` or `|`, we inlude the
 * necessary `shift` modifier and automatically convert the action key to the
 * unshifted version. For example, `@` is equivalent to `shift+2`.
 */
exports.parseKeyCombo = function (combo) {
    var pieces = combo.replace(/\s/g, "").toLowerCase().split("+");
    var modifiers = 0;
    var key = null;
    for (var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++) {
        var piece = pieces_1[_i];
        if (piece === "") {
            throw new Error("Failed to parse key combo \"" + combo + "\".\n                Valid key combos look like \"cmd + plus\", \"shift+p\", or \"!\"");
        }
        if (exports.Aliases[piece] != null) {
            piece = exports.Aliases[piece];
        }
        if (exports.ModifierBitMasks[piece] != null) {
            modifiers += exports.ModifierBitMasks[piece];
        } else if (exports.ShiftKeys[piece] != null) {
            // tslint:disable-next-line no-string-literal
            modifiers += exports.ModifierBitMasks["shift"];
            key = exports.ShiftKeys[piece];
        } else {
            key = piece.toLowerCase();
        }
    }
    return { modifiers: modifiers, key: key };
};
/**
 * PhantomJS's webkit totally messes up keyboard events, so we have do this
 * fancy little dance with the event data to determine which key was pressed
 * for unit tests.
 */
var normalizeKeyCode = function normalizeKeyCode(e) {
    return e.which === 0 && e.key != null ? e.key.charCodeAt(0) : e.which;
};
/**
 * Converts a keyboard event into a valid combo prop string
 */
exports.getKeyComboString = function (e) {
    var keys = [];
    // modifiers first
    if (e.ctrlKey) {
        keys.push("ctrl");
    }
    if (e.altKey) {
        keys.push("alt");
    }
    if (e.shiftKey) {
        keys.push("shift");
    }
    if (e.metaKey) {
        keys.push("meta");
    }
    var which = normalizeKeyCode(e);
    if (exports.Modifiers[which] != null) {
        // no action key
    } else if (exports.KeyCodes[which] != null) {
        keys.push(exports.KeyCodes[which]);
    } else {
        keys.push(String.fromCharCode(which).toLowerCase());
    }
    // join keys with plusses
    return keys.join(" + ");
};
/**
 * Determines the key combo object from the given keyboard event. Again, a key
 * combo includes zero or more modifiers (represented by a bitmask) and one
 * action key, which we determine from the `e.which` property of the keyboard
 * event.
 */
exports.getKeyCombo = function (e) {
    var key = null;
    var which = normalizeKeyCode(e);
    if (exports.Modifiers[which] != null) {
        // keep key null
    } else if (exports.KeyCodes[which] != null) {
        key = exports.KeyCodes[which];
    } else {
        key = String.fromCharCode(which).toLowerCase();
    }
    var modifiers = 0;
    // tslint:disable no-string-literal
    if (e.altKey) {
        modifiers += exports.ModifierBitMasks["alt"];
    }
    if (e.ctrlKey) {
        modifiers += exports.ModifierBitMasks["ctrl"];
    }
    if (e.metaKey) {
        modifiers += exports.ModifierBitMasks["meta"];
    }
    if (e.shiftKey) {
        modifiers += exports.ModifierBitMasks["shift"];
    }
    // tslint:enable
    return { modifiers: modifiers, key: key };
};
/**
 * Splits a key combo string into its constituent key values and looks up
 * aliases, such as `return` -> `enter`.
 *
 * Unlike the parseKeyCombo method, this method does NOT convert shifted
 * action keys. So `"@"` will NOT be converted to `["shift", "2"]`).
 */
exports.normalizeKeyCombo = function (combo) {
    var keys = combo.replace(/\s/g, "").split("+");
    return keys.map(function (key) {
        return exports.Aliases[key] != null ? exports.Aliases[key] : key;
    });
};
/* tslint:enable:no-string-literal */

//# sourceMappingURL=hotkeyParser.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Menu = function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        return React.createElement("ul", { className: classNames(Classes.MENU, this.props.className), ref: this.props.ulRef }, this.props.children);
    };
    return Menu;
}(React.Component);
Menu.displayName = "Blueprint.Menu";
exports.Menu = Menu;
exports.MenuFactory = React.createFactory(Menu);

//# sourceMappingURL=menu.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var SPINNER_TRACK = "M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89";
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var PATH_LENGTH = 280;
var Spinner = function (_super) {
    tslib_1.__extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            intent = _a.intent,
            value = _a.value;
        var classes = classNames(Classes.SPINNER, Classes.intentClass(intent), {
            "pt-no-spin": value != null
        }, className);
        var style = {
            strokeDasharray: PATH_LENGTH + " " + PATH_LENGTH,
            // default to quarter-circle when indeterminate
            // IE11: CSS transitions on SVG elements are Not Supported :(
            strokeDashoffset: PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : utils_1.clamp(value, 0, 1))
        };
        // HACKHACK to temporarily squash error regarding React.SVGProps missing prop pathLength
        var headElement = React.createElement("path", {
            className: "pt-spinner-head",
            d: SPINNER_TRACK,
            pathLength: PATH_LENGTH,
            style: style
        });
        return this.renderContainer(classes, React.createElement("svg", { viewBox: classes.indexOf(Classes.SMALL) >= 0 ? "-15 -15 130 130" : "0 0 100 100" }, React.createElement("path", { className: "pt-spinner-track", d: SPINNER_TRACK }), headElement));
    };
    // abstract away the container elements so SVGSpinner can do its own thing
    Spinner.prototype.renderContainer = function (classes, content) {
        return React.createElement("div", { className: classes }, React.createElement("div", { className: "pt-spinner-svg-container" }, content));
    };
    return Spinner;
}(React.Component);
Spinner.displayName = "Blueprint.Spinner";
Spinner = tslib_1.__decorate([PureRender], Spinner);
exports.Spinner = Spinner;
exports.SpinnerFactory = React.createFactory(Spinner);

//# sourceMappingURL=spinner.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var position_1 = __webpack_require__(157);
var popover_1 = __webpack_require__(266);
var Tooltip = function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            intent = _a.intent,
            openOnTargetFocus = _a.openOnTargetFocus,
            tooltipClassName = _a.tooltipClassName;
        var classes = classNames(Classes.TOOLTIP, Classes.intentClass(intent), tooltipClassName);
        return React.createElement(popover_1.Popover, tslib_1.__assign({}, this.props, { arrowSize: 22, autoFocus: false, canEscapeKeyClose: false, enforceFocus: false, interactionKind: popover_1.PopoverInteractionKind.HOVER_TARGET_ONLY, lazy: true, openOnTargetFocus: openOnTargetFocus, popoverClassName: classes }), children);
    };
    return Tooltip;
}(React.Component);
Tooltip.defaultProps = {
    hoverCloseDelay: 0,
    hoverOpenDelay: 100,
    isDisabled: false,
    openOnTargetFocus: true,
    position: position_1.Position.TOP,
    rootElementTag: "span",
    transitionDuration: 100,
    useSmartArrowPositioning: true,
    useSmartPositioning: false
};
Tooltip.displayName = "Blueprint.Tooltip";
Tooltip = tslib_1.__decorate([PureRender], Tooltip);
exports.Tooltip = Tooltip;
exports.TooltipFactory = React.createFactory(Tooltip);

//# sourceMappingURL=tooltip.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1524));
__export(__webpack_require__(186));
__export(__webpack_require__(845));

//# sourceMappingURL=index.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.

var rawAsap = __webpack_require__(305);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(549), __esModule: true };

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(552), __esModule: true };

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(553), __esModule: true };

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _symbol = __webpack_require__(306);

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new _promise2.default(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          _promise2.default.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof _symbol2.default === "function" && _symbol2.default.asyncIterator) {
    AsyncGenerator.prototype[_symbol2.default.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function wrap(fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function _await(value) {
      return new AwaitValue(value);
    }
  };
}();

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getIterator2 = __webpack_require__(392);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _iterator = __webpack_require__(395);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(306);

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (iterable) {
  if (typeof _symbol2.default === "function") {
    if (_symbol2.default.asyncIterator) {
      var method = iterable[_symbol2.default.asyncIterator];
      if (method != null) return method.call(iterable);
    }

    if (_iterator2.default) {
      return (0, _getIterator3.default)(iterable);
    }
  }

  throw new TypeError("Object is not async iterable");
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
__webpack_require__(573);
module.exports = __webpack_require__(45).Array.from;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(575);
module.exports = __webpack_require__(45).Object.assign;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(576);
var $Object = __webpack_require__(45).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(577);
var $Object = __webpack_require__(45).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
module.exports = __webpack_require__(45).Object.setPrototypeOf;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(579);
__webpack_require__(402);
__webpack_require__(580);
__webpack_require__(581);
module.exports = __webpack_require__(45).Symbol;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
__webpack_require__(315);
module.exports = __webpack_require__(225).f('iterator');

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(88);
var toLength = __webpack_require__(271);
var toAbsoluteIndex = __webpack_require__(572);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(79);
var createDesc = __webpack_require__(129);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(109);
var gOPS = __webpack_require__(219);
var pIE = __webpack_require__(147);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(159);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(218);
var descriptor = __webpack_require__(129);
var setToStringTag = __webpack_require__(191);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(101)(IteratorPrototype, __webpack_require__(56)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(109);
var toIObject = __webpack_require__(88);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) {
    if (O[key = keys[index++]] === el) return key;
  }
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(161)('meta');
var isObject = __webpack_require__(125);
var has = __webpack_require__(94);
var setDesc = __webpack_require__(79).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(124)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__(269);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var getKeys = __webpack_require__(109);
var gOPS = __webpack_require__(219);
var pIE = __webpack_require__(147);
var toObject = __webpack_require__(160);
var IObject = __webpack_require__(308);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(124)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(79);
var anObject = __webpack_require__(86);
var getKeys = __webpack_require__(109);

module.exports = __webpack_require__(87) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(88);
var gOPN = __webpack_require__(311).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(125);
var anObject = __webpack_require__(86);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(146)(Function.call, __webpack_require__(310).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(222);
var defined = __webpack_require__(216);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(146);
var invoke = __webpack_require__(1616);
var html = __webpack_require__(397);
var cel = __webpack_require__(270);
var global = __webpack_require__(64);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(159)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(222);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(146);
var $export = __webpack_require__(63);
var toObject = __webpack_require__(160);
var call = __webpack_require__(399);
var isArrayIter = __webpack_require__(398);
var toLength = __webpack_require__(271);
var createProperty = __webpack_require__(558);
var getIterFn = __webpack_require__(314);

$export($export.S + $export.F * !__webpack_require__(400)(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(556);
var step = __webpack_require__(562);
var Iterators = __webpack_require__(128);
var toIObject = __webpack_require__(88);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(309)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(63);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(566) });

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(63);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(218) });

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(63);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(87), 'Object', { defineProperty: __webpack_require__(79).f });

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(63);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(569).set });

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(64);
var has = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(87);
var $export = __webpack_require__(63);
var redefine = __webpack_require__(313);
var META = __webpack_require__(564).KEY;
var $fails = __webpack_require__(124);
var shared = __webpack_require__(221);
var setToStringTag = __webpack_require__(191);
var uid = __webpack_require__(161);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(225);
var wksDefine = __webpack_require__(224);
var keyOf = __webpack_require__(563);
var enumKeys = __webpack_require__(559);
var isArray = __webpack_require__(560);
var anObject = __webpack_require__(86);
var toIObject = __webpack_require__(88);
var toPrimitive = __webpack_require__(223);
var createDesc = __webpack_require__(129);
var _create = __webpack_require__(218);
var gOPNExt = __webpack_require__(568);
var $GOPD = __webpack_require__(310);
var $DP = __webpack_require__(79);
var $keys = __webpack_require__(109);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(311).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(147).f = $propertyIsEnumerable;
  __webpack_require__(219).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(190)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(101)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(224)('asyncIterator');

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(224)('observable');

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(316);
var TAG = __webpack_require__(96)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95);
var document = __webpack_require__(102).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(272);
var call = __webpack_require__(1636);
var isArrayIter = __webpack_require__(1634);
var anObject = __webpack_require__(192);
var toLength = __webpack_require__(882);
var getIterFn = __webpack_require__(1648);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(404);
var $export = __webpack_require__(130);
var redefine = __webpack_require__(230);
var hide = __webpack_require__(228);
var has = __webpack_require__(193);
var Iterators = __webpack_require__(317);
var $iterCreate = __webpack_require__(1637);
var setToStringTag = __webpack_require__(318);
var getPrototypeOf = __webpack_require__(877);
var ITERATOR = __webpack_require__(96)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(406);
var createDesc = __webpack_require__(407);
var toIObject = __webpack_require__(194);
var toPrimitive = __webpack_require__(595);
var has = __webpack_require__(193);
var IE8_DOM_DEFINE = __webpack_require__(869);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(149) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 590 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(230);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(593)('keys');
var uid = __webpack_require__(319);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(95);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(1645)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(588)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(1649);
var getKeys = __webpack_require__(229);
var redefine = __webpack_require__(230);
var global = __webpack_require__(102);
var hide = __webpack_require__(228);
var Iterators = __webpack_require__(317);
var wks = __webpack_require__(96);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(320);


/* harmony default export */ __webpack_exports__["a"] = (function (values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function has(key) {
    return prefix + key in this;
  },
  get: function get(key) {
    return this[prefix + key];
  },
  set: function set(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function remove(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function clear() {
    for (var property in this) {
      if (property[0] === prefix) delete this[property];
    }
  },
  keys: function keys() {
    var keys = [];
    for (var property in this) {
      if (property[0] === prefix) keys.push(property.slice(1));
    }return keys;
  },
  values: function values() {
    var values = [];
    for (var property in this) {
      if (property[0] === prefix) values.push(this[property]);
    }return values;
  },
  entries: function entries() {
    var entries = [];
    for (var property in this) {
      if (property[0] === prefix) entries.push({ key: property.slice(1), value: this[property] });
    }return entries;
  },
  size: function size() {
    var size = 0;
    for (var property in this) {
      if (property[0] === prefix) ++size;
    }return size;
  },
  empty: function empty() {
    for (var property in this) {
      if (property[0] === prefix) return false;
    }return true;
  },
  each: function each(f) {
    for (var property in this) {
      if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
  }
};

function map(object, f) {
  var map = new Map();

  // Copy constructor.
  if (object instanceof Map) object.each(function (value, key) {
    map.set(key, value);
  });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;

      if (f == null) while (++i < n) {
        map.set(i, object[i]);
      } else while (++i < n) {
        map.set(f(o = object[i], i, object), o);
      }
    }

    // Convert object to map.
    else if (object) for (var key in object) {
        map.set(key, object[key]);
      }return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(602);


function Color() {}

var _darker = 0.7;

var _brighter = 1 / _darker;


var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: function hex() {
    return this.rgb().hex();
  },
  toString: function toString() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb(m >> 8 & 0xf | m >> 4 & 0x0f0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  ) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
  : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: function hex() {
    return "#" + _hex(this.r) + _hex(this.g) + _hex(this.b);
  },
  toString: function toString() {
    var a = this.opacity;a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function _hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) {
    prototype[key] = definition[key];
  }return prototype;
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
/* harmony default export */ __webpack_exports__["a"] = (function (x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i,
      coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = optional;
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error();
  return f;
}

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["c"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links__ = __webpack_require__(1722);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do {
    node.height = height;
  } while ((node = node.parent) && node.height < ++height);
}

function Node(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links__["a" /* default */],
  copy: node_copy
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["b"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(411);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx,
      dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do {
      sumValue = nodes[i1++].value;
    } while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;break;
      }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
      t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(907);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
    var t = typeof b === "undefined" ? "undefined" : _typeof(b),
        c;
    return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b) : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */] : t === "string" ? (c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["color"])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */] : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["color"] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */] : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */] : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */] : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loggish;
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nice__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init__ = __webpack_require__(103);






function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : function (x) {
    return Math.pow(base, x);
  };
}

function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function (x) {
    return Math.log(x) / base;
  });
}

function reflect(f) {
  return function (x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function (_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function (count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function (count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["format"])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function (d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function () {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nice__["a" /* default */])(domain(), {
      floor: function floor(x) {
        return pows(Math.floor(logs(x)));
      },
      ceil: function ceil(x) {
        return pows(Math.ceil(logs(x)));
      }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["b" /* transformer */])()).domain([1, 10]);

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["c" /* copy */])(scale, log()).base(scale.base());
  };

  __WEBPACK_IMPORTED_MODULE_4__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = powish;
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




function transformPow(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */]),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */]) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function (_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function pow() {
  var scale = powish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b" /* transformer */])());

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, pow()).exponent(scale.exponent());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = symlogish;
/* harmony export (immutable) */ __webpack_exports__["a"] = symlog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




function transformSymlog(c) {
  return function (x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function (x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1,
      scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function (_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function symlog() {
  var scale = symlogish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b" /* transformer */])());

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, symlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _point; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(414);




function _point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);break;
      case 3:
        this.point(this._x2, this._y2);break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3; // proceed
      default:
        _point(this, x, y);break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(615);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(327);


/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function (a, b) {
    return sums[a] - sums[b];
  });
});

function sum(series) {
  var s = 0,
      i = -1,
      n = series.length,
      v;
  while (++i < n) {
    if (v = +series[i][1]) s += v;
  }return s;
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(936);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond__ = __webpack_require__(1826);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second__ = __webpack_require__(1829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute__ = __webpack_require__(1827);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour__ = __webpack_require__(1825);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day__ = __webpack_require__(1824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week__ = __webpack_require__(1836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month__ = __webpack_require__(1828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year__ = __webpack_require__(1837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute__ = __webpack_require__(1832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour__ = __webpack_require__(1831);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay__ = __webpack_require__(1830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek__ = __webpack_require__(1834);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth__ = __webpack_require__(1833);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear__ = __webpack_require__(1835);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear__["a"]; });
/* unused harmony reexport utcYears */






























/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keys = __webpack_require__(1172);
var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol('foo')) === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) {
			// jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) {
		/* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _off = __webpack_require__(625);

var _off2 = _interopRequireDefault(_off);

var _on = __webpack_require__(626);

var _on2 = _interopRequireDefault(_on);

var _invariant = __webpack_require__(627);

var _invariant2 = _interopRequireDefault(_invariant);

var _createPath = __webpack_require__(418);

var _createPath2 = _interopRequireDefault(_createPath);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var BrowserProtocol = function () {
  function BrowserProtocol() {
    _classCallCheck(this, BrowserProtocol);

    this._keyPrefix = Math.random().toString(36).slice(2, 8);
    this._keyIndex = 0;

    this._index = null;
  }

  BrowserProtocol.prototype.init = function init() {
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var _ref = window.history.state || {},
        key = _ref.key,
        _ref$index = _ref.index,
        index = _ref$index === undefined ? 0 : _ref$index,
        state = _ref.state;

    var delta = this._index != null ? index - this._index : 0;
    this._index = index;

    return {
      action: 'POP',
      pathname: pathname,
      search: search,
      hash: hash,
      key: key,
      index: index,
      delta: delta,
      state: state
    };
  };

  BrowserProtocol.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    var onPopState = function onPopState() {
      listener(_this.init());
    };

    // TODO: On most versions of IE, we need a hashChange listener for hash-
    // only changes.

    (0, _on2.default)(window, 'popstate', onPopState);
    return function () {
      return (0, _off2.default)(window, 'popstate', onPopState);
    };
  };

  BrowserProtocol.prototype.transition = function transition(location) {
    var action = location.action,
        state = location.state;

    var push = action === 'PUSH';
    !(push || action === 'REPLACE') ?  false ? (0, _invariant2.default)(false, 'Unrecognized browser protocol action ' + action + '.') : (0, _invariant2.default)(false) : void 0;

    var delta = push ? 1 : 0;
    var extraState = this._createExtraState(delta);

    var browserState = _extends({ state: state }, extraState);
    var path = (0, _createPath2.default)(location);

    if (push) {
      window.history.pushState(browserState, null, path);
    } else {
      window.history.replaceState(browserState, null, path);
    }

    return _extends({}, location, extraState, { delta: delta });
  };

  BrowserProtocol.prototype.go = function go(delta) {
    window.history.go(delta);
  };

  BrowserProtocol.prototype.createHref = function createHref(location) {
    return (0, _createPath2.default)(location);
  };

  BrowserProtocol.prototype._createExtraState = function _createExtraState(delta) {
    var keyIndex = this._keyIndex++;
    this._index += delta;

    return {
      key: this._keyPrefix + ':' + keyIndex.toString(36),
      index: this._index
    };
  };

  return BrowserProtocol;
}();

exports.default = BrowserProtocol;
module.exports = exports['default'];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = createHistoryEnhancer;

var _redux = __webpack_require__(296);

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createHistoryMiddleware = __webpack_require__(952);

var _createHistoryMiddleware2 = _interopRequireDefault(_createHistoryMiddleware);

var _createTransitionHookMiddleware = __webpack_require__(955);

var _createTransitionHookMiddleware2 = _interopRequireDefault(_createTransitionHookMiddleware);

var _ensureLocationMiddleware = __webpack_require__(956);

var _ensureLocationMiddleware2 = _interopRequireDefault(_ensureLocationMiddleware);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createHref(location) {
  return {
    type: _ActionTypes2.default.CREATE_HREF,
    payload: location
  };
}

function createLocation(location) {
  return {
    type: _ActionTypes2.default.CREATE_LOCATION,
    payload: location
  };
}

function createHistoryEnhancer(_ref) {
  var protocol = _ref.protocol,
      _ref$middlewares = _ref.middlewares,
      middlewares = _ref$middlewares === undefined ? [] : _ref$middlewares,
      useBeforeUnload = _ref.useBeforeUnload;

  return function historyEnhancer(createStore) {
    return function () {
      var transitionHookMiddleware = (0, _createTransitionHookMiddleware2.default)({
        useBeforeUnload: useBeforeUnload
      });

      var middlewareEnhancer = _redux.applyMiddleware.apply(undefined, [_ensureLocationMiddleware2.default, transitionHookMiddleware].concat(middlewares, [(0, _createHistoryMiddleware2.default)(protocol)], [].concat(middlewares).reverse(), [transitionHookMiddleware]));

      var store = middlewareEnhancer(createStore).apply(undefined, arguments);
      var boundActionCreators = (0, _redux.bindActionCreators)({ createHref: createHref, createLocation: createLocation }, store.dispatch);

      return _extends({}, store, {
        farce: _extends({}, boundActionCreators, {
          addTransitionHook: transitionHookMiddleware.addHook
        })
      });
    };
  };
}
module.exports = exports['default'];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createLocationMiddleware;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createLocationMiddleware(_ref) {
  var makeLocationDescriptor = _ref.makeLocationDescriptor,
      makeLocation = _ref.makeLocation;

  return function locationMiddleware() {
    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        switch (type) {
          case _ActionTypes2.default.TRANSITION:
          case _ActionTypes2.default.CREATE_HREF:
            return next({ type: type, payload: makeLocationDescriptor(payload) });
          case _ActionTypes2.default.CREATE_LOCATION:
            return makeLocation(next({ type: type, payload: makeLocationDescriptor(payload) }));
          case _ActionTypes2.default.UPDATE_LOCATION:
            return next({ type: type, payload: makeLocation(payload) });
          default:
            return next(action);
        }
      };
    };
  };
}
module.exports = exports['default'];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(959);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(959);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var PropTypes = __webpack_require__(1);
var utils = __webpack_require__(960);
var React = global.React || __webpack_require__(0);

var convertValidationsToObject = function convertValidationsToObject(validations) {

  if (typeof validations === 'string') {

    return validations.split(/\,(?![^{\[]*[}\]])/g).reduce(function (validations, validation) {
      var args = validation.split(':');
      var validateMethod = args.shift();

      args = args.map(function (arg) {
        try {
          return JSON.parse(arg);
        } catch (e) {
          return arg; // It is a string if it can not parse it
        }
      });

      if (args.length > 1) {
        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
      }

      validations[validateMethod] = args.length ? args[0] : true;
      return validations;
    }, {});
  }

  return validations || {};
};

module.exports = {
  getInitialState: function getInitialState() {
    return {
      _value: this.props.value,
      _isRequired: false,
      _isValid: true,
      _isPristine: true,
      _pristineValue: this.props.value,
      _validationError: [],
      _externalError: null,
      _formSubmitted: false
    };
  },
  contextTypes: {
    formsy: PropTypes.object // What about required?
  },
  getDefaultProps: function getDefaultProps() {
    return {
      validationError: '',
      validationErrors: {}
    };
  },

  componentWillMount: function componentWillMount() {
    var configure = function () {
      this.setValidations(this.props.validations, this.props.required);

      // Pass a function instead?
      this.context.formsy.attachToForm(this);
      //this.props._attachToForm(this);
    }.bind(this);

    if (!this.props.name) {
      throw new Error('Form Input requires a name property when used');
    }

    /*
    if (!this.props._attachToForm) {
      return setTimeout(function () {
        if (!this.isMounted()) return;
        if (!this.props._attachToForm) {
          throw new Error('Form Mixin requires component to be nested in a Form');
        }
        configure();
      }.bind(this), 0);
    }
    */
    configure();
  },

  // We have to make the validate method is kept when new props are added
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setValidations(nextProps.validations, nextProps.required);
  },

  componentDidUpdate: function componentDidUpdate(prevProps) {

    // If the value passed has changed, set it. If value is not passed it will
    // internally update, and this will never run
    if (!utils.isSame(this.props.value, prevProps.value)) {
      this.setValue(this.props.value);
    }

    // If validations or required is changed, run a new validation
    if (!utils.isSame(this.props.validations, prevProps.validations) || !utils.isSame(this.props.required, prevProps.required)) {
      this.context.formsy.validate(this);
    }
  },

  // Detach it when component unmounts
  componentWillUnmount: function componentWillUnmount() {
    this.context.formsy.detachFromForm(this);
    //this.props._detachFromForm(this);
  },

  setValidations: function setValidations(validations, required) {

    // Add validations to the store itself as the props object can not be modified
    this._validations = convertValidationsToObject(validations) || {};
    this._requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
  },

  // We validate after the value has been set
  setValue: function setValue(value) {
    this.setState({
      _value: value,
      _isPristine: false
    }, function () {
      this.context.formsy.validate(this);
      //this.props._validate(this);
    }.bind(this));
  },
  resetValue: function resetValue() {
    this.setState({
      _value: this.state._pristineValue,
      _isPristine: true
    }, function () {
      this.context.formsy.validate(this);
      //this.props._validate(this);
    });
  },
  getValue: function getValue() {
    return this.state._value;
  },
  hasValue: function hasValue() {
    return this.state._value !== '';
  },
  getErrorMessage: function getErrorMessage() {
    var messages = this.getErrorMessages();
    return messages.length ? messages[0] : null;
  },
  getErrorMessages: function getErrorMessages() {
    return !this.isValid() || this.showRequired() ? this.state._externalError || this.state._validationError || [] : [];
  },
  isFormDisabled: function isFormDisabled() {
    return this.context.formsy.isFormDisabled();
    //return this.props._isFormDisabled();
  },
  isValid: function isValid() {
    return this.state._isValid;
  },
  isPristine: function isPristine() {
    return this.state._isPristine;
  },
  isFormSubmitted: function isFormSubmitted() {
    return this.state._formSubmitted;
  },
  isRequired: function isRequired() {
    return !!this.props.required;
  },
  showRequired: function showRequired() {
    return this.state._isRequired;
  },
  showError: function showError() {
    return !this.showRequired() && !this.isValid();
  },
  isValidValue: function isValidValue(value) {
    return this.context.formsy.isValidValue.call(null, this, value);
    //return this.props._isValidValue.call(null, this, value);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var QuerySubscription = function () {
  function QuerySubscription(environment, operation, cacheConfig, dataFrom) {
    var _this = this;

    (0, _classCallCheck3.default)(this, QuerySubscription);

    this.onChange = function (snapshot) {
      _this.updateReadyState({
        error: null,
        props: snapshot.data,
        retry: _this.retry
      });
    };

    this.retry = function () {
      _this.retrying = true;
      _this.retryingAfterError = !!_this.readyState.error;

      _this.dispose();
      _this.execute(function () {});
    };

    this.environment = environment;
    this.operation = operation;
    this.cacheConfig = cacheConfig;
    this.dataFrom = dataFrom;

    this.fetchPromise = null;
    this.selectionReference = null;
    this.pendingRequest = null;
    this.rootSubscription = null;

    this.retrying = false;
    this.retryingAfterError = false;

    this.readyState = {
      error: null,
      props: null,
      retry: null
    };

    this.listeners = [];

    this.relayContext = {
      environment: this.environment,
      variables: this.operation.variables
    };
  }

  QuerySubscription.prototype.fetch = function fetch() {
    var _this2 = this;

    if (!this.fetchPromise) {
      this.fetchPromise = new _promise2.default(function (resolve) {
        _this2.execute(resolve);
      });
    }

    return this.fetchPromise;
  };

  QuerySubscription.prototype.execute = function execute(resolve) {
    var _this3 = this;

    var snapshot = void 0;

    this.selectionReference = this.retain();

    var onSnapshot = function onSnapshot() {
      if (snapshot) {
        return;
      }

      snapshot = _this3.environment.lookup(_this3.operation.fragment);

      _this3.onChange(snapshot);

      _this3.rootSubscription = _this3.environment.subscribe(snapshot, _this3.onChange);

      resolve();
    };

    var onError = function onError(error) {
      _this3.updateReadyState({
        error: error,
        props: null,
        // FIXME: Use default readyState when retrying.
        retry: _this3.retry
      });

      resolve();
    };

    var useStoreSnapshot = !this.retrying && (this.dataFrom === 'STORE_THEN_NETWORK' || this.dataFrom === 'STORE_OR_NETWORK') && this.environment.check(this.operation.root);

    if (!(this.dataFrom === 'STORE_OR_NETWORK' && useStoreSnapshot)) {
      try {
        this.pendingRequest = this.environment.execute({
          operation: this.operation,
          cacheConfig: this.cacheConfig
        }).finally(function () {
          _this3.pendingRequest = null;
        }).subscribe({
          next: onSnapshot,
          error: onError
        });
      } catch (error) {
        onError(error);
        return;
      }
    }

    // Only use the store snapshot if the network layer doesn't synchronously
    // resolve a snapshot, to match <QueryRenderer>.
    if (!snapshot && useStoreSnapshot) {
      onSnapshot();
    }

    if (!snapshot && this.retryingAfterError) {
      this.updateReadyState({
        error: null,
        props: null,
        retry: null
      });
    }
  };

  QuerySubscription.prototype.updateReadyState = function updateReadyState(readyState) {
    this.readyState = readyState;

    this.listeners.forEach(function (listener) {
      listener(readyState);
    });
  };

  QuerySubscription.prototype.subscribe = function subscribe(listener) {
    this.listeners.push(listener);
  };

  QuerySubscription.prototype.unsubscribe = function unsubscribe(listener) {
    this.listeners = this.listeners.filter(function (item) {
      return item !== listener;
    });
  };

  QuerySubscription.prototype.retain = function retain() {
    return this.environment.retain(this.operation.root);
  };

  QuerySubscription.prototype.dispose = function dispose() {
    this.fetchPromise = null;

    if (this.selectionReference) {
      this.selectionReference.dispose();
    }

    if (this.pendingRequest) {
      this.pendingRequest.unsubscribe();
    }

    if (this.rootSubscription) {
      this.rootSubscription.dispose();
    }
  };

  return QuerySubscription;
}();

exports.default = QuerySubscription;
module.exports = exports['default'];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getQueryName;
function getQueryName(route) {
  if (false) {
    var query = route.query;

    if (query && query.modern) {
      query = query.modern;
    }

    if (typeof query === 'function') {
      return query().name;
    }
  }

  return 'UNKNOWN';
}
module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = renderElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(972);

var _warning2 = _interopRequireDefault(_warning);

var _getQueryName = __webpack_require__(630);

var _getQueryName2 = _interopRequireDefault(_getQueryName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function renderElement(_ref) {
  var match = _ref.match,
      Component = _ref.Component,
      isComponentResolved = _ref.isComponentResolved,
      hasComponent = _ref.hasComponent,
      readyState = _ref.readyState,
      resolving = _ref.resolving;
  var route = match.route;
  var error = readyState.error,
      props = readyState.props;

  if (!route.render) {
    if (!isComponentResolved || !error && !props) {
      return undefined;
    }

    if (!props || !hasComponent) {
       false ? (0, _warning2.default)(hasComponent, 'Route with query `%s` has no render method or component.', (0, _getQueryName2.default)(route)) : void 0;

      return null;
    }

    return _react2.default.createElement(Component, (0, _extends3.default)({}, match, props));
  }

  return route.render((0, _extends3.default)({}, readyState, {
    match: match,
    Component: isComponentResolved ? Component : null,
    props: props && (0, _extends3.default)({}, match, props),
    resolving: resolving
  }));
}
module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277),
    root = __webpack_require__(165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(165);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// This isn't really an error.
var RedirectException = function RedirectException(location) {
  (0, _classCallCheck3.default)(this, RedirectException);

  this.location = location;
};

exports.default = RedirectException;
module.exports = exports["default"];

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createFarceRouter;

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(700);

var _createConnectedRouter = __webpack_require__(979);

var _createConnectedRouter2 = _interopRequireDefault(_createConnectedRouter);

var _createFarceStore = __webpack_require__(987);

var _createFarceStore2 = _interopRequireDefault(_createFarceStore);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createFarceRouter(_ref) {
  var store = _ref.store,
      historyProtocol = _ref.historyProtocol,
      historyMiddlewares = _ref.historyMiddlewares,
      historyOptions = _ref.historyOptions,
      routeConfig = _ref.routeConfig,
      matcherOptions = _ref.matcherOptions,
      options = (0, _objectWithoutProperties3.default)(_ref, ['store', 'historyProtocol', 'historyMiddlewares', 'historyOptions', 'routeConfig', 'matcherOptions']);

  var ConnectedRouter = (0, _createConnectedRouter2.default)(options);

  var FarceRouter = function (_React$Component) {
    (0, _inherits3.default)(FarceRouter, _React$Component);

    function FarceRouter(props, context) {
      (0, _classCallCheck3.default)(this, FarceRouter);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

      _this.store = store || (0, _createFarceStore2.default)({
        historyProtocol: historyProtocol,
        historyMiddlewares: historyMiddlewares,
        historyOptions: historyOptions,
        routeConfig: routeConfig,
        matcherOptions: matcherOptions
      });
      return _this;
    }

    FarceRouter.prototype.componentWillUnmount = function componentWillUnmount() {
      this.store.dispatch(_Actions2.default.dispose());
    };

    FarceRouter.prototype.render = function render() {
      return _react2.default.createElement(_reactRedux.Provider, { store: this.store }, _react2.default.createElement(ConnectedRouter, this.props));
    };

    return FarceRouter;
  }(_react2.default.Component);

  return FarceRouter;
}
module.exports = exports['default'];

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createWithRouter;

var _reactRedux = __webpack_require__(700);

var _PropTypes = __webpack_require__(427);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var routerContextTypes = {
  router: _PropTypes.routerShape.isRequired
};

function createWithRouter(_ref) {
  var _ref$getFound = _ref.getFound,
      getFound = _ref$getFound === undefined ? function (_ref2) {
    var found = _ref2.found;
    return found;
  } : _ref$getFound,
      _ref$matchKey = _ref.matchKey,
      matchKey = _ref$matchKey === undefined ? 'resolvedMatch' : _ref$matchKey;

  var withMatch = (0, _reactRedux.connect)(function (state) {
    return { match: getFound(state)[matchKey] };
  }, null, function (stateProps, dispatchProps, ownProps) {
    return (0, _extends3.default)({}, ownProps, stateProps);
  },
  // This needs to be pure, to avoid rerendering on changes to other matchKey
  // values in the store.
  {
    getDisplayName: function getDisplayName(name) {
      return 'withRouter(' + name + ')';
    }
  });

  return function withRouter(Component) {
    var ConnectedComponent = withMatch(Component);

    // Yes, this is pretty gross. It's the simplest way to inject router as
    // a prop without adding yet another wrapper component, though.
    ConnectedComponent.contextTypes = (0, _extends3.default)({}, ConnectedComponent.contextTypes, routerContextTypes);

    // TODO: Use connectAdvanced.
    // Overwriting the method instead of extending the class is used to avoid
    // issues with compatibility on IE <= 10.
    var baseAddExtraProps = ConnectedComponent.prototype.addExtraProps;

    function addExtraProps(props) {
      return (0, _extends3.default)({}, baseAddExtraProps.call(this, props), {

        // It's safe to read from the context because the router context
        // methods should never change. With the default implementation, they
        // in fact can't change.
        router: this.context.router
      });
    }

    ConnectedComponent.prototype.addExtraProps = addExtraProps;

    return ConnectedComponent;
  };
}
module.exports = exports['default'];

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

var _asyncGenerator2 = __webpack_require__(546);

var _asyncGenerator3 = _interopRequireDefault(_asyncGenerator2);

var _isPromise = __webpack_require__(435);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _createElements = __webpack_require__(980);

var _createElements2 = _interopRequireDefault(_createElements);

var _ResolverUtils = __webpack_require__(428);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getRouteGetData(route) {
  return route.getData;
}

function getRouteData(route) {
  return route.data;
}

exports.default = {
  resolveElements: function resolveElements(match) {
    var _this = this;

    return _asyncGenerator3.default.wrap( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var routeMatches, Components, data, earlyComponents, earlyData, fetchedComponents, fetchedData, pendingElements;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              routeMatches = (0, _ResolverUtils.getRouteMatches)(match);
              Components = (0, _ResolverUtils.getComponents)(routeMatches);
              data = _this.getData(match, routeMatches);

              if (!Components.some(_isPromise2.default)) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return _asyncGenerator3.default.await(_promise2.default.all(Components.map(_ResolverUtils.checkResolved)));

            case 6:
              _context.t0 = _context.sent;
              _context.next = 10;
              break;

            case 9:
              _context.t0 = Components;

            case 10:
              earlyComponents = _context.t0;

              if (!data.some(_isPromise2.default)) {
                _context.next = 17;
                break;
              }

              _context.next = 14;
              return _asyncGenerator3.default.await(_promise2.default.all(data.map(_ResolverUtils.checkResolved)));

            case 14:
              _context.t1 = _context.sent;
              _context.next = 18;
              break;

            case 17:
              _context.t1 = data;

            case 18:
              earlyData = _context.t1;
              fetchedComponents = void 0;
              fetchedData = void 0;

              if (!(!earlyComponents.every(_ResolverUtils.isResolved) || !earlyData.every(_ResolverUtils.isResolved))) {
                _context.next = 33;
                break;
              }

              pendingElements = (0, _createElements2.default)(routeMatches, earlyComponents, earlyData);
              _context.next = 25;
              return pendingElements.every(function (element) {
                return element !== undefined;
              }) ? pendingElements : undefined;

            case 25:
              _context.next = 27;
              return _asyncGenerator3.default.await(_promise2.default.all(Components));

            case 27:
              fetchedComponents = _context.sent;
              _context.next = 30;
              return _asyncGenerator3.default.await(_promise2.default.all(data));

            case 30:
              fetchedData = _context.sent;
              _context.next = 35;
              break;

            case 33:
              fetchedComponents = earlyComponents;
              fetchedData = earlyData;

            case 35:
              _context.next = 37;
              return (0, _createElements2.default)(routeMatches, fetchedComponents, fetchedData);

            case 37:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * Generate route data according to their getters, respecting the order of
   * promises per the `defer` flag on routes.
   */
  getData: function getData(match, routeMatches) {
    return (0, _ResolverUtils.accumulateRouteValues)(routeMatches, match.routeIndices, function (_ref, routeMatch) {
      var ancestorRouteData = _ref.ancestorRouteData,
          prevParentPromise = _ref.prevParentPromise;

      // For a deferred route, the parent promise is the previous promise.
      // Otherwise, it's the previous parent promise.
      var parentPromise = routeMatch.route.defer ? _promise2.default.all(ancestorRouteData) : prevParentPromise;

      // If there is a parent promise, execute after it resolves.
      var routeData = parentPromise ? parentPromise.then(function () {
        return (0, _ResolverUtils.getRouteValue)(routeMatch, getRouteGetData, getRouteData);
      }) : (0, _ResolverUtils.getRouteValue)(routeMatch, getRouteGetData, getRouteData);

      return {
        routeData: routeData,
        ancestorRouteData: [].concat(ancestorRouteData, [routeData]),
        prevParentPromise: parentPromise
      };
    }, {
      routeData: null,
      ancestorRouteData: [],
      prevParentPromise: null
    }).map(function (_ref2) {
      var routeData = _ref2.routeData;
      return routeData;
    });
  }
};
module.exports = exports['default'];

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278),
    root = __webpack_require__(167);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(167);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(2023);

module.exports = Function.prototype.bind || implementation;

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export Immer */
/* unused harmony export applyPatches */
/* unused harmony export createDraft */
/* unused harmony export finishDraft */
/* unused harmony export immerable */
/* unused harmony export isDraft */
/* unused harmony export isDraftable */
/* unused harmony export nothing */
/* unused harmony export original */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return produce; });
/* unused harmony export setAutoFreeze */
/* unused harmony export setUseProxies */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var obj;
var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : (obj = {}, obj["immer-nothing"] = true, obj);
var DRAFTABLE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-draftable") : "__$immer_draftable";
var DRAFT_STATE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-state") : "__$immer_state";
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value || (typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") {
    return false;
  }
  if (Array.isArray(value)) {
    return true;
  }
  var proto = Object.getPrototypeOf(value);
  if (!proto || proto === Object.prototype) {
    return true;
  }
  return !!value[DRAFTABLE] || !!value.constructor[DRAFTABLE];
}
function original(value) {
  if (value && value[DRAFT_STATE]) {
    return value[DRAFT_STATE].base;
  } // otherwise return undefined
}
var assign = Object.assign || function assign(target, value) {
  for (var key in value) {
    if (has(value, key)) {
      target[key] = value[key];
    }
  }

  return target;
};
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : typeof Object.getOwnPropertySymbols !== "undefined" ? function (obj) {
  return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : Object.getOwnPropertyNames;
function shallowCopy(base, invokeGetters) {
  if (invokeGetters === void 0) invokeGetters = false;

  if (Array.isArray(base)) {
    return base.slice();
  }
  var clone = Object.create(Object.getPrototypeOf(base));
  ownKeys(base).forEach(function (key) {
    if (key === DRAFT_STATE) {
      return; // Never copy over draft state.
    }

    var desc = Object.getOwnPropertyDescriptor(base, key);
    var value = desc.value;

    if (desc.get) {
      if (!invokeGetters) {
        throw new Error("Immer drafts cannot have computed properties");
      }

      value = desc.get.call(base);
    }

    if (desc.enumerable) {
      clone[key] = value;
    } else {
      Object.defineProperty(clone, key, {
        value: value,
        writable: true,
        configurable: true
      });
    }
  });
  return clone;
}
function each(value, cb) {
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      cb(i, value[i], value);
    }
  } else {
    ownKeys(value).forEach(function (key) {
      return cb(key, value[key], value);
    });
  }
}
function isEnumerable(base, prop) {
  var desc = Object.getOwnPropertyDescriptor(base, prop);
  return !!desc && desc.enumerable;
}
function has(thing, prop) {
  return Object.prototype.hasOwnProperty.call(thing, prop);
}
function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

/** Each scope represents a `produce` call. */

var ImmerScope = function ImmerScope(parent) {
  this.drafts = [];
  this.parent = parent; // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.

  this.canAutoFreeze = true; // To avoid prototype lookups:

  this.patches = null;
};

ImmerScope.prototype.usePatches = function usePatches(patchListener) {
  if (patchListener) {
    this.patches = [];
    this.inversePatches = [];
    this.patchListener = patchListener;
  }
};

ImmerScope.prototype.revoke = function revoke$1() {
  this.leave();
  this.drafts.forEach(revoke);
  this.drafts = null; // Make draft-related methods throw.
};

ImmerScope.prototype.leave = function leave() {
  if (this === ImmerScope.current) {
    ImmerScope.current = this.parent;
  }
};
ImmerScope.current = null;

ImmerScope.enter = function () {
  return this.current = new ImmerScope(this.current);
};

function revoke(draft) {
  draft[DRAFT_STATE].revoke();
}

// but share them all instead

var descriptors = {};
function willFinalize(scope, result, isReplaced) {
  scope.drafts.forEach(function (draft) {
    draft[DRAFT_STATE].finalizing = true;
  });

  if (!isReplaced) {
    if (scope.patches) {
      markChangesRecursively(scope.drafts[0]);
    } // This is faster when we don't care about which attributes changed.


    markChangesSweep(scope.drafts);
  } // When a child draft is returned, look for changes.
  else if (isDraft(result) && result[DRAFT_STATE].scope === scope) {
      markChangesSweep(scope.drafts);
    }
}
function createProxy(base, parent) {
  var isArray = Array.isArray(base);
  var draft = clonePotentialDraft(base);
  each(draft, function (prop) {
    proxyProperty(draft, prop, isArray || isEnumerable(base, prop));
  }); // See "proxy.js" for property documentation.

  var scope = parent ? parent.scope : ImmerScope.current;
  var state = {
    scope: scope,
    modified: false,
    finalizing: false,
    // es5 only
    finalized: false,
    assigned: {},
    parent: parent,
    base: base,
    draft: draft,
    copy: null,
    revoke: revoke$1,
    revoked: false // es5 only

  };
  createHiddenProperty(draft, DRAFT_STATE, state);
  scope.drafts.push(draft);
  return draft;
}

function revoke$1() {
  this.revoked = true;
}

function source(state) {
  return state.copy || state.base;
} // Access a property without creating an Immer draft.


function peek(draft, prop) {
  var state = draft[DRAFT_STATE];

  if (state && !state.finalizing) {
    state.finalizing = true;
    var value = draft[prop];
    state.finalizing = false;
    return value;
  }

  return draft[prop];
}

function get(state, prop) {
  assertUnrevoked(state);
  var value = peek(source(state), prop);
  if (state.finalizing) {
    return value;
  } // Create a draft if the value is unmodified.

  if (value === peek(state.base, prop) && isDraftable(value)) {
    prepareCopy(state);
    return state.copy[prop] = createProxy(value, state);
  }

  return value;
}

function set(state, prop, value) {
  assertUnrevoked(state);
  state.assigned[prop] = true;

  if (!state.modified) {
    if (is(value, peek(source(state), prop))) {
      return;
    }
    markChanged(state);
    prepareCopy(state);
  }

  state.copy[prop] = value;
}

function markChanged(state) {
  if (!state.modified) {
    state.modified = true;
    if (state.parent) {
      markChanged(state.parent);
    }
  }
}

function prepareCopy(state) {
  if (!state.copy) {
    state.copy = clonePotentialDraft(state.base);
  }
}

function clonePotentialDraft(base) {
  var state = base && base[DRAFT_STATE];

  if (state) {
    state.finalizing = true;
    var draft = shallowCopy(state.draft, true);
    state.finalizing = false;
    return draft;
  }

  return shallowCopy(base);
}

function proxyProperty(draft, prop, enumerable) {
  var desc = descriptors[prop];

  if (desc) {
    desc.enumerable = enumerable;
  } else {
    descriptors[prop] = desc = {
      configurable: true,
      enumerable: enumerable,

      get: function get$1() {
        return get(this[DRAFT_STATE], prop);
      },

      set: function set$1(value) {
        set(this[DRAFT_STATE], prop, value);
      }

    };
  }

  Object.defineProperty(draft, prop, desc);
}

function assertUnrevoked(state) {
  if (state.revoked === true) {
    throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(source(state)));
  }
} // This looks expensive, but only proxies are visited, and only objects without known changes are scanned.


function markChangesSweep(drafts) {
  // The natural order of drafts in the `scope` array is based on when they
  // were accessed. By processing drafts in reverse natural order, we have a
  // better chance of processing leaf nodes first. When a leaf node is known to
  // have changed, we can avoid any traversal of its ancestor nodes.
  for (var i = drafts.length - 1; i >= 0; i--) {
    var state = drafts[i][DRAFT_STATE];

    if (!state.modified) {
      if (Array.isArray(state.base)) {
        if (hasArrayChanges(state)) {
          markChanged(state);
        }
      } else if (hasObjectChanges(state)) {
        markChanged(state);
      }
    }
  }
}

function markChangesRecursively(object) {
  if (!object || (typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") {
    return;
  }
  var state = object[DRAFT_STATE];
  if (!state) {
    return;
  }
  var base = state.base;
  var draft = state.draft;
  var assigned = state.assigned;

  if (!Array.isArray(object)) {
    // Look for added keys.
    Object.keys(draft).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (base[key] === undefined && !has(base, key)) {
        assigned[key] = true;
        markChanged(state);
      } else if (!assigned[key]) {
        // Only untouched properties trigger recursion.
        markChangesRecursively(draft[key]);
      }
    }); // Look for removed keys.

    Object.keys(base).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (draft[key] === undefined && !has(draft, key)) {
        assigned[key] = false;
        markChanged(state);
      }
    });
  } else if (hasArrayChanges(state)) {
    markChanged(state);
    assigned.length = true;

    if (draft.length < base.length) {
      for (var i = draft.length; i < base.length; i++) {
        assigned[i] = false;
      }
    } else {
      for (var i$1 = base.length; i$1 < draft.length; i$1++) {
        assigned[i$1] = true;
      }
    }

    for (var i$2 = 0; i$2 < draft.length; i$2++) {
      // Only untouched indices trigger recursion.
      if (assigned[i$2] === undefined) {
        markChangesRecursively(draft[i$2]);
      }
    }
  }
}

function hasObjectChanges(state) {
  var base = state.base;
  var draft = state.draft; // Search for added keys and changed keys. Start at the back, because
  // non-numeric keys are ordered by time of definition on the object.

  var keys = Object.keys(draft);

  for (var i = keys.length - 1; i >= 0; i--) {
    var key = keys[i];
    var baseValue = base[key]; // The `undefined` check is a fast path for pre-existing keys.

    if (baseValue === undefined && !has(base, key)) {
      return true;
    } // Once a base key is deleted, future changes go undetected, because its
    // descriptor is erased. This branch detects any missed changes.
    else {
        var value = draft[key];
        var state$1 = value && value[DRAFT_STATE];

        if (state$1 ? state$1.base !== baseValue : !is(value, baseValue)) {
          return true;
        }
      }
  } // At this point, no keys were added or changed.
  // Compare key count to determine if keys were deleted.


  return keys.length !== Object.keys(base).length;
}

function hasArrayChanges(state) {
  var draft = state.draft;
  if (draft.length !== state.base.length) {
    return true;
  } // See #116
  // If we first shorten the length, our array interceptors will be removed.
  // If after that new items are added, result in the same original length,
  // those last items will have no intercepting property.
  // So if there is no own descriptor on the last position, we know that items were removed and added
  // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
  // the last one

  var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1); // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)

  if (descriptor && !descriptor.get) {
    return true;
  } // For all other cases, we don't have to compare, as they would have been picked up by the index setters

  return false;
}

function createHiddenProperty(target, prop, value) {
  Object.defineProperty(target, prop, {
    value: value,
    enumerable: false,
    writable: true
  });
}

var legacyProxy = /*#__PURE__*/Object.freeze({
  willFinalize: willFinalize,
  createProxy: createProxy
});

function willFinalize$1() {}
function createProxy$1(base, parent) {
  var scope = parent ? parent.scope : ImmerScope.current;
  var state = {
    // Track which produce call this is associated with.
    scope: scope,
    // True for both shallow and deep changes.
    modified: false,
    // Used during finalization.
    finalized: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned: {},
    // The parent draft state.
    parent: parent,
    // The base state.
    base: base,
    // The base proxy.
    draft: null,
    // Any property proxies.
    drafts: {},
    // The base copy with any updated values.
    copy: null,
    // Called by the `produce` function.
    revoke: null
  };
  var ref = Array.isArray(base) ? // [state] is used for arrays, to make sure the proxy is array-ish and not violate invariants,
  // although state itself is an object
  Proxy.revocable([state], arrayTraps) : Proxy.revocable(state, objectTraps);
  var revoke = ref.revoke;
  var proxy = ref.proxy;
  state.draft = proxy;
  state.revoke = revoke;
  scope.drafts.push(proxy);
  return proxy;
}
var objectTraps = {
  get: get$1,

  has: function has(target, prop) {
    return prop in source$1(target);
  },

  ownKeys: function ownKeys(target) {
    return Reflect.ownKeys(source$1(target));
  },

  set: set$1,
  deleteProperty: deleteProperty,
  getOwnPropertyDescriptor: getOwnPropertyDescriptor,

  defineProperty: function defineProperty() {
    throw new Error("Object.defineProperty() cannot be used on an Immer draft"); // prettier-ignore
  },

  getPrototypeOf: function getPrototypeOf(target) {
    return Object.getPrototypeOf(target.base);
  },

  setPrototypeOf: function setPrototypeOf() {
    throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft"); // prettier-ignore
  }

};
var arrayTraps = {};
each(objectTraps, function (key, fn) {
  arrayTraps[key] = function () {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});

arrayTraps.deleteProperty = function (state, prop) {
  if (isNaN(parseInt(prop))) {
    throw new Error("Immer only supports deleting array indices"); // prettier-ignore
  }

  return objectTraps.deleteProperty.call(this, state[0], prop);
};

arrayTraps.set = function (state, prop, value) {
  if (prop !== "length" && isNaN(parseInt(prop))) {
    throw new Error("Immer only supports setting array indices and the 'length' property"); // prettier-ignore
  }

  return objectTraps.set.call(this, state[0], prop, value);
}; // returns the object we should be reading the current value from, which is base, until some change has been made


function source$1(state) {
  return state.copy || state.base;
} // Access a property without creating an Immer draft.


function peek$1(draft, prop) {
  var state = draft[DRAFT_STATE];
  var desc = Reflect.getOwnPropertyDescriptor(state ? source$1(state) : draft, prop);
  return desc && desc.value;
}

function get$1(state, prop) {
  if (prop === DRAFT_STATE) {
    return state;
  }
  var drafts = state.drafts; // Check for existing draft in unmodified state.

  if (!state.modified && has(drafts, prop)) {
    return drafts[prop];
  }

  var value = source$1(state)[prop];

  if (state.finalized || !isDraftable(value)) {
    return value;
  } // Check for existing draft in modified state.


  if (state.modified) {
    // Assigned values are never drafted. This catches any drafts we created, too.
    if (value !== peek$1(state.base, prop)) {
      return value;
    } // Store drafts on the copy (when one exists).

    drafts = state.copy;
  }

  return drafts[prop] = createProxy$1(value, state);
}

function set$1(state, prop, value) {
  if (!state.modified) {
    var baseValue = peek$1(state.base, prop); // Optimize based on value's truthiness. Truthy values are guaranteed to
    // never be undefined, so we can avoid the `in` operator. Lastly, truthy
    // values may be drafts, but falsy values are never drafts.

    var isUnchanged = value ? is(baseValue, value) || value === state.drafts[prop] : is(baseValue, value) && prop in state.base;
    if (isUnchanged) {
      return true;
    }
    markChanged$1(state);
  }

  state.assigned[prop] = true;
  state.copy[prop] = value;
  return true;
}

function deleteProperty(state, prop) {
  // The `undefined` check is a fast path for pre-existing keys.
  if (peek$1(state.base, prop) !== undefined || prop in state.base) {
    state.assigned[prop] = false;
    markChanged$1(state);
  }

  if (state.copy) {
    delete state.copy[prop];
  }
  return true;
} // Note: We never coerce `desc.value` into an Immer draft, because we can't make
// the same guarantee in ES5 mode.


function getOwnPropertyDescriptor(state, prop) {
  var owner = source$1(state);
  var desc = Reflect.getOwnPropertyDescriptor(owner, prop);

  if (desc) {
    desc.writable = true;
    desc.configurable = !Array.isArray(owner) || prop !== "length";
  }

  return desc;
}

function markChanged$1(state) {
  if (!state.modified) {
    state.modified = true;
    state.copy = assign(shallowCopy(state.base), state.drafts);
    state.drafts = null;
    if (state.parent) {
      markChanged$1(state.parent);
    }
  }
}

var modernProxy = /*#__PURE__*/Object.freeze({
  willFinalize: willFinalize$1,
  createProxy: createProxy$1
});

function generatePatches(state, basePath, patches, inversePatches) {
  Array.isArray(state.base) ? generateArrayPatches(state, basePath, patches, inversePatches) : generateObjectPatches(state, basePath, patches, inversePatches);
}

function generateArrayPatches(state, basePath, patches, inversePatches) {
  var assign, assign$1;

  var base = state.base;
  var copy = state.copy;
  var assigned = state.assigned; // Reduce complexity by ensuring `base` is never longer.

  if (copy.length < base.length) {
    assign = [copy, base], base = assign[0], copy = assign[1];
    assign$1 = [inversePatches, patches], patches = assign$1[0], inversePatches = assign$1[1];
  }

  var delta = copy.length - base.length; // Find the first replaced index.

  var start = 0;

  while (base[start] === copy[start] && start < base.length) {
    ++start;
  } // Find the last replaced index. Search from the end to optimize splice patches.


  var end = base.length;

  while (end > start && base[end - 1] === copy[end + delta - 1]) {
    --end;
  } // Process replaced indices.


  for (var i = start; i < end; ++i) {
    if (assigned[i] && copy[i] !== base[i]) {
      var path = basePath.concat([i]);
      patches.push({
        op: "replace",
        path: path,
        value: copy[i]
      });
      inversePatches.push({
        op: "replace",
        path: path,
        value: base[i]
      });
    }
  }

  var useRemove = end != base.length;
  var replaceCount = patches.length; // Process added indices.

  for (var i$1 = end + delta - 1; i$1 >= end; --i$1) {
    var path$1 = basePath.concat([i$1]);
    patches[replaceCount + i$1 - end] = {
      op: "add",
      path: path$1,
      value: copy[i$1]
    };

    if (useRemove) {
      inversePatches.push({
        op: "remove",
        path: path$1
      });
    }
  } // One "replace" patch reverses all non-splicing "add" patches.


  if (!useRemove) {
    inversePatches.push({
      op: "replace",
      path: basePath.concat(["length"]),
      value: base.length
    });
  }
}

function generateObjectPatches(state, basePath, patches, inversePatches) {
  var base = state.base;
  var copy = state.copy;
  each(state.assigned, function (key, assignedValue) {
    var origValue = base[key];
    var value = copy[key];
    var op = !assignedValue ? "remove" : key in base ? "replace" : "add";
    if (origValue === value && op === "replace") {
      return;
    }
    var path = basePath.concat(key);
    patches.push(op === "remove" ? {
      op: op,
      path: path
    } : {
      op: op,
      path: path,
      value: value
    });
    inversePatches.push(op === "add" ? {
      op: "remove",
      path: path
    } : op === "remove" ? {
      op: "add",
      path: path,
      value: origValue
    } : {
      op: "replace",
      path: path,
      value: origValue
    });
  });
}

function applyPatches(draft, patches) {
  for (var i = 0; i < patches.length; i++) {
    var patch = patches[i];
    var path = patch.path;

    if (path.length === 0 && patch.op === "replace") {
      draft = patch.value;
    } else {
      var base = draft;

      for (var i$1 = 0; i$1 < path.length - 1; i$1++) {
        base = base[path[i$1]];
        if (!base || (typeof base === "undefined" ? "undefined" : _typeof(base)) !== "object") {
          throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/"));
        } // prettier-ignore
      }

      var key = path[path.length - 1];

      switch (patch.op) {
        case "replace":
          base[key] = patch.value;
          break;

        case "add":
          if (Array.isArray(base)) {
            // TODO: support "foo/-" paths for appending to an array
            base.splice(key, 0, patch.value);
          } else {
            base[key] = patch.value;
          }

          break;

        case "remove":
          if (Array.isArray(base)) {
            base.splice(key, 1);
          } else {
            delete base[key];
          }

          break;

        default:
          throw new Error("Unsupported patch operation: " + patch.op);
      }
    }
  }

  return draft;
}

function verifyMinified() {}

var configDefaults = {
  useProxies: typeof Proxy !== "undefined" && typeof Reflect !== "undefined",
  autoFreeze: typeof process !== "undefined" ? "production" !== "production" : verifyMinified.name === "verifyMinified",
  onAssign: null,
  onDelete: null,
  onCopy: null
};
var Immer = function Immer(config) {
  assign(this, configDefaults, config);
  this.setUseProxies(this.useProxies);
  this.produce = this.produce.bind(this);
};

Immer.prototype.produce = function produce(base, recipe, patchListener) {
  var this$1 = this;

  // curried invocation
  if (typeof base === "function" && typeof recipe !== "function") {
    var defaultBase = recipe;
    recipe = base;
    var self = this;
    return function curriedProduce(base) {
      var this$1 = this;
      if (base === void 0) base = defaultBase;
      var args = [],
          len = arguments.length - 1;
      while (len-- > 0) {
        args[len] = arguments[len + 1];
      }return self.produce(base, function (draft) {
        return recipe.call.apply(recipe, [this$1, draft].concat(args));
      }); // prettier-ignore
    };
  } // prettier-ignore


  {
    if (typeof recipe !== "function") {
      throw new Error("The first or second argument to `produce` must be a function");
    }

    if (patchListener !== undefined && typeof patchListener !== "function") {
      throw new Error("The third argument to `produce` must be a function or undefined");
    }
  }
  var result; // Only plain objects, arrays, and "immerable classes" are drafted.

  if (isDraftable(base)) {
    var scope = ImmerScope.enter();
    var proxy = this.createProxy(base);
    var hasError = true;

    try {
      result = recipe(proxy);
      hasError = false;
    } finally {
      // finally instead of catch + rethrow better preserves original stack
      if (hasError) {
        scope.revoke();
      } else {
        scope.leave();
      }
    }

    if (result instanceof Promise) {
      return result.then(function (result) {
        scope.usePatches(patchListener);
        return this$1.processResult(result, scope);
      }, function (error) {
        scope.revoke();
        throw error;
      });
    }

    scope.usePatches(patchListener);
    return this.processResult(result, scope);
  } else {
    result = recipe(base);
    if (result === undefined) {
      return base;
    }
    return result !== NOTHING ? result : undefined;
  }
};

Immer.prototype.createDraft = function createDraft(base) {
  if (!isDraftable(base)) {
    throw new Error("First argument to `createDraft` must be a plain object, an array, or an immerable object"); // prettier-ignore
  }

  var scope = ImmerScope.enter();
  var proxy = this.createProxy(base);
  proxy[DRAFT_STATE].isManual = true;
  scope.leave();
  return proxy;
};

Immer.prototype.finishDraft = function finishDraft(draft, patchListener) {
  var state = draft && draft[DRAFT_STATE];

  if (!state || !state.isManual) {
    throw new Error("First argument to `finishDraft` must be a draft returned by `createDraft`"); // prettier-ignore
  }

  if (state.finalized) {
    throw new Error("The given draft is already finalized"); // prettier-ignore
  }

  var scope = state.scope;
  scope.usePatches(patchListener);
  return this.processResult(undefined, scope);
};

Immer.prototype.setAutoFreeze = function setAutoFreeze(value) {
  this.autoFreeze = value;
};

Immer.prototype.setUseProxies = function setUseProxies(value) {
  this.useProxies = value;
  assign(this, value ? modernProxy : legacyProxy);
};

Immer.prototype.applyPatches = function applyPatches$1(base, patches) {
  // Mutate the base state when a draft is passed.
  if (isDraft(base)) {
    return applyPatches(base, patches);
  } // Otherwise, produce a copy of the base state.


  return this.produce(base, function (draft) {
    return applyPatches(draft, patches);
  });
};
/** @internal */

Immer.prototype.processResult = function processResult(result, scope) {
  var baseDraft = scope.drafts[0];
  var isReplaced = result !== undefined && result !== baseDraft;
  this.willFinalize(scope, result, isReplaced);

  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified) {
      scope.revoke();
      throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore
    }

    if (isDraftable(result)) {
      // Finalize the result in case it contains (or is) a subset of the draft.
      result = this.finalize(result, null, scope);
    }

    if (scope.patches) {
      scope.patches.push({
        op: "replace",
        path: [],
        value: result
      });
      scope.inversePatches.push({
        op: "replace",
        path: [],
        value: baseDraft[DRAFT_STATE].base
      });
    }
  } else {
    // Finalize the base draft.
    result = this.finalize(baseDraft, [], scope);
  }

  scope.revoke();

  if (scope.patches) {
    scope.patchListener(scope.patches, scope.inversePatches);
  }

  return result !== NOTHING ? result : undefined;
};
/**
 * @internal
 * Finalize a draft, returning either the unmodified base state or a modified
 * copy of the base state.
 */

Immer.prototype.finalize = function finalize(draft, path, scope) {
  var this$1 = this;

  var state = draft[DRAFT_STATE];

  if (!state) {
    if (Object.isFrozen(draft)) {
      return draft;
    }
    return this.finalizeTree(draft, null, scope);
  } // Never finalize drafts owned by another scope.


  if (state.scope !== scope) {
    return draft;
  }

  if (!state.modified) {
    return state.base;
  }

  if (!state.finalized) {
    state.finalized = true;
    this.finalizeTree(state.draft, path, scope);

    if (this.onDelete) {
      // The `assigned` object is unreliable with ES5 drafts.
      if (this.useProxies) {
        var assigned = state.assigned;

        for (var prop in assigned) {
          if (!assigned[prop]) {
            this.onDelete(state, prop);
          }
        }
      } else {
        var base = state.base;
        var copy = state.copy;
        each(base, function (prop) {
          if (!has(copy, prop)) {
            this$1.onDelete(state, prop);
          }
        });
      }
    }

    if (this.onCopy) {
      this.onCopy(state);
    } // At this point, all descendants of `state.copy` have been finalized,
    // so we can be sure that `scope.canAutoFreeze` is accurate.


    if (this.autoFreeze && scope.canAutoFreeze) {
      Object.freeze(state.copy);
    }

    if (path && scope.patches) {
      generatePatches(state, path, scope.patches, scope.inversePatches);
    }
  }

  return state.copy;
};
/**
 * @internal
 * Finalize all drafts in the given state tree.
 */

Immer.prototype.finalizeTree = function finalizeTree(root, rootPath, scope) {
  var this$1 = this;

  var state = root[DRAFT_STATE];

  if (state) {
    if (!this.useProxies) {
      // Create the final copy, with added keys and without deleted keys.
      state.copy = shallowCopy(state.draft, true);
    }

    root = state.copy;
  }

  var needPatches = !!rootPath && !!scope.patches;

  var finalizeProperty = function finalizeProperty(prop, value, parent) {
    if (value === parent) {
      throw Error("Immer forbids circular references");
    } // In the `finalizeTree` method, only the `root` object may be a draft.


    var isDraftProp = !!state && parent === root;

    if (isDraft(value)) {
      var path = isDraftProp && needPatches && !state.assigned[prop] ? rootPath.concat(prop) : null; // Drafts owned by `scope` are finalized here.

      value = this$1.finalize(value, path, scope); // Drafts from another scope must prevent auto-freezing.

      if (isDraft(value)) {
        scope.canAutoFreeze = false;
      } // Preserve non-enumerable properties.


      if (Array.isArray(parent) || isEnumerable(parent, prop)) {
        parent[prop] = value;
      } else {
        Object.defineProperty(parent, prop, {
          value: value
        });
      } // Unchanged drafts are never passed to the `onAssign` hook.


      if (isDraftProp && value === state.base[prop]) {
        return;
      }
    } // Unchanged draft properties are ignored.
    else if (isDraftProp && is(value, state.base[prop])) {
        return;
      } // Search new objects for unfinalized drafts. Frozen objects should never contain drafts.
      else if (isDraftable(value) && !Object.isFrozen(value)) {
          each(value, finalizeProperty);
        }

    if (isDraftProp && this$1.onAssign) {
      this$1.onAssign(state, prop, value);
    }
  };

  each(root, finalizeProperty);
  return root;
};

var immer = new Immer();
/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */

var produce = immer.produce;
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */

var setAutoFreeze = immer.setAutoFreeze.bind(immer);
/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */

var setUseProxies = immer.setUseProxies.bind(immer);
/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */

var applyPatches$1 = immer.applyPatches.bind(immer);
/**
 * Create an Immer draft from the given base state, which may be a draft itself.
 * The draft can be modified until you finalize it with the `finishDraft` function.
 */

var createDraft = immer.createDraft.bind(immer);
/**
 * Finalize an Immer draft from a `createDraft` call, returning the base state
 * (if no changes were made) or a modified copy. The draft must *not* be
 * mutated afterwards.
 *
 * Pass a function as the 2nd argument to generate Immer patches based on the
 * changes that were made.
 */

var finishDraft = immer.finishDraft.bind(immer);

/* unused harmony default export */ var _unused_webpack_default_export = (produce);

//# sourceMappingURL=immer.module.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(339)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(331),
    baseLodash = __webpack_require__(654);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237),
    root = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2134),
    mapCacheDelete = __webpack_require__(2135),
    mapCacheGet = __webpack_require__(2136),
    mapCacheHas = __webpack_require__(2137),
    mapCacheSet = __webpack_require__(2138);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(646),
    setCacheAdd = __webpack_require__(2147),
    setCacheHas = __webpack_require__(2148);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 648 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2060);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(442),
    eq = __webpack_require__(282);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1015),
    keys = __webpack_require__(283);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2063),
    isObjectLike = __webpack_require__(135);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;

/***/ }),
/* 655 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1005);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

/***/ }),
/* 657 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2054),
    stubArray = __webpack_require__(1055);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = __webpack_require__(80),
    isSymbol = __webpack_require__(337);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2081),
    shortOut = __webpack_require__(1047);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(2102),
    findIndex = __webpack_require__(1049);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(653);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}

module.exports = isNumber;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1014),
    baseOrderBy = __webpack_require__(2075),
    baseRest = __webpack_require__(332),
    isIterateeCall = __webpack_require__(334);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1056);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

module.exports = toInteger;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function () {
  var getNanoSeconds, hrtime, loadTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(339)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(111);

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Promise = __webpack_require__(111);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function (value) {
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(111);

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(111);
__webpack_require__(670);
__webpack_require__(672);
__webpack_require__(671);
__webpack_require__(674);
__webpack_require__(675);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = __webpack_require__(111);
var asap = __webpack_require__(542);

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (typeof argumentCount === 'number' && argumentCount !== Infinity) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = 'function (err, res) {' + 'if (err) { rj(err); } else { rs(res); }' + '}';
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = ['return function (' + args.join(',') + ') {', 'var self = this;', 'return new Promise(function (rs, rj) {', 'var res = fn.call(', ['self'].concat(args).concat([callbackFn]).join(','), ');', 'if (res &&', '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ') {rs(res);}', '});', '};'].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = ['return function (' + args.join(',') + ') {', 'var self = this;', 'var args;', 'var argLength = arguments.length;', 'if (arguments.length > ' + fnLength + ') {', 'args = new Array(arguments.length + 1);', 'for (var i = 0; i < arguments.length; i++) {', 'args[i] = arguments[i];', '}', '}', 'return new Promise(function (rs, rj) {', 'var cb = ' + callbackFn + ';', 'var res;', 'switch (argLength) {', args.concat(['extra']).map(function (_, index) {
    return 'case ' + index + ':' + 'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' + 'break;';
  }).join(''), 'default:', 'args[argLength] = cb;', 'res = fn.apply(self, args);', '}', 'if (res &&', '(typeof res === "object" || typeof res === "function") &&', 'typeof res.then === "function"', ') {rs(res);}', '});', '};'].join('');

  return Function(['Promise', 'fn'], body)(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback = typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        });
      }
    }
  };
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(111);

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function () {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function () {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function () {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function () {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1175);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return frameId;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(undefined, lastArgs);
    });

    return frameId;
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  var resultFn = wrapperFn;

  return resultFn;
});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2192),
    root = typeof window === 'undefined' ? global : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = now(),
          next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_drag_drop_context___ = __webpack_require__(1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__view_drag_drop_context___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_droppable___ = __webpack_require__(2242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__view_droppable___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_draggable___ = __webpack_require__(2237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__view_draggable___["a"]; });
/* unused harmony reexport resetServerContext */








/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPartiallyVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isTotallyVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_partially_visible_through_frame__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_totally_visible_through_frame__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spacing__ = __webpack_require__(342);





var origin = { x: 0, y: 0 };

var isVisible = function isVisible(_ref) {
  var target = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;

  var displacement = destination.viewport.closestScrollable ? destination.viewport.closestScrollable.scroll.diff.displacement : origin;
  var withDisplacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__spacing__["a" /* offsetByPosition */])(target, displacement);

  if (!destination.viewport.clipped) {
    return false;
  }

  var isVisibleInDroppable = isVisibleThroughFrameFn(destination.viewport.clipped)(withDisplacement);

  var isVisibleInViewport = isVisibleThroughFrameFn(viewport)(withDisplacement);

  return isVisibleInDroppable && isVisibleInViewport;
};

var isPartiallyVisible = function isPartiallyVisible(_ref2) {
  var target = _ref2.target,
      destination = _ref2.destination,
      viewport = _ref2.viewport;
  return isVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    isVisibleThroughFrameFn: __WEBPACK_IMPORTED_MODULE_0__is_partially_visible_through_frame__["a" /* default */]
  });
};

var isTotallyVisible = function isTotallyVisible(_ref3) {
  var target = _ref3.target,
      destination = _ref3.destination,
      viewport = _ref3.viewport;
  return isVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    isVisibleThroughFrameFn: __WEBPACK_IMPORTED_MODULE_1__is_totally_visible_through_frame__["a" /* default */]
  });
};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf_schd__ = __webpack_require__(677);




/* harmony default export */ __webpack_exports__["a"] = (function (callbacks) {
  var memoizedMove = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (x, y) {
    var point = { x: x, y: y };
    callbacks.onMove(point);
  });

  var move = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(function (point) {
    return memoizedMove(point.x, point.y);
  });
  var moveForward = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(callbacks.onMoveForward);
  var moveBackward = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(callbacks.onMoveBackward);
  var crossAxisMoveForward = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(callbacks.onCrossAxisMoveForward);
  var crossAxisMoveBackward = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(callbacks.onCrossAxisMoveBackward);
  var windowScrollMove = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf_schd__["a" /* default */])(callbacks.onWindowScroll);

  var cancel = function cancel() {

    move.cancel();
    moveForward.cancel();
    moveBackward.cancel();
    crossAxisMoveForward.cancel();
    crossAxisMoveBackward.cancel();
    windowScrollMove.cancel();
  };

  return {
    move: move,
    moveForward: moveForward,
    moveBackward: moveBackward,
    crossAxisMoveForward: crossAxisMoveForward,
    crossAxisMoveBackward: crossAxisMoveBackward,
    windowScrollMove: windowScrollMove,
    cancel: cancel
  };
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (ref) {
  return ref ? ref.ownerDocument.defaultView : window;
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BackgroundWrapper = function (_React$Component) {
  _inherits(BackgroundWrapper, _React$Component);

  function BackgroundWrapper() {
    _classCallCheck(this, BackgroundWrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  BackgroundWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return BackgroundWrapper;
}(_react2.default.Component);

BackgroundWrapper.propTypes = {
  children: _propTypes2.default.element,
  value: _propTypes2.default.instanceOf(Date),
  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date))
};

exports.default = BackgroundWrapper;
module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _requestAnimationFrame = __webpack_require__(621);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _DayColumn = __webpack_require__(2280);

var _DayColumn2 = _interopRequireDefault(_DayColumn);

var _TimeGutter = __webpack_require__(2286);

var _TimeGutter2 = _interopRequireDefault(_TimeGutter);

var _width = __webpack_require__(946);

var _width2 = _interopRequireDefault(_width);

var _TimeGridHeader = __webpack_require__(2285);

var _TimeGridHeader2 = _interopRequireDefault(_TimeGridHeader);

var _propTypes3 = __webpack_require__(113);

var _helpers = __webpack_require__(287);

var _accessors = __webpack_require__(239);

var _eventLevels = __webpack_require__(343);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimeGrid = function (_Component) {
  _inherits(TimeGrid, _Component);

  function TimeGrid(props) {
    _classCallCheck(this, TimeGrid);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function () {
      _requestAnimationFrame2.default.cancel(_this.rafHandle);
      _this.rafHandle = (0, _requestAnimationFrame2.default)(_this.checkOverflow);
    };

    _this.gutterRef = function (ref) {
      _this.gutter = ref && (0, _reactDom.findDOMNode)(ref);
    };

    _this.handleSelectAlldayEvent = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      //cancel any pending selections so only the event click goes through.
      _this.clearSelection();
      (0, _helpers.notify)(_this.props.onSelectEvent, args);
    };

    _this.handleSelectAllDaySlot = function (slots, slotInfo) {
      var onSelectSlot = _this.props.onSelectSlot;

      (0, _helpers.notify)(onSelectSlot, {
        slots: slots,
        start: slots[0],
        end: slots[slots.length - 1],
        action: slotInfo.action
      });
    };

    _this.checkOverflow = function () {
      if (_this._updatingOverflow) return;

      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;

      if (_this.state.isOverflowing !== isOverflowing) {
        _this._updatingOverflow = true;
        _this.setState({ isOverflowing: isOverflowing }, function () {
          _this._updatingOverflow = false;
        });
      }
    };

    _this.state = { gutterWidth: undefined, isOverflowing: null };
    return _this;
  }

  TimeGrid.prototype.componentWillMount = function componentWillMount() {
    this.calculateScroll();
  };

  TimeGrid.prototype.componentDidMount = function componentDidMount() {
    this.checkOverflow();

    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll();

    this.positionTimeIndicator();
    this.triggerTimeIndicatorUpdate();

    window.addEventListener('resize', this.handleResize);
  };

  TimeGrid.prototype.componentWillUnmount = function componentWillUnmount() {
    window.clearTimeout(this._timeIndicatorTimeout);
    window.removeEventListener('resize', this.handleResize);

    _requestAnimationFrame2.default.cancel(this.rafHandle);
  };

  TimeGrid.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll();
    this.positionTimeIndicator();
    //this.checkOverflow()
  };

  TimeGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        range = _props.range,
        scrollToTime = _props.scrollToTime;
    // When paginating, reset scroll

    if (!_dates2.default.eq(nextProps.range[0], range[0], 'minute') || !_dates2.default.eq(nextProps.scrollToTime, scrollToTime, 'minute')) {
      this.calculateScroll(nextProps);
    }
  };

  TimeGrid.prototype.renderEvents = function renderEvents(range, events, today, resources) {
    var _this2 = this;

    var _props2 = this.props,
        min = _props2.min,
        max = _props2.max,
        endAccessor = _props2.endAccessor,
        startAccessor = _props2.startAccessor,
        resourceAccessor = _props2.resourceAccessor,
        resourceIdAccessor = _props2.resourceIdAccessor,
        components = _props2.components;

    return range.map(function (date, idx) {
      var daysEvents = events.filter(function (event) {
        return _dates2.default.inRange(date, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), 'day');
      });

      return resources.map(function (resource, id) {
        var eventsToDisplay = !resource ? daysEvents : daysEvents.filter(function (event) {
          return (0, _accessors.accessor)(event, resourceAccessor) === (0, _accessors.accessor)(resource, resourceIdAccessor);
        });

        return _react2.default.createElement(_DayColumn2.default, _extends({}, _this2.props, {
          min: _dates2.default.merge(date, min),
          max: _dates2.default.merge(date, max),
          resource: (0, _accessors.accessor)(resource, resourceIdAccessor),
          eventComponent: components.event,
          eventWrapperComponent: components.eventWrapper,
          timeSlotWrapperComponent: components.dayWrapper,
          className: (0, _classnames2.default)({ 'rbc-now': _dates2.default.eq(date, today, 'day') }),
          key: idx + '-' + id,
          date: date,
          events: eventsToDisplay
        }));
      });
    });
  };

  TimeGrid.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        events = _props3.events,
        range = _props3.range,
        width = _props3.width,
        startAccessor = _props3.startAccessor,
        endAccessor = _props3.endAccessor,
        selected = _props3.selected,
        getNow = _props3.getNow,
        resources = _props3.resources,
        components = _props3.components,
        allDayAccessor = _props3.allDayAccessor,
        eventPropGetter = _props3.eventPropGetter,
        showMultiDayTimes = _props3.showMultiDayTimes,
        longPressThreshold = _props3.longPressThreshold;

    width = width || this.state.gutterWidth;

    var start = range[0],
        end = range[range.length - 1];

    this.slots = range.length;

    var allDayEvents = [],
        rangeEvents = [];

    events.forEach(function (event) {
      if ((0, _eventLevels.inRange)(event, start, end, _this3.props)) {
        var eStart = (0, _accessors.accessor)(event, startAccessor),
            eEnd = (0, _accessors.accessor)(event, endAccessor);

        if ((0, _accessors.accessor)(event, allDayAccessor) || _dates2.default.isJustDate(eStart) && _dates2.default.isJustDate(eEnd) || !showMultiDayTimes && !_dates2.default.eq(eStart, eEnd, 'day')) {
          allDayEvents.push(event);
        } else {
          rangeEvents.push(event);
        }
      }
    });

    allDayEvents.sort(function (a, b) {
      return (0, _eventLevels.sortEvents)(a, b, _this3.props);
    });

    return _react2.default.createElement('div', { className: 'rbc-time-view' }, _react2.default.createElement(_TimeGridHeader2.default, {
      range: range,
      events: allDayEvents,
      width: width,
      getNow: getNow,
      dayFormat: this.props.dayFormat,
      culture: this.props.culture,
      resources: resources,
      selected: selected,
      selectable: this.props.selectable,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      titleAccessor: this.props.titleAccessor,
      tooltipAccessor: this.props.tooltipAccessor,
      allDayAccessor: this.props.allDayAccessor,
      resourceAccessor: this.props.resourceAccessor,
      resourceIdAccessor: this.props.resourceIdAccessor,
      resourceTitleAccessor: this.props.resourceTitleAccessor,
      isOverflowing: this.state.isOverflowing,
      dayPropGetter: this.props.dayPropGetter,
      eventPropGetter: eventPropGetter,
      longPressThreshold: longPressThreshold,
      headerComponent: components.header,
      eventComponent: components.event,
      eventWrapperComponent: components.eventWrapper,
      dateCellWrapperComponent: components.dateCellWrapper,
      onSelectSlot: this.handleSelectAllDaySlot,
      onSelectEvent: this.handleSelectAlldayEvent,
      onDoubleClickEvent: this.props.onDoubleClickEvent,
      onDrillDown: this.props.onDrillDown,
      getDrilldownView: this.props.getDrilldownView
    }), _react2.default.createElement('div', { ref: 'content', className: 'rbc-time-content' }, _react2.default.createElement(_TimeGutter2.default, _extends({}, this.props, {
      date: start,
      ref: this.gutterRef,
      className: 'rbc-time-gutter'
    })), this.renderEvents(range, rangeEvents, getNow(), resources || [null]), _react2.default.createElement('div', { ref: 'timeIndicator', className: 'rbc-current-time-indicator' })));
  };

  TimeGrid.prototype.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  TimeGrid.prototype.measureGutter = function measureGutter() {
    var width = (0, _width2.default)(this.gutter);

    if (width && this.state.gutterWidth !== width) {
      this.setState({ gutterWidth: width });
    }
  };

  TimeGrid.prototype.applyScroll = function applyScroll() {
    if (this._scrollRatio) {
      var content = this.refs.content;

      content.scrollTop = content.scrollHeight * this._scrollRatio;
      // Only do this once
      this._scrollRatio = null;
    }
  };

  TimeGrid.prototype.calculateScroll = function calculateScroll() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    var min = props.min,
        max = props.max,
        scrollToTime = props.scrollToTime;

    var diffMillis = scrollToTime - _dates2.default.startOf(scrollToTime, 'day');
    var totalMillis = _dates2.default.diff(max, min);

    this._scrollRatio = diffMillis / totalMillis;
  };

  TimeGrid.prototype.positionTimeIndicator = function positionTimeIndicator() {
    var _props4 = this.props,
        rtl = _props4.rtl,
        min = _props4.min,
        max = _props4.max,
        getNow = _props4.getNow,
        range = _props4.range;

    var current = getNow();

    var secondsGrid = _dates2.default.diff(max, min, 'seconds');
    var secondsPassed = _dates2.default.diff(current, min, 'seconds');

    var timeIndicator = this.refs.timeIndicator;
    var factor = secondsPassed / secondsGrid;
    var timeGutter = this.gutter;

    var content = this.refs.content;

    if (timeGutter && current >= min && current <= max) {
      var pixelHeight = timeGutter.offsetHeight;
      var dayPixelWidth = (content.offsetWidth - timeGutter.offsetWidth) / this.slots;
      var dayOffset = range.findIndex(function (d) {
        return _dates2.default.eq(d, _dates2.default.today(), 'day');
      }) * dayPixelWidth;
      var offset = Math.floor(factor * pixelHeight);

      timeIndicator.style.display = dayOffset >= 0 ? 'block' : 'none';
      timeIndicator.style[rtl ? 'left' : 'right'] = 0;
      timeIndicator.style[rtl ? 'right' : 'left'] = timeGutter.offsetWidth + dayOffset + 'px';
      timeIndicator.style.top = offset + 'px';
      timeIndicator.style.width = dayPixelWidth + 'px';
    } else {
      timeIndicator.style.display = 'none';
    }
  };

  TimeGrid.prototype.triggerTimeIndicatorUpdate = function triggerTimeIndicatorUpdate() {
    var _this4 = this;

    // Update the position of the time indicator every minute
    this._timeIndicatorTimeout = window.setTimeout(function () {
      _this4.positionTimeIndicator();

      _this4.triggerTimeIndicatorUpdate();
    }, 60000);
  };

  return TimeGrid;
}(_react.Component);

TimeGrid.propTypes = {
  events: _propTypes2.default.array.isRequired,
  resources: _propTypes2.default.array,

  step: _propTypes2.default.number,
  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  min: _propTypes2.default.instanceOf(Date),
  max: _propTypes2.default.instanceOf(Date),
  getNow: _propTypes2.default.func.isRequired,

  scrollToTime: _propTypes2.default.instanceOf(Date),
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  dayFormat: _propTypes3.dateFormat,
  showMultiDayTimes: _propTypes2.default.bool,
  culture: _propTypes2.default.string,

  rtl: _propTypes2.default.bool,
  width: _propTypes2.default.number,

  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,
  resourceAccessor: _propTypes3.accessor.isRequired,

  resourceIdAccessor: _propTypes3.accessor.isRequired,
  resourceTitleAccessor: _propTypes3.accessor.isRequired,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onNavigate: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,
  onSelectEvent: _propTypes2.default.func,
  onDoubleClickEvent: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  getDrilldownView: _propTypes2.default.func.isRequired,

  messages: _propTypes2.default.object,
  components: _propTypes2.default.object.isRequired
};
TimeGrid.defaultProps = {
  step: 30,
  timeslots: 2,
  min: _dates2.default.startOf(new Date(), 'day'),
  max: _dates2.default.endOf(new Date(), 'day'),
  scrollToTime: _dates2.default.startOf(new Date(), 'day')
};
exports.default = TimeGrid;
module.exports = exports['default'];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.set = set;
exports.result = result;
exports.default = messages;

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var defaultMessages = {
  date: 'Date',
  time: 'Time',
  event: 'Event',
  allDay: 'all day',
  week: 'week',
  work_week: 'work week',
  day: 'day',
  month: 'month',
  previous: 'back',
  next: 'next',
  yesterday: 'yesterday',
  tomorrow: 'tomorrow',
  today: 'today',
  agenda: 'agenda',

  showMore: function showMore(total) {
    return '+' + total + ' more';
  }
};

function set(key, msg) {
  !messages.hasOwnProperty(key) ?  false ? (0, _invariant2.default)(false, 'The message key: "' + key + '" is not a valid message name. ' + ('valid keys are: ' + Object.keys(messages).join(', '))) : (0, _invariant2.default)(false) : void 0;

  messages[key] = msg;
}

function result(msg) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof msg === 'function' ? msg(args) : msg;
}

function messages(msgs) {
  return _extends({}, defaultMessages, msgs);
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(288);

var _Helpers = __webpack_require__(462);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var aa = __webpack_require__(0),
    n = __webpack_require__(169),
    ba = __webpack_require__(758);function ca(a, b, c, d, e, f, g, h) {
  if (!a) {
    a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var k = [c, d, e, f, g, h],
          l = 0;a = Error(b.replace(/%s/g, function () {
        return k[l++];
      }));a.name = "Invariant Violation";
    }a.framesToPop = 1;throw a;
  }
}
function t(a) {
  for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
    c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
  }ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}aa ? void 0 : t("227");function da(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);try {
    b.apply(c, l);
  } catch (m) {
    this.onError(m);
  }
}
var ea = !1,
    fa = null,
    ha = !1,
    ia = null,
    ja = { onError: function onError(a) {
    ea = !0;fa = a;
  } };function ka(a, b, c, d, e, f, g, h, k) {
  ea = !1;fa = null;da.apply(ja, arguments);
}function la(a, b, c, d, e, f, g, h, k) {
  ka.apply(this, arguments);if (ea) {
    if (ea) {
      var l = fa;ea = !1;fa = null;
    } else t("198"), l = void 0;ha || (ha = !0, ia = l);
  }
}var ma = null,
    na = {};
function oa() {
  if (ma) for (var a in na) {
    var b = na[a],
        c = ma.indexOf(a);-1 < c ? void 0 : t("96", a);if (!pa[c]) {
      b.extractEvents ? void 0 : t("97", a);pa[c] = b;c = b.eventTypes;for (var d in c) {
        var e = void 0;var f = c[d],
            g = b,
            h = d;qa.hasOwnProperty(h) ? t("99", h) : void 0;qa[h] = f;var k = f.phasedRegistrationNames;if (k) {
          for (e in k) {
            k.hasOwnProperty(e) && ra(k[e], g, h);
          }e = !0;
        } else f.registrationName ? (ra(f.registrationName, g, h), e = !0) : e = !1;e ? void 0 : t("98", d, a);
      }
    }
  }
}
function ra(a, b, c) {
  sa[a] ? t("100", a) : void 0;sa[a] = b;ta[a] = b.eventTypes[c].dependencies;
}var pa = [],
    qa = {},
    sa = {},
    ta = {},
    ua = null,
    va = null,
    wa = null;function xa(a, b, c, d) {
  b = a.type || "unknown-event";a.currentTarget = wa(d);la(b, c, void 0, a);a.currentTarget = null;
}function ya(a, b) {
  null == b ? t("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
  }return Array.isArray(b) ? [a].concat(b) : [a, b];
}
function za(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}var Aa = null;function Ba(a, b) {
  if (a) {
    var c = a._dispatchListeners,
        d = a._dispatchInstances;if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
      xa(a, b, c[e], d[e]);
    } else c && xa(a, b, c, d);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
  }
}function Ca(a) {
  return Ba(a, !0);
}function Da(a) {
  return Ba(a, !1);
}
var Ea = { injectEventPluginOrder: function injectEventPluginOrder(a) {
    ma ? t("101") : void 0;ma = Array.prototype.slice.call(a);oa();
  }, injectEventPluginsByName: function injectEventPluginsByName(a) {
    var b = !1,
        c;for (c in a) {
      if (a.hasOwnProperty(c)) {
        var d = a[c];na.hasOwnProperty(c) && na[c] === d || (na[c] ? t("102", c) : void 0, na[c] = d, b = !0);
      }
    }b && oa();
  } };
function Fa(a, b) {
  var c = a.stateNode;if (!c) return null;var d = ua(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
      a = !1;}if (a) return null;c && "function" !== typeof c ? t("231", b, typeof c === "undefined" ? "undefined" : _typeof(c)) : void 0;
  return c;
}function Ga(a, b) {
  null !== a && (Aa = ya(Aa, a));a = Aa;Aa = null;if (a && (b ? za(a, Ca) : za(a, Da), Aa ? t("95") : void 0, ha)) throw b = ia, ha = !1, ia = null, b;
}var Ha = Math.random().toString(36).slice(2),
    Ia = "__reactInternalInstance$" + Ha,
    Ja = "__reactEventHandlers$" + Ha;function Ka(a) {
  if (a[Ia]) return a[Ia];for (; !a[Ia];) {
    if (a.parentNode) a = a.parentNode;else return null;
  }a = a[Ia];return 7 === a.tag || 8 === a.tag ? a : null;
}function La(a) {
  a = a[Ia];return !a || 7 !== a.tag && 8 !== a.tag ? null : a;
}
function Ma(a) {
  if (7 === a.tag || 8 === a.tag) return a.stateNode;t("33");
}function Na(a) {
  return a[Ja] || null;
}function Oa(a) {
  do {
    a = a.return;
  } while (a && 7 !== a.tag);return a ? a : null;
}function Pa(a, b, c) {
  if (b = Fa(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a);
}
function Qa(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b;) {
      c.push(b), b = Oa(b);
    }for (b = c.length; 0 < b--;) {
      Pa(c[b], "captured", a);
    }for (b = 0; b < c.length; b++) {
      Pa(c[b], "bubbled", a);
    }
  }
}function Ra(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Fa(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a));
}function Ta(a) {
  a && a.dispatchConfig.registrationName && Ra(a._targetInst, null, a);
}
function Ua(a) {
  za(a, Qa);
}var Va = !("undefined" === typeof window || !window.document || !window.document.createElement);function Wa(a, b) {
  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;return c;
}var Ya = { animationend: Wa("Animation", "AnimationEnd"), animationiteration: Wa("Animation", "AnimationIteration"), animationstart: Wa("Animation", "AnimationStart"), transitionend: Wa("Transition", "TransitionEnd") },
    Za = {},
    $a = {};
Va && ($a = document.createElement("div").style, "AnimationEvent" in window || (delete Ya.animationend.animation, delete Ya.animationiteration.animation, delete Ya.animationstart.animation), "TransitionEvent" in window || delete Ya.transitionend.transition);function ab(a) {
  if (Za[a]) return Za[a];if (!Ya[a]) return a;var b = Ya[a],
      c;for (c in b) {
    if (b.hasOwnProperty(c) && c in $a) return Za[a] = b[c];
  }return a;
}
var bb = ab("animationend"),
    cb = ab("animationiteration"),
    db = ab("animationstart"),
    eb = ab("transitionend"),
    fb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    gb = null,
    hb = null,
    ib = null;
function jb() {
  if (ib) return ib;var a,
      b = hb,
      c = b.length,
      d,
      e = "value" in gb ? gb.value : gb.textContent,
      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var g = c - a;for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {}return ib = e.slice(a, 1 < d ? 1 - d : void 0);
}function kb() {
  return !0;
}function lb() {
  return !1;
}
function z(a, b, c, d) {
  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {
    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  }this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? kb : lb;this.isPropagationStopped = lb;return this;
}
n(z.prototype, { preventDefault: function preventDefault() {
    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = kb);
  }, stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = kb);
  }, persist: function persist() {
    this.isPersistent = kb;
  }, isPersistent: lb, destructor: function destructor() {
    var a = this.constructor.Interface,
        b;for (b in a) {
      this[b] = null;
    }this.nativeEvent = this._targetInst = this.dispatchConfig = null;this.isPropagationStopped = this.isDefaultPrevented = lb;this._dispatchInstances = this._dispatchListeners = null;
  } });z.Interface = { type: null, target: null, currentTarget: function currentTarget() {
    return null;
  }, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null };
z.extend = function (a) {
  function b() {}function c() {
    return d.apply(this, arguments);
  }var d = this;b.prototype = d.prototype;var e = new b();n(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = n({}, d.Interface, a);c.extend = d.extend;mb(c);return c;
};mb(z);function nb(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
  }return new this(a, b, c, d);
}function ob(a) {
  a instanceof this ? void 0 : t("279");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
}
function mb(a) {
  a.eventPool = [];a.getPooled = nb;a.release = ob;
}var pb = z.extend({ data: null }),
    qb = z.extend({ data: null }),
    rb = [9, 13, 27, 32],
    sb = Va && "CompositionEvent" in window,
    tb = null;Va && "documentMode" in document && (tb = document.documentMode);
var ub = Va && "TextEvent" in window && !tb,
    vb = Va && (!sb || tb && 8 < tb && 11 >= tb),
    wb = String.fromCharCode(32),
    xb = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } },
    yb = !1;
function zb(a, b) {
  switch (a) {case "keyup":
      return -1 !== rb.indexOf(b.keyCode);case "keydown":
      return 229 !== b.keyCode;case "keypress":case "mousedown":case "blur":
      return !0;default:
      return !1;}
}function Ab(a) {
  a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && "data" in a ? a.data : null;
}var Bb = !1;function Cb(a, b) {
  switch (a) {case "compositionend":
      return Ab(b);case "keypress":
      if (32 !== b.which) return null;yb = !0;return wb;case "textInput":
      return a = b.data, a === wb && yb ? null : a;default:
      return null;}
}
function Db(a, b) {
  if (Bb) return "compositionend" === a || !sb && zb(a, b) ? (a = jb(), ib = hb = gb = null, Bb = !1, a) : null;switch (a) {case "paste":
      return null;case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
      }return null;case "compositionend":
      return vb && "ko" !== b.locale ? null : b.data;default:
      return null;}
}
var Eb = { eventTypes: xb, extractEvents: function extractEvents(a, b, c, d) {
    var e = void 0;var f = void 0;if (sb) b: {
      switch (a) {case "compositionstart":
          e = xb.compositionStart;break b;case "compositionend":
          e = xb.compositionEnd;break b;case "compositionupdate":
          e = xb.compositionUpdate;break b;}e = void 0;
    } else Bb ? zb(a, c) && (e = xb.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = xb.compositionStart);e ? (vb && "ko" !== c.locale && (Bb || e !== xb.compositionStart ? e === xb.compositionEnd && Bb && (f = jb()) : (gb = d, hb = "value" in gb ? gb.value : gb.textContent, Bb = !0)), e = pb.getPooled(e, b, c, d), f ? e.data = f : (f = Ab(c), null !== f && (e.data = f)), Ua(e), f = e) : f = null;(a = ub ? Cb(a, c) : Db(a, c)) ? (b = qb.getPooled(xb.beforeInput, b, c, d), b.data = a, Ua(b)) : b = null;return null === f ? b : null === b ? f : [f, b];
  } },
    Fb = null,
    Gb = null,
    Hb = null;function Ib(a) {
  if (a = va(a)) {
    "function" !== typeof Fb ? t("280") : void 0;var b = ua(a.stateNode);Fb(a.stateNode, a.type, b);
  }
}function Jb(a) {
  Gb ? Hb ? Hb.push(a) : Hb = [a] : Gb = a;
}function Kb() {
  if (Gb) {
    var a = Gb,
        b = Hb;Hb = Gb = null;Ib(a);if (b) for (a = 0; a < b.length; a++) {
      Ib(b[a]);
    }
  }
}
function Lb(a, b) {
  return a(b);
}function Mb(a, b, c) {
  return a(b, c);
}function Nb() {}var Ob = !1;function Pb(a, b) {
  if (Ob) return a(b);Ob = !0;try {
    return Lb(a, b);
  } finally {
    if (Ob = !1, null !== Gb || null !== Hb) Nb(), Kb();
  }
}var Qb = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function Rb(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!Qb[a.type] : "textarea" === b ? !0 : !1;
}
function Sb(a) {
  a = a.target || a.srcElement || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
}function Tb(a) {
  if (!Va) return !1;a = "on" + a;var b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
}function Ub(a) {
  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Vb(a) {
  var b = Ub(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;Object.defineProperty(a, b, { configurable: !0, get: function get() {
        return e.call(this);
      }, set: function set(a) {
        d = "" + a;f.call(this, a);
      } });Object.defineProperty(a, b, { enumerable: c.enumerable });return { getValue: function getValue() {
        return d;
      }, setValue: function setValue(a) {
        d = "" + a;
      }, stopTracking: function stopTracking() {
        a._valueTracker = null;delete a[b];
      } };
  }
}function Wb(a) {
  a._valueTracker || (a._valueTracker = Vb(a));
}function Xb(a) {
  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = Ub(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
}
var Yb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    Zb = /^(.*)[\\\/]/,
    C = "function" === typeof Symbol && Symbol.for,
    $b = C ? Symbol.for("react.element") : 60103,
    ac = C ? Symbol.for("react.portal") : 60106,
    bc = C ? Symbol.for("react.fragment") : 60107,
    cc = C ? Symbol.for("react.strict_mode") : 60108,
    dc = C ? Symbol.for("react.profiler") : 60114,
    ec = C ? Symbol.for("react.provider") : 60109,
    fc = C ? Symbol.for("react.context") : 60110,
    gc = C ? Symbol.for("react.async_mode") : 60111,
    hc = C ? Symbol.for("react.forward_ref") : 60112,
    ic = C ? Symbol.for("react.placeholder") : 60113,
    jc = "function" === typeof Symbol && Symbol.iterator;function kc(a) {
  if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) return null;a = jc && a[jc] || a["@@iterator"];return "function" === typeof a ? a : null;
}
function lc(a) {
  if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case gc:
      return "AsyncMode";case bc:
      return "Fragment";case ac:
      return "Portal";case dc:
      return "Profiler";case cc:
      return "StrictMode";case ic:
      return "Placeholder";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    switch (a.$$typeof) {case fc:
        return "Context.Consumer";case ec:
        return "Context.Provider";case hc:
        var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");}if ("function" === typeof a.then && (a = 1 === a._reactStatus ? a._reactResult : null)) return lc(a);
  }return null;
}function mc(a) {
  var b = "";do {
    a: switch (a.tag) {case 4:case 0:case 1:case 2:case 3:case 7:case 10:
        var c = a._debugOwner,
            d = a._debugSource,
            e = lc(a.type);var f = null;c && (f = lc(c.type));c = e;e = "";d ? e = " (at " + d.fileName.replace(Zb, "") + ":" + d.lineNumber + ")" : f && (e = " (created by " + f + ")");f = "\n    in " + (c || "Unknown") + e;break a;default:
        f = "";}b += f;a = a.return;
  } while (a);return b;
}
var nc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    pc = Object.prototype.hasOwnProperty,
    qc = {},
    rc = {};
function sc(a) {
  if (pc.call(rc, a)) return !0;if (pc.call(qc, a)) return !1;if (nc.test(a)) return rc[a] = !0;qc[a] = !0;return !1;
}function tc(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
      return !0;case "boolean":
      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}
function uc(a, b, c, d) {
  if (null === b || "undefined" === typeof b || tc(a, b, c, d)) return !0;if (d) return !1;if (null !== c) switch (c.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}function D(a, b, c, d, e) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;
}var E = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  E[a] = new D(a, 0, !1, a, null);
});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];E[b] = new D(b, 1, !1, a[1], null);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  E[a] = new D(a, 2, !1, a.toLowerCase(), null);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  E[a] = new D(a, 2, !1, a, null);
});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  E[a] = new D(a, 3, !1, a.toLowerCase(), null);
});["checked", "multiple", "muted", "selected"].forEach(function (a) {
  E[a] = new D(a, 3, !0, a, null);
});
["capture", "download"].forEach(function (a) {
  E[a] = new D(a, 4, !1, a, null);
});["cols", "rows", "size", "span"].forEach(function (a) {
  E[a] = new D(a, 6, !1, a, null);
});["rowSpan", "start"].forEach(function (a) {
  E[a] = new D(a, 5, !1, a.toLowerCase(), null);
});var vc = /[\-:]([a-z])/g;function wc(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(vc, wc);E[b] = new D(b, 1, !1, a, null);
});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(vc, wc);E[b] = new D(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(vc, wc);E[b] = new D(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});E.tabIndex = new D("tabIndex", 1, !1, "tabindex", null);
function xc(a, b, c, d) {
  var e = E.hasOwnProperty(b) ? E[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (uc(b, c, e, d) && (c = null), d || null === e ? sc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function yc(a) {
  switch (typeof a === "undefined" ? "undefined" : _typeof(a)) {case "boolean":case "number":case "object":case "string":case "undefined":
      return a;default:
      return "";}
}function zc(a, b) {
  var c = b.checked;return n({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Bc(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;c = yc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}function Cc(a, b) {
  b = b.checked;null != b && xc(a, "checked", b, !1);
}
function Dc(a, b) {
  Cc(a, b);var c = yc(b.value),
      d = b.type;if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");return;
  }b.hasOwnProperty("value") ? Ec(a, b.type, c) : b.hasOwnProperty("defaultValue") && Ec(a, b.type, yc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Fc(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;b = "" + a._wrapperState.initialValue;c || b === a.value || (a.value = b);a.defaultValue = b;
  }c = a.name;"" !== c && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !!a._wrapperState.initialChecked;"" !== c && (a.name = c);
}
function Ec(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}var Gc = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };function Hc(a, b, c) {
  a = z.getPooled(Gc.change, a, b, c);a.type = "change";Jb(c);Ua(a);return a;
}var Ic = null,
    Jc = null;function Kc(a) {
  Ga(a, !1);
}
function Lc(a) {
  var b = Ma(a);if (Xb(b)) return a;
}function Mc(a, b) {
  if ("change" === a) return b;
}var Nc = !1;Va && (Nc = Tb("input") && (!document.documentMode || 9 < document.documentMode));function Oc() {
  Ic && (Ic.detachEvent("onpropertychange", Pc), Jc = Ic = null);
}function Pc(a) {
  "value" === a.propertyName && Lc(Jc) && (a = Hc(Jc, a, Sb(a)), Pb(Kc, a));
}function Qc(a, b, c) {
  "focus" === a ? (Oc(), Ic = b, Jc = c, Ic.attachEvent("onpropertychange", Pc)) : "blur" === a && Oc();
}function Rc(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Lc(Jc);
}
function Sc(a, b) {
  if ("click" === a) return Lc(b);
}function Tc(a, b) {
  if ("input" === a || "change" === a) return Lc(b);
}
var Uc = { eventTypes: Gc, _isInputEventSupported: Nc, extractEvents: function extractEvents(a, b, c, d) {
    var e = b ? Ma(b) : window,
        f = void 0,
        g = void 0,
        h = e.nodeName && e.nodeName.toLowerCase();"select" === h || "input" === h && "file" === e.type ? f = Mc : Rb(e) ? Nc ? f = Tc : (f = Rc, g = Qc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = Sc);if (f && (f = f(a, b))) return Hc(f, c, d);g && g(a, e, b);"blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Ec(e, "number", e.value);
  } },
    Vc = z.extend({ view: null, detail: null }),
    Wc = { Alt: "altKey",
  Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function Xc(a) {
  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = Wc[a]) ? !!b[a] : !1;
}function Yc() {
  return Xc;
}
var Zc = 0,
    $c = 0,
    ad = !1,
    bd = !1,
    cd = Vc.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Yc, button: null, buttons: null, relatedTarget: function relatedTarget(a) {
    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
  }, movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;var b = Zc;Zc = a.screenX;return ad ? "mousemove" === a.type ? a.screenX - b : 0 : (ad = !0, 0);
  }, movementY: function movementY(a) {
    if ("movementY" in a) return a.movementY;
    var b = $c;$c = a.screenY;return bd ? "mousemove" === a.type ? a.screenY - b : 0 : (bd = !0, 0);
  } }),
    dd = cd.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }),
    ed = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: { registrationName: "onPointerLeave",
    dependencies: ["pointerout", "pointerover"] } },
    fd = { eventTypes: ed, extractEvents: function extractEvents(a, b, c, d) {
    var e = "mouseover" === a || "pointerover" === a,
        f = "mouseout" === a || "pointerout" === a;if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? Ka(b) : null) : f = null;if (f === b) return null;var g = void 0,
        h = void 0,
        k = void 0,
        l = void 0;if ("mouseout" === a || "mouseover" === a) g = cd, h = ed.mouseLeave, k = ed.mouseEnter, l = "mouse";else if ("pointerout" === a || "pointerover" === a) g = dd, h = ed.pointerLeave, k = ed.pointerEnter, l = "pointer";var m = null == f ? e : Ma(f);e = null == b ? e : Ma(b);a = g.getPooled(h, f, c, d);a.type = l + "leave";a.target = m;a.relatedTarget = e;c = g.getPooled(k, b, c, d);c.type = l + "enter";c.target = e;c.relatedTarget = m;d = b;if (f && d) a: {
      b = f;e = d;l = 0;for (g = b; g; g = Oa(g)) {
        l++;
      }g = 0;for (k = e; k; k = Oa(k)) {
        g++;
      }for (; 0 < l - g;) {
        b = Oa(b), l--;
      }for (; 0 < g - l;) {
        e = Oa(e), g--;
      }for (; l--;) {
        if (b === e || b === e.alternate) break a;b = Oa(b);e = Oa(e);
      }b = null;
    } else b = null;e = b;for (b = []; f && f !== e;) {
      l = f.alternate;if (null !== l && l === e) break;b.push(f);f = Oa(f);
    }for (f = []; d && d !== e;) {
      l = d.alternate;if (null !== l && l === e) break;f.push(d);d = Oa(d);
    }for (d = 0; d < b.length; d++) {
      Ra(b[d], "bubbled", a);
    }for (d = f.length; 0 < d--;) {
      Ra(f[d], "captured", c);
    }return [a, c];
  } },
    gd = Object.prototype.hasOwnProperty;function hd(a, b) {
  return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;
}
function id(a, b) {
  if (hd(a, b)) return !0;if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : _typeof(b)) || null === b) return !1;var c = Object.keys(a),
      d = Object.keys(b);if (c.length !== d.length) return !1;for (d = 0; d < c.length; d++) {
    if (!gd.call(b, c[d]) || !hd(a[c[d]], b[c[d]])) return !1;
  }return !0;
}function jd(a) {
  var b = a;if (a.alternate) for (; b.return;) {
    b = b.return;
  } else {
    if (0 !== (b.effectTag & 2)) return 1;for (; b.return;) {
      if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
  }return 5 === b.tag ? 2 : 3;
}function kd(a) {
  2 !== jd(a) ? t("188") : void 0;
}
function ld(a) {
  var b = a.alternate;if (!b) return b = jd(a), 3 === b ? t("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
    var e = c.return,
        f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {
      for (var g = e.child; g;) {
        if (g === c) return kd(e), a;if (g === d) return kd(e), b;g = g.sibling;
      }t("188");
    }if (c.return !== d.return) c = e, d = f;else {
      g = !1;for (var h = e.child; h;) {
        if (h === c) {
          g = !0;c = e;d = f;break;
        }if (h === d) {
          g = !0;d = e;c = f;break;
        }h = h.sibling;
      }if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;c = f;d = e;break;
          }if (h === d) {
            g = !0;d = f;c = e;break;
          }h = h.sibling;
        }g ? void 0 : t("189");
      }
    }c.alternate !== d ? t("190") : void 0;
  }5 !== c.tag ? t("188") : void 0;return c.stateNode.current === c ? a : b;
}function md(a) {
  a = ld(a);if (!a) return null;for (var b = a;;) {
    if (7 === b.tag || 8 === b.tag) return b;if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;b = b.return;
      }b.sibling.return = b.return;b = b.sibling;
    }
  }return null;
}
var nd = z.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
    od = z.extend({ clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }),
    pd = Vc.extend({ relatedTarget: null });function qd(a) {
  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
}
var rd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
    sd = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
    td = Vc.extend({ key: function key(a) {
    if (a.key) {
      var b = rd[a.key] || a.key;if ("Unidentified" !== b) return b;
    }return "keypress" === a.type ? (a = qd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? sd[a.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Yc, charCode: function charCode(a) {
    return "keypress" === a.type ? qd(a) : 0;
  }, keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function which(a) {
    return "keypress" === a.type ? qd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }),
    ud = cd.extend({ dataTransfer: null }),
    vd = Vc.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Yc }),
    wd = z.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
    xd = cd.extend({ deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  }, deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }),
    yd = [["abort", "abort"], [bb, "animationEnd"], [cb, "animationIteration"], [db, "animationStart"], ["canplay", "canPlay"], ["canplaythrough", "canPlayThrough"], ["drag", "drag"], ["dragenter", "dragEnter"], ["dragexit", "dragExit"], ["dragleave", "dragLeave"], ["dragover", "dragOver"], ["durationchange", "durationChange"], ["emptied", "emptied"], ["encrypted", "encrypted"], ["ended", "ended"], ["error", "error"], ["gotpointercapture", "gotPointerCapture"], ["load", "load"], ["loadeddata", "loadedData"], ["loadedmetadata", "loadedMetadata"], ["loadstart", "loadStart"], ["lostpointercapture", "lostPointerCapture"], ["mousemove", "mouseMove"], ["mouseout", "mouseOut"], ["mouseover", "mouseOver"], ["playing", "playing"], ["pointermove", "pointerMove"], ["pointerout", "pointerOut"], ["pointerover", "pointerOver"], ["progress", "progress"], ["scroll", "scroll"], ["seeking", "seeking"], ["stalled", "stalled"], ["suspend", "suspend"], ["timeupdate", "timeUpdate"], ["toggle", "toggle"], ["touchmove", "touchMove"], [eb, "transitionEnd"], ["waiting", "waiting"], ["wheel", "wheel"]],
    zd = {},
    Ad = {};function Bd(a, b) {
  var c = a[0];a = a[1];var d = "on" + (a[0].toUpperCase() + a.slice(1));b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };zd[a] = b;Ad[c] = b;
}
[["blur", "blur"], ["cancel", "cancel"], ["click", "click"], ["close", "close"], ["contextmenu", "contextMenu"], ["copy", "copy"], ["cut", "cut"], ["auxclick", "auxClick"], ["dblclick", "doubleClick"], ["dragend", "dragEnd"], ["dragstart", "dragStart"], ["drop", "drop"], ["focus", "focus"], ["input", "input"], ["invalid", "invalid"], ["keydown", "keyDown"], ["keypress", "keyPress"], ["keyup", "keyUp"], ["mousedown", "mouseDown"], ["mouseup", "mouseUp"], ["paste", "paste"], ["pause", "pause"], ["play", "play"], ["pointercancel", "pointerCancel"], ["pointerdown", "pointerDown"], ["pointerup", "pointerUp"], ["ratechange", "rateChange"], ["reset", "reset"], ["seeked", "seeked"], ["submit", "submit"], ["touchcancel", "touchCancel"], ["touchend", "touchEnd"], ["touchstart", "touchStart"], ["volumechange", "volumeChange"]].forEach(function (a) {
  Bd(a, !0);
});yd.forEach(function (a) {
  Bd(a, !1);
});
var Cd = { eventTypes: zd, isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
    a = Ad[a];return void 0 !== a && !0 === a.isInteractive;
  }, extractEvents: function extractEvents(a, b, c, d) {
    var e = Ad[a];if (!e) return null;switch (a) {case "keypress":
        if (0 === qd(c)) return null;case "keydown":case "keyup":
        a = td;break;case "blur":case "focus":
        a = pd;break;case "click":
        if (2 === c.button) return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":
        a = cd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":
        a = ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":
        a = vd;break;case bb:case cb:case db:
        a = nd;break;case eb:
        a = wd;break;case "scroll":
        a = Vc;break;case "wheel":
        a = xd;break;case "copy":case "cut":case "paste":
        a = od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":
        a = dd;break;default:
        a = z;}b = a.getPooled(e, b, c, d);Ua(b);return b;
  } },
    Dd = Cd.isInteractiveTopLevelEventType,
    Ed = [];function Fd(a) {
  var b = a.targetInst,
      c = b;do {
    if (!c) {
      a.ancestors.push(c);break;
    }var d;for (d = c; d.return;) {
      d = d.return;
    }d = 5 !== d.tag ? null : d.stateNode.containerInfo;if (!d) break;a.ancestors.push(c);c = Ka(d);
  } while (c);for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c];var e = Sb(a.nativeEvent);d = a.topLevelType;for (var f = a.nativeEvent, g = null, h = 0; h < pa.length; h++) {
      var k = pa[h];k && (k = k.extractEvents(d, b, f, e)) && (g = ya(g, k));
    }Ga(g, !1);
  }
}var Gd = !0;
function F(a, b) {
  if (!b) return null;var c = (Dd(a) ? Hd : Id).bind(null, a);b.addEventListener(a, c, !1);
}function Jd(a, b) {
  if (!b) return null;var c = (Dd(a) ? Hd : Id).bind(null, a);b.addEventListener(a, c, !0);
}function Hd(a, b) {
  Mb(Id, a, b);
}
function Id(a, b) {
  if (Gd) {
    var c = Sb(b);c = Ka(c);null === c || "number" !== typeof c.tag || 2 === jd(c) || (c = null);if (Ed.length) {
      var d = Ed.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;
    } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {
      Pb(Fd, a);
    } finally {
      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Ed.length && Ed.push(a);
    }
  }
}var Kd = {},
    Ld = 0,
    Md = "_reactListenersID" + ("" + Math.random()).slice(2);
function Nd(a) {
  Object.prototype.hasOwnProperty.call(a, Md) || (a[Md] = Ld++, Kd[a[Md]] = {});return Kd[a[Md]];
}function Od(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);if ("undefined" === typeof a) return null;try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}function Qd(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }return a;
}
function Rd(a, b) {
  var c = Qd(a);a = 0;for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
    }a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;break a;
        }c = c.parentNode;
      }c = void 0;
    }c = Qd(c);
  }
}function Sd(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Sd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Td() {
  for (var a = window, b = Od(); b instanceof a.HTMLIFrameElement;) {
    try {
      a = b.contentDocument.defaultView;
    } catch (c) {
      break;
    }b = Od(a.document);
  }return b;
}function Ud(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Vd = Va && "documentMode" in document && 11 >= document.documentMode,
    Wd = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } },
    Xd = null,
    Yd = null,
    Zd = null,
    $d = !1;
function ae(a, b) {
  var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;if ($d || null == Xd || Xd !== Od(c)) return null;c = Xd;"selectionStart" in c && Ud(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });return Zd && id(Zd, c) ? null : (Zd = c, a = z.getPooled(Wd.select, Yd, a, b), a.type = "select", a.target = Xd, Ua(a), a);
}
var be = { eventTypes: Wd, extractEvents: function extractEvents(a, b, c, d) {
    var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
        f;if (!(f = !e)) {
      a: {
        e = Nd(e);f = ta.onSelect;for (var g = 0; g < f.length; g++) {
          var h = f[g];if (!e.hasOwnProperty(h) || !e[h]) {
            e = !1;break a;
          }
        }e = !0;
      }f = !e;
    }if (f) return null;e = b ? Ma(b) : window;switch (a) {case "focus":
        if (Rb(e) || "true" === e.contentEditable) Xd = e, Yd = b, Zd = null;break;case "blur":
        Zd = Yd = Xd = null;break;case "mousedown":
        $d = !0;break;case "contextmenu":case "mouseup":case "dragend":
        return $d = !1, ae(c, d);case "selectionchange":
        if (Vd) break;
      case "keydown":case "keyup":
        return ae(c, d);}return null;
  } };Ea.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua = Na;va = La;wa = Ma;Ea.injectEventPluginsByName({ SimpleEventPlugin: Cd, EnterLeaveEventPlugin: fd, ChangeEventPlugin: Uc, SelectEventPlugin: be, BeforeInputEventPlugin: Eb });function ce(a) {
  var b = "";aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });return b;
}
function de(a, b) {
  a = n({ children: void 0 }, b);if (b = ce(b.children)) a.children = b;return a;
}function ee(a, b, c, d) {
  a = a.options;if (b) {
    b = {};for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + yc(c);b = null;for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
      }null !== b || a[e].disabled || (b = a[e]);
    }null !== b && (b.selected = !0);
  }
}
function fe(a, b) {
  null != b.dangerouslySetInnerHTML ? t("91") : void 0;return n({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}function ge(a, b) {
  var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? t("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : t("93"), b = b[0]), c = b), null == c && (c = ""));a._wrapperState = { initialValue: yc(c) };
}
function he(a, b) {
  var c = yc(b.value);null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));null != b.defaultValue && (a.defaultValue = "" + yc(b.defaultValue));
}function ie(a) {
  var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);
}var je = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function ke(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}function le(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? ke(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var me = void 0,
    ne = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== je.svg || "innerHTML" in a) a.innerHTML = b;else {
    me = me || document.createElement("div");me.innerHTML = "<svg>" + b + "</svg>";for (b = me.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});
function oe(a, b) {
  if (b) {
    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;return;
    }
  }a.textContent = b;
}
var pe = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridArea: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0,
  floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    qe = ["Webkit", "ms", "Moz", "O"];Object.keys(pe).forEach(function (a) {
  qe.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);pe[b] = pe[a];
  });
});
function re(a, b) {
  a = a.style;for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--");var e = c;var f = b[c];e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || pe.hasOwnProperty(e) && pe[e] ? ("" + f).trim() : f + "px";"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}var se = n({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function te(a, b) {
  b && (se[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? t("137", a, "") : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? t("60") : void 0, "object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : t("61")), null != b.style && "object" !== _typeof(b.style) ? t("62", "") : void 0);
}
function ue(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
      return !1;default:
      return !0;}
}
function ve(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = Nd(a);b = ta[b];for (var d = 0; d < b.length; d++) {
    var e = b[d];if (!c.hasOwnProperty(e) || !c[e]) {
      switch (e) {case "scroll":
          Jd("scroll", a);break;case "focus":case "blur":
          Jd("focus", a);Jd("blur", a);c.blur = !0;c.focus = !0;break;case "cancel":case "close":
          Tb(e) && Jd(e, a);break;case "invalid":case "submit":case "reset":
          break;default:
          -1 === fb.indexOf(e) && F(e, a);}c[e] = !0;
    }
  }
}function we() {}var xe = null,
    ye = null;
function ze(a, b) {
  switch (a) {case "button":case "input":case "select":case "textarea":
      return !!b.autoFocus;}return !1;
}function Ae(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}function Be(a) {
  for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
    a = a.nextSibling;
  }return a;
}
function Ce(a) {
  for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
    a = a.nextSibling;
  }return a;
}new Set();var De = [],
    Ee = -1;function G(a) {
  0 > Ee || (a.current = De[Ee], De[Ee] = null, Ee--);
}function H(a, b) {
  Ee++;De[Ee] = a.current;a.current = b;
}var Fe = {},
    I = { current: Fe },
    J = { current: !1 },
    Ge = Fe;
function He(a, b) {
  var c = a.type.contextTypes;if (!c) return Fe;var d = a.stateNode;if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;var e = {},
      f;for (f in c) {
    e[f] = b[f];
  }d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);return e;
}function K(a) {
  a = a.childContextTypes;return null !== a && void 0 !== a;
}function Ie(a) {
  G(J, a);G(I, a);
}function Je(a) {
  G(J, a);G(I, a);
}
function Ke(a, b, c) {
  I.current !== Fe ? t("168") : void 0;H(I, b, a);H(J, c, a);
}function Le(a, b, c) {
  var d = a.stateNode;a = b.childContextTypes;if ("function" !== typeof d.getChildContext) return c;d = d.getChildContext();for (var e in d) {
    e in a ? void 0 : t("108", lc(b) || "Unknown", e);
  }return n({}, c, d);
}function Me(a) {
  var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || Fe;Ge = I.current;H(I, b, a);H(J, J.current, a);return !0;
}
function Ne(a, b, c) {
  var d = a.stateNode;d ? void 0 : t("169");c ? (b = Le(a, b, Ge), d.__reactInternalMemoizedMergedChildContext = b, G(J, a), G(I, a), H(I, b, a)) : G(J, a);H(J, c, a);
}var Oe = null,
    Pe = null;function Qe(a) {
  return function (b) {
    try {
      return a(b);
    } catch (c) {}
  };
}
function Re(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
    var c = b.inject(a);Oe = Qe(function (a) {
      return b.onCommitFiberRoot(c, a);
    });Pe = Qe(function (a) {
      return b.onCommitFiberUnmount(c, a);
    });
  } catch (d) {}return !0;
}
function Se(a, b, c, d) {
  this.tag = a;this.key = c;this.sibling = this.child = this.return = this.stateNode = this.type = null;this.index = 0;this.ref = null;this.pendingProps = b;this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.childExpirationTime = this.expirationTime = 0;this.alternate = null;
}function Te(a) {
  a = a.prototype;return !(!a || !a.isReactComponent);
}
function Ue(a, b, c) {
  var d = a.alternate;null === d ? (d = new Se(a.tag, b, a.key, a.mode), d.type = a.type, d.stateNode = a.stateNode, d.alternate = a, a.alternate = d) : (d.pendingProps = b, d.effectTag = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null);d.childExpirationTime = a.childExpirationTime;d.expirationTime = b !== a.pendingProps ? c : a.expirationTime;d.child = a.child;d.memoizedProps = a.memoizedProps;d.memoizedState = a.memoizedState;d.updateQueue = a.updateQueue;d.firstContextDependency = a.firstContextDependency;d.sibling = a.sibling;
  d.index = a.index;d.ref = a.ref;return d;
}
function Ve(a, b, c) {
  var d = a.type,
      e = a.key;a = a.props;var f = void 0;if ("function" === typeof d) f = Te(d) ? 2 : 4;else if ("string" === typeof d) f = 7;else a: switch (d) {case bc:
      return We(a.children, b, c, e);case gc:
      f = 10;b |= 3;break;case cc:
      f = 10;b |= 2;break;case dc:
      return d = new Se(15, a, e, b | 4), d.type = dc, d.expirationTime = c, d;case ic:
      f = 16;break;default:
      if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) switch (d.$$typeof) {case ec:
          f = 12;break a;case fc:
          f = 11;break a;case hc:
          f = 13;break a;default:
          if ("function" === typeof d.then) {
            f = 4;break a;
          }}t("130", null == d ? d : typeof d === "undefined" ? "undefined" : _typeof(d), "");}b = new Se(f, a, e, b);b.type = d;b.expirationTime = c;return b;
}function We(a, b, c, d) {
  a = new Se(9, a, d, b);a.expirationTime = c;return a;
}function Xe(a, b, c) {
  a = new Se(8, a, null, b);a.expirationTime = c;return a;
}function Ye(a, b, c) {
  b = new Se(6, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
}
function Ze(a, b) {
  a.didError = !1;var c = a.earliestPendingTime;0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c > b ? a.earliestPendingTime = b : a.latestPendingTime < b && (a.latestPendingTime = b);$e(b, a);
}function $e(a, b) {
  var c = b.earliestSuspendedTime,
      d = b.latestSuspendedTime,
      e = b.earliestPendingTime,
      f = b.latestPingedTime;e = 0 !== e ? e : f;0 === e && (0 === a || d > a) && (e = d);a = e;0 !== a && 0 !== c && c < a && (a = c);b.nextExpirationTimeToWorkOn = e;b.expirationTime = a;
}var af = !1;
function bf(a) {
  return { baseState: a, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}function cf(a) {
  return { baseState: a.baseState, firstUpdate: a.firstUpdate, lastUpdate: a.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}
function df(a) {
  return { expirationTime: a, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
}function ef(a, b) {
  null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function ff(a, b) {
  var c = a.alternate;if (null === c) {
    var d = a.updateQueue;var e = null;null === d && (d = a.updateQueue = bf(a.memoizedState));
  } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = bf(a.memoizedState), e = c.updateQueue = bf(c.memoizedState)) : d = a.updateQueue = cf(e) : null === e && (e = c.updateQueue = cf(d));null === e || d === e ? ef(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (ef(d, b), ef(e, b)) : (ef(d, b), e.lastUpdate = b);
}
function gf(a, b) {
  var c = a.updateQueue;c = null === c ? a.updateQueue = bf(a.memoizedState) : hf(a, c);null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}function hf(a, b) {
  var c = a.alternate;null !== c && b === c.updateQueue && (b = a.updateQueue = cf(b));return b;
}
function jf(a, b, c, d, e, f) {
  switch (c.tag) {case 1:
      return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;case 3:
      a.effectTag = a.effectTag & -1025 | 64;case 0:
      a = c.payload;e = "function" === typeof a ? a.call(f, d, e) : a;if (null === e || void 0 === e) break;return n({}, d, e);case 2:
      af = !0;}return d;
}
function kf(a, b, c, d, e) {
  af = !1;b = hf(a, b);for (var f = b.baseState, g = null, h = 0, k = b.firstUpdate, l = f; null !== k;) {
    var m = k.expirationTime;if (m > e) {
      if (null === g && (g = k, f = l), 0 === h || h > m) h = m;
    } else l = jf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k));k = k.next;
  }m = null;for (k = b.firstCapturedUpdate; null !== k;) {
    var r = k.expirationTime;if (r > e) {
      if (null === m && (m = k, null === g && (f = l)), 0 === h || h > r) h = r;
    } else l = jf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k));k = k.next;
  }null === g && (b.lastUpdate = null);null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;null === g && null === m && (f = l);b.baseState = f;b.firstUpdate = g;b.firstCapturedUpdate = m;a.expirationTime = h;a.memoizedState = l;
}
function lf(a, b, c) {
  null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);mf(b.firstEffect, c);b.firstEffect = b.lastEffect = null;mf(b.firstCapturedEffect, c);b.firstCapturedEffect = b.lastCapturedEffect = null;
}function mf(a, b) {
  for (; null !== a;) {
    var c = a.callback;if (null !== c) {
      a.callback = null;var d = b;"function" !== typeof c ? t("191", c) : void 0;c.call(d);
    }a = a.nextEffect;
  }
}
function nf(a, b) {
  return { value: a, source: b, stack: mc(b) };
}var of = { current: null },
    pf = null,
    qf = null,
    rf = null;function sf(a, b) {
  var c = a.type._context;H(of, c._currentValue, a);c._currentValue = b;
}function tf(a) {
  var b = of.current;G(of, a);a.type._context._currentValue = b;
}function uf(a) {
  pf = a;rf = qf = null;a.firstContextDependency = null;
}
function vf(a, b) {
  if (rf !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) rf = a, b = 1073741823;b = { context: a, observedBits: b, next: null };null === qf ? (null === pf ? t("277") : void 0, pf.firstContextDependency = qf = b) : qf = qf.next = b;
  }return a._currentValue;
}var wf = {},
    L = { current: wf },
    xf = { current: wf },
    yf = { current: wf };function zf(a) {
  a === wf ? t("174") : void 0;return a;
}
function Af(a, b) {
  H(yf, b, a);H(xf, a, a);H(L, wf, a);var c = b.nodeType;switch (c) {case 9:case 11:
      b = (b = b.documentElement) ? b.namespaceURI : le(null, "");break;default:
      c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = le(b, c);}G(L, a);H(L, b, a);
}function Bf(a) {
  G(L, a);G(xf, a);G(yf, a);
}function Cf(a) {
  zf(yf.current);var b = zf(L.current);var c = le(b, a.type);b !== c && (H(xf, a, a), H(L, c, a));
}function Df(a) {
  xf.current === a && (G(L, a), G(xf, a));
}var Ef = new aa.Component().refs;
function Ff(a, b, c, d) {
  b = a.memoizedState;c = c(d, b);c = null === c || void 0 === c ? b : n({}, b, c);a.memoizedState = c;d = a.updateQueue;null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var Jf = { isMounted: function isMounted(a) {
    return (a = a._reactInternalFiber) ? 2 === jd(a) : !1;
  }, enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternalFiber;var d = Gf();d = Hf(d, a);var e = df(d);e.payload = b;void 0 !== c && null !== c && (e.callback = c);ff(a, e);If(a, d);
  }, enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternalFiber;var d = Gf();d = Hf(d, a);var e = df(d);e.tag = 1;e.payload = b;void 0 !== c && null !== c && (e.callback = c);ff(a, e);If(a, d);
  }, enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternalFiber;var c = Gf();c = Hf(c, a);var d = df(c);d.tag = 2;void 0 !== b && null !== b && (d.callback = b);ff(a, d);If(a, c);
  } };function Kf(a, b, c, d, e, f, g) {
  a = a.stateNode;return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !id(c, d) || !id(e, f) : !0;
}function Lf(a, b, c, d) {
  a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && Jf.enqueueReplaceState(b, b.state, null);
}
function Mf(a, b, c, d) {
  var e = a.stateNode,
      f = K(b) ? Ge : I.current;e.props = c;e.state = a.memoizedState;e.refs = Ef;e.context = He(a, f);f = a.updateQueue;null !== f && (kf(a, f, c, e, d), e.state = a.memoizedState);f = b.getDerivedStateFromProps;"function" === typeof f && (Ff(a, b, f, c), e.state = a.memoizedState);"function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (kf(a, f, c, e, d), e.state = a.memoizedState));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
}var Nf = Array.isArray;
function Of(a, b, c) {
  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    if (c._owner) {
      c = c._owner;var d = void 0;c && (2 !== c.tag && 3 !== c.tag ? t("110") : void 0, d = c.stateNode);d ? void 0 : t("147", a);var e = "" + a;if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {
        var b = d.refs;b === Ef && (b = d.refs = {});null === a ? delete b[e] : b[e] = a;
      };b._stringRef = e;return b;
    }"string" !== typeof a ? t("284") : void 0;c._owner ? void 0 : t("254", a);
  }return a;
}
function Pf(a, b) {
  "textarea" !== a.type && t("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function Qf(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
    }
  }function c(c, d) {
    if (!a) return null;for (; null !== d;) {
      b(c, d), d = d.sibling;
    }return null;
  }function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }return a;
  }function e(a, b, c) {
    a = Ue(a, b, c);a.index = 0;a.sibling = null;return a;
  }function f(b, c, d) {
    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
  }function g(b) {
    a && null === b.alternate && (b.effectTag = 2);return b;
  }function h(a, b, c, d) {
    if (null === b || 8 !== b.tag) return b = Xe(c, a.mode, d), b.return = a, b;b = e(b, c, d);b.return = a;return b;
  }function k(a, b, c, d) {
    if (null !== b && b.type === c.type) return d = e(b, c.props, d), d.ref = Of(a, b, c), d.return = a, d;d = Ve(c, a.mode, d);d.ref = Of(a, b, c);d.return = a;return d;
  }function l(a, b, c, d) {
    if (null === b || 6 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Ye(c, a.mode, d), b.return = a, b;b = e(b, c.children || [], d);b.return = a;return b;
  }function m(a, b, c, d, f) {
    if (null === b || 9 !== b.tag) return b = We(c, a.mode, d, f), b.return = a, b;b = e(b, c, d);b.return = a;return b;
  }function r(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Xe("" + b, a.mode, c), b.return = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
      switch (b.$$typeof) {case $b:
          return c = Ve(b, a.mode, c), c.ref = Of(a, null, b), c.return = a, c;case ac:
          return b = Ye(b, a.mode, c), b.return = a, b;}if (Nf(b) || kc(b)) return b = We(b, a.mode, c, null), b.return = a, b;Pf(a, b);
    }return null;
  }function A(a, b, c, d) {
    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
      switch (c.$$typeof) {case $b:
          return c.key === e ? c.type === bc ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case ac:
          return c.key === e ? l(a, b, c, d) : null;}if (Nf(c) || kc(c)) return null !== e ? null : m(a, b, c, d, null);Pf(a, c);
    }return null;
  }function S(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
    if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
      switch (d.$$typeof) {case $b:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === bc ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);case ac:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);}if (Nf(d) || kc(d)) return a = a.get(c) || null, m(b, a, d, e, null);Pf(b, d);
    }return null;
  }function B(e, g, h, k) {
    for (var l = null, m = null, p = g, u = g = 0, q = null; null !== p && u < h.length; u++) {
      p.index > u ? (q = p, p = null) : q = p.sibling;var v = A(e, p, h[u], k);if (null === v) {
        null === p && (p = q);break;
      }a && p && null === v.alternate && b(e, p);g = f(v, g, u);null === m ? l = v : m.sibling = v;m = v;p = q;
    }if (u === h.length) return c(e, p), l;if (null === p) {
      for (; u < h.length; u++) {
        if (p = r(e, h[u], k)) g = f(p, g, u), null === m ? l = p : m.sibling = p, m = p;
      }return l;
    }for (p = d(e, p); u < h.length; u++) {
      if (q = S(p, e, u, h[u], k)) a && null !== q.alternate && p.delete(null === q.key ? u : q.key), g = f(q, g, u), null === m ? l = q : m.sibling = q, m = q;
    }a && p.forEach(function (a) {
      return b(e, a);
    });return l;
  }function P(e, g, h, k) {
    var l = kc(h);"function" !== typeof l ? t("150") : void 0;h = l.call(h);null == h ? t("151") : void 0;for (var m = l = null, p = g, u = g = 0, q = null, v = h.next(); null !== p && !v.done; u++, v = h.next()) {
      p.index > u ? (q = p, p = null) : q = p.sibling;var x = A(e, p, v.value, k);if (null === x) {
        p || (p = q);break;
      }a && p && null === x.alternate && b(e, p);g = f(x, g, u);null === m ? l = x : m.sibling = x;m = x;p = q;
    }if (v.done) return c(e, p), l;if (null === p) {
      for (; !v.done; u++, v = h.next()) {
        v = r(e, v.value, k), null !== v && (g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
      }return l;
    }for (p = d(e, p); !v.done; u++, v = h.next()) {
      v = S(p, e, u, v.value, k), null !== v && (a && null !== v.alternate && p.delete(null === v.key ? u : v.key), g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
    }a && p.forEach(function (a) {
      return b(e, a);
    });return l;
  }return function (a, d, f, h) {
    var k = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && f.type === bc && null === f.key;k && (f = f.props.children);var l = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f;if (l) switch (f.$$typeof) {case $b:
        a: {
          l = f.key;for (k = d; null !== k;) {
            if (k.key === l) {
              if (9 === k.tag ? f.type === bc : k.type === f.type) {
                c(a, k.sibling);d = e(k, f.type === bc ? f.props.children : f.props, h);d.ref = Of(a, k, f);d.return = a;a = d;break a;
              } else {
                c(a, k);break;
              }
            } else b(a, k);k = k.sibling;
          }f.type === bc ? (d = We(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ve(f, a.mode, h), h.ref = Of(a, d, f), h.return = a, a = h);
        }return g(a);case ac:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (6 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);d = e(d, f.children || [], h);d.return = a;a = d;break a;
              } else {
                c(a, d);break;
              }
            } else b(a, d);d = d.sibling;
          }d = Ye(f, a.mode, h);d.return = a;a = d;
        }return g(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 8 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = Xe(f, a.mode, h), d.return = a, a = d), g(a);if (Nf(f)) return B(a, d, f, h);if (kc(f)) return P(a, d, f, h);l && Pf(a, f);if ("undefined" === typeof f && !k) switch (a.tag) {case 2:case 3:case 0:
        h = a.type, t("152", h.displayName || h.name || "Component");}return c(a, d);
  };
}var Rf = Qf(!0),
    Sf = Qf(!1),
    Tf = null,
    Uf = null,
    Vf = !1;function Wf(a, b) {
  var c = new Se(7, null, null, 0);c.type = "DELETED";c.stateNode = b;c.return = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Xf(a, b) {
  switch (a.tag) {case 7:
      var c = a.type;b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;return null !== b ? (a.stateNode = b, !0) : !1;case 8:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;default:
      return !1;}
}function Yf(a) {
  if (Vf) {
    var b = Uf;if (b) {
      var c = b;if (!Xf(a, b)) {
        b = Be(c);if (!b || !Xf(a, b)) {
          a.effectTag |= 2;Vf = !1;Tf = a;return;
        }Wf(Tf, c);
      }Tf = a;Uf = Ce(b);
    } else a.effectTag |= 2, Vf = !1, Tf = a;
  }
}
function Zf(a) {
  for (a = a.return; null !== a && 7 !== a.tag && 5 !== a.tag;) {
    a = a.return;
  }Tf = a;
}function $f(a) {
  if (a !== Tf) return !1;if (!Vf) return Zf(a), Vf = !0, !1;var b = a.type;if (7 !== a.tag || "head" !== b && "body" !== b && !Ae(b, a.memoizedProps)) for (b = Uf; b;) {
    Wf(a, b), b = Be(b);
  }Zf(a);Uf = Tf ? Be(a.stateNode) : null;return !0;
}function ag() {
  Uf = Tf = null;Vf = !1;
}
function bg(a) {
  switch (a._reactStatus) {case 1:
      return a._reactResult;case 2:
      throw a._reactResult;case 0:
      throw a;default:
      throw a._reactStatus = 0, a.then(function (b) {
        if (0 === a._reactStatus) {
          a._reactStatus = 1;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
            var c = b.default;b = void 0 !== c && null !== c ? c : b;
          }a._reactResult = b;
        }
      }, function (b) {
        0 === a._reactStatus && (a._reactStatus = 2, a._reactResult = b);
      }), a;}
}var cg = Yb.ReactCurrentOwner;function M(a, b, c, d) {
  b.child = null === a ? Sf(b, null, c, d) : Rf(b, a.child, c, d);
}
function dg(a, b, c, d, e) {
  c = c.render;var f = b.ref;if (!J.current && b.memoizedProps === d && f === (null !== a ? a.ref : null)) return eg(a, b, e);c = c(d, f);M(a, b, c, e);b.memoizedProps = d;return b.child;
}function fg(a, b) {
  var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}function gg(a, b, c, d, e) {
  var f = K(c) ? Ge : I.current;f = He(b, f);uf(b, e);c = c(d, f);b.effectTag |= 1;M(a, b, c, e);b.memoizedProps = d;return b.child;
}
function hg(a, b, c, d, e) {
  if (K(c)) {
    var f = !0;Me(b);
  } else f = !1;uf(b, e);if (null === a) {
    if (null === b.stateNode) {
      var g = K(c) ? Ge : I.current,
          h = c.contextTypes,
          k = null !== h && void 0 !== h;h = k ? He(b, g) : Fe;var l = new c(d, h);b.memoizedState = null !== l.state && void 0 !== l.state ? l.state : null;l.updater = Jf;b.stateNode = l;l._reactInternalFiber = b;k && (k = b.stateNode, k.__reactInternalMemoizedUnmaskedChildContext = g, k.__reactInternalMemoizedMaskedChildContext = h);Mf(b, c, d, e);d = !0;
    } else {
      g = b.stateNode;h = b.memoizedProps;g.props = h;var m = g.context;
      k = K(c) ? Ge : I.current;k = He(b, k);var r = c.getDerivedStateFromProps;(l = "function" === typeof r || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || m !== k) && Lf(b, g, d, k);af = !1;var A = b.memoizedState;m = g.state = A;var S = b.updateQueue;null !== S && (kf(b, S, d, g, e), m = b.memoizedState);h !== d || A !== m || J.current || af ? ("function" === typeof r && (Ff(b, c, r, d), m = b.memoizedState), (h = af || Kf(b, c, h, d, A, m, k)) ? (l || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    }
  } else g = b.stateNode, h = b.memoizedProps, g.props = h, m = g.context, k = K(c) ? Ge : I.current, k = He(b, k), r = c.getDerivedStateFromProps, (l = "function" === typeof r || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || m !== k) && Lf(b, g, d, k), af = !1, m = b.memoizedState, A = g.state = m, S = b.updateQueue, null !== S && (kf(b, S, d, g, e), A = b.memoizedState), h !== d || m !== A || J.current || af ? ("function" === typeof r && (Ff(b, c, r, d), A = b.memoizedState), (r = af || Kf(b, c, h, d, m, A, k)) ? (l || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, A, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, A, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && m === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && m === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = A), g.props = d, g.state = A, g.context = k, d = r) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && m === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && m === a.memoizedState || (b.effectTag |= 256), d = !1);return ig(a, b, c, d, f, e);
}
function ig(a, b, c, d, e, f) {
  fg(a, b);var g = 0 !== (b.effectTag & 64);if (!d && !g) return e && Ne(b, c, !1), eg(a, b, f);d = b.stateNode;cg.current = b;var h = g ? null : d.render();b.effectTag |= 1;null !== a && g && (M(a, b, null, f), b.child = null);M(a, b, h, f);b.memoizedState = d.state;b.memoizedProps = d.props;e && Ne(b, c, !0);return b.child;
}function jg(a) {
  var b = a.stateNode;b.pendingContext ? Ke(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ke(a, b.context, !1);Af(a, b.containerInfo);
}
function ng(a, b) {
  if (a && a.defaultProps) {
    b = n({}, b);a = a.defaultProps;for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }
  }return b;
}
function og(a, b, c, d) {
  null !== a ? t("155") : void 0;var e = b.pendingProps;if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c && "function" === typeof c.then) {
    c = bg(c);var f = c;f = "function" === typeof f ? Te(f) ? 3 : 1 : void 0 !== f && null !== f && f.$$typeof ? 14 : 4;f = b.tag = f;var g = ng(c, e);switch (f) {case 1:
        return gg(a, b, c, g, d);case 3:
        return hg(a, b, c, g, d);case 14:
        return dg(a, b, c, g, d);default:
        t("283", c);}
  }f = He(b, I.current);uf(b, d);f = c(e, f);b.effectTag |= 1;if ("object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) {
    b.tag = 2;K(c) ? (g = !0, Me(b)) : g = !1;b.memoizedState = null !== f.state && void 0 !== f.state ? f.state : null;var h = c.getDerivedStateFromProps;"function" === typeof h && Ff(b, c, h, e);f.updater = Jf;b.stateNode = f;f._reactInternalFiber = b;Mf(b, c, e, d);return ig(a, b, c, !0, g, d);
  }b.tag = 0;M(a, b, f, d);b.memoizedProps = e;return b.child;
}
function eg(a, b, c) {
  null !== a && (b.firstContextDependency = a.firstContextDependency);var d = b.childExpirationTime;if (0 === d || d > c) return null;null !== a && b.child !== a.child ? t("153") : void 0;if (null !== b.child) {
    a = b.child;c = Ue(a, a.pendingProps, a.expirationTime);b.child = c;for (c.return = b; null !== a.sibling;) {
      a = a.sibling, c = c.sibling = Ue(a, a.pendingProps, a.expirationTime), c.return = b;
    }c.sibling = null;
  }return b.child;
}
function pg(a, b, c) {
  var d = b.expirationTime;if (!J.current && (0 === d || d > c)) {
    switch (b.tag) {case 5:
        jg(b);ag();break;case 7:
        Cf(b);break;case 2:
        K(b.type) && Me(b);break;case 3:
        K(b.type._reactResult) && Me(b);break;case 6:
        Af(b, b.stateNode.containerInfo);break;case 12:
        sf(b, b.memoizedProps.value);}return eg(a, b, c);
  }b.expirationTime = 0;switch (b.tag) {case 4:
      return og(a, b, b.type, c);case 0:
      return gg(a, b, b.type, b.pendingProps, c);case 1:
      var e = b.type._reactResult;d = b.pendingProps;a = gg(a, b, e, ng(e, d), c);b.memoizedProps = d;return a;
    case 2:
      return hg(a, b, b.type, b.pendingProps, c);case 3:
      return e = b.type._reactResult, d = b.pendingProps, a = hg(a, b, e, ng(e, d), c), b.memoizedProps = d, a;case 5:
      jg(b);d = b.updateQueue;null === d ? t("282") : void 0;e = b.memoizedState;e = null !== e ? e.element : null;kf(b, d, b.pendingProps, null, c);d = b.memoizedState.element;if (d === e) ag(), b = eg(a, b, c);else {
        e = b.stateNode;if (e = (null === a || null === a.child) && e.hydrate) Uf = Ce(b.stateNode.containerInfo), Tf = b, e = Vf = !0;e ? (b.effectTag |= 2, b.child = Sf(b, null, d, c)) : (M(a, b, d, c), ag());b = b.child;
      }return b;
    case 7:
      Cf(b);null === a && Yf(b);d = b.type;e = b.pendingProps;var f = null !== a ? a.memoizedProps : null,
          g = e.children;Ae(d, e) ? g = null : null !== f && Ae(d, f) && (b.effectTag |= 16);fg(a, b);1073741823 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = 1073741823, b.memoizedProps = e, b = null) : (M(a, b, g, c), b.memoizedProps = e, b = b.child);return b;case 8:
      return null === a && Yf(b), b.memoizedProps = b.pendingProps, null;case 16:
      return null;case 6:
      return Af(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Rf(b, null, d, c) : M(a, b, d, c), b.memoizedProps = d, b.child;case 13:
      return dg(a, b, b.type, b.pendingProps, c);case 14:
      return e = b.type._reactResult, d = b.pendingProps, a = dg(a, b, e, ng(e, d), c), b.memoizedProps = d, a;case 9:
      return d = b.pendingProps, M(a, b, d, c), b.memoizedProps = d, b.child;case 10:
      return d = b.pendingProps.children, M(a, b, d, c), b.memoizedProps = d, b.child;case 15:
      return d = b.pendingProps, M(a, b, d.children, c), b.memoizedProps = d, b.child;case 12:
      a: {
        d = b.type._context;e = b.pendingProps;g = b.memoizedProps;f = e.value;b.memoizedProps = e;sf(b, f);if (null !== g) {
          var h = g.value;
          f = h === f && (0 !== h || 1 / h === 1 / f) || h !== h && f !== f ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;if (0 === f) {
            if (g.children === e.children && !J.current) {
              b = eg(a, b, c);break a;
            }
          } else for (g = b.child, null !== g && (g.return = b); null !== g;) {
            h = g.firstContextDependency;if (null !== h) {
              do {
                if (h.context === d && 0 !== (h.observedBits & f)) {
                  if (2 === g.tag || 3 === g.tag) {
                    var k = df(c);k.tag = 2;ff(g, k);
                  }if (0 === g.expirationTime || g.expirationTime > c) g.expirationTime = c;k = g.alternate;null !== k && (0 === k.expirationTime || k.expirationTime > c) && (k.expirationTime = c);for (var l = g.return; null !== l;) {
                    k = l.alternate;if (0 === l.childExpirationTime || l.childExpirationTime > c) l.childExpirationTime = c, null !== k && (0 === k.childExpirationTime || k.childExpirationTime > c) && (k.childExpirationTime = c);else if (null !== k && (0 === k.childExpirationTime || k.childExpirationTime > c)) k.childExpirationTime = c;else break;l = l.return;
                  }
                }k = g.child;h = h.next;
              } while (null !== h);
            } else k = 12 === g.tag ? g.type === b.type ? null : g.child : g.child;if (null !== k) k.return = g;else for (k = g; null !== k;) {
              if (k === b) {
                k = null;break;
              }g = k.sibling;if (null !== g) {
                g.return = k.return;k = g;break;
              }k = k.return;
            }g = k;
          }
        }M(a, b, e.children, c);b = b.child;
      }return b;case 11:
      return f = b.type, d = b.pendingProps, e = d.children, uf(b, c), f = vf(f, d.unstable_observedBits), e = e(f), b.effectTag |= 1, M(a, b, e, c), b.memoizedProps = d, b.child;default:
      t("156");}
}function qg(a) {
  a.effectTag |= 4;
}var rg = void 0,
    sg = void 0,
    tg = void 0;rg = function rg() {};
sg = function sg(a, b, c, d, e) {
  var f = a.memoizedProps;if (f !== d) {
    var g = b.stateNode;zf(L.current);a = null;switch (c) {case "input":
        f = zc(g, f);d = zc(g, d);a = [];break;case "option":
        f = de(g, f);d = de(g, d);a = [];break;case "select":
        f = n({}, f, { value: void 0 });d = n({}, d, { value: void 0 });a = [];break;case "textarea":
        f = fe(g, f);d = fe(g, d);a = [];break;default:
        "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = we);}te(c, d);g = c = void 0;var h = null;for (c in f) {
      if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) if ("style" === c) {
        var k = f[c];for (g in k) {
          k.hasOwnProperty(g) && (h || (h = {}), h[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (sa.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
    }for (c in d) {
      var l = d[c];k = null != f ? f[c] : void 0;if (d.hasOwnProperty(c) && l !== k && (null != l || null != k)) if ("style" === c) {
        if (k) {
          for (g in k) {
            !k.hasOwnProperty(g) || l && l.hasOwnProperty(g) || (h || (h = {}), h[g] = "");
          }for (g in l) {
            l.hasOwnProperty(g) && k[g] !== l[g] && (h || (h = {}), h[g] = l[g]);
          }
        } else h || (a || (a = []), a.push(c, h)), h = l;
      } else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, k = k ? k.__html : void 0, null != l && k !== l && (a = a || []).push(c, "" + l)) : "children" === c ? k === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (sa.hasOwnProperty(c) ? (null != l && ve(e, c), a || k === l || (a = [])) : (a = a || []).push(c, l));
    }h && (a = a || []).push("style", h);e = a;(b.updateQueue = e) && qg(b);
  }
};tg = function tg(a, b, c, d) {
  c !== d && qg(b);
};
function ug(a, b) {
  var c = b.source,
      d = b.stack;null === d && null !== c && (d = mc(c));null !== c && lc(c.type);b = b.value;null !== a && 2 === a.tag && lc(a.type);try {
    console.error(b);
  } catch (e) {
    setTimeout(function () {
      throw e;
    });
  }
}function vg(a) {
  var b = a.ref;if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    wg(a, c);
  } else b.current = null;
}
function xg(a) {
  "function" === typeof Pe && Pe(a);switch (a.tag) {case 2:case 3:
      vg(a);var b = a.stateNode;if ("function" === typeof b.componentWillUnmount) try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
      } catch (c) {
        wg(a, c);
      }break;case 7:
      vg(a);break;case 6:
      yg(a);}
}function zg(a) {
  return 7 === a.tag || 5 === a.tag || 6 === a.tag;
}
function Ag(a) {
  a: {
    for (var b = a.return; null !== b;) {
      if (zg(b)) {
        var c = b;break a;
      }b = b.return;
    }t("160");c = void 0;
  }var d = b = void 0;switch (c.tag) {case 7:
      b = c.stateNode;d = !1;break;case 5:
      b = c.stateNode.containerInfo;d = !0;break;case 6:
      b = c.stateNode.containerInfo;d = !0;break;default:
      t("161");}c.effectTag & 16 && (oe(b, ""), c.effectTag &= -17);a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c.return || zg(c.return)) {
        c = null;break a;
      }c = c.return;
    }c.sibling.return = c.return;for (c = c.sibling; 7 !== c.tag && 8 !== c.tag;) {
      if (c.effectTag & 2) continue b;
      if (null === c.child || 6 === c.tag) continue b;else c.child.return = c, c = c.child;
    }if (!(c.effectTag & 2)) {
      c = c.stateNode;break a;
    }
  }for (var e = a;;) {
    if (7 === e.tag || 8 === e.tag) {
      if (c) {
        if (d) {
          var f = b,
              g = e.stateNode,
              h = c;8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
        } else b.insertBefore(e.stateNode, c);
      } else d ? (f = b, g = e.stateNode, 8 === f.nodeType ? (h = f.parentNode, h.insertBefore(g, f)) : (h = f, h.appendChild(g)), null === h.onclick && (h.onclick = we)) : b.appendChild(e.stateNode);
    } else if (6 !== e.tag && null !== e.child) {
      e.child.return = e;e = e.child;continue;
    }if (e === a) break;for (; null === e.sibling;) {
      if (null === e.return || e.return === a) return;e = e.return;
    }e.sibling.return = e.return;e = e.sibling;
  }
}
function yg(a) {
  for (var b = a, c = !1, d = void 0, e = void 0;;) {
    if (!c) {
      c = b.return;a: for (;;) {
        null === c ? t("160") : void 0;switch (c.tag) {case 7:
            d = c.stateNode;e = !1;break a;case 5:
            d = c.stateNode.containerInfo;e = !0;break a;case 6:
            d = c.stateNode.containerInfo;e = !0;break a;}c = c.return;
      }c = !0;
    }if (7 === b.tag || 8 === b.tag) {
      a: for (var f = b, g = f;;) {
        if (xg(g), null !== g.child && 6 !== g.tag) g.child.return = g, g = g.child;else {
          if (g === f) break;for (; null === g.sibling;) {
            if (null === g.return || g.return === f) break a;g = g.return;
          }g.sibling.return = g.return;g = g.sibling;
        }
      }e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
    } else if (6 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : xg(b), null !== b.child) {
      b.child.return = b;b = b.child;continue;
    }if (b === a) break;for (; null === b.sibling;) {
      if (null === b.return || b.return === a) return;b = b.return;6 === b.tag && (c = !1);
    }b.sibling.return = b.return;b = b.sibling;
  }
}
function Bg(a, b) {
  switch (b.tag) {case 2:case 3:
      break;case 7:
      var c = b.stateNode;if (null != c) {
        var d = b.memoizedProps,
            e = null !== a ? a.memoizedProps : d;a = b.type;var f = b.updateQueue;b.updateQueue = null;if (null !== f) {
          c[Ja] = d;"input" === a && "radio" === d.type && null != d.name && Cc(c, d);ue(a, e);b = ue(a, d);for (e = 0; e < f.length; e += 2) {
            var g = f[e],
                h = f[e + 1];"style" === g ? re(c, h) : "dangerouslySetInnerHTML" === g ? ne(c, h) : "children" === g ? oe(c, h) : xc(c, g, h, b);
          }switch (a) {case "input":
              Dc(c, d);break;case "textarea":
              he(c, d);break;case "select":
              a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? ee(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? ee(c, !!d.multiple, d.defaultValue, !0) : ee(c, !!d.multiple, d.multiple ? [] : "", !1));}
        }
      }break;case 8:
      null === b.stateNode ? t("162") : void 0;b.stateNode.nodeValue = b.memoizedProps;break;case 5:
      break;case 15:
      break;case 16:
      break;default:
      t("163");}
}function Cg(a, b, c) {
  c = df(c);c.tag = 3;c.payload = { element: null };var d = b.value;c.callback = function () {
    Dg(d);ug(a, b);
  };return c;
}
function Eg(a, b, c) {
  c = df(c);c.tag = 3;var d = a.stateNode;null !== d && "function" === typeof d.componentDidCatch && (c.callback = function () {
    null === Fg ? Fg = new Set([this]) : Fg.add(this);var c = b.value,
        d = b.stack;ug(a, b);this.componentDidCatch(c, { componentStack: null !== d ? d : "" });
  });return c;
}
function Gg(a) {
  switch (a.tag) {case 2:
      K(a.type) && Ie(a);var b = a.effectTag;return b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 3:
      return K(a.type._reactResult) && Ie(a), b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 5:
      return Bf(a), Je(a), b = a.effectTag, 0 !== (b & 64) ? t("285") : void 0, a.effectTag = b & -1025 | 64, a;case 7:
      return Df(a), null;case 16:
      return b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 6:
      return Bf(a), null;case 12:
      return tf(a), null;default:
      return null;}
}
var Hg = { readContext: vf },
    Ig = Yb.ReactCurrentOwner,
    Jg = 0,
    Kg = 0,
    Lg = !1,
    N = null,
    Mg = null,
    O = 0,
    Ng = !1,
    Q = null,
    Og = !1,
    Fg = null;function Pg() {
  if (null !== N) for (var a = N.return; null !== a;) {
    var b = a;switch (b.tag) {case 2:
        var c = b.type.childContextTypes;null !== c && void 0 !== c && Ie(b);break;case 3:
        c = b.type._reactResult.childContextTypes;null !== c && void 0 !== c && Ie(b);break;case 5:
        Bf(b);Je(b);break;case 7:
        Df(b);break;case 6:
        Bf(b);break;case 12:
        tf(b);}a = a.return;
  }Mg = null;O = 0;Ng = !1;N = null;
}
function Qg(a) {
  for (;;) {
    var b = a.alternate,
        c = a.return,
        d = a.sibling;if (0 === (a.effectTag & 512)) {
      var e = b;b = a;var f = b.pendingProps;switch (b.tag) {case 0:case 1:
          break;case 2:
          K(b.type) && Ie(b);break;case 3:
          K(b.type._reactResult) && Ie(b);break;case 5:
          Bf(b);Je(b);f = b.stateNode;f.pendingContext && (f.context = f.pendingContext, f.pendingContext = null);if (null === e || null === e.child) $f(b), b.effectTag &= -3;rg(b);break;case 7:
          Df(b);var g = zf(yf.current),
              h = b.type;if (null !== e && null != b.stateNode) sg(e, b, h, f, g), e.ref !== b.ref && (b.effectTag |= 128);else if (f) {
            var k = zf(L.current);if ($f(b)) {
              f = b;e = f.stateNode;var l = f.type,
                  m = f.memoizedProps,
                  r = g;e[Ia] = f;e[Ja] = m;h = void 0;g = l;switch (g) {case "iframe":case "object":
                  F("load", e);break;case "video":case "audio":
                  for (l = 0; l < fb.length; l++) {
                    F(fb[l], e);
                  }break;case "source":
                  F("error", e);break;case "img":case "image":case "link":
                  F("error", e);F("load", e);break;case "form":
                  F("reset", e);F("submit", e);break;case "details":
                  F("toggle", e);break;case "input":
                  Bc(e, m);F("invalid", e);ve(r, "onChange");break;case "select":
                  e._wrapperState = { wasMultiple: !!m.multiple };F("invalid", e);ve(r, "onChange");break;case "textarea":
                  ge(e, m), F("invalid", e), ve(r, "onChange");}te(g, m);l = null;for (h in m) {
                m.hasOwnProperty(h) && (k = m[h], "children" === h ? "string" === typeof k ? e.textContent !== k && (l = ["children", k]) : "number" === typeof k && e.textContent !== "" + k && (l = ["children", "" + k]) : sa.hasOwnProperty(h) && null != k && ve(r, h));
              }switch (g) {case "input":
                  Wb(e);Fc(e, m, !0);break;case "textarea":
                  Wb(e);ie(e, m);break;case "select":case "option":
                  break;default:
                  "function" === typeof m.onClick && (e.onclick = we);}h = l;f.updateQueue = h;f = null !== h ? !0 : !1;f && qg(b);
            } else {
              m = b;e = h;r = f;l = 9 === g.nodeType ? g : g.ownerDocument;k === je.html && (k = ke(e));k === je.html ? "script" === e ? (e = l.createElement("div"), e.innerHTML = "<script>\x3c/script>", l = e.removeChild(e.firstChild)) : "string" === typeof r.is ? l = l.createElement(e, { is: r.is }) : (l = l.createElement(e), "select" === e && r.multiple && (l.multiple = !0)) : l = l.createElementNS(k, e);e = l;e[Ia] = m;e[Ja] = f;a: for (m = e, r = b, l = r.child; null !== l;) {
                if (7 === l.tag || 8 === l.tag) m.appendChild(l.stateNode);else if (6 !== l.tag && null !== l.child) {
                  l.child.return = l;l = l.child;continue;
                }if (l === r) break;for (; null === l.sibling;) {
                  if (null === l.return || l.return === r) break a;l = l.return;
                }l.sibling.return = l.return;l = l.sibling;
              }r = e;l = h;m = f;var A = g,
                  S = ue(l, m);switch (l) {case "iframe":case "object":
                  F("load", r);g = m;break;case "video":case "audio":
                  for (g = 0; g < fb.length; g++) {
                    F(fb[g], r);
                  }g = m;break;case "source":
                  F("error", r);g = m;break;case "img":case "image":case "link":
                  F("error", r);F("load", r);g = m;break;case "form":
                  F("reset", r);F("submit", r);g = m;break;case "details":
                  F("toggle", r);g = m;break;case "input":
                  Bc(r, m);g = zc(r, m);F("invalid", r);ve(A, "onChange");break;case "option":
                  g = de(r, m);break;case "select":
                  r._wrapperState = { wasMultiple: !!m.multiple };g = n({}, m, { value: void 0 });F("invalid", r);ve(A, "onChange");break;case "textarea":
                  ge(r, m);g = fe(r, m);F("invalid", r);ve(A, "onChange");break;default:
                  g = m;}te(l, g);k = void 0;var B = l,
                  P = r,
                  v = g;for (k in v) {
                if (v.hasOwnProperty(k)) {
                  var p = v[k];"style" === k ? re(P, p) : "dangerouslySetInnerHTML" === k ? (p = p ? p.__html : void 0, null != p && ne(P, p)) : "children" === k ? "string" === typeof p ? ("textarea" !== B || "" !== p) && oe(P, p) : "number" === typeof p && oe(P, "" + p) : "suppressContentEditableWarning" !== k && "suppressHydrationWarning" !== k && "autoFocus" !== k && (sa.hasOwnProperty(k) ? null != p && ve(A, k) : null != p && xc(P, k, p, S));
                }
              }switch (l) {case "input":
                  Wb(r);Fc(r, m, !1);break;case "textarea":
                  Wb(r);ie(r, m);break;case "option":
                  null != m.value && r.setAttribute("value", "" + yc(m.value));break;case "select":
                  g = r;g.multiple = !!m.multiple;r = m.value;null != r ? ee(g, !!m.multiple, r, !1) : null != m.defaultValue && ee(g, !!m.multiple, m.defaultValue, !0);break;default:
                  "function" === typeof g.onClick && (r.onclick = we);}(f = ze(h, f)) && qg(b);b.stateNode = e;
            }null !== b.ref && (b.effectTag |= 128);
          } else null === b.stateNode ? t("166") : void 0;break;case 8:
          e && null != b.stateNode ? tg(e, b, e.memoizedProps, f) : ("string" !== typeof f && (null === b.stateNode ? t("166") : void 0), e = zf(yf.current), zf(L.current), $f(b) ? (f = b, h = f.stateNode, e = f.memoizedProps, h[Ia] = f, (f = h.nodeValue !== e) && qg(b)) : (h = b, f = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(f), f[Ia] = h, b.stateNode = f));break;case 13:case 14:
          break;case 16:
          break;case 9:
          break;case 10:
          break;case 15:
          break;case 6:
          Bf(b);rg(b);break;case 12:
          tf(b);break;case 11:
          break;case 4:
          t("167");default:
          t("156");}b = N = null;f = a;if (1073741823 === O || 1073741823 !== f.childExpirationTime) {
        h = 0;for (e = f.child; null !== e;) {
          g = e.expirationTime;m = e.childExpirationTime;if (0 === h || 0 !== g && g < h) h = g;if (0 === h || 0 !== m && m < h) h = m;e = e.sibling;
        }f.childExpirationTime = h;
      }if (null !== b) return b;null !== c && 0 === (c.effectTag & 512) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
    } else {
      a = Gg(a, O);if (null !== a) return a.effectTag &= 511, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 512);
    }if (null !== d) return d;if (null !== c) a = c;else break;
  }return null;
}function Rg(a) {
  var b = pg(a.alternate, a, O);null === b && (b = Qg(a));Ig.current = null;return b;
}
function Sg(a, b, c) {
  Lg ? t("243") : void 0;Lg = !0;Ig.currentDispatcher = Hg;var d = a.nextExpirationTimeToWorkOn;if (d !== O || a !== Mg || null === N) Pg(), Mg = a, O = d, N = Ue(Mg.current, null, O), a.pendingCommitExpirationTime = 0;var e = !1;do {
    try {
      if (b) for (; null !== N && !Tg();) {
        N = Rg(N);
      } else for (; null !== N;) {
        N = Rg(N);
      }
    } catch (r) {
      if (null === N) e = !0, Dg(r);else {
        null === N ? t("271") : void 0;var f = N,
            g = f.return;if (null === g) e = !0, Dg(r);else {
          a: {
            var h = g,
                k = f,
                l = r;g = O;k.effectTag |= 512;k.firstEffect = k.lastEffect = null;Ng = !0;l = nf(l, k);do {
              switch (h.tag) {case 5:
                  h.effectTag |= 1024;h.expirationTime = g;g = Cg(h, l, g);gf(h, g);break a;case 2:case 3:
                  k = l;var m = h.stateNode;if (0 === (h.effectTag & 64) && null !== m && "function" === typeof m.componentDidCatch && (null === Fg || !Fg.has(m))) {
                    h.effectTag |= 1024;h.expirationTime = g;g = Eg(h, k, g);gf(h, g);break a;
                  }}h = h.return;
            } while (null !== h);
          }N = Qg(f);continue;
        }
      }
    }break;
  } while (1);Lg = !1;rf = qf = pf = Ig.currentDispatcher = null;if (e) Mg = null, a.finishedWork = null;else if (null !== N) a.finishedWork = null;else {
    b = a.current.alternate;null === b ? t("281") : void 0;Mg = null;if (Ng) {
      e = a.latestPendingTime;
      f = a.latestSuspendedTime;g = a.latestPingedTime;if (0 !== e && e > d || 0 !== f && f > d || 0 !== g && g > d) {
        a.didError = !1;c = a.latestPingedTime;0 !== c && c <= d && (a.latestPingedTime = 0);c = a.earliestPendingTime;b = a.latestPendingTime;c === d ? a.earliestPendingTime = b === d ? a.latestPendingTime = 0 : b : b === d && (a.latestPendingTime = c);c = a.earliestSuspendedTime;b = a.latestSuspendedTime;0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = d : c > d ? a.earliestSuspendedTime = d : b < d && (a.latestSuspendedTime = d);$e(d, a);a.expirationTime = a.expirationTime;return;
      }if (!a.didError && !c) {
        a.didError = !0;a.nextExpirationTimeToWorkOn = d;d = a.expirationTime = 1;a.expirationTime = d;return;
      }
    }a.pendingCommitExpirationTime = d;a.finishedWork = b;
  }
}
function wg(a, b) {
  var c;a: {
    Lg && !Og ? t("263") : void 0;for (c = a.return; null !== c;) {
      switch (c.tag) {case 2:case 3:
          var d = c.stateNode;if ("function" === typeof c.type.getDerivedStateFromCatch || "function" === typeof d.componentDidCatch && (null === Fg || !Fg.has(d))) {
            a = nf(b, a);a = Eg(c, a, 1);ff(c, a);If(c, 1);c = void 0;break a;
          }break;case 5:
          a = nf(b, a);a = Cg(c, a, 1);ff(c, a);If(c, 1);c = void 0;break a;}c = c.return;
    }5 === a.tag && (c = nf(b, a), c = Cg(a, c, 1), ff(a, c), If(a, 1));c = void 0;
  }return c;
}
function Hf(a, b) {
  0 !== Kg ? a = Kg : Lg ? a = Og ? 1 : O : b.mode & 1 ? (a = Ug ? 2 + 10 * (((a - 2 + 15) / 10 | 0) + 1) : 2 + 25 * (((a - 2 + 500) / 25 | 0) + 1), null !== Mg && a === O && (a += 1)) : a = 1;Ug && (0 === Vg || a > Vg) && (Vg = a);return a;
}
function If(a, b) {
  a: {
    if (0 === a.expirationTime || a.expirationTime > b) a.expirationTime = b;var c = a.alternate;null !== c && (0 === c.expirationTime || c.expirationTime > b) && (c.expirationTime = b);var d = a.return;if (null === d && 5 === a.tag) a = a.stateNode;else {
      for (; null !== d;) {
        c = d.alternate;if (0 === d.childExpirationTime || d.childExpirationTime > b) d.childExpirationTime = b;null !== c && (0 === c.childExpirationTime || c.childExpirationTime > b) && (c.childExpirationTime = b);if (null === d.return && 5 === d.tag) {
          a = d.stateNode;break a;
        }d = d.return;
      }a = null;
    }
  }if (null !== a) {
    !Lg && 0 !== O && b < O && Pg();Ze(a, b);if (!Lg || Og || Mg !== a) {
      b = a;a = a.expirationTime;if (null === b.nextScheduledRoot) b.expirationTime = a, null === T ? (U = T = b, b.nextScheduledRoot = b) : (T = T.nextScheduledRoot = b, T.nextScheduledRoot = U);else if (c = b.expirationTime, 0 === c || a < c) b.expirationTime = a;V || (W ? Wg && (Y = b, Z = 1, Xg(b, 1, !0)) : 1 === a ? Yg(1, null) : Zg(b, a));
    }$g > ah && ($g = 0, t("185"));
  }
}function bh(a, b, c, d, e) {
  var f = Kg;Kg = 1;try {
    return a(b, c, d, e);
  } finally {
    Kg = f;
  }
}
var U = null,
    T = null,
    ch = 0,
    dh = void 0,
    V = !1,
    Y = null,
    Z = 0,
    Vg = 0,
    eh = !1,
    fh = !1,
    gh = null,
    hh = null,
    W = !1,
    Wg = !1,
    Ug = !1,
    ih = null,
    jh = ba.unstable_now(),
    kh = (jh / 10 | 0) + 2,
    lh = kh,
    ah = 50,
    $g = 0,
    mh = null,
    nh = 1;function oh() {
  kh = ((ba.unstable_now() - jh) / 10 | 0) + 2;
}function Zg(a, b) {
  if (0 !== ch) {
    if (b > ch) return;null !== dh && ba.unstable_cancelScheduledWork(dh);
  }ch = b;a = ba.unstable_now() - jh;dh = ba.unstable_scheduleWork(ph, { timeout: 10 * (b - 2) - a });
}function Gf() {
  if (V) return lh;qh();if (0 === Z || 1073741823 === Z) oh(), lh = kh;return lh;
}
function qh() {
  var a = 0,
      b = null;if (null !== T) for (var c = T, d = U; null !== d;) {
    var e = d.expirationTime;if (0 === e) {
      null === c || null === T ? t("244") : void 0;if (d === d.nextScheduledRoot) {
        U = T = d.nextScheduledRoot = null;break;
      } else if (d === U) U = e = d.nextScheduledRoot, T.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === T) {
        T = c;T.nextScheduledRoot = U;d.nextScheduledRoot = null;break;
      } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
    } else {
      if (0 === a || e < a) a = e, b = d;if (d === T) break;if (1 === a) break;
      c = d;d = d.nextScheduledRoot;
    }
  }Y = b;Z = a;
}function ph(a) {
  if (a.didTimeout && null !== U) {
    oh();var b = U;do {
      var c = b.expirationTime;0 !== c && kh >= c && (b.nextExpirationTimeToWorkOn = kh);b = b.nextScheduledRoot;
    } while (b !== U);
  }Yg(0, a);
}
function Yg(a, b) {
  hh = b;qh();if (null !== hh) for (oh(), lh = kh; null !== Y && 0 !== Z && (0 === a || a >= Z) && (!eh || kh >= Z);) {
    Xg(Y, Z, kh >= Z), qh(), oh(), lh = kh;
  } else for (; null !== Y && 0 !== Z && (0 === a || a >= Z);) {
    Xg(Y, Z, !0), qh();
  }null !== hh && (ch = 0, dh = null);0 !== Z && Zg(Y, Z);hh = null;eh = !1;$g = 0;mh = null;if (null !== ih) for (a = ih, ih = null, b = 0; b < a.length; b++) {
    var c = a[b];try {
      c._onComplete();
    } catch (d) {
      fh || (fh = !0, gh = d);
    }
  }if (fh) throw a = gh, gh = null, fh = !1, a;
}
function Xg(a, b, c) {
  V ? t("245") : void 0;V = !0;if (null === hh || c) {
    var d = a.finishedWork;null !== d ? rh(a, d, b) : (a.finishedWork = null, Sg(a, !1, c), d = a.finishedWork, null !== d && rh(a, d, b));
  } else d = a.finishedWork, null !== d ? rh(a, d, b) : (a.finishedWork = null, Sg(a, !0, c), d = a.finishedWork, null !== d && (Tg() ? a.finishedWork = d : rh(a, d, b)));V = !1;
}
function rh(a, b, c) {
  var d = a.firstBatch;if (null !== d && d._expirationTime <= c && (null === ih ? ih = [d] : ih.push(d), d._defer)) {
    a.finishedWork = b;a.expirationTime = 0;return;
  }a.finishedWork = null;a === mh ? $g++ : (mh = a, $g = 0);Og = Lg = !0;a.current === b ? t("177") : void 0;c = a.pendingCommitExpirationTime;0 === c ? t("261") : void 0;a.pendingCommitExpirationTime = 0;d = b.expirationTime;var e = b.childExpirationTime;d = 0 === d || 0 !== e && e < d ? e : d;a.didError = !1;0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0) : (e = a.latestPendingTime, 0 !== e && (e < d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime < d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? Ze(a, d) : d > a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, Ze(a, d)) : d < e && Ze(a, d));$e(0, a);Ig.current = null;1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;xe = Gd;e = Td();if (Ud(e)) {
    if ("selectionStart" in e) var f = { start: e.selectionStart, end: e.selectionEnd };else a: {
      f = (f = e.ownerDocument) && f.defaultView || window;var g = f.getSelection && f.getSelection();if (g && 0 !== g.rangeCount) {
        f = g.anchorNode;var h = g.anchorOffset,
            k = g.focusNode;g = g.focusOffset;try {
          f.nodeType, k.nodeType;
        } catch (Xa) {
          f = null;break a;
        }var l = 0,
            m = -1,
            r = -1,
            A = 0,
            S = 0,
            B = e,
            P = null;b: for (;;) {
          for (var v;;) {
            B !== f || 0 !== h && 3 !== B.nodeType || (m = l + h);B !== k || 0 !== g && 3 !== B.nodeType || (r = l + g);3 === B.nodeType && (l += B.nodeValue.length);if (null === (v = B.firstChild)) break;P = B;B = v;
          }for (;;) {
            if (B === e) break b;P === f && ++A === h && (m = l);P === k && ++S === g && (r = l);if (null !== (v = B.nextSibling)) break;B = P;P = B.parentNode;
          }B = v;
        }f = -1 === m || -1 === r ? null : { start: m, end: r };
      } else f = null;
    }f = f || { start: 0, end: 0 };
  } else f = null;ye = { focusedElem: e, selectionRange: f };Gd = !1;for (Q = d; null !== Q;) {
    e = !1;f = void 0;try {
      for (; null !== Q;) {
        if (Q.effectTag & 256) {
          var p = Q.alternate;a: switch (h = Q, h.tag) {case 2:case 3:
              if (h.effectTag & 256 && null !== p) {
                var u = p.memoizedProps,
                    x = p.memoizedState,
                    R = h.stateNode;R.props = h.memoizedProps;R.state = h.memoizedState;var yh = R.getSnapshotBeforeUpdate(u, x);R.__reactInternalSnapshotBeforeUpdate = yh;
              }break a;case 5:case 7:case 8:case 6:
              break a;default:
              t("163");}
        }Q = Q.nextEffect;
      }
    } catch (Xa) {
      e = !0, f = Xa;
    }e && (null === Q ? t("178") : void 0, wg(Q, f), null !== Q && (Q = Q.nextEffect));
  }for (Q = d; null !== Q;) {
    p = !1;u = void 0;try {
      for (; null !== Q;) {
        var w = Q.effectTag;w & 16 && oe(Q.stateNode, "");if (w & 128) {
          var y = Q.alternate;if (null !== y) {
            var q = y.ref;null !== q && ("function" === typeof q ? q(null) : q.current = null);
          }
        }switch (w & 14) {case 2:
            Ag(Q);Q.effectTag &= -3;break;case 6:
            Ag(Q);Q.effectTag &= -3;Bg(Q.alternate, Q);break;case 4:
            Bg(Q.alternate, Q);break;case 8:
            x = Q, yg(x), x.return = null, x.child = null, x.alternate && (x.alternate.child = null, x.alternate.return = null);}Q = Q.nextEffect;
      }
    } catch (Xa) {
      p = !0, u = Xa;
    }p && (null === Q ? t("178") : void 0, wg(Q, u), null !== Q && (Q = Q.nextEffect));
  }q = ye;y = Td();w = q.focusedElem;u = q.selectionRange;if (y !== w && w && w.ownerDocument && Sd(w.ownerDocument.documentElement, w)) {
    null !== u && Ud(w) && (y = u.start, q = u.end, void 0 === q && (q = y), "selectionStart" in w ? (w.selectionStart = y, w.selectionEnd = Math.min(q, w.value.length)) : (p = w.ownerDocument || document, y = (p ? p.defaultView : window).getSelection(), x = w.textContent.length, q = Math.min(u.start, x), u = void 0 === u.end ? q : Math.min(u.end, x), !y.extend && q > u && (x = u, u = q, q = x), x = Rd(w, q), R = Rd(w, u), x && R && (1 !== y.rangeCount || y.anchorNode !== x.node || y.anchorOffset !== x.offset || y.focusNode !== R.node || y.focusOffset !== R.offset) && (p = p.createRange(), p.setStart(x.node, x.offset), y.removeAllRanges(), q > u ? (y.addRange(p), y.extend(R.node, R.offset)) : (p.setEnd(R.node, R.offset), y.addRange(p)))));y = [];for (q = w; q = q.parentNode;) {
      1 === q.nodeType && y.push({ element: q, left: q.scrollLeft, top: q.scrollTop });
    }"function" === typeof w.focus && w.focus();for (w = 0; w < y.length; w++) {
      q = y[w], q.element.scrollLeft = q.left, q.element.scrollTop = q.top;
    }
  }ye = null;Gd = !!xe;xe = null;a.current = b;for (Q = d; null !== Q;) {
    d = !1;w = void 0;try {
      for (y = c; null !== Q;) {
        var Sa = Q.effectTag;if (Sa & 36) {
          var oc = Q.alternate;q = Q;p = y;switch (q.tag) {case 2:case 3:
              var X = q.stateNode;if (q.effectTag & 4) if (null === oc) X.props = q.memoizedProps, X.state = q.memoizedState, X.componentDidMount();else {
                var Ih = oc.memoizedProps,
                    Jh = oc.memoizedState;X.props = q.memoizedProps;X.state = q.memoizedState;X.componentDidUpdate(Ih, Jh, X.__reactInternalSnapshotBeforeUpdate);
              }var kg = q.updateQueue;null !== kg && (X.props = q.memoizedProps, X.state = q.memoizedState, lf(q, kg, X, p));break;case 5:
              var lg = q.updateQueue;if (null !== lg) {
                u = null;if (null !== q.child) switch (q.child.tag) {case 7:
                    u = q.child.stateNode;break;case 2:case 3:
                    u = q.child.stateNode;}lf(q, lg, u, p);
              }break;case 7:
              var Kh = q.stateNode;null === oc && q.effectTag & 4 && ze(q.type, q.memoizedProps) && Kh.focus();break;
            case 8:
              break;case 6:
              break;case 15:
              break;case 16:
              break;default:
              t("163");}
        }if (Sa & 128) {
          var Ac = Q.ref;if (null !== Ac) {
            var mg = Q.stateNode;switch (Q.tag) {case 7:
                var Pd = mg;break;default:
                Pd = mg;}"function" === typeof Ac ? Ac(Pd) : Ac.current = Pd;
          }
        }var Lh = Q.nextEffect;Q.nextEffect = null;Q = Lh;
      }
    } catch (Xa) {
      d = !0, w = Xa;
    }d && (null === Q ? t("178") : void 0, wg(Q, w), null !== Q && (Q = Q.nextEffect));
  }Lg = Og = !1;"function" === typeof Oe && Oe(b.stateNode);Sa = b.expirationTime;b = b.childExpirationTime;b = 0 === Sa || 0 !== b && b < Sa ? b : Sa;0 === b && (Fg = null);a.expirationTime = b;a.finishedWork = null;
}function Tg() {
  return eh ? !0 : null === hh || hh.timeRemaining() > nh ? !1 : eh = !0;
}function Dg(a) {
  null === Y ? t("246") : void 0;Y.expirationTime = 0;fh || (fh = !0, gh = a);
}function sh(a, b) {
  var c = W;W = !0;try {
    return a(b);
  } finally {
    (W = c) || V || Yg(1, null);
  }
}function th(a, b) {
  if (W && !Wg) {
    Wg = !0;try {
      return a(b);
    } finally {
      Wg = !1;
    }
  }return a(b);
}function uh(a, b, c) {
  if (Ug) return a(b, c);W || V || 0 === Vg || (Yg(Vg, null), Vg = 0);var d = Ug,
      e = W;W = Ug = !0;try {
    return a(b, c);
  } finally {
    Ug = d, (W = e) || V || Yg(1, null);
  }
}
function vh(a) {
  if (!a) return Fe;a = a._reactInternalFiber;a: {
    2 !== jd(a) || 2 !== a.tag && 3 !== a.tag ? t("170") : void 0;var b = a;do {
      switch (b.tag) {case 5:
          b = b.stateNode.context;break a;case 2:
          if (K(b.type)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;break a;
          }break;case 3:
          if (K(b.type._reactResult)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;break a;
          }}b = b.return;
    } while (null !== b);t("171");b = void 0;
  }if (2 === a.tag) {
    var c = a.type;if (K(c)) return Le(a, c, b);
  } else if (3 === a.tag && (c = a.type._reactResult, K(c))) return Le(a, c, b);return b;
}function wh(a, b, c, d, e) {
  var f = b.current;c = vh(c);null === b.context ? b.context = c : b.pendingContext = c;b = e;e = df(d);e.payload = { element: a };b = void 0 === b ? null : b;null !== b && (e.callback = b);ff(f, e);If(f, d);return d;
}function xh(a, b, c, d) {
  var e = b.current,
      f = Gf();e = Hf(f, e);return wh(a, b, c, e, d);
}function zh(a) {
  a = a.current;if (!a.child) return null;switch (a.child.tag) {case 7:
      return a.child.stateNode;default:
      return a.child.stateNode;}
}
function Ah(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: ac, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
Fb = function Fb(a, b, c) {
  switch (b) {case "input":
      Dc(a, c);b = c.name;if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');for (b = 0; b < c.length; b++) {
          var d = c[b];if (d !== a && d.form === a.form) {
            var e = Na(d);e ? void 0 : t("90");Xb(d);Dc(d, e);
          }
        }
      }break;case "textarea":
      he(a, c);break;case "select":
      b = c.value, null != b && ee(a, !!c.multiple, b, !1);}
};
function Bh(a) {
  var b = 2 + 25 * (((Gf() - 2 + 500) / 25 | 0) + 1);b <= Jg && (b = Jg + 1);this._expirationTime = Jg = b;this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;
}Bh.prototype.render = function (a) {
  this._defer ? void 0 : t("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,
      c = this._expirationTime,
      d = new Ch();wh(a, b, null, c, d._onCommit);return d;
};
Bh.prototype.then = function (a) {
  if (this._didComplete) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
Bh.prototype.commit = function () {
  var a = this._root._internalRoot,
      b = a.firstBatch;this._defer && null !== b ? void 0 : t("251");if (this._hasChildren) {
    var c = this._expirationTime;if (b !== this) {
      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) {
        d = e, e = e._next;
      }null === d ? t("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;
    }this._defer = !1;b = c;V ? t("253") : void 0;Y = a;Z = b;Xg(a, b, !0);Yg(1, null);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);
  } else this._next = null, this._defer = !1;
};Bh.prototype._onComplete = function () {
  if (!this._didComplete) {
    this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      (0, a[b])();
    }
  }
};function Ch() {
  this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);
}Ch.prototype.then = function (a) {
  if (this._didCommit) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
Ch.prototype._onCommit = function () {
  if (!this._didCommit) {
    this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      var c = a[b];"function" !== typeof c ? t("191", c) : void 0;c();
    }
  }
};
function Dh(a, b, c) {
  b = new Se(5, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, earliestPendingTime: 0, latestPendingTime: 0, earliestSuspendedTime: 0, latestSuspendedTime: 0, latestPingedTime: 0, didError: !1, pendingCommitExpirationTime: 0, finishedWork: null, timeoutHandle: -1, context: null, pendingContext: null, hydrate: c, nextExpirationTimeToWorkOn: 0, expirationTime: 0, firstBatch: null, nextScheduledRoot: null };this._internalRoot = b.stateNode = a;
}
Dh.prototype.render = function (a, b) {
  var c = this._internalRoot,
      d = new Ch();b = void 0 === b ? null : b;null !== b && d.then(b);xh(a, c, null, d._onCommit);return d;
};Dh.prototype.unmount = function (a) {
  var b = this._internalRoot,
      c = new Ch();a = void 0 === a ? null : a;null !== a && c.then(a);xh(null, b, null, c._onCommit);return c;
};Dh.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
  var d = this._internalRoot,
      e = new Ch();c = void 0 === c ? null : c;null !== c && e.then(c);xh(b, d, a, e._onCommit);return e;
};
Dh.prototype.createBatch = function () {
  var a = new Bh(this),
      b = a._expirationTime,
      c = this._internalRoot,
      d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {
    for (c = null; null !== d && d._expirationTime <= b;) {
      c = d, d = d._next;
    }a._next = d;null !== c && (c._next = a);
  }return a;
};function Eh(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}Lb = sh;Mb = uh;Nb = function Nb() {
  V || 0 === Vg || (Yg(Vg, null), Vg = 0);
};
function Fh(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }return new Dh(a, !1, b);
}
function Gh(a, b, c, d, e) {
  Eh(c) ? void 0 : t("200");var f = c._reactRootContainer;if (f) {
    if ("function" === typeof e) {
      var g = e;e = function e() {
        var a = zh(f._internalRoot);g.call(a);
      };
    }null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
  } else {
    f = c._reactRootContainer = Fh(c, d);if ("function" === typeof e) {
      var h = e;e = function e() {
        var a = zh(f._internalRoot);h.call(a);
      };
    }th(function () {
      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    });
  }return zh(f._internalRoot);
}
function Hh(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;Eh(b) ? void 0 : t("200");return Ah(a, b, null, c);
}
var Mh = { createPortal: Hh, findDOMNode: function findDOMNode(a) {
    if (null == a) return null;if (1 === a.nodeType) return a;var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? t("188") : t("268", Object.keys(a)));a = md(b);a = null === a ? null : a.stateNode;return a;
  }, hydrate: function hydrate(a, b, c) {
    return Gh(null, a, b, !0, c);
  }, render: function render(a, b, c) {
    return Gh(null, a, b, !1, c);
  }, unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
    null == a || void 0 === a._reactInternalFiber ? t("38") : void 0;return Gh(a, b, c, !1, d);
  }, unmountComponentAtNode: function unmountComponentAtNode(a) {
    Eh(a) ? void 0 : t("40");return a._reactRootContainer ? (th(function () {
      Gh(null, null, a, !1, function () {
        a._reactRootContainer = null;
      });
    }), !0) : !1;
  }, unstable_createPortal: function unstable_createPortal() {
    return Hh.apply(void 0, arguments);
  }, unstable_batchedUpdates: sh, unstable_interactiveUpdates: uh, flushSync: function flushSync(a, b) {
    V ? t("187") : void 0;var c = W;W = !0;try {
      return bh(a, b);
    } finally {
      W = c, Yg(1, null);
    }
  }, unstable_flushControlled: function unstable_flushControlled(a) {
    var b = W;W = !0;try {
      bh(a);
    } finally {
      (W = b) || V || Yg(1, null);
    }
  }, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { Events: [La, Ma, Na, Ea.injectEventPluginsByName, qa, Ua, function (a) {
      za(a, Ta);
    }, Jb, Kb, Id, Ga] }, unstable_createRoot: function unstable_createRoot(a, b) {
    Eh(a) ? void 0 : t("278");return new Dh(a, !0, null != b && !0 === b.hydrate);
  } };(function (a) {
  var b = a.findFiberByHostInstance;return Re(n({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = md(a);return null === a ? null : a.stateNode;
    }, findFiberByHostInstance: function findFiberByHostInstance(a) {
      return b ? b(a) : null;
    } }));
})({ findFiberByHostInstance: Ka, bundleType: 0, version: "16.5.1", rendererPackageName: "react-dom" });
var Nh = { default: Mh },
    Oh = Nh && Mh || Nh;module.exports = Oh.default || Oh;

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_parseMask__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_environment__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_string__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_defer__ = __webpack_require__(2307);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// https://github.com/sanniassin/react-input-mask







var InputElement = function (_React$Component) {
  _inherits(InputElement, _React$Component);

  function InputElement(props) {
    _classCallCheck(this, InputElement);

    var _this = _possibleConstructorReturn(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).call(this, props));

    _initialiseProps.call(_this);

    var mask = props.mask,
        maskChar = props.maskChar,
        formatChars = props.formatChars,
        defaultValue = props.defaultValue,
        value = props.value,
        alwaysShowMask = props.alwaysShowMask;

    _this.hasValue = value != null;
    _this.maskOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_parseMask__["a" /* default */])(mask, maskChar, formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }
    if (value == null) {
      value = defaultValue;
    }

    value = _this.getStringValue(value);

    if (_this.maskOptions.mask && (alwaysShowMask || value)) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["a" /* formatValue */])(_this.maskOptions, value);
    }

    _this.value = value;
    return _this;
  }

  return InputElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.lastCursorPos = null;
  this.focused = false;

  this.componentDidMount = function () {
    _this2.isAndroidBrowser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_environment__["a" /* isAndroidBrowser */])();
    _this2.isWindowsPhoneBrowser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_environment__["b" /* isWindowsPhoneBrowser */])();
    _this2.isAndroidFirefox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_environment__["c" /* isAndroidFirefox */])();

    if (_this2.maskOptions.mask && _this2.getInputValue() !== _this2.value) {
      _this2.setInputValue(_this2.value);
    }
  };

  this.componentWillReceiveProps = function (nextProps) {
    var oldMaskOptions = _this2.maskOptions;

    _this2.hasValue = nextProps.value != null;
    _this2.maskOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_parseMask__["a" /* default */])(nextProps.mask, nextProps.maskChar, nextProps.formatChars);

    if (!_this2.maskOptions.mask) {
      _this2.backspaceOrDeleteRemoval = null;
      _this2.lastCursorPos = null;
      return;
    }

    var isMaskChanged = _this2.maskOptions.mask && _this2.maskOptions.mask !== oldMaskOptions.mask;
    var showEmpty = nextProps.alwaysShowMask || _this2.isFocused();
    var newValue = _this2.hasValue ? _this2.getStringValue(nextProps.value) : _this2.value;

    if (!oldMaskOptions.mask && !_this2.hasValue) {
      newValue = _this2.getInputDOMNode().value;
    }

    if (isMaskChanged || _this2.maskOptions.mask && (newValue || showEmpty)) {
      newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["a" /* formatValue */])(_this2.maskOptions, newValue);

      if (isMaskChanged) {
        var pos = _this2.lastCursorPos;
        var filledLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["b" /* getFilledLength */])(_this2.maskOptions, newValue);
        if (pos === null || filledLen < pos) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["c" /* isFilled */])(_this2.maskOptions, newValue)) {
            pos = filledLen;
          } else {
            pos = _this2.getRightEditablePos(filledLen);
          }
          _this2.setCursorPos(pos);
        }
      }
    }

    if (_this2.maskOptions.mask && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["d" /* isEmpty */])(_this2.maskOptions, newValue) && !showEmpty && (!_this2.hasValue || !nextProps.value)) {
      newValue = '';
    }

    _this2.value = newValue;
  };

  this.componentDidUpdate = function () {
    if (_this2.maskOptions.mask && _this2.getInputValue() !== _this2.value) {
      _this2.setInputValue(_this2.value);
    }
  };

  this.isDOMElement = function (element) {
    return (typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object' ? element instanceof HTMLElement // DOM2
    : element.nodeType === 1 && typeof element.nodeName === 'string';
  };

  this.getInputDOMNode = function () {
    var input = _this2.input;
    if (!input) {
      return null;
    }

    if (_this2.isDOMElement(input)) {
      return input;
    }

    // React 0.13
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.findDOMNode(input);
  };

  this.getInputValue = function () {
    var input = _this2.getInputDOMNode();
    if (!input) {
      return null;
    }

    return input.value;
  };

  this.setInputValue = function (value) {
    var input = _this2.getInputDOMNode();
    if (!input) {
      return;
    }

    _this2.value = value;
    input.value = value;
  };

  this.getLeftEditablePos = function (pos) {
    for (var i = pos; i >= 0; --i) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["e" /* isPermanentChar */])(_this2.maskOptions, i)) {
        return i;
      }
    }
    return null;
  };

  this.getRightEditablePos = function (pos) {
    var mask = _this2.maskOptions.mask;

    for (var i = pos; i < mask.length; ++i) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["e" /* isPermanentChar */])(_this2.maskOptions, i)) {
        return i;
      }
    }
    return null;
  };

  this.setCursorToEnd = function () {
    var filledLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["b" /* getFilledLength */])(_this2.maskOptions, _this2.value);
    var pos = _this2.getRightEditablePos(filledLen);
    if (pos !== null) {
      _this2.setCursorPos(pos);
    }
  };

  this.setSelection = function (start) {
    var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var input = _this2.getInputDOMNode();
    if (!input) {
      return;
    }

    var end = start + len;
    if ('selectionStart' in input && 'selectionEnd' in input) {
      input.selectionStart = start;
      input.selectionEnd = end;
    } else {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    }
  };

  this.getSelection = function () {
    var input = _this2.getInputDOMNode();
    var start = 0;
    var end = 0;

    if ('selectionStart' in input && 'selectionEnd' in input) {
      start = input.selectionStart;
      end = input.selectionEnd;
    } else {
      var range = document.selection.createRange();
      if (range.parentElement() === input) {
        start = -range.moveStart('character', -input.value.length);
        end = -range.moveEnd('character', -input.value.length);
      }
    }

    return {
      start: start,
      end: end,
      length: end - start
    };
  };

  this.getCursorPos = function () {
    return _this2.getSelection().start;
  };

  this.setCursorPos = function (pos) {
    _this2.setSelection(pos, 0);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_defer__["a" /* default */])(function () {
      _this2.setSelection(pos, 0);
    });

    _this2.lastCursorPos = pos;
  };

  this.isFocused = function () {
    return _this2.focused;
  };

  this.getStringValue = function (value) {
    return !value && value !== 0 ? '' : value + '';
  };

  this.onKeyDown = function (event) {
    _this2.backspaceOrDeleteRemoval = null;

    if (typeof _this2.props.onKeyDown === 'function') {
      _this2.props.onKeyDown(event);
    }

    var key = event.key,
        ctrlKey = event.ctrlKey,
        metaKey = event.metaKey,
        defaultPrevented = event.defaultPrevented;

    if (ctrlKey || metaKey || defaultPrevented) {
      return;
    }

    if (key === 'Backspace' || key === 'Delete') {
      var selection = _this2.getSelection();
      var canRemove = key === 'Backspace' && selection.end > 0 || key === 'Delete' && _this2.value.length > selection.start;

      if (!canRemove) {
        return;
      }

      _this2.backspaceOrDeleteRemoval = {
        key: key,
        selection: _this2.getSelection()
      };
    }
  };

  this.onChange = function (event) {
    var paste = _this2.paste;
    var _maskOptions = _this2.maskOptions,
        mask = _maskOptions.mask,
        maskChar = _maskOptions.maskChar,
        lastEditablePos = _maskOptions.lastEditablePos,
        prefix = _maskOptions.prefix;

    var value = _this2.getInputValue();
    var oldValue = _this2.value;

    if (paste) {
      _this2.paste = null;
      _this2.pasteText(paste.value, value, paste.selection, event);
      return;
    }

    var selection = _this2.getSelection();
    var cursorPos = selection.end;
    var maskLen = mask.length;
    var valueLen = value.length;
    var oldValueLen = oldValue.length;

    var clearedValue;
    var enteredString;

    if (_this2.backspaceOrDeleteRemoval) {
      var deleteFromRight = _this2.backspaceOrDeleteRemoval.key === 'Delete';
      value = _this2.value;
      selection = _this2.backspaceOrDeleteRemoval.selection;
      cursorPos = selection.start;

      _this2.backspaceOrDeleteRemoval = null;

      if (selection.length) {
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, value, selection.start, selection.length);
      } else if (selection.start < prefix.length || !deleteFromRight && selection.start === prefix.length) {
        cursorPos = prefix.length;
      } else {
        var editablePos = deleteFromRight ? _this2.getRightEditablePos(cursorPos) : _this2.getLeftEditablePos(cursorPos - 1);

        if (editablePos !== null) {
          value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, value, editablePos, 1);
          cursorPos = editablePos;
        }
      }
    } else if (valueLen > oldValueLen) {
      var enteredStringLen = valueLen - oldValueLen;
      var startPos = selection.end - enteredStringLen;
      enteredString = value.substr(startPos, enteredStringLen);

      if (startPos < lastEditablePos && (enteredStringLen !== 1 || enteredString !== mask[startPos])) {
        cursorPos = _this2.getRightEditablePos(startPos);
      } else {
        cursorPos = startPos;
      }

      value = value.substr(0, startPos) + value.substr(startPos + enteredStringLen);

      clearedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, value, startPos, maskLen - startPos);
      clearedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["g" /* insertString */])(_this2.maskOptions, clearedValue, enteredString, cursorPos);

      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["g" /* insertString */])(_this2.maskOptions, oldValue, enteredString, cursorPos);

      if (enteredStringLen !== 1 || cursorPos >= prefix.length && cursorPos < lastEditablePos) {
        cursorPos = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["b" /* getFilledLength */])(_this2.maskOptions, clearedValue), cursorPos);
        if (cursorPos < lastEditablePos) {
          cursorPos = _this2.getRightEditablePos(cursorPos);
        }
      } else if (cursorPos < lastEditablePos) {
        cursorPos++;
      }
    } else if (valueLen < oldValueLen) {
      var removedLen = maskLen - valueLen;
      enteredString = value.substr(0, selection.end);
      var clearOnly = enteredString === oldValue.substr(0, selection.end);

      clearedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, oldValue, selection.end, removedLen);

      if (maskChar) {
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["g" /* insertString */])(_this2.maskOptions, clearedValue, enteredString, 0);
      }

      clearedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, clearedValue, selection.end, maskLen - selection.end);
      clearedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["g" /* insertString */])(_this2.maskOptions, clearedValue, enteredString, 0);

      if (!clearOnly) {
        cursorPos = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["b" /* getFilledLength */])(_this2.maskOptions, clearedValue), cursorPos);
        if (cursorPos < lastEditablePos) {
          cursorPos = _this2.getRightEditablePos(cursorPos);
        }
      } else if (cursorPos < prefix.length) {
        cursorPos = prefix.length;
      }
    }
    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["a" /* formatValue */])(_this2.maskOptions, value);

    _this2.setInputValue(value);

    if (typeof _this2.props.onChange === 'function') {
      _this2.props.onChange(event);
    }

    if (_this2.isWindowsPhoneBrowser) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_defer__["a" /* default */])(function () {
        _this2.setSelection(cursorPos, 0);
      });
    } else {
      _this2.setCursorPos(cursorPos);
    }
  };

  this.onFocus = function (event) {
    _this2.focused = true;

    if (_this2.maskOptions.mask) {
      if (!_this2.value) {
        var prefix = _this2.maskOptions.prefix;
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["a" /* formatValue */])(_this2.maskOptions, prefix);
        var inputValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["a" /* formatValue */])(_this2.maskOptions, value);

        // do not use this.getInputValue and this.setInputValue as this.input
        // can be undefined at this moment if autoFocus attribute is set
        var isInputValueChanged = inputValue !== event.target.value;

        if (isInputValueChanged) {
          event.target.value = inputValue;
        }

        _this2.value = inputValue;

        if (isInputValueChanged && typeof _this2.props.onChange === 'function') {
          _this2.props.onChange(event);
        }

        _this2.setCursorToEnd();
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["b" /* getFilledLength */])(_this2.maskOptions, _this2.value) < _this2.maskOptions.mask.length) {
        _this2.setCursorToEnd();
      }
    }

    if (typeof _this2.props.onFocus === 'function') {
      _this2.props.onFocus(event);
    }
  };

  this.onBlur = function (event) {
    _this2.focused = false;

    if (_this2.maskOptions.mask && !_this2.props.alwaysShowMask && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["d" /* isEmpty */])(_this2.maskOptions, _this2.value)) {
      var inputValue = '';
      var isInputValueChanged = inputValue !== _this2.getInputValue();

      if (isInputValueChanged) {
        _this2.setInputValue(inputValue);
      }

      if (isInputValueChanged && typeof _this2.props.onChange === 'function') {
        _this2.props.onChange(event);
      }
    }

    if (typeof _this2.props.onBlur === 'function') {
      _this2.props.onBlur(event);
    }
  };

  this.onPaste = function (event) {
    if (typeof _this2.props.onPaste === 'function') {
      _this2.props.onPaste(event);
    }

    if (_this2.isAndroidBrowser && !event.defaultPrevented) {
      _this2.paste = {
        value: _this2.getInputValue(),
        selection: _this2.getSelection()
      };
      _this2.setInputValue('');
    }
  };

  this.pasteText = function (value, text, selection, event) {
    var cursorPos = selection.start;
    if (selection.length) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["f" /* clearRange */])(_this2.maskOptions, value, cursorPos, selection.length);
    }
    var textLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["h" /* getInsertStringLength */])(_this2.maskOptions, value, text, cursorPos);
    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["g" /* insertString */])(_this2.maskOptions, value, text, cursorPos);
    cursorPos += textLen;
    cursorPos = _this2.getRightEditablePos(cursorPos) || cursorPos;

    if (value !== _this2.getInputValue()) {
      _this2.setInputValue(value);
      if (event && typeof _this2.props.onChange === 'function') {
        _this2.props.onChange(event);
      }
    }

    _this2.setCursorPos(cursorPos);
  };

  this.render = function () {
    var _props = _this2.props,
        mask = _props.mask,
        alwaysShowMask = _props.alwaysShowMask,
        maskChar = _props.maskChar,
        formatChars = _props.formatChars,
        props = _objectWithoutProperties(_props, ['mask', 'alwaysShowMask', 'maskChar', 'formatChars']);

    if (_this2.maskOptions.mask) {
      if (!props.disabled && !props.readOnly) {
        var handlersKeys = ['onChange', 'onKeyDown', 'onPaste'];
        handlersKeys.forEach(function (key) {
          props[key] = _this2[key];
        });
      }

      if (props.value != null) {
        props.value = _this2.value;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ ref: function ref(_ref) {
        return _this2.input = _ref;
      } }, props, { onFocus: _this2.onFocus, onBlur: _this2.onBlur }));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (InputElement);

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2323)();
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(2365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function profileContainer(Container, containerName) {
  __webpack_require__(9).RelayProfiler.instrumentMethods(Container.prototype, {
    constructor: containerName + '.prototype.constructor',
    UNSAFE_componentWillReceiveProps: containerName + '.prototype.UNSAFE_componentWillReceiveProps',
    componentWillUnmount: containerName + '.prototype.componentWillUnmount',
    shouldComponentUpdate: containerName + '.prototype.shouldComponentUpdate'
  });

  // Copy static getDerivedStateFromProps() to the instrumented constructor.
  // This is necessary to support the react-lifecycle-compat poyfill.
  // This can be removed once react-relay requires React 16.3+.
  if (Container.prototype !== null && _typeof(Container.prototype) === 'object' && typeof Container.getDerivedStateFromProps === 'function') {
    Container.prototype.constructor.getDerivedStateFromProps = Container.getDerivedStateFromProps;
  }
}

module.exports = { profileContainer: profileContainer };

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var ReactRelayQueryFetcher = function () {
  function ReactRelayQueryFetcher() {
    (0, _classCallCheck3['default'])(this, ReactRelayQueryFetcher);
    this._selectionReferences = [];
    this._callOnDataChangeWhenSet = false;
  } // results of the root fragment;
  // fetch error


  ReactRelayQueryFetcher.prototype.lookupInStore = function lookupInStore(environment, operation) {
    if (environment.check(operation.root)) {
      this._retainCachedOperation(environment, operation);
      return environment.lookup(operation.fragment);
    }
    return null;
  };

  ReactRelayQueryFetcher.prototype.execute = function execute(_ref) {
    var _this = this;

    var environment = _ref.environment,
        operation = _ref.operation,
        cacheConfig = _ref.cacheConfig,
        _ref$preservePrevious = _ref.preservePreviousReferences,
        preservePreviousReferences = _ref$preservePrevious === undefined ? false : _ref$preservePrevious;
    var createOperationSelector = environment.unstable_internal.createOperationSelector;

    var nextReferences = [];

    return environment.execute({ operation: operation, cacheConfig: cacheConfig }).map(function (payload) {
      var operationForPayload = createOperationSelector(operation.node, payload.variables, payload.operation);
      nextReferences.push(environment.retain(operationForPayload.root));
      return payload;
    })['do']({
      error: function error() {
        // We may have partially fulfilled the request, so let the next request
        // or the unmount dispose of the references.
        _this._selectionReferences = _this._selectionReferences.concat(nextReferences);
      },
      complete: function complete() {
        if (!preservePreviousReferences) {
          _this._disposeSelectionReferences();
        }
        _this._selectionReferences = _this._selectionReferences.concat(nextReferences);
      },
      unsubscribe: function unsubscribe() {
        // Let the next request or the unmount code dispose of the references.
        // We may have partially fulfilled the request.
        _this._selectionReferences = _this._selectionReferences.concat(nextReferences);
      }
    });
  };

  ReactRelayQueryFetcher.prototype.setOnDataChange = function setOnDataChange(onDataChange) {
    !this._fetchOptions ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayQueryFetcher: `setOnDataChange` should have been called after having called `fetch`') : __webpack_require__(3)(false) : void 0;

    // Mutate the most recent fetchOptions in place,
    // So that in-progress requests can access the updated callback.
    this._fetchOptions.onDataChange = onDataChange;

    if (this._callOnDataChangeWhenSet && typeof onDataChange === 'function') {
      this._callOnDataChangeWhenSet = false;
      if (this._error != null) {
        onDataChange({ error: this._error });
      } else if (this._snapshot != null) {
        onDataChange({ snapshot: this._snapshot });
      }
    }
  };

  /**
   * `fetch` fetches the data for the given operation.
   * If a result is immediately available synchronously, it will be synchronously
   * returned by this function.
   *
   * Otherwise, the fetched result will be communicated via the `onDataChange` callback.
   * `onDataChange` will be called with the first result (**if it wasn't returned synchronously**),
   * and then subsequently whenever the data changes.
   */

  ReactRelayQueryFetcher.prototype.fetch = function fetch(fetchOptions) {
    var _this2 = this;

    var cacheConfig = fetchOptions.cacheConfig,
        environment = fetchOptions.environment,
        operation = fetchOptions.operation;

    var fetchHasReturned = false;
    var error = void 0;

    this._disposeRequest();
    this._fetchOptions = fetchOptions;

    var request = this.execute({
      environment: environment,
      operation: operation,
      cacheConfig: cacheConfig
    })['finally'](function () {
      _this2._pendingRequest = null;
    }).subscribe({
      next: function next() {
        var onDataChange = _this2._fetchOptions ? _this2._fetchOptions.onDataChange : null;

        // If we received a response when we didn't have a change callback,
        // Make a note that to notify the callback when it's later added.
        _this2._callOnDataChangeWhenSet = typeof onDataChange !== 'function';
        _this2._error = null;

        // Only notify of the first result if `next` is being called **asynchronously**
        // (i.e. after `fetch` has returned).
        _this2._onQueryDataAvailable({ notifyFirstResult: fetchHasReturned });
      },
      error: function (_error) {
        function error(_x) {
          return _error.apply(this, arguments);
        }

        error.toString = function () {
          return _error.toString();
        };

        return error;
      }(function (err) {
        var onDataChange = _this2._fetchOptions ? _this2._fetchOptions.onDataChange : null;

        // If we received a response when we didn't have a change callback,
        // Make a note that to notify the callback when it's later added.
        _this2._callOnDataChangeWhenSet = typeof onDataChange !== 'function';
        _this2._error = err;
        _this2._snapshot = null;

        // Only notify of error if `error` is being called **asynchronously**
        // (i.e. after `fetch` has returned).
        if (fetchHasReturned) {
          if (typeof onDataChange === 'function') {
            onDataChange({ error: err });
          }
        } else {
          error = err;
        }
      })
    });

    this._pendingRequest = {
      dispose: function dispose() {
        request.unsubscribe();
      }
    };

    fetchHasReturned = true;

    if (error) {
      throw error;
    }

    return this._snapshot;
  };

  ReactRelayQueryFetcher.prototype.retry = function retry() {
    !this._fetchOptions ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayQueryFetcher: `retry` should be called after having called `fetch`') : __webpack_require__(3)(false) : void 0;
    return this.fetch(this._fetchOptions);
  };

  ReactRelayQueryFetcher.prototype.dispose = function dispose() {
    this._disposeRequest();
    this._disposeSelectionReferences();
  };

  ReactRelayQueryFetcher.prototype._disposeRequest = function _disposeRequest() {
    this._error = null;
    this._snapshot = null;

    // order is important, dispose of pendingFetch before selectionReferences
    if (this._pendingRequest) {
      this._pendingRequest.dispose();
    }
    if (this._rootSubscription) {
      this._rootSubscription.dispose();
      this._rootSubscription = null;
    }
  };

  ReactRelayQueryFetcher.prototype._retainCachedOperation = function _retainCachedOperation(environment, operation) {
    this._disposeCacheSelectionReference();
    this._cacheSelectionReference = environment.retain(operation.root);
  };

  ReactRelayQueryFetcher.prototype._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
    this._cacheSelectionReference && this._cacheSelectionReference.dispose();
    this._cacheSelectionReference = null;
  };

  ReactRelayQueryFetcher.prototype._disposeSelectionReferences = function _disposeSelectionReferences() {
    this._disposeCacheSelectionReference();
    this._selectionReferences.forEach(function (r) {
      return r.dispose();
    });
    this._selectionReferences = [];
  };

  ReactRelayQueryFetcher.prototype._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
    var _this3 = this;

    var notifyFirstResult = _ref2.notifyFirstResult;

    !this._fetchOptions ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayQueryFetcher: `_onQueryDataAvailable` should have been called after having called `fetch`') : __webpack_require__(3)(false) : void 0;
    var _fetchOptions = this._fetchOptions,
        environment = _fetchOptions.environment,
        onDataChange = _fetchOptions.onDataChange,
        operation = _fetchOptions.operation;

    // `_onQueryDataAvailable` can be called synchronously the first time and can be called
    // multiple times by network layers that support data subscriptions.
    // Wait until the first payload to call `onDataChange` and subscribe for data updates.

    if (this._snapshot) {
      return;
    }

    this._snapshot = environment.lookup(operation.fragment);

    // Subscribe to changes in the data of the root fragment
    this._rootSubscription = environment.subscribe(this._snapshot, function (snapshot) {
      // Read from this._fetchOptions in case onDataChange() was lazily added.
      if (_this3._fetchOptions != null) {
        var maybeNewOnDataChange = _this3._fetchOptions.onDataChange;
        if (typeof maybeNewOnDataChange === 'function') {
          maybeNewOnDataChange({ snapshot: snapshot });
        }
      }
    });

    if (this._snapshot && notifyFirstResult && typeof onDataChange === 'function') {
      onDataChange({ snapshot: this._snapshot });
    }
  };

  return ReactRelayQueryFetcher;
}();

module.exports = ReactRelayQueryFetcher;

/***/ }),
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var containerContextTypes = {
  relay: __webpack_require__(81).Relay
};

/**
 * Creates a component class whose instances adapt to the
 * `context.relay.environment` in which they are rendered and which have the
 * necessary static methods (`getFragment()` etc) to be composed within classic
 * `Relay.Containers`.
 */
function buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments, providesChildContext) {
  // Sanity-check user-defined fragment input
  var containerName = __webpack_require__(154).getContainerName(ComponentClass);
  __webpack_require__(2408)(__webpack_require__(154).getComponentName(ComponentClass), fragmentSpec);

  // Memoize a container for the last environment instance encountered
  var environment = void 0;
  var Container = void 0;
  function ContainerConstructor(props, context) {
    if (Container == null || context.relay.environment !== environment) {
      environment = context.relay.environment;
      if (false) {
        var _require2 = require('relay-runtime'),
            isRelayModernEnvironment = _require2.isRelayModernEnvironment;

        if (!isRelayModernEnvironment(environment)) {
          throw new Error('RelayModernContainer: Can only use Relay Modern component ' + (containerName + ' in a Relay Modern environment!\n') + 'When using Relay Modern and Relay Classic in the same ' + 'application, ensure components use Relay Compat to work in ' + 'both environments.\n' + 'See: http://facebook.github.io/relay/docs/relay-compat.html');
        }
      }
      var getFragmentFromTag = environment.unstable_internal.getFragment;

      var _fragments = __webpack_require__(242)(fragmentSpec, getFragmentFromTag);
      Container = createContainerWithFragments(ComponentClass, _fragments);

      // Attach static lifecycle to wrapper component so React can see it.
      ContainerConstructor.getDerivedStateFromProps = Container.getDerivedStateFromProps;
    }
    // $FlowFixMe
    return new Container(props, context);
  }
  ContainerConstructor.contextTypes = containerContextTypes;
  if (providesChildContext) {
    ContainerConstructor.childContextTypes = containerContextTypes;
  }

  function forwardRef(props, ref) {
    return __webpack_require__(0).createElement(ContainerConstructor, (0, _extends3['default'])({}, props, {
      componentRef: props.componentRef || ref
    }));
  }
  forwardRef.displayName = containerName;
  // $FlowFixMe
  var ForwardContainer = __webpack_require__(0).forwardRef(forwardRef);

  if (false) {
    ForwardContainer.__ComponentClass = ComponentClass;
    // Classic container static methods.
    ForwardContainer.getFragment = function getFragmentOnModernContainer() {
      throw new Error('RelayModernContainer: ' + containerName + '.getFragment() was called on ' + 'a Relay Modern component by a Relay Classic or Relay Compat ' + 'component.\n' + 'When using Relay Modern and Relay Classic in the same ' + 'application, ensure components use Relay Compat to work in ' + 'both environments.\n' + 'See: http://facebook.github.io/relay/docs/relay-compat.html');
    };
  }

  return ForwardContainer;
}

module.exports = buildReactRelayContainer;

/***/ }),
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(723);
var invariant = __webpack_require__(724);
var ReactPropTypesSecret = __webpack_require__(722);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(480);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(2433);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(2434);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(2435);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var m = __webpack_require__(169),
    n = "function" === typeof Symbol && Symbol.for,
    p = n ? Symbol.for("react.element") : 60103,
    q = n ? Symbol.for("react.portal") : 60106,
    r = n ? Symbol.for("react.fragment") : 60107,
    t = n ? Symbol.for("react.strict_mode") : 60108,
    u = n ? Symbol.for("react.profiler") : 60114,
    v = n ? Symbol.for("react.provider") : 60109,
    w = n ? Symbol.for("react.context") : 60110,
    x = n ? Symbol.for("react.async_mode") : 60111,
    y = n ? Symbol.for("react.forward_ref") : 60112;n && Symbol.for("react.placeholder");
var z = "function" === typeof Symbol && Symbol.iterator;function A(a, b, d, c, e, g, h, f) {
  if (!a) {
    a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var k = [d, c, e, g, h, f],
          l = 0;a = Error(b.replace(/%s/g, function () {
        return k[l++];
      }));a.name = "Invariant Violation";
    }a.framesToPop = 1;throw a;
  }
}
function B(a) {
  for (var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {
    d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
  }A(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}var C = { isMounted: function isMounted() {
    return !1;
  }, enqueueForceUpdate: function enqueueForceUpdate() {}, enqueueReplaceState: function enqueueReplaceState() {}, enqueueSetState: function enqueueSetState() {} },
    D = {};
function E(a, b, d) {
  this.props = a;this.context = b;this.refs = D;this.updater = d || C;
}E.prototype.isReactComponent = {};E.prototype.setState = function (a, b) {
  "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) && "function" !== typeof a && null != a ? B("85") : void 0;this.updater.enqueueSetState(this, a, b, "setState");
};E.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};function F() {}F.prototype = E.prototype;function G(a, b, d) {
  this.props = a;this.context = b;this.refs = D;this.updater = d || C;
}var H = G.prototype = new F();
H.constructor = G;m(H, E.prototype);H.isPureReactComponent = !0;var I = { current: null, currentDispatcher: null },
    J = Object.prototype.hasOwnProperty,
    K = { key: !0, ref: !0, __self: !0, __source: !0 };
function L(a, b, d) {
  var c = void 0,
      e = {},
      g = null,
      h = null;if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) {
    J.call(b, c) && !K.hasOwnProperty(c) && (e[c] = b[c]);
  }var f = arguments.length - 2;if (1 === f) e.children = d;else if (1 < f) {
    for (var k = Array(f), l = 0; l < f; l++) {
      k[l] = arguments[l + 2];
    }e.children = k;
  }if (a && a.defaultProps) for (c in f = a.defaultProps, f) {
    void 0 === e[c] && (e[c] = f[c]);
  }return { $$typeof: p, type: a, key: g, ref: h, props: e, _owner: I.current };
}
function M(a, b) {
  return { $$typeof: p, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
}function N(a) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === p;
}function escape(a) {
  var b = { "=": "=0", ":": "=2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {
    return b[a];
  });
}var O = /\/+/g,
    P = [];function Q(a, b, d, c) {
  if (P.length) {
    var e = P.pop();e.result = a;e.keyPrefix = b;e.func = d;e.context = c;e.count = 0;return e;
  }return { result: a, keyPrefix: b, func: d, context: c, count: 0 };
}
function R(a) {
  a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > P.length && P.push(a);
}
function S(a, b, d, c) {
  var e = typeof a === "undefined" ? "undefined" : _typeof(a);if ("undefined" === e || "boolean" === e) a = null;var g = !1;if (null === a) g = !0;else switch (e) {case "string":case "number":
      g = !0;break;case "object":
      switch (a.$$typeof) {case p:case q:
          g = !0;}}if (g) return d(c, a, "" === b ? "." + T(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {
    e = a[h];var f = b + T(e, h);g += S(e, f, d, c);
  } else if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) ? f = null : (f = z && a[z] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h = 0; !(e = a.next()).done;) {
    e = e.value, f = b + T(e, h++), g += S(e, f, d, c);
  } else "object" === e && (d = "" + a, B("31", "[object Object]" === d ? "object with keys {" + Object.keys(a).join(", ") + "}" : d, ""));return g;
}function U(a, b, d) {
  return null == a ? 0 : S(a, "", b, d);
}function T(a, b) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}function V(a, b) {
  a.func.call(a.context, b, a.count++);
}
function aa(a, b, d) {
  var c = a.result,
      e = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? W(a, c, d, function (a) {
    return a;
  }) : null != a && (N(a) && (a = M(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(O, "$&/") + "/") + d)), c.push(a));
}function W(a, b, d, c, e) {
  var g = "";null != d && (g = ("" + d).replace(O, "$&/") + "/");b = Q(b, g, c, e);U(a, aa, b);R(b);
}function ba(a, b) {
  var d = I.currentDispatcher;null === d ? B("277") : void 0;return d.readContext(a, b);
}
var X = { Children: { map: function map(a, b, d) {
      if (null == a) return a;var c = [];W(a, c, null, b, d);return c;
    }, forEach: function forEach(a, b, d) {
      if (null == a) return a;b = Q(null, null, b, d);U(a, V, b);R(b);
    }, count: function count(a) {
      return U(a, function () {
        return null;
      }, null);
    }, toArray: function toArray(a) {
      var b = [];W(a, b, null, function (a) {
        return a;
      });return b;
    }, only: function only(a) {
      N(a) ? void 0 : B("143");return a;
    } }, createRef: function createRef() {
    return { current: null };
  }, Component: E, PureComponent: G, createContext: function createContext(a, b) {
    void 0 === b && (b = null);a = { $$typeof: w, _calculateChangedBits: b,
      _currentValue: a, _currentValue2: a, Provider: null, Consumer: null, unstable_read: null };a.Provider = { $$typeof: v, _context: a };a.Consumer = a;a.unstable_read = ba.bind(null, a);return a;
  }, forwardRef: function forwardRef(a) {
    return { $$typeof: y, render: a };
  }, Fragment: r, StrictMode: t, unstable_AsyncMode: x, unstable_Profiler: u, createElement: L, cloneElement: function cloneElement(a, b, d) {
    null === a || void 0 === a ? B("267", a) : void 0;var c = void 0,
        e = m({}, a.props),
        g = a.key,
        h = a.ref,
        f = a._owner;if (null != b) {
      void 0 !== b.ref && (h = b.ref, f = I.current);void 0 !== b.key && (g = "" + b.key);
      var k = void 0;a.type && a.type.defaultProps && (k = a.type.defaultProps);for (c in b) {
        J.call(b, c) && !K.hasOwnProperty(c) && (e[c] = void 0 === b[c] && void 0 !== k ? k[c] : b[c]);
      }
    }c = arguments.length - 2;if (1 === c) e.children = d;else if (1 < c) {
      k = Array(c);for (var l = 0; l < c; l++) {
        k[l] = arguments[l + 2];
      }e.children = k;
    }return { $$typeof: p, type: a.type, key: g, ref: h, props: e, _owner: f };
  }, createFactory: function createFactory(a) {
    var b = L.bind(null, a);b.type = a;return b;
  }, isValidElement: N, version: "16.5.1", __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: I,
    assign: m } },
    Y = { default: X },
    Z = Y && X || Y;module.exports = Z.default || Z;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1272);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(1271);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _pick = __webpack_require__(2472);

var _pick2 = _interopRequireDefault(_pick);

var _shallowEqual = __webpack_require__(1271);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      _inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

exports.default = withPropsOnChange;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Synchronously check whether the records required to fulfill the
 * given `selector` are present in `source`.
 *
 * If a field is missing, it uses the provided handlers to attempt to substitute
 * data. The `target` will store all records that are modified because of a
 * successful substitution.
 *
 * If all records are present, returns `true`, otherwise `false`.
 */
function check(source, target, selector, handlers) {
  var dataID = selector.dataID,
      node = selector.node,
      variables = selector.variables;

  var loader = new RelayDataLoader(source, target, variables, handlers);
  return loader.check(node, dataID);
}

/**
 * @private
 */

var RelayDataLoader = function () {
  function RelayDataLoader(source, target, variables, handlers) {
    (0, _classCallCheck3['default'])(this, RelayDataLoader);

    this._source = source;
    this._variables = variables;
    this._recordWasMissing = false;
    this._handlers = handlers;
    this._mutator = new (__webpack_require__(177))(source, target);
  }

  RelayDataLoader.prototype.check = function check(node, dataID) {
    this._traverse(node, dataID);
    return !this._recordWasMissing;
  };

  RelayDataLoader.prototype._getVariableValue = function _getVariableValue(name) {
    !this._variables.hasOwnProperty(name) ?  false ? require('fbjs/lib/invariant')(false, 'RelayAsyncLoader(): Undefined variable `%s`.', name) : __webpack_require__(10)(false) : void 0;
    return this._variables[name];
  };

  RelayDataLoader.prototype._handleMissing = function _handleMissing() {
    this._recordWasMissing = true;
  };

  RelayDataLoader.prototype._getDataForHandlers = function _getDataForHandlers(field, dataID) {
    return {
      args: field.args ? __webpack_require__(12).getArgumentValues(field.args, this._variables) : {},
      // Getting a snapshot of the record state is potentially expensive since
      // we will need to merge the sink and source records. Since we do not create
      // any new records in this process, it is probably reasonable to provide
      // handlers with a copy of the source record.
      // The only thing that the provided record will not contain is fields
      // added by previous handlers.
      record: this._source.get(dataID)
    };
  };

  RelayDataLoader.prototype._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
    var _getDataForHandlers2 = this._getDataForHandlers(field, dataID),
        args = _getDataForHandlers2.args,
        record = _getDataForHandlers2.record;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this._handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var handler = _step.value;

        if (handler.kind === 'scalar') {
          var newValue = handler.handle(field, record, args);
          if (newValue !== undefined) {
            return newValue;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this._handleMissing();
  };

  RelayDataLoader.prototype._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
    var _getDataForHandlers3 = this._getDataForHandlers(field, dataID),
        args = _getDataForHandlers3.args,
        record = _getDataForHandlers3.record;

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this._handlers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var handler = _step2.value;

        if (handler.kind === 'linked') {
          var newValue = handler.handle(field, record, args);
          if (newValue != null && this._mutator.getStatus(newValue) === __webpack_require__(49).EXISTENT) {
            return newValue;
          }
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    this._handleMissing();
  };

  RelayDataLoader.prototype._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
    var _this = this;

    var _getDataForHandlers4 = this._getDataForHandlers(field, dataID),
        args = _getDataForHandlers4.args,
        record = _getDataForHandlers4.record;

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this._handlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var handler = _step3.value;

        if (handler.kind === 'pluralLinked') {
          var newValue = handler.handle(field, record, args);
          if (newValue != null) {
            return newValue.filter(function (linkedID) {
              return linkedID != null && _this._mutator.getStatus(linkedID) === __webpack_require__(49).EXISTENT;
            });
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    this._handleMissing();
  };

  RelayDataLoader.prototype._traverse = function _traverse(node, dataID) {
    var status = this._mutator.getStatus(dataID);
    if (status === __webpack_require__(49).UNKNOWN) {
      this._handleMissing();
    }
    if (status === __webpack_require__(49).EXISTENT) {
      this._traverseSelections(node.selections, dataID);
    }
  };

  RelayDataLoader.prototype._traverseSelections = function _traverseSelections(selections, dataID) {
    var _this2 = this;

    selections.every(function (selection) {
      switch (selection.kind) {
        case __webpack_require__(18).SCALAR_FIELD:
          _this2._prepareScalar(selection, dataID);
          break;
        case __webpack_require__(18).LINKED_FIELD:
          if (selection.plural) {
            _this2._preparePluralLink(selection, dataID);
          } else {
            _this2._prepareLink(selection, dataID);
          }
          break;
        case __webpack_require__(18).CONDITION:
          var conditionValue = _this2._getVariableValue(selection.condition);
          if (conditionValue === selection.passingValue) {
            _this2._traverseSelections(selection.selections, dataID);
          }
          break;
        case __webpack_require__(18).INLINE_FRAGMENT:
          var typeName = _this2._mutator.getType(dataID);
          if (typeName != null && typeName === selection.type) {
            _this2._traverseSelections(selection.selections, dataID);
          }
          break;
        case __webpack_require__(18).LINKED_HANDLE:
          // Handles have no selections themselves; traverse the original field
          // where the handle was set-up instead.
          var handleField = __webpack_require__(361)(selection, selections, _this2._variables);
          if (handleField.plural) {
            _this2._preparePluralLink(handleField, dataID);
          } else {
            _this2._prepareLink(handleField, dataID);
          }
          break;
        default:
          !(selection.kind === __webpack_require__(18).SCALAR_FIELD) ?  false ? require('fbjs/lib/invariant')(false, 'RelayAsyncLoader(): Unexpected ast kind `%s`.', selection.kind) : __webpack_require__(10)(false) : void 0;
      }
      return !_this2._done;
    });
  };

  RelayDataLoader.prototype._prepareScalar = function _prepareScalar(field, dataID) {
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var fieldValue = this._mutator.getValue(dataID, storageKey);
    if (fieldValue === undefined) {
      fieldValue = this._handleMissingScalarField(field, dataID);
      if (fieldValue !== undefined) {
        this._mutator.setValue(dataID, storageKey, fieldValue);
      }
    }
  };

  RelayDataLoader.prototype._prepareLink = function _prepareLink(field, dataID) {
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);

    if (linkedID === undefined) {
      linkedID = this._handleMissingLinkField(field, dataID);
      if (linkedID != null) {
        this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
      }
    }
    if (linkedID != null) {
      this._traverse(field, linkedID);
    }
  };

  RelayDataLoader.prototype._preparePluralLink = function _preparePluralLink(field, dataID) {
    var _this3 = this;

    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);

    if (linkedIDs === undefined) {
      linkedIDs = this._handleMissingPluralLinkField(field, dataID);
      if (linkedIDs != null) {
        this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
      }
    }
    if (linkedIDs) {
      linkedIDs.forEach(function (linkedID) {
        if (linkedID != null) {
          _this3._traverse(field, linkedID);
        }
      });
    }
  };

  return RelayDataLoader;
}();

module.exports = {
  check: check
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



function RelayDefaultHandlerProvider(handle) {
  switch (handle) {
    case 'connection':
      return __webpack_require__(83);
    case 'viewer':
      return __webpack_require__(360);
  }
   true ?  false ? require('fbjs/lib/invariant')(false, 'RelayDefaultHandlerProvider: No handler provided for `%s`.', handle) : __webpack_require__(10)(false) : void 0;
}

module.exports = RelayDefaultHandlerProvider;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @public
 *
 * An implementation of the `Store` interface defined in `RelayStoreTypes`.
 *
 * Note that a Store takes ownership of all records provided to it: other
 * objects may continue to hold a reference to such records but may not mutate
 * them. The static Relay core is architected to avoid mutating records that may have been
 * passed to a store: operations that mutate records will either create fresh
 * records or clone existing records and modify the clones. Record immutability
 * is also enforced in development mode by freezing all records passed to a store.
 */
var RelayMarkSweepStore = function () {
  function RelayMarkSweepStore(source) {
    (0, _classCallCheck3['default'])(this, RelayMarkSweepStore);

    // Prevent mutation of a record from outside the store.
    if (false) {
      var storeIDs = source.getRecordIDs();
      for (var ii = 0; ii < storeIDs.length; ii++) {
        var record = source.get(storeIDs[ii]);
        if (record) {
          require('./RelayModernRecord').freeze(record);
        }
      }
    }
    this._gcEnabled = true;
    this._hasScheduledGC = false;
    this._index = 0;
    this._recordSource = source;
    this._roots = new Map();
    this._subscriptions = new Set();
    this._updatedRecordIDs = {};
  }

  RelayMarkSweepStore.prototype.getSource = function getSource() {
    return this._recordSource;
  };

  RelayMarkSweepStore.prototype.check = function check(selector) {
    return __webpack_require__(730).check(this._recordSource, this._recordSource, selector, []);
  };

  RelayMarkSweepStore.prototype.retain = function retain(selector) {
    var _this = this;

    var index = this._index++;
    var dispose = function dispose() {
      _this._roots['delete'](index);
      _this._scheduleGC();
    };
    this._roots.set(index, selector);
    return { dispose: dispose };
  };

  RelayMarkSweepStore.prototype.lookup = function lookup(selector) {
    var snapshot = __webpack_require__(245).read(this._recordSource, selector);
    if (false) {
      require('./deepFreeze')(snapshot);
    }
    return snapshot;
  };

  RelayMarkSweepStore.prototype.notify = function notify() {
    var _this2 = this;

    this._subscriptions.forEach(function (subscription) {
      _this2._updateSubscription(subscription);
    });
    this._updatedRecordIDs = {};
  };

  RelayMarkSweepStore.prototype.publish = function publish(source) {
    updateTargetFromSource(this._recordSource, source, this._updatedRecordIDs);
  };

  RelayMarkSweepStore.prototype.subscribe = function subscribe(snapshot, callback) {
    var _this3 = this;

    var subscription = { callback: callback, snapshot: snapshot };
    var dispose = function dispose() {
      _this3._subscriptions['delete'](subscription);
    };
    this._subscriptions.add(subscription);
    return { dispose: dispose };
  };

  // Internal API


  RelayMarkSweepStore.prototype.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
    return this._updatedRecordIDs;
  };

  RelayMarkSweepStore.prototype._updateSubscription = function _updateSubscription(subscription) {
    var callback = subscription.callback,
        snapshot = subscription.snapshot;

    if (!__webpack_require__(747)(snapshot, this._updatedRecordIDs)) {
      return;
    }

    var _RelayReader$read = __webpack_require__(245).read(this._recordSource, snapshot),
        data = _RelayReader$read.data,
        seenRecords = _RelayReader$read.seenRecords;

    var nextData = __webpack_require__(365)(snapshot.data, data);
    var nextSnapshot = (0, _extends3['default'])({}, snapshot, {
      data: nextData,
      seenRecords: seenRecords
    });
    if (false) {
      require('./deepFreeze')(nextSnapshot);
    }
    subscription.snapshot = nextSnapshot;
    if (nextSnapshot.data !== snapshot.data) {
      callback(nextSnapshot);
    }
  };

  RelayMarkSweepStore.prototype._scheduleGC = function _scheduleGC() {
    var _this4 = this;

    if (!this._gcEnabled || this._hasScheduledGC) {
      return;
    }
    this._hasScheduledGC = true;
    __webpack_require__(754)(function () {
      _this4.__gc();
      _this4._hasScheduledGC = false;
    });
  };

  RelayMarkSweepStore.prototype.__gc = function __gc() {
    var _this5 = this;

    var references = new Set();
    // Mark all records that are traversable from a root
    this._roots.forEach(function (selector) {
      __webpack_require__(740).mark(_this5._recordSource, selector, references);
    });
    // Short-circuit if *nothing* is referenced
    if (!references.size) {
      this._recordSource.clear();
      return;
    }
    // Evict any unreferenced nodes
    var storeIDs = this._recordSource.getRecordIDs();
    for (var ii = 0; ii < storeIDs.length; ii++) {
      var dataID = storeIDs[ii];
      if (!references.has(dataID)) {
        this._recordSource.remove(dataID);
      }
    }
  };

  // Internal hooks to enable/disable garbage collection for experimentation


  RelayMarkSweepStore.prototype.__enableGC = function __enableGC() {
    this._gcEnabled = true;
  };

  RelayMarkSweepStore.prototype.__disableGC = function __disableGC() {
    this._gcEnabled = false;
  };

  return RelayMarkSweepStore;
}();

/**
 * Updates the target with information from source, also updating a mapping of
 * which records in the target were changed as a result.
 */

function updateTargetFromSource(target, source, updatedRecordIDs) {
  var dataIDs = source.getRecordIDs();
  for (var ii = 0; ii < dataIDs.length; ii++) {
    var dataID = dataIDs[ii];
    var sourceRecord = source.get(dataID);
    var targetRecord = target.get(dataID);
    // Prevent mutation of a record from outside the store.
    if (false) {
      if (sourceRecord) {
        require('./RelayModernRecord').freeze(sourceRecord);
      }
    }
    if (sourceRecord === __webpack_require__(12).UNPUBLISH_RECORD_SENTINEL) {
      // Unpublish a record
      target.remove(dataID);
      updatedRecordIDs[dataID] = true;
    } else if (sourceRecord && targetRecord) {
      var nextRecord = __webpack_require__(17).update(targetRecord, sourceRecord);
      if (nextRecord !== targetRecord) {
        // Prevent mutation of a record from outside the store.
        if (false) {
          require('./RelayModernRecord').freeze(nextRecord);
        }
        updatedRecordIDs[dataID] = true;
        target.set(dataID, nextRecord);
      }
    } else if (sourceRecord === null) {
      target['delete'](dataID);
      if (targetRecord !== null) {
        updatedRecordIDs[dataID] = true;
      }
    } else if (sourceRecord) {
      target.set(dataID, sourceRecord);
      updatedRecordIDs[dataID] = true;
    } // don't add explicit undefined
  }
}

__webpack_require__(244).instrumentMethods(RelayMarkSweepStore.prototype, {
  lookup: 'RelayMarkSweepStore.prototype.lookup',
  notify: 'RelayMarkSweepStore.prototype.notify',
  publish: 'RelayMarkSweepStore.prototype.publish',
  retain: 'RelayMarkSweepStore.prototype.retain',
  subscribe: 'RelayMarkSweepStore.prototype.subscribe',
  __gc: 'RelayMarkSweepStore.prototype.__gc'
});

module.exports = RelayMarkSweepStore;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var RelayModernEnvironment = function () {
  function RelayModernEnvironment(config) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, RelayModernEnvironment);
    this._deferrableSelections = new Set();

    this.configName = config.configName;
    var handlerProvider = config.handlerProvider ? config.handlerProvider : __webpack_require__(731);
    this._network = config.network;
    this._publishQueue = new (__webpack_require__(737))(config.store, handlerProvider);
    this._store = config.store;
    this.unstable_internal = __webpack_require__(75);

    this.__setNet = function (newNet) {
      return _this._network = newNet;
    };

    // Register this Relay Environment with Relay DevTools if it exists.
    // Note: this must always be the last step in the constructor.
    var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) {
      devToolsHook.registerEnvironment(this);
    }
  }

  RelayModernEnvironment.prototype.getStore = function getStore() {
    return this._store;
  };

  RelayModernEnvironment.prototype.getNetwork = function getNetwork() {
    return this._network;
  };

  RelayModernEnvironment.prototype.applyUpdate = function applyUpdate(optimisticUpdate) {
    var _this2 = this;

    var dispose = function dispose() {
      _this2._publishQueue.revertUpdate(optimisticUpdate);
      _this2._publishQueue.run();
    };
    this._publishQueue.applyUpdate(optimisticUpdate);
    this._publishQueue.run();
    return { dispose: dispose };
  };

  RelayModernEnvironment.prototype.revertUpdate = function revertUpdate(update) {
    this._publishQueue.revertUpdate(update);
    this._publishQueue.run();
  };

  RelayModernEnvironment.prototype.replaceUpdate = function replaceUpdate(update, newUpdate) {
    this._publishQueue.revertUpdate(update);
    this._publishQueue.applyUpdate(newUpdate);
    this._publishQueue.run();
  };

  RelayModernEnvironment.prototype.applyMutation = function applyMutation(_ref) {
    var operation = _ref.operation,
        optimisticResponse = _ref.optimisticResponse,
        optimisticUpdater = _ref.optimisticUpdater;

    return this.applyUpdate({
      operation: operation,
      selectorStoreUpdater: optimisticUpdater,
      response: optimisticResponse || null
    });
  };

  RelayModernEnvironment.prototype.check = function check(readSelector) {
    return this._store.check(readSelector);
  };

  RelayModernEnvironment.prototype.commitPayload = function commitPayload(operationSelector, payload) {
    // Do not handle stripped nulls when commiting a payload
    var relayPayload = __webpack_require__(137)(operationSelector.root, payload);
    this._publishQueue.commitPayload(operationSelector, relayPayload);
    this._publishQueue.run();
  };

  RelayModernEnvironment.prototype.commitUpdate = function commitUpdate(updater) {
    this._publishQueue.commitUpdate(updater);
    this._publishQueue.run();
  };

  RelayModernEnvironment.prototype.lookup = function lookup(readSelector) {
    return this._store.lookup(readSelector);
  };

  RelayModernEnvironment.prototype.subscribe = function subscribe(snapshot, callback) {
    return this._store.subscribe(snapshot, callback);
  };

  RelayModernEnvironment.prototype.retain = function retain(selector) {
    return this._store.retain(selector);
  };

  RelayModernEnvironment.prototype.isSelectorLoading = function isSelectorLoading(selector) {
    var key = __webpack_require__(248)(selector.dataID, selector.node.name, selector.variables);
    return this._deferrableSelections.has(key);
  };
  /**
   * Returns an Observable of ExecutePayload resulting from executing the
   * provided Query or Subscription operation, each result of which is then
   * normalized and committed to the publish queue.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to: environment.execute({...}).subscribe({...}).
   */

  RelayModernEnvironment.prototype.execute = function execute(_ref2) {
    var _this3 = this;

    var operation = _ref2.operation,
        cacheConfig = _ref2.cacheConfig,
        updater = _ref2.updater;

    var optimisticResponse = void 0;
    return this._network.execute(operation.node, operation.variables, cacheConfig || {})['do']({
      next: function next(executePayload) {
        var responsePayload = __webpack_require__(364)(executePayload);
        var source = responsePayload.source,
            fieldPayloads = responsePayload.fieldPayloads,
            deferrableSelections = responsePayload.deferrableSelections;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (deferrableSelections || new Set())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var selectionKey = _step.value;

            _this3._deferrableSelections.add(selectionKey);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (executePayload.isOptimistic) {
          !(optimisticResponse == null) ?  false ? require('fbjs/lib/invariant')(false, 'environment.execute: only support one optimistic respnose per ' + 'execute.') : __webpack_require__(10)(false) : void 0;
          optimisticResponse = {
            source: source,
            fieldPayloads: fieldPayloads
          };
          _this3._publishQueue.applyUpdate(optimisticResponse);
          _this3._publishQueue.run();
        } else {
          if (optimisticResponse) {
            _this3._publishQueue.revertUpdate(optimisticResponse);
            optimisticResponse = undefined;
          }
          var writeSelector = __webpack_require__(359).createOperationSelector(operation.node, executePayload.variables, executePayload.operation);
          if (executePayload.operation.kind === 'DeferrableOperation') {
            var fragmentKey = __webpack_require__(248)(executePayload.variables[executePayload.operation.rootFieldVariable], executePayload.operation.fragmentName, __webpack_require__(243).getOperationVariables(executePayload.operation, executePayload.variables));
            _this3._deferrableSelections['delete'](fragmentKey);
          }
          _this3._publishQueue.commitPayload(writeSelector, responsePayload, updater);
          _this3._publishQueue.run();
        }
      }
    })['finally'](function () {
      if (optimisticResponse) {
        _this3._publishQueue.revertUpdate(optimisticResponse);
        optimisticResponse = undefined;
        _this3._publishQueue.run();
      }
    });
  };

  /**
   * Returns an Observable of ExecutePayload resulting from executing the
   * provided Mutation operation, the result of which is then normalized and
   * committed to the publish queue along with an optional optimistic response
   * or updater.
   *
   * Note: Observables are lazy, so calling this method will do nothing until
   * the result is subscribed to:
   * environment.executeMutation({...}).subscribe({...}).
   */

  RelayModernEnvironment.prototype.executeMutation = function executeMutation(_ref3) {
    var _this4 = this;

    var operation = _ref3.operation,
        optimisticResponse = _ref3.optimisticResponse,
        optimisticUpdater = _ref3.optimisticUpdater,
        updater = _ref3.updater,
        uploadables = _ref3.uploadables;

    var optimisticUpdate = void 0;
    if (optimisticResponse || optimisticUpdater) {
      optimisticUpdate = {
        operation: operation,
        selectorStoreUpdater: optimisticUpdater,
        response: optimisticResponse || null
      };
    }

    return this._network.execute(operation.node, operation.variables, { force: true }, uploadables)['do']({
      start: function start() {
        if (optimisticUpdate) {
          _this4._publishQueue.applyUpdate(optimisticUpdate);
          _this4._publishQueue.run();
        }
      },
      next: function next(payload) {
        if (optimisticUpdate) {
          _this4._publishQueue.revertUpdate(optimisticUpdate);
          optimisticUpdate = undefined;
        }
        _this4._publishQueue.commitPayload(operation, __webpack_require__(364)(payload), updater);
        _this4._publishQueue.run();
      },
      error: function (_error) {
        function error(_x) {
          return _error.apply(this, arguments);
        }

        error.toString = function () {
          return _error.toString();
        };

        return error;
      }(function (error) {
        if (optimisticUpdate) {
          _this4._publishQueue.revertUpdate(optimisticUpdate);
          optimisticUpdate = undefined;
          _this4._publishQueue.run();
        }
      }),
      unsubscribe: function unsubscribe() {
        if (optimisticUpdate) {
          _this4._publishQueue.revertUpdate(optimisticUpdate);
          optimisticUpdate = undefined;
          _this4._publishQueue.run();
        }
      }
    });
  };

  /**
   * @deprecated Use Environment.execute().subscribe()
   */

  RelayModernEnvironment.prototype.sendQuery = function sendQuery(_ref4) {
    var cacheConfig = _ref4.cacheConfig,
        onCompleted = _ref4.onCompleted,
        onError = _ref4.onError,
        onNext = _ref4.onNext,
        operation = _ref4.operation;

     false ? require('fbjs/lib/warning')(false, 'environment.sendQuery() is deprecated. Update to the latest ' + 'version of react-relay, and use environment.execute().') : void 0;
    return this.execute({ operation: operation, cacheConfig: cacheConfig }).subscribeLegacy({
      onNext: onNext,
      onError: onError,
      onCompleted: onCompleted
    });
  };

  /**
   * @deprecated Use Environment.execute().subscribe()
   */

  RelayModernEnvironment.prototype.streamQuery = function streamQuery(_ref5) {
    var cacheConfig = _ref5.cacheConfig,
        onCompleted = _ref5.onCompleted,
        onError = _ref5.onError,
        onNext = _ref5.onNext,
        operation = _ref5.operation;

     false ? require('fbjs/lib/warning')(false, 'environment.streamQuery() is deprecated. Update to the latest ' + 'version of react-relay, and use environment.execute().') : void 0;
    return this.execute({ operation: operation, cacheConfig: cacheConfig }).subscribeLegacy({
      onNext: onNext,
      onError: onError,
      onCompleted: onCompleted
    });
  };

  /**
   * @deprecated Use Environment.executeMutation().subscribe()
   */

  RelayModernEnvironment.prototype.sendMutation = function sendMutation(_ref6) {
    var onCompleted = _ref6.onCompleted,
        onError = _ref6.onError,
        operation = _ref6.operation,
        optimisticResponse = _ref6.optimisticResponse,
        optimisticUpdater = _ref6.optimisticUpdater,
        updater = _ref6.updater,
        uploadables = _ref6.uploadables;

     false ? require('fbjs/lib/warning')(false, 'environment.sendMutation() is deprecated. Update to the latest ' + 'version of react-relay, and use environment.executeMutation().') : void 0;
    return this.executeMutation({
      operation: operation,
      optimisticResponse: optimisticResponse,
      optimisticUpdater: optimisticUpdater,
      updater: updater,
      uploadables: uploadables
    }).subscribeLegacy({
      // NOTE: sendMutation has a non-standard use of onCompleted() by passing
      // it a value. When switching to use executeMutation(), the next()
      // Observer should be used to preserve behavior.
      onNext: function onNext(payload) {
        onCompleted && onCompleted(payload.response.errors);
      },
      onError: onError,
      onCompleted: onCompleted
    });
  };

  /**
   * @deprecated Use Environment.execute().subscribe()
   */

  RelayModernEnvironment.prototype.sendSubscription = function sendSubscription(_ref7) {
    var onCompleted = _ref7.onCompleted,
        onNext = _ref7.onNext,
        onError = _ref7.onError,
        operation = _ref7.operation,
        updater = _ref7.updater;

     false ? require('fbjs/lib/warning')(false, 'environment.sendSubscription() is deprecated. Update to the latest ' + 'version of react-relay, and use environment.execute().') : void 0;
    return this.execute({
      operation: operation,
      updater: updater,
      cacheConfig: { force: true }
    }).subscribeLegacy({ onNext: onNext, onError: onError, onCompleted: onCompleted });
  };

  return RelayModernEnvironment;
}();

// Add a sigil for detection by `isRelayModernEnvironment()` to avoid a
// realm-specific instanceof check, and to aid in module tree-shaking to
// avoid requiring all of RelayRuntime just to detect its environment.


RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;

module.exports = RelayModernEnvironment;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * A utility for resolving and subscribing to the results of a fragment spec
 * (key -> fragment mapping) given some "props" that determine the root ID
 * and variables to use when reading each fragment. When props are changed via
 * `setProps()`, the resolver will update its results and subscriptions
 * accordingly. Internally, the resolver:
 * - Converts the fragment map & props map into a map of `Selector`s.
 * - Removes any resolvers for any props that became null.
 * - Creates resolvers for any props that became non-null.
 * - Updates resolvers with the latest props.
 *
 * This utility is implemented as an imperative, stateful API for performance
 * reasons: reusing previous resolvers, callback functions, and subscriptions
 * all helps to reduce object allocation and thereby decrease GC time.
 *
 * The `resolve()` function is also lazy and memoized: changes in the store mark
 * the resolver as stale and notify the caller, and the actual results are
 * recomputed the first time `resolve()` is called.
 */
var RelayModernFragmentSpecResolver = function () {
  function RelayModernFragmentSpecResolver(context, fragments, props, callback) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, RelayModernFragmentSpecResolver);

    this._onChange = function () {
      _this._stale = true;

      if (typeof _this._callback === 'function') {
        _this._callback();
      }
    };

    this._callback = callback;
    this._context = context;
    this._data = {};
    this._fragments = fragments;
    this._props = props;
    this._resolvers = {};
    this._stale = false;

    this.setProps(props);
  }

  RelayModernFragmentSpecResolver.prototype.dispose = function dispose() {
    for (var _key in this._resolvers) {
      if (this._resolvers.hasOwnProperty(_key)) {
        disposeCallback(this._resolvers[_key]);
      }
    }
  };

  RelayModernFragmentSpecResolver.prototype.resolve = function resolve() {
    if (this._stale) {
      // Avoid mapping the object multiple times, which could occur if data for
      // multiple keys changes in the same event loop.
      var prevData = this._data;
      var nextData = void 0;
      for (var _key2 in this._resolvers) {
        if (this._resolvers.hasOwnProperty(_key2)) {
          var resolver = this._resolvers[_key2];
          var prevItem = prevData[_key2];
          if (resolver) {
            var nextItem = resolver.resolve();
            if (nextData || nextItem !== prevItem) {
              nextData = nextData || (0, _extends3['default'])({}, prevData);
              nextData[_key2] = nextItem;
            }
          } else {
            var prop = this._props[_key2];
            var _nextItem = prop !== undefined ? prop : null;
            if (nextData || !__webpack_require__(363)(_nextItem, prevItem)) {
              nextData = nextData || (0, _extends3['default'])({}, prevData);
              nextData[_key2] = _nextItem;
            }
          }
        }
      }
      this._data = nextData || prevData;
      this._stale = false;
    }
    return this._data;
  };

  RelayModernFragmentSpecResolver.prototype.isLoading = function isLoading() {
    for (var _key3 in this._resolvers) {
      if (this._resolvers.hasOwnProperty(_key3) && this._resolvers[_key3] && this._resolvers[_key3].isLoading()) {
        return true;
      }
    }
    return false;
  };

  RelayModernFragmentSpecResolver.prototype.setCallback = function setCallback(callback) {
    this._callback = callback;
  };

  RelayModernFragmentSpecResolver.prototype.setProps = function setProps(props) {
    var selectors = __webpack_require__(85).getSelectorsFromObject(this._context.variables, this._fragments, props);
    for (var _key4 in selectors) {
      if (selectors.hasOwnProperty(_key4)) {
        var selector = selectors[_key4];
        var resolver = this._resolvers[_key4];
        if (selector == null) {
          if (resolver != null) {
            resolver.dispose();
          }
          resolver = null;
        } else if (Array.isArray(selector)) {
          if (resolver == null) {
            resolver = new SelectorListResolver(this._context.environment, selector, this._onChange);
          } else {
            !(resolver instanceof SelectorListResolver) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernFragmentSpecResolver: Expected prop `%s` to always be an array.', _key4) : __webpack_require__(10)(false) : void 0;
            resolver.setSelectors(selector);
          }
        } else {
          if (resolver == null) {
            resolver = new SelectorResolver(this._context.environment, selector, this._onChange);
          } else {
            !(resolver instanceof SelectorResolver) ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernFragmentSpecResolver: Expected prop `%s` to always be an object.', _key4) : __webpack_require__(10)(false) : void 0;
            resolver.setSelector(selector);
          }
        }
        this._resolvers[_key4] = resolver;
      }
    }
    this._props = props;
    this._stale = true;
  };

  RelayModernFragmentSpecResolver.prototype.setVariables = function setVariables(variables) {
    for (var _key5 in this._resolvers) {
      if (this._resolvers.hasOwnProperty(_key5)) {
        var resolver = this._resolvers[_key5];
        if (resolver) {
          resolver.setVariables(variables);
        }
      }
    }
    this._stale = true;
  };

  return RelayModernFragmentSpecResolver;
}();

/**
 * A resolver for a single Selector.
 */

var SelectorResolver = function () {
  function SelectorResolver(environment, selector, callback) {
    (0, _classCallCheck3['default'])(this, SelectorResolver);

    _initialiseProps.call(this);

    var snapshot = environment.lookup(selector);
    this._callback = callback;
    this._data = snapshot.data;
    this._environment = environment;
    this._selector = selector;
    this._subscription = environment.subscribe(snapshot, this._onChange);
  }

  SelectorResolver.prototype.dispose = function dispose() {
    if (this._subscription) {
      this._subscription.dispose();
      this._subscription = null;
    }
  };

  SelectorResolver.prototype.resolve = function resolve() {
    return this._data;
  };

  SelectorResolver.prototype.setSelector = function setSelector(selector) {
    if (this._subscription != null && __webpack_require__(85).areEqualSelectors(selector, this._selector)) {
      return;
    }
    this.dispose();
    var snapshot = this._environment.lookup(selector);
    this._data = snapshot.data;
    this._selector = selector;
    this._subscription = this._environment.subscribe(snapshot, this._onChange);
  };

  SelectorResolver.prototype.setVariables = function setVariables(variables) {
    var selector = (0, _extends3['default'])({}, this._selector, {
      variables: variables
    });
    this.setSelector(selector);
  };

  SelectorResolver.prototype.isLoading = function isLoading() {
    return this._environment.isSelectorLoading(this._selector);
  };

  return SelectorResolver;
}();

/**
 * A resolver for an array of Selectors.
 */

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._onChange = function (snapshot) {
    _this3._data = snapshot.data;
    _this3._callback();
  };
};

var SelectorListResolver = function () {
  function SelectorListResolver(environment, selectors, callback) {
    var _this2 = this;

    (0, _classCallCheck3['default'])(this, SelectorListResolver);

    this._onChange = function (data) {
      _this2._stale = true;
      _this2._callback();
    };

    this._callback = callback;
    this._data = [];
    this._environment = environment;
    this._resolvers = [];
    this._stale = true;

    this.setSelectors(selectors);
  }

  SelectorListResolver.prototype.dispose = function dispose() {
    this._resolvers.forEach(disposeCallback);
  };

  SelectorListResolver.prototype.resolve = function resolve() {
    if (this._stale) {
      // Avoid mapping the array multiple times, which could occur if data for
      // multiple indices changes in the same event loop.
      var prevData = this._data;
      var nextData = void 0;
      for (var ii = 0; ii < this._resolvers.length; ii++) {
        var prevItem = prevData[ii];
        var nextItem = this._resolvers[ii].resolve();
        if (nextData || nextItem !== prevItem) {
          nextData = nextData || prevData.slice(0, ii);
          nextData.push(nextItem);
        }
      }
      if (!nextData && this._resolvers.length !== prevData.length) {
        nextData = prevData.slice(0, this._resolvers.length);
      }
      this._data = nextData || prevData;
      this._stale = false;
    }
    return this._data;
  };

  SelectorListResolver.prototype.setSelectors = function setSelectors(selectors) {
    while (this._resolvers.length > selectors.length) {
      var resolver = this._resolvers.pop();
      resolver.dispose();
    }
    for (var ii = 0; ii < selectors.length; ii++) {
      if (ii < this._resolvers.length) {
        this._resolvers[ii].setSelector(selectors[ii]);
      } else {
        this._resolvers[ii] = new SelectorResolver(this._environment, selectors[ii], this._onChange);
      }
    }
    this._stale = true;
  };

  SelectorListResolver.prototype.setVariables = function setVariables(variables) {
    this._resolvers.forEach(function (resolver) {
      return resolver.setVariables(variables);
    });
    this._stale = true;
  };

  SelectorListResolver.prototype.isLoading = function isLoading() {
    return this._resolvers.some(function (resolver) {
      return resolver.isLoading();
    });
  };

  return SelectorListResolver;
}();

function disposeCallback(disposable) {
  disposable && disposable.dispose();
}

module.exports = RelayModernFragmentSpecResolver;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



/**
 * Creates an implementation of the `Network` interface defined in
 * `RelayNetworkTypes` given `fetch` and `subscribe` functions.
 */

function create(fetchFn, subscribeFn) {
  // Convert to functions that returns RelayObservable.
  var observeFetch = __webpack_require__(175).convertFetch(fetchFn);
  var observeSubscribe = subscribeFn ? __webpack_require__(175).convertSubscribe(subscribeFn) : undefined;

  function execute(request, variables, cacheConfig, uploadables) {
    if (request.operationKind === 'subscription') {
      !observeSubscribe ?  false ? require('fbjs/lib/invariant')(false, 'RelayNetwork: This network layer does not support Subscriptions. ' + 'To use Subscriptions, provide a custom network layer.') : __webpack_require__(10)(false) : void 0;

      !!uploadables ?  false ? require('fbjs/lib/invariant')(false, 'RelayNetwork: Cannot provide uploadables while subscribing.') : __webpack_require__(10)(false) : void 0;
      return observeSubscribe(request, variables, cacheConfig);
    }

    var pollInterval = cacheConfig.poll;
    if (pollInterval != null) {
      !!uploadables ?  false ? require('fbjs/lib/invariant')(false, 'RelayNetwork: Cannot provide uploadables while polling.') : __webpack_require__(10)(false) : void 0;
      return observeFetch(request, variables, { force: true }).poll(pollInterval);
    }

    return observeFetch(request, variables, cacheConfig, uploadables);
  }

  return { execute: execute };
}

module.exports = { create: create };

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

var _toConsumableArray3 = _interopRequireDefault(__webpack_require__(123));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var queryID = 1;

/**
 * A network logger transaction is an object that you can construct, pass around
 * and add logs to, ultimately calling its commit method when you're done.
 * Different transactions can have different commit logic. One might use
 * `console.log`. Another might ping a logging endpoint. Another might add some
 * autogenerated logs before doing either of the foregoing.
 */
var RelayNetworkLoggerTransaction = function () {
  function RelayNetworkLoggerTransaction(_ref) {
    var request = _ref.request,
        variables = _ref.variables,
        cacheConfig = _ref.cacheConfig,
        uploadables = _ref.uploadables;
    (0, _classCallCheck3['default'])(this, RelayNetworkLoggerTransaction);
    this._hasCommittedLogs = false;
    this._logs = [];

    this._cacheConfig = cacheConfig;
    this._id = queryID++;
    this._request = request;
    this._uploadables = uploadables;
    this._variables = variables;
  }

  RelayNetworkLoggerTransaction.prototype.addLog = function addLog(label) {
    for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }

    this._logs.push({ label: label, values: values });
  };

  RelayNetworkLoggerTransaction.prototype.clearLogs = function clearLogs() {
    this._logs = [];
  };

  RelayNetworkLoggerTransaction.prototype.printLogs = function printLogs(error, payload, status) {
    /* eslint-disable no-console */
    var transactionId = this.getIdentifier();
    console.groupCollapsed && console.groupCollapsed('%c' + transactionId, error ? 'color:red' : '');
    console.timeEnd && console.timeEnd(transactionId);
    this.getLogsToPrint(error, payload, status).forEach(function (_ref2) {
      var _console;

      var label = _ref2.label,
          values = _ref2.values;

      (_console = console).log.apply(_console, [label + ':'].concat((0, _toConsumableArray3['default'])(values)));
    });
    console.groupEnd && console.groupEnd();
    /* eslint-enable no-console */
  };

  RelayNetworkLoggerTransaction.prototype.commitLogs = function commitLogs(error, payload, status) {
    !(this._hasCommittedLogs === false) ?  false ? require('fbjs/lib/invariant')(false, 'The logs for transaction #' + this._id + ' have already been committed.') : __webpack_require__(10)(false) : void 0;
    this.printLogs(error, payload, status);
    this.markCommitted();
  };

  RelayNetworkLoggerTransaction.prototype.markCommitted = function markCommitted() {
    this._hasCommittedLogs = true;
  };

  RelayNetworkLoggerTransaction.prototype.flushLogs = function flushLogs(error, payload, status) {
    !(this._hasCommittedLogs === false) ?  false ? require('fbjs/lib/invariant')(false, 'The logs for transaction #' + this._id + ' have already been committed.') : __webpack_require__(10)(false) : void 0;
    this.printLogs(error, payload, status);
    this.clearLogs();
  };

  RelayNetworkLoggerTransaction.prototype.getCacheConfig = function getCacheConfig() {
    return this._cacheConfig;
  };

  RelayNetworkLoggerTransaction.prototype.getIdentifier = function getIdentifier() {
    return '[' + this._id + '] Relay Modern: ' + this._request.name;
  };

  RelayNetworkLoggerTransaction.prototype.getLogsToPrint = function getLogsToPrint(error, payload, status) {
    return this._logs;
  };

  RelayNetworkLoggerTransaction.prototype.getRequest = function getRequest() {
    return this._request;
  };

  RelayNetworkLoggerTransaction.prototype.getUploadables = function getUploadables() {
    return this._uploadables;
  };

  RelayNetworkLoggerTransaction.prototype.getVariables = function getVariables() {
    return this._variables;
  };

  return RelayNetworkLoggerTransaction;
}();

module.exports = RelayNetworkLoggerTransaction;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Coordinates the concurrent modification of a `Store` due to optimistic and
 * non-revertable client updates and server payloads:
 * - Applies optimistic updates.
 * - Reverts optimistic updates, rebasing any subsequent updates.
 * - Commits client updates (typically for client schema extensions).
 * - Commits server updates:
 *   - Normalizes query/mutation/subscription responses.
 *   - Executes handlers for "handle" fields.
 *   - Reverts and reapplies pending optimistic updates.
 */
var RelayPublishQueue = function () {
  // Optimistic updaters to add with the next `run()`.

  // Payloads to apply or Sources to publish to the store with the next `run()`.


  // A "negative" of all applied updaters. It can be published to the store to
  // undo them in order to re-apply some of them for a rebase.
  function RelayPublishQueue(store, handlerProvider) {
    (0, _classCallCheck3['default'])(this, RelayPublishQueue);

    this._backup = new (__webpack_require__(115))();
    this._handlerProvider = handlerProvider || null;
    this._pendingBackupRebase = false;
    this._pendingUpdaters = new Set();
    this._pendingData = new Set();
    this._pendingOptimisticUpdates = new Set();
    this._store = store;
    this._appliedOptimisticUpdates = new Set();
  }

  /**
   * Schedule applying an optimistic updates on the next `run()`.
   */

  // Optimistic updaters that are already added and might be rerun in order to
  // rebase them.

  // Updaters to apply with the next `run()`. These mutate the store and should
  // typically only mutate client schema extensions.

  // True if the next `run()` should apply the backup and rerun all optimistic
  // updates performing a rebase.


  RelayPublishQueue.prototype.applyUpdate = function applyUpdate(updater) {
    !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) ?  false ? require('fbjs/lib/invariant')(false, 'RelayPublishQueue: Cannot apply the same update function more than ' + 'once concurrently.') : __webpack_require__(10)(false) : void 0;
    this._pendingOptimisticUpdates.add(updater);
  };

  /**
   * Schedule reverting an optimistic updates on the next `run()`.
   */

  RelayPublishQueue.prototype.revertUpdate = function revertUpdate(updater) {
    if (this._pendingOptimisticUpdates.has(updater)) {
      // Reverted before it was applied
      this._pendingOptimisticUpdates['delete'](updater);
    } else if (this._appliedOptimisticUpdates.has(updater)) {
      this._pendingBackupRebase = true;
      this._appliedOptimisticUpdates['delete'](updater);
    }
  };

  /**
   * Schedule a revert of all optimistic updates on the next `run()`.
   */

  RelayPublishQueue.prototype.revertAll = function revertAll() {
    this._pendingBackupRebase = true;
    this._pendingOptimisticUpdates.clear();
    this._appliedOptimisticUpdates.clear();
  };

  /**
   * Schedule applying a payload to the store on the next `run()`.
   */

  RelayPublishQueue.prototype.commitPayload = function commitPayload(operation, _ref, updater) {
    var fieldPayloads = _ref.fieldPayloads,
        source = _ref.source;

    this._pendingBackupRebase = true;
    this._pendingData.add({
      kind: 'payload',
      payload: { fieldPayloads: fieldPayloads, operation: operation, source: source, updater: updater }
    });
  };

  /**
   * Schedule an updater to mutate the store on the next `run()` typically to
   * update client schema fields.
   */

  RelayPublishQueue.prototype.commitUpdate = function commitUpdate(updater) {
    this._pendingBackupRebase = true;
    this._pendingUpdaters.add(updater);
  };

  /**
   * Schedule a publish to the store from the provided source on the next
   * `run()`. As an example, to update the store with substituted fields that
   * are missing in the store.
   */

  RelayPublishQueue.prototype.commitSource = function commitSource(source) {
    this._pendingBackupRebase = true;
    this._pendingData.add({ kind: 'source', source: source });
  };

  /**
   * Execute all queued up operations from the other public methods.
   */

  RelayPublishQueue.prototype.run = function run() {
    if (this._pendingBackupRebase && this._backup.size()) {
      this._store.publish(this._backup);
      this._backup = new (__webpack_require__(115))();
    }
    this._commitData();
    this._commitUpdaters();
    this._applyUpdates();
    this._pendingBackupRebase = false;
    this._store.notify();
  };

  RelayPublishQueue.prototype._getSourceFromPayload = function _getSourceFromPayload(payload) {
    var _this = this;

    var fieldPayloads = payload.fieldPayloads,
        operation = payload.operation,
        source = payload.source,
        updater = payload.updater;

    var mutator = new (__webpack_require__(177))(this._store.getSource(), source);
    var store = new (__webpack_require__(246))(mutator);
    var selectorStore = new (__webpack_require__(247))(store, operation.fragment);
    if (fieldPayloads && fieldPayloads.length) {
      fieldPayloads.forEach(function (fieldPayload) {
        var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
        !handler ?  false ? require('fbjs/lib/invariant')(false, 'RelayModernEnvironment: Expected a handler to be provided for ' + 'handle `%s`.', fieldPayload.handle) : __webpack_require__(10)(false) : void 0;
        handler.update(store, fieldPayload);
      });
    }
    if (updater) {
      var selectorData = lookupSelector(source, operation.fragment);
      updater(selectorStore, selectorData);
    }
    return source;
  };

  RelayPublishQueue.prototype._commitData = function _commitData() {
    var _this2 = this;

    if (!this._pendingData.size) {
      return;
    }
    this._pendingData.forEach(function (data) {
      var source = void 0;
      if (data.kind === 'payload') {
        source = _this2._getSourceFromPayload(data.payload);
      } else {
        source = data.source;
      }
      _this2._store.publish(source);
    });
    this._pendingData.clear();
  };

  RelayPublishQueue.prototype._commitUpdaters = function _commitUpdaters() {
    var _this3 = this;

    if (!this._pendingUpdaters.size) {
      return;
    }
    var sink = new (__webpack_require__(115))();
    this._pendingUpdaters.forEach(function (updater) {
      var mutator = new (__webpack_require__(177))(_this3._store.getSource(), sink);
      var store = new (__webpack_require__(246))(mutator);
      __webpack_require__(138).applyWithGuard(updater, null, [store], null, 'RelayPublishQueue:commitUpdaters');
    });
    this._store.publish(sink);
    this._pendingUpdaters.clear();
  };

  RelayPublishQueue.prototype._applyUpdates = function _applyUpdates() {
    var _this4 = this;

    if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
      var sink = new (__webpack_require__(115))();
      var mutator = new (__webpack_require__(177))(this._store.getSource(), sink, this._backup);
      var store = new (__webpack_require__(246))(mutator, this._handlerProvider);

      // rerun all updaters in case we are running a rebase
      if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
        this._appliedOptimisticUpdates.forEach(function (optimisticUpdate) {
          if (optimisticUpdate.operation) {
            var selectorStoreUpdater = optimisticUpdate.selectorStoreUpdater,
                _operation = optimisticUpdate.operation,
                response = optimisticUpdate.response;

            var selectorStore = store.commitPayload(_operation, response);
            // TODO: Fix commitPayload so we don't have to run normalize twice
            var selectorData = void 0,
                _source = void 0;
            if (response) {
              var _normalizeRelayPayloa = __webpack_require__(137)(_operation.root, response);

              _source = _normalizeRelayPayloa.source;

              selectorData = lookupSelector(_source, _operation.fragment);
            }
            selectorStoreUpdater && __webpack_require__(138).applyWithGuard(selectorStoreUpdater, null, [selectorStore, selectorData], null, 'RelayPublishQueue:applyUpdates');
          } else if (optimisticUpdate.storeUpdater) {
            var storeUpdater = optimisticUpdate.storeUpdater;

            __webpack_require__(138).applyWithGuard(storeUpdater, null, [store], null, 'RelayPublishQueue:applyUpdates');
          } else {
            var _source2 = optimisticUpdate.source,
                _fieldPayloads = optimisticUpdate.fieldPayloads;

            store.publishSource(_source2, _fieldPayloads);
          }
        });
      }

      // apply any new updaters
      if (this._pendingOptimisticUpdates.size) {
        this._pendingOptimisticUpdates.forEach(function (optimisticUpdate) {
          if (optimisticUpdate.operation) {
            var selectorStoreUpdater = optimisticUpdate.selectorStoreUpdater,
                _operation2 = optimisticUpdate.operation,
                response = optimisticUpdate.response;

            var selectorStore = store.commitPayload(_operation2, response);
            // TODO: Fix commitPayload so we don't have to run normalize twice
            var selectorData = void 0,
                _source3 = void 0;
            if (response) {
              var _normalizeRelayPayloa2 = __webpack_require__(137)(_operation2.root, response);

              _source3 = _normalizeRelayPayloa2.source;

              selectorData = lookupSelector(_source3, _operation2.fragment);
            }
            selectorStoreUpdater && __webpack_require__(138).applyWithGuard(selectorStoreUpdater, null, [selectorStore, selectorData], null, 'RelayPublishQueue:applyUpdates');
          } else if (optimisticUpdate.storeUpdater) {
            var storeUpdater = optimisticUpdate.storeUpdater;

            __webpack_require__(138).applyWithGuard(storeUpdater, null, [store], null, 'RelayPublishQueue:applyUpdates');
          } else {
            var _source4 = optimisticUpdate.source,
                _fieldPayloads2 = optimisticUpdate.fieldPayloads;

            store.publishSource(_source4, _fieldPayloads2);
          }
          _this4._appliedOptimisticUpdates.add(optimisticUpdate);
        });
        this._pendingOptimisticUpdates.clear();
      }

      this._store.publish(sink);
    }
  };

  return RelayPublishQueue;
}();

function lookupSelector(source, selector) {
  var selectorData = __webpack_require__(245).read(source, selector).data;
  if (false) {
    var deepFreeze = require('./deepFreeze');
    if (selectorData) {
      deepFreeze(selectorData);
    }
  }
  return selectorData;
}

module.exports = RelayPublishQueue;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * A cache for storing query responses, featuring:
 * - `get` with TTL
 * - cache size limiting, with least-recently *updated* entries purged first
 */
var RelayQueryResponseCache = function () {
  function RelayQueryResponseCache(_ref) {
    var size = _ref.size,
        ttl = _ref.ttl;
    (0, _classCallCheck3['default'])(this, RelayQueryResponseCache);

    !(size > 0) ?  false ? require('fbjs/lib/invariant')(false, 'RelayQueryResponseCache: Expected the max cache size to be > 0, got ' + '`%s`.', size) : __webpack_require__(10)(false) : void 0;
    !(ttl > 0) ?  false ? require('fbjs/lib/invariant')(false, 'RelayQueryResponseCache: Expected the max ttl to be > 0, got `%s`.', ttl) : __webpack_require__(10)(false) : void 0;
    this._responses = new Map();
    this._size = size;
    this._ttl = ttl;
  }

  RelayQueryResponseCache.prototype.clear = function clear() {
    this._responses.clear();
  };

  RelayQueryResponseCache.prototype.get = function get(queryID, variables) {
    var _this = this;

    var cacheKey = getCacheKey(queryID, variables);
    this._responses.forEach(function (response, key) {
      if (!isCurrent(response.fetchTime, _this._ttl)) {
        _this._responses['delete'](key);
      }
    });
    var response = this._responses.get(cacheKey);
    return response != null ? response.payload : null;
  };

  RelayQueryResponseCache.prototype.set = function set(queryID, variables, payload) {
    var fetchTime = Date.now();
    var cacheKey = getCacheKey(queryID, variables);
    this._responses['delete'](cacheKey); // deletion resets key ordering
    this._responses.set(cacheKey, {
      fetchTime: fetchTime,
      payload: payload
    });
    // Purge least-recently updated key when max size reached
    if (this._responses.size > this._size) {
      var firstKey = this._responses.keys().next();
      if (!firstKey.done) {
        this._responses['delete'](firstKey.value);
      }
    }
  };

  return RelayQueryResponseCache;
}();

function getCacheKey(queryID, variables) {
  return JSON.stringify(__webpack_require__(178)({ queryID: queryID, variables: variables }));
}

/**
 * Determine whether a response fetched at `fetchTime` is still valid given
 * some `ttl`.
 */
function isCurrent(fetchTime, ttl) {
  return fetchTime + ttl >= Date.now();
}

module.exports = RelayQueryResponseCache;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * @internal
 *
 * A helper class for manipulating a given record from a record source via an
 * imperative/OO-style API.
 */
var RelayRecordProxy = function () {
  function RelayRecordProxy(source, mutator, dataID) {
    (0, _classCallCheck3['default'])(this, RelayRecordProxy);

    this._dataID = dataID;
    this._mutator = mutator;
    this._source = source;
  }

  RelayRecordProxy.prototype.copyFieldsFrom = function copyFieldsFrom(source) {
    this._mutator.copyFields(source.getDataID(), this._dataID);
  };

  RelayRecordProxy.prototype.getDataID = function getDataID() {
    return this._dataID;
  };

  RelayRecordProxy.prototype.getType = function getType() {
    var type = this._mutator.getType(this._dataID);
    !(type != null) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordProxy: Cannot get the type of deleted record `%s`.', this._dataID) : __webpack_require__(10)(false) : void 0;
    return type;
  };

  RelayRecordProxy.prototype.getValue = function getValue(name, args) {
    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    return this._mutator.getValue(this._dataID, storageKey);
  };

  RelayRecordProxy.prototype.setValue = function setValue(value, name, args) {
    !isValidLeafValue(value) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordProxy#setValue(): Expected a scalar or array of scalars, ' + 'got `%s`.', JSON.stringify(value)) : __webpack_require__(10)(false) : void 0;
    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    this._mutator.setValue(this._dataID, storageKey, value);
    return this;
  };

  RelayRecordProxy.prototype.getLinkedRecord = function getLinkedRecord(name, args) {
    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
    return linkedID != null ? this._source.get(linkedID) : linkedID;
  };

  RelayRecordProxy.prototype.setLinkedRecord = function setLinkedRecord(record, name, args) {
    !(record instanceof RelayRecordProxy) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordProxy#setLinkedRecord(): Expected a record, got `%s`.', record) : __webpack_require__(10)(false) : void 0;
    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    var linkedID = record.getDataID();
    this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
    return this;
  };

  RelayRecordProxy.prototype.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
    var linkedRecord = this.getLinkedRecord(name, args);
    if (!linkedRecord) {
      var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
      var clientID = __webpack_require__(76)(this.getDataID(), storageKey);
      linkedRecord = this._source.create(clientID, typeName);
      this.setLinkedRecord(linkedRecord, name, args);
    }
    return linkedRecord;
  };

  RelayRecordProxy.prototype.getLinkedRecords = function getLinkedRecords(name, args) {
    var _this = this;

    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
    if (linkedIDs == null) {
      return linkedIDs;
    }
    return linkedIDs.map(function (linkedID) {
      return linkedID != null ? _this._source.get(linkedID) : linkedID;
    });
  };

  RelayRecordProxy.prototype.setLinkedRecords = function setLinkedRecords(records, name, args) {
    !Array.isArray(records) ?  false ? require('fbjs/lib/invariant')(false, 'RelayRecordProxy#setLinkedRecords(): Expected records to be an array, got `%s`.', records) : __webpack_require__(10)(false) : void 0;
    var storageKey = __webpack_require__(12).getStableStorageKey(name, args);
    var linkedIDs = records.map(function (record) {
      return record && record.getDataID();
    });
    this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
    return this;
  };

  return RelayRecordProxy;
}();

function isValidLeafValue(value) {
  return value == null || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || Array.isArray(value) && value.every(isValidLeafValue);
}

module.exports = RelayRecordProxy;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function mark(recordSource, selector, references) {
  var dataID = selector.dataID,
      node = selector.node,
      variables = selector.variables;

  var marker = new RelayReferenceMarker(recordSource, variables, references);
  marker.mark(node, dataID);
}

/**
 * @private
 */

var RelayReferenceMarker = function () {
  function RelayReferenceMarker(recordSource, variables, references) {
    (0, _classCallCheck3['default'])(this, RelayReferenceMarker);

    this._references = references;
    this._recordSource = recordSource;
    this._variables = variables;
  }

  RelayReferenceMarker.prototype.mark = function mark(node, dataID) {
    this._traverse(node, dataID);
  };

  RelayReferenceMarker.prototype._traverse = function _traverse(node, dataID) {
    this._references.add(dataID);
    var record = this._recordSource.get(dataID);
    if (record == null) {
      return;
    }
    this._traverseSelections(node.selections, record);
  };

  RelayReferenceMarker.prototype._getVariableValue = function _getVariableValue(name) {
    !this._variables.hasOwnProperty(name) ?  false ? require('fbjs/lib/invariant')(false, 'RelayReferenceMarker(): Undefined variable `%s`.', name) : __webpack_require__(10)(false) : void 0;
    return this._variables[name];
  };

  RelayReferenceMarker.prototype._traverseSelections = function _traverseSelections(selections, record) {
    var _this = this;

    selections.forEach(function (selection) {
      /* eslint-disable no-fallthrough */
      switch (selection.kind) {
        case __webpack_require__(18).LINKED_FIELD:
          if (selection.plural) {
            _this._traversePluralLink(selection, record);
          } else {
            _this._traverseLink(selection, record);
          }
          break;
        case __webpack_require__(18).CONDITION:
          var conditionValue = _this._getVariableValue(selection.condition);
          if (conditionValue === selection.passingValue) {
            _this._traverseSelections(selection.selections, record);
          }
          break;
        case __webpack_require__(18).INLINE_FRAGMENT:
          var typeName = __webpack_require__(17).getType(record);
          if (typeName != null && typeName === selection.type) {
            _this._traverseSelections(selection.selections, record);
          }
          break;
        case __webpack_require__(18).FRAGMENT_SPREAD:
           true ?  false ? require('fbjs/lib/invariant')(false, 'RelayReferenceMarker(): Unexpected fragment spread `...%s`, ' + 'expected all fragments to be inlined.', selection.name) : __webpack_require__(10)(false) : void 0;
        case __webpack_require__(18).LINKED_HANDLE:
          // The selections for a "handle" field are the same as those of the
          // original linked field where the handle was applied. Reference marking
          // therefore requires traversing the original field selections against
          // the synthesized client field.
          //
          // TODO: Instead of finding the source field in `selections`, change
          // the concrete structure to allow shared subtrees, and have the linked
          // handle directly refer to the same selections as the LinkedField that
          // it was split from.
          var handleField = __webpack_require__(361)(selection, selections, _this._variables);
          if (handleField.plural) {
            _this._traversePluralLink(handleField, record);
          } else {
            _this._traverseLink(handleField, record);
          }
          break;
        case __webpack_require__(18).SCALAR_FIELD:
        case __webpack_require__(18).SCALAR_HANDLE:
        case __webpack_require__(18).DEFERRABLE_FRAGMENT_SPREAD:
          break;
        default:
          selection;
           true ?  false ? require('fbjs/lib/invariant')(false, 'RelayReferenceMarker: Unknown AST node `%s`.', selection) : __webpack_require__(10)(false) : void 0;
      }
    });
  };

  RelayReferenceMarker.prototype._traverseLink = function _traverseLink(field, record) {
    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedID = __webpack_require__(17).getLinkedRecordID(record, storageKey);

    if (linkedID == null) {
      return;
    }
    this._traverse(field, linkedID);
  };

  RelayReferenceMarker.prototype._traversePluralLink = function _traversePluralLink(field, record) {
    var _this2 = this;

    var storageKey = __webpack_require__(12).getStorageKey(field, this._variables);
    var linkedIDs = __webpack_require__(17).getLinkedRecordIDs(record, storageKey);

    if (linkedIDs == null) {
      return;
    }
    linkedIDs.forEach(function (linkedID) {
      if (linkedID != null) {
        _this2._traverse(field, linkedID);
      }
    });
  };

  return RelayReferenceMarker;
}();

module.exports = { mark: mark };

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _defineProperty3 = _interopRequireDefault(__webpack_require__(122));

var _extends4 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Normalizes the results of a query and standard GraphQL response, writing the
 * normalized records/fields into the given MutableRecordSource.
 *
 * If handleStrippedNulls is true, will replace fields on the Selector that
 * are not present in the response with null. Otherwise will leave fields unset.
 */
function normalize(recordSource, selector, response) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { handleStrippedNulls: false };
  var dataID = selector.dataID,
      node = selector.node,
      variables = selector.variables;

  var normalizer = new RelayResponseNormalizer(recordSource, variables, options);
  return normalizer.normalizeResponse(node, dataID, response);
}

/**
 * @private
 *
 * Helper for handling payloads.
 */

var RelayResponseNormalizer = function () {
  function RelayResponseNormalizer(recordSource, variables, options) {
    (0, _classCallCheck3['default'])(this, RelayResponseNormalizer);
    this._handleFieldPayloads = [];
    this._deferrableSelections = new Set();

    this._recordSource = recordSource;
    this._variables = variables;
    this._handleStrippedNulls = options.handleStrippedNulls;
  }

  RelayResponseNormalizer.prototype.normalizeResponse = function normalizeResponse(node, dataID, data) {
    var record = this._recordSource.get(dataID);
    !record ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer(): Expected root record `%s` to exist.', dataID) : __webpack_require__(10)(false) : void 0;
    this._traverseSelections(node, record, data);
    return {
      fieldPayloads: this._handleFieldPayloads,
      deferrableSelections: this._deferrableSelections
    };
  };

  RelayResponseNormalizer.prototype._getVariableValue = function _getVariableValue(name) {
    !this._variables.hasOwnProperty(name) ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer(): Undefined variable `%s`.', name) : __webpack_require__(10)(false) : void 0;
    return this._variables[name];
  };

  RelayResponseNormalizer.prototype._getRecordType = function _getRecordType(data) {
    var typeName = data[__webpack_require__(12).TYPENAME_KEY];
    !(typeName != null) ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer(): Expected a typename for record `%s`.', JSON.stringify(data, null, 2)) : __webpack_require__(10)(false) : void 0;
    return typeName;
  };

  RelayResponseNormalizer.prototype._traverseSelections = function _traverseSelections(node, record, data) {
    var _this = this;

    node.selections.forEach(function (selection) {
      if (selection.kind === __webpack_require__(18).SCALAR_FIELD || selection.kind === __webpack_require__(18).LINKED_FIELD) {
        _this._normalizeField(node, selection, record, data);
      } else if (selection.kind === __webpack_require__(18).CONDITION) {
        var conditionValue = _this._getVariableValue(selection.condition);
        if (conditionValue === selection.passingValue) {
          _this._traverseSelections(selection, record, data);
        }
      } else if (selection.kind === __webpack_require__(18).INLINE_FRAGMENT) {
        var typeName = __webpack_require__(17).getType(record);
        if (typeName === selection.type) {
          _this._traverseSelections(selection, record, data);
        }
      } else if (selection.kind === __webpack_require__(18).LINKED_HANDLE || selection.kind === __webpack_require__(18).SCALAR_HANDLE) {
        var args = selection.args ? __webpack_require__(12).getArgumentValues(selection.args, _this._variables) : {};
        var fieldKey = __webpack_require__(12).getStorageKey(selection, _this._variables);
        var handleKey = __webpack_require__(12).getHandleStorageKey(selection, _this._variables);
        _this._handleFieldPayloads.push({
          args: args,
          dataID: __webpack_require__(17).getDataID(record),
          fieldKey: fieldKey,
          handle: selection.handle,
          handleKey: handleKey
        });
      } else if (selection.kind === __webpack_require__(18).DEFERRABLE_FRAGMENT_SPREAD) {
        var dataID = __webpack_require__(17).getDataID(record);
        var value = __webpack_require__(17).getValue(record, selection.storageKey);
        !(typeof value === 'string') ?  false ? require('fbjs/lib/invariant')(false, 'expected ID at %s', selection.storageKey) : __webpack_require__(10)(false) : void 0;
        var variables = selection.args ? __webpack_require__(12).getArgumentValues(selection.args, (0, _extends4['default'])({}, _this._variables, (0, _defineProperty3['default'])({}, selection.rootFieldVariable, value))) : {};
        var key = __webpack_require__(248)(dataID, selection.name, variables);
        _this._deferrableSelections.add(key);
      } else {
         true ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer(): Unexpected ast kind `%s`.', selection.kind) : __webpack_require__(10)(false) : void 0;
      }
    });
  };

  RelayResponseNormalizer.prototype._normalizeField = function _normalizeField(parent, selection, record, data) {
    !((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data) ?  false ? require('fbjs/lib/invariant')(false, 'writeField(): Expected data for field `%s` to be an object.', selection.name) : __webpack_require__(10)(false) : void 0;
    var responseKey = selection.alias || selection.name;
    var storageKey = __webpack_require__(12).getStorageKey(selection, this._variables);
    var fieldValue = data[responseKey];
    if (fieldValue == null) {
      if (fieldValue === undefined && !this._handleStrippedNulls) {
        // If we're not stripping nulls, undefined fields are unset
        return;
      }
      if (false) {
        process.env.NODE_ENV !== 'production' ? require('fbjs/lib/warning')(parent.kind === require('./RelayConcreteNode').LINKED_FIELD && parent.concreteType == null ? true : Object.prototype.hasOwnProperty.call(data, responseKey), 'RelayResponseNormalizer(): Payload did not contain a value ' + 'for field `%s: %s`. Check that you are parsing with the same ' + 'query that was used to fetch the payload.', responseKey, storageKey) : void 0;
      }
      __webpack_require__(17).setValue(record, storageKey, null);
      return;
    }

    if (selection.kind === __webpack_require__(18).SCALAR_FIELD) {
      __webpack_require__(17).setValue(record, storageKey, fieldValue);
    } else if (selection.plural) {
      this._normalizePluralLink(selection, record, storageKey, fieldValue);
    } else {
      this._normalizeLink(selection, record, storageKey, fieldValue);
    }
  };

  RelayResponseNormalizer.prototype._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
    !((typeof fieldValue === 'undefined' ? 'undefined' : _typeof(fieldValue)) === 'object' && fieldValue) ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer: Expected data for field `%s` to be an object.', storageKey) : __webpack_require__(10)(false) : void 0;
    var nextID = fieldValue.id ||
    // Reuse previously generated client IDs
    __webpack_require__(17).getLinkedRecordID(record, storageKey) || __webpack_require__(76)(__webpack_require__(17).getDataID(record), storageKey);
    !(typeof nextID === 'string') ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer: Expected id on field `%s` to be a string.', storageKey) : __webpack_require__(10)(false) : void 0;
    __webpack_require__(17).setLinkedRecordID(record, storageKey, nextID);
    var nextRecord = this._recordSource.get(nextID);
    if (!nextRecord) {
      var typeName = field.concreteType || this._getRecordType(fieldValue);
      nextRecord = __webpack_require__(17).create(nextID, typeName);
      this._recordSource.set(nextID, nextRecord);
    } else if (false) {
      this._validateRecordType(nextRecord, field, fieldValue);
    }
    this._traverseSelections(field, nextRecord, fieldValue);
  };

  RelayResponseNormalizer.prototype._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
    var _this2 = this;

    !Array.isArray(fieldValue) ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer: Expected data for field `%s` to be an array ' + 'of objects.', storageKey) : __webpack_require__(10)(false) : void 0;
    var prevIDs = __webpack_require__(17).getLinkedRecordIDs(record, storageKey);
    var nextIDs = [];
    fieldValue.forEach(function (item, nextIndex) {
      // validate response data
      if (item == null) {
        nextIDs.push(item);
        return;
      }
      !((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer: Expected elements for field `%s` to be ' + 'objects.', storageKey) : __webpack_require__(10)(false) : void 0;

      var nextID = item.id || prevIDs && prevIDs[nextIndex] || // Reuse previously generated client IDs
      __webpack_require__(76)(__webpack_require__(17).getDataID(record), storageKey, nextIndex);
      !(typeof nextID === 'string') ?  false ? require('fbjs/lib/invariant')(false, 'RelayResponseNormalizer: Expected id of elements of field `%s` to ' + 'be strings.', storageKey) : __webpack_require__(10)(false) : void 0;

      nextIDs.push(nextID);
      var nextRecord = _this2._recordSource.get(nextID);
      if (!nextRecord) {
        var typeName = field.concreteType || _this2._getRecordType(item);
        nextRecord = __webpack_require__(17).create(nextID, typeName);
        _this2._recordSource.set(nextID, nextRecord);
      } else if (false) {
        _this2._validateRecordType(nextRecord, field, item);
      }
      _this2._traverseSelections(field, nextRecord, item);
    });
    __webpack_require__(17).setLinkedRecordIDs(record, storageKey, nextIDs);
  };

  /**
   * Warns if the type of the record does not match the type of the field/payload.
   */

  RelayResponseNormalizer.prototype._validateRecordType = function _validateRecordType(record, field, payload) {
    var typeName = field.concreteType || this._getRecordType(payload);
     false ? require('fbjs/lib/warning')(require('./RelayModernRecord').getType(record) === typeName, 'RelayResponseNormalizer: Invalid record `%s`. Expected %s to be ' + 'be consistent, but the record was assigned conflicting types `%s` ' + 'and `%s`. The GraphQL server likely violated the globally unique ' + 'id requirement by returning the same id for different objects.', require('./RelayModernRecord').getDataID(record), require('./RelayStoreUtils').TYPENAME_KEY, require('./RelayModernRecord').getType(record), typeName) : void 0;
  };

  return RelayResponseNormalizer;
}();

// eslint-disable-next-line no-func-assign


normalize = __webpack_require__(244).instrument('RelayResponseNormalizer.normalize', normalize);

module.exports = { normalize: normalize };

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */

function applyRelayModernOptimisticMutation(environment, config) {
  !__webpack_require__(250)(environment) ?  false ? require('fbjs/lib/invariant')(false, 'commitRelayModernMutation: expect `environment` to be an instance of ' + '`RelayModernEnvironment`.') : __webpack_require__(10)(false) : void 0;
  var _environment$unstable = environment.unstable_internal,
      createOperationSelector = _environment$unstable.createOperationSelector,
      getRequest = _environment$unstable.getRequest;

  var mutation = getRequest(config.mutation);
  if (mutation.operationKind !== 'mutation') {
    throw new Error('commitRelayModernMutation: Expected mutation operation');
  }
  var optimisticUpdater = config.optimisticUpdater;
  var configs = config.configs,
      optimisticResponse = config.optimisticResponse,
      variables = config.variables;

  var operation = createOperationSelector(mutation, variables);
  if (configs) {
    var _RelayDeclarativeMuta = __webpack_require__(136).convert(configs, mutation, optimisticUpdater);

    optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
  }

  return environment.applyUpdate({
    operation: operation,
    selectorStoreUpdater: optimisticUpdater,
    response: optimisticResponse
  });
}

module.exports = applyRelayModernOptimisticMutation;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



function commitLocalUpdate(environment, updater) {
  environment.commitUpdate(updater);
}

module.exports = commitLocalUpdate;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Higher-level helper function to execute a mutation against a specific
 * environment.
 */

function commitRelayModernMutation(environment, config) {
  !__webpack_require__(250)(environment) ?  false ? require('fbjs/lib/invariant')(false, 'commitRelayModernMutation: expect `environment` to be an instance of ' + '`RelayModernEnvironment`.') : __webpack_require__(10)(false) : void 0;
  var _environment$unstable = environment.unstable_internal,
      createOperationSelector = _environment$unstable.createOperationSelector,
      getRequest = _environment$unstable.getRequest;

  var mutation = getRequest(config.mutation);
  if (mutation.operationKind !== 'mutation') {
    throw new Error('commitRelayModernMutation: Expected mutation operation');
  }
  var optimisticResponse = config.optimisticResponse,
      optimisticUpdater = config.optimisticUpdater,
      updater = config.updater;
  var configs = config.configs,
      onError = config.onError,
      variables = config.variables,
      uploadables = config.uploadables;

  var operation = createOperationSelector(mutation, variables);
  // TODO: remove this check after we fix flow.
  if (typeof optimisticResponse === 'function') {
    optimisticResponse = optimisticResponse();
     false ? require('fbjs/lib/warning')(false, 'commitRelayModernMutation: Expected `optimisticResponse` to be an object, ' + 'received a function.') : void 0;
  }
  if (optimisticResponse && mutation.fragment.selections && mutation.fragment.selections.length === 1 && mutation.fragment.selections[0].kind === 'LinkedField') {
    var mutationRoot = mutation.fragment.selections[0].name;
     false ? require('fbjs/lib/warning')(optimisticResponse[mutationRoot], 'commitRelayModernMutation: Expected `optimisticResponse` to be wrapped ' + 'in mutation name `%s`', mutationRoot) : void 0;
  }
  if (configs) {
    var _RelayDeclarativeMuta = __webpack_require__(136).convert(configs, mutation, optimisticUpdater, updater);

    optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    updater = _RelayDeclarativeMuta.updater;
  }
  return environment.executeMutation({
    operation: operation,
    optimisticResponse: optimisticResponse,
    optimisticUpdater: optimisticUpdater,
    updater: updater,
    uploadables: uploadables
  }).subscribeLegacy({
    onNext: function onNext(payload) {
      // NOTE: commitRelayModernMutation has a non-standard use of
      // onCompleted() by calling it on every next value. It may be called
      // multiple times if a network request produces multiple responses.
      var onCompleted = config.onCompleted;

      if (onCompleted) {
        var snapshot = environment.lookup(operation.fragment);
        onCompleted(snapshot.data, payload.response.errors);
      }
    },
    onError: onError
  });
}

module.exports = commitRelayModernMutation;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function createRelayNetworkLogger(LoggerTransaction) {
  return {
    wrapFetch: function wrapFetch(fetch, graphiQLPrinter) {
      return function (request, variables, cacheConfig, uploadables) {
        var wrapped = wrapExecute(__webpack_require__(175).convertFetch(fetch), LoggerTransaction, graphiQLPrinter);
        return wrapped(request, variables, cacheConfig, uploadables);
      };
    },
    wrapSubscribe: function wrapSubscribe(subscribe, graphiQLPrinter) {
      return function (request, variables, cacheConfig) {
        var wrapped = wrapExecute(__webpack_require__(175).convertSubscribe(subscribe), LoggerTransaction, graphiQLPrinter);
        return wrapped(request, variables, cacheConfig);
      };
    }
  };
}

function wrapExecute(execute, LoggerTransaction, graphiQLPrinter) {
  return function (request, variables, cacheConfig, uploadables) {
    var transaction = void 0;

    function addLogs(error, response, status) {
      // Only print GraphiQL links for non-batch requests.
      if (graphiQLPrinter && request.kind === __webpack_require__(18).REQUEST) {
        transaction.addLog('GraphiQL', graphiQLPrinter(request, variables));
      }
      transaction.addLog('Cache Config', cacheConfig);
      transaction.addLog('Variables', JSON.stringify(variables, null, 2));
      if (status) {
        transaction.addLog('Status', status);
      }
      if (error) {
        transaction.addLog('Error', error);
      }
      if (response) {
        transaction.addLog('Response', response);
      }
    }

    function flushLogs(error, response, status) {
      addLogs(error, response, status);
      transaction.flushLogs(error, response, status);
    }

    function commitLogs(error, response, status) {
      addLogs(error, response, status);
      transaction.commitLogs(error, response, status);
    }

    var observable = execute(request, variables, cacheConfig, uploadables);

    var isSubscription = request.operationKind === 'subscription';

    return observable['do']({
      start: function start() {
        transaction = new LoggerTransaction({
          request: request,
          variables: variables,
          cacheConfig: cacheConfig,
          uploadables: uploadables
        });
        console.time && console.time(transaction.getIdentifier());
        if (isSubscription) {
          flushLogs(null, null, 'subscription is sent.');
        }
      },
      next: function next(payload) {
        flushLogs(null, payload);
        console.time && console.time(transaction.getIdentifier());
      },
      error: function error(_error) {
        return commitLogs(_error, null, null);
      },
      complete: function complete() {
        if (isSubscription) {
          commitLogs(null, null, 'subscription was closed.');
        } else {
          // the last `next` already flushed the logs, just mark as committed
          // without spamming the logs
          transaction.markCommitted();
        }
      },
      unsubscribe: function unsubscribe() {
        return commitLogs(null, null, isSubscription ? 'subscription is unsubscribed.' : 'execution is unsubscribed.');
      }
    });
  };
}

module.exports = createRelayNetworkLogger;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



/**
 * A helper function to fetch the results of a query. Note that results for
 * fragment spreads are masked: fields must be explicitly listed in the query in
 * order to be accessible in the result object.
 */

function fetchRelayModernQuery(environment, taggedNode, variables, cacheConfig) {
  !environment.unstable_internal ?  false ? require('fbjs/lib/invariant')(false, 'fetchRelayModernQuery: Expected a valid Relay environment, got `%s`.', environment) : __webpack_require__(10)(false) : void 0;
  var _environment$unstable = environment.unstable_internal,
      createOperationSelector = _environment$unstable.createOperationSelector,
      getRequest = _environment$unstable.getRequest;

  var query = getRequest(taggedNode);
  if (query.kind === __webpack_require__(18).BATCH_REQUEST) {
    throw new Error('fetchRelayModernQuery: Batch request not supported in this API.');
  }
  if (query.operationKind !== 'query') {
    throw new Error('fetchRelayModernQuery: Expected query operation');
  }
  var operation = createOperationSelector(query, variables);

  return environment.execute({ operation: operation, cacheConfig: cacheConfig }).map(function () {
    return environment.lookup(operation.fragment).data;
  }).toPromise();
}

module.exports = fetchRelayModernQuery;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



function hasOverlappingIDs(snapshot, updatedRecordIDs) {
  var keys = Object.keys(snapshot.seenRecords);
  for (var ii = 0; ii < keys.length; ii++) {
    if (updatedRecordIDs.hasOwnProperty(keys[ii])) {
      return true;
    }
  }
  return false;
}

module.exports = hasOverlappingIDs;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



// As early as possible, check for the existence of the JavaScript globals which
// Relay Runtime relies upon, and produce a clear message if they do not exist.

if (false) {
  if (typeof Map !== 'function' || typeof Set !== 'function' || typeof Promise !== 'function' || typeof Object.assign !== 'function') {
    throw new Error('relay-runtime requires Map, Set, Promise, and Object.assign to exist. ' + 'Use a polyfill to provide these for older browsers.');
  }
}

/**
 * The public interface to Relay Runtime.
 */
module.exports = {
  // Core API
  Environment: __webpack_require__(733),
  Network: __webpack_require__(735),
  Observable: __webpack_require__(176),
  QueryResponseCache: __webpack_require__(738),
  RecordSource: __webpack_require__(115),
  Store: __webpack_require__(732),

  areEqualSelectors: __webpack_require__(75).areEqualSelectors,
  createFragmentSpecResolver: __webpack_require__(75).createFragmentSpecResolver,
  createOperationSelector: __webpack_require__(75).createOperationSelector,
  getDataIDsFromObject: __webpack_require__(75).getDataIDsFromObject,
  getFragment: __webpack_require__(116).getFragment,
  getRequest: __webpack_require__(116).getRequest,
  // TODO (T23201154) remove in a future Relay release.
  getOperation: function getOperation() {
    if (false) {
      require('fbjs/lib/warning')(false, 'getOperation() deprecated. Use getRequest().');
    }
    return __webpack_require__(116).getRequest.apply(null, arguments);
  },
  getSelector: __webpack_require__(75).getSelector,
  getSelectorList: __webpack_require__(75).getSelectorList,
  getSelectorsFromObject: __webpack_require__(75).getSelectorsFromObject,
  getStorageKey: __webpack_require__(12).getStorageKey,
  getVariablesFromObject: __webpack_require__(75).getVariablesFromObject,
  graphql: __webpack_require__(116).graphql,

  // Declarative mutation API
  MutationTypes: __webpack_require__(136).MutationTypes,
  RangeOperations: __webpack_require__(136).RangeOperations,

  // Extensions
  ConnectionHandler: __webpack_require__(83),
  ViewerHandler: __webpack_require__(360),

  // Helpers (can be implemented via the above API)
  applyOptimisticMutation: __webpack_require__(742),
  commitLocalUpdate: __webpack_require__(743),
  commitMutation: __webpack_require__(744),
  fetchQuery: __webpack_require__(746),
  isRelayModernEnvironment: __webpack_require__(250),
  requestSubscription: __webpack_require__(750),

  // Configuration interface for legacy or special uses
  ConnectionInterface: __webpack_require__(84),

  // Utilities
  RelayProfiler: __webpack_require__(244),

  // INTERNAL-ONLY: These exports might be removed at any point.
  RelayConcreteNode: __webpack_require__(18),
  RelayError: __webpack_require__(358),
  RelayNetworkLoggerTransaction: __webpack_require__(736),
  DEFAULT_HANDLE_KEY: __webpack_require__(357).DEFAULT_HANDLE_KEY,
  ROOT_ID: __webpack_require__(12).ROOT_ID,

  createRelayNetworkLogger: __webpack_require__(745),
  deepFreeze: __webpack_require__(362),
  generateClientID: __webpack_require__(76),
  getRelayHandleKey: __webpack_require__(249),
  isScalarAndEqual: __webpack_require__(363),
  recycleNodesInto: __webpack_require__(365),
  simpleClone: __webpack_require__(751),
  stableCopy: __webpack_require__(178)
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */



function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

module.exports = isPromise;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



function requestRelaySubscription(environment, config) {
  var _environment$unstable = environment.unstable_internal,
      createOperationSelector = _environment$unstable.createOperationSelector,
      getRequest = _environment$unstable.getRequest;

  var subscription = getRequest(config.subscription);
  if (subscription.operationKind !== 'subscription') {
    throw new Error('requestRelaySubscription: Must use Subscription operation');
  }
  var configs = config.configs,
      onCompleted = config.onCompleted,
      onError = config.onError,
      onNext = config.onNext,
      variables = config.variables;

  var operation = createOperationSelector(subscription, variables);

   false ? require('fbjs/lib/warning')(!(config.updater && configs), 'requestRelaySubscription: Expected only one of `updater` and `configs` to be provided') : void 0;

  var _ref = configs ? __webpack_require__(136).convert(configs, subscription, null /* optimisticUpdater */
  , config.updater) : config,
      updater = _ref.updater;

  return environment.execute({
    operation: operation,
    updater: updater,
    cacheConfig: { force: true }
  }).map(function () {
    return environment.lookup(operation.fragment).data;
  }).subscribeLegacy({
    onNext: onNext,
    onError: onError,
    onCompleted: onCompleted
  });
}

module.exports = requestRelaySubscription;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * A helper to create a deep clone of a value, plain Object, or array of such.
 *
 * Does not support RegExp, Date, other classes, or self-referential values.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function simpleClone(value) {
  if (Array.isArray(value)) {
    return value.map(simpleClone);
  } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    return __webpack_require__(753)(value, simpleClone);
  } else {
    return value;
  }
}

module.exports = simpleClone;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = __webpack_require__(455);

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(752);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var resolvedPromise = Promise.resolve();

/**
 * An alternative to setImmediate based on Promise.
 */
function resolveImmediate(callback) {
  resolvedPromise.then(callback)["catch"](throwNext);
}

function throwNext(error) {
  setTimeout(function () {
    throw error;
  }, 0);
}

module.exports = resolveImmediate;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Simple function for formatting strings.
 *
 * Replaces placeholders with values passed as extra arguments
 *
 * @param {string} format the base string
 * @param ...args the values to insert
 * @return {string} the replaced string
 */

function sprintf(format) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var index = 0;
  return format.replace(/%s/g, function (match) {
    return args[index++];
  });
}

module.exports = sprintf;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'undefined' ? 'undefined' : _typeof(dep);
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if ((typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors)) !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + (typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors))));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.1
 * schedule.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: !0 });var d = !("undefined" === typeof window || !window.document || !window.document.createElement),
    f = Date,
    g = "function" === typeof setTimeout ? setTimeout : void 0,
    h = "function" === typeof clearTimeout ? clearTimeout : void 0,
    l = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
    m = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
    n = "object" === (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" === typeof performance.now;
exports.unstable_now = void 0;if (n) {
  var p = performance;exports.unstable_now = function () {
    return p.now();
  };
} else exports.unstable_now = function () {
  return f.now();
};exports.unstable_scheduleWork = void 0;exports.unstable_cancelScheduledWork = void 0;
if (d) {
  var q = null,
      r = null,
      t = -1,
      u = !1,
      v = !1,
      w = void 0,
      x = void 0,
      y = function y(a) {
    w = l(function (b) {
      h(x);a(b);
    });x = g(function () {
      m(w);a(exports.unstable_now());
    }, 100);
  },
      z = 0,
      A = 33,
      B = 33,
      C = { didTimeout: !1, timeRemaining: function timeRemaining() {
      var a = z - exports.unstable_now();return 0 < a ? a : 0;
    } },
      E = function E(a, b) {
    var c = a.scheduledCallback,
        e = !1;try {
      c(b), e = !0;
    } finally {
      exports.unstable_cancelScheduledWork(a), e || (u = !0, window.postMessage(D, "*"));
    }
  },
      D = "__reactIdleCallback$" + Math.random().toString(36).slice(2);window.addEventListener("message", function (a) {
    if (a.source === window && a.data === D && (u = !1, null !== q)) {
      if (null !== q) {
        var b = exports.unstable_now();if (!(-1 === t || t > b)) {
          a = -1;for (var c = [], e = q; null !== e;) {
            var k = e.timeoutTime;-1 !== k && k <= b ? c.push(e) : -1 !== k && (-1 === a || k < a) && (a = k);e = e.next;
          }if (0 < c.length) for (C.didTimeout = !0, b = 0, e = c.length; b < e; b++) {
            E(c[b], C);
          }t = a;
        }
      }for (a = exports.unstable_now(); 0 < z - a && null !== q;) {
        a = q, C.didTimeout = !1, E(a, C), a = exports.unstable_now();
      }null === q || v || (v = !0, y(F));
    }
  }, !1);var F = function F(a) {
    v = !1;var b = a - z + B;b < B && A < B ? (8 > b && (b = 8), B = b < A ? A : b) : A = b;z = a + B;u || (u = !0, window.postMessage(D, "*"));
  };exports.unstable_scheduleWork = function (a, b) {
    var c = -1;null != b && "number" === typeof b.timeout && (c = exports.unstable_now() + b.timeout);if (-1 === t || -1 !== c && c < t) t = c;a = { scheduledCallback: a, timeoutTime: c, prev: null, next: null };null === q ? q = a : (b = a.prev = r, null !== b && (b.next = a));r = a;v || (v = !0, y(F));return a;
  };exports.unstable_cancelScheduledWork = function (a) {
    if (null !== a.prev || q === a) {
      var b = a.next,
          c = a.prev;a.next = null;a.prev = null;null !== b ? null !== c ? (c.next = b, b.prev = c) : (b.prev = null, q = b) : null !== c ? (c.next = null, r = c) : r = q = null;
    }
  };
} else {
  var G = new Map();exports.unstable_scheduleWork = function (a) {
    var b = { scheduledCallback: a, timeoutTime: 0, next: null, prev: null },
        c = g(function () {
      a({ timeRemaining: function timeRemaining() {
          return Infinity;
        }, didTimeout: !1 });
    });G.set(a, c);return b;
  };exports.unstable_cancelScheduledWork = function (a) {
    var b = G.get(a.scheduledCallback);G.delete(a);h(b);
  };
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(757);
} else {
  module.exports = require('./cjs/schedule.development.js');
}

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(2492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Radio__["a"]; });



/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A column sub-component for Grid.
 */

function GridColumn(props) {
  var children = props.children,
      className = props.className,
      computer = props.computer,
      color = props.color,
      floated = props.floated,
      largeScreen = props.largeScreen,
      mobile = props.mobile,
      only = props.only,
      stretched = props.stretched,
      tablet = props.tablet,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      widescreen = props.widescreen,
      width = props.width;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["t" /* useMultipleProp */])(only, 'only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(computer, 'wide computer'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(largeScreen, 'wide large screen'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(mobile, 'wide mobile'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(tablet, 'wide tablet'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(widescreen, 'wide widescreen'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(width, 'wide'), 'column', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(GridColumn, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(GridColumn, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

GridColumn.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"];
GridColumn.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid column can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A column can specify a width for a computer. */
  computer: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can sit flush against the left or right edge of a row. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A column can specify a width for a large screen device. */
  largeScreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify a width for a mobile device. */
  mobile: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A column can stretch its contents to take up the entire grid or row height. */
  stretched: PropTypes.bool,

  /** A column can specify a width for a tablet device. */
  tablet: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A column can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A column can specify a width for a wide screen device. */
  widescreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** Represents width of column. */
  width: customPropTypes.every([customPropTypes.disallow(['computer', 'largeScreen', 'mobile', 'tablet', 'widescreen']), PropTypes.oneOf(SUI.WIDTHS)])
} : {};
GridColumn.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(GridColumn, function (children) {
  return {
    children: children
  };
});
/* harmony default export */ __webpack_exports__["a"] = (GridColumn);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startCase__ = __webpack_require__(2768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(90);















/**
 * A menu can contain an item.
 */

var MenuItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(MenuItem, _Component);

  function MenuItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MenuItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          disabled = _this$props.disabled,
          fitted = _this$props.fitted,
          header = _this$props.header,
          icon = _this$props.icon,
          link = _this$props.link,
          name = _this$props.name,
          onClick = _this$props.onClick,
          position = _this$props.position;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(color, position, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(icon === true || icon && !(name || content), 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(header, 'header'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["h" /* useKeyOrValueAndKey */])(fitted, 'fitted'), 'item', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(MenuItem, this.props, function () {
        if (onClick) return 'a';
      });
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(MenuItem, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(content) ? __WEBPACK_IMPORTED_MODULE_8_lodash_startCase___default()(name) : content);
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(MenuItem, "handledProps", ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"]);


MenuItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A menu item can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A menu item can be disabled. */
  disabled: PropTypes.bool,

  /** A menu item or menu can remove element padding, vertically or horizontally. */
  fitted: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A menu item may include a header or may itself be a header. */
  header: PropTypes.bool,

  /** MenuItem can be only icon. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** MenuItem index inside Menu. */
  index: PropTypes.number,

  /** A menu item can be link. */
  link: PropTypes.bool,

  /** Internal name of the MenuItem. */
  name: PropTypes.string,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A menu item can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
MenuItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["e" /* createShorthandFactory */])(MenuItem, function (val) {
  return {
    content: val,
    name: val
  };
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A message list can contain an item.
 */

function MessageItem(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageItem, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageItem, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageItem.handledProps = ["as", "children", "className", "content"];
MessageItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageItem.defaultProps = {
  as: 'li'
};
MessageItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(MessageItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageItem);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A table can have a header.
 */

function TableHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fullWidth = props.fullWidth;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fullWidth, 'full-width'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TableHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

TableHeader.handledProps = ["as", "children", "className", "content", "fullWidth"];
TableHeader.defaultProps = {
  as: 'thead'
};
TableHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
  fullWidth: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Label_Label__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonContent__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ButtonGroup__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ButtonOr__ = __webpack_require__(1307);





















/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */

var Button =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Button, _Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var _this$props = _this.props,
          attached = _this$props.attached,
          label = _this$props.label;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(attached) || !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(label)) return 'div';
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function (ElementType) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
      if (ElementType === 'div') return 0;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.ref.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "hasIconClass", function () {
      var _this$props3 = _this.props,
          labelPosition = _this$props3.labelPosition,
          children = _this$props3.children,
          content = _this$props3.content,
          icon = _this$props3.icon;
      if (icon === true) return true;
      return icon && (labelPosition || __WEBPACK_IMPORTED_MODULE_15__lib__["d" /* childrenUtils */].isNil(children) && __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(content));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Button, [{
    key: "computeButtonAriaRole",
    value: function computeButtonAriaRole(ElementType) {
      var role = this.props.role;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(role)) return role;
      if (ElementType !== 'button') return 'button';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          active = _this$props4.active,
          animated = _this$props4.animated,
          attached = _this$props4.attached,
          basic = _this$props4.basic,
          children = _this$props4.children,
          circular = _this$props4.circular,
          className = _this$props4.className,
          color = _this$props4.color,
          compact = _this$props4.compact,
          content = _this$props4.content,
          disabled = _this$props4.disabled,
          floated = _this$props4.floated,
          fluid = _this$props4.fluid,
          icon = _this$props4.icon,
          inverted = _this$props4.inverted,
          label = _this$props4.label,
          labelPosition = _this$props4.labelPosition,
          loading = _this$props4.loading,
          negative = _this$props4.negative,
          positive = _this$props4.positive,
          primary = _this$props4.primary,
          secondary = _this$props4.secondary,
          size = _this$props4.size,
          toggle = _this$props4.toggle;
      var baseClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(this.hasIconClass(), 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(primary, 'primary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["h" /* useKeyOrValueAndKey */])(animated, 'animated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'));
      var labeledClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["h" /* useKeyOrValueAndKey */])(labelPosition || !!label, 'labeled'));
      var wrapperClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["g" /* useValueAndKey */])(floated, 'floated'));
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* getUnhandledProps */])(Button, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* getElementType */])(Button, this.props, this.computeElementType);
      var tabIndex = this.computeTabIndex(ElementType);

      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(label)) {
        var buttonClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', baseClasses, 'button', className);
        var containerClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', labeledClasses, 'button', className, wrapperClasses);
        var labelElement = __WEBPACK_IMPORTED_MODULE_17__Label_Label__["a" /* default */].create(label, {
          defaultProps: {
            basic: true,
            pointing: labelPosition === 'left' ? 'right' : 'left'
          },
          autoGenerateKey: false
        });
        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
          className: containerClasses,
          onClick: this.handleClick
        }), labelPosition === 'left' && labelElement, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__addons_Ref__["a" /* default */], {
          innerRef: this.ref
        }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("button", {
          className: buttonClasses,
          "aria-pressed": toggle ? !!active : undefined,
          disabled: disabled,
          tabIndex: tabIndex
        }, __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__["a" /* default */].create(icon, {
          autoGenerateKey: false
        }), " ", content)), (labelPosition === 'right' || !labelPosition) && labelElement);
      }

      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
      var hasChildren = !__WEBPACK_IMPORTED_MODULE_15__lib__["d" /* childrenUtils */].isNil(children);
      var role = this.computeButtonAriaRole(ElementType);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__addons_Ref__["a" /* default */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        "aria-pressed": toggle ? !!active : undefined,
        disabled: disabled && ElementType === 'button' || undefined,
        onClick: this.handleClick,
        role: role,
        tabIndex: tabIndex
      }), hasChildren && children, !hasChildren && __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), !hasChildren && content));
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "defaultProps", {
  as: 'button'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Content", __WEBPACK_IMPORTED_MODULE_18__ButtonContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Group", __WEBPACK_IMPORTED_MODULE_19__ButtonGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Or", __WEBPACK_IMPORTED_MODULE_20__ButtonOr__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "handledProps", ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle"]);

Button.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A button can show it is currently the active user selection. */
  active: PropTypes.bool,

  /** A button can animate to show hidden content. */
  animated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['fade', 'vertical'])]),

  /** A button can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** A basic button is less pronounced. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([PropTypes.node, customPropTypes.disallow(['label']), customPropTypes.givenProps({
    icon: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired, PropTypes.element.isRequired])
  }, customPropTypes.disallow(['icon']))]),

  /** A button can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A button can have different colors */
  color: PropTypes.oneOf([].concat(_toConsumableArray(SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),

  /** A button can reduce its padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A button can show it is currently unable to be interacted with. */
  disabled: PropTypes.bool,

  /** A button can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A button can take the width of its container. */
  fluid: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon />. */
  icon: customPropTypes.some([PropTypes.bool, PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A button can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Add a Label by text, props object, or pass a <Label />. */
  label: customPropTypes.some([PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A labeled button can format a Label or Icon to appear on the left or right. */
  labelPosition: PropTypes.oneOf(['right', 'left']),

  /** A button can show a loading indicator. */
  loading: PropTypes.bool,

  /** A button can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A button can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** A button can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** The role of the HTML element. */
  role: PropTypes.string,

  /** A button can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** A button can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A button can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A button can be formatted to toggle on and off. */
  toggle: PropTypes.bool
} : {};
Button.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["e" /* createShorthandFactory */])(Button, function (value) {
  return {
    content: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(2519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });



/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Image_Image__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LabelDetail__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LabelGroup__ = __webpack_require__(1315);


















/**
 * A label displays content classification.
 */

var Label =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Label, _Component);

  function Label() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Label);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Label)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onRemove', e, _this.props);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          attached = _this$props.attached,
          basic = _this$props.basic,
          children = _this$props.children,
          circular = _this$props.circular,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          corner = _this$props.corner,
          detail = _this$props.detail,
          empty = _this$props.empty,
          floating = _this$props.floating,
          horizontal = _this$props.horizontal,
          icon = _this$props.icon,
          image = _this$props.image,
          onRemove = _this$props.onRemove,
          pointing = _this$props.pointing,
          removeIcon = _this$props.removeIcon,
          ribbon = _this$props.ribbon,
          size = _this$props.size,
          tag = _this$props.tag;
      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && "".concat(pointing, " pointing") || (pointing === 'above' || pointing === 'below') && "pointing ".concat(pointing);
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', color, pointingClass, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(empty, 'empty'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(image === true, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(tag, 'tag'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["h" /* useKeyOrValueAndKey */])(corner, 'corner'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["h" /* useKeyOrValueAndKey */])(ribbon, 'ribbon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["g" /* useValueAndKey */])(attached, 'attached'), 'label', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(Label, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(Label, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      var removeIconShorthand = __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default()(removeIcon) ? 'delete' : removeIcon;
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        className: classes,
        onClick: this.handleClick
      }, rest), __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), typeof image !== 'boolean' && __WEBPACK_IMPORTED_MODULE_15__Image_Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      }), content, __WEBPACK_IMPORTED_MODULE_16__LabelDetail__["a" /* default */].create(detail, {
        autoGenerateKey: false
      }), onRemove && __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__["a" /* default */].create(removeIconShorthand, {
        autoGenerateKey: false,
        overrideProps: this.handleIconOverrides
      }));
    }
  }]);

  return Label;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "Detail", __WEBPACK_IMPORTED_MODULE_16__LabelDetail__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "Group", __WEBPACK_IMPORTED_MODULE_17__LabelGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "handledProps", ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "removeIcon", "ribbon", "size", "tag"]);


Label.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A label can be active. */
  active: PropTypes.bool,

  /** A label can attach to a content segment. */
  attached: PropTypes.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),

  /** A label can reduce its complexity. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A label can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the label. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A label can position itself in the corner of an element. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Shorthand for LabelDetail. */
  detail: customPropTypes.itemShorthand,

  /** Formats the label as a dot. */
  empty: customPropTypes.every([PropTypes.bool, customPropTypes.demand(['circular'])]),

  /** Float above another element in the upper right corner. */
  floating: PropTypes.bool,

  /** A horizontal label is formatted to label content along-side it horizontally. */
  horizontal: PropTypes.bool,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
  image: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Adds an "x" icon, called when "x" is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onRemove: PropTypes.func,

  /** A label can point to content next to it. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['above', 'below', 'left', 'right'])]),

  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
  removeIcon: customPropTypes.itemShorthand,

  /** A label can appear as a ribbon attaching itself to an element. */
  ribbon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A label can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A label can appear as a tag. */
  tag: PropTypes.bool
} : {};
Label.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["e" /* createShorthandFactory */])(Label, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListDescription__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListHeader__ = __webpack_require__(487);







/**
 * A list item can contain a content.
 */

function ListContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      floated = props.floated,
      header = props.header,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__ListHeader__["a" /* default */].create(header), __WEBPACK_IMPORTED_MODULE_5__ListDescription__["a" /* default */].create(description), content);
}

ListContent.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"];
ListContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** An list content can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListContent);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_Icon__ = __webpack_require__(484);






/**
 * A list item can contain an icon.
 */

function ListIcon(props) {
  var className = props.className,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListIcon, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon_Icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

ListIcon.handledProps = ["className", "verticalAlign"];
ListIcon.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListIcon.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListIcon, function (name) {
  return {
    name: name
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListIcon);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);






function StepDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StepDescription.handledProps = ["as", "children", "className", "content"];
StepDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepDescription);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A step can contain a title.
 */

function StepTitle(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('title', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepTitle, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepTitle, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StepTitle.handledProps = ["as", "children", "className", "content"];
StepTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepTitle.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepTitle, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepTitle);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numberToWordMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = numberToWord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);

var numberToWordMap = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine',
  10: 'ten',
  11: 'eleven',
  12: 'twelve',
  13: 'thirteen',
  14: 'fourteen',
  15: 'fifteen',
  16: 'sixteen'
  /**
   * Return the number word for numbers 1-16.
   * Returns strings or numbers as is if there is no corresponding word.
   * Returns an empty string if value is not a string or number.
   * @param {string|number} value The value to convert to a word.
   * @returns {string}
   */

};
function numberToWord(value) {
  var type = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value);

  if (type === 'string' || type === 'number') {
    return numberToWordMap[value] || value;
  }

  return '';
}

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A content sub-component for Accordion component.
 */

function AccordionContent(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(AccordionContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(AccordionContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

AccordionContent.handledProps = ["active", "as", "children", "className", "content"];
AccordionContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not the content is visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
AccordionContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(AccordionContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (AccordionContent);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccordionTitle__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccordionContent__ = __webpack_require__(772);













/**
 * A panel sub-component for Accordion component.
 */

var AccordionPanel =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AccordionPanel, _Component);

  function AccordionPanel() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AccordionPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AccordionPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTitleOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, titleProps) {
          __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(predefinedProps, 'onClick', e, titleProps);

          __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onTitleClick', e, titleProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AccordionPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          content = _this$props.content,
          index = _this$props.index,
          title = _this$props.title;
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_11__AccordionTitle__["a" /* default */].create(title, {
        autoGenerateKey: false,
        defaultProps: {
          active: active,
          index: index
        },
        overrideProps: this.handleTitleOverrides
      }), __WEBPACK_IMPORTED_MODULE_12__AccordionContent__["a" /* default */].create(content, {
        autoGenerateKey: false,
        defaultProps: {
          active: active
        }
      }));
    }
  }]);

  return AccordionPanel;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AccordionPanel, "handledProps", ["active", "content", "index", "onTitleClick", "title"]);

AccordionPanel.propTypes =  false ? {
  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** A shorthand for Accordion.Content. */
  content: customPropTypes.itemShorthand,

  /** A panel index. */
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: PropTypes.func,

  /** A shorthand for Accordion.Title. */
  title: customPropTypes.itemShorthand
} : {};
AccordionPanel.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["e" /* createShorthandFactory */])(AccordionPanel, null);
/* harmony default export */ __webpack_exports__["a"] = (AccordionPanel);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(90);















/**
 * A title sub-component for Accordion component.
 */

var AccordionTitle =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AccordionTitle, _Component);

  function AccordionTitle() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AccordionTitle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AccordionTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AccordionTitle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          icon = _this$props.icon;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active'), 'title', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(AccordionTitle, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(AccordionTitle, this.props);
      var iconValue = __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(icon) ? 'dropdown' : icon;

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(iconValue, {
        autoGenerateKey: false
      }), content);
    }
  }]);

  return AccordionTitle;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AccordionTitle, "handledProps", ["active", "as", "children", "className", "content", "icon", "index", "onClick"]);


AccordionTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** AccordionTitle index inside Accordion. */
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
AccordionTitle.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["e" /* createShorthandFactory */])(AccordionTitle, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A card can contain a description with one or more paragraphs.
 */

function CardDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardDescription, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardDescription.handledProps = ["as", "children", "className", "content", "textAlign"];
CardDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardDescription);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A card can contain a header.
 */

function CardHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardHeader, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardHeader.handledProps = ["as", "children", "className", "content", "textAlign"];
CardHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card header can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A card can contain content metadata.
 */

function CardMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardMeta, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardMeta.handledProps = ["as", "children", "className", "content", "textAlign"];
CardMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card meta can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardMeta);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedExtra__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeedMeta__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedSummary__ = __webpack_require__(783);










function FeedContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      extraImages = props.extraImages,
      extraText = props.extraText,
      date = props.date,
      meta = props.meta,
      summary = props.summary;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__FeedSummary__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, summary, {
    autoGenerateKey: false
  }), content, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      text: true,
      content: val
    };
  }, extraText, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      images: val
    };
  }, extraImages, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__FeedMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }));
}

FeedContent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"];
FeedContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain a date. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: FeedExtra.propTypes.images,

  /** Shorthand for FeedExtra with text. */
  extraText: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedContent);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A feed can contain an extra content.
 */

function FeedExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      images = props.images,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(images, 'images'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(content || text, 'text'), 'extra', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(FeedExtra, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(FeedExtra, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  } // TODO need a "collection factory" to handle creating multiple image elements and their keys


  var imageElements = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images, function (image, index) {
    var key = [index, image].join('-');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createHTMLImage */])(image, {
      key: key
    });
  });

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, imageElements);
}

FeedExtra.handledProps = ["as", "children", "className", "content", "images", "text"];
FeedExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain additional information like a set of images. */
  images: customPropTypes.every([customPropTypes.disallow(['text']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.collectionShorthand])]),

  /** An event can contain additional text information. */
  text: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedExtra);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(90);






/**
 * An event can contain an image or icon label.
 */

function FeedLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon,
      image = props.image;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedLabel, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedLabel, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createHTMLImage */])(image));
}

FeedLabel.handledProps = ["as", "children", "className", "content", "icon", "image"];
FeedLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLabel);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(90);






/**
 * A feed can contain a like element.
 */

function FeedLike(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('like', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedLike, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedLike, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

FeedLike.handledProps = ["as", "children", "className", "content", "icon"];
FeedLike.defaultProps = {
  as: 'a'
};
FeedLike.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for icon. Mutually exclusive with children. */
  icon: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLike);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedLike__ = __webpack_require__(781);






/**
 * A feed can contain a meta.
 */

function FeedMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      like = props.like;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedMeta, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedLike__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, like, {
    autoGenerateKey: false
  }), content);
}

FeedMeta.handledProps = ["as", "children", "className", "content", "like"];
FeedMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedLike. */
  like: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedMeta);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedUser__ = __webpack_require__(784);







/**
 * A feed can contain a summary.
 */

function FeedSummary(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      date = props.date,
      user = props.user;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('summary', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedSummary, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedSummary, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedUser__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, user, {
    autoGenerateKey: false
  }), content, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }));
}

FeedSummary.handledProps = ["as", "children", "className", "content", "date", "user"];
FeedSummary.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedUser. */
  user: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedSummary);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A feed can contain a user element.
 */

function FeedUser(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('user', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedUser, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedUser, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

FeedUser.handledProps = ["as", "children", "className", "content"];
FeedUser.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
FeedUser.defaultProps = {
  as: 'a'
};
/* harmony default export */ __webpack_exports__["a"] = (FeedUser);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An item can contain a description with a single or multiple paragraphs.
 */

function ItemDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemDescription.handledProps = ["as", "children", "className", "content"];
ItemDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemDescription);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An item can contain extra content meant to be formatted separately from the main content.
 */

function ItemExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('extra', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemExtra, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemExtra, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemExtra.handledProps = ["as", "children", "className", "content"];
ItemExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemExtra.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemExtra, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemExtra);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An item can contain a header.
 */

function ItemHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemHeader.handledProps = ["as", "children", "className", "content"];
ItemHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemHeader);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An item can contain content metadata.
 */

function ItemMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemMeta, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemMeta.handledProps = ["as", "children", "className", "content"];
ItemMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemMeta.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemMeta, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemMeta);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    baseLodash = __webpack_require__(797);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    baseLodash = __webpack_require__(797);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257),
    root = __webpack_require__(99);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2681),
    mapCacheDelete = __webpack_require__(2682),
    mapCacheGet = __webpack_require__(2683),
    mapCacheHas = __webpack_require__(2684),
    mapCacheSet = __webpack_require__(2685);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(368),
    eq = __webpack_require__(374);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2604),
    isObjectLike = __webpack_require__(91);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(502);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

module.exports = castSlice;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1378);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(2717),
    overRest = __webpack_require__(1421),
    setToString = __webpack_require__(805);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(1419),
    noop = __webpack_require__(1439);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function (func) {
  return metaMap.get(func);
};

module.exports = getData;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1380),
    stubArray = __webpack_require__(1440);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(259);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2624),
    shortOut = __webpack_require__(1425);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(1383),
    baseIteratee = __webpack_require__(117),
    baseSome = __webpack_require__(2625),
    isArray = __webpack_require__(51),
    isIterateeCall = __webpack_require__(299);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(525);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1398);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}

module.exports = uniq;

/***/ }),
/* 810 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function () {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype,
      ObjProto = Object.prototype,
      FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeBind = FuncProto.bind,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function Ctor() {};

  // Create a safe reference to the Underscore object for use below.
  var _ = function _(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1:
        return function (value) {
          return func.call(context, value);
        };
      case 2:
        return function (value, other) {
          return func.call(context, value, other);
        };
      case 3:
        return function (value, index, collection) {
          return func.call(context, value, index, collection);
        };
      case 4:
        return function (accumulator, value, index, collection) {
          return func.call(context, accumulator, value, index, collection);
        };
    }
    return function () {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function cb(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function (value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
    return function (obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function baseCreate(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor();
    Ctor.prototype = null;
    return result;
  };

  var property = function property(key) {
    return function (obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function isArrayLike(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function (obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function (obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function (obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function (obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function (obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function (value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function (obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function (obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function (obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function (obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function (value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function (obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function (obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function (obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function (obj, iteratee, context) {
    var result = -Infinity,
        lastComputed = -Infinity,
        value,
        computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function (value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function (obj, iteratee, context) {
    var result = Infinity,
        lastComputed = Infinity,
        value,
        computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function (value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function (obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function (obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function (obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function (value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function (left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function group(behavior) {
    return function (obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function (value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function (result, value, key) {
    if (_.has(result, key)) result[key].push(value);else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function (result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function (result, value, key) {
    if (_.has(result, key)) result[key]++;else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function (obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function (obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function (obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [],
        fail = [];
    _.each(obj, function (value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function (array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function (array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function (array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function (array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function (array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function flatten(input, shallow, strict, startIndex) {
    var output = [],
        idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0,
            len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function (array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function (array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function (array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function () {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function (array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function (array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function (value) {
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function () {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function (array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function (list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function (array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function (array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0,
        high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function (array, item, idx) {
      var i = 0,
          length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function (start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function (func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function bound() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function (func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function bound() {
      var position = 0,
          length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) {
        args.push(arguments[position++]);
      }return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function (obj) {
    var i,
        length = arguments.length,
        key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function (func, hasher) {
    var memoize = function memoize(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function (func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function () {
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function (func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function () {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function (func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function later() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function () {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function (func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function (predicate) {
    return function () {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function () {
    var args = arguments;
    var start = args.length - 1;
    return function () {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) {
        result = args[i].call(this, result);
      }return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function (times, func) {
    return function () {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function (times, func) {
    var memo;
    return function () {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function (obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) {
      if (_.has(obj, key)) keys.push(key);
    } // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function (obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) {
      keys.push(key);
    } // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function (obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function (obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {},
        currentKey;
    for (var index = 0; index < length; index++) {
      currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function (obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function (obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function (obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function (obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj),
        key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function (object, oiteratee, context) {
    var result = {},
        obj = object,
        iteratee,
        keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function iteratee(value, key, obj) {
        return key in obj;
      };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

  // Return a copy of the object without the blacklisted properties.
  _.omit = function (obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function iteratee(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function (prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function (obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function (obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function (object, attrs) {
    var keys = _.keys(attrs),
        length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };

  // Internal recursive comparison function for `isEqual`.
  var eq = function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor,
          bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a),
          key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function (a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function (obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function (obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function (obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function (obj) {
    var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
    _['is' + name] = function (obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function (obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) != 'object') {
    _.isFunction = function (obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function (obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function (obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function (obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function (obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function (obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function (obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function () {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function (value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function (value) {
    return function () {
      return value;
    };
  };

  _.noop = function () {};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function (obj) {
    return obj == null ? function () {} : function (key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function (attrs) {
    attrs = _.extendOwn({}, attrs);
    return function (obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function (n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) {
      accum[i] = iteratee(i);
    }return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function (min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function () {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function createEscaper(map) {
    var escaper = function escaper(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function (string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function (object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function (prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function escapeChar(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function (text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function template(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function (obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function result(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function (obj) {
    _.each(_.functions(obj), function (name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function () {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
    var method = ArrayProto[name];
    _.prototype[name] = function () {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function (name) {
    var method = ArrayProto[name];
    _.prototype[name] = function () {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function () {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function () {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Proposal_scss__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Proposal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_currency_formatter__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LineItemShow = function (_React$Component) {
  _inherits(LineItemShow, _React$Component);

  function LineItemShow() {
    _classCallCheck(this, LineItemShow);

    return _possibleConstructorReturn(this, (LineItemShow.__proto__ || Object.getPrototypeOf(LineItemShow)).apply(this, arguments));
  }

  _createClass(LineItemShow, [{
    key: 'render',
    value: function render() {
      var service = this.props.service;
      var quantity = service.quantity || 1;
      var price = (service.price_cents || 0) / 100;
      var cardStyles = { background: 'transparent' };
      if (!this.props.readOnly) cardStyles.userSelect = 'none';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
        {
          link: !this.props.readOnly,
          fluid: true,
          style: cardStyles,
          className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.noShadow,
          ref: this.props.innerRef
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { computer: 8, tablet: 8, mobile: 16 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'strong',
                    null,
                    service.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', {
                  className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.description,
                  dangerouslySetInnerHTML: { __html: service.description }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right', only: 'computer tablet' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(price, {
                    code: service.price_currency
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { width: 2, textAlign: 'right', only: 'computer tablet' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  quantity
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right', only: 'computer tablet' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(quantity * price, {
                    code: service.price_currency
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16, only: 'mobile' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.itemTotalMobile },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { float: 'left' }, className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.qtyPrice },
                    '(',
                    quantity,
                    ' @ \xA0',
                    __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(price, {
                      code: service.price_currency
                    }),
                    ')'
                  ),
                  '\xA0',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { float: 'right' } },
                    __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(quantity * price, {
                      code: service.price_currency
                    }),
                    ' '
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LineItemShow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LineItemShow.propTypes = {
  innerRef: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  service: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemShow);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_EventSegment_EventSegmentShow__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_EventSegment_EventSegmentMobile__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Event_EventSegment_EventSegmentDesktop__ = __webpack_require__(816);









var ScheduleComponent = function ScheduleComponent(_ref) {
  var addEventSegment = _ref.addEventSegment,
      closeNewEventSegmentEditor = _ref.closeNewEventSegmentEditor,
      createEventSegment = _ref.createEventSegment,
      deleteEventSegment = _ref.deleteEventSegment,
      eventSegments = _ref.eventSegments,
      eventSegmentChangeHandler = _ref.eventSegmentChangeHandler,
      localEventSegments = _ref.localEventSegments,
      newEventSegment = _ref.newEventSegment,
      newEventSegmentChangeHandler = _ref.newEventSegmentChangeHandler,
      editingNewEventSegment = _ref.editingNewEventSegment,
      readOnly = _ref.readOnly,
      resetAddEventSegment = _ref.resetAddEventSegment,
      resetEditEventSegment = _ref.resetEditEventSegment,
      updateEventSegment = _ref.updateEventSegment,
      viewer = _ref.viewer;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    eventSegments.length === 0 && !editingNewEventSegment && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { textAlign: 'center', padding: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        null,
        'This event has no schedule'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
        basic: true,
        icon: 'plus',
        onClick: addEventSegment,
        labelPosition: 'left',
        content: 'Add Time & Place'
      })
    ),
    !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      eventSegments.map(function (eventSegment, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: eventSegment.node.id || idx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
            {
              eventSegment: eventSegment.node,
              localEventSegment: localEventSegments[idx].node,
              onChange: function onChange(segment) {
                eventSegmentChangeHandler(segment, idx);
              },
              commitUpdate: updateEventSegment,
              desktop: __WEBPACK_IMPORTED_MODULE_7__Event_EventSegment_EventSegmentDesktop__["a" /* default */],
              mobile: __WEBPACK_IMPORTED_MODULE_6__Event_EventSegment_EventSegmentMobile__["a" /* default */],
              index: idx,
              reset: resetEditEventSegment,
              'delete': deleteEventSegment,
              viewer: viewer
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Event_EventSegment_EventSegmentShow__["a" /* default */], { noBorder: true, eventSegment: eventSegment.node })
          )
        );
      })
    ),
    readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      eventSegments.map(function (eventSegment, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: eventSegment.node.id || idx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Event_EventSegment_EventSegmentShow__["a" /* default */], {
            noBorder: true,
            readOnly: readOnly,
            eventSegment: eventSegment.node
          })
        );
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,
      {
        transitionName: 'slide',
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      },
      newEventSegment && editingNewEventSegment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
          {
            eventSegment: newEventSegment.node,
            localEventSegment: newEventSegment.node,
            onChange: function onChange(segment) {
              newEventSegmentChangeHandler(segment);
            },
            commitUpdate: createEventSegment,
            desktop: __WEBPACK_IMPORTED_MODULE_7__Event_EventSegment_EventSegmentDesktop__["a" /* default */],
            mobile: __WEBPACK_IMPORTED_MODULE_6__Event_EventSegment_EventSegmentMobile__["a" /* default */],
            reset: resetAddEventSegment,
            initiallyOpen: true,
            isNew: true,
            'delete': resetAddEventSegment,
            closeEditor: closeNewEventSegmentEditor,
            editorOpen: editingNewEventSegment,
            viewer: viewer
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Event_EventSegment_EventSegmentShow__["a" /* default */], { eventSegment: newEventSegment.node })
        )
      )
    ),
    eventSegments.length > 0 && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { marginTop: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { onClick: addEventSegment },
        '+ Add Time and Place'
      )
    )
  );
};

ScheduleComponent.propTypes = {
  addEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeNewEventSegmentEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  createEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventSegments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  eventSegmentChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editingNewEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  localEventSegments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  newEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  newEventSegmentChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resetAddEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetEditEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateEventSegment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduleComponent);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignatureBlockSizeClass__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SignatureBlockShow = function (_React$Component) {
  _inherits(SignatureBlockShow, _React$Component);

  function SignatureBlockShow(props) {
    _classCallCheck(this, SignatureBlockShow);

    var _this = _possibleConstructorReturn(this, (SignatureBlockShow.__proto__ || Object.getPrototypeOf(SignatureBlockShow)).call(this, props));

    _this.state = {
      signatureImageHeight: 100,
      signatureImageContainer: { width: 0, height: 0 }
    };
    _this.updateSignatureImageProps = _this.updateSignatureImageProps.bind(_this);
    return _this;
  }

  _createClass(SignatureBlockShow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateSignatureImageProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateSignatureImageProps);
    }
  }, {
    key: 'updateSignatureImageProps',
    value: function updateSignatureImageProps() {
      if (this.refs.signatureImageContainer) {
        var signatureImageHeight = this.refs.signatureImageContainer.offsetWidth * this.refs.signatureImage.naturalHeight / this.refs.signatureImage.naturalWidth;
        this.setState({
          signatureImageOffset: (signatureImageHeight - 100) / 3,
          signatureImageHeight: signatureImageHeight,
          signatureImageContainer: {
            width: this.refs.signatureImageContainer.offsetWidth,
            height: this.refs.signatureImageContainer.offsetWidth
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isVisible = function isVisible(visibility) {
        return visibility === 'SHOW';
      };
      var _props = this.props,
          signatureBlock = _props.signatureBlock,
          style = _props.style,
          isTemplate = _props.isTemplate,
          withoutSignature = _props.withoutSignature;

      var canSign = this.props.isSigner && !this.props.signatureBlock.node.signed_at;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureBlock,
          style: Object.assign({}, { padding: '1em', cursor: canSign ? 'pointer' : null }, style),
          onClick: canSign ? this.props.openSignModal : null
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          signatureBlock.node.signing_party
        ),
        !withoutSignature && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          !signatureBlock.node.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureImage },
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureLine },
              '\xD7'
            )
          ),
          signatureBlock.node.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            signatureBlock.node.signature_type === 'PAD' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureContainer,
                ref: 'signatureImageContainer'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                alt: signatureBlock.node.name || 'Signature',
                src: signatureBlock.node.signature_url,
                ref: 'signatureImage',
                onLoad: this.updateSignatureImageProps,
                className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureImage,
                style: {
                  bottom: 0,
                  transform: 'translateY(' + this.state.signatureImageOffset + 'px)'
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureLine },
                '\xD7'
              )
            ),
            signatureBlock.node.signature_type === 'TYPED' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureContainer },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  className: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__SignatureBlockSizeClass__["a" /* default */])(signatureBlock.node.signature_typed_name || ''), __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureText].join(' ')
                },
                signatureBlock.node.signature_typed_name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureLine },
                '\xD7'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          isTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            isVisible(signatureBlock.node.name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '[Name]'
            ),
            isVisible(signatureBlock.node.company_name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              isVisible(signatureBlock.node.title_visibility) ? '[Title], ' : '',
              '[Company Name]'
            ),
            isVisible(signatureBlock.node.email_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '[Email Address]'
            ),
            isVisible(signatureBlock.node.phone_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '[Phone Number]'
            ),
            isVisible(signatureBlock.node.address_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '[Address]'
            )
          ),
          !isTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            signatureBlock.node.name_visibility && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              signatureBlock.node.name
            ),
            signatureBlock.node.company_name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              signatureBlock.node.title ? signatureBlock.node.title + ', ' : '',
              signatureBlock.node.company_name
            ),
            signatureBlock.node.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              signatureBlock.node.email
            ),
            signatureBlock.node.phone && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              signatureBlock.node.phone
            ),
            signatureBlock.node.address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { whiteSpace: 'pre-wrap' } },
              signatureBlock.node.address
            ),
            signatureBlock.node.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_2__SignatureBlocks_scss___default.a.signatureTimestamp },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'em',
                null,
                'Signed on',
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(signatureBlock.node.signed_at).format('lll'),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess()).format('z')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], {
                name: 'check circle',
                color: 'green',
                style: { marginLeft: '1em' }
              })
            )
          )
        )
      );
    }
  }]);

  return SignatureBlockShow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SignatureBlockShow.propTypes = {
  isTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  openSignModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  signatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  isSigner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  withoutSignature: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (SignatureBlockShow);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['setValidations', 'setValue', 'resetValue', 'getValue', 'hasValue', 'getErrorMessage', 'getErrorMessages', 'isFormDisabled', 'isValid', 'isPristine', 'isFormSubmitted', 'isRequired', 'showRequired', 'showError', 'isValidValue', 'submitted', 'validationError', 'validationErrors']);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements_CardField_CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements_CardField_CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Elements_CardField_CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_stylesheets_ExpandCollapseTransition_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_stylesheets_ExpandCollapseTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__lib_stylesheets_ExpandCollapseTransition_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocationAutocomplete__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_timezone__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var blurringStartsAt = false;

var EventSegmentDesktop = function (_React$Component) {
  _inherits(EventSegmentDesktop, _React$Component);

  function EventSegmentDesktop(props) {
    _classCallCheck(this, EventSegmentDesktop);

    var _this = _possibleConstructorReturn(this, (EventSegmentDesktop.__proto__ || Object.getPrototypeOf(EventSegmentDesktop)).call(this, props));

    _this.state = {
      submitted: _this.props.submissionAttempts > 0,
      endAtKey: _this.generateKey()
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.endAtChange = _this.endAtChange.bind(_this);
    _this.startAtChange = _this.startAtChange.bind(_this);
    _this.tzChange = _this.tzChange.bind(_this);
    _this.allDayChange = _this.allDayChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.handleBlurringStartsAt = _this.handleBlurringStartsAt.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.generateKey = _this.generateKey.bind(_this);
    return _this;
  }

  _createClass(EventSegmentDesktop, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          localEventSegment = _props.localEventSegment,
          viewer = _props.viewer;

      if (!localEventSegment.time_zone) {
        var timeZone = viewer && viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz.guess();
        this.fieldChange('time_zone', timeZone);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.refs.eventSegment.scrollIntoViewIfNeeded) {
        this.refs.eventSegment.scrollIntoViewIfNeeded();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.submissionAttempts !== this.props.submissionAttempts) {
        this.refs.form.submit();
        this.setState({ submitted: nextProps.submissionAttempts > 0 });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(data, reset, invalidateForm) {
      var _this2 = this;

      this.setState({ submitted: true });
      if (new Date(data.ends_at) < new Date(data.starts_at)) {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        invalidateForm({ ends_at: 'Event must end later than it starts' });
      } else {
        this.props.commitUpdate(this.props.index, function () {
          return _this2.props.closeHandler();
        });
      }
    }
  }, {
    key: 'getDateString',
    value: function getDateString(date) {
      var _props$localEventSegm = this.props.localEventSegment,
          all_day = _props$localEventSegm.all_day,
          time_zone = _props$localEventSegm.time_zone;
      // eslint-disable-next-line camelcase

      if (all_day) {
        return __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(date).format('YYYY-MM-DD');
      }
      return __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(date, time_zone).toISOString();
    }
  }, {
    key: 'generateKey',
    value: function generateKey() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate(e) {
      var _this3 = this;

      e.preventDefault();
      e.stopPropagation();
      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        return _this3.props.closeHandler();
      });
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset(this.props.index);
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this4 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this4.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'tzChange',
    value: function tzChange(e, _ref) {
      var value = _ref.value;
      var _props$localEventSegm2 = this.props.localEventSegment,
          start_at = _props$localEventSegm2.start_at,
          end_at = _props$localEventSegm2.end_at;

      if (__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(start_at, __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.ISO_8601).isValid()) {
        // TODO: handle if dateOnly
        this.fieldChange('start_at', this.getDateString(start_at));
      }
      if (__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(end_at, __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.ISO_8601).isValid()) {
        this.fieldChange('end_at', this.getDateString(end_at));
      }
      this.fieldChange('time_zone', value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localEventSegment, newValue));
    }
  }, {
    key: 'endAtChange',
    value: function endAtChange(e) {
      this.fieldChange('end_at', e.target.value);
    }
  }, {
    key: 'startAtChange',
    value: function startAtChange(e) {
      this.fieldChange('start_at', e.target.value);
      if ((!this.props.localEventSegment.end_at || __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(this.props.localEventSegment.end_at) <= __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(this.props.localEventSegment.start_at)) && blurringStartsAt) {
        var isDate = e.target.value.length === 10;
        if (isDate && __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(e.target.value, __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.ISO_8601).isValid()) {
          this.fieldChange('end_at', e.target.value);
        } else if (__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(e.target.value).isValid()) {
          this.fieldChange('end_at', __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(e.target.value).add(4, 'hours').toDate().toISOString());
          this.setState({ endAtKey: this.generateKey() });
        }
      }
    }
  }, {
    key: 'allDayChange',
    value: function allDayChange(allDay) {
      this.fieldChange('all_day', allDay);
      var timeZone = this.props.localEventSegment.time_zone;
      if (__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(this.props.localEventSegment.start_at).isValid()) {
        var startAt = allDay ? __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(this.props.localEventSegment.start_at, timeZone).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(this.props.localEventSegment.start_at, timeZone).toISOString();
        this.fieldChange('start_at', startAt);
      }
      if (__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(this.props.localEventSegment.end_at).isValid()) {
        var endAt = allDay ? __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(this.props.localEventSegment.end_at, timeZone).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(this.props.localEventSegment.end_at, timeZone).add(4, 'hours').toISOString();
        this.fieldChange('end_at', endAt);
      }
    }

    // Since DatePicker contains multiple inputs,
    // we need to explicitly declare when the
    // component loses focus, otherwise validations
    // will run as you try to select a value from the DatePicker
    // because technically the input first loses focus when you click

  }, {
    key: 'handleBlurringStartsAt',
    value: function handleBlurringStartsAt(blurring) {
      blurringStartsAt = blurring;
    }
  }, {
    key: 'render',
    value: function render() {
      var eventSegment = this.props.localEventSegment;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
        { ref: 'form', className: 'ui form', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { ref: 'eventSegment' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
            { fluid: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h4',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["i" /* TextArea */], {
                    className: 'transparent fluid ' + __WEBPACK_IMPORTED_MODULE_5__Elements_CardField_CardField_scss___default.a.textArea,
                    rows: 1,
                    placeholder: 'Description (eg. Reception)',
                    value: eventSegment.title || '',
                    onChange: this.textFieldChange,
                    name: 'title',
                    submitted: this.state.submitted
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["m" /* CardCheckbox */], {
                label: 'All-day',
                name: 'all_day',
                checked: eventSegment.all_day || false,
                onChange: this.allDayChange,
                submitted: this.state.submitted
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                label: 'Starts',
                name: 'starts_at',
                datePlaceholder: 'Start Date',
                timePlaceholder: 'Start Time',
                dateOnly: eventSegment.all_day || false,
                timeZone: eventSegment.time_zone,
                value: eventSegment.start_at || '',
                onChange: this.startAtChange,
                viewer: this.props.viewer,
                submitted: this.state.submitted,
                handleBlurringDatePicker: this.handleBlurringStartsAt
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                label: 'Ends',
                name: 'ends_at',
                datePlaceholder: 'End Date',
                timePlaceholder: 'End Time',
                dateOnly: eventSegment.all_day || false,
                value: eventSegment.end_at || '',
                timeZone: eventSegment.time_zone,
                onChange: this.endAtChange,
                viewer: this.props.viewer,
                submitted: this.state.submitted,
                key: this.state.endAtKey,
                validationError: 'Event must end later than it starts'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default.a,
                {
                  transitionName: 'background',
                  transitionEnterTimeout: 500,
                  transitionLeaveTimeout: 500
                },
                eventSegment.start_at && eventSegment.end_at && !eventSegment.all_day && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginTop: '1em' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["o" /* CardTZSelect */], {
                    label: 'Time Zone',
                    name: 'time_zone',
                    value: eventSegment.time_zone,
                    onChange: this.tzChange,
                    submitted: this.state.submitted,
                    validationError: 'Time zone is required'
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginBottom: '1em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LocationAutocomplete__["a" /* default */], {
                  eventSegment: eventSegment,
                  updateLocalEventSegment: this.props.onChange
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default.a,
                {
                  transitionName: 'background',
                  transitionEnterTimeout: 500,
                  transitionLeaveTimeout: 500
                },
                eventSegment.location && eventSegment.location !== '' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { margin: '1em 0' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                    label: 'Address',
                    name: 'line1',
                    placeholder: '5 Embarcadero Center',
                    value: eventSegment.line1 || '',
                    onChange: this.textFieldChange,
                    submitted: this.state.submitted
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                    label: 'City',
                    name: 'city',
                    placeholder: 'San Francisco',
                    value: eventSegment.city || '',
                    onChange: this.textFieldChange,
                    submitted: this.state.submitted
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                    label: 'State/\u200BProvince',
                    name: 'province',
                    placeholder: 'California',
                    value: eventSegment.province || '',
                    onChange: this.textFieldChange,
                    submitted: this.state.submitted
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                    label: 'Postal Code',
                    name: 'postal_code',
                    placeholder: '94111',
                    value: eventSegment.postal_code || '',
                    onChange: this.textFieldChange,
                    submitted: this.state.submitted
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                    label: 'Room',
                    name: 'room',
                    placeholder: 'Grand Ballroom',
                    value: eventSegment.room || '',
                    onChange: this.textFieldChange,
                    submitted: this.state.submitted
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                label: 'Notes',
                name: 'notes',
                value: eventSegment.notes || '',
                placeholder: 'Cocktail hour will be in the foyer area',
                onChange: this.textFieldChange,
                submitted: this.state.submitted
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["j" /* DthcActions */], {
                id: eventSegment.id,
                reset: this.reset,
                'delete': this.delete,
                isNew: this.props.isNew
              })
            )
          )
        )
      );
    }
  }]);

  return EventSegmentDesktop;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventSegmentDesktop.propTypes = {
  localEventSegment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  submissionAttempts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (EventSegmentDesktop);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements_CardField_CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements_CardField_CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Elements_CardField_CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LocationAutocomplete__ = __webpack_require__(1480);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var EventSegmentMobile = function (_React$Component) {
  _inherits(EventSegmentMobile, _React$Component);

  function EventSegmentMobile(props) {
    _classCallCheck(this, EventSegmentMobile);

    var _this = _possibleConstructorReturn(this, (EventSegmentMobile.__proto__ || Object.getPrototypeOf(EventSegmentMobile)).call(this, props));

    _this.state = {
      submitted: _this.props.submissionAttempts > 0,
      endAtKey: _this.generateKey()
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.endAtChange = _this.endAtChange.bind(_this);
    _this.startAtChange = _this.startAtChange.bind(_this);
    _this.tzChange = _this.tzChange.bind(_this);
    _this.allDayChange = _this.allDayChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.generateKey = _this.generateKey.bind(_this);
    return _this;
  }

  _createClass(EventSegmentMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          localEventSegment = _props.localEventSegment,
          viewer = _props.viewer;

      if (!localEventSegment.time_zone) {
        var timeZone = viewer && viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.guess();
        this.fieldChange('time_zone', timeZone);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.submissionAttempts !== this.props.submissionAttempts) {
        this.refs.form.submit();
        this.setState({ submitted: nextProps.submissionAttempts > 0 });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(data, reset, invalidateForm) {
      var _this2 = this;

      this.setState({ submitted: true });
      if (new Date(data.ends_at) < new Date(data.starts_at)) {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({ message: 'Unable to update event information', intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER });
        invalidateForm({ ends_at: 'Event must end later than it starts' });
      } else {
        this.props.commitUpdate(this.props.index, function () {
          return _this2.props.closeHandler();
        });
      }
    }
  }, {
    key: 'getUtcDate',
    value: function getUtcDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(date, this.props.localEventSegment.time_zone).toISOString();
    }
  }, {
    key: 'getDateString',
    value: function getDateString(date) {
      var _props$localEventSegm = this.props.localEventSegment,
          all_day = _props$localEventSegm.all_day,
          time_zone = _props$localEventSegm.time_zone;
      // eslint-disable-next-line camelcase

      if (all_day) {
        return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(date).format('YYYY-MM-DD');
      }
      return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(date, time_zone).toISOString();
    }
  }, {
    key: 'generateKey',
    value: function generateKey() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate() {
      var _this3 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        setTimeout(function () {
          return _this3.props.closeHandler();
        }, 0);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      this.props.reset(this.props.index);
      setTimeout(function () {
        return _this4.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this5 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this5.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'tzChange',
    value: function tzChange(e, _ref) {
      var value = _ref.value;
      var _props$localEventSegm2 = this.props.localEventSegment,
          start_at = _props$localEventSegm2.start_at,
          end_at = _props$localEventSegm2.end_at;

      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(start_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.fieldChange('start_at', this.getDateString(start_at));
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(end_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.fieldChange('end_at', this.getDateString(end_at));
      }
      this.fieldChange('time_zone', value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localEventSegment, newValue));
    }
  }, {
    key: 'endAtChange',
    value: function endAtChange(e) {
      var isDate = e.target.value.length === 10;
      this.fieldChange('end_at', isDate ? e.target.value : this.getUtcDate(e.target.value));
    }
  }, {
    key: 'startAtChange',
    value: function startAtChange(e) {
      var isDate = e.target.value.length === 10;
      this.fieldChange('start_at', isDate ? e.target.value : this.getUtcDate(e.target.value));
      if (!this.props.localEventSegment.end_at || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.props.localEventSegment.end_at) <= __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.props.localEventSegment.start_at)) {
        if (isDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
          this.fieldChange('end_at', e.target.value);
        } else if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).isValid()) {
          this.fieldChange('end_at', __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).add(4, 'hours').toDate().toISOString());
        }
        this.setState({ endAtKey: this.generateKey() });
      }
    }
  }, {
    key: 'allDayChange',
    value: function allDayChange() {
      var allDay = !this.props.localEventSegment.all_day;
      var timeZone = this.props.localEventSegment.time_zone;
      this.fieldChange('all_day', allDay);
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.props.localEventSegment.start_at).isValid()) {
        var startAt = allDay ? __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.props.localEventSegment.start_at, timeZone).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.props.localEventSegment.start_at, timeZone).toISOString();
        this.fieldChange('start_at', startAt);
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.props.localEventSegment.end_at).isValid()) {
        var endAt = allDay ? __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.props.localEventSegment.end_at, timeZone).format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(this.props.localEventSegment.end_at, timeZone).add(4, 'hours').toISOString();
        this.fieldChange('end_at', endAt);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var eventSegment = this.props.localEventSegment;
      var deleteButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["b" /* Button */],
        { negative: true, fluid: true, type: 'button' },
        'Delete Event Time'
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_formsy_react___default.a.Form,
        { className: 'ui form', ref: 'form', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this6.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["i" /* TextArea */], {
                className: 'transparent fluid ' + __WEBPACK_IMPORTED_MODULE_4__Elements_CardField_CardField_scss___default.a.textArea,
                rows: 1,
                placeholder: 'Description (eg. Reception)',
                value: eventSegment.title || '',
                onChange: this.textFieldChange,
                name: 'title',
                submitted: this.state.submitted
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["m" /* CardCheckbox */], {
              label: 'All-day',
              name: 'all_day',
              checked: eventSegment.all_day || false,
              onChange: this.allDayChange,
              submitted: this.state.submitted
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["n" /* CardDateTime */], {
              label: 'Starts',
              name: 'starts_at',
              placeholder: 'Start Time',
              value: eventSegment.start_at || '',
              timeZone: eventSegment.time_zone,
              dateOnly: eventSegment.all_day || false,
              onChange: this.startAtChange,
              submitted: this.state.submitted
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["n" /* CardDateTime */], {
              label: 'Ends',
              name: 'ends_at',
              placeholder: 'End Time',
              value: eventSegment.end_at || '',
              timeZone: eventSegment.time_zone,
              dateOnly: eventSegment.all_day || false,
              onChange: this.endAtChange,
              submitted: this.state.submitted,
              key: this.state.endAtKey,
              validationError: 'Event must end later than it starts'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default.a,
              {
                transitionName: 'background',
                transitionEnterTimeout: 500,
                transitionLeaveTimeout: 500,
                style: { margin: '1em 0' }
              },
              eventSegment.start_at && eventSegment.end_at && !eventSegment.all_day && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["o" /* CardTZSelect */], {
                  label: 'Time Zone',
                  name: 'time_zone',
                  value: eventSegment.time_zone,
                  onChange: this.tzChange,
                  submitted: this.state.submitted,
                  validationError: 'Time zone is required'
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LocationAutocomplete__["a" /* default */], {
              eventSegment: eventSegment,
              updateLocalEventSegment: this.props.onChange
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default.a,
              {
                transitionName: 'background',
                transitionEnterTimeout: 500,
                transitionLeaveTimeout: 500,
                style: { margin: '1em 0' }
              },
              eventSegment.location && eventSegment.location !== '' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["p" /* CardTextArea */], {
                  label: 'Address',
                  name: 'line1',
                  placeholder: '4900 Chagrin Drive',
                  value: eventSegment.line1 || '',
                  onChange: this.textFieldChange,
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["p" /* CardTextArea */], {
                  label: 'City',
                  name: 'city',
                  placeholder: 'San Francisco',
                  value: eventSegment.city || '',
                  onChange: this.textFieldChange,
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["p" /* CardTextArea */], {
                  label: 'State/\u200BProvince',
                  name: 'province',
                  placeholder: 'California',
                  value: eventSegment.province || '',
                  onChange: this.textFieldChange,
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["q" /* CardInput */], {
                  label: 'Postal Code',
                  name: 'postal_code',
                  type: 'tel',
                  placeholder: '94105',
                  value: eventSegment.postal_code || '',
                  onChange: this.textFieldChange,
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["p" /* CardTextArea */], {
                  label: 'Room',
                  name: 'room',
                  placeholder: 'Grand Ballroom',
                  value: eventSegment.room || '',
                  onChange: this.textFieldChange,
                  submitted: this.state.submitted
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["p" /* CardTextArea */], {
              label: 'Notes',
              name: 'notes',
              value: eventSegment.notes || '',
              placeholder: 'Cocktail hour will be in the foyer area',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.props.delete && !this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { flex: 1 } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: 'center', marginTop: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["i" /* DeleteConfirmation */], { trigger: deleteButton, 'delete': this.delete, id: eventSegment.id })
              )
            )
          )
        )
      );
    }
  }]);

  return EventSegmentMobile;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventSegmentMobile.propTypes = {
  localEventSegment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  submissionAttempts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EventSegmentMobile);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_location__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss__ = __webpack_require__(3620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EventSegment_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EventSegmentShow = function (_React$Component) {
  _inherits(EventSegmentShow, _React$Component);

  function EventSegmentShow() {
    _classCallCheck(this, EventSegmentShow);

    return _possibleConstructorReturn(this, (EventSegmentShow.__proto__ || Object.getPrototypeOf(EventSegmentShow)).apply(this, arguments));
  }

  _createClass(EventSegmentShow, [{
    key: 'render',
    value: function render() {
      var eventSegment = this.props.eventSegment;

      var venueTitle = (eventSegment.location || '') + (eventSegment.room ? ' (' + eventSegment.room + ')' : '');

      var hasTimes = eventSegment.start_at && eventSegment.end_at;
      var startAt = __WEBPACK_IMPORTED_MODULE_5__lib_utils_date__["a" /* default */].isoStringToMoment(eventSegment.start_at, eventSegment.all_day, eventSegment.time_zone);
      var endAt = __WEBPACK_IMPORTED_MODULE_5__lib_utils_date__["a" /* default */].isoStringToMoment(eventSegment.end_at, eventSegment.all_day, eventSegment.time_zone);
      var allDay = eventSegment.all_day;
      var timeZone = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(eventSegment.time_zone).format('z');

      var isSingleDayEvent = function isSingleDayEvent() {
        return startAt.isSame(endAt, 'day') || startAt.isSame(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(endAt).subtract(6, 'hours'), 'day') && !allDay;
      };
      // Include year formatter if date is not this year
      var yearFormat = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isSame(startAt, 'year') && __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isSame(endAt, 'year') ? '' : ', YYYY';
      var primaryTimeInfo = function primaryTimeInfo() {
        if (isSingleDayEvent()) {
          // If single day, return day of week
          return startAt.format('dddd, MMMM D' + yearFormat);
        }
        // If multi-day event, return date range
        return startAt.format('MMMM D' + yearFormat) + ' \u2013 ' + endAt.format('MMMM D' + yearFormat);
      };
      var secondaryTimeInfo = function secondaryTimeInfo() {
        // If date with no times, return All Day
        if (eventSegment.all_day) {
          return 'All Day';
        }
        if (isSingleDayEvent()) {
          // If single day, return times only
          return startAt.format('LT') + ' \u2013 ' + endAt.format('LT') + ' ' + timeZone;
        }
        // If multi-day event, return dates and times
        // Don't forget YEAR formatting!
        return startAt.format('MMM D' + yearFormat + ' [at] LT') + ' \u2013 ' + endAt.format('MMM D' + yearFormat + ' [at] LT') + ' ' + timeZone;
      };
      var venueText = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        venueTitle,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss___default.a.secondaryInfo },
          eventSegment.line1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          eventSegment.line1,
          (eventSegment.city || eventSegment.province || eventSegment.postal_code) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_4__lib_utils_location__["a" /* default */].getLocalityString({
            city: eventSegment.city,
            province: eventSegment.province,
            postal_code: eventSegment.postal_code
          })
        )
      );

      var cardStyles = { background: 'transparent' };
      if (this.props.noBorder) cardStyles.boxShadow = 'none';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
        { link: !this.props.readOnly, fluid: true, style: cardStyles },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
            { stackable: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 1 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h3',
                  null,
                  eventSegment.title
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
              { columns: this.props.compact ? 1 : 'equal' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                {
                  style: this.props.compact ? { marginBottom: '2em' } : {}
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss___default.a.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'calendar alternate outline' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    hasTimes && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      primaryTimeInfo(),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { className: __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss___default.a.secondaryInfo },
                        secondaryTimeInfo()
                      )
                    ),
                    !hasTimes && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      null,
                      'N/A'
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                null,
                (venueTitle !== '' || eventSegment.notes) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__EventSegment_scss___default.a.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'map marker alternate' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      venueText
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventSegmentShow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventSegmentShow.propTypes = {
  compact: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  eventSegment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  noBorder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (EventSegmentShow);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventList_scss__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EventList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_date__ = __webpack_require__(106);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var EventCard = function (_React$Component) {
  _inherits(EventCard, _React$Component);

  function EventCard(props) {
    _classCallCheck(this, EventCard);

    var _this = _possibleConstructorReturn(this, (EventCard.__proto__ || Object.getPrototypeOf(EventCard)).call(this, props));

    _this.state = {
      selected: false
    };
    _this.onSelect = _this.onSelect.bind(_this);
    _this.onDeselect = _this.onDeselect.bind(_this);
    _this.getBorderClass = _this.getBorderClass.bind(_this);
    _this.toggleVisibility = _this.toggleVisibility.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(EventCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      this.setState({ selected: true });
    }
  }, {
    key: 'onDeselect',
    value: function onDeselect() {
      this.setState({ selected: false });
    }
  }, {
    key: 'getBorderClass',
    value: function getBorderClass(status) {
      switch (status) {
        case 'BOOKED':
          return __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default.a.cardBorderPrimary;
        case 'INITIAL':
          return __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default.a.cardBorderTentative;
        case 'CANCELED':
          return __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default.a.cardBorderCanceled;
        default:
          return null;
      }
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'toggleVisibility',
    value: function toggleVisibility(e) {
      var _this2 = this;

      e.preventDefault();
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_7__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_7__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_7__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_7__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.relay.refetchConnection(_this2.props.listSize);
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3271);
      });

      var id = this.props.event.id;
      var visibility = this.props.event.visibility === 'SHOW' ? 'HIDDEN' : 'SHOW';
      var optimisticResponse = {
        updateUserEvent: { user_event: { id: id, visibility: visibility } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            visibility: visibility
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var event = this.props.event;
      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.guess();
      var room = event.user_event_segments.edges[0] && event.user_event_segments.edges[0].node.room;
      var venueName = event.user_event_segments.edges[0] && event.user_event_segments.edges[0].node.location;
      var allDay = event.start_at && event.start_at.length === 10;
      var startAt = event.start_at ? __WEBPACK_IMPORTED_MODULE_10__lib_utils_date__["a" /* default */].isoStringToMoment(event.start_at, allDay, timeZone) : null;
      var endAt = event.end_at ? __WEBPACK_IMPORTED_MODULE_10__lib_utils_date__["a" /* default */].isoStringToMoment(event.end_at, allDay, timeZone) : null;
      var hasDates = startAt && endAt;
      var multiDay = hasDates && !(startAt.isSame(endAt, 'day') || !allDay && startAt.isSame(__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(endAt).subtract(6, 'hours'), 'day'));

      var _props = this.props,
          basic = _props.basic,
          link = _props.link,
          showDateLabel = _props.showDateLabel,
          sortable = _props.sortable;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { paddingBottom: '0.75em' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
          {
            fluid: true,
            onMouseEnter: this.onSelect,
            onMouseLeave: this.onDeselect,
            as: link ? __WEBPACK_IMPORTED_MODULE_6_found__["Link"] : 'div',
            to: '/events/' + event.event.id,
            link: link,
            style: sortable ? { cursor: 'move' } : {}
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: this.getBorderClass(event.booking_status) }),
          (this.state.selected || this.state.window.width < __WEBPACK_IMPORTED_MODULE_9__variables__["a" /* default */].desktopBreakpoint) && this.props.menu,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
            {
              style: {
                marginLeft: '6px',
                display: 'table',
                border: 'none',
                minHeight: '6.4rem'
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: {
                  textAlign: 'center',
                  paddingRight: '1em',
                  minWidth: showDateLabel ? '3.5em' : '1em',
                  display: 'table-cell',
                  verticalAlign: 'middle'
                }
              },
              showDateLabel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { className: __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default.a.cardDateLabel },
                  startAt && startAt.format('ddd'),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  startAt && startAt.format('D'),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
                ),
                multiDay && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { className: __WEBPACK_IMPORTED_MODULE_3__EventList_scss___default.a.cardDateLabel },
                  endAt && endAt.format('ddd'),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  endAt && endAt.format('D'),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: {
                  display: 'table-cell',
                  verticalAlign: 'middle',
                  width: '100%'
                }
              },
              !link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_found__["Link"],
                { to: '/events/' + event.event.id },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h4',
                  { style: { display: 'inline-block', marginBottom: 0 } },
                  event.event.title
                )
              ),
              link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h4',
                { style: { display: 'inline-block', marginBottom: 0 } },
                event.event.title
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Meta,
                { style: { display: 'inline-block' } },
                venueName || 'Venue TBD',
                room ? ' (' + room + ')' : '',
                !showDateLabel && startAt && endAt && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  '' + startAt.format('LL') + (multiDay ? ' - ' + endAt.format('LL') : '')
                )
              )
            ),
            !basic && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: { display: 'table-cell', verticalAlign: 'middle' },
                className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.desktop
              },
              this.state.selected && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
                { basic: true, size: 'tiny', onClick: this.toggleVisibility },
                event.visibility === 'SHOW' ? 'Archive' : 'Unarchive'
              )
            )
          )
        )
      );
    }
  }]);

  return EventCard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventCard.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  basic: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  listSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  menu: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  showDateLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (EventCard);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_country_data__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_country_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_country_data__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ContactFieldsEdit = function (_React$Component) {
  _inherits(ContactFieldsEdit, _React$Component);

  function ContactFieldsEdit(props) {
    _classCallCheck(this, ContactFieldsEdit);

    var _this = _possibleConstructorReturn(this, (ContactFieldsEdit.__proto__ || Object.getPrototypeOf(ContactFieldsEdit)).call(this, props));

    _this.state = {
      submitted: _this.props.submissionAttempts > 0,
      countries: _this.getCountries()
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.handleRelationChange = _this.handleRelationChange.bind(_this);
    _this.addPhone = _this.addPhone.bind(_this);
    _this.addEmail = _this.addEmail.bind(_this);
    _this.addAddress = _this.addAddress.bind(_this);
    _this.handleRoleChange = _this.handleRoleChange.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.generateId = _this.generateId.bind(_this);
    return _this;
  }

  _createClass(ContactFieldsEdit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.submissionAttempts !== this.props.submissionAttempts) {
        this.setState({ submitted: nextProps.submissionAttempts > 0 });
      }
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, this.props.closeHandler);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_7__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update contact',
        intent: __WEBPACK_IMPORTED_MODULE_7__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'getCountries',
    value: function getCountries() {
      var compare = function compare(a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      };
      return __WEBPACK_IMPORTED_MODULE_9_country_data___default.a.countries.all.slice().map(function (country, index) {
        return {
          text: country.name,
          value: country.alpha2,
          key: country.alpha2 + '_' + index
        };
      }).sort(compare);
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset(this.props.index);
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this2 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this2.props.closeHandler;
      });
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'handleRelationChange',
    value: function handleRelationChange(e, idx, relation, field) {
      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localContact);
      var value = field === 'label' ? e.target.value.toLowerCase() : e.target.value;
      contact.node[relation].edges[idx].node[field] = value;
      this.props.onChange(contact);
    }
  }, {
    key: 'handleRoleChange',
    value: function handleRoleChange(e) {
      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localContact);
      contact.role = e.target.value;
      this.props.onChange(contact);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localContact);
      contact.node[key] = value;
      this.props.onChange(contact);
    }
  }, {
    key: 'addPhone',
    value: function addPhone() {
      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localContact);
      contact.node.user_contact_phones.edges.push({
        node: { label: 'mobile', number: '', tempId: this.generateId() }
      });
      this.props.onChange(contact);
    }
  }, {
    key: 'addEmail',
    value: function addEmail() {
      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localContact);
      contact.node.user_contact_emails.edges.push({
        node: { label: 'work', address: '', tempId: this.generateId() }
      });
      this.props.onChange(contact);
    }
  }, {
    key: 'addAddress',
    value: function addAddress() {
      var contact = this.props.localContact;
      contact.node.user_contact_addresses.edges.push({
        node: {
          label: 'home',
          line1: '',
          line2: '',
          city: '',
          province: '',
          postal_code: '',
          country: 'US',
          tempId: this.generateId()
        }
      });
      this.props.onChange(contact);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var localContact = this.props.localContact;

      var phoneLabelSuggestions = [{ text: 'Mobile', value: 'mobile' }, { text: 'Home', value: 'home' }, { text: 'Work', value: 'work' }, { text: 'Other', value: 'other' }];

      var emailLabelSuggestions = [{ text: 'Home', value: 'home' }, { text: 'Work', value: 'work' }, { text: 'Other', value: 'other' }];

      var addressLabelSuggestions = [{ text: 'Home', value: 'home' }, { text: 'Work', value: 'work' }, { text: 'Other', value: 'other' }];

      var getLabelOptions = function getLabelOptions(selectedValue, options) {
        var allOptions = options.slice();
        if (selectedValue) {
          var isNewValue = true;
          allOptions.map(function (option) {
            if (option.value === selectedValue) {
              isNewValue = false;
            }
            return option;
          });
          if (isNewValue) {
            allOptions.push({
              text: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(selectedValue),
              value: selectedValue
            });
          }
        }
        return allOptions;
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        {
          noValidate: true,
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { ref: 'contact' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
            label: 'First Name',
            name: 'first_name',
            placeholder: 'Jane',
            required: true,
            inline: true,
            validationError: 'First name is required',
            value: localContact.node.first_name,
            onChange: this.textFieldChange,
            submitted: this.state.submitted,
            width: '50%'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
            label: 'Last Name',
            name: 'last_name',
            placeholder: 'Smith',
            inline: 'last',
            value: localContact.node.last_name,
            onChange: this.textFieldChange,
            submitted: this.state.submitted,
            width: '50%'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
            label: 'Company Name',
            name: 'company_name',
            placeholder: 'Striking Events',
            value: localContact.node.company_name,
            onChange: this.textFieldChange,
            submitted: this.state.submitted
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
            label: 'Role',
            name: 'role',
            placeholder: 'Bride',
            required: true,
            validationError: 'Role is required',
            onChange: this.handleRoleChange,
            value: localContact.role,
            submitted: this.state.submitted
          }),
          localContact.node.user_contact_phones.edges.map(function (userContactPhone, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: userContactPhone.node.id || userContactPhone.node.tempId,
                className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.relation
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.delete,
                  onClick: _this3.props.deleteUserContactPhone.bind(null, _this3.props.index, idx)
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'close' })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["f" /* FloatingLabelSelect */], {
                label: 'Type',
                name: 'label',
                value: userContactPhone.node.label,
                type: 'select',
                onChange: function onChange(e) {
                  _this3.handleRelationChange(e, idx, 'user_contact_phones', 'label');
                },
                submitted: _this3.state.submitted,
                placeholder: 'Type...',
                options: getLabelOptions(userContactPhone.node.label, phoneLabelSuggestions),
                className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.label,
                inline: true,
                required: true,
                validationError: 'Required'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */],
                {
                  label: 'Phone',
                  type: 'tel',
                  name: 'number',
                  validations: {
                    matchRegexp: /\(\d{3}\)\s\d{3}-\d{4}|\d{10}/
                  },
                  required: true,
                  validationError: 'Phone number is invalid',
                  placeholder: '(555) 555-1212',
                  value: userContactPhone.node.number,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_phones', 'number');
                  },
                  submitted: _this3.state.submitted,
                  className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.expanding,
                  inline: 'last'
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__["a" /* default */], {
                  mask: '(999) 999-9999',
                  value: userContactPhone.node.number
                })
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.addRelation },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.addPhone },
              '+ Add Phone'
            )
          ),
          localContact.node.user_contact_emails.edges.map(function (userContactEmail, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: userContactEmail.node.id || userContactEmail.node.tempId,
                className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.relation
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.delete,
                  onClick: _this3.props.deleteUserContactEmail.bind(null, _this3.props.index, idx)
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'close' })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["f" /* FloatingLabelSelect */], {
                label: 'Type',
                name: 'label',
                value: userContactEmail.node.label,
                type: 'select',
                onChange: function onChange(e) {
                  _this3.handleRelationChange(e, idx, 'user_contact_emails', 'label');
                },
                submitted: _this3.state.submitted,
                placeholder: 'Type...',
                options: getLabelOptions(userContactEmail.node.label, emailLabelSuggestions),
                className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.label,
                inline: true,
                required: true,
                validationError: 'Required'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                label: 'Email',
                type: 'email',
                name: 'address',
                required: true,
                validations: 'isEmail',
                validationError: 'Email address is invalid',
                placeholder: 'email@example.com',
                value: userContactEmail.node.address,
                onChange: function onChange(e) {
                  _this3.handleRelationChange(e, idx, 'user_contact_emails', 'address');
                },
                submitted: _this3.state.submitted,
                className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.expanding,
                inline: 'last'
              })
            );
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.addRelation },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.addEmail },
              '+ Add Email'
            )
          ),
          localContact.node.user_contact_addresses.edges.map(function (userContactAddress, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: userContactAddress.node.id || userContactAddress.node.tempId
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.relation },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  {
                    className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.delete,
                    onClick: _this3.props.deleteUserContactAddress.bind(null, _this3.props.index, idx)
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'close' })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["f" /* FloatingLabelSelect */], {
                  label: 'Type',
                  name: 'label',
                  value: userContactAddress.node.label,
                  type: 'select',
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'label');
                  },
                  submitted: _this3.state.submitted,
                  placeholder: 'Type...',
                  options: getLabelOptions(userContactAddress.node.label, addressLabelSuggestions),
                  className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.label,
                  inline: true,
                  required: true,
                  validationError: 'Required'
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                  label: 'Address 1',
                  name: 'line1',
                  placeholder: '3 Elm Street',
                  value: userContactAddress.node.line1,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'line1');
                  },
                  submitted: _this3.state.submitted,
                  className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.expanding,
                  inline: 'last',
                  required: true,
                  validationError: 'Address is required'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                  label: 'Address 2',
                  name: 'line2',
                  placeholder: 'Apt. 2B',
                  value: userContactAddress.node.line2,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'line2');
                  },
                  submitted: _this3.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                  label: 'City',
                  name: 'city',
                  placeholder: 'San Francisco',
                  value: userContactAddress.node.city,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'city');
                  },
                  submitted: _this3.state.submitted,
                  required: true,
                  validationError: 'Required'
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                  label: 'State/Province',
                  name: 'province',
                  placeholder: 'California',
                  value: userContactAddress.node.province,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'province');
                  },
                  submitted: _this3.state.submitted,
                  required: true,
                  validationError: 'Required'
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
                  label: 'Postal Code',
                  name: 'postal_code',
                  placeholder: '94105',
                  value: userContactAddress.node.postal_code,
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'postal_code');
                  },
                  submitted: _this3.state.submitted,
                  required: true,
                  validationError: 'Required'
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["f" /* FloatingLabelSelect */], {
                  label: 'Country',
                  name: 'country',
                  value: userContactAddress.node.country,
                  type: 'select',
                  onChange: function onChange(e) {
                    _this3.handleRelationChange(e, idx, 'user_contact_addresses', 'country');
                  },
                  submitted: _this3.state.submitted,
                  search: true,
                  placeholder: 'Country...',
                  options: _this3.state.countries,
                  fluid: true,
                  required: true,
                  validationError: 'Country is required'
                })
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__ContactStyles_scss___default.a.addRelation },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.addAddress },
              '+ Add Address'
            )
          ),
          !this.props.hideActions && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modules__["j" /* DthcActions */], {
            reset: this.reset,
            'delete': this.props.delete ? this.delete : null,
            id: localContact.node.id,
            isNew: this.props.isNew
          })
        )
      );
    }
  }]);

  return ContactFieldsEdit;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContactFieldsEdit.propTypes = {
  localContact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  delete: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  isNew: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  hideActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  deleteUserContactEmail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  deleteUserContactPhone: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  deleteUserContactAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  submissionAttempts: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ContactFieldsEdit);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leads_scss__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Leads_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Leads_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_relay__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RecaptchaSettings = function (_Component) {
  _inherits(RecaptchaSettings, _Component);

  function RecaptchaSettings(props) {
    _classCallCheck(this, RecaptchaSettings);

    var _this = _possibleConstructorReturn(this, (RecaptchaSettings.__proto__ || Object.getPrototypeOf(RecaptchaSettings)).call(this, props));

    var _this$props$viewer = _this.props.viewer,
        s_recaptcha_enabled = _this$props$viewer.s_recaptcha_enabled,
        s_recaptcha_site_key = _this$props$viewer.s_recaptcha_site_key,
        s_recaptcha_secret_key = _this$props$viewer.s_recaptcha_secret_key;

    _this.state = {
      submitted: false,
      submitting: false,
      recaptchaSettings: {
        s_recaptcha_enabled: s_recaptcha_enabled,
        s_recaptcha_site_key: s_recaptcha_site_key,
        s_recaptcha_secret_key: s_recaptcha_secret_key
      },
      dirtyInputs: false,
      showSecretKey: false
    };
    _this.onValidRecaptchaSubmit = _this.onValidRecaptchaSubmit.bind(_this);
    _this.onInvalidRecaptchaSubmit = _this.onInvalidRecaptchaSubmit.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.checkboxChange = _this.checkboxChange.bind(_this);
    _this.toggleSecretKey = _this.toggleSecretKey.bind(_this);
    return _this;
  }

  _createClass(RecaptchaSettings, [{
    key: 'onInvalidRecaptchaSubmit',
    value: function onInvalidRecaptchaSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update reCAPTCHA settings',
        intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onValidRecaptchaSubmit',
    value: function onValidRecaptchaSubmit() {
      this.setState({ submitting: true, submitted: true });
      this.updateRecaptchaSettings();
    }
  }, {
    key: 'checkboxChange',
    value: function checkboxChange(e, data) {
      this.setState({
        recaptchaSettings: Object.assign({}, this.state.recaptchaSettings, {
          s_recaptcha_enabled: data.checked
        }),
        dirtyInputs: true
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.setState({
        recaptchaSettings: Object.assign({}, this.state.recaptchaSettings, _defineProperty({}, e.target.name, e.target.value)),
        dirtyInputs: true
      });
    }
  }, {
    key: 'toggleSecretKey',
    value: function toggleSecretKey() {
      this.setState({ showSecretKey: !this.state.showSecretKey });
    }
  }, {
    key: 'updateRecaptchaSettings',
    value: function updateRecaptchaSettings() {
      var _this2 = this;

      var onError = function onError() {
        _this2.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update reCAPTCHA settings',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.setState({ submitting: false, dirtyInputs: false });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated reCAPTCHA settings',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-recaptcha-settings');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3395);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            id: this.props.viewer.id
          }, this.state.recaptchaSettings)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          dirtyInputs = _state.dirtyInputs,
          showSecretKey = _state.showSecretKey,
          submitting = _state.submitting;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidRecaptchaSubmit,
          onInvalidSubmit: this.onInvalidRecaptchaSubmit
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */],
          { padded: true, relaxed: true, stackable: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
              { width: 5, className: __WEBPACK_IMPORTED_MODULE_5__Leads_scss___default.a.settingsLabels },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'reCAPTCHA'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __WEBPACK_IMPORTED_MODULE_5__Leads_scss___default.a.helperText },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'em',
                  null,
                  'Receiving spam? Require users to solve a challenge before submitting their forms to filter out automated submissions.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
              { width: 11 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Checkbox */], {
                label: 'Enable reCAPTCHA Verification',
                onChange: this.checkboxChange,
                name: 's_recaptcha_enabled',
                checked: this.state.recaptchaSettings.s_recaptcha_enabled,
                style: { paddingBottom: '2em' }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'You will need to register your website for reCAPTCHA in order to enable this feature. If you don\'t already have an account,',
                ' ',
                'please ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'https://www.google.com/recaptcha/admin/create' },
                  'create one here'
                ),
                ' to get site and secret keys.',
                ' '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Please be sure to use ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'reCAPTCHA v2'
                ),
                ' and select the ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  '"I\'m not a robot" Checkbox'
                ),
                ' option.'
              ),
              this.state.recaptchaSettings.s_recaptcha_enabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
                  label: 'Site key',
                  type: 'text',
                  name: 's_recaptcha_site_key',
                  value: this.state.recaptchaSettings.s_recaptcha_site_key || '',
                  onChange: this.textFieldChange,
                  required: true,
                  validationError: 'Site key is required',
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
                  label: 'Secret key',
                  type: showSecretKey ? 'text' : 'password',
                  name: 's_recaptcha_secret_key',
                  value: this.state.recaptchaSettings.s_recaptcha_secret_key || '',
                  onChange: this.textFieldChange,
                  required: true,
                  validationError: 'Secret key is required',
                  submitted: this.state.submitted
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: this.toggleSecretKey },
                    showSecretKey ? 'Hide' : 'Show',
                    ' secret key'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column, { width: 5 }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
              { width: 11 },
              dirtyInputs && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */], {
                primary: true,
                type: 'submit',
                content: submitting ? 'Saving...' : 'Save',
                disabled: submitting
              })
            )
          )
        )
      );
    }
  }]);

  return RecaptchaSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RecaptchaSettings.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types__["PropTypes"].object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (RecaptchaSettings);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Playlist_scss__);





var PlaylistPreview = function PlaylistPreview(_ref) {
  var following = _ref.following,
      openPlaylist = _ref.openPlaylist,
      playlist = _ref.playlist,
      style = _ref.style;

  var numSongs = playlist.num_songs;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { paddingBottom: '1em' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        onClick: function onClick() {
          if (openPlaylist) openPlaylist(playlist.id);
        },
        key: playlist.id,
        className: 'ui card fluid link',
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songThumbnail },
            !playlist.thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'music' }),
            playlist.thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { src: playlist.thumbnail.url })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: [__WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songDetails, __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.truncate].join(' ') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              playlist.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.muted },
              playlist.description
            ),
            following && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["y" /* Label */],
              { style: { marginTop: '0.5em' } },
              'Following'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            numSongs,
            ' ',
            'song' + (numSongs !== 1 ? 's' : '')
          )
        )
      )
    )
  );
};

PlaylistPreview.propTypes = {
  following: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  openPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (PlaylistPreview);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Playlist_scss__);





var RecommendationThumbnail = function RecommendationThumbnail(_ref) {
  var _onClick = _ref.onClick,
      playlist = _ref.playlist,
      action = _ref.action,
      actionClassName = _ref.actionClassName,
      actionIcon = _ref.actionIcon;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.recommendation },
    action !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], {
      src: actionIcon,
      className: actionClassName,
      onClick: function onClick(e) {
        e.stopPropagation();
        action(playlist.id);
      }
    }),
    function () {
      var thumbnail = playlist.thumbnail;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.playlistThumbnail,
          onClick: function onClick(e) {
            if (_onClick) _onClick(e);
          }
        },
        !thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'music' }),
        thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { src: thumbnail.url })
      );
    }(),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.recommendationTitle, title: playlist.title },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        playlist.title
      )
    )
  );
};

RecommendationThumbnail.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  actionIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  actionClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (RecommendationThumbnail);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_playlist__ = __webpack_require__(3471);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Song = function (_React$Component) {
  _inherits(Song, _React$Component);

  function Song(props) {
    _classCallCheck(this, Song);

    var _this = _possibleConstructorReturn(this, (Song.__proto__ || Object.getPrototypeOf(Song)).call(this, props));

    _this.state = {
      loading: false
    };
    _this.onClick = _this.onClick.bind(_this);
    _this.onSuccess = _this.onSuccess.bind(_this);
    _this.onFailure = _this.onFailure.bind(_this);
    return _this;
  }

  _createClass(Song, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.actionCallback && !this.state.loading) {
        this.setState({ loading: true });
        this.props.actionCallback(e, this.props.song, this.props.parent, this.onSuccess, this.onFailure);
      }
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      var _this2 = this;

      this.setState({ loading: false }, function () {
        if (_this2.props.onSuccess) _this2.props.onSuccess();
      });
    }
  }, {
    key: 'onFailure',
    value: function onFailure() {
      this.setState({ loading: false });
      if (this.props.onFailure) this.props.onFailure();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          actionCallback = _props.actionCallback,
          actionTrigger = _props.actionTrigger,
          song = _props.song;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songCard },
        function () {
          var songImage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_utils_playlist__["a" /* getSongImage */])(song, 64, 64);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songThumbnail },
            !songImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'music' }),
            songImage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { src: songImage.url })
          );
        }(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songDetails },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            song.name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.muted },
            song.artist
          )
        ),
        actionCallback && actionTrigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.songAction },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: this.onClick },
            actionTrigger
          )
        )
      );
    }
  }]);

  return Song;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Song.propTypes = {
  actionCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  actionTrigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFailure: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  song: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Song);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Song_Songs__ = __webpack_require__(3441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Song_Search__ = __webpack_require__(3440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recommendation_Recommendations__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Import___ = __webpack_require__(3428);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Playlist = function (_React$Component) {
  _inherits(Playlist, _React$Component);

  function Playlist(props) {
    _classCallCheck(this, Playlist);

    var _this = _possibleConstructorReturn(this, (Playlist.__proto__ || Object.getPrototypeOf(Playlist)).call(this, props));

    _this.listRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.importSpotifyRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.createNewSong = _this.createNewSong.bind(_this);
    return _this;
  }

  _createClass(Playlist, [{
    key: 'createNewSong',
    value: function createNewSong(e) {
      this.createPlannerPlaylistSong(e, this.state.newSong, this.props.playlist, this.closeNewSongForm);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          playlist = _props.playlist,
          editable = _props.editable,
          fillable = _props.fillable,
          goBack = _props.goBack,
          addToPlaylist = _props.addToPlaylist,
          addPlaylistRecommendations = _props.addPlaylistRecommendations,
          removePlaylistRecommendation = _props.removePlaylistRecommendation,
          playlistContainsSong = _props.playlistContainsSong,
          removeFromPlaylist = _props.removeFromPlaylist,
          relay = _props.relay,
          refetchSearchResults = _props.refetchSearchResults,
          searchResults = _props.searchResults,
          showControls = _props.showControls,
          updatePlaylist = _props.updatePlaylist,
          updateMaxLength = _props.updateMaxLength,
          deletePlaylist = _props.deletePlaylist,
          viewer = _props.viewer;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
        { stretched: true, centered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { computer: 16, tablet: 16, mobile: 16 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */], {
              playlist: playlist,
              editable: editable,
              goBack: goBack,
              showControls: showControls,
              updatePlaylist: updatePlaylist,
              updateMaxLength: updateMaxLength,
              deletePlaylist: deletePlaylist
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          {
            style: { marginTop: 0 },
            verticalAlign: 'top'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { computer: 16, tablet: 16, mobile: 16 },
            fillable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', marginBottom: '1em', alignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, marginRight: '0.5em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Song_Search__["a" /* default */], {
                  searchResults: searchResults,
                  refetchSearchResults: refetchSearchResults,
                  addToPlaylist: addToPlaylist,
                  playlistContainsSong: playlistContainsSong,
                  playlist: playlist,
                  clearSearch: function clearSearch() {},
                  listRef: this.listRef
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Import___["a" /* default */], { addToPlaylist: addToPlaylist, importSpotifyRef: this.importSpotifyRef })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Song_Songs__["a" /* default */], {
              playlist: playlist,
              innerRef: this.listRef,
              importSpotifyRef: this.importSpotifyRef,
              removeFromPlaylist: fillable ? removeFromPlaylist : null
            }),
            playlist.playlist_recommendations && (editable || playlist.playlist_recommendations.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Recommendation_Recommendations__["a" /* default */], {
              addPlaylistRecommendations: addPlaylistRecommendations,
              removePlaylistRecommendation: removePlaylistRecommendation,
              playlistRecommendations: playlist.playlist_recommendations.edges,
              viewer: viewer,
              relay: relay,
              editable: editable,
              addToPlaylist: addToPlaylist,
              playlist: playlist,
              playlistContainsSong: playlistContainsSong
            })
          )
        )
      );
    }
  }]);

  return Playlist;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Playlist.propTypes = {
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  searchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  showControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  refetchSearchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fillable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  goBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  removeFromPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updatePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updateMaxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deletePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  playlistContainsSong: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addPlaylistRecommendations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  removePlaylistRecommendation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (Playlist);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_day_picker__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_day_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_day_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_date__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  groupEventsByDate: function groupEventsByDate(events, month, timeZone) {
    var eventsByDate = {};
    var convertDateTimeToDate = function convertDateTimeToDate(datetime, allDay) {
      var m = __WEBPACK_IMPORTED_MODULE_2__lib_utils_date__["a" /* default */].isoStringToMoment(datetime, allDay, timeZone);
      return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
    };
    for (var i = 1; i <= 31; i++) {
      eventsByDate[i] = [];
      var day = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(month).date(i);
      for (var j = 0; j < events.length; j++) {
        var eventAdded = false;
        var userEventSegments = events[j].node.user_event_segments.edges;
        for (var k = 0; k < userEventSegments.length; k++) {
          if (__WEBPACK_IMPORTED_MODULE_0_react_day_picker__["DateUtils"].isDayInRange(day.toDate(), {
            from: convertDateTimeToDate(userEventSegments[k].node.start_at, userEventSegments[k].node.all_day),
            to: convertDateTimeToDate(userEventSegments[k].node.end_at, userEventSegments[k].node.all_day)
          })) {
            if (!eventAdded) eventsByDate[i].push(events[j]);
            eventAdded = true;
          }
        }
      }
    }
    return eventsByDate;
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ianaTimezones */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);


var ianaTimezones = ['Etc/GMT+12', 'Pacific/Midway', 'Pacific/Honolulu', 'America/Juneau', 'America/Los_Angeles', 'America/Denver', 'America/Chihuahua', 'America/Phoenix', 'America/Chicago', 'America/Regina', 'America/Mexico_City', 'America/Belize', 'America/New_York', 'America/Indiana/Indianapolis', 'America/Bogota', 'America/Glace_Bay', 'America/Caracas', 'America/Santiago', 'America/St_Johns', 'America/Sao_Paulo', 'America/Argentina/Buenos_Aires', 'America/Godthab', 'Etc/GMT+2', 'Atlantic/Azores', 'Atlantic/Cape_Verde', 'GMT', 'Africa/Casablanca', 'Atlantic/Canary', 'Europe/Belgrade', 'Europe/Sarajevo', 'Europe/Brussels', 'Europe/Amsterdam', 'Africa/Algiers', 'Europe/Bucharest', 'Africa/Cairo', 'Europe/Helsinki', 'Europe/Athens', 'Asia/Jerusalem', 'Africa/Harare', 'Europe/Moscow', 'Asia/Kuwait', 'Africa/Nairobi', 'Asia/Baghdad', 'Asia/Tehran', 'Asia/Dubai', 'Asia/Baku', 'Asia/Kabul', 'Asia/Yekaterinburg', 'Asia/Karachi', 'Asia/Kolkata', 'Asia/Kathmandu', 'Asia/Dhaka', 'Asia/Colombo', 'Asia/Almaty', 'Asia/Rangoon', 'Asia/Bangkok', 'Asia/Krasnoyarsk', 'Asia/Shanghai', 'Asia/Kuala_Lumpur', 'Asia/Taipei', 'Australia/Perth', 'Asia/Irkutsk', 'Asia/Seoul', 'Asia/Tokyo', 'Asia/Yakutsk', 'Australia/Darwin', 'Australia/Adelaide', 'Australia/Sydney', 'Australia/Brisbane', 'Australia/Hobart', 'Asia/Vladivostok', 'Pacific/Guam', 'Asia/Magadan', 'Pacific/Fiji', 'Pacific/Auckland', 'Pacific/Tongatapu'];

var i18n = {
  'Etc/GMT+12': 'International Date Line West',
  'Pacific/Midway': 'Midway Island, Samoa',
  'Pacific/Honolulu': 'Hawaii',
  'America/Juneau': 'Alaska',
  'America/Los_Angeles': 'Pacific Time (US and Canada); Tijuana',
  'America/Denver': 'Mountain Time (US and Canada)',
  'America/Chihuahua': 'Chihuahua, La Paz, Mazatlan',
  'America/Phoenix': 'Arizona',
  'America/Chicago': 'Central Time (US and Canada)',
  'America/Regina': 'Saskatchewan',
  'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
  'America/Belize': 'Central America',
  'America/New_York': 'Eastern Time (US and Canada)',
  'America/Indiana/Indianapolis': 'Indiana (East)',
  'America/Bogota': 'Bogota, Lima, Quito',
  'America/Glace_Bay': 'Atlantic Time (Canada)',
  'America/Caracas': 'Caracas, La Paz',
  'America/Santiago': 'Santiago',
  'America/St_Johns': 'Newfoundland and Labrador',
  'America/Sao_Paulo': 'Brasilia',
  'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
  'America/Godthab': 'Greenland',
  'Etc/GMT+2': 'Mid-Atlantic',
  'Atlantic/Azores': 'Azores',
  'Atlantic/Cape_Verde': 'Cape Verde Islands',
  GMT: 'Dublin, Edinburgh, Lisbon, London',
  'Africa/Casablanca': 'Casablanca, Monrovia',
  'Atlantic/Canary': 'Canary Islands',
  'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  'Europe/Sarajevo': 'Sarajevo, Skopje, Warsaw, Zagreb',
  'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
  'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  'Africa/Algiers': 'West Central Africa',
  'Europe/Bucharest': 'Bucharest',
  'Africa/Cairo': 'Cairo',
  'Europe/Helsinki': 'Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
  'Europe/Athens': 'Athens, Istanbul, Minsk',
  'Asia/Jerusalem': 'Jerusalem',
  'Africa/Harare': 'Harare, Pretoria',
  'Europe/Moscow': 'Moscow, St. Petersburg, Volgograd',
  'Asia/Kuwait': 'Kuwait, Riyadh',
  'Africa/Nairobi': 'Nairobi',
  'Asia/Baghdad': 'Baghdad',
  'Asia/Tehran': 'Tehran',
  'Asia/Dubai': 'Abu Dhabi, Muscat',
  'Asia/Baku': 'Baku, Tbilisi, Yerevan',
  'Asia/Kabul': 'Kabul',
  'Asia/Yekaterinburg': 'Ekaterinburg',
  'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
  'Asia/Kolkata': 'Chennai, Kolkata, Mumbai, New Delhi',
  'Asia/Kathmandu': 'Kathmandu',
  'Asia/Dhaka': 'Astana, Dhaka',
  'Asia/Colombo': 'Sri Jayawardenepura',
  'Asia/Almaty': 'Almaty, Novosibirsk',
  'Asia/Rangoon': 'Yangon Rangoon',
  'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
  'Asia/Krasnoyarsk': 'Krasnoyarsk',
  'Asia/Shanghai': 'Beijing, Chongqing, Hong Kong SAR, Urumqi',
  'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
  'Asia/Taipei': 'Taipei',
  'Australia/Perth': 'Perth',
  'Asia/Irkutsk': 'Irkutsk, Ulaanbaatar',
  'Asia/Seoul': 'Seoul',
  'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
  'Asia/Yakutsk': 'Yakutsk',
  'Australia/Darwin': 'Darwin',
  'Australia/Adelaide': 'Adelaide',
  'Australia/Sydney': 'Canberra, Melbourne, Sydney',
  'Australia/Brisbane': 'Brisbane',
  'Australia/Hobart': 'Hobart',
  'Asia/Vladivostok': 'Vladivostok',
  'Pacific/Guam': 'Guam, Port Moresby',
  'Asia/Magadan': 'Magadan, Solomon Islands, New Caledonia',
  'Pacific/Fiji': 'Fiji Islands, Kamchatka, Marshall Islands',
  'Pacific/Auckland': 'Auckland, Wellington',
  'Pacific/Tongatapu': "Nuku'alofa"
};

var t = function t(s) {
  if (i18n !== void 0 && i18n[s]) {
    return i18n[s];
  }
  return s;
};

var timezones = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz.names().filter(function (tz) {
  return ianaTimezones.includes(tz);
}).reduce(function (memo, tz) {
  memo.push({
    name: tz,
    offset: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz(tz).utcOffset()
  });
  return memo;
}, []).sort(function (a, b) {
  return a.offset - b.offset;
}).reduce(function (memo, tz) {
  var timezone = tz.offset ? __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz(tz.name).format('Z') : '';
  return memo.concat({
    name: tz.name,
    offset: tz.offset,
    text: '(GMT' + timezone + ') ' + t(tz.name)
  });
}, []);

/* harmony default export */ __webpack_exports__["a"] = (timezones);



/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3519);
});

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3543);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Contract.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Contract.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3565);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./FloatingLabelInput.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./FloatingLabelInput.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3574);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventList.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3581);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./AvailabilityChecker.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./AvailabilityChecker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(1522);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The four basic intents.
 */
var Intent;
(function (Intent) {
  Intent[Intent["NONE"] = -1] = "NONE";
  Intent[Intent["PRIMARY"] = 0] = "PRIMARY";
  Intent[Intent["SUCCESS"] = 1] = "SUCCESS";
  Intent[Intent["WARNING"] = 2] = "WARNING";
  Intent[Intent["DANGER"] = 3] = "DANGER";
})(Intent = exports.Intent || (exports.Intent = {}));

//# sourceMappingURL=intent.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var position_1 = __webpack_require__(157);
// per https://github.com/HubSpot/tether/pull/204, Tether now exposes a `bodyElement` option that,
// when present, gets the tethered element injected into *it* instead of into the document body.
// but both approaches still cause React to freak out, because it loses its handle on the DOM
// element. thus, we pass a fake HTML bodyElement to Tether, with a no-op `appendChild` function
// (the only function the library uses from bodyElement).
var fakeHtmlElement = {
    appendChild: function appendChild() {}
};
/** @internal */
function createTetherOptions(element, target, position, tetherOptions) {
    if (tetherOptions === void 0) {
        tetherOptions = {};
    }
    return tslib_1.__assign({}, tetherOptions, { attachment: getPopoverAttachment(position), bodyElement: fakeHtmlElement, classPrefix: "pt-tether", element: element,
        target: target, targetAttachment: getTargetAttachment(position) });
}
exports.createTetherOptions = createTetherOptions;
/** @internal */
function getTargetAttachment(position) {
    var attachments = (_a = {}, _a[position_1.Position.TOP_LEFT] = "top left", _a[position_1.Position.TOP] = "top center", _a[position_1.Position.TOP_RIGHT] = "top right", _a[position_1.Position.RIGHT_TOP] = "top right", _a[position_1.Position.RIGHT] = "middle right", _a[position_1.Position.RIGHT_BOTTOM] = "bottom right", _a[position_1.Position.BOTTOM_RIGHT] = "bottom right", _a[position_1.Position.BOTTOM] = "bottom center", _a[position_1.Position.BOTTOM_LEFT] = "bottom left", _a[position_1.Position.LEFT_BOTTOM] = "bottom left", _a[position_1.Position.LEFT] = "middle left", _a[position_1.Position.LEFT_TOP] = "top left", _a);
    return attachments[position];
    var _a;
}
exports.getTargetAttachment = getTargetAttachment;
/** @internal */
function getPopoverAttachment(position) {
    var attachments = (_a = {}, _a[position_1.Position.TOP_LEFT] = "bottom left", _a[position_1.Position.TOP] = "bottom center", _a[position_1.Position.TOP_RIGHT] = "bottom right", _a[position_1.Position.RIGHT_TOP] = "top left", _a[position_1.Position.RIGHT] = "middle left", _a[position_1.Position.RIGHT_BOTTOM] = "bottom left", _a[position_1.Position.BOTTOM_RIGHT] = "top right", _a[position_1.Position.BOTTOM] = "top center", _a[position_1.Position.BOTTOM_LEFT] = "top left", _a[position_1.Position.LEFT_BOTTOM] = "bottom right", _a[position_1.Position.LEFT] = "middle right", _a[position_1.Position.LEFT_TOP] = "top right", _a);
    return attachments[position];
    var _a;
}
exports.getPopoverAttachment = getPopoverAttachment;
/** @internal */
function getAttachmentClasses(position) {
    // this essentially reimplements the Tether logic for attachment classes so the same styles
    // can be reused outside of Tether-based popovers.
    return expandAttachmentClasses(getPopoverAttachment(position), "pt-tether-element-attached").concat(expandAttachmentClasses(getTargetAttachment(position), "pt-tether-target-attached"));
}
exports.getAttachmentClasses = getAttachmentClasses;
function expandAttachmentClasses(attachments, prefix) {
    var _a = attachments.split(" "),
        verticalAlign = _a[0],
        horizontalAlign = _a[1];
    return [prefix + "-" + verticalAlign, prefix + "-" + horizontalAlign];
}

//# sourceMappingURL=tetherUtils.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var AnimationStates;
(function (AnimationStates) {
    AnimationStates[AnimationStates["CLOSED"] = 0] = "CLOSED";
    AnimationStates[AnimationStates["OPENING"] = 1] = "OPENING";
    AnimationStates[AnimationStates["OPEN"] = 2] = "OPEN";
    AnimationStates[AnimationStates["CLOSING_START"] = 3] = "CLOSING_START";
    AnimationStates[AnimationStates["CLOSING_END"] = 4] = "CLOSING_END";
})(AnimationStates = exports.AnimationStates || (exports.AnimationStates = {}));
/*
 * A collapse can be in one of 5 states:
 * CLOSED
 * When in this state, the contents of the collapse is not rendered, the collapse height is 0,
 * and the body Y is at -height (so that the bottom of the body is at Y=0).
 *
 * OPEN
 * When in this state, the collapse height is set to auto, and the body Y is set to 0 (so the element can be seen
 * as normal).
 *
 * CLOSING_START
 * When in this state, height has been changed from auto to the measured height of the body to prepare for the
 * closing animation in CLOSING_END.
 *
 * CLOSING_END
 * When in this state, the height is set to 0 and the body Y is at -height. Both of these properties are transformed,
 * and then after the animation is complete, the state changes to CLOSED.
 *
 * OPENING
 * When in this state, the body is re-rendered, height is set to the measured body height and the body Y is set to 0.
 * This is all animated, and on complete, the state changes to OPEN.
 *
 * When changing the isOpen prop, the following happens to the states:
 * isOpen = true : CLOSED -> OPENING -> OPEN
 * isOpen = false: OPEN -> CLOSING_START -> CLOSING_END -> CLOSED
 * These are all animated.
 */
var Collapse = function (_super) {
    tslib_1.__extends(Collapse, _super);
    function Collapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            animationState: AnimationStates.OPEN,
            height: "0px"
        };
        // The most recent non-0 height (once a height has been measured - is 0 until then)
        _this.height = 0;
        _this.contentsRefHandler = function (el) {
            _this.contents = el;
            if (el != null) {
                _this.height = _this.contents.clientHeight;
                _this.setState({
                    animationState: _this.props.isOpen ? AnimationStates.OPEN : AnimationStates.CLOSED,
                    height: _this.height + "px"
                });
            }
        };
        return _this;
    }
    Collapse.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.contents != null && this.contents.clientHeight !== 0) {
            this.height = this.contents.clientHeight;
        }
        if (this.props.isOpen !== nextProps.isOpen) {
            this.clearTimeouts();
            if (this.state.animationState !== AnimationStates.CLOSED && !nextProps.isOpen) {
                this.setState({
                    animationState: AnimationStates.CLOSING_START,
                    height: this.height + "px"
                });
            } else if (this.state.animationState !== AnimationStates.OPEN && nextProps.isOpen) {
                this.setState({
                    animationState: AnimationStates.OPENING,
                    height: this.height + "px"
                });
                this.setTimeout(function () {
                    return _this.onDelayedStateChange();
                }, this.props.transitionDuration);
            }
        }
    };
    Collapse.prototype.render = function () {
        var showContents = this.state.animationState !== AnimationStates.CLOSED;
        var displayWithTransform = showContents && this.state.animationState !== AnimationStates.CLOSING_END;
        var isAutoHeight = this.state.height === "auto";
        var containerStyle = {
            height: showContents ? this.state.height : undefined,
            overflowY: isAutoHeight ? "visible" : undefined,
            transition: isAutoHeight ? "none" : undefined
        };
        var contentsStyle = {
            transform: displayWithTransform ? "translateY(0)" : "translateY(-" + this.height + "px)",
            transition: isAutoHeight ? "none" : undefined
        };
        // quick type cast because there's no single overload that supports all three ReactTypes (str | Cmp | SFC)
        return React.createElement(this.props.component, {
            className: classNames(Classes.COLLAPSE, this.props.className),
            style: containerStyle
        }, React.createElement("div", { className: "pt-collapse-body", ref: this.contentsRefHandler, style: contentsStyle }, showContents ? this.props.children : null));
    };
    Collapse.prototype.componentDidMount = function () {
        this.forceUpdate();
        if (this.props.isOpen) {
            this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
        } else {
            this.setState({ animationState: AnimationStates.CLOSED });
        }
    };
    Collapse.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.animationState === AnimationStates.CLOSING_START) {
            this.setTimeout(function () {
                return _this.setState({
                    animationState: AnimationStates.CLOSING_END,
                    height: "0px"
                });
            });
            this.setTimeout(function () {
                return _this.onDelayedStateChange();
            }, this.props.transitionDuration);
        }
    };
    Collapse.prototype.onDelayedStateChange = function () {
        switch (this.state.animationState) {
            case AnimationStates.OPENING:
                this.setState({ animationState: AnimationStates.OPEN, height: "auto" });
                break;
            case AnimationStates.CLOSING_END:
                this.setState({ animationState: AnimationStates.CLOSED });
                break;
            default:
                break;
        }
    };
    return Collapse;
}(abstractComponent_1.AbstractComponent);
Collapse.displayName = "Blueprint.Collapse";
Collapse.defaultProps = {
    component: "div",
    isOpen: false,
    transitionDuration: 200
};
exports.Collapse = Collapse;

//# sourceMappingURL=collapse.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var position_1 = __webpack_require__(157);
var utils_1 = __webpack_require__(53);
var popover_1 = __webpack_require__(266);
var TETHER_OPTIONS = {
    constraints: [{ attachment: "together", pin: true, to: "window" }]
};
var TRANSITION_DURATION = 100;
var ContextMenu = function (_super) {
    tslib_1.__extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.cancelContextMenu = function (e) {
            return e.preventDefault();
        };
        _this.handleBackdropContextMenu = function (e) {
            // React function to remove from the event pool, useful when using a event within a callback
            e.persist();
            e.preventDefault();
            // wait for backdrop to disappear so we can find the "real" element at event coordinates.
            // timeout duration is equivalent to transition duration so we know it's animated out.
            _this.setTimeout(function () {
                // retrigger context menu event at the element beneath the backdrop.
                // if it has a `contextmenu` event handler then it'll be invoked.
                // if it doesn't, no native menu will show (at least on OSX) :(
                var newTarget = document.elementFromPoint(e.clientX, e.clientY);
                newTarget.dispatchEvent(new MouseEvent("contextmenu", e));
            }, TRANSITION_DURATION);
        };
        _this.handlePopoverInteraction = function (nextOpenState) {
            if (!nextOpenState) {
                // delay the actual hiding till the event queue clears
                // to avoid flicker of opening twice
                requestAnimationFrame(function () {
                    return _this.hide();
                });
            }
        };
        return _this;
    }
    ContextMenu.prototype.render = function () {
        // prevent right-clicking in a context menu
        var content = React.createElement("div", { onContextMenu: this.cancelContextMenu }, this.state.menu);
        return React.createElement(popover_1.Popover, { backdropProps: { onContextMenu: this.handleBackdropContextMenu }, content: content, enforceFocus: false, isModal: true, isOpen: this.state.isOpen, onInteraction: this.handlePopoverInteraction, position: position_1.Position.RIGHT_TOP, popoverClassName: Classes.MINIMAL, useSmartArrowPositioning: false, tetherOptions: TETHER_OPTIONS, transitionDuration: TRANSITION_DURATION }, React.createElement("div", { className: Classes.CONTEXT_MENU_POPOVER_TARGET, style: this.state.offset }));
    };
    ContextMenu.prototype.show = function (menu, offset, onClose) {
        this.setState({ isOpen: true, menu: menu, offset: offset, onClose: onClose });
    };
    ContextMenu.prototype.hide = function () {
        utils_1.safeInvoke(this.state.onClose);
        this.setState({ isOpen: false, onClose: undefined });
    };
    return ContextMenu;
}(abstractComponent_1.AbstractComponent);
var contextMenu;
/**
 * Show the given menu element at the given offset from the top-left corner of the viewport.
 * The menu will appear below-right of this point and will flip to below-left if there is not enough
 * room onscreen. The optional callback will be invoked when this menu closes.
 */
function show(menu, offset, onClose) {
    if (contextMenu == null) {
        var contextMenuElement = document.createElement("div");
        contextMenuElement.classList.add(Classes.CONTEXT_MENU);
        document.body.appendChild(contextMenuElement);
        contextMenu = ReactDOM.render(React.createElement(ContextMenu, null), contextMenuElement);
    }
    contextMenu.show(menu, offset, onClose);
}
exports.show = show;
/** Hide the open context menu. */
function hide() {
    if (contextMenu != null) {
        contextMenu.hide();
    }
}
exports.hide = hide;
/** Return whether a context menu is currently open. */
function isOpen() {
    return contextMenu != null && contextMenu.state.isOpen;
}
exports.isOpen = isOpen;

//# sourceMappingURL=contextMenu.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var utils_1 = __webpack_require__(53);
var icon_1 = __webpack_require__(188);
var overlay_1 = __webpack_require__(391);
var Dialog = function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleContainerMouseDown = function (evt) {
            // quick re-implementation of canOutsideClickClose because .pt-dialog-container covers the backdrop
            var isClickOutsideDialog = evt.target.closest("." + Classes.DIALOG) == null;
            if (isClickOutsideDialog && _this.props.canOutsideClickClose) {
                utils_1.safeInvoke(_this.props.onClose, evt);
            }
        };
        return _this;
    }
    Dialog.prototype.render = function () {
        return React.createElement(overlay_1.Overlay, tslib_1.__assign({}, this.props, { className: Classes.OVERLAY_SCROLL_CONTAINER, hasBackdrop: true }), React.createElement("div", { className: Classes.DIALOG_CONTAINER, onMouseDown: this.handleContainerMouseDown }, React.createElement("div", { className: classNames(Classes.DIALOG, this.props.className), style: this.props.style }, this.maybeRenderHeader(), this.props.children)));
    };
    Dialog.prototype.validateProps = function (props) {
        if (props.title == null) {
            if (props.iconName != null) {
                console.warn(Errors.DIALOG_WARN_NO_HEADER_ICON);
            }
            if (props.isCloseButtonShown != null) {
                console.warn(Errors.DIALOG_WARN_NO_HEADER_CLOSE_BUTTON);
            }
        }
    };
    Dialog.prototype.maybeRenderCloseButton = function () {
        // for now, show close button if prop is undefined or null
        // this gives us a behavior as if the default value were `true`
        if (this.props.isCloseButtonShown !== false) {
            var classes = classNames(Classes.DIALOG_CLOSE_BUTTON, Classes.iconClass("small-cross"));
            return React.createElement("button", { "aria-label": "Close", className: classes, onClick: this.props.onClose });
        } else {
            return undefined;
        }
    };
    Dialog.prototype.maybeRenderHeader = function () {
        var _a = this.props,
            iconName = _a.iconName,
            title = _a.title;
        if (title == null) {
            return undefined;
        }
        return React.createElement("div", { className: Classes.DIALOG_HEADER }, React.createElement(icon_1.Icon, { iconName: iconName, iconSize: 20 }), React.createElement("h5", null, title), this.maybeRenderCloseButton());
    };
    return Dialog;
}(abstractComponent_1.AbstractComponent);
Dialog.defaultProps = {
    canOutsideClickClose: true,
    isOpen: false
};
Dialog.displayName = "Blueprint.Dialog";
exports.Dialog = Dialog;
exports.DialogFactory = React.createFactory(Dialog);

//# sourceMappingURL=dialog.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
// HACKHACK: these components should go in separate files
// tslint:disable max-classes-per-file
// we need some empty interfaces to show up in docs
// tslint:disable no-empty-interface
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var props_1 = __webpack_require__(265);
var utils_1 = __webpack_require__(53);
var INVALID_PROPS = [
// we spread props to `<input>` but render `children` as its sibling
"children", "defaultIndeterminate", "indeterminate", "labelElement"];
/** Base Component class for all Controls */
var Control = function (_super) {
    tslib_1.__extends(Control, _super);
    function Control() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // generates control markup for given input type.
    // optional inputRef in case the component needs reference for itself (don't forget to invoke the prop!).
    Control.prototype.renderControl = function (type, typeClassName, inputRef) {
        if (inputRef === void 0) {
            inputRef = this.props.inputRef;
        }
        var className = classNames(Classes.CONTROL, typeClassName, (_a = {}, _a[Classes.DISABLED] = this.props.disabled, _a), this.props.className);
        var inputProps = props_1.removeNonHTMLProps(this.props, INVALID_PROPS, true);
        return React.createElement("label", { className: className, style: this.props.style }, React.createElement("input", tslib_1.__assign({}, inputProps, { ref: inputRef, type: type })), React.createElement("span", { className: Classes.CONTROL_INDICATOR }), this.props.label, this.props.labelElement, this.props.children);
        var _a;
    };
    return Control;
}(React.Component);
exports.Control = Control;
var Checkbox = function (_super) {
    tslib_1.__extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputRef = function (ref) {
            _this.input = ref;
            utils_1.safeInvoke(_this.props.inputRef, ref);
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        return this.renderControl("checkbox", "pt-checkbox", this.handleInputRef);
    };
    Checkbox.prototype.componentDidMount = function () {
        if (this.props.defaultIndeterminate != null) {
            this.input.indeterminate = this.props.defaultIndeterminate;
        }
        this.updateIndeterminate();
    };
    Checkbox.prototype.componentDidUpdate = function () {
        this.updateIndeterminate();
    };
    Checkbox.prototype.updateIndeterminate = function () {
        if (this.props.indeterminate != null) {
            this.input.indeterminate = this.props.indeterminate;
        }
    };
    return Checkbox;
}(Control);
Checkbox.displayName = "Blueprint.Checkbox";
exports.Checkbox = Checkbox;
var Switch = function (_super) {
    tslib_1.__extends(Switch, _super);
    function Switch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switch.prototype.render = function () {
        return this.renderControl("checkbox", "pt-switch");
    };
    return Switch;
}(Control);
Switch.displayName = "Blueprint.Switch";
exports.Switch = Switch;
var Radio = function (_super) {
    tslib_1.__extends(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function () {
        return this.renderControl("radio", "pt-radio");
    };
    return Radio;
}(Control);
Radio.displayName = "Blueprint.Radio";
exports.Radio = Radio;
exports.CheckboxFactory = React.createFactory(Checkbox);
exports.SwitchFactory = React.createFactory(Switch);
exports.RadioFactory = React.createFactory(Radio);

//# sourceMappingURL=controls.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var props_1 = __webpack_require__(265);
var icon_1 = __webpack_require__(188);
var InputGroup = function (_super) {
    tslib_1.__extends(InputGroup, _super);
    function InputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            rightElementWidth: 30
        };
        _this.refHandlers = {
            rightElement: function rightElement(ref) {
                return _this.rightElement = ref;
            }
        };
        return _this;
    }
    InputGroup.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            intent = _a.intent,
            leftIconName = _a.leftIconName;
        var classes = classNames(Classes.INPUT_GROUP, Classes.intentClass(intent), (_b = {}, _b[Classes.DISABLED] = this.props.disabled, _b), className);
        var style = { paddingRight: this.state.rightElementWidth };
        return React.createElement("div", { className: classes }, React.createElement(icon_1.Icon, { iconName: leftIconName, iconSize: "inherit" }), React.createElement("input", tslib_1.__assign({ type: "text" }, props_1.removeNonHTMLProps(this.props), { className: Classes.INPUT, ref: this.props.inputRef, style: style })), this.maybeRenderRightElement());
        var _b;
    };
    InputGroup.prototype.componentDidMount = function () {
        this.updateInputWidth();
    };
    InputGroup.prototype.componentDidUpdate = function () {
        this.updateInputWidth();
    };
    InputGroup.prototype.maybeRenderRightElement = function () {
        var rightElement = this.props.rightElement;
        if (rightElement == null) {
            return undefined;
        }
        return React.createElement("span", { className: "pt-input-action", ref: this.refHandlers.rightElement }, rightElement);
    };
    InputGroup.prototype.updateInputWidth = function () {
        if (this.rightElement != null) {
            var clientWidth = this.rightElement.clientWidth;
            // small threshold to prevent infinite loops
            if (Math.abs(clientWidth - this.state.rightElementWidth) > 2) {
                this.setState({ rightElementWidth: clientWidth });
            }
        } else {
            this.setState({ rightElementWidth: 0 });
        }
    };
    return InputGroup;
}(React.Component);
InputGroup.displayName = "Blueprint.InputGroup";
InputGroup = tslib_1.__decorate([PureRender], InputGroup);
exports.InputGroup = InputGroup;
exports.InputGroupFactory = React.createFactory(InputGroup);

//# sourceMappingURL=inputGroup.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var react_1 = __webpack_require__(0);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var hotkey_1 = __webpack_require__(390);
var hotkey_2 = __webpack_require__(390);
exports.Hotkey = hotkey_2.Hotkey;
var keyCombo_1 = __webpack_require__(844);
exports.KeyCombo = keyCombo_1.KeyCombo;
var hotkeysTarget_1 = __webpack_require__(1538);
exports.HotkeysTarget = hotkeysTarget_1.HotkeysTarget;
var hotkeyParser_1 = __webpack_require__(537);
exports.comboMatches = hotkeyParser_1.comboMatches;
exports.getKeyCombo = hotkeyParser_1.getKeyCombo;
exports.getKeyComboString = hotkeyParser_1.getKeyComboString;
exports.parseKeyCombo = hotkeyParser_1.parseKeyCombo;
var hotkeysDialog_1 = __webpack_require__(843);
exports.hideHotkeysDialog = hotkeysDialog_1.hideHotkeysDialog;
exports.setHotkeysDialogProps = hotkeysDialog_1.setHotkeysDialogProps;
var errors_1 = __webpack_require__(93);
var Hotkeys = function (_super) {
    tslib_1.__extends(Hotkeys, _super);
    function Hotkeys() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hotkeys.prototype.render = function () {
        var hotkeys = react_1.Children.map(this.props.children, function (child) {
            return child.props;
        });
        // sort by group label alphabetically, globals first
        hotkeys.sort(function (a, b) {
            if (a.global) {
                return b.global ? 0 : -1;
            }
            if (b.global) {
                return 1;
            }
            return a.group.localeCompare(b.group);
        });
        var lastGroup = null;
        var elems = [];
        for (var _i = 0, hotkeys_1 = hotkeys; _i < hotkeys_1.length; _i++) {
            var hotkey = hotkeys_1[_i];
            var groupLabel = hotkey.group;
            if (groupLabel !== lastGroup) {
                elems.push(React.createElement("h4", { key: "group-" + elems.length, className: "pt-hotkey-group" }, groupLabel));
                lastGroup = groupLabel;
            }
            elems.push(React.createElement(hotkey_1.Hotkey, tslib_1.__assign({ key: elems.length }, hotkey)));
        }
        return React.createElement("div", { className: "pt-hotkey-column" }, elems);
    };
    Hotkeys.prototype.validateProps = function (props) {
        react_1.Children.forEach(props.children, function (child) {
            if (!hotkey_1.Hotkey.isInstance(child)) {
                throw new Error(errors_1.HOTKEYS_HOTKEY_CHILDREN);
            }
        });
    };
    return Hotkeys;
}(common_1.AbstractComponent);
Hotkeys.defaultProps = {
    tabIndex: 0
};
exports.Hotkeys = Hotkeys;

//# sourceMappingURL=hotkeys.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var common_1 = __webpack_require__(186);
var components_1 = __webpack_require__(845);
var hotkey_1 = __webpack_require__(390);
var hotkeys_1 = __webpack_require__(842);
/**
 * The delay before showing or hiding the dialog. Should be long enough to
 * allow all registered hotkey listeners to execute first.
 */
var DELAY_IN_MS = 10;
var HotkeysDialog = function () {
    function HotkeysDialog() {
        var _this = this;
        this.componentProps = {
            globalHotkeysGroup: "Global hotkeys"
        };
        this.hotkeysQueue = [];
        this.isDialogShowing = false;
        this.show = function () {
            _this.isDialogShowing = true;
            _this.render();
        };
        this.hide = function () {
            _this.isDialogShowing = false;
            _this.render();
        };
    }
    HotkeysDialog.prototype.render = function () {
        if (this.container == null) {
            this.container = this.getContainer();
        }
        ReactDOM.render(this.renderComponent(), this.container);
    };
    HotkeysDialog.prototype.unmount = function () {
        if (this.container != null) {
            ReactDOM.unmountComponentAtNode(this.container);
            this.container.remove();
            delete this.container;
        }
    };
    /**
     * Because hotkeys can be registered globally and locally and because
     * event ordering cannot be guaranteed, we use this debouncing method to
     * allow all hotkey listeners to fire and add their hotkeys to the dialog.
     *
     * 10msec after the last listener adds their hotkeys, we render the dialog
     * and clear the queue.
     */
    HotkeysDialog.prototype.enqueueHotkeysForDisplay = function (hotkeys) {
        this.hotkeysQueue.push(hotkeys);
        // reset timeout for debounce
        clearTimeout(this.showTimeoutToken);
        this.showTimeoutToken = setTimeout(this.show, DELAY_IN_MS);
    };
    HotkeysDialog.prototype.hideAfterDelay = function () {
        clearTimeout(this.hideTimeoutToken);
        this.hideTimeoutToken = setTimeout(this.hide, DELAY_IN_MS);
    };
    HotkeysDialog.prototype.isShowing = function () {
        return this.isDialogShowing;
    };
    HotkeysDialog.prototype.getContainer = function () {
        if (this.container == null) {
            this.container = document.createElement("div");
            this.container.classList.add(common_1.Classes.PORTAL);
            document.body.appendChild(this.container);
        }
        return this.container;
    };
    HotkeysDialog.prototype.renderComponent = function () {
        return React.createElement(components_1.Dialog, tslib_1.__assign({}, this.componentProps, { className: classNames(this.componentProps.className, "pt-hotkey-dialog"), isOpen: this.isDialogShowing, onClose: this.hide }), React.createElement("div", { className: common_1.Classes.DIALOG_BODY }, this.renderHotkeys()));
    };
    HotkeysDialog.prototype.renderHotkeys = function () {
        var _this = this;
        var hotkeys = this.emptyHotkeyQueue();
        var elements = hotkeys.map(function (hotkey, index) {
            var group = hotkey.global === true && hotkey.group == null ? _this.componentProps.globalHotkeysGroup : hotkey.group;
            return React.createElement(hotkey_1.Hotkey, tslib_1.__assign({ key: index }, hotkey, { group: group }));
        });
        return React.createElement(hotkeys_1.Hotkeys, null, elements);
    };
    HotkeysDialog.prototype.emptyHotkeyQueue = function () {
        // flatten then empty the hotkeys queue
        var hotkeys = this.hotkeysQueue.reduce(function (arr, queued) {
            return arr.concat(queued);
        }, []);
        this.hotkeysQueue.length = 0;
        return hotkeys;
    };
    return HotkeysDialog;
}();
// singleton instance
var HOTKEYS_DIALOG = new HotkeysDialog();
function isHotkeysDialogShowing() {
    return HOTKEYS_DIALOG.isShowing();
}
exports.isHotkeysDialogShowing = isHotkeysDialogShowing;
function setHotkeysDialogProps(props) {
    for (var key in props) {
        if (props.hasOwnProperty(key)) {
            HOTKEYS_DIALOG.componentProps[key] = props[key];
        }
    }
}
exports.setHotkeysDialogProps = setHotkeysDialogProps;
function showHotkeysDialog(hotkeys) {
    HOTKEYS_DIALOG.enqueueHotkeysForDisplay(hotkeys);
}
exports.showHotkeysDialog = showHotkeysDialog;
function hideHotkeysDialog() {
    HOTKEYS_DIALOG.hide();
}
exports.hideHotkeysDialog = hideHotkeysDialog;
/**
 * Use this function instead of `hideHotkeysDialog` if you need to ensure that all hotkey listeners
 * have time to execute with the dialog in a consistent open state. This can avoid flickering the
 * dialog between open and closed states as successive listeners fire.
 */
function hideHotkeysDialogAfterDelay() {
    HOTKEYS_DIALOG.hideAfterDelay();
}
exports.hideHotkeysDialogAfterDelay = hideHotkeysDialogAfterDelay;

//# sourceMappingURL=hotkeysDialog.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var hotkeyParser_1 = __webpack_require__(537);
var KeyIcons = {
    alt: "pt-icon-key-option",
    ctrl: "pt-icon-key-control",
    delete: "pt-icon-key-delete",
    down: "pt-icon-arrow-down",
    enter: "pt-icon-key-enter",
    left: "pt-icon-arrow-left",
    meta: "pt-icon-key-command",
    right: "pt-icon-arrow-right",
    shift: "pt-icon-key-shift",
    up: "pt-icon-arrow-up"
};
var KeyCombo = function (_super) {
    tslib_1.__extends(KeyCombo, _super);
    function KeyCombo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyCombo.prototype.render = function () {
        var keys = hotkeyParser_1.normalizeKeyCombo(this.props.combo);
        var components = [];
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var icon = KeyIcons[key];
            if (icon != null) {
                components.push(React.createElement("kbd", { className: "pt-key pt-modifier-key", key: "key-" + i }, React.createElement("span", { className: "pt-icon-standard " + icon }), key));
            } else {
                if (key.length === 1) {
                    key = key.toUpperCase();
                }
                components.push(React.createElement("kbd", { className: "pt-key", key: "key-" + i }, key));
            }
        }
        return React.createElement("div", { className: "pt-key-combo" }, components);
    };
    return KeyCombo;
}(React.Component);
exports.KeyCombo = KeyCombo;

//# sourceMappingURL=keyCombo.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
if (typeof window !== "undefined" && typeof document !== "undefined") {
    // tslint:disable-next-line:no-var-requires
    __webpack_require__(1856); // only import actual dom4 if we're in the browser (not server-compatible)
    // we'll still need dom4 types for the TypeScript to compile, these are included in package.json
}
var contextMenu = __webpack_require__(838);
exports.ContextMenu = contextMenu;
__export(__webpack_require__(1529));
__export(__webpack_require__(1530));
__export(__webpack_require__(389));
__export(__webpack_require__(837));
__export(__webpack_require__(1532));
__export(__webpack_require__(1533));
__export(__webpack_require__(839));
__export(__webpack_require__(1534));
__export(__webpack_require__(840));
__export(__webpack_require__(841));
__export(__webpack_require__(1535));
__export(__webpack_require__(1536));
__export(__webpack_require__(842));
__export(__webpack_require__(188));
__export(__webpack_require__(538));
__export(__webpack_require__(1539));
__export(__webpack_require__(846));
__export(__webpack_require__(1540));
__export(__webpack_require__(391));
__export(__webpack_require__(1551));
__export(__webpack_require__(266));
__export(__webpack_require__(1542));
__export(__webpack_require__(847));
__export(__webpack_require__(1543));
__export(__webpack_require__(1553));
__export(__webpack_require__(1544));
__export(__webpack_require__(1545));
__export(__webpack_require__(539));
__export(__webpack_require__(1546));
__export(__webpack_require__(850));
__export(__webpack_require__(1547));
__export(__webpack_require__(851));
__export(__webpack_require__(852));
__export(__webpack_require__(853));
__export(__webpack_require__(1549));
__export(__webpack_require__(1550));
__export(__webpack_require__(854));
__export(__webpack_require__(1552));
__export(__webpack_require__(540));
__export(__webpack_require__(1554));
__export(__webpack_require__(855));

//# sourceMappingURL=index.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var position_1 = __webpack_require__(157);
var popover_1 = __webpack_require__(266);
var menu_1 = __webpack_require__(538);
var REACT_CONTEXT_TYPES = {
    alignLeft: function alignLeft(obj, key) {
        if (obj[key] != null && typeof obj[key] !== "boolean") {
            return new Error("[Blueprint] MenuItem context alignLeft must be boolean");
        }
        return undefined;
    }
};
var MenuItem = function (_super) {
    tslib_1.__extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            alignLeft: false
        };
        _this.liRefHandler = function (r) {
            return _this.liElement = r;
        };
        _this.measureSubmenu = function (el) {
            if (el != null) {
                var submenuRect = ReactDOM.findDOMNode(el).getBoundingClientRect();
                var parentWidth = _this.liElement.parentElement.getBoundingClientRect().width;
                var adjustmentWidth = submenuRect.width + parentWidth;
                // this ensures that the left and right measurements represent a submenu opened to the right
                var submenuLeft = submenuRect.left;
                var submenuRight = submenuRect.right;
                if (_this.state.alignLeft) {
                    submenuLeft += adjustmentWidth;
                    submenuRight += adjustmentWidth;
                }
                var _a = _this.props.submenuViewportMargin.left,
                    left = _a === void 0 ? 0 : _a;
                var _b = _this.props.submenuViewportMargin.right,
                    right = _b === void 0 ? 0 : _b;
                if (typeof document !== "undefined" && typeof document.documentElement !== "undefined" && Number(document.documentElement.clientWidth)) {
                    // we're in a browser context and the clientWidth is available,
                    // use it to set calculate 'right'
                    right = document.documentElement.clientWidth - right;
                }
                // uses context to prioritize the previous positioning
                var alignLeft = _this.context.alignLeft || false;
                if (alignLeft) {
                    if (submenuLeft - adjustmentWidth <= left) {
                        alignLeft = false;
                    }
                } else {
                    if (submenuRight >= right) {
                        alignLeft = true;
                    }
                }
                _this.setState({ alignLeft: alignLeft });
            }
        };
        _this.renderChildren = function () {
            var _a = _this.props,
                children = _a.children,
                submenu = _a.submenu;
            if (children != null) {
                var childProps_1 = _this.cascadeProps();
                if (Object.keys(childProps_1).length === 0) {
                    return children;
                } else {
                    return React.Children.map(children, function (child) {
                        return React.cloneElement(child, childProps_1);
                    });
                }
            } else if (submenu != null) {
                return submenu.map(_this.cascadeProps).map(renderMenuItem);
            } else {
                return undefined;
            }
        };
        /**
         * Evalutes this.props and cascades prop values into new props when:
         * - submenuViewportMargin is defined, but is undefined for the supplied input.
         * - useSmartPositioning is false, but is undefined for the supplied input.
         * @param {IMenuItemProps} newProps If supplied, object will be modified, otherwise, defaults to an empty object.
         * @returns An object to be used as child props.
         */
        _this.cascadeProps = function (newProps) {
            if (newProps === void 0) {
                newProps = {};
            }
            var _a = _this.props,
                submenuViewportMargin = _a.submenuViewportMargin,
                useSmartPositioning = _a.useSmartPositioning;
            if (submenuViewportMargin != null && newProps.submenuViewportMargin == null) {
                newProps.submenuViewportMargin = submenuViewportMargin;
            }
            if (useSmartPositioning === false && newProps.useSmartPositioning == null) {
                newProps.useSmartPositioning = useSmartPositioning;
            }
            return newProps;
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            disabled = _a.disabled,
            label = _a.label,
            submenu = _a.submenu;
        var hasSubmenu = children != null || submenu != null;
        var liClasses = classNames((_b = {}, _b[Classes.MENU_SUBMENU] = hasSubmenu, _b));
        var anchorClasses = classNames(Classes.MENU_ITEM, Classes.intentClass(this.props.intent), (_c = {}, _c[Classes.DISABLED] = disabled,
        // prevent popover from closing when clicking on submenu trigger or disabled item
        _c[Classes.POPOVER_DISMISS] = this.props.shouldDismissPopover && !disabled && !hasSubmenu, _c), Classes.iconClass(this.props.iconName), this.props.className);
        var labelElement;
        if (label != null) {
            labelElement = React.createElement("span", { className: "pt-menu-item-label" }, label);
        }
        var content = React.createElement("a", { className: anchorClasses, href: disabled ? undefined : this.props.href, onClick: disabled ? undefined : this.props.onClick, tabIndex: disabled ? undefined : 0, target: this.props.target }, labelElement, this.props.text);
        if (hasSubmenu) {
            var measureSubmenu = this.props.useSmartPositioning ? this.measureSubmenu : null;
            var submenuElement = React.createElement(menu_1.Menu, { ref: measureSubmenu }, this.renderChildren());
            var popoverClasses = classNames((_d = {}, _d[Classes.ALIGN_LEFT] = this.state.alignLeft, _d));
            content = React.createElement(popover_1.Popover, { content: submenuElement, isDisabled: disabled, enforceFocus: false, hoverCloseDelay: 0, inline: true, interactionKind: popover_1.PopoverInteractionKind.HOVER, position: this.state.alignLeft ? position_1.Position.LEFT_TOP : position_1.Position.RIGHT_TOP, popoverClassName: classNames(Classes.MINIMAL, Classes.MENU_SUBMENU, popoverClasses), useSmartArrowPositioning: false }, content);
        }
        return React.createElement("li", { className: liClasses, ref: this.liRefHandler }, content);
        var _b, _c, _d;
    };
    MenuItem.prototype.getChildContext = function () {
        return { alignLeft: this.state.alignLeft };
    };
    MenuItem.prototype.validateProps = function (props) {
        if (props.children != null && props.submenu != null) {
            console.warn(Errors.MENU_WARN_CHILDREN_SUBMENU_MUTEX);
        }
    };
    return MenuItem;
}(abstractComponent_1.AbstractComponent);
MenuItem.defaultProps = {
    disabled: false,
    shouldDismissPopover: true,
    submenuViewportMargin: {},
    text: "",
    useSmartPositioning: true
};
MenuItem.displayName = "Blueprint.MenuItem";
MenuItem.contextTypes = REACT_CONTEXT_TYPES;
MenuItem.childContextTypes = REACT_CONTEXT_TYPES;
exports.MenuItem = MenuItem;
function renderMenuItem(props, key) {
    return React.createElement(MenuItem, tslib_1.__assign({ key: key }, props));
}
exports.renderMenuItem = renderMenuItem;
exports.MenuItemFactory = React.createFactory(MenuItem);

//# sourceMappingURL=menuItem.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var props_1 = __webpack_require__(265);
var utils_1 = __webpack_require__(53);
var REACT_CONTEXT_TYPES = {
    blueprintPortalClassName: function blueprintPortalClassName(obj, key) {
        if (obj[key] != null && typeof obj[key] !== "string") {
            return new Error(Errors.PORTAL_CONTEXT_CLASS_NAME_STRING);
        }
        return undefined;
    }
};
/**
 * This component detaches its contents and re-attaches them to document.body.
 * Use it when you need to circumvent DOM z-stacking (for dialogs, popovers, etc.).
 * Any class names passed to this element will be propagated to the new container element on document.body.
 */
var Portal = function (_super) {
    tslib_1.__extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Portal.prototype.render = function () {
        return null;
    };
    Portal.prototype.componentDidMount = function () {
        var targetElement = document.createElement("div");
        targetElement.classList.add(Classes.PORTAL);
        if (this.context.blueprintPortalClassName != null) {
            targetElement.classList.add(this.context.blueprintPortalClassName);
        }
        document.body.appendChild(targetElement);
        this.targetElement = targetElement;
        this.componentDidUpdate();
    };
    Portal.prototype.componentDidUpdate = function () {
        var _this = this;
        // use special render function to preserve React context, in case children need it
        ReactDOM.unstable_renderSubtreeIntoContainer(
        /* parentComponent */this, React.createElement("div", tslib_1.__assign({}, props_1.removeNonHTMLProps(this.props), { ref: this.props.containerRef }), this.props.children), this.targetElement, function () {
            return utils_1.safeInvoke(_this.props.onChildrenMount);
        });
    };
    Portal.prototype.componentWillUnmount = function () {
        ReactDOM.unmountComponentAtNode(this.targetElement);
        this.targetElement.remove();
    };
    return Portal;
}(React.Component);
Portal.displayName = "Blueprint.Portal";
Portal.contextTypes = REACT_CONTEXT_TYPES;
exports.Portal = Portal;

//# sourceMappingURL=portal.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var utils_1 = __webpack_require__(53);
var CoreSlider = function (_super) {
    tslib_1.__extends(CoreSlider, _super);
    function CoreSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.className = Classes.SLIDER;
        _this.refHandlers = {
            track: function track(el) {
                return _this.trackElement = el;
            }
        };
        _this.maybeHandleTrackClick = function (event) {
            if (_this.canHandleTrackEvent(event)) {
                _this.handleTrackClick(event);
            }
        };
        _this.maybeHandleTrackTouch = function (event) {
            if (_this.canHandleTrackEvent(event)) {
                _this.handleTrackTouch(event);
            }
        };
        _this.canHandleTrackEvent = function (event) {
            var target = event.target;
            // ensure event does not come from inside the handle
            return !_this.props.disabled && target.closest("." + Classes.SLIDER_HANDLE) == null;
        };
        _this.state = {
            labelPrecision: _this.getLabelPrecision(props),
            tickSize: 0
        };
        return _this;
    }
    CoreSlider.prototype.render = function () {
        var disabled = this.props.disabled;
        var classes = classNames(this.className, (_a = {}, _a[Classes.DISABLED] = disabled, _a[Classes.SLIDER + "-unlabeled"] = this.props.renderLabel === false, _a), this.props.className);
        return React.createElement("div", { className: classes, onMouseDown: this.maybeHandleTrackClick, onTouchStart: this.maybeHandleTrackTouch }, React.createElement("div", { className: Classes.SLIDER + "-track", ref: this.refHandlers.track }), this.maybeRenderFill(), this.maybeRenderAxis(), this.renderHandles());
        var _a;
    };
    CoreSlider.prototype.componentDidMount = function () {
        this.updateTickSize();
    };
    CoreSlider.prototype.componentDidUpdate = function () {
        this.updateTickSize();
    };
    CoreSlider.prototype.componentWillReceiveProps = function (props) {
        _super.prototype.componentWillReceiveProps.call(this, props);
        this.setState({ labelPrecision: this.getLabelPrecision(props) });
    };
    CoreSlider.prototype.formatLabel = function (value) {
        var renderLabel = this.props.renderLabel;
        if (renderLabel === false) {
            return undefined;
        } else if (utils_1.isFunction(renderLabel)) {
            return renderLabel(value);
        } else {
            return value.toFixed(this.state.labelPrecision);
        }
    };
    CoreSlider.prototype.validateProps = function (props) {
        if (props.stepSize <= 0) {
            throw new Error(Errors.SLIDER_ZERO_STEP);
        }
        if (props.labelStepSize <= 0) {
            throw new Error(Errors.SLIDER_ZERO_LABEL_STEP);
        }
    };
    CoreSlider.prototype.maybeRenderAxis = function () {
        var _a = this.props,
            max = _a.max,
            min = _a.min,
            labelStepSize = _a.labelStepSize;
        if (this.props.renderLabel === false) {
            return undefined;
        }
        var stepSize = Math.round(this.state.tickSize * labelStepSize);
        var labels = [];
        // tslint:disable-next-line:one-variable-per-declaration
        for (var i = min, left = 0; i < max || utils_1.approxEqual(i, max); i += labelStepSize, left += stepSize) {
            labels.push(React.createElement("div", { className: Classes.SLIDER + "-label", key: i, style: { left: left } }, this.formatLabel(i)));
        }
        return React.createElement("div", { className: Classes.SLIDER + "-axis" }, labels);
    };
    CoreSlider.prototype.maybeRenderFill = function () {
        if (this.props.showTrackFill && this.trackElement != null) {
            return this.renderFill();
        }
        return undefined;
    };
    CoreSlider.prototype.getLabelPrecision = function (_a) {
        var labelPrecision = _a.labelPrecision,
            stepSize = _a.stepSize;
        // infer default label precision from stepSize because that's how much the handle moves.
        return labelPrecision == null ? utils_1.countDecimalPlaces(stepSize) : labelPrecision;
    };
    CoreSlider.prototype.updateTickSize = function () {
        if (this.trackElement != null) {
            var tickSize = this.trackElement.clientWidth / (this.props.max - this.props.min);
            this.setState({ tickSize: tickSize });
        }
    };
    return CoreSlider;
}(abstractComponent_1.AbstractComponent);
CoreSlider = tslib_1.__decorate([PureRender], CoreSlider);
exports.CoreSlider = CoreSlider;

//# sourceMappingURL=coreSlider.js.map

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Keys = __webpack_require__(187);
var utils_1 = __webpack_require__(53);
// props that require number values, for validation
var NUMBER_PROPS = ["max", "min", "stepSize", "tickSize", "value"];
var Handle = function (_super) {
    tslib_1.__extends(Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMoving: false
        };
        _this.refHandlers = {
            handle: function handle(el) {
                return _this.handleElement = el;
            }
        };
        _this.beginHandleMovement = function (event) {
            document.addEventListener("mousemove", _this.handleHandleMovement);
            document.addEventListener("mouseup", _this.endHandleMovement);
            _this.setState({ isMoving: true });
            _this.changeValue(_this.clientToValue(event.clientX));
        };
        _this.beginHandleTouchMovement = function (event) {
            document.addEventListener("touchmove", _this.handleHandleTouchMovement);
            document.addEventListener("touchend", _this.endHandleTouchMovement);
            document.addEventListener("touchcancel", _this.endHandleTouchMovement);
            _this.setState({ isMoving: true });
            _this.changeValue(_this.clientToValue(_this.touchEventClientX(event)));
        };
        _this.endHandleMovement = function (event) {
            _this.handleMoveEndedAt(event.clientX);
        };
        _this.endHandleTouchMovement = function (event) {
            _this.handleMoveEndedAt(_this.touchEventClientX(event));
        };
        _this.handleMoveEndedAt = function (clientPixel) {
            _this.removeDocumentEventListeners();
            _this.setState({ isMoving: false });
            // not using changeValue because we want to invoke the handler regardless of current prop value
            var onRelease = _this.props.onRelease;
            var finalValue = _this.clamp(_this.clientToValue(clientPixel));
            utils_1.safeInvoke(onRelease, finalValue);
        };
        _this.handleHandleMovement = function (event) {
            _this.handleMovedTo(event.clientX);
        };
        _this.handleHandleTouchMovement = function (event) {
            _this.handleMovedTo(_this.touchEventClientX(event));
        };
        _this.handleMovedTo = function (clientPixel) {
            if (_this.state.isMoving && !_this.props.disabled) {
                _this.changeValue(_this.clientToValue(clientPixel));
            }
        };
        _this.handleKeyDown = function (event) {
            var _a = _this.props,
                stepSize = _a.stepSize,
                value = _a.value;
            var which = event.which;
            if (which === Keys.ARROW_DOWN || which === Keys.ARROW_LEFT) {
                _this.changeValue(value - stepSize);
                // this key event has been handled! prevent browser scroll on up/down
                event.preventDefault();
            } else if (which === Keys.ARROW_UP || which === Keys.ARROW_RIGHT) {
                _this.changeValue(value + stepSize);
                event.preventDefault();
            }
        };
        _this.handleKeyUp = function (event) {
            if ([Keys.ARROW_UP, Keys.ARROW_DOWN, Keys.ARROW_LEFT, Keys.ARROW_RIGHT].indexOf(event.which) >= 0) {
                utils_1.safeInvoke(_this.props.onRelease, _this.props.value);
            }
        };
        return _this;
    }
    Handle.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            disabled = _a.disabled,
            label = _a.label,
            min = _a.min,
            tickSize = _a.tickSize,
            value = _a.value;
        var isMoving = this.state.isMoving;
        // getBoundingClientRect().height includes border size as opposed to clientHeight
        var handleSize = this.handleElement == null ? 0 : this.handleElement.getBoundingClientRect().height;
        return React.createElement("span", { className: classNames(Classes.SLIDER_HANDLE, (_b = {}, _b[Classes.ACTIVE] = isMoving, _b), className), onKeyDown: disabled ? null : this.handleKeyDown, onKeyUp: disabled ? null : this.handleKeyUp, onMouseDown: disabled ? null : this.beginHandleMovement, onTouchStart: disabled ? null : this.beginHandleTouchMovement, ref: this.refHandlers.handle, style: { left: Math.round((value - min) * tickSize - handleSize / 2) }, tabIndex: 0 }, label == null ? null : React.createElement("span", { className: Classes.SLIDER_LABEL }, label));
        var _b;
    };
    Handle.prototype.componentWillUnmount = function () {
        this.removeDocumentEventListeners();
    };
    /** Convert client pixel to value between min and max. */
    Handle.prototype.clientToValue = function (clientPixel) {
        var _a = this.props,
            stepSize = _a.stepSize,
            tickSize = _a.tickSize,
            value = _a.value;
        if (this.handleElement == null) {
            return value;
        }
        var handleRect = this.handleElement.getBoundingClientRect();
        var handleCenterPixel = handleRect.left + handleRect.width / 2;
        var pixelDelta = clientPixel - handleCenterPixel;
        // convert pixels to range value in increments of `stepSize`
        var valueDelta = Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
        return value + valueDelta;
    };
    Handle.prototype.touchEventClientX = function (event) {
        return event.changedTouches[0].clientX;
    };
    Handle.prototype.validateProps = function (props) {
        for (var _i = 0, NUMBER_PROPS_1 = NUMBER_PROPS; _i < NUMBER_PROPS_1.length; _i++) {
            var prop = NUMBER_PROPS_1[_i];
            if (typeof props[prop] !== "number") {
                throw new Error("[Blueprint] <Handle> requires number value for " + prop + " prop");
            }
        }
    };
    /** Clamp value and invoke callback if it differs from current value */
    Handle.prototype.changeValue = function (newValue, callback) {
        if (callback === void 0) {
            callback = this.props.onChange;
        }
        newValue = this.clamp(newValue);
        if (!isNaN(newValue) && this.props.value !== newValue) {
            utils_1.safeInvoke(callback, newValue);
        }
    };
    /** Clamp value between min and max props */
    Handle.prototype.clamp = function (value) {
        return utils_1.clamp(value, this.props.min, this.props.max);
    };
    Handle.prototype.removeDocumentEventListeners = function () {
        document.removeEventListener("mousemove", this.handleHandleMovement);
        document.removeEventListener("mouseup", this.endHandleMovement);
        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
        document.removeEventListener("touchend", this.endHandleTouchMovement);
        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
    };
    return Handle;
}(abstractComponent_1.AbstractComponent);
Handle.displayName = "Blueprint.SliderHandle";
Handle = tslib_1.__decorate([PureRender], Handle);
exports.Handle = Handle;

//# sourceMappingURL=handle.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Tab = function (_super) {
    tslib_1.__extends(Tab, _super);
    function Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tab.prototype.render = function () {
        return React.createElement("li", { "aria-controls": this.props.panelId, "aria-disabled": this.props.isDisabled, "aria-expanded": this.props.isSelected, "aria-selected": this.props.isSelected, className: classNames(Classes.TAB, this.props.className), id: this.props.id, role: "tab", selected: this.props.isSelected ? true : null, tabIndex: this.props.isDisabled ? null : 0 }, this.props.children);
    };
    return Tab;
}(React.Component);
Tab.defaultProps = {
    isDisabled: false,
    isSelected: false
};
Tab.displayName = "Blueprint.Tab";
Tab = tslib_1.__decorate([PureRender], Tab);
exports.Tab = Tab;
exports.TabFactory = React.createFactory(Tab);

//# sourceMappingURL=tab.js.map

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var TabList = function (_super) {
    tslib_1.__extends(TabList, _super);
    function TabList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shouldAnimate: false
        };
        return _this;
    }
    TabList.prototype.render = function () {
        return React.createElement("ul", { className: classNames(Classes.TAB_LIST, this.props.className), role: "tablist" }, React.createElement("div", { className: classNames("pt-tab-indicator-wrapper", { "pt-no-animation": !this.state.shouldAnimate }), style: this.props.indicatorWrapperStyle }, React.createElement("div", { className: "pt-tab-indicator" })), this.props.children);
    };
    TabList.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.indicatorWrapperStyle == null) {
            this.setTimeout(function () {
                return _this.setState({ shouldAnimate: true });
            });
        }
    };
    return TabList;
}(abstractComponent_1.AbstractComponent);
TabList.displayName = "Blueprint.TabList";
TabList = tslib_1.__decorate([PureRender], TabList);
exports.TabList = TabList;
exports.TabListFactory = React.createFactory(TabList);

//# sourceMappingURL=tabList.js.map

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var TabPanel = function (_super) {
    tslib_1.__extends(TabPanel, _super);
    function TabPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPanel.prototype.render = function () {
        return React.createElement("div", { "aria-labelledby": this.props._tabId, className: classNames(Classes.TAB_PANEL, this.props.className), id: this.props._id, role: "tabpanel" }, this.props.children);
    };
    return TabPanel;
}(React.Component);
TabPanel.displayName = "Blueprint.TabPanel";
TabPanel = tslib_1.__decorate([PureRender], TabPanel);
exports.TabPanel = TabPanel;
exports.TabPanelFactory = React.createFactory(TabPanel);

//# sourceMappingURL=tabPanel.js.map

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Tab2 = function (_super) {
    tslib_1.__extends(Tab2, _super);
    function Tab2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // this component is never rendered directly; see Tabs2#renderTabPanel()
    /* istanbul ignore next */
    Tab2.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            panel = _a.panel;
        return React.createElement("div", { className: classNames(Classes.TAB_PANEL, className), role: "tablist" }, panel);
    };
    return Tab2;
}(React.Component);
Tab2.defaultProps = {
    disabled: false,
    id: undefined
};
Tab2.displayName = "Blueprint.Tab2";
Tab2 = tslib_1.__decorate([PureRender], Tab2);
exports.Tab2 = Tab2;
exports.Tab2Factory = React.createFactory(Tab2);

//# sourceMappingURL=tab2.js.map

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
var buttons_1 = __webpack_require__(389);
var icon_1 = __webpack_require__(188);
var Toast = function (_super) {
    tslib_1.__extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleActionClick = function (e) {
            utils_1.safeInvoke(_this.props.action.onClick, e);
            _this.triggerDismiss(false);
        };
        _this.handleCloseClick = function () {
            return _this.triggerDismiss(false);
        };
        _this.startTimeout = function () {
            if (_this.props.timeout > 0) {
                _this.setTimeout(function () {
                    return _this.triggerDismiss(true);
                }, _this.props.timeout);
            }
        };
        return _this;
    }
    Toast.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            iconName = _a.iconName,
            intent = _a.intent,
            message = _a.message;
        return React.createElement("div", { className: classNames(Classes.TOAST, Classes.intentClass(intent), className), onBlur: this.startTimeout, onFocus: this.clearTimeouts, onMouseEnter: this.clearTimeouts, onMouseLeave: this.startTimeout, tabIndex: 0 }, React.createElement(icon_1.Icon, { iconName: iconName }), React.createElement("span", { className: Classes.TOAST_MESSAGE }, message), React.createElement("div", { className: classNames(Classes.BUTTON_GROUP, Classes.MINIMAL) }, this.maybeRenderActionButton(), React.createElement(buttons_1.Button, { iconName: "cross", onClick: this.handleCloseClick })));
    };
    Toast.prototype.componentDidMount = function () {
        this.startTimeout();
    };
    Toast.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.timeout <= 0 && this.props.timeout > 0) {
            this.startTimeout();
        } else if (prevProps.timeout > 0 && this.props.timeout <= 0) {
            this.clearTimeouts();
        }
    };
    Toast.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
    };
    Toast.prototype.maybeRenderActionButton = function () {
        var action = this.props.action;
        if (action == null) {
            return undefined;
        } else {
            return React.createElement(buttons_1.AnchorButton, tslib_1.__assign({}, action, { intent: undefined, onClick: this.handleActionClick }));
        }
    };
    Toast.prototype.triggerDismiss = function (didTimeoutExpire) {
        utils_1.safeInvoke(this.props.onDismiss, didTimeoutExpire);
        this.clearTimeouts();
    };
    return Toast;
}(abstractComponent_1.AbstractComponent);
Toast.defaultProps = {
    className: "",
    message: "",
    timeout: 5000
};
Toast.displayName = "Blueprint.Toast";
Toast = tslib_1.__decorate([PureRender], Toast);
exports.Toast = Toast;
exports.ToastFactory = React.createFactory(Toast);

//# sourceMappingURL=toast.js.map

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
var collapse_1 = __webpack_require__(837);
var icon_1 = __webpack_require__(188);
var TreeNode = function (_super) {
    tslib_1.__extends(TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCaretClick = function (e) {
            e.stopPropagation();
            var _a = _this.props,
                isExpanded = _a.isExpanded,
                onCollapse = _a.onCollapse,
                onExpand = _a.onExpand;
            utils_1.safeInvoke(isExpanded ? onCollapse : onExpand, _this, e);
        };
        _this.handleClick = function (e) {
            utils_1.safeInvoke(_this.props.onClick, _this, e);
        };
        _this.handleContentRef = function (element) {
            utils_1.safeInvoke(_this.props.contentRef, _this, element);
        };
        _this.handleContextMenu = function (e) {
            utils_1.safeInvoke(_this.props.onContextMenu, _this, e);
        };
        _this.handleDoubleClick = function (e) {
            utils_1.safeInvoke(_this.props.onDoubleClick, _this, e);
        };
        return _this;
    }
    TreeNode.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            className = _a.className,
            hasCaret = _a.hasCaret,
            iconName = _a.iconName,
            isExpanded = _a.isExpanded,
            isSelected = _a.isSelected,
            label = _a.label;
        var showCaret = hasCaret == null ? React.Children.count(children) > 0 : hasCaret;
        var caretClass = showCaret ? Classes.TREE_NODE_CARET : Classes.TREE_NODE_CARET_NONE;
        var caretStateClass = isExpanded ? Classes.TREE_NODE_CARET_OPEN : Classes.TREE_NODE_CARET_CLOSED;
        var caretClasses = classNames(caretClass, Classes.ICON_STANDARD, (_b = {}, _b[caretStateClass] = showCaret, _b));
        var classes = classNames(Classes.TREE_NODE, (_c = {}, _c[Classes.TREE_NODE_SELECTED] = isSelected, _c[Classes.TREE_NODE_EXPANDED] = isExpanded, _c), className);
        var contentClasses = classNames(Classes.TREE_NODE_CONTENT, "pt-tree-node-content-" + this.props.depth);
        return React.createElement("li", { className: classes }, React.createElement("div", { className: contentClasses, onClick: this.handleClick, onContextMenu: this.handleContextMenu, onDoubleClick: this.handleDoubleClick, ref: this.handleContentRef }, React.createElement("span", { className: caretClasses, onClick: showCaret ? this.handleCaretClick : null }), React.createElement(icon_1.Icon, { className: Classes.TREE_NODE_ICON, iconName: iconName }), React.createElement("span", { className: Classes.TREE_NODE_LABEL }, label), this.maybeRenderSecondaryLabel()), React.createElement(collapse_1.Collapse, { isOpen: isExpanded }, children));
        var _b, _c;
    };
    TreeNode.prototype.maybeRenderSecondaryLabel = function () {
        if (this.props.secondaryLabel != null) {
            return React.createElement("span", { className: Classes.TREE_NODE_SECONDARY_LABEL }, this.props.secondaryLabel);
        } else {
            return undefined;
        }
    };
    return TreeNode;
}(React.Component);
exports.TreeNode = TreeNode;

//# sourceMappingURL=treeNode.js.map

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1559);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var settle = __webpack_require__(1573);
var buildURL = __webpack_require__(1577);
var parseHeaders = __webpack_require__(1583);
var isURLSameOrigin = __webpack_require__(1581);
var createError = __webpack_require__(858);
var btoa = typeof window !== 'undefined' && window.btoa || __webpack_require__(1576);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || request.readyState !== 4 && !xDomain) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      if (request.status === 0) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1579);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1572);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1595), __webpack_require__(2788), __webpack_require__(2025)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */

        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(63);
var core = __webpack_require__(45);
var fails = __webpack_require__(124);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(109);
var toIObject = __webpack_require__(88);
var isEnum = __webpack_require__(147).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var newPromiseCapability = __webpack_require__(565);

module.exports = function (C, x) {
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(86);
var aFunction = __webpack_require__(269);
var SPECIES = __webpack_require__(56)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(162).f;
var create = __webpack_require__(405);
var redefineAll = __webpack_require__(591);
var ctx = __webpack_require__(272);
var anInstance = __webpack_require__(582);
var forOf = __webpack_require__(587);
var $iterDefine = __webpack_require__(588);
var step = __webpack_require__(872);
var setSpecies = __webpack_require__(880);
var DESCRIPTORS = __webpack_require__(149);
var fastKey = __webpack_require__(273).fastKey;
var validate = __webpack_require__(596);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = create(null); // index
      that._f = undefined; // first entry
      that._l = undefined; // last entry
      that[SIZE] = 0; // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function get() {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
      // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key, // <- key
        v: value, // <- value
        p: prev = that._l, // <- previous entry
        n: undefined, // <- next entry
        r: false // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    }return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind; // kind
      this._l = undefined; // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(102);
var $export = __webpack_require__(130);
var redefine = __webpack_require__(230);
var redefineAll = __webpack_require__(591);
var meta = __webpack_require__(273);
var forOf = __webpack_require__(587);
var anInstance = __webpack_require__(582);
var isObject = __webpack_require__(95);
var fails = __webpack_require__(227);
var $iterDetect = __webpack_require__(871);
var setToStringTag = __webpack_require__(318);
var inheritIfRequired = __webpack_require__(1632);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(102).document;
module.exports = document && document.documentElement;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(149) && !__webpack_require__(227)(function () {
  return Object.defineProperty(__webpack_require__(585)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(316);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(96)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__(403);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(162);
var anObject = __webpack_require__(192);
var getKeys = __webpack_require__(229);

module.exports = __webpack_require__(149) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(194);
var gOPN = __webpack_require__(876).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(878);
var hiddenKeys = __webpack_require__(586).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(193);
var toObject = __webpack_require__(408);
var IE_PROTO = __webpack_require__(592)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(193);
var toIObject = __webpack_require__(194);
var arrayIndexOf = __webpack_require__(1630)(false);
var IE_PROTO = __webpack_require__(592)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(95);
var anObject = __webpack_require__(192);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(272)(Function.call, __webpack_require__(589).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(102);
var dP = __webpack_require__(162);
var DESCRIPTORS = __webpack_require__(149);
var SPECIES = __webpack_require__(96)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(272);
var invoke = __webpack_require__(1633);
var html = __webpack_require__(868);
var cel = __webpack_require__(585);
var global = __webpack_require__(102);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(316)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(594);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(96);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regions = {};

regions.centralAsia = {
  name: 'Central Asia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Central_Asia
  'KZ', // Kazakhstan
  'KG', // Kyrgyzstan
  'TJ', // Tajikistan
  'TM', // Turkmenistan
  'UZ']
};

regions.southernAsia = {
  name: 'Southern Asia',
  countries: [
  // source is http://en.wikipedia.org/wiki/South_Asia
  'AF', // Afghanistan
  'BD', // Bangladesh
  'BT', // Bhutan
  'IO', // British Indian Ocean Territory
  'IN', // India
  'IR', // Iran
  'MV', // Maldives
  'NP', // Nepal
  'PK', // Pakistan
  'LK']
};

regions.southeastAsia = {
  name: 'Southeast Asia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Southeast_Asia
  'BN', // Brunei
  'KH', // Cambodia
  'CX', // Christmas Island
  'CC', // Cocos (Keeling) Islands
  'TL', // East Timor
  'ID', // Indonesia
  'LA', // Laos
  'MY', // Malaysia
  'MM', // Myanmar (Burma)
  'PH', // Philippines
  'SG', // Singapore
  'TH', // Thailand
  'VN']
};

regions.eastAsia = {
  name: 'East Asia',
  countries: [
  // source is http://en.wikipedia.org/wiki/East_Asia
  'CN', // China
  'HK', // Hong Kong
  'JP', // Japan
  'KP', // North Korea
  'KR', // South Korea
  'MO', // Macao
  'MN', // Mongolia
  'TW']
};

regions.westernAsia = {
  name: 'Western Asia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Western_Asia
  'AM', // Armenia
  'AZ', // Azerbaijan
  'BH', // Bahrain
  'IQ', // Iraq
  'IL', // Israel
  'JO', // Jordan
  'KW', // Kuwait
  'LB', // Lebanon
  'OM', // Oman
  'PS', // Palestinian territories
  'QA', // Qatar
  'SA', // Saudi Arabia
  'SY', // Syria
  'TR', // Turkey
  'AE', // United Arab Emirates
  'YE']
};

regions.centralAfrica = {
  name: 'Central Aftrica',
  countries: [
  // source is http://en.wikipedia.org/wiki/Central_Africa
  'AO', // Angola
  'CM', // Cameroon
  'CF', // Central African Republic
  'TD', // Chad
  'CG', // Republic of the Congo
  'CD', // Democratic Republic of the Congo
  'GQ', // Equatorial Guinea
  'GA', // Gabon
  'ST']
};

regions.northAfrica = {
  name: 'North Africa',
  countries: [
  // source is http://en.wikipedia.org/wiki/North_Africa
  'DZ', // Algeria
  'EG', // Egypt
  'LY', // Libya
  'MA', // Morocco
  'SD', // Sudan
  'TN', // Tunisia
  'EH']
};

regions.southernAfrica = {
  name: 'Southern Africa',
  countries: [
  // source is http://en.wikipedia.org/wiki/Southern_Africa
  'BW', // Botswana
  'LS', // Lesotho
  'NA', // Namibia
  'ZA', // South Africa
  'SZ']
};

regions.eastAfrica = {
  name: 'East Africa',
  countries: [
  // source is http://en.wikipedia.org/wiki/East_Africa
  'BI', // Burundi
  'KM', // Comoros
  'DJ', // Djibouti
  'ER', // Eritrea
  'ET', // Ethiopia
  'KE', // Kenya
  'MG', // Madagascar
  'MW', // Malawi
  'MU', // Mauritius
  'YT', // Mayotte (France)
  'MZ', // Mozambique
  'RE', // Réunion (France)
  'RW', // Rwanda
  'SC', // Seychelles
  'SO', // Somalia
  'SS', // South Sudan
  'TZ', // Tanzania
  'UG', // Uganda
  'ZM', // Zambia
  'ZW']
};

regions.westAfrica = {
  name: 'West Africa',
  countries: [
  // source is http://en.wikipedia.org/wiki/West_Africa
  'BJ', // Benin
  'BF', // Burkina Faso
  'CV', // Cabo Verde
  'CI', // Côte d'Ivoire
  'GM', // Gambia
  'GH', // Ghana
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'LR', // Liberia
  'ML', // Mali
  'MR', // Mauritania
  'NE', // Niger
  'NG', // Nigeria
  'SH', // Saint Helena, Ascension and Tristan da Cunha (United Kingdom)
  'SN', // Senegal
  'SL', // Sierra Leone
  'TG']
};

regions.centralAmerica = {
  name: 'Central America',
  countries: [
  // source is http://en.wikipedia.org/wiki/Central_America
  'BZ', // Belize
  'CR', // Costa Rica
  'SV', // El Salvador
  'GT', // Guatemala
  'HN', // Honduras
  'NI', // Nicaragua
  'PA']
};

regions.northernAmerica = {
  name: 'Northern America',
  countries: [
  // source is http://en.wikipedia.org/wiki/Northern_America
  'BM', // Bermuda
  'CA', // Canada
  'GL', // Greenland
  'MX', // Mexico
  'PM', // Saint Pierre and Miquelon
  'US']
};

regions.caribbean = {
  name: 'Caribbean',
  countries: [
  // source is http://en.wikipedia.org/wiki/Caribbean
  'AI', // Anguilla
  'AG', // Antigua and Barbuda
  'AW', // Aruba
  'BS', // Bahamas
  'BB', // Barbados
  'BQ', // Bonaire, Sint Eustatius & Saba
  'VG', // British Virgin Islands
  'KY', // Cayman Islands
  'CU', // Cuba
  'CW', // Curaçao
  'DM', // Dominica
  'DO', // Dominican Republic
  'GD', // Grenada
  'GP', // Guadeloupe
  'HT', // Haiti
  'JM', // Jamaica
  'MQ', // Martinique
  'MS', // Montserrat
  'PR', // Puerto Rico
  'BL', // Saint Barthélemy
  'KN', // St. Kitts & Nevis
  'LC', // Saint Lucia
  'MF', // Saint Martin
  'VC', // Saint Vincent and the Grenadines
  'SX', // Sint Maarten
  'TT', // Trinidad and Tobago
  'TC', // Turks & Caicos
  'VI']
};

regions.southAmerica = {
  name: 'South America',
  countries: [
  // source is http://en.wikipedia.org/wiki/South_America
  'AR', // Argentina
  'BO', // Bolivia
  'BR', // Brazil
  'CL', // Chile
  'CO', // Colombia
  'EC', // Ecuador
  'FK', // Falkland Islands
  'GF', // French Guiana
  'GY', // Guyana
  'PY', // Paraguay
  'PE', // Peru
  'SR', // Suriname
  'UY', // Uruguay
  'VE']
};

regions.antartica = {
  name: 'Antartica',
  countries: [
  // source is http://en.wikipedia.org/wiki/Antarctica
  'AQ', // Antarctica
  'BV', // Bouvet Island
  'TF', // French Southern Territories
  'HM', // Heard Island and McDonald Islands
  'GS']
};

regions.northernEurope = {
  name: 'Northern Europe',
  countries: [
  // source is http://en.wikipedia.org/wiki/Northern_Europe
  'AX', // Åland
  'DK', // Denmark
  'EE', // Estonia
  'FO', // Faroe Islands
  'FI', // Finland
  'GG', // Guernsey
  'IS', // Iceland
  'IE', // Republic of Ireland
  'JE', // Jersey (UK)
  'IM', // Isle of Man
  'LV', // Latvia
  'LT', // Lithuania
  'NO', // Norway
  'SJ', // Svalbard and Jan Mayen
  'SE', // Sweden
  'GB']
};

regions.southernEurope = {
  name: 'Southern Europe',
  countries: [
  // source is http://en.wikipedia.org/wiki/Southern_Europe
  'AL', // Albania
  'AD', // Andorra
  'BA', // Bosnia and Herzegovina
  'HR', // Croatia
  'CY', // Cyprus
  'GI', // Gibraltar
  'GR', // Greece
  'IT', // Italy
  'MK', // Republic of Macedonia
  'VA', // Vatican City
  'MT', // Malta
  'ME', // Montenegro
  'PT', // Portugal
  'SM', // San Marino
  'RS', // Serbia
  'SI', // Slovenia
  'ES']
};

regions.easternEurope = {
  name: 'Eastern Europe',
  countries: [
  // source is http://en.wikipedia.org/wiki/Eastern_Europe
  'BY', // Belarus
  'BG', // Bulgaria
  'CZ', // Czech Republic
  'GE', // Georgia
  'HU', // Hungary
  'MD', // Moldova
  'PL', // Poland
  'RO', // Romania
  'RU', // Russia
  'SK', // Slovakia
  'UA']
};

regions.westernEurope = {
  name: 'Western Europe',
  countries: [
  // source is http://en.wikipedia.org/wiki/Western_Europe
  'AT', // Austria
  'BE', // Belgium
  'FR', // France
  'DE', // Germany
  'LI', // Liechtenstein
  'LU', // Luxembourg
  'MC', // Monaco
  'NL', // Netherlands
  'CH']
};

regions.australia = {
  name: 'Australia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Oceania
  'AU', // Australia
  'NF', // Norfolk Island
  'NZ']
};

regions.melanesia = {
  name: 'Melanesia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Oceania
  'FJ', // Fiji
  'NC', //  New Caledonia
  'PG', // Papua New Guinea
  'SB', // Solomon Islands
  'VU']
};

regions.micronesia = {
  name: 'Micronesia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Oceania
  'GU', // Guam
  'KI', // Kiribati
  'MH', // Marshall Islands
  'FM', // Micronesia, Fed. Sts.
  'NR', // Nauru
  'MP', // Northern Mariana Islands
  'PW', // Palau
  'UM']
};

regions.polynesia = {
  name: 'Polynesia',
  countries: [
  // source is http://en.wikipedia.org/wiki/Oceania
  'AS', // American Samoa
  'CK', // Cook Islands
  'PF', // French Polynesia
  'NU', // Niue
  'PN', // Pitcairn Islands
  'WS', // Samoa
  'TK', // Tokelau
  'TO', // Tonga
  'TV', // Tuvalu
  'WF']
};

module.exports = regions;

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(887);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(275);


/* harmony default export */ __webpack_exports__["a"] = (function (compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function left(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      }
      return lo;
    },
    right: function right(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function (d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(896);


/* harmony default export */ __webpack_exports__["a"] = (function (array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, f) {
  if (f == null) f = pair;
  var i = 0,
      n = array.length - 1,
      p = array[0],
      pairs = new Array(n < 0 ? 0 : n);
  while (i < n) {
    pairs[i] = f(p, p = array[++i]);
  }return pairs;
});

function pair(a, b) {
  return [a, b];
}

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["a"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["b"] = (function (start, stop, count) {
    var reverse,
        i = -1,
        n,
        ticks,
        step;

    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [start];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while (++i < n) {
            ticks[i] = (start + i) * step;
        }
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while (++i < n) {
            ticks[i] = (start - i) / step;
        }
    }

    if (reverse) ticks.reverse();

    return ticks;
});

function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count),
        power = Math.floor(Math.log(step) / Math.LN10),
        error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(890);


/* harmony default export */ __webpack_exports__["a"] = (function (matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(320);


/* harmony default export */ __webpack_exports__["a"] = (function (values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(603);


var prefixExponent;

/* harmony default export */ __webpack_exports__["b"] = (function (x, p) {
    var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1],
        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
        n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  this.fill = match[1] || " ";
  this.align = match[2] || ">";
  this.sign = match[3] || "-";
  this.symbol = match[4] || "";
  this.zero = !!match[5];
  this.width = match[6] && +match[6];
  this.comma = !!match[7];
  this.precision = match[8] && +match[8].slice(1);
  this.trim = !!match[9];
  this.type = match[10] || "";
}

FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity__ = __webpack_require__(1709);









var prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

/* harmony default export */ __webpack_exports__["a"] = (function (locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type]) precision == null && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i,
          n,
          c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__formatTrim__["a" /* default */])(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? sign === "(" ? sign : "-" : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__["a" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);break;
        default:
          value = padding + valuePrefix + value + valueSuffix;break;
      }

      return numerals(value);
    }

    format.toString = function () {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(1713);


/* harmony default export */ __webpack_exports__["a"] = (function (circles) {
  var i = 0,
      n = (circles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(circles))).length,
      B = [],
      p,
      e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error();
}

function enclosesNot(a, b) {
  var dr = a.r - b.r,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1:
      return encloseBasis1(B[0]);
    case 2:
      return encloseBasis2(B[0], B[1]);
    case 3:
      return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x,
      y1 = a.y,
      r1 = a.r,
      x2 = b.x,
      y2 = b.y,
      r2 = b.r,
      x21 = x2 - x1,
      y21 = y2 - y1,
      r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x,
      y1 = a.y,
      r1 = a.r,
      x2 = b.x,
      y2 = b.y,
      r2 = b.r,
      x3 = c.x,
      y3 = c.y,
      r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose__ = __webpack_require__(902);


function place(b, a, c) {
  var dx = b.x - a.x,
      x,
      a2,
      dy = b.y - a.y,
      y,
      b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b;while ((c = c.next) !== b) {
    a.push(c._);
  }c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__enclose__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) {
    a = circles[i], a.x -= c.x, a.y -= c.y;
  }return c.r;
}

/* harmony default export */ __webpack_exports__["a"] = (function (circles) {
  packEnclose(circles);
  return circles;
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(608);


/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) {
    x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  }for (; i < nb; ++i) {
    c[i] = b[i];
  }return function (t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }return c;
  };
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(607);


/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var d = new Date();
  return a = +a, b -= a, function (t) {
    return d.setTime(a + b * t), d;
  };
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(608);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || (typeof a === "undefined" ? "undefined" : _typeof(a)) !== "object") a = {};
  if (b === null || (typeof b === "undefined" ? "undefined" : _typeof(b)) !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }return c;
  };
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(276);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i,
        color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(412);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      // scan index for next number in b
  am,
      // current match in a
  bm,
      // current match in b
  bs,
      // string preceding current number in b, if any
  i = -1,
      // index in s
  s = [],
      // string constants and placeholders
  q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({ i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm) });
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) {
      s[(o = q[i]).i] = o.x(t);
    }return s.join("");
  });
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__band__ = __webpack_require__(1790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(1793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSymlog", function() { return __WEBPACK_IMPORTED_MODULE_4__symlog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ordinal__ = __webpack_require__(915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quantile__ = __webpack_require__(1794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_7__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quantize__ = __webpack_require__(1795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_8__quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold__ = __webpack_require__(1797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_9__threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_10__time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcTime__ = __webpack_require__(1798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_11__utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sequential__ = __webpack_require__(916);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialLog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialPow", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSqrt", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSymlog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__ = __webpack_require__(1796);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialQuantile", function() { return __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__diverging__ = __webpack_require__(1792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingLog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingPow", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSqrt", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSymlog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tickFormat__ = __webpack_require__(917);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickFormat", function() { return __WEBPACK_IMPORTED_MODULE_15__tickFormat__["a"]; });
































/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return +x;
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




var implicit = { name: "implicit" };

function ordinal() {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "",
        i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1,
        n = _.length,
        d,
        key;
    while (++i < n) {
      if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    }return scale;
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony export (immutable) */ __webpack_exports__["b"] = sequentialLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = sequentialSymlog;
/* harmony export (immutable) */ __webpack_exports__["c"] = sequentialPow;
/* harmony export (immutable) */ __webpack_exports__["d"] = sequentialSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pow__ = __webpack_require__(610);







function transformer() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */],
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}

function sequential() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */]));

  scale.copy = function () {
    return copy(scale, sequential());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialLog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([1, 10]);

  scale.copy = function () {
    return copy(scale, sequentialLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function () {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialPow() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pow__["c" /* powish */])(transformer());

  scale.copy = function () {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(321);



/* harmony default export */ __webpack_exports__["a"] = (function (start, stop, count, specifier) {
  var step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start, stop, count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["formatSpecifier"])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["precisionPrefix"])(step, value))) specifier.precision = precision;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["formatPrefix"])(specifier, value);
      }
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["precisionRound"])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }
    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["precisionFixed"])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["format"])(specifier);
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time_format__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(913);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* identity */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisector */])(function (i) {
        return i[2];
      }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function (y) {
    return new Date(invert(y));
  };

  scale.domain = function (_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_3__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function (interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function (interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval)) : scale;
  };

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_5__init__["b" /* initRange */].apply(calendar(__WEBPACK_IMPORTED_MODULE_1_d3_time__["e" /* timeYear */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["q" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["r" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["d" /* timeDay */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["s" /* timeHour */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["t" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["u" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["v" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time_format__["timeFormat"]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(615);






/* harmony default export */ __webpack_exports__["a"] = (function () {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function (_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function (_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 = area.lineY0 = function () {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function () {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function () {
    return arealine().x(x1).y(y0);
  };

  area.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(414);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._x3 = x, this._y3 = y;break;
      case 1:
        this._point = 2;this._context.moveTo(this._x4 = x, this._y4 = y);break;
      case 2:
        this._point = 3;this._x5 = x, this._y5 = y;break;
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(414);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3;this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);break;
      case 3:
        this._point = 4; // proceed
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(415);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function areaStart() {
    this._curve.areaStart();
  },
  areaEnd: function areaEnd() {
    this._curve.areaEnd();
  },
  lineStart: function lineStart() {
    this._curve.lineStart();
  },
  lineEnd: function lineEnd() {
    this._curve.lineEnd();
  },
  point: function point(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc__ = __webpack_require__(1799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie__ = __webpack_require__(1820);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial__ = __webpack_require__(1800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial__ = __webpack_require__(925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial__ = __webpack_require__(927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index__ = __webpack_require__(1812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol__ = __webpack_require__(1822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle__ = __webpack_require__(928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross__ = __webpack_require__(929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye__ = __webpack_require__(934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__ = __webpack_require__(1801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__ = __webpack_require__(1802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__curve_basis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle__ = __webpack_require__(1803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__ = __webpack_require__(921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__ = __webpack_require__(922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__ = __webpack_require__(1804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__ = __webpack_require__(1805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__ = __webpack_require__(1806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone__ = __webpack_require__(1807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural__ = __webpack_require__(1808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step__ = __webpack_require__(1809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack__ = __webpack_require__(1821);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand__ = __webpack_require__(1814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging__ = __webpack_require__(1813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__ = __webpack_require__(1815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__ = __webpack_require__(1816);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_appearance__ = __webpack_require__(926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAppearance", function() { return __WEBPACK_IMPORTED_MODULE_37__order_appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_ascending__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_38__order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_descending__ = __webpack_require__(1817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_39__order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_insideOut__ = __webpack_require__(1818);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_40__order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_none__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_41__order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__order_reverse__ = __webpack_require__(1819);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_42__order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(613);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function (_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return lineRadial(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]));
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(327);


/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  var peaks = series.map(peak);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function (a, b) {
    return peaks[a] - peaks[b];
  });
});

function peak(series) {
  var i = -1,
      j = 0,
      n = series.length,
      vi,
      vj = -Infinity;
  while (++i < n) {
    if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  }return j;
}

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(325);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function draw(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */]);
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function draw(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function draw(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function draw(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(325);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
    draw: function draw(context, size) {
        var r = Math.sqrt(size * ka),
            x = kx * r,
            y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for (var i = 1; i < 5; ++i) {
            var a = __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] * i / 5,
                c = Math.cos(a),
                s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function draw(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
    draw: function draw(context, size) {
        var r = Math.sqrt(size / a),
            x0 = r / 2,
            y0 = r * k,
            x1 = x0,
            y1 = r * k + r,
            x2 = -x1,
            y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(616);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
    return date.toISOString();
}

var formatIso = Date.prototype.toISOString ? formatIsoNative : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ __webpack_exports__["a"] = (formatIso);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(617);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return { y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function (date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function (string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week,
          day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function format(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    parse: function parse(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function () {
        return specifier;
      };
      return p;
    },
    utcFormat: function utcFormat(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function () {
        return specifier;
      };
      return f;
    },
    utcParse: function utcParse(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function () {
        return specifier;
      };
      return p;
    }
  };
}

var pads = { "-": "", "_": " ", "0": "0" },
    numberRe = /^\s*\d+/,
    // note: ignores next directive
percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {},
      i = -1,
      n = names.length;
  while (++i < n) {
    map[names[i].toLowerCase()] = i;
  }return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(938);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = height;

var _offset = __webpack_require__(417);

var _offset2 = _interopRequireDefault(_offset);

var _isWindow = __webpack_require__(329);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function height(node, client) {
  var win = (0, _isWindow2.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset2.default)(node).height;
}
module.exports = exports['default'];

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(329);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(329);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = width;

var _offset = __webpack_require__(417);

var _offset2 = _interopRequireDefault(_offset);

var _isWindow = __webpack_require__(329);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function width(node, client) {
  var win = (0, _isWindow2.default)(node);
  return win ? win.innerWidth : client ? node.clientWidth : (0, _offset2.default)(node).width;
}
module.exports = exports['default'];

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(949);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(1855);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(1850);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(1851);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(948);

var _isTransform = __webpack_require__(1852);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;

  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};

function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(1853);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var StateStorage = function () {
  function StateStorage(farce, namespace) {
    _classCallCheck(this, StateStorage);

    this._getFallbackLocationKey = farce.createHref;
    this._stateKeyPrefix = namespace + "|";
  }

  StateStorage.prototype.read = function read(location, key) {
    var stateKey = this._getStateKey(location, key);

    try {
      var value = window.sessionStorage.getItem(stateKey);
      // === null is probably sufficient.
      if (value == null) {
        return undefined;
      }

      // We want to catch JSON parse errors in case someone separately threw
      // junk into sessionStorage under our namespace.
      return JSON.parse(value);
    } catch (e) {
      // Pretend that the entry doesn't exist.
      return undefined;
    }
  };

  StateStorage.prototype.save = function save(location, key, value) {
    var stateKey = this._getStateKey(location, key);

    if (value === undefined) {
      try {
        window.sessionStorage.removeItem(stateKey);
      } catch (e) {
        // No need to handle errors here.
      }

      return;
    }

    // Unlike with read, we want to fail on invalid values here, since the
    // value here is provided by the caller of this method.
    var valueString = JSON.stringify(value);

    try {
      window.sessionStorage.setItem(stateKey, valueString);
    } catch (e) {
      // No need to handle errors here either. If it didn't work, it didn't
      // work. We make no guarantees about actually saving the value.
    }
  };

  StateStorage.prototype._getStateKey = function _getStateKey(location, key) {
    var locationKey = location.key || this._getFallbackLocationKey(location);
    var stateKeyBase = "" + this._stateKeyPrefix + locationKey;
    return key == null ? stateKeyBase : stateKeyBase + "|" + key;
  };

  return StateStorage;
}();

exports.default = StateStorage;
module.exports = exports["default"];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createHistoryMiddleware;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function updateLocation(location) {
  return {
    type: _ActionTypes2.default.UPDATE_LOCATION,
    payload: location
  };
}

function createHistoryMiddleware(protocol) {
  return function historyMiddleware() {
    return function (next) {
      var dispose = protocol.subscribe(function (location) {
        next(updateLocation(location));
      });

      return function (action) {
        var type = action.type,
            payload = action.payload;

        switch (type) {
          case _ActionTypes2.default.INIT:
            return next(updateLocation(protocol.init()));
          case _ActionTypes2.default.TRANSITION:
            return next(updateLocation(protocol.transition(payload)));
          case _ActionTypes2.default.GO:
            protocol.go(payload);
            return null;
          case _ActionTypes2.default.CREATE_HREF:
            return protocol.createHref(payload);
          case _ActionTypes2.default.CREATE_LOCATION:
            return payload;
          case _ActionTypes2.default.DISPOSE:
            dispose();
            return null;
          default:
            return next(action);
        }
      };
    };
  };
}
module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = createQueryMiddleware;

var _createLocationMiddleware = __webpack_require__(624);

var _createLocationMiddleware2 = _interopRequireDefault(_createLocationMiddleware);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createQueryMiddleware(_ref) {
  var parse = _ref.parse,
      stringify = _ref.stringify;

  return (0, _createLocationMiddleware2.default)({
    makeLocationDescriptor: function makeLocationDescriptor(location) {
      var query = location.query;

      if (query === undefined) {
        return location;
      }

      var queryString = stringify(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, location, { search: search });
    },
    makeLocation: function makeLocation(location) {
      if (location.query !== undefined) {
        return location;
      }

      var query = void 0;
      try {
        query = parse(location.search.slice(1));
      } catch (e) {
        query = null;
      }

      return _extends({}, location, { query: query });
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createStoreHistory;

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _maybePromisify = __webpack_require__(1866);

var _maybePromisify2 = _interopRequireDefault(_maybePromisify);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createStoreHistory(store) {
  var getLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref) {
    var location = _ref.location;
    return location;
  };

  return {
    listen: function listen(listener) {
      var location = getLocation(store.getState());
      listener(location);

      return store.subscribe(function () {
        var nextLocation = getLocation(store.getState());

        if (nextLocation !== location) {
          listener(nextLocation);
          location = nextLocation;
        }
      });
    },
    listenBefore: function listenBefore(hook) {
      return store.farce.addTransitionHook((0, _maybePromisify2.default)(hook, 1));
    },
    push: function push(location) {
      store.dispatch(_Actions2.default.push(location));
    },
    replace: function replace(location) {
      store.dispatch(_Actions2.default.replace(location));
    },
    goBack: function goBack() {
      store.dispatch(_Actions2.default.go(-1));
    },
    goForward: function goForward() {
      store.dispatch(_Actions2.default.go(1));
    },
    go: function go(delta) {
      store.dispatch(_Actions2.default.go(delta));
    },
    createHref: function createHref(location) {
      return store.farce.createHref(location);
    },
    createLocation: function createLocation(location) {
      return store.farce.createLocation(location);
    },
    dispose: function dispose() {
      store.dispatch(_Actions2.default.dispose());
    },

    // For compatibility with React Router v2.x.
    __v2_compatible__: true
  };
}
module.exports = exports['default'];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createTransitionHookMiddleware;

var _off = __webpack_require__(625);

var _off2 = _interopRequireDefault(_off);

var _on = __webpack_require__(626);

var _on2 = _interopRequireDefault(_on);

var _isPromise = __webpack_require__(435);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function runHook(hook, location, callback) {
  var result = void 0;
  try {
    result = hook(location);
  } catch (e) {
     false ? (0, _warning2.default)(false, 'Ignoring transition hook `%s` that failed with `%s`.', hook.name, e) : void 0;

    result = null;
  }

  if (!(0, _isPromise2.default)(result)) {
    return callback(result);
  }

  result.catch(function (e) {
     false ? (0, _warning2.default)(false, 'Ignoring transition hook `%s` that failed with `%s`.', hook.name, e) : void 0;

    return null;
  }).then(callback);

  return undefined;
}

function runHooks(hooks, location, callback) {
  if (!hooks.length) {
    return callback(true);
  }

  return runHook(hooks[0], location, function (result) {
    return result != null ? callback(result) : runHooks(hooks.slice(1), location, callback);
  });
}

function maybeConfirm(result) {
  if (typeof result === 'boolean') {
    return result;
  }

  return window.confirm(result); // eslint-disable-line no-alert
}

function runAllowTransition(hooks, location, callback) {
  return runHooks(hooks, location, function (result) {
    return callback(maybeConfirm(result));
  });
}

function createTransitionHookMiddleware(_ref) {
  var _ref$useBeforeUnload = _ref.useBeforeUnload,
      useBeforeUnload = _ref$useBeforeUnload === undefined ? false : _ref$useBeforeUnload;

  var nextStep = null;
  var hooks = [];

  function addHook(hook) {
    hooks.push(hook);

    return function () {
      hooks = hooks.filter(function (item) {
        return item !== hook;
      });
    };
  }

  var onBeforeUnload = null;

  function transitionHookMiddleware(_ref2) {
    var dispatch = _ref2.dispatch;

    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        if (nextStep && type === _ActionTypes2.default.UPDATE_LOCATION) {
          var step = nextStep;
          nextStep = null;
          return step(next, action);
        }

        switch (type) {
          case _ActionTypes2.default.INIT:
            // Only attach this listener once.
            if (useBeforeUnload && !onBeforeUnload) {
              /* istanbul ignore next: not testable with Karma */
              onBeforeUnload = function onBeforeUnload(event) {
                var syncResult = runHooks(hooks, null, function (result) {
                  return result;
                });

                if (syncResult === true || syncResult === undefined) {
                  // An asynchronous transition hook usually means there will be
                  // a custom confirm dialog. However, we'll already be showing
                  // the before unload dialog, and there's no way to prevent the
                  // custom dialog from showing. In such cases, the application
                  // code will need to explicitly handle the null location
                  // anyway, so don't potentially show two confirmation dialogs.
                  return undefined;
                }

                var resultSafe = syncResult || '';

                event.returnValue = resultSafe; // eslint-disable-line no-param-reassign
                return resultSafe;
              };

              (0, _on2.default)(window, 'beforeunload', onBeforeUnload);
            }

            return next(action);
          case _ActionTypes2.default.TRANSITION:
            return runAllowTransition(hooks, payload, function (allowTransition) {
              if (!allowTransition) {
                return null;
              }

              // Skip the repeated transition hook check on UPDATE_LOCATION.
              nextStep = function nextStep(nextNext, nextAction) {
                return nextNext(nextAction);
              };

              return next(action);
            });
          case _ActionTypes2.default.UPDATE_LOCATION:
            {
              // No transition hooks to run.
              if (!hooks.length) {
                return next(action);
              }

              // This is the initial load. It doesn't make sense to block this
              // transition.
              if (payload.delta === 0) {
                return next(action);
              }

              // Without delta, we can't restore the location.
              if (payload.delta == null) {
                return runAllowTransition(hooks, payload, function (allowTransition) {
                  return allowTransition ? next(action) : null;
                });
              }

              var finishRunAllowTransition = function finishRunAllowTransition(result) {
                if (!maybeConfirm(result)) {
                  return null;
                }

                // Release the original UPDATE_LOCATION when the un-rewind
                // happens. We need to do so here to maintain the invariant that
                // the store location only updates after the window location.
                nextStep = function nextStep() {
                  return next(action);
                };

                dispatch(_Actions2.default.go(payload.delta));
                return undefined;
              };

              var sync = true;
              var rewindDone = false;

              var syncResult = runHooks(hooks, payload, function (result) {
                if (sync) {
                  return result;
                }

                if (!rewindDone) {
                  // The rewind hasn't finished yet. Replace the next step hook so
                  // we finish running when that happens.
                  nextStep = function nextStep() {
                    return finishRunAllowTransition(result);
                  };
                  return undefined;
                }

                return finishRunAllowTransition(result);
              });

              sync = false;

              switch (syncResult) {
                case true:
                  // The transition was synchronously allowed, so skip the rewind.
                  return next(action);
                case false:
                  // We're done as soon as the rewind finishes.
                  nextStep = function nextStep() {};
                  break;
                case undefined:
                  // Let the callback from runHooks take care of things.
                  nextStep = function nextStep() {
                    rewindDone = true;
                  };
                  break;
                default:
                  // Show the confirm dialog after the rewind.
                  nextStep = function nextStep() {
                    return finishRunAllowTransition(syncResult);
                  };
              }

              dispatch(_Actions2.default.go(-payload.delta));
              return undefined;
            }
          case _ActionTypes2.default.DISPOSE:
            if (onBeforeUnload) {
              (0, _off2.default)(window, 'beforeunload', onBeforeUnload);
              onBeforeUnload = null;
            }

            return next(action);
          default:
            return next(action);
        }
      };
    };
  }

  transitionHookMiddleware.addHook = addHook;
  return transitionHookMiddleware;
}
module.exports = exports['default'];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = ensureLocationMiddleware;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ensureLocation = __webpack_require__(419);

var _ensureLocation2 = _interopRequireDefault(_ensureLocation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ensureLocationMiddleware() {
  return function (next) {
    return function (action) {
      var type = action.type,
          payload = action.payload;

      switch (type) {
        case _ActionTypes2.default.PUSH:
          return next({
            type: _ActionTypes2.default.TRANSITION,
            payload: _extends({}, (0, _ensureLocation2.default)(payload), { action: 'PUSH' })
          });
        case _ActionTypes2.default.REPLACE:
          return next({
            type: _ActionTypes2.default.TRANSITION,
            payload: _extends({}, (0, _ensureLocation2.default)(payload), { action: 'REPLACE' })
          });
        case _ActionTypes2.default.CREATE_HREF:
        case _ActionTypes2.default.CREATE_LOCATION:
          return next({
            type: type,
            payload: (0, _ensureLocation2.default)(payload)
          });
        default:
          return next(action);
      }
    };
  };
}
module.exports = exports['default'];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = locationReducer;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function locationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  if (action.type === _ActionTypes2.default.UPDATE_LOCATION) {
    return action.payload;
  }

  return state;
}
module.exports = exports['default'];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _queryString = __webpack_require__(1867);

var _queryString2 = _interopRequireDefault(_queryString);

var _createQueryMiddleware = __webpack_require__(953);

var _createQueryMiddleware2 = _interopRequireDefault(_createQueryMiddleware);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createQueryMiddleware2.default)(_queryString2.default);
module.exports = exports['default'];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

module.exports = {
  arraysDiffer: function arraysDiffer(a, b) {
    var isDifferent = false;
    if (a.length !== b.length) {
      isDifferent = true;
    } else {
      a.forEach(function (item, index) {
        if (!this.isSame(item, b[index])) {
          isDifferent = true;
        }
      }, this);
    }
    return isDifferent;
  },

  objectsDiffer: function objectsDiffer(a, b) {
    var isDifferent = false;
    if (Object.keys(a).length !== Object.keys(b).length) {
      isDifferent = true;
    } else {
      Object.keys(a).forEach(function (key) {
        if (!this.isSame(a[key], b[key])) {
          isDifferent = true;
        }
      }, this);
    }
    return isDifferent;
  },

  isSame: function isSame(a, b) {
    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
      return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      return !this.arraysDiffer(a, b);
    } else if (typeof a === 'function') {
      return a.toString() === b.toString();
    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
      return !this.objectsDiffer(a, b);
    }

    return a === b;
  },

  find: function find(collection, fn) {
    for (var i = 0, l = collection.length; i < l; i++) {
      var item = collection[i];
      if (fn(item)) {
        return item;
      }
    }
    return null;
  }
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(189);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(215);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(1946);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RelayPropTypes = __webpack_require__(81);

var _RelayPropTypes2 = _interopRequireDefault(_RelayPropTypes);

var _warning = __webpack_require__(972);

var _warning2 = _interopRequireDefault(_warning);

var _getQueryName = __webpack_require__(630);

var _getQueryName2 = _interopRequireDefault(_getQueryName);

var _QuerySubscription = __webpack_require__(629);

var _QuerySubscription2 = _interopRequireDefault(_QuerySubscription);

var _renderElement = __webpack_require__(631);

var _renderElement2 = _interopRequireDefault(_renderElement);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

var propTypes = {
  match: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired,
  Component: _elementType2.default,
  isComponentResolved: _propTypes2.default.bool.isRequired,
  hasComponent: _propTypes2.default.bool.isRequired,
  element: _propTypes2.default.element,
  querySubscription: _propTypes2.default.instanceOf(_QuerySubscription2.default).isRequired,
  fetched: _propTypes2.default.bool.isRequired
};

var childContextTypes = {
  relay: _RelayPropTypes2.default.Relay
};

var ReadyStateRenderer = function (_React$Component) {
  (0, _inherits3.default)(ReadyStateRenderer, _React$Component);

  function ReadyStateRenderer(props, context) {
    (0, _classCallCheck3.default)(this, ReadyStateRenderer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

    _initialiseProps.call(_this);

    var element = props.element,
        querySubscription = props.querySubscription;

    _this.state = {
      element: element
    };

    _this.selectionReference = querySubscription.retain();

    _this.relayContext = {};
    _this.updateRelayContext(querySubscription);
    return _this;
  }

  ReadyStateRenderer.prototype.getChildContext = function getChildContext() {
    return {
      relay: this.relayContext
    };
  };

  ReadyStateRenderer.prototype.componentDidMount = function componentDidMount() {
    this.props.querySubscription.subscribe(this.onUpdate);
  };

  ReadyStateRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var element = nextProps.element,
        querySubscription = nextProps.querySubscription;

    if (element !== this.props.element) {
      this.setState({ element: element });
    }

    if (querySubscription !== this.props.querySubscription) {
      this.selectionReference.dispose();
      this.selectionReference = querySubscription.retain();

      this.props.querySubscription.unsubscribe(this.onUpdate);
      querySubscription.subscribe(this.onUpdate);

      this.updateRelayContext(querySubscription);
    }
  };

  ReadyStateRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.selectionReference.dispose();
    this.props.querySubscription.unsubscribe(this.onUpdate);
  };

  ReadyStateRenderer.prototype.updateRelayContext = function updateRelayContext(querySubscription) {
    // XXX: Relay v1.6.0 adds an assumption that context.relay is mutated
    // in-place, so we need to do that here.
    (0, _assign2.default)(this.relayContext, querySubscription.relayContext);
  };

  ReadyStateRenderer.prototype.render = function render() {
    var _this2 = this;

    var element = this.state.element;

    if (!element) {
      return element;
    }

    var _props = this.props,
        querySubscription = _props.querySubscription,
        ownProps = (0, _objectWithoutProperties3.default)(_props, ['querySubscription']);

    delete ownProps.match;
    delete ownProps.Component;
    delete ownProps.isComponentResolved;
    delete ownProps.hasComponent;
    delete ownProps.element;
    delete ownProps.fetched;

    var relayProps = querySubscription.readyState.props;

    if (relayProps) {
      (0, _keys2.default)(relayProps).forEach(function (relayPropName) {
        // At least on Node v8.x, it's slightly faster to guard the delete here
        // with this hasOwnProperty check.
        if (hasOwnProperty.call(ownProps, relayPropName)) {
           false ? (0, _warning2.default)(false, 'Ignoring <ReadyStateRenderer> prop `%s` that shadows a Relay ' + 'prop from its query `%s`. This is most likely due to its ' + 'parent cloning it and adding extraneous Relay props.', relayPropName, (0, _getQueryName2.default)(_this2.props.match.route)) : void 0;

          delete ownProps[relayPropName];
        }
      });
    }

    return _react2.default.cloneElement(element, ownProps);
  };

  return ReadyStateRenderer;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onUpdate = function (readyState) {
    if (!_this3.props.fetched) {
      // Ignore subscription updates if our data aren't yet fetched. We'll
      // rerender anyway once fetching finishes.
      return;
    }

    var _props2 = _this3.props,
        match = _props2.match,
        Component = _props2.Component,
        isComponentResolved = _props2.isComponentResolved,
        hasComponent = _props2.hasComponent;

    var element = (0, _renderElement2.default)({
      match: match,
      Component: Component,
      isComponentResolved: isComponentResolved,
      hasComponent: hasComponent,
      readyState: readyState,
      resolving: false
    });

    _this3.setState({ element: element || null });
  };
};

ReadyStateRenderer.propTypes = propTypes;
ReadyStateRenderer.childContextTypes = childContextTypes;

exports.default = ReadyStateRenderer;
module.exports = exports['default'];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1922),
    mapCacheDelete = __webpack_require__(1923),
    mapCacheGet = __webpack_require__(1924),
    mapCacheHas = __webpack_require__(1925),
    mapCacheSet = __webpack_require__(1926);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1882),
    arraySome = __webpack_require__(1889),
    cacheHas = __webpack_require__(1899);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 965 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 966 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(165),
    stubFalse = __webpack_require__(1945);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(422),
    isObject = __webpack_require__(970);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 969 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 970 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1895),
    baseUnary = __webpack_require__(1898),
    nodeUtil = __webpack_require__(1929);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(1585);

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(1174);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

var _PropTypes = __webpack_require__(427);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var propTypes = {
  Component: _elementType2.default,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  match: _propTypes2.default.object.isRequired,
  activeClassName: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  activePropName: _propTypes2.default.string,
  router: _PropTypes.routerShape.isRequired,
  exact: _propTypes2.default.bool,
  target: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  childProps: _propTypes2.default.object // In case of name conflicts here.
};

var defaultProps = {
  Component: 'a',
  exact: false
};

var BaseLink = function (_React$Component) {
  (0, _inherits3.default)(BaseLink, _React$Component);

  function BaseLink() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BaseLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          target = _this$props.target,
          router = _this$props.router,
          to = _this$props.to;

      if (onClick) {
        onClick(event);
      }

      // Don't do anything if the user's onClick handler prevented default.
      // Otherwise, let the browser handle the link with the computed href if the
      // event wasn't an unmodified left click, or if the link has a target.
      if (event.defaultPrevented || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey || event.button !== 0 || target) {
        return;
      }

      event.preventDefault();

      // FIXME: When clicking on a link to the same location in the browser, the
      // actual becomes a replace rather than a push. We may want the same
      // handling – perhaps implemented in the Farce protocol.
      router.push(to);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  BaseLink.prototype.render = function render() {
    var _props = this.props,
        Component = _props.Component,
        to = _props.to,
        match = _props.match,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        activePropName = _props.activePropName,
        router = _props.router,
        exact = _props.exact,
        childProps = _props.childProps,
        props = (0, _objectWithoutProperties3.default)(_props, ['Component', 'to', 'match', 'activeClassName', 'activeStyle', 'activePropName', 'router', 'exact', 'childProps']);

    if (false) {
      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(typeof Component === 'function', 'Link to %s with `component` prop `%s` has an element type that ' + 'is not a component. The expected prop for the link component is ' + '`Component`.', (0, _stringify2.default)(to), props.component.displayName || props.component.name) : void 0;
    }

    if (activeClassName || activeStyle || activePropName) {
      var toLocation = router.createLocation(to);
      var active = router.isActive(match, toLocation, { exact: exact });

      if (active) {
        if (activeClassName) {
          props.className = props.className ? props.className + ' ' + activeClassName : activeClassName;
        }

        if (activeStyle) {
          props.style = (0, _extends3.default)({}, props.style, activeStyle);
        }
      }

      if (activePropName) {
        props[activePropName] = active;
      }
    }

    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, childProps, {
      href: router.createHref(to),
      onClick: this.onClick // This overrides props.onClick.
    }));
  };

  return BaseLink;
}(_react2.default.Component);

BaseLink.propTypes = propTypes;
BaseLink.defaultProps = defaultProps;

exports.default = BaseLink;
module.exports = exports['default'];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(394);

var _entries2 = _interopRequireDefault(_entries);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var propTypes = {
  elements: _propTypes2.default.arrayOf(
  // This should be an object of this same type, but recursive checks would
  // probably be too messy.
  _propTypes2.default.object, _propTypes2.default.element).isRequired
};

function accumulateElement(children, element) {
  if (!children) {
    return element;
  }

  if (!element) {
    return children;
  }

  if (!_react2.default.isValidElement(children)) {
    // Children come from named child routes.
    var groups = {};
    (0, _entries2.default)(children).forEach(function (_ref) {
      var groupName = _ref[0],
          groupElements = _ref[1];

      groups[groupName] = groupElements.reduceRight(accumulateElement, null);
    });

    return _react2.default.cloneElement(element, groups);
  }

  return _react2.default.cloneElement(element, { children: children });
}

function ElementsRenderer(_ref2) {
  var elements = _ref2.elements;

  return elements.reduceRight(accumulateElement, null);
}

ElementsRenderer.propTypes = propTypes;

exports.default = ElementsRenderer;
module.exports = exports['default'];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var HttpError = function HttpError(status, data) {
  (0, _classCallCheck3.default)(this, HttpError);

  this.status = status;
  this.data = data;
};

exports.default = HttpError;
module.exports = exports["default"];

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(215);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(189);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(392);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _entries = __webpack_require__(394);

var _entries2 = _interopRequireDefault(_entries);

var _create = __webpack_require__(393);

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _isEqual = __webpack_require__(997);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _pathToRegexp = __webpack_require__(2187);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Matcher = function () {
  function Matcher(routeConfig) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$matchStemRoutes = _ref.matchStemRoutes,
        matchStemRoutes = _ref$matchStemRoutes === undefined ? true : _ref$matchStemRoutes;

    (0, _classCallCheck3.default)(this, Matcher);

    this.routeConfig = routeConfig;

    this.matchStemRoutes = matchStemRoutes;

    // Overly-aggressive deduplication of packages can lead to the wrong
    // version of path-to-regexp getting bundled. This is a common enough
    // failure mode that it's worthwhile to add a dev-only warning here.
     false ? (0, _warning2.default)(typeof _pathToRegexp2.default.compile === 'function', 'Incorrect version of path-to-regexp imported. If this is running ' + 'from a client bundle, check your bundler settings.') : void 0;
  }

  Matcher.prototype.match = function match(_ref2) {
    var pathname = _ref2.pathname;

    var matches = this.matchRoutes(this.routeConfig, pathname);
    if (!matches) {
      return null;
    }

    return this.makePayload(matches);
  };

  Matcher.prototype.getRoutes = function getRoutes(_ref3) {
    var routeIndices = _ref3.routeIndices;

    if (!routeIndices) {
      return null;
    }

    return this.getRoutesFromIndices(routeIndices, this.routeConfig);
  };

  Matcher.prototype.joinPaths = function joinPaths(basePath, path) {
    if (!path) {
      return basePath;
    }

    if (basePath.charAt(basePath.length - 1) === '/') {
      // eslint-disable-next-line no-param-reassign
      basePath = basePath.slice(0, -1);
    }

    return '' + basePath + this.getCanonicalPattern(path);
  };

  Matcher.prototype.isActive = function isActive(_ref4, location) {
    var matchLocation = _ref4.location;

    var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        exact = _ref5.exact;

    return this.isPathnameActive(matchLocation.pathname, location.pathname, exact) && this.isQueryActive(matchLocation.query, location.query);
  };

  Matcher.prototype.format = function format(pattern, params) {
    return _pathToRegexp2.default.compile(pattern)(params);
  };

  Matcher.prototype.matchRoutes = function matchRoutes(routeConfig, pathname) {
    for (var index = 0; index < routeConfig.length; ++index) {
      var route = routeConfig[index];

      var match = this.matchRoute(route, pathname);
      if (!match) {
        continue; // eslint-disable-line no-continue
      }

      var params = match.params,
          remaining = match.remaining;
      var children = route.children;

      if (children) {
        if (Array.isArray(children)) {
          var childMatches = this.matchRoutes(children, remaining);
          if (childMatches) {
            return [{ index: index, params: params }].concat(childMatches);
          }
        } else {
          var groups = this.matchGroups(children, remaining);
          if (groups) {
            return [{ index: index, params: params }, { groups: groups }];
          }
        }
      }

      if (!remaining) {
        if (this.matchStemRoutes || !children) {
          return [{ index: index, params: params }];
        }
      }
    }

    return null;
  };

  Matcher.prototype.matchRoute = function matchRoute(route, pathname) {
    var routePath = route.path;
    if (!routePath) {
      return {
        params: {},
        remaining: pathname
      };
    }

    var pattern = this.getCanonicalPattern(routePath);
    var keys = [];
    var regexp = (0, _pathToRegexp2.default)(pattern, keys, { end: false });

    var match = regexp.exec(pathname);
    if (match === null) {
      return null;
    }

    var params = (0, _create2.default)(null);
    keys.forEach(function (_ref6, index) {
      var name = _ref6.name;

      var value = match[index + 1];
      params[name] = value && decodeURIComponent(value);
    });

    return {
      params: params,
      remaining: pathname.slice(match[0].length)
    };
  };

  Matcher.prototype.getCanonicalPattern = function getCanonicalPattern(pattern) {
    return pattern.charAt(0) === '/' ? pattern : '/' + pattern;
  };

  Matcher.prototype.matchGroups = function matchGroups(routeGroups, pathname) {
    var groups = {};

    for (var _iterator = (0, _entries2.default)(routeGroups), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
      var _ref8;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref8 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref8 = _i.value;
      }

      var _ref7 = _ref8;
      var groupName = _ref7[0];
      var routes = _ref7[1];

      var groupMatch = this.matchRoutes(routes, pathname);
      if (!groupMatch) {
        return null;
      }

      groups[groupName] = groupMatch;
    }

    return groups;
  };

  Matcher.prototype.makePayload = function makePayload(matches) {
    var _this = this;

    var routeMatch = matches[0];

    if (routeMatch.groups) {
       false ? (0, _warning2.default)(matches.length === 1, 'Route match with groups %s has children, which are ignored.', (0, _keys2.default)(routeMatch.groups).join(', ')) : void 0;

      var routeIndices = {};
      var routeParams = [];
      var _params = {};

      (0, _entries2.default)(routeMatch.groups).forEach(function (_ref9) {
        var groupName = _ref9[0],
            groupMatches = _ref9[1];

        var groupPayload = _this.makePayload(groupMatches);

        // Retain the nested group structure for route indices so we can
        // reconstruct the element tree from flattened route elements.
        routeIndices[groupName] = groupPayload.routeIndices;

        // Flatten route groups for route params matching getRoutesFromIndices
        // below.
        routeParams.push.apply(routeParams, groupPayload.routeParams);

        // Just merge all the params depth-first; it's the easiest option.
        (0, _assign2.default)(_params, groupPayload.params);
      });

      return { routeIndices: routeIndices, routeParams: routeParams, params: _params };
    }

    var index = routeMatch.index,
        params = routeMatch.params;

    if (matches.length === 1) {
      return {
        routeIndices: [index],
        routeParams: [params],
        params: params
      };
    }

    var childPayload = this.makePayload(matches.slice(1));
    return {
      routeIndices: [index].concat(childPayload.routeIndices),
      routeParams: [params].concat(childPayload.routeParams),
      params: (0, _extends3.default)({}, params, childPayload.params)
    };
  };

  Matcher.prototype.getRoutesFromIndices = function getRoutesFromIndices(routeIndices, routeConfigOrGroups) {
    var _this2 = this;

    var routeIndex = routeIndices[0];

    if ((typeof routeIndex === 'undefined' ? 'undefined' : (0, _typeof3.default)(routeIndex)) === 'object') {
      // Flatten route groups to save resolvers from having to explicitly
      // handle them.
      var groupRoutes = [];
      (0, _entries2.default)(routeIndex).forEach(function (_ref10) {
        var groupName = _ref10[0],
            groupRouteIndices = _ref10[1];

        groupRoutes.push.apply(groupRoutes, _this2.getRoutesFromIndices(groupRouteIndices, routeConfigOrGroups[groupName]));
      });

      return groupRoutes;
    }

    var route = routeConfigOrGroups[routeIndex];

    if (routeIndices.length === 1) {
      return [route];
    }

    return [route].concat(this.getRoutesFromIndices(routeIndices.slice(1), route.children));
  };

  Matcher.prototype.isPathnameActive = function isPathnameActive(matchPathname, pathname, exact) {
    if (pathname === matchPathname) {
      return true;
    }

    if (exact) {
      // The above condition is necessary for an exact match.
      return false;
    }

    // Require that a partial match be followed by a path separator.
    var pathnameWithSeparator = pathname.slice(-1) !== '/' ? pathname + '/' : pathname;

    // Can't use startsWith, as that requires a polyfill.
    return matchPathname.indexOf(pathnameWithSeparator) === 0;
  };

  Matcher.prototype.isQueryActive = function isQueryActive(matchQuery, query) {
    if (!query) {
      return true;
    }

    return (0, _entries2.default)(query).every(function (_ref11) {
      var key = _ref11[0],
          value = _ref11[1];
      return Object.prototype.hasOwnProperty.call(matchQuery, key) ? (0, _isEqual2.default)(matchQuery[key], value) : value === undefined;
    });
  };

  Matcher.prototype.replaceRouteConfig = function replaceRouteConfig(routeConfig) {
    this.routeConfig = routeConfig;
  };

  return Matcher;
}();

exports.default = Matcher;
module.exports = exports['default'];

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncIterator2 = __webpack_require__(547);

var _asyncIterator3 = _interopRequireDefault(_asyncIterator2);

var _asyncToGenerator2 = __webpack_require__(548);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = createBaseRouter;

var _isEqual = __webpack_require__(997);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStaticContainer = __webpack_require__(1266);

var _reactStaticContainer2 = _interopRequireDefault(_reactStaticContainer);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

var _PropTypes = __webpack_require__(427);

var _RedirectException = __webpack_require__(635);

var _RedirectException2 = _interopRequireDefault(_RedirectException);

var _resolveRenderArgs = __webpack_require__(989);

var _resolveRenderArgs2 = _interopRequireDefault(_resolveRenderArgs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createBaseRouter(_ref) {
  var render = _ref.render;

  var propTypes = {
    match: _propTypes2.default.object.isRequired,
    resolvedMatch: _propTypes2.default.object.isRequired,
    matchContext: _propTypes2.default.any,
    resolver: _propTypes2.default.shape({
      resolveElements: _propTypes2.default.func.isRequired
    }).isRequired,
    router: _PropTypes.routerShape.isRequired,
    onResolveMatch: _propTypes2.default.func.isRequired,
    initialRenderArgs: _propTypes2.default.object
  };

  var childContextTypes = {
    router: _PropTypes.routerShape.isRequired
  };

  var BaseRouter = function (_React$Component) {
    (0, _inherits3.default)(BaseRouter, _React$Component);

    function BaseRouter(props, context) {
      (0, _classCallCheck3.default)(this, BaseRouter);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

      var router = props.router,
          initialRenderArgs = props.initialRenderArgs;

      _this.state = {
        element: initialRenderArgs ? render(initialRenderArgs) : null
      };

      _this.mounted = true;

      _this.shouldResolveMatch = false;
      _this.pendingResolvedMatch = false;

      _this.childContext = { router: router };
      return _this;
    }

    BaseRouter.prototype.getChildContext = function getChildContext() {
      return this.childContext;
    };

    // We use componentDidMount and componentDidUpdate to resolve the match if
    // needed because element resolution is asynchronous anyway, and this lets
    // us not worry about setState not being available in the constructor, or
    // about having to pass around nextProps.

    BaseRouter.prototype.componentDidMount = function componentDidMount() {
      if (!this.props.initialRenderArgs) {
        this.resolveMatch();
      }

      if (false) {
        /* eslint-env browser */
        /* eslint-disable no-underscore-dangle */
        if (window.__FOUND_HOT_RELOAD__) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(!window.__FOUND_REPLACE_ROUTE_CONFIG__, 'Replacing existing hot reloading hook. Do not render more than ' + 'one router instance when using hot reloading.') : void 0;

          window.__FOUND_REPLACE_ROUTE_CONFIG__ = this.props.router.replaceRouteConfig;
        }
        /* eslint-enable no-underscore-dangle */
        /* eslint-env browser: false */
      }
    };

    BaseRouter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
       false ? (0, _warning2.default)(nextProps.router === this.props.router, '<BaseRouter> does not support changing the router object.') : void 0;

      if (nextProps.match !== this.props.match || nextProps.resolver !== this.props.resolver || !(0, _isEqual2.default)(nextProps.matchContext, this.props.matchContext)) {
        this.shouldResolveMatch = true;
      }
    };

    BaseRouter.prototype.componentDidUpdate = function componentDidUpdate() {
      if (this.shouldResolveMatch) {
        this.shouldResolveMatch = false;
        this.resolveMatch();
      }
    };

    BaseRouter.prototype.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;

      if (false) {
        /* eslint-env browser */
        /* eslint-disable no-underscore-dangle */
        if (window.__FOUND_HOT_RELOAD__) {
          delete window.__FOUND_REPLACE_ROUTE_CONFIG__;
        }
        /* eslint-enable no-underscore-dangle */
        /* eslint-env browser: false */
      }
    };

    BaseRouter.prototype.resolveMatch = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var pendingMatch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, renderArgs;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pendingMatch = this.props.match;
                _context.prev = 1;

                // ESLint doesn't handle for-await yet.
                // eslint-disable-next-line semi
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = (0, _asyncIterator3.default)((0, _resolveRenderArgs2.default)(this.props));

              case 7:
                _context.next = 9;
                return _iterator.next();

              case 9:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 13;
                return _step.value;

              case 13:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 24;
                  break;
                }

                renderArgs = _value;

                if (!(!this.mounted || this.props.match !== pendingMatch)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt('return');

              case 18:

                // If we're about to mark the match resolved, delay the rerender
                // until we do so.
                this.pendingResolvedMatch = !!((renderArgs.elements || renderArgs.error) && this.props.resolvedMatch !== pendingMatch);

                this.setState({ element: render(renderArgs) });

                if (this.pendingResolvedMatch) {
                  // If this is a new match, update the store, so we can rerender at
                  // the same time as all of the links and other components connected
                  // to the router state.
                  this.pendingResolvedMatch = false;
                  this.props.onResolveMatch(pendingMatch);
                }

              case 21:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 30:
                _context.prev = 30;
                _context.prev = 31;

                if (!(!_iteratorNormalCompletion && _iterator.return)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 35;
                return _iterator.return();

              case 35:
                _context.prev = 35;

                if (!_didIteratorError) {
                  _context.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context.finish(35);

              case 39:
                return _context.finish(30);

              case 40:
                _context.next = 48;
                break;

              case 42:
                _context.prev = 42;
                _context.t1 = _context['catch'](1);

                if (!(_context.t1 instanceof _RedirectException2.default)) {
                  _context.next = 47;
                  break;
                }

                this.props.router.replace(_context.t1.location);
                return _context.abrupt('return');

              case 47:
                throw _context.t1;

              case 48:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 42], [5, 26, 30, 40], [31,, 35, 39]]);
      }));

      function resolveMatch() {
        return _ref2.apply(this, arguments);
      }

      return resolveMatch;
    }();

    BaseRouter.prototype.render = function render() {
      // Don't rerender synchronously if we have another rerender coming. Just
      // memoizing the element here doesn't do anything because we're using
      // context.
      return _react2.default.createElement(_reactStaticContainer2.default, {
        shouldUpdate: !this.shouldResolveMatch && !this.pendingResolvedMatch
      }, this.state.element);
    };

    return BaseRouter;
  }(_react2.default.Component);

  BaseRouter.propTypes = propTypes;
  BaseRouter.childContextTypes = childContextTypes;

  return BaseRouter;
}
module.exports = exports['default'];

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createConnectedLink;

var _BaseLink = __webpack_require__(973);

var _BaseLink2 = _interopRequireDefault(_BaseLink);

var _createWithRouter = __webpack_require__(637);

var _createWithRouter2 = _interopRequireDefault(_createWithRouter);

var _withRouter = __webpack_require__(990);

var _withRouter2 = _interopRequireDefault(_withRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createConnectedLink(options) {
  var withRouter = options ? (0, _createWithRouter2.default)(options) : _withRouter2.default;

  var ConnectedLink = withRouter(_BaseLink2.default);
  ConnectedLink.displayName = 'ConnectedLink';

  return ConnectedLink;
}
module.exports = exports['default'];

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createConnectedRouter;

var _reactRedux = __webpack_require__(700);

var _ActionTypes = __webpack_require__(426);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createBaseRouter = __webpack_require__(977);

var _createBaseRouter2 = _interopRequireDefault(_createBaseRouter);

var _createStoreRouterObject = __webpack_require__(988);

var _createStoreRouterObject2 = _interopRequireDefault(_createStoreRouterObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function resolveMatch(match) {
  return {
    type: _ActionTypes2.default.RESOLVE_MATCH,
    payload: match
  };
}

function createConnectedRouter(_ref) {
  var _ref$getFound = _ref.getFound,
      getFound = _ref$getFound === undefined ? function (_ref2) {
    var found = _ref2.found;
    return found;
  } : _ref$getFound,
      options = (0, _objectWithoutProperties3.default)(_ref, ['getFound']);

  var ConnectedRouter = (0, _reactRedux.connect)(function (state) {
    var _getFound = getFound(state),
        match = _getFound.match,
        resolvedMatch = _getFound.resolvedMatch;

    return { match: match, resolvedMatch: resolvedMatch };
  }, {
    onResolveMatch: resolveMatch
  }, null, {
    // Don't block context propagation from above. The router should seldom
    // be unnecessarily rerendering anyway.
    pure: false,
    getDisplayName: function getDisplayName() {
      return 'ConnectedRouter';
    }
  })((0, _createBaseRouter2.default)(options));

  // TODO: Use connectAdvanced.
  // This implementation is very messy, but it provides the cleanest API to get
  // these methods into the base router from the store, since they're already
  // on the store context.
  // Overwriting the method instead of extending the class is used to avoid
  // issues with compatibility on IE <= 10.
  var baseAddExtraProps = ConnectedRouter.prototype.addExtraProps;

  function addExtraProps(props) {
    if (!this.router) {
      this.router = (0, _createStoreRouterObject2.default)(this.props.store || this.context.store);
    }

    return (0, _extends3.default)({}, baseAddExtraProps.call(this, props), {
      router: this.router
    });
  }

  ConnectedRouter.prototype.addExtraProps = addExtraProps;

  return ConnectedRouter;
}
module.exports = exports['default'];

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createElements;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

var _ResolverUtils = __webpack_require__(428);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createElements(routeMatches, Components, matchData) {
  return routeMatches.map(function (match, i) {
    var route = match.route;

    var Component = Components[i];
    var data = matchData[i];

    var isComponentResolved = (0, _ResolverUtils.isResolved)(Component);
    var areDataResolved = (0, _ResolverUtils.isResolved)(data);

    if (route.render) {
      // Perhaps undefined here would be more correct for "not ready", but
      // Relay uses null in RelayReadyStateRenderer, so let's follow that
      // convention.
      return route.render({
        match: match,
        Component: isComponentResolved ? Component : null,
        props: areDataResolved ? (0, _extends3.default)({}, match, { data: data }) : null,
        data: areDataResolved ? data : null
      });
    }

    if (!isComponentResolved || !areDataResolved) {
      // Can't render.
      return undefined;
    }

    if (!Component) {
      // Note this check would be wrong on potentially unresolved data.
       false ? (0, _warning2.default)(data === undefined, 'Route %s with data has no render method or component.', i) : void 0;

      // Nothing to render.
      return null;
    }

    return _react2.default.createElement(Component, (0, _extends3.default)({}, match, { data: data }));
  });
}
module.exports = exports['default'];

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _asyncToGenerator2 = __webpack_require__(548);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _createFarceRouter = __webpack_require__(636);

var _createFarceRouter2 = _interopRequireDefault(_createFarceRouter);

var _getStoreRenderArgs = __webpack_require__(986);

var _getStoreRenderArgs2 = _interopRequireDefault(_getStoreRenderArgs);

var _createFarceStore = __webpack_require__(987);

var _createFarceStore2 = _interopRequireDefault(_createFarceStore);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
    var historyProtocol = _ref2.historyProtocol,
        historyMiddlewares = _ref2.historyMiddlewares,
        historyOptions = _ref2.historyOptions,
        routeConfig = _ref2.routeConfig,
        matchContext = _ref2.matchContext,
        resolver = _ref2.resolver,
        options = (0, _objectWithoutProperties3.default)(_ref2, ['historyProtocol', 'historyMiddlewares', 'historyOptions', 'routeConfig', 'matchContext', 'resolver']);
    var store, FarceRouter, initialRenderArgs;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = (0, _createFarceStore2.default)({
              historyProtocol: historyProtocol,
              historyMiddlewares: historyMiddlewares,
              historyOptions: historyOptions,
              routeConfig: routeConfig
            });
            FarceRouter = (0, _createFarceRouter2.default)((0, _extends3.default)({}, options, { store: store }));

            // This intentionally doesn't handle RedirectExceptions, because those
            // shouldn't happen here anyway.

            _context.next = 4;
            return (0, _getStoreRenderArgs2.default)({
              store: store,
              matchContext: matchContext,
              resolver: resolver
            });

          case 4:
            initialRenderArgs = _context.sent;

            // We own this FarceRouter, so it's safe to replace its default props.
            FarceRouter.defaultProps = (0, _extends3.default)({}, FarceRouter.defaultProps, {
              matchContext: matchContext,
              resolver: resolver,
              initialRenderArgs: initialRenderArgs
            });

            return _context.abrupt('return', FarceRouter);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function createInitialFarceRouter(_x) {
    return _ref.apply(this, arguments);
  }

  return createInitialFarceRouter;
}();

module.exports = exports['default'];

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createMatchEnhancer;

var _ActionTypes = __webpack_require__(164);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _redux = __webpack_require__(296);

var _ActionTypes3 = __webpack_require__(426);

var _ActionTypes4 = _interopRequireDefault(_ActionTypes3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createMatchMiddleware(matcher) {
  return function matchMiddleware() {
    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        if (type !== _ActionTypes2.default.UPDATE_LOCATION) {
          return next(action);
        }

        return next({
          type: _ActionTypes4.default.UPDATE_MATCH,
          payload: (0, _extends3.default)({
            location: payload
          }, matcher.match(payload))
        });
      };
    };
  };
}

function createMatchEnhancer(matcher) {
  var getFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref) {
    var found = _ref.found;
    return found;
  };

  return function matchEnhancer(createStore) {
    return function () {
      var middlewareEnhancer = (0, _redux.applyMiddleware)(createMatchMiddleware(matcher));

      var store = middlewareEnhancer(createStore).apply(undefined, arguments);

      function replaceRouteConfig(routeConfig) {
        matcher.replaceRouteConfig(routeConfig);

        store.dispatch({
          type: _ActionTypes2.default.UPDATE_LOCATION,
          payload: getFound(store.getState()).match.location
        });
      }

      return (0, _extends3.default)({}, store, {
        found: { matcher: matcher, replaceRouteConfig: replaceRouteConfig }
      });
    };
  };
}
module.exports = exports['default'];

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createRender;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStaticContainer = __webpack_require__(1266);

var _reactStaticContainer2 = _interopRequireDefault(_reactStaticContainer);

var _ElementsRenderer = __webpack_require__(974);

var _ElementsRenderer2 = _interopRequireDefault(_ElementsRenderer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// These are intentionally not renderLoading, renderFetched, and renderFailure
// from Relay, because these don't quite correspond to those conditions.
function createRender(_ref) {
  var renderPending = _ref.renderPending,
      renderReady = _ref.renderReady,
      renderError = _ref.renderError;

  return function render(renderArgs) {
    var error = renderArgs.error,
        elements = renderArgs.elements;

    var element = void 0;

    if (error) {
      element = renderError ? renderError(renderArgs) : null;
    } else if (!elements) {
      element = renderPending ? renderPending(renderArgs) : undefined;
    } else if (renderReady) {
      element = renderReady(renderArgs);
    } else {
      element = _react2.default.createElement(_ElementsRenderer2.default, { elements: elements });
    }

    var hasElement = element !== undefined;

    return _react2.default.createElement(_reactStaticContainer2.default, { shouldUpdate: hasElement }, hasElement ? element : null);
  };
}
module.exports = exports['default'];

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = foundReducer;

var _ActionTypes = __webpack_require__(426);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function foundReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _ActionTypes2.default.UPDATE_MATCH:
      // For the initial match, set resolvedMatch too. There's no previous
      // result to keep rendered, plus this simplifies server rendering.
      return {
        match: payload,
        resolvedMatch: state ? state.resolvedMatch : payload
      };
    case _ActionTypes2.default.RESOLVE_MATCH:
      // It doesn't make sense to resolve a match if there wasn't already an
      // unresolved match.
      return state && {
        match: state.match,
        resolvedMatch: payload
      };
    default:
      return state;
  }
}
module.exports = exports['default'];

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncIterator2 = __webpack_require__(547);

var _asyncIterator3 = _interopRequireDefault(_asyncIterator2);

var _asyncToGenerator2 = __webpack_require__(548);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _resolveRenderArgs = __webpack_require__(989);

var _resolveRenderArgs2 = _interopRequireDefault(_resolveRenderArgs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(props) {
    var elements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            elements = void 0;

            // ESLint doesn't handle for-await yet.
            // eslint-disable-next-line semi

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = (0, _asyncIterator3.default)((0, _resolveRenderArgs2.default)(props));

          case 6:
            _context.next = 8;
            return _iterator.next();

          case 8:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 12;
            return _step.value;

          case 12:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 18;
              break;
            }

            elements = _value;

          case 15:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context['catch'](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 24:
            _context.prev = 24;
            _context.prev = 25;

            if (!(!_iteratorNormalCompletion && _iterator.return)) {
              _context.next = 29;
              break;
            }

            _context.next = 29;
            return _iterator.return();

          case 29:
            _context.prev = 29;

            if (!_didIteratorError) {
              _context.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context.finish(29);

          case 33:
            return _context.finish(24);

          case 34:
            return _context.abrupt('return', elements);

          case 35:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 20, 24, 34], [25,, 29, 33]]);
  }));

  function getRenderArgs(_x) {
    return _ref.apply(this, arguments);
  }

  return getRenderArgs;
}();

module.exports = exports['default'];

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getStoreRenderArgs;

var _getRenderArgs = __webpack_require__(985);

var _getRenderArgs2 = _interopRequireDefault(_getRenderArgs);

var _createStoreRouterObject = __webpack_require__(988);

var _createStoreRouterObject2 = _interopRequireDefault(_createStoreRouterObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// This function returns a promise. It doesn't need to be an async function
// because it doesn't use the promise's value.
function getStoreRenderArgs(_ref) {
  var store = _ref.store,
      _ref$getFound = _ref.getFound,
      getFound = _ref$getFound === undefined ? function (_ref2) {
    var found = _ref2.found;
    return found;
  } : _ref$getFound,
      matchContext = _ref.matchContext,
      resolver = _ref.resolver;

  var router = (0, _createStoreRouterObject2.default)(store);
  var match = getFound(store.getState()).resolvedMatch;

  return (0, _getRenderArgs2.default)({
    router: router,
    match: match,
    matchContext: matchContext,
    resolver: resolver
  });
}
module.exports = exports['default'];

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createFarceStore;

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _createHistoryEnhancer = __webpack_require__(623);

var _createHistoryEnhancer2 = _interopRequireDefault(_createHistoryEnhancer);

var _queryMiddleware = __webpack_require__(958);

var _queryMiddleware2 = _interopRequireDefault(_queryMiddleware);

var _redux = __webpack_require__(296);

var _createMatchEnhancer = __webpack_require__(982);

var _createMatchEnhancer2 = _interopRequireDefault(_createMatchEnhancer);

var _foundReducer = __webpack_require__(984);

var _foundReducer2 = _interopRequireDefault(_foundReducer);

var _Matcher = __webpack_require__(976);

var _Matcher2 = _interopRequireDefault(_Matcher);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createFarceStore(_ref) {
  var historyProtocol = _ref.historyProtocol,
      historyMiddlewares = _ref.historyMiddlewares,
      historyOptions = _ref.historyOptions,
      routeConfig = _ref.routeConfig,
      matcherOptions = _ref.matcherOptions;

  var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    found: _foundReducer2.default
  }), (0, _redux.compose)((0, _createHistoryEnhancer2.default)((0, _extends3.default)({}, historyOptions, {
    protocol: historyProtocol,
    middlewares: historyMiddlewares || [_queryMiddleware2.default]
  })), (0, _createMatchEnhancer2.default)(new _Matcher2.default(routeConfig, matcherOptions))));

  store.dispatch(_Actions2.default.init());

  return store;
}
module.exports = exports['default'];

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createStoreRouterObject;

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _redux = __webpack_require__(296);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var NAVIGATION_ACTION_CREATORS = {
  push: _Actions2.default.push,
  replace: _Actions2.default.replace,
  go: _Actions2.default.go
};

function createStoreRouterObject(store) {
  var farce = store.farce,
      found = store.found;
  var matcher = found.matcher;

  return (0, _extends3.default)({}, (0, _redux.bindActionCreators)(NAVIGATION_ACTION_CREATORS, store.dispatch), farce, found, {

    // Expose isActive from matcher directly for convenience. This pattern is
    // faster than using matcher.isActive.bind(matcher).
    isActive: function isActive(match, location, options) {
      return matcher.isActive(match, location, options);
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncIterator2 = __webpack_require__(547);

var _asyncIterator3 = _interopRequireDefault(_asyncIterator2);

var _asyncGenerator2 = __webpack_require__(546);

var _asyncGenerator3 = _interopRequireDefault(_asyncGenerator2);

var _entries = __webpack_require__(394);

var _entries2 = _interopRequireDefault(_entries);

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(392);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _HttpError = __webpack_require__(975);

var _HttpError2 = _interopRequireDefault(_HttpError);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function foldElements(elementsRaw, routeIndices) {
  var elements = [];

  for (var _iterator = routeIndices, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var routeIndex = _ref;

    if ((typeof routeIndex === 'undefined' ? 'undefined' : (0, _typeof3.default)(routeIndex)) === 'object') {
      (function () {
        // Reshape the next elements in the elements array to match the nested
        // tree structure corresponding to the route groups.
        var groupElements = {};
        (0, _entries2.default)(routeIndex).forEach(function (_ref2) {
          var groupName = _ref2[0],
              groupRouteIndices = _ref2[1];

          groupElements[groupName] = foldElements(elementsRaw, groupRouteIndices);
        });

        elements.push(groupElements);
      })();
    } else {
      // We intentionally modify elementsRaw, to make it easier to recursively
      // handle groups.
      elements.push(elementsRaw.shift());
    }
  }

  return elements;
}

exports.default = function () {
  var _ref3 = _asyncGenerator3.default.wrap( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref4) {
    var router = _ref4.router,
        match = _ref4.match,
        matchContext = _ref4.matchContext,
        resolver = _ref4.resolver;

    var routes, augmentedMatch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator2, _step, _value, elements;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            routes = router.matcher.getRoutes(match);
            augmentedMatch = (0, _extends3.default)({}, match, {
              routes: routes,
              match: match, // For symmetry with withRouter.
              router: router, // Convenience access for route components.
              context: matchContext
            });

            if (routes) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return (0, _extends3.default)({}, augmentedMatch, { error: new _HttpError2.default(404) });

          case 5:
            return _context.abrupt('return');

          case 6:
            _context.prev = 6;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 10;
            _iterator2 = (0, _asyncIterator3.default)(resolver.resolveElements(augmentedMatch));

          case 12:
            _context.next = 14;
            return _asyncGenerator3.default.await(_iterator2.next());

          case 14:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 18;
            return _asyncGenerator3.default.await(_step.value);

          case 18:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 26;
              break;
            }

            elements = _value;
            _context.next = 23;
            return (0, _extends3.default)({}, augmentedMatch, {
              elements: elements && foldElements([].concat(elements), match.routeIndices)
            });

          case 23:
            _iteratorNormalCompletion = true;
            _context.next = 12;
            break;

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context['catch'](10);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 32:
            _context.prev = 32;
            _context.prev = 33;

            if (!(!_iteratorNormalCompletion && _iterator2.return)) {
              _context.next = 37;
              break;
            }

            _context.next = 37;
            return _asyncGenerator3.default.await(_iterator2.return());

          case 37:
            _context.prev = 37;

            if (!_didIteratorError) {
              _context.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context.finish(37);

          case 41:
            return _context.finish(32);

          case 42:
            _context.next = 51;
            break;

          case 44:
            _context.prev = 44;
            _context.t1 = _context['catch'](6);

            if (!(_context.t1 instanceof _HttpError2.default)) {
              _context.next = 50;
              break;
            }

            _context.next = 49;
            return (0, _extends3.default)({}, augmentedMatch, { error: _context.t1 });

          case 49:
            return _context.abrupt('return');

          case 50:
            throw _context.t1;

          case 51:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[6, 44], [10, 28, 32, 42], [33,, 37, 41]]);
  }));

  function resolveRenderArgs(_x) {
    return _ref3.apply(this, arguments);
  }

  return resolveRenderArgs;
}();

module.exports = exports['default'];

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWithRouter = __webpack_require__(637);

var _createWithRouter2 = _interopRequireDefault(_createWithRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _createWithRouter2.default)({});
module.exports = exports['default'];

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2000),
    mapCacheDelete = __webpack_require__(2001),
    mapCacheGet = __webpack_require__(2002),
    mapCacheHas = __webpack_require__(2003),
    mapCacheSet = __webpack_require__(2004);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1960),
    arraySome = __webpack_require__(1967),
    cacheHas = __webpack_require__(1977);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 994 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(167),
    stubFalse = __webpack_require__(2022);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1970);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(431),
    isObject = __webpack_require__(1000);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 999 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1973),
    baseUnary = __webpack_require__(1976),
    nodeUtil = __webpack_require__(2007);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(2046);


/** Built-in value references. */
var _Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (_Symbol);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(331),
    baseLodash = __webpack_require__(654);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237),
    root = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(104);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237),
    root = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2084),
    isArguments = __webpack_require__(452),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(336),
    isIndex = __webpack_require__(333),
    isTypedArray = __webpack_require__(454);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(442),
    eq = __webpack_require__(282);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(652),
    createBaseEach = __webpack_require__(2098);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(650),
    isFlattenable = __webpack_require__(2125);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2099);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(650),
    isArray = __webpack_require__(80);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(651),
    castPath = __webpack_require__(280),
    isIndex = __webpack_require__(333),
    isObject = __webpack_require__(110),
    toKey = __webpack_require__(281);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(335),
    metaMap = __webpack_require__(1041);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function (func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(647),
    arrayIncludes = __webpack_require__(649),
    arrayIncludesWith = __webpack_require__(1007),
    cacheHas = __webpack_require__(655),
    createSet = __webpack_require__(2105),
    setToArray = __webpack_require__(451);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(104);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(656);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(332),
    isIterateeCall = __webpack_require__(334);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1023),
    composeArgsRight = __webpack_require__(1024),
    countHolders = __webpack_require__(2097),
    createCtor = __webpack_require__(446),
    createRecurry = __webpack_require__(1027),
    getHolder = __webpack_require__(657),
    reorder = __webpack_require__(2146),
    replaceHolders = __webpack_require__(450),
    root = __webpack_require__(104);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(2127),
    setData = __webpack_require__(1045),
    setWrapToString = __webpack_require__(1046);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(647),
    arraySome = __webpack_require__(1010),
    cacheHas = __webpack_require__(655);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(2162),
    overRest = __webpack_require__(1044),
    setToString = __webpack_require__(661);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1016),
    getSymbols = __webpack_require__(658),
    keys = __webpack_require__(283);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1016),
    getSymbolsIn = __webpack_require__(1035),
    keysIn = __webpack_require__(338);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(1041),
    noop = __webpack_require__(1054);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function (func) {
  return metaMap.get(func);
};

module.exports = getData;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(650),
    getPrototype = __webpack_require__(448),
    getSymbols = __webpack_require__(658),
    stubArray = __webpack_require__(1055);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2049),
    Map = __webpack_require__(645),
    Promise = __webpack_require__(2051),
    Set = __webpack_require__(1004),
    WeakMap = __webpack_require__(1006),
    baseGetTag = __webpack_require__(168),
    toSource = __webpack_require__(1048);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(331),
    getPrototype = __webpack_require__(448),
    isPrototype = __webpack_require__(660);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

module.exports = initCloneObject;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(110);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(1006);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap();

module.exports = metaMap;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(1031);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(439);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1018),
    shortOut = __webpack_require__(1047);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(2115),
    insertWrapDetails = __webpack_require__(2124),
    setToString = __webpack_require__(661),
    updateWrapDetails = __webpack_require__(2156);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = reference + '';
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1013),
    baseIteratee = __webpack_require__(235),
    toInteger = __webpack_require__(668);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(443);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2059),
    hasPath = __webpack_require__(2116);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(238),
    isObjectLike = __webpack_require__(135);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(646);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(2175);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function isPM(input) {
            return (/^nm$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: '\'n paar sekondes',
            m: '\'n minuut',
            mm: '%d minute',
            h: '\'n uur',
            hh: '%d ure',
            d: '\'n dag',
            dd: '%d dae',
            M: '\'n maand',
            MM: '%d maande',
            y: '\'n jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;
});

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var arDz = moment.defineLocale('ar-dz', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arDz;
});

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arKw;
});

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    };
    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    };
    var plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    };
    var pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    };
    var months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/\u200f/g, '').replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arLy;
});

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arMa;
});

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    };
    var numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arSa;
});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;
});

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    };
    var numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };
    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    };
    var plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    };
    var pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    };
    var months = ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;
});

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'birneçə saniyyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function isPM(input) {
            return (/^(gündüz|axşam)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;
});

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function nextWeek() {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function isPM(input) {
            return (/^(дня|вечара)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;
});

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дни',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;
});

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    };
    var numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;
});

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    };
    var numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ'
        },
        preparse: function preparse(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;
});

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h[e]mm A',
            LTS: 'h[e]mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warc\'hoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Dec\'h da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s \'zo',
            s: 'un nebeud segondennoù',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;
});

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;
});

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: '[el] D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: '[el] D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: '[el] dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function nextDay() {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'd\'aquí %s',
            past: 'fa %s',
            s: 'uns segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;
});

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
    var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsParse: function (months, monthsShort) {
            var i,
                _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort),
        shortMonthsParse: function (monthsShort) {
            var i,
                _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort),
        longMonthsParse: function (months) {
            var i,
                _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months),
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;
});

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;
});

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function ordinal(number) {
            var b = number,
                output = '',
                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;
});

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;
});

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;
});

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    // based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH.mm',
            LLLL: 'dddd, D. MMMM YYYY HH.mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;
});

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;
});

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'];
    var weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {

            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM: function isPM(input) {
            return 'މފ' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;
});

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function isPM(input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L'
        },
        calendar: function calendar(key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;
});

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;
});

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;
});

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;
});

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;
});

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;
});

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D[-a de] MMMM, YYYY',
            LLL: 'D[-a de] MMMM, YYYY HH:mm',
            LLLL: 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function isPM(input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd [je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasinta] dddd [je] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'sekundoj',
            m: 'minuto',
            mm: '%d minutoj',
            h: 'horo',
            hh: '%d horoj',
            d: 'tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'monato',
            MM: '%d monatoj',
            y: 'jaro',
            yy: '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;
});

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;
});

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;
});

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'm': ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h': ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd': ['ühe päeva', 'üks päev'],
            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y': ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;
});

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;
});

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    };
    var numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function isPM(input) {
            return (/بعد از ظهر/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;
});

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
    var numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;
});

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            m: 'ein minutt',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaði',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;
});

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;
});

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;
});

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;
});

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;
});

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;
});

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function lastDay() {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;
});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' hor'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;
});

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function hh(number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function dd(number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function MM(number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function yy(number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function isPM(input) {
            return (/^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;
});

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;
});

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;
});

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number,
            suffix;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function isPM(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function nextWeek() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function lastWeek() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;
});

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function nextWeek() {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function lastWeek() {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function isPM(input) {
            return (/^(ցերեկվա|երեկոյան)$/.test(input)
            );
        },
        meridiem: function meridiem(hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hyAm;
});

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;
});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;
});

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: 'un\'ora',
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;
});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ja = moment.defineLocale('ja', {
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 HH:mm dddd',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日 HH:mm dddd'
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(input) {
            return input === '午後';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: '[来週]dddd LT',
            lastDay: '[昨日] LT',
            lastWeek: '[前週]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年'
        }
    });

    return ja;
});

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;
});

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ka = moment.defineLocale('ka', {
        months: {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში'
                );
            },
            past: function past(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის უკან');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის უკან');
                }
            },
            s: 'რამდენიმე წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7
        }
    });

    return ka;
});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;
});

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;
});

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    };
    var numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ'
        },
        preparse: function preparse(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function ordinal(number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kn;
});

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년'
        },
        dayOfMonthOrdinalParse: /\d{1,2}일/,
        ordinal: '%d일',
        meridiemParse: /오전|오후/,
        isPM: function isPM(token) {
            return token === '오후';
        },
        meridiem: function meridiem(hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;
});

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кече саат] LT',
            lastWeek: '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;
});

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function lastWeek() {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;
});

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function isPM(input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function ordinal(number) {
            return 'ທີ່' + number;
        }
    });

    return lo;
});

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var units = {
        'm': 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h': 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd': 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M': 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y': 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function ordinal(number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;
});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var units = {
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;
});

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;
});

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;
});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'после %s',
            past: 'пред %s',
            s: 'неколку секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            M: 'месец',
            MM: '%d месеци',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;
});

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;
});

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';break;
                case 'm':
                    output = 'एक मिनिट';break;
                case 'mm':
                    output = '%d मिनिटे';break;
                case 'h':
                    output = 'एक तास';break;
                case 'hh':
                    output = '%d तास';break;
                case 'd':
                    output = 'एक दिवस';break;
                case 'dd':
                    output = '%d दिवस';break;
                case 'M':
                    output = 'एक महिना';break;
                case 'MM':
                    output = '%d महिने';break;
                case 'y':
                    output = 'एक वर्ष';break;
                case 'yy':
                    output = '%d वर्षे';break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';break;
                case 'm':
                    output = 'एका मिनिटा';break;
                case 'mm':
                    output = '%d मिनिटां';break;
                case 'h':
                    output = 'एका तासा';break;
                case 'hh':
                    output = '%d तासां';break;
                case 'd':
                    output = 'एका दिवसा';break;
                case 'dd':
                    output = '%d दिवसां';break;
                case 'M':
                    output = 'एका महिन्या';break;
                case 'MM':
                    output = '%d महिन्यां';break;
                case 'y':
                    output = 'एका वर्षा';break;
                case 'yy':
                    output = '%d वर्षां';break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;
});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return msMy;
});

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;
});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    };
    var numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function preparse(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;
});

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;
});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    };
    var numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;
});

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;
});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;
});

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;
});

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    };
    var numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ'
        },
        preparse: function preparse(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return paIn;
});

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
    var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: '[W] dddd [o] LT',
            lastDay: '[Wczoraj o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;
});

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ptBr = moment.defineLocale('pt-br', {
        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: '%s atrás',
            s: 'poucos segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº'
    });

    return ptBr;
});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var pt = moment.defineLocale('pt', {
        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;
});

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
            separator = ' ';
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;
});

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сегодня в] LT',
            nextDay: '[Завтра в] LT',
            lastDay: '[Вчера в] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            lastWeek: function lastWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd [в] LT';
                    } else {
                        return '[В] dddd [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(input) {
            return (/^(дня|вечера)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ru;
});

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'];
    var days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;
});

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;
});

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    /*jshint -W100*/

    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function ordinal(number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function isPM(input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;
});

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
    var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;
});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;
});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function isPM(input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;
});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var translator = {
        words: { //Different grammatical cases
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;
});

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;
});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;
});

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;
});

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'masiku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;
});

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    };
    var numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function ordinal(number) {
            return number + 'வது';
        },
        preparse: function preparse(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;
});

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;
});

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'minutu balun',
            m: 'minutu ida',
            mm: 'minutus %d',
            h: 'horas ida',
            hh: 'horas %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;
});

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function isPM(input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี'
        }
    });

    return th;
});

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;
});

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100),
            ten = Math.floor(number % 100 / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;
});

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[haftaya] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen hafta] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl'
        },
        dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                // special case for zero
                return number + '\'ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;
});

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.

    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function isPM(input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }

    return tzl;
});

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzmLatn;
});

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;
});

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(input) {
            return (/^(дня|вечора)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;
});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'];
    var days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;
});

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uzLatn;
});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;
});

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function isPM(input) {
            return (/^ch$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;
});

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;
});

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d'
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;
});

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日Ah点mm分',
            LLLL: 'YYYY年MMMD日ddddAh点mm分',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s内',
            past: '%s前',
            s: '几秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;
});

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日 HH:mm',
            LLLL: 'YYYY年MMMD日dddd HH:mm',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhHk;
});

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(2)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY年MMMD日',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日 HH:mm',
            LLLL: 'YYYY年MMMD日dddd HH:mm',
            l: 'YYYY年MMMD日',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日 HH:mm',
            llll: 'YYYY年MMMD日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhTw;
});

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(1173);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
	return origKeys(o);
} : __webpack_require__(2186);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2);
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) {
				// eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1175);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Quill Editor v1.3.4
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["Quill"] = factory();else root["Quill"] = factory();
})(this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 109);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var container_1 = __webpack_require__(17);
      var format_1 = __webpack_require__(18);
      var leaf_1 = __webpack_require__(19);
      var scroll_1 = __webpack_require__(45);
      var inline_1 = __webpack_require__(46);
      var block_1 = __webpack_require__(47);
      var embed_1 = __webpack_require__(48);
      var text_1 = __webpack_require__(49);
      var attributor_1 = __webpack_require__(12);
      var class_1 = __webpack_require__(32);
      var style_1 = __webpack_require__(33);
      var store_1 = __webpack_require__(31);
      var Registry = __webpack_require__(1);
      var Parchment = {
        Scope: Registry.Scope,
        create: Registry.create,
        find: Registry.find,
        query: Registry.query,
        register: Registry.register,
        Container: container_1.default,
        Format: format_1.default,
        Leaf: leaf_1.default,
        Embed: embed_1.default,
        Scroll: scroll_1.default,
        Block: block_1.default,
        Inline: inline_1.default,
        Text: text_1.default,
        Attributor: {
          Attribute: attributor_1.default,
          Class: class_1.default,
          Style: style_1.default,
          Store: store_1.default
        }
      };
      exports.default = Parchment;

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var ParchmentError = /** @class */function (_super) {
        __extends(ParchmentError, _super);
        function ParchmentError(message) {
          var _this = this;
          message = '[Parchment] ' + message;
          _this = _super.call(this, message) || this;
          _this.message = message;
          _this.name = _this.constructor.name;
          return _this;
        }
        return ParchmentError;
      }(Error);
      exports.ParchmentError = ParchmentError;
      var attributes = {};
      var classes = {};
      var tags = {};
      var types = {};
      exports.DATA_KEY = '__blot';
      var Scope;
      (function (Scope) {
        Scope[Scope["TYPE"] = 3] = "TYPE";
        Scope[Scope["LEVEL"] = 12] = "LEVEL";
        Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
        Scope[Scope["BLOT"] = 14] = "BLOT";
        Scope[Scope["INLINE"] = 7] = "INLINE";
        Scope[Scope["BLOCK"] = 11] = "BLOCK";
        Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
        Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
        Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
        Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
        Scope[Scope["ANY"] = 15] = "ANY";
      })(Scope = exports.Scope || (exports.Scope = {}));
      function create(input, value) {
        var match = query(input);
        if (match == null) {
          throw new ParchmentError("Unable to create " + input + " blot");
        }
        var BlotClass = match;
        var node = input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
        return new BlotClass(node, value);
      }
      exports.create = create;
      function find(node, bubble) {
        if (bubble === void 0) {
          bubble = false;
        }
        if (node == null) return null;
        if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
        if (bubble) return find(node.parentNode, bubble);
        return null;
      }
      exports.find = find;
      function query(query, scope) {
        if (scope === void 0) {
          scope = Scope.ANY;
        }
        var match;
        if (typeof query === 'string') {
          match = types[query] || attributes[query];
        } else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
          match = types['text'];
        } else if (typeof query === 'number') {
          if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
          } else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
          }
        } else if (query instanceof HTMLElement) {
          var names = (query.getAttribute('class') || '').split(/\s+/);
          for (var i in names) {
            match = classes[names[i]];
            if (match) break;
          }
          match = match || tags[query.tagName];
        }
        if (match == null) return null;
        if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
        return null;
      }
      exports.query = query;
      function register() {
        var Definitions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          Definitions[_i] = arguments[_i];
        }
        if (Definitions.length > 1) {
          return Definitions.map(function (d) {
            return register(d);
          });
        }
        var Definition = Definitions[0];
        if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
          throw new ParchmentError('Invalid definition');
        } else if (Definition.blotName === 'abstract') {
          throw new ParchmentError('Cannot register abstract class');
        }
        types[Definition.blotName || Definition.attrName] = Definition;
        if (typeof Definition.keyName === 'string') {
          attributes[Definition.keyName] = Definition;
        } else {
          if (Definition.className != null) {
            classes[Definition.className] = Definition;
          }
          if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
              Definition.tagName = Definition.tagName.map(function (tagName) {
                return tagName.toUpperCase();
              });
            } else {
              Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
              if (tags[tag] == null || Definition.className == null) {
                tags[tag] = Definition;
              }
            });
          }
        }
        return Definition;
      }
      exports.register = register;

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      var diff = __webpack_require__(51);
      var equal = __webpack_require__(11);
      var extend = __webpack_require__(3);
      var op = __webpack_require__(20);

      var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()


      var Delta = function Delta(ops) {
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) {
          this.ops = ops;
        } else if (ops != null && Array.isArray(ops.ops)) {
          this.ops = ops.ops;
        } else {
          this.ops = [];
        }
      };

      Delta.prototype.insert = function (text, attributes) {
        var newOp = {};
        if (text.length === 0) return this;
        newOp.insert = text;
        if (attributes != null && (typeof attributes === 'undefined' ? 'undefined' : _typeof2(attributes)) === 'object' && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }
        return this.push(newOp);
      };

      Delta.prototype['delete'] = function (length) {
        if (length <= 0) return this;
        return this.push({ 'delete': length });
      };

      Delta.prototype.retain = function (length, attributes) {
        if (length <= 0) return this;
        var newOp = { retain: length };
        if (attributes != null && (typeof attributes === 'undefined' ? 'undefined' : _typeof2(attributes)) === 'object' && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }
        return this.push(newOp);
      };

      Delta.prototype.push = function (newOp) {
        var index = this.ops.length;
        var lastOp = this.ops[index - 1];
        newOp = extend(true, {}, newOp);
        if ((typeof lastOp === 'undefined' ? 'undefined' : _typeof2(lastOp)) === 'object') {
          if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
            this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
            return this;
          }
          // Since it does not matter if we insert before or after deleting at the same index,
          // always prefer to insert first
          if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
            index -= 1;
            lastOp = this.ops[index - 1];
            if ((typeof lastOp === 'undefined' ? 'undefined' : _typeof2(lastOp)) !== 'object') {
              this.ops.unshift(newOp);
              return this;
            }
          }
          if (equal(newOp.attributes, lastOp.attributes)) {
            if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
              this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
              if (_typeof2(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
              return this;
            } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
              this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
              if (_typeof2(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
              return this;
            }
          }
        }
        if (index === this.ops.length) {
          this.ops.push(newOp);
        } else {
          this.ops.splice(index, 0, newOp);
        }
        return this;
      };

      Delta.prototype.chop = function () {
        var lastOp = this.ops[this.ops.length - 1];
        if (lastOp && lastOp.retain && !lastOp.attributes) {
          this.ops.pop();
        }
        return this;
      };

      Delta.prototype.filter = function (predicate) {
        return this.ops.filter(predicate);
      };

      Delta.prototype.forEach = function (predicate) {
        this.ops.forEach(predicate);
      };

      Delta.prototype.map = function (predicate) {
        return this.ops.map(predicate);
      };

      Delta.prototype.partition = function (predicate) {
        var passed = [],
            failed = [];
        this.forEach(function (op) {
          var target = predicate(op) ? passed : failed;
          target.push(op);
        });
        return [passed, failed];
      };

      Delta.prototype.reduce = function (predicate, initial) {
        return this.ops.reduce(predicate, initial);
      };

      Delta.prototype.changeLength = function () {
        return this.reduce(function (length, elem) {
          if (elem.insert) {
            return length + op.length(elem);
          } else if (elem.delete) {
            return length - elem.delete;
          }
          return length;
        }, 0);
      };

      Delta.prototype.length = function () {
        return this.reduce(function (length, elem) {
          return length + op.length(elem);
        }, 0);
      };

      Delta.prototype.slice = function (start, end) {
        start = start || 0;
        if (typeof end !== 'number') end = Infinity;
        var ops = [];
        var iter = op.iterator(this.ops);
        var index = 0;
        while (index < end && iter.hasNext()) {
          var nextOp;
          if (index < start) {
            nextOp = iter.next(start - index);
          } else {
            nextOp = iter.next(end - index);
            ops.push(nextOp);
          }
          index += op.length(nextOp);
        }
        return new Delta(ops);
      };

      Delta.prototype.compose = function (other) {
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var delta = new Delta();
        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (otherIter.peekType() === 'insert') {
            delta.push(otherIter.next());
          } else if (thisIter.peekType() === 'delete') {
            delta.push(thisIter.next());
          } else {
            var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length);
            var otherOp = otherIter.next(length);
            if (typeof otherOp.retain === 'number') {
              var newOp = {};
              if (typeof thisOp.retain === 'number') {
                newOp.retain = length;
              } else {
                newOp.insert = thisOp.insert;
              }
              // Preserve null when composing with a retain, otherwise remove it for inserts
              var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
              if (attributes) newOp.attributes = attributes;
              delta.push(newOp);
              // Other op should be delete, we could be an insert or retain
              // Insert + delete cancels out
            } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
              delta.push(otherOp);
            }
          }
        }
        return delta.chop();
      };

      Delta.prototype.concat = function (other) {
        var delta = new Delta(this.ops.slice());
        if (other.ops.length > 0) {
          delta.push(other.ops[0]);
          delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
      };

      Delta.prototype.diff = function (other, index) {
        if (this.ops === other.ops) {
          return new Delta();
        }
        var strings = [this, other].map(function (delta) {
          return delta.map(function (op) {
            if (op.insert != null) {
              return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
            }
            var prep = delta === other ? 'on' : 'with';
            throw new Error('diff() called ' + prep + ' non-document');
          }).join('');
        });
        var delta = new Delta();
        var diffResult = diff(strings[0], strings[1], index);
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        diffResult.forEach(function (component) {
          var length = component[1].length;
          while (length > 0) {
            var opLength = 0;
            switch (component[0]) {
              case diff.INSERT:
                opLength = Math.min(otherIter.peekLength(), length);
                delta.push(otherIter.next(opLength));
                break;
              case diff.DELETE:
                opLength = Math.min(length, thisIter.peekLength());
                thisIter.next(opLength);
                delta['delete'](opLength);
                break;
              case diff.EQUAL:
                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                var thisOp = thisIter.next(opLength);
                var otherOp = otherIter.next(opLength);
                if (equal(thisOp.insert, otherOp.insert)) {
                  delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                } else {
                  delta.push(otherOp)['delete'](opLength);
                }
                break;
            }
            length -= opLength;
          }
        });
        return delta.chop();
      };

      Delta.prototype.eachLine = function (predicate, newline) {
        newline = newline || '\n';
        var iter = op.iterator(this.ops);
        var line = new Delta();
        var i = 0;
        while (iter.hasNext()) {
          if (iter.peekType() !== 'insert') return;
          var thisOp = iter.peek();
          var start = op.length(thisOp) - iter.peekLength();
          var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
          if (index < 0) {
            line.push(iter.next());
          } else if (index > 0) {
            line.push(iter.next(index));
          } else {
            if (predicate(line, iter.next(1).attributes || {}, i) === false) {
              return;
            }
            i += 1;
            line = new Delta();
          }
        }
        if (line.length() > 0) {
          predicate(line, {}, i);
        }
      };

      Delta.prototype.transform = function (other, priority) {
        priority = !!priority;
        if (typeof other === 'number') {
          return this.transformPosition(other, priority);
        }
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var delta = new Delta();
        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
            delta.retain(op.length(thisIter.next()));
          } else if (otherIter.peekType() === 'insert') {
            delta.push(otherIter.next());
          } else {
            var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length);
            var otherOp = otherIter.next(length);
            if (thisOp['delete']) {
              // Our delete either makes their delete redundant or removes their retain
              continue;
            } else if (otherOp['delete']) {
              delta.push(otherOp);
            } else {
              // We retain either their retain or insert
              delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
            }
          }
        }
        return delta.chop();
      };

      Delta.prototype.transformPosition = function (index, priority) {
        priority = !!priority;
        var thisIter = op.iterator(this.ops);
        var offset = 0;
        while (thisIter.hasNext() && offset <= index) {
          var length = thisIter.peekLength();
          var nextType = thisIter.peekType();
          thisIter.next();
          if (nextType === 'delete') {
            index -= Math.min(length, index - offset);
            continue;
          } else if (nextType === 'insert' && (offset < index || !priority)) {
            index += length;
          }
          offset += length;
        }
        return index;
      };

      module.exports = Delta;

      /***/
    },
    /* 3 */
    /***/function (module, exports) {

      'use strict';

      var hasOwn = Object.prototype.hasOwnProperty;
      var toStr = Object.prototype.toString;

      var isArray = function isArray(arr) {
        if (typeof Array.isArray === 'function') {
          return Array.isArray(arr);
        }

        return toStr.call(arr) === '[object Array]';
      };

      var isPlainObject = function isPlainObject(obj) {
        if (!obj || toStr.call(obj) !== '[object Object]') {
          return false;
        }

        var hasOwnConstructor = hasOwn.call(obj, 'constructor');
        var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
        // Not own constructor property must be Object
        if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
          return false;
        }

        // Own properties are enumerated firstly, so to speed up,
        // if last one is own, then all properties are own.
        var key;
        for (key in obj) {/**/}

        return typeof key === 'undefined' || hasOwn.call(obj, key);
      };

      module.exports = function extend() {
        var options, name, src, copy, copyIsArray, clone;
        var target = arguments[0];
        var i = 1;
        var length = arguments.length;
        var deep = false;

        // Handle a deep copy situation
        if (typeof target === 'boolean') {
          deep = target;
          target = arguments[1] || {};
          // skip the boolean and the target
          i = 2;
        }
        if (target == null || (typeof target === 'undefined' ? 'undefined' : _typeof2(target)) !== 'object' && typeof target !== 'function') {
          target = {};
        }

        for (; i < length; ++i) {
          options = arguments[i];
          // Only deal with non-null/undefined values
          if (options != null) {
            // Extend the base object
            for (name in options) {
              src = target[name];
              copy = options[name];

              // Prevent never-ending loop
              if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                  if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && isArray(src) ? src : [];
                  } else {
                    clone = src && isPlainObject(src) ? src : {};
                  }

                  // Never move original objects, clone them
                  target[name] = extend(deep, clone, copy);

                  // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') {
                  target[name] = copy;
                }
              }
            }
          }
        }

        // Return the modified object
        return target;
      };

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWLINE_LENGTH = 1;

      var BlockEmbed = function (_Parchment$Embed) {
        _inherits(BlockEmbed, _Parchment$Embed);

        function BlockEmbed() {
          _classCallCheck(this, BlockEmbed);

          return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
        }

        _createClass(BlockEmbed, [{
          key: 'attach',
          value: function attach() {
            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
          }
        }, {
          key: 'delta',
          value: function delta() {
            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
            if (attribute != null) {
              this.attributes.attribute(attribute, value);
            }
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            this.format(name, value);
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (typeof value === 'string' && value.endsWith('\n')) {
              var block = _parchment2.default.create(Block.blotName);
              this.parent.insertBefore(block, index === 0 ? this : this.next);
              block.insertAt(0, value.slice(0, -1));
            } else {
              _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
            }
          }
        }]);

        return BlockEmbed;
      }(_parchment2.default.Embed);

      BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
      // It is important for cursor behavior BlockEmbeds use tags that are block level elements


      var Block = function (_Parchment$Block) {
        _inherits(Block, _Parchment$Block);

        function Block(domNode) {
          _classCallCheck(this, Block);

          var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

          _this2.cache = {};
          return _this2;
        }

        _createClass(Block, [{
          key: 'delta',
          value: function delta() {
            if (this.cache.delta == null) {
              this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
                if (leaf.length() === 0) {
                  return delta;
                } else {
                  return delta.insert(leaf.value(), bubbleFormats(leaf));
                }
              }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
            }
            return this.cache.delta;
          }
        }, {
          key: 'deleteAt',
          value: function deleteAt(index, length) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
            this.cache = {};
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (length <= 0) return;
            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
              if (index + length === this.length()) {
                this.format(name, value);
              }
            } else {
              _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
            }
            this.cache = {};
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
            if (value.length === 0) return;
            var lines = value.split('\n');
            var text = lines.shift();
            if (text.length > 0) {
              if (index < this.length() - 1 || this.children.tail == null) {
                _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
              } else {
                this.children.tail.insertAt(this.children.tail.length(), text);
              }
              this.cache = {};
            }
            var block = this;
            lines.reduce(function (index, line) {
              block = block.split(index, true);
              block.insertAt(0, line);
              return line.length;
            }, index + text.length);
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            var head = this.children.head;
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
            if (head instanceof _break2.default) {
              head.remove();
            }
            this.cache = {};
          }
        }, {
          key: 'length',
          value: function length() {
            if (this.cache.length == null) {
              this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
            }
            return this.cache.length;
          }
        }, {
          key: 'moveChildren',
          value: function moveChildren(target, ref) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
            this.cache = {};
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
            this.cache = {};
          }
        }, {
          key: 'path',
          value: function path(index) {
            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
          }
        }, {
          key: 'removeChild',
          value: function removeChild(child) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
            this.cache = {};
          }
        }, {
          key: 'split',
          value: function split(index) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
              var clone = this.clone();
              if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
              } else {
                this.parent.insertBefore(clone, this.next);
                return clone;
              }
            } else {
              var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
              this.cache = {};
              return next;
            }
          }
        }]);

        return Block;
      }(_parchment2.default.Block);

      Block.blotName = 'block';
      Block.tagName = 'P';
      Block.defaultChild = 'break';
      Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

      function bubbleFormats(blot) {
        var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (blot == null) return formats;
        if (typeof blot.formats === 'function') {
          formats = (0, _extend2.default)(formats, blot.formats());
        }
        if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
          return formats;
        }
        return bubbleFormats(blot.parent, formats);
      }

      exports.bubbleFormats = bubbleFormats;
      exports.BlockEmbed = BlockEmbed;
      exports.default = Block;

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.overload = exports.expandConfig = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      __webpack_require__(50);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _editor = __webpack_require__(14);

      var _editor2 = _interopRequireDefault(_editor);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _selection = __webpack_require__(15);

      var _selection2 = _interopRequireDefault(_selection);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)('quill');

      var Quill = function () {
        _createClass(Quill, null, [{
          key: 'debug',
          value: function debug(limit) {
            if (limit === true) {
              limit = 'log';
            }
            _logger2.default.level(limit);
          }
        }, {
          key: 'find',
          value: function find(node) {
            return node.__quill || _parchment2.default.find(node);
          }
        }, {
          key: 'import',
          value: function _import(name) {
            if (this.imports[name] == null) {
              debug.error('Cannot import ' + name + '. Are you sure it was registered?');
            }
            return this.imports[name];
          }
        }, {
          key: 'register',
          value: function register(path, target) {
            var _this = this;

            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (typeof path !== 'string') {
              var name = path.attrName || path.blotName;
              if (typeof name === 'string') {
                // register(Blot | Attributor, overwrite)
                this.register('formats/' + name, path, target);
              } else {
                Object.keys(path).forEach(function (key) {
                  _this.register(key, path[key], target);
                });
              }
            } else {
              if (this.imports[path] != null && !overwrite) {
                debug.warn('Overwriting ' + path + ' with', target);
              }
              this.imports[path] = target;
              if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
                _parchment2.default.register(target);
              } else if (path.startsWith('modules') && typeof target.register === 'function') {
                target.register();
              }
            }
          }
        }]);

        function Quill(container) {
          var _this2 = this;

          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, Quill);

          this.options = expandConfig(container, options);
          this.container = this.options.container;
          if (this.container == null) {
            return debug.error('Invalid Quill container', container);
          }
          if (this.options.debug) {
            Quill.debug(this.options.debug);
          }
          var html = this.container.innerHTML.trim();
          this.container.classList.add('ql-container');
          this.container.innerHTML = '';
          this.container.__quill = this;
          this.root = this.addContainer('ql-editor');
          this.root.classList.add('ql-blank');
          this.root.setAttribute('data-gramm', false);
          this.scrollingContainer = this.options.scrollingContainer || this.root;
          this.emitter = new _emitter4.default();
          this.scroll = _parchment2.default.create(this.root, {
            emitter: this.emitter,
            whitelist: this.options.formats
          });
          this.editor = new _editor2.default(this.scroll);
          this.selection = new _selection2.default(this.scroll, this.emitter);
          this.theme = new this.options.theme(this, this.options);
          this.keyboard = this.theme.addModule('keyboard');
          this.clipboard = this.theme.addModule('clipboard');
          this.history = this.theme.addModule('history');
          this.theme.init();
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
            if (type === _emitter4.default.events.TEXT_CHANGE) {
              _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
            var range = _this2.selection.lastRange;
            var index = range && range.length === 0 ? range.index : undefined;
            modify.call(_this2, function () {
              return _this2.editor.update(null, mutations, index);
            }, source);
          });
          var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
          this.setContents(contents);
          this.history.clear();
          if (this.options.placeholder) {
            this.root.setAttribute('data-placeholder', this.options.placeholder);
          }
          if (this.options.readOnly) {
            this.disable();
          }
        }

        _createClass(Quill, [{
          key: 'addContainer',
          value: function addContainer(container) {
            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (typeof container === 'string') {
              var className = container;
              container = document.createElement('div');
              container.classList.add(className);
            }
            this.container.insertBefore(container, refNode);
            return container;
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.selection.setRange(null);
          }
        }, {
          key: 'deleteText',
          value: function deleteText(index, length, source) {
            var _this3 = this;

            var _overload = overload(index, length, source);

            var _overload2 = _slicedToArray(_overload, 4);

            index = _overload2[0];
            length = _overload2[1];
            source = _overload2[3];

            return modify.call(this, function () {
              return _this3.editor.deleteText(index, length);
            }, source, index, -1 * length);
          }
        }, {
          key: 'disable',
          value: function disable() {
            this.enable(false);
          }
        }, {
          key: 'enable',
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.scroll.enable(enabled);
            this.container.classList.toggle('ql-disabled', !enabled);
          }
        }, {
          key: 'focus',
          value: function focus() {
            var scrollTop = this.scrollingContainer.scrollTop;
            this.selection.focus();
            this.scrollingContainer.scrollTop = scrollTop;
            this.scrollIntoView();
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            var _this4 = this;

            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              var range = _this4.getSelection(true);
              var change = new _quillDelta2.default();
              if (range == null) {
                return change;
              } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
              } else if (range.length === 0) {
                _this4.selection.format(name, value);
                return change;
              } else {
                change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
              }
              _this4.setSelection(range, _emitter4.default.sources.SILENT);
              return change;
            }, source);
          }
        }, {
          key: 'formatLine',
          value: function formatLine(index, length, name, value, source) {
            var _this5 = this;

            var formats = void 0;

            var _overload3 = overload(index, length, name, value, source);

            var _overload4 = _slicedToArray(_overload3, 4);

            index = _overload4[0];
            length = _overload4[1];
            formats = _overload4[2];
            source = _overload4[3];

            return modify.call(this, function () {
              return _this5.editor.formatLine(index, length, formats);
            }, source, index, 0);
          }
        }, {
          key: 'formatText',
          value: function formatText(index, length, name, value, source) {
            var _this6 = this;

            var formats = void 0;

            var _overload5 = overload(index, length, name, value, source);

            var _overload6 = _slicedToArray(_overload5, 4);

            index = _overload6[0];
            length = _overload6[1];
            formats = _overload6[2];
            source = _overload6[3];

            return modify.call(this, function () {
              return _this6.editor.formatText(index, length, formats);
            }, source, index, 0);
          }
        }, {
          key: 'getBounds',
          value: function getBounds(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var bounds = void 0;
            if (typeof index === 'number') {
              bounds = this.selection.getBounds(index, length);
            } else {
              bounds = this.selection.getBounds(index.index, index.length);
            }
            var containerBounds = this.container.getBoundingClientRect();
            return {
              bottom: bounds.bottom - containerBounds.top,
              height: bounds.height,
              left: bounds.left - containerBounds.left,
              right: bounds.right - containerBounds.left,
              top: bounds.top - containerBounds.top,
              width: bounds.width
            };
          }
        }, {
          key: 'getContents',
          value: function getContents() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

            var _overload7 = overload(index, length);

            var _overload8 = _slicedToArray(_overload7, 2);

            index = _overload8[0];
            length = _overload8[1];

            return this.editor.getContents(index, length);
          }
        }, {
          key: 'getFormat',
          value: function getFormat() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (typeof index === 'number') {
              return this.editor.getFormat(index, length);
            } else {
              return this.editor.getFormat(index.index, index.length);
            }
          }
        }, {
          key: 'getIndex',
          value: function getIndex(blot) {
            return blot.offset(this.scroll);
          }
        }, {
          key: 'getLength',
          value: function getLength() {
            return this.scroll.length();
          }
        }, {
          key: 'getLeaf',
          value: function getLeaf(index) {
            return this.scroll.leaf(index);
          }
        }, {
          key: 'getLine',
          value: function getLine(index) {
            return this.scroll.line(index);
          }
        }, {
          key: 'getLines',
          value: function getLines() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

            if (typeof index !== 'number') {
              return this.scroll.lines(index.index, index.length);
            } else {
              return this.scroll.lines(index, length);
            }
          }
        }, {
          key: 'getModule',
          value: function getModule(name) {
            return this.theme.modules[name];
          }
        }, {
          key: 'getSelection',
          value: function getSelection() {
            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (focus) this.focus();
            this.update(); // Make sure we access getRange with editor in consistent state
            return this.selection.getRange()[0];
          }
        }, {
          key: 'getText',
          value: function getText() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

            var _overload9 = overload(index, length);

            var _overload10 = _slicedToArray(_overload9, 2);

            index = _overload10[0];
            length = _overload10[1];

            return this.editor.getText(index, length);
          }
        }, {
          key: 'hasFocus',
          value: function hasFocus() {
            return this.selection.hasFocus();
          }
        }, {
          key: 'insertEmbed',
          value: function insertEmbed(index, embed, value) {
            var _this7 = this;

            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

            return modify.call(this, function () {
              return _this7.editor.insertEmbed(index, embed, value);
            }, source, index);
          }
        }, {
          key: 'insertText',
          value: function insertText(index, text, name, value, source) {
            var _this8 = this;

            var formats = void 0;

            var _overload11 = overload(index, 0, name, value, source);

            var _overload12 = _slicedToArray(_overload11, 4);

            index = _overload12[0];
            formats = _overload12[2];
            source = _overload12[3];

            return modify.call(this, function () {
              return _this8.editor.insertText(index, text, formats);
            }, source, index, text.length);
          }
        }, {
          key: 'isEnabled',
          value: function isEnabled() {
            return !this.container.classList.contains('ql-disabled');
          }
        }, {
          key: 'off',
          value: function off() {
            return this.emitter.off.apply(this.emitter, arguments);
          }
        }, {
          key: 'on',
          value: function on() {
            return this.emitter.on.apply(this.emitter, arguments);
          }
        }, {
          key: 'once',
          value: function once() {
            return this.emitter.once.apply(this.emitter, arguments);
          }
        }, {
          key: 'pasteHTML',
          value: function pasteHTML(index, html, source) {
            this.clipboard.dangerouslyPasteHTML(index, html, source);
          }
        }, {
          key: 'removeFormat',
          value: function removeFormat(index, length, source) {
            var _this9 = this;

            var _overload13 = overload(index, length, source);

            var _overload14 = _slicedToArray(_overload13, 4);

            index = _overload14[0];
            length = _overload14[1];
            source = _overload14[3];

            return modify.call(this, function () {
              return _this9.editor.removeFormat(index, length);
            }, source, index);
          }
        }, {
          key: 'scrollIntoView',
          value: function scrollIntoView() {
            this.selection.scrollIntoView(this.scrollingContainer);
          }
        }, {
          key: 'setContents',
          value: function setContents(delta) {
            var _this10 = this;

            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);
              var length = _this10.getLength();
              var deleted = _this10.editor.deleteText(0, length);
              var applied = _this10.editor.applyDelta(delta);
              var lastOp = applied.ops[applied.ops.length - 1];
              if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                _this10.editor.deleteText(_this10.getLength() - 1, 1);
                applied.delete(1);
              }
              var ret = deleted.compose(applied);
              return ret;
            }, source);
          }
        }, {
          key: 'setSelection',
          value: function setSelection(index, length, source) {
            if (index == null) {
              this.selection.setRange(null, length || Quill.sources.API);
            } else {
              var _overload15 = overload(index, length, source);

              var _overload16 = _slicedToArray(_overload15, 4);

              index = _overload16[0];
              length = _overload16[1];
              source = _overload16[3];

              this.selection.setRange(new _selection.Range(index, length), source);
              if (source !== _emitter4.default.sources.SILENT) {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }
          }
        }, {
          key: 'setText',
          value: function setText(text) {
            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            var delta = new _quillDelta2.default().insert(text);
            return this.setContents(delta, source);
          }
        }, {
          key: 'update',
          value: function update() {
            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
            this.selection.update(source);
            return change;
          }
        }, {
          key: 'updateContents',
          value: function updateContents(delta) {
            var _this11 = this;

            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);
              return _this11.editor.applyDelta(delta, source);
            }, source, true);
          }
        }]);

        return Quill;
      }();

      Quill.DEFAULTS = {
        bounds: null,
        formats: null,
        modules: {},
        placeholder: '',
        readOnly: false,
        scrollingContainer: null,
        strict: true,
        theme: 'default'
      };
      Quill.events = _emitter4.default.events;
      Quill.sources = _emitter4.default.sources;
      // eslint-disable-next-line no-undef
      Quill.version = false ? 'dev' : "1.3.4";

      Quill.imports = {
        'delta': _quillDelta2.default,
        'parchment': _parchment2.default,
        'core/module': _module2.default,
        'core/theme': _theme2.default
      };

      function expandConfig(container, userConfig) {
        userConfig = (0, _extend2.default)(true, {
          container: container,
          modules: {
            clipboard: true,
            keyboard: true,
            history: true
          }
        }, userConfig);
        if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
          userConfig.theme = _theme2.default;
        } else {
          userConfig.theme = Quill.import('themes/' + userConfig.theme);
          if (userConfig.theme == null) {
            throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
          }
        }
        var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
        [themeConfig, userConfig].forEach(function (config) {
          config.modules = config.modules || {};
          Object.keys(config.modules).forEach(function (module) {
            if (config.modules[module] === true) {
              config.modules[module] = {};
            }
          });
        });
        var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
        var moduleConfig = moduleNames.reduce(function (config, name) {
          var moduleClass = Quill.import('modules/' + name);
          if (moduleClass == null) {
            debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
          } else {
            config[name] = moduleClass.DEFAULTS || {};
          }
          return config;
        }, {});
        // Special case toolbar shorthand
        if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
          userConfig.modules.toolbar = {
            container: userConfig.modules.toolbar
          };
        }
        userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
        ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
          if (typeof userConfig[key] === 'string') {
            userConfig[key] = document.querySelector(userConfig[key]);
          }
        });
        userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
          if (userConfig.modules[name]) {
            config[name] = userConfig.modules[name];
          }
          return config;
        }, {});
        return userConfig;
      }

      // Handle selection preservation and TEXT_CHANGE emission
      // common to modification APIs
      function modify(modifier, source, index, shift) {
        if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
          return new _quillDelta2.default();
        }
        var range = index == null ? null : this.getSelection();
        var oldDelta = this.editor.delta;
        var change = modifier();
        if (range != null) {
          if (index === true) index = range.index;
          if (shift == null) {
            range = shiftRange(range, change, source);
          } else if (shift !== 0) {
            range = shiftRange(range, index, shift, source);
          }
          this.setSelection(range, _emitter4.default.sources.SILENT);
        }
        if (change.length() > 0) {
          var _emitter;

          var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
          (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
          if (source !== _emitter4.default.sources.SILENT) {
            var _emitter2;

            (_emitter2 = this.emitter).emit.apply(_emitter2, args);
          }
        }
        return change;
      }

      function overload(index, length, name, value, source) {
        var formats = {};
        if (typeof index.index === 'number' && typeof index.length === 'number') {
          // Allow for throwaway end (used by insertText/insertEmbed)
          if (typeof length !== 'number') {
            source = value, value = name, name = length, length = index.length, index = index.index;
          } else {
            length = index.length, index = index.index;
          }
        } else if (typeof length !== 'number') {
          source = value, value = name, name = length, length = 0;
        }
        // Handle format being object, two format name/value strings or excluded
        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
          formats = name;
          source = value;
        } else if (typeof name === 'string') {
          if (value != null) {
            formats[name] = value;
          } else {
            source = name;
          }
        }
        // Handle optional source
        source = source || _emitter4.default.sources.API;
        return [index, length, formats, source];
      }

      function shiftRange(range, index, length, source) {
        if (range == null) return null;
        var start = void 0,
            end = void 0;
        if (index instanceof _quillDelta2.default) {
          var _map = [range.index, range.index + range.length].map(function (pos) {
            return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
          });

          var _map2 = _slicedToArray(_map, 2);

          start = _map2[0];
          end = _map2[1];
        } else {
          var _map3 = [range.index, range.index + range.length].map(function (pos) {
            if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
            if (length >= 0) {
              return pos + length;
            } else {
              return Math.max(index, pos + length);
            }
          });

          var _map4 = _slicedToArray(_map3, 2);

          start = _map4[0];
          end = _map4[1];
        }
        return new _selection.Range(start, end - start);
      }

      exports.expandConfig = expandConfig;
      exports.overload = overload;
      exports.default = Quill;

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Inline = function (_Parchment$Inline) {
        _inherits(Inline, _Parchment$Inline);

        function Inline() {
          _classCallCheck(this, Inline);

          return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
        }

        _createClass(Inline, [{
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
              var blot = this.isolate(index, length);
              if (value) {
                blot.wrap(name, value);
              }
            } else {
              _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
              var parent = this.parent.isolate(this.offset(), this.length());
              this.moveChildren(parent);
              parent.wrap(this);
            }
          }
        }], [{
          key: 'compare',
          value: function compare(self, other) {
            var selfIndex = Inline.order.indexOf(self);
            var otherIndex = Inline.order.indexOf(other);
            if (selfIndex >= 0 || otherIndex >= 0) {
              return selfIndex - otherIndex;
            } else if (self === other) {
              return 0;
            } else if (self < other) {
              return -1;
            } else {
              return 1;
            }
          }
        }]);

        return Inline;
      }(_parchment2.default.Inline);

      Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
      // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
      Inline.order = ['cursor', 'inline', // Must be lower
      'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
      ];

      exports.default = Inline;

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TextBlot = function (_Parchment$Text) {
        _inherits(TextBlot, _Parchment$Text);

        function TextBlot() {
          _classCallCheck(this, TextBlot);

          return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
        }

        return TextBlot;
      }(_parchment2.default.Text);

      exports.default = TextBlot;

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _eventemitter = __webpack_require__(54);

      var _eventemitter2 = _interopRequireDefault(_eventemitter);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:events');

      var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

      EVENTS.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
            // TODO use WeakMap
            if (node.__quill && node.__quill.emitter) {
              var _node$__quill$emitter;

              (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
            }
          });
        });
      });

      var Emitter = function (_EventEmitter) {
        _inherits(Emitter, _EventEmitter);

        function Emitter() {
          _classCallCheck(this, Emitter);

          var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

          _this.listeners = {};
          _this.on('error', debug.error);
          return _this;
        }

        _createClass(Emitter, [{
          key: 'emit',
          value: function emit() {
            debug.log.apply(debug, arguments);
            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
          }
        }, {
          key: 'handleDOM',
          value: function handleDOM(event) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (this.listeners[event.type] || []).forEach(function (_ref) {
              var node = _ref.node,
                  handler = _ref.handler;

              if (event.target === node || node.contains(event.target)) {
                handler.apply(undefined, [event].concat(args));
              }
            });
          }
        }, {
          key: 'listenDOM',
          value: function listenDOM(eventName, node, handler) {
            if (!this.listeners[eventName]) {
              this.listeners[eventName] = [];
            }
            this.listeners[eventName].push({ node: node, handler: handler });
          }
        }]);

        return Emitter;
      }(_eventemitter2.default);

      Emitter.events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change'
      };
      Emitter.sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
      };

      exports.default = Emitter;

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Module = function Module(quill) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Module);

        this.quill = quill;
        this.options = options;
      };

      Module.DEFAULTS = {};

      exports.default = Module;

      /***/
    },
    /* 10 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var levels = ['error', 'warn', 'log', 'info'];
      var level = 'warn';

      function debug(method) {
        if (levels.indexOf(method) <= levels.indexOf(level)) {
          var _console;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
        }
      }

      function namespace(ns) {
        return levels.reduce(function (logger, method) {
          logger[method] = debug.bind(console, method, ns);
          return logger;
        }, {});
      }

      debug.level = namespace.level = function (newLevel) {
        level = newLevel;
      };

      exports.default = namespace;

      /***/
    },
    /* 11 */
    /***/function (module, exports, __webpack_require__) {

      var pSlice = Array.prototype.slice;
      var objectKeys = __webpack_require__(52);
      var isArguments = __webpack_require__(53);

      var deepEqual = module.exports = function (actual, expected, opts) {
        if (!opts) opts = {};
        // 7.1. All identical values are equivalent, as determined by ===.
        if (actual === expected) {
          return true;
        } else if (actual instanceof Date && expected instanceof Date) {
          return actual.getTime() === expected.getTime();

          // 7.3. Other pairs that do not both pass typeof value == 'object',
          // equivalence is determined by ==.
        } else if (!actual || !expected || (typeof actual === 'undefined' ? 'undefined' : _typeof2(actual)) != 'object' && (typeof expected === 'undefined' ? 'undefined' : _typeof2(expected)) != 'object') {
          return opts.strict ? actual === expected : actual == expected;

          // 7.4. For all other Object pairs, including Array objects, equivalence is
          // determined by having the same number of owned properties (as verified
          // with Object.prototype.hasOwnProperty.call), the same set of keys
          // (although not necessarily the same order), equivalent values for every
          // corresponding key, and an identical 'prototype' property. Note: this
          // accounts for both named and indexed properties on Arrays.
        } else {
          return objEquiv(actual, expected, opts);
        }
      };

      function isUndefinedOrNull(value) {
        return value === null || value === undefined;
      }

      function isBuffer(x) {
        if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof2(x)) !== 'object' || typeof x.length !== 'number') return false;
        if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
          return false;
        }
        if (x.length > 0 && typeof x[0] !== 'number') return false;
        return true;
      }

      function objEquiv(a, b, opts) {
        var i, key;
        if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
        // an identical 'prototype' property.
        if (a.prototype !== b.prototype) return false;
        //~~~I've managed to break Object.keys through screwy arguments passing.
        //   Converting to array solves the problem.
        if (isArguments(a)) {
          if (!isArguments(b)) {
            return false;
          }
          a = pSlice.call(a);
          b = pSlice.call(b);
          return deepEqual(a, b, opts);
        }
        if (isBuffer(a)) {
          if (!isBuffer(b)) {
            return false;
          }
          if (a.length !== b.length) return false;
          for (i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
          }
          return true;
        }
        try {
          var ka = objectKeys(a),
              kb = objectKeys(b);
        } catch (e) {
          //happens when one is a string literal and the other isn't
          return false;
        }
        // having the same number of owned properties (keys incorporates
        // hasOwnProperty)
        if (ka.length != kb.length) return false;
        //the same set of keys (although not necessarily the same order),
        ka.sort();
        kb.sort();
        //~~~cheap key test
        for (i = ka.length - 1; i >= 0; i--) {
          if (ka[i] != kb[i]) return false;
        }
        //equivalent values for every corresponding key, and
        //~~~possibly expensive deep test
        for (i = ka.length - 1; i >= 0; i--) {
          key = ka[i];
          if (!deepEqual(a[key], b[key], opts)) return false;
        }
        return (typeof a === 'undefined' ? 'undefined' : _typeof2(a)) === (typeof b === 'undefined' ? 'undefined' : _typeof2(b));
      }

      /***/
    },
    /* 12 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var Registry = __webpack_require__(1);
      var Attributor = /** @class */function () {
        function Attributor(attrName, keyName, options) {
          if (options === void 0) {
            options = {};
          }
          this.attrName = attrName;
          this.keyName = keyName;
          var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
          if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
          } else {
            this.scope = Registry.Scope.ATTRIBUTE;
          }
          if (options.whitelist != null) this.whitelist = options.whitelist;
        }
        Attributor.keys = function (node) {
          return [].map.call(node.attributes, function (item) {
            return item.name;
          });
        };
        Attributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          node.setAttribute(this.keyName, value);
          return true;
        };
        Attributor.prototype.canAdd = function (node, value) {
          var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
          if (match != null && (this.whitelist == null || this.whitelist.indexOf(value) > -1)) {
            return true;
          }
          return false;
        };
        Attributor.prototype.remove = function (node) {
          node.removeAttribute(this.keyName);
        };
        Attributor.prototype.value = function (node) {
          var value = node.getAttribute(this.keyName);
          return this.canAdd(node, value) ? value : '';
        };
        return Attributor;
      }();
      exports.default = Attributor;

      /***/
    },
    /* 13 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.Code = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Code = function (_Inline) {
        _inherits(Code, _Inline);

        function Code() {
          _classCallCheck(this, Code);

          return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
        }

        return Code;
      }(_inline2.default);

      Code.blotName = 'code';
      Code.tagName = 'CODE';

      var CodeBlock = function (_Block) {
        _inherits(CodeBlock, _Block);

        function CodeBlock() {
          _classCallCheck(this, CodeBlock);

          return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
        }

        _createClass(CodeBlock, [{
          key: 'delta',
          value: function delta() {
            var _this3 = this;

            var text = this.domNode.textContent;
            if (text.endsWith('\n')) {
              // Should always be true
              text = text.slice(0, -1);
            }
            return text.split('\n').reduce(function (delta, frag) {
              return delta.insert(frag).insert('\n', _this3.formats());
            }, new _quillDelta2.default());
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            if (name === this.statics.blotName && value) return;

            var _descendant = this.descendant(_text2.default, this.length() - 1),
                _descendant2 = _slicedToArray(_descendant, 1),
                text = _descendant2[0];

            if (text != null) {
              text.deleteAt(text.length() - 1, 1);
            }
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (length === 0) return;
            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
              return;
            }
            var nextNewline = this.newlineIndex(index);
            if (nextNewline < 0 || nextNewline >= index + length) return;
            var prevNewline = this.newlineIndex(index, true) + 1;
            var isolateLength = nextNewline - prevNewline + 1;
            var blot = this.isolate(prevNewline, isolateLength);
            var next = blot.next;
            blot.format(name, value);
            if (next instanceof CodeBlock) {
              next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
            }
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null) return;

            var _descendant3 = this.descendant(_text2.default, index),
                _descendant4 = _slicedToArray(_descendant3, 2),
                text = _descendant4[0],
                offset = _descendant4[1];

            text.insertAt(offset, value);
          }
        }, {
          key: 'length',
          value: function length() {
            var length = this.domNode.textContent.length;
            if (!this.domNode.textContent.endsWith('\n')) {
              return length + 1;
            }
            return length;
          }
        }, {
          key: 'newlineIndex',
          value: function newlineIndex(searchIndex) {
            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!reverse) {
              var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
              return offset > -1 ? searchIndex + offset : -1;
            } else {
              return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            if (!this.domNode.textContent.endsWith('\n')) {
              this.appendChild(_parchment2.default.create('text', '\n'));
            }
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
            var next = this.next;
            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
              next.optimize(context);
              next.moveChildren(this);
              next.remove();
            }
          }
        }, {
          key: 'replace',
          value: function replace(target) {
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
              var blot = _parchment2.default.find(node);
              if (blot == null) {
                node.parentNode.removeChild(node);
              } else if (blot instanceof _parchment2.default.Embed) {
                blot.remove();
              } else {
                blot.unwrap();
              }
            });
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
            domNode.setAttribute('spellcheck', false);
            return domNode;
          }
        }, {
          key: 'formats',
          value: function formats() {
            return true;
          }
        }]);

        return CodeBlock;
      }(_block2.default);

      CodeBlock.blotName = 'code-block';
      CodeBlock.tagName = 'PRE';
      CodeBlock.TAB = '  ';

      exports.Code = Code;
      exports.default = CodeBlock;

      /***/
    },
    /* 14 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _cursor = __webpack_require__(23);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var ASCII = /^[ -~]*$/;

      var Editor = function () {
        function Editor(scroll) {
          _classCallCheck(this, Editor);

          this.scroll = scroll;
          this.delta = this.getDelta();
        }

        _createClass(Editor, [{
          key: 'applyDelta',
          value: function applyDelta(delta) {
            var _this = this;

            var consumeNextNewline = false;
            this.scroll.update();
            var scrollLength = this.scroll.length();
            this.scroll.batchStart();
            delta = normalizeDelta(delta);
            delta.reduce(function (index, op) {
              var length = op.retain || op.delete || op.insert.length || 1;
              var attributes = op.attributes || {};
              if (op.insert != null) {
                if (typeof op.insert === 'string') {
                  var text = op.insert;
                  if (text.endsWith('\n') && consumeNextNewline) {
                    consumeNextNewline = false;
                    text = text.slice(0, -1);
                  }
                  if (index >= scrollLength && !text.endsWith('\n')) {
                    consumeNextNewline = true;
                  }
                  _this.scroll.insertAt(index, text);

                  var _scroll$line = _this.scroll.line(index),
                      _scroll$line2 = _slicedToArray(_scroll$line, 2),
                      line = _scroll$line2[0],
                      offset = _scroll$line2[1];

                  var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                  if (line instanceof _block2.default) {
                    var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                        _line$descendant2 = _slicedToArray(_line$descendant, 1),
                        leaf = _line$descendant2[0];

                    formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                  }
                  attributes = _op2.default.attributes.diff(formats, attributes) || {};
                } else if (_typeof(op.insert) === 'object') {
                  var key = Object.keys(op.insert)[0]; // There should only be one key
                  if (key == null) return index;
                  _this.scroll.insertAt(index, key, op.insert[key]);
                }
                scrollLength += length;
              }
              Object.keys(attributes).forEach(function (name) {
                _this.scroll.formatAt(index, length, name, attributes[name]);
              });
              return index + length;
            }, 0);
            delta.reduce(function (index, op) {
              if (typeof op.delete === 'number') {
                _this.scroll.deleteAt(index, op.delete);
                return index;
              }
              return index + (op.retain || op.insert.length || 1);
            }, 0);
            this.scroll.batchEnd();
            return this.update(delta);
          }
        }, {
          key: 'deleteText',
          value: function deleteText(index, length) {
            this.scroll.deleteAt(index, length);
            return this.update(new _quillDelta2.default().retain(index).delete(length));
          }
        }, {
          key: 'formatLine',
          value: function formatLine(index, length) {
            var _this2 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            this.scroll.update();
            Object.keys(formats).forEach(function (format) {
              if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
              var lines = _this2.scroll.lines(index, Math.max(length, 1));
              var lengthRemaining = length;
              lines.forEach(function (line) {
                var lineLength = line.length();
                if (!(line instanceof _code2.default)) {
                  line.format(format, formats[format]);
                } else {
                  var codeIndex = index - line.offset(_this2.scroll);
                  var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                  line.formatAt(codeIndex, codeLength, format, formats[format]);
                }
                lengthRemaining -= lineLength;
              });
            });
            this.scroll.optimize();
            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'formatText',
          value: function formatText(index, length) {
            var _this3 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            Object.keys(formats).forEach(function (format) {
              _this3.scroll.formatAt(index, length, format, formats[format]);
            });
            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'getContents',
          value: function getContents(index, length) {
            return this.delta.slice(index, index + length);
          }
        }, {
          key: 'getDelta',
          value: function getDelta() {
            return this.scroll.lines().reduce(function (delta, line) {
              return delta.concat(line.delta());
            }, new _quillDelta2.default());
          }
        }, {
          key: 'getFormat',
          value: function getFormat(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var lines = [],
                leaves = [];
            if (length === 0) {
              this.scroll.path(index).forEach(function (path) {
                var _path = _slicedToArray(path, 1),
                    blot = _path[0];

                if (blot instanceof _block2.default) {
                  lines.push(blot);
                } else if (blot instanceof _parchment2.default.Leaf) {
                  leaves.push(blot);
                }
              });
            } else {
              lines = this.scroll.lines(index, length);
              leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
            }
            var formatsArr = [lines, leaves].map(function (blots) {
              if (blots.length === 0) return {};
              var formats = (0, _block.bubbleFormats)(blots.shift());
              while (Object.keys(formats).length > 0) {
                var blot = blots.shift();
                if (blot == null) return formats;
                formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
              }
              return formats;
            });
            return _extend2.default.apply(_extend2.default, formatsArr);
          }
        }, {
          key: 'getText',
          value: function getText(index, length) {
            return this.getContents(index, length).filter(function (op) {
              return typeof op.insert === 'string';
            }).map(function (op) {
              return op.insert;
            }).join('');
          }
        }, {
          key: 'insertEmbed',
          value: function insertEmbed(index, embed, value) {
            this.scroll.insertAt(index, embed, value);
            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
          }
        }, {
          key: 'insertText',
          value: function insertText(index, text) {
            var _this4 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            this.scroll.insertAt(index, text);
            Object.keys(formats).forEach(function (format) {
              _this4.scroll.formatAt(index, text.length, format, formats[format]);
            });
            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'isBlank',
          value: function isBlank() {
            if (this.scroll.children.length == 0) return true;
            if (this.scroll.children.length > 1) return false;
            var block = this.scroll.children.head;
            if (block.statics.blotName !== _block2.default.blotName) return false;
            if (block.children.length > 1) return false;
            return block.children.head instanceof _break2.default;
          }
        }, {
          key: 'removeFormat',
          value: function removeFormat(index, length) {
            var text = this.getText(index, length);

            var _scroll$line3 = this.scroll.line(index + length),
                _scroll$line4 = _slicedToArray(_scroll$line3, 2),
                line = _scroll$line4[0],
                offset = _scroll$line4[1];

            var suffixLength = 0,
                suffix = new _quillDelta2.default();
            if (line != null) {
              if (!(line instanceof _code2.default)) {
                suffixLength = line.length() - offset;
              } else {
                suffixLength = line.newlineIndex(offset) - offset + 1;
              }
              suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
            }
            var contents = this.getContents(index, length + suffixLength);
            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
            var delta = new _quillDelta2.default().retain(index).concat(diff);
            return this.applyDelta(delta);
          }
        }, {
          key: 'update',
          value: function update(change) {
            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            var oldDelta = this.delta;
            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
              // Optimization for character changes
              var textBlot = _parchment2.default.find(mutations[0].target);
              var formats = (0, _block.bubbleFormats)(textBlot);
              var index = textBlot.offset(this.scroll);
              var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
              var oldText = new _quillDelta2.default().insert(oldValue);
              var newText = new _quillDelta2.default().insert(textBlot.value());
              var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
              change = diffDelta.reduce(function (delta, op) {
                if (op.insert) {
                  return delta.insert(op.insert, formats);
                } else {
                  return delta.push(op);
                }
              }, new _quillDelta2.default());
              this.delta = oldDelta.compose(change);
            } else {
              this.delta = this.getDelta();
              if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                change = oldDelta.diff(this.delta, cursorIndex);
              }
            }
            return change;
          }
        }]);

        return Editor;
      }();

      function combineFormats(formats, combined) {
        return Object.keys(combined).reduce(function (merged, name) {
          if (formats[name] == null) return merged;
          if (combined[name] === formats[name]) {
            merged[name] = combined[name];
          } else if (Array.isArray(combined[name])) {
            if (combined[name].indexOf(formats[name]) < 0) {
              merged[name] = combined[name].concat([formats[name]]);
            }
          } else {
            merged[name] = [combined[name], formats[name]];
          }
          return merged;
        }, {});
      }

      function normalizeDelta(delta) {
        return delta.reduce(function (delta, op) {
          if (op.insert === 1) {
            var attributes = (0, _clone2.default)(op.attributes);
            delete attributes['image'];
            return delta.insert({ image: op.attributes.image }, attributes);
          }
          if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
            op = (0, _clone2.default)(op);
            if (op.attributes.list) {
              op.attributes.list = 'ordered';
            } else {
              op.attributes.list = 'bullet';
              delete op.attributes.bullet;
            }
          }
          if (typeof op.insert === 'string') {
            var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return delta.insert(text, op.attributes);
          }
          return delta.push(op);
        }, new _quillDelta2.default());
      }

      exports.default = Editor;

      /***/
    },
    /* 15 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.Range = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }return arr2;
        } else {
          return Array.from(arr);
        }
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)('quill:selection');

      var Range = function Range(index) {
        var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, Range);

        this.index = index;
        this.length = length;
      };

      var Selection = function () {
        function Selection(scroll, emitter) {
          var _this = this;

          _classCallCheck(this, Selection);

          this.emitter = emitter;
          this.scroll = scroll;
          this.composing = false;
          this.mouseDown = false;
          this.root = this.scroll.domNode;
          this.cursor = _parchment2.default.create('cursor', this);
          // savedRange is last non-null range
          this.lastRange = this.savedRange = new Range(0, 0);
          this.handleComposition();
          this.handleDragging();
          this.emitter.listenDOM('selectionchange', document, function () {
            if (!_this.mouseDown) {
              setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
            }
          });
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
            if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
              _this.update(_emitter4.default.sources.SILENT);
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
            if (!_this.hasFocus()) return;
            var native = _this.getNativeRange();
            if (native == null) return;
            if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
            // TODO unclear if this has negative side effects
            _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
              try {
                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
              } catch (ignored) {}
            });
          });
          this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
            if (context.range) {
              var _context$range = context.range,
                  startNode = _context$range.startNode,
                  startOffset = _context$range.startOffset,
                  endNode = _context$range.endNode,
                  endOffset = _context$range.endOffset;

              _this.setNativeRange(startNode, startOffset, endNode, endOffset);
            }
          });
          this.update(_emitter4.default.sources.SILENT);
        }

        _createClass(Selection, [{
          key: 'handleComposition',
          value: function handleComposition() {
            var _this2 = this;

            this.root.addEventListener('compositionstart', function () {
              _this2.composing = true;
            });
            this.root.addEventListener('compositionend', function () {
              _this2.composing = false;
              if (_this2.cursor.parent) {
                var range = _this2.cursor.restore();
                if (!range) return;
                setTimeout(function () {
                  _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
              }
            });
          }
        }, {
          key: 'handleDragging',
          value: function handleDragging() {
            var _this3 = this;

            this.emitter.listenDOM('mousedown', document.body, function () {
              _this3.mouseDown = true;
            });
            this.emitter.listenDOM('mouseup', document.body, function () {
              _this3.mouseDown = false;
              _this3.update(_emitter4.default.sources.USER);
            });
          }
        }, {
          key: 'focus',
          value: function focus() {
            if (this.hasFocus()) return;
            this.root.focus();
            this.setRange(this.savedRange);
          }
        }, {
          key: 'format',
          value: function format(_format, value) {
            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
            this.scroll.update();
            var nativeRange = this.getNativeRange();
            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
            if (nativeRange.start.node !== this.cursor.textNode) {
              var blot = _parchment2.default.find(nativeRange.start.node, false);
              if (blot == null) return;
              // TODO Give blot ability to not split
              if (blot instanceof _parchment2.default.Leaf) {
                var after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
              } else {
                blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
              }
              this.cursor.attach();
            }
            this.cursor.format(_format, value);
            this.scroll.optimize();
            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
            this.update();
          }
        }, {
          key: 'getBounds',
          value: function getBounds(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var scrollLength = this.scroll.length();
            index = Math.min(index, scrollLength - 1);
            length = Math.min(index + length, scrollLength - 1) - index;
            var node = void 0,
                _scroll$leaf = this.scroll.leaf(index),
                _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
                leaf = _scroll$leaf2[0],
                offset = _scroll$leaf2[1];
            if (leaf == null) return null;

            var _leaf$position = leaf.position(offset, true);

            var _leaf$position2 = _slicedToArray(_leaf$position, 2);

            node = _leaf$position2[0];
            offset = _leaf$position2[1];

            var range = document.createRange();
            if (length > 0) {
              range.setStart(node, offset);

              var _scroll$leaf3 = this.scroll.leaf(index + length);

              var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

              leaf = _scroll$leaf4[0];
              offset = _scroll$leaf4[1];

              if (leaf == null) return null;

              var _leaf$position3 = leaf.position(offset, true);

              var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

              node = _leaf$position4[0];
              offset = _leaf$position4[1];

              range.setEnd(node, offset);
              return range.getBoundingClientRect();
            } else {
              var side = 'left';
              var rect = void 0;
              if (node instanceof Text) {
                if (offset < node.data.length) {
                  range.setStart(node, offset);
                  range.setEnd(node, offset + 1);
                } else {
                  range.setStart(node, offset - 1);
                  range.setEnd(node, offset);
                  side = 'right';
                }
                rect = range.getBoundingClientRect();
              } else {
                rect = leaf.domNode.getBoundingClientRect();
                if (offset > 0) side = 'right';
              }
              return {
                bottom: rect.top + rect.height,
                height: rect.height,
                left: rect[side],
                right: rect[side],
                top: rect.top,
                width: 0
              };
            }
          }
        }, {
          key: 'getNativeRange',
          value: function getNativeRange() {
            var selection = document.getSelection();
            if (selection == null || selection.rangeCount <= 0) return null;
            var nativeRange = selection.getRangeAt(0);
            if (nativeRange == null) return null;
            var range = this.normalizeNative(nativeRange);
            debug.info('getNativeRange', range);
            return range;
          }
        }, {
          key: 'getRange',
          value: function getRange() {
            var normalized = this.getNativeRange();
            if (normalized == null) return [null, null];
            var range = this.normalizedToRange(normalized);
            return [range, normalized];
          }
        }, {
          key: 'hasFocus',
          value: function hasFocus() {
            return document.activeElement === this.root;
          }
        }, {
          key: 'normalizedToRange',
          value: function normalizedToRange(range) {
            var _this4 = this;

            var positions = [[range.start.node, range.start.offset]];
            if (!range.native.collapsed) {
              positions.push([range.end.node, range.end.offset]);
            }
            var indexes = positions.map(function (position) {
              var _position = _slicedToArray(position, 2),
                  node = _position[0],
                  offset = _position[1];

              var blot = _parchment2.default.find(node, true);
              var index = blot.offset(_this4.scroll);
              if (offset === 0) {
                return index;
              } else if (blot instanceof _parchment2.default.Container) {
                return index + blot.length();
              } else {
                return index + blot.index(node, offset);
              }
            });
            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
            var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
            return new Range(start, end - start);
          }
        }, {
          key: 'normalizeNative',
          value: function normalizeNative(nativeRange) {
            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
              return null;
            }
            var range = {
              start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
              end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
              native: nativeRange
            };
            [range.start, range.end].forEach(function (position) {
              var node = position.node,
                  offset = position.offset;
              while (!(node instanceof Text) && node.childNodes.length > 0) {
                if (node.childNodes.length > offset) {
                  node = node.childNodes[offset];
                  offset = 0;
                } else if (node.childNodes.length === offset) {
                  node = node.lastChild;
                  offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                } else {
                  break;
                }
              }
              position.node = node, position.offset = offset;
            });
            return range;
          }
        }, {
          key: 'rangeToNative',
          value: function rangeToNative(range) {
            var _this5 = this;

            var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
            var args = [];
            var scrollLength = this.scroll.length();
            indexes.forEach(function (index, i) {
              index = Math.min(scrollLength - 1, index);
              var node = void 0,
                  _scroll$leaf5 = _this5.scroll.leaf(index),
                  _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
                  leaf = _scroll$leaf6[0],
                  offset = _scroll$leaf6[1];
              var _leaf$position5 = leaf.position(offset, i !== 0);

              var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

              node = _leaf$position6[0];
              offset = _leaf$position6[1];

              args.push(node, offset);
            });
            if (args.length < 2) {
              args = args.concat(args);
            }
            return args;
          }
        }, {
          key: 'scrollIntoView',
          value: function scrollIntoView(scrollingContainer) {
            var range = this.lastRange;
            if (range == null) return;
            var bounds = this.getBounds(range.index, range.length);
            if (bounds == null) return;
            var limit = this.scroll.length() - 1;

            var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
                _scroll$line2 = _slicedToArray(_scroll$line, 1),
                first = _scroll$line2[0];

            var last = first;
            if (range.length > 0) {
              var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

              var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

              last = _scroll$line4[0];
            }
            if (first == null || last == null) return;
            var scrollBounds = scrollingContainer.getBoundingClientRect();
            if (bounds.top < scrollBounds.top) {
              scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
            } else if (bounds.bottom > scrollBounds.bottom) {
              scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
            }
          }
        }, {
          key: 'setNativeRange',
          value: function setNativeRange(startNode, startOffset) {
            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
              return;
            }
            var selection = document.getSelection();
            if (selection == null) return;
            if (startNode != null) {
              if (!this.hasFocus()) this.root.focus();
              var native = (this.getNativeRange() || {}).native;
              if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

                if (startNode.tagName == "BR") {
                  startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                  startNode = startNode.parentNode;
                }
                if (endNode.tagName == "BR") {
                  endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                  endNode = endNode.parentNode;
                }
                var range = document.createRange();
                range.setStart(startNode, startOffset);
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
              }
            } else {
              selection.removeAllRanges();
              this.root.blur();
              document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
            }
          }
        }, {
          key: 'setRange',
          value: function setRange(range) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

            if (typeof force === 'string') {
              source = force;
              force = false;
            }
            debug.info('setRange', range);
            if (range != null) {
              var args = this.rangeToNative(range);
              this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
            } else {
              this.setNativeRange(null);
            }
            this.update(source);
          }
        }, {
          key: 'update',
          value: function update() {
            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

            var oldRange = this.lastRange;

            var _getRange = this.getRange(),
                _getRange2 = _slicedToArray(_getRange, 2),
                lastRange = _getRange2[0],
                nativeRange = _getRange2[1];

            this.lastRange = lastRange;
            if (this.lastRange != null) {
              this.savedRange = this.lastRange;
            }
            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
              var _emitter;

              if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                this.cursor.restore();
              }
              var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
              (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
              if (source !== _emitter4.default.sources.SILENT) {
                var _emitter2;

                (_emitter2 = this.emitter).emit.apply(_emitter2, args);
              }
            }
          }
        }]);

        return Selection;
      }();

      function contains(parent, descendant) {
        try {
          // Firefox inserts inaccessible nodes around video elements
          descendant.parentNode;
        } catch (e) {
          return false;
        }
        // IE11 has bug with Text nodes
        // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
        if (descendant instanceof Text) {
          descendant = descendant.parentNode;
        }
        return parent.contains(descendant);
      }

      exports.Range = Range;
      exports.default = Selection;

      /***/
    },
    /* 16 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Break = function (_Parchment$Embed) {
        _inherits(Break, _Parchment$Embed);

        function Break() {
          _classCallCheck(this, Break);

          return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
        }

        _createClass(Break, [{
          key: 'insertInto',
          value: function insertInto(parent, ref) {
            if (parent.children.length === 0) {
              _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
            } else {
              this.remove();
            }
          }
        }, {
          key: 'length',
          value: function length() {
            return 0;
          }
        }, {
          key: 'value',
          value: function value() {
            return '';
          }
        }], [{
          key: 'value',
          value: function value() {
            return undefined;
          }
        }]);

        return Break;
      }(_parchment2.default.Embed);

      Break.blotName = 'break';
      Break.tagName = 'BR';

      exports.default = Break;

      /***/
    },
    /* 17 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var linked_list_1 = __webpack_require__(44);
      var shadow_1 = __webpack_require__(30);
      var Registry = __webpack_require__(1);
      var ContainerBlot = /** @class */function (_super) {
        __extends(ContainerBlot, _super);
        function ContainerBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        ContainerBlot.prototype.appendChild = function (other) {
          this.insertBefore(other);
        };
        ContainerBlot.prototype.attach = function () {
          var _this = this;
          _super.prototype.attach.call(this);
          this.children = new linked_list_1.default();
          // Need to be reversed for if DOM nodes already in order
          [].slice.call(this.domNode.childNodes).reverse().forEach(function (node) {
            try {
              var child = makeBlot(node);
              _this.insertBefore(child, _this.children.head);
            } catch (err) {
              if (err instanceof Registry.ParchmentError) return;else throw err;
            }
          });
        };
        ContainerBlot.prototype.deleteAt = function (index, length) {
          if (index === 0 && length === this.length()) {
            return this.remove();
          }
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
          });
        };
        ContainerBlot.prototype.descendant = function (criteria, index) {
          var _a = this.children.find(index),
              child = _a[0],
              offset = _a[1];
          if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
            return [child, offset];
          } else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
          } else {
            return [null, -1];
          }
        };
        ContainerBlot.prototype.descendants = function (criteria, index, length) {
          if (index === void 0) {
            index = 0;
          }
          if (length === void 0) {
            length = Number.MAX_VALUE;
          }
          var descendants = [],
              lengthLeft = length;
          this.children.forEachAt(index, length, function (child, index, length) {
            if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
              descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
              descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
          });
          return descendants;
        };
        ContainerBlot.prototype.detach = function () {
          this.children.forEach(function (child) {
            child.detach();
          });
          _super.prototype.detach.call(this);
        };
        ContainerBlot.prototype.formatAt = function (index, length, name, value) {
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
          });
        };
        ContainerBlot.prototype.insertAt = function (index, value, def) {
          var _a = this.children.find(index),
              child = _a[0],
              offset = _a[1];
          if (child) {
            child.insertAt(offset, value, def);
          } else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
          }
        };
        ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
          if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function (child) {
            return childBlot instanceof child;
          })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
          }
          childBlot.insertInto(this, refBlot);
        };
        ContainerBlot.prototype.length = function () {
          return this.children.reduce(function (memo, child) {
            return memo + child.length();
          }, 0);
        };
        ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
          this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
          });
        };
        ContainerBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
              var child = Registry.create(this.statics.defaultChild);
              this.appendChild(child);
              child.optimize(context);
            } else {
              this.remove();
            }
          }
        };
        ContainerBlot.prototype.path = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var _a = this.children.find(index, inclusive),
              child = _a[0],
              offset = _a[1];
          var position = [[this, index]];
          if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
          } else if (child != null) {
            position.push([child, offset]);
          }
          return position;
        };
        ContainerBlot.prototype.removeChild = function (child) {
          this.children.remove(child);
        };
        ContainerBlot.prototype.replace = function (target) {
          if (target instanceof ContainerBlot) {
            target.moveChildren(this);
          }
          _super.prototype.replace.call(this, target);
        };
        ContainerBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = this.clone();
          this.parent.insertBefore(after, this.next);
          this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
          });
          return after;
        };
        ContainerBlot.prototype.unwrap = function () {
          this.moveChildren(this.parent, this.next);
          this.remove();
        };
        ContainerBlot.prototype.update = function (mutations, context) {
          var _this = this;
          var addedNodes = [],
              removedNodes = [];
          mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
              addedNodes.push.apply(addedNodes, mutation.addedNodes);
              removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
          });
          removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null && node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
              return;
            }
            var blot = Registry.find(node);
            if (blot == null) return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
              blot.detach();
            }
          });
          addedNodes.filter(function (node) {
            return node.parentNode == _this.domNode;
          }).sort(function (a, b) {
            if (a === b) return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
              return 1;
            }
            return -1;
          }).forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
              refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
              if (blot.parent != null) {
                blot.parent.removeChild(_this);
              }
              _this.insertBefore(blot, refBlot);
            }
          });
        };
        return ContainerBlot;
      }(shadow_1.default);
      function makeBlot(node) {
        var blot = Registry.find(node);
        if (blot == null) {
          try {
            blot = Registry.create(node);
          } catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
              blot.domNode.appendChild(child);
            });
            node.parentNode.replaceChild(blot.domNode, node);
            blot.attach();
          }
        }
        return blot;
      }
      exports.default = ContainerBlot;

      /***/
    },
    /* 18 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      var store_1 = __webpack_require__(31);
      var container_1 = __webpack_require__(17);
      var Registry = __webpack_require__(1);
      var FormatBlot = /** @class */function (_super) {
        __extends(FormatBlot, _super);
        function FormatBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        FormatBlot.formats = function (domNode) {
          if (typeof this.tagName === 'string') {
            return true;
          } else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
          }
          return undefined;
        };
        FormatBlot.prototype.attach = function () {
          _super.prototype.attach.call(this);
          this.attributes = new store_1.default(this.domNode);
        };
        FormatBlot.prototype.format = function (name, value) {
          var format = Registry.query(name);
          if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
          } else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
              this.replaceWith(name, value);
            }
          }
        };
        FormatBlot.prototype.formats = function () {
          var formats = this.attributes.values();
          var format = this.statics.formats(this.domNode);
          if (format != null) {
            formats[this.statics.blotName] = format;
          }
          return formats;
        };
        FormatBlot.prototype.replaceWith = function (name, value) {
          var replacement = _super.prototype.replaceWith.call(this, name, value);
          this.attributes.copy(replacement);
          return replacement;
        };
        FormatBlot.prototype.update = function (mutations, context) {
          var _this = this;
          _super.prototype.update.call(this, mutations, context);
          if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
          })) {
            this.attributes.build();
          }
        };
        FormatBlot.prototype.wrap = function (name, value) {
          var wrapper = _super.prototype.wrap.call(this, name, value);
          if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
          }
          return wrapper;
        };
        return FormatBlot;
      }(container_1.default);
      exports.default = FormatBlot;

      /***/
    },
    /* 19 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var shadow_1 = __webpack_require__(30);
      var Registry = __webpack_require__(1);
      var LeafBlot = /** @class */function (_super) {
        __extends(LeafBlot, _super);
        function LeafBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        LeafBlot.value = function (domNode) {
          return true;
        };
        LeafBlot.prototype.index = function (node, offset) {
          if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
          }
          return -1;
        };
        LeafBlot.prototype.position = function (index, inclusive) {
          var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
          if (index > 0) offset += 1;
          return [this.parent.domNode, offset];
        };
        LeafBlot.prototype.value = function () {
          return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
          var _a;
        };
        LeafBlot.scope = Registry.Scope.INLINE_BLOT;
        return LeafBlot;
      }(shadow_1.default);
      exports.default = LeafBlot;

      /***/
    },
    /* 20 */
    /***/function (module, exports, __webpack_require__) {

      var equal = __webpack_require__(11);
      var extend = __webpack_require__(3);

      var lib = {
        attributes: {
          compose: function compose(a, b, keepNull) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') a = {};
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') b = {};
            var attributes = extend(true, {}, b);
            if (!keepNull) {
              attributes = Object.keys(attributes).reduce(function (copy, key) {
                if (attributes[key] != null) {
                  copy[key] = attributes[key];
                }
                return copy;
              }, {});
            }
            for (var key in a) {
              if (a[key] !== undefined && b[key] === undefined) {
                attributes[key] = a[key];
              }
            }
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          },

          diff: function diff(a, b) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') a = {};
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') b = {};
            var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
              if (!equal(a[key], b[key])) {
                attributes[key] = b[key] === undefined ? null : b[key];
              }
              return attributes;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          },

          transform: function transform(a, b, priority) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') return b;
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') return undefined;
            if (!priority) return b; // b simply overwrites us without priority
            var attributes = Object.keys(b).reduce(function (attributes, key) {
              if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
              return attributes;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          }
        },

        iterator: function iterator(ops) {
          return new Iterator(ops);
        },

        length: function length(op) {
          if (typeof op['delete'] === 'number') {
            return op['delete'];
          } else if (typeof op.retain === 'number') {
            return op.retain;
          } else {
            return typeof op.insert === 'string' ? op.insert.length : 1;
          }
        }
      };

      function Iterator(ops) {
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
      };

      Iterator.prototype.hasNext = function () {
        return this.peekLength() < Infinity;
      };

      Iterator.prototype.next = function (length) {
        if (!length) length = Infinity;
        var nextOp = this.ops[this.index];
        if (nextOp) {
          var offset = this.offset;
          var opLength = lib.length(nextOp);
          if (length >= opLength - offset) {
            length = opLength - offset;
            this.index += 1;
            this.offset = 0;
          } else {
            this.offset += length;
          }
          if (typeof nextOp['delete'] === 'number') {
            return { 'delete': length };
          } else {
            var retOp = {};
            if (nextOp.attributes) {
              retOp.attributes = nextOp.attributes;
            }
            if (typeof nextOp.retain === 'number') {
              retOp.retain = length;
            } else if (typeof nextOp.insert === 'string') {
              retOp.insert = nextOp.insert.substr(offset, length);
            } else {
              // offset should === 0, length should === 1
              retOp.insert = nextOp.insert;
            }
            return retOp;
          }
        } else {
          return { retain: Infinity };
        }
      };

      Iterator.prototype.peek = function () {
        return this.ops[this.index];
      };

      Iterator.prototype.peekLength = function () {
        if (this.ops[this.index]) {
          // Should never return 0 if our index is being managed correctly
          return lib.length(this.ops[this.index]) - this.offset;
        } else {
          return Infinity;
        }
      };

      Iterator.prototype.peekType = function () {
        if (this.ops[this.index]) {
          if (typeof this.ops[this.index]['delete'] === 'number') {
            return 'delete';
          } else if (typeof this.ops[this.index].retain === 'number') {
            return 'retain';
          } else {
            return 'insert';
          }
        }
        return 'retain';
      };

      module.exports = lib;

      /***/
    },
    /* 21 */
    /***/function (module, exports) {

      var clone = function () {
        'use strict';

        function _instanceof(obj, type) {
          return type != null && obj instanceof type;
        }

        var nativeMap;
        try {
          nativeMap = Map;
        } catch (_) {
          // maybe a reference error because no `Map`. Give it a dummy value that no
          // value will ever be an instanceof.
          nativeMap = function nativeMap() {};
        }

        var nativeSet;
        try {
          nativeSet = Set;
        } catch (_) {
          nativeSet = function nativeSet() {};
        }

        var nativePromise;
        try {
          nativePromise = Promise;
        } catch (_) {
          nativePromise = function nativePromise() {};
        }

        /**
         * Clones (copies) an Object using deep copying.
         *
         * This function supports circular references by default, but if you are certain
         * there are no circular references in your object, you can save some CPU time
         * by calling clone(obj, false).
         *
         * Caution: if `circular` is false and `parent` contains circular references,
         * your program may enter an infinite loop and crash.
         *
         * @param `parent` - the object to be cloned
         * @param `circular` - set to true if the object to be cloned may contain
         *    circular references. (optional - true by default)
         * @param `depth` - set to a number if the object is only to be cloned to
         *    a particular depth. (optional - defaults to Infinity)
         * @param `prototype` - sets the prototype to be used when cloning an object.
         *    (optional - defaults to parent prototype).
         * @param `includeNonEnumerable` - set to true if the non-enumerable properties
         *    should be cloned as well. Non-enumerable properties on the prototype
         *    chain will be ignored. (optional - false by default)
        */
        function clone(parent, circular, depth, prototype, includeNonEnumerable) {
          if ((typeof circular === 'undefined' ? 'undefined' : _typeof2(circular)) === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
          }
          // maintain two arrays for circular references, where corresponding parents
          // and children have the same index
          var allParents = [];
          var allChildren = [];

          var useBuffer = typeof Buffer != 'undefined';

          if (typeof circular == 'undefined') circular = true;

          if (typeof depth == 'undefined') depth = Infinity;

          // recurse this function so we don't reset allParents and allChildren
          function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;

            if (depth === 0) return parent;

            var child;
            var proto;
            if ((typeof parent === 'undefined' ? 'undefined' : _typeof2(parent)) != 'object') {
              return parent;
            }

            if (_instanceof(parent, nativeMap)) {
              child = new nativeMap();
            } else if (_instanceof(parent, nativeSet)) {
              child = new nativeSet();
            } else if (_instanceof(parent, nativePromise)) {
              child = new nativePromise(function (resolve, reject) {
                parent.then(function (value) {
                  resolve(_clone(value, depth - 1));
                }, function (err) {
                  reject(_clone(err, depth - 1));
                });
              });
            } else if (clone.__isArray(parent)) {
              child = [];
            } else if (clone.__isRegExp(parent)) {
              child = new RegExp(parent.source, __getRegExpFlags(parent));
              if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) {
              child = new Date(parent.getTime());
            } else if (useBuffer && Buffer.isBuffer(parent)) {
              child = new Buffer(parent.length);
              parent.copy(child);
              return child;
            } else if (_instanceof(parent, Error)) {
              child = Object.create(parent);
            } else {
              if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
              } else {
                child = Object.create(prototype);
                proto = prototype;
              }
            }

            if (circular) {
              var index = allParents.indexOf(parent);

              if (index != -1) {
                return allChildren[index];
              }
              allParents.push(parent);
              allChildren.push(child);
            }

            if (_instanceof(parent, nativeMap)) {
              parent.forEach(function (value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
              });
            }
            if (_instanceof(parent, nativeSet)) {
              parent.forEach(function (value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
              });
            }

            for (var i in parent) {
              var attrs;
              if (proto) {
                attrs = Object.getOwnPropertyDescriptor(proto, i);
              }

              if (attrs && attrs.set == null) {
                continue;
              }
              child[i] = _clone(parent[i], depth - 1);
            }

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(parent);
              for (var i = 0; i < symbols.length; i++) {
                // Don't need to worry about cloning a symbol because it is a primitive,
                // like a number or string.
                var symbol = symbols[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                  continue;
                }
                child[symbol] = _clone(parent[symbol], depth - 1);
                if (!descriptor.enumerable) {
                  Object.defineProperty(child, symbol, {
                    enumerable: false
                  });
                }
              }
            }

            if (includeNonEnumerable) {
              var allPropertyNames = Object.getOwnPropertyNames(parent);
              for (var i = 0; i < allPropertyNames.length; i++) {
                var propertyName = allPropertyNames[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                if (descriptor && descriptor.enumerable) {
                  continue;
                }
                child[propertyName] = _clone(parent[propertyName], depth - 1);
                Object.defineProperty(child, propertyName, {
                  enumerable: false
                });
              }
            }

            return child;
          }

          return _clone(parent, depth);
        }

        /**
         * Simple flat clone using prototype, accepts only objects, usefull for property
         * override on FLAT configuration object (no nested props).
         *
         * USE WITH CAUTION! This may not behave as you wish if you do not know how this
         * works.
         */
        clone.clonePrototype = function clonePrototype(parent) {
          if (parent === null) return null;

          var c = function c() {};
          c.prototype = parent;
          return new c();
        };

        // private utility functions

        function __objToStr(o) {
          return Object.prototype.toString.call(o);
        }
        clone.__objToStr = __objToStr;

        function __isDate(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object Date]';
        }
        clone.__isDate = __isDate;

        function __isArray(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object Array]';
        }
        clone.__isArray = __isArray;

        function __isRegExp(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object RegExp]';
        }
        clone.__isRegExp = __isRegExp;

        function __getRegExpFlags(re) {
          var flags = '';
          if (re.global) flags += 'g';
          if (re.ignoreCase) flags += 'i';
          if (re.multiline) flags += 'm';
          return flags;
        }
        clone.__getRegExpFlags = __getRegExpFlags;

        return clone;
      }();

      if ((typeof module === 'undefined' ? 'undefined' : _typeof2(module)) === 'object' && module.exports) {
        module.exports = clone;
      }

      /***/
    },
    /* 22 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _container = __webpack_require__(24);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function isLine(blot) {
        return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
      }

      var Scroll = function (_Parchment$Scroll) {
        _inherits(Scroll, _Parchment$Scroll);

        function Scroll(domNode, config) {
          _classCallCheck(this, Scroll);

          var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

          _this.emitter = config.emitter;
          if (Array.isArray(config.whitelist)) {
            _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
              whitelist[format] = true;
              return whitelist;
            }, {});
          }
          // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
          _this.domNode.addEventListener('DOMNodeInserted', function () {});
          _this.optimize();
          _this.enable();
          return _this;
        }

        _createClass(Scroll, [{
          key: 'batchStart',
          value: function batchStart() {
            this.batch = true;
          }
        }, {
          key: 'batchEnd',
          value: function batchEnd() {
            this.batch = false;
            this.optimize();
          }
        }, {
          key: 'deleteAt',
          value: function deleteAt(index, length) {
            var _line = this.line(index),
                _line2 = _slicedToArray(_line, 2),
                first = _line2[0],
                offset = _line2[1];

            var _line3 = this.line(index + length),
                _line4 = _slicedToArray(_line3, 1),
                last = _line4[0];

            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
            if (last != null && first !== last && offset > 0) {
              if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                this.optimize();
                return;
              }
              if (first instanceof _code2.default) {
                var newlineIndex = first.newlineIndex(first.length(), true);
                if (newlineIndex > -1) {
                  first = first.split(newlineIndex + 1);
                  if (first === last) {
                    this.optimize();
                    return;
                  }
                }
              } else if (last instanceof _code2.default) {
                var _newlineIndex = last.newlineIndex(0);
                if (_newlineIndex > -1) {
                  last.split(_newlineIndex + 1);
                }
              }
              var ref = last.children.head instanceof _break2.default ? null : last.children.head;
              first.moveChildren(last, ref);
              first.remove();
            }
            this.optimize();
          }
        }, {
          key: 'enable',
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.domNode.setAttribute('contenteditable', enabled);
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, format, value) {
            if (this.whitelist != null && !this.whitelist[format]) return;
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
            this.optimize();
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
            if (index >= this.length()) {
              if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                var blot = _parchment2.default.create(this.statics.defaultChild);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) {
                  value = value.slice(0, -1);
                }
                blot.insertAt(0, value, def);
              } else {
                var embed = _parchment2.default.create(value, def);
                this.appendChild(embed);
              }
            } else {
              _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
            }
            this.optimize();
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
              var wrapper = _parchment2.default.create(this.statics.defaultChild);
              wrapper.appendChild(blot);
              blot = wrapper;
            }
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
          }
        }, {
          key: 'leaf',
          value: function leaf(index) {
            return this.path(index).pop() || [null, -1];
          }
        }, {
          key: 'line',
          value: function line(index) {
            if (index === this.length()) {
              return this.line(index - 1);
            }
            return this.descendant(isLine, index);
          }
        }, {
          key: 'lines',
          value: function lines() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

            var getLines = function getLines(blot, index, length) {
              var lines = [],
                  lengthLeft = length;
              blot.children.forEachAt(index, length, function (child, index, length) {
                if (isLine(child)) {
                  lines.push(child);
                } else if (child instanceof _parchment2.default.Container) {
                  lines = lines.concat(getLines(child, index, lengthLeft));
                }
                lengthLeft -= length;
              });
              return lines;
            };
            return getLines(this, index, length);
          }
        }, {
          key: 'optimize',
          value: function optimize() {
            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.batch === true) return;
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
            }
          }
        }, {
          key: 'path',
          value: function path(index) {
            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
          }
        }, {
          key: 'update',
          value: function update(mutations) {
            if (this.batch === true) return;
            var source = _emitter2.default.sources.USER;
            if (typeof mutations === 'string') {
              source = mutations;
            }
            if (!Array.isArray(mutations)) {
              mutations = this.observer.takeRecords();
            }
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
            }
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
            }
          }
        }]);

        return Scroll;
      }(_parchment2.default.Scroll);

      Scroll.blotName = 'scroll';
      Scroll.className = 'ql-editor';
      Scroll.tagName = 'DIV';
      Scroll.defaultChild = 'block';
      Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

      exports.default = Scroll;

      /***/
    },
    /* 23 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Cursor = function (_Parchment$Embed) {
        _inherits(Cursor, _Parchment$Embed);

        _createClass(Cursor, null, [{
          key: 'value',
          value: function value() {
            return undefined;
          }
        }]);

        function Cursor(domNode, selection) {
          _classCallCheck(this, Cursor);

          var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

          _this.selection = selection;
          _this.textNode = document.createTextNode(Cursor.CONTENTS);
          _this.domNode.appendChild(_this.textNode);
          _this._length = 0;
          return _this;
        }

        _createClass(Cursor, [{
          key: 'detach',
          value: function detach() {
            // super.detach() will also clear domNode.__blot
            if (this.parent != null) this.parent.removeChild(this);
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            if (this._length !== 0) {
              return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
            }
            var target = this,
                index = 0;
            while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
              index += target.offset(target.parent);
              target = target.parent;
            }
            if (target != null) {
              this._length = Cursor.CONTENTS.length;
              target.optimize();
              target.formatAt(index, Cursor.CONTENTS.length, name, value);
              this._length = 0;
            }
          }
        }, {
          key: 'index',
          value: function index(node, offset) {
            if (node === this.textNode) return 0;
            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
          }
        }, {
          key: 'length',
          value: function length() {
            return this._length;
          }
        }, {
          key: 'position',
          value: function position() {
            return [this.textNode, this.textNode.data.length];
          }
        }, {
          key: 'remove',
          value: function remove() {
            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
            this.parent = null;
          }
        }, {
          key: 'restore',
          value: function restore() {
            if (this.selection.composing || this.parent == null) return;
            var textNode = this.textNode;
            var range = this.selection.getNativeRange();
            var restoreText = void 0,
                start = void 0,
                end = void 0;
            if (range != null && range.start.node === textNode && range.end.node === textNode) {
              var _ref = [textNode, range.start.offset, range.end.offset];
              restoreText = _ref[0];
              start = _ref[1];
              end = _ref[2];
            }
            // Link format will insert text outside of anchor tag
            while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
              this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
            }
            if (this.textNode.data !== Cursor.CONTENTS) {
              var text = this.textNode.data.split(Cursor.CONTENTS).join('');
              if (this.next instanceof _text2.default) {
                restoreText = this.next.domNode;
                this.next.insertAt(0, text);
                this.textNode.data = Cursor.CONTENTS;
              } else {
                this.textNode.data = text;
                this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                this.textNode = document.createTextNode(Cursor.CONTENTS);
                this.domNode.appendChild(this.textNode);
              }
            }
            this.remove();
            if (start != null) {
              var _map = [start, end].map(function (offset) {
                return Math.max(0, Math.min(restoreText.data.length, offset - 1));
              });

              var _map2 = _slicedToArray(_map, 2);

              start = _map2[0];
              end = _map2[1];

              return {
                startNode: restoreText,
                startOffset: start,
                endNode: restoreText,
                endOffset: end
              };
            }
          }
        }, {
          key: 'update',
          value: function update(mutations, context) {
            var _this2 = this;

            if (mutations.some(function (mutation) {
              return mutation.type === 'characterData' && mutation.target === _this2.textNode;
            })) {
              var range = this.restore();
              if (range) context.range = range;
            }
          }
        }, {
          key: 'value',
          value: function value() {
            return '';
          }
        }]);

        return Cursor;
      }(_parchment2.default.Embed);

      Cursor.blotName = 'cursor';
      Cursor.className = 'ql-cursor';
      Cursor.tagName = 'span';
      Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


      exports.default = Cursor;

      /***/
    },
    /* 24 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Container = function (_Parchment$Container) {
        _inherits(Container, _Parchment$Container);

        function Container() {
          _classCallCheck(this, Container);

          return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
        }

        return Container;
      }(_parchment2.default.Container);

      Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

      exports.default = Container;

      /***/
    },
    /* 25 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var GUARD_TEXT = '\uFEFF';

      var Embed = function (_Parchment$Embed) {
        _inherits(Embed, _Parchment$Embed);

        function Embed(node) {
          _classCallCheck(this, Embed);

          var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

          _this.contentNode = document.createElement('span');
          _this.contentNode.setAttribute('contenteditable', false);
          [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
            _this.contentNode.appendChild(childNode);
          });
          _this.leftGuard = document.createTextNode(GUARD_TEXT);
          _this.rightGuard = document.createTextNode(GUARD_TEXT);
          _this.domNode.appendChild(_this.leftGuard);
          _this.domNode.appendChild(_this.contentNode);
          _this.domNode.appendChild(_this.rightGuard);
          return _this;
        }

        _createClass(Embed, [{
          key: 'index',
          value: function index(node, offset) {
            if (node === this.leftGuard) return 0;
            if (node === this.rightGuard) return 1;
            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
          }
        }, {
          key: 'restore',
          value: function restore(node) {
            var range = void 0,
                textNode = void 0;
            var text = node.data.split(GUARD_TEXT).join('');
            if (node === this.leftGuard) {
              if (this.prev instanceof _text2.default) {
                var prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                  startNode: this.prev.domNode,
                  startOffset: prevLength + text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this);
                range = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            } else if (node === this.rightGuard) {
              if (this.next instanceof _text2.default) {
                this.next.insertAt(0, text);
                range = {
                  startNode: this.next.domNode,
                  startOffset: text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                range = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            }
            node.data = GUARD_TEXT;
            return range;
          }
        }, {
          key: 'update',
          value: function update(mutations, context) {
            var _this2 = this;

            mutations.forEach(function (mutation) {
              if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                var range = _this2.restore(mutation.target);
                if (range) context.range = range;
              }
            });
          }
        }]);

        return Embed;
      }(_parchment2.default.Embed);

      exports.default = Embed;

      /***/
    },
    /* 26 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorAttributor = function (_Parchment$Attributor) {
        _inherits(ColorAttributor, _Parchment$Attributor);

        function ColorAttributor() {
          _classCallCheck(this, ColorAttributor);

          return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
        }

        _createClass(ColorAttributor, [{
          key: 'value',
          value: function value(domNode) {
            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
            if (!value.startsWith('rgb(')) return value;
            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
            return '#' + value.split(',').map(function (component) {
              return ('00' + parseInt(component).toString(16)).slice(-2);
            }).join('');
          }
        }]);

        return ColorAttributor;
      }(_parchment2.default.Attributor.Style);

      var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
        scope: _parchment2.default.Scope.INLINE
      });
      var ColorStyle = new ColorAttributor('color', 'color', {
        scope: _parchment2.default.Scope.INLINE
      });

      exports.ColorAttributor = ColorAttributor;
      exports.ColorClass = ColorClass;
      exports.ColorStyle = ColorStyle;

      /***/
    },
    /* 27 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sanitize = exports.default = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Link = function (_Inline) {
        _inherits(Link, _Inline);

        function Link() {
          _classCallCheck(this, Link);

          return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
        }

        _createClass(Link, [{
          key: 'format',
          value: function format(name, value) {
            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
            value = this.constructor.sanitize(value);
            this.domNode.setAttribute('href', value);
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
            value = this.sanitize(value);
            node.setAttribute('href', value);
            node.setAttribute('target', '_blank');
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return domNode.getAttribute('href');
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
          }
        }]);

        return Link;
      }(_inline2.default);

      Link.blotName = 'link';
      Link.tagName = 'A';
      Link.SANITIZED_URL = 'about:blank';
      Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

      function _sanitize(url, protocols) {
        var anchor = document.createElement('a');
        anchor.href = url;
        var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
        return protocols.indexOf(protocol) > -1;
      }

      exports.default = Link;
      exports.sanitize = _sanitize;

      /***/
    },
    /* 28 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _dropdown = __webpack_require__(107);

      var _dropdown2 = _interopRequireDefault(_dropdown);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Picker = function () {
        function Picker(select) {
          var _this = this;

          _classCallCheck(this, Picker);

          this.select = select;
          this.container = document.createElement('span');
          this.buildPicker();
          this.select.style.display = 'none';
          this.select.parentNode.insertBefore(this.container, this.select);
          this.label.addEventListener('mousedown', function () {
            _this.container.classList.toggle('ql-expanded');
          });
          this.select.addEventListener('change', this.update.bind(this));
        }

        _createClass(Picker, [{
          key: 'buildItem',
          value: function buildItem(option) {
            var _this2 = this;

            var item = document.createElement('span');
            item.classList.add('ql-picker-item');
            if (option.hasAttribute('value')) {
              item.setAttribute('data-value', option.getAttribute('value'));
            }
            if (option.textContent) {
              item.setAttribute('data-label', option.textContent);
            }
            item.addEventListener('click', function () {
              _this2.selectItem(item, true);
            });
            return item;
          }
        }, {
          key: 'buildLabel',
          value: function buildLabel() {
            var label = document.createElement('span');
            label.classList.add('ql-picker-label');
            label.innerHTML = _dropdown2.default;
            this.container.appendChild(label);
            return label;
          }
        }, {
          key: 'buildOptions',
          value: function buildOptions() {
            var _this3 = this;

            var options = document.createElement('span');
            options.classList.add('ql-picker-options');
            [].slice.call(this.select.options).forEach(function (option) {
              var item = _this3.buildItem(option);
              options.appendChild(item);
              if (option.selected === true) {
                _this3.selectItem(item);
              }
            });
            this.container.appendChild(options);
          }
        }, {
          key: 'buildPicker',
          value: function buildPicker() {
            var _this4 = this;

            [].slice.call(this.select.attributes).forEach(function (item) {
              _this4.container.setAttribute(item.name, item.value);
            });
            this.container.classList.add('ql-picker');
            this.label = this.buildLabel();
            this.buildOptions();
          }
        }, {
          key: 'close',
          value: function close() {
            this.container.classList.remove('ql-expanded');
          }
        }, {
          key: 'selectItem',
          value: function selectItem(item) {
            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var selected = this.container.querySelector('.ql-selected');
            if (item === selected) return;
            if (selected != null) {
              selected.classList.remove('ql-selected');
            }
            if (item == null) return;
            item.classList.add('ql-selected');
            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
            if (item.hasAttribute('data-value')) {
              this.label.setAttribute('data-value', item.getAttribute('data-value'));
            } else {
              this.label.removeAttribute('data-value');
            }
            if (item.hasAttribute('data-label')) {
              this.label.setAttribute('data-label', item.getAttribute('data-label'));
            } else {
              this.label.removeAttribute('data-label');
            }
            if (trigger) {
              if (typeof Event === 'function') {
                this.select.dispatchEvent(new Event('change'));
              } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                // IE11
                var event = document.createEvent('Event');
                event.initEvent('change', true, true);
                this.select.dispatchEvent(event);
              }
              this.close();
            }
          }
        }, {
          key: 'update',
          value: function update() {
            var option = void 0;
            if (this.select.selectedIndex > -1) {
              var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
              option = this.select.options[this.select.selectedIndex];
              this.selectItem(item);
            } else {
              this.selectItem(null);
            }
            var isActive = option != null && option !== this.select.querySelector('option[selected]');
            this.label.classList.toggle('ql-active', isActive);
          }
        }]);

        return Picker;
      }();

      exports.default = Picker;

      /***/
    },
    /* 29 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _container = __webpack_require__(24);

      var _container2 = _interopRequireDefault(_container);

      var _cursor = __webpack_require__(23);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _embed = __webpack_require__(25);

      var _embed2 = _interopRequireDefault(_embed);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _scroll = __webpack_require__(22);

      var _scroll2 = _interopRequireDefault(_scroll);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _clipboard = __webpack_require__(55);

      var _clipboard2 = _interopRequireDefault(_clipboard);

      var _history = __webpack_require__(42);

      var _history2 = _interopRequireDefault(_history);

      var _keyboard = __webpack_require__(35);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      _quill2.default.register({
        'blots/block': _block2.default,
        'blots/block/embed': _block.BlockEmbed,
        'blots/break': _break2.default,
        'blots/container': _container2.default,
        'blots/cursor': _cursor2.default,
        'blots/embed': _embed2.default,
        'blots/inline': _inline2.default,
        'blots/scroll': _scroll2.default,
        'blots/text': _text2.default,

        'modules/clipboard': _clipboard2.default,
        'modules/history': _history2.default,
        'modules/keyboard': _keyboard2.default
      });

      _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

      exports.default = _quill2.default;

      /***/
    },
    /* 30 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var Registry = __webpack_require__(1);
      var ShadowBlot = /** @class */function () {
        function ShadowBlot(domNode) {
          this.domNode = domNode;
          this.attach();
        }
        Object.defineProperty(ShadowBlot.prototype, "statics", {
          // Hack for accessing inherited static methods
          get: function get() {
            return this.constructor;
          },
          enumerable: true,
          configurable: true
        });
        ShadowBlot.create = function (value) {
          if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
          }
          var node;
          if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
              value = value.toUpperCase();
              if (parseInt(value).toString() === value) {
                value = parseInt(value);
              }
            }
            if (typeof value === 'number') {
              node = document.createElement(this.tagName[value - 1]);
            } else if (this.tagName.indexOf(value) > -1) {
              node = document.createElement(value);
            } else {
              node = document.createElement(this.tagName[0]);
            }
          } else {
            node = document.createElement(this.tagName);
          }
          if (this.className) {
            node.classList.add(this.className);
          }
          return node;
        };
        ShadowBlot.prototype.attach = function () {
          this.domNode[Registry.DATA_KEY] = { blot: this };
        };
        ShadowBlot.prototype.clone = function () {
          var domNode = this.domNode.cloneNode(false);
          return Registry.create(domNode);
        };
        ShadowBlot.prototype.detach = function () {
          if (this.parent != null) this.parent.removeChild(this);
          delete this.domNode[Registry.DATA_KEY];
        };
        ShadowBlot.prototype.deleteAt = function (index, length) {
          var blot = this.isolate(index, length);
          blot.remove();
        };
        ShadowBlot.prototype.formatAt = function (index, length, name, value) {
          var blot = this.isolate(index, length);
          if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
          } else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
          }
        };
        ShadowBlot.prototype.insertAt = function (index, value, def) {
          var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
          var ref = this.split(index);
          this.parent.insertBefore(blot, ref);
        };
        ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
          if (this.parent != null) {
            this.parent.children.remove(this);
          }
          parentBlot.children.insertBefore(this, refBlot);
          if (refBlot != null) {
            var refDomNode = refBlot.domNode;
          }
          if (this.next == null || this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, typeof refDomNode !== 'undefined' ? refDomNode : null);
          }
          this.parent = parentBlot;
          this.scroll = parentBlot.scroll;
        };
        ShadowBlot.prototype.isolate = function (index, length) {
          var target = this.split(index);
          target.split(length);
          return target;
        };
        ShadowBlot.prototype.length = function () {
          return 1;
        };
        ShadowBlot.prototype.offset = function (root) {
          if (root === void 0) {
            root = this.parent;
          }
          if (this.parent == null || this == root) return 0;
          return this.parent.children.offset(this) + this.parent.offset(root);
        };
        ShadowBlot.prototype.optimize = function (context) {
          // TODO clean up once we use WeakMap
          if (this.domNode[Registry.DATA_KEY] != null) {
            delete this.domNode[Registry.DATA_KEY].mutations;
          }
        };
        ShadowBlot.prototype.remove = function () {
          if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
          }
          this.detach();
        };
        ShadowBlot.prototype.replace = function (target) {
          if (target.parent == null) return;
          target.parent.insertBefore(this, target.next);
          target.remove();
        };
        ShadowBlot.prototype.replaceWith = function (name, value) {
          var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
          replacement.replace(this);
          return replacement;
        };
        ShadowBlot.prototype.split = function (index, force) {
          return index === 0 ? this : this.next;
        };
        ShadowBlot.prototype.update = function (mutations, context) {
          // Nothing to do by default
        };
        ShadowBlot.prototype.wrap = function (name, value) {
          var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
          if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
          }
          wrapper.appendChild(this);
          return wrapper;
        };
        ShadowBlot.blotName = 'abstract';
        return ShadowBlot;
      }();
      exports.default = ShadowBlot;

      /***/
    },
    /* 31 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      var class_1 = __webpack_require__(32);
      var style_1 = __webpack_require__(33);
      var Registry = __webpack_require__(1);
      var AttributorStore = /** @class */function () {
        function AttributorStore(domNode) {
          this.attributes = {};
          this.domNode = domNode;
          this.build();
        }
        AttributorStore.prototype.attribute = function (attribute, value) {
          // verb
          if (value) {
            if (attribute.add(this.domNode, value)) {
              if (attribute.value(this.domNode) != null) {
                this.attributes[attribute.attrName] = attribute;
              } else {
                delete this.attributes[attribute.attrName];
              }
            }
          } else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
          }
        };
        AttributorStore.prototype.build = function () {
          var _this = this;
          this.attributes = {};
          var attributes = attributor_1.default.keys(this.domNode);
          var classes = class_1.default.keys(this.domNode);
          var styles = style_1.default.keys(this.domNode);
          attributes.concat(classes).concat(styles).forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
              _this.attributes[attr.attrName] = attr;
            }
          });
        };
        AttributorStore.prototype.copy = function (target) {
          var _this = this;
          Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
          });
        };
        AttributorStore.prototype.move = function (target) {
          var _this = this;
          this.copy(target);
          Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
          });
          this.attributes = {};
        };
        AttributorStore.prototype.values = function () {
          var _this = this;
          return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
          }, {});
        };
        return AttributorStore;
      }();
      exports.default = AttributorStore;

      /***/
    },
    /* 32 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      function match(node, prefix) {
        var className = node.getAttribute('class') || '';
        return className.split(/\s+/).filter(function (name) {
          return name.indexOf(prefix + "-") === 0;
        });
      }
      var ClassAttributor = /** @class */function (_super) {
        __extends(ClassAttributor, _super);
        function ClassAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        ClassAttributor.keys = function (node) {
          return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name.split('-').slice(0, -1).join('-');
          });
        };
        ClassAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          this.remove(node);
          node.classList.add(this.keyName + "-" + value);
          return true;
        };
        ClassAttributor.prototype.remove = function (node) {
          var matches = match(node, this.keyName);
          matches.forEach(function (name) {
            node.classList.remove(name);
          });
          if (node.classList.length === 0) {
            node.removeAttribute('class');
          }
        };
        ClassAttributor.prototype.value = function (node) {
          var result = match(node, this.keyName)[0] || '';
          var value = result.slice(this.keyName.length + 1); // +1 for hyphen
          return this.canAdd(node, value) ? value : '';
        };
        return ClassAttributor;
      }(attributor_1.default);
      exports.default = ClassAttributor;

      /***/
    },
    /* 33 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      function camelize(name) {
        var parts = name.split('-');
        var rest = parts.slice(1).map(function (part) {
          return part[0].toUpperCase() + part.slice(1);
        }).join('');
        return parts[0] + rest;
      }
      var StyleAttributor = /** @class */function (_super) {
        __extends(StyleAttributor, _super);
        function StyleAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        StyleAttributor.keys = function (node) {
          return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
          });
        };
        StyleAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          node.style[camelize(this.keyName)] = value;
          return true;
        };
        StyleAttributor.prototype.remove = function (node) {
          node.style[camelize(this.keyName)] = '';
          if (!node.getAttribute('style')) {
            node.removeAttribute('style');
          }
        };
        StyleAttributor.prototype.value = function (node) {
          var value = node.style[camelize(this.keyName)];
          return this.canAdd(node, value) ? value : '';
        };
        return StyleAttributor;
      }(attributor_1.default);
      exports.default = StyleAttributor;

      /***/
    },
    /* 34 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Theme = function () {
        function Theme(quill, options) {
          _classCallCheck(this, Theme);

          this.quill = quill;
          this.options = options;
          this.modules = {};
        }

        _createClass(Theme, [{
          key: 'init',
          value: function init() {
            var _this = this;

            Object.keys(this.options.modules).forEach(function (name) {
              if (_this.modules[name] == null) {
                _this.addModule(name);
              }
            });
          }
        }, {
          key: 'addModule',
          value: function addModule(name) {
            var moduleClass = this.quill.constructor.import('modules/' + name);
            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
            return this.modules[name];
          }
        }]);

        return Theme;
      }();

      Theme.DEFAULTS = {
        modules: {}
      };
      Theme.themes = {
        'default': Theme
      };

      exports.default = Theme;

      /***/
    },
    /* 35 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SHORTKEY = exports.default = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _embed = __webpack_require__(25);

      var _embed2 = _interopRequireDefault(_embed);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:keyboard');

      var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

      var Keyboard = function (_Module) {
        _inherits(Keyboard, _Module);

        _createClass(Keyboard, null, [{
          key: 'match',
          value: function match(evt, binding) {
            binding = normalize(binding);
            if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
              return !!binding[key] !== evt[key] && binding[key] !== null;
            })) {
              return false;
            }
            return binding.key === (evt.which || evt.keyCode);
          }
        }]);

        function Keyboard(quill, options) {
          _classCallCheck(this, Keyboard);

          var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

          _this.bindings = {};
          Object.keys(_this.options.bindings).forEach(function (name) {
            if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
              return;
            }
            if (_this.options.bindings[name]) {
              _this.addBinding(_this.options.bindings[name]);
            }
          });
          _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
          _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
          if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
            _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
          } else {
            _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
            _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
          }
          _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
          _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
          _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
          _this.listen();
          return _this;
        }

        _createClass(Keyboard, [{
          key: 'addBinding',
          value: function addBinding(key) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var binding = normalize(key);
            if (binding == null || binding.key == null) {
              return debug.warn('Attempted to add invalid keyboard binding', binding);
            }
            if (typeof context === 'function') {
              context = { handler: context };
            }
            if (typeof handler === 'function') {
              handler = { handler: handler };
            }
            binding = (0, _extend2.default)(binding, context, handler);
            this.bindings[binding.key] = this.bindings[binding.key] || [];
            this.bindings[binding.key].push(binding);
          }
        }, {
          key: 'listen',
          value: function listen() {
            var _this2 = this;

            this.quill.root.addEventListener('keydown', function (evt) {
              if (evt.defaultPrevented) return;
              var which = evt.which || evt.keyCode;
              var bindings = (_this2.bindings[which] || []).filter(function (binding) {
                return Keyboard.match(evt, binding);
              });
              if (bindings.length === 0) return;
              var range = _this2.quill.getSelection();
              if (range == null || !_this2.quill.hasFocus()) return;

              var _quill$getLine = _this2.quill.getLine(range.index),
                  _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
                  line = _quill$getLine2[0],
                  offset = _quill$getLine2[1];

              var _quill$getLeaf = _this2.quill.getLeaf(range.index),
                  _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
                  leafStart = _quill$getLeaf2[0],
                  offsetStart = _quill$getLeaf2[1];

              var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
                  _ref2 = _slicedToArray(_ref, 2),
                  leafEnd = _ref2[0],
                  offsetEnd = _ref2[1];

              var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
              var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
              var curContext = {
                collapsed: range.length === 0,
                empty: range.length === 0 && line.length() <= 1,
                format: _this2.quill.getFormat(range),
                offset: offset,
                prefix: prefixText,
                suffix: suffixText
              };
              var prevented = bindings.some(function (binding) {
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                  // any format is present
                  if (binding.format.every(function (name) {
                    return curContext.format[name] == null;
                  })) {
                    return false;
                  }
                } else if (_typeof(binding.format) === 'object') {
                  // all formats must match
                  if (!Object.keys(binding.format).every(function (name) {
                    if (binding.format[name] === true) return curContext.format[name] != null;
                    if (binding.format[name] === false) return curContext.format[name] == null;
                    return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                  })) {
                    return false;
                  }
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                return binding.handler.call(_this2, range, curContext) !== true;
              });
              if (prevented) {
                evt.preventDefault();
              }
            });
          }
        }]);

        return Keyboard;
      }(_module2.default);

      Keyboard.keys = {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46
      };

      Keyboard.DEFAULTS = {
        bindings: {
          'bold': makeFormatHandler('bold'),
          'italic': makeFormatHandler('italic'),
          'underline': makeFormatHandler('underline'),
          'indent': {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: Keyboard.keys.TAB,
            format: ['blockquote', 'indent', 'list'],
            handler: function handler(range, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format('indent', '+1', _quill2.default.sources.USER);
            }
          },
          'outdent': {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            format: ['blockquote', 'indent', 'list'],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler: function handler(range, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format('indent', '-1', _quill2.default.sources.USER);
            }
          },
          'outdent backspace': {
            key: Keyboard.keys.BACKSPACE,
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: ['indent', 'list'],
            offset: 0,
            handler: function handler(range, context) {
              if (context.format.indent != null) {
                this.quill.format('indent', '-1', _quill2.default.sources.USER);
              } else if (context.format.list != null) {
                this.quill.format('list', false, _quill2.default.sources.USER);
              }
            }
          },
          'indent code-block': makeCodeBlockHandler(true),
          'outdent code-block': makeCodeBlockHandler(false),
          'remove tab': {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler: function handler(range) {
              this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
            }
          },
          'tab': {
            key: Keyboard.keys.TAB,
            handler: function handler(range) {
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
            }
          },
          'list empty enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['list'],
            empty: true,
            handler: function handler(range, context) {
              this.quill.format('list', false, _quill2.default.sources.USER);
              if (context.format.indent) {
                this.quill.format('indent', false, _quill2.default.sources.USER);
              }
            }
          },
          'checklist enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: { list: 'checked' },
            handler: function handler(range) {
              var _quill$getLine3 = this.quill.getLine(range.index),
                  _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
                  line = _quill$getLine4[0],
                  offset = _quill$getLine4[1];

              var delta = new _quillDelta2.default().retain(range.index).insert('\n', { list: 'checked' }).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          'header enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['header'],
            suffix: /^$/,
            handler: function handler(range, context) {
              var _quill$getLine5 = this.quill.getLine(range.index),
                  _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
                  line = _quill$getLine6[0],
                  offset = _quill$getLine6[1];

              var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          'list autofill': {
            key: ' ',
            collapsed: true,
            format: { list: false },
            prefix: /^\s*?(\d+\.|-|\[ ?\]|\[x\])$/,
            handler: function handler(range, context) {
              var length = context.prefix.length;

              var _quill$getLine7 = this.quill.getLine(range.index),
                  _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
                  line = _quill$getLine8[0],
                  offset = _quill$getLine8[1];

              if (offset > length) return true;
              var value = void 0;
              switch (context.prefix.trim()) {
                case '[]':case '[ ]':
                  value = 'unchecked';
                  break;
                case '[x]':
                  value = 'checked';
                  break;
                case '-':
                  value = 'bullet';
                  break;
                default:
                  value = 'ordered';
              }
              this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
            }
          },
          'code exit': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['code-block'],
            prefix: /\n\n$/,
            suffix: /^\s+$/,
            handler: function handler(range) {
              var _quill$getLine9 = this.quill.getLine(range.index),
                  _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
                  line = _quill$getLine10[0],
                  offset = _quill$getLine10[1];

              var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
              this.quill.updateContents(delta, _quill2.default.sources.USER);
            }
          },
          'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
          'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
          'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
          'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
        }
      };

      function makeEmbedArrowHandler(key, shiftKey) {
        var _ref3;

        var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
        return _ref3 = {
          key: key,
          shiftKey: shiftKey
        }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
          var index = range.index;
          if (key === Keyboard.keys.RIGHT) {
            index += range.length + 1;
          }

          var _quill$getLeaf3 = this.quill.getLeaf(index),
              _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
              leaf = _quill$getLeaf4[0];

          if (!(leaf instanceof _embed2.default)) return true;
          if (key === Keyboard.keys.LEFT) {
            if (shiftKey) {
              this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
            }
          } else {
            if (shiftKey) {
              this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
            }
          }
          return false;
        }), _ref3;
      }

      function handleBackspace(range, context) {
        if (range.index === 0 || this.quill.getLength() <= 1) return;

        var _quill$getLine11 = this.quill.getLine(range.index),
            _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
            line = _quill$getLine12[0];

        var formats = {};
        if (context.offset === 0) {
          var _quill$getLine13 = this.quill.getLine(range.index - 1),
              _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
              prev = _quill$getLine14[0];

          if (prev != null && prev.length() > 1) {
            var curFormats = line.formats();
            var prevFormats = this.quill.getFormat(range.index - 1, 1);
            formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
          }
        }
        // Check for astral symbols
        var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
        }
        this.quill.focus();
      }

      function handleDelete(range, context) {
        // Check for astral symbols
        var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        var formats = {},
            nextLength = 0;

        var _quill$getLine15 = this.quill.getLine(range.index),
            _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
            line = _quill$getLine16[0];

        if (context.offset >= line.length() - 1) {
          var _quill$getLine17 = this.quill.getLine(range.index + 1),
              _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
              next = _quill$getLine18[0];

          if (next) {
            var curFormats = line.formats();
            var nextFormats = this.quill.getFormat(range.index, 1);
            formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
            nextLength = next.length();
          }
        }
        this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
        }
      }

      function handleDeleteRange(range) {
        var lines = this.quill.getLines(range);
        var formats = {};
        if (lines.length > 1) {
          var firstFormats = lines[0].formats();
          var lastFormats = lines[lines.length - 1].formats();
          formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
        }
        this.quill.deleteText(range, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
        }
        this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
        this.quill.focus();
      }

      function handleEnter(range, context) {
        var _this3 = this;

        if (range.length > 0) {
          this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
        }
        var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
          if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
            lineFormats[format] = context.format[format];
          }
          return lineFormats;
        }, {});
        this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
        // Earlier scroll.deleteAt might have messed up our selection,
        // so insertText's built in selection preservation is not reliable
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.focus();
        Object.keys(context.format).forEach(function (name) {
          if (lineFormats[name] != null) return;
          if (Array.isArray(context.format[name])) return;
          if (name === 'link') return;
          _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
        });
      }

      function makeCodeBlockHandler(indent) {
        return {
          key: Keyboard.keys.TAB,
          shiftKey: !indent,
          format: { 'code-block': true },
          handler: function handler(range) {
            var CodeBlock = _parchment2.default.query('code-block');
            var index = range.index,
                length = range.length;

            var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
                _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
                block = _quill$scroll$descend2[0],
                offset = _quill$scroll$descend2[1];

            if (block == null) return;
            var scrollIndex = this.quill.getIndex(block);
            var start = block.newlineIndex(offset, true) + 1;
            var end = block.newlineIndex(scrollIndex + offset + length);
            var lines = block.domNode.textContent.slice(start, end).split('\n');
            offset = 0;
            lines.forEach(function (line, i) {
              if (indent) {
                block.insertAt(start + offset, CodeBlock.TAB);
                offset += CodeBlock.TAB.length;
                if (i === 0) {
                  index += CodeBlock.TAB.length;
                } else {
                  length += CodeBlock.TAB.length;
                }
              } else if (line.startsWith(CodeBlock.TAB)) {
                block.deleteAt(start + offset, CodeBlock.TAB.length);
                offset -= CodeBlock.TAB.length;
                if (i === 0) {
                  index -= CodeBlock.TAB.length;
                } else {
                  length -= CodeBlock.TAB.length;
                }
              }
              offset += line.length + 1;
            });
            this.quill.update(_quill2.default.sources.USER);
            this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
          }
        };
      }

      function makeFormatHandler(format) {
        return {
          key: format[0].toUpperCase(),
          shortKey: true,
          handler: function handler(range, context) {
            this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
          }
        };
      }

      function normalize(binding) {
        if (typeof binding === 'string' || typeof binding === 'number') {
          return normalize({ key: binding });
        }
        if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
          binding = (0, _clone2.default)(binding, false);
        }
        if (typeof binding.key === 'string') {
          if (Keyboard.keys[binding.key.toUpperCase()] != null) {
            binding.key = Keyboard.keys[binding.key.toUpperCase()];
          } else if (binding.key.length === 1) {
            binding.key = binding.key.toUpperCase().charCodeAt(0);
          } else {
            return null;
          }
        }
        if (binding.shortKey) {
          binding[SHORTKEY] = binding.shortKey;
          delete binding.shortKey;
        }
        return binding;
      }

      exports.default = Keyboard;
      exports.SHORTKEY = SHORTKEY;

      /***/
    },
    /* 36 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ['right', 'center', 'justify']
      };

      var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
      var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
      var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

      exports.AlignAttribute = AlignAttribute;
      exports.AlignClass = AlignClass;
      exports.AlignStyle = AlignStyle;

      /***/
    },
    /* 37 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.BackgroundStyle = exports.BackgroundClass = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _color = __webpack_require__(26);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
        scope: _parchment2.default.Scope.INLINE
      });
      var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
        scope: _parchment2.default.Scope.INLINE
      });

      exports.BackgroundClass = BackgroundClass;
      exports.BackgroundStyle = BackgroundStyle;

      /***/
    },
    /* 38 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ['rtl']
      };

      var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
      var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
      var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

      exports.DirectionAttribute = DirectionAttribute;
      exports.DirectionClass = DirectionClass;
      exports.DirectionStyle = DirectionStyle;

      /***/
    },
    /* 39 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FontClass = exports.FontStyle = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var config = {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['serif', 'monospace']
      };

      var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

      var FontStyleAttributor = function (_Parchment$Attributor) {
        _inherits(FontStyleAttributor, _Parchment$Attributor);

        function FontStyleAttributor() {
          _classCallCheck(this, FontStyleAttributor);

          return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
        }

        _createClass(FontStyleAttributor, [{
          key: 'value',
          value: function value(node) {
            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
          }
        }]);

        return FontStyleAttributor;
      }(_parchment2.default.Attributor.Style);

      var FontStyle = new FontStyleAttributor('font', 'font-family', config);

      exports.FontStyle = FontStyle;
      exports.FontClass = FontClass;

      /***/
    },
    /* 40 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SizeStyle = exports.SizeClass = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['small', 'large', 'huge']
      });
      var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['10px', '18px', '32px']
      });

      exports.SizeClass = SizeClass;
      exports.SizeStyle = SizeStyle;

      /***/
    },
    /* 41 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      module.exports = {
        'align': {
          '': __webpack_require__(76),
          'center': __webpack_require__(77),
          'right': __webpack_require__(78),
          'justify': __webpack_require__(79)
        },
        'background': __webpack_require__(80),
        'blockquote': __webpack_require__(81),
        'bold': __webpack_require__(82),
        'clean': __webpack_require__(83),
        'code': __webpack_require__(58),
        'code-block': __webpack_require__(58),
        'color': __webpack_require__(84),
        'direction': {
          '': __webpack_require__(85),
          'rtl': __webpack_require__(86)
        },
        'float': {
          'center': __webpack_require__(87),
          'full': __webpack_require__(88),
          'left': __webpack_require__(89),
          'right': __webpack_require__(90)
        },
        'formula': __webpack_require__(91),
        'header': {
          '1': __webpack_require__(92),
          '2': __webpack_require__(93)
        },
        'italic': __webpack_require__(94),
        'image': __webpack_require__(95),
        'indent': {
          '+1': __webpack_require__(96),
          '-1': __webpack_require__(97)
        },
        'link': __webpack_require__(98),
        'list': {
          'ordered': __webpack_require__(99),
          'bullet': __webpack_require__(100),
          'check': __webpack_require__(101)
        },
        'script': {
          'sub': __webpack_require__(102),
          'super': __webpack_require__(103)
        },
        'strike': __webpack_require__(104),
        'underline': __webpack_require__(105),
        'video': __webpack_require__(106)
      };

      /***/
    },
    /* 42 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getLastChangeIndex = exports.default = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var History = function (_Module) {
        _inherits(History, _Module);

        function History(quill, options) {
          _classCallCheck(this, History);

          var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

          _this.lastRecorded = 0;
          _this.ignoreChange = false;
          _this.clear();
          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
            if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
            if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
              _this.record(delta, oldDelta);
            } else {
              _this.transform(delta);
            }
          });
          _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
          _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
          if (/Win/i.test(navigator.platform)) {
            _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
          }
          return _this;
        }

        _createClass(History, [{
          key: 'change',
          value: function change(source, dest) {
            if (this.stack[source].length === 0) return;
            var delta = this.stack[source].pop();
            this.lastRecorded = 0;
            this.ignoreChange = true;
            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
            this.ignoreChange = false;
            var index = getLastChangeIndex(delta[source]);
            this.quill.setSelection(index);
            this.stack[dest].push(delta);
          }
        }, {
          key: 'clear',
          value: function clear() {
            this.stack = { undo: [], redo: [] };
          }
        }, {
          key: 'cutoff',
          value: function cutoff() {
            this.lastRecorded = 0;
          }
        }, {
          key: 'record',
          value: function record(changeDelta, oldDelta) {
            if (changeDelta.ops.length === 0) return;
            this.stack.redo = [];
            var undoDelta = this.quill.getContents().diff(oldDelta);
            var timestamp = Date.now();
            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
              var delta = this.stack.undo.pop();
              undoDelta = undoDelta.compose(delta.undo);
              changeDelta = delta.redo.compose(changeDelta);
            } else {
              this.lastRecorded = timestamp;
            }
            this.stack.undo.push({
              redo: changeDelta,
              undo: undoDelta
            });
            if (this.stack.undo.length > this.options.maxStack) {
              this.stack.undo.shift();
            }
          }
        }, {
          key: 'redo',
          value: function redo() {
            this.change('redo', 'undo');
          }
        }, {
          key: 'transform',
          value: function transform(delta) {
            this.stack.undo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
            this.stack.redo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
          }
        }, {
          key: 'undo',
          value: function undo() {
            this.change('undo', 'redo');
          }
        }]);

        return History;
      }(_module2.default);

      History.DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
      };

      function endsWithNewlineChange(delta) {
        var lastOp = delta.ops[delta.ops.length - 1];
        if (lastOp == null) return false;
        if (lastOp.insert != null) {
          return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
        }
        if (lastOp.attributes != null) {
          return Object.keys(lastOp.attributes).some(function (attr) {
            return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
          });
        }
        return false;
      }

      function getLastChangeIndex(delta) {
        var deleteLength = delta.reduce(function (length, op) {
          length += op.delete || 0;
          return length;
        }, 0);
        var changeIndex = delta.length() - deleteLength;
        if (endsWithNewlineChange(delta)) {
          changeIndex -= 1;
        }
        return changeIndex;
      }

      exports.default = History;
      exports.getLastChangeIndex = getLastChangeIndex;

      /***/
    },
    /* 43 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BaseTooltip = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _keyboard = __webpack_require__(35);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ALIGNS = [false, 'center', 'right', 'justify'];

      var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

      var FONTS = [false, 'serif', 'monospace'];

      var HEADERS = ['1', '2', '3', false];

      var SIZES = ['small', false, 'large', 'huge'];

      var BaseTheme = function (_Theme) {
        _inherits(BaseTheme, _Theme);

        function BaseTheme(quill, options) {
          _classCallCheck(this, BaseTheme);

          var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

          var listener = function listener(e) {
            if (!document.body.contains(quill.root)) {
              return document.body.removeEventListener('click', listener);
            }
            if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
              _this.tooltip.hide();
            }
            if (_this.pickers != null) {
              _this.pickers.forEach(function (picker) {
                if (!picker.container.contains(e.target)) {
                  picker.close();
                }
              });
            }
          };
          quill.emitter.listenDOM('click', document.body, listener);
          return _this;
        }

        _createClass(BaseTheme, [{
          key: 'addModule',
          value: function addModule(name) {
            var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
            if (name === 'toolbar') {
              this.extendToolbar(module);
            }
            return module;
          }
        }, {
          key: 'buildButtons',
          value: function buildButtons(buttons, icons) {
            buttons.forEach(function (button) {
              var className = button.getAttribute('class') || '';
              className.split(/\s+/).forEach(function (name) {
                if (!name.startsWith('ql-')) return;
                name = name.slice('ql-'.length);
                if (icons[name] == null) return;
                if (name === 'direction') {
                  button.innerHTML = icons[name][''] + icons[name]['rtl'];
                } else if (typeof icons[name] === 'string') {
                  button.innerHTML = icons[name];
                } else {
                  var value = button.value || '';
                  if (value != null && icons[name][value]) {
                    button.innerHTML = icons[name][value];
                  }
                }
              });
            });
          }
        }, {
          key: 'buildPickers',
          value: function buildPickers(selects, icons) {
            var _this2 = this;

            this.pickers = selects.map(function (select) {
              if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) {
                  fillSelect(select, ALIGNS);
                }
                return new _iconPicker2.default(select, icons.align);
              } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                var format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) {
                  fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                }
                return new _colorPicker2.default(select, icons[format]);
              } else {
                if (select.querySelector('option') == null) {
                  if (select.classList.contains('ql-font')) {
                    fillSelect(select, FONTS);
                  } else if (select.classList.contains('ql-header')) {
                    fillSelect(select, HEADERS);
                  } else if (select.classList.contains('ql-size')) {
                    fillSelect(select, SIZES);
                  }
                }
                return new _picker2.default(select);
              }
            });
            var update = function update() {
              _this2.pickers.forEach(function (picker) {
                picker.update();
              });
            };
            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
          }
        }]);

        return BaseTheme;
      }(_theme2.default);

      BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              formula: function formula() {
                this.quill.theme.tooltip.edit('formula');
              },
              image: function image() {
                var _this3 = this;

                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                if (fileInput == null) {
                  fileInput = document.createElement('input');
                  fileInput.setAttribute('type', 'file');
                  fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                  fileInput.classList.add('ql-image');
                  fileInput.addEventListener('change', function () {
                    if (fileInput.files != null && fileInput.files[0] != null) {
                      var reader = new FileReader();
                      reader.onload = function (e) {
                        var range = _this3.quill.getSelection(true);
                        _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                        _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                        fileInput.value = "";
                      };
                      reader.readAsDataURL(fileInput.files[0]);
                    }
                  });
                  this.container.appendChild(fileInput);
                }
                fileInput.click();
              },
              video: function video() {
                this.quill.theme.tooltip.edit('video');
              }
            }
          }
        }
      });

      var BaseTooltip = function (_Tooltip) {
        _inherits(BaseTooltip, _Tooltip);

        function BaseTooltip(quill, boundsContainer) {
          _classCallCheck(this, BaseTooltip);

          var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

          _this4.textbox = _this4.root.querySelector('input[type="text"]');
          _this4.listen();
          return _this4;
        }

        _createClass(BaseTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this5 = this;

            this.textbox.addEventListener('keydown', function (event) {
              if (_keyboard2.default.match(event, 'enter')) {
                _this5.save();
                event.preventDefault();
              } else if (_keyboard2.default.match(event, 'escape')) {
                _this5.cancel();
                event.preventDefault();
              }
            });
          }
        }, {
          key: 'cancel',
          value: function cancel() {
            this.hide();
          }
        }, {
          key: 'edit',
          value: function edit() {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.root.classList.remove('ql-hidden');
            this.root.classList.add('ql-editing');
            if (preview != null) {
              this.textbox.value = preview;
            } else if (mode !== this.root.getAttribute('data-mode')) {
              this.textbox.value = '';
            }
            this.position(this.quill.getBounds(this.quill.selection.savedRange));
            this.textbox.select();
            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
            this.root.setAttribute('data-mode', mode);
          }
        }, {
          key: 'restoreFocus',
          value: function restoreFocus() {
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.quill.focus();
            this.quill.scrollingContainer.scrollTop = scrollTop;
          }
        }, {
          key: 'save',
          value: function save() {
            var value = this.textbox.value;
            switch (this.root.getAttribute('data-mode')) {
              case 'link':
                {
                  var scrollTop = this.quill.root.scrollTop;
                  if (this.linkRange) {
                    this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                    delete this.linkRange;
                  } else {
                    this.restoreFocus();
                    this.quill.format('link', value, _emitter2.default.sources.USER);
                  }
                  this.quill.root.scrollTop = scrollTop;
                  break;
                }
              case 'video':
                {
                  value = extractVideoUrl(value);
                } // eslint-disable-next-line no-fallthrough
              case 'formula':
                {
                  if (!value) break;
                  var range = this.quill.getSelection(true);
                  if (range != null) {
                    var index = range.index + range.length;
                    this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                    if (this.root.getAttribute('data-mode') === 'formula') {
                      this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                    }
                    this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                  }
                  break;
                }
              default:
            }
            this.textbox.value = '';
            this.hide();
          }
        }]);

        return BaseTooltip;
      }(_tooltip2.default);

      function extractVideoUrl(url) {
        var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
        if (match) {
          return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
        }
        if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
          // eslint-disable-line no-cond-assign
          return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
        }
        return url;
      }

      function fillSelect(select, values) {
        var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        values.forEach(function (value) {
          var option = document.createElement('option');
          if (value === defaultValue) {
            option.setAttribute('selected', 'selected');
          } else {
            option.setAttribute('value', value);
          }
          select.appendChild(option);
        });
      }

      exports.BaseTooltip = BaseTooltip;
      exports.default = BaseTheme;

      /***/
    },
    /* 44 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var LinkedList = /** @class */function () {
        function LinkedList() {
          this.head = this.tail = undefined;
          this.length = 0;
        }
        LinkedList.prototype.append = function () {
          var nodes = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
          }
          this.insertBefore(nodes[0], undefined);
          if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
          }
        };
        LinkedList.prototype.contains = function (node) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            if (cur === node) return true;
          }
          return false;
        };
        LinkedList.prototype.insertBefore = function (node, refNode) {
          node.next = refNode;
          if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
              refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
              this.head = node;
            }
          } else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
          } else {
            node.prev = undefined;
            this.head = this.tail = node;
          }
          this.length += 1;
        };
        LinkedList.prototype.offset = function (target) {
          var index = 0,
              cur = this.head;
          while (cur != null) {
            if (cur === target) return index;
            index += cur.length();
            cur = cur.next;
          }
          return -1;
        };
        LinkedList.prototype.remove = function (node) {
          if (!this.contains(node)) return;
          if (node.prev != null) node.prev.next = node.next;
          if (node.next != null) node.next.prev = node.prev;
          if (node === this.head) this.head = node.next;
          if (node === this.tail) this.tail = node.prev;
          this.length -= 1;
        };
        LinkedList.prototype.iterator = function (curNode) {
          if (curNode === void 0) {
            curNode = this.head;
          }
          // TODO use yield when we can
          return function () {
            var ret = curNode;
            if (curNode != null) curNode = curNode.next;
            return ret;
          };
        };
        LinkedList.prototype.find = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var cur,
              next = this.iterator();
          while (cur = next()) {
            var length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) {
              return [cur, index];
            }
            index -= length;
          }
          return [null, 0];
        };
        LinkedList.prototype.forEach = function (callback) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            callback(cur);
          }
        };
        LinkedList.prototype.forEachAt = function (index, length, callback) {
          if (length <= 0) return;
          var _a = this.find(index),
              startNode = _a[0],
              offset = _a[1];
          var cur,
              curIndex = index - offset,
              next = this.iterator(startNode);
          while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
              callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            } else {
              callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
          }
        };
        LinkedList.prototype.map = function (callback) {
          return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
          }, []);
        };
        LinkedList.prototype.reduce = function (callback, memo) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            memo = callback(memo, cur);
          }
          return memo;
        };
        return LinkedList;
      }();
      exports.default = LinkedList;

      /***/
    },
    /* 45 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var container_1 = __webpack_require__(17);
      var Registry = __webpack_require__(1);
      var OBSERVER_CONFIG = {
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
      };
      var MAX_OPTIMIZE_ITERATIONS = 100;
      var ScrollBlot = /** @class */function (_super) {
        __extends(ScrollBlot, _super);
        function ScrollBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.parent = null;
          _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
          });
          _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
          _this.scroll = _this;
          return _this;
        }
        ScrollBlot.prototype.detach = function () {
          _super.prototype.detach.call(this);
          this.observer.disconnect();
        };
        ScrollBlot.prototype.deleteAt = function (index, length) {
          this.update();
          if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
              child.remove();
            });
          } else {
            _super.prototype.deleteAt.call(this, index, length);
          }
        };
        ScrollBlot.prototype.formatAt = function (index, length, name, value) {
          this.update();
          _super.prototype.formatAt.call(this, index, length, name, value);
        };
        ScrollBlot.prototype.insertAt = function (index, value, def) {
          this.update();
          _super.prototype.insertAt.call(this, index, value, def);
        };
        ScrollBlot.prototype.optimize = function (mutations, context) {
          var _this = this;
          if (mutations === void 0) {
            mutations = [];
          }
          if (context === void 0) {
            context = {};
          }
          _super.prototype.optimize.call(this, context);
          // We must modify mutations directly, cannot make copy and then modify
          var records = [].slice.call(this.observer.takeRecords());
          // Array.push currently seems to be implemented by a non-tail recursive function
          // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
          while (records.length > 0) {
            mutations.push(records.pop());
          } // TODO use WeakMap
          var mark = function mark(blot, markParent) {
            if (markParent === void 0) {
              markParent = true;
            }
            if (blot == null || blot === _this) return;
            if (blot.domNode.parentNode == null) return;
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent) mark(blot.parent);
          };
          var optimize = function optimize(blot) {
            // Post-order traversal
            if (blot.domNode[Registry.DATA_KEY] == null || blot.domNode[Registry.DATA_KEY].mutations == null) {
              return;
            }
            if (blot instanceof container_1.default) {
              blot.children.forEach(optimize);
            }
            blot.optimize(context);
          };
          var remaining = mutations;
          for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
              throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
              var blot = Registry.find(mutation.target, true);
              if (blot == null) return;
              if (blot.domNode === mutation.target) {
                if (mutation.type === 'childList') {
                  mark(Registry.find(mutation.previousSibling, false));
                  [].forEach.call(mutation.addedNodes, function (node) {
                    var child = Registry.find(node, false);
                    mark(child, false);
                    if (child instanceof container_1.default) {
                      child.children.forEach(function (grandChild) {
                        mark(grandChild, false);
                      });
                    }
                  });
                } else if (mutation.type === 'attributes') {
                  mark(blot.prev);
                }
              }
              mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0) {
              mutations.push(records.pop());
            }
          }
        };
        ScrollBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (context === void 0) {
            context = {};
          }
          mutations = mutations || this.observer.takeRecords();
          // TODO use WeakMap
          mutations.map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null) return;
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              blot.domNode[Registry.DATA_KEY].mutations = [mutation];
              return blot;
            } else {
              blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
              return null;
            }
          }).forEach(function (blot) {
            if (blot == null || blot === _this || blot.domNode[Registry.DATA_KEY] == null) return;
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
          });
          if (this.domNode[Registry.DATA_KEY].mutations != null) {
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
          }
          this.optimize(mutations, context);
        };
        ScrollBlot.blotName = 'scroll';
        ScrollBlot.defaultChild = 'block';
        ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
        ScrollBlot.tagName = 'DIV';
        return ScrollBlot;
      }(container_1.default);
      exports.default = ScrollBlot;

      /***/
    },
    /* 46 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var format_1 = __webpack_require__(18);
      var Registry = __webpack_require__(1);
      // Shallow object comparison
      function isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for (var prop in obj1) {
          if (obj1[prop] !== obj2[prop]) return false;
        }
        return true;
      }
      var InlineBlot = /** @class */function (_super) {
        __extends(InlineBlot, _super);
        function InlineBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        InlineBlot.formats = function (domNode) {
          if (domNode.tagName === InlineBlot.tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        InlineBlot.prototype.format = function (name, value) {
          var _this = this;
          if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
              if (!(child instanceof format_1.default)) {
                child = child.wrap(InlineBlot.blotName, true);
              }
              _this.attributes.copy(child);
            });
            this.unwrap();
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        InlineBlot.prototype.formatAt = function (index, length, name, value) {
          if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        InlineBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          var formats = this.formats();
          if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
          }
          var next = this.next;
          if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
          }
        };
        InlineBlot.blotName = 'inline';
        InlineBlot.scope = Registry.Scope.INLINE_BLOT;
        InlineBlot.tagName = 'SPAN';
        return InlineBlot;
      }(format_1.default);
      exports.default = InlineBlot;

      /***/
    },
    /* 47 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var format_1 = __webpack_require__(18);
      var Registry = __webpack_require__(1);
      var BlockBlot = /** @class */function (_super) {
        __extends(BlockBlot, _super);
        function BlockBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        BlockBlot.formats = function (domNode) {
          var tagName = Registry.query(BlockBlot.blotName).tagName;
          if (domNode.tagName === tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        BlockBlot.prototype.format = function (name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
          } else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        BlockBlot.prototype.formatAt = function (index, length, name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        BlockBlot.prototype.insertAt = function (index, value, def) {
          if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
          } else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
          }
        };
        BlockBlot.prototype.update = function (mutations, context) {
          if (navigator.userAgent.match(/Trident/)) {
            this.attach();
          } else {
            _super.prototype.update.call(this, mutations, context);
          }
        };
        BlockBlot.blotName = 'block';
        BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
        BlockBlot.tagName = 'P';
        return BlockBlot;
      }(format_1.default);
      exports.default = BlockBlot;

      /***/
    },
    /* 48 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var leaf_1 = __webpack_require__(19);
      var EmbedBlot = /** @class */function (_super) {
        __extends(EmbedBlot, _super);
        function EmbedBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        EmbedBlot.formats = function (domNode) {
          return undefined;
        };
        EmbedBlot.prototype.format = function (name, value) {
          // super.formatAt wraps, which is what we want in general,
          // but this allows subclasses to overwrite for formats
          // that just apply to particular embeds
          _super.prototype.formatAt.call(this, 0, this.length(), name, value);
        };
        EmbedBlot.prototype.formatAt = function (index, length, name, value) {
          if (index === 0 && length === this.length()) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        EmbedBlot.prototype.formats = function () {
          return this.statics.formats(this.domNode);
        };
        return EmbedBlot;
      }(leaf_1.default);
      exports.default = EmbedBlot;

      /***/
    },
    /* 49 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var leaf_1 = __webpack_require__(19);
      var Registry = __webpack_require__(1);
      var TextBlot = /** @class */function (_super) {
        __extends(TextBlot, _super);
        function TextBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.text = _this.statics.value(_this.domNode);
          return _this;
        }
        TextBlot.create = function (value) {
          return document.createTextNode(value);
        };
        TextBlot.value = function (domNode) {
          var text = domNode.data;
          if (text['normalize']) text = text['normalize']();
          return text;
        };
        TextBlot.prototype.deleteAt = function (index, length) {
          this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
        };
        TextBlot.prototype.index = function (node, offset) {
          if (this.domNode === node) {
            return offset;
          }
          return -1;
        };
        TextBlot.prototype.insertAt = function (index, value, def) {
          if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
          } else {
            _super.prototype.insertAt.call(this, index, value, def);
          }
        };
        TextBlot.prototype.length = function () {
          return this.text.length;
        };
        TextBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          this.text = this.statics.value(this.domNode);
          if (this.text.length === 0) {
            this.remove();
          } else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
          }
        };
        TextBlot.prototype.position = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          return [this.domNode, index];
        };
        TextBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = Registry.create(this.domNode.splitText(index));
          this.parent.insertBefore(after, this.next);
          this.text = this.statics.value(this.domNode);
          return after;
        };
        TextBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
          })) {
            this.text = this.statics.value(this.domNode);
          }
        };
        TextBlot.prototype.value = function () {
          return this.text;
        };
        TextBlot.blotName = 'text';
        TextBlot.scope = Registry.Scope.INLINE_BLOT;
        return TextBlot;
      }(leaf_1.default);
      exports.default = TextBlot;

      /***/
    },
    /* 50 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var elem = document.createElement('div');
      elem.classList.toggle('test-class', false);
      if (elem.classList.contains('test-class')) {
        var _toggle = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function (token, force) {
          if (arguments.length > 1 && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };
      }

      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
          position = position || 0;
          return this.substr(position, searchString.length) === searchString;
        };
      }

      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (searchString, position) {
          var subjectString = this.toString();
          if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
          }
          position -= searchString.length;
          var lastIndex = subjectString.indexOf(searchString, position);
          return lastIndex !== -1 && lastIndex === position;
        };
      }

      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
          value: function value(predicate) {
            if (this === null) {
              throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
              throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
              value = list[i];
              if (predicate.call(thisArg, value, i, list)) {
                return value;
              }
            }
            return undefined;
          }
        });
      }

      document.addEventListener("DOMContentLoaded", function () {
        // Disable resizing in Firefox
        document.execCommand("enableObjectResizing", false, false);
        // Disable automatic linkifying in IE11
        document.execCommand("autoUrlDetect", false, false);
      });

      /***/
    },
    /* 51 */
    /***/function (module, exports) {

      /**
       * This library modifies the diff-patch-match library by Neil Fraser
       * by removing the patch and match functionality and certain advanced
       * options in the diff function. The original license is as follows:
       *
       * ===
       *
       * Diff Match and Patch
       *
       * Copyright 2006 Google Inc.
       * http://code.google.com/p/google-diff-match-patch/
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      /**
       * The data structure representing a diff is an array of tuples:
       * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
       * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
       */
      var DIFF_DELETE = -1;
      var DIFF_INSERT = 1;
      var DIFF_EQUAL = 0;

      /**
       * Find the differences between two texts.  Simplifies the problem by stripping
       * any common prefix or suffix off the texts before diffing.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @param {Int} cursor_pos Expected edit position in text1 (optional)
       * @return {Array} Array of diff tuples.
       */
      function diff_main(text1, text2, cursor_pos) {
        // Check for equality (speedup).
        if (text1 == text2) {
          if (text1) {
            return [[DIFF_EQUAL, text1]];
          }
          return [];
        }

        // Check cursor_pos within bounds
        if (cursor_pos < 0 || text1.length < cursor_pos) {
          cursor_pos = null;
        }

        // Trim off common prefix (speedup).
        var commonlength = diff_commonPrefix(text1, text2);
        var commonprefix = text1.substring(0, commonlength);
        text1 = text1.substring(commonlength);
        text2 = text2.substring(commonlength);

        // Trim off common suffix (speedup).
        commonlength = diff_commonSuffix(text1, text2);
        var commonsuffix = text1.substring(text1.length - commonlength);
        text1 = text1.substring(0, text1.length - commonlength);
        text2 = text2.substring(0, text2.length - commonlength);

        // Compute the diff on the middle block.
        var diffs = diff_compute_(text1, text2);

        // Restore the prefix and suffix.
        if (commonprefix) {
          diffs.unshift([DIFF_EQUAL, commonprefix]);
        }
        if (commonsuffix) {
          diffs.push([DIFF_EQUAL, commonsuffix]);
        }
        diff_cleanupMerge(diffs);
        if (cursor_pos != null) {
          diffs = fix_cursor(diffs, cursor_pos);
        }
        diffs = fix_emoji(diffs);
        return diffs;
      };

      /**
       * Find the differences between two texts.  Assumes that the texts do not
       * have any common prefix or suffix.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @return {Array} Array of diff tuples.
       */
      function diff_compute_(text1, text2) {
        var diffs;

        if (!text1) {
          // Just add some text (speedup).
          return [[DIFF_INSERT, text2]];
        }

        if (!text2) {
          // Just delete some text (speedup).
          return [[DIFF_DELETE, text1]];
        }

        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        var i = longtext.indexOf(shorttext);
        if (i != -1) {
          // Shorter text is inside the longer text (speedup).
          diffs = [[DIFF_INSERT, longtext.substring(0, i)], [DIFF_EQUAL, shorttext], [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
          // Swap insertions for deletions if diff is reversed.
          if (text1.length > text2.length) {
            diffs[0][0] = diffs[2][0] = DIFF_DELETE;
          }
          return diffs;
        }

        if (shorttext.length == 1) {
          // Single character string.
          // After the previous speedup, the character can't be an equality.
          return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
        }

        // Check to see if the problem can be split in two.
        var hm = diff_halfMatch_(text1, text2);
        if (hm) {
          // A half-match was found, sort out the return data.
          var text1_a = hm[0];
          var text1_b = hm[1];
          var text2_a = hm[2];
          var text2_b = hm[3];
          var mid_common = hm[4];
          // Send both pairs off for separate processing.
          var diffs_a = diff_main(text1_a, text2_a);
          var diffs_b = diff_main(text1_b, text2_b);
          // Merge the results.
          return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
        }

        return diff_bisect_(text1, text2);
      };

      /**
       * Find the 'middle snake' of a diff, split the problem in two
       * and return the recursively constructed diff.
       * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @return {Array} Array of diff tuples.
       * @private
       */
      function diff_bisect_(text1, text2) {
        // Cache the text lengths to prevent multiple calls.
        var text1_length = text1.length;
        var text2_length = text2.length;
        var max_d = Math.ceil((text1_length + text2_length) / 2);
        var v_offset = max_d;
        var v_length = 2 * max_d;
        var v1 = new Array(v_length);
        var v2 = new Array(v_length);
        // Setting all elements to -1 is faster in Chrome & Firefox than mixing
        // integers and undefined.
        for (var x = 0; x < v_length; x++) {
          v1[x] = -1;
          v2[x] = -1;
        }
        v1[v_offset + 1] = 0;
        v2[v_offset + 1] = 0;
        var delta = text1_length - text2_length;
        // If the total number of characters is odd, then the front path will collide
        // with the reverse path.
        var front = delta % 2 != 0;
        // Offsets for start and end of k loop.
        // Prevents mapping of space beyond the grid.
        var k1start = 0;
        var k1end = 0;
        var k2start = 0;
        var k2end = 0;
        for (var d = 0; d < max_d; d++) {
          // Walk the front path one step.
          for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
              x1 = v1[k1_offset + 1];
            } else {
              x1 = v1[k1_offset - 1] + 1;
            }
            var y1 = x1 - k1;
            while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)) {
              x1++;
              y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) {
              // Ran off the right of the graph.
              k1end += 2;
            } else if (y1 > text2_length) {
              // Ran off the bottom of the graph.
              k1start += 2;
            } else if (front) {
              var k2_offset = v_offset + delta - k1;
              if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                // Mirror x2 onto top-left coordinate system.
                var x2 = text1_length - v2[k2_offset];
                if (x1 >= x2) {
                  // Overlap detected.
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }

          // Walk the reverse path one step.
          for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
              x2 = v2[k2_offset + 1];
            } else {
              x2 = v2[k2_offset - 1] + 1;
            }
            var y2 = x2 - k2;
            while (x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)) {
              x2++;
              y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) {
              // Ran off the left of the graph.
              k2end += 2;
            } else if (y2 > text2_length) {
              // Ran off the top of the graph.
              k2start += 2;
            } else if (!front) {
              var k1_offset = v_offset + delta - k2;
              if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                var x1 = v1[k1_offset];
                var y1 = v_offset + x1 - k1_offset;
                // Mirror x2 onto top-left coordinate system.
                x2 = text1_length - x2;
                if (x1 >= x2) {
                  // Overlap detected.
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }
        }
        // Diff took too long and hit the deadline or
        // number of diffs equals number of characters, no commonality at all.
        return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
      };

      /**
       * Given the location of the 'middle snake', split the diff in two parts
       * and recurse.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @param {number} x Index of split point in text1.
       * @param {number} y Index of split point in text2.
       * @return {Array} Array of diff tuples.
       */
      function diff_bisectSplit_(text1, text2, x, y) {
        var text1a = text1.substring(0, x);
        var text2a = text2.substring(0, y);
        var text1b = text1.substring(x);
        var text2b = text2.substring(y);

        // Compute both diffs serially.
        var diffs = diff_main(text1a, text2a);
        var diffsb = diff_main(text1b, text2b);

        return diffs.concat(diffsb);
      };

      /**
       * Determine the common prefix of two strings.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {number} The number of characters common to the start of each
       *     string.
       */
      function diff_commonPrefix(text1, text2) {
        // Quick check for common null cases.
        if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
          return 0;
        }
        // Binary search.
        // Performance analysis: http://neil.fraser.name/news/2007/10/09/
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerstart = 0;
        while (pointermin < pointermid) {
          if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
          } else {
            pointermax = pointermid;
          }
          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
      };

      /**
       * Determine the common suffix of two strings.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {number} The number of characters common to the end of each string.
       */
      function diff_commonSuffix(text1, text2) {
        // Quick check for common null cases.
        if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
          return 0;
        }
        // Binary search.
        // Performance analysis: http://neil.fraser.name/news/2007/10/09/
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerend = 0;
        while (pointermin < pointermid) {
          if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
          } else {
            pointermax = pointermid;
          }
          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
      };

      /**
       * Do the two texts share a substring which is at least half the length of the
       * longer text?
       * This speedup can produce non-minimal diffs.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {Array.<string>} Five element Array, containing the prefix of
       *     text1, the suffix of text1, the prefix of text2, the suffix of
       *     text2 and the common middle.  Or null if there was no match.
       */
      function diff_halfMatch_(text1, text2) {
        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
          return null; // Pointless.
        }

        /**
         * Does a substring of shorttext exist within longtext such that the substring
         * is at least half the length of longtext?
         * Closure, but does not reference any external variables.
         * @param {string} longtext Longer string.
         * @param {string} shorttext Shorter string.
         * @param {number} i Start index of quarter length substring within longtext.
         * @return {Array.<string>} Five element Array, containing the prefix of
         *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
         *     of shorttext and the common middle.  Or null if there was no match.
         * @private
         */
        function diff_halfMatchI_(longtext, shorttext, i) {
          // Start with a 1/4 length substring at position i as a seed.
          var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
          var j = -1;
          var best_common = '';
          var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
          while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
            var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
              best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
              best_longtext_a = longtext.substring(0, i - suffixLength);
              best_longtext_b = longtext.substring(i + prefixLength);
              best_shorttext_a = shorttext.substring(0, j - suffixLength);
              best_shorttext_b = shorttext.substring(j + prefixLength);
            }
          }
          if (best_common.length * 2 >= longtext.length) {
            return [best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b, best_common];
          } else {
            return null;
          }
        }

        // First check if the second quarter is the seed for a half-match.
        var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
        // Check again based on the third quarter.
        var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
        var hm;
        if (!hm1 && !hm2) {
          return null;
        } else if (!hm2) {
          hm = hm1;
        } else if (!hm1) {
          hm = hm2;
        } else {
          // Both matched.  Select the longest.
          hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
        }

        // A half-match was found, sort out the return data.
        var text1_a, text1_b, text2_a, text2_b;
        if (text1.length > text2.length) {
          text1_a = hm[0];
          text1_b = hm[1];
          text2_a = hm[2];
          text2_b = hm[3];
        } else {
          text2_a = hm[0];
          text2_b = hm[1];
          text1_a = hm[2];
          text1_b = hm[3];
        }
        var mid_common = hm[4];
        return [text1_a, text1_b, text2_a, text2_b, mid_common];
      };

      /**
       * Reorder and merge like edit sections.  Merge equalities.
       * Any edit section can move as long as it doesn't cross an equality.
       * @param {Array} diffs Array of diff tuples.
       */
      function diff_cleanupMerge(diffs) {
        diffs.push([DIFF_EQUAL, '']); // Add a dummy entry at the end.
        var pointer = 0;
        var count_delete = 0;
        var count_insert = 0;
        var text_delete = '';
        var text_insert = '';
        var commonlength;
        while (pointer < diffs.length) {
          switch (diffs[pointer][0]) {
            case DIFF_INSERT:
              count_insert++;
              text_insert += diffs[pointer][1];
              pointer++;
              break;
            case DIFF_DELETE:
              count_delete++;
              text_delete += diffs[pointer][1];
              pointer++;
              break;
            case DIFF_EQUAL:
              // Upon reaching an equality, check for prior redundancies.
              if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                  // Factor out any common prefixies.
                  commonlength = diff_commonPrefix(text_insert, text_delete);
                  if (commonlength !== 0) {
                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) {
                      diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                    } else {
                      diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                      pointer++;
                    }
                    text_insert = text_insert.substring(commonlength);
                    text_delete = text_delete.substring(commonlength);
                  }
                  // Factor out any common suffixies.
                  commonlength = diff_commonSuffix(text_insert, text_delete);
                  if (commonlength !== 0) {
                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                  }
                }
                // Delete the offending records and add the merged ones.
                if (count_delete === 0) {
                  diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
                } else if (count_insert === 0) {
                  diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
                } else {
                  diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
                }
                pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
              } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
              } else {
                pointer++;
              }
              count_insert = 0;
              count_delete = 0;
              text_delete = '';
              text_insert = '';
              break;
          }
        }
        if (diffs[diffs.length - 1][1] === '') {
          diffs.pop(); // Remove the dummy entry at the end.
        }

        // Second pass: look for single edits surrounded on both sides by equalities
        // which can be shifted sideways to eliminate an equality.
        // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
        var changes = false;
        pointer = 1;
        // Intentionally ignore the first and last element (don't need checking).
        while (pointer < diffs.length - 1) {
          if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
              // Shift the edit over the previous equality.
              diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
              diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
              diffs.splice(pointer - 1, 1);
              changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
              // Shift the edit over the next equality.
              diffs[pointer - 1][1] += diffs[pointer + 1][1];
              diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
              diffs.splice(pointer + 1, 1);
              changes = true;
            }
          }
          pointer++;
        }
        // If shifts were made, the diff needs reordering and another shift sweep.
        if (changes) {
          diff_cleanupMerge(diffs);
        }
      };

      var diff = diff_main;
      diff.INSERT = DIFF_INSERT;
      diff.DELETE = DIFF_DELETE;
      diff.EQUAL = DIFF_EQUAL;

      module.exports = diff;

      /*
       * Modify a diff such that the cursor position points to the start of a change:
       * E.g.
       *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
       *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
       *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
       *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
       *
       * @param {Array} diffs Array of diff tuples
       * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
       * @return {Array} A tuple [cursor location in the modified diff, modified diff]
       */
      function cursor_normalize_diff(diffs, cursor_pos) {
        if (cursor_pos === 0) {
          return [DIFF_EQUAL, diffs];
        }
        for (var current_pos = 0, i = 0; i < diffs.length; i++) {
          var d = diffs[i];
          if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
            var next_pos = current_pos + d[1].length;
            if (cursor_pos === next_pos) {
              return [i + 1, diffs];
            } else if (cursor_pos < next_pos) {
              // copy to prevent side effects
              diffs = diffs.slice();
              // split d into two diff changes
              var split_pos = cursor_pos - current_pos;
              var d_left = [d[0], d[1].slice(0, split_pos)];
              var d_right = [d[0], d[1].slice(split_pos)];
              diffs.splice(i, 1, d_left, d_right);
              return [i + 1, diffs];
            } else {
              current_pos = next_pos;
            }
          }
        }
        throw new Error('cursor_pos is out of bounds!');
      }

      /*
       * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
       *
       * Case 1)
       *   Check if a naive shift is possible:
       *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
       *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
       * Case 2)
       *   Check if the following shifts are possible:
       *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
       *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
       *         ^            ^
       *         d          d_next
       *
       * @param {Array} diffs Array of diff tuples
       * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
       * @return {Array} Array of diff tuples
       */
      function fix_cursor(diffs, cursor_pos) {
        var norm = cursor_normalize_diff(diffs, cursor_pos);
        var ndiffs = norm[1];
        var cursor_pointer = norm[0];
        var d = ndiffs[cursor_pointer];
        var d_next = ndiffs[cursor_pointer + 1];

        if (d == null) {
          // Text was deleted from end of original string,
          // cursor is now out of bounds in new string
          return diffs;
        } else if (d[0] !== DIFF_EQUAL) {
          // A modification happened at the cursor location.
          // This is the expected outcome, so we can return the original diff.
          return diffs;
        } else {
          if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
            // Case 1)
            // It is possible to perform a naive shift
            ndiffs.splice(cursor_pointer, 2, d_next, d);
            return merge_tuples(ndiffs, cursor_pointer, 2);
          } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
            // Case 2)
            // d[1] is a prefix of d_next[1]
            // We can assume that d_next[0] !== 0, since d[0] === 0
            // Shift edit locations..
            ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
            var suffix = d_next[1].slice(d[1].length);
            if (suffix.length > 0) {
              ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
            }
            return merge_tuples(ndiffs, cursor_pointer, 3);
          } else {
            // Not possible to perform any modification
            return diffs;
          }
        }
      }

      /*
       * Check diff did not split surrogate pairs.
       * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
       *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
       *
       * @param {Array} diffs Array of diff tuples
       * @return {Array} Array of diff tuples
       */
      function fix_emoji(diffs) {
        var compact = false;
        var starts_with_pair_end = function starts_with_pair_end(str) {
          return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
        };
        var ends_with_pair_start = function ends_with_pair_start(str) {
          return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
        };
        for (var i = 2; i < diffs.length; i += 1) {
          if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
            compact = true;

            diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
            diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];

            diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
          }
        }
        if (!compact) {
          return diffs;
        }
        var fixed_diffs = [];
        for (var i = 0; i < diffs.length; i += 1) {
          if (diffs[i][1].length > 0) {
            fixed_diffs.push(diffs[i]);
          }
        }
        return fixed_diffs;
      }

      /*
       * Try to merge tuples with their neigbors in a given range.
       * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
       *
       * @param {Array} diffs Array of diff tuples.
       * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
       * @param {Int} length Number of consecutive elements to check.
       * @return {Array} Array of merged diff tuples.
       */
      function merge_tuples(diffs, start, length) {
        // Check from (start-1) to (start+length).
        for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
          if (i + 1 < diffs.length) {
            var left_d = diffs[i];
            var right_d = diffs[i + 1];
            if (left_d[0] === right_d[1]) {
              diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
            }
          }
        }
        return diffs;
      }

      /***/
    },
    /* 52 */
    /***/function (module, exports) {

      exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

      exports.shim = shim;
      function shim(obj) {
        var keys = [];
        for (var key in obj) {
          keys.push(key);
        }return keys;
      }

      /***/
    },
    /* 53 */
    /***/function (module, exports) {

      var supportsArgumentsClass = function () {
        return Object.prototype.toString.call(arguments);
      }() == '[object Arguments]';

      exports = module.exports = supportsArgumentsClass ? supported : unsupported;

      exports.supported = supported;
      function supported(object) {
        return Object.prototype.toString.call(object) == '[object Arguments]';
      };

      exports.unsupported = unsupported;
      function unsupported(object) {
        return object && (typeof object === 'undefined' ? 'undefined' : _typeof2(object)) == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
      };

      /***/
    },
    /* 54 */
    /***/function (module, exports) {

      'use strict';

      var has = Object.prototype.hasOwnProperty,
          prefix = '~';

      /**
       * Constructor to create a storage for our `EE` objects.
       * An `Events` instance is a plain object whose properties are event names.
       *
       * @constructor
       * @api private
       */
      function Events() {}

      //
      // We try to not inherit from `Object.prototype`. In some engines creating an
      // instance in this way is faster than calling `Object.create(null)` directly.
      // If `Object.create(null)` is not supported we prefix the event names with a
      // character to make sure that the built-in object properties are not
      // overridden or used as an attack vector.
      //
      if (Object.create) {
        Events.prototype = Object.create(null);

        //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //
        if (!new Events().__proto__) prefix = false;
      }

      /**
       * Representation of a single event listener.
       *
       * @param {Function} fn The listener function.
       * @param {Mixed} context The context to invoke the listener with.
       * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
       * @constructor
       * @api private
       */
      function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
      }

      /**
       * Minimal `EventEmitter` interface that is molded against the Node.js
       * `EventEmitter` interface.
       *
       * @constructor
       * @api public
       */
      function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
      }

      /**
       * Return an array listing the events for which the emitter has registered
       * listeners.
       *
       * @returns {Array}
       * @api public
       */
      EventEmitter.prototype.eventNames = function eventNames() {
        var names = [],
            events,
            name;

        if (this._eventsCount === 0) return names;

        for (name in events = this._events) {
          if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        }

        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }

        return names;
      };

      /**
       * Return the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Boolean} exists Only check if there are listeners.
       * @returns {Array|Boolean}
       * @api public
       */
      EventEmitter.prototype.listeners = function listeners(event, exists) {
        var evt = prefix ? prefix + event : event,
            available = this._events[evt];

        if (exists) return !!available;
        if (!available) return [];
        if (available.fn) return [available.fn];

        for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
          ee[i] = available[i].fn;
        }

        return ee;
      };

      /**
       * Calls each of the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @returns {Boolean} `true` if the event had listeners, else `false`.
       * @api public
       */
      EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;

        if (!this._events[evt]) return false;

        var listeners = this._events[evt],
            len = arguments.length,
            args,
            i;

        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;
            case 2:
              return listeners.fn.call(listeners.context, a1), true;
            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }

          for (i = 1, args = new Array(len - 1); i < len; i++) {
            args[i - 1] = arguments[i];
          }

          listeners.fn.apply(listeners.context, args);
        } else {
          var length = listeners.length,
              j;

          for (i = 0; i < length; i++) {
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

            switch (len) {
              case 1:
                listeners[i].fn.call(listeners[i].context);break;
              case 2:
                listeners[i].fn.call(listeners[i].context, a1);break;
              case 3:
                listeners[i].fn.call(listeners[i].context, a1, a2);break;
              case 4:
                listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }

                listeners[i].fn.apply(listeners[i].context, args);
            }
          }
        }

        return true;
      };

      /**
       * Add a listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.on = function on(event, fn, context) {
        var listener = new EE(fn, context || this),
            evt = prefix ? prefix + event : event;

        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

        return this;
      };

      /**
       * Add a one-time listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.once = function once(event, fn, context) {
        var listener = new EE(fn, context || this, true),
            evt = prefix ? prefix + event : event;

        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

        return this;
      };

      /**
       * Remove the listeners of a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn Only remove the listeners that match this function.
       * @param {Mixed} context Only remove the listeners that have this context.
       * @param {Boolean} once Only remove one-time listeners.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;

        if (!this._events[evt]) return this;
        if (!fn) {
          if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          return this;
        }

        var listeners = this._events[evt];

        if (listeners.fn) {
          if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          for (var i = 0, events = [], length = listeners.length; i < length; i++) {
            if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
              events.push(listeners[i]);
            }
          }

          //
          // Reset the array, or remove it completely if we have no more listeners.
          //
          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
        }

        return this;
      };

      /**
       * Remove all listeners, or those of the specified event.
       *
       * @param {String|Symbol} [event] The event name.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;

        if (event) {
          evt = prefix ? prefix + event : event;
          if (this._events[evt]) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }

        return this;
      };

      //
      // Alias methods names because people roll like that.
      //
      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.addListener = EventEmitter.prototype.on;

      //
      // This function doesn't apply anymore.
      //
      EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
        return this;
      };

      //
      // Expose the prefix.
      //
      EventEmitter.prefixed = prefix;

      //
      // Allow `EventEmitter` to be imported as module namespace.
      //
      EventEmitter.EventEmitter = EventEmitter;

      //
      // Expose the module.
      //
      if ('undefined' !== typeof module) {
        module.exports = EventEmitter;
      }

      /***/
    },
    /* 55 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend2 = __webpack_require__(3);

      var _extend3 = _interopRequireDefault(_extend2);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _align = __webpack_require__(36);

      var _background = __webpack_require__(37);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _color = __webpack_require__(26);

      var _direction = __webpack_require__(38);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:clipboard');

      var DOM_KEY = '__ql-matcher';

      var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

      var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});

      var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});

      var Clipboard = function (_Module) {
        _inherits(Clipboard, _Module);

        function Clipboard(quill, options) {
          _classCallCheck(this, Clipboard);

          var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

          _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
          _this.container = _this.quill.addContainer('ql-clipboard');
          _this.container.setAttribute('contenteditable', true);
          _this.container.setAttribute('tabindex', -1);
          _this.matchers = [];
          CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                selector = _ref2[0],
                matcher = _ref2[1];

            if (!options.matchVisual && matcher === matchSpacing) return;
            _this.addMatcher(selector, matcher);
          });
          return _this;
        }

        _createClass(Clipboard, [{
          key: 'addMatcher',
          value: function addMatcher(selector, matcher) {
            this.matchers.push([selector, matcher]);
          }
        }, {
          key: 'convert',
          value: function convert(html) {
            if (typeof html === 'string') {
              this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
              return this.convert();
            }
            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
            if (formats[_code2.default.blotName]) {
              var text = this.container.innerText;
              this.container.innerHTML = '';
              return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
            }

            var _prepareMatching = this.prepareMatching(),
                _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
                elementMatchers = _prepareMatching2[0],
                textMatchers = _prepareMatching2[1];

            var delta = traverse(this.container, elementMatchers, textMatchers);
            // Remove trailing newline
            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
              delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
            }
            debug.log('convert', this.container.innerHTML, delta);
            this.container.innerHTML = '';
            return delta;
          }
        }, {
          key: 'dangerouslyPasteHTML',
          value: function dangerouslyPasteHTML(index, html) {
            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

            if (typeof index === 'string') {
              return this.quill.setContents(this.convert(index), html);
            } else {
              var paste = this.convert(html);
              return this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
            }
          }
        }, {
          key: 'onPaste',
          value: function onPaste(e) {
            var _this2 = this;

            if (e.defaultPrevented || !this.quill.isEnabled()) return;
            var range = this.quill.getSelection();
            var delta = new _quillDelta2.default().retain(range.index);
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.container.focus();
            this.quill.selection.update(_quill2.default.sources.SILENT);
            setTimeout(function () {
              delta = delta.concat(_this2.convert()).delete(range.length);
              _this2.quill.updateContents(delta, _quill2.default.sources.USER);
              // range.length contributes to delta.length()
              _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
              _this2.quill.scrollingContainer.scrollTop = scrollTop;
              _this2.quill.focus();
            }, 1);
          }
        }, {
          key: 'prepareMatching',
          value: function prepareMatching() {
            var _this3 = this;

            var elementMatchers = [],
                textMatchers = [];
            this.matchers.forEach(function (pair) {
              var _pair = _slicedToArray(pair, 2),
                  selector = _pair[0],
                  matcher = _pair[1];

              switch (selector) {
                case Node.TEXT_NODE:
                  textMatchers.push(matcher);
                  break;
                case Node.ELEMENT_NODE:
                  elementMatchers.push(matcher);
                  break;
                default:
                  [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
                    // TODO use weakmap
                    node[DOM_KEY] = node[DOM_KEY] || [];
                    node[DOM_KEY].push(matcher);
                  });
                  break;
              }
            });
            return [elementMatchers, textMatchers];
          }
        }]);

        return Clipboard;
      }(_module2.default);

      Clipboard.DEFAULTS = {
        matchers: [],
        matchVisual: true
      };

      function applyFormat(delta, format, value) {
        if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
          return Object.keys(format).reduce(function (delta, key) {
            return applyFormat(delta, key, format[key]);
          }, delta);
        } else {
          return delta.reduce(function (delta, op) {
            if (op.attributes && op.attributes[format]) {
              return delta.push(op);
            } else {
              return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
            }
          }, new _quillDelta2.default());
        }
      }

      function computeStyle(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return {};
        var DOM_KEY = '__ql-computed-style';
        return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
      }

      function deltaEndsWith(delta, text) {
        var endText = "";
        for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
          var op = delta.ops[i];
          if (typeof op.insert !== 'string') break;
          endText = op.insert + endText;
        }
        return endText.slice(-1 * text.length) === text;
      }

      function isLine(node) {
        if (node.childNodes.length === 0) return false; // Exclude embed blocks
        var style = computeStyle(node);
        return ['block', 'list-item'].indexOf(style.display) > -1;
      }

      function traverse(node, elementMatchers, textMatchers) {
        // Post-order
        if (node.nodeType === node.TEXT_NODE) {
          return textMatchers.reduce(function (delta, matcher) {
            return matcher(node, delta);
          }, new _quillDelta2.default());
        } else if (node.nodeType === node.ELEMENT_NODE) {
          return [].reduce.call(node.childNodes || [], function (delta, childNode) {
            var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
            if (childNode.nodeType === node.ELEMENT_NODE) {
              childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
                return matcher(childNode, childrenDelta);
              }, childrenDelta);
              childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
                return matcher(childNode, childrenDelta);
              }, childrenDelta);
            }
            return delta.concat(childrenDelta);
          }, new _quillDelta2.default());
        } else {
          return new _quillDelta2.default();
        }
      }

      function matchAlias(format, node, delta) {
        return applyFormat(delta, format, true);
      }

      function matchAttributor(node, delta) {
        var attributes = _parchment2.default.Attributor.Attribute.keys(node);
        var classes = _parchment2.default.Attributor.Class.keys(node);
        var styles = _parchment2.default.Attributor.Style.keys(node);
        var formats = {};
        attributes.concat(classes).concat(styles).forEach(function (name) {
          var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
          if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
          }
          attr = ATTRIBUTE_ATTRIBUTORS[name];
          if (attr != null && attr.attrName === name) {
            formats[attr.attrName] = attr.value(node) || undefined;
          }
          attr = STYLE_ATTRIBUTORS[name];
          if (attr != null && attr.attrName === name) {
            attr = STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
          }
        });
        if (Object.keys(formats).length > 0) {
          delta = applyFormat(delta, formats);
        }
        return delta;
      }

      function matchBlot(node, delta) {
        var match = _parchment2.default.query(node);
        if (match == null) return delta;
        if (match.prototype instanceof _parchment2.default.Embed) {
          var embed = {};
          var value = match.value(node);
          if (value != null) {
            embed[match.blotName] = value;
            delta = new _quillDelta2.default().insert(embed, match.formats(node));
          }
        } else if (typeof match.formats === 'function') {
          delta = applyFormat(delta, match.blotName, match.formats(node));
        }
        return delta;
      }

      function matchBreak(node, delta) {
        if (!deltaEndsWith(delta, '\n')) {
          delta.insert('\n');
        }
        return delta;
      }

      function matchIgnore() {
        return new _quillDelta2.default();
      }

      function matchIndent(node, delta) {
        var match = _parchment2.default.query(node);
        if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
          return delta;
        }
        var indent = -1,
            parent = node.parentNode;
        while (!parent.classList.contains('ql-clipboard')) {
          if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
            indent += 1;
          }
          parent = parent.parentNode;
        }
        if (indent <= 0) return delta;
        return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
      }

      function matchNewline(node, delta) {
        if (!deltaEndsWith(delta, '\n')) {
          if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
            delta.insert('\n');
          }
        }
        return delta;
      }

      function matchSpacing(node, delta) {
        if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
          var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
          if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
            delta.insert('\n');
          }
        }
        return delta;
      }

      function matchStyles(node, delta) {
        var formats = {};
        var style = node.style || {};
        if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
          formats.italic = true;
        }
        if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
          formats.bold = true;
        }
        if (Object.keys(formats).length > 0) {
          delta = applyFormat(delta, formats);
        }
        if (parseFloat(style.textIndent || 0) > 0) {
          // Could be 0.5in
          delta = new _quillDelta2.default().insert('\t').concat(delta);
        }
        return delta;
      }

      function matchText(node, delta) {
        var text = node.data;
        // Word represents empty line with <o:p>&nbsp;</o:p>
        if (node.parentNode.tagName === 'O:P') {
          return delta.insert(text.trim());
        }
        if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
          return delta;
        }
        if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
          // eslint-disable-next-line func-style
          var replacer = function replacer(collapse, match) {
            match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
            return match.length < 1 && collapse ? ' ' : match;
          };
          text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
          text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
          if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
            text = text.replace(/^\s+/, replacer.bind(replacer, false));
          }
          if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
            text = text.replace(/\s+$/, replacer.bind(replacer, false));
          }
        }
        return delta.insert(text);
      }

      exports.default = Clipboard;
      exports.matchAttributor = matchAttributor;
      exports.matchBlot = matchBlot;
      exports.matchNewline = matchNewline;
      exports.matchSpacing = matchSpacing;
      exports.matchText = matchText;

      /***/
    },
    /* 56 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Bold = function (_Inline) {
        _inherits(Bold, _Inline);

        function Bold() {
          _classCallCheck(this, Bold);

          return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
        }

        _createClass(Bold, [{
          key: 'optimize',
          value: function optimize(context) {
            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
            if (this.domNode.tagName !== this.statics.tagName[0]) {
              this.replaceWith(this.statics.blotName);
            }
          }
        }], [{
          key: 'create',
          value: function create() {
            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
          }
        }, {
          key: 'formats',
          value: function formats() {
            return true;
          }
        }]);

        return Bold;
      }(_inline2.default);

      Bold.blotName = 'bold';
      Bold.tagName = ['STRONG', 'B'];

      exports.default = Bold;

      /***/
    },
    /* 57 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.addControls = exports.default = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:toolbar');

      var Toolbar = function (_Module) {
        _inherits(Toolbar, _Module);

        function Toolbar(quill, options) {
          _classCallCheck(this, Toolbar);

          var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

          if (Array.isArray(_this.options.container)) {
            var container = document.createElement('div');
            addControls(container, _this.options.container);
            quill.container.parentNode.insertBefore(container, quill.container);
            _this.container = container;
          } else if (typeof _this.options.container === 'string') {
            _this.container = document.querySelector(_this.options.container);
          } else {
            _this.container = _this.options.container;
          }
          if (!(_this.container instanceof HTMLElement)) {
            var _ret;

            return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
          }
          _this.container.classList.add('ql-toolbar');
          _this.controls = [];
          _this.handlers = {};
          Object.keys(_this.options.handlers).forEach(function (format) {
            _this.addHandler(format, _this.options.handlers[format]);
          });
          [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
            _this.attach(input);
          });
          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
            if (type === _quill2.default.events.SELECTION_CHANGE) {
              _this.update(range);
            }
          });
          _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            var _this$quill$selection = _this.quill.selection.getRange(),
                _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
                range = _this$quill$selection2[0]; // quill.getSelection triggers update


            _this.update(range);
          });
          return _this;
        }

        _createClass(Toolbar, [{
          key: 'addHandler',
          value: function addHandler(format, handler) {
            this.handlers[format] = handler;
          }
        }, {
          key: 'attach',
          value: function attach(input) {
            var _this2 = this;

            var format = [].find.call(input.classList, function (className) {
              return className.indexOf('ql-') === 0;
            });
            if (!format) return;
            format = format.slice('ql-'.length);
            if (input.tagName === 'BUTTON') {
              input.setAttribute('type', 'button');
            }
            if (this.handlers[format] == null) {
              if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                debug.warn('ignoring attaching to disabled format', format, input);
                return;
              }
              if (_parchment2.default.query(format) == null) {
                debug.warn('ignoring attaching to nonexistent format', format, input);
                return;
              }
            }
            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
            input.addEventListener(eventName, function (e) {
              var value = void 0;
              if (input.tagName === 'SELECT') {
                if (input.selectedIndex < 0) return;
                var selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) {
                  value = false;
                } else {
                  value = selected.value || false;
                }
              } else {
                if (input.classList.contains('ql-active')) {
                  value = false;
                } else {
                  value = input.value || !input.hasAttribute('value');
                }
                e.preventDefault();
              }
              _this2.quill.focus();

              var _quill$selection$getR = _this2.quill.selection.getRange(),
                  _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
                  range = _quill$selection$getR2[0];

              if (_this2.handlers[format] != null) {
                _this2.handlers[format].call(_this2, value);
              } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                value = prompt('Enter ' + format);
                if (!value) return;
                _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
              } else {
                _this2.quill.format(format, value, _quill2.default.sources.USER);
              }
              _this2.update(range);
            });
            // TODO use weakmap
            this.controls.push([format, input]);
          }
        }, {
          key: 'update',
          value: function update(range) {
            var formats = range == null ? {} : this.quill.getFormat(range);
            this.controls.forEach(function (pair) {
              var _pair = _slicedToArray(pair, 2),
                  format = _pair[0],
                  input = _pair[1];

              if (input.tagName === 'SELECT') {
                var option = void 0;
                if (range == null) {
                  option = null;
                } else if (formats[format] == null) {
                  option = input.querySelector('option[selected]');
                } else if (!Array.isArray(formats[format])) {
                  var value = formats[format];
                  if (typeof value === 'string') {
                    value = value.replace(/\"/g, '\\"');
                  }
                  option = input.querySelector('option[value="' + value + '"]');
                }
                if (option == null) {
                  input.value = ''; // TODO make configurable?
                  input.selectedIndex = -1;
                } else {
                  option.selected = true;
                }
              } else {
                if (range == null) {
                  input.classList.remove('ql-active');
                } else if (input.hasAttribute('value')) {
                  // both being null should match (default values)
                  // '1' should match with 1 (headers)
                  var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                  input.classList.toggle('ql-active', isActive);
                } else {
                  input.classList.toggle('ql-active', formats[format] != null);
                }
              }
            });
          }
        }]);

        return Toolbar;
      }(_module2.default);

      Toolbar.DEFAULTS = {};

      function addButton(container, format, value) {
        var input = document.createElement('button');
        input.setAttribute('type', 'button');
        input.classList.add('ql-' + format);
        if (value != null) {
          input.value = value;
        }
        container.appendChild(input);
      }

      function addControls(container, groups) {
        if (!Array.isArray(groups[0])) {
          groups = [groups];
        }
        groups.forEach(function (controls) {
          var group = document.createElement('span');
          group.classList.add('ql-formats');
          controls.forEach(function (control) {
            if (typeof control === 'string') {
              addButton(group, control);
            } else {
              var format = Object.keys(control)[0];
              var value = control[format];
              if (Array.isArray(value)) {
                addSelect(group, format, value);
              } else {
                addButton(group, format, value);
              }
            }
          });
          container.appendChild(group);
        });
      }

      function addSelect(container, format, values) {
        var input = document.createElement('select');
        input.classList.add('ql-' + format);
        values.forEach(function (value) {
          var option = document.createElement('option');
          if (value !== false) {
            option.setAttribute('value', value);
          } else {
            option.setAttribute('selected', 'selected');
          }
          input.appendChild(option);
        });
        container.appendChild(input);
      }

      Toolbar.DEFAULTS = {
        container: null,
        handlers: {
          clean: function clean() {
            var _this3 = this;

            var range = this.quill.getSelection();
            if (range == null) return;
            if (range.length == 0) {
              var formats = this.quill.getFormat();
              Object.keys(formats).forEach(function (name) {
                // Clean functionality in existing apps only clean inline formats
                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
                  _this3.quill.format(name, false);
                }
              });
            } else {
              this.quill.removeFormat(range, _quill2.default.sources.USER);
            }
          },
          direction: function direction(value) {
            var align = this.quill.getFormat()['align'];
            if (value === 'rtl' && align == null) {
              this.quill.format('align', 'right', _quill2.default.sources.USER);
            } else if (!value && align === 'right') {
              this.quill.format('align', false, _quill2.default.sources.USER);
            }
            this.quill.format('direction', value, _quill2.default.sources.USER);
          },
          indent: function indent(value) {
            var range = this.quill.getSelection();
            var formats = this.quill.getFormat(range);
            var indent = parseInt(formats.indent || 0);
            if (value === '+1' || value === '-1') {
              var modifier = value === '+1' ? 1 : -1;
              if (formats.direction === 'rtl') modifier *= -1;
              this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
            }
          },
          link: function link(value) {
            if (value === true) {
              value = prompt('Enter link URL:');
            }
            this.quill.format('link', value, _quill2.default.sources.USER);
          },
          list: function list(value) {
            var range = this.quill.getSelection();
            var formats = this.quill.getFormat(range);
            if (value === 'check') {
              if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
                this.quill.format('list', false, _quill2.default.sources.USER);
              } else {
                this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
              }
            } else {
              this.quill.format('list', value, _quill2.default.sources.USER);
            }
          }
        }
      };

      exports.default = Toolbar;
      exports.addControls = addControls;

      /***/
    },
    /* 58 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

      /***/
    },
    /* 59 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorPicker = function (_Picker) {
        _inherits(ColorPicker, _Picker);

        function ColorPicker(select, label) {
          _classCallCheck(this, ColorPicker);

          var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

          _this.label.innerHTML = label;
          _this.container.classList.add('ql-color-picker');
          [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
            item.classList.add('ql-primary');
          });
          return _this;
        }

        _createClass(ColorPicker, [{
          key: 'buildItem',
          value: function buildItem(option) {
            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
            item.style.backgroundColor = option.getAttribute('value') || '';
            return item;
          }
        }, {
          key: 'selectItem',
          value: function selectItem(item, trigger) {
            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
            var colorLabel = this.label.querySelector('.ql-color-label');
            var value = item ? item.getAttribute('data-value') || '' : '';
            if (colorLabel) {
              if (colorLabel.tagName === 'line') {
                colorLabel.style.stroke = value;
              } else {
                colorLabel.style.fill = value;
              }
            }
          }
        }]);

        return ColorPicker;
      }(_picker2.default);

      exports.default = ColorPicker;

      /***/
    },
    /* 60 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IconPicker = function (_Picker) {
        _inherits(IconPicker, _Picker);

        function IconPicker(select, icons) {
          _classCallCheck(this, IconPicker);

          var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

          _this.container.classList.add('ql-icon-picker');
          [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
          });
          _this.defaultItem = _this.container.querySelector('.ql-selected');
          _this.selectItem(_this.defaultItem);
          return _this;
        }

        _createClass(IconPicker, [{
          key: 'selectItem',
          value: function selectItem(item, trigger) {
            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
            item = item || this.defaultItem;
            this.label.innerHTML = item.innerHTML;
          }
        }]);

        return IconPicker;
      }(_picker2.default);

      exports.default = IconPicker;

      /***/
    },
    /* 61 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Tooltip = function () {
        function Tooltip(quill, boundsContainer) {
          var _this = this;

          _classCallCheck(this, Tooltip);

          this.quill = quill;
          this.boundsContainer = boundsContainer || document.body;
          this.root = quill.addContainer('ql-tooltip');
          this.root.innerHTML = this.constructor.TEMPLATE;
          if (this.quill.root === this.quill.scrollingContainer) {
            this.quill.root.addEventListener('scroll', function () {
              _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
            });
          }
          this.hide();
        }

        _createClass(Tooltip, [{
          key: 'hide',
          value: function hide() {
            this.root.classList.add('ql-hidden');
          }
        }, {
          key: 'position',
          value: function position(reference) {
            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
            // root.scrollTop should be 0 if scrollContainer !== root
            var top = reference.bottom + this.quill.root.scrollTop;
            this.root.style.left = left + 'px';
            this.root.style.top = top + 'px';
            this.root.classList.remove('ql-flip');
            var containerBounds = this.boundsContainer.getBoundingClientRect();
            var rootBounds = this.root.getBoundingClientRect();
            var shift = 0;
            if (rootBounds.right > containerBounds.right) {
              shift = containerBounds.right - rootBounds.right;
              this.root.style.left = left + shift + 'px';
            }
            if (rootBounds.left < containerBounds.left) {
              shift = containerBounds.left - rootBounds.left;
              this.root.style.left = left + shift + 'px';
            }
            if (rootBounds.bottom > containerBounds.bottom) {
              var height = rootBounds.bottom - rootBounds.top;
              var verticalShift = reference.bottom - reference.top + height;
              this.root.style.top = top - verticalShift + 'px';
              this.root.classList.add('ql-flip');
            }
            return shift;
          }
        }, {
          key: 'show',
          value: function show() {
            this.root.classList.remove('ql-editing');
            this.root.classList.remove('ql-hidden');
          }
        }]);

        return Tooltip;
      }();

      exports.default = Tooltip;

      /***/
    },
    /* 62 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

      var SnowTheme = function (_BaseTheme) {
        _inherits(SnowTheme, _BaseTheme);

        function SnowTheme(quill, options) {
          _classCallCheck(this, SnowTheme);

          if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
            options.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

          _this.quill.container.classList.add('ql-snow');
          return _this;
        }

        _createClass(SnowTheme, [{
          key: 'extendToolbar',
          value: function extendToolbar(toolbar) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) {
              this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
                toolbar.handlers['link'].call(toolbar, !context.format.link);
              });
            }
          }
        }]);

        return SnowTheme;
      }(_base2.default);

      SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (value) {
                  var range = this.quill.getSelection();
                  if (range == null || range.length == 0) return;
                  var preview = this.quill.getText(range);
                  if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
                    preview = 'mailto:' + preview;
                  }
                  var tooltip = this.quill.theme.tooltip;
                  tooltip.edit('link', preview);
                } else {
                  this.quill.format('link', false);
                }
              }
            }
          }
        }
      });

      var SnowTooltip = function (_BaseTooltip) {
        _inherits(SnowTooltip, _BaseTooltip);

        function SnowTooltip(quill, bounds) {
          _classCallCheck(this, SnowTooltip);

          var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

          _this2.preview = _this2.root.querySelector('a.ql-preview');
          return _this2;
        }

        _createClass(SnowTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this3 = this;

            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
            this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
              if (_this3.root.classList.contains('ql-editing')) {
                _this3.save();
              } else {
                _this3.edit('link', _this3.preview.textContent);
              }
              event.preventDefault();
            });
            this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
              if (_this3.linkRange != null) {
                var range = _this3.linkRange;
                _this3.restoreFocus();
                _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                delete _this3.linkRange;
              }
              event.preventDefault();
              _this3.hide();
            });
            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
              if (range == null) return;
              if (range.length === 0 && source === _emitter2.default.sources.USER) {
                var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
                    _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
                    link = _quill$scroll$descend2[0],
                    offset = _quill$scroll$descend2[1];

                if (link != null) {
                  _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                  var preview = _link2.default.formats(link.domNode);
                  _this3.preview.textContent = preview;
                  _this3.preview.setAttribute('href', preview);
                  _this3.show();
                  _this3.position(_this3.quill.getBounds(_this3.linkRange));
                  return;
                }
              } else {
                delete _this3.linkRange;
              }
              _this3.hide();
            });
          }
        }, {
          key: 'show',
          value: function show() {
            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
            this.root.removeAttribute('data-mode');
          }
        }]);

        return SnowTooltip;
      }(_base.BaseTooltip);

      SnowTooltip.TEMPLATE = ['<a class="ql-preview" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

      exports.default = SnowTheme;

      /***/
    },
    /* 63 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _core = __webpack_require__(29);

      var _core2 = _interopRequireDefault(_core);

      var _align = __webpack_require__(36);

      var _direction = __webpack_require__(38);

      var _indent = __webpack_require__(64);

      var _blockquote = __webpack_require__(65);

      var _blockquote2 = _interopRequireDefault(_blockquote);

      var _header = __webpack_require__(66);

      var _header2 = _interopRequireDefault(_header);

      var _list = __webpack_require__(67);

      var _list2 = _interopRequireDefault(_list);

      var _background = __webpack_require__(37);

      var _color = __webpack_require__(26);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      var _italic = __webpack_require__(68);

      var _italic2 = _interopRequireDefault(_italic);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      var _script = __webpack_require__(69);

      var _script2 = _interopRequireDefault(_script);

      var _strike = __webpack_require__(70);

      var _strike2 = _interopRequireDefault(_strike);

      var _underline = __webpack_require__(71);

      var _underline2 = _interopRequireDefault(_underline);

      var _image = __webpack_require__(72);

      var _image2 = _interopRequireDefault(_image);

      var _video = __webpack_require__(73);

      var _video2 = _interopRequireDefault(_video);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _formula = __webpack_require__(74);

      var _formula2 = _interopRequireDefault(_formula);

      var _syntax = __webpack_require__(75);

      var _syntax2 = _interopRequireDefault(_syntax);

      var _toolbar = __webpack_require__(57);

      var _toolbar2 = _interopRequireDefault(_toolbar);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      var _bubble = __webpack_require__(108);

      var _bubble2 = _interopRequireDefault(_bubble);

      var _snow = __webpack_require__(62);

      var _snow2 = _interopRequireDefault(_snow);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      _core2.default.register({
        'attributors/attribute/direction': _direction.DirectionAttribute,

        'attributors/class/align': _align.AlignClass,
        'attributors/class/background': _background.BackgroundClass,
        'attributors/class/color': _color.ColorClass,
        'attributors/class/direction': _direction.DirectionClass,
        'attributors/class/font': _font.FontClass,
        'attributors/class/size': _size.SizeClass,

        'attributors/style/align': _align.AlignStyle,
        'attributors/style/background': _background.BackgroundStyle,
        'attributors/style/color': _color.ColorStyle,
        'attributors/style/direction': _direction.DirectionStyle,
        'attributors/style/font': _font.FontStyle,
        'attributors/style/size': _size.SizeStyle
      }, true);

      _core2.default.register({
        'formats/align': _align.AlignClass,
        'formats/direction': _direction.DirectionClass,
        'formats/indent': _indent.IndentClass,

        'formats/background': _background.BackgroundStyle,
        'formats/color': _color.ColorStyle,
        'formats/font': _font.FontClass,
        'formats/size': _size.SizeClass,

        'formats/blockquote': _blockquote2.default,
        'formats/code-block': _code2.default,
        'formats/header': _header2.default,
        'formats/list': _list2.default,

        'formats/bold': _bold2.default,
        'formats/code': _code.Code,
        'formats/italic': _italic2.default,
        'formats/link': _link2.default,
        'formats/script': _script2.default,
        'formats/strike': _strike2.default,
        'formats/underline': _underline2.default,

        'formats/image': _image2.default,
        'formats/video': _video2.default,

        'formats/list/item': _list.ListItem,

        'modules/formula': _formula2.default,
        'modules/syntax': _syntax2.default,
        'modules/toolbar': _toolbar2.default,

        'themes/bubble': _bubble2.default,
        'themes/snow': _snow2.default,

        'ui/icons': _icons2.default,
        'ui/picker': _picker2.default,
        'ui/icon-picker': _iconPicker2.default,
        'ui/color-picker': _colorPicker2.default,
        'ui/tooltip': _tooltip2.default
      }, true);

      exports.default = _core2.default;

      /***/
    },
    /* 64 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.IndentClass = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IdentAttributor = function (_Parchment$Attributor) {
        _inherits(IdentAttributor, _Parchment$Attributor);

        function IdentAttributor() {
          _classCallCheck(this, IdentAttributor);

          return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
        }

        _createClass(IdentAttributor, [{
          key: 'add',
          value: function add(node, value) {
            if (value === '+1' || value === '-1') {
              var indent = this.value(node) || 0;
              value = value === '+1' ? indent + 1 : indent - 1;
            }
            if (value === 0) {
              this.remove(node);
              return true;
            } else {
              return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
            }
          }
        }, {
          key: 'canAdd',
          value: function canAdd(node, value) {
            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
          }
        }, {
          key: 'value',
          value: function value(node) {
            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
          }
        }]);

        return IdentAttributor;
      }(_parchment2.default.Attributor.Class);

      var IndentClass = new IdentAttributor('indent', 'ql-indent', {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
      });

      exports.IndentClass = IndentClass;

      /***/
    },
    /* 65 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Blockquote = function (_Block) {
        _inherits(Blockquote, _Block);

        function Blockquote() {
          _classCallCheck(this, Blockquote);

          return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
        }

        return Blockquote;
      }(_block2.default);

      Blockquote.blotName = 'blockquote';
      Blockquote.tagName = 'blockquote';

      exports.default = Blockquote;

      /***/
    },
    /* 66 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Header = function (_Block) {
        _inherits(Header, _Block);

        function Header() {
          _classCallCheck(this, Header);

          return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
        }

        _createClass(Header, null, [{
          key: 'formats',
          value: function formats(domNode) {
            return this.tagName.indexOf(domNode.tagName) + 1;
          }
        }]);

        return Header;
      }(_block2.default);

      Header.blotName = 'header';
      Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

      exports.default = Header;

      /***/
    },
    /* 67 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.ListItem = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _container = __webpack_require__(24);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ListItem = function (_Block) {
        _inherits(ListItem, _Block);

        function ListItem() {
          _classCallCheck(this, ListItem);

          return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
        }

        _createClass(ListItem, [{
          key: 'format',
          value: function format(name, value) {
            if (name === List.blotName && !value) {
              this.replaceWith(_parchment2.default.create(this.statics.scope));
            } else {
              _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
            }
          }
        }, {
          key: 'remove',
          value: function remove() {
            if (this.prev == null && this.next == null) {
              this.parent.remove();
            } else {
              _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
            }
          }
        }, {
          key: 'replaceWith',
          value: function replaceWith(name, value) {
            this.parent.isolate(this.offset(this.parent), this.length());
            if (name === this.parent.statics.blotName) {
              this.parent.replaceWith(name, value);
              return this;
            } else {
              this.parent.unwrap();
              return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
            }
          }
        }], [{
          key: 'formats',
          value: function formats(domNode) {
            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
          }
        }]);

        return ListItem;
      }(_block2.default);

      ListItem.blotName = 'list-item';
      ListItem.tagName = 'LI';

      var List = function (_Container) {
        _inherits(List, _Container);

        _createClass(List, null, [{
          key: 'create',
          value: function create(value) {
            var tagName = value === 'ordered' ? 'OL' : 'UL';
            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
            if (value === 'checked' || value === 'unchecked') {
              node.setAttribute('data-checked', value === 'checked');
            }
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            if (domNode.tagName === 'OL') return 'ordered';
            if (domNode.tagName === 'UL') {
              if (domNode.hasAttribute('data-checked')) {
                return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
              } else {
                return 'bullet';
              }
            }
            return undefined;
          }
        }]);

        function List(domNode) {
          _classCallCheck(this, List);

          var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

          var listEventHandler = function listEventHandler(e) {
            if (e.target.parentNode !== domNode) return;
            var format = _this2.statics.formats(domNode);
            var blot = _parchment2.default.find(e.target);
            if (format === 'checked') {
              blot.format('list', 'unchecked');
            } else if (format === 'unchecked') {
              blot.format('list', 'checked');
            }
          };

          domNode.addEventListener('touchstart', listEventHandler);
          domNode.addEventListener('mousedown', listEventHandler);
          return _this2;
        }

        _createClass(List, [{
          key: 'format',
          value: function format(name, value) {
            if (this.children.length > 0) {
              this.children.tail.format(name, value);
            }
          }
        }, {
          key: 'formats',
          value: function formats() {
            // We don't inherit from FormatBlot
            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            if (blot instanceof ListItem) {
              _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
            } else {
              var index = ref == null ? this.length() : ref.offset(this);
              var after = this.split(index);
              after.parent.insertBefore(blot, after);
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
            var next = this.next;
            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
              next.moveChildren(this);
              next.remove();
            }
          }
        }, {
          key: 'replace',
          value: function replace(target) {
            if (target.statics.blotName !== this.statics.blotName) {
              var item = _parchment2.default.create(this.statics.defaultChild);
              target.moveChildren(item);
              this.appendChild(item);
            }
            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
          }
        }]);

        return List;
      }(_container2.default);

      List.blotName = 'list';
      List.scope = _parchment2.default.Scope.BLOCK_BLOT;
      List.tagName = ['OL', 'UL'];
      List.defaultChild = 'list-item';
      List.allowedChildren = [ListItem];

      exports.ListItem = ListItem;
      exports.default = List;

      /***/
    },
    /* 68 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Italic = function (_Bold) {
        _inherits(Italic, _Bold);

        function Italic() {
          _classCallCheck(this, Italic);

          return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
        }

        return Italic;
      }(_bold2.default);

      Italic.blotName = 'italic';
      Italic.tagName = ['EM', 'I'];

      exports.default = Italic;

      /***/
    },
    /* 69 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Script = function (_Inline) {
        _inherits(Script, _Inline);

        function Script() {
          _classCallCheck(this, Script);

          return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
        }

        _createClass(Script, null, [{
          key: 'create',
          value: function create(value) {
            if (value === 'super') {
              return document.createElement('sup');
            } else if (value === 'sub') {
              return document.createElement('sub');
            } else {
              return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
            }
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            if (domNode.tagName === 'SUB') return 'sub';
            if (domNode.tagName === 'SUP') return 'super';
            return undefined;
          }
        }]);

        return Script;
      }(_inline2.default);

      Script.blotName = 'script';
      Script.tagName = ['SUB', 'SUP'];

      exports.default = Script;

      /***/
    },
    /* 70 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Strike = function (_Inline) {
        _inherits(Strike, _Inline);

        function Strike() {
          _classCallCheck(this, Strike);

          return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
        }

        return Strike;
      }(_inline2.default);

      Strike.blotName = 'strike';
      Strike.tagName = 'S';

      exports.default = Strike;

      /***/
    },
    /* 71 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Underline = function (_Inline) {
        _inherits(Underline, _Inline);

        function Underline() {
          _classCallCheck(this, Underline);

          return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
        }

        return Underline;
      }(_inline2.default);

      Underline.blotName = 'underline';
      Underline.tagName = 'U';

      exports.default = Underline;

      /***/
    },
    /* 72 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _link = __webpack_require__(27);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ['alt', 'height', 'width'];

      var Image = function (_Parchment$Embed) {
        _inherits(Image, _Parchment$Embed);

        function Image() {
          _classCallCheck(this, Image);

          return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
        }

        _createClass(Image, [{
          key: 'format',
          value: function format(name, value) {
            if (ATTRIBUTES.indexOf(name) > -1) {
              if (value) {
                this.domNode.setAttribute(name, value);
              } else {
                this.domNode.removeAttribute(name);
              }
            } else {
              _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
            }
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
            if (typeof value === 'string') {
              node.setAttribute('src', this.sanitize(value));
            }
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return ATTRIBUTES.reduce(function (formats, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
              }
              return formats;
            }, {});
          }
        }, {
          key: 'match',
          value: function match(url) {
            return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
            );
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('src');
          }
        }]);

        return Image;
      }(_parchment2.default.Embed);

      Image.blotName = 'image';
      Image.tagName = 'IMG';

      exports.default = Image;

      /***/
    },
    /* 73 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _block = __webpack_require__(4);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ['height', 'width'];

      var Video = function (_BlockEmbed) {
        _inherits(Video, _BlockEmbed);

        function Video() {
          _classCallCheck(this, Video);

          return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
        }

        _createClass(Video, [{
          key: 'format',
          value: function format(name, value) {
            if (ATTRIBUTES.indexOf(name) > -1) {
              if (value) {
                this.domNode.setAttribute(name, value);
              } else {
                this.domNode.removeAttribute(name);
              }
            } else {
              _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
            }
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
            node.setAttribute('frameborder', '0');
            node.setAttribute('allowfullscreen', true);
            node.setAttribute('src', this.sanitize(value));
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return ATTRIBUTES.reduce(function (formats, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
              }
              return formats;
            }, {});
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return _link2.default.sanitize(url);
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('src');
          }
        }]);

        return Video;
      }(_block.BlockEmbed);

      Video.blotName = 'video';
      Video.className = 'ql-video';
      Video.tagName = 'IFRAME';

      exports.default = Video;

      /***/
    },
    /* 74 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.FormulaBlot = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _embed = __webpack_require__(25);

      var _embed2 = _interopRequireDefault(_embed);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var FormulaBlot = function (_Embed) {
        _inherits(FormulaBlot, _Embed);

        function FormulaBlot() {
          _classCallCheck(this, FormulaBlot);

          return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
        }

        _createClass(FormulaBlot, null, [{
          key: 'create',
          value: function create(value) {
            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
            if (typeof value === 'string') {
              window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
              });
              node.setAttribute('data-value', value);
            }
            return node;
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('data-value');
          }
        }]);

        return FormulaBlot;
      }(_embed2.default);

      FormulaBlot.blotName = 'formula';
      FormulaBlot.className = 'ql-formula';
      FormulaBlot.tagName = 'SPAN';

      var Formula = function (_Module) {
        _inherits(Formula, _Module);

        _createClass(Formula, null, [{
          key: 'register',
          value: function register() {
            _quill2.default.register(FormulaBlot, true);
          }
        }]);

        function Formula() {
          _classCallCheck(this, Formula);

          var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

          if (window.katex == null) {
            throw new Error('Formula module requires KaTeX.');
          }
          return _this2;
        }

        return Formula;
      }(_module2.default);

      exports.FormulaBlot = FormulaBlot;
      exports.default = Formula;

      /***/
    },
    /* 75 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.CodeToken = exports.CodeBlock = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var SyntaxCodeBlock = function (_CodeBlock) {
        _inherits(SyntaxCodeBlock, _CodeBlock);

        function SyntaxCodeBlock() {
          _classCallCheck(this, SyntaxCodeBlock);

          return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
        }

        _createClass(SyntaxCodeBlock, [{
          key: 'replaceWith',
          value: function replaceWith(block) {
            this.domNode.textContent = this.domNode.textContent;
            this.attach();
            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
          }
        }, {
          key: 'highlight',
          value: function highlight(_highlight) {
            var text = this.domNode.textContent;
            if (this.cachedText !== text) {
              if (text.trim().length > 0 || this.cachedText == null) {
                this.domNode.innerHTML = _highlight(text);
                this.domNode.normalize();
                this.attach();
              }
              this.cachedText = text;
            }
          }
        }]);

        return SyntaxCodeBlock;
      }(_code2.default);

      SyntaxCodeBlock.className = 'ql-syntax';

      var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
        scope: _parchment2.default.Scope.INLINE
      });

      var Syntax = function (_Module) {
        _inherits(Syntax, _Module);

        _createClass(Syntax, null, [{
          key: 'register',
          value: function register() {
            _quill2.default.register(CodeToken, true);
            _quill2.default.register(SyntaxCodeBlock, true);
          }
        }]);

        function Syntax(quill, options) {
          _classCallCheck(this, Syntax);

          var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

          if (typeof _this2.options.highlight !== 'function') {
            throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
          }
          var timer = null;
          _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              _this2.highlight();
              timer = null;
            }, _this2.options.interval);
          });
          _this2.highlight();
          return _this2;
        }

        _createClass(Syntax, [{
          key: 'highlight',
          value: function highlight() {
            var _this3 = this;

            if (this.quill.selection.composing) return;
            this.quill.update(_quill2.default.sources.USER);
            var range = this.quill.getSelection();
            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
              code.highlight(_this3.options.highlight);
            });
            this.quill.update(_quill2.default.sources.SILENT);
            if (range != null) {
              this.quill.setSelection(range, _quill2.default.sources.SILENT);
            }
          }
        }]);

        return Syntax;
      }(_module2.default);

      Syntax.DEFAULTS = {
        highlight: function () {
          if (window.hljs == null) return null;
          return function (text) {
            var result = window.hljs.highlightAuto(text);
            return result.value;
          };
        }(),
        interval: 1000
      };

      exports.CodeBlock = SyntaxCodeBlock;
      exports.CodeToken = CodeToken;
      exports.default = Syntax;

      /***/
    },
    /* 76 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 77 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 78 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 79 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 80 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

      /***/
    },
    /* 81 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

      /***/
    },
    /* 82 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

      /***/
    },
    /* 83 */
    /***/function (module, exports) {

      module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

      /***/
    },
    /* 84 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

      /***/
    },
    /* 85 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

      /***/
    },
    /* 86 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

      /***/
    },
    /* 87 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 88 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 89 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 90 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

      /***/
    },
    /* 91 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

      /***/
    },
    /* 92 */
    /***/function (module, exports) {

      module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

      /***/
    },
    /* 93 */
    /***/function (module, exports) {

      module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

      /***/
    },
    /* 94 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

      /***/
    },
    /* 95 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

      /***/
    },
    /* 96 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

      /***/
    },
    /* 97 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

      /***/
    },
    /* 98 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

      /***/
    },
    /* 99 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

      /***/
    },
    /* 100 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

      /***/
    },
    /* 101 */
    /***/function (module, exports) {

      module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

      /***/
    },
    /* 102 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

      /***/
    },
    /* 103 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

      /***/
    },
    /* 104 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

      /***/
    },
    /* 105 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

      /***/
    },
    /* 106 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

      /***/
    },
    /* 107 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

      /***/
    },
    /* 108 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BubbleTooltip = undefined;

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

      var BubbleTheme = function (_BaseTheme) {
        _inherits(BubbleTheme, _BaseTheme);

        function BubbleTheme(quill, options) {
          _classCallCheck(this, BubbleTheme);

          if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
            options.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

          _this.quill.container.classList.add('ql-bubble');
          return _this;
        }

        _createClass(BubbleTheme, [{
          key: 'extendToolbar',
          value: function extendToolbar(toolbar) {
            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
          }
        }]);

        return BubbleTheme;
      }(_base2.default);

      BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (!value) {
                  this.quill.format('link', false);
                } else {
                  this.quill.theme.tooltip.edit();
                }
              }
            }
          }
        }
      });

      var BubbleTooltip = function (_BaseTooltip) {
        _inherits(BubbleTooltip, _BaseTooltip);

        function BubbleTooltip(quill, bounds) {
          _classCallCheck(this, BubbleTooltip);

          var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

          _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
            if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
              _this2.show();
              // Lock our width so we will expand beyond our offsetParent boundaries
              _this2.root.style.left = '0px';
              _this2.root.style.width = '';
              _this2.root.style.width = _this2.root.offsetWidth + 'px';
              var lines = _this2.quill.getLines(range.index, range.length);
              if (lines.length === 1) {
                _this2.position(_this2.quill.getBounds(range));
              } else {
                var lastLine = lines[lines.length - 1];
                var index = _this2.quill.getIndex(lastLine);
                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                _this2.position(_bounds);
              }
            } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
              _this2.hide();
            }
          });
          return _this2;
        }

        _createClass(BubbleTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this3 = this;

            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
            this.root.querySelector('.ql-close').addEventListener('click', function () {
              _this3.root.classList.remove('ql-editing');
            });
            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
              // Let selection be restored by toolbar handlers before repositioning
              setTimeout(function () {
                if (_this3.root.classList.contains('ql-hidden')) return;
                var range = _this3.quill.getSelection();
                if (range != null) {
                  _this3.position(_this3.quill.getBounds(range));
                }
              }, 1);
            });
          }
        }, {
          key: 'cancel',
          value: function cancel() {
            this.show();
          }
        }, {
          key: 'position',
          value: function position(reference) {
            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
            var arrow = this.root.querySelector('.ql-tooltip-arrow');
            arrow.style.marginLeft = '';
            if (shift === 0) return shift;
            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
          }
        }]);

        return BubbleTooltip;
      }(_base.BaseTooltip);

      BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

      exports.BubbleTooltip = BubbleTooltip;
      exports.default = BubbleTheme;

      /***/
    },
    /* 109 */
    /***/function (module, exports, __webpack_require__) {

      module.exports = __webpack_require__(63);

      /***/
    }]
    /******/)["default"]
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1593).Buffer, __webpack_require__(68)(module)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2196)();
}

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return finish; });


var records = {};

var flag = '__react-beautiful-dnd-debug-timings-hook__';

var isTimingsEnabled = function isTimingsEnabled() {
  return Boolean(window[flag]);
};

var start = function start(key) {
  if (!isTimingsEnabled()) {
    return;
  }
  var now = performance.now();

  records[key] = now;
};

var finish = function finish(key) {
  if (!isTimingsEnabled()) {
    return;
  }
  var now = performance.now();

  var previous = records[key];

  if (previous == null) {
    console.error('cannot finish timing as no previous time found');
    return;
  }

  var result = now - previous;

  console.log('%cTiming (' + key + '): %c' + result + ' %cms', 'font-weight: bold;', 'color: blue;', 'color: grey;');
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestDimensions */
/* unused harmony export completeLift */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return publishDraggableDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return publishDroppableDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return bulkPublishDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateDroppableDimensionScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateDroppableDimensionIsEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return move; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return moveByWindowScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return moveBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moveForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return crossAxisMoveForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return crossAxisMoveBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clean; });
/* unused harmony export prepare */
/* unused harmony export completeDrop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return drop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return cancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dropAnimationFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lift; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__no_impact__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__with_droppable_displacement__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_new_home_client_center__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__debug_timings__ = __webpack_require__(1178);







var origin = { x: 0, y: 0 };

var getScrollDiff = function getScrollDiff(_ref) {
  var initial = _ref.initial,
      current = _ref.current,
      droppable = _ref.droppable;

  var windowScrollDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["b" /* subtract */])(initial.viewport.scroll, current.viewport.scroll);

  if (!droppable) {
    return windowScrollDiff;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__with_droppable_displacement__["a" /* default */])(droppable, windowScrollDiff);
};

var requestDimensions = function requestDimensions(request) {
  return {
    type: 'REQUEST_DIMENSIONS',
    payload: request
  };
};

var completeLift = function completeLift(id, client, viewport, autoScrollMode) {
  return {
    type: 'COMPLETE_LIFT',
    payload: {
      id: id,
      client: client,
      viewport: viewport,
      autoScrollMode: autoScrollMode
    }
  };
};

var publishDraggableDimension = function publishDraggableDimension(dimension) {
  return {
    type: 'PUBLISH_DRAGGABLE_DIMENSION',
    payload: dimension
  };
};

var publishDroppableDimension = function publishDroppableDimension(dimension) {
  return {
    type: 'PUBLISH_DROPPABLE_DIMENSION',
    payload: dimension
  };
};

var bulkPublishDimensions = function bulkPublishDimensions(droppables, draggables) {
  return {
    type: 'BULK_DIMENSION_PUBLISH',
    payload: {
      droppables: droppables,
      draggables: draggables
    }
  };
};

var updateDroppableDimensionScroll = function updateDroppableDimensionScroll(id, offset) {
  return {
    type: 'UPDATE_DROPPABLE_DIMENSION_SCROLL',
    payload: {
      id: id,
      offset: offset
    }
  };
};

var updateDroppableDimensionIsEnabled = function updateDroppableDimensionIsEnabled(id, isEnabled) {
  return {
    type: 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED',
    payload: {
      id: id,
      isEnabled: isEnabled
    }
  };
};

var move = function move(id, client, viewport) {
  var shouldAnimate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    type: 'MOVE',
    payload: {
      id: id,
      client: client,
      viewport: viewport,
      shouldAnimate: shouldAnimate
    }
  };
};

var moveByWindowScroll = function moveByWindowScroll(id, viewport) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: {
      id: id,
      viewport: viewport
    }
  };
};

var moveBackward = function moveBackward(id) {
  return {
    type: 'MOVE_BACKWARD',
    payload: id
  };
};

var moveForward = function moveForward(id) {
  return {
    type: 'MOVE_FORWARD',
    payload: id
  };
};

var crossAxisMoveForward = function crossAxisMoveForward(id) {
  return {
    type: 'CROSS_AXIS_MOVE_FORWARD',
    payload: id
  };
};

var crossAxisMoveBackward = function crossAxisMoveBackward(id) {
  return {
    type: 'CROSS_AXIS_MOVE_BACKWARD',
    payload: id
  };
};

var clean = function clean() {
  return {
    type: 'CLEAN',
    payload: null
  };
};

var prepare = function prepare() {
  return {
    type: 'PREPARE',
    payload: null
  };
};

var animateDrop = function animateDrop(_ref2) {
  var newHomeOffset = _ref2.newHomeOffset,
      impact = _ref2.impact,
      result = _ref2.result;
  return {
    type: 'DROP_ANIMATE',
    payload: {
      newHomeOffset: newHomeOffset,
      impact: impact,
      result: result
    }
  };
};

var completeDrop = function completeDrop(result) {
  return {
    type: 'DROP_COMPLETE',
    payload: result
  };
};

var drop = function drop() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.phase === 'PREPARING' || state.phase === 'COLLECTING_INITIAL_DIMENSIONS') {
      dispatch(clean());
      return;
    }

    if (state.phase !== 'DRAGGING') {
      console.error('not able to drop in phase: \'' + state.phase + '\'');
      dispatch(clean());
      return;
    }

    if (!state.drag) {
      console.error('not able to drop when there is invalid drag state', state);
      dispatch(clean());
      return;
    }

    var _state$drag = state.drag,
        impact = _state$drag.impact,
        initial = _state$drag.initial,
        current = _state$drag.current;

    var descriptor = initial.descriptor;
    var draggable = state.dimension.draggable[initial.descriptor.id];
    var home = state.dimension.droppable[draggable.descriptor.droppableId];
    var destination = impact.destination ? state.dimension.droppable[impact.destination.droppableId] : null;

    var source = {
      droppableId: descriptor.droppableId,
      index: descriptor.index
    };

    var result = {
      draggableId: descriptor.id,
      type: home.descriptor.type,
      source: source,
      destination: impact.destination,
      reason: 'DROP'
    };

    var newCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_new_home_client_center__["a" /* default */])({
      movement: impact.movement,
      draggable: draggable,
      draggables: state.dimension.draggable,
      destination: destination
    });

    var clientOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["b" /* subtract */])(newCenter, draggable.client.marginBox.center);
    var scrollDiff = getScrollDiff({
      initial: initial,
      current: current,
      droppable: destination || home
    });
    var newHomeOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(clientOffset, scrollDiff);

    var isAnimationRequired = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["d" /* isEqual */])(current.client.offset, newHomeOffset);

    if (!isAnimationRequired) {
      dispatch(completeDrop(result));
      return;
    }

    dispatch(animateDrop({
      newHomeOffset: newHomeOffset,
      impact: impact,
      result: result
    }));
  };
};

var cancel = function cancel() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.phase !== 'DRAGGING') {
      dispatch(clean());
      return;
    }

    if (!state.drag) {
      console.error('invalid drag state', state);
      dispatch(clean());
      return;
    }

    var _state$drag2 = state.drag,
        initial = _state$drag2.initial,
        current = _state$drag2.current;

    var descriptor = initial.descriptor;
    var home = state.dimension.droppable[descriptor.droppableId];

    var source = {
      index: descriptor.index,
      droppableId: descriptor.droppableId
    };

    var result = {
      draggableId: descriptor.id,
      type: home.descriptor.type,
      source: source,

      destination: null,
      reason: 'CANCEL'
    };

    var isAnimationRequired = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["d" /* isEqual */])(current.client.offset, origin);

    if (!isAnimationRequired) {
      dispatch(completeDrop(result));
      return;
    }

    var scrollDiff = getScrollDiff({ initial: initial, current: current, droppable: home });

    dispatch(animateDrop({
      newHomeOffset: scrollDiff,
      impact: __WEBPACK_IMPORTED_MODULE_0__no_impact__["a" /* default */],
      result: result
    }));
  };
};

var dropAnimationFinished = function dropAnimationFinished() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.phase !== 'DROP_ANIMATING') {
      console.error('cannot end drop that is no longer animating', state);
      dispatch(clean());
      return;
    }

    if (!state.drop || !state.drop.pending) {
      console.error('cannot end drop that has no pending state', state);
      dispatch(clean());
      return;
    }

    dispatch(completeDrop(state.drop.pending.result));
  };
};

var lift = function lift(id, client, viewport, autoScrollMode) {
  return function (dispatch, getState) {
    var initial = getState();

    if (initial.phase === 'DROP_ANIMATING') {
      if (!initial.drop || !initial.drop.pending) {
        console.error('cannot flush drop animation if there is no pending');
        dispatch(clean());
      } else {
        dispatch(completeDrop(initial.drop.pending.result));
      }
    }

    dispatch(prepare());

    setTimeout(function () {
      var state = getState();

      if (state.phase !== 'PREPARING') {
        return;
      }

      var scrollOptions = {
        shouldPublishImmediately: autoScrollMode === 'JUMP'
      };
      var request = {
        draggableId: id,
        scrollOptions: scrollOptions
      };
      dispatch(requestDimensions(request));

      setTimeout(function () {
        var newState = getState();

        if (newState.phase !== 'COLLECTING_INITIAL_DIMENSIONS') {
          return;
        }

        dispatch(completeLift(id, client, viewport, autoScrollMode));
        __WEBPACK_IMPORTED_MODULE_4__debug_timings__["b" /* finish */]('LIFT');
      });
    });
  };
};

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOverlap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canPartiallyScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return canScrollWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canScrollDroppable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getWindowOverlap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDroppableOverlap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);



var origin = { x: 0, y: 0 };

var smallestSigned = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["g" /* apply */])(function (value) {
  if (value === 0) {
    return 0;
  }
  return value > 0 ? 1 : -1;
});

var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }
    if (target > max) {
      return target - max;
    }
    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;

    var targetScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["c" /* add */])(current, change);

    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["d" /* isEqual */])(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();

var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var max = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;

  var smallestChange = smallestSigned(change);

  var overlap = getOverlap({
    max: max, current: current, change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};

var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll,
    max: viewport.maxScroll,
    change: change
  });
};

var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return false;
  }

  return canPartiallyScroll({
    current: closestScrollable.scroll.current,
    max: closestScrollable.scroll.max,
    change: change
  });
};

var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.maxScroll;
  var current = viewport.scroll;

  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};

var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return null;
  }

  return getOverlap({
    current: closestScrollable.scroll.current,
    max: closestScrollable.scroll.max,
    change: change
  });
};

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return horizontal; });


var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};

var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_memoize_one__ = __webpack_require__(112);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
}));

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;

  var maxScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])({ x: scrollWidth, y: scrollHeight }, { x: width, y: height });

  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };

  return adjustedMaxScroll;
});

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withFirstAdded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withFirstRemoved; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_displacement__ = __webpack_require__(340);



var withFirstAdded = function withFirstAdded(_ref) {
  var add = _ref.add,
      previousImpact = _ref.previousImpact,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;

  var newDisplacement = {
    draggableId: add,
    isVisible: true,
    shouldAnimate: true
  };

  var added = [newDisplacement].concat(previousImpact.movement.displaced);

  var withUpdatedVisibility = added.map(function (current) {
    if (current === newDisplacement) {
      return current;
    }

    var updated = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_displacement__["a" /* default */])({
      draggable: draggables[current.draggableId],
      destination: droppable,
      previousImpact: previousImpact,
      viewport: viewport.subject
    });

    return updated;
  });

  return withUpdatedVisibility;
};

var forceVisibleDisplacement = function forceVisibleDisplacement(current) {
  if (current.isVisible) {
    return current;
  }

  return {
    draggableId: current.draggableId,
    isVisible: true,
    shouldAnimate: false
  };
};

var withFirstRemoved = function withFirstRemoved(_ref2) {
  var dragging = _ref2.dragging,
      isVisibleInNewLocation = _ref2.isVisibleInNewLocation,
      previousImpact = _ref2.previousImpact,
      droppable = _ref2.droppable,
      draggables = _ref2.draggables;

  var last = previousImpact.movement.displaced;
  if (!last.length) {
    console.error('cannot remove displacement from empty list');
    return [];
  }

  var withFirstRestored = last.slice(1, last.length);

  if (!withFirstRestored.length) {
    return withFirstRestored;
  }

  if (isVisibleInNewLocation) {
    return withFirstRestored;
  }

  var axis = droppable.axis;

  var sizeOfRestored = draggables[last[0].draggableId].page.marginBox[axis.size];
  var sizeOfDragging = draggables[dragging].page.marginBox[axis.size];
  var buffer = sizeOfRestored + sizeOfDragging;

  var withUpdatedVisibility = withFirstRestored.map(function (displacement, index) {
    if (index === 0) {
      return forceVisibleDisplacement(displacement);
    }

    if (buffer > 0) {
      var current = draggables[displacement.draggableId];
      var size = current.page.marginBox[axis.size];
      buffer -= size;

      return forceVisibleDisplacement(displacement);
    }

    return {
      draggableId: displacement.draggableId,
      isVisible: false,
      shouldAnimate: false
    };
  });

  return withUpdatedVisibility;
};

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spacing__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visibility_is_visible__ = __webpack_require__(680);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageCenter = _ref.newPageCenter,
      viewport = _ref.viewport;

  var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(newPageCenter, draggable.page.paddingBox.center);
  var shifted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__spacing__["a" /* offsetByPosition */])(draggable.page.paddingBox, diff);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__visibility_is_visible__["b" /* isTotallyVisible */])({
    target: shifted,
    destination: destination,
    viewport: viewport
  });
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_within__ = __webpack_require__(457);



/* harmony default export */ __webpack_exports__["a"] = (function (frame) {
  var isWithinVertical = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.top, frame.bottom);
  var isWithinHorizontal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.left, frame.right);

  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);

    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;

    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;

    return isTargetBiggerOnOneAxis;
  };
});

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_within__ = __webpack_require__(457);



/* harmony default export */ __webpack_exports__["a"] = (function (frame) {
  var isWithinVertical = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.top, frame.bottom);
  var isWithinHorizontal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.left, frame.right);

  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
});

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);



/* harmony default export */ __webpack_exports__["a"] = (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["c" /* add */])(point, closestScrollable.scroll.diff.value);
});

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return physics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var physics = function () {
  var base = {
    stiffness: 1000,
    damping: 60,

    precision: 0.99
  };

  var standard = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, base);

  var fast = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, base, {
    stiffness: base.stiffness * 2
  });

  return { standard: standard, fast: fast };
}();

var css = {
  outOfTheWay: 'transform 0.2s cubic-bezier(0.2, 0, 0, 1)'
};

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag_drop_context__ = __webpack_require__(2225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__drag_drop_context__["a"]; });
/* unused harmony reexport resetServerContext */



/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    if (isMouseDownHandled) {
      console.error('Cannot handle mouse down as it is already handled');
      return;
    }
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bind_events__ = __webpack_require__(459);



/* harmony default export */ __webpack_exports__["a"] = (function (getWindow) {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }
    isBound = true;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bind_events__["a" /* bindEvents */])(getWindow(), pointerEvents, { capture: true });
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }
    isBound = false;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bind_events__["b" /* unbindEvents */])(getWindow(), pointerEvents, { capture: true });
  };

  var pointerEvents = [{
    eventName: 'click',
    fn: function fn(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: 'mousedown',

    fn: unbind
  }, {
    eventName: 'touchstart',
    fn: unbind
  }];

  var preventNext = function preventNext() {
    if (isBound) {
      unbind();
    }

    bind();
  };

  var preventer = {
    preventNext: preventNext,
    abort: unbind
  };

  return preventer;
});

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__key_codes__ = __webpack_require__(460);
var _preventedKeys;



var preventedKeys = (_preventedKeys = {}, _preventedKeys[__WEBPACK_IMPORTED_MODULE_0__key_codes__["k" /* enter */]] = true, _preventedKeys[__WEBPACK_IMPORTED_MODULE_0__key_codes__["l" /* tab */]] = true, _preventedKeys);

/* harmony default export */ __webpack_exports__["a"] = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_get_area__ = __webpack_require__(284);



/* harmony default export */ __webpack_exports__["a"] = (function (el) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state_get_area__["a" /* default */])(el.getBoundingClientRect()).center;
});

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__placeholder__ = __webpack_require__(2246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__placeholder__["a"]; });



/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(1199);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1200);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(2257);
/* unused harmony reexport Provider */
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(684);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(943);

var _height2 = _interopRequireDefault(_height);

var _querySelectorAll = __webpack_require__(620);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(113);

var _eventLevels2 = __webpack_require__(343);

var _BackgroundCells = __webpack_require__(2276);

var _BackgroundCells2 = _interopRequireDefault(_BackgroundCells);

var _EventRow = __webpack_require__(2282);

var _EventRow2 = _interopRequireDefault(_EventRow);

var _EventEndingRow = __webpack_require__(2281);

var _EventEndingRow2 = _interopRequireDefault(_EventEndingRow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  events: _propTypes2.default.array.isRequired,
  range: _propTypes2.default.array.isRequired,

  rtl: _propTypes2.default.bool,
  renderForMeasure: _propTypes2.default.bool,
  renderHeader: _propTypes2.default.func,

  container: _propTypes2.default.func,
  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onShowMore: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,

  getNow: _propTypes2.default.func.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  dateCellWrapperComponent: _propTypes3.elementType,
  minRows: _propTypes2.default.number.isRequired,
  maxRows: _propTypes2.default.number.isRequired
};

var defaultProps = {
  minRows: 0,
  maxRows: Infinity
};

var DateContentRow = function (_React$Component) {
  _inherits(DateContentRow, _React$Component);

  function DateContentRow() {
    var _temp, _this, _ret;

    _classCallCheck(this, DateContentRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelectSlot = function (slot) {
      var _this$props = _this.props,
          range = _this$props.range,
          onSelectSlot = _this$props.onSelectSlot;

      onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
    }, _this.handleShowMore = function (slot) {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          onShowMore = _this$props2.onShowMore;

      var row = (0, _querySelectorAll2.default)((0, _reactDom.findDOMNode)(_this), '.rbc-row-bg')[0];

      var cell = void 0;
      if (row) cell = row.children[slot - 1];

      var events = _this.segments.filter(function (seg) {
        return isSegmentInSlot(seg, slot);
      }).map(function (seg) {
        return seg.event;
      });

      onShowMore(events, range[slot - 1], cell, slot);
    }, _this.createHeadingRef = function (r) {
      _this.headingRow = r;
    }, _this.createEventRef = function (r) {
      _this.eventRow = r;
    }, _this.getContainer = function () {
      var container = _this.props.container;

      return container ? container() : (0, _reactDom.findDOMNode)(_this);
    }, _this.renderHeadingCell = function (date, index) {
      var _this$props3 = _this.props,
          renderHeader = _this$props3.renderHeader,
          getNow = _this$props3.getNow;

      return renderHeader({
        date: date,
        key: 'header_' + index,
        className: (0, _classnames2.default)('rbc-date-cell', _dates2.default.eq(date, getNow(), 'day') && 'rbc-now')
      });
    }, _this.renderDummy = function () {
      var _this$props4 = _this.props,
          className = _this$props4.className,
          range = _this$props4.range,
          renderHeader = _this$props4.renderHeader;

      return _react2.default.createElement('div', { className: className }, _react2.default.createElement('div', { className: 'rbc-row-content' }, renderHeader && _react2.default.createElement('div', { className: 'rbc-row', ref: _this.createHeadingRef }, range.map(_this.renderHeadingCell)), _react2.default.createElement('div', { className: 'rbc-row', ref: _this.createEventRef }, _react2.default.createElement('div', { className: 'rbc-row-segment' }, _react2.default.createElement('div', { className: 'rbc-event' }, _react2.default.createElement('div', { className: 'rbc-event-content' }, '\xA0'))))));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DateContentRow.prototype.getRowLimit = function getRowLimit() {
    var eventHeight = (0, _height2.default)(this.eventRow);
    var headingHeight = this.headingRow ? (0, _height2.default)(this.headingRow) : 0;
    var eventSpace = (0, _height2.default)((0, _reactDom.findDOMNode)(this)) - headingHeight;

    return Math.max(Math.floor(eventSpace / eventHeight), 1);
  };

  DateContentRow.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        rtl = _props.rtl,
        events = _props.events,
        range = _props.range,
        className = _props.className,
        selectable = _props.selectable,
        dayPropGetter = _props.dayPropGetter,
        renderForMeasure = _props.renderForMeasure,
        startAccessor = _props.startAccessor,
        endAccessor = _props.endAccessor,
        getNow = _props.getNow,
        renderHeader = _props.renderHeader,
        minRows = _props.minRows,
        maxRows = _props.maxRows,
        dateCellWrapperComponent = _props.dateCellWrapperComponent,
        eventComponent = _props.eventComponent,
        eventWrapperComponent = _props.eventWrapperComponent,
        onSelectStart = _props.onSelectStart,
        onSelectEnd = _props.onSelectEnd,
        longPressThreshold = _props.longPressThreshold,
        props = _objectWithoutProperties(_props, ['date', 'rtl', 'events', 'range', 'className', 'selectable', 'dayPropGetter', 'renderForMeasure', 'startAccessor', 'endAccessor', 'getNow', 'renderHeader', 'minRows', 'maxRows', 'dateCellWrapperComponent', 'eventComponent', 'eventWrapperComponent', 'onSelectStart', 'onSelectEnd', 'longPressThreshold']);

    if (renderForMeasure) return this.renderDummy();

    var _endOfRange = (0, _eventLevels2.endOfRange)(range),
        first = _endOfRange.first,
        last = _endOfRange.last;

    var segments = this.segments = events.map(function (evt) {
      return (0, _eventLevels2.eventSegments)(evt, first, last, {
        startAccessor: startAccessor,
        endAccessor: endAccessor
      }, range);
    });

    var _eventLevels = (0, _eventLevels2.eventLevels)(segments, Math.max(maxRows - 1, 1)),
        levels = _eventLevels.levels,
        extra = _eventLevels.extra;

    while (levels.length < minRows) {
      levels.push([]);
    }return _react2.default.createElement('div', { className: className }, _react2.default.createElement(_BackgroundCells2.default, {
      date: date,
      getNow: getNow,
      rtl: rtl,
      range: range,
      selectable: selectable,
      container: this.getContainer,
      dayPropGetter: dayPropGetter,
      onSelectStart: onSelectStart,
      onSelectEnd: onSelectEnd,
      onSelectSlot: this.handleSelectSlot,
      cellWrapperComponent: dateCellWrapperComponent,
      longPressThreshold: longPressThreshold
    }), _react2.default.createElement('div', { className: 'rbc-row-content' }, renderHeader && _react2.default.createElement('div', { className: 'rbc-row', ref: this.createHeadingRef }, range.map(this.renderHeadingCell)), levels.map(function (segs, idx) {
      return _react2.default.createElement(_EventRow2.default, _extends({}, props, {
        key: idx,
        start: first,
        end: last,
        segments: segs,
        slots: range.length,
        eventComponent: eventComponent,
        eventWrapperComponent: eventWrapperComponent,
        startAccessor: startAccessor,
        endAccessor: endAccessor
      }));
    }), !!extra.length && _react2.default.createElement(_EventEndingRow2.default, _extends({}, props, {
      start: first,
      end: last,
      segments: extra,
      onShowMore: this.handleShowMore,
      eventComponent: eventComponent,
      eventWrapperComponent: eventWrapperComponent,
      startAccessor: startAccessor,
      endAccessor: endAccessor
    }))));
  };

  return DateContentRow;
}(_react2.default.Component);

DateContentRow.propTypes = propTypes;
DateContentRow.defaultProps = defaultProps;

exports.default = DateContentRow;
module.exports = exports['default'];

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(113);

var _accessors = __webpack_require__(239);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  event: _propTypes2.default.object.isRequired,
  slotStart: _propTypes2.default.instanceOf(Date),
  slotEnd: _propTypes2.default.instanceOf(Date),

  selected: _propTypes2.default.bool,
  isAllDay: _propTypes2.default.bool,
  eventPropGetter: _propTypes2.default.func,
  titleAccessor: _propTypes3.accessor,
  tooltipAccessor: _propTypes3.accessor,
  allDayAccessor: _propTypes3.accessor,
  startAccessor: _propTypes3.accessor,
  endAccessor: _propTypes3.accessor,

  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onDoubleClick: _propTypes2.default.func.isRequired
};

var EventCell = function (_React$Component) {
  _inherits(EventCell, _React$Component);

  function EventCell() {
    _classCallCheck(this, EventCell);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventCell.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        event = _props.event,
        selected = _props.selected,
        isAllDay = _props.isAllDay,
        eventPropGetter = _props.eventPropGetter,
        startAccessor = _props.startAccessor,
        endAccessor = _props.endAccessor,
        titleAccessor = _props.titleAccessor,
        tooltipAccessor = _props.tooltipAccessor,
        allDayAccessor = _props.allDayAccessor,
        slotStart = _props.slotStart,
        slotEnd = _props.slotEnd,
        onSelect = _props.onSelect,
        _onDoubleClick = _props.onDoubleClick,
        Event = _props.eventComponent,
        EventWrapper = _props.eventWrapperComponent,
        props = _objectWithoutProperties(_props, ['className', 'event', 'selected', 'isAllDay', 'eventPropGetter', 'startAccessor', 'endAccessor', 'titleAccessor', 'tooltipAccessor', 'allDayAccessor', 'slotStart', 'slotEnd', 'onSelect', 'onDoubleClick', 'eventComponent', 'eventWrapperComponent']);

    var title = (0, _accessors.accessor)(event, titleAccessor),
        tooltip = (0, _accessors.accessor)(event, tooltipAccessor),
        end = (0, _accessors.accessor)(event, endAccessor),
        start = (0, _accessors.accessor)(event, startAccessor),
        allDay = (0, _accessors.accessor)(event, allDayAccessor),
        showAsAllDay = isAllDay || allDay || _dates2.default.diff(start, _dates2.default.ceil(end, 'day'), 'day') > 1,
        continuesPrior = _dates2.default.lt(start, slotStart, 'day'),
        continuesAfter = _dates2.default.gte(end, slotEnd, 'day');

    if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, selected),
        style = _eventPropGetter.style,
        xClassName = _eventPropGetter.className;

    var wrapperProps = {
      event: event,
      allDay: allDay,
      continuesPrior: continuesPrior,
      continuesAfter: continuesAfter
    };

    return (
      // give EventWrapper some extra info to help it determine whether it
      // it's in a row, etc. Useful for dnd, etc.
      _react2.default.createElement(EventWrapper, _extends({}, wrapperProps, { isRow: true }), _react2.default.createElement('div', {
        style: _extends({}, props.style, style),
        className: (0, _classnames2.default)('rbc-event', className, xClassName, {
          'rbc-selected': selected,
          'rbc-event-allday': showAsAllDay,
          'rbc-event-continues-prior': continuesPrior,
          'rbc-event-continues-after': continuesAfter
        }),
        onClick: function onClick(e) {
          return onSelect(event, e);
        },
        onDoubleClick: function onDoubleClick(e) {
          return _onDoubleClick(event, e);
        }
      }, _react2.default.createElement('div', { className: 'rbc-event-content', title: tooltip || undefined }, Event ? _react2.default.createElement(Event, { event: event, title: title, isAllDay: allDay }) : title)))
    );
  };

  return EventCell;
}(_react2.default.Component);

EventCell.propTypes = propTypes;

exports.default = EventCell;
module.exports = exports['default'];

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _EventCell = __webpack_require__(1205);

var _EventCell2 = _interopRequireDefault(_EventCell);

var _height = __webpack_require__(943);

var _height2 = _interopRequireDefault(_height);

var _propTypes3 = __webpack_require__(113);

var _selection = __webpack_require__(344);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* eslint-disable react/prop-types */
exports.default = {
  propTypes: {
    slots: _propTypes2.default.number.isRequired,
    end: _propTypes2.default.instanceOf(Date),
    start: _propTypes2.default.instanceOf(Date),

    selected: _propTypes2.default.object,
    isAllDay: _propTypes2.default.bool,
    eventPropGetter: _propTypes2.default.func,
    titleAccessor: _propTypes3.accessor,
    tooltipAccessor: _propTypes3.accessor,
    allDayAccessor: _propTypes3.accessor,
    startAccessor: _propTypes3.accessor,
    endAccessor: _propTypes3.accessor,

    eventComponent: _propTypes3.elementType,
    eventWrapperComponent: _propTypes3.elementType.isRequired,
    onSelect: _propTypes2.default.func,
    onDoubleClick: _propTypes2.default.func
  },

  defaultProps: {
    segments: [],
    selected: {},
    slots: 7
  },

  renderEvent: function renderEvent(props, event) {
    var eventPropGetter = props.eventPropGetter,
        selected = props.selected,
        isAllDay = props.isAllDay,
        start = props.start,
        end = props.end,
        startAccessor = props.startAccessor,
        endAccessor = props.endAccessor,
        titleAccessor = props.titleAccessor,
        tooltipAccessor = props.tooltipAccessor,
        allDayAccessor = props.allDayAccessor,
        eventComponent = props.eventComponent,
        eventWrapperComponent = props.eventWrapperComponent,
        onSelect = props.onSelect,
        onDoubleClick = props.onDoubleClick;

    return _react2.default.createElement(_EventCell2.default, {
      event: event,
      eventWrapperComponent: eventWrapperComponent,
      eventPropGetter: eventPropGetter,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      selected: (0, _selection.isSelected)(event, selected),
      isAllDay: isAllDay,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      titleAccessor: titleAccessor,
      tooltipAccessor: tooltipAccessor,
      allDayAccessor: allDayAccessor,
      slotStart: start,
      slotEnd: end,
      eventComponent: eventComponent
    });
  },
  renderSpan: function renderSpan(slots, len, key) {
    var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';

    var per = Math.abs(len) / slots * 100 + '%';

    return _react2.default.createElement('div', {
      key: key,
      className: 'rbc-row-segment'
      // IE10/11 need max-width. flex-basis doesn't respect box-sizing
      , style: { WebkitFlexBasis: per, flexBasis: per, maxWidth: per }
    }, content);
  },
  getRowHeight: function getRowHeight() {
    (0, _height2.default)((0, _reactDom.findDOMNode)(this));
  }
};
module.exports = exports['default'];

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EventWrapper = function (_React$Component) {
  _inherits(EventWrapper, _React$Component);

  function EventWrapper() {
    _classCallCheck(this, EventWrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return EventWrapper;
}(_react2.default.Component);

exports.default = EventWrapper;
module.exports = exports['default'];

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Header = function Header(_ref) {
  var label = _ref.label;

  return _react2.default.createElement('span', null, label);
};

Header.propTypes = {
  label: _propTypes2.default.node
};

exports.default = Header;
module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.isEvent = isEvent;
exports.objectsCollide = objectsCollide;
exports.getBoundsForNode = getBoundsForNode;

var _contains = __webpack_require__(619);

var _contains2 = _interopRequireDefault(_contains);

var _closest = __webpack_require__(1846);

var _closest2 = _interopRequireDefault(_closest);

var _events = __webpack_require__(1844);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function addEventListener(type, handler) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

  _events2.default.on(target, type, handler);
  return {
    remove: function remove() {
      _events2.default.off(target, type, handler);
    }
  };
}

function isOverContainer(container, x, y) {
  return !container || (0, _contains2.default)(container, document.elementFromPoint(x, y));
}

function isEvent(node, _ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;

  var target = document.elementFromPoint(clientX, clientY);
  return !!(0, _closest2.default)(target, '.rbc-event', node);
}

function getEventCoordinates(e) {
  var target = e;

  if (e.touches && e.touches.length) {
    target = e.touches[0];
  }

  return {
    clientX: target.clientX,
    clientY: target.clientY,
    pageX: target.pageX,
    pageY: target.pageY
  };
}

var clickTolerance = 5;
var clickInterval = 250;

var Selection = function () {
  function Selection(node) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$global = _ref2.global,
        global = _ref2$global === undefined ? false : _ref2$global,
        _ref2$longPressThresh = _ref2.longPressThreshold,
        longPressThreshold = _ref2$longPressThresh === undefined ? 250 : _ref2$longPressThresh;

    _classCallCheck(this, Selection);

    this.container = node;
    this.globalMouse = !node || global;
    this.longPressThreshold = longPressThreshold;

    this._listeners = Object.create(null);

    this._handleInitialEvent = this._handleInitialEvent.bind(this);
    this._handleMoveEvent = this._handleMoveEvent.bind(this);
    this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
    this._keyListener = this._keyListener.bind(this);

    // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
    // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
    this._onTouchMoveWindowListener = addEventListener('touchmove', function () {}, window);
    this._onKeyDownListener = addEventListener('keydown', this._keyListener);
    this._onKeyUpListener = addEventListener('keyup', this._keyListener);
    this._addInitialEventListener();
  }

  Selection.prototype.on = function on(type, handler) {
    var handlers = this._listeners[type] || (this._listeners[type] = []);

    handlers.push(handler);

    return {
      remove: function remove() {
        var idx = handlers.indexOf(handler);
        if (idx !== -1) handlers.splice(idx, 1);
      }
    };
  };

  Selection.prototype.emit = function emit(type) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result = void 0;
    var handlers = this._listeners[type] || [];
    handlers.forEach(function (fn) {
      if (result === undefined) result = fn.apply(undefined, args);
    });
    return result;
  };

  Selection.prototype.teardown = function teardown() {
    this.listeners = Object.create(null);
    this._onTouchMoveWindowListener && this._onTouchMoveWindowListener.remove();
    this._onInitialEventListener && this._onInitialEventListener.remove();
    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();
    this._onKeyUpListener && this._onKeyUpListener.remove();
    this._onKeyDownListener && this._onKeyDownListener.remove();
  };

  Selection.prototype.isSelected = function isSelected(node) {
    var box = this._selectRect;

    if (!box || !this.selecting) return false;

    return objectsCollide(box, getBoundsForNode(node));
  };

  Selection.prototype.filter = function filter(items) {
    var box = this._selectRect;

    //not selecting
    if (!box || !this.selecting) return [];

    return items.filter(this.isSelected, this);
  };

  // Adds a listener that will call the handler only after the user has pressed on the screen
  // without moving their finger for 250ms.


  Selection.prototype._addLongPressListener = function _addLongPressListener(handler, initialEvent) {
    var _this = this;

    var timer = null;
    var touchMoveListener = null;
    var touchEndListener = null;
    var handleTouchStart = function handleTouchStart(initialEvent) {
      timer = setTimeout(function () {
        cleanup();
        handler(initialEvent);
      }, _this.longPressThreshold);
      touchMoveListener = addEventListener('touchmove', function () {
        return cleanup();
      });
      touchEndListener = addEventListener('touchend', function () {
        return cleanup();
      });
    };
    var touchStartListener = addEventListener('touchstart', handleTouchStart);
    var cleanup = function cleanup() {
      if (timer) {
        clearTimeout(timer);
      }
      if (touchMoveListener) {
        touchMoveListener.remove();
      }
      if (touchEndListener) {
        touchEndListener.remove();
      }

      timer = null;
      touchMoveListener = null;
      touchEndListener = null;
    };

    if (initialEvent) {
      handleTouchStart(initialEvent);
    }

    return {
      remove: function remove() {
        cleanup();
        touchStartListener.remove();
      }
    };
  };

  // Listen for mousedown and touchstart events. When one is received, disable the other and setup
  // future event handling based on the type of event.


  Selection.prototype._addInitialEventListener = function _addInitialEventListener() {
    var _this2 = this;

    var mouseDownListener = addEventListener('mousedown', function (e) {
      _this2._onInitialEventListener.remove();
      _this2._handleInitialEvent(e);
      _this2._onInitialEventListener = addEventListener('mousedown', _this2._handleInitialEvent);
    });
    var touchStartListener = addEventListener('touchstart', function (e) {
      _this2._onInitialEventListener.remove();
      _this2._onInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
    });

    this._onInitialEventListener = {
      remove: function remove() {
        mouseDownListener.remove();
        touchStartListener.remove();
      }
    };
  };

  Selection.prototype._handleInitialEvent = function _handleInitialEvent(e) {
    var _getEventCoordinates = getEventCoordinates(e),
        clientX = _getEventCoordinates.clientX,
        clientY = _getEventCoordinates.clientY,
        pageX = _getEventCoordinates.pageX,
        pageY = _getEventCoordinates.pageY;

    var node = this.container(),
        collides = void 0,
        offsetData = void 0;

    // Right clicks
    if (e.which === 3 || e.button === 2 || !isOverContainer(node, clientX, clientY)) return;

    if (!this.globalMouse && node && !(0, _contains2.default)(node, e.target)) {
      var _normalizeDistance = normalizeDistance(0),
          top = _normalizeDistance.top,
          left = _normalizeDistance.left,
          bottom = _normalizeDistance.bottom,
          right = _normalizeDistance.right;

      offsetData = getBoundsForNode(node);

      collides = objectsCollide({
        top: offsetData.top - top,
        left: offsetData.left - left,
        bottom: offsetData.bottom + bottom,
        right: offsetData.right + right
      }, { top: pageY, left: pageX });

      if (!collides) return;
    }

    var result = this.emit('beforeSelect', this._initialEventData = {
      isTouch: /^touch/.test(e.type),
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });

    if (result === false) return;

    switch (e.type) {
      case 'mousedown':
        this._onEndListener = addEventListener('mouseup', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('mousemove', this._handleMoveEvent);
        break;
      case 'touchstart':
        this._handleMoveEvent(e);
        this._onEndListener = addEventListener('touchend', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('touchmove', this._handleMoveEvent);
        break;
      default:
        break;
    }
  };

  Selection.prototype._handleTerminatingEvent = function _handleTerminatingEvent(e) {
    var _getEventCoordinates2 = getEventCoordinates(e),
        pageX = _getEventCoordinates2.pageX,
        pageY = _getEventCoordinates2.pageY;

    this.selecting = false;

    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();

    if (!this._initialEventData) return;

    var inRoot = !this.container || (0, _contains2.default)(this.container(), e.target);
    var bounds = this._selectRect;
    var click = this.isClick(pageX, pageY);

    this._initialEventData = null;

    if (click && !inRoot) {
      return this.emit('reset');
    }

    if (click && inRoot) {
      return this._handleClickEvent(e);
    }

    // User drag-clicked in the Selectable area
    if (!click) return this.emit('select', bounds);
  };

  Selection.prototype._handleClickEvent = function _handleClickEvent(e) {
    var _getEventCoordinates3 = getEventCoordinates(e),
        pageX = _getEventCoordinates3.pageX,
        pageY = _getEventCoordinates3.pageY,
        clientX = _getEventCoordinates3.clientX,
        clientY = _getEventCoordinates3.clientY;

    var now = new Date().getTime();

    if (this._lastClickData && now - this._lastClickData.timestamp < clickInterval) {
      // Double click event
      this._lastClickData = null;
      return this.emit('doubleClick', {
        x: pageX,
        y: pageY,
        clientX: clientX,
        clientY: clientY
      });
    }

    // Click event
    this._lastClickData = {
      timestamp: now
    };
    return this.emit('click', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
  };

  Selection.prototype._handleMoveEvent = function _handleMoveEvent(e) {
    var _initialEventData = this._initialEventData,
        x = _initialEventData.x,
        y = _initialEventData.y;

    var _getEventCoordinates4 = getEventCoordinates(e),
        pageX = _getEventCoordinates4.pageX,
        pageY = _getEventCoordinates4.pageY;

    var w = Math.abs(x - pageX);
    var h = Math.abs(y - pageY);

    var left = Math.min(pageX, x),
        top = Math.min(pageY, y),
        old = this.selecting;

    // Prevent emitting selectStart event until mouse is moved.
    // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
    if (!old && !(w || h)) {
      return;
    }

    this.selecting = true;
    this._selectRect = {
      top: top,
      left: left,
      x: pageX,
      y: pageY,
      right: left + w,
      bottom: top + h
    };

    if (!old) {
      this.emit('selectStart', this._initialEventData);
    }

    if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);

    e.preventDefault();
  };

  Selection.prototype._keyListener = function _keyListener(e) {
    this.ctrl = e.metaKey || e.ctrlKey;
  };

  Selection.prototype.isClick = function isClick(pageX, pageY) {
    var _initialEventData2 = this._initialEventData,
        x = _initialEventData2.x,
        y = _initialEventData2.y,
        isTouch = _initialEventData2.isTouch;

    return !isTouch && Math.abs(pageX - x) <= clickTolerance && Math.abs(pageY - y) <= clickTolerance;
  };

  return Selection;
}();

/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */

function normalizeDistance() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if ((typeof distance === 'undefined' ? 'undefined' : _typeof(distance)) !== 'object') distance = {
    top: distance,
    left: distance,
    right: distance,
    bottom: distance
  };

  return distance;
}

/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */
function objectsCollide(nodeA, nodeB) {
  var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var _getBoundsForNode = getBoundsForNode(nodeA),
      aTop = _getBoundsForNode.top,
      aLeft = _getBoundsForNode.left,
      _getBoundsForNode$rig = _getBoundsForNode.right,
      aRight = _getBoundsForNode$rig === undefined ? aLeft : _getBoundsForNode$rig,
      _getBoundsForNode$bot = _getBoundsForNode.bottom,
      aBottom = _getBoundsForNode$bot === undefined ? aTop : _getBoundsForNode$bot;

  var _getBoundsForNode2 = getBoundsForNode(nodeB),
      bTop = _getBoundsForNode2.top,
      bLeft = _getBoundsForNode2.left,
      _getBoundsForNode2$ri = _getBoundsForNode2.right,
      bRight = _getBoundsForNode2$ri === undefined ? bLeft : _getBoundsForNode2$ri,
      _getBoundsForNode2$bo = _getBoundsForNode2.bottom,
      bBottom = _getBoundsForNode2$bo === undefined ? bTop : _getBoundsForNode2$bo;

  return !( // 'a' bottom doesn't touch 'b' top
  aBottom - tolerance < bTop ||
  // 'a' top doesn't touch 'b' bottom
  aTop + tolerance > bBottom ||
  // 'a' right doesn't touch 'b' left
  aRight - tolerance < bLeft ||
  // 'a' left doesn't touch 'b' right
  aLeft + tolerance > bRight);
}

/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */
function getBoundsForNode(node) {
  if (!node.getBoundingClientRect) return node;

  var rect = node.getBoundingClientRect(),
      left = rect.left + pageOffset('left'),
      top = rect.top + pageOffset('top');

  return {
    top: top,
    left: left,
    right: (node.offsetWidth || 0) + left,
    bottom: (node.offsetHeight || 0) + top
  };
}

function pageOffset(dir) {
  if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
  if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
exports.default = Selection;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes3 = __webpack_require__(113);

var _BackgroundWrapper = __webpack_require__(685);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimeSlotGroup = function (_Component) {
  _inherits(TimeSlotGroup, _Component);

  function TimeSlotGroup() {
    _classCallCheck(this, TimeSlotGroup);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TimeSlotGroup.prototype.render = function render() {
    var _props = this.props,
        renderSlot = _props.renderSlot,
        resource = _props.resource,
        group = _props.group,
        slotPropGetter = _props.slotPropGetter,
        Wrapper = _props.timeSlotWrapperComponent;

    return _react2.default.createElement('div', { className: 'rbc-timeslot-group' }, group.map(function (value, idx) {
      var slotProps = slotPropGetter && slotPropGetter(value) || {};

      return _react2.default.createElement(Wrapper, { key: idx, value: value, resource: resource }, _react2.default.createElement('div', _extends({}, slotProps, {
        className: (0, _classnames2.default)('rbc-time-slot', slotProps.className)
      }), renderSlot && renderSlot(value, idx)));
    }));
  };

  return TimeSlotGroup;
}(_react.Component);

TimeSlotGroup.propTypes = {
  renderSlot: _propTypes2.default.func,
  timeSlotWrapperComponent: _propTypes3.elementType,
  group: _propTypes2.default.array.isRequired,
  slotPropGetter: _propTypes2.default.func,
  resource: _propTypes2.default.any
};
TimeSlotGroup.defaultProps = {
  timeSlotWrapperComponent: _BackgroundWrapper2.default
};
exports.default = TimeSlotGroup;
module.exports = exports['default'];

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VIEWS;

var _constants = __webpack_require__(153);

var _Month = __webpack_require__(2283);

var _Month2 = _interopRequireDefault(_Month);

var _Day = __webpack_require__(2279);

var _Day2 = _interopRequireDefault(_Day);

var _Week = __webpack_require__(1212);

var _Week2 = _interopRequireDefault(_Week);

var _WorkWeek = __webpack_require__(2288);

var _WorkWeek2 = _interopRequireDefault(_WorkWeek);

var _Agenda = __webpack_require__(2275);

var _Agenda2 = _interopRequireDefault(_Agenda);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var VIEWS = (_VIEWS = {}, _VIEWS[_constants.views.MONTH] = _Month2.default, _VIEWS[_constants.views.WEEK] = _Week2.default, _VIEWS[_constants.views.WORK_WEEK] = _WorkWeek2.default, _VIEWS[_constants.views.DAY] = _Day2.default, _VIEWS[_constants.views.AGENDA] = _Agenda2.default, _VIEWS);

exports.default = VIEWS;
module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _constants = __webpack_require__(153);

var _TimeGrid = __webpack_require__(686);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Week = function (_React$Component) {
  _inherits(Week, _React$Component);

  function Week() {
    _classCallCheck(this, Week);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Week.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    var range = Week.range(date, this.props);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
  };

  return Week;
}(_react2.default.Component);

Week.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};
Week.defaultProps = _TimeGrid2.default.defaultProps;

Week.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'week');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'week');

    default:
      return date;
  }
};

Week.range = function (date, _ref) {
  var culture = _ref.culture;

  var firstOfWeek = _localizer2.default.startOfWeek(culture);
  var start = _dates2.default.startOf(date, 'week', firstOfWeek);
  var end = _dates2.default.endOf(date, 'week', firstOfWeek);

  return _dates2.default.range(start, end);
};

Week.title = function (date, _ref2) {
  var formats = _ref2.formats,
      culture = _ref2.culture;

  var _Week$range = Week.range(date, { culture: culture }),
      start = _Week$range[0],
      rest = _Week$range.slice(1);

  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
};

exports.default = Week;
module.exports = exports['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getSlotMetrics = getSlotMetrics;

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var getDstOffset = function getDstOffset(start, end) {
  return Math.abs(start.getTimezoneOffset() - end.getTimezoneOffset());
};

var getKey = function getKey(min, max, step, slots) {
  return '' + +_dates2.default.startOf(min, 'minutes') + ('' + +_dates2.default.startOf(max, 'minutes')) + (step + '-' + slots);
};

function getSlotMetrics(_ref) {
  var start = _ref.min,
      end = _ref.max,
      step = _ref.step,
      timeslots = _ref.timeslots;

  var key = getKey(start, end, step, timeslots);

  var totalMin = _dates2.default.diff(start, end, 'minutes') + getDstOffset(start, end);
  var minutesFromMidnight = _dates2.default.diff(_dates2.default.startOf(start, 'day'), start, 'minutes');

  var numGroups = Math.ceil(totalMin / (step * timeslots));
  var numSlots = numGroups * timeslots;

  var groups = new Array(numGroups);
  var slots = new Array(numSlots);
  // Each slot date is created from "zero", instead of adding `step` to
  // the previous one, in order to avoid DST oddities
  for (var grp = 0; grp < numGroups; grp++) {
    groups[grp] = new Array(timeslots);

    for (var slot = 0; slot < timeslots; slot++) {
      var slotIdx = grp * timeslots + slot;
      var minFromStart = slotIdx * step;
      // A date with total minutes calculated from the start of the day
      slots[slotIdx] = groups[grp][slot] = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + minFromStart, 0, 0);
    }
  }

  // Necessary to be able to select up until the last timeslot in a day
  var lastSlotMinFromStart = slots.length * step;
  slots.push(new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + lastSlotMinFromStart, 0, 0));

  function positionFromDate(date) {
    var diff = _dates2.default.diff(start, date, 'minutes') + getDstOffset(start, date);
    return Math.min(diff, totalMin);
  }

  return {
    groups: groups,
    update: function update(args) {
      if (getKey(args) !== key) return getSlotMetrics(args);
      return this;
    },
    dateIsInGroup: function dateIsInGroup(date, groupIndex) {
      var nextGroup = groups[groupIndex + 1];
      return _dates2.default.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
    },
    nextSlot: function nextSlot(slot) {
      var next = slots[Math.min(slots.indexOf(slot) + 1, slots.length - 1)];
      // in the case of the last slot we won't a long enough range so manually get it
      if (next === slot) next = _dates2.default.add(slot, step, 'minutes');
      return next;
    },
    closestSlotToPosition: function closestSlotToPosition(percent) {
      var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
      return slots[slot];
    },
    startsBefore: function startsBefore(date) {
      return _dates2.default.lt(_dates2.default.merge(start, date), start, 'minutes');
    },
    startsAfter: function startsAfter(date) {
      return _dates2.default.gt(_dates2.default.merge(end, date), end, 'minutes');
    },
    getRange: function getRange(rangeStart, rangeEnd) {
      rangeStart = _dates2.default.min(end, _dates2.default.max(start, rangeStart));
      rangeEnd = _dates2.default.min(end, _dates2.default.max(start, rangeEnd));

      var rangeStartMin = positionFromDate(rangeStart);
      var rangeEndMin = positionFromDate(rangeEnd);
      var top = rangeStartMin / totalMin * 100;

      return {
        top: top,
        height: rangeEndMin / totalMin * 100 - top,
        start: positionFromDate(rangeStart),
        startDate: rangeStart,
        end: positionFromDate(rangeEnd),
        endDate: rangeEnd
      };
    }
  };
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = moveDate;

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(153);

var _Views = __webpack_require__(1211);

var _Views2 = _interopRequireDefault(_Views);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function moveDate(View, _ref) {
  var action = _ref.action,
      date = _ref.date,
      today = _ref.today,
      props = _objectWithoutProperties(_ref, ['action', 'date', 'today']);

  View = typeof View === 'string' ? _Views2.default[View] : View;

  switch (action) {
    case _constants.navigate.TODAY:
      date = today || new Date();
      break;
    case _constants.navigate.DATE:
      break;
    default:
      !(View && typeof View.navigate === 'function') ?  false ? (0, _invariant2.default)(false, 'Calendar View components must implement a static `.navigate(date, action)` method.s') : (0, _invariant2.default)(false) : void 0;
      date = View.navigate(date, action, props);
  }
  return date;
}
module.exports = exports['default'];

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2296)();
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Used as main file in package.json
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__(2300);
var DateUtils = __webpack_require__(288);
var LocaleUtils = __webpack_require__(463);
var ModifiersUtils = __webpack_require__(688);
var Weekday = __webpack_require__(1219);
var Navbar = __webpack_require__(1218);
var PropTypes = __webpack_require__(2302);

module.exports = DayPicker;
module.exports.DateUtils = DateUtils;
module.exports.LocaleUtils = LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.propTypes;
module.exports.NavbarPropTypes = Navbar.propTypes;
module.exports.PropTypes = PropTypes;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(464);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(465);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;

      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement('div', { className: className || classNames.navBar }, dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]);
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
Navbar.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
} : {};
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement('div', { className: className, role: 'columnheader' }, _react2.default.createElement('abbr', { title: title }, content));
    }
  }]);

  return Weekday;
}(_react.Component);

exports.default = Weekday;
Weekday.propTypes =  false ? {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
} : {};
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (f) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined') {
    module.exports = f(__webpack_require__(0));
    /* global define */
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function (React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan')
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Script = function (_React$Component) {
  _inherits(Script, _React$Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function Script(props) {
    _classCallCheck(this, Script);

    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));

    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  _createClass(Script, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onError = _props.onError,
          onLoad = _props.onLoad,
          url = _props.url;

      if (this.constructor.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        onError();
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props2 = this.props,
          onCreate = _props2.onCreate,
          url = _props2.url,
          attributes = _props2.attributes;

      var script = document.createElement('script');

      onCreate();

      // add 'data-' or non standard attributes to the script tag
      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          return script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      // default async to true if not set with custom attributes
      if (!script.hasAttribute('async')) {
        script.async = 1;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Script;
}(_react2.default.Component);

Script.propTypes = {
  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: _propTypes.PropTypes.func,
  onError: _propTypes.PropTypes.func.isRequired,
  onLoad: _propTypes.PropTypes.func.isRequired,
  url: _propTypes.PropTypes.string.isRequired
};
Script.defaultProps = {
  attributes: {},
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {} };
Script.scriptObservers = {};
Script.loadedScripts = {};
Script.erroredScripts = {};
Script.idCount = 0;
exports.default = Script;
module.exports = exports['default'];

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(469);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(1223);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(697);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(696);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(697);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(1227);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(2349);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(2343);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(2344);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(2346);

var _isTransform = __webpack_require__(2345);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(2347);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Quill = __webpack_require__(1176);

var QuillMixin = {

	/**
 Creates an editor on the given element. The editor will
 be passed the configuration, have its events bound,
 */
	createEditor: function createEditor($el, config) {
		var editor = new Quill($el, config);
		if (config.tabIndex !== undefined) {
			this.setEditorTabIndex(editor, config.tabIndex);
		}
		this.hookEditor(editor);
		return editor;
	},

	hookEditor: function hookEditor(editor) {
		// Expose the editor on change events via a weaker,
		// unprivileged proxy object that does not allow
		// accidentally modifying editor state.
		var unprivilegedEditor = this.makeUnprivilegedEditor(editor);

		this.handleTextChange = function (delta, oldDelta, source) {
			if (this.onEditorChangeText) {
				this.onEditorChangeText(editor.root.innerHTML, delta, source, unprivilegedEditor);
				this.onEditorChangeSelection(editor.getSelection(), source, unprivilegedEditor);
			}
		}.bind(this);

		this.handleSelectionChange = function (range, oldRange, source) {
			if (this.onEditorChangeSelection) {
				this.onEditorChangeSelection(range, source, unprivilegedEditor);
			}
		}.bind(this);

		editor.on('editor-change', function (eventType, rangeOrDelta, oldRangeOrOldDelta, source) {
			if (eventType === Quill.events.SELECTION_CHANGE) {
				this.handleSelectionChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}

			if (eventType === Quill.events.TEXT_CHANGE) {
				this.handleTextChange(rangeOrDelta, oldRangeOrOldDelta, source);
			}
		}.bind(this));
	},

	unhookEditor: function unhookEditor(editor) {
		editor.off('selection-change');
		editor.off('text-change');
	},

	setEditorReadOnly: function setEditorReadOnly(editor, value) {
		value ? editor.disable() : editor.enable();
	},

	/*
 Replace the contents of the editor, but keep
 the previous selection hanging around so that
 the cursor won't move.
 */
	setEditorContents: function setEditorContents(editor, value) {
		var sel = editor.getSelection();

		if (typeof value === 'string') {
			editor.setContents(editor.clipboard.convert(value));
		} else {
			editor.setContents(value);
		}

		if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
	},

	setEditorSelection: function setEditorSelection(editor, range) {
		if (range) {
			// Validate bounds before applying.
			var length = editor.getLength();
			range.index = Math.max(0, Math.min(range.index, length - 1));
			range.length = Math.max(0, Math.min(range.length, length - 1 - range.index));
		}
		editor.setSelection(range);
	},

	setEditorTabIndex: function setEditorTabIndex(editor, tabIndex) {
		if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
			editor.editor.scroll.domNode.tabIndex = tabIndex;
		}
	},

	/*
 Returns an weaker, unprivileged proxy object that only
 exposes read-only accessors found on the editor instance,
 without any state-modificating methods.
 */
	makeUnprivilegedEditor: function makeUnprivilegedEditor(editor) {
		var e = editor;
		return {
			getLength: function getLength() {
				return e.getLength.apply(e, arguments);
			},
			getText: function getText() {
				return e.getText.apply(e, arguments);
			},
			getHTML: function getHTML() {
				return e.root.innerHTML;
			},
			getContents: function getContents() {
				return e.getContents.apply(e, arguments);
			},
			getSelection: function getSelection() {
				return e.getSelection.apply(e, arguments);
			},
			getBounds: function getBounds() {
				return e.getBounds.apply(e, arguments);
			}
		};
	}

};

module.exports = QuillMixin;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2362)();
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(1233);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1234);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(701);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2376)();
}

/***/ }),
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2436)();
}

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports = __webpack_require__(2438);

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(481);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};
module.exports = exports['default'];

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

exports.default = defaultProps;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(2469);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _shallowEqual2.default;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1273);

var supportsDescriptors = __webpack_require__(618).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if (/a/mig.flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MountNode__ = __webpack_require__(2483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MountNode__["a"]; });



/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keyboard_key__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collections_Menu_MenuItem__ = __webpack_require__(761);













/**
 * An item of a pagination.
 */

var PaginationItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PaginationItem, _Component);

  function PaginationItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PaginationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PaginationItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleKeyDown", function (e) {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onKeyDown', e, _this.props);

      if (__WEBPACK_IMPORTED_MODULE_8_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_8_keyboard_key___default.a.Enter) __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOverrides", function () {
      return {
        onClick: _this.handleClick,
        onKeyDown: _this.handleKeyDown
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PaginationItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          type = _this$props.type;
      var disabled = this.props.disabled || type === 'ellipsisItem';
      return __WEBPACK_IMPORTED_MODULE_12__collections_Menu_MenuItem__["a" /* default */].create(this.props, {
        defaultProps: {
          active: active,
          'aria-current': active,
          'aria-disabled': disabled,
          disabled: disabled,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          tabIndex: disabled ? -1 : 0
        },
        overrideProps: this.handleOverrides
      });
    }
  }]);

  return PaginationItem;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PaginationItem, "handledProps", ["active", "disabled", "onClick", "onKeyDown", "type"]);

PaginationItem.propTypes =  false ? {
  /** A pagination item can be active. */
  active: PropTypes.bool,

  /** A pagination item can be disabled. */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on key down.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyDown: PropTypes.func,

  /** A pagination should have a type. */
  type: PropTypes.oneOf(['ellipsisItem', 'firstItem', 'prevItem', 'pageItem', 'nextItem', 'lastItem'])
} : {};
PaginationItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["e" /* createShorthandFactory */])(PaginationItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Ref__ = __webpack_require__(127);














/**
 * An inner component that allows you to render children outside their parent.
 */
var PortalInner =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PortalInner, _Component);

  function PortalInner() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PortalInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PortalInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleRef", function (c) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["z" /* handleRef */])(_this.props.innerRef, c);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PortalInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(this.props, 'onMount', null, this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(this.props, 'onUnmount', null, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["w" /* isBrowser */])()) return null;
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$mountNode = _this$props.mountNode,
          mountNode = _this$props$mountNode === void 0 ? document.body : _this$props$mountNode;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Ref__["a" /* default */], {
        innerRef: this.handleRef
      }, children), mountNode);
    }
  }]);

  return PortalInner;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PortalInner, "handledProps", ["children", "innerRef", "mountNode", "onMount", "onUnmount"]);

PortalInner.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Called with a ref to the inner node. */
  innerRef: customPropTypes.ref,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PortalInner);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefFindNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_refUtils__ = __webpack_require__(488);












var RefFindNode =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RefFindNode, _Component);

  function RefFindNode() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RefFindNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RefFindNode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "prevNode", null);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RefFindNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.prevNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"])(this);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_refUtils__["b" /* handleRef */])(this.props.innerRef, this.prevNode);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // eslint-disable-next-line react/no-find-dom-node
      var currentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"])(this);

      if (this.prevNode !== currentNode) {
        this.prevNode = currentNode;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_refUtils__["b" /* handleRef */])(this.props.innerRef, currentNode);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_refUtils__["b" /* handleRef */])(this.props.innerRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return RefFindNode;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(RefFindNode, "handledProps", ["children", "innerRef"]);


RefFindNode.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.element.isRequired,

  /**
   * Called when a child component will be mounted or updated.
   *
   * @param {HTMLElement} node - Referred node.
   */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
} : {};

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefForward; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_refUtils__ = __webpack_require__(488);











var RefForward =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RefForward, _Component);

  function RefForward() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RefForward);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RefForward)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleRefOverride", function (node) {
      var _this$props = _this.props,
          children = _this$props.children,
          innerRef = _this$props.innerRef;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_refUtils__["b" /* handleRef */])(children.ref, node);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_refUtils__["b" /* handleRef */])(innerRef, node);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RefForward, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(children, {
        ref: this.handleRefOverride
      });
    }
  }]);

  return RefForward;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(RefForward, "handledProps", ["children", "innerRef"]);


RefForward.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.element.isRequired,

  /**
   * Called when a child component will be mounted or updated.
   *
   * @param {HTMLElement} node - Referred node.
   */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
} : {};

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(2497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextArea__ = __webpack_require__(2498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextArea__["a"]; });



/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Icon__ = __webpack_require__(90);








/**
 * A divider sub-component for Breadcrumb component.
 */

function BreadcrumbDivider(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(BreadcrumbDivider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(BreadcrumbDivider, props);

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(icon)) {
    return __WEBPACK_IMPORTED_MODULE_7__elements_Icon__["a" /* default */].create(icon, {
      defaultProps: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, rest, {
        className: classes
      }),
      autoGenerateKey: false
    });
  }

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? '/' : children);
}

BreadcrumbDivider.handledProps = ["as", "children", "className", "content", "icon"];
BreadcrumbDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `Icon` component with `divider` class instead of a `div`. */
  icon: customPropTypes.itemShorthand
} : {};
BreadcrumbDivider.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(BreadcrumbDivider, function (icon) {
  return {
    icon: icon
  };
});
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbDivider);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(7);













/**
 * A section sub-component for Breadcrumb component.
 */

var BreadcrumbSection =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BreadcrumbSection, _Component);

  function BreadcrumbSection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BreadcrumbSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var _this$props = _this.props,
          link = _this$props.link,
          onClick = _this$props.onClick;
      if (link || onClick) return 'a';
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BreadcrumbSection, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          children = _this$props2.children,
          className = _this$props2.className,
          content = _this$props2.content,
          href = _this$props2.href;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(active, 'active'), 'section', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["b" /* getUnhandledProps */])(BreadcrumbSection, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* getElementType */])(BreadcrumbSection, this.props, this.computeElementType);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
    }
  }]);

  return BreadcrumbSection;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(BreadcrumbSection, "handledProps", ["active", "as", "children", "className", "content", "href", "link", "onClick"]);


BreadcrumbSection.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently active section. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: customPropTypes.every([customPropTypes.disallow(['link']), PropTypes.string]),

  /** Render as an `a` tag instead of a `div`. */
  link: customPropTypes.every([customPropTypes.disallow(['href']), PropTypes.bool]),

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
BreadcrumbSection.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["e" /* createShorthandFactory */])(BreadcrumbSection, function (content) {
  return {
    content: content,
    link: true
  };
});

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Button__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={Button} />.
 * @see Button
 * @see Form
 */

function FormButton(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormButton, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormButton, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormButton.handledProps = ["as", "control"];
FormButton.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormButton.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__elements_Button__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormButton);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={Checkbox} />.
 * @see Checkbox
 * @see Form
 */

function FormCheckbox(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormCheckbox, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormCheckbox, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormCheckbox.handledProps = ["as", "control"];
FormCheckbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormCheckbox.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormCheckbox);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={Dropdown} />.
 * @see Dropdown
 * @see Form
 */

function FormDropdown(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormDropdown, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormDropdown, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormDropdown.handledProps = ["as", "control"];
FormDropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormDropdown.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormDropdown);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A set of fields can appear grouped together.
 * @see Form
 */

function FormGroup(props) {
  var children = props.children,
      className = props.className,
      grouped = props.grouped,
      inline = props.inline,
      unstackable = props.unstackable,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(grouped, 'grouped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* useWidthProp */])(widths, null, true), 'fields', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(FormGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(FormGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

FormGroup.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"];
FormGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Fields can show related choices. */
  grouped: customPropTypes.every([customPropTypes.disallow(['inline']), PropTypes.bool]),

  /** Multiple fields may be inline in a row. */
  inline: customPropTypes.every([customPropTypes.disallow(['grouped']), PropTypes.bool]),

  /** A form group can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal']))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Input__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={Input} />.
 * @see Form
 * @see Input
 */

function FormInput(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormInput, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormInput, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormInput.handledProps = ["as", "control"];
FormInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormInput.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__elements_Input__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormInput);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Radio__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={Radio} />.
 * @see Form
 * @see Radio
 */

function FormRadio(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormRadio, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormRadio, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormRadio.handledProps = ["as", "control"];
FormRadio.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormRadio.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__addons_Radio__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormRadio);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Select__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Dropdown__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormField__ = __webpack_require__(179);







/**
 * Sugar for <Form.Field control={Select} />.
 * @see Form
 * @see Select
 */

function FormSelect(props) {
  var control = props.control,
      options = props.options;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormSelect, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormSelect, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control,
    options: options
  }));
}

FormSelect.handledProps = ["as", "control", "options"];
FormSelect.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
FormSelect.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_6__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_Select__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormSelect);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_TextArea__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(179);





/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */

function FormTextArea(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(FormTextArea, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["c" /* getElementType */])(FormTextArea, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormTextArea.handledProps = ["as", "control"];
FormTextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormTextArea.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__addons_TextArea__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormTextArea);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GridColumn__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GridRow__ = __webpack_require__(1293);








/**
 * A grid is used to harmonize negative space in a layout.
 */

function Grid(props) {
  var celled = props.celled,
      centered = props.centered,
      children = props.children,
      className = props.className,
      columns = props.columns,
      container = props.container,
      divided = props.divided,
      doubling = props.doubling,
      inverted = props.inverted,
      padded = props.padded,
      relaxed = props.relaxed,
      reversed = props.reversed,
      stackable = props.stackable,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(container, 'container'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(doubling, 'doubling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["t" /* useMultipleProp */])(reversed, 'reversed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* useWidthProp */])(columns, 'column', true), 'grid', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Grid, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Grid, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

Grid.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"];
Grid.Column = __WEBPACK_IMPORTED_MODULE_6__GridColumn__["a" /* default */];
Grid.Row = __WEBPACK_IMPORTED_MODULE_7__GridRow__["a" /* default */];
Grid.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A grid can have rows divided into cells. */
  celled: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['internally'])]),

  /** A grid can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Represents column count per row in Grid. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A grid can be combined with a container to use the available layout and alignment. */
  container: PropTypes.bool,

  /** A grid can have dividers between its columns. */
  divided: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['vertically'])]),

  /** A grid can double its column width on tablet and mobile sizes. */
  doubling: PropTypes.bool,

  /** A grid's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A grid can increase its gutters to allow for more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A grid can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
  stackable: PropTypes.bool,

  /** A grid can stretch its contents to take up the entire grid height. */
  stretched: PropTypes.bool,

  /** A grid can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A row sub-component for Grid.
 */

function GridRow(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      color = props.color,
      columns = props.columns,
      divided = props.divided,
      only = props.only,
      reversed = props.reversed,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["t" /* useMultipleProp */])(only, 'only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["t" /* useMultipleProp */])(reversed, 'reversed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* useWidthProp */])(columns, 'column', true), 'row', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(GridRow, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(GridRow, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

GridRow.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"];
GridRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A row can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid row can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Represents column count per line in Row. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A row can have dividers between its columns. */
  divided: PropTypes.bool,

  /** A row can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A row can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A row can stretch its contents to take up the entire column height. */
  stretched: PropTypes.bool,

  /** A row can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A row can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MenuHeader__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MenuItem__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MenuMenu__ = __webpack_require__(1296);


















/**
 * A menu displays grouped navigation actions.
 * @see Dropdown
 */

var Menu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Menu, _Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          var index = itemProps.index;

          _this.trySetState({
            activeIndex: index
          });

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Menu, [{
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var items = this.props.items;
      var activeIndex = this.state.activeIndex;
      return __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(items, function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_16__MenuItem__["a" /* default */].create(item, {
          defaultProps: {
            active: parseInt(activeIndex, 10) === index,
            index: index
          },
          overrideProps: _this2.handleItemOverrides
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attached = _this$props.attached,
          borderless = _this$props.borderless,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          compact = _this$props.compact,
          fixed = _this$props.fixed,
          floated = _this$props.floated,
          fluid = _this$props.fluid,
          icon = _this$props.icon,
          inverted = _this$props.inverted,
          pagination = _this$props.pagination,
          pointing = _this$props.pointing,
          secondary = _this$props.secondary,
          size = _this$props.size,
          stackable = _this$props.stackable,
          tabular = _this$props.tabular,
          text = _this$props.text,
          vertical = _this$props.vertical,
          widths = _this$props.widths;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(borderless, 'borderless'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(pagination, 'pagination'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(pointing, 'pointing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(text, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* useKeyOrValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* useKeyOrValueAndKey */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* useKeyOrValueAndKey */])(tabular, 'tabular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["g" /* useValueAndKey */])(fixed, 'fixed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["f" /* useWidthProp */])(widths, 'item'), className, 'menu');
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(Menu, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["c" /* getElementType */])(Menu, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_14__lib__["d" /* childrenUtils */].isNil(children) ? this.renderItems() : children);
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Header", __WEBPACK_IMPORTED_MODULE_15__MenuHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Item", __WEBPACK_IMPORTED_MODULE_16__MenuItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Menu", __WEBPACK_IMPORTED_MODULE_17__MenuMenu__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "handledProps", ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"]);

Menu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Index of the currently active item. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu may be attached to other content segments. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A menu item or menu can have no borders. */
  borderless: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A menu can take up only the space necessary to fit its content. */
  compact: PropTypes.bool,

  /** Initial activeIndex value. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu can be fixed to a side of its context. */
  fixed: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),

  /** A menu can be floated. */
  floated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A vertical menu may take the size of its container. */
  fluid: PropTypes.bool,

  /** A menu may have just icons (bool) or labeled icons. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['labeled'])]),

  /** A menu may have its colors inverted to show greater contrast. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for Menu. */
  items: customPropTypes.collectionShorthand,

  /**
   * onClick handler for MenuItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A pagination menu is specially formatted to present links to pages of content. */
  pagination: PropTypes.bool,

  /** A menu can point to show its relationship to nearby content. */
  pointing: PropTypes.bool,

  /** A menu can adjust its appearance to de-emphasize its contents. */
  secondary: PropTypes.bool,

  /** A menu can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big')),

  /** A menu can stack at mobile resolutions. */
  stackable: PropTypes.bool,

  /** A menu can be formatted to show tabs of information. */
  tabular: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A menu can be formatted for text content. */
  text: PropTypes.bool,

  /** A vertical menu displays elements vertically. */
  vertical: PropTypes.bool,

  /** A menu can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
Menu.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["e" /* createShorthandFactory */])(Menu, function (items) {
  return {
    items: items
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A menu item may include a header or may itself be a header.
 */

function MenuHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MenuHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MenuHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MenuHeader.handledProps = ["as", "children", "className", "content"];
MenuHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuHeader);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A menu can contain a sub menu.
 */

function MenuMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      position = props.position;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(position, 'menu', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MenuMenu, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MenuMenu, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MenuMenu.handledProps = ["as", "children", "className", "content", "position"];
MenuMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A sub menu can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuMenu);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });



/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A message can contain a content.
 */

function MessageContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageContent.handledProps = ["as", "children", "className", "content"];
MessageContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MessageContent);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A message can contain a header.
 */

function MessageHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageHeader.handledProps = ["as", "children", "className", "content"];
MessageHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(MessageHeader, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageHeader);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageItem__ = __webpack_require__(762);







/**
 * A message can contain a list of items.
 */

function MessageList(props) {
  var children = props.children,
      className = props.className,
      items = props.items;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(MessageList, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(MessageList, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(items, __WEBPACK_IMPORTED_MODULE_6__MessageItem__["a" /* default */].create) : children);
}

MessageList.handledProps = ["as", "children", "className", "items"];
MessageList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand Message.Items. */
  items: customPropTypes.collectionShorthand
} : {};
MessageList.defaultProps = {
  as: 'ul'
};
MessageList.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(MessageList, function (val) {
  return {
    items: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageList);

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);






function TableBody(props) {
  var children = props.children,
      className = props.className;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableBody, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TableBody, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

TableBody.handledProps = ["as", "children", "className"];
TableBody.defaultProps = {
  as: 'tbody'
};
TableBody.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableHeader__ = __webpack_require__(763);




/**
 * A table can have a footer.
 */

function TableFooter(props) {
  var as = props.as;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(TableFooter, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableHeader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    as: as
  }));
}

TableFooter.handledProps = ["as"];
TableFooter.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as
} : {};
TableFooter.defaultProps = {
  as: 'tfoot'
};
/* harmony default export */ __webpack_exports__["a"] = (TableFooter);

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableCell__ = __webpack_require__(482);






/**
 * A table can have a header cell.
 */

function TableHeaderCell(props) {
  var as = props.as,
      className = props.className,
      sorted = props.sorted;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(sorted, 'sorted'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableHeaderCell, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableCell__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    as: as,
    className: classes
  }));
}

TableHeaderCell.handledProps = ["as", "className", "sorted"];
TableHeaderCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** A header cell can be sorted in ascending or descending order. */
  sorted: PropTypes.oneOf(['ascending', 'descending'])
} : {};
TableHeaderCell.defaultProps = {
  as: 'th'
};
/* harmony default export */ __webpack_exports__["a"] = (TableHeaderCell);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(482);








/**
 * A table can have rows.
 */

function TableRow(props) {
  var active = props.active,
      cellAs = props.cellAs,
      cells = props.cells,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      negative = props.negative,
      positive = props.positive,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(TableRow, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(TableRow, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(cells, function (cell) {
    return __WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* default */].create(cell, {
      defaultProps: {
        as: cellAs
      }
    });
  }));
}

TableRow.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"];
TableRow.defaultProps = {
  as: 'tr',
  cellAs: 'td'
};
TableRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A row can be active or selected by a user. */
  active: PropTypes.bool,

  /** An element type to render as (string or function). */
  cellAs: customPropTypes.as,

  /** Shorthand array of props for TableCell. */
  cells: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A row can be disabled. */
  disabled: PropTypes.bool,

  /** A row may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** A row may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A row may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A table row can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table row can adjust its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A row may warn a user. */
  warning: PropTypes.bool
} : {};
TableRow.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(TableRow, function (cells) {
  return {
    cells: cells
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * Used in some Button types, such as `animated`.
 */

function ButtonContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(visible, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ButtonContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ButtonContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ButtonContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
ButtonContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initially hidden, visible on hover. */
  hidden: PropTypes.bool,

  /** Initially visible, hidden on hover. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(764);








/**
 * Buttons can be grouped.
 */

function ButtonGroup(props) {
  var attached = props.attached,
      basic = props.basic,
      buttons = props.buttons,
      children = props.children,
      className = props.className,
      color = props.color,
      compact = props.compact,
      content = props.content,
      floated = props.floated,
      fluid = props.fluid,
      icon = props.icon,
      inverted = props.inverted,
      labeled = props.labeled,
      negative = props.negative,
      positive = props.positive,
      primary = props.primary,
      secondary = props.secondary,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(labeled, 'labeled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(primary, 'primary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(widths), 'buttons', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(ButtonGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(ButtonGroup, props);

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(buttons)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(buttons, function (button) {
    return __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].create(button);
  }));
}

ButtonGroup.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"];
ButtonGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Groups can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** Groups can be less pronounced. */
  basic: PropTypes.bool,

  /** Array of shorthand Button values. */
  buttons: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Groups can have a shared color. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Groups can reduce their padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Groups can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Groups can take the width of their container. */
  fluid: PropTypes.bool,

  /** Groups can be formatted as icons. */
  icon: PropTypes.bool,

  /** Groups can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Groups can be formatted as labeled icon buttons. */
  labeled: PropTypes.bool,

  /** Groups can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /** Groups can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** Groups can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Groups can be formatted to toggle on and off. */
  toggle: PropTypes.bool,

  /** Groups can be formatted to appear vertically. */
  vertical: PropTypes.bool,

  /** Groups can have their widths divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * Button groups can contain conditionals.
 */

function ButtonOr(props) {
  var className = props.className,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('or', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ButtonOr, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ButtonOr, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes,
    "data-text": text
  }));
}

ButtonOr.handledProps = ["as", "className", "text"];
ButtonOr.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonOr);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag__ = __webpack_require__(2516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flag__["a"]; });



/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */

function HeaderContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(HeaderContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(HeaderContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderContent.handledProps = ["as", "children", "className", "content"];
HeaderContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (HeaderContent);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * Headers may contain subheaders.
 */

function HeaderSubheader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('sub header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(HeaderSubheader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(HeaderSubheader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderSubheader.handledProps = ["as", "children", "className", "content"];
HeaderSubheader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
HeaderSubheader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(HeaderSubheader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (HeaderSubheader);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * Several icons can be used together as a group.
 */

function IconGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(size, 'icons', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(IconGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(IconGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

IconGroup.handledProps = ["as", "children", "className", "content", "size"];
IconGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Size of the icon group. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
IconGroup.defaultProps = {
  as: 'i'
};
/* harmony default export */ __webpack_exports__["a"] = (IconGroup);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Label_Label__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImageGroup__ = __webpack_require__(1313);










/**
 * An image is a graphic representation of something.
 * @see Icon
 */

function Image(props) {
  var avatar = props.avatar,
      bordered = props.bordered,
      centered = props.centered,
      children = props.children,
      circular = props.circular,
      className = props.className,
      content = props.content,
      dimmer = props.dimmer,
      disabled = props.disabled,
      floated = props.floated,
      fluid = props.fluid,
      hidden = props.hidden,
      href = props.href,
      inline = props.inline,
      label = props.label,
      rounded = props.rounded,
      size = props.size,
      spaced = props.spaced,
      verticalAlign = props.verticalAlign,
      wrapped = props.wrapped,
      ui = props.ui;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(ui, 'ui'), size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(avatar, 'avatar'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(bordered, 'bordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(rounded, 'rounded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(spaced, 'spaced'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* useVerticalAlignProp */])(verticalAlign, 'aligned'), 'image', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Image, props);

  var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_6__lib__["m" /* htmlImageProps */]
  }),
      _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
      imgTagProps = _partitionHTMLProps2[0],
      rootProps = _partitionHTMLProps2[1];

  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Image, props, function () {
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dimmer) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(label) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(wrapped) || !__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
      return 'div';
    }
  });

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  if (ElementType === 'img') {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, imgTagProps, {
      className: classes
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, {
    className: classes,
    href: href
  }), __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__["a" /* default */].create(dimmer, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_8__Label_Label__["a" /* default */].create(label, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", imgTagProps));
}

Image.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"];
Image.Group = __WEBPACK_IMPORTED_MODULE_9__ImageGroup__["a" /* default */];
Image.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An image may be formatted to appear inline with text as an avatar. */
  avatar: PropTypes.bool,

  /** An image may include a border to emphasize the edges of white or transparent content. */
  bordered: PropTypes.bool,

  /** An image can appear centered in a content block. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** An image may appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An image can show that it is disabled and cannot be selected. */
  disabled: PropTypes.bool,

  /** Shorthand for Dimmer. */
  dimmer: customPropTypes.itemShorthand,

  /** An image can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** An image can take up the width of its container. */
  fluid: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['size'])]),

  /** An image can be hidden. */
  hidden: PropTypes.bool,

  /** Renders the Image as an <a> tag with this href. */
  href: PropTypes.string,

  /** An image may appear inline. */
  inline: PropTypes.bool,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /** An image may appear rounded. */
  rounded: PropTypes.bool,

  /** An image may appear at different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
  spaced: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Whether or not to add the ui className. */
  ui: PropTypes.bool,

  /** An image can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
  wrapped: PropTypes.bool
} : {};
Image.defaultProps = {
  as: 'img',
  ui: true
};
Image.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(Image, function (value) {
  return {
    src: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A group of images.
 */

function ImageGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, className, 'images');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ImageGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ImageGroup, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ImageGroup.handledProps = ["as", "children", "className", "content", "size"];
ImageGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of images can be formatted to have the same size. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ImageGroup);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);






function LabelDetail(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('detail', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(LabelDetail, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(LabelDetail, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

LabelDetail.handledProps = ["as", "children", "className", "content"];
LabelDetail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
LabelDetail.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(LabelDetail, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (LabelDetail);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A label can be grouped.
 */

function LabelGroup(props) {
  var children = props.children,
      circular = props.circular,
      className = props.className,
      color = props.color,
      content = props.content,
      size = props.size,
      tag = props.tag;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(tag, 'tag'), 'labels', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(LabelGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(LabelGroup, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

LabelGroup.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"];
LabelGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Labels can share shapes. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Label group can share colors together. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Label group can share sizes together. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Label group can share tag formatting. */
  tag: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (LabelGroup);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Image__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListContent__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ListDescription__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ListHeader__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ListIcon__ = __webpack_require__(768);



















/**
 * A list item can contain a set of items.
 */

var ListItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ListItem, _Component);

  function ListItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          description = _this$props.description,
          disabled = _this$props.disabled,
          header = _this$props.header,
          icon = _this$props.icon,
          image = _this$props.image,
          value = _this$props.value;
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(ListItem, this.props);
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(ElementType !== 'li', 'item'), className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(ListItem, this.props);
      var valueProp = ElementType === 'li' ? {
        value: value
      } : {
        'data-value': value
      };

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), children);
      }

      var iconElement = __WEBPACK_IMPORTED_MODULE_18__ListIcon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      });
      var imageElement = __WEBPACK_IMPORTED_MODULE_14__Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      }); // See description of `content` prop for explanation about why this is necessary.

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["isValidElement"])(content) && __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject___default()(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), iconElement || imageElement, __WEBPACK_IMPORTED_MODULE_15__ListContent__["a" /* default */].create(content, {
          autoGenerateKey: false,
          defaultProps: {
            header: header,
            description: description
          }
        }));
      }

      var headerElement = __WEBPACK_IMPORTED_MODULE_17__ListHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      });
      var descriptionElement = __WEBPACK_IMPORTED_MODULE_16__ListDescription__["a" /* default */].create(description, {
        autoGenerateKey: false
      });

      if (iconElement || imageElement) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), iconElement || imageElement, (content || headerElement || descriptionElement) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ListContent__["a" /* default */], null, headerElement, descriptionElement, content));
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
        role: "listitem",
        className: classes,
        onClick: this.handleClick
      }, rest), headerElement, descriptionElement, content);
    }
  }]);

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ListItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"]);

ListItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A list item can active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * Shorthand for primary content.
   *
   * Heads up!
   *
   * This is handled slightly differently than the typical `content` prop since
   * the wrapping ListContent is not used when there's no icon or image.
   *
   * If you pass content as:
   * - an element/literal, it's treated as the sibling node to
   * header/description (whether wrapped in Item.Content or not).
   * - a props object, it forces the presence of Item.Content and passes those
   * props to it. If you pass a content prop within that props object, it
   * will be treated as the sibling node to header/description.
   */
  content: customPropTypes.itemShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** A list item can disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ListIcon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), customPropTypes.itemShorthand]),

  /** Shorthand for Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.itemShorthand]),

  /** A ListItem can be clicked */
  onClick: PropTypes.func,

  /** A value for an ordered list. */
  value: PropTypes.string
} : {};
ListItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["e" /* createShorthandFactory */])(ListItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A list can contain a sub list.
 */

function ListList(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListList, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListList, props);
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListList.handledProps = ["as", "children", "className", "content"];
ListList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ListList);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A placeholder can contain a header.
 */

function PlaceholderHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(image, 'image'), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderHeader.handledProps = ["as", "children", "className", "content", "image"];
PlaceholderHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A placeholder can contain an image. */
  image: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderHeader);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A placeholder can contain an image.
 */

function PlaceholderImage(props) {
  var className = props.className,
      square = props.square,
      rectangular = props.rectangular;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(square, 'square'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(rectangular, 'rectangular'), 'image', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderImage, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderImage, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

PlaceholderImage.handledProps = ["as", "className", "rectangular", "square"];
PlaceholderImage.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** An image can modify size correctly with responsive styles. */
  square: customPropTypes.every([customPropTypes.disallow(['rectangular']), PropTypes.bool]),

  /** An image can modify size correctly with responsive styles. */
  rectangular: customPropTypes.every([customPropTypes.disallow(['square']), PropTypes.bool])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderImage);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A placeholder can contain have lines of text.
 */

function PlaceholderLine(props) {
  var className = props.className,
      length = props.length;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('line', length, className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderLine, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderLine, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

PlaceholderLine.handledProps = ["as", "className", "length"];
PlaceholderLine.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** A line can specify how long its contents should appear. */
  length: PropTypes.oneOf(['full', 'very long', 'long', 'medium', 'short', 'very short'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderLine);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A placeholder can contain a paragraph.
 */

function PlaceholderParagraph(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('paragraph', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderParagraph, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderParagraph, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderParagraph.handledProps = ["as", "children", "className", "content"];
PlaceholderParagraph.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderParagraph);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A content sub-component for the Reveal.
 */

function RevealContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(visible, 'visible'), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(RevealContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(RevealContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

RevealContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
RevealContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A reveal may contain content that is visible before interaction. */
  hidden: PropTypes.bool,

  /** A reveal may contain content that is hidden before user interaction. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (RevealContent);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SegmentInline__ = __webpack_require__(1325);








/**
 * A segment is used to create a grouping of related content.
 */

function Segment(props) {
  var attached = props.attached,
      basic = props.basic,
      children = props.children,
      circular = props.circular,
      className = props.className,
      clearing = props.clearing,
      color = props.color,
      compact = props.compact,
      content = props.content,
      disabled = props.disabled,
      floated = props.floated,
      inverted = props.inverted,
      loading = props.loading,
      placeholder = props.placeholder,
      padded = props.padded,
      piled = props.piled,
      raised = props.raised,
      secondary = props.secondary,
      size = props.size,
      stacked = props.stacked,
      tertiary = props.tertiary,
      textAlign = props.textAlign,
      vertical = props.vertical;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(clearing, 'clearing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(placeholder, 'placeholder'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(piled, 'piled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(raised, 'raised'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stacked, 'stacked'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(tertiary, 'tertiary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), 'segment', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Segment, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Segment, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Segment.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"];
Segment.Group = __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__["a" /* default */];
Segment.Inline = __WEBPACK_IMPORTED_MODULE_7__SegmentInline__["a" /* default */];
Segment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach segment to other content, like a header. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A basic segment has no special formatting. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A segment can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment can clear floated content. */
  clearing: PropTypes.bool,

  /** Segment can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A segment may show its content is disabled. */
  disabled: PropTypes.bool,

  /** Segment content can be floated to the left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A segment can have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** A segment may show its content is being loaded. */
  loading: PropTypes.bool,

  /** A segment can increase its padding. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A segment can be used to reserve space for conditionally displayed content. */
  placeholder: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment can be formatted to appear less noticeable. */
  secondary: PropTypes.bool,

  /** A segment can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool,

  /** A segment can be formatted to appear even less noticeable. */
  tertiary: PropTypes.bool,

  /** Formats content to be aligned as part of a vertical group. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** Formats content to be aligned vertically. */
  vertical: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Segment);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A group of segments can be formatted to appear together.
 */

function SegmentGroup(props) {
  var children = props.children,
      className = props.className,
      compact = props.compact,
      content = props.content,
      horizontal = props.horizontal,
      piled = props.piled,
      raised = props.raised,
      size = props.size,
      stacked = props.stacked;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(piled, 'piled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(raised, 'raised'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stacked, 'stacked'), 'segments', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(SegmentGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(SegmentGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentGroup.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"];
SegmentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Formats content to be aligned horizontally. */
  horizontal: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment group may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment group can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentGroup);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A placeholder segment can be inline.
 */

function SegmentInline(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('inline', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SegmentInline, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SegmentInline, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentInline.handledProps = ["as", "children", "className", "content"];
SegmentInline.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentInline);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StepContent__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StepDescription__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StepGroup__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StepTitle__ = __webpack_require__(770);


















/**
 * A step shows the completion status of an activity in a series of activities.
 */

var Step =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Step, _Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var onClick = _this.props.onClick;
      if (onClick) return 'a';
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Step, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          completed = _this$props.completed,
          content = _this$props.content,
          description = _this$props.description,
          disabled = _this$props.disabled,
          href = _this$props.href,
          icon = _this$props.icon,
          link = _this$props.link,
          title = _this$props.title;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(completed, 'completed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(link, 'link'), 'step', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["b" /* getUnhandledProps */])(Step, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* getElementType */])(Step, this.props, this.computeElementType);

      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_13__Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_14__StepContent__["a" /* default */].create({
        description: description,
        title: title
      }, {
        autoGenerateKey: false
      }));
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Content", __WEBPACK_IMPORTED_MODULE_14__StepContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Description", __WEBPACK_IMPORTED_MODULE_15__StepDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Group", __WEBPACK_IMPORTED_MODULE_16__StepGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Title", __WEBPACK_IMPORTED_MODULE_17__StepTitle__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "handledProps", ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"]);

Step.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A step can be highlighted as active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A step can show that a user has completed it. */
  completed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Show that the Loader is inactive. */
  disabled: PropTypes.bool,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A step can be link. */
  link: PropTypes.bool,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
  ordered: PropTypes.bool,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
Step.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["e" /* createShorthandFactory */])(Step, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Step);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepDescription__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepTitle__ = __webpack_require__(770);







/**
 * A step can contain a content.
 */

function StepContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      title = props.title;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__StepTitle__["a" /* default */].create(title, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_5__StepDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }));
}

StepContent.handledProps = ["as", "children", "className", "content", "description", "title"];
StepContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
StepContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepContent);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__ = __webpack_require__(2759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step__ = __webpack_require__(1326);












var numberMap =  false ? _pickBy(numberToWordMap, function (val, key) {
  return key <= 8;
}) : {};
/**
 * A set of steps.
 */

function StepGroup(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      items = props.items,
      ordered = props.ordered,
      size = props.size,
      stackable = props.stackable,
      unstackable = props.unstackable,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(ordered, 'ordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["g" /* useValueAndKey */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["f" /* useWidthProp */])(widths), 'steps', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["b" /* getUnhandledProps */])(StepGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* getElementType */])(StepGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_11__Step__["a" /* default */].create(item);
  }));
}

StepGroup.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"];
StepGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Steps can be attached to other elements. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid step takes up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand array of props for Step. */
  items: customPropTypes.collectionShorthand,

  /** A step can show a ordered sequence of steps. */
  ordered: PropTypes.bool,

  /** Steps can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A step can stack vertically only on smaller screens. */
  stackable: PropTypes.oneOf(['tablet']),

  /** A step can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** A step can be displayed stacked vertically. */
  vertical: PropTypes.bool,

  /** Steps can be divided evenly inside their parent. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(_keys(numberMap)), _toConsumableArray(_keys(numberMap).map(Number)), _toConsumableArray(_values(numberMap))))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StepGroup);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createEllipsisItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPrevItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPageFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createNextItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createLastItem; });
/**
 * @param {number} pageNumber
 * @return {Object}
 */
var createEllipsisItem = function createEllipsisItem(pageNumber) {
  return {
    active: false,
    type: 'ellipsisItem',
    value: pageNumber
  };
};
/**
 * @return {Object}
 */

var createFirstPage = function createFirstPage() {
  return {
    active: false,
    type: 'firstItem',
    value: 1
  };
};
/**
 * @param {number} activePage
 * @return {Object}
 */

var createPrevItem = function createPrevItem(activePage) {
  return {
    active: false,
    type: 'prevItem',
    value: Math.max(1, activePage - 1)
  };
};
/**
 * @param {number} activePage
 * @return {function}
 */

var createPageFactory = function createPageFactory(activePage) {
  return function (pageNumber) {
    return {
      active: activePage === pageNumber,
      type: 'pageItem',
      value: pageNumber
    };
  };
};
/**
 * @param {number} activePage
 * @param {number} totalPages
 * @return {Object}
 */

var createNextItem = function createNextItem(activePage, totalPages) {
  return {
    active: false,
    type: 'nextItem',
    value: Math.min(activePage + 1, totalPages)
  };
};
/**
 * @param {number} totalPages
 * @return {Object}
 */

var createLastItem = function createLastItem(totalPages) {
  return {
    active: false,
    type: 'lastItem',
    value: totalPages
  };
};

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy of sindre's leven, wrapped in dead code elimination for production
// https://github.com/sindresorhus/leven/blob/master/index.js

/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */
var leven = function leven() {
  return 0;
};

if (false) {
  var arr = [];
  var charCodeCache = [];

  leven = function leven(a, b) {
    if (a === b) return 0;
    var aLen = a.length;
    var bLen = b.length;
    if (aLen === 0) return bLen;
    if (bLen === 0) return aLen;
    var bCharCode;
    var ret;
    var tmp;
    var tmp2;
    var i = 0;
    var j = 0;

    while (i < aLen) {
      charCodeCache[i] = a.charCodeAt(i);
      arr[i] = ++i;
    }

    while (j < bLen) {
      bCharCode = b.charCodeAt(j);
      tmp = j++;
      ret = j;

      for (i = 0; i < aLen; i++) {
        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
        tmp = arr[i];
        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
      }
    }

    return ret;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (leven);

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AccordionPanel__ = __webpack_require__(773);




















var warnIfPropsAreInvalid = function warnIfPropsAreInvalid(props, state) {
  var exclusive = props.exclusive;
  var activeIndex = state.activeIndex;
  /* eslint-disable no-console */

  if (exclusive && typeof activeIndex !== 'number') {
    console.error('`activeIndex` must be a number if `exclusive` is true');
  } else if (!exclusive && !__WEBPACK_IMPORTED_MODULE_13_lodash_isArray___default()(activeIndex)) {
    console.error('`activeIndex` must be an array if `exclusive` is false');
  }
  /* eslint-enable no-console */
};
/**
 * An Accordion can contain sub-accordions.
 */

var AccordionAccordion =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AccordionAccordion, _Component);

  function AccordionAccordion() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AccordionAccordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AccordionAccordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeNewIndex", function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      if (exclusive) return index === activeIndex ? -1 : index; // check to see if index is in array, and remove it, if not then add it

      return __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(activeIndex, index) ? __WEBPACK_IMPORTED_MODULE_11_lodash_without___default()(activeIndex, index) : [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(activeIndex), [index]);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTitleClick", function (e, titleProps) {
      var index = titleProps.index;

      _this.trySetState({
        activeIndex: _this.computeNewIndex(index)
      });

      __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default()(_this.props, 'onTitleClick', e, titleProps);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "isIndexActive", function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      return exclusive ? activeIndex === index : __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(activeIndex, index);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AccordionAccordion, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState(_ref) {
      var exclusive = _ref.exclusive;
      return {
        activeIndex: exclusive ? -1 : []
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (false) {
        warnIfPropsAreInvalid(this.props, this.state);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (false) {
        warnIfPropsAreInvalid(this.props, this.state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          panels = _this$props.panels;
      var classes = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('accordion', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["b" /* getUnhandledProps */])(AccordionAccordion, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["c" /* getElementType */])(AccordionAccordion, this.props);
      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_17__lib__["d" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panels, function (panel, index) {
        return __WEBPACK_IMPORTED_MODULE_18__AccordionPanel__["a" /* default */].create(panel, {
          defaultProps: {
            active: _this2.isIndexActive(index),
            index: index,
            onTitleClick: _this2.handleTitleClick
          }
        });
      }) : children);
    }
  }]);

  return AccordionAccordion;
}(__WEBPACK_IMPORTED_MODULE_17__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "defaultProps", {
  exclusive: true
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "handledProps", ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"]);


AccordionAccordion.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Index of the currently active panel. */
  activeIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Initial activeIndex value. */
  defaultActiveIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Only allow one panel open at a time. */
  exclusive: PropTypes.bool,

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** Shorthand array of props for Accordion. */
  panels: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape({
    content: customPropTypes.itemShorthand,
    title: customPropTypes.itemShorthand
  }))])
} : {};
AccordionAccordion.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["e" /* createShorthandFactory */])(AccordionAccordion, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A dimmable sub-component for Dimmer.
 */

function DimmerDimmable(props) {
  var blurring = props.blurring,
      className = props.className,
      children = props.children,
      content = props.content,
      dimmed = props.dimmed;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(blurring, 'blurring'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(dimmed, 'dimmed'), 'dimmable', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DimmerDimmable, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DimmerDimmable, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

DimmerDimmable.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"];
DimmerDimmable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A dimmable element can blur its contents. */
  blurring: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DimmerDimmable);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DimmerInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);














/**
 * An inner element for a Dimmer.
 */

var DimmerInner =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DimmerInner, _Component);

  function DimmerInner() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DimmerInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DimmerInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "containerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "contentRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var contentRef = _this.contentRef.current;

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);

      if (contentRef && contentRef !== e.target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["x" /* doesNodeContainClick */])(contentRef, e)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClickOutside', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DimmerInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var active = this.props.active;
      this.toggleStyles(active);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var currentActive = this.props.active;
      var prevActive = prevProps.active;
      if (prevActive !== currentActive) this.toggleStyles(currentActive);
    }
  }, {
    key: "toggleStyles",
    value: function toggleStyles(active) {
      var containerRef = this.containerRef.current;
      if (!containerRef || !containerRef.style) return;

      if (active) {
        containerRef.style.setProperty('display', 'flex', 'important');
      } else {
        containerRef.style.removeProperty('display');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          disabled = _this$props.disabled,
          inverted = _this$props.inverted,
          page = _this$props.page,
          simple = _this$props.simple,
          verticalAlign = _this$props.verticalAlign;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active transition visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(page, 'page'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(simple, 'simple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'dimmer', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(DimmerInner, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(DimmerInner, this.props);
      var childrenContent = __WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children) ? content : children;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__addons_Ref__["a" /* default */], {
        innerRef: this.containerRef
      }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), childrenContent && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "content",
        ref: this.contentRef
      }, childrenContent)));
    }
  }]);

  return DimmerInner;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DimmerInner, "handledProps", ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"]);


DimmerInner.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled dimmer cannot be activated */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Handles click outside Dimmer's content, but inside Dimmer area.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClickOutside: PropTypes.func,

  /** A dimmer can be formatted to have its colors inverted. */
  inverted: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool,

  /** A dimmer can be controlled with simple prop. */
  simple: PropTypes.bool,

  /** A dimmer can have its content top or bottom aligned. */
  verticalAlign: PropTypes.oneOf(['bottom', 'top'])
} : {};

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dimmer__ = __webpack_require__(2555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dimmer__["a"]; });



/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A dropdown menu can contain dividers to separate related content.
 */

function DropdownDivider(props) {
  var className = props.className;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownDivider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownDivider, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

DropdownDivider.handledProps = ["as", "className"];
DropdownDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownDivider);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(90);






/**
 * A dropdown menu can contain a header.
 */

function DropdownHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownHeader, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

DropdownHeader.handledProps = ["as", "children", "className", "content", "icon"];
DropdownHeader.propTypes =  false ? {
  /** An element type to render as (string or function) */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand
} : {};
DropdownHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(DropdownHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownHeader);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Flag__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elements_Image__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_Label__ = __webpack_require__(485);

















/**
 * An item sub-component for Dropdown component.
 */

var DropdownItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DropdownItem, _Component);

  function DropdownItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DropdownItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DropdownItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DropdownItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          disabled = _this$props.disabled,
          description = _this$props.description,
          flag = _this$props.flag,
          icon = _this$props.icon,
          image = _this$props.image,
          label = _this$props.label,
          selected = _this$props.selected,
          text = _this$props.text;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(selected, 'selected'), 'item', className); // add default dropdown icon if item contains another menu

      var iconName = __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(icon) ? __WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].someByType(children, 'DropdownMenu') && 'dropdown' : icon;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["b" /* getUnhandledProps */])(DropdownItem, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* getElementType */])(DropdownItem, this.props);
      var ariaOptions = {
        role: 'option',
        'aria-disabled': disabled,
        'aria-checked': active,
        'aria-selected': selected
      };

      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      var flagElement = __WEBPACK_IMPORTED_MODULE_13__elements_Flag__["a" /* default */].create(flag, {
        autoGenerateKey: false
      });
      var iconElement = __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(iconName, {
        autoGenerateKey: false
      });
      var imageElement = __WEBPACK_IMPORTED_MODULE_15__elements_Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      });
      var labelElement = __WEBPACK_IMPORTED_MODULE_16__elements_Label__["a" /* default */].create(label, {
        autoGenerateKey: false
      });
      var descriptionElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["j" /* createShorthand */])('span', function (val) {
        return {
          children: val
        };
      }, description, {
        defaultProps: {
          className: 'description'
        },
        autoGenerateKey: false
      });
      var textElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["j" /* createShorthand */])('span', function (val) {
        return {
          children: val
        };
      }, __WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(content) ? text : content, {
        defaultProps: {
          className: 'text'
        },
        autoGenerateKey: false
      });
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onClick: this.handleClick
      }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
    }
  }]);

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"]);

DropdownItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently chosen item. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: customPropTypes.itemShorthand,

  /** A dropdown item can be disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for Flag. */
  flag: customPropTypes.itemShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** Shorthand for Image. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * The item currently selected by keyboard shortcut.
   * This is not the active item.
   */
  selected: PropTypes.bool,

  /** Display text. */
  text: customPropTypes.contentShorthand,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
} : {};
DropdownItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["e" /* createShorthandFactory */])(DropdownItem, function (opts) {
  return opts;
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A dropdown menu can contain a menu.
 */

function DropdownMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      direction = props.direction,
      open = props.open,
      scrolling = props.scrolling;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(direction, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(open, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'menu transition', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownMenu, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownMenu, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

DropdownMenu.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"];
DropdownMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** Whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** A dropdown menu can scroll. */
  scrolling: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);















/**
 * A search item sub-component for Dropdown component.
 */

var DropdownSearchInput =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(DropdownSearchInput, _Component);

  function DropdownSearchInput() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, DropdownSearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DropdownSearchInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(DropdownSearchInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          className = _this$props.className,
          tabIndex = _this$props.tabIndex,
          type = _this$props.type,
          value = _this$props.value;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('search', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(DropdownSearchInput, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("input", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        "aria-autocomplete": "list",
        autoComplete: autoComplete,
        className: classes,
        onChange: this.handleChange,
        tabIndex: tabIndex,
        type: type,
        value: value
      }));
    }
  }]);

  return DropdownSearchInput;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DropdownSearchInput, "defaultProps", {
  autoComplete: 'off',
  type: 'text'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DropdownSearchInput, "handledProps", ["as", "autoComplete", "className", "tabIndex", "type", "value"]);

DropdownSearchInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An input can have the auto complete. */
  autoComplete: PropTypes.string,

  /** Additional classes. */
  className: PropTypes.string,

  /** An input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The HTML input type. */
  type: PropTypes.string,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
DropdownSearchInput.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["e" /* createShorthandFactory */])(DropdownSearchInput, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownSearchInput);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Button__ = __webpack_require__(483);















/**
 * A modal can contain a row of actions.
 */

var ModalActions =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ModalActions, _Component);

  function ModalActions() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ModalActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ModalActions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleButtonOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onActionClick', e, buttonProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ModalActions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('actions', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(ModalActions, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(ModalActions, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(actions, function (action) {
        return __WEBPACK_IMPORTED_MODULE_14__elements_Button__["a" /* default */].create(action, {
          overrideProps: _this2.handleButtonOverrides
        });
      }));
    }
  }]);

  return ModalActions;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ModalActions, "handledProps", ["actions", "as", "children", "className", "content", "onActionClick"]);


ModalActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Array of shorthand buttons. */
  actions: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props from the clicked action.
   */
  onActionClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func])
} : {};
ModalActions.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["e" /* createShorthandFactory */])(ModalActions, function (actions) {
  return {
    actions: actions
  };
});

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A modal can contain content.
 */

function ModalContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image,
      scrolling = props.scrolling;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(image, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'content');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalContent.handledProps = ["as", "children", "className", "content", "image", "scrolling"];
ModalContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A modal can contain image content. */
  image: PropTypes.bool,

  /** A modal can use the entire size of the screen. */
  scrolling: PropTypes.bool
} : {};
ModalContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ModalContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalContent);

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A modal can contain a description with one or more paragraphs.
 */

function ModalDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalDescription.handledProps = ["as", "children", "className", "content"];
ModalDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ModalDescription);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A modal can have a header.
 */

function ModalHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'header');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalHeader.handledProps = ["as", "children", "className", "content"];
ModalHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ModalHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ModalHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(2559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A PopupContent displays the content body of a Popover.
 */

function PopupContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PopupContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PopupContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}
PopupContent.handledProps = ["as", "children", "className", "content"];
PopupContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The content of the Popup */
  children: PropTypes.node,

  /** Classes to add to the Popup content className. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(PopupContent, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A PopupHeader displays a header in a Popover.
 */

function PopupHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PopupHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PopupHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}
PopupHeader.handledProps = ["as", "children", "className", "content"];
PopupHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(PopupHeader, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);














/**
 * An internal icon sub-component for Rating component
 */

var RatingIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(RatingIcon, _Component);

  function RatingIcon() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RatingIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(RatingIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleKeyUp", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onKeyUp', e, _this.props);

      switch (__WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.Enter:
        case __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.Spacebar:
          e.preventDefault();

          __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);

          break;

        default:
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseEnter", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onMouseEnter', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(RatingIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          selected = _this$props.selected;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(selected, 'selected'), 'icon', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(RatingIcon, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(RatingIcon, this.props);
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick,
        onKeyUp: this.handleKeyUp,
        onMouseEnter: this.handleMouseEnter,
        role: "radio"
      }));
    }
  }]);

  return RatingIcon;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(RatingIcon, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(RatingIcon, "handledProps", ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"]);


RatingIcon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Indicates activity of an icon. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** An index of icon inside Rating. */
  index: PropTypes.number,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on keyup.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyUp: PropTypes.func,

  /**
   * Called on mouseenter.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseEnter: PropTypes.func,

  /** Indicates selection of an icon. */
  selected: PropTypes.bool
} : {};

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);






function SearchCategory(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      renderer = props.renderer;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), 'category', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SearchCategory, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SearchCategory, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "name"
  }, renderer(props)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "results"
  }, __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children));
}

SearchCategory.handledProps = ["active", "as", "children", "className", "content", "name", "renderer", "results"];
SearchCategory.defaultProps = {
  renderer: function renderer(_ref) {
    var name = _ref.name;
    return name;
  }
};
SearchCategory.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Display name. */
  name: PropTypes.string,

  /**
   * Renders the category contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable category contents.
   */
  renderer: PropTypes.func,

  /** Array of Search.Result props. */
  results: PropTypes.array
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchCategory);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(7);











 // Note: You technically only need the 'content' wrapper when there's an
// image. However, optionally wrapping it makes this function a lot more
// complicated and harder to read. Since always wrapping it doesn't affect
// the style in any way let's just do that.
//
// Note: To avoid requiring a wrapping div, we return an array here so to
// prevent rendering issues each node needs a unique key.

var defaultRenderer = function defaultRenderer(_ref) {
  var image = _ref.image,
      price = _ref.price,
      title = _ref.title,
      description = _ref.description;
  return [image && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    key: "image",
    className: "image"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["k" /* createHTMLImage */])(image, {
    autoGenerateKey: false
  })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    key: "content",
    className: "content"
  }, price && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "price"
  }, price), title && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "title"
  }, title), description && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "description"
  }, description))];
};

defaultRenderer.handledProps = [];

var SearchResult =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SearchResult, _Component);

  function SearchResult() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchResult);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchResult)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchResult, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          renderer = _this$props.renderer;
      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(active, 'active'), 'result', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["b" /* getUnhandledProps */])(SearchResult, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* getElementType */])(SearchResult, this.props); // Note: You technically only need the 'content' wrapper when there's an
      // image. However, optionally wrapping it makes this function a lot more
      // complicated and harder to read. Since always wrapping it doesn't affect
      // the style in any way let's just do that.

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), renderer(this.props));
    }
  }]);

  return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(SearchResult, "defaultProps", {
  renderer: defaultRenderer
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(SearchResult, "handledProps", ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"]);


SearchResult.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: PropTypes.string,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Add an image to the item. */
  image: PropTypes.string,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** Customized text for price. */
  price: PropTypes.string,

  /**
   * Renders the result contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable result contents.
   */
  renderer: PropTypes.func,

  /** Display title. */
  title: PropTypes.string.isRequired
} : {};

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);






function SearchResults(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('results transition', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SearchResults, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SearchResults, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SearchResults.handledProps = ["as", "children", "className", "content"];
SearchResults.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPushable(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pushable', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SidebarPushable, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SidebarPushable, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPushable.handledProps = ["as", "children", "className", "content"];
SidebarPushable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPushable);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPusher(props) {
  var className = props.className,
      dimmed = props.dimmed,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pusher', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(dimmed, 'dimmed'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SidebarPusher, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SidebarPusher, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPusher.handledProps = ["as", "children", "className", "content", "dimmed"];
SidebarPusher.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPusher);

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__ = __webpack_require__(1323);






/**
 * A tab pane holds the content of a tab.
 */

function TabPane(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      loading = props.loading;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(loading, 'loading'), 'tab', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TabPane, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TabPane, props);
  var calculatedDefaultProps = {};

  if (ElementType === __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */]) {
    calculatedDefaultProps.attached = 'bottom';
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, calculatedDefaultProps, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

TabPane.handledProps = ["active", "as", "children", "className", "content", "loading"];
TabPane.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */],
  active: true
};
TabPane.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A tab pane can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A Tab.Pane can display a loading indicator. */
  loading: PropTypes.bool
} : {};
TabPane.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(TabPane, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TransitionGroup__ = __webpack_require__(1355);

















var TRANSITION_TYPE = {
  ENTERING: 'show',
  EXITING: 'hide'
  /**
   * A transition is an animation usually used to move content in or out of view.
   */

};

var Transition =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Transition, _Component);

  function Transition() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Transition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Transition)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleStart", function () {
      var duration = _this.props.duration;
      var status = _this.nextStatus;
      _this.nextStatus = null;

      _this.setState({
        status: status,
        animating: true
      }, function () {
        var durationType = TRANSITION_TYPE[status];
        var durationValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* normalizeTransitionDuration */])(duration, durationType);

        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          status: status
        }));

        _this.timeoutId = setTimeout(_this.handleComplete, durationValue);
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleComplete", function () {
      var current = _this.state.status;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onComplete', null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        status: current
      }));

      if (_this.nextStatus) {
        _this.handleStart();

        return;
      }

      var status = _this.computeCompletedStatus();

      var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';

      _this.setState({
        status: status,
        animating: false
      }, function () {
        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, callback, null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          status: status
        }));
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStatus", function () {
      var animating = _this.state.animating;

      if (_this.nextStatus) {
        _this.nextStatus = _this.computeNextStatus();
        if (!animating) _this.handleStart();
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeClasses", function () {
      var _this$props = _this.props,
          animation = _this$props.animation,
          directional = _this$props.directional,
          children = _this$props.children;
      var _this$state = _this.state,
          animating = _this$state.animating,
          status = _this$state.status;

      var childClasses = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(children, 'props.className');

      var isDirectional = __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(directional) ? __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_15__lib__["r" /* SUI */].DIRECTIONAL_TRANSITIONS, animation) : directional;

      if (isDirectional) {
        return __WEBPACK_IMPORTED_MODULE_12_classnames___default()(animation, childClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(animating, 'animating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(status === Transition.ENTERING, 'in'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(status === Transition.EXITING, 'out'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(status === Transition.EXITED, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(status !== Transition.EXITED, 'visible'), 'transition');
      }

      return __WEBPACK_IMPORTED_MODULE_12_classnames___default()(animation, childClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(animating, 'animating transition'));
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeCompletedStatus", function () {
      var unmountOnHide = _this.props.unmountOnHide;
      var status = _this.state.status;
      if (status === Transition.ENTERING) return Transition.ENTERED;
      return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeInitialStatuses", function () {
      var _this$props2 = _this.props,
          visible = _this$props2.visible,
          mountOnShow = _this$props2.mountOnShow,
          transitionOnMount = _this$props2.transitionOnMount,
          unmountOnHide = _this$props2.unmountOnHide;

      if (visible) {
        if (transitionOnMount) {
          return {
            initial: Transition.EXITED,
            next: Transition.ENTERING
          };
        }

        return {
          initial: Transition.ENTERED
        };
      }

      if (mountOnShow || unmountOnHide) return {
        initial: Transition.UNMOUNTED
      };
      return {
        initial: Transition.EXITED
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeNextStatus", function () {
      var _this$state2 = _this.state,
          animating = _this$state2.animating,
          status = _this$state2.status;
      if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
      return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeStatuses", function (props) {
      var status = _this.state.status;
      var visible = props.visible;

      if (visible) {
        return {
          current: status === Transition.UNMOUNTED && Transition.EXITED,
          next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
        };
      }

      return {
        next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeStyle", function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          duration = _this$props3.duration;
      var status = _this.state.status;

      var childStyle = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(children, 'props.style');

      var type = TRANSITION_TYPE[status];
      var animationDuration = type && "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* normalizeTransitionDuration */])(duration, type), "ms");
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, childStyle, {
        animationDuration: animationDuration
      });
    });

    var _this$computeInitialS = _this.computeInitialStatuses(),
        _status = _this$computeInitialS.initial,
        next = _this$computeInitialS.next;

    _this.nextStatus = next;
    _this.state = {
      status: _status
    };
    return _this;
  } // ----------------------------------------
  // Lifecycle
  // ----------------------------------------


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Transition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateStatus();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$computeStatuses = this.computeStatuses(nextProps),
          status = _this$computeStatuses.current,
          next = _this$computeStatuses.next;

      this.nextStatus = next;
      if (status) this.setState({
        status: status
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateStatus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var children = this.props.children;
      var status = this.state.status;
      if (status === Transition.UNMOUNTED) return null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react__["cloneElement"])(children, {
        className: this.computeClasses(),
        style: this.computeStyle()
      });
    }
  }]);

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "defaultProps", {
  animation: 'fade',
  duration: 500,
  visible: true,
  mountOnShow: true,
  transitionOnMount: false,
  unmountOnHide: false
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "ENTERED", 'ENTERED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "ENTERING", 'ENTERING');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "EXITED", 'EXITED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "EXITING", 'EXITING');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "UNMOUNTED", 'UNMOUNTED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "Group", __WEBPACK_IMPORTED_MODULE_16__TransitionGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "handledProps", ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"]);


Transition.propTypes =  false ? {
  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.element.isRequired,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number,
    show: PropTypes.number
  }), PropTypes.string]),

  /** Show the component; triggers the enter or exit animation. */
  visible: PropTypes.bool,

  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
  mountOnShow: PropTypes.bool,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onComplete: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onHide: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onShow: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onStart: PropTypes.func,

  /** React's key of the element. */
  reactKey: PropTypes.string,

  /** Run the enter animation when the component mounts, if it is initially shown. */
  transitionOnMount: PropTypes.bool,

  /** Unmount the component (remove it from the DOM) when it is not shown. */
  unmountOnHide: PropTypes.bool
} : {};

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_values__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Transition__ = __webpack_require__(1354);


















/**
 * A Transition.Group animates children as they mount and unmount.
 */
var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(TransitionGroup, _React$Component);

  function TransitionGroup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, TransitionGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(TransitionGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOnHide", function (nothing, childProps) {
      var reactKey = childProps.reactKey;

      _this.setState(function (state) {
        var children = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, state.children);

        delete children[reactKey];
        return {
          children: children
        };
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "wrapChild", function (child) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          animation = _this$props.animation,
          directional = _this$props.directional,
          duration = _this$props.duration;
      var key = child.key;
      var _options$visible = options.visible,
          visible = _options$visible === void 0 ? true : _options$visible,
          _options$transitionOn = options.transitionOnMount,
          transitionOnMount = _options$transitionOn === void 0 ? false : _options$transitionOn;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Transition__["a" /* default */], {
        animation: animation,
        directional: directional,
        duration: duration,
        key: key,
        onHide: _this.handleOnHide,
        reactKey: key,
        transitionOnMount: transitionOnMount,
        visible: visible
      }, child);
    });

    var _children = _this.props.children;
    _this.state = {
      children: __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["o" /* getChildMapping */])(_children), function (child) {
        return _this.wrapChild(child);
      })
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(TransitionGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var prevMapping = this.state.children;
      var nextMapping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["o" /* getChildMapping */])(nextProps.children);
      var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* mergeChildMappings */])(prevMapping, nextMapping);

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(children, function (child, key) {
        var hasPrev = __WEBPACK_IMPORTED_MODULE_10_lodash_has___default()(prevMapping, key);

        var hasNext = __WEBPACK_IMPORTED_MODULE_10_lodash_has___default()(nextMapping, key);

        var prevChild = prevMapping[key];
        var isLeaving = !__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(prevChild, 'props.visible'); // Heads up!
        // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped

        if (hasNext && (!hasPrev || isLeaving)) {
          children[key] = _this2.wrapChild(child, {
            transitionOnMount: true
          });
          return;
        } // Heads up!
        // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
        // wrapped, so should be only updated


        if (!hasNext && hasPrev && !isLeaving) {
          children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react__["cloneElement"])(prevChild, {
            visible: false
          });
          return;
        } // Heads up!
        // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
        // so we should wrap it again


        var _prevChild$props = prevChild.props,
            visible = _prevChild$props.visible,
            transitionOnMount = _prevChild$props.transitionOnMount;
        children[key] = _this2.wrapChild(child, {
          transitionOnMount: transitionOnMount,
          visible: visible
        });
      });

      this.setState({
        children: children
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.state.children;
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* getElementType */])(TransitionGroup, this.props);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* getUnhandledProps */])(TransitionGroup, this.props);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, rest, __WEBPACK_IMPORTED_MODULE_8_lodash_values___default()(children));
    }
  }]);

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(TransitionGroup, "defaultProps", {
  as: __WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],
  animation: 'fade',
  duration: 500
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(TransitionGroup, "handledProps", ["animation", "as", "children", "directional", "duration"]);


TransitionGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.node,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number.isRequired,
    show: PropTypes.number.isRequired
  }), PropTypes.string])
} : {};

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transition__ = __webpack_require__(1354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Transition__["a"]; });



/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_Image__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardContent__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardDescription__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CardGroup__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CardHeader__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CardMeta__ = __webpack_require__(777);


















/**
 * A card displays site content in a manner similar to a playing card.
 */

var Card =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Card, _Component);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centered = _this$props.centered,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          description = _this$props.description,
          extra = _this$props.extra,
          fluid = _this$props.fluid,
          header = _this$props.header,
          href = _this$props.href,
          image = _this$props.image,
          link = _this$props.link,
          meta = _this$props.meta,
          onClick = _this$props.onClick,
          raised = _this$props.raised;
      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(raised, 'raised'), 'card', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["b" /* getUnhandledProps */])(Card, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* getElementType */])(Card, this.props, function () {
        if (onClick) return 'a';
      });

      if (!__WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_12__elements_Image__["a" /* default */].create(image, {
        autoGenerateKey: false,
        defaultProps: {
          ui: false,
          wrapped: true
        }
      }), (description || header || meta) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */], {
        description: description,
        header: header,
        meta: meta
      }), extra && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */], {
        extra: true
      }, extra));
    }
  }]);

  return Card;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Content", __WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Description", __WEBPACK_IMPORTED_MODULE_14__CardDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Group", __WEBPACK_IMPORTED_MODULE_15__CardGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Header", __WEBPACK_IMPORTED_MODULE_16__CardHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Meta", __WEBPACK_IMPORTED_MODULE_17__CardMeta__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "handledProps", ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"]);


Card.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A Card can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A Card can be formatted to display different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for primary content of CardContent. */
  extra: customPropTypes.contentShorthand,

  /** A Card can be formatted to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** A card can contain an Image component. */
  image: customPropTypes.itemShorthand,

  /** A card can be formatted to link to other content. */
  link: PropTypes.bool,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /**
   * Called on click. When passed, the component renders as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A Card can be formatted to raise above the page. */
  raised: PropTypes.bool
} : {};

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDescription__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardHeader__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardMeta__ = __webpack_require__(777);









/**
 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
 */

function CardContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(extra, 'extra'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__CardHeader__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, header, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__CardMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__CardDescription__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, description, {
    autoGenerateKey: false
  }));
}

CardContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"];
CardContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** A card can contain extra content meant to be formatted separately from the main content. */
  extra: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardContent);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card__ = __webpack_require__(1357);








/**
 * A group of cards.
 */

function CardGroup(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      doubling = props.doubling,
      items = props.items,
      itemsPerRow = props.itemsPerRow,
      stackable = props.stackable,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(doubling, 'doubling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(itemsPerRow), 'cards', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(CardGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(CardGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var key = item.key || [item.header, item.description].join('-');
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Card__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      key: key
    }, item));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), itemsJSX);
}

CardGroup.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"];
CardGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A group of cards can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of cards can double its column width for mobile. */
  doubling: PropTypes.bool,

  /** Shorthand array of props for Card. */
  items: customPropTypes.collectionShorthand,

  /** A group of cards can set how many cards should exist in a row. */
  itemsPerRow: PropTypes.oneOf(SUI.WIDTHS),

  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
  stackable: PropTypes.bool,

  /** A card group can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardGroup);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain an action.
 */

function CommentAction(props) {
  var active = props.active,
      className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentAction, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentAction, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAction.handledProps = ["active", "as", "children", "className", "content"];
CommentAction.defaultProps = {
  as: 'a'
};
CommentAction.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently active action. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAction);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain an list of actions a user may perform related to this comment.
 */

function CommentActions(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('actions', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentActions, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentActions, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentActions.handledProps = ["as", "children", "className", "content"];
CommentActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentActions);

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain an author.
 */

function CommentAuthor(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('author', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentAuthor, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentAuthor, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAuthor.handledProps = ["as", "children", "className", "content"];
CommentAuthor.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAuthor);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A comment can contain an image or avatar.
 */

function CommentAvatar(props) {
  var className = props.className,
      src = props.src;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('avatar', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CommentAvatar, props);

  var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_5__lib__["m" /* htmlImageProps */]
  }),
      _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
      imageProps = _partitionHTMLProps2[0],
      rootProps = _partitionHTMLProps2[1];

  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CommentAvatar, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createHTMLImage */])(src, {
    autoGenerateKey: false,
    defaultProps: imageProps
  }));
}

CommentAvatar.handledProps = ["as", "className", "src"];
CommentAvatar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies the URL of the image. */
  src: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAvatar);

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain content.
 */

function CommentContent(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'content');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentContent.handledProps = ["as", "children", "className", "content"];
CommentContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentContent);

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * Comments can be grouped.
 */

function CommentGroup(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content,
      minimal = props.minimal,
      size = props.size,
      threaded = props.threaded;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(collapsed, 'collapsed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(minimal, 'minimal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(threaded, 'threaded'), 'comments', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CommentGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CommentGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentGroup.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"];
CommentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comments can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
  minimal: PropTypes.bool,

  /** Comments can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A comment list can be threaded to showing the relationship between conversations. */
  threaded: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentGroup);

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
 */

function CommentMetadata(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('metadata', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentMetadata, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentMetadata, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentMetadata.handledProps = ["as", "children", "className", "content"];
CommentMetadata.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentMetadata);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A comment can contain text.
 */

function CommentText(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'text');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentText, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentText, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentText.handledProps = ["as", "children", "className", "content"];
CommentText.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentText);

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedContent__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedLabel__ = __webpack_require__(780);







/**
 * A feed contains an event.
 */

function FeedEvent(props) {
  var content = props.content,
      children = props.children,
      className = props.className,
      date = props.date,
      extraImages = props.extraImages,
      extraText = props.extraText,
      image = props.image,
      icon = props.icon,
      meta = props.meta,
      summary = props.summary;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('event', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedEvent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedEvent, props);
  var hasContentProp = content || date || extraImages || extraText || meta || summary;
  var contentProps = {
    content: content,
    date: date,
    extraImages: extraImages,
    extraText: extraText,
    meta: meta,
    summary: summary
  };
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      icon: val
    };
  }, icon, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      image: val
    };
  }, image, {
    autoGenerateKey: false
  }), hasContentProp && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FeedContent__["a" /* default */], contentProps), children);
}

FeedEvent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"];
FeedEvent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for FeedContent. */
  content: customPropTypes.itemShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with content. */
  extraText: customPropTypes.itemShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedEvent);

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemContent__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemGroup__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ItemHeader__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemImage__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemMeta__ = __webpack_require__(788);












/**
 * An item view presents large collections of site content for display.
 */

function Item(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      image = props.image,
      meta = props.meta;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('item', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Item, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Item, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */].create(image, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */], {
    content: content,
    description: description,
    extra: extra,
    header: header,
    meta: meta
  }));
}

Item.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"];
Item.Content = __WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */];
Item.Description = __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */];
Item.Extra = __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */];
Item.Group = __WEBPACK_IMPORTED_MODULE_8__ItemGroup__["a" /* default */];
Item.Header = __WEBPACK_IMPORTED_MODULE_9__ItemHeader__["a" /* default */];
Item.Image = __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */];
Item.Meta = __WEBPACK_IMPORTED_MODULE_11__ItemMeta__["a" /* default */];
Item.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for ItemContent component. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemImage component. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemHeader__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemMeta__ = __webpack_require__(788);









/**
 * An item can contain content.
 */

function ItemContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__ItemHeader__["a" /* default */].create(header, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_8__ItemMeta__["a" /* default */].create(meta, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */].create(extra, {
    autoGenerateKey: false
  }), content);
}

ItemContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"];
ItemContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand,

  /** Content can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemContent);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1369);








/**
 * A group of items.
 */

function ItemGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      divided = props.divided,
      items = props.items,
      link = props.link,
      relaxed = props.relaxed,
      unstackable = props.unstackable;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), 'items', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(ItemGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(ItemGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var childKey = item.childKey,
        itemProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(item, ["childKey"]);

    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, itemProps, {
      key: finalKey
    }));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), itemsJSX);
}

ItemGroup.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"];
ItemGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Items can be divided to better distinguish between grouped content. */
  divided: PropTypes.bool,

  /** Shorthand array of props for Item. */
  items: customPropTypes.collectionShorthand,

  /** An item can be formatted so that the entire contents link to another page. */
  link: PropTypes.bool,

  /** A group of items can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Prevent items from stacking on mobile. */
  unstackable: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemGroup);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Image__ = __webpack_require__(297);




/**
 * An item can contain an image.
 */

function ItemImage(props) {
  var size = props.size;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(ItemImage, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    size: size,
    ui: !!size,
    wrapped: true
  }));
}

ItemImage.handledProps = ["size"];
ItemImage.propTypes =  false ? {
  /** An image may appear at different sizes. */
  size: Image.propTypes.size
} : {};
ItemImage.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* createShorthandFactory */])(ItemImage, function (src) {
  return {
    src: src
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemImage);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatisticValue__ = __webpack_require__(1376);









/**
 * A statistic emphasizes the current value of an attribute.
 */

function Statistic(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      floated = props.floated,
      horizontal = props.horizontal,
      inverted = props.inverted,
      label = props.label,
      size = props.size,
      text = props.text,
      value = props.value;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'statistic', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Statistic, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Statistic, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */].create(value, {
    defaultProps: {
      text: text
    },
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */].create(label, {
    autoGenerateKey: false
  }));
}

Statistic.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"];
Statistic.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A statistic can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Label content of the Statistic. */
  label: customPropTypes.contentShorthand,

  /** A statistic can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool,

  /** Value content of the Statistic. */
  value: customPropTypes.contentShorthand
} : {};
Statistic.Group = __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__["a" /* default */];
Statistic.Label = __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */];
Statistic.Value = __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */];
Statistic.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(Statistic, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Statistic);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Statistic__ = __webpack_require__(1373);








/**
 * A group of statistics.
 */

function StatisticGroup(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      horizontal = props.horizontal,
      inverted = props.inverted,
      items = props.items,
      size = props.size,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(widths), 'statistics', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(StatisticGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(StatisticGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_7__Statistic__["a" /* default */].create(item);
  }));
}

StatisticGroup.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"];
StatisticGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic group can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic group can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic group can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Array of props for Statistic. */
  items: customPropTypes.collectionShorthand,

  /** A statistic group can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** A statistic group can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StatisticGroup);

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A statistic can contain a label to help provide context for the presented value.
 */

function StatisticLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StatisticLabel, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StatisticLabel, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticLabel.handledProps = ["as", "children", "className", "content"];
StatisticLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StatisticLabel.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StatisticLabel, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticLabel);

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A statistic can contain a numeric, icon, image, or text value.
 */

function StatisticValue(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(text, 'text'), 'value', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StatisticValue, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StatisticValue, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticValue.handledProps = ["as", "children", "className", "content", "text"];
StatisticValue.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Format the value with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool
} : {};
StatisticValue.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StatisticValue, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticValue);

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257),
    root = __webpack_require__(99);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(99);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257),
    root = __webpack_require__(99);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1397),
    isArguments = __webpack_require__(375),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(302),
    isIndex = __webpack_require__(373),
    isTypedArray = __webpack_require__(378);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(368),
    eq = __webpack_require__(374);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(372),
    keys = __webpack_require__(118);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    arrayEach = __webpack_require__(367),
    assignValue = __webpack_require__(795),
    baseAssign = __webpack_require__(1385),
    baseAssignIn = __webpack_require__(2593),
    cloneBuffer = __webpack_require__(1400),
    copyArray = __webpack_require__(298),
    copySymbols = __webpack_require__(2637),
    copySymbolsIn = __webpack_require__(2638),
    getAllKeys = __webpack_require__(1409),
    getAllKeysIn = __webpack_require__(1410),
    getTag = __webpack_require__(206),
    initCloneArray = __webpack_require__(2669),
    initCloneByTag = __webpack_require__(2670),
    initCloneObject = __webpack_require__(1414),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(302),
    isMap = __webpack_require__(2747),
    isObject = __webpack_require__(105),
    isSet = __webpack_require__(2750),
    keys = __webpack_require__(118);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(493),
    arrayIncludes = __webpack_require__(496),
    arrayIncludesWith = __webpack_require__(793),
    arrayMap = __webpack_require__(180),
    baseUnary = __webpack_require__(256),
    cacheHas = __webpack_require__(504);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2644);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(794),
    isArray = __webpack_require__(51);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(255),
    isArrayLike = __webpack_require__(142);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(499),
    baseSet = __webpack_require__(1395),
    castPath = __webpack_require__(371);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
    var index = -1,
        length = paths.length,
        result = {};

    while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
        }
    }
    return result;
}

module.exports = basePickBy;

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(795),
    castPath = __webpack_require__(371),
    isIndex = __webpack_require__(373),
    isObject = __webpack_require__(105),
    toKey = __webpack_require__(258);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(155),
    metaMap = __webpack_require__(1419);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function (func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(493),
    arrayIncludes = __webpack_require__(496),
    arrayIncludesWith = __webpack_require__(793),
    cacheHas = __webpack_require__(504),
    createSet = __webpack_require__(2655),
    setToArray = __webpack_require__(514);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(155);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(99);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(799);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1402),
    composeArgsRight = __webpack_require__(1403),
    countHolders = __webpack_require__(2640),
    createCtor = __webpack_require__(505),
    createRecurry = __webpack_require__(1405),
    getHolder = __webpack_require__(802),
    reorder = __webpack_require__(2693),
    replaceHolders = __webpack_require__(513),
    root = __webpack_require__(99);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1415),
    setData = __webpack_require__(1423),
    setWrapToString = __webpack_require__(1424);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(493),
    arraySome = __webpack_require__(1383),
    cacheHas = __webpack_require__(504);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1391),
    getSymbols = __webpack_require__(803),
    keys = __webpack_require__(118);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1391),
    getSymbolsIn = __webpack_require__(1412),
    keysIn = __webpack_require__(521);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(2692);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = func.name + '',
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(794),
    getPrototype = __webpack_require__(508),
    getSymbols = __webpack_require__(803),
    stubArray = __webpack_require__(1440);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(371),
    isArguments = __webpack_require__(375),
    isArray = __webpack_require__(51),
    isIndex = __webpack_require__(373),
    isLength = __webpack_require__(806),
    toKey = __webpack_require__(258);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

module.exports = hasPath;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(369),
    getPrototype = __webpack_require__(508),
    isPrototype = __webpack_require__(510);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

module.exports = initCloneObject;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(789),
    getData = __webpack_require__(801),
    getFuncName = __webpack_require__(1411),
    lodash = __webpack_require__(2782);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(1379);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap();

module.exports = metaMap;

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(495);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1396),
    shortOut = __webpack_require__(1425);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(2662),
    insertWrapDetails = __webpack_require__(2671),
    setToString = __webpack_require__(805),
    updateWrapDetails = __webpack_require__(2706);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = reference + '';
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2686);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(2656),
    toString = __webpack_require__(156);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(300);

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(2649),
    findIndex = __webpack_require__(1433);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1389),
    baseIteratee = __webpack_require__(117),
    toInteger = __webpack_require__(181);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('flow', __webpack_require__(2718));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('map', __webpack_require__(66));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2598),
    hasPath = __webpack_require__(1413);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__(2599),
    toFinite = __webpack_require__(808),
    toNumber = __webpack_require__(525);

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(796);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.trimCanvas = t() : e.trimCanvas = t();
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;var o = r[n] = { exports: {}, id: n, loaded: !1 };return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }var r = {};return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t) {
    "use strict";
    function r(e) {
      var t = e.getContext("2d"),
          r = e.width,
          n = e.height,
          o = t.getImageData(0, 0, r, n).data,
          f = a(!0, r, n, o),
          i = a(!1, r, n, o),
          c = u(!0, r, n, o),
          d = u(!1, r, n, o),
          p = d - c + 1,
          l = i - f + 1,
          s = t.getImageData(c, f, p, l);return e.width = p, e.height = l, t.clearRect(0, 0, p, l), t.putImageData(s, 0, 0), e;
    }function n(e, t, r, n) {
      return { red: n[4 * (r * t + e)], green: n[4 * (r * t + e) + 1], blue: n[4 * (r * t + e) + 2], alpha: n[4 * (r * t + e) + 3] };
    }function o(e, t, r, o) {
      return n(e, t, r, o).alpha;
    }function a(e, t, r, n) {
      for (var a = e ? 1 : -1, u = e ? 0 : r - 1, f = u; e ? f < r : f > -1; f += a) {
        for (var i = 0; i < t; i++) {
          if (o(i, f, t, n)) return f;
        }
      }return null;
    }function u(e, t, r, n) {
      for (var a = e ? 1 : -1, u = e ? 0 : t - 1, f = u; e ? f < t : f > -1; f += a) {
        for (var i = 0; i < r; i++) {
          if (o(f, i, t, n)) return f;
        }
      }return null;
    }Object.defineProperty(t, "__esModule", { value: !0 }), t.default = r;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils_payments__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss__ = __webpack_require__(3605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_formsy_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6, _graphql7, _graphql8;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-underscore-dangle */














var AcceptedPaymentMethods = function (_React$Component) {
  _inherits(AcceptedPaymentMethods, _React$Component);

  function AcceptedPaymentMethods(props) {
    _classCallCheck(this, AcceptedPaymentMethods);

    var _this = _possibleConstructorReturn(this, (AcceptedPaymentMethods.__proto__ || Object.getPrototypeOf(AcceptedPaymentMethods)).call(this, props));

    _this.state = {
      editModalOpen: false,
      newModalOpen: false,
      squareModalOpen: false,
      submitted: false,
      isNew: false,
      newMethod: {
        enabled: false,
        instructions: '',
        label: ''
      }
    };
    _this.onUpdateValidSubmit = _this.onUpdateValidSubmit.bind(_this);
    _this.onUpdateInvalidSubmit = _this.onUpdateInvalidSubmit.bind(_this);
    _this.onCreateValidSubmit = _this.onCreateValidSubmit.bind(_this);
    _this.onCreateInvalidSubmit = _this.onCreateInvalidSubmit.bind(_this);
    _this.onCheckboxChange = _this.onCheckboxChange.bind(_this);
    _this.getPaymentMethod = _this.getPaymentMethod.bind(_this);
    _this.openEditPaymentMethod = _this.openEditPaymentMethod.bind(_this);
    _this.closeEditPaymentMethod = _this.closeEditPaymentMethod.bind(_this);
    _this.openNewPaymentMethod = _this.openNewPaymentMethod.bind(_this);
    _this.closeNewPaymentMethod = _this.closeNewPaymentMethod.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.textEditorChange = _this.textEditorChange.bind(_this);
    _this.newMethodTextFieldChange = _this.newMethodTextFieldChange.bind(_this);
    _this.newMethodTextEditorChange = _this.newMethodTextEditorChange.bind(_this);
    _this.createPaymentMethod = _this.createPaymentMethod.bind(_this);
    _this.updatePaymentMethod = _this.updatePaymentMethod.bind(_this);
    _this.onCreateNewValidSubmit = _this.onCreateNewValidSubmit.bind(_this);
    _this.onCreateNewInvalidSubmit = _this.onCreateNewInvalidSubmit.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.deleteCustomPaymentMethod = _this.deleteCustomPaymentMethod.bind(_this);
    return _this;
  }

  _createClass(AcceptedPaymentMethods, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onCreateValidSubmit',
    value: function onCreateValidSubmit() {
      this.setState({ submitted: true });
      this.createPaymentMethod(this.closeEditPaymentMethod);
    }
  }, {
    key: 'onCreateInvalidSubmit',
    value: function onCreateInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update payment method',
        intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onCreateNewValidSubmit',
    value: function onCreateNewValidSubmit() {
      this.setState({ submitted: true });
      this.createCustomPaymentMethod(this.closeNewPaymentMethod);
    }
  }, {
    key: 'onCreateNewInvalidSubmit',
    value: function onCreateNewInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add payment method',
        intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onUpdateValidSubmit',
    value: function onUpdateValidSubmit() {
      this.setState({ submitted: true });
      this.updatePaymentMethod(this.closeEditPaymentMethod);
    }
  }, {
    key: 'onUpdateInvalidSubmit',
    value: function onUpdateInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update payment method',
        intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onCheckboxChange',
    value: function onCheckboxChange(e, data) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.method[data.name] = data.checked;
      this.setState(state);
    }
  }, {
    key: 'getPaymentMethod',
    value: function getPaymentMethod(typename) {
      var methods = this.props.viewer.payment_methods.edges.filter(function (method) {
        return method.node.__typename === typename;
      });
      return methods && methods.length > 0 ? methods[0].node : null;
    }
  }, {
    key: 'openEditPaymentMethod',
    value: function openEditPaymentMethod(method, isNew) {
      this.setState({ editModalOpen: true, method: method, isNew: isNew, submitted: false });
    }
  }, {
    key: 'closeEditPaymentMethod',
    value: function closeEditPaymentMethod() {
      this.setState({ editModalOpen: false });
    }
  }, {
    key: 'openNewPaymentMethod',
    value: function openNewPaymentMethod() {
      this.setState({
        newModalOpen: true,
        newMethod: {
          enabled: false,
          instructions: '',
          label: ''
        },
        submitted: false
      });
    }
  }, {
    key: 'closeNewPaymentMethod',
    value: function closeNewPaymentMethod() {
      this.setState({ newModalOpen: false });
    }
  }, {
    key: 'createCustomPaymentMethod',
    value: function createCustomPaymentMethod(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('created-custom-method');
      };
      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2801);
      });

      var customPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newMethod), ['instructions', 'enabled', 'label']);
      if (this.props.node) {
        customPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      var updater = function updater(store) {
        var payload = store.getRootField('createCustomPaymentMethod');
        var node = payload.getLinkedRecord('custom_payment_method');
        var viewerProxy = store.get(_this2.props.viewer.id);
        var paymentMethods = viewerProxy.getLinkedRecord('payment_methods');
        var newEdge = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].createEdge(store, paymentMethods, node, 'PaymentMethodEdge');
        var conn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'SettingsContainer_payment_methods');
        var invoiceConn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'InvoiceContainer_payment_methods');
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(conn, newEdge);
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(invoiceConn, newEdge);
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        updater: updater,
        variables: {
          input: _extends({}, customPaymentMethod, {
            enabled: true,
            user_id: this.props.viewer.id
          })
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPaymentMethod',
    value: function createPaymentMethod(successCb, failureCb) {
      switch (this.state.method.__typename) {
        case 'CashPaymentMethod':
          this.createCashPaymentMethod(successCb, failureCb);
          break;
        case 'CheckPaymentMethod':
          this.createCheckPaymentMethod(successCb, failureCb);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'createCashPaymentMethod',
    value: function createCashPaymentMethod(successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('created-cash-payment-method');
      };
      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2799);
      });

      var cashPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['instructions', 'enabled']);
      if (this.props.node) {
        cashPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      var updater = function updater(store) {
        var payload = store.getRootField('createCashPaymentMethod');
        var node = payload.getLinkedRecord('cash_payment_method');
        var viewerProxy = store.get(_this3.props.viewer.id);
        var paymentMethods = viewerProxy.getLinkedRecord('payment_methods');
        var newEdge = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].createEdge(store, paymentMethods, node, 'PaymentMethodEdge');
        var conn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'SettingsContainer_payment_methods');
        var invoiceConn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'InvoiceContainer_payment_methods');
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(conn, newEdge);
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(invoiceConn, newEdge);
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, cashPaymentMethod, {
            user_id: this.props.viewer.id
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createCheckPaymentMethod',
    value: function createCheckPaymentMethod(successCb, failureCb) {
      var _this4 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('created-check-payment-method');
      };
      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2800);
      });

      var checkPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['enabled', 'address', 'pay_to']);
      if (this.props.node) {
        checkPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      var updater = function updater(store) {
        var payload = store.getRootField('createCheckPaymentMethod');
        var node = payload.getLinkedRecord('check_payment_method');
        var viewerProxy = store.get(_this4.props.viewer.id);
        var paymentMethods = viewerProxy.getLinkedRecord('payment_methods');
        var newEdge = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].createEdge(store, paymentMethods, node, 'PaymentMethodEdge');
        var conn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'SettingsContainer_payment_methods');
        var invoiceConn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'InvoiceContainer_payment_methods');
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(conn, newEdge);
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].insertEdgeAfter(invoiceConn, newEdge);
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, checkPaymentMethod, {
            user_id: this.props.viewer.id
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updatePaymentMethod',
    value: function updatePaymentMethod(successCb, failureCb) {
      switch (this.state.method.__typename) {
        case 'CashPaymentMethod':
          this.updateCashPaymentMethod(successCb, failureCb);
          break;
        case 'CheckPaymentMethod':
          this.updateCheckPaymentMethod(successCb, failureCb);
          break;
        case 'SquarePaymentMethod':
          this.updateSquarePaymentMethod(successCb, failureCb);
          break;
        case 'CustomPaymentMethod':
          this.updateCustomPaymentMethod(successCb, failureCb);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'updateCashPaymentMethod',
    value: function updateCashPaymentMethod(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-cash-payment-method');
      };
      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(2802);
      });

      var cashPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['id', 'instructions', 'enabled']);

      if (this.props.node) {
        cashPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, cashPaymentMethod)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateCustomPaymentMethod',
    value: function updateCustomPaymentMethod(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-custom-method');
      };
      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(2804);
      });

      var customPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['id', 'instructions', 'label', 'enabled']);

      if (this.props.node) {
        customPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, customPaymentMethod)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateCheckPaymentMethod',
    value: function updateCheckPaymentMethod(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-check-payment-method');
      };
      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(2803);
      });

      var checkPaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['id', 'address', 'pay_to', 'enabled']);
      if (this.props.node) {
        checkPaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, checkPaymentMethod)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateSquarePaymentMethod',
    value: function updateSquarePaymentMethod(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-square-payment-method');
      };
      var mutation = _graphql7 || (_graphql7 = function _graphql7() {
        return __webpack_require__(2805);
      });

      var squarePaymentMethod = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.method), ['id', 'enabled']);
      if (this.props.node) {
        squarePaymentMethod.invoice_id = this.props.node.id;
      }

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, squarePaymentMethod)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.method[e.target.name] = e.target.value;
      this.setState(state);
    }
  }, {
    key: 'textEditorChange',
    value: function textEditorChange(name, value) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.method[name] = value;
      this.setState(state);
    }
  }, {
    key: 'newMethodTextFieldChange',
    value: function newMethodTextFieldChange(e) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.newMethod[e.target.name] = e.target.value;
      this.setState(state);
    }
  }, {
    key: 'newMethodTextEditorChange',
    value: function newMethodTextEditorChange(name, value) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.newMethod[name] = value;
      this.setState(state);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'deleteCustomPaymentMethod',
    value: function deleteCustomPaymentMethod(id, successCb, failureCb) {
      var _this5 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted payment method',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('deleted-custom-payment-method');
      };

      var mutation = _graphql8 || (_graphql8 = function _graphql8() {
        return __webpack_require__(2806);
      });

      var environment = this.props.relay.environment;

      var updater = function updater(store) {
        var payload = store.getRootField('deleteCustomPaymentMethod');
        var deletedCustomPaymentMethodId = payload.getValue('deletedCustomPaymentMethodId');
        var viewerProxy = store.get(_this5.props.viewer.id);
        var conn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'SettingsContainer_payment_methods');
        var invoiceConn = __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'InvoiceContainer_payment_methods');
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].deleteNode(conn, deletedCustomPaymentMethodId);
        __WEBPACK_IMPORTED_MODULE_3_relay_runtime__["ConnectionHandler"].deleteNode(invoiceConn, deletedCustomPaymentMethodId);
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var tag = function tag(_ref) {
        var enabled = _ref.enabled;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          {
            className: [__WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss___default.a.paymentMethodIndicator, enabled ? __WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss___default.a.paymentMethodEnabled : __WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss___default.a.paymentMethodDisabled].join(' ')
          },
          enabled ? 'Enabled' : 'Disabled'
        );
      };

      tag.propTypes = {
        enabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
      };

      var squareConnectButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */],
        {
          primary: true,
          onClick: function onClick() {
            window.location = '/auth/square';
          }
        },
        'Continue'
      );

      var squareInstructions = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'We\'ll first need to connect to your Square account'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'You will be redirected to Square to log into or create a new Square account'
        )
      );

      var EditPaymentMethodFields = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.state.method && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h3',
              null,
              this.state.method && this.state.method.__typename !== 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_9__lib_utils_payments__["a" /* default */].methods(this.state.method),
              this.state.method && this.state.method.__typename === 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["e" /* FloatingLabelInput */], {
                label: 'Payment Method Name',
                type: 'text',
                name: 'label',
                placeholder: '(Eg. Paypal, Venmo, QuickPay)',
                value: this.state.method.label || '',
                onChange: this.textFieldChange,
                submitted: this.state.submitted,
                fluid: true,
                required: true,
                validationError: 'Name is required'
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_10__PaymentMethods_scss___default.a.paymentMethodToggle },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["i" /* Checkbox */], {
              checked: this.state.method.enabled,
              label: this.state.method.enabled ? 'Enabled' : 'Disabled',
              name: 'enabled',
              toggle: true,
              onChange: this.onCheckboxChange
            })
          )
        ),
        this.state.method && this.state.method.__typename === 'CashPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please provide instructions so your client knows where to send the cash'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["l" /* TextEditor */], {
            type: 'text',
            name: 'instructions',
            placeholder: "Just throw it out the window. We'll come pick it up.",
            value: this.state.method.instructions || '',
            onChange: function onChange(value) {
              return _this6.textEditorChange('instructions', value);
            },
            submitted: this.state.submitted,
            required: true,
            validationError: 'Instructions are required'
          })
        ),
        this.state.method && this.state.method.__typename === 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please provide instructions so your client knows how to pay'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["l" /* TextEditor */], {
            placeholder: '(E.g. Send all payments to Venmo username @cloverbook)',
            value: this.state.method.instructions || '',
            onChange: function onChange(value) {
              return _this6.textEditorChange('instructions', value);
            }
          })
        ),
        this.state.method && this.state.method.__typename === 'CheckPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please provide instructions so your client know how to write the check and where to send it'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["e" /* FloatingLabelInput */], {
            label: 'Pay To The Order Of',
            type: 'text',
            name: 'pay_to',
            placeholder: 'Your Company, Inc.',
            submitted: this.state.submitted,
            required: true,
            validationError: 'Name is required',
            value: this.state.method.pay_to || '',
            onChange: this.textFieldChange
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["e" /* FloatingLabelInput */], {
            label: 'Mailing Address',
            type: 'text',
            name: 'address',
            placeholder: '1540 Market Street\nSan Francisco, CA 94102',
            autoHeight: true,
            rows: 2,
            submitted: this.state.submitted,
            value: this.state.method.address || '',
            required: true,
            validationError: 'Mailing address is required',
            onChange: this.textFieldChange
          })
        )
      );

      var NewPaymentMethodFields = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_formsy_react___default.a.Form,
        {
          ref: 'newForm',
          onValidSubmit: this.onCreateNewValidSubmit,
          onInvalidSubmit: this.onCreateNewInvalidSubmit
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'New Payment Method'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["e" /* FloatingLabelInput */], {
            label: 'Payment Method Name',
            type: 'text',
            name: 'label',
            placeholder: '(Eg. Paypal, Venmo, QuickPay)',
            autoHeight: true,
            value: this.state.newMethod.label || '',
            onChange: this.newMethodTextFieldChange,
            submitted: this.state.submitted,
            required: true,
            validationError: 'Payment method name is required'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please provide instructions so your client knows how to pay you'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["l" /* TextEditor */], {
            placeholder: '(E.g. Send all payments to Venmo username @cloverbook)',
            value: this.state.newMethod.instructions || '',
            onChange: function onChange(value) {
              return _this6.newMethodTextEditorChange('instructions', value);
            }
          })
        )
      );

      var deleteButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */],
        { negative: true, fluid: true },
        'Delete Payment Method'
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.state.window.width < __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */],
            {
              open: this.state.squareModalOpen,
              onClose: function onClose() {
                return _this6.setState({ squareModalOpen: false });
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    className: 'menu item',
                    onClick: function onClick() {
                      return _this6.setState({ squareModalOpen: false });
                    }
                  },
                  'Cancel'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Content,
              null,
              squareInstructions,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              squareConnectButton
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */],
            {
              open: this.state.newModalOpen,
              onClose: this.closeNewPaymentMethod
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: this.closeNewPaymentMethod },
                  'Cancel'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'right menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    onClick: function onClick() {
                      return _this6.refs.newForm.submit();
                    }
                  },
                  'Save'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Content,
              null,
              NewPaymentMethodFields
            )
          )
        ),
        this.state.window.width >= __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.squareModalOpen,
              size: 'small',
              onClose: function onClose() {
                return _this6.setState({ squareModalOpen: false });
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Header, { content: 'Connect to Square' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Content,
              null,
              squareInstructions
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */],
                {
                  basic: true,
                  onClick: function onClick() {
                    return _this6.setState({ squareModalOpen: false });
                  }
                },
                'Cancel'
              ),
              squareConnectButton
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.newModalOpen,
              onClose: this.closeNewPaymentMethod,
              size: 'small'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Header, { content: 'Add New Payment Method' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Content,
              null,
              NewPaymentMethodFields
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["j" /* DthcActions */], {
                reset: this.closeNewPaymentMethod,
                save: function save() {
                  return _this6.refs.newForm.submit();
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_formsy_react___default.a.Form,
          {
            ref: 'form',
            key: this.state.method && this.state.method.id,
            onValidSubmit: this.state.isNew ? this.onCreateValidSubmit : this.onUpdateValidSubmit,
            onInvalidSubmit: this.state.isNew ? this.onCreateInvalidSubmit : this.onUpdateInvalidSubmit
          },
          this.state.window.width < __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */],
            {
              open: this.state.editModalOpen,
              onClose: this.closeEditPaymentMethod
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: this.closeEditPaymentMethod },
                  'Cancel'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'right menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: function onClick() {
                      return _this6.refs.form.submit();
                    } },
                  'Save'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Content,
              null,
              EditPaymentMethodFields,
              this.state.method && this.state.method.__typename === 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["i" /* DeleteConfirmation */], {
                trigger: deleteButton,
                'delete': function _delete() {
                  return _this6.deleteCustomPaymentMethod(_this6.state.method.id, _this6.closeEditPaymentMethod);
                },
                id: this.state.method.id
              })
            )
          ),
          this.state.window.width >= __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.editModalOpen,
              onClose: this.closeEditPaymentMethod,
              size: 'small'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Header, { content: 'Edit Payment Method' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Content,
              null,
              EditPaymentMethodFields
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["j" /* DthcActions */], {
                'delete': this.state.method && this.state.method.__typename === 'CustomPaymentMethod' ? function () {
                  return _this6.deleteCustomPaymentMethod(_this6.state.method.id, _this6.closeEditPaymentMethod);
                } : null,
                reset: this.closeEditPaymentMethod,
                save: function save() {
                  return _this6.refs.form.submit();
                }
              })
            )
          )
        ),
        this.props.viewer.payment_methods.edges.map(function (method) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
            {
              key: method.node.id,
              checked: method.enabled,
              style: { marginBottom: '2em' },
              onChange: _this6.openEditPaymentMethod.bind(null, method.node, false)
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              null,
              __WEBPACK_IMPORTED_MODULE_9__lib_utils_payments__["a" /* default */].methods(method.node),
              tag({ enabled: method.node.enabled })
            ),
            method.node.enabled && method.node.__typename === 'CashPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: method.node.instructions } }),
            method.node.enabled && method.node.__typename === 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: method.node.instructions } }),
            method.node.enabled && method.node.__typename === 'CheckPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'em',
                  null,
                  'Pay to the order of: ',
                  method.node.pay_to
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { whiteSpace: 'pre' } },
                method.node.address
              )
            )
          );
        }),
        !this.getPaymentMethod('CashPaymentMethod') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
          {
            checked: false,
            style: { marginBottom: '2em' },
            onChange: this.openEditPaymentMethod.bind(null, { __typename: 'CashPaymentMethod', enabled: false }, true)
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            'Cash',
            tag({ enabled: false })
          )
        ),
        !this.getPaymentMethod('CheckPaymentMethod') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
          {
            checked: false,
            style: { marginBottom: '2em' },
            onChange: this.openEditPaymentMethod.bind(null, { __typename: 'CheckPaymentMethod', enabled: false }, true)
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            'Check',
            tag({ enabled: false })
          )
        ),
        !this.getPaymentMethod('SquarePaymentMethod') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
          {
            checked: false,
            style: { marginBottom: '2em' },
            onChange: function onChange() {
              return _this6.setState({ squareModalOpen: true });
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            'Credit Card',
            tag({ enabled: false })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { onClick: this.openNewPaymentMethod },
          '+ Add New'
        )
      );
    }
  }]);

  return AcceptedPaymentMethods;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AcceptedPaymentMethods.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AcceptedPaymentMethods);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Document_Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AcceptedPaymentMethods__ = __webpack_require__(1443);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var NoPaymentMethods = function (_React$Component) {
  _inherits(NoPaymentMethods, _React$Component);

  function NoPaymentMethods(props) {
    _classCallCheck(this, NoPaymentMethods);

    var _this = _possibleConstructorReturn(this, (NoPaymentMethods.__proto__ || Object.getPrototypeOf(NoPaymentMethods)).call(this, props));

    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(NoPaymentMethods, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var helperText = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { style: { marginBottom: '2em' } },
        'Please select one or more ways to get paid'
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.window.width >= __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */],
          {
            open: this.props.open,
            onClose: this.props.onClose,
            size: 'small'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Header, { content: 'Enable Payment Methods' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Content,
            null,
            helperText,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AcceptedPaymentMethods__["a" /* default */], {
              viewer: this.props.viewer,
              relay: this.props.relay,
              node: this.props.node
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Actions,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: this.props.onClose,
                className: __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss___default.a.modalSecondaryAction
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                type: 'submit',
                disabled: this.props.viewer.payment_methods.edges.filter(function (node) {
                  return node.enabled;
                }).length === 0,
                onClick: function onClick() {
                  return _this2.refs.form.submit();
                }
              },
              'Next'
            )
          )
        ),
        this.state.window.width < __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__Modules__["f" /* MobileModal */],
          { open: this.props.open, onClose: this.props.onClose },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.props.onClose },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this2.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__Modules__["f" /* MobileModal */].Content,
            null,
            helperText,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AcceptedPaymentMethods__["a" /* default */], {
              viewer: this.props.viewer,
              relay: this.props.relay,
              node: this.props.node
            })
          )
        )
      );
    }
  }]);

  return NoPaymentMethods;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NoPaymentMethods.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (NoPaymentMethods);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Share__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Sections_Actions_Actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_timezone__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ContractActions = function (_React$Component) {
  _inherits(ContractActions, _React$Component);

  function ContractActions(props) {
    _classCallCheck(this, ContractActions);

    var _this = _possibleConstructorReturn(this, (ContractActions.__proto__ || Object.getPrototypeOf(ContractActions)).call(this, props));

    _this.state = {
      alreadySignedModalOpen: false,
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.deleteContract = _this.deleteContract.bind(_this);
    _this.saveContractAsTemplate = _this.saveContractAsTemplate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    _this.downloadPdf = _this.downloadPdf.bind(_this);
    _this.print = _this.print.bind(_this);
    return _this;
  }

  _createClass(ContractActions, [{
    key: 'deleteContract',
    value: function deleteContract() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete contract',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted contract',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/events/' + _this2.props.node.workspaces.edges[0].node.event.id + '/workspaces');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-contract');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2855);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'saveContractAsTemplate',
    value: function saveContractAsTemplate() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.props.router.push('/templates/c/' + response.saveContractAsTemplate.c_template.id);
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-contract-template', {
          source: 'existing-contract'
        });
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2856);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { contract_id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'downloadPdf',
    value: function downloadPdf() {
      window.location = '/contracts/' + this.props.node.id + '.pdf?tz=' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz.guess();
    }
  }, {
    key: 'print',
    value: function print() {
      window.location = '/contracts/' + this.props.node.id + '.pdf?tz=' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz.guess() + '&disposition=inline';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteContract,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/docs/c/' + _this4.props.node.id);
                },
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && this.props.node.editable && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/docs/c/' + _this4.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            this.props.params.action !== 'edit' && this.props.node.can_edit && !this.props.node.editable && this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
              {
                trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                  { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
                  ' \xA0 Edit'
                ),
                size: 'small',
                onOpen: function onOpen() {
                  return _this4.setState({ alreadySignedModalOpen: true });
                },
                onClose: this.selectItem.bind(null, function () {
                  return _this4.setState({ alreadySignedModalOpen: false });
                }),
                open: this.state.alreadySignedModalOpen
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Header,
                null,
                'Contract has already been signed'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'You cannot make changes to this contract since it has already been signed.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                  basic: true,
                  content: 'Close',
                  onClick: this.selectItem.bind(null, function () {
                    return _this4.setState({ alreadySignedModalOpen: false });
                  })
                })
              )
            ),
            this.props.node.can_edit && this.props.params.action !== 'edit' && !this.props.node.editable && this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                key: 'edit',
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem,
                onClick: function onClick() {
                  return _this4.setState({ alreadySignedModalOpen: true });
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */],
              { open: this.state.alreadySignedModalOpen, key: 'modal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                      className: 'item',
                      onClick: this.selectItem.bind(null, function () {
                        return _this4.setState({ alreadySignedModalOpen: false });
                      })
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Content,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  'Contract has already been signed'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'You cannot make changes to this contract since it has already been signed.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                  basic: true,
                  fluid: true,
                  content: 'Close',
                  onClick: this.selectItem.bind(null, function () {
                    return _this4.setState({ alreadySignedModalOpen: false });
                  }),
                  style: { marginTop: '2em' }
                })
              )
            )],
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Share__["a" /* default */], {
              document: this.props.node,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'share' }),
                ' \xA0 Share'
              ),
              onClose: this.selectItem,
              relay: this.props.relay
            }),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem,
                onClick: this.selectItem.bind(null, this.saveContractAsTemplate)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Save As Template'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.print,
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'print' }),
              ' \xA0 Print'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.downloadPdf,
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'download' }),
              ' \xA0 Download PDF'
            ),
            this.props.node.can_edit && this.props.node.deletable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Contract'
            )
          )
        )
      );
    }
  }]);

  return ContractActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractActions);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Share__ = __webpack_require__(2891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EstimateActions = function (_React$Component) {
  _inherits(EstimateActions, _React$Component);

  function EstimateActions(props) {
    _classCallCheck(this, EstimateActions);

    var _this = _possibleConstructorReturn(this, (EstimateActions.__proto__ || Object.getPrototypeOf(EstimateActions)).call(this, props));

    _this.state = {
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.deleteEstimate = _this.deleteEstimate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    _this.downloadPdf = _this.downloadPdf.bind(_this);
    _this.print = _this.print.bind(_this);
    return _this;
  }

  _createClass(EstimateActions, [{
    key: 'deleteEstimate',
    value: function deleteEstimate() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete estimate',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted estimate',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-estimate');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2893);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'downloadPdf',
    value: function downloadPdf() {
      window.location = '/estimates/' + this.props.node.id + '.pdf';
    }
  }, {
    key: 'print',
    value: function print() {
      window.location = '/estimates/' + this.props.node.id + '.pdf?disposition=inline';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteEstimate,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/docs/e/' + _this3.props.node.id);
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/docs/e/' + _this3.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Share__["a" /* default */], {
              document: this.props.node,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'share' }),
                ' \xA0 Share'
              ),
              relay: this.props.relay,
              onClose: this.props.onClose
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.print,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'print' }),
              ' \xA0 Print'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.downloadPdf,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'download' }),
              ' \xA0 Download PDF'
            ),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Estimate'
            )
          )
        )
      );
    }
  }]);

  return EstimateActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimateActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateActions);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Share__ = __webpack_require__(2997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var FormActions = function (_React$Component) {
  _inherits(FormActions, _React$Component);

  function FormActions(props) {
    _classCallCheck(this, FormActions);

    var _this = _possibleConstructorReturn(this, (FormActions.__proto__ || Object.getPrototypeOf(FormActions)).call(this, props));

    _this.state = {
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.deleteForm = _this.deleteForm.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    _this.downloadPdf = _this.downloadPdf.bind(_this);
    _this.saveFormAsTemplate = _this.saveFormAsTemplate.bind(_this);
    _this.print = _this.print.bind(_this);
    return _this;
  }

  _createClass(FormActions, [{
    key: 'deleteForm',
    value: function deleteForm() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete form',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted form',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-form');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2999);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'downloadPdf',
    value: function downloadPdf() {
      window.location = '/forms/' + this.props.node.id + '.pdf';
    }
  }, {
    key: 'saveFormAsTemplate',
    value: function saveFormAsTemplate() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.props.router.push('/templates/f/' + response.saveFormAsTemplate.form_template.id);
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-form-template', {
          source: 'existing-form'
        });
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3000);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { form_id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'print',
    value: function print() {
      window.location = '/forms/' + this.props.node.id + '.pdf?disposition=inline';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteForm,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/docs/f/' + _this4.props.node.id);
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/docs/f/' + _this4.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Share__["a" /* default */], {
              document: this.props.node,
              relay: this.props.relay,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'share' }),
                ' \xA0 Share'
              ),
              onClose: this.props.onClose
            }),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem,
                onClick: this.selectItem.bind(null, this.saveFormAsTemplate)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Save As Template'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.print,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'print' }),
              ' \xA0 Print'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.downloadPdf,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'download' }),
              ' \xA0 Download PDF'
            ),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Form'
            )
          )
        )
      );
    }
  }]);

  return FormActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormActions);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fields_SchemaField__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FormBuilder = function (_React$Component) {
  _inherits(FormBuilder, _React$Component);

  function FormBuilder() {
    _classCallCheck(this, FormBuilder);

    return _possibleConstructorReturn(this, (FormBuilder.__proto__ || Object.getPrototypeOf(FormBuilder)).apply(this, arguments));
  }

  _createClass(FormBuilder, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          addContentBlock = _props.addContentBlock,
          addQuestion = _props.addQuestion,
          formData = _props.formData,
          schema = _props.schema,
          uiSchema = _props.uiSchema,
          onChange = _props.onChange,
          deleteQuestion = _props.deleteQuestion,
          updateForm = _props.updateForm;

      var hasQuestions = schema && schema.properties && Object.keys(schema.properties).length > 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !hasQuestions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: 'center', padding: '2em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'This form has no questions'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            primary: true,
            icon: 'plus',
            labelPosition: 'left',
            content: 'Add Question',
            onClick: addQuestion
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: addContentBlock },
              '+ Add Content'
            )
          )
        ),
        hasQuestions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Fields_SchemaField__["a" /* default */], {
            schema: schema,
            onChange: onChange,
            uiSchema: uiSchema,
            updateForm: updateForm,
            deleteQuestion: deleteQuestion,
            formData: formData
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            style: { marginRight: '1em', marginBottom: '1em' },
            onClick: addContentBlock,
            content: 'Add Content'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            onClick: addQuestion,
            positive: true,
            content: 'Add Question'
          })
        )
      );
    }
  }]);

  return FormBuilder;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormBuilder.propTypes = {
  addContentBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addQuestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteQuestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormBuilder);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Array__ = __webpack_require__(2916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Object__ = __webpack_require__(2918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__String__ = __webpack_require__(2921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Null__ = __webpack_require__(2917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Unsupported__ = __webpack_require__(2922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SchemaFieldEditDesktop__ = __webpack_require__(2919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SchemaFieldEditMobile__ = __webpack_require__(2920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__changeQuestionType__ = __webpack_require__(2930);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var COMPONENT_TYPES = {
  array: __WEBPACK_IMPORTED_MODULE_3__Array__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_7__Unsupported__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_7__Unsupported__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_7__Unsupported__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_4__Object__["a" /* default */],
  string: __WEBPACK_IMPORTED_MODULE_5__String__["a" /* default */],
  null: __WEBPACK_IMPORTED_MODULE_6__Null__["a" /* default */]
};

var SchemaField = function (_React$Component) {
  _inherits(SchemaField, _React$Component);

  function SchemaField(props) {
    _classCallCheck(this, SchemaField);

    var _this = _possibleConstructorReturn(this, (SchemaField.__proto__ || Object.getPrototypeOf(SchemaField)).call(this, props));

    _this.state = {
      schema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.schema),
      uiSchema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.uiSchema),
      formData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.formData),
      deleting: false
    };
    _this.getQuestionType = _this.getQuestionType.bind(_this);
    _this.onQuestionTypeChange = _this.onQuestionTypeChange.bind(_this);
    _this.deleteQuestion = _this.deleteQuestion.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    return _this;
  }

  _createClass(SchemaField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.schema.type === 'object') {
        this.setState({
          schema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.schema),
          uiSchema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.uiSchema),
          formData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.formData)
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(form, callback) {
      this.setState(form, callback);
    }
  }, {
    key: 'onQuestionTypeChange',
    value: function onQuestionTypeChange(e) {
      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema,
          formData = _props.formData,
          updateForm = _props.updateForm,
          deleteResponse = _props.deleteResponse;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__changeQuestionType__["a" /* default */])({
        to: e.target.value,
        from: this.getQuestionType(),
        onChange: this.onChange,
        schema: schema,
        uiSchema: uiSchema,
        formData: formData,
        localSchema: this.state.schema,
        localUiSchema: this.state.uiSchema,
        localFormData: this.state.formData,
        updateForm: updateForm,
        deleteResponse: deleteResponse
      });
    }
  }, {
    key: 'getQuestionType',
    value: function getQuestionType() {
      switch (this.state.schema.type) {
        case 'string':
          switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
            case 'radio':
              return 'radio';
            case 'select':
              return 'select';
            case 'textArea':
              return 'textArea';
            default:
              return 'text';
          }
        case 'array':
          switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
            case 'table':
              return 'table';
            case 'checkboxes':
              return 'checkboxes';
            default:
              return 'textList';
          }
        case 'object':
          switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
            case 'table':
              return 'table';
            default:
              return 'table';
          }
        default:
          return 'text';
      }
    }
  }, {
    key: 'deleteQuestion',
    value: function deleteQuestion(key) {
      var _this2 = this;

      this.setState({ deleting: true }, function () {
        return _this2.props.deleteQuestion(key);
      });
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate(callback) {
      var _this3 = this;

      // Check if deleting due to DTHC onclickoutside
      if (!this.state.deleting) {
        new Promise(function (resolve) {
          _this3.props.onChange({
            schema: _this3.state.schema,
            uiSchema: _this3.state.uiSchema,
            formData: _this3.state.formData
          }, resolve);
        }).then(function () {
          return new Promise(function (resolve) {
            // Remove bad form data
            if (
            // Radio and Select widgets
            _this3.state.uiSchema && (_this3.state.uiSchema['ui:widget'] === 'select' || _this3.state.uiSchema['ui:widget'] === 'radio') && !_this3.state.schema.enum.includes(_this3.state.formData)) {
              _this3.props.deleteResponse(resolve);
            } else if (
            // Checkboxes
            _this3.state.uiSchema && _this3.state.uiSchema['ui:widget'] === 'checkboxes') {
              var newFormData = _this3.state.formData && _this3.state.formData.filter(function (item) {
                return _this3.state.schema.items.enum.includes(item);
              });
              _this3.props.onChange({
                schema: _this3.state.schema,
                uiSchema: _this3.state.uiSchema,
                formData: newFormData
              }, resolve);
            } else {
              resolve();
            }
          });
        }).then(function () {
          _this3.props.updateForm(callback);
        });
      }
    }
  }, {
    key: 'reset',
    value: function reset(e, callback) {
      this.setState({
        schema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.schema),
        uiSchema: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.uiSchema),
        formData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.formData)
      }, callback);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onChange = _props2.onChange,
          updateForm = _props2.updateForm,
          objectKey = _props2.objectKey,
          formData = _props2.formData;
      var _state$schema = this.state.schema,
          title = _state$schema.title,
          type = _state$schema.type;

      var description = this.state.uiSchema && this.state.uiSchema['ui:description'];
      var FieldComponent = COMPONENT_TYPES[type];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_9__Form_scss___default.a.fieldSpacing },
        type === 'object' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            title
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FieldComponent, _defineProperty({
            schema: this.state.schema,
            uiSchema: this.state.uiSchema,
            onChange: onChange,
            updateForm: updateForm,
            deleteQuestion: this.deleteQuestion,
            formData: formData
          }, 'updateForm', updateForm))
        ),
        type !== 'object' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__Modules__["k" /* Dthc */],
          {
            desktop: __WEBPACK_IMPORTED_MODULE_10__SchemaFieldEditDesktop__["a" /* default */],
            mobile: __WEBPACK_IMPORTED_MODULE_11__SchemaFieldEditMobile__["a" /* default */],
            FieldComponent: FieldComponent,
            schema: this.state.schema,
            uiSchema: this.state.uiSchema,
            getQuestionType: this.getQuestionType,
            onChange: this.onChange,
            onQuestionTypeChange: this.onQuestionTypeChange,
            commitUpdate: this.commitUpdate,
            deleteQuestion: this.deleteQuestion,
            handleClickOutside: true,
            editing: true,
            objectKey: objectKey,
            formData: this.state.formData,
            reset: this.reset
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { padding: '1em' } },
            type !== 'null' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                { className: [__WEBPACK_IMPORTED_MODULE_9__Form_scss___default.a.fieldTitle, title ? '' : __WEBPACK_IMPORTED_MODULE_9__Form_scss___default.a.questionPlaceholder].join(' ') },
                title || 'Question'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_9__Form_scss___default.a.fieldDescription },
                description
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FieldComponent, {
              formData: this.state.formData,
              schema: this.state.schema,
              uiSchema: this.state.uiSchema,
              onChange: onChange
            })
          )
        )
      );
    }
  }]);

  return SchemaField;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SchemaField.propTypes = {
  deleteResponse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  deleteQuestion: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  objectKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  updateForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SchemaField);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);





var TextWidget = function TextWidget(_ref) {
  var placeholder = _ref.placeholder;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], { name: 'textInput', placeholder: placeholder || 'Short answer text', disabled: true })
  );
};

TextWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TextWidget);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);






var FormRendererControls = function FormRendererControls(_ref) {
  var readOnly = _ref.readOnly,
      allChangesSaved = _ref.allChangesSaved,
      updateResponse = _ref.updateResponse;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'right', marginBottom: '2em' } },
    !readOnly && allChangesSaved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.changesSaved },
      'All Changes Saved'
    ),
    readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.changesSaved },
        'Your answers won\'t be saved'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], { primary: true, disabled: true, content: 'Save' })
    ),
    !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
      primary: true,
      disabled: allChangesSaved,
      content: 'Save',
      onClick: function onClick() {
        return updateResponse(function () {
          return __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
            message: 'Successfully saved form',
            intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
          });
        });
      }
    })
  );
};

FormRendererControls.propTypes = {
  allChangesSaved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  updateResponse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (FormRendererControls);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Object__ = __webpack_require__(2986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__String__ = __webpack_require__(2988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Array__ = __webpack_require__(2984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Null__ = __webpack_require__(2985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Unsupported__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Form_scss__);









var COMPONENT_TYPES = {
  array: __WEBPACK_IMPORTED_MODULE_4__Array__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_6__Unsupported__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_6__Unsupported__["a" /* default */],
  null: __WEBPACK_IMPORTED_MODULE_5__Null__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_6__Unsupported__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_2__Object__["a" /* default */],
  string: __WEBPACK_IMPORTED_MODULE_3__String__["a" /* default */]
};

var SchemaField = function SchemaField(_ref) {
  var schema = _ref.schema,
      formData = _ref.formData,
      onChange = _ref.onChange,
      uiSchema = _ref.uiSchema;
  var title = schema.title,
      type = schema.type;

  var description = uiSchema && uiSchema['ui:description'];
  var FieldComponent = COMPONENT_TYPES[type];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_7__Form_scss___default.a.fieldSpacing },
    title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: __WEBPACK_IMPORTED_MODULE_7__Form_scss___default.a.fieldTitle },
      title
    ),
    description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_7__Form_scss___default.a.fieldDescription },
      description
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldComponent, {
      schema: schema,
      formData: formData,
      uiSchema: uiSchema,
      onChange: onChange
    })
  );
};

SchemaField.propTypes = {
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SchemaField);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fields_SchemaField__ = __webpack_require__(1452);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormResponse = function (_React$PureComponent) {
  _inherits(FormResponse, _React$PureComponent);

  function FormResponse() {
    _classCallCheck(this, FormResponse);

    return _possibleConstructorReturn(this, (FormResponse.__proto__ || Object.getPrototypeOf(FormResponse)).apply(this, arguments));
  }

  _createClass(FormResponse, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          formData = _props.formData,
          schema = _props.schema,
          uiSchema = _props.uiSchema;

      var hasQuestions = schema && schema.properties && Object.keys(schema.properties).length > 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !hasQuestions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: 'center', padding: '2em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'This form has no questions'
          )
        ),
        hasQuestions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Fields_SchemaField__["a" /* default */], {
          schema: schema,
          formData: formData,
          onChange: onChange,
          uiSchema: uiSchema
        })
      );
    }
  }]);

  return FormResponse;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

FormResponse.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormResponse);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TextWidget = function (_React$Component) {
  _inherits(TextWidget, _React$Component);

  function TextWidget(props) {
    _classCallCheck(this, TextWidget);

    var _this = _possibleConstructorReturn(this, (TextWidget.__proto__ || Object.getPrototypeOf(TextWidget)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(TextWidget, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          value = _props.value;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          name: 'textWidget',
          value: value || '',
          placeholder: 'Your answer',
          label: label,
          onChange: this.onChange,
          autoHeight: true
        })
      );
    }
  }]);

  return TextWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextWidget.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (TextWidget);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Share__ = __webpack_require__(3032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Refund___ = __webpack_require__(1456);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var InvoiceActions = function (_React$Component) {
  _inherits(InvoiceActions, _React$Component);

  function InvoiceActions(props) {
    _classCallCheck(this, InvoiceActions);

    var _this = _possibleConstructorReturn(this, (InvoiceActions.__proto__ || Object.getPrototypeOf(InvoiceActions)).call(this, props));

    _this.state = {
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.deleteInvoice = _this.deleteInvoice.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    _this.addPayment = _this.addPayment.bind(_this);
    _this.downloadPdf = _this.downloadPdf.bind(_this);
    _this.print = _this.print.bind(_this);
    return _this;
  }

  _createClass(InvoiceActions, [{
    key: 'deleteInvoice',
    value: function deleteInvoice() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete invoice',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted invoice',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-invoice');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3034);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'addPayment',
    value: function addPayment() {
      this.props.addPayment();
      if (this.props.onClose) this.props.onClose();
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'downloadPdf',
    value: function downloadPdf() {
      window.location = '/invoices/' + this.props.node.id + '.pdf?tz=' + __WEBPACK_IMPORTED_MODULE_8_moment_timezone___default.a.tz.guess();
    }
  }, {
    key: 'print',
    value: function print() {
      window.location = '/invoices/' + this.props.node.id + '.pdf?tz=' + __WEBPACK_IMPORTED_MODULE_8_moment_timezone___default.a.tz.guess() + '&disposition=inline';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var hasPayments = this.props.node.payments.edges.length > 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteInvoice,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/docs/i/' + _this3.props.node.id + '/');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/docs/i/' + _this3.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Share__["a" /* default */], {
              document: this.props.node,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'share' }),
                ' \xA0 Share'
              ),
              relay: this.props.relay,
              onClose: this.props.onClose
            }),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.addPayment,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'payment' }),
              ' \xA0 Add Payment'
            ),
            this.props.node.can_edit && hasPayments && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Refund___["a" /* default */], {
              node: this.props.node,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'minus circle' }),
                ' \xA0 Add Refund'
              ),
              relay: this.props.relay,
              onClose: this.props.onClose
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.print,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'print' }),
              ' \xA0 Print'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.downloadPdf,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'download' }),
              ' \xA0 Download PDF'
            ),
            this.props.node.can_edit && this.props.node.deletable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Invoice'
            )
          )
        )
      );
    }
  }]);

  return InvoiceActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceActions.propTypes = {
  addPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openSetupPaymentMethods: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceActions);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectPayment__ = __webpack_require__(3027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnterAmount__ = __webpack_require__(3026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Confirmation__ = __webpack_require__(3025);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InvoiceRefund = function (_React$Component) {
  _inherits(InvoiceRefund, _React$Component);

  function InvoiceRefund(props) {
    _classCallCheck(this, InvoiceRefund);

    var _this = _possibleConstructorReturn(this, (InvoiceRefund.__proto__ || Object.getPrototypeOf(InvoiceRefund)).call(this, props));

    _this.state = {
      submitting: false
    };
    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onPaymentSelect = _this.onPaymentSelect.bind(_this);
    _this.onRefundTypeSelect = _this.onRefundTypeSelect.bind(_this);
    _this.refundPayment = _this.refundPayment.bind(_this);
    _this.refundButtonText = _this.refundButtonText.bind(_this);
    return _this;
  }

  _createClass(InvoiceRefund, [{
    key: 'onOpen',
    value: function onOpen() {
      this.setState({ refund: {}, refundType: null, selectedPayment: null });
      if (this.props.onOpen) this.props.onOpen();
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      if (this.props.onClose) this.props.onClose();
    }
  }, {
    key: 'onPaymentSelect',
    value: function onPaymentSelect(e, _ref) {
      var value = _ref.value;

      this.setState({ selectedPayment: value });
    }
  }, {
    key: 'onRefundTypeSelect',
    value: function onRefundTypeSelect(e, _ref2) {
      var value = _ref2.value;

      this.setState({ refundType: value });
    }
  }, {
    key: 'maxRefund',
    value: function maxRefund() {
      var refundedCents = this.state.selectedPayment.refunds.edges.reduce(function (total, paymentRefund) {
        return total + paymentRefund.node.amount_cents;
      }, 0);
      return this.state.selectedPayment.amount_cents - refundedCents;
    }
  }, {
    key: 'refundPayment',
    value: function refundPayment(model, resetForm, invalidateForm, successCb) {
      // eslint-disable-next-line no-underscore-dangle
      if (this.state.selectedPayment.__typename === 'SquarePayment') {
        this.refundSquarePayment(model, resetForm, invalidateForm, successCb);
      } else {
        this.recordManualPayment(model, resetForm, invalidateForm, successCb);
      }
    }
  }, {
    key: 'recordManualPayment',
    value: function recordManualPayment(model, resetForm, invalidateForm, successCb) {
      var _this2 = this;

      var onError = function onError() {
        _this2.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to record refund',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.setState({ submitting: false });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('created-manual-refund');
      };

      var amount = this.state.refundType === 'full' ? this.maxRefund() : model.amount * 100;

      this.setState({
        submitting: true,
        refund: Object.assign({}, model, { amount_cents: amount })
      });

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3028);
      });

      var environment = this.props.relay.environment;
      var selectedPayment = this.state.selectedPayment;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            payment_id: selectedPayment.id,
            amount_cents: amount,
            notes: model.notes,
            amount_currency: selectedPayment.amount_currency
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'refundSquarePayment',
    value: function refundSquarePayment(model, resetForm, invalidateForm, successCb) {
      var _this3 = this;

      var onError = function onError() {
        _this3.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to issue refund',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this3.setState({ submitting: false });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('created-square-refund');
      };

      var amount = this.state.refundType === 'full' ? this.maxRefund() : model.amount * 100;

      this.setState({
        submitting: true,
        refund: Object.assign({}, model, { amount_cents: amount })
      });

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3029);
      });

      var environment = this.props.relay.environment;
      var selectedPayment = this.state.selectedPayment;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            payment_id: selectedPayment.id,
            amount_cents: amount,
            notes: model.notes,
            amount_currency: selectedPayment.amount_currency
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'refundButtonText',
    value: function refundButtonText() {
      var selectedPayment = this.state.selectedPayment;

      if (selectedPayment) {
        // eslint-disable-next-line no-underscore-dangle
        return selectedPayment.__typename === 'SquarePayment' ? 'Issue Refund' : 'Record Refund';
      }
      return 'Refund';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          node = _props.node;
      var _state = this.state,
          refund = _state.refund,
          refundType = _state.refundType,
          selectedPayment = _state.selectedPayment,
          submitting = _state.submitting;

      var title = 'Issue a Refund';
      var steps = [{
        component: __WEBPACK_IMPORTED_MODULE_4__SelectPayment__["a" /* default */],
        componentProps: {
          onPaymentSelect: this.onPaymentSelect,
          payments: node.payments.edges,
          selectedPayment: selectedPayment
        },
        actions: {
          primary: { disabled: !selectedPayment }
        },
        title: title
      }, {
        component: __WEBPACK_IMPORTED_MODULE_5__EnterAmount__["a" /* default */],
        componentProps: {
          invoice: node,
          refundType: refundType,
          payment: selectedPayment,
          onRefundTypeSelect: this.onRefundTypeSelect
        },
        title: title,
        actions: {
          primary: {
            type: 'submit',
            disabled: submitting || !refundType,
            content: submitting ? 'Refunding...' : this.refundButtonText()
          }
        },
        formProps: {
          onValidSubmit: this.refundPayment
        }
      }, {
        component: __WEBPACK_IMPORTED_MODULE_6__Confirmation__["a" /* default */],
        componentProps: { refund: refund, originalPayment: selectedPayment },
        title: title,
        hideActions: true
      }];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["e" /* Wizard */], {
        onOpen: this.onOpen,
        onClose: this.onClose,
        steps: steps,
        trigger: trigger
      });
    }
  }]);

  return InvoiceRefund;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceRefund.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceRefund);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Share__ = __webpack_require__(3066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MusicPlannerActions = function (_React$Component) {
  _inherits(MusicPlannerActions, _React$Component);

  function MusicPlannerActions(props) {
    _classCallCheck(this, MusicPlannerActions);

    var _this = _possibleConstructorReturn(this, (MusicPlannerActions.__proto__ || Object.getPrototypeOf(MusicPlannerActions)).call(this, props));

    _this.state = {
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.deleteMusicPlanner = _this.deleteMusicPlanner.bind(_this);
    _this.saveAsTemplate = _this.saveAsTemplate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    _this.downloadPdf = _this.downloadPdf.bind(_this);
    _this.print = _this.print.bind(_this);
    _this.toggleView = _this.toggleView.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerActions, [{
    key: 'downloadPdf',
    value: function downloadPdf() {
      window.location = '/music_planners/' + this.props.node.id + '.pdf';
    }
  }, {
    key: 'print',
    value: function print() {
      window.location = '/music_planners/' + this.props.node.id + '.pdf?disposition=inline';
    }
  }, {
    key: 'deleteMusicPlanner',
    value: function deleteMusicPlanner() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete music list',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted music list',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-music-planner');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3068);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'saveAsTemplate',
    value: function saveAsTemplate() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.props.router.push('/templates/m/' + response.saveMusicPlannerAsTemplate.mp_template.id);
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-music-planner-template', {
          source: 'existing-music-planner'
        });
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3069);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { music_planner_id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'toggleView',
    value: function toggleView() {
      var _props$params = this.props.params,
          action = _props$params.action,
          playlistId = _props$params.playlist_id;

      var nextAction = action === 'edit' ? 'preview' : 'edit';
      this.props.router.replace('/docs/m/' + this.props.node.id + '/' + nextAction + (playlistId ? '/playlist/' + playlistId : ''));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteMusicPlanner,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.toggleView,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.toggleView,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Share__["a" /* default */], {
              document: this.props.node,
              relay: this.props.relay,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'share' }),
                ' \xA0 Share'
              ),
              onClose: this.props.onClose
            }),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem,
                onClick: this.selectItem.bind(null, this.saveAsTemplate)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Save As Template'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.print,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'print' }),
              ' \xA0 Print'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.downloadPdf,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'download' }),
              ' \xA0 Download PDF'
            ),
            this.props.node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete List'
            )
          )
        )
      );
    }
  }]);

  return MusicPlannerActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerActions);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);





var EmailConfirmation = function EmailConfirmation(_ref) {
  var documentType = _ref.documentType,
      onClose = _ref.onClose,
      to = _ref.to,
      cc = _ref.cc;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'center' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["j" /* Success */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { style: { textTransform: 'capitalize' } },
      documentType,
      ' Sent!'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { style: { marginBottom: '2em' } },
      'Your ',
      documentType,
      ' was sent to ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        to
      ),
      cc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        ' and CC\'d to ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          cc
        )
      ),
      '.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, fluid: true, content: 'Done', onClick: onClose })
  );
};

EmailConfirmation.propTypes = {
  documentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (EmailConfirmation);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_clipboard_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Share_scss__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Share_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Share_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DocumentShareOptions = function (_Component) {
  _inherits(DocumentShareOptions, _Component);

  function DocumentShareOptions(props) {
    _classCallCheck(this, DocumentShareOptions);

    var _this = _possibleConstructorReturn(this, (DocumentShareOptions.__proto__ || Object.getPrototypeOf(DocumentShareOptions)).call(this, props));

    _this.state = {
      to: '',
      cc: '',
      subject: '',
      message: '',
      showCc: false
    };
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onSuccessfulCopy = _this.onSuccessfulCopy.bind(_this);
    _this.onTextChange = _this.onTextChange.bind(_this);
    _this.onEmailChange = _this.onEmailChange.bind(_this);
    return _this;
  }

  _createClass(DocumentShareOptions, [{
    key: 'onFocus',
    value: function onFocus(e) {
      e.target.select();
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(e, _ref) {
      var value = _ref.value,
          name = _ref.name;

      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: 'onTextChange',
    value: function onTextChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'onSuccessfulCopy',
    value: function onSuccessfulCopy() {
      __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
        message: 'Successfully copied ' + this.props.documentType + ' URL',
        intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canEmail = _props.canEmail,
          documentType = _props.documentType,
          emailSuggestions = _props.emailSuggestions,
          permissionsNode = _props.permissionsNode,
          shareUrl = _props.shareUrl,
          showLink = _props.showLink,
          submitted = _props.submitted,
          toggleLink = _props.toggleLink;
      var _state = this.state,
          to = _state.to,
          cc = _state.cc,
          subject = _state.subject,
          message = _state.message,
          showCc = _state.showCc;


      var copyButton = function copyButton() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_clipboard_js___default.a,
          {
            'option-text': function optionText() {
              return shareUrl;
            },
            onSuccess: _this2.onSuccessfulCopy,
            className: 'ui right icon button button'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Copy \xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' })
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref2) {
          var isMobile = _ref2.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
            { padded: true, relaxed: true, stackable: true, centered: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  showLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { style: { textAlign: 'left' } },
                      'You can share this ',
                      documentType,
                      ' with anyone through this link.'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], {
                      fluid: true,
                      name: 'share_url',
                      onFocus: _this2.onFocus,
                      value: shareUrl,
                      onChange: function onChange() {},
                      action: copyButton(),
                      style: { marginTop: '2em', marginBottom: '2em' }
                    }),
                    permissionsNode,
                    canEmail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { style: { marginTop: '1em' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { onClick: toggleLink },
                        'Share via email ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'mail outline' })
                      )
                    )
                  ),
                  !showLink && canEmail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["k" /* InputWithSuggestions */], {
                      label: 'To',
                      name: 'to',
                      value: to,
                      onChange: _this2.onEmailChange,
                      submitted: submitted,
                      placeholder: 'Email address...',
                      className: !showCc ? __WEBPACK_IMPORTED_MODULE_7__Share_scss___default.a.toField : null,
                      fluid: true,
                      required: true,
                      validations: 'isEmail',
                      autoComplete: 'off',
                      options: emailSuggestions,
                      validationError: 'Valid email address required'
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    showCc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["k" /* InputWithSuggestions */], {
                        label: 'Cc',
                        name: 'cc',
                        value: cc,
                        onChange: _this2.onEmailChange,
                        submitted: submitted,
                        placeholder: 'Email address...',
                        fluid: true,
                        validations: 'isEmail',
                        autoComplete: 'off',
                        options: emailSuggestions,
                        validationError: 'Valid email address required'
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    !showCc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      {
                        style: {
                          position: 'absolute',
                          top: isMobile ? '2.125em' : '2.25em',
                          right: '1.125em'
                        },
                        onClick: function onClick() {
                          return _this2.setState({ showCc: true });
                        }
                      },
                      'Cc'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], {
                      label: 'Subject',
                      name: 'subject',
                      value: subject,
                      placeholder: 'Email subject...',
                      onChange: _this2.onTextChange,
                      submitted: submitted,
                      fluid: true,
                      required: true,
                      validationError: 'Subject is required'
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'ui form' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { marginBottom: '0.25em' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'strong',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { htmlFor: 'message' },
                            'Message'
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["i" /* TextArea */], {
                        placeholder: 'Enter a personal message',
                        name: 'message',
                        id: 'message',
                        value: message,
                        onChange: _this2.onTextChange
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { onClick: toggleLink },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        'Get shareable link ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'linkify' })
                      )
                    )
                  )
                )
              )
            )
          );
        }
      );
    }
  }]);

  return DocumentShareOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DocumentShareOptions.propTypes = {
  canEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  documentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  emailSuggestions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  permissionsNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  shareUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  showLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggleLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (DocumentShareOptions);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BrandFields = function (_React$Component) {
  _inherits(BrandFields, _React$Component);

  function BrandFields(props) {
    _classCallCheck(this, BrandFields);

    var _this = _possibleConstructorReturn(this, (BrandFields.__proto__ || Object.getPrototypeOf(BrandFields)).call(this, props));

    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    return _this;
  }

  _createClass(BrandFields, [{
    key: 'textFieldChange',
    value: function textFieldChange(value) {
      this.fieldChange('brand_header', value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign({}, this.props.localBrand, newValue));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
        value: this.props.localBrand.brand_header || '',
        onChange: this.textFieldChange,
        placeholder: 'Brand header information'
      });
    }
  }]);

  return BrandFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrandFields.propTypes = {
  selectedBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BrandFields);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DescriptionEditDesktop__ = __webpack_require__(3104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DescriptionEditMobile__ = __webpack_require__(3105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Description_scss__ = __webpack_require__(3607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Description_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Description_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DescriptionComponent = function (_React$Component) {
  _inherits(DescriptionComponent, _React$Component);

  function DescriptionComponent(props) {
    _classCallCheck(this, DescriptionComponent);

    var _this = _possibleConstructorReturn(this, (DescriptionComponent.__proto__ || Object.getPrototypeOf(DescriptionComponent)).call(this, props));

    _this.state = {
      addingNew: false,
      selected: false
    };
    _this.addNew = _this.addNew.bind(_this);
    _this.closeNew = _this.closeNew.bind(_this);
    return _this;
  }

  _createClass(DescriptionComponent, [{
    key: 'addNew',
    value: function addNew() {
      this.setState({ addingNew: true, selected: false });
    }
  }, {
    key: 'closeNew',
    value: function closeNew() {
      this.setState({ addingNew: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canEdit = _props.canEdit,
          localDescription = _props.localDescription,
          reset = _props.reset,
          description = _props.description,
          descriptionChangeHandler = _props.descriptionChangeHandler,
          updateDescription = _props.updateDescription;
      var _state = this.state,
          addingNew = _state.addingNew,
          selected = _state.selected;

      var DescriptionShow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: { padding: '1em', wordBreak: 'break-word' },
        dangerouslySetInnerHTML: { __html: description }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__Description_scss___default.a.description },
            canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
                {
                  desktop: __WEBPACK_IMPORTED_MODULE_3__DescriptionEditDesktop__["a" /* default */],
                  mobile: __WEBPACK_IMPORTED_MODULE_4__DescriptionEditMobile__["a" /* default */],
                  onChange: descriptionChangeHandler,
                  commitUpdate: updateDescription,
                  reset: reset,
                  value: localDescription
                },
                DescriptionShow
              ),
              !description && !addingNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_5__Description_scss___default.a.placeholder,
                  onClick: _this2.addNew,
                  onMouseOver: function onMouseOver() {
                    return _this2.setState({ selected: true });
                  },
                  onMouseOut: function onMouseOut() {
                    return _this2.setState({ selected: false });
                  }
                },
                selected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { className: __WEBPACK_IMPORTED_MODULE_5__Description_scss___default.a.editIcon, name: 'write' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'em',
                  null,
                  'Add a description, message, or instructions...'
                )
              ),
              !description && addingNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DescriptionEditMobile__["a" /* default */], {
                  onChange: descriptionChangeHandler,
                  commitUpdate: updateDescription,
                  reset: reset,
                  closeHandler: _this2.closeNew,
                  value: localDescription,
                  open: addingNew
                }),
                !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DescriptionEditDesktop__["a" /* default */], {
                  onChange: descriptionChangeHandler,
                  commitUpdate: updateDescription,
                  reset: reset,
                  closeHandler: _this2.closeNew,
                  value: localDescription
                })
              )
            ),
            !canEdit && DescriptionShow
          );
        }
      );
    }
  }]);

  return DescriptionComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DescriptionComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  localDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  descriptionChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DescriptionComponent);

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_number_format__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LibraryItemEditDesktop = function (_React$Component) {
  _inherits(LibraryItemEditDesktop, _React$Component);

  function LibraryItemEditDesktop(props) {
    _classCallCheck(this, LibraryItemEditDesktop);

    var _this = _possibleConstructorReturn(this, (LibraryItemEditDesktop.__proto__ || Object.getPrototypeOf(LibraryItemEditDesktop)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.priceFieldChange = _this.priceFieldChange.bind(_this);
    _this.addToLibraryChange = _this.addToLibraryChange.bind(_this);
    _this.descriptionFieldChange = _this.descriptionFieldChange.bind(_this);
    return _this;
  }

  _createClass(LibraryItemEditDesktop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.refs.service.scrollIntoViewIfNeeded) this.refs.service.scrollIntoViewIfNeeded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.setState(function () {
        return { submitted: true };
      });
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.props.commitUpdate(this.props.index, function () {
        return _this2.props.closeHandler();
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add service',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate(e) {
      var _this3 = this;

      e.preventDefault();
      e.stopPropagation();
      this.setState({ submitted: true });
      if (!this.props.isNew) {
        this.props.commitUpdate(this.props.index, function () {
          return _this3.props.closeHandler();
        });
      }
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset(this.props.index);
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this4 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this4.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localService, newValue));
    }
  }, {
    key: 'priceFieldChange',
    value: function priceFieldChange(e) {
      this.fieldChange('price_cents', e.target.value * 100);
    }
  }, {
    key: 'descriptionFieldChange',
    value: function descriptionFieldChange(value) {
      this.fieldChange('description', value);
    }
  }, {
    key: 'addToLibraryChange',
    value: function addToLibraryChange(e, data) {
      this.fieldChange('addToLibrary', data.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var service = this.props.localService;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
        {
          className: 'ui form',
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          onSubmit: this.onSubmit
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { ref: 'service' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
            {
              fluid: true,
              style: {
                background: 'transparent',
                boxShadow: 'none',
                userSelect: 'none'
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                { style: { marginTop: 0 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  { style: { paddingBottom: 0 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { computer: 8, tablet: 8, mobile: 16 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                      fluid: true,
                      rows: 1,
                      placeholder: 'Service name',
                      value: service.title || '',
                      onChange: this.textFieldChange,
                      name: 'title',
                      label: 'Service name',
                      submitted: this.state.submitted,
                      className: 'strong',
                      required: true,
                      validationError: 'Service name is required'
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 3, only: 'computer tablet' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */],
                      {
                        name: 'price_cents',
                        type: 'currency',
                        placeholder: '$500.00',
                        value: service.price_cents ? service.price_cents / 100 : '',
                        onChange: this.priceFieldChange,
                        submitted: this.state.submitted,
                        required: true,
                        label: 'Price',
                        validationError: 'Price is required',
                        className: 'textAlignRight'
                      },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_number_format___default.a, {
                        thousandSeparator: true,
                        prefix: '$',
                        decimalScale: 2,
                        fixedDecimalScale: true
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 2, only: 'computer tablet' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                      name: 'quantity',
                      label: 'Qty',
                      type: 'number',
                      placeholder: '1',
                      value: service.quantity,
                      onChange: this.textFieldChange,
                      submitted: this.state.submitted,
                      className: 'textAlignRight'
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      width: 3,
                      textAlign: 'right',
                      only: 'computer tablet'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      { style: { paddingTop: '0.5em' } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'strong',
                        null,
                        'Total'
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format((service.quantity || 1) * (service.price_cents || 0) / 100, {
                        code: service.price_currency
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  { style: { paddingTop: 0 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["l" /* TextEditor */], {
                      onChange: this.descriptionFieldChange,
                      value: service.description || '',
                      placeholder: 'Short description of item'
                    }),
                    this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
                        label: 'Save to library for future use',
                        checked: service.addToLibrary,
                        onChange: this.addToLibraryChange,
                        name: 'saveToLibrary',
                        submitted: this.state.submitted
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], {
                id: this.props.service.id,
                reset: this.props.reset ? this.reset : undefined,
                'delete': this.props.delete ? this.delete : undefined,
                isNew: this.props.isNew
              })
            )
          )
        )
      );
    }
  }]);

  return LibraryItemEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LibraryItemEditDesktop.propTypes = {
  localService: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  service: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LibraryItemEditDesktop);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_currency_formatter__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LibraryItemEditMobile = function (_React$Component) {
  _inherits(LibraryItemEditMobile, _React$Component);

  function LibraryItemEditMobile(props) {
    _classCallCheck(this, LibraryItemEditMobile);

    var _this = _possibleConstructorReturn(this, (LibraryItemEditMobile.__proto__ || Object.getPrototypeOf(LibraryItemEditMobile)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.priceFieldChange = _this.priceFieldChange.bind(_this);
    _this.addToLibraryChange = _this.addToLibraryChange.bind(_this);
    _this.descriptionFieldChange = _this.descriptionFieldChange.bind(_this);
    return _this;
  }

  _createClass(LibraryItemEditMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.setState(function () {
        return { submitted: true };
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add service',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.props.commitUpdate(this.props.index, function () {
        return _this2.props.closeHandler();
      });
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate() {
      var _this3 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        setTimeout(function () {
          return _this3.props.closeHandler();
        }, 0);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      this.props.reset(this.props.index);
      setTimeout(function () {
        return _this4.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this5 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this5.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localService, newValue));
    }
  }, {
    key: 'priceFieldChange',
    value: function priceFieldChange(e) {
      this.fieldChange('price_cents', e.target.value * 100);
    }
  }, {
    key: 'descriptionFieldChange',
    value: function descriptionFieldChange(value) {
      this.fieldChange('description', value);
    }
  }, {
    key: 'addToLibraryChange',
    value: function addToLibraryChange(e, data) {
      this.fieldChange('addToLibrary', data.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var service = this.props.localService;
      var deleteButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
        { negative: true, fluid: true, type: 'button' },
        'Delete Item'
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
        {
          className: 'ui form',
          ref: 'form',
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          onSubmit: this.onSubmit
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this6.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              fluid: true,
              rows: 1,
              value: service.title || '',
              onChange: this.textFieldChange,
              name: 'title',
              label: 'Service name',
              submitted: this.state.submitted,
              className: 'strong',
              required: true,
              autoHeight: true,
              validationError: 'Service name is required'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["l" /* TextEditor */], {
              onChange: this.descriptionFieldChange,
              value: service.description || '',
              placeholder: 'Short description of item',
              label: 'Description'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */],
              {
                name: 'price_cents',
                type: 'currency',
                label: 'Price',
                placeholder: '$500.00',
                value: service.price_cents ? service.price_cents / 100 : '',
                onChange: this.priceFieldChange,
                submitted: this.state.submitted,
                required: true,
                validationError: 'Price is required'
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a, {
                thousandSeparator: true,
                prefix: '$',
                decimalScale: 2,
                fixedDecimalScale: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              name: 'quantity',
              type: 'number',
              label: 'Quantity',
              placeholder: '1',
              value: service.quantity,
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
              label: 'Save for future use',
              checked: service.addToLibrary,
              onChange: this.addToLibraryChange,
              name: 'saveToLibrary',
              submitted: this.state.submitted
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                'Total:'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { marginLeft: '1em' } },
                __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format((service.quantity || 1) * (service.price_cents || 0) / 100, {
                  code: service.price_currency
                })
              )
            ),
            this.props.delete && !this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { flex: 1 } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: 'center', marginTop: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["i" /* DeleteConfirmation */], {
                  trigger: deleteButton,
                  'delete': this.delete,
                  id: this.props.service.id
                })
              )
            )
          )
        )
      );
    }
  }]);

  return LibraryItemEditMobile;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LibraryItemEditMobile.propTypes = {
  localService: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  service: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LibraryItemEditMobile);

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Proposal_scss__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Proposal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_currency_formatter__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ServiceShow = function (_React$Component) {
  _inherits(ServiceShow, _React$Component);

  function ServiceShow() {
    _classCallCheck(this, ServiceShow);

    return _possibleConstructorReturn(this, (ServiceShow.__proto__ || Object.getPrototypeOf(ServiceShow)).apply(this, arguments));
  }

  _createClass(ServiceShow, [{
    key: 'render',
    value: function render() {
      var service = this.props.service;
      var quantity = service.quantity || 1;
      var price = (service.price_cents || 0) / 100;
      var cardStyles = { background: 'transparent' };
      if (!this.props.readOnly) cardStyles.userSelect = 'none';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
        {
          link: !this.props.readOnly,
          fluid: true,
          style: cardStyles,
          className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.noShadow
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
          { style: { paddingLeft: 0, marginLeft: '1em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'strong',
                  null,
                  service.title
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
                  className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.description,
                  dangerouslySetInnerHTML: { __html: service.description }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.itemTotalMobile },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { float: 'left' }, className: __WEBPACK_IMPORTED_MODULE_3__Proposal_scss___default.a.qtyPrice },
                    '(',
                    quantity,
                    ' @ \xA0',
                    __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(price, { code: service.price_currency }),
                    ')'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { float: 'right' } },
                    __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(quantity * price, {
                      code: service.price_currency
                    }),
                    ' '
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ServiceShow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ServiceShow.propTypes = {
  service: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ServiceShow);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_currency_formatter__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LineItemEditMobile = function (_React$Component) {
  _inherits(LineItemEditMobile, _React$Component);

  function LineItemEditMobile(props) {
    _classCallCheck(this, LineItemEditMobile);

    var _this = _possibleConstructorReturn(this, (LineItemEditMobile.__proto__ || Object.getPrototypeOf(LineItemEditMobile)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.priceFieldChange = _this.priceFieldChange.bind(_this);
    _this.descriptionFieldChange = _this.descriptionFieldChange.bind(_this);
    return _this;
  }

  _createClass(LineItemEditMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(data, reset, invalidateForm) {
      var _this2 = this;

      this.setState({ submitted: true });
      if (new Date(data.ends_at) < new Date(data.starts_at)) {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        invalidateForm({ ends_at: 'Event must end later than it starts' });
      } else {
        this.props.commitUpdate(this.props.index, function () {
          return _this2.props.closeHandler();
        });
      }
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate() {
      var _this3 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        setTimeout(function () {
          return _this3.props.closeHandler();
        }, 0);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      this.props.reset(this.props.index);
      setTimeout(function () {
        return _this4.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this5 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this5.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localService, newValue));
    }
  }, {
    key: 'priceFieldChange',
    value: function priceFieldChange(e) {
      this.fieldChange('price_cents', e.target.value * 100);
    }
  }, {
    key: 'descriptionFieldChange',
    value: function descriptionFieldChange(value) {
      this.fieldChange('description', value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var service = this.props.localService;
      var deleteButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
        { negative: true, fluid: true, type: 'button' },
        'Delete Item'
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
        { className: 'ui form', ref: 'form', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this6.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              fluid: true,
              rows: 1,
              value: service.title || '',
              onChange: this.textFieldChange,
              name: 'title',
              label: 'Service name',
              submitted: this.state.submitted,
              className: 'strong',
              required: true,
              autoHeight: true,
              validationError: 'Service name is required'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["l" /* TextEditor */], {
              onChange: this.descriptionFieldChange,
              value: service.description || '',
              placeholder: 'Short description of item',
              label: 'Description'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */],
              {
                name: 'price_cents',
                type: 'currency',
                label: 'Price',
                placeholder: '$500.00',
                value: service.price_cents ? service.price_cents / 100 : '',
                onChange: this.priceFieldChange,
                submitted: this.state.submitted,
                required: true,
                validationError: 'Price is required'
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a, {
                thousandSeparator: true,
                prefix: '$',
                decimalScale: 2,
                fixedDecimalScale: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              name: 'quantity',
              type: 'number',
              label: 'Quantity',
              placeholder: '1',
              value: service.quantity,
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                'Total:'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { marginLeft: '1em' } },
                __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format((service.quantity || 1) * (service.price_cents || 0) / 100, {
                  code: service.price_currency
                })
              )
            ),
            this.props.delete && !this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { flex: 1 } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: 'center', marginTop: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["i" /* DeleteConfirmation */], {
                  trigger: deleteButton,
                  'delete': this.delete,
                  id: service.id
                })
              )
            )
          )
        )
      );
    }
  }]);

  return LineItemEditMobile;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LineItemEditMobile.propTypes = {
  localService: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemEditMobile);

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notepad_scss__ = __webpack_require__(3610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notepad_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Notepad_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Notepad = function (_Component) {
  _inherits(Notepad, _Component);

  function Notepad(props) {
    _classCallCheck(this, Notepad);

    var _this = _possibleConstructorReturn(this, (Notepad.__proto__ || Object.getPrototypeOf(Notepad)).call(this, props));

    _this.state = {
      notes: _this.props.notes
    };
    _this.notesChangeHandler = _this.notesChangeHandler.bind(_this);
    return _this;
  }

  _createClass(Notepad, [{
    key: 'notesChangeHandler',
    value: function notesChangeHandler(e) {
      this.setState({ notes: e.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var notes = this.state.notes;
      var update = this.props.update;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { className: 'ui form field ' + __WEBPACK_IMPORTED_MODULE_4__Notepad_scss___default.a.notepad },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Elements__["i" /* TextArea */], {
          name: 'notes',
          rows: 12,
          onBlur: function onBlur() {
            return update(notes);
          },
          onChange: this.notesChangeHandler,
          value: notes || ''
        })
      );
    }
  }]);

  return Notepad;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Notepad.propTypes = {
  terms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  notes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Notepad);

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentPlan_scss__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentPlan_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PaymentPlan_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownPayment__ = __webpack_require__(3119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SummaryTotals__ = __webpack_require__(3125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PaymentPlanItems__ = __webpack_require__(3123);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PaymentPlanFields = function (_React$Component) {
  _inherits(PaymentPlanFields, _React$Component);

  function PaymentPlanFields(props) {
    _classCallCheck(this, PaymentPlanFields);

    var _this = _possibleConstructorReturn(this, (PaymentPlanFields.__proto__ || Object.getPrototypeOf(PaymentPlanFields)).call(this, props));

    _this.state = {
      window: { width: 0, height: 0 }
    };
    _this.onPaymentTypeChange = _this.onPaymentTypeChange.bind(_this);
    _this.onIPPlanItemChange = _this.onIPPlanItemChange.bind(_this);
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.dateFieldChange = _this.dateFieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.numberFieldChange = _this.numberFieldChange.bind(_this);
    _this.currencyFieldChange = _this.currencyFieldChange.bind(_this);
    _this.generateId = _this.generateId.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);

    var paymentType = function () {
      if (_this.props.invoice.down_payment_distribution_type) {
        return 'multiple';
      }
      return _this.props.invoice.i_pplan_items.edges.length === 1 ? 'full' : null;
    }();

    _this.state = {
      paymentType: paymentType
    };
    return _this;
  }

  _createClass(PaymentPlanFields, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onPaymentTypeChange',
    value: function onPaymentTypeChange(e, data) {
      var invoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.invoice);
      if (data.value === 'full') {
        this.setState({ paymentType: 'full' });
        invoice.down_payment_cents = null;
        invoice.down_payment_currency = null;
        invoice.down_payment_distribution_type = null;
        invoice.down_payment_due_at = null;
        invoice.down_payment_percent = null;
        invoice.pplan_distribution_type = 'FIXED';
        invoice.delete_pplan_items_with_ids = invoice.i_pplan_items.edges.map(function (item) {
          return item.node.id;
        });
        invoice.i_pplan_items = {
          edges: [{
            node: {
              amount_cents: this.props.invoice.total_cents,
              amount_currency: 'USD',
              due_at: null,
              locked: false,
              percent: null,
              tempId: this.generateId()
            }
          }]
        };
      } else {
        this.setState({ paymentType: 'multiple' });
        invoice.down_payment_cents = null;
        invoice.down_payment_currency = 'USD';
        invoice.down_payment_distribution_type = 'FIXED';
        invoice.down_payment_due_at = null;
        invoice.down_payment_percent = null;
        invoice.pplan_distribution_type = 'FIXED';
        invoice.i_pplan_items = invoice.i_pplan_items.edges.length === 0 ? {
          edges: [{
            node: {
              amount_cents: null,
              amount_currency: 'USD',
              due_at: null,
              locked: false,
              percent: null,
              tempId: this.generateId()
            }
          }]
        } : invoice.i_pplan_items;
      }
      this.props.onChange(invoice);
    }
  }, {
    key: 'onIPPlanItemChange',
    value: function onIPPlanItemChange(e, idx) {
      var localInvoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localInvoice);
      localInvoice.i_pplan_items.edges[idx].node[e.target.name] = e.target.value;
      this.props.onChange(localInvoice);
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localInvoice, newValue));
    }
  }, {
    key: 'dateFieldChange',
    value: function dateFieldChange(e) {
      this.fieldChange(e.target.name, __WEBPACK_IMPORTED_MODULE_10_moment___default()(e.target.value).toISOString());
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'numberFieldChange',
    value: function numberFieldChange(e) {
      this.fieldChange(e.target.name, parseInt(e.target.value, 10));
    }
  }, {
    key: 'currencyFieldChange',
    value: function currencyFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value * 100);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var localInvoice = this.props.localInvoice;

      var DateInput = this.state.window.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint ? __WEBPACK_IMPORTED_MODULE_3__Elements__["s" /* FloatingLabelDateTime */] : __WEBPACK_IMPORTED_MODULE_3__Elements__["t" /* FloatingLabelDateTimePicker */];

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
        { padded: true, relaxed: true, stackable: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 1 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { style: { paddingLeft: '2em', paddingRight: '2em' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h3',
              null,
              'How would you like to collect payment?'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                radio: true,
                checked: this.state.paymentType === 'full',
                onChange: this.onPaymentTypeChange,
                value: 'full',
                label: 'Payment In Full',
                className: __WEBPACK_IMPORTED_MODULE_6__PaymentPlan_scss___default.a.checkbox
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              this.state.paymentType === 'full' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  {
                    style: {
                      display: 'inline-block',
                      marginTop: '1.75em'
                    }
                  },
                  'A full payment of',
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'strong',
                    null,
                    __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format((this.props.invoice.total_cents || 0) / 100, {
                      code: 'USD'
                    })
                  ),
                  '\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  {
                    style: {
                      display: 'inline-block',
                      marginTop: '1.75em',
                      marginRight: '0.5em'
                    }
                  },
                  'is due on'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DateInput, {
                  dateOnly: true,
                  value: localInvoice.i_pplan_items.edges.length > 0 && localInvoice.i_pplan_items.edges[0].node.due_at || '',
                  onChange: function onChange(e) {
                    return _this2.onIPPlanItemChange(e, 0);
                  },
                  name: 'due_at',
                  datePlaceholder: 'Date',
                  placeholder: 'Date',
                  label: '',
                  required: true,
                  validationError: 'Required',
                  style: {
                    marginTop: '1.25em'
                  },
                  inline: true,
                  viewer: null,
                  submitted: this.props.submitted
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                radio: true,
                checked: this.state.paymentType === 'multiple',
                onChange: this.onPaymentTypeChange,
                value: 'multiple',
                label: 'Multiple Payments',
                className: __WEBPACK_IMPORTED_MODULE_6__PaymentPlan_scss___default.a.checkbox
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 1 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { style: { paddingLeft: '2em', paddingRight: '2em' } },
            this.state.paymentType === 'multiple' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Down Payment'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DownPayment__["a" /* default */], {
                localInvoice: localInvoice,
                dateFieldChange: this.dateFieldChange,
                submitted: this.props.submitted,
                currencyFieldChange: this.currencyFieldChange,
                numberFieldChange: this.numberFieldChange,
                textFieldChange: this.textFieldChange,
                DateInput: DateInput
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Additional Payments'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PaymentPlanItems__["a" /* default */], {
                localInvoice: localInvoice,
                onChange: this.props.onChange,
                onIPPlanItemChange: this.onIPPlanItemChange,
                DateInput: DateInput,
                submitted: this.props.submitted
              }),
              this.props.submitted && this.props.getRemainingBalance() !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["B" /* Message */],
                { negative: true },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["B" /* Message */].Header,
                  null,
                  'Remaining balance must be zero'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'The down payment and additional payments must add up to the invoice total'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SummaryTotals__["a" /* default */], {
                localInvoice: this.props.localInvoice,
                getDownPayment: this.props.getDownPayment,
                getAdditionalPayments: this.props.getAdditionalPayments,
                getRemainingBalance: this.props.getRemainingBalance
              })
            )
          )
        )
      );
    }
  }]);

  return PaymentPlanFields;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PaymentPlanFields.propTypes = {
  invoice: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  closeEditor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  getRemainingBalance: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getAdditionalPayments: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getDownPayment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentPlanFields);

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientEditDesktop__ = __webpack_require__(3126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecipientEditMobile__ = __webpack_require__(3127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecipientShow__ = __webpack_require__(3128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);







var RecipientComponent = function RecipientComponent(_ref) {
  var canEdit = _ref.canEdit,
      localRecipient = _ref.localRecipient,
      onChange = _ref.onChange,
      resetRecipient = _ref.resetRecipient,
      recipient = _ref.recipient,
      updateRecipient = _ref.updateRecipient;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Modules__["k" /* Dthc */],
      {
        desktop: __WEBPACK_IMPORTED_MODULE_2__RecipientEditDesktop__["a" /* default */],
        mobile: __WEBPACK_IMPORTED_MODULE_3__RecipientEditMobile__["a" /* default */],
        reset: resetRecipient,
        onChange: onChange,
        commitUpdate: updateRecipient,
        localRecipient: localRecipient
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RecipientShow__["a" /* default */], { recipient: recipient })
    ),
    !canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RecipientShow__["a" /* default */], { recipient: recipient, readOnly: true })
  );
};

RecipientComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  localRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  resetRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  recipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  updateRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecipientComponent);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(690);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RecipientFields = function (_React$Component) {
  _inherits(RecipientFields, _React$Component);

  function RecipientFields(props) {
    _classCallCheck(this, RecipientFields);

    var _this = _possibleConstructorReturn(this, (RecipientFields.__proto__ || Object.getPrototypeOf(RecipientFields)).call(this, props));

    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    return _this;
  }

  _createClass(RecipientFields, [{
    key: 'textFieldChange',
    value: function textFieldChange(_ref) {
      var _ref$target = _ref.target,
          name = _ref$target.name,
          value = _ref$target.value;

      this.fieldChange(name, value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign({}, this.props.localRecipient, newValue));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          recipient = _props.localRecipient,
          submitted = _props.submitted;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { textAlign: 'left' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          label: 'First Name',
          name: 'recipient_first_name',
          placeholder: 'Jane',
          inline: true,
          validationError: 'First name is required',
          value: recipient.recipient_first_name || '',
          onChange: this.textFieldChange,
          submitted: submitted,
          width: '50%'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          label: 'Last Name',
          name: 'recipient_last_name',
          placeholder: 'Smith',
          inline: 'last',
          value: recipient.recipient_last_name || '',
          onChange: this.textFieldChange,
          submitted: submitted,
          width: '50%'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          label: 'Company Name',
          name: 'recipient_company_name',
          placeholder: 'Acme, Inc.',
          value: recipient.recipient_company_name || '',
          onChange: this.textFieldChange,
          submitted: submitted
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */],
          {
            label: 'Phone Number',
            type: 'tel',
            name: 'recipient_phone',
            placeholder: '(555) 555-1212',
            onChange: this.textFieldChange,
            value: recipient.recipient_phone || '',
            submitted: submitted
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__["a" /* default */], {
            mask: '(999) 999-9999',
            value: recipient.recipient_phone || ''
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          label: 'Email',
          type: 'email',
          name: 'recipient_email',
          validations: 'isEmail',
          validationError: 'Email address is invalid',
          placeholder: 'email@example.com',
          value: recipient.recipient_email || '',
          onChange: this.textFieldChange,
          submitted: submitted
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          autoHeight: true,
          rows: 2,
          label: 'Billing Address',
          type: 'address',
          name: 'recipient_address',
          placeholder: '123 Elm St.\nSan Francisco, CA 94105',
          value: recipient.recipient_address || '',
          onChange: this.textFieldChange,
          submitted: submitted
        })
      );
    }
  }]);

  return RecipientFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RecipientFields.propTypes = {
  localRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RecipientFields);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SignatureBlockFields = function (_React$Component) {
  _inherits(SignatureBlockFields, _React$Component);

  function SignatureBlockFields(props) {
    _classCallCheck(this, SignatureBlockFields);

    var _this = _possibleConstructorReturn(this, (SignatureBlockFields.__proto__ || Object.getPrototypeOf(SignatureBlockFields)).call(this, props));

    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.isVisible = _this.isVisible.bind(_this);
    _this.setVisibility = _this.setVisibility.bind(_this);
    _this.checkboxChange = _this.checkboxChange.bind(_this);
    _this.selectField = _this.selectField.bind(_this);
    return _this;
  }

  _createClass(SignatureBlockFields, [{
    key: 'setVisibility',
    value: function setVisibility(field, visibility) {
      this.fieldChange(field + '_visibility', visibility === true ? 'SHOW' : 'HIDE');
      this.fieldChange(field, null);
    }
  }, {
    key: 'isVisible',
    value: function isVisible(visibility) {
      return visibility === 'SHOW';
    }
  }, {
    key: 'checkboxChange',
    value: function checkboxChange(e, data) {
      this.fieldChange(data.name, data.checked);
    }
  }, {
    key: 'selectField',
    value: function selectField(e, data) {
      this.setVisibility(data.name, data.checked);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localSignatureBlock, newValue));
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var localSignatureBlock = this.props.localSignatureBlock;

      var signingPartyHelp = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'help circle', className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.helpIcon });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
            label: 'Signing Party',
            name: 'signing_party',
            placeholder: '(Eg. Client)',
            required: true,
            validationError: 'Signing party is required',
            value: localSignatureBlock.signing_party || '',
            onChange: this.textFieldChange,
            submitted: this.props.submitted,
            width: '100%'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Popup */], {
            trigger: signingPartyHelp,
            on: 'hover',
            position: 'right center',
            inverted: true,
            content: 'This value should correspond to the party defined in your contract terms (E.g. Client or Purchaser)'
          })
        ),
        this.props.isTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Please select the information you would like the signing party to provide:'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.name_visibility),
            content: 'Name',
            onChange: this.selectField,
            name: 'name'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.email_visibility),
            content: 'Email',
            onChange: this.selectField,
            name: 'email'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.phone_visibility),
            content: 'Phone Number',
            onChange: this.selectField,
            name: 'phone'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.company_name_visibility),
            content: 'Company Name',
            onChange: this.selectField,
            name: 'company_name'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.title_visibility),
            content: 'Title',
            onChange: this.selectField,
            name: 'title'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
            cardBorder: true,
            checkbox: true,
            checked: this.isVisible(localSignatureBlock.address_visibility),
            content: 'Address',
            onChange: this.selectField,
            name: 'address'
          })
        ),
        !this.props.isTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.isVisible(localSignatureBlock.name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Name',
              name: 'name',
              required: this.isVisible(localSignatureBlock.name_visibility) && !localSignatureBlock.signer_fills_fields,
              validationError: 'Name is required',
              value: localSignatureBlock.name || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'name', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.setVisibility.bind(null, 'name', true) },
              '+ Add Name'
            )
          ),
          this.isVisible(localSignatureBlock.title_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Title',
              name: 'title',
              required: this.isVisible(localSignatureBlock.title_visibility) && !localSignatureBlock.signer_fills_fields,
              validationError: 'Title is required',
              value: localSignatureBlock.title || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'title', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.title_visibility) && this.isVisible(localSignatureBlock.company_name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.setVisibility.bind(null, 'title', true) },
              '+ Add Title'
            )
          ),
          this.isVisible(localSignatureBlock.company_name_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Company Name',
              name: 'company_name',
              required: this.isVisible(localSignatureBlock.company_name_visibility) && !localSignatureBlock.signer_fills_fields,
              validationError: 'Company name is required',
              value: localSignatureBlock.company_name || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'company_name', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.company_name_visibility) && this.isVisible(localSignatureBlock.title_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: this.setVisibility.bind(null, 'company_name', true)
              },
              '+ Add Company Name'
            )
          ),
          !this.isVisible(localSignatureBlock.company_name_visibility) && !this.isVisible(localSignatureBlock.title_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  _this2.setVisibility('company_name', true);
                  _this2.setVisibility('title', true);
                }
              },
              '+ Add Title and Company Name'
            )
          ),
          this.isVisible(localSignatureBlock.email_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Email Address',
              name: 'email',
              required: this.isVisible(localSignatureBlock.email_visibility) && !localSignatureBlock.signer_fills_fields,
              validations: 'isEmail',
              validationError: 'Must be valid email address',
              value: localSignatureBlock.email || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'email', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.email_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.setVisibility.bind(null, 'email', true) },
              '+ Add Email Address'
            )
          ),
          this.isVisible(localSignatureBlock.phone_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Phone Number',
              name: 'phone',
              required: this.isVisible(localSignatureBlock.phone_visibility) && !localSignatureBlock.signer_fills_fields,
              validationError: 'Phone number is required',
              value: localSignatureBlock.phone || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'phone', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.phone_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.setVisibility.bind(null, 'phone', true) },
              '+ Add Phone Number'
            )
          ),
          this.isVisible(localSignatureBlock.address_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.optional },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              label: 'Address',
              name: 'address',
              autoHeight: true,
              required: this.isVisible(localSignatureBlock.address_visibility) && !localSignatureBlock.signer_fills_fields,
              validationError: 'Address is required',
              value: localSignatureBlock.address || '',
              onChange: this.textFieldChange,
              submitted: this.props.submitted,
              width: '100%'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.delete,
                onClick: this.setVisibility.bind(null, 'address', false)
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          ),
          !this.isVisible(localSignatureBlock.address_visibility) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.setVisibility.bind(null, 'address', true) },
              '+ Add Address'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], {
            label: 'Allow signing party to update their contact information',
            onChange: this.checkboxChange,
            name: 'signer_fills_fields',
            checked: localSignatureBlock.signer_fills_fields
          })
        )
      );
    }
  }]);

  return SignatureBlockFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SignatureBlockFields.propTypes = {
  isTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  localSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (SignatureBlockFields);

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss__);


/* harmony default export */ __webpack_exports__["a"] = (function (signature) {
  var length = signature.length;

  if (length > 12 && length < 18) {
    return __WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss___default.a.signatureSmall;
  }
  if (length >= 18) {
    return __WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss___default.a.signatureTiny;
  }
  return __WEBPACK_IMPORTED_MODULE_0__SignatureBlocks_scss___default.a.signatureLarge;
});

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureBlockShow__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SignatureBlockEditDesktop__ = __webpack_require__(3129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SignatureBlockEditMobile__ = __webpack_require__(3130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__);









var SignatureBlocks = function SignatureBlocks(_ref) {
  var addSignatureBlock = _ref.addSignatureBlock,
      deleteBlock = _ref.deleteBlock,
      closeNewSignatureBlockEditor = _ref.closeNewSignatureBlockEditor,
      createSignatureBlock = _ref.createSignatureBlock,
      editingNewSignatureBlock = _ref.editingNewSignatureBlock,
      isTemplate = _ref.isTemplate,
      localSignatureBlocks = _ref.localSignatureBlocks,
      newSignatureBlock = _ref.newSignatureBlock,
      newSignatureBlockChangeHandler = _ref.newSignatureBlockChangeHandler,
      _onChange = _ref.onChange,
      openSignModal = _ref.openSignModal,
      readOnly = _ref.readOnly,
      reset = _ref.reset,
      resetAddSignatureBlock = _ref.resetAddSignatureBlock,
      signatureBlocks = _ref.signatureBlocks,
      signer = _ref.signer,
      update = _ref.update;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    signatureBlocks.length === 0 && !newSignatureBlock && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { textAlign: 'center', padding: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        null,
        'This contract requires no signatures'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
        { primary: true, onClick: addSignatureBlock },
        '+ Add Signature Block'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
      { stackable: true },
      readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 2 },
        signatureBlocks.map(function (signatureBlock, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            { style: { paddingBottom: '2em' }, key: signatureBlock.node.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SignatureBlockShow__["a" /* default */], {
              key: signatureBlock.id || idx,
              signatureBlock: signatureBlock,
              isSigner: signer && signer.id === signatureBlock.node.id,
              openSignModal: openSignModal
            })
          );
        })
      ),
      !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 2 },
        signatureBlocks.map(function (signatureBlock, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            { style: { paddingBottom: '2em' }, key: signatureBlock.node.id || idx },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
              {
                localSignatureBlock: localSignatureBlocks[idx].node,
                onChange: function onChange(block) {
                  _onChange(block, idx);
                },
                commitUpdate: update,
                desktop: __WEBPACK_IMPORTED_MODULE_5__SignatureBlockEditDesktop__["a" /* default */],
                mobile: __WEBPACK_IMPORTED_MODULE_6__SignatureBlockEditMobile__["a" /* default */],
                reset: reset,
                'delete': deleteBlock,
                index: idx,
                isTemplate: isTemplate
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SignatureBlockShow__["a" /* default */], {
                signatureBlock: signatureBlock,
                isTemplate: isTemplate
              })
            )
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          { style: { paddingBottom: '2em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 300
            },
            newSignatureBlock && editingNewSignatureBlock && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
              {
                localSignatureBlock: newSignatureBlock.node,
                onChange: function onChange(block) {
                  newSignatureBlockChangeHandler(block);
                },
                commitUpdate: createSignatureBlock,
                desktop: __WEBPACK_IMPORTED_MODULE_5__SignatureBlockEditDesktop__["a" /* default */],
                mobile: __WEBPACK_IMPORTED_MODULE_6__SignatureBlockEditMobile__["a" /* default */],
                reset: resetAddSignatureBlock,
                isNew: true,
                initiallyOpen: true,
                'delete': resetAddSignatureBlock,
                closeEditor: closeNewSignatureBlockEditor,
                editorOpen: editingNewSignatureBlock,
                isTemplate: isTemplate
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 'equal' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          null,
          signatureBlocks.length > 0 && !editingNewSignatureBlock && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { onClick: addSignatureBlock },
            '+ Add Signature Block'
          )
        )
      )
    )
  );
};

SignatureBlocks.propTypes = {
  addSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeNewSignatureBlockEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  createSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editingNewSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  localSignatureBlocks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  newSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  newSignatureBlockChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openSignModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetAddSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  signatureBlocks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  signer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SignatureBlocks);

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsEditDesktop__ = __webpack_require__(3131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TermsEditMobile__ = __webpack_require__(3132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Terms_scss__ = __webpack_require__(3612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Terms_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Terms_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TermsBuilder_TermsBuilder__ = __webpack_require__(3141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TermsComponent = function (_React$Component) {
  _inherits(TermsComponent, _React$Component);

  function TermsComponent(props) {
    _classCallCheck(this, TermsComponent);

    var _this = _possibleConstructorReturn(this, (TermsComponent.__proto__ || Object.getPrototypeOf(TermsComponent)).call(this, props));

    _this.state = {
      addingNew: false
    };
    _this.addNew = _this.addNew.bind(_this);
    _this.closeNew = _this.closeNew.bind(_this);
    return _this;
  }

  _createClass(TermsComponent, [{
    key: 'addNew',
    value: function addNew() {
      this.setState({ addingNew: true });
    }
  }, {
    key: 'closeNew',
    value: function closeNew() {
      this.setState({ addingNew: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canEdit = _props.canEdit,
          localTerms = _props.localTerms,
          reset = _props.reset,
          terms = _props.terms,
          termsChangeHandler = _props.termsChangeHandler,
          updateTerms = _props.updateTerms,
          builderSaveTerms = _props.builderSaveTerms;
      var addingNew = this.state.addingNew;

      var TermsShow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: { padding: '1em', wordBreak: 'break-word' },
        dangerouslySetInnerHTML: { __html: terms }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__Terms_scss___default.a.terms },
            canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              terms && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
                {
                  desktop: __WEBPACK_IMPORTED_MODULE_3__TermsEditDesktop__["a" /* default */],
                  mobile: __WEBPACK_IMPORTED_MODULE_4__TermsEditMobile__["a" /* default */],
                  onChange: termsChangeHandler,
                  commitUpdate: updateTerms,
                  reset: reset,
                  value: localTerms
                },
                TermsShow
              ),
              !terms && !addingNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */],
                { columns: 2, relaxed: 'very', stackable: true, divided: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Need a contract?'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TermsBuilder_TermsBuilder__["a" /* default */], {
                    save: builderSaveTerms,
                    trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */], { primary: true, content: '+ Generate Terms' })
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Generate a legally-binding, lawyer-approved contract in minutes. Customized to your business. Valid in your state.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Already have a contract?'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */], { basic: true, onClick: _this2.addNew, content: '+ Add Terms' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Paste your own contract terms and edit them right within Cloverbook.'
                  )
                )
              ),
              !terms && addingNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TermsEditMobile__["a" /* default */], {
                  onChange: termsChangeHandler,
                  commitUpdate: updateTerms,
                  reset: reset,
                  closeHandler: _this2.closeNew,
                  value: localTerms,
                  open: addingNew
                }),
                !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TermsEditDesktop__["a" /* default */], {
                  onChange: termsChangeHandler,
                  commitUpdate: updateTerms,
                  reset: reset,
                  closeHandler: _this2.closeNew,
                  value: localTerms
                })
              )
            ),
            !canEdit && TermsShow
          );
        }
      );
    }
  }]);

  return TermsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TermsComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  localTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  terms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  termsChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  builderSaveTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (TermsComponent);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_SearchContainer__ = __webpack_require__(527);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ContractTemplateActions = function (_React$Component) {
  _inherits(ContractTemplateActions, _React$Component);

  function ContractTemplateActions(props) {
    _classCallCheck(this, ContractTemplateActions);

    var _this = _possibleConstructorReturn(this, (ContractTemplateActions.__proto__ || Object.getPrototypeOf(ContractTemplateActions)).call(this, props));

    _this.state = {
      alreadySignedModalOpen: false,
      deleteModalOpen: false,
      useTemplateModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.closeUseTemplateModal = _this.closeUseTemplateModal.bind(_this);
    _this.openUseTemplateModal = _this.openUseTemplateModal.bind(_this);
    _this.deleteTemplate = _this.deleteTemplate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateActions, [{
    key: 'deleteTemplate',
    value: function deleteTemplate() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/templates');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-contract-template');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3155);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'openUseTemplateModal',
    value: function openUseTemplateModal() {
      this.setState({ useTemplateModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'closeUseTemplateModal',
    value: function closeUseTemplateModal() {
      this.selectItem();
      this.setState({ useTemplateModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (typeof callback === 'function') callback();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ModalContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Please select an event to use this template'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App_SearchContainer__["a" /* default */], {
          viewer: this.props.viewer,
          onBlur: this.hideSearch,
          onFocus: this.showSearch,
          handleResultSelect: function handleResultSelect(e, data) {
            return _this3.props.router.push('/events/' + data.result.eventId + '/workspaces/?action=new&type=contract&id=' + _this3.props.node.id);
          },
          fluid: true
        })
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
          { open: this.state.useTemplateModalOpen, size: 'small', onClose: this.closeUseTemplateModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Header */], { content: 'Use Template' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            null,
            ModalContent
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
            { style: { textAlign: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, content: 'Cancel', onClick: this.closeUseTemplateModal })
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */],
          { open: this.state.useTemplateModalOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  onClick: this.closeUseTemplateModal
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Content,
            null,
            ModalContent
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteTemplate,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/templates/c/' + _this3.props.node.id);
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/templates/c/' + _this3.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openUseTemplateModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Use Template'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Template'
            )
          )
        )
      );
    }
  }]);

  return ContractTemplateActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTemplateActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateActions);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sections_Actions_Actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_SearchContainer__ = __webpack_require__(527);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var FormTemplateActions = function (_React$Component) {
  _inherits(FormTemplateActions, _React$Component);

  function FormTemplateActions(props) {
    _classCallCheck(this, FormTemplateActions);

    var _this = _possibleConstructorReturn(this, (FormTemplateActions.__proto__ || Object.getPrototypeOf(FormTemplateActions)).call(this, props));

    _this.state = {
      deleteModalOpen: false
    };
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.closeUseTemplateModal = _this.closeUseTemplateModal.bind(_this);
    _this.openUseTemplateModal = _this.openUseTemplateModal.bind(_this);
    _this.deleteTemplate = _this.deleteTemplate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    return _this;
  }

  _createClass(FormTemplateActions, [{
    key: 'openUseTemplateModal',
    value: function openUseTemplateModal() {
      this.setState({ useTemplateModalOpen: true });
    }
  }, {
    key: 'closeUseTemplateModal',
    value: function closeUseTemplateModal() {
      this.selectItem();
      this.setState({ useTemplateModalOpen: false });
    }
  }, {
    key: 'deleteTemplate',
    value: function deleteTemplate() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete form template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted form',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/templates');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-form-template');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3178);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ModalContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Please select an event to use this template'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App_SearchContainer__["a" /* default */], {
          viewer: this.props.viewer,
          onBlur: this.hideSearch,
          onFocus: this.showSearch,
          handleResultSelect: function handleResultSelect(e, data) {
            return _this3.props.router.push('/events/' + data.result.eventId + '/workspaces/?action=new&type=form&id=' + _this3.props.node.id);
          },
          fluid: true
        })
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
          { open: this.state.useTemplateModalOpen, size: 'small', onClose: this.closeUseTemplateModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Header */], { content: 'Use Template' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            null,
            ModalContent
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
            { style: { textAlign: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, content: 'Cancel', onClick: this.closeUseTemplateModal })
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */],
          { open: this.state.useTemplateModalOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  onClick: this.closeUseTemplateModal
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Content,
            null,
            ModalContent
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteTemplate,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/templates/f/' + _this3.props.node.id);
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this3.props.router.replace('/templates/f/' + _this3.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openUseTemplateModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Use Template'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Template'
            )
          )
        )
      );
    }
  }]);

  return FormTemplateActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormTemplateActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormTemplateActions);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_SearchContainer__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CopyConfirmation__ = __webpack_require__(3187);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MpTemplateActions = function (_React$Component) {
  _inherits(MpTemplateActions, _React$Component);

  function MpTemplateActions(props) {
    _classCallCheck(this, MpTemplateActions);

    var _this = _possibleConstructorReturn(this, (MpTemplateActions.__proto__ || Object.getPrototypeOf(MpTemplateActions)).call(this, props));

    _this.state = {
      copyTitle: '',
      deleteModalOpen: false
    };
    _this.onCloseCopy = _this.onCloseCopy.bind(_this);
    _this.closeDeleteModal = _this.closeDeleteModal.bind(_this);
    _this.openDeleteModal = _this.openDeleteModal.bind(_this);
    _this.closeUseTemplateModal = _this.closeUseTemplateModal.bind(_this);
    _this.openUseTemplateModal = _this.openUseTemplateModal.bind(_this);
    _this.deleteTemplate = _this.deleteTemplate.bind(_this);
    _this.copyTemplate = _this.copyTemplate.bind(_this);
    _this.selectItem = _this.selectItem.bind(_this);
    return _this;
  }

  _createClass(MpTemplateActions, [{
    key: 'onCloseCopy',
    value: function onCloseCopy() {
      this.setState({ copyTitle: '', copiedNode: null });
    }
  }, {
    key: 'openUseTemplateModal',
    value: function openUseTemplateModal() {
      this.setState({ useTemplateModalOpen: true });
    }
  }, {
    key: 'closeUseTemplateModal',
    value: function closeUseTemplateModal() {
      this.selectItem();
      this.setState({ useTemplateModalOpen: false });
    }
  }, {
    key: 'deleteTemplate',
    value: function deleteTemplate() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete music list template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted music list template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/templates');
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-mp-template');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3198);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'copyTemplate',
    value: function copyTemplate(model, resetForm, invalidateForm, callback) {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to copy music list template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully copied music list template',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.setState({ copiedNode: response.copyMpTemplate.mp_template });
        callback();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('copied-mp-template');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3197);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            mp_template_id: this.props.node.id,
            title: this.state.copyTitle
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openDeleteModal',
    value: function openDeleteModal() {
      this.setState({ deleteModalOpen: true });
    }
  }, {
    key: 'closeDeleteModal',
    value: function closeDeleteModal() {
      this.selectItem();
      this.setState({ deleteModalOpen: false });
    }
  }, {
    key: 'selectItem',
    value: function selectItem(callback) {
      if (this.props.onClose) this.props.onClose();
      if (callback) callback();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          node = _props.node,
          router = _props.router;
      var _state = this.state,
          copyTitle = _state.copyTitle,
          copiedNode = _state.copiedNode;

      var ModalContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Please select an event to use this template'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__App_SearchContainer__["a" /* default */], {
          viewer: this.props.viewer,
          onBlur: this.hideSearch,
          onFocus: this.showSearch,
          handleResultSelect: function handleResultSelect(e, data) {
            return _this4.props.router.push('/events/' + data.result.eventId + '/workspaces/?action=new&type=music%20list&id=' + _this4.props.node.id);
          },
          fluid: true
        })
      );

      var copyTemplateFields = function copyTemplateFields() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            'Copy this template to your account to customize and use it.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["e" /* FloatingLabelInput */], {
            autoFocus: true,
            name: 'title',
            onChange: function onChange(e) {
              return _this4.setState({ copyTitle: e.target.value });
            },
            value: copyTitle,
            required: true,
            label: 'Template Title',
            placeholder: 'Wedding Music List',
            validationError: 'Title is required'
          })
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_8__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
          {
            open: this.state.useTemplateModalOpen,
            size: 'small',
            onClose: this.closeUseTemplateModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Header */], { content: 'Use Template' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            null,
            ModalContent
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
            { style: { textAlign: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
              basic: true,
              content: 'Cancel',
              onClick: this.closeUseTemplateModal
            })
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_8__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */],
          { open: this.state.useTemplateModalOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.closeUseTemplateModal },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Content,
            null,
            ModalContent
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["i" /* DeleteConfirmation */], {
          'delete': this.deleteTemplate,
          id: this.props.node.id,
          open: this.state.deleteModalOpen,
          onClose: this.closeDeleteModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Actions__["a" /* default */],
          {
            windowDimensions: this.props.windowDimensions,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */],
            null,
            this.props.params.action === 'edit' && node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/templates/m/' + _this4.props.node.id + '/preview');
                },
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'eye' }),
              ' \xA0 Preview'
            ),
            this.props.params.action !== 'edit' && node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: function onClick() {
                  return _this4.props.router.replace('/templates/m/' + _this4.props.node.id + '/edit');
                },
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'pencil' }),
              ' \xA0 Edit'
            ),
            node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openUseTemplateModal,
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' }),
              ' \xA0 Use Template'
            ),
            !node.can_edit && node.public && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["e" /* Wizard */], {
              modalSize: 'tiny',
              onClose: this.onCloseCopy,
              steps: [{
                component: copyTemplateFields,
                title: 'Save to your Account',
                actions: {
                  primary: {
                    content: 'Save',
                    disabled: copyTitle === '',
                    type: 'submit'
                  }
                },
                formProps: {
                  onValidSubmit: this.copyTemplate
                }
              }, {
                component: __WEBPACK_IMPORTED_MODULE_10__CopyConfirmation__["a" /* default */],
                componentProps: { node: copiedNode, router: router },
                title: 'Save to your Account',
                hideActions: true
              }],
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
                {
                  onClick: this.copyTemplate,
                  className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'save outline' }),
                ' \xA0 Save to My Account'
              )
            }),
            node.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* List */].Item,
              {
                onClick: this.openDeleteModal,
                className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionMenuItem
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' }),
              ' \xA0 Delete Template'
            )
          )
        )
      );
    }
  }]);

  return MpTemplateActions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MpTemplateActions.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateActions);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */




var CardFieldNoValidate = function (_React$Component) {
  _inherits(CardFieldNoValidate, _React$Component);

  function CardFieldNoValidate(props) {
    _classCallCheck(this, CardFieldNoValidate);

    var _this = _possibleConstructorReturn(this, (CardFieldNoValidate.__proto__ || Object.getPrototypeOf(CardFieldNoValidate)).call(this, props));

    _this.state = {
      focused: false,
      initialBlur: false,
      id: _this.getId()
    };
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.changeValue = _this.changeValue.bind(_this);
    return _this;
  }

  _createClass(CardFieldNoValidate, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.activeElement) {
        document.activeElement.blur();
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      this.setState({ focused: true });
      if (this.props.onFocus) this.props.onFocus(e);
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      // Make exception for blurring field to access DayPicker
      if (!(e.relatedTarget && e.relatedTarget.className.match('DayPicker-Day'))) {
        this.setState({ focused: false, initialBlur: true });
        if (this.props.onBlur) this.props.onBlur(e);
      }
    }
  }, {
    key: 'getId',
    value: function getId() {
      return this.props.id || (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'changeValue',
    value: function changeValue(e) {
      this.props.setValue(e.target.value);
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      // Workaround to validate required fields that are empty
      var _props = this.props,
          showError = _props.showError,
          hasValue = _props.hasValue,
          validationError = _props.validationError;

      var hasError = (this.state.initialBlur || this.props.submitted) && (showError() || this.props.required && !hasValue());
      var errorMessage = hasError ? validationError : null;
      var inputWidth = this.props.label ? 12 : 16;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
        {
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          className: [this.state.focused ? __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.focused : '', this.props.className, errorMessage ? __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.error : ''].join(' ')
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          { className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.row },
          this.props.label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { width: 4, textAlign: 'right', className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.row },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              { htmlFor: this.state.id },
              this.props.label,
              ':'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            { width: inputWidth, className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.row },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children, {
              id: this.state.id,
              onChange: this.changeValue,
              value: this.props.getValue()
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.errorMessage },
              errorMessage
            )
          )
        )
      );
    }
  }]);

  return CardFieldNoValidate;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

CardFieldNoValidate.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  showError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  hasValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  validationError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  submitted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (CardFieldNoValidate);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DatePicker = (_temp = _class = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker() {
    _classCallCheck(this, DatePicker);

    return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
  }

  _createClass(DatePicker, [{
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      this.props.close();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          style: Object.assign({}, {
            position: 'absolute',
            top: 'calc(100% + 0.25em)',
            left: '0.5em',
            background: '#fff',
            border: '1px solid #ccc',
            zIndex: 100,
            padding: '1em'
          }, this.props.style)
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["g" /* AvailabilityCalendar */], {
          closeOnSelect: true,
          close: this.props.close,
          style: { flex: 1 },
          initialMonth: this.props.month,
          selectedDay: this.props.selectedDay,
          updateSelectedDay: this.props.updateSelectedDay,
          onDayClick: this.props.handleDayClick,
          viewer: this.props.viewer
        })
      );
    }
  }]);

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  month: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  selectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  updateSelectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  handleDayClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside___default()(DatePicker));

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormsyProps__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_textarea_autosize__ = __webpack_require__(356);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */









var FloatingLabelInput = (_temp = _class = function (_React$Component) {
  _inherits(FloatingLabelInput, _React$Component);

  function FloatingLabelInput(props) {
    _classCallCheck(this, FloatingLabelInput);

    var _this = _possibleConstructorReturn(this, (FloatingLabelInput.__proto__ || Object.getPrototypeOf(FloatingLabelInput)).call(this, props));

    _this.state = {
      isActive: _this.props.getValue() !== null && _this.props.getValue() !== '',
      isFocused: false,
      initialBlur: false,
      id: _this.getId()
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.getValidationError = _this.getValidationError.bind(_this);
    return _this;
  }

  _createClass(FloatingLabelInput, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.activeElement) {
        document.activeElement.blur();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Ties `value` field to HOC value functions
      if (nextProps.value && nextProps.value !== this.props.getValue()) {
        this.props.setValue(nextProps.value);
        this.setState({ isActive: nextProps.value !== null && nextProps.value !== '' });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.getValue() === nextProps.value;
    }
  }, {
    key: 'onChange',
    value: function onChange(e, data) {
      var value = function (type) {
        switch (type) {
          case 'select':
            return window.innerWidth >= __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint ? data.value : e.target.value;
          case 'currency':
            return e.floatValue;
          default:
            return e.target.value;
        }
      }(this.props.type);

      var changeEvent = function (type) {
        switch (type) {
          case 'select':
            return Object.assign({}, e, { target: { value: value } });
          case 'currency':
            return Object.assign({}, data, { target: Object.assign(data.target, { value: value }) });
          default:
            return e;
        }
      }(this.props.type);

      this.setState({
        isActive: value !== ''
      });
      if (this.props.onChange) this.props.onChange(changeEvent);
      this.props.setValue(value);
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      this.setState({
        isFocused: true
      });
      if (this.props.onFocus) this.props.onFocus(e);
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      this.setState({
        isFocused: false,
        initialBlur: true
      });
      if (this.props.onBlur) this.props.onBlur(e);
    }
  }, {
    key: 'getId',
    value: function getId() {
      return this.props.id || (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'getInitialStyles',
    value: function getInitialStyles() {
      var initialStyles = [__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.floatingLabelInput];
      if (this.props.className) initialStyles.push(this.props.className);
      return initialStyles;
    }
  }, {
    key: 'getValidationError',
    value: function getValidationError() {
      var _props = this.props,
          getErrorMessage = _props.getErrorMessage,
          getErrorMessages = _props.getErrorMessages,
          validationError = _props.validationError;

      if (getErrorMessages().length > 0) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          Object.values(getErrorMessages()).map(function (error, index) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { key: index },
              error
            );
          })
        );
      }
      return getErrorMessage() || validationError;
    }
  }, {
    key: 'render',
    value: function render() {
      var inputStyles = this.getInitialStyles();
      var _props2 = this.props,
          showError = _props2.showError,
          hasValue = _props2.hasValue;

      var hasError = (this.state.initialBlur || this.props.submitted) && (showError() || this.props.required && !hasValue());
      var errorMessage = hasError ? this.getValidationError() : null;

      if (this.props.disabled) {
        inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.disabled);
      }

      if (this.state.isActive) {
        inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.isActive);
      }

      if (this.state.isFocused) {
        inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.isFocused);
      }

      if (hasError) {
        inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.hasError);
      }

      if (this.props.inline) {
        inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.inline);
        if (this.props.inline === 'last') {
          inputStyles.push(__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.last);
        }
      }

      var placeholder = this.state.isFocused || !this.props.label ? this.props.placeholder : undefined;

      var eventHandlers = {
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };

      // Remove props specific to this component
      // before passing them onto the child
      var _rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit.apply(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a, [this.props, 'autoHeight', 'inline', 'inputRef', 'label', 'children', 'className', 'onChange', 'onFocus', 'onBlur', 'placeholder', 'style', 'type', 'value'].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__FormsyProps__["a" /* default */])));

      var type = this.props.type === 'currency' ? 'text' : this.props.type || 'text';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: [__WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.field, this.props.inline ? __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.inlineBlock : '', this.props.className].join(' '),
          style: Object.assign({}, this.props.style, this.props.width ? { width: this.props.width } : {})
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: inputStyles.join(' ') },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'label',
            { htmlFor: this.state.id },
            this.props.label
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            this.props.children && this.props.type !== 'currency' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(this.props.children, _extends({
              type: type,
              id: this.state.id,
              placeholder: placeholder,
              value: this.props.getValue()
            }, eventHandlers, _rest)),
            this.props.children && this.props.type === 'currency' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(this.props.children, _extends({
              type: 'text',
              id: this.state.id,
              placeholder: placeholder,
              value: this.props.getValue(),
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              onValueChange: this.onChange
            }, _rest)),
            !this.props.children && !this.props.autoHeight && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', _extends({
              type: type,
              id: this.state.id,
              value: this.props.getValue(),
              placeholder: placeholder,
              ref: this.props.inputRef
            }, eventHandlers, _rest)),
            !this.props.children && this.props.autoHeight && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_textarea_autosize__["a" /* default */], _extends({
              id: this.state.id,
              value: this.props.getValue(),
              placeholder: placeholder,
              className: __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.textarea,
              rows: 1,
              inputRef: this.props.inputRef
            }, eventHandlers, _rest))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__FloatingLabelInput_scss___default.a.error },
          errorMessage
        )
      );
    }
  }]);

  return FloatingLabelInput;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  autoHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['last', true, false]),
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getErrorMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getErrorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  validationError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_formsy_react__["HOC"])(FloatingLabelInput));

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationAutocomplete_scss__ = __webpack_require__(3621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationAutocomplete_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LocationAutocomplete_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* global google */





var LocationAutocomplete = function (_React$Component) {
  _inherits(LocationAutocomplete, _React$Component);

  function LocationAutocomplete(props) {
    _classCallCheck(this, LocationAutocomplete);

    var _this = _possibleConstructorReturn(this, (LocationAutocomplete.__proto__ || Object.getPrototypeOf(LocationAutocomplete)).call(this, props));

    _this.state = {
      locationIsLoading: false,
      locationSuggestions: [],
      userLocation: null
    };
    if (google) {
      // We must send a DOM element proving we are providing attribution for usage
      _this.state.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    }
    _this.locationOnFocus = _this.locationOnFocus.bind(_this);
    _this.locationOnBlur = _this.locationOnBlur.bind(_this);
    _this.onLocationSelect = _this.onLocationSelect.bind(_this);
    _this.onLocationSearchChange = _this.onLocationSearchChange.bind(_this);
    _this.updateLocationOptions = _this.updateLocationOptions.bind(_this);
    return _this;
  }

  _createClass(LocationAutocomplete, [{
    key: 'onLocationSelect',
    value: function onLocationSelect(e, data) {
      var _this2 = this;

      if (google) {
        var service = this.state.placesService;
        var addressParts = {};
        service.getDetails({ placeId: data.result.key }, function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            place.address_components.map(function (component) {
              if (component.types.includes('street_number')) {
                addressParts.street_number = component.long_name;
              } else if (component.types.includes('route')) {
                addressParts.route = component.long_name;
              } else if (component.types.includes('locality')) {
                addressParts.city = component.long_name;
              } else if (component.types.includes('administrative_area_level_1')) {
                addressParts.province = component.long_name;
              } else if (component.types.includes('postal_code')) {
                addressParts.postal_code = component.long_name;
              }
              return component;
            });
          } else {
            // eslint-disable-next-line no-undef
            Bugsnag.notify(new Error(status), {
              metaData: {
                PlacesService: service
              },
              severity: 'error'
            });
          }
          _this2.props.updateLocalEventSegment(Object.assign(_this2.props.eventSegment, {
            location: place.name,
            line1: '' + (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route ? addressParts.route : ''),
            city: addressParts.city,
            province: addressParts.province,
            postal_code: addressParts.postal_code,
            room: ''
          }));
        });
      }
    }
  }, {
    key: 'onLocationSearchChange',
    value: function onLocationSearchChange(e, data) {
      this.props.updateLocalEventSegment(Object.assign(this.props.eventSegment, {
        location: data.value
      }));
      this.getLocationSuggestions(data.value);
    }
  }, {
    key: 'getLocationSuggestions',
    value: function getLocationSuggestions(input) {
      if (google && input !== '') {
        var location = this.state.userLocation;
        var service = new google.maps.places.AutocompleteService();
        var params = {
          input: input,
          types: ['establishment', 'geocode']
        };
        if (location) {
          Object.assign(params, { location: location, radius: 200000 });
        }
        service.getPlacePredictions(params, this.updateLocationOptions);
        this.setState({ locationIsLoading: true });
      }
    }
  }, {
    key: 'getUserLocation',
    value: function getUserLocation() {
      var _this3 = this;

      if (navigator.geolocation && google) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this3.setState({
            userLocation: new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          });
        });
      }
      return null;
    }
  }, {
    key: 'locationOnFocus',
    value: function locationOnFocus(e) {
      this.getUserLocation();
      this.getLocationSuggestions(e.target.value);
    }
  }, {
    key: 'locationOnBlur',
    value: function locationOnBlur() {
      if (!this.props.eventSegment.location) {
        this.props.updateLocalEventSegment(Object.assign(this.props.eventSegment, {
          line1: null,
          city: null,
          province: null,
          postal_code: null,
          room: null,
          notes: null
        }));
      }
    }
  }, {
    key: 'updateLocationOptions',
    value: function updateLocationOptions(predictions, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        return;
      }
      var locationSuggestions = predictions.map(function (prediction) {
        return {
          title: prediction.structured_formatting.main_text,
          description: prediction.structured_formatting.secondary_text,
          key: prediction.place_id
        };
      });
      this.setState({ locationSuggestions: locationSuggestions, locationIsLoading: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Elements__["q" /* CardInput */],
        {
          label: 'Venue',
          name: 'location',
          submitted: this.state.submitted
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* Search */], {
          loading: this.state.locationIsLoading,
          onResultSelect: this.onLocationSelect,
          onSearchChange: this.onLocationSearchChange,
          results: this.state.locationSuggestions,
          onFocus: this.locationOnFocus,
          onBlur: this.locationOnBlur,
          value: this.props.eventSegment.location || '',
          fluid: true,
          className: 'transparent locationAutocomplete',
          placeholder: 'Hyatt Regency',
          noResultsMessage: 'No venue suggestions'
        })
      );
    }
  }]);

  return LocationAutocomplete;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LocationAutocomplete.propTypes = {
  updateLocalEventSegment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  eventSegment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (LocationAutocomplete);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_md5__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ContactShow = function (_React$Component) {
  _inherits(ContactShow, _React$Component);

  function ContactShow(props) {
    _classCallCheck(this, ContactShow);

    var _this = _possibleConstructorReturn(this, (ContactShow.__proto__ || Object.getPrototypeOf(ContactShow)).call(this, props));

    _this.getAvatarLink = _this.getAvatarLink.bind(_this);
    return _this;
  }

  _createClass(ContactShow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var email = this.props.contact.node.user_contact_emails ? this.props.contact.node.user_contact_emails.edges[0] : null;
      var address = email ? email.node.address : null;
      this.getAvatarPhoto(address);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentEmailAddress = null;
      if (this.props.contact.node.user_contact_emails && this.props.contact.node.user_contact_emails.edges[0] && this.props.contact.node.user_contact_emails.edges[0].node.address) {
        currentEmailAddress = this.props.contact.node.user_contact_emails.edges[0].node.address;
      }
      if (nextProps.contact.node.user_contact_emails && nextProps.contact.node.user_contact_emails.edges[0] && nextProps.contact.node.user_contact_emails.edges[0].node.address !== currentEmailAddress) {
        this.getAvatarPhoto(nextProps.contact.node.user_contact_emails.edges[0].node.address);
      }
    }
  }, {
    key: 'getAvatarLink',
    value: function getAvatarLink(email) {
      var emailHash = __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default()(email);
      return 'https://www.gravatar.com/avatar/' + emailHash + '?s=50&d=404';
    }
  }, {
    key: 'getAvatarPhoto',
    value: function getAvatarPhoto(email) {
      var _this2 = this;

      var emailHash = __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default()(email);
      if (this.props.avatarCache[emailHash] === undefined) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getAvatarLink(email)).then(function () {
          _this2.props.updateAvatarCache(emailHash, true);
        }).catch(function () {
          _this2.props.updateAvatarCache(emailHash, false);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var contact = this.props.contact;

      var primaryEmail = contact.node.user_contact_emails && contact.node.user_contact_emails.edges[0] !== undefined ? contact.node.user_contact_emails.edges[0].node.address : null;
      var emailHash = __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default()(primaryEmail);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { style: { display: 'flex', paddingLeft: '1em', marginTop: '1em' } },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.avatarWrapper },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.avatar,
              style: {
                backgroundImage: this.props.avatarCache[emailHash] ? 'url(' + this.getAvatarLink(primaryEmail) + ')' : '',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }
            },
            !this.props.avatarCache[emailHash] && contact.node.first_name && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.avatarText },
              contact.node.first_name.charAt(0).toUpperCase()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: [__WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.contact, this.props.extended ? '' : __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.hideOverflow].join(' ') },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.name },
            contact.node.first_name,
            ' ',
            contact.node.last_name
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            contact.node.company_name
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.label, style: { margin: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(contact.role)
          )
        )
      );
    }
  }]);

  return ContactShow;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

ContactShow.propTypes = {
  avatarCache: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  updateAvatarCache: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  extended: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ContactShow);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ReferralSource = function (_React$Component) {
  _inherits(ReferralSource, _React$Component);

  function ReferralSource() {
    _classCallCheck(this, ReferralSource);

    return _possibleConstructorReturn(this, (ReferralSource.__proto__ || Object.getPrototypeOf(ReferralSource)).apply(this, arguments));
  }

  _createClass(ReferralSource, [{
    key: 'render',
    value: function render() {
      var defaultSuggestions = [{ text: 'Past Client', value: 'Past Client' }, { text: 'Venue', value: 'Venue' }, { text: 'Website', value: 'Website' }, { text: 'Staff', value: 'Staff' }, { text: 'Paid Ad', value: 'Paid Ad' }, { text: 'Facebook', value: 'Facebook' }, { text: 'Google', value: 'Google' }, { text: 'Friend', value: 'Friend' }, { text: 'Family', value: 'Family' }];

      var pastReferralSources = this.props.pastReferralSources.slice();

      var sources = pastReferralSources.slice().map(function (source) {
        return { text: source, value: source };
      });

      // Merge past and suggested referral sources
      defaultSuggestions.map(function (suggestion) {
        if (pastReferralSources.indexOf(suggestion.value) === -1) {
          sources.push(suggestion);
        }
        return suggestion;
      });

      // Limit options
      var suggestedSources = sources.slice(0, 8);

      // Add value of selected referral_source if it isn't already
      // in list of suggested sources and it is not null
      if (this.props.value && suggestedSources.indexOf(this.props.value) === -1) {
        suggestedSources.push({ text: this.props.value, value: this.props.value });
      }

      // Remove blank values returned by server
      suggestedSources = suggestedSources.filter(function (source) {
        return source.value !== '';
      });
      // Add option for null source
      suggestedSources.unshift({ text: 'None', value: '' });

      suggestedSources = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqBy"])(suggestedSources, 'value');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["E" /* Select */], {
          label: this.props.label,
          name: 'referral_source',
          value: this.props.value,
          type: 'select',
          onChange: this.props.onChange,
          submitted: this.props.submitted,
          search: true,
          placeholder: 'Referral Source...',
          allowAdditions: true,
          options: suggestedSources,
          fluid: true
        })
      );
    }
  }]);

  return ReferralSource;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

ReferralSource.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pastReferralSources: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ReferralSource);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Event_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TitleEdit = function (_React$Component) {
  _inherits(TitleEdit, _React$Component);

  function TitleEdit(props) {
    _classCallCheck(this, TitleEdit);

    var _this = _possibleConstructorReturn(this, (TitleEdit.__proto__ || Object.getPrototypeOf(TitleEdit)).call(this, props));

    _this.state = {
      title: _this.props.title
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(TitleEdit, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.commitUpdate();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({ title: e.target.value });
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { onBlur: this.props.closeHandler },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__["a" /* default */], {
          autoFocus: true,
          value: this.state.title,
          placeholder: '(Untitled Event)',
          rows: 1,
          name: 'title',
          onChange: this.handleChange,
          className: __WEBPACK_IMPORTED_MODULE_3__Event_scss___default.a.title
        })
      );
    }
  }]);

  return TitleEdit;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

TitleEdit.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (TitleEdit);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Financial_scss__);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */],
    { className: __WEBPACK_IMPORTED_MODULE_2__Financial_scss___default.a.tableHeader },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Row,
      { only: 'computer tablet' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Invoice'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Status'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 3, textAlign: 'right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Invoice Total'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 3, textAlign: 'right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Remaining Balance'
        )
      )
    )
  );
});

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_phone__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask__ = __webpack_require__(690);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SMSNotifications = function (_React$Component) {
  _inherits(SMSNotifications, _React$Component);

  function SMSNotifications(props) {
    _classCallCheck(this, SMSNotifications);

    var _this = _possibleConstructorReturn(this, (SMSNotifications.__proto__ || Object.getPrototypeOf(SMSNotifications)).call(this, props));

    _this.state = {
      phone: '',
      verificationCode: '',
      changeNumber: false,
      initialVerificationMessage: true
    };
    _this.onNotificationsChange = _this.onNotificationsChange.bind(_this);
    _this.verifyPhone = _this.verifyPhone.bind(_this);
    _this.changeNumber = _this.changeNumber.bind(_this);
    _this.updatePhone = _this.updatePhone.bind(_this);
    _this.cancelChangeNumber = _this.cancelChangeNumber.bind(_this);
    _this.sendVerificationCode = _this.sendVerificationCode.bind(_this);
    _this.resendVerificationCode = _this.resendVerificationCode.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.invalidPhone = _this.invalidPhone.bind(_this);
    return _this;
  }

  _createClass(SMSNotifications, [{
    key: 'onNotificationsChange',
    value: function onNotificationsChange(e, data) {
      var _this2 = this;

      var smsNotifications = data.checked;
      var phone = this.props.viewer.phones.edges[0].node;
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to enable SMS notifications',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (!smsNotifications || phone.verified) {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Successfully ' + (smsNotifications ? 'enabled' : 'disabled') + ' SMS notifications',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
          });
        } else {
          _this2.sendVerificationCode(phone);
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Please enter verification code to confirm SMS notifications',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].WARNING
          });
        }
      };
      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3398);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.viewer.id,
            s_text_on_embed_submit: smsNotifications
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'changeNumber',
    value: function changeNumber() {
      this.setState({ changeNumber: true });
    }
  }, {
    key: 'cancelChangeNumber',
    value: function cancelChangeNumber() {
      this.setState({ changeNumber: false, phone: '' });
    }
  }, {
    key: 'invalidPhone',
    value: function invalidPhone() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Invalid phone number',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'updatePhone',
    value: function updatePhone() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update phone number',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        _this3.setState({ phone: '', changeNumber: false });
        if (response.updatePhone.phone.verified) {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Successfully updated phone number',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
          });
        } else {
          _this3.sendVerificationCode(_this3.props.viewer.phones.edges[0].node);
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Please enter verification code to confirm SMS notifications',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].WARNING
          });
        }
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3397);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.viewer.phones.edges[0].node.id,
            number: this.state.phone
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      var newValue = {};
      newValue[e.target.name] = e.target.value;
      this.setState(Object.assign(this.state, newValue));
    }
  }, {
    key: 'sendVerificationCode',
    value: function sendVerificationCode(phone) {
      this.setState({ initialVerificationMessage: false });

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3396);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: phone.id } }
      });
    }
  }, {
    key: 'resendVerificationCode',
    value: function resendVerificationCode() {
      this.sendVerificationCode(this.props.viewer.phones.edges[0].node);
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Please enter verification code to confirm SMS notifications',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].WARNING
      });
    }
  }, {
    key: 'verifyPhone',
    value: function verifyPhone() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Incorrect verification code. Please check for a new code.',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
        _this4.sendVerificationCode(_this4.props.viewer.phones.edges[0].node);
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully enabled SMS notifications',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3399);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.viewer.phones.edges[0].node.id,
            verification_code: this.state.verificationCode
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });

      this.setState({ verificationCode: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      var phone = this.props.viewer.phones.edges[0].node;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
          { className: 'ui form' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], {
            label: 'Send SMS Notifications',
            onChange: this.onNotificationsChange,
            name: 'notifications',
            checked: this.props.viewer.s_text_on_embed_submit
          })
        ),
        this.props.viewer.s_text_on_embed_submit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          this.state.changeNumber && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
            {
              className: 'ui form',
              onValidSubmit: this.updatePhone,
              onInvalidSubmit: this.invalidPhone
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */],
              {
                label: 'Phone Number',
                type: 'tel',
                name: 'phone',
                value: this.state.phone,
                onChange: this.textFieldChange,
                validations: { matchRegexp: /\(\d{3}\)\s\d{3}-\d{4}|\d{10}/ },
                validationError: 'Phone number is invalid',
                required: true
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask__["a" /* default */], { mask: '(999) 999-9999' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { type: 'submit', primary: true, content: 'Update Phone Number' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
              basic: true,
              content: 'Cancel',
              onClick: this.cancelChangeNumber
            })
          ),
          !this.state.changeNumber && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              __WEBPACK_IMPORTED_MODULE_7__lib_utils_phone__["a" /* default */].formatPhoneNumber(phone.number)
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["y" /* Label */],
              {
                color: phone.verified ? 'green' : 'red',
                horizontal: true,
                size: 'small',
                style: { marginLeft: '1em' }
              },
              phone.verified ? 'Verified' : 'Unverified'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { onClick: this.changeNumber },
                'Change Number'
              )
            ),
            !phone.verified && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              this.state.initialVerificationMessage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginTop: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["B" /* Message */],
                  { negative: true },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["B" /* Message */].Header,
                    null,
                    'Phone number not verified'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    null,
                    'Your phone number has not been verified. You will not receive SMS messages until you verify your number.'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                    primary: true,
                    content: 'Verify Now',
                    onClick: this.resendVerificationCode
                  })
                )
              ),
              !this.state.initialVerificationMessage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["B" /* Message */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["B" /* Message */].Header,
                  null,
                  'SMS Verification'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  'We just sent a verification code to your device. Please enter it below.',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  'You will not receive SMS messages until you verify your number.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
                  {
                    className: 'ui form',
                    onSubmit: this.verifyPhone
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                    label: 'Verification Code',
                    type: 'text',
                    name: 'verificationCode',
                    value: this.state.verificationCode,
                    onChange: this.textFieldChange,
                    validations: {
                      isInt: true,
                      isLength: 4
                    },
                    validationError: 'Please enter 4-digit verification code',
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { type: 'submit', primary: true, content: 'Verify' })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'Didn\'t receive a code? \xA0',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { onClick: this.resendVerificationCode },
                    'Resend'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SMSNotifications;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SMSNotifications.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SMSNotifications);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgendaView__ = __webpack_require__(3406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DayView__ = __webpack_require__(3409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AvailabilityChecker_scss__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AvailabilityChecker_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AvailabilityChecker_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AvailabilityDetails = function (_React$Component) {
  _inherits(AvailabilityDetails, _React$Component);

  function AvailabilityDetails(props) {
    _classCallCheck(this, AvailabilityDetails);

    var _this = _possibleConstructorReturn(this, (AvailabilityDetails.__proto__ || Object.getPrototypeOf(AvailabilityDetails)).call(this, props));

    _this.state = {
      view: 'dayView'
    };
    _this.setView = _this.setView.bind(_this);
    return _this;
  }

  _createClass(AvailabilityDetails, [{
    key: 'setView',
    value: function setView(view) {
      this.setState({ view: view });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          close = _props.close,
          closeAvailabilityChecker = _props.closeAvailabilityChecker,
          eventsOnDay = _props.eventsOnDay,
          isOpen = _props.isOpen,
          selectedDay = _props.selectedDay,
          updateSelectedDay = _props.updateSelectedDay,
          viewer = _props.viewer;
      var view = this.state.view;

      var selectedView = view === 'agenda' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AgendaView__["a" /* default */], {
        selectedDay: selectedDay,
        eventsOnDay: eventsOnDay,
        close: close,
        closeAvailabilityChecker: closeAvailabilityChecker,
        timeZone: viewer.s_time_zone
      }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DayView__["a" /* default */], {
        events: eventsOnDay,
        selectedDay: selectedDay,
        updateSelectedDay: updateSelectedDay,
        close: close,
        closeAvailabilityChecker: closeAvailabilityChecker,
        timeZone: viewer.s_time_zone
      });
      var availabilityInfo = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */].Group,
          { basic: true, size: 'small' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
            {
              active: view === 'dayView',
              onClick: this.setView.bind(this, 'dayView')
            },
            'Day'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
            {
              onClick: this.setView.bind(this, 'agenda'),
              active: view === 'agenda'
            },
            'Agenda'
          )
        ),
        selectedView
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: 'inline-block' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */],
          {
            open: isOpen,
            onClose: close,
            closeIcon: true,
            size: 'small',
            className: __WEBPACK_IMPORTED_MODULE_6__AvailabilityChecker_scss___default.a.availabilityDetailsDesktop,
            mountNode: document.getElementById('desktopModal')
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Content,
            { style: { maxHeight: '100%', overflowY: 'scroll' } },
            availabilityInfo
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */],
          {
            open: isOpen,
            onClose: close,
            mountNode: document.getElementById('mobileModal')
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: close },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'chevron left icon' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */].Content,
            null,
            availabilityInfo
          )
        )
      );
    }
  }]);

  return AvailabilityDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AvailabilityDetails.propTypes = {
  eventsOnDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  selectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  updateSelectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeAvailabilityChecker: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  isOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AvailabilityDetails);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Thumbnail__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_circle_plus_icon_svg__ = __webpack_require__(3638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_circle_plus_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_circle_plus_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_circle_check_icon_svg__ = __webpack_require__(3636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_circle_check_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_circle_check_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Playlist_scss__);







var SelectablePlaylist = function SelectablePlaylist(_ref) {
  var isSelected = _ref.isSelected,
      playlist = _ref.playlist,
      togglePlaylist = _ref.togglePlaylist;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Thumbnail__["a" /* default */], {
    playlist: playlist,
    action: function action(e) {
      togglePlaylist(e, { value: playlist.id });
    },
    actionClassName: __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.toggleRecommendation,
    actionIcon: isSelected(playlist.id) ? __WEBPACK_IMPORTED_MODULE_4__assets_circle_check_icon_svg___default.a : __WEBPACK_IMPORTED_MODULE_3__assets_circle_plus_icon_svg___default.a,
    onClick: function onClick(e) {
      e.stopPropagation();
      togglePlaylist(e, { value: playlist.id });
    }
  });
};

SelectablePlaylist.propTypes = {
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  togglePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SelectablePlaylist);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Artwork__ = __webpack_require__(3425);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PlaylistSummary = function (_React$Component) {
  _inherits(PlaylistSummary, _React$Component);

  function PlaylistSummary(props) {
    _classCallCheck(this, PlaylistSummary);

    var _this = _possibleConstructorReturn(this, (PlaylistSummary.__proto__ || Object.getPrototypeOf(PlaylistSummary)).call(this, props));

    _this.state = {
      deleteConfirmationOpen: false,
      deleting: false,
      limitPlaylistSize: _this.props.playlist.max_length !== null
    };
    _this.deletePlaylist = _this.deletePlaylist.bind(_this);
    _this.toggleLimitPlaylistSize = _this.toggleLimitPlaylistSize.bind(_this);
    return _this;
  }

  _createClass(PlaylistSummary, [{
    key: 'deletePlaylist',
    value: function deletePlaylist() {
      this.setState({ deleting: true });
      if (this.props.goBack) this.props.goBack();
      this.props.deletePlaylist();
    }
  }, {
    key: 'toggleLimitPlaylistSize',
    value: function toggleLimitPlaylistSize() {
      var _this2 = this;

      var numSongs = this.props.playlist.playlist_songs.edges.length;
      var limitPlaylistSize = this.state.limitPlaylistSize;

      var successCb = function successCb() {
        return _this2.setState({ limitPlaylistSize: !limitPlaylistSize });
      };
      if (limitPlaylistSize) {
        this.props.updateMaxLength({ value: null, name: 'max_length' }, successCb);
      } else {
        var value = numSongs >= 10 ? numSongs + 5 : 10;
        this.props.updateMaxLength({ value: value, name: 'max_length' }, successCb);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          editable = _props.editable,
          goBack = _props.goBack,
          playlist = _props.playlist,
          _props$showControls = _props.showControls,
          showControls = _props$showControls === undefined ? true : _props$showControls,
          updatePlaylist = _props.updatePlaylist,
          updateMaxLength = _props.updateMaxLength,
          deletePlaylist = _props.deletePlaylist;
      var _state = this.state,
          deleting = _state.deleting,
          deleteConfirmationOpen = _state.deleteConfirmationOpen,
          limitPlaylistSize = _state.limitPlaylistSize;

      var numSongs = playlist.playlist_songs.edges.length;

      var DeleteConfirmation = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */],
        {
          open: deleteConfirmationOpen,
          onClose: function onClose() {
            return _this3.setState({ deleteConfirmationOpen: false });
          },
          size: 'small'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Header, { content: 'Delete Playlist' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Are you sure you want to ',
            editable ? 'delete' : 'unfollow',
            ' ',
            playlist.title,
            '?'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
            {
              basic: true,
              onClick: function onClick() {
                return _this3.setState({ deleteConfirmationOpen: false });
              }
            },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
            { color: 'red', onClick: this.deletePlaylist, disabled: deleting },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'delete' }),
            ' Delete'
          )
        )
      );

      var OptionsMenu = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Menu,
        { style: { left: 'auto', right: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
          {
            onClick: function onClick() {
              if (_this3.props.editable) {
                _this3.setState({ deleteConfirmationOpen: true });
              } else {
                _this3.deletePlaylist();
              }
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.delete },
            editable ? 'Delete' : 'Unfollow',
            ' Playlist'
          )
        )
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: isMobile ? null : { display: 'flex' } },
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: goBack },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              ),
              showControls && deletePlaylist && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
                  {
                    floating: true,
                    icon: 'ellipsis vertical',
                    labeled: true,
                    item: true,
                    className: 'icon basic',
                    style: { padding: '1em 2em' }
                  },
                  OptionsMenu
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Artwork__["a" /* default */], { playlist: playlist }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: isMobile ? { paddingTop: '1em', paddingRight: '1.5em' } : { flex: 1, paddingLeft: '2em', paddingRight: '1.5em' }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                {
                  className: [playlist.title ? '' : __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.muted].join(' '),
                  style: { margin: 0 }
                },
                editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["h" /* EditableText */], {
                  value: playlist.title,
                  update: updatePlaylist,
                  placeholder: 'Playlist Title',
                  name: 'title',
                  fluid: true,
                  autoHeight: true
                }),
                !editable && playlist.title
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: '0.5em' } },
                editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["h" /* EditableText */], {
                  value: playlist.description,
                  update: updatePlaylist,
                  placeholder: 'Playlist description...',
                  name: 'description',
                  fluid: true,
                  autoHeight: true
                }),
                !editable && playlist.description
              ),
              updateMaxLength && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: '0.5em' } },
                editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                    size: 'tiny',
                    toggle: true,
                    label: 'Limit Playlist Size',
                    checked: limitPlaylistSize,
                    onClick: _this3.toggleLimitPlaylistSize
                  }),
                  limitPlaylistSize && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: '0.5em' } },
                    'Song Limit:',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["h" /* EditableText */], {
                      value: playlist.max_length,
                      update: updateMaxLength,
                      placeholder: 'Song Limit',
                      name: 'max_length',
                      type: 'number',
                      min: 0,
                      style: { marginLeft: '0.25em', width: '50px' }
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.songCount },
                numSongs,
                ' ',
                'song' + (numSongs !== 1 ? 's' : ''),
                !editable && playlist.max_length && ' (Limit: ' + playlist.max_length + ' song' + (numSongs !== 1 ? 's' : '') + ')'
              )
            ),
            showControls && DeleteConfirmation,
            showControls && deletePlaylist && !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
                {
                  floating: true,
                  icon: 'ellipsis vertical',
                  labeled: true,
                  className: 'icon basic ' + __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.playlistOptions,
                  direction: 'right'
                },
                OptionsMenu
              )
            )
          );
        }
      );
    }
  }]);

  return PlaylistSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PlaylistSummary.propTypes = {
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  goBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  showControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  updatePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  updateMaxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deletePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (PlaylistSummary);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  eventPropGetter: function eventPropGetter(event) {
    var className = function () {
      switch (event.bookingStatus) {
        case 'BOOKED':
          return 'rbc-booked';
        case 'INITIAL':
          return 'rbc-tentative';
        case 'CANCELED':
          return 'rbc-canceled';
        default:
          return '';
      }
    }();
    return { className: className };
  },
  getFlattenedEventSegments: function getFlattenedEventSegments(events) {
    var flattenedEventSegments = [];

    events.map(function (event) {
      event.node.user_event_segments.edges.map(function (eventSegment) {
        flattenedEventSegments.push({
          title: event.node.event.title + ' - ' + eventSegment.node.title,
          start: eventSegment.node.start_at,
          end: eventSegment.node.end_at,
          allDay: eventSegment.node.all_day,
          id: event.node.event.id,
          bookingStatus: event.node.booking_status
        });
        return eventSegment;
      });
      return event;
    });
    return flattenedEventSegments;
  }
});

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3483);
});

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3491);
});

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3497);
});

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3498);
});

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3499);
});

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3505);
});

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Event_List_EventListContainer__ = __webpack_require__(3268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Event_List_EventIndexContainer__ = __webpack_require__(3266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Event_Pipelines_PipelinesContainer__ = __webpack_require__(3278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Event_List_EventCalendarContainer__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventListQuery__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EventCalendarQuery__ = __webpack_require__(3475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__params_EventListParams__ = __webpack_require__(3522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__params_EventCalendarParams__ = __webpack_require__(3521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewerQuery__ = __webpack_require__(828);














var EventListRoute = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default.a,
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default.a,
    {
      Component: __WEBPACK_IMPORTED_MODULE_4__components_Event_List_EventIndexContainer__["a" /* default */],
      query: __WEBPACK_IMPORTED_MODULE_12__ViewerQuery__["a" /* default */],
      render: function render(_ref) {
        var props = _ref.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Event_List_EventIndexContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Elements__["a" /* Loader */], null);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default.a, {
      Component: __WEBPACK_IMPORTED_MODULE_3__components_Event_List_EventListContainer__["a" /* default */],
      prepareVariables: __WEBPACK_IMPORTED_MODULE_9__params_EventListParams__["a" /* default */],
      query: __WEBPACK_IMPORTED_MODULE_7__EventListQuery__["a" /* default */],
      render: function render(_ref2) {
        var props = _ref2.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Event_List_EventListContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Elements__["a" /* Loader */], null);
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default.a, {
      path: 'calendar',
      Component: __WEBPACK_IMPORTED_MODULE_6__components_Event_List_EventCalendarContainer__["a" /* default */],
      prepareVariables: __WEBPACK_IMPORTED_MODULE_10__params_EventCalendarParams__["a" /* default */],
      query: __WEBPACK_IMPORTED_MODULE_8__EventCalendarQuery__["a" /* default */],
      render: function render(_ref3) {
        var props = _ref3.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Event_List_EventCalendarContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Elements__["a" /* Loader */], null);
      }
    })
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_found_lib_Route___default.a, {
    path: 'pipelines',
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Event_Pipelines_PipelinesContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3492);
    },
    render: function render(_ref4) {
      var props = _ref4.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Event_Pipelines_PipelinesContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Elements__["a" /* Loader */], null);
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = (EventListRoute);

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3534);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js??ref--3-2!./react-big-calendar.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js??ref--3-2!./react-big-calendar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3548);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Share.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Share.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3549);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Brand.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Brand.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3555);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentPlan.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentPlan.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3556);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Recipient.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Recipient.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3561);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./placeholder.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./placeholder.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3566);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./InputWithSuggestions.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./InputWithSuggestions.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3575);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Pipelines.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Pipelines.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3577);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./NewDocumentMenu.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./NewDocumentMenu.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3584);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Dthc.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Dthc.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3585);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Modal.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/13db00b7a34fee4d819ab7f9838cc428.eot";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/8e3c7f5520f5ae906c6cf6d7f3ddcd19.eot";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/701ae6abd4719e9c2ada3535a497b341.eot";

/***/ }),
/* 1512 */,
/* 1513 */,
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_farce__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_farce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_farce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found_relay__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es6_map__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_es6_set__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_es6_promise__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_es6_object__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_es6_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_es6_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_Route__ = __webpack_require__(3478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_semantic_semantic_css__ = __webpack_require__(3603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_semantic_semantic_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_semantic_semantic_css__);




// Polyfill












var rootNode = document.getElementById('app');

function fetchQuery(operation, variables) {
  return fetch('/queries', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      // Add authentication and other headers here
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      query: operation.text, // GraphQL text from input
      variables: variables
    })
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    if (operation.operationKind === 'mutation' && Array.isArray(json.errors)) {
      return Promise.reject(json.errors);
    }
    return json;
  });
}

var network = __WEBPACK_IMPORTED_MODULE_10_relay_runtime__["Network"].create(fetchQuery);
var source = new __WEBPACK_IMPORTED_MODULE_10_relay_runtime__["RecordSource"]();
var store = new __WEBPACK_IMPORTED_MODULE_10_relay_runtime__["Store"](source);

var environment = new __WEBPACK_IMPORTED_MODULE_10_relay_runtime__["Environment"]({
  network: network,
  store: store
});

var Router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_found__["createFarceRouter"])({
  historyProtocol: new __WEBPACK_IMPORTED_MODULE_0_farce__["BrowserProtocol"](),
  historyMiddlewares: [__WEBPACK_IMPORTED_MODULE_0_farce__["queryMiddleware"]],
  routeConfig: __WEBPACK_IMPORTED_MODULE_11__routes_Route__["a" /* default */],
  render: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_found__["createRender"])({})
});

__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Router, { resolver: new __WEBPACK_IMPORTED_MODULE_2_found_relay__["Resolver"](environment) }), rootNode);

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(30);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var interactionMode_1 = __webpack_require__(1526);
exports.FOCUS_DISABLED_CLASS = "pt-focus-disabled";
/* istanbul ignore next */
var fakeFocusEngine = {
    isActive: function isActive() {
        return true;
    },
    start: function start() {
        return true;
    },
    stop: function stop() {
        return true;
    }
};
/* istanbul ignore next */
var focusEngine = typeof document !== "undefined" ? new interactionMode_1.InteractionModeEngine(document.documentElement, exports.FOCUS_DISABLED_CLASS) : fakeFocusEngine;
// this is basically meaningless to unit test; it requires manual UI testing
/* istanbul ignore next */
exports.FocusStyleManager = {
    alwaysShowFocus: function alwaysShowFocus() {
        return focusEngine.stop();
    },
    isActive: function isActive() {
        return focusEngine.isActive();
    },
    onlyShowFocusOnTabs: function onlyShowFocusOnTabs() {
        return focusEngine.start();
    }
};

//# sourceMappingURL=focusStyleManager.js.map

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1523));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = {
    BLACK: "#10161A",
    BLUE1: "#0E5A8A",
    BLUE2: "#106BA3",
    BLUE3: "#137CBD",
    BLUE4: "#2B95D6",
    BLUE5: "#48AFF0",
    COBALT1: "#1F4B99",
    COBALT2: "#2458B3",
    COBALT3: "#2965CC",
    COBALT4: "#4580E6",
    COBALT5: "#669EFF",
    DARK_GRAY1: "#182026",
    DARK_GRAY2: "#202B33",
    DARK_GRAY3: "#293742",
    DARK_GRAY4: "#30404D",
    DARK_GRAY5: "#394B59",
    FOREST1: "#1D7324",
    FOREST2: "#238C2C",
    FOREST3: "#29A634",
    FOREST4: "#43BF4D",
    FOREST5: "#62D96B",
    GOLD1: "#A67908",
    GOLD2: "#BF8C0A",
    GOLD3: "#D99E0B",
    GOLD4: "#F2B824",
    GOLD5: "#FFC940",
    GRAY1: "#5C7080",
    GRAY2: "#738694",
    GRAY3: "#8A9BA8",
    GRAY4: "#A7B6C2",
    GRAY5: "#BFCCD6",
    GREEN1: "#0A6640",
    GREEN2: "#0D8050",
    GREEN3: "#0F9960",
    GREEN4: "#15B371",
    GREEN5: "#3DCC91",
    INDIGO1: "#5642A6",
    INDIGO2: "#634DBF",
    INDIGO3: "#7157D9",
    INDIGO4: "#9179F2",
    INDIGO5: "#AD99FF",
    LIGHT_GRAY1: "#CED9E0",
    LIGHT_GRAY2: "#D8E1E8",
    LIGHT_GRAY3: "#E1E8ED",
    LIGHT_GRAY4: "#EBF1F5",
    LIGHT_GRAY5: "#F5F8FA",
    LIME1: "#728C23",
    LIME2: "#87A629",
    LIME3: "#9BBF30",
    LIME4: "#B6D94C",
    LIME5: "#D1F26D",
    ORANGE1: "#A66321",
    ORANGE2: "#BF7326",
    ORANGE3: "#D9822B",
    ORANGE4: "#F29D49",
    ORANGE5: "#FFB366",
    RED1: "#A82A2A",
    RED2: "#C23030",
    RED3: "#DB3737",
    RED4: "#F55656",
    RED5: "#FF7373",
    ROSE1: "#A82255",
    ROSE2: "#C22762",
    ROSE3: "#DB2C6F",
    ROSE4: "#F5498B",
    ROSE5: "#FF66A1",
    SEPIA1: "#63411E",
    SEPIA2: "#7D5125",
    SEPIA3: "#96622D",
    SEPIA4: "#B07B46",
    SEPIA5: "#C99765",
    TURQUOISE1: "#008075",
    TURQUOISE2: "#00998C",
    TURQUOISE3: "#00B3A4",
    TURQUOISE4: "#14CCBD",
    TURQUOISE5: "#2EE6D6",
    VERMILION1: "#9E2B0E",
    VERMILION2: "#B83211",
    VERMILION3: "#D13913",
    VERMILION4: "#EB532D",
    VERMILION5: "#FF6E4A",
    VIOLET1: "#5C255C",
    VIOLET2: "#752F75",
    VIOLET3: "#8F398F",
    VIOLET4: "#A854A8",
    VIOLET5: "#C274C2",
    WHITE: "#FFFFFF"
};

//# sourceMappingURL=colors.js.map

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var TAB_KEY_CODE = 9;
/* istanbul ignore next */
/**
 * A nifty little class that maintains event handlers to add a class to the container element
 * when entering "mouse mode" (on a `mousedown` event) and remove it when entering "keyboard mode"
 * (on a `tab` key `keydown` event).
 */
var InteractionModeEngine = function () {
    // tslint:disable-next-line:no-constructor-vars
    function InteractionModeEngine(container, className) {
        var _this = this;
        this.container = container;
        this.className = className;
        this.isRunning = false;
        this.handleKeyDown = function (e) {
            if (e.which === TAB_KEY_CODE) {
                _this.reset();
                _this.container.addEventListener("mousedown", _this.handleMouseDown);
            }
        };
        this.handleMouseDown = function () {
            _this.reset();
            _this.container.classList.add(_this.className);
            _this.container.addEventListener("keydown", _this.handleKeyDown);
        };
    }
    /** Returns whether the engine is currently running. */
    InteractionModeEngine.prototype.isActive = function () {
        return this.isRunning;
    };
    /** Enable behavior which applies the given className when in mouse mode. */
    InteractionModeEngine.prototype.start = function () {
        this.container.addEventListener("mousedown", this.handleMouseDown);
        this.isRunning = true;
    };
    /** Disable interaction mode behavior and remove className from container. */
    InteractionModeEngine.prototype.stop = function () {
        this.reset();
        this.isRunning = false;
    };
    InteractionModeEngine.prototype.reset = function () {
        this.container.classList.remove(this.className);
        this.container.removeEventListener("keydown", this.handleKeyDown);
        this.container.removeEventListener("mousedown", this.handleMouseDown);
    };
    return InteractionModeEngine;
}();
exports.InteractionModeEngine = InteractionModeEngine;

//# sourceMappingURL=interactionMode.js.map

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
var browser = {
    isEdge: !!userAgent.match(/Edge/),
    isInternetExplorer: !!userAgent.match(/Trident/) || !!userAgent.match(/rv:11/),
    isWebkit: !!userAgent.match(/AppleWebKit/)
};
exports.Browser = {
    isEdge: function isEdge() {
        return browser.isEdge;
    },
    isInternetExplorer: function isInternetExplorer() {
        return browser.isInternetExplorer;
    },
    isWebkit: function isWebkit() {
        return browser.isWebkit;
    }
};

//# sourceMappingURL=browser.js.map

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1527));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var errors_1 = __webpack_require__(93);
var buttons_1 = __webpack_require__(389);
var dialog_1 = __webpack_require__(839);
var icon_1 = __webpack_require__(188);
var Alert = function (_super) {
    tslib_1.__extends(Alert, _super);
    function Alert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Alert.prototype.render = function () {
        var _a = this.props,
            children = _a.children,
            className = _a.className,
            iconName = _a.iconName,
            intent = _a.intent,
            isOpen = _a.isOpen,
            confirmButtonText = _a.confirmButtonText,
            onConfirm = _a.onConfirm,
            style = _a.style;
        return React.createElement(dialog_1.Dialog, { className: classNames(common_1.Classes.ALERT, className), isOpen: isOpen, style: style }, React.createElement("div", { className: common_1.Classes.ALERT_BODY }, React.createElement(icon_1.Icon, { iconName: iconName, iconSize: "inherit", intent: common_1.Intent.DANGER }), React.createElement("div", { className: common_1.Classes.ALERT_CONTENTS }, children)), React.createElement("div", { className: common_1.Classes.ALERT_FOOTER }, React.createElement(buttons_1.Button, { intent: intent, text: confirmButtonText, onClick: onConfirm }), this.maybeRenderSecondaryAction()));
    };
    Alert.prototype.validateProps = function (props) {
        if (props.cancelButtonText != null && props.onCancel == null || props.cancelButtonText == null && props.onCancel != null) {
            console.warn(errors_1.ALERT_WARN_CANCEL_PROPS);
        }
    };
    Alert.prototype.maybeRenderSecondaryAction = function () {
        if (this.props.cancelButtonText != null) {
            return React.createElement(buttons_1.Button, { text: this.props.cancelButtonText, onClick: this.props.onCancel });
        }
        return undefined;
    };
    return Alert;
}(common_1.AbstractComponent);
Alert.defaultProps = {
    confirmButtonText: "OK",
    isOpen: false,
    onConfirm: null
};
Alert.displayName = "Blueprint.Alert";
exports.Alert = Alert;

//# sourceMappingURL=alert.js.map

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
exports.Breadcrumb = function (breadcrumbProps) {
    var classes = classNames(Classes.BREADCRUMB, (_a = {}, _a[Classes.DISABLED] = breadcrumbProps.disabled, _a), breadcrumbProps.className);
    return React.createElement("a", { className: classes, href: breadcrumbProps.href, onClick: breadcrumbProps.disabled ? null : breadcrumbProps.onClick, tabIndex: breadcrumbProps.disabled ? null : 0, target: breadcrumbProps.target }, breadcrumbProps.text);
    var _a;
};

//# sourceMappingURL=breadcrumb.js.map

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Keys = __webpack_require__(187);
var utils_1 = __webpack_require__(53);
var icon_1 = __webpack_require__(188);
var spinner_1 = __webpack_require__(539);
var AbstractButton = function (_super) {
    tslib_1.__extends(AbstractButton, _super);
    function AbstractButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false
        };
        _this.refHandlers = {
            button: function button(ref) {
                _this.buttonRef = ref;
                utils_1.safeInvoke(_this.props.elementRef, ref);
            }
        };
        _this.currentKeyDown = null;
        // we're casting as `any` to get around a somewhat opaque safeInvoke error
        // that "Type argument candidate 'KeyboardEvent<T>' is not a valid type
        // argument because it is not a supertype of candidate
        // 'KeyboardEvent<HTMLElement>'."
        _this.handleKeyDown = function (e) {
            if (isKeyboardClick(e.which)) {
                e.preventDefault();
                if (e.which !== _this.currentKeyDown) {
                    _this.setState({ isActive: true });
                }
            }
            _this.currentKeyDown = e.which;
            utils_1.safeInvoke(_this.props.onKeyDown, e);
        };
        _this.handleKeyUp = function (e) {
            if (isKeyboardClick(e.which)) {
                _this.setState({ isActive: false });
                _this.buttonRef.click();
            }
            _this.currentKeyDown = null;
            utils_1.safeInvoke(_this.props.onKeyUp, e);
        };
        return _this;
    }
    AbstractButton.prototype.getCommonButtonProps = function () {
        var disabled = this.props.disabled || this.props.loading;
        var className = classNames(Classes.BUTTON, (_a = {}, _a[Classes.ACTIVE] = this.state.isActive || this.props.active, _a[Classes.DISABLED] = disabled, _a[Classes.LOADING] = this.props.loading, _a), Classes.iconClass(this.props.iconName), Classes.intentClass(this.props.intent), this.props.className);
        return {
            className: className,
            disabled: disabled,
            onClick: disabled ? undefined : this.props.onClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            ref: this.refHandlers.button
        };
        var _a;
    };
    AbstractButton.prototype.renderChildren = function () {
        var _a = this.props,
            loading = _a.loading,
            rightIconName = _a.rightIconName,
            text = _a.text;
        var children = React.Children.map(this.props.children, function (child, index) {
            // must wrap string children in spans so loading prop can hide them
            if (typeof child === "string") {
                return React.createElement("span", { key: "text-" + index }, child);
            }
            return child;
        });
        return [loading ? React.createElement(spinner_1.Spinner, { className: "pt-small pt-button-spinner", key: "spinner" }) : undefined, text != null ? React.createElement("span", { key: "text" }, text) : undefined].concat(children, [React.createElement(icon_1.Icon, { className: Classes.ALIGN_RIGHT, iconName: rightIconName, key: "icon" })]);
    };
    return AbstractButton;
}(React.Component);
exports.AbstractButton = AbstractButton;
function isKeyboardClick(keyCode) {
    return keyCode === Keys.ENTER || keyCode === Keys.SPACE;
}

//# sourceMappingURL=abstractButton.js.map

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var position_1 = __webpack_require__(157);
var menu_1 = __webpack_require__(538);
var menuItem_1 = __webpack_require__(846);
var popover_1 = __webpack_require__(266);
var CollapseFrom;
(function (CollapseFrom) {
    CollapseFrom[CollapseFrom["START"] = 0] = "START";
    CollapseFrom[CollapseFrom["END"] = 1] = "END";
})(CollapseFrom = exports.CollapseFrom || (exports.CollapseFrom = {}));
var CollapsibleList = function (_super) {
    tslib_1.__extends(CollapsibleList, _super);
    function CollapsibleList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsibleList.prototype.render = function () {
        var _this = this;
        var collapseFrom = this.props.collapseFrom;
        var childrenLength = React.Children.count(this.props.children);
        var _a = this.partitionChildren(),
            visibleChildren = _a[0],
            collapsedChildren = _a[1];
        var visibleItems = visibleChildren.map(function (child, index) {
            var absoluteIndex = collapseFrom === CollapseFrom.START ? childrenLength - 1 - index : index;
            return React.createElement("li", { className: _this.props.visibleItemClassName, key: absoluteIndex }, _this.props.renderVisibleItem(child.props, absoluteIndex));
        });
        if (collapseFrom === CollapseFrom.START) {
            // reverse START list so separators appear before items
            visibleItems.reverse();
        }
        // construct dropdown menu for collapsed items
        var collapsedPopover;
        if (collapsedChildren.length > 0) {
            var position = collapseFrom === CollapseFrom.END ? position_1.Position.BOTTOM_RIGHT : position_1.Position.BOTTOM_LEFT;
            collapsedPopover = React.createElement("li", { className: this.props.visibleItemClassName }, React.createElement(popover_1.Popover, tslib_1.__assign({ content: React.createElement(menu_1.Menu, null, collapsedChildren), position: position }, this.props.dropdownProps), this.props.dropdownTarget));
        }
        return React.createElement("ul", { className: classNames(Classes.COLLAPSIBLE_LIST, this.props.className) }, collapseFrom === CollapseFrom.START ? collapsedPopover : null, visibleItems, collapseFrom === CollapseFrom.END ? collapsedPopover : null);
    };
    // splits the list of children into two arrays: visible and collapsed
    CollapsibleList.prototype.partitionChildren = function () {
        if (this.props.children == null) {
            return [[], []];
        }
        var childrenArray = React.Children.map(this.props.children, function (child, index) {
            if (child.type !== menuItem_1.MenuItem) {
                throw new Error(Errors.COLLAPSIBLE_LIST_INVALID_CHILD);
            }
            return React.cloneElement(child, { key: "visible-" + index });
        });
        if (this.props.collapseFrom === CollapseFrom.START) {
            // reverse START list so we can always slice visible items from the front of the list
            childrenArray.reverse();
        }
        var visibleItemCount = this.props.visibleItemCount;
        return [childrenArray.slice(0, visibleItemCount), childrenArray.slice(visibleItemCount)];
    };
    return CollapsibleList;
}(React.Component);
CollapsibleList.displayName = "Blueprint.CollapsibleList";
CollapsibleList.defaultProps = {
    collapseFrom: CollapseFrom.START,
    dropdownTarget: null,
    renderVisibleItem: null,
    visibleItemCount: 3
};
exports.CollapsibleList = CollapsibleList;
exports.CollapsibleListFactory = React.createFactory(CollapsibleList);

//# sourceMappingURL=collapsibleList.js.map

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var errors_1 = __webpack_require__(93);
var utils_1 = __webpack_require__(53);
var ContextMenu = __webpack_require__(838);
function ContextMenuTarget(constructor) {
    var _a = constructor.prototype,
        render = _a.render,
        renderContextMenu = _a.renderContextMenu,
        onContextMenuClose = _a.onContextMenuClose;
    if (!utils_1.isFunction(renderContextMenu)) {
        console.warn(errors_1.CONTEXTMENU_WARN_DECORATOR_NO_METHOD);
    }
    // patching classes like this requires preserving function context
    // tslint:disable-next-line only-arrow-functions
    constructor.prototype.render = function () {
        var _this = this;
        /* tslint:disable:no-invalid-this */
        var element = render.call(this);
        if (element == null) {
            // always return `element` in case caller is distinguishing between `null` and `undefined`
            return element;
        }
        var oldOnContextMenu = element.props.onContextMenu;
        var onContextMenu = function onContextMenu(e) {
            // support nested menus (inner menu target would have called preventDefault())
            if (e.defaultPrevented) {
                return;
            }
            if (utils_1.isFunction(_this.renderContextMenu)) {
                var menu = _this.renderContextMenu(e);
                if (menu != null) {
                    e.preventDefault();
                    ContextMenu.show(menu, { left: e.clientX, top: e.clientY }, onContextMenuClose);
                }
            }
            utils_1.safeInvoke(oldOnContextMenu, e);
        };
        return React.cloneElement(element, { onContextMenu: onContextMenu });
        /* tslint:enable:no-invalid-this */
    };
}
exports.ContextMenuTarget = ContextMenuTarget;
;

//# sourceMappingURL=contextMenuTarget.js.map

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Keys = __webpack_require__(187);
var utils_1 = __webpack_require__(53);
var compatibility_1 = __webpack_require__(1528);
var BUFFER_WIDTH_EDGE = 5;
var BUFFER_WIDTH_IE = 30;
var EditableText = function (_super) {
    tslib_1.__extends(EditableText, _super);
    function EditableText(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refHandlers = {
            content: function content(spanElement) {
                _this.valueElement = spanElement;
            },
            input: function input(_input) {
                if (_input != null) {
                    _input.focus();
                    var length_1 = _input.value.length;
                    _input.setSelectionRange(_this.props.selectAllOnFocus ? 0 : length_1, length_1);
                }
            }
        };
        _this.cancelEditing = function () {
            var _a = _this.state,
                lastValue = _a.lastValue,
                value = _a.value;
            _this.setState({ isEditing: false, value: lastValue });
            if (value !== lastValue) {
                utils_1.safeInvoke(_this.props.onChange, lastValue);
            }
            utils_1.safeInvoke(_this.props.onCancel, lastValue);
        };
        _this.toggleEditing = function () {
            if (_this.state.isEditing) {
                var value = _this.state.value;
                _this.setState({ isEditing: false, lastValue: value });
                utils_1.safeInvoke(_this.props.onConfirm, value);
            } else if (!_this.props.disabled) {
                _this.setState({ isEditing: true });
            }
        };
        _this.handleFocus = function () {
            if (!_this.props.disabled) {
                _this.setState({ isEditing: true });
            }
        };
        _this.handleTextChange = function (event) {
            var value = event.target.value;
            // state value should be updated only when uncontrolled
            if (_this.props.value == null) {
                _this.setState({ value: value });
            }
            utils_1.safeInvoke(_this.props.onChange, value);
        };
        _this.handleKeyEvent = function (event) {
            var altKey = event.altKey,
                ctrlKey = event.ctrlKey,
                metaKey = event.metaKey,
                shiftKey = event.shiftKey,
                which = event.which;
            if (which === Keys.ESCAPE) {
                _this.cancelEditing();
                return;
            }
            var hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
            if (which === Keys.ENTER) {
                // prevent IE11 from full screening with alt + enter
                // shift + enter adds a newline by default
                if (altKey || shiftKey) {
                    event.preventDefault();
                }
                if (_this.props.confirmOnEnterKey && _this.props.multiline) {
                    if (event.target != null && hasModifierKey) {
                        insertAtCaret(event.target, "\n");
                        _this.handleTextChange(event);
                    } else {
                        _this.toggleEditing();
                    }
                } else if (!_this.props.multiline || hasModifierKey) {
                    _this.toggleEditing();
                }
            }
        };
        var value = props.value == null ? props.defaultValue : props.value;
        _this.state = {
            inputHeight: 0,
            inputWidth: 0,
            isEditing: props.isEditing === true && props.disabled === false,
            lastValue: value,
            value: value
        };
        return _this;
    }
    EditableText.prototype.render = function () {
        var _a = this.props,
            disabled = _a.disabled,
            multiline = _a.multiline;
        var value = this.props.value == null ? this.state.value : this.props.value;
        var hasValue = value != null && value !== "";
        var classes = classNames(Classes.EDITABLE_TEXT, Classes.intentClass(this.props.intent), (_b = {}, _b[Classes.DISABLED] = disabled, _b["pt-editable-editing"] = this.state.isEditing, _b["pt-editable-placeholder"] = !hasValue, _b["pt-multiline"] = multiline, _b), this.props.className);
        var contentStyle;
        if (multiline) {
            // set height only in multiline mode when not editing
            // otherwise we're measuring this element to determine appropriate height of text
            contentStyle = { height: !this.state.isEditing ? this.state.inputHeight : null };
        } else {
            // minWidth only applies in single line mode (multiline == width 100%)
            contentStyle = {
                height: this.state.inputHeight,
                lineHeight: this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
                minWidth: this.props.minWidth
            };
        }
        // make enclosing div focusable when not editing, so it can still be tabbed to focus
        // (when editing, input itself is focusable so div doesn't need to be)
        var tabIndex = this.state.isEditing || disabled ? null : 0;
        return React.createElement("div", { className: classes, onFocus: this.handleFocus, tabIndex: tabIndex }, this.maybeRenderInput(value), React.createElement("span", { className: "pt-editable-content", ref: this.refHandlers.content, style: contentStyle }, hasValue ? value : this.props.placeholder));
        var _b;
    };
    EditableText.prototype.componentDidMount = function () {
        this.updateInputDimensions();
    };
    EditableText.prototype.componentDidUpdate = function (_, prevState) {
        if (this.state.isEditing && !prevState.isEditing) {
            utils_1.safeInvoke(this.props.onEdit);
        }
        this.updateInputDimensions();
    };
    EditableText.prototype.componentWillReceiveProps = function (nextProps) {
        var state = {};
        if (nextProps.value != null) {
            state.value = nextProps.value;
        }
        if (nextProps.isEditing != null) {
            state.isEditing = nextProps.isEditing;
        }
        if (nextProps.disabled || nextProps.disabled == null && this.props.disabled) {
            state.isEditing = false;
        }
        this.setState(state);
    };
    EditableText.prototype.maybeRenderInput = function (value) {
        var _a = this.props,
            maxLength = _a.maxLength,
            multiline = _a.multiline;
        if (!this.state.isEditing) {
            return undefined;
        }
        var props = {
            className: "pt-editable-input",
            maxLength: maxLength,
            onBlur: this.toggleEditing,
            onChange: this.handleTextChange,
            onKeyDown: this.handleKeyEvent,
            ref: this.refHandlers.input,
            style: {
                height: this.state.inputHeight,
                lineHeight: !multiline && this.state.inputHeight != null ? this.state.inputHeight + "px" : null,
                width: multiline ? "100%" : this.state.inputWidth
            },
            value: value
        };
        return multiline ? React.createElement("textarea", tslib_1.__assign({}, props)) : React.createElement("input", tslib_1.__assign({ type: "text" }, props));
    };
    EditableText.prototype.updateInputDimensions = function () {
        if (this.valueElement != null) {
            var _a = this.props,
                maxLines = _a.maxLines,
                minLines = _a.minLines,
                minWidth = _a.minWidth,
                multiline = _a.multiline;
            var _b = this.valueElement,
                parentElement_1 = _b.parentElement,
                textContent = _b.textContent;
            var _c = this.valueElement,
                scrollHeight_1 = _c.scrollHeight,
                scrollWidth = _c.scrollWidth;
            var lineHeight = getLineHeight(this.valueElement);
            // add one line to computed <span> height if text ends in newline
            // because <span> collapses that trailing whitespace but <textarea> shows it
            if (multiline && this.state.isEditing && /\n$/.test(textContent)) {
                scrollHeight_1 += lineHeight;
            }
            if (lineHeight > 0) {
                // line height could be 0 if the isNaN block from getLineHeight kicks in
                scrollHeight_1 = utils_1.clamp(scrollHeight_1, minLines * lineHeight, maxLines * lineHeight);
            }
            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
            scrollHeight_1 = Math.max(scrollHeight_1, getFontSize(this.valueElement) + 1, getLineHeight(parentElement_1));
            // IE11 & Edge needs a small buffer so text does not shift prior to resizing
            if (compatibility_1.Browser.isEdge()) {
                scrollWidth += BUFFER_WIDTH_EDGE;
            } else if (compatibility_1.Browser.isInternetExplorer()) {
                scrollWidth += BUFFER_WIDTH_IE;
            }
            this.setState({
                inputHeight: scrollHeight_1,
                inputWidth: Math.max(scrollWidth, minWidth)
            });
            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
            if (multiline && this.state.isEditing) {
                this.setTimeout(function () {
                    return parentElement_1.style.height = scrollHeight_1 + "px";
                });
            }
        }
    };
    return EditableText;
}(abstractComponent_1.AbstractComponent);
EditableText.defaultProps = {
    confirmOnEnterKey: false,
    defaultValue: "",
    disabled: false,
    maxLines: Infinity,
    minLines: 1,
    minWidth: 80,
    multiline: false,
    placeholder: "Click to Edit"
};
EditableText = tslib_1.__decorate([PureRender], EditableText);
exports.EditableText = EditableText;
function getFontSize(element) {
    var fontSize = getComputedStyle(element).fontSize;
    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
}
function getLineHeight(element) {
    // getComputedStyle() => 18.0001px => 18
    var lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
    // this check will be true if line-height is a keyword like "normal"
    if (isNaN(lineHeight)) {
        // @see http://stackoverflow.com/a/18430767/6342931
        var line = document.createElement("span");
        line.innerHTML = "<br>";
        element.appendChild(line);
        var singleLineHeight = element.offsetHeight;
        line.innerHTML = "<br><br>";
        var doubleLineHeight = element.offsetHeight;
        element.removeChild(line);
        // this can return 0 in edge cases
        lineHeight = doubleLineHeight - singleLineHeight;
    }
    return lineHeight;
}
function insertAtCaret(el, text) {
    var selectionEnd = el.selectionEnd,
        selectionStart = el.selectionStart,
        value = el.value;
    if (selectionStart >= 0) {
        var before_1 = value.substring(0, selectionStart);
        var after_1 = value.substring(selectionEnd, value.length);
        var len = text.length;
        el.value = "" + before_1 + text + after_1;
        el.selectionStart = selectionStart + len;
        el.selectionEnd = selectionStart + len;
    }
}
exports.EditableTextFactory = React.createFactory(EditableText);

//# sourceMappingURL=editableText.js.map

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var Errors = __webpack_require__(93);
var buttons_1 = __webpack_require__(389);
var inputGroup_1 = __webpack_require__(841);
var IncrementDirection;
(function (IncrementDirection) {
    IncrementDirection[IncrementDirection["DOWN"] = -1] = "DOWN";
    IncrementDirection[IncrementDirection["UP"] = 1] = "UP";
})(IncrementDirection || (IncrementDirection = {}));
var NumericInput = NumericInput_1 = function (_super) {
    tslib_1.__extends(NumericInput, _super);
    function NumericInput(props, context) {
        var _this = _super.call(this, props, context) || this;
        // updating these flags need not trigger re-renders, so don't include them in this.state.
        _this.didPasteEventJustOccur = false;
        _this.shouldSelectAfterUpdate = false;
        _this.inputRef = function (input) {
            _this.inputElement = input;
        };
        // Callbacks - Buttons
        // ===================
        _this.handleDecrementButtonClick = function (e) {
            var delta = _this.getIncrementDelta(IncrementDirection.DOWN, e.shiftKey, e.altKey);
            var nextValue = _this.incrementValue(delta);
            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
        };
        _this.handleIncrementButtonClick = function (e) {
            var delta = _this.getIncrementDelta(IncrementDirection.UP, e.shiftKey, e.altKey);
            var nextValue = _this.incrementValue(delta);
            _this.invokeValueCallback(nextValue, _this.props.onButtonClick);
        };
        _this.handleButtonFocus = function () {
            _this.setState({ isButtonGroupFocused: true });
        };
        _this.handleButtonBlur = function () {
            _this.setState({ isButtonGroupFocused: false });
        };
        _this.handleButtonKeyUp = function (e, onClick) {
            if (e.keyCode === common_1.Keys.SPACE || e.keyCode === common_1.Keys.ENTER) {
                // prevent the page from scrolling (this is the default browser
                // behavior for shift + space or alt + space).
                e.preventDefault();
                // trigger a click event to update the input value appropriately,
                // based on the active modifier keys.
                var fakeClickEvent = {
                    altKey: e.altKey,
                    currentTarget: e.currentTarget,
                    shiftKey: e.shiftKey,
                    target: e.target
                };
                onClick(fakeClickEvent);
            }
        };
        // Callbacks - Input
        // =================
        _this.handleInputFocus = function (e) {
            _this.shouldSelectAfterUpdate = _this.props.selectAllOnFocus;
            _this.setState({ isInputGroupFocused: true });
            common_1.Utils.safeInvoke(_this.props.onFocus, e);
        };
        _this.handleInputBlur = function (e) {
            // explicitly set `shouldSelectAfterUpdate` to `false` to prevent focus
            // hoarding on IE11 (#704)
            _this.shouldSelectAfterUpdate = false;
            var baseStateChange = { isInputGroupFocused: false };
            if (_this.props.clampValueOnBlur) {
                var value = e.target.value;
                var sanitizedValue = _this.getSanitizedValue(value);
                _this.setState(tslib_1.__assign({}, baseStateChange, { value: sanitizedValue }));
                if (value !== sanitizedValue) {
                    _this.invokeValueCallback(sanitizedValue, _this.props.onValueChange);
                }
            } else {
                _this.setState(baseStateChange);
            }
            common_1.Utils.safeInvoke(_this.props.onBlur, e);
        };
        _this.handleInputKeyDown = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var keyCode = e.keyCode;
            var direction;
            if (keyCode === common_1.Keys.ARROW_UP) {
                direction = IncrementDirection.UP;
            } else if (keyCode === common_1.Keys.ARROW_DOWN) {
                direction = IncrementDirection.DOWN;
            }
            if (direction != null) {
                // when the input field has focus, some key combinations will modify
                // the field's selection range. we'll actually want to select all
                // text in the field after we modify the value on the following
                // lines. preventing the default selection behavior lets us do that
                // without interference.
                e.preventDefault();
                var delta = _this.getIncrementDelta(direction, e.shiftKey, e.altKey);
                _this.incrementValue(delta);
            }
            common_1.Utils.safeInvoke(_this.props.onKeyDown, e);
        };
        _this.handleInputKeyPress = function (e) {
            // we prohibit keystrokes in onKeyPress instead of onKeyDown, because
            // e.key is not trustworthy in onKeyDown in all browsers.
            if (_this.props.allowNumericCharactersOnly && _this.isKeyboardEventDisabledForBasicNumericEntry(e)) {
                e.preventDefault();
            }
            common_1.Utils.safeInvoke(_this.props.onKeyPress, e);
        };
        _this.handleInputPaste = function (e) {
            _this.didPasteEventJustOccur = true;
            common_1.Utils.safeInvoke(_this.props.onPaste, e);
        };
        _this.handleInputChange = function (e) {
            var value = e.target.value;
            var nextValue;
            if (_this.props.allowNumericCharactersOnly && _this.didPasteEventJustOccur) {
                _this.didPasteEventJustOccur = false;
                var valueChars = value.split("");
                var sanitizedValueChars = valueChars.filter(_this.isFloatingPointNumericCharacter);
                var sanitizedValue = sanitizedValueChars.join("");
                nextValue = sanitizedValue;
            } else {
                nextValue = value;
            }
            _this.shouldSelectAfterUpdate = false;
            _this.setState({ value: nextValue });
            _this.invokeValueCallback(nextValue, _this.props.onValueChange);
        };
        _this.state = {
            stepMaxPrecision: _this.getStepMaxPrecision(props),
            value: _this.getValueOrEmptyValue(props.value)
        };
        return _this;
    }
    NumericInput.prototype.componentWillReceiveProps = function (nextProps) {
        _super.prototype.componentWillReceiveProps.call(this, nextProps);
        var value = this.getValueOrEmptyValue(nextProps.value);
        var didMinChange = nextProps.min !== this.props.min;
        var didMaxChange = nextProps.max !== this.props.max;
        var didBoundsChange = didMinChange || didMaxChange;
        var sanitizedValue = value !== NumericInput_1.VALUE_EMPTY ? this.getSanitizedValue(value, /* delta */0, nextProps.min, nextProps.max) : NumericInput_1.VALUE_EMPTY;
        var stepMaxPrecision = this.getStepMaxPrecision(nextProps);
        // if a new min and max were provided that cause the existing value to fall
        // outside of the new bounds, then clamp the value to the new valid range.
        if (didBoundsChange && sanitizedValue !== this.state.value) {
            this.setState({ stepMaxPrecision: stepMaxPrecision, value: sanitizedValue });
            this.invokeValueCallback(sanitizedValue, this.props.onValueChange);
        } else {
            this.setState({ stepMaxPrecision: stepMaxPrecision, value: value });
        }
    };
    NumericInput.prototype.render = function () {
        var _a = this.props,
            buttonPosition = _a.buttonPosition,
            className = _a.className,
            large = _a.large;
        var inputGroupHtmlProps = common_1.removeNonHTMLProps(this.props, ["allowNumericCharactersOnly", "buttonPosition", "clampValueOnBlur", "className", "large", "majorStepSize", "minorStepSize", "onButtonClick", "onValueChange", "selectAllOnFocus", "selectAllOnIncrement", "stepSize"], true);
        var inputGroup = React.createElement(inputGroup_1.InputGroup, tslib_1.__assign({ autoComplete: "off" }, inputGroupHtmlProps, { className: classNames((_b = {}, _b[common_1.Classes.LARGE] = large, _b)), intent: this.props.intent, inputRef: this.inputRef, key: "input-group", leftIconName: this.props.leftIconName, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, onKeyPress: this.handleInputKeyPress, onPaste: this.handleInputPaste, value: this.state.value }));
        // the strict null check here is intentional; an undefined value should
        // fall back to the default button position on the right side.
        if (buttonPosition === "none" || buttonPosition === null) {
            // If there are no buttons, then the control group will render the
            // text field with squared border-radii on the left side, causing it
            // to look weird. This problem goes away if we simply don't nest within
            // a control group.
            return React.createElement("div", { className: className }, inputGroup);
        } else {
            var incrementButton = this.renderButton(NumericInput_1.INCREMENT_KEY, NumericInput_1.INCREMENT_ICON_NAME, this.handleIncrementButtonClick);
            var decrementButton = this.renderButton(NumericInput_1.DECREMENT_KEY, NumericInput_1.DECREMENT_ICON_NAME, this.handleDecrementButtonClick);
            var buttonGroup = React.createElement("div", { key: "button-group", className: classNames(common_1.Classes.BUTTON_GROUP, common_1.Classes.VERTICAL, common_1.Classes.FIXED) }, incrementButton, decrementButton);
            var inputElems = buttonPosition === common_1.Position.LEFT ? [buttonGroup, inputGroup] : [inputGroup, buttonGroup];
            var classes = classNames(common_1.Classes.NUMERIC_INPUT, common_1.Classes.CONTROL_GROUP, (_c = {}, _c[common_1.Classes.LARGE] = large, _c), className);
            return React.createElement("div", { className: classes }, inputElems);
        }
        var _b, _c;
    };
    NumericInput.prototype.componentDidUpdate = function () {
        if (this.shouldSelectAfterUpdate) {
            this.inputElement.setSelectionRange(0, this.state.value.length);
        }
    };
    NumericInput.prototype.validateProps = function (nextProps) {
        var majorStepSize = nextProps.majorStepSize,
            max = nextProps.max,
            min = nextProps.min,
            minorStepSize = nextProps.minorStepSize,
            stepSize = nextProps.stepSize;
        if (min != null && max != null && min >= max) {
            throw new Error(Errors.NUMERIC_INPUT_MIN_MAX);
        }
        if (stepSize == null) {
            throw new Error(Errors.NUMERIC_INPUT_STEP_SIZE_NULL);
        }
        if (stepSize <= 0) {
            throw new Error(Errors.NUMERIC_INPUT_STEP_SIZE_NON_POSITIVE);
        }
        if (minorStepSize && minorStepSize <= 0) {
            throw new Error(Errors.NUMERIC_INPUT_MINOR_STEP_SIZE_NON_POSITIVE);
        }
        if (majorStepSize && majorStepSize <= 0) {
            throw new Error(Errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_NON_POSITIVE);
        }
        if (minorStepSize && minorStepSize > stepSize) {
            throw new Error(Errors.NUMERIC_INPUT_MINOR_STEP_SIZE_BOUND);
        }
        if (majorStepSize && majorStepSize < stepSize) {
            throw new Error(Errors.NUMERIC_INPUT_MAJOR_STEP_SIZE_BOUND);
        }
    };
    // Render Helpers
    // ==============
    NumericInput.prototype.renderButton = function (key, iconName, onClick) {
        var _this = this;
        // respond explicitly on key *up*, because onKeyDown triggers multiple
        // times and doesn't always receive modifier-key flags, leading to an
        // unintuitive/out-of-control incrementing experience.
        var onKeyUp = function onKeyUp(e) {
            _this.handleButtonKeyUp(e, onClick);
        };
        return React.createElement(buttons_1.Button, { disabled: this.props.disabled || this.props.readOnly, iconName: iconName, intent: this.props.intent, key: key, onBlur: this.handleButtonBlur, onClick: onClick, onFocus: this.handleButtonFocus, onKeyUp: onKeyUp });
    };
    NumericInput.prototype.invokeValueCallback = function (value, callback) {
        common_1.Utils.safeInvoke(callback, +value, value);
    };
    // Value Helpers
    // =============
    NumericInput.prototype.incrementValue = function (delta) {
        // pretend we're incrementing from 0 if currValue is empty
        var currValue = this.state.value || NumericInput_1.VALUE_ZERO;
        var nextValue = this.getSanitizedValue(currValue, delta);
        this.shouldSelectAfterUpdate = this.props.selectAllOnIncrement;
        this.setState({ value: nextValue });
        this.invokeValueCallback(nextValue, this.props.onValueChange);
        return nextValue;
    };
    NumericInput.prototype.getIncrementDelta = function (direction, isShiftKeyPressed, isAltKeyPressed) {
        var _a = this.props,
            majorStepSize = _a.majorStepSize,
            minorStepSize = _a.minorStepSize,
            stepSize = _a.stepSize;
        if (isShiftKeyPressed && majorStepSize != null) {
            return direction * majorStepSize;
        } else if (isAltKeyPressed && minorStepSize != null) {
            return direction * minorStepSize;
        } else {
            return direction * stepSize;
        }
    };
    NumericInput.prototype.getSanitizedValue = function (value, delta, min, max) {
        if (delta === void 0) {
            delta = 0;
        }
        if (min === void 0) {
            min = this.props.min;
        }
        if (max === void 0) {
            max = this.props.max;
        }
        if (!this.isValueNumeric(value)) {
            return NumericInput_1.VALUE_EMPTY;
        }
        var nextValue = this.toMaxPrecision(parseFloat(value) + delta);
        // defaultProps won't work if the user passes in null, so just default
        // to +/- infinity here instead, as a catch-all.
        var adjustedMin = min != null ? min : -Infinity;
        var adjustedMax = max != null ? max : Infinity;
        nextValue = common_1.Utils.clamp(nextValue, adjustedMin, adjustedMax);
        return nextValue.toString();
    };
    NumericInput.prototype.getValueOrEmptyValue = function (value) {
        return value != null ? value.toString() : NumericInput_1.VALUE_EMPTY;
    };
    NumericInput.prototype.isValueNumeric = function (value) {
        // checking if a string is numeric in Typescript is a big pain, because
        // we can't simply toss a string parameter to isFinite. below is the
        // essential approach that jQuery uses, which involves subtracting a
        // parsed numeric value from the string representation of the value. we
        // need to cast the value to the `any` type to allow this operation
        // between dissimilar types.
        return value != null && value - parseFloat(value) + 1 >= 0;
    };
    NumericInput.prototype.isKeyboardEventDisabledForBasicNumericEntry = function (e) {
        // unit tests may not include e.key. don't bother disabling those events.
        if (e.key == null) {
            return false;
        }
        // allow modified key strokes that may involve letters and other
        // non-numeric/invalid characters (Cmd + A, Cmd + C, Cmd + V, Cmd + X).
        if (e.ctrlKey || e.altKey || e.metaKey) {
            return false;
        }
        // keys that print a single character when pressed have a `key` name of
        // length 1. every other key has a longer `key` name (e.g. "Backspace",
        // "ArrowUp", "Shift"). since none of those keys can print a character
        // to the field--and since they may have important native behaviors
        // beyond printing a character--we don't want to disable their effects.
        var isSingleCharKey = e.key.length === 1;
        if (!isSingleCharKey) {
            return false;
        }
        // now we can simply check that the single character that wants to be printed
        // is a floating-point number character that we're allowed to print.
        return !this.isFloatingPointNumericCharacter(e.key);
    };
    NumericInput.prototype.isFloatingPointNumericCharacter = function (char) {
        return NumericInput_1.FLOATING_POINT_NUMBER_CHARACTER_REGEX.test(char);
    };
    NumericInput.prototype.getStepMaxPrecision = function (props) {
        if (props.minorStepSize != null) {
            return common_1.Utils.countDecimalPlaces(props.minorStepSize);
        } else {
            return common_1.Utils.countDecimalPlaces(props.stepSize);
        }
    };
    NumericInput.prototype.toMaxPrecision = function (value) {
        // round the value to have the specified maximum precision (toFixed is the wrong choice,
        // because it would show trailing zeros in the decimal part out to the specified precision)
        // source: http://stackoverflow.com/a/18358056/5199574
        var scaleFactor = Math.pow(10, this.state.stepMaxPrecision);
        return Math.round(value * scaleFactor) / scaleFactor;
    };
    return NumericInput;
}(common_1.AbstractComponent);
NumericInput.displayName = "Blueprint.NumericInput";
NumericInput.VALUE_EMPTY = "";
NumericInput.VALUE_ZERO = "0";
NumericInput.defaultProps = {
    allowNumericCharactersOnly: true,
    buttonPosition: common_1.Position.RIGHT,
    clampValueOnBlur: false,
    large: false,
    majorStepSize: 10,
    minorStepSize: 0.1,
    selectAllOnFocus: false,
    selectAllOnIncrement: false,
    stepSize: 1,
    value: NumericInput_1.VALUE_EMPTY
};
NumericInput.DECREMENT_KEY = "decrement";
NumericInput.INCREMENT_KEY = "increment";
NumericInput.DECREMENT_ICON_NAME = "chevron-down";
NumericInput.INCREMENT_ICON_NAME = "chevron-up";
/**
 * A regex that matches a string of length 1 (i.e. a standalone character)
 * if and only if it is a floating-point number character as defined by W3C:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
 *
 * Floating-point number characters are the only characters that can be
 * printed within a default input[type="number"]. This component should
 * behave the same way when this.props.allowNumericCharactersOnly = true.
 * See here for the input[type="number"].value spec:
 * https://www.w3.org/TR/2012/WD-html-markup-20120329/input.number.html#input.number.attrs.value
 */
NumericInput.FLOATING_POINT_NUMBER_CHARACTER_REGEX = /^[Ee0-9\+\-\.]$/;
NumericInput = NumericInput_1 = tslib_1.__decorate([PureRender], NumericInput);
exports.NumericInput = NumericInput;
exports.NumericInputFactory = React.createFactory(NumericInput);
var NumericInput_1;

//# sourceMappingURL=numericInput.js.map

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var controls_1 = __webpack_require__(840);
var counter = 0;
function nextName() {
    return RadioGroup.displayName + "-" + counter++;
}
var RadioGroup = function (_super) {
    tslib_1.__extends(RadioGroup, _super);
    function RadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // a unique name for this group, which can be overridden by `name` prop.
        _this.autoGroupName = nextName();
        return _this;
    }
    RadioGroup.prototype.render = function () {
        var label = this.props.label;
        return React.createElement("div", { className: this.props.className }, label == null ? null : React.createElement("label", { className: Classes.LABEL }, label), Array.isArray(this.props.options) ? this.renderOptions() : this.renderChildren());
    };
    RadioGroup.prototype.validateProps = function () {
        if (this.props.children != null && this.props.options != null) {
            console.warn(Errors.RADIOGROUP_WARN_CHILDREN_OPTIONS_MUTEX);
        }
    };
    RadioGroup.prototype.renderChildren = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            if (isRadio(child)) {
                return React.cloneElement(child, _this.getRadioProps(child.props));
            } else {
                return child;
            }
        });
    };
    RadioGroup.prototype.renderOptions = function () {
        var _this = this;
        return this.props.options.map(function (option) {
            return React.createElement(controls_1.Radio, tslib_1.__assign({}, option, _this.getRadioProps(option), { key: option.value }));
        });
    };
    RadioGroup.prototype.getRadioProps = function (optionProps) {
        var name = this.props.name;
        var value = optionProps.value,
            disabled = optionProps.disabled;
        return {
            checked: value === this.props.selectedValue,
            disabled: disabled || this.props.disabled,
            name: name == null ? this.autoGroupName : name,
            onChange: this.props.onChange
        };
    };
    return RadioGroup;
}(abstractComponent_1.AbstractComponent);
RadioGroup.displayName = "Blueprint.RadioGroup";
exports.RadioGroup = RadioGroup;
;
function isRadio(child) {
    return child != null && child.type === controls_1.Radio;
}

//# sourceMappingURL=radioGroup.js.map

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(53);
var hotkey_1 = __webpack_require__(390);
var hotkeyParser_1 = __webpack_require__(537);
var hotkeysDialog_1 = __webpack_require__(843);
var SHOW_DIALOG_KEY = "?";
var HotkeyScope;
(function (HotkeyScope) {
    HotkeyScope[HotkeyScope["LOCAL"] = 0] = "LOCAL";
    HotkeyScope[HotkeyScope["GLOBAL"] = 1] = "GLOBAL";
})(HotkeyScope = exports.HotkeyScope || (exports.HotkeyScope = {}));
var HotkeysEvents = function () {
    function HotkeysEvents(scope) {
        var _this = this;
        this.scope = scope;
        this.actions = [];
        this.handleKeyDown = function (e) {
            var combo = hotkeyParser_1.getKeyCombo(e);
            var isTextInput = _this.isTextInput(e);
            if (!isTextInput && hotkeyParser_1.comboMatches(hotkeyParser_1.parseKeyCombo(SHOW_DIALOG_KEY), combo)) {
                if (hotkeysDialog_1.isHotkeysDialogShowing()) {
                    hotkeysDialog_1.hideHotkeysDialogAfterDelay();
                } else {
                    hotkeysDialog_1.showHotkeysDialog(_this.actions.map(function (action) {
                        return action.props;
                    }));
                }
                return;
            } else if (hotkeysDialog_1.isHotkeysDialogShowing()) {
                return;
            }
            _this.invokeNamedCallbackIfComboRecognized(combo, "onKeyDown", e);
        };
        this.handleKeyUp = function (e) {
            if (hotkeysDialog_1.isHotkeysDialogShowing()) {
                return;
            }
            _this.invokeNamedCallbackIfComboRecognized(hotkeyParser_1.getKeyCombo(e), "onKeyUp", e);
        };
    }
    HotkeysEvents.prototype.count = function () {
        return this.actions.length;
    };
    HotkeysEvents.prototype.clear = function () {
        this.actions = [];
    };
    HotkeysEvents.prototype.setHotkeys = function (props) {
        var _this = this;
        var actions = [];
        react_1.Children.forEach(props.children, function (child) {
            if (hotkey_1.Hotkey.isInstance(child) && _this.isScope(child.props)) {
                actions.push({
                    combo: hotkeyParser_1.parseKeyCombo(child.props.combo),
                    props: child.props
                });
            }
        });
        this.actions = actions;
    };
    HotkeysEvents.prototype.invokeNamedCallbackIfComboRecognized = function (combo, callbackName, e) {
        var isTextInput = this.isTextInput(e);
        for (var _i = 0, _a = this.actions; _i < _a.length; _i++) {
            var action = _a[_i];
            var shouldIgnore = isTextInput && !action.props.allowInInput || action.props.disabled;
            if (!shouldIgnore && hotkeyParser_1.comboMatches(action.combo, combo)) {
                if (action.props.preventDefault) {
                    e.preventDefault();
                }
                if (action.props.stopPropagation) {
                    // set a flag just for unit testing. not meant to be referenced in feature work.
                    e.isPropagationStopped = true;
                    e.stopPropagation();
                }
                utils_1.safeInvoke(action.props[callbackName], e);
            }
        }
    };
    HotkeysEvents.prototype.isScope = function (props) {
        return (props.global ? HotkeyScope.GLOBAL : HotkeyScope.LOCAL) === this.scope;
    };
    HotkeysEvents.prototype.isTextInput = function (e) {
        var elem = e.target;
        // we check these cases for unit testing, but this should not happen
        // during normal operation
        if (elem == null || elem.closest == null) {
            return false;
        }
        var editable = elem.closest("input, textarea, [contenteditable=true]");
        if (editable == null) {
            return false;
        }
        // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
        if (editable.tagName.toLowerCase() === "input") {
            var inputType = editable.type;
            if (inputType === "checkbox" || inputType === "radio") {
                return false;
            }
        }
        // don't let read-only fields prevent hotkey behavior
        if (editable.readOnly) {
            return false;
        }
        return true;
    };
    return HotkeysEvents;
}();
exports.HotkeysEvents = HotkeysEvents;

//# sourceMappingURL=hotkeysEvents.js.map

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(53);
var hotkeysEvents_1 = __webpack_require__(1537);
function HotkeysTarget(constructor) {
    var _a = constructor.prototype,
        componentWillMount = _a.componentWillMount,
        componentDidMount = _a.componentDidMount,
        componentWillUnmount = _a.componentWillUnmount,
        render = _a.render,
        renderHotkeys = _a.renderHotkeys;
    if (!utils_1.isFunction(renderHotkeys)) {
        throw new Error("@HotkeysTarget-decorated class must implement `renderHotkeys`. " + constructor);
    }
    // tslint:disable no-invalid-this only-arrow-functions
    constructor.prototype.componentWillMount = function () {
        this.localHotkeysEvents = new hotkeysEvents_1.HotkeysEvents(hotkeysEvents_1.HotkeyScope.LOCAL);
        this.globalHotkeysEvents = new hotkeysEvents_1.HotkeysEvents(hotkeysEvents_1.HotkeyScope.GLOBAL);
        if (componentWillMount != null) {
            componentWillMount.call(this);
        }
    };
    constructor.prototype.componentDidMount = function () {
        // attach global key event listeners
        document.addEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
        document.addEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
        if (componentDidMount != null) {
            componentDidMount.call(this);
        }
    };
    constructor.prototype.componentWillUnmount = function () {
        // detach global key event listeners
        document.removeEventListener("keydown", this.globalHotkeysEvents.handleKeyDown);
        document.removeEventListener("keyup", this.globalHotkeysEvents.handleKeyUp);
        this.globalHotkeysEvents.clear();
        this.localHotkeysEvents.clear();
        if (componentWillUnmount != null) {
            componentWillUnmount.call(this);
        }
    };
    constructor.prototype.render = function () {
        var _this = this;
        var element = render.call(this);
        var hotkeys = renderHotkeys.call(this);
        this.localHotkeysEvents.setHotkeys(hotkeys.props);
        this.globalHotkeysEvents.setHotkeys(hotkeys.props);
        // attach local key event listeners
        if (element != null && this.localHotkeysEvents.count() > 0) {
            var tabIndex = hotkeys.props.tabIndex === undefined ? 0 : hotkeys.props.tabIndex;
            var existingKeyDown_1 = element.props.onKeyDown;
            var onKeyDown = function onKeyDown(e) {
                _this.localHotkeysEvents.handleKeyDown(e.nativeEvent);
                utils_1.safeInvoke(existingKeyDown_1, e);
            };
            var existingKeyUp_1 = element.props.onKeyUp;
            var onKeyUp = function onKeyUp(e) {
                _this.localHotkeysEvents.handleKeyUp(e.nativeEvent);
                utils_1.safeInvoke(existingKeyUp_1, e);
            };
            return React.cloneElement(element, { tabIndex: tabIndex, onKeyDown: onKeyDown, onKeyUp: onKeyUp });
        } else {
            return element;
        }
    };
    // tslint:enable
}
exports.HotkeysTarget = HotkeysTarget;
;

//# sourceMappingURL=hotkeysTarget.js.map

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var MenuDivider = function (_super) {
    tslib_1.__extends(MenuDivider, _super);
    function MenuDivider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuDivider.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            title = _a.title;
        if (title == null) {
            // simple divider
            return React.createElement("li", { className: classNames(Classes.MENU_DIVIDER, className) });
        } else {
            // section header with title
            return React.createElement("li", { className: classNames(Classes.MENU_HEADER, className) }, React.createElement("h6", null, title));
        }
    };
    return MenuDivider;
}(React.Component);
MenuDivider.displayName = "Blueprint.MenuDivider";
exports.MenuDivider = MenuDivider;
exports.MenuDividerFactory = React.createFactory(MenuDivider);

//# sourceMappingURL=menuDivider.js.map

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var icon_1 = __webpack_require__(188);
var NonIdealState = function (_super) {
    tslib_1.__extends(NonIdealState, _super);
    function NonIdealState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NonIdealState.prototype.render = function () {
        return React.createElement("div", { className: classNames(Classes.NON_IDEAL_STATE, this.props.className) }, this.maybeRenderVisual(), this.maybeRenderTitle(), this.maybeRenderDescription(), this.maybeRenderAction());
    };
    NonIdealState.prototype.maybeRenderAction = function () {
        if (this.props.action == null) {
            return undefined;
        }
        return React.createElement("div", { className: Classes.NON_IDEAL_STATE_ACTION }, this.props.action);
    };
    NonIdealState.prototype.maybeRenderDescription = function () {
        if (this.props.description == null) {
            return undefined;
        }
        return React.createElement("div", { className: Classes.NON_IDEAL_STATE_DESCRIPTION }, this.props.description);
    };
    NonIdealState.prototype.maybeRenderTitle = function () {
        if (this.props.title == null) {
            return undefined;
        }
        return React.createElement("h4", { className: Classes.NON_IDEAL_STATE_TITLE }, this.props.title);
    };
    NonIdealState.prototype.maybeRenderVisual = function () {
        var visual = this.props.visual;
        if (visual == null) {
            return undefined;
        } else if (typeof visual === "string") {
            return React.createElement("div", { className: classNames(Classes.NON_IDEAL_STATE_VISUAL, Classes.NON_IDEAL_STATE_ICON) }, React.createElement(icon_1.Icon, { iconName: visual, iconSize: "inherit" }));
        } else {
            return React.createElement("div", { className: Classes.NON_IDEAL_STATE_VISUAL }, visual);
        }
    };
    return NonIdealState;
}(React.Component);
NonIdealState = tslib_1.__decorate([PureRender], NonIdealState);
exports.NonIdealState = NonIdealState;
exports.NonIdealStateFactory = React.createFactory(NonIdealState);

//# sourceMappingURL=nonIdealState.js.map

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var position_1 = __webpack_require__(157);
// this value causes popover and target edges to line up on 50px targets
exports.MIN_ARROW_SPACING = 18;
function computeArrowOffset(sideLength, arrowSize, minimum) {
    if (minimum === void 0) {
        minimum = exports.MIN_ARROW_SPACING;
    }
    return Math.max(Math.round((sideLength - arrowSize) / 2), minimum);
}
exports.computeArrowOffset = computeArrowOffset;
function getPopoverTransformOrigin(position, arrowSize, targetDimensions) {
    var offsetX = computeArrowOffset(targetDimensions.width, arrowSize);
    var offsetY = computeArrowOffset(targetDimensions.height, arrowSize);
    switch (position) {
        case position_1.Position.TOP_LEFT:
            return offsetX + "px bottom";
        case position_1.Position.TOP_RIGHT:
            return "calc(100% - " + offsetX + "px) bottom";
        case position_1.Position.BOTTOM_LEFT:
            return offsetX + "px top";
        case position_1.Position.BOTTOM_RIGHT:
            return "calc(100% - " + offsetX + "px) top";
        case position_1.Position.LEFT_TOP:
            return "right " + offsetY + "px";
        case position_1.Position.LEFT_BOTTOM:
            return "right calc(100% - " + offsetY + "px)";
        case position_1.Position.RIGHT_TOP:
            return "left " + offsetY + "px";
        case position_1.Position.RIGHT_BOTTOM:
            return "left calc(100% - " + offsetY + "px)";
        default:
            return undefined;
    }
}
exports.getPopoverTransformOrigin = getPopoverTransformOrigin;
function getArrowPositionStyles(position, arrowSize, ignoreTargetDimensions, targetDimensions, inline) {
    // compute the offset to center an arrow with given hypotenuse in a side of the given length
    var popoverOffset = function popoverOffset(sideLength) {
        var offset = computeArrowOffset(sideLength, arrowSize, 0);
        return offset < exports.MIN_ARROW_SPACING ? exports.MIN_ARROW_SPACING - offset : 0;
    };
    var popoverOffsetX = popoverOffset(targetDimensions.width);
    var popoverOffsetY = popoverOffset(targetDimensions.height);
    // TOP, RIGHT, BOTTOM, LEFT are handled purely in CSS because of centering transforms
    switch (position) {
        case position_1.Position.TOP_LEFT:
        case position_1.Position.BOTTOM_LEFT:
            return {
                arrow: ignoreTargetDimensions ? {} : { left: computeArrowOffset(targetDimensions.width, arrowSize) },
                container: { marginLeft: -popoverOffsetX }
            };
        case position_1.Position.TOP_RIGHT:
        case position_1.Position.BOTTOM_RIGHT:
            return {
                arrow: ignoreTargetDimensions ? {} : { right: computeArrowOffset(targetDimensions.width, arrowSize) },
                container: { marginLeft: popoverOffsetX }
            };
        case position_1.Position.RIGHT_TOP:
        case position_1.Position.LEFT_TOP:
            return {
                arrow: ignoreTargetDimensions ? {} : { top: computeArrowOffset(targetDimensions.height, arrowSize) },
                container: inline ? { top: -popoverOffsetY } : { marginTop: -popoverOffsetY }
            };
        case position_1.Position.RIGHT_BOTTOM:
        case position_1.Position.LEFT_BOTTOM:
            return {
                arrow: ignoreTargetDimensions ? {} : { bottom: computeArrowOffset(targetDimensions.height, arrowSize) },
                container: inline ? { bottom: -popoverOffsetY } : { marginTop: popoverOffsetY }
            };
        default:
            return {};
    }
}
exports.getArrowPositionStyles = getArrowPositionStyles;

//# sourceMappingURL=arrows.js.map

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var popover_1 = __webpack_require__(266);
var SVGPopover = function (_super) {
    tslib_1.__extends(SVGPopover, _super);
    function SVGPopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPopover.prototype.render = function () {
        return React.createElement(popover_1.Popover, tslib_1.__assign({ rootElementTag: "g" }, this.props), this.props.children);
    };
    return SVGPopover;
}(React.Component);
exports.SVGPopover = SVGPopover;
exports.SVGPopoverFactory = React.createFactory(SVGPopover);

//# sourceMappingURL=svgPopover.js.map

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
var ProgressBar = function (_super) {
    tslib_1.__extends(ProgressBar, _super);
    function ProgressBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressBar.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            intent = _a.intent,
            value = _a.value;
        var classes = classNames("pt-progress-bar", Classes.intentClass(intent), className);
        // don't set width if value is null (rely on default CSS value)
        var width = value == null ? null : 100 * utils_1.clamp(value, 0, 1) + "%";
        return React.createElement("div", { className: classes }, React.createElement("div", { className: "pt-progress-meter", style: { width: width } }));
    };
    return ProgressBar;
}(React.Component);
ProgressBar.displayName = "Blueprint.ProgressBar";
ProgressBar = tslib_1.__decorate([PureRender], ProgressBar);
exports.ProgressBar = ProgressBar;
exports.ProgressBarFactory = React.createFactory(ProgressBar);

//# sourceMappingURL=progressBar.js.map

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var utils_1 = __webpack_require__(53);
var coreSlider_1 = __webpack_require__(848);
var handle_1 = __webpack_require__(849);
var RangeEnd;
(function (RangeEnd) {
    RangeEnd[RangeEnd["LEFT"] = 0] = "LEFT";
    RangeEnd[RangeEnd["RIGHT"] = 1] = "RIGHT";
})(RangeEnd || (RangeEnd = {}));
var RangeSlider = function (_super) {
    tslib_1.__extends(RangeSlider, _super);
    function RangeSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = classNames(Classes.SLIDER, Classes.RANGE_SLIDER);
        _this.handles = [];
        _this.addHandleRef = function (ref) {
            if (ref != null) {
                _this.handles.push(ref);
            }
        };
        _this.getHandlerForIndex = function (index, callback) {
            return function (newValue) {
                if (utils_1.isFunction(callback)) {
                    var _a = _this.props.value,
                        leftValue = _a[0],
                        rightValue = _a[1];
                    if (index === RangeEnd.LEFT) {
                        callback([Math.min(newValue, rightValue), rightValue]);
                    } else {
                        callback([leftValue, Math.max(newValue, leftValue)]);
                    }
                }
            };
        };
        _this.handleChange = function (newValue) {
            var _a = _this.props.value,
                leftValue = _a[0],
                rightValue = _a[1];
            var newLeftValue = newValue[0],
                newRightValue = newValue[1];
            if ((leftValue !== newLeftValue || rightValue !== newRightValue) && utils_1.isFunction(_this.props.onChange)) {
                _this.props.onChange(newValue);
            }
        };
        return _this;
    }
    RangeSlider.prototype.renderFill = function () {
        var _a = this.props.value,
            leftValue = _a[0],
            rightValue = _a[1];
        if (leftValue === rightValue) {
            return undefined;
        }
        // expand by 1px in each direction so it sits under the handle border
        var left = Math.round((leftValue - this.props.min) * this.state.tickSize) - 1;
        var width = Math.round((rightValue - leftValue) * this.state.tickSize) + 2;
        if (width < 0) {
            left += width;
            width = Math.abs(width);
        }
        return React.createElement("div", { className: Classes.SLIDER + "-progress", style: { left: left, width: width } });
    };
    RangeSlider.prototype.renderHandles = function () {
        var _this = this;
        var _a = this.props,
            disabled = _a.disabled,
            max = _a.max,
            min = _a.min,
            onRelease = _a.onRelease,
            stepSize = _a.stepSize,
            value = _a.value;
        return value.map(function (val, index) {
            return React.createElement(handle_1.Handle, { disabled: disabled, key: index, label: _this.formatLabel(val), max: max, min: min, onChange: _this.getHandlerForIndex(index, _this.handleChange), onRelease: _this.getHandlerForIndex(index, onRelease), ref: _this.addHandleRef, stepSize: stepSize, tickSize: _this.state.tickSize, value: val });
        });
    };
    RangeSlider.prototype.handleTrackClick = function (event) {
        var _this = this;
        this.handles.reduce(function (min, handle) {
            // find closest handle to the mouse position
            var value = handle.clientToValue(event.clientX);
            return _this.nearestHandleForValue(value, min, handle);
        }).beginHandleMovement(event);
    };
    RangeSlider.prototype.handleTrackTouch = function (event) {
        var _this = this;
        this.handles.reduce(function (min, handle) {
            // find closest handle to the touch position
            var value = handle.clientToValue(handle.touchEventClientX(event));
            return _this.nearestHandleForValue(value, min, handle);
        }).beginHandleTouchMovement(event);
    };
    RangeSlider.prototype.nearestHandleForValue = function (value, firstHandle, secondHandle) {
        var firstDistance = Math.abs(value - firstHandle.props.value);
        var secondDistance = Math.abs(value - secondHandle.props.value);
        return secondDistance < firstDistance ? secondHandle : firstHandle;
    };
    RangeSlider.prototype.validateProps = function (props) {
        var value = props.value;
        if (value == null || value[RangeEnd.LEFT] == null || value[RangeEnd.RIGHT] == null) {
            throw new Error(Errors.RANGESLIDER_NULL_VALUE);
        }
    };
    return RangeSlider;
}(coreSlider_1.CoreSlider);
RangeSlider.defaultProps = {
    disabled: false,
    labelStepSize: 1,
    max: 10,
    min: 0,
    showTrackFill: true,
    stepSize: 1,
    value: [0, 10]
};
RangeSlider.displayName = "Blueprint.RangeSlider";
exports.RangeSlider = RangeSlider;
exports.RangeSliderFactory = React.createFactory(RangeSlider);

//# sourceMappingURL=rangeSlider.js.map

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
var coreSlider_1 = __webpack_require__(848);
var handle_1 = __webpack_require__(849);
var Slider = function (_super) {
    tslib_1.__extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleHandleRef = function (ref) {
            _this.handle = ref;
        };
        return _this;
    }
    Slider.prototype.renderFill = function () {
        var initialValue = utils_1.clamp(this.props.initialValue, this.props.min, this.props.max);
        var left = Math.round((initialValue - this.props.min) * this.state.tickSize);
        var width = Math.round((this.props.value - initialValue) * this.state.tickSize);
        if (width < 0) {
            left += width;
            width = Math.abs(width);
        }
        return React.createElement("div", { className: Classes.SLIDER + "-progress", style: { left: left, width: width } });
    };
    Slider.prototype.renderHandles = function () {
        // make sure to *not* pass this.props.className to handle
        return React.createElement(handle_1.Handle, tslib_1.__assign({}, this.props, this.state, { className: "", label: this.formatLabel(this.props.value), ref: this.handleHandleRef }));
    };
    Slider.prototype.handleTrackClick = function (event) {
        if (this.handle != null) {
            this.handle.beginHandleMovement(event);
        }
    };
    Slider.prototype.handleTrackTouch = function (event) {
        if (this.handle != null) {
            this.handle.beginHandleTouchMovement(event);
        }
    };
    return Slider;
}(coreSlider_1.CoreSlider);
Slider.defaultProps = {
    disabled: false,
    initialValue: 0,
    labelStepSize: 1,
    max: 10,
    min: 0,
    showTrackFill: true,
    stepSize: 1,
    value: 0
};
exports.Slider = Slider;
exports.SliderFactory = React.createFactory(Slider);

//# sourceMappingURL=slider.js.map

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
// import * to avoid "cannot be named" error on factory
var spinner = __webpack_require__(539);
var SVGSpinner = function (_super) {
    tslib_1.__extends(SVGSpinner, _super);
    function SVGSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGSpinner.prototype.renderContainer = function (classes, content) {
        return React.createElement("g", { className: classNames(Classes.SVG_SPINNER, classes) }, React.createElement("g", { className: "pt-svg-spinner-transform-group" }, content));
    };
    return SVGSpinner;
}(spinner.Spinner);
exports.SVGSpinner = SVGSpinner;
exports.SVGSpinnerFactory = React.createFactory(SVGSpinner);

//# sourceMappingURL=svgSpinner.js.map

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(44);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Errors = __webpack_require__(93);
var Keys = __webpack_require__(187);
var Utils = __webpack_require__(53);
var tab_1 = __webpack_require__(850);
var tabList_1 = __webpack_require__(851);
var tabPanel_1 = __webpack_require__(852);
var TAB_CSS_SELECTOR = "li[role=tab]";
var Tabs = function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs(props, context) {
        var _this = _super.call(this, props, context) || this;
        // state is initialized in the constructor but getStateFromProps needs state defined
        _this.state = {};
        _this.panelIds = [];
        _this.tabIds = [];
        _this.handleClick = function (e) {
            _this.handleTabSelectingEvent(e);
        };
        _this.handleKeyPress = function (e) {
            var insideTab = e.target.closest("." + Classes.TAB) != null;
            if (insideTab && (e.which === Keys.SPACE || e.which === Keys.ENTER)) {
                e.preventDefault();
                _this.handleTabSelectingEvent(e);
            }
        };
        _this.handleKeyDown = function (e) {
            // don't want to handle keyDown events inside a tab panel
            var insideTabList = e.target.closest("." + Classes.TAB_LIST) != null;
            if (!insideTabList) {
                return;
            }
            var focusedTabIndex = _this.getFocusedTabIndex();
            if (focusedTabIndex === -1) {
                return;
            }
            if (e.which === Keys.ARROW_LEFT) {
                e.preventDefault();
                // find previous tab that isn't disabled
                var newTabIndex = focusedTabIndex - 1;
                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
                while (tabIsDisabled && newTabIndex !== -1) {
                    newTabIndex--;
                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
                }
                if (newTabIndex !== -1) {
                    _this.focusTab(newTabIndex);
                }
            } else if (e.which === Keys.ARROW_RIGHT) {
                e.preventDefault();
                // find next tab that isn't disabled
                var tabsCount = _this.getTabsCount();
                var newTabIndex = focusedTabIndex + 1;
                var tabIsDisabled = _this.isTabDisabled(newTabIndex);
                while (tabIsDisabled && newTabIndex !== tabsCount) {
                    newTabIndex++;
                    tabIsDisabled = _this.isTabDisabled(newTabIndex);
                }
                if (newTabIndex !== tabsCount) {
                    _this.focusTab(newTabIndex);
                }
            }
        };
        _this.handleTabSelectingEvent = function (e) {
            var tabElement = e.target.closest(TAB_CSS_SELECTOR);
            // select only if Tab is one of us and is enabled
            if (tabElement != null && _this.tabIds.indexOf(tabElement.id) >= 0 && tabElement.getAttribute("aria-disabled") !== "true") {
                var index = tabElement.parentElement.queryAll(TAB_CSS_SELECTOR).indexOf(tabElement);
                _this.setSelectedTabIndex(index);
            }
        };
        _this.state = _this.getStateFromProps(_this.props);
        if (!Utils.isNodeEnv("production")) {
            console.warn(Errors.TABS_WARN_DEPRECATED);
        }
        return _this;
    }
    Tabs.prototype.render = function () {
        return React.createElement("div", { className: classNames(Classes.TABS, this.props.className), onClick: this.handleClick, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown }, this.getChildren());
    };
    Tabs.prototype.componentWillReceiveProps = function (newProps) {
        var newState = this.getStateFromProps(newProps);
        this.setState(newState);
    };
    Tabs.prototype.componentDidMount = function () {
        var _this = this;
        var selectedTab = react_dom_1.findDOMNode(this.refs["tabs-" + this.state.selectedTabIndex]);
        this.setTimeout(function () {
            return _this.moveIndicator(selectedTab);
        });
    };
    Tabs.prototype.componentDidUpdate = function (_, prevState) {
        var _this = this;
        var newIndex = this.state.selectedTabIndex;
        if (newIndex !== prevState.selectedTabIndex) {
            var tabElement_1 = react_dom_1.findDOMNode(this.refs["tabs-" + newIndex]);
            // need to measure on the next frame in case the Tab children simultaneously change
            this.setTimeout(function () {
                return _this.moveIndicator(tabElement_1);
            });
        }
    };
    Tabs.prototype.validateProps = function (props) {
        if (React.Children.count(props.children) > 0) {
            var child = React.Children.toArray(props.children)[0];
            if (child != null && child.type !== tabList_1.TabList) {
                throw new Error(Errors.TABS_FIRST_CHILD);
            }
            if (this.getTabsCount() !== this.getPanelsCount()) {
                throw new Error(Errors.TABS_MISMATCH);
            }
        }
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */
    Tabs.prototype.moveIndicator = function (_a) {
        var clientHeight = _a.clientHeight,
            clientWidth = _a.clientWidth,
            offsetLeft = _a.offsetLeft,
            offsetTop = _a.offsetTop;
        var indicatorWrapperStyle = {
            height: clientHeight,
            transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
            width: clientWidth
        };
        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
    };
    /**
     * Most of the component logic lives here. We clone the children provided by the user to set up refs,
     * accessibility attributes, and selection props correctly.
     */
    Tabs.prototype.getChildren = function () {
        var _this = this;
        for (var unassignedTabs = this.getTabsCount() - this.tabIds.length; unassignedTabs > 0; unassignedTabs--) {
            this.tabIds.push(generateTabId());
            this.panelIds.push(generatePanelId());
        }
        var childIndex = 0;
        return React.Children.map(this.props.children, function (child) {
            var result;
            // can be null if conditionally rendering TabList / TabPanel
            if (child == null) {
                return null;
            }
            if (childIndex === 0) {
                // clone TabList / Tab elements
                result = _this.cloneTabList(child);
            } else {
                var tabPanelIndex = childIndex - 1;
                var shouldRenderTabPanel = _this.state.selectedTabIndex === tabPanelIndex;
                result = shouldRenderTabPanel ? _this.cloneTabPanel(child, tabPanelIndex) : null;
            }
            childIndex++;
            return result;
        });
    };
    Tabs.prototype.cloneTabList = function (child) {
        var _this = this;
        var tabIndex = 0;
        var tabs = React.Children.map(child.props.children, function (tab) {
            // can be null if conditionally rendering Tab
            if (tab == null) {
                return null;
            }
            var clonedTab = React.cloneElement(tab, {
                id: _this.tabIds[tabIndex],
                isSelected: _this.state.selectedTabIndex === tabIndex,
                panelId: _this.panelIds[tabIndex],
                ref: "tabs-" + tabIndex
            });
            tabIndex++;
            return clonedTab;
        });
        return React.cloneElement(child, {
            children: tabs,
            indicatorWrapperStyle: this.state.indicatorWrapperStyle,
            ref: "tablist"
        });
    };
    Tabs.prototype.cloneTabPanel = function (child, tabIndex) {
        return React.cloneElement(child, {
            id: this.panelIds[tabIndex],
            isSelected: this.state.selectedTabIndex === tabIndex,
            ref: "panels-" + tabIndex,
            tabId: this.tabIds[tabIndex]
        });
    };
    Tabs.prototype.focusTab = function (index) {
        var ref = "tabs-" + index;
        var tab = react_dom_1.findDOMNode(this.refs[ref]);
        tab.focus();
    };
    Tabs.prototype.getFocusedTabIndex = function () {
        var focusedElement = document.activeElement;
        if (focusedElement != null && focusedElement.classList.contains(Classes.TAB)) {
            var tabId = focusedElement.id;
            return this.tabIds.indexOf(tabId);
        }
        return -1;
    };
    Tabs.prototype.getTabs = function () {
        if (this.props.children == null) {
            return [];
        }
        var tabs = [];
        if (React.Children.count(this.props.children) > 0) {
            var firstChild = React.Children.toArray(this.props.children)[0];
            if (firstChild != null) {
                React.Children.forEach(firstChild.props.children, function (tabListChild) {
                    if (tabListChild.type === tab_1.Tab) {
                        tabs.push(tabListChild);
                    }
                });
            }
        }
        return tabs;
    };
    Tabs.prototype.getTabsCount = function () {
        return this.getTabs().length;
    };
    Tabs.prototype.getPanelsCount = function () {
        if (this.props.children == null) {
            return 0;
        }
        var index = 0;
        var panelCount = 0;
        React.Children.forEach(this.props.children, function (child) {
            if (child.type === tabPanel_1.TabPanel) {
                panelCount++;
            }
            index++;
        });
        return panelCount;
    };
    Tabs.prototype.getStateFromProps = function (props) {
        var selectedTabIndex = props.selectedTabIndex,
            initialSelectedTabIndex = props.initialSelectedTabIndex;
        if (this.isValidTabIndex(selectedTabIndex)) {
            return { selectedTabIndex: selectedTabIndex };
        } else if (this.isValidTabIndex(initialSelectedTabIndex) && this.state.selectedTabIndex == null) {
            return { selectedTabIndex: initialSelectedTabIndex };
        } else {
            return this.state;
        }
    };
    Tabs.prototype.isTabDisabled = function (index) {
        var tab = this.getTabs()[index];
        return tab != null && tab.props.isDisabled;
    };
    Tabs.prototype.isValidTabIndex = function (index) {
        return index != null && index >= 0 && index < this.getTabsCount();
    };
    /**
     * Updates the component's state if uncontrolled and calls onChange.
     */
    Tabs.prototype.setSelectedTabIndex = function (index) {
        if (index === this.state.selectedTabIndex || !this.isValidTabIndex(index)) {
            return;
        }
        var prevSelectedIndex = this.state.selectedTabIndex;
        if (this.props.selectedTabIndex == null) {
            this.setState({
                selectedTabIndex: index
            });
        }
        if (Utils.isFunction(this.props.onChange)) {
            this.props.onChange(index, prevSelectedIndex);
        }
    };
    return Tabs;
}(abstractComponent_1.AbstractComponent);
Tabs.defaultProps = {
    initialSelectedTabIndex: 0
};
Tabs.displayName = "Blueprint.Tabs";
Tabs = tslib_1.__decorate([PureRender], Tabs);
exports.Tabs = Tabs;
var tabCount = 0;
function generateTabId() {
    return "pt-tab-" + tabCount++;
}
var panelCount = 0;
function generatePanelId() {
    return "pt-tab-panel-" + panelCount++;
}
exports.TabsFactory = React.createFactory(Tabs);

//# sourceMappingURL=tabs.js.map

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var TabTitle = function (_super) {
    tslib_1.__extends(TabTitle, _super);
    function TabTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            return _this.props.onClick(_this.props.id, e);
        };
        return _this;
    }
    TabTitle.prototype.render = function () {
        var _a = this.props,
            disabled = _a.disabled,
            id = _a.id,
            parentId = _a.parentId,
            selected = _a.selected;
        return React.createElement("div", { "aria-controls": generateTabPanelId(parentId, id), "aria-disabled": disabled, "aria-expanded": selected, "aria-selected": selected, className: classNames(Classes.TAB, this.props.className), "data-tab-id": id, id: generateTabTitleId(parentId, id), onClick: disabled ? undefined : this.handleClick, role: "tab", selected: selected ? true : undefined, tabIndex: disabled ? undefined : 0 }, this.props.title, this.props.children);
    };
    return TabTitle;
}(React.Component);
TabTitle.displayName = "Blueprint.TabTitle";
TabTitle = tslib_1.__decorate([PureRender], TabTitle);
exports.TabTitle = TabTitle;
function generateTabPanelId(parentId, tabId) {
    return Classes.TAB_PANEL + "_" + parentId + "_" + tabId;
}
exports.generateTabPanelId = generateTabPanelId;
function generateTabTitleId(parentId, tabId) {
    return Classes.TAB + "-title_" + parentId + "_" + tabId;
}
exports.generateTabTitleId = generateTabTitleId;

//# sourceMappingURL=tabTitle.js.map

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var Keys = __webpack_require__(187);
var utils_1 = __webpack_require__(53);
var tab2_1 = __webpack_require__(853);
var tabTitle_1 = __webpack_require__(1548);
exports.Expander = function () {
    return React.createElement("div", { className: "pt-flex-expander" });
};
var TAB_SELECTOR = "." + Classes.TAB;
var Tabs2 = function (_super) {
    tslib_1.__extends(Tabs2, _super);
    function Tabs2(props) {
        var _this = _super.call(this, props) || this;
        _this.refHandlers = {
            tablist: function tablist(tabElement) {
                return _this.tablistElement = tabElement;
            }
        };
        _this.handleKeyDown = function (e) {
            var focusedElement = document.activeElement.closest(TAB_SELECTOR);
            // rest of this is potentially expensive and futile, so bail if no tab is focused
            if (focusedElement == null) {
                return;
            }
            // must rely on DOM state because we have no way of mapping `focusedElement` to a JSX.Element
            var enabledTabElements = _this.getTabElements().filter(function (el) {
                return el.getAttribute("aria-disabled") === "false";
            });
            var focusedIndex = enabledTabElements.indexOf(focusedElement);
            var direction = _this.getKeyCodeDirection(e);
            if (focusedIndex >= 0 && direction !== undefined) {
                e.preventDefault();
                var length_1 = enabledTabElements.length;
                // auto-wrapping at 0 and `length`
                var nextFocusedIndex = (focusedIndex + direction + length_1) % length_1;
                enabledTabElements[nextFocusedIndex].focus();
            }
        };
        _this.handleKeyPress = function (e) {
            var targetTabElement = e.target.closest(TAB_SELECTOR);
            if (targetTabElement != null && isEventKeyCode(e, Keys.SPACE, Keys.ENTER)) {
                e.preventDefault();
                targetTabElement.click();
            }
        };
        _this.handleTabClick = function (newTabId, event) {
            utils_1.safeInvoke(_this.props.onChange, newTabId, _this.state.selectedTabId, event);
            if (_this.props.selectedTabId === undefined) {
                _this.setState({ selectedTabId: newTabId });
            }
        };
        _this.renderTabPanel = function (tab) {
            var _a = tab.props,
                className = _a.className,
                panel = _a.panel,
                id = _a.id;
            if (panel === undefined) {
                return undefined;
            }
            return React.createElement("div", { "aria-labelledby": tabTitle_1.generateTabTitleId(_this.props.id, id), "aria-hidden": id !== _this.state.selectedTabId, className: classNames(Classes.TAB_PANEL, className), id: tabTitle_1.generateTabPanelId(_this.props.id, id), key: id, role: "tabpanel" }, panel);
        };
        _this.renderTabTitle = function (tab) {
            var id = tab.props.id;
            return React.createElement(tabTitle_1.TabTitle, tslib_1.__assign({}, tab.props, { parentId: _this.props.id, onClick: _this.handleTabClick, selected: id === _this.state.selectedTabId }));
        };
        var selectedTabId = _this.getInitialSelectedTabId();
        _this.state = { selectedTabId: selectedTabId };
        return _this;
    }
    Tabs2.prototype.render = function () {
        var _this = this;
        var _a = this.state,
            indicatorWrapperStyle = _a.indicatorWrapperStyle,
            selectedTabId = _a.selectedTabId;
        var tabTitles = React.Children.map(this.props.children, function (child) {
            return isTab(child) ? _this.renderTabTitle(child) : child;
        });
        var tabPanels = this.getTabChildren().filter(this.props.renderActiveTabPanelOnly ? function (tab) {
            return tab.props.id === selectedTabId;
        } : function () {
            return true;
        }).map(this.renderTabPanel);
        var tabIndicator = React.createElement("div", { className: "pt-tab-indicator-wrapper", style: indicatorWrapperStyle }, React.createElement("div", { className: "pt-tab-indicator" }));
        var classes = classNames(Classes.TABS, (_b = {}, _b[Classes.VERTICAL] = this.props.vertical, _b), this.props.className);
        return React.createElement("div", { className: classes }, React.createElement("div", { className: Classes.TAB_LIST, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, ref: this.refHandlers.tablist, role: "tablist" }, this.props.animate ? tabIndicator : undefined, tabTitles), tabPanels);
        var _b;
    };
    Tabs2.prototype.componentDidMount = function () {
        this.moveSelectionIndicator();
    };
    Tabs2.prototype.componentWillReceiveProps = function (_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) {
            // keep state in sync with controlled prop, so state is canonical source of truth
            this.setState({ selectedTabId: selectedTabId });
        }
    };
    Tabs2.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) {
            this.moveSelectionIndicator();
        }
    };
    Tabs2.prototype.getInitialSelectedTabId = function () {
        // NOTE: providing an unknown ID will hide the selection
        var _a = this.props,
            defaultSelectedTabId = _a.defaultSelectedTabId,
            selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) {
            return selectedTabId;
        } else if (defaultSelectedTabId !== undefined) {
            return defaultSelectedTabId;
        } else {
            // select first tab in absence of user input
            var tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    };
    Tabs2.prototype.getKeyCodeDirection = function (e) {
        if (isEventKeyCode(e, Keys.ARROW_LEFT, Keys.ARROW_UP)) {
            return -1;
        } else if (isEventKeyCode(e, Keys.ARROW_RIGHT, Keys.ARROW_DOWN)) {
            return 1;
        }
        return undefined;
    };
    /** Filters this.props.children to only `<Tab>`s */
    Tabs2.prototype.getTabChildren = function () {
        return React.Children.toArray(this.props.children).filter(isTab);
    };
    /** Queries root HTML element for all `.pt-tab`s with optional filter selector */
    Tabs2.prototype.getTabElements = function (subselector) {
        if (subselector === void 0) {
            subselector = "";
        }
        if (this.tablistElement == null) {
            return [];
        }
        return this.tablistElement.queryAll(TAB_SELECTOR + subselector);
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */
    Tabs2.prototype.moveSelectionIndicator = function () {
        if (this.tablistElement === undefined) {
            return;
        }
        var tabIdSelector = TAB_SELECTOR + "[data-tab-id=\"" + this.state.selectedTabId + "\"]";
        var selectedTabElement = this.tablistElement.query(tabIdSelector);
        var indicatorWrapperStyle = { display: "none" };
        if (selectedTabElement != null) {
            var clientHeight = selectedTabElement.clientHeight,
                clientWidth = selectedTabElement.clientWidth,
                offsetLeft = selectedTabElement.offsetLeft,
                offsetTop = selectedTabElement.offsetTop;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
                width: clientWidth
            };
        }
        this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
    };
    return Tabs2;
}(abstractComponent_1.AbstractComponent);
/** Insert a `Tabs2.Expander` between any two children to right-align all subsequent children. */
Tabs2.Expander = exports.Expander;
Tabs2.Tab = tab2_1.Tab2;
Tabs2.defaultProps = {
    animate: true,
    renderActiveTabPanelOnly: false,
    vertical: false
};
Tabs2.displayName = "Blueprint.Tabs2";
Tabs2 = tslib_1.__decorate([PureRender], Tabs2);
exports.Tabs2 = Tabs2;
exports.Tabs2Factory = React.createFactory(Tabs2);
function isEventKeyCode(e) {
    var codes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        codes[_i - 1] = arguments[_i];
    }
    return codes.indexOf(e.which) >= 0;
}
function isTab(child) {
    return child != null && child.type === tab2_1.Tab2;
}

//# sourceMappingURL=tabs2.js.map

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var common_1 = __webpack_require__(186);
var props_1 = __webpack_require__(265);
var Classes = __webpack_require__(37);
var Tag = function (_super) {
    tslib_1.__extends(Tag, _super);
    function Tag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRemoveClick = function (e) {
            common_1.Utils.safeInvoke(_this.props.onRemove, e, _this.props);
        };
        return _this;
    }
    Tag.prototype.render = function () {
        var _a = this.props,
            active = _a.active,
            className = _a.className,
            intent = _a.intent,
            onRemove = _a.onRemove;
        var tagClasses = classNames(Classes.TAG, Classes.intentClass(intent), (_b = {}, _b[Classes.TAG_REMOVABLE] = onRemove != null, _b[Classes.ACTIVE] = active, _b), className);
        var button = common_1.Utils.isFunction(onRemove) ? React.createElement("button", { type: "button", className: Classes.TAG_REMOVE, onClick: this.onRemoveClick }) : undefined;
        return React.createElement("span", tslib_1.__assign({}, props_1.removeNonHTMLProps(this.props), { className: tagClasses }), this.props.children, button);
        var _b;
    };
    return Tag;
}(React.Component);
Tag.displayName = "Blueprint.Tag";
Tag = tslib_1.__decorate([PureRender], Tag);
exports.Tag = Tag;
exports.TagFactory = React.createFactory(Tag);

//# sourceMappingURL=tag.js.map

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var Text = function (_super) {
    tslib_1.__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isContentOverflowing: false,
            textContent: ""
        };
        _this.refHandlers = {
            text: function text(overflowElement) {
                return _this.textRef = overflowElement;
            }
        };
        return _this;
    }
    Text.prototype.componentDidMount = function () {
        this.update();
    };
    Text.prototype.componentDidUpdate = function () {
        this.update();
    };
    Text.prototype.render = function () {
        var classes = classNames((_a = {}, _a[Classes.TEXT_OVERFLOW_ELLIPSIS] = this.props.ellipsize, _a), this.props.className);
        return React.createElement("div", { className: classes, ref: this.refHandlers.text, title: this.state.isContentOverflowing ? this.state.textContent : undefined }, this.props.children);
        var _a;
    };
    Text.prototype.update = function () {
        var newState = {
            isContentOverflowing: this.props.ellipsize && this.textRef.scrollWidth > this.textRef.clientWidth,
            textContent: this.textRef.textContent
        };
        this.setState(newState);
    };
    return Text;
}(React.Component);
Text = tslib_1.__decorate([PureRender], Text);
exports.Text = Text;

//# sourceMappingURL=text.js.map

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var PureRender = __webpack_require__(60);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var abstractComponent_1 = __webpack_require__(92);
var Classes = __webpack_require__(37);
var errors_1 = __webpack_require__(93);
var keys_1 = __webpack_require__(187);
var position_1 = __webpack_require__(157);
var utils_1 = __webpack_require__(53);
var overlay_1 = __webpack_require__(391);
var toast_1 = __webpack_require__(854);
var Toaster = Toaster_1 = function (_super) {
    tslib_1.__extends(Toaster, _super);
    function Toaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toasts: []
        };
        // auto-incrementing identifier for un-keyed toasts
        _this.toastId = 0;
        _this.getDismissHandler = function (toast) {
            return function (timeoutExpired) {
                _this.dismiss(toast.key, timeoutExpired);
            };
        };
        _this.handleClose = function (e) {
            // NOTE that `e` isn't always a KeyboardEvent but that's the only type we care about
            if (e.which === keys_1.ESCAPE) {
                _this.clear();
            }
        };
        return _this;
    }
    /**
     * Create a new `Toaster` instance that can be shared around your application.
     * The `Toaster` will be rendered into a new element appended to the given container.
     */
    Toaster.create = function (props, container) {
        if (container === void 0) {
            container = document.body;
        }
        if (props != null && props.inline != null && !utils_1.isNodeEnv("production")) {
            console.warn(errors_1.TOASTER_WARN_INLINE);
        }
        var containerElement = document.createElement("div");
        container.appendChild(containerElement);
        return ReactDOM.render(React.createElement(Toaster_1, tslib_1.__assign({}, props, { inline: true })), containerElement);
    };
    Toaster.prototype.show = function (props) {
        var options = this.createToastOptions(props);
        this.setState(function (prevState) {
            return {
                toasts: [options].concat(prevState.toasts)
            };
        });
        return options.key;
    };
    Toaster.prototype.update = function (key, props) {
        var options = this.createToastOptions(props, key);
        this.setState(function (prevState) {
            return {
                toasts: prevState.toasts.map(function (t) {
                    return t.key === key ? options : t;
                })
            };
        });
    };
    Toaster.prototype.dismiss = function (key, timeoutExpired) {
        if (timeoutExpired === void 0) {
            timeoutExpired = false;
        }
        this.setState(function (_a) {
            var toasts = _a.toasts;
            return {
                toasts: toasts.filter(function (t) {
                    var matchesKey = t.key === key;
                    if (matchesKey) {
                        utils_1.safeInvoke(t.onDismiss, timeoutExpired);
                    }
                    return !matchesKey;
                })
            };
        });
    };
    Toaster.prototype.clear = function () {
        this.state.toasts.map(function (t) {
            return utils_1.safeInvoke(t.onDismiss, false);
        });
        this.setState({ toasts: [] });
    };
    Toaster.prototype.getToasts = function () {
        return this.state.toasts;
    };
    Toaster.prototype.render = function () {
        // $pt-transition-duration * 3 + $pt-transition-duration / 2
        var classes = classNames(Classes.TOAST_CONTAINER, this.getPositionClasses(), this.props.className);
        return React.createElement(overlay_1.Overlay, { autoFocus: this.props.autoFocus, canEscapeKeyClose: this.props.canEscapeKeyClear, canOutsideClickClose: false, className: classes, enforceFocus: false, hasBackdrop: false, inline: this.props.inline, isOpen: this.state.toasts.length > 0, onClose: this.handleClose, transitionDuration: 350, transitionName: "pt-toast" }, this.state.toasts.map(this.renderToast, this));
    };
    Toaster.prototype.validateProps = function (props) {
        if (props.position === position_1.Position.LEFT || props.position === position_1.Position.RIGHT) {
            console.warn(errors_1.TOASTER_WARN_LEFT_RIGHT);
        }
    };
    Toaster.prototype.renderToast = function (toast) {
        return React.createElement(toast_1.Toast, tslib_1.__assign({}, toast, { onDismiss: this.getDismissHandler(toast) }));
    };
    Toaster.prototype.createToastOptions = function (props, key) {
        if (key === void 0) {
            key = "toast-" + this.toastId++;
        }
        // clone the object before adding the key prop to avoid leaking the mutation
        return tslib_1.__assign({}, props, { key: key });
    };
    Toaster.prototype.getPositionClasses = function () {
        var positions = position_1.Position[this.props.position].split("_");
        // NOTE that there is no -center class because that's the default style
        return positions.map(function (p) {
            return Classes.TOAST_CONTAINER + "-" + p.toLowerCase();
        });
    };
    return Toaster;
}(abstractComponent_1.AbstractComponent);
Toaster.defaultProps = {
    autoFocus: false,
    canEscapeKeyClear: true,
    inline: false,
    position: position_1.Position.TOP
};
Toaster = Toaster_1 = tslib_1.__decorate([PureRender], Toaster);
exports.Toaster = Toaster;
var Toaster_1;

//# sourceMappingURL=toaster.js.map

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var React = __webpack_require__(0);
var tooltip_1 = __webpack_require__(540);
var SVGTooltip = function (_super) {
    tslib_1.__extends(SVGTooltip, _super);
    function SVGTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGTooltip.prototype.render = function () {
        return React.createElement(tooltip_1.Tooltip, tslib_1.__assign({ rootElementTag: "g" }, this.props), this.props.children);
    };
    return SVGTooltip;
}(React.Component);
exports.SVGTooltip = SVGTooltip;
exports.SVGTooltipFactory = React.createFactory(SVGTooltip);

//# sourceMappingURL=svgTooltip.js.map

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */


Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(33);
var classNames = __webpack_require__(28);
var React = __webpack_require__(0);
var Classes = __webpack_require__(37);
var utils_1 = __webpack_require__(53);
var treeNode_1 = __webpack_require__(855);
var Tree = function (_super) {
    tslib_1.__extends(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nodeRefs = {};
        _this.handleNodeCollapse = function (node, e) {
            _this.handlerHelper(_this.props.onNodeCollapse, node, e);
        };
        _this.handleNodeClick = function (node, e) {
            _this.handlerHelper(_this.props.onNodeClick, node, e);
        };
        _this.handleContentRef = function (node, element) {
            if (element != null) {
                _this.nodeRefs[node.props.id] = element;
            } else {
                // don't want our object to get bloated with old keys
                delete _this.nodeRefs[node.props.id];
            }
        };
        _this.handleNodeContextMenu = function (node, e) {
            _this.handlerHelper(_this.props.onNodeContextMenu, node, e);
        };
        _this.handleNodeDoubleClick = function (node, e) {
            _this.handlerHelper(_this.props.onNodeDoubleClick, node, e);
        };
        _this.handleNodeExpand = function (node, e) {
            _this.handlerHelper(_this.props.onNodeExpand, node, e);
        };
        return _this;
    }
    Tree.nodeFromPath = function (path, treeNodes) {
        if (path.length === 1) {
            return treeNodes[path[0]];
        } else {
            return Tree.nodeFromPath(path.slice(1), treeNodes[path[0]].childNodes);
        }
    };
    Tree.prototype.render = function () {
        return React.createElement("div", { className: classNames(Classes.TREE, this.props.className) }, this.renderNodes(this.props.contents, [], Classes.TREE_ROOT));
    };
    /**
     * Returns the underlying HTML element of the `Tree` node with an id of `nodeId`.
     * This element does not contain the children of the node, only its label and controls.
     * If the node is not currently mounted, `undefined` is returned.
     */
    Tree.prototype.getNodeContentElement = function (nodeId) {
        return this.nodeRefs[nodeId];
    };
    Tree.prototype.renderNodes = function (treeNodes, currentPath, className) {
        var _this = this;
        if (treeNodes == null) {
            return null;
        }
        var nodeItems = treeNodes.map(function (node, i) {
            var elementPath = currentPath.concat(i);
            return React.createElement(treeNode_1.TreeNode, tslib_1.__assign({}, node, { key: node.id, contentRef: _this.handleContentRef, depth: elementPath.length - 1, onClick: _this.handleNodeClick, onContextMenu: _this.handleNodeContextMenu, onCollapse: _this.handleNodeCollapse, onDoubleClick: _this.handleNodeDoubleClick, onExpand: _this.handleNodeExpand, path: elementPath }), _this.renderNodes(node.childNodes, elementPath));
        });
        return React.createElement("ul", { className: classNames(Classes.TREE_NODE_LIST, className) }, nodeItems);
    };
    Tree.prototype.handlerHelper = function (handlerFromProps, node, e) {
        if (utils_1.isFunction(handlerFromProps)) {
            var nodeData = Tree.nodeFromPath(node.props.path, this.props.contents);
            handlerFromProps(nodeData, node.props.path, e);
        }
    };
    return Tree;
}(React.Component);
exports.Tree = Tree;
exports.TreeFactory = React.createFactory(Tree);

//# sourceMappingURL=tree.js.map

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-present Palantir Technologies, Inc. All rights reserved.
 */


Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:object-literal-sort-keys
exports.IconClasses = {
    BLANK: "pt-icon-blank",
    STYLE: "pt-icon-style",
    ALIGN_LEFT: "pt-icon-align-left",
    ALIGN_CENTER: "pt-icon-align-center",
    ALIGN_RIGHT: "pt-icon-align-right",
    ALIGN_JUSTIFY: "pt-icon-align-justify",
    BOLD: "pt-icon-bold",
    ITALIC: "pt-icon-italic",
    UNDERLINE: "pt-icon-underline",
    SEARCH_AROUND: "pt-icon-search-around",
    GRAPH_REMOVE: "pt-icon-graph-remove",
    GROUP_OBJECTS: "pt-icon-group-objects",
    MERGE_LINKS: "pt-icon-merge-links",
    LAYOUT: "pt-icon-layout",
    LAYOUT_AUTO: "pt-icon-layout-auto",
    LAYOUT_CIRCLE: "pt-icon-layout-circle",
    LAYOUT_HIERARCHY: "pt-icon-layout-hierarchy",
    LAYOUT_GRID: "pt-icon-layout-grid",
    LAYOUT_GROUP_BY: "pt-icon-layout-group-by",
    LAYOUT_SKEW_GRID: "pt-icon-layout-skew-grid",
    GEOSEARCH: "pt-icon-geosearch",
    HEATMAP: "pt-icon-heatmap",
    DRIVE_TIME: "pt-icon-drive-time",
    SELECT: "pt-icon-select",
    PREDICTIVE_ANALYSIS: "pt-icon-predictive-analysis",
    LAYERS: "pt-icon-layers",
    LOCATE: "pt-icon-locate",
    BOOKMARK: "pt-icon-bookmark",
    CITATION: "pt-icon-citation",
    TAG: "pt-icon-tag",
    CLIPBOARD: "pt-icon-clipboard",
    SELECTION: "pt-icon-selection",
    TIMELINE_EVENTS: "pt-icon-timeline-events",
    TIMELINE_LINE_CHART: "pt-icon-timeline-line-chart",
    TIMELINE_BAR_CHART: "pt-icon-timeline-bar-chart",
    APPLICATIONS: "pt-icon-applications",
    PROJECTS: "pt-icon-projects",
    CHANGES: "pt-icon-changes",
    NOTIFICATIONS: "pt-icon-notifications",
    LOCK: "pt-icon-lock",
    UNLOCK: "pt-icon-unlock",
    USER: "pt-icon-user",
    SEARCH_TEMPLATE: "pt-icon-search-template",
    INBOX: "pt-icon-inbox",
    MORE: "pt-icon-more",
    HELP: "pt-icon-help",
    CALENDAR: "pt-icon-calendar",
    MEDIA: "pt-icon-media",
    LINK: "pt-icon-link",
    SHARE: "pt-icon-share",
    DOWNLOAD: "pt-icon-download",
    DOCUMENT: "pt-icon-document",
    PROPERTIES: "pt-icon-properties",
    IMPORT: "pt-icon-import",
    EXPORT: "pt-icon-export",
    MINIMIZE: "pt-icon-minimize",
    MAXIMIZE: "pt-icon-maximize",
    TICK: "pt-icon-tick",
    CROSS: "pt-icon-cross",
    PLUS: "pt-icon-plus",
    MINUS: "pt-icon-minus",
    ARROW_LEFT: "pt-icon-arrow-left",
    ARROW_RIGHT: "pt-icon-arrow-right",
    EXCHANGE: "pt-icon-exchange",
    COMPARISON: "pt-icon-comparison",
    LIST: "pt-icon-list",
    FILTER: "pt-icon-filter",
    CONFIRM: "pt-icon-confirm",
    FORK: "pt-icon-fork",
    TRASH: "pt-icon-trash",
    PERSON: "pt-icon-person",
    PEOPLE: "pt-icon-people",
    ADD: "pt-icon-add",
    REMOVE: "pt-icon-remove",
    GEOLOCATION: "pt-icon-geolocation",
    ZOOM_IN: "pt-icon-zoom-in",
    ZOOM_OUT: "pt-icon-zoom-out",
    REFRESH: "pt-icon-refresh",
    DELETE: "pt-icon-delete",
    COG: "pt-icon-cog",
    FLAG: "pt-icon-flag",
    PIN: "pt-icon-pin",
    WARNING_SIGN: "pt-icon-warning-sign",
    ERROR: "pt-icon-error",
    INFO_SIGN: "pt-icon-info-sign",
    CREDIT_CARD: "pt-icon-credit-card",
    EDIT: "pt-icon-edit",
    HISTORY: "pt-icon-history",
    SEARCH: "pt-icon-search",
    LOG_OUT: "pt-icon-log-out",
    STAR: "pt-icon-star",
    STAR_EMPTY: "pt-icon-star-empty",
    SORT_ALPHABETICAL: "pt-icon-sort-alphabetical",
    SORT_NUMERICAL: "pt-icon-sort-numerical",
    SORT: "pt-icon-sort",
    FOLDER_OPEN: "pt-icon-folder-open",
    FOLDER_CLOSE: "pt-icon-folder-close",
    FOLDER_SHARED: "pt-icon-folder-shared",
    CARET_UP: "pt-icon-caret-up",
    CARET_RIGHT: "pt-icon-caret-right",
    CARET_DOWN: "pt-icon-caret-down",
    CARET_LEFT: "pt-icon-caret-left",
    MENU_OPEN: "pt-icon-menu-open",
    MENU_CLOSED: "pt-icon-menu-closed",
    FEED: "pt-icon-feed",
    TWO_COLUMNS: "pt-icon-two-columns",
    ONE_COLUMN: "pt-icon-one-column",
    DOT: "pt-icon-dot",
    PROPERTY: "pt-icon-property",
    TIME: "pt-icon-time",
    DISABLE: "pt-icon-disable",
    UNPIN: "pt-icon-unpin",
    FLOWS: "pt-icon-flows",
    NEW_TEXT_BOX: "pt-icon-new-text-box",
    NEW_LINK: "pt-icon-new-link",
    NEW_OBJECT: "pt-icon-new-object",
    PATH_SEARCH: "pt-icon-path-search",
    AUTOMATIC_UPDATES: "pt-icon-automatic-updates",
    PAGE_LAYOUT: "pt-icon-page-layout",
    CODE: "pt-icon-code",
    MAP: "pt-icon-map",
    SEARCH_TEXT: "pt-icon-search-text",
    ENVELOPE: "pt-icon-envelope",
    PAPERCLIP: "pt-icon-paperclip",
    LABEL: "pt-icon-label",
    GLOBE: "pt-icon-globe",
    HOME: "pt-icon-home",
    TH: "pt-icon-th",
    TH_LIST: "pt-icon-th-list",
    TH_DERIVED: "pt-icon-th-derived",
    CIRCLE: "pt-icon-circle",
    DRAW: "pt-icon-draw",
    INSERT: "pt-icon-insert",
    HELPER_MANAGEMENT: "pt-icon-helper-management",
    SEND_TO: "pt-icon-send-to",
    EYE_OPEN: "pt-icon-eye-open",
    FOLDER_SHARED_OPEN: "pt-icon-folder-shared-open",
    SOCIAL_MEDIA: "pt-icon-social-media",
    ARROW_UP: "pt-icon-arrow-up",
    ARROW_DOWN: "pt-icon-arrow-down",
    ARROWS_HORIZONTAL: "pt-icon-arrows-horizontal",
    ARROWS_VERTICAL: "pt-icon-arrows-vertical",
    RESOLVE: "pt-icon-resolve",
    GRAPH: "pt-icon-graph",
    BRIEFCASE: "pt-icon-briefcase",
    DOLLAR: "pt-icon-dollar",
    NINJA: "pt-icon-ninja",
    DELTA: "pt-icon-delta",
    BARCODE: "pt-icon-barcode",
    TORCH: "pt-icon-torch",
    WIDGET: "pt-icon-widget",
    UNRESOLVE: "pt-icon-unresolve",
    OFFLINE: "pt-icon-offline",
    ZOOM_TO_FIT: "pt-icon-zoom-to-fit",
    ADD_TO_ARTIFACT: "pt-icon-add-to-artifact",
    MAP_MARKER: "pt-icon-map-marker",
    CHART: "pt-icon-chart",
    CONTROL: "pt-icon-control",
    MULTI_SELECT: "pt-icon-multi-select",
    DIRECTION_LEFT: "pt-icon-direction-left",
    DIRECTION_RIGHT: "pt-icon-direction-right",
    DATABASE: "pt-icon-database",
    PIE_CHART: "pt-icon-pie-chart",
    FULL_CIRCLE: "pt-icon-full-circle",
    SQUARE: "pt-icon-square",
    PRINT: "pt-icon-print",
    PRESENTATION: "pt-icon-presentation",
    UNGROUP_OBJECTS: "pt-icon-ungroup-objects",
    CHAT: "pt-icon-chat",
    COMMENT: "pt-icon-comment",
    CIRCLE_ARROW_RIGHT: "pt-icon-circle-arrow-right",
    CIRCLE_ARROW_LEFT: "pt-icon-circle-arrow-left",
    CIRCLE_ARROW_UP: "pt-icon-circle-arrow-up",
    CIRCLE_ARROW_DOWN: "pt-icon-circle-arrow-down",
    UPLOAD: "pt-icon-upload",
    ASTERISK: "pt-icon-asterisk",
    CLOUD: "pt-icon-cloud",
    CLOUD_DOWNLOAD: "pt-icon-cloud-download",
    CLOUD_UPLOAD: "pt-icon-cloud-upload",
    REPEAT: "pt-icon-repeat",
    MOVE: "pt-icon-move",
    CHEVRON_LEFT: "pt-icon-chevron-left",
    CHEVRON_RIGHT: "pt-icon-chevron-right",
    CHEVRON_UP: "pt-icon-chevron-up",
    CHEVRON_DOWN: "pt-icon-chevron-down",
    RANDOM: "pt-icon-random",
    FULLSCREEN: "pt-icon-fullscreen",
    LOG_IN: "pt-icon-log-in",
    HEART: "pt-icon-heart",
    OFFICE: "pt-icon-office",
    DUPLICATE: "pt-icon-duplicate",
    BAN_CIRCLE: "pt-icon-ban-circle",
    CAMERA: "pt-icon-camera",
    MOBILE_VIDEO: "pt-icon-mobile-video",
    VIDEO: "pt-icon-video",
    FILM: "pt-icon-film",
    SETTINGS: "pt-icon-settings",
    VOLUME_OFF: "pt-icon-volume-off",
    VOLUME_DOWN: "pt-icon-volume-down",
    VOLUME_UP: "pt-icon-volume-up",
    MUSIC: "pt-icon-music",
    STEP_BACKWARD: "pt-icon-step-backward",
    FAST_BACKWARD: "pt-icon-fast-backward",
    PAUSE: "pt-icon-pause",
    STOP: "pt-icon-stop",
    PLAY: "pt-icon-play",
    FAST_FORWARD: "pt-icon-fast-forward",
    STEP_FORWARD: "pt-icon-step-forward",
    EJECT: "pt-icon-eject",
    RECORD: "pt-icon-record",
    DESKTOP: "pt-icon-desktop",
    PHONE: "pt-icon-phone",
    LIGHTBULB: "pt-icon-lightbulb",
    GLASS: "pt-icon-glass",
    TINT: "pt-icon-tint",
    FLASH: "pt-icon-flash",
    FONT: "pt-icon-font",
    HEADER: "pt-icon-header",
    SAVED: "pt-icon-saved",
    FLOPPY_DISK: "pt-icon-floppy-disk",
    BOOK: "pt-icon-book",
    HAND_RIGHT: "pt-icon-hand-right",
    HAND_UP: "pt-icon-hand-up",
    HAND_DOWN: "pt-icon-hand-down",
    HAND_LEFT: "pt-icon-hand-left",
    THUMBS_UP: "pt-icon-thumbs-up",
    THUMBS_DOWN: "pt-icon-thumbs-down",
    BOX: "pt-icon-box",
    COMPRESSED: "pt-icon-compressed",
    SHOPPING_CART: "pt-icon-shopping-cart",
    SHOP: "pt-icon-shop",
    LAYOUT_LINEAR: "pt-icon-layout-linear",
    UNDO: "pt-icon-undo",
    REDO: "pt-icon-redo",
    CODE_BLOCK: "pt-icon-code-block",
    DOUBLE_CARET_VERTICAL: "pt-icon-double-caret-vertical",
    DOUBLE_CARET_HORIZONTAL: "pt-icon-double-caret-horizontal",
    SORT_ALPHABETICAL_DESC: "pt-icon-sort-alphabetical-desc",
    SORT_NUMERICAL_DESC: "pt-icon-sort-numerical-desc",
    TAKE_ACTION: "pt-icon-take-action",
    CONTRAST: "pt-icon-contrast",
    EYE_OFF: "pt-icon-eye-off",
    TIMELINE_AREA_CHART: "pt-icon-timeline-area-chart",
    DOUGHNUT_CHART: "pt-icon-doughnut-chart",
    LAYER: "pt-icon-layer",
    GRID: "pt-icon-grid",
    POLYGON_FILTER: "pt-icon-polygon-filter",
    ADD_TO_FOLDER: "pt-icon-add-to-folder",
    LAYOUT_BALLOON: "pt-icon-layout-balloon",
    LAYOUT_SORTED_CLUSTERS: "pt-icon-layout-sorted-clusters",
    SORT_ASC: "pt-icon-sort-asc",
    SORT_DESC: "pt-icon-sort-desc",
    SMALL_CROSS: "pt-icon-small-cross",
    SMALL_TICK: "pt-icon-small-tick",
    POWER: "pt-icon-power",
    COLUMN_LAYOUT: "pt-icon-column-layout",
    ARROW_TOP_LEFT: "pt-icon-arrow-top-left",
    ARROW_TOP_RIGHT: "pt-icon-arrow-top-right",
    ARROW_BOTTOM_RIGHT: "pt-icon-arrow-bottom-right",
    ARROW_BOTTOM_LEFT: "pt-icon-arrow-bottom-left",
    MUGSHOT: "pt-icon-mugshot",
    HEADSET: "pt-icon-headset",
    TEXT_HIGHLIGHT: "pt-icon-text-highlight",
    HAND: "pt-icon-hand",
    CHEVRON_BACKWARD: "pt-icon-chevron-backward",
    CHEVRON_FORWARD: "pt-icon-chevron-forward",
    ROTATE_DOCUMENT: "pt-icon-rotate-document",
    ROTATE_PAGE: "pt-icon-rotate-page",
    BADGE: "pt-icon-badge",
    GRID_VIEW: "pt-icon-grid-view",
    FUNCTION: "pt-icon-function",
    WATERFALL_CHART: "pt-icon-waterfall-chart",
    STACKED_CHART: "pt-icon-stacked-chart",
    PULSE: "pt-icon-pulse",
    NEW_PERSON: "pt-icon-new-person",
    EXCLUDE_ROW: "pt-icon-exclude-row",
    PIVOT_TABLE: "pt-icon-pivot-table",
    SEGMENTED_CONTROL: "pt-icon-segmented-control",
    HIGHLIGHT: "pt-icon-highlight",
    FILTER_LIST: "pt-icon-filter-list",
    CUT: "pt-icon-cut",
    ANNOTATION: "pt-icon-annotation",
    PIVOT: "pt-icon-pivot",
    RING: "pt-icon-ring",
    HEAT_GRID: "pt-icon-heat-grid",
    GANTT_CHART: "pt-icon-gantt-chart",
    VARIABLE: "pt-icon-variable",
    MANUAL: "pt-icon-manual",
    ADD_ROW_TOP: "pt-icon-add-row-top",
    ADD_ROW_BOTTOM: "pt-icon-add-row-bottom",
    ADD_COLUMN_LEFT: "pt-icon-add-column-left",
    ADD_COLUMN_RIGHT: "pt-icon-add-column-right",
    REMOVE_ROW_TOP: "pt-icon-remove-row-top",
    REMOVE_ROW_BOTTOM: "pt-icon-remove-row-bottom",
    REMOVE_COLUMN_LEFT: "pt-icon-remove-column-left",
    REMOVE_COLUMN_RIGHT: "pt-icon-remove-column-right",
    DOUBLE_CHEVRON_LEFT: "pt-icon-double-chevron-left",
    DOUBLE_CHEVRON_RIGHT: "pt-icon-double-chevron-right",
    DOUBLE_CHEVRON_UP: "pt-icon-double-chevron-up",
    DOUBLE_CHEVRON_DOWN: "pt-icon-double-chevron-down",
    KEY_CONTROL: "pt-icon-key-control",
    KEY_COMMAND: "pt-icon-key-command",
    KEY_SHIFT: "pt-icon-key-shift",
    KEY_BACKSPACE: "pt-icon-key-backspace",
    KEY_DELETE: "pt-icon-key-delete",
    KEY_ESCAPE: "pt-icon-key-escape",
    KEY_ENTER: "pt-icon-key-enter",
    CALCULATOR: "pt-icon-calculator",
    HORIZONTAL_BAR_CHART: "pt-icon-horizontal-bar-chart",
    SMALL_PLUS: "pt-icon-small-plus",
    SMALL_MINUS: "pt-icon-small-minus",
    STEP_CHART: "pt-icon-step-chart",
    EURO: "pt-icon-euro",
    DRAG_HANDLE_VERTICAL: "pt-icon-drag-handle-vertical",
    DRAG_HANDLE_HORIZONTAL: "pt-icon-drag-handle-horizontal",
    MOBILE_PHONE: "pt-icon-mobile-phone",
    SIM_CARD: "pt-icon-sim-card",
    TRENDING_UP: "pt-icon-trending-up",
    TRENDING_DOWN: "pt-icon-trending-down",
    CURVED_RANGE_CHART: "pt-icon-curved-range-chart",
    VERTICAL_BAR_CHART_DESC: "pt-icon-vertical-bar-chart-desc",
    HORIZONTAL_BAR_CHART_DESC: "pt-icon-horizontal-bar-chart-desc",
    DOCUMENT_OPEN: "pt-icon-document-open",
    DOCUMENT_SHARE: "pt-icon-document-share",
    HORIZONTAL_DISTRIBUTION: "pt-icon-horizontal-distribution",
    VERTICAL_DISTRIBUTION: "pt-icon-vertical-distribution",
    ALIGNMENT_LEFT: "pt-icon-alignment-left",
    ALIGNMENT_VERTICAL_CENTER: "pt-icon-alignment-vertical-center",
    ALIGNMENT_RIGHT: "pt-icon-alignment-right",
    ALIGNMENT_TOP: "pt-icon-alignment-top",
    ALIGNMENT_HORIZONTAL_CENTER: "pt-icon-alignment-horizontal-center",
    ALIGNMENT_BOTTOM: "pt-icon-alignment-bottom",
    GIT_PULL: "pt-icon-git-pull",
    GIT_MERGE: "pt-icon-git-merge",
    GIT_BRANCH: "pt-icon-git-branch",
    GIT_COMMIT: "pt-icon-git-commit",
    GIT_PUSH: "pt-icon-git-push",
    BUILD: "pt-icon-build",
    SYMBOL_CIRCLE: "pt-icon-symbol-circle",
    SYMBOL_SQUARE: "pt-icon-symbol-square",
    SYMBOL_DIAMOND: "pt-icon-symbol-diamond",
    SYMBOL_CROSS: "pt-icon-symbol-cross",
    SYMBOL_TRIANGLE_UP: "pt-icon-symbol-triangle-up",
    SYMBOL_TRIANGLE_DOWN: "pt-icon-symbol-triangle-down",
    WRENCH: "pt-icon-wrench",
    APPLICATION: "pt-icon-application",
    SEND_TO_GRAPH: "pt-icon-send-to-graph",
    SEND_TO_MAP: "pt-icon-send-to-map",
    JOIN_TABLE: "pt-icon-join-table",
    DERIVE_COLUMN: "pt-icon-derive-column",
    IMAGE_ROTATE_LEFT: "pt-icon-image-rotate-left",
    IMAGE_ROTATE_RIGHT: "pt-icon-image-rotate-right",
    KNOWN_VEHICLE: "pt-icon-known-vehicle",
    UNKNOWN_VEHICLE: "pt-icon-unknown-vehicle",
    SCATTER_PLOT: "pt-icon-scatter-plot",
    OIL_FIELD: "pt-icon-oil-field",
    RIG: "pt-icon-rig",
    MAP_CREATE: "pt-icon-map-create",
    KEY_OPTION: "pt-icon-key-option",
    LIST_DETAIL_VIEW: "pt-icon-list-detail-view",
    SWAP_VERTICAL: "pt-icon-swap-vertical",
    SWAP_HORIZONTAL: "pt-icon-swap-horizontal",
    NUMBERED_LIST: "pt-icon-numbered-list",
    NEW_GRID_ITEM: "pt-icon-new-grid-item",
    GIT_REPO: "pt-icon-git-repo",
    GIT_NEW_BRANCH: "pt-icon-git-new-branch",
    MANUALLY_ENTERED_DATA: "pt-icon-manually-entered-data",
    AIRPLANE: "pt-icon-airplane",
    MERGE_COLUMNS: "pt-icon-merge-columns",
    SPLIT_COLUMNS: "pt-icon-split-columns",
    DASHBOARD: "pt-icon-dashboard",
    PUBLISH_FUNCTION: "pt-icon-publish-function",
    PATH: "pt-icon-path",
    MOON: "pt-icon-moon",
    REMOVE_COLUMN: "pt-icon-remove-column",
    NUMERICAL: "pt-icon-numerical",
    KEY_TAB: "pt-icon-key-tab",
    REGRESSION_CHART: "pt-icon-regression-chart",
    TRANSLATE: "pt-icon-translate",
    EYE_ON: "pt-icon-eye-on",
    VERTICAL_BAR_CHART_ASC: "pt-icon-vertical-bar-chart-asc",
    HORIZONTAL_BAR_CHART_ASC: "pt-icon-horizontal-bar-chart-asc",
    GROUPED_BAR_CHART: "pt-icon-grouped-bar-chart",
    FULL_STACKED_CHART: "pt-icon-full-stacked-chart",
    ENDORSED: "pt-icon-endorsed",
    FOLLOWER: "pt-icon-follower",
    FOLLOWING: "pt-icon-following",
    MENU: "pt-icon-menu",
    COLLAPSE_ALL: "pt-icon-collapse-all",
    EXPAND_ALL: "pt-icon-expand-all",
    INTERSECTION: "pt-icon-intersection",
    BLOCKED_PERSON: "pt-icon-blocked-person",
    SLASH: "pt-icon-slash",
    PERCENTAGE: "pt-icon-percentage",
    SATELLITE: "pt-icon-satellite",
    PARAGRAPH: "pt-icon-paragraph",
    BANL_ACCOUNT: "pt-icon-banl-account",
    CELL_TOWER: "pt-icon-cell-tower",
    ID_NUMBER: "pt-icon-id-number",
    IP_ADDRESS: "pt-icon-ip-address",
    ERASER: "pt-icon-eraser",
    ISSUE: "pt-icon-issue",
    ISSUE_NEW: "pt-icon-issue-new",
    ISSUE_CLOSED: "pt-icon-issue-closed",
    PANEL_STATS: "pt-icon-panel-stats",
    PANEL_TABLE: "pt-icon-panel-table",
    TICK_CIRCLE: "pt-icon-tick-circle",
    PRESCRIPTION: "pt-icon-prescription",
    NEW_PRESCRIPTION: "pt-icon-new-prescription"
};

//# sourceMappingURL=iconClasses.js.map

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright 2015-present Palantir Technologies, Inc. All rights reserved.
 */


Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:object-literal-sort-keys
exports.IconContents = {
    BLANK: "\uE900",
    STYLE: "\uE601",
    ALIGN_LEFT: "\uE602",
    ALIGN_CENTER: "\uE603",
    ALIGN_RIGHT: "\uE604",
    ALIGN_JUSTIFY: "\uE605",
    BOLD: "\uE606",
    ITALIC: "\uE607",
    UNDERLINE: "\u2381",
    SEARCH_AROUND: "\uE608",
    GRAPH_REMOVE: "\uE609",
    GROUP_OBJECTS: "\uE60A",
    MERGE_LINKS: "\uE60B",
    LAYOUT: "\uE60C",
    LAYOUT_AUTO: "\uE60D",
    LAYOUT_CIRCLE: "\uE60E",
    LAYOUT_HIERARCHY: "\uE60F",
    LAYOUT_GRID: "\uE610",
    LAYOUT_GROUP_BY: "\uE611",
    LAYOUT_SKEW_GRID: "\uE612",
    GEOSEARCH: "\uE613",
    HEATMAP: "\uE614",
    DRIVE_TIME: "\uE615",
    SELECT: "\uE616",
    PREDICTIVE_ANALYSIS: "\uE617",
    LAYERS: "\uE618",
    LOCATE: "\uE619",
    BOOKMARK: "\uE61A",
    CITATION: "\uE61B",
    TAG: "\uE61C",
    CLIPBOARD: "\uE61D",
    SELECTION: "\u29BF",
    TIMELINE_EVENTS: "\uE61E",
    TIMELINE_LINE_CHART: "\uE61F",
    TIMELINE_BAR_CHART: "\uE620",
    APPLICATIONS: "\uE621",
    PROJECTS: "\uE622",
    CHANGES: "\uE623",
    NOTIFICATIONS: "\uE624",
    LOCK: "\uE625",
    UNLOCK: "\uE626",
    USER: "\uE627",
    SEARCH_TEMPLATE: "\uE628",
    INBOX: "\uE629",
    MORE: "\uE62A",
    HELP: "?",
    CALENDAR: "\uE62B",
    MEDIA: "\uE62C",
    LINK: "\uE62D",
    SHARE: "\uE62E",
    DOWNLOAD: "\uE62F",
    DOCUMENT: "\uE630",
    PROPERTIES: "\uE631",
    IMPORT: "\uE632",
    EXPORT: "\uE633",
    MINIMIZE: "\uE634",
    MAXIMIZE: "\uE635",
    TICK: "\u2713",
    CROSS: "\u2717",
    PLUS: "+",
    MINUS: "\u2212",
    ARROW_LEFT: "\u2190",
    ARROW_RIGHT: "\u2192",
    EXCHANGE: "\uE636",
    COMPARISON: "\uE637",
    LIST: "\u2630",
    FILTER: "\uE638",
    CONFIRM: "\uE639",
    FORK: "\uE63A",
    TRASH: "\uE63B",
    PERSON: "\uE63C",
    PEOPLE: "\uE63D",
    ADD: "\uE63E",
    REMOVE: "\uE63F",
    GEOLOCATION: "\uE640",
    ZOOM_IN: "\uE641",
    ZOOM_OUT: "\uE642",
    REFRESH: "\uE643",
    DELETE: "\uE644",
    COG: "\uE645",
    FLAG: "\u2691",
    PIN: "\uE646",
    WARNING_SIGN: "\uE647",
    ERROR: "\uE648",
    INFO_SIGN: "\u2139",
    CREDIT_CARD: "\uE649",
    EDIT: "\u270E",
    HISTORY: "\uE64A",
    SEARCH: "\uE64B",
    LOG_OUT: "\uE64C",
    STAR: "\u2605",
    STAR_EMPTY: "\u2606",
    SORT_ALPHABETICAL: "\uE64D",
    SORT_NUMERICAL: "\uE64E",
    SORT: "\uE64F",
    FOLDER_OPEN: "\uE651",
    FOLDER_CLOSE: "\uE652",
    FOLDER_SHARED: "\uE653",
    CARET_UP: "\u2303",
    CARET_RIGHT: "\u232A",
    CARET_DOWN: "\u2304",
    CARET_LEFT: "\u2329",
    MENU_OPEN: "\uE654",
    MENU_CLOSED: "\uE655",
    FEED: "\uE656",
    TWO_COLUMNS: "\uE657",
    ONE_COLUMN: "\uE658",
    DOT: "\u2022",
    PROPERTY: "\uE65A",
    TIME: "\u23F2",
    DISABLE: "\uE600",
    UNPIN: "\uE650",
    FLOWS: "\uE659",
    NEW_TEXT_BOX: "\uE65B",
    NEW_LINK: "\uE65C",
    NEW_OBJECT: "\uE65D",
    PATH_SEARCH: "\uE65E",
    AUTOMATIC_UPDATES: "\uE65F",
    PAGE_LAYOUT: "\uE660",
    CODE: "\uE661",
    MAP: "\uE662",
    SEARCH_TEXT: "\uE663",
    ENVELOPE: "\u2709",
    PAPERCLIP: "\uE664",
    LABEL: "\uE665",
    GLOBE: "\uE666",
    HOME: "\u2302",
    TH: "\uE667",
    TH_LIST: "\uE668",
    TH_DERIVED: "\uE669",
    CIRCLE: "\uE66A",
    DRAW: "\uE66B",
    INSERT: "\uE66C",
    HELPER_MANAGEMENT: "\uE66D",
    SEND_TO: "\uE66E",
    EYE_OPEN: "\uE66F",
    FOLDER_SHARED_OPEN: "\uE670",
    SOCIAL_MEDIA: "\uE671",
    ARROW_UP: "\u2191 ",
    ARROW_DOWN: "\u2193 ",
    ARROWS_HORIZONTAL: "\u2194 ",
    ARROWS_VERTICAL: "\u2195 ",
    RESOLVE: "\uE672",
    GRAPH: "\uE673",
    BRIEFCASE: "\uE674",
    DOLLAR: "$",
    NINJA: "\uE675",
    DELTA: "\u0394",
    BARCODE: "\uE676",
    TORCH: "\uE677",
    WIDGET: "\uE678",
    UNRESOLVE: "\uE679",
    OFFLINE: "\uE67A",
    ZOOM_TO_FIT: "\uE67B",
    ADD_TO_ARTIFACT: "\uE67C",
    MAP_MARKER: "\uE67D",
    CHART: "\uE67E",
    CONTROL: "\uE67F",
    MULTI_SELECT: "\uE680",
    DIRECTION_LEFT: "\uE681",
    DIRECTION_RIGHT: "\uE682",
    DATABASE: "\uE683",
    PIE_CHART: "\uE684",
    FULL_CIRCLE: "\uE685",
    SQUARE: "\uE686",
    PRINT: "\u2399",
    PRESENTATION: "\uE687",
    UNGROUP_OBJECTS: "\uE688",
    CHAT: "\uE689",
    COMMENT: "\uE68A",
    CIRCLE_ARROW_RIGHT: "\uE68B",
    CIRCLE_ARROW_LEFT: "\uE68C",
    CIRCLE_ARROW_UP: "\uE68D",
    CIRCLE_ARROW_DOWN: "\uE68E",
    UPLOAD: "\uE68F",
    ASTERISK: "*",
    CLOUD: "\u2601",
    CLOUD_DOWNLOAD: "\uE690",
    CLOUD_UPLOAD: "\uE691",
    REPEAT: "\uE692",
    MOVE: "\uE693",
    CHEVRON_LEFT: "\uE694",
    CHEVRON_RIGHT: "\uE695",
    CHEVRON_UP: "\uE696",
    CHEVRON_DOWN: "\uE697",
    RANDOM: "\uE698",
    FULLSCREEN: "\uE699",
    LOG_IN: "\uE69A",
    HEART: "\u2665",
    OFFICE: "\uE69B",
    DUPLICATE: "\uE69C",
    BAN_CIRCLE: "\uE69D",
    CAMERA: "\uE69E",
    MOBILE_VIDEO: "\uE69F",
    VIDEO: "\uE6A0",
    FILM: "\uE6A1",
    SETTINGS: "\uE6A2",
    VOLUME_OFF: "\uE6A3",
    VOLUME_DOWN: "\uE6A4",
    VOLUME_UP: "\uE6A5",
    MUSIC: "\uE6A6",
    STEP_BACKWARD: "\uE6A7",
    FAST_BACKWARD: "\uE6A8",
    PAUSE: "\uE6A9",
    STOP: "\uE6AA",
    PLAY: "\uE6AB",
    FAST_FORWARD: "\uE6AC",
    STEP_FORWARD: "\uE6AD",
    EJECT: "\u23CF",
    RECORD: "\uE6AE",
    DESKTOP: "\uE6AF",
    PHONE: "\u260E",
    LIGHTBULB: "\uE6B0",
    GLASS: "\uE6B1",
    TINT: "\uE6B2",
    FLASH: "\uE6B3",
    FONT: "\uE6B4",
    HEADER: "\uE6B5",
    SAVED: "\uE6B6",
    FLOPPY_DISK: "\uE6B7",
    BOOK: "\uE6B8",
    HAND_RIGHT: "\uE6B9",
    HAND_UP: "\uE6BA",
    HAND_DOWN: "\uE6BB",
    HAND_LEFT: "\uE6BC",
    THUMBS_UP: "\uE6BD",
    THUMBS_DOWN: "\uE6BE",
    BOX: "\uE6BF",
    COMPRESSED: "\uE6C0",
    SHOPPING_CART: "\uE6C1",
    SHOP: "\uE6C2",
    LAYOUT_LINEAR: "\uE6C3",
    UNDO: "\u238C",
    REDO: "\uE6C4",
    CODE_BLOCK: "\uE6C5",
    DOUBLE_CARET_VERTICAL: "\uE6C6",
    DOUBLE_CARET_HORIZONTAL: "\uE6C7",
    SORT_ALPHABETICAL_DESC: "\uE6C8",
    SORT_NUMERICAL_DESC: "\uE6C9",
    TAKE_ACTION: "\uE6CA",
    CONTRAST: "\uE6CB",
    EYE_OFF: "\uE6CC",
    TIMELINE_AREA_CHART: "\uE6CD",
    DOUGHNUT_CHART: "\uE6CE",
    LAYER: "\uE6CF",
    GRID: "\uE6D0",
    POLYGON_FILTER: "\uE6D1",
    ADD_TO_FOLDER: "\uE6D2",
    LAYOUT_BALLOON: "\uE6D3",
    LAYOUT_SORTED_CLUSTERS: "\uE6D4",
    SORT_ASC: "\uE6D5",
    SORT_DESC: "\uE6D6",
    SMALL_CROSS: "\uE6D7",
    SMALL_TICK: "\uE6D8",
    POWER: "\uE6D9",
    COLUMN_LAYOUT: "\uE6DA",
    ARROW_TOP_LEFT: "\u2196",
    ARROW_TOP_RIGHT: "\u2197",
    ARROW_BOTTOM_RIGHT: "\u2198",
    ARROW_BOTTOM_LEFT: "\u2199",
    MUGSHOT: "\uE6DB",
    HEADSET: "\uE6DC",
    TEXT_HIGHLIGHT: "\uE6DD",
    HAND: "\uE6DE",
    CHEVRON_BACKWARD: "\uE6DF",
    CHEVRON_FORWARD: "\uE6E0",
    ROTATE_DOCUMENT: "\uE6E1",
    ROTATE_PAGE: "\uE6E2",
    BADGE: "\uE6E3",
    GRID_VIEW: "\uE6E4",
    FUNCTION: "\uE6E5",
    WATERFALL_CHART: "\uE6E6",
    STACKED_CHART: "\uE6E7",
    PULSE: "\uE6E8",
    NEW_PERSON: "\uE6E9",
    EXCLUDE_ROW: "\uE6EA",
    PIVOT_TABLE: "\uE6EB",
    SEGMENTED_CONTROL: "\uE6EC",
    HIGHLIGHT: "\uE6ED",
    FILTER_LIST: "\uE6EE",
    CUT: "\uE6EF",
    ANNOTATION: "\uE6F0",
    PIVOT: "\uE6F1",
    RING: "\uE6F2",
    HEAT_GRID: "\uE6F3",
    GANTT_CHART: "\uE6F4",
    VARIABLE: "\uE6F5",
    MANUAL: "\uE6F6",
    ADD_ROW_TOP: "\uE6F7",
    ADD_ROW_BOTTOM: "\uE6F8",
    ADD_COLUMN_LEFT: "\uE6F9",
    ADD_COLUMN_RIGHT: "\uE6FA",
    REMOVE_ROW_TOP: "\uE6FB",
    REMOVE_ROW_BOTTOM: "\uE6FC",
    REMOVE_COLUMN_LEFT: "\uE6FD",
    REMOVE_COLUMN_RIGHT: "\uE6FE",
    DOUBLE_CHEVRON_LEFT: "\uE6FF",
    DOUBLE_CHEVRON_RIGHT: "\uE701",
    DOUBLE_CHEVRON_UP: "\uE702",
    DOUBLE_CHEVRON_DOWN: "\uE703",
    KEY_CONTROL: "\uE704",
    KEY_COMMAND: "\uE705",
    KEY_SHIFT: "\uE706",
    KEY_BACKSPACE: "\uE707",
    KEY_DELETE: "\uE708",
    KEY_ESCAPE: "\uE709",
    KEY_ENTER: "\uE70A",
    CALCULATOR: "\uE70B",
    HORIZONTAL_BAR_CHART: "\uE70C",
    SMALL_PLUS: "\uE70D",
    SMALL_MINUS: "\uE70E",
    STEP_CHART: "\uE70F",
    EURO: "\u20AC",
    DRAG_HANDLE_VERTICAL: "\uE715",
    DRAG_HANDLE_HORIZONTAL: "\uE716",
    MOBILE_PHONE: "\uE717",
    SIM_CARD: "\uE718",
    TRENDING_UP: "\uE719",
    TRENDING_DOWN: "\uE71A",
    CURVED_RANGE_CHART: "\uE71B",
    VERTICAL_BAR_CHART_DESC: "\uE71C",
    HORIZONTAL_BAR_CHART_DESC: "\uE71D",
    DOCUMENT_OPEN: "\uE71E",
    DOCUMENT_SHARE: "\uE71F",
    HORIZONTAL_DISTRIBUTION: "\uE720",
    VERTICAL_DISTRIBUTION: "\uE721",
    ALIGNMENT_LEFT: "\uE722",
    ALIGNMENT_VERTICAL_CENTER: "\uE723",
    ALIGNMENT_RIGHT: "\uE724",
    ALIGNMENT_TOP: "\uE725",
    ALIGNMENT_HORIZONTAL_CENTER: "\uE726",
    ALIGNMENT_BOTTOM: "\uE727",
    GIT_PULL: "\uE728",
    GIT_MERGE: "\uE729",
    GIT_BRANCH: "\uE72A",
    GIT_COMMIT: "\uE72B",
    GIT_PUSH: "\uE72C",
    BUILD: "\uE72D",
    SYMBOL_CIRCLE: "\uE72E",
    SYMBOL_SQUARE: "\uE72F",
    SYMBOL_DIAMOND: "\uE730",
    SYMBOL_CROSS: "\uE731",
    SYMBOL_TRIANGLE_UP: "\uE732",
    SYMBOL_TRIANGLE_DOWN: "\uE733",
    WRENCH: "\uE734",
    APPLICATION: "\uE735",
    SEND_TO_GRAPH: "\uE736",
    SEND_TO_MAP: "\uE737",
    JOIN_TABLE: "\uE738",
    DERIVE_COLUMN: "\uE739",
    IMAGE_ROTATE_LEFT: "\uE73A",
    IMAGE_ROTATE_RIGHT: "\uE73B",
    KNOWN_VEHICLE: "\uE73C",
    UNKNOWN_VEHICLE: "\uE73D",
    SCATTER_PLOT: "\uE73E",
    OIL_FIELD: "\uE73F",
    RIG: "\uE740",
    MAP_CREATE: "\uE741",
    KEY_OPTION: "\uE742",
    LIST_DETAIL_VIEW: "\uE743",
    SWAP_VERTICAL: "\uE744",
    SWAP_HORIZONTAL: "\uE745",
    NUMBERED_LIST: "\uE746",
    NEW_GRID_ITEM: "\uE747",
    GIT_REPO: "\uE748",
    GIT_NEW_BRANCH: "\uE749",
    MANUALLY_ENTERED_DATA: "\uE74A",
    AIRPLANE: "\uE74B",
    MERGE_COLUMNS: "\uE74F",
    SPLIT_COLUMNS: "\uE750",
    DASHBOARD: "\uE751",
    PUBLISH_FUNCTION: "\uE752",
    PATH: "\uE753",
    MOON: "\uE754",
    REMOVE_COLUMN: "\uE755",
    NUMERICAL: "\uE756",
    KEY_TAB: "\uE757",
    REGRESSION_CHART: "\uE758",
    TRANSLATE: "\uE759",
    EYE_ON: "\uE75A",
    VERTICAL_BAR_CHART_ASC: "\uE75B",
    HORIZONTAL_BAR_CHART_ASC: "\uE75C",
    GROUPED_BAR_CHART: "\uE75D",
    FULL_STACKED_CHART: "\uE75E",
    ENDORSED: "\uE75F",
    FOLLOWER: "\uE760",
    FOLLOWING: "\uE761",
    MENU: "\uE762",
    COLLAPSE_ALL: "\uE763",
    EXPAND_ALL: "\uE764",
    INTERSECTION: "\uE765",
    BLOCKED_PERSON: "\uE768",
    SLASH: "\uE769",
    PERCENTAGE: "\uE76A",
    SATELLITE: "\uE76B",
    PARAGRAPH: "\uE76C",
    BANL_ACCOUNT: "\uE76F",
    CELL_TOWER: "\uE770",
    ID_NUMBER: "\uE771",
    IP_ADDRESS: "\uE772",
    ERASER: "\uE773",
    ISSUE: "\uE774",
    ISSUE_NEW: "\uE775",
    ISSUE_CLOSED: "\uE776",
    PANEL_STATS: "\uE777",
    PANEL_TABLE: "\uE778",
    TICK_CIRCLE: "\uE779",
    PRESCRIPTION: "\uE78A",
    NEW_PRESCRIPTION: "\uE78B"
};

//# sourceMappingURL=iconStrings.js.map

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
    return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var isNumber = _interopDefault(__webpack_require__(665));
var isArray = _interopDefault(__webpack_require__(80));
var isFunction = _interopDefault(__webpack_require__(197));
var d3TimeFormat = __webpack_require__(328);
var d3Format = __webpack_require__(321);
var core = __webpack_require__(856);
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(1));
var compose = _interopDefault(__webpack_require__(727));
var withPropsOnChange = _interopDefault(__webpack_require__(729));
var pure = _interopDefault(__webpack_require__(728));
var setDisplayName = _interopDefault(__webpack_require__(174));
var reactMotion = __webpack_require__(466);

var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
};

var centerScale = function centerScale(scale) {
    var bandwidth = scale.bandwidth();

    if (bandwidth === 0) return scale;

    var offset = bandwidth / 2;
    if (scale.round()) {
        offset = Math.round(offset);
    }

    return function (d) {
        return scale(d) + offset;
    };
};

var getScaleTicks = function getScaleTicks(scale, tickCount) {
    if (scale.ticks) return scale.ticks(tickCount);
    return scale.domain();
};

var computeCartesianTicks = function computeCartesianTicks(_ref) {
    var axis = _ref.axis,
        scale = _ref.scale,
        ticksPosition = _ref.ticksPosition,
        _tickValues = _ref.tickValues,
        tickSize = _ref.tickSize,
        tickPadding = _ref.tickPadding,
        tickRotation = _ref.tickRotation,
        _ref$engine = _ref.engine,
        engine = _ref$engine === undefined ? 'svg' : _ref$engine;

    var tickValues = isArray(_tickValues) ? _tickValues : undefined;
    var tickCount = isNumber(_tickValues) ? _tickValues : undefined;

    var values = tickValues || getScaleTicks(scale, tickCount);

    var textProps = core.textPropsByEngine[engine];

    var position = scale.bandwidth ? centerScale(scale) : scale;
    var line = { lineX: 0, lineY: 0 };
    var text = { textX: 0, textY: 0 };

    var translate = void 0;
    var textAlign = textProps.align.center;
    var textBaseline = textProps.baseline.center;

    if (axis === 'x') {
        translate = function translate(d) {
            return { x: position(d), y: 0 };
        };

        line.lineY = tickSize * (ticksPosition === 'after' ? 1 : -1);
        text.textY = (tickSize + tickPadding) * (ticksPosition === 'after' ? 1 : -1);

        if (ticksPosition === 'after') {
            textBaseline = textProps.baseline.top;
        } else {
            textBaseline = textProps.baseline.bottom;
        }

        if (tickRotation === 0) {
            textAlign = textProps.align.center;
        } else if (ticksPosition === 'after' && tickRotation < 0 || ticksPosition === 'before' && tickRotation > 0) {
            textAlign = textProps.align.right;
            textBaseline = textProps.baseline.center;
        } else if (ticksPosition === 'after' && tickRotation > 0 || ticksPosition === 'before' && tickRotation < 0) {
            textAlign = textProps.align.left;
            textBaseline = textProps.baseline.center;
        }
    } else {
        translate = function translate(d) {
            return { x: 0, y: position(d) };
        };

        line.lineX = tickSize * (ticksPosition === 'after' ? 1 : -1);
        text.textX = (tickSize + tickPadding) * (ticksPosition === 'after' ? 1 : -1);

        if (ticksPosition === 'after') {
            textAlign = textProps.align.left;
        } else {
            textAlign = textProps.align.right;
        }
    }

    var ticks = values.map(function (value) {
        return _extends({
            key: value,
            value: value
        }, translate(value), line, text);
    });

    return {
        ticks: ticks,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
};

var getFormatter = function getFormatter(format, scale) {
    if (!format || isFunction(format)) return format;

    if (scale.type === 'time') {
        var f = d3TimeFormat.timeFormat(format);
        return function (d) {
            return f(new Date(d));
        };
    }

    return d3Format.format(format);
};

var AxisTick = function (_PureComponent) {
    inherits(AxisTick, _PureComponent);

    function AxisTick() {
        classCallCheck(this, AxisTick);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    AxisTick.prototype.render = function render() {
        var _props = this.props,
            _value = _props.value,
            x = _props.x,
            y = _props.y,
            opacity = _props.opacity,
            rotate = _props.rotate,
            format = _props.format,
            lineX = _props.lineX,
            lineY = _props.lineY,
            _onClick = _props.onClick,
            textX = _props.textX,
            textY = _props.textY,
            textBaseline = _props.textBaseline,
            textAnchor = _props.textAnchor,
            theme = _props.theme;

        var value = _value;
        if (format !== undefined) {
            value = format(value);
        }

        var gStyle = { opacity: opacity };
        if (_onClick) {
            gStyle['cursor'] = 'pointer';
        }

        return React__default.createElement('g', _extends({
            transform: 'translate(' + x + ',' + y + ')'
        }, _onClick ? { onClick: function onClick(e) {
                return _onClick(e, value);
            } } : {}, {
            style: gStyle
        }), React__default.createElement('line', { x1: 0, x2: lineX, y1: 0, y2: lineY, style: theme.axis.ticks.line }), React__default.createElement('text', {
            alignmentBaseline: textBaseline,
            textAnchor: textAnchor,
            transform: 'translate(' + textX + ',' + textY + ') rotate(' + rotate + ')',
            style: theme.axis.ticks.text
        }, value));
    };

    return AxisTick;
}(React.PureComponent);

AxisTick.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    format: PropTypes.func,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    lineX: PropTypes.number.isRequired,
    lineY: PropTypes.number.isRequired,
    textX: PropTypes.number.isRequired,
    textY: PropTypes.number.isRequired,
    textBaseline: PropTypes.string.isRequired,
    textAnchor: PropTypes.string.isRequired,
    opacity: PropTypes.number.isRequired,
    rotate: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    theme: PropTypes.shape({
        axis: core.axisThemePropType.isRequired
    }).isRequired
};
AxisTick.defaultProps = {
    opacity: 1,
    rotate: 0
};

var willEnter = function willEnter() {
    return {
        rotate: 0,
        opacity: 0,
        x: 0,
        y: 0
    };
};

var willLeave = function willLeave(springConfig) {
    return function (_ref) {
        var _ref$style = _ref.style,
            x = _ref$style.x,
            y = _ref$style.y,
            rotate = _ref$style.rotate;
        return {
            rotate: rotate,
            opacity: reactMotion.spring(0, springConfig),
            x: reactMotion.spring(x.val, springConfig),
            y: reactMotion.spring(y.val, springConfig)
        };
    };
};

var defaultTickRenderer = function defaultTickRenderer(props) {
    return React__default.createElement(AxisTick, props);
};

var Axis = function (_Component) {
    inherits(Axis, _Component);

    function Axis() {
        classCallCheck(this, Axis);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Axis.prototype.render = function render() {
        var _props = this.props,
            axis = _props.axis,
            scale = _props.scale,
            x = _props.x,
            y = _props.y,
            length = _props.length,
            ticksPosition = _props.ticksPosition,
            tickValues = _props.tickValues,
            tickSize = _props.tickSize,
            tickPadding = _props.tickPadding,
            tickRotation = _props.tickRotation,
            format = _props.format,
            renderTick = _props.renderTick,
            legend = _props.legend,
            legendPosition = _props.legendPosition,
            legendOffset = _props.legendOffset,
            theme = _props.theme,
            animate = _props.animate,
            motionStiffness = _props.motionStiffness,
            motionDamping = _props.motionDamping,
            onClick = _props.onClick;

        var _computeCartesianTick = computeCartesianTicks({
            axis: axis,
            scale: scale,
            ticksPosition: ticksPosition,
            tickValues: tickValues,
            tickSize: tickSize,
            tickPadding: tickPadding,
            tickRotation: tickRotation
        }),
            ticks = _computeCartesianTick.ticks,
            textAlign = _computeCartesianTick.textAlign,
            textBaseline = _computeCartesianTick.textBaseline;

        var legendNode = null;
        if (legend !== undefined) {
            var legendX = 0;
            var legendY = 0;
            var legendRotation = 0;
            var textAnchor = void 0;

            if (axis === 'y') {
                legendRotation = -90;
                legendX = legendOffset;
                if (legendPosition === 'start') {
                    textAnchor = 'start';
                    legendY = length;
                } else if (legendPosition === 'middle') {
                    textAnchor = 'middle';
                    legendY = length / 2;
                } else if (legendPosition === 'end') {
                    textAnchor = 'end';
                }
            } else {
                legendY = legendOffset;
                if (legendPosition === 'start') {
                    textAnchor = 'start';
                } else if (legendPosition === 'middle') {
                    textAnchor = 'middle';
                    legendX = length / 2;
                } else if (legendPosition === 'end') {
                    textAnchor = 'end';
                    legendX = length;
                }
            }

            legendNode = React__default.createElement('text', {
                transform: 'translate(' + legendX + ', ' + legendY + ') rotate(' + legendRotation + ')',
                textAnchor: textAnchor,
                style: _extends({
                    alignmentBaseline: 'middle'
                }, theme.axis.legend.text)
            }, legend);
        }

        if (animate !== true) {
            return React__default.createElement('g', { transform: 'translate(' + x + ',' + y + ')' }, ticks.map(function (tick, tickIndex) {
                return renderTick(_extends({
                    tickIndex: tickIndex,
                    format: format,
                    rotate: tickRotation,
                    textBaseline: textBaseline,
                    textAnchor: textAlign,
                    theme: theme
                }, tick, onClick ? { onClick: onClick } : {}));
            }), React__default.createElement('line', {
                style: theme.axis.domain.line,
                x1: 0,
                x2: axis === 'x' ? length : 0,
                y1: 0,
                y2: axis === 'x' ? 0 : length
            }), legendNode);
        }

        var springConfig = {
            stiffness: motionStiffness,
            damping: motionDamping
        };

        return React__default.createElement(reactMotion.Motion, { style: { x: reactMotion.spring(x, springConfig), y: reactMotion.spring(y, springConfig) } }, function (xy) {
            return React__default.createElement('g', { transform: 'translate(' + xy.x + ',' + xy.y + ')' }, React__default.createElement(reactMotion.TransitionMotion, {
                willEnter: willEnter,
                willLeave: willLeave(springConfig),
                styles: ticks.map(function (tick) {
                    return {
                        key: '' + tick.key,
                        data: tick,
                        style: {
                            opacity: reactMotion.spring(1, springConfig),
                            x: reactMotion.spring(tick.x, springConfig),
                            y: reactMotion.spring(tick.y, springConfig),
                            rotate: reactMotion.spring(tickRotation, springConfig)
                        }
                    };
                })
            }, function (interpolatedStyles) {
                return React__default.createElement(React.Fragment, null, interpolatedStyles.map(function (_ref2, tickIndex) {
                    var style = _ref2.style,
                        tick = _ref2.data;
                    return renderTick(_extends({
                        tickIndex: tickIndex,
                        format: format,
                        textBaseline: textBaseline,
                        textAnchor: textAlign,
                        theme: theme
                    }, tick, style, onClick ? { onClick: onClick } : {}));
                }));
            }), React__default.createElement(reactMotion.Motion, {
                style: {
                    x2: reactMotion.spring(axis === 'x' ? length : 0, springConfig),
                    y2: reactMotion.spring(axis === 'x' ? 0 : length, springConfig)
                }
            }, function (values) {
                return React__default.createElement('line', _extends({ style: theme.axis.domain.line, x1: 0, y1: 0 }, values));
            }), legendNode);
        });
    };

    return Axis;
}(React.Component);

Axis.propTypes = _extends({
    axis: PropTypes.oneOf(['x', 'y']).isRequired,
    scale: PropTypes.func.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    length: PropTypes.number.isRequired,
    ticksPosition: PropTypes.oneOf(['before', 'after']).isRequired,
    tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    tickSize: PropTypes.number.isRequired,
    tickPadding: PropTypes.number.isRequired,
    tickRotation: PropTypes.number.isRequired,
    tickFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    renderTick: PropTypes.func.isRequired,
    legend: PropTypes.node,
    legendPosition: PropTypes.oneOf(['start', 'middle', 'end']).isRequired,
    legendOffset: PropTypes.number.isRequired,
    theme: PropTypes.shape({
        axis: core.axisThemePropType.isRequired
    }).isRequired
}, core.motionPropTypes);
Axis.defaultProps = {
    x: 0,
    y: 0,
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    renderTick: defaultTickRenderer,
    legendPosition: 'end',
    legendOffset: 0
};

var enhance = compose(core.withMotion(), withPropsOnChange(['format', 'scale'], function (_ref3) {
    var format = _ref3.format,
        scale = _ref3.scale;
    return {
        format: getFormatter(format, scale)
    };
}), pure);

var Axis$1 = setDisplayName('Axis')(enhance(Axis));

var axisPropTypes = {
    ticksPosition: PropTypes.oneOf(['before', 'after']),
    tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    tickSize: PropTypes.number,
    tickPadding: PropTypes.number,
    tickRotation: PropTypes.number,
    format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    renderTick: PropTypes.func,
    legend: PropTypes.node,
    legendPosition: PropTypes.oneOf(['start', 'middle', 'end']),
    legendOffset: PropTypes.number
};

var axisPropType = PropTypes.shape(axisPropTypes);

var positions = ['top', 'right', 'bottom', 'left'];

var Axes = function (_PureComponent) {
    inherits(Axes, _PureComponent);

    function Axes() {
        classCallCheck(this, Axes);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    Axes.prototype.render = function render() {
        var _props = this.props,
            xScale = _props.xScale,
            yScale = _props.yScale,
            width = _props.width,
            height = _props.height,
            top = _props.top,
            right = _props.right,
            bottom = _props.bottom,
            left = _props.left,
            theme = _props.theme,
            animate = _props.animate,
            motionStiffness = _props.motionStiffness,
            motionDamping = _props.motionDamping;

        var axes = { top: top, right: right, bottom: bottom, left: left };

        return React__default.createElement(React.Fragment, null, positions.map(function (position) {
            var axis = axes[position];

            if (!axis) return null;

            var isXAxis = position === 'top' || position === 'bottom';
            var ticksPosition = position === 'top' || position === 'left' ? 'before' : 'after';

            return React__default.createElement(Axis$1, _extends({
                key: position
            }, axis, {
                axis: isXAxis ? 'x' : 'y',
                x: position === 'right' ? width : 0,
                y: position === 'bottom' ? height : 0,
                scale: isXAxis ? xScale : yScale,
                length: isXAxis ? width : height,
                ticksPosition: ticksPosition,
                theme: theme,
                animate: animate,
                motionDamping: motionDamping,
                motionStiffness: motionStiffness
            }));
        }));
    };

    return Axes;
}(React.PureComponent);

Axes.propTypes = _extends({
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    top: axisPropType,
    right: axisPropType,
    bottom: axisPropType,
    left: axisPropType,
    theme: PropTypes.shape({
        axis: core.axisThemePropType.isRequired
    }).isRequired
}, core.motionPropTypes);

var degreesToRadians = function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
};

var renderAxisToCanvas = function renderAxisToCanvas(ctx, _ref) {
    var axis = _ref.axis,
        scale = _ref.scale,
        _ref$x = _ref.x,
        x = _ref$x === undefined ? 0 : _ref$x,
        _ref$y = _ref.y,
        y = _ref$y === undefined ? 0 : _ref$y,
        length = _ref.length,
        ticksPosition = _ref.ticksPosition,
        tickValues = _ref.tickValues,
        _ref$tickSize = _ref.tickSize,
        tickSize = _ref$tickSize === undefined ? 5 : _ref$tickSize,
        _ref$tickPadding = _ref.tickPadding,
        tickPadding = _ref$tickPadding === undefined ? 5 : _ref$tickPadding,
        _ref$tickRotation = _ref.tickRotation,
        tickRotation = _ref$tickRotation === undefined ? 0 : _ref$tickRotation,
        format = _ref.format,
        theme = _ref.theme;

    var _computeCartesianTick = computeCartesianTicks({
        axis: axis,
        scale: scale,
        ticksPosition: ticksPosition,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation,
        engine: 'canvas'
    }),
        ticks = _computeCartesianTick.ticks,
        textAlign = _computeCartesianTick.textAlign,
        textBaseline = _computeCartesianTick.textBaseline;

    ctx.save();
    ctx.translate(x, y);

    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = theme.axis.ticks.text.fontSize + 'px ' + (theme.axis.ticks.text.fontFamily || 'sans-serif');

    ctx.lineWidth = theme.axis.domain.line.strokeWidth;
    ctx.lineCap = 'square';
    ctx.strokeStyle = theme.axis.domain.line.stroke;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(axis === 'x' ? length : 0, axis === 'x' ? 0 : length);
    ctx.stroke();

    ticks.forEach(function (tick) {
        ctx.lineWidth = theme.axis.ticks.line.strokeWidth;
        ctx.lineCap = 'square';
        ctx.strokeStyle = theme.axis.ticks.line.stroke;
        ctx.beginPath();
        ctx.moveTo(tick.x, tick.y);
        ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
        ctx.stroke();

        var value = format !== undefined ? format(tick.value) : tick.value;

        ctx.save();
        ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
        ctx.rotate(degreesToRadians(tickRotation));
        ctx.fillStyle = theme.axis.ticks.text.fill;
        ctx.fillText(value, 0, 0);
        ctx.restore();
    });

    ctx.restore();
};

var positions$1 = ['top', 'right', 'bottom', 'left'];

var renderAxesToCanvas = function renderAxesToCanvas(ctx, _ref2) {
    var xScale = _ref2.xScale,
        yScale = _ref2.yScale,
        width = _ref2.width,
        height = _ref2.height,
        top = _ref2.top,
        right = _ref2.right,
        bottom = _ref2.bottom,
        left = _ref2.left,
        theme = _ref2.theme;

    var axes = { top: top, right: right, bottom: bottom, left: left };

    positions$1.forEach(function (position) {
        var axis = axes[position];

        if (!axis) return null;

        var isXAxis = position === 'top' || position === 'bottom';
        var ticksPosition = position === 'top' || position === 'left' ? 'before' : 'after';
        var scale = isXAxis ? xScale : yScale;
        var format = getFormatter(axis.format, scale);

        renderAxisToCanvas(ctx, _extends({}, axis, {
            axis: isXAxis ? 'x' : 'y',
            x: position === 'right' ? width : 0,
            y: position === 'bottom' ? height : 0,
            scale: scale,
            format: format,
            length: isXAxis ? width : height,
            ticksPosition: ticksPosition,
            theme: theme
        }));
    });
};

exports.Axes = Axes;
exports.Axis = Axis$1;
exports.renderAxisToCanvas = renderAxisToCanvas;
exports.renderAxesToCanvas = renderAxesToCanvas;
exports.axisPropTypes = axisPropTypes;
exports.axisPropType = axisPropType;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1557);

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
    return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(1));
var Measure = _interopDefault(__webpack_require__(2313));
var pure = _interopDefault(__webpack_require__(728));
var reactMotion = __webpack_require__(466);
var d3Interpolate = __webpack_require__(323);
var isFunction = _interopDefault(__webpack_require__(197));
var d3Format = __webpack_require__(321);
var compose = _interopDefault(__webpack_require__(727));
var withPropsOnChange = _interopDefault(__webpack_require__(729));
var memoize = _interopDefault(__webpack_require__(1053));
var get = _interopDefault(__webpack_require__(1050));
var d3Color = __webpack_require__(152);
var last = _interopDefault(__webpack_require__(666));
var isArray = _interopDefault(__webpack_require__(80));
var d3Scale = __webpack_require__(912);
var d3ScaleChromatic = __webpack_require__(1767);
var isString = _interopDefault(__webpack_require__(2164));
var setPropTypes = _interopDefault(__webpack_require__(2470));
var defaultProps = _interopDefault(__webpack_require__(1269));
var without = _interopDefault(__webpack_require__(2181));
var d3Shape = __webpack_require__(924);
var d3Hierarchy = __webpack_require__(1726);
var withProps = _interopDefault(__webpack_require__(2474));
var isEqual = _interopDefault(__webpack_require__(663));
var partialRight = _interopDefault(__webpack_require__(2168));
var merge = _interopDefault(__webpack_require__(2166));
var isNumber = _interopDefault(__webpack_require__(665));
var d3TimeFormat = __webpack_require__(328);
var shouldUpdate = _interopDefault(__webpack_require__(1272));
var isPlainObject = _interopDefault(__webpack_require__(453));
var pick = _interopDefault(__webpack_require__(2169));
var set = _interopDefault(__webpack_require__(2172));

var noop = function noop() {};

var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }

    return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
};

var containerStyle = {
    position: 'relative'
};

var tooltipStyle = {
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 10
};

var noopHandlers = {
    showTooltip: noop,
    hideTooltip: noop
};

var Container = function (_Component) {
    inherits(Container, _Component);

    function Container() {
        var _temp, _this, _ret;

        classCallCheck(this, Container);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            isTooltipVisible: false,
            tooltipContent: null,
            position: {}
        }, _this.showTooltip = function (content, event) {
            var clientX = event.clientX,
                clientY = event.clientY;

            var bounds = _this.container.getBoundingClientRect();

            var x = clientX - bounds.left;
            var y = clientY - bounds.top;

            var position = {};

            if (x < bounds.width / 2) position.left = x + 20;else position.right = bounds.width - x + 20;

            if (y < bounds.height / 2) position.top = y - 12;else position.bottom = bounds.height - y - 12;

            _this.setState({
                isTooltipVisible: true,
                tooltipContent: content,
                position: position
            });
        }, _this.hideTooltip = function () {
            _this.setState({ isTooltipVisible: false, tooltipContent: null });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    Container.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            children = _props.children,
            isInteractive = _props.isInteractive,
            theme = _props.theme;
        var _state = this.state,
            isTooltipVisible = _state.isTooltipVisible,
            tooltipContent = _state.tooltipContent,
            position = _state.position;

        if (!isInteractive) return children(noopHandlers);

        return React__default.createElement('div', {
            style: containerStyle,
            ref: function ref(container) {
                _this2.container = container;
            }
        }, children({
            showTooltip: this.showTooltip,
            hideTooltip: this.hideTooltip
        }), isTooltipVisible && React__default.createElement('div', {
            style: _extends({}, tooltipStyle, position, theme.tooltip)
        }, tooltipContent));
    };

    return Container;
}(React.Component);

Container.propTypes = {
    children: PropTypes.func.isRequired,
    isInteractive: PropTypes.bool.isRequired,
    theme: PropTypes.object.isRequired
};
Container.defaultProps = {
    isInteractive: true
};

var ResponsiveWrapper = function (_Component) {
    inherits(ResponsiveWrapper, _Component);

    function ResponsiveWrapper() {
        var _temp, _this, _ret;

        classCallCheck(this, ResponsiveWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            dimensions: {
                width: -1,
                height: -1
            }
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    ResponsiveWrapper.prototype.render = function render() {
        var _this2 = this;

        var _state$dimensions = this.state.dimensions,
            width = _state$dimensions.width,
            height = _state$dimensions.height;

        var shouldRender = width > 0 && height > 0;

        return React__default.createElement(Measure, {
            bounds: true,
            onResize: function onResize(contentRect) {
                _this2.setState({ dimensions: contentRect.bounds });
            }
        }, function (_ref) {
            var measureRef = _ref.measureRef;
            return React__default.createElement('div', { ref: measureRef, style: { width: '100%', height: '100%' } }, shouldRender && _this2.props.children({ width: width, height: height }));
        });
    };

    return ResponsiveWrapper;
}(React.Component);

ResponsiveWrapper.propTypes = {
    children: PropTypes.func.isRequired
};

var LinearGradient = function LinearGradient(_ref) {
    var id = _ref.id,
        colors = _ref.colors;
    return React__default.createElement('linearGradient', { id: id, x1: 0, x2: 0, y1: 0, y2: 1 }, colors.map(function (_ref2) {
        var offset = _ref2.offset,
            color = _ref2.color,
            opacity = _ref2.opacity;
        return React__default.createElement('stop', {
            key: offset,
            offset: offset + '%',
            stopColor: color,
            stopOpacity: opacity !== undefined ? opacity : 1
        });
    }));
};

LinearGradient.propTypes = {
    id: PropTypes.string.isRequired,
    colors: PropTypes.arrayOf(PropTypes.shape({
        offset: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired
    })).isRequired
};

var linearGradientDef = function linearGradientDef(id, colors) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _extends({
        id: id,
        type: 'linearGradient',
        colors: colors
    }, options);
};

var gradientTypes = {
    linearGradient: LinearGradient
};

var PatternDots = pure(function (_ref) {
    var id = _ref.id,
        background = _ref.background,
        color = _ref.color,
        size = _ref.size,
        padding = _ref.padding,
        stagger = _ref.stagger;

    var fullSize = size + padding;
    var radius = size / 2;
    var halfPadding = padding / 2;
    if (stagger === true) {
        fullSize = size * 2 + padding * 2;
    }

    return React__default.createElement('pattern', { id: id, width: fullSize, height: fullSize, patternUnits: 'userSpaceOnUse' }, React__default.createElement('rect', { width: fullSize, height: fullSize, fill: background }), React__default.createElement('circle', { cx: halfPadding + radius, cy: halfPadding + radius, r: radius, fill: color }), stagger && React__default.createElement('circle', {
        cx: padding * 1.5 + size + radius,
        cy: padding * 1.5 + size + radius,
        r: radius,
        fill: color
    }));
});

PatternDots.propTypes = {
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    background: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    padding: PropTypes.number.isRequired,
    stagger: PropTypes.bool.isRequired
};

PatternDots.defaultProps = {
    color: '#000000',
    background: '#ffffff',
    size: 4,
    padding: 4,
    stagger: false
};

var patternDotsDef = function patternDotsDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _extends({
        id: id,
        type: 'patternDots'
    }, options);
};

var TWO_PI = Math.PI * 2;

var degreesToRadians = function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
};

var radiansToDegrees = function radiansToDegrees(radians) {
    return 180 * radians / Math.PI;
};

var midAngle = function midAngle(arc) {
    return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
};

var positionFromAngle = function positionFromAngle(angle, distance) {
    return {
        x: Math.cos(angle) * distance,
        y: Math.sin(angle) * distance
    };
};

/**
 * Normalize given angle (degrees) in the 0~360 range.
 *
 * @param {number} angle
 *
 * @return {number}
 */
var absoluteAngleDegrees = function absoluteAngleDegrees(angle) {
    var absAngle = angle % 360;
    if (absAngle < 0) {
        absAngle += 360;
    }

    return absAngle;
};

var absoluteAngleRadians = function absoluteAngleRadians(angle) {
    return angle - TWO_PI * Math.floor((angle + Math.PI) / TWO_PI);
};

/**
 * Computes the bounding box for a circle arc.
 *
 * Assumptions:
 *   - Anywhere the arc intersects an axis will be a max or a min.
 *   - If the arc doesn't intersect an axis, then the center
 *     will be one corner of the bounding rectangle,
 *     and this is the only case when it will be.
 *   - The only other possible extreme points of the sector to consider
 *     are the endpoints of the radii.
 *
 * This script was built within the help of this answer on stackoverflow:
 *   https://stackoverflow.com/questions/1336663/2d-bounding-box-of-a-sector
 *
 * @param {number}  ox                   - circle x origin
 * @param {number}  oy                   - circle y origin
 * @param {number}  radius               - circle radius
 * @param {number}  startAngle           - arc start angle
 * @param {number}  endAngle             - arc end angle
 * @param {boolean} [includeCenter=true] - if true, include the center
 *
 * @return {{ points: *[][], x: number, y: number, width: number, height: number }}
 */
var computeArcBoundingBox = function computeArcBoundingBox(ox, oy, radius, startAngle, endAngle) {
    var includeCenter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    var points = [];

    var p0 = positionFromAngle(degreesToRadians(startAngle), radius);
    points.push([p0.x, p0.y]);

    var p1 = positionFromAngle(degreesToRadians(endAngle), radius);
    points.push([p1.x, p1.y]);

    for (var angle = Math.round(Math.min(startAngle, endAngle)); angle <= Math.round(Math.max(startAngle, endAngle)); angle++) {
        if (angle % 90 === 0) {
            var p = positionFromAngle(degreesToRadians(angle), radius);
            points.push([p.x, p.y]);
        }
    }

    points = points.map(function (_ref) {
        var x = _ref[0],
            y = _ref[1];
        return [ox + x, oy + y];
    });
    if (includeCenter === true) points.push([ox, oy]);

    var xs = points.map(function (_ref2) {
        var x = _ref2[0];
        return x;
    });
    var ys = points.map(function (_ref3) {
        var y = _ref3[1];
        return y;
    });

    var x0 = Math.min.apply(Math, xs);
    var x1 = Math.max.apply(Math, xs);

    var y0 = Math.min.apply(Math, ys);
    var y1 = Math.max.apply(Math, ys);

    return {
        points: points,
        x: x0,
        y: y0,
        width: x1 - x0,
        height: y1 - y0
    };
};

var textPropsByEngine = {
    svg: {
        align: {
            left: 'start',
            center: 'middle',
            right: 'end'
        },
        baseline: {
            top: 'before-edge',
            center: 'central',
            bottom: 'after-edge'
        }
    },
    canvas: {
        align: {
            left: 'left',
            center: 'center',
            right: 'right'
        },
        baseline: {
            top: 'top',
            center: 'middle',
            bottom: 'bottom'
        }
    }
};

/**
 * @param {number} radius
 * @param {number} angle          angle (radians)
 * @param {number} [rotation=0]   label rotation (degrees)
 * @param {string} [engine='svg'] one of: 'svg', 'canvas'
 * @return {{ x: number, y: number, rotate: number, align: string, baseline: string }}
 */
var getPolarLabelProps = function getPolarLabelProps(radius, angle, rotation) {
    var engine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'svg';

    var textProps = textPropsByEngine[engine];

    var _positionFromAngle = positionFromAngle(angle - Math.PI / 2, radius),
        x = _positionFromAngle.x,
        y = _positionFromAngle.y;

    var rotate = radiansToDegrees(angle);
    var align = textProps.align.center;
    var baseline = textProps.baseline.bottom;

    if (rotation > 0) {
        align = textProps.align.right;
        baseline = textProps.baseline.center;
    } else if (rotation < 0) {
        align = textProps.align.left;
        baseline = textProps.baseline.center;
    }

    // reverse labels after 180°
    if (rotation !== 0 && rotate > 180) {
        rotate -= 180;
        align = align === textProps.align.right ? textProps.align.left : textProps.align.right;
    }

    rotate += rotation;

    return { x: x, y: y, rotate: rotate, align: align, baseline: baseline };
};

var PatternLines = pure(function (_ref) {
    var id = _ref.id,
        _spacing = _ref.spacing,
        _rotation = _ref.rotation,
        background = _ref.background,
        color = _ref.color,
        lineWidth = _ref.lineWidth;

    var rotation = Math.round(_rotation) % 360;
    var spacing = Math.abs(_spacing);

    if (rotation > 180) rotation = rotation - 360;else if (rotation > 90) rotation = rotation - 180;else if (rotation < -180) rotation = rotation + 360;else if (rotation < -90) rotation = rotation + 180;

    var width = spacing;
    var height = spacing;
    var path = void 0;

    if (rotation === 0) {
        path = '\n                M 0 0 L ' + width + ' 0\n                M 0 ' + height + ' L ' + width + ' ' + height + '\n            ';
    } else if (rotation === 90) {
        path = '\n                M 0 0 L 0 ' + height + '\n                M ' + width + ' 0 L ' + width + ' ' + height + '\n            ';
    } else {
        width = Math.abs(spacing / Math.sin(degreesToRadians(rotation)));
        height = spacing / Math.sin(degreesToRadians(90 - rotation));

        if (rotation > 0) {
            path = '\n                    M 0 ' + -height + ' L ' + width * 2 + ' ' + height + '\n                    M ' + -width + ' ' + -height + ' L ' + width + ' ' + height + '\n                    M ' + -width + ' 0 L ' + width + ' ' + height * 2 + '\n                ';
        } else {
            path = '\n                    M ' + -width + ' ' + height + ' L ' + width + ' ' + -height + '\n                    M ' + -width + ' ' + height * 2 + ' L ' + width * 2 + ' ' + -height + '\n                    M 0 ' + height * 2 + ' L ' + width * 2 + ' 0\n                ';
        }
    }

    return React__default.createElement('pattern', { id: id, width: width, height: height, patternUnits: 'userSpaceOnUse' }, React__default.createElement('rect', {
        width: width,
        height: height,
        fill: background,
        stroke: 'rgba(255, 0, 0, 0.1)',
        strokeWidth: 0
    }), React__default.createElement('path', { d: path, strokeWidth: lineWidth, stroke: color, strokeLinecap: 'square' }));
});

PatternLines.propTypes = {
    id: PropTypes.string.isRequired,
    spacing: PropTypes.number.isRequired,
    rotation: PropTypes.number.isRequired,
    background: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    lineWidth: PropTypes.number.isRequired
};

PatternLines.defaultProps = {
    spacing: 5,
    rotation: 0,
    color: '#000000',
    background: '#ffffff',
    lineWidth: 2
};

var patternLinesDef = function patternLinesDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _extends({
        id: id,
        type: 'patternLines'
    }, options);
};

var PatternSquares = pure(function (_ref) {
    var id = _ref.id,
        background = _ref.background,
        color = _ref.color,
        size = _ref.size,
        padding = _ref.padding,
        stagger = _ref.stagger;

    var fullSize = size + padding;
    var halfPadding = padding / 2;
    if (stagger === true) {
        fullSize = size * 2 + padding * 2;
    }

    return React__default.createElement('pattern', { id: id, width: fullSize, height: fullSize, patternUnits: 'userSpaceOnUse' }, React__default.createElement('rect', { width: fullSize, height: fullSize, fill: background }), React__default.createElement('rect', { x: halfPadding, y: halfPadding, width: size, height: size, fill: color }), stagger && React__default.createElement('rect', {
        x: padding * 1.5 + size,
        y: padding * 1.5 + size,
        width: size,
        height: size,
        fill: color
    }));
});

PatternSquares.propTypes = {
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    background: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    padding: PropTypes.number.isRequired,
    stagger: PropTypes.bool.isRequired
};

PatternSquares.defaultProps = {
    color: '#000000',
    background: '#ffffff',
    size: 4,
    padding: 4,
    stagger: false
};

var patternSquaresDef = function patternSquaresDef(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _extends({
        id: id,
        type: 'patternSquares'
    }, options);
};

var patternTypes = {
    patternDots: PatternDots,
    patternLines: PatternLines,
    patternSquares: PatternSquares
};

var defsMapping = _extends({}, gradientTypes, patternTypes);

var Defs = pure(function (_ref) {
    var definitions = _ref.defs;

    if (!definitions || definitions.length < 1) return null;

    return React__default.createElement('defs', null, definitions.map(function (_ref2) {
        var type = _ref2.type,
            def = objectWithoutProperties(_ref2, ['type']);

        if (defsMapping[type]) return React__default.createElement(defsMapping[type], _extends({ key: def.id }, def));

        return null;
    }));
});
Defs.propTypes = {
    defs: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.oneOf(Object.keys(defsMapping)).isRequired,
        id: PropTypes.string.isRequired
    }))
};

var axisThemePropType = PropTypes.shape({
    domain: PropTypes.shape({
        line: PropTypes.shape({
            stroke: PropTypes.string.isRequired,
            strokeWidth: PropTypes.number.isRequired,
            strokeDasharray: PropTypes.string
        }).isRequired
    }).isRequired,
    ticks: PropTypes.shape({
        line: PropTypes.shape({
            stroke: PropTypes.string.isRequired,
            strokeWidth: PropTypes.number.isRequired,
            strokeDasharray: PropTypes.string
        }).isRequired,
        text: PropTypes.shape({
            fill: PropTypes.string.isRequired,
            fontSize: PropTypes.number.isRequired
        }).isRequired
    }).isRequired,
    legend: PropTypes.shape({
        text: PropTypes.shape({
            fill: PropTypes.string.isRequired,
            fontSize: PropTypes.number.isRequired
        }).isRequired
    }).isRequired
});

var gridThemePropType = PropTypes.shape({
    line: PropTypes.shape({
        stroke: PropTypes.string.isRequired,
        strokeWidth: PropTypes.number.isRequired,
        strokeDasharray: PropTypes.string
    }).isRequired
});

var legendsThemePropType = PropTypes.shape({
    text: PropTypes.shape({
        fill: PropTypes.string.isRequired,
        fontSize: PropTypes.number.isRequired
    }).isRequired
});

var labelsThemePropType = PropTypes.shape({
    text: PropTypes.shape({
        fill: PropTypes.string.isRequired,
        fontSize: PropTypes.number.isRequired
    }).isRequired
});

var dotsThemePropType = PropTypes.shape({
    text: PropTypes.shape({
        fill: PropTypes.string.isRequired,
        fontSize: PropTypes.number.isRequired
    }).isRequired
});

var themePropType = PropTypes.shape({
    background: PropTypes.string.isRequired,
    axis: axisThemePropType.isRequired,
    grid: gridThemePropType.isRequired,
    legends: legendsThemePropType.isRequired,
    labels: labelsThemePropType.isRequired,
    dots: dotsThemePropType.isRequired
});

var defaultTextColor = '#333333';
var defaultFontSize = 11;

var defaultTheme = {
    background: 'transparent',
    axis: {
        domain: {
            line: {
                stroke: 'transparent',
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: '#777',
                strokeWidth: 1
            },
            text: {
                fill: defaultTextColor,
                fontSize: defaultFontSize
            }
        },
        legend: {
            text: {
                fill: defaultTextColor,
                fontSize: defaultFontSize
            }
        }
    },
    grid: {
        line: {
            stroke: '#ddd',
            strokeWidth: 1
        }
    },
    legends: {
        text: {
            fill: defaultTextColor,
            fontSize: defaultFontSize
        }
    },
    labels: {
        text: {
            fill: defaultTextColor,
            fontSize: defaultFontSize
        }
    },
    markers: {
        lineColor: '#000',
        lineStrokeWidth: 1,
        textColor: defaultTextColor,
        fontSize: defaultFontSize
    },
    dots: {
        text: {
            fill: defaultTextColor,
            fontSize: defaultFontSize
        }
    },
    tooltip: {
        container: {
            background: 'white',
            color: 'inherit',
            fontSize: 'inherit',
            borderRadius: '2px',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
            padding: '5px 9px'
        },
        basic: {
            whiteSpace: 'pre',
            display: 'flex',
            alignItems: 'center'
        },
        table: {},
        tableCell: {
            padding: '3px 5px'
        }
    }
};

var SvgWrapper = function SvgWrapper(_ref) {
    var width = _ref.width,
        height = _ref.height,
        margin = _ref.margin,
        defs = _ref.defs,
        children = _ref.children,
        theme = _ref.theme;
    return React__default.createElement('svg', { xmlns: 'http://www.w3.org/2000/svg', role: 'img', width: width, height: height }, React__default.createElement(Defs, { defs: defs }), React__default.createElement('rect', { width: width, height: height, fill: theme.background }), React__default.createElement('g', { transform: 'translate(' + margin.left + ',' + margin.top + ')' }, children));
};

SvgWrapper.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    margin: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired
    }).isRequired,
    defs: PropTypes.array,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    theme: themePropType.isRequired
};

// credit to Tanner Linsey from this issue on react motion repository:

var enhancedSpring = function enhancedSpring(value, config) {
    if (typeof value !== 'number') {
        return {
            value: value,
            config: config,
            interpolator: config && config.interpolator ? config.interpolator : d3Interpolate.interpolate
        };
    }
    return reactMotion.spring(value, config);
};

var SmartMotion = function (_PureComponent) {
    inherits(SmartMotion, _PureComponent);

    function SmartMotion() {
        var _temp, _this, _ret;

        classCallCheck(this, SmartMotion);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.oldValues = {}, _this.newInters = {}, _this.currentStepValues = {}, _this.stepValues = {}, _this.stepInterpolators = {}, _temp), possibleConstructorReturn(_this, _ret);
    }

    SmartMotion.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            style = _props.style,
            children = _props.children,
            rest = objectWithoutProperties(_props, ['style', 'children']);

        var resolvedStyle = style(enhancedSpring);

        for (var key in resolvedStyle) {
            if (
            // If key is a non-numeric interpolation
            resolvedStyle[key] && resolvedStyle[key].interpolator) {
                // Make sure the steps start at 0
                this.currentStepValues[key] = this.currentStepValues[key] || 0;
                if (
                // And the value has changed
                typeof this.newInters[key] === 'undefined' || resolvedStyle[key].value !== this.newInters[key].value) {
                    // Save the new value
                    this.newInters[key] = resolvedStyle[key];

                    // Increment the stepInterValue for this key by 1
                    this.stepValues[key] = this.currentStepValues[key] + 1;

                    // Set up the new interpolator
                    this.stepInterpolators[key] = this.newInters[key].interpolator(this.oldValues[key], this.newInters[key].value);
                }
                // Return the spring with the destination stepValue and spring config
                resolvedStyle[key] = reactMotion.spring(this.stepValues[key], this.newInters[key].config);
                // console.log(resolvedStyle[key])
            }
        }

        return React__default.createElement(reactMotion.Motion, _extends({}, rest, { style: resolvedStyle }), function (values) {
            var newValues = {};
            for (var _key2 in values) {
                if (_this2.stepValues[_key2]) {
                    // Save the currentStepValue
                    _this2.currentStepValues[_key2] = values[_key2];
                    // Figure the percentage
                    var percentage = _this2.currentStepValues[_key2] - _this2.stepValues[_key2] + 1;
                    // Save the current value and replace the value in the interpolated object
                    _this2.oldValues[_key2] = newValues[_key2] = _this2.stepInterpolators[_key2](percentage);
                }
            }
            return children(_extends({}, values, newValues));
        });
    };

    return SmartMotion;
}(React.PureComponent);

SmartMotion.propTypes = {
    children: PropTypes.func.isRequired,
    style: PropTypes.func.isRequired
};

var DotsItemSymbol = function DotsItemSymbol(_ref) {
    var size = _ref.size,
        color = _ref.color,
        borderWidth = _ref.borderWidth,
        borderColor = _ref.borderColor;
    return React__default.createElement('circle', {
        r: size / 2,
        fill: color,
        stroke: borderColor,
        strokeWidth: borderWidth,
        style: { pointerEvents: 'none' }
    });
};

DotsItemSymbol.propTypes = {
    size: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    borderWidth: PropTypes.number.isRequired,
    borderColor: PropTypes.string.isRequired
};

var DotsItemSymbol$1 = pure(DotsItemSymbol);

var DotsItem = function DotsItem(_ref) {
    var x = _ref.x,
        y = _ref.y,
        symbol = _ref.symbol,
        size = _ref.size,
        datum = _ref.datum,
        color = _ref.color,
        borderWidth = _ref.borderWidth,
        borderColor = _ref.borderColor,
        label = _ref.label,
        labelTextAnchor = _ref.labelTextAnchor,
        labelYOffset = _ref.labelYOffset,
        theme = _ref.theme;
    return React__default.createElement('g', { transform: 'translate(' + x + ', ' + y + ')', style: { pointerEvents: 'none' } }, React__default.createElement(symbol, {
        size: size,
        color: color,
        datum: datum,
        borderWidth: borderWidth,
        borderColor: borderColor
    }), label && React__default.createElement('text', { textAnchor: labelTextAnchor, y: labelYOffset, style: theme.dots.text }, label));
};

DotsItem.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    datum: PropTypes.object.isRequired,

    size: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    borderWidth: PropTypes.number.isRequired,
    borderColor: PropTypes.string.isRequired,

    symbol: PropTypes.func.isRequired,

    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    labelTextAnchor: PropTypes.oneOf(['start', 'middle', 'end']),
    labelYOffset: PropTypes.number.isRequired,

    theme: PropTypes.shape({
        dots: dotsThemePropType.isRequired
    }).isRequired
};

var DotsItemDefaultProps = {
    symbol: DotsItemSymbol$1,

    // label
    labelTextAnchor: 'middle',
    labelYOffset: -12
};

DotsItem.defaultProps = DotsItemDefaultProps;

var DotsItem$1 = pure(DotsItem);

var Chip = function Chip(_ref) {
    var size = _ref.size,
        color = _ref.color,
        style = _ref.style;
    return React__default.createElement('span', { style: _extends({ display: 'block', width: size, height: size, background: color }, style) });
};

Chip.propTypes = {
    size: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    style: PropTypes.object.isRequired
};

Chip.defaultProps = {
    size: 12,
    style: {}
};

var Chip$1 = pure(Chip);

var chipStyle = { marginRight: 7 };

var BasicTooltip = function BasicTooltip(props) {
    var id = props.id,
        _value = props.value,
        format = props.format,
        enableChip = props.enableChip,
        color = props.color,
        theme = props.theme,
        renderContent = props.renderContent;

    var content = void 0;
    if (typeof renderContent === 'function') {
        content = renderContent();
    } else {
        var value = _value;
        if (format !== undefined && value !== undefined) {
            value = format(value);
        }
        content = React__default.createElement('div', { style: theme.tooltip.basic }, enableChip && React__default.createElement(Chip$1, { color: color, style: chipStyle }), value !== undefined ? React__default.createElement('span', null, id, ': ', React__default.createElement('strong', null, isNaN(value) ? String(value) : value)) : id);
    }

    return React__default.createElement('div', { style: theme.tooltip.container }, content);
};

BasicTooltip.propTypes = {
    id: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    enableChip: PropTypes.bool.isRequired,
    color: PropTypes.string,
    format: PropTypes.func,
    renderContent: PropTypes.func,

    theme: PropTypes.shape({
        tooltip: PropTypes.shape({
            container: PropTypes.object.isRequired,
            basic: PropTypes.object.isRequired
        }).isRequired
    }).isRequired
};

BasicTooltip.defaultProps = {
    enableChip: false
};

var enhance = compose(withPropsOnChange(['format'], function (_ref) {
    var format = _ref.format;

    if (!format || isFunction(format)) return { format: format };
    return { format: d3Format.format(format) };
}), pure);

var BasicTooltip$1 = enhance(BasicTooltip);

var tableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
};

var TableTooltip = function TableTooltip(_ref) {
    var title = _ref.title,
        rows = _ref.rows,
        theme = _ref.theme,
        renderContent = _ref.renderContent;

    if (!rows.length) return null;

    var content = void 0;
    if (typeof renderContent === 'function') {
        content = renderContent();
    } else {
        content = React__default.createElement('div', null, title && title, React__default.createElement('table', { style: _extends({}, tableStyle, theme.tooltip.table) }, React__default.createElement('tbody', null, rows.map(function (row, i) {
            return React__default.createElement('tr', { key: i }, row.map(function (column, j) {
                return React__default.createElement('td', { key: j, style: theme.tooltip.tableCell }, column);
            }));
        }))));
    }
    return React__default.createElement('div', { style: theme.tooltip.container }, content);
};

TableTooltip.propTypes = {
    title: PropTypes.node,
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
    theme: PropTypes.shape({
        tooltip: PropTypes.shape({
            container: PropTypes.object.isRequired,
            table: PropTypes.object.isRequired,
            tableCell: PropTypes.object.isRequired
        }).isRequired
    }).isRequired,
    renderContent: PropTypes.func
};

TableTooltip.defaultProps = {};

var TableTooltip$1 = pure(TableTooltip);

/**
 * Memoize both color generator & color generator result.
 */
var memoizedColorModifier = memoize(function (method, _amount) {
    var amount = parseFloat(_amount);

    return memoize(function (d) {
        return d3Color.rgb(d.color)[method](amount) // eslint-disable-line no-unexpected-multiline
        .toString();
    }, function (d) {
        return d.color;
    });
}, function (method, amount) {
    return method + '.' + amount;
});

var noneGenerator = function noneGenerator() {
    return 'none';
};
var inheritGenerator = function inheritGenerator(d) {
    return d.color;
};

/**
 * @param {string|Function} instruction
 * @param {string}          [themeKey]
 * @return {Function}
 */
var getInheritedColorGenerator = function getInheritedColorGenerator(instruction, themeKey) {
    if (instruction === 'none') return noneGenerator;

    if (isFunction(instruction)) return instruction;

    if (instruction === 'theme') {
        if (!themeKey) {
            throw new Error('Cannot use \'theme\' directive without providing \'themeKey\'');
        }

        return function (d, theme) {
            return get(theme, themeKey);
        };
    }

    if (instruction === 'inherit') return inheritGenerator;

    var inheritMatches = instruction.match(/inherit:(darker|brighter)\(([0-9.]+)\)/);
    if (inheritMatches) {
        var method = inheritMatches[1];
        var amount = inheritMatches[2];

        return memoizedColorModifier(method, amount);
    }

    return function () {
        return instruction;
    };
};

/**
 * Decompose a color for use with react-motion.
 *
 * @param {string} _color
 * @param {Object} [_config]
 * @return {Object}
 */
var colorMotionSpring = function colorMotionSpring(_color, _config) {
    var color = d3Color.rgb(_color);

    if (!_config) return {
        colorR: color.r,
        colorG: color.g,
        colorB: color.b
    };

    var config = Object.assign({}, _config, { precision: 1 });

    return {
        colorR: reactMotion.spring(color.r, config),
        colorG: reactMotion.spring(color.g, config),
        colorB: reactMotion.spring(color.b, config)
    };
};

/**
 * Re-assemble interpolated color components for easy use.
 *
 * @param {number} colorR
 * @param {number} colorG
 * @param {number} colorB
 * @return {string}
 */
var getInterpolatedColor = function getInterpolatedColor(_ref) {
    var colorR = _ref.colorR,
        colorG = _ref.colorG,
        colorB = _ref.colorB;
    return 'rgb(' + Math.round(Math.max(colorR, 0)) + ',' + Math.round(Math.max(colorG, 0)) + ',' + Math.round(Math.max(colorB, 0)) + ')';
};

var quantizeColorScales = {
    nivo: ['#d76445', '#f47560', '#e8c1a0', '#97e3d5', '#61cdbb', '#00b0a7'],

    // Diverging
    BrBG: last(d3ScaleChromatic.schemeBrBG),
    PRGn: last(d3ScaleChromatic.schemePRGn),
    PiYG: last(d3ScaleChromatic.schemePiYG),
    PuOr: last(d3ScaleChromatic.schemePuOr),
    RdBu: last(d3ScaleChromatic.schemeRdBu),
    RdGy: last(d3ScaleChromatic.schemeRdGy),
    RdYlBu: last(d3ScaleChromatic.schemeRdYlBu),
    RdYlGn: last(d3ScaleChromatic.schemeRdYlGn),
    spectral: last(d3ScaleChromatic.schemeSpectral),

    // Sequential (Single Hue)
    blues: last(d3ScaleChromatic.schemeBlues),
    greens: last(d3ScaleChromatic.schemeGreens),
    greys: last(d3ScaleChromatic.schemeGreys),
    oranges: last(d3ScaleChromatic.schemeOranges),
    purples: last(d3ScaleChromatic.schemePurples),
    reds: last(d3ScaleChromatic.schemeReds),

    // Sequential (Multi-Hue)
    BuGn: last(d3ScaleChromatic.schemeBuGn),
    BuPu: last(d3ScaleChromatic.schemeBuPu),
    GnBu: last(d3ScaleChromatic.schemeGnBu),
    OrRd: last(d3ScaleChromatic.schemeOrRd),
    PuBuGn: last(d3ScaleChromatic.schemePuBuGn),
    PuBu: last(d3ScaleChromatic.schemePuBu),
    PuRd: last(d3ScaleChromatic.schemePuRd),
    RdPu: last(d3ScaleChromatic.schemeRdPu),
    YlGnBu: last(d3ScaleChromatic.schemeYlGnBu),
    YlGn: last(d3ScaleChromatic.schemeYlGn),
    YlOrBr: last(d3ScaleChromatic.schemeYlOrBr),
    YlOrRd: last(d3ScaleChromatic.schemeYlOrRd)
};

var quantizeColorScalesKeys = Object.keys(quantizeColorScales);

var guessQuantizeColorScale = function guessQuantizeColorScale(colors) {
    // colors is already a valid scale
    if (isFunction(colors)) {
        if (!isFunction(colors.domain)) {
            throw new Error('Provided colors should be a valid quantize scale providing a \'domain()\' function');
        }

        return colors;
    }

    if (quantizeColorScales[colors]) {
        // use predefined d3 quantize color scale
        return d3Scale.scaleQuantize().range(quantizeColorScales[colors]);
    }

    // user defined colors
    if (isArray(colors)) return d3Scale.scaleQuantize().range(colors);

    throw new Error('Unable to guess quantize color scale from \'' + colors + '\',\nmust be a function or one of:\n\'' + quantizeColorScalesKeys.join('\', \'') + '\'');
};

// used for ordinal color scales
var colorSchemes = {
    nivo: ['#e8c1a0', '#f47560', '#f1e15b', '#e8a838', '#61cdbb', '#97e3d5'],
    // categorical
    category10: d3ScaleChromatic.schemeCategory10,
    accent: d3ScaleChromatic.schemeAccent,
    dark2: d3ScaleChromatic.schemeDark2,
    paired: d3ScaleChromatic.schemePaired,
    pastel1: d3ScaleChromatic.schemePastel1,
    pastel2: d3ScaleChromatic.schemePastel2,
    set1: d3ScaleChromatic.schemeSet1,
    set2: d3ScaleChromatic.schemeSet2,
    set3: d3ScaleChromatic.schemeSet3,
    // diverging
    brown_blueGreen: last(d3ScaleChromatic.schemeBrBG),
    purpleRed_green: last(d3ScaleChromatic.schemePRGn),
    pink_yellowGreen: last(d3ScaleChromatic.schemePiYG),
    purple_orange: last(d3ScaleChromatic.schemePuOr),
    red_blue: last(d3ScaleChromatic.schemeRdBu),
    red_grey: last(d3ScaleChromatic.schemeRdGy),
    red_yellow_blue: last(d3ScaleChromatic.schemeRdYlBu),
    red_yellow_green: last(d3ScaleChromatic.schemeRdYlGn),
    spectral: last(d3ScaleChromatic.schemeSpectral),
    // sequential single hue
    blues: last(d3ScaleChromatic.schemeBlues),
    greens: last(d3ScaleChromatic.schemeGreens),
    greys: last(d3ScaleChromatic.schemeGreys),
    oranges: last(d3ScaleChromatic.schemeOranges),
    purples: last(d3ScaleChromatic.schemePurples),
    reds: last(d3ScaleChromatic.schemeReds),
    // sequential multi hue
    blue_green: last(d3ScaleChromatic.schemeBuGn),
    blue_purple: last(d3ScaleChromatic.schemeBuPu),
    green_blue: last(d3ScaleChromatic.schemeGnBu),
    orange_red: last(d3ScaleChromatic.schemeOrRd),
    purple_blue_green: last(d3ScaleChromatic.schemePuBuGn),
    purple_blue: last(d3ScaleChromatic.schemePuBu),
    purple_red: last(d3ScaleChromatic.schemePuRd),
    red_purple: last(d3ScaleChromatic.schemeRdPu),
    yellow_green_blue: last(d3ScaleChromatic.schemeYlGnBu),
    yellow_green: last(d3ScaleChromatic.schemeYlGn),
    yellow_orange_brown: last(d3ScaleChromatic.schemeYlOrBr),
    yellow_orange_red: last(d3ScaleChromatic.schemeYlOrRd)
};

var colorSchemeIds = ['nivo',
// categorical
'category10', 'accent', 'dark2', 'paired', 'pastel1', 'pastel2', 'set1', 'set2', 'set3',
// diverging
'brown_blueGreen', 'purpleRed_green', 'pink_yellowGreen', 'purple_orange', 'red_blue', 'red_grey', 'red_yellow_blue', 'red_yellow_green', 'spectral',
// sequential single hue
'blues', 'greens', 'greys', 'oranges', 'purples', 'reds',
// sequential multi hue
'blue_green', 'blue_purple', 'green_blue', 'orange_red', 'purple_blue_green', 'purple_blue', 'purple_red', 'red_purple', 'yellow_green_blue', 'yellow_green', 'yellow_orange_brown', 'yellow_orange_red'];

// used for sequential color scales
var colorInterpolators = {
    // diverging
    brown_blueGreen: d3ScaleChromatic.interpolateBrBG,
    purpleRed_green: d3ScaleChromatic.interpolatePRGn,
    pink_yellowGreen: d3ScaleChromatic.interpolatePiYG,
    purple_orange: d3ScaleChromatic.interpolatePuOr,
    red_blue: d3ScaleChromatic.interpolateRdBu,
    red_grey: d3ScaleChromatic.interpolateRdGy,
    red_yellow_blue: d3ScaleChromatic.interpolateRdYlBu,
    red_yellow_green: d3ScaleChromatic.interpolateRdYlGn,
    spectral: d3ScaleChromatic.interpolateSpectral,
    // sequential single hue
    blues: d3ScaleChromatic.interpolateBlues,
    greens: d3ScaleChromatic.interpolateGreens,
    greys: d3ScaleChromatic.interpolateGreys,
    oranges: d3ScaleChromatic.interpolateOranges,
    purples: d3ScaleChromatic.interpolatePurples,
    reds: d3ScaleChromatic.interpolateReds,
    // sequential multi hue
    viridis: d3ScaleChromatic.interpolateViridis,
    inferno: d3ScaleChromatic.interpolateInferno,
    magma: d3ScaleChromatic.interpolateMagma,
    plasma: d3ScaleChromatic.interpolatePlasma,
    warm: d3ScaleChromatic.interpolateWarm,
    cool: d3ScaleChromatic.interpolateCool,
    cubehelixDefault: d3ScaleChromatic.interpolateCubehelixDefault,
    blue_green: d3ScaleChromatic.interpolateBuGn,
    blue_purple: d3ScaleChromatic.interpolateBuPu,
    green_blue: d3ScaleChromatic.interpolateGnBu,
    orange_red: d3ScaleChromatic.interpolateOrRd,
    purple_blue_green: d3ScaleChromatic.interpolatePuBuGn,
    purple_blue: d3ScaleChromatic.interpolatePuBu,
    purple_red: d3ScaleChromatic.interpolatePuRd,
    red_purple: d3ScaleChromatic.interpolateRdPu,
    yellow_green_blue: d3ScaleChromatic.interpolateYlGnBu,
    yellow_green: d3ScaleChromatic.interpolateYlGn,
    yellow_orange_brown: d3ScaleChromatic.interpolateYlOrBr,
    yellow_orange_red: d3ScaleChromatic.interpolateYlOrRd,
    // cyclical
    rainbow: d3ScaleChromatic.interpolateRainbow,
    sinebow: d3ScaleChromatic.interpolateSinebow
};

var colorInterpolatorIds = [
// diverging
'brown_blueGreen', 'purpleRed_green', 'pink_yellowGreen', 'purple_orange', 'red_blue', 'red_grey', 'red_yellow_blue', 'red_yellow_green', 'spectral',
// sequential single hue
'blues', 'greens', 'greys', 'oranges', 'purples', 'reds',
// sequential multi hue
'viridis', 'inferno', 'magma', 'plasma', 'warm', 'cool', 'cubehelixDefault', 'blue_green', 'blue_purple', 'green_blue', 'orange_red', 'purple_blue_green', 'purple_blue', 'purple_red', 'red_purple', 'yellow_green_blue', 'yellow_green', 'yellow_orange_brown', 'yellow_orange_red',
// cyclical
'rainbow', 'sinebow'];

var ordinalColorScales = {
    category10: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeCategory10),
    accent: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeAccent),
    dark2: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeDark2),
    paired: d3Scale.scaleOrdinal(d3ScaleChromatic.schemePaired),
    pastel1: d3Scale.scaleOrdinal(d3ScaleChromatic.schemePastel1),
    pastel2: d3Scale.scaleOrdinal(d3ScaleChromatic.schemePastel2),
    set1: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeSet1),
    set2: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeSet2),
    set3: d3Scale.scaleOrdinal(d3ScaleChromatic.schemeSet3)
};

var nivoCategoricalColors = function nivoCategoricalColors() {
    return d3Scale.scaleOrdinal(['#e8c1a0', '#f47560', '#f1e15b', '#e8a838', '#61cdbb', '#97e3d5']);
};

var dataColor = function dataColor(d) {
    return d.color || d.data.color;
};

var getColorRange = function getColorRange(instruction) {
    if (instruction === 'data') return dataColor;

    if (instruction === 'nivo') return nivoCategoricalColors();

    if (isFunction(instruction)) return instruction;

    if (ordinalColorScales[instruction]) return ordinalColorScales[instruction];

    if (isArray(instruction)) return d3Scale.scaleOrdinal(instruction);

    return function () {
        return instruction;
    };
};

var getColorScale = function getColorScale(colors, dataScale) {
    if (isString(colors)) {
        var scheme = colorSchemes[colors];
        if (scheme !== undefined) {
            var scale = d3Scale.scaleOrdinal(scheme);
            scale.type = 'ordinal';

            return scale;
        }

        if (dataScale !== undefined && colors.indexOf('seq:') === 0) {
            var interpolator = colorInterpolators[colors.slice(4)];
            if (interpolator !== undefined) {
                var _scale = d3Scale.scaleSequential(interpolator).domain(dataScale.domain());
                _scale.type = 'sequential';

                return _scale;
            }
        }
    }

    if (isArray(colors)) {
        var _scale2 = d3Scale.scaleOrdinal(colors);
        _scale2.type = 'ordinal';

        return _scale2;
    }

    // just use provided value,
    // all elements will have identical color
    return function () {
        return colors;
    };
};

var getColorsGenerator = function getColorsGenerator(colors, colorBy) {
    // skip range, color should be bound to data
    if (isFunction(colorBy)) return colorBy;

    var scale = void 0;
    var getColorId = function getColorId(d) {
        return get(d, colorBy);
    };

    if (isString(colors) && colorSchemes[colors] !== undefined) {
        scale = d3Scale.scaleOrdinal(colorSchemes[colors]);
        scale.type = 'ordinal';
    } else if (isArray(colors)) {
        // user defined color range
        scale = d3Scale.scaleOrdinal(colors);
        scale.type = 'ordinal';
    } else {
        // just use provided value,
        // all elements will have identical color
        return function () {
            return colors;
        };
    }

    var colorGenerator = function colorGenerator(d) {
        return scale(getColorId(d));
    };
    colorGenerator.type = scale.type;

    return colorGenerator;
};

/**
 * This HOC watch colors related props change
 * and returns the corresponding color generator function.
 * Using it prevent from having a new ref each time
 * we pass through the component, useful for shallow comparison.
 */
var withColors = function withColors() {
    var _defaultProps, _setPropTypes;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$colorsKey = _ref.colorsKey,
        colorsKey = _ref$colorsKey === undefined ? 'colors' : _ref$colorsKey,
        _ref$colorByKey = _ref.colorByKey,
        colorByKey = _ref$colorByKey === undefined ? 'colorBy' : _ref$colorByKey,
        _ref$destKey = _ref.destKey,
        destKey = _ref$destKey === undefined ? 'getColor' : _ref$destKey,
        _ref$defaultColors = _ref.defaultColors,
        defaultColors = _ref$defaultColors === undefined ? 'nivo' : _ref$defaultColors,
        _ref$defaultColorBy = _ref.defaultColorBy,
        defaultColorBy = _ref$defaultColorBy === undefined ? 'id' : _ref$defaultColorBy;

    return compose(defaultProps((_defaultProps = {}, _defaultProps[colorsKey] = defaultColors, _defaultProps[colorByKey] = defaultColorBy, _defaultProps)), setPropTypes((_setPropTypes = {}, _setPropTypes[colorsKey] = PropTypes.any.isRequired, _setPropTypes[colorByKey] = PropTypes.oneOfType([PropTypes.string, PropTypes.func]), _setPropTypes)), withPropsOnChange([colorsKey, colorByKey], function (props) {
        var _ref2;

        return _ref2 = {}, _ref2[destKey] = getColorsGenerator(props[colorsKey], props[colorByKey]), _ref2;
    }));
};

var quantizeColorScalePropType = PropTypes.oneOfType([PropTypes.oneOf(quantizeColorScalesKeys), PropTypes.func, PropTypes.arrayOf(PropTypes.string)]);

var curvePropMapping = {
    basis: d3Shape.curveBasis,
    basisClosed: d3Shape.curveBasisClosed,
    basisOpen: d3Shape.curveBasisOpen,
    bundle: d3Shape.curveBundle,
    cardinal: d3Shape.curveCardinal,
    cardinalClosed: d3Shape.curveCardinalClosed,
    cardinalOpen: d3Shape.curveCardinalOpen,
    catmullRom: d3Shape.curveCatmullRom,
    catmullRomClosed: d3Shape.curveCatmullRomClosed,
    catmullRomOpen: d3Shape.curveCatmullRomOpen,
    linear: d3Shape.curveLinear,
    linearClosed: d3Shape.curveLinearClosed,
    monotoneX: d3Shape.curveMonotoneX,
    monotoneY: d3Shape.curveMonotoneY,
    natural: d3Shape.curveNatural,
    step: d3Shape.curveStep,
    stepAfter: d3Shape.curveStepAfter,
    stepBefore: d3Shape.curveStepBefore
};

var curvePropKeys = Object.keys(curvePropMapping);

var curvePropType = PropTypes.oneOf(curvePropKeys);

var closedCurvePropKeys = curvePropKeys.filter(function (c) {
    return c.endsWith('Closed');
});

var closedCurvePropType = PropTypes.oneOf(closedCurvePropKeys);

// Safe curves to be used with d3 area shape generator
var areaCurvePropKeys = without(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');

var areaCurvePropType = PropTypes.oneOf(areaCurvePropKeys);

// Safe curves to be used with d3 line shape generator
var lineCurvePropKeys = without(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');

var lineCurvePropType = PropTypes.oneOf(lineCurvePropKeys);

/**
 * Returns curve interpolator from given identifier.
 *
 * @param {string} id - Curve interpolator identifier
 * @return {Function}
 */
var curveFromProp = function curveFromProp(id) {
    var curveInterpolator = curvePropMapping[id];
    if (!curveInterpolator) {
        throw new TypeError('\'' + id + '\', is not a valid curve interpolator identifier.');
    }

    return curvePropMapping[id];
};

var defsPropTypes = {
    defs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired
    })).isRequired,
    fill: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        match: PropTypes.oneOfType([PropTypes.oneOf(['*']), PropTypes.object, PropTypes.func]).isRequired
    })).isRequired
};

var stackOrderPropMapping = {
    ascending: d3Shape.stackOrderAscending,
    descending: d3Shape.stackOrderDescending,
    insideOut: d3Shape.stackOrderInsideOut,
    none: d3Shape.stackOrderNone,
    reverse: d3Shape.stackOrderReverse
};

var stackOrderPropKeys = Object.keys(stackOrderPropMapping);

var stackOrderPropType = PropTypes.oneOf(stackOrderPropKeys);

var stackOrderFromProp = function stackOrderFromProp(prop) {
    return stackOrderPropMapping[prop];
};

var stackOffsetPropMapping = {
    expand: d3Shape.stackOffsetExpand,
    diverging: d3Shape.stackOffsetDiverging,
    none: d3Shape.stackOffsetNone,
    silhouette: d3Shape.stackOffsetSilhouette,
    wiggle: d3Shape.stackOffsetWiggle
};

var stackOffsetPropKeys = Object.keys(stackOffsetPropMapping);

var stackOffsetPropType = PropTypes.oneOf(stackOffsetPropKeys);

var stackOffsetFromProp = function stackOffsetFromProp(prop) {
    return stackOffsetPropMapping[prop];
};

var treeMapTilePropMapping = {
    binary: d3Hierarchy.treemapBinary,
    dice: d3Hierarchy.treemapDice,
    slice: d3Hierarchy.treemapSlice,
    sliceDice: d3Hierarchy.treemapSliceDice,
    squarify: d3Hierarchy.treemapSquarify,
    resquarify: d3Hierarchy.treemapResquarify
};

var treeMapTilePropKeys = Object.keys(treeMapTilePropMapping);

var treeMapTilePropType = PropTypes.oneOf(treeMapTilePropKeys);

var treeMapTileFromProp = function treeMapTileFromProp(prop) {
    return treeMapTilePropMapping[prop];
};

var scalePropType = PropTypes.shape({
    type: PropTypes.string.isRequired,
    domain: PropTypes.array.isRequired,
    range: PropTypes.array.isRequired
});

var marginPropType = PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number
}).isRequired;

var motionPropTypes = {
    animate: PropTypes.bool.isRequired,
    motionStiffness: PropTypes.number.isRequired,
    motionDamping: PropTypes.number.isRequired
};

var blendModePropType = PropTypes.oneOf(['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity']);

/**
 * This HOC transform d3 curve interpolation identifier
 * to its corresponding interpolator.
 */
var withCurve = function withCurve() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$srcKey = _ref.srcKey,
        srcKey = _ref$srcKey === undefined ? 'curve' : _ref$srcKey,
        _ref$destKey = _ref.destKey,
        destKey = _ref$destKey === undefined ? 'curveInterpolator' : _ref$destKey;

    return withProps(function (props) {
        var _ref2;

        return _ref2 = {}, _ref2[destKey] = curveFromProp(props[srcKey]), _ref2;
    });
};

// motion
var defaultAnimate = true;
var defaultMotionStiffness = 90;
var defaultMotionDamping = 13;

// colors
var defaultCategoricalColors = nivoCategoricalColors;
var defaultColorRange = d3Scale.scaleOrdinal(d3ScaleChromatic.schemeSet3);

// margin
var defaultMargin = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};

/**
 * This HOC watch width, height & margin props change
 * and returns new width/height plus outer dimensions.
 * Using it prevent from having a new ref each time
 * we pass through the component, useful for shallow comparison.
 * It also add required propTypes & set default margin.
 */
var withDimensions = function withDimensions() {
    return compose(defaultProps({
        margin: defaultMargin
    }), setPropTypes({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        margin: marginPropType
    }), withPropsOnChange(function (props, nextProps) {
        return props.width !== nextProps.width || props.height !== nextProps.height || !isEqual(props.margin, nextProps.margin);
    }, function (props) {
        var margin = Object.assign({}, defaultMargin, props.margin);

        return {
            margin: margin,
            width: props.width - margin.left - margin.right,
            height: props.height - margin.top - margin.bottom,
            outerWidth: props.width,
            outerHeight: props.height
        };
    }));
};

var getLabelGenerator = function getLabelGenerator(_label, labelFormat) {
    var getRawLabel = isFunction(_label) ? _label : function (d) {
        return get(d, _label);
    };
    var formatter = void 0;
    if (labelFormat) {
        formatter = isFunction(labelFormat) ? labelFormat : d3Format.format(labelFormat);
    }

    if (formatter) return function (d) {
        return formatter(getRawLabel(d));
    };
    return getRawLabel;
};

var getAccessorFor = function getAccessorFor(directive) {
    return isFunction(directive) ? directive : function (d) {
        return d[directive];
    };
};

var getAccessorOrValue = function getAccessorOrValue(value) {
    return isFunction(value) ? value : function () {
        return value;
    };
};

/**
 * This HOC watch hierarchical data props change
 * and returns the corresponding summed hierarchy.
 * Using it prevent from having a new ref each time
 * we pass through the component, useful for shallow comparison.
 */
var withHierarchy = function withHierarchy() {
    var _defaultProps, _setPropTypes;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$srcKey = _ref.srcKey,
        srcKey = _ref$srcKey === undefined ? 'root' : _ref$srcKey,
        _ref$destKey = _ref.destKey,
        destKey = _ref$destKey === undefined ? 'root' : _ref$destKey,
        _ref$valueKey = _ref.valueKey,
        valueKey = _ref$valueKey === undefined ? 'value' : _ref$valueKey,
        _ref$valueDefault = _ref.valueDefault,
        valueDefault = _ref$valueDefault === undefined ? 'value' : _ref$valueDefault;

    return compose(defaultProps((_defaultProps = {}, _defaultProps[valueKey] = valueDefault, _defaultProps)), setPropTypes((_setPropTypes = {}, _setPropTypes[srcKey] = PropTypes.object.isRequired, _setPropTypes[valueKey] = PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired, _setPropTypes)), withPropsOnChange([srcKey, valueKey], function (props) {
        var _ref2;

        return _ref2 = {}, _ref2[destKey] = d3Hierarchy.hierarchy(props[srcKey]).sum(getAccessorFor(props[valueKey])), _ref2;
    }));
};

var withMotion = function withMotion() {
    return compose(setPropTypes(motionPropTypes), defaultProps({
        animate: defaultAnimate,
        motionDamping: defaultMotionDamping,
        motionStiffness: defaultMotionStiffness
    }), withPropsOnChange(['motionDamping', 'motionStiffness'], function (_ref) {
        var motionDamping = _ref.motionDamping,
            motionStiffness = _ref.motionStiffness;
        return {
            boundSpring: partialRight(reactMotion.spring, {
                damping: motionDamping,
                stiffness: motionStiffness
            })
        };
    }));
};

/**
 * This HOC watch theme prop change
 * and returns it deeply merged with default theme.
 * Using it prevent from having a new ref each time
 * we pass through the component, useful for shallow comparison.
 */
var withTheme = function withTheme() {
    var _setPropTypes;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$srcKey = _ref.srcKey,
        srcKey = _ref$srcKey === undefined ? 'theme' : _ref$srcKey,
        _ref$destKey = _ref.destKey,
        destKey = _ref$destKey === undefined ? 'theme' : _ref$destKey;

    return compose(setPropTypes((_setPropTypes = {}, _setPropTypes[srcKey] = PropTypes.object, _setPropTypes)), withPropsOnChange([srcKey], function (props) {
        var _ref2;

        return _ref2 = {}, _ref2[destKey] = merge({}, defaultTheme, props[srcKey]), _ref2;
    }));
};

var horizontalPositions = ['top', 'bottom'];
var verticalPositions = ['left', 'right'];

/**
 * @param {Object} scale
 *
 * @return {Object} centered scale
 */
var centerScale = function centerScale(scale) {
    var bandwidth = scale.bandwidth();

    if (bandwidth === 0) return scale;

    var offset = bandwidth / 2;
    if (scale.round()) {
        offset = Math.round(offset);
    }

    return function (d) {
        return scale(d) + offset;
    };
};

/**
 * @param {Object} scale
 * @param {number} [tickCount]
 *
 * @return {Array.<number|string>}
 */
var getScaleValues = function getScaleValues(scale, tickCount) {
    if (scale.ticks) return scale.ticks(tickCount);
    return scale.domain();
};

/**
 * @typedef {Object} AxisTick
 * @param {number} x
 * @param {number} y
 * @param {number} lineX
 * @param {number} lineY
 * @param {number} textX
 * @param {number} textY
 */

/**
 * @param {number}                       width
 * @param {number}                       height
 * @param {string}                       _position
 * @param {Object}                       scale
 * @param {number|Array.<string|number>} [_tickValues]
 * @param {number}                       [tickSize=5]
 * @param {number}                       [tickPadding=5]
 * @param {number}                       [tickRotation=0]
 * @parem {string}                       [engine='svg']
 *
 * @return {{ x: number, y: number, ticks: Array.<AxisTick>, textAlign: string, textBaseline: string }}
 */
var computeAxisTicks = function computeAxisTicks(_ref) {
    var width = _ref.width,
        height = _ref.height,
        _position = _ref.position,
        scale = _ref.scale,
        _tickValues = _ref.tickValues,
        _ref$tickSize = _ref.tickSize,
        tickSize = _ref$tickSize === undefined ? 5 : _ref$tickSize,
        _ref$tickPadding = _ref.tickPadding,
        tickPadding = _ref$tickPadding === undefined ? 5 : _ref$tickPadding,
        _ref$tickRotation = _ref.tickRotation,
        tickRotation = _ref$tickRotation === undefined ? 0 : _ref$tickRotation,
        _ref$engine = _ref.engine,
        engine = _ref$engine === undefined ? 'svg' : _ref$engine;

    var tickValues = isArray(_tickValues) ? _tickValues : undefined;
    var tickCount = isNumber(_tickValues) ? _tickValues : undefined;

    var values = tickValues || getScaleValues(scale, tickCount);

    var textProps = textPropsByEngine[engine];

    var orient = _position;
    var position = scale.bandwidth ? centerScale(scale) : scale;
    var line = { lineX: 0, lineY: 0 };
    var text = { textX: 0, textY: 0 };

    var x = 0;
    var y = 0;
    var translate = void 0;
    var textAlign = textProps.align.center;
    var textBaseline = textProps.baseline.center;

    if (horizontalPositions.includes(orient)) {
        translate = function translate(d) {
            return { x: position(d), y: 0 };
        };

        line.lineY = tickSize * (orient === 'bottom' ? 1 : -1);
        text.textY = (tickSize + tickPadding) * (orient === 'bottom' ? 1 : -1);

        if (orient === 'bottom') {
            y = height;
            textBaseline = textProps.baseline.top;
        } else {
            textBaseline = textProps.baseline.bottom;
        }

        if (tickRotation === 0) {
            textAlign = textProps.align.center;
        } else if (orient === 'bottom' && tickRotation < 0 || orient === 'top' && tickRotation > 0) {
            textAlign = textProps.align.right;
            textBaseline = textProps.baseline.center;
        } else if (orient === 'bottom' && tickRotation > 0 || orient === 'top' && tickRotation < 0) {
            textAlign = textProps.align.left;
            textBaseline = textProps.baseline.center;
        }
    } else if (verticalPositions.includes(orient)) {
        translate = function translate(d) {
            return { x: 0, y: position(d) };
        };

        line.lineX = tickSize * (orient === 'right' ? 1 : -1);
        text.textX = (tickSize + tickPadding) * (orient === 'right' ? 1 : -1);

        if (orient === 'right') {
            x = width;
            textAlign = textProps.align.left;
        } else {
            textAlign = textProps.align.right;
        }
    }

    var ticks = values.map(function (value) {
        return _extends({
            key: value,
            value: value
        }, translate(value), line, text);
    });

    return {
        x: x,
        y: y,
        ticks: ticks,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
};

/**
 * @param {number} width
 * @param {number} height
 * @param {Object} scale
 * @param {string} axis
 *
 * @return {Array.<Object>}
 */
var computeGridLines = function computeGridLines(_ref2) {
    var width = _ref2.width,
        height = _ref2.height,
        scale = _ref2.scale,
        axis = _ref2.axis,
        _ref2$values = _ref2.values,
        values = _ref2$values === undefined ? getScaleValues(scale) : _ref2$values;

    var position = scale.bandwidth ? centerScale(scale) : scale;

    var lines = void 0;
    if (axis === 'x') {
        lines = values.map(function (v) {
            return {
                key: '' + v,
                x1: position(v),
                x2: position(v),
                y1: 0,
                y2: height
            };
        });
    } else if (axis === 'y') {
        lines = values.map(function (v) {
            return {
                key: '' + v,
                x1: 0,
                x2: width,
                y1: position(v),
                y2: position(v)
            };
        });
    }

    return lines;
};

var AxisTick = function (_Component) {
    inherits(AxisTick, _Component);

    function AxisTick() {
        classCallCheck(this, AxisTick);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    AxisTick.prototype.render = function render() {
        var _props = this.props,
            _value = _props.value,
            x = _props.x,
            y = _props.y,
            opacity = _props.opacity,
            rotate = _props.rotate,
            format = _props.format,
            lineX = _props.lineX,
            lineY = _props.lineY,
            _onClick = _props.onClick,
            textX = _props.textX,
            textY = _props.textY,
            textBaseline = _props.textBaseline,
            textAnchor = _props.textAnchor,
            theme = _props.theme;

        var value = _value;
        if (format !== undefined) {
            value = format(value);
        }

        var gStyle = { opacity: opacity };
        if (_onClick) {
            gStyle['cursor'] = 'pointer';
        }

        return React__default.createElement('g', _extends({
            transform: 'translate(' + x + ',' + y + ')'
        }, _onClick ? { onClick: function onClick(e) {
                return _onClick(e, value);
            } } : {}, {
            style: gStyle
        }), React__default.createElement('line', { x1: 0, x2: lineX, y1: 0, y2: lineY, style: theme.axis.ticks.line }), React__default.createElement('text', {
            alignmentBaseline: textBaseline,
            textAnchor: textAnchor,
            transform: 'translate(' + textX + ',' + textY + ') rotate(' + rotate + ')',
            style: theme.axis.ticks.text
        }, value));
    };

    return AxisTick;
}(React.Component);

AxisTick.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    format: PropTypes.func,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    lineX: PropTypes.number.isRequired,
    lineY: PropTypes.number.isRequired,
    textX: PropTypes.number.isRequired,
    textY: PropTypes.number.isRequired,
    textBaseline: PropTypes.string.isRequired,
    textAnchor: PropTypes.string.isRequired,
    opacity: PropTypes.number.isRequired,
    rotate: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    theme: PropTypes.shape({
        axis: axisThemePropType.isRequired
    }).isRequired
};
AxisTick.defaultProps = {
    opacity: 1,
    rotate: 0
};

var axisPositions = ['top', 'right', 'bottom', 'left'];
var legendPositions = ['start', 'center', 'end'];

var axisPropType = PropTypes.shape({
    orient: PropTypes.oneOf(axisPositions),

    tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    tickSize: PropTypes.number,
    tickPadding: PropTypes.number,
    tickRotation: PropTypes.number,
    format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

    legend: PropTypes.node,
    legendPosition: PropTypes.oneOf(legendPositions),
    legendOffset: PropTypes.number
});

var willEnter = function willEnter() {
    return {
        opacity: 0,
        x: 0,
        y: 0
    };
};

var willLeave = function willLeave(springConfig) {
    return function (_ref) {
        var _ref$style = _ref.style,
            x = _ref$style.x,
            y = _ref$style.y;
        return {
            opacity: reactMotion.spring(0, springConfig),
            x: reactMotion.spring(x.val, springConfig),
            y: reactMotion.spring(y.val, springConfig)
        };
    };
};

var Axis = function Axis(_ref2) {
    var scale = _ref2.scale,
        width = _ref2.width,
        height = _ref2.height,
        _position = _ref2.position,
        tickValues = _ref2.tickValues,
        tickSize = _ref2.tickSize,
        tickPadding = _ref2.tickPadding,
        tickRotation = _ref2.tickRotation,
        format = _ref2.format,
        _legend = _ref2.legend,
        legendPosition = _ref2.legendPosition,
        legendOffset = _ref2.legendOffset,
        theme = _ref2.theme,
        animate = _ref2.animate,
        motionStiffness = _ref2.motionStiffness,
        motionDamping = _ref2.motionDamping,
        onClick = _ref2.onClick;

    var _computeAxisTicks = computeAxisTicks({
        width: width,
        height: height,
        scale: scale,
        position: _position,
        tickValues: tickValues,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation
    }),
        x = _computeAxisTicks.x,
        y = _computeAxisTicks.y,
        ticks = _computeAxisTicks.ticks,
        textAlign = _computeAxisTicks.textAlign,
        textBaseline = _computeAxisTicks.textBaseline;

    var isHorizontal = ['top', 'bottom'].includes(_position);
    var isVertical = !isHorizontal;

    var legend = null;
    if (_legend !== undefined) {
        var legendX = 0;
        var legendY = 0;
        var legendRotation = 0;
        var textAnchor = void 0;

        if (isVertical) {
            legendRotation = -90;
            legendX = legendOffset;
            if (legendPosition === 'start') {
                textAnchor = 'start';
                legendY = height;
            } else if (legendPosition === 'center') {
                textAnchor = 'middle';
                legendY = height / 2;
            } else if (legendPosition === 'end') {
                textAnchor = 'end';
            }
        } else {
            legendY = legendOffset;
            if (legendPosition === 'start') {
                textAnchor = 'start';
            } else if (legendPosition === 'center') {
                textAnchor = 'middle';
                legendX = width / 2;
            } else if (legendPosition === 'end') {
                textAnchor = 'end';
                legendX = width;
            }
        }

        legend = React__default.createElement('text', {
            transform: 'translate(' + legendX + ', ' + legendY + ') rotate(' + legendRotation + ')',
            textAnchor: textAnchor,
            style: theme.axis.legend.text
        }, _legend);
    }

    var tickElements = void 0;
    if (!animate) {
        tickElements = React__default.createElement('g', null, ticks.map(function (tick) {
            return React__default.createElement(AxisTick, _extends({
                key: tick.key,
                value: tick.key,
                format: format,
                lineX: tick.lineX,
                lineY: tick.lineY,
                rotate: tickRotation,
                textX: tick.textX,
                textY: tick.textY,
                textBaseline: textBaseline,
                textAnchor: textAlign,
                theme: theme,
                x: tick.x,
                y: tick.y
            }, onClick ? { onClick: onClick } : {}));
        }));
    } else {
        var springConfig = {
            stiffness: motionStiffness,
            damping: motionDamping
        };

        tickElements = React__default.createElement(reactMotion.TransitionMotion, {
            willEnter: willEnter,
            willLeave: willLeave(springConfig),
            styles: ticks.map(function (tick) {
                return {
                    key: '' + tick.key,
                    data: tick,
                    style: {
                        opacity: reactMotion.spring(1, springConfig),
                        x: reactMotion.spring(tick.x, springConfig),
                        y: reactMotion.spring(tick.y, springConfig)
                    }
                };
            })
        }, function (interpolatedStyles) {
            return React__default.createElement('g', null, interpolatedStyles.map(function (_ref3) {
                var key = _ref3.key,
                    style = _ref3.style,
                    tick = _ref3.data;
                return React__default.createElement(AxisTick, _extends({
                    key: key,
                    value: key,
                    format: format,
                    lineX: tick.lineX,
                    lineY: tick.lineY,
                    rotate: tickRotation,
                    textX: tick.textX,
                    textY: tick.textY,
                    textBaseline: textBaseline,
                    textAnchor: textAlign,
                    theme: theme
                }, onClick ? { onClick: onClick } : {}, style));
            }));
        });
    }

    return React__default.createElement('g', { transform: 'translate(' + x + ',' + y + ')' }, legend, tickElements, React__default.createElement('line', {
        style: theme.axis.domain.line,
        x1: 0,
        x2: isHorizontal ? width : 0,
        y1: 0,
        y2: isHorizontal ? 0 : height
    }));
};

Axis.propTypes = _extends({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    position: PropTypes.oneOf(axisPositions).isRequired,
    scale: PropTypes.func.isRequired,

    tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]))]),
    tickSize: PropTypes.number.isRequired,
    tickPadding: PropTypes.number.isRequired,
    tickRotation: PropTypes.number.isRequired,
    format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

    legend: PropTypes.node,
    legendPosition: PropTypes.oneOf(legendPositions).isRequired,
    legendOffset: PropTypes.number.isRequired,

    theme: PropTypes.shape({
        axis: axisThemePropType.isRequired
    }).isRequired,

    onClick: PropTypes.func

}, motionPropTypes);

Axis.defaultProps = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,

    legendPosition: 'end',
    legendOffset: 0
};

var enhance$1 = compose(withMotion(), withPropsOnChange(['format', 'scale'], function (_ref4) {
    var format = _ref4.format,
        scale = _ref4.scale;

    if (!format || isFunction(format)) {
        return { format: format };
    } else if (scale.type === 'time') {
        var f = d3TimeFormat.timeFormat(format);
        return { format: function format(d) {
                return f(new Date(d));
            } };
    } else {
        return { format: d3Format.format(format) };
    }
}), pure);

var Axis$1 = enhance$1(Axis);

var horizontalPositions$1 = ['top', 'bottom'];
var verticalPositions$1 = ['left', 'right'];
var positions = [].concat(horizontalPositions$1, verticalPositions$1);

var Axes = function Axes(_ref) {
    var xScale = _ref.xScale,
        yScale = _ref.yScale,
        width = _ref.width,
        height = _ref.height,
        top = _ref.top,
        right = _ref.right,
        bottom = _ref.bottom,
        left = _ref.left,
        theme = _ref.theme,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;

    var axes = { top: top, right: right, bottom: bottom, left: left };

    return React__default.createElement('g', null, positions.map(function (position) {
        var axis = axes[position];

        if (!axis) return null;

        var scale = horizontalPositions$1.includes(position) ? xScale : yScale;

        return React__default.createElement(Axis$1, _extends({
            theme: theme
        }, axis, {
            key: position,
            width: width,
            height: height,
            position: position,
            scale: scale,
            animate: animate,
            motionDamping: motionDamping,
            motionStiffness: motionStiffness
        }));
    }));
};

Axes.propTypes = _extends({
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    top: axisPropType,
    right: axisPropType,
    bottom: axisPropType,
    left: axisPropType,

    theme: PropTypes.shape({
        axis: axisThemePropType.isRequired
    }).isRequired

}, motionPropTypes);

var Axes$1 = shouldUpdate(function (props, nextProps) {
    return props.xScale !== nextProps.xScale || props.yScale !== nextProps.yScale || props.width !== nextProps.width || props.height !== nextProps.height || props.theme !== nextProps.theme || props.animate !== nextProps.animate || props.motionDamping !== nextProps.motionDamping || props.motionStiffness !== nextProps.motionStiffness || !isEqual(props.top, nextProps.top) || !isEqual(props.right, nextProps.right) || !isEqual(props.bottom, nextProps.bottom) || !isEqual(props.left, nextProps.left);
})(Axes);

var GridLine = function GridLine(props) {
    return React__default.createElement('line', props);
};

GridLine.propTypes = {
    x1: PropTypes.number.isRequired,
    x2: PropTypes.number.isRequired,
    y1: PropTypes.number.isRequired,
    y2: PropTypes.number.isRequired
};

GridLine.defaultProps = {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
};

var GridLines = function (_Component) {
    inherits(GridLines, _Component);

    function GridLines(props) {
        classCallCheck(this, GridLines);

        var _this = possibleConstructorReturn(this, _Component.call(this, props));

        _this.willEnter = _this.willEnter.bind(_this);
        _this.willLeave = _this.willLeave.bind(_this);
        return _this;
    }

    GridLines.prototype.willEnter = function willEnter(_ref) {
        var style = _ref.style;
        var type = this.props.type;

        return {
            opacity: 0,
            x1: type === 'x' ? 0 : style.x1.val,
            x2: type === 'x' ? 0 : style.x2.val,
            y1: type === 'y' ? 0 : style.y1.val,
            y2: type === 'y' ? 0 : style.y2.val
        };
    };

    GridLines.prototype.willLeave = function willLeave(_ref2) {
        var style = _ref2.style;
        var _props = this.props,
            motionStiffness = _props.motionStiffness,
            motionDamping = _props.motionDamping;

        var springConfig = {
            stiffness: motionStiffness,
            damping: motionDamping
        };

        return {
            opacity: reactMotion.spring(0, springConfig),
            x1: reactMotion.spring(style.x1.val, springConfig),
            x2: reactMotion.spring(style.x2.val, springConfig),
            y1: reactMotion.spring(style.y1.val, springConfig),
            y2: reactMotion.spring(style.y2.val, springConfig)
        };
    };

    GridLines.prototype.render = function render() {
        var _props2 = this.props,
            lines = _props2.lines,
            animate = _props2.animate,
            motionStiffness = _props2.motionStiffness,
            motionDamping = _props2.motionDamping,
            theme = _props2.theme;

        if (!animate) {
            return React__default.createElement('g', null, lines.map(function (line) {
                return React__default.createElement(GridLine, _extends({ key: line.key }, line, theme.grid.line));
            }));
        }

        var springConfig = {
            stiffness: motionStiffness,
            damping: motionDamping
        };

        return React__default.createElement(reactMotion.TransitionMotion, {
            willEnter: this.willEnter,
            willLeave: this.willLeave,
            styles: lines.map(function (line) {
                return {
                    key: line.key,
                    style: {
                        opacity: reactMotion.spring(1, springConfig),
                        x1: reactMotion.spring(line.x1 || 0, springConfig),
                        x2: reactMotion.spring(line.x2 || 0, springConfig),
                        y1: reactMotion.spring(line.y1 || 0, springConfig),
                        y2: reactMotion.spring(line.y2 || 0, springConfig)
                    }
                };
            })
        }, function (interpolatedStyles) {
            return React__default.createElement('g', null, interpolatedStyles.map(function (interpolatedStyle) {
                var key = interpolatedStyle.key,
                    style = interpolatedStyle.style;

                return React__default.createElement(GridLine, _extends({ key: key }, theme.grid.line, style));
            }));
        });
    };

    return GridLines;
}(React.Component);

GridLines.propTypes = {
    type: PropTypes.oneOf(['x', 'y']).isRequired,
    lines: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        x1: PropTypes.number,
        x2: PropTypes.number,
        y1: PropTypes.number,
        y2: PropTypes.number
    })).isRequired,
    theme: PropTypes.object.isRequired,

    animate: PropTypes.bool.isRequired,
    motionStiffness: PropTypes.number.isRequired,
    motionDamping: PropTypes.number.isRequired
};

var Grid = function Grid(_ref) {
    var width = _ref.width,
        height = _ref.height,
        xScale = _ref.xScale,
        yScale = _ref.yScale,
        xValues = _ref.xValues,
        yValues = _ref.yValues,
        theme = _ref.theme,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;

    var xLines = xScale ? computeGridLines({
        width: width,
        height: height,
        scale: xScale,
        axis: 'x',
        values: xValues
    }) : false;

    var yLines = yScale ? computeGridLines({
        width: width,
        height: height,
        scale: yScale,
        axis: 'y',
        values: yValues
    }) : false;

    return React__default.createElement('g', null, xLines && React__default.createElement(GridLines, {
        type: 'x',
        lines: xLines,
        theme: theme,
        animate: animate,
        motionStiffness: motionStiffness,
        motionDamping: motionDamping
    }), yLines && React__default.createElement(GridLines, {
        type: 'y',
        lines: yLines,
        theme: theme,
        animate: animate,
        motionStiffness: motionStiffness,
        motionDamping: motionDamping
    }));
};

Grid.propTypes = _extends({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    xScale: PropTypes.func,
    yScale: PropTypes.func,
    xValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    yValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),

    theme: PropTypes.object.isRequired

}, motionPropTypes);

Grid.defaultProps = {
    // motion
    animate: true,
    motionStiffness: defaultMotionStiffness,
    motionDamping: defaultMotionDamping
};

var Grid$1 = pure(Grid);

/**
 *
 * @param {string} axis
 * @param {number} width
 * @param {number} height
 * @param {string} position
 * @param {number} offsetX
 * @param {number} offsetY
 * @param {string} orientation
 * @return {{ x: number, y: number, textAnchor: string }}
 */
var computeLabel = function computeLabel(_ref) {
    var axis = _ref.axis,
        width = _ref.width,
        height = _ref.height,
        position = _ref.position,
        offsetX = _ref.offsetX,
        offsetY = _ref.offsetY,
        orientation = _ref.orientation;

    var x = 0;
    var y = 0;
    var rotation = orientation === 'vertical' ? -90 : 0;
    var textAnchor = 'start';

    if (axis === 'x') {
        switch (position) {
            case 'top-left':
                x = -offsetX;
                y = offsetY;
                textAnchor = 'end';
                break;
            case 'top':
                y = -offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'middle';
                } else {
                    textAnchor = 'start';
                }
                break;
            case 'top-right':
                x = offsetX;
                y = offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'start';
                } else {
                    textAnchor = 'end';
                }
                break;
            case 'right':
                x = offsetX;
                y = height / 2;
                if (orientation === 'horizontal') {
                    textAnchor = 'start';
                } else {
                    textAnchor = 'middle';
                }
                break;
            case 'bottom-right':
                x = offsetX;
                y = height - offsetY;
                textAnchor = 'start';
                break;
            case 'bottom':
                y = height + offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'middle';
                } else {
                    textAnchor = 'end';
                }
                break;
            case 'bottom-left':
                y = height - offsetY;
                x = -offsetX;
                if (orientation === 'horizontal') {
                    textAnchor = 'end';
                } else {
                    textAnchor = 'start';
                }
                break;
            case 'left':
                x = -offsetX;
                y = height / 2;
                if (orientation === 'horizontal') {
                    textAnchor = 'end';
                } else {
                    textAnchor = 'middle';
                }
                break;
        }
    } else {
        switch (position) {
            case 'top-left':
                x = offsetX;
                y = -offsetY;
                textAnchor = 'start';
                break;
            case 'top':
                x = width / 2;
                y = -offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'middle';
                } else {
                    textAnchor = 'start';
                }
                break;
            case 'top-right':
                x = width - offsetX;
                y = -offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'end';
                } else {
                    textAnchor = 'start';
                }
                break;
            case 'right':
                x = width + offsetX;
                if (orientation === 'horizontal') {
                    textAnchor = 'start';
                } else {
                    textAnchor = 'middle';
                }
                break;
            case 'bottom-right':
                x = width - offsetX;
                y = offsetY;
                textAnchor = 'end';
                break;
            case 'bottom':
                x = width / 2;
                y = offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'middle';
                } else {
                    textAnchor = 'end';
                }
                break;
            case 'bottom-left':
                x = offsetX;
                y = offsetY;
                if (orientation === 'horizontal') {
                    textAnchor = 'start';
                } else {
                    textAnchor = 'end';
                }
                break;
            case 'left':
                x = -offsetX;
                if (orientation === 'horizontal') {
                    textAnchor = 'end';
                } else {
                    textAnchor = 'middle';
                }
                break;
        }
    }

    return { x: x, y: y, rotation: rotation, textAnchor: textAnchor };
};

var CartesianMarkersItem = function CartesianMarkersItem(_ref2) {
    var width = _ref2.width,
        height = _ref2.height,
        axis = _ref2.axis,
        scale = _ref2.scale,
        value = _ref2.value,
        theme = _ref2.theme,
        lineStyle = _ref2.lineStyle,
        textStyle = _ref2.textStyle,
        legend = _ref2.legend,
        legendPosition = _ref2.legendPosition,
        legendOffsetX = _ref2.legendOffsetX,
        legendOffsetY = _ref2.legendOffsetY,
        legendOrientation = _ref2.legendOrientation;

    var x = 0;
    var x2 = 0;
    var y = 0;
    var y2 = 0;

    if (axis === 'y') {
        y = scale(value);
        x2 = width;
    } else {
        x = scale(value);
        y2 = height;
    }

    var legendNode = null;
    if (legend) {
        var legendProps = computeLabel({
            axis: axis,
            width: width,
            height: height,
            position: legendPosition,
            offsetX: legendOffsetX,
            offsetY: legendOffsetY,
            orientation: legendOrientation
        });
        legendNode = React__default.createElement('text', {
            transform: 'translate(' + legendProps.x + ', ' + legendProps.y + ') rotate(' + legendProps.rotation + ')',
            textAnchor: legendProps.textAnchor,
            alignmentBaseline: 'central',
            style: textStyle
        }, legend);
    }

    return React__default.createElement('g', { transform: 'translate(' + x + ', ' + y + ')' }, React__default.createElement('line', {
        x1: 0,
        x2: x2,
        y1: 0,
        y2: y2,
        stroke: theme.markers.lineColor,
        strokeWidth: theme.markers.lineStrokeWidth,
        style: lineStyle
    }), legendNode);
};

CartesianMarkersItem.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    axis: PropTypes.oneOf(['x', 'y']).isRequired,
    scale: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    lineStyle: PropTypes.object,
    textStyle: PropTypes.object,

    legend: PropTypes.string,
    legendPosition: PropTypes.oneOf(['top-left', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left']),
    legendOffsetX: PropTypes.number.isRequired,
    legendOffsetY: PropTypes.number.isRequired,
    legendOrientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,

    theme: PropTypes.shape({
        markers: PropTypes.shape({
            textColor: PropTypes.string.isRequired,
            fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
        }).isRequired
    }).isRequired
};

CartesianMarkersItem.defaultProps = {
    legendPosition: 'top-right',
    legendOffsetX: 14,
    legendOffsetY: 14,
    legendOrientation: 'horizontal'
};

var CartesianMarkersItem$1 = pure(CartesianMarkersItem);

var CartesianMarkers = function CartesianMarkers(_ref) {
    var markers = _ref.markers,
        width = _ref.width,
        height = _ref.height,
        xScale = _ref.xScale,
        yScale = _ref.yScale,
        theme = _ref.theme;

    if (!markers || markers.length === 0) return null;

    return React__default.createElement('g', null, markers.map(function (marker, i) {
        return React__default.createElement(CartesianMarkersItem$1, _extends({
            key: i
        }, marker, {
            width: width,
            height: height,
            scale: marker.axis === 'y' ? yScale : xScale,
            theme: theme
        }));
    }));
};

CartesianMarkers.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,

    theme: PropTypes.shape({
        markers: PropTypes.shape({
            lineColor: PropTypes.string.isRequired,
            lineStrokeWidth: PropTypes.number.isRequired,
            textColor: PropTypes.string.isRequired,
            fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
        }).isRequired
    }).isRequired,

    markers: PropTypes.arrayOf(PropTypes.shape({
        axis: PropTypes.oneOf(['x', 'y']).isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        lineStyle: PropTypes.object,
        textStyle: PropTypes.object
    }))
};

var CartesianMarkers$1 = pure(CartesianMarkers);

/**
 * Computes distance between two points.
 *
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @return {number}
 */
var getDistance = function getDistance(x1, y1, x2, y2) {
    var deltaX = x2 - x1;
    var deltaY = y2 - y1;

    deltaX *= deltaX;
    deltaY *= deltaY;

    return Math.sqrt(deltaX + deltaY);
};

/**
 * Computes angle (radians) between two points.
 *
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @return {number}
 */
var getAngle = function getAngle(x1, y1, x2, y2) {
    var angle = Math.atan2(y2 - y1, x2 - x1) - Math.PI / 2;

    return angle > 0 ? angle : Math.PI * 2 + angle;
};

/**
 * Check if cursor is in given rectangle.
 *
 * @param {number} x
 * @param {number} y
 * @param {number} width
 * @param {number} height
 * @param {number} cursorX
 * @param {number} cursorY
 * @return {boolean}
 */
var isCursorInRect = function isCursorInRect(x, y, width, height, cursorX, cursorY) {
    return x <= cursorX && cursorX <= x + width && y <= cursorY && cursorY <= y + height;
};

/**
 * Check if cursor is in given ring.
 *
 * @param {number} centerX
 * @param {number} centerY
 * @param {number} radius
 * @param {number} innerRadius
 * @param {number} cursorX
 * @param {number} cursorY
 * @return {boolean}
 */
var isCursorInRing = function isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY) {
    var distance = getDistance(cursorX, cursorY, centerX, centerY);

    return distance < radius && distance > innerRadius;
};

/**
 * Search for an arc being under cursor.
 *
 * @param {number}         centerX
 * @param {number}         centerY
 * @param {number}         radius
 * @param {number}         innerRadius
 * @param {Array.<Object>} arcs
 * @param {number}         cursorX
 * @param {number}         cursorY
 * @return {*}
 */
var getHoveredArc = function getHoveredArc(centerX, centerY, radius, innerRadius, arcs, cursorX, cursorY) {
    if (!isCursorInRing(centerX, centerY, radius, innerRadius, cursorX, cursorY)) return null;

    var cursorAngle = getAngle(cursorX, cursorY, centerX, centerY);

    return arcs.find(function (_ref) {
        var startAngle = _ref.startAngle,
            endAngle = _ref.endAngle;
        return cursorAngle >= startAngle && cursorAngle < endAngle;
    });
};

var getRelativeCursor = function getRelativeCursor(el, event) {
    var clientX = event.clientX,
        clientY = event.clientY;

    var bounds = el.getBoundingClientRect();

    return [clientX - bounds.left, clientY - bounds.top];
};

var horizontalPositions$2 = ['top', 'bottom'];
var positions$1 = ['top', 'right', 'bottom', 'left'];

var renderAxisToCanvas = function renderAxisToCanvas(ctx, _ref) {
    var width = _ref.width,
        height = _ref.height,
        position = _ref.position,
        scale = _ref.scale,
        _ref$tickSize = _ref.tickSize,
        tickSize = _ref$tickSize === undefined ? 5 : _ref$tickSize,
        _ref$tickPadding = _ref.tickPadding,
        tickPadding = _ref$tickPadding === undefined ? 5 : _ref$tickPadding,
        _ref$tickRotation = _ref.tickRotation,
        tickRotation = _ref$tickRotation === undefined ? 0 : _ref$tickRotation,
        format = _ref.format,
        theme = _ref.theme;

    var _computeAxisTicks = computeAxisTicks({
        width: width,
        height: height,
        position: position,
        scale: scale,
        tickSize: tickSize,
        tickPadding: tickPadding,
        tickRotation: tickRotation,
        engine: 'canvas'
    }),
        x = _computeAxisTicks.x,
        y = _computeAxisTicks.y,
        ticks = _computeAxisTicks.ticks,
        textAlign = _computeAxisTicks.textAlign,
        textBaseline = _computeAxisTicks.textBaseline;

    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = theme.axis.ticks.text.fontSize + 'px sans-serif';

    ticks.forEach(function (tick) {
        ctx.lineWidth = theme.axis.ticks.line.strokeWidth;
        ctx.strokeStyle = theme.axis.ticks.line.stroke;
        ctx.beginPath();
        ctx.moveTo(tick.x, tick.y);
        ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
        ctx.stroke();

        var value = format !== undefined ? format(tick.value) : tick.value;

        ctx.save();
        ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
        ctx.rotate(degreesToRadians(tickRotation));
        ctx.fillStyle = theme.axis.ticks.text.fill;
        ctx.fillText(value, 0, 0);
        ctx.restore();
    });

    ctx.restore();
};

var renderAxesToCanvas = function renderAxesToCanvas(ctx, _ref2) {
    var xScale = _ref2.xScale,
        yScale = _ref2.yScale,
        width = _ref2.width,
        height = _ref2.height,
        top = _ref2.top,
        right = _ref2.right,
        bottom = _ref2.bottom,
        left = _ref2.left,
        theme = _ref2.theme;

    var axes = { top: top, right: right, bottom: bottom, left: left };

    positions$1.map(function (position) {
        if (!axes[position]) return null;

        var axis = axes[position];
        var scale = horizontalPositions$2.includes(position) ? xScale : yScale;

        renderAxisToCanvas(ctx, _extends({}, axis, {
            width: width,
            height: height,
            position: position,
            scale: scale,
            theme: theme
        }));
    });
};

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {number}                   width
 * @param {number}                   height
 * @param {number}                   scale
 * @param {('x'|'y')}                axis
 */
var renderGridLinesToCanvas = function renderGridLinesToCanvas(ctx, _ref3) {
    var width = _ref3.width,
        height = _ref3.height,
        scale = _ref3.scale,
        axis = _ref3.axis;

    var lines = computeGridLines({ width: width, height: height, scale: scale, axis: axis });

    lines.forEach(function (line) {
        ctx.beginPath();
        ctx.moveTo(line.x1, line.y1);
        ctx.lineTo(line.x2, line.y2);
        ctx.stroke();
    });
};

var gradientKeys = Object.keys(gradientTypes);
var patternKeys = Object.keys(patternTypes);

/**
 * Check a node matches given def predicate.
 *
 * @param {string|Function|Object} predicate
 * @param {Object}                 node
 * @param {string}                 [dataKey] - Optional path to access node data
 * @returns {boolean}
 */
var isMatchingDef = function isMatchingDef(predicate, node, dataKey) {
    if (predicate === '*') {
        return true;
    } else if (isFunction(predicate)) {
        return predicate(node);
    } else if (isPlainObject(predicate)) {
        var data = dataKey ? get(node, dataKey) : node;
        return isEqual(pick(data, Object.keys(predicate)), predicate);
    }

    return false;
};

/**
 * Compute SVG defs.
 *
 * @param {Array.<Object>} defs               - Base SVG defs configs
 * @param {Array.<Object>} nodes              - Data nodes to apply defs on
 * @param {Array.<Object>} rules              - Rules used to conditionally apply defs on data nodes
 * @param {string}         [dataKey]          - Path to node data, used for rule object query based predicate
 * @param {string}         [colorKey='color'] - Node color path, required when inheritance is involved
 * @param {string}         [targetKey='fill'] - Node target property to apply def ID on
 * @returns {Array}
 */
var bindDefs = function bindDefs(defs, nodes, rules) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        dataKey = _ref.dataKey,
        _ref$colorKey = _ref.colorKey,
        colorKey = _ref$colorKey === undefined ? 'color' : _ref$colorKey,
        _ref$targetKey = _ref.targetKey,
        targetKey = _ref$targetKey === undefined ? 'fill' : _ref$targetKey;

    var boundDefs = [];

    // will hold generated variation ids,
    // to avoid generating multiple identical defs
    var generatedIds = {};

    if (defs.length && nodes.length) {
        // first, add base defs
        boundDefs = [].concat(defs);

        nodes.forEach(function (node) {
            var _loop = function _loop(i) {
                var _rules$i = rules[i],
                    id = _rules$i.id,
                    match = _rules$i.match;

                if (isMatchingDef(match, node, dataKey)) {
                    var def = defs.find(function (_ref2) {
                        var defId = _ref2.id;
                        return defId === id;
                    });
                    if (def) {
                        if (patternKeys.includes(def.type)) {
                            if (def.background === 'inherit' || def.color === 'inherit') {
                                var nodeColor = get(node, colorKey);
                                var background = def.background;
                                var color = def.color;

                                var inheritedId = id;
                                if (def.background === 'inherit') {
                                    inheritedId = inheritedId + '.bg.' + nodeColor;
                                    background = nodeColor;
                                }
                                if (def.color === 'inherit') {
                                    inheritedId = inheritedId + '.fg.' + nodeColor;
                                    color = nodeColor;
                                }

                                set(node, targetKey, 'url(#' + inheritedId + ')');
                                if (!generatedIds[inheritedId]) {
                                    boundDefs.push(_extends({}, def, {
                                        id: inheritedId,
                                        background: background,
                                        color: color
                                    }));
                                    generatedIds[inheritedId] = 1;
                                }
                            } else {
                                // do not generate new def as there's no inheritance involved
                                set(node, targetKey, 'url(#' + id + ')');
                            }
                        } else if (gradientKeys.includes(def.type)) {
                            var allColors = def.colors.map(function (_ref3) {
                                var color = _ref3.color;
                                return color;
                            });

                            if (allColors.includes('inherit')) {
                                var _nodeColor = get(node, colorKey);

                                var _inheritedId = id;
                                var inheritedDef = _extends({}, def, {
                                    colors: def.colors.map(function (colorStop, i) {
                                        if (colorStop.color !== 'inherit') return colorStop;

                                        _inheritedId = _inheritedId + '.' + i + '.' + _nodeColor;

                                        return _extends({}, colorStop, {
                                            color: colorStop.color === 'inherit' ? _nodeColor : colorStop.color
                                        });
                                    })
                                });
                                inheritedDef.id = _inheritedId;

                                set(node, targetKey, 'url(#' + _inheritedId + ')');
                                if (!generatedIds[_inheritedId]) {
                                    boundDefs.push(inheritedDef);
                                    generatedIds[_inheritedId] = 1;
                                }
                            } else {
                                // do not generate new def as there's no inheritance involved
                                set(node, targetKey, 'url(#' + id + ')');
                            }
                        }
                    }

                    // break loop on first match
                    return 'break';
                }
            };

            for (var i = 0; i < rules.length; i++) {
                var _ret = _loop(i);

                if (_ret === 'break') break;
            }
        });
    }

    return boundDefs;
};

exports.Container = Container;
exports.ResponsiveWrapper = ResponsiveWrapper;
exports.SvgWrapper = SvgWrapper;
exports.SmartMotion = SmartMotion;
exports.noop = noop;
exports.DotsItem = DotsItem$1;
exports.DotsItemDefaultProps = DotsItemDefaultProps;
exports.gradientTypes = gradientTypes;
exports.LinearGradient = LinearGradient;
exports.linearGradientDef = linearGradientDef;
exports.patternTypes = patternTypes;
exports.PatternDots = PatternDots;
exports.patternDotsDef = patternDotsDef;
exports.PatternLines = PatternLines;
exports.patternLinesDef = patternLinesDef;
exports.PatternSquares = PatternSquares;
exports.patternSquaresDef = patternSquaresDef;
exports.defsMapping = defsMapping;
exports.Defs = Defs;
exports.BasicTooltip = BasicTooltip$1;
exports.Chip = Chip$1;
exports.TableTooltip = TableTooltip$1;
exports.Axis = Axis$1;
exports.Axes = Axes$1;
exports.Grid = Grid$1;
exports.CartesianMarkers = CartesianMarkers$1;
exports.CartesianMarkersItem = CartesianMarkersItem$1;
exports.withColors = withColors;
exports.withCurve = withCurve;
exports.withDimensions = withDimensions;
exports.withHierarchy = withHierarchy;
exports.withMotion = withMotion;
exports.withTheme = withTheme;
exports.getLabelGenerator = getLabelGenerator;
exports.getAccessorFor = getAccessorFor;
exports.getAccessorOrValue = getAccessorOrValue;
exports.scalePropType = scalePropType;
exports.marginPropType = marginPropType;
exports.motionPropTypes = motionPropTypes;
exports.blendModePropType = blendModePropType;
exports.quantizeColorScalePropType = quantizeColorScalePropType;
exports.curvePropMapping = curvePropMapping;
exports.curvePropKeys = curvePropKeys;
exports.curvePropType = curvePropType;
exports.closedCurvePropKeys = closedCurvePropKeys;
exports.closedCurvePropType = closedCurvePropType;
exports.areaCurvePropKeys = areaCurvePropKeys;
exports.areaCurvePropType = areaCurvePropType;
exports.lineCurvePropKeys = lineCurvePropKeys;
exports.lineCurvePropType = lineCurvePropType;
exports.curveFromProp = curveFromProp;
exports.defsPropTypes = defsPropTypes;
exports.stackOrderPropMapping = stackOrderPropMapping;
exports.stackOrderPropKeys = stackOrderPropKeys;
exports.stackOrderPropType = stackOrderPropType;
exports.stackOrderFromProp = stackOrderFromProp;
exports.stackOffsetPropMapping = stackOffsetPropMapping;
exports.stackOffsetPropKeys = stackOffsetPropKeys;
exports.stackOffsetPropType = stackOffsetPropType;
exports.stackOffsetFromProp = stackOffsetFromProp;
exports.treeMapTilePropMapping = treeMapTilePropMapping;
exports.treeMapTilePropKeys = treeMapTilePropKeys;
exports.treeMapTilePropType = treeMapTilePropType;
exports.treeMapTileFromProp = treeMapTileFromProp;
exports.colorSchemes = colorSchemes;
exports.colorSchemeIds = colorSchemeIds;
exports.colorInterpolators = colorInterpolators;
exports.colorInterpolatorIds = colorInterpolatorIds;
exports.nivoCategoricalColors = nivoCategoricalColors;
exports.getColorRange = getColorRange;
exports.getColorScale = getColorScale;
exports.getColorsGenerator = getColorsGenerator;
exports.getInheritedColorGenerator = getInheritedColorGenerator;
exports.colorMotionSpring = colorMotionSpring;
exports.getInterpolatedColor = getInterpolatedColor;
exports.quantizeColorScales = quantizeColorScales;
exports.quantizeColorScalesKeys = quantizeColorScalesKeys;
exports.guessQuantizeColorScale = guessQuantizeColorScale;
exports.TWO_PI = TWO_PI;
exports.degreesToRadians = degreesToRadians;
exports.radiansToDegrees = radiansToDegrees;
exports.midAngle = midAngle;
exports.positionFromAngle = positionFromAngle;
exports.absoluteAngleDegrees = absoluteAngleDegrees;
exports.absoluteAngleRadians = absoluteAngleRadians;
exports.computeArcBoundingBox = computeArcBoundingBox;
exports.getPolarLabelProps = getPolarLabelProps;
exports.getRelativeCursor = getRelativeCursor;
exports.getDistance = getDistance;
exports.getAngle = getAngle;
exports.isCursorInRect = isCursorInRect;
exports.isCursorInRing = isCursorInRing;
exports.getHoveredArc = getHoveredArc;
exports.renderAxisToCanvas = renderAxisToCanvas;
exports.renderAxesToCanvas = renderAxesToCanvas;
exports.renderGridLinesToCanvas = renderGridLinesToCanvas;
exports.isMatchingDef = isMatchingDef;
exports.bindDefs = bindDefs;
exports.textPropsByEngine = textPropsByEngine;
exports.axisThemePropType = axisThemePropType;
exports.gridThemePropType = gridThemePropType;
exports.legendsThemePropType = legendsThemePropType;
exports.labelsThemePropType = labelsThemePropType;
exports.dotsThemePropType = dotsThemePropType;
exports.themePropType = themePropType;
exports.defaultTheme = defaultTheme;
exports.defaultAnimate = defaultAnimate;
exports.defaultMotionStiffness = defaultMotionStiffness;
exports.defaultMotionDamping = defaultMotionDamping;
exports.defaultCategoricalColors = defaultCategoricalColors;
exports.defaultColorRange = defaultColorRange;
exports.defaultMargin = defaultMargin;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
    return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var PropTypes = _interopDefault(__webpack_require__(1));
var isNumber = _interopDefault(__webpack_require__(665));
var isPlainObject = _interopDefault(__webpack_require__(453));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var isFunction = _interopDefault(__webpack_require__(197));

var DIRECTION_ROW = 'row';
var DIRECTION_COLUMN = 'column';

var ANCHOR_TOP = 'top';
var ANCHOR_TOP_RIGHT = 'top-right';
var ANCHOR_RIGHT = 'right';
var ANCHOR_BOTTOM_RIGHT = 'bottom-right';
var ANCHOR_BOTTOM = 'bottom';
var ANCHOR_BOTTOM_LEFT = 'bottom-left';
var ANCHOR_LEFT = 'left';
var ANCHOR_TOP_LEFT = 'top-left';
var ANCHOR_CENTER = 'center';

var DIRECTION_LEFT_TO_RIGHT = 'left-to-right';
var DIRECTION_RIGHT_TO_LEFT = 'right-to-left';
var DIRECTION_TOP_TO_BOTTOM = 'top-to-bottom';
var DIRECTION_BOTTOM_TO_TOP = 'bottom-to-top';

var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
};

/**
 * This can be used to add effect on legends on interaction.
 */
var legendEffectPropType = PropTypes.shape({
    on: PropTypes.oneOfType([PropTypes.oneOf(['hover'])]).isRequired,
    style: PropTypes.shape({
        itemTextColor: PropTypes.string,
        itemBackground: PropTypes.string,
        itemOpacity: PropTypes.number,
        symbolSize: PropTypes.number,
        symbolBorderWidth: PropTypes.number,
        symbolBorderColor: PropTypes.string
    }).isRequired
});

var symbolPropTypes = {
    symbolShape: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    symbolSize: PropTypes.number,
    symbolSpacing: PropTypes.number,
    symbolBorderWidth: PropTypes.number,
    symbolBorderColor: PropTypes.string
};

var interactivityPropTypes = {
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func
};

var datumPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    color: PropTypes.string.isRequired,
    fill: PropTypes.string
});

/**
 * The prop type is exported as a simple object instead of `PropTypes.shape`
 * to be able to add extra properties.
 *
 * @example
 * ```javascript
 * import { LegendPropShape } from '@nivo/legends'
 *
 * const customLegendPropType = PropTypes.shape({
 *     ...LegendPropShape,
 *     extra: PropTypes.any.isRequired,
 * })
 * ```
 */
var LegendPropShape = _extends({
    data: PropTypes.arrayOf(datumPropType),

    // position & layout
    anchor: PropTypes.oneOf([ANCHOR_TOP, ANCHOR_TOP_RIGHT, ANCHOR_RIGHT, ANCHOR_BOTTOM_RIGHT, ANCHOR_BOTTOM, ANCHOR_BOTTOM_LEFT, ANCHOR_LEFT, ANCHOR_TOP_LEFT, ANCHOR_CENTER]).isRequired,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    direction: PropTypes.oneOf([DIRECTION_ROW, DIRECTION_COLUMN]).isRequired,

    // item
    itemsSpacing: PropTypes.number,
    itemWidth: PropTypes.number.isRequired,
    itemHeight: PropTypes.number.isRequired,
    itemDirection: PropTypes.oneOf([DIRECTION_LEFT_TO_RIGHT, DIRECTION_RIGHT_TO_LEFT, DIRECTION_TOP_TO_BOTTOM, DIRECTION_BOTTOM_TO_TOP]),
    itemTextColor: PropTypes.string,
    itemBackground: PropTypes.string,
    itemOpacity: PropTypes.number

}, symbolPropTypes, interactivityPropTypes, {

    effects: PropTypes.arrayOf(legendEffectPropType)
});

var zeroPadding = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};

var computeDimensions = function computeDimensions(_ref) {
    var itemCount = _ref.itemCount,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        direction = _ref.direction,
        itemsSpacing = _ref.itemsSpacing,
        _padding = _ref.padding;

    var padding = void 0;
    if (isNumber(_padding)) {
        padding = {
            top: _padding,
            right: _padding,
            bottom: _padding,
            left: _padding
        };
    } else if (isPlainObject(_padding)) {
        padding = _extends({}, zeroPadding, _padding);
    } else {
        throw new TypeError('Invalid property padding, must be one of: number, object');
    }

    var horizontalPadding = padding.left + padding.right;
    var verticalPadding = padding.top + padding.bottom;
    var width = itemWidth + horizontalPadding;
    var height = itemHeight + verticalPadding;
    var spacing = (itemCount - 1) * itemsSpacing;
    if (direction === DIRECTION_ROW) {
        width = itemWidth * itemCount + spacing + horizontalPadding;
    } else if (direction === DIRECTION_COLUMN) {
        height = itemHeight * itemCount + spacing + verticalPadding;
    }

    return { width: width, height: height, padding: padding };
};

var computePositionFromAnchor = function computePositionFromAnchor(_ref2) {
    var anchor = _ref2.anchor,
        translateX = _ref2.translateX,
        translateY = _ref2.translateY,
        containerWidth = _ref2.containerWidth,
        containerHeight = _ref2.containerHeight,
        width = _ref2.width,
        height = _ref2.height;

    var x = translateX;
    var y = translateY;

    switch (anchor) {
        case ANCHOR_TOP:
            x += (containerWidth - width) / 2;
            break;

        case ANCHOR_TOP_RIGHT:
            x += containerWidth - width;
            break;

        case ANCHOR_RIGHT:
            x += containerWidth - width;
            y += (containerHeight - height) / 2;
            break;

        case ANCHOR_BOTTOM_RIGHT:
            x += containerWidth - width;
            y += containerHeight - height;
            break;

        case ANCHOR_BOTTOM:
            x += (containerWidth - width) / 2;
            y += containerHeight - height;
            break;

        case ANCHOR_BOTTOM_LEFT:
            y += containerHeight - height;
            break;

        case ANCHOR_LEFT:
            y += (containerHeight - height) / 2;
            break;

        case ANCHOR_CENTER:
            x += (containerWidth - width) / 2;
            y += (containerHeight - height) / 2;
            break;
    }

    return { x: x, y: y };
};

var computeItemLayout = function computeItemLayout(_ref3) {
    var direction = _ref3.direction,
        justify = _ref3.justify,
        symbolSize = _ref3.symbolSize,
        symbolSpacing = _ref3.symbolSpacing,
        width = _ref3.width,
        height = _ref3.height;

    var symbolX = void 0;
    var symbolY = void 0;

    var labelX = void 0;
    var labelY = void 0;
    var labelAnchor = void 0;
    var labelAlignment = void 0;

    switch (direction) {
        case DIRECTION_LEFT_TO_RIGHT:
            symbolX = 0;
            symbolY = (height - symbolSize) / 2;

            labelY = height / 2;
            labelAlignment = 'middle';
            if (justify === true) {
                labelX = width;
                labelAnchor = 'end';
            } else {
                labelX = symbolSize + symbolSpacing;
                labelAnchor = 'start';
            }
            break;

        case DIRECTION_RIGHT_TO_LEFT:
            symbolX = width - symbolSize;
            symbolY = (height - symbolSize) / 2;

            labelY = height / 2;
            labelAlignment = 'middle';
            if (justify === true) {
                labelX = 0;
                labelAnchor = 'start';
            } else {
                labelX = width - symbolSize - symbolSpacing;
                labelAnchor = 'end';
            }
            break;

        case DIRECTION_TOP_TO_BOTTOM:
            symbolX = (width - symbolSize) / 2;
            symbolY = 0;

            labelX = width / 2;

            labelAnchor = 'middle';
            if (justify === true) {
                labelY = height;
                labelAlignment = 'baseline';
            } else {
                labelY = symbolSize + symbolSpacing;
                labelAlignment = 'hanging';
            }
            break;

        case DIRECTION_BOTTOM_TO_TOP:
            symbolX = (width - symbolSize) / 2;
            symbolY = height - symbolSize;

            labelX = width / 2;
            labelAnchor = 'middle';
            if (justify === true) {
                labelY = 0;
                labelAlignment = 'hanging';
            } else {
                labelY = height - symbolSize - symbolSpacing;
                labelAlignment = 'baseline';
            }
            break;
    }

    return {
        symbolX: symbolX,
        symbolY: symbolY,

        labelX: labelX,
        labelY: labelY,
        labelAnchor: labelAnchor,
        labelAlignment: labelAlignment
    };
};

var symbolPropTypes$1 = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
    borderWidth: PropTypes.number.isRequired,
    borderColor: PropTypes.string.isRequired
};

var symbolDefaultProps = {
    borderWidth: 0,
    borderColor: 'transparent'
};

var SymbolCircle = function (_PureComponent) {
    inherits(SymbolCircle, _PureComponent);

    function SymbolCircle() {
        classCallCheck(this, SymbolCircle);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    SymbolCircle.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            size = _props.size,
            fill = _props.fill,
            borderWidth = _props.borderWidth,
            borderColor = _props.borderColor;

        return React__default.createElement('circle', {
            r: size / 2,
            cx: x + size / 2,
            cy: y + size / 2,
            fill: fill,
            strokeWidth: borderWidth,
            stroke: borderColor,
            style: {
                pointerEvents: 'none'
            }
        });
    };

    return SymbolCircle;
}(React.PureComponent);

SymbolCircle.propTypes = _extends({}, symbolPropTypes$1);
SymbolCircle.defaultProps = _extends({}, symbolDefaultProps);

var SymbolDiamond = function (_PureComponent) {
    inherits(SymbolDiamond, _PureComponent);

    function SymbolDiamond() {
        classCallCheck(this, SymbolDiamond);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    SymbolDiamond.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            size = _props.size,
            fill = _props.fill,
            borderWidth = _props.borderWidth,
            borderColor = _props.borderColor;

        return React__default.createElement('g', { transform: 'translate(' + x + ',' + y + ')' }, React__default.createElement('path', {
            d: '\n                    M' + size / 2 + ' 0\n                    L' + size * 0.8 + ' ' + size / 2 + '\n                    L' + size / 2 + ' ' + size + '\n                    L' + size * 0.2 + ' ' + size / 2 + '\n                    L' + size / 2 + ' 0\n                ',
            fill: fill,
            strokeWidth: borderWidth,
            stroke: borderColor,
            style: {
                pointerEvents: 'none'
            }
        }));
    };

    return SymbolDiamond;
}(React.PureComponent);

SymbolDiamond.propTypes = _extends({}, symbolPropTypes$1);
SymbolDiamond.defaultProps = _extends({}, symbolDefaultProps);

var SymbolSquare = function (_PureComponent) {
    inherits(SymbolSquare, _PureComponent);

    function SymbolSquare() {
        classCallCheck(this, SymbolSquare);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    SymbolSquare.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            size = _props.size,
            fill = _props.fill,
            borderWidth = _props.borderWidth,
            borderColor = _props.borderColor;

        return React__default.createElement('rect', {
            x: x,
            y: y,
            fill: fill,
            strokeWidth: borderWidth,
            stroke: borderColor,
            width: size,
            height: size,
            style: {
                pointerEvents: 'none'
            }
        });
    };

    return SymbolSquare;
}(React.PureComponent);

SymbolSquare.propTypes = _extends({}, symbolPropTypes$1);
SymbolSquare.defaultProps = _extends({}, symbolDefaultProps);

var SymbolTriangle = function (_PureComponent) {
    inherits(SymbolTriangle, _PureComponent);

    function SymbolTriangle() {
        classCallCheck(this, SymbolTriangle);
        return possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
    }

    SymbolTriangle.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            size = _props.size,
            fill = _props.fill,
            borderWidth = _props.borderWidth,
            borderColor = _props.borderColor;

        return React__default.createElement('g', { transform: 'translate(' + x + ',' + y + ')' }, React__default.createElement('path', {
            d: '\n                M' + size / 2 + ' 0\n                L' + size + ' ' + size + '\n                L0 ' + size + '\n                L' + size / 2 + ' 0\n            ',
            fill: fill,
            strokeWidth: borderWidth,
            stroke: borderColor,
            style: {
                pointerEvents: 'none'
            }
        }));
    };

    return SymbolTriangle;
}(React.PureComponent);

SymbolTriangle.propTypes = _extends({}, symbolPropTypes$1);
SymbolTriangle.defaultProps = _extends({}, symbolDefaultProps);

var symbolByShape = {
    circle: SymbolCircle,
    diamond: SymbolDiamond,
    square: SymbolSquare,
    triangle: SymbolTriangle
};

var LegendSvgItem = function (_Component) {
    inherits(LegendSvgItem, _Component);

    function LegendSvgItem() {
        var _temp, _this, _ret;

        classCallCheck(this, LegendSvgItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            style: {}
        }, _this.handleClick = function (event) {
            var _this$props = _this.props,
                onClick = _this$props.onClick,
                data = _this$props.data;

            if (onClick === undefined) return;
            onClick(data, event);
        }, _this.handleMouseEnter = function (event) {
            var _this$props2 = _this.props,
                onMouseEnter = _this$props2.onMouseEnter,
                data = _this$props2.data,
                effects = _this$props2.effects;

            if (effects.length > 0) {
                var applyEffects = effects.filter(function (_ref) {
                    var on = _ref.on;
                    return on === 'hover';
                });
                var style = applyEffects.reduce(function (acc, effect) {
                    return _extends({}, acc, effect.style);
                }, {});
                _this.setState({ style: style });
            }

            if (onMouseEnter === undefined) return;
            onMouseEnter(data, event);
        }, _this.handleMouseLeave = function () {
            var _this$props3 = _this.props,
                onMouseLeave = _this$props3.onMouseLeave,
                data = _this$props3.data,
                effects = _this$props3.effects;

            if (effects.length > 0) {
                var applyEffects = effects.filter(function (_ref2) {
                    var on = _ref2.on;
                    return on !== 'hover';
                });
                var style = applyEffects.reduce(function (acc, effect) {
                    return _extends({}, acc, effect.style);
                }, {});
                _this.setState({ style: style });
            }

            if (onMouseLeave === undefined) return;
            onMouseLeave(data, event);
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    LegendSvgItem.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            width = _props.width,
            height = _props.height,
            data = _props.data,
            direction = _props.direction,
            justify = _props.justify,
            textColor = _props.textColor,
            background = _props.background,
            opacity = _props.opacity,
            symbolShape = _props.symbolShape,
            symbolSize = _props.symbolSize,
            symbolSpacing = _props.symbolSpacing,
            symbolBorderWidth = _props.symbolBorderWidth,
            symbolBorderColor = _props.symbolBorderColor,
            onClick = _props.onClick,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave,
            theme = _props.theme;
        var style = this.state.style;

        var _computeItemLayout = computeItemLayout({
            direction: direction,
            justify: justify,
            symbolSize: style.symbolSize || symbolSize,
            symbolSpacing: symbolSpacing,
            width: width,
            height: height
        }),
            symbolX = _computeItemLayout.symbolX,
            symbolY = _computeItemLayout.symbolY,
            labelX = _computeItemLayout.labelX,
            labelY = _computeItemLayout.labelY,
            labelAnchor = _computeItemLayout.labelAnchor,
            labelAlignment = _computeItemLayout.labelAlignment;

        var isInteractive = [onClick, onMouseEnter, onMouseLeave].some(function (handler) {
            return handler !== undefined;
        });

        var _Symbol = void 0;
        if (isFunction(symbolShape)) {
            _Symbol = symbolShape;
        } else {
            _Symbol = symbolByShape[symbolShape];
        }

        return React__default.createElement('g', {
            transform: 'translate(' + x + ',' + y + ')',
            style: {
                opacity: style.itemOpacity !== undefined ? style.itemOpacity : opacity
            }
        }, React__default.createElement('rect', {
            width: width,
            height: height,
            fill: style.itemBackground || background,
            style: {
                cursor: isInteractive ? 'pointer' : 'auto'
            },
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        }), React__default.createElement(_Symbol, {
            x: symbolX,
            y: symbolY,
            size: style.symbolSize || symbolSize,
            fill: data.fill || data.color,
            borderWidth: style.symbolBorderWidth !== undefined ? style.symbolBorderWidth : symbolBorderWidth,
            borderColor: style.symbolBorderColor || symbolBorderColor
        }), React__default.createElement('text', {
            textAnchor: labelAnchor,
            style: _extends({}, theme.legends.text, {
                fill: style.itemTextColor || textColor,
                alignmentBaseline: labelAlignment,
                pointerEvents: 'none',
                userSelect: 'none'
            }),
            x: labelX,
            y: labelY
        }, data.label));
    };

    return LegendSvgItem;
}(React.Component);

LegendSvgItem.propTypes = _extends({
    data: datumPropType.isRequired,

    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    textColor: PropTypes.string,
    background: PropTypes.string,
    opacity: PropTypes.number,

    direction: PropTypes.oneOf([DIRECTION_LEFT_TO_RIGHT, DIRECTION_RIGHT_TO_LEFT, DIRECTION_TOP_TO_BOTTOM, DIRECTION_BOTTOM_TO_TOP]).isRequired,
    justify: PropTypes.bool.isRequired

}, symbolPropTypes, interactivityPropTypes);
LegendSvgItem.defaultProps = {
    direction: DIRECTION_LEFT_TO_RIGHT,
    justify: false,

    textColor: 'black',
    background: 'transparent',
    opacity: 1,

    // symbol
    symbolShape: 'square',
    symbolSize: 16,
    symbolSpacing: 8,
    symbolBorderWidth: 0,
    symbolBorderColor: 'transparent',

    effects: []
};

var LegendSvg = function LegendSvg(_ref) {
    var data = _ref.data,
        x = _ref.x,
        y = _ref.y,
        direction = _ref.direction,
        _padding = _ref.padding,
        justify = _ref.justify,
        effects = _ref.effects,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        itemDirection = _ref.itemDirection,
        itemsSpacing = _ref.itemsSpacing,
        itemTextColor = _ref.itemTextColor,
        itemBackground = _ref.itemBackground,
        itemOpacity = _ref.itemOpacity,
        symbolShape = _ref.symbolShape,
        symbolSize = _ref.symbolSize,
        symbolSpacing = _ref.symbolSpacing,
        symbolBorderWidth = _ref.symbolBorderWidth,
        symbolBorderColor = _ref.symbolBorderColor,
        onClick = _ref.onClick,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        theme = _ref.theme;

    // eslint-disable-next-line no-unused-vars
    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }),
        padding = _computeDimensions.padding;

    var xStep = 0;
    var yStep = 0;
    if (direction === DIRECTION_ROW) {
        xStep = itemWidth + itemsSpacing;
    } else if (direction === DIRECTION_COLUMN) {
        yStep = itemHeight + itemsSpacing;
    }

    return React__default.createElement('g', { transform: 'translate(' + x + ',' + y + ')' }, data.map(function (data, i) {
        return React__default.createElement(LegendSvgItem, {
            key: i,
            data: data,
            x: i * xStep + padding.left,
            y: i * yStep + padding.top,
            width: itemWidth,
            height: itemHeight,
            direction: itemDirection,
            justify: justify,
            effects: effects,
            textColor: itemTextColor,
            background: itemBackground,
            opacity: itemOpacity,
            symbolShape: symbolShape,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            symbolBorderWidth: symbolBorderWidth,
            symbolBorderColor: symbolBorderColor,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            theme: theme
        });
    }));
};

LegendSvg.propTypes = _extends({
    data: PropTypes.arrayOf(datumPropType).isRequired,

    // position/layout
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    direction: PropTypes.oneOf([DIRECTION_COLUMN, DIRECTION_ROW]).isRequired,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
        top: PropTypes.number,
        right: PropTypes.number,
        bottom: PropTypes.number,
        left: PropTypes.number
    })]).isRequired,
    justify: PropTypes.bool.isRequired,

    // items
    itemsSpacing: PropTypes.number.isRequired,
    itemWidth: PropTypes.number.isRequired,
    itemHeight: PropTypes.number.isRequired,
    itemDirection: PropTypes.oneOf([DIRECTION_LEFT_TO_RIGHT, DIRECTION_RIGHT_TO_LEFT, DIRECTION_TOP_TO_BOTTOM, DIRECTION_BOTTOM_TO_TOP]).isRequired,
    itemTextColor: PropTypes.string.isRequired,
    itemBackground: PropTypes.string.isRequired,
    itemOpacity: PropTypes.number.isRequired

}, symbolPropTypes, interactivityPropTypes);

LegendSvg.defaultProps = {
    // position/layout
    padding: 0,
    justify: false,

    // items
    itemsSpacing: 0,
    itemDirection: DIRECTION_LEFT_TO_RIGHT,
    itemTextColor: 'black',
    itemBackground: 'transparent',
    itemOpacity: 1
};

var BoxLegendSvg = function BoxLegendSvg(_ref) {
    var data = _ref.data,
        containerWidth = _ref.containerWidth,
        containerHeight = _ref.containerHeight,
        translateX = _ref.translateX,
        translateY = _ref.translateY,
        anchor = _ref.anchor,
        direction = _ref.direction,
        padding = _ref.padding,
        justify = _ref.justify,
        itemsSpacing = _ref.itemsSpacing,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        itemDirection = _ref.itemDirection,
        itemTextColor = _ref.itemTextColor,
        itemBackground = _ref.itemBackground,
        itemOpacity = _ref.itemOpacity,
        symbolShape = _ref.symbolShape,
        symbolSize = _ref.symbolSize,
        symbolSpacing = _ref.symbolSpacing,
        symbolBorderWidth = _ref.symbolBorderWidth,
        symbolBorderColor = _ref.symbolBorderColor,
        onClick = _ref.onClick,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        effects = _ref.effects,
        theme = _ref.theme;

    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        direction: direction,
        padding: padding
    }),
        width = _computeDimensions.width,
        height = _computeDimensions.height;

    var _computePositionFromA = computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }),
        x = _computePositionFromA.x,
        y = _computePositionFromA.y;

    return React__default.createElement(LegendSvg, {
        data: data,
        x: x,
        y: y,
        direction: direction,
        padding: padding,
        justify: justify,
        effects: effects,
        itemsSpacing: itemsSpacing,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemDirection: itemDirection,
        itemTextColor: itemTextColor,
        itemBackground: itemBackground,
        itemOpacity: itemOpacity,
        symbolShape: symbolShape,
        symbolSize: symbolSize,
        symbolSpacing: symbolSpacing,
        symbolBorderWidth: symbolBorderWidth,
        symbolBorderColor: symbolBorderColor,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        theme: theme
    });
};

BoxLegendSvg.propTypes = _extends({
    data: PropTypes.arrayOf(datumPropType).isRequired,
    containerWidth: PropTypes.number.isRequired,
    containerHeight: PropTypes.number.isRequired,
    translateX: PropTypes.number.isRequired,
    translateY: PropTypes.number.isRequired,
    anchor: PropTypes.oneOf([ANCHOR_TOP, ANCHOR_TOP_RIGHT, ANCHOR_RIGHT, ANCHOR_BOTTOM_RIGHT, ANCHOR_BOTTOM, ANCHOR_BOTTOM_LEFT, ANCHOR_LEFT, ANCHOR_TOP_LEFT, ANCHOR_CENTER]).isRequired,
    direction: PropTypes.oneOf([DIRECTION_ROW, DIRECTION_COLUMN]).isRequired,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
        top: PropTypes.number,
        right: PropTypes.number,
        bottom: PropTypes.number,
        left: PropTypes.number
    })]).isRequired,
    justify: PropTypes.bool,

    itemWidth: PropTypes.number.isRequired,
    itemHeight: PropTypes.number.isRequired,
    itemDirection: PropTypes.oneOf([DIRECTION_LEFT_TO_RIGHT, DIRECTION_RIGHT_TO_LEFT, DIRECTION_TOP_TO_BOTTOM, DIRECTION_BOTTOM_TO_TOP]),
    itemsSpacing: PropTypes.number.isRequired,
    itemTextColor: PropTypes.string,
    itemBackground: PropTypes.string,
    itemOpacity: PropTypes.number

}, symbolPropTypes, interactivityPropTypes);

BoxLegendSvg.defaultProps = {
    translateX: 0,
    translateY: 0,
    itemsSpacing: LegendSvg.defaultProps.itemsSpacing,
    padding: LegendSvg.defaultProps.padding
};

var textPropsMapping = {
    align: {
        start: 'left',
        middle: 'center',
        end: 'right'
    },
    baseline: {
        hanging: 'top',
        middle: 'middle',
        baseline: 'bottom'
    }
};

var renderLegendToCanvas = function renderLegendToCanvas(ctx, _ref) {
    var data = _ref.data,
        containerWidth = _ref.containerWidth,
        containerHeight = _ref.containerHeight,
        _ref$translateX = _ref.translateX,
        translateX = _ref$translateX === undefined ? BoxLegendSvg.defaultProps.translateX : _ref$translateX,
        _ref$translateY = _ref.translateY,
        translateY = _ref$translateY === undefined ? BoxLegendSvg.defaultProps.translateY : _ref$translateY,
        anchor = _ref.anchor,
        direction = _ref.direction,
        _ref$padding = _ref.padding,
        _padding = _ref$padding === undefined ? LegendSvg.defaultProps.padding : _ref$padding,
        _ref$justify = _ref.justify,
        justify = _ref$justify === undefined ? LegendSvgItem.defaultProps.justify : _ref$justify,
        _ref$itemsSpacing = _ref.itemsSpacing,
        itemsSpacing = _ref$itemsSpacing === undefined ? LegendSvg.defaultProps.itemsSpacing : _ref$itemsSpacing,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        _ref$itemDirection = _ref.itemDirection,
        itemDirection = _ref$itemDirection === undefined ? LegendSvgItem.defaultProps.direction : _ref$itemDirection,
        _ref$itemTextColor = _ref.itemTextColor,
        itemTextColor = _ref$itemTextColor === undefined ? LegendSvg.defaultProps.textColor : _ref$itemTextColor,
        _ref$symbolSize = _ref.symbolSize,
        symbolSize = _ref$symbolSize === undefined ? LegendSvgItem.defaultProps.symbolSize : _ref$symbolSize,
        _ref$symbolSpacing = _ref.symbolSpacing,
        symbolSpacing = _ref$symbolSpacing === undefined ? LegendSvgItem.defaultProps.symbolSpacing : _ref$symbolSpacing;

    var _computeDimensions = computeDimensions({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }),
        width = _computeDimensions.width,
        height = _computeDimensions.height,
        padding = _computeDimensions.padding;

    var _computePositionFromA = computePositionFromAnchor({
        anchor: anchor,
        translateX: translateX,
        translateY: translateY,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        width: width,
        height: height
    }),
        x = _computePositionFromA.x,
        y = _computePositionFromA.y;

    var xStep = 0;
    var yStep = 0;
    if (direction === DIRECTION_ROW) {
        xStep = itemWidth + itemsSpacing;
    } else if (direction === DIRECTION_COLUMN) {
        yStep = itemHeight + itemsSpacing;
    }

    ctx.save();
    ctx.translate(x, y);

    data.forEach(function (d, i) {
        var itemX = i * xStep + padding.left;
        var itemY = i * yStep + padding.top;

        var _computeItemLayout = computeItemLayout({
            direction: itemDirection,
            justify: justify,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            width: itemWidth,
            height: itemHeight
        }),
            symbolX = _computeItemLayout.symbolX,
            symbolY = _computeItemLayout.symbolY,
            labelX = _computeItemLayout.labelX,
            labelY = _computeItemLayout.labelY,
            labelAnchor = _computeItemLayout.labelAnchor,
            labelAlignment = _computeItemLayout.labelAlignment;

        ctx.fillStyle = d.color;
        ctx.fillRect(itemX + symbolX, itemY + symbolY, symbolSize, symbolSize);

        ctx.textAlign = textPropsMapping.align[labelAnchor];
        ctx.textBaseline = textPropsMapping.baseline[labelAlignment];
        ctx.fillStyle = itemTextColor;
        ctx.fillText(d.label, itemX + labelX, itemY + labelY);
    });

    ctx.restore();
};

exports.BoxLegendSvg = BoxLegendSvg;
exports.LegendSvg = LegendSvg;
exports.LegendSvgItem = LegendSvgItem;
exports.renderLegendToCanvas = renderLegendToCanvas;
exports.DIRECTION_ROW = DIRECTION_ROW;
exports.DIRECTION_COLUMN = DIRECTION_COLUMN;
exports.ANCHOR_TOP = ANCHOR_TOP;
exports.ANCHOR_TOP_RIGHT = ANCHOR_TOP_RIGHT;
exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
exports.ANCHOR_BOTTOM_RIGHT = ANCHOR_BOTTOM_RIGHT;
exports.ANCHOR_BOTTOM = ANCHOR_BOTTOM;
exports.ANCHOR_BOTTOM_LEFT = ANCHOR_BOTTOM_LEFT;
exports.ANCHOR_LEFT = ANCHOR_LEFT;
exports.ANCHOR_TOP_LEFT = ANCHOR_TOP_LEFT;
exports.ANCHOR_CENTER = ANCHOR_CENTER;
exports.DIRECTION_LEFT_TO_RIGHT = DIRECTION_LEFT_TO_RIGHT;
exports.DIRECTION_RIGHT_TO_LEFT = DIRECTION_RIGHT_TO_LEFT;
exports.DIRECTION_TOP_TO_BOTTOM = DIRECTION_TOP_TO_BOTTOM;
exports.DIRECTION_BOTTOM_TO_TOP = DIRECTION_BOTTOM_TO_TOP;
exports.legendEffectPropType = legendEffectPropType;
exports.symbolPropTypes = symbolPropTypes;
exports.interactivityPropTypes = interactivityPropTypes;
exports.datumPropType = datumPropType;
exports.LegendPropShape = LegendPropShape;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1560);

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
    return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(1));
var pure = _interopDefault(__webpack_require__(728));
var core = __webpack_require__(856);
var isFunction = _interopDefault(__webpack_require__(197));
var d3Format = __webpack_require__(321);
var compose = _interopDefault(__webpack_require__(727));
var withState = _interopDefault(__webpack_require__(2475));
var withHandlers = _interopDefault(__webpack_require__(2473));
var withPropsOnChange = _interopDefault(__webpack_require__(729));
var reactMotion = __webpack_require__(466);
var axes = __webpack_require__(1558);
var scales = __webpack_require__(1565);
var legends = __webpack_require__(1561);
var d3Shape = __webpack_require__(924);
var defaultProps = _interopDefault(__webpack_require__(1269));

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var LineAreas = function LineAreas(_ref) {
    var areaGenerator = _ref.areaGenerator,
        areaOpacity = _ref.areaOpacity,
        areaBlendMode = _ref.areaBlendMode,
        lines = _ref.lines,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;

    if (animate !== true) {
        return React__default.createElement('g', null, lines.slice(0).reverse().map(function (_ref2) {
            var id = _ref2.id,
                data = _ref2.data,
                areaColor = _ref2.color;
            return React__default.createElement('path', {
                key: id,
                d: areaGenerator(data.map(function (d) {
                    return d.position;
                })),
                fill: areaColor,
                fillOpacity: areaOpacity,
                strokeWidth: 0,
                style: {
                    mixBlendMode: areaBlendMode
                }
            });
        }));
    }

    var springConfig = {
        stiffness: motionStiffness,
        damping: motionDamping
    };

    return React__default.createElement('g', null, lines.slice(0).reverse().map(function (_ref3) {
        var id = _ref3.id,
            data = _ref3.data,
            areaColor = _ref3.color;
        return React__default.createElement(core.SmartMotion, {
            key: id,
            style: function style(spring) {
                return {
                    d: spring(areaGenerator(data.map(function (d) {
                        return d.position;
                    })), springConfig),
                    fill: spring(areaColor, springConfig)
                };
            }
        }, function (style) {
            return React__default.createElement('path', {
                key: id,
                d: style.d,
                fill: areaColor,
                fillOpacity: areaOpacity,
                strokeWidth: 0,
                style: { mixBlendMode: areaBlendMode }
            });
        });
    }));
};

LineAreas.propTypes = _extends({
    areaOpacity: PropTypes.number.isRequired,
    areaBlendMode: core.blendModePropType.isRequired
}, core.motionPropTypes);

var LineAreas$1 = pure(LineAreas);

var LineLine = function LineLine(_ref) {
    var lineGenerator = _ref.lineGenerator,
        id = _ref.id,
        points = _ref.points,
        color = _ref.color,
        thickness = _ref.thickness,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;

    if (animate !== true) {
        return React__default.createElement('path', {
            key: id,
            d: lineGenerator(points),
            fill: 'none',
            strokeWidth: thickness,
            stroke: color
        });
    }

    var springConfig = {
        stiffness: motionStiffness,
        damping: motionDamping
    };

    return React__default.createElement(core.SmartMotion, {
        key: id,
        style: function style(spring) {
            return {
                d: spring(lineGenerator(points), springConfig),
                stroke: spring(color, springConfig)
            };
        }
    }, function (style) {
        return React__default.createElement('path', {
            key: id,
            d: style.d,
            fill: 'none',
            strokeWidth: thickness,
            stroke: style.stroke
        });
    });
};

LineLine.propTypes = _extends({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    points: PropTypes.arrayOf(PropTypes.shape({
        x: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        y: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })),
    lineGenerator: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
    thickness: PropTypes.number.isRequired
}, core.motionPropTypes);

var Line = pure(LineLine);

var LineLines = function LineLines(_ref) {
    var lines = _ref.lines,
        lineGenerator = _ref.lineGenerator,
        lineWidth = _ref.lineWidth,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;
    return React__default.createElement('g', null, lines.map(function (_ref2) {
        var id = _ref2.id,
            data = _ref2.data,
            color = _ref2.color;

        return React__default.createElement(Line, {
            key: id,
            id: id,
            points: data.map(function (d) {
                return d.position;
            }),
            lineGenerator: lineGenerator,
            color: color,
            thickness: lineWidth,
            animate: animate,
            motionStiffness: motionStiffness,
            motionDamping: motionDamping
        });
    }));
};

LineLines.propTypes = _extends({
    lines: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        color: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            data: PropTypes.shape({
                x: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
                y: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
            }).isRequired,
            position: PropTypes.shape({
                x: PropTypes.number,
                y: PropTypes.number
            }).isRequired
        })).isRequired
    })).isRequired,
    lineWidth: PropTypes.number.isRequired,
    lineGenerator: PropTypes.func.isRequired
}, core.motionPropTypes);

var LineLines$1 = pure(LineLines);

var Chip = function Chip(_ref) {
    var color = _ref.color;
    return React__default.createElement('span', { style: { display: 'block', width: '12px', height: '12px', background: color } });
};

Chip.propTypes = {
    color: PropTypes.string.isRequired
};

var LineSlicesItem = function LineSlicesItem(_ref2) {
    var slice = _ref2.slice,
        height = _ref2.height,
        showTooltip = _ref2.showTooltip,
        hideTooltip = _ref2.hideTooltip,
        isHover = _ref2.isHover;
    return React__default.createElement('g', { transform: 'translate(' + slice.x + ', 0)' }, isHover && React__default.createElement('line', {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: height,
        stroke: '#000',
        strokeOpacity: 0.35,
        strokeWidth: 1
    }), React__default.createElement('rect', {
        x: -20,
        width: 40,
        height: height,
        fill: '#F00',
        fillOpacity: 0,
        onMouseEnter: showTooltip,
        onMouseMove: showTooltip,
        onMouseLeave: hideTooltip
    }));
};

LineSlicesItem.propTypes = {
    slice: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTooltip: PropTypes.func.isRequired,
    hideTooltip: PropTypes.func.isRequired,
    isHover: PropTypes.bool.isRequired,
    theme: PropTypes.object.isRequired,
    tooltip: PropTypes.func,
    tooltipFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

var enhance = compose(withState('isHover', 'setIsHover', false), withPropsOnChange(['slice', 'theme', 'tooltip', 'tooltipFormat'], function (_ref3) {
    var slice = _ref3.slice,
        theme = _ref3.theme,
        tooltip = _ref3.tooltip,
        tooltipFormat = _ref3.tooltipFormat;

    var format = !tooltipFormat || isFunction(tooltipFormat) ? tooltipFormat : d3Format.format(tooltipFormat);
    var hasValues = slice.data.some(function (d) {
        return d.position.x !== null && d.position.y !== null;
    });

    return {
        tooltipElement: hasValues ? React__default.createElement(core.TableTooltip, {
            theme: theme,
            rows: slice.data.filter(function (d) {
                return d.position.x !== null && d.position.y !== null;
            }).map(function (d) {
                return [React__default.createElement(Chip, { key: d.id, color: d.serie.color }), d.serie.id, format ? format(d.data.y) : d.data.y];
            }),
            format: format,
            renderContent: typeof tooltip === 'function' ? tooltip.bind(null, _extends({}, slice)) : null
        }) : null
    };
}), withHandlers({
    showTooltip: function showTooltip(_ref4) {
        var _showTooltip = _ref4.showTooltip,
            setIsHover = _ref4.setIsHover,
            tooltipElement = _ref4.tooltipElement;
        return function (e) {
            setIsHover(true);
            _showTooltip(tooltipElement, e);
        };
    },
    hideTooltip: function hideTooltip(_ref5) {
        var _hideTooltip = _ref5.hideTooltip,
            setIsHover = _ref5.setIsHover;
        return function () {
            setIsHover(false);
            _hideTooltip();
        };
    }
}), pure);

var LineSlicesItem$1 = enhance(LineSlicesItem);

var LineSlices = function LineSlices(_ref) {
    var slices = _ref.slices,
        height = _ref.height,
        showTooltip = _ref.showTooltip,
        hideTooltip = _ref.hideTooltip,
        theme = _ref.theme,
        tooltip = _ref.tooltip,
        tooltipFormat = _ref.tooltipFormat;
    return React__default.createElement('g', null, slices.map(function (slice) {
        return React__default.createElement(LineSlicesItem$1, {
            key: slice.id,
            slice: slice,
            height: height,
            showTooltip: showTooltip,
            hideTooltip: hideTooltip,
            theme: theme,
            tooltipFormat: tooltipFormat,
            tooltip: tooltip
        });
    }));
};

LineSlices.propTypes = {
    slices: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
        x: PropTypes.number.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            data: PropTypes.shape({
                x: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
                y: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)])
            }),
            position: PropTypes.shape({
                x: PropTypes.number,
                y: PropTypes.number
            }).isRequired,
            serie: PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
                color: PropTypes.string.isRequired
            }).isRequired
        })).isRequired
    })).isRequired,
    height: PropTypes.number.isRequired,
    showTooltip: PropTypes.func.isRequired,
    hideTooltip: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
    tooltip: PropTypes.func,
    tooltipFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

var LineSlices$1 = pure(LineSlices);

var LineDots = function LineDots(_ref) {
    var lines = _ref.lines,
        symbol = _ref.symbol,
        size = _ref.size,
        color = _ref.color,
        borderWidth = _ref.borderWidth,
        borderColor = _ref.borderColor,
        enableLabel = _ref.enableLabel,
        label = _ref.label,
        labelFormat = _ref.labelFormat,
        labelYOffset = _ref.labelYOffset,
        theme = _ref.theme,
        animate = _ref.animate,
        motionStiffness = _ref.motionStiffness,
        motionDamping = _ref.motionDamping;

    var getLabel = core.getLabelGenerator(label, labelFormat);

    var points = lines.reduce(function (acc, line) {
        var id = line.id,
            data = line.data;

        return [].concat(acc, data.filter(function (datum) {
            return datum.position.x !== null && datum.position.y !== null;
        }).map(function (datum) {
            return {
                key: id + '.' + datum.data.x,
                x: datum.position.x,
                y: datum.position.y,
                datum: datum,
                fill: color(line),
                stroke: borderColor(line),
                label: enableLabel ? getLabel(datum.data) : null
            };
        }));
    }, []);

    if (animate !== true) {
        return React__default.createElement('g', null, points.map(function (point) {
            return React__default.createElement(core.DotsItem, {
                key: point.key,
                x: point.x,
                y: point.y,
                datum: point.datum,
                symbol: symbol,
                size: size,
                color: point.fill,
                borderWidth: borderWidth,
                borderColor: point.stroke,
                label: point.label,
                labelYOffset: labelYOffset,
                theme: theme
            });
        }));
    }
    var springConfig = {
        motionDamping: motionDamping,
        motionStiffness: motionStiffness
    };

    return React__default.createElement(reactMotion.TransitionMotion, {
        styles: points.map(function (point) {
            return {
                key: point.key,
                data: point,
                style: {
                    x: reactMotion.spring(point.x, springConfig),
                    y: reactMotion.spring(point.y, springConfig),
                    size: reactMotion.spring(size, springConfig)
                }
            };
        })
    }, function (interpolatedStyles) {
        return React__default.createElement('g', null, interpolatedStyles.map(function (_ref2) {
            var key = _ref2.key,
                style = _ref2.style,
                point = _ref2.data;
            return React__default.createElement(core.DotsItem, _extends({
                key: key
            }, style, {
                symbol: symbol,
                datum: point.datum,
                color: point.fill,
                borderWidth: borderWidth,
                borderColor: point.stroke,
                label: point.label,
                labelYOffset: labelYOffset,
                theme: theme
            }));
        }));
    });
};

LineDots.propTypes = _extends({
    lines: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired
    })),

    symbol: PropTypes.func,
    size: PropTypes.number.isRequired,
    color: PropTypes.func.isRequired,
    borderWidth: PropTypes.number.isRequired,
    borderColor: PropTypes.func.isRequired,

    enableLabel: PropTypes.bool.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    labelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    labelYOffset: PropTypes.number,

    theme: PropTypes.shape({
        dots: core.dotsThemePropType.isRequired
    }).isRequired

}, core.motionPropTypes);

LineDots.defaultProps = {
    // labels
    enableLabel: false,
    label: 'y'
};

var LinePropTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            x: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
            y: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)])
        })).isRequired
    })).isRequired,

    xScale: scales.scalePropType.isRequired,
    yScale: scales.scalePropType.isRequired,

    computedData: PropTypes.object.isRequired,
    layers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(['grid', 'markers', 'axes', 'areas', 'lines', 'slices', 'dots', 'legends']), PropTypes.func])).isRequired,

    curve: core.lineCurvePropType.isRequired,
    areaGenerator: PropTypes.func.isRequired,
    lineGenerator: PropTypes.func.isRequired,

    axisTop: axes.axisPropType,
    axisRight: axes.axisPropType,
    axisBottom: axes.axisPropType,
    axisLeft: axes.axisPropType,

    enableGridX: PropTypes.bool.isRequired,
    enableGridY: PropTypes.bool.isRequired,
    gridXValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    gridYValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),

    enableDots: PropTypes.bool.isRequired,
    dotSymbol: PropTypes.func,
    dotSize: PropTypes.number.isRequired,
    dotColor: PropTypes.any.isRequired,
    dotBorderWidth: PropTypes.number.isRequired,
    dotBorderColor: PropTypes.any.isRequired,
    enableDotLabel: PropTypes.bool.isRequired,

    markers: PropTypes.arrayOf(PropTypes.shape({
        axis: PropTypes.oneOf(['x', 'y']).isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        style: PropTypes.object
    })),

    getColor: PropTypes.func.isRequired,
    enableArea: PropTypes.bool.isRequired,
    areaOpacity: PropTypes.number.isRequired,
    areaBlendMode: core.blendModePropType.isRequired,
    areaBaselineValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    lineWidth: PropTypes.number.isRequired,
    defs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired
    })).isRequired,

    isInteractive: PropTypes.bool.isRequired,
    enableStackTooltip: PropTypes.bool.isRequired,
    tooltip: PropTypes.func,
    tooltipFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

    legends: PropTypes.arrayOf(PropTypes.shape(legends.LegendPropShape)).isRequired
};

var LineDefaultProps = {
    curve: 'linear',

    xScale: {
        type: 'point'
    },
    yScale: {
        type: 'linear',
        min: 0,
        max: 'auto'
    },

    layers: ['grid', 'markers', 'axes', 'areas', 'lines', 'slices', 'dots', 'legends'],
    axisBottom: {},
    axisLeft: {},
    enableGridX: true,
    enableGridY: true,

    enableDots: true,
    dotSize: 6,
    dotColor: 'inherit',
    dotBorderWidth: 0,
    dotBorderColor: 'inherit',
    enableDotLabel: false,

    colors: 'nivo',
    colorBy: 'id',
    enableArea: false,
    areaBaselineValue: 0,
    areaOpacity: 0.2,
    areaBlendMode: 'normal',
    lineWidth: 2,
    defs: [],

    isInteractive: true,
    enableStackTooltip: true,

    legends: []
};

var Line$1 = function Line(props) {
    var computedData = props.computedData,
        lineGenerator = props.lineGenerator,
        areaGenerator = props.areaGenerator,
        layers = props.layers,
        margin = props.margin,
        width = props.width,
        height = props.height,
        outerWidth = props.outerWidth,
        outerHeight = props.outerHeight,
        axisTop = props.axisTop,
        axisRight = props.axisRight,
        axisBottom = props.axisBottom,
        axisLeft = props.axisLeft,
        enableGridX = props.enableGridX,
        enableGridY = props.enableGridY,
        gridXValues = props.gridXValues,
        gridYValues = props.gridYValues,
        lineWidth = props.lineWidth,
        enableArea = props.enableArea,
        areaOpacity = props.areaOpacity,
        areaBlendMode = props.areaBlendMode,
        enableDots = props.enableDots,
        dotSymbol = props.dotSymbol,
        dotSize = props.dotSize,
        dotColor = props.dotColor,
        dotBorderWidth = props.dotBorderWidth,
        dotBorderColor = props.dotBorderColor,
        enableDotLabel = props.enableDotLabel,
        dotLabel = props.dotLabel,
        dotLabelFormat = props.dotLabelFormat,
        dotLabelYOffset = props.dotLabelYOffset,
        markers = props.markers,
        theme = props.theme,
        animate = props.animate,
        motionStiffness = props.motionStiffness,
        motionDamping = props.motionDamping,
        isInteractive = props.isInteractive,
        tooltipFormat = props.tooltipFormat,
        tooltip = props.tooltip,
        enableStackTooltip = props.enableStackTooltip,
        legends$$1 = props.legends;

    var motionProps = {
        animate: animate,
        motionDamping: motionDamping,
        motionStiffness: motionStiffness
    };

    var legendData = computedData.series.map(function (line) {
        return {
            id: line.id,
            label: line.id,
            color: line.color
        };
    }).reverse();

    return React__default.createElement(core.Container, { isInteractive: isInteractive, theme: theme }, function (_ref) {
        var showTooltip = _ref.showTooltip,
            hideTooltip = _ref.hideTooltip;

        var layerById = {
            grid: React__default.createElement(core.Grid, _extends({
                key: 'grid',
                theme: theme,
                width: width,
                height: height,
                xScale: enableGridX ? computedData.xScale : null,
                yScale: enableGridY ? computedData.yScale : null,
                xValues: gridXValues,
                yValues: gridYValues
            }, motionProps)),
            markers: React__default.createElement(core.CartesianMarkers, {
                key: 'markers',
                markers: markers,
                width: width,
                height: height,
                xScale: computedData.xScale,
                yScale: computedData.yScale,
                theme: theme
            }),
            axes: React__default.createElement(axes.Axes, _extends({
                key: 'axes',
                xScale: computedData.xScale,
                yScale: computedData.yScale,
                width: width,
                height: height,
                theme: theme,
                top: axisTop,
                right: axisRight,
                bottom: axisBottom,
                left: axisLeft
            }, motionProps)),
            areas: null,
            lines: React__default.createElement(LineLines$1, _extends({
                key: 'lines',
                lines: computedData.series,
                lineGenerator: lineGenerator,
                lineWidth: lineWidth
            }, motionProps)),
            slices: null,
            dots: null,
            legends: legends$$1.map(function (legend, i) {
                return React__default.createElement(legends.BoxLegendSvg, _extends({
                    key: i
                }, legend, {
                    containerWidth: width,
                    containerHeight: height,
                    data: legendData,
                    theme: theme
                }));
            })
        };

        if (enableArea) {
            layerById.areas = React__default.createElement(LineAreas$1, _extends({
                key: 'areas',
                areaGenerator: areaGenerator,
                areaOpacity: areaOpacity,
                areaBlendMode: areaBlendMode,
                lines: computedData.series
            }, motionProps));
        }

        if (isInteractive && enableStackTooltip) {
            layerById.slices = React__default.createElement(LineSlices$1, {
                key: 'slices',
                slices: computedData.slices,
                height: height,
                showTooltip: showTooltip,
                hideTooltip: hideTooltip,
                theme: theme,
                tooltipFormat: tooltipFormat,
                tooltip: tooltip
            });
        }

        if (enableDots) {
            layerById.dots = React__default.createElement(LineDots, _extends({
                key: 'dots',
                lines: computedData.series,
                symbol: dotSymbol,
                size: dotSize,
                color: core.getInheritedColorGenerator(dotColor),
                borderWidth: dotBorderWidth,
                borderColor: core.getInheritedColorGenerator(dotBorderColor),
                enableLabel: enableDotLabel,
                label: dotLabel,
                labelFormat: dotLabelFormat,
                labelYOffset: dotLabelYOffset,
                theme: theme
            }, motionProps));
        }
        return React__default.createElement(core.SvgWrapper, {
            width: outerWidth,
            height: outerHeight,
            margin: margin,
            theme: theme
        }, layers.map(function (layer, i) {
            if (typeof layer === 'function') {
                return React__default.createElement(React.Fragment, { key: i }, layer(_extends({}, props, {
                    xScale: computedData.xScale,
                    yScale: computedData.yScale,
                    showTooltip: showTooltip,
                    hideTooltip: hideTooltip
                })));
            }
            return layerById[layer];
        }));
    });
};

Line$1.propTypes = LinePropTypes;

var enhance$1 = compose(defaultProps(LineDefaultProps), core.withTheme(), core.withColors(), core.withDimensions(), core.withMotion(), withPropsOnChange(['curve'], function (_ref2) {
    var curve = _ref2.curve;
    return {
        lineGenerator: d3Shape.line().defined(function (d) {
            return d.x !== null && d.y !== null;
        }).x(function (d) {
            return d.x;
        }).y(function (d) {
            return d.y;
        }).curve(core.curveFromProp(curve))
    };
}), withPropsOnChange(['data', 'xScale', 'yScale', 'width', 'height'], function (_ref3) {
    var data = _ref3.data,
        xScale = _ref3.xScale,
        yScale = _ref3.yScale,
        width = _ref3.width,
        height = _ref3.height;
    return {
        computedData: scales.computeXYScalesForSeries(data, xScale, yScale, width, height)
    };
}), withPropsOnChange(['getColor', 'computedData'], function (_ref4) {
    var getColor = _ref4.getColor,
        _computedData = _ref4.computedData;

    var computedData = _extends({}, _computedData, {
        series: _computedData.series.map(function (serie) {
            return _extends({}, serie, {
                color: getColor(serie)
            });
        })
    });

    computedData.slices = scales.computeYSlices(computedData);

    return { computedData: computedData };
}), withPropsOnChange(['curve', 'computedData', 'areaBaselineValue'], function (_ref5) {
    var curve = _ref5.curve,
        computedData = _ref5.computedData,
        areaBaselineValue = _ref5.areaBaselineValue;
    return {
        areaGenerator: d3Shape.area().defined(function (d) {
            return d.x !== null && d.y !== null;
        }).x(function (d) {
            return d.x;
        }).y1(function (d) {
            return d.y;
        }).curve(core.curveFromProp(curve)).y0(computedData.yScale(areaBaselineValue))
    };
}), pure);

var enhancedLine = enhance$1(Line$1);
enhancedLine.displayName = 'Line';

var ResponsiveLine = function ResponsiveLine(props) {
    return React__default.createElement(core.ResponsiveWrapper, null, function (_ref) {
        var width = _ref.width,
            height = _ref.height;
        return React__default.createElement(enhancedLine, _extends({ width: width, height: height }, props));
    });
};

exports.Line = enhancedLine;
exports.ResponsiveLine = ResponsiveLine;
exports.LinePropTypes = LinePropTypes;
exports.LineDefaultProps = LineDefaultProps;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1562);

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
    return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var d3Scale = __webpack_require__(912);
var PropTypes = _interopDefault(__webpack_require__(1));
var d3TimeFormat = __webpack_require__(328);
var uniq = _interopDefault(__webpack_require__(2179));
var uniqBy = _interopDefault(__webpack_require__(2180));
var sortBy = _interopDefault(__webpack_require__(667));
var last = _interopDefault(__webpack_require__(666));
var isDate = _interopDefault(__webpack_require__(2163));

var linearScale = function linearScale(_ref, xy, width, height) {
    var axis = _ref.axis,
        _ref$min = _ref.min,
        min = _ref$min === undefined ? 0 : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? 'auto' : _ref$max,
        _ref$stacked = _ref.stacked,
        stacked = _ref$stacked === undefined ? false : _ref$stacked;

    var values = xy[axis];
    var size = axis === 'x' ? width : height;

    var minValue = min;
    if (min === 'auto') {
        minValue = stacked === true ? values.minStacked : values.min;
    }
    var maxValue = max;
    if (max === 'auto') {
        maxValue = stacked === true ? values.maxStacked : values.max;
    }

    var scale = d3Scale.scaleLinear().rangeRound(axis === 'x' ? [0, size] : [size, 0]).domain([minValue, maxValue]);

    scale.type = 'linear';
    scale.stacked = stacked;

    return scale;
};

var linearScalePropTypes = {
    type: PropTypes.oneOf(['linear']).isRequired,
    min: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
    stacked: PropTypes.bool
};

var logScale = function logScale(_ref, xy, width, height) {
    var axis = _ref.axis,
        _ref$base = _ref.base,
        base = _ref$base === undefined ? 10 : _ref$base,
        _ref$min = _ref.min,
        min = _ref$min === undefined ? 'auto' : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? 'auto' : _ref$max;

    var values = xy[axis];
    var size = axis === 'x' ? width : height;

    var hasZero = values.all.some(function (v) {
        return v === 0;
    });
    var sign = void 0;
    var hasMixedSign = false;
    values.all.forEach(function (v) {
        if (hasMixedSign === true) return;
        if (sign === undefined) {
            sign = Math.sign(v);
        } else if (Math.sign(v) !== sign) {
            hasMixedSign = true;
        }
    });

    if (hasZero || hasMixedSign) {
        throw new Error(['a log scale domain must be strictly-positive or strictly-negative,', 'and must not include or cross zero.'].join('\n'));
    }

    var minValue = min;
    if (min === 'auto') {
        minValue = values.min;
    }
    var maxValue = max;
    if (max === 'auto') {
        maxValue = values.max;
    }

    var scale = d3Scale.scaleLog().domain([minValue, maxValue]).rangeRound(axis === 'x' ? [0, size] : [size, 0]).base(base).nice();

    scale.type = 'log';

    return scale;
};

var logScalePropTypes = {
    type: PropTypes.oneOf(['log']).isRequired,
    base: PropTypes.number,
    min: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number])
};

var pointScale = function pointScale(_ref, xy, width, height) {
    var axis = _ref.axis;

    var values = xy[axis];
    var size = axis === 'x' ? width : height;

    var scale = d3Scale.scalePoint().range([0, size]).domain(values.all);

    scale.type = 'point';

    return scale;
};

var pointScalePropTypes = {
    type: PropTypes.oneOf(['point']).isRequired
};

var _precisionCutOffsByTy;

var TIME_PRECISION_MILLISECOND = 'millisecond';
var TIME_PRECISION_SECOND = 'second';
var TIME_PRECISION_MINUTE = 'minute';
var TIME_PRECISION_HOUR = 'hour';
var TIME_PRECISION_DAY = 'day';
var TIME_PRECISION_MONTH = 'month';
var TIME_PRECISION_YEAR = 'year';

var timePrecisions = [TIME_PRECISION_MILLISECOND, TIME_PRECISION_SECOND, TIME_PRECISION_MINUTE, TIME_PRECISION_HOUR, TIME_PRECISION_DAY, TIME_PRECISION_MONTH, TIME_PRECISION_YEAR];

var precisionCutOffs = [function (date) {
    return date.setMilliseconds(0);
}, function (date) {
    return date.setSeconds(0);
}, function (date) {
    return date.setMinutes(0);
}, function (date) {
    return date.setHours(0);
}, function (date) {
    return date.setDate(1);
}, function (date) {
    return date.setMonth(0);
}];

var precisionCutOffsByType = (_precisionCutOffsByTy = {}, _precisionCutOffsByTy[TIME_PRECISION_MILLISECOND] = [], _precisionCutOffsByTy[TIME_PRECISION_SECOND] = precisionCutOffs.slice(0, 1), _precisionCutOffsByTy[TIME_PRECISION_MINUTE] = precisionCutOffs.slice(0, 2), _precisionCutOffsByTy[TIME_PRECISION_HOUR] = precisionCutOffs.slice(0, 3), _precisionCutOffsByTy[TIME_PRECISION_DAY] = precisionCutOffs.slice(0, 4), _precisionCutOffsByTy[TIME_PRECISION_MONTH] = precisionCutOffs.slice(0, 5), _precisionCutOffsByTy[TIME_PRECISION_YEAR] = precisionCutOffs.slice(0, 6), _precisionCutOffsByTy);

var createPrecisionMethod = function createPrecisionMethod(precision) {
    return function (date) {
        precisionCutOffsByType[precision].forEach(function (cutOff) {
            cutOff(date);
        });
        return date;
    };
};

var createDateNormalizer = function createDateNormalizer(_ref) {
    var _ref$format = _ref.format,
        format = _ref$format === undefined ? 'native' : _ref$format,
        _ref$precision = _ref.precision,
        precision = _ref$precision === undefined ? 'millisecond' : _ref$precision;

    var precisionFn = createPrecisionMethod(precision);
    if (format === 'native') return function (v) {
        return precisionFn(v);
    };

    var parseTime = d3TimeFormat.timeParse(format);
    return function (v) {
        return precisionFn(parseTime(v));
    };
};

var timeScale = function timeScale(_ref, xy, width, height) {
    var axis = _ref.axis,
        _ref$format = _ref.format,
        format = _ref$format === undefined ? 'native' : _ref$format,
        _ref$precision = _ref.precision,
        precision = _ref$precision === undefined ? TIME_PRECISION_MILLISECOND : _ref$precision,
        _ref$min = _ref.min,
        min = _ref$min === undefined ? 'auto' : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === undefined ? 'auto' : _ref$max;

    var values = xy[axis];
    var size = axis === 'x' ? width : height;

    var normalize = createDateNormalizer({ format: format, precision: precision });

    var minValue = min;
    if (min === 'auto') {
        minValue = values.min;
    } else if (format !== 'native') {
        minValue = normalize(values.min);
    }

    var maxValue = max;
    if (max === 'auto') {
        maxValue = values.max;
    } else if (format !== 'native') {
        maxValue = normalize(values.max);
    }

    var scale = d3Scale.scaleTime().domain([minValue, maxValue]).range([0, size]);

    scale.type = 'time';

    return scale;
};

var timeScalePropTypes = {
    type: PropTypes.oneOf(['time']).isRequired,
    format: PropTypes.string,
    precision: PropTypes.oneOf(timePrecisions)
};

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

var getOtherAxis = function getOtherAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
};

var compareValues = function compareValues(a, b) {
    return a === b;
};
var compareDateValues = function compareDateValues(a, b) {
    return a.getTime() === b.getTime();
};

var computeXYScalesForSeries = function computeXYScalesForSeries(_series, xScaleSpec, yScaleSpec, width, height) {
    var series = _series.map(function (serie) {
        return _extends({}, serie, {
            data: serie.data.map(function (d) {
                return { data: _extends({}, d) };
            })
        });
    });

    var xy = generateSeriesXY(series, xScaleSpec, yScaleSpec);
    if (xScaleSpec.stacked === true) {
        stackX(yScaleSpec.type, xy, series);
    }
    if (yScaleSpec.stacked === true) {
        stackY(xScaleSpec.type, xy, series);
    }

    var xScale = computeScale(_extends({}, xScaleSpec, { axis: 'x' }), xy, width, height);
    var yScale = computeScale(_extends({}, yScaleSpec, { axis: 'y' }), xy, width, height);

    series.forEach(function (serie) {
        serie.data.forEach(function (d) {
            d.position = {
                x: xScale.stacked === true ? d.data.xStacked === null ? null : xScale(d.data.xStacked) : d.data.x === null ? null : xScale(d.data.x),
                y: yScale.stacked === true ? d.data.yStacked === null ? null : yScale(d.data.yStacked) : d.data.y === null ? null : yScale(d.data.y)
            };
        });
    });

    return _extends({}, xy, {
        series: series,
        xScale: xScale,
        yScale: yScale
    });
};

var computeScale = function computeScale(spec, xy, width, height) {
    if (spec.type === 'linear') return linearScale(spec, xy, width, height);else if (spec.type === 'point') return pointScale(spec, xy, width, height);else if (spec.type === 'time') return timeScale(spec, xy, width, height);else if (spec.type === 'log') return logScale(spec, xy, width, height);
};

var generateSeriesXY = function generateSeriesXY(series, xScaleSpec, yScaleSpec) {
    return {
        x: generateSeriesAxis(series, 'x', xScaleSpec),
        y: generateSeriesAxis(series, 'y', yScaleSpec)
    };
};

/**
 * Normalize data according to scale type, (time => Date, linear => Number)
 * compute sorted unique values and min/max.
 */
var generateSeriesAxis = function generateSeriesAxis(series, axis, scaleSpec) {
    if (scaleSpec.type === 'linear') {
        series.forEach(function (serie) {
            serie.data.forEach(function (d) {
                d.data[axis] = d.data[axis] === null ? null : parseFloat(d.data[axis]);
            });
        });
    } else if (scaleSpec.type === 'time' && scaleSpec.format !== 'native') {
        var parseTime = createDateNormalizer(scaleSpec);
        series.forEach(function (serie) {
            serie.data.forEach(function (d) {
                d.data[axis] = d.data[axis] === null ? null : parseTime(d.data[axis]);
            });
        });
    }

    var all = [];
    series.forEach(function (serie) {
        serie.data.forEach(function (d) {
            all.push(d.data[axis]);
        });
    });

    var min = void 0,
        max = void 0;
    if (scaleSpec.type === 'linear') {
        all = uniq(all);
        all = sortBy(all, function (v) {
            return v;
        });
        min = Math.min.apply(Math, all);
        max = Math.max.apply(Math, all);
    } else if (scaleSpec.type === 'time') {
        all = uniqBy(all, function (v) {
            return v.getTime();
        });
        all = all.slice(0).sort(function (a, b) {
            return b - a;
        }).reverse();
        min = all[0];
        max = last(all);
    } else {
        all = uniq(all);
        min = all[0];
        max = last(all);
    }

    return { all: all, min: min, max: max };
};

var stackAxis = function stackAxis(axis, otherType, xy, series) {
    var otherAxis = getOtherAxis(axis);

    var all = [];
    xy[otherAxis].all.forEach(function (v) {
        var compare = isDate(v) ? compareDateValues : compareValues;
        var stack = [];
        series.forEach(function (serie) {
            var datum = serie.data.find(function (d) {
                return compare(d.data[otherAxis], v);
            });
            var value = null;
            var stackValue = null;
            if (datum !== undefined) {
                value = datum.data[axis];
                if (value !== null) {
                    var head = last(stack);
                    if (head === undefined) {
                        stackValue = value;
                    } else if (head !== null) {
                        stackValue = head + value;
                    }
                }
                datum.data[axis + 'Stacked'] = stackValue;
            }
            stack.push(stackValue);
            all.push(stackValue);
        });
    });
    all = all.filter(function (v) {
        return v !== null;
    });

    xy[axis].minStacked = Math.min.apply(Math, all);
    xy[axis].maxStacked = Math.max.apply(Math, all);
};

var stackX = function stackX(xy, otherType, series) {
    return stackAxis('x', xy, otherType, series);
};
var stackY = function stackY(xy, otherType, series) {
    return stackAxis('y', xy, otherType, series);
};

var computeAxisSlices = function computeAxisSlices(axis, data) {
    var otherAxis = getOtherAxis(axis);

    return data[otherAxis].all.map(function (v) {
        var _slice;

        var slice = (_slice = {
            id: v
        }, _slice[otherAxis] = data[otherAxis + 'Scale'](v), _slice.data = [], _slice);
        var compare = isDate(v) ? compareDateValues : compareValues;
        data.series.forEach(function (serie) {
            var datum = serie.data.find(function (d) {
                return compare(d.data[otherAxis], v);
            });
            if (datum !== undefined) {
                slice.data.push(_extends({}, datum, {
                    serie: serie
                }));
            }
        });
        slice.data.reverse();

        return slice;
    });
};

var computeXSlices = function computeXSlices(data) {
    return computeAxisSlices('x', data);
};
var computeYSlices = function computeYSlices(data) {
    return computeAxisSlices('y', data);
};

var scalePropType = PropTypes.oneOfType([PropTypes.shape(linearScalePropTypes), PropTypes.shape(pointScalePropTypes), PropTypes.shape(timeScalePropTypes), PropTypes.shape(logScalePropTypes)]);

exports.scalePropType = scalePropType;
exports.getOtherAxis = getOtherAxis;
exports.compareValues = compareValues;
exports.compareDateValues = compareDateValues;
exports.computeXYScalesForSeries = computeXYScalesForSeries;
exports.computeScale = computeScale;
exports.generateSeriesXY = generateSeriesXY;
exports.generateSeriesAxis = generateSeriesAxis;
exports.stackAxis = stackAxis;
exports.stackX = stackX;
exports.stackY = stackY;
exports.computeAxisSlices = computeAxisSlices;
exports.computeXSlices = computeXSlices;
exports.computeYSlices = computeYSlices;
exports.linearScale = linearScale;
exports.linearScalePropTypes = linearScalePropTypes;
exports.logScale = logScale;
exports.logScalePropTypes = logScalePropTypes;
exports.pointScale = pointScale;
exports.pointScalePropTypes = pointScalePropTypes;
exports.timeScale = timeScale;
exports.timeScalePropTypes = timeScalePropTypes;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1564);

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: !0 });var env = __webpack_require__(1859);__webpack_require__(1);var React = __webpack_require__(0);function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof2(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof2(e);
  })(e);
}function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && _setPrototypeOf(e, t);
}function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
}function _possibleConstructorReturn(e, t) {
  return !t || "object" != (typeof t === "undefined" ? "undefined" : _typeof2(t)) && "function" != typeof t ? _assertThisInitialized(e) : t;
}var EventSet = function () {
  function e(t) {
    _classCallCheck(this, e), _defineProperty(this, "handlers", void 0), this.handlers = t.slice(0);
  }return _createClass(e, [{ key: "addHandlers", value: function value(t) {
      for (var n = this.handlers.slice(0), r = t.length, o = 0; o < r; o += 1) {
        n.push(t[o]);
      }return new e(n);
    } }, { key: "dispatchEvent", value: function value(e, t) {
      var n = this.handlers.length - 1;if (t) {
        for (var r = n; r >= 0; r -= 1) {
          this.handlers[r].called || (this.handlers[r].called = !0, this.handlers[r](e));
        }for (var o = n; o >= 0; o -= 1) {
          this.handlers[o].called = !1;
        }
      } else {
        (0, this.handlers[n])(e);
      }
    } }, { key: "hasHandlers", value: function value() {
      return this.handlers.length > 0;
    } }, { key: "removeHandlers", value: function value(t) {
      for (var n = [], r = this.handlers.length, o = 0; o < r; o += 1) {
        var a = this.handlers[o];-1 === t.indexOf(a) && n.push(a);
      }return new e(n);
    } }]), e;
}();function cloneMap(e) {
  var t = new Map();return e.forEach(function (e, n) {
    t.set(n, e);
  }), t;
}function normalizeHandlers(e) {
  return Array.isArray(e) ? e : [e];
}var isRefObject = function isRefObject(e) {
  return null !== e && "object" === _typeof(e) && e.hasOwnProperty("current");
};function normalizeTarget(e) {
  return "document" === e ? document : "window" === e ? window : isRefObject(e) ? e.current || document : e || document;
}var EventPool = function () {
  function e(t, n) {
    _classCallCheck(this, e), _defineProperty(this, "handlerSets", void 0), _defineProperty(this, "poolName", void 0), this.handlerSets = n, this.poolName = t;
  }return _createClass(e, [{ key: "addHandlers", value: function value(t, n) {
      var r = cloneMap(this.handlerSets);if (r.has(t)) {
        var o = r.get(t);r.set(t, o.addHandlers(n));
      } else r.set(t, new EventSet(n));return new e(this.poolName, r);
    } }, { key: "dispatchEvent", value: function value(e, t) {
      var n = this.handlerSets.get(e),
          r = "default" === this.poolName;n && n.dispatchEvent(t, r);
    } }, { key: "hasHandlers", value: function value(e) {
      if (!e) return this.handlerSets.size > 0;var t = this.handlerSets.get(e);return !!t && t.hasHandlers();
    } }, { key: "removeHandlers", value: function value(t, n) {
      var r = cloneMap(this.handlerSets);if (!r.has(t)) return new e(this.poolName, r);var o = r.get(t).removeHandlers(n);return o.hasHandlers() ? r.set(t, o) : r.delete(t), new e(this.poolName, r);
    } }]), e;
}();_defineProperty(EventPool, "createByType", function (e, t, n) {
  var r = new Map();return r.set(t, new EventSet(n)), new EventPool(e, r);
});var EventTarget = function () {
  function e(t) {
    var n = this;_classCallCheck(this, e), _defineProperty(this, "handlers", new Map()), _defineProperty(this, "pools", new Map()), _defineProperty(this, "target", void 0), _defineProperty(this, "createEmitter", function (e) {
      return function (t) {
        n.pools.forEach(function (n) {
          n.dispatchEvent(e, t);
        });
      };
    }), this.target = t;
  }return _createClass(e, [{ key: "addHandlers", value: function value(e, t, n) {
      if (this.pools.has(e)) {
        var r = this.pools.get(e);this.pools.set(e, r.addHandlers(t, n));
      } else this.pools.set(e, EventPool.createByType(e, t, n));this.handlers.has(t) || this.addTargetHandler(t);
    } }, { key: "hasHandlers", value: function value() {
      return this.handlers.size > 0;
    } }, { key: "removeHandlers", value: function value(e, t, n) {
      if (this.pools.has(e)) {
        var r = this.pools.get(e).removeHandlers(t, n);r.hasHandlers() ? this.pools.set(e, r) : this.pools.delete(e);var o = !1;this.pools.forEach(function (e) {
          return o = o || e.hasHandlers(t);
        }), o || this.removeTargetHandler(t);
      }
    } }, { key: "addTargetHandler", value: function value(e) {
      var t = this.createEmitter(e);this.handlers.set(e, t), this.target.addEventListener(e, t, !0);
    } }, { key: "removeTargetHandler", value: function value(e) {
      this.handlers.has(e) && (this.target.removeEventListener(e, this.handlers.get(e), !0), this.handlers.delete(e));
    } }]), e;
}(),
    EventStack = function () {
  function e() {
    var t = this;_classCallCheck(this, e), _defineProperty(this, "targets", new Map()), _defineProperty(this, "getTarget", function (e) {
      var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          r = normalizeTarget(e);if (t.targets.has(r)) return t.targets.get(r);if (!n) return null;var o = new EventTarget(r);return t.targets.set(r, o), o;
    }), _defineProperty(this, "removeTarget", function (e) {
      t.targets.delete(normalizeTarget(e));
    });
  }return _createClass(e, [{ key: "sub", value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};if (env.canUseDOM) {
        var r = n.target,
            o = void 0 === r ? document : r,
            a = n.pool,
            s = void 0 === a ? "default" : a;this.getTarget(o).addHandlers(s, e, normalizeHandlers(t));
      }
    } }, { key: "unsub", value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};if (env.canUseDOM) {
        var r = n.target,
            o = void 0 === r ? document : r,
            a = n.pool,
            s = void 0 === a ? "default" : a,
            i = this.getTarget(o, !1);i && (i.removeHandlers(s, e, normalizeHandlers(t)), i.hasHandlers() || this.removeTarget(o));
      }
    } }]), e;
}(),
    instance = new EventStack(),
    EventStack$1 = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
  }return _inherits(t, React.PureComponent), _createClass(t, [{ key: "componentDidMount", value: function value() {
      this.subscribe(this.props);
    } }, { key: "componentDidUpdate", value: function value(e) {
      this.unsubscribe(e), this.subscribe(this.props);
    } }, { key: "componentWillUnmount", value: function value() {
      this.unsubscribe(this.props);
    } }, { key: "subscribe", value: function value(e) {
      var t = e.name,
          n = e.on,
          r = e.pool,
          o = e.target;instance.sub(t, n, { pool: r, target: o });
    } }, { key: "unsubscribe", value: function value(e) {
      var t = e.name,
          n = e.on,
          r = e.pool,
          o = e.target;instance.unsub(t, n, { pool: r, target: o });
    } }, { key: "render", value: function value() {
      return null;
    } }]), t;
}();_defineProperty(EventStack$1, "defaultProps", { pool: "default", target: "document" }), EventStack$1.propTypes = {}, exports.instance = instance, exports.default = EventStack$1;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function (root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';

	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol: "$", // default currency symbol is '$'
			format: "%s%v", // controls output: %s = symbol, %v = value (can be object, see docs)
			decimal: ".", // decimal point separator
			thousand: ",", // thousands separator
			precision: 2, // decimal places
			grouping: 3 // digit grouping (not implemented yet)
		},
		number: {
			precision: 0, // default precision on numbers is 0
			grouping: 3, // digit grouping (not implemented yet)
			thousand: ",",
			decimal: "."
		}
	};

	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
	    nativeIsArray = Array.isArray,
	    toString = Object.prototype.toString;

	/**
  * Tests whether supplied parameter is a string
  * from underscore.js
  */
	function isString(obj) {
		return !!(obj === '' || obj && obj.charCodeAt && obj.substr);
	}

	/**
  * Tests whether supplied parameter is a string
  * from underscore.js, delegates to ECMA5's native Array.isArray
  */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
  * Tests whether supplied parameter is a true object
  */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
  * Extends an object with a defaults object, similar to underscore's _.defaults
  *
  * Used for abstracting parameter handling from API methods
  */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
  * Implementation of `Array.map()` for iteration loops
  *
  * Returns a new Array as a result of calling `iterator` on each array value.
  * Defers to native Array.map if available
  */
	function map(obj, iterator, context) {
		var results = [],
		    i,
		    j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
  * Check and normalise the value of precision (must be positive integer)
  */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val) ? base : val;
	}

	/**
  * Parses a format string or object and returns format obj for use in rendering
  *
  * `format` is either a string with the default (positive) format, or object
  * containing `pos` (required), `neg` and `zero` values (or a function returning
  * either a string or object)
  *
  * Either string or format.pos must contain "%v" (value) to be valid
  */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if (typeof format === "function") format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if (isString(format) && format.match("%v")) {

			// Create and return positive, negative and zero formats:
			return {
				pos: format,
				neg: format.replace("-", "").replace("%v", "-%v"),
				zero: format
			};

			// If no format, or object is missing valid positive value, use defaults:
		} else if (!format || !format.pos || !format.pos.match("%v")) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return !isString(defaults) ? defaults : lib.settings.currency.format = {
				pos: defaults,
				neg: defaults.replace("%v", "-%v"),
				zero: defaults
			};
		}
		// Otherwise, assume format was fine:
		return format;
	}

	/* --- API Methods --- */

	/**
  * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
  * Alias: `accounting.parse(string)`
  *
  * Decimal must be included in the regular expression to match floats (defaults to
  * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
  * separator, provide it as the second argument.
  *
  * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
  *
  * Doesn't throw any errors (`NaN`s become 0) but this may change in future
  */
	var unformat = lib.unformat = lib.parse = function (value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function (val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		// Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
		    unformatted = parseFloat(("" + value).replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
		.replace(regex, '') // strip out any cruft
		.replace(decimal, '.') // make sure decimal point is standard
		);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};

	/**
  * Implementation of toFixed() that treats floats more like decimals
  *
  * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
  * problems for accounting- and finance-related software.
  */
	var toFixed = lib.toFixed = function (value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};

	/**
  * Format a number, with comma-separated thousands and custom precision/decimal places
  * Alias: `accounting.format()`
  *
  * Localise by overriding the precision and thousand / decimal separators
  * 2nd parameter `precision` can be an object matching `settings.number`
  */
	var formatNumber = lib.formatNumber = lib.format = function (number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function (val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(isObject(precision) ? precision : {
			precision: precision,
			thousand: thousand,
			decimal: decimal
		}, lib.settings.number),


		// Clean up precision
		usePrecision = checkPrecision(opts.precision),


		// Do some calc:
		negative = number < 0 ? "-" : "",
		    base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
		    mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};

	/**
  * Format a number into currency
  *
  * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
  * defaults: (0, "$", 2, ",", ".", "%s%v")
  *
  * Localise by overriding the symbol, precision, thousand / decimal separators and format
  * Second param can be an object matching `settings.currency` which is the easiest way.
  *
  * To do: tidy up the parameters
  */
	var formatMoney = lib.formatMoney = function (number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function (val) {
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(isObject(symbol) ? symbol : {
			symbol: symbol,
			precision: precision,
			thousand: thousand,
			decimal: decimal,
			format: format
		}, lib.settings.currency),


		// Check format (returns object with pos, neg and zero):
		formats = checkCurrencyFormat(opts.format),


		// Choose which format to use for this value:
		useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};

	/**
  * Format a list of numbers into an accounting column, padding with whitespace
  * to line up currency symbols, thousand separators and decimals places
  *
  * List should be an array of numbers
  * Second parameter can be an object containing keys that match the params
  *
  * Returns array of accouting-formatted number strings of same length
  *
  * NB: `white-space:pre` CSS rule is required on the list container to prevent
  * browsers from collapsing the whitespace in the output strings.
  */
	lib.formatColumn = function (list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(isObject(symbol) ? symbol : {
			symbol: symbol,
			precision: precision,
			thousand: thousand,
			decimal: decimal,
			format: format
		}, lib.settings.currency),


		// Check format (returns object with pos, neg and zero), only need pos for now:
		formats = checkCurrencyFormat(opts.format),


		// Whether to pad at start of string or after currency symbol:
		padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,


		// Store value for the length of the longest string in the column:
		maxLength = 0,


		// Format the list according to options, store the length of the longest string:
		formatted = map(list, function (val, i) {
			if (isArray(val)) {
				// Recursively format columns if list is a multi-dimensional array:
				return lib.formatColumn(val, opts);
			} else {
				// Clean up the value
				val = unformat(val);

				// Choose which format to use for this value (pos, neg or zero):
				var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,


				// Format this value, push into formatted list and save the length:
				fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

				if (fVal.length > maxLength) maxLength = fVal.length;
				return fVal;
			}
		});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function (val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + new Array(maxLength - val.length + 1).join(" ")) : new Array(maxLength - val.length + 1).join(" ") + val;
			}
			return val;
		});
	};

	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function () {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = function (oldAccounting) {
			return function () {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		}(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
})(this);

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var bind = __webpack_require__(859);
var Axios = __webpack_require__(1569);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance();

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(defaultConfig) {
  return createInstance(defaultConfig);
};

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1584);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(1575);
var utils = __webpack_require__(121);
var InterceptorManager = __webpack_require__(1570);
var dispatchRequest = __webpack_require__(1571);
var isAbsoluteURL = __webpack_require__(1580);
var combineURLs = __webpack_require__(1578);

/**
 * Create a new instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 */
function Axios(defaultConfig) {
  this.defaults = utils.merge(defaults, defaultConfig);
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(121);
var transformData = __webpack_require__(1574);

/**
 * Dispatch a request to the server using whichever adapter
 * is supported by the current environment.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter;

  if (typeof config.adapter === 'function') {
    // For custom adapter support
    adapter = config.adapter;
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(857);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(857);
  }

  return Promise.resolve(config)
  // Wrap synchronous adapter errors and pass configuration
  .then(adapter).then(function onFulfilled(response) {
    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onRejected(error) {
    // Transform response data
    if (error && error.response) {
      error.response.data = transformData(error.response.data, error.response.headers, config.transformResponse);
    }

    return Promise.reject(error);
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(339)))

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(858);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response));
  }
};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);
var normalizeHeaderName = __webpack_require__(1582);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

module.exports = {
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    },
    patch: utils.merge(DEFAULT_CONTENT_TYPE),
    post: utils.merge(DEFAULT_CONTENT_TYPE),
    put: utils.merge(DEFAULT_CONTENT_TYPE)
  },

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error();
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
  // initialize result and counter
  var block, charCode, idx = 0, map = chars;
  // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1);
  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(121);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1607), __esModule: true };

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1609), __esModule: true };

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1611), __esModule: true };

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1613), __esModule: true };

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = function () {
  return this;
}() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1590);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch (e) {
    g.regeneratorRuntime = undefined;
  }
}

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function () {
  return this;
}() || Function("return this")());
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function placeHoldersCount(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
}

function byteLength(b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64);
}

function toByteArray(b64) {
  var i, l, tmp, placeHolders, arr;
  var len = b64.length;
  placeHolders = placeHoldersCount(b64);

  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0; i < l; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 0xFF;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 0x3F];
    output += lookup[tmp << 2 & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('');
}

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/* global define */

;(function ($) {
  'use strict';

  /*
  * Add integers, wrapping at 2^32. This uses 16-bit operations internally
  * to work around bugs in some JS interpreters.
  */

  function safeAdd(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  }

  /*
  * Bitwise rotate a 32-bit number to the left.
  */
  function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }

  /*
  * These functions implement the four basic operations the algorithm uses.
  */
  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
  }
  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
  }
  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
  }
  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
  }
  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  /*
  * Calculate the MD5 of an array of little-endian words, and a bit length.
  */
  function binlMD5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;

    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;

      a = md5ff(a, b, c, d, x[i], 7, -680876936);
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5gg(b, c, d, a, x[i], 20, -373897302);
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5hh(d, a, b, c, x[i], 11, -358537222);
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

      a = md5ii(a, b, c, d, x[i], 6, -198630844);
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

      a = safeAdd(a, olda);
      b = safeAdd(b, oldb);
      c = safeAdd(c, oldc);
      d = safeAdd(d, oldd);
    }
    return [a, b, c, d];
  }

  /*
  * Convert an array of little-endian words to a string
  */
  function binl2rstr(input) {
    var i;
    var output = '';
    var length32 = input.length * 32;
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
    }
    return output;
  }

  /*
  * Convert a raw string to an array of little-endian words
  * Characters >255 have their high-byte silently ignored.
  */
  function rstr2binl(input) {
    var i;
    var output = [];
    output[(input.length >> 2) - 1] = undefined;
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0;
    }
    var length8 = input.length * 8;
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
    }
    return output;
  }

  /*
  * Calculate the MD5 of a raw string
  */
  function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
  }

  /*
  * Calculate the HMAC-MD5, of a key and some data (raw strings)
  */
  function rstrHMACMD5(key, data) {
    var i;
    var bkey = rstr2binl(key);
    var ipad = [];
    var opad = [];
    var hash;
    ipad[15] = opad[15] = undefined;
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8);
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
  }

  /*
  * Convert a raw string to a hex string
  */
  function rstr2hex(input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i;
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i);
      output += hexTab.charAt(x >>> 4 & 0x0F) + hexTab.charAt(x & 0x0F);
    }
    return output;
  }

  /*
  * Encode a string as utf-8
  */
  function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input));
  }

  /*
  * Take string arguments and return either raw or hex encoded strings
  */
  function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s));
  }
  function hexMD5(s) {
    return rstr2hex(rawMD5(s));
  }
  function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
  }
  function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d));
  }

  function md5(string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string);
      }
      return rawMD5(string);
    }
    if (!raw) {
      return hexHMACMD5(key, string);
    }
    return rawHMACMD5(key, string);
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return md5;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    module.exports = md5;
  } else {
    $.md5 = md5;
  }
})(this);

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1591);
var ieee754 = __webpack_require__(2029);
var isArray = __webpack_require__(2036);

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1594 */
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(2480)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */

        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _eventOptionsKey = __webpack_require__(1599);

var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

var TargetEventHandlers = function () {
  function TargetEventHandlers(target) {
    _classCallCheck(this, TargetEventHandlers);

    this.target = target;
    this.events = {};
  }

  _createClass(TargetEventHandlers, [{
    key: 'getEventHandlers',
    value: function () {
      function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

        if (!this.events[key]) {
          this.events[key] = {
            handlers: [],
            handleEvent: undefined
          };
          this.events[key].nextHandlers = this.events[key].handlers;
        }

        return this.events[key];
      }

      return getEventHandlers;
    }()
  }, {
    key: 'handleEvent',
    value: function () {
      function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function (handler) {
          if (handler) {
            // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
          }
        });
      }

      return handleEvent;
    }()
  }, {
    key: 'add',
    value: function () {
      function add(eventName, listener, options) {
        var _this = this;

        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);

        ensureCanMutateNextEventHandlers(eventHandlers);

        if (eventHandlers.nextHandlers.length === 0) {
          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }

        eventHandlers.nextHandlers.push(listener);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;

            ensureCanMutateNextEventHandlers(eventHandlers);
            var index = eventHandlers.nextHandlers.indexOf(listener);
            eventHandlers.nextHandlers.splice(index, 1);

            if (eventHandlers.nextHandlers.length === 0) {
              // All event handlers have been removed, so we want to remove the event
              // listener from the target node.

              if (_this.target) {
                // There can be a race condition where the target may no longer exist
                // when this function is called, e.g. when a React component is
                // unmounting. Guarding against this prevents the following error:
                //
                //   Cannot read property 'removeEventListener' of undefined
                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
              }

              eventHandlers.handleEvent = undefined;
            }
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return add;
    }()
  }]);

  return TargetEventHandlers;
}();

exports['default'] = TargetEventHandlers;

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = canUsePassiveEventListeners;

var _canUseDOM = __webpack_require__(1597);

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
function testPassiveEventListeners() {
  if (!_canUseDOM2['default']) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    window.addEventListener('test', null, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventOptionsKey;
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_HANDLERS_KEY = undefined;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;

var _normalizeEventOptions = __webpack_require__(1601);

var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

var _TargetEventHandlers = __webpack_require__(1596);

var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

// Export to make testing possible.
var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
  }
  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

// Deprecated
function removeEventListener(unsubscribeFn) {
  unsubscribeFn();
}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = normalizeEventOptions;

var _canUsePassiveEventListeners = __webpack_require__(1598);

var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!(0, _canUsePassiveEventListeners2['default'])()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(409);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(1650);
module.exports = __webpack_require__(148).Map;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1669);
__webpack_require__(1652);
__webpack_require__(1654);
__webpack_require__(1653);
__webpack_require__(1656);
__webpack_require__(1658);
__webpack_require__(1663);
__webpack_require__(1657);
__webpack_require__(1655);
__webpack_require__(1665);
__webpack_require__(1664);
__webpack_require__(1660);
__webpack_require__(1661);
__webpack_require__(1659);
__webpack_require__(1651);
__webpack_require__(1662);
__webpack_require__(1666);
__webpack_require__(409);

module.exports = __webpack_require__(148).Object;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(409);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(1667);
module.exports = __webpack_require__(148).Promise;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(409);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(1668);
module.exports = __webpack_require__(148).Set;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(315);
__webpack_require__(226);
module.exports = __webpack_require__(1620);

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(45);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) {
  // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1624);
module.exports = __webpack_require__(45).Object.entries;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1621);
module.exports = __webpack_require__(45).Object.getPrototypeOf;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1622);
module.exports = __webpack_require__(45).Object.keys;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1625);
module.exports = __webpack_require__(45).Object.values;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(402);
__webpack_require__(226);
__webpack_require__(315);
__webpack_require__(1623);
__webpack_require__(1626);
__webpack_require__(1627);
module.exports = __webpack_require__(45).Promise;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1628);
module.exports = __webpack_require__(45).setImmediate;

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(146);
var call = __webpack_require__(399);
var isArrayIter = __webpack_require__(398);
var anObject = __webpack_require__(86);
var toLength = __webpack_require__(271);
var getIterFn = __webpack_require__(314);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(64);
var macrotask = __webpack_require__(571).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(159)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(101);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
  }return target;
};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(64);
var core = __webpack_require__(45);
var dP = __webpack_require__(79);
var DESCRIPTORS = __webpack_require__(87);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(86);
var get = __webpack_require__(314);
module.exports = __webpack_require__(45).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(160);
var $getPrototypeOf = __webpack_require__(401);

__webpack_require__(861)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(160);
var $keys = __webpack_require__(109);

__webpack_require__(861)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(190);
var global = __webpack_require__(64);
var ctx = __webpack_require__(146);
var classof = __webpack_require__(396);
var $export = __webpack_require__(63);
var isObject = __webpack_require__(125);
var aFunction = __webpack_require__(269);
var anInstance = __webpack_require__(1614);
var forOf = __webpack_require__(1615);
var speciesConstructor = __webpack_require__(865);
var task = __webpack_require__(571).set;
var microtask = __webpack_require__(1617)();
var newPromiseCapabilityModule = __webpack_require__(565);
var perform = __webpack_require__(863);
var promiseResolve = __webpack_require__(864);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) {/* empty */}
}();

// helpers
var sameConstructor = LIBRARY ? function (a, b) {
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
} : function (a, b) {
  return a === b;
};
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  }return true;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(1618)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return sameConstructor($Promise, C) ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(191)($Promise, PROMISE);
__webpack_require__(1619)(PROMISE);
Wrapper = __webpack_require__(45)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
    return promiseResolve(this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(400)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(63);
var $entries = __webpack_require__(862)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(63);
var $values = __webpack_require__(862)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally


var $export = __webpack_require__(63);
var core = __webpack_require__(45);
var global = __webpack_require__(64);
var speciesConstructor = __webpack_require__(865);
var promiseResolve = __webpack_require__(864);

$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  } });

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try

var $export = __webpack_require__(63);
var newPromiseCapability = __webpack_require__(565);
var perform = __webpack_require__(863);

$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(63);
var $task = __webpack_require__(571);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(96)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(228)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(194);
var toLength = __webpack_require__(882);
var toAbsoluteIndex = __webpack_require__(1646);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(229);
var gOPS = __webpack_require__(590);
var pIE = __webpack_require__(406);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95);
var setPrototypeOf = __webpack_require__(879).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }return that;
};

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(317);
var ITERATOR = __webpack_require__(96)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(316);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(192);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(405);
var descriptor = __webpack_require__(407);
var setToStringTag = __webpack_require__(318);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(228)(IteratorPrototype, __webpack_require__(96)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(229);
var toIObject = __webpack_require__(194);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) {
    if (O[key = keys[index++]] === el) return key;
  }
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var macrotask = __webpack_require__(881).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(316)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var getKeys = __webpack_require__(229);
var gOPS = __webpack_require__(590);
var pIE = __webpack_require__(406);
var toObject = __webpack_require__(408);
var IObject = __webpack_require__(870);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(227)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var newPromiseCapability = __webpack_require__(873);

module.exports = function (C, x) {
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(192);
var aFunction = __webpack_require__(403);
var SPECIES = __webpack_require__(96)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(594);
var defined = __webpack_require__(584);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(594);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(102);
var core = __webpack_require__(148);
var LIBRARY = __webpack_require__(404);
var wksExt = __webpack_require__(883);
var defineProperty = __webpack_require__(162).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(583);
var ITERATOR = __webpack_require__(96)('iterator');
var Iterators = __webpack_require__(317);
module.exports = __webpack_require__(148).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(1629);
var step = __webpack_require__(872);
var Iterators = __webpack_require__(317);
var toIObject = __webpack_require__(194);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(588)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(866);
var validate = __webpack_require__(596);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(867)(MAP, function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(130);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1640) });

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(130);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(405) });

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(130);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(149), 'Object', { defineProperties: __webpack_require__(874) });

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(130);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(149), 'Object', { defineProperty: __webpack_require__(162).f });

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(95);
var meta = __webpack_require__(273).onFreeze;

__webpack_require__(150)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(194);
var $getOwnPropertyDescriptor = __webpack_require__(589).f;

__webpack_require__(150)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(150)('getOwnPropertyNames', function () {
  return __webpack_require__(875).f;
});

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(408);
var $getPrototypeOf = __webpack_require__(877);

__webpack_require__(150)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(95);

__webpack_require__(150)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(95);

__webpack_require__(150)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(95);

__webpack_require__(150)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(130);
$export($export.S, 'Object', { is: __webpack_require__(1643) });

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(408);
var $keys = __webpack_require__(229);

__webpack_require__(150)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(95);
var meta = __webpack_require__(273).onFreeze;

__webpack_require__(150)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(95);
var meta = __webpack_require__(273).onFreeze;

__webpack_require__(150)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(130);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(879).set });

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(404);
var global = __webpack_require__(102);
var ctx = __webpack_require__(272);
var classof = __webpack_require__(583);
var $export = __webpack_require__(130);
var isObject = __webpack_require__(95);
var aFunction = __webpack_require__(403);
var anInstance = __webpack_require__(582);
var forOf = __webpack_require__(587);
var speciesConstructor = __webpack_require__(1644);
var task = __webpack_require__(881).set;
var microtask = __webpack_require__(1639)();
var newPromiseCapabilityModule = __webpack_require__(873);
var perform = __webpack_require__(1641);
var promiseResolve = __webpack_require__(1642);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(96)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) {/* empty */}
}();

// helpers
var sameConstructor = LIBRARY ? function (a, b) {
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
} : function (a, b) {
  return a === b;
};
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  }return true;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(591)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return sameConstructor($Promise, C) ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(318)($Promise, PROMISE);
__webpack_require__(880)(PROMISE);
Wrapper = __webpack_require__(148)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
    return promiseResolve(this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(871)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(866);
var validate = __webpack_require__(596);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(867)(SET, function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(102);
var has = __webpack_require__(193);
var DESCRIPTORS = __webpack_require__(149);
var $export = __webpack_require__(130);
var redefine = __webpack_require__(230);
var META = __webpack_require__(273).KEY;
var $fails = __webpack_require__(227);
var shared = __webpack_require__(593);
var setToStringTag = __webpack_require__(318);
var uid = __webpack_require__(319);
var wks = __webpack_require__(96);
var wksExt = __webpack_require__(883);
var wksDefine = __webpack_require__(1647);
var keyOf = __webpack_require__(1638);
var enumKeys = __webpack_require__(1631);
var isArray = __webpack_require__(1635);
var anObject = __webpack_require__(192);
var toIObject = __webpack_require__(194);
var toPrimitive = __webpack_require__(595);
var createDesc = __webpack_require__(407);
var _create = __webpack_require__(405);
var gOPNExt = __webpack_require__(875);
var $GOPD = __webpack_require__(589);
var $DP = __webpack_require__(162);
var $keys = __webpack_require__(229);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(876).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(406).f = $propertyIsEnumerable;
  __webpack_require__(590).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(404)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(228)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(811);
var regions = __webpack_require__(884);
var continents = {};

continents.asia = {
  name: 'Asia',
  regions: ['centralAsia', 'southernAsia', 'southeastAsia', 'eastAsia', 'westernAsia'],
  countries: _.flatten([regions.centralAsia.countries, regions.southernAsia.countries, regions.southeastAsia.countries, regions.eastAsia.countries, regions.westernAsia.countries]).sort()
};

continents.africa = {
  name: 'Africa',
  regions: ['centralAfrica', 'northAfrica', 'southernAfrica', 'eastAfrica', 'westAfrica'],
  countries: _.flatten([regions.centralAfrica.countries, regions.northAfrica.countries, regions.southernAfrica.countries, regions.eastAfrica.countries, regions.westAfrica.countries]).sort()
};

continents.northAmerica = {
  name: 'North America',
  regions: ['centralAmerica', 'northernAmerica', 'caribbean'],
  countries: _.flatten([regions.centralAmerica.countries, regions.northernAmerica.countries, regions.caribbean.countries]).sort()
};

continents.southAmerica = {
  name: 'South America',
  regions: ['southAmerica'],
  countries: _.flatten([regions.southAmerica.countries]).sort()
};

continents.antartica = {
  name: 'Antartica',
  regions: ['antartica'],
  countries: _.flatten([regions.antartica.countries]).sort()
};

continents.europe = {
  name: 'Europe',
  regions: ['northernEurope', 'southernEurope', 'easternEurope', 'westernEurope'],
  countries: _.flatten([regions.northernEurope.countries, regions.southernEurope.countries, regions.easternEurope.countries, regions.westernEurope.countries]).sort()
};

continents.oceania = {
  name: 'Oceania',
  regions: ['australia', 'melanesia', 'micronesia', 'polynesia'],
  countries: _.flatten([regions.australia.countries, regions.melanesia.countries, regions.micronesia.countries, regions.polynesia.countries]).sort()
};

module.exports = continents;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(811);
var continents = __webpack_require__(1670);
var regions = __webpack_require__(884);
var countriesAll = __webpack_require__(3528);
var currenciesAll = __webpack_require__(3529);
var languagesAll = __webpack_require__(3530);
var lookup = __webpack_require__(1672);

var getSymbol = __webpack_require__(1677);

exports.continents = continents;
exports.regions = regions;

exports.countries = {
  all: countriesAll
};

_.each(countriesAll, function (country) {
  // prefer assigned country codes over inactive ones
  var exportedAlpha2 = exports.countries[country.alpha2];
  if (!exportedAlpha2 || exportedAlpha2.status === 'deleted') {
    exports.countries[country.alpha2] = country;
  }

  var exportedAlpha3 = exports.countries[country.alpha3];
  if (!exportedAlpha3 || exportedAlpha3.status === 'deleted') {
    exports.countries[country.alpha3] = country;
  }
});

exports.currencies = {
  all: currenciesAll
};

_.each(currenciesAll, function (currency) {
  //If the symbol isn't available, default to the currency code
  var symbol = getSymbol(currency.code);
  if (symbol == '?') {
    symbol = currency.code;
  }

  currency.symbol = symbol;
  exports.currencies[currency.code] = currency;
});

exports.languages = {
  all: languagesAll
};

// Note that for the languages there are several entries with the same alpha3 -
// eg Dutch and Flemish. Not sure how to best deal with that - here whichever
// comes last wins.
_.each(languagesAll, function (language) {
  exports.languages[language.alpha2] = language;
  exports.languages[language.bibliographic] = language;
  exports.languages[language.alpha3] = language;
});

exports.lookup = lookup({
  countries: countriesAll,
  currencies: currenciesAll,
  languages: languagesAll
});

var callingCountries = { all: [] };

var callingCodesAll = _.reduce(countriesAll, function (codes, country) {
  if (country.countryCallingCodes && country.countryCallingCodes.length) {
    callingCountries.all.push(country);

    callingCountries[country.alpha2] = country;
    callingCountries[country.alpha3] = country;

    _.each(country.countryCallingCodes, function (code) {
      if (codes.indexOf(code) == -1) {
        codes.push(code);
      }
    });
  }
  return codes;
}, []);

delete callingCountries['']; // remove empty alpha3s
exports.callingCountries = callingCountries;

callingCodesAll.sort(function (a, b) {
  var parse = function parse(str) {
    return parseInt(str);
  };
  var splitA = _.map(a.split(' '), parse);
  var splitB = _.map(b.split(' '), parse);

  if (splitA[0] < splitB[0]) {
    return -1;
  } else if (splitA[0] > splitB[0]) {
    return 1;
  } else {
    // Same - check split[1]
    if (splitA[1] === undefined && splitB[1] !== undefined) {
      return -1;
    } else if (splitA[1] !== undefined && splitB[1] === undefined) {
      return 1;
    } else if (splitA[1] < splitB[1]) {
      return -1;
    } else if (splitA[1] > splitB[1]) {
      return 1;
    } else {
      return 0;
    }
  }
});

exports.callingCodes = {
  all: callingCodesAll
};

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(811);

module.exports = init;

function init(o) {
  return {
    countries: search.bind(null, o.countries),
    currencies: search.bind(null, o.currencies),
    languages: search.bind(null, o.languages)
  };
}

function search(data, query) {
  var q = _.pairs(query);

  return data.filter(function (d) {
    return q.filter(function (v) {
      var prop = d[v[0]];

      if (_.isArray(prop)) return prop.indexOf(v[1]) >= 0;

      return prop == v[1];
    }).length == q.length;
  });
}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(169);

var emptyObject = __webpack_require__(1868);
var _invariant = __webpack_require__(132);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function displayName(Constructor, _displayName) {
      Constructor.displayName = _displayName;
    },
    mixins: function mixins(Constructor, _mixins) {
      if (_mixins) {
        for (var i = 0; i < _mixins.length; i++) {
          mixSpecIntoComponent(Constructor, _mixins[i]);
        }
      }
    },
    childContextTypes: function childContextTypes(Constructor, _childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, _childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes);
    },
    contextTypes: function contextTypes(Constructor, _contextTypes) {
      if (false) {
        validateTypeDef(Constructor, _contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
      } else {
        Constructor.getDefaultProps = _getDefaultProps;
      }
    },
    propTypes: function propTypes(Constructor, _propTypes) {
      if (false) {
        validateTypeDef(Constructor, _propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes);
    },
    statics: function statics(Constructor, _statics) {
      mixStaticSpecIntoComponent(Constructor, _statics);
    },
    autobind: function autobind() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec === 'undefined' ? 'undefined' : _typeof(spec);
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
        }
      }

      return;
    }

    _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isInherited = name in Constructor;
      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && (typeof one === 'undefined' ? 'undefined' : _typeof(one)) === 'object' && (typeof two === 'undefined' ? 'undefined' : _typeof(two)) === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function componentDidMount() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function componentWillUnmount() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function replaceState(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function isMounted() {
      if (false) {
        warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function ReactClassComponent() {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
      warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(2026);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1676);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);

  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1674);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = mapSymbol;

var map = __webpack_require__(1678);

function mapSymbol(currencyCode) {
  if (map.hasOwnProperty(currencyCode)) {
    return map[currencyCode];
  } else {
    return '?';
  }
}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports = { "ALL": "L",
  "AFN": "؋",
  "ARS": "$",
  "AWG": "ƒ",
  "AUD": "$",
  "AZN": "₼",
  "BSD": "$",
  "BBD": "$",
  "BYR": "p.",
  "BZD": "BZ$",
  "BMD": "$",
  "BOB": "Bs.",
  "BAM": "KM",
  "BWP": "P",
  "BGN": "лв",
  "BRL": "R$",
  "BND": "$",
  "KHR": "៛",
  "CAD": "$",
  "KYD": "$",
  "CLP": "$",
  "CNY": "¥",
  "COP": "$",
  "CRC": "₡",
  "HRK": "kn",
  "CUP": "₱",
  "CZK": "Kč",
  "DKK": "kr",
  "DOP": "RD$",
  "XCD": "$",
  "EGP": "£",
  "SVC": "$",
  "EEK": "kr",
  "EUR": "€",
  "FKP": "£",
  "FJD": "$",
  "GHC": "¢",
  "GIP": "£",
  "GTQ": "Q",
  "GGP": "£",
  "GYD": "$",
  "HNL": "L",
  "HKD": "$",
  "HUF": "Ft",
  "ISK": "kr",
  "INR": "₹",
  "IDR": "Rp",
  "IRR": "﷼",
  "IMP": "£",
  "ILS": "₪",
  "JMD": "J$",
  "JPY": "¥",
  "JEP": "£",
  "KES": "KSh",
  "KZT": "лв",
  "KPW": "₩",
  "KRW": "₩",
  "KGS": "лв",
  "LAK": "₭",
  "LVL": "Ls",
  "LBP": "£",
  "LRD": "$",
  "LTL": "Lt",
  "MKD": "ден",
  "MYR": "RM",
  "MUR": "₨",
  "MXN": "$",
  "MNT": "₮",
  "MZN": "MT",
  "NAD": "$",
  "NPR": "₨",
  "ANG": "ƒ",
  "NZD": "$",
  "NIO": "C$",
  "NGN": "₦",
  "NOK": "kr",
  "OMR": "﷼",
  "PKR": "₨",
  "PAB": "B/.",
  "PYG": "Gs",
  "PEN": "S/.",
  "PHP": "₱",
  "PLN": "zł",
  "QAR": "﷼",
  "RON": "lei",
  "RUB": "₽",
  "SHP": "£",
  "SAR": "﷼",
  "RSD": "Дин.",
  "SCR": "₨",
  "SGD": "$",
  "SBD": "$",
  "SOS": "S",
  "ZAR": "R",
  "LKR": "₨",
  "SEK": "kr",
  "CHF": "CHF",
  "SRD": "$",
  "SYP": "£",
  "TZS": "TSh",
  "TWD": "NT$",
  "THB": "฿",
  "TTD": "TT$",
  "TRY": "",
  "TRL": "₤",
  "TVD": "$",
  "UGX": "USh",
  "UAH": "₴",
  "GBP": "£",
  "USD": "$",
  "UYU": "$U",
  "UZS": "лв",
  "VEF": "Bs",
  "VND": "₫",
  "YER": "﷼",
  "ZWD": "Z$"
};

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(891);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(893);









/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["a" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) {
      tz.shift(), --m;
    }while (tz[m - 1] > x1) {
      tz.pop(), --m;
    }var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function (_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function (_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x;
});

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  } else {
    while (++i < n) {
      // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) {
          // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(320);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;else --m;
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;else --m;
    }
  }

  if (m) return sum / m;
});

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(599);




/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  } else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) {
    j += arrays[i].length;
  }merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, indexes) {
  var i = indexes.length,
      permutes = new Array(i);
  while (i--) {
    permutes[i] = array[indexes[i]];
  }return permutes;
});

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(275);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  } else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(599);





/* unused harmony default export */ var _unused_webpack_default_export = (function (values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(888);


/* unused harmony default export */ var _unused_webpack_default_export = (function (values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(895);


/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var entries = [];
  for (var key in map) {
    entries.push({ key: key, value: map[key] });
  }return entries;
});

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(1698);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(1699);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(600);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(1697);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(1700);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(1695);
/* unused harmony reexport entries */







/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var keys = [];
  for (var key in map) {
    keys.push(key);
  }return keys;
});

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(600);


/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var keys = [],
      _sortKeys = [],
      _sortValues,
      _rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (_sortValues != null) array.sort(_sortValues);
      return _rollup != null ? _rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function (values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function _entries(map, depth) {
    if (++depth > keys.length) return map;
    var array,
        sortKey = _sortKeys[depth - 1];
    if (_rollup != null && depth >= keys.length) array = map.entries();else array = [], map.each(function (v, k) {
      array.push({ key: k, values: _entries(v, depth) });
    });
    return sortKey != null ? array.sort(function (a, b) {
      return sortKey(a.key, b.key);
    }) : array;
  }

  return nest = {
    object: function object(array) {
      return apply(array, 0, createObject, setObject);
    },
    map: function map(array) {
      return apply(array, 0, createMap, setMap);
    },
    entries: function entries(array) {
      return _entries(apply(array, 0, createMap, setMap), 0);
    },
    key: function key(d) {
      keys.push(d);return nest;
    },
    sortKeys: function sortKeys(order) {
      _sortKeys[keys.length - 1] = order;return nest;
    },
    sortValues: function sortValues(order) {
      _sortValues = order;return nest;
    },
    rollup: function rollup(f) {
      _rollup = f;return nest;
    }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(600);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function add(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set();

  // Copy constructor.
  if (object instanceof Set) object.each(function (value) {
    set.add(value);
  });

  // Otherwise, assume it’s an array.
  else if (object) {
      var i = -1,
          n = object.length;
      if (f == null) while (++i < n) {
        set.add(object[i]);
      } else while (++i < n) {
        set.add(f(object[i], i, object));
      }
    }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (map) {
  var values = [];
  for (var key in map) {
    values.push(map[key]);
  }return values;
});

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(897);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
      // NaN if l=0 or l=1
  h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function brighter(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }
}));

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = gray;
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["c"] = lch;
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(897);




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
      x,
      z;
  if (r === g && g === b) x = z = y;else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function brighter(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function darker(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function rgb() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function brighter(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function darker(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function rgb() {
    return labConvert(this).rgb();
  }
}));

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(900);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (grouping, thousands) {
  return function (value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
});

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(603);


/* harmony default export */ __webpack_exports__["a"] = (function (x, p) {
    var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
    if (!d) return x + "";
    var coefficient = d[0],
        exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function (s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;break;
      case "0":
        if (i0 === 0) i0 = i;i1 = i;break;
      default:
        if (i0 > 0) {
          if (!+s[i]) break out;i0 = 0;
        }break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatRounded__ = __webpack_require__(1706);



/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function _(x, p) {
    return (x * 100).toFixed(p);
  },
  "b": function b(x) {
    return Math.round(x).toString(2);
  },
  "c": function c(x) {
    return x + "";
  },
  "d": function d(x) {
    return Math.round(x).toString(10);
  },
  "e": function e(x, p) {
    return x.toExponential(p);
  },
  "f": function f(x, p) {
    return x.toFixed(p);
  },
  "g": function g(x, p) {
    return x.toPrecision(p);
  },
  "o": function o(x) {
    return Math.round(x).toString(8);
  },
  "p": function p(x, _p) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */])(x * 100, _p);
  },
  "r": __WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__["b" /* default */],
  "X": function X(x) {
    return Math.round(x).toString(16).toUpperCase();
  },
  "x": function x(_x) {
    return Math.round(_x).toString(16);
  }
});

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return x;
});

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(410);


/* harmony default export */ __webpack_exports__["a"] = (function (step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(410);


/* harmony default export */ __webpack_exports__["a"] = (function (step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(410);


/* harmony default export */ __webpack_exports__["a"] = (function (step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) {
    node = children[0];
  }return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) {
    node = children[children.length - 1];
  }return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function (node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function (node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function (node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function (x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
  };

  cluster.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
  };

  return cluster;
});

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var node = this,
      nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;else while (--i >= 0) {
    sum += children[i].value;
  }node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return this.eachAfter(count);
});

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var nodes = [];
  this.each(function (node) {
    nodes.push(node);
  });
  return nodes;
});

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
  var node = this,
      current,
      next = [node],
      children,
      i,
      n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
  var node = this,
      nodes = [node],
      next = [],
      children,
      i,
      n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
  var node = this,
      nodes = [node],
      children,
      i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var leaves = [];
  this.eachBefore(function (node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var root = this,
      links = [];
  root.each(function (node) {
    if (node !== root) {
      // Don’t include the root’s parent, if any.
      links.push({ source: node.parent, target: node });
    }
  });
  return links;
});

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (compare) {
  return this.eachBefore(function (node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return this.eachAfter(function (node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) {
      sum += children[i].value;
    }node.value = sum;
  });
});

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cluster__ = __webpack_require__(1714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cluster", function() { return __WEBPACK_IMPORTED_MODULE_0__cluster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hierarchy", function() { return __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pack_index__ = __webpack_require__(1727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pack", function() { return __WEBPACK_IMPORTED_MODULE_2__pack_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_siblings__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packSiblings", function() { return __WEBPACK_IMPORTED_MODULE_3__pack_siblings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_enclose__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "packEnclose", function() { return __WEBPACK_IMPORTED_MODULE_4__pack_enclose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partition__ = __webpack_require__(1728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_5__partition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stratify__ = __webpack_require__(1729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stratify", function() { return __WEBPACK_IMPORTED_MODULE_6__stratify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree__ = __webpack_require__(1730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tree", function() { return __WEBPACK_IMPORTED_MODULE_7__tree__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treemap_index__ = __webpack_require__(1732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemap", function() { return __WEBPACK_IMPORTED_MODULE_8__treemap_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treemap_binary__ = __webpack_require__(1731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapBinary", function() { return __WEBPACK_IMPORTED_MODULE_9__treemap_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treemap_dice__ = __webpack_require__(322);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapDice", function() { return __WEBPACK_IMPORTED_MODULE_10__treemap_dice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__treemap_slice__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSlice", function() { return __WEBPACK_IMPORTED_MODULE_11__treemap_slice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice__ = __webpack_require__(1734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function() { return __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__treemap_squarify__ = __webpack_require__(606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapSquarify", function() { return __WEBPACK_IMPORTED_MODULE_13__treemap_squarify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify__ = __webpack_require__(1733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "treemapResquarify", function() { return __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify__["a"]; });
















/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(901);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* constantZero */], 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function (x) {
    return arguments.length ? (radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__accessors__["b" /* optional */])(x), pack) : radius;
  };

  pack.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function (x) {
    return arguments.length ? (padding = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function (node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function (node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) {
        children[i].r += r;
      }e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__siblings__["b" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) {
        children[i].r -= r;
      }node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function (node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice__ = __webpack_require__(322);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 = root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function (node) {
      if (node.children) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__treemap_dice__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function (x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function (x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__ = __webpack_require__(605);



var keyPrefix = "$",
    // Protect against keys like “__proto__”.
preroot = { depth: -1 },
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["b" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function (node) {
      node.depth = node.parent.depth + 1;--n;
    }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index__["c" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function (x) {
    return arguments.length ? (id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function (x) {
    return arguments.length ? (parentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__accessors__["a" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index__ = __webpack_require__(605);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index__["b" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
        var left = root,
            right = root,
            bottom = root;
        root.eachBefore(function (node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var s = left === right ? 1 : separation(left, right) / 2,
            tx = s - left.x,
            kx = dx / (right.x + s + tx),
            ky = dy / (bottom.depth || 1);
        root.eachBefore(function (node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function (x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
  };

  tree.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
  };

  return tree;
});

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i,
      n = nodes.length,
      sum,
      sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = value / 2 + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;else hi = mid;
    }

    if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if (x1 - x0 > y1 - y0) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(901);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* constantZero */];

  function treemap(root) {
    root.x0 = root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function (x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function (x) {
    return arguments.length ? (tile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__accessors__["a" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function (x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function (x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function (x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function (x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function (x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function (x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function (x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify__ = __webpack_require__(606);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && rows.ratio === ratio) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) {
          row.value += nodes[i].value;
        }if (row.dice) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__squarify__["b" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify__["c" /* phi */]));

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice__ = __webpack_require__(411);



/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice__["a" /* default */])(parent, x0, y0, x1, y1);
});

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(276);



function cubehelix(hue) {
  return function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  }(1);
}

/* harmony default export */ __webpack_exports__["a"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(276);



function hcl(hue) {
  return function (start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hcl"])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(276);



function hsl(hue) {
  return function (start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["hsl"])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(276);


/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__color__["b" /* hue */])(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(276);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["lab"])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function (t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0,
      n = values.length - 1,
      v = values[0],
      I = new Array(n < 0 ? 0 : n);
  while (i < n) {
    I[i] = interpolate(v, v = values[++i]);
  }return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) {
    samples[i] = interpolator(i / (n - 1));
  }return samples;
});

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a = +a, b -= a, function (t) {
    return Math.round(a + b * t);
  };
});

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function (a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1746);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({ i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb) }, { i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb) });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path
      q.push({ i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b) });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({ i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b) });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({ i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb) }, { i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function (a, b) {
    var s = [],
        // string constants and placeholders
    q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function (t) {
      var i = -1,
          n = q.length,
          o;
      while (++i < n) {
        s[(o = q[i]).i] = o.x(t);
      }return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1744);


var cssNode, cssRoot, cssView, svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function (p0, p1) {
  var ux0 = p0[0],
      uy0 = p0[1],
      w0 = p0[2],
      ux1 = p1[0],
      uy1 = p1[1],
      w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function i(t) {
      return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
    };
  }

  // General case.
  else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function i(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }

  i.duration = S * 1000;

  return i;
});

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path();
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function moveTo(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function lineTo(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
    this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) ;

      // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
      // Equivalently, is (x1,y1) coincident with (x2,y2)?
      // Or, is the radius zero? Line to (x1,y1).
      else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
          this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        }

        // Otherwise, draw an arc!
        else {
            var x20 = x2 - x0,
                y20 = y2 - y0,
                l21_2 = x21 * x21 + y21 * y21,
                l20_2 = x20 * x20 + y20 * y20,
                l21 = Math.sqrt(l21_2),
                l01 = Math.sqrt(l01_2),
                l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
                t01 = l / l01,
                t21 = l / l21;

            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) {
              this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            }

            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
          }
  },
  arc: function arc(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
        this._ += "L" + x0 + "," + y0;
      }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
        this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
      }
  },
  rect: function rect(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
  },
  toString: function toString() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"));

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"));

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"));

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"));

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"));

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"));

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"));

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"));

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__categorical_category10__ = __webpack_require__(1757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_0__categorical_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categorical_Accent__ = __webpack_require__(1749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeAccent", function() { return __WEBPACK_IMPORTED_MODULE_1__categorical_Accent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__categorical_Dark2__ = __webpack_require__(1750);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeDark2", function() { return __WEBPACK_IMPORTED_MODULE_2__categorical_Dark2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categorical_Paired__ = __webpack_require__(1751);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePaired", function() { return __WEBPACK_IMPORTED_MODULE_3__categorical_Paired__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categorical_Pastel1__ = __webpack_require__(1752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePastel1", function() { return __WEBPACK_IMPORTED_MODULE_4__categorical_Pastel1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__categorical_Pastel2__ = __webpack_require__(1753);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePastel2", function() { return __WEBPACK_IMPORTED_MODULE_5__categorical_Pastel2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categorical_Set1__ = __webpack_require__(1754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeSet1", function() { return __WEBPACK_IMPORTED_MODULE_6__categorical_Set1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__categorical_Set2__ = __webpack_require__(1755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeSet2", function() { return __WEBPACK_IMPORTED_MODULE_7__categorical_Set2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__categorical_Set3__ = __webpack_require__(1756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeSet3", function() { return __WEBPACK_IMPORTED_MODULE_8__categorical_Set3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__ = __webpack_require__(1758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBrBG", function() { return __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeBrBG", function() { return __WEBPACK_IMPORTED_MODULE_9__diverging_BrBG__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__ = __webpack_require__(1759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePRGn", function() { return __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePRGn", function() { return __WEBPACK_IMPORTED_MODULE_10__diverging_PRGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__ = __webpack_require__(1760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePiYG", function() { return __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePiYG", function() { return __WEBPACK_IMPORTED_MODULE_11__diverging_PiYG__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__ = __webpack_require__(1761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePuOr", function() { return __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePuOr", function() { return __WEBPACK_IMPORTED_MODULE_12__diverging_PuOr__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__ = __webpack_require__(1762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRdBu", function() { return __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeRdBu", function() { return __WEBPACK_IMPORTED_MODULE_13__diverging_RdBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__ = __webpack_require__(1763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRdGy", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeRdGy", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging_RdGy__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__ = __webpack_require__(1764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRdYlBu", function() { return __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeRdYlBu", function() { return __WEBPACK_IMPORTED_MODULE_15__diverging_RdYlBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__ = __webpack_require__(1765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRdYlGn", function() { return __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeRdYlGn", function() { return __WEBPACK_IMPORTED_MODULE_16__diverging_RdYlGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__ = __webpack_require__(1766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateSpectral", function() { return __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeSpectral", function() { return __WEBPACK_IMPORTED_MODULE_17__diverging_Spectral__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__ = __webpack_require__(1768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBuGn", function() { return __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeBuGn", function() { return __WEBPACK_IMPORTED_MODULE_18__sequential_multi_BuGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__ = __webpack_require__(1769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBuPu", function() { return __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeBuPu", function() { return __WEBPACK_IMPORTED_MODULE_19__sequential_multi_BuPu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__ = __webpack_require__(1770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateGnBu", function() { return __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeGnBu", function() { return __WEBPACK_IMPORTED_MODULE_20__sequential_multi_GnBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__ = __webpack_require__(1771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateOrRd", function() { return __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeOrRd", function() { return __WEBPACK_IMPORTED_MODULE_21__sequential_multi_OrRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__ = __webpack_require__(1773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePuBuGn", function() { return __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePuBuGn", function() { return __WEBPACK_IMPORTED_MODULE_22__sequential_multi_PuBuGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__ = __webpack_require__(1772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePuBu", function() { return __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePuBu", function() { return __WEBPACK_IMPORTED_MODULE_23__sequential_multi_PuBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__ = __webpack_require__(1774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePuRd", function() { return __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePuRd", function() { return __WEBPACK_IMPORTED_MODULE_24__sequential_multi_PuRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__ = __webpack_require__(1775);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRdPu", function() { return __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeRdPu", function() { return __WEBPACK_IMPORTED_MODULE_25__sequential_multi_RdPu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__ = __webpack_require__(1777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateYlGnBu", function() { return __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeYlGnBu", function() { return __WEBPACK_IMPORTED_MODULE_26__sequential_multi_YlGnBu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__ = __webpack_require__(1776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateYlGn", function() { return __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeYlGn", function() { return __WEBPACK_IMPORTED_MODULE_27__sequential_multi_YlGn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__ = __webpack_require__(1778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateYlOrBr", function() { return __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeYlOrBr", function() { return __WEBPACK_IMPORTED_MODULE_28__sequential_multi_YlOrBr__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__ = __webpack_require__(1779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateYlOrRd", function() { return __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeYlOrRd", function() { return __WEBPACK_IMPORTED_MODULE_29__sequential_multi_YlOrRd__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__ = __webpack_require__(1784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBlues", function() { return __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeBlues", function() { return __WEBPACK_IMPORTED_MODULE_30__sequential_single_Blues__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__ = __webpack_require__(1785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateGreens", function() { return __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeGreens", function() { return __WEBPACK_IMPORTED_MODULE_31__sequential_single_Greens__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__ = __webpack_require__(1786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateGreys", function() { return __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeGreys", function() { return __WEBPACK_IMPORTED_MODULE_32__sequential_single_Greys__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__ = __webpack_require__(1788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePurples", function() { return __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemePurples", function() { return __WEBPACK_IMPORTED_MODULE_33__sequential_single_Purples__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__ = __webpack_require__(1789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateReds", function() { return __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeReds", function() { return __WEBPACK_IMPORTED_MODULE_34__sequential_single_Reds__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__ = __webpack_require__(1787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateOranges", function() { return __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeOranges", function() { return __WEBPACK_IMPORTED_MODULE_35__sequential_single_Oranges__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sequential_multi_cubehelix__ = __webpack_require__(1780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_36__sequential_multi_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__ = __webpack_require__(1781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_37__sequential_multi_rainbow__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sequential_multi_sinebow__ = __webpack_require__(1782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateSinebow", function() { return __WEBPACK_IMPORTED_MODULE_38__sequential_multi_sinebow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__ = __webpack_require__(1783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_39__sequential_multi_viridis__["d"]; });









































/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(323);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-240, 0.5, 1.0)));

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(323);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])(80, 1.50, 0.8));

var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["cubehelix"])();

/* harmony default export */ __webpack_exports__["a"] = (function (t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c.h = 360 * t - 100;
  c.s = 1.5 - 1.5 * ts;
  c.l = 0.8 - 0.9 * ts;
  return c + "";
});

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(152);


var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["rgb"])(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

/* harmony default export */ __webpack_exports__["a"] = (function (t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c.r = 255 * (x = Math.sin(t)) * x;
  c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c + "";
});

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);


function ramp(range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ramp__ = __webpack_require__(52);



var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ramp__["a" /* default */])(scheme));

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ordinal__ = __webpack_require__(915);




function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n).map(function (i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function (_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function () {
    return bandwidth;
  };

  scale.step = function () {
    return step;
  };

  scale.round = function (_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function (_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function (_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function () {
    return band(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["b" /* initRange */].apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function () {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diverging;
/* harmony export (immutable) */ __webpack_exports__["b"] = divergingLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = divergingSymlog;
/* harmony export (immutable) */ __webpack_exports__["c"] = divergingPow;
/* harmony export (immutable) */ __webpack_exports__["d"] = divergingSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sequential__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symlog__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(610);








function transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */],
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
    return scale;
  };
}

function diverging() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */]));

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, diverging());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingLog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([0.1, 1, 10]);

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSymlog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingPow() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pow__["c" /* powish */])(transformer());

  scale.copy = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(914);




function identity(domain) {
  var unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return identity(domain).unknown(unknown);
  };

  domain = arguments.length ? __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(domain, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]) : [0, 1];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0,
        n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) {
      thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* quantile */])(domain, i / n);
    }return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) {
      if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    }domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* ascending */]);
    return rescale();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function () {
    return thresholds.slice();
  };

  scale.copy = function () {
    return quantile().domain(domain).range(range).unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(103);





function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x <= x ? range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) {
      domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    }return scale;
  }

  scale.domain = function (_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function (_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function () {
    return domain.slice();
  };

  scale.copy = function () {
    return quantize().domain([x0, x1]).range(range).unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale), arguments);
}

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequentialQuantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




function sequentialQuantile() {
  var domain = [],
      interpolator = __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */];

  function scale(x) {
    if (!isNaN(x = +x)) return interpolator((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x) - 1) / (domain.length - 1));
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) {
      if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    }domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* ascending */]);
    return scale;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function () {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["a" /* initInterpolator */].apply(scale, arguments);
}

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(103);




function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x <= x ? range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  scale.domain = function (_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return threshold().domain(domain).range(range).unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(103);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["utcFormat"]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
});

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(325);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0,
      y10 = y1 - y0,
      x32 = x3 - x2,
      y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        da = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a0), r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a0));
        context.arc(0, 0, r1, a0, a1, !cw);
        if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
          context.moveTo(r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a1), r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a1));
          context.arc(0, 0, r0, a1, a0, cw);
        }
      }

      // Or is it a circular or annular sector?
      else {
          var a01 = a0,
              a11 = a1,
              a00 = a0,
              a10 = a1,
              da0 = da,
              da1 = da,
              ap = padAngle.apply(this, arguments) / 2,
              rp = ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] && (padRadius ? +padRadius.apply(this, arguments) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(r0 * r0 + r1 * r1)),
              rc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
              rc0 = rc,
              rc1 = rc,
              t0,
              t1;

          // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
          if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
            var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap)),
                p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap));
            if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
            if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
          }

          var x01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a01),
              y01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a01),
              x10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a10),
              y10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a10);

          // Apply rounded corners?
          if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
            var x11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a11),
                y11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a11),
                x00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a00),
                y00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a00),
                oc;

            // Restrict the corner radius according to the sector angle.
            if (da < __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
              var ax = x01 - oc[0],
                  ay = y01 - oc[1],
                  bx = x11 - oc[0],
                  by = y11 - oc[1],
                  kc = 1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* acos */])((ax * bx + ay * by) / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(ax * ax + ay * ay) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(bx * bx + by * by))) / 2),
                  lc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
              rc0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r0 - lc) / (kc - 1));
              rc1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r1 - lc) / (kc + 1));
            }
          }

          // Is the sector collapsed to a line?
          if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

          // Does the sector’s outer ring have rounded corners?
          else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
              t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
              t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

              context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

              // Have the corners merged?
              if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

              // Otherwise, draw the two corners and the ring.
              else {
                  context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
                  context.arc(0, 0, r1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                  context.arc(t1.cx, t1.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
                }
            }

            // Or is the outer ring just a circular arc?
            else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

          // Is there no inner ring, and it’s a circular sector?
          // Or perhaps it’s an annular sector collapsed due to padding?
          if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

          // Does the sector’s inner ring (or point) have rounded corners?
          else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
              t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
              t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

              context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

              // Have the corners merged?
              if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

              // Otherwise, draw the two corners and the ring.
              else {
                  context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
                  context.arc(0, 0, r0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                  context.arc(t1.cx, t1.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
                }
            }

            // Or is the inner ring just a circular arc?
            else context.arc(0, 0, r0, a10, a00, cw);
        }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function () {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] / 2;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a) * r, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a) * r];
  };

  arc.innerRadius = function (_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function (_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function (_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function (_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };

  return arc;
});

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(925);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0());
  }, delete a.lineX0;
  a.lineEndAngle = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1());
  }, delete a.lineX1;
  a.lineInnerRadius = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0());
  }, delete a.lineY0;
  a.lineOuterRadius = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1());
  }, delete a.lineY1;

  a.curve = function (_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(413);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x2, this._y2);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x2, this._y2);
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._x2 = x, this._y2 = y;break;
      case 1:
        this._point = 2;this._x3 = x, this._y3 = y;break;
      case 2:
        this._point = 3;this._x4 = x, this._y4 = y;this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);break;
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new BasisClosed(context);
});

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(413);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3;var x0 = (this._x0 + 4 * this._x1 + x) / 6,
            y0 = (this._y0 + 4 * this._y1 + y) / 6;this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);break;
      case 3:
        this._point = 4; // proceed
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y);break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new BasisOpen(context);
});

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(413);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["b" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function lineStart() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function lineEnd() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function point(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["b" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function (beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(612);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 2:
        {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function point(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;this._x3 = x, this._y3 = y;break;
      case 1:
        this._point = 2;this._context.moveTo(this._x4 = x, this._y4 = y);break;
      case 2:
        this._point = 3;this._x5 = x, this._y5 = y;break;
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y);break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["b" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(612);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3;this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);break;
      case 3:
        this._point = 4; // proceed
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y);break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["b" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(416);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (this._point) this._context.closePath();
  },
  point: function point(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new LinearClosed(context);
});

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function _point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);break;
      case 3:
        _point(this, this._t0, slope2(this, this._t0));break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function point(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2;break;
      case 2:
        this._point = 3;_point(this, slope2(this, t1 = slope3(this, x, y)), t1);break;
      default:
        _point(this, this._t0, t1 = slope3(this, x, y));break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function moveTo(x, y) {
    this._context.moveTo(y, x);
  },
  closePath: function closePath() {
    this._context.closePath();
  },
  lineTo: function lineTo(x, y) {
    this._context.lineTo(y, x);
  },
  bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
  }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function lineEnd() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function point(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) {
    a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  }a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) {
    m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  }a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) {
    a[i] = (r[i] - a[i + 1]) / b[i];
  }b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) {
    b[i] = 2 * x[i + 1] - a[i + 1];
  }return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new Natural(context);
});

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0:
        this._point = 1;this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);break;
      case 1:
        this._point = 2; // proceed
      default:
        {
          if (this._t <= 0) {
            this._context.lineTo(this._x, y);
            this._context.lineTo(x, y);
          } else {
            var x1 = this._x * (1 - this._t) + x * this._t;
            this._context.lineTo(x1, this._y);
            this._context.lineTo(x1, y);
          }
          break;
        }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (d) {
  return d;
});

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(927);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer,
        argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv);
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function (_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function (_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(326);


/* harmony default export */ __webpack_exports__["a"] = (function (series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) {
      y += series[i][j][1] || 0;
    }if (y) for (i = 0; i < n; ++i) {
      series[i][j][1] /= y;
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(326);


/* harmony default export */ __webpack_exports__["a"] = (function (series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) {
      y += series[i][j][1] || 0;
    }s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(326);


/* harmony default export */ __webpack_exports__["a"] = (function (series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(614);


/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appearance__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(614);



/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__appearance__["a" /* default */])(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(327);


/* harmony default export */ __webpack_exports__["a"] = (function (series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(325);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function (i, j) {
      return sortValues(arcs[i], arcs[j]);
    });else if (sort != null) index.sort(function (i, j) {
      return sort(data[i], data[j]);
    });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function (_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function (_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(327);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function (_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function (_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function (_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(233);










var symbols = [__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function (_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function (_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(616);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" /* isoSpecifier */]);

/* harmony default export */ __webpack_exports__["a"] = (parseIso);

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setDate(date.getDate() + step);
}, function (start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function (date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */] - date.getMinutes() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function (date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function (date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function () {
  // noop
}, function (date, step) {
  date.setTime(+date + step);
}, function (start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function (k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
    date.setTime(Math.floor(date / k) * k);
  }, function (date, step) {
    date.setTime(+date + step * k);
  }, function (start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function (date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function (date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setMonth(date.getMonth() + step);
}, function (start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function (date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setTime(date - date.getMilliseconds());
}, function (date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function (date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function (date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setUTCMinutes(0, 0, 0);
}, function (date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function (date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setUTCSeconds(0, 0);
}, function (date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function (start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function (date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function (start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function (date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function (start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function (start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function (date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(163);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function (start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(97);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function (start, end) {
  return end.getFullYear() - start.getFullYear();
}, function (date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function (date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

var MILI = 'milliseconds',
    SECONDS = 'seconds',
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
    DECADE = 'decade',
    CENTURY = 'century';

var dates = module.exports = {

  add: function add(date, num, unit) {
    date = new Date(date);

    switch (unit) {
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case YEAR:
        return dates[unit](date, dates[unit](date) + num);
      case DAY:
        return dates.date(date, dates.date(date) + num);
      case WEEK:
        return dates.date(date, dates.date(date) + 7 * num);
      case MONTH:
        return monthMath(date, num);
      case DECADE:
        return dates.year(date, dates.year(date) + num * 10);
      case CENTURY:
        return dates.year(date, dates.year(date) + num * 100);
    }

    throw new TypeError('Invalid units: "' + unit + '"');
  },

  subtract: function subtract(date, num, unit) {
    return dates.add(date, -num, unit);
  },

  startOf: function startOf(date, unit, firstOfWeek) {
    date = new Date(date);

    switch (unit) {
      case 'century':
      case 'decade':
      case 'year':
        date = dates.month(date, 0);
      case 'month':
        date = dates.date(date, 1);
      case 'week':
      case 'day':
        date = dates.hours(date, 0);
      case 'hours':
        date = dates.minutes(date, 0);
      case 'minutes':
        date = dates.seconds(date, 0);
      case 'seconds':
        date = dates.milliseconds(date, 0);
    }

    if (unit === DECADE) date = dates.subtract(date, dates.year(date) % 10, 'year');

    if (unit === CENTURY) date = dates.subtract(date, dates.year(date) % 100, 'year');

    if (unit === WEEK) date = dates.weekday(date, 0, firstOfWeek);

    return date;
  },

  endOf: function endOf(date, unit, firstOfWeek) {
    date = new Date(date);
    date = dates.startOf(date, unit, firstOfWeek);
    date = dates.add(date, 1, unit);
    date = dates.subtract(date, 1, MILI);
    return date;
  },

  eq: createComparer(function (a, b) {
    return a === b;
  }),
  neq: createComparer(function (a, b) {
    return a !== b;
  }),
  gt: createComparer(function (a, b) {
    return a > b;
  }),
  gte: createComparer(function (a, b) {
    return a >= b;
  }),
  lt: createComparer(function (a, b) {
    return a < b;
  }),
  lte: createComparer(function (a, b) {
    return a <= b;
  }),

  min: function min() {
    return new Date(Math.min.apply(Math, arguments));
  },

  max: function max() {
    return new Date(Math.max.apply(Math, arguments));
  },

  inRange: function inRange(day, min, max, unit) {
    unit = unit || 'day';

    return (!min || dates.gte(day, min, unit)) && (!max || dates.lte(day, max, unit));
  },

  milliseconds: createAccessor('Milliseconds'),
  seconds: createAccessor('Seconds'),
  minutes: createAccessor('Minutes'),
  hours: createAccessor('Hours'),
  day: createAccessor('Day'),
  date: createAccessor('Date'),
  month: createAccessor('Month'),
  year: createAccessor('FullYear'),

  decade: function decade(date, val) {
    return val === undefined ? dates.year(dates.startOf(date, DECADE)) : dates.add(date, val + 10, YEAR);
  },

  century: function century(date, val) {
    return val === undefined ? dates.year(dates.startOf(date, CENTURY)) : dates.add(date, val + 100, YEAR);
  },

  weekday: function weekday(date, val, firstDay) {
    var weekday = (dates.day(date) + 7 - (firstDay || 0)) % 7;

    return val === undefined ? weekday : dates.add(date, val - weekday, DAY);
  },

  diff: function diff(date1, date2, unit, asFloat) {
    var dividend, divisor, result;

    switch (unit) {
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case DAY:
      case WEEK:
        dividend = date2.getTime() - date1.getTime();break;
      case MONTH:
      case YEAR:
      case DECADE:
      case CENTURY:
        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1);break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    switch (unit) {
      case MILI:
        divisor = 1;break;
      case SECONDS:
        divisor = 1000;break;
      case MINUTES:
        divisor = 1000 * 60;break;
      case HOURS:
        divisor = 1000 * 60 * 60;break;
      case DAY:
        divisor = 1000 * 60 * 60 * 24;break;
      case WEEK:
        divisor = 1000 * 60 * 60 * 24 * 7;break;
      case MONTH:
        divisor = 1;break;
      case YEAR:
        divisor = 12;break;
      case DECADE:
        divisor = 120;break;
      case CENTURY:
        divisor = 1200;break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    result = dividend / divisor;

    return asFloat ? result : absoluteFloor(result);
  }
};

function absoluteFloor(number) {
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function monthMath(date, val) {
  var current = dates.month(date),
      newMonth = current + val;

  date = dates.month(date, newMonth);

  while (newMonth < 0) {
    newMonth = 12 + newMonth;
  } //month rollover
  if (dates.month(date) !== newMonth % 12) date = dates.date(date, 0); //move to last of month

  return date;
}

function createAccessor(method) {
  return function (date, val) {
    if (val === undefined) return date['get' + method]();

    date = new Date(date);
    date['set' + method](val);
    return date;
  };
}

function createComparer(operator) {
  return function (a, b, unit) {
    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit));
  };
}

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + (typeof encodedURI === 'undefined' ? 'undefined' : _typeof(encodedURI)) + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest(element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' && element.matches(selector)) {
            return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(1840);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function destroy() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    };
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function (e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    };
}

module.exports = delegate;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(937);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(939);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(938);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(619);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(620);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(941);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(940);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(1843);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(1845);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(941);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(940);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(1847);

var _matches2 = _interopRequireDefault(_matches);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isDoc = function isDoc(obj) {
  return obj != null && obj.nodeType === obj.DOCUMENT_NODE;
};

function closest(node, selector, context) {
  while (node && (isDoc(node) || !(0, _matches2.default)(node, selector))) {
    node = node !== context && !isDoc(node) ? node.parentNode : undefined;
  }
  return node;
}
module.exports = exports['default'];

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(196);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _querySelectorAll = __webpack_require__(620);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var matches = void 0;
if (_inDOM2.default) {
  (function () {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;

    matches = nativeMatch ? function (node, selector) {
      return nativeMatch.call(node, selector);
    } : ie8MatchesSelector;
  })();
}

exports.default = matches;

function ie8MatchesSelector(node, selector) {
  var matches = (0, _querySelectorAll2.default)(node.document || node.ownerDocument, selector),
      i = 0;

  while (matches[i] && matches[i] !== node) {
    i++;
  }return !!matches[i];
}
module.exports = exports['default'];

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(942);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(947);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = position;

var _offset = __webpack_require__(417);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(1848);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(945);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(944);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(947);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(949);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(1854);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function (window) {
  'use strict';
  /* jshint loopfunc: true, noempty: false*/
  // http://www.w3.org/TR/dom/#element

  function createDocumentFragment() {
    return document.createDocumentFragment();
  }

  function createElement(nodeName) {
    return document.createElement(nodeName);
  }

  function enoughArguments(length, name) {
    if (!length) throw new Error('Failed to construct ' + name + ': 1 argument required, but only 0 present.');
  }

  function mutationMacro(nodes) {
    if (nodes.length === 1) {
      return textNodeIfString(nodes[0]);
    }
    for (var fragment = createDocumentFragment(), list = slice.call(nodes), i = 0; i < nodes.length; i++) {
      fragment.appendChild(textNodeIfString(list[i]));
    }
    return fragment;
  }

  function textNodeIfString(node) {
    return typeof node === 'string' ? document.createTextNode(node) : node;
  }

  for (var head, property, TemporaryPrototype, TemporaryTokenList, wrapVerifyToken, document = window.document, hOP = Object.prototype.hasOwnProperty, defineProperty = Object.defineProperty || function (object, property, descriptor) {
    if (hOP.call(descriptor, 'value')) {
      object[property] = descriptor.value;
    } else {
      if (hOP.call(descriptor, 'get')) object.__defineGetter__(property, descriptor.get);
      if (hOP.call(descriptor, 'set')) object.__defineSetter__(property, descriptor.set);
    }
    return object;
  }, indexOf = [].indexOf || function indexOf(value) {
    var length = this.length;
    while (length--) {
      if (this[length] === value) {
        break;
      }
    }
    return length;
  },
  // http://www.w3.org/TR/domcore/#domtokenlist
  verifyToken = function verifyToken(token) {
    if (!token) {
      throw 'SyntaxError';
    } else if (spaces.test(token)) {
      throw 'InvalidCharacterError';
    }
    return token;
  }, DOMTokenList = function DOMTokenList(node) {
    var noClassName = typeof node.className === 'undefined',
        className = noClassName ? node.getAttribute('class') || '' : node.className,
        isSVG = noClassName || (typeof className === 'undefined' ? 'undefined' : _typeof(className)) === 'object',
        value = (isSVG ? noClassName ? className : className.baseVal : className).replace(trim, '');
    if (value.length) {
      properties.push.apply(this, value.split(spaces));
    }
    this._isSVG = isSVG;
    this._ = node;
  }, classListDescriptor = {
    get: function get() {
      return new DOMTokenList(this);
    },
    set: function set() {}
  }, uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.', '-'), trim = /^\s+|\s+$/g, spaces = /\s+/, SPACE = '\x20', CLASS_LIST = 'classList', toggle = function toggle(token, force) {
    if (this.contains(token)) {
      if (!force) {
        // force is not true (either false or omitted)
        this.remove(token);
      }
    } else if (force === undefined || force) {
      force = true;
      this.add(token);
    }
    return !!force;
  }, DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype, Node = window.Node, NodePrototype = (Node || Element).prototype, CharacterData = window.CharacterData || Node, CharacterDataPrototype = CharacterData && CharacterData.prototype, DocumentType = window.DocumentType, DocumentTypePrototype = DocumentType && DocumentType.prototype, ElementPrototype = (window.Element || Node || window.HTMLElement).prototype, HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor, selectRemove = HTMLSelectElement.prototype.remove, ShadowRoot = window.ShadowRoot, SVGElement = window.SVGElement,
  // normalizes multiple ids as CSS query
  idSpaceFinder = / /g, idSpaceReplacer = '\\ ', createQueryMethod = function createQueryMethod(methodName) {
    var createArray = methodName === 'querySelectorAll';
    return function (css) {
      var a,
          i,
          id,
          query,
          nl,
          selectors,
          node = this.parentNode;
      if (node) {
        for (id = this.getAttribute('id') || uid, query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer), selectors = css.split(','), i = 0; i < selectors.length; i++) {
          selectors[i] = '#' + query + ' ' + selectors[i];
        }
        css = selectors.join(',');
      }
      if (id === uid) this.setAttribute('id', id);
      nl = (node || this)[methodName](css);
      if (id === uid) this.removeAttribute('id');
      // return a list
      if (createArray) {
        i = nl.length;
        a = new Array(i);
        while (i--) {
          a[i] = nl[i];
        }
      }
      // return node or null
      else {
          a = nl;
        }
      return a;
    };
  }, addQueryAndAll = function addQueryAndAll(where) {
    if (!('query' in where)) {
      where.query = ElementPrototype.query;
    }
    if (!('queryAll' in where)) {
      where.queryAll = ElementPrototype.queryAll;
    }
  }, properties = ['matches', ElementPrototype.matchesSelector || ElementPrototype.webkitMatchesSelector || ElementPrototype.khtmlMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || function matches(selector) {
    var parentNode = this.parentNode;
    return !!parentNode && -1 < indexOf.call(parentNode.querySelectorAll(selector), this);
  }, 'closest', function closest(selector) {
    var parentNode = this,
        matches;
    while (
    // document has no .matches
    (matches = parentNode && parentNode.matches) && !parentNode.matches(selector)) {
      parentNode = parentNode.parentNode;
    }
    return matches ? parentNode : null;
  }, 'prepend', function prepend() {
    var firstChild = this.firstChild,
        node = mutationMacro(arguments);
    if (firstChild) {
      this.insertBefore(node, firstChild);
    } else {
      this.appendChild(node);
    }
  }, 'append', function append() {
    this.appendChild(mutationMacro(arguments));
  }, 'before', function before() {
    var parentNode = this.parentNode;
    if (parentNode) {
      parentNode.insertBefore(mutationMacro(arguments), this);
    }
  }, 'after', function after() {
    var parentNode = this.parentNode,
        nextSibling = this.nextSibling,
        node = mutationMacro(arguments);
    if (parentNode) {
      if (nextSibling) {
        parentNode.insertBefore(node, nextSibling);
      } else {
        parentNode.appendChild(node);
      }
    }
  },
  // WARNING - DEPRECATED - use .replaceWith() instead
  'replace', function replace() {
    this.replaceWith.apply(this, arguments);
  }, 'replaceWith', function replaceWith() {
    var parentNode = this.parentNode;
    if (parentNode) {
      parentNode.replaceChild(mutationMacro(arguments), this);
    }
  }, 'remove', function remove() {
    var parentNode = this.parentNode;
    if (parentNode) {
      parentNode.removeChild(this);
    }
  }, 'query', createQueryMethod('querySelector'), 'queryAll', createQueryMethod('querySelectorAll')], slice = properties.slice, i = properties.length; i; i -= 2) {
    property = properties[i - 2];
    if (!(property in ElementPrototype)) {
      ElementPrototype[property] = properties[i - 1];
    }
    if (property === 'remove') {
      // see https://github.com/WebReflection/dom4/issues/19
      HTMLSelectElement.prototype[property] = function () {
        return 0 < arguments.length ? selectRemove.apply(this, arguments) : ElementPrototype.remove.call(this);
      };
    }
    // see https://github.com/WebReflection/dom4/issues/18
    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
      if (CharacterData && !(property in CharacterDataPrototype)) {
        CharacterDataPrototype[property] = properties[i - 1];
      }
      if (DocumentType && !(property in DocumentTypePrototype)) {
        DocumentTypePrototype[property] = properties[i - 1];
      }
    }
    // see https://github.com/WebReflection/dom4/pull/26
    if (/^(?:append|prepend)$/.test(property)) {
      if (DocumentFragmentPrototype) {
        if (!(property in DocumentFragmentPrototype)) {
          DocumentFragmentPrototype[property] = properties[i - 1];
        }
      } else {
        try {
          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
        } catch (o_O) {}
      }
    }
  }

  // bring query and queryAll to the document too
  addQueryAndAll(document);

  // brings query and queryAll to fragments as well
  if (DocumentFragmentPrototype) {
    addQueryAndAll(DocumentFragmentPrototype);
  } else {
    try {
      addQueryAndAll(createDocumentFragment().constructor.prototype);
    } catch (o_O) {}
  }

  // bring query and queryAll to the ShadowRoot too
  if (ShadowRoot) {
    addQueryAndAll(ShadowRoot.prototype);
  }

  // most likely an IE9 only issue
  // see https://github.com/WebReflection/dom4/issues/6
  if (!createElement('a').matches('a')) {
    ElementPrototype[property] = function (matches) {
      return function (selector) {
        return matches.call(this.parentNode ? this : createDocumentFragment().appendChild(this), selector);
      };
    }(ElementPrototype[property]);
  }

  // used to fix both old webkit and SVG
  DOMTokenList.prototype = {
    length: 0,
    add: function add() {
      for (var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if (!this.contains(token)) {
          properties.push.call(this, property);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    contains: function (indexOf) {
      return function contains(token) {
        i = indexOf.call(this, property = verifyToken(token));
        return -1 < i;
      };
    }([].indexOf || function (token) {
      i = this.length;
      while (i-- && this[i] !== token) {}
      return i;
    }),
    item: function item(i) {
      return this[i] || null;
    },
    remove: function remove() {
      for (var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if (this.contains(token)) {
          properties.splice.call(this, i, 1);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    toggle: toggle,
    toString: function toString() {
      return properties.join.call(this, SPACE);
    }
  };

  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
  }

  // http://www.w3.org/TR/dom/#domtokenlist
  // iOS 5.1 has completely screwed this property
  // classList in ElementPrototype is false
  // but it's actually there as getter
  if (!(CLASS_LIST in document.documentElement)) {
    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
  } else {
    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
    // trying to detect and fix that in here
    TemporaryTokenList = createElement('div')[CLASS_LIST];
    TemporaryTokenList.add('a', 'b', 'a');
    if ('a\x20b' != TemporaryTokenList) {
      // no other way to reach original methods in iOS 5.1
      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
      if (!('add' in TemporaryPrototype)) {
        // ASHA double fails in here
        TemporaryPrototype = window.TemporaryTokenList.prototype;
      }
      wrapVerifyToken = function wrapVerifyToken(original) {
        return function () {
          var i = 0;
          while (i < arguments.length) {
            original.call(this, arguments[i++]);
          }
        };
      };
      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
      // toggle is broken too ^_^ ... let's fix it
      TemporaryPrototype.toggle = toggle;
    }
  }

  if (!('contains' in NodePrototype)) {
    defineProperty(NodePrototype, 'contains', {
      value: function value(el) {
        while (el && el !== this) {
          el = el.parentNode;
        }return this === el;
      }
    });
  }

  if (!('head' in document)) {
    defineProperty(document, 'head', {
      get: function get() {
        return head || (head = document.getElementsByTagName('head')[0]);
      }
    });
  }

  // requestAnimationFrame partial polyfill
  (function () {
    for (var raf, rAF = window.requestAnimationFrame, cAF = window.cancelAnimationFrame, prefixes = ['o', 'ms', 'moz', 'webkit'], i = prefixes.length; !cAF && i--;) {
      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
      cAF = window[prefixes[i] + 'CancelAnimationFrame'] || window[prefixes[i] + 'CancelRequestAnimationFrame'];
    }
    if (!cAF) {
      // some FF apparently implemented rAF but no cAF 
      if (rAF) {
        raf = rAF;
        rAF = function rAF(callback) {
          var goOn = true;
          raf(function () {
            if (goOn) callback.apply(this, arguments);
          });
          return function () {
            goOn = false;
          };
        };
        cAF = function cAF(id) {
          id();
        };
      } else {
        rAF = function rAF(callback) {
          return setTimeout(callback, 15, 15);
        };
        cAF = function cAF(id) {
          clearTimeout(id);
        };
      }
    }
    window.requestAnimationFrame = rAF;
    window.cancelAnimationFrame = cAF;
  })();

  // http://www.w3.org/TR/dom/#customevent
  try {
    new window.CustomEvent('?');
  } catch (o_O) {
    window.CustomEvent = function (eventName, defaultInitDict) {

      // the infamous substitute
      function CustomEvent(type, eventInitDict) {
        /*jshint eqnull:true */
        var event = document.createEvent(eventName);
        if (typeof type != 'string') {
          throw new Error('An event name must be provided');
        }
        if (eventName == 'Event') {
          event.initCustomEvent = initCustomEvent;
        }
        if (eventInitDict == null) {
          eventInitDict = defaultInitDict;
        }
        event.initCustomEvent(type, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
        return event;
      }

      // attached at runtime
      function initCustomEvent(type, bubbles, cancelable, detail) {
        /*jshint validthis:true*/
        this.initEvent(type, bubbles, cancelable);
        this.detail = detail;
      }

      // that's it
      return CustomEvent;
    }(
    // is this IE9 or IE10 ?
    // where CustomEvent is there
    // but not usable as construtor ?
    window.CustomEvent ?
    // use the CustomEvent interface in such case
    'CustomEvent' : 'Event',
    // otherwise the common compatible one
    {
      bubbles: false,
      cancelable: false,
      detail: null
    });
  }

  // window.Event as constructor
  try {
    new Event('_');
  } catch (o_O) {
    /* jshint -W022 */
    o_O = function ($Event) {
      function Event(type, init) {
        enoughArguments(arguments.length, 'Event');
        var out = document.createEvent('Event');
        if (!init) init = {};
        out.initEvent(type, !!init.bubbles, !!init.cancelable);
        return out;
      }
      Event.prototype = $Event.prototype;
      return Event;
    }(window.Event || function Event() {});
    defineProperty(window, 'Event', { value: o_O });
    // Android 4 gotcha
    if (Event !== o_O) Event = o_O;
  }

  // window.KeyboardEvent as constructor
  try {
    new KeyboardEvent('_', {});
  } catch (o_O) {
    /* jshint -W022 */
    o_O = function ($KeyboardEvent) {
      // code inspired by https://gist.github.com/termi/4654819
      var initType = 0,
          defaults = {
        char: '',
        key: '',
        location: 0,
        ctrlKey: false,
        shiftKey: false,
        altKey: false,
        metaKey: false,
        altGraphKey: false,
        repeat: false,
        locale: navigator.language,
        detail: 0,
        bubbles: false,
        cancelable: false,
        keyCode: 0,
        charCode: 0,
        which: 0
      },
          eventType;
      try {
        var e = document.createEvent('KeyboardEvent');
        e.initKeyboardEvent('keyup', false, false, window, '+', 3, true, false, true, false, false);
        initType = (e.keyIdentifier || e.key) == '+' && (e.keyLocation || e.location) == 3 && (e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4) || 9;
      } catch (o_O) {}
      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

      function getModifier(init) {
        for (var out = [], keys = ['ctrlKey', 'Control', 'shiftKey', 'Shift', 'altKey', 'Alt', 'metaKey', 'Meta', 'altGraphKey', 'AltGraph'], i = 0; i < keys.length; i += 2) {
          if (init[keys[i]]) out.push(keys[i + 1]);
        }
        return out.join(' ');
      }

      function withDefaults(target, source) {
        for (var key in source) {
          if (source.hasOwnProperty(key) && !source.hasOwnProperty.call(target, key)) target[key] = source[key];
        }
        return target;
      }

      function withInitValues(key, out, init) {
        try {
          out[key] = init[key];
        } catch (o_O) {}
      }

      function KeyboardEvent(type, init) {
        enoughArguments(arguments.length, 'KeyboardEvent');
        init = withDefaults(init || {}, defaults);
        var out = document.createEvent(eventType),
            ctrlKey = init.ctrlKey,
            shiftKey = init.shiftKey,
            altKey = init.altKey,
            metaKey = init.metaKey,
            altGraphKey = init.altGraphKey,
            modifiers = initType > 3 ? getModifier(init) : null,
            key = String(init.key),
            chr = String(init.char),
            location = init.location,
            keyCode = init.keyCode || (init.keyCode = key) && key.charCodeAt(0) || 0,
            charCode = init.charCode || (init.charCode = chr) && chr.charCodeAt(0) || 0,
            bubbles = init.bubbles,
            cancelable = init.cancelable,
            repeat = init.repeat,
            locale = init.locale,
            view = init.view || window,
            args;
        if (!init.which) init.which = init.keyCode;
        if ('initKeyEvent' in out) {
          out.initKeyEvent(type, bubbles, cancelable, view, ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
        } else if (0 < initType && 'initKeyboardEvent' in out) {
          args = [type, bubbles, cancelable, view];
          switch (initType) {
            case 1:
              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
              break;
            case 2:
              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
              break;
            case 3:
              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
              break;
            case 4:
              args.push(key, location, modifiers, repeat, locale);
              break;
            default:
              args.push(char, key, location, modifiers, repeat, locale);
          }
          out.initKeyboardEvent.apply(out, args);
        } else {
          out.initEvent(type, bubbles, cancelable);
        }
        for (key in out) {
          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
            withInitValues(key, out, init);
          }
        }
        return out;
      }
      KeyboardEvent.prototype = $KeyboardEvent.prototype;
      return KeyboardEvent;
    }(window.KeyboardEvent || function KeyboardEvent() {});
    defineProperty(window, 'KeyboardEvent', { value: o_O });
    // Android 4 gotcha
    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
  }

  // window.MouseEvent as constructor
  try {
    new MouseEvent('_', {});
  } catch (o_O) {
    /* jshint -W022 */
    o_O = function ($MouseEvent) {
      function MouseEvent(type, init) {
        enoughArguments(arguments.length, 'MouseEvent');
        var out = document.createEvent('MouseEvent');
        if (!init) init = {};
        out.initMouseEvent(type, !!init.bubbles, !!init.cancelable, init.view || window, init.detail || 1, init.screenX || 0, init.screenY || 0, init.clientX || 0, init.clientY || 0, !!init.ctrlKey, !!init.altKey, !!init.shiftKey, !!init.metaKey, init.button || 0, init.relatedTarget || null);
        return out;
      }
      MouseEvent.prototype = $MouseEvent.prototype;
      return MouseEvent;
    }(window.MouseEvent || function MouseEvent() {});
    defineProperty(window, 'MouseEvent', { value: o_O });
    // Android 4 gotcha
    if (MouseEvent !== o_O) MouseEvent = o_O;
  }
})(window);(function (global) {
  'use strict';

  // a WeakMap fallback for DOM nodes only used as key

  var DOMMap = global.WeakMap || function () {

    var counter = 0,
        dispatched = false,
        drop = false,
        value;

    function dispatch(key, ce, shouldDrop) {
      drop = shouldDrop;
      dispatched = false;
      value = undefined;
      key.dispatchEvent(ce);
    }

    function Handler(value) {
      this.value = value;
    }

    Handler.prototype.handleEvent = function handleEvent(e) {
      dispatched = true;
      if (drop) {
        e.currentTarget.removeEventListener(e.type, this, false);
      } else {
        value = this.value;
      }
    };

    function DOMMap() {
      counter++; // make id clashing highly improbable
      this.__ce__ = new Event('@DOMMap:' + counter + Math.random());
    }

    DOMMap.prototype = {
      'constructor': DOMMap,
      'delete': function del(key) {
        return dispatch(key, this.__ce__, true), dispatched;
      },
      'get': function get(key) {
        dispatch(key, this.__ce__, false);
        var v = value;
        value = undefined;
        return v;
      },
      'has': function has(key) {
        return dispatch(key, this.__ce__, false), dispatched;
      },
      'set': function set(key, value) {
        dispatch(key, this.__ce__, true);
        key.addEventListener(this.__ce__.type, new Handler(value), false);
        return this;
      }
    };

    return DOMMap;
  }();

  function Dict() {}
  Dict.prototype = (Object.create || Object)(null);

  // https://dom.spec.whatwg.org/#interface-eventtarget

  function createEventListener(type, callback, options) {
    function eventListener(e) {
      if (eventListener.once) {
        e.currentTarget.removeEventListener(e.type, callback, eventListener);
        eventListener.removed = true;
      }
      if (eventListener.passive) {
        e.preventDefault = createEventListener.preventDefault;
      }
      if (typeof eventListener.callback === 'function') {
        /* jshint validthis: true */
        eventListener.callback.call(this, e);
      } else if (eventListener.callback) {
        eventListener.callback.handleEvent(e);
      }
      if (eventListener.passive) {
        delete e.preventDefault;
      }
    }
    eventListener.type = type;
    eventListener.callback = callback;
    eventListener.capture = !!options.capture;
    eventListener.passive = !!options.passive;
    eventListener.once = !!options.once;
    // currently pointless but specs say to use it, so ...
    eventListener.removed = false;
    return eventListener;
  }

  createEventListener.preventDefault = function preventDefault() {};

  var Event = global.CustomEvent,
      hOP = Object.prototype.hasOwnProperty,
      dE = global.dispatchEvent,
      aEL = global.addEventListener,
      rEL = global.removeEventListener,
      counter = 0,
      increment = function increment() {
    counter++;
  },
      indexOf = [].indexOf || function indexOf(value) {
    var length = this.length;
    while (length--) {
      if (this[length] === value) {
        break;
      }
    }
    return length;
  },
      getListenerKey = function getListenerKey(options) {
    return ''.concat(options.capture ? '1' : '0', options.passive ? '1' : '0', options.once ? '1' : '0');
  },
      augment,
      proto;

  try {
    aEL('_', increment, { once: true });
    dE(new Event('_'));
    dE(new Event('_'));
    rEL('_', increment, { once: true });
  } catch (o_O) {}

  if (counter !== 1) {
    (function () {
      var dm = new DOMMap();
      function createAEL(aEL) {
        return function addEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var info = dm.get(this),
                key = getListenerKey(options),
                i,
                tmp,
                wrap;
            if (!info) dm.set(this, info = new Dict());
            if (!(type in info)) info[type] = {
              handler: [],
              wrap: []
            };
            tmp = info[type];
            i = indexOf.call(tmp.handler, handler);
            if (i < 0) {
              i = tmp.handler.push(handler) - 1;
              tmp.wrap[i] = wrap = new Dict();
            } else {
              wrap = tmp.wrap[i];
            }
            if (!(key in wrap)) {
              wrap[key] = createEventListener(type, handler, options);
              aEL.call(this, type, wrap[key], wrap[key].capture);
            }
          } else {
            aEL.call(this, type, handler, options);
          }
        };
      }
      function createREL(rEL) {
        return function removeEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var info = dm.get(this),
                key,
                i,
                tmp,
                wrap;
            if (info && type in info) {
              tmp = info[type];
              i = indexOf.call(tmp.handler, handler);
              if (-1 < i) {
                key = getListenerKey(options);
                wrap = tmp.wrap[i];
                if (key in wrap) {
                  rEL.call(this, type, wrap[key], wrap[key].capture);
                  delete wrap[key];
                  // return if there are other wraps
                  for (key in wrap) {
                    return;
                  } // otherwise remove all the things
                  tmp.handler.splice(i, 1);
                  tmp.wrap.splice(i, 1);
                  // if there are no other handlers
                  if (tmp.handler.length === 0)
                    // drop the info[type] entirely
                    delete info[type];
                }
              }
            }
          } else {
            rEL.call(this, type, handler, options);
          }
        };
      }

      augment = function augment(Constructor) {
        if (!Constructor) return;
        var proto = Constructor.prototype;
        proto.addEventListener = createAEL(proto.addEventListener);
        proto.removeEventListener = createREL(proto.removeEventListener);
      };

      if (global.EventTarget) {
        augment(EventTarget);
      } else {
        augment(global.Text);
        augment(global.Element || global.HTMLElement);
        augment(global.HTMLDocument);
        augment(global.Window || { prototype: global });
        augment(global.XMLHttpRequest);
      }
    })();
  }
})(self);

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function throwTypeError() {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
	try {
		// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
		arguments.callee; // IE 8 does not throw here
		return throwTypeError;
	} catch (calleeThrows) {
		try {
			// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
			return $gOPD(arguments, 'callee').get;
		} catch (gOPDthrows) {
			return throwTypeError;
		}
	}
}() : throwTypeError;

var hasSymbols = __webpack_require__(2027)();

var getProto = Object.getPrototypeOf || function (x) {
	return x.__proto__;
}; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': (typeof JSON === 'undefined' ? 'undefined' : _typeof(JSON)) === 'object' ? JSON : undefined,
	'%JSONParse%': (typeof JSON === 'undefined' ? 'undefined' : _typeof(JSON)) === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(642);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && i + 1 >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? desc.get || desc.value : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(642);

var GetIntrinsic = __webpack_require__(1857);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ("function" === 'function' && _typeof(__webpack_require__(214)) === 'object' && __webpack_require__(214)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}
})();

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _off = __webpack_require__(625);

var _off2 = _interopRequireDefault(_off);

var _on = __webpack_require__(626);

var _on2 = _interopRequireDefault(_on);

var _invariant = __webpack_require__(627);

var _invariant2 = _interopRequireDefault(_invariant);

var _StateStorage = __webpack_require__(951);

var _StateStorage2 = _interopRequireDefault(_StateStorage);

var _createPath = __webpack_require__(418);

var _createPath2 = _interopRequireDefault(_createPath);

var _ensureLocation = __webpack_require__(419);

var _ensureLocation2 = _interopRequireDefault(_ensureLocation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var HashProtocol = function () {
  function HashProtocol() {
    _classCallCheck(this, HashProtocol);

    this.stateStorage = new _StateStorage2.default(this, '@@farce');

    this._index = null;
    this._numExpectedHashChanges = 0;
  }

  HashProtocol.prototype.init = function init() {
    // TODO: Do we still need to work around the old Firefox bug here?
    var location = (0, _ensureLocation2.default)(window.location.hash.slice(1) || '/');

    var _ref = this.stateStorage.read(location, null) || {},
        _ref$index = _ref.index,
        index = _ref$index === undefined ? 0 : _ref$index,
        state = _ref.state;

    var delta = this._index != null ? index - this._index : 0;
    this._index = index;

    return _extends({
      action: 'POP'
    }, location, {
      index: index,
      delta: delta,
      state: state
    });
  };

  HashProtocol.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    var onHashChange = function onHashChange() {
      // Ignore hash change events triggered by our own navigation.
      if (_this._numExpectedHashChanges > 0) {
        --_this._numExpectedHashChanges;
        return;
      }

      listener(_this.init());
    };

    (0, _on2.default)(window, 'hashchange', onHashChange);
    return function () {
      return (0, _off2.default)(window, 'hashchange', onHashChange);
    };
  };

  HashProtocol.prototype.transition = function transition(location) {
    var action = location.action,
        state = location.state;

    var push = action === 'PUSH';
    !(push || action === 'REPLACE') ?  false ? (0, _invariant2.default)(false, 'Unrecognized browser protocol action ' + action + '.') : (0, _invariant2.default)(false) : void 0;

    var delta = push ? 1 : 0;
    this._index += delta;

    var path = (0, _createPath2.default)(location);

    ++this._numExpectedHashChanges;
    if (push) {
      window.location.hash = path;
    } else {
      window.location.replace('#' + path);
    }

    this.stateStorage.save(location, null, { index: this._index, state: state });

    return _extends({}, location, { index: this._index, delta: delta });
  };

  HashProtocol.prototype.go = function go(delta) {
    window.history.go(delta);
  };

  HashProtocol.prototype.createHref = function createHref(location) {
    return '#' + (0, _createPath2.default)(location);
  };

  return HashProtocol;
}();

exports.default = HashProtocol;
module.exports = exports['default'];

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _invariant = __webpack_require__(627);

var _invariant2 = _interopRequireDefault(_invariant);

var _createPath = __webpack_require__(418);

var _createPath2 = _interopRequireDefault(_createPath);

var _ensureLocation = __webpack_require__(419);

var _ensureLocation2 = _interopRequireDefault(_ensureLocation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var STATE_KEY = '@@farce/state';

var MemoryProtocol = function () {
  function MemoryProtocol(initialLocation) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$persistent = _ref.persistent,
        persistent = _ref$persistent === undefined ? false : _ref$persistent;

    _classCallCheck(this, MemoryProtocol);

    this._persistent = persistent;

    var initialState = persistent ? this._loadState() : null;
    if (initialState) {
      this._stack = initialState.stack;
      this._index = initialState.index;
    } else {
      this._stack = [(0, _ensureLocation2.default)(initialLocation)];
      this._index = 0;
    }

    this._keyPrefix = Math.random().toString(36).slice(2, 8);
    this._keyIndex = 0;

    this._listener = null;
  }

  MemoryProtocol.prototype._loadState = function _loadState() {
    try {
      var _JSON$parse = JSON.parse(window.sessionStorage.getItem(STATE_KEY)),
          stack = _JSON$parse.stack,
          index = _JSON$parse.index;

      // Check that the stack and index at least seem reasonable before using
      // them as state. This isn't foolproof, but it might prevent mistakes.


      if (Array.isArray(stack) && typeof index === 'number' && stack[index]) {
        return { stack: stack, index: index };
      }
    } catch (e) {} // eslint-disable-line no-empty

    return null;
  };

  MemoryProtocol.prototype.init = function init() {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return _extends({}, this._stack[this._index], {
      action: 'POP',
      index: this._index,
      delta: delta
    });
  };

  MemoryProtocol.prototype.transition = function transition(location) {
    // Match BrowserProtocol here in only saving these fields.
    var action = location.action,
        pathname = location.pathname,
        search = location.search,
        hash = location.hash,
        state = location.state;

    var push = action === 'PUSH';
    !(push || action === 'REPLACE') ?  false ? (0, _invariant2.default)(false, 'Unrecognized memory protocol action ' + action + '.') : (0, _invariant2.default)(false) : void 0;

    var delta = push ? 1 : 0;
    this._index += delta;

    var keyIndex = this._keyIndex++;
    var key = this._keyPrefix + ':' + keyIndex.toString(36);

    this._stack[this._index] = { pathname: pathname, search: search, hash: hash, state: state, key: key };
    if (push) {
      this._stack.length = this._index + 1;
    }

    if (this._persistent) {
      this._saveState();
    }

    return _extends({}, location, { key: key, index: this._index, delta: delta });
  };

  MemoryProtocol.prototype.go = function go(delta) {
    var prevIndex = this._index;

    this._index = Math.min(Math.max(this._index + delta, 0), this._stack.length - 1);

    if (this._index === prevIndex) {
      return;
    }

    if (this._persistent) {
      this._saveState();
    }

    if (this._listener) {
      this._listener(this.init(this._index - prevIndex));
    }
  };

  MemoryProtocol.prototype._saveState = function _saveState() {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify({
        stack: this._stack,
        index: this._index
      }));
    } catch (e) {} // eslint-disable-line no-empty
  };

  MemoryProtocol.prototype.createHref = function createHref(location) {
    return (0, _createPath2.default)(location);
  };

  MemoryProtocol.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    this._listener = listener;

    return function () {
      _this._listener = null;
    };
  };

  return MemoryProtocol;
}();

exports.default = MemoryProtocol;
module.exports = exports['default'];

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createPath = __webpack_require__(418);

var _createPath2 = _interopRequireDefault(_createPath);

var _ensureLocation = __webpack_require__(419);

var _ensureLocation2 = _interopRequireDefault(_ensureLocation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function noop() {}

var ServerProtocol = function () {
  function ServerProtocol(url) {
    _classCallCheck(this, ServerProtocol);

    this._location = (0, _ensureLocation2.default)(url);
  }

  ServerProtocol.prototype.init = function init() {
    return _extends({
      action: 'POP'
    }, this._location);
  };

  ServerProtocol.prototype.subscribe = function subscribe() {
    // Server protocol emits no events.
    return noop;
  };

  ServerProtocol.prototype.createHref = function createHref(location) {
    return (0, _createPath2.default)(location);
  };

  // The other methods are not implemented, because ServerProtocol instances
  // cannot navigate.


  return ServerProtocol;
}();

exports.default = ServerProtocol;
module.exports = exports['default'];

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = createBasenameMiddleware;

var _createLocationMiddleware = __webpack_require__(624);

var _createLocationMiddleware2 = _interopRequireDefault(_createLocationMiddleware);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createBasenameMiddleware(_ref) {
  var basename = _ref.basename;

  if (!basename || basename === '/') {
    // Fast path in case basename is trivial.
    return function () {
      return function (next) {
        return next;
      };
    };
  }

  // Normalize away trailing slash on basename.
  var pathnamePrefix = basename.slice(-1) === '/' ? basename.slice(0, -1) : basename;

  return (0, _createLocationMiddleware2.default)({
    makeLocationDescriptor: function makeLocationDescriptor(location) {
      return _extends({}, location, {
        pathname: '' + pathnamePrefix + location.pathname
      });
    },
    makeLocation: function makeLocation(location) {
      return _extends({}, location, {
        pathname: location.pathname.indexOf(pathnamePrefix) === 0 ? location.pathname.slice(pathnamePrefix.length) : null
      });
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createHistory;

var _redux = __webpack_require__(296);

var _Actions = __webpack_require__(234);

var _Actions2 = _interopRequireDefault(_Actions);

var _createHistoryEnhancer = __webpack_require__(623);

var _createHistoryEnhancer2 = _interopRequireDefault(_createHistoryEnhancer);

var _createStoreHistory = __webpack_require__(954);

var _createStoreHistory2 = _interopRequireDefault(_createStoreHistory);

var _locationReducer = __webpack_require__(957);

var _locationReducer2 = _interopRequireDefault(_locationReducer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createHistory(options) {
  var store = (0, _redux.createStore)(_locationReducer2.default, (0, _createHistoryEnhancer2.default)(options));
  store.dispatch(_Actions2.default.init());

  return (0, _createStoreHistory2.default)(store, function (location) {
    return location;
  });
}
module.exports = exports['default'];

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StateStorage = exports.ServerProtocol = exports.queryMiddleware = exports.MemoryProtocol = exports.locationReducer = exports.HashProtocol = exports.ensureLocationMiddleware = exports.createTransitionHookMiddleware = exports.createStoreHistory = exports.createQueryMiddleware = exports.createLocationMiddleware = exports.createHistoryMiddleware = exports.createHistoryEnhancer = exports.createHistory = exports.createBasenameMiddleware = exports.BrowserProtocol = exports.ActionTypes = exports.Actions = undefined;

var _Actions2 = __webpack_require__(234);

var _Actions3 = _interopRequireDefault(_Actions2);

var _ActionTypes2 = __webpack_require__(164);

var _ActionTypes3 = _interopRequireDefault(_ActionTypes2);

var _BrowserProtocol2 = __webpack_require__(622);

var _BrowserProtocol3 = _interopRequireDefault(_BrowserProtocol2);

var _createBasenameMiddleware2 = __webpack_require__(1863);

var _createBasenameMiddleware3 = _interopRequireDefault(_createBasenameMiddleware2);

var _createHistory2 = __webpack_require__(1864);

var _createHistory3 = _interopRequireDefault(_createHistory2);

var _createHistoryEnhancer2 = __webpack_require__(623);

var _createHistoryEnhancer3 = _interopRequireDefault(_createHistoryEnhancer2);

var _createHistoryMiddleware2 = __webpack_require__(952);

var _createHistoryMiddleware3 = _interopRequireDefault(_createHistoryMiddleware2);

var _createLocationMiddleware2 = __webpack_require__(624);

var _createLocationMiddleware3 = _interopRequireDefault(_createLocationMiddleware2);

var _createQueryMiddleware2 = __webpack_require__(953);

var _createQueryMiddleware3 = _interopRequireDefault(_createQueryMiddleware2);

var _createStoreHistory2 = __webpack_require__(954);

var _createStoreHistory3 = _interopRequireDefault(_createStoreHistory2);

var _createTransitionHookMiddleware2 = __webpack_require__(955);

var _createTransitionHookMiddleware3 = _interopRequireDefault(_createTransitionHookMiddleware2);

var _ensureLocationMiddleware2 = __webpack_require__(956);

var _ensureLocationMiddleware3 = _interopRequireDefault(_ensureLocationMiddleware2);

var _HashProtocol2 = __webpack_require__(1860);

var _HashProtocol3 = _interopRequireDefault(_HashProtocol2);

var _locationReducer2 = __webpack_require__(957);

var _locationReducer3 = _interopRequireDefault(_locationReducer2);

var _MemoryProtocol2 = __webpack_require__(1861);

var _MemoryProtocol3 = _interopRequireDefault(_MemoryProtocol2);

var _queryMiddleware2 = __webpack_require__(958);

var _queryMiddleware3 = _interopRequireDefault(_queryMiddleware2);

var _ServerProtocol2 = __webpack_require__(1862);

var _ServerProtocol3 = _interopRequireDefault(_ServerProtocol2);

var _StateStorage2 = __webpack_require__(951);

var _StateStorage3 = _interopRequireDefault(_StateStorage2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Actions = _Actions3.default;
exports.ActionTypes = _ActionTypes3.default;
exports.BrowserProtocol = _BrowserProtocol3.default;
exports.createBasenameMiddleware = _createBasenameMiddleware3.default;
exports.createHistory = _createHistory3.default;
exports.createHistoryEnhancer = _createHistoryEnhancer3.default;
exports.createHistoryMiddleware = _createHistoryMiddleware3.default;
exports.createLocationMiddleware = _createLocationMiddleware3.default;
exports.createQueryMiddleware = _createQueryMiddleware3.default;
exports.createStoreHistory = _createStoreHistory3.default;
exports.createTransitionHookMiddleware = _createTransitionHookMiddleware3.default;
exports.ensureLocationMiddleware = _ensureLocationMiddleware3.default;
exports.HashProtocol = _HashProtocol3.default;
exports.locationReducer = _locationReducer3.default;
exports.MemoryProtocol = _MemoryProtocol3.default;
exports.queryMiddleware = _queryMiddleware3.default;
exports.ServerProtocol = _ServerProtocol3.default;
exports.StateStorage = _StateStorage3.default;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = maybePromisify;
function maybePromisify(hook, syncLength) {
  if (hook.length <= syncLength) {
    return hook;
  }

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var hasSyncResult = false;
    var syncResult = void 0;

    var resolvePromise = void 0;

    hook.apply(undefined, args.concat([function (result) {
      if (resolvePromise) {
        resolvePromise(result);
        return;
      }

      hasSyncResult = true;
      syncResult = result;
    }]));

    if (!hasSyncResult) {
      return new Promise(function (resolve) {
        resolvePromise = resolve;
      });
    }

    return syncResult;
  };
}
module.exports = exports["default"];

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var strictUriEncode = __webpack_require__(2783);
var objectAssign = __webpack_require__(169);
var decodeComponent = __webpack_require__(1839);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({ arrayFormat: 'none' }, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(131);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

function toObj(source) {
  return Object.keys(source).reduce(function (output, key) {
    var parentKey = key.match(/[^\[]*/i);
    var paths = key.match(/\[.*?\]/g) || [];
    paths = [parentKey[0]].concat(paths).map(function (key) {
      return key.replace(/\[|\]/g, '');
    });
    var currentPath = output;
    while (paths.length) {
      var pathKey = paths.shift();

      if (pathKey in currentPath) {
        currentPath = currentPath[pathKey];
      } else {
        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
        currentPath = currentPath[pathKey];
      }
    }

    return output;
  }, {});
}

function fromObj(obj) {
  function recur(newObj, propName, currVal) {
    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
      Object.keys(currVal).forEach(function (v) {
        recur(newObj, propName + "[" + v + "]", currVal[v]);
      });
      return newObj;
    }

    newObj[propName] = currVal;
    return newObj;
  }

  var keys = Object.keys(obj);
  return keys.reduce(function (newObj, propName) {
    return recur(newObj, propName, obj[propName]);
  }, {});
}

module.exports = {
  fromObj: fromObj,
  toObj: toObj
};

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var React = global.React || __webpack_require__(0);
var createReactClass = __webpack_require__(274);
var Mixin = __webpack_require__(628);
module.exports = function () {
  return function (Component) {
    return createReactClass({
      mixins: [Mixin],
      render: function render() {
        return React.createElement(Component, _extends({
          setValidations: this.setValidations,
          setValue: this.setValue,
          resetValue: this.resetValue,
          getValue: this.getValue,
          hasValue: this.hasValue,
          getErrorMessage: this.getErrorMessage,
          getErrorMessages: this.getErrorMessages,
          isFormDisabled: this.isFormDisabled,
          isValid: this.isValid,
          isPristine: this.isPristine,
          isFormSubmitted: this.isFormSubmitted,
          isRequired: this.isRequired,
          showRequired: this.showRequired,
          showError: this.showError,
          isValidValue: this.isValidValue
        }, this.props));
      }
    });
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var React = global.React || __webpack_require__(0);
var createReactClass = __webpack_require__(274);
var Mixin = __webpack_require__(628);
module.exports = function (Component) {
  return createReactClass({
    displayName: 'Formsy(' + getDisplayName(Component) + ')',
    mixins: [Mixin],

    render: function render() {
      var innerRef = this.props.innerRef;

      var propsForElement = _extends({
        setValidations: this.setValidations,
        setValue: this.setValue,
        resetValue: this.resetValue,
        getValue: this.getValue,
        hasValue: this.hasValue,
        getErrorMessage: this.getErrorMessage,
        getErrorMessages: this.getErrorMessages,
        isFormDisabled: this.isFormDisabled,
        isValid: this.isValid,
        isPristine: this.isPristine,
        isFormSubmitted: this.isFormSubmitted,
        isRequired: this.isRequired,
        showRequired: this.showRequired,
        showError: this.showError,
        isValidValue: this.isValidValue
      }, this.props);

      if (innerRef) {
        propsForElement.ref = innerRef;
      }
      return React.createElement(Component, propsForElement);
    }
  });
};

function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isExisty = function _isExisty(value) {
  return value !== null && value !== undefined;
};

var isEmpty = function isEmpty(value) {
  return value === '';
};

var validations = {
  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
    return value === undefined || value === '';
  },
  isExisty: function isExisty(values, value) {
    return _isExisty(value);
  },
  matchRegexp: function matchRegexp(values, value, regexp) {
    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
  },
  isUndefined: function isUndefined(values, value) {
    return value === undefined;
  },
  isEmptyString: function isEmptyString(values, value) {
    return isEmpty(value);
  },
  isEmail: function isEmail(values, value) {
    return validations.matchRegexp(values, value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
  },
  isUrl: function isUrl(values, value) {
    return validations.matchRegexp(values, value, /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);
  },
  isTrue: function isTrue(values, value) {
    return value === true;
  },
  isFalse: function isFalse(values, value) {
    return value === false;
  },
  isNumeric: function isNumeric(values, value) {
    if (typeof value === 'number') {
      return true;
    }
    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
  },
  isAlpha: function isAlpha(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
  },
  isAlphanumeric: function isAlphanumeric(values, value) {
    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
  },
  isInt: function isInt(values, value) {
    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
  },
  isFloat: function isFloat(values, value) {
    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
  },
  isWords: function isWords(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
  },
  isSpecialWords: function isSpecialWords(values, value) {
    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
  },
  isLength: function isLength(values, value, length) {
    return !_isExisty(value) || isEmpty(value) || value.length === length;
  },
  equals: function equals(values, value, eql) {
    return !_isExisty(value) || isEmpty(value) || value == eql;
  },
  equalsField: function equalsField(values, value, field) {
    return value == values[field];
  },
  maxLength: function maxLength(values, value, length) {
    return !_isExisty(value) || value.length <= length;
  },
  minLength: function minLength(values, value, length) {
    return !_isExisty(value) || isEmpty(value) || value.length >= length;
  }
};

module.exports = validations;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _modern = __webpack_require__(1877);

Object.defineProperty(exports, 'QuerySubscription', {
  enumerable: true,
  get: function get() {
    return _modern.QuerySubscription;
  }
});
Object.defineProperty(exports, 'ReadyStateRenderer', {
  enumerable: true,
  get: function get() {
    return _modern.ReadyStateRenderer;
  }
});
Object.defineProperty(exports, 'Resolver', {
  enumerable: true,
  get: function get() {
    return _modern.Resolver;
  }
});

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(268);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(267);

var _promise2 = _interopRequireDefault(_promise);

var _asyncGenerator2 = __webpack_require__(546);

var _asyncGenerator3 = _interopRequireDefault(_asyncGenerator2);

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _ResolverUtils = __webpack_require__(428);

var _isPromise = __webpack_require__(435);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _isEqual = __webpack_require__(1942);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _QuerySubscription = __webpack_require__(629);

var _QuerySubscription2 = _interopRequireDefault(_QuerySubscription);

var _ReadyStateRenderer = __webpack_require__(961);

var _ReadyStateRenderer2 = _interopRequireDefault(_ReadyStateRenderer);

var _renderElement = __webpack_require__(631);

var _renderElement2 = _interopRequireDefault(_renderElement);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Resolver = function () {
  function Resolver(environment) {
    (0, _classCallCheck3.default)(this, Resolver);

    this.environment = environment;

    this.lastQueries = [];
    this.lastRouteVariables = [];
    this.lastQuerySubscriptions = [];
  }

  Resolver.prototype.resolveElements = function () {
    var _ref = _asyncGenerator3.default.wrap( /*#__PURE__*/_regenerator2.default.mark(function _callee(match) {
      var routeMatches, Components, queries, cacheConfigs, dataFroms, routeVariables, querySubscriptions, fetches, earlyComponents, earlyData, fetchedComponents, pendingElements;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              routeMatches = (0, _ResolverUtils.getRouteMatches)(match);
              Components = (0, _ResolverUtils.getComponents)(routeMatches);
              queries = (0, _ResolverUtils.getRouteValues)(routeMatches, function (route) {
                return route.getQuery;
              }, function (route) {
                return route.query;
              });
              cacheConfigs = (0, _ResolverUtils.getRouteValues)(routeMatches, function (route) {
                return route.getCacheConfig;
              }, function (route) {
                return route.cacheConfig;
              });
              dataFroms = (0, _ResolverUtils.getRouteValues)(routeMatches, function (route) {
                return route.getDataFrom;
              }, function (route) {
                return route.dataFrom;
              });
              routeVariables = this.getRouteVariables(match, routeMatches);
              querySubscriptions = this.updateQuerySubscriptions(queries, routeVariables, cacheConfigs, dataFroms);
              fetches = querySubscriptions.map(function (querySubscription) {
                return querySubscription && querySubscription.fetch();
              });

              if (!Components.some(_isPromise2.default)) {
                _context.next = 14;
                break;
              }

              _context.next = 11;
              return _asyncGenerator3.default.await(_promise2.default.all(Components.map(_ResolverUtils.checkResolved)));

            case 11:
              _context.t0 = _context.sent;
              _context.next = 15;
              break;

            case 14:
              _context.t0 = Components;

            case 15:
              earlyComponents = _context.t0;
              _context.next = 18;
              return _asyncGenerator3.default.await(_promise2.default.all(fetches.map(_ResolverUtils.checkResolved)));

            case 18:
              earlyData = _context.sent;
              fetchedComponents = void 0;

              if (!(!earlyComponents.every(_ResolverUtils.isResolved) || !earlyData.every(_ResolverUtils.isResolved))) {
                _context.next = 31;
                break;
              }

              pendingElements = this.createElements(routeMatches, earlyComponents, querySubscriptions, false);
              _context.next = 24;
              return pendingElements.every(function (element) {
                return element !== undefined;
              }) ? pendingElements : undefined;

            case 24:
              _context.next = 26;
              return _asyncGenerator3.default.await(_promise2.default.all(Components));

            case 26:
              fetchedComponents = _context.sent;
              _context.next = 29;
              return _asyncGenerator3.default.await(_promise2.default.all(fetches));

            case 29:
              _context.next = 32;
              break;

            case 31:
              fetchedComponents = earlyComponents;

            case 32:
              _context.next = 34;
              return this.createElements(routeMatches, fetchedComponents, querySubscriptions, true);

            case 34:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function resolveElements(_x) {
      return _ref.apply(this, arguments);
    }

    return resolveElements;
  }();

  Resolver.prototype.getRouteVariables = function getRouteVariables(match, routeMatches) {
    return (0, _ResolverUtils.accumulateRouteValues)(routeMatches, match.routeIndices, function (variables, routeMatch) {
      var route = routeMatch.route,
          routeParams = routeMatch.routeParams;

      // We need to always run this to make sure we don't miss route params.

      var nextVariables = (0, _extends3.default)({}, variables, routeParams);
      if (route.prepareVariables) {
        nextVariables = route.prepareVariables(nextVariables, routeMatch);
      }

      return nextVariables;
    }, null);
  };

  Resolver.prototype.updateQuerySubscriptions = function updateQuerySubscriptions(queries, routeVariables, cacheConfigs, dataFroms) {
    var _this = this;

    var _environment$unstable = this.environment.unstable_internal,
        createOperationSelector = _environment$unstable.createOperationSelector,
        getRequest = _environment$unstable.getRequest,
        getOperation = _environment$unstable.getOperation;

    // FIXME: Use getRequest directly when only supporting relay >=1.5.0.

    var getRequestOrOperation = getRequest || getOperation;

    var querySubscriptions = queries.map(function (query, i) {
      if (!query) {
        return null;
      }

      var variables = routeVariables[i];

      if (_this.lastQueries[i] === query && (0, _isEqual2.default)(_this.lastRouteVariables[i], variables)) {
        // Match the logic in <QueryRenderer> for not refetching.
        var lastQuerySubscription = _this.lastQuerySubscriptions[i];
        _this.lastQuerySubscriptions[i] = null;
        return lastQuerySubscription;
      }

      return new _QuerySubscription2.default(_this.environment, createOperationSelector(getRequestOrOperation(query), variables), cacheConfigs[i], dataFroms[i]);
    });

    this.lastQuerySubscriptions.forEach(function (querySubscription) {
      if (querySubscription) {
        querySubscription.dispose();
      }
    });

    this.lastQueries = queries;
    this.lastRouteVariables = routeVariables;
    this.lastQuerySubscriptions = querySubscriptions;

    return querySubscriptions;
  };

  Resolver.prototype.createElements = function createElements(routeMatches, Components, querySubscriptions, fetched) {
    return routeMatches.map(function (match, i) {
      var route = match.route;

      var Component = Components[i];
      var querySubscription = querySubscriptions[i];

      var isComponentResolved = (0, _ResolverUtils.isResolved)(Component);

      // Handle non-Relay routes.
      if (!querySubscription) {
        if (route.render) {
          return route.render({
            match: match,
            Component: isComponentResolved ? Component : null,
            props: match
          });
        }

        if (!isComponentResolved) {
          return undefined;
        }

        return Component ? _react2.default.createElement(Component, match) : null;
      }

      var resolvedComponent = isComponentResolved ? Component : null;
      var hasComponent = Component != null;

      var element = (0, _renderElement2.default)({
        match: match,
        Component: resolvedComponent,
        isComponentResolved: isComponentResolved,
        hasComponent: hasComponent,
        readyState: querySubscription.readyState,
        resolving: true
      });

      if (element === undefined) {
        return element;
      }

      return _react2.default.createElement(_ReadyStateRenderer2.default, {
        match: match,
        Component: resolvedComponent,
        isComponentResolved: isComponentResolved,
        hasComponent: hasComponent,
        element: element,
        querySubscription: querySubscription,
        fetched: fetched
      });
    });
  };

  return Resolver;
}();

exports.default = Resolver;
module.exports = exports['default'];

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Resolver = exports.renderElement = exports.ReadyStateRenderer = exports.QuerySubscription = exports.getQueryName = undefined;

var _getQueryName2 = __webpack_require__(630);

var _getQueryName3 = _interopRequireDefault(_getQueryName2);

var _QuerySubscription2 = __webpack_require__(629);

var _QuerySubscription3 = _interopRequireDefault(_QuerySubscription2);

var _ReadyStateRenderer2 = __webpack_require__(961);

var _ReadyStateRenderer3 = _interopRequireDefault(_ReadyStateRenderer2);

var _renderElement2 = __webpack_require__(631);

var _renderElement3 = _interopRequireDefault(_renderElement2);

var _Resolver2 = __webpack_require__(1876);

var _Resolver3 = _interopRequireDefault(_Resolver2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getQueryName = _getQueryName3.default;
exports.QuerySubscription = _QuerySubscription3.default;
exports.ReadyStateRenderer = _ReadyStateRenderer3.default;
exports.renderElement = _renderElement3.default;
exports.Resolver = _Resolver3.default;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277),
    root = __webpack_require__(165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1908),
    hashDelete = __webpack_require__(1909),
    hashGet = __webpack_require__(1910),
    hashHas = __webpack_require__(1911),
    hashSet = __webpack_require__(1912);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277),
    root = __webpack_require__(165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277),
    root = __webpack_require__(165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(962),
    setCacheAdd = __webpack_require__(1932),
    setCacheHas = __webpack_require__(1933);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(420),
    stackClear = __webpack_require__(1935),
    stackDelete = __webpack_require__(1936),
    stackGet = __webpack_require__(1937),
    stackHas = __webpack_require__(1938),
    stackSet = __webpack_require__(1939);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(277),
    root = __webpack_require__(165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1897),
    isArguments = __webpack_require__(1940),
    isArray = __webpack_require__(634),
    isBuffer = __webpack_require__(967),
    isIndex = __webpack_require__(1913),
    isTypedArray = __webpack_require__(971);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1888),
    isArray = __webpack_require__(634);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(422),
    isObjectLike = __webpack_require__(425);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1893),
    isObjectLike = __webpack_require__(425);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1883),
    equalArrays = __webpack_require__(963),
    equalByTag = __webpack_require__(1901),
    equalObjects = __webpack_require__(1902),
    getTag = __webpack_require__(1906),
    isArray = __webpack_require__(634),
    isBuffer = __webpack_require__(967),
    isTypedArray = __webpack_require__(971);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(968),
    isMasked = __webpack_require__(1915),
    isObject = __webpack_require__(970),
    toSource = __webpack_require__(965);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(422),
    isLength = __webpack_require__(969),
    isObjectLike = __webpack_require__(425);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1916),
    nativeKeys = __webpack_require__(1928);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(633),
    Uint8Array = __webpack_require__(1884),
    eq = __webpack_require__(966),
    equalArrays = __webpack_require__(963),
    mapToArray = __webpack_require__(1927),
    setToArray = __webpack_require__(1934);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1903);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1890),
    getSymbols = __webpack_require__(1905),
    keys = __webpack_require__(1943);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(633);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1886),
    stubArray = __webpack_require__(1944);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1878),
    Map = __webpack_require__(632),
    Promise = __webpack_require__(1880),
    Set = __webpack_require__(1881),
    WeakMap = __webpack_require__(1885),
    baseGetTag = __webpack_require__(422),
    toSource = __webpack_require__(965);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(424);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(424);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(424);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(424);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1900);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(421);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(421);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(421);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(421);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1879),
    ListCache = __webpack_require__(420),
    Map = __webpack_require__(632);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(423);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(423);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(423);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(423);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1931);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(964);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(420);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(420),
    Map = __webpack_require__(632),
    MapCache = __webpack_require__(962);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1891),
    isObjectLike = __webpack_require__(425);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(968),
    isLength = __webpack_require__(969);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1892);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1887),
    baseKeys = __webpack_require__(1896),
    isArrayLike = __webpack_require__(1941);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(1949);

var _createChainableTypeChecker = __webpack_require__(1947);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: !0 });
var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.forward_ref") : 60112,
    n = b ? Symbol.for("react.placeholder") : 60113;
function q(a) {
  if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) {
    var p = a.$$typeof;switch (p) {case c:
        switch (a = a.type, a) {case l:case e:case g:case f:
            return a;default:
            switch (a = a && a.$$typeof, a) {case k:case m:case h:
                return a;default:
                return p;}}case d:
        return p;}
  }
}exports.typeOf = q;exports.AsyncMode = l;exports.ContextConsumer = k;exports.ContextProvider = h;exports.Element = c;exports.ForwardRef = m;exports.Fragment = e;exports.Profiler = g;exports.Portal = d;exports.StrictMode = f;
exports.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === l || a === g || a === f || a === n || "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && ("function" === typeof a.then || a.$$typeof === h || a.$$typeof === k || a.$$typeof === m);
};exports.isAsyncMode = function (a) {
  return q(a) === l;
};exports.isContextConsumer = function (a) {
  return q(a) === k;
};exports.isContextProvider = function (a) {
  return q(a) === h;
};exports.isElement = function (a) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function (a) {
  return q(a) === m;
};exports.isFragment = function (a) {
  return q(a) === e;
};exports.isProfiler = function (a) {
  return q(a) === g;
};exports.isPortal = function (a) {
  return q(a) === d;
};exports.isStrictMode = function (a) {
  return q(a) === f;
};

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1948);
} else {
  module.exports = require('./cjs/react-is.development.js');
}

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createConnectedLink = __webpack_require__(978);

var _createConnectedLink2 = _interopRequireDefault(_createConnectedLink);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Link = (0, _createConnectedLink2.default)();
Link.displayName = 'Link';

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(15);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _RedirectException = __webpack_require__(635);

var _RedirectException2 = _interopRequireDefault(_RedirectException);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Redirect = function () {
  function Redirect(_ref) {
    var from = _ref.from,
        to = _ref.to;
    (0, _classCallCheck3.default)(this, Redirect);

    this.path = from;
    this.to = to;
  }

  Redirect.prototype.render = function render(_ref2) {
    var match = _ref2.match;
    var to = this.to;

    var toLocation = void 0;

    if (typeof to === 'function') {
      toLocation = to(match);
    } else {
      var router = match.router,
          params = match.params;

      toLocation = router.matcher.format(to, params);
    }

    throw new _RedirectException2.default(toLocation);
  };

  return Redirect;
}();

exports.default = Redirect;

if (false) {
  // Workaround to make React Proxy give me the original class, to allow
  // makeRouteConfig to get the actual class, when using JSX for routes.
  Redirect.prototype.isReactComponent = {};
}
module.exports = exports['default'];

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createBrowserRouter;

var _BrowserProtocol = __webpack_require__(622);

var _BrowserProtocol2 = _interopRequireDefault(_BrowserProtocol);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createFarceRouter = __webpack_require__(636);

var _createFarceRouter2 = _interopRequireDefault(_createFarceRouter);

var _createRender = __webpack_require__(983);

var _createRender2 = _interopRequireDefault(_createRender);

var _resolver = __webpack_require__(638);

var _resolver2 = _interopRequireDefault(_resolver);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createBrowserRouter(_ref) {
  var render = _ref.render,
      renderPending = _ref.renderPending,
      renderReady = _ref.renderReady,
      renderError = _ref.renderError,
      options = (0, _objectWithoutProperties3.default)(_ref, ['render', 'renderPending', 'renderReady', 'renderError']);

  var FarceRouter = (0, _createFarceRouter2.default)((0, _extends3.default)({}, options, {
    historyProtocol: new _BrowserProtocol2.default(),
    render: render || (0, _createRender2.default)({
      renderPending: renderPending,
      renderReady: renderReady,
      renderError: renderError
    })
  }));

  function BrowserRouter(props) {
    return _react2.default.createElement(FarceRouter, (0, _extends3.default)({}, props, { resolver: _resolver2.default }));
  }

  return BrowserRouter;
}
module.exports = exports['default'];

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(19);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createInitialBrowserRouter;

var _BrowserProtocol = __webpack_require__(622);

var _BrowserProtocol2 = _interopRequireDefault(_BrowserProtocol);

var _createInitialFarceRouter = __webpack_require__(981);

var _createInitialFarceRouter2 = _interopRequireDefault(_createInitialFarceRouter);

var _resolver = __webpack_require__(638);

var _resolver2 = _interopRequireDefault(_resolver);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function createInitialBrowserRouter(options) {
  return (0, _createInitialFarceRouter2.default)((0, _extends3.default)({}, options, {
    historyProtocol: new _BrowserProtocol2.default(),
    resolver: _resolver2.default
  }));
}
module.exports = exports['default'];

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hotRouteConfig;
function hotRouteConfig(routeConfig) {
  if (false) {
    /* eslint-env browser */
    /* eslint-disable no-underscore-dangle */
    window.__FOUND_HOT_RELOAD__ = true;

    if (window.__FOUND_REPLACE_ROUTE_CONFIG__) {
      window.__FOUND_REPLACE_ROUTE_CONFIG__(routeConfig);
    }
    /* eslint-enable no-underscore-dangle */
    /* eslint-env browser: false */
  }

  return routeConfig;
}
module.exports = exports['default'];

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _entries = __webpack_require__(394);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(1586);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = makeRouteConfig;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function buildRouteConfig(node, routeConfig) {
  _react2.default.Children.forEach(node, function (child) {
    if (!_react2.default.isValidElement(child)) {
      return;
    }

    var Type = child.type;
    var _child$props = child.props,
        children = _child$props.children,
        props = (0, _objectWithoutProperties3.default)(_child$props, ['children']);

    if (Type === _react2.default.Fragment) {
      buildRouteConfig(children, routeConfig);
      return;
    }

    if (false) {
      if (Type.prototype.constructor !== Type) {
        // Unwrap proxies from react-proxy. This isn't strictly necessary.
        // eslint-disable-next-line no-param-reassign
        Type = Type.prototype.constructor;
      } else if (
      // eslint-disable-next-line no-underscore-dangle
      Type.__reactstandin__getCurrent) {
        // Unwrap proxies from react-stand-in.
        // eslint-disable-next-line no-param-reassign
        Type = (0, _getPrototypeOf2.default)(Type);
      }
    }

    var route = new Type(props);

    if (children) {
      if (_react2.default.isValidElement(children) || Array.isArray(children)) {
        // eslint-disable-next-line no-use-before-define
        route.children = makeRouteConfig(children);
      } else {
        var routeGroups = {};
        (0, _entries2.default)(children).forEach(function (_ref) {
          var groupName = _ref[0],
              groupRoutes = _ref[1];

          // eslint-disable-next-line no-use-before-define
          routeGroups[groupName] = makeRouteConfig(groupRoutes);
        });

        route.children = routeGroups;
      }
    }

    routeConfig.push(route);
  });

  return routeConfig;
}

/**
 * Create a route configuration from JSX configuration elements.
 */
function makeRouteConfig(node) {
  return buildRouteConfig(node, []);
}
module.exports = exports['default'];

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278),
    root = __webpack_require__(167);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1986),
    hashDelete = __webpack_require__(1987),
    hashGet = __webpack_require__(1988),
    hashHas = __webpack_require__(1989),
    hashSet = __webpack_require__(1990);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278),
    root = __webpack_require__(167);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278),
    root = __webpack_require__(167);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(991),
    setCacheAdd = __webpack_require__(2010),
    setCacheHas = __webpack_require__(2011);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(429),
    stackClear = __webpack_require__(2013),
    stackDelete = __webpack_require__(2014),
    stackGet = __webpack_require__(2015),
    stackHas = __webpack_require__(2016),
    stackSet = __webpack_require__(2017);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(167);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(278),
    root = __webpack_require__(167);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1975),
    isArguments = __webpack_require__(2018),
    isArray = __webpack_require__(641),
    isBuffer = __webpack_require__(996),
    isIndex = __webpack_require__(1991),
    isTypedArray = __webpack_require__(1001);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1966),
    isArray = __webpack_require__(641);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(431),
    isObjectLike = __webpack_require__(434);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1971),
    isObjectLike = __webpack_require__(434);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1961),
    equalArrays = __webpack_require__(992),
    equalByTag = __webpack_require__(1979),
    equalObjects = __webpack_require__(1980),
    getTag = __webpack_require__(1984),
    isArray = __webpack_require__(641),
    isBuffer = __webpack_require__(996),
    isTypedArray = __webpack_require__(1001);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(998),
    isMasked = __webpack_require__(1993),
    isObject = __webpack_require__(1000),
    toSource = __webpack_require__(994);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(431),
    isLength = __webpack_require__(999),
    isObjectLike = __webpack_require__(434);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1994),
    nativeKeys = __webpack_require__(2006);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(167);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(640),
    Uint8Array = __webpack_require__(1962),
    eq = __webpack_require__(995),
    equalArrays = __webpack_require__(992),
    mapToArray = __webpack_require__(2005),
    setToArray = __webpack_require__(2012);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1981);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1968),
    getSymbols = __webpack_require__(1983),
    keys = __webpack_require__(2020);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(640);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1964),
    stubArray = __webpack_require__(2021);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1956),
    Map = __webpack_require__(639),
    Promise = __webpack_require__(1958),
    Set = __webpack_require__(1959),
    WeakMap = __webpack_require__(1963),
    baseGetTag = __webpack_require__(431),
    toSource = __webpack_require__(994);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(433);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(433);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(433);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(433);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1978);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(430);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(430);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(430);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(430);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1957),
    ListCache = __webpack_require__(429),
    Map = __webpack_require__(639);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(432);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(2009);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(993);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(429);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(429),
    Map = __webpack_require__(639),
    MapCache = __webpack_require__(991);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1969),
    isObjectLike = __webpack_require__(434);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(998),
    isLength = __webpack_require__(999);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1965),
    baseKeys = __webpack_require__(1974),
    isArrayLike = __webpack_require__(2019);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function (value) {
  return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function (value) {
  var type = Object.prototype.toString.call(value);

  return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function (value) {
  return typeof value === 'string' || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function (value) {
  var type = Object.prototype.toString.call(value);

  return type === '[object Function]';
};

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(2024);
var delegate = __webpack_require__(1841);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    } else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    } else if (is.string(target)) {
        return listenSelector(target, type, callback);
    } else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function destroy() {
            node.removeEventListener(type, callback);
        }
    };
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function (node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function destroy() {
            Array.prototype.forEach.call(nodeList, function (node) {
                node.removeEventListener(type, callback);
            });
        }
    };
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var key = '__global_unique_id__';

module.exports = function () {
  return global[key] = (global[key] || 0) + 1;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(2028);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (_typeof(origSymbol('foo')) !== 'symbol') {
		return false;
	}
	if (_typeof(Symbol('bar')) !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (_typeof(Symbol.iterator) === 'symbol') {
		return true;
	}

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
var invariant = __webpack_require__(2031);
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function (obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
}
/* istanbul ignore next */
: function (obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && (typeof object === "undefined" ? "undefined" : _typeof(object)) === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object)
    /* istanbul ignore next */
    : object;
}
var Context = /** @class */function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) {
            return x === y;
        };
        this.update.newContext = function () {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function get() {
            return this.update.isEquals;
        },
        set: function set(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), 'update(): You provided an invalid spec to update(). The spec may ' + 'not contain an array except as the value of $set, $push, $unshift, ' + '$splice or any custom command allowing an array value.');
        }
        invariant((typeof spec === "undefined" ? "undefined" : _typeof(spec)) === 'object' && spec !== null, 'update(): You provided an invalid spec to update(). The spec and ' + 'every included key path must be plain objects containing one of the ' + 'following commands: %s.', Object.keys(this.commands).join(', '));
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    } else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function $push(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function $unshift(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function $splice(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function $set(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function $toggle(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function $unset(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function $add(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0],
                    value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        } else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function $remove(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function $merge(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function $apply(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), 'update(): expected target of %s to be an array; got %s.', command, value);
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), 'update(): expected spec of %s to be an array; got %s. ' + 'Did you forget to wrap your parameter in an array?', command, spec);
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), 'Expected $splice target to be an array; got %s', value);
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), 'update(): expected spec of $splice to be an array of arrays; got %s. ' + 'Did you forget to wrap your parameters in an array?', value);
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', 'update(): expected spec of $apply to be a function; got %s.', fn);
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, 'Cannot have more than one key in an object with $set');
}
function invariantMerge(target, specValue) {
    invariant(specValue && (typeof specValue === "undefined" ? "undefined" : _typeof(specValue)) === 'object', 'update(): $merge expects a spec of type \'object\'; got %s', specValue);
    invariant(target && (typeof target === "undefined" ? "undefined" : _typeof(target)) === 'object', 'update(): $merge expects a target of type \'object\'; got %s', target);
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', 'update(): %s expects a target of type Set or Map; got %s', command, typeOfTarget);
}

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value) !== '[object Array]' && toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = function () {
	return isStandardArguments(arguments);
}();

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isDateObject(value) {
	if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var has = __webpack_require__(2035);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isRegex(value) {
	if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(642);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),
/* 2037 */,
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(2039);

var getCountryCode = function getCountryCode(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) {
        return components.pop();
    }
    components = localeString.split("-");
    if (components.length == 2) {
        return components.pop();
    }
    return localeString;
};

exports.getCurrency = function (locale) {
    var countryCode = getCountryCode(locale).toUpperCase();
    if (countryCode in map) {
        return map[countryCode];
    }
    return null;
};

exports.getLocales = function (currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for (countryCode in map) {
        if (map[countryCode] === currencyCode) {
            locales.push(countryCode);
        }
    }
    return locales;
};

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

// Generated using ShowCurrencies.java
var map = {
  AD: 'EUR',
  AE: 'AED',
  AF: 'AFN',
  AG: 'XCD',
  AI: 'XCD',
  AL: 'ALL',
  AM: 'AMD',
  AN: 'ANG',
  AO: 'AOA',
  AR: 'ARS',
  AS: 'USD',
  AT: 'EUR',
  AU: 'AUD',
  AW: 'AWG',
  AX: 'EUR',
  AZ: 'AZN',
  BA: 'BAM',
  BB: 'BBD',
  BD: 'BDT',
  BE: 'EUR',
  BF: 'XOF',
  BG: 'BGN',
  BH: 'BHD',
  BI: 'BIF',
  BJ: 'XOF',
  BL: 'EUR',
  BM: 'BMD',
  BN: 'BND',
  BO: 'BOB',
  BQ: 'USD',
  BR: 'BRL',
  BS: 'BSD',
  BT: 'BTN',
  BV: 'NOK',
  BW: 'BWP',
  BY: 'BYR',
  BZ: 'BZD',
  CA: 'CAD',
  CC: 'AUD',
  CD: 'CDF',
  CF: 'XAF',
  CG: 'XAF',
  CH: 'CHF',
  CI: 'XOF',
  CK: 'NZD',
  CL: 'CLP',
  CM: 'XAF',
  CN: 'CNY',
  CO: 'COP',
  CR: 'CRC',
  CU: 'CUP',
  CV: 'CVE',
  CW: 'ANG',
  CX: 'AUD',
  CY: 'EUR',
  CZ: 'CZK',
  DE: 'EUR',
  DJ: 'DJF',
  DK: 'DKK',
  DM: 'XCD',
  DO: 'DOP',
  DZ: 'DZD',
  EC: 'USD',
  EE: 'EUR',
  EG: 'EGP',
  EH: 'MAD',
  ER: 'ERN',
  ES: 'EUR',
  ET: 'ETB',
  FI: 'EUR',
  FJ: 'FJD',
  FK: 'FKP',
  FM: 'USD',
  FO: 'DKK',
  FR: 'EUR',
  GA: 'XAF',
  GB: 'GBP',
  GD: 'XCD',
  GE: 'GEL',
  GF: 'EUR',
  GG: 'GBP',
  GH: 'GHS',
  GI: 'GIP',
  GL: 'DKK',
  GM: 'GMD',
  GN: 'GNF',
  GP: 'EUR',
  GQ: 'XAF',
  GR: 'EUR',
  GS: 'GBP',
  GT: 'GTQ',
  GU: 'USD',
  GW: 'XOF',
  GY: 'GYD',
  HK: 'HKD',
  HM: 'AUD',
  HN: 'HNL',
  HR: 'HRK',
  HT: 'HTG',
  HU: 'HUF',
  ID: 'IDR',
  IE: 'EUR',
  IL: 'ILS',
  IM: 'GBP',
  IN: 'INR',
  IO: 'USD',
  IQ: 'IQD',
  IR: 'IRR',
  IS: 'ISK',
  IT: 'EUR',
  JE: 'GBP',
  JM: 'JMD',
  JO: 'JOD',
  JP: 'JPY',
  KE: 'KES',
  KG: 'KGS',
  KH: 'KHR',
  KI: 'AUD',
  KM: 'KMF',
  KN: 'XCD',
  KP: 'KPW',
  KR: 'KRW',
  KW: 'KWD',
  KY: 'KYD',
  KZ: 'KZT',
  LA: 'LAK',
  LB: 'LBP',
  LC: 'XCD',
  LI: 'CHF',
  LK: 'LKR',
  LR: 'LRD',
  LS: 'LSL',
  LT: 'LTL',
  LU: 'EUR',
  LV: 'LVL',
  LY: 'LYD',
  MA: 'MAD',
  MC: 'EUR',
  MD: 'MDL',
  ME: 'EUR',
  MF: 'EUR',
  MG: 'MGA',
  MH: 'USD',
  MK: 'MKD',
  ML: 'XOF',
  MM: 'MMK',
  MN: 'MNT',
  MO: 'MOP',
  MP: 'USD',
  MQ: 'EUR',
  MR: 'MRO',
  MS: 'XCD',
  MT: 'EUR',
  MU: 'MUR',
  MV: 'MVR',
  MW: 'MWK',
  MX: 'MXN',
  MY: 'MYR',
  MZ: 'MZN',
  NA: 'NAD',
  NC: 'XPF',
  NE: 'XOF',
  NF: 'AUD',
  NG: 'NGN',
  NI: 'NIO',
  NL: 'EUR',
  NO: 'NOK',
  NP: 'NPR',
  NR: 'AUD',
  NU: 'NZD',
  NZ: 'NZD',
  OM: 'OMR',
  PA: 'PAB',
  PE: 'PEN',
  PF: 'XPF',
  PG: 'PGK',
  PH: 'PHP',
  PK: 'PKR',
  PL: 'PLN',
  PM: 'EUR',
  PN: 'NZD',
  PR: 'USD',
  PS: 'ILS',
  PT: 'EUR',
  PW: 'USD',
  PY: 'PYG',
  QA: 'QAR',
  RE: 'EUR',
  RO: 'RON',
  RS: 'RSD',
  RU: 'RUB',
  RW: 'RWF',
  SA: 'SAR',
  SB: 'SBD',
  SC: 'SCR',
  SD: 'SDG',
  SE: 'SEK',
  SG: 'SGD',
  SH: 'SHP',
  SI: 'EUR',
  SJ: 'NOK',
  SK: 'EUR',
  SL: 'SLL',
  SM: 'EUR',
  SN: 'XOF',
  SO: 'SOS',
  SR: 'SRD',
  ST: 'STD',
  SV: 'SVC',
  SX: 'ANG',
  SY: 'SYP',
  SZ: 'SZL',
  TC: 'USD',
  TD: 'XAF',
  TF: 'EUR',
  TG: 'XOF',
  TH: 'THB',
  TJ: 'TJS',
  TK: 'NZD',
  TL: 'USD',
  TM: 'TMT',
  TN: 'TND',
  TO: 'TOP',
  TR: 'TRY',
  TT: 'TTD',
  TV: 'AUD',
  TW: 'TWD',
  TZ: 'TZS',
  UA: 'UAH',
  UG: 'UGX',
  UM: 'USD',
  US: 'USD',
  UY: 'UYU',
  UZ: 'UZS',
  VA: 'EUR',
  VC: 'XCD',
  VE: 'VEF',
  VG: 'USD',
  VI: 'USD',
  VN: 'VND',
  VU: 'VUV',
  WF: 'XPF',
  WS: 'WST',
  YE: 'YER',
  YT: 'EUR',
  ZA: 'ZAR',
  ZM: 'ZMK',
  ZW: 'ZWL'
};

module.exports = map;

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(2044);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(2045);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(1002);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(2041);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237),
    root = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2117),
    hashDelete = __webpack_require__(2118),
    hashGet = __webpack_require__(2119),
    hashHas = __webpack_require__(2120),
    hashSet = __webpack_require__(2121);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(237),
    root = __webpack_require__(104);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    keys = __webpack_require__(283);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    keysIn = __webpack_require__(338);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(438),
    arrayEach = __webpack_require__(648),
    assignValue = __webpack_require__(651),
    baseAssign = __webpack_require__(2055),
    baseAssignIn = __webpack_require__(2056),
    cloneBuffer = __webpack_require__(1021),
    copyArray = __webpack_require__(445),
    copySymbols = __webpack_require__(2094),
    copySymbolsIn = __webpack_require__(2095),
    getAllKeys = __webpack_require__(1032),
    getAllKeysIn = __webpack_require__(1033),
    getTag = __webpack_require__(1036),
    initCloneArray = __webpack_require__(2122),
    initCloneByTag = __webpack_require__(2123),
    initCloneObject = __webpack_require__(1037),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(336),
    isObject = __webpack_require__(110),
    keys = __webpack_require__(283);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(647),
    arrayIncludes = __webpack_require__(649),
    arrayIncludesWith = __webpack_require__(1007),
    arrayMap = __webpack_require__(440),
    baseUnary = __webpack_require__(444),
    cacheHas = __webpack_require__(655);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1013),
    baseIsNaN = __webpack_require__(2065),
    strictIndexOf = __webpack_require__(2154);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(438),
    equalArrays = __webpack_require__(1029),
    equalByTag = __webpack_require__(2109),
    equalObjects = __webpack_require__(2110),
    getTag = __webpack_require__(1036),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(336),
    isTypedArray = __webpack_require__(454);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(438),
    baseIsEqual = __webpack_require__(653);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(197),
    isMasked = __webpack_require__(2128),
    isObject = __webpack_require__(110),
    toSource = __webpack_require__(1048);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isLength = __webpack_require__(664),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(660),
    nativeKeys = __webpack_require__(2141);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(110),
    isPrototype = __webpack_require__(660),
    nativeKeysIn = __webpack_require__(2142);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1012),
    isArrayLike = __webpack_require__(238);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2064),
    getMatchData = __webpack_require__(2112),
    matchesStrictComparable = __webpack_require__(1040);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(653),
    get = __webpack_require__(1050),
    hasIn = __webpack_require__(1051),
    isKey = __webpack_require__(659),
    isStrictComparable = __webpack_require__(1038),
    matchesStrictComparable = __webpack_require__(1040),
    toKey = __webpack_require__(281);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(438),
    assignMergeValue = __webpack_require__(1011),
    baseFor = __webpack_require__(1015),
    baseMergeDeep = __webpack_require__(2074),
    isObject = __webpack_require__(110),
    keysIn = __webpack_require__(338);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack());
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(object[key], srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(1011),
    cloneBuffer = __webpack_require__(1021),
    cloneTypedArray = __webpack_require__(1022),
    copyArray = __webpack_require__(445),
    initCloneObject = __webpack_require__(1037),
    isArguments = __webpack_require__(452),
    isArray = __webpack_require__(80),
    isArrayLikeObject = __webpack_require__(1052),
    isBuffer = __webpack_require__(336),
    isFunction = __webpack_require__(197),
    isObject = __webpack_require__(110),
    isPlainObject = __webpack_require__(453),
    isTypedArray = __webpack_require__(454),
    toPlainObject = __webpack_require__(2176);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || srcIndex && isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(440),
    baseIteratee = __webpack_require__(235),
    baseMap = __webpack_require__(2070),
    baseSortBy = __webpack_require__(2083),
    baseUnary = __webpack_require__(444),
    compareMultiple = __webpack_require__(2093),
    identity = __webpack_require__(335);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(2077),
    hasIn = __webpack_require__(1051);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(443),
    baseSet = __webpack_require__(1017),
    castPath = __webpack_require__(280);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
    var index = -1,
        length = paths.length,
        result = {};

    while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
        }
    }
    return result;
}

module.exports = basePickBy;

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(443);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2160),
    defineProperty = __webpack_require__(1028),
    identity = __webpack_require__(335);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1012);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function (value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279),
    arrayMap = __webpack_require__(440),
    isArray = __webpack_require__(80),
    isSymbol = __webpack_require__(337);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(280),
    last = __webpack_require__(666),
    parent = __webpack_require__(2144),
    toKey = __webpack_require__(281);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(656);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(2052),
    arrayReduce = __webpack_require__(1009),
    mapToArray = __webpack_require__(1039);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor());
}

module.exports = cloneMap;

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(2053),
    arrayReduce = __webpack_require__(1009),
    setToArray = __webpack_require__(451);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor());
}

module.exports = cloneSet;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(337);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(2092);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    getSymbols = __webpack_require__(658);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    getSymbolsIn = __webpack_require__(1035);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(104);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(238);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(446),
    root = __webpack_require__(104);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(439),
    createCtor = __webpack_require__(446),
    createHybrid = __webpack_require__(1026),
    createRecurry = __webpack_require__(1027),
    getHolder = __webpack_require__(657),
    replaceHolders = __webpack_require__(450),
    root = __webpack_require__(104);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
    }
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(235),
    isArrayLike = __webpack_require__(238),
    keys = __webpack_require__(283);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(439),
    createCtor = __webpack_require__(446),
    root = __webpack_require__(104);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = this && this !== root && this instanceof wrapper ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(2080),
    isIterateeCall = __webpack_require__(334),
    toFinite = __webpack_require__(1056);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(1004),
    noop = __webpack_require__(1054),
    setToArray = __webpack_require__(451);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
  return new Set(values);
};

module.exports = createSet;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1018),
    createBind = __webpack_require__(2100),
    createCurry = __webpack_require__(2101),
    createHybrid = __webpack_require__(1026),
    createPartial = __webpack_require__(2103),
    getData = __webpack_require__(1034),
    mergeData = __webpack_require__(2140),
    setData = __webpack_require__(1045),
    setWrapToString = __webpack_require__(1046),
    toInteger = __webpack_require__(668);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(282);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(453);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279),
    Uint8Array = __webpack_require__(1005),
    eq = __webpack_require__(282),
    equalArrays = __webpack_require__(1029),
    mapToArray = __webpack_require__(1039),
    setToArray = __webpack_require__(451);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1032);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(2145);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = func.name + '',
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1038),
    keys = __webpack_require__(283);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(280),
    isArguments = __webpack_require__(452),
    isArray = __webpack_require__(80),
    isIndex = __webpack_require__(333),
    isLength = __webpack_require__(664),
    toKey = __webpack_require__(281);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

module.exports = hasPath;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(656),
    cloneDataView = __webpack_require__(2087),
    cloneMap = __webpack_require__(2088),
    cloneRegExp = __webpack_require__(2089),
    cloneSet = __webpack_require__(2090),
    cloneSymbol = __webpack_require__(2091),
    cloneTypedArray = __webpack_require__(1022);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(279),
    isArguments = __webpack_require__(452),
    isArray = __webpack_require__(80);

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(644),
    getData = __webpack_require__(1034),
    getFuncName = __webpack_require__(2111),
    lodash = __webpack_require__(2182);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2096);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(441);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(441);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(441);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(441);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2050),
    ListCache = __webpack_require__(437),
    Map = __webpack_require__(645);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(447);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(447);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(447);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(447);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1053);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1023),
    composeArgsRight = __webpack_require__(1024),
    replaceHolders = __webpack_require__(450);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1043);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(443),
    baseSlice = __webpack_require__(1019);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(445),
    isIndex = __webpack_require__(333);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(437);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(437),
    Map = __webpack_require__(645),
    MapCache = __webpack_require__(646);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2139);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(648),
    arrayIncludes = __webpack_require__(649);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function (pair) {
    var value = '_.' + pair[0];
    if (bitmask & pair[1] && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(644),
    LodashWrapper = __webpack_require__(1003),
    copyArray = __webpack_require__(445);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__ = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    createAssigner = __webpack_require__(1025),
    keysIn = __webpack_require__(338);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1019),
    isIterateeCall = __webpack_require__(334),
    toInteger = __webpack_require__(668);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, index += size);
  }
  return result;
}

module.exports = chunk;

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(439),
    assignInWith = __webpack_require__(2158),
    baseRest = __webpack_require__(332),
    customDefaultsAssignIn = __webpack_require__(2107);

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function (args) {
  args.push(undefined, customDefaultsAssignIn);
  return apply(assignInWith, undefined, args);
});

module.exports = defaults;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1014);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__(2062),
    baseUnary = __webpack_require__(444),
    nodeUtil = __webpack_require__(1042);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(168),
    isArray = __webpack_require__(80),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(442),
    baseForOwn = __webpack_require__(652),
    baseIteratee = __webpack_require__(235);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(2073),
    createAssigner = __webpack_require__(1025);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(440),
    baseClone = __webpack_require__(2057),
    baseUnset = __webpack_require__(2086),
    castPath = __webpack_require__(280),
    copyObject = __webpack_require__(236),
    customOmitClone = __webpack_require__(2108),
    flatRest = __webpack_require__(1030),
    getAllKeysIn = __webpack_require__(1033);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function (path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(332),
    createWrap = __webpack_require__(2106),
    getHolder = __webpack_require__(657),
    replaceHolders = __webpack_require__(450);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function (func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

module.exports = partialRight;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(2076),
    flatRest = __webpack_require__(1030);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2078),
    basePropertyDeep = __webpack_require__(2079),
    isKey = __webpack_require__(659),
    toKey = __webpack_require__(281);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(2104);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(1017);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(1010),
    baseIteratee = __webpack_require__(235),
    baseSome = __webpack_require__(2082),
    isArray = __webpack_require__(80),
    isIterateeCall = __webpack_require__(334);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(110),
    isSymbol = __webpack_require__(337);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(236),
    keysIn = __webpack_require__(338);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2085);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(648),
    baseCreate = __webpack_require__(331),
    baseForOwn = __webpack_require__(652),
    baseIteratee = __webpack_require__(235),
    getPrototype = __webpack_require__(448),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(336),
    isFunction = __webpack_require__(197),
    isObject = __webpack_require__(110),
    isTypedArray = __webpack_require__(454);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor() : [];
    } else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    } else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1020);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}

module.exports = uniq;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(235),
    baseUniq = __webpack_require__(1020);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(2058),
    baseRest = __webpack_require__(332),
    isArrayLikeObject = __webpack_require__(1052);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function (array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});

module.exports = without;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(644),
    LodashWrapper = __webpack_require__(1003),
    baseLodash = __webpack_require__(654),
    isArray = __webpack_require__(80),
    isObjectLike = __webpack_require__(135),
    wrapperClone = __webpack_require__(2157);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) {
        isEqual = areInputsEqual;
    }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment-timezone.js
//! version : 0.5.26
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/

	if (( false ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(2)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	} else {
		factory(root.moment); // Browser
	}
})(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.26",
	    zones = {},
	    links = {},
	    names = {},
	    guesses = {},
	    cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
	    major = +momentVersion[0],
	    minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || major === 2 && minor < 6) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
 	Unpacking
 ************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
		    parts = string.split('.'),
		    whole = parts[0],
		    fractional = parts[1] || '',
		    multiplier = 1,
		    num,
		    out = 0,
		    sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt(array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil(array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices(source, indices) {
		var out = [],
		    i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack(string) {
		var data = string.split('|'),
		    offsets = data[2].split(' '),
		    indices = data[3].split(''),
		    untils = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name: data[0],
			abbrs: mapIndices(data[1].split(' '), indices),
			offsets: mapIndices(offsets, indices),
			untils: untils,
			population: data[5] | 0
		};
	}

	/************************************
 	Zone object
 ************************************/

	function Zone(packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set: function _set(unpacked) {
			this.name = unpacked.name;
			this.abbrs = unpacked.abbrs;
			this.untils = unpacked.untils;
			this.offsets = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index: function _index(timestamp) {
			var target = +timestamp,
			    untils = this.untils,
			    i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse: function parse(timestamp) {
			var target = +timestamp,
			    offsets = this.offsets,
			    untils = this.untils,
			    max = untils.length - 1,
			    offset,
			    offsetNext,
			    offsetPrev,
			    i;

			for (i = 0; i < max; i++) {
				offset = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - offset * 60000) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr: function abbr(mom) {
			return this.abbrs[this._index(mom)];
		},

		offset: function offset(mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset: function utcOffset(mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
 	Current Timezone
 ************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while (diff = ((high.at - low.at) / 12e4 | 0) * 6e4) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
		    last = new OffsetAt(new Date(startYear, 0, 1)),
		    offsets = [last],
		    change,
		    next,
		    i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores(a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses(name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets(offsets) {
		var offsetsLength = offsets.length,
		    filteredGuesses = {},
		    out = [],
		    i,
		    j,
		    guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess() {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
		    offsetsLength = offsets.length,
		    guesses = guessesForUserOffsets(offsets),
		    zoneScores = [],
		    zoneScore,
		    i,
		    j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess(ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
 	Global Methods
 ************************************/

	function normalizeName(name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone(packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone(name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames() {
		var i,
		    out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink(aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData(data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists(name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
			logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset(m) {
		var isUnixTimestamp = m._f === 'X' || m._f === 'x';
		return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
	}

	function logError(message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
 	moment.tz namespace
 ************************************/

	function tz(input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
		    name = arguments[arguments.length - 1],
		    zone = getZone(name),
		    out = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version = VERSION;
	tz.dataVersion = '';
	tz._zones = zones;
	tz._links = links;
	tz._names = names;
	tz.add = addZone;
	tz.link = addLink;
	tz.load = loadData;
	tz.zone = getZone;
	tz.zoneExists = zoneExists; // deprecated in 0.1.0
	tz.guess = guess;
	tz.names = getNames;
	tz.Zone = Zone;
	tz.unpack = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset = needsOffset;
	tz.moveInvalidForward = true;
	tz.moveAmbiguousForward = false;

	/************************************
 	Interface with Moment.js
 ************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
		    offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) {
			return this._z.name;
		}
	};

	function abbrWrap(old) {
		return function () {
			if (this._z) {
				return this._z.abbr(this);
			}
			return old.call(this);
		};
	}

	function resetZoneWrap(old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2(old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc = resetZoneWrap(fn.utc);
	fn.local = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function (name) {
		if (major < 2 || major === 2 && minor < 9) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is

var numberIsNaN = function numberIsNaN(value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(1173); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
	var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = function () {
		/* global window */
		if (typeof window === 'undefined') {
			return false;
		}
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && _typeof(window[k]) === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}();
	var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isarray = __webpack_require__(2188);

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2191);

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);

//# sourceMappingURL=performance-now.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(339)))

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1177);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
}

function isString(str) {
  return typeof str === 'string';
}

var Step = function (_React$Component) {
  _inherits(Step, _React$Component);

  function Step() {
    _classCallCheck(this, Step);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Step.prototype.render = function render() {
    var _classNames, _classNames2;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        style = _props.style,
        itemWidth = _props.itemWidth,
        _props$status = _props.status,
        status = _props$status === undefined ? 'wait' : _props$status,
        iconPrefix = _props.iconPrefix,
        icon = _props.icon,
        wrapperStyle = _props.wrapperStyle,
        adjustMarginRight = _props.adjustMarginRight,
        stepNumber = _props.stepNumber,
        description = _props.description,
        title = _props.title,
        progressDot = _props.progressDot,
        restProps = _objectWithoutProperties(_props, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot']);

    var iconClassName = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls + '-icon', true), _defineProperty(_classNames, iconPrefix + 'icon', true), _defineProperty(_classNames, iconPrefix + 'icon-' + icon, icon && isString(icon)), _defineProperty(_classNames, iconPrefix + 'icon-check', !icon && status === 'finish'), _defineProperty(_classNames, iconPrefix + 'icon-cross', !icon && status === 'error'), _classNames));

    var iconNode = void 0;
    var iconDot = _react2["default"].createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (!!progressDot) {
      if (typeof progressDot === 'function') {
        iconNode = _react2["default"].createElement('span', { className: prefixCls + '-icon' }, progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description }));
      } else {
        iconNode = _react2["default"].createElement('span', { className: prefixCls + '-icon' }, iconDot);
      }
    } else if (icon && !isString(icon)) {
      iconNode = _react2["default"].createElement('span', { className: prefixCls + '-icon' }, icon);
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = _react2["default"].createElement('span', { className: iconClassName });
    } else {
      iconNode = _react2["default"].createElement('span', { className: prefixCls + '-icon' }, stepNumber);
    }
    var classString = (0, _classnames2["default"])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-status-' + status, true), _defineProperty(_classNames2, prefixCls + '-custom', icon), _defineProperty(_classNames2, className, !!className), _classNames2));
    return _react2["default"].createElement('div', _extends({}, restProps, {
      className: classString,
      style: _extends({ width: itemWidth, marginRight: adjustMarginRight }, style)
    }), _react2["default"].createElement('div', {
      ref: 'tail',
      className: prefixCls + '-tail',
      style: { paddingRight: -adjustMarginRight }
    }, _react2["default"].createElement('i', null)), _react2["default"].createElement('div', { className: prefixCls + '-step' }, _react2["default"].createElement('div', {
      className: prefixCls + '-head',
      style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
    }, _react2["default"].createElement('div', { className: prefixCls + '-head-inner' }, iconNode)), _react2["default"].createElement('div', { ref: 'main', className: prefixCls + '-main' }, _react2["default"].createElement('div', {
      className: prefixCls + '-title',
      style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
    }, title), description ? _react2["default"].createElement('div', { className: prefixCls + '-description' }, description) : '')));
  };

  return Step;
}(_react2["default"].Component);

exports["default"] = Step;

Step.propTypes = {
  className: _propTypes2["default"].string,
  prefixCls: _propTypes2["default"].string,
  style: _propTypes2["default"].object,
  wrapperStyle: _propTypes2["default"].object,
  itemWidth: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  status: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  icon: _propTypes2["default"].node,
  adjustMarginRight: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  stepNumber: _propTypes2["default"].string,
  description: _propTypes2["default"].any,
  title: _propTypes2["default"].any,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};
module.exports = exports['default'];

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1177);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(2048);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
}

var Steps = function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps(props) {
    _classCallCheck(this, Steps);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.calcStepOffsetWidth = function () {
      var domNode = _reactDom2["default"].findDOMNode(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = (0, _lodash2["default"])(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var props = this.props;

    var prefixCls = props.prefixCls,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = props.className,
        children = props.children,
        direction = props.direction,
        labelPlacement = props.labelPlacement,
        iconPrefix = props.iconPrefix,
        status = props.status,
        size = props.size,
        current = props.current,
        progressDot = props.progressDot,
        restProps = _objectWithoutProperties(props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot']);

    var filteredChildren = _react2["default"].Children.toArray(children).filter(function (c) {
      return !!c;
    });
    var lastIndex = filteredChildren.length - 1;
    var reLayouted = this.state.lastStepOffsetWidth > 0;
    var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
    var classString = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, prefixCls + '-' + size, size), _defineProperty(_classNames, prefixCls + '-' + direction, true), _defineProperty(_classNames, prefixCls + '-label-' + adjustedlabelPlacement, direction === 'horizontal'), _defineProperty(_classNames, prefixCls + '-hidden', !reLayouted), _defineProperty(_classNames, prefixCls + '-dot', !!progressDot), _defineProperty(_classNames, className, className), _classNames));

    return _react2["default"].createElement('div', _extends({ className: classString, style: style }, restProps), _react2["default"].Children.map(filteredChildren, function (ele, idx) {
      if (!ele) {
        return null;
      }
      var itemWidth = direction === 'vertical' || idx === lastIndex || !reLayouted ? null : 100 / lastIndex + '%';
      var adjustMarginRight = direction === 'vertical' || idx === lastIndex ? null : -Math.round(_this2.state.lastStepOffsetWidth / lastIndex + 1);
      var np = {
        stepNumber: (idx + 1).toString(),
        itemWidth: itemWidth,
        adjustMarginRight: adjustMarginRight,
        prefixCls: prefixCls,
        iconPrefix: iconPrefix,
        wrapperStyle: style,
        progressDot: progressDot
      };

      // fix tail color
      if (status === 'error' && idx === current - 1) {
        np.className = props.prefixCls + '-next-error';
      }

      if (!ele.props.status) {
        if (idx === current) {
          np.status = status;
        } else if (idx < current) {
          np.status = 'finish';
        } else {
          np.status = 'wait';
        }
      }
      return _react2["default"].cloneElement(ele, np);
    }, this));
  };

  return Steps;
}(_react2["default"].Component);

exports["default"] = Steps;

Steps.propTypes = {
  prefixCls: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  direction: _propTypes2["default"].string,
  labelPlacement: _propTypes2["default"].string,
  children: _propTypes2["default"].any,
  status: _propTypes2["default"].string,
  size: _propTypes2["default"].string,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};

Steps.defaultProps = {
  prefixCls: 'rc-steps',
  iconPrefix: 'rc',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  current: 0,
  status: 'process',
  size: '',
  progressDot: false
};
module.exports = exports['default'];

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Steps = __webpack_require__(2194);

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = __webpack_require__(2193);

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

_Steps2["default"].Step = _Step2["default"];
exports["default"] = _Steps2["default"];
module.exports = exports['default'];

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2197);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export config */
/* unused harmony export getPixelThresholds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_schd__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_best_scrollable_droppable__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__can_scroll__ = __webpack_require__(1180);







var config = {
  startFrom: 0.25,
  maxSpeedAt: 0.05,

  maxScrollSpeed: 28,

  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  }
};

var origin = { x: 0, y: 0 };

var clean = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["g" /* apply */])(function (value) {
  return value === 0 ? 0 : value;
});

var getPixelThresholds = function getPixelThresholds(container, axis) {
  var startFrom = container[axis.size] * config.startFrom;
  var maxSpeedAt = container[axis.size] * config.maxSpeedAt;
  var accelerationPlane = startFrom - maxSpeedAt;

  var thresholds = {
    startFrom: startFrom,
    maxSpeedAt: maxSpeedAt,
    accelerationPlane: accelerationPlane
  };

  return thresholds;
};

var getSpeed = function getSpeed(distance, thresholds) {
  if (distance >= thresholds.startFrom) {
    return 0;
  }

  if (distance <= thresholds.maxSpeedAt) {
    return config.maxScrollSpeed;
  }

  var distancePastStart = thresholds.startFrom - distance;
  var percentage = distancePastStart / thresholds.accelerationPlane;
  var transformed = config.ease(percentage);

  var speed = config.maxScrollSpeed * transformed;

  return speed;
};

var adjustForSizeLimits = function adjustForSizeLimits(_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;

  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};

var getRequiredScroll = function getRequiredScroll(_ref2) {
  var container = _ref2.container,
      subject = _ref2.subject,
      center = _ref2.center;

  var distance = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };

  var y = function () {
    var thresholds = getPixelThresholds(container, __WEBPACK_IMPORTED_MODULE_3__axis__["a" /* vertical */]);
    var isCloserToBottom = distance.bottom < distance.top;

    if (isCloserToBottom) {
      return getSpeed(distance.bottom, thresholds);
    }

    return -1 * getSpeed(distance.top, thresholds);
  }();

  var x = function () {
    var thresholds = getPixelThresholds(container, __WEBPACK_IMPORTED_MODULE_3__axis__["b" /* horizontal */]);
    var isCloserToRight = distance.right < distance.left;

    if (isCloserToRight) {
      return getSpeed(distance.right, thresholds);
    }

    return -1 * getSpeed(distance.left, thresholds);
  }();

  var required = clean({ x: x, y: y });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["d" /* isEqual */])(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["d" /* isEqual */])(limited, origin) ? null : limited;
};

var withPlaceholder = function withPlaceholder(droppable, draggable) {
  var closest = droppable.viewport.closestScrollable;

  if (!closest) {
    return null;
  }

  var isOverHome = droppable.descriptor.id === draggable.descriptor.droppableId;
  var max = closest.scroll.max;
  var current = closest.scroll.current;

  if (isOverHome) {
    return { max: max, current: current };
  }

  var spaceForPlaceholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["e" /* patch */])(droppable.axis.line, draggable.placeholder.paddingBox[droppable.axis.size]);

  var newMax = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["c" /* add */])(max, spaceForPlaceholder);

  var newCurrent = {
    x: Math.min(current.x, newMax.x),
    y: Math.min(current.y, newMax.y)
  };

  return {
    max: newMax,
    current: newCurrent
  };
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref3) {
  var scrollWindow = _ref3.scrollWindow,
      scrollDroppable = _ref3.scrollDroppable;

  var scheduleWindowScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_raf_schd__["a" /* default */])(scrollWindow);
  var scheduleDroppableScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_raf_schd__["a" /* default */])(scrollDroppable);

  var scroller = function scroller(state) {
    var drag = state.drag;
    if (!drag) {
      console.error('Invalid drag state');
      return;
    }

    var center = drag.current.page.center;

    var draggable = state.dimension.draggable[drag.initial.descriptor.id];
    var subject = draggable.page.marginBox;
    var viewport = drag.current.viewport;
    var requiredWindowScroll = getRequiredScroll({
      container: viewport.subject,
      subject: subject,
      center: center
    });

    if (requiredWindowScroll && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__can_scroll__["c" /* canScrollWindow */])(viewport, requiredWindowScroll)) {
      scheduleWindowScroll(requiredWindowScroll);
      return;
    }

    var droppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_best_scrollable_droppable__["a" /* default */])({
      center: center,
      destination: drag.impact.destination,
      droppables: state.dimension.droppable
    });

    if (!droppable) {
      return;
    }

    var closestScrollable = droppable.viewport.closestScrollable;

    if (!closestScrollable) {
      return;
    }

    var requiredFrameScroll = getRequiredScroll({
      container: closestScrollable.frame,
      subject: subject,
      center: center
    });

    if (!requiredFrameScroll) {
      return;
    }

    var result = withPlaceholder(droppable, draggable);

    if (!result) {
      return;
    }

    var canScrollDroppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__can_scroll__["e" /* canPartiallyScroll */])({
      max: result.max,
      current: result.current,
      change: requiredFrameScroll
    });

    if (canScrollDroppable) {
      scheduleDroppableScroll(droppable.descriptor.id, requiredFrameScroll);
    }
  };

  scroller.cancel = function () {
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };

  return scroller;
});

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visibility_is_position_in_frame__ = __webpack_require__(1187);





var getScrollableDroppables = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(function (droppables) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(droppables).map(function (id) {
    return droppables[id];
  }).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.viewport.closestScrollable) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = getScrollableDroppables(droppables).find(function (droppable) {
    if (!droppable.viewport.closestScrollable) {
      throw new Error('Invalid result');
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__visibility_is_position_in_frame__["a" /* default */])(droppable.viewport.closestScrollable.frame)(target);
  });

  return maybe;
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination.droppableId];
    if (!_dimension.viewport.closestScrollable) {
      return null;
    }
    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);

  return dimension;
});

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fluid_scroller__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jump_scroller__ = __webpack_require__(2201);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;

  var fluidScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fluid_scroller__["a" /* default */])({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var jumpScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jump_scroller__["a" /* default */])({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var onStateChange = function onStateChange(previous, current) {
    if (current.phase === 'DRAGGING') {
      if (!current.drag) {
        console.error('invalid drag state');
        return;
      }

      if (current.drag.initial.autoScrollMode === 'FLUID') {
        fluidScroll(current);
        return;
      }

      if (!current.drag.scrollJumpRequest) {
        return;
      }

      jumpScroll(current);
      return;
    }

    if (previous.phase === 'DRAGGING' && current.phase !== 'DRAGGING') {
      fluidScroll.cancel();
    }
  };

  var marshal = {
    onStateChange: onStateChange
  };

  return marshal;
});

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__can_scroll__ = __webpack_require__(1180);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var drag = state.drag;
    if (!drag) {
      console.error('Cannot move by offset when not dragging');
      return;
    }

    var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["c" /* add */])(drag.current.client.selection, offset);
    move(drag.initial.descriptor.id, client, drag.current.viewport, true);
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__can_scroll__["a" /* canScrollDroppable */])(droppable, change)) {
      return change;
    }

    var overlap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__can_scroll__["b" /* getDroppableOverlap */])(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);

    var remainder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(viewport, change) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__can_scroll__["c" /* canScrollWindow */])(viewport, change)) {
      return change;
    }

    var overlap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__can_scroll__["d" /* getWindowOverlap */])(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(change, overlap);
    scrollWindow(whatTheWindowCanScroll);

    var remainder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["b" /* subtract */])(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var drag = state.drag;

    if (!drag) {
      return;
    }

    var request = drag.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = drag.impact.destination;

    if (!destination) {
      console.error('Cannot perform a jump scroll when there is no destination');
      return;
    }

    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimension.droppable[destination.droppableId], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = drag.current.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (state, id) {
  var phase = state.phase;

  if (phase === 'IDLE' || phase === 'DROP_COMPLETE') {
    return true;
  }

  if (phase === 'PREPARING' || phase === 'COLLECTING_INITIAL_DIMENSIONS' || phase === 'DRAGGING') {
    return false;
  }

  if (phase === 'DROP_ANIMATING') {
    if (!state.drop || !state.drop.pending) {
      console.error('Invalid state shape for drop animating');
      return false;
    }

    if (state.drop.pending.result.draggableId === id) {
      return false;
    }

    return state.drop.pending.result.reason === 'DROP';
  }

  console.warn('unhandled phase ' + phase + ' in canLift check');
  return false;
});

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(2221);






var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_1_redux__["a" /* compose */];

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* default */], composeEnhancers(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a)));
});

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["a"] = (function (callbacks) {
  var state = {
    droppables: {},
    draggables: {},
    isCollecting: false,
    scrollOptions: null,
    request: null,
    frameId: null
  };

  var setState = function setState(partial) {
    var newState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, partial);
    state = newState;
  };

  var cancel = function cancel() {
    var _console;

    (_console = console).error.apply(_console, arguments);

    if (!state.isCollecting) {
      return;
    }

    stopCollecting();
    callbacks.cancel();
  };

  var registerDraggable = function registerDraggable(descriptor, getDimension) {
    var _extends2;

    var id = descriptor.id;

    if (!state.droppables[descriptor.droppableId]) {
      cancel('Cannot register Draggable ' + id + ' as there is no entry for the Droppable ' + descriptor.droppableId);
      return;
    }

    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    var draggables = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.draggables, (_extends2 = {}, _extends2[id] = entry, _extends2));

    setState({
      draggables: draggables
    });

    if (!state.isCollecting) {
      return;
    }

    console.warn('Adding a draggable during a drag is currently not supported');
  };

  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
    var _extends3;

    var id = descriptor.id;

    var entry = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };

    var droppables = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.droppables, (_extends3 = {}, _extends3[id] = entry, _extends3));

    setState({
      droppables: droppables
    });

    if (!state.isCollecting) {
      return;
    }

    console.warn('Currently not supporting updating Droppables during a drag');
  };

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    if (!state.droppables[id]) {
      cancel('Cannot update the scroll on Droppable ' + id + ' as it is not registered');
      return;
    }

    if (!state.isCollecting) {
      return;
    }
    callbacks.updateDroppableIsEnabled(id, isEnabled);
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!state.droppables[id]) {
      cancel('Cannot update the scroll on Droppable ' + id + ' as it is not registered');
      return;
    }

    if (!state.isCollecting) {
      return;
    }
    callbacks.updateDroppableScroll(id, newScroll);
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    var entry = state.droppables[id];
    if (!entry) {
      return;
    }

    if (!state.isCollecting) {
      return;
    }

    entry.callbacks.scroll(change);
  };

  var unregisterDraggable = function unregisterDraggable(descriptor) {
    var entry = state.draggables[descriptor.id];

    if (!entry) {
      cancel('Cannot unregister Draggable with id ' + descriptor.id + ' as it is not registered');
      return;
    }

    if (entry.descriptor !== descriptor) {
      return;
    }

    var newMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.draggables);
    delete newMap[descriptor.id];

    setState({
      draggables: newMap
    });

    if (!state.isCollecting) {
      return;
    }

    console.warn('currently not supporting unmounting a Draggable during a drag');
  };

  var unregisterDroppable = function unregisterDroppable(descriptor) {
    var entry = state.droppables[descriptor.id];

    if (!entry) {
      cancel('Cannot unregister Droppable with id ' + descriptor.id + ' as as it is not registered');
      return;
    }

    if (entry.descriptor !== descriptor) {
      return;
    }

    var newMap = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.droppables);
    delete newMap[descriptor.id];

    setState({
      droppables: newMap
    });

    if (!state.isCollecting) {
      return;
    }

    console.warn('currently not supporting unmounting a Droppable during a drag');
  };

  var getToBeCollected = function getToBeCollected() {
    var draggables = state.draggables;
    var droppables = state.droppables;
    var request = state.request;

    if (!request) {
      console.error('cannot find request in state');
      return [];
    }
    var draggableId = request.draggableId;
    var descriptor = draggables[draggableId].descriptor;
    var home = droppables[descriptor.droppableId].descriptor;

    var draggablesToBeCollected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(draggables).map(function (id) {
      return draggables[id].descriptor;
    }).filter(function (item) {
      return item.id !== descriptor.id;
    }).filter(function (item) {
      var entry = droppables[item.droppableId];

      if (!entry) {
        console.warn('Orphan Draggable found ' + item.id + ' which says it belongs to unknown Droppable ' + item.droppableId);
        return false;
      }

      return entry.descriptor.type === home.type;
    });

    var droppablesToBeCollected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(droppables).map(function (id) {
      return droppables[id].descriptor;
    }).filter(function (item) {
      return item.id !== home.id;
    }).filter(function (item) {
      var droppable = droppables[item.id].descriptor;
      return droppable.type === home.type;
    });

    var toBeCollected = [].concat(droppablesToBeCollected, draggablesToBeCollected);

    return toBeCollected;
  };

  var processPrimaryDimensions = function processPrimaryDimensions(request) {
    if (state.isCollecting) {
      cancel('Cannot start capturing dimensions for a drag it is already dragging');
      return;
    }

    if (!request) {
      cancel('Cannot start capturing dimensions with an invalid request', request);
      return;
    }

    var draggableId = request.draggableId;

    setState({
      isCollecting: true,
      request: request
    });

    var draggables = state.draggables;
    var droppables = state.droppables;
    var draggableEntry = draggables[draggableId];

    if (!draggableEntry) {
      cancel('Cannot find Draggable with id ' + draggableId + ' to start collecting dimensions');
      return;
    }

    var homeEntry = droppables[draggableEntry.descriptor.droppableId];

    if (!homeEntry) {
      cancel('\n        Cannot find home Droppable [id:' + draggableEntry.descriptor.droppableId + ']\n        for Draggable [id:' + request.draggableId + ']\n      ');
      return;
    }

    var home = homeEntry.callbacks.getDimension();
    var draggable = draggableEntry.getDimension();

    callbacks.publishDroppable(home);
    callbacks.publishDraggable(draggable);

    homeEntry.callbacks.watchScroll(request.scrollOptions);
  };

  var setFrameId = function setFrameId(frameId) {
    setState({
      frameId: frameId
    });
  };

  var processSecondaryDimensions = function processSecondaryDimensions(requestInAppState) {
    if (!state.isCollecting) {
      cancel('Cannot collect secondary dimensions when collection is not occurring');
      return;
    }

    var request = state.request;

    if (!request) {
      cancel('Cannot process secondary dimensions without a request');
      return;
    }

    if (!requestInAppState) {
      cancel('Cannot process secondary dimensions without a request on the state');
      return;
    }

    if (requestInAppState.draggableId !== request.draggableId) {
      cancel('Cannot process secondary dimensions as local request does not match app state');
      return;
    }

    var toBeCollected = getToBeCollected();

    var collectFrameId = requestAnimationFrame(function () {
      var toBePublishedBuffer = toBeCollected.map(function (descriptor) {
        if (descriptor.type) {
          return state.droppables[descriptor.id].callbacks.getDimension();
        }

        return state.draggables[descriptor.id].getDimension();
      });

      var publishFrameId = requestAnimationFrame(function () {
        var toBePublished = toBePublishedBuffer.reduce(function (previous, dimension) {
          if (dimension.placeholder) {
            previous.draggables.push(dimension);
          } else {
            previous.droppables.push(dimension);
          }
          return previous;
        }, { draggables: [], droppables: [] });

        callbacks.bulkPublish(toBePublished.droppables, toBePublished.draggables);

        toBePublished.droppables.forEach(function (dimension) {
          var entry = state.droppables[dimension.descriptor.id];
          entry.callbacks.watchScroll(request.scrollOptions);
        });

        setFrameId(null);
      });

      setFrameId(publishFrameId);
    });

    setFrameId(collectFrameId);
  };

  var stopCollecting = function stopCollecting() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.droppables).forEach(function (id) {
      return state.droppables[id].callbacks.unwatchScroll();
    });

    if (state.frameId) {
      cancelAnimationFrame(state.frameId);
    }

    setState({
      isCollecting: false,
      request: null,
      frameId: null
    });
  };

  var onPhaseChange = function onPhaseChange(current) {
    var phase = current.phase;

    if (phase === 'COLLECTING_INITIAL_DIMENSIONS') {
      processPrimaryDimensions(current.dimension.request);
      return;
    }

    if (phase === 'DRAGGING') {
      processSecondaryDimensions(current.dimension.request);
      return;
    }

    if (phase === 'DROP_ANIMATING' || phase === 'DROP_COMPLETE') {
      if (state.isCollecting) {
        stopCollecting();
      }
      return;
    }

    if (phase === 'IDLE') {
      if (state.isCollecting) {
        stopCollecting();
      }
    }
  };

  var marshal = {
    registerDraggable: registerDraggable,
    unregisterDraggable: unregisterDraggable,
    registerDroppable: registerDroppable,
    unregisterDroppable: unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    onPhaseChange: onPhaseChange
  };

  return marshal;
});

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_displacement__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_scroll__ = __webpack_require__(1188);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var pageCenter = _ref.pageCenter,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var axis = destination.axis;

  var currentCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_scroll__["a" /* default */])(destination, pageCenter);

  var displaced = insideDestination.filter(function (child) {
    var threshold = child.page.paddingBox[axis.end];
    return threshold > currentCenter[axis.line];
  }).map(function (dimension) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_displacement__["a" /* default */])({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.subject
    });
  });

  var newIndex = insideDestination.length - displaced.length;

  var movement = {
    amount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["e" /* patch */])(axis.line, draggable.page.marginBox[axis.size]),
    displaced: displaced,
    isBeyondStartPosition: false
  };

  var impact = {
    movement: movement,
    direction: axis.direction,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    }
  };

  return impact;
});

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_displacement__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_scroll__ = __webpack_require__(1188);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var pageCenter = _ref.pageCenter,
      draggable = _ref.draggable,
      home = _ref.home,
      insideHome = _ref.insideHome,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var axis = home.axis;

  var originalCenter = draggable.page.paddingBox.center;

  var currentCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_scroll__["a" /* default */])(home, pageCenter);

  var isBeyondStartPosition = currentCenter[axis.line] - originalCenter[axis.line] > 0;

  var amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["e" /* patch */])(axis.line, draggable.client.marginBox[axis.size]);

  var displaced = insideHome.filter(function (child) {
    if (child === draggable) {
      return false;
    }

    var area = child.page.paddingBox;

    if (isBeyondStartPosition) {
      if (area.center[axis.line] < originalCenter[axis.line]) {
        return false;
      }

      return currentCenter[axis.line] > area[axis.start];
    }

    if (originalCenter[axis.line] < area.center[axis.line]) {
      return false;
    }

    return currentCenter[axis.line] < area[axis.end];
  }).map(function (dimension) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_displacement__["a" /* default */])({
      draggable: dimension,
      destination: home,
      previousImpact: previousImpact,
      viewport: viewport.subject
    });
  });

  var ordered = isBeyondStartPosition ? displaced.reverse() : displaced;
  var index = function () {
    var startIndex = insideHome.indexOf(draggable);
    var length = ordered.length;
    if (!length) {
      return startIndex;
    }

    if (isBeyondStartPosition) {
      return startIndex + length;
    }

    return startIndex - length;
  }();

  var movement = {
    amount: amount,
    displaced: ordered,
    isBeyondStartPosition: isBeyondStartPosition
  };

  var impact = {
    movement: movement,
    direction: axis.direction,
    destination: {
      droppableId: home.descriptor.id,
      index: index
    }
  };

  return impact;
});

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_droppable_over__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_draggables_inside_droppable__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__no_impact__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__in_home_list__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__in_foreign_list__ = __webpack_require__(2205);







/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var pageCenter = _ref.pageCenter,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var previousDroppableOverId = previousImpact.destination && previousImpact.destination.droppableId;

  var destinationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_droppable_over__["a" /* default */])({
    target: pageCenter,
    draggable: draggable,
    draggables: draggables,
    droppables: droppables,
    previousDroppableOverId: previousDroppableOverId
  });

  if (!destinationId) {
    return __WEBPACK_IMPORTED_MODULE_2__no_impact__["a" /* default */];
  }

  var destination = droppables[destinationId];

  if (!destination.isEnabled) {
    return __WEBPACK_IMPORTED_MODULE_2__no_impact__["a" /* default */];
  }

  var home = droppables[draggable.descriptor.droppableId];
  var isWithinHomeDroppable = home.descriptor.id === destinationId;
  var insideDestination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_draggables_inside_droppable__["a" /* default */])(destination, draggables);

  if (isWithinHomeDroppable) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__in_home_list__["a" /* default */])({
      pageCenter: pageCenter,
      draggable: draggable,
      home: home,
      insideHome: insideDestination,
      previousImpact: previousImpact || __WEBPACK_IMPORTED_MODULE_2__no_impact__["a" /* default */],
      viewport: viewport
    });
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__in_foreign_list__["a" /* default */])({
    pageCenter: pageCenter,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact || __WEBPACK_IMPORTED_MODULE_2__no_impact__["a" /* default */],
    viewport: viewport
  });
});

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_area__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_draggables_inside_droppable__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visibility_is_position_in_frame__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spacing__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dimension__ = __webpack_require__(456);










var getRequiredGrowth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(function (draggable, draggables, droppable) {

  var getResult = function getResult(existingSpace) {
    var requiredSpace = draggable.page.marginBox[droppable.axis.size];

    if (requiredSpace <= existingSpace) {
      return null;
    }
    var requiredGrowth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__position__["e" /* patch */])(droppable.axis.line, requiredSpace - existingSpace);

    return requiredGrowth;
  };

  var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_draggables_inside_droppable__["a" /* default */])(droppable, draggables);

  if (!dimensions.length) {
    var _existingSpace = droppable.page.marginBox[droppable.axis.size];
    return getResult(_existingSpace);
  }

  var endOfDraggables = dimensions[dimensions.length - 1].page.marginBox[droppable.axis.end];
  var endOfDroppable = droppable.page.marginBox[droppable.axis.end];
  var existingSpace = endOfDroppable - endOfDraggables;

  return getResult(existingSpace);
});

var getWithGrowth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(function (area, growth) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_area__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__spacing__["e" /* expandByPosition */])(area, growth));
});

var getClippedAreaWithPlaceholder = function getClippedAreaWithPlaceholder(_ref) {
  var draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      previousDroppableOverId = _ref.previousDroppableOverId;

  var isHome = draggable.descriptor.droppableId === droppable.descriptor.id;
  var wasOver = Boolean(previousDroppableOverId && previousDroppableOverId === droppable.descriptor.id);
  var clipped = droppable.viewport.clipped;

  if (!clipped) {
    return clipped;
  }

  if (isHome || !wasOver) {
    return clipped;
  }

  var requiredGrowth = getRequiredGrowth(draggable, draggables, droppable);

  if (!requiredGrowth) {
    return clipped;
  }

  var subjectWithGrowth = getWithGrowth(clipped, requiredGrowth);
  var closestScrollable = droppable.viewport.closestScrollable;

  if (!closestScrollable) {
    return subjectWithGrowth;
  }

  if (!closestScrollable.shouldClipSubject) {
    return subjectWithGrowth;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__dimension__["d" /* clip */])(closestScrollable.frame, subjectWithGrowth);
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref2) {
  var target = _ref2.target,
      draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousDroppableOverId = _ref2.previousDroppableOverId;

  var maybe = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(droppables).map(function (id) {
    return droppables[id];
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).find(function (droppable) {
    var withPlaceholder = getClippedAreaWithPlaceholder({
      draggable: draggable, draggables: draggables, droppable: droppable, previousDroppableOverId: previousDroppableOverId
    });

    if (!withPlaceholder) {
      return false;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__visibility_is_position_in_frame__["a" /* default */])(withPlaceholder)(target);
  });

  return maybe ? maybe.descriptor.id : null;
});

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__move_to_edge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_draggables_inside_droppable__ = __webpack_require__(285);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var movement = _ref.movement,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination;

  var homeCenter = draggable.client.marginBox.center;

  if (destination == null) {
    return homeCenter;
  }

  var displaced = movement.displaced,
      isBeyondStartPosition = movement.isBeyondStartPosition;

  var axis = destination.axis;

  var isWithinHomeDroppable = destination.descriptor.id === draggable.descriptor.droppableId;

  if (isWithinHomeDroppable && !displaced.length) {
    return homeCenter;
  }

  var draggablesInDestination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_draggables_inside_droppable__["a" /* default */])(destination, draggables);

  var destinationFragment = function () {
    if (isWithinHomeDroppable) {
      return draggables[displaced[0].draggableId].client.marginBox;
    }

    if (displaced.length) {
      return draggables[displaced[0].draggableId].client.marginBox;
    }

    if (draggablesInDestination.length) {
      return draggablesInDestination[draggablesInDestination.length - 1].client.marginBox;
    }

    return destination.client.contentBox;
  }();

  var _ref2 = function () {
    if (isWithinHomeDroppable) {
      if (isBeyondStartPosition) {
        return { sourceEdge: 'end', destinationEdge: 'end' };
      }

      return { sourceEdge: 'start', destinationEdge: 'start' };
    }

    if (!displaced.length && draggablesInDestination.length) {
      return { sourceEdge: 'start', destinationEdge: 'end' };
    }

    return { sourceEdge: 'start', destinationEdge: 'start' };
  }(),
      sourceEdge = _ref2.sourceEdge,
      destinationEdge = _ref2.destinationEdge;

  var source = draggable.client.marginBox;

  var targetCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__move_to_edge__["a" /* default */])({
    source: source,
    sourceEdge: sourceEdge,
    destination: destinationFragment,
    destinationEdge: destinationEdge,
    destinationAxis: axis
  });

  return targetCenter;
});

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message_preset__ = __webpack_require__(2211);




var notDragging = {
  isDragging: false,
  start: null,
  lastDestination: null,
  hasMovedFromStartLocation: false
};

var areLocationsEqual = function areLocationsEqual(current, next) {
  if (current == null && next == null) {
    return true;
  }

  if (current == null || next == null) {
    return false;
  }

  return current.droppableId === next.droppableId && current.index === next.index;
};

var getAnnouncerForConsumer = function getAnnouncerForConsumer(announce) {
  var wasCalled = false;
  var isExpired = false;

  setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      console.warn('Announcement already made. Not making a second announcement');
      return;
    }

    if (isExpired) {
      console.warn('\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ');
      return;
    }

    wasCalled = true;
    announce(message);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (function (announce) {
  var state = notDragging;

  var setState = function setState(partial) {
    var newState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, partial);
    state = newState;
  };

  var getDragStart = function getDragStart(appState) {
    if (!appState.drag) {
      return null;
    }

    var descriptor = appState.drag.initial.descriptor;
    var home = appState.dimension.droppable[descriptor.droppableId];

    if (!home) {
      return null;
    }

    var source = {
      index: descriptor.index,
      droppableId: descriptor.droppableId
    };

    var start = {
      draggableId: descriptor.id,
      type: home.descriptor.type,
      source: source
    };

    return start;
  };

  var execute = function execute(hook, data, getDefaultMessage) {
    if (!hook) {
      announce(getDefaultMessage(data));
      return;
    }

    var managed = getAnnouncerForConsumer(announce);
    var provided = {
      announce: managed
    };

    hook(data, provided);

    if (!managed.wasCalled()) {
      announce(getDefaultMessage(data));
    }
  };

  var onDrag = function onDrag(current, onDragUpdate) {
    if (!state.isDragging) {
      console.error('Cannot process dragging update if drag has not started');
      return;
    }

    var drag = current.drag;
    var start = getDragStart(current);
    if (!start || !drag) {
      console.error('Cannot update drag when there is invalid state');
      return;
    }

    var destination = drag.impact.destination;
    var update = {
      draggableId: start.draggableId,
      type: start.type,
      source: start.source,
      destination: destination
    };

    if (!state.hasMovedFromStartLocation) {
      if (areLocationsEqual(start.source, destination)) {
        return;
      }

      setState({
        lastDestination: destination,
        hasMovedFromStartLocation: true
      });

      execute(onDragUpdate, update, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragUpdate);

      return;
    }

    if (areLocationsEqual(state.lastDestination, destination)) {
      return;
    }

    setState({
      lastDestination: destination
    });

    execute(onDragUpdate, update, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragUpdate);
  };

  var onStateChange = function onStateChange(hooks, previous, current) {
    var onDragStart = hooks.onDragStart,
        onDragUpdate = hooks.onDragUpdate,
        onDragEnd = hooks.onDragEnd;

    var currentPhase = current.phase;
    var previousPhase = previous.phase;

    if (currentPhase === 'DRAGGING' && previousPhase === 'DRAGGING') {
      onDrag(current, onDragUpdate);
      return;
    }

    if (state.isDragging) {
      setState(notDragging);
    }

    if (currentPhase === previousPhase) {
      return;
    }

    if (currentPhase === 'DRAGGING' && previousPhase !== 'DRAGGING') {
      var _start = getDragStart(current);

      if (!_start) {
        console.error('Unable to publish onDragStart');
        return;
      }

      setState({
        isDragging: true,
        hasMovedFromStartLocation: false,
        start: _start
      });

      execute(onDragStart, _start, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragStart);
      return;
    }

    if (currentPhase === 'DROP_COMPLETE' && previousPhase !== 'DROP_COMPLETE') {
      if (!current.drop || !current.drop.result) {
        console.error('cannot fire onDragEnd hook without drag state', { current: current, previous: previous });
        return;
      }
      var result = current.drop.result;

      execute(onDragEnd, result, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragEnd);
      return;
    }

    if (currentPhase === 'IDLE' && previousPhase === 'DRAGGING') {
      if (!previous.drag) {
        console.error('cannot fire onDragEnd for cancel because cannot find previous drag');
        return;
      }

      var descriptor = previous.drag.initial.descriptor;
      var home = previous.dimension.droppable[descriptor.droppableId];

      if (!home) {
        console.error('cannot find dimension for home droppable');
        return;
      }

      var source = {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      };
      var _result = {
        draggableId: descriptor.id,
        type: home.descriptor.type,
        source: source,
        destination: null,
        reason: 'CANCEL'
      };

      execute(onDragEnd, _result, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragEnd);
      return;
    }

    if (currentPhase === 'IDLE' && previousPhase === 'DROP_ANIMATING') {
      if (!previous.drop || !previous.drop.pending) {
        console.error('cannot fire onDragEnd for cancel because cannot find previous pending drop');
        return;
      }

      var _result2 = {
        draggableId: previous.drop.pending.result.draggableId,
        type: previous.drop.pending.result.type,
        source: previous.drop.pending.result.source,
        destination: null,
        reason: 'CANCEL'
      };

      execute(onDragEnd, _result2, __WEBPACK_IMPORTED_MODULE_1__message_preset__["a" /* default */].onDragEnd);
    }
  };

  var caller = {
    onStateChange: onStateChange
  };

  return caller;
});

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var onDragStart = function onDragStart(start) {
  return '\n  You have lifted an item in position ' + (start.source.index + 1) + '.\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n';
};

var onDragUpdate = function onDragUpdate(update) {
  if (!update.destination) {
    return 'You are currently not dragging over a droppable area';
  }

  if (update.source.droppableId === update.destination.droppableId) {
    return 'You have moved the item to position ' + (update.destination.index + 1);
  }

  return '\n    You have moved the item from list ' + update.source.droppableId + ' in position ' + (update.source.index + 1) + '\n    to list ' + update.destination.droppableId + ' in position ' + (update.destination.index + 1) + '\n  ';
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return '\n      Movement cancelled.\n      The item has returned to its starting position of ' + (result.source.index + 1) + '\n    ';
  }

  if (!result.destination) {
    return '\n      The item has been dropped while not over a droppable location.\n      The item has returned to its starting position of ' + (result.source.index + 1) + '\n    ';
  }

  if (result.source.droppableId === result.destination.droppableId) {
    if (result.source.index === result.destination.index) {
      return '\n        You have dropped the item.\n        It has been dropped on its starting position of ' + (result.source.index + 1) + '\n      ';
    }

    return '\n      You have dropped the item.\n      It has moved from position ' + (result.source.index + 1) + ' to ' + (result.destination.index + 1) + '\n    ';
  }

  return '\n    You have dropped the item.\n    It has moved from position ' + (result.source.index + 1) + ' in list ' + result.source.droppableId + '\n    to position ' + (result.destination.index + 1) + ' in list ' + result.destination.droppableId + '\n  ';
};

var preset = {
  onDragStart: onDragStart, onDragUpdate: onDragUpdate, onDragEnd: onDragEnd
};

/* harmony default export */ __webpack_exports__["a"] = (preset);

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_within__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spacing__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visibility_is_partially_visible_through_frame__ = __webpack_require__(1186);







var getSafeClipped = function getSafeClipped(droppable) {
  var area = droppable.viewport.clipped;

  if (!area) {
    throw new Error('cannot get clipped area from droppable');
  }
  return area;
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageCenter = _ref.pageCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;

  var sourceClipped = source.viewport.clipped;

  if (!sourceClipped) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__is_within__["a" /* default */])(sourceClipped[axis.start], sourceClipped[axis.end]);

  var candidates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(droppables).map(function (id) {
    return droppables[id];
  }).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    var clipped = droppable.viewport.clipped;

    if (!clipped) {
      return false;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__visibility_is_partially_visible_through_frame__["a" /* default */])(viewport.subject)(clipped);
  }).filter(function (droppable) {
    var targetClipped = getSafeClipped(droppable);

    if (isMovingForward) {
      return sourceClipped[axis.crossAxisEnd] <= targetClipped[axis.crossAxisStart];
    }

    return targetClipped[axis.crossAxisEnd] <= sourceClipped[axis.crossAxisStart];
  }).filter(function (droppable) {
    var targetClipped = getSafeClipped(droppable);

    var isBetweenDestinationClipped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__is_within__["a" /* default */])(targetClipped[axis.start], targetClipped[axis.end]);

    return isBetweenSourceClipped(targetClipped[axis.start]) || isBetweenSourceClipped(targetClipped[axis.end]) || isBetweenDestinationClipped(sourceClipped[axis.start]) || isBetweenDestinationClipped(sourceClipped[axis.end]);
  }).sort(function (a, b) {
    var first = getSafeClipped(a)[axis.crossAxisStart];
    var second = getSafeClipped(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }
    return second - first;
  }).filter(function (droppable, index, array) {
    return getSafeClipped(droppable)[axis.crossAxisStart] === getSafeClipped(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__is_within__["a" /* default */])(getSafeClipped(droppable)[axis.start], getSafeClipped(droppable)[axis.end]);
    return isWithinDroppable(pageCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["i" /* closest */])(pageCenter, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["d" /* getCorners */])(getSafeClipped(a)));
    var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["i" /* closest */])(pageCenter, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spacing__["d" /* getCorners */])(getSafeClipped(b)));

    if (first !== second) {
      return first - second;
    }

    return getSafeClipped(a)[axis.start] - getSafeClipped(b)[axis.start];
  })[0];
});

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visibility_is_visible__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__ = __webpack_require__(286);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var axis = _ref.axis,
      viewport = _ref.viewport,
      pageCenter = _ref.pageCenter,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination;

  if (!insideDestination.length) {
    return null;
  }

  var result = insideDestination.filter(function (draggable) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__visibility_is_visible__["b" /* isTotallyVisible */])({
      target: draggable.page.marginBox,
      destination: destination,
      viewport: viewport.subject
    });
  }).sort(function (a, b) {
    var distanceToA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["h" /* distance */])(pageCenter, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(destination, a.page.marginBox.center));
    var distanceToB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__position__["h" /* distance */])(pageCenter, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(destination, b.page.marginBox.center));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.page.marginBox[axis.start] - b.page.marginBox[axis.start];
  });

  return result.length ? result[0] : null;
});

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_best_cross_axis_droppable__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_closest_draggable__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__move_to_new_droppable___ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__no_impact__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_draggables_inside_droppable__ = __webpack_require__(285);







/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageCenter = _ref.pageCenter,
      draggableId = _ref.draggableId,
      droppableId = _ref.droppableId,
      home = _ref.home,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var draggable = draggables[draggableId];
  var source = droppables[droppableId];

  var destination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_best_cross_axis_droppable__["a" /* default */])({
    isMovingForward: isMovingForward,
    pageCenter: pageCenter,
    source: source,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_draggables_inside_droppable__["a" /* default */])(destination, draggables);

  var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_closest_draggable__["a" /* default */])({
    axis: destination.axis,
    pageCenter: pageCenter,
    destination: destination,
    insideDestination: insideDestination,
    viewport: viewport
  });

  if (insideDestination.length && !target) {
    return null;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__move_to_new_droppable___["a" /* default */])({
    pageCenter: pageCenter,
    destination: destination,
    draggable: draggable,
    target: target,
    insideDestination: insideDestination,
    home: home,
    previousImpact: previousImpact || __WEBPACK_IMPORTED_MODULE_3__no_impact__["a" /* default */],
    viewport: viewport
  });
});

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_home_list__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__to_foreign_list__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__position__ = __webpack_require__(69);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var pageCenter = _ref.pageCenter,
      destination = _ref.destination,
      draggable = _ref.draggable,
      target = _ref.target,
      home = _ref.home,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__position__["e" /* patch */])(destination.axis.line, draggable.client.marginBox[destination.axis.size]);

  if (destination.descriptor.id === draggable.descriptor.droppableId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__to_home_list__["a" /* default */])({
      amount: amount,
      originalIndex: home.index,
      target: target,
      insideDroppable: insideDestination,
      draggable: draggable,
      droppable: destination,
      previousImpact: previousImpact,
      viewport: viewport
    });
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__to_foreign_list__["a" /* default */])({
    amount: amount,
    pageCenter: pageCenter,
    target: target,
    insideDroppable: insideDestination,
    draggable: draggable,
    droppable: destination,
    previousImpact: previousImpact,
    viewport: viewport
  });
});

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__move_to_edge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_displacement__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__ = __webpack_require__(286);






/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var amount = _ref.amount,
      pageCenter = _ref.pageCenter,
      target = _ref.target,
      insideDroppable = _ref.insideDroppable,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  var axis = droppable.axis;
  var isGoingBeforeTarget = Boolean(target && pageCenter[droppable.axis.line] < target.page.marginBox.center[droppable.axis.line]);

  if (!target) {

    var _newCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__move_to_edge__["a" /* default */])({
      source: draggable.page.paddingBox,
      sourceEdge: 'start',
      destination: droppable.page.contentBox,
      destinationEdge: 'start',
      destinationAxis: axis
    });

    var _newImpact = {
      movement: {
        displaced: [],
        amount: amount,
        isBeyondStartPosition: false
      },
      direction: axis.direction,
      destination: {
        droppableId: droppable.descriptor.id,
        index: 0
      }
    };

    return {
      pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, _newCenter),
      impact: _newImpact
    };
  }

  var targetIndex = insideDroppable.indexOf(target);
  var proposedIndex = isGoingBeforeTarget ? targetIndex : targetIndex + 1;

  if (targetIndex === -1) {
    console.error('could not find target inside destination');
    return null;
  }

  var newCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__move_to_edge__["a" /* default */])({
    source: draggable.page.paddingBox,
    sourceEdge: 'start',
    destination: target.page.marginBox,
    destinationEdge: isGoingBeforeTarget ? 'start' : 'end',
    destinationAxis: axis
  });

  var displaced = insideDroppable.slice(proposedIndex, insideDroppable.length).map(function (dimension) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_displacement__["a" /* default */])({
      draggable: dimension,
      destination: droppable,
      viewport: viewport.subject,
      previousImpact: previousImpact
    });
  });

  var newImpact = {
    movement: {
      displaced: displaced,
      amount: amount,
      isBeyondStartPosition: false
    },
    direction: axis.direction,
    destination: {
      droppableId: droppable.descriptor.id,
      index: proposedIndex
    }
  };

  return {
    pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, newCenter),
    impact: newImpact
  };
});

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__move_to_edge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_displacement__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__ = __webpack_require__(286);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var amount = _ref.amount,
      originalIndex = _ref.originalIndex,
      target = _ref.target,
      insideDroppable = _ref.insideDroppable,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport;

  if (!target) {
    console.error('there will always be a target in the original list');
    return null;
  }

  var axis = droppable.axis;
  var targetIndex = insideDroppable.indexOf(target);

  if (targetIndex === -1) {
    console.error('unable to find target in destination droppable');
    return null;
  }

  if (targetIndex === originalIndex) {
    var _newCenter = draggable.page.paddingBox.center;
    var _newImpact = {
      movement: {
        displaced: [],
        amount: amount,
        isBeyondStartPosition: false
      },
      direction: droppable.axis.direction,
      destination: {
        droppableId: droppable.descriptor.id,
        index: originalIndex
      }
    };

    return {
      pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, _newCenter),
      impact: _newImpact
    };
  }

  var isMovingPastOriginalIndex = targetIndex > originalIndex;
  var edge = isMovingPastOriginalIndex ? 'end' : 'start';

  var newCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__move_to_edge__["a" /* default */])({
    source: draggable.page.paddingBox,
    sourceEdge: edge,
    destination: isMovingPastOriginalIndex ? target.page.paddingBox : target.page.marginBox,
    destinationEdge: edge,
    destinationAxis: axis
  });

  var modified = function () {
    if (!isMovingPastOriginalIndex) {
      return insideDroppable.slice(targetIndex, originalIndex);
    }

    var from = originalIndex + 1;

    var to = targetIndex + 1;

    return insideDroppable.slice(from, to).reverse();
  }();

  var displaced = modified.map(function (dimension) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_displacement__["a" /* default */])({
      draggable: dimension,
      destination: droppable,
      previousImpact: previousImpact,
      viewport: viewport.subject
    });
  });

  var newImpact = {
    movement: {
      displaced: displaced,
      amount: amount,
      isBeyondStartPosition: isMovingPastOriginalIndex
    },
    direction: axis.direction,
    destination: {
      droppableId: droppable.descriptor.id,
      index: targetIndex
    }
  };

  return {
    pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, newCenter),
    impact: newImpact
  };
});

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_draggables_inside_droppable__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__move_to_edge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__is_totally_visible_in_new_location__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__ = __webpack_require__(1184);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggableId = _ref.draggableId,
      previousImpact = _ref.previousImpact,
      previousPageCenter = _ref.previousPageCenter,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;

  if (!previousImpact.destination) {
    console.error('cannot move to next index when there is not previous destination');
    return null;
  }

  var location = previousImpact.destination;
  var draggable = draggables[draggableId];
  var axis = droppable.axis;

  var insideForeignDroppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_draggables_inside_droppable__["a" /* default */])(droppable, draggables);

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var lastIndex = insideForeignDroppable.length - 1;

  if (proposedIndex > insideForeignDroppable.length) {
    return null;
  }

  if (proposedIndex < 0) {
    return null;
  }

  var movingRelativeTo = insideForeignDroppable[Math.min(proposedIndex, lastIndex)];

  var isMovingPastLastIndex = proposedIndex > lastIndex;
  var sourceEdge = 'start';
  var destinationEdge = function () {
    if (isMovingPastLastIndex) {
      return 'end';
    }

    return 'start';
  }();

  var newPageCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__move_to_edge__["a" /* default */])({
    source: draggable.page.paddingBox,
    sourceEdge: sourceEdge,
    destination: movingRelativeTo.page.marginBox,
    destinationEdge: destinationEdge,
    destinationAxis: droppable.axis
  });

  var isVisibleInNewLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__is_totally_visible_in_new_location__["a" /* default */])({
    draggable: draggable,
    destination: droppable,
    newPageCenter: newPageCenter,
    viewport: viewport.subject
  });

  var displaced = function () {
    if (isMovingForward) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__["a" /* withFirstRemoved */])({
        dragging: draggableId,
        isVisibleInNewLocation: isVisibleInNewLocation,
        previousImpact: previousImpact,
        droppable: droppable,
        draggables: draggables
      });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__["b" /* withFirstAdded */])({
      add: movingRelativeTo.descriptor.id,
      previousImpact: previousImpact,
      droppable: droppable,
      draggables: draggables,
      viewport: viewport
    });
  }();

  var newImpact = {
    movement: {
      displaced: displaced,
      amount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["e" /* patch */])(axis.line, draggable.page.marginBox[axis.size]),

      isBeyondStartPosition: false
    },
    destination: {
      droppableId: droppable.descriptor.id,
      index: proposedIndex
    },
    direction: droppable.axis.direction
  };

  if (isVisibleInNewLocation) {
    return {
      pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, newPageCenter),
      impact: newImpact,
      scrollJumpRequest: null
    };
  }

  var distanceMoving = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["b" /* subtract */])(newPageCenter, previousPageCenter);
  var distanceWithScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, distanceMoving);

  return {
    pageCenter: previousPageCenter,
    impact: newImpact,
    scrollJumpRequest: distanceWithScroll
  };
});

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_draggables_inside_droppable__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_totally_visible_in_new_location__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__move_to_edge__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__ = __webpack_require__(1184);









/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggableId = _ref.draggableId,
      previousPageCenter = _ref.previousPageCenter,
      previousImpact = _ref.previousImpact,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport;

  var location = previousImpact.destination;

  if (!location) {
    console.error('cannot move to next index when there is not previous destination');
    return null;
  }

  var draggable = draggables[draggableId];
  var axis = droppable.axis;

  var insideDroppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_draggables_inside_droppable__["a" /* default */])(droppable, draggables);

  var startIndex = draggable.descriptor.index;
  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (startIndex === -1) {
    console.error('could not find draggable inside current droppable');
    return null;
  }

  if (proposedIndex > insideDroppable.length - 1) {
    return null;
  }

  if (proposedIndex < 0) {
    return null;
  }

  var destination = insideDroppable[proposedIndex];
  var isMovingTowardStart = isMovingForward && proposedIndex <= startIndex || !isMovingForward && proposedIndex >= startIndex;

  var edge = function () {
    if (!isMovingTowardStart) {
      return isMovingForward ? 'end' : 'start';
    }

    return isMovingForward ? 'start' : 'end';
  }();

  var newPageCenter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__move_to_edge__["a" /* default */])({
    source: draggable.page.paddingBox,
    sourceEdge: edge,
    destination: destination.page.paddingBox,
    destinationEdge: edge,
    destinationAxis: droppable.axis
  });

  var isVisibleInNewLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__is_totally_visible_in_new_location__["a" /* default */])({
    draggable: draggable,
    destination: droppable,
    newPageCenter: newPageCenter,
    viewport: viewport.subject
  });

  var displaced = function () {
    if (isMovingTowardStart) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__["a" /* withFirstRemoved */])({
        dragging: draggableId,
        isVisibleInNewLocation: isVisibleInNewLocation,
        previousImpact: previousImpact,
        droppable: droppable,
        draggables: draggables
      });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_forced_displacement__["b" /* withFirstAdded */])({
      add: destination.descriptor.id,
      previousImpact: previousImpact,
      droppable: droppable,
      draggables: draggables,
      viewport: viewport
    });
  }();

  var newImpact = {
    movement: {
      displaced: displaced,
      amount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["e" /* patch */])(axis.line, draggable.page.marginBox[axis.size]),
      isBeyondStartPosition: proposedIndex > startIndex
    },
    destination: {
      droppableId: droppable.descriptor.id,
      index: proposedIndex
    },
    direction: droppable.axis.direction
  };

  if (isVisibleInNewLocation) {
    return {
      pageCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, newPageCenter),
      impact: newImpact,
      scrollJumpRequest: null
    };
  }

  var distance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__position__["b" /* subtract */])(newPageCenter, previousPageCenter);
  var distanceWithScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_droppable_displacement__["a" /* default */])(droppable, distance);

  return {
    pageCenter: previousPageCenter,
    impact: newImpact,
    scrollJumpRequest: distanceWithScroll
  };
});

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__in_home_list__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__in_foreign_list__ = __webpack_require__(2218);




/* harmony default export */ __webpack_exports__["a"] = (function (args) {
  var draggableId = args.draggableId,
      draggables = args.draggables,
      droppable = args.droppable;

  var draggable = draggables[draggableId];
  var isInHomeList = draggable.descriptor.droppableId === droppable.descriptor.id;

  if (!droppable.isEnabled) {
    return null;
  }

  if (isInHomeList) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__in_home_list__["a" /* default */])(args);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__in_foreign_list__["a" /* default */])(args);
});

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__no_impact__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_drag_impact___ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__move_to_next_index___ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__move_cross_axis___ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dimension__ = __webpack_require__(456);













var noDimensions = {
  request: null,
  draggable: {},
  droppable: {}
};

var origin = { x: 0, y: 0 };

var clean = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_memoize_one__["a" /* default */])(function () {
  var phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'IDLE';
  return {
    phase: phase,
    drag: null,
    drop: null,
    dimension: noDimensions
  };
});

var canPublishDimension = function canPublishDimension(phase) {
  return ['IDLE', 'DROP_ANIMATING', 'DROP_COMPLETE'].indexOf(phase) === -1;
};

var move = function move(_ref) {
  var state = _ref.state,
      clientSelection = _ref.clientSelection,
      shouldAnimate = _ref.shouldAnimate,
      proposedViewport = _ref.viewport,
      impact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;

  if (state.phase !== 'DRAGGING') {
    console.error('cannot move while not dragging');
    return clean();
  }

  var last = state.drag;

  if (last == null) {
    console.error('cannot move if there is no drag information');
    return clean();
  }

  var previous = last.current;
  var initial = last.initial;
  var viewport = proposedViewport || previous.viewport;
  var currentWindowScroll = viewport.scroll;

  var client = function () {
    var offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["b" /* subtract */])(clientSelection, initial.client.selection);

    var result = {
      offset: offset,
      selection: clientSelection,
      center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(offset, initial.client.center)
    };
    return result;
  }();

  var page = {
    selection: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(client.selection, currentWindowScroll),
    offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(client.offset, currentWindowScroll),
    center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(client.center, currentWindowScroll)
  };

  var current = {
    client: client,
    page: page,
    shouldAnimate: shouldAnimate,
    viewport: viewport,
    hasCompletedFirstBulkPublish: previous.hasCompletedFirstBulkPublish
  };

  var newImpact = impact || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_drag_impact___["a" /* default */])({
    pageCenter: page.center,
    draggable: state.dimension.draggable[initial.descriptor.id],
    draggables: state.dimension.draggable,
    droppables: state.dimension.droppable,
    previousImpact: last.impact,
    viewport: viewport
  });

  var drag = {
    initial: initial,
    impact: newImpact,
    current: current,
    scrollJumpRequest: scrollJumpRequest
  };

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    drag: drag
  });
};

var updateStateAfterDimensionChange = function updateStateAfterDimensionChange(newState, impact) {
  if (newState.phase === 'COLLECTING_INITIAL_DIMENSIONS') {
    return newState;
  }

  if (newState.phase !== 'DRAGGING') {
    return newState;
  }

  if (!newState.drag) {
    console.error('cannot update a draggable dimension in an existing drag as there is invalid drag state');
    return clean();
  }

  return move({
    state: newState,

    clientSelection: newState.drag.current.client.selection,
    shouldAnimate: newState.drag.current.shouldAnimate,
    impact: impact
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : clean('IDLE');
  var action = arguments[1];

  if (action.type === 'CLEAN') {
    return clean();
  }

  if (action.type === 'PREPARE') {
    return clean('PREPARING');
  }

  if (action.type === 'REQUEST_DIMENSIONS') {
    if (state.phase !== 'PREPARING') {
      console.error('trying to start a lift while not preparing for a lift');
      return clean();
    }

    var request = action.payload;

    return {
      phase: 'COLLECTING_INITIAL_DIMENSIONS',
      drag: null,
      drop: null,
      dimension: {
        request: request,
        draggable: {},
        droppable: {}
      }
    };
  }

  if (action.type === 'PUBLISH_DRAGGABLE_DIMENSION') {
    var _extends2;

    var dimension = action.payload;

    if (!canPublishDimension(state.phase)) {
      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
      return state;
    }

    var newState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      dimension: {
        request: state.dimension.request,
        droppable: state.dimension.droppable,
        draggable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.draggable, (_extends2 = {}, _extends2[dimension.descriptor.id] = dimension, _extends2))
      }
    });

    return updateStateAfterDimensionChange(newState);
  }

  if (action.type === 'PUBLISH_DROPPABLE_DIMENSION') {
    var _extends3;

    var _dimension = action.payload;

    if (!canPublishDimension(state.phase)) {
      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
      return state;
    }

    var _newState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      dimension: {
        request: state.dimension.request,
        draggable: state.dimension.draggable,
        droppable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.droppable, (_extends3 = {}, _extends3[_dimension.descriptor.id] = _dimension, _extends3))
      }
    });

    return updateStateAfterDimensionChange(_newState);
  }

  if (action.type === 'BULK_DIMENSION_PUBLISH') {
    var draggables = action.payload.draggables;
    var droppables = action.payload.droppables;

    if (!canPublishDimension(state.phase)) {
      console.warn('dimensions rejected as no longer allowing dimension capture in phase', state.phase);
      return state;
    }

    var newDraggables = draggables.reduce(function (previous, current) {
      previous[current.descriptor.id] = current;
      return previous;
    }, {});

    var newDroppables = droppables.reduce(function (previous, current) {
      previous[current.descriptor.id] = current;
      return previous;
    }, {});

    var drag = function () {
      var existing = state.drag;
      if (!existing) {
        return null;
      }

      if (existing.current.hasCompletedFirstBulkPublish) {
        return existing;
      }

      var newDrag = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, existing, {
        current: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, existing.current, {
          hasCompletedFirstBulkPublish: true
        })
      });

      return newDrag;
    }();

    var _newState2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      drag: drag,
      dimension: {
        request: state.dimension.request,
        draggable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.draggable, newDraggables),
        droppable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.droppable, newDroppables)
      }
    });

    return updateStateAfterDimensionChange(_newState2);
  }

  if (action.type === 'COMPLETE_LIFT') {
    if (state.phase !== 'COLLECTING_INITIAL_DIMENSIONS') {
      console.error('trying complete lift without collecting dimensions');
      return state;
    }

    var _action$payload = action.payload,
        id = _action$payload.id,
        client = _action$payload.client,
        _viewport = _action$payload.viewport,
        autoScrollMode = _action$payload.autoScrollMode;

    var page = {
      selection: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(client.selection, _viewport.scroll),
      center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["c" /* add */])(client.center, _viewport.scroll)
    };

    var draggable = state.dimension.draggable[id];

    if (!draggable) {
      console.error('could not find draggable in store after lift');
      return clean();
    }

    var descriptor = draggable.descriptor;

    var initial = {
      descriptor: descriptor,
      autoScrollMode: autoScrollMode,
      client: client,
      page: page,
      viewport: _viewport
    };

    var current = {
      client: {
        selection: client.selection,
        center: client.center,
        offset: origin
      },
      page: {
        selection: page.selection,
        center: page.center,
        offset: origin
      },
      viewport: _viewport,
      hasCompletedFirstBulkPublish: false,
      shouldAnimate: false
    };

    var home = state.dimension.droppable[descriptor.droppableId];

    if (!home) {
      console.error('Cannot find home dimension for initial lift');
      return clean();
    }

    var destination = {
      index: descriptor.index,
      droppableId: descriptor.droppableId
    };

    var _impact = {
      movement: __WEBPACK_IMPORTED_MODULE_4__no_impact__["b" /* noMovement */],
      direction: home.axis.direction,
      destination: destination
    };

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      phase: 'DRAGGING',
      drag: {
        initial: initial,
        current: current,
        impact: _impact,
        scrollJumpRequest: null
      }
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_SCROLL') {
    var _extends4;

    if (state.phase !== 'DRAGGING') {
      console.error('cannot update a droppable dimensions scroll when not dragging');
      return clean();
    }

    var _drag = state.drag;

    if (_drag == null) {
      console.error('invalid store state');
      return clean();
    }

    var _action$payload2 = action.payload,
        _id = _action$payload2.id,
        offset = _action$payload2.offset;

    var target = state.dimension.droppable[_id];

    if (!target) {
      console.warn('cannot update scroll for droppable as it has not yet been collected');
      return state;
    }

    var _dimension2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dimension__["c" /* scrollDroppable */])(target, offset);

    var _impact2 = _drag.initial.autoScrollMode === 'JUMP' ? _drag.impact : null;

    var _newState3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      dimension: {
        request: state.dimension.request,
        draggable: state.dimension.draggable,
        droppable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.droppable, (_extends4 = {}, _extends4[_id] = _dimension2, _extends4))
      }
    });

    return updateStateAfterDimensionChange(_newState3, _impact2);
  }

  if (action.type === 'UPDATE_DROPPABLE_DIMENSION_IS_ENABLED') {
    var _extends5;

    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.dimension.droppable).length) {
      return state;
    }

    var _action$payload3 = action.payload,
        _id2 = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;

    var _target = state.dimension.droppable[_id2];

    if (!_target) {
      console.warn('cannot update enabled state for droppable as it has not yet been collected');
      return state;
    }

    if (_target.isEnabled === isEnabled) {
      console.warn('trying to set droppable isEnabled to ' + String(isEnabled) + ' but it is already ' + String(isEnabled));
      return state;
    }

    var updatedDroppableDimension = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _target, {
      isEnabled: isEnabled
    });

    var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
      dimension: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension, {
        droppable: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.dimension.droppable, (_extends5 = {}, _extends5[_id2] = updatedDroppableDimension, _extends5))
      })
    });

    return updateStateAfterDimensionChange(result);
  }

  if (action.type === 'MOVE') {
    var _action$payload4 = action.payload,
        _client = _action$payload4.client,
        _viewport2 = _action$payload4.viewport,
        _shouldAnimate = _action$payload4.shouldAnimate;

    var _drag2 = state.drag;

    if (!_drag2) {
      console.error('Cannot move while there is no drag state');
      return state;
    }

    var _impact3 = function () {
      if (!_drag2.current.hasCompletedFirstBulkPublish) {
        return _drag2.impact;
      }

      if (_drag2.initial.autoScrollMode === 'JUMP') {
        return _drag2.impact;
      }

      return null;
    }();

    return move({
      state: state,
      clientSelection: _client,
      viewport: _viewport2,
      shouldAnimate: _shouldAnimate,
      impact: _impact3
    });
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    var _viewport3 = action.payload.viewport;

    var _drag3 = state.drag;

    if (!_drag3) {
      console.error('cannot move with window scrolling if no current drag');
      return clean();
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["d" /* isEqual */])(_viewport3.scroll, _drag3.current.viewport.scroll)) {
      return state;
    }

    var isJumpScrolling = _drag3.initial.autoScrollMode === 'JUMP';

    var _impact4 = isJumpScrolling ? _drag3.impact : null;

    return move({
      state: state,
      clientSelection: _drag3.current.client.selection,
      viewport: _viewport3,
      shouldAnimate: false,
      impact: _impact4
    });
  }

  if (action.type === 'MOVE_FORWARD' || action.type === 'MOVE_BACKWARD') {
    if (state.phase !== 'DRAGGING') {
      console.error('cannot move while not dragging', action);
      return clean();
    }

    if (!state.drag) {
      console.error('cannot move if there is no drag information');
      return clean();
    }

    var existing = state.drag;
    var isMovingForward = action.type === 'MOVE_FORWARD';

    if (!existing.impact.destination) {
      console.error('cannot move if there is no previous destination');
      return clean();
    }

    var droppable = state.dimension.droppable[existing.impact.destination.droppableId];

    var _result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__move_to_next_index___["a" /* default */])({
      isMovingForward: isMovingForward,
      draggableId: existing.initial.descriptor.id,
      droppable: droppable,
      draggables: state.dimension.draggable,
      previousPageCenter: existing.current.page.center,
      previousImpact: existing.impact,
      viewport: existing.current.viewport
    });

    if (!_result) {
      return state;
    }

    var _impact5 = _result.impact;
    var _page = _result.pageCenter;
    var _client2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["b" /* subtract */])(_page, existing.current.viewport.scroll);

    return move({
      state: state,
      impact: _impact5,
      clientSelection: _client2,
      shouldAnimate: true,
      scrollJumpRequest: _result.scrollJumpRequest
    });
  }

  if (action.type === 'CROSS_AXIS_MOVE_FORWARD' || action.type === 'CROSS_AXIS_MOVE_BACKWARD') {
    if (state.phase !== 'DRAGGING') {
      console.error('cannot move cross axis when not dragging');
      return clean();
    }

    if (!state.drag) {
      console.error('cannot move cross axis if there is no drag information');
      return clean();
    }

    if (!state.drag.impact.destination) {
      console.error('cannot move cross axis if not in a droppable');
      return clean();
    }

    var _current = state.drag.current;
    var _descriptor = state.drag.initial.descriptor;
    var draggableId = _descriptor.id;
    var center = _current.page.center;
    var droppableId = state.drag.impact.destination.droppableId;
    var _home = {
      index: _descriptor.index,
      droppableId: _descriptor.droppableId
    };

    var _result2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__move_cross_axis___["a" /* default */])({
      isMovingForward: action.type === 'CROSS_AXIS_MOVE_FORWARD',
      pageCenter: center,
      draggableId: draggableId,
      droppableId: droppableId,
      home: _home,
      draggables: state.dimension.draggable,
      droppables: state.dimension.droppable,
      previousImpact: state.drag.impact,
      viewport: _current.viewport
    });

    if (!_result2) {
      return state;
    }

    var _page2 = _result2.pageCenter;
    var _client3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__position__["b" /* subtract */])(_page2, _current.viewport.scroll);

    return move({
      state: state,
      clientSelection: _client3,
      impact: _result2.impact,
      shouldAnimate: true
    });
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        newHomeOffset = _action$payload5.newHomeOffset,
        _impact6 = _action$payload5.impact,
        _result3 = _action$payload5.result;

    if (state.phase !== 'DRAGGING') {
      console.error('cannot animate drop while not dragging', action);
      return state;
    }

    if (!state.drag) {
      console.error('cannot animate drop - invalid drag state');
      return clean();
    }

    var pending = {
      newHomeOffset: newHomeOffset,
      result: _result3,
      impact: _impact6
    };

    return {
      phase: 'DROP_ANIMATING',
      drag: null,
      drop: {
        pending: pending,
        result: null
      },
      dimension: state.dimension
    };
  }

  if (action.type === 'DROP_COMPLETE') {
    var _result4 = action.payload;

    return {
      phase: 'DROP_COMPLETE',
      drag: null,
      drop: {
        pending: null,
        result: _result4
      },
      dimension: noDimensions
    };
  }

  return state;
});

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return phaseSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pendingDropSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dragSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return draggingDraggableSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);



var phaseSelector = function phaseSelector(state) {
  return state.phase;
};

var pendingDropSelector = function pendingDropSelector(state) {
  if (!state.drop || !state.drop.pending) {
    return null;
  }
  return state.drop.pending;
};

var dragSelector = function dragSelector(state) {
  return state.drag;
};

var draggableMapSelector = function draggableMapSelector(state) {
  return state.dimension.draggable;
};

var draggingDraggableSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([phaseSelector, dragSelector, pendingDropSelector, draggableMapSelector], function (phase, drag, pending, draggables) {
  if (phase === 'DRAGGING') {
    if (!drag) {
      console.error('cannot get placeholder dimensions as there is an invalid drag state');
      return null;
    }

    var draggable = draggables[drag.initial.descriptor.id];
    return draggable;
  }

  if (phase === 'DROP_ANIMATING') {
    if (!pending) {
      console.error('cannot get placeholder dimensions as there is an invalid drag state');
      return null;
    }

    if (!pending.result.destination) {
      return null;
    }

    var _draggable = draggables[pending.result.draggableId];
    return _draggable;
  }

  return null;
});

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_within__ = __webpack_require__(457);



/* harmony default export */ __webpack_exports__["a"] = (function (frame) {
  var isWithinVertical = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.top, frame.bottom);
  var isWithinHorizontal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_within__["a" /* default */])(frame.left, frame.right);

  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    return isContained;
  };
});

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var count = 0;

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',

  'clip-path': 'inset(100%)'
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var id = 'react-beautiful-dnd-announcement-' + count++;

  var state = {
    el: null
  };

  var setState = function setState(newState) {
    state = newState;
  };

  var announce = function announce(message) {
    var el = state.el;
    if (!el) {
      console.error('Cannot announce to unmounted node');
      return;
    }

    el.textContent = message;
  };

  var mount = function mount() {
    if (state.el) {
      console.error('Announcer already mounted');
      return;
    }

    var el = document.createElement('div');

    el.id = id;

    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');

    el.setAttribute('aria-atomic', 'true');

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(el.style, visuallyHidden);

    if (!document.body) {
      throw new Error('Cannot find the head to append a style to');
    }

    document.body.appendChild(el);
    setState({
      el: el
    });
  };

  var unmount = function unmount() {
    if (!state.el) {
      console.error('Will not unmount annoucer as it is already unmounted');
      return;
    }
    var node = state.el;

    setState({
      el: null
    });

    if (!node.parentNode) {
      console.error('Cannot unmount style marshal as cannot find parent');
      return;
    }

    node.parentNode.removeChild(node);
  };

  var announcer = {
    announce: announce,
    id: id,
    mount: mount,
    unmount: unmount
  };

  return announcer;
});

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetServerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_create_store__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_hooks_hook_caller__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_dimension_marshal_dimension_marshal__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_marshal_style_marshal__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_can_start_drag__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__window_scroll_window__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__announcer_announcer__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state_auto_scroller__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__state_action_creators__ = __webpack_require__(1179);




var _DragDropContext$chil;
















var resetServerContext = function resetServerContext() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__style_marshal_style_marshal__["a" /* resetStyleContext */])();
};

var DragDropContext = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DragDropContext, _React$Component);

  function DragDropContext() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DragDropContext);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.canLift = function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__state_can_start_drag__["a" /* default */])(_this.store.getState(), id);
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  DragDropContext.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_13__context_keys__["a" /* storeKey */]] = this.store, _ref[__WEBPACK_IMPORTED_MODULE_13__context_keys__["e" /* dimensionMarshalKey */]] = this.dimensionMarshal, _ref[__WEBPACK_IMPORTED_MODULE_13__context_keys__["b" /* styleContextKey */]] = this.styleMarshal.styleContext, _ref[__WEBPACK_IMPORTED_MODULE_13__context_keys__["d" /* canLiftContextKey */]] = this.canLift, _ref;
  };

  DragDropContext.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    this.store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__state_create_store__["a" /* default */])();

    this.announcer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__announcer_announcer__["a" /* default */])();

    this.hookCaller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__state_hooks_hook_caller__["a" /* default */])(this.announcer.announce);

    this.styleMarshal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__style_marshal_style_marshal__["b" /* default */])();

    var callbacks = {
      cancel: function cancel() {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["k" /* clean */])());
      },
      publishDraggable: function publishDraggable(dimension) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["l" /* publishDraggableDimension */])(dimension));
      },
      publishDroppable: function publishDroppable(dimension) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["m" /* publishDroppableDimension */])(dimension));
      },
      bulkPublish: function bulkPublish(droppables, draggables) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["n" /* bulkPublishDimensions */])(droppables, draggables));
      },
      updateDroppableScroll: function updateDroppableScroll(id, newScroll) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["o" /* updateDroppableDimensionScroll */])(id, newScroll));
      },
      updateDroppableIsEnabled: function updateDroppableIsEnabled(id, isEnabled) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["p" /* updateDroppableDimensionIsEnabled */])(id, isEnabled));
      }
    };
    this.dimensionMarshal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__state_dimension_marshal_dimension_marshal__["a" /* default */])(callbacks);
    this.autoScroller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__state_auto_scroller__["a" /* default */])({
      scrollWindow: __WEBPACK_IMPORTED_MODULE_10__window_scroll_window__["a" /* default */],
      scrollDroppable: this.dimensionMarshal.scrollDroppable,
      move: function move(id, client, viewport, shouldAnimate) {
        _this2.store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__state_action_creators__["b" /* move */])(id, client, viewport, shouldAnimate));
      }
    });

    var previous = this.store.getState();

    this.unsubscribe = this.store.subscribe(function () {
      var current = _this2.store.getState();
      var previousInThisExecution = previous;
      var isPhaseChanging = current.phase !== previous.phase;

      previous = current;

      if (isPhaseChanging) {
        _this2.styleMarshal.onPhaseChange(current);
      }

      var isDragEnding = previousInThisExecution.phase === 'DRAGGING' && current.phase !== 'DRAGGING';

      if (isDragEnding) {
        _this2.dimensionMarshal.onPhaseChange(current);
      }

      var hooks = {
        onDragStart: _this2.props.onDragStart,
        onDragEnd: _this2.props.onDragEnd,
        onDragUpdate: _this2.props.onDragUpdate
      };
      _this2.hookCaller.onStateChange(hooks, previousInThisExecution, current);

      if (isPhaseChanging && !isDragEnding) {
        _this2.dimensionMarshal.onPhaseChange(current);
      }

      _this2.autoScroller.onStateChange(previousInThisExecution, current);
    });
  };

  DragDropContext.prototype.componentDidMount = function componentDidMount() {
    this.styleMarshal.mount();
    this.announcer.mount();
  };

  DragDropContext.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribe();
    this.styleMarshal.unmount();
    this.announcer.unmount();
  };

  DragDropContext.prototype.render = function render() {
    return this.props.children;
  };

  return DragDropContext;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DragDropContext.childContextTypes = (_DragDropContext$chil = {}, _DragDropContext$chil[__WEBPACK_IMPORTED_MODULE_13__context_keys__["a" /* storeKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  dispatch: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
}).isRequired, _DragDropContext$chil[__WEBPACK_IMPORTED_MODULE_13__context_keys__["e" /* dimensionMarshalKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired, _DragDropContext$chil[__WEBPACK_IMPORTED_MODULE_13__context_keys__["b" /* styleContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _DragDropContext$chil[__WEBPACK_IMPORTED_MODULE_13__context_keys__["d" /* canLiftContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired, _DragDropContext$chil);
/* harmony default export */ __webpack_exports__["a"] = (DragDropContext);

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_should_allow_dragging_from_target__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sensor_create_mouse_sensor__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sensor_create_keyboard_sensor__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sensor_create_touch_sensor__ = __webpack_require__(2230);




var _DragHandle$contextTy;











var preventHtml5Dnd = function preventHtml5Dnd(event) {
  event.preventDefault();
};

var DragHandle = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DragHandle, _Component);

  function DragHandle(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DragHandle);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props, context));

    _this.onKeyDown = function (event) {
      if (_this.mouseSensor.isCapturing()) {
        return;
      }

      _this.keyboardSensor.onKeyDown(event, _this.props);
    };

    _this.onMouseDown = function (event) {
      if (_this.keyboardSensor.isCapturing() || _this.mouseSensor.isCapturing()) {
        return;
      }

      _this.mouseSensor.onMouseDown(event);
    };

    _this.onTouchStart = function (event) {
      if (_this.mouseSensor.isCapturing() || _this.keyboardSensor.isCapturing()) {
        console.error('mouse or keyboard already listening when attempting to touch drag');
        return;
      }

      _this.touchSensor.onTouchStart(event);
    };

    _this.onTouchMove = function (event) {
      _this.touchSensor.onTouchMove(event);
    };

    _this.canStartCapturing = function (event) {
      if (_this.isAnySensorCapturing()) {
        return false;
      }

      if (!_this.canLift(_this.props.draggableId)) {
        return false;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_should_allow_dragging_from_target__["a" /* default */])(event, _this.props);
    };

    _this.isAnySensorCapturing = function () {
      return _this.sensors.some(function (sensor) {
        return sensor.isCapturing();
      });
    };

    _this.getProvided = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (isEnabled) {
      if (!isEnabled) {
        return null;
      }

      var provided = {
        onMouseDown: _this.onMouseDown,
        onKeyDown: _this.onKeyDown,
        onTouchStart: _this.onTouchStart,
        onTouchMove: _this.onTouchMove,
        tabIndex: 0,
        'data-react-beautiful-dnd-drag-handle': _this.styleContext,

        'aria-roledescription': 'Draggable item. Press space bar to lift',
        draggable: false,
        onDragStart: preventHtml5Dnd
      };

      return provided;
    });

    var args = {
      callbacks: _this.props.callbacks,
      getDraggableRef: _this.props.getDraggableRef,
      canStartCapturing: _this.canStartCapturing
    };

    _this.mouseSensor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__sensor_create_mouse_sensor__["a" /* default */])(args);
    _this.keyboardSensor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sensor_create_keyboard_sensor__["a" /* default */])(args);
    _this.touchSensor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sensor_create_touch_sensor__["a" /* default */])(args);
    _this.sensors = [_this.mouseSensor, _this.keyboardSensor, _this.touchSensor];
    _this.styleContext = context[__WEBPACK_IMPORTED_MODULE_6__context_keys__["b" /* styleContextKey */]];

    _this.canLift = context[__WEBPACK_IMPORTED_MODULE_6__context_keys__["d" /* canLiftContextKey */]];
    return _this;
  }

  DragHandle.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this2 = this;

    this.sensors.forEach(function (sensor) {
      var wasDragging = sensor.isDragging();

      sensor.unmount();

      if (wasDragging) {
        _this2.props.callbacks.onCancel();
      }
    });
  };

  DragHandle.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    var isCapturing = this.isAnySensorCapturing();

    if (!isCapturing) {
      return;
    }

    var isDragStopping = this.props.isDragging && !nextProps.isDragging;

    if (isDragStopping) {
      this.sensors.forEach(function (sensor) {
        if (sensor.isCapturing()) {
          sensor.kill();
        }
      });
      return;
    }

    if (!nextProps.isEnabled) {
      this.sensors.forEach(function (sensor) {
        if (sensor.isCapturing()) {
          var wasDragging = sensor.isDragging();

          sensor.kill();

          if (wasDragging) {
            _this3.props.callbacks.onCancel();
          }
        }
      });
    }
  };

  DragHandle.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        isEnabled = _props.isEnabled;

    return children(this.getProvided(isEnabled));
  };

  return DragHandle;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

DragHandle.contextTypes = (_DragHandle$contextTy = {}, _DragHandle$contextTy[__WEBPACK_IMPORTED_MODULE_6__context_keys__["b" /* styleContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _DragHandle$contextTy[__WEBPACK_IMPORTED_MODULE_6__context_keys__["d" /* canLiftContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired, _DragHandle$contextTy);
/* harmony default export */ __webpack_exports__["a"] = (DragHandle);

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drag_handle__ = __webpack_require__(2226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__drag_handle__["a"]; });



/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_create_scheduler__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_prevent_standard_key_events__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__key_codes__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_window_from_ref__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_center_position__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_bind_events__ = __webpack_require__(459);
var _scrollJumpKeys;








var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[__WEBPACK_IMPORTED_MODULE_2__key_codes__["b" /* pageDown */]] = true, _scrollJumpKeys[__WEBPACK_IMPORTED_MODULE_2__key_codes__["c" /* pageUp */]] = true, _scrollJumpKeys[__WEBPACK_IMPORTED_MODULE_2__key_codes__["d" /* home */]] = true, _scrollJumpKeys[__WEBPACK_IMPORTED_MODULE_2__key_codes__["e" /* end */]] = true, _scrollJumpKeys);

var noop = function noop() {};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var callbacks = _ref.callbacks,
      getDraggableRef = _ref.getDraggableRef,
      canStartCapturing = _ref.canStartCapturing;

  var state = {
    isDragging: false
  };
  var setState = function setState(newState) {
    state = newState;
  };
  var getWindow = function getWindow() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_window_from_ref__["a" /* default */])(getDraggableRef());
  };

  var startDragging = function startDragging() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    setState({
      isDragging: true
    });
    bindWindowEvents();
    fn();
  };
  var stopDragging = function stopDragging() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    schedule.cancel();
    unbindWindowEvents();
    setState({ isDragging: false });
    fn();
  };
  var kill = function kill() {
    return stopDragging();
  };
  var cancel = function cancel() {
    stopDragging(callbacks.onCancel);
  };
  var isDragging = function isDragging() {
    return state.isDragging;
  };
  var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_create_scheduler__["a" /* default */])(callbacks);

  var onKeyDown = function onKeyDown(event, props) {
    var direction = props.direction;

    if (!isDragging()) {
      if (event.defaultPrevented) {
        return;
      }

      if (!canStartCapturing(event)) {
        return;
      }

      if (event.keyCode !== __WEBPACK_IMPORTED_MODULE_2__key_codes__["f" /* space */]) {
        return;
      }

      var ref = getDraggableRef();

      if (!ref) {
        console.error('cannot start a keyboard drag without a draggable ref');
        return;
      }

      var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_center_position__["a" /* default */])(ref);

      event.preventDefault();
      startDragging(function () {
        return callbacks.onLift({
          client: center,
          autoScrollMode: 'JUMP'
        });
      });
      return;
    }

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["a" /* escape */]) {
      event.preventDefault();
      cancel();
      return;
    }

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["f" /* space */]) {
      event.preventDefault();
      stopDragging(callbacks.onDrop);
      return;
    }

    if (!direction) {
      console.error('Cannot handle keyboard movement event if direction is not provided');

      event.preventDefault();
      cancel();
      return;
    }

    var executeBasedOnDirection = function executeBasedOnDirection(fns) {
      if (direction === 'vertical') {
        fns.vertical();
        return;
      }
      fns.horizontal();
    };

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["g" /* arrowDown */]) {
      event.preventDefault();
      executeBasedOnDirection({
        vertical: schedule.moveForward,
        horizontal: schedule.crossAxisMoveForward
      });
      return;
    }

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["h" /* arrowUp */]) {
      event.preventDefault();
      executeBasedOnDirection({
        vertical: schedule.moveBackward,
        horizontal: schedule.crossAxisMoveBackward
      });
      return;
    }

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["i" /* arrowRight */]) {
      event.preventDefault();
      executeBasedOnDirection({
        vertical: schedule.crossAxisMoveForward,
        horizontal: schedule.moveForward
      });
      return;
    }

    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__key_codes__["j" /* arrowLeft */]) {
      event.preventDefault();
      executeBasedOnDirection({
        vertical: schedule.crossAxisMoveBackward,
        horizontal: schedule.moveBackward
      });
    }

    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_prevent_standard_key_events__["a" /* default */])(event);
  };

  var windowBindings = [{
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel
  }, {
    eventName: 'scroll',
    fn: callbacks.onWindowScroll
  }];

  var bindWindowEvents = function bindWindowEvents() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_bind_events__["a" /* bindEvents */])(getWindow(), windowBindings, { capture: true });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_bind_events__["b" /* unbindEvents */])(getWindow(), windowBindings, { capture: true });
  };

  var sensor = {
    onKeyDown: onKeyDown,
    kill: kill,
    isDragging: isDragging,

    isCapturing: isDragging,

    unmount: kill
  };

  return sensor;
});

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_create_scheduler__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_is_sloppy_click_threshold_exceeded__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_window_from_ref__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__key_codes__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_prevent_standard_key_events__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_create_post_drag_event_preventer__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_bind_events__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_create_event_marshal__ = __webpack_require__(1191);










var primaryButton = 0;
var noop = function noop() {};

var mouseDownMarshal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_create_event_marshal__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var callbacks = _ref.callbacks,
      getDraggableRef = _ref.getDraggableRef,
      canStartCapturing = _ref.canStartCapturing;

  var state = {
    isDragging: false,
    pending: null
  };
  var setState = function setState(newState) {
    state = newState;
  };
  var isDragging = function isDragging() {
    return state.isDragging;
  };
  var isCapturing = function isCapturing() {
    return Boolean(state.pending || state.isDragging);
  };
  var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_create_scheduler__["a" /* default */])(callbacks);
  var getWindow = function getWindow() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_window_from_ref__["a" /* default */])(getDraggableRef());
  };
  var postDragEventPreventer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_create_post_drag_event_preventer__["a" /* default */])(getWindow);

  var startDragging = function startDragging() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    setState({
      pending: null,
      isDragging: true
    });
    fn();
  };
  var stopDragging = function stopDragging() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
    var shouldBlockClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    schedule.cancel();
    unbindWindowEvents();
    mouseDownMarshal.reset();
    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }
    setState({
      isDragging: false,
      pending: null
    });
    fn();
  };
  var startPendingDrag = function startPendingDrag(point) {
    setState({ pending: point, isDragging: false });
    bindWindowEvents();
  };
  var stopPendingDrag = function stopPendingDrag() {
    stopDragging(noop, false);
  };

  var kill = function kill() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (state.pending) {
      stopPendingDrag();
      return;
    }
    stopDragging(fn);
  };

  var unmount = function unmount() {
    kill();
    postDragEventPreventer.abort();
  };

  var cancel = function cancel() {
    kill(callbacks.onCancel);
  };

  var windowBindings = [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };

      if (state.isDragging) {
        event.preventDefault();
        schedule.move(point);
        return;
      }

      if (!state.pending) {
        console.error('invalid state');
        return;
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_is_sloppy_click_threshold_exceeded__["a" /* default */])(state.pending, point)) {
        return;
      }

      event.preventDefault();
      startDragging(function () {
        return callbacks.onLift({
          client: point,
          autoScrollMode: 'FLUID'
        });
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      if (state.pending) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onDrop);
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (state.isDragging) {
        event.preventDefault();
      }

      stopDragging(callbacks.onCancel);
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (!state.isDragging) {
        cancel();
        return;
      }

      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3__key_codes__["a" /* escape */]) {
        event.preventDefault();
        cancel();
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_prevent_standard_key_events__["a" /* default */])(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',

    options: { passive: true },
    fn: function fn() {
      if (state.pending) {
        stopPendingDrag();
        return;
      }
      schedule.windowScrollMove();
    }
  }, {
    eventName: 'webkitmouseforcechanged',
    fn: function fn(event) {
      if (event.webkitForce == null || MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN == null) {
        console.error('handling a mouse force changed event when it is not supported');
        return;
      }

      var forcePressThreshold = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
      var isForcePressing = event.webkitForce >= forcePressThreshold;

      if (isForcePressing) {
        cancel();
      }
    }
  }];

  var bindWindowEvents = function bindWindowEvents() {
    var win = getWindow();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_bind_events__["a" /* bindEvents */])(win, windowBindings, { capture: true });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    var win = getWindow();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_bind_events__["b" /* unbindEvents */])(win, windowBindings, { capture: true });
  };

  var onMouseDown = function onMouseDown(event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }

    if (!canStartCapturing(event)) {
      return;
    }

    if (isCapturing()) {
      console.error('should not be able to perform a mouse down while a drag or pending drag is occurring');
      cancel();
      return;
    }

    var button = event.button,
        clientX = event.clientX,
        clientY = event.clientY;

    if (button !== primaryButton) {
      return;
    }

    mouseDownMarshal.handle();

    event.preventDefault();

    var point = {
      x: clientX,
      y: clientY
    };

    startPendingDrag(point);
  };

  var sensor = {
    onMouseDown: onMouseDown,
    kill: kill,
    isCapturing: isCapturing,
    isDragging: isDragging,
    unmount: unmount
  };

  return sensor;
});

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeForLongPress */
/* unused harmony export forcePressThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_create_scheduler__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_window_from_ref__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_create_post_drag_event_preventer__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_create_event_marshal__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_bind_events__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__key_codes__ = __webpack_require__(460);









var timeForLongPress = 150;
var forcePressThreshold = 0.15;
var touchStartMarshal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_create_event_marshal__["a" /* default */])();
var noop = function noop() {};

var webkitHack = function () {
  var stub = {
    preventTouchMove: noop,
    releaseTouchMove: noop
  };

  if (typeof window === 'undefined') {
    return stub;
  }

  if (!('ontouchstart' in window)) {
    return stub;
  }

  var isBlocking = false;

  window.addEventListener('touchmove', function (event) {
    if (!isBlocking) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();
  }, { passive: false, capture: false });

  var preventTouchMove = function preventTouchMove() {
    isBlocking = true;
  };
  var releaseTouchMove = function releaseTouchMove() {
    isBlocking = false;
  };

  return { preventTouchMove: preventTouchMove, releaseTouchMove: releaseTouchMove };
}();

var initial = {
  isDragging: false,
  pending: null,
  hasMoved: false,
  longPressTimerId: null
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var callbacks = _ref.callbacks,
      getDraggableRef = _ref.getDraggableRef,
      canStartCapturing = _ref.canStartCapturing;

  var state = initial;

  var getWindow = function getWindow() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_window_from_ref__["a" /* default */])(getDraggableRef());
  };
  var setState = function setState(partial) {
    state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, partial);
  };
  var isDragging = function isDragging() {
    return state.isDragging;
  };
  var isCapturing = function isCapturing() {
    return Boolean(state.pending || state.isDragging || state.longPressTimerId);
  };
  var schedule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_create_scheduler__["a" /* default */])(callbacks);
  var postDragEventPreventer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_create_post_drag_event_preventer__["a" /* default */])(getWindow);

  var startDragging = function startDragging() {
    var pending = state.pending;

    if (!pending) {
      console.error('cannot start a touch drag without a pending position');
      kill();
      return;
    }

    setState({
      isDragging: true,

      hasMoved: false,

      pending: null,
      longPressTimerId: null
    });

    callbacks.onLift({
      client: pending,
      autoScrollMode: 'FLUID'
    });
  };
  var stopDragging = function stopDragging() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    schedule.cancel();
    touchStartMarshal.reset();
    webkitHack.releaseTouchMove();
    unbindWindowEvents();
    postDragEventPreventer.preventNext();
    setState(initial);
    fn();
  };

  var startPendingDrag = function startPendingDrag(event) {
    var touch = event.touches[0];
    var clientX = touch.clientX,
        clientY = touch.clientY;

    var point = {
      x: clientX,
      y: clientY
    };

    var longPressTimerId = setTimeout(startDragging, timeForLongPress);

    setState({
      longPressTimerId: longPressTimerId,
      pending: point,
      isDragging: false,
      hasMoved: false
    });
    bindWindowEvents();
  };

  var stopPendingDrag = function stopPendingDrag() {
    if (state.longPressTimerId) {
      clearTimeout(state.longPressTimerId);
    }
    schedule.cancel();
    touchStartMarshal.reset();
    webkitHack.releaseTouchMove();
    unbindWindowEvents();

    setState(initial);
  };

  var kill = function kill() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (state.pending) {
      stopPendingDrag();
      return;
    }
    stopDragging(fn);
  };

  var unmount = function unmount() {
    kill();
    postDragEventPreventer.abort();
  };

  var cancel = function cancel() {
    kill(callbacks.onCancel);
  };

  var windowBindings = [{
    eventName: 'touchmove',

    options: { passive: false },
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      if (!state.hasMoved) {
        setState({
          hasMoved: true
        });
      }

      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;

      var point = {
        x: clientX,
        y: clientY
      };

      event.preventDefault();
      schedule.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onDrop);
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (!state.isDragging) {
        stopPendingDrag();
        return;
      }

      event.preventDefault();
      stopDragging(callbacks.onCancel);
    }
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: { passive: true },
    fn: function fn() {
      if (state.pending) {
        stopPendingDrag();
        return;
      }
      schedule.windowScrollMove();
    }
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (!state.isDragging) {
        cancel();
        return;
      }

      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_6__key_codes__["a" /* escape */]) {
        event.preventDefault();
      }
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      if (state.hasMoved) {
        event.preventDefault();
        return;
      }

      var touch = event.touches[0];

      if (touch.force >= forcePressThreshold) {
        cancel();
      }
    }
  }];

  var bindWindowEvents = function bindWindowEvents() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_bind_events__["a" /* bindEvents */])(getWindow(), windowBindings, { capture: true });
  };

  var unbindWindowEvents = function unbindWindowEvents() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_bind_events__["b" /* unbindEvents */])(getWindow(), windowBindings, { capture: true });
  };

  var onTouchStart = function onTouchStart(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }

    if (!canStartCapturing(event)) {
      return;
    }

    if (isCapturing()) {
      console.error('should not be able to perform a touch start while a drag or pending drag is occurring');
      cancel();
      return;
    }

    touchStartMarshal.handle();

    webkitHack.preventTouchMove();
    startPendingDrag(event);
  };

  var onTouchMove = function onTouchMove() {
    if (state.pending) {
      stopPendingDrag();
    }
  };

  var sensor = {
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    kill: kill,
    isCapturing: isCapturing,
    isDragging: isDragging,
    unmount: unmount
  };

  return sensor;
});

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sloppyClickThreshold */

var sloppyClickThreshold = 5;

/* harmony default export */ __webpack_exports__["a"] = (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interactiveTagNames */


var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');
  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
};

/* harmony default export */ __webpack_exports__["a"] = (function (event, props) {
  if (props.canDragInteractiveElements) {
    return true;
  }

  var target = event.target,
      currentTarget = event.currentTarget;

  if (!(target instanceof Element) || !(currentTarget instanceof Element)) {
    return true;
  }

  return !isAnInteractiveElement(currentTarget, target);
});

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__window_get_window_scroll__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_dimension__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_get_area__ = __webpack_require__(284);




var _DraggableDimensionPu;










var DraggableDimensionPublisher = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DraggableDimensionPublisher, _Component);

  function DraggableDimensionPublisher() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DraggableDimensionPublisher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.publishedDescriptor = null, _this.getMemoizedDescriptor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (id, droppableId, index) {
      return {
        id: id,
        droppableId: droppableId,
        index: index
      };
    }), _this.unpublish = function () {
      if (!_this.publishedDescriptor) {
        console.error('cannot unpublish descriptor when none is published');
        return;
      }

      var marshal = _this.context[__WEBPACK_IMPORTED_MODULE_8__context_keys__["e" /* dimensionMarshalKey */]];
      marshal.unregisterDraggable(_this.publishedDescriptor);
      _this.publishedDescriptor = null;
    }, _this.publish = function (descriptor) {
      if (descriptor === _this.publishedDescriptor) {
        return;
      }

      if (_this.publishedDescriptor) {
        _this.unpublish();
      }

      var marshal = _this.context[__WEBPACK_IMPORTED_MODULE_8__context_keys__["e" /* dimensionMarshalKey */]];
      marshal.registerDraggable(descriptor, _this.getDimension);
      _this.publishedDescriptor = descriptor;
    }, _this.getDimension = function () {
      var targetRef = _this.props.targetRef;

      if (!targetRef) {
        throw new Error('DraggableDimensionPublisher cannot calculate a dimension when not attached to the DOM');
      }

      var descriptor = _this.publishedDescriptor;

      if (!descriptor) {
        throw new Error('Cannot get dimension for unpublished draggable');
      }

      var style = window.getComputedStyle(targetRef);

      var margin = {
        top: parseInt(style.marginTop, 10),
        right: parseInt(style.marginRight, 10),
        bottom: parseInt(style.marginBottom, 10),
        left: parseInt(style.marginLeft, 10)
      };

      var paddingBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__state_get_area__["a" /* default */])(targetRef.getBoundingClientRect());

      var dimension = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__state_dimension__["a" /* getDraggableDimension */])({
        descriptor: descriptor,
        paddingBox: paddingBox,
        margin: margin,
        windowScroll: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__window_get_window_scroll__["a" /* default */])()
      });

      return dimension;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  DraggableDimensionPublisher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var draggableId = nextProps.draggableId,
        droppableId = nextProps.droppableId,
        index = nextProps.index,
        targetRef = nextProps.targetRef;

    if (!targetRef) {
      console.error('Updating draggable dimension handler without a targetRef');
      return;
    }

    var descriptor = this.getMemoizedDescriptor(draggableId, droppableId, index);

    this.publish(descriptor);
  };

  DraggableDimensionPublisher.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unpublish();
  };

  DraggableDimensionPublisher.prototype.render = function render() {
    return this.props.children;
  };

  return DraggableDimensionPublisher;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

DraggableDimensionPublisher.contextTypes = (_DraggableDimensionPu = {}, _DraggableDimensionPu[__WEBPACK_IMPORTED_MODULE_8__context_keys__["e" /* dimensionMarshalKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired, _DraggableDimensionPu);
/* harmony default export */ __webpack_exports__["a"] = (DraggableDimensionPublisher);

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__draggable_dimension_publisher__ = __webpack_require__(2233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__draggable_dimension_publisher__["a"]; });



/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_position__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_get_displacement_map__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_action_creators__ = __webpack_require__(1179);










var origin = { x: 0, y: 0 };

var defaultMapProps = {
  isDropAnimating: false,
  isDragging: false,
  offset: origin,
  shouldAnimateDragMovement: false,

  shouldAnimateDisplacement: true,

  dimension: null,
  direction: null,
  draggingOver: null
};

var makeSelector = function makeSelector() {
  var memoizedOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x, y: y
    };
  });

  var getNotDraggingProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (offset, shouldAnimateDisplacement) {
    return {
      isDropAnimating: false,
      isDragging: false,
      offset: offset,
      shouldAnimateDisplacement: shouldAnimateDisplacement,

      shouldAnimateDragMovement: false,
      dimension: null,
      direction: null,
      draggingOver: null
    };
  });

  var getDraggingProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (offset, shouldAnimateDragMovement, dimension, direction, draggingOver) {
    return {
      isDragging: true,
      isDropAnimating: false,
      shouldAnimateDisplacement: false,
      offset: offset,
      shouldAnimateDragMovement: shouldAnimateDragMovement,
      dimension: dimension,
      direction: direction,
      draggingOver: draggingOver
    };
  });

  var draggingSelector = function draggingSelector(state, ownProps) {
    if (state.phase !== 'DRAGGING' && state.phase !== 'DROP_ANIMATING') {
      return null;
    }

    if (state.phase === 'DRAGGING') {
      if (!state.drag) {
        console.error('invalid drag state found in selector');
        return null;
      }

      if (state.drag.initial.descriptor.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.drag.current.client.offset;
      var dimension = state.dimension.draggable[ownProps.draggableId];
      var _direction = state.drag.impact.direction;
      var shouldAnimateDragMovement = state.drag.current.shouldAnimate;
      var _draggingOver = state.drag.impact.destination ? state.drag.impact.destination.droppableId : null;

      return getDraggingProps(memoizedOffset(offset.x, offset.y), shouldAnimateDragMovement, dimension, _direction, _draggingOver);
    }

    var pending = state.drop && state.drop.pending;

    if (!pending) {
      console.error('cannot provide props for dropping item when there is invalid state');
      return null;
    }

    if (pending.result.draggableId !== ownProps.draggableId) {
      return null;
    }

    var draggingOver = pending.result.destination ? pending.result.destination.droppableId : null;
    var direction = pending.impact.direction ? pending.impact.direction : null;

    return {
      isDragging: false,
      isDropAnimating: true,
      offset: pending.newHomeOffset,

      dimension: state.dimension.draggable[ownProps.draggableId],
      draggingOver: draggingOver,
      direction: direction,

      shouldAnimateDragMovement: false,

      shouldAnimateDisplacement: false
    };
  };

  var getOutOfTheWayMovement = function getOutOfTheWayMovement(id, movement) {
    var map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__state_get_displacement_map__["a" /* default */])(movement.displaced);
    var displacement = map[id];

    if (!displacement) {
      return null;
    }

    if (!displacement.isVisible) {
      return null;
    }

    var amount = movement.isBeyondStartPosition ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__state_position__["a" /* negate */])(movement.amount) : movement.amount;

    return getNotDraggingProps(memoizedOffset(amount.x, amount.y), displacement.shouldAnimate);
  };

  var movingOutOfTheWaySelector = function movingOutOfTheWaySelector(state, ownProps) {
    if (state.phase !== 'DRAGGING' && state.phase !== 'DROP_ANIMATING') {
      return null;
    }

    if (state.phase === 'DRAGGING') {
      if (!state.drag) {
        console.error('cannot correctly move item out of the way when there is invalid state');
        return null;
      }

      if (state.drag.initial.descriptor.id === ownProps.draggableId) {
        return null;
      }

      return getOutOfTheWayMovement(ownProps.draggableId, state.drag.impact.movement);
    }

    if (!state.drop || !state.drop.pending) {
      console.error('cannot provide props for dropping item when there is invalid state');
      return null;
    }

    if (state.drop.pending.result.draggableId === ownProps.draggableId) {
      return null;
    }

    return getOutOfTheWayMovement(ownProps.draggableId, state.drop.pending.impact.movement);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([draggingSelector, movingOutOfTheWaySelector], function (dragging, movingOutOfTheWay) {
    if (dragging) {
      return dragging;
    }

    if (movingOutOfTheWay) {
      return movingOutOfTheWay;
    }

    return defaultMapProps;
  });
};

var makeMapStateToProps = function makeMapStateToProps() {
  var selector = makeSelector();
  return function (state, props) {
    return selector(state, props);
  };
};

var mapDispatchToProps = {
  lift: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["a" /* lift */],
  move: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["b" /* move */],
  moveForward: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["c" /* moveForward */],
  moveBackward: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["d" /* moveBackward */],
  crossAxisMoveForward: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["e" /* crossAxisMoveForward */],
  crossAxisMoveBackward: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["f" /* crossAxisMoveBackward */],
  moveByWindowScroll: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["g" /* moveByWindowScroll */],
  drop: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["h" /* drop */],
  dropAnimationFinished: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["i" /* dropAnimationFinished */],
  cancel: __WEBPACK_IMPORTED_MODULE_7__state_action_creators__["j" /* cancel */]
};

var ConnectedDraggable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* connect */])(makeMapStateToProps, mapDispatchToProps, null, { storeKey: __WEBPACK_IMPORTED_MODULE_4__context_keys__["a" /* storeKey */] })(__WEBPACK_IMPORTED_MODULE_3__draggable__["a" /* default */]);

ConnectedDraggable.defaultProps = {
  isDragDisabled: false,

  disableInteractiveElementBlocking: false
};

/* harmony default export */ __webpack_exports__["a"] = (ConnectedDraggable);

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export zIndexOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__draggable_dimension_publisher___ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moveable___ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__drag_handle__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__window_get_viewport__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__get_center_position__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placeholder__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__debug_timings__ = __webpack_require__(1178);




var _Draggable$contextTyp;
















var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var Draggable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Draggable, _Component);

  function Draggable(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Draggable);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props, context));

    _this.state = {
      ref: null
    };

    _this.onMoveEnd = function () {
      if (!_this.props.isDropAnimating) {
        return;
      }

      _this.props.dropAnimationFinished();
    };

    _this.onLift = function (options) {
      __WEBPACK_IMPORTED_MODULE_14__debug_timings__["a" /* start */]('LIFT');
      _this.throwIfCannotDrag();
      var client = options.client,
          autoScrollMode = options.autoScrollMode;
      var _this$props = _this.props,
          lift = _this$props.lift,
          draggableId = _this$props.draggableId;
      var ref = _this.state.ref;

      if (!ref) {
        throw new Error('cannot lift at this time');
      }

      var initial = {
        selection: client,
        center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__get_center_position__["a" /* default */])(ref)
      };

      lift(draggableId, initial, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__window_get_viewport__["a" /* default */])(), autoScrollMode);
    };

    _this.onMove = function (client) {
      _this.throwIfCannotDrag();

      var _this$props2 = _this.props,
          draggableId = _this$props2.draggableId,
          dimension = _this$props2.dimension,
          move = _this$props2.move;

      if (!dimension) {
        return;
      }

      move(draggableId, client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__window_get_viewport__["a" /* default */])());
    };

    _this.onMoveForward = function () {
      _this.throwIfCannotDrag();
      _this.props.moveForward(_this.props.draggableId);
    };

    _this.onMoveBackward = function () {
      _this.throwIfCannotDrag();
      _this.props.moveBackward(_this.props.draggableId);
    };

    _this.onCrossAxisMoveForward = function () {
      _this.throwIfCannotDrag();
      _this.props.crossAxisMoveForward(_this.props.draggableId);
    };

    _this.onCrossAxisMoveBackward = function () {
      _this.throwIfCannotDrag();
      _this.props.crossAxisMoveBackward(_this.props.draggableId);
    };

    _this.onWindowScroll = function () {
      _this.throwIfCannotDrag();
      _this.props.moveByWindowScroll(_this.props.draggableId, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__window_get_viewport__["a" /* default */])());
    };

    _this.onDrop = function () {
      _this.throwIfCannotDrag();
      _this.props.drop();
    };

    _this.onCancel = function () {
      _this.props.cancel();
    };

    _this.setRef = function (ref) {
      if (ref === null) {
        return;
      }

      if (ref === _this.state.ref) {
        return;
      }

      _this.setState({
        ref: ref
      });
    };

    _this.getDraggableRef = function () {
      return _this.state.ref;
    };

    _this.getDraggingStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (dimension, isDropAnimating, movementStyle) {
      var _dimension$client$pad = dimension.client.paddingBox,
          width = _dimension$client$pad.width,
          height = _dimension$client$pad.height,
          top = _dimension$client$pad.top,
          left = _dimension$client$pad.left;

      var style = {
        position: 'fixed',
        boxSizing: 'border-box',
        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
        width: width,
        height: height,
        top: top,
        left: left,
        margin: 0,
        pointerEvents: 'none',
        transition: 'none',
        transform: movementStyle.transform ? '' + movementStyle.transform : null
      };
      return style;
    });
    _this.getNotDraggingStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (movementStyle, shouldAnimateDisplacement) {
      var style = {
        transform: movementStyle.transform,

        transition: shouldAnimateDisplacement ? null : 'none'
      };
      return style;
    });
    _this.getProvided = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps, movementStyle) {
      var useDraggingStyle = isDragging || isDropAnimating;

      var draggableStyle = function () {
        if (!useDraggingStyle) {
          return _this.getNotDraggingStyle(movementStyle, shouldAnimateDisplacement);
        }

        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(dimension, 'draggable dimension required for dragging');

        return _this.getDraggingStyle(dimension, isDropAnimating, movementStyle);
      }();

      var provided = {
        innerRef: _this.setRef,
        draggableProps: {
          'data-react-beautiful-dnd-draggable': _this.styleContext,
          style: draggableStyle
        },
        dragHandleProps: dragHandleProps,
        placeholder: useDraggingStyle ? _this.getPlaceholder() : null
      };
      return provided;
    });
    _this.getSnapshot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (isDragging, isDropAnimating, draggingOver) {
      return {
        isDragging: isDragging || isDropAnimating,
        draggingOver: draggingOver
      };
    });
    _this.getSpeed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (isDragging, shouldAnimateDragMovement, isDropAnimating) {
      if (isDropAnimating) {
        return 'STANDARD';
      }

      if (isDragging && shouldAnimateDragMovement) {
        return 'FAST';
      }

      return 'INSTANT';
    });

    var callbacks = {
      onLift: _this.onLift,
      onMove: _this.onMove,
      onDrop: _this.onDrop,
      onCancel: _this.onCancel,
      onMoveBackward: _this.onMoveBackward,
      onMoveForward: _this.onMoveForward,
      onCrossAxisMoveForward: _this.onCrossAxisMoveForward,
      onCrossAxisMoveBackward: _this.onCrossAxisMoveBackward,
      onWindowScroll: _this.onWindowScroll
    };

    _this.callbacks = callbacks;
    _this.styleContext = context[__WEBPACK_IMPORTED_MODULE_13__context_keys__["b" /* styleContextKey */]];
    return _this;
  }

  Draggable.prototype.throwIfCannotDrag = function throwIfCannotDrag() {
    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(this.state.ref, 'Draggable: cannot drag as no DOM node has been provided');
    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!this.props.isDragDisabled, 'Draggable: cannot drag as dragging is not enabled');
  };

  Draggable.prototype.getPlaceholder = function getPlaceholder() {
    var dimension = this.props.dimension;
    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(dimension, 'cannot get a drag placeholder when not dragging');

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__placeholder__["a" /* default */], { placeholder: dimension.placeholder });
  };

  Draggable.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        draggableId = _props.draggableId,
        index = _props.index,
        offset = _props.offset,
        isDragging = _props.isDragging,
        isDropAnimating = _props.isDropAnimating,
        isDragDisabled = _props.isDragDisabled,
        dimension = _props.dimension,
        draggingOver = _props.draggingOver,
        direction = _props.direction,
        shouldAnimateDragMovement = _props.shouldAnimateDragMovement,
        shouldAnimateDisplacement = _props.shouldAnimateDisplacement,
        disableInteractiveElementBlocking = _props.disableInteractiveElementBlocking,
        children = _props.children;

    var droppableId = this.context[__WEBPACK_IMPORTED_MODULE_13__context_keys__["c" /* droppableIdKey */]];

    var speed = this.getSpeed(isDragging, shouldAnimateDragMovement, isDropAnimating);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__draggable_dimension_publisher___["a" /* default */], {
      draggableId: draggableId,
      droppableId: droppableId,
      index: index,
      targetRef: this.state.ref
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__moveable___["a" /* default */], {
      speed: speed,
      destination: offset,
      onMoveEnd: this.onMoveEnd
    }, function (movementStyle) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__drag_handle__["a" /* default */], {
        draggableId: draggableId,
        isDragging: isDragging,
        direction: direction,
        isEnabled: !isDragDisabled,
        callbacks: _this2.callbacks,
        getDraggableRef: _this2.getDraggableRef,

        canDragInteractiveElements: disableInteractiveElementBlocking
      }, function (dragHandleProps) {
        return children(_this2.getProvided(isDragging, isDropAnimating, shouldAnimateDisplacement, dimension, dragHandleProps, movementStyle), _this2.getSnapshot(isDragging, isDropAnimating, draggingOver));
      });
    }));
  };

  return Draggable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Draggable.contextTypes = (_Draggable$contextTyp = {}, _Draggable$contextTyp[__WEBPACK_IMPORTED_MODULE_13__context_keys__["c" /* droppableIdKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _Draggable$contextTyp[__WEBPACK_IMPORTED_MODULE_13__context_keys__["b" /* styleContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _Draggable$contextTyp);
/* harmony default export */ __webpack_exports__["a"] = (Draggable);

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connected_draggable__ = __webpack_require__(2235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__connected_draggable__["a"]; });



/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raf_schd__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__window_get_window_scroll__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_get_area__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_dimension__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__get_closest_scrollable__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_keys__ = __webpack_require__(198);




var _DroppableDimensionPu;












var origin = { x: 0, y: 0 };

var DroppableDimensionPublisher = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DroppableDimensionPublisher, _Component);

  function DroppableDimensionPublisher(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DroppableDimensionPublisher);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props, context));

    _this.closestScrollable = null;
    _this.isWatchingScroll = false;
    _this.scrollOptions = null;
    _this.publishedDescriptor = null;

    _this.getClosestScroll = function () {
      if (!_this.closestScrollable) {
        return origin;
      }

      var offset = {
        x: _this.closestScrollable.scrollLeft,
        y: _this.closestScrollable.scrollTop
      };

      return offset;
    };

    _this.memoizedUpdateScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (x, y) {
      if (!_this.publishedDescriptor) {
        console.error('Cannot update scroll on unpublished droppable');
        return;
      }

      var newScroll = { x: x, y: y };
      var marshal = _this.context[__WEBPACK_IMPORTED_MODULE_11__context_keys__["e" /* dimensionMarshalKey */]];
      marshal.updateDroppableScroll(_this.publishedDescriptor.id, newScroll);
    });

    _this.updateScroll = function () {
      var offset = _this.getClosestScroll();
      _this.memoizedUpdateScroll(offset.x, offset.y);
    };

    _this.scheduleScrollUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_raf_schd__["a" /* default */])(_this.updateScroll);

    _this.onClosestScroll = function () {
      if (!_this.scrollOptions) {
        console.error('Cannot find scroll options while scrolling');
        return;
      }
      if (_this.scrollOptions.shouldPublishImmediately) {
        _this.updateScroll();
        return;
      }
      _this.scheduleScrollUpdate();
    };

    _this.scroll = function (change) {
      if (_this.closestScrollable == null) {
        console.error('Cannot scroll a droppable with no closest scrollable');
        return;
      }

      if (!_this.isWatchingScroll) {
        console.error('Updating Droppable scroll while not watching for updates');
        return;
      }

      _this.closestScrollable.scrollTop += change.y;
      _this.closestScrollable.scrollLeft += change.x;
    };

    _this.watchScroll = function (options) {
      if (!_this.props.targetRef) {
        console.error('cannot watch droppable scroll if not in the dom');
        return;
      }

      if (_this.closestScrollable == null) {
        return;
      }

      if (_this.isWatchingScroll) {
        return;
      }

      _this.isWatchingScroll = true;
      _this.scrollOptions = options;
      _this.closestScrollable.addEventListener('scroll', _this.onClosestScroll, { passive: true });
    };

    _this.unwatchScroll = function () {
      if (!_this.isWatchingScroll) {
        return;
      }

      _this.isWatchingScroll = false;
      _this.scrollOptions = null;
      _this.scheduleScrollUpdate.cancel();

      if (!_this.closestScrollable) {
        console.error('cannot unbind event listener if element is null');
        return;
      }

      _this.closestScrollable.removeEventListener('scroll', _this.onClosestScroll);
    };

    _this.getMemoizedDescriptor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(function (id, type) {
      return {
        id: id,
        type: type
      };
    });

    _this.unpublish = function () {
      if (!_this.publishedDescriptor) {
        console.error('cannot unpublish descriptor when none is published');
        return;
      }

      var marshal = _this.context[__WEBPACK_IMPORTED_MODULE_11__context_keys__["e" /* dimensionMarshalKey */]];
      marshal.unregisterDroppable(_this.publishedDescriptor);
      _this.publishedDescriptor = null;
    };

    _this.publish = function (descriptor) {
      if (descriptor === _this.publishedDescriptor) {
        return;
      }

      if (_this.publishedDescriptor) {
        _this.unpublish();
      }

      var marshal = _this.context[__WEBPACK_IMPORTED_MODULE_11__context_keys__["e" /* dimensionMarshalKey */]];
      marshal.registerDroppable(descriptor, _this.callbacks);
      _this.publishedDescriptor = descriptor;
    };

    _this.getDimension = function () {
      var _this$props = _this.props,
          direction = _this$props.direction,
          ignoreContainerClipping = _this$props.ignoreContainerClipping,
          isDropDisabled = _this$props.isDropDisabled,
          targetRef = _this$props.targetRef;

      if (!targetRef) {
        throw new Error('DimensionPublisher cannot calculate a dimension when not attached to the DOM');
      }

      if (_this.isWatchingScroll) {
        throw new Error('Attempting to recapture Droppable dimension while already watching scroll on previous capture');
      }

      var descriptor = _this.publishedDescriptor;

      if (!descriptor) {
        throw new Error('Cannot get dimension for unpublished droppable');
      }

      _this.closestScrollable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__get_closest_scrollable__["a" /* default */])(targetRef);
      var style = window.getComputedStyle(targetRef);

      var margin = {
        top: parseInt(style.marginTop, 10),
        right: parseInt(style.marginRight, 10),
        bottom: parseInt(style.marginBottom, 10),
        left: parseInt(style.marginLeft, 10)
      };
      var padding = {
        top: parseInt(style.paddingTop, 10),
        right: parseInt(style.paddingRight, 10),
        bottom: parseInt(style.paddingBottom, 10),
        left: parseInt(style.paddingLeft, 10)
      };

      var paddingBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__state_get_area__["a" /* default */])(targetRef.getBoundingClientRect());

      var closest = function () {
        var closestScrollable = _this.closestScrollable;

        if (!closestScrollable) {
          return null;
        }

        var framePaddingBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__state_get_area__["a" /* default */])(closestScrollable.getBoundingClientRect());
        var scroll = _this.getClosestScroll();
        var scrollWidth = closestScrollable.scrollWidth;
        var scrollHeight = closestScrollable.scrollHeight;

        return {
          framePaddingBox: framePaddingBox,
          scrollWidth: scrollWidth,
          scrollHeight: scrollHeight,
          scroll: scroll,
          shouldClipSubject: !ignoreContainerClipping
        };
      }();

      var dimension = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__state_dimension__["b" /* getDroppableDimension */])({
        descriptor: descriptor,
        direction: direction,
        paddingBox: paddingBox,
        closest: closest,
        margin: margin,
        padding: padding,
        windowScroll: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__window_get_window_scroll__["a" /* default */])(),
        isEnabled: !isDropDisabled
      });

      return dimension;
    };

    var callbacks = {
      getDimension: _this.getDimension,
      watchScroll: _this.watchScroll,
      unwatchScroll: _this.unwatchScroll,
      scroll: _this.scroll
    };
    _this.callbacks = callbacks;
    return _this;
  }

  DroppableDimensionPublisher.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.targetRef) {
      console.error('Cannot update droppable dimension publisher without a target ref');
      return;
    }

    var droppableId = nextProps.droppableId,
        type = nextProps.type;

    var descriptor = this.getMemoizedDescriptor(droppableId, type);

    this.publish(descriptor);

    if (this.props.isDropDisabled === nextProps.isDropDisabled) {
      return;
    }

    var marshal = this.context[__WEBPACK_IMPORTED_MODULE_11__context_keys__["e" /* dimensionMarshalKey */]];
    marshal.updateDroppableIsEnabled(nextProps.droppableId, !nextProps.isDropDisabled);
  };

  DroppableDimensionPublisher.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.isWatchingScroll) {
      console.warn('unmounting droppable while it was watching scroll');
      this.unwatchScroll();
    }

    this.unpublish();
  };

  DroppableDimensionPublisher.prototype.render = function render() {
    return this.props.children;
  };

  return DroppableDimensionPublisher;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

DroppableDimensionPublisher.contextTypes = (_DroppableDimensionPu = {}, _DroppableDimensionPu[__WEBPACK_IMPORTED_MODULE_11__context_keys__["e" /* dimensionMarshalKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired, _DroppableDimensionPu);
/* harmony default export */ __webpack_exports__["a"] = (DroppableDimensionPublisher);

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droppable_dimension_publisher__ = __webpack_require__(2238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__droppable_dimension_publisher__["a"]; });



/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_selectors__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__droppable__ = __webpack_require__(2241);








var makeSelector = function makeSelector() {
  var idSelector = function idSelector(state, ownProps) {
    return ownProps.droppableId;
  };
  var isDropDisabledSelector = function isDropDisabledSelector(state, ownProps) {
    return ownProps.isDropDisabled || false;
  };

  var getIsDraggingOver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_memoize_one__["a" /* default */])(function (id, destination) {
    if (!destination) {
      return false;
    }
    return destination.droppableId === id;
  });

  var getPlaceholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_memoize_one__["a" /* default */])(function (id, destination, draggable) {
    if (!draggable) {
      return null;
    }

    if (!destination) {
      return null;
    }

    if (id === draggable.descriptor.droppableId) {
      return null;
    }

    if (id !== destination.droppableId) {
      return null;
    }

    return draggable.placeholder;
  });

  var getMapProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_memoize_one__["a" /* default */])(function (isDraggingOver, draggingOverWith, placeholder) {
    return {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith,
      placeholder: placeholder
    };
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__state_selectors__["a" /* phaseSelector */], __WEBPACK_IMPORTED_MODULE_4__state_selectors__["b" /* dragSelector */], __WEBPACK_IMPORTED_MODULE_4__state_selectors__["c" /* draggingDraggableSelector */], __WEBPACK_IMPORTED_MODULE_4__state_selectors__["d" /* pendingDropSelector */], idSelector, isDropDisabledSelector], function (phase, drag, draggable, pending, id, isDropDisabled) {
    if (isDropDisabled) {
      return getMapProps(false, null, null);
    }

    if (phase === 'DRAGGING') {
      if (!drag) {
        console.error('cannot determine dragging over as there is not drag');
        return getMapProps(false, null, null);
      }

      var isDraggingOver = getIsDraggingOver(id, drag.impact.destination);
      var draggingOverWith = isDraggingOver ? drag.initial.descriptor.id : null;

      var placeholder = getPlaceholder(id, drag.impact.destination, draggable);

      return getMapProps(isDraggingOver, draggingOverWith, placeholder);
    }

    if (phase === 'DROP_ANIMATING') {
      if (!pending) {
        console.error('cannot determine dragging over as there is no pending result');
        return getMapProps(false, null, null);
      }

      var _isDraggingOver = getIsDraggingOver(id, pending.impact.destination);
      var _draggingOverWith = _isDraggingOver ? pending.result.draggableId : null;

      var _placeholder = getPlaceholder(id, pending.result.destination, draggable);
      return getMapProps(_isDraggingOver, _draggingOverWith, _placeholder);
    }

    return getMapProps(false, null, null);
  });
};

var makeMapStateToProps = function makeMapStateToProps() {
  var selector = makeSelector();
  return function (state, props) {
    return selector(state, props);
  };
};

var connectedDroppable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["a" /* connect */])(makeMapStateToProps, null, null, { storeKey: __WEBPACK_IMPORTED_MODULE_3__context_keys__["a" /* storeKey */] })(__WEBPACK_IMPORTED_MODULE_5__droppable__["a" /* default */]);

connectedDroppable.defaultProps = {
  type: 'DEFAULT',
  isDropDisabled: false,
  direction: 'vertical',
  ignoreContainerClipping: false
};

/* harmony default export */ __webpack_exports__["a"] = (connectedDroppable);

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__droppable_dimension_publisher___ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__placeholder___ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_keys__ = __webpack_require__(198);




var _Droppable$contextTyp, _Droppable$childConte;








var Droppable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Droppable, _Component);

  function Droppable(props, context) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Droppable);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props, context));

    _this.state = {
      ref: null
    };

    _this.setRef = function (ref) {
      if (ref === null) {
        return;
      }

      if (ref === _this.state.ref) {
        return;
      }

      _this.setState({
        ref: ref
      });
    };

    _this.styleContext = context[__WEBPACK_IMPORTED_MODULE_7__context_keys__["b" /* styleContextKey */]];
    return _this;
  }

  Droppable.prototype.getChildContext = function getChildContext() {
    var _value;

    var value = (_value = {}, _value[__WEBPACK_IMPORTED_MODULE_7__context_keys__["c" /* droppableIdKey */]] = this.props.droppableId, _value);
    return value;
  };

  Droppable.prototype.getPlaceholder = function getPlaceholder() {
    if (!this.props.placeholder) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__placeholder___["a" /* default */], { placeholder: this.props.placeholder });
  };

  Droppable.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        direction = _props.direction,
        droppableId = _props.droppableId,
        ignoreContainerClipping = _props.ignoreContainerClipping,
        isDraggingOver = _props.isDraggingOver,
        isDropDisabled = _props.isDropDisabled,
        draggingOverWith = _props.draggingOverWith,
        type = _props.type;

    var provided = {
      innerRef: this.setRef,
      placeholder: this.getPlaceholder(),
      droppableProps: {
        'data-react-beautiful-dnd-droppable': this.styleContext
      }
    };
    var snapshot = {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith
    };

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__droppable_dimension_publisher___["a" /* default */], {
      droppableId: droppableId,
      type: type,
      direction: direction,
      ignoreContainerClipping: ignoreContainerClipping,
      isDropDisabled: isDropDisabled,
      targetRef: this.state.ref
    }, children(provided, snapshot));
  };

  return Droppable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Droppable.contextTypes = (_Droppable$contextTyp = {}, _Droppable$contextTyp[__WEBPACK_IMPORTED_MODULE_7__context_keys__["b" /* styleContextKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _Droppable$contextTyp);
Droppable.childContextTypes = (_Droppable$childConte = {}, _Droppable$childConte[__WEBPACK_IMPORTED_MODULE_7__context_keys__["c" /* droppableIdKey */]] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired, _Droppable$childConte);
/* harmony default export */ __webpack_exports__["a"] = (Droppable);

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connected_droppable__ = __webpack_require__(2240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__connected_droppable__["a"]; });



/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var isScrollable = function isScrollable() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.some(function (value) {
    return value === 'auto' || value === 'scroll';
  });
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  return isScrollable(style.overflow, style.overflowY, style.overflowX);
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

/* harmony default export */ __webpack_exports__["a"] = (getClosestScrollable);

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moveable__ = __webpack_require__(2245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__moveable__["a"]; });



/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation__ = __webpack_require__(1189);








var origin = {
  x: 0,
  y: 0
};

var noMovement = {
  transform: null
};

var isAtOrigin = function isAtOrigin(point) {
  return point.x === origin.x && point.y === origin.y;
};

var getStyle = function getStyle(isNotMoving, x, y) {
  if (isNotMoving) {
    return noMovement;
  }

  var point = { x: x, y: y };

  if (isAtOrigin(point)) {
    return noMovement;
  }
  var style = {
    transform: 'translate(' + point.x + 'px, ' + point.y + 'px)'
  };
  return style;
};

var Movable = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Movable, _Component);

  function Movable() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Movable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onRest = function () {
      var onMoveEnd = _this.props.onMoveEnd;

      if (!onMoveEnd) {
        return;
      }

      setTimeout(function () {
        return onMoveEnd();
      });
    }, _this.getFinal = function () {
      var destination = _this.props.destination;
      var speed = _this.props.speed;

      if (speed === 'INSTANT') {
        return destination;
      }

      var selected = speed === 'FAST' ? __WEBPACK_IMPORTED_MODULE_5__animation__["a" /* physics */].fast : __WEBPACK_IMPORTED_MODULE_5__animation__["a" /* physics */].standard;

      return {
        x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_motion__["spring"])(destination.x, selected),
        y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_motion__["spring"])(destination.y, selected)
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Movable.prototype.render = function render() {
    var _this2 = this;

    var final = this.getFinal();

    var isNotMoving = isAtOrigin(final);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_motion__["Motion"], { defaultStyle: origin, style: final, onRest: this.onRest }, function (current) {
      return _this2.props.children(getStyle(isNotMoving, current.x, current.y));
    });
  };

  return Movable;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Movable.defaultProps = {
  destination: origin
};
/* harmony default export */ __webpack_exports__["a"] = (Movable);

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);






var Placeholder = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Placeholder, _PureComponent);

  function Placeholder() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Placeholder);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _PureComponent.apply(this, arguments));
  }

  Placeholder.prototype.render = function render() {
    var placeholder = this.props.placeholder;
    var _placeholder$margin = placeholder.margin,
        top = _placeholder$margin.top,
        left = _placeholder$margin.left,
        bottom = _placeholder$margin.bottom,
        right = _placeholder$margin.right;
    var _placeholder$paddingB = placeholder.paddingBox,
        width = _placeholder$paddingB.width,
        height = _placeholder$paddingB.height;

    var style = {
      width: width,
      height: height,
      marginTop: top,
      marginLeft: left,
      marginBottom: bottom,
      marginRight: right,
      pointerEvents: 'none',
      boxSizing: 'border-box'
    };
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { style: style });
  };

  return Placeholder;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation__ = __webpack_require__(1189);



var prefix = 'data-react-beautiful-dnd';

/* harmony default export */ __webpack_exports__["a"] = (function (styleContext) {
  var dragHandleSelector = '[' + prefix + '-drag-handle="' + styleContext + '"]';
  var draggableSelector = '[' + prefix + '-draggable="' + styleContext + '"]';
  var droppableSelector = '[' + prefix + '-droppable="' + styleContext + '"]';

  var dragHandleStyles = {
    base: '\n      ' + dragHandleSelector + ' {\n        -webkit-touch-callout: none;\n        -webkit-tap-highlight-color: rgba(0,0,0,0);\n        touch-action: manipulation;\n      }\n    ',
    grabCursor: '\n      ' + dragHandleSelector + ' {\n        cursor: -webkit-grab;\n        cursor: grab;\n      }\n    ',
    blockPointerEvents: '\n      ' + dragHandleSelector + ' {\n        pointer-events: none;\n      }\n    '
  };

  var draggableStyles = {
    animateMovement: '\n      ' + draggableSelector + ' {\n        transition: ' + __WEBPACK_IMPORTED_MODULE_0__animation__["b" /* css */].outOfTheWay + ';\n      }\n    '
  };

  var droppableStyles = {
    base: '\n      ' + droppableSelector + ' {\n        overflow-anchor: none;\n      }\n    '
  };

  var bodyStyles = {
    whileActiveDragging: '\n      body {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n      }\n    '
  };

  var base = [dragHandleStyles.base, droppableStyles.base];

  var resting = [].concat(base, [dragHandleStyles.grabCursor]).join('');

  var dragging = [].concat(base, [dragHandleStyles.blockPointerEvents, draggableStyles.animateMovement, bodyStyles.whileActiveDragging]).join('');

  var dropAnimating = [].concat(base, [dragHandleStyles.grabCursor, draggableStyles.animateMovement]).join('');

  var userCancel = [].concat(base, [draggableStyles.animateMovement]).join('');

  return { resting: resting, dragging: dragging, dropAnimating: dropAnimating, userCancel: userCancel };
});

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetStyleContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_memoize_one__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_styles__ = __webpack_require__(2247);




var count = 0;

var prefix = 'data-react-beautiful-dnd';

var resetStyleContext = function resetStyleContext() {
  count = 0;
};

/* harmony default export */ __webpack_exports__["b"] = (function () {
  var context = '' + count++;
  var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_styles__["a" /* default */])(context);

  var state = {
    el: null
  };

  var setState = function setState(newState) {
    state = newState;
  };

  var setStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (proposed) {
    if (!state.el) {
      console.error('cannot set style of style tag if not mounted');
      return;
    }

    state.el.innerHTML = proposed;
  });

  var mount = function mount() {
    if (state.el) {
      console.error('Style marshal already mounted');
      return;
    }

    var el = document.createElement('style');
    el.type = 'text/css';

    el.setAttribute(prefix, context);
    var head = document.querySelector('head');

    if (!head) {
      throw new Error('Cannot find the head to append a style to');
    }

    head.appendChild(el);
    setState({
      el: el
    });

    setStyle(styles.resting);
  };

  var onPhaseChange = function onPhaseChange(current) {
    if (!state.el) {
      console.error('cannot update styles until style marshal is mounted');
      return;
    }

    var phase = current.phase;

    if (phase === 'DRAGGING') {
      setStyle(styles.dragging);
      return;
    }

    if (phase === 'DROP_ANIMATING') {
      if (!current.drop || !current.drop.pending) {
        console.error('Invalid state found in style-marshal');
        return;
      }

      var reason = current.drop.pending.result.reason;

      if (reason === 'DROP') {
        setStyle(styles.dropAnimating);
        return;
      }
      setStyle(styles.userCancel);
      return;
    }

    setStyle(styles.resting);
  };

  var unmount = function unmount() {
    if (!state.el) {
      console.error('Cannot unmount style marshal as it is already unmounted');
      return;
    }
    var previous = state.el;

    setState({
      el: null
    });

    if (!previous.parentNode) {
      console.error('Cannot unmount style marshal as cannot find parent');
      return;
    }

    previous.parentNode.removeChild(previous);
  };

  var marshal = {
    onPhaseChange: onPhaseChange,
    styleContext: context,
    mount: mount,
    unmount: unmount
  };

  return marshal;
});

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_get_area__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_window_scroll__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_get_max_scroll__ = __webpack_require__(1183);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var scroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_window_scroll__["a" /* default */])();

  var top = scroll.y;
  var left = scroll.x;

  var doc = document.documentElement;

  var width = doc.clientWidth;
  var height = doc.clientHeight;

  var right = left + width;
  var bottom = top + height;

  var subject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state_get_area__["a" /* default */])({
    top: top, left: left, right: right, bottom: bottom
  });

  var maxScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__state_get_max_scroll__["a" /* default */])({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: subject.width,
    height: subject.height
  });

  var viewport = {
    subject: subject,
    maxScroll: maxScroll,
    scroll: scroll
  };

  return viewport;
});

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (change) {
  window.scrollBy(change.x, change.y);
});

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.hoistNonReactStatics = factory();
})(this, function () {
    'use strict';

    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };

    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };

    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components

            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }

            var keys = getOwnPropertyNames(sourceComponent);

            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }

            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try {
                        // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }

            return targetComponent;
        }

        return targetComponent;
    };
});

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(2251);
var invariant = __webpack_require__(2252);
var ReactPropTypesSecret = __webpack_require__(2255);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(684);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* unused harmony default export */ var _unused_webpack_default_export = (createProvider());

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(2261);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(1197);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && (typeof mapDispatchToProps === 'undefined' ? 'undefined' : _typeof(mapDispatchToProps)) === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(1197);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1200);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(2262);
function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(684);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStore */
/* unused harmony export combineReducers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* unused harmony export applyMiddleware */
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(2266);
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(2267);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42), __webpack_require__(1442)(module)))

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(1201);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(1203);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(1203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* unused harmony reexport combineReducers */
/* unused harmony reexport bindActionCreators */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2273);

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(2274);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var root; /* global window */

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(68)(module)))

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _class = __webpack_require__(1842);

var _class2 = _interopRequireDefault(_class);

var _width = __webpack_require__(946);

var _width2 = _interopRequireDefault(_width);

var _scrollbarSize = __webpack_require__(950);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _messages = __webpack_require__(687);

var _messages2 = _interopRequireDefault(_messages);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _constants = __webpack_require__(153);

var _accessors = __webpack_require__(239);

var _propTypes3 = __webpack_require__(113);

var _eventLevels = __webpack_require__(343);

var _selection = __webpack_require__(344);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Agenda = function (_React$Component) {
  _inherits(Agenda, _React$Component);

  function Agenda() {
    var _temp, _this, _ret;

    _classCallCheck(this, Agenda);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderDay = function (day, events, dayKey) {
      var _this$props = _this.props,
          culture = _this$props.culture,
          components = _this$props.components,
          titleAccessor = _this$props.titleAccessor,
          agendaDateFormat = _this$props.agendaDateFormat,
          eventPropGetter = _this$props.eventPropGetter,
          startAccessor = _this$props.startAccessor,
          endAccessor = _this$props.endAccessor,
          selected = _this$props.selected;

      var EventComponent = components.event;
      var DateComponent = components.date;

      events = events.filter(function (e) {
        return (0, _eventLevels.inRange)(e, _dates2.default.startOf(day, 'day'), _dates2.default.endOf(day, 'day'), _this.props);
      });

      return events.map(function (event, idx) {
        var _ref = eventPropGetter ? eventPropGetter(event, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), (0, _selection.isSelected)(event, selected)) : {},
            className = _ref.className,
            style = _ref.style;

        var dateLabel = idx === 0 && _localizer2.default.format(day, agendaDateFormat, culture);
        var first = idx === 0 ? _react2.default.createElement('td', { rowSpan: events.length, className: 'rbc-agenda-date-cell' }, DateComponent ? _react2.default.createElement(DateComponent, { day: day, label: dateLabel }) : dateLabel) : false;

        var title = (0, _accessors.accessor)(event, titleAccessor);

        return _react2.default.createElement('tr', { key: dayKey + '_' + idx, className: className, style: style }, first, _react2.default.createElement('td', { className: 'rbc-agenda-time-cell' }, _this.timeRangeLabel(day, event)), _react2.default.createElement('td', { className: 'rbc-agenda-event-cell' }, EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title));
      }, []);
    }, _this.timeRangeLabel = function (day, event) {
      var _this$props2 = _this.props,
          endAccessor = _this$props2.endAccessor,
          startAccessor = _this$props2.startAccessor,
          allDayAccessor = _this$props2.allDayAccessor,
          culture = _this$props2.culture,
          messages = _this$props2.messages,
          components = _this$props2.components;

      var labelClass = '',
          TimeComponent = components.time,
          label = (0, _messages2.default)(messages).allDay;

      var start = (0, _accessors.accessor)(event, startAccessor);
      var end = (0, _accessors.accessor)(event, endAccessor);

      if (!(0, _accessors.accessor)(event, allDayAccessor)) {
        if (_dates2.default.eq(start, end, 'day')) {
          label = _localizer2.default.format({ start: start, end: end }, _this.props.agendaTimeRangeFormat, culture);
        } else if (_dates2.default.eq(day, start, 'day')) {
          label = _localizer2.default.format(start, _this.props.agendaTimeFormat, culture);
        } else if (_dates2.default.eq(day, end, 'day')) {
          label = _localizer2.default.format(end, _this.props.agendaTimeFormat, culture);
        }
      }

      if (_dates2.default.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
      if (_dates2.default.lt(day, end, 'day')) labelClass += ' rbc-continues-after';

      return _react2.default.createElement('span', { className: labelClass.trim() }, TimeComponent ? _react2.default.createElement(TimeComponent, { event: event, day: day, label: label }) : label);
    }, _this._adjustHeader = function () {
      var header = _this.refs.header;
      var firstRow = _this.refs.tbody.firstChild;

      if (!firstRow) return;

      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;
      var widths = _this._widths || [];

      _this._widths = [(0, _width2.default)(firstRow.children[0]), (0, _width2.default)(firstRow.children[1])];

      if (widths[0] !== _this._widths[0] || widths[1] !== _this._widths[1]) {
        _this.refs.dateCol.style.width = _this._widths[0] + 'px';
        _this.refs.timeCol.style.width = _this._widths[1] + 'px';
      }

      if (isOverflowing) {
        _class2.default.addClass(header, 'rbc-header-overflowing');
        header.style.marginRight = (0, _scrollbarSize2.default)() + 'px';
      } else {
        _class2.default.removeClass(header, 'rbc-header-overflowing');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Agenda.prototype.componentDidMount = function componentDidMount() {
    this._adjustHeader();
  };

  Agenda.prototype.componentDidUpdate = function componentDidUpdate() {
    this._adjustHeader();
  };

  Agenda.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        length = _props.length,
        date = _props.date,
        events = _props.events,
        startAccessor = _props.startAccessor;

    var messages = (0, _messages2.default)(this.props.messages);
    var end = _dates2.default.add(date, length, 'day');

    var range = _dates2.default.range(date, end, 'day');

    events = events.filter(function (event) {
      return (0, _eventLevels.inRange)(event, date, end, _this2.props);
    });

    events.sort(function (a, b) {
      return +(0, _accessors.accessor)(a, startAccessor) - +(0, _accessors.accessor)(b, startAccessor);
    });

    return _react2.default.createElement('div', { className: 'rbc-agenda-view' }, _react2.default.createElement('table', { ref: 'header', className: 'rbc-agenda-table' }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', { className: 'rbc-header', ref: 'dateCol' }, messages.date), _react2.default.createElement('th', { className: 'rbc-header', ref: 'timeCol' }, messages.time), _react2.default.createElement('th', { className: 'rbc-header' }, messages.event)))), _react2.default.createElement('div', { className: 'rbc-agenda-content', ref: 'content' }, _react2.default.createElement('table', { className: 'rbc-agenda-table' }, _react2.default.createElement('tbody', { ref: 'tbody' }, range.map(function (day, idx) {
      return _this2.renderDay(day, events, idx);
    })))));
  };

  return Agenda;
}(_react2.default.Component);

Agenda.propTypes = {
  events: _propTypes2.default.array,
  date: _propTypes2.default.instanceOf(Date),
  length: _propTypes2.default.number.isRequired,
  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,
  eventPropGetter: _propTypes2.default.func,
  selected: _propTypes2.default.object,

  agendaDateFormat: _propTypes3.dateFormat,
  agendaTimeFormat: _propTypes3.dateFormat,
  agendaTimeRangeFormat: _propTypes3.dateRangeFormat,
  culture: _propTypes2.default.string,

  components: _propTypes2.default.object.isRequired,
  messages: _propTypes2.default.shape({
    date: _propTypes2.default.string,
    time: _propTypes2.default.string
  })
};
Agenda.defaultProps = {
  length: 30
};

Agenda.range = function (start, _ref2) {
  var _ref2$length = _ref2.length,
      length = _ref2$length === undefined ? Agenda.defaultProps.length : _ref2$length;

  var end = _dates2.default.add(start, length, 'day');
  return { start: start, end: end };
};

Agenda.navigate = function (date, action, _ref3) {
  var _ref3$length = _ref3.length,
      length = _ref3$length === undefined ? Agenda.defaultProps.length : _ref3$length;

  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -length, 'day');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, length, 'day');

    default:
      return date;
  }
};

Agenda.title = function (start, _ref4) {
  var _ref4$length = _ref4.length,
      length = _ref4$length === undefined ? Agenda.defaultProps.length : _ref4$length,
      formats = _ref4.formats,
      culture = _ref4.culture;

  var end = _dates2.default.add(start, length, 'day');
  return _localizer2.default.format({ start: start, end: end }, formats.agendaHeaderFormat, culture);
};

exports.default = Agenda;
module.exports = exports['default'];

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _helpers = __webpack_require__(287);

var _propTypes3 = __webpack_require__(113);

var _selection = __webpack_require__(344);

var _Selection = __webpack_require__(1209);

var _Selection2 = _interopRequireDefault(_Selection);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BackgroundCells = function (_React$Component) {
  _inherits(BackgroundCells, _React$Component);

  function BackgroundCells(props, context) {
    _classCallCheck(this, BackgroundCells);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      selecting: false
    };
    return _this;
  }

  BackgroundCells.prototype.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  BackgroundCells.prototype.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  BackgroundCells.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();

    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
  };

  BackgroundCells.prototype.render = function render() {
    var _props = this.props,
        range = _props.range,
        Wrapper = _props.cellWrapperComponent,
        dayPropGetter = _props.dayPropGetter,
        currentDate = _props.date,
        getNow = _props.getNow;
    var _state = this.state,
        selecting = _state.selecting,
        startIdx = _state.startIdx,
        endIdx = _state.endIdx;

    var current = getNow();

    return _react2.default.createElement('div', { className: 'rbc-row-bg' }, range.map(function (date, index) {
      var selected = selecting && index >= startIdx && index <= endIdx;

      var _ref = dayPropGetter && dayPropGetter(date) || {},
          className = _ref.className,
          style = _ref.style;

      return _react2.default.createElement(Wrapper, { key: index, value: date, range: range }, _react2.default.createElement('div', {
        style: style,
        className: (0, _classnames2.default)('rbc-day-bg', className, selected && 'rbc-selected-cell', _dates2.default.eq(date, current, 'day') && 'rbc-today', currentDate && _dates2.default.month(currentDate) !== _dates2.default.month(date) && 'rbc-off-range-bg')
      }));
    }));
  };

  BackgroundCells.prototype._selectable = function _selectable() {
    var _this2 = this;

    var node = (0, _reactDom.findDOMNode)(this);
    var selector = this._selector = new _Selection2.default(this.props.container, {
      longPressThreshold: this.props.longPressThreshold
    });

    var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), point)) {
        var rowBox = (0, _Selection.getBoundsForNode)(node);
        var _props2 = _this2.props,
            range = _props2.range,
            rtl = _props2.rtl;

        if ((0, _selection.pointInBox)(rowBox, point)) {
          var width = (0, _selection.slotWidth)((0, _Selection.getBoundsForNode)(node), range.length);
          var currentCell = (0, _selection.getCellAtX)(rowBox, point.x, width, rtl, range.length);

          _this2._selectSlot({
            startIdx: currentCell,
            endIdx: currentCell,
            action: actionType,
            box: point
          });
        }
      }

      _this2._initial = {};
      _this2.setState({ selecting: false });
    };

    selector.on('selecting', function (box) {
      var _props3 = _this2.props,
          range = _props3.range,
          rtl = _props3.rtl;

      var startIdx = -1;
      var endIdx = -1;

      if (!_this2.state.selecting) {
        (0, _helpers.notify)(_this2.props.onSelectStart, [box]);
        _this2._initial = { x: box.x, y: box.y };
      }
      if (selector.isSelected(node)) {
        var nodeBox = (0, _Selection.getBoundsForNode)(node);
        var _dateCellSelection = (0, _selection.dateCellSelection)(_this2._initial, nodeBox, box, range.length, rtl);

        startIdx = _dateCellSelection.startIdx;
        endIdx = _dateCellSelection.endIdx;
      }

      _this2.setState({
        selecting: true,
        startIdx: startIdx,
        endIdx: endIdx
      });
    });

    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;

      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
    });

    selector.on('click', function (point) {
      return selectorClicksHandler(point, 'click');
    });

    selector.on('doubleClick', function (point) {
      return selectorClicksHandler(point, 'doubleClick');
    });

    selector.on('select', function (bounds) {
      _this2._selectSlot(_extends({}, _this2.state, { action: 'select', bounds: bounds }));
      _this2._initial = {};
      _this2.setState({ selecting: false });
      (0, _helpers.notify)(_this2.props.onSelectEnd, [_this2.state]);
    });
  };

  BackgroundCells.prototype._teardownSelectable = function _teardownSelectable() {
    if (!this._selector) return;
    this._selector.teardown();
    this._selector = null;
  };

  BackgroundCells.prototype._selectSlot = function _selectSlot(_ref2) {
    var endIdx = _ref2.endIdx,
        startIdx = _ref2.startIdx,
        action = _ref2.action,
        bounds = _ref2.bounds,
        box = _ref2.box;

    if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
      start: startIdx,
      end: endIdx,
      action: action,
      bounds: bounds,
      box: box
    });
  };

  return BackgroundCells;
}(_react2.default.Component);

BackgroundCells.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  getNow: _propTypes2.default.func.isRequired,
  cellWrapperComponent: _propTypes3.elementType,
  container: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onSelectSlot: _propTypes2.default.func.isRequired,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,

  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  rtl: _propTypes2.default.bool,
  type: _propTypes2.default.string
};
exports.default = BackgroundCells;
module.exports = exports['default'];

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uncontrollable = __webpack_require__(2790);

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes3 = __webpack_require__(113);

var _warning = __webpack_require__(1215);

var _warning2 = _interopRequireDefault(_warning);

var _helpers = __webpack_require__(287);

var _constants = __webpack_require__(153);

var _formats = __webpack_require__(461);

var _formats2 = _interopRequireDefault(_formats);

var _messages = __webpack_require__(687);

var _messages2 = _interopRequireDefault(_messages);

var _move = __webpack_require__(1214);

var _move2 = _interopRequireDefault(_move);

var _Views = __webpack_require__(1211);

var _Views2 = _interopRequireDefault(_Views);

var _Toolbar = __webpack_require__(2287);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _EventWrapper = __webpack_require__(1207);

var _EventWrapper2 = _interopRequireDefault(_EventWrapper);

var _BackgroundWrapper = __webpack_require__(685);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

var _omit = __webpack_require__(2167);

var _omit2 = _interopRequireDefault(_omit);

var _defaults = __webpack_require__(2161);

var _defaults2 = _interopRequireDefault(_defaults);

var _transform = __webpack_require__(2178);

var _transform2 = _interopRequireDefault(_transform);

var _mapValues = __webpack_require__(2165);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function viewNames(_views) {
  return !Array.isArray(_views) ? Object.keys(_views) : _views;
}

function isValidView(view, _ref) {
  var _views = _ref.views;

  var names = viewNames(_views);
  return names.indexOf(view) !== -1;
}

/**
 * react-big-calendar is a full featured Calendar component for managing events and dates. It uses
 * modern `flexbox` for layout, making it super responsive and performant. Leaving most of the layout heavy lifting
 * to the browser. __note:__ The default styles use `height: 100%` which means your container must set an explicit
 * height (feel free to adjust the styles to suit your specific needs).
 *
 * Big Calendar is unopiniated about editing and moving events, preferring to let you implement it in a way that makes
 * the most sense to your app. It also tries not to be prescriptive about your event data structures, just tell it
 * how to find the start and end datetimes and you can pass it whatever you want.
 *
 * One thing to note is that, `react-big-calendar` treats event start/end dates as an _exclusive_ range.
 * which means that the event spans up to, but not including, the end date. In the case
 * of displaying events on whole days, end dates are rounded _up_ to the next day. So an
 * event ending on `Apr 8th 12:00:00 am` will not appear on the 8th, whereas one ending
 * on `Apr 8th 12:01:00 am` will. If you want _inclusive_ ranges consider providing a
 * function `endAccessor` that returns the end date + 1 day for those events that end at midnight.
 */
/**
 *
 *
 * @static
 * @memberof Calendar
 */

var Calendar = function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Calendar.prototype.render = function render() {
    var _props = this.props,
        view = _props.view,
        toolbar = _props.toolbar,
        events = _props.events,
        culture = _props.culture,
        _props$components = _props.components,
        components = _props$components === undefined ? {} : _props$components,
        _props$formats = _props.formats,
        formats = _props$formats === undefined ? {} : _props$formats,
        _props$messages = _props.messages,
        messages = _props$messages === undefined ? {} : _props$messages,
        style = _props.style,
        className = _props.className,
        elementProps = _props.elementProps,
        current = _props.date,
        getNow = _props.getNow,
        length = _props.length,
        props = _objectWithoutProperties(_props, ['view', 'toolbar', 'events', 'culture', 'components', 'formats', 'messages', 'style', 'className', 'elementProps', 'date', 'getNow', 'length']);

    current = current || getNow();

    formats = (0, _formats2.default)(formats);
    messages = (0, _messages2.default)(messages);

    var View = this.getView();
    var names = viewNames(this.props.views);

    var viewComponents = (0, _defaults2.default)(components[view] || {}, (0, _omit2.default)(components, names), {
      eventWrapper: _EventWrapper2.default,
      dayWrapper: _BackgroundWrapper2.default,
      dateCellWrapper: _BackgroundWrapper2.default
    });

    var CalToolbar = components.toolbar || _Toolbar2.default;
    var label = View.title(current, { formats: formats, culture: culture, length: length });

    return _react2.default.createElement('div', _extends({}, elementProps, {
      className: (0, _classnames2.default)(className, 'rbc-calendar', props.rtl && 'rbc-is-rtl'),
      style: style
    }), toolbar && _react2.default.createElement(CalToolbar, {
      date: current,
      view: view,
      views: names,
      label: label,
      onViewChange: this.handleViewChange,
      onNavigate: this.handleNavigate,
      messages: messages
    }), _react2.default.createElement(View, _extends({
      ref: 'view'
    }, props, formats, {
      messages: messages,
      culture: culture,
      formats: undefined,
      events: events,
      date: current,
      getNow: getNow,
      length: length,
      components: viewComponents,
      getDrilldownView: this.getDrilldownView,
      onNavigate: this.handleNavigate,
      onDrillDown: this.handleDrillDown,
      onSelectEvent: this.handleSelectEvent,
      onDoubleClickEvent: this.handleDoubleClickEvent,
      onSelectSlot: this.handleSelectSlot,
      onShowMore: this._showMore
    })));
  };

  return Calendar;
}(_react2.default.Component);

Calendar.propTypes = {
  /**
   * Props passed to main calendar `<div>`.
   *
   */
  elementProps: _propTypes2.default.object,

  /**
   * The current date value of the calendar. Determines the visible view range.
   * If `date` is omitted then the result of `getNow` is used; otherwise the
   * current date is used.
   *
   * @controllable onNavigate
   */
  date: _propTypes2.default.instanceOf(Date),

  /**
   * The current view of the calendar.
   *
   * @default 'month'
   * @controllable onView
   */
  view: _propTypes2.default.string,

  /**
   * The initial view set for the Calendar.
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @default 'month'
   */
  defaultView: _propTypes2.default.string,

  /**
   * An array of event objects to display on the calendar. Events objects
   * can be any shape, as long as the Calendar knows how to retrieve the
   * following details of the event:
   *
   *  - start time
   *  - end time
   *  - title
   *  - whether its an "all day" event or not
   *  - any resource the event may be a related too
   *
   * Each of these properties can be customized or generated dynamically by
   * setting the various "accessor" props. Without any configuration the default
   * event should look like:
   *
   * ```js
   * Event {
   *   title: string,
   *   start: Date,
   *   end: Date,
   *   allDay?: boolean
   *   resource?: any,
   * }
   * ```
   */
  events: _propTypes2.default.arrayOf(_propTypes2.default.object),

  /**
   * Accessor for the event title, used to display event information. Should
   * resolve to a `renderable` value.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  titleAccessor: _propTypes3.accessor,

  /**
   * Accessor for the event tooltip. Should
   * resolve to a `renderable` value. Removes the tooltip if null.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  tooltipAccessor: _propTypes3.accessor,

  /**
   * Determines whether the event should be considered an "all day" event and ignore time.
   * Must resolve to a `boolean` value.
   *
   * ```js
   * string | (event: Object) => boolean
   * ```
   *
   * @type {(func|string)}
   */
  allDayAccessor: _propTypes3.accessor,

  /**
   * The start date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  startAccessor: _propTypes3.accessor,

  /**
   * The end date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  endAccessor: _propTypes3.accessor,

  /**
   * Returns the id of the `resource` that the event is a member of. This
   * id should match at least one resource in the `resources` array.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  resourceAccessor: _propTypes3.accessor,

  /**
   * An array of resource objects that map events to a specific resource.
   * Resource objects, like events, can be any shape or have any properties,
   * but should be uniquly identifiable via the `resourceIdAccessor`, as
   * well as a "title" or name as provided by the `resourceTitleAccessor` prop.
   */
  resources: _propTypes2.default.arrayOf(_propTypes2.default.object),

  /**
   * Provides a unique identifier for each resource in the `resources` array
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceIdAccessor: _propTypes3.accessor,

  /**
   * Provides a human readable name for the resource object, used in headers.
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceTitleAccessor: _propTypes3.accessor,

  /**
   * Determines the current date/time which is highlighted in the views.
   *
   * The value affects which day is shaded and which time is shown as
   * the current time. It also affects the date used by the Today button in
   * the toolbar.
   *
   * Providing a value here can be useful when you are implementing time zones
   * using the `startAccessor` and `endAccessor` properties.
   *
   * @type {func}
   * @default () => new Date()
   */
  getNow: _propTypes2.default.func,

  /**
   * Callback fired when the `date` value changes.
   *
   * @controllable date
   */
  onNavigate: _propTypes2.default.func,

  /**
   * Callback fired when the `view` value changes.
   *
   * @controllable view
   */
  onView: _propTypes2.default.func,

  /**
   * Callback fired when date header, or the truncated events links are clicked
   *
   */
  onDrillDown: _propTypes2.default.func,

  /**
   * Callback fired when the visible date range changes. Returns an Array of dates
   * or an object with start and end dates for BUILTIN views.
   *
   * Cutom views may return something different.
   */
  onRangeChange: _propTypes2.default.func,

  /**
   * A callback fired when a date selection is made. Only fires when `selectable` is `true`.
   *
   * ```js
   * (
   *   slotInfo: {
   *     start: Date,
   *     end: Date,
   *     slots: Array<Date>,
   *     action: "select" | "click" | "doubleClick",
   *     bounds: ?{ // For "select" action
   *       x: number,
   *       y: number,
   *       top: number,
   *       right: number,
   *       left: number,
   *       bottom: number,
   *     },
   *     box: ?{ // For "click" or "doubleClick" actions
   *       clientX: number,
   *       clientY: number,
   *       x: number,
   *       y: number,
   *     },
   *   }
   * ) => any
   * ```
   */
  onSelectSlot: _propTypes2.default.func,

  /**
   * Callback fired when a calendar event is selected.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => any
   * ```
   *
   * @controllable selected
   */
  onSelectEvent: _propTypes2.default.func,

  /**
   * Callback fired when a calendar event is clicked twice.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => void
   * ```
   */
  onDoubleClickEvent: _propTypes2.default.func,

  /**
   * Callback fired when dragging a selection in the Time views.
   *
   * Returning `false` from the handler will prevent a selection.
   *
   * ```js
   * (range: { start: Date, end: Date }) => ?boolean
   * ```
   */
  onSelecting: _propTypes2.default.func,

  /**
   * The selected event, if any.
   */
  selected: _propTypes2.default.object,

  /**
   * An array of built-in view names to allow the calendar to display.
   * accepts either an array of builtin view names,
   *
   * ```jsx
   * views={['month', 'day', 'agenda']}
   * ```
   * or an object hash of the view name and the component (or boolean for builtin).
   *
   * ```jsx
   * views={{
   *   month: true,
   *   week: false,
   *   myweek: WorkWeekViewComponent,
   * }}
   * ```
   *
   * Custom views can be any React component, that implements the following
   * interface:
   *
   * ```js
   * interface View {
   *   static title(date: Date, { formats: DateFormat[], culture: string?, ...props }): string
   *   static navigate(date: Date, action: 'PREV' | 'NEXT' | 'DATE'): Date
   * }
   * ```
   *
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @View
   ['month', 'week', 'day', 'agenda']
   */
  views: _propTypes3.views,

  /**
   * The string name of the destination view for drill-down actions, such
   * as clicking a date header, or the truncated events links. If
   * `getDrilldownView` is also specified it will be used instead.
   *
   * Set to `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   drilldownView="agenda"
   * />
   * ```
   */
  drilldownView: _propTypes2.default.string,

  /**
   * Functionally equivalent to `drilldownView`, but accepts a function
   * that can return a view name. It's useful for customizing the drill-down
   * actions depending on the target date and triggering view.
   *
   * Return `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   getDrilldownView={(targetDate, currentViewName, configuredViewNames) =>
   *     if (currentViewName === 'month' && configuredViewNames.includes('week'))
   *       return 'week'
   *
   *     return null;
   *   }}
   * />
   * ```
   */
  getDrilldownView: _propTypes2.default.func,

  /**
   * Determines the end date from date prop in the agenda view
   * date prop + length (in number of days) = end date
   */
  length: _propTypes2.default.number,

  /**
   * Determines whether the toolbar is displayed
   */
  toolbar: _propTypes2.default.bool,

  /**
   * Show truncated events in an overlay when you click the "+_x_ more" link.
   */
  popup: _propTypes2.default.bool,

  /**
   * Distance in pixels, from the edges of the viewport, the "show more" overlay should be positioned.
   *
   * ```jsx
   * <BigCalendar popupOffset={30}/>
   * <BigCalendar popupOffset={{x: 30, y: 20}}/>
   * ```
   */
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number })]),

  /**
   * Allows mouse selection of ranges of dates/times.
   *
   * The 'ignoreEvents' option prevents selection code from running when a
   * drag begins over an event. Useful when you want custom event click or drag
   * logic
   */
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),

  /** Determines whether you want events to be resizable */
  resizable: _propTypes2.default.bool,

  /**
   * Specifies the number of miliseconds the user must press and hold on the screen for a touch
   * to be considered a "long press." Long presses are used for time slot selection on touch
   * devices.
   *
   * @type {number}
   * @default 250
   */
  longPressThreshold: _propTypes2.default.number,

  /**
   * Determines the selectable time increments in week and day views
   */
  step: _propTypes2.default.number,

  /**
   * The number of slots per "section" in the time grid views. Adjust with `step`
   * to change the default of 1 hour long groups, with 30 minute slots.
   */
  timeslots: _propTypes2.default.number,

  /**
   *Switch the calendar to a `right-to-left` read direction.
   */
  rtl: _propTypes2.default.bool,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the event node.
   *
   * ```js
   * (
   * 	event: Object,
   * 	start: Date,
   * 	end: Date,
   * 	isSelected: boolean
   * ) => { className?: string, style?: Object }
   * ```
   */
  eventPropGetter: _propTypes2.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the time-slot node. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  slotPropGetter: _propTypes2.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the day background. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  dayPropGetter: _propTypes2.default.func,

  /**
   * Support to show multi-day events with specific start and end times in the
   * main time grid (rather than in the all day header).
   *
   * **Note: This may cause calendars with several events to look very busy in
   * the week and day views.**
   */
  showMultiDayTimes: _propTypes2.default.bool,

  /**
   * Constrains the minimum _time_ of the Day and Week views.
   */
  min: _propTypes2.default.instanceOf(Date),

  /**
   * Constrains the maximum _time_ of the Day and Week views.
   */
  max: _propTypes2.default.instanceOf(Date),

  /**
   * Determines how far down the scroll pane is initially scrolled down.
   */
  scrollToTime: _propTypes2.default.instanceOf(Date),

  /**
   * Specify a specific culture code for the Calendar.
   *
   * **Note: it's generally better to handle this globally via your i18n library.**
   */
  culture: _propTypes2.default.string,

  /**
   * Localizer specific formats, tell the Calendar how to format and display dates.
   *
   * `format` types are dependent on the configured localizer; both Moment and Globalize
   * accept strings of tokens according to their own specification, such as: `'DD mm yyyy'`.
   *
   * ```jsx
   * let formats = {
   *   dateFormat: 'dd',
   *
   *   dayFormat: (date, culture, localizer) =>
   *     localizer.format(date, 'DDD', culture),
   *
   *   dayRangeHeaderFormat: ({ start, end }, culture, local) =>
   *     local.format(start, { date: 'short' }, culture) + ' — ' +
   *     local.format(end, { date: 'short' }, culture)
   * }
   *
   * <Calendar formats={formats} />
   * ```
   *
   * All localizers accept a function of
   * the form `(date: Date, culture: ?string, localizer: Localizer) -> string`
   */
  formats: _propTypes2.default.shape({
    /**
     * Format for the day of the month heading in the Month view.
     * e.g. "01", "02", "03", etc
     */
    dateFormat: _propTypes3.dateFormat,

    /**
     * A day of the week format for Week and Day headings,
     * e.g. "Wed 01/04"
     *
     */
    dayFormat: _propTypes3.dateFormat,

    /**
     * Week day name format for the Month week day headings,
     * e.g: "Sun", "Mon", "Tue", etc
     *
     */
    weekdayFormat: _propTypes3.dateFormat,

    /**
     * The timestamp cell formats in Week and Time views, e.g. "4:00 AM"
     */
    timeGutterFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Month view, e.g "2015 April"
     *
     */
    monthHeaderFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Week views, e.g. "Mar 29 - Apr 04"
     */
    dayRangeHeaderFormat: _propTypes3.dateRangeFormat,

    /**
     * Toolbar header format for the Day view, e.g. "Wednesday Apr 01"
     */
    dayHeaderFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Agenda view, e.g. "4/1/2015 — 5/1/2015"
     */
    agendaHeaderFormat: _propTypes3.dateRangeFormat,

    /**
     * A time range format for selecting time slots, e.g "8:00am — 2:00pm"
     */
    selectRangeFormat: _propTypes3.dateRangeFormat,

    agendaDateFormat: _propTypes3.dateFormat,
    agendaTimeFormat: _propTypes3.dateFormat,
    agendaTimeRangeFormat: _propTypes3.dateRangeFormat,

    /**
     * Time range displayed on events.
     */
    eventTimeRangeFormat: _propTypes3.dateRangeFormat,

    /**
     * An optional event time range for events that continue onto another day
     */
    eventTimeRangeStartFormat: _propTypes3.dateFormat,

    /**
     * An optional event time range for events that continue from another day
     */
    eventTimeRangeEndFormat: _propTypes3.dateFormat
  }),

  /**
   * Customize how different sections of the calendar render by providing custom Components.
   * In particular the `Event` component can be specified for the entire calendar, or you can
   * provide an individual component for each view type.
   *
   * ```jsx
   * let components = {
   *   event: MyEvent, // used by each view (Month, Day, Week)
   *   toolbar: MyToolbar,
   *   agenda: {
   *   	 event: MyAgendaEvent // with the agenda view use a different component to render events
   *   }
   * }
   * <Calendar components={components} />
   * ```
   */
  components: _propTypes2.default.shape({
    event: _propTypes3.elementType,
    eventWrapper: _propTypes3.elementType,
    dayWrapper: _propTypes3.elementType,
    dateCellWrapper: _propTypes3.elementType,

    toolbar: _propTypes3.elementType,

    agenda: _propTypes2.default.shape({
      date: _propTypes3.elementType,
      time: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),

    day: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),
    week: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),
    month: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      dateHeader: _propTypes3.elementType,
      event: _propTypes3.elementType
    })
  }),

  /**
   * String messages used throughout the component, override to provide localizations
   */
  messages: _propTypes2.default.shape({
    allDay: _propTypes2.default.node,
    previous: _propTypes2.default.node,
    next: _propTypes2.default.node,
    today: _propTypes2.default.node,
    month: _propTypes2.default.node,
    week: _propTypes2.default.node,
    day: _propTypes2.default.node,
    agenda: _propTypes2.default.node,
    date: _propTypes2.default.node,
    time: _propTypes2.default.node,
    event: _propTypes2.default.node,
    showMore: _propTypes2.default.func
  })
};
Calendar.defaultProps = {
  elementProps: {},
  popup: false,
  toolbar: true,
  view: _constants.views.MONTH,
  views: [_constants.views.MONTH, _constants.views.WEEK, _constants.views.DAY, _constants.views.AGENDA],
  step: 30,
  length: 30,

  drilldownView: _constants.views.DAY,

  titleAccessor: 'title',
  tooltipAccessor: 'title',
  allDayAccessor: 'allDay',
  startAccessor: 'start',
  endAccessor: 'end',
  resourceAccessor: 'resourceId',

  resourceIdAccessor: 'id',
  resourceTitleAccessor: 'title',

  longPressThreshold: 250,
  getNow: function getNow() {
    return new Date();
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getViews = function () {
    var views = _this2.props.views;

    if (Array.isArray(views)) {
      return (0, _transform2.default)(views, function (obj, name) {
        return obj[name] = _Views2.default[name];
      }, {});
    }

    if ((typeof views === 'undefined' ? 'undefined' : _typeof(views)) === 'object') {
      return (0, _mapValues2.default)(views, function (value, key) {
        if (value === true) {
          return _Views2.default[key];
        }

        return value;
      });
    }

    return _Views2.default;
  };

  this.getView = function () {
    var views = _this2.getViews();

    return views[_this2.props.view];
  };

  this.getDrilldownView = function (date) {
    var _props2 = _this2.props,
        view = _props2.view,
        drilldownView = _props2.drilldownView,
        getDrilldownView = _props2.getDrilldownView;

    if (!getDrilldownView) return drilldownView;

    return getDrilldownView(date, view, Object.keys(_this2.getViews()));
  };

  this.handleRangeChange = function (date, view) {
    var onRangeChange = _this2.props.onRangeChange;

    if (onRangeChange) {
      if (view.range) {
        onRangeChange(view.range(date, {}));
      } else {
         false ? (0, _warning2.default)(true, 'onRangeChange prop not supported for this view') : void 0;
      }
    }
  };

  this.handleNavigate = function (action, newDate) {
    var _props3 = _this2.props,
        view = _props3.view,
        date = _props3.date,
        getNow = _props3.getNow,
        onNavigate = _props3.onNavigate,
        props = _objectWithoutProperties(_props3, ['view', 'date', 'getNow', 'onNavigate']);

    var ViewComponent = _this2.getView();
    var today = getNow();

    date = (0, _move2.default)(ViewComponent, _extends({}, props, {
      action: action,
      date: newDate || date || today,
      today: today
    }));

    onNavigate(date, view, action);
    _this2.handleRangeChange(date, ViewComponent);
  };

  this.handleViewChange = function (view) {
    if (view !== _this2.props.view && isValidView(view, _this2.props)) {
      _this2.props.onView(view);
    }

    var views = _this2.getViews();
    _this2.handleRangeChange(_this2.props.date, views[view]);
  };

  this.handleSelectEvent = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
  };

  this.handleDoubleClickEvent = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
  };

  this.handleSelectSlot = function (slotInfo) {
    (0, _helpers.notify)(_this2.props.onSelectSlot, slotInfo);
  };

  this.handleDrillDown = function (date, view) {
    var onDrillDown = _this2.props.onDrillDown;

    if (onDrillDown) {
      onDrillDown(date, view, _this2.drilldownView);
      return;
    }
    if (view) _this2.handleViewChange(view);

    _this2.handleNavigate(_constants.navigate.DATE, date);
  };
};

exports.default = (0, _uncontrollable2.default)(Calendar, {
  view: 'onView',
  date: 'onNavigate',
  selected: 'onSelectEvent'
});
module.exports = exports['default'];

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var DateHeader = function DateHeader(_ref) {
  var label = _ref.label,
      drilldownView = _ref.drilldownView,
      onDrillDown = _ref.onDrillDown;

  if (!drilldownView) {
    return _react2.default.createElement('span', null, label);
  }

  return _react2.default.createElement('a', { href: '#', onClick: onDrillDown }, label);
};

DateHeader.propTypes = {
  label: _propTypes2.default.node,
  date: _propTypes2.default.instanceOf(Date),
  drilldownView: _propTypes2.default.string,
  onDrillDown: _propTypes2.default.func,
  isOffRange: _propTypes2.default.bool
};

exports.default = DateHeader;
module.exports = exports['default'];

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _constants = __webpack_require__(153);

var _TimeGrid = __webpack_require__(686);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Day = function (_React$Component) {
  _inherits(Day, _React$Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Day.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    var range = Day.range(date);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 10 }));
  };

  return Day;
}(_react2.default.Component);

Day.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};

Day.range = function (date) {
  return [_dates2.default.startOf(date, 'day')];
};

Day.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'day');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'day');

    default:
      return date;
  }
};

Day.title = function (date, _ref) {
  var formats = _ref.formats,
      culture = _ref.culture;
  return _localizer2.default.format(date, formats.dayHeaderFormat, culture);
};

exports.default = Day;
module.exports = exports['default'];

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _Selection = __webpack_require__(1209);

var _Selection2 = _interopRequireDefault(_Selection);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _TimeSlots = __webpack_require__(1213);

var TimeSlotUtils = _interopRequireWildcard(_TimeSlots);

var _selection = __webpack_require__(344);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _helpers = __webpack_require__(287);

var _propTypes3 = __webpack_require__(113);

var _accessors = __webpack_require__(239);

var _DayEventLayout = __webpack_require__(2293);

var DayEventLayout = _interopRequireWildcard(_DayEventLayout);

var _TimeSlotGroup = __webpack_require__(1210);

var _TimeSlotGroup2 = _interopRequireDefault(_TimeSlotGroup);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DayColumn = function (_React$Component) {
  _inherits(DayColumn, _React$Component);

  function DayColumn() {
    _classCallCheck(this, DayColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _initialiseProps.call(_this);

    _this.slotMetrics = TimeSlotUtils.getSlotMetrics(_this.props);
    return _this;
  }

  DayColumn.prototype.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  DayColumn.prototype.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  DayColumn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();

    this.slotMetrics = this.slotMetrics.update(nextProps);
  };

  DayColumn.prototype.render = function render() {
    var _props = this.props,
        max = _props.max,
        rtl = _props.rtl,
        date = _props.date,
        getNow = _props.getNow,
        selectRangeFormat = _props.selectRangeFormat,
        culture = _props.culture,
        slotPropGetter = _props.slotPropGetter,
        resource = _props.resource,
        timeSlotWrapperComponent = _props.timeSlotWrapperComponent,
        dayPropGetter = _props.dayPropGetter;
    var slotMetrics = this.slotMetrics;
    var _state = this.state,
        selecting = _state.selecting,
        top = _state.top,
        height = _state.height,
        startDate = _state.startDate,
        endDate = _state.endDate;

    var selectDates = { start: startDate, end: endDate };

    var _ref = dayPropGetter && dayPropGetter(max) || {},
        className = _ref.className,
        style = _ref.style;

    var current = getNow();

    return _react2.default.createElement('div', {
      style: style,
      className: (0, _classnames2.default)(className, 'rbc-day-slot', 'rbc-time-column', selecting && 'rbc-slot-selecting', _dates2.default.eq(date, current, 'day') && 'rbc-today')
    }, slotMetrics.groups.map(function (grp, idx) {
      return _react2.default.createElement(_TimeSlotGroup2.default, {
        key: idx,
        group: grp,
        resource: resource,
        slotPropGetter: slotPropGetter,
        timeSlotWrapperComponent: timeSlotWrapperComponent
      });
    }), _react2.default.createElement('div', { className: (0, _classnames2.default)('rbc-events-container', rtl && 'rtl') }, this.renderEvents()), selecting && _react2.default.createElement('div', { className: 'rbc-slot-selection', style: { top: top, height: height } }, _react2.default.createElement('span', null, _localizer2.default.format(selectDates, selectRangeFormat, culture))));
  };

  return DayColumn;
}(_react2.default.Component);

DayColumn.propTypes = {
  events: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object,
  step: _propTypes2.default.number.isRequired,
  date: _propTypes2.default.instanceOf(Date).isRequired,
  min: _propTypes2.default.instanceOf(Date).isRequired,
  max: _propTypes2.default.instanceOf(Date).isRequired,
  getNow: _propTypes2.default.func.isRequired,

  rtl: _propTypes2.default.bool,
  titleAccessor: _propTypes3.accessor,
  tooltipAccessor: _propTypes3.accessor,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  selectRangeFormat: _propTypes3.dateFormat,
  eventTimeRangeFormat: _propTypes3.dateFormat,
  eventTimeRangeStartFormat: _propTypes3.dateFormat,
  eventTimeRangeEndFormat: _propTypes3.dateFormat,
  showMultiDayTimes: _propTypes2.default.bool,
  culture: _propTypes2.default.string,
  timeslots: _propTypes2.default.number,
  messages: _propTypes2.default.object,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  eventOffset: _propTypes2.default.number,
  longPressThreshold: _propTypes2.default.number,

  onSelecting: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func.isRequired,
  onSelectEvent: _propTypes2.default.func.isRequired,
  onDoubleClickEvent: _propTypes2.default.func.isRequired,

  className: _propTypes2.default.string,
  dragThroughEvents: _propTypes2.default.bool,
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  slotPropGetter: _propTypes2.default.func,
  timeSlotWrapperComponent: _propTypes3.elementType,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  resource: _propTypes2.default.any
};
DayColumn.defaultProps = {
  dragThroughEvents: true,
  timeslots: 2
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { selecting: false };

  this.renderEvents = function () {
    var _props2 = _this2.props,
        EventComponent = _props2.components.event,
        culture = _props2.culture,
        endAccessor = _props2.endAccessor,
        eventPropGetter = _props2.eventPropGetter,
        eventTimeRangeEndFormat = _props2.eventTimeRangeEndFormat,
        eventTimeRangeFormat = _props2.eventTimeRangeFormat,
        eventTimeRangeStartFormat = _props2.eventTimeRangeStartFormat,
        EventWrapper = _props2.eventWrapperComponent,
        events = _props2.events,
        max = _props2.max,
        messages = _props2.messages,
        min = _props2.min,
        isRtl = _props2.rtl,
        selected = _props2.selected,
        startAccessor = _props2.startAccessor,
        titleAccessor = _props2.titleAccessor,
        tooltipAccessor = _props2.tooltipAccessor;

    var styledEvents = DayEventLayout.getStyledEvents({
      events: events,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      slotMetrics: _this2.slotMetrics
    });

    return styledEvents.map(function (_ref2, idx) {
      var _extends2;

      var event = _ref2.event,
          style = _ref2.style;

      var _eventTimeRangeFormat = eventTimeRangeFormat;
      var _continuesPrior = false;
      var _continuesAfter = false;
      var start = (0, _accessors.accessor)(event, startAccessor);
      var end = (0, _accessors.accessor)(event, endAccessor);

      if (start < min) {
        start = min;
        _continuesPrior = true;
        _eventTimeRangeFormat = eventTimeRangeEndFormat;
      }

      if (end > max) {
        end = max;
        _continuesAfter = true;
        _eventTimeRangeFormat = eventTimeRangeStartFormat;
      }

      var continuesPrior = _this2.slotMetrics.startsBefore(start);
      var continuesAfter = _this2.slotMetrics.startsAfter(end);

      var title = (0, _accessors.accessor)(event, titleAccessor);
      var tooltip = (0, _accessors.accessor)(event, tooltipAccessor);
      var label = void 0;
      if (_continuesPrior && _continuesAfter) {
        label = messages.allDay;
      } else {
        label = _localizer2.default.format({ start: start, end: end }, _eventTimeRangeFormat, culture);
      }

      var _isSelected = (0, _selection.isSelected)(event, selected);

      if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, _isSelected),
          xStyle = _eventPropGetter.style,
          className = _eventPropGetter.className;

      var height = style.height,
          top = style.top,
          width = style.width,
          xOffset = style.xOffset;

      var wrapperProps = {
        event: event,
        continuesPrior: _continuesPrior,
        continuesAfter: _continuesAfter
      };

      return _react2.default.createElement(EventWrapper, _extends({}, wrapperProps, { key: 'evt_' + idx }), _react2.default.createElement('div', {
        style: _extends({}, xStyle, (_extends2 = {
          top: top + '%',
          height: height + '%'
        }, _extends2[isRtl ? 'right' : 'left'] = Math.max(0, xOffset) + '%', _extends2.width = width + '%', _extends2)),
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        onClick: function onClick(e) {
          return _this2._select(event, e);
        },
        onDoubleClick: function onDoubleClick(e) {
          return _this2._doubleClick(event, e);
        },
        className: (0, _classnames2.default)('rbc-event', className, {
          'rbc-selected': _isSelected,
          'rbc-event-continues-earlier': continuesPrior,
          'rbc-event-continues-later': continuesAfter,
          'rbc-event-continues-day-prior': _continuesPrior,
          'rbc-event-continues-day-after': _continuesAfter
        })
      }, _react2.default.createElement('div', { className: 'rbc-event-label' }, label), _react2.default.createElement('div', { className: 'rbc-event-content' }, EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title)));
    });
  };

  this._selectable = function () {
    var node = (0, _reactDom.findDOMNode)(_this2);
    var selector = _this2._selector = new _Selection2.default(function () {
      return (0, _reactDom.findDOMNode)(_this2);
    }, {
      longPressThreshold: _this2.props.longPressThreshold
    });

    var maybeSelect = function maybeSelect(box) {
      var onSelecting = _this2.props.onSelecting;
      var current = _this2.state || {};
      var state = selectionState(box);
      var start = state.startDate,
          end = state.endDate;

      if (onSelecting) {
        if (_dates2.default.eq(current.startDate, start, 'minutes') && _dates2.default.eq(current.endDate, end, 'minutes') || onSelecting({ start: start, end: end }) === false) return;
      }

      if (_this2.state.start !== state.start || _this2.state.end !== state.end || _this2.state.selecting !== state.selecting) {
        _this2.setState(state);
      }
    };

    var selectionState = function selectionState(_ref3) {
      var y = _ref3.y;

      var _getBoundsForNode = (0, _Selection.getBoundsForNode)(node),
          top = _getBoundsForNode.top,
          bottom = _getBoundsForNode.bottom;

      var range = Math.abs(top - bottom);
      var currentSlot = _this2.slotMetrics.closestSlotToPosition((y - top) / range);

      if (!_this2.state.selecting) _this2._initialSlot = currentSlot;

      var initialSlot = _this2._initialSlot;
      if (initialSlot === currentSlot) currentSlot = _this2.slotMetrics.nextSlot(initialSlot);

      var selectRange = _this2.slotMetrics.getRange(_dates2.default.min(initialSlot, currentSlot), _dates2.default.max(initialSlot, currentSlot));

      return _extends({}, selectRange, {
        selecting: true,

        top: selectRange.top + '%',
        height: selectRange.height + '%'
      });
    };

    var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box)) {
        var _selectionState = selectionState(box),
            startDate = _selectionState.startDate,
            endDate = _selectionState.endDate;

        _this2._selectSlot({
          startDate: startDate,
          endDate: endDate,
          action: actionType,
          box: box
        });
      }
      _this2.setState({ selecting: false });
    };

    selector.on('selecting', maybeSelect);
    selector.on('selectStart', maybeSelect);

    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;

      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
    });

    selector.on('click', function (box) {
      return selectorClicksHandler(box, 'click');
    });

    selector.on('doubleClick', function (box) {
      return selectorClicksHandler(box, 'doubleClick');
    });

    selector.on('select', function (bounds) {
      if (_this2.state.selecting) {
        _this2._selectSlot(_extends({}, _this2.state, { action: 'select', bounds: bounds }));
        _this2.setState({ selecting: false });
      }
    });
  };

  this._teardownSelectable = function () {
    if (!_this2._selector) return;
    _this2._selector.teardown();
    _this2._selector = null;
  };

  this._selectSlot = function (_ref4) {
    var startDate = _ref4.startDate,
        endDate = _ref4.endDate,
        action = _ref4.action,
        bounds = _ref4.bounds,
        box = _ref4.box;

    var current = startDate,
        slots = [];

    while (_dates2.default.lte(current, endDate)) {
      slots.push(current);
      current = _dates2.default.add(current, _this2.props.step, 'minutes');
    }

    (0, _helpers.notify)(_this2.props.onSelectSlot, {
      slots: slots,
      start: startDate,
      end: endDate,
      resourceId: _this2.props.resource,
      action: action,
      bounds: bounds,
      box: box
    });
  };

  this._select = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
  };

  this._doubleClick = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
  };
};

exports.default = DayColumn;
module.exports = exports['default'];

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EventRowMixin = __webpack_require__(1206);

var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);

var _eventLevels = __webpack_require__(343);

var _messages = __webpack_require__(687);

var _messages2 = _interopRequireDefault(_messages);

var _range = __webpack_require__(2171);

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};
var eventsInSlot = function eventsInSlot(segments, slot) {
  return segments.filter(function (seg) {
    return isSegmentInSlot(seg, slot);
  }).length;
};

var EventEndingRow = function (_React$Component) {
  _inherits(EventEndingRow, _React$Component);

  function EventEndingRow() {
    _classCallCheck(this, EventEndingRow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventEndingRow.prototype.render = function render() {
    var _props = this.props,
        segments = _props.segments,
        slotCount = _props.slots;

    var rowSegments = (0, _eventLevels.eventLevels)(segments).levels[0];

    var current = 1,
        lastEnd = 1,
        row = [];

    while (current <= slotCount) {
      var key = '_lvl_' + current;

      var _ref = rowSegments.filter(function (seg) {
        return isSegmentInSlot(seg, current);
      })[0] || {},
          event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span; //eslint-disable-line

      if (!event) {
        current++;
        continue;
      }

      var gap = Math.max(0, left - lastEnd);

      if (this.canRenderSlotEvent(left, span)) {
        var content = _EventRowMixin2.default.renderEvent(this.props, event);

        if (gap) {
          row.push(_EventRowMixin2.default.renderSpan(slotCount, gap, key + '_gap'));
        }

        row.push(_EventRowMixin2.default.renderSpan(slotCount, span, key, content));

        lastEnd = current = right + 1;
      } else {
        if (gap) {
          row.push(_EventRowMixin2.default.renderSpan(slotCount, gap, key + '_gap'));
        }

        row.push(_EventRowMixin2.default.renderSpan(slotCount, 1, key, this.renderShowMore(segments, current)));
        lastEnd = current = current + 1;
      }
    }

    return _react2.default.createElement('div', { className: 'rbc-row' }, row);
  };

  EventEndingRow.prototype.canRenderSlotEvent = function canRenderSlotEvent(slot, span) {
    var segments = this.props.segments;

    return (0, _range2.default)(slot, slot + span).every(function (s) {
      var count = eventsInSlot(segments, s);

      return count === 1;
    });
  };

  EventEndingRow.prototype.renderShowMore = function renderShowMore(segments, slot) {
    var _this2 = this;

    var messages = (0, _messages2.default)(this.props.messages);
    var count = eventsInSlot(segments, slot);

    return count ? _react2.default.createElement('a', {
      key: 'sm_' + slot,
      href: '#',
      className: 'rbc-show-more',
      onClick: function onClick(e) {
        return _this2.showMore(slot, e);
      }
    }, messages.showMore(count)) : false;
  };

  EventEndingRow.prototype.showMore = function showMore(slot, e) {
    e.preventDefault();
    this.props.onShowMore(slot);
  };

  return EventEndingRow;
}(_react2.default.Component);

EventEndingRow.propTypes = _extends({
  segments: _propTypes2.default.array,
  slots: _propTypes2.default.number,
  messages: _propTypes2.default.object,
  onShowMore: _propTypes2.default.func
}, _EventRowMixin2.default.propTypes);
EventEndingRow.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps);
exports.default = EventEndingRow;
module.exports = exports['default'];

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EventRowMixin = __webpack_require__(1206);

var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EventRow = function (_React$Component) {
  _inherits(EventRow, _React$Component);

  function EventRow() {
    _classCallCheck(this, EventRow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventRow.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        segments = _props.segments,
        slots = _props.slots;

    var lastEnd = 1;

    return _react2.default.createElement('div', { className: 'rbc-row' }, segments.reduce(function (row, _ref, li) {
      var event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span;

      var key = '_lvl_' + li;
      var gap = left - lastEnd;

      var content = _EventRowMixin2.default.renderEvent(_this2.props, event);

      if (gap) row.push(_EventRowMixin2.default.renderSpan(slots, gap, key + '_gap'));

      row.push(_EventRowMixin2.default.renderSpan(slots, span, key, content));

      lastEnd = right + 1;

      return row;
    }, []));
  };

  return EventRow;
}(_react2.default.Component);

EventRow.propTypes = _extends({
  segments: _propTypes2.default.array
}, _EventRowMixin2.default.propTypes);
EventRow.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps);
exports.default = EventRow;
module.exports = exports['default'];

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _chunk = __webpack_require__(2159);

var _chunk2 = _interopRequireDefault(_chunk);

var _constants = __webpack_require__(153);

var _helpers = __webpack_require__(287);

var _position = __webpack_require__(1849);

var _position2 = _interopRequireDefault(_position);

var _requestAnimationFrame = __webpack_require__(621);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _Popup = __webpack_require__(2284);

var _Popup2 = _interopRequireDefault(_Popup);

var _Overlay = __webpack_require__(2332);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _DateContentRow = __webpack_require__(1204);

var _DateContentRow2 = _interopRequireDefault(_DateContentRow);

var _Header = __webpack_require__(1208);

var _Header2 = _interopRequireDefault(_Header);

var _DateHeader = __webpack_require__(2278);

var _DateHeader2 = _interopRequireDefault(_DateHeader);

var _propTypes3 = __webpack_require__(113);

var _eventLevels = __webpack_require__(343);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var eventsForWeek = function eventsForWeek(evts, start, end, props) {
  return evts.filter(function (e) {
    return (0, _eventLevels.inRange)(e, start, end, props);
  });
};

var propTypes = {
  events: _propTypes2.default.array.isRequired,
  date: _propTypes2.default.instanceOf(Date),

  min: _propTypes2.default.instanceOf(Date),
  max: _propTypes2.default.instanceOf(Date),

  step: _propTypes2.default.number,
  getNow: _propTypes2.default.func.isRequired,

  scrollToTime: _propTypes2.default.instanceOf(Date),
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,

  culture: _propTypes2.default.string,
  dayFormat: _propTypes3.dateFormat,

  rtl: _propTypes2.default.bool,
  width: _propTypes2.default.number,

  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onNavigate: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEvent: _propTypes2.default.func,
  onDoubleClickEvent: _propTypes2.default.func,
  onShowMore: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  getDrilldownView: _propTypes2.default.func.isRequired,

  dateFormat: _propTypes3.dateFormat,

  weekdayFormat: _propTypes3.dateFormat,
  popup: _propTypes2.default.bool,

  messages: _propTypes2.default.object,
  components: _propTypes2.default.object.isRequired,
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  })])
};

var MonthView = function (_React$Component) {
  _inherits(MonthView, _React$Component);

  function MonthView() {
    _classCallCheck(this, MonthView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _initialiseProps.call(_this);

    _this._bgRows = [];
    _this._pendingSelection = [];
    _this.state = {
      rowLimit: 5,
      needLimitMeasure: true
    };
    return _this;
  }

  MonthView.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var date = _ref.date;

    this.setState({
      needLimitMeasure: !_dates2.default.eq(date, this.props.date)
    });
  };

  MonthView.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var running = void 0;

    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);

    window.addEventListener('resize', this._resizeListener = function () {
      if (!running) {
        (0, _requestAnimationFrame2.default)(function () {
          running = false;
          _this2.setState({ needLimitMeasure: true }); //eslint-disable-line
        });
      }
    }, false);
  };

  MonthView.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
  };

  MonthView.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener, false);
  };

  MonthView.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        culture = _props.culture,
        weekdayFormat = _props.weekdayFormat,
        className = _props.className,
        month = _dates2.default.visibleDays(date, culture),
        weeks = (0, _chunk2.default)(month, 7);

    this._weekCount = weeks.length;

    return _react2.default.createElement('div', { className: (0, _classnames2.default)('rbc-month-view', className) }, _react2.default.createElement('div', { className: 'rbc-row rbc-month-header' }, this.renderHeaders(weeks[0], weekdayFormat, culture)), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
  };

  MonthView.prototype.renderHeaders = function renderHeaders(row, format, culture) {
    var first = row[0];
    var last = row[row.length - 1];
    var HeaderComponent = this.props.components.header || _Header2.default;

    return _dates2.default.range(first, last, 'day').map(function (day, idx) {
      return _react2.default.createElement('div', { key: 'header_' + idx, className: 'rbc-header' }, _react2.default.createElement(HeaderComponent, {
        date: day,
        label: _localizer2.default.format(day, format, culture),
        localizer: _localizer2.default,
        format: format,
        culture: culture
      }));
    });
  };

  MonthView.prototype.renderOverlay = function renderOverlay() {
    var _this3 = this;

    var overlay = this.state && this.state.overlay || {};
    var components = this.props.components;

    return _react2.default.createElement(_Overlay2.default, {
      rootClose: true,
      placement: 'bottom',
      container: this,
      show: !!overlay.position,
      onHide: function onHide() {
        return _this3.setState({ overlay: null });
      }
    }, _react2.default.createElement(_Popup2.default, _extends({}, this.props, {
      eventComponent: components.event,
      eventWrapperComponent: components.eventWrapper,
      position: overlay.position,
      events: overlay.events,
      slotStart: overlay.date,
      slotEnd: overlay.end,
      onSelect: this.handleSelectEvent,
      onDoubleClick: this.handleDoubleClickEvent
    })));
  };

  MonthView.prototype.measureRowLimit = function measureRowLimit() {
    this.setState({
      needLimitMeasure: false,
      rowLimit: this.refs.slotRow.getRowLimit()
    });
  };

  MonthView.prototype.selectDates = function selectDates(slotInfo) {
    var slots = this._pendingSelection.slice();

    this._pendingSelection = [];

    slots.sort(function (a, b) {
      return +a - +b;
    });

    (0, _helpers.notify)(this.props.onSelectSlot, {
      slots: slots,
      start: slots[0],
      end: slots[slots.length - 1],
      action: slotInfo.action
    });
  };

  MonthView.prototype.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  return MonthView;
}(_react2.default.Component);

MonthView.displayName = 'MonthView';
MonthView.propTypes = propTypes;

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getContainer = function () {
    return (0, _reactDom.findDOMNode)(_this4);
  };

  this.renderWeek = function (week, weekIdx) {
    var _props2 = _this4.props,
        events = _props2.events,
        components = _props2.components,
        selectable = _props2.selectable,
        titleAccessor = _props2.titleAccessor,
        tooltipAccessor = _props2.tooltipAccessor,
        startAccessor = _props2.startAccessor,
        endAccessor = _props2.endAccessor,
        allDayAccessor = _props2.allDayAccessor,
        getNow = _props2.getNow,
        eventPropGetter = _props2.eventPropGetter,
        dayPropGetter = _props2.dayPropGetter,
        messages = _props2.messages,
        selected = _props2.selected,
        date = _props2.date,
        longPressThreshold = _props2.longPressThreshold;
    var _state = _this4.state,
        needLimitMeasure = _state.needLimitMeasure,
        rowLimit = _state.rowLimit;

    events = eventsForWeek(events, week[0], week[week.length - 1], _this4.props);
    events.sort(function (a, b) {
      return (0, _eventLevels.sortEvents)(a, b, _this4.props);
    });

    return _react2.default.createElement(_DateContentRow2.default, {
      key: weekIdx,
      ref: weekIdx === 0 ? 'slotRow' : undefined,
      container: _this4.getContainer,
      className: 'rbc-month-row',
      getNow: getNow,
      date: date,
      range: week,
      events: events,
      maxRows: rowLimit,
      selected: selected,
      selectable: selectable,
      messages: messages,
      titleAccessor: titleAccessor,
      tooltipAccessor: tooltipAccessor,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      allDayAccessor: allDayAccessor,
      eventPropGetter: eventPropGetter,
      dayPropGetter: dayPropGetter,
      renderHeader: _this4.readerDateHeading,
      renderForMeasure: needLimitMeasure,
      onShowMore: _this4.handleShowMore,
      onSelect: _this4.handleSelectEvent,
      onDoubleClick: _this4.handleDoubleClickEvent,
      onSelectSlot: _this4.handleSelectSlot,
      eventComponent: components.event,
      eventWrapperComponent: components.eventWrapper,
      dateCellWrapperComponent: components.dateCellWrapper,
      longPressThreshold: longPressThreshold
    });
  };

  this.readerDateHeading = function (_ref4) {
    var date = _ref4.date,
        className = _ref4.className,
        props = _objectWithoutProperties(_ref4, ['date', 'className']);

    var _props3 = _this4.props,
        currentDate = _props3.date,
        getDrilldownView = _props3.getDrilldownView,
        dateFormat = _props3.dateFormat,
        culture = _props3.culture;

    var isOffRange = _dates2.default.month(date) !== _dates2.default.month(currentDate);
    var isCurrent = _dates2.default.eq(date, currentDate, 'day');
    var drilldownView = getDrilldownView(date);
    var label = _localizer2.default.format(date, dateFormat, culture);
    var DateHeaderComponent = _this4.props.components.dateHeader || _DateHeader2.default;

    return _react2.default.createElement('div', _extends({}, props, {
      className: (0, _classnames2.default)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current')
    }), _react2.default.createElement(DateHeaderComponent, {
      label: label,
      date: date,
      drilldownView: drilldownView,
      isOffRange: isOffRange,
      onDrillDown: function onDrillDown(e) {
        return _this4.handleHeadingClick(date, drilldownView, e);
      }
    }));
  };

  this.handleSelectSlot = function (range, slotInfo) {
    _this4._pendingSelection = _this4._pendingSelection.concat(range);

    clearTimeout(_this4._selectTimer);
    _this4._selectTimer = setTimeout(function () {
      return _this4.selectDates(slotInfo);
    });
  };

  this.handleHeadingClick = function (date, view, e) {
    e.preventDefault();
    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onDrillDown, [date, view]);
  };

  this.handleSelectEvent = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onSelectEvent, args);
  };

  this.handleDoubleClickEvent = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onDoubleClickEvent, args);
  };

  this.handleShowMore = function (events, date, cell, slot) {
    var _props4 = _this4.props,
        popup = _props4.popup,
        onDrillDown = _props4.onDrillDown,
        onShowMore = _props4.onShowMore,
        getDrilldownView = _props4.getDrilldownView;
    //cancel any pending selections so only the event click goes through.

    _this4.clearSelection();

    if (popup) {
      var position = (0, _position2.default)(cell, (0, _reactDom.findDOMNode)(_this4));

      _this4.setState({
        overlay: { date: date, events: events, position: position }
      });
    } else {
      (0, _helpers.notify)(onDrillDown, [date, getDrilldownView(date) || _constants.views.DAY]);
    }

    (0, _helpers.notify)(onShowMore, [events, date, slot]);
  };
};

MonthView.range = function (date, _ref2) {
  var culture = _ref2.culture;

  var start = _dates2.default.firstVisibleDay(date, culture);
  var end = _dates2.default.lastVisibleDay(date, culture);
  return { start: start, end: end };
};

MonthView.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'month');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'month');

    default:
      return date;
  }
};

MonthView.title = function (date, _ref3) {
  var formats = _ref3.formats,
      culture = _ref3.culture;
  return _localizer2.default.format(date, formats.monthHeaderFormat, culture);
};

exports.default = MonthView;
module.exports = exports['default'];

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _offset = __webpack_require__(417);

var _offset2 = _interopRequireDefault(_offset);

var _scrollTop = __webpack_require__(945);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(944);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _EventCell = __webpack_require__(1205);

var _EventCell2 = _interopRequireDefault(_EventCell);

var _selection = __webpack_require__(344);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _propTypes3 = __webpack_require__(113);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  position: _propTypes2.default.object,
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  })]),
  events: _propTypes2.default.array,
  selected: _propTypes2.default.object,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType,
  dayHeaderFormat: _propTypes3.dateFormat
};

var Popup = function (_React$Component) {
  _inherits(Popup, _React$Component);

  function Popup() {
    _classCallCheck(this, Popup);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    var _props$popupOffset = this.props.popupOffset,
        popupOffset = _props$popupOffset === undefined ? 5 : _props$popupOffset,
        _getOffset = (0, _offset2.default)(this.refs.root),
        top = _getOffset.top,
        left = _getOffset.left,
        width = _getOffset.width,
        height = _getOffset.height,
        viewBottom = window.innerHeight + (0, _scrollTop2.default)(window),
        viewRight = window.innerWidth + (0, _scrollLeft2.default)(window),
        bottom = top + height,
        right = left + width;

    if (bottom > viewBottom || right > viewRight) {
      var topOffset = void 0,
          leftOffset = void 0;

      if (bottom > viewBottom) topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
      if (right > viewRight) leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);

      this.setState({ topOffset: topOffset, leftOffset: leftOffset }); //eslint-disable-line
    }
  };

  Popup.prototype.render = function render() {
    var _props = this.props,
        events = _props.events,
        selected = _props.selected,
        eventComponent = _props.eventComponent,
        eventWrapperComponent = _props.eventWrapperComponent,
        props = _objectWithoutProperties(_props, ['events', 'selected', 'eventComponent', 'eventWrapperComponent']);

    var _props$position = this.props.position,
        left = _props$position.left,
        width = _props$position.width,
        top = _props$position.top,
        topOffset = (this.state || {}).topOffset || 0,
        leftOffset = (this.state || {}).leftOffset || 0;

    var style = {
      top: Math.max(0, top - topOffset),
      left: left - leftOffset,
      minWidth: width + width / 2
    };

    return _react2.default.createElement('div', { ref: 'root', style: style, className: 'rbc-overlay' }, _react2.default.createElement('div', { className: 'rbc-overlay-header' }, _localizer2.default.format(props.slotStart, props.dayHeaderFormat, props.culture)), events.map(function (event, idx) {
      return _react2.default.createElement(_EventCell2.default, _extends({
        key: idx
      }, props, {
        event: event,
        eventComponent: eventComponent,
        eventWrapperComponent: eventWrapperComponent,
        selected: (0, _selection.isSelected)(event, selected)
      }));
    }));
  };

  return Popup;
}(_react2.default.Component);

Popup.propTypes = propTypes;

exports.default = Popup;
module.exports = exports['default'];

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _scrollbarSize = __webpack_require__(950);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(113);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _DateContentRow = __webpack_require__(1204);

var _DateContentRow2 = _interopRequireDefault(_DateContentRow);

var _Header = __webpack_require__(1208);

var _Header2 = _interopRequireDefault(_Header);

var _helpers = __webpack_require__(287);

var _accessors = __webpack_require__(239);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimeGridHeader = function (_React$Component) {
  _inherits(TimeGridHeader, _React$Component);

  function TimeGridHeader() {
    var _temp, _this, _ret;

    _classCallCheck(this, TimeGridHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleHeaderClick = function (date, view, e) {
      e.preventDefault();
      (0, _helpers.notify)(_this.props.onDrillDown, [date, view]);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TimeGridHeader.prototype.renderHeaderResources = function renderHeaderResources(range, resources) {
    var _props = this.props,
        resourceTitleAccessor = _props.resourceTitleAccessor,
        getNow = _props.getNow;

    var today = getNow();

    return range.map(function (date, i) {
      return resources.map(function (resource, j) {
        return _react2.default.createElement('div', {
          key: i + '-' + j,
          className: (0, _classnames2.default)('rbc-header', _dates2.default.eq(date, today, 'day') && 'rbc-today')
        }, (0, _accessors.accessor)(resource, resourceTitleAccessor));
      });
    });
  };

  TimeGridHeader.prototype.renderHeaderCells = function renderHeaderCells(range) {
    var _this2 = this;

    var _props2 = this.props,
        dayFormat = _props2.dayFormat,
        culture = _props2.culture,
        dayPropGetter = _props2.dayPropGetter,
        getDrilldownView = _props2.getDrilldownView,
        getNow = _props2.getNow,
        Header = _props2.headerComponent;

    var today = getNow();

    return range.map(function (date, i) {
      var drilldownView = getDrilldownView(date);
      var label = _localizer2.default.format(date, dayFormat, culture);

      var _ref = dayPropGetter && dayPropGetter(date) || {},
          className = _ref.className,
          style = _ref.style;

      var header = _react2.default.createElement(Header, {
        date: date,
        label: label,
        localizer: _localizer2.default,
        format: dayFormat,
        culture: culture
      });

      return _react2.default.createElement('div', {
        key: i,
        style: style,
        className: (0, _classnames2.default)('rbc-header', className, _dates2.default.eq(date, today, 'day') && 'rbc-today')
      }, drilldownView ? _react2.default.createElement('a', {
        href: '#',
        onClick: function onClick(e) {
          return _this2.handleHeaderClick(date, drilldownView, e);
        }
      }, header) : _react2.default.createElement('span', null, header));
    });
  };

  TimeGridHeader.prototype.render = function render() {
    var _props3 = this.props,
        width = _props3.width,
        events = _props3.events,
        rtl = _props3.rtl,
        selectable = _props3.selectable,
        resources = _props3.resources,
        getNow = _props3.getNow,
        range = _props3.range,
        isOverflowing = _props3.isOverflowing,
        eventComponent = _props3.eventComponent,
        dateCellWrapperComponent = _props3.dateCellWrapperComponent,
        eventWrapperComponent = _props3.eventWrapperComponent;

    var style = {};
    if (isOverflowing) {
      style[rtl ? 'marginLeft' : 'marginRight'] = (0, _scrollbarSize2.default)() + 'px';
    }

    return _react2.default.createElement('div', {
      ref: 'headerCell',
      style: style,
      className: (0, _classnames2.default)('rbc-time-header', isOverflowing && 'rbc-overflowing')
    }, _react2.default.createElement('div', { className: 'rbc-label rbc-time-header-gutter', style: { width: width } }), _react2.default.createElement('div', { className: 'rbc-time-header-content' }, _react2.default.createElement('div', { className: 'rbc-row rbc-time-header-cell' }, this.renderHeaderCells(range)), resources && _react2.default.createElement('div', { className: 'rbc-row rbc-row-resource' }, this.renderHeaderResources(range, resources)), _react2.default.createElement(_DateContentRow2.default, {
      isAllDay: true,
      rtl: rtl,
      getNow: getNow,
      minRows: 2,
      range: range,
      events: events,
      className: 'rbc-allday-cell',
      selectable: selectable,
      selected: this.props.selected,
      eventComponent: eventComponent,
      eventWrapperComponent: eventWrapperComponent,
      dateCellWrapperComponent: dateCellWrapperComponent,
      dayPropGetter: this.props.dayPropGetter,
      titleAccessor: this.props.titleAccessor,
      tooltipAccessor: this.props.tooltipAccessor,
      startAccessor: this.props.startAccessor,
      endAccessor: this.props.endAccessor,
      allDayAccessor: this.props.allDayAccessor,
      eventPropGetter: this.props.eventPropGetter,
      onSelect: this.props.onSelectEvent,
      onDoubleClick: this.props.onDoubleClickEvent,
      onSelectSlot: this.props.onSelectSlot,
      longPressThreshold: this.props.longPressThreshold
    })));
  };

  return TimeGridHeader;
}(_react2.default.Component);

TimeGridHeader.propTypes = {
  range: _propTypes2.default.array.isRequired,
  events: _propTypes2.default.array.isRequired,
  resources: _propTypes2.default.array,
  getNow: _propTypes2.default.func.isRequired,
  isOverflowing: _propTypes2.default.bool,

  dayFormat: _propTypes3.dateFormat,
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  culture: _propTypes2.default.string,

  rtl: _propTypes2.default.bool,
  width: _propTypes2.default.number,

  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,
  resourceAccessor: _propTypes3.accessor.isRequired,

  resourceIdAccessor: _propTypes3.accessor.isRequired,
  resourceTitleAccessor: _propTypes3.accessor.isRequired,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  headerComponent: _propTypes3.elementType,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  dateCellWrapperComponent: _propTypes3.elementType,

  onSelectSlot: _propTypes2.default.func,
  onSelectEvent: _propTypes2.default.func,
  onDoubleClickEvent: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  getDrilldownView: _propTypes2.default.func.isRequired
};
TimeGridHeader.defaultProps = {
  headerComponent: _Header2.default
};
exports.default = TimeGridHeader;
module.exports = exports['default'];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TimeSlots = __webpack_require__(1213);

var TimeSlotUtils = _interopRequireWildcard(_TimeSlots);

var _propTypes3 = __webpack_require__(113);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

var _TimeSlotGroup = __webpack_require__(1210);

var _TimeSlotGroup2 = _interopRequireDefault(_TimeSlotGroup);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimeGutter = function (_Component) {
  _inherits(TimeGutter, _Component);

  function TimeGutter() {
    _classCallCheck(this, TimeGutter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));

    _this.renderSlot = function (value, idx) {
      if (idx !== 0) return null;
      var _this$props = _this.props,
          timeGutterFormat = _this$props.timeGutterFormat,
          getNow = _this$props.getNow,
          culture = _this$props.culture;

      var isNow = _this.slotMetrics.dateIsInGroup(getNow(), idx);
      return _react2.default.createElement('span', { className: (0, _classnames2.default)('rbc-label', isNow && 'rbc-now') }, _localizer2.default.format(value, timeGutterFormat, culture));
    };

    var _this$props2 = _this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        timeslots = _this$props2.timeslots,
        step = _this$props2.step;

    _this.slotMetrics = TimeSlotUtils.getSlotMetrics({
      min: min,
      max: max,
      timeslots: timeslots,
      step: step
    });
    return _this;
  }

  TimeGutter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var min = nextProps.min,
        max = nextProps.max,
        timeslots = nextProps.timeslots,
        step = nextProps.step;

    this.slotMetrics = this.slotMetrics.update({ min: min, max: max, timeslots: timeslots, step: step });
  };

  TimeGutter.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        culture = _props.culture,
        resource = _props.resource;

    return _react2.default.createElement('div', { className: 'rbc-time-gutter rbc-time-column' }, this.slotMetrics.groups.map(function (grp, idx) {
      return _react2.default.createElement(_TimeSlotGroup2.default, {
        key: idx,
        group: grp,
        culture: culture,
        resource: resource,
        renderSlot: _this2.renderSlot
      });
    }));
  };

  return TimeGutter;
}(_react.Component);

TimeGutter.propTypes = {
  min: _propTypes2.default.instanceOf(Date).isRequired,
  max: _propTypes2.default.instanceOf(Date).isRequired,
  timeslots: _propTypes2.default.number.isRequired,
  step: _propTypes2.default.number.isRequired,
  getNow: _propTypes2.default.func.isRequired,

  timeGutterFormat: _propTypes3.dateFormat,
  culture: _propTypes2.default.string,
  resource: _propTypes2.default.string
};
exports.default = TimeGutter;
module.exports = exports['default'];

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(153);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Toolbar = function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Toolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.navigate = function (action) {
      _this.props.onNavigate(action);
    }, _this.view = function (view) {
      _this.props.onViewChange(view);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Toolbar.prototype.render = function render() {
    var _props = this.props,
        messages = _props.messages,
        label = _props.label;

    return _react2.default.createElement('div', { className: 'rbc-toolbar' }, _react2.default.createElement('span', { className: 'rbc-btn-group' }, _react2.default.createElement('button', {
      type: 'button',
      onClick: this.navigate.bind(null, _constants.navigate.TODAY)
    }, messages.today), _react2.default.createElement('button', {
      type: 'button',
      onClick: this.navigate.bind(null, _constants.navigate.PREVIOUS)
    }, messages.previous), _react2.default.createElement('button', {
      type: 'button',
      onClick: this.navigate.bind(null, _constants.navigate.NEXT)
    }, messages.next)), _react2.default.createElement('span', { className: 'rbc-toolbar-label' }, label), _react2.default.createElement('span', { className: 'rbc-btn-group' }, this.viewNamesGroup(messages)));
  };

  Toolbar.prototype.viewNamesGroup = function viewNamesGroup(messages) {
    var _this2 = this;

    var viewNames = this.props.views;
    var view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(function (name) {
        return _react2.default.createElement('button', {
          type: 'button',
          key: name,
          className: (0, _classnames2.default)({ 'rbc-active': view === name }),
          onClick: _this2.view.bind(null, name)
        }, messages[name]);
      });
    }
  };

  return Toolbar;
}(_react2.default.Component);

Toolbar.propTypes = {
  view: _propTypes2.default.string.isRequired,
  views: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  label: _propTypes2.default.node.isRequired,
  messages: _propTypes2.default.object,
  onNavigate: _propTypes2.default.func.isRequired,
  onViewChange: _propTypes2.default.func.isRequired
};
exports.default = Toolbar;
module.exports = exports['default'];

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(58);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Week = __webpack_require__(1212);

var _Week2 = _interopRequireDefault(_Week);

var _TimeGrid = __webpack_require__(686);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

var _localizer = __webpack_require__(98);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function workWeekRange(date, options) {
  return _Week2.default.range(date, options).filter(function (d) {
    return [6, 0].indexOf(d.getDay()) === -1;
  });
}

var WorkWeek = function (_React$Component) {
  _inherits(WorkWeek, _React$Component);

  function WorkWeek() {
    _classCallCheck(this, WorkWeek);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  WorkWeek.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    var range = workWeekRange(date, this.props);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
  };

  return WorkWeek;
}(_react2.default.Component);

WorkWeek.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};
WorkWeek.defaultProps = _TimeGrid2.default.defaultProps;

WorkWeek.range = function (date, options) {
  return _Week2.default.range(date, options).filter(function (d) {
    return [6, 0].indexOf(d.getDay()) === -1;
  });
};

WorkWeek.navigate = _Week2.default.navigate;

WorkWeek.title = function (date, _ref) {
  var formats = _ref.formats,
      culture = _ref.culture;

  var _workWeekRange = workWeekRange(date, { culture: culture }),
      start = _workWeekRange[0],
      rest = _workWeekRange.slice(1);

  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
};

exports.default = WorkWeek;
module.exports = exports['default'];

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _Calendar = __webpack_require__(2277);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _EventWrapper = __webpack_require__(1207);

var _EventWrapper2 = _interopRequireDefault(_EventWrapper);

var _BackgroundWrapper = __webpack_require__(685);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

var _localizer = __webpack_require__(98);

var _moment = __webpack_require__(2291);

var _moment2 = _interopRequireDefault(_moment);

var _globalize = __webpack_require__(2290);

var _globalize2 = _interopRequireDefault(_globalize);

var _move = __webpack_require__(1214);

var _move2 = _interopRequireDefault(_move);

var _constants = __webpack_require__(153);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_extends(_Calendar2.default, {
  setLocalizer: _localizer.set,
  globalizeLocalizer: _globalize2.default,
  momentLocalizer: _moment2.default,
  Views: _constants.views,
  Navigate: _constants.navigate,
  move: _move2.default,
  components: {
    eventWrapper: _EventWrapper2.default,
    dayWrapper: _BackgroundWrapper2.default,
    dateCellWrapper: _BackgroundWrapper2.default
  }
});

exports.default = _Calendar2.default;
module.exports = exports['default'];

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (globalize) {
  var locale = function locale(culture) {
    return culture ? globalize(culture) : globalize;
  };

  // return the first day of the week from the locale data. Defaults to 'world'
  // territory if no territory is derivable from CLDR.
  // Failing to use CLDR supplemental (not loaded?), revert to the original
  // method of getting first day of week.
  function firstOfWeek(culture) {
    try {
      var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var cldr = locale(culture).cldr;
      var territory = cldr.attributes.territory;
      var weekData = cldr.get('supplemental').weekData;
      var firstDay = weekData.firstDay[territory || '001'];
      return days.indexOf(firstDay);
    } catch (e) {
       false ? (0, _warning2.default)(true, 'Failed to accurately determine first day of the week.\n            Is supplemental data loaded into CLDR?') : void 0;
      // maybe cldr supplemental is not loaded? revert to original method
      var date = new Date();
      //cldr-data doesn't seem to be zero based
      var localeDay = Math.max(parseInt(locale(culture).formatDate(date, { raw: 'e' }), 10) - 1, 0);

      return Math.abs(date.getDay() - localeDay);
    }
  }

  if (!globalize.load) return (0, _oldGlobalize2.default)(globalize);

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: firstOfWeek,

    parse: function parse(value, format, culture) {
      format = typeof format === 'string' ? { raw: format } : format;
      return locale(culture).parseDate(value, format);
    },
    format: function format(value, _format, culture) {
      _format = typeof _format === 'string' ? { raw: _format } : _format;
      return locale(culture).formatDate(value, _format);
    }
  });
};

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _oldGlobalize = __webpack_require__(2292);

var _oldGlobalize2 = _interopRequireDefault(_oldGlobalize);

var _warning = __webpack_require__(1215);

var _warning2 = _interopRequireDefault(_warning);

var _formats = __webpack_require__(461);

var _localizer = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, { date: 'short' }, culture) + ' — ' + local.format(end, { date: 'short' }, culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, { time: 'short' }, culture) + ' — ' + local.format(end, { time: 'short' }, culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, { time: 'short' }, culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' — ' + local.format(end, { time: 'short' }, culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' — ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = exports.formats = {
  dateFormat: 'dd',
  dayFormat: 'eee dd/MM',
  weekdayFormat: 'eee',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: { time: 'short' },

  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'eeee MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'eee MMM dd',
  agendaTimeFormat: { time: 'short' },
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (moment) {
  var locale = function locale(m, c) {
    return c ? m.locale(c) : m;
  };

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: function firstOfWeek(culture) {
      var data = culture ? moment.localeData(culture) : moment.localeData();
      return data ? data.firstDayOfWeek() : 0;
    },
    parse: function parse(value, format, culture) {
      return locale(moment(value, format), culture).toDate();
    },
    format: function format(value, _format, culture) {
      return locale(moment(value), culture).format(_format);
    }
  });
};

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _formats = __webpack_require__(461);

var _localizer = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'L', culture) + ' — ' + local.format(end, 'L', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'LT', culture) + ' — ' + local.format(end, 'LT', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 'h:mma', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 'h:mma', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMMM DD', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};

var formats = exports.formats = {
  dateFormat: 'DD',
  dayFormat: 'DD ddd',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 'LT',

  monthHeaderFormat: 'MMMM YYYY',
  dayHeaderFormat: 'dddd MMM DD',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM DD',
  agendaTimeFormat: 'LT',
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (globalize) {
  function getCulture(culture) {
    return culture ? globalize.findClosestCulture(culture) : globalize.culture();
  }

  function firstOfWeek(culture) {
    culture = getCulture(culture);
    return culture && culture.calendar.firstDay || 0;
  }

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: firstOfWeek,

    parse: function parse(value, format, culture) {
      return globalize.parseDate(value, format, culture);
    },
    format: function format(value, _format, culture) {
      return globalize.format(value, _format, culture);
    }
  });
};

var _dates = __webpack_require__(89);

var _dates2 = _interopRequireDefault(_dates);

var _formats = __webpack_require__(461);

var _localizer = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 't', culture) + ' — ' + local.format(end, 't', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 't', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 't', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = exports.formats = {
  dateFormat: 'dd',
  dayFormat: 'ddd dd/MM',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 't',

  monthHeaderFormat: 'Y',
  dayHeaderFormat: 'dddd MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM dd',
  agendaTimeFormat: 't',
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getStyledEvents = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _sortBy = __webpack_require__(667);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _accessors = __webpack_require__(239);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Event = function () {
  function Event(data, _ref) {
    var startAccessor = _ref.startAccessor,
        endAccessor = _ref.endAccessor,
        slotMetrics = _ref.slotMetrics;

    _classCallCheck(this, Event);

    var _slotMetrics$getRange = slotMetrics.getRange((0, _accessors.accessor)(data, startAccessor), (0, _accessors.accessor)(data, endAccessor)),
        start = _slotMetrics$getRange.start,
        startDate = _slotMetrics$getRange.startDate,
        end = _slotMetrics$getRange.end,
        endDate = _slotMetrics$getRange.endDate,
        top = _slotMetrics$getRange.top,
        height = _slotMetrics$getRange.height;

    this.start = start;
    this.end = end;
    this.startMs = +startDate;
    this.endMs = +endDate;
    this.top = top;
    this.height = height;
    this.data = data;
  }

  /**
   * The event's width without any overlap.
   */

  _createClass(Event, [{
    key: '_width',
    get: function get() {
      // The container event's width is determined by the maximum number of
      // events in any of its rows.
      if (this.rows) {
        var columns = this.rows.reduce(function (max, row) {
          return Math.max(max, row.leaves.length + 1);
        }, // add itself
        0) + 1; // add the container

        return 100 / columns;
      }

      var availableWidth = 100 - this.container._width;

      // The row event's width is the space left by the container, divided
      // among itself and its leaves.
      if (this.leaves) {
        return availableWidth / (this.leaves.length + 1);
      }

      // The leaf event's width is determined by its row's width
      return this.row._width;
    }

    /**
     * The event's calculated width, possibly with extra width added for
     * overlapping effect.
     */

  }, {
    key: 'width',
    get: function get() {
      var noOverlap = this._width;
      var overlap = Math.min(100, this._width * 1.7);

      // Containers can always grow.
      if (this.rows) {
        return overlap;
      }

      // Rows can grow if they have leaves.
      if (this.leaves) {
        return this.leaves.length > 0 ? overlap : noOverlap;
      }

      // Leaves can grow unless they're the last item in a row.
      var leaves = this.row.leaves;

      var index = leaves.indexOf(this);
      return index === leaves.length - 1 ? noOverlap : overlap;
    }
  }, {
    key: 'xOffset',
    get: function get() {
      // Containers have no offset.
      if (this.rows) return 0;

      // Rows always start where their container ends.
      if (this.leaves) return this.container._width;

      // Leaves are spread out evenly on the space left by its row.
      var _row = this.row,
          leaves = _row.leaves,
          xOffset = _row.xOffset,
          _width = _row._width;

      var index = leaves.indexOf(this) + 1;
      return xOffset + index * _width;
    }
  }]);

  return Event;
}();

/**
 * Return true if event a and b is considered to be on the same row.
 */

function onSameRow(a, b) {
  return (
    // Occupies the same start slot.
    Math.abs(b.start - a.start) <= 30 ||
    // A's start slot overlaps with b's end slot.
    a.start > b.start && a.start < b.end
  );
}

function sortByRender(events) {
  var sortedByTime = (0, _sortBy2.default)(events, ['startMs', function (e) {
    return -e.endMs;
  }]);

  var sorted = [];
  while (sortedByTime.length > 0) {
    var event = sortedByTime.shift();
    sorted.push(event);

    for (var i = 0; i < sortedByTime.length; i++) {
      var test = sortedByTime[i];

      // Still inside this event, look for next.
      if (event.endMs > test.startMs) continue;

      // We've found the first event of the next event group.
      // If that event is not right next to our current event, we have to
      // move it here.
      if (i > 0) {
        var _event = sortedByTime.splice(i, 1)[0];
        sorted.push(_event);
      }

      // We've already found the next event group, so stop looking.
      break;
    }
  }

  return sorted;
}

function getStyledEvents(_ref2) {
  var events = _ref2.events,
      props = _objectWithoutProperties(_ref2, ['events']);

  // Create proxy events and order them so that we don't have
  // to fiddle with z-indexes.
  var proxies = events.map(function (event) {
    return new Event(event, props);
  });
  var eventsInRenderOrder = sortByRender(proxies);

  // Group overlapping events, while keeping order.
  // Every event is always one of: container, row or leaf.
  // Containers can contain rows, and rows can contain leaves.
  var containerEvents = [];

  var _loop = function _loop(i) {
    var event = eventsInRenderOrder[i];

    // Check if this event can go into a container event.
    var container = containerEvents.find(function (c) {
      return c.end > event.start || Math.abs(event.start - c.start) < 30;
    });

    // Couldn't find a container — that means this event is a container.
    if (!container) {
      event.rows = [];
      containerEvents.push(event);
      return 'continue';
    }

    // Found a container for the event.
    event.container = container;

    // Check if the event can be placed in an existing row.
    // Start looking from behind.
    var row = null;
    for (var j = container.rows.length - 1; !row && j >= 0; j--) {
      if (onSameRow(container.rows[j], event)) {
        row = container.rows[j];
      }
    }

    if (row) {
      // Found a row, so add it.
      row.leaves.push(event);
      event.row = row;
    } else {
      // Couldn't find a row – that means this event is a row.
      event.leaves = [];
      container.rows.push(event);
    }
  };

  for (var i = 0; i < eventsInRenderOrder.length; i++) {
    var _ret = _loop(i);

    if (_ret === 'continue') continue;
  }

  // Return the original events, along with their styles.
  return eventsInRenderOrder.map(function (event) {
    return {
      event: event.data,
      style: {
        top: event.top,
        height: event.height,
        width: event.width,
        xOffset: event.xOffset
      }
    };
  });
}

exports.getStyledEvents = getStyledEvents;

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2295);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2297);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(463);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(465);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement('div', { className: classNames.caption, role: 'heading' }, _react2.default.createElement('div', { onClick: onClick, onKeyUp: this.handleKeyUp }, months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
    }
  }]);

  return Caption;
}(_react.Component);

Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
Caption.propTypes =  false ? {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
} : {};
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(288);

var _Helpers = __webpack_require__(462);

var _classNames = __webpack_require__(464);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;

      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement('div', {
        className: className,
        tabIndex: tabIndex,
        style: style,
        role: 'gridcell',
        'aria-label': ariaLabel,
        'aria-disabled': ariaDisabled,
        'aria-selected': ariaSelected,
        onClick: handleEvent(onClick, day, modifiers),
        onKeyDown: handleEvent(onKeyDown, day, modifiers),
        onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
        onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
        onMouseUp: handleEvent(onMouseUp, day, modifiers),
        onMouseDown: handleEvent(onMouseDown, day, modifiers),
        onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
        onTouchStart: handleEvent(onTouchStart, day, modifiers),
        onFocus: handleEvent(onFocus, day, modifiers)
      }, children);
    }
  }]);

  return Day;
}(_react.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
Day.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
} : {};
//# sourceMappingURL=Day.js.map

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(2298);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(1218);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(2301);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(1219);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(462);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(288);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(463);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(688);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(464);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(465);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          _this.showPreviousMonth();
          break;
        case _keys.RIGHT:
          _this.showNextMonth();
          break;
        case _keys.UP:
          _this.showPreviousYear();
          break;
        case _keys.DOWN:
          _this.showNextYear();
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();
      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          _this.focusPreviousDay(e.target);
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          _this.focusNextDay(e.target);
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }

    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */

  }, {
    key: 'getCurrentMonthFromProps',
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement('div', { className: this.props.classNames.footer }, this.renderTodayButton());
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement('button', {
        type: 'button',
        tabIndex: 0,
        className: this.props.classNames.todayButton,
        'aria-label': this.props.todayButton,
        onClick: this.handleTodayButtonClick
      }, this.props.todayButton);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement('div', _extends({}, this.props.containerProps, {
        className: className,
        ref: function ref(el) {
          return _this7.dayPicker = el;
        },
        lang: this.props.locale
      }), _react2.default.createElement('div', {
        className: this.props.classNames.wrapper,
        tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
        onKeyDown: this.handleKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur
      }, this.renderNavbar(), _react2.default.createElement('div', { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '7.2.4';
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.propTypes =  false ? {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
} : {};

DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(2303);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(2299);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(465);

var _ModifiersUtils = __webpack_require__(688);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(462);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(288);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(_Day2.default, {
        key: '' + (isOutside ? 'outside-' : '') + key,
        classNames: _this.props.classNames,
        day: day,
        modifiers: modifiers,
        modifiersStyles: _this.props.modifiersStyles,
        empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
        tabIndex: tabIndex,
        ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
        ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
        ariaSelected: dayModifiers.indexOf('selected') > -1,
        onClick: _this.props.onDayClick,
        onFocus: _this.props.onDayFocus,
        onKeyDown: _this.props.onDayKeyDown,
        onMouseEnter: _this.props.onDayMouseEnter,
        onMouseLeave: _this.props.onDayMouseLeave,
        onMouseDown: _this.props.onDayMouseDown,
        onMouseUp: _this.props.onDayMouseUp,
        onTouchEnd: _this.props.onDayTouchEnd,
        onTouchStart: _this.props.onDayTouchStart
      }, _this.props.renderDay(day, modifiers));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;

      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement('div', { className: classNames.month, role: 'grid' }, caption, showWeekDays && _react2.default.createElement(_Weekdays2.default, {
        classNames: classNames,
        weekdaysShort: weekdaysShort,
        weekdaysLong: weekdaysLong,
        firstDayOfWeek: firstDayOfWeek,
        showWeekNumbers: showWeekNumbers,
        locale: locale,
        localeUtils: localeUtils,
        weekdayElement: weekdayElement
      }), _react2.default.createElement('div', { className: classNames.body, role: 'rowgroup' }, weeks.map(function (week) {
        var weekNumber = void 0;
        if (showWeekNumbers) {
          weekNumber = DateUtils.getWeekNumber(week[6]);
        }
        return _react2.default.createElement('div', {
          key: week[0].getTime(),
          className: classNames.week,
          role: 'row'
        }, showWeekNumbers && _react2.default.createElement('div', {
          className: classNames.weekNumber,
          tabIndex: 0,
          role: 'gridcell',
          onClick: onWeekClick ? function (e) {
            return onWeekClick(weekNumber, week, e);
          } : undefined,
          onKeyUp: onWeekClick ? function (e) {
            return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
          } : undefined
        }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
      })));
    }
  }]);

  return Month;
}(_react.Component);

exports.default = Month;
Month.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=Month.js.map

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PrimitiveTypes = {
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement('div', { className: classNames.weekdays, role: 'rowgroup' }, _react2.default.createElement('div', { className: classNames.weekdaysRow, role: 'row' }, showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }), days));
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
} : {};
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.1
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var p = __webpack_require__(169),
    q = __webpack_require__(0);function aa(a, b, d, c, k, f, h, l) {
  if (!a) {
    a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var D = [d, c, k, f, h, l],
          z = 0;a = Error(b.replace(/%s/g, function () {
        return D[z++];
      }));a.name = "Invariant Violation";
    }a.framesToPop = 1;throw a;
  }
}
function r(a) {
  for (var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {
    d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
  }aa(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
}
var x = "function" === typeof Symbol && Symbol.for,
    y = x ? Symbol.for("react.portal") : 60106,
    A = x ? Symbol.for("react.fragment") : 60107,
    B = x ? Symbol.for("react.strict_mode") : 60108,
    C = x ? Symbol.for("react.profiler") : 60114,
    E = x ? Symbol.for("react.provider") : 60109,
    F = x ? Symbol.for("react.context") : 60110,
    G = x ? Symbol.for("react.async_mode") : 60111,
    H = x ? Symbol.for("react.forward_ref") : 60112,
    ba = x ? Symbol.for("react.placeholder") : 60113;
function I(a) {
  if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case G:
      return "AsyncMode";case A:
      return "Fragment";case y:
      return "Portal";case C:
      return "Profiler";case B:
      return "StrictMode";case ba:
      return "Placeholder";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    switch (a.$$typeof) {case F:
        return "Context.Consumer";case E:
        return "Context.Provider";case H:
        var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");}if ("function" === typeof a.then && (a = 1 === a._reactStatus ? a._reactResult : null)) return I(a);
  }return null;
}var ca = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    J = Object.prototype.hasOwnProperty,
    K = {},
    L = {};
function M(a) {
  if (J.call(L, a)) return !0;if (J.call(K, a)) return !1;if (ca.test(a)) return L[a] = !0;K[a] = !0;return !1;
}function da(a, b, d, c) {
  if (null !== d && 0 === d.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
      return !0;case "boolean":
      if (c) return !1;if (null !== d) return !d.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}
function ea(a, b, d, c) {
  if (null === b || "undefined" === typeof b || da(a, b, d, c)) return !0;if (c) return !1;if (null !== d) switch (d.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}function N(a, b, d, c, k) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = c;this.attributeNamespace = k;this.mustUseProperty = d;this.propertyName = a;this.type = b;
}var O = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  O[a] = new N(a, 0, !1, a, null);
});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];O[b] = new N(b, 1, !1, a[1], null);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  O[a] = new N(a, 2, !1, a.toLowerCase(), null);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  O[a] = new N(a, 2, !1, a, null);
});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  O[a] = new N(a, 3, !1, a.toLowerCase(), null);
});["checked", "multiple", "muted", "selected"].forEach(function (a) {
  O[a] = new N(a, 3, !0, a, null);
});
["capture", "download"].forEach(function (a) {
  O[a] = new N(a, 4, !1, a, null);
});["cols", "rows", "size", "span"].forEach(function (a) {
  O[a] = new N(a, 6, !1, a, null);
});["rowSpan", "start"].forEach(function (a) {
  O[a] = new N(a, 5, !1, a.toLowerCase(), null);
});var P = /[\-:]([a-z])/g;function Q(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(P, Q);O[b] = new N(b, 1, !1, a, null);
});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(P, Q);O[b] = new N(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(P, Q);O[b] = new N(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});O.tabIndex = new N("tabIndex", 1, !1, "tabindex", null);var fa = /["'&<>]/;
function R(a) {
  if ("boolean" === typeof a || "number" === typeof a) return "" + a;a = "" + a;var b = fa.exec(a);if (b) {
    var d = "",
        c,
        k = 0;for (c = b.index; c < a.length; c++) {
      switch (a.charCodeAt(c)) {case 34:
          b = "&quot;";break;case 38:
          b = "&amp;";break;case 39:
          b = "&#x27;";break;case 60:
          b = "&lt;";break;case 62:
          b = "&gt;";break;default:
          continue;}k !== c && (d += a.substring(k, c));k = c + 1;d += b;
    }a = k !== c ? d + a.substring(k, c) : d;
  }return a;
}var S = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function T(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}
var U = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 },
    ha = p({ menuitem: !0 }, U),
    V = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridArea: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0,
  gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    ia = ["Webkit", "ms", "Moz", "O"];Object.keys(V).forEach(function (a) {
  ia.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);V[b] = V[a];
  });
});
var ja = /([A-Z])/g,
    ka = /^ms-/,
    W = q.Children.toArray,
    la = { listing: !0, pre: !0, textarea: !0 },
    ma = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
    X = {},
    Y = {};function na(a) {
  if (void 0 === a || null === a) return a;var b = "";q.Children.forEach(a, function (a) {
    null != a && (b += a);
  });return b;
}var Z = {};function oa(a, b) {
  if (a = a.contextTypes) {
    var d = {},
        c;for (c in a) {
      d[c] = b[c];
    }b = d;
  } else b = Z;return b;
}var pa = Object.prototype.hasOwnProperty,
    qa = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
function ra(a, b) {
  void 0 === a && r("152", I(b) || "Component");
}
function sa(a, b) {
  function d(c, k) {
    var d = oa(k, b),
        f = [],
        h = !1,
        g = { isMounted: function isMounted() {
        return !1;
      }, enqueueForceUpdate: function enqueueForceUpdate() {
        if (null === f) return null;
      }, enqueueReplaceState: function enqueueReplaceState(a, b) {
        h = !0;f = [b];
      }, enqueueSetState: function enqueueSetState(a, b) {
        if (null === f) return null;f.push(b);
      } },
        e = void 0;if (k.prototype && k.prototype.isReactComponent) {
      if (e = new k(c.props, d, g), "function" === typeof k.getDerivedStateFromProps) {
        var v = k.getDerivedStateFromProps.call(null, c.props, e.state);null != v && (e.state = p({}, e.state, v));
      }
    } else if (e = k(c.props, d, g), null == e || null == e.render) {
      a = e;ra(a, k);return;
    }e.props = c.props;e.context = d;e.updater = g;g = e.state;void 0 === g && (e.state = g = null);if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) if ("function" === typeof e.componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), f.length) {
      g = f;var t = h;f = null;h = !1;if (t && 1 === g.length) e.state = g[0];else {
        v = t ? g[0] : e.state;var m = !0;for (t = t ? 1 : 0; t < g.length; t++) {
          var n = g[t];n = "function" === typeof n ? n.call(e, v, c.props, d) : n;null != n && (m ? (m = !1, v = p({}, v, n)) : p(v, n));
        }e.state = v;
      }
    } else f = null;a = e.render();ra(a, k);c = void 0;if ("function" === typeof e.getChildContext && (d = k.childContextTypes, "object" === (typeof d === "undefined" ? "undefined" : _typeof(d)))) {
      c = e.getChildContext();for (var w in c) {
        w in d ? void 0 : r("108", I(k) || "Unknown", w);
      }
    }c && (b = p({}, b, c));
  }for (; q.isValidElement(a);) {
    var c = a,
        k = c.type;if ("function" !== typeof k) break;d(c, k);
  }return { child: a,
    context: b };
}
var ta = function () {
  function a(b, d) {
    if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");q.isValidElement(b) ? b.type !== A ? b = [b] : (b = b.props.children, b = q.isValidElement(b) ? [b] : W(b)) : b = W(b);this.stack = [{ type: null, domNamespace: S.html, children: b, childIndex: 0, context: Z, footer: "" }];this.exhausted = !1;this.currentSelectValue = null;this.previousWasTextNode = !1;this.makeStaticMarkup = d;this.contextIndex = -1;this.contextStack = [];this.contextValueStack = [];
  }a.prototype.pushProvider = function (a) {
    var b = ++this.contextIndex,
        c = a.type._context,
        k = c._currentValue;this.contextStack[b] = c;this.contextValueStack[b] = k;c._currentValue = a.props.value;
  };a.prototype.popProvider = function () {
    var a = this.contextIndex,
        d = this.contextStack[a],
        c = this.contextValueStack[a];this.contextStack[a] = null;this.contextValueStack[a] = null;this.contextIndex--;d._currentValue = c;
  };a.prototype.read = function (a) {
    if (this.exhausted) return null;for (var b = ""; b.length < a;) {
      if (0 === this.stack.length) {
        this.exhausted = !0;break;
      }var c = this.stack[this.stack.length - 1];if (c.childIndex >= c.children.length) {
        var k = c.footer;b += k;"" !== k && (this.previousWasTextNode = !1);this.stack.pop();"select" === c.type ? this.currentSelectValue = null : null != c.type && null != c.type.type && c.type.type.$$typeof === E && this.popProvider(c.type);
      } else k = c.children[c.childIndex++], b += this.render(k, c.context, c.domNamespace);
    }return b;
  };a.prototype.render = function (a, d, c) {
    if ("string" === typeof a || "number" === typeof a) {
      c = "" + a;if ("" === c) return "";if (this.makeStaticMarkup) return R(c);if (this.previousWasTextNode) return "\x3c!-- --\x3e" + R(c);this.previousWasTextNode = !0;return R(c);
    }d = sa(a, d);a = d.child;d = d.context;if (null === a || !1 === a) return "";if (!q.isValidElement(a)) {
      if (null != a && null != a.$$typeof) {
        var b = a.$$typeof;b === y ? r("257") : void 0;r("258", b.toString());
      }a = W(a);this.stack.push({ type: null, domNamespace: c, children: a, childIndex: 0, context: d, footer: "" });return "";
    }b = a.type;if ("string" === typeof b) return this.renderDOM(a, d, c);switch (b) {case B:case G:case C:case A:
        return a = W(a.props.children), this.stack.push({ type: null, domNamespace: c, children: a,
          childIndex: 0, context: d, footer: "" }), "";}if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) switch (b.$$typeof) {case H:
        return a = W(b.render(a.props, a.ref)), this.stack.push({ type: null, domNamespace: c, children: a, childIndex: 0, context: d, footer: "" }), "";case E:
        return b = W(a.props.children), c = { type: a, domNamespace: c, children: b, childIndex: 0, context: d, footer: "" }, this.pushProvider(a), this.stack.push(c), "";case F:
        return b = W(a.props.children(a.type._currentValue)), this.stack.push({ type: a, domNamespace: c, children: b, childIndex: 0, context: d,
          footer: "" }), "";}r("130", null == b ? b : typeof b === "undefined" ? "undefined" : _typeof(b), "");
  };a.prototype.renderDOM = function (a, d, c) {
    var b = a.type.toLowerCase();c === S.html && T(b);X.hasOwnProperty(b) || (ma.test(b) ? void 0 : r("65", b), X[b] = !0);var f = a.props;if ("input" === b) f = p({ type: void 0 }, f, { defaultChecked: void 0, defaultValue: void 0, value: null != f.value ? f.value : f.defaultValue, checked: null != f.checked ? f.checked : f.defaultChecked });else if ("textarea" === b) {
      var h = f.value;if (null == h) {
        h = f.defaultValue;var l = f.children;null != l && (null != h ? r("92") : void 0, Array.isArray(l) && (1 >= l.length ? void 0 : r("93"), l = l[0]), h = "" + l);null == h && (h = "");
      }f = p({}, f, { value: void 0, children: "" + h });
    } else if ("select" === b) this.currentSelectValue = null != f.value ? f.value : f.defaultValue, f = p({}, f, { value: void 0 });else if ("option" === b) {
      l = this.currentSelectValue;var D = na(f.children);if (null != l) {
        var z = null != f.value ? f.value + "" : D;h = !1;if (Array.isArray(l)) for (var g = 0; g < l.length; g++) {
          if ("" + l[g] === z) {
            h = !0;break;
          }
        } else h = "" + l === z;f = p({ selected: void 0, children: void 0 }, f, { selected: h, children: D });
      }
    }if (h = f) ha[b] && (null != h.children || null != h.dangerouslySetInnerHTML ? r("137", b, "") : void 0), null != h.dangerouslySetInnerHTML && (null != h.children ? r("60") : void 0, "object" === _typeof(h.dangerouslySetInnerHTML) && "__html" in h.dangerouslySetInnerHTML ? void 0 : r("61")), null != h.style && "object" !== _typeof(h.style) ? r("62", "") : void 0;h = f;l = this.makeStaticMarkup;D = 1 === this.stack.length;z = "<" + a.type;for (u in h) {
      if (pa.call(h, u)) {
        var e = h[u];if (null != e) {
          if ("style" === u) {
            g = void 0;var v = "",
                t = "";for (g in e) {
              if (e.hasOwnProperty(g)) {
                var m = 0 === g.indexOf("--"),
                    n = e[g];if (null != n) {
                  var w = g;if (Y.hasOwnProperty(w)) w = Y[w];else {
                    var xa = w.replace(ja, "-$1").toLowerCase().replace(ka, "-ms-");w = Y[w] = xa;
                  }v += t + w + ":";t = g;m = null == n || "boolean" === typeof n || "" === n ? "" : m || "number" !== typeof n || 0 === n || V.hasOwnProperty(t) && V[t] ? ("" + n).trim() : n + "px";v += m;t = ";";
                }
              }
            }e = v || null;
          }g = null;b: if (m = b, n = h, -1 === m.indexOf("-")) m = "string" === typeof n.is;else switch (m) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
              m = !1;break b;default:
              m = !0;}if (m) qa.hasOwnProperty(u) || (g = u, g = M(g) && null != e ? g + "=" + ('"' + R(e) + '"') : "");else {
            m = u;g = e;e = O.hasOwnProperty(m) ? O[m] : null;if (n = "style" !== m) n = null !== e ? 0 === e.type : !(2 < m.length) || "o" !== m[0] && "O" !== m[0] || "n" !== m[1] && "N" !== m[1] ? !1 : !0;n || ea(m, g, e, !1) ? g = "" : null !== e ? (m = e.attributeName, e = e.type, g = 3 === e || 4 === e && !0 === g ? m + '=""' : m + "=" + ('"' + R(g) + '"')) : g = M(m) ? m + "=" + ('"' + R(g) + '"') : "";
          }g && (z += " " + g);
        }
      }
    }l || D && (z += ' data-reactroot=""');var u = z;h = "";U.hasOwnProperty(b) ? u += "/>" : (u += ">", h = "</" + a.type + ">");a: {
      l = f.dangerouslySetInnerHTML;if (null != l) {
        if (null != l.__html) {
          l = l.__html;break a;
        }
      } else if (l = f.children, "string" === typeof l || "number" === typeof l) {
        l = R(l);break a;
      }l = null;
    }null != l ? (f = [], la[b] && "\n" === l.charAt(0) && (u += "\n"), u += l) : f = W(f.children);a = a.type;c = null == c || "http://www.w3.org/1999/xhtml" === c ? T(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;this.stack.push({ domNamespace: c, type: b, children: f, childIndex: 0, context: d, footer: h });this.previousWasTextNode = !1;return u;
  };return a;
}(),
    ua = { renderToString: function renderToString(a) {
    return new ta(a, !1).read(Infinity);
  }, renderToStaticMarkup: function renderToStaticMarkup(a) {
    return new ta(a, !0).read(Infinity);
  }, renderToNodeStream: function renderToNodeStream() {
    r("207");
  }, renderToStaticNodeStream: function renderToStaticNodeStream() {
    r("208");
  }, version: "16.5.1" },
    va = { default: ua },
    wa = va && ua || va;module.exports = wa.default || wa;

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2304);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCharsRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultMaskChar; });
var defaultCharsRules = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};

var defaultMaskChar = '_';

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (fn) {
            var defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function () {
                        return setTimeout(fn, 0);
            };

            return defer(fn);
});

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAndroidBrowser;
/* harmony export (immutable) */ __webpack_exports__["b"] = isWindowsPhoneBrowser;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAndroidFirefox;
/* unused harmony export isIOS */
function isAndroidBrowser() {
  var windows = new RegExp('windows', 'i');
  var firefox = new RegExp('firefox', 'i');
  var android = new RegExp('android', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
}

function isWindowsPhoneBrowser() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}

function isAndroidFirefox() {
  var windows = new RegExp('windows', 'i');
  var firefox = new RegExp('firefox', 'i');
  var android = new RegExp('android', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && firefox.test(ua) && android.test(ua);
}

function isIOS() {
  var windows = new RegExp('windows', 'i');
  var ios = new RegExp('(ipod|iphone|ipad)', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && ios.test(ua);
}

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2306);


/* harmony default export */ __webpack_exports__["a"] = (function (mask, maskChar, charsRules) {
  if (maskChar === undefined) {
    maskChar = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* defaultMaskChar */];
  }
  if (charsRules == null) {
    charsRules = __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* defaultCharsRules */];
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      charsRules: charsRules,
      mask: null,
      prefix: null,
      lastEditablePos: null,
      permanents: []
    };
  }
  var str = '';
  var prefix = '';
  var permanents = [];
  var isPermanent = false;
  var lastEditablePos = null;

  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !charsRules[character]) {
        permanents.push(str.length);
        if (str.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePos = str.length + 1;
      }
      str += character;
      isPermanent = false;
    }
  });

  return {
    maskChar: maskChar,
    charsRules: charsRules,
    prefix: prefix,
    mask: str,
    lastEditablePos: lastEditablePos,
    permanents: permanents
  };
});

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = isPermanentChar;
/* unused harmony export isAllowedChar */
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFilledLength;
/* harmony export (immutable) */ __webpack_exports__["c"] = isFilled;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearRange;
/* harmony export (immutable) */ __webpack_exports__["g"] = insertString;
/* harmony export (immutable) */ __webpack_exports__["h"] = getInsertStringLength;
function isPermanentChar(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}

function isAllowedChar(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      charsRules = maskOptions.charsRules;

  if (!character) {
    return false;
  }

  if (isPermanentChar(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = charsRules[ruleChar];

  return new RegExp(charRule).test(character);
}

function isEmpty(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentChar(maskOptions, i) || !isAllowedChar(maskOptions, i, character);
  });
}

function getFilledLength(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentChar(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }
    return value.length;
  }

  var filledLength = prefix.length;
  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentChar(maskOptions, i) && isAllowedChar(maskOptions, i, character);
    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}

function isFilled(maskOptions, value) {
  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
}

function formatValue(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString(maskOptions, '', value, 0);
    value = value.slice(0, getFilledLength(maskOptions, value));

    if (value.length < prefix.length) {
      value = prefix;
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue(maskOptions, '');
    return insertString(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentChar(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}

function clearRange(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  var arrayValue = value.split('');

  if (!maskChar) {
    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');

    return formatValue(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }
    if (isPermanentChar(maskOptions, i)) {
      return mask[i];
    }
    return maskChar;
  }).join('');
}

function insertString(maskOptions, value, insertStr, insertPos) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
  };
  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentChar(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPos > value.length) {
    value += mask.slice(value.length, insertPos);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPos, insertCharacter)) {
      if (insertPos >= value.length) {
        value += mask[insertPos];
      }

      if (!isUsableCharacter(insertCharacter, insertPos)) {
        return true;
      }

      insertPos++;

      // stop iteration if maximum value length reached
      if (insertPos >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;
    if (!isAllowed) {
      return true;
    }

    if (insertPos < value.length) {
      if (maskChar || isInputFilled || insertPos < prefix.length) {
        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos + 1);
      } else {
        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos);
        value = formatValue(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPos++;

    // stop iteration if maximum value length reached
    return insertPos < mask.length;
  });

  return value;
}

function getInsertStringLength(maskOptions, value, insertStr, insertPos) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;

  var arrayInsertStr = insertStr.split('');
  var initialInsertPos = insertPos;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPos, insertCharacter)) {
      insertPos++;

      // stop iteration if maximum value length reached
      if (insertPos >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPos++;
    }

    // stop iteration if maximum value length reached
    return insertPos < mask.length;
  });

  return insertPos - initialInsertPos;
}

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: !0 });
var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.fundamental") : 60117,
    w = b ? Symbol.for("react.responder") : 60118,
    x = b ? Symbol.for("react.scope") : 60119;function y(a) {
  if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) {
    var u = a.$$typeof;switch (u) {case c:
        switch (a = a.type, a) {case l:case m:case e:case g:case f:case p:
            return a;default:
            switch (a = a && a.$$typeof, a) {case k:case n:case t:case r:case h:
                return a;default:
                return u;}}case d:
        return u;}
  }
}function z(a) {
  return y(a) === m;
}
exports.typeOf = y;exports.AsyncMode = l;exports.ConcurrentMode = m;exports.ContextConsumer = k;exports.ContextProvider = h;exports.Element = c;exports.ForwardRef = n;exports.Fragment = e;exports.Lazy = t;exports.Memo = r;exports.Portal = d;exports.Profiler = g;exports.StrictMode = f;exports.Suspense = p;
exports.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
};exports.isAsyncMode = function (a) {
  return z(a) || y(a) === l;
};exports.isConcurrentMode = z;exports.isContextConsumer = function (a) {
  return y(a) === k;
};exports.isContextProvider = function (a) {
  return y(a) === h;
};
exports.isElement = function (a) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === c;
};exports.isForwardRef = function (a) {
  return y(a) === n;
};exports.isFragment = function (a) {
  return y(a) === e;
};exports.isLazy = function (a) {
  return y(a) === t;
};exports.isMemo = function (a) {
  return y(a) === r;
};exports.isPortal = function (a) {
  return y(a) === d;
};exports.isProfiler = function (a) {
  return y(a) === g;
};exports.isStrictMode = function (a) {
  return y(a) === f;
};exports.isSuspense = function (a) {
  return y(a) === p;
};

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2311);
} else {
  module.exports = require('./cjs/react-is.development.js');
}

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContentRect", function() { return withContentRect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_resize_observer_polyfill__ = __webpack_require__(2479);







var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}

function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }

  return calculations;
}

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithContentRect, _Component);

      function WithContentRect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;

        _this.measure = function (entries) {
          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this._animationFrameID = window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });
            }
          });

          if (typeof _this.props.onResize === 'function') {
            _this.props.onResize(contentRect);
          }
        };

        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.unobserve(_this._node);
          }

          _this._node = node;

          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.observe(_this._node);
          }

          var innerRef = _this.props.innerRef;

          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(_this._node);
            } else {
              innerRef.current = _this._node;
            }
          }
        };

        return _this;
      }

      var _proto = WithContentRect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = new __WEBPACK_IMPORTED_MODULE_5_resize_observer_polyfill__["a" /* default */](this.measure);

        if (this._node !== null) {
          this._resizeObserver.observe(this._node);
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();

          this._resizeObserver = null;
        }

        window.cancelAnimationFrame(this._animationFrameID);
      };

      _proto.render = function render() {
        var _this$props = this.props,
            innerRef = _this$props.innerRef,
            onResize = _this$props.onResize,
            props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "onResize"]);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(WrappedComponent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };

      return WithContentRect;
    }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class.propTypes = {
      client: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      scroll: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      bounds: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      margin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
      onResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
    }, _temp;
  };
}

var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func;

/* harmony default export */ __webpack_exports__["default"] = (Measure);


/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _mapToZero = __webpack_require__(691);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(467);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(693);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(669);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(678);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(692);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(694);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
}(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _mapToZero = __webpack_require__(691);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(467);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(693);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(669);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(678);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(692);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(694);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
}(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _mapToZero = __webpack_require__(691);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(467);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(693);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(2320);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(669);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(678);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(692);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(694);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
}(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports['default'] = spring;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _presets = __webpack_require__(1222);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2324);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.returnTrue = returnTrue;
exports.charIsNumber = charIsNumber;
exports.escapeRegExp = escapeRegExp;
exports.splitDecimal = splitDecimal;
exports.fixLeadingZero = fixLeadingZero;
exports.limitToScale = limitToScale;
exports.roundToPrecision = roundToPrecision;
exports.omit = omit;
exports.setCaretPosition = setCaretPosition;
exports.findChangedIndex = findChangedIndex;
exports.clamp = clamp;

// basic noop function
function noop() {}
function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr) {
  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation
  };
}

function fixLeadingZero(numStr) {
  if (!numStr) return numStr;
  var isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return '' + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? '.' + afterDecimal : '');
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr, scale, fixedDecimalScale) {
  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;

  var _splitDecimal = splitDecimal(numStr),
      beforeDecimal = _splitDecimal.beforeDecimal,
      afterDecimal = _splitDecimal.afterDecimal,
      hasNagation = _splitDecimal.hasNagation;

  var roundedDecimalParts = parseFloat('0.' + (afterDecimal || '0')).toFixed(scale).split('.');
  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }
    return current + roundedStr;
  }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(roundedDecimalParts[1] || '', (afterDecimal || '').length, fixedDecimalScale);
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return '' + negation + intPart + decimalSeparator + decimalPart;
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  Object.keys(obj).forEach(function (key) {
    if (!keyMaps[key]) filteredObj[key] = obj[key];
  });
  return filteredObj;
}

/** set the caret positon in an input field **/
function setCaretPosition(el, caretPos) {
  el.value = el.value;
  // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue, newValue) {
  var i = 0,
      j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  } //check what has been changed from last
  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(2326);
var invariant = __webpack_require__(2327);
var ReactPropTypesSecret = __webpack_require__(2330);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2328)();
}

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(347);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(676);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(695);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(346);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(347);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(1174);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(2333);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(2334);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(2335);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(_Position2.default, { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition }, child);

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(Transition, {
        'in': props.show,
        transitionAppear: true,
        onExit: onExit,
        onExiting: onExiting,
        onExited: this.onHiddenListener,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
      }, child);
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(_RootCloseWrapper2.default, { onRootClose: props.onHide }, child);
    }

    return _react2.default.createElement(_Portal2.default, { container: container }, child);
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },

  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(347);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(676);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(695);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(346);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(2331);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _classnames = __webpack_require__(28);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(347);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(676);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(2337);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(695);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(346);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _contains = __webpack_require__(1223);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(347);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(2336);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(346);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(2339);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(2338);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = exports['default'];

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(1224);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(2341);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(1225);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(346);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(469);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(469);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(696);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(1226);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = position;

var _offset = __webpack_require__(1224);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(2340);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(1225);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(2342);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(1226);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(697);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(1227);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(469);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;

  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};

function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(2348);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2351);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1228);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1228);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* setRef */])(_this.props.innerRef, node);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(2353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* unused harmony reexport Manager */
/* unused harmony reexport Reference */
// Public components



 // Public types

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var objectKeys = __webpack_require__(1172);
var isArguments = __webpack_require__(2032);
var is = __webpack_require__(2185);
var isRegex = __webpack_require__(2034);
var flags = __webpack_require__(2477);
var isDate = __webpack_require__(2033);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual === 'undefined' ? 'undefined' : _typeof(actual)) !== 'object' && (typeof expected === 'undefined' ? 'undefined' : _typeof(expected)) !== 'object') {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
    return false;
  }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) {
    return false;
  }

  if (isArguments(a) !== isArguments(b)) {
    return false;
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
    return false;
  }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }

  return true;
}

module.exports = deepEqual;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(699);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(699);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(44);
var createClass = __webpack_require__(274);
var QuillMixin = __webpack_require__(1229);
var find = __webpack_require__(662);
var some = __webpack_require__(2173);
var isEqual = __webpack_require__(663);
var T = __webpack_require__(1230);
var DOM = __webpack_require__(1220);

var QuillComponent = createClass({

	displayName: 'Quill',

	mixins: [QuillMixin],

	propTypes: {
		id: T.string,
		className: T.string,
		theme: T.string,
		style: T.object,
		readOnly: T.bool,
		value: T.oneOfType([T.string, T.shape({ ops: T.array })]),
		defaultValue: T.oneOfType([T.string, T.shape({ ops: T.array })]),
		placeholder: T.string,
		tabIndex: T.number,
		bounds: T.oneOfType([T.string, T.element]),
		onChange: T.func,
		onChangeSelection: T.func,
		onFocus: T.func,
		onBlur: T.func,
		onKeyPress: T.func,
		onKeyDown: T.func,
		onKeyUp: T.func,
		preserveWhitespace: T.bool,

		modules: function modules(props) {
			var isNotObject = T.object.apply(this, arguments);
			if (isNotObject) return isNotObject;

			if (props.modules && props.modules.toolbar && props.modules.toolbar[0] && props.modules.toolbar[0].type) return new Error('Since v1.0.0, React Quill will not create a custom toolbar for you ' + 'anymore. Create a toolbar explictly, or let Quill create one. ' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100');
		},

		toolbar: function toolbar(props) {
			if ('toolbar' in props) return new Error('The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100');
		},

		formats: function formats(props) {
			var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);

			if (isNotArrayOfString) return new Error('You cannot specify custom `formats` anymore. Use Parchment instead.  ' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.');
		},

		styles: function styles(props) {
			if ('styles' in props) return new Error('The `styles` prop has been deprecated. Use custom stylesheets instead. ' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.');
		},

		pollInterval: function pollInterval(props) {
			if ('pollInterval' in props) return new Error('The `pollInterval` property does not have any effect anymore. ' + 'You can safely remove it from your props.' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.');
		},

		children: function children(props) {
			// Validate that the editor has only one child element and it is not a <textarea>
			var isNotASingleElement = T.element.apply(this, arguments);
			if (isNotASingleElement) return new Error('The Quill editing area can only be composed of a single React element.');

			if (React.Children.count(props.children)) {
				var child = React.Children.only(props.children);
				if (child.type === 'textarea') return new Error('Quill does not support editing on a <textarea>. Use a <div> instead.');
			}
		}
	},

	/*
 Changing one of these props should cause a full re-render.
 */
	dirtyProps: ['modules', 'formats', 'bounds', 'theme', 'children'],

	/*
 Changing one of these props should cause a regular update.
 */
	cleanProps: ['id', 'className', 'style', 'placeholder', 'tabIndex', 'onChange', 'onChangeSelection', 'onFocus', 'onBlur', 'onKeyPress', 'onKeyDown', 'onKeyUp'],

	getDefaultProps: function getDefaultProps() {
		return {
			theme: 'snow',
			modules: {}
		};
	},

	/*
 We consider the component to be controlled if `value` is being sent in props.
 */
	isControlled: function isControlled() {
		return 'value' in this.props;
	},

	getInitialState: function getInitialState() {
		return {
			generation: 0,
			value: this.isControlled() ? this.props.value : this.props.defaultValue
		};
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
		var editor = this.editor;

		// If the component is unmounted and mounted too quickly
		// an error is thrown in setEditorContents since editor is
		// still undefined. Must check if editor is undefined
		// before performing this call.
		if (!editor) return;

		// Update only if we've been passed a new `value`.
		// This leaves components using `defaultValue` alone.
		if ('value' in nextProps) {
			var currentContents = this.getEditorContents();
			var nextContents = nextProps.value;

			if (nextContents === this.lastDeltaChangeSet) throw new Error('You are passing the `delta` object from the `onChange` event back ' + 'as `value`. You most probably want `editor.getContents()` instead. ' + 'See: https://github.com/zenoamaro/react-quill#using-deltas');

			// NOTE: Seeing that Quill is missing a way to prevent
			//       edits, we have to settle for a hybrid between
			//       controlled and uncontrolled mode. We can't prevent
			//       the change, but we'll still override content
			//       whenever `value` differs from current state.
			// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
			//       a change, regardless of whether they represent the same document.
			if (!this.isEqualValue(nextContents, currentContents)) {
				this.setEditorContents(editor, nextContents);
			}
		}

		// We can update readOnly state in-place.
		if ('readOnly' in nextProps) {
			if (nextProps.readOnly !== this.props.readOnly) {
				this.setEditorReadOnly(editor, nextProps.readOnly);
			}
		}

		// If we need to regenerate the component, we can avoid a detailed
		// in-place update step, and just let everything rerender.
		if (this.shouldComponentRegenerate(nextProps, nextState)) {
			return this.regenerate();
		}
	},

	componentDidMount: function componentDidMount() {
		this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
		// Restore editor from Quill's native formats in regeneration scenario
		if (this.quillDelta) {
			this.editor.setContents(this.quillDelta);
			this.editor.setSelection(this.quillSelection);
			this.editor.focus();
			this.quillDelta = this.quillSelection = null;
			return;
		}
		if (this.state.value) {
			this.setEditorContents(this.editor, this.state.value);
			return;
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		var editor;if (editor = this.getEditor()) {
			this.unhookEditor(editor);
			this.editor = null;
		}
	},

	shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		var self = this;

		// If the component has been regenerated, we already know we should update.
		if (this.state.generation !== nextState.generation) {
			return true;
		}

		// Compare props that require React updating the DOM.
		return some(this.cleanProps, function (prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	shouldComponentRegenerate: function shouldComponentRegenerate(nextProps, nextState) {
		var self = this;
		// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
		return some(this.dirtyProps, function (prop) {
			// Note that `isEqual` compares deeply, making it safe to perform
			// non-immutable updates, at the cost of performance.
			return !isEqual(nextProps[prop], self.props[prop]);
		});
	},

	/*
 If we could not update settings from the new props in-place, we have to tear
 down everything and re-render from scratch.
 */
	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (this.state.generation !== nextState.generation) {
			this.componentWillUnmount();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (this.state.generation !== prevState.generation) {
			this.componentDidMount();
		}
	},

	getEditorConfig: function getEditorConfig() {
		return {
			bounds: this.props.bounds,
			formats: this.props.formats,
			modules: this.props.modules,
			placeholder: this.props.placeholder,
			readOnly: this.props.readOnly,
			scrollingContainer: this.props.scrollingContainer,
			tabIndex: this.props.tabIndex,
			theme: this.props.theme
		};
	},

	getEditor: function getEditor() {
		return this.editor;
	},

	getEditingArea: function getEditingArea() {
		return ReactDOM.findDOMNode(this.editingArea);
	},

	getEditorContents: function getEditorContents() {
		return this.state.value;
	},

	getEditorSelection: function getEditorSelection() {
		return this.state.selection;
	},

	/*
 True if the value is a Delta instance or a Delta look-alike.
 */
	isDelta: function isDelta(value) {
		return value && value.ops;
	},

	/*
 Special comparison function that knows how to compare Deltas.
 */
	isEqualValue: function isEqualValue(value, nextValue) {
		if (this.isDelta(value) && this.isDelta(nextValue)) {
			return isEqual(value.ops, nextValue.ops);
		} else {
			return isEqual(value, nextValue);
		}
	},

	/*
 Regenerating the editor will cause the whole tree, including the container,
 to be cleaned up and re-rendered from scratch.
 */
	regenerate: function regenerate() {
		// Cache selection and contents in Quill's native format to be restored later
		this.quillDelta = this.editor.getContents();
		this.quillSelection = this.editor.getSelection();
		this.setState({
			generation: this.state.generation + 1
		});
	},

	/*
 Renders an editor area, unless it has been provided one to clone.
 */
	renderEditingArea: function renderEditingArea() {
		var self = this;
		var children = this.props.children;
		var preserveWhitespace = this.props.preserveWhitespace;

		var properties = {
			key: this.state.generation,
			tabIndex: this.props.tabIndex,
			ref: function ref(element) {
				self.editingArea = element;
			}
		};

		var customElement = React.Children.count(children) ? React.Children.only(children) : null;
		var defaultElement = preserveWhitespace ? DOM.pre : DOM.div;
		var editingArea = customElement ? React.cloneElement(customElement, properties) : defaultElement(properties);

		return editingArea;
	},

	render: function render() {
		return DOM.div({
			id: this.props.id,
			style: this.props.style,
			key: this.state.generation,
			className: ['quill'].concat(this.props.className).join(' '),
			onKeyPress: this.props.onKeyPress,
			onKeyDown: this.props.onKeyDown,
			onKeyUp: this.props.onKeyUp }, this.renderEditingArea());
	},

	onEditorChangeText: function onEditorChangeText(value, delta, source, editor) {
		var currentContents = this.getEditorContents();

		// We keep storing the same type of value as what the user gives us,
		// so that value comparisons will be more stable and predictable.
		var nextContents = this.isDelta(currentContents) ? editor.getContents() : editor.getHTML();

		if (!this.isEqualValue(nextContents, currentContents)) {
			// Taint this `delta` object, so we can recognize whether the user
			// is trying to send it back as `value`, preventing a likely loop.
			this.lastDeltaChangeSet = delta;

			this.setState({ value: nextContents });

			if (this.props.onChange) {
				this.props.onChange(value, delta, source, editor);
			}
		}
	},

	onEditorChangeSelection: function onEditorChangeSelection(nextSelection, source, editor) {
		var currentSelection = this.getEditorSelection();
		var hasGainedFocus = !currentSelection && nextSelection;
		var hasLostFocus = currentSelection && !nextSelection;

		if (isEqual(nextSelection, currentSelection)) {
			return;
		}

		this.setState({ selection: nextSelection });

		if (this.props.onChangeSelection) {
			this.props.onChangeSelection(nextSelection, source, editor);
		}

		if (hasGainedFocus && this.props.onFocus) {
			this.props.onFocus(nextSelection, source, editor);
		} else if (hasLostFocus && this.props.onBlur) {
			this.props.onBlur(currentSelection, source, editor);
		}
	},

	focus: function focus() {
		this.editor.focus();
	},

	blur: function blur() {
		this.setEditorSelection(this.editor, null);
	}

});

module.exports = QuillComponent;

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
var Quill = __webpack_require__(1176);
var Component = __webpack_require__(2359);

module.exports = Component;
module.exports.default = Component;
module.exports.Quill = Quill;
module.exports.Mixin = __webpack_require__(1229);
module.exports.Toolbar = __webpack_require__(2361);

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
QuillToolbar is deprecated. Consider switching to the official Quill
toolbar format, or providing your own toolbar instead. 
See https://quilljs.com/docs/modules/toolbar
*/



var React = __webpack_require__(0);
var ReactDOMServer = __webpack_require__(2305);
var createClass = __webpack_require__(274);
var find = __webpack_require__(662);
var isEqual = __webpack_require__(663);
var T = __webpack_require__(1230);
var DOM = __webpack_require__(1220);

var defaultColors = ['rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)', 'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)', 'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)', 'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)', 'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)', 'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)', 'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)', 'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)', 'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)', 'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)', 'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)', 'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)'].map(function (color) {
	return { value: color };
});

var defaultItems = [{ label: 'Formats', type: 'group', items: [{ label: 'Font', type: 'font', items: [{ label: 'Sans Serif', value: 'sans-serif', selected: true }, { label: 'Serif', value: 'serif' }, { label: 'Monospace', value: 'monospace' }] }, { label: 'Size', type: 'size', items: [{ label: 'Small', value: '10px' }, { label: 'Normal', value: '13px', selected: true }, { label: 'Large', value: '18px' }, { label: 'Huge', value: '32px' }] }, { label: 'Alignment', type: 'align', items: [{ label: '', value: '', selected: true }, { label: '', value: 'center' }, { label: '', value: 'right' }, { label: '', value: 'justify' }] }] }, { label: 'Text', type: 'group', items: [{ type: 'bold', label: 'Bold' }, { type: 'italic', label: 'Italic' }, { type: 'strike', label: 'Strike' }, { type: 'underline', label: 'Underline' }, { type: 'color', label: 'Color', items: defaultColors }, { type: 'background', label: 'Background color', items: defaultColors }, { type: 'link', label: 'Link' }] }, { label: 'Blocks', type: 'group', items: [{ type: 'list', value: 'bullet' }, { type: 'list', value: 'ordered' }] }, { label: 'Blocks', type: 'group', items: [{ type: 'image', label: 'Image' }] }];

var QuillToolbar = createClass({

	displayName: 'Quill Toolbar',

	propTypes: {
		id: T.string,
		className: T.string,
		style: T.object,
		items: T.array
	},

	getDefaultProps: function getDefaultProps() {
		return {
			items: defaultItems
		};
	},

	componentDidMount: function componentDidMount() {
		console.warn('QuillToolbar is deprecated. Consider switching to the official Quill ' + 'toolbar format, or providing your own toolbar instead. ' + 'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0');
	},

	shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		return !isEqual(nextProps, this.props);
	},

	renderGroup: function renderGroup(item, key) {
		return DOM.span({
			key: item.label || key,
			className: 'ql-formats' }, item.items.map(this.renderItem));
	},

	renderChoiceItem: function renderChoiceItem(item, key) {
		return DOM.option({
			key: item.label || item.value || key,
			value: item.value }, item.label);
	},

	renderChoices: function renderChoices(item, key) {
		var choiceItems = item.items.map(this.renderChoiceItem);
		var selectedItem = find(item.items, function (item) {
			return item.selected;
		});
		var attrs = {
			key: item.label || key,
			title: item.label,
			className: 'ql-' + item.type,
			value: selectedItem.value
		};
		return DOM.select(attrs, choiceItems);
	},

	renderButton: function renderButton(item, key) {
		return DOM.button({
			type: 'button',
			key: item.label || item.value || key,
			value: item.value,
			className: 'ql-' + item.type,
			title: item.label }, item.children);
	},

	renderAction: function renderAction(item, key) {
		return DOM.button({
			key: item.label || item.value || key,
			className: 'ql-' + item.type,
			title: item.label }, item.children);
	},

	/* jshint maxcomplexity: false */
	renderItem: function renderItem(item, key) {
		switch (item.type) {
			case 'group':
				return this.renderGroup(item, key);
			case 'font':
			case 'header':
			case 'align':
			case 'size':
			case 'color':
			case 'background':
				return this.renderChoices(item, key);
			case 'bold':
			case 'italic':
			case 'underline':
			case 'strike':
			case 'link':
			case 'list':
			case 'bullet':
			case 'ordered':
			case 'indent':
			case 'image':
			case 'video':
				return this.renderButton(item, key);
			default:
				return this.renderAction(item, key);
		}
	},

	getClassName: function getClassName() {
		return 'quill-toolbar ' + (this.props.className || '');
	},

	render: function render() {
		var children = this.props.items.map(this.renderItem);
		var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
		return DOM.div({
			id: this.props.id,
			className: this.getClassName(),
			style: this.props.style,
			dangerouslySetInnerHTML: { __html: html }
		});
	}

});

module.exports = QuillToolbar;
QuillToolbar.defaultItems = defaultItems;
QuillToolbar.defaultColors = defaultColors;

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2363);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(701);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(2369);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(1232);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && (typeof mapDispatchToProps === 'undefined' ? 'undefined' : _typeof(mapDispatchToProps)) === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(1232);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1234);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(2370);
function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(701);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.hoistNonReactStatics = factory();
})(this, function () {
    'use strict';

    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };

    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };

    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components

            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }

            var keys = getOwnPropertyNames(sourceComponent);

            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }

            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try {
                        // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }

            return targetComponent;
        }

        return targetComponent;
    };
});

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(2373);
var invariant = __webpack_require__(2374);
var ReactPropTypesSecret = __webpack_require__(2377);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _objectWithoutProperties3 = _interopRequireDefault(__webpack_require__(145));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

var _possibleConstructorReturn3 = _interopRequireDefault(__webpack_require__(41));

var _inherits3 = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 * Composes a React component class, returning a new class that intercepts
 * props, resolving them with the provided fragments and subscribing for
 * updates.
 */
function createContainerWithFragments(Component, fragments) {
  var containerName = __webpack_require__(154).getContainerName(Component);

  var Container = function (_React$Component) {
    (0, _inherits3['default'])(Container, _React$Component);

    function Container(props, context) {
      (0, _classCallCheck3['default'])(this, Container);

      var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

      _this._handleFragmentDataUpdate = function () {
        var profiler = __webpack_require__(9).RelayProfiler.profile('ReactRelayFragmentContainer.handleFragmentDataUpdate');
        var resolverFromThisUpdate = _this.state.resolver;
        _this.setState(function (updatedState) {
          // If this event belongs to the current data source, update.
          // Otherwise we should ignore it.
          if (resolverFromThisUpdate === updatedState.resolver) {
            return {
              data: updatedState.resolver.resolve(),
              relayProp: {
                isLoading: updatedState.resolver.isLoading(),
                environment: updatedState.relayProp.environment
              }
            };
          }

          return null;
        }, profiler.stop);
      };

      var relay = __webpack_require__(126).assertRelayContext(context.relay);
      var createFragmentSpecResolver = relay.environment.unstable_internal.createFragmentSpecResolver;
      // Do not provide a subscription/callback here.
      // It is possible for this render to be interrupted or aborted,
      // In which case the subscription would cause a leak.
      // We will add the subscription in componentDidMount().

      var resolver = createFragmentSpecResolver(relay, containerName, fragments, props);
      _this.state = {
        data: resolver.resolve(),
        relay: relay,
        relayEnvironment: context.relay.environment,
        prevProps: _this.props,
        relayVariables: context.relay.variables,
        relayProp: {
          isLoading: resolver.isLoading(),
          environment: relay.environment
        },
        resolver: resolver
      };
      return _this;
    }

    /**
     * When new props are received, read data for the new props and subscribe
     * for updates. Props may be the same in which case previous data and
     * subscriptions can be reused.
     */

    Container.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Any props change could impact the query, so we mirror props in state.
      // This is an unusual pattern, but necessary for this container usecase.
      var prevProps = prevState.prevProps,
          relay = prevState.relay;
      var _relay$environment$un = relay.environment.unstable_internal,
          createFragmentSpecResolver = _relay$environment$un.createFragmentSpecResolver,
          getDataIDsFromObject = _relay$environment$un.getDataIDsFromObject;

      var prevIDs = getDataIDsFromObject(fragments, prevProps);
      var nextIDs = getDataIDsFromObject(fragments, nextProps);

      var resolver = prevState.resolver;

      // If the environment has changed or props point to new records then
      // previously fetched data and any pending fetches no longer apply:
      // - Existing references are on the old environment.
      // - Existing references are based on old variables.
      // - Pending fetches are for the previous records.
      if (prevState.relayEnvironment !== relay.environment || prevState.relayVariables !== relay.variables || !__webpack_require__(82)(prevIDs, nextIDs)) {
        // Do not provide a subscription/callback here.
        // It is possible for this render to be interrupted or aborted,
        // In which case the subscription would cause a leak.
        // We will add the subscription in componentDidUpdate().
        resolver = createFragmentSpecResolver(relay, containerName, fragments, nextProps);

        return {
          data: resolver.resolve(),
          relayEnvironment: relay.environment,
          prevProps: nextProps,
          relayVariables: relay.variables,
          relayProp: {
            isLoading: resolver.isLoading(),
            environment: relay.environment
          },
          resolver: resolver
        };
      } else {
        resolver.setProps(nextProps);

        var _data = resolver.resolve();
        if (_data !== prevState.data) {
          return {
            data: _data,
            relayEnvironment: relay.environment,
            prevProps: nextProps,
            relayVariables: relay.variables,
            relayProp: {
              isLoading: resolver.isLoading(),
              environment: relay.environment
            }
          };
        }
      }

      return null;
    };

    Container.prototype.componentDidMount = function componentDidMount() {
      this._subscribeToNewResolver();
      this._rerenderIfStoreHasChanged();
    };

    Container.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (this.state.resolver !== prevState.resolver) {
        prevState.resolver.dispose();

        this._subscribeToNewResolver();
      }
      this._rerenderIfStoreHasChanged();
    };

    Container.prototype.componentWillUnmount = function componentWillUnmount() {
      this.state.resolver.dispose();
    };

    Container.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
      // Short-circuit if any Relay-related data has changed
      if (nextState.data !== this.state.data) {
        return true;
      }
      // Otherwise, for convenience short-circuit if all non-Relay props
      // are scalar and equal
      var keys = Object.keys(nextProps);
      for (var ii = 0; ii < keys.length; ii++) {
        var _key = keys[ii];
        if (_key === 'relay') {
          if (nextState.relayEnvironment !== this.state.relayEnvironment || nextState.relayVariables !== this.state.relayVariables) {
            return true;
          }
        } else {
          if (!fragments.hasOwnProperty(_key) && !__webpack_require__(9).isScalarAndEqual(nextProps[_key], this.props[_key])) {
            return true;
          }
        }
      }
      return false;
    };

    /**
     * Render new data for the existing props/context.
     */

    Container.prototype._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
      var _state = this.state,
          data = _state.data,
          resolver = _state.resolver;
      // External values could change between render and commit.
      // Check for this case, even though it requires an extra store read.

      var maybeNewData = resolver.resolve();
      if (data !== maybeNewData) {
        this.setState({ data: maybeNewData });
      }
    };

    Container.prototype._subscribeToNewResolver = function _subscribeToNewResolver() {
      var resolver = this.state.resolver;

      // Event listeners are only safe to add during the commit phase,
      // So they won't leak if render is interrupted or errors.

      resolver.setCallback(this._handleFragmentDataUpdate);
    };

    Container.prototype.render = function render() {
      var _props = this.props,
          componentRef = _props.componentRef,
          props = (0, _objectWithoutProperties3['default'])(_props, ['componentRef']);

      return __webpack_require__(0).createElement(Component, (0, _extends3['default'])({}, props, this.state.data, {
        ref: componentRef,
        relay: this.state.relayProp
      }));
    };

    return Container;
  }(__webpack_require__(0).Component);

  Container.displayName = containerName;
  Container.contextTypes = {
    relay: __webpack_require__(81).Relay
  };

  __webpack_require__(702).profileContainer(Container, 'ReactRelayFragmentContainer');

  return Container;
}

/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */
function createContainer(Component, fragmentSpec) {
  return __webpack_require__(713)(Component, fragmentSpec, createContainerWithFragments,
  /* provides child context */false);
}

module.exports = { createContainer: createContainer, createContainerWithFragments: createContainerWithFragments };

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _objectWithoutProperties3 = _interopRequireDefault(__webpack_require__(145));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

var _possibleConstructorReturn3 = _interopRequireDefault(__webpack_require__(41));

var _inherits3 = _interopRequireDefault(__webpack_require__(40));

var _defineProperty3 = _interopRequireDefault(__webpack_require__(122));

var _extends4 = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var containerContextTypes = {
  relay: __webpack_require__(81).Relay
};

var FORWARD = 'forward';

/**
 * Extends the functionality of RelayFragmentContainer by providing a mechanism
 * to load more data from a connection.
 *
 * # Configuring a PaginationContainer
 *
 * PaginationContainer accepts the standard FragmentContainer arguments and an
 * additional `connectionConfig` argument:
 *
 * - `Component`: the component to be wrapped/rendered.
 * - `fragments`: an object whose values are `graphql` fragments. The object
 *   keys determine the prop names by which fragment data is available.
 * - `connectionConfig`: an object that determines how to load more connection
 *   data. Details below.
 *
 * # Loading More Data
 *
 * Use `props.relay.hasMore()` to determine if there are more items to load.
 *
 * ```
 * hasMore(): boolean
 * ```
 *
 * Use `props.relay.isLoading()` to determine if a previous call to `loadMore()`
 * is still pending. This is convenient for avoiding duplicate load calls.
 *
 * ```
 * isLoading(): boolean
 * ```
 *
 * Use `props.relay.loadMore()` to load more items. This will return null if
 * there are no more items to fetch, otherwise it will fetch more items and
 * return a Disposable that can be used to cancel the fetch.
 *
 * `pageSize` should be the number of *additional* items to fetch (not the
 * total).
 *
 * ```
 * loadMore(pageSize: number, callback: ?(error: ?Error) => void): ?Disposable
 * ```
 *
 * A complete example:
 *
 * ```
 * class Foo extends React.Component {
 *   ...
 *   _onEndReached() {
 *     if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
 *       return;
 *     }
 *     this.props.relay.loadMore(10);
 *   }
 *   ...
 * }
 * ```
 *
 * # Connection Config
 *
 * Here's an example, followed by details of each config property:
 *
 * ```
 * ReactRelayPaginationContainer.createContainer(
 *   Component,
 *   {
 *     user: graphql`fragment FriendsFragment on User {
 *       friends(after: $afterCursor first: $count) @connection {
 *         edges { ... }
 *         pageInfo {
 *           startCursor
 *           endCursor
 *           hasNextPage
 *           hasPreviousPage
 *         }
 *       }
 *     }`,
 *   },
 *   {
 *     direction: 'forward',
 *     getConnectionFromProps(props) {
 *       return props.user && props.user.friends;
 *     },
 *     getFragmentVariables(vars, totalCount) {
 *       // The component presumably wants *all* edges, not just those after
 *       // the cursor, so notice that we don't set $afterCursor here.
 *       return {
 *         ...vars,
 *         count: totalCount,
 *       };
 *     },
 *     getVariables(props, {count, cursor}, fragmentVariables) {
 *       return {
 *         id: props.user.id,
 *         afterCursor: cursor,
 *         count,
 *       },
 *     },
 *     query: graphql`
 *       query FriendsQuery($id: ID!, $afterCursor: ID, $count: Int!) {
 *         node(id: $id) {
 *           ...FriendsFragment
 *         }
 *       }
 *     `,
 *   }
 * );
 * ```
 *
 * ## Config Properties
 *
 * - `direction`: Either "forward" to indicate forward pagination using
 *   after/first, or "backward" to indicate backward pagination using
 *   before/last.
 * - `getConnectionFromProps(props)`: PaginationContainer doesn't magically know
 *   which connection data you mean to fetch more of (a container might fetch
 *   multiple connections, but can only paginate one of them). This function is
 *   given the fragment props only (not full props), and should return the
 *   connection data. See the above example that returns the friends data via
 *   `props.user.friends`.
 * - `getFragmentVariables(previousVars, totalCount)`: Given the previous variables
 *   and the new total number of items, get the variables to use when reading
 *   your fragments. Typically this means setting whatever your local "count"
 *   variable is to the value of `totalCount`. See the example.
 * - `getVariables(props, {count, cursor})`: Get the variables to use when
 *   fetching the pagination `query`. You may determine the root object id from
 *   props (see the example that uses `props.user.id`) and may also set whatever
 *   variables you use for the after/first/before/last calls based on the count
 *   and cursor.
 * - `query`: A query to use when fetching more connection data. This should
 *   typically reference one of the container's fragment (as in the example)
 *   to ensure that all the necessary fields for sub-components are fetched.
 */

function createGetConnectionFromProps(metadata) {
  var path = metadata.path;
  !path ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Unable to synthesize a ' + 'getConnectionFromProps function.') : __webpack_require__(3)(false) : void 0;
  return function (props) {
    var data = props[metadata.fragmentName];
    for (var i = 0; i < path.length; i++) {
      if (!data || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        return null;
      }
      data = data[path[i]];
    }
    return data;
  };
}

function createGetFragmentVariables(metadata) {
  var countVariable = metadata.count;
  !countVariable ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Unable to synthesize a ' + 'getFragmentVariables function.') : __webpack_require__(3)(false) : void 0;
  return function (prevVars, totalCount) {
    return (0, _extends4['default'])({}, prevVars, (0, _defineProperty3['default'])({}, countVariable, totalCount));
  };
}

function findConnectionMetadata(fragments) {
  var foundConnectionMetadata = null;
  var isRelayModern = false;
  for (var _fragmentName in fragments) {
    var fragment = fragments[_fragmentName];
    var connectionMetadata = fragment.metadata && fragment.metadata.connection;
    // HACK: metadata is always set to `undefined` in classic. In modern, even
    // if empty, it is set to null (never undefined). We use that knowlege to
    // check if we're dealing with classic or modern
    if (fragment.metadata !== undefined) {
      isRelayModern = true;
    }
    if (connectionMetadata) {
      !(connectionMetadata.length === 1) ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Only a single @connection is ' + 'supported, `%s` has %s.', _fragmentName, connectionMetadata.length) : __webpack_require__(3)(false) : void 0;
      !!foundConnectionMetadata ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Only a single fragment with ' + '@connection is supported.') : __webpack_require__(3)(false) : void 0;
      foundConnectionMetadata = (0, _extends4['default'])({}, connectionMetadata[0], {
        fragmentName: _fragmentName
      });
    }
  }
  !(!isRelayModern || foundConnectionMetadata !== null) ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: A @connection directive must be present.') : __webpack_require__(3)(false) : void 0;
  return foundConnectionMetadata || {};
}

function toObserver(observerOrCallback) {
  return typeof observerOrCallback === 'function' ? {
    error: observerOrCallback,
    complete: observerOrCallback,
    unsubscribe: function unsubscribe(subscription) {
      typeof observerOrCallback === 'function' && observerOrCallback();
    }
  } : observerOrCallback || {};
}

function createContainerWithFragments(Component, fragments, connectionConfig) {
  var componentName = __webpack_require__(154).getComponentName(Component);
  var containerName = __webpack_require__(154).getContainerName(Component);

  var metadata = findConnectionMetadata(fragments);

  var getConnectionFromProps = connectionConfig.getConnectionFromProps || createGetConnectionFromProps(metadata);

  var direction = connectionConfig.direction || metadata.direction;
  !direction ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Unable to infer direction of the ' + 'connection, possibly because both first and last are provided.') : __webpack_require__(3)(false) : void 0;

  var getFragmentVariables = connectionConfig.getFragmentVariables || createGetFragmentVariables(metadata);

  var Container = function (_React$Component) {
    (0, _inherits3['default'])(Container, _React$Component);

    function Container(props, context) {
      (0, _classCallCheck3['default'])(this, Container);

      var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

      _this._handleFragmentDataUpdate = function () {
        var profiler = __webpack_require__(9).RelayProfiler.profile('ReactRelayPaginationContainer.handleFragmentDataUpdate');
        _this.setState({ data: _this._resolver.resolve() }, profiler.stop);
      };

      _this._hasMore = function () {
        var connectionData = _this._getConnectionData();
        return !!(connectionData && connectionData.hasMore && connectionData.cursor);
      };

      _this._isLoading = function () {
        return !!_this._refetchSubscription;
      };

      _this._refetchConnection = function (totalCount, observerOrCallback, refetchVariables) {
        _this._refetchVariables = refetchVariables;
        var paginatingVariables = {
          count: totalCount,
          cursor: null,
          totalCount: totalCount
        };
        var fetch = _this._fetchPage(paginatingVariables, toObserver(observerOrCallback), { force: true });

        return { dispose: fetch.unsubscribe };
      };

      _this._loadMore = function (pageSize, observerOrCallback, options) {
        var observer = toObserver(observerOrCallback);
        var connectionData = _this._getConnectionData();
        if (!connectionData) {
          __webpack_require__(9).Observable.create(function (sink) {
            return sink.complete();
          }).subscribe(observer);
          return null;
        }
        var totalCount = connectionData.edgeCount + pageSize;
        if (options && options.force) {
          return _this._refetchConnection(totalCount, observerOrCallback);
        }

        var _ConnectionInterface$ = __webpack_require__(9).ConnectionInterface.get(),
            END_CURSOR = _ConnectionInterface$.END_CURSOR,
            START_CURSOR = _ConnectionInterface$.START_CURSOR;

        var cursor = connectionData.cursor;
         false ? require('fbjs/lib/warning')(cursor, 'ReactRelayPaginationContainer: Cannot `loadMore` without valid `%s` (got `%s`)', direction === FORWARD ? END_CURSOR : START_CURSOR, cursor) : void 0;
        var paginatingVariables = {
          count: pageSize,
          cursor: cursor,
          totalCount: totalCount
        };
        _this._hasPaginated = true;
        var fetch = _this._fetchPage(paginatingVariables, observer, options);
        return { dispose: fetch.unsubscribe };
      };

      var relay = __webpack_require__(126).assertRelayContext(context.relay);
      var createFragmentSpecResolver = relay.environment.unstable_internal.createFragmentSpecResolver;

      _this._isARequestInFlight = false;
      _this._hasPaginated = false;
      _this._refetchSubscription = null;
      _this._refetchVariables = null;
      _this._resolver = createFragmentSpecResolver(relay, containerName, fragments, props, _this._handleFragmentDataUpdate);
      _this._relayContext = {
        environment: relay.environment,
        variables: relay.variables
      };
      _this.state = {
        data: _this._resolver.resolve(),
        relayEnvironment: relay.environment,
        relayProp: _this._buildRelayProp(relay),
        relayVariables: relay.variables
      };
      return _this;
    }

    /**
     * When new props are received, read data for the new props and subscribe
     * for updates. Props may be the same in which case previous data and
     * subscriptions can be reused.
     */

    Container.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
      var context = __webpack_require__(172)(nextContext);
      var relay = __webpack_require__(126).assertRelayContext(context.relay);
      var _relay$environment$un = relay.environment.unstable_internal,
          createFragmentSpecResolver = _relay$environment$un.createFragmentSpecResolver,
          getDataIDsFromObject = _relay$environment$un.getDataIDsFromObject;

      var prevIDs = getDataIDsFromObject(fragments, this.props);
      var nextIDs = getDataIDsFromObject(fragments, nextProps);

      // If the environment has changed or props point to new records then
      // previously fetched data and any pending fetches no longer apply:
      // - Existing references are on the old environment.
      // - Existing references are based on old variables.
      // - Pending fetches are for the previous records.
      if (this.state.relayEnvironment !== relay.environment || this.state.relayVariables !== relay.variables || !__webpack_require__(82)(prevIDs, nextIDs)) {
        this._cleanup();
        // Child containers rely on context.relay being mutated (for gDSFP).
        this._relayContext.environment = relay.environment;
        this._relayContext.variables = relay.variables;
        this._resolver = createFragmentSpecResolver(relay, containerName, fragments, nextProps, this._handleFragmentDataUpdate);
        this.setState({
          relayEnvironment: relay.environment,
          relayProp: this._buildRelayProp(relay),
          relayVariables: relay.variables
        });
      } else if (!this._hasPaginated) {
        this._resolver.setProps(nextProps);
      }
      var data = this._resolver.resolve();
      if (data !== this.state.data) {
        this.setState({ data: data });
      }
    };

    Container.prototype.componentWillUnmount = function componentWillUnmount() {
      this._cleanup();
    };

    Container.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
      // Short-circuit if any Relay-related data has changed
      if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) {
        return true;
      }
      // Otherwise, for convenience short-circuit if all non-Relay props
      // are scalar and equal
      var keys = Object.keys(nextProps);
      for (var ii = 0; ii < keys.length; ii++) {
        var _key = keys[ii];
        if (_key === 'relay') {
          if (nextState.relayEnvironment !== this.state.relayEnvironment || nextState.relayVariables !== this.state.relayVariables) {
            return true;
          }
        } else {
          if (!fragments.hasOwnProperty(_key) && !__webpack_require__(9).isScalarAndEqual(nextProps[_key], this.props[_key])) {
            return true;
          }
        }
      }
      return false;
    };

    Container.prototype._buildRelayProp = function _buildRelayProp(relay) {
      return {
        hasMore: this._hasMore,
        isLoading: this._isLoading,
        loadMore: this._loadMore,
        refetchConnection: this._refetchConnection,
        environment: relay.environment
      };
    };

    /**
     * Render new data for the existing props/context.
     */

    Container.prototype._getConnectionData = function _getConnectionData() {
      // Extract connection data and verify there are more edges to fetch
      var _props = this.props,
          _ = _props.componentRef,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['componentRef']);

      var props = (0, _extends4['default'])({}, restProps, this.state.data);
      var connectionData = getConnectionFromProps(props);
      if (connectionData == null) {
        return null;
      }

      var _ConnectionInterface$2 = __webpack_require__(9).ConnectionInterface.get(),
          EDGES = _ConnectionInterface$2.EDGES,
          PAGE_INFO = _ConnectionInterface$2.PAGE_INFO,
          HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE,
          HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE,
          END_CURSOR = _ConnectionInterface$2.END_CURSOR,
          START_CURSOR = _ConnectionInterface$2.START_CURSOR;

      !((typeof connectionData === 'undefined' ? 'undefined' : _typeof(connectionData)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`' + 'to return `null` or a plain object with %s and %s properties, got `%s`.', componentName, EDGES, PAGE_INFO, connectionData) : __webpack_require__(3)(false) : void 0;
      var edges = connectionData[EDGES];
      var pageInfo = connectionData[PAGE_INFO];
      if (edges == null || pageInfo == null) {
        return null;
      }
      !Array.isArray(edges) ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`' + 'to return an object with %s: Array, got `%s`.', componentName, EDGES, edges) : __webpack_require__(3)(false) : void 0;
      !((typeof pageInfo === 'undefined' ? 'undefined' : _typeof(pageInfo)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`' + 'to return an object with %s: Object, got `%s`.', componentName, PAGE_INFO, pageInfo) : __webpack_require__(3)(false) : void 0;
      var hasMore = direction === FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
      var cursor = direction === FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
      if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') {
         false ? require('fbjs/lib/warning')(false, 'ReactRelayPaginationContainer: Cannot paginate without %s fields in `%s`. ' + 'Be sure to fetch %s (got `%s`) and %s (got `%s`).', PAGE_INFO, componentName, direction === FORWARD ? HAS_NEXT_PAGE : HAS_PREV_PAGE, hasMore, direction === FORWARD ? END_CURSOR : START_CURSOR, cursor) : void 0;
        return null;
      }
      return {
        cursor: cursor,
        edgeCount: edges.length,
        hasMore: hasMore
      };
    };

    Container.prototype._getQueryFetcher = function _getQueryFetcher() {
      if (!this._queryFetcher) {
        this._queryFetcher = new (__webpack_require__(703))();
      }
      return this._queryFetcher;
    };

    Container.prototype._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
      var _this2 = this;

      var _assertRelayContext = __webpack_require__(126).assertRelayContext(this.context.relay),
          environment = _assertRelayContext.environment;

      var _environment$unstable = environment.unstable_internal,
          createOperationSelector = _environment$unstable.createOperationSelector,
          getRequest = _environment$unstable.getRequest,
          getVariablesFromObject = _environment$unstable.getVariablesFromObject;
      var _props2 = this.props,
          _ = _props2.componentRef,
          restProps = (0, _objectWithoutProperties3['default'])(_props2, ['componentRef']);

      var props = (0, _extends4['default'])({}, restProps, this.state.data);
      var rootVariables = this._relayContext.variables;
      var fragmentVariables = getVariablesFromObject(rootVariables, fragments, restProps);
      fragmentVariables = (0, _extends4['default'])({}, rootVariables, fragmentVariables, this._refetchVariables);
      var fetchVariables = connectionConfig.getVariables(props, {
        count: paginatingVariables.count,
        cursor: paginatingVariables.cursor
      }, fragmentVariables);
      !((typeof fetchVariables === 'undefined' ? 'undefined' : _typeof(fetchVariables)) === 'object' && fetchVariables !== null) ?  false ? require('fbjs/lib/invariant')(false, 'ReactRelayPaginationContainer: Expected `getVariables()` to ' + 'return an object, got `%s` in `%s`.', fetchVariables, componentName) : __webpack_require__(3)(false) : void 0;
      fetchVariables = (0, _extends4['default'])({}, fetchVariables, this._refetchVariables);

      var cacheConfig = options ? { force: !!options.force } : undefined;
      if (cacheConfig && options && options.rerunParamExperimental) {
        cacheConfig.rerunParamExperimental = options.rerunParamExperimental;
      }
      var request = getRequest(connectionConfig.query);
      var operation = createOperationSelector(request, fetchVariables);

      var refetchSubscription = null;

      if (this._refetchSubscription) {
        this._refetchSubscription.unsubscribe();
      }

      var onNext = function onNext(payload, complete) {
        // Child containers rely on context.relay being mutated (for gDSFP).
        _this2._relayContext.environment = _this2.context.relay.environment;
        _this2._relayContext.variables = (0, _extends4['default'])({}, _this2.context.relay.variables, fragmentVariables);
        var prevData = _this2._resolver.resolve();
        _this2._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount));
        var nextData = _this2._resolver.resolve();

        // Workaround slightly different handling for connection in different
        // core implementations:
        // - Classic core requires the count to be explicitly incremented
        // - Modern core automatically appends new items, updating the count
        //   isn't required to see new data.
        //
        // `setState` is only required if changing the variables would change the
        // resolved data.
        // TODO #14894725: remove PaginationContainer equal check
        if (!__webpack_require__(82)(prevData, nextData)) {
          _this2.setState({ data: nextData }, complete);
        } else {
          complete();
        }
      };

      var cleanup = function cleanup() {
        if (_this2._refetchSubscription === refetchSubscription) {
          _this2._refetchSubscription = null;
          _this2._isARequestInFlight = false;
        }
      };

      this._isARequestInFlight = true;
      refetchSubscription = this._getQueryFetcher().execute({
        environment: environment,
        operation: operation,
        cacheConfig: cacheConfig,
        preservePreviousReferences: true
      }).mergeMap(function (payload) {
        return __webpack_require__(9).Observable.create(function (sink) {
          onNext(payload, function () {
            sink.next(); // pass void to public observer's `next`
            sink.complete();
          });
        });
      })
      // use do instead of finally so that observer's `complete` fires after cleanup
      ['do']({
        error: cleanup,
        complete: cleanup,
        unsubscribe: cleanup
      }).subscribe(observer || {});

      this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;

      return refetchSubscription;
    };

    Container.prototype._cleanup = function _cleanup() {
      this._resolver.dispose();
      this._hasPaginated = false;
      this._refetchVariables = null;
      if (this._refetchSubscription) {
        this._refetchSubscription.unsubscribe();
        this._refetchSubscription = null;
        this._isARequestInFlight = false;
      }
      if (this._queryFetcher) {
        this._queryFetcher.dispose();
      }
    };

    Container.prototype.getChildContext = function getChildContext() {
      return { relay: this._relayContext };
    };

    Container.prototype.render = function render() {
      var _props3 = this.props,
          componentRef = _props3.componentRef,
          props = (0, _objectWithoutProperties3['default'])(_props3, ['componentRef']);

      return __webpack_require__(0).createElement(Component, (0, _extends4['default'])({}, props, this.state.data, {
        ref: componentRef,
        relay: this.state.relayProp
      }));
    };

    return Container;
  }(__webpack_require__(0).Component);

  Container.displayName = containerName;
  Container.contextTypes = containerContextTypes;

  __webpack_require__(702).profileContainer(Container, 'ReactRelayPaginationContainer');

  return Container;
}

/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */
function createContainer(Component, fragmentSpec, connectionConfig) {
  return __webpack_require__(713)(Component, fragmentSpec, function (ComponentClass, fragments) {
    return createContainerWithFragments(ComponentClass, fragments, connectionConfig);
  },
  /* provides child context */true);
}

module.exports = { createContainer: createContainer, createContainerWithFragments: createContainerWithFragments };

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



/**
 * The public interface to React Relay.
 */

module.exports = {
  QueryRenderer: __webpack_require__(2385),

  MutationTypes: __webpack_require__(9).MutationTypes,
  RangeOperations: __webpack_require__(9).RangeOperations,

  applyOptimisticMutation: __webpack_require__(9).applyOptimisticMutation,
  commitLocalUpdate: __webpack_require__(9).commitLocalUpdate,
  commitMutation: __webpack_require__(9).commitMutation,
  createFragmentContainer: __webpack_require__(2382).createContainer,
  createPaginationContainer: __webpack_require__(2383).createContainer,
  createRefetchContainer: __webpack_require__(2386).createContainer,
  fetchQuery: __webpack_require__(9).fetchQuery,
  graphql: __webpack_require__(9).graphql,
  requestSubscription: __webpack_require__(9).requestSubscription
};

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

var _possibleConstructorReturn3 = _interopRequireDefault(__webpack_require__(41));

var _inherits3 = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var NETWORK_ONLY = 'NETWORK_ONLY';
var STORE_THEN_NETWORK = 'STORE_THEN_NETWORK';
var DataFromEnum = {
  NETWORK_ONLY: NETWORK_ONLY,
  STORE_THEN_NETWORK: STORE_THEN_NETWORK
};

/**
 * @public
 *
 * Orchestrates fetching and rendering data for a single view or view hierarchy:
 * - Fetches the query/variables using the given network implementation.
 * - Normalizes the response(s) to that query, publishing them to the given
 *   store.
 * - Renders the pending/fail/success states with the provided render function.
 * - Subscribes for updates to the root data and re-renders with any changes.
 */
var ReactRelayQueryRenderer = function (_React$Component) {
  (0, _inherits3['default'])(ReactRelayQueryRenderer, _React$Component);

  // TODO T25783053 Update this component to use the new React context API,
  // Once we have confirmed that it's okay to raise min React version to 16.3.
  function ReactRelayQueryRenderer(props, context) {
    (0, _classCallCheck3['default'])(this, ReactRelayQueryRenderer);

    // Callbacks are attached to the current instance and shared with static
    // lifecyles by bundling with state. This is okay to do because the
    // callbacks don't change in reaction to props. However we should not
    // "leak" them before mounting (since we would be unable to clean up). For
    // that reason, we define them as null initially and fill them in after
    // mounting to avoid leaking memory.
    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this._relayContext = {
      // $FlowFixMe TODO t16225453 QueryRenderer works with old+new environment.
      environment: _this.props.environment,
      variables: _this.props.variables
    };
    var retryCallbacks = {
      handleDataChange: null,
      handleRetryAfterError: null
    };

    var queryFetcher = new (__webpack_require__(703))();

    _this.state = (0, _extends3['default'])({
      prevPropsEnvironment: props.environment,
      prevPropsVariables: props.variables,
      prevQuery: props.query,
      queryFetcher: queryFetcher,
      retryCallbacks: retryCallbacks
    }, fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks));
    return _this;
  }

  ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !__webpack_require__(82)(prevState.prevPropsVariables, nextProps.variables)) {
      return (0, _extends3['default'])({
        prevQuery: nextProps.query,
        prevPropsEnvironment: nextProps.environment,
        prevPropsVariables: nextProps.variables
      }, fetchQueryAndComputeStateFromProps(nextProps, prevState.queryFetcher, prevState.retryCallbacks));
    }

    return null;
  };

  ReactRelayQueryRenderer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _state = this.state,
        retryCallbacks = _state.retryCallbacks,
        queryFetcher = _state.queryFetcher;

    retryCallbacks.handleDataChange = function (params) {
      var error = params.error == null ? null : params.error;
      var snapshot = params.snapshot == null ? null : params.snapshot;

      _this2.setState(function (prevState) {
        // Don't update state if nothing has changed.
        if (snapshot === prevState.snapshot && error === prevState.error) {
          return null;
        }
        return {
          renderProps: getRenderProps(error, snapshot, queryFetcher, retryCallbacks),
          snapshot: snapshot
        };
      });
    };

    retryCallbacks.handleRetryAfterError = function (error) {
      return _this2.setState({ renderProps: getLoadingRenderProps() });
    };

    // Re-initialize the ReactRelayQueryFetcher with callbacks.
    // If data has changed since constructions, this will re-render.
    if (this.props.query) {
      queryFetcher.setOnDataChange(retryCallbacks.handleDataChange);
    }
  };

  ReactRelayQueryRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.state.queryFetcher.dispose();
  };

  ReactRelayQueryRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
  };

  ReactRelayQueryRenderer.prototype.getChildContext = function getChildContext() {
    return {
      relay: this._relayContext
    };
  };

  ReactRelayQueryRenderer.prototype.render = function render() {
    var _state2 = this.state,
        relayContextEnvironment = _state2.relayContextEnvironment,
        relayContextVariables = _state2.relayContextVariables,
        renderProps = _state2.renderProps;

    // HACK Mutate the context.relay object before updating children,
    // To account for any changes made by static gDSFP.
    // Updating this value in gDSFP would be less safe, since props changes
    // could be interrupted and we might re-render based on a setState call.
    // Child containers rely on context.relay being mutated (also for gDSFP).
    // $FlowFixMe TODO t16225453 QueryRenderer works with old+new environment.

    this._relayContext.environment = relayContextEnvironment;
    this._relayContext.variables = relayContextVariables;

    // Note that the root fragment results in `renderProps.props` is already
    // frozen by the store; this call is to freeze the renderProps object and
    // error property if set.
    if (false) {
      require('relay-runtime').deepFreeze(renderProps);
    }
    return this.props.render(renderProps);
  };

  return ReactRelayQueryRenderer;
}(__webpack_require__(0).Component);

ReactRelayQueryRenderer.childContextTypes = {
  relay: __webpack_require__(81).Relay
};

function getLoadingRenderProps() {
  return {
    error: null,
    props: null, // `props: null` indicates that the data is being fetched (i.e. loading)
    retry: null
  };
}

function getEmptyRenderProps() {
  return {
    error: null,
    props: {}, // `props: {}` indicates no data available
    retry: null
  };
}

function getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
  return {
    error: error ? error : null,
    props: snapshot ? snapshot.data : null,
    retry: function retry() {
      var syncSnapshot = queryFetcher.retry();
      if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') {
        retryCallbacks.handleDataChange({ snapshot: syncSnapshot });
      } else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') {
        // If retrying after an error and no synchronous result available,
        // reset the render props
        retryCallbacks.handleRetryAfterError(error);
      }
    }
  };
}

function fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks) {
  var environment = props.environment,
      query = props.query,
      variables = props.variables;

  if (query) {
    // $FlowFixMe TODO t16225453 QueryRenderer works with old+new environment.
    var genericEnvironment = environment;

    var _genericEnvironment$u = genericEnvironment.unstable_internal,
        createOperationSelector = _genericEnvironment$u.createOperationSelector,
        getRequest = _genericEnvironment$u.getRequest;

    var request = getRequest(query);
    var operation = createOperationSelector(request, variables);

    try {
      var storeSnapshot = props.dataFrom === STORE_THEN_NETWORK ? queryFetcher.lookupInStore(genericEnvironment, operation) : null;
      var querySnapshot = queryFetcher.fetch({
        cacheConfig: props.cacheConfig,
        dataFrom: props.dataFrom,
        environment: genericEnvironment,
        onDataChange: retryCallbacks.handleDataChange,
        operation: operation
      });
      // Use network data first, since it may be fresher
      var _snapshot = querySnapshot || storeSnapshot;
      if (!_snapshot) {
        return {
          error: null,
          relayContextEnvironment: environment,
          relayContextVariables: operation.variables,
          renderProps: getLoadingRenderProps(),
          snapshot: null
        };
      }

      return {
        error: null,
        relayContextEnvironment: environment,
        relayContextVariables: operation.variables,
        renderProps: getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
        snapshot: _snapshot
      };
    } catch (error) {
      return {
        error: error,
        relayContextEnvironment: environment,
        relayContextVariables: operation.variables,
        renderProps: getRenderProps(error, null, queryFetcher, retryCallbacks),
        snapshot: null
      };
    }
  } else {
    queryFetcher.dispose();

    return {
      error: null,
      relayContextEnvironment: environment,
      relayContextVariables: variables,
      renderProps: getEmptyRenderProps()
    };
  }
}

module.exports = ReactRelayQueryRenderer;

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var _objectWithoutProperties3 = _interopRequireDefault(__webpack_require__(145));

var _extends3 = _interopRequireDefault(__webpack_require__(19));

var _classCallCheck3 = _interopRequireDefault(__webpack_require__(15));

var _possibleConstructorReturn3 = _interopRequireDefault(__webpack_require__(41));

var _inherits3 = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var containerContextTypes = {
  relay: __webpack_require__(81).Relay
};

/**
 * Composes a React component class, returning a new class that intercepts
 * props, resolving them with the provided fragments and subscribing for
 * updates.
 */
function createContainerWithFragments(Component, fragments, taggedNode) {
  var containerName = __webpack_require__(154).getContainerName(Component);

  var Container = function (_React$Component) {
    (0, _inherits3['default'])(Container, _React$Component);

    function Container(props, context) {
      (0, _classCallCheck3['default'])(this, Container);

      var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

      _this._handleFragmentDataUpdate = function () {
        var profiler = __webpack_require__(9).RelayProfiler.profile('ReactRelayRefetchContainer.handleFragmentDataUpdate');
        var resolverFromThisUpdate = _this.state.resolver;
        _this.setState(function (updatedState) {
          // If this event belongs to the current data source, update.
          // Otherwise we should ignore it.
          if (resolverFromThisUpdate === updatedState.resolver) {
            return {
              data: updatedState.resolver.resolve()
            };
          }

          return null;
        }, profiler.stop);
      };

      _this._refetch = function (refetchVariables, renderVariables, observerOrCallback, options) {
        var _assertRelayContext = __webpack_require__(126).assertRelayContext(_this.context.relay),
            environment = _assertRelayContext.environment,
            rootVariables = _assertRelayContext.variables;

        var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
        fetchVariables = (0, _extends3['default'])({}, rootVariables, fetchVariables);
        var fragmentVariables = renderVariables ? (0, _extends3['default'])({}, rootVariables, renderVariables) : fetchVariables;
        var cacheConfig = options ? { force: !!options.force } : undefined;

        var observer = typeof observerOrCallback === 'function' ? {
          // callback is not exectued on complete or unsubscribe
          // for backward compatibility
          next: observerOrCallback,
          error: observerOrCallback
        } : observerOrCallback || {};

        var _this$context$relay$e = _this.context.relay.environment.unstable_internal,
            createOperationSelector = _this$context$relay$e.createOperationSelector,
            getRequest = _this$context$relay$e.getRequest;

        var query = getRequest(taggedNode);
        var operation = createOperationSelector(query, fetchVariables);

        // TODO: T26288752 find a better way
        /* eslint-disable lint/react-state-props-mutation */
        _this.state.localVariables = fetchVariables;
        /* eslint-enable lint/react-state-props-mutation */

        // Cancel any previously running refetch.
        _this._refetchSubscription && _this._refetchSubscription.unsubscribe();

        // Declare refetchSubscription before assigning it in .start(), since
        // synchronous completion may call callbacks .subscribe() returns.
        var refetchSubscription = void 0;
        _this._getQueryFetcher().execute({
          environment: environment,
          operation: operation,
          cacheConfig: cacheConfig,
          // TODO (T26430099): Cleanup old references
          preservePreviousReferences: true
        }).mergeMap(function (response) {
          // Child containers rely on context.relay being mutated (for gDSFP).
          // TODO: T26288752 find a better way
          /* eslint-disable lint/react-state-props-mutation */
          _this.state.relayContext.environment = _this.context.relay.environment;
          _this.state.relayContext.variables = fragmentVariables;
          /* eslint-enable lint/react-state-props-mutation */
          _this.state.resolver.setVariables(fragmentVariables);
          return __webpack_require__(9).Observable.create(function (sink) {
            return _this.setState({ data: _this.state.resolver.resolve() }, function () {
              sink.next();
              sink.complete();
            });
          });
        })['finally'](function () {
          // Finalizing a refetch should only clear this._refetchSubscription
          // if the finizing subscription is the most recent call.
          if (_this._refetchSubscription === refetchSubscription) {
            _this._refetchSubscription = null;
          }
        }).subscribe((0, _extends3['default'])({}, observer, {
          start: function start(subscription) {
            _this._refetchSubscription = refetchSubscription = subscription;
            observer.start && observer.start(subscription);
          }
        }));

        return {
          dispose: function dispose() {
            refetchSubscription && refetchSubscription.unsubscribe();
          }
        };
      };

      var relay = __webpack_require__(126).assertRelayContext(context.relay);
      var createFragmentSpecResolver = relay.environment.unstable_internal.createFragmentSpecResolver;

      _this._refetchSubscription = null;
      // Do not provide a subscription/callback here.
      // It is possible for this render to be interrupted or aborted,
      // In which case the subscription would cause a leak.
      // We will add the subscription in componentDidMount().
      var resolver = createFragmentSpecResolver(relay, containerName, fragments, props);
      _this.state = {
        data: resolver.resolve(),
        localVariables: null,
        relay: relay,
        relayContext: {
          environment: relay.environment,
          variables: relay.variables
        },
        relayEnvironment: relay.environment,
        relayProp: {
          environment: relay.environment,
          refetch: _this._refetch
        },
        prevProps: _this.props,
        relayVariables: relay.variables,
        resolver: resolver
      };
      return _this;
    }

    Container.prototype.componentDidMount = function componentDidMount() {
      this._subscribeToNewResolver();
    };

    Container.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      // If the environment has changed or props point to new records then
      // previously fetched data and any pending fetches no longer apply:
      // - Existing references are on the old environment.
      // - Existing references are based on old variables.
      // - Pending fetches are for the previous records.
      if (this.state.resolver !== prevState.resolver) {
        prevState.resolver.dispose();
        this._queryFetcher && this._queryFetcher.dispose();
        this._refetchSubscription && this._refetchSubscription.unsubscribe();

        this._subscribeToNewResolver();
      }
    };

    /**
     * When new props are received, read data for the new props and add it to
     * state. Props may be the same in which case previous data can be reused.
     */

    Container.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      // Any props change could impact the query, so we mirror props in state.
      // This is an unusual pattern, but necessary for this container usecase.
      var prevProps = prevState.prevProps;

      var relay = __webpack_require__(126).assertRelayContext(prevState.relay);

      var _relay$environment$un = relay.environment.unstable_internal,
          createFragmentSpecResolver = _relay$environment$un.createFragmentSpecResolver,
          getDataIDsFromObject = _relay$environment$un.getDataIDsFromObject;

      var prevIDs = getDataIDsFromObject(fragments, prevProps);
      var nextIDs = getDataIDsFromObject(fragments, nextProps);

      var resolver = prevState.resolver;

      // If the environment has changed or props point to new records then
      // previously fetched data and any pending fetches no longer apply:
      // - Existing references are on the old environment.
      // - Existing references are based on old variables.
      // - Pending fetches are for the previous records.
      if (prevState.relayEnvironment !== relay.environment || prevState.relayVariables !== relay.variables || !__webpack_require__(82)(prevIDs, nextIDs)) {
        // Child containers rely on context.relay being mutated (for gDSFP).
        var mutatedRelayContext = prevState.relayContext;
        mutatedRelayContext.environment = relay.environment;
        mutatedRelayContext.variables = relay.variables;

        // Do not provide a subscription/callback here.
        // It is possible for this render to be interrupted or aborted,
        // In which case the subscription would cause a leak.
        // We will add the subscription in componentDidUpdate().
        resolver = createFragmentSpecResolver(relay, containerName, fragments, nextProps);
        return {
          data: resolver.resolve(),
          localVariables: null,
          prevProps: nextProps,
          relayContext: mutatedRelayContext,
          relayEnvironment: relay.environment,
          relayProp: {
            environment: relay.environment,
            // refetch should never really change
            refetch: prevState.relayProp.refetch
          },
          relayVariables: relay.variables,
          resolver: resolver
        };
      } else if (!prevState.localVariables) {
        resolver.setProps(nextProps);
      }
      var data = resolver.resolve();
      if (data !== prevState.data) {
        return {
          data: data,
          prevProps: nextProps
        };
      }
      return null;
    };

    Container.prototype.componentWillUnmount = function componentWillUnmount() {
      this.state.resolver.dispose();
      this._queryFetcher && this._queryFetcher.dispose();
      this._refetchSubscription && this._refetchSubscription.unsubscribe();
    };

    Container.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
      // Short-circuit if any Relay-related data has changed
      if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) {
        return true;
      }
      // Otherwise, for convenience short-circuit if all non-Relay props
      // are scalar and equal
      var keys = Object.keys(nextProps);
      for (var ii = 0; ii < keys.length; ii++) {
        var _key = keys[ii];
        if (_key === 'relay') {
          if (nextState.relayEnvironment !== this.state.relayEnvironment || nextState.relayVariables !== this.state.relayVariables) {
            return true;
          }
        } else {
          if (!fragments.hasOwnProperty(_key) && !__webpack_require__(9).isScalarAndEqual(nextProps[_key], this.props[_key])) {
            return true;
          }
        }
      }
      return false;
    };

    Container.prototype._subscribeToNewResolver = function _subscribeToNewResolver() {
      var _state = this.state,
          data = _state.data,
          resolver = _state.resolver;

      // Event listeners are only safe to add during the commit phase,
      // So they won't leak if render is interrupted or errors.

      resolver.setCallback(this._handleFragmentDataUpdate);

      // External values could change between render and commit.
      // Check for this case, even though it requires an extra store read.
      var maybeNewData = resolver.resolve();
      if (data !== maybeNewData) {
        this.setState({ data: maybeNewData });
      }
    };

    /**
     * Render new data for the existing props/context.
     */

    Container.prototype._getFragmentVariables = function _getFragmentVariables() {
      var getVariablesFromObject = this.context.relay.environment.unstable_internal.getVariablesFromObject;

      return getVariablesFromObject(this.context.relay.variables, fragments, this.props);
    };

    Container.prototype._getQueryFetcher = function _getQueryFetcher() {
      if (!this._queryFetcher) {
        this._queryFetcher = new (__webpack_require__(703))();
      }
      return this._queryFetcher;
    };

    Container.prototype.getChildContext = function getChildContext() {
      return { relay: this.state.relayContext };
    };

    Container.prototype.render = function render() {
      var _props = this.props,
          componentRef = _props.componentRef,
          props = (0, _objectWithoutProperties3['default'])(_props, ['componentRef']);

      return __webpack_require__(0).createElement(Component, (0, _extends3['default'])({}, props, this.state.data, {
        ref: componentRef,
        relay: this.state.relayProp
      }));
    };

    return Container;
  }(__webpack_require__(0).Component);

  Container.displayName = containerName;
  Container.contextTypes = containerContextTypes;

  __webpack_require__(702).profileContainer(Container, 'ReactRelayRefetchContainer');

  return Container;
}

/**
 * Wrap the basic `createContainer()` function with logic to adapt to the
 * `context.relay.environment` in which it is rendered. Specifically, the
 * extraction of the environment-specific version of fragments in the
 * `fragmentSpec` is memoized once per environment, rather than once per
 * instance of the container constructed/rendered.
 */
function createContainer(Component, fragmentSpec, taggedNode) {
  return __webpack_require__(713)(Component, fragmentSpec, function (ComponentClass, fragments) {
    return createContainerWithFragments(ComponentClass, fragments, taggedNode);
  },
  /* provides child context */true);
}

module.exports = { createContainer: createContainer, createContainerWithFragments: createContainerWithFragments };

/***/ }),
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict-local
 * @format
 */



/**
 * Fail fast if the user supplies invalid fragments as input.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function assertFragmentMap(componentName, fragments) {
  !(fragments && (typeof fragments === 'undefined' ? 'undefined' : _typeof(fragments)) === 'object') ?  false ? require('fbjs/lib/invariant')(false, 'Could not create Relay Container for `%s`. ' + 'Expected a set of GraphQL fragments, got `%s` instead.', componentName, fragments) : __webpack_require__(3)(false) : void 0;

  for (var key in fragments) {
    if (fragments.hasOwnProperty(key)) {
      var fragment = fragments[key];
      !(fragment && ((typeof fragment === 'undefined' ? 'undefined' : _typeof(fragment)) === 'object' || typeof fragment === 'function')) ?  false ? require('fbjs/lib/invariant')(false, 'Could not create Relay Container for `%s`. ' + 'The value of fragment `%s` was expected to be a fragment, got `%s` instead.', componentName, key, fragment) : __webpack_require__(3)(false) : void 0;
    }
  }
}

module.exports = assertFragmentMap;

/***/ }),
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CANCEL_DISTANCE_ON_SCROLL = 20;

var defaultStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden'
  },
  sidebar: {
    zIndex: 2,
    position: 'absolute',
    top: 0,
    bottom: 0,
    transition: 'transform .3s ease-out',
    WebkitTransition: '-webkit-transform .3s ease-out',
    willChange: 'transform',
    overflowY: 'auto'
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    transition: 'left .3s ease-out, right .3s ease-out'
  },
  overlay: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity .3s ease-out, visibility .3s ease-out',
    backgroundColor: 'rgba(0,0,0,.3)'
  },
  dragHandle: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    bottom: 0
  }
};

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.state = {
      // the detected width of the sidebar in pixels
      sidebarWidth: props.defaultSidebarWidth,

      // keep track of touching params
      touchIdentifier: null,
      touchStartX: null,
      touchStartY: null,
      touchCurrentX: null,
      touchCurrentY: null,

      // if touch is supported by the browser
      dragSupported: false
    };

    _this.overlayClicked = _this.overlayClicked.bind(_this);
    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchMove = _this.onTouchMove.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.saveSidebarRef = _this.saveSidebarRef.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        dragSupported: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && 'ontouchstart' in window
      });
      this.saveSidebarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // filter out the updates when we're touching
      if (!this.isTouching()) {
        this.saveSidebarWidth();
      }
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(ev) {
      // filter out if a user starts swiping with a second finger
      if (!this.isTouching()) {
        var touch = ev.targetTouches[0];
        this.setState({
          touchIdentifier: touch.identifier,
          touchStartX: touch.clientX,
          touchStartY: touch.clientY,
          touchCurrentX: touch.clientX,
          touchCurrentY: touch.clientY
        });
      }
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(ev) {
      if (this.isTouching()) {
        for (var ind = 0; ind < ev.targetTouches.length; ind++) {
          // we only care about the finger that we are tracking
          if (ev.targetTouches[ind].identifier === this.state.touchIdentifier) {
            this.setState({
              touchCurrentX: ev.targetTouches[ind].clientX,
              touchCurrentY: ev.targetTouches[ind].clientY
            });
            break;
          }
        }
      }
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd() {
      if (this.isTouching()) {
        // trigger a change to open if sidebar has been dragged beyond dragToggleDistance
        var touchWidth = this.touchSidebarWidth();

        if (this.props.open && touchWidth < this.state.sidebarWidth - this.props.dragToggleDistance || !this.props.open && touchWidth > this.props.dragToggleDistance) {
          this.props.onSetOpen(!this.props.open);
        }

        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    }

    // This logic helps us prevents the user from sliding the sidebar horizontally
    // while scrolling the sidebar vertically. When a scroll event comes in, we're
    // cancelling the ongoing gesture if it did not move horizontally much.

  }, {
    key: 'onScroll',
    value: function onScroll() {
      if (this.isTouching() && this.inCancelDistanceOnScroll()) {
        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    }

    // True if the on going gesture X distance is less than the cancel distance

  }, {
    key: 'inCancelDistanceOnScroll',
    value: function inCancelDistanceOnScroll() {
      var cancelDistanceOnScroll = void 0;

      if (this.props.pullRight) {
        cancelDistanceOnScroll = Math.abs(this.state.touchCurrentX - this.state.touchStartX) < CANCEL_DISTANCE_ON_SCROLL;
      } else {
        cancelDistanceOnScroll = Math.abs(this.state.touchStartX - this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
      }
      return cancelDistanceOnScroll;
    }
  }, {
    key: 'isTouching',
    value: function isTouching() {
      return this.state.touchIdentifier !== null;
    }
  }, {
    key: 'overlayClicked',
    value: function overlayClicked() {
      if (this.props.open) {
        this.props.onSetOpen(false);
      }
    }
  }, {
    key: 'saveSidebarWidth',
    value: function saveSidebarWidth() {
      var width = this.sidebar.offsetWidth;

      if (width !== this.state.sidebarWidth) {
        this.setState({ sidebarWidth: width });
      }
    }
  }, {
    key: 'saveSidebarRef',
    value: function saveSidebarRef(node) {
      this.sidebar = node;
    }

    // calculate the sidebarWidth based on current touch info

  }, {
    key: 'touchSidebarWidth',
    value: function touchSidebarWidth() {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (this.props.pullRight) {
        if (this.props.open && window.innerWidth - this.state.touchStartX < this.state.sidebarWidth) {
          if (this.state.touchCurrentX > this.state.touchStartX) {
            return this.state.sidebarWidth + this.state.touchStartX - this.state.touchCurrentX;
          }
          return this.state.sidebarWidth;
        }
        return Math.min(window.innerWidth - this.state.touchCurrentX, this.state.sidebarWidth);
      }

      if (this.props.open && this.state.touchStartX < this.state.sidebarWidth) {
        if (this.state.touchCurrentX > this.state.touchStartX) {
          return this.state.sidebarWidth;
        }
        return this.state.sidebarWidth - this.state.touchStartX + this.state.touchCurrentX;
      }
      return Math.min(this.state.touchCurrentX, this.state.sidebarWidth);
    }
  }, {
    key: 'render',
    value: function render() {
      var sidebarStyle = _extends({}, defaultStyles.sidebar, this.props.styles.sidebar);
      var contentStyle = _extends({}, defaultStyles.content, this.props.styles.content);
      var overlayStyle = _extends({}, defaultStyles.overlay, this.props.styles.overlay);
      var useTouch = this.state.dragSupported && this.props.touch;
      var isTouching = this.isTouching();
      var rootProps = {
        className: this.props.rootClassName,
        style: _extends({}, defaultStyles.root, this.props.styles.root),
        role: "navigation"
      };
      var dragHandle = void 0;

      // sidebarStyle right/left
      if (this.props.pullRight) {
        sidebarStyle.right = 0;
        sidebarStyle.transform = 'translateX(100%)';
        sidebarStyle.WebkitTransform = 'translateX(100%)';
        if (this.props.shadow) {
          sidebarStyle.boxShadow = '-2px 2px 4px rgba(0, 0, 0, 0.15)';
        }
      } else {
        sidebarStyle.left = 0;
        sidebarStyle.transform = 'translateX(-100%)';
        sidebarStyle.WebkitTransform = 'translateX(-100%)';
        if (this.props.shadow) {
          sidebarStyle.boxShadow = '2px 2px 4px rgba(0, 0, 0, 0.15)';
        }
      }

      if (isTouching) {
        var percentage = this.touchSidebarWidth() / this.state.sidebarWidth;

        // slide open to what we dragged
        if (this.props.pullRight) {
          sidebarStyle.transform = 'translateX(' + (1 - percentage) * 100 + '%)';
          sidebarStyle.WebkitTransform = 'translateX(' + (1 - percentage) * 100 + '%)';
        } else {
          sidebarStyle.transform = 'translateX(-' + (1 - percentage) * 100 + '%)';
          sidebarStyle.WebkitTransform = 'translateX(-' + (1 - percentage) * 100 + '%)';
        }

        // fade overlay to match distance of drag
        overlayStyle.opacity = percentage;
        overlayStyle.visibility = 'visible';
      } else if (this.props.docked) {
        // show sidebar
        if (this.state.sidebarWidth !== 0) {
          sidebarStyle.transform = 'translateX(0%)';
          sidebarStyle.WebkitTransform = 'translateX(0%)';
        }

        // make space on the left/right side of the content for the sidebar
        if (this.props.pullRight) {
          contentStyle.right = this.state.sidebarWidth + 'px';
        } else {
          contentStyle.left = this.state.sidebarWidth + 'px';
        }
      } else if (this.props.open) {
        // slide open sidebar
        sidebarStyle.transform = 'translateX(0%)';
        sidebarStyle.WebkitTransform = 'translateX(0%)';

        // show overlay
        overlayStyle.opacity = 1;
        overlayStyle.visibility = 'visible';
      }

      if (isTouching || !this.props.transitions) {
        sidebarStyle.transition = 'none';
        sidebarStyle.WebkitTransition = 'none';
        contentStyle.transition = 'none';
        overlayStyle.transition = 'none';
      }

      if (useTouch) {
        if (this.props.open) {
          rootProps.onTouchStart = this.onTouchStart;
          rootProps.onTouchMove = this.onTouchMove;
          rootProps.onTouchEnd = this.onTouchEnd;
          rootProps.onTouchCancel = this.onTouchEnd;
          rootProps.onScroll = this.onScroll;
        } else {
          var dragHandleStyle = _extends({}, defaultStyles.dragHandle, this.props.styles.dragHandle);
          dragHandleStyle.width = this.props.touchHandleWidth;

          // dragHandleStyle right/left
          if (this.props.pullRight) {
            dragHandleStyle.right = 0;
          } else {
            dragHandleStyle.left = 0;
          }

          dragHandle = _react2.default.createElement('div', { style: dragHandleStyle,
            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd });
        }
      }

      return _react2.default.createElement('div', rootProps, _react2.default.createElement('div', { className: this.props.sidebarClassName, style: sidebarStyle, ref: this.saveSidebarRef }, this.props.sidebar), _react2.default.createElement('div', { className: this.props.overlayClassName,
        style: overlayStyle,
        role: 'presentation',
        tabIndex: '0',
        onClick: this.overlayClicked
      }), _react2.default.createElement('div', { className: this.props.contentClassName, style: contentStyle }, dragHandle, this.props.children));
    }
  }]);

  return Sidebar;
}(_react.Component);

Sidebar.propTypes = {
  // main content to render
  children: _propTypes2.default.node.isRequired,

  // styles
  styles: _propTypes2.default.shape({
    root: _propTypes2.default.object,
    sidebar: _propTypes2.default.object,
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object,
    dragHandle: _propTypes2.default.object
  }),

  // root component optional class
  rootClassName: _propTypes2.default.string,

  // sidebar optional class
  sidebarClassName: _propTypes2.default.string,

  // content optional class
  contentClassName: _propTypes2.default.string,

  // overlay optional class
  overlayClassName: _propTypes2.default.string,

  // sidebar content to render
  sidebar: _propTypes2.default.node.isRequired,

  // boolean if sidebar should be docked
  docked: _propTypes2.default.bool,

  // boolean if sidebar should slide open
  open: _propTypes2.default.bool,

  // boolean if transitions should be disabled
  transitions: _propTypes2.default.bool,

  // boolean if touch gestures are enabled
  touch: _propTypes2.default.bool,

  // max distance from the edge we can start touching
  touchHandleWidth: _propTypes2.default.number,

  // Place the sidebar on the right
  pullRight: _propTypes2.default.bool,

  // Enable/Disable sidebar shadow
  shadow: _propTypes2.default.bool,

  // distance we have to drag the sidebar to toggle open state
  dragToggleDistance: _propTypes2.default.number,

  // callback called when the overlay is clicked
  onSetOpen: _propTypes2.default.func,

  // Intial sidebar width when page loads
  defaultSidebarWidth: _propTypes2.default.number
};

Sidebar.defaultProps = {
  docked: false,
  open: false,
  transitions: true,
  touch: true,
  touchHandleWidth: 20,
  pullRight: false,
  shadow: true,
  dragToggleDistance: 30,
  onSetOpen: function onSetOpen() {},
  styles: {},
  defaultSidebarWidth: 0
};

exports.default = Sidebar;

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e(__webpack_require__(1), __webpack_require__(0), __webpack_require__(1441)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(0), __webpack_require__(1441)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.SignatureCanvas = e(require("prop-types"), require("react"), require("trim-canvas")) : t.SignatureCanvas = e(t["prop-types"], t.react, t["trim-canvas"]);
}(this, function (t, e, n) {
  return function (t) {
    function e(o) {
      if (n[o]) return n[o].exports;var r = n[o] = { exports: {}, id: o, loaded: !1 };return t[o].call(r.exports, r, r.exports, e), r.loaded = !0, r.exports;
    }var n = {};return e.m = t, e.c = n, e.p = "", e(0);
  }([function (t, e, n) {
    "use strict";
    function o(t) {
      return t && t.__esModule ? t : { default: t };
    }function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }function i(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !e || "object" != (typeof e === "undefined" ? "undefined" : _typeof(e)) && "function" != typeof e ? t : e;
    }function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + (typeof e === "undefined" ? "undefined" : _typeof(e)));t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }Object.defineProperty(e, "__esModule", { value: !0 });var s = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
      }return t;
    },
        u = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }return function (e, n, o) {
        return n && t(e.prototype, n), o && t(e, o), e;
      };
    }(),
        c = n(3),
        l = o(c),
        d = n(4),
        f = o(d),
        h = n(5),
        p = o(h),
        v = n(1),
        _ = o(v),
        y = n(2),
        m = o(y),
        x = function (t) {
      function e() {
        var t, n, o, a;r(this, e);for (var s = arguments.length, u = Array(s), c = 0; c < s; c++) {
          u[c] = arguments[c];
        }return n = o = i(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(u))), o.clear = function () {
          var t = o._ctx,
              e = o._canvas;t.fillStyle = o.props.backgroundColor, t.clearRect(0, 0, e.width, e.height), t.fillRect(0, 0, e.width, e.height), o._reset();
        }, o.fromDataURL = function (t) {
          var e = new Image(),
              n = window.devicePixelRatio || 1,
              r = o._canvas.width / n,
              i = o._canvas.height / n;o._reset(), e.onload = function () {
            return o._ctx.drawImage(e, 0, 0, r, i);
          }, e.src = t, o._isEmpty = !1;
        }, o.getCanvas = function () {
          return o._canvas;
        }, o.getTrimmedCanvas = function () {
          var t = document.createElement("canvas");return t.width = o._canvas.width, t.height = o._canvas.height, t.getContext("2d").drawImage(o._canvas, 0, 0), (0, p.default)(t);
        }, o.isEmpty = function () {
          return o._isEmpty;
        }, o._resizeCanvas = function () {
          var t = o.props.canvasProps || {},
              e = t.width,
              n = t.height,
              r = o._ctx,
              i = o._canvas,
              a = Math.max(window.devicePixelRatio || 1, 1);e || (i.width = i.offsetWidth * a), n || (i.height = i.offsetHeight * a), e && n || r.scale(a, a);
        }, o._reset = function () {
          o.points = [], o._lastVelocity = 0, o._lastWidth = (o.props.minWidth + o.props.maxWidth) / 2, o._isEmpty = !0, o._ctx.fillStyle = o.props.penColor;
        }, o._handleMouseEvents = function () {
          o._mouseButtonDown = !1, o._canvas.addEventListener("mousedown", o._handleMouseDown), o._canvas.addEventListener("mousemove", o._handleMouseMove), document.addEventListener("mouseup", o._handleMouseUp), window.addEventListener("resize", o._resizeCanvas);
        }, o._handleTouchEvents = function () {
          o._canvas.style.msTouchAction = "none", o._canvas.addEventListener("touchstart", o._handleTouchStart), o._canvas.addEventListener("touchmove", o._handleTouchMove), document.addEventListener("touchend", o._handleTouchEnd);
        }, o.off = function () {
          o._canvas.removeEventListener("mousedown", o._handleMouseDown), o._canvas.removeEventListener("mousemove", o._handleMouseMove), document.removeEventListener("mouseup", o._handleMouseUp), o._canvas.removeEventListener("touchstart", o._handleTouchStart), o._canvas.removeEventListener("touchmove", o._handleTouchMove), document.removeEventListener("touchend", o._handleTouchEnd), window.removeEventListener("resize", o._resizeCanvas);
        }, o._handleMouseDown = function (t) {
          1 === t.which && (o._mouseButtonDown = !0, o._strokeBegin(t));
        }, o._handleMouseMove = function (t) {
          o._mouseButtonDown && o._strokeUpdate(t);
        }, o._handleMouseUp = function (t) {
          1 === t.which && o._mouseButtonDown && (o._mouseButtonDown = !1, o._strokeEnd(t));
        }, o._handleTouchStart = function (t) {
          var e = t.changedTouches[0];o._strokeBegin(e);
        }, o._handleTouchMove = function (t) {
          t.preventDefault();var e = t.changedTouches[0];o._strokeUpdate(e);
        }, o._handleTouchEnd = function (t) {
          var e = t.target === o._canvas;e && o._strokeEnd(t);
        }, o._strokeUpdate = function (t) {
          var e = o._createPoint(t);o._addPoint(e);
        }, o._strokeBegin = function (t) {
          o._reset(), o._strokeUpdate(t), o.props.onBegin(t);
        }, o._strokeDraw = function (t) {
          var e = o._ctx,
              n = "function" == typeof o.props.dotSize ? o.props.dotSize(o.props.minWidth, o.props.maxWidth) : o.props.dotSize;e.beginPath(), o._drawPoint(t.x, t.y, n), e.closePath(), e.fill();
        }, o._strokeEnd = function (t) {
          var e = o.points.length > 2,
              n = o.points[0];!e && n && o._strokeDraw(n), o.props.onEnd(t);
        }, o._createPoint = function (t) {
          var e = o._canvas.getBoundingClientRect();return new m.default(t.clientX - e.left, t.clientY - e.top);
        }, o._addPoint = function (t) {
          var e,
              n,
              r,
              i,
              a = o.points;a.push(t), a.length > 2 && (3 === a.length && a.unshift(a[0]), i = o._calculateCurveControlPoints(a[0], a[1], a[2]), e = i.c2, i = o._calculateCurveControlPoints(a[1], a[2], a[3]), n = i.c1, r = new _.default(a[1], e, n, a[2]), o._addCurve(r), a.shift());
        }, o._addCurve = function (t) {
          var e,
              n,
              r = t.startPoint,
              i = t.endPoint;e = i.velocityFrom(r), e = o.props.velocityFilterWeight * e + (1 - o.props.velocityFilterWeight) * o._lastVelocity, n = o._strokeWidth(e), o._drawCurve(t, o._lastWidth, n), o._lastVelocity = e, o._lastWidth = n;
        }, o._drawPoint = function (t, e, n) {
          var r = o._ctx;r.moveTo(t, e), r.arc(t, e, n, 0, 2 * Math.PI, !1), o._isEmpty = !1;
        }, o._drawCurve = function (t, e, n) {
          var r,
              i,
              a,
              s,
              u,
              c,
              l,
              d,
              f,
              h,
              p,
              v = o._ctx,
              _ = n - e;for (r = Math.floor(t.length()), v.beginPath(), a = 0; a < r; a++) {
            s = a / r, u = s * s, c = u * s, l = 1 - s, d = l * l, f = d * l, h = f * t.startPoint.x, h += 3 * d * s * t.control1.x, h += 3 * l * u * t.control2.x, h += c * t.endPoint.x, p = f * t.startPoint.y, p += 3 * d * s * t.control1.y, p += 3 * l * u * t.control2.y, p += c * t.endPoint.y, i = e + c * _, o._drawPoint(h, p, i);
          }v.closePath(), v.fill();
        }, o._strokeWidth = function (t) {
          return Math.max(o.props.maxWidth / (t + 1), o.props.minWidth);
        }, a = n, i(o, a);
      }return a(e, t), u(e, [{ key: "componentDidMount", value: function value() {
          this._ctx = this._canvas.getContext("2d"), this._handleMouseEvents(), this._handleTouchEvents(), this._resizeCanvas(), this.clear();
        } }, { key: "componentWillUnmount", value: function value() {
          this.off();
        } }, { key: "_calculateCurveControlPoints", value: function value(t, e, n) {
          var o = t.x - e.x,
              r = t.y - e.y,
              i = e.x - n.x,
              a = e.y - n.y,
              s = { x: (t.x + e.x) / 2, y: (t.y + e.y) / 2 },
              u = { x: (e.x + n.x) / 2, y: (e.y + n.y) / 2 },
              c = Math.sqrt(o * o + r * r),
              l = Math.sqrt(i * i + a * a),
              d = s.x - u.x,
              f = s.y - u.y,
              h = l / (c + l),
              p = { x: u.x + d * h, y: u.y + f * h },
              v = e.x - p.x,
              _ = e.y - p.y;return { c1: new m.default(s.x + v, s.y + _), c2: new m.default(u.x + v, u.y + _) };
        } }, { key: "render", value: function value() {
          var t = this,
              e = this.props.canvasProps;return f.default.createElement("canvas", s({ ref: function ref(e) {
              t._canvas = e;
            } }, e));
        } }]), e;
    }(d.Component);x.propTypes = { velocityFilterWeight: l.default.number, minWidth: l.default.number, maxWidth: l.default.number, dotSize: l.default.oneOfType([l.default.number, l.default.func]), penColor: l.default.string, onEnd: l.default.func, onBegin: l.default.func, canvasProps: l.default.object }, x.defaultProps = { velocityFilterWeight: .7, minWidth: .5, maxWidth: 2.5, dotSize: function dotSize(t, e) {
        return (t + e) / 2;
      }, penColor: "black", backgroundColor: "rgba(0,0,0,0)", onEnd: function onEnd() {}, onBegin: function onBegin() {} }, e.default = x;
  }, function (t, e) {
    "use strict";
    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }return function (e, n, o) {
        return n && t(e.prototype, n), o && t(e, o), e;
      };
    }(),
        r = function () {
      function t(e, o, r, i) {
        n(this, t), this.startPoint = e, this.control1 = o, this.control2 = r, this.endPoint = i;
      }return o(t, [{ key: "length", value: function t() {
          var e,
              n,
              o,
              r,
              i,
              a,
              s,
              u,
              c = 10,
              t = 0;for (e = 0; e <= c; e++) {
            n = e / c, o = this._point(n, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), r = this._point(n, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y), e > 0 && (s = o - i, u = r - a, t += Math.sqrt(s * s + u * u)), i = o, a = r;
          }return t;
        } }, { key: "_point", value: function value(t, e, n, o, r) {
          return e * (1 - t) * (1 - t) * (1 - t) + 3 * n * (1 - t) * (1 - t) * t + 3 * o * (1 - t) * t * t + r * t * t * t;
        } }]), t;
    }();e.default = r;
  }, function (t, e) {
    "use strict";
    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }Object.defineProperty(e, "__esModule", { value: !0 });var o = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }return function (e, n, o) {
        return n && t(e.prototype, n), o && t(e, o), e;
      };
    }(),
        r = function () {
      function t(e, o, r) {
        n(this, t), this.x = e, this.y = o, this.time = r || new Date().getTime();
      }return o(t, [{ key: "velocityFrom", value: function value(t) {
          return this.time !== t.time ? this.distanceTo(t) / (this.time - t.time) : 1;
        } }, { key: "distanceTo", value: function value(t) {
          return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2));
        } }]), t;
    }();e.default = r;
  }, function (e, n) {
    e.exports = t;
  }, function (t, n) {
    t.exports = e;
  }, function (t, e) {
    t.exports = n;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _find = __webpack_require__(662);

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__(667);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1265);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(2432);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(480);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;

        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;

          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;

        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;

        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;

        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;

        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1265);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(480);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;

        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;

        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(480);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2437);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule StaticContainer.react
 * @typechecks
 * 
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _get = function get(_x, _x2, _x3) {
  var _again = true;_function: while (_again) {
    var object = _x,
        property = _x2,
        receiver = _x3;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);if (parent === null) {
        return undefined;
      } else {
        _x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;
      }
    } else if ('value' in desc) {
      return desc.value;
    } else {
      var getter = desc.get;if (getter === undefined) {
        return undefined;
      }return getter.call(receiver);
    }
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);

/**
 * Renders static content efficiently by allowing React to short-circuit the
 * reconciliation process. This component should be used when you know that a
 * subtree of components will never need to be updated.
 *
 *   var someValue = ...; // We know for certain this value will never change.
 *   return (
 *     <StaticContainer>
 *       <MyComponent value={someValue} />
 *     </StaticContainer>
 *   );
 *
 * Typically, you will not need to use this component and should opt for normal
 * React reconciliation.
 */

var StaticContainer = function (_React$Component) {
  _inherits(StaticContainer, _React$Component);

  function StaticContainer() {
    _classCallCheck(this, StaticContainer);

    _get(Object.getPrototypeOf(StaticContainer.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(StaticContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !!nextProps.shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var child = this.props.children;
      if (child === null || child === false) {
        return null;
      }
      return React.Children.only(child);
    }
  }]);

  return StaticContainer;
}(React.Component);

module.exports = StaticContainer;

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateNodeHeight;
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var browser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE = browser ? !!document.documentElement.currentStyle : false;
var boxSizingProp = function () {
  if (!browser) {
    return 'box-sizing';
  }
  var documentStyle = window.getComputedStyle(document.documentElement);
  // TODO: remove prefixed - they are probably obsolete, were introduced in by df79cf502630744d40233b64cad01770e5584610 in 2014
  return documentStyle.getPropertyValue('box-sizing') ? 'box-sizing' : documentStyle.getPropertyValue('-moz-box-sizing') ? '-moz-box-sizing' : documentStyle.getPropertyValue('-webkit-box-sizing') ? '-webkit-box-sizing' : 'box-sizing';
}();

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  'height': '0',
  'visibility': 'hidden',
  'overflow': 'hidden',
  'position': 'absolute',
  'z-index': '-1000',
  'top': '0',
  'right': '0'
};

var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', boxSizingProp];

var computedStyleCache = {};
var hiddenTextarea = void 0;

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } else if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  // Copy all CSS properties that have an impact on the height of the content in
  // the textbox

  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle;

  // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  Object.keys(sizingStyle).map(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).map(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';

  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = 'x';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
    }
  }
  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
}

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // TODO: generate id in constructor + clear cache in componentWillUnmount
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});

  var boxSizing = sizingStyle[boxSizingProp];

  // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths
  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);

  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);

  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2442);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2440)();
}

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(481);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(2445);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(2444);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1267);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';

CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _addClass = __webpack_require__(937);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(939);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(621);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(948);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(481);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(44);

var _PropTypes = __webpack_require__(1267);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';

CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__(1594);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(481);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(260);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2448);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2447);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
};

var AutoSizer = function (_React$PureComponent) {
  inherits(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = createDetectElementResize(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      // Avoid rendering children before the initial measurements have been collected.
      // At best this would just be wasting cycles.
      var bailoutOnChildren = false;

      if (!disableHeight) {
        if (height === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        if (width === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.width = 0;
        childParams.width = width;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', {
        className: className,
        ref: this._setRef,
        style: _extends({}, outerStyle, style) }, !bailoutOnChildren && children(childParams));
    }
  }]);
  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};

/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeOffsetPixels;

var _parseOffsetAsPercentage = __webpack_require__(2456);

var _parseOffsetAsPercentage2 = _interopRequireDefault(_parseOffsetAsPercentage);

var _parseOffsetAsPixels = __webpack_require__(2457);

var _parseOffsetAsPixels2 = _interopRequireDefault(_parseOffsetAsPixels);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = (0, _parseOffsetAsPixels2.default)(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = (0, _parseOffsetAsPercentage2.default)(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}
module.exports = exports['default'];

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debugLog;
function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}
module.exports = exports['default'];

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureChildrenIsSingleDOMElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isDOMElement = __webpack_require__(2454);

var _isDOMElement2 = _interopRequireDefault(_isDOMElement);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Raise an error if "children" isn't a single DOM Element
 *
 * @param {React.element|null} children
 * @return {undefined}
 */
function ensureChildrenIsSingleDOMElement(children) {
  if (children) {
    _react2.default.Children.only(children);

    if (!(0, _isDOMElement2.default)(children)) {
      throw new Error('You must wrap any Component Elements passed to Waypoint in a DOM Element (eg; a <div>).');
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCurrentPosition;

var _constants = __webpack_require__(1268);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return _constants2.default.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return _constants2.default.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return _constants2.default.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return _constants2.default.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return _constants2.default.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return _constants2.default.above;
  }

  return _constants2.default.invisible;
}
module.exports = exports['default'];

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDOMElement;
/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}
module.exports = exports['default'];

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onNextTick;
var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function unsubscribe() {
    if (!isSubscribed) {
      return;
    }

    isSubscribed = false;

    var index = timeoutQueue.indexOf(cb);
    if (index === -1) {
      return;
    }

    timeoutQueue.splice(index, 1);

    if (!timeoutQueue.length && timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}
module.exports = exports["default"];

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseOffsetAsPercentage;
/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}
module.exports = exports['default'];

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseOffsetAsPixels;
/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}
module.exports = exports['default'];

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveScrollableAncestorProp;
function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(131);
var invariant = __webpack_require__(132);
var ReactPropTypesSecret = __webpack_require__(2461);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2459)();
}

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VariableSizeGrid */
/* unused harmony export VariableSizeList */
/* unused harmony export FixedSizeGrid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedSizeList; });
/* unused harmony export areEqual */
/* unused harmony export shouldComponentUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_memoize_one__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(2466);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };








// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = (typeof performance === 'undefined' ? 'undefined' : _typeof(performance)) === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex,
      data = _ref.data,
      rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (false) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsOverscanCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsOverscanRowsColumnsCount =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createGridComponent(_ref2) {
  var _class, _temp;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _style;

          itemStyleCache[key] = style = (_style = {
            position: 'absolute'
          }, _style[direction === 'rtl' ? 'right' : 'left'] = getColumnOffset(_this.props, columnIndex, _this._instanceProps), _style.top = getRowOffset(_this.props, rowIndex, _this._instanceProps), _style.height = getRowHeight(_this.props, rowIndex, _this._instanceProps), _style.width = getColumnWidth(_this.props, columnIndex, _this._instanceProps), _style);
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
          // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
          // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
          // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            switch (getRTLOffsetType()) {
              case 'negative':
                calculatedScrollLeft = -scrollLeft;
                break;

              case 'positive-descending':
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && (typeof outerRef === 'undefined' ? 'undefined' : _typeof(outerRef)) === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          switch (getRTLOffsetType()) {
            case 'negative':
              outerRef.scrollLeft = -scrollLeft;
              break;

            case 'positive-ascending':
              outerRef.scrollLeft = scrollLeft;
              break;

            default:
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _temp;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (false) {
    if (typeof overscanCount === 'number') {
      if (devWarningsOverscanCount && !devWarningsOverscanCount.has(instance)) {
        devWarningsOverscanCount.add(instance);
        console.warn('The overscanCount prop has been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (typeof overscanColumnsCount === 'number' || typeof overscanRowsCount === 'number') {
      if (devWarningsOverscanRowsColumnsCount && !devWarningsOverscanRowsColumnsCount.has(instance)) {
        devWarningsOverscanRowsColumnsCount.add(instance);
        console.warn('The overscanColumnsCount and overscanRowsCount props have been deprecated. ' + 'Please use the overscanColumnCount and overscanRowCount props instead.');
      }
    }

    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName && !devWarningsTagName.has(instance)) {
        devWarningsTagName.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children === 'undefined' ? 'undefined' : _typeof(children)) + "\" was specified."));
    }

    switch (direction) {
      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    if (typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Grids must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width === 'undefined' ? 'undefined' : _typeof(width)) + "\" was specified."));
    }

    if (typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Grids must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height === 'undefined' ? 'undefined' : _typeof(height)) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        // Because we only take into account the scrollbar size when calculating minOffset
        // this value can be larger than maxOffset when at the end of the list
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (false) {
      if (typeof columnWidth !== 'function') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth === 'undefined' ? 'undefined' : _typeof(columnWidth)) + "\" was specified."));
      } else if (typeof rowHeight !== 'function') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight === 'undefined' ? 'undefined' : _typeof(rowHeight)) + "\" was specified."));
      }
    }
  }
});

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (false) {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection =
    /*#__PURE__*/
    new WeakSet();
    devWarningsTagName$1 =
    /*#__PURE__*/
    new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class, _temp;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _style;

          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          itemStyleCache[index] = style = (_style = {
            position: 'absolute'
          }, _style[direction === 'rtl' ? 'right' : 'left'] = isHorizontal ? _offset : 0, _style.top = !isHorizontal ? _offset : 0, _style.height = !isHorizontal ? size : '100%', _style.width = isHorizontal ? size : '100%', _style);
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_memoize_one__["a" /* default */])(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && (typeof outerRef === 'undefined' ? 'undefined' : _typeof(outerRef)) === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          initialScrollOffset = _this$props2.initialScrollOffset,
          layout = _this$props2.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          layout = _this$props3.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemCount = _this$props4.itemCount,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey,
          layout = _this$props4.layout,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    }; // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.


    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props,
          itemCount = _this$props5.itemCount,
          overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _temp;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (false) {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children === 'undefined' ? 'undefined' : _typeof(children)) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width === 'undefined' ? 'undefined' : _typeof(width)) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height === 'undefined' ? 'undefined' : _typeof(height)) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList =
/*#__PURE__*/
createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (false) {
      if (typeof itemSize !== 'function') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize === 'undefined' ? 'undefined' : _typeof(itemSize)) + "\" was specified."));
      }
    }
  }
});

var FixedSizeGrid =
/*#__PURE__*/
createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(width / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(height / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (false) {
      if (typeof columnWidth !== 'number') {
        throw Error('An invalid "columnWidth" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (columnWidth === null ? 'null' : typeof columnWidth === 'undefined' ? 'undefined' : _typeof(columnWidth)) + "\" was specified."));
      }

      if (typeof rowHeight !== 'number') {
        throw Error('An invalid "rowHeight" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (rowHeight === null ? 'null' : typeof rowHeight === 'undefined' ? 'undefined' : _typeof(rowHeight)) + "\" was specified."));
      }
    }
  }
});

var FixedSizeList =
/*#__PURE__*/
createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (false) {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize === 'undefined' ? 'undefined' : _typeof(itemSize)) + "\" was specified."));
      }
    }
  }
});

// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }

  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }

  return false;
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo

function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style,
      prevRest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(prevProps, ["style"]);

  var nextStyle = nextProps.style,
      nextRest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(nextProps, ["style"]);

  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate

function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}


//# sourceMappingURL=index.esm.js.map

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1270);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var setPropTypes = function setPropTypes(propTypes) {
  return (0, _setStatic2.default)('propTypes', propTypes);
};

exports.default = setPropTypes;

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

exports.default = mapValues;

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _mapValues = __webpack_require__(2471);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-console */

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var WithHandlers = function (_Component) {
      _inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(_react.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = (0, _mapValues2.default)(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

exports.default = withHandlers;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__(2468);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(174);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(204);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var WithState = function (_Component) {
      _inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        _classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return WithState;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

exports.default = withState;

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(618);
var callBind = __webpack_require__(1858);

var implementation = __webpack_require__(1273);
var getPolyfill = __webpack_require__(1274);
var shim = __webpack_require__(2478);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(618).supportsDescriptors;
var getPolyfill = __webpack_require__(1274);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["a"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    } else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Button__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_Modal__ = __webpack_require__(1344);















/**
 * A Confirm modal gives the user a choice to confirm or cancel an action/
 * @see Modal
 */

var Confirm =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Confirm, _Component);

  function Confirm() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Confirm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Confirm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCancel", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onCancel', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCancelOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          _this.handleCancel(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleConfirmOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onConfirm', e, _this.props);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Confirm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelButton = _this$props.cancelButton,
          confirmButton = _this$props.confirmButton,
          content = _this$props.content,
          header = _this$props.header,
          open = _this$props.open,
          size = _this$props.size;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["b" /* getUnhandledProps */])(Confirm, this.props); // `open` is auto controlled by the Modal
      // It cannot be present (even undefined) with `defaultOpen`
      // only apply it if the user provided an open prop

      var openProp = {};
      if (__WEBPACK_IMPORTED_MODULE_8_lodash_has___default()(this.props, 'open')) openProp.open = open;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, openProp, {
        size: size,
        onClose: this.handleCancel
      }), __WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Header.create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Content.create(content, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Actions, null, __WEBPACK_IMPORTED_MODULE_13__elements_Button__["a" /* default */].create(cancelButton, {
        autoGenerateKey: false,
        overrideProps: this.handleCancelOverrides
      }), __WEBPACK_IMPORTED_MODULE_13__elements_Button__["a" /* default */].create(confirmButton, {
        autoGenerateKey: false,
        defaultProps: {
          primary: true
        },
        overrideProps: this.handleConfirmOverrides
      })));
    }
  }]);

  return Confirm;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Confirm, "defaultProps", {
  cancelButton: 'Cancel',
  confirmButton: 'OK',
  content: 'Are you sure?',
  size: 'small'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Confirm, "handledProps", ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"]);

Confirm.propTypes =  false ? {
  /** The cancel button text. */
  cancelButton: customPropTypes.itemShorthand,

  /** The OK button text. */
  confirmButton: customPropTypes.itemShorthand,

  /** The ModalContent text. */
  content: customPropTypes.itemShorthand,

  /** The ModalHeader text. */
  header: customPropTypes.itemShorthand,

  /**
   * Called when the Modal is closed without clicking confirm.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onCancel: PropTypes.func,

  /**
   * Called when the OK button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onConfirm: PropTypes.func,

  /** Whether or not the modal is visible. */
  open: PropTypes.bool,

  /** A Confirm can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen'])
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Confirm);

/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirm__ = __webpack_require__(2481);
/* unused harmony reexport default */



/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MountNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_NodeRegistry__ = __webpack_require__(2484);












var nodeRegistry = new __WEBPACK_IMPORTED_MODULE_11__lib_NodeRegistry__["a" /* default */]();
/**
 * A component that allows to manage classNames on a DOM node in declarative manner.
 */

var MountNode =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(MountNode, _Component);

  function MountNode() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MountNode);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(MountNode).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MountNode, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var nextClassName = _ref.className;
      var currentClassName = this.props.className;
      return nextClassName !== currentClassName;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var nodeRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props);
      nodeRegistry.add(nodeRef, this);
      nodeRegistry.emit(nodeRef, __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      nodeRegistry.emit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props), __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var nodeRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props);
      nodeRegistry.del(nodeRef, this);
      nodeRegistry.emit(nodeRef, __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return MountNode;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(MountNode, "handledProps", ["className", "node"]);


MountNode.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** The DOM node where we will apply class names. Defaults to document.body. */
  node: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject])
} : {};

/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NodeRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);



var NodeRegistry = function NodeRegistry() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NodeRegistry);

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "add", function (nodeRef, component) {
    if (_this.nodes.has(nodeRef)) {
      var set = _this.nodes.get(nodeRef);

      set.add(component);
      return;
    }

    _this.nodes.set(nodeRef, new Set([component]));
  });

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "del", function (nodeRef, component) {
    if (!_this.nodes.has(nodeRef)) return;

    var set = _this.nodes.get(nodeRef);

    if (set.size === 1) {
      _this.nodes.delete(nodeRef);

      return;
    }

    set.delete(component);
  });

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "emit", function (nodeRef, callback) {
    callback(nodeRef, _this.nodes.get(nodeRef));
  });

  this.nodes = new Map();
};



/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__ = __webpack_require__(2741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(2726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__ = __webpack_require__(2724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__ = __webpack_require__(2736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__ = __webpack_require__(2725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__ = __webpack_require__(2739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__);









var computeClassNames = __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default.a, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default()('props.className'), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default()(/\s+/)), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a), __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default.a);

/* harmony default export */ __webpack_exports__["a"] = (computeClassNames);

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);


var computeClassNamesDifference = function computeClassNamesDifference(prevClassNames, currentClassNames) {
  return [__WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(currentClassNames, prevClassNames), __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(prevClassNames, currentClassNames)];
};

/* harmony default export */ __webpack_exports__["a"] = (computeClassNamesDifference);

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_memoize__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);




var toRef = __WEBPACK_IMPORTED_MODULE_1_lodash_memoize___default()(function (node) {
  return {
    current: node
  };
});
/**
 * Given `this.props`, return a `node` value or undefined.
 *
 * @param {object|React.RefObject} props Component's props
 * @return {React.RefObject|undefined}
 */

var getNodeRefFromProps = function getNodeRefFromProps(props) {
  var node = props.node;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["w" /* isBrowser */])()) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["u" /* isRefObject */])(node)) return node;
    return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(node) ? toRef(document.body) : toRef(node);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getNodeRefFromProps);

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeClassNames__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__ = __webpack_require__(2486);




var prevClassNames = new Map();
/**
 * @param {React.RefObject} nodeRef
 * @param {Object[]} components
 */

var handleClassNamesChange = function handleClassNamesChange(nodeRef, components) {
  var currentClassNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__computeClassNames__["a" /* default */])(components);

  var _computeClassNamesDif = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__["a" /* default */])(prevClassNames.get(nodeRef), currentClassNames),
      _computeClassNamesDif2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_computeClassNamesDif, 2),
      forAdd = _computeClassNamesDif2[0],
      forRemoval = _computeClassNamesDif2[1];

  if (nodeRef.current) {
    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forAdd, function (className) {
      return nodeRef.current.classList.add(className);
    });

    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forRemoval, function (className) {
      return nodeRef.current.classList.remove(className);
    });
  }

  prevClassNames.set(nodeRef, currentClassNames);
};

/* harmony default export */ __webpack_exports__["a"] = (handleClassNamesChange);

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Menu__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PaginationItem__ = __webpack_require__(1276);

















/**
 * A component to render a pagination.
 */

var Pagination =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Pagination, _Component);

  function Pagination() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Pagination)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var nextActivePage = _ref.value;
      var prevActivePage = _this.state.activePage; // Heads up! We need the cast to the "number" type there, as `activePage` can be a string

      if (+prevActivePage === +nextActivePage) return;

      _this.trySetState({
        activePage: nextActivePage
      });

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onPageChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        activePage: nextActivePage
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (active, type, value) {
      return function (predefinedProps) {
        return {
          active: active,
          type: type,
          key: "".concat(type, "-").concat(value),
          onClick: function onClick(e, itemProps) {
            __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

            if (itemProps.type !== 'ellipsisItem') _this.handleItemClick(e, itemProps);
          }
        };
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          boundaryRange = _this$props.boundaryRange,
          disabled = _this$props.disabled,
          ellipsisItem = _this$props.ellipsisItem,
          siblingRange = _this$props.siblingRange,
          totalPages = _this$props.totalPages;
      var activePage = this.state.activePage;
      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["G" /* createPaginationItems */])({
        activePage: activePage,
        boundaryRange: boundaryRange,
        hideEllipsis: __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(ellipsisItem),
        siblingRange: siblingRange,
        totalPages: totalPages
      });
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(Pagination, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__collections_Menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        "aria-label": ariaLabel,
        pagination: true,
        role: "navigation"
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(items, function (_ref2) {
        var active = _ref2.active,
            type = _ref2.type,
            value = _ref2.value;
        return __WEBPACK_IMPORTED_MODULE_16__PaginationItem__["a" /* default */].create(_this2.props[type], {
          defaultProps: {
            content: value,
            disabled: disabled,
            value: value
          },
          overrideProps: _this2.handleItemOverrides(active, type, value)
        });
      }));
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "autoControlledProps", ['activePage']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "defaultProps", {
  'aria-label': 'Pagination Navigation',
  boundaryRange: 1,
  ellipsisItem: '...',
  firstItem: {
    'aria-label': 'First item',
    content: '«'
  },
  lastItem: {
    'aria-label': 'Last item',
    content: '»'
  },
  nextItem: {
    'aria-label': 'Next item',
    content: '⟩'
  },
  pageItem: {},
  prevItem: {
    'aria-label': 'Previous item',
    content: '⟨'
  },
  siblingRange: 1
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "Item", __WEBPACK_IMPORTED_MODULE_16__PaginationItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "handledProps", ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"]);


Pagination.propTypes =  false ? {
  /** A pagination item can have an aria label. */
  'aria-label': PropTypes.string,

  /** Initial activePage value. */
  defaultActivePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active page. */
  activePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Number of always visible pages at the beginning and end. */
  boundaryRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A pagination can be disabled. */
  disabled: PropTypes.bool,

  /** A shorthand for PaginationItem. */
  ellipsisItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  firstItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  lastItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  nextItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  pageItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  prevItem: customPropTypes.itemShorthand,

  /**
   * Called on change of an active page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onPageChange: PropTypes.func,

  /** Number of always visible pages before and after the current one. */
  siblingRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Total number of pages. */
  totalPages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
} : {};

/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(2489);
/* unused harmony reexport default */



/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PortalInner__ = __webpack_require__(1277);

















/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */
var Portal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Portal, _Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "contentRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "latestDocumentMouseDownEvent", null);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseDown", function (e) {
      _this.latestDocumentMouseDownEvent = e;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      var closeOnDocumentClick = _this.props.closeOnDocumentClick;
      var currentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;

      if (!_this.contentRef.current || // no portal
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["x" /* doesNodeContainClick */])(_this.triggerRef.current, e) || // event happened in trigger (delegate to trigger handlers)
      currentMouseDownEvent && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["x" /* doesNodeContainClick */])(_this.contentRef.current, currentMouseDownEvent) || // event originated in the portal but was ended outside
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["x" /* doesNodeContainClick */])(_this.contentRef.current, e) // event happened in the portal
      ) {
          return;
        } // ignore the click


      if (closeOnDocumentClick) {
        _this.close(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleEscape", function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.Escape) return;

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMouseLeave", function (e) {
      var _this$props = _this.props,
          closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave,
          mouseLeaveDelay = _this$props.mouseLeaveDelay;
      if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children

      if (e.target !== _this.contentRef.current) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMouseEnter", function () {
      // In order to enable mousing from the trigger to the portal, we need to
      // clear the mouseleave timer that was set when leaving the trigger.
      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
      if (!closeOnPortalMouseLeave) return;
      clearTimeout(_this.mouseLeaveTimer);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerBlur", function (e) {
      var _this$props2 = _this.props,
          trigger = _this$props2.trigger,
          closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onBlur', e].concat(rest)); // IE 11 doesn't work with relatedTarget in blur events


      var target = e.relatedTarget || document.activeElement; // do not close if focus is given to the portal

      var didFocusPortal = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.contentRef.current, 'contains', target);

      if (!closeOnTriggerBlur || didFocusPortal) return;

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerClick", function (e) {
      var _this$props3 = _this.props,
          trigger = _this$props3.trigger,
          closeOnTriggerClick = _this$props3.closeOnTriggerClick,
          openOnTriggerClick = _this$props3.openOnTriggerClick;
      var open = _this.state.open; // Call original event handler

      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onClick', e].concat(rest));

      if (open && closeOnTriggerClick) {
        _this.close(e);
      } else if (!open && openOnTriggerClick) {
        _this.open(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerFocus", function (e) {
      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler

      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onFocus', e].concat(rest));

      if (!openOnTriggerFocus) return;

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerMouseLeave", function (e) {
      clearTimeout(_this.mouseEnterTimer);
      var _this$props5 = _this.props,
          trigger = _this$props5.trigger,
          closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave,
          mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler

      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onMouseLeave', e].concat(rest));

      if (!closeOnTriggerMouseLeave) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerMouseEnter", function (e) {
      clearTimeout(_this.mouseLeaveTimer);
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          mouseEnterDelay = _this$props6.mouseEnterDelay,
          openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler

      for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        rest[_key6 - 1] = arguments[_key6];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onMouseEnter', e].concat(rest));

      if (!openOnTriggerMouseEnter) return;
      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function (e) {
      var onOpen = _this.props.onOpen;
      if (onOpen) onOpen(e, _this.props);

      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openWithTimeout", function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, e);

      return setTimeout(function () {
        return _this.open(eventClone);
      }, delay || 0);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function (e) {
      var onClose = _this.props.onClose;
      if (onClose) onClose(e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeWithTimeout", function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, e);

      return setTimeout(function () {
        return _this.close(eventClone);
      }, delay || 0);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMount", function () {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onMount', null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUnmount", function () {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onUnmount', null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerRef", function (c) {
      _this.triggerRef.current = c;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* handleRef */])(_this.props.triggerRef, c);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up timers
      clearTimeout(this.mouseEnterTimer);
      clearTimeout(this.mouseLeaveTimer);
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          children = _this$props7.children,
          eventPool = _this$props7.eventPool,
          mountNode = _this$props7.mountNode,
          trigger = _this$props7.trigger;
      var open = this.state.open;
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"], null, open && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PortalInner__["a" /* default */], {
        innerRef: this.contentRef,
        mountNode: mountNode,
        onMount: this.handleMount,
        onUnmount: this.handleUnmount
      }, children), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mouseleave",
        on: this.handlePortalMouseLeave,
        pool: eventPool,
        target: this.contentRef
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mouseenter",
        on: this.handlePortalMouseEnter,
        pool: eventPool,
        target: this.contentRef
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mousedown",
        on: this.handleDocumentMouseDown,
        pool: eventPool
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "click",
        on: this.handleDocumentClick,
        pool: eventPool
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.handleEscape,
        pool: eventPool
      })), trigger && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Ref__["a" /* default */], {
        innerRef: this.handleTriggerRef
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["cloneElement"])(trigger, {
        onBlur: this.handleTriggerBlur,
        onClick: this.handleTriggerClick,
        onFocus: this.handleTriggerFocus,
        onMouseLeave: this.handleTriggerMouseLeave,
        onMouseEnter: this.handleTriggerMouseEnter
      })));
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_13__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "defaultProps", {
  closeOnDocumentClick: true,
  closeOnEscape: true,
  eventPool: 'default',
  openOnTriggerClick: true
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "autoControlledProps", ['open']);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "Inner", __WEBPACK_IMPORTED_MODULE_15__PortalInner__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "handledProps", ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"]);

Portal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: PropTypes.bool,

  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: PropTypes.bool,

  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: PropTypes.number,

  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: PropTypes.number,

  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: PropTypes.bool,

  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: PropTypes.bool,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node,

  /** Called with a ref to the trigger node. */
  triggerRef: customPropTypes.ref
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(489);




/**
 * A Radio is sugar for <Checkbox radio />.
 * Useful for exclusive groups of sliders or toggles.
 * @see Checkbox
 * @see Form
 */

function Radio(props) {
  var slider = props.slider,
      toggle = props.toggle,
      type = props.type;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(Radio, props); // const ElementType = getElementType(Radio, props)
  // radio, slider, toggle are exclusive
  // use an undefined radio if slider or toggle are present

  var radio = !(slider || toggle) || undefined;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    type: type,
    radio: radio,
    slider: slider,
    toggle: toggle
  }));
}

Radio.handledProps = ["slider", "toggle", "type"];
Radio.propTypes =  false ? {
  /** Format to emphasize the current selection state. */
  slider: Checkbox.propTypes.slider,

  /** Format to show an on or off choice. */
  toggle: Checkbox.propTypes.toggle,

  /** HTML input type, either checkbox or radio. */
  type: Checkbox.propTypes.type
} : {};
Radio.defaultProps = {
  type: 'radio'
};
/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefFindNode__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RefForward__ = __webpack_require__(1279);





/**
 * This component exposes a prop that supports functional and createRef() API and returns the DOM
 * node of both functional and class component children.
 */

function Ref(props) {
  var children = props.children,
      innerRef = props.innerRef;
  var child = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_is__["isForwardRef"])(child) ? __WEBPACK_IMPORTED_MODULE_4__RefForward__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__RefFindNode__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, {
    innerRef: innerRef
  }, child);
}

Ref.handledProps = ["children", "innerRef"];
Ref.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.element.isRequired,

  /**
   * Called when a child component will be mounted or updated.
   *
   * @param {HTMLElement} node - Referred node.
   */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
} : {};
Ref.FindNode = __WEBPACK_IMPORTED_MODULE_3__RefFindNode__["a" /* default */];
Ref.Forward = __WEBPACK_IMPORTED_MODULE_4__RefForward__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Ref);

/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_isVisible__ = __webpack_require__(2496);













/**
 * Responsive can control visibility of content.
 */

var Responsive =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Responsive, _Component);

  function Responsive() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Responsive);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Responsive)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      visible: true
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleResize", function (e) {
      if (_this.ticking) return;
      _this.ticking = true;
      _this.frameId = requestAnimationFrame(function () {
        return _this.handleUpdate(e);
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function (e) {
      _this.ticking = false;
      var visible = _this.state.visible;

      var width = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'getWidth');

      var nextVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_isVisible__["a" /* default */])(width, _this.props);
      if (visible !== nextVisible) _this.setState({
        visible: nextVisible
      });

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onUpdate', e, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        width: width
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Responsive, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var fireOnMount = this.props.fireOnMount;
      __WEBPACK_IMPORTED_MODULE_11__lib__["v" /* eventStack */].sub('resize', this.handleResize, {
        target: 'window'
      });
      if (fireOnMount) this.handleUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_11__lib__["v" /* eventStack */].unsub('resize', this.handleResize, {
        target: 'window'
      });
      cancelAnimationFrame(this.frameId);
    } // ----------------------------------------
    // Event handlers
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var children = this.props.children;
      var visible = this.state.visible;
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* getElementType */])(Responsive, this.props);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["b" /* getUnhandledProps */])(Responsive, this.props);
      if (visible) return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, rest, children);
      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var width = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(props, 'getWidth');

      var visible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_isVisible__["a" /* default */])(width, props);
      return {
        visible: visible
      };
    }
  }]);

  return Responsive;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "defaultProps", {
  getWidth: function getWidth() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["w" /* isBrowser */])() ? window.innerWidth : 0;
  }
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyMobile", {
  minWidth: 320,
  maxWidth: 767
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyTablet", {
  minWidth: 768,
  maxWidth: 991
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyComputer", {
  minWidth: 992
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyLargeScreen", {
  minWidth: 1200,
  maxWidth: 1919
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyWidescreen", {
  minWidth: 1920
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "handledProps", ["as", "children", "fireOnMount", "getWidth", "maxWidth", "minWidth", "onUpdate"]);


Responsive.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Called to get width of screen. Defaults to using `window.innerWidth` when in a browser;
   * otherwise, assumes a width of 0.
   */
  getWidth: PropTypes.func,

  /** The maximum width at which content will be displayed. */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The minimum width at which content will be displayed. */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called on update.
   *
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onUpdate: PropTypes.func
} : {};

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Responsive__ = __webpack_require__(2494);
/* unused harmony reexport default */



/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);


var fitsMaxWidth = function fitsMaxWidth(width, maxWidth) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(maxWidth) ? true : width <= maxWidth;
};

var fitsMinWidth = function fitsMinWidth(width, minWidth) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(minWidth) ? true : width >= minWidth;
};

var isVisible = function isVisible(width, _ref) {
  var maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth;
  return fitsMinWidth(width, minWidth) && fitsMaxWidth(width, maxWidth);
};

/* harmony default export */ __webpack_exports__["a"] = (isVisible);

/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(490);




/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */

function Select(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
    selection: true
  }));
}

Select.handledProps = ["options"];
Select.propTypes =  false ? {
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
Select.Divider = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Divider;
Select.Header = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Header;
Select.Item = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Item;
Select.Menu = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Menu;
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);















/**
 * A TextArea can be used to allow for extended user input.
 * @see Form
 */

var TextArea =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(TextArea, _Component);

  function TextArea() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return _this.ref.current.focus();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleInput", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onInput', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(TextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          value = _this$props.value;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(TextArea, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["c" /* getElementType */])(TextArea, this.props);
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Ref__["a" /* default */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        onChange: this.handleChange,
        onInput: this.handleInput,
        rows: rows,
        value: value
      })));
    }
  }]);

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TextArea, "defaultProps", {
  as: 'textarea',
  rows: 3
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TextArea, "handledProps", ["as", "onChange", "onInput", "rows", "value"]);

TextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /**
   * Called on change.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onChange: PropTypes.func,

  /**
   * Called on input.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onInput: PropTypes.func,

  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Portal__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Transition__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);
















/**
 * A sugar for `Portal` and `Transition`.
 * @see Portal
 * @see Transition
 */
var TransitionablePortal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(TransitionablePortal, _Component);

  function TransitionablePortal(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, TransitionablePortal);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(TransitionablePortal).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalClose", function () {
      _this.setState({
        portalOpen: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalOpen", function () {
      _this.setState({
        portalOpen: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTransitionHide", function (nothing, data) {
      var portalOpen = _this.state.portalOpen;

      _this.setState({
        transitionVisible: false
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClose', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: false,
        transitionVisible: false
      }));

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onHide', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: portalOpen,
        transitionVisible: false
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTransitionStart", function (nothing, data) {
      var portalOpen = _this.state.portalOpen;
      var status = data.status;
      var transitionVisible = status === __WEBPACK_IMPORTED_MODULE_13__modules_Transition__["a" /* default */].ENTERING;

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: portalOpen,
        transitionVisible: transitionVisible
      })); // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation


      if (!transitionVisible) return;

      _this.setState({
        transitionVisible: transitionVisible
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onOpen', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        transitionVisible: transitionVisible,
        portalOpen: true
      }));
    });

    _this.state = {
      portalOpen: props.open
    };
    return _this;
  } // ----------------------------------------
  // Lifecycle
  // ----------------------------------------


  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(TransitionablePortal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var open = _ref.open;
      this.setState({
        portalOpen: open
      });
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          transition = _this$props.transition;
      var _this$state = this.state,
          portalOpen = _this$state.portalOpen,
          transitionVisible = _this$state.transitionVisible;
      var open = portalOpen || transitionVisible;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(TransitionablePortal, this.props);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        open: open,
        onOpen: this.handlePortalOpen,
        onClose: this.handlePortalClose
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modules_Transition__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, transition, {
        transitionOnMount: true,
        onStart: this.handleTransitionStart,
        onHide: this.handleTransitionHide,
        visible: portalOpen
      }), children));
    }
  }]);

  return TransitionablePortal;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TransitionablePortal, "defaultProps", {
  transition: {
    animation: 'scale',
    duration: 400
  }
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TransitionablePortal, "handledProps", ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"]);


TransitionablePortal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onClose: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onHide: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onOpen: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onStart: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Transition props. */
  transition: PropTypes.object
} : {};

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransitionablePortal__ = __webpack_require__(2499);
/* unused harmony reexport default */



/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib__ = __webpack_require__(7);

















/**
 * Visibility provides a set of callbacks for when a content appears in the viewport.
 */

var Visibility =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Visibility, _Component);

  function Visibility() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Visibility);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Visibility)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "calculations", {
      bottomPassed: false,
      bottomVisible: false,
      fits: false,
      passing: false,
      offScreen: false,
      onScreen: false,
      topPassed: false,
      topVisible: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "firedCallbacks", []);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "fire", function (_ref, value) {
      var callback = _ref.callback,
          name = _ref.name;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          continuous = _this$props.continuous,
          once = _this$props.once; // Heads up! For the execution is required:
      // - current value correspond to the fired direction
      // - `continuous` is true or calculation values are different

      var matchesDirection = _this.calculations[value] !== reverse;
      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
      if (matchesDirection && executionPossible) _this.execute(callback, name); // Heads up! We should remove callback from the happened when it's not `once`

      if (!once) _this.firedCallbacks = __WEBPACK_IMPORTED_MODULE_11_lodash_without___default()(_this.firedCallbacks, name);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function () {
      if (_this.ticking) return;
      _this.ticking = true;
      _this.frameId = requestAnimationFrame(_this.update);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "update", function () {
      if (!_this.mounted) return;
      _this.ticking = false;
      _this.oldCalculations = _this.calculations;
      _this.calculations = _this.computeCalculations();
      _this.pageYOffset = _this.getPageYOffset();
      var _this$props2 = _this.props,
          onBottomPassed = _this$props2.onBottomPassed,
          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
          onBottomVisible = _this$props2.onBottomVisible,
          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
          onPassing = _this$props2.onPassing,
          onPassingReverse = _this$props2.onPassingReverse,
          onTopPassed = _this$props2.onTopPassed,
          onTopPassedReverse = _this$props2.onTopPassedReverse,
          onTopVisible = _this$props2.onTopVisible,
          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
          onOffScreen = _this$props2.onOffScreen,
          onOnScreen = _this$props2.onOnScreen,
          updateOn = _this$props2.updateOn;
      var forward = {
        bottomPassed: {
          callback: onBottomPassed,
          name: 'onBottomPassed'
        },
        bottomVisible: {
          callback: onBottomVisible,
          name: 'onBottomVisible'
        },
        passing: {
          callback: onPassing,
          name: 'onPassing'
        },
        offScreen: {
          callback: onOffScreen,
          name: 'onOffScreen'
        },
        onScreen: {
          callback: onOnScreen,
          name: 'onOnScreen'
        },
        topPassed: {
          callback: onTopPassed,
          name: 'onTopPassed'
        },
        topVisible: {
          callback: onTopVisible,
          name: 'onTopVisible'
        }
      };
      var reverse = {
        bottomPassed: {
          callback: onBottomPassedReverse,
          name: 'onBottomPassedReverse'
        },
        bottomVisible: {
          callback: onBottomVisibleReverse,
          name: 'onBottomVisibleReverse'
        },
        passing: {
          callback: onPassingReverse,
          name: 'onPassingReverse'
        },
        topPassed: {
          callback: onTopPassedReverse,
          name: 'onTopPassedReverse'
        },
        topVisible: {
          callback: onTopVisibleReverse,
          name: 'onTopVisibleReverse'
        }
      };

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onUpdate', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        calculations: _this.calculations
      }));

      _this.fireOnPassed(); // Heads up! Reverse callbacks should be fired first


      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(reverse, function (data, value) {
        return _this.fire(data, value, true);
      });

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(forward, function (data, value) {
        return _this.fire(data, value);
      });

      if (updateOn === 'repaint') _this.handleUpdate();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Visibility, [{
    key: "componentWillReceiveProps",
    // ----------------------------------------
    // Lifecycle
    // ----------------------------------------
    value: function componentWillReceiveProps(_ref2) {
      var continuous = _ref2.continuous,
          once = _ref2.once,
          context = _ref2.context,
          updateOn = _ref2.updateOn;
      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once || updateOn !== this.props.updateOn; // Heads up! We should clean up array of happened callbacks, if values of these props are changed

      if (cleanHappened) this.firedCallbacks = [];

      if (context !== this.props.context || updateOn !== this.props.updateOn) {
        this.unattachHandlers(this.props.context);
        this.attachHandlers(context, updateOn);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["w" /* isBrowser */])()) return;
      var _this$props3 = this.props,
          context = _this$props3.context,
          fireOnMount = _this$props3.fireOnMount,
          updateOn = _this$props3.updateOn;
      this.pageYOffset = this.getPageYOffset();
      this.attachHandlers(context, updateOn);
      if (fireOnMount) this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var context = this.props.context;
      this.unattachHandlers(context);
      this.mounted = false;
    }
  }, {
    key: "attachHandlers",
    value: function attachHandlers(context, updateOn) {
      if (updateOn === 'events') {
        if (context) {
          __WEBPACK_IMPORTED_MODULE_16__lib__["v" /* eventStack */].sub('resize', this.handleUpdate, {
            target: context
          });
          __WEBPACK_IMPORTED_MODULE_16__lib__["v" /* eventStack */].sub('scroll', this.handleUpdate, {
            target: context
          });
        }

        return;
      } // Heads up!
      // We will deal with `repaint` there


      this.handleUpdate();
    }
  }, {
    key: "unattachHandlers",
    value: function unattachHandlers(context) {
      if (context) {
        __WEBPACK_IMPORTED_MODULE_16__lib__["v" /* eventStack */].unsub('resize', this.handleUpdate, {
          target: context
        });
        __WEBPACK_IMPORTED_MODULE_16__lib__["v" /* eventStack */].unsub('scroll', this.handleUpdate, {
          target: context
        });
      }

      if (this.frameId) cancelAnimationFrame(this.frameId);
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "execute",
    value: function execute(callback, name) {
      var continuous = this.props.continuous;
      if (!callback) return; // Heads up! When `continuous` is true, callback will be fired always

      if (!continuous && __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(this.firedCallbacks, name)) return;
      callback(null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.props, {
        calculations: this.calculations
      }));
      this.firedCallbacks.push(name);
    }
  }, {
    key: "fireOnPassed",
    value: function fireOnPassed() {
      var _this2 = this;

      var _this$calculations = this.calculations,
          percentagePassed = _this$calculations.percentagePassed,
          pixelsPassed = _this$calculations.pixelsPassed;
      var onPassed = this.props.onPassed;

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(onPassed, function (callback, passed) {
        var pixelsValue = Number(passed);

        if (pixelsValue && pixelsPassed >= pixelsValue) {
          _this2.execute(callback, passed);

          return;
        }

        var matchPercentage = "".concat(passed).match(/^(\d+)%$/);
        if (!matchPercentage) return;
        var percentageValue = Number(matchPercentage[1]) / 100;
        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
      });
    }
  }, {
    key: "computeCalculations",
    // ----------------------------------------
    // Helpers
    // ----------------------------------------
    value: function computeCalculations() {
      var offset = this.props.offset;

      var _this$ref$current$get = this.ref.current.getBoundingClientRect(),
          bottom = _this$ref$current$get.bottom,
          height = _this$ref$current$get.height,
          top = _this$ref$current$get.top,
          width = _this$ref$current$get.width;

      var _normalizeOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["F" /* normalizeOffset */])(offset),
          _normalizeOffset2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_normalizeOffset, 2),
          topOffset = _normalizeOffset2[0],
          bottomOffset = _normalizeOffset2[1];

      var newOffset = this.getPageYOffset();
      var direction = newOffset > this.pageYOffset ? 'down' : 'up';
      var topPassed = top < topOffset;
      var bottomPassed = bottom < bottomOffset;
      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
      var percentagePassed = pixelsPassed / height;
      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
      var topVisible = top >= topOffset && top <= window.innerHeight;
      var fits = topVisible && bottomVisible;
      var passing = topPassed && !bottomPassed;
      var onScreen = (topVisible || topPassed) && !bottomPassed;
      var offScreen = !onScreen;
      return {
        bottomPassed: bottomPassed,
        bottomVisible: bottomVisible,
        direction: direction,
        fits: fits,
        height: height,
        passing: passing,
        percentagePassed: percentagePassed,
        pixelsPassed: pixelsPassed,
        offScreen: offScreen,
        onScreen: onScreen,
        topPassed: topPassed,
        topVisible: topVisible,
        width: width
      };
    }
  }, {
    key: "getPageYOffset",
    value: function getPageYOffset() {
      var context = this.props.context;

      if (context) {
        // Heads up! `window` doesn't have `pageYOffset` property
        return context === window ? window.pageYOffset : context.scrollTop;
      }

      return 0;
    } // ----------------------------------------
    // Render
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["c" /* getElementType */])(Visibility, this.props);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["b" /* getUnhandledProps */])(Visibility, this.props);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__addons_Ref__["a" /* default */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, rest, children));
    }
  }]);

  return Visibility;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Visibility, "defaultProps", {
  context: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib__["w" /* isBrowser */])() ? window : null,
  continuous: false,
  offset: [0, 0],
  once: true,
  updateOn: 'events'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Visibility, "handledProps", ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"]);


Visibility.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Context which visibility should attach onscroll events. */
  context: PropTypes.object,

  /**
   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
   * threshold is met.
   */
  continuous: PropTypes.bool,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Element's bottom edge has passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassed: PropTypes.func,

  /**
   * Element's bottom edge has not passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassedReverse: PropTypes.func,

  /**
   * Element's bottom edge has passed bottom of screen
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisible: PropTypes.func,

  /**
   * Element's bottom edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisibleReverse: PropTypes.func,

  /**
   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
   * page.
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),

  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
  once: PropTypes.bool,

  /** Element is not visible on the screen. */
  onPassed: PropTypes.object,

  /**
   * Any part of an element is visible on screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassing: PropTypes.func,

  /**
   * Element's top has not passed top of screen but bottom has.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassingReverse: PropTypes.func,

  /**
   * Element is not visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOffScreen: PropTypes.func,

  /**
   * Element is visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOnScreen: PropTypes.func,

  /**
   * Element's top edge has passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassed: PropTypes.func,

  /**
   * Element's top edge has not passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassedReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisible: PropTypes.func,

  /**
   * Element's top edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisibleReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUpdate: PropTypes.func,

  /**
   * Allows to choose the mode of the position calculations:
   * - `events` - (default) update and fire callbacks only on scroll/resize events
   * - `repaint` - update and fire callbacks on browser repaint (animation frames)
   */
  updateOn: PropTypes.oneOf(['events', 'repaint'])
} : {};

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Visibility__ = __webpack_require__(2501);
/* unused harmony reexport default */



/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__ = __webpack_require__(1283);









/**
 * A breadcrumb is used to show hierarchy between content.
 */

function Breadcrumb(props) {
  var children = props.children,
      className = props.className,
      divider = props.divider,
      icon = props.icon,
      sections = props.sections,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', size, 'breadcrumb', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Breadcrumb, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Breadcrumb, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var childElements = [];

  __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(sections, function (section, index) {
    // section
    var breadcrumbElement = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */].create(section);
    childElements.push(breadcrumbElement); // divider

    if (index !== sections.length - 1) {
      var key = "".concat(breadcrumbElement.key, "_divider") || JSON.stringify(section);
      childElements.push(__WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */].create({
        content: divider,
        icon: icon,
        key: key
      }));
    }
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), childElements);
}

Breadcrumb.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"];
Breadcrumb.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content of the Breadcrumb.Divider. */
  divider: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.contentShorthand]),

  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
   *  Breadcrumb.Divider. */
  icon: customPropTypes.every([customPropTypes.disallow(['divider']), customPropTypes.itemShorthand]),

  /** Shorthand array of props for Breadcrumb.Section. */
  sections: customPropTypes.collectionShorthand,

  /** Size of Breadcrumb. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
Breadcrumb.Divider = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */];
Breadcrumb.Section = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Breadcrumb);

/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__ = __webpack_require__(2503);
/* unused harmony reexport default */



/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FormButton__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FormCheckbox__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FormDropdown__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FormField__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FormGroup__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FormInput__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormRadio__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormSelect__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FormTextArea__ = __webpack_require__(1291);























/**
 * A Form displays a set of related user input fields in a structured way.
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Message
 * @see Radio
 * @see Select
 * @see Visibility
 */

var Form =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Form);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Form)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSubmit", function (e) {
      var action = _this.props.action; // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
      // method.

      if (typeof action !== 'string') __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(e, 'preventDefault');

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [_this.props, 'onSubmit', e, _this.props].concat(args));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          children = _this$props.children,
          className = _this$props.className,
          error = _this$props.error,
          inverted = _this$props.inverted,
          loading = _this$props.loading,
          reply = _this$props.reply,
          size = _this$props.size,
          success = _this$props.success,
          unstackable = _this$props.unstackable,
          warning = _this$props.warning,
          widths = _this$props.widths;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(reply, 'reply'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(success, 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["f" /* useWidthProp */])(widths, null, true), 'form', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(Form, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(Form, this.props);
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        action: action,
        className: classes,
        onSubmit: this.handleSubmit
      }), children);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "defaultProps", {
  as: 'form'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Field", __WEBPACK_IMPORTED_MODULE_17__FormField__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Button", __WEBPACK_IMPORTED_MODULE_14__FormButton__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Checkbox", __WEBPACK_IMPORTED_MODULE_15__FormCheckbox__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Dropdown", __WEBPACK_IMPORTED_MODULE_16__FormDropdown__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Group", __WEBPACK_IMPORTED_MODULE_18__FormGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Input", __WEBPACK_IMPORTED_MODULE_19__FormInput__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Radio", __WEBPACK_IMPORTED_MODULE_20__FormRadio__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Select", __WEBPACK_IMPORTED_MODULE_21__FormSelect__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "TextArea", __WEBPACK_IMPORTED_MODULE_22__FormTextArea__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "handledProps", ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"]);

Form.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The HTML form action */
  action: PropTypes.string,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Automatically show any error Message children. */
  error: PropTypes.bool,

  /** A form can have its color inverted for contrast. */
  inverted: PropTypes.bool,

  /** Automatically show a loading indicator. */
  loading: PropTypes.bool,

  /** The HTML form submit handler. */
  onSubmit: PropTypes.func,

  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: PropTypes.bool,

  /** A form can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Automatically show any success Message children. */
  success: PropTypes.bool,

  /** A form can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Automatically show any warning Message children. */
  warning: PropTypes.bool,

  /** Forms can automatically divide fields to be equal width. */
  widths: PropTypes.oneOf(['equal'])
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(2505);
/* unused harmony reexport default */



/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });



/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MessageContent__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MessageHeader__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MessageList__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MessageItem__ = __webpack_require__(762);



















/**
 * A message displays information that explains nearby content.
 * @see Form
 */

var Message =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Message, _Component);

  function Message() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Message);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Message)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDismiss", function (e) {
      var onDismiss = _this.props.onDismiss;
      if (onDismiss) onDismiss(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Message, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attached = _this$props.attached,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          compact = _this$props.compact,
          content = _this$props.content,
          error = _this$props.error,
          floating = _this$props.floating,
          header = _this$props.header,
          hidden = _this$props.hidden,
          icon = _this$props.icon,
          info = _this$props.info,
          list = _this$props.list,
          negative = _this$props.negative,
          onDismiss = _this$props.onDismiss,
          positive = _this$props.positive,
          size = _this$props.size,
          success = _this$props.success,
          visible = _this$props.visible,
          warning = _this$props.warning;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(info, 'info'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(success, 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(visible, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), 'message', className);
      var dismissIcon = onDismiss && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */], {
        name: "close",
        onClick: this.handleDismiss
      });
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(Message, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(Message, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), dismissIcon, children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), dismissIcon, __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(header) || !__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(content) || !__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(list)) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MessageContent__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_16__MessageHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_17__MessageList__["a" /* default */].create(list, {
        autoGenerateKey: false
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["E" /* createHTMLParagraph */])(content, {
        autoGenerateKey: false
      })));
    }
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Content", __WEBPACK_IMPORTED_MODULE_15__MessageContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Header", __WEBPACK_IMPORTED_MODULE_16__MessageHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "List", __WEBPACK_IMPORTED_MODULE_17__MessageList__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Item", __WEBPACK_IMPORTED_MODULE_18__MessageItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "handledProps", ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"]);


Message.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A message can be formatted to attach itself to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['bottom', 'top'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A message can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A message can only take up the width of its content. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A message may be formatted to display a negative message. Same as `negative`. */
  error: PropTypes.bool,

  /** A message can float above content that it is related to. */
  floating: PropTypes.bool,

  /** Shorthand for MessageHeader. */
  header: customPropTypes.itemShorthand,

  /** A message can be hidden. */
  hidden: PropTypes.bool,

  /** A message can contain an icon. */
  icon: PropTypes.oneOfType([customPropTypes.itemShorthand, PropTypes.bool]),

  /** A message may be formatted to display information. */
  info: PropTypes.bool,

  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
  list: customPropTypes.collectionShorthand,

  /** A message may be formatted to display a negative message. Same as `error`. */
  negative: PropTypes.bool,

  /**
   * A message that the user can choose to hide.
   * Called when the user clicks the "x" icon. This also adds the "x" icon.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onDismiss: PropTypes.func,

  /** A message may be formatted to display a positive message.  Same as `success`. */
  positive: PropTypes.bool,

  /** A message can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A message may be formatted to display a positive message.  Same as `positive`. */
  success: PropTypes.bool,

  /** A message can be set to visible to force itself to be shown. */
  visible: PropTypes.bool,

  /** A message may be formatted to display warning messages. */
  warning: PropTypes.bool
} : {};

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(2508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Message__["a"]; });



/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableBody__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableCell__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableFooter__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TableRow__ = __webpack_require__(1304);













/**
 * A table displays a collections of data grouped into rows.
 */

function Table(props) {
  var attached = props.attached,
      basic = props.basic,
      celled = props.celled,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      color = props.color,
      columns = props.columns,
      compact = props.compact,
      definition = props.definition,
      fixed = props.fixed,
      footerRow = props.footerRow,
      headerRow = props.headerRow,
      headerRows = props.headerRows,
      inverted = props.inverted,
      padded = props.padded,
      renderBodyRow = props.renderBodyRow,
      selectable = props.selectable,
      singleLine = props.singleLine,
      size = props.size,
      sortable = props.sortable,
      stackable = props.stackable,
      striped = props.striped,
      structured = props.structured,
      tableData = props.tableData,
      textAlign = props.textAlign,
      unstackable = props.unstackable,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(collapsing, 'collapsing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(definition, 'definition'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(fixed, 'fixed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(selectable, 'selectable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(singleLine, 'single line'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(sortable, 'sortable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(striped, 'striped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(structured, 'structured'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(columns, 'column'), 'table', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Table, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Table, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var hasHeaderRows = headerRow || headerRows;
  var headerShorthandOptions = {
    defaultProps: {
      cellAs: 'th'
    }
  };
  var headerElement = hasHeaderRows && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(headerRow, headerShorthandOptions), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(headerRows, function (data) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(data, headerShorthandOptions);
  }));
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), headerElement, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */], null, renderBodyRow && __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(tableData, function (data, index) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(renderBodyRow(data, index));
  })), footerRow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(footerRow)));
}

Table.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"];
Table.defaultProps = {
  as: 'table'
};
Table.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach table to other content */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A table can reduce its complexity to increase readability. */
  basic: PropTypes.oneOfType([PropTypes.oneOf(['very']), PropTypes.bool]),

  /** A table may be divided each row into separate cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A table can be collapsing, taking up only as much space as its rows. */
  collapsing: PropTypes.bool,

  /** A table can be given a color to distinguish it from other tables. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A table can specify its column count to divide its content evenly. */
  columns: PropTypes.oneOf(SUI.WIDTHS),

  /** A table may sometimes need to be more compact to make more rows visible at a time. */
  compact: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A table may be formatted to emphasize a first column that defines a rows content. */
  definition: PropTypes.bool,

  /**
   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
   */
  fixed: PropTypes.bool,

  /** Shorthand for a TableRow to be placed within Table.Footer. */
  footerRow: customPropTypes.itemShorthand,

  /** Shorthand for a TableRow to be placed within Table.Header. */
  headerRow: customPropTypes.every([customPropTypes.disallow(['headerRows']), customPropTypes.itemShorthand]),

  /** Shorthand for multiple TableRows to be placed within Table.Header. */
  headerRows: customPropTypes.every([customPropTypes.disallow(['headerRow']), customPropTypes.collectionShorthand]),

  /** A table's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A table may sometimes need to be more padded for legibility. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /**
   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
   *
   * @param {*} data - An element in the `tableData` array.
   * @param {number} index - The index of the current element in `tableData`.
   * @returns {*} Shorthand for a Table.Row.
   */
  renderBodyRow: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['tableData']), PropTypes.func]),

  /** A table can have its rows appear selectable. */
  selectable: PropTypes.bool,

  /** A table can specify that its cell contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table can also be small or large. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),

  /** A table may allow a user to sort contents by clicking on a table header. */
  sortable: PropTypes.bool,

  /** A table can specify how it stacks table content responsively. */
  stackable: PropTypes.bool,

  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
  striped: PropTypes.bool,

  /** A table can be formatted to display complex structured data. */
  structured: PropTypes.bool,

  /** Data to be passed to the renderBodyRow function. */
  tableData: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['renderBodyRow']), PropTypes.array]),

  /** A table can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table can specify how it stacks table content responsively. */
  unstackable: PropTypes.bool,

  /** A table can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
Table.Body = __WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */];
Table.Cell = __WEBPACK_IMPORTED_MODULE_8__TableCell__["a" /* default */];
Table.Footer = __WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */];
Table.Header = __WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */];
Table.HeaderCell = __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__["a" /* default */];
Table.Row = __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(2510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });



/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A container limits content to a maximum width.
 */

function Container(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      text = props.text,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(text, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), 'container', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Container, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Container, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Container.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"];
Container.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Container has no maximum width. */
  fluid: PropTypes.bool,

  /** Reduce maximum width to more naturally accommodate text. */
  text: PropTypes.bool,

  /** Align container text. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(2512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });



/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A divider visually segments content into groups.
 */

function Divider(props) {
  var children = props.children,
      className = props.className,
      clearing = props.clearing,
      content = props.content,
      fitted = props.fitted,
      hidden = props.hidden,
      horizontal = props.horizontal,
      inverted = props.inverted,
      section = props.section,
      vertical = props.vertical;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(clearing, 'clearing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fitted, 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(section, 'section'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), 'divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Divider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Divider, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Divider.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"];
Divider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Divider can clear the content above it. */
  clearing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Divider can be fitted without any space above or below it. */
  fitted: PropTypes.bool,

  /** Divider can divide content without creating a dividing line. */
  hidden: PropTypes.bool,

  /** Divider can segment content horizontally. */
  horizontal: PropTypes.bool,

  /** Divider can have its colours inverted. */
  inverted: PropTypes.bool,

  /** Divider can provide greater margins to divide sections of content. */
  section: PropTypes.bool,

  /** Divider can segment content vertically. */
  vertical: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(2514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Divider__["a"]; });



/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(7);











var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'uk', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
/**
 * A flag is is used to represent a political state.
 */

var Flag =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Flag, _PureComponent);

  function Flag() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Flag);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Flag).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Flag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          name = _this$props.name;
      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(name, 'flag', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["b" /* getUnhandledProps */])(Flag, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* getElementType */])(Flag, this.props);
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }));
    }
  }]);

  return Flag;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Flag, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Flag, "handledProps", ["as", "className", "name"]);

Flag.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Flag name, can use the two digit country code, the full name, or a common alias. */
  name: customPropTypes.suggest(names)
} : {};
Flag.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["e" /* createShorthandFactory */])(Flag, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Flag);

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Image__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderContent__ = __webpack_require__(1309);










/**
 * A header provides a short summary of content
 */

function Header(props) {
  var attached = props.attached,
      block = props.block,
      children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      disabled = props.disabled,
      dividing = props.dividing,
      floated = props.floated,
      icon = props.icon,
      image = props.image,
      inverted = props.inverted,
      size = props.size,
      sub = props.sub,
      subheader = props.subheader,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(block, 'block'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(dividing, 'dividing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(icon === true, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(image === true, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(sub, 'sub'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Header, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Header, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var iconElement = __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  });
  var imageElement = __WEBPACK_IMPORTED_MODULE_7__Image__["a" /* default */].create(image, {
    autoGenerateKey: false
  });
  var subheaderElement = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */].create(subheader, {
    autoGenerateKey: false
  });

  if (iconElement || imageElement) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), iconElement || imageElement, (content || subheaderElement) && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */], null, content, subheaderElement));
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, subheaderElement);
}

Header.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"];
Header.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach header  to other content, like a segment. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Format header to appear inside a content block. */
  block: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the header. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Show that the header is inactive. */
  disabled: PropTypes.bool,

  /** Divide header from the content below it. */
  dividing: PropTypes.bool,

  /** Header can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Add an icon by icon name or pass an Icon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Add an image by img src or pass an Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Inverts the color of the header for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Content headings are sized with em and are based on the font-size of their container. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'mini')),

  /** Headers may be formatted to label smaller or de-emphasized content. */
  sub: PropTypes.bool,

  /** Shorthand for Header.Subheader. */
  subheader: customPropTypes.itemShorthand,

  /** Align header content. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
Header.Content = __WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */];
Header.Subheader = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(2517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });



/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Button__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Label__ = __webpack_require__(485);






















/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */

var Input =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Input, _Component);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "inputRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeIcon", function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          icon = _this$props.icon;
      if (!__WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default()(icon)) return icon;
      if (loading) return 'spinner';
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return _this.inputRef.current.focus();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "select", function () {
      return _this.inputRef.current.select();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_12_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChildOverrides", function (child, defaultProps) {
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, defaultProps, child.props, {
        ref: function ref(c) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["z" /* handleRef */])(child.ref, c);
          _this.inputRef.current = c;
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "partitionProps", function () {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          type = _this$props3.type;

      var tabIndex = _this.computeTabIndex();

      var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["b" /* getUnhandledProps */])(Input, _this.props);

      var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["l" /* partitionHTMLProps */])(unhandled),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return [__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, htmlInputProps, {
        disabled: disabled,
        type: type,
        tabIndex: tabIndex,
        onChange: _this.handleChange,
        ref: _this.inputRef
      }), rest];
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          actionPosition = _this$props4.actionPosition,
          children = _this$props4.children,
          className = _this$props4.className,
          disabled = _this$props4.disabled,
          error = _this$props4.error,
          fluid = _this$props4.fluid,
          focus = _this$props4.focus,
          icon = _this$props4.icon,
          iconPosition = _this$props4.iconPosition,
          input = _this$props4.input,
          inverted = _this$props4.inverted,
          label = _this$props4.label,
          labelPosition = _this$props4.labelPosition,
          loading = _this$props4.loading,
          size = _this$props4.size,
          transparent = _this$props4.transparent,
          type = _this$props4.type;
      var classes = __WEBPACK_IMPORTED_MODULE_15_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(focus, 'focus'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(transparent, 'transparent'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["g" /* useValueAndKey */])(actionPosition, 'action') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(action, 'action'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["g" /* useValueAndKey */])(iconPosition, 'icon') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(icon || loading, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["g" /* useValueAndKey */])(labelPosition, 'labeled') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(label, 'labeled'), 'input', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["c" /* getElementType */])(Input, this.props);

      var _this$partitionProps = this.partitionProps(),
          _this$partitionProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_this$partitionProps, 2),
          htmlInputProps = _this$partitionProps2[0],
          rest = _this$partitionProps2[1]; // Render with children
      // ----------------------------------------


      if (!__WEBPACK_IMPORTED_MODULE_18__lib__["d" /* childrenUtils */].isNil(children)) {
        // add htmlInputProps to the `<input />` child
        var childElements = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_17_react__["Children"].toArray(children), function (child) {
          if (child.type !== 'input') return child;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_react__["cloneElement"])(child, _this2.handleChildOverrides(child, htmlInputProps));
        });

        return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), childElements);
      } // Render Shorthand
      // ----------------------------------------


      var actionElement = __WEBPACK_IMPORTED_MODULE_19__Button__["a" /* default */].create(action, {
        autoGenerateKey: false
      });
      var labelElement = __WEBPACK_IMPORTED_MODULE_21__Label__["a" /* default */].create(label, {
        defaultProps: {
          className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('label', // add 'left|right corner'
          __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(labelPosition, 'corner') && labelPosition)
        },
        autoGenerateKey: false
      });
      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["A" /* createHTMLInput */])(input || type, {
        defaultProps: htmlInputProps,
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_20__Icon__["a" /* default */].create(this.computeIcon(), {
        autoGenerateKey: false
      }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Input, "defaultProps", {
  type: 'text'
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Input, "handledProps", ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"]);

Input.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An Input can be formatted to alert the user to an action they may perform. */
  action: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An action can appear along side an Input on the left or right. */
  actionPosition: PropTypes.oneOf(['left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** An Input field can show that it is disabled. */
  disabled: PropTypes.bool,

  /** An Input field can show the data contains errors. */
  error: PropTypes.bool,

  /** Take on the size of its container. */
  fluid: PropTypes.bool,

  /** An Input field can show a user is currently interacting with it. */
  focus: PropTypes.bool,

  /** Optional Icon to display inside the Input. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: PropTypes.oneOf(['left']),

  /** Shorthand for creating the HTML Input. */
  input: customPropTypes.itemShorthand,

  /** Format to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Optional Label to display along side the Input. */
  label: customPropTypes.itemShorthand,

  /** A Label can appear outside an Input on the left or right. */
  labelPosition: PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),

  /** An Icon Input field can show that it is currently loading data. */
  loading: PropTypes.bool,

  /**
   * Called on change.
   *
   * @param {ChangeEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and a proposed value.
   */
  onChange: PropTypes.func,

  /** An Input can vary in size. */
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive']),

  /** An Input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Transparent Input has no background. */
  transparent: PropTypes.bool,

  /** The HTML input type. */
  type: PropTypes.string
} : {};
Input.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["e" /* createShorthandFactory */])(Input, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListContent__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListDescription__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ListHeader__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ListIcon__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ListItem__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ListList__ = __webpack_require__(1317);




















/**
 * A list groups related content.
 */

var List =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(List, _Component);

  function List() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(List, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          animated = _this$props.animated,
          bulleted = _this$props.bulleted,
          celled = _this$props.celled,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          divided = _this$props.divided,
          floated = _this$props.floated,
          horizontal = _this$props.horizontal,
          inverted = _this$props.inverted,
          items = _this$props.items,
          link = _this$props.link,
          ordered = _this$props.ordered,
          relaxed = _this$props.relaxed,
          selection = _this$props.selection,
          size = _this$props.size,
          verticalAlign = _this$props.verticalAlign;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(animated, 'animated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(bulleted, 'bulleted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(ordered, 'ordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(selection, 'selection'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'list', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(List, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(List, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          role: "list",
          className: classes
        }, rest), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          role: "list",
          className: classes
        }, rest), content);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        role: "list",
        className: classes
      }, rest), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(items, function (item) {
        return __WEBPACK_IMPORTED_MODULE_18__ListItem__["a" /* default */].create(item, {
          overrideProps: _this2.handleItemOverrides
        });
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Content", __WEBPACK_IMPORTED_MODULE_14__ListContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Description", __WEBPACK_IMPORTED_MODULE_15__ListDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Header", __WEBPACK_IMPORTED_MODULE_16__ListHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Icon", __WEBPACK_IMPORTED_MODULE_17__ListIcon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Item", __WEBPACK_IMPORTED_MODULE_18__ListItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "List", __WEBPACK_IMPORTED_MODULE_19__ListList__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "handledProps", ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"]);

List.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A list can animate to set the current item apart from the list. */
  animated: PropTypes.bool,

  /** A list can mark items with a bullet. */
  bulleted: PropTypes.bool,

  /** A list can divide its items into cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A list can show divisions between content. */
  divided: PropTypes.bool,

  /** An list can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A list can be formatted to have items appear horizontally. */
  horizontal: PropTypes.bool,

  /** A list can be inverted to appear on a dark background. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for ListItem. */
  items: customPropTypes.collectionShorthand,

  /** A list can be specially formatted for navigation links. */
  link: PropTypes.bool,

  /**
   * onClick handler for ListItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A list can be ordered numerically. */
  ordered: PropTypes.bool,

  /** A list can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A selection list formats list items as possible choices. */
  selection: PropTypes.bool,

  /** A list can vary in size. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(2520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });



/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * A loader alerts a user to wait for an activity to complete.
 * @see Dimmer
 */

function Loader(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      indeterminate = props.indeterminate,
      inline = props.inline,
      inverted = props.inverted,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(indeterminate, 'indeterminate'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(children || content, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(inline, 'inline'), 'loader', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Loader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Loader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Loader.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"];
Loader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A loader can be active or visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A loader can be disabled or hidden. */
  disabled: PropTypes.bool,

  /** A loader can show it's unsure of how long a task will take. */
  indeterminate: PropTypes.bool,

  /** Loaders can appear inline with content. */
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['centered'])]),

  /** Loaders can have their colors inverted. */
  inverted: PropTypes.bool,

  /** Loaders can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(2522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__ = __webpack_require__(1321);









/**
 * A placeholder is used to reserve splace for content that soon will appear in a layout.
 */

function Placeholder(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      inverted = props.inverted;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'placeholder', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Placeholder, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Placeholder, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Placeholder.handledProps = ["as", "children", "className", "content", "fluid", "inverted"];
Placeholder.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid placeholder takes up the width of its container. */
  fluid: PropTypes.bool,

  /** A placeholder can have their colors inverted. */
  inverted: PropTypes.bool
} : {};
Placeholder.Header = __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__["a" /* default */];
Placeholder.Image = __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__["a" /* default */];
Placeholder.Line = __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__["a" /* default */];
Placeholder.Paragraph = __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Placeholder);

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Placeholder__ = __webpack_require__(2524);
/* unused harmony reexport default */



/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(7);






/**
 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
 */

function Rail(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      close = props.close,
      content = props.content,
      dividing = props.dividing,
      internal = props.internal,
      position = props.position,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', position, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(dividing, 'dividing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(internal, 'internal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(close, 'close'), 'rail', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Rail, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Rail, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Rail.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"];
Rail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A rail can appear attached to the main viewport. */
  attached: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A rail can appear closer to the main viewport. */
  close: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A rail can create a division between itself and a container. */
  dividing: PropTypes.bool,

  /** A rail can attach itself to the inside of a container. */
  internal: PropTypes.bool,

  /** A rail can be presented on the left or right side of a container. */
  position: PropTypes.oneOf(SUI.FLOATS).isRequired,

  /** A rail can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Rail);

/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rail__ = __webpack_require__(2526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Rail__["a"]; });



/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RevealContent__ = __webpack_require__(1322);






/**
 * A reveal displays additional content in place of previous content when activated.
 */

function Reveal(props) {
  var active = props.active,
      animated = props.animated,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      instant = props.instant;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', animated, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(instant, 'instant'), 'reveal', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Reveal, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Reveal, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Reveal.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"];
Reveal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An active reveal displays its hidden content. */
  active: PropTypes.bool,

  /** An animation name that will be applied to Reveal. */
  animated: PropTypes.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled reveal will not animate when hovered. */
  disabled: PropTypes.bool,

  /** An element can show its content without delay. */
  instant: PropTypes.bool
} : {};
Reveal.Content = __WEBPACK_IMPORTED_MODULE_5__RevealContent__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Reveal);

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reveal__ = __webpack_require__(2528);
/* unused harmony reexport default */



/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Segment__ = __webpack_require__(1323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Segment__["a"]; });



/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(1326);
/* unused harmony reexport default */



/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAutoControlledStateValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoControlledComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_difference__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_startsWith__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_intersection__ = __webpack_require__(2743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_each__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);




















var getDefaultPropName = function getDefaultPropName(prop) {
  return "default".concat(prop[0].toUpperCase() + prop.slice(1));
};
/**
 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
 *  - regular props
 *  - then, default props
 *  - then, initial state
 *  - then, `checked` defaults to false
 *  - then, `value` defaults to '' or [] if props.multiple
 *  - else, undefined
 *
 *  @param {string} propName A prop name
 *  @param {object} [props] A props object
 *  @param {object} [state] A state object
 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
 */

var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // regular props
  var propValue = props[propName];
  if (propValue !== undefined) return propValue;

  if (includeDefaults) {
    // defaultProps
    var defaultProp = props[getDefaultPropName(propName)];
    if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined

    if (state) {
      var initialState = state[propName];
      if (initialState !== undefined) return initialState;
    }
  } // React doesn't allow changing from uncontrolled to controlled components,
  // default checked/value if they were not present.


  if (propName === 'checked') return false;
  if (propName === 'value') return props.multiple ? [] : ''; // otherwise, undefined
};

var AutoControlledComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AutoControlledComponent, _Component);

  function AutoControlledComponent() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AutoControlledComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AutoControlledComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "trySetState", function (maybeState, state) {
      var autoControlledProps = _this.constructor.autoControlledProps;

      if (false) {
        var name = _this.constructor.name; // warn about failed attempts to setState for keys not listed in autoControlledProps

        var illegalKeys = _difference(_keys(maybeState), autoControlledProps);

        if (!_isEmpty(illegalKeys)) {
          console.error(["".concat(name, " called trySetState() with controlled props: \"").concat(illegalKeys, "\"."), 'State will not be set.', 'Only props in static autoControlledProps will be set on state.'].join(' '));
        }
      }

      var newState = Object.keys(maybeState).reduce(function (acc, prop) {
        // ignore props defined by the parent
        if (_this.props[prop] !== undefined) return acc; // ignore props not listed in auto controlled props

        if (autoControlledProps.indexOf(prop) === -1) return acc;
        acc[prop] = maybeState[prop];
        return acc;
      }, {});
      if (state) newState = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, newState, state);
      if (Object.keys(newState).length > 0) _this.setState(newState);
    });

    var _autoControlledProps = _this.constructor.autoControlledProps;

    var _state = __WEBPACK_IMPORTED_MODULE_17_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), 'getInitialAutoControlledState', _this.props) || {};

    if (false) {
      var _this$constructor = _this.constructor,
          defaultProps = _this$constructor.defaultProps,
          name = _this$constructor.name,
          propTypes = _this$constructor.propTypes; // require static autoControlledProps

      if (!_autoControlledProps) {
        console.error("Auto controlled ".concat(name, " must specify a static autoControlledProps array."));
      } // require propTypes


      _each(_autoControlledProps, function (prop) {
        var defaultProp = getDefaultPropName(prop); // regular prop

        if (!_has(propTypes, defaultProp)) {
          console.error("".concat(name, " is missing \"").concat(defaultProp, "\" propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        } // its default prop


        if (!_has(propTypes, prop)) {
          console.error("".concat(name, " is missing propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        }
      }); // prevent autoControlledProps in defaultProps
      //
      // When setting state, auto controlled props values always win (so the parent can manage them).
      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
      // Auto controlled props also listed in defaultProps can never be updated.
      //
      // To set defaults for an AutoControlled prop, you can set the initial state in the
      // constructor or by using an ES7 property initializer:
      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers


      var illegalDefaults = _intersection(_autoControlledProps, _keys(defaultProps));

      if (!_isEmpty(illegalDefaults)) {
        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', "See ".concat(name, " props: \"").concat(illegalDefaults, "\".")].join(' '));
      } // prevent listing defaultProps in autoControlledProps
      //
      // Default props are automatically handled.
      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.


      var illegalAutoControlled = _filter(_autoControlledProps, function (prop) {
        return _startsWith(prop, 'default');
      });

      if (!_isEmpty(illegalAutoControlled)) {
        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', "See ".concat(name, " autoControlledProps: \"").concat(illegalAutoControlled, "\".")].join(' '));
      }
    } // Auto controlled props are copied to state.
    // Set initial state by copying auto controlled props to state.
    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
    // so we can set initial values from defaults.


    var initialAutoControlledState = _autoControlledProps.reduce(function (acc, prop) {
      acc[prop] = getAutoControlledStateValue(prop, _this.props, _state, true);

      if (false) {
        var defaultPropName = getDefaultPropName(prop);
        var _name = _this.constructor.name; // prevent defaultFoo={} along side foo={}

        if (!_isUndefined(_this.props[defaultPropName]) && !_isUndefined(_this.props[prop])) {
          console.error("".concat(_name, " prop \"").concat(prop, "\" is auto controlled. Specify either ").concat(defaultPropName, " or ").concat(prop, ", but not both."));
        }
      }

      return acc;
    }, {});

    _this.state = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _state, initialAutoControlledState);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AutoControlledComponent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var autoControlledProps = this.constructor.autoControlledProps; // Solve the next state for autoControlledProps

      var newState = autoControlledProps.reduce(function (acc, prop) {
        var isNextDefined = !__WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined___default()(nextProps[prop]); // if next is defined then use its value

        if (isNextDefined) acc[prop] = nextProps[prop];
        return acc;
      }, {});
      if (Object.keys(newState).length > 0) this.setState(newState);
    }
    /**
     * Safely attempt to set state for props that might be controlled by the user.
     * Second argument is a state object that is always passed to setState.
     * @param {object} maybeState State that corresponds to controlled props.
     * @param {object} [state] Actual state, useful when you also need to setState.
     */

  }]);

  return AutoControlledComponent;
}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);



/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLORS", function() { return COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOATS", function() { return FLOATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIZES", function() { return SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGNMENTS", function() { return TEXT_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERTICAL_ALIGNMENTS", function() { return VERTICAL_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISIBILITY", function() { return VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDTHS", function() { return WIDTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTIONAL_TRANSITIONS", function() { return DIRECTIONAL_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATIC_TRANSITIONS", function() { return STATIC_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSITIONS", function() { return TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCESSIBILITY", function() { return ACCESSIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROWS", function() { return ARROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_VIDEO", function() { return AUDIO_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUSINESS", function() { return BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHESS", function() { return CHESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODE", function() { return CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMUNICATION", function() { return COMMUNICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPUTERS", function() { return COMPUTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENCY", function() { return CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_TIME", function() { return DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESIGN", function() { return DESIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITORS", function() { return EDITORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILES", function() { return FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GENDERS", function() { return GENDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HANDS_GESTURES", function() { return HANDS_GESTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEALTH", function() { return HEALTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGES", function() { return IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERFACES", function() { return INTERFACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGISTICS", function() { return LOGISTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAPS", function() { return MAPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDICAL", function() { return MEDICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OBJECTS", function() { return OBJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAYMENTS_SHOPPING", function() { return PAYMENTS_SHOPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHAPES", function() { return SHAPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNERS", function() { return SPINNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPORTS", function() { return SPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_PEOPLE", function() { return USERS_PEOPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VEHICLES", function() { return VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WRITING", function() { return WRITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRANDS", function() { return BRANDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_ALIASES", function() { return ICON_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS_AND_ALIASES", function() { return ICONS_AND_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function() { return COMPONENT_CONTEXT_SPECIFIC_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALL_ICONS_IN_ALL_CONTEXTS", function() { return ALL_ICONS_IN_ALL_CONTEXTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numberToWord__ = __webpack_require__(771);





var COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
var FLOATS = ['left', 'right'];
var SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
var WIDTHS = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["a" /* numberToWordMap */])), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["a" /* numberToWordMap */]).map(Number)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_values___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["a" /* numberToWordMap */])));
var DIRECTIONAL_TRANSITIONS = ['browse', 'browse right', 'drop', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'fly up', 'fly down', 'fly left', 'fly right', 'horizontal flip', 'vertical flip', 'scale', 'slide up', 'slide down', 'slide left', 'slide right', 'swing up', 'swing down', 'swing left', 'swing right', 'zoom'];
var STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce', 'glow'];
var TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS); // Generated from:
// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css

var ACCESSIBILITY = ['american sign language interpreting', 'assistive listening systems', 'audio description', 'blind', 'braille', 'closed captioning', 'closed captioning outline', 'deaf', 'low vision', 'phone volume', 'question circle', 'question circle outline', 'sign language', 'tty', 'universal access', 'wheelchair'];
var ARROWS = ['angle double down', 'angle double left', 'angle double right', 'angle double up', 'angle down', 'angle left', 'angle right', 'angle up', 'arrow alternate circle down', 'arrow alternate circle down outline', 'arrow alternate circle left', 'arrow alternate circle left outline', 'arrow alternate circle right', 'arrow alternate circle right outline', 'arrow alternate circle up', 'arrow alternate circle up outline', 'arrow circle down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow down', 'arrow left', 'arrow right', 'arrow up', 'arrows alternate', 'arrows alternate horizontal', 'arrows alternate vertical', 'caret down', 'caret left', 'caret right', 'caret square down', 'caret square down outline', 'caret square left', 'caret square left outline', 'caret square right', 'caret square right outline', 'caret square up', 'caret square up outline', 'caret up', 'cart arrow down', 'chart line', 'chevron circle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron down', 'chevron left', 'chevron right', 'chevron up', 'cloud download', 'cloud upload', 'download', 'exchange', 'expand arrows alternate', 'external alternate', 'external square alternate', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'history', 'level down alternate', 'level up alternate', 'location arrow', 'long arrow alternate down', 'long arrow alternate left', 'long arrow alternate right', 'long arrow alternate up', 'mouse pointer', 'play', 'random', 'recycle', 'redo', 'redo alternate', 'reply', 'reply all', 'retweet', 'share', 'share square', 'share square outline', 'sign-in', 'sign-out', 'sign-in alternate', 'sign-out alternate', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'sync', 'sync alternate', 'text height', 'text width', 'undo', 'undo alternate', 'upload', 'zoom-in', 'zoom-out'];
var AUDIO_VIDEO = ['audio description', 'backward', 'circle', 'circle outline', 'closed captioning', 'closed captioning outline', 'compress', 'eject', 'expand', 'expand arrows alternate', 'fast backward', 'fast forward', 'file audio', 'file audio outline', 'file video', 'file video outline', 'film', 'forward', 'headphones', 'microphone', 'microphone slash', 'music', 'pause', 'pause circle', 'pause circle outline', 'phone volume', 'play', 'play circle', 'play circle outline', 'podcast', 'random', 'redo', 'redo alternate', 'rss', 'rss square', 'step backward', 'step forward', 'stop', 'stop circle', 'stop circle outline', 'sync', 'sync alternate', 'undo', 'undo alternate', 'video', 'volume down', 'volume off', 'volume up'];
var BUSINESS = ['address book', 'address book outline', 'address card', 'address card outline', 'archive', 'balance scale', 'birthday cake', 'book', 'briefcase', 'building', 'building outline', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'certificate', 'chart area', 'chart bar', 'chart bar outline', 'chart line', 'chart pie', 'clipboard', 'clipboard outline', 'coffee', 'columns', 'compass', 'compass outline', 'copy', 'copy outline', 'copyright', 'copyright outline', 'cut', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'eraser', 'fax', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'globe', 'industry', 'paperclip', 'paste', 'pen square', 'pencil alternate', 'percent', 'phone', 'phone square', 'phone volume', 'registered', 'registered outline', 'save', 'save outline', 'sitemap', 'sticky note', 'sticky note outline', 'suitcase', 'table', 'tag', 'tags', 'tasks', 'thumbtack', 'trademark'];
var CHESS = ['chess', 'chess bishop', 'chess board', 'chess king', 'chess knight', 'chess pawn', 'chess queen', 'chess rook', 'square full'];
var CODE = ['archive', 'barcode', 'bath', 'bug', 'code', 'code branch', 'coffee', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file code', 'file code outline', 'filter', 'fire extinguisher', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'microchip', 'qrcode', 'shield alternate', 'sitemap', 'terminal', 'user secret', 'window close', 'window close outline', 'window maximize', 'window maximize outline', 'window minimize', 'window minimize outline', 'window restore', 'window restore outline'];
var COMMUNICATION = ['address book', 'address book outline', 'address card', 'address card outline', 'american sign language interpreting', 'assistive listening systems', 'at', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bullhorn', 'comment', 'comment outline', 'comment alternate', 'comment alternate outline', 'comments', 'comments outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'fax', 'inbox', 'language', 'microphone', 'microphone slash', 'mobile', 'mobile alternate', 'paper plane', 'paper plane outline', 'phone', 'phone square', 'phone volume', 'rss', 'rss square', 'tty', 'wifi'];
var COMPUTERS = ['desktop', 'download', 'hdd', 'hdd outline', 'headphones', 'keyboard', 'keyboard outline', 'laptop', 'microchip', 'mobile', 'mobile alternate', 'plug', 'power off', 'print', 'save', 'save outline', 'server', 'tablet', 'tablet alternate', 'tv', 'upload'];
var CURRENCY = ['dollar sign', 'euro sign', 'lira sign', 'money bill alternate', 'money bill alternate outline', 'pound sign', 'ruble sign', 'rupee sign', 'shekel sign', 'won sign', 'yen sign'];
var DATE_TIME = ['bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'clock', 'clock outline', 'hourglass', 'hourglass outline', 'hourglass end', 'hourglass half', 'hourglass start', 'stopwatch'];
var DESIGN = ['adjust', 'clone', 'clone outline', 'copy', 'copy outline', 'crop', 'crosshairs', 'cut', 'edit', 'edit outline', 'eraser', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'object group', 'object group outline', 'object ungroup', 'object ungroup outline', 'paint brush', 'paste', 'pencil alternate', 'save', 'save outline', 'tint'];
var EDITORS = ['align center', 'align justify', 'align left', 'align right', 'bold', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'columns', 'copy', 'copy outline', 'cut', 'edit', 'edit outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'font', 'heading', 'i cursor', 'indent', 'italic', 'linkify', 'list', 'list alternate', 'list alternate outline', 'list ol', 'list ul', 'outdent', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'paste', 'pencil alternate', 'print', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'share', 'strikethrough', 'subscript', 'superscript', 'sync', 'sync alternate', 'table', 'tasks', 'text height', 'text width', 'th', 'th large', 'th list', 'trash', 'trash alternate', 'trash alternate outline', 'underline', 'undo', 'undo alternate', 'unlink'];
var FILES = ['archive', 'clone', 'clone outline', 'copy', 'copy outline', 'cut', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file archive', 'file archive outline', 'file audio', 'file audio outline', 'file code', 'file code outline', 'file excel', 'file excel outline', 'file image', 'file image outline', 'file pdf', 'file pdf outline', 'file powerpoint', 'file powerpoint outline', 'file video', 'file video outline', 'file word', 'file word outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'paste', 'save', 'save outline', 'sticky note', 'sticky note outline'];
var GENDERS = ['genderless', 'mars', 'mars double', 'mars stroke', 'mars stroke horizontal', 'mars stroke vertical', 'mercury', 'neuter', 'transgender', 'transgender alternate', 'venus', 'venus double', 'venus mars'];
var HANDS_GESTURES = ['hand lizard', 'hand lizard outline', 'hand paper', 'hand paper outline', 'hand peace', 'hand peace outline', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'hand rock', 'hand rock outline', 'hand scissors', 'hand scissors outline', 'hand spock', 'hand spock outline', 'handshake', 'handshake outline', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline'];
var HEALTH = ['ambulance', 'h square', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'medkit', 'plus square', 'plus square outline', 'stethoscope', 'user md', 'wheelchair'];
var IMAGES = ['adjust', 'bolt', 'camera', 'camera retro', 'clone', 'clone outline', 'compress', 'expand', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'file image', 'file image outline', 'film', 'id badge', 'id badge outline', 'id card', 'id card outline', 'image', 'image outline', 'images', 'images outline', 'sliders horizontal', 'tint'];
var INTERFACES = ['ban', 'barcode', 'bars', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bug', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'certificate', 'check', 'check circle', 'check circle outline', 'check square', 'check square outline', 'circle', 'circle outline', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'cloud', 'cloud download', 'cloud upload', 'coffee', 'cog', 'cogs', 'copy', 'copy outline', 'cut', 'database', 'dot circle', 'dot circle outline', 'download', 'edit', 'edit outline', 'ellipsis horizontal', 'ellipsis vertical', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'exclamation', 'exclamation circle', 'exclamation triangle', 'external alternate', 'external square alternate', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'filter', 'flag', 'flag outline', 'flag checkered', 'folder', 'folder outline', 'folder open', 'folder open outline', 'frown', 'frown outline', 'hashtag', 'heart', 'heart outline', 'history', 'home', 'i cursor', 'info', 'info circle', 'language', 'magic', 'meh', 'meh outline', 'microphone', 'microphone slash', 'minus', 'minus circle', 'minus square', 'minus square outline', 'paste', 'pencil alternate', 'plus', 'plus circle', 'plus square', 'plus square outline', 'qrcode', 'question', 'question circle', 'question circle outline', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'rss', 'rss square', 'save', 'save outline', 'search', 'search minus', 'search plus', 'share', 'share alternate', 'share alternate square', 'share square', 'share square outline', 'shield alternate', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders horizontal', 'smile', 'smile outline', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'star', 'star outline', 'star half', 'star half outline', 'sync', 'sync alternate', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'times', 'times circle', 'times circle outline', 'toggle off', 'toggle on', 'trash', 'trash alternate', 'trash alternate outline', 'trophy', 'undo', 'undo alternate', 'upload', 'user', 'user outline', 'user circle', 'user circle outline', 'wifi'];
var LOGISTICS = ['box', 'boxes', 'clipboard check', 'clipboard list', 'dolly', 'dolly flatbed', 'pallet', 'shipping fast', 'truck', 'warehouse'];
var MAPS = ['ambulance', 'anchor', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bicycle', 'binoculars', 'birthday cake', 'blind', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'building', 'building outline', 'car', 'coffee', 'crosshairs', 'dollar sign', 'eye', 'eye slash', 'eye slash outline', 'fighter jet', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'gamepad', 'gavel', 'gift', 'glass martini', 'globe', 'graduation cap', 'h square', 'heart', 'heart outline', 'heartbeat', 'home', 'hospital', 'hospital outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'info', 'info circle', 'key', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'location arrow', 'low vision', 'magnet', 'male', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'money bill alternate', 'money bill alternate outline', 'motorcycle', 'music', 'newspaper', 'newspaper outline', 'paw', 'phone', 'phone square', 'phone volume', 'plane', 'plug', 'plus', 'plus square', 'plus square outline', 'print', 'recycle', 'road', 'rocket', 'search', 'search minus', 'search plus', 'ship', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'street view', 'subway', 'suitcase', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'tint', 'train', 'tree', 'trophy', 'truck', 'tty', 'umbrella', 'university', 'utensil spoon', 'utensils', 'wheelchair', 'wifi', 'wrench'];
var MEDICAL = ['ambulance', 'band aid', 'dna', 'first aid', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'hospital symbol', 'pills', 'plus', 'stethoscope', 'syringe', 'thermometer', 'user md', 'weight'];
var OBJECTS = ['ambulance', 'anchor', 'archive', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bicycle', 'binoculars', 'birthday cake', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'bug', 'building', 'building outline', 'bullhorn', 'bullseye', 'bus', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'camera', 'camera retro', 'car', 'clipboard', 'clipboard outline', 'cloud', 'coffee', 'cog', 'cogs', 'compass', 'compass outline', 'copy', 'copy outline', 'cube', 'cubes', 'cut', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'eye', 'eye dropper', 'fax', 'fighter jet', 'file', 'file outline', 'file alternate', 'file alternate outline', 'film', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'futbol', 'futbol outline', 'gamepad', 'gavel', 'gem', 'gem outline', 'gift', 'glass martini', 'globe', 'graduation cap', 'hdd', 'hdd outline', 'headphones', 'heart', 'heart outline', 'home', 'hospital', 'hospital outline', 'hourglass', 'hourglass outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'key', 'keyboard', 'keyboard outline', 'laptop', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'lock', 'lock open', 'magic', 'magnet', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'microchip', 'microphone', 'mobile', 'mobile alternate', 'money bill alternate', 'money bill alternate outline', 'moon', 'moon outline', 'motorcycle', 'newspaper', 'newspaper outline', 'paint brush', 'paper plane', 'paper plane outline', 'paperclip', 'paste', 'paw', 'pencil alternate', 'phone', 'plane', 'plug', 'print', 'puzzle piece', 'road', 'rocket', 'save', 'save outline', 'search', 'shield alternate', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'snowflake', 'snowflake outline', 'space shuttle', 'star', 'star outline', 'sticky note', 'sticky note outline', 'stopwatch', 'subway', 'suitcase', 'sun', 'sun outline', 'tablet', 'tablet alternate', 'tachometer alternate', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'train', 'trash', 'trash alternate', 'trash alternate outline', 'tree', 'trophy', 'truck', 'tv', 'umbrella', 'university', 'unlock', 'unlock alternate', 'utensil spoon', 'utensils', 'wheelchair', 'wrench'];
var PAYMENTS_SHOPPING = ['bell', 'bell outline', 'bookmark', 'bookmark outline', 'bullhorn', 'camera', 'camera retro', 'cart arrow down', 'cart plus', 'certificate', 'credit card', 'credit card outline', 'gem', 'gem outline', 'gift', 'handshake', 'handshake outline', 'heart', 'heart outline', 'key', 'shopping bag', 'shopping basket', 'shopping cart', 'star', 'star outline', 'tag', 'tags', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'trophy'];
var SHAPES = ['bookmark', 'bookmark outline', 'calendar', 'calendar outline', 'certificate', 'circle', 'circle outline', 'cloud', 'comment', 'comment outline', 'file', 'file outline', 'folder', 'folder outline', 'heart', 'heart outline', 'map marker', 'play', 'square', 'square outline', 'star', 'star outline'];
var SPINNERS = ['asterisk', 'certificate', 'circle notch', 'cog', 'compass', 'compass outline', 'crosshairs', 'life ring', 'life ring outline', 'snowflake', 'snowflake outline', 'spinner', 'sun', 'sun outline', 'sync'];
var SPORTS = ['baseball ball', 'basketball ball', 'bowling ball', 'football ball', 'futbol', 'futbol outline', 'golf ball', 'hockey puck', 'quidditch', 'table tennis', 'volleyball ball'];
var STATUS = ['ban', 'battery empty', 'battery full', 'battery half', 'battery quarter', 'battery three quarters', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'cart arrow down', 'cart plus', 'exclamation', 'exclamation circle', 'exclamation triangle', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'info', 'info circle', 'lock', 'lock open', 'minus', 'minus circle', 'minus square', 'minus square outline', 'plus', 'plus circle', 'plus square', 'plus square outline', 'question', 'question circle', 'question circle outline', 'shield alternate', 'shopping cart', 'sign in alternate', 'sign out alternate', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'toggle off', 'toggle on', 'unlock', 'unlock alternate'];
var USERS_PEOPLE = ['address book', 'address book outline', 'address card', 'address card outline', 'bed', 'blind', 'child', 'female', 'frown', 'frown outline', 'id badge', 'id badge outline', 'id card', 'id card outline', 'male', 'meh', 'meh outline', 'power off', 'smile', 'smile outline', 'street view', 'user', 'user outline', 'user circle', 'user circle outline', 'user md', 'user plus', 'user secret', 'user times', 'users', 'wheelchair'];
var VEHICLES = ['ambulance', 'bicycle', 'bus', 'car', 'fighter jet', 'motorcycle', 'paper plane', 'paper plane outline', 'plane', 'rocket', 'ship', 'shopping cart', 'space shuttle', 'subway', 'taxi', 'train', 'truck', 'wheelchair'];
var WRITING = ['archive', 'book', 'bookmark', 'bookmark outline', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'newspaper', 'newspaper outline', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'pen square', 'pencil alternate', 'quote left', 'quote right', 'sticky note', 'sticky note outline', 'thumbtack'];
var BRANDS = ['500px', 'accessible', 'accusoft', 'adn', 'adversal', 'affiliatetheme', 'algolia', 'amazon', 'amazon pay', 'amilia', 'android', 'angellist', 'angrycreative', 'angular', 'app store', 'app store ios', 'apper', 'apple', 'apple pay', 'asymmetrik', 'audible', 'autoprefixer', 'avianex', 'aviato', 'aws', 'bandcamp', 'behance', 'behance square', 'bimobject', 'bitbucket', 'bitcoin', 'bity', 'black tie', 'blackberry', 'blogger', 'blogger b', 'bluetooth', 'bluetooth b', 'btc', 'buromobelexperte', 'buysellads', 'cc amazon pay', 'cc amex', 'cc apple pay', 'cc diners club', 'cc discover', 'cc jcb', 'cc mastercard', 'cc paypal', 'cc stripe', 'cc visa', 'centercode', 'chrome', 'cloudscale', 'cloudsmith', 'cloudversify', 'codepen', 'codiepie', 'connectdevelop', 'contao', 'cpanel', 'creative commons', 'css3', 'css3 alternate', 'cuttlefish', 'd and d', 'dashcube', 'delicious', 'deploydog', 'deskpro', 'deviantart', 'digg', 'digital ocean', 'discord', 'discourse', 'dochub', 'docker', 'draft2digital', 'dribbble', 'dribbble square', 'dropbox', 'drupal', 'dyalog', 'earlybirds', 'edge', 'elementor', 'ember', 'empire', 'envira', 'erlang', 'ethereum', 'etsy', 'expeditedssl', 'facebook', 'facebook f', 'facebook messenger', 'facebook square', 'firefox', 'first order', 'firstdraft', 'flickr', 'flipboard', 'fly', 'font awesome', 'font awesome alternate', 'font awesome flag', 'fonticons', 'fonticons fi', 'fort awesome', 'fort awesome alternate', 'forumbee', 'foursquare', 'free code camp', 'freebsd', 'get pocket', 'gg', 'gg circle', 'git', 'git square', 'github', 'github alternate', 'github square', 'gitkraken', 'gitlab', 'gitter', 'glide', 'glide g', 'gofore', 'goodreads', 'goodreads g', 'google', 'google drive', 'google play', 'google plus', 'google plus g', 'google plus square', 'google wallet', 'gratipay', 'grav', 'gripfire', 'grunt', 'gulp', 'hacker news', 'hacker news square', 'hips', 'hire a helper', 'hooli', 'hotjar', 'houzz', 'html5', 'hubspot', 'imdb', 'instagram', 'internet explorer', 'ioxhost', 'itunes', 'itunes note', 'jenkins', 'joget', 'joomla', 'js', 'js square', 'jsfiddle', 'keycdn', 'kickstarter', 'kickstarter k', 'korvue', 'laravel', 'lastfm', 'lastfm square', 'leanpub', 'less', 'linechat', 'linkedin', 'linkedin alternate', 'linode', 'linux', 'lyft', 'magento', 'maxcdn', 'medapps', 'medium', 'medium m', 'medrt', 'meetup', 'microsoft', 'mix', 'mixcloud', 'mizuni', 'modx', 'monero', 'napster', 'nintendo switch', 'node', 'node js', 'npm', 'ns8', 'nutritionix', 'odnoklassniki', 'odnoklassniki square', 'opencart', 'openid', 'opera', 'optin monster', 'osi', 'page4', 'pagelines', 'palfed', 'patreon', 'paypal', 'periscope', 'phabricator', 'phoenix framework', 'php', 'pied piper', 'pied piper alternate', 'pied piper pp', 'pinterest', 'pinterest p', 'pinterest square', 'playstation', 'product hunt', 'pushed', 'python', 'qq', 'quinscape', 'quora', 'ravelry', 'react', 'rebel', 'redriver', 'reddit', 'reddit alien', 'reddit square', 'rendact', 'renren', 'replyd', 'resolving', 'rocketchat', 'rockrms', 'safari', 'sass', 'schlix', 'scribd', 'searchengin', 'sellcast', 'sellsy', 'servicestack', 'shirtsinbulk', 'simplybuilt', 'sistrix', 'skyatlas', 'skype', 'slack', 'slack hash', 'slideshare', 'snapchat', 'snapchat ghost', 'snapchat square', 'soundcloud', 'speakap', 'spotify', 'stack exchange', 'stack overflow', 'staylinked', 'steam', 'steam square', 'steam symbol', 'sticker mule', 'strava', 'stripe', 'stripe s', 'studiovinari', 'stumbleupon', 'stumbleupon circle', 'superpowers', 'supple', 'telegram', 'telegram plane', 'tencent weibo', 'themeisle', 'trello', 'tripadvisor', 'tumblr', 'tumblr square', 'twitch', 'twitter', 'twitter square', 'typo3', 'uber', 'uikit', 'uniregistry', 'untappd', 'usb', 'ussunnah', 'vaadin', 'viacoin', 'viadeo', 'viadeo square', 'viber', 'vimeo', 'vimeo square', 'vimeo v', 'vine', 'vk', 'vnv', 'vuejs', 'wechat', 'weibo', 'weixin', 'whatsapp', 'whatsapp square', 'whmcs', 'wikipedia w', 'windows', 'wordpress', 'wordpress simple', 'wpbeginner', 'wpexplorer', 'wpforms', 'xbox', 'xing', 'xing square', 'y combinator', 'yahoo', 'yandex', 'yandex international', 'yelp', 'yoast', 'youtube', 'youtube square'];
var ICONS = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(ACCESSIBILITY, ARROWS, AUDIO_VIDEO, BUSINESS, CHESS, CODE, COMMUNICATION, COMPUTERS, CURRENCY, DATE_TIME, DESIGN, EDITORS, FILES, GENDERS, HANDS_GESTURES, HEALTH, IMAGES, INTERFACES, LOGISTICS, MAPS, MEDICAL, OBJECTS, PAYMENTS_SHOPPING, SHAPES, SPINNERS, SPORTS, STATUS, USERS_PEOPLE, VEHICLES, WRITING, BRANDS));
var ICON_ALIASES = ['chess rock', 'ordered list', 'unordered list', 'user doctor', 'shield', 'puzzle', 'add circle', 'add square', 'add to calendar', 'add to cart', 'add user', 'add', 'alarm mute', 'alarm', 'ald', 'als', 'announcement', 'area chart', 'area graph', 'arrow down cart', 'asexual', 'asl interpreting', 'asl', 'assistive listening devices', 'attach', 'attention', 'balance', 'bar', 'bathtub', 'battery four', 'battery high', 'battery low', 'battery one', 'battery three', 'battery two', 'battery zero', 'birthday', 'block layout', 'bluetooth alternative', 'broken chain', 'browser', 'call square', 'call', 'cancel', 'cart', 'cc', 'chain', 'chat', 'checked calendar', 'checkmark', 'circle notched', 'close', 'cny', 'cocktail', 'commenting', 'computer', 'configure', 'content', 'deafness', 'delete calendar', 'delete', 'detective', 'discussions', 'doctor', 'dollar', 'dont', 'drivers license', 'dropdown', 'emergency', 'envira gallery', 'erase', 'eur', 'euro', 'eyedropper', 'factory', 'favorite', 'feed', 'female homosexual', 'file text', 'file text outline', 'find', 'first aid', 'fork', 'game', 'gay', 'gbp', 'google plus circle', 'google plus official', 'grab', 'graduation', 'grid layout', 'group', 'h', 'hand victory', 'handicap', 'hard of hearing', 'header', 'help circle', 'help', 'heterosexual', 'hide', 'hotel', 'hourglass four', 'hourglass full', 'hourglass one', 'hourglass three', 'hourglass two', 'idea', 'ils', 'in cart', 'inr', 'intergender', 'intersex', 'jpy', 'krw', 'lab', 'law', 'legal', 'lesbian', 'lightning', 'like', 'line graph', 'linkedin square', 'linkify', 'lira', 'list layout', 'magnify', 'mail forward', 'mail outline', 'mail square', 'mail', 'male homosexual', 'man', 'marker', 'mars alternate', 'mars horizontal', 'mars vertical', 'microsoft edge', 'military', 'ms edge', 'mute', 'new pied piper', 'non binary transgender', 'numbered list', 'options', 'other gender horizontal', 'other gender vertical', 'other gender', 'payment', 'paypal card', 'pencil square', 'photo', 'picture', 'pie chart', 'pie graph', 'pied piper hat', 'pin', 'plus cart', 'point', 'pointing down', 'pointing left', 'pointing right', 'pointing up', 'pound', 'power cord', 'power', 'privacy', 'r circle', 'rain', 'record', 'refresh', 'remove circle', 'remove from calendar', 'remove user', 'remove', 'repeat', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 's15', 'selected radio', 'send', 'setting', 'settings', 'shekel', 'sheqel', 'shipping', 'shop', 'shuffle', 'shutdown', 'sidebar', 'signing', 'signup', 'sliders', 'soccer', 'sort alphabet ascending', 'sort alphabet descending', 'sort ascending', 'sort content ascending', 'sort content descending', 'sort descending', 'sort numeric ascending', 'sort numeric descending', 'sound', 'spy', 'stripe card', 'student', 'talk', 'target', 'teletype', 'television', 'text cursor', 'text telephone', 'theme', 'thermometer', 'thumb tack', 'time', 'tm', 'toggle down', 'toggle left', 'toggle right', 'toggle up', 'translate', 'travel', 'treatment', 'triangle down', 'triangle left', 'triangle right', 'triangle up', 'try', 'unhide', 'unlinkify', 'unmute', 'usd', 'user cancel', 'user close', 'user delete', 'user x', 'vcard', 'video camera', 'video play', 'volume control phone', 'wait', 'warning circle', 'warning sign', 'warning', 'wi-fi', 'winner', 'wizard', 'woman', 'won', 'wordpress beginner', 'wordpress forms', 'world', 'write square', 'x', 'yen', 'zip', 'zoom in', 'zoom out', 'zoom', 'bitbucket square', 'checkmark box', 'circle thin', 'cloud download', 'cloud upload', 'compose', 'conversation', 'credit card alternative', 'currency', 'dashboard', 'diamond', 'disk', 'exchange', 'external share', 'external square', 'external', 'facebook official', 'food', 'hourglass zero', 'level down', 'level up', 'log out', 'meanpath', 'money', 'move', 'pencil', 'protect', 'radio', 'remove bookmark', 'resize horizontal', 'resize vertical', 'sign in', 'sign out', 'spoon', 'star half empty', 'star half full', 'ticket', 'times rectangle', 'write', 'youtube play'];
var ICONS_AND_ALIASES = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(ICONS), ICON_ALIASES)); // Some icon names are not part of icons.css.
// These are only valid as children of other components.
// Their CSS rules are defined by a specific component's CSS.
// We don't want to show name warnings for those usages so we add them as valid names here.

var COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown'];
var ALL_ICONS_IN_ALL_CONTEXTS = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(ICONS_AND_ALIASES), COMPONENT_CONTEXT_SPECIFIC_ICONS));

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeChildMappings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);







/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {object} children Element's children
 * @return {object} Mapping of key to child
 */

var getChildMapping = function getChildMapping(children) {
  return __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_6_react__["Children"].toArray(children), __WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"]), 'key');
};

var getPendingKeys = function getPendingKeys(prev, next) {
  var nextKeysPending = {};
  var pendingKeys = [];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(prev), function (prevKey) {
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, prevKey)) {
      pendingKeys.push(prevKey);
      return;
    }

    if (pendingKeys.length) {
      nextKeysPending[prevKey] = pendingKeys;
      pendingKeys = [];
    }
  });

  return [nextKeysPending, pendingKeys];
};

var getValue = function getValue(key, prev, next) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, key) ? next[key] : prev[key];
};
/**
 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
 * of keys and merges them with its best guess of the correct ordering.
 *
 * @param {object} prev Prev children as returned from `getChildMapping()`
 * @param {object} next Next children as returned from `getChildMapping()`
 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
 */

var mergeChildMappings = function mergeChildMappings() {
  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var childMapping = {};

  var _getPendingKeys = getPendingKeys(prev, next),
      _getPendingKeys2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_getPendingKeys, 2),
      nextKeysPending = _getPendingKeys2[0],
      pendingKeys = _getPendingKeys2[1];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(next), function (nextKey) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(nextKeysPending, nextKey)) {
      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(nextKeysPending[nextKey], function (pendingKey) {
        childMapping[pendingKey] = getValue(pendingKey, prev, next);
      });
    }

    childMapping[nextKey] = getValue(nextKey, prev, next);
  });

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(pendingKeys, function (pendingKey) {
    childMapping[pendingKey] = getValue(pendingKey, prev, next);
  });

  return childMapping;
};

/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "someByType", function() { return someByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findByType", function() { return findByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



/**
 * Determine if child by type exists in children.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {Boolean}
 */

var someByType = function someByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Find child by type.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {undefined|Object}
 */

var findByType = function findByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Tests if children are nil in React and Preact.
 * @param {Object} children The children prop of a component.
 * @returns {Boolean}
 */

var isNil = function isNil(children) {
  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useKeyOrValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useMultipleProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useTextAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useVerticalAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useWidthProp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberToWord__ = __webpack_require__(771);


/*
 * There are 3 prop patterns used to build up the className for a component.
 * Each utility here is meant for use in a classnames() argument.
 *
 * There is no util for valueOnly() because it would simply return val.
 * Use the prop value inline instead.
 *   <Label size='big' />
 *   <div class="ui big label"></div>
 */

/**
 * Props where only the prop key is used in the className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label tag />
 * <div class="ui tag label"></div>
 */

var useKeyOnly = function useKeyOnly(val, key) {
  return val && key;
};
/**
 * Props that require both a key and value to create a className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label corner='left' />
 * <div class="ui left corner label"></div>
 */

var useValueAndKey = function useValueAndKey(val, key) {
  return val && val !== true && "".concat(val, " ").concat(key);
};
/**
 * Props whose key will be used in className, or value and key.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example Key Only
 * <Label pointing />
 * <div class="ui pointing label"></div>
 *
 * @example Key and Value
 * <Label pointing='left' />
 * <div class="ui left pointing label"></div>
 */

var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
  return val && (val === true ? key : "".concat(val, " ").concat(key));
}; //
// Prop to className exceptions
//

/**
 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
 *
 * @param {*} val The value of the "multiple" prop
 * @param {*} key A props key
 *
 * @example
 * <Grid.Row only='mobile' />
 * <Grid.Row only='mobile tablet' />
 * <div class="mobile only row"></div>
 * <div class="mobile only tablet only row"></div>
 */

var useMultipleProp = function useMultipleProp(val, key) {
  if (!val || val === true) return null;
  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
    return "".concat(prop.replace('-', ' '), " ").concat(key);
  }).join(' ');
};
/**
 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
 * In this case, only the class "justified" is used, ignoring the "aligned" class.
 * @param {*} val The value of the "textAlign" prop
 *
 * @example
 * <Container textAlign='justified' />
 * <div class="ui justified container"></div>
 *
 * @example
 * <Container textAlign='left' />
 * <div class="ui left aligned container"></div>
 */

var useTextAlignProp = function useTextAlignProp(val) {
  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
};
/**
 * The "verticalAlign" prop follows the useValueAndKey.
 *
 * @param {*} val The value of the "verticalAlign" prop
 *
 * @example
 * <Grid verticalAlign='middle' />
 * <div class="ui middle aligned grid"></div>
 */

var useVerticalAlignProp = function useVerticalAlignProp(val) {
  return useValueAndKey(val, 'aligned');
};
/**
 * Create "X", "X wide" and "equal width" classNames.
 * "X" is a numberToWord value and "wide" is configurable.
 * @param {*} val The prop value
 * @param {string} [widthClass=''] The class
 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
 *
 * @example
 * <Grid columns='equal' />
 * <div class="ui equal width grid"></div>
 *
 * <Form widths='equal' />
 * <div class="ui equal width form"></div>
 *
 * <FieldGroup widths='equal' />
 * <div class="equal width fields"></div>
 *
 * @example
 * <Grid columns={4} />
 * <div class="ui four column grid"></div>
 */

var useWidthProp = function useWidthProp(val) {
  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (canEqual && val === 'equal') {
    return 'equal width';
  }

  var valType = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(val);

  if ((valType === 'string' || valType === 'number') && widthClass) {
    return "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["b" /* numberToWord */])(val), " ").concat(widthClass);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["b" /* numberToWord */])(val);
};

/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemFactories__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rangeFactories__ = __webpack_require__(2540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paginationUtils__ = __webpack_require__(2539);




/**
 * @param {object} rawOptions
 * @param {number|string} rawOptions.activePage
 * @param {number|string} rawOptions.boundaryRange Number of always visible pages at the beginning and end.
 * @param {boolean} rawOptions.hideEllipsis Marks if ellipsis should be hidden.
 * @param {number|string} rawOptions.siblingRange Number of always visible pages before and after the current one.
 * @param {number|string} rawOptions.totalPages Total number of pages.
 */

var createPaginationItems = function createPaginationItems(rawOptions) {
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["a" /* typifyOptions */])(rawOptions);
  var activePage = options.activePage,
      totalPages = options.totalPages;
  var pageFactory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["a" /* createPageFactory */])(activePage);
  var innerRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["b" /* isSimplePagination */])(options) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["a" /* createSimpleRange */])(1, totalPages, pageFactory) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["b" /* createComplexRange */])(options, pageFactory);
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["b" /* createFirstPage */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["c" /* createPrevItem */])(activePage)].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(innerRange), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["d" /* createNextItem */])(activePage, totalPages), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["e" /* createLastItem */])(totalPages)]);
};

/* harmony default export */ __webpack_exports__["a"] = (createPaginationItems);

/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__ = __webpack_require__(2537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__["a"]; });



/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSimplePagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typifyOptions; });
/**
 * Checks the possibility of using simple range generation, if number of generated pages is equal
 * or greater than total pages to show.
 *
 * @param {object} options
 * @param {number} options.boundaryRange Number of always visible pages at the beginning and end.
 * @param {number} options.siblingRange Number of always visible pages before and after the current one.
 * @param {number} options.totalPages Total number of pages.
 * @return {boolean}
 */
var isSimplePagination = function isSimplePagination(_ref) {
  var boundaryRange = _ref.boundaryRange,
      hideEllipsis = _ref.hideEllipsis,
      siblingRange = _ref.siblingRange,
      totalPages = _ref.totalPages;
  var boundaryRangeSize = 2 * boundaryRange;
  var ellipsisSize = hideEllipsis ? 0 : 2;
  var siblingRangeSize = 2 * siblingRange;
  return 1 + ellipsisSize + siblingRangeSize + boundaryRangeSize >= totalPages;
};
var typifyOptions = function typifyOptions(_ref2) {
  var activePage = _ref2.activePage,
      boundaryRange = _ref2.boundaryRange,
      hideEllipsis = _ref2.hideEllipsis,
      siblingRange = _ref2.siblingRange,
      totalPages = _ref2.totalPages;
  return {
    activePage: +activePage,
    boundaryRange: +boundaryRange,
    hideEllipsis: !!hideEllipsis,
    siblingRange: +siblingRange,
    totalPages: +totalPages
  };
};

/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSimpleRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createComplexRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__(2761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__suffixFactories__ = __webpack_require__(2541);




var createSimpleRange = function createSimpleRange(start, end, pageFactory) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(start, end + 1), pageFactory);
};
var createComplexRange = function createComplexRange(options, pageFactory) {
  var activePage = options.activePage,
      boundaryRange = options.boundaryRange,
      hideEllipsis = options.hideEllipsis,
      siblingRange = options.siblingRange,
      totalPages = options.totalPages;
  var ellipsisSize = hideEllipsis ? 0 : 1;
  var firstGroupEnd = boundaryRange;
  var firstGroup = createSimpleRange(1, firstGroupEnd, pageFactory);
  var lastGroupStart = totalPages + 1 - boundaryRange;
  var lastGroup = createSimpleRange(lastGroupStart, totalPages, pageFactory);
  var innerGroupStart = Math.min(Math.max(activePage - siblingRange, firstGroupEnd + ellipsisSize + 1), lastGroupStart - ellipsisSize - 2 * siblingRange - 1);
  var innerGroupEnd = innerGroupStart + 2 * siblingRange;
  var innerGroup = createSimpleRange(innerGroupStart, innerGroupEnd, pageFactory);
  return [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(firstGroup), [!hideEllipsis && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["a" /* createInnerPrefix */])(firstGroupEnd, innerGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(innerGroup), [!hideEllipsis && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["b" /* createInnerSuffix */])(innerGroupEnd, lastGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(lastGroup)).filter(Boolean);
};

/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInnerPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createInnerSuffix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemFactories__ = __webpack_require__(1329);

var createInnerPrefix = function createInnerPrefix(firstGroupEnd, innerGroupStart, pageFactory) {
  var prefixPage = innerGroupStart - 1;
  var showEllipsis = prefixPage !== firstGroupEnd + 1;
  var prefixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["f" /* createEllipsisItem */] : pageFactory;
  return prefixFactory(prefixPage);
};
var createInnerSuffix = function createInnerSuffix(innerGroupEnd, lastGroupStart, pageFactory) {
  var suffixPage = innerGroupEnd + 1;
  var showEllipsis = suffixPage !== lastGroupStart - 1;
  var suffixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["f" /* createEllipsisItem */] : pageFactory;
  return suffixFactory(suffixPage);
};

/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export as */
/* unused harmony export domNode */
/* unused harmony export suggest */
/* unused harmony export disallow */
/* unused harmony export every */
/* unused harmony export some */
/* unused harmony export givenProps */
/* unused harmony export demand */
/* unused harmony export multipleProp */
/* unused harmony export contentShorthand */
/* unused harmony export itemShorthand */
/* unused harmony export collectionShorthand */
/* unused harmony export deprecate */
/* unused harmony export refObject */
/* unused harmony export ref */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__ = __webpack_require__(2723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__ = __webpack_require__(2740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__ = __webpack_require__(2729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__ = __webpack_require__(2734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__ = __webpack_require__(2731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__ = __webpack_require__(2730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__ = __webpack_require__(2727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__ = __webpack_require__(2722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__ = __webpack_require__(2728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__ = __webpack_require__(2738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__ = __webpack_require__(2737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__ = __webpack_require__(2732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__leven__ = __webpack_require__(1330);




















var typeOf = function typeOf() {
  var _Object$prototype$toS;

  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
};
/**
 * Ensure a component can render as a give prop value.
 */

var as = function as() {
  return __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.symbol]).apply(void 0, arguments);
};
/**
 * Ensure a prop is a valid DOM node.
 */

var domNode = function domNode(props, propName) {
  // skip if prop is undefined
  if (props[propName] === undefined) return; // skip if prop is valid

  if (props[propName] instanceof Element) return;
  return new Error("Invalid prop \"".concat(propName, "\" supplied, expected a DOM node."));
};
/**
 * Similar to PropTypes.oneOf but shows closest matches.
 * Word order is ignored allowing `left chevron` to match `chevron left`.
 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
 * @param {string[]} suggestions An array of allowed values.
 */

var suggest = function suggest(suggestions) {
  if (!Array.isArray(suggestions)) {
    throw new Error('Invalid argument supplied to suggest, expected an instance of array.');
  }
  /* eslint-disable max-nested-callbacks */

  var findBestSuggestions = __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default()(function (str) {
    var propValueWords = str.split(' ');
    return __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (suggestion) {
      var suggestionWords = suggestion.split(' ');

      var propValueScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, suggestionWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(propValueWords);

      var suggestionScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, propValueWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(suggestionWords);

      return {
        suggestion: suggestion,
        score: propValueScore + suggestionScore
      };
    }), __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default()(['score', 'suggestion']), __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default()(3))(suggestions);
  });
  /* eslint-enable max-nested-callbacks */
  // Convert the suggestions list into a hash map for O(n) lookup times. Ensure
  // the words in each key are sorted alphabetically so that we have a consistent
  // way of looking up a value in the map, i.e. we can sort the words in the
  // incoming propValue and look that up without having to check all permutations.


  var suggestionsLookup = suggestions.reduce(function (acc, key) {
    acc[key.split(' ').sort().join(' ')] = true;
    return acc;
  }, {});
  return function (props, propName, componentName) {
    var propValue = props[propName]; // skip if prop is undefined or is included in the suggestions

    if (!propValue || suggestionsLookup[propValue]) return; // check if the words were correct but ordered differently.
    // Since we're matching for classNames we need to allow any word order
    // to pass validation, e.g. `left chevron` vs `chevron left`.

    var propValueSorted = propValue.split(' ').sort().join(' ');
    if (suggestionsLookup[propValueSorted]) return; // find best suggestions

    var bestMatches = findBestSuggestions(propValue); // skip if a match scored 0

    if (bestMatches.some(function (x) {
      return x.score === 0;
    })) return;
    return new Error(["Invalid prop `".concat(propName, "` of value `").concat(propValue, "` supplied to `").concat(componentName, "`."), "\n\nInstead of `".concat(propValue, "`, did you mean:"), bestMatches.map(function (x) {
      return "\n  - ".concat(x.suggestion);
    }).join(''), '\n'].join(''));
  };
};
/**
 * Disallow other props from being defined with this prop.
 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
 */

var disallow = function disallow(disallowedProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(disallowedProps)) {
      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
    } // skip if prop is undefined


    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[propName]) || props[propName] === false) return; // find disallowed props with values

    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[disallowedProp]) && props[disallowedProp] !== false) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(acc), [disallowedProp]);
      }

      return acc;
    }, []);

    if (disallowed.length > 0) {
      return new Error(["Prop `".concat(propName, "` in `").concat(componentName, "` conflicts with props: `").concat(disallowed.join('`, `'), "`."), 'They cannot be defined together, choose one or the other.'].join(' '));
    }
  };
};
/**
 * Ensure a prop adherers to multiple prop type validators.
 * @param {function[]} validators An array of propType functions.
 */

var every = function every(validators) {
  return function (props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to every, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (validator) {
      if (typeof validator !== 'function') {
        throw new Error("every() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    }), __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default.a)(validators); // we can only return one error at a time


    return errors[0];
  };
};
/**
 * Ensure a prop adherers to at least one of the given prop type validators.
 * @param {function[]} validators An array of propType functions.
 */

var some = function some(validators) {
  return function (props, propName, componentName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(validators, function (validator) {
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default()(validator)) {
        throw new Error("some() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    })); // fail only if all validators failed


    if (errors.length === validators.length) {
      var error = new Error('One of these validators must pass:');
      error.message += "\n".concat(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(errors, function (err, i) {
        return "[".concat(i + 1, "]: ").concat(err.message);
      }).join('\n'));
      return error;
    }
  };
};
/**
 * Ensure a validator passes only when a component has a given propsShape.
 * @param {object} propsShape An object describing the prop shape.
 * @param {function} validator A propType function.
 */

var givenProps = function givenProps(propsShape, validator) {
  return function (props, propName, componentName) {
    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    if (!__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default()(propsShape)) {
      throw new Error(['Invalid argument supplied to givenProps, expected an object.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    if (typeof validator !== 'function') {
      throw new Error(['Invalid argument supplied to givenProps, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var shouldValidate = __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape).every(function (key) {
      var val = propsShape[key]; // require propShape validators to pass or prop values to match

      return typeof val === 'function' ? !val.apply(void 0, [props, key, componentName].concat(rest)) : val === props[propName];
    });

    if (!shouldValidate) return;
    var error = validator.apply(void 0, [props, propName, componentName].concat(rest));

    if (error) {
      // poor mans shallow pretty print, prevents JSON circular reference errors
      var prettyProps = "{ ".concat(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape), props)).map(function (key) {
        var val = props[key];
        var renderedValue = val;
        if (typeof val === 'string') renderedValue = "\"".concat(val, "\"");else if (Array.isArray(val)) renderedValue = "[".concat(val.join(', '), "]");else if (__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default()(val)) renderedValue = '{...}';
        return "".concat(key, ": ").concat(renderedValue);
      }).join(', '), " }");
      error.message = "Given props ".concat(prettyProps, ": ").concat(error.message);
      return error;
    }
  };
};
/**
 * Define prop dependencies by requiring other props.
 * @param {string[]} requiredProps An array of required prop names.
 */

var demand = function demand(requiredProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(requiredProps)) {
      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
    } // skip if prop is undefined


    if (props[propName] === undefined) return;
    var missingRequired = requiredProps.filter(function (requiredProp) {
      return props[requiredProp] === undefined;
    });

    if (missingRequired.length > 0) {
      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` requires props: `").concat(missingRequired.join('`, `'), "`."));
    }
  };
};
/**
 * Ensure an multiple prop contains a string with only possible values.
 * @param {string[]} possible An array of possible values to prop.
 */

var multipleProp = function multipleProp(possible) {
  return function (props, propName, componentName) {
    if (!Array.isArray(possible)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var propValue = props[propName]; // skip if prop is undefined

    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(propValue) || propValue === false) return;
    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default()(val).replace('-', ' ');
    });

    var invalid = __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default()(values, possible); // fail only if there are invalid values


    if (invalid.length > 0) {
      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` has invalid values: `").concat(invalid.join('`, `'), "`."));
    }
  };
};
/**
 * Ensure a component can render as a node passed as a prop value in place of children.
 */

var contentShorthand = function contentShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node]).apply(void 0, arguments);
};
/**
 * Item shorthand is a description of a component that can be a literal,
 * a props object, or an element.
 */

var itemShorthand = function itemShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object]))])]).apply(void 0, arguments);
};
/**
 * Collection shorthand ensures a prop is an array of item shorthand.
 */

var collectionShorthand = function collectionShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(itemShorthand)]).apply(void 0, arguments);
};
/**
 * Show a deprecated warning for component props with a help message and optional validator.
 * @param {string} help A help message to display with the deprecation warning.
 * @param {function} [validator] A propType function.
 */

var deprecate = function deprecate(help, validator) {
  return function (props, propName, componentName) {
    if (typeof help !== 'string') {
      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    } // skip if prop is undefined


    if (props[propName] === undefined) return; // deprecation error and help

    var error = new Error("The `".concat(propName, "` prop in `").concat(componentName, "` is deprecated."));
    if (help) error.message += " ".concat(help); // add optional validation error message

    if (validator) {
      if (typeof validator === 'function') {
        for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
          args[_key4 - 3] = arguments[_key4];
        }

        var validationError = validator.apply(void 0, [props, propName, componentName].concat(args));

        if (validationError) {
          error.message = "".concat(error.message, " ").concat(validationError.message);
        }
      } else {
        throw new Error(['Invalid argument supplied to deprecate, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
      }
    }

    return error;
  };
};
/** A checker that matches the React.RefObject type. */

var refObject = __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object
});
/** A checker that matches the React.Ref type. */

var ref = __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, refObject]);

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);






/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */
var doesNodeContainClick = function doesNodeContainClick(node, e) {
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([e, node], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // if there is an e.target and it is in the document, use a simple node.contains() check

  if (e.target) {
    __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'setAttribute', 'data-suir-click-target', true);

    if (document.querySelector('[data-suir-click-target=true]')) {
      __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'removeAttribute', 'data-suir-click-target');

      return node.contains(e.target);
    }
  } // Below logic handles cases where the e.target is no longer in the document.
  // The result of the click likely has removed the e.target node.
  // Instead of node.contains(), we'll identify the click by X/Y position.
  // return early if the event properties aren't available
  // prevent measuring the node and repainting if we don't need to


  var clientX = e.clientX,
      clientY = e.clientY;
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([clientX, clientY], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // false if the node is not visible

  var clientRects = node.getClientRects(); // Heads Up!
  // getClientRects returns a DOMRectList, not an array nor a plain object
  // We explicitly avoid _.isEmpty and check .length to cover all possible shapes

  if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect

  var _first2 = __WEBPACK_IMPORTED_MODULE_1_lodash_first___default()(clientRects),
      top = _first2.top,
      bottom = _first2.bottom,
      left = _first2.left,
      right = _first2.right;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([top, bottom, left, right], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // we add a small decimal to the upper bound just to make it inclusive
  // don't add an whole pixel (1) as the event/node values may be decimal sensitive

  return __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientY, top, bottom + 0.001) && __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientX, left, right + 0.001);
};

/* harmony default export */ __webpack_exports__["a"] = (doesNodeContainClick);

/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__["instance"]);

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createShorthand;
/* harmony export (immutable) */ __webpack_exports__["a"] = createShorthandFactory;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHTMLDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createHTMLIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createHTMLImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createHTMLInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createHTMLLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createHTMLParagraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__ = __webpack_require__(2748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);











 // ============================================================
// Factories
// ============================================================

/**
 * A more robust React.createElement. It can create elements from primitive values.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @param {string|object|function} val The value to create a ReactElement from
 * @param {Object} [options={}]
 * @param {object} [options.defaultProps={}] Default props object
 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
 * @param {boolean} [options.autoGenerateKey=true] Whether or not automatic key generation is allowed
 * @returns {object|null}
 */

function createShorthand(Component, mapValueToProps, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthand() Component must be a string or function.');
  } // short circuit noop values


  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(val) || __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default()(val)) return null;

  var valIsString = __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(val);

  var valIsNumber = __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default()(val);

  var valIsFunction = __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(val);

  var valIsReactElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["isValidElement"])(val);

  var valIsPropsObject = __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject___default()(val);

  var valIsPrimitiveValue = valIsString || valIsNumber || __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(val); // unhandled type return null

  /* eslint-disable no-console */

  if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) {
    if (false) {
      console.error(['Shorthand value must be a string|number|array|object|ReactElement|function.', ' Use null|undefined|boolean for none', " Received ".concat(_typeof(val), ".")].join(''));
    }

    return null;
  }
  /* eslint-enable no-console */
  // ----------------------------------------
  // Build up props
  // ----------------------------------------


  var _options$defaultProps = options.defaultProps,
      defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props

  var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props

  var _options$overrideProp = options.overrideProps,
      overrideProps = _options$overrideProp === void 0 ? {} : _options$overrideProp;
  overrideProps = __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(overrideProps) ? overrideProps(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, usersProps)) : overrideProps; // Merge props

  /* eslint-disable react/prop-types */

  var props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, usersProps, overrideProps); // Merge className


  if (defaultProps.className || overrideProps.className || usersProps.className) {
    var mergedClassesNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(defaultProps.className, overrideProps.className, usersProps.className);
    props.className = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(mergedClassesNames.split(' ')).join(' ');
  } // Merge style


  if (defaultProps.style || overrideProps.style || usersProps.style) {
    props.style = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps.style, usersProps.style, overrideProps.style);
  } // ----------------------------------------
  // Get key
  // ----------------------------------------
  // Use key, childKey, or generate key


  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(props.key)) {
    var childKey = props.childKey;
    var _options$autoGenerate = options.autoGenerateKey,
        autoGenerateKey = _options$autoGenerate === void 0 ? true : _options$autoGenerate;

    if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(childKey)) {
      // apply and consume the childKey
      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
      delete props.childKey;
    } else if (autoGenerateKey && (valIsString || valIsNumber)) {
      // use string/number shorthand values as the key
      props.key = val;
    }
  } // ----------------------------------------
  // Create Element
  // ----------------------------------------
  // Clone ReactElements


  if (valIsReactElement) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"])(val, props); // Create ReactElements from built up props

  if (valIsPrimitiveValue || valIsPropsObject) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Component, props); // Call functions with args similar to createElement()

  if (valIsFunction) return val(Component, props, props.children);
  /* eslint-enable react/prop-types */
} // ============================================================
// Factory Creators
// ============================================================

/**
 * Creates a `createShorthand` function that is waiting for a value and options.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
 */

createShorthand.handledProps = [];
function createShorthandFactory(Component, mapValueToProps) {
  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthandFactory() Component must be a string or function.');
  }

  return function (val, options) {
    return createShorthand(Component, mapValueToProps, val, options);
  };
} // ============================================================
// HTML Factories
// ============================================================

var createHTMLDivision = createShorthandFactory('div', function (val) {
  return {
    children: val
  };
});
var createHTMLIframe = createShorthandFactory('iframe', function (src) {
  return {
    src: src
  };
});
var createHTMLImage = createShorthandFactory('img', function (val) {
  return {
    src: val
  };
});
var createHTMLInput = createShorthandFactory('input', function (val) {
  return {
    type: val
  };
});
var createHTMLLabel = createShorthandFactory('label', function (val) {
  return {
    children: val
  };
});
var createHTMLParagraph = createShorthandFactory('p', function (val) {
  return {
    children: val
  };
});

/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */
function getElementType(Component, props, getDefault) {
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
  // user defined "as" element type

  if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
  // computed default element type

  if (getDefault) {
    var computedDefault = getDefault();
    if (computedDefault) return computedDefault;
  } // ----------------------------------------
  // infer anchor links


  if (props.href) return 'a'; // ----------------------------------------
  // use defaultProp or 'div'

  return defaultProps.as || 'div';
}

/* harmony default export */ __webpack_exports__["a"] = (getElementType);

/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
var getUnhandledProps = function getUnhandledProps(Component, props) {
  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
  var _Component$handledPro = Component.handledProps,
      handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (getUnhandledProps);

/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return htmlInputAttrs; });
/* unused harmony export htmlInputEvents */
/* unused harmony export htmlInputProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlImageProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partitionHTMLProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);


var htmlInputAttrs = [// REACT
'selected', 'defaultValue', 'defaultChecked', // LIMITED HTML PROPS
'accept', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'form', 'id', 'lang', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'title', 'type', 'value'];
var htmlInputEvents = [// EVENTS
// keyboard
'onKeyDown', 'onKeyPress', 'onKeyUp', // focus
'onFocus', 'onBlur', // form
'onChange', 'onInput', // mouse
'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // selection
'onSelect', // touch
'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
var htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);
var htmlImageProps = ['alt', 'height', 'src', 'srcSet', 'width'];
/**
 * Returns an array of objects consisting of: props of html input element and rest.
 * @param {object} props A ReactElement props object
 * @param {Object} [options={}]
 * @param {Array} [options.htmlProps] An array of html input props
 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
 * @returns {[{}, {}]} An array of objects
 */

var partitionHTMLProps = function partitionHTMLProps(props) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$htmlProps = options.htmlProps,
      htmlProps = _options$htmlProps === void 0 ? htmlInputProps : _options$htmlProps,
      _options$includeAria = options.includeAria,
      includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
  var inputProps = {};
  var rest = {};

  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(props, function (val, prop) {
    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
    var target = __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(htmlProps, prop) || possibleAria ? inputProps : rest;
    target[prop] = val;
  });

  return [inputProps, rest];
};

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);


var hasDocument = (typeof document === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(document)) === 'object' && document !== null;
var hasWindow = (typeof window === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(window)) === 'object' && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow

var isBrowser = function isBrowser() {
  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
};

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);

/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
});

/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
});

/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_transform__);




/**
 * Naive and inefficient object difference, intended for development / debugging use only.
 * Deleted keys are shown as [DELETED].
 * @param {{}} source The source object
 * @param {{}} target The target object.
 * @returns {{}} A new object containing new/modified/deleted keys.
 * @example
 * import { objectDiff } from 'src/lib'
 *
 * const a = { key: 'val', foo: 'bar' }
 * const b = { key: 'val', foo: 'baz' }
 *
 * objectDiff(a, b)
 * //=> { foo: 'baz' }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source, target) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default()(source, function (res, val, key) {
    // deleted keys
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(target, key)) res[key] = '[DELETED]'; // new keys / changed values
    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
    else if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(val, target[key])) res[key] = target[key];
  }, {});
});

/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionContent__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__ = __webpack_require__(774);









/**
 * An accordion allows users to toggle the display of sections of content.
 */

function Accordion(props) {
  var className = props.className,
      fluid = props.fluid,
      inverted = props.inverted,
      styled = props.styled;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(styled, 'styled'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Accordion, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

Accordion.handledProps = ["className", "fluid", "inverted", "styled"];
Accordion.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** Format to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Format for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Adds some basic styling to accordion panels. */
  styled: PropTypes.bool
} : {};
Accordion.Accordion = __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */];
Accordion.Content = __WEBPACK_IMPORTED_MODULE_6__AccordionContent__["a" /* default */];
Accordion.Panel = __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__["a" /* default */];
Accordion.Title = __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib__ = __webpack_require__(7);




















/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 * @see Form
 * @see Radio
 */
var Checkbox =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Checkbox, _Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "inputRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "labelRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "canToggle", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          radio = _this$props.radio,
          readOnly = _this$props.readOnly;
      var checked = _this.state.checked;
      return !disabled && !readOnly && !(radio && checked);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var id = _this.props.id;
      var _this$state = _this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;
      var hasId = !__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(id);
      var isLabelClick = e.target === _this.labelRef.current;
      var isLabelClickAndForwardedToInput = isLabelClick && hasId; // https://github.com/Semantic-Org/Semantic-UI-React/pull/3351

      if (!isLabelClickAndForwardedToInput) {
        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onClick', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          checked: !checked,
          indeterminate: !!indeterminate
        }));
      }

      if (_this.isClickFromMouse) {
        _this.isClickFromMouse = false;

        if (isLabelClick && !hasId) {
          _this.handleChange(e);
        }

        if (hasId) {
          // To prevent two clicks from being fired from the component we have to stop the propagation
          // from the "input" click: https://github.com/Semantic-Org/Semantic-UI-React/issues/3433
          e.stopPropagation();
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var checked = _this.state.checked;
      if (!_this.canToggle()) return;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !checked,
        indeterminate: false
      }));

      _this.trySetState({
        checked: !checked,
        indeterminate: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      var _this$state2 = _this.state,
          checked = _this$state2.checked,
          indeterminate = _this$state2.indeterminate;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMouseDown', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.inputRef.current, 'focus'); // Heads up!
      // We need to call "preventDefault" to keep element focused.


      e.preventDefault();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseUp", function (e) {
      var _this$state3 = _this.state,
          checked = _this$state3.checked,
          indeterminate = _this$state3.indeterminate;
      _this.isClickFromMouse = true;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMouseUp', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "setIndeterminate", function () {
      var indeterminate = _this.state.indeterminate;

      __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()(_this.inputRef, 'current.indeterminate', !!indeterminate);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIndeterminate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setIndeterminate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          label = _this$props3.label,
          id = _this$props3.id,
          name = _this$props3.name,
          radio = _this$props3.radio,
          readOnly = _this$props3.readOnly,
          slider = _this$props3.slider,
          toggle = _this$props3.toggle,
          type = _this$props3.type,
          value = _this$props3.value;
      var _this$state4 = this.state,
          checked = _this$state4.checked,
          indeterminate = _this$state4.indeterminate;
      var classes = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(checked, 'checked'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(indeterminate, 'indeterminate'), // auto apply fitted class to compact white space when there is no label
      // https://semantic-ui.com/modules/checkbox.html#fitted
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(label), 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(radio, 'radio'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(readOnly, 'read-only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(slider, 'slider'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), 'checkbox', className);
      var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["b" /* getUnhandledProps */])(Checkbox, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["c" /* getElementType */])(Checkbox, this.props);

      var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["l" /* partitionHTMLProps */])(unhandled, {
        htmlProps: __WEBPACK_IMPORTED_MODULE_18__lib__["y" /* htmlInputAttrs */]
      }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1]; // Heads Up!
      // Do not remove empty labels, they are required by SUI CSS


      var labelElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["D" /* createHTMLLabel */])(label, {
        defaultProps: {
          htmlFor: id
        },
        autoGenerateKey: false
      }) || __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("label", {
        htmlFor: id
      });
      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      }), __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__addons_Ref__["a" /* default */], {
        innerRef: this.inputRef
      }, __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("input", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, htmlInputProps, {
        checked: checked,
        className: "hidden",
        disabled: disabled,
        id: id,
        name: name,
        readOnly: true,
        tabIndex: this.computeTabIndex(),
        type: type,
        value: value
      }))), __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__addons_Ref__["a" /* default */], {
        innerRef: this.labelRef
      }, labelElement));
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_18__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "defaultProps", {
  type: 'checkbox'
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "autoControlledProps", ['checked', 'indeterminate']);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "handledProps", ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"]);


Checkbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not checkbox is checked. */
  checked: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** The initial value of checked. */
  defaultChecked: PropTypes.bool,

  /** Whether or not checkbox is indeterminate. */
  defaultIndeterminate: PropTypes.bool,

  /** A checkbox can appear disabled and be unable to change states */
  disabled: PropTypes.bool,

  /** Removes padding for a label. Auto applied when there is no label. */
  fitted: PropTypes.bool,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Whether or not checkbox is indeterminate. */
  indeterminate: PropTypes.bool,

  /** The text of the associated label element. */
  label: customPropTypes.itemShorthand,

  /** The HTML input name. */
  name: PropTypes.string,

  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed checked/indeterminate state.
   */
  onChange: PropTypes.func,

  /**
   * Called when the checkbox or label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onClick: PropTypes.func,

  /**
   * Called when the user presses down on the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when the user releases the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseUp: PropTypes.func,

  /** Format as a radio element. This means it is an exclusive option. */
  radio: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['slider', 'toggle'])]),

  /** A checkbox can be read-only and unable to change states. */
  readOnly: PropTypes.bool,

  /** Format to emphasize the current selection state. */
  slider: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'toggle'])]),

  /** A checkbox can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Format to show an on or off choice. */
  toggle: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'slider'])]),

  /** HTML input type, either checkbox or radio. */
  type: PropTypes.oneOf(['checkbox', 'radio']),

  /** The HTML input value. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};

/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addons_Portal__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DimmerDimmable__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DimmerInner__ = __webpack_require__(1333);














/**
 * A dimmer hides distractions to focus attention on particular content.
 */

var Dimmer =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Dimmer, _Component);

  function Dimmer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Dimmer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Dimmer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["w" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.add('dimmed');
      document.body.classList.add('dimmable');
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["w" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.remove('dimmed');
      document.body.classList.remove('dimmable');
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Dimmer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          page = _this$props.page;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["b" /* getUnhandledProps */])(Dimmer, this.props);

      if (page) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__addons_Portal__["a" /* default */], {
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onMount: this.handlePortalMount,
          onUnmount: this.handlePortalUnmount,
          open: active,
          openOnTriggerClick: false
        }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          active: active,
          page: page
        })));
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        active: active,
        page: page
      }));
    }
  }]);

  return Dimmer;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "Dimmable", __WEBPACK_IMPORTED_MODULE_12__DimmerDimmable__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "Inner", __WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "handledProps", ["active", "page"]);


Dimmer.propTypes =  false ? {
  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool
} : {};
Dimmer.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["e" /* createShorthandFactory */])(Dimmer, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_compact__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_every__ = __webpack_require__(2714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_reduce__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_some__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp__ = __webpack_require__(2713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_deburr__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_deburr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isFunction__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_filter__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_pick__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight__ = __webpack_require__(2712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_size__ = __webpack_require__(2765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_difference__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_union__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_isUndefined__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_isEqual__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_has__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_keyboard_key__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_shallowequal__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__elements_Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__elements_Label__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__DropdownDivider__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__DropdownItem__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__DropdownHeader__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__DropdownMenu__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__DropdownSearchInput__ = __webpack_require__(1339);



















































var getKeyOrValue = function getKeyOrValue(key, value) {
  return __WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default()(key) ? value : key;
};
/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */

var Dropdown =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Dropdown, _Component);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "searchRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "sizerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e, value) {
      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnChange", function (e) {
      var _this$props = _this.props,
          closeOnChange = _this$props.closeOnChange,
          multiple = _this$props.multiple;
      var shouldClose = __WEBPACK_IMPORTED_MODULE_30_lodash_isUndefined___default()(closeOnChange) ? !multiple : closeOnChange;
      if (shouldClose) _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnEscape", function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionOnKeyDown", function (e) {
      var _moves;

      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          selectOnNavigation = _this$props2.selectOnNavigation;
      var moves = (_moves = {}, __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.ArrowDown, 1), __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.ArrowUp, -1), _moves);
      var move = moves[__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e)];
      if (move === undefined) return;
      e.preventDefault();

      _this.moveSelectionBy(move);

      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openOnSpace", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.Spacebar) return;
      e.preventDefault();

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openOnArrow", function (e) {
      var code = __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e);
      if (!__WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()([__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.ArrowDown, __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.ArrowUp], code)) return;
      if (_this.state.open) return;
      e.preventDefault();

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "makeSelectedItemActive", function (e) {
      var _this$state = _this.state,
          open = _this$state.open,
          value = _this$state.value;
      var multiple = _this.props.multiple;

      var item = _this.getSelectedItem();

      var selectedValue = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(item, 'value'); // prevent selecting null if there was no selected item value
      // prevent selecting duplicate items when the dropdown is closed


      if (__WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default()(selectedValue) || !open) return; // state value may be undefined

      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_27_lodash_union___default()(_this.state.value, [selectedValue]) : selectedValue;
      var valueHasChanged = multiple ? !!__WEBPACK_IMPORTED_MODULE_26_lodash_difference___default()(newValue, value).length : newValue !== value;

      if (valueHasChanged) {
        // notify the onChange prop that the user is trying to change value
        _this.setValue(newValue);

        _this.setSelectedIndex(newValue);

        _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
        // Notify the onAddItem prop if this is a new value


        if (item['data-additional']) {
          __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
            value: selectedValue
          }));
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "selectItemOnEnter", function (e) {
      var search = _this.props.search;
      if (__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.Enter) return;
      e.preventDefault();

      var optionSize = __WEBPACK_IMPORTED_MODULE_25_lodash_size___default()(_this.getMenuOptions());

      if (search && optionSize === 0) return;

      _this.makeSelectedItemActive(e);

      _this.closeOnChange(e);

      _this.clearSearchQuery();

      if (search) __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.searchRef.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "removeItemOnBackspace", function (e) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          search = _this$props3.search;
      var _this$state2 = _this.state,
          searchQuery = _this$state2.searchQuery,
          value = _this$state2.value;
      if (__WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_37_keyboard_key___default.a.Backspace) return;
      if (searchQuery || !search || !multiple || __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value)) return;
      e.preventDefault(); // remove most recent value

      var newValue = __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight___default()(value);

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnDocumentClick", function (e) {
      if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it

      if (_this.ref.current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["x" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      _this.isMouseDown = true;

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);

      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseUp", function () {
      _this.isMouseDown = false;
      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var _this$props4 = _this.props,
          minCharacters = _this$props4.minCharacters,
          search = _this$props4.search;
      var _this$state3 = _this.state,
          open = _this$state3.open,
          searchQuery = _this$state3.searchQuery;

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onClick', e, _this.props); // prevent closeOnDocumentClick()


      e.stopPropagation();
      if (!search) return _this.toggle(e);

      if (open) {
        __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.searchRef.current, 'focus');

        return;
      }

      if (searchQuery.length >= minCharacters || minCharacters === 1) {
        _this.open(e);

        return;
      }

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.searchRef.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconClick", function (e) {
      var clearable = _this.props.clearable;

      var hasValue = _this.hasValue();

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onClick', e, _this.props); // prevent handleClick()


      e.stopPropagation();

      if (clearable && hasValue) {
        _this.clearValue(e);
      } else {
        _this.toggle(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, item) {
      var _this$props5 = _this.props,
          multiple = _this$props5.multiple,
          search = _this$props5.search;
      var currentValue = _this.state.value;
      var value = item.value; // prevent toggle() in handleClick()

      e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled

      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
      if (item.disabled) return;
      var isAdditionItem = item['data-additional'];
      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_27_lodash_union___default()(_this.state.value, [value]) : value;
      var valueHasChanged = multiple ? !!__WEBPACK_IMPORTED_MODULE_26_lodash_difference___default()(newValue, currentValue).length : newValue !== currentValue; // notify the onChange prop that the user is trying to change value

      if (valueHasChanged) {
        _this.setValue(newValue);

        _this.setSelectedIndex(value);

        _this.handleChange(e, newValue);
      }

      _this.clearSearchQuery(value);

      _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
      // Notify the onAddItem prop if this is a new value


      if (isAdditionItem) __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
      if (search) __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.searchRef.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleFocus", function (e) {
      var focus = _this.state.focus;
      if (focus) return;

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleBlur", function (e) {
      // Heads up! Don't remove this.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
      var currentTarget = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(e, 'currentTarget');

      if (currentTarget && currentTarget.contains(document.activeElement)) return;
      var _this$props6 = _this.props,
          closeOnBlur = _this$props6.closeOnBlur,
          multiple = _this$props6.multiple,
          selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown

      if (_this.isMouseDown) return;

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onBlur', e, _this.props);

      if (selectOnBlur && !multiple) {
        _this.makeSelectedItemActive(e);

        if (closeOnBlur) _this.close();
      }

      _this.setState({
        focus: false
      });

      _this.clearSearchQuery();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchChange", function (e, _ref) {
      var value = _ref.value;
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = value;

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        searchQuery: newQuery
      }));

      _this.trySetState({
        searchQuery: newQuery
      }, {
        selectedIndex: 0
      }); // open search dropdown on search query


      if (!open && newQuery.length >= minCharacters) {
        _this.open();

        return;
      } // close search dropdown if search query is too small


      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getKeyAndValues", function (options) {
      return options ? options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_22_lodash_pick___default()(option, ['key', 'value']);
      }) : options;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMenuOptions", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
      var _this$props7 = _this.props,
          additionLabel = _this$props7.additionLabel,
          additionPosition = _this$props7.additionPosition,
          allowAdditions = _this$props7.allowAdditions,
          deburr = _this$props7.deburr,
          multiple = _this$props7.multiple,
          search = _this$props7.search;
      var filteredOptions = options; // filter out active options

      if (multiple) {
        filteredOptions = __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default()(filteredOptions, function (opt) {
          return !__WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(value, opt.value);
        });
      } // filter by search query


      if (search && searchQuery) {
        if (__WEBPACK_IMPORTED_MODULE_20_lodash_isFunction___default()(search)) {
          filteredOptions = search(filteredOptions, searchQuery);
        } else {
          // remove diacritics on search input and options, if deburr prop is set
          var strippedQuery = deburr ? __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default()(searchQuery) : searchQuery;
          var re = new RegExp(__WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp___default()(strippedQuery), 'i');
          filteredOptions = __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default()(filteredOptions, function (opt) {
            return re.test(deburr ? __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default()(opt.text) : opt.text);
          });
        }
      } // insert the "add" item


      if (allowAdditions && search && searchQuery && !__WEBPACK_IMPORTED_MODULE_17_lodash_some___default()(filteredOptions, {
        text: searchQuery
      })) {
        var additionLabelElement = __WEBPACK_IMPORTED_MODULE_39_react___default.a.isValidElement(additionLabel) ? __WEBPACK_IMPORTED_MODULE_39_react___default.a.cloneElement(additionLabel, {
          key: 'addition-label'
        }) : additionLabel || '';
        var addItem = {
          key: 'addition',
          // by using an array, we can pass multiple elements, but when doing so
          // we must specify a `key` for React to know which one is which
          text: [additionLabelElement, __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement("b", {
            key: "addition-query"
          }, searchQuery)],
          value: searchQuery,
          className: 'addition',
          'data-additional': true
        };
        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
      }

      return filteredOptions;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getSelectedItem", function () {
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(options, "[".concat(selectedIndex, "]"));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getEnabledIndices", function (givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_16_lodash_reduce___default()(options, function (memo, item, index) {
        if (!item.disabled) memo.push(index);
        return memo;
      }, []);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getItemByValue", function (value) {
      var options = _this.props.options;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_find___default()(options, {
        value: value
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMenuItemIndexByValue", function (value, givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex___default()(options, ['value', value]);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getDropdownAriaOptions", function () {
      var _this$props8 = _this.props,
          loading = _this$props8.loading,
          disabled = _this$props8.disabled,
          search = _this$props8.search,
          multiple = _this$props8.multiple;
      var open = _this.state.open;
      var ariaOptions = {
        role: search ? 'combobox' : 'listbox',
        'aria-busy': loading,
        'aria-disabled': disabled,
        'aria-expanded': !!open
      };

      if (ariaOptions.role === 'listbox') {
        ariaOptions['aria-multiselectable'] = multiple;
      }

      return ariaOptions;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "clearSearchQuery", function (value) {
      var searchQuery = _this.state.searchQuery;
      if (searchQuery === undefined || searchQuery === '') return;

      _this.trySetState({
        searchQuery: ''
      });

      _this.setSelectedIndex(value, undefined, '');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setValue", function (value) {
      _this.trySetState({
        value: value
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setSelectedIndex", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
      var multiple = _this.props.multiple;
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions(value, optionsProps, searchQuery);

      var enabledIndicies = _this.getEnabledIndices(options);

      var newSelectedIndex; // update the selected index

      if (!selectedIndex || selectedIndex < 0) {
        var firstIndex = enabledIndicies[0]; // Select the currently active item, if none, use the first item.
        // Multiple selects remove active items from the list,
        // their initial selected index should be 0.

        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
      } else if (multiple) {
        // multiple selects remove options from the menu as they are made active
        // keep the selected index within range of the remaining items
        if (selectedIndex >= options.length - 1) {
          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
        }
      } else {
        var activeIndex = _this.getMenuItemIndexByValue(value, options); // regular selects can only have one active item
        // set the selected index to the currently active item


        newSelectedIndex = __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(enabledIndicies, activeIndex) ? activeIndex : undefined;
      }

      if (!newSelectedIndex || newSelectedIndex < 0) {
        newSelectedIndex = enabledIndicies[0];
      }

      _this.setState({
        selectedIndex: newSelectedIndex
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleLabelClick", function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();

      _this.setState({
        selectedLabel: labelProps.value
      });

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onLabelClick', e, labelProps);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleLabelRemove", function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();
      var value = _this.state.value;

      var newValue = __WEBPACK_IMPORTED_MODULE_13_lodash_without___default()(value, labelProps.value);

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionBy", function (offset) {
      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;

      var options = _this.getMenuOptions(); // Prevent infinite loop
      // TODO: remove left part of condition after children API will be removed


      if (options === undefined || __WEBPACK_IMPORTED_MODULE_12_lodash_every___default()(options, 'disabled')) return;
      var lastIndex = options.length - 1;
      var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change

      if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) {
        nextIndex = startIndex;
      } else if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      if (options[nextIndex].disabled) {
        _this.moveSelectionBy(offset, nextIndex);

        return;
      }

      _this.setState({
        selectedIndex: nextIndex
      });

      _this.scrollSelectedItemIntoView();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      var clearable = _this.props.clearable;
      var classes = __WEBPACK_IMPORTED_MODULE_36_classnames___default()(clearable && _this.hasValue() && 'clear', predefinedProps.className);
      return {
        className: classes,
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(predefinedProps, 'onClick', e, predefinedProps);

          _this.handleIconClick(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "clearValue", function (e) {
      var multiple = _this.props.multiple;
      var newValue = multiple ? [] : '';

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeSearchInputTabIndex", function () {
      var _this$props9 = _this.props,
          disabled = _this$props9.disabled,
          tabIndex = _this$props9.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeSearchInputWidth", function () {
      var searchQuery = _this.state.searchQuery;

      if (_this.sizerRef.current && searchQuery) {
        // resize the search input, temporarily show the sizer so we can measure it
        _this.sizerRef.current.style.display = 'inline';
        _this.sizerRef.current.textContent = searchQuery;
        var searchWidth = Math.ceil(_this.sizerRef.current.getBoundingClientRect().width);

        _this.sizerRef.current.style.removeProperty('display');

        return searchWidth;
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props10 = _this.props,
          disabled = _this$props10.disabled,
          search = _this$props10.search,
          tabIndex = _this$props10.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex

      if (search) return undefined;
      if (disabled) return -1;
      return __WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default()(tabIndex) ? 0 : tabIndex;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchInputOverrides", function (predefinedProps) {
      return {
        onChange: function onChange(e, inputProps) {
          __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(predefinedProps, 'onChange', e, inputProps);

          _this.handleSearchChange(e, inputProps);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "hasValue", function () {
      var multiple = _this.props.multiple;
      var value = _this.state.value;
      return multiple ? !__WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value) : !__WEBPACK_IMPORTED_MODULE_34_lodash_isNil___default()(value) && value !== '';
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "scrollSelectedItemIntoView", function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;
      var item = menu.querySelector('.item.selected');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        // eslint-disable-next-line no-mixed-operators
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setOpenDirection", function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;

      var dropdownRect = _this.ref.current.getBoundingClientRect();

      var menuHeight = menu.clientHeight;
      var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
      var spaceAtTheTop = dropdownRect.top - menuHeight;
      var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference

      if (!upward !== !_this.state.upward) {
        _this.trySetState({
          upward: upward
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function (e) {
      var _this$props11 = _this.props,
          disabled = _this$props11.disabled,
          open = _this$props11.open,
          search = _this$props11.search;
      if (disabled) return;
      if (search) __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.searchRef.current, 'focus');

      __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);

      _this.trySetState({
        open: true
      });

      _this.scrollSelectedItemIntoView();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function (e) {
      var open = _this.state.open;

      if (open) {
        __WEBPACK_IMPORTED_MODULE_31_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

        _this.trySetState({
          open: false
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function () {
      var hasSearchFocus = document.activeElement === _this.searchRef.current; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
      // Blur the Dropdown on close so it is blurred after selecting an item.
      // This is to prevent it from re-opening when switching tabs after selecting an item.

      if (!hasSearchFocus) {
        _this.ref.current.blur();
      }

      var hasDropdownFocus = document.activeElement === _this.ref.current;
      var hasFocus = hasSearchFocus || hasDropdownFocus; // We need to keep the virtual model in sync with the browser focus change
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692

      _this.setState({
        focus: hasFocus
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "toggle", function (e) {
      return _this.state.open ? _this.close(e) : _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderText", function () {
      var _this$props12 = _this.props,
          multiple = _this$props12.multiple,
          placeholder = _this$props12.placeholder,
          search = _this$props12.search,
          text = _this$props12.text;
      var _this$state4 = _this.state,
          searchQuery = _this$state4.searchQuery,
          value = _this$state4.value,
          open = _this$state4.open;

      var hasValue = _this.hasValue();

      var classes = __WEBPACK_IMPORTED_MODULE_36_classnames___default()(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
      var _text = placeholder;

      if (searchQuery) {
        _text = null;
      } else if (text) {
        _text = text;
      } else if (open && !multiple) {
        _text = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.getSelectedItem(), 'text');
      } else if (hasValue) {
        _text = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.getItemByValue(value), 'text');
      }

      return __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement("div", {
        className: classes,
        role: "alert",
        "aria-live": "polite",
        "aria-atomic": true
      }, _text);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchInput", function () {
      var _this$props13 = _this.props,
          search = _this$props13.search,
          searchInput = _this$props13.searchInput;
      var searchQuery = _this.state.searchQuery;
      return search && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__addons_Ref__["a" /* default */], {
        innerRef: _this.searchRef
      }, __WEBPACK_IMPORTED_MODULE_49__DropdownSearchInput__["a" /* default */].create(searchInput, {
        defaultProps: {
          style: {
            width: _this.computeSearchInputWidth()
          },
          tabIndex: _this.computeSearchInputTabIndex(),
          value: searchQuery
        },
        overrideProps: _this.handleSearchInputOverrides
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchSizer", function () {
      var _this$props14 = _this.props,
          search = _this$props14.search,
          multiple = _this$props14.multiple;
      return search && multiple && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement("span", {
        className: "sizer",
        ref: _this.sizerRef
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderLabels", function () {
      var _this$props15 = _this.props,
          multiple = _this$props15.multiple,
          renderLabel = _this$props15.renderLabel;
      var _this$state5 = _this.state,
          selectedLabel = _this$state5.selectedLabel,
          value = _this$state5.value;

      if (!multiple || __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value)) {
        return;
      }

      var selectedItems = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(value, _this.getItemByValue);

      // if no item could be found for a given state value the selected item will be undefined
      // compact the selectedItems so we only have actual objects left
      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_compact___default()(selectedItems), function (item, index) {
        var defaultProps = {
          active: item.value === selectedLabel,
          as: 'a',
          key: getKeyOrValue(item.key, item.value),
          onClick: _this.handleLabelClick,
          onRemove: _this.handleLabelRemove,
          value: item.value
        };
        return __WEBPACK_IMPORTED_MODULE_44__elements_Label__["a" /* default */].create(renderLabel(item, index, defaultProps), {
          defaultProps: defaultProps
        });
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderOptions", function () {
      var _this$props16 = _this.props,
          lazyLoad = _this$props16.lazyLoad,
          multiple = _this$props16.multiple,
          search = _this$props16.search,
          noResultsMessage = _this$props16.noResultsMessage;
      var _this$state6 = _this.state,
          open = _this$state6.open,
          selectedIndex = _this$state6.selectedIndex,
          value = _this$state6.value; // lazy load, only render options when open

      if (lazyLoad && !open) return null;

      var options = _this.getMenuOptions();

      if (noResultsMessage !== null && search && __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(options)) {
        return __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement("div", {
          className: "message"
        }, noResultsMessage);
      }

      var isActive = multiple ? function (optValue) {
        return __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(value, optValue);
      } : function (optValue) {
        return optValue === value;
      };
      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(options, function (opt, i) {
        return __WEBPACK_IMPORTED_MODULE_46__DropdownItem__["a" /* default */].create(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
          active: isActive(opt.value),
          onClick: _this.handleItemClick,
          selected: selectedIndex === i
        }, opt, {
          key: getKeyOrValue(opt.key, opt.value),
          // Needed for handling click events on disabled items
          style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, opt.style, {
            pointerEvents: 'all'
          })
        }));
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderMenu", function () {
      var _this$props17 = _this.props,
          children = _this$props17.children,
          direction = _this$props17.direction,
          header = _this$props17.header;
      var open = _this.state.open;

      var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child


      if (!__WEBPACK_IMPORTED_MODULE_41__lib__["d" /* childrenUtils */].isNil(children)) {
        var menuChild = __WEBPACK_IMPORTED_MODULE_39_react__["Children"].only(children);
        var className = __WEBPACK_IMPORTED_MODULE_36_classnames___default()(direction, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(open, 'visible'), menuChild.props.className);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_react__["cloneElement"])(menuChild, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
          className: className
        }, ariaOptions));
      }

      return __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__DropdownMenu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, ariaOptions, {
        direction: direction,
        open: open
      }), __WEBPACK_IMPORTED_MODULE_47__DropdownHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), _this.renderOptions());
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Dropdown, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState() {
      return {
        focus: false,
        searchQuery: ''
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$state7 = this.state,
          open = _this$state7.open,
          value = _this$state7.value;
      this.setValue(value);
      this.setSelectedIndex(value);

      if (open) {
        this.open();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Dropdown.prototype), "componentWillReceiveProps", this).call(this, nextProps);

      /* eslint-disable no-console */
      if (false) {
        // in development, validate value type matches dropdown type
        var isNextValueArray = Array.isArray(nextProps.value);

        var hasValue = _has(nextProps, 'value');

        if (hasValue && nextProps.multiple && !isNextValueArray) {
          console.error('Dropdown `value` must be an array when `multiple` is set.' + " Received type: `".concat(Object.prototype.toString.call(nextProps.value), "`."));
        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
        }
      }
      /* eslint-enable no-console */

      if (!__WEBPACK_IMPORTED_MODULE_40_shallowequal___default()(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
        this.setSelectedIndex(nextProps.value);
      } // The selected index is only dependent on option keys/values.
      // We only check those properties to avoid recursive performance impacts.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000


      if (!__WEBPACK_IMPORTED_MODULE_32_lodash_isEqual___default()(this.getKeyAndValues(nextProps.options), this.getKeyAndValues(this.props.options))) {
        this.setSelectedIndex(undefined, nextProps.options);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !__WEBPACK_IMPORTED_MODULE_40_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_40_shallowequal___default()(nextState, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // eslint-disable-line complexity
      var _this$props18 = this.props,
          closeOnBlur = _this$props18.closeOnBlur,
          minCharacters = _this$props18.minCharacters,
          openOnFocus = _this$props18.openOnFocus,
          search = _this$props18.search; // focused / blurred

      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          var openable = !search || search && minCharacters === 1 && !this.state.open;
          if (openOnFocus && openable) this.open();
        }
      } else if (prevState.focus && !this.state.focus) {
        if (!this.isMouseDown && closeOnBlur) {
          this.close();
        }
      } // opened / closed


      if (!prevState.open && this.state.open) {
        this.setOpenDirection();
        this.scrollSelectedItemIntoView();
      } else if (prevState.open && !this.state.open) {
        this.handleClose();
      }
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------
    // onChange needs to receive a value
    // can't rely on props.value if we are controlled

  }, {
    key: "getDropdownMenuAriaOptions",
    value: function getDropdownMenuAriaOptions() {
      var _this$props19 = this.props,
          search = _this$props19.search,
          multiple = _this$props19.multiple;
      var ariaOptions = {};

      if (search) {
        ariaOptions['aria-multiselectable'] = multiple;
        ariaOptions.role = 'listbox';
      }

      return ariaOptions;
    } // ----------------------------------------
    // Setters
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$props20 = this.props,
          basic = _this$props20.basic,
          button = _this$props20.button,
          className = _this$props20.className,
          compact = _this$props20.compact,
          disabled = _this$props20.disabled,
          error = _this$props20.error,
          fluid = _this$props20.fluid,
          floating = _this$props20.floating,
          icon = _this$props20.icon,
          inline = _this$props20.inline,
          item = _this$props20.item,
          labeled = _this$props20.labeled,
          loading = _this$props20.loading,
          multiple = _this$props20.multiple,
          pointing = _this$props20.pointing,
          search = _this$props20.search,
          selection = _this$props20.selection,
          scrolling = _this$props20.scrolling,
          simple = _this$props20.simple,
          trigger = _this$props20.trigger;
      var _this$state8 = this.state,
          focus = _this$state8.focus,
          open = _this$state8.open,
          upward = _this$state8.upward; // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_36_classnames___default()('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(open, 'active visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(button, 'button'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(inline, 'inline'), // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
      // TODO: the icon class is only required when a dropdown is a button
      // useKeyOnly(icon, 'icon'),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(labeled, 'labeled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(item, 'item'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(multiple, 'multiple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(search, 'search'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(selection, 'selection'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(simple, 'simple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["a" /* useKeyOnly */])(upward, 'upward'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["h" /* useKeyOrValueAndKey */])(pointing, 'pointing'), 'dropdown', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["b" /* getUnhandledProps */])(Dropdown, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__lib__["c" /* getElementType */])(Dropdown, this.props);
      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
      return __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__addons_Ref__["a" /* default */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        tabIndex: this.computeTabIndex()
      }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), __WEBPACK_IMPORTED_MODULE_43__elements_Icon__["a" /* default */].create(icon, {
        overrideProps: this.handleIconOverrides,
        autoGenerateKey: false
      }), this.renderMenu(), open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.closeOnEscape
      }), open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.moveSelectionOnKeyDown
      }), open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "click",
        on: this.closeOnDocumentClick
      }), open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.selectItemOnEnter
      }), focus && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.removeItemOnBackspace
      }), focus && !open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.openOnArrow
      }), focus && !open && __WEBPACK_IMPORTED_MODULE_39_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.openOnSpace
      })));
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_41__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "defaultProps", {
  additionLabel: 'Add ',
  additionPosition: 'top',
  closeOnBlur: true,
  closeOnEscape: true,
  deburr: false,
  icon: 'dropdown',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  openOnFocus: true,
  renderLabel: function renderLabel(_ref2) {
    var text = _ref2.text;
    return text;
  },
  searchInput: 'text',
  selectOnBlur: true,
  selectOnNavigation: true,
  wrapSelection: true
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "autoControlledProps", ['open', 'searchQuery', 'selectedLabel', 'value', 'upward']);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Divider", __WEBPACK_IMPORTED_MODULE_45__DropdownDivider__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Header", __WEBPACK_IMPORTED_MODULE_47__DropdownHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Item", __WEBPACK_IMPORTED_MODULE_46__DropdownItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Menu", __WEBPACK_IMPORTED_MODULE_48__DropdownMenu__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "SearchInput", __WEBPACK_IMPORTED_MODULE_49__DropdownSearchInput__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "handledProps", ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"]);


Dropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Label prefixed to an option added by a user. */
  additionLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
  additionPosition: PropTypes.oneOf(['top', 'bottom']),

  /**
   * Allow user additions to the list of options (boolean).
   * Requires the use of `selection`, `options` and `search`.
   */
  allowAdditions: customPropTypes.every([customPropTypes.demand(['options', 'selection', 'search']), PropTypes.bool]),

  /** A Dropdown can reduce its complexity. */
  basic: PropTypes.bool,

  /** Format the Dropdown to appear as a button. */
  button: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([customPropTypes.disallow(['options', 'selection']), customPropTypes.givenProps({
    children: PropTypes.any.isRequired
  }, PropTypes.element.isRequired)]),

  /** Additional classes. */
  className: PropTypes.string,

  /** Using the clearable setting will let users remove their selection from a dropdown. */
  clearable: PropTypes.bool,

  /** Whether or not the menu should close when the dropdown is blurred. */
  closeOnBlur: PropTypes.bool,

  /** Whether or not the dropdown should close when the escape key is pressed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Whether or not the menu should close when a value is selected from the dropdown.
   * By default, multiple selection dropdowns will remain open on change, while single
   * selection dropdowns will close on change.
   */
  closeOnChange: PropTypes.bool,

  /** A compact dropdown has no minimum width. */
  compact: PropTypes.bool,

  /** Whether or not the dropdown should strip diacritics in options and input search */
  deburr: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value of searchQuery. */
  defaultSearchQuery: PropTypes.string,

  /** Currently selected label in multi-select. */
  defaultSelectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Initial value of upward. */
  defaultUpward: PropTypes.bool,

  /** Initial value or value array if multiple. */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))]),

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** A disabled dropdown menu or item does not allow user interaction. */
  disabled: PropTypes.bool,

  /** An errored dropdown can alert a user to a problem. */
  error: PropTypes.bool,

  /** A dropdown menu can contain floated content. */
  floating: PropTypes.bool,

  /** A dropdown can take the full width of its parent */
  fluid: PropTypes.bool,

  /** A dropdown menu can contain a header. */
  header: PropTypes.node,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A dropdown can be formatted to appear inline in other content. */
  inline: PropTypes.bool,

  /** A dropdown can be formatted as a Menu item. */
  item: PropTypes.bool,

  /** A dropdown can be labeled. */
  labeled: PropTypes.bool,

  /** A dropdown can defer rendering its options until it is open. */
  lazyLoad: PropTypes.bool,

  /** A dropdown can show that it is currently loading data. */
  loading: PropTypes.bool,

  /** The minimum characters for a search to begin showing results. */
  minCharacters: PropTypes.number,

  /** A selection dropdown can allow multiple selections. */
  multiple: PropTypes.bool,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /**
   * Called when a user adds a new item. Use this to update the options list.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and the new item's value.
   */
  onAddItem: PropTypes.func,

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called when the user attempts to change the value.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: PropTypes.func,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called when a multi-select label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All label props.
   */
  onLabelClick: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of searchQuery.
   */
  onSearchChange: PropTypes.func,

  /** Controls whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** Whether or not the menu should open when the dropdown is focused. */
  openOnFocus: PropTypes.bool,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape(DropdownItem.propTypes))]),

  /** Placeholder text. */
  placeholder: PropTypes.string,

  /** A dropdown can be formatted so that its menu is pointing. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),

  /**
   * Mapped over the active items and returns shorthand for the active item Labels.
   * Only applies to `multiple` Dropdowns.
   *
   * @param {object} item - A currently active dropdown item.
   * @param {number} index - The current index.
   * @param {object} defaultLabelProps - The default props for an active item Label.
   * @returns {*} Shorthand for a Label.
   */
  renderLabel: PropTypes.func,

  /** A dropdown can have its menu scroll. */
  scrolling: PropTypes.bool,

  /**
   * A selection dropdown can allow a user to search through a large list of choices.
   * Pass a function here to replace the default search.
   */
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

  /** A shorthand for a search input. */
  searchInput: PropTypes.oneOfType([PropTypes.array, PropTypes.node, PropTypes.object]),

  /** Current value of searchQuery. Creates a controlled component. */
  searchQuery: PropTypes.string,
  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?

  /** Define whether the highlighted item should be selected on blur. */
  selectOnBlur: PropTypes.bool,

  /**
   * Whether or not to change the value when navigating the menu using arrow keys.
   * Setting to false will require enter or left click to confirm a choice.
   */
  selectOnNavigation: PropTypes.bool,

  /** Currently selected label in multi-select. */
  selectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.string, PropTypes.number])]),

  /** A dropdown can be used to select between choices in a form. */
  selection: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['options']), PropTypes.bool]),

  /** A simple dropdown can open without Javascript. */
  simple: PropTypes.bool,

  /** A dropdown can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The text displayed in the dropdown, usually for the active item. */
  text: PropTypes.string,

  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
  trigger: customPropTypes.every([customPropTypes.disallow(['selection', 'text']), PropTypes.node]),

  /** Current value or value array if multiple. Creates a controlled component. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]))]),

  /** Controls whether the dropdown will open upward. */
  upward: PropTypes.bool,

  /**
   * A dropdown will go to the last element when ArrowUp is pressed on the first,
   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
   */
  wrapSelection: PropTypes.bool
} : {};

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Icon__ = __webpack_require__(90);














/**
 * An embed displays content from other websites like YouTube videos or Google Maps.
 */

var Embed =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Embed, _Component);

  function Embed() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Embed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Embed)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      var active = _this.state.active;
      if (onClick) onClick(e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        active: true
      }));
      if (!active) _this.trySetState({
        active: true
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Embed, [{
    key: "getSrc",
    value: function getSrc() {
      var _this$props = this.props,
          _this$props$autoplay = _this$props.autoplay,
          autoplay = _this$props$autoplay === void 0 ? true : _this$props$autoplay,
          _this$props$brandedUI = _this$props.brandedUI,
          brandedUI = _this$props$brandedUI === void 0 ? false : _this$props$brandedUI,
          _this$props$color = _this$props.color,
          color = _this$props$color === void 0 ? '#444444' : _this$props$color,
          _this$props$hd = _this$props.hd,
          hd = _this$props$hd === void 0 ? true : _this$props$hd,
          id = _this$props.id,
          source = _this$props.source,
          url = _this$props.url;

      if (source === 'youtube') {
        return ["//www.youtube.com/embed/".concat(id), '?autohide=true', "&amp;autoplay=".concat(autoplay), "&amp;color=".concat(encodeURIComponent(color)), "&amp;hq=".concat(hd), '&amp;jsapi=false', "&amp;modestbranding=".concat(brandedUI), "&amp;rel=".concat(brandedUI ? 0 : 1)].join('');
      }

      if (source === 'vimeo') {
        return ["//player.vimeo.com/video/".concat(id), '?api=false', "&amp;autoplay=".concat(autoplay), '&amp;byline=false', "&amp;color=".concat(encodeURIComponent(color)), '&amp;portrait=false', '&amp;title=false'].join('');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          aspectRatio = _this$props2.aspectRatio,
          className = _this$props2.className,
          icon = _this$props2.icon,
          placeholder = _this$props2.placeholder;
      var active = this.state.active;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ui', aspectRatio, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* useKeyOnly */])(active, 'active'), 'embed', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["b" /* getUnhandledProps */])(Embed, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* getElementType */])(Embed, this.props);
      var iconShorthand = icon !== undefined ? icon : 'video play';
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_13__elements_Icon__["a" /* default */].create(iconShorthand, {
        autoGenerateKey: false
      }), placeholder && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img", {
        className: "placeholder",
        src: placeholder
      }), this.renderEmbed());
    }
  }, {
    key: "renderEmbed",
    value: function renderEmbed() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          content = _this$props3.content,
          iframe = _this$props3.iframe,
          source = _this$props3.source;
      var active = this.state.active;
      if (!active) return null;
      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, children);
      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, content);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib__["C" /* createHTMLIframe */])(__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(iframe) ? this.getSrc() : iframe, {
        defaultProps: {
          allowFullScreen: false,
          frameBorder: 0,
          height: '100%',
          scrolling: 'no',
          src: this.getSrc(),
          title: "Embedded content from ".concat(source, "."),
          width: '100%'
        },
        autoGenerateKey: false
      }));
    }
  }]);

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_12__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Embed, "autoControlledProps", ['active']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Embed, "handledProps", ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"]);


Embed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An embed can be active. */
  active: PropTypes.bool,

  /** An embed can specify an alternative aspect ratio. */
  aspectRatio: PropTypes.oneOf(['4:3', '16:9', '21:9']),

  /** Setting to true or false will force autoplay. */
  autoplay: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Whether to show networks branded UI like title cards, or after video calls to action. */
  brandedUI: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies a default chrome color with Vimeo or YouTube. */
  color: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initial value of active. */
  defaultActive: PropTypes.bool,

  /** Whether to prefer HD content. */
  hd: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Specifies an icon to use with placeholder content. */
  icon: customPropTypes.itemShorthand,

  /** Specifies an id for source. */
  id: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for HTML iframe. */
  iframe: customPropTypes.every([customPropTypes.demand(['source']), customPropTypes.itemShorthand]),

  /**
   * Сalled on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onClick: PropTypes.func,

  /** A placeholder image for embed. */
  placeholder: PropTypes.string,

  /** Specifies a source to use. */
  source: customPropTypes.every([customPropTypes.disallow(['sourceUrl']), PropTypes.oneOf(['youtube', 'vimeo'])]),

  /** Specifies a url to use for embed. */
  url: customPropTypes.every([customPropTypes.disallow(['source']), PropTypes.string])
} : {};

/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Embed__ = __webpack_require__(2557);
/* unused harmony reexport default */



/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reduce__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__elements_Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__addons_MountNode__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__addons_Portal__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalHeader__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ModalContent__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ModalActions__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ModalDescription__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__addons_Ref__ = __webpack_require__(127);



























/**
 * A modal displays content that temporarily blocks interactions with the main view of a site.
 * @see Confirm
 * @see Portal
 */
var Modal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "dimmerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "latestDocumentMouseDownEvent", null);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMountNode", function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["w" /* isBrowser */])() ? _this.props.mountNode || document.body : null;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleActionsOverrides", function (predefinedProps) {
      return {
        onActionClick: function onActionClick(e, actionProps) {
          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(predefinedProps, 'onActionClick', e, actionProps);

          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onActionClick', e, _this.props);

          _this.handleClose(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function (e) {
      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseDown", function (e) {
      _this.latestDocumentMouseDownEvent = e;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      var closeOnDimmerClick = _this.props.closeOnDimmerClick;
      var currentDocumentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;
      if (!closeOnDimmerClick || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["x" /* doesNodeContainClick */])(_this.ref.current, currentDocumentMouseDownEvent) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["x" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(predefinedProps, 'onClick', e);

          _this.handleClose(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOpen", function (e) {
      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);

      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function (e) {
      var eventPool = _this.props.eventPool;

      _this.setState({
        scrolling: false
      });

      _this.setPositionAndClassNames();

      __WEBPACK_IMPORTED_MODULE_17__lib__["v" /* eventStack */].sub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_17__lib__["v" /* eventStack */].sub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function (e) {
      var eventPool = _this.props.eventPool;
      cancelAnimationFrame(_this.animationRequestId);
      __WEBPACK_IMPORTED_MODULE_17__lib__["v" /* eventStack */].unsub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_17__lib__["v" /* eventStack */].unsub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "setDimmerNodeStyle", function () {
      var current = _this.dimmerRef.current;

      if (current && current.style && current.style.display !== 'flex') {
        current.style.setProperty('display', 'flex', 'important');
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPositionAndClassNames", function () {
      var dimmer = _this.props.dimmer;
      var classes;

      if (dimmer) {
        classes = 'dimmable dimmed';

        if (dimmer === 'blurring') {
          classes += ' blurring';
        }
      }

      var newState = {};

      if (_this.ref.current) {
        var _this$ref$current$get = _this.ref.current.getBoundingClientRect(),
            height = _this$ref$current$get.height; // Leaving the old calculation here since we may need it as an older browser fallback
        // SEE: https://github.com/Semantic-Org/Semantic-UI/issues/6185#issuecomment-376725956
        // const marginTop = -Math.round(height / 2)


        var marginTop = null;
        var scrolling = height > window.innerHeight;

        if (_this.state.marginTop !== marginTop) {
          newState.marginTop = marginTop;
        }

        if (_this.state.scrolling !== scrolling) {
          newState.scrolling = scrolling;
        }

        if (scrolling) classes += ' scrolling';
      }

      if (_this.state.mountClasses !== classes) newState.mountClasses = classes;
      if (!__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default()(newState)) _this.setState(newState);
      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);

      _this.setDimmerNodeStyle();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderContent", function (rest) {
      var _this$props = _this.props,
          actions = _this$props.actions,
          basic = _this$props.basic,
          children = _this$props.children,
          className = _this$props.className,
          closeIcon = _this$props.closeIcon,
          content = _this$props.content,
          header = _this$props.header,
          mountNode = _this$props.mountNode,
          size = _this$props.size,
          style = _this$props.style;
      var _this$state = _this.state,
          marginTop = _this$state.marginTop,
          mountClasses = _this$state.mountClasses,
          scrolling = _this$state.scrolling;
      var classes = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'modal transition visible active', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["c" /* getElementType */])(Modal, _this.props);
      var closeIconName = closeIcon === true ? 'close' : closeIcon;
      var closeIconJSX = __WEBPACK_IMPORTED_MODULE_18__elements_Icon__["a" /* default */].create(closeIconName, {
        overrideProps: _this.handleIconOverrides
      });
      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__addons_Ref__["a" /* default */], {
        innerRef: _this.ref
      }, __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
          marginTop: marginTop
        }, style)
      }), __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__addons_MountNode__["a" /* default */], {
        className: mountClasses,
        node: mountNode
      }), closeIconJSX, __WEBPACK_IMPORTED_MODULE_17__lib__["d" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_21__ModalHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_22__ModalContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_23__ModalActions__["a" /* default */].create(actions, {
        overrideProps: _this.handleActionsOverrides
      })) : children));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Modal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handlePortalUnmount();
    } // Do not access document when server side rendering

  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props2 = this.props,
          centered = _this$props2.centered,
          closeOnDocumentClick = _this$props2.closeOnDocumentClick,
          dimmer = _this$props2.dimmer,
          eventPool = _this$props2.eventPool,
          trigger = _this$props2.trigger;
      var mountNode = this.getMountNode(); // Short circuit when server side rendering

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["w" /* isBrowser */])()) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_react__["isValidElement"])(trigger) ? trigger : null;
      }

      var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["b" /* getUnhandledProps */])(Modal, this.props);
      var portalPropNames = __WEBPACK_IMPORTED_MODULE_20__addons_Portal__["a" /* default */].handledProps;

      var rest = __WEBPACK_IMPORTED_MODULE_11_lodash_reduce___default()(unhandled, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(portalPropNames, key)) acc[key] = val;
        return acc;
      }, {});

      var portalProps = __WEBPACK_IMPORTED_MODULE_9_lodash_pick___default()(unhandled, portalPropNames); // wrap dimmer modals


      var dimmerClasses = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('ui', dimmer === 'inverted' && 'inverted', !centered && 'top aligned', 'page modals dimmer transition visible active'); // Heads up!
      //
      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
      //
      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
      // We need the immediate child to be the dimmer to :not() blur the modal itself!
      // Otherwise, the portal div is also blurred, blurring the modal.
      //
      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.

      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__addons_Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        closeOnDocumentClick: closeOnDocumentClick
      }, portalProps, {
        trigger: trigger,
        eventPool: eventPool,
        mountNode: mountNode,
        open: open,
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount
      }), __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div", {
        className: dimmerClasses,
        ref: this.dimmerRef
      }, this.renderContent(rest)));
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_17__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "defaultProps", {
  centered: true,
  dimmer: true,
  closeOnDimmerClick: true,
  closeOnDocumentClick: false,
  eventPool: 'Modal'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "autoControlledProps", ['open']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Header", __WEBPACK_IMPORTED_MODULE_21__ModalHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Content", __WEBPACK_IMPORTED_MODULE_22__ModalContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Description", __WEBPACK_IMPORTED_MODULE_24__ModalDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Actions", __WEBPACK_IMPORTED_MODULE_23__ModalActions__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "handledProps", ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"]);

Modal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
  actions: customPropTypes.itemShorthand,

  /** A modal can reduce its complexity */
  basic: PropTypes.bool,

  /** A modal can be vertically centered in the viewport */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for the close icon. Closes the modal on click. */
  closeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.bool]),

  /** Whether or not the Modal should close when the dimmer is clicked. */
  closeOnDimmerClick: PropTypes.bool,

  /** Whether or not the Modal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Simple text content for the Modal. */
  content: customPropTypes.itemShorthand,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** A Modal can appear in a dimmer. */
  dimmer: PropTypes.oneOf([true, 'inverted', 'blurring']),

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** Modal displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: PropTypes.any,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onActionClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the Modal is displayed. */
  open: PropTypes.bool,

  /** A modal can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen']),

  /** Custom styles. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node
  /**
   * NOTE: Any unhandled props that are defined in Portal are passed-through
   * to the wrapping Portal.
   */

} : {};
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge__ = __webpack_require__(2756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_pick__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_includes__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_reduce__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_popper__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shallowequal__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__addons_Portal__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_positions__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_createReferenceProxy__ = __webpack_require__(2562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PopupContent__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PopupHeader__ = __webpack_require__(1346);































/**
 * A Popup displays additional information on top of a page.
 */
var Popup =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Popup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {});

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", false);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPortalProps", function () {
      var portalProps = {};
      var _this$props = _this.props,
          on = _this$props.on,
          hoverable = _this$props.hoverable;
      var normalizedOn = __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default()(on) ? on : [on];

      if (hoverable) {
        portalProps.closeOnPortalMouseLeave = true;
        portalProps.mouseLeaveDelay = 300;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'click')) {
        portalProps.openOnTriggerClick = true;
        portalProps.closeOnTriggerClick = true;
        portalProps.closeOnDocumentClick = true;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'focus')) {
        portalProps.openOnTriggerFocus = true;
        portalProps.closeOnTriggerBlur = true;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'hover')) {
        portalProps.openOnTriggerMouseEnter = true;
        portalProps.closeOnTriggerMouseLeave = true; // Taken from SUI: https://git.io/vPmCm

        portalProps.mouseLeaveDelay = 70;
        portalProps.mouseEnterDelay = 50;
      }

      return portalProps;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "hideOnScroll", function (e) {
      _this.setState({
        closed: true
      });

      __WEBPACK_IMPORTED_MODULE_23__lib__["v" /* eventStack */].unsub('scroll', _this.hideOnScroll, {
        target: window
      });
      _this.timeoutId = setTimeout(function () {
        _this.setState({
          closed: false
        });
      }, 50);

      _this.handleClose(e);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOpen", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function (e) {
      _this.positionUpdate = null;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderContent", function (_ref) {
      var popperPlacement = _ref.placement,
          popperRef = _ref.ref,
          scheduleUpdate = _ref.scheduleUpdate,
          popperStyle = _ref.style;
      var _this$props2 = _this.props,
          basic = _this$props2.basic,
          children = _this$props2.children,
          className = _this$props2.className,
          content = _this$props2.content,
          hideOnScroll = _this$props2.hideOnScroll,
          flowing = _this$props2.flowing,
          header = _this$props2.header,
          inverted = _this$props2.inverted,
          size = _this$props2.size,
          style = _this$props2.style,
          wide = _this$props2.wide;
      var contentRestProps = _this.state.contentRestProps;
      _this.positionUpdate = scheduleUpdate;
      var classes = __WEBPACK_IMPORTED_MODULE_18_classnames___default()('ui', __WEBPACK_IMPORTED_MODULE_26__lib_positions__["a" /* placementMapping */][popperPlacement], size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["h" /* useKeyOrValueAndKey */])(wide, 'wide'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["a" /* useKeyOnly */])(flowing, 'flowing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'popup transition visible', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["c" /* getElementType */])(Popup, _this.props);

      var styles = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        // Heads up! We need default styles to get working correctly `flowing`
        left: 'auto',
        right: 'auto'
      }, popperStyle, style);

      return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__addons_Ref__["a" /* default */], {
        innerRef: popperRef
      }, __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, contentRestProps, {
        className: classes,
        style: styles
      }), __WEBPACK_IMPORTED_MODULE_23__lib__["d" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_29__PopupHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_28__PopupContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      })) : children, hideOnScroll && __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack___default.a, {
        on: _this.hideOnScroll,
        name: "scroll",
        target: "window"
      })));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Popup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var depsEqual = __WEBPACK_IMPORTED_MODULE_22_shallowequal___default()(this.props.popperDependencies, prevProps.popperDependencies);

      if (!depsEqual) {
        this.handleUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      if (this.positionUpdate) this.positionUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          context = _this$props3.context,
          disabled = _this$props3.disabled,
          offset = _this$props3.offset,
          pinned = _this$props3.pinned,
          popperModifiers = _this$props3.popperModifiers,
          position = _this$props3.position,
          trigger = _this$props3.trigger;
      var _this$state = this.state,
          closed = _this$state.closed,
          portalRestProps = _this$state.portalRestProps;
      if (closed || disabled) return trigger;

      var modifiers = __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default()({
        arrow: {
          enabled: false
        },
        flip: {
          enabled: !pinned
        },
        // There are issues with `keepTogether` and `offset`
        // https://github.com/FezVrasta/popper.js/issues/557
        keepTogether: {
          enabled: !!offset
        },
        offset: {
          offset: offset
        }
      }, popperModifiers);

      var referenceElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_createReferenceProxy__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(context) ? this.triggerRef : context);

      var mergedPortalProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.getPortalProps(), portalRestProps);

      return __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__addons_Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, mergedPortalProps, {
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount,
        trigger: trigger,
        triggerRef: this.triggerRef
      }), __WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_popper__["a" /* Popper */], {
        modifiers: modifiers,
        placement: __WEBPACK_IMPORTED_MODULE_26__lib_positions__["b" /* positionsMapping */][position],
        referenceElement: referenceElement
      }, this.renderContent));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.closed || state.disabled) return {};
      var unhandledProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib__["b" /* getUnhandledProps */])(Popup, props);

      var contentRestProps = __WEBPACK_IMPORTED_MODULE_15_lodash_reduce___default()(unhandledProps, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_24__addons_Portal__["a" /* default */].handledProps, key)) acc[key] = val;
        return acc;
      }, {});

      var portalRestProps = __WEBPACK_IMPORTED_MODULE_13_lodash_pick___default()(unhandledProps, __WEBPACK_IMPORTED_MODULE_24__addons_Portal__["a" /* default */].handledProps);

      return {
        contentRestProps: contentRestProps,
        portalRestProps: portalRestProps
      };
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "defaultProps", {
  disabled: false,
  offset: 0,
  on: 'hover',
  pinned: false,
  position: 'top left'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "Content", __WEBPACK_IMPORTED_MODULE_28__PopupContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "Header", __WEBPACK_IMPORTED_MODULE_29__PopupHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "handledProps", ["as", "basic", "children", "className", "content", "context", "disabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popperDependencies", "popperModifiers", "position", "size", "style", "trigger", "wide"]);


Popup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Display the popup without the pointing arrow. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Simple text content for the popover. */
  content: customPropTypes.itemShorthand,

  /** Existing element the pop-up should be bound to. */
  context: PropTypes.oneOfType([PropTypes.object, customPropTypes.refObject]),

  /** A disabled popup only renders its trigger. */
  disabled: PropTypes.bool,

  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
  flowing: PropTypes.bool,

  /** Takes up the entire width of its offset container. */
  // TODO: implement the Popup fluid layout
  // fluid: PropTypes.bool,

  /** Header displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** Hide the Popup when scrolling the window. */
  hideOnScroll: PropTypes.bool,

  /** Whether the popup should not close on hover. */
  hoverable: PropTypes.bool,

  /** Invert the colors of the Popup. */
  inverted: PropTypes.bool,

  /** Offset value to apply to rendered popup. Accepts the following units:
   * - px or unit-less, interpreted as pixels
   * - %, percentage relative to the length of the trigger element
   * - %p, percentage relative to the length of the popup element
   * - vw, CSS viewport width unit
   * - vh, CSS viewport height unit
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Events triggering the popup. */
  on: PropTypes.oneOfType([PropTypes.oneOf(['hover', 'click', 'focus']), PropTypes.arrayOf(PropTypes.oneOf(['hover', 'click', 'focus']))]),

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Disables automatic repositioning of the component, it will always be placed according to the position value. */
  pinned: PropTypes.bool,

  /** Position for the popover. */
  position: PropTypes.oneOf(positions),

  /** An object containing custom settings for the Popper.js modifiers. */
  popperModifiers: PropTypes.object,

  /** A popup can have dependencies which update will schedule a position update. */
  popperDependencies: PropTypes.array,

  /** Popup size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big', 'massive')),

  /** Custom Popup style. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the popup is defined. */
  trigger: PropTypes.node,

  /** Popup width. */
  wide: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])])
} : {};

/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(2560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popup__["a"]; });



/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_memoize__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_refUtils__ = __webpack_require__(488);






var ReferenceProxy =
/*#__PURE__*/
function () {
  function ReferenceProxy(refObject) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ReferenceProxy);

    this.ref = refObject;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ReferenceProxy, [{
    key: "getBoundingClientRect",
    value: function getBoundingClientRect() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_invoke___default()(this.ref.current, 'getBoundingClientRect', {});
    }
  }, {
    key: "clientWidth",
    get: function get() {
      return this.getBoundingClientRect().width;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      return this.getBoundingClientRect().height;
    }
  }, {
    key: "parentNode",
    get: function get() {
      return this.ref.current ? this.ref.current.parentNode : undefined;
    }
  }]);

  return ReferenceProxy;
}();
/**
 * Popper.js does not support ref objects from `createRef()` as referenceElement. If we will pass
 * directly `ref`, `ref.current` will be `null` at the render process. We use memoize to keep the
 * same reference between renders.
 *
 * @see https://popper.js.org/popper-documentation.html#referenceObject
 */

var createReferenceProxy = __WEBPACK_IMPORTED_MODULE_2_lodash_memoize___default()(function (reference) {
  return new ReferenceProxy( // TODO: use toRefObject from Stardust
  // https://github.com/stardust-ui/react/issues/998
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_refUtils__["a" /* isRefObject */])(reference) ? reference : {
    current: reference
  });
});

/* harmony default export */ __webpack_exports__["a"] = (createReferenceProxy);

/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return positionsMapping; });
/* unused harmony export positions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placementMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert__ = __webpack_require__(2744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_invert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keys__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keys__);


var positionsMapping = {
  'top center': 'top',
  'top left': 'top-start',
  'top right': 'top-end',
  'bottom center': 'bottom',
  'bottom left': 'bottom-start',
  'bottom right': 'bottom-end',
  'right center': 'right',
  'left center': 'left'
};
var positions = __WEBPACK_IMPORTED_MODULE_1_lodash_keys___default()(positionsMapping);
var placementMapping = __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default()(positionsMapping);

/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_round__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_clamp__ = __webpack_require__(2709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
















/**
 * A progress bar shows the progression of a task.
 */

var Progress =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Progress, _Component);

  function Progress() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Progress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Progress)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "calculatePercent", function () {
      var _this$props = _this.props,
          percent = _this$props.percent,
          total = _this$props.total,
          value = _this$props.value;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(percent)) return percent;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(value)) return value / total * 100;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeValueText", function (percent) {
      var _this$props2 = _this.props,
          progress = _this$props2.progress,
          total = _this$props2.total,
          value = _this$props2.value;
      if (progress === 'value') return value;
      if (progress === 'ratio') return "".concat(value, "/").concat(total);
      return "".concat(percent, "%");
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPercent", function () {
      var _this$props3 = _this.props,
          precision = _this$props3.precision,
          progress = _this$props3.progress,
          total = _this$props3.total,
          value = _this$props3.value;

      var percent = __WEBPACK_IMPORTED_MODULE_9_lodash_clamp___default()(_this.calculatePercent(), 0, 100);

      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(value) && progress === 'value') {
        return value / total * 100;
      }

      if (progress === 'value') return value;
      if (__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(precision)) return percent;
      return __WEBPACK_IMPORTED_MODULE_8_lodash_round___default()(percent, precision);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "isAutoSuccess", function () {
      var _this$props4 = _this.props,
          autoSuccess = _this$props4.autoSuccess,
          percent = _this$props4.percent,
          total = _this$props4.total,
          value = _this$props4.value;
      return autoSuccess && (percent >= 100 || value >= total);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderLabel", function () {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          content = _this$props5.content,
          label = _this$props5.label;
      if (!__WEBPACK_IMPORTED_MODULE_15__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "label"
      }, children);
      if (!__WEBPACK_IMPORTED_MODULE_15__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "label"
      }, content);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["B" /* createHTMLDivision */])(label, {
        autoGenerateKey: false,
        defaultProps: {
          className: 'label'
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderProgress", function (percent) {
      var _this$props6 = _this.props,
          precision = _this$props6.precision,
          progress = _this$props6.progress;
      if (!progress && __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(precision)) return;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "progress"
      }, _this.computeValueText(percent));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Progress, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          active = _this$props7.active,
          attached = _this$props7.attached,
          className = _this$props7.className,
          color = _this$props7.color,
          disabled = _this$props7.disabled,
          error = _this$props7.error,
          indicating = _this$props7.indicating,
          inverted = _this$props7.inverted,
          size = _this$props7.size,
          success = _this$props7.success,
          warning = _this$props7.warning;
      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(active || indicating, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(indicating, 'indicating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(success || this.isAutoSuccess(), 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["g" /* useValueAndKey */])(attached, 'attached'), 'progress', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* getUnhandledProps */])(Progress, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* getElementType */])(Progress, this.props);
      var percent = this.getPercent() || 0;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        "data-percent": Math.floor(percent)
      }), __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "bar",
        style: {
          width: "".concat(percent, "%")
        }
      }, this.renderProgress(percent)), this.renderLabel());
    }
  }]);

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Progress, "handledProps", ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"]);

Progress.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A progress bar can show activity. */
  active: PropTypes.bool,

  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
  attached: PropTypes.oneOf(['top', 'bottom']),

  /** Whether success state should automatically trigger when progress completes. */
  autoSuccess: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A progress bar can have different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A progress bar be disabled. */
  disabled: PropTypes.bool,

  /** A progress bar can show a error state. */
  error: PropTypes.bool,

  /** An indicating progress bar visually indicates the current level of progress of a task. */
  indicating: PropTypes.bool,

  /** A progress bar can have its colors inverted. */
  inverted: PropTypes.bool,

  /** Can be set to either to display progress as percent or ratio. */
  label: customPropTypes.itemShorthand,

  /** Current percent complete. */
  percent: customPropTypes.every([customPropTypes.disallow(['total', 'value']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Decimal point precision for calculated progress. */
  precision: PropTypes.number,

  /** A progress bar can contain a text value indicating current progress. */
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['percent', 'ratio', 'value'])]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'huge', 'massive')),

  /** A progress bar can show a success state. */
  success: PropTypes.bool,

  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
  total: customPropTypes.every([customPropTypes.demand(['value']), customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
  value: customPropTypes.every([customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** A progress bar can show a warning state. */
  warning: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Progress);

/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress__ = __webpack_require__(2564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Progress__["a"]; });



/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_times__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_times__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RatingIcon__ = __webpack_require__(1347);

















/**
 * A rating indicates user interest in content.
 */

var Rating =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Rating, _Component);

  function Rating() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Rating);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Rating)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconClick", function (e, _ref) {
      var index = _ref.index;
      var _this$props = _this.props,
          clearable = _this$props.clearable,
          disabled = _this$props.disabled,
          maxRating = _this$props.maxRating,
          onRate = _this$props.onRate;
      var rating = _this.state.rating;
      if (disabled) return; // default newRating is the clicked icon
      // allow toggling a binary rating
      // allow clearing ratings

      var newRating = index + 1;

      if (clearable === 'auto' && maxRating === 1) {
        newRating = +!rating;
      } else if (clearable === true && newRating === rating) {
        newRating = 0;
      } // set rating


      _this.trySetState({
        rating: newRating
      }, {
        isSelecting: false
      });

      if (onRate) onRate(e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        rating: newRating
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconMouseEnter", function (e, _ref2) {
      var index = _ref2.index;
      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: index,
        isSelecting: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseLeave", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default.a.apply(void 0, [_this.props, 'onMouseLeave'].concat(args));

      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: -1,
        isSelecting: false
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Rating, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          icon = _this$props2.icon,
          maxRating = _this$props2.maxRating,
          size = _this$props2.size;
      var _this$state = this.state,
          rating = _this$state.rating,
          selectedIndex = _this$state.selectedIndex,
          isSelecting = _this$state.isSelecting;
      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', icon, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* getUnhandledProps */])(Rating, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* getElementType */])(Rating, this.props);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        role: "radiogroup",
        onMouseLeave: this.handleMouseLeave,
        tabIndex: disabled ? 0 : -1
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_times___default()(maxRating, function (i) {
        return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RatingIcon__["a" /* default */], {
          tabIndex: disabled ? -1 : 0,
          active: rating >= i + 1,
          "aria-checked": rating === i + 1,
          "aria-posinset": i + 1,
          "aria-setsize": maxRating,
          index: i,
          key: i,
          onClick: _this2.handleIconClick,
          onMouseEnter: _this2.handleIconMouseEnter,
          selected: selectedIndex >= i && isSelecting
        });
      }));
    }
  }]);

  return Rating;
}(__WEBPACK_IMPORTED_MODULE_15__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "autoControlledProps", ['rating']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "defaultProps", {
  clearable: 'auto',
  maxRating: 1
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "Icon", __WEBPACK_IMPORTED_MODULE_16__RatingIcon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "handledProps", ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"]);


Rating.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * You can clear the rating by clicking on the current start rating.
   * By default a rating will be only clearable if there is 1 icon.
   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
   */
  clearable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['auto'])]),

  /** The initial rating value. */
  defaultRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** You can disable or enable interactive rating.  Makes a read-only rating. */
  disabled: PropTypes.bool,

  /** A rating can use a set of star or heart icons. */
  icon: PropTypes.oneOf(['star', 'heart']),

  /** The total number of icons. */
  maxRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called after user selects a new rating.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed rating.
   */
  onRate: PropTypes.func,

  /** The current number of active icons. */
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big'))
} : {};

/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(2566);
/* unused harmony reexport default */



/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight__ = __webpack_require__(2758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_partialRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_inRange__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reduce__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_keyboard_key__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shallowequal__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__elements_Input__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SearchCategory__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SearchResult__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SearchResults__ = __webpack_require__(1350);































/**
 * A search module allows a user to query for results from a selection of data
 */
var Search =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits___default()(Search, _Component);

  function Search() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default()(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default()(Search)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleResultSelect", function (e, result) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onResultSelect', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        result: result
      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSelectionChange", function (e) {
      var result = _this.getSelectedResult();

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onSelectionChange', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        result: result
      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnEscape", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionOnKeyDown", function (e) {
      switch (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.ArrowDown:
          e.preventDefault();

          _this.moveSelectionBy(e, 1);

          break;

        case __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.ArrowUp:
          e.preventDefault();

          _this.moveSelectionBy(e, -1);

          break;

        default:
          break;
      }
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "selectItemOnEnter", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.Enter) return;

      var result = _this.getSelectedResult(); // prevent selecting null if there was no selected item value


      if (!result) return;
      e.preventDefault(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnDocumentClick", function (e) {
      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      _this.isMouseDown = true;

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);

      __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].sub('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseUp", function () {
      _this.isMouseDown = false;
      __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleInputClick", function (e) {
      // prevent closeOnDocumentClick()
      e.nativeEvent.stopImmediatePropagation();

      _this.tryOpen();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var id = _ref.id;

      var result = _this.getSelectedResult(id); // prevent closeOnDocumentClick()


      e.nativeEvent.stopImmediatePropagation(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemMouseDown", function (e) {
      // Heads up! We should prevent default to prevent blur events.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3298
      e.preventDefault();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleFocus", function (e) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleBlur", function (e) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onBlur', e, _this.props);

      _this.setState({
        focus: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchChange", function (e) {
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = e.target.value;

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: newQuery
      })); // open search dropdown on search query


      if (newQuery.length < minCharacters) {
        _this.close();
      } else if (!open) {
        _this.tryOpen(newQuery);
      }

      _this.setValue(newQuery);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "getFlattenedResults", function () {
      var _this$props = _this.props,
          category = _this$props.category,
          results = _this$props.results;
      return !category ? results : __WEBPACK_IMPORTED_MODULE_17_lodash_reduce___default()(results, function (memo, categoryData) {
        return memo.concat(categoryData.results);
      }, []);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "getSelectedResult", function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;

      var results = _this.getFlattenedResults();

      return __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(results, index);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "setValue", function (value) {
      var selectFirstResult = _this.props.selectFirstResult;

      _this.trySetState({
        value: value
      }, {
        selectedIndex: selectFirstResult ? 0 : -1
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionBy", function (e, offset) {
      var selectedIndex = _this.state.selectedIndex;

      var results = _this.getFlattenedResults();

      var lastIndex = results.length - 1; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = selectedIndex + offset;
      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      _this.setState({
        selectedIndex: nextIndex
      });

      _this.scrollSelectedItemIntoView();

      _this.handleSelectionChange(e);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "scrollSelectedItemIntoView", function () {
      // Do not access document when server side rendering
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["w" /* isBrowser */])()) return;
      var menu = document.querySelector('.ui.search.active.visible .results.visible');
      var item = menu.querySelector('.result.active');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "tryOpen", function () {
      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var minCharacters = _this.props.minCharacters;
      if (currentValue.length < minCharacters) return;

      _this.open();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function () {
      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function () {
      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchInput", function (rest) {
      var _this$props2 = _this.props,
          icon = _this$props2.icon,
          input = _this$props2.input;
      var value = _this.state.value;
      return __WEBPACK_IMPORTED_MODULE_26__elements_Input__["a" /* default */].create(input, {
        autoGenerateKey: false,
        defaultProps: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, rest, {
          icon: icon,
          input: {
            className: 'prompt',
            tabIndex: '0',
            autoComplete: 'off'
          },
          onChange: _this.handleSearchChange,
          onClick: _this.handleInputClick,
          value: value
        })
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderNoResults", function () {
      var _this$props3 = _this.props,
          noResultsDescription = _this$props3.noResultsDescription,
          noResultsMessage = _this$props3.noResultsMessage;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "message empty"
      }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "header"
      }, noResultsMessage), noResultsDescription && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "description"
      }, noResultsDescription));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResult", function (_ref2, index, _array) {
      var childKey = _ref2.childKey,
          result = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ["childKey"]);

      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var resultRenderer = _this.props.resultRenderer;
      var selectedIndex = _this.state.selectedIndex;
      var offsetIndex = index + offset;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__SearchResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        key: childKey || result.title,
        active: selectedIndex === offsetIndex,
        onClick: _this.handleItemClick,
        onMouseDown: _this.handleItemMouseDown,
        renderer: resultRenderer
      }, result, {
        id: offsetIndex // Used to lookup the result on item click

      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResults", function () {
      var results = _this.props.results;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(results, _this.renderResult);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderCategories", function () {
      var _this$props4 = _this.props,
          categoryRenderer = _this$props4.categoryRenderer,
          categories = _this$props4.results;
      var selectedIndex = _this.state.selectedIndex;
      var count = 0;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(categories, function (_ref3) {
        var childKey = _ref3.childKey,
            category = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ["childKey"]);

        var categoryProps = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({
          key: childKey || category.name,
          active: __WEBPACK_IMPORTED_MODULE_14_lodash_inRange___default()(selectedIndex, count, count + category.results.length),
          renderer: categoryRenderer
        }, category);

        var renderFn = __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight___default()(_this.renderResult, count);

        count += category.results.length;
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__SearchCategory__["a" /* default */], categoryProps, category.results.map(renderFn));
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderMenuContent", function () {
      var _this$props5 = _this.props,
          category = _this$props5.category,
          showNoResults = _this$props5.showNoResults,
          results = _this$props5.results;

      if (__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default()(results)) {
        return showNoResults ? _this.renderNoResults() : null;
      }

      return category ? _this.renderCategories() : _this.renderResults();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResultsMenu", function () {
      var open = _this.state.open;
      var resultsClasses = open ? 'visible' : '';

      var menuContent = _this.renderMenuContent();

      if (!menuContent) return;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__SearchResults__["a" /* default */], {
        className: resultsClasses
      }, menuContent);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(Search, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      this.setValue(value);
      if (open) this.open();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default()(Search.prototype), "componentWillReceiveProps", this).call(this, nextProps);

      if (!__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextState, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // eslint-disable-line complexity
      // focused / blurred
      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          this.tryOpen();
        }

        if (this.state.open) {
          __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
        }
      } else if (prevState.focus && !this.state.focus) {
        if (!this.isMouseDown) {
          this.close();
        }

        __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      } // opened / closed


      if (!prevState.open && this.state.open) {
        this.open();
        __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].sub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      } else if (prevState.open && !this.state.open) {
        this.close();
        __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('click', this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_25__lib__["v" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          searchClasses = _this$state2.searchClasses,
          focus = _this$state2.focus,
          open = _this$state2.open;
      var _this$props6 = this.props,
          aligned = _this$props6.aligned,
          category = _this$props6.category,
          className = _this$props6.className,
          fluid = _this$props6.fluid,
          loading = _this$props6.loading,
          size = _this$props6.size; // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_20_classnames___default()('ui', open && 'active visible', size, searchClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["a" /* useKeyOnly */])(category, 'category'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["a" /* useKeyOnly */])(focus, 'focus'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["g" /* useValueAndKey */])(aligned, 'aligned'), 'search', className);
      var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["b" /* getUnhandledProps */])(Search, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["c" /* getElementType */])(Search, this.props);

      var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__lib__["l" /* partitionHTMLProps */])(unhandled, {
        htmlProps: __WEBPACK_IMPORTED_MODULE_25__lib__["y" /* htmlInputAttrs */]
      }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onMouseDown: this.handleMouseDown
      }), this.renderSearchInput(htmlInputProps), this.renderResultsMenu());
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_25__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "defaultProps", {
  icon: 'search',
  input: 'text',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  showNoResults: true
});

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "autoControlledProps", ['open', 'value']);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Category", __WEBPACK_IMPORTED_MODULE_27__SearchCategory__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Result", __WEBPACK_IMPORTED_MODULE_28__SearchResult__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Results", __WEBPACK_IMPORTED_MODULE_29__SearchResults__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "handledProps", ["aligned", "as", "category", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"]);


Search.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,
  // ------------------------------------
  // Behavior
  // ------------------------------------

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value. */
  defaultValue: PropTypes.string,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** Minimum characters to query for results */
  minCharacters: PropTypes.number,

  /** Additional text for "No Results" message with less emphasis. */
  noResultsDescription: PropTypes.node,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /** Controls whether or not the results menu is displayed. */
  open: PropTypes.bool,

  /**
   * One of:
   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
   */
  results: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(SearchResult.propTypes)), PropTypes.shape(SearchCategory.propTypes)]),

  /** Whether the search should automatically select the first result after searching. */
  selectFirstResult: PropTypes.bool,

  /** Whether a "no results" message should be shown if no results are found. */
  showNoResults: PropTypes.bool,

  /** Current value of the search input. Creates a controlled component. */
  value: PropTypes.string,
  // ------------------------------------
  // Rendering
  // ------------------------------------

  /**
   * Renders the SearchCategory contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable SearchCategory contents.
   */
  categoryRenderer: PropTypes.func,

  /**
   * Renders the SearchResult contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable SearchResult contents.
   */
  resultRenderer: PropTypes.func,
  // ------------------------------------
  // Callbacks
  // ------------------------------------

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when a result is selected.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onResultSelect: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of search input.
   */
  onSearchChange: PropTypes.func,

  /**
   * Called when the active selection index is changed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onSelectionChange: PropTypes.func,
  // ------------------------------------
  // Style
  // ------------------------------------

  /** A search can have its results aligned to its left or right container edge. */
  aligned: PropTypes.string,

  /** A search can display results from remote content ordered by categories. */
  category: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A search can have its results take up the width of its container. */
  fluid: PropTypes.bool,

  /** A search input can take up the width of its container. */
  input: customPropTypes.itemShorthand,

  /** A search can show a loading indicator. */
  loading: PropTypes.bool,

  /** A search can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__semantic_ui_react_event_stack__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__addons_Ref__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SidebarPushable__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SidebarPusher__ = __webpack_require__(1352);


















/**
 * A sidebar hides additional content beside a page.
 */

var Sidebar =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Sidebar, _Component);

  function Sidebar() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Sidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Sidebar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {});

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleAnimationStart", function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onVisible' : 'onHide';

      _this.setState({
        animating: true
      }, function () {
        clearTimeout(_this.animationTimer);
        _this.animationTimer = setTimeout(_this.handleAnimationEnd, Sidebar.animationDuration);

        if (_this.skipNextCallback) {
          _this.skipNextCallback = false;
          return;
        }

        __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, callback, null, _this.props);
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleAnimationEnd", function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onShow' : 'onHidden';

      _this.setState({
        animating: false
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, callback, null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["x" /* doesNodeContainClick */])(_this.ref.current, e)) {
        _this.skipNextCallback = true;

        __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onHide', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          visible: false
        }));
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Sidebar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevVisible = prevProps.visible;
      var currentVisible = this.props.visible;
      if (prevVisible !== currentVisible) this.handleAnimationStart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.animationTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animation = _this$props.animation,
          className = _this$props.className,
          children = _this$props.children,
          content = _this$props.content,
          direction = _this$props.direction,
          target = _this$props.target,
          visible = _this$props.visible,
          width = _this$props.width;
      var animating = this.state.animating;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', animation, direction, width, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(animating, 'animating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* useKeyOnly */])(visible, 'visible'), 'sidebar', className);
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* getUnhandledProps */])(Sidebar, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* getElementType */])(Sidebar, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__addons_Ref__["a" /* default */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_15__lib__["d" /* childrenUtils */].isNil(children) ? content : children, visible && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__semantic_ui_react_event_stack___default.a, {
        name: "click",
        on: this.handleDocumentClick,
        target: target
      })));
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "defaultProps", {
  direction: 'left'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "animationDuration", 500);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "autoControlledProps", ['visible']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "Pushable", __WEBPACK_IMPORTED_MODULE_16__SidebarPushable__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "Pusher", __WEBPACK_IMPORTED_MODULE_17__SidebarPusher__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "handledProps", ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"]);

Sidebar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Animation style. */
  animation: PropTypes.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Direction the sidebar should appear on. */
  direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Called before a sidebar begins to animate out.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onHide: PropTypes.func,

  /**
   * Called after a sidebar has finished animating out.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onHidden: PropTypes.func,

  /**
   * Called when a sidebar has finished animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onShow: PropTypes.func,

  /**
   * Called when a sidebar begins animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onVisible: PropTypes.func,

  /** A sidebar can handle clicks on the passed element. */
  target: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Controls whether or not the sidebar is visible on the page. */
  visible: PropTypes.bool,

  /** Sidebar width. */
  width: PropTypes.oneOf(['very thin', 'thin', 'wide', 'very wide'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(2570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });



/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(7);














/**
 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
 */

var Sticky =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Sticky, _Component);

  function Sticky() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Sticky);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Sticky)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      sticky: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickyRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "addListeners", function (props) {
      var scrollContext = props.scrollContext;
      var scrollContextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["u" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_13__lib__["v" /* eventStack */].sub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_13__lib__["v" /* eventStack */].sub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "removeListeners", function () {
      var scrollContext = _this.props.scrollContext;
      var scrollContextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["u" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_13__lib__["v" /* eventStack */].unsub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_13__lib__["v" /* eventStack */].unsub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "update", function (e) {
      var pushing = _this.state.pushing;
      _this.ticking = false;

      _this.assignRects();

      if (pushing) {
        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
        return _this.stickToContextBottom(e);
      }

      if (_this.isOversized()) {
        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
      }

      if (_this.didTouchScreenTop()) {
        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
        return _this.stickToScreenTop(e);
      }

      return _this.stickToContextTop(e);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function (e) {
      if (!_this.ticking) {
        _this.ticking = true;
        _this.frameId = requestAnimationFrame(function () {
          return _this.update(e);
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "assignRects", function () {
      var context = _this.props.context;
      var contextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["u" /* isRefObject */])(context) ? context.current : context || document.body;
      _this.triggerRect = _this.triggerRef.current.getBoundingClientRect();
      _this.contextRect = contextNode.getBoundingClientRect();
      _this.stickyRect = _this.stickyRef.current.getBoundingClientRect();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didReachContextBottom", function () {
      var offset = _this.props.offset;
      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didReachStartingPoint", function () {
      return _this.stickyRect.top <= _this.triggerRect.top;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didTouchScreenTop", function () {
      return _this.triggerRect.top < _this.props.offset;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didTouchScreenBottom", function () {
      var bottomOffset = _this.props.bottomOffset;
      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "isOversized", function () {
      return _this.stickyRect.height > window.innerHeight;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "pushing", function (pushing) {
      var possible = _this.props.pushing;
      if (possible) _this.setState({
        pushing: pushing
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stick", function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: true
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onStick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "unstick", function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: false
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onUnstick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToContextBottom", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onBottom', e, _this.props);

      _this.stick(e, true);

      _this.pushing(true);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToContextTop", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onTop', e, _this.props);

      _this.unstick(e, false);

      _this.pushing(false);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToScreenBottom", function (e) {
      var bottom = _this.props.bottomOffset;

      _this.stick(e, false);

      _this.setState({
        bottom: bottom,
        top: null
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToScreenTop", function (e) {
      var top = _this.props.offset;

      _this.stick(e, false);

      _this.setState({
        top: top,
        bottom: null
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["w" /* isBrowser */])()) return;
      var active = this.props.active;

      if (active) {
        this.handleUpdate();
        this.addListeners(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          current = _this$props.active,
          currentScrollContext = _this$props.scrollContext;
      var next = nextProps.active,
          nextScrollContext = nextProps.scrollContext;

      if (current === next) {
        if (currentScrollContext !== nextScrollContext) {
          this.removeListeners();
          this.addListeners(nextProps);
        }

        return;
      }

      if (next) {
        this.handleUpdate();
        this.addListeners(nextProps);
        return;
      }

      this.removeListeners();
      this.setState({
        sticky: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["w" /* isBrowser */])()) return;
      var active = this.props.active;

      if (active) {
        this.removeListeners();
        cancelAnimationFrame(this.frameId);
      }
    } // ----------------------------------------
    // Events
    // ----------------------------------------

  }, {
    key: "computeStyle",
    value: function computeStyle() {
      var styleElement = this.props.styleElement;
      var _this$state = this.state,
          bottom = _this$state.bottom,
          bound = _this$state.bound,
          sticky = _this$state.sticky,
          top = _this$state.top;
      if (!sticky) return styleElement;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        bottom: bound ? 0 : bottom,
        top: bound ? undefined : top,
        width: this.triggerRect.width
      }, styleElement);
    } // Return true when the component reached the bottom of the context

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className;
      var _this$state2 = this.state,
          bottom = _this$state2.bottom,
          bound = _this$state2.bound,
          sticky = _this$state2.sticky;
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(Sticky, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(Sticky, this.props);
      var containerClasses = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(sticky && 'ui', sticky && 'stuck-container', sticky && (bound ? 'bound-container' : 'fixed-container'), className);
      var elementClasses = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', sticky && (bound ? 'bound bottom' : 'fixed'), sticky && !bound && (bottom === null ? 'top' : 'bottom'), 'sticky');
      var triggerStyles = sticky && this.stickyRect ? {
        height: this.stickyRect.height
      } : {};
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: containerClasses
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", {
        ref: this.triggerRef,
        style: triggerStyles
      }), __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", {
        className: elementClasses,
        ref: this.stickyRef,
        style: this.computeStyle()
      }, children));
    }
  }]);

  return Sticky;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sticky, "defaultProps", {
  active: true,
  bottomOffset: 0,
  offset: 0,
  scrollContext: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["w" /* isBrowser */])() ? window : null
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sticky, "handledProps", ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"]);


Sticky.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A Sticky can be active. */
  active: PropTypes.bool,

  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
  bottomOffset: PropTypes.number,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Context which sticky element should stick to. */
  context: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Offset in pixels from the top of the screen when fixing element to viewport. */
  offset: PropTypes.number,

  /**
   * Callback when element is bound to bottom of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBottom: PropTypes.func,

  /**
   * Callback when element is fixed to page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onStick: PropTypes.func,

  /**
   * Callback when element is bound to top of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onTop: PropTypes.func,

  /**
   * Callback when element is unfixed from page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onUnstick: PropTypes.func,

  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
  pushing: PropTypes.bool,

  /** Context which sticky should attach onscroll events. */
  scrollContext: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Custom style for sticky element. */
  styleElement: PropTypes.object
} : {};

/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sticky__ = __webpack_require__(2572);
/* unused harmony reexport default */



/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Grid_Grid__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Menu_Menu__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TabPane__ = __webpack_require__(1353);



















/**
 * A Tab is a hidden section of content activated by a Menu.
 * @see Menu
 * @see Segment
 */

var Tab =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Tab, _Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var index = _ref.index;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onTabChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        activeIndex: index
      }));

      _this.trySetState({
        activeIndex: index
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Tab, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState() {
      return {
        activeIndex: 0
      };
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this$props = this.props,
          panes = _this$props.panes,
          renderActiveOnly = _this$props.renderActiveOnly;
      var activeIndex = this.state.activeIndex;
      if (renderActiveOnly) return __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(panes, "[".concat(activeIndex, "]")), 'render', this.props);
      return __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panes, function (_ref2, index) {
        var pane = _ref2.pane;
        return __WEBPACK_IMPORTED_MODULE_18__TabPane__["a" /* default */].create(pane, {
          overrideProps: {
            active: index === activeIndex
          }
        });
      });
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this$props2 = this.props,
          menu = _this$props2.menu,
          panes = _this$props2.panes,
          menuPosition = _this$props2.menuPosition;
      var activeIndex = this.state.activeIndex;

      if (menu.tabular === true && menuPosition === 'right') {
        menu.tabular = 'right';
      }

      return __WEBPACK_IMPORTED_MODULE_17__collections_Menu_Menu__["a" /* default */].create(menu, {
        autoGenerateKey: false,
        overrideProps: {
          items: __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panes, 'menuItem'),
          onItemClick: this.handleItemClick,
          activeIndex: activeIndex
        }
      });
    }
  }, {
    key: "renderVertical",
    value: function renderVertical(menu) {
      var _this$props3 = this.props,
          grid = _this$props3.grid,
          menuPosition = _this$props3.menuPosition;

      var paneWidth = grid.paneWidth,
          tabWidth = grid.tabWidth,
          gridProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(grid, ["paneWidth", "tabWidth"]);

      var position = menuPosition || menu.props.tabular === 'right' && 'right' || 'left';
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__collections_Grid_Grid__["a" /* default */], gridProps, position === 'left' && __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: tabWidth,
        children: menu
      }, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: paneWidth,
        children: this.renderItems(),
        stretched: true
      }, {
        autoGenerateKey: false
      }), position === 'right' && __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: tabWidth,
        children: menu
      }, {
        autoGenerateKey: false
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var menu = this.renderMenu();
      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["b" /* getUnhandledProps */])(Tab, this.props);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["c" /* getElementType */])(Tab, this.props);

      if (menu.props.vertical) {
        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, rest, this.renderVertical(menu));
      }

      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, rest, menu.props.attached !== 'bottom' && menu, this.renderItems(), menu.props.attached === 'bottom' && menu);
    }
  }]);

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["s" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "defaultProps", {
  grid: {
    paneWidth: 12,
    tabWidth: 4
  },
  menu: {
    attached: true,
    tabular: true
  },
  renderActiveOnly: true
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "Pane", __WEBPACK_IMPORTED_MODULE_18__TabPane__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "handledProps", ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"]);

Tab.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The initial activeIndex. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active tab. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Shorthand props for the Menu.
   * tabular, if true, will derive final value from `menuPosition`, otherwise set 'left' or 'right' explicitly.
   */
  menu: PropTypes.object,

  /** Align vertical menu */
  menuPosition: PropTypes.oneOf(['left', 'right']),

  /** Shorthand props for the Grid. */
  grid: PropTypes.object,

  /**
   * Called on tab change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed new activeIndex.
   * @param {object} data.activeIndex - The new proposed activeIndex.
   */
  onTabChange: PropTypes.func,

  /**
   * Array of objects describing each Menu.Item and Tab.Pane:
   * { menuItem: 'Home', render: () => <Tab.Pane /> }
   * or
   * { menuItem: 'Home', pane: 'Welcome' }
   */
  panes: PropTypes.arrayOf(PropTypes.shape({
    menuItem: customPropTypes.itemShorthand,
    pane: customPropTypes.itemShorthand,
    render: PropTypes.func
  })),

  /** A Tab can render only active pane. */
  renderActiveOnly: PropTypes.bool
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(2574);
/* unused harmony reexport default */



/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);





/**
 * An ad displays third-party promotional content.
 */

function Advertisement(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      test = props.test,
      unit = props.unit;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', unit, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(test, 'test'), 'ad', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Advertisement, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Advertisement, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes,
    "data-text": test
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Advertisement.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"];
Advertisement.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Center the advertisement. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Text to be displayed on the advertisement. */
  test: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),

  /** Varies the size of the advertisement. */
  unit: PropTypes.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Advertisement);

/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Advertisement__ = __webpack_require__(2576);
/* unused harmony reexport default */



/***/ }),
/* 2578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentAction__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommentActions__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommentContent__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommentGroup__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommentText__ = __webpack_require__(1367);













/**
 * A comment displays user feedback to site content.
 */

function Comment(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(collapsed, 'collapsed'), 'comment', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Comment, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Comment, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Comment.handledProps = ["as", "children", "className", "collapsed", "content"];
Comment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comment can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
Comment.Author = __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__["a" /* default */];
Comment.Action = __WEBPACK_IMPORTED_MODULE_5__CommentAction__["a" /* default */];
Comment.Actions = __WEBPACK_IMPORTED_MODULE_6__CommentActions__["a" /* default */];
Comment.Avatar = __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__["a" /* default */];
Comment.Content = __WEBPACK_IMPORTED_MODULE_9__CommentContent__["a" /* default */];
Comment.Group = __WEBPACK_IMPORTED_MODULE_10__CommentGroup__["a" /* default */];
Comment.Metadata = __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__["a" /* default */];
Comment.Text = __WEBPACK_IMPORTED_MODULE_12__CommentText__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Comment);

/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment__ = __webpack_require__(2578);
/* unused harmony reexport default */



/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedContent__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedDate__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FeedEvent__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeedExtra__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedLabel__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedLike__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedMeta__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedSummary__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedUser__ = __webpack_require__(784);

















/**
 * A feed presents user activity chronologically.
 */

function Feed(props) {
  var children = props.children,
      className = props.className,
      events = props.events,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ui', size, 'feed', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Feed, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Feed, props);

  if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var eventElements = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(events, function (eventProps) {
    var childKey = eventProps.childKey,
        date = eventProps.date,
        meta = eventProps.meta,
        summary = eventProps.summary,
        eventData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(eventProps, ["childKey", "date", "meta", "summary"]);

    var finalKey = childKey || [date, meta, summary].join('-');
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      date: date,
      key: finalKey,
      meta: meta,
      summary: summary
    }, eventData));
  });

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), eventElements);
}

Feed.handledProps = ["as", "children", "className", "events", "size"];
Feed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand array of props for FeedEvent. */
  events: customPropTypes.collectionShorthand,

  /** A feed can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
} : {};
Feed.Content = __WEBPACK_IMPORTED_MODULE_8__FeedContent__["a" /* default */];
Feed.Date = __WEBPACK_IMPORTED_MODULE_9__FeedDate__["a" /* default */];
Feed.Event = __WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */];
Feed.Extra = __WEBPACK_IMPORTED_MODULE_11__FeedExtra__["a" /* default */];
Feed.Label = __WEBPACK_IMPORTED_MODULE_12__FeedLabel__["a" /* default */];
Feed.Like = __WEBPACK_IMPORTED_MODULE_13__FeedLike__["a" /* default */];
Feed.Meta = __WEBPACK_IMPORTED_MODULE_14__FeedMeta__["a" /* default */];
Feed.Summary = __WEBPACK_IMPORTED_MODULE_15__FeedSummary__["a" /* default */];
Feed.User = __WEBPACK_IMPORTED_MODULE_16__FeedUser__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Feed);

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Feed__ = __webpack_require__(2580);
/* unused harmony reexport default */



/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(1369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Item__["a"]; });



/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Statistic__ = __webpack_require__(1373);
/* unused harmony reexport default */



/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257),
    root = __webpack_require__(99);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2664),
    hashDelete = __webpack_require__(2665),
    hashGet = __webpack_require__(2666),
    hashHas = __webpack_require__(2667),
    hashSet = __webpack_require__(2668);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(257),
    root = __webpack_require__(99);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;

/***/ }),
/* 2588 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1394);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;

/***/ }),
/* 2590 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;

/***/ }),
/* 2591 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(255);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function (value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(372),
    keysIn = __webpack_require__(521);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(255);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function (value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(259);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(255);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(493),
    arrayIncludes = __webpack_require__(496),
    arrayIncludesWith = __webpack_require__(793),
    arrayMap = __webpack_require__(180),
    baseUnary = __webpack_require__(256),
    cacheHas = __webpack_require__(504);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer: while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(498);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function (value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(495),
    castPath = __webpack_require__(371),
    last = __webpack_require__(2754),
    parent = __webpack_require__(2691),
    toKey = __webpack_require__(258);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    equalArrays = __webpack_require__(1407),
    equalByTag = __webpack_require__(2657),
    equalObjects = __webpack_require__(2658),
    getTag = __webpack_require__(206),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(302),
    isTypedArray = __webpack_require__(378);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(206),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    baseIsEqual = __webpack_require__(796);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(208),
    isMasked = __webpack_require__(2674),
    isObject = __webpack_require__(105),
    toSource = __webpack_require__(1427);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(206),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isLength = __webpack_require__(806),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105),
    isPrototype = __webpack_require__(510),
    nativeKeysIn = __webpack_require__(2689);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2606),
    getMatchData = __webpack_require__(2659),
    matchesStrictComparable = __webpack_require__(1418);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(796),
    get = __webpack_require__(141),
    hasIn = __webpack_require__(1436),
    isKey = __webpack_require__(804),
    isStrictComparable = __webpack_require__(1416),
    matchesStrictComparable = __webpack_require__(1418),
    toKey = __webpack_require__(258);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    assignMergeValue = __webpack_require__(1384),
    baseFor = __webpack_require__(1390),
    baseMergeDeep = __webpack_require__(2617),
    isObject = __webpack_require__(105),
    keysIn = __webpack_require__(521),
    safeGet = __webpack_require__(1422);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(1384),
    cloneBuffer = __webpack_require__(1400),
    cloneTypedArray = __webpack_require__(1401),
    copyArray = __webpack_require__(298),
    initCloneObject = __webpack_require__(1414),
    isArguments = __webpack_require__(375),
    isArray = __webpack_require__(51),
    isArrayLikeObject = __webpack_require__(376),
    isBuffer = __webpack_require__(302),
    isFunction = __webpack_require__(208),
    isObject = __webpack_require__(105),
    isPlainObject = __webpack_require__(377),
    isTypedArray = __webpack_require__(378),
    safeGet = __webpack_require__(1422),
    toPlainObject = __webpack_require__(2776);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180),
    baseIteratee = __webpack_require__(117),
    baseMap = __webpack_require__(1392),
    baseSortBy = __webpack_require__(2626),
    baseUnary = __webpack_require__(256),
    compareMultiple = __webpack_require__(2636),
    identity = __webpack_require__(155);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1393),
    hasIn = __webpack_require__(1436);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;

/***/ }),
/* 2623 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function (value, index, collection) {
    accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1429),
    defineProperty = __webpack_require__(1406),
    identity = __webpack_require__(155);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(255);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function (value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;

/***/ }),
/* 2626 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : result + current;
    }
  }
  return result;
}

module.exports = baseSum;

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

module.exports = baseValues;

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(376);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(500);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(500);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(799);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

/***/ }),
/* 2633 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(259);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(2635);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(372),
    getSymbols = __webpack_require__(803);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(372),
    getSymbolsIn = __webpack_require__(1412);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(99);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 2640 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(2587),
    baseAggregator = __webpack_require__(2592),
    baseIteratee = __webpack_require__(117),
    isArray = __webpack_require__(51);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
    return function (collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}

module.exports = createAggregator;

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(205),
    isIterateeCall = __webpack_require__(299);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(142);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),
/* 2644 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(505),
    root = __webpack_require__(99);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(798),
    hasUnicode = __webpack_require__(509),
    stringToArray = __webpack_require__(515),
    toString = __webpack_require__(156);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);

    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;

    var chr = strSymbols ? strSymbols[0] : string.charAt(0);

    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(1382),
    deburr = __webpack_require__(1430),
    words = __webpack_require__(2781);

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(495),
    createCtor = __webpack_require__(505),
    createHybrid = __webpack_require__(1404),
    createRecurry = __webpack_require__(1405),
    getHolder = __webpack_require__(802),
    replaceHolders = __webpack_require__(513),
    root = __webpack_require__(99);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
    }
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(117),
    isArrayLike = __webpack_require__(142),
    keys = __webpack_require__(118);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(790),
    flatRest = __webpack_require__(800),
    getData = __webpack_require__(801),
    getFuncName = __webpack_require__(1411),
    isArray = __webpack_require__(51),
    isLaziable = __webpack_require__(1415);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function (funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
      }
    }
    return function () {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(2601);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function (object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(495),
    createCtor = __webpack_require__(505),
    root = __webpack_require__(99);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = this && this !== root && this instanceof wrapper ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(2622),
    isIterateeCall = __webpack_require__(299),
    toFinite = __webpack_require__(808);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(99),
    toInteger = __webpack_require__(181),
    toNumber = __webpack_require__(525),
    toString = __webpack_require__(156);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function (number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(1377),
    noop = __webpack_require__(1439),
    setToArray = __webpack_require__(514);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
  return new Set(values);
};

module.exports = createSet;

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(2621);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C', '\xe7': 'c',
  '\xd0': 'D', '\xf0': 'd',
  '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N', '\xf1': 'n',
  '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C', '\u0108': 'C', '\u010A': 'C', '\u010C': 'C',
  '\u0107': 'c', '\u0109': 'c', '\u010B': 'c', '\u010D': 'c',
  '\u010E': 'D', '\u0110': 'D', '\u010F': 'd', '\u0111': 'd',
  '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011A': 'E',
  '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011B': 'e',
  '\u011C': 'G', '\u011E': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011D': 'g', '\u011F': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I', '\u012A': 'I', '\u012C': 'I', '\u012E': 'I', '\u0130': 'I',
  '\u0129': 'i', '\u012B': 'i', '\u012D': 'i', '\u012F': 'i', '\u0131': 'i',
  '\u0134': 'J', '\u0135': 'j',
  '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L', '\u013B': 'L', '\u013D': 'L', '\u013F': 'L', '\u0141': 'L',
  '\u013A': 'l', '\u013C': 'l', '\u013E': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014A': 'N',
  '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014B': 'n',
  '\u014C': 'O', '\u014E': 'O', '\u0150': 'O',
  '\u014D': 'o', '\u014F': 'o', '\u0151': 'o',
  '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
  '\u015A': 'S', '\u015C': 'S', '\u015E': 'S', '\u0160': 'S',
  '\u015B': 's', '\u015D': 's', '\u015F': 's', '\u0161': 's',
  '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't', '\u0165': 't', '\u0167': 't',
  '\u0168': 'U', '\u016A': 'U', '\u016C': 'U', '\u016E': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u', '\u016B': 'u', '\u016D': 'u', '\u016F': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W', '\u0175': 'w',
  '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z', '\u017B': 'Z', '\u017D': 'Z',
  '\u017A': 'z', '\u017C': 'z', '\u017E': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017F': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254),
    Uint8Array = __webpack_require__(1378),
    eq = __webpack_require__(374),
    equalArrays = __webpack_require__(1407),
    mapToArray = __webpack_require__(1417),
    setToArray = __webpack_require__(514);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1409);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1416),
    keys = __webpack_require__(118);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 2661 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 2662 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;

/***/ }),
/* 2663 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(511);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(511);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(511);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(511);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 2669 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(799),
    cloneDataView = __webpack_require__(2632),
    cloneRegExp = __webpack_require__(2633),
    cloneSymbol = __webpack_require__(2634),
    cloneTypedArray = __webpack_require__(1401);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor();

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor();

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

/***/ }),
/* 2671 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254),
    isArguments = __webpack_require__(375),
    isArray = __webpack_require__(51);

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

/***/ }),
/* 2673 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2639);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 2675 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;

/***/ }),
/* 2676 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(497);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(497);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(497);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(497);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2585),
    ListCache = __webpack_require__(492),
    Map = __webpack_require__(791);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(507);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(507);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(507);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(507);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(522);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1402),
    composeArgsRight = __webpack_require__(1403),
    replaceHolders = __webpack_require__(513);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1420);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 2689 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

/***/ }),
/* 2690 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(499),
    baseSlice = __webpack_require__(502);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;

/***/ }),
/* 2692 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(298),
    isIndex = __webpack_require__(373);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;

/***/ }),
/* 2694 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 2695 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(492);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 2697 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 2698 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 2699 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(492),
    Map = __webpack_require__(791),
    MapCache = __webpack_require__(792);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 2701 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(2589),
    hasUnicode = __webpack_require__(509),
    unicodeSize = __webpack_require__(2703);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}

module.exports = stringSize;

/***/ }),
/* 2703 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
        ++result;
    }
    return result;
}

module.exports = unicodeSize;

/***/ }),
/* 2704 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;

/***/ }),
/* 2705 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(367),
    arrayIncludes = __webpack_require__(496);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function (pair) {
    var value = '_.' + pair[0];
    if (bitmask & pair[1] && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(789),
    LodashWrapper = __webpack_require__(790),
    copyArray = __webpack_require__(298);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__ = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(506);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = func && n == null ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1386),
    toNumber = __webpack_require__(525);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(1387);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(506);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(502),
    toInteger = __webpack_require__(181);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(156);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
}

module.exports = escapeRegExp;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(2588),
    baseEvery = __webpack_require__(2594),
    baseIteratee = __webpack_require__(117),
    isArray = __webpack_require__(51),
    isIterateeCall = __webpack_require__(299);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2742);

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(370),
    map = __webpack_require__(66);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(370);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(2650);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(2720),
    fallbackHolder = __webpack_require__(62);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2 ? function (a, b) {
    return func.apply(undefined, arguments);
  } : function (a) {
    return func.apply(undefined, arguments);
  };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2 ? function (a, b) {
    return func(a, b);
  } : function (a) {
    return func(a);
  };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function (object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function () {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function () {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError();
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = 'curry' in options && options.curry,
      forceFixed = 'fixed' in options && options.fixed,
      forceRearg = 'rearg' in options && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function castArray(_castArray) {
      return function () {
        var value = arguments[0];
        return isArray(value) ? _castArray(cloneArray(value)) : _castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function iteratee(_iteratee) {
      return function () {
        var func = arguments[0],
            arity = arguments[1],
            result = _iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? arity - 2 : 1;
          return length && length <= arity ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function mixin(_mixin) {
      return function (source) {
        var func = this;
        if (!isFunction(func)) {
          return _mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function (key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        _mixin(func, Object(source));

        each(pairs, function (pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function nthArg(_nthArg) {
      return function (n) {
        var arity = n < 0 ? 1 : toInteger(n) + 1;
        return curry(_nthArg(n), arity);
      };
    },
    'rearg': function rearg(_rearg) {
      return function (func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(_rearg(func, indexes), arity);
      };
    },
    'runInContext': function runInContext(_runInContext) {
      return function (context) {
        return baseConvert(util, _runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]) ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n]) : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function (options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function (func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function (func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function () {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : length - 1;
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    } else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      } else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      } else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function (aryKey) {
      each(mapping.aryMethod[aryKey], function (otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function () {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function (aryKey) {
    each(mapping.aryMethod[aryKey], function (key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function (key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function (pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function (key) {
    each(mapping.realToAlias[key] || [], function (alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;

/***/ }),
/* 2720 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': ['assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create', 'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow', 'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll', 'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome', 'rest', 'reverse', 'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart', 'uniqueId', 'words', 'zipAll'],
  '2': ['add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith', 'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith', 'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN', 'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference', 'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq', 'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex', 'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach', 'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get', 'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection', 'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy', 'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty', 'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit', 'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial', 'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll', 'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove', 'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex', 'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy', 'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight', 'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars', 'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith', 'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject', 'zipObjectDeep'],
  '3': ['assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith', 'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr', 'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith', 'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth', 'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd', 'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight', 'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy', 'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy', 'xorWith', 'zipWith'],
  '4': ['fill', 'setWith', 'updateWith']
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = function () {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}();

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(2708),
  'assign': __webpack_require__(1385),
  'clone': __webpack_require__(2710),
  'curry': __webpack_require__(2711),
  'forEach': __webpack_require__(367),
  'isArray': __webpack_require__(51),
  'isError': __webpack_require__(2746),
  'isFunction': __webpack_require__(208),
  'isWeakMap': __webpack_require__(2751),
  'iteratee': __webpack_require__(2752),
  'keys': __webpack_require__(501),
  'rearg': __webpack_require__(2762),
  'toInteger': __webpack_require__(181),
  'toPath': __webpack_require__(2775)
};

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('compact', __webpack_require__(1428), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('difference', __webpack_require__(516));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('filter', __webpack_require__(517));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('flatMap', __webpack_require__(2716));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('identity', __webpack_require__(155), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('isFunction', __webpack_require__(208), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('isNil', __webpack_require__(67), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('isObject', __webpack_require__(105), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('isPlainObject', __webpack_require__(377), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('keys', __webpack_require__(118), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('memoize', __webpack_require__(522));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('min', __webpack_require__(2757), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('pick', __webpack_require__(523));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('sortBy', __webpack_require__(2766));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('split', __webpack_require__(2767));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('sum', __webpack_require__(2771), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('take', __webpack_require__(2772));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('toArray', __webpack_require__(2774), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('trim', __webpack_require__(2778));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(65),
    func = convert('uniq', __webpack_require__(809), __webpack_require__(140));

func.placeholder = __webpack_require__(62);
module.exports = func;

/***/ }),
/* 2742 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return array && array.length ? array[0] : undefined;
}

module.exports = head;

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180),
    baseIntersection = __webpack_require__(2600),
    baseRest = __webpack_require__(205),
    castArrayLikeObject = __webpack_require__(2629);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function (arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});

module.exports = intersection;

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1429),
    createInverter = __webpack_require__(2651),
    identity = __webpack_require__(155);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function (result, value, key) {
  if (value != null && typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}

module.exports = isBoolean;

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91),
    isPlainObject = __webpack_require__(377);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
    if (!isObjectLike(value)) {
        return false;
    }
    var tag = baseGetTag(value);
    return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
}

module.exports = isError;

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(2605),
    baseUnary = __webpack_require__(256),
    nodeUtil = __webpack_require__(512);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}

module.exports = isNumber;

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(2609),
    baseUnary = __webpack_require__(256),
    nodeUtil = __webpack_require__(512);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(2610),
    baseUnary = __webpack_require__(256),
    nodeUtil = __webpack_require__(512);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(206),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(1387),
    baseIteratee = __webpack_require__(117);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(368),
    createAggregator = __webpack_require__(2641);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function (result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;

/***/ }),
/* 2754 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(368),
    baseForOwn = __webpack_require__(498),
    baseIteratee = __webpack_require__(117);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(2616),
    createAssigner = __webpack_require__(2642);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(2595),
    baseLt = __webpack_require__(2613),
    identity = __webpack_require__(155);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}

module.exports = min;

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(205),
    createWrap = __webpack_require__(506),
    getHolder = __webpack_require__(802),
    replaceHolders = __webpack_require__(513);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function (func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

module.exports = partialRight;

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180),
    baseIteratee = __webpack_require__(117),
    basePickBy = __webpack_require__(1393),
    getAllKeysIn = __webpack_require__(1410);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function (prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function (value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1394),
    basePropertyDeep = __webpack_require__(2620),
    isKey = __webpack_require__(804),
    toKey = __webpack_require__(258);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(2653);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(506),
    flatRest = __webpack_require__(800);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function (func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(2654);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(1395);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(501),
    getTag = __webpack_require__(206),
    isArrayLike = __webpack_require__(142),
    isString = __webpack_require__(519),
    stringSize = __webpack_require__(2702);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(370),
    baseOrderBy = __webpack_require__(2618),
    baseRest = __webpack_require__(205),
    isIterateeCall = __webpack_require__(299);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(503),
    castSlice = __webpack_require__(798),
    hasUnicode = __webpack_require__(509),
    isIterateeCall = __webpack_require__(299),
    isRegExp = __webpack_require__(2749),
    stringToArray = __webpack_require__(515),
    toString = __webpack_require__(156);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(2647),
    upperFirst = __webpack_require__(2780);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1386),
    baseToString = __webpack_require__(503),
    toInteger = __webpack_require__(181),
    toString = __webpack_require__(156);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;

/***/ }),
/* 2770 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(2627),
    identity = __webpack_require__(155);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
    return array && array.length ? baseSum(array, identity) : 0;
}

module.exports = sum;

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(502),
    toInteger = __webpack_require__(181);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = guard || n === undefined ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1397),
    castFunction = __webpack_require__(1399),
    toInteger = __webpack_require__(181);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(254),
    copyArray = __webpack_require__(298),
    getTag = __webpack_require__(206),
    isArrayLike = __webpack_require__(142),
    isString = __webpack_require__(519),
    iteratorToArray = __webpack_require__(2675),
    mapToArray = __webpack_require__(1417),
    setToArray = __webpack_require__(514),
    stringToArray = __webpack_require__(515),
    values = __webpack_require__(379);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = _Symbol ? _Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;

  return func(value);
}

module.exports = toArray;

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(180),
    copyArray = __webpack_require__(298),
    isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(259),
    stringToPath = __webpack_require__(1426),
    toKey = __webpack_require__(258),
    toString = __webpack_require__(156);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(372),
    keysIn = __webpack_require__(521);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(367),
    baseCreate = __webpack_require__(369),
    baseForOwn = __webpack_require__(498),
    baseIteratee = __webpack_require__(117),
    getPrototype = __webpack_require__(508),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(302),
    isFunction = __webpack_require__(208),
    isObject = __webpack_require__(105),
    isTypedArray = __webpack_require__(378);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor() : [];
    } else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    } else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(503),
    castSlice = __webpack_require__(798),
    charsEndIndex = __webpack_require__(2630),
    charsStartIndex = __webpack_require__(2631),
    stringToArray = __webpack_require__(515),
    toString = __webpack_require__(156);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(370),
    baseRest = __webpack_require__(205),
    baseUniq = __webpack_require__(1398),
    isArrayLikeObject = __webpack_require__(376);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function (arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(2646);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(2591),
    hasUnicodeWord = __webpack_require__(2663),
    toString = __webpack_require__(156),
    unicodeWords = __webpack_require__(2705);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(789),
    LodashWrapper = __webpack_require__(790),
    baseLodash = __webpack_require__(797),
    isArray = __webpack_require__(51),
    isObjectLike = __webpack_require__(91),
    wrapperClone = __webpack_require__(2707);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

/***/ }),
/* 2784 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(2786);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42), __webpack_require__(1442)(module)))

/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! tether 1.4.0 */

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory(require, exports, module);
  } else {
    root.Tether = factory();
  }
})(this, function (require, exports, module) {

  'use strict';

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
    }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  var TetherBase = undefined;
  if (typeof TetherBase === 'undefined') {
    TetherBase = { modules: [] };
  }

  var zeroElement = null;

  // Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
  // if the element lies within a nested document (<frame> or <iframe>-like).
  function getActualBoundingClientRect(node) {
    var boundingRect = node.getBoundingClientRect();

    // The original object returned by getBoundingClientRect is immutable, so we clone it
    // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
    var rect = {};
    for (var k in boundingRect) {
      rect[k] = boundingRect[k];
    }

    if (node.ownerDocument !== document) {
      var _frameElement = node.ownerDocument.defaultView.frameElement;
      if (_frameElement) {
        var frameRect = getActualBoundingClientRect(_frameElement);
        rect.top += frameRect.top;
        rect.bottom += frameRect.top;
        rect.left += frameRect.left;
        rect.right += frameRect.left;
      }
    }

    return rect;
  }

  function getScrollParents(el) {
    // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
    // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    var computedStyle = getComputedStyle(el) || {};
    var position = computedStyle.position;
    var parents = [];

    if (position === 'fixed') {
      return [el];
    }

    var parent = el;
    while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
      var style = undefined;
      try {
        style = getComputedStyle(parent);
      } catch (err) {}

      if (typeof style === 'undefined' || style === null) {
        parents.push(parent);
        return parents;
      }

      var _style = style;
      var overflow = _style.overflow;
      var overflowX = _style.overflowX;
      var overflowY = _style.overflowY;

      if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
        if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
          parents.push(parent);
        }
      }
    }

    parents.push(el.ownerDocument.body);

    // If the node is within a frame, account for the parent window scroll
    if (el.ownerDocument !== document) {
      parents.push(el.ownerDocument.defaultView);
    }

    return parents;
  }

  var uniqueId = function () {
    var id = 0;
    return function () {
      return ++id;
    };
  }();

  var zeroPosCache = {};
  var getOrigin = function getOrigin() {
    // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
    // jitter as the user scrolls that messes with our ability to detect if two positions
    // are equivilant or not.  We place an element at the top left of the page that will
    // get the same jitter, so we can cancel the two out.
    var node = zeroElement;
    if (!node || !document.body.contains(node)) {
      node = document.createElement('div');
      node.setAttribute('data-tether-id', uniqueId());
      extend(node.style, {
        top: 0,
        left: 0,
        position: 'absolute'
      });

      document.body.appendChild(node);

      zeroElement = node;
    }

    var id = node.getAttribute('data-tether-id');
    if (typeof zeroPosCache[id] === 'undefined') {
      zeroPosCache[id] = getActualBoundingClientRect(node);

      // Clear the cache when this position call is done
      defer(function () {
        delete zeroPosCache[id];
      });
    }

    return zeroPosCache[id];
  };

  function removeUtilElements() {
    if (zeroElement) {
      document.body.removeChild(zeroElement);
    }
    zeroElement = null;
  };

  function getBounds(el) {
    var doc = undefined;
    if (el === document) {
      doc = document;
      el = document.documentElement;
    } else {
      doc = el.ownerDocument;
    }

    var docEl = doc.documentElement;

    var box = getActualBoundingClientRect(el);

    var origin = getOrigin();

    box.top -= origin.top;
    box.left -= origin.left;

    if (typeof box.width === 'undefined') {
      box.width = document.body.scrollWidth - box.left - box.right;
    }
    if (typeof box.height === 'undefined') {
      box.height = document.body.scrollHeight - box.top - box.bottom;
    }

    box.top = box.top - docEl.clientTop;
    box.left = box.left - docEl.clientLeft;
    box.right = doc.body.clientWidth - box.width - box.left;
    box.bottom = doc.body.clientHeight - box.height - box.top;

    return box;
  }

  function getOffsetParent(el) {
    return el.offsetParent || document.documentElement;
  }

  var _scrollBarSize = null;
  function getScrollBarSize() {
    if (_scrollBarSize) {
      return _scrollBarSize;
    }
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    extend(outer.style, {
      position: 'absolute',
      top: 0,
      left: 0,
      pointerEvents: 'none',
      visibility: 'hidden',
      width: '200px',
      height: '150px',
      overflow: 'hidden'
    });

    outer.appendChild(inner);

    document.body.appendChild(outer);

    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);

    var width = widthContained - widthScroll;

    _scrollBarSize = { width: width, height: width };
    return _scrollBarSize;
  }

  function extend() {
    var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var args = [];

    Array.prototype.push.apply(args, arguments);

    args.slice(1).forEach(function (obj) {
      if (obj) {
        for (var key in obj) {
          if ({}.hasOwnProperty.call(obj, key)) {
            out[key] = obj[key];
          }
        }
      }
    });

    return out;
  }

  function removeClass(el, name) {
    if (typeof el.classList !== 'undefined') {
      name.split(' ').forEach(function (cls) {
        if (cls.trim()) {
          el.classList.remove(cls);
        }
      });
    } else {
      var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
      var className = getClassName(el).replace(regex, ' ');
      setClassName(el, className);
    }
  }

  function addClass(el, name) {
    if (typeof el.classList !== 'undefined') {
      name.split(' ').forEach(function (cls) {
        if (cls.trim()) {
          el.classList.add(cls);
        }
      });
    } else {
      removeClass(el, name);
      var cls = getClassName(el) + (' ' + name);
      setClassName(el, cls);
    }
  }

  function hasClass(el, name) {
    if (typeof el.classList !== 'undefined') {
      return el.classList.contains(name);
    }
    var className = getClassName(el);
    return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
  }

  function getClassName(el) {
    // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
    // completely separately SVGAnimatedString base classes
    if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
      return el.className.baseVal;
    }
    return el.className;
  }

  function setClassName(el, className) {
    el.setAttribute('class', className);
  }

  function updateClasses(el, add, all) {
    // Of the set of 'all' classes, we need the 'add' classes, and only the
    // 'add' classes to be set.
    all.forEach(function (cls) {
      if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
        removeClass(el, cls);
      }
    });

    add.forEach(function (cls) {
      if (!hasClass(el, cls)) {
        addClass(el, cls);
      }
    });
  }

  var deferred = [];

  var defer = function defer(fn) {
    deferred.push(fn);
  };

  var flush = function flush() {
    var fn = undefined;
    while (fn = deferred.pop()) {
      fn();
    }
  };

  var Evented = function () {
    function Evented() {
      _classCallCheck(this, Evented);
    }

    _createClass(Evented, [{
      key: 'on',
      value: function on(event, handler, ctx) {
        var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

        if (typeof this.bindings === 'undefined') {
          this.bindings = {};
        }
        if (typeof this.bindings[event] === 'undefined') {
          this.bindings[event] = [];
        }
        this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
      }
    }, {
      key: 'once',
      value: function once(event, handler, ctx) {
        this.on(event, handler, ctx, true);
      }
    }, {
      key: 'off',
      value: function off(event, handler) {
        if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
          return;
        }

        if (typeof handler === 'undefined') {
          delete this.bindings[event];
        } else {
          var i = 0;
          while (i < this.bindings[event].length) {
            if (this.bindings[event][i].handler === handler) {
              this.bindings[event].splice(i, 1);
            } else {
              ++i;
            }
          }
        }
      }
    }, {
      key: 'trigger',
      value: function trigger(event) {
        if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
          var i = 0;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          while (i < this.bindings[event].length) {
            var _bindings$event$i = this.bindings[event][i];
            var handler = _bindings$event$i.handler;
            var ctx = _bindings$event$i.ctx;
            var once = _bindings$event$i.once;

            var context = ctx;
            if (typeof context === 'undefined') {
              context = this;
            }

            handler.apply(context, args);

            if (once) {
              this.bindings[event].splice(i, 1);
            } else {
              ++i;
            }
          }
        }
      }
    }]);

    return Evented;
  }();

  TetherBase.Utils = {
    getActualBoundingClientRect: getActualBoundingClientRect,
    getScrollParents: getScrollParents,
    getBounds: getBounds,
    getOffsetParent: getOffsetParent,
    extend: extend,
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    updateClasses: updateClasses,
    defer: defer,
    flush: flush,
    uniqueId: uniqueId,
    Evented: Evented,
    getScrollBarSize: getScrollBarSize,
    removeUtilElements: removeUtilElements
  };
  /* globals TetherBase, performance */

  'use strict';

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;_e = err;
      } finally {
        try {
          if (!_n && _i['return']) _i['return']();
        } finally {
          if (_d) throw _e;
        }
      }return _arr;
    }return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      }
    };
  }();

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
    }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
  }();

  var _get = function get(_x6, _x7, _x8) {
    var _again = true;_function: while (_again) {
      var object = _x6,
          property = _x7,
          receiver = _x8;_again = false;if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);if (parent === null) {
          return undefined;
        } else {
          _x6 = parent;_x7 = property;_x8 = receiver;_again = true;desc = parent = undefined;continue _function;
        }
      } else if ('value' in desc) {
        return desc.value;
      } else {
        var getter = desc.get;if (getter === undefined) {
          return undefined;
        }return getter.call(receiver);
      }
    }
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  if (typeof TetherBase === 'undefined') {
    throw new Error('You must include the utils.js file before tether.js');
  }

  var _TetherBase$Utils = TetherBase.Utils;
  var getScrollParents = _TetherBase$Utils.getScrollParents;
  var getBounds = _TetherBase$Utils.getBounds;
  var getOffsetParent = _TetherBase$Utils.getOffsetParent;
  var extend = _TetherBase$Utils.extend;
  var addClass = _TetherBase$Utils.addClass;
  var removeClass = _TetherBase$Utils.removeClass;
  var updateClasses = _TetherBase$Utils.updateClasses;
  var defer = _TetherBase$Utils.defer;
  var flush = _TetherBase$Utils.flush;
  var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
  var removeUtilElements = _TetherBase$Utils.removeUtilElements;

  function within(a, b) {
    var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

    return a + diff >= b && b >= a - diff;
  }

  var transformKey = function () {
    if (typeof document === 'undefined') {
      return '';
    }
    var el = document.createElement('div');

    var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
    for (var i = 0; i < transforms.length; ++i) {
      var key = transforms[i];
      if (el.style[key] !== undefined) {
        return key;
      }
    }
  }();

  var tethers = [];

  var position = function position() {
    tethers.forEach(function (tether) {
      tether.position(false);
    });
    flush();
  };

  function now() {
    if (typeof performance !== 'undefined' && typeof performance.now !== 'undefined') {
      return performance.now();
    }
    return +new Date();
  }

  (function () {
    var lastCall = null;
    var lastDuration = null;
    var pendingTimeout = null;

    var tick = function tick() {
      if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
        // We voluntarily throttle ourselves if we can't manage 60fps
        lastDuration = Math.min(lastDuration - 16, 250);

        // Just in case this is the last event, remember to position just once more
        pendingTimeout = setTimeout(tick, 250);
        return;
      }

      if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
        // Some browsers call events a little too frequently, refuse to run more than is reasonable
        return;
      }

      if (pendingTimeout != null) {
        clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }

      lastCall = now();
      position();
      lastDuration = now() - lastCall;
    };

    if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
      ['resize', 'scroll', 'touchmove'].forEach(function (event) {
        window.addEventListener(event, tick);
      });
    }
  })();

  var MIRROR_LR = {
    center: 'center',
    left: 'right',
    right: 'left'
  };

  var MIRROR_TB = {
    middle: 'middle',
    top: 'bottom',
    bottom: 'top'
  };

  var OFFSET_MAP = {
    top: 0,
    left: 0,
    middle: '50%',
    center: '50%',
    bottom: '100%',
    right: '100%'
  };

  var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
    var left = attachment.left;
    var top = attachment.top;

    if (left === 'auto') {
      left = MIRROR_LR[relativeToAttachment.left];
    }

    if (top === 'auto') {
      top = MIRROR_TB[relativeToAttachment.top];
    }

    return { left: left, top: top };
  };

  var attachmentToOffset = function attachmentToOffset(attachment) {
    var left = attachment.left;
    var top = attachment.top;

    if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
      left = OFFSET_MAP[attachment.left];
    }

    if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
      top = OFFSET_MAP[attachment.top];
    }

    return { left: left, top: top };
  };

  function addOffset() {
    var out = { top: 0, left: 0 };

    for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
      offsets[_key] = arguments[_key];
    }

    offsets.forEach(function (_ref) {
      var top = _ref.top;
      var left = _ref.left;

      if (typeof top === 'string') {
        top = parseFloat(top, 10);
      }
      if (typeof left === 'string') {
        left = parseFloat(left, 10);
      }

      out.top += top;
      out.left += left;
    });

    return out;
  }

  function offsetToPx(offset, size) {
    if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
      offset.left = parseFloat(offset.left, 10) / 100 * size.width;
    }
    if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
      offset.top = parseFloat(offset.top, 10) / 100 * size.height;
    }

    return offset;
  }

  var parseOffset = function parseOffset(value) {
    var _value$split = value.split(' ');

    var _value$split2 = _slicedToArray(_value$split, 2);

    var top = _value$split2[0];
    var left = _value$split2[1];

    return { top: top, left: left };
  };
  var parseAttachment = parseOffset;

  var TetherClass = function (_Evented) {
    _inherits(TetherClass, _Evented);

    function TetherClass(options) {
      var _this = this;

      _classCallCheck(this, TetherClass);

      _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
      this.position = this.position.bind(this);

      tethers.push(this);

      this.history = [];

      this.setOptions(options, false);

      TetherBase.modules.forEach(function (module) {
        if (typeof module.initialize !== 'undefined') {
          module.initialize.call(_this);
        }
      });

      this.position();
    }

    _createClass(TetherClass, [{
      key: 'getClass',
      value: function getClass() {
        var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
        var classes = this.options.classes;

        if (typeof classes !== 'undefined' && classes[key]) {
          return this.options.classes[key];
        } else if (this.options.classPrefix) {
          return this.options.classPrefix + '-' + key;
        } else {
          return key;
        }
      }
    }, {
      key: 'setOptions',
      value: function setOptions(options) {
        var _this2 = this;

        var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

        var defaults = {
          offset: '0 0',
          targetOffset: '0 0',
          targetAttachment: 'auto auto',
          classPrefix: 'tether'
        };

        this.options = extend(defaults, options);

        var _options = this.options;
        var element = _options.element;
        var target = _options.target;
        var targetModifier = _options.targetModifier;

        this.element = element;
        this.target = target;
        this.targetModifier = targetModifier;

        if (this.target === 'viewport') {
          this.target = document.body;
          this.targetModifier = 'visible';
        } else if (this.target === 'scroll-handle') {
          this.target = document.body;
          this.targetModifier = 'scroll-handle';
        }

        ['element', 'target'].forEach(function (key) {
          if (typeof _this2[key] === 'undefined') {
            throw new Error('Tether Error: Both element and target must be defined');
          }

          if (typeof _this2[key].jquery !== 'undefined') {
            _this2[key] = _this2[key][0];
          } else if (typeof _this2[key] === 'string') {
            _this2[key] = document.querySelector(_this2[key]);
          }
        });

        addClass(this.element, this.getClass('element'));
        if (!(this.options.addTargetClasses === false)) {
          addClass(this.target, this.getClass('target'));
        }

        if (!this.options.attachment) {
          throw new Error('Tether Error: You must provide an attachment');
        }

        this.targetAttachment = parseAttachment(this.options.targetAttachment);
        this.attachment = parseAttachment(this.options.attachment);
        this.offset = parseOffset(this.options.offset);
        this.targetOffset = parseOffset(this.options.targetOffset);

        if (typeof this.scrollParents !== 'undefined') {
          this.disable();
        }

        if (this.targetModifier === 'scroll-handle') {
          this.scrollParents = [this.target];
        } else {
          this.scrollParents = getScrollParents(this.target);
        }

        if (!(this.options.enabled === false)) {
          this.enable(pos);
        }
      }
    }, {
      key: 'getTargetBounds',
      value: function getTargetBounds() {
        if (typeof this.targetModifier !== 'undefined') {
          if (this.targetModifier === 'visible') {
            if (this.target === document.body) {
              return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
            } else {
              var bounds = getBounds(this.target);

              var out = {
                height: bounds.height,
                width: bounds.width,
                top: bounds.top,
                left: bounds.left
              };

              out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
              out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
              out.height = Math.min(innerHeight, out.height);
              out.height -= 2;

              out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
              out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
              out.width = Math.min(innerWidth, out.width);
              out.width -= 2;

              if (out.top < pageYOffset) {
                out.top = pageYOffset;
              }
              if (out.left < pageXOffset) {
                out.left = pageXOffset;
              }

              return out;
            }
          } else if (this.targetModifier === 'scroll-handle') {
            var bounds = undefined;
            var target = this.target;
            if (target === document.body) {
              target = document.documentElement;

              bounds = {
                left: pageXOffset,
                top: pageYOffset,
                height: innerHeight,
                width: innerWidth
              };
            } else {
              bounds = getBounds(target);
            }

            var style = getComputedStyle(target);

            var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

            var scrollBottom = 0;
            if (hasBottomScroll) {
              scrollBottom = 15;
            }

            var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

            var out = {
              width: 15,
              height: height * 0.975 * (height / target.scrollHeight),
              left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
            };

            var fitAdj = 0;
            if (height < 408 && this.target === document.body) {
              fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
            }

            if (this.target !== document.body) {
              out.height = Math.max(out.height, 24);
            }

            var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
            out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

            if (this.target === document.body) {
              out.height = Math.max(out.height, 24);
            }

            return out;
          }
        } else {
          return getBounds(this.target);
        }
      }
    }, {
      key: 'clearCache',
      value: function clearCache() {
        this._cache = {};
      }
    }, {
      key: 'cache',
      value: function cache(k, getter) {
        // More than one module will often need the same DOM info, so
        // we keep a cache which is cleared on each position call
        if (typeof this._cache === 'undefined') {
          this._cache = {};
        }

        if (typeof this._cache[k] === 'undefined') {
          this._cache[k] = getter.call(this);
        }

        return this._cache[k];
      }
    }, {
      key: 'enable',
      value: function enable() {
        var _this3 = this;

        var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        if (!(this.options.addTargetClasses === false)) {
          addClass(this.target, this.getClass('enabled'));
        }
        addClass(this.element, this.getClass('enabled'));
        this.enabled = true;

        this.scrollParents.forEach(function (parent) {
          if (parent !== _this3.target.ownerDocument) {
            parent.addEventListener('scroll', _this3.position);
          }
        });

        if (pos) {
          this.position();
        }
      }
    }, {
      key: 'disable',
      value: function disable() {
        var _this4 = this;

        removeClass(this.target, this.getClass('enabled'));
        removeClass(this.element, this.getClass('enabled'));
        this.enabled = false;

        if (typeof this.scrollParents !== 'undefined') {
          this.scrollParents.forEach(function (parent) {
            parent.removeEventListener('scroll', _this4.position);
          });
        }
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        var _this5 = this;

        this.disable();

        tethers.forEach(function (tether, i) {
          if (tether === _this5) {
            tethers.splice(i, 1);
          }
        });

        // Remove any elements we were using for convenience from the DOM
        if (tethers.length === 0) {
          removeUtilElements();
        }
      }
    }, {
      key: 'updateAttachClasses',
      value: function updateAttachClasses(elementAttach, targetAttach) {
        var _this6 = this;

        elementAttach = elementAttach || this.attachment;
        targetAttach = targetAttach || this.targetAttachment;
        var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

        if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
          // updateAttachClasses can be called more than once in a position call, so
          // we need to clean up after ourselves such that when the last defer gets
          // ran it doesn't add any extra classes from previous calls.
          this._addAttachClasses.splice(0, this._addAttachClasses.length);
        }

        if (typeof this._addAttachClasses === 'undefined') {
          this._addAttachClasses = [];
        }
        var add = this._addAttachClasses;

        if (elementAttach.top) {
          add.push(this.getClass('element-attached') + '-' + elementAttach.top);
        }
        if (elementAttach.left) {
          add.push(this.getClass('element-attached') + '-' + elementAttach.left);
        }
        if (targetAttach.top) {
          add.push(this.getClass('target-attached') + '-' + targetAttach.top);
        }
        if (targetAttach.left) {
          add.push(this.getClass('target-attached') + '-' + targetAttach.left);
        }

        var all = [];
        sides.forEach(function (side) {
          all.push(_this6.getClass('element-attached') + '-' + side);
          all.push(_this6.getClass('target-attached') + '-' + side);
        });

        defer(function () {
          if (!(typeof _this6._addAttachClasses !== 'undefined')) {
            return;
          }

          updateClasses(_this6.element, _this6._addAttachClasses, all);
          if (!(_this6.options.addTargetClasses === false)) {
            updateClasses(_this6.target, _this6._addAttachClasses, all);
          }

          delete _this6._addAttachClasses;
        });
      }
    }, {
      key: 'position',
      value: function position() {
        var _this7 = this;

        var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        // flushChanges commits the changes immediately, leave true unless you are positioning multiple
        // tethers (in which case call Tether.Utils.flush yourself when you're done)

        if (!this.enabled) {
          return;
        }

        this.clearCache();

        // Turn 'auto' attachments into the appropriate corner or edge
        var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

        this.updateAttachClasses(this.attachment, targetAttachment);

        var elementPos = this.cache('element-bounds', function () {
          return getBounds(_this7.element);
        });

        var width = elementPos.width;
        var height = elementPos.height;

        if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
          var _lastSize = this.lastSize;

          // We cache the height and width to make it possible to position elements that are
          // getting hidden.
          width = _lastSize.width;
          height = _lastSize.height;
        } else {
          this.lastSize = { width: width, height: height };
        }

        var targetPos = this.cache('target-bounds', function () {
          return _this7.getTargetBounds();
        });
        var targetSize = targetPos;

        // Get an actual px offset from the attachment
        var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
        var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

        var manualOffset = offsetToPx(this.offset, { width: width, height: height });
        var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

        // Add the manually provided offset
        offset = addOffset(offset, manualOffset);
        targetOffset = addOffset(targetOffset, manualTargetOffset);

        // It's now our goal to make (element position + offset) == (target position + target offset)
        var left = targetPos.left + targetOffset.left - offset.left;
        var top = targetPos.top + targetOffset.top - offset.top;

        for (var i = 0; i < TetherBase.modules.length; ++i) {
          var _module2 = TetherBase.modules[i];
          var ret = _module2.position.call(this, {
            left: left,
            top: top,
            targetAttachment: targetAttachment,
            targetPos: targetPos,
            elementPos: elementPos,
            offset: offset,
            targetOffset: targetOffset,
            manualOffset: manualOffset,
            manualTargetOffset: manualTargetOffset,
            scrollbarSize: scrollbarSize,
            attachment: this.attachment
          });

          if (ret === false) {
            return false;
          } else if (typeof ret === 'undefined' || (typeof ret === 'undefined' ? 'undefined' : _typeof(ret)) !== 'object') {
            continue;
          } else {
            top = ret.top;
            left = ret.left;
          }
        }

        // We describe the position three different ways to give the optimizer
        // a chance to decide the best possible way to position the element
        // with the fewest repaints.
        var next = {
          // It's position relative to the page (absolute positioning when
          // the element is a child of the body)
          page: {
            top: top,
            left: left
          },

          // It's position relative to the viewport (fixed positioning)
          viewport: {
            top: top - pageYOffset,
            bottom: pageYOffset - top - height + innerHeight,
            left: left - pageXOffset,
            right: pageXOffset - left - width + innerWidth
          }
        };

        var doc = this.target.ownerDocument;
        var win = doc.defaultView;

        var scrollbarSize = undefined;
        if (win.innerHeight > doc.documentElement.clientHeight) {
          scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
          next.viewport.bottom -= scrollbarSize.height;
        }

        if (win.innerWidth > doc.documentElement.clientWidth) {
          scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
          next.viewport.right -= scrollbarSize.width;
        }

        if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
          // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
          next.page.bottom = doc.body.scrollHeight - top - height;
          next.page.right = doc.body.scrollWidth - left - width;
        }

        if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
          (function () {
            var offsetParent = _this7.cache('target-offsetparent', function () {
              return getOffsetParent(_this7.target);
            });
            var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
              return getBounds(offsetParent);
            });
            var offsetParentStyle = getComputedStyle(offsetParent);
            var offsetParentSize = offsetPosition;

            var offsetBorder = {};
            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
              offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
            });

            offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
            offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

            if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
              if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
                // We're within the visible part of the target's scroll parent
                var scrollTop = offsetParent.scrollTop;
                var scrollLeft = offsetParent.scrollLeft;

                // It's position relative to the target's offset parent (absolute positioning when
                // the element is moved to be a child of the target's offset parent).
                next.offset = {
                  top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                  left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
                };
              }
            }
          })();
        }

        // We could also travel up the DOM and try each containing context, rather than only
        // looking at the body, but we're gonna get diminishing returns.

        this.move(next);

        this.history.unshift(next);

        if (this.history.length > 3) {
          this.history.pop();
        }

        if (flushChanges) {
          flush();
        }

        return true;
      }

      // THE ISSUE
    }, {
      key: 'move',
      value: function move(pos) {
        var _this8 = this;

        if (!(typeof this.element.parentNode !== 'undefined')) {
          return;
        }

        var same = {};

        for (var type in pos) {
          same[type] = {};

          for (var key in pos[type]) {
            var found = false;

            for (var i = 0; i < this.history.length; ++i) {
              var point = this.history[i];
              if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
                found = true;
                break;
              }
            }

            if (!found) {
              same[type][key] = true;
            }
          }
        }

        var css = { top: '', left: '', right: '', bottom: '' };

        var transcribe = function transcribe(_same, _pos) {
          var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
          var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
          if (gpu !== false) {
            var yPos = undefined,
                xPos = undefined;
            if (_same.top) {
              css.top = 0;
              yPos = _pos.top;
            } else {
              css.bottom = 0;
              yPos = -_pos.bottom;
            }

            if (_same.left) {
              css.left = 0;
              xPos = _pos.left;
            } else {
              css.right = 0;
              xPos = -_pos.right;
            }

            if (window.matchMedia) {
              // HubSpot/tether#207
              var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
              if (!retina) {
                xPos = Math.round(xPos);
                yPos = Math.round(yPos);
              }
            }

            css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

            if (transformKey !== 'msTransform') {
              // The Z transform will keep this in the GPU (faster, and prevents artifacts),
              // but IE9 doesn't support 3d transforms and will choke.
              css[transformKey] += " translateZ(0)";
            }
          } else {
            if (_same.top) {
              css.top = _pos.top + 'px';
            } else {
              css.bottom = _pos.bottom + 'px';
            }

            if (_same.left) {
              css.left = _pos.left + 'px';
            } else {
              css.right = _pos.right + 'px';
            }
          }
        };

        var moved = false;
        if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
          css.position = 'absolute';
          transcribe(same.page, pos.page);
        } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
          css.position = 'fixed';
          transcribe(same.viewport, pos.viewport);
        } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
          (function () {
            css.position = 'absolute';
            var offsetParent = _this8.cache('target-offsetparent', function () {
              return getOffsetParent(_this8.target);
            });

            if (getOffsetParent(_this8.element) !== offsetParent) {
              defer(function () {
                _this8.element.parentNode.removeChild(_this8.element);
                offsetParent.appendChild(_this8.element);
              });
            }

            transcribe(same.offset, pos.offset);
            moved = true;
          })();
        } else {
          css.position = 'absolute';
          transcribe({ top: true, left: true }, pos.page);
        }

        if (!moved) {
          if (this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          } else {
            var offsetParentIsBody = true;
            var currentNode = this.element.parentNode;
            while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
              if (getComputedStyle(currentNode).position !== 'static') {
                offsetParentIsBody = false;
                break;
              }

              currentNode = currentNode.parentNode;
            }

            if (!offsetParentIsBody) {
              this.element.parentNode.removeChild(this.element);
              this.element.ownerDocument.body.appendChild(this.element);
            }
          }
        }

        // Any css change will trigger a repaint, so let's avoid one if nothing changed
        var writeCSS = {};
        var write = false;
        for (var key in css) {
          var val = css[key];
          var elVal = this.element.style[key];

          if (elVal !== val) {
            write = true;
            writeCSS[key] = val;
          }
        }

        if (write) {
          defer(function () {
            extend(_this8.element.style, writeCSS);
            _this8.trigger('repositioned');
          });
        }
      }
    }]);

    return TetherClass;
  }(Evented);

  TetherClass.modules = [];

  TetherBase.position = position;

  var Tether = extend(TetherClass, TetherBase);
  /* globals TetherBase */

  'use strict';

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;_e = err;
      } finally {
        try {
          if (!_n && _i['return']) _i['return']();
        } finally {
          if (_d) throw _e;
        }
      }return _arr;
    }return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      }
    };
  }();

  var _TetherBase$Utils = TetherBase.Utils;
  var getBounds = _TetherBase$Utils.getBounds;
  var extend = _TetherBase$Utils.extend;
  var updateClasses = _TetherBase$Utils.updateClasses;
  var defer = _TetherBase$Utils.defer;

  var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

  function getBoundingRect(tether, to) {
    if (to === 'scrollParent') {
      to = tether.scrollParents[0];
    } else if (to === 'window') {
      to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
    }

    if (to === document) {
      to = to.documentElement;
    }

    if (typeof to.nodeType !== 'undefined') {
      (function () {
        var node = to;
        var size = getBounds(to);
        var pos = size;
        var style = getComputedStyle(to);

        to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

        // Account any parent Frames scroll offset
        if (node.ownerDocument !== document) {
          var win = node.ownerDocument.defaultView;
          to[0] += win.pageXOffset;
          to[1] += win.pageYOffset;
          to[2] += win.pageXOffset;
          to[3] += win.pageYOffset;
        }

        BOUNDS_FORMAT.forEach(function (side, i) {
          side = side[0].toUpperCase() + side.substr(1);
          if (side === 'Top' || side === 'Left') {
            to[i] += parseFloat(style['border' + side + 'Width']);
          } else {
            to[i] -= parseFloat(style['border' + side + 'Width']);
          }
        });
      })();
    }

    return to;
  }

  TetherBase.modules.push({
    position: function position(_ref) {
      var _this = this;

      var top = _ref.top;
      var left = _ref.left;
      var targetAttachment = _ref.targetAttachment;

      if (!this.options.constraints) {
        return true;
      }

      var _cache = this.cache('element-bounds', function () {
        return getBounds(_this.element);
      });

      var height = _cache.height;
      var width = _cache.width;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // Handle the item getting hidden as a result of our positioning without glitching
        // the classes in and out
        width = _lastSize.width;
        height = _lastSize.height;
      }

      var targetSize = this.cache('target-bounds', function () {
        return _this.getTargetBounds();
      });

      var targetHeight = targetSize.height;
      var targetWidth = targetSize.width;

      var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

      this.options.constraints.forEach(function (constraint) {
        var outOfBoundsClass = constraint.outOfBoundsClass;
        var pinnedClass = constraint.pinnedClass;

        if (outOfBoundsClass) {
          allClasses.push(outOfBoundsClass);
        }
        if (pinnedClass) {
          allClasses.push(pinnedClass);
        }
      });

      allClasses.forEach(function (cls) {
        ['left', 'top', 'right', 'bottom'].forEach(function (side) {
          allClasses.push(cls + '-' + side);
        });
      });

      var addClasses = [];

      var tAttachment = extend({}, targetAttachment);
      var eAttachment = extend({}, this.attachment);

      this.options.constraints.forEach(function (constraint) {
        var to = constraint.to;
        var attachment = constraint.attachment;
        var pin = constraint.pin;

        if (typeof attachment === 'undefined') {
          attachment = '';
        }

        var changeAttachX = undefined,
            changeAttachY = undefined;
        if (attachment.indexOf(' ') >= 0) {
          var _attachment$split = attachment.split(' ');

          var _attachment$split2 = _slicedToArray(_attachment$split, 2);

          changeAttachY = _attachment$split2[0];
          changeAttachX = _attachment$split2[1];
        } else {
          changeAttachX = changeAttachY = attachment;
        }

        var bounds = getBoundingRect(_this, to);

        if (changeAttachY === 'target' || changeAttachY === 'both') {
          if (top < bounds[1] && tAttachment.top === 'top') {
            top += targetHeight;
            tAttachment.top = 'bottom';
          }

          if (top + height > bounds[3] && tAttachment.top === 'bottom') {
            top -= targetHeight;
            tAttachment.top = 'top';
          }
        }

        if (changeAttachY === 'together') {
          if (tAttachment.top === 'top') {
            if (eAttachment.top === 'bottom' && top < bounds[1]) {
              top += targetHeight;
              tAttachment.top = 'bottom';

              top += height;
              eAttachment.top = 'top';
            } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
              top -= height - targetHeight;
              tAttachment.top = 'bottom';

              eAttachment.top = 'bottom';
            }
          }

          if (tAttachment.top === 'bottom') {
            if (eAttachment.top === 'top' && top + height > bounds[3]) {
              top -= targetHeight;
              tAttachment.top = 'top';

              top -= height;
              eAttachment.top = 'bottom';
            } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
              top += height - targetHeight;
              tAttachment.top = 'top';

              eAttachment.top = 'top';
            }
          }

          if (tAttachment.top === 'middle') {
            if (top + height > bounds[3] && eAttachment.top === 'top') {
              top -= height;
              eAttachment.top = 'bottom';
            } else if (top < bounds[1] && eAttachment.top === 'bottom') {
              top += height;
              eAttachment.top = 'top';
            }
          }
        }

        if (changeAttachX === 'target' || changeAttachX === 'both') {
          if (left < bounds[0] && tAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';
          }

          if (left + width > bounds[2] && tAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';
          }
        }

        if (changeAttachX === 'together') {
          if (left < bounds[0] && tAttachment.left === 'left') {
            if (eAttachment.left === 'right') {
              left += targetWidth;
              tAttachment.left = 'right';

              left += width;
              eAttachment.left = 'left';
            } else if (eAttachment.left === 'left') {
              left += targetWidth;
              tAttachment.left = 'right';

              left -= width;
              eAttachment.left = 'right';
            }
          } else if (left + width > bounds[2] && tAttachment.left === 'right') {
            if (eAttachment.left === 'left') {
              left -= targetWidth;
              tAttachment.left = 'left';

              left -= width;
              eAttachment.left = 'right';
            } else if (eAttachment.left === 'right') {
              left -= targetWidth;
              tAttachment.left = 'left';

              left += width;
              eAttachment.left = 'left';
            }
          } else if (tAttachment.left === 'center') {
            if (left + width > bounds[2] && eAttachment.left === 'left') {
              left -= width;
              eAttachment.left = 'right';
            } else if (left < bounds[0] && eAttachment.left === 'right') {
              left += width;
              eAttachment.left = 'left';
            }
          }
        }

        if (changeAttachY === 'element' || changeAttachY === 'both') {
          if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }

          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          }
        }

        if (changeAttachX === 'element' || changeAttachX === 'both') {
          if (left < bounds[0]) {
            if (eAttachment.left === 'right') {
              left += width;
              eAttachment.left = 'left';
            } else if (eAttachment.left === 'center') {
              left += width / 2;
              eAttachment.left = 'left';
            }
          }

          if (left + width > bounds[2]) {
            if (eAttachment.left === 'left') {
              left -= width;
              eAttachment.left = 'right';
            } else if (eAttachment.left === 'center') {
              left -= width / 2;
              eAttachment.left = 'right';
            }
          }
        }

        if (typeof pin === 'string') {
          pin = pin.split(',').map(function (p) {
            return p.trim();
          });
        } else if (pin === true) {
          pin = ['top', 'left', 'right', 'bottom'];
        }

        pin = pin || [];

        var pinned = [];
        var oob = [];

        if (top < bounds[1]) {
          if (pin.indexOf('top') >= 0) {
            top = bounds[1];
            pinned.push('top');
          } else {
            oob.push('top');
          }
        }

        if (top + height > bounds[3]) {
          if (pin.indexOf('bottom') >= 0) {
            top = bounds[3] - height;
            pinned.push('bottom');
          } else {
            oob.push('bottom');
          }
        }

        if (left < bounds[0]) {
          if (pin.indexOf('left') >= 0) {
            left = bounds[0];
            pinned.push('left');
          } else {
            oob.push('left');
          }
        }

        if (left + width > bounds[2]) {
          if (pin.indexOf('right') >= 0) {
            left = bounds[2] - width;
            pinned.push('right');
          } else {
            oob.push('right');
          }
        }

        if (pinned.length) {
          (function () {
            var pinnedClass = undefined;
            if (typeof _this.options.pinnedClass !== 'undefined') {
              pinnedClass = _this.options.pinnedClass;
            } else {
              pinnedClass = _this.getClass('pinned');
            }

            addClasses.push(pinnedClass);
            pinned.forEach(function (side) {
              addClasses.push(pinnedClass + '-' + side);
            });
          })();
        }

        if (oob.length) {
          (function () {
            var oobClass = undefined;
            if (typeof _this.options.outOfBoundsClass !== 'undefined') {
              oobClass = _this.options.outOfBoundsClass;
            } else {
              oobClass = _this.getClass('out-of-bounds');
            }

            addClasses.push(oobClass);
            oob.forEach(function (side) {
              addClasses.push(oobClass + '-' + side);
            });
          })();
        }

        if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
          eAttachment.left = tAttachment.left = false;
        }
        if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
          eAttachment.top = tAttachment.top = false;
        }

        if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
          _this.updateAttachClasses(eAttachment, tAttachment);
          _this.trigger('update', {
            attachment: eAttachment,
            targetAttachment: tAttachment
          });
        }
      });

      defer(function () {
        if (!(_this.options.addTargetClasses === false)) {
          updateClasses(_this.target, addClasses, allClasses);
        }
        updateClasses(_this.element, addClasses, allClasses);
      });

      return { top: top, left: left };
    }
  });
  /* globals TetherBase */

  'use strict';

  var _TetherBase$Utils = TetherBase.Utils;
  var getBounds = _TetherBase$Utils.getBounds;
  var updateClasses = _TetherBase$Utils.updateClasses;
  var defer = _TetherBase$Utils.defer;

  TetherBase.modules.push({
    position: function position(_ref) {
      var _this = this;

      var top = _ref.top;
      var left = _ref.left;

      var _cache = this.cache('element-bounds', function () {
        return getBounds(_this.element);
      });

      var height = _cache.height;
      var width = _cache.width;

      var targetPos = this.getTargetBounds();

      var bottom = top + height;
      var right = left + width;

      var abutted = [];
      if (top <= targetPos.bottom && bottom >= targetPos.top) {
        ['left', 'right'].forEach(function (side) {
          var targetPosSide = targetPos[side];
          if (targetPosSide === left || targetPosSide === right) {
            abutted.push(side);
          }
        });
      }

      if (left <= targetPos.right && right >= targetPos.left) {
        ['top', 'bottom'].forEach(function (side) {
          var targetPosSide = targetPos[side];
          if (targetPosSide === top || targetPosSide === bottom) {
            abutted.push(side);
          }
        });
      }

      var allClasses = [];
      var addClasses = [];

      var sides = ['left', 'top', 'right', 'bottom'];
      allClasses.push(this.getClass('abutted'));
      sides.forEach(function (side) {
        allClasses.push(_this.getClass('abutted') + '-' + side);
      });

      if (abutted.length) {
        addClasses.push(this.getClass('abutted'));
      }

      abutted.forEach(function (side) {
        addClasses.push(_this.getClass('abutted') + '-' + side);
      });

      defer(function () {
        if (!(_this.options.addTargetClasses === false)) {
          updateClasses(_this.target, addClasses, allClasses);
        }
        updateClasses(_this.element, addClasses, allClasses);
      });

      return true;
    }
  });
  /* globals TetherBase */

  'use strict';

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;_e = err;
      } finally {
        try {
          if (!_n && _i['return']) _i['return']();
        } finally {
          if (_d) throw _e;
        }
      }return _arr;
    }return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      }
    };
  }();

  TetherBase.modules.push({
    position: function position(_ref) {
      var top = _ref.top;
      var left = _ref.left;

      if (!this.options.shift) {
        return;
      }

      var shift = this.options.shift;
      if (typeof this.options.shift === 'function') {
        shift = this.options.shift.call(this, { top: top, left: left });
      }

      var shiftTop = undefined,
          shiftLeft = undefined;
      if (typeof shift === 'string') {
        shift = shift.split(' ');
        shift[1] = shift[1] || shift[0];

        var _shift = shift;

        var _shift2 = _slicedToArray(_shift, 2);

        shiftTop = _shift2[0];
        shiftLeft = _shift2[1];

        shiftTop = parseFloat(shiftTop, 10);
        shiftLeft = parseFloat(shiftLeft, 10);
      } else {
        shiftTop = shift.top;
        shiftLeft = shift.left;
      }

      top += shiftTop;
      left += shiftLeft;

      return { top: top, left: left };
    }
  });
  return Tether;
});

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

function E() {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function on(name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function once(name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function emit(name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function off(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    liveEvents.length ? e[name] = liveEvents : delete e[name];

    return this;
  }
};

module.exports = E;

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(2791);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */

      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(2789);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(134);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = writtenNumber;
var util = __webpack_require__(2793);

var languages = ["en", "es", "ar", "pt", "fr", "eo", "it", "vi", "tr", "uk", "id"];
var i18n = {
  en: __webpack_require__(3663),
  es: __webpack_require__(3665),
  ar: __webpack_require__(3661),
  pt: __webpack_require__(3671),
  ptPT: __webpack_require__(3670),
  fr: __webpack_require__(3666),
  eo: __webpack_require__(3664),
  it: __webpack_require__(3669),
  vi: __webpack_require__(3674),
  tr: __webpack_require__(3672),
  hu: __webpack_require__(3667),
  enIndian: __webpack_require__(3662),
  uk: __webpack_require__(3673),
  id: __webpack_require__(3668)
};
exports.i18n = i18n;

var shortScale = [100];
for (var i = 1; i <= 16; i++) {
  shortScale.push(Math.pow(10, i * 3));
}

var longScale = [100, 1000];
for (i = 1; i <= 15; i++) {
  longScale.push(Math.pow(10, i * 6));
}

writtenNumber.defaults = {
  noAnd: false,
  alternativeBase: null,
  lang: "en"
};

/**
 * Converts numbers to their written form.
 *
 * @param {Number} n The number to convert
 * @param {Object} [options] An object representation of the options
 * @return {String} writtenN The written form of `n`
 */

function writtenNumber(n, options) {
  options = options || {};
  options = util.defaults(options, writtenNumber.defaults);

  if (n < 0) {
    return "";
  }

  n = Math.round(+n);

  var language = typeof options.lang === "string" ? i18n[options.lang] : options.lang;

  if (!language) {
    if (languages.indexOf(writtenNumber.defaults.lang) < 0) {
      writtenNumber.defaults.lang = "en";
    }

    language = i18n[writtenNumber.defaults.lang];
  }

  var scale = language.useLongScale ? longScale : shortScale;
  var units = language.units;
  var unit;

  if (!(units instanceof Array)) {
    var rawUnits = units;

    units = [];
    scale = Object.keys(rawUnits);

    for (var i in scale) {
      units.push(rawUnits[scale[i]]);
      scale[i] = Math.pow(10, parseInt(scale[i]));
    }
  }

  var baseCardinals = language.base;
  var alternativeBaseCardinals = options.alternativeBase ? language.alternativeBase[options.alternativeBase] : {};

  if (language.unitExceptions[n]) return language.unitExceptions[n];
  if (alternativeBaseCardinals[n]) return alternativeBaseCardinals[n];
  if (baseCardinals[n]) return baseCardinals[n];
  if (n < 100) return handleSmallerThan100(n, language, unit, baseCardinals, alternativeBaseCardinals, options);

  var m = n % 100;
  var ret = [];

  if (m) {
    if (options.noAnd && !(language.andException && language.andException[10])) {
      ret.push(writtenNumber(m, options));
    } else {
      ret.push(language.unitSeparator + writtenNumber(m, options));
    }
  }

  var firstSignificant;

  for (var i = 0, len = units.length; i < len; i++) {
    var r = Math.floor(n / scale[i]);
    var divideBy;

    if (i === len - 1) divideBy = 1000000;else divideBy = scale[i + 1] / scale[i];

    r %= divideBy;

    unit = units[i];

    if (!r) continue;
    firstSignificant = scale[i];

    if (unit.useBaseInstead) {
      var shouldUseBaseException = unit.useBaseException.indexOf(r) > -1 && (unit.useBaseExceptionWhenNoTrailingNumbers ? i === 0 && ret.length : true);
      if (!shouldUseBaseException) {
        ret.push(alternativeBaseCardinals[r * scale[i]] || baseCardinals[r * scale[i]]);
      } else {
        ret.push(r > 1 && unit.plural ? unit.plural : unit.singular);
      }
      continue;
    }

    var str;
    if (typeof unit === "string") {
      str = unit;
    } else if (r === 1 || unit.useSingularEnding && r % 10 === 1 && (!unit.avoidEndingRules || unit.avoidEndingRules.indexOf(r) < 0)) {
      str = unit.singular;
    } else if (unit.few && (r > 1 && r < 5 || unit.useFewEnding && r % 10 > 1 && r % 10 < 5 && (!unit.avoidEndingRules || unit.avoidEndingRules.indexOf(r) < 0))) {
      str = unit.few;
    } else {
      str = unit.plural && (!unit.avoidInNumberPlural || !m) ? unit.plural : unit.singular;

      // Languages with dual
      str = r === 2 && unit.dual ? unit.dual : str;

      // "restrictedPlural" : use plural only for 3 to 10
      str = r > 10 && unit.restrictedPlural ? unit.singular : str;
    }

    if (unit.avoidPrefixException && unit.avoidPrefixException.indexOf(r) > -1) {
      ret.push(str);
      continue;
    }

    var exception = language.unitExceptions[r];
    var number = exception || writtenNumber(r, util.defaults({
      // Languages with and exceptions need to set `noAnd` to false
      noAnd: !(language.andException && language.andException[r] || unit.andException) && true,
      alternativeBase: unit.useAlternativeBase
    }, options));
    n -= r * scale[i];
    ret.push(number + " " + str);
  }

  var firstSignificantN = firstSignificant * Math.floor(n / firstSignificant);
  var rest = n - firstSignificantN;

  if (language.andWhenTrailing && firstSignificant && 0 < rest && ret[0].indexOf(language.unitSeparator) !== 0) {
    ret = [ret[0], language.unitSeparator.replace(/\s+$/, "")].concat(ret.slice(1));
  }

  // Languages that have separators for all cardinals.
  if (language.allSeparator) {
    for (var j = 0; j < ret.length - 1; j++) {
      ret[j] = language.allSeparator + ret[j];
    }
  }
  var result = ret.reverse().join(" ");
  return result;
}

function handleSmallerThan100(n, language, unit, baseCardinals, alternativeBaseCardinals, options) {
  var dec = Math.floor(n / 10) * 10;
  unit = n - dec;
  if (unit) {
    return alternativeBaseCardinals[dec] || baseCardinals[dec] + language.baseSeparator + writtenNumber(unit, options);
  }
  return alternativeBaseCardinals[dec] || baseCardinals[dec];
}

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Merges a set of default keys with a target object
 * (Like _.defaults, but will also extend onto null/undefined)
 *
 * @param {Object} [target] The object to extend
 * @param {Object} defaults The object to default to
 * @return {Object} extendedTarget
 */

function defaults(target, defs) {
  if (target == null) target = {};
  var ret = {};
  var keys = Object.keys(defs);
  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    ret[key] = target[key] || defs[key];
  }
  return ret;
}
exports.defaults = defaults;

/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountInfoFields__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_timezones__ = __webpack_require__(827);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AccountInfo = function (_React$Component) {
  _inherits(AccountInfo, _React$Component);

  function AccountInfo(props) {
    _classCallCheck(this, AccountInfo);

    var _this = _possibleConstructorReturn(this, (AccountInfo.__proto__ || Object.getPrototypeOf(AccountInfo)).call(this, props));

    _this.state = {
      user: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.viewer),
      submitted: false
    };
    _this.onFieldChange = _this.onFieldChange.bind(_this);
    _this.resetUser = _this.resetUser.bind(_this);
    _this.updateUser = _this.updateUser.bind(_this);
    return _this;
  }

  _createClass(AccountInfo, [{
    key: 'onFieldChange',
    value: function onFieldChange(e, name) {
      this.setState({ user: _extends({}, this.state.user, _defineProperty({}, name, e.target.value)) });
    }
  }, {
    key: 'resetUser',
    value: function resetUser(callback) {
      this.setState({ user: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.viewer) }, callback);
    }
  }, {
    key: 'updateUser',
    value: function updateUser(successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update account information',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated account information',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
      };

      // Set default title if null
      var localUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.user);

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2821);
      });

      var user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(localUser, ['id', 'first_name', 'last_name', 'company_name', 's_time_zone']);
      var optimisticResponse = { updateUser: { user: user } };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, user)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var viewer = this.props.viewer;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
        {
          desktop: __WEBPACK_IMPORTED_MODULE_6__AccountInfoFields__["a" /* default */],
          mobile: __WEBPACK_IMPORTED_MODULE_6__AccountInfoFields__["a" /* default */],
          localUser: this.state.user,
          onFieldChange: this.onFieldChange,
          reset: this.resetUser,
          commitUpdate: this.updateUser
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          viewer.first_name && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              'First Name'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            viewer.first_name
          ),
          viewer.last_name && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              'Last Name'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            viewer.last_name
          ),
          viewer.company_name && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              'Company Name'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            viewer.company_name
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              'Time Zone'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_7__lib_utils_timezones__["b" /* i18n */][viewer.s_time_zone] || viewer.s_time_zone
          )
        )
      );
    }
  }]);

  return AccountInfo;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AccountInfo.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AccountInfo);

/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AccountInfoFields = function (_React$Component) {
  _inherits(AccountInfoFields, _React$Component);

  function AccountInfoFields(props) {
    _classCallCheck(this, AccountInfoFields);

    var _this = _possibleConstructorReturn(this, (AccountInfoFields.__proto__ || Object.getPrototypeOf(AccountInfoFields)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.reset = _this.reset.bind(_this);
    return _this;
  }

  _createClass(AccountInfoFields, [{
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.props.commitUpdate(this.props.closeHandler);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update account information',
        intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.props.reset(this.props.closeHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          localUser = _props.localUser,
          onFieldChange = _props.onFieldChange;
      var submitted = this.state.submitted;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_formsy_react___default.a.Form,
          {
            onValidSubmit: this.onValidSubmit,
            onInvalidSubmit: this.onInvalidSubmit,
            ref: 'form'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
            name: 'first_name',
            label: 'First Name',
            value: localUser.first_name,
            onChange: function onChange(e) {
              return onFieldChange(e, 'first_name');
            },
            required: true,
            submitted: submitted,
            validationError: 'First name is required'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
            name: 'last_name',
            label: 'Last Name',
            value: localUser.last_name,
            onChange: function onChange(e) {
              return onFieldChange(e, 'last_name');
            },
            required: true,
            submitted: submitted,
            validationError: 'Last name is required'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
            name: 'company_name',
            label: 'Company Name',
            value: localUser.company_name,
            onChange: function onChange(e) {
              return onFieldChange(e, 'company_name');
            },
            required: true,
            submitted: submitted,
            validationError: 'Company name is required'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["u" /* FloatingLabelTZSelect */], {
            name: 's_time_zone',
            label: 'Time Zone',
            value: localUser.s_time_zone,
            onChange: function onChange(e) {
              return onFieldChange(e, 's_time_zone');
            },
            required: true,
            submitted: submitted,
            validationError: 'Time Zone is required'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules__["j" /* DthcActions */], { save: function save() {
            return _this2.refs.form.submit();
          }, reset: this.reset })
      );
    }
  }]);

  return AccountInfoFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AccountInfoFields.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  localUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AccountInfoFields);

/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppComponent__ = __webpack_require__(526);


// import AvailabilityCheckerContainer from '../Modules/AvailabilityChecker/AvailabilityCheckerContainer';
// import AvailabilityCalendarContainer from '../Modules/AvailabilityCalendar/AvailabilityCalendarContainer';

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__AppComponent__["b" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2823);
  }
}));

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_png__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OptionsMenu__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      lastMounted: new Date()
    };
    _this.transition = _this.transition.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: 'transition',
    value: function transition(e) {
      e.preventDefault();
      this.props.router.push(e.target.getAttribute('to') || '/');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _$omit = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'router'),
          viewer = _$omit.viewer,
          rest = _objectWithoutProperties(_$omit, ['viewer']);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
        _extends({
          padded: true,
          style: {
            boxShadow: '0px 1px 3px 0px #DEDEDF, 0px 0px 0px 1px #DEDEDF',
            padding: '0 2em'
          },
          verticalAlign: 'middle',
          className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.header
        }, rest),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          {
            only: 'computer',
            style: { padding: '0.325em 0 0.325em 0', minHeight: '48px' }
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { floated: 'left', style: { width: '220px' } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { to: '/', onClick: this.transition },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["e" /* Image */], { src: __WEBPACK_IMPORTED_MODULE_3__assets_logo_png___default.a, style: { height: '22px' } })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            {
              style: { flex: 2, height: '100%', position: 'relative' }
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { style: { position: 'absolute', width: '100%' } },
              this.props.viewer && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                  primary: true,
                  size: 'small',
                  content: 'Add Event',
                  to: '/events/new',
                  onClick: this.transition
                }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["o" /* Menu */],
                  { text: true, compact: true, style: { marginLeft: '2em' } },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["o" /* Menu */].Item, {
                    name: 'All Events',
                    to: '/',
                    onClick: this.transition,
                    active: location.pathname.match(/^\/$/) !== null,
                    className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.headerMenuItem
                  }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["o" /* Menu */].Item, {
                    name: 'Calendar',
                    to: '/calendar',
                    onClick: this.transition,
                    active: location.pathname.match(/^\/calendar(\/(.)*)?$/) !== null,
                    className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.headerMenuItem
                  }),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
                    {
                      item: true,
                      text: 'More',
                      className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.headerMenuItem
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Menu,
                      null,
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
                        {
                          to: '/pipelines',
                          onClick: this.transition,
                          active: location.pathname.match(/^\/pipelines(\/(.)*)?$/) !== null
                        },
                        'Pipeline'
                      ),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
                        {
                          to: '/financials',
                          onClick: this.transition,
                          active: location.pathname.match(/^\/financials(\/(.)*)?$/) !== null
                        },
                        'Financials'
                      )
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { style: { flex: 1 }, floated: 'right', textAlign: 'right' },
            this.props.viewer && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'a',
                {
                  className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.searchIcon,
                  onClick: function onClick() {
                    return _this2.props.router.push('/search');
                  }
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["n" /* AvailabilityChecker */], { viewer: viewer }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OptionsMenu__["a" /* default */], { viewer: viewer, router: this.props.router })
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Header.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NewPlaylist = function (_Component) {
  _inherits(NewPlaylist, _Component);

  function NewPlaylist(props) {
    _classCallCheck(this, NewPlaylist);

    var _this = _possibleConstructorReturn(this, (NewPlaylist.__proto__ || Object.getPrototypeOf(NewPlaylist)).call(this, props));

    _this.state = {
      title: ''
    };
    _this.onOpen = _this.onOpen.bind(_this);
    _this.onTitleChange = _this.onTitleChange.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.createPlaylist = _this.createPlaylist.bind(_this);
    return _this;
  }

  _createClass(NewPlaylist, [{
    key: 'onOpen',
    value: function onOpen() {
      this.setState({ title: '' });
    }
  }, {
    key: 'onTitleChange',
    value: function onTitleChange(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit(model, resetForm, invalidateForm, successCb) {
      this.createPlaylist(model, successCb);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add playlist',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'createPlaylist',
    value: function createPlaylist(playlist, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        if (successCb) successCb();
        _this2.props.openPlaylist(response.createPlaylist.new_playlist_edge.node.id);
        __WEBPACK_IMPORTED_MODULE_2__Modules__["c" /* Analytics */].trackEvent('created-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2824);
      });

      var parentID = this.props.viewer.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_playlist_edge',
        connectionInfo: [{
          key: 'PlaylistsContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'PlannerPlaylistContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'MpTemplateContainer_playlists',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            title: playlist.title
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var trigger = this.props.trigger;
      var title = this.state.title;

      var content = function content() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
            autoFocus: true,
            name: 'title',
            onChange: _this3.onTitleChange,
            value: title,
            required: true,
            label: 'Playlist Title',
            placeholder: 'Wedding Dance Hits',
            validationError: 'Title is required'
          })
        );
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["e" /* Wizard */], {
          onOpen: this.onOpen,
          steps: [{
            component: content,
            title: 'Add Playlist',
            actions: {
              primary: {
                content: 'Create Playlist',
                disabled: title === '',
                type: 'submit'
              }
            },
            formProps: {
              onValidSubmit: this.onValidSubmit,
              onInvalidSubmit: this.onInvalidSubmit
            }
          }],
          trigger: trigger
        })
      );
    }
  }]);

  return NewPlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

NewPlaylist.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  openPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (NewPlaylist);

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 47a0bac0800637bb5a1ceffee5de7cac
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateCashPaymentMethodInput = {
  clientMutationId?: ?string,
  user_id: string,
  instructions: string,
  enabled: boolean,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_CreateCashPaymentMethodMutationVariables = {|
  input: CreateCashPaymentMethodInput
|};
export type AcceptedPaymentMethods_CreateCashPaymentMethodMutationResponse = {|
  +createCashPaymentMethod: ?{|
    +cash_payment_method: ?{|
      +id: string,
      +enabled: ?boolean,
      +instructions: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
    +user: ?{|
      +payment_methods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?({|
            +__typename: "CashPaymentMethod",
            +id: string,
            +instructions: ?string,
            +enabled: ?boolean,
          |} | {|
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            +__typename: "%other"
          |})
        |}>
      |}
    |},
  |}
|};
export type AcceptedPaymentMethods_CreateCashPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_CreateCashPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_CreateCashPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_CreateCashPaymentMethodMutation(
  $input: CreateCashPaymentMethodInput!
) {
  createCashPaymentMethod(input: $input) {
    cash_payment_method {
      id
      enabled
      instructions
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
    user {
      payment_methods {
        edges {
          node {
            __typename
            ... on CashPaymentMethod {
              __typename
              id
              instructions
              enabled
            }
            ... on Node {
              id
            }
          }
        }
      }
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCashPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateCashPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "cash_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CashPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v6, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_CreateCashPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_CreateCashPaymentMethodMutation(\n  $input: CreateCashPaymentMethodInput!\n) {\n  createCashPaymentMethod(input: $input) {\n    cash_payment_method {\n      id\n      enabled\n      instructions\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n    user {\n      payment_methods {\n        edges {\n          node {\n            __typename\n            ... on CashPaymentMethod {\n              __typename\n              id\n              instructions\n              enabled\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_CreateCashPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCashPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCashPaymentMethodPayload",
        "plural": false,
        "selections": [v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [{
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v6, v2, v4, v3]
                }]
              }]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_CreateCashPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCashPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCashPaymentMethodPayload",
        "plural": false,
        "selections": [v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v7, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v6, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v3, v8, v4]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v3, v4]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v7, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v6]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v7, v6]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v6, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v6, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v6, v10, v11, v17, v14, v12, v8, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v6, v2, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v6, v4, v3]
                }]
              }]
            }]
          }, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9f80fcdfcbd08dcf08a30b003ffbc518';
module.exports = node;

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 116f642ac1cb972e6d550c5044d65ed6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateCheckPaymentMethodInput = {
  clientMutationId?: ?string,
  user_id: string,
  address: string,
  pay_to: string,
  enabled: boolean,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutationVariables = {|
  input: CreateCheckPaymentMethodInput
|};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutationResponse = {|
  +createCheckPaymentMethod: ?{|
    +check_payment_method: ?{|
      +id: string,
      +address: ?string,
      +enabled: ?boolean,
      +pay_to: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
    +user: ?{|
      +payment_methods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?({|
            +__typename: "CheckPaymentMethod",
            +id: string,
            +address: ?string,
            +enabled: ?boolean,
            +pay_to: ?string,
          |} | {|
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            +__typename: "%other"
          |})
        |}>
      |}
    |},
  |}
|};
export type AcceptedPaymentMethods_CreateCheckPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_CreateCheckPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_CreateCheckPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_CreateCheckPaymentMethodMutation(
  $input: CreateCheckPaymentMethodInput!
) {
  createCheckPaymentMethod(input: $input) {
    check_payment_method {
      id
      address
      enabled
      pay_to
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
    user {
      payment_methods {
        edges {
          node {
            __typename
            ... on CheckPaymentMethod {
              __typename
              id
              address
              enabled
              pay_to
            }
            ... on Node {
              id
            }
          }
        }
      }
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCheckPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateCheckPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "pay_to",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "check_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CheckPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4, v5]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v14 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v11, v12, v15, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v21 = [v7, v11, v12, v18, v15, v13, v19, v20];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_CreateCheckPaymentMethodMutation(\n  $input: CreateCheckPaymentMethodInput!\n) {\n  createCheckPaymentMethod(input: $input) {\n    check_payment_method {\n      id\n      address\n      enabled\n      pay_to\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n    user {\n      payment_methods {\n        edges {\n          node {\n            __typename\n            ... on CheckPaymentMethod {\n              __typename\n              id\n              address\n              enabled\n              pay_to\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [{
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v7, v2, v3, v4, v5]
                }]
              }]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_CreateCheckPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v8, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v4, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v4, v9, v10]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v3, v4, v5]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v4, v10]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v11, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v13]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v14,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v15, v7]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v14,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v14,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v8, v7]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v14,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v7, v11, v12, v18, v19, v20]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v7, v11, v12, v18, v15, v13, v9, v19, v20]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v21
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v21
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v3, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v7, v3, v4, v5]
                }]
              }]
            }]
          }, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '689baa35bdee9a91373f3126a535df9c';
module.exports = node;

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 849ff33e90330ba04196fec35225145a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateCustomPaymentMethodInput = {
  clientMutationId?: ?string,
  user_id: string,
  instructions: string,
  enabled: boolean,
  label: string,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_CreateCustomPaymentMethodMutationVariables = {|
  input: CreateCustomPaymentMethodInput
|};
export type AcceptedPaymentMethods_CreateCustomPaymentMethodMutationResponse = {|
  +createCustomPaymentMethod: ?{|
    +custom_payment_method: ?{|
      +__typename: string,
      +id: string,
      +enabled: ?boolean,
      +label: ?string,
      +instructions: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
    +user: ?{|
      +payment_methods: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?({|
            +__typename: "CustomPaymentMethod",
            +id: string,
            +instructions: ?string,
            +label: ?string,
            +enabled: ?boolean,
          |} | {|
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            +__typename: "%other"
          |})
        |}>
      |}
    |},
  |}
|};
export type AcceptedPaymentMethods_CreateCustomPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_CreateCustomPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_CreateCustomPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_CreateCustomPaymentMethodMutation(
  $input: CreateCustomPaymentMethodInput!
) {
  createCustomPaymentMethod(input: $input) {
    custom_payment_method {
      __typename
      id
      enabled
      label
      instructions
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
    user {
      payment_methods {
        edges {
          node {
            __typename
            ... on CustomPaymentMethod {
              __typename
              id
              instructions
              label
              enabled
            }
            ... on Node {
              id
            }
          }
        }
      }
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCustomPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateCustomPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "custom_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CustomPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4, v5, v6]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v3, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v2, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_CreateCustomPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_CreateCustomPaymentMethodMutation(\n  $input: CreateCustomPaymentMethodInput!\n) {\n  createCustomPaymentMethod(input: $input) {\n    custom_payment_method {\n      __typename\n      id\n      enabled\n      label\n      instructions\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n    user {\n      payment_methods {\n        edges {\n          node {\n            __typename\n            ... on CustomPaymentMethod {\n              __typename\n              id\n              instructions\n              label\n              enabled\n            }\n            ... on Node {\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_CreateCustomPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCustomPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCustomPaymentMethodPayload",
        "plural": false,
        "selections": [v7, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [{
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v2, v3, v6, v5, v4]
                }]
              }]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_CreateCustomPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createCustomPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateCustomPaymentMethodPayload",
        "plural": false,
        "selections": [v7, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v8, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v4, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v4, v5, v6]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v4, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v4, v6]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v2]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v8, v2]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v2, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v2, v10, v11, v17, v14, v12, v5, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v2, v6, v5, v4]
                }]
              }]
            }]
          }, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '801b1ed1c0932521bc65b9ac18613f0e';
module.exports = node;

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash cd6bab351795be8774771f5c15bff42c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type UpdateCashPaymentMethodInput = {
  clientMutationId?: ?string,
  id: string,
  instructions?: ?string,
  enabled?: ?boolean,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_UpdateCashPaymentMethodMutationVariables = {|
  input: UpdateCashPaymentMethodInput
|};
export type AcceptedPaymentMethods_UpdateCashPaymentMethodMutationResponse = {|
  +updateCashPaymentMethod: ?{|
    +cash_payment_method: ?{|
      +id: string,
      +enabled: ?boolean,
      +instructions: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
  |}
|};
export type AcceptedPaymentMethods_UpdateCashPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_UpdateCashPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_UpdateCashPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_UpdateCashPaymentMethodMutation(
  $input: UpdateCashPaymentMethodInput!
) {
  updateCashPaymentMethod(input: $input) {
    cash_payment_method {
      id
      enabled
      instructions
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCashPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCashPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "cash_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CashPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v7, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_UpdateCashPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_UpdateCashPaymentMethodMutation(\n  $input: UpdateCashPaymentMethodInput!\n) {\n  updateCashPaymentMethod(input: $input) {\n    cash_payment_method {\n      id\n      enabled\n      instructions\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_UpdateCashPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCashPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCashPaymentMethodPayload",
        "plural": false,
        "selections": [v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_UpdateCashPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCashPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCashPaymentMethodPayload",
        "plural": false,
        "selections": [v5, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v6, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v3, v8, v4]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v3, v4]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v7]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v6, v7]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v7, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v7, v10, v11, v17, v14, v12, v8, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd9137af61a2da7fe0b32bad60e7eac7e';
module.exports = node;

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c1790c888c5846e9675979c3b11ff6b5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type UpdateCheckPaymentMethodInput = {
  clientMutationId?: ?string,
  id: string,
  address?: ?string,
  pay_to?: ?string,
  enabled?: ?boolean,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_UpdateCheckPaymentMethodMutationVariables = {|
  input: UpdateCheckPaymentMethodInput
|};
export type AcceptedPaymentMethods_UpdateCheckPaymentMethodMutationResponse = {|
  +updateCheckPaymentMethod: ?{|
    +check_payment_method: ?{|
      +id: string,
      +address: ?string,
      +enabled: ?boolean,
      +pay_to: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
  |}
|};
export type AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_UpdateCheckPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_UpdateCheckPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation(
  $input: UpdateCheckPaymentMethodInput!
) {
  updateCheckPaymentMethod(input: $input) {
    check_payment_method {
      id
      address
      enabled
      pay_to
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCheckPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCheckPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "pay_to",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "check_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CheckPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4, v5]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v14 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v11, v12, v15, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v21 = [v8, v11, v12, v18, v15, v13, v19, v20];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation(\n  $input: UpdateCheckPaymentMethodInput!\n) {\n  updateCheckPaymentMethod(input: $input) {\n    check_payment_method {\n      id\n      address\n      enabled\n      pay_to\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_UpdateCheckPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCheckPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCheckPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v7, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v8, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v4, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v4, v9, v10]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v3, v4, v5]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v4, v10]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v11, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v13]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v14,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v7, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v15, v8]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v14,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v14,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v7, v8]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v14,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v8, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v8, v11, v12, v18, v19, v20]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v8, v11, v12, v18, v15, v13, v9, v19, v20]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v21
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v21
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v3, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '10d45af34cd7f5a0db7407e53f8a2a54';
module.exports = node;

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0a8171680599cb564116524c12ba801e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type UpdateCustomPaymentMethodInput = {
  clientMutationId?: ?string,
  id: string,
  instructions?: ?string,
  enabled?: ?boolean,
  label?: ?string,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_UpdateCustomPaymentMethodMutationVariables = {|
  input: UpdateCustomPaymentMethodInput
|};
export type AcceptedPaymentMethods_UpdateCustomPaymentMethodMutationResponse = {|
  +updateCustomPaymentMethod: ?{|
    +custom_payment_method: ?{|
      +id: string,
      +enabled: ?boolean,
      +label: ?string,
      +instructions: ?string,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
  |}
|};
export type AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_UpdateCustomPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_UpdateCustomPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation(
  $input: UpdateCustomPaymentMethodInput!
) {
  updateCustomPaymentMethod(input: $input) {
    custom_payment_method {
      id
      enabled
      label
      instructions
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCustomPaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "custom_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "CustomPaymentMethod",
    "plural": false,
    "selections": [v2, v3, v4, v5]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v8, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation(\n  $input: UpdateCustomPaymentMethodInput!\n) {\n  updateCustomPaymentMethod(input: $input) {\n    custom_payment_method {\n      id\n      enabled\n      label\n      instructions\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCustomPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_UpdateCustomPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomPaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCustomPaymentMethodPayload",
        "plural": false,
        "selections": [v6, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v7, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v8, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v3, v4, v5]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v3, v5]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v7, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v8]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v7, v8]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v8, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v8, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v8, v10, v11, v17, v14, v12, v4, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f6edbdad961b7eb10bae394bd347b275';
module.exports = node;

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9851f633405741e436e8b503c8199910
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type UpdateSquarePaymentMethodInput = {
  clientMutationId?: ?string,
  id: string,
  enabled?: ?boolean,
  square_location_id?: ?string,
  invoice_id?: ?string,
};
export type AcceptedPaymentMethods_UpdateSquarePaymentMethodMutationVariables = {|
  input: UpdateSquarePaymentMethodInput
|};
export type AcceptedPaymentMethods_UpdateSquarePaymentMethodMutationResponse = {|
  +updateSquarePaymentMethod: ?{|
    +square_payment_method: ?{|
      +id: string,
      +enabled: ?boolean,
    |},
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
  |}
|};
export type AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_UpdateSquarePaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_UpdateSquarePaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation(
  $input: UpdateSquarePaymentMethodInput!
) {
  updateSquarePaymentMethod(input: $input) {
    square_payment_method {
      id
      enabled
    }
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateSquarePaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateSquarePaymentMethodInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "square_payment_method",
    "storageKey": null,
    "args": null,
    "concreteType": "SquarePaymentMethod",
    "plural": false,
    "selections": [v2, v3]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v6, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation(\n  $input: UpdateSquarePaymentMethodInput!\n) {\n  updateSquarePaymentMethod(input: $input) {\n    square_payment_method {\n      id\n      enabled\n    }\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateSquarePaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateSquarePaymentMethodPayload",
        "plural": false,
        "selections": [v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_UpdateSquarePaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateSquarePaymentMethod",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateSquarePaymentMethodPayload",
        "plural": false,
        "selections": [v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v6, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v3, v7, v8]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v3, v8]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v6]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v5, v6]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v6, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v6, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v6, v10, v11, v17, v14, v12, v7, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '509b3a4c6442c636e9b9960394e2d315';
module.exports = node;

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0701a9cc657bd1706b34e9299103690a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomPaymentMethodInput = {
  clientMutationId?: ?string,
  id: string,
};
export type AcceptedPaymentMethods_deleteCustomPaymentMethodMutationVariables = {|
  input: DeleteCustomPaymentMethodInput
|};
export type AcceptedPaymentMethods_deleteCustomPaymentMethodMutationResponse = {|
  +deleteCustomPaymentMethod: ?{|
    +deletedCustomPaymentMethodId: ?string
  |}
|};
export type AcceptedPaymentMethods_deleteCustomPaymentMethodMutation = {|
  variables: AcceptedPaymentMethods_deleteCustomPaymentMethodMutationVariables,
  response: AcceptedPaymentMethods_deleteCustomPaymentMethodMutationResponse,
|};
*/

/*
mutation AcceptedPaymentMethods_deleteCustomPaymentMethodMutation(
  $input: DeleteCustomPaymentMethodInput!
) {
  deleteCustomPaymentMethod(input: $input) {
    deletedCustomPaymentMethodId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCustomPaymentMethodInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCustomPaymentMethod",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteCustomPaymentMethodInput!"
    }],
    "concreteType": "DeleteCustomPaymentMethodPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedCustomPaymentMethodId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AcceptedPaymentMethods_deleteCustomPaymentMethodMutation",
    "id": null,
    "text": "mutation AcceptedPaymentMethods_deleteCustomPaymentMethodMutation(\n  $input: DeleteCustomPaymentMethodInput!\n) {\n  deleteCustomPaymentMethod(input: $input) {\n    deletedCustomPaymentMethodId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AcceptedPaymentMethods_deleteCustomPaymentMethodMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "AcceptedPaymentMethods_deleteCustomPaymentMethodMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '104e67bbec82568e827337064fc7a704';
module.exports = node;

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserPlaylistQuery__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewPlaylist__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Playlist_Preview__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Playlists = function (_Component) {
  _inherits(Playlists, _Component);

  function Playlists(props) {
    _classCallCheck(this, Playlists);

    var _this = _possibleConstructorReturn(this, (Playlists.__proto__ || Object.getPrototypeOf(Playlists)).call(this, props));

    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.openPlaylist = _this.openPlaylist.bind(_this);
    _this.getSelectedPlaylist = _this.getSelectedPlaylist.bind(_this);
    _this.deletePlaylist = _this.deletePlaylist.bind(_this);
    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Playlists, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.viewer.playlists.edges.length !== this.props.viewer.playlists.edges.length) {
        this.setState({ selectedPlaylistId: undefined });
      }
    }
  }, {
    key: 'onOpen',
    value: function onOpen() {
      this.setState({ open: true });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({ open: false, selectedPlaylistId: undefined });
    }
  }, {
    key: 'getSelectedPlaylist',
    value: function getSelectedPlaylist() {
      var _this2 = this;

      var filtered = this.props.viewer.playlists.edges.filter(function (p) {
        return p.node.id === _this2.state.selectedPlaylistId;
      });
      return filtered.length > 0 ? filtered[0].node : null;
    }
  }, {
    key: 'openPlaylist',
    value: function openPlaylist(id) {
      this.setState({ selectedPlaylistId: id, open: true });
    }
  }, {
    key: 'deletePlaylist',
    value: function deletePlaylist() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete playlist',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this3.onClose();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2826);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.viewer.id,
        pathToConnection: ['viewer', 'playlists'],
        deletedIDFieldName: 'deletedPlaylistId',
        connectionKeys: [{
          key: 'PlaylistsContainer_playlists',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.getSelectedPlaylist().id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          relay = _props.relay,
          viewer = _props.viewer;
      var open = this.state.open;


      var AddPlaylistButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
        primary: true,
        icon: 'plus',
        labelPosition: 'left',
        content: 'Add Playlist'
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
              {
                open: open,
                size: 'small',
                onClose: _this4.onClose,
                closeOnEscape: false,
                closeIcon: true
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Header, { content: 'View Playlist' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
                null,
                _this4.getSelectedPlaylist() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserPlaylistQuery__["a" /* default */], {
                  playlistId: _this4.getSelectedPlaylist().id,
                  relay: relay,
                  deletePlaylist: _this4.deletePlaylist
                })
              )
            ),
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
              {
                open: open,
                onClose: _this4.onClose
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
                null,
                _this4.getSelectedPlaylist() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserPlaylistQuery__["a" /* default */], {
                  playlistId: _this4.getSelectedPlaylist().id,
                  relay: relay,
                  goBack: _this4.onClose,
                  deletePlaylist: _this4.deletePlaylist
                })
              )
            ),
            viewer.playlists.edges.map(function (_ref2, index) {
              var playlist = _ref2.node;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Playlist_Preview__["a" /* default */], {
                playlist: playlist,
                key: index,
                following: !playlist.can_edit,
                openPlaylist: _this4.openPlaylist
              });
            }),
            viewer.playlists.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center', padding: '2em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                'You have no saved playlists'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NewPlaylist__["a" /* default */], {
                viewer: viewer,
                relay: relay,
                openPlaylist: _this4.openPlaylist,
                trigger: AddPlaylistButton
              })
            ),
            viewer.playlists.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NewPlaylist__["a" /* default */], {
              viewer: viewer,
              relay: relay,
              openPlaylist: _this4.openPlaylist,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                null,
                '+ Add Playlist'
              )
            })
          );
        }
      );
    }
  }]);

  return Playlists;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Playlists.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Playlists);

/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Playlists__ = __webpack_require__(2807);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__Playlists__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2825);
  }
}));

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_List_EventList_scss__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_List_EventList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Event_List_EventList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_stylesheets_ExpandCollapseTransition_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_stylesheets_ExpandCollapseTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__lib_stylesheets_ExpandCollapseTransition_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SearchPageComponent = (_temp = _class = function (_React$Component) {
  _inherits(SearchPage, _React$Component);

  function SearchPage(props) {
    _classCallCheck(this, SearchPage);

    var _this = _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).call(this, props));

    _this.searchChange = _this.searchChange.bind(_this);
    return _this;
  }

  _createClass(SearchPage, [{
    key: 'setQuery',
    value: function setQuery(key, value) {
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      query[key] = value;
      this.props.router.replace({ pathname: pathname, query: query });
    }
  }, {
    key: 'searchChange',
    value: function searchChange(e) {
      this.setQuery('q', e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          location = _props.location,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;
      var q = location.query.q;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6__Event_List_EventList_scss___default.a.scrollContainer },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__["a" /* default */],
          { viewer: viewer, showSearch: false, router: router },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["C" /* Item */],
              { as: 'a', onClick: function onClick() {
                  return router.go(-1);
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                className: '' + (sidebarOpen ? 'active ' : ''),
                onClick: toggleSidebar
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { container: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { style: { paddingBottom: '2em' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                null,
                'Search'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                  fluid: true,
                  value: q || '',
                  name: 'q',
                  autoFocus: true,
                  placeholder: 'Search by event name, contact, venue, or phone number...',
                  onChange: this.searchChange,
                  icon: {
                    name: q === '' ? 'search' : 'close',
                    onClick: function onClick() {
                      return _this2.searchChange({ target: { value: '' } });
                    },
                    link: true
                  }
                })
              )
            )
          ),
          children
        )
      );
    }
  }]);

  return SearchPage;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__App_Authenticate__["a" /* default */])(SearchPageComponent)));

/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchPage__ = __webpack_require__(2809);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__SearchPage__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2813);
  }
}));

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Event_List_EventCard__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_waypoint__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SearchResultsComponent = (_temp = _class = function (_React$Component) {
  _inherits(SearchResults, _React$Component);

  function SearchResults(props) {
    _classCallCheck(this, SearchResults);

    var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));

    _this.state = {
      listSize: 10,
      loading: false
    };
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(SearchResults, [{
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(10, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 10 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var timeZone = this.props.viewer.s_time_zone;
      var events = this.props.viewer.user_event_search.edges;
      var query = this.props.location.query;
      var q = query.q;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          null,
          events.map(function (userEvent, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Event_List_EventCard__["a" /* default */], {
              showDateLabel: false,
              event: userEvent.node,
              timeZone: timeZone,
              key: idx,
              index: idx,
              basic: true,
              link: true,
              location: _this3.props.location,
              listSize: _this3.state.listSize,
              relay: _this3.props.relay
            });
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { textAlign: 'center', padding: '2em' } },
            events.length === 0 && q && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                null,
                'We couldn\'t find anything matching your search.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -50 }),
            this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { marginBottom: '2em' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* Loader */], {
                active: true,
                inline: true,
                size: 'tiny',
                style: { marginRight: '1em' }
              }),
              ' ',
              'Loading More...'
            )
          )
        )
      );
    }
  }]);

  return SearchResults;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(SearchResultsComponent));

/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchResults__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_SearchResultsQuery__ = __webpack_require__(1495);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__SearchResults__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2814);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.user_event_search;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return {
      count: count,
      cursor: cursor,
      query: fragmentVariables.query
    };
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_SearchResultsQuery__["a" /* default */]
}));

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type SearchResultsContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchPageContainer_viewer$ref: FragmentReference;
export type SearchPageContainer_viewer = {|
  +id: string,
  +$fragmentRefs: SearchResultsContainer_viewer$ref,
  +$refType: SearchPageContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchPageContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "SearchResultsContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '8fadd6fe64adca874b4afdbe2c2220f6';
module.exports = node;

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchResultsContainer_viewer$ref: FragmentReference;
export type SearchResultsContainer_viewer = {|
  +s_time_zone: ?string,
  +user_event_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +location: ?string
            |}
          |}>
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: SearchResultsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchResultsContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [{
      "count": "count",
      "cursor": "cursor",
      "direction": "forward",
      "path": ["user_event_search"]
    }]
  },
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": ""
  }],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "user_event_search",
    "name": "__SearchResultsContainer_user_event_search_connection",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "query",
      "variableName": "query",
      "type": "String!"
    }],
    "concreteType": "UserEventConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEventEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "booking_status",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "start_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "end_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_segments",
          "storageKey": "user_event_segments(first:1)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }],
          "concreteType": "UserEventSegmentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegmentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegment",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "pageInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "PageInfo",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '780eb8752f76c63677256b3aa7b820c2';
module.exports = node;

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_onclickoutside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_scss__ = __webpack_require__(3606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__search_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SearchComponent = (_temp = _class = function (_React$Component) {
  _inherits(SearchComponent, _React$Component);

  function SearchComponent(props) {
    _classCallCheck(this, SearchComponent);

    var _this = _possibleConstructorReturn(this, (SearchComponent.__proto__ || Object.getPrototypeOf(SearchComponent)).call(this, props));

    _this.state = {
      isLoading: false,
      value: '',
      results: [],
      lastRequest: new Date(),
      cachedQuery: ''
    };
    _this.getBorderClass = _this.getBorderClass.bind(_this);
    _this.handleSearchChange = _this.handleSearchChange.bind(_this);
    _this.handleResultSelect = _this.handleResultSelect.bind(_this);
    return _this;
  }

  _createClass(SearchComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.viewer !== this.props.viewer) {
        this.parseResults(nextProps.viewer.user_event_search.edges);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.activeElement) {
        document.activeElement.blur();
      }
    }
  }, {
    key: 'getBorderClass',
    value: function getBorderClass(status) {
      switch (status) {
        case 'BOOKED':
          return __WEBPACK_IMPORTED_MODULE_7__search_scss___default.a.cardBorderPrimary;
        case 'INITIAL':
          return __WEBPACK_IMPORTED_MODULE_7__search_scss___default.a.cardBorderTentative;
        case 'CANCELED':
          return __WEBPACK_IMPORTED_MODULE_7__search_scss___default.a.cardBorderCanceled;
        default:
          return null;
      }
    }
  }, {
    key: 'getLocation',
    value: function getLocation(result) {
      return result.node.user_event_segments.edges.length > 0 ? result.node.user_event_segments.edges[0].node.location : null;
    }
  }, {
    key: 'getTimes',
    value: function getTimes(result) {
      var valid = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(result.node.start_at).isValid() && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(result.node.end_at).isValid();
      var timeZone = this.props.viewer.s_time_zone;
      var startAt = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(result.node.start_at, timeZone).format('LL');
      var endAt = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(result.node.end_at, timeZone).format('LL');
      return valid ? '' + startAt + (endAt !== startAt ? ' - ' + endAt : '') : '';
    }
  }, {
    key: 'parseResults',
    value: function parseResults(results) {
      var _this2 = this;

      var flattenedResults = results.map(function (result, index) {
        return {
          description: _this2.getTimes(result),
          location: _this2.getLocation(result),
          childKey: index,
          eventId: result.node.event.id,
          title: result.node.event.title,
          bookingStatus: result.node.booking_status
        };
      });
      this.setState({ results: flattenedResults });
    }
  }, {
    key: 'handleSearchChange',
    value: function handleSearchChange(e, data) {
      var _this3 = this;

      this.setState({ value: data.value });
      if (data.value && data.value.length > 0) {
        this.setState({ cachedQuery: data.value, isLoading: true });
        this.trackAnalytics();
        this.props.relay.refetch({ query: data.value }, null, function () {
          return _this3.setState({ isLoading: false });
        });
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      if (this.props.closeHandler) this.props.closeHandler();
    }
  }, {
    key: 'handleResultSelect',
    value: function handleResultSelect(e, data) {
      this.setState({ value: '' });
      if (this.props.handleResultSelect) this.props.handleResultSelect(e, data);
      if (this.props.closeHandler) this.props.closeHandler();
    }
  }, {
    key: 'trackAnalytics',
    value: function trackAnalytics() {
      var _this4 = this;

      if (new Date() - this.state.lastRequest > 5000) {
        this.setState({ lastRequest: new Date() }, function () {
          return setTimeout(function () {
            return __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('searched', { query: _this4.state.cachedQuery });
          }, 5000);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          isLoading = _state.isLoading,
          value = _state.value;


      var resultRenderer = function resultRenderer(_ref) {
        var description = _ref.description,
            bookingStatus = _ref.bookingStatus,
            location = _ref.location,
            title = _ref.title;
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { position: 'relative' } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: _this5.getBorderClass(bookingStatus) }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'title' },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'description' },
            description
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'description' },
            location
          )
        );
      };

      var rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'viewer', 'results', 'relay', 'disableOnClickOutside', 'enableOnClickOutside', 'closeHandler', 'outsideClickIgnoreClass', 'router');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* Search */], _extends({
        autoFocus: true,
        loading: isLoading,
        onSearchChange: this.handleSearchChange,
        onResultSelect: this.handleResultSelect,
        results: this.state.results,
        value: value,
        onFocus: function onFocus(e) {
          return _this5.handleSearchChange(e, e.target.value);
        },
        resultRenderer: resultRenderer,
        placeholder: 'Search...',
        fluid: true,
        className: 'transparent globalHeaderSearch'
      }, rest));
    }
  }]);

  return SearchComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  handleResultSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_onclickoutside___default()(SearchComponent));

/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PaymentMethods_AcceptedPaymentMethods__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AccountInfo__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PlaylistsContainer__ = __webpack_require__(2808);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */
/* eslint-disable new-cap */












var SettingsComponent = (_temp = _class = function (_React$Component) {
  _inherits(SettingsComponent, _React$Component);

  function SettingsComponent() {
    _classCallCheck(this, SettingsComponent);

    return _possibleConstructorReturn(this, (SettingsComponent.__proto__ || Object.getPrototypeOf(SettingsComponent)).apply(this, arguments));
  }

  _createClass(SettingsComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7__Modules__["c" /* Analytics */].trackEvent('viewed-settings');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["s" /* Container */],
        { text: true, className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["t" /* Segment */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            { viewer: viewer, router: router },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                {
                  as: 'a',
                  className: sidebarOpen ? 'active ' : '',
                  onClick: toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
            { padded: true, relaxed: true, stackable: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  { style: { marginBottom: '2em' } },
                  'Settings'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["v" /* Divider */],
                  { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.settingsHeading },
                  'Accepted Payment Methods'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PaymentMethods_AcceptedPaymentMethods__["a" /* default */], { viewer: viewer, relay: relay })
              )
            ),
            viewer.features.music_lists && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              { key: 'heading' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["v" /* Divider */],
                  { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.settingsHeading },
                  'Saved Playlists'
                )
              )
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              { key: 'playlists' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PlaylistsContainer__["a" /* default */], { viewer: viewer, relay: relay })
              )
            )],
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["v" /* Divider */],
                  { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_5__App_scss___default.a.settingsHeading },
                  'User Profile and Billing'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AccountInfo__["a" /* default */], { viewer: viewer, relay: relay }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                  basic: true,
                  style: { marginTop: '2em' },
                  onClick: function onClick() {
                    return Intercom('showNewMessage', 'Hi, I would like to update my subscription.');
                  },
                  content: 'Update or Cancel Subscription'
                })
              )
            )
          )
        )
      );
    }
  }]);

  return SettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Authenticate__["a" /* default */])(SettingsComponent)));

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettingsComponent__ = __webpack_require__(2816);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__SettingsComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(2829);
  }
}));

/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UserPlaylist = function (_Component) {
  _inherits(UserPlaylist, _Component);

  function UserPlaylist(props) {
    _classCallCheck(this, UserPlaylist);

    var _this = _possibleConstructorReturn(this, (UserPlaylist.__proto__ || Object.getPrototypeOf(UserPlaylist)).call(this, props));

    _this.createPlaylistSong = _this.createPlaylistSong.bind(_this);
    _this.deletePlaylistSong = _this.deletePlaylistSong.bind(_this);
    _this.updatePlaylist = _this.updatePlaylist.bind(_this);
    _this.playlistContainsSong = _this.playlistContainsSong.bind(_this);
    return _this;
  }

  _createClass(UserPlaylist, [{
    key: 'playlistContainsSong',
    value: function playlistContainsSong(song) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.node.playlist_songs.edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var playlistSong = _step.value;

          if (playlistSong.node.song.isrc === song.isrc) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'deletePlaylistSong',
    value: function deletePlaylistSong(e, song, parent, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete song',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2835);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.node.id,
        pathToConnection: ['playlist', 'playlist_songs'],
        deletedIDFieldName: 'deletedPlaylistSongId',
        connectionKeys: [{
          key: 'UserPlaylistContainer_playlist_songs',
          rangeBehavior: 'append'
        }, {
          key: 'MusicPlannerContainer_playlist_songs',
          rangeBehavior: 'append'
        }, {
          key: 'PlannerPlaylistContainer_playlist_songs',
          rangeBehavior: 'append'
        }, {
          key: 'MpTemplateContainer_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: parent.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updatePlaylist',
    value: function updatePlaylist(data, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2836);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _defineProperty({
            id: this.props.node.id
          }, data.name, data.value)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPlaylistSong',
    value: function createPlaylistSong(e, song, parent, successCb, failureCb) {
      var _this2 = this;

      if (Array.isArray(song)) {
        this.createPlaylistSongs(e, song, parent, successCb, failureCb);
        return;
      }
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add song to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2833);
      });

      var songParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id'));
      if (songParams.external_source) {
        songParams.external_source = songParams.external_source.toUpperCase();
      }

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_playlist_song_edge',
        connectionInfo: [{
          key: 'UserPlaylistContainer_playlist_songs',
          rangeBehavior: 'append'
        }, {
          key: 'PlannerPlaylistContainer_playlist_songs',
          rangeBehavior: 'append'
        }, {
          key: 'MusicPlannerContainer_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      var updater = function updater(store) {
        if (_this2.props.parentID) {
          // If parent playlist is provided and it has no thumbnail,
          // update with new UserPlaylist thumbnail
          var parentPlaylist = store.get(_this2.props.parentID);
          var payload = store.getRootField('createPlaylistSong');
          var thumbnailArgs = { width: 240, height: 240 };
          var oldThumbnail = parentPlaylist.getLinkedRecord('thumbnail', thumbnailArgs);
          if (!oldThumbnail) {
            var newThumbnail = payload.getLinkedRecord('playlist').getLinkedRecord('thumbnail', thumbnailArgs);
            parentPlaylist.setLinkedRecord(newThumbnail, 'thumbnail', thumbnailArgs);
          }
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            playlist_id: parentID
          }, songParams, {
            song_images: songParams.song_images ? songParams.song_images.edges.map(function (_ref) {
              var image = _ref.node;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
            }) : []
          })
        },
        configs: configs,
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPlaylistSongs',
    value: function createPlaylistSongs(e, songs, parent, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add songs to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(2834);
      });

      var newSongs = songs.map(function (song) {
        var newSong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id', '__typename'));
        if (newSong.external_source) {
          newSong.external_source = newSong.external_source.toUpperCase();
        }
        newSong.song_images = newSong.song_images ? newSong.song_images.edges.map(function (_ref2) {
          var image = _ref2.node;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
        }) : [];
        return newSong;
      });

      var parentID = this.props.node.id;

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            playlist_id: parentID,
            songs: newSongs
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          node = _props.node,
          deletePlaylist = _props.deletePlaylist,
          showControls = _props.showControls,
          relay = _props.relay,
          goBack = _props.goBack;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Playlist__["a" /* default */], {
        playlist: node,
        relay: relay,
        refetchSearchResults: relay.refetch,
        searchResults: node.song_search.edges.map(function (edge) {
          return edge.node;
        }),
        editable: node.can_edit,
        fillable: node.can_edit,
        showControls: showControls,
        goBack: goBack,
        removeFromPlaylist: this.deletePlaylistSong,
        updatePlaylist: this.updatePlaylist,
        deletePlaylist: deletePlaylist,
        playlistContainsSong: this.playlistContainsSong,
        addToPlaylist: this.createPlaylistSong
      });
    }
  }]);

  return UserPlaylist;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UserPlaylist.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  deletePlaylist: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  showControls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parentID: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (UserPlaylist);

/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserPlaylist__ = __webpack_require__(2818);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__UserPlaylist__["a" /* default */], {
  node: function node() {
    return __webpack_require__(2831);
  }
}, function () {
  return __webpack_require__(2830);
}));

/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserPlaylistContainer__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserPlaylistQuery__ = __webpack_require__(380);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var UserPlaylistRenderer = function UserPlaylistRenderer(_ref) {
  var props = _ref.props;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__UserPlaylistQuery__["b" /* UserPlaylistConsumer */],
    null,
    function (_ref2) {
      var Component = _ref2.component,
          contextProps = _objectWithoutProperties(_ref2, ['component']);

      if (props) {
        var RenderedComponent = Component || __WEBPACK_IMPORTED_MODULE_2__UserPlaylistContainer__["a" /* default */];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderedComponent, _extends({}, contextProps, props));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Loading...'
      );
    }
  );
};

UserPlaylistRenderer.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (UserPlaylistRenderer);

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6e455e7f5f430cfd82f5a4cd1ea0f1db
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  s_text_on_embed_submit?: ?boolean,
  s_country?: ?string,
  s_currency?: ?string,
  s_time_zone?: ?string,
  s_recaptcha_enabled?: ?boolean,
  s_recaptcha_site_key?: ?string,
  s_recaptcha_secret_key?: ?string,
};
export type AccountInfo_UpdateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type AccountInfo_UpdateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +company_name: ?string,
      +s_time_zone: ?string,
    |}
  |}
|};
export type AccountInfo_UpdateUserMutation = {|
  variables: AccountInfo_UpdateUserMutationVariables,
  response: AccountInfo_UpdateUserMutationResponse,
|};
*/

/*
mutation AccountInfo_UpdateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      id
      first_name
      last_name
      company_name
      s_time_zone
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUser",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserInput!"
    }],
    "concreteType": "UpdateUserPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "s_time_zone",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AccountInfo_UpdateUserMutation",
    "id": null,
    "text": "mutation AccountInfo_UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      id\n      first_name\n      last_name\n      company_name\n      s_time_zone\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AccountInfo_UpdateUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "AccountInfo_UpdateUserMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '65a95f54bf734ff36b603c1555c021b9';
module.exports = node;

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 88de3a960386ca6f23d25f974431d3d7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  s_text_on_embed_submit?: ?boolean,
  s_country?: ?string,
  s_currency?: ?string,
  s_time_zone?: ?string,
  s_recaptcha_enabled?: ?boolean,
  s_recaptcha_site_key?: ?string,
  s_recaptcha_secret_key?: ?string,
};
export type AppComponent_updateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type AppComponent_updateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +s_time_zone: ?string
    |}
  |}
|};
export type AppComponent_updateUserMutation = {|
  variables: AppComponent_updateUserMutationVariables,
  response: AppComponent_updateUserMutationResponse,
|};
*/

/*
mutation AppComponent_updateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      s_time_zone
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "AppComponent_updateUserMutation",
    "id": null,
    "text": "mutation AppComponent_updateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      s_time_zone\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AppComponent_updateUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AppComponent_updateUserMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '42d5aaefbff39e46b26a119d024f315b';
module.exports = node;

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AppContainer_viewer$ref: FragmentReference;
export type AppContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +s_time_zone: ?string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: AppContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AppContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ec20d10b28eb7256ce7e43913670ed9b';
module.exports = node;

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 49de47f05af55a5ea40d621dfb0c9359
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePlaylistInput = {
  clientMutationId?: ?string,
  title: string,
  description?: ?string,
};
export type NewPlaylist_createPlaylistMutationVariables = {|
  input: CreatePlaylistInput
|};
export type NewPlaylist_createPlaylistMutationResponse = {|
  +createPlaylist: ?{|
    +new_playlist_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +can_edit: ?boolean,
        +playlist_songs: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string
            |}
          |}>
        |},
      |}
    |}
  |}
|};
export type NewPlaylist_createPlaylistMutation = {|
  variables: NewPlaylist_createPlaylistMutationVariables,
  response: NewPlaylist_createPlaylistMutationResponse,
|};
*/

/*
mutation NewPlaylist_createPlaylistMutation(
  $input: CreatePlaylistInput!
) {
  createPlaylist(input: $input) {
    new_playlist_edge {
      node {
        id
        title
        description
        can_edit
        playlist_songs(first: 99999) {
          edges {
            node {
              id
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlaylistSongEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistSong",
      "plural": false,
      "selections": [v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "cursor",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  }],
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewPlaylist_createPlaylistMutation",
    "id": null,
    "text": "mutation NewPlaylist_createPlaylistMutation(\n  $input: CreatePlaylistInput!\n) {\n  createPlaylist(input: $input) {\n    new_playlist_edge {\n      node {\n        id\n        title\n        description\n        can_edit\n        playlist_songs(first: 99999) {\n          edges {\n            node {\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["createPlaylist", "new_playlist_edge", "node", "playlist_songs"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "NewPlaylist_createPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": "playlist_songs",
              "name": "__UserPlaylistContainer_playlist_songs_connection",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistSongConnection",
              "plural": false,
              "selections": v6
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "NewPlaylist_createPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": null,
              "name": "playlist_songs",
              "storageKey": "playlist_songs(first:99999)",
              "args": v7,
              "concreteType": "PlaylistSongConnection",
              "plural": false,
              "selections": v6
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "playlist_songs",
              "args": v7,
              "handle": "connection",
              "key": "UserPlaylistContainer_playlist_songs",
              "filters": null
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'edf53eb2347b5ba9b58bb1d3e131c1c0';
module.exports = node;

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlaylistsContainer_viewer$ref: FragmentReference;
export type PlaylistsContainer_viewer = {|
  +id: string,
  +playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +$refType: PlaylistsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "PlaylistsContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlists"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "playlists",
      "name": "__PlaylistsContainer_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "num_songs",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "width",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "height",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '1c50169bbd1490d8653c29484b026d8d';
module.exports = node;

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 20d675ced95c59fbbd820dd36cd89679
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Playlists_deletePlaylistMutationVariables = {|
  input: DeletePlaylistInput
|};
export type Playlists_deletePlaylistMutationResponse = {|
  +deletePlaylist: ?{|
    +deletedPlaylistId: ?string
  |}
|};
export type Playlists_deletePlaylistMutation = {|
  variables: Playlists_deletePlaylistMutationVariables,
  response: Playlists_deletePlaylistMutationResponse,
|};
*/

/*
mutation Playlists_deletePlaylistMutation(
  $input: DeletePlaylistInput!
) {
  deletePlaylist(input: $input) {
    deletedPlaylistId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePlaylistInput!"
    }],
    "concreteType": "DeletePlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedPlaylistId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Playlists_deletePlaylistMutation",
    "id": null,
    "text": "mutation Playlists_deletePlaylistMutation(\n  $input: DeletePlaylistInput!\n) {\n  deletePlaylist(input: $input) {\n    deletedPlaylistId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Playlists_deletePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Playlists_deletePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '16cdbe49da84c71074e3088da4277e76';
module.exports = node;

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4f5ca716131fa3f0728aa9b5d213082f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
export type SearchContainerRefetchQueryVariables = {|
  query: string
|};
export type SearchContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchContainer_viewer$ref
  |}
|};
export type SearchContainerRefetchQuery = {|
  variables: SearchContainerRefetchQueryVariables,
  response: SearchContainerRefetchQueryResponse,
|};
*/

/*
query SearchContainerRefetchQuery(
  $query: String!
) {
  viewer {
    ...SearchContainer_viewer_1Qr5xf
    id
  }
}

fragment SearchContainer_viewer_1Qr5xf on User {
  s_time_zone
  user_event_search(first: 3, query: $query) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "SearchContainerRefetchQuery",
    "id": null,
    "text": "query SearchContainerRefetchQuery(\n  $query: String!\n) {\n  viewer {\n    ...SearchContainer_viewer_1Qr5xf\n    id\n  }\n}\n\nfragment SearchContainer_viewer_1Qr5xf on User {\n  s_time_zone\n  user_event_search(first: 3, query: $query) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SearchContainerRefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SearchContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SearchContainerRefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String!"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }, v1]
            }]
          }]
        }, v1]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '59fc8930bad017ad22a4ca5971020d97';
module.exports = node;

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchContainer_viewer$ref: FragmentReference;
export type SearchContainer_viewer = {|
  +s_time_zone: ?string,
  +user_event_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +location: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: SearchContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": 3
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": ""
  }],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_event_search",
    "storageKey": null,
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 3,
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "query",
      "variableName": "query",
      "type": "String!"
    }],
    "concreteType": "UserEventConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEventEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "booking_status",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "start_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "end_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_segments",
          "storageKey": "user_event_segments(first:1)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }],
          "concreteType": "UserEventSegmentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegmentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegment",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '6992d655ca6b9b91f5e5afcfaffd6e4d';
module.exports = node;

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
type PlaylistsContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SettingsContainer_viewer$ref: FragmentReference;
export type SettingsContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +company_name: ?string,
  +s_time_zone: ?string,
  +features: ?{|
    +music_lists: ?boolean
  |},
  +payment_methods: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: "SquarePaymentMethod",
        +id?: string,
        +enabled?: ?boolean,
        +instructions?: ?string,
        +address?: ?string,
        +pay_to?: ?string,
        +label?: ?string,
      |}
    |}>
  |},
  +$fragmentRefs: PlaylistsContainer_viewer$ref & AvailabilityCheckerContainer_viewer$ref,
  +$refType: SettingsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "SettingsContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["payment_methods"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "company_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "features",
      "storageKey": null,
      "args": null,
      "concreteType": "Features",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "music_lists",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "payment_methods",
      "name": "__SettingsContainer_payment_methods_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentMethodConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentMethodEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "type": "CustomPaymentMethod",
            "selections": [v0, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }, v2]
          }, {
            "kind": "InlineFragment",
            "type": "CheckPaymentMethod",
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "address",
              "args": null,
              "storageKey": null
            }, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "pay_to",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "InlineFragment",
            "type": "CashPaymentMethod",
            "selections": [v0, v1, v2]
          }, {
            "kind": "InlineFragment",
            "type": "SquarePaymentMethod",
            "selections": [v0, v1]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "PlaylistsContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '03d98c6637c7abcaa9170409f38604cf';
module.exports = node;

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7dda7f202b7481f0c4921abff5d90dc1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserPlaylistContainer_node$ref = any;
export type UserPlaylistContainer_RefetchQueryVariables = {|
  query: string,
  id: string,
|};
export type UserPlaylistContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: UserPlaylistContainer_node$ref
  |}
|};
export type UserPlaylistContainer_RefetchQuery = {|
  variables: UserPlaylistContainer_RefetchQueryVariables,
  response: UserPlaylistContainer_RefetchQueryResponse,
|};
*/

/*
query UserPlaylistContainer_RefetchQuery(
  $query: String!
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...UserPlaylistContainer_node_1Qr5xf
    id
  }
}

fragment UserPlaylistContainer_node_1Qr5xf on Playlist {
  id
  can_edit
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: $query) {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v4, v5, v6]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "UserPlaylistContainer_RefetchQuery",
    "id": null,
    "text": "query UserPlaylistContainer_RefetchQuery(\n  $query: String!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UserPlaylistContainer_node_1Qr5xf\n    id\n  }\n}\n\nfragment UserPlaylistContainer_node_1Qr5xf on Playlist {\n  id\n  can_edit\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: $query) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylistContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "UserPlaylistContainer_node",
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylistContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Playlist",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [v4, v5, v6, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_songs",
            "storageKey": "playlist_songs(first:99999)",
            "args": v7,
            "concreteType": "PlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistSong",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v8, v9, v10, v11, v12]
                }, v2]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "playlist_songs",
            "args": v7,
            "handle": "connection",
            "key": "UserPlaylistContainer_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": null,
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Variable",
              "name": "query",
              "variableName": "query",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v9, v10, v11, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v12, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c763ce63563463d011df2a1f06019478';
module.exports = node;

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserPlaylistContainer_node$ref: FragmentReference;
export type UserPlaylistContainer_node = {|
  +id: string,
  +can_edit: ?boolean,
  +title: ?string,
  +description: ?string,
  +thumbnail: ?{|
    +url: ?string,
    +width: ?number,
    +height: ?number,
  |},
  +playlist_songs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +__typename: string,
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +album: ?string,
          +artist: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +song_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +album: ?string,
        +artist: ?string,
        +isrc: ?string,
        +duration_ms: ?number,
        +song_images: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +url: ?string,
              +width: ?number,
              +height: ?number,
            |}
          |}>
        |},
        +external_id?: ?string,
        +external_source?: ?string,
        +external_data?: ?string,
      |}
    |}>
  |},
  +$refType: UserPlaylistContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v0, v1, v2, v3]
      }]
    }]
  };
  return {
    "kind": "Fragment",
    "name": "UserPlaylistContainer_node",
    "type": "Playlist",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlist_songs"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    }],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "thumbnail",
      "storageKey": "thumbnail(height:240,width:240)",
      "args": [{
        "kind": "Literal",
        "name": "height",
        "value": 240,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "width",
        "value": 240,
        "type": "Int"
      }],
      "concreteType": "SongImage",
      "plural": false,
      "selections": [v1, v2, v3]
    }, {
      "kind": "LinkedField",
      "alias": "playlist_songs",
      "name": "__UserPlaylistContainer_playlist_songs_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistSongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistSongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistSong",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v4, v0, v5, v6, v7, v8, v9]
          }, v4]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "song_search",
      "storageKey": null,
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 10,
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String!"
      }],
      "concreteType": "SongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "SongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [v0, v6, v7, v8, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration_ms",
            "args": null,
            "storageKey": null
          }, v9, {
            "kind": "InlineFragment",
            "type": "SpotifySong",
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "external_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_data",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '806485ee164d9c5ca1200712d7076bcd';
module.exports = node;

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c05d5cf026214f280ed5ccce44152f06
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type RecommendationContainer_node$ref = any;
type UserPlaylistContainer_node$ref = any;
export type UserPlaylistQuery_QueryVariables = {|
  id: string,
  query: string,
|};
export type UserPlaylistQuery_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: UserPlaylistContainer_node$ref & RecommendationContainer_node$ref
  |}
|};
export type UserPlaylistQuery_Query = {|
  variables: UserPlaylistQuery_QueryVariables,
  response: UserPlaylistQuery_QueryResponse,
|};
*/

/*
query UserPlaylistQuery_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on Playlist {
      ...UserPlaylistContainer_node
      ...RecommendationContainer_node
    }
    id
  }
}

fragment UserPlaylistContainer_node on Playlist {
  id
  can_edit
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}

fragment RecommendationContainer_node on Playlist {
  id
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v4, v5, v6]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "UserPlaylistQuery_Query",
    "id": null,
    "text": "query UserPlaylistQuery_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Playlist {\n      ...UserPlaylistContainer_node\n      ...RecommendationContainer_node\n    }\n    id\n  }\n}\n\nfragment UserPlaylistContainer_node on Playlist {\n  id\n  can_edit\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n\nfragment RecommendationContainer_node on Playlist {\n  id\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylistQuery_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "type": "Playlist",
          "selections": [{
            "kind": "FragmentSpread",
            "name": "UserPlaylistContainer_node",
            "args": null
          }, {
            "kind": "FragmentSpread",
            "name": "RecommendationContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylistQuery_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Playlist",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [v4, v5, v6, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_songs",
            "storageKey": "playlist_songs(first:99999)",
            "args": v7,
            "concreteType": "PlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistSong",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v8, v9, v10, v11, v12]
                }, v2]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "playlist_songs",
            "args": v7,
            "handle": "connection",
            "key": "UserPlaylistContainer_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v9, v10, v11, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v12, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8066f059c1060e61e6dceda569e37686';
module.exports = node;

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f8bf4ea6340389ad4ffdf35722b25309
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlaylistSongInput = {
  clientMutationId?: ?string,
  playlist_id: string,
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type UserPlaylist_createPlaylistSongMutationVariables = {|
  input: CreatePlaylistSongInput
|};
export type UserPlaylist_createPlaylistSongMutationResponse = {|
  +createPlaylistSong: ?{|
    +new_playlist_song_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +artist: ?string,
          +album: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |},
    +playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type UserPlaylist_createPlaylistSongMutation = {|
  variables: UserPlaylist_createPlaylistSongMutationVariables,
  response: UserPlaylist_createPlaylistSongMutationResponse,
|};
*/

/*
mutation UserPlaylist_createPlaylistSongMutation(
  $input: CreatePlaylistSongInput!
) {
  createPlaylistSong(input: $input) {
    new_playlist_song_edge {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          artist
          album
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
      }
    }
    playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }, v8, v9]
      }]
    }]
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v2, v8, v9]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UserPlaylist_createPlaylistSongMutation",
    "id": null,
    "text": "mutation UserPlaylist_createPlaylistSongMutation(\n  $input: CreatePlaylistSongInput!\n) {\n  createPlaylistSong(input: $input) {\n    new_playlist_song_edge {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          artist\n          album\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n      }\n    }\n    playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylist_createPlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v2, v4, v5, v6, v7, v10]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v11]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylist_createPlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }, v2, v4, v5, v6, v7, v10]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v11, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'accade1526db63bddd979d4c64411fe7';
module.exports = node;

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 42db63721677984b7fb799e6b59c4fae
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type RecommendationContainer_node$ref = any;
type UserPlaylistContainer_node$ref = any;
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlaylistSongsInput = {
  clientMutationId?: ?string,
  playlist_id: string,
  songs: $ReadOnlyArray<?SongInput>,
};
export type SongInput = {
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type UserPlaylist_createPlaylistSongsMutationVariables = {|
  input: CreatePlaylistSongsInput
|};
export type UserPlaylist_createPlaylistSongsMutationResponse = {|
  +createPlaylistSongs: ?{|
    +playlist: ?{|
      +$fragmentRefs: UserPlaylistContainer_node$ref & RecommendationContainer_node$ref
    |}
  |}
|};
export type UserPlaylist_createPlaylistSongsMutation = {|
  variables: UserPlaylist_createPlaylistSongsMutationVariables,
  response: UserPlaylist_createPlaylistSongsMutationResponse,
|};
*/

/*
mutation UserPlaylist_createPlaylistSongsMutation(
  $input: CreatePlaylistSongsInput!
) {
  createPlaylistSongs(input: $input) {
    playlist {
      ...UserPlaylistContainer_node
      ...RecommendationContainer_node
      id
    }
  }
}

fragment UserPlaylistContainer_node on Playlist {
  id
  can_edit
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}

fragment RecommendationContainer_node on Playlist {
  id
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistSongsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistSongsInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v3, v4, v5]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UserPlaylist_createPlaylistSongsMutation",
    "id": null,
    "text": "mutation UserPlaylist_createPlaylistSongsMutation(\n  $input: CreatePlaylistSongsInput!\n) {\n  createPlaylistSongs(input: $input) {\n    playlist {\n      ...UserPlaylistContainer_node\n      ...RecommendationContainer_node\n      id\n    }\n  }\n}\n\nfragment UserPlaylistContainer_node on Playlist {\n  id\n  can_edit\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n\nfragment RecommendationContainer_node on Playlist {\n  id\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylist_createPlaylistSongsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "UserPlaylistContainer_node",
            "args": null
          }, {
            "kind": "FragmentSpread",
            "name": "RecommendationContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylist_createPlaylistSongsMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [v3, v4, v5, v2]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_songs",
            "storageKey": "playlist_songs(first:99999)",
            "args": v6,
            "concreteType": "PlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistSong",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v7, v2, v8, v9, v10, v11, v12]
                }, v7]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "playlist_songs",
            "args": v6,
            "handle": "connection",
            "key": "UserPlaylistContainer_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v7, v2, v9, v10, v11, v8, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v12, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'afe096e26279335aa1501d4bb4648813';
module.exports = node;

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash db8218a8c8594a4f9fbd07767772144f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlaylistSongInput = {
  clientMutationId?: ?string,
  id: string,
};
export type UserPlaylist_deletePlaylistSongMutationVariables = {|
  input: DeletePlaylistSongInput
|};
export type UserPlaylist_deletePlaylistSongMutationResponse = {|
  +deletePlaylistSong: ?{|
    +deletedPlaylistSongId: ?string,
    +playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type UserPlaylist_deletePlaylistSongMutation = {|
  variables: UserPlaylist_deletePlaylistSongMutationVariables,
  response: UserPlaylist_deletePlaylistSongMutationResponse,
|};
*/

/*
mutation UserPlaylist_deletePlaylistSongMutation(
  $input: DeletePlaylistSongInput!
) {
  deletePlaylistSong(input: $input) {
    deletedPlaylistSongId
    playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeletePlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedPlaylistSongId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UserPlaylist_deletePlaylistSongMutation",
    "id": null,
    "text": "mutation UserPlaylist_deletePlaylistSongMutation(\n  $input: DeletePlaylistSongInput!\n) {\n  deletePlaylistSong(input: $input) {\n    deletedPlaylistSongId\n    playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylist_deletePlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylist_deletePlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v4, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd8eee93135d61559106e6b04fdef087e';
module.exports = node;

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 93ae048206d1de9acf2bd93cb7c21e69
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
};
export type UserPlaylist_updatePlaylistMutationVariables = {|
  input: UpdatePlaylistInput
|};
export type UserPlaylist_updatePlaylistMutationResponse = {|
  +updatePlaylist: ?{|
    +playlist: ?{|
      +title: ?string,
      +description: ?string,
    |}
  |}
|};
export type UserPlaylist_updatePlaylistMutation = {|
  variables: UserPlaylist_updatePlaylistMutationVariables,
  response: UserPlaylist_updatePlaylistMutationResponse,
|};
*/

/*
mutation UserPlaylist_updatePlaylistMutation(
  $input: UpdatePlaylistInput!
) {
  updatePlaylist(input: $input) {
    playlist {
      title
      description
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UserPlaylist_updatePlaylistMutation",
    "id": null,
    "text": "mutation UserPlaylist_updatePlaylistMutation(\n  $input: UpdatePlaylistInput!\n) {\n  updatePlaylist(input: $input) {\n    playlist {\n      title\n      description\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UserPlaylist_updatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v2, v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UserPlaylist_updatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '198afe1ca2acdb1dcd7d59c48cf8b8aa';
module.exports = node;

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContractBrand = function (_React$Component) {
  _inherits(ContractBrand, _React$Component);

  function ContractBrand(props) {
    _classCallCheck(this, ContractBrand);

    var _this = _possibleConstructorReturn(this, (ContractBrand.__proto__ || Object.getPrototypeOf(ContractBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromContract()
    };
    _this.getBrandFromContract = _this.getBrandFromContract.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.updateContractBrand = _this.updateContractBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(ContractBrand, [{
    key: 'getBrandFromContract',
    value: function getBrandFromContract() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['brand_header']);
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.updateContractBrand(successCb, failureCb);
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2857);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateContractBrand',
    value: function updateContractBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2858);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            contract_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromContract();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromContract(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return ContractBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractBrand);

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(2840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Actions__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Schedule__ = __webpack_require__(2844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineItems__ = __webpack_require__(2842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Library__ = __webpack_require__(2841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Brand__ = __webpack_require__(2837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Logo__ = __webpack_require__(2843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Terms__ = __webpack_require__(2853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Sign__ = __webpack_require__(2850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SignatureBlocks__ = __webpack_require__(2851);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var Contract = (_temp = _class = function (_React$Component) {
  _inherits(Contract, _React$Component);

  function Contract(props) {
    _classCallCheck(this, Contract);

    var _this = _possibleConstructorReturn(this, (Contract.__proto__ || Object.getPrototypeOf(Contract)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.openSignModal = _this.openSignModal.bind(_this);
    _this.closeSignModal = _this.closeSignModal.bind(_this);
    _this.getSigner = _this.getSigner.bind(_this);
    _this.getAlreadySigned = _this.getAlreadySigned.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false,
      signModalOpen: false
    };
    return _this;
  }

  _createClass(Contract, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
      if (!this.props.node && this.props.location.query.share_token) this.addContractToSession();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'getAlreadySigned',
    value: function getAlreadySigned() {
      var alreadySigned = 0;
      this.props.node.contract_signature_blocks.edges.map(function (signatureBlock) {
        if (signatureBlock.node.signed_at) {
          ++alreadySigned;
        }
        return signatureBlock;
      });
      return alreadySigned;
    }
  }, {
    key: 'getSigner',
    value: function getSigner() {
      var _this2 = this;

      var signer = null;
      if (this.props.node) {
        this.props.node.contract_signature_blocks.edges.map(function (signatureBlock) {
          if (signatureBlock.node.id === _this2.props.params.signer_id) {
            signer = signatureBlock.node;
          }
          return signatureBlock;
        });
      }
      return signer;
    }
  }, {
    key: 'addContractToSession',
    value: function addContractToSession() {
      var _this3 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this3.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null);
      };

      var onError = function onError() {
        _this3.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2859);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.node.editable && this.props.params.action === 'edit';
    }
  }, {
    key: 'openSignModal',
    value: function openSignModal() {
      this.setState({ signModalOpen: true });
    }
  }, {
    key: 'closeSignModal',
    value: function closeSignModal() {
      this.setState({ signModalOpen: false });
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var CheckIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["d" /* Icon */], { name: 'check circle', color: 'green', style: { marginLeft: '0.5em' } });
      var StartSigningButtonDesktop = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["b" /* Button */], {
        content: 'Start Signing',
        size: 'large',
        className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionButton,
        style: this.getSigner() && this.getSigner().signed_at ? { display: 'none' } : {},
        onClick: this.openSignModal
      });

      var StartSigningButtonMobile = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["b" /* Button */], {
        content: 'Start Signing',
        fluid: true,
        primary: true,
        size: 'big',
        style: this.getSigner() && this.getSigner().signed_at ? { display: 'none' } : {},
        onClick: this.openSignModal
      });

      var signer = this.getSigner();

      var isLargeScreen = this.state.window.width >= 1280;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Actions__["a" /* default */], {
        node: this.props.node,
        params: this.props.params,
        relay: this.props.relay,
        router: this.props.router,
        windowDimensions: this.state.window
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default.a,
          {
            sidebar: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__["a" /* default */], {
              setSidebarOpenState: this.onSetSidebarOpen,
              router: this.props.router,
              viewer: this.props.viewer
            }),
            sidebarClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.sidebar,
            open: this.state.sidebarOpen,
            onSetOpen: this.onSetSidebarOpen,
            touch: false,
            contentClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarContent,
            rootClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarRoot
          },
          !signer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["a" /* default */], {
            toggleSidebar: this.toggleSidebar,
            sidebarOpen: this.state.sidebarOpen,
            document: this.props.node,
            relay: this.props.relay,
            router: this.props.router,
            params: this.props.params,
            viewer: this.props.viewer,
            windowDimensions: this.state.window
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["s" /* Container */],
            {
              className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.container, signer ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.documentOffset : ''].join(' ')
            },
            !isLargeScreen && this.state.window.width >= __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuTablet },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  !signer && ActionsMenu
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["t" /* Segment */],
              { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.segment },
              isLargeScreen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["u" /* Rail */],
                { position: 'right', close: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuDesktop },
                !signer && ActionsMenu
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */],
                { padded: true, relaxed: true, stackable: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Logo__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Brand__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column, null)
                ),
                (this.canEdit() || this.props.node.contract_event_segments.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                      'Schedule'
                    )
                  )
                ),
                (this.canEdit() || this.props.node.contract_event_segments.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Schedule__["a" /* default */], {
                      eventSegments: this.props.node.contract_event_segments.edges,
                      viewer: this.props.viewer,
                      relay: this.props.relay,
                      readOnly: !this.canEdit(),
                      node: this.props.node
                    })
                  )
                ),
                (this.canEdit() || this.props.node.contract_line_items.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                      'Line Items'
                    )
                  )
                ),
                (this.canEdit() || this.props.node.contract_line_items.edges.length) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LineItems__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      canEdit: this.canEdit()
                    })
                  )
                ),
                this.canEdit() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Library__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      viewer: this.props.viewer
                    })
                  )
                ),
                (this.canEdit() || this.props.node.terms) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                      'Terms and Conditions'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Terms__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      canEdit: this.canEdit()
                    })
                  )
                ),
                (this.canEdit() || this.props.node.contract_signature_blocks.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                      'Signatures'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SignatureBlocks__["a" /* default */], {
                      relay: this.props.relay,
                      node: this.props.node,
                      canEdit: this.canEdit(),
                      signer: this.getSigner(),
                      openSignModal: this.openSignModal
                    })
                  )
                )
              )
            )
          ),
          signer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.state.window.width >= __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptDesktop, signer.signed_at ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptCompleted : ''].join(' ')
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_semantic_ui_react__["s" /* Container */],
                null,
                !signer.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  signer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      signer.name,
                      ','
                    ),
                    ' this contract is ready for you to sign.'
                  ),
                  !signer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'This contract is ready for you to sign.'
                  )
                ),
                signer.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  signer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    signer.name,
                    ', you have signed this contract ',
                    CheckIcon
                  ),
                  !signer.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'You have signed this contract ',
                    CheckIcon
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Sign__["a" /* default */], {
                  relay: this.props.relay,
                  signatureBlock: signer,
                  trigger: StartSigningButtonDesktop,
                  contract: this.props.node,
                  open: this.state.signModalOpen,
                  onClose: this.closeSignModal,
                  onOpen: this.openSignModal
                })
              )
            ),
            this.state.window.width < __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptMobile, signer.signed_at ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptCompleted : ''].join(' ')
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Sign__["a" /* default */], {
                relay: this.props.relay,
                signatureBlock: signer,
                trigger: StartSigningButtonMobile,
                contract: this.props.node,
                open: this.state.signModalOpen,
                onClose: this.closeSignModal,
                onOpen: this.openSignModal
              }),
              signer.signed_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { padding: '1em' } },
                'You have signed this contract ',
                CheckIcon
              )
            )
          )
        ),
        !this.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App_404__["a" /* default */], { viewer: this.props.viewer }),
          !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return Contract;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  signer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_found__["withRouter"])(Contract));

/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractComponent__ = __webpack_require__(2838);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__ContractComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(2861);
  },
  viewer: function viewer() {
    return __webpack_require__(2862);
  }
}, function () {
  return __webpack_require__(2860);
}));

/***/ }),
/* 2840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var ContractHeader = function (_React$Component) {
  _inherits(ContractHeader, _React$Component);

  function ContractHeader(props) {
    _classCallCheck(this, ContractHeader);

    var _this = _possibleConstructorReturn(this, (ContractHeader.__proto__ || Object.getPrototypeOf(ContractHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false,
      alreadySignedModalOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(ContractHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit && this.props.document.editable
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  className: 'item',
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit && this.props.document.editable
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return ContractHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractHeader);

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__ = __webpack_require__(529);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ContractLibrary = function (_React$Component) {
  _inherits(ContractLibrary, _React$Component);

  function ContractLibrary(props) {
    _classCallCheck(this, ContractLibrary);

    var _this = _possibleConstructorReturn(this, (ContractLibrary.__proto__ || Object.getPrototypeOf(ContractLibrary)).call(this, props));

    _this.copyLibraryLineItemsToContract = _this.copyLibraryLineItemsToContract.bind(_this);
    _this.createLineItem = _this.createLineItem.bind(_this);
    _this.resetNewLibraryLineItem = _this.resetNewLibraryLineItem.bind(_this);
    _this.newLibraryLineItemChangeHandler = _this.newLibraryLineItemChangeHandler.bind(_this);
    return _this;
  }

  _createClass(ContractLibrary, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Initialize new library line item
      this.resetNewLibraryLineItem();
    }
  }, {
    key: 'copyLibraryLineItemsToContract',
    value: function copyLibraryLineItemsToContract(itemsToCopy) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('added-line-items-from-library', {
          item_count: itemsToCopy.length
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2863);
      });

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        var contractProxy = store.get(_this2.props.node.id);
        var payload = store.getRootField('copyUserLineItemsToContract');
        var newContractLineItems = payload.getLinkedRecord('contract').getLinkedRecord('contract_line_items');
        var conn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(contractProxy, 'ContractContainer_contract_line_items');
        conn.copyFieldsFrom(newContractLineItems);
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            contract_id: parentID,
            user_line_item_ids: itemsToCopy
          }
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createLineItem',
    value: function createLineItem(idx, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this3.resetNewLibraryLineItem();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2864);
      });

      var newLineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newLibraryLineItem), 'title', 'description', 'price_cents', 'price_currency', 'quantity');

      newLineItem.quantity = parseInt(newLineItem.quantity, 10);

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        // Update contract
        var contractProxy = store.get(_this3.props.node.id);
        var payload = store.getRootField('createContractLineItem');
        var newContractLineItemEdge = payload.getLinkedRecord('new_contract_line_item_edge');
        var contractLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(contractProxy, 'ContractContainer_contract_line_items');
        __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(contractLineItemConn, newContractLineItemEdge);

        // Update viewer if adding to library
        if (_this3.state.newLibraryLineItem.addToLibrary) {
          var viewerProxy = store.get(_this3.props.viewer.id);
          var newUserLineItemEdge = payload.getLinkedRecord('new_user_line_item_edge');
          var userLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'LibraryContainer_user_line_items');
          __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(userLineItemConn, newUserLineItemEdge);
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            contract_id: parentID
          }, newLineItem, {
            add_to_library: this.state.newLibraryLineItem.addToLibrary
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetNewLibraryLineItem',
    value: function resetNewLibraryLineItem() {
      this.setState({
        newLibraryLineItem: {
          title: '',
          description: '',
          quantity: 1,
          price_cents: 0,
          price_currency: 'USD',
          addToLibrary: false
        }
      });
    }
  }, {
    key: 'newLibraryLineItemChangeHandler',
    value: function newLibraryLineItemChangeHandler(lineItem) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newLibraryLineItem = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'render',
    value: function render() {
      var contractLineItems = this.props.node.contract_line_items.edges;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__["a" /* default */], {
        initiallyExpanded: contractLineItems.length === 0,
        newLibraryLineItem: this.state.newLibraryLineItem,
        newLibraryLineItemChangeHandler: this.newLibraryLineItemChangeHandler,
        resetNewLibraryLineItem: this.resetNewLibraryLineItem,
        createLineItem: this.createLineItem,
        copyLibraryLineItemsToDocument: this.copyLibraryLineItemsToContract,
        viewer: this.props.viewer,
        relay: this.props.relay
      });
    }
  }]);

  return ContractLibrary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractLibrary.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractLibrary);

/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_array__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ContractLineItems = function (_React$Component) {
  _inherits(ContractLineItems, _React$Component);

  function ContractLineItems(props) {
    _classCallCheck(this, ContractLineItems);

    var _this = _possibleConstructorReturn(this, (ContractLineItems.__proto__ || Object.getPrototypeOf(ContractLineItems)).call(this, props));

    _this.state = {
      localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.contract_line_items.edges)
    };
    _this.deleteLineItem = _this.deleteLineItem.bind(_this);
    _this.resetEditLineItem = _this.resetEditLineItem.bind(_this);
    _this.lineItemChangeHandler = _this.lineItemChangeHandler.bind(_this);
    _this.updateLineItem = _this.updateLineItem.bind(_this);
    _this.moveLineItem = _this.moveLineItem.bind(_this);
    return _this;
  }

  _createClass(ContractLineItems, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localLineItems if any edges are added/deleted
      this.setState({
        localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.contract_line_items.edges)
      });
    }
  }, {
    key: 'lineItemChangeHandler',
    value: function lineItemChangeHandler(lineItem, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx].node = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'resetEditLineItem',
    value: function resetEditLineItem(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.contract_line_items.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'moveLineItem',
    value: function moveLineItem(source, destination) {
      var _this2 = this;

      var localLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_array__["a" /* arrayMove */])(this.state.localLineItems, source, destination);
      localLineItems[destination].node.position = destination + 1;
      this.setState({
        localLineItems: localLineItems
      }, function () {
        return _this2.updateLineItem(destination);
      });
    }
  }, {
    key: 'updateLineItem',
    value: function updateLineItem(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-line-item');
      };
      var lineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localLineItems[idx].node), ['id', 'description', 'position', 'price_cents', 'price_currency', 'quantity', 'title']);

      lineItem.quantity = parseInt(lineItem.quantity, 10);
      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2866);
      });

      var contract = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node);
      contract.contract_line_items.edges = this.state.localLineItems;
      var optimisticResponse = {
        updateContractLineItem: { contract: contract }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, lineItem)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteLineItem',
    value: function deleteLineItem(idx, successCb, failureCb) {
      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2865);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['contract', 'contract_line_items'],
        deletedIDFieldName: 'deletedContractLineItemId',
        connectionKeys: [{
          key: 'ContractContainer_contract_line_items',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.contract_line_items.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__["a" /* default */], {
        lineItems: this.props.node.contract_line_items.edges,
        localLineItems: this.state.localLineItems,
        updateLineItem: this.updateLineItem,
        deleteLineItem: this.deleteLineItem,
        moveLineItem: this.moveLineItem,
        resetEditLineItem: this.resetEditLineItem,
        lineItemChangeHandler: this.lineItemChangeHandler,
        readOnly: !this.props.canEdit
      });
    }
  }]);

  return ContractLineItems;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractLineItems.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractLineItems);

/***/ }),
/* 2843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var ContractLogo = function (_React$Component) {
  _inherits(ContractLogo, _React$Component);

  function ContractLogo(props) {
    _classCallCheck(this, ContractLogo);

    var _this = _possibleConstructorReturn(this, (ContractLogo.__proto__ || Object.getPrototypeOf(ContractLogo)).call(this, props));

    _this.updateContractLogo = _this.updateContractLogo.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(ContractLogo, [{
    key: 'updateContractLogo',
    value: function updateContractLogo(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2869);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            contract_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.updateContractLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2867);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this3 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this4.updateContractLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2868);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand_logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return ContractLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractLogo);

/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sections_Schedule_Schedule__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__ = __webpack_require__(106);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ContractSchedule = function (_React$Component) {
  _inherits(ContractSchedule, _React$Component);

  function ContractSchedule(props) {
    _classCallCheck(this, ContractSchedule);

    var _this = _possibleConstructorReturn(this, (ContractSchedule.__proto__ || Object.getPrototypeOf(ContractSchedule)).call(this, props));

    _this.toggleSearch = _this.toggleSearch.bind(_this);
    _this.closeSearchHandler = _this.closeSearchHandler.bind(_this);
    _this.eventSegmentChangeHandler = _this.eventSegmentChangeHandler.bind(_this);
    _this.updateEventSegment = _this.updateEventSegment.bind(_this);
    _this.resetEditEventSegment = _this.resetEditEventSegment.bind(_this);
    _this.deleteEventSegment = _this.deleteEventSegment.bind(_this);
    _this.newEventSegmentChangeHandler = _this.newEventSegmentChangeHandler.bind(_this);
    _this.closeNewEventSegmentEditor = _this.closeNewEventSegmentEditor.bind(_this);
    _this.createEventSegment = _this.createEventSegment.bind(_this);
    _this.addEventSegment = _this.addEventSegment.bind(_this);
    _this.resetAddEventSegment = _this.resetAddEventSegment.bind(_this);
    _this.state = {
      showSearch: false,
      eventSegments: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.eventSegments),
      editingNewEventSegment: false
    };
    return _this;
  }

  _createClass(ContractSchedule, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update eventSegments if any edges are added/deleted
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.eventSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.eventSegments);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ showSearch: !this.state.showSearch });
    }
  }, {
    key: 'closeSearchHandler',
    value: function closeSearchHandler() {
      this.setState({ showSearch: false });
    }
  }, {
    key: 'eventSegmentChangeHandler',
    value: function eventSegmentChangeHandler(eventSegment, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.eventSegments[idx].node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateEventSegment',
    value: function updateEventSegment(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-contract-event-segment');
      };
      var eventSegment = __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.eventSegments[idx].node), ['id', 'title', 'start_at', 'end_at', 'time_zone', 'location', 'line1', 'city', 'province', 'postal_code', 'room', 'notes']));

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2872);
      });

      var optimisticResponse = {
        updateContractEventSegment: { contract_event_segment: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(eventSegment) }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, eventSegment)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetEditEventSegment',
    value: function resetEditEventSegment(index) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.eventSegments[index] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.eventSegments[index]);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'deleteEventSegment',
    value: function deleteEventSegment(idx, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this2.resetEditEventSegment();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-contract-event-segment');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2871);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['contract', 'contract_event_segments'],
        deletedIDFieldName: 'deletedContractEventSegmentId',
        connectionKeys: [{
          key: 'ContractContainer_contract_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.eventSegments[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetAddEventSegment',
    value: function resetAddEventSegment() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete obj.newEventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'createEventSegment',
    value: function createEventSegment(index, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.state);
        delete obj.newEventSegment;
        _this3.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-contract-event-segment');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2870);
      });

      var eventSegment = __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newEventSegment.node), 'all_day'));

      eventSegment.title = eventSegment.title || '(Untitled Agenda Item)';

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_contract_event_segment_edge',
        connectionInfo: [{
          key: 'ContractContainer_contract_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            contract_id: parentID
          }, eventSegment)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'addEventSegment',
    value: function addEventSegment(e) {
      e.preventDefault();
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewEventSegment = true;
      if (!this.state.newEventSegment) {
        obj.newEventSegment = { node: {} };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newEventSegmentChangeHandler',
    value: function newEventSegmentChangeHandler(eventSegment) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newEventSegment.node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewEventSegmentEditor',
    value: function closeNewEventSegmentEditor() {
      this.setState({ editingNewEventSegment: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Sections_Schedule_Schedule__["a" /* default */], {
        addEventSegment: this.addEventSegment,
        closeNewEventSegmentEditor: this.closeNewEventSegmentEditor,
        createEventSegment: this.createEventSegment,
        deleteEventSegment: this.deleteEventSegment,
        eventSegments: this.props.eventSegments,
        eventSegmentChangeHandler: this.eventSegmentChangeHandler,
        editingNewEventSegment: this.state.editingNewEventSegment,
        localEventSegments: this.state.eventSegments,
        newEventSegment: this.state.newEventSegment,
        newEventSegmentChangeHandler: this.newEventSegmentChangeHandler,
        readOnly: this.props.readOnly,
        resetAddEventSegment: this.resetAddEventSegment,
        resetEditEventSegment: this.resetEditEventSegment,
        updateEventSegment: this.updateEventSegment,
        viewer: this.props.viewer
      });
    }
  }]);

  return ContractSchedule;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractSchedule.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  eventSegments: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractSchedule);

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);





var EmailSuccess = function EmailSuccess(_ref) {
  var onClose = _ref.onClose,
      to = _ref.to,
      cc = _ref.cc;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'center' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["j" /* Success */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Contract Sent!'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { style: { marginBottom: '2em' } },
      'Your contract was sent to ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        to
      ),
      '.',
      cc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        ' and CC\'d to ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          cc
        )
      ),
      '.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, fluid: true, content: 'Done', onClick: onClose })
  );
};

EmailSuccess.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (EmailSuccess);

/***/ }),
/* 2846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Contract_scss__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Contract_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Contract_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Share_Share_scss__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Share_Share_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Share_Share_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RequestSignature = function (_Component) {
  _inherits(RequestSignature, _Component);

  function RequestSignature(props) {
    _classCallCheck(this, RequestSignature);

    var _this = _possibleConstructorReturn(this, (RequestSignature.__proto__ || Object.getPrototypeOf(RequestSignature)).call(this, props));

    _this.state = {
      showSignLink: false,
      showCc: false,
      submitted: false
    };
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.toggleSignLink = _this.toggleSignLink.bind(_this);
    return _this;
  }

  _createClass(RequestSignature, [{
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
    }
  }, {
    key: 'toggleSignLink',
    value: function toggleSignLink() {
      this.setState(function (prevState) {
        return { showSignLink: !prevState.showSignLink };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          copyButton = _props.copyButton,
          to = _props.to,
          cc = _props.cc,
          subject = _props.subject,
          message = _props.message,
          emailSuggestions = _props.emailSuggestions,
          emailSignLink = _props.emailSignLink,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onEmailChange = _props.onEmailChange,
          onTextChange = _props.onTextChange,
          previous = _props.previous,
          selectedSignatureBlock = _props.selectedSignatureBlock;
      var _state = this.state,
          showCc = _state.showCc,
          showSignLink = _state.showSignLink,
          submitted = _state.submitted;

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
        { key: 'requestSignature' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
          { textAlign: 'left' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            !showSignLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'relative' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
                {
                  onValidSubmit: emailSignLink,
                  onInvalidSubmit: this.onInvalidSubmit,
                  autoComplete: 'off',
                  ref: 'emailForm'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["k" /* InputWithSuggestions */], {
                  label: 'To',
                  name: 'to',
                  value: to,
                  onChange: onEmailChange,
                  submitted: submitted,
                  placeholder: 'Email address...',
                  className: !showCc ? __WEBPACK_IMPORTED_MODULE_7__Sections_Actions_Share_Share_scss___default.a.toField : null,
                  fluid: true,
                  required: true,
                  validations: 'isEmail',
                  autoComplete: 'off',
                  options: emailSuggestions,
                  validationError: 'Valid email address required'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                showCc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["k" /* InputWithSuggestions */], {
                    label: 'Cc',
                    name: 'cc',
                    value: cc,
                    onChange: onEmailChange,
                    submitted: submitted,
                    placeholder: 'Email address...',
                    fluid: true,
                    validations: 'isEmail',
                    autoComplete: 'off',
                    options: emailSuggestions,
                    validationError: 'Valid email address required'
                  })
                ),
                !showCc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__RootComponent__["b" /* RootConsumer */],
                  null,
                  function (_ref) {
                    var isMobile = _ref.isMobile;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      {
                        style: {
                          position: 'absolute',
                          top: isMobile ? '2.125em' : '2.25em',
                          right: '1.125em'
                        },
                        onClick: function onClick() {
                          return _this2.setState({ showCc: true });
                        }
                      },
                      'Cc'
                    );
                  }
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], {
                  label: 'Subject',
                  name: 'subject',
                  value: subject,
                  onChange: onTextChange,
                  submitted: submitted,
                  fluid: true,
                  required: true,
                  validationError: 'Subject is required'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'ui form' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginBottom: '0.25em' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        { htmlFor: 'message' },
                        'Message'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["A" /* TextArea */], {
                    placeholder: 'Enter a personal message',
                    name: 'message',
                    id: 'message',
                    value: message,
                    onChange: onTextChange
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: this.toggleSignLink },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  'Get shareable link ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'linkify' })
                )
              )
            ),
            showSignLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'You can copy, paste and share this link.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], {
                  fluid: true,
                  name: 'share_url',
                  onFocus: onFocus,
                  value: "https://www.cloverbook.com" + '/open/sign/' + selectedSignatureBlock.share_token,
                  onChange: function onChange() {},
                  action: copyButton("https://www.cloverbook.com" + '/open/sign/' + selectedSignatureBlock.share_token),
                  style: {
                    marginTop: '1em',
                    marginBottom: '1em'
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: this.toggleSignLink },
                  'Share via email ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'mail outline' })
                )
              )
            )
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 'equal', verticalAlign: 'middle', key: 'controls' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
          { textAlign: 'left' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { onClick: previous },
            '< Back'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
          { textAlign: 'right' },
          showSignLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], { primary: true, content: 'Close', onClick: onClose }),
          !showSignLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: __WEBPACK_IMPORTED_MODULE_6__Contract_scss___default.a.modalCancel, onClick: onClose },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
              primary: true,
              content: 'Send',
              onClick: function onClick() {
                return _this2.refs.emailForm.submit();
              }
            })
          )
        )
      )];
    }
  }]);

  return RequestSignature;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RequestSignature.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  emailSuggestions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  emailSignLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onEmailChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onTextChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  copyButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (RequestSignature);

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlockShow__ = __webpack_require__(814);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SelectSigner = function (_Component) {
  _inherits(SelectSigner, _Component);

  function SelectSigner(props) {
    _classCallCheck(this, SelectSigner);

    var _this = _possibleConstructorReturn(this, (SelectSigner.__proto__ || Object.getPrototypeOf(SelectSigner)).call(this, props));

    _this.state = {
      showShareLink: !_this.props.document.can_edit
    };
    _this.getRemainingSigners = _this.getRemainingSigners.bind(_this);
    _this.getShareUrl = _this.getShareUrl.bind(_this);
    return _this;
  }

  _createClass(SelectSigner, [{
    key: 'getRemainingSigners',
    value: function getRemainingSigners() {
      var remainingSigners = 0;
      this.props.document.contract_signature_blocks.edges.map(function (signatureBlock) {
        if (!signatureBlock.node.signed_at) {
          ++remainingSigners;
        }
        return signatureBlock;
      });
      return remainingSigners;
    }
  }, {
    key: 'getShareUrl',
    value: function getShareUrl() {
      return "https://www.cloverbook.com" + '/open/c/' + this.props.document.share_token;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          copyButton = _props.copyButton,
          document = _props.document,
          next = _props.next,
          onFocus = _props.onFocus,
          selectSignatureBlock = _props.selectSignatureBlock,
          selectedSignatureBlock = _props.selectedSignatureBlock;
      var showShareLink = this.state.showShareLink;

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 1, key: 'SelectSigner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
          { textAlign: 'left' },
          document.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.getRemainingSigners() > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Please select who needs to sign this contract.'
            ),
            !this.getRemainingSigners() > 0 && document.contract_signature_blocks.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'All parties have signed this contract.'
            ),
            !this.getRemainingSigners() > 0 && document.contract_signature_blocks.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'This contract contains no signature blocks. You must add signature blocks before you can request signatures.'
            ),
            document.contract_signature_blocks.edges.map(function (signatureBlock, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: signatureBlock.node.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__Elements__["g" /* SelectableBlock */],
                  {
                    cardBorder: true,
                    style: { marginTop: '2em', padding: '0 1em' },
                    onChange: function onChange() {
                      return selectSignatureBlock(idx);
                    },
                    checked: selectedSignatureBlock && selectedSignatureBlock.id === signatureBlock.node.id,
                    disabled: document.contract_signature_blocks.edges[idx].node.signed_at && true,
                    radio: true
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlockShow__["a" /* default */], {
                    signatureBlock: signatureBlock,
                    withoutSignature: true
                  })
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["v" /* Divider */],
              { style: { margin: '2em auto' }, horizontal: true },
              'Or'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { style: { textAlign: 'left' } },
            'Sharing this contract with someone that isn\'t signing?'
          ),
          !showShareLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: function onClick() {
                  return _this2.setState({ showShareLink: true });
                } },
              'Click here',
              ' '
            ),
            'to share a view-only version of this contract with anyone'
          ),
          showShareLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], {
              fluid: true,
              name: 'share_url',
              onFocus: onFocus,
              value: this.getShareUrl(),
              onChange: function onChange() {},
              action: copyButton(this.getShareUrl()),
              style: { marginTop: '2em', marginBottom: '2em' }
            }),
            'Anyone with the link above ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'can view'
            ),
            ' this contract but ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'cannot sign'
            ),
            '.'
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 'equal', verticalAlign: 'middle', key: 'controls' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
          { textAlign: 'right' },
          this.getRemainingSigners() > 0 && document.can_edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            primary: true,
            disabled: !selectedSignatureBlock,
            content: 'Request Signature',
            onClick: next
          })
        )
      )];
    }
  }]);

  return SelectSigner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SelectSigner.propTypes = {
  copyButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (SelectSigner);

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 83ab63a810d9d4c76aa161bd5e0d8c0b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailContractSignLinkInput = {
  clientMutationId?: ?string,
  csb_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type Share_emailContractSignLinkMutationVariables = {|
  input: EmailContractSignLinkInput
|};
export type Share_emailContractSignLinkMutationResponse = {|
  +emailContractSignLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type Share_emailContractSignLinkMutation = {|
  variables: Share_emailContractSignLinkMutationVariables,
  response: Share_emailContractSignLinkMutationResponse,
|};
*/

/*
mutation Share_emailContractSignLinkMutation(
  $input: EmailContractSignLinkInput!
) {
  emailContractSignLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailContractSignLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailContractSignLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailContractSignLinkInput!"
    }],
    "concreteType": "EmailContractSignLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Share_emailContractSignLinkMutation",
    "id": null,
    "text": "mutation Share_emailContractSignLinkMutation(\n  $input: EmailContractSignLinkInput!\n) {\n  emailContractSignLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Share_emailContractSignLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Share_emailContractSignLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1580e9e415838acd44526e780e10ac6a';
module.exports = node;

/***/ }),
/* 2849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_clipboard_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectSigner__ = __webpack_require__(2847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RequestSignature__ = __webpack_require__(2846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EmailSuccess__ = __webpack_require__(2845);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ContractShare = function (_React$Component) {
  _inherits(ContractShare, _React$Component);

  function ContractShare(props) {
    _classCallCheck(this, ContractShare);

    var _this = _possibleConstructorReturn(this, (ContractShare.__proto__ || Object.getPrototypeOf(ContractShare)).call(this, props));

    _this.state = {
      open: false,
      step: 0,
      to: '',
      cc: '',
      subject: _this.props.document.title,
      message: ''
    };
    _this.steps = ['SelectSigner', 'requestSignature', 'emailSuccess'];
    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onSuccessfulCopy = _this.onSuccessfulCopy.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onTextChange = _this.onTextChange.bind(_this);
    _this.onEmailChange = _this.onEmailChange.bind(_this);
    _this.getEmailSuggestions = _this.getEmailSuggestions.bind(_this);
    _this.currentStep = _this.currentStep.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.emailSignLink = _this.emailSignLink.bind(_this);
    _this.selectSignatureBlock = _this.selectSignatureBlock.bind(_this);
    return _this;
  }

  _createClass(ContractShare, [{
    key: 'onOpen',
    value: function onOpen() {
      this.setState({ open: true, step: 0 });
      if (this.props.onOpen) this.props.onOpen();
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({ open: false });
      if (this.props.onClose) this.props.onClose();
    }
  }, {
    key: 'onSuccessfulCopy',
    value: function onSuccessfulCopy() {
      __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
        message: 'Successfully copied URL',
        intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
      });
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      e.target.select();
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(e, _ref) {
      var value = _ref.value,
          name = _ref.name;

      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: 'onTextChange',
    value: function onTextChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'getWorkspaceContactEmails',
    value: function getWorkspaceContactEmails() {
      var workspaces = this.props.document.workspaces.edges;
      var contacts = [];
      if (workspaces.length > 0) {
        var userContacts = workspaces[0].node.event.user_contacts.edges;
        userContacts.map(function (_ref2) {
          var uc = _ref2.node;
          return uc.user_contact_emails.edges.map(function (_ref3) {
            var email = _ref3.node;

            contacts.push({
              title: uc.first_name + ' ' + uc.last_name,
              description: email.address,
              value: email.address
            });
            return email;
          });
        });
      }
      return contacts;
    }
  }, {
    key: 'getEmailSuggestions',
    value: function getEmailSuggestions() {
      var _state$selectedSignat = this.state.selectedSignatureBlock,
          email = _state$selectedSignat.email,
          name = _state$selectedSignat.name;

      var emails = this.getWorkspaceContactEmails();
      if (email) {
        emails.unshift({ title: name, description: email, value: email });
      }
      return emails;
    }
  }, {
    key: 'currentStep',
    value: function currentStep() {
      return this.steps[this.state.step];
    }
  }, {
    key: 'hasNextStep',
    value: function hasNextStep() {
      return this.state.step < this.steps.length - 1;
    }
  }, {
    key: 'hasPreviousStep',
    value: function hasPreviousStep() {
      return this.state.step > 0;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.hasNextStep) {
        this.setState(function (prevState) {
          return { step: prevState.step + 1 };
        });
      }
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.hasPreviousStep) {
        this.setState(function (prevState) {
          return { step: prevState.step - 1 };
        });
      }
    }
  }, {
    key: 'selectSignatureBlock',
    value: function selectSignatureBlock(idx) {
      var selectedSignatureBlock = this.props.document.contract_signature_blocks.edges[idx].node;
      if (!selectedSignatureBlock.signed_at) {
        this.setState({ selectedSignatureBlock: selectedSignatureBlock, to: selectedSignatureBlock.email || '' });
      }
    }
  }, {
    key: 'emailSignLink',
    value: function emailSignLink() {
      var _this2 = this;

      var onCompleted = function onCompleted() {
        _this2.next();
      };

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2848);
      });

      var environment = this.props.relay.environment;
      var csbId = this.state.selectedSignatureBlock.id;

      var _state = this.state,
          to = _state.to,
          subject = _state.subject,
          message = _state.message;

      var cc = this.state.cc === '' ? null : this.state.cc;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { csb_id: csbId, to: to, cc: cc, subject: subject, message: message } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          to = _state2.to,
          cc = _state2.cc,
          subject = _state2.subject,
          message = _state2.message,
          selectedSignatureBlock = _state2.selectedSignatureBlock;
      var _props = this.props,
          document = _props.document,
          trigger = _props.trigger;

      var copyButton = function copyButton(url) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_clipboard_js___default.a,
          {
            'option-text': function optionText() {
              return url;
            },
            onSuccess: _this3.onSuccessfulCopy,
            className: 'ui right icon button button'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Copy \xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' })
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */],
        {
          trigger: trigger,
          closeIcon: true,
          onClose: this.onClose,
          onOpen: this.onOpen,
          open: this.state.open,
          size: 'small'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Header */], { content: 'Share Contract' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
            { padded: true, relaxed: true, stackable: true, centered: true },
            this.currentStep() === 'SelectSigner' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelectSigner__["a" /* default */], {
              copyButton: copyButton,
              document: document,
              next: this.next,
              onFocus: this.onFocus,
              selectSignatureBlock: this.selectSignatureBlock,
              selectedSignatureBlock: selectedSignatureBlock
            }),
            this.currentStep() === 'requestSignature' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RequestSignature__["a" /* default */], {
              to: to,
              cc: cc,
              subject: subject,
              message: message,
              emailSuggestions: this.getEmailSuggestions(),
              emailSignLink: this.emailSignLink,
              copyButton: copyButton,
              onClose: this.onClose,
              onFocus: this.onFocus,
              onEmailChange: this.onEmailChange,
              onTextChange: this.onTextChange,
              previous: this.previous,
              selectedSignatureBlock: selectedSignatureBlock
            }),
            this.currentStep() === 'emailSuccess' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__EmailSuccess__["a" /* default */], { to: to, cc: cc, onClose: this.onClose })
          )
        )
      );
    }
  }]);

  return ContractShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractShare.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ContractShare);

/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Sections_SignatureBlocks_SignatureBlockShow__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Contract_scss__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Contract_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SignaturePad__ = __webpack_require__(2852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_utils_polyfills_toBlob__ = __webpack_require__(3472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Sections_SignatureBlocks_SignatureBlockSizeClass__ = __webpack_require__(1471);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_13_filestack_js__["a" /* default */].init(apikey);

var SignContractFlow = function (_React$Component) {
  _inherits(SignContractFlow, _React$Component);

  function SignContractFlow(props) {
    _classCallCheck(this, SignContractFlow);

    var _this = _possibleConstructorReturn(this, (SignContractFlow.__proto__ || Object.getPrototypeOf(SignContractFlow)).call(this, props));

    _this.state = {
      localSignatureBlock: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.signatureBlock),
      window: { width: 0, height: 0 },
      step: _this.signatureBlockFields(_this.props.signatureBlock) ? 'signatureBlock' : 'sign',
      submitting: false,
      submitted: false,
      signatureSubmitted: false,
      signatureFormat: 'type'
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.signatureBlockFields = _this.signatureBlockFields.bind(_this);
    _this.onValidSignatureBlockFormSubmit = _this.onValidSignatureBlockFormSubmit.bind(_this);
    _this.onInvalidSignatureBlockFormSubmit = _this.onInvalidSignatureBlockFormSubmit.bind(_this);
    _this.onSignaturePadSubmit = _this.onSignaturePadSubmit.bind(_this);
    _this.isVisible = _this.isVisible.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.updateSignaturePadRef = _this.updateSignaturePadRef.bind(_this);
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.signContract = _this.signContract.bind(_this);
    _this.setDefaultSignatureFormat = _this.setDefaultSignatureFormat.bind(_this);
    return _this;
  }

  _createClass(SignContractFlow, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
      window.addEventListener('touchstart', this.setDefaultSignatureFormat);
      window.addEventListener('orientationchange', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
      window.removeEventListener('orientationchange', this.updateWindowDimensions);
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var localSignatureBlock = this.state.localSignatureBlock;

      if (localSignatureBlock.name_visibility === 'SHOW' && localSignatureBlock.signature_typed_name && localSignatureBlock.name && localSignatureBlock.signature_typed_name.toLowerCase() !== localSignatureBlock.name.toLowerCase()) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to sign contract',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      } else {
        this.signContract();
        this.setState({ submitting: true });
      }
      this.setState({ signatureSubmitted: true });
    }
  }, {
    key: 'onValidSignatureBlockFormSubmit',
    value: function onValidSignatureBlockFormSubmit() {
      this.setState({ submitted: true, step: 'sign' });
    }
  }, {
    key: 'onInvalidSignatureBlockFormSubmit',
    value: function onInvalidSignatureBlockFormSubmit() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to sign contract',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
      this.setState({ submitted: true });
    }
  }, {
    key: 'onSignaturePadSubmit',
    value: function onSignaturePadSubmit() {
      if (this.state.signaturePadRef.isEmpty()) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to sign contract',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      } else {
        this.setState({ submitting: true });
        this.processSignature();
      }
      this.setState({ signatureSubmitted: true });
    }
  }, {
    key: 'setDefaultSignatureFormat',
    value: function setDefaultSignatureFormat() {
      this.setState({
        signatureFormat: this.state.window.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint ? 'draw' : 'type'
      });
      window.removeEventListener('touchstart', this.setDefaultSignatureFormat);
    }
  }, {
    key: 'signatureBlockFields',
    value: function signatureBlockFields(signatureBlock) {
      return this.isVisible(signatureBlock.name_visibility) || this.isVisible(signatureBlock.email_visibility) || this.isVisible(signatureBlock.phone_visibility) || this.isVisible(signatureBlock.company_name_visibility) || this.isVisible(signatureBlock.title_visibility) || this.isVisible(signatureBlock.address_visibility);
    }
  }, {
    key: 'isVisible',
    value: function isVisible(visibility) {
      return visibility === 'SHOW';
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      state.localSignatureBlock[key] = value;
      this.setState(state);
    }
  }, {
    key: 'processSignature',
    value: function processSignature() {
      var _this2 = this;

      var canvas = this.state.signaturePadRef.getCanvas();
      var rotatedCanvas = this.refs.rotatedCanvas;
      if (window.innerWidth <= window.innerHeight) {
        var ctx = rotatedCanvas.getContext('2d');
        var image = new Image();
        image.src = canvas.toDataURL();
        image.onload = function () {
          rotatedCanvas.width = image.height;
          rotatedCanvas.height = image.width;
          ctx.rotate(90 * Math.PI / 180);
          ctx.translate(0, -canvas.height);
          ctx.drawImage(image, 0, 0);
          _this2.uploadSignature(rotatedCanvas);
        };
      } else {
        this.uploadSignature(canvas);
      }
    }
  }, {
    key: 'uploadSignature',
    value: function uploadSignature(canvas) {
      var _this3 = this;

      canvas.toBlob(function (blob) {
        client.upload(blob, {}, { location: 's3', filename: _this3.props.signatureBlock.id + '.png' }).then(function (file) {
          var fileProps = {
            signature_url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            signature_size: file.size,
            signature_mimetype: file.mimetype,
            signature_handle: file.handle
          };
          _this3.signContract(fileProps);
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Unable to sign contract',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
          });
          _this3.setState({ submitting: false });
          // TODO: Log error to Bugsnag
        });
      }, 'image/png');
    }
  }, {
    key: 'signContract',
    value: function signContract(fileProps) {
      var _this4 = this;

      var onError = function onError() {
        _this4.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to sign contract',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this4.setState({ submitting: false, step: 'success' });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2873);
      });

      var signatureBlock = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localSignatureBlock), (this.state.localSignatureBlock.signer_fills_fields ? ['name', 'email', 'title', 'company_name', 'phone', 'address'] : []).concat(this.state.signatureFormat === 'type' ? 'signature_typed_name' : ''));
      signatureBlock.contract_signature_block_id = this.state.localSignatureBlock.id;
      signatureBlock.signature_type = this.state.signatureFormat === 'type' ? 'TYPED' : 'PAD';

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, signatureBlock, fileProps)
        },
        updater: function updater() {},
        optimisticUpdater: function optimisticUpdater() {},
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      var _this5 = this;

      setTimeout(function () {
        _this5.setState({
          window: { width: window.innerWidth, height: window.innerHeight }
        });
      }, 250);
    }
  }, {
    key: 'updateSignaturePadRef',
    value: function updateSignaturePadRef(signaturePadRef) {
      this.setState({ signaturePadRef: signaturePadRef });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var signatureBlock = this.props.signatureBlock;
      var localSignatureBlock = this.state.localSignatureBlock;


      var legalNotice = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.legalNotice },
        'I understand that this is a legal representation of my signature.'
      );

      var SignatureBlockFields = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          null,
          'Please',
          ' ',
          localSignatureBlock.signer_fills_fields ? 'provide' : 'confirm',
          ' the following details to sign:'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
          {
            onValidSubmit: this.onValidSignatureBlockFormSubmit,
            onInvalidSubmit: this.onInvalidSignatureBlockFormSubmit,
            ref: 'signatureBlockForm'
          },
          !signatureBlock.signer_fills_fields && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.card },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Sections_SignatureBlocks_SignatureBlockShow__["a" /* default */], {
              signatureBlock: { node: signatureBlock },
              style: { padding: 0 }
            })
          ),
          signatureBlock.signer_fills_fields && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            this.isVisible(signatureBlock.name_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Name',
              name: 'name',
              required: this.isVisible(signatureBlock.name_visibility),
              validationError: 'Name is required',
              value: localSignatureBlock.name || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.isVisible(signatureBlock.title_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Title',
              name: 'title',
              required: this.isVisible(signatureBlock.title_visibility),
              validationError: 'Title is required',
              value: localSignatureBlock.title || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.isVisible(signatureBlock.company_name_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Company Name',
              name: 'company_name',
              required: this.isVisible(signatureBlock.company_name_visibility),
              validationError: 'Company name is required',
              value: localSignatureBlock.company_name || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.isVisible(signatureBlock.email_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Email Address',
              name: 'email',
              type: 'email',
              required: this.isVisible(signatureBlock.email_visibility),
              validationError: 'Email is required',
              value: localSignatureBlock.email || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.isVisible(signatureBlock.phone_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Phone Number',
              name: 'phone',
              type: 'tel',
              required: this.isVisible(signatureBlock.phone_visibility),
              validationError: 'Phone number is required',
              value: localSignatureBlock.phone || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            }),
            this.isVisible(signatureBlock.address_visibility) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              label: 'Address',
              name: 'address',
              autoHeight: true,
              required: this.isVisible(signatureBlock.address_visibility),
              validationError: 'Address is required',
              value: localSignatureBlock.address || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            })
          )
        )
      );

      var signatureFormatSwitcher = function signatureFormatSwitcher(type) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */].Group,
          { basic: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
            content: 'Draw',
            active: _this6.state.signatureFormat === 'draw',
            className: type === 'header' ? __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.headerButton : '',
            onClick: function onClick() {
              return _this6.setState({ signatureFormat: 'draw' });
            }
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
            content: 'Type',
            className: type === 'header' ? __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.headerButton : '',
            active: _this6.state.signatureFormat === 'type',
            onClick: function onClick() {
              return _this6.setState({ signatureFormat: 'type' });
            }
          })
        );
      };

      var mobileSignatureFormatSwitcher = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { marginLeft: 'auto', transform: 'translateY(0.5em)' } },
        signatureFormatSwitcher('header')
      );

      var showError = false;
      var errorMessage = '';
      var emptySignaturePad = this.state.signaturePadRef && this.state.signaturePadRef.isEmpty();
      var signatureNameMismatch = localSignatureBlock.name_visibility === 'SHOW' && localSignatureBlock.signature_typed_name && localSignatureBlock.name && localSignatureBlock.signature_typed_name.toLowerCase() !== localSignatureBlock.name.toLowerCase();
      if (this.state.signatureSubmitted) {
        if (this.state.signatureFormat === 'draw') {
          if (emptySignaturePad) {
            showError = true;
          }
        } else {
          if (signatureNameMismatch) {
            showError = true;
            errorMessage = 'Signature must match name: ' + localSignatureBlock.name;
          }
          if (!localSignatureBlock.signature_typed_name) {
            showError = true;
            errorMessage = 'Signature is required';
          }
        }
      }

      var TypeComponent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
          {
            onSubmit: this.onSubmit,
            ref: 'signatureForm',
            style: { position: 'relative' }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            name: 'signature_typed_name',
            required: true,
            autoFocus: true,
            autoComplete: 'off',
            value: localSignatureBlock.signature_typed_name || '',
            onChange: this.textFieldChange,
            className: [__WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.typeSignatureInput, showError ? __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.signatureError : '', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__Sections_SignatureBlocks_SignatureBlockSizeClass__["a" /* default */])(localSignatureBlock.signature_typed_name || '')].join(' ')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            {
              onClick: function onClick() {
                return _this6.fieldChange('signature_typed_name', '');
              },
              className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.signaturePadReset
            },
            'Clear'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.signatureLine },
            '\xD7'
          ),
          legalNotice
        ),
        showError && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.signatureErrorText },
          errorMessage
        )
      );

      var SignButtonContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        this.state.submitting && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* Loader */], {
          active: this.state.submitting,
          inline: true,
          inverted: true,
          size: 'mini',
          style: { marginRight: '1em' }
        }),
        this.state.submitting ? 'Submitting Signature' : 'Sign Contract'
      );
      var SuccessMessage = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { textAlign: 'center' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["j" /* Success */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          { style: { marginBottom: '2em' } },
          'You have signed this contract'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, fluid: true, content: 'Done', onClick: this.props.onClose })
      );

      var rotateStyles = {
        height: this.state.window.width + 'px',
        minHeight: '100%',
        transform: 'rotate(-90deg)',
        width: this.state.window.height + 'px',
        position: 'absolute'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        this.state.window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
          {
            trigger: this.props.trigger,
            onClose: this.props.onClose,
            onOpen: this.props.onOpen,
            open: this.props.open,
            size: 'small',
            closeOnDimmerClick: false
          },
          this.state.step === 'signatureBlock' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Header, { content: 'Sign Contract', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '400px', margin: '0 auto' } },
              SignatureBlockFields
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
            { key: 'actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { onClick: this.props.onClose, className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.modalCancel },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                type: 'submit',
                onClick: function onClick() {
                  return _this6.refs.signatureBlockForm.submit();
                }
              },
              'Next'
            )
          )],
          this.state.step === 'sign' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Header, { content: 'Sign Contract', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: {
                  maxWidth: '600px',
                  margin: '0 auto'
                }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: 'center' } },
                signatureFormatSwitcher()
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              this.state.signatureFormat === 'draw' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SignaturePad__["a" /* default */], {
                  showError: showError,
                  legalNotice: legalNotice,
                  updateSignaturePadRef: this.updateSignaturePadRef
                })
              ),
              this.state.signatureFormat === 'type' && TypeComponent
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
            { key: 'actions' },
            this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return _this6.setState({ step: 'signatureBlock' });
                },
                className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.modalCancel
              },
              'Back'
            ),
            !this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: this.props.onClose,
                className: __WEBPACK_IMPORTED_MODULE_10__Contract_scss___default.a.modalCancel
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                type: 'submit',
                disabled: this.state.submitting,
                onClick: function onClick() {
                  if (_this6.state.signatureFormat === 'draw') {
                    _this6.onSignaturePadSubmit();
                  } else {
                    _this6.refs.signatureForm.submit();
                  }
                }
              },
              SignButtonContent
            )
          )],
          this.state.step === 'success' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Header, { content: 'Sign Contract', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '280px', margin: '0 auto' } },
              SuccessMessage
            )
          )]
        ),
        this.state.window.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
          {
            trigger: this.props.trigger,
            open: this.props.open,
            onClose: this.props.onClose,
            onOpen: this.props.onOpen
          },
          this.state.step === 'signatureBlock' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
            { key: 'header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.props.onClose },
                'Cancel'
              )
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
            { key: 'content' },
            SignatureBlockFields,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                type: 'submit',
                onClick: function onClick() {
                  _this6.refs.signatureBlockForm.submit();
                }
              },
              'Next'
            )
          )],
          this.state.step === 'sign' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            this.state.signatureFormat === 'draw' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: this.state.window.width < this.state.window.height ? rotateStyles : {}
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
                { style: { textAlign: 'center' } },
                this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      className: 'item',
                      onClick: function onClick() {
                        return _this6.setState({ step: 'signatureBlock' });
                      }
                    },
                    'Back'
                  )
                ),
                !this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { className: 'item', onClick: this.props.onClose },
                    'Cancel'
                  )
                ),
                mobileSignatureFormatSwitcher,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu right' },
                  !this.state.submitting && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      className: 'item',
                      onClick: this.onSignaturePadSubmit
                    },
                    'Sign'
                  ),
                  this.state.submitting && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* Loader */], { active: true, inline: true, size: 'tiny' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas', {
                  ref: 'rotatedCanvas',
                  width: 0,
                  height: 0,
                  style: { display: 'none' }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SignaturePad__["a" /* default */], {
                  showError: showError,
                  legalNotice: legalNotice,
                  updateSignaturePadRef: this.updateSignaturePadRef
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                this.state.window.height > 350 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
                  {
                    primary: true,
                    type: 'submit',
                    onClick: this.onSignaturePadSubmit,
                    disabled: this.state.submitting,
                    style: { zIndex: 1 }
                  },
                  SignButtonContent
                )
              )
            ),
            this.state.signatureFormat === 'type' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
                null,
                this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      className: 'item',
                      onClick: function onClick() {
                        return _this6.setState({ step: 'signatureBlock' });
                      }
                    },
                    'Back'
                  )
                ),
                !this.signatureBlockFields(signatureBlock) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { className: 'item', onClick: this.props.onClose },
                    'Cancel'
                  )
                ),
                mobileSignatureFormatSwitcher,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu right' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    {
                      className: 'item',
                      onClick: function onClick() {
                        return _this6.refs.signatureForm.submit();
                      }
                    },
                    'Sign'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
                null,
                TypeComponent,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
                  {
                    primary: true,
                    type: 'submit',
                    disabled: this.state.submitting,
                    onClick: function onClick() {
                      _this6.refs.signatureForm.submit();
                    },
                    fluid: true
                  },
                  SignButtonContent
                )
              )
            )
          ),
          this.state.step === 'success' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
              null,
              SuccessMessage
            )
          )
        )
      );
    }
  }]);

  return SignContractFlow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SignContractFlow.propTypes = {
  contract: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  signatureBlock: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SignContractFlow);

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlocks__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContractSignatureBlocks = function (_React$Component) {
  _inherits(ContractSignatureBlocks, _React$Component);

  function ContractSignatureBlocks(props) {
    _classCallCheck(this, ContractSignatureBlocks);

    var _this = _possibleConstructorReturn(this, (ContractSignatureBlocks.__proto__ || Object.getPrototypeOf(ContractSignatureBlocks)).call(this, props));

    _this.state = {
      contract: {},
      localSignatureBlocks: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.contract_signature_blocks.edges),
      editingNewSignatureBlock: false
    };
    _this.reset = _this.reset.bind(_this);
    _this.deleteBlock = _this.deleteBlock.bind(_this);
    _this.update = _this.update.bind(_this);
    _this.onChange = _this.onChange.bind(_this);

    _this.newSignatureBlockChangeHandler = _this.newSignatureBlockChangeHandler.bind(_this);
    _this.closeNewSignatureBlockEditor = _this.closeNewSignatureBlockEditor.bind(_this);
    _this.addSignatureBlock = _this.addSignatureBlock.bind(_this);
    _this.resetAddSignatureBlock = _this.resetAddSignatureBlock.bind(_this);
    _this.createSignatureBlock = _this.createSignatureBlock.bind(_this);
    return _this;
  }

  _createClass(ContractSignatureBlocks, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localSignatureBlocks if any edges are added/deleted
      if (this.state.localSignatureBlocks.length !== nextProps.node.contract_signature_blocks.edges.length) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
        obj.localSignatureBlocks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.contract_signature_blocks.edges);
        this.setState(_extends({}, obj));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(signatureBlock, idx) {
      this.setState(function (state) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
        obj.localSignatureBlocks[idx].node = signatureBlock;
        return obj;
      });
    }
  }, {
    key: 'reset',
    value: function reset(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localSignatureBlocks[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.contract_signature_blocks.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'addSignatureBlock',
    value: function addSignatureBlock() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewSignatureBlock = true;
      if (!this.state.contract.newSignatureBlock) {
        obj.contract.newSignatureBlock = {
          node: {
            address: '',
            address_visibility: 'HIDE',
            company_name: '',
            company_name_visibility: 'HIDE',
            email: '',
            email_visibility: 'SHOW',
            name: '',
            name_visibility: 'SHOW',
            phone: '',
            phone_visibility: 'SHOW',
            signer_fills_fields: true,
            signing_party: '',
            title: '',
            title_visibility: 'HIDE'
          }
        };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newSignatureBlockChangeHandler',
    value: function newSignatureBlockChangeHandler(signatureBlock) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.contract.newSignatureBlock.node = signatureBlock;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewSignatureBlockEditor',
    value: function closeNewSignatureBlockEditor() {
      this.setState({ editingNewSignatureBlock: false });
    }
  }, {
    key: 'resetAddSignatureBlock',
    value: function resetAddSignatureBlock() {
      this.setState(function (state) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
        delete obj.contract.newSignatureBlock;
        return obj;
      });
    }
  }, {
    key: 'createSignatureBlock',
    value: function createSignatureBlock(index, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.state);
        delete obj.contract.newSignatureBlock;
        _this2.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-contract-signature-block');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2876);
      });

      var signatureBlock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.contract.newSignatureBlock.node);

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_contract_signature_block_edge',
        connectionInfo: [{
          key: 'ContractContainer_contract_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            contract_id: parentID
          }, signatureBlock)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'update',
    value: function update(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-signature-block');
      };

      var signatureBlock = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localSignatureBlocks[idx].node), ['id', 'address', 'address_visibility', 'company_name', 'company_name_visibility', 'email', 'email_visibility', 'name', 'name_visibility', 'phone', 'phone_visibility', 'signing_party', 'signer_fills_fields', 'title', 'title_visibility']);

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2875);
      });

      var optimisticResponse = {
        updateContractSignatureBlock: {
          contract_signature_block: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(signatureBlock)
        }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, signatureBlock)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteBlock',
    value: function deleteBlock(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-signature-block');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2874);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['contract', 'contract_signature_blocks'],
        deletedIDFieldName: 'deletedContractSignatureBlockId',
        connectionKeys: [{
          key: 'ContractContainer_contract_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.contract_signature_blocks.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlocks__["a" /* default */], {
        signatureBlocks: this.props.node.contract_signature_blocks.edges,
        localSignatureBlocks: this.state.localSignatureBlocks,
        onChange: this.onChange,
        reset: this.reset,
        deleteBlock: this.deleteBlock,
        update: this.update,
        readOnly: !this.props.canEdit,
        resetAddSignatureBlock: this.resetAddSignatureBlock,
        newSignatureBlockChangeHandler: this.newSignatureBlockChangeHandler,
        closeNewSignatureBlockEditor: this.closeNewSignatureBlockEditor,
        addSignatureBlock: this.addSignatureBlock,
        newSignatureBlock: this.state.contract.newSignatureBlock,
        editingNewSignatureBlock: this.state.editingNewSignatureBlock,
        createSignatureBlock: this.createSignatureBlock,
        signer: this.props.signer,
        openSignModal: this.props.openSignModal
      });
    }
  }]);

  return ContractSignatureBlocks;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractSignatureBlocks.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  signer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  openSignModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ContractSignatureBlocks);

/***/ }),
/* 2852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contract_scss__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Contract_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_signature_canvas__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_signature_canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_signature_canvas__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SignaturePadComponent = function (_React$Component) {
  _inherits(SignaturePadComponent, _React$Component);

  function SignaturePadComponent(props) {
    _classCallCheck(this, SignaturePadComponent);

    var _this = _possibleConstructorReturn(this, (SignaturePadComponent.__proto__ || Object.getPrototypeOf(SignaturePadComponent)).call(this, props));

    _this.state = {
      signaturePadDimensions: { width: 0, height: 0 }
    };
    _this.updateSignaturePadDimensions = _this.updateSignaturePadDimensions.bind(_this);
    return _this;
  }

  _createClass(SignaturePadComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateSignaturePadDimensions();
      this.props.updateSignaturePadRef(this.refs.signaturePad);
      window.addEventListener('resize', this.updateSignaturePadDimensions);
      window.addEventListener('orientationchange', this.updateSignaturePadDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateSignaturePadDimensions);
      window.removeEventListener('orientationchange', this.updateSignaturePadDimensions);
    }
  }, {
    key: 'updateSignaturePadDimensions',
    value: function updateSignaturePadDimensions() {
      var _this2 = this;

      var sigContainer = this.refs.sigContainer;
      // We add a setTimeout here so that we can get the
      // dimensions of the signature container after resize has completed
      setTimeout(function () {
        _this2.setState(function (state) {
          return Object.assign({}, state, {
            signaturePadDimensions: {
              width: window.innerWidth > window.innerHeight ? sigContainer.offsetWidth : sigContainer.offsetHeight,
              height: window.innerWidth > window.innerHeight ? sigContainer.offsetHeight : sigContainer.offsetWidth
            }
          });
        });
      }, 250);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default.a.sigContainer, ref: 'sigContainer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: window.innerWidth > window.innerHeight ? {} : { transform: 'rotate(90deg)' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_signature_canvas___default.a, {
              canvasProps: {
                className: this.props.showError ? __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default.a.signatureError : '',
                width: this.state.signaturePadDimensions.width,
                height: this.state.signaturePadDimensions.height
              },
              ref: 'signaturePad'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              onClick: function onClick() {
                if (_this3.refs.signaturePad) _this3.refs.signaturePad.clear();
              },
              className: __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default.a.signaturePadReset
            },
            'Clear'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default.a.signatureLine },
            '\xD7'
          ),
          this.props.legalNotice
        ),
        this.props.showError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__Contract_scss___default.a.signatureErrorText },
          'Signature is required'
        )
      );
    }
  }]);

  return SignaturePadComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SignaturePadComponent.propTypes = {
  showError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  legalNotice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  updateSignaturePadRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SignaturePadComponent);

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Terms_Terms__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContractTerms = function (_React$Component) {
  _inherits(ContractTerms, _React$Component);

  function ContractTerms(props) {
    _classCallCheck(this, ContractTerms);

    var _this = _possibleConstructorReturn(this, (ContractTerms.__proto__ || Object.getPrototypeOf(ContractTerms)).call(this, props));

    _this.state = {
      terms: _this.props.node.terms
    };
    _this.termsChangeHandler = _this.termsChangeHandler.bind(_this);
    _this.updateTerms = _this.updateTerms.bind(_this);
    _this.resetTerms = _this.resetTerms.bind(_this);
    _this.createSignatureBlock = _this.createSignatureBlock.bind(_this);
    _this.insertGeneratedTerms = _this.insertGeneratedTerms.bind(_this);
    _this.builderSaveTerms = _this.builderSaveTerms.bind(_this);
    return _this;
  }

  _createClass(ContractTerms, [{
    key: 'signatureBlockFactory',
    value: function signatureBlockFactory() {
      return {
        address_visibility: 'HIDE',
        company_name_visibility: 'HIDE',
        email_visibility: 'SHOW',
        name_visibility: 'SHOW',
        phone_visibility: 'SHOW',
        signer_fills_fields: true,
        title_visibility: 'HIDE'
      };
    }
  }, {
    key: 'termsChangeHandler',
    value: function termsChangeHandler(value) {
      this.setState({ terms: value });
    }
  }, {
    key: 'builderSaveTerms',
    value: function builderSaveTerms(terms, successCb) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to generate contract',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully generated contract terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.setState({ terms: _this2.props.node.terms });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('used-contract-generator');
      };

      this.createSignatureBlock(Object.assign(this.signatureBlockFactory(), { signing_party: 'Client' }), function () {
        return _this2.createSignatureBlock(Object.assign(_this2.signatureBlockFactory(), { signing_party: 'DJ' }), function () {
          return _this2.insertGeneratedTerms(terms, onCompleted, onError);
        }, onError);
      }, onError);
    }
  }, {
    key: 'insertGeneratedTerms',
    value: function insertGeneratedTerms(terms, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };
      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2877);
      });

      var optimisticResponse = {
        updateContract: { contract: { id: id, terms: terms } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            terms: terms
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateTerms',
    value: function updateTerms(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update contract terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated contract terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default terms if null
      var terms = this.state.terms === '<p><br></p>' ? null : this.state.terms;
      var id = this.props.node.id;


      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2878);
      });

      var optimisticResponse = {
        updateContract: { contract: { id: id, terms: terms } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            terms: terms
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetTerms',
    value: function resetTerms() {
      this.setState({ terms: this.props.node.terms });
    }
  }, {
    key: 'createSignatureBlock',
    value: function createSignatureBlock(signatureBlock, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2879);
      });

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_contract_signature_block_edge',
        connectionInfo: [{
          key: 'ContractContainer_contract_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            contract_id: parentID
          }, signatureBlock)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Terms_Terms__["a" /* default */], {
          canEdit: this.props.canEdit,
          localTerms: this.state.terms,
          reset: this.resetTerms,
          terms: this.props.node.terms,
          termsChangeHandler: this.termsChangeHandler,
          updateTerms: this.updateTerms,
          builderSaveTerms: this.builderSaveTerms
        })
      );
    }
  }]);

  return ContractTerms;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTerms.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTerms);

/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContractTitle = function (_React$Component) {
  _inherits(ContractTitle, _React$Component);

  function ContractTitle(props) {
    _classCallCheck(this, ContractTitle);

    var _this = _possibleConstructorReturn(this, (ContractTitle.__proto__ || Object.getPrototypeOf(ContractTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(ContractTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update contract title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated contract title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Contract)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(2880);
        });

        var optimisticResponse = {
          updateContract: { contract: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign,
        placeholder: '(Untitled Contract)'
      });
    }
  }]);

  return ContractTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTitle);

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7b9a508ef29cc3c8b6240727c3f79650
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContractInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteContractMutationVariables = {|
  input: DeleteContractInput
|};
export type ActionsComponent_deleteContractMutationResponse = {|
  +deleteContract: ?{|
    +deletedContractId: ?string
  |}
|};
export type ActionsComponent_deleteContractMutation = {|
  variables: ActionsComponent_deleteContractMutationVariables,
  response: ActionsComponent_deleteContractMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteContractMutation(
  $input: DeleteContractInput!
) {
  deleteContract(input: $input) {
    deletedContractId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContract",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteContractInput!"
    }],
    "concreteType": "DeleteContractPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedContractId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteContractMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteContractMutation(\n  $input: DeleteContractInput!\n) {\n  deleteContract(input: $input) {\n    deletedContractId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteContractMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4f04a515c1d6f53db5b11d90030750e8';
module.exports = node;

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 69dd0fd4372207d9c7ee954e932dbf59
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SaveContractAsTemplateInput = {
  clientMutationId?: ?string,
  contract_id: string,
};
export type ActionsComponent_saveContractAsTemplateMutationVariables = {|
  input: SaveContractAsTemplateInput
|};
export type ActionsComponent_saveContractAsTemplateMutationResponse = {|
  +saveContractAsTemplate: ?{|
    +c_template: ?{|
      +id: string
    |}
  |}
|};
export type ActionsComponent_saveContractAsTemplateMutation = {|
  variables: ActionsComponent_saveContractAsTemplateMutationVariables,
  response: ActionsComponent_saveContractAsTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_saveContractAsTemplateMutation(
  $input: SaveContractAsTemplateInput!
) {
  saveContractAsTemplate(input: $input) {
    c_template {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SaveContractAsTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "saveContractAsTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "SaveContractAsTemplateInput!"
    }],
    "concreteType": "SaveContractAsTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "c_template",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_saveContractAsTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_saveContractAsTemplateMutation(\n  $input: SaveContractAsTemplateInput!\n) {\n  saveContractAsTemplate(input: $input) {\n    c_template {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_saveContractAsTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_saveContractAsTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '117b284fe155726c27abf23896cb0736';
module.exports = node;

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 98ab0df958f2e0c8f30520328af33863
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_Contract_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_Contract_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_Contract_updateBrandMutation = {|
  variables: Brand_Contract_updateBrandMutationVariables,
  response: Brand_Contract_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_Contract_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_Contract_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_Contract_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_Contract_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_Contract_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '83a90bbf7c84dbd3116cc166f4e70850';
module.exports = node;

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5d94d678ed4b467f4ee59c69da5fc50d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractBrandInput = {
  clientMutationId?: ?string,
  contract_id: string,
  brand_id: string,
};
export type Brand_updateContractBrandMutationVariables = {|
  input: UpdateContractBrandInput
|};
export type Brand_updateContractBrandMutationResponse = {|
  +updateContractBrand: ?{|
    +contract: ?{|
      +id: string,
      +brand_header: ?string,
    |}
  |}
|};
export type Brand_updateContractBrandMutation = {|
  variables: Brand_updateContractBrandMutationVariables,
  response: Brand_updateContractBrandMutationResponse,
|};
*/

/*
mutation Brand_updateContractBrandMutation(
  $input: UpdateContractBrandInput!
) {
  updateContractBrand(input: $input) {
    contract {
      id
      brand_header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContractBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateContractBrandInput!"
    }],
    "concreteType": "UpdateContractBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_updateContractBrandMutation",
    "id": null,
    "text": "mutation Brand_updateContractBrandMutation(\n  $input: UpdateContractBrandInput!\n) {\n  updateContractBrand(input: $input) {\n    contract {\n      id\n      brand_header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_updateContractBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_updateContractBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1e66804d3c13a60f19bf5275df78a935';
module.exports = node;

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7790238d617cdc736694fa79355963d0
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddContractToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type ContractComponent_addContractToSessionMutationVariables = {|
  input: AddContractToSessionInput
|};
export type ContractComponent_addContractToSessionMutationResponse = {|
  +addContractToSession: ?{|
    +contract: ?{|
      +id: string
    |}
  |}
|};
export type ContractComponent_addContractToSessionMutation = {|
  variables: ContractComponent_addContractToSessionMutationVariables,
  response: ContractComponent_addContractToSessionMutationResponse,
|};
*/

/*
mutation ContractComponent_addContractToSessionMutation(
  $input: AddContractToSessionInput!
) {
  addContractToSession(input: $input) {
    contract {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddContractToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addContractToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddContractToSessionInput!"
    }],
    "concreteType": "AddContractToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ContractComponent_addContractToSessionMutation",
    "id": null,
    "text": "mutation ContractComponent_addContractToSessionMutation(\n  $input: AddContractToSessionInput!\n) {\n  addContractToSession(input: $input) {\n    contract {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ContractComponent_addContractToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ContractComponent_addContractToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '01a1bf9d21acc3143d3d0448fd0263f6';
module.exports = node;

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 82a5fdcabfd6dad9bd0971874bc53e1f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
export type ContractContainer_RefetchQueryVariables = {|
  id: string
|};
export type ContractContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: ContractContainer_node$ref
  |}
|};
export type ContractContainer_RefetchQuery = {|
  variables: ContractContainer_RefetchQueryVariables,
  response: ContractContainer_RefetchQueryResponse,
|};
*/

/*
query ContractContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...ContractContainer_node
    id
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ContractContainer_RefetchQuery",
    "id": null,
    "text": "query ContractContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContractContainer_node\n    id\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ContractContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContractContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ContractContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Contract",
          "selections": [v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "editable",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_event_segments",
            "storageKey": "contract_event_segments(first:99999)",
            "args": v6,
            "concreteType": "ContractEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_event_segments",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_line_items",
            "storageKey": "contract_line_items(first:99999)",
            "args": v6,
            "concreteType": "ContractLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v5, v2]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_line_items",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_signature_blocks",
            "storageKey": "contract_signature_blocks(first:99999)",
            "args": v6,
            "concreteType": "ContractSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractSignatureBlock",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                }, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, v4, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_signature_blocks",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_signature_blocks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '58240dc9170224435da557f025d4ac90';
module.exports = node;

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractContainer_node$ref: FragmentReference;
export type ContractContainer_node = {|
  +id: string,
  +title: ?string,
  +terms: ?string,
  +can_edit: ?boolean,
  +deletable: ?boolean,
  +editable: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +contract_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +contract_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +contract_signature_blocks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +address: ?string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name: ?string,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email: ?string,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name: ?string,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone: ?string,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signature_type: ?SignatureTypeEnum,
        +signature_typed_name: ?string,
        +signature_url: ?string,
        +signed_at: ?any,
        +signer_fills_fields: ?boolean,
        +signing_party: ?string,
        +share_token: ?string,
        +title: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +user_contacts: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +first_name: ?string,
                +last_name: ?string,
                +user_contact_emails: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +address: ?string
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +$refType: ContractContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "ContractContainer_node",
    "type": "Contract",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["contract_event_segments"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["contract_line_items"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["contract_signature_blocks"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "terms",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "deletable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "editable",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "contract_event_segments",
      "name": "__ContractContainer_contract_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractEventSegmentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractEventSegmentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractEventSegment",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "line1",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "start_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "end_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "time_zone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "all_day",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "line2",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "province",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "postal_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "room",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, v3]
        }, v4]
      }, v5]
    }, {
      "kind": "LinkedField",
      "alias": "contract_line_items",
      "name": "__ContractContainer_contract_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractLineItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractLineItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractLineItem",
          "plural": false,
          "selections": [v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          }, v2, v3]
        }, v4]
      }, v5]
    }, {
      "kind": "LinkedField",
      "alias": "contract_signature_blocks",
      "name": "__ContractContainer_contract_signature_blocks_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlockConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractSignatureBlockEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractSignatureBlock",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "phone_visibility",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "address_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "name_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          }, v6, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signature_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signature_typed_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signature_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signed_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signer_fills_fields",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signing_party",
            "args": null,
            "storageKey": null
          }, v0, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title_visibility",
            "args": null,
            "storageKey": null
          }, v3]
        }, v4]
      }, v5]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v1, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_contacts",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactConnectionWithRole",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "EventUserContactEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContact",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "first_name",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "last_name",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contact_emails",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailConnection",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmailEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContactEmail",
                        "plural": false,
                        "selections": [v6]
                      }]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '3f0aa52e9b1da6498ceb4da57d60f6b3';
module.exports = node;

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type LibraryContainer_viewer$ref = any;
type ScheduleContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractContainer_viewer$ref: FragmentReference;
export type ContractContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +s_time_zone: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref & ScheduleContainer_viewer$ref & LibraryContainer_viewer$ref,
  +$refType: ContractContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "ContractContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "ScheduleContainer_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "FragmentSpread",
      "name": "LibraryContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b6c62fe74aab6d87589241f76521b625';
module.exports = node;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash de4e4e5c633b22e979df2329cbc62887
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToContractInput = {
  clientMutationId?: ?string,
  contract_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_Contract_copyUserLineItemsToContractMutationVariables = {|
  input: CopyUserLineItemsToContractInput
|};
export type Library_Contract_copyUserLineItemsToContractMutationResponse = {|
  +copyUserLineItemsToContract: ?{|
    +contract: ?{|
      +contract_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_Contract_copyUserLineItemsToContractMutation = {|
  variables: Library_Contract_copyUserLineItemsToContractMutationVariables,
  response: Library_Contract_copyUserLineItemsToContractMutationResponse,
|};
*/

/*
mutation Library_Contract_copyUserLineItemsToContractMutation(
  $input: CopyUserLineItemsToContractInput!
) {
  copyUserLineItemsToContract(input: $input) {
    contract {
      contract_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToContractInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "contract_line_items",
    "storageKey": null,
    "args": null,
    "concreteType": "ContractLineItemConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractLineItemEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractLineItem",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_cents",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_currency",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantity",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_Contract_copyUserLineItemsToContractMutation",
    "id": null,
    "text": "mutation Library_Contract_copyUserLineItemsToContractMutation(\n  $input: CopyUserLineItemsToContractInput!\n) {\n  copyUserLineItemsToContract(input: $input) {\n    contract {\n      contract_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_Contract_copyUserLineItemsToContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_Contract_copyUserLineItemsToContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v3, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '46f135548c7e335715dcbe6b92006ba2';
module.exports = node;

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 692e8552f028ab20e02412aaf0753915
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateContractLineItemInput = {
  clientMutationId?: ?string,
  contract_id: string,
  title: string,
  quantity: number,
  price_cents: number,
  price_currency: string,
  description?: ?string,
  add_to_library?: ?boolean,
};
export type Library_Contract_createContractLineItemMutationVariables = {|
  input: CreateContractLineItemInput
|};
export type Library_Contract_createContractLineItemMutationResponse = {|
  +createContractLineItem: ?{|
    +new_contract_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
    +new_user_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
  |}
|};
export type Library_Contract_createContractLineItemMutation = {|
  variables: Library_Contract_createContractLineItemMutationVariables,
  response: Library_Contract_createContractLineItemMutationResponse,
|};
*/

/*
mutation Library_Contract_createContractLineItemMutation(
  $input: CreateContractLineItemInput!
) {
  createContractLineItem(input: $input) {
    new_contract_line_item_edge {
      node {
        id
        title
        description
        position
        price_cents
        price_currency
        quantity
      }
    }
    new_user_line_item_edge {
      node {
        id
        title
        description
        price_cents
        price_currency
        quantity
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractLineItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractLineItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateContractLineItemInput!"
    }],
    "concreteType": "CreateContractLineItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_contract_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractLineItem",
        "plural": false,
        "selections": [v1, v2, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, v4, v5, v6]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "new_user_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserLineItem",
        "plural": false,
        "selections": [v1, v2, v3, v4, v5, v6]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_Contract_createContractLineItemMutation",
    "id": null,
    "text": "mutation Library_Contract_createContractLineItemMutation(\n  $input: CreateContractLineItemInput!\n) {\n  createContractLineItem(input: $input) {\n    new_contract_line_item_edge {\n      node {\n        id\n        title\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n    new_user_line_item_edge {\n      node {\n        id\n        title\n        description\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_Contract_createContractLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_Contract_createContractLineItemMutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5de9cb68b1c3f9011c768f6d005ef09e';
module.exports = node;

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0f04419c875082d2d4e263aefdcdc281
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
export type DeleteContractLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type LineItems_Contract_deleteContractLineItemMutationVariables = {|
  input: DeleteContractLineItemInput
|};
export type LineItems_Contract_deleteContractLineItemMutationResponse = {|
  +deleteContractLineItem: ?{|
    +deletedContractLineItemId: ?string,
    +contract: ?{|
      +$fragmentRefs: ContractContainer_node$ref
    |},
  |}
|};
export type LineItems_Contract_deleteContractLineItemMutation = {|
  variables: LineItems_Contract_deleteContractLineItemMutationVariables,
  response: LineItems_Contract_deleteContractLineItemMutationResponse,
|};
*/

/*
mutation LineItems_Contract_deleteContractLineItemMutation(
  $input: DeleteContractLineItemInput!
) {
  deleteContractLineItem(input: $input) {
    deletedContractLineItemId
    contract {
      ...ContractContainer_node
      id
    }
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteContractLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedContractLineItemId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_Contract_deleteContractLineItemMutation",
    "id": null,
    "text": "mutation LineItems_Contract_deleteContractLineItemMutation(\n  $input: DeleteContractLineItemInput!\n) {\n  deleteContractLineItem(input: $input) {\n    deletedContractLineItemId\n    contract {\n      ...ContractContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_Contract_deleteContractLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteContractLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteContractLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "ContractContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_Contract_deleteContractLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteContractLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteContractLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "editable",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_event_segments",
            "storageKey": "contract_event_segments(first:99999)",
            "args": v6,
            "concreteType": "ContractEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, v7]
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_event_segments",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_line_items",
            "storageKey": "contract_line_items(first:99999)",
            "args": v6,
            "concreteType": "ContractLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractLineItem",
                "plural": false,
                "selections": [v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v5, v7]
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_line_items",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_signature_blocks",
            "storageKey": "contract_signature_blocks(first:99999)",
            "args": v6,
            "concreteType": "ContractSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractSignatureBlock",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                }, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, v3, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v7]
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_signature_blocks",
            "args": v6,
            "handle": "connection",
            "key": "ContractContainer_contract_signature_blocks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v4, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v10, v4]
                            }]
                          }]
                        }, v4]
                      }, v4]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8ab3bbbd608bd702de1b35d86eed576c';
module.exports = node;

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ace722675ec6fa9e42352729722636da
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
export type UpdateContractLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  position?: ?number,
  description?: ?string,
};
export type LineItems_Contract_updateContractLineItemMutationVariables = {|
  input: UpdateContractLineItemInput
|};
export type LineItems_Contract_updateContractLineItemMutationResponse = {|
  +updateContractLineItem: ?{|
    +contract: ?{|
      +$fragmentRefs: ContractContainer_node$ref
    |}
  |}
|};
export type LineItems_Contract_updateContractLineItemMutation = {|
  variables: LineItems_Contract_updateContractLineItemMutationVariables,
  response: LineItems_Contract_updateContractLineItemMutationResponse,
|};
*/

/*
mutation LineItems_Contract_updateContractLineItemMutation(
  $input: UpdateContractLineItemInput!
) {
  updateContractLineItem(input: $input) {
    contract {
      ...ContractContainer_node
      id
    }
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateContractLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_Contract_updateContractLineItemMutation",
    "id": null,
    "text": "mutation LineItems_Contract_updateContractLineItemMutation(\n  $input: UpdateContractLineItemInput!\n) {\n  updateContractLineItem(input: $input) {\n    contract {\n      ...ContractContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_Contract_updateContractLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContractLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "ContractContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_Contract_updateContractLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContractLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "editable",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_event_segments",
            "storageKey": "contract_event_segments(first:99999)",
            "args": v5,
            "concreteType": "ContractEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_event_segments",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_line_items",
            "storageKey": "contract_line_items(first:99999)",
            "args": v5,
            "concreteType": "ContractLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_line_items",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_signature_blocks",
            "storageKey": "contract_signature_blocks(first:99999)",
            "args": v5,
            "concreteType": "ContractSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractSignatureBlock",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                }, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, v2, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_signature_blocks",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_signature_blocks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ead2c40cc94b540cd7caf581ed9871ed';
module.exports = node;

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 390ac1a6c931b5355f705d95b43bf234
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Contract_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Contract_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Contract_Logo_updateBrandMutation = {|
  variables: Logo_Contract_Logo_updateBrandMutationVariables,
  response: Logo_Contract_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Contract_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Contract_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Contract_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Contract_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Contract_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '93e22cbfcee131a6fd5fa5c7d4e3aff4';
module.exports = node;

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5d1734c80613648e45ee4729492134ea
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Contract_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Contract_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Contract_deleteLogo_updateBrandMutation = {|
  variables: Logo_Contract_deleteLogo_updateBrandMutationVariables,
  response: Logo_Contract_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Contract_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Contract_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Contract_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Contract_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Contract_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '006d2641f8087932b5904317ab86d99b';
module.exports = node;

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bfa500ed28441b14d9507d32a5c75ccd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractBrandInput = {
  clientMutationId?: ?string,
  contract_id: string,
  brand_id: string,
};
export type Logo_updateContractBrandMutationVariables = {|
  input: UpdateContractBrandInput
|};
export type Logo_updateContractBrandMutationResponse = {|
  +updateContractBrand: ?{|
    +contract: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateContractBrandMutation = {|
  variables: Logo_updateContractBrandMutationVariables,
  response: Logo_updateContractBrandMutationResponse,
|};
*/

/*
mutation Logo_updateContractBrandMutation(
  $input: UpdateContractBrandInput!
) {
  updateContractBrand(input: $input) {
    contract {
      id
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContractBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateContractBrandInput!"
    }],
    "concreteType": "UpdateContractBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_updateContractBrandMutation",
    "id": null,
    "text": "mutation Logo_updateContractBrandMutation(\n  $input: UpdateContractBrandInput!\n) {\n  updateContractBrand(input: $input) {\n    contract {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_updateContractBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_updateContractBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a8be9c281bf639122d250534cd58072d';
module.exports = node;

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b0283ba18e41560a29b8c62e9f9a41fb
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateContractEventSegmentInput = {
  clientMutationId?: ?string,
  contract_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_Contract_createContractEventSegmentMutationVariables = {|
  input: CreateContractEventSegmentInput
|};
export type Schedule_Contract_createContractEventSegmentMutationResponse = {|
  +createContractEventSegment: ?{|
    +new_contract_event_segment_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}
  |}
|};
export type Schedule_Contract_createContractEventSegmentMutation = {|
  variables: Schedule_Contract_createContractEventSegmentMutationVariables,
  response: Schedule_Contract_createContractEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_Contract_createContractEventSegmentMutation(
  $input: CreateContractEventSegmentInput!
) {
  createContractEventSegment(input: $input) {
    new_contract_event_segment_edge {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateContractEventSegmentInput!"
    }],
    "concreteType": "CreateContractEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_contract_event_segment_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractEventSegmentEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractEventSegment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "start_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "end_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "all_day",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "location",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "city",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "province",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "postal_code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "room",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_Contract_createContractEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_Contract_createContractEventSegmentMutation(\n  $input: CreateContractEventSegmentInput!\n) {\n  createContractEventSegment(input: $input) {\n    new_contract_event_segment_edge {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_Contract_createContractEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_Contract_createContractEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '987ef798aed143f7bb0a3f874c7ee5e4';
module.exports = node;

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5ab4e30aa6e2191c953a97eaed8023ce
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContractEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Schedule_Contract_deleteContractEventSegmentMutationVariables = {|
  input: DeleteContractEventSegmentInput
|};
export type Schedule_Contract_deleteContractEventSegmentMutationResponse = {|
  +deleteContractEventSegment: ?{|
    +deletedContractEventSegmentId: ?string
  |}
|};
export type Schedule_Contract_deleteContractEventSegmentMutation = {|
  variables: Schedule_Contract_deleteContractEventSegmentMutationVariables,
  response: Schedule_Contract_deleteContractEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_Contract_deleteContractEventSegmentMutation(
  $input: DeleteContractEventSegmentInput!
) {
  deleteContractEventSegment(input: $input) {
    deletedContractEventSegmentId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContractEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteContractEventSegmentInput!"
    }],
    "concreteType": "DeleteContractEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedContractEventSegmentId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_Contract_deleteContractEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_Contract_deleteContractEventSegmentMutation(\n  $input: DeleteContractEventSegmentInput!\n) {\n  deleteContractEventSegment(input: $input) {\n    deletedContractEventSegmentId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_Contract_deleteContractEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_Contract_deleteContractEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5eaeb8ba2d8b17bfadee77cca07ca887';
module.exports = node;

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 907dae54dc37865f8018e96369c605c3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_Contract_updateContractEventSegmentMutationVariables = {|
  input: UpdateContractEventSegmentInput
|};
export type Schedule_Contract_updateContractEventSegmentMutationResponse = {|
  +updateContractEventSegment: ?{|
    +contract_event_segment: ?{|
      +id: string,
      +title: ?string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +all_day: ?boolean,
      +location: ?string,
      +line1: ?string,
      +line2: ?string,
      +city: ?string,
      +province: ?string,
      +postal_code: ?string,
      +room: ?string,
      +notes: ?string,
    |}
  |}
|};
export type Schedule_Contract_updateContractEventSegmentMutation = {|
  variables: Schedule_Contract_updateContractEventSegmentMutationVariables,
  response: Schedule_Contract_updateContractEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_Contract_updateContractEventSegmentMutation(
  $input: UpdateContractEventSegmentInput!
) {
  updateContractEventSegment(input: $input) {
    contract_event_segment {
      id
      title
      start_at
      end_at
      time_zone
      all_day
      location
      line1
      line2
      city
      province
      postal_code
      room
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContractEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateContractEventSegmentInput!"
    }],
    "concreteType": "UpdateContractEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract_event_segment",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractEventSegment",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "line1",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "start_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "end_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "time_zone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "all_day",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "location",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "line2",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "province",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "postal_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "room",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_Contract_updateContractEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_Contract_updateContractEventSegmentMutation(\n  $input: UpdateContractEventSegmentInput!\n) {\n  updateContractEventSegment(input: $input) {\n    contract_event_segment {\n      id\n      title\n      start_at\n      end_at\n      time_zone\n      all_day\n      location\n      line1\n      line2\n      city\n      province\n      postal_code\n      room\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_Contract_updateContractEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_Contract_updateContractEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f7a404a6cf516bcd80898c9d896b5999';
module.exports = node;

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 43870680467ab01a9db7438ad3e06905
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
export type SignContractInput = {
  clientMutationId?: ?string,
  contract_signature_block_id: string,
  signature_type: SignatureTypeEnum,
  name?: ?string,
  email?: ?string,
  title?: ?string,
  company_name?: ?string,
  phone?: ?string,
  address?: ?string,
  signature_url?: ?string,
  signature_size?: ?number,
  signature_mimetype?: ?string,
  signature_handle?: ?string,
  signature_typed_name?: ?string,
};
export type Sign_signContractMutationVariables = {|
  input: SignContractInput
|};
export type Sign_signContractMutationResponse = {|
  +signContract: ?{|
    +contract: ?{|
      +$fragmentRefs: ContractContainer_node$ref
    |}
  |}
|};
export type Sign_signContractMutation = {|
  variables: Sign_signContractMutationVariables,
  response: Sign_signContractMutationResponse,
|};
*/

/*
mutation Sign_signContractMutation(
  $input: SignContractInput!
) {
  signContract(input: $input) {
    contract {
      ...ContractContainer_node
      id
    }
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SignContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SignContractInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Sign_signContractMutation",
    "id": null,
    "text": "mutation Sign_signContractMutation(\n  $input: SignContractInput!\n) {\n  signContract(input: $input) {\n    contract {\n      ...ContractContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Sign_signContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "signContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "SignContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "ContractContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Sign_signContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "signContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "SignContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "editable",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_event_segments",
            "storageKey": "contract_event_segments(first:99999)",
            "args": v5,
            "concreteType": "ContractEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_event_segments",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_line_items",
            "storageKey": "contract_line_items(first:99999)",
            "args": v5,
            "concreteType": "ContractLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_line_items",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_signature_blocks",
            "storageKey": "contract_signature_blocks(first:99999)",
            "args": v5,
            "concreteType": "ContractSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractSignatureBlock",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                }, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, v2, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_signature_blocks",
            "args": v5,
            "handle": "connection",
            "key": "ContractContainer_contract_signature_blocks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7d46a5affe26a5e94c384a448c4e557a';
module.exports = node;

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 485e430f55048f18cf3b76d360f09a20
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContractSignatureBlockInput = {
  clientMutationId?: ?string,
  id: string,
};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutationVariables = {|
  input: DeleteContractSignatureBlockInput
|};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutationResponse = {|
  +deleteContractSignatureBlock: ?{|
    +deletedContractSignatureBlockId: ?string
  |}
|};
export type SignatureBlocks_Contract_deleteContractSignatureBlockMutation = {|
  variables: SignatureBlocks_Contract_deleteContractSignatureBlockMutationVariables,
  response: SignatureBlocks_Contract_deleteContractSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_Contract_deleteContractSignatureBlockMutation(
  $input: DeleteContractSignatureBlockInput!
) {
  deleteContractSignatureBlock(input: $input) {
    deletedContractSignatureBlockId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContractSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteContractSignatureBlockInput!"
    }],
    "concreteType": "DeleteContractSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedContractSignatureBlockId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_Contract_deleteContractSignatureBlockMutation(\n  $input: DeleteContractSignatureBlockInput!\n) {\n  deleteContractSignatureBlock(input: $input) {\n    deletedContractSignatureBlockId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_Contract_deleteContractSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fc5d291826c284800dc169c1cfd8143f';
module.exports = node;

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 92051a5624637559605cc5bb3a93a8c8
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
export type UpdateContractSignatureBlockInput = {
  clientMutationId?: ?string,
  id: string,
  signing_party?: ?string,
  name_visibility?: ?SignatureBlockFieldVisibility,
  name?: ?string,
  email_visibility?: ?SignatureBlockFieldVisibility,
  email?: ?string,
  title_visibility?: ?SignatureBlockFieldVisibility,
  title?: ?string,
  company_name_visibility?: ?SignatureBlockFieldVisibility,
  company_name?: ?string,
  phone_visibility?: ?SignatureBlockFieldVisibility,
  phone?: ?string,
  address_visibility?: ?SignatureBlockFieldVisibility,
  address?: ?string,
  signer_fills_fields?: ?boolean,
};
export type SignatureBlocks_Contract_updateContractSignatureBlockMutationVariables = {|
  input: UpdateContractSignatureBlockInput
|};
export type SignatureBlocks_Contract_updateContractSignatureBlockMutationResponse = {|
  +updateContractSignatureBlock: ?{|
    +contract_signature_block: ?{|
      +id: string,
      +address: ?string,
      +address_visibility: ?SignatureBlockFieldVisibility,
      +company_name: ?string,
      +company_name_visibility: ?SignatureBlockFieldVisibility,
      +email: ?string,
      +email_visibility: ?SignatureBlockFieldVisibility,
      +name: ?string,
      +name_visibility: ?SignatureBlockFieldVisibility,
      +phone: ?string,
      +phone_visibility: ?SignatureBlockFieldVisibility,
      +signature_type: ?SignatureTypeEnum,
      +signature_typed_name: ?string,
      +signed_at: ?any,
      +signer_fills_fields: ?boolean,
      +signing_party: ?string,
      +share_token: ?string,
      +title: ?string,
      +title_visibility: ?SignatureBlockFieldVisibility,
    |}
  |}
|};
export type SignatureBlocks_Contract_updateContractSignatureBlockMutation = {|
  variables: SignatureBlocks_Contract_updateContractSignatureBlockMutationVariables,
  response: SignatureBlocks_Contract_updateContractSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_Contract_updateContractSignatureBlockMutation(
  $input: UpdateContractSignatureBlockInput!
) {
  updateContractSignatureBlock(input: $input) {
    contract_signature_block {
      id
      address
      address_visibility
      company_name
      company_name_visibility
      email
      email_visibility
      name
      name_visibility
      phone
      phone_visibility
      signature_type
      signature_typed_name
      signed_at
      signer_fills_fields
      signing_party
      share_token
      title
      title_visibility
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContractSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateContractSignatureBlockInput!"
    }],
    "concreteType": "UpdateContractSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract_signature_block",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlock",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "phone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "address_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "name_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "address",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "phone_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signature_type",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signature_typed_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signed_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signer_fills_fields",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signing_party",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "share_token",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title_visibility",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_Contract_updateContractSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_Contract_updateContractSignatureBlockMutation(\n  $input: UpdateContractSignatureBlockInput!\n) {\n  updateContractSignatureBlock(input: $input) {\n    contract_signature_block {\n      id\n      address\n      address_visibility\n      company_name\n      company_name_visibility\n      email\n      email_visibility\n      name\n      name_visibility\n      phone\n      phone_visibility\n      signature_type\n      signature_typed_name\n      signed_at\n      signer_fills_fields\n      signing_party\n      share_token\n      title\n      title_visibility\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_Contract_updateContractSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_Contract_updateContractSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ed678a6b5d9469c6f384ef940233b97b';
module.exports = node;

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 07022acd2338cbea86e518673611dbd0
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
export type CreateContractSignatureBlockInput = {
  clientMutationId?: ?string,
  contract_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  name?: ?string,
  email_visibility: SignatureBlockFieldVisibility,
  email?: ?string,
  title_visibility: SignatureBlockFieldVisibility,
  title?: ?string,
  company_name_visibility: SignatureBlockFieldVisibility,
  company_name?: ?string,
  phone_visibility: SignatureBlockFieldVisibility,
  phone?: ?string,
  address_visibility: SignatureBlockFieldVisibility,
  address?: ?string,
  signer_fills_fields: boolean,
};
export type SignatureBlocks_createContractSignatureBlockMutationVariables = {|
  input: CreateContractSignatureBlockInput
|};
export type SignatureBlocks_createContractSignatureBlockMutationResponse = {|
  +createContractSignatureBlock: ?{|
    +new_contract_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address: ?string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name: ?string,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email: ?string,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name: ?string,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone: ?string,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signature_type: ?SignatureTypeEnum,
        +signature_typed_name: ?string,
        +signed_at: ?any,
        +signer_fills_fields: ?boolean,
        +signing_party: ?string,
        +share_token: ?string,
        +title: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type SignatureBlocks_createContractSignatureBlockMutation = {|
  variables: SignatureBlocks_createContractSignatureBlockMutationVariables,
  response: SignatureBlocks_createContractSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_createContractSignatureBlockMutation(
  $input: CreateContractSignatureBlockInput!
) {
  createContractSignatureBlock(input: $input) {
    new_contract_signature_block_edge {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateContractSignatureBlockInput!"
    }],
    "concreteType": "CreateContractSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_contract_signature_block_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlockEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractSignatureBlock",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signature_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signature_typed_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signed_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signer_fills_fields",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signing_party",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "share_token",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title_visibility",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_createContractSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_createContractSignatureBlockMutation(\n  $input: CreateContractSignatureBlockInput!\n) {\n  createContractSignatureBlock(input: $input) {\n    new_contract_signature_block_edge {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_createContractSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_createContractSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f5a05b0c4c61675e884ad4b4f3ad4a4a';
module.exports = node;

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 156eeacaa2f5eacdfe726a1f77a91f71
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
};
export type Terms_Contract_Generated_UpdateContractMutationVariables = {|
  input: UpdateContractInput
|};
export type Terms_Contract_Generated_UpdateContractMutationResponse = {|
  +updateContract: ?{|
    +contract: ?{|
      +terms: ?string
    |}
  |}
|};
export type Terms_Contract_Generated_UpdateContractMutation = {|
  variables: Terms_Contract_Generated_UpdateContractMutationVariables,
  response: Terms_Contract_Generated_UpdateContractMutationResponse,
|};
*/

/*
mutation Terms_Contract_Generated_UpdateContractMutation(
  $input: UpdateContractInput!
) {
  updateContract(input: $input) {
    contract {
      terms
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateContractInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "terms",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_Contract_Generated_UpdateContractMutation",
    "id": null,
    "text": "mutation Terms_Contract_Generated_UpdateContractMutation(\n  $input: UpdateContractInput!\n) {\n  updateContract(input: $input) {\n    contract {\n      terms\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_Contract_Generated_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_Contract_Generated_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '689133ea3e3e528df39fa6d460960dc5';
module.exports = node;

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 42192a85e94ae77ed28c2771bbd013ae
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
};
export type Terms_Contract_UpdateContractMutationVariables = {|
  input: UpdateContractInput
|};
export type Terms_Contract_UpdateContractMutationResponse = {|
  +updateContract: ?{|
    +contract: ?{|
      +terms: ?string
    |}
  |}
|};
export type Terms_Contract_UpdateContractMutation = {|
  variables: Terms_Contract_UpdateContractMutationVariables,
  response: Terms_Contract_UpdateContractMutationResponse,
|};
*/

/*
mutation Terms_Contract_UpdateContractMutation(
  $input: UpdateContractInput!
) {
  updateContract(input: $input) {
    contract {
      terms
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateContractInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "terms",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_Contract_UpdateContractMutation",
    "id": null,
    "text": "mutation Terms_Contract_UpdateContractMutation(\n  $input: UpdateContractInput!\n) {\n  updateContract(input: $input) {\n    contract {\n      terms\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_Contract_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_Contract_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8412b09961936feca35e7adeaa7d72e9';
module.exports = node;

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 322b5c7ee431c70f7f705a71f1779f0f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
export type CreateContractSignatureBlockInput = {
  clientMutationId?: ?string,
  contract_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  name?: ?string,
  email_visibility: SignatureBlockFieldVisibility,
  email?: ?string,
  title_visibility: SignatureBlockFieldVisibility,
  title?: ?string,
  company_name_visibility: SignatureBlockFieldVisibility,
  company_name?: ?string,
  phone_visibility: SignatureBlockFieldVisibility,
  phone?: ?string,
  address_visibility: SignatureBlockFieldVisibility,
  address?: ?string,
  signer_fills_fields: boolean,
};
export type Terms_createContractSignatureBlockMutationVariables = {|
  input: CreateContractSignatureBlockInput
|};
export type Terms_createContractSignatureBlockMutationResponse = {|
  +createContractSignatureBlock: ?{|
    +new_contract_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address: ?string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name: ?string,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email: ?string,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name: ?string,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone: ?string,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signature_type: ?SignatureTypeEnum,
        +signature_typed_name: ?string,
        +signed_at: ?any,
        +signer_fills_fields: ?boolean,
        +signing_party: ?string,
        +share_token: ?string,
        +title: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type Terms_createContractSignatureBlockMutation = {|
  variables: Terms_createContractSignatureBlockMutationVariables,
  response: Terms_createContractSignatureBlockMutationResponse,
|};
*/

/*
mutation Terms_createContractSignatureBlockMutation(
  $input: CreateContractSignatureBlockInput!
) {
  createContractSignatureBlock(input: $input) {
    new_contract_signature_block_edge {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createContractSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateContractSignatureBlockInput!"
    }],
    "concreteType": "CreateContractSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_contract_signature_block_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlockEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractSignatureBlock",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "phone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signature_type",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signature_typed_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signed_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signer_fills_fields",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signing_party",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "share_token",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title_visibility",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_createContractSignatureBlockMutation",
    "id": null,
    "text": "mutation Terms_createContractSignatureBlockMutation(\n  $input: CreateContractSignatureBlockInput!\n) {\n  createContractSignatureBlock(input: $input) {\n    new_contract_signature_block_edge {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_createContractSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_createContractSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'bd27d7f9b2cd9cb5af17d1c306e51db0';
module.exports = node;

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash acd11991f38e73399aa2ead0316f3759
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
};
export type Title_Contract_UpdateContractMutationVariables = {|
  input: UpdateContractInput
|};
export type Title_Contract_UpdateContractMutationResponse = {|
  +updateContract: ?{|
    +contract: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_Contract_UpdateContractMutation = {|
  variables: Title_Contract_UpdateContractMutationVariables,
  response: Title_Contract_UpdateContractMutationResponse,
|};
*/

/*
mutation Title_Contract_UpdateContractMutation(
  $input: UpdateContractInput!
) {
  updateContract(input: $input) {
    contract {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateContractInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_Contract_UpdateContractMutation",
    "id": null,
    "text": "mutation Title_Contract_UpdateContractMutation(\n  $input: UpdateContractInput!\n) {\n  updateContract(input: $input) {\n    contract {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_Contract_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_Contract_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateContractPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "contract",
          "storageKey": null,
          "args": null,
          "concreteType": "Contract",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '73ca08ee7b1c0a3d9954a61decf3c7f0';
module.exports = node;

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EstimateBrand = function (_React$Component) {
  _inherits(EstimateBrand, _React$Component);

  function EstimateBrand(props) {
    _classCallCheck(this, EstimateBrand);

    var _this = _possibleConstructorReturn(this, (EstimateBrand.__proto__ || Object.getPrototypeOf(EstimateBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromEstimate()
    };
    _this.getBrandFromEstimate = _this.getBrandFromEstimate.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.updateEstimateBrand = _this.updateEstimateBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(EstimateBrand, [{
    key: 'getBrandFromEstimate',
    value: function getBrandFromEstimate() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['brand_header']);
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.updateEstimateBrand(successCb, failureCb);
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2894);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateEstimateBrand',
    value: function updateEstimateBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2895);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            estimate_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromEstimate();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromEstimate(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return EstimateBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EstimateBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateBrand);

/***/ }),
/* 2882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(2884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Schedule__ = __webpack_require__(2890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LineItems__ = __webpack_require__(2886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Library__ = __webpack_require__(2885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Brand__ = __webpack_require__(2881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Logo__ = __webpack_require__(2887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Recipient__ = __webpack_require__(2889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Actions__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Notes__ = __webpack_require__(2888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var Estimate = (_temp = _class = function (_React$Component) {
  _inherits(Estimate, _React$Component);

  function Estimate(props) {
    _classCallCheck(this, Estimate);

    var _this = _possibleConstructorReturn(this, (Estimate.__proto__ || Object.getPrototypeOf(Estimate)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.hasRecipient = _this.hasRecipient.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(Estimate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.node && this.props.location.query.share_token) this.addEstimateToSession();
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'addEstimateToSession',
    value: function addEstimateToSession() {
      var _this2 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this2.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null);
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2896);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'hasRecipient',
    value: function hasRecipient() {
      var node = this.props.node;

      return (node.recipient_first_name || node.recipient_last_name || node.recipient_company_name || node.recipient_phone || node.recipient_email || node.recipient_address) && true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var window = _ref.window;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Actions__["a" /* default */], {
            node: _this3.props.node,
            params: _this3.props.params,
            relay: _this3.props.relay,
            router: _this3.props.router,
            windowDimensions: window
          });
        }
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref2) {
          var isComputer = _ref2.isComputer,
              isLargeScreen = _ref2.isLargeScreen,
              isMobile = _ref2.isMobile,
              window = _ref2.window;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            _this3.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_sidebar___default.a,
              {
                sidebar: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App_SidebarComponent__["a" /* default */], {
                  setSidebarOpenState: _this3.onSetSidebarOpen,
                  router: _this3.props.router,
                  viewer: _this3.props.viewer
                }),
                sidebarClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.sidebar,
                open: _this3.state.sidebarOpen,
                onSetOpen: _this3.onSetSidebarOpen,
                touch: false,
                contentClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarContent,
                rootClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarRoot
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], {
                toggleSidebar: _this3.toggleSidebar,
                sidebarOpen: _this3.state.sidebarOpen,
                document: _this3.props.node,
                relay: _this3.props.relay,
                router: _this3.props.router,
                params: _this3.props.params,
                viewer: _this3.props.viewer,
                windowDimensions: window
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["s" /* Container */],
                { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.container },
                !isLargeScreen && isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                    { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuTablet },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      ActionsMenu
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["t" /* Segment */],
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.segment },
                  isLargeScreen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["u" /* Rail */],
                    { position: 'right', close: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuDesktop },
                    ActionsMenu
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                    { padded: true, relaxed: true, stackable: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      {
                        columns: 'equal',
                        verticalAlign: 'bottom',
                        style: { paddingBottom: 0 }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { only: 'tablet computer', textAlign: 'right' },
                        (_this3.hasRecipient() || _this3.canEdit()) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'h3',
                          { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.to },
                          'To:'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Brand__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { only: 'mobile', style: { paddingBottom: 0 } },
                        (_this3.hasRecipient() || _this3.canEdit()) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'h3',
                          { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.to },
                          'To:'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { textAlign: isMobile ? 'left' : 'right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Recipient__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.estimate_event_segments.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Schedule'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Schedule__["a" /* default */], {
                          estimateEventSegments: _this3.props.node.estimate_event_segments.edges,
                          viewer: _this3.props.viewer,
                          relay: _this3.props.relay,
                          readOnly: !_this3.canEdit(),
                          node: _this3.props.node
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.estimate_line_items.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Line Items'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__LineItems__["a" /* default */], {
                          canHideTotal: _this3.props.viewer && _this3.props.viewer.features.hide_estimate_total,
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          canEdit: _this3.canEdit()
                        })
                      )
                    ),
                    _this3.canEdit() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Library__["a" /* default */], {
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          viewer: _this3.props.viewer
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.notes) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Notes'
                        )
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.notes) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Notes__["a" /* default */], {
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          canEdit: _this3.canEdit()
                        })
                      )
                    )
                  )
                )
              )
            ),
            !_this3.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              _this3.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App_404__["a" /* default */], { viewer: _this3.props.viewer }),
              !_this3.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements__["a" /* Loader */], null)
            )
          );
        }
      );
    }
  }]);

  return Estimate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_found__["withRouter"])(Estimate));

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EstimateComponent__ = __webpack_require__(2882);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__EstimateComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(2898);
  },
  viewer: function viewer() {
    return __webpack_require__(2899);
  }
}, function () {
  return __webpack_require__(2897);
}));

/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(2892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var EstimatetHeader = function (_React$Component) {
  _inherits(EstimatetHeader, _React$Component);

  function EstimatetHeader(props) {
    _classCallCheck(this, EstimatetHeader);

    var _this = _possibleConstructorReturn(this, (EstimatetHeader.__proto__ || Object.getPrototypeOf(EstimatetHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(EstimatetHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return EstimatetHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimatetHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimatetHeader);

/***/ }),
/* 2885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__ = __webpack_require__(529);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EstimateLibrary = function (_React$Component) {
  _inherits(EstimateLibrary, _React$Component);

  function EstimateLibrary(props) {
    _classCallCheck(this, EstimateLibrary);

    var _this = _possibleConstructorReturn(this, (EstimateLibrary.__proto__ || Object.getPrototypeOf(EstimateLibrary)).call(this, props));

    _this.copyLibraryLineItemsToEstimate = _this.copyLibraryLineItemsToEstimate.bind(_this);
    _this.createLineItem = _this.createLineItem.bind(_this);
    _this.resetNewLibraryLineItem = _this.resetNewLibraryLineItem.bind(_this);
    _this.newLibraryLineItemChangeHandler = _this.newLibraryLineItemChangeHandler.bind(_this);
    return _this;
  }

  _createClass(EstimateLibrary, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Initialize new library line item
      this.resetNewLibraryLineItem();
    }
  }, {
    key: 'copyLibraryLineItemsToEstimate',
    value: function copyLibraryLineItemsToEstimate(itemsToCopy) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('added-line-items-from-library', {
          item_count: itemsToCopy.length
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2900);
      });

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        var estimateProxy = store.get(_this2.props.node.id);
        var payload = store.getRootField('copyUserLineItemsToEstimate');
        var newEstimateLineItems = payload.getLinkedRecord('estimate').getLinkedRecord('estimate_line_items');
        var conn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(estimateProxy, 'EstimateContainer_estimate_line_items');
        conn.copyFieldsFrom(newEstimateLineItems);
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            estimate_id: parentID,
            user_line_item_ids: itemsToCopy
          }
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createLineItem',
    value: function createLineItem(idx, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this3.resetNewLibraryLineItem();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2901);
      });

      var newLineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newLibraryLineItem), 'title', 'description', 'price_cents', 'price_currency', 'quantity');

      newLineItem.quantity = parseInt(newLineItem.quantity, 10);

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        // Update estimate
        var estimateProxy = store.get(_this3.props.node.id);
        var payload = store.getRootField('createEstimateLineItem');
        var newEstimateLineItemEdge = payload.getLinkedRecord('new_estimate_line_item_edge');
        var estimateLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(estimateProxy, 'EstimateContainer_estimate_line_items');
        __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(estimateLineItemConn, newEstimateLineItemEdge);

        // Update viewer if adding to library
        if (_this3.state.newLibraryLineItem.addToLibrary) {
          var viewerProxy = store.get(_this3.props.viewer.id);
          var newUserLineItemEdge = payload.getLinkedRecord('new_user_line_item_edge');
          var userLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'LibraryContainer_user_line_items');
          __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(userLineItemConn, newUserLineItemEdge);
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            estimate_id: parentID
          }, newLineItem, {
            add_to_library: this.state.newLibraryLineItem.addToLibrary
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetNewLibraryLineItem',
    value: function resetNewLibraryLineItem() {
      this.setState({
        newLibraryLineItem: {
          title: '',
          description: '',
          quantity: 1,
          price_cents: 0,
          price_currency: 'USD',
          addToLibrary: false
        }
      });
    }
  }, {
    key: 'newLibraryLineItemChangeHandler',
    value: function newLibraryLineItemChangeHandler(lineItem) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newLibraryLineItem = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'render',
    value: function render() {
      var estimateLineItems = this.props.node.estimate_line_items.edges;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__["a" /* default */], {
        initiallyExpanded: estimateLineItems.length === 0,
        newLibraryLineItem: this.state.newLibraryLineItem,
        newLibraryLineItemChangeHandler: this.newLibraryLineItemChangeHandler,
        resetNewLibraryLineItem: this.resetNewLibraryLineItem,
        createLineItem: this.createLineItem,
        copyLibraryLineItemsToDocument: this.copyLibraryLineItemsToEstimate,
        viewer: this.props.viewer,
        relay: this.props.relay
      });
    }
  }]);

  return EstimateLibrary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EstimateLibrary.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateLibrary);

/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_array__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EstimateLineItems = function (_React$Component) {
  _inherits(EstimateLineItems, _React$Component);

  function EstimateLineItems(props) {
    _classCallCheck(this, EstimateLineItems);

    var _this = _possibleConstructorReturn(this, (EstimateLineItems.__proto__ || Object.getPrototypeOf(EstimateLineItems)).call(this, props));

    _this.state = {
      localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.estimate_line_items.edges)
    };
    _this.deleteLineItem = _this.deleteLineItem.bind(_this);
    _this.resetEditLineItem = _this.resetEditLineItem.bind(_this);
    _this.lineItemChangeHandler = _this.lineItemChangeHandler.bind(_this);
    _this.updateLineItem = _this.updateLineItem.bind(_this);
    _this.moveLineItem = _this.moveLineItem.bind(_this);
    _this.toggleHideTotal = _this.toggleHideTotal.bind(_this);
    return _this;
  }

  _createClass(EstimateLineItems, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localLineItems if any edges are added/deleted
      this.setState({
        localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.estimate_line_items.edges)
      });
    }
  }, {
    key: 'lineItemChangeHandler',
    value: function lineItemChangeHandler(lineItem, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx].node = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'resetEditLineItem',
    value: function resetEditLineItem(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.estimate_line_items.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'moveLineItem',
    value: function moveLineItem(source, destination) {
      var _this2 = this;

      var localLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_array__["a" /* arrayMove */])(this.state.localLineItems, source, destination);
      localLineItems[destination].node.position = destination + 1;
      this.setState({
        localLineItems: localLineItems
      }, function () {
        return _this2.updateLineItem(destination);
      });
    }
  }, {
    key: 'updateLineItem',
    value: function updateLineItem(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-line-item');
      };
      var lineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localLineItems[idx].node), ['id', 'description', 'position', 'price_cents', 'price_currency', 'quantity', 'title']);

      lineItem.quantity = parseInt(lineItem.quantity, 10);

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2904);
      });

      var estimate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node);
      estimate.estimate_line_items.edges = this.state.localLineItems;
      var optimisticResponse = {
        updateEstimateLineItem: { estimate: estimate }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, lineItem)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteLineItem',
    value: function deleteLineItem(idx, successCb, failureCb) {
      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2903);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['estimate', 'estimate_line_items'],
        deletedIDFieldName: 'deletedEstimateLineItemId',
        connectionKeys: [{
          key: 'EstimateContainer_estimate_line_items',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.estimate_line_items.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'toggleHideTotal',
    value: function toggleHideTotal(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update invoice',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var _props$node = this.props.node,
          id = _props$node.id,
          hideTotal = _props$node.hide_total;


      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2902);
      });

      var optimisticResponse = {
        updateEstimate: { estimate: { id: id, hide_total: !hideTotal } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            hide_total: !hideTotal
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__["a" /* default */], {
        canHideTotal: this.props.canHideTotal,
        toggleHideTotal: this.toggleHideTotal,
        lineItems: this.props.node.estimate_line_items.edges,
        localLineItems: this.state.localLineItems,
        updateLineItem: this.updateLineItem,
        deleteLineItem: this.deleteLineItem,
        resetEditLineItem: this.resetEditLineItem,
        lineItemChangeHandler: this.lineItemChangeHandler,
        readOnly: !this.props.canEdit,
        hideTotal: this.props.node.hide_total,
        moveLineItem: this.moveLineItem
      });
    }
  }]);

  return EstimateLineItems;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EstimateLineItems.propTypes = {
  canHideTotal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateLineItems);

/***/ }),
/* 2887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var EstimateLogo = function (_React$Component) {
  _inherits(EstimateLogo, _React$Component);

  function EstimateLogo(props) {
    _classCallCheck(this, EstimateLogo);

    var _this = _possibleConstructorReturn(this, (EstimateLogo.__proto__ || Object.getPrototypeOf(EstimateLogo)).call(this, props));

    _this.updateEstimateLogo = _this.updateEstimateLogo.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(EstimateLogo, [{
    key: 'updateEstimateLogo',
    value: function updateEstimateLogo(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2907);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            estimate_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.updateEstimateLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2905);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this3 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this4.updateEstimateLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2906);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand_logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return EstimateLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimateLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateLogo);

/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Notes_Notes__ = __webpack_require__(3116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EstimateNotes = function (_React$Component) {
  _inherits(EstimateNotes, _React$Component);

  function EstimateNotes(props) {
    _classCallCheck(this, EstimateNotes);

    var _this = _possibleConstructorReturn(this, (EstimateNotes.__proto__ || Object.getPrototypeOf(EstimateNotes)).call(this, props));

    _this.state = {
      notes: _this.props.node.notes
    };
    _this.notesChangeHandler = _this.notesChangeHandler.bind(_this);
    _this.updateNotes = _this.updateNotes.bind(_this);
    _this.resetNotes = _this.resetNotes.bind(_this);
    return _this;
  }

  _createClass(EstimateNotes, [{
    key: 'notesChangeHandler',
    value: function notesChangeHandler(value) {
      this.setState({ notes: value });
    }
  }, {
    key: 'updateNotes',
    value: function updateNotes(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update estimate notes',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated estimate notes',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default notes if null
      var notes = this.state.notes === '<p><br></p>' ? null : this.state.notes;
      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2908);
      });

      var optimisticResponse = {
        updateEstimate: { estimate: { id: id, notes: notes } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            notes: notes
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetNotes',
    value: function resetNotes() {
      this.setState({ notes: this.props.node.notes });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Notes_Notes__["a" /* default */], {
          canEdit: this.props.canEdit,
          localNotes: this.state.notes,
          reset: this.resetNotes,
          notes: this.props.node.notes,
          notesChangeHandler: this.notesChangeHandler,
          updateNotes: this.updateNotes
        })
      );
    }
  }]);

  return EstimateNotes;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimateNotes.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateNotes);

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Recipient_Recipient__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EstimateRecipient = function (_React$Component) {
  _inherits(EstimateRecipient, _React$Component);

  function EstimateRecipient(props) {
    _classCallCheck(this, EstimateRecipient);

    var _this = _possibleConstructorReturn(this, (EstimateRecipient.__proto__ || Object.getPrototypeOf(EstimateRecipient)).call(this, props));

    _this.state = {
      localRecipient: _this.getRecipientFromEstimate()
    };
    _this.getRecipientFromEstimate = _this.getRecipientFromEstimate.bind(_this);
    _this.updateRecipient = _this.updateRecipient.bind(_this);
    _this.resetRecipient = _this.resetRecipient.bind(_this);
    _this.recipientChangeHandler = _this.recipientChangeHandler.bind(_this);
    return _this;
  }

  _createClass(EstimateRecipient, [{
    key: 'getRecipientFromEstimate',
    value: function getRecipientFromEstimate() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['recipient_first_name', 'recipient_last_name', 'recipient_company_name', 'recipient_email', 'recipient_phone', 'recipient_address']);
    }
  }, {
    key: 'updateRecipient',
    value: function updateRecipient(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update recipient information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated recipient information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-recipient');
      };

      var localRecipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localRecipient);
      var phone = localRecipient.recipient_phone;
      localRecipient.recipient_phone = phone ? phone.replace(/\D/g, '') : null;

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2909);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            id: this.props.node.id
          }, localRecipient)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetRecipient',
    value: function resetRecipient() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localRecipient = this.getRecipientFromEstimate();
      this.setState(obj);
    }
  }, {
    key: 'recipientChangeHandler',
    value: function recipientChangeHandler(recipient) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localRecipient = recipient;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Recipient_Recipient__["a" /* default */], {
        canEdit: this.props.canEdit,
        recipient: this.getRecipientFromEstimate(),
        resetRecipient: this.resetRecipient,
        localRecipient: this.state.localRecipient,
        onChange: this.recipientChangeHandler,
        updateRecipient: this.updateRecipient,
        viewer: this.props.viewer
      });
    }
  }]);

  return EstimateRecipient;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EstimateRecipient.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateRecipient);

/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Schedule_Schedule__ = __webpack_require__(813);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EstimateSchedule = function (_React$Component) {
  _inherits(EstimateSchedule, _React$Component);

  function EstimateSchedule(props) {
    _classCallCheck(this, EstimateSchedule);

    var _this = _possibleConstructorReturn(this, (EstimateSchedule.__proto__ || Object.getPrototypeOf(EstimateSchedule)).call(this, props));

    _this.toggleSearch = _this.toggleSearch.bind(_this);
    _this.closeSearchHandler = _this.closeSearchHandler.bind(_this);
    _this.eventSegmentChangeHandler = _this.eventSegmentChangeHandler.bind(_this);
    _this.updateEventSegment = _this.updateEventSegment.bind(_this);
    _this.resetEditEventSegment = _this.resetEditEventSegment.bind(_this);
    _this.deleteEventSegment = _this.deleteEventSegment.bind(_this);
    _this.newEventSegmentChangeHandler = _this.newEventSegmentChangeHandler.bind(_this);
    _this.closeNewEventSegmentEditor = _this.closeNewEventSegmentEditor.bind(_this);
    _this.createEventSegment = _this.createEventSegment.bind(_this);
    _this.addEventSegment = _this.addEventSegment.bind(_this);
    _this.resetAddEventSegment = _this.resetAddEventSegment.bind(_this);
    _this.state = {
      showSearch: false,
      estimateEventSegments: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.estimateEventSegments),
      editingNewEventSegment: false
    };
    return _this;
  }

  _createClass(EstimateSchedule, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update estimateEventSegments if any edges are added/deleted
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.estimateEventSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.estimateEventSegments);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ showSearch: !this.state.showSearch });
    }
  }, {
    key: 'closeSearchHandler',
    value: function closeSearchHandler() {
      this.setState({ showSearch: false });
    }
  }, {
    key: 'eventSegmentChangeHandler',
    value: function eventSegmentChangeHandler(eventSegment, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.estimateEventSegments[idx].node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateEventSegment',
    value: function updateEventSegment(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-estimate-event-segment');
      };
      var eventSegment = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.estimateEventSegments[idx].node), ['id', 'title', 'start_at', 'end_at', 'time_zone', 'location', 'line1', 'city', 'province', 'postal_code', 'room', 'notes']));

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2912);
      });

      var optimisticResponse = {
        updateEstimateEventSegment: { estimate_event_segment: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(eventSegment) }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, eventSegment)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetEditEventSegment',
    value: function resetEditEventSegment(index) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.estimateEventSegments[index] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.estimateEventSegments[index]);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'deleteEventSegment',
    value: function deleteEventSegment(idx, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this2.resetEditEventSegment();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-estimate-event-segment');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(2911);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['estimate', 'estimate_event_segments'],
        deletedIDFieldName: 'deletedEstimateEventSegmentId',
        connectionKeys: [{
          key: 'EstimateContainer_estimate_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.estimateEventSegments[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetAddEventSegment',
    value: function resetAddEventSegment() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete obj.newEventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'createEventSegment',
    value: function createEventSegment(index, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.state);
        delete obj.newEventSegment;
        _this3.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-estimate-event-segment');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(2910);
      });

      var eventSegment = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newEventSegment.node), 'all_day'));

      eventSegment.title = eventSegment.title || '(Untitled Agenda Item)';

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_estimate_event_segment_edge',
        connectionInfo: [{
          key: 'EstimateContainer_estimate_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            estimate_id: parentID
          }, eventSegment)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'addEventSegment',
    value: function addEventSegment(e) {
      e.preventDefault();
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewEventSegment = true;
      if (!this.state.newEventSegment) {
        obj.newEventSegment = { node: {} };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newEventSegmentChangeHandler',
    value: function newEventSegmentChangeHandler(eventSegment) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newEventSegment.node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewEventSegmentEditor',
    value: function closeNewEventSegmentEditor() {
      this.setState({ editingNewEventSegment: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Schedule_Schedule__["a" /* default */], {
        addEventSegment: this.addEventSegment,
        closeNewEventSegmentEditor: this.closeNewEventSegmentEditor,
        createEventSegment: this.createEventSegment,
        deleteEventSegment: this.deleteEventSegment,
        eventSegments: this.props.estimateEventSegments,
        eventSegmentChangeHandler: this.eventSegmentChangeHandler,
        editingNewEventSegment: this.state.editingNewEventSegment,
        localEventSegments: this.state.estimateEventSegments,
        newEventSegment: this.state.newEventSegment,
        newEventSegmentChangeHandler: this.newEventSegmentChangeHandler,
        readOnly: this.props.readOnly,
        resetAddEventSegment: this.resetAddEventSegment,
        resetEditEventSegment: this.resetEditEventSegment,
        updateEventSegment: this.updateEventSegment,
        viewer: this.props.viewer
      });
    }
  }]);

  return EstimateSchedule;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EstimateSchedule.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  estimateEventSegments: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateSchedule);

/***/ }),
/* 2891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__ = __webpack_require__(528);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EstimateShare = function (_React$Component) {
  _inherits(EstimateShare, _React$Component);

  function EstimateShare(props) {
    _classCallCheck(this, EstimateShare);

    var _this = _possibleConstructorReturn(this, (EstimateShare.__proto__ || Object.getPrototypeOf(EstimateShare)).call(this, props));

    _this.sendEmail = _this.sendEmail.bind(_this);
    return _this;
  }

  _createClass(EstimateShare, [{
    key: 'sendEmail',
    value: function sendEmail(formModel, successCb) {
      var subject = formModel.subject,
          to = formModel.to,
          message = formModel.message;

      var cc = formModel.cc === '' ? null : formModel.cc;
      var onCompleted = function onCompleted() {
        successCb();
      };
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(2913);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { estimate_id: this.props.document.id, to: to, cc: cc, subject: subject, message: message }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          onOpen = _props.onOpen,
          onClose = _props.onClose;

      var permissionsNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Anyone with the link ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'can view'
        ),
        ' this estimate.'
      );
      var workspaces = this.props.document.workspaces.edges;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__["a" /* default */], {
        document: this.props.document,
        canEmail: this.props.document.can_email,
        event: workspaces.length > 0 ? workspaces[0].node.event : null,
        title: 'Share Estimate',
        shareUrl: "https://www.cloverbook.com" + '/open/e/' + this.props.document.share_token,
        documentType: 'estimate',
        permissionsNode: permissionsNode,
        sendEmail: this.sendEmail,
        trigger: trigger,
        onOpen: onOpen,
        onClose: onClose
      });
    }
  }]);

  return EstimateShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimateShare.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateShare);

/***/ }),
/* 2892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EstimateTitle = function (_React$Component) {
  _inherits(EstimateTitle, _React$Component);

  function EstimateTitle(props) {
    _classCallCheck(this, EstimateTitle);

    var _this = _possibleConstructorReturn(this, (EstimateTitle.__proto__ || Object.getPrototypeOf(EstimateTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(EstimateTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update estimate title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated estimate title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Estimate)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(2914);
        });

        var optimisticResponse = {
          updateEstimate: { estimate: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return EstimateTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EstimateTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (EstimateTitle);

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash adc6c00aa7c41aaf41e977e15db99a42
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteEstimateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteEstimateMutationVariables = {|
  input: DeleteEstimateInput
|};
export type ActionsComponent_deleteEstimateMutationResponse = {|
  +deleteEstimate: ?{|
    +deletedEstimateId: ?string
  |}
|};
export type ActionsComponent_deleteEstimateMutation = {|
  variables: ActionsComponent_deleteEstimateMutationVariables,
  response: ActionsComponent_deleteEstimateMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteEstimateMutation(
  $input: DeleteEstimateInput!
) {
  deleteEstimate(input: $input) {
    deletedEstimateId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteEstimate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteEstimateInput!"
    }],
    "concreteType": "DeleteEstimatePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedEstimateId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteEstimateMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteEstimateMutation(\n  $input: DeleteEstimateInput!\n) {\n  deleteEstimate(input: $input) {\n    deletedEstimateId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteEstimateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a128170e4c20a48aa0b500e212508ceb';
module.exports = node;

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9f451e34e7edad427816a413af5d5bc3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_Estimate_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_Estimate_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_Estimate_updateBrandMutation = {|
  variables: Brand_Estimate_updateBrandMutationVariables,
  response: Brand_Estimate_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_Estimate_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_Estimate_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_Estimate_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_Estimate_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_Estimate_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ab3ed0503f78720b97b199b3a53e6936';
module.exports = node;

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6678aa43d2e6dd4f033788ccd1bb48f9
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateBrandInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  brand_id: string,
};
export type Brand_updateEstimateBrandMutationVariables = {|
  input: UpdateEstimateBrandInput
|};
export type Brand_updateEstimateBrandMutationResponse = {|
  +updateEstimateBrand: ?{|
    +estimate: ?{|
      +id: string,
      +brand_header: ?string,
    |}
  |}
|};
export type Brand_updateEstimateBrandMutation = {|
  variables: Brand_updateEstimateBrandMutationVariables,
  response: Brand_updateEstimateBrandMutationResponse,
|};
*/

/*
mutation Brand_updateEstimateBrandMutation(
  $input: UpdateEstimateBrandInput!
) {
  updateEstimateBrand(input: $input) {
    estimate {
      id
      brand_header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEstimateBrandInput!"
    }],
    "concreteType": "UpdateEstimateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_updateEstimateBrandMutation",
    "id": null,
    "text": "mutation Brand_updateEstimateBrandMutation(\n  $input: UpdateEstimateBrandInput!\n) {\n  updateEstimateBrand(input: $input) {\n    estimate {\n      id\n      brand_header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_updateEstimateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_updateEstimateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6e3ec3196effc71d88de632b7370fcb7';
module.exports = node;

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 654ab8c6b9cef5988b6e9f664eebaf89
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddEstimateToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type EstimateComponent_addEstimateToSessionMutationVariables = {|
  input: AddEstimateToSessionInput
|};
export type EstimateComponent_addEstimateToSessionMutationResponse = {|
  +addEstimateToSession: ?{|
    +estimate: ?{|
      +id: string
    |}
  |}
|};
export type EstimateComponent_addEstimateToSessionMutation = {|
  variables: EstimateComponent_addEstimateToSessionMutationVariables,
  response: EstimateComponent_addEstimateToSessionMutationResponse,
|};
*/

/*
mutation EstimateComponent_addEstimateToSessionMutation(
  $input: AddEstimateToSessionInput!
) {
  addEstimateToSession(input: $input) {
    estimate {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddEstimateToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addEstimateToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddEstimateToSessionInput!"
    }],
    "concreteType": "AddEstimateToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "EstimateComponent_addEstimateToSessionMutation",
    "id": null,
    "text": "mutation EstimateComponent_addEstimateToSessionMutation(\n  $input: AddEstimateToSessionInput!\n) {\n  addEstimateToSession(input: $input) {\n    estimate {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EstimateComponent_addEstimateToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "EstimateComponent_addEstimateToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '14852a454515c5151ab71a31b8e0d192';
module.exports = node;

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c1d42d8224af08f5f0b4a75c3ffd421d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
export type EstimateContainer_RefetchQueryVariables = {|
  id: string
|};
export type EstimateContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EstimateContainer_node$ref
  |}
|};
export type EstimateContainer_RefetchQuery = {|
  variables: EstimateContainer_RefetchQueryVariables,
  response: EstimateContainer_RefetchQueryResponse,
|};
*/

/*
query EstimateContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EstimateContainer_node
    id
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EstimateContainer_RefetchQuery",
    "id": null,
    "text": "query EstimateContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EstimateContainer_node\n    id\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EstimateContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EstimateContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EstimateContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Estimate",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "hide_total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_event_segments",
            "storageKey": "estimate_event_segments(first:99999)",
            "args": v6,
            "concreteType": "EstimateEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v4, v2]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_event_segments",
            "args": v6,
            "handle": "connection",
            "key": "EstimateContainer_estimate_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_line_items",
            "storageKey": "estimate_line_items(first:99999)",
            "args": v6,
            "concreteType": "EstimateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v5, v2]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_line_items",
            "args": v6,
            "handle": "connection",
            "key": "EstimateContainer_estimate_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2fb023f910da021b23263ea3ecc92e90';
module.exports = node;

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type Share_event$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EstimateContainer_node$ref: FragmentReference;
export type EstimateContainer_node = {|
  +id: string,
  +title: ?string,
  +notes: ?string,
  +can_edit: ?boolean,
  +can_email: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +recipient_first_name: ?string,
  +recipient_last_name: ?string,
  +recipient_company_name: ?string,
  +recipient_email: ?string,
  +recipient_phone: ?string,
  +recipient_address: ?string,
  +hide_total: ?boolean,
  +estimate_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +estimate_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +$fragmentRefs: Share_event$ref,
        |},
      |}
    |}>
  |},
  +$refType: EstimateContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "EstimateContainer_node",
    "type": "Estimate",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["estimate_event_segments"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["estimate_line_items"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_last_name",
      "args": null,
      "storageKey": null
    }, v0, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_email",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "share_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_first_name",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_company_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_email",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_phone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_address",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hide_total",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "estimate_event_segments",
      "name": "__EstimateContainer_estimate_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateEventSegmentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EstimateEventSegmentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "EstimateEventSegment",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "line1",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "start_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "end_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "time_zone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "all_day",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "line2",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "province",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "postal_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "room",
            "args": null,
            "storageKey": null
          }, v1, v3]
        }, v4]
      }, v5]
    }, {
      "kind": "LinkedField",
      "alias": "estimate_line_items",
      "name": "__EstimateContainer_estimate_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateLineItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EstimateLineItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "EstimateLineItem",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          }, v2, v3]
        }, v4]
      }, v5]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, {
              "kind": "FragmentSpread",
              "name": "Share_event",
              "args": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '15c350b28682c78f26b642473ceec8fa';
module.exports = node;

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type LibraryContainer_viewer$ref = any;
type ScheduleContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EstimateContainer_viewer$ref: FragmentReference;
export type EstimateContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +s_time_zone: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +features: ?{|
    +hide_estimate_total: ?boolean
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref & ScheduleContainer_viewer$ref & LibraryContainer_viewer$ref,
  +$refType: EstimateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "EstimateContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "ScheduleContainer_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "features",
      "storageKey": null,
      "args": null,
      "concreteType": "Features",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "hide_estimate_total",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "LibraryContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '3c768d7d6fb613bbcf241ba2ebf63c4e';
module.exports = node;

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 419bacee24a71d1b9356ca0bf2c228ad
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToEstimateInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_Estimate_copyUserLineItemsToEstimateMutationVariables = {|
  input: CopyUserLineItemsToEstimateInput
|};
export type Library_Estimate_copyUserLineItemsToEstimateMutationResponse = {|
  +copyUserLineItemsToEstimate: ?{|
    +estimate: ?{|
      +estimate_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_Estimate_copyUserLineItemsToEstimateMutation = {|
  variables: Library_Estimate_copyUserLineItemsToEstimateMutationVariables,
  response: Library_Estimate_copyUserLineItemsToEstimateMutationResponse,
|};
*/

/*
mutation Library_Estimate_copyUserLineItemsToEstimateMutation(
  $input: CopyUserLineItemsToEstimateInput!
) {
  copyUserLineItemsToEstimate(input: $input) {
    estimate {
      estimate_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToEstimateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "estimate_line_items",
    "storageKey": null,
    "args": null,
    "concreteType": "EstimateLineItemConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateLineItemEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "EstimateLineItem",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_cents",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_currency",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantity",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
    "id": null,
    "text": "mutation Library_Estimate_copyUserLineItemsToEstimateMutation(\n  $input: CopyUserLineItemsToEstimateInput!\n) {\n  copyUserLineItemsToEstimate(input: $input) {\n    estimate {\n      estimate_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v3, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '35319167e802e3260f305f21fd500c52';
module.exports = node;

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 80c9fff5e81e8b6d5511f31a85809751
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateEstimateLineItemInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  title: string,
  quantity: number,
  price_cents: number,
  price_currency: string,
  description?: ?string,
  add_to_library?: ?boolean,
};
export type Library_Estimate_createEstimateLineItemMutationVariables = {|
  input: CreateEstimateLineItemInput
|};
export type Library_Estimate_createEstimateLineItemMutationResponse = {|
  +createEstimateLineItem: ?{|
    +new_estimate_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
    +new_user_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
  |}
|};
export type Library_Estimate_createEstimateLineItemMutation = {|
  variables: Library_Estimate_createEstimateLineItemMutationVariables,
  response: Library_Estimate_createEstimateLineItemMutationResponse,
|};
*/

/*
mutation Library_Estimate_createEstimateLineItemMutation(
  $input: CreateEstimateLineItemInput!
) {
  createEstimateLineItem(input: $input) {
    new_estimate_line_item_edge {
      node {
        id
        title
        description
        position
        price_cents
        price_currency
        quantity
      }
    }
    new_user_line_item_edge {
      node {
        id
        title
        description
        price_cents
        price_currency
        quantity
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEstimateLineItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createEstimateLineItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateEstimateLineItemInput!"
    }],
    "concreteType": "CreateEstimateLineItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_estimate_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "EstimateLineItem",
        "plural": false,
        "selections": [v1, v2, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, v4, v5, v6]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "new_user_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserLineItem",
        "plural": false,
        "selections": [v1, v2, v3, v4, v5, v6]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_Estimate_createEstimateLineItemMutation",
    "id": null,
    "text": "mutation Library_Estimate_createEstimateLineItemMutation(\n  $input: CreateEstimateLineItemInput!\n) {\n  createEstimateLineItem(input: $input) {\n    new_estimate_line_item_edge {\n      node {\n        id\n        title\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n    new_user_line_item_edge {\n      node {\n        id\n        title\n        description\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_Estimate_createEstimateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_Estimate_createEstimateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'aba46272b4aa793f54eb915a6d750a7e';
module.exports = node;

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b9ad6764d0c6fd6814ffbd807fbd084c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type LineItems_UpdateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type LineItems_UpdateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +hide_total: ?boolean
    |}
  |}
|};
export type LineItems_UpdateEstimateMutation = {|
  variables: LineItems_UpdateEstimateMutationVariables,
  response: LineItems_UpdateEstimateMutationResponse,
|};
*/

/*
mutation LineItems_UpdateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      hide_total
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "hide_total",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_UpdateEstimateMutation",
    "id": null,
    "text": "mutation LineItems_UpdateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      hide_total\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_UpdateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_UpdateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8339e8936366e0ff48b2951a9cfe9ea7';
module.exports = node;

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d98eed91d76ef26ce74df399e16b6760
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
export type DeleteEstimateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type LineItems_deleteEstimateLineItemMutationVariables = {|
  input: DeleteEstimateLineItemInput
|};
export type LineItems_deleteEstimateLineItemMutationResponse = {|
  +deleteEstimateLineItem: ?{|
    +deletedEstimateLineItemId: ?string,
    +estimate: ?{|
      +$fragmentRefs: EstimateContainer_node$ref
    |},
  |}
|};
export type LineItems_deleteEstimateLineItemMutation = {|
  variables: LineItems_deleteEstimateLineItemMutationVariables,
  response: LineItems_deleteEstimateLineItemMutationResponse,
|};
*/

/*
mutation LineItems_deleteEstimateLineItemMutation(
  $input: DeleteEstimateLineItemInput!
) {
  deleteEstimateLineItem(input: $input) {
    deletedEstimateLineItemId
    estimate {
      ...EstimateContainer_node
      id
    }
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteEstimateLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteEstimateLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedEstimateLineItemId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_deleteEstimateLineItemMutation",
    "id": null,
    "text": "mutation LineItems_deleteEstimateLineItemMutation(\n  $input: DeleteEstimateLineItemInput!\n) {\n  deleteEstimateLineItem(input: $input) {\n    deletedEstimateLineItemId\n    estimate {\n      ...EstimateContainer_node\n      id\n    }\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_deleteEstimateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteEstimateLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "EstimateContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_deleteEstimateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteEstimateLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "hide_total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_event_segments",
            "storageKey": "estimate_event_segments(first:99999)",
            "args": v6,
            "concreteType": "EstimateEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v4, v7]
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_event_segments",
            "args": v6,
            "handle": "connection",
            "key": "EstimateContainer_estimate_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_line_items",
            "storageKey": "estimate_line_items(first:99999)",
            "args": v6,
            "concreteType": "EstimateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v5, v7]
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_line_items",
            "args": v6,
            "handle": "connection",
            "key": "EstimateContainer_estimate_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4821f776d2f1317b021487e0e8ba394d';
module.exports = node;

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5ab2cf9a717801ff1cf4693cdc0964af
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
export type UpdateEstimateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  position?: ?number,
  description?: ?string,
};
export type LineItems_updateEstimateLineItemMutationVariables = {|
  input: UpdateEstimateLineItemInput
|};
export type LineItems_updateEstimateLineItemMutationResponse = {|
  +updateEstimateLineItem: ?{|
    +estimate: ?{|
      +$fragmentRefs: EstimateContainer_node$ref
    |}
  |}
|};
export type LineItems_updateEstimateLineItemMutation = {|
  variables: LineItems_updateEstimateLineItemMutationVariables,
  response: LineItems_updateEstimateLineItemMutationResponse,
|};
*/

/*
mutation LineItems_updateEstimateLineItemMutation(
  $input: UpdateEstimateLineItemInput!
) {
  updateEstimateLineItem(input: $input) {
    estimate {
      ...EstimateContainer_node
      id
    }
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_updateEstimateLineItemMutation",
    "id": null,
    "text": "mutation LineItems_updateEstimateLineItemMutation(\n  $input: UpdateEstimateLineItemInput!\n) {\n  updateEstimateLineItem(input: $input) {\n    estimate {\n      ...EstimateContainer_node\n      id\n    }\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_updateEstimateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimateLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "EstimateContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_updateEstimateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimateLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "hide_total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_event_segments",
            "storageKey": "estimate_event_segments(first:99999)",
            "args": v5,
            "concreteType": "EstimateEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v3, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_event_segments",
            "args": v5,
            "handle": "connection",
            "key": "EstimateContainer_estimate_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_line_items",
            "storageKey": "estimate_line_items(first:99999)",
            "args": v5,
            "concreteType": "EstimateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_line_items",
            "args": v5,
            "handle": "connection",
            "key": "EstimateContainer_estimate_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7938569013266410b44ca561eceec4ae';
module.exports = node;

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 379759df3ad2df96b68f094240c33531
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Estimate_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Estimate_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Estimate_Logo_updateBrandMutation = {|
  variables: Logo_Estimate_Logo_updateBrandMutationVariables,
  response: Logo_Estimate_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Estimate_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Estimate_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Estimate_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Estimate_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Estimate_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8814ad1023b86159deeb2a189eeb593d';
module.exports = node;

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f6a73db63c7bd70c27cce76f87bd2ebb
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Estimate_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Estimate_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Estimate_deleteLogo_updateBrandMutation = {|
  variables: Logo_Estimate_deleteLogo_updateBrandMutationVariables,
  response: Logo_Estimate_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Estimate_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Estimate_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Estimate_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Estimate_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Estimate_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '840978de2ed468cd8a689e46f513661d';
module.exports = node;

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 248329ef85c2487fe4e5509f2426ed85
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateBrandInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  brand_id: string,
};
export type Logo_updateEstimateBrandMutationVariables = {|
  input: UpdateEstimateBrandInput
|};
export type Logo_updateEstimateBrandMutationResponse = {|
  +updateEstimateBrand: ?{|
    +estimate: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateEstimateBrandMutation = {|
  variables: Logo_updateEstimateBrandMutationVariables,
  response: Logo_updateEstimateBrandMutationResponse,
|};
*/

/*
mutation Logo_updateEstimateBrandMutation(
  $input: UpdateEstimateBrandInput!
) {
  updateEstimateBrand(input: $input) {
    estimate {
      id
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEstimateBrandInput!"
    }],
    "concreteType": "UpdateEstimateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_updateEstimateBrandMutation",
    "id": null,
    "text": "mutation Logo_updateEstimateBrandMutation(\n  $input: UpdateEstimateBrandInput!\n) {\n  updateEstimateBrand(input: $input) {\n    estimate {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_updateEstimateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_updateEstimateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd93bc12f794049d41c435dfb81ac44a6';
module.exports = node;

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c44021d458030f70a12de6515ae32375
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type Notes_Estimate_UpdateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type Notes_Estimate_UpdateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +notes: ?string
    |}
  |}
|};
export type Notes_Estimate_UpdateEstimateMutation = {|
  variables: Notes_Estimate_UpdateEstimateMutationVariables,
  response: Notes_Estimate_UpdateEstimateMutationResponse,
|};
*/

/*
mutation Notes_Estimate_UpdateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      notes
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Notes_Estimate_UpdateEstimateMutation",
    "id": null,
    "text": "mutation Notes_Estimate_UpdateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      notes\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Notes_Estimate_UpdateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Notes_Estimate_UpdateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6912e9a584bdfd4c62fe415c323c202c';
module.exports = node;

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 495f6a2c1be400d0b88bfcaa48979413
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type Recipient_updateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type Recipient_updateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +id: string,
      +recipient_first_name: ?string,
      +recipient_last_name: ?string,
      +recipient_company_name: ?string,
      +recipient_email: ?string,
      +recipient_phone: ?string,
      +recipient_address: ?string,
    |}
  |}
|};
export type Recipient_updateEstimateMutation = {|
  variables: Recipient_updateEstimateMutationVariables,
  response: Recipient_updateEstimateMutationResponse,
|};
*/

/*
mutation Recipient_updateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      id
      recipient_first_name
      recipient_last_name
      recipient_company_name
      recipient_email
      recipient_phone
      recipient_address
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEstimateInput!"
    }],
    "concreteType": "UpdateEstimatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_phone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_address",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Recipient_updateEstimateMutation",
    "id": null,
    "text": "mutation Recipient_updateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      id\n      recipient_first_name\n      recipient_last_name\n      recipient_company_name\n      recipient_email\n      recipient_phone\n      recipient_address\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Recipient_updateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Recipient_updateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6e0257bc6e5862e40f6e00dda7da232a';
module.exports = node;

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b63a66ecc04a0db6cff0c427b7737777
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateEstimateEventSegmentInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_createEstimateEventSegmentMutationVariables = {|
  input: CreateEstimateEventSegmentInput
|};
export type Schedule_createEstimateEventSegmentMutationResponse = {|
  +createEstimateEventSegment: ?{|
    +new_estimate_event_segment_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}
  |}
|};
export type Schedule_createEstimateEventSegmentMutation = {|
  variables: Schedule_createEstimateEventSegmentMutationVariables,
  response: Schedule_createEstimateEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_createEstimateEventSegmentMutation(
  $input: CreateEstimateEventSegmentInput!
) {
  createEstimateEventSegment(input: $input) {
    new_estimate_event_segment_edge {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEstimateEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createEstimateEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateEstimateEventSegmentInput!"
    }],
    "concreteType": "CreateEstimateEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_estimate_event_segment_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateEventSegmentEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "EstimateEventSegment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "start_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "end_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "all_day",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "location",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "city",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "province",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "postal_code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "room",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_createEstimateEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_createEstimateEventSegmentMutation(\n  $input: CreateEstimateEventSegmentInput!\n) {\n  createEstimateEventSegment(input: $input) {\n    new_estimate_event_segment_edge {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_createEstimateEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_createEstimateEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8c7179e0dbf35b1e4b5dc2e7b03aa370';
module.exports = node;

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 53bbcab109b71940f3843807f48c47b2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteEstimateEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Schedule_deleteEstimateEventSegmentMutationVariables = {|
  input: DeleteEstimateEventSegmentInput
|};
export type Schedule_deleteEstimateEventSegmentMutationResponse = {|
  +deleteEstimateEventSegment: ?{|
    +deletedEstimateEventSegmentId: ?string
  |}
|};
export type Schedule_deleteEstimateEventSegmentMutation = {|
  variables: Schedule_deleteEstimateEventSegmentMutationVariables,
  response: Schedule_deleteEstimateEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_deleteEstimateEventSegmentMutation(
  $input: DeleteEstimateEventSegmentInput!
) {
  deleteEstimateEventSegment(input: $input) {
    deletedEstimateEventSegmentId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteEstimateEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteEstimateEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteEstimateEventSegmentInput!"
    }],
    "concreteType": "DeleteEstimateEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedEstimateEventSegmentId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_deleteEstimateEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_deleteEstimateEventSegmentMutation(\n  $input: DeleteEstimateEventSegmentInput!\n) {\n  deleteEstimateEventSegment(input: $input) {\n    deletedEstimateEventSegmentId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_deleteEstimateEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_deleteEstimateEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'dfddf07ec884f8daac7874e9b3111aa5';
module.exports = node;

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7cb7ec04e4242db1b153784865a186de
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_updateEstimateEventSegmentMutationVariables = {|
  input: UpdateEstimateEventSegmentInput
|};
export type Schedule_updateEstimateEventSegmentMutationResponse = {|
  +updateEstimateEventSegment: ?{|
    +estimate_event_segment: ?{|
      +id: string,
      +title: ?string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +all_day: ?boolean,
      +location: ?string,
      +line1: ?string,
      +line2: ?string,
      +city: ?string,
      +province: ?string,
      +postal_code: ?string,
      +room: ?string,
      +notes: ?string,
    |}
  |}
|};
export type Schedule_updateEstimateEventSegmentMutation = {|
  variables: Schedule_updateEstimateEventSegmentMutationVariables,
  response: Schedule_updateEstimateEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_updateEstimateEventSegmentMutation(
  $input: UpdateEstimateEventSegmentInput!
) {
  updateEstimateEventSegment(input: $input) {
    estimate_event_segment {
      id
      title
      start_at
      end_at
      time_zone
      all_day
      location
      line1
      line2
      city
      province
      postal_code
      room
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimateEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEstimateEventSegmentInput!"
    }],
    "concreteType": "UpdateEstimateEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate_event_segment",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateEventSegment",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "line1",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "start_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "end_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "time_zone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "all_day",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "location",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "line2",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "province",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "postal_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "room",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_updateEstimateEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_updateEstimateEventSegmentMutation(\n  $input: UpdateEstimateEventSegmentInput!\n) {\n  updateEstimateEventSegment(input: $input) {\n    estimate_event_segment {\n      id\n      title\n      start_at\n      end_at\n      time_zone\n      all_day\n      location\n      line1\n      line2\n      city\n      province\n      postal_code\n      room\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_updateEstimateEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_updateEstimateEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6007a16afd43ab454ac0cc08e8a7abf0';
module.exports = node;

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 645a5eeaba1cfc382e7a3db2177978c5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailEstimateLinkInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type Share_emailEstimateLinkMutationVariables = {|
  input: EmailEstimateLinkInput
|};
export type Share_emailEstimateLinkMutationResponse = {|
  +emailEstimateLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type Share_emailEstimateLinkMutation = {|
  variables: Share_emailEstimateLinkMutationVariables,
  response: Share_emailEstimateLinkMutationResponse,
|};
*/

/*
mutation Share_emailEstimateLinkMutation(
  $input: EmailEstimateLinkInput!
) {
  emailEstimateLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailEstimateLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailEstimateLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailEstimateLinkInput!"
    }],
    "concreteType": "EmailEstimateLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Share_emailEstimateLinkMutation",
    "id": null,
    "text": "mutation Share_emailEstimateLinkMutation(\n  $input: EmailEstimateLinkInput!\n) {\n  emailEstimateLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Share_emailEstimateLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Share_emailEstimateLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '10d2f05abe63a285a60de63bef8b7f85';
module.exports = node;

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e35d8ccb192c70b484733e48131eed19
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type Title_UpdateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type Title_UpdateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_UpdateEstimateMutation = {|
  variables: Title_UpdateEstimateMutationVariables,
  response: Title_UpdateEstimateMutationResponse,
|};
*/

/*
mutation Title_UpdateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateEstimateMutation",
    "id": null,
    "text": "mutation Title_UpdateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "estimate",
          "storageKey": null,
          "args": null,
          "concreteType": "Estimate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6fd6f72f9df5d73b0a7daffcb52e5c49';
module.exports = node;

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FormBrand = function (_React$Component) {
  _inherits(FormBrand, _React$Component);

  function FormBrand(props) {
    _classCallCheck(this, FormBrand);

    var _this = _possibleConstructorReturn(this, (FormBrand.__proto__ || Object.getPrototypeOf(FormBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromForm()
    };
    _this.getBrandFromForm = _this.getBrandFromForm.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.updateFormBrand = _this.updateFormBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(FormBrand, [{
    key: 'getBrandFromForm',
    value: function getBrandFromForm() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['brand_header']);
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.updateFormBrand(successCb, failureCb);
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3001);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateFormBrand',
    value: function updateFormBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3002);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            form_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromForm();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromForm(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return FormBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FormBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (FormBrand);

/***/ }),
/* 2916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widgets_Checkboxes__ = __webpack_require__(2923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Widgets_TextList__ = __webpack_require__(2929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Widgets_Table__ = __webpack_require__(2927);






var COMPONENT_TYPES = {
  textList: __WEBPACK_IMPORTED_MODULE_3__Widgets_TextList__["a" /* default */],
  table: __WEBPACK_IMPORTED_MODULE_4__Widgets_Table__["a" /* default */],
  checkboxes: __WEBPACK_IMPORTED_MODULE_2__Widgets_Checkboxes__["a" /* default */]
};

var ArrayField = function ArrayField(_ref) {
  var formData = _ref.formData,
      onChange = _ref.onChange,
      editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  // Defaults to TextList widget
  var Widget = COMPONENT_TYPES[uiSchema && uiSchema['ui:widget'] || 'textList'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, {
    formData: formData,
    onChange: onChange,
    editing: editing,
    schema: schema,
    uiSchema: uiSchema
  });
};

ArrayField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (ArrayField);

/***/ }),
/* 2917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widgets_ContentBlock__ = __webpack_require__(2924);




var COMPONENT_TYPES = {
  contentBlock: __WEBPACK_IMPORTED_MODULE_2__Widgets_ContentBlock__["a" /* default */]
};

var NullField = function NullField(_ref) {
  var formData = _ref.formData,
      onChange = _ref.onChange,
      editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  // Defaults to ContentBlock widget for now
  var Widget = COMPONENT_TYPES[uiSchema && uiSchema['ui:widget'] || 'contentBlock'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, {
    formData: formData,
    onChange: onChange,
    editing: editing,
    schema: schema,
    uiSchema: uiSchema
  });
};

NullField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (NullField);

/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SchemaField__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Form_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// eslint-disable-next-line new-cap
var DragHandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["SortableHandle"])(function () {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.dragHandleContainer },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.dragHandle })
  );
});

// eslint-disable-next-line new-cap
var SortableItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["SortableElement"])(function (_ref) {
  var objectKey = _ref.objectKey,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      updateForm = _ref.updateForm,
      deleteQuestion = _ref.deleteQuestion,
      _deleteResponse = _ref.deleteResponse,
      _onChange = _ref.onChange,
      formData = _ref.formData;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      style: { display: 'flex', flexDirection: 'row', alignItems: 'center' }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DragHandle, null),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { style: { flex: 1 } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SchemaField__["a" /* default */], {
        key: objectKey,
        objectKey: objectKey,
        schema: schema.properties[objectKey],
        uiSchema: uiSchema[objectKey],
        onChange: function onChange(value, callback) {
          return _onChange(value, objectKey, callback);
        },
        updateForm: updateForm,
        formData: formData && formData[objectKey],
        deleteQuestion: deleteQuestion,
        deleteResponse: function deleteResponse(callback) {
          return _deleteResponse(objectKey, callback);
        }
      })
    )
  );
});

// eslint-disable-next-line new-cap
var SortableList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["SortableContainer"])(function (_ref2) {
  var items = _ref2.items,
      onChange = _ref2.onChange,
      schema = _ref2.schema,
      uiSchema = _ref2.uiSchema,
      updateForm = _ref2.updateForm,
      formData = _ref2.formData,
      deleteQuestion = _ref2.deleteQuestion,
      deleteResponse = _ref2.deleteResponse;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    items.map(function (key, index) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableItem, {
        key: key,
        objectKey: key,
        onChange: onChange,
        formData: formData,
        index: index,
        schema: schema,
        uiSchema: uiSchema,
        updateForm: updateForm,
        deleteQuestion: deleteQuestion,
        deleteResponse: deleteResponse
      });
    })
  );
});

var ObjectField = function (_React$Component) {
  _inherits(ObjectField, _React$Component);

  function ObjectField(props) {
    _classCallCheck(this, ObjectField);

    var _this = _possibleConstructorReturn(this, (ObjectField.__proto__ || Object.getPrototypeOf(ObjectField)).call(this, props));

    _this.onSortEnd = function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      var uiSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.uiSchema);
      var _this$props = _this.props,
          schema = _this$props.schema,
          formData = _this$props.formData;

      uiSchema['ui:order'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_sortable_hoc__["arrayMove"])(uiSchema['ui:order'], oldIndex, newIndex);
      _this.props.onChange({ schema: schema, uiSchema: uiSchema, formData: formData }, _this.props.updateForm);
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onSortEnd = _this.onSortEnd.bind(_this);
    _this.deleteResponse = _this.deleteResponse.bind(_this);
    return _this;
  }

  _createClass(ObjectField, [{
    key: 'onChange',
    value: function onChange(value, key, callback) {
      var schema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.schema);
      var uiSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.uiSchema);
      var formData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.formData);
      schema.properties[key] = value.schema;
      uiSchema[key] = value.uiSchema;
      if (formData) {
        formData[key] = value.formData;
      }
      this.props.onChange({ schema: schema, uiSchema: uiSchema, formData: formData }, callback);
    }
  }, {
    key: 'deleteResponse',
    value: function deleteResponse(key, callback) {
      var formData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.formData);
      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema;

      if (formData) {
        delete formData[key];
      }
      this.props.onChange({ formData: formData, schema: schema, uiSchema: uiSchema }, callback);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          schema = _props2.schema,
          uiSchema = _props2.uiSchema,
          updateForm = _props2.updateForm,
          formData = _props2.formData,
          deleteQuestion = _props2.deleteQuestion;

      var orderedKeys = uiSchema['ui:order'] || Object.keys(schema.properties);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableList, {
        items: orderedKeys,
        onSortEnd: this.onSortEnd,
        onChange: this.onChange,
        useDragHandle: true,
        schema: schema,
        uiSchema: uiSchema,
        updateForm: updateForm,
        formData: formData,
        deleteQuestion: deleteQuestion,
        deleteResponse: this.deleteResponse
      });
    }
  }]);

  return ObjectField;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ObjectField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  updateForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  deleteQuestion: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ObjectField);

/***/ }),
/* 2919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Form_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SchemaFieldEditDesktop = function (_React$Component) {
  _inherits(SchemaFieldEditDesktop, _React$Component);

  function SchemaFieldEditDesktop(props) {
    _classCallCheck(this, SchemaFieldEditDesktop);

    var _this = _possibleConstructorReturn(this, (SchemaFieldEditDesktop.__proto__ || Object.getPrototypeOf(SchemaFieldEditDesktop)).call(this, props));

    _this.onTitleChange = _this.onTitleChange.bind(_this);
    _this.onDescriptionChange = _this.onDescriptionChange.bind(_this);
    return _this;
  }

  _createClass(SchemaFieldEditDesktop, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.commitUpdate();
    }
  }, {
    key: 'onTitleChange',
    value: function onTitleChange(e) {
      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema,
          formData = _props.formData;

      this.props.onChange({
        schema: Object.assign({}, schema, { title: e.target.value }),
        uiSchema: uiSchema,
        formData: formData
      });
    }
  }, {
    key: 'onDescriptionChange',
    value: function onDescriptionChange(e) {
      var _props2 = this.props,
          schema = _props2.schema,
          uiSchema = _props2.uiSchema,
          formData = _props2.formData;

      this.props.onChange({
        schema: schema,
        uiSchema: Object.assign({}, uiSchema, { 'ui:description': e.target.value }),
        formData: formData
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          FieldComponent = _props3.FieldComponent,
          schema = _props3.schema,
          uiSchema = _props3.uiSchema,
          onChange = _props3.onChange,
          deleteQuestion = _props3.deleteQuestion,
          objectKey = _props3.objectKey,
          _reset = _props3.reset,
          props = _objectWithoutProperties(_props3, ['FieldComponent', 'schema', 'uiSchema', 'onChange', 'deleteQuestion', 'objectKey', 'reset']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["x" /* Card */],
        { fluid: true, style: { marginBottom: '2em' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["x" /* Card */].Content,
          null,
          schema.type !== 'null' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
                  autoFocus: true,
                  autoHeight: true,
                  name: 'title',
                  value: schema.title || '',
                  onChange: this.onTitleChange,
                  placeholder: 'Question',
                  style: { maxWidth: '600px' }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
                autoHeight: true,
                name: 'description',
                value: uiSchema && uiSchema['ui:description'] || '',
                onChange: this.onDescriptionChange,
                placeholder: 'Description',
                style: { maxWidth: '600px' }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: '2em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["f" /* FloatingLabelSelect */], {
                label: 'Question Type',
                name: 'type',
                type: 'select',
                placeholder: 'Question Type...',
                options: [{ text: 'Short answer', value: 'text', icon: 'text cursor' }, { text: 'Paragraph', value: 'textArea', icon: 'paragraph' }, { text: 'Multiple Choice', value: 'radio', icon: 'selected radio' }, { text: 'Checkboxes', value: 'checkboxes', icon: 'check square' }, { text: 'Dropdown', value: 'select', icon: 'chevron down' }, { text: 'List', value: 'textList', icon: 'list' }, { text: 'Table', value: 'table', icon: 'table' }],
                fluid: true,
                required: true,
                validationError: 'Question type is required',
                width: '200px',
                onChange: this.props.onQuestionTypeChange,
                value: this.props.getQuestionType(),
                className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.noBorderBottom
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { padding: '2em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldComponent, _extends({}, props, { uiSchema: uiSchema, schema: schema, onChange: onChange }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], {
            'delete': function _delete() {
              return deleteQuestion(objectKey);
            },
            id: objectKey,
            reset: function reset(e) {
              _reset(e, _this2.props.closeHandler);
            },
            save: function save() {
              return _this2.props.commitUpdate(_this2.props.closeHandler);
            }
          })
        )
      );
    }
  }]);

  return SchemaFieldEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SchemaFieldEditDesktop.propTypes = {
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteQuestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  FieldComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getQuestionType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onQuestionTypeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  objectKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (SchemaFieldEditDesktop);

/***/ }),
/* 2920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__globals_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SchemaFieldEditMobile = function (_React$Component) {
  _inherits(SchemaFieldEditMobile, _React$Component);

  function SchemaFieldEditMobile(props) {
    _classCallCheck(this, SchemaFieldEditMobile);

    var _this = _possibleConstructorReturn(this, (SchemaFieldEditMobile.__proto__ || Object.getPrototypeOf(SchemaFieldEditMobile)).call(this, props));

    _this.onTitleChange = _this.onTitleChange.bind(_this);
    _this.onDescriptionChange = _this.onDescriptionChange.bind(_this);
    return _this;
  }

  _createClass(SchemaFieldEditMobile, [{
    key: 'onTitleChange',
    value: function onTitleChange(e) {
      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema,
          formData = _props.formData;

      this.props.onChange({
        schema: Object.assign({}, schema, { title: e.target.value }),
        uiSchema: uiSchema,
        formData: formData
      });
    }
  }, {
    key: 'onDescriptionChange',
    value: function onDescriptionChange(e) {
      var _props2 = this.props,
          schema = _props2.schema,
          uiSchema = _props2.uiSchema,
          formData = _props2.formData;

      this.props.onChange({
        schema: schema,
        uiSchema: Object.assign({}, uiSchema, { 'ui:description': e.target.value }),
        formData: formData
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement;

      var _props3 = this.props,
          closeHandler = _props3.closeHandler,
          commitUpdate = _props3.commitUpdate,
          FieldComponent = _props3.FieldComponent,
          schema = _props3.schema,
          uiSchema = _props3.uiSchema,
          getQuestionType = _props3.getQuestionType,
          onChange = _props3.onChange,
          onQuestionTypeChange = _props3.onQuestionTypeChange,
          open = _props3.open,
          deleteQuestion = _props3.deleteQuestion,
          objectKey = _props3.objectKey,
          reset = _props3.reset,
          props = _objectWithoutProperties(_props3, ['closeHandler', 'commitUpdate', 'FieldComponent', 'schema', 'uiSchema', 'getQuestionType', 'onChange', 'onQuestionTypeChange', 'open', 'deleteQuestion', 'objectKey', 'reset']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */],
        { open: open, onClose: closeHandler, inline: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'item',
                onClick: function onClick(e) {
                  reset(e, closeHandler);
                }
              },
              'Cancel'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item', onClick: function onClick() {
                  return commitUpdate(closeHandler);
                } },
              'Done'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Content,
          null,
          schema.type !== 'null' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { style: { marginBottom: '0' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
                autoFocus: true,
                autoHeight: true,
                label: 'Question',
                name: 'question',
                value: schema.title || '',
                onChange: this.onTitleChange,
                style: { maxWidth: '600px' }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
              autoHeight: true,
              name: 'description',
              label: 'Description',
              value: uiSchema && uiSchema['ui:description'] || '',
              onChange: this.onDescriptionChange,
              style: { maxWidth: '600px' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: '1em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["f" /* FloatingLabelSelect */], (_React$createElement = {
                name: 'type',
                type: 'select',
                placeholder: 'Question Type...',
                options: [{ text: 'Short answer', value: 'text' }, { text: 'Paragraph', value: 'textArea' }, { text: 'Multiple Choice', value: 'radio' }, { text: 'Checkboxes', value: 'checkboxes' }, { text: 'Dropdown', value: 'select' }, { text: 'List', value: 'textList' }, { text: 'Table', value: 'table' }],
                fluid: true,
                required: true,
                validationError: 'Question type is required'
              }, _defineProperty(_React$createElement, 'fluid', true), _defineProperty(_React$createElement, 'onChange', onQuestionTypeChange), _defineProperty(_React$createElement, 'value', getQuestionType()), _defineProperty(_React$createElement, 'className', __WEBPACK_IMPORTED_MODULE_4__Form_scss___default.a.noBorderBottom), _React$createElement))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldComponent, _extends({}, props, {
            schema: schema,
            uiSchema: uiSchema,
            onChange: onChange
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: '2em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: __WEBPACK_IMPORTED_MODULE_5__globals_scss___default.a.negative,
                onClick: deleteQuestion.bind(null, objectKey)
              },
              'Delete ',
              schema.type !== 'null' ? 'Question' : 'Content'
            )
          )
        )
      );
    }
  }]);

  return SchemaFieldEditMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SchemaFieldEditMobile.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteQuestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getQuestionType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onQuestionTypeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  FieldComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  objectKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (SchemaFieldEditMobile);

/***/ }),
/* 2921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widgets_Text__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Widgets_TextArea__ = __webpack_require__(2928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Widgets_Radio__ = __webpack_require__(2925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Widgets_Select__ = __webpack_require__(2926);







var COMPONENT_TYPES = {
  text: __WEBPACK_IMPORTED_MODULE_2__Widgets_Text__["a" /* default */],
  textArea: __WEBPACK_IMPORTED_MODULE_3__Widgets_TextArea__["a" /* default */],
  radio: __WEBPACK_IMPORTED_MODULE_4__Widgets_Radio__["a" /* default */],
  select: __WEBPACK_IMPORTED_MODULE_5__Widgets_Select__["a" /* default */]
};

var StringField = function StringField(_ref) {
  var formData = _ref.formData,
      onChange = _ref.onChange,
      editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  // Defaults to Text widget for now
  var Widget = COMPONENT_TYPES[uiSchema && uiSchema['ui:widget'] || 'text'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, {
    formData: formData,
    onChange: onChange,
    editing: editing,
    schema: schema,
    uiSchema: uiSchema
  });
};

StringField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (StringField);

/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'Unsupported field type'
  );
});

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Form_scss__);







var CheckboxesWidget = function CheckboxesWidget(_ref) {
  var editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      formData = _ref.formData,
      onChange = _ref.onChange;

  var onCheckboxLabelChange = function onCheckboxLabelChange(e, index) {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    newSchema.items.enum[index] = e.target.value;
    onChange({
      schema: newSchema,
      uiSchema: uiSchema,
      formData: formData
    });
  };
  var addOption = function addOption() {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    newSchema.items.enum.push('Option ' + (schema.items.enum.length + 1));
    onChange({
      schema: newSchema,
      uiSchema: uiSchema,
      formData: formData
    });
  };

  var removeOption = function removeOption(index) {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    newSchema.items.enum.splice(index, 1);
    onChange({
      schema: newSchema,
      uiSchema: uiSchema,
      formData: formData
    });
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.responseField },
    schema.items.enum.map(function (option, index) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { key: index },
        editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], { checked: false, style: { paddingTop: '0.5em', marginRight: '0.5em' } })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
              onChange: function onChange(e) {
                return onCheckboxLabelChange(e, index);
              },
              value: option, name: 'option-' + index,
              inline: true,
              width: '100%'
            })
          ),
          schema.items.enum.length > 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            {
              className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.deleteItemRelative,
              onClick: function onClick() {
                return removeOption(index);
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
          )
        ),
        !editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], { checked: false, style: { paddingBottom: '1em' }, label: option })
      );
    }),
    editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { onClick: addOption },
      '+ Add Option'
    )
  );
};

CheckboxesWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CheckboxesWidget);

/***/ }),
/* 2924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ContentBlockWidget = function (_React$Component) {
  _inherits(ContentBlockWidget, _React$Component);

  function ContentBlockWidget(props) {
    _classCallCheck(this, ContentBlockWidget);

    var _this = _possibleConstructorReturn(this, (ContentBlockWidget.__proto__ || Object.getPrototypeOf(ContentBlockWidget)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(ContentBlockWidget, [{
    key: 'onChange',
    value: function onChange(value) {
      this.props.onChange({
        uiSchema: _extends({}, this.props.uiSchema, { 'ui:content': value }),
        schema: this.props.schema,
        formData: this.props.formData
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          uiSchema = _props.uiSchema,
          editing = _props.editing;

      var hasContent = uiSchema['ui:content'] === null || uiSchema['ui:content'].replace(/(<h1>)(<br>)(<\/h1>)/gim, '') !== '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
          extended: true,
          value: uiSchema['ui:content'],
          onChange: this.onChange,
          modules: {
            toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']]
          },
          formats: ['bold', 'italic', 'link', 'list', 'header']
        }),
        !editing && hasContent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          style: { wordBreak: 'break-word' },
          dangerouslySetInnerHTML: { __html: uiSchema['ui:content'] }
        }),
        !editing && !hasContent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.questionPlaceholder },
            'Heading'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.questionPlaceholder },
            'Description'
          )
        )
      );
    }
  }]);

  return ContentBlockWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContentBlockWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContentBlockWidget);

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);






var RadioWidget = function RadioWidget(_ref) {
  var editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      formData = _ref.formData,
      onChange = _ref.onChange;

  var onRadioLabelChange = function onRadioLabelChange(e, index) {
    var schemaEnum = schema.enum.slice();
    schemaEnum[index] = e.target.value;
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };
  var addOption = function addOption() {
    var schemaEnum = schema.enum.slice();
    schemaEnum.push('Option ' + (schemaEnum.length + 1));
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };

  var removeOption = function removeOption(index) {
    var schemaEnum = schema.enum.slice();
    schemaEnum.splice(index, 1);
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
    schema.enum.map(function (option, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["z" /* Radio */], { checked: false, style: { paddingTop: '0.5em', marginRight: '0.5em' } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
              onChange: function onChange(e) {
                return onRadioLabelChange(e, index);
              },
              value: option, name: 'option-' + index,
              inline: true,
              width: '100%'
            })
          ),
          index > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.deleteItemRelative,
              onClick: function onClick() {
                return removeOption(index);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'close' })
          ),
          index <= 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: '1.5em' } })
        ),
        !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["z" /* Radio */], { checked: false, style: { paddingBottom: '1em' }, label: option })
      );
    }),
    editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { onClick: addOption },
      '+ Add Option'
    )
  );
};

RadioWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (RadioWidget);

/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);






var SelectWidget = function SelectWidget(_ref) {
  var editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      formData = _ref.formData,
      onChange = _ref.onChange;

  var onOptionLabelChange = function onOptionLabelChange(e, index) {
    var schemaEnum = schema.enum.slice();
    schemaEnum[index] = e.target.value;
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };
  var addOption = function addOption() {
    var schemaEnum = schema.enum.slice();
    schemaEnum.push('Option ' + (schemaEnum.length + 1));
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };

  var removeOption = function removeOption(index) {
    var schemaEnum = schema.enum.slice();
    schemaEnum.splice(index, 1);
    onChange({
      schema: Object.assign({}, schema, { enum: schemaEnum }),
      uiSchema: uiSchema,
      formData: formData
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
    schema.enum.map(function (option, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
              onChange: function onChange(e) {
                return onOptionLabelChange(e, index);
              },
              value: option, name: 'option-' + index,
              inline: true,
              width: '100%'
            })
          ),
          index > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.deleteItemRelative,
              onClick: function onClick() {
                return removeOption(index);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'close' })
          ),
          index <= 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: '1.5em' } })
        )
      );
    }),
    !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
      name: 'select',
      type: 'select',
      placeholder: 'Select option...',
      fluid: true,
      disabled: true,
      options: []
    }),
    editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { onClick: addOption },
      '+ Add Option'
    )
  );
};

SelectWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SelectWidget);

/***/ }),
/* 2927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Text__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootComponent__ = __webpack_require__(54);









function generateId() {
  return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
}

var TextTableWidget = function TextTableWidget(_ref) {
  var editing = _ref.editing,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      onChange = _ref.onChange,
      formData = _ref.formData;

  var updateColumnHeader = function updateColumnHeader(e, key) {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    newSchema.items.properties[key].title = e.target.value;
    onChange({ schema: newSchema, uiSchema: uiSchema, formData: formData });
  };
  var addColumn = function addColumn() {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    var key = generateId();
    newSchema.items.properties[key] = {
      title: 'Column ' + (uiSchema['ui:headers'].length + 1),
      type: 'string'
    };
    var newUiSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(uiSchema);
    var keys = newUiSchema['ui:headers'];
    keys.push(key);
    newUiSchema.items.properties['ui:order'] = keys;
    onChange({ schema: newSchema, uiSchema: newUiSchema, formData: formData });
  };
  var removeColumn = function removeColumn(key, index) {
    var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
    delete newSchema.items.properties[key];
    var newUiSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(uiSchema);
    newUiSchema['ui:headers'].splice(index, 1);
    newUiSchema.items.properties['ui:order'] = newUiSchema['ui:headers'];
    var newFormData = Array.isArray(formData) ? formData.map(function (row) {
      var newRow = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(row);
      delete newRow[key];
      return newRow;
    }) : [];
    onChange({ schema: newSchema, uiSchema: newUiSchema, formData: newFormData });
  };

  var tableHeader = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Header,
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Row,
      null,
      uiSchema['ui:headers'].map(function (key, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].HeaderCell,
          { key: index },
          !editing && schema.items.properties[key].title,
          editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                name: 'textInput',
                placeholder: 'Column ' + (index + 1),
                value: schema.items.properties[key].title,
                onChange: function onChange(e) {
                  return updateColumnHeader(e, key);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              {
                className: __WEBPACK_IMPORTED_MODULE_6__Form_scss___default.a.deleteItemRelative,
                style: { marginTop: '0.5em' },
                onClick: function onClick() {
                  return removeColumn(key, index);
                }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            )
          )
        );
      })
    )
  );

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__RootComponent__["b" /* RootConsumer */],
    null,
    function (_ref2) {
      var isComputer = _ref2.isComputer;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */],
          { stackable: true },
          isComputer && tableHeader,
          !isComputer && editing && tableHeader,
          (!editing || isComputer) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Row,
              null,
              uiSchema['ui:headers'].map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Cell,
                  { key: index },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Text__["a" /* default */], { placeholder: schema.items.properties[item].title })
                );
              })
            )
          )
        ),
        editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { onClick: addColumn },
          '+ Add Column'
        ),
        !editing && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          null,
          '+ Add Row'
        )
      );
    }
  );
};

TextTableWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TextTableWidget);

/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);




var TextAreaWidget = function TextAreaWidget() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], { name: 'textInput', placeholder: 'Paragraph', disabled: true, autoHeight: true, rows: 2 })
  );
};

TextAreaWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (TextAreaWidget);

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);





var TextListWidget = function TextListWidget() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], { name: 'textInput', placeholder: 'Short answer text', disabled: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      null,
      '+ Add Another'
    )
  );
};

TextListWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (TextListWidget);

/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toRadio__ = __webpack_require__(2944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toText__ = __webpack_require__(2965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toTextArea__ = __webpack_require__(2972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toTextList__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toTable__ = __webpack_require__(2958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toSelect__ = __webpack_require__(2951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toCheckboxes__ = __webpack_require__(2937);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var to = props.to,
      rest = _objectWithoutProperties(props, ['to']);

  switch (to) {
    case 'radio':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toRadio__["a" /* default */])(rest);
      break;
    case 'checkboxes':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toCheckboxes__["a" /* default */])(rest);
      break;
    case 'text':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toText__["a" /* default */])(rest);
      break;
    case 'textArea':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toTextArea__["a" /* default */])(rest);
      break;
    case 'textList':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toTextList__["a" /* default */])(rest);
      break;
    case 'table':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toTable__["a" /* default */])(rest);
      break;
    case 'select':
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toSelect__["a" /* default */])(rest);
      break;
    default:
      break;
  }
});

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  var newFormData = [];
  if (formData) {
    if (!newSchema.items.enum.includes(formData)) {
      newSchema.items.enum[0] = formData;
    }
    newFormData.push(formData);
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  var newFormData = [];
  if (formData) {
    if (!newSchema.items.enum.includes(formData)) {
      newSchema.items.enum[0] = formData;
    }
    newFormData.push(formData);
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: [] };
});

/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  var newFormData = [];
  if (formData) {
    if (!newSchema.items.enum.includes(formData)) {
      newSchema.items.enum[0] = formData;
    }
    newFormData.push(formData);
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: [] };
});

/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  if (formData && formData.length > 0) {
    newSchema.items.enum = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniq(formData);
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniq(formData) };
});

/***/ }),
/* 2937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromText__ = __webpack_require__(2934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromRadio__ = __webpack_require__(2931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromTextArea__ = __webpack_require__(2935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTextList__ = __webpack_require__(2936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromTable__ = __webpack_require__(2933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromSelect__ = __webpack_require__(2932);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      formData = props.formData,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema;

  var options = localSchema.enum || ['Option 1', 'Option 2', 'Option 3'];
  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'array',
      items: {
        type: 'string',
        enum: options
      }
    },
    uiSchema: {
      'ui:widget': 'checkboxes',
      'ui:description': localUiSchema['ui:description']
    },
    formData: formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromSelect__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = null;
  if (Array.isArray(formData) && formData.length === 1) {
    newFormData = formData[0];
  }
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: undefined };
});

/***/ }),
/* 2941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  if (formData) {
    newSchema.enum[0] = formData;
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: formData };
});

/***/ }),
/* 2942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData && formData.filter(function (r) {
    return r !== '';
  }).length > 0 ? formData.filter(function (r) {
    return r !== '';
  }).join(', ') : undefined;
  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  if (newFormData) {
    newSchema.enum[0] = newFormData;
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromText__ = __webpack_require__(2941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromTextArea__ = __webpack_require__(2942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromTextList__ = __webpack_require__(2943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTable__ = __webpack_require__(2940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromSelect__ = __webpack_require__(2939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2938);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      formData = props.formData,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema;

  var options = localSchema.enum || localSchema.items && localSchema.items.enum || ['Option 1', 'Option 2', 'Option 3'];
  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'string',
      enum: options
    },
    uiSchema: { 'ui:widget': 'radio', 'ui:description': localUiSchema['ui:description'] },
    formData: formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromSelect__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = null;
  if (Array.isArray(formData) && formData.length === 1) {
    newFormData = formData[0];
  }
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: undefined };
});

/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  if (formData) {
    newSchema.enum[0] = formData;
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: formData };
});

/***/ }),
/* 2949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData && formData.filter(function (r) {
    return r !== '';
  }).length > 0 ? formData.filter(function (r) {
    return r !== '';
  }).join(', ') : undefined;
  var newSchema = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(schema);
  if (newFormData) {
    newSchema.enum[0] = newFormData;
  }
  return { schema: newSchema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromText__ = __webpack_require__(2948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromTextArea__ = __webpack_require__(2949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromTextList__ = __webpack_require__(2950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTable__ = __webpack_require__(2947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromRadio__ = __webpack_require__(2946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2945);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema,
      formData = props.formData;

  var options = localSchema.enum || localSchema.items && localSchema.items.enum || ['Option 1', 'Option 2', 'Option 3'];
  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'string',
      enum: options
    },
    uiSchema: { 'ui:widget': 'select', 'ui:description': localUiSchema['ui:description'] },
    formData: formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromText__ = __webpack_require__(2955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromRadio__ = __webpack_require__(2953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromSelect__ = __webpack_require__(2954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTextArea__ = __webpack_require__(2956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromTextList__ = __webpack_require__(2957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2952);







function generateId() {
  return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
}

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema;

  var newSchema = {
    title: localSchema.title,
    type: 'array',
    items: {
      type: 'object',
      properties: {}
    }
  };
  var keys = [];
  for (var i = 0; i < 3; i++) {
    var id = generateId();
    keys.push(id);
    newSchema.items.properties[id] = {
      title: 'Column ' + (i + 1),
      type: 'string'
    };
  }
  var updatedForm = {
    schema: newSchema,
    uiSchema: {
      'ui:widget': 'table',
      'ui:headers': keys,
      'ui:description': localUiSchema['ui:description'],
      items: { properties: { 'ui:order': keys } }
    },
    formData: [{}]
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromSelect__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? formData.join(', ') : undefined;
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: undefined };
});

/***/ }),
/* 2963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? formData.join(', ') : undefined;
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromRadio__ = __webpack_require__(2960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromTextArea__ = __webpack_require__(2963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromTextList__ = __webpack_require__(2964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTable__ = __webpack_require__(2962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromSelect__ = __webpack_require__(2961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2959);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema,
      formData = props.formData;

  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'string'
    },
    uiSchema: {
      'ui:widget': 'text',
      'ui:description': localUiSchema['ui:description']
    },
    formData: formData
  };
  switch (from) {
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromSelect__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? formData.join('\n') : undefined;
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { schema: schema, uiSchema: uiSchema, formData: undefined };
});

/***/ }),
/* 2970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? formData.join('\n') : undefined;
  return { schema: schema, uiSchema: uiSchema, formData: newFormData };
});

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromRadio__ = __webpack_require__(2967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromText__ = __webpack_require__(2970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromTextList__ = __webpack_require__(2971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTable__ = __webpack_require__(2969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromSelect__ = __webpack_require__(2968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2966);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema,
      formData = props.formData;

  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'string'
    },
    uiSchema: {
      'ui:widget': 'textArea',
      'ui:description': localUiSchema['ui:description']
    },
    formData: formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromTextList__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromSelect__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Do nothing
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return props;
});

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? [formData] : [''];
  return { formData: newFormData, schema: schema, uiSchema: uiSchema };
});

/***/ }),
/* 2975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? [formData] : [''];
  return { formData: newFormData, schema: schema, uiSchema: uiSchema };
});

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema;
  return { formData: [''], schema: schema, uiSchema: uiSchema };
});

/***/ }),
/* 2977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? [formData] : [''];
  return { formData: newFormData, schema: schema, uiSchema: uiSchema };
});

/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var formData = _ref.formData,
      schema = _ref.schema,
      uiSchema = _ref.uiSchema;

  var newFormData = formData ? [formData] : [''];
  return { formData: newFormData, schema: schema, uiSchema: uiSchema };
});

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromText__ = __webpack_require__(2977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromTextArea__ = __webpack_require__(2978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromRadio__ = __webpack_require__(2974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromTable__ = __webpack_require__(2976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fromSelect__ = __webpack_require__(2975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__ = __webpack_require__(2973);







/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var from = props.from,
      onChange = props.onChange,
      localSchema = props.localSchema,
      localUiSchema = props.localUiSchema,
      formData = props.formData;

  var updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'array',
      items: { type: 'string' }
    },
    uiSchema: {
      'ui:widget': 'textList',
      'ui:description': localUiSchema['ui:description']
    },
    formData: formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fromText__["a" /* default */])(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fromTextArea__["a" /* default */])(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fromRadio__["a" /* default */])(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromTable__["a" /* default */])(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fromSelect__["a" /* default */])(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__fromCheckboxes__["a" /* default */])(updatedForm)));
      break;
    default:
      break;
  }
});

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(2982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Actions__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Brand__ = __webpack_require__(2915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Logo__ = __webpack_require__(2983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Renderer_Renderer__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Builder_Builder__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Renderer_Controls__ = __webpack_require__(1451);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _class, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var Form = (_temp = _class = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.addContentBlock = _this.addContentBlock.bind(_this);
    _this.addQuestion = _this.addQuestion.bind(_this);
    _this.canEdit = _this.canEdit.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.onResponseChange = _this.onResponseChange.bind(_this);
    _this.generateId = _this.generateId.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.deleteQuestion = _this.deleteQuestion.bind(_this);
    _this.updateResponse = _this.updateResponse.bind(_this);
    _this.updateForm = _this.updateForm.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.allChangesSaved = _this.allChangesSaved.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.updateWindowDimensions();
      if (this.props.location.query.share_token) {
        this.addFormToSession(function () {
          return _this2.initializeForm(_this2.props);
        });
      } else if (this.props.node) {
        this.initializeForm(this.props);
      }
      if (this.props.params.action !== 'edit') {
        this.setState({
          dirtyChecker: setInterval(function () {
            return _this2.updateResponse();
          }, 5000)
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Temporary fix for #304 until relay fixes callback handling
      // https://github.com/unp/cloverbook-rails/issues/304
      if (!this.props.node && nextProps.node) {
        this.initializeForm(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.dirtyChecker) clearInterval(this.state.dirtyChecker);
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'onChange',
    value: function onChange(_ref, callback) {
      var schema = _ref.schema,
          uiSchema = _ref.uiSchema,
          formData = _ref.formData;

      this.setState({ schema: schema, uiSchema: uiSchema, formData: formData }, callback);
    }
  }, {
    key: 'onResponseChange',
    value: function onResponseChange(key, value) {
      this.setState({
        formData: Object.assign({}, this.state.formData, _defineProperty({}, key, value))
      });
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'allChangesSaved',
    value: function allChangesSaved() {
      return this.props.node.data === JSON.stringify(this.state.formData);
    }
  }, {
    key: 'addContentBlock',
    value: function addContentBlock() {
      var _this3 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var key = this.generateId();
      state.schema.properties[key] = { type: 'null', title: null };
      state.uiSchema['ui:order'].push(key);
      state.uiSchema[key] = { 'ui:widget': 'contentBlock', 'ui:content': '' };
      this.setState(state, function () {
        return _this3.updateForm();
      });
    }
  }, {
    key: 'addQuestion',
    value: function addQuestion() {
      var _this4 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var key = this.generateId();
      state.schema.properties[key] = { type: 'string', title: null };
      state.uiSchema['ui:order'].push(key);
      state.uiSchema[key] = { 'ui:widget': 'text', 'ui:description': '' };
      this.setState(state, function () {
        return _this4.updateForm();
      });
    }
  }, {
    key: 'addFormToSession',
    value: function addFormToSession(onSuccess) {
      var _this5 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this5.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null, onSuccess);
      };

      var onError = function onError() {
        _this5.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3005);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'initializeForm',
    value: function initializeForm(props) {
      var node = props.node;

      if (node) {
        this.setState({
          initialFormData: JSON.parse(node.data),
          formData: JSON.parse(node.data),
          schema: JSON.parse(node.schema),
          uiSchema: JSON.parse(node.ui_schema)
        });
      }
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'deleteQuestion',
    value: function deleteQuestion(key) {
      var _this6 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete state.schema.properties[key];
      delete state.formData[key];
      delete state.uiSchema[key];
      delete state.initialFormData[key];
      state.uiSchema['ui:order'].splice(state.uiSchema['ui:order'].indexOf(key), 1);
      this.setState(state, function () {
        return _this6.updateForm();
      });
    }
  }, {
    key: 'updateForm',
    value: function updateForm(onSuccess, onFailure) {
      var onError = function onError() {
        if (onFailure) onFailure();
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (onSuccess) onSuccess();
      };

      var id = this.props.node.id;


      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3004);
      });

      var schema = JSON.stringify(this.state.schema);
      var ui_schema = JSON.stringify(this.state.uiSchema); // eslint-disable-line camelcase
      var data = JSON.stringify(this.state.formData);

      var optimisticResponse = {
        updateForm: {
          form: { id: id, schema: schema, ui_schema: ui_schema, data: data }
        }
      };
      var environment = this.props.relay.environment;

      if (this.props.node.ui_schema !== JSON.stringify(this.state.uiSchema) || this.props.node.schema !== JSON.stringify(this.state.schema)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              schema: schema,
              ui_schema: ui_schema,
              data: data
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      } else {
        if (onSuccess) onSuccess();
      }
    }
  }, {
    key: 'updateResponse',
    value: function updateResponse(onSuccess, onFailure) {
      if (this.props.node && !this.allChangesSaved()) {
        var onError = function onError() {
          if (onFailure) onFailure();
          __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
            message: 'Unable to save form',
            intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
          });
        };
        var onCompleted = function onCompleted() {
          if (onSuccess) onSuccess();
        };

        var id = this.props.node.id;


        var mutation = _graphql3 || (_graphql3 = function _graphql3() {
          return __webpack_require__(3003);
        });

        var data = JSON.stringify(this.state.formData);

        var optimisticResponse = {
          fillForm: {
            form: { id: id, data: data }
          }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              data: data
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isLargeScreen = this.state.window.width >= 1280;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Actions__["a" /* default */], {
        node: this.props.node,
        params: this.props.params,
        relay: this.props.relay,
        router: this.props.router,
        windowDimensions: this.state.window
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default.a,
          {
            sidebar: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__["a" /* default */], {
              setSidebarOpenState: this.onSetSidebarOpen,
              router: this.props.router,
              viewer: this.props.viewer
            }),
            sidebarClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.sidebar,
            open: this.state.sidebarOpen,
            onSetOpen: this.onSetSidebarOpen,
            touch: false,
            contentClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileSidebarContent,
            rootClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileSidebarRoot
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["a" /* default */], {
            allChangesSaved: this.allChangesSaved(),
            toggleSidebar: this.toggleSidebar,
            sidebarOpen: this.state.sidebarOpen,
            document: this.props.node,
            relay: this.props.relay,
            router: this.props.router,
            params: this.props.params,
            viewer: this.props.viewer,
            windowDimensions: this.state.window
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["s" /* Container */],
            { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.container },
            !isLargeScreen && this.state.window.width >= __WEBPACK_IMPORTED_MODULE_6__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                {
                  columns: 'equal',
                  className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionsMenuTablet
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  ActionsMenu
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["t" /* Segment */],
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.segment },
              isLargeScreen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["u" /* Rail */],
                {
                  position: 'right',
                  close: true,
                  className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionsMenuDesktop
                },
                ActionsMenu
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */],
                { padded: true, stackable: true, relaxed: true },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Logo__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Brand__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Renderer_Controls__["a" /* default */], {
                      allChangesSaved: this.allChangesSaved(),
                      updateResponse: this.updateResponse
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', style: { marginTop: '2em' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    this.props.params.action === 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Builder_Builder__["a" /* default */], {
                      addContentBlock: this.addContentBlock,
                      addQuestion: this.addQuestion,
                      schema: this.state.schema,
                      uiSchema: this.state.uiSchema,
                      onChange: this.onChange,
                      updateForm: this.updateForm,
                      deleteQuestion: this.deleteQuestion,
                      formData: this.state.formData
                    }),
                    this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Renderer_Renderer__["a" /* default */], {
                      updateResponse: this.updateResponse,
                      allChangesSaved: this.allChangesSaved(),
                      formData: this.state.initialFormData,
                      onChange: this.onResponseChange,
                      schema: this.state.schema,
                      uiSchema: this.state.uiSchema
                    })
                  )
                )
              )
            )
          )
        ),
        !this.props.node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App_404__["a" /* default */], { viewer: this.props.viewer }),
          !this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(Form));

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormComponent__ = __webpack_require__(2980);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__FormComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3007);
  },
  viewer: function viewer() {
    return __webpack_require__(3008);
  }
}, function () {
  return __webpack_require__(3006);
}));

/***/ }),
/* 2982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(2998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var FormHeader = function (_React$Component) {
  _inherits(FormHeader, _React$Component);

  function FormHeader(props) {
    _classCallCheck(this, FormHeader);

    var _this = _possibleConstructorReturn(this, (FormHeader.__proto__ || Object.getPrototypeOf(FormHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(FormHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return FormHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormHeader);

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var FormLogo = function (_React$Component) {
  _inherits(FormLogo, _React$Component);

  function FormLogo(props) {
    _classCallCheck(this, FormLogo);

    var _this = _possibleConstructorReturn(this, (FormLogo.__proto__ || Object.getPrototypeOf(FormLogo)).call(this, props));

    _this.updateFormLogo = _this.updateFormLogo.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(FormLogo, [{
    key: 'updateFormLogo',
    value: function updateFormLogo(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3011);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            form_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.updateFormLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3009);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this3 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this4.updateFormLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3010);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand_logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return FormLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (FormLogo);

/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Widgets_Checkboxes__ = __webpack_require__(2990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Widgets_TextList__ = __webpack_require__(2996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Widgets_Table__ = __webpack_require__(2994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var COMPONENT_TYPES = {
  checkboxes: __WEBPACK_IMPORTED_MODULE_4__Widgets_Checkboxes__["a" /* default */],
  textList: __WEBPACK_IMPORTED_MODULE_5__Widgets_TextList__["a" /* default */],
  table: __WEBPACK_IMPORTED_MODULE_6__Widgets_Table__["a" /* default */]
};

var ArrayField = function (_React$Component) {
  _inherits(ArrayField, _React$Component);

  function ArrayField(props) {
    _classCallCheck(this, ArrayField);

    var _this = _possibleConstructorReturn(this, (ArrayField.__proto__ || Object.getPrototypeOf(ArrayField)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    _this.addResponse = _this.addResponse.bind(_this);
    _this.removeResponse = _this.removeResponse.bind(_this);
    return _this;
  }

  _createClass(ArrayField, [{
    key: 'onChange',
    value: function onChange(value, index) {
      var formData = this.props.formData ? this.props.formData.slice() : [];
      formData[index] = value;
      this.props.onChange(formData);
    }
  }, {
    key: 'addResponse',
    value: function addResponse() {
      var formData = this.props.formData ? this.props.formData.slice() : [];
      switch (this.props.uiSchema['ui:widget']) {
        case 'textList':
          formData.push('');
          break;
        case 'table':
          formData.push({});
          break;
        default:
          formData.push('');
      }
      this.props.onChange(formData);
    }
  }, {
    key: 'removeResponse',
    value: function removeResponse(index) {
      var formData = this.props.formData.slice();
      formData.splice(index, 1);
      this.props.onChange(formData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema,
          onChange = _props.onChange;

      var formData = this.props.formData || (uiSchema && uiSchema['ui:widget'] === 'textList' ? [''] : []);
      var widgetName = uiSchema && uiSchema['ui:widget'] || 'textList';
      var Widget = COMPONENT_TYPES[widgetName];
      var addText = 'Add ' + (uiSchema && uiSchema['ui:widget'] === 'table' ? 'Row' : 'Another');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isComputer = _ref.isComputer;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            widgetName === 'checkboxes' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, {
              schema: schema,
              onChange: onChange,
              uiSchema: uiSchema,
              formData: formData
            }),
            widgetName === 'table' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */],
              { stackable: true },
              isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
                  null,
                  uiSchema['ui:headers'].map(function (header, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                      { key: index },
                      schema.items.properties[header].title
                    );
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell, null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Body,
                null,
                formData.map(function (item, index) {
                  var _React$createElement;

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, (_React$createElement = {
                    schema: schema,
                    onChange: onChange,
                    uiSchema: uiSchema,
                    formData: item,
                    key: index
                  }, _defineProperty(_React$createElement, 'onChange', function onChange(e) {
                    return _this2.onChange(e, index);
                  }), _defineProperty(_React$createElement, 'removeResponse', function removeResponse() {
                    return _this2.removeResponse(index);
                  }), _React$createElement));
                })
              )
            ),
            widgetName !== 'table' && widgetName !== 'checkboxes' && formData.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' }, key: index, className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, _defineProperty({
                    schema: schema,
                    onChange: onChange,
                    uiSchema: uiSchema,
                    formData: item,
                    key: index
                  }, 'onChange', function onChange(e) {
                    return _this2.onChange(e, index);
                  }))
                ),
                index > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.deleteItemRelative,
                    style: { marginTop: '0.5em' },
                    onClick: function onClick() {
                      return _this2.removeResponse(index);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'close' })
                ),
                index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: '1.5em' } })
              );
            }),
            widgetName !== 'checkboxes' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: _this2.addResponse },
              '+ ',
              addText
            )
          );
        }
      );
    }
  }]);

  return ArrayField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ArrayField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (ArrayField);

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widgets_ContentBlock__ = __webpack_require__(2991);




var COMPONENT_TYPES = {
  contentBlock: __WEBPACK_IMPORTED_MODULE_2__Widgets_ContentBlock__["a" /* default */]
};

var NullField = function NullField(_ref) {
  var uiSchema = _ref.uiSchema,
      schema = _ref.schema;

  // Defaults to ContentBlock widget
  var Widget = COMPONENT_TYPES[uiSchema && uiSchema['ui:widget'] || 'contentBlock'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, { schema: schema, uiSchema: uiSchema });
};

NullField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (NullField);

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObjectKey__ = __webpack_require__(2987);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ObjectField = function (_React$Component) {
  _inherits(ObjectField, _React$Component);

  function ObjectField() {
    _classCallCheck(this, ObjectField);

    return _possibleConstructorReturn(this, (ObjectField.__proto__ || Object.getPrototypeOf(ObjectField)).apply(this, arguments));
  }

  _createClass(ObjectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formData = _props.formData,
          onChange = _props.onChange,
          schema = _props.schema,
          uiSchema = _props.uiSchema;

      var orderedKeys = uiSchema['ui:order'] || Object.keys(schema.properties);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        orderedKeys.map(function (key, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index, style: { marginBottom: '4em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ObjectKey__["a" /* default */], {
              schema: schema.properties[key],
              uiSchema: uiSchema[key],
              formData: formData && formData[key],
              onChange: onChange,
              fieldID: key
            })
          );
        })
      );
    }

    // TODO: Review proptypes validations

  }]);

  return ObjectField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ObjectField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  properties: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ObjectField);

/***/ }),
/* 2987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SchemaField__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ObjectKey = function (_React$PureComponent) {
  _inherits(ObjectKey, _React$PureComponent);

  function ObjectKey(props) {
    _classCallCheck(this, ObjectKey);

    var _this = _possibleConstructorReturn(this, (ObjectKey.__proto__ || Object.getPrototypeOf(ObjectKey)).call(this, props));

    _this.state = {
      formData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(_this.props.formData)
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(ObjectKey, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.formData !== nextProps.formData) {
        this.setState({ formData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(nextProps.formData) });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(formData) {
      var _this2 = this;

      this.setState({ formData: formData }, function () {
        return _this2.props.onChange(_this2.props.fieldID, formData);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          schema = _props.schema,
          uiSchema = _props.uiSchema;
      var formData = this.state.formData;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SchemaField__["a" /* default */], {
          schema: schema,
          uiSchema: uiSchema,
          formData: formData,
          onChange: this.onChange
        })
      );
    }
  }]);

  return ObjectKey;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

ObjectKey.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  fieldID: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ObjectKey);

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Widgets_Text__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Widgets_TextArea__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Widgets_Radio__ = __webpack_require__(2992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Widgets_Select__ = __webpack_require__(2993);







var COMPONENT_TYPES = {
  text: __WEBPACK_IMPORTED_MODULE_2__Widgets_Text__["a" /* default */],
  textArea: __WEBPACK_IMPORTED_MODULE_3__Widgets_TextArea__["a" /* default */],
  radio: __WEBPACK_IMPORTED_MODULE_4__Widgets_Radio__["a" /* default */],
  select: __WEBPACK_IMPORTED_MODULE_5__Widgets_Select__["a" /* default */]
};

var StringField = function StringField(_ref) {
  var onChange = _ref.onChange,
      formData = _ref.formData,
      uiSchema = _ref.uiSchema,
      schema = _ref.schema;

  // Defaults to Text widget
  var Widget = COMPONENT_TYPES[uiSchema && uiSchema['ui:widget'] || 'text'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Widget, { value: formData, onChange: onChange, schema: schema, uiSchema: uiSchema });
};

StringField.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (StringField);

/***/ }),
/* 2989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'Unsupported field type'
  );
});

/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);





var CheckboxesWidget = function CheckboxesWidget(_ref) {
  var onChange = _ref.onChange,
      formData = _ref.formData,
      schema = _ref.schema;

  var onCheck = function onCheck(e, _ref2) {
    var value = _ref2.value;

    var newFormData = formData.slice();
    var index = formData.indexOf(value);
    if (index === -1) {
      newFormData.push(value);
    } else {
      newFormData.splice(index, 1);
    }
    onChange(newFormData);
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
    schema.items.enum.map(function (option, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
          onChange: onCheck,
          checked: formData.includes(option),
          style: { paddingBottom: '1em' },
          label: option,
          value: option
        })
      );
    })
  );
};

CheckboxesWidget.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CheckboxesWidget);

/***/ }),
/* 2991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var ContentBlockWidget = function ContentBlockWidget(_ref) {
  var uiSchema = _ref.uiSchema;

  var hasContent = uiSchema['ui:content'] === null || uiSchema['ui:content'].replace(/(<h1>)(<br>)(<\/h1>)/gim, '') !== '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    hasContent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      style: { wordBreak: 'break-word' },
      dangerouslySetInnerHTML: { __html: uiSchema['ui:content'] }
    })
  );
};

ContentBlockWidget.propTypes = {
  uiSchema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ContentBlockWidget);

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RadioWidget = function (_React$Component) {
  _inherits(RadioWidget, _React$Component);

  function RadioWidget(props) {
    _classCallCheck(this, RadioWidget);

    var _this = _possibleConstructorReturn(this, (RadioWidget.__proto__ || Object.getPrototypeOf(RadioWidget)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(RadioWidget, [{
    key: 'onChange',
    value: function onChange(e, data) {
      this.props.onChange(data.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          schema = _props.schema;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
        schema.enum.map(function (option, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["z" /* Radio */], {
              onChange: _this2.onChange,
              checked: value === option,
              style: { paddingBottom: '1em' },
              label: option,
              value: option
            })
          );
        })
      );
    }
  }]);

  return RadioWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RadioWidget.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RadioWidget);

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SelectWidget = function (_React$Component) {
  _inherits(SelectWidget, _React$Component);

  function SelectWidget(props) {
    _classCallCheck(this, SelectWidget);

    var _this = _possibleConstructorReturn(this, (SelectWidget.__proto__ || Object.getPrototypeOf(SelectWidget)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(SelectWidget, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          schema = _props.schema;

      var options = schema.enum.map(function (option) {
        return { text: option, value: option };
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__Form_scss___default.a.responseField },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["f" /* FloatingLabelSelect */], {
          onChange: this.onChange,
          value: value,
          name: 'select',
          options: options,
          fluid: true,
          placeholder: 'Select option...'
        })
      );
    }
  }]);

  return SelectWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectWidget.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SelectWidget);

/***/ }),
/* 2994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Text__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RootComponent__ = __webpack_require__(54);








var TextTableWidget = function TextTableWidget(_ref) {
  var schema = _ref.schema,
      uiSchema = _ref.uiSchema,
      onChange = _ref.onChange,
      formData = _ref.formData,
      removeResponse = _ref.removeResponse;

  var onCellChange = function onCellChange(value, key) {
    var newFormData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(formData);
    newFormData[key] = value;
    onChange(newFormData);
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__RootComponent__["b" /* RootConsumer */],
    null,
    function (_ref2) {
      var isMobile = _ref2.isMobile;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Row,
        null,
        uiSchema['ui:headers'].map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Cell,
            { key: index },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Text__["a" /* default */], {
              schema: schema.items.properties[item],
              value: formData[item],
              label: isMobile && schema.items.properties[item].title,
              onChange: function onChange(value) {
                return onCellChange(value, item);
              }
            })
          );
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["q" /* Table */].Cell,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_5__Form_scss___default.a.deleteItemRelative,
              style: { marginTop: '-0.5em' },
              onClick: removeResponse
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'close' })
          )
        )
      );
    }
  );
};

TextTableWidget.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  uiSchema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  schema: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  formData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  removeResponse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TextTableWidget);

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TextAreaWidget = function (_React$Component) {
  _inherits(TextAreaWidget, _React$Component);

  function TextAreaWidget(props) {
    _classCallCheck(this, TextAreaWidget);

    var _this = _possibleConstructorReturn(this, (TextAreaWidget.__proto__ || Object.getPrototypeOf(TextAreaWidget)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(TextAreaWidget, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.props.value;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          name: 'textAreaWidget',
          value: value || '',
          placeholder: 'Your answer',
          onChange: this.onChange,
          autoHeight: true,
          rows: 2
        })
      );
    }
  }]);

  return TextAreaWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextAreaWidget.propTypes = {
  schema: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (TextAreaWidget);

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);




var TextArrayWidget = function TextArrayWidget(_ref) {
  var _onChange = _ref.onChange,
      formData = _ref.formData;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
    name: 'textWidget',
    value: formData,
    autoHeight: true,
    placeholder: 'Your answer',
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  });
};

TextArrayWidget.propTypes = {
  formData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TextArrayWidget);

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__ = __webpack_require__(528);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FormShare = function (_React$Component) {
  _inherits(FormShare, _React$Component);

  function FormShare(props) {
    _classCallCheck(this, FormShare);

    var _this = _possibleConstructorReturn(this, (FormShare.__proto__ || Object.getPrototypeOf(FormShare)).call(this, props));

    _this.sendEmail = _this.sendEmail.bind(_this);
    return _this;
  }

  _createClass(FormShare, [{
    key: 'sendEmail',
    value: function sendEmail(formModel, successCb) {
      var subject = formModel.subject,
          to = formModel.to,
          message = formModel.message;

      var cc = formModel.cc === '' ? null : formModel.cc;
      var onCompleted = function onCompleted() {
        successCb();
      };
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3012);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { form_id: this.props.document.id, to: to, cc: cc, subject: subject, message: message }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          onOpen = _props.onOpen,
          onClose = _props.onClose;

      var permissionsNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Anyone with the link ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'can fill out'
        ),
        ' this form.'
      );
      var workspaces = this.props.document.workspaces.edges;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__["a" /* default */], {
        document: this.props.document,
        canEmail: this.props.document.can_email,
        event: workspaces.length > 0 ? workspaces[0].node.event : null,
        title: 'Share Form',
        shareUrl: "https://www.cloverbook.com" + '/open/f/' + this.props.document.share_token,
        documentType: 'form',
        permissionsNode: permissionsNode,
        sendEmail: this.sendEmail,
        trigger: trigger,
        onOpen: onOpen,
        onClose: onClose
      });
    }
  }]);

  return FormShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormShare.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormShare);

/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FormTitle = function (_React$Component) {
  _inherits(FormTitle, _React$Component);

  function FormTitle(props) {
    _classCallCheck(this, FormTitle);

    var _this = _possibleConstructorReturn(this, (FormTitle.__proto__ || Object.getPrototypeOf(FormTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(FormTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated form title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Form)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3013);
        });

        var optimisticResponse = {
          updateForm: { form: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return FormTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (FormTitle);

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 246349bbe7ddd3cbdcc80a35edc98c02
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFormInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteFormMutationVariables = {|
  input: DeleteFormInput
|};
export type ActionsComponent_deleteFormMutationResponse = {|
  +deleteForm: ?{|
    +deletedFormId: ?string
  |}
|};
export type ActionsComponent_deleteFormMutation = {|
  variables: ActionsComponent_deleteFormMutationVariables,
  response: ActionsComponent_deleteFormMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteFormMutation(
  $input: DeleteFormInput!
) {
  deleteForm(input: $input) {
    deletedFormId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteForm",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteFormInput!"
    }],
    "concreteType": "DeleteFormPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedFormId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteFormMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteFormMutation(\n  $input: DeleteFormInput!\n) {\n  deleteForm(input: $input) {\n    deletedFormId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteFormMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b5566983289034a2b42460cec7b88032';
module.exports = node;

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 90c2d4638cab9a6744c89a4dfa639f1f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SaveFormAsTemplateInput = {
  clientMutationId?: ?string,
  form_id: string,
};
export type ActionsComponent_saveFormAsTemplateMutationVariables = {|
  input: SaveFormAsTemplateInput
|};
export type ActionsComponent_saveFormAsTemplateMutationResponse = {|
  +saveFormAsTemplate: ?{|
    +form_template: ?{|
      +id: string
    |}
  |}
|};
export type ActionsComponent_saveFormAsTemplateMutation = {|
  variables: ActionsComponent_saveFormAsTemplateMutationVariables,
  response: ActionsComponent_saveFormAsTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_saveFormAsTemplateMutation(
  $input: SaveFormAsTemplateInput!
) {
  saveFormAsTemplate(input: $input) {
    form_template {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SaveFormAsTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "saveFormAsTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "SaveFormAsTemplateInput!"
    }],
    "concreteType": "SaveFormAsTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form_template",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_saveFormAsTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_saveFormAsTemplateMutation(\n  $input: SaveFormAsTemplateInput!\n) {\n  saveFormAsTemplate(input: $input) {\n    form_template {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_saveFormAsTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_saveFormAsTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c85a0c20a7a8e768d2c4c810cbce2369';
module.exports = node;

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6695fcb9379c3018c0280b15063b9f69
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_Form_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_Form_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_Form_updateBrandMutation = {|
  variables: Brand_Form_updateBrandMutationVariables,
  response: Brand_Form_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_Form_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_Form_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_Form_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_Form_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_Form_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '982748ed41746ca29b27bc549f806503';
module.exports = node;

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5426daeee3f81a03ea067176aeb07a14
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormBrandInput = {
  clientMutationId?: ?string,
  form_id: string,
  brand_id: string,
};
export type Brand_updateFormBrandMutationVariables = {|
  input: UpdateFormBrandInput
|};
export type Brand_updateFormBrandMutationResponse = {|
  +updateFormBrand: ?{|
    +form: ?{|
      +id: string,
      +brand_header: ?string,
    |}
  |}
|};
export type Brand_updateFormBrandMutation = {|
  variables: Brand_updateFormBrandMutationVariables,
  response: Brand_updateFormBrandMutationResponse,
|};
*/

/*
mutation Brand_updateFormBrandMutation(
  $input: UpdateFormBrandInput!
) {
  updateFormBrand(input: $input) {
    form {
      id
      brand_header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFormBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateFormBrandInput!"
    }],
    "concreteType": "UpdateFormBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_updateFormBrandMutation",
    "id": null,
    "text": "mutation Brand_updateFormBrandMutation(\n  $input: UpdateFormBrandInput!\n) {\n  updateFormBrand(input: $input) {\n    form {\n      id\n      brand_header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_updateFormBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_updateFormBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8c07c75e5f276d8eeedb1e8b7e6c075c';
module.exports = node;

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c80ef62dd13bf973728f14b125bcec3e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FillFormInput = {
  clientMutationId?: ?string,
  id: string,
  data: string,
};
export type FormComponent_FillFormMutationVariables = {|
  input: FillFormInput
|};
export type FormComponent_FillFormMutationResponse = {|
  +fillForm: ?{|
    +form: ?{|
      +data: ?string
    |}
  |}
|};
export type FormComponent_FillFormMutation = {|
  variables: FormComponent_FillFormMutationVariables,
  response: FormComponent_FillFormMutationResponse,
|};
*/

/*
mutation FormComponent_FillFormMutation(
  $input: FillFormInput!
) {
  fillForm(input: $input) {
    form {
      data
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "FillFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "FillFormInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "FormComponent_FillFormMutation",
    "id": null,
    "text": "mutation FormComponent_FillFormMutation(\n  $input: FillFormInput!\n) {\n  fillForm(input: $input) {\n    form {\n      data\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "FormComponent_FillFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "fillForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "FillFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "FormComponent_FillFormMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "fillForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "FillFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5f3e9433fc4c7863130d9dae83c37ecf';
module.exports = node;

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d68aa5de6573989bb739dcaaf5cd5d3c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type FormComponent_UpdateFormMutationVariables = {|
  input: UpdateFormInput
|};
export type FormComponent_UpdateFormMutationResponse = {|
  +updateForm: ?{|
    +form: ?{|
      +schema: ?string,
      +ui_schema: ?string,
    |}
  |}
|};
export type FormComponent_UpdateFormMutation = {|
  variables: FormComponent_UpdateFormMutationVariables,
  response: FormComponent_UpdateFormMutationResponse,
|};
*/

/*
mutation FormComponent_UpdateFormMutation(
  $input: UpdateFormInput!
) {
  updateForm(input: $input) {
    form {
      schema
      ui_schema
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateFormInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "schema",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "ui_schema",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "FormComponent_UpdateFormMutation",
    "id": null,
    "text": "mutation FormComponent_UpdateFormMutation(\n  $input: UpdateFormInput!\n) {\n  updateForm(input: $input) {\n    form {\n      schema\n      ui_schema\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "FormComponent_UpdateFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2, v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "FormComponent_UpdateFormMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '17f9a98f5292e0a54cf7186971d1b7e0';
module.exports = node;

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 965ac54c2646f9acd5ffe89e54556e0c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddFormToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type FormComponent_addFormToSessionMutationVariables = {|
  input: AddFormToSessionInput
|};
export type FormComponent_addFormToSessionMutationResponse = {|
  +addFormToSession: ?{|
    +form: ?{|
      +id: string
    |}
  |}
|};
export type FormComponent_addFormToSessionMutation = {|
  variables: FormComponent_addFormToSessionMutationVariables,
  response: FormComponent_addFormToSessionMutationResponse,
|};
*/

/*
mutation FormComponent_addFormToSessionMutation(
  $input: AddFormToSessionInput!
) {
  addFormToSession(input: $input) {
    form {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddFormToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addFormToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddFormToSessionInput!"
    }],
    "concreteType": "AddFormToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "FormComponent_addFormToSessionMutation",
    "id": null,
    "text": "mutation FormComponent_addFormToSessionMutation(\n  $input: AddFormToSessionInput!\n) {\n  addFormToSession(input: $input) {\n    form {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "FormComponent_addFormToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "FormComponent_addFormToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '257dd68248a7acc38dd93571a36398f1';
module.exports = node;

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5722c668ecda450246b7a202c66793b7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type FormContainer_node$ref = any;
export type FormContainer_RefetchQueryVariables = {|
  id: string
|};
export type FormContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: FormContainer_node$ref
  |}
|};
export type FormContainer_RefetchQuery = {|
  variables: FormContainer_RefetchQueryVariables,
  response: FormContainer_RefetchQueryResponse,
|};
*/

/*
query FormContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...FormContainer_node
    id
  }
}

fragment FormContainer_node on Form {
  id
  brand_logo_url
  brand_header
  title
  can_edit
  can_email
  share_token
  data
  schema
  ui_schema
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "FormContainer_RefetchQuery",
    "id": null,
    "text": "query FormContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...FormContainer_node\n    id\n  }\n}\n\nfragment FormContainer_node on Form {\n  id\n  brand_logo_url\n  brand_header\n  title\n  can_edit\n  can_email\n  share_token\n  data\n  schema\n  ui_schema\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "FormContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FormContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "FormContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "InlineFragment",
          "type": "Form",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "data",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "ui_schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3ee278590c2e234b969316ecbf638fdf';
module.exports = node;

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type Share_event$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormContainer_node$ref: FragmentReference;
export type FormContainer_node = {|
  +id: string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +title: ?string,
  +can_edit: ?boolean,
  +can_email: ?boolean,
  +share_token: ?string,
  +data: ?string,
  +schema: ?string,
  +ui_schema: ?string,
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +$fragmentRefs: Share_event$ref,
        |},
      |}
    |}>
  |},
  +$refType: FormContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "FormContainer_node",
    "type": "Form",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "can_email",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "share_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "data",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "schema",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "ui_schema",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, {
              "kind": "FragmentSpread",
              "name": "Share_event",
              "args": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '8c7d510183b1840e58b0c40931741bbe';
module.exports = node;

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormContainer_viewer$ref: FragmentReference;
export type FormContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$refType: FormContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "FormContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '0625f4cad669b2b77009c31a5a354a10';
module.exports = node;

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 462b5ac6ea7027eb0bbf1917889eab1c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Form_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Form_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Form_Logo_updateBrandMutation = {|
  variables: Logo_Form_Logo_updateBrandMutationVariables,
  response: Logo_Form_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Form_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Form_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Form_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Form_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Form_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f6e150ef258cafe1b1162a821a15970e';
module.exports = node;

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 3913830e734d043a33f78d948086ecf2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Form_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Form_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Form_deleteLogo_updateBrandMutation = {|
  variables: Logo_Form_deleteLogo_updateBrandMutationVariables,
  response: Logo_Form_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Form_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Form_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Form_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Form_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Form_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f1e19b7332fcf1f2bdbc17c9e574633f';
module.exports = node;

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fb2174911c5ac2296ee657d4ea0780b7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormBrandInput = {
  clientMutationId?: ?string,
  form_id: string,
  brand_id: string,
};
export type Logo_updateFormBrandMutationVariables = {|
  input: UpdateFormBrandInput
|};
export type Logo_updateFormBrandMutationResponse = {|
  +updateFormBrand: ?{|
    +form: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateFormBrandMutation = {|
  variables: Logo_updateFormBrandMutationVariables,
  response: Logo_updateFormBrandMutationResponse,
|};
*/

/*
mutation Logo_updateFormBrandMutation(
  $input: UpdateFormBrandInput!
) {
  updateFormBrand(input: $input) {
    form {
      id
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFormBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateFormBrandInput!"
    }],
    "concreteType": "UpdateFormBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_updateFormBrandMutation",
    "id": null,
    "text": "mutation Logo_updateFormBrandMutation(\n  $input: UpdateFormBrandInput!\n) {\n  updateFormBrand(input: $input) {\n    form {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_updateFormBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_updateFormBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fc0f5f66ce42f5541ad40b746b81ccfc';
module.exports = node;

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f22b8e158898c136ab428ac2036f9d13
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailFormLinkInput = {
  clientMutationId?: ?string,
  form_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type Share_emailFormLinkMutationVariables = {|
  input: EmailFormLinkInput
|};
export type Share_emailFormLinkMutationResponse = {|
  +emailFormLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type Share_emailFormLinkMutation = {|
  variables: Share_emailFormLinkMutationVariables,
  response: Share_emailFormLinkMutationResponse,
|};
*/

/*
mutation Share_emailFormLinkMutation(
  $input: EmailFormLinkInput!
) {
  emailFormLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailFormLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailFormLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailFormLinkInput!"
    }],
    "concreteType": "EmailFormLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Share_emailFormLinkMutation",
    "id": null,
    "text": "mutation Share_emailFormLinkMutation(\n  $input: EmailFormLinkInput!\n) {\n  emailFormLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Share_emailFormLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Share_emailFormLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '10b6e64dad772afe91d3eee5a0e2b7bf';
module.exports = node;

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 3e2861c47b7c7424baed84e830eb381e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type Title_UpdateFormMutationVariables = {|
  input: UpdateFormInput
|};
export type Title_UpdateFormMutationResponse = {|
  +updateForm: ?{|
    +form: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_UpdateFormMutation = {|
  variables: Title_UpdateFormMutationVariables,
  response: Title_UpdateFormMutationResponse,
|};
*/

/*
mutation Title_UpdateFormMutation(
  $input: UpdateFormInput!
) {
  updateForm(input: $input) {
    form {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateFormInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateFormMutation",
    "id": null,
    "text": "mutation Title_UpdateFormMutation(\n  $input: UpdateFormInput!\n) {\n  updateForm(input: $input) {\n    form {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateFormMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateForm",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '38b5103b3a40a4c877f3cd29fc0d5c46';
module.exports = node;

/***/ }),
/* 3014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InvoiceBrand = function (_React$Component) {
  _inherits(InvoiceBrand, _React$Component);

  function InvoiceBrand(props) {
    _classCallCheck(this, InvoiceBrand);

    var _this = _possibleConstructorReturn(this, (InvoiceBrand.__proto__ || Object.getPrototypeOf(InvoiceBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromInvoice()
    };
    _this.getBrandFromInvoice = _this.getBrandFromInvoice.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.updateInvoiceBrand = _this.updateInvoiceBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(InvoiceBrand, [{
    key: 'getBrandFromInvoice',
    value: function getBrandFromInvoice() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['brand_header']);
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.updateInvoiceBrand(successCb, failureCb);
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3035);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateInvoiceBrand',
    value: function updateInvoiceBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3036);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            invoice_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromInvoice();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromInvoice(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return InvoiceBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoiceBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceBrand);

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */













var InvoiceHeader = function (_React$Component) {
  _inherits(InvoiceHeader, _React$Component);

  function InvoiceHeader(props) {
    _classCallCheck(this, InvoiceHeader);

    var _this = _possibleConstructorReturn(this, (InvoiceHeader.__proto__ || Object.getPrototypeOf(InvoiceHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(InvoiceHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu, key: 'actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '1em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                node: this.props.document,
                relay: this.props.relay,
                canEdit: this.props.document.can_edit
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
              addPayment: this.props.addPayment,
              node: this.props.document,
              params: this.props.params,
              relay: this.props.relay,
              router: this.props.router,
              onClose: this.toggleActionsMenu,
              windowDimensions: this.props.windowDimensions
            })
          )
        )
      );
    }
  }]);

  return InvoiceHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceHeader.propTypes = {
  addPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceHeader);

/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(3015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Schedule__ = __webpack_require__(3031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LineItems__ = __webpack_require__(3019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Library__ = __webpack_require__(3018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Brand__ = __webpack_require__(3014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Logo__ = __webpack_require__(3020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Recipient__ = __webpack_require__(3024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Actions__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Payments__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PaymentPlan__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Pay__ = __webpack_require__(3021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Refunds__ = __webpack_require__(3030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment_timezone__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var Invoice = (_temp = _class = function (_React$Component) {
  _inherits(Invoice, _React$Component);

  function Invoice(props) {
    _classCallCheck(this, Invoice);

    var _this = _possibleConstructorReturn(this, (Invoice.__proto__ || Object.getPrototypeOf(Invoice)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.hasRecipient = _this.hasRecipient.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.closeSetupPaymentMethods = _this.closeSetupPaymentMethods.bind(_this);
    _this.openSetupPaymentMethods = _this.openSetupPaymentMethods.bind(_this);
    _this.openAddPayment = _this.openAddPayment.bind(_this);
    _this.closeAddPayment = _this.closeAddPayment.bind(_this);

    _this.state = {
      addPaymentOpen: false,
      error: !_this.props.node,
      sidebarOpen: false,
      setupPaymentMethodsOpen: false
    };
    return _this;
  }

  _createClass(Invoice, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.node && this.props.location.query.share_token) {
        this.addInvoiceToSession();
      }
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'addInvoiceToSession',
    value: function addInvoiceToSession() {
      var _this2 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this2.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null);
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3037);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'closeSetupPaymentMethods',
    value: function closeSetupPaymentMethods() {
      this.setState({ setupPaymentMethodsOpen: false });
    }
  }, {
    key: 'openSetupPaymentMethods',
    value: function openSetupPaymentMethods() {
      this.setState({ setupPaymentMethodsOpen: true });
    }
  }, {
    key: 'closeAddPayment',
    value: function closeAddPayment() {
      this.setState({ addPaymentOpen: false });
    }
  }, {
    key: 'openAddPayment',
    value: function openAddPayment() {
      this.setState({ addPaymentOpen: true });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'hasRecipient',
    value: function hasRecipient() {
      var node = this.props.node;

      return (node.recipient_first_name || node.recipient_last_name || node.recipient_company_name || node.recipient_phone || node.recipient_email || node.recipient_address) && true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var CheckIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["d" /* Icon */], { name: 'check circle', color: 'green', style: { marginLeft: '0.5em' } });

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var window = _ref.window;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Actions__["a" /* default */], {
            node: _this3.props.node,
            addPayment: _this3.openAddPayment,
            openSetupPaymentMethods: _this3.openSetupPaymentMethods,
            params: _this3.props.params,
            relay: _this3.props.relay,
            router: _this3.props.router,
            viewer: _this3.props.viewer,
            windowDimensions: window
          });
        }
      );

      var paidInFull = this.props.node ? this.props.node.total_cents <= this.props.node.total_paid_cents : null;

      var PayButtonDesktop = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["b" /* Button */], {
        content: 'Pay Invoice',
        size: 'large',
        className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionButton,
        style: paidInFull ? { display: 'none' } : {},
        onClick: this.openSignModal
      });

      var PayButtonMobile = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["b" /* Button */], {
        content: 'Pay Invoice',
        fluid: true,
        primary: true,
        size: 'big',
        style: paidInFull ? { display: 'none' } : {},
        onClick: this.openSignModal
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref2) {
          var isComputer = _ref2.isComputer,
              isLargeScreen = _ref2.isLargeScreen,
              isMobile = _ref2.isMobile,
              window = _ref2.window;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            _this3.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_sidebar___default.a,
              {
                sidebar: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App_SidebarComponent__["a" /* default */], {
                  setSidebarOpenState: _this3.onSetSidebarOpen,
                  router: _this3.props.router,
                  viewer: _this3.props.viewer
                }),
                sidebarClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.sidebar,
                open: _this3.state.sidebarOpen,
                onSetOpen: _this3.onSetSidebarOpen,
                touch: false,
                contentClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarContent,
                rootClassName: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.mobileSidebarRoot
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], {
                addPayment: _this3.openAddPayment,
                toggleSidebar: _this3.toggleSidebar,
                sidebarOpen: _this3.state.sidebarOpen,
                document: _this3.props.node,
                relay: _this3.props.relay,
                router: _this3.props.router,
                params: _this3.props.params,
                viewer: _this3.props.viewer,
                windowDimensions: window
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["s" /* Container */],
                {
                  className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.container, _this3.props.params.action !== 'edit' ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.documentOffset : ''].join(' ')
                },
                !isLargeScreen && isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                    {
                      columns: 'equal',
                      className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuTablet
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      ActionsMenu
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["t" /* Segment */],
                  { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.segment },
                  isLargeScreen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["u" /* Rail */],
                    {
                      position: 'right',
                      close: true,
                      className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionsMenuDesktop
                    },
                    ActionsMenu
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      {
                        columns: 'equal',
                        style: { paddingTop: 0, paddingBottom: '2em' }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.invoiceNumber },
                        'Invoice #',
                        _this3.props.node.number
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                    { padded: true, relaxed: true, stackable: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      {
                        columns: 'equal',
                        verticalAlign: 'bottom',
                        style: { paddingBottom: 0 }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { only: 'tablet computer', textAlign: 'right' },
                        (_this3.hasRecipient() || _this3.canEdit()) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'h3',
                          { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.to },
                          'Billed To:'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Brand__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { only: 'mobile', style: { paddingBottom: 0 } },
                        (_this3.hasRecipient() || _this3.canEdit()) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'h3',
                          { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.to },
                          'Billed To:'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { textAlign: isMobile ? 'left' : 'right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Recipient__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: _this3.props.viewer,
                          node: _this3.props.node,
                          relay: _this3.props.relay
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.invoice_event_segments.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Schedule'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Schedule__["a" /* default */], {
                          invoiceEventSegments: _this3.props.node.invoice_event_segments.edges,
                          viewer: _this3.props.viewer,
                          relay: _this3.props.relay,
                          readOnly: !_this3.canEdit(),
                          node: _this3.props.node
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.invoice_line_items.edges.length > 0) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section, key: 'header' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Line Items'
                        )
                      )
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      {
                        columns: 'equal',
                        className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section,
                        key: 'content'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__LineItems__["a" /* default */], {
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          canEdit: _this3.canEdit(),
                          totalPaid: _this3.props.node.total_paid_cents
                        })
                      )
                    )],
                    _this3.canEdit() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Library__["a" /* default */], {
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          viewer: _this3.props.viewer
                        })
                      )
                    ),
                    (_this3.canEdit() || _this3.props.node.i_pplan_items.edges.length > 0) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section, key: 'header' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Payment Plan'
                        )
                      )
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal', key: 'content' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PaymentPlan__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          viewer: _this3.props.viewer
                        })
                      )
                    )],
                    (_this3.canEdit() || _this3.props.node.payments.edges.length > 0) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section, key: 'header' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Payments'
                        )
                      )
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal', key: 'content' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Payments__["a" /* default */], {
                          addPayment: _this3.openAddPayment,
                          canEdit: _this3.canEdit(),
                          node: _this3.props.node,
                          timeZone: _this3.props.viewer && _this3.props.viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_23_moment_timezone___default.a.tz.guess()
                        })
                      )
                    )],
                    (_this3.canEdit() || _this3.props.node.payments.edges.reduce(function (numRefunds, payment) {
                      return numRefunds + payment.node.refunds.edges.length;
                    }, 0) > 0) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.section, key: 'header' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        { width: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.heading },
                          'Refunds'
                        )
                      )
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal', key: 'content' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Refunds__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          timeZone: _this3.props.viewer && _this3.props.viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_23_moment_timezone___default.a.tz.guess()
                        })
                      )
                    )]
                  )
                )
              ),
              _this3.props.params.action === 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Pay__["a" /* default */], {
                relay: _this3.props.relay,
                node: _this3.props.node,
                viewer: _this3.props.viewer,
                onOpen: _this3.openAddPayment,
                onClose: _this3.closeAddPayment,
                open: _this3.state.addPaymentOpen,
                window: window
              }),
              _this3.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptDesktop, paidInFull ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptCompleted : ''].join(' ')
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["s" /* Container */],
                    null,
                    !paidInFull && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'This invoice is ready to pay.'
                    ),
                    paidInFull && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      'You have paid this invoice in full ',
                      CheckIcon
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Pay__["a" /* default */], {
                      relay: _this3.props.relay,
                      trigger: PayButtonDesktop,
                      node: _this3.props.node,
                      viewer: _this3.props.viewer,
                      onOpen: _this3.openAddPayment,
                      onClose: _this3.closeAddPayment,
                      open: _this3.state.addPaymentOpen,
                      window: window
                    })
                  )
                ),
                isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: [__WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptMobile, paidInFull ? __WEBPACK_IMPORTED_MODULE_4__Document_scss___default.a.actionPromptCompleted : ''].join(' ')
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Pay__["a" /* default */], {
                    relay: _this3.props.relay,
                    trigger: PayButtonMobile,
                    node: _this3.props.node,
                    viewer: _this3.props.viewer,
                    onOpen: _this3.openAddPayment,
                    onClose: _this3.closeAddPayment,
                    open: _this3.state.addPaymentOpen,
                    window: window
                  }),
                  paidInFull && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { padding: '1em' } },
                    'You have paid this invoice in full ',
                    CheckIcon
                  )
                )
              )
            ),
            !_this3.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              _this3.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App_404__["a" /* default */], { viewer: _this3.props.viewer }),
              !_this3.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements__["a" /* Loader */], null)
            )
          );
        }
      );
    }
  }]);

  return Invoice;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_found__["withRouter"])(Invoice));

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InvoiceComponent__ = __webpack_require__(3016);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__InvoiceComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3039);
  },
  viewer: function viewer() {
    return __webpack_require__(3040);
  }
}, function () {
  return __webpack_require__(3038);
}));

/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__ = __webpack_require__(529);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InvoiceLibrary = function (_React$Component) {
  _inherits(InvoiceLibrary, _React$Component);

  function InvoiceLibrary(props) {
    _classCallCheck(this, InvoiceLibrary);

    var _this = _possibleConstructorReturn(this, (InvoiceLibrary.__proto__ || Object.getPrototypeOf(InvoiceLibrary)).call(this, props));

    _this.copyLibraryLineItemsToInvoice = _this.copyLibraryLineItemsToInvoice.bind(_this);
    _this.createLineItem = _this.createLineItem.bind(_this);
    _this.resetNewLibraryLineItem = _this.resetNewLibraryLineItem.bind(_this);
    _this.newLibraryLineItemChangeHandler = _this.newLibraryLineItemChangeHandler.bind(_this);
    return _this;
  }

  _createClass(InvoiceLibrary, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Initialize new library line item
      this.resetNewLibraryLineItem();
    }
  }, {
    key: 'copyLibraryLineItemsToInvoice',
    value: function copyLibraryLineItemsToInvoice(itemsToCopy) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('added-line-items-from-library', {
          item_count: itemsToCopy.length
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3041);
      });

      var parentID = this.props.node.id;

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            invoice_id: parentID,
            user_line_item_ids: itemsToCopy
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createLineItem',
    value: function createLineItem(idx, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this2.resetNewLibraryLineItem();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3042);
      });

      var newLineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newLibraryLineItem), 'title', 'description', 'price_cents', 'price_currency', 'quantity');

      newLineItem.quantity = parseInt(newLineItem.quantity, 10);

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        // Update viewer if adding to library
        if (_this2.state.newLibraryLineItem.addToLibrary) {
          var payload = store.getRootField('createInvoiceLineItem');
          var viewerProxy = store.get(_this2.props.viewer.id);
          var newUserLineItemEdge = payload.getLinkedRecord('new_user_line_item_edge');
          var userLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'LibraryContainer_user_line_items');
          __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(userLineItemConn, newUserLineItemEdge);
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            invoice_id: parentID
          }, newLineItem, {
            add_to_library: this.state.newLibraryLineItem.addToLibrary
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetNewLibraryLineItem',
    value: function resetNewLibraryLineItem() {
      this.setState({
        newLibraryLineItem: {
          title: '',
          description: '',
          quantity: 1,
          price_cents: 0,
          price_currency: 'USD',
          addToLibrary: false
        }
      });
    }
  }, {
    key: 'newLibraryLineItemChangeHandler',
    value: function newLibraryLineItemChangeHandler(lineItem) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newLibraryLineItem = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'render',
    value: function render() {
      var invoiceLineItems = this.props.node.invoice_line_items.edges;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__["a" /* default */], {
        initiallyExpanded: invoiceLineItems.length === 0,
        newLibraryLineItem: this.state.newLibraryLineItem,
        newLibraryLineItemChangeHandler: this.newLibraryLineItemChangeHandler,
        resetNewLibraryLineItem: this.resetNewLibraryLineItem,
        createLineItem: this.createLineItem,
        copyLibraryLineItemsToDocument: this.copyLibraryLineItemsToInvoice,
        viewer: this.props.viewer,
        relay: this.props.relay
      });
    }
  }]);

  return InvoiceLibrary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoiceLibrary.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceLibrary);

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_array__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InvoiceLineItems = function (_React$Component) {
  _inherits(InvoiceLineItems, _React$Component);

  function InvoiceLineItems(props) {
    _classCallCheck(this, InvoiceLineItems);

    var _this = _possibleConstructorReturn(this, (InvoiceLineItems.__proto__ || Object.getPrototypeOf(InvoiceLineItems)).call(this, props));

    _this.state = {
      localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.invoice_line_items.edges)
    };
    _this.deleteLineItem = _this.deleteLineItem.bind(_this);
    _this.resetEditLineItem = _this.resetEditLineItem.bind(_this);
    _this.lineItemChangeHandler = _this.lineItemChangeHandler.bind(_this);
    _this.updateLineItem = _this.updateLineItem.bind(_this);
    _this.moveLineItem = _this.moveLineItem.bind(_this);
    return _this;
  }

  _createClass(InvoiceLineItems, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localLineItems if any edges are added/deleted/updated
      this.setState({
        localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.invoice_line_items.edges)
      });
    }
  }, {
    key: 'lineItemChangeHandler',
    value: function lineItemChangeHandler(lineItem, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx].node = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'resetEditLineItem',
    value: function resetEditLineItem(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.invoice_line_items.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'moveLineItem',
    value: function moveLineItem(source, destination) {
      var _this2 = this;

      var localLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_array__["a" /* arrayMove */])(this.state.localLineItems, source, destination);
      localLineItems[destination].node.position = destination + 1;
      this.setState({
        localLineItems: localLineItems
      }, function () {
        return _this2.updateLineItem(destination);
      });
    }
  }, {
    key: 'updateLineItem',
    value: function updateLineItem(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-line-item');
      };
      var lineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localLineItems[idx].node), ['id', 'description', 'position', 'price_cents', 'price_currency', 'quantity', 'title']);

      lineItem.quantity = parseInt(lineItem.quantity, 10);

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3044);
      });

      var invoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node);
      invoice.invoice_line_items.edges = this.state.localLineItems;
      var optimisticResponse = {
        updateInvoiceLineItem: { invoice: invoice }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, lineItem)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteLineItem',
    value: function deleteLineItem(idx, successCb, failureCb) {
      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3043);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['invoice', 'invoice_line_items'],
        deletedIDFieldName: 'deletedInvoiceLineItemId',
        connectionKeys: [{
          key: 'InvoiceContainer_invoice_line_items',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.invoice_line_items.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__["a" /* default */], {
        lineItems: this.props.node.invoice_line_items.edges,
        localLineItems: this.state.localLineItems,
        updateLineItem: this.updateLineItem,
        deleteLineItem: this.deleteLineItem,
        moveLineItem: this.moveLineItem,
        resetEditLineItem: this.resetEditLineItem,
        lineItemChangeHandler: this.lineItemChangeHandler,
        readOnly: !this.props.canEdit,
        totalPaid: this.props.totalPaid
      });
    }
  }]);

  return InvoiceLineItems;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoiceLineItems.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  totalPaid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceLineItems);

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var InvoiceLogo = function (_React$Component) {
  _inherits(InvoiceLogo, _React$Component);

  function InvoiceLogo(props) {
    _classCallCheck(this, InvoiceLogo);

    var _this = _possibleConstructorReturn(this, (InvoiceLogo.__proto__ || Object.getPrototypeOf(InvoiceLogo)).call(this, props));

    _this.updateInvoiceLogo = _this.updateInvoiceLogo.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(InvoiceLogo, [{
    key: 'updateInvoiceLogo',
    value: function updateInvoiceLogo(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3047);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            invoice_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.updateInvoiceLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3045);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this3 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this4.updateInvoiceLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3046);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand_logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return InvoiceLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceLogo);

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Invoice_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Invoice_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Invoice_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils_payments__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_load_script__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_load_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_load_script__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App_PaymentMethods_NoPaymentMethods__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_immer__ = __webpack_require__(643);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-underscore-dangle */




















var PayInvoiceFlow = function (_React$Component) {
  _inherits(PayInvoiceFlow, _React$Component);

  function PayInvoiceFlow(props) {
    _classCallCheck(this, PayInvoiceFlow);

    var _this = _possibleConstructorReturn(this, (PayInvoiceFlow.__proto__ || Object.getPrototypeOf(PayInvoiceFlow)).call(this, props));

    _this.state = Object.assign({
      squareError: false,
      squareScriptLoading: true,
      squareFormLoading: true
    }, _this.initializePayModal());
    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onSquareValidSubmit = _this.onSquareValidSubmit.bind(_this);
    _this.onSquareInvalidSubmit = _this.onSquareInvalidSubmit.bind(_this);
    _this.onSquareScriptLoaded = _this.onSquareScriptLoaded.bind(_this);
    _this.onSquareError = _this.onSquareError.bind(_this);
    _this.onManualPaymentValidSubmit = _this.onManualPaymentValidSubmit.bind(_this);
    _this.onManualPaymentInvalidSubmit = _this.onManualPaymentInvalidSubmit.bind(_this);
    _this.getInvoiceTotal = _this.getInvoiceTotal.bind(_this);
    _this.getTotalPaid = _this.getTotalPaid.bind(_this);
    _this.getMinimumBalance = _this.getMinimumBalance.bind(_this);
    _this.getPaymentAmount = _this.getPaymentAmount.bind(_this);
    _this.initializeCard = _this.initializeCard.bind(_this);
    _this.tokenizeSquare = _this.tokenizeSquare.bind(_this);
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.handlePaymentMethodChange = _this.handlePaymentMethodChange.bind(_this);
    _this.onPaymentAmountChange = _this.onPaymentAmountChange.bind(_this);
    _this.customAmountFieldChange = _this.customAmountFieldChange.bind(_this);
    _this.chargeSquare = _this.chargeSquare.bind(_this);
    _this.paymentMethodsExist = _this.paymentMethodsExist.bind(_this);
    return _this;
  }

  _createClass(PayInvoiceFlow, [{
    key: 'onOpen',
    value: function onOpen() {
      this.props.onOpen();
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.props.onClose();
      this.setState(Object.assign(this.state, this.initializePayModal()));
    }
  }, {
    key: 'onSquareValidSubmit',
    value: function onSquareValidSubmit() {
      var _this2 = this;

      this.tokenizeSquare(this.state.card).then(function (token) {
        _this2.setState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_immer__["a" /* produce */])(function (draft) {
          /* eslint-disable no-param-reassign */
          draft.payment.nonce = token;
        }), function () {
          return _this2.chargeSquare(function () {
            return _this2.setState({ step: 'success' });
          });
        });
      }).catch(function () {
        _this2.setState({ submitting: false });
      });
      this.setState({ submitted: true, submitting: true });
    }
  }, {
    key: 'onSquareInvalidSubmit',
    value: function onSquareInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to pay invoice',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
      this.setState({ submitted: true });
    }
  }, {
    key: 'onSquareScriptLoaded',
    value: function onSquareScriptLoaded() {
      var _this3 = this;

      this.setState({ squareScriptLoading: false });
      var squarePaymentMethod = this.props.node.accepted_payment_methods.edges.filter(function (method) {
        return method.node.__typename === 'SquarePaymentMethod';
      })[0].node;
      if (!window.Square) {
        throw new Error('Square.js failed to load properly');
      }
      var payments = window.Square.payments(squarePaymentMethod.application_id, squarePaymentMethod.location_id);
      try {
        this.initializeCard(payments).then(function (card) {
          _this3.setState({ card: card });
        });
      } catch (e) {
        return;
      }
    }
  }, {
    key: 'onSquareError',
    value: function onSquareError() {
      this.setState({ squareError: true });
    }
  }, {
    key: 'onManualPaymentValidSubmit',
    value: function onManualPaymentValidSubmit() {
      var _this4 = this;

      this.createManualPayment(function () {
        return _this4.setState({ step: 'success' });
      });
      this.setState({ submitted: true, submitting: true });
    }
  }, {
    key: 'onManualPaymentInvalidSubmit',
    value: function onManualPaymentInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to pay invoice',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
      this.setState({ submitted: true });
    }
  }, {
    key: 'onPaymentAmountChange',
    value: function onPaymentAmountChange(e, _ref) {
      var name = _ref.name;

      if (name !== this.state.paymentAmount) {
        this.setState({ paymentAmount: name });
      }
    }
  }, {
    key: 'getInvoiceTotal',
    value: function getInvoiceTotal() {
      return this.props.node.total_cents || 0;
    }
  }, {
    key: 'getTotalPaid',
    value: function getTotalPaid() {
      return this.props.node.total_paid_cents || 0;
    }
  }, {
    key: 'getMinimumBalance',
    value: function getMinimumBalance() {
      var paymentsDue = 0;
      var lastItemDue = 0;
      // All i_pplan_items with due_at in the past are now due
      this.props.node.i_pplan_items.edges.slice().map(function (pplanItem, index) {
        if (new Date(pplanItem.node.due_at) < new Date()) {
          paymentsDue += pplanItem.node.amount_cents || 0;
          lastItemDue = index;
        }
        return pplanItem;
      });
      // If down payment exists, it is always due regardless of down_payment_due_at
      if (this.props.node.down_payment_cents) {
        paymentsDue += this.props.node.down_payment_cents || 0;
      } else if (this.props.node.i_pplan_items.edges.length > lastItemDue + 1) {
        // If down payment does not exist, the next payment that is due
        // is the first one that wasn't already due in the past
        // (assuming another i_pplan_item exists)
        paymentsDue += this.props.node.i_pplan_items.edges[lastItemDue + 1].node.amount_cents;
      }
      // Total payments made towards this invoice
      var paymentsMade = this.getTotalPaid();
      // Minimum balance due today
      var minimumBalance = paymentsDue - paymentsMade;
      // Return remaining balance. If more payments have been made than are due,
      // return zero as the minimum balance
      return minimumBalance < 0 ? 0 : minimumBalance;
    }
  }, {
    key: 'getPaymentAmount',
    value: function getPaymentAmount() {
      var _this5 = this;

      return function () {
        switch (_this5.state.paymentAmount) {
          case 'minimum':
            return _this5.getMinimumBalance();
          case 'total':
            return _this5.getInvoiceTotal() - _this5.getTotalPaid();
          default:
            return _this5.state.payment.amount_cents;
        }
      }();
    }
  }, {
    key: 'initializeCard',
    value: function initializeCard(payments) {
      var promise = new Promise(function (resolve) {
        payments.card().then(function (card) {
          card.attach('#card-container').then(function () {
            return resolve(card);
          });
        });
      });
      return promise;
    }
  }, {
    key: 'tokenizeSquare',
    value: function tokenizeSquare(paymentMethod) {
      return new Promise(function (resolve, reject) {
        paymentMethod.tokenize().then(function (tokenResult) {
          if (tokenResult.status === 'OK') {
            resolve(tokenResult.token);
          } else {
            var errorMessage = 'Tokenization failed-status: ' + tokenResult.status;
            if (tokenResult.errors) {
              errorMessage += ' and errors: ' + JSON.stringify(tokenResult.errors);
            }
            reject(errorMessage);
          }
        });
      });
    }
  }, {
    key: 'initializePayModal',
    value: function initializePayModal() {
      return {
        errors: {},
        paymentAmount: null,
        payment: {
          // TODO: replace with payment method for next payment
          payment_method: {},
          amount_cents: null,
          amount_currency: 'USD',
          notes: null
        },
        step: 'selectAmount',
        submitting: false,
        submitted: false
      };
    }
  }, {
    key: 'createManualPayment',
    value: function createManualPayment(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add payment',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added payment',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-manual-payment');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3049);
      });

      var payment = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.payment), ['name', 'notes', 'amount_cents', 'amount_currency', 'paid_at']);

      payment.paid_at = __WEBPACK_IMPORTED_MODULE_17_moment___default()(payment.paid_at).toDate().toISOString();

      payment.amount_cents = this.getPaymentAmount();

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            invoice_id: this.props.node.id,
            payment_method_id: this.state.payment.payment_method.id
          }, payment)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'chargeSquare',
    value: function chargeSquare(successCb, failureCb) {
      var _this6 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        _this6.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to process payment',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this6.setState({ submitting: false });
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3048);
      });

      var squarePayment = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.payment), ['name', 'nonce', 'amount_currency']);

      var squarePaymentMethod = this.props.node.accepted_payment_methods.edges.filter(function (method) {
        return method.node.__typename === 'SquarePaymentMethod';
      })[0];

      squarePayment.amount_cents = this.getPaymentAmount();

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            invoice_id: this.props.node.id,
            square_payment_method_id: squarePaymentMethod.node.id
          }, squarePayment)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'customAmountFieldChange',
    value: function customAmountFieldChange(e) {
      this.fieldChange('amount_cents', e.target.value * 100);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      this.setState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_immer__["a" /* produce */])(function (draft) {
        // eslint-disable-next-line
        draft.payment[key] = value;
      }));
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'handlePaymentMethodChange',
    value: function handlePaymentMethodChange(e, method) {
      this.fieldChange('payment_method', method);
    }
  }, {
    key: 'paymentMethodsExist',
    value: function paymentMethodsExist() {
      return this.props.node.accepted_payment_methods.edges.length > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var window = this.props.window;

      var squarePaymentMethod = this.props.node.accepted_payment_methods.edges.filter(function (method) {
        return method.node.__typename === 'SquarePaymentMethod';
      })[0];

      var DateInput = window.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint ? __WEBPACK_IMPORTED_MODULE_6__Elements__["s" /* FloatingLabelDateTime */] : __WEBPACK_IMPORTED_MODULE_6__Elements__["t" /* FloatingLabelDateTimePicker */];

      var paymentOptions = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.paymentMethodsExist() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'Select a Payment Method'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          this.props.node.accepted_payment_methods.edges.map(function (method, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Elements__["g" /* SelectableBlock */],
              {
                onChange: function onChange(e) {
                  return _this7.handlePaymentMethodChange(e, method.node);
                },
                key: idx,
                radio: true,
                checked: _this7.state.payment.payment_method.id === method.node.id,
                style: { marginBottom: '2em' }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h4',
                { style: { marginBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_13__lib_utils_payments__["a" /* default */].methods(method.node)
              )
            );
          })
        ),
        !this.props.node.can_edit && !this.paymentMethodsExist() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'No payment methods enabled'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please contact us for additional payment options and instructions'
          )
        ),
        this.props.node.can_edit && !this.paymentMethodsExist() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__App_PaymentMethods_NoPaymentMethods__["a" /* default */], {
          viewer: this.props.viewer,
          relay: this.props.relay,
          node: this.props.node,
          onClose: function onClose() {
            return _this7.paymentMethodsExist() ? function () {} : _this7.onClose();
          },
          onOpen: this.onOpen,
          open: this.props.open
        })
      );

      var ManualPaymentForm = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_formsy_react___default.a.Form,
        {
          ref: 'manualPaymentForm',
          onValidSubmit: this.onManualPaymentValidSubmit,
          onInvalidSubmit: this.onManualPaymentInvalidSubmit,
          style: { marginTop: '2em' }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["v" /* Divider */],
          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_8__Document_scss___default.a.heading },
          'Admin Only'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            style: window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint ? {
              display: 'flex'
            } : {}
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              style: window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint ? {
                flex: 1,
                marginRight: '1em'
              } : {}
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              name: 'name',
              label: 'Paid By',
              placeholder: 'Jane Smith',
              value: this.state.payment.name || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted,
              required: true,
              validationError: 'Name is required',
              fluid: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DateInput, {
              dateOnly: true,
              value: this.state.payment.paid_at || '',
              onChange: this.textFieldChange,
              name: 'paid_at',
              fluid: true,
              autocomplete: 'off',
              dateLabel: 'Paid On',
              style: {
                marginTop: '1.25em'
              },
              required: true,
              validationError: 'Date is required',
              inline: true,
              viewer: null,
              submitted: this.state.submitted
            })
          )
        ),
        this.state.paymentAmount === 'other' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */],
          {
            name: 'amount_cents',
            label: 'Amount',
            type: 'currency',
            placeholder: '$500.00',
            value: this.state.payment.amount_cents ? this.state.payment.amount_cents / 100 : '',
            onChange: this.customAmountFieldChange,
            submitted: this.state.submitted,
            required: true,
            validationError: 'Amount is required'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_number_format___default.a, {
            thousandSeparator: true,
            prefix: '$',
            decimalScale: 2,
            fixedDecimalScale: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
          name: 'notes',
          label: 'Notes',
          value: this.state.payment.notes || '',
          onChange: this.textFieldChange,
          submitted: this.state.submitted,
          autoHeight: true,
          fluid: true
        })
      );

      var PayFields = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.state.payment.payment_method.__typename === 'CheckPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'Instructions'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please write a check to',
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              this.state.payment.payment_method.pay_to
            ),
            ' and mail to:'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            { style: { whiteSpace: 'pre-line' } },
            this.state.payment.payment_method.address
          ),
          this.props.viewer && ManualPaymentForm
        ),
        this.state.payment.payment_method.__typename === 'CashPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'Instructions'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: this.state.payment.payment_method.instructions
            }
          }),
          this.props.viewer && ManualPaymentForm
        ),
        this.state.payment.payment_method.__typename === 'CustomPaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'Instructions'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { whiteSpace: 'pre-line' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
              dangerouslySetInnerHTML: {
                __html: this.state.payment.payment_method.instructions
              }
            })
          ),
          this.props.viewer && ManualPaymentForm
        ),
        this.state.payment.payment_method.__typename === 'SquarePaymentMethod' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_formsy_react___default.a.Form,
            {
              ref: 'squareForm',
              onValidSubmit: this.onSquareValidSubmit,
              onInvalidSubmit: this.onSquareInvalidSubmit
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h3',
              null,
              'Enter credit card information'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              { htmlFor: 'name' },
              'Name'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              name: 'name',
              id: 'name',
              placeholder: 'Jane Smith',
              required: true,
              validationError: 'Name is required',
              value: this.state.payment.name || '',
              onChange: this.textFieldChange,
              submitted: this.state.submitted
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'form',
            { id: 'payment-form' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: 'card-container' })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: 'payment-status-container' })
        )
      );

      var SquareScript = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_load_script___default.a, {
        url: 'https://web.squarecdn.com/v1/square.js',
        onCreate: function onCreate() {},
        onError: function onError() {
          return _this7.onSquareError;
        },
        onLoad: this.onSquareScriptLoaded
      });

      var BalanceOption = function BalanceOption(_ref2) {
        var amount = _ref2.amount,
            description = _ref2.description,
            label = _ref2.label;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              { width: 10 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                label
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              { width: 6, textAlign: 'right' },
              amount
            )
          ),
          description && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
            { style: { paddingTop: '0em' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              { width: 12 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: __WEBPACK_IMPORTED_MODULE_9__Invoice_scss___default.a.paymentAmountDescription },
                description
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column, { width: 4 })
          )
        );
      };

      var SelectAmount = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'Select a Payment Amount'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        this.getMinimumBalance() !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Elements__["g" /* SelectableBlock */],
          {
            onChange: this.onPaymentAmountChange,
            name: 'minimum',
            value: 'minimum',
            radio: true,
            checked: this.state.paymentAmount === 'minimum',
            style: { marginBottom: '2em' }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BalanceOption, {
            label: 'Minimum Payment Due',
            amount: __WEBPACK_IMPORTED_MODULE_12_currency_formatter___default.a.format(this.getMinimumBalance() / 100, {
              code: 'USD'
            }),
            description: 'Pay the minimum balance due based on your payment plan and any past payments.'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Elements__["g" /* SelectableBlock */],
          {
            onChange: this.onPaymentAmountChange,
            name: 'total',
            value: 'total',
            radio: true,
            checked: this.state.paymentAmount === 'total',
            style: { marginBottom: '2em' }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BalanceOption, {
            label: 'Total Balance',
            amount: __WEBPACK_IMPORTED_MODULE_12_currency_formatter___default.a.format((this.getInvoiceTotal() - this.getTotalPaid()) / 100, {
              code: 'USD'
            }),
            description: 'Pay the full balance on this invoice adjusted for any existing payments, refunds, and credits.'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Elements__["g" /* SelectableBlock */],
          {
            onChange: this.onPaymentAmountChange,
            name: 'other',
            value: 'other',
            fitted: false,
            radio: true,
            checked: this.state.paymentAmount === 'other'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BalanceOption, { label: 'Other' })
        ),
        this.state.paymentAmount === 'other' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_formsy_react___default.a.Form,
          {
            style: {
              marginTop: '2em'
            },
            key: 'otherAmountForm'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            { htmlFor: 'amount_cents' },
            'Amount'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */],
            {
              name: 'amount_cents',
              id: 'amount_cents',
              type: 'currency',
              placeholder: '$500.00',
              value: this.state.payment.amount_cents ? this.state.payment.amount_cents / 100 : '',
              onChange: this.customAmountFieldChange,
              submitted: this.state.submitted,
              required: true,
              validationError: 'Amount is required'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_number_format___default.a, {
              thousandSeparator: true,
              prefix: '$',
              decimalScale: 2,
              fixedDecimalScale: true
            })
          )
        )
      );

      var payButtonText = function () {
        var formattedAmount = __WEBPACK_IMPORTED_MODULE_12_currency_formatter___default.a.format(_this7.getPaymentAmount() / 100, {
          code: _this7.state.payment.amount_currency
        });

        if (_this7.state.submitting) {
          return 'Processing Payment';
        }
        if (_this7.state.payment.payment_method.__typename === 'SquarePaymentMethod') {
          return 'Charge Credit Card ' + formattedAmount;
        }
        return _this7.props.viewer ? 'Record Payment of ' + formattedAmount : 'Done';
      }();

      var PayButtonContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        this.state.submitting && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["j" /* Loader */], {
          active: this.state.submitting,
          inline: true,
          inverted: true,
          size: 'mini',
          style: { marginRight: '1em' }
        }),
        payButtonText
      );

      var PayButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
        {
          primary: true,
          disabled: this.state.submitting || this.state.payment.payment_method.__typename === 'SquarePaymentMethod' && !this.state.card,
          onClick: function onClick() {
            if (_this7.state.payment.payment_method.__typename === 'SquarePaymentMethod') {
              _this7.refs.squareForm.submit();
            } else if (_this7.props.viewer) {
              _this7.refs.manualPaymentForm.submit();
            } else {
              _this7.onClose();
            }
          }
        },
        PayButtonContent
      );

      var SuccessMessage = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { textAlign: 'center' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["j" /* Success */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          { style: { marginBottom: '2em' } },
          'You have ',
          this.props.viewer ? 'added' : 'made',
          ' a payment'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], { basic: true, fluid: true, content: 'Done', onClick: this.onClose })
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */],
          {
            trigger: this.props.trigger,
            onClose: this.onClose,
            onOpen: this.onOpen,
            open: this.props.open,
            size: 'small'
          },
          this.state.step === 'selectAmount' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Header, { content: 'Pay Invoice', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '600px', margin: '0 auto' } },
              SelectAmount
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
            { key: 'actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: this.onClose,
                className: __WEBPACK_IMPORTED_MODULE_8__Document_scss___default.a.modalSecondaryAction
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                type: 'submit',
                disabled: !this.state.paymentAmount || this.state.paymentAmount === 'other' && !(this.state.payment.amount_cents > 0),
                onClick: function onClick() {
                  return _this7.setState({ step: 'selectPaymentMethod' });
                }
              },
              'Next'
            )
          )],
          this.state.step === 'selectPaymentMethod' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Header, { content: 'Pay Invoice', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '600px', margin: '0 auto' } },
              paymentOptions
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
            { key: 'actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return _this7.setState({ step: 'selectAmount' });
                },
                className: __WEBPACK_IMPORTED_MODULE_8__Document_scss___default.a.modalSecondaryAction
              },
              'Back'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                onClick: function onClick() {
                  return _this7.setState({ step: 'pay' });
                },
                disabled: !this.state.payment.payment_method.id
              },
              'Next'
            )
          )],
          this.state.step === 'pay' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Header, { content: 'Pay Invoice', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '400px', margin: '0 auto' } },
              PayFields,
              squarePaymentMethod && SquareScript
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
            { key: 'actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return _this7.setState({ step: 'selectPaymentMethod' });
                },
                className: __WEBPACK_IMPORTED_MODULE_8__Document_scss___default.a.modalSecondaryAction
              },
              'Back'
            ),
            PayButton
          )],
          this.state.step === 'success' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Header, { content: 'Pay Invoice', key: 'header' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
            { key: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { maxWidth: '280px', margin: '0 auto' } },
              SuccessMessage
            )
          )]
        ),
        window.width < __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
          {
            trigger: this.props.trigger,
            open: this.props.open,
            onClose: this.onClose,
            onOpen: this.onOpen
          },
          this.state.step === 'selectAmount' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
            { key: 'header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.onClose },
                'Cancel'
              )
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
            { key: 'content' },
            SelectAmount,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                style: { marginTop: '2em' },
                disabled: !this.state.paymentAmount || this.state.paymentAmount === 'other' && !(this.state.payment.amount_cents > 0),
                onClick: function onClick() {
                  return _this7.setState({ step: 'selectPaymentMethod' });
                }
              },
              'Next'
            )
          )],
          this.state.step === 'selectPaymentMethod' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
            { key: 'header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  onClick: function onClick() {
                    return _this7.setState({ step: 'selectAmount' });
                  }
                },
                'Back'
              )
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
            { key: 'content' },
            paymentOptions,
            this.paymentMethodsExist() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
              {
                primary: true,
                onClick: function onClick() {
                  return _this7.setState({ step: 'pay' });
                },
                disabled: !this.state.payment.payment_method.id
              },
              'Next'
            )
          )],
          this.state.step === 'pay' && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
            { key: 'header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  onClick: function onClick() {
                    return _this7.setState({ step: 'selectPaymentMethod' });
                  }
                },
                'Back'
              )
            )
          ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
            { key: 'content' },
            PayFields,
            squarePaymentMethod && SquareScript,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            PayButton
          )],
          this.state.step === 'success' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
              null,
              SuccessMessage
            )
          )
        )
      );
    }
  }]);

  return PayInvoiceFlow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PayInvoiceFlow.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  window: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PayInvoiceFlow);

/***/ }),
/* 3022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_PaymentPlan_PaymentPlan__ = __webpack_require__(3120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InvoicePaymentPlan = function (_React$Component) {
  _inherits(InvoicePaymentPlan, _React$Component);

  function InvoicePaymentPlan(props) {
    _classCallCheck(this, InvoicePaymentPlan);

    var _this = _possibleConstructorReturn(this, (InvoicePaymentPlan.__proto__ || Object.getPrototypeOf(InvoicePaymentPlan)).call(this, props));

    _this.state = {
      invoice: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node)
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.updatePaymentPlan = _this.updatePaymentPlan.bind(_this);
    return _this;
  }

  _createClass(InvoicePaymentPlan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update local invoice values in case they changed
      this.setState({ invoice: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node) });
    }
  }, {
    key: 'onChange',
    value: function onChange(invoice) {
      this.setState(function (state) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
        obj.invoice = invoice;
        return obj;
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({ invoice: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node) });
    }
  }, {
    key: 'updatePaymentPlan',
    value: function updatePaymentPlan(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment plan',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated payment plan',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.reset();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-invoice-payment-plan');
      };

      var invoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.invoice), ['down_payment_cents', 'down_payment_currency', 'down_payment_distribution_type', 'down_payment_due_at', 'down_payment_percent', 'pplan_distribution_type', 'delete_pplan_items_with_ids']);

      invoice.down_payment_percent = invoice.down_payment_percent === 0 ? null : invoice.down_payment_percent;
      invoice.down_payment_cents = invoice.down_payment_cents || 0;

      invoice.pplan_items = this.state.invoice.i_pplan_items.edges.slice();
      invoice.pplan_items = invoice.pplan_items.filter(function (item) {
        return !item.node.locked;
      });
      invoice.pplan_items = invoice.pplan_items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(item.node), item.node.id ? 'id' : null, item.node.due_at ? 'due_at' : null, item.node.amount_cents ? 'amount_cents' : null, item.node.amount_currency ? 'amount_currency' : null);
      });

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3050);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            invoice_id: this.props.node.id
          }, invoice)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_PaymentPlan_PaymentPlan__["a" /* default */], {
          invoice: this.props.node,
          localInvoice: this.state.invoice,
          canEdit: this.props.canEdit,
          commitUpdate: this.updatePaymentPlan,
          onChange: this.onChange,
          reset: this.reset,
          relay: this.props.relay,
          viewer: this.props.viewer
        })
      );
    }
  }]);

  return InvoicePaymentPlan;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoicePaymentPlan.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (InvoicePaymentPlan);

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Invoice_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Invoice_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__ = __webpack_require__(262);
/* eslint-disable no-underscore-dangle */









var Payments = function Payments(_ref) {
  var addPayment = _ref.addPayment,
      canEdit = _ref.canEdit,
      node = _ref.node,
      _ref$timeZone = _ref.timeZone,
      timeZone = _ref$timeZone === undefined ? __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess() : _ref$timeZone;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
    null,
    node.payments.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
      { columns: 'equal' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        { className: __WEBPACK_IMPORTED_MODULE_5__globals_scss___default.a.desktop },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */],
          { stackable: true, basic: 'very', striped: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Date'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Amount'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Paid By'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Payment Method'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Notes'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Body,
            null,
            node.payments.edges.map(function (payment) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
                { key: payment.node.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    {
                      title: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(timeZone).format('z')
                    },
                    __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('L')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                  null,
                  __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((payment.node.amount_cents || 0) / 100, {
                    code: payment.node.amount_currency
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                  null,
                  payment.node.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                  null,
                  __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__["a" /* default */].payments(payment.node)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { whiteSpace: 'pre-line' } },
                    payment.node.notes
                  )
                )
              );
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        { className: __WEBPACK_IMPORTED_MODULE_5__globals_scss___default.a.mobile, width: 16 },
        node.payments.edges.map(function (payment) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: payment.node.id, style: { marginBottom: '4em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                { columns: 'equal' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { style: { marginBottom: '0.5rem' } },
                    __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((payment.node.amount_cents || 0) / 100, {
                      code: payment.node.amount_currency
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default.a.paymentAmountDescription },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["y" /* Label */], { size: 'small', content: __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__["a" /* default */].payments(payment.node) })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('L'),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { marginTop: '0.5rem' }, className: __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default.a.paymentAmountDescription },
                    'Paid By ',
                    payment.node.name
                  )
                )
              )
            ),
            payment.node.notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: '1em' }, className: __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default.a.paymentAmountDescription },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'Notes: ',
              payment.node.notes
            )
          );
        })
      )
    ),
    node.payments.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
      { style: { textAlign: 'center', padding: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'This invoice has no payments'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
          basic: true,
          icon: 'plus',
          labelPosition: 'left',
          onClick: addPayment,
          content: 'Add Payment'
        })
      )
    ),
    canEdit && node.payments.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { onClick: addPayment, style: { marginTop: '1em' } },
      '+ Add Payment'
    )
  );
};

Payments.propTypes = {
  addPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  timeZone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Payments);

/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Recipient_Recipient__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InvoiceRecipient = function (_React$Component) {
  _inherits(InvoiceRecipient, _React$Component);

  function InvoiceRecipient(props) {
    _classCallCheck(this, InvoiceRecipient);

    var _this = _possibleConstructorReturn(this, (InvoiceRecipient.__proto__ || Object.getPrototypeOf(InvoiceRecipient)).call(this, props));

    _this.state = {
      localRecipient: _this.getRecipientFromInvoice()
    };
    _this.getRecipientFromInvoice = _this.getRecipientFromInvoice.bind(_this);
    _this.updateRecipient = _this.updateRecipient.bind(_this);
    _this.resetRecipient = _this.resetRecipient.bind(_this);
    _this.recipientChangeHandler = _this.recipientChangeHandler.bind(_this);
    return _this;
  }

  _createClass(InvoiceRecipient, [{
    key: 'getRecipientFromInvoice',
    value: function getRecipientFromInvoice() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['recipient_first_name', 'recipient_last_name', 'recipient_company_name', 'recipient_email', 'recipient_phone', 'recipient_address']);
    }
  }, {
    key: 'updateRecipient',
    value: function updateRecipient(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update recipient information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated recipient information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-recipient');
      };

      var localRecipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localRecipient);
      var phone = localRecipient.recipient_phone;
      localRecipient.recipient_phone = phone ? phone.replace(/\D/g, '') : null;

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3051);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            id: this.props.node.id
          }, localRecipient)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetRecipient',
    value: function resetRecipient() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localRecipient = this.getRecipientFromInvoice();
      this.setState(obj);
    }
  }, {
    key: 'recipientChangeHandler',
    value: function recipientChangeHandler(recipient) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localRecipient = recipient;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Recipient_Recipient__["a" /* default */], {
        canEdit: this.props.canEdit,
        recipient: this.getRecipientFromInvoice(),
        resetRecipient: this.resetRecipient,
        localRecipient: this.state.localRecipient,
        onChange: this.recipientChangeHandler,
        updateRecipient: this.updateRecipient,
        viewer: this.props.viewer
      });
    }
  }]);

  return InvoiceRecipient;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoiceRecipient.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceRecipient);

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_currency_formatter__);






var RefundConfirmation = function RefundConfirmation(_ref) {
  var refund = _ref.refund,
      onClose = _ref.onClose,
      originalPayment = _ref.originalPayment;

  // eslint-disable-next-line no-underscore-dangle
  var isCreditCard = originalPayment.__typename === 'SquarePayment';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'center' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["j" /* Success */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Refund ',
      isCreditCard ? 'Issued' : 'Recorded'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { style: { marginBottom: '2em' } },
      'A refund of ',
      __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(refund.amount_cents / 100, {
        code: originalPayment.amount_currency
      }),
      ' has been ',
      isCreditCard ? 'issued' : 'recorded',
      '.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, fluid: true, content: 'Done', onClick: onClose })
  );
};

RefundConfirmation.propTypes = {
  refund: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  originalPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RefundConfirmation);

/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immer__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Invoice_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Invoice_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Invoice_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var EnterAmount = function (_Component) {
  _inherits(EnterAmount, _Component);

  function EnterAmount(props) {
    _classCallCheck(this, EnterAmount);

    var _this = _possibleConstructorReturn(this, (EnterAmount.__proto__ || Object.getPrototypeOf(EnterAmount)).call(this, props));

    _this.state = {
      refund: {}
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.getInvoiceTotal = _this.getInvoiceTotal.bind(_this);
    _this.getTotalRefunds = _this.getTotalRefunds.bind(_this);
    _this.getTotalPaid = _this.getTotalPaid.bind(_this);
    _this.maxRefund = _this.maxRefund.bind(_this);
    return _this;
  }

  _createClass(EnterAmount, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7_formsy_react___default.a.addValidationRule('isPositive', function (values, value) {
        return Number(value) > 0;
      });
      __WEBPACK_IMPORTED_MODULE_7_formsy_react___default.a.addValidationRule('isUnderMaxRefund', function (values, value) {
        return Number(value) <= _this2.maxRefund() / 100;
      });
    }
  }, {
    key: 'getInvoiceTotal',
    value: function getInvoiceTotal() {
      return this.props.invoice.invoice_line_items.edges.reduce(function (total, _ref) {
        var lineItem = _ref.node;
        return total + (lineItem.quantity || 1) * (lineItem.price_cents || 0) / 100;
      }, 0);
    }
  }, {
    key: 'getTotalRefunds',
    value: function getTotalRefunds() {
      return this.props.invoice.payments.edges.reduce(function (totalRefunds, _ref2) {
        var payment = _ref2.node;
        return totalRefunds + payment.refunds.edges.reduce(function (paymentRefunds, _ref3) {
          var refund = _ref3.node;
          return refund.amount_cents / 100;
        }, 0);
      }, 0);
    }
  }, {
    key: 'getTotalPaid',
    value: function getTotalPaid() {
      return this.props.invoice.payments.edges.reduce(function (total, _ref4) {
        var payment = _ref4.node;
        return total + payment.amount_cents / 100;
      }, 0);
    }
  }, {
    key: 'maxRefund',
    value: function maxRefund() {
      var refundedCents = this.props.payment.refunds.edges.reduce(function (total, paymentRefund) {
        return total + paymentRefund.node.amount_cents;
      }, 0);
      return this.props.payment.amount_cents - refundedCents;
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      this.setState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immer__["a" /* produce */])(function (draft) {
        /* eslint-disable no-param-reassign */
        draft.refund[key] = value;
      }));
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onRefundTypeSelect = _props.onRefundTypeSelect,
          payment = _props.payment,
          refundType = _props.refundType,
          submitted = _props.submitted;
      var refund = this.state.refund;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
        { padded: true, relaxed: true, stackable: true, centered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__Elements__["g" /* SelectableBlock */],
              {
                name: 'refundType',
                value: 'full',
                radio: true,
                onChange: onRefundTypeSelect,
                checked: refundType === 'full',
                style: { margin: '2em 0' }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'Full Refund'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'right' } },
                  __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(this.maxRefund() / 100, {
                    code: payment.amount_currency
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__Elements__["g" /* SelectableBlock */],
              {
                name: 'refundType',
                value: 'partial',
                radio: true,
                onChange: onRefundTypeSelect,
                checked: refundType === 'partial'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'Partial Refund'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_8__Invoice_scss___default.a.paymentAmountDescription },
                    'You can refund any amount up to',
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(this.maxRefund() / 100, {
                      code: payment.amount_currency
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'right' } },
                  refundType === 'partial' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */],
                    {
                      name: 'amount',
                      autoFocus: true,
                      className: __WEBPACK_IMPORTED_MODULE_8__Invoice_scss___default.a.rightAlignedField,
                      type: 'currency',
                      value: refund.amount || '',
                      onChange: this.textFieldChange,
                      submitted: submitted,
                      placeholder: '$100.00',
                      validations: {
                        isPositive: null,
                        isUnderMaxRefund: null
                      },
                      required: refundType === 'partial',
                      validationError: 'Required',
                      validationErrors: {
                        isPositive: 'Must be a positive number',
                        isUnderMaxRefund: 'Cannot refund more than ' + __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(this.maxRefund() / 100, {
                          code: payment.amount_currency
                        })
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_number_format___default.a, {
                      thousandSeparator: true,
                      prefix: '$',
                      decimalScale: 2,
                      fixedDecimalScale: true
                    })
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
              name: 'notes',
              label: 'Refund Notes',
              value: refund.notes || '',
              onChange: this.textFieldChange,
              submitted: submitted,
              autoHeight: true
            })
          )
        )
      );
    }
  }]);

  return EnterAmount;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EnterAmount.propTypes = {
  onRefundTypeSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  payment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  refundType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (EnterAmount);

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_payments__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invoice_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Invoice_scss__);









var SelectPayment = function SelectPayment(_ref) {
  var onPaymentSelect = _ref.onPaymentSelect,
      payments = _ref.payments,
      selectedPayment = _ref.selectedPayment,
      _ref$timeZone = _ref.timeZone,
      timeZone = _ref$timeZone === undefined ? __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.tz.guess() : _ref$timeZone;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      null,
      'Select a payment to issue a partial or full refund'
    ),
    payments.map(function (_ref2) {
      var payment = _ref2.node;

      var cannotRefundSquare =
      // eslint-disable-next-line no-underscore-dangle
      payment.__typename === 'SquarePayment' && __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()(payment.paid_at).isBefore(__WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()().subtract(1, 'years'));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: payment.id, style: { margin: '2em 0' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */],
          {
            name: 'payment',
            value: payment,
            radio: true,
            onChange: onPaymentSelect,
            checked: selectedPayment && selectedPayment.id === payment.id,
            disabled: cannotRefundSquare || __WEBPACK_IMPORTED_MODULE_5__lib_utils_payments__["a" /* default */].refundedCents(payment) === payment.amount_cents
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { style: { marginBottom: '0.5em' } },
                'Paid by ',
                payment.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default.a.paymentAmountDescription,
                  style: { marginBottom: '0.5em' },
                  title: __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.tz(payment.paid_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.tz(timeZone).format('z')
                },
                __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.tz(payment.paid_at, timeZone).format('L')
              ),
              cannotRefundSquare && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default.a.warning,
                  style: { marginBottom: '0.5em' }
                },
                '*Must refund card payments within 1 year of original transaction'
              ),
              payment.notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default.a.paymentAmountDescription },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'em',
                  null,
                  'Notes: ',
                  payment.notes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: 'right' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { style: { marginBottom: '0.5em' } },
                __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(payment.amount_cents / 100, {
                  code: payment.amount_currency
                })
              ),
              __WEBPACK_IMPORTED_MODULE_5__lib_utils_payments__["a" /* default */].refundedCents(payment) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default.a.paymentAmountDescription },
                '(',
                __WEBPACK_IMPORTED_MODULE_4_currency_formatter___default.a.format(__WEBPACK_IMPORTED_MODULE_5__lib_utils_payments__["a" /* default */].refundedCents(payment) / 100, {
                  code: payment.amount_currency
                }),
                ' ',
                'Refunded)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_7__Invoice_scss___default.a.paymentAmountDescription },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["y" /* Label */], {
                  size: 'small',
                  content: __WEBPACK_IMPORTED_MODULE_5__lib_utils_payments__["a" /* default */].payments(payment)
                })
              )
            )
          )
        )
      );
    })
  );
};

SelectPayment.propTypes = {
  onPaymentSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  payments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  selectedPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeZone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SelectPayment);

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b5e9811d7b57de773a7d3f6f6ae8ed59
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateManualRefundInput = {
  clientMutationId?: ?string,
  payment_id: string,
  notes?: ?string,
  amount_cents: number,
  amount_currency: string,
  refunded_at?: ?any,
};
export type Refund_createManualRefundMutationVariables = {|
  input: CreateManualRefundInput
|};
export type Refund_createManualRefundMutationResponse = {|
  +createManualRefund: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type Refund_createManualRefundMutation = {|
  variables: Refund_createManualRefundMutationVariables,
  response: Refund_createManualRefundMutationResponse,
|};
*/

/*
mutation Refund_createManualRefundMutation(
  $input: CreateManualRefundInput!
) {
  createManualRefund(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateManualRefundInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateManualRefundInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Refund_createManualRefundMutation",
    "id": null,
    "text": "mutation Refund_createManualRefundMutation(\n  $input: CreateManualRefundInput!\n) {\n  createManualRefund(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Refund_createManualRefundMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createManualRefund",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateManualRefundPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Refund_createManualRefundMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createManualRefund",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateManualRefundPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '364a697519504b5fc3a332036eae677d';
module.exports = node;

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1f9d45e03d39d39378740e663a33c13f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type RefundSquareInput = {
  clientMutationId?: ?string,
  payment_id: string,
  amount_cents: number,
  amount_currency: string,
  notes?: ?string,
};
export type Refund_refundSquareMutationVariables = {|
  input: RefundSquareInput
|};
export type Refund_refundSquareMutationResponse = {|
  +refundSquare: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type Refund_refundSquareMutation = {|
  variables: Refund_refundSquareMutationVariables,
  response: Refund_refundSquareMutationResponse,
|};
*/

/*
mutation Refund_refundSquareMutation(
  $input: RefundSquareInput!
) {
  refundSquare(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "RefundSquareInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "RefundSquareInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Refund_refundSquareMutation",
    "id": null,
    "text": "mutation Refund_refundSquareMutation(\n  $input: RefundSquareInput!\n) {\n  refundSquare(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Refund_refundSquareMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "refundSquare",
        "storageKey": null,
        "args": v1,
        "concreteType": "RefundSquarePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Refund_refundSquareMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "refundSquare",
        "storageKey": null,
        "args": v1,
        "concreteType": "RefundSquarePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9d635a706e1e4baf768e83cca239cfb4';
module.exports = node;

/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Invoice_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Invoice_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Refund___ = __webpack_require__(1456);
/* eslint-disable no-underscore-dangle */










var Refunds = function Refunds(_ref) {
  var canEdit = _ref.canEdit,
      node = _ref.node,
      relay = _ref.relay,
      _ref$timeZone = _ref.timeZone,
      timeZone = _ref$timeZone === undefined ? __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess() : _ref$timeZone;

  var numRefunds = node.payments.edges.reduce(function (total, payment) {
    return total + payment.node.refunds.edges.length;
  }, 0);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
    null,
    node.payments.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
      { columns: 'equal' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        { className: __WEBPACK_IMPORTED_MODULE_5__globals_scss___default.a.desktop },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */],
          { stackable: true, basic: 'very', striped: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Date'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Amount'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Payment Method'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].HeaderCell,
                null,
                'Notes'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Body,
            null,
            node.payments.edges.map(function (payment) {
              return payment.node.refunds.edges.map(function (refund) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
                  { key: refund.node.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      {
                        title: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(timeZone).format('z')
                      },
                      __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('L')
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                    null,
                    __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((refund.node.amount_cents || 0) / 100, {
                      code: refund.node.amount_currency
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                    null,
                    __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__["a" /* default */].payments(payment.node)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { whiteSpace: 'pre-line' } },
                      refund.node.notes
                    )
                  )
                );
              });
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        { className: __WEBPACK_IMPORTED_MODULE_5__globals_scss___default.a.mobile, width: 16 },
        node.payments.edges.map(function (payment) {
          return payment.node.refunds.edges.map(function (refund) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: refund.node.id, style: { marginBottom: '4em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'h3',
                      { style: { marginBottom: '0.5rem' } },
                      __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((refund.node.amount_cents || 0) / 100, {
                        code: refund.node.amount_currency
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default.a.paymentAmountDescription },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["y" /* Label */], {
                        size: 'small',
                        content: __WEBPACK_IMPORTED_MODULE_7__lib_utils_payments__["a" /* default */].payments(payment.node)
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { textAlign: 'right' },
                    __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('L')
                  )
                )
              ),
              refund.node.notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { marginTop: '1em' },
                  className: __WEBPACK_IMPORTED_MODULE_6__Invoice_scss___default.a.paymentAmountDescription
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                'Notes: ',
                refund.node.notes
              )
            );
          });
        })
      )
    ),
    numRefunds === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
      { style: { textAlign: 'center', padding: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'This invoice has no refunds'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Refund___["a" /* default */], {
          node: node,
          trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            basic: true,
            icon: 'plus',
            labelPosition: 'left',
            content: 'Add Refund'
          }),
          relay: relay
        })
      )
    ),
    canEdit && numRefunds > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Refund___["a" /* default */], {
      node: node,
      trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { style: { marginTop: '1em' } },
        '+ Add Refund'
      ),
      relay: relay
    })
  );
};

Refunds.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  timeZone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Refunds);

/***/ }),
/* 3031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Schedule_Schedule__ = __webpack_require__(813);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InvoiceSchedule = function (_React$Component) {
  _inherits(InvoiceSchedule, _React$Component);

  function InvoiceSchedule(props) {
    _classCallCheck(this, InvoiceSchedule);

    var _this = _possibleConstructorReturn(this, (InvoiceSchedule.__proto__ || Object.getPrototypeOf(InvoiceSchedule)).call(this, props));

    _this.toggleSearch = _this.toggleSearch.bind(_this);
    _this.closeSearchHandler = _this.closeSearchHandler.bind(_this);
    _this.eventSegmentChangeHandler = _this.eventSegmentChangeHandler.bind(_this);
    _this.updateEventSegment = _this.updateEventSegment.bind(_this);
    _this.resetEditEventSegment = _this.resetEditEventSegment.bind(_this);
    _this.deleteEventSegment = _this.deleteEventSegment.bind(_this);
    _this.newEventSegmentChangeHandler = _this.newEventSegmentChangeHandler.bind(_this);
    _this.closeNewEventSegmentEditor = _this.closeNewEventSegmentEditor.bind(_this);
    _this.createEventSegment = _this.createEventSegment.bind(_this);
    _this.addEventSegment = _this.addEventSegment.bind(_this);
    _this.resetAddEventSegment = _this.resetAddEventSegment.bind(_this);
    _this.state = {
      showSearch: false,
      invoiceEventSegments: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.invoiceEventSegments),
      editingNewEventSegment: false
    };
    return _this;
  }

  _createClass(InvoiceSchedule, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update invoiceEventSegments if any edges are added/deleted
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.invoiceEventSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.invoiceEventSegments);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ showSearch: !this.state.showSearch });
    }
  }, {
    key: 'closeSearchHandler',
    value: function closeSearchHandler() {
      this.setState({ showSearch: false });
    }
  }, {
    key: 'eventSegmentChangeHandler',
    value: function eventSegmentChangeHandler(eventSegment, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.invoiceEventSegments[idx].node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateEventSegment',
    value: function updateEventSegment(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-invoice-event-segment');
      };
      var eventSegment = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.invoiceEventSegments[idx].node), ['id', 'title', 'start_at', 'end_at', 'time_zone', 'location', 'line1', 'city', 'province', 'postal_code', 'room', 'notes']));

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3054);
      });

      var optimisticResponse = {
        updateInvoiceEventSegment: { invoice_event_segment: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(eventSegment) }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, eventSegment)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetEditEventSegment',
    value: function resetEditEventSegment(index) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.invoiceEventSegments[index] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.invoiceEventSegments[index]);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'deleteEventSegment',
    value: function deleteEventSegment(idx, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this2.resetEditEventSegment();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-invoice-event-segment');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3053);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['invoice', 'invoice_event_segments'],
        deletedIDFieldName: 'deletedInvoiceEventSegmentId',
        connectionKeys: [{
          key: 'InvoiceContainer_invoice_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.invoiceEventSegments[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetAddEventSegment',
    value: function resetAddEventSegment() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete obj.newEventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'createEventSegment',
    value: function createEventSegment(index, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.state);
        delete obj.newEventSegment;
        _this3.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-invoice-event-segment');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3052);
      });

      var eventSegment = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newEventSegment.node), 'all_day'));

      eventSegment.title = eventSegment.title || '(Untitled Agenda Item)';

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_invoice_event_segment_edge',
        connectionInfo: [{
          key: 'InvoiceContainer_invoice_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            invoice_id: parentID
          }, eventSegment)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'addEventSegment',
    value: function addEventSegment(e) {
      e.preventDefault();
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewEventSegment = true;
      if (!this.state.newEventSegment) {
        obj.newEventSegment = { node: {} };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newEventSegmentChangeHandler',
    value: function newEventSegmentChangeHandler(eventSegment) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newEventSegment.node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewEventSegmentEditor',
    value: function closeNewEventSegmentEditor() {
      this.setState({ editingNewEventSegment: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Schedule_Schedule__["a" /* default */], {
        addEventSegment: this.addEventSegment,
        closeNewEventSegmentEditor: this.closeNewEventSegmentEditor,
        createEventSegment: this.createEventSegment,
        deleteEventSegment: this.deleteEventSegment,
        eventSegments: this.props.invoiceEventSegments,
        eventSegmentChangeHandler: this.eventSegmentChangeHandler,
        editingNewEventSegment: this.state.editingNewEventSegment,
        localEventSegments: this.state.invoiceEventSegments,
        newEventSegment: this.state.newEventSegment,
        newEventSegmentChangeHandler: this.newEventSegmentChangeHandler,
        readOnly: this.props.readOnly,
        resetAddEventSegment: this.resetAddEventSegment,
        resetEditEventSegment: this.resetEditEventSegment,
        updateEventSegment: this.updateEventSegment,
        viewer: this.props.viewer
      });
    }
  }]);

  return InvoiceSchedule;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

InvoiceSchedule.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  invoiceEventSegments: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceSchedule);

/***/ }),
/* 3032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__ = __webpack_require__(528);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InvoiceShare = function (_React$Component) {
  _inherits(InvoiceShare, _React$Component);

  function InvoiceShare(props) {
    _classCallCheck(this, InvoiceShare);

    var _this = _possibleConstructorReturn(this, (InvoiceShare.__proto__ || Object.getPrototypeOf(InvoiceShare)).call(this, props));

    _this.sendEmail = _this.sendEmail.bind(_this);
    return _this;
  }

  _createClass(InvoiceShare, [{
    key: 'sendEmail',
    value: function sendEmail(formModel, successCb) {
      var subject = formModel.subject,
          to = formModel.to,
          message = formModel.message;

      var cc = formModel.cc === '' ? null : formModel.cc;
      var onCompleted = function onCompleted() {
        successCb();
      };
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3055);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { invoice_id: this.props.document.id, to: to, cc: cc, subject: subject, message: message }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          onOpen = _props.onOpen,
          onClose = _props.onClose;

      var permissionsNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Anyone with the link ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'can view and pay'
        ),
        ' this invoice.'
      );
      var workspaces = this.props.document.workspaces.edges;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__["a" /* default */], {
        document: this.props.document,
        canEmail: this.props.document.can_email,
        event: workspaces.length > 0 ? workspaces[0].node.event : null,
        title: 'Share Invoice',
        shareUrl: "https://www.cloverbook.com" + '/open/i/' + this.props.document.share_token,
        documentType: 'invoice',
        permissionsNode: permissionsNode,
        sendEmail: this.sendEmail,
        trigger: trigger,
        onOpen: onOpen,
        onClose: onClose
      });
    }
  }]);

  return InvoiceShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceShare.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceShare);

/***/ }),
/* 3033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InvoiceTitle = function (_React$Component) {
  _inherits(InvoiceTitle, _React$Component);

  function InvoiceTitle(props) {
    _classCallCheck(this, InvoiceTitle);

    var _this = _possibleConstructorReturn(this, (InvoiceTitle.__proto__ || Object.getPrototypeOf(InvoiceTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(InvoiceTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update invoice title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated invoice title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Invoice)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3056);
        });

        var optimisticResponse = {
          updateInvoice: { invoice: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return InvoiceTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InvoiceTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (InvoiceTitle);

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b1c19ecb1c68080f681be65068a9e9a4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteInvoiceMutationVariables = {|
  input: DeleteInvoiceInput
|};
export type ActionsComponent_deleteInvoiceMutationResponse = {|
  +deleteInvoice: ?{|
    +deletedInvoiceId: ?string
  |}
|};
export type ActionsComponent_deleteInvoiceMutation = {|
  variables: ActionsComponent_deleteInvoiceMutationVariables,
  response: ActionsComponent_deleteInvoiceMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteInvoiceMutation(
  $input: DeleteInvoiceInput!
) {
  deleteInvoice(input: $input) {
    deletedInvoiceId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoice",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteInvoiceInput!"
    }],
    "concreteType": "DeleteInvoicePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedInvoiceId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteInvoiceMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteInvoiceMutation(\n  $input: DeleteInvoiceInput!\n) {\n  deleteInvoice(input: $input) {\n    deletedInvoiceId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ee62bcd68d2ad3ddc5391e2e819fe3e2';
module.exports = node;

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d6c5522212cc680e41380d0d9d4a2db2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_Invoice_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_Invoice_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_Invoice_updateBrandMutation = {|
  variables: Brand_Invoice_updateBrandMutationVariables,
  response: Brand_Invoice_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_Invoice_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_Invoice_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_Invoice_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_Invoice_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_Invoice_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6f354e9112d041af497d19f42761d127';
module.exports = node;

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 978f8e3cd5a6888f6a61db1cb13ce8ac
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceBrandInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  brand_id: string,
};
export type Brand_updateInvoiceBrandMutationVariables = {|
  input: UpdateInvoiceBrandInput
|};
export type Brand_updateInvoiceBrandMutationResponse = {|
  +updateInvoiceBrand: ?{|
    +invoice: ?{|
      +id: string,
      +brand_header: ?string,
    |}
  |}
|};
export type Brand_updateInvoiceBrandMutation = {|
  variables: Brand_updateInvoiceBrandMutationVariables,
  response: Brand_updateInvoiceBrandMutationResponse,
|};
*/

/*
mutation Brand_updateInvoiceBrandMutation(
  $input: UpdateInvoiceBrandInput!
) {
  updateInvoiceBrand(input: $input) {
    invoice {
      id
      brand_header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoiceBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateInvoiceBrandInput!"
    }],
    "concreteType": "UpdateInvoiceBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_updateInvoiceBrandMutation",
    "id": null,
    "text": "mutation Brand_updateInvoiceBrandMutation(\n  $input: UpdateInvoiceBrandInput!\n) {\n  updateInvoiceBrand(input: $input) {\n    invoice {\n      id\n      brand_header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_updateInvoiceBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_updateInvoiceBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c4893e23403782bed96af93ae0074e68';
module.exports = node;

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e6cd5cee04847478a5e26151863e848c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddInvoiceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type InvoiceComponent_addInvoiceToSessionMutationVariables = {|
  input: AddInvoiceToSessionInput
|};
export type InvoiceComponent_addInvoiceToSessionMutationResponse = {|
  +addInvoiceToSession: ?{|
    +invoice: ?{|
      +id: string
    |}
  |}
|};
export type InvoiceComponent_addInvoiceToSessionMutation = {|
  variables: InvoiceComponent_addInvoiceToSessionMutationVariables,
  response: InvoiceComponent_addInvoiceToSessionMutationResponse,
|};
*/

/*
mutation InvoiceComponent_addInvoiceToSessionMutation(
  $input: AddInvoiceToSessionInput!
) {
  addInvoiceToSession(input: $input) {
    invoice {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddInvoiceToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addInvoiceToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddInvoiceToSessionInput!"
    }],
    "concreteType": "AddInvoiceToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "InvoiceComponent_addInvoiceToSessionMutation",
    "id": null,
    "text": "mutation InvoiceComponent_addInvoiceToSessionMutation(\n  $input: AddInvoiceToSessionInput!\n) {\n  addInvoiceToSession(input: $input) {\n    invoice {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "InvoiceComponent_addInvoiceToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "InvoiceComponent_addInvoiceToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3e88246bce05ed3210cfecc671117c16';
module.exports = node;

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 614c1cab7745e017cd0b324323e4cb67
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type InvoiceContainer_RefetchQueryVariables = {|
  id: string
|};
export type InvoiceContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: InvoiceContainer_node$ref
  |}
|};
export type InvoiceContainer_RefetchQuery = {|
  variables: InvoiceContainer_RefetchQueryVariables,
  response: InvoiceContainer_RefetchQueryResponse,
|};
*/

/*
query InvoiceContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...InvoiceContainer_node
    id
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v3, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v2, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "InvoiceContainer_RefetchQuery",
    "id": null,
    "text": "query InvoiceContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...InvoiceContainer_node\n    id\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "InvoiceContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "InvoiceContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "InvoiceContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Invoice",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v2]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v2]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v2, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v2, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b5c39f51ea099e1d066d523320274243';
module.exports = node;

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type Share_event$ref = any;
export type DownPaymentDistribution = "FIXED" | "PERCENT" | "%future added value";
export type PaymentStatus = "INITIAL" | "PAID" | "%future added value";
export type PplanDistributionEnum = "EQUAL" | "FIXED" | "PERCENT" | "%future added value";
export type PplanStatusEnum = "INITIAL" | "PAID" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceContainer_node$ref: FragmentReference;
export type InvoiceContainer_node = {|
  +id: string,
  +title: ?string,
  +can_edit: ?boolean,
  +can_email: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +recipient_first_name: ?string,
  +recipient_last_name: ?string,
  +recipient_company_name: ?string,
  +recipient_email: ?string,
  +recipient_phone: ?string,
  +recipient_address: ?string,
  +deletable: ?boolean,
  +down_payment_cents: ?number,
  +down_payment_currency: ?string,
  +down_payment_distribution_type: ?DownPaymentDistribution,
  +down_payment_due_at: ?any,
  +down_payment_percent: ?number,
  +down_payment_status: ?PaymentStatus,
  +number: ?string,
  +pplan_distribution_type: ?PplanDistributionEnum,
  +total_cents: ?number,
  +total_paid_cents: ?number,
  +accepted_payment_methods: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?({|
        +__typename: "CashPaymentMethod",
        +id: string,
        +enabled: ?boolean,
        +instructions: ?string,
      |} | {|
        +__typename: "CheckPaymentMethod",
        +address: ?string,
        +pay_to: ?string,
      |} | {|
        +__typename: "CustomPaymentMethod",
        +label: ?string,
      |} | {|
        +__typename: "SquarePaymentMethod",
        +application_id: ?string,
        +location_id: ?string,
        +location_name: ?string,
      |} | {|
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        +__typename: "%other"
      |})
    |}>
  |},
  +i_pplan_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +amount_cents: ?number,
        +amount_currency: ?string,
        +due_at: ?any,
        +id: string,
        +locked: ?boolean,
        +status: ?PplanStatusEnum,
      |}
    |}>
  |},
  +invoice_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +invoice_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: "CashPayment",
        +id?: string,
        +amount_cents?: ?number,
        +amount_currency?: ?string,
        +name?: ?string,
        +notes?: ?string,
        +status?: ?PaymentStatus,
        +paid_at?: ?any,
        +refunds?: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +amount_cents: ?number,
              +amount_currency: ?string,
              +notes: ?string,
              +refunded_at: ?any,
            |}
          |}>
        |},
        +label?: ?string,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +$fragmentRefs: Share_event$ref,
        |},
      |}
    |}>
  |},
  +$refType: InvoiceContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v0, v6, v7, v9, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v15 = [v2, v0, v6, v7, v12, v9, v8, v13, v14];
  return {
    "kind": "Fragment",
    "name": "InvoiceContainer_node",
    "type": "Invoice",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["invoice_event_segments"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["invoice_line_items"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_currency",
      "args": null,
      "storageKey": null
    }, v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_email",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "share_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_company_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_email",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_phone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_address",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "deletable",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_cents",
      "args": null,
      "storageKey": null
    }, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_distribution_type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_due_at",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_percent",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_status",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "number",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "pplan_distribution_type",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "total_cents",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "total_paid_cents",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "accepted_payment_methods",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentMethodConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentMethodEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [v2, {
            "kind": "InlineFragment",
            "type": "SquarePaymentMethod",
            "selections": [v0, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "application_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location_name",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "InlineFragment",
            "type": "CustomPaymentMethod",
            "selections": [v0, v3, v4, v5]
          }, {
            "kind": "InlineFragment",
            "type": "CheckPaymentMethod",
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "address",
              "args": null,
              "storageKey": null
            }, v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "pay_to",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "InlineFragment",
            "type": "CashPaymentMethod",
            "selections": [v0, v3, v5]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "i_pplan_items",
      "storageKey": null,
      "args": null,
      "concreteType": "IPplanItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "IPplanItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "IPplanItem",
          "plural": false,
          "selections": [v6, v7, {
            "kind": "ScalarField",
            "alias": null,
            "name": "due_at",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "locked",
            "args": null,
            "storageKey": null
          }, v8]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": "invoice_event_segments",
      "name": "__InvoiceContainer_invoice_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceEventSegmentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEventSegmentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "InvoiceEventSegment",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "line1",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "start_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "end_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "time_zone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "all_day",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "line2",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "province",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "postal_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "room",
            "args": null,
            "storageKey": null
          }, v9, v2]
        }, v10]
      }, v11]
    }, {
      "kind": "LinkedField",
      "alias": "invoice_line_items",
      "name": "__InvoiceContainer_invoice_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceLineItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceLineItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "InvoiceLineItem",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          }, v1, v2]
        }, v10]
      }, v11]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "payments",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [{
            "kind": "InlineFragment",
            "type": "SquarePayment",
            "selections": [v2, v0, v6, v7, v12, v13, v14]
          }, {
            "kind": "InlineFragment",
            "type": "CustomPayment",
            "selections": [v2, v0, v6, v7, v12, v9, v8, v4, v13, v14]
          }, {
            "kind": "InlineFragment",
            "type": "CheckPayment",
            "selections": v15
          }, {
            "kind": "InlineFragment",
            "type": "CashPayment",
            "selections": v15
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, {
              "kind": "FragmentSpread",
              "name": "Share_event",
              "args": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f91ebe1f5905a198ffa445bd44d4e955';
module.exports = node;

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type LibraryContainer_viewer$ref = any;
type ScheduleContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceContainer_viewer$ref: FragmentReference;
export type InvoiceContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +s_time_zone: ?string,
  +payment_methods: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: "SquarePaymentMethod",
        +id?: string,
        +enabled?: ?boolean,
        +application_id?: ?string,
        +location_id?: ?string,
        +instructions?: ?string,
        +address?: ?string,
        +pay_to?: ?string,
        +label?: ?string,
      |}
    |}>
  |},
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref & ScheduleContainer_viewer$ref & LibraryContainer_viewer$ref,
  +$refType: InvoiceContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "InvoiceContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["payment_methods"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "payment_methods",
      "name": "__InvoiceContainer_payment_methods_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentMethodConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentMethodEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "type": "CustomPaymentMethod",
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }, v1, v2]
          }, {
            "kind": "InlineFragment",
            "type": "CheckPaymentMethod",
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "address",
              "args": null,
              "storageKey": null
            }, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "pay_to",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "InlineFragment",
            "type": "CashPaymentMethod",
            "selections": [v0, v1, v2]
          }, {
            "kind": "InlineFragment",
            "type": "SquarePaymentMethod",
            "selections": [v0, v1, {
              "kind": "ScalarField",
              "alias": null,
              "name": "application_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location_id",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "ScheduleContainer_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "FragmentSpread",
      "name": "LibraryContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd90e8b9fb65a47e91c093f2af5ad6deb';
module.exports = node;

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6e6636d0772dd78fb78c6d8fafdf7d29
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CopyUserLineItemsToInvoiceInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_Invoice_copyUserLineItemsToInvoiceMutationVariables = {|
  input: CopyUserLineItemsToInvoiceInput
|};
export type Library_Invoice_copyUserLineItemsToInvoiceMutationResponse = {|
  +copyUserLineItemsToInvoice: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type Library_Invoice_copyUserLineItemsToInvoiceMutation = {|
  variables: Library_Invoice_copyUserLineItemsToInvoiceMutationVariables,
  response: Library_Invoice_copyUserLineItemsToInvoiceMutationResponse,
|};
*/

/*
mutation Library_Invoice_copyUserLineItemsToInvoiceMutation(
  $input: CopyUserLineItemsToInvoiceInput!
) {
  copyUserLineItemsToInvoice(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToInvoiceInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_Invoice_copyUserLineItemsToInvoiceMutation",
    "id": null,
    "text": "mutation Library_Invoice_copyUserLineItemsToInvoiceMutation(\n  $input: CopyUserLineItemsToInvoiceInput!\n) {\n  copyUserLineItemsToInvoice(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_Invoice_copyUserLineItemsToInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToInvoice",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToInvoicePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_Invoice_copyUserLineItemsToInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToInvoice",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToInvoicePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0227660ac4447a580ecfc51012a64009';
module.exports = node;

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7580280496647312ad06cbdee1686d96
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateInvoiceLineItemInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  title: string,
  quantity: number,
  price_cents: number,
  price_currency: string,
  description?: ?string,
  add_to_library?: ?boolean,
};
export type Library_createInvoiceLineItemMutationVariables = {|
  input: CreateInvoiceLineItemInput
|};
export type Library_createInvoiceLineItemMutationResponse = {|
  +createInvoiceLineItem: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
    +new_invoice_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
    +new_user_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
  |}
|};
export type Library_createInvoiceLineItemMutation = {|
  variables: Library_createInvoiceLineItemMutationVariables,
  response: Library_createInvoiceLineItemMutationResponse,
|};
*/

/*
mutation Library_createInvoiceLineItemMutation(
  $input: CreateInvoiceLineItemInput!
) {
  createInvoiceLineItem(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
    new_invoice_line_item_edge {
      node {
        id
        title
        description
        position
        price_cents
        price_currency
        quantity
      }
    }
    new_user_line_item_edge {
      node {
        id
        title
        description
        price_cents
        price_currency
        quantity
      }
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateInvoiceLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateInvoiceLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "new_invoice_line_item_edge",
    "storageKey": null,
    "args": null,
    "concreteType": "InvoiceLineItemEdge",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceLineItem",
      "plural": false,
      "selections": [v2, v3, v4, v5, v6, v7, v8]
    }]
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "new_user_line_item_edge",
    "storageKey": null,
    "args": null,
    "concreteType": "UserLineItemEdge",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItem",
      "plural": false,
      "selections": [v2, v3, v4, v6, v7, v8]
    }]
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v19 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v22 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v23 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v24 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v25 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v16, v17, v20, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v26 = [v11, v16, v17, v23, v20, v18, v24, v25];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_createInvoiceLineItemMutation",
    "id": null,
    "text": "mutation Library_createInvoiceLineItemMutation(\n  $input: CreateInvoiceLineItemInput!\n) {\n  createInvoiceLineItem(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n    new_invoice_line_item_edge {\n      node {\n        id\n        title\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n    new_user_line_item_edge {\n      node {\n        id\n        title\n        description\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_createInvoiceLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateInvoiceLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }, v9, v10]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_createInvoiceLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateInvoiceLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v11, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v12, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v12, v13, v14]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v15, v12, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v12, v14]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v16, v17, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v18]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v19,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v20, v11]
              }, v21]
            }, v22]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v19,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v19,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, v4, v5, v6, v7, v8, v3, v11]
              }, v21]
            }, v22]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v19,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v11, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v11, v16, v17, v23, v24, v25]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v11, v16, v17, v23, v20, v18, v13, v24, v25]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v26
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v26
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v15, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }, v9, v10]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '21391436504ebed634788d0b1d3deeba';
module.exports = node;

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 85b86b1d6a2ef305b423f4dbf5f1a0ba
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type DeleteInvoiceLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type LineItems_deleteInvoiceLineItemMutationVariables = {|
  input: DeleteInvoiceLineItemInput
|};
export type LineItems_deleteInvoiceLineItemMutationResponse = {|
  +deleteInvoiceLineItem: ?{|
    +deletedInvoiceLineItemId: ?string,
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |},
  |}
|};
export type LineItems_deleteInvoiceLineItemMutation = {|
  variables: LineItems_deleteInvoiceLineItemMutationVariables,
  response: LineItems_deleteInvoiceLineItemMutationResponse,
|};
*/

/*
mutation LineItems_deleteInvoiceLineItemMutation(
  $input: DeleteInvoiceLineItemInput!
) {
  deleteInvoiceLineItem(input: $input) {
    deletedInvoiceLineItemId
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteInvoiceLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedInvoiceLineItemId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v3, v10, v11, v14, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v20 = [v5, v10, v11, v17, v14, v12, v18, v19];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_deleteInvoiceLineItemMutation",
    "id": null,
    "text": "mutation LineItems_deleteInvoiceLineItemMutation(\n  $input: DeleteInvoiceLineItemInput!\n) {\n  deleteInvoiceLineItem(input: $input) {\n    deletedInvoiceLineItemId\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_deleteInvoiceLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteInvoiceLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_deleteInvoiceLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteInvoiceLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v5, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v6, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v6, v7, v8]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v9, v6, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v6, v8]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v10, v11, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v13,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v14, v5]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v13,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v5]
              }, v15]
            }, v16]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v13,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v5, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v5, v10, v11, v17, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v5, v10, v11, v17, v14, v12, v7, v18, v19]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v20
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v20
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v9, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '245b9c12116f230686cfeeaa460c90e0';
module.exports = node;

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 354a65a35df026c0903f394f4583344e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type UpdateInvoiceLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  position?: ?number,
  description?: ?string,
};
export type LineItems_updateInvoiceLineItemMutationVariables = {|
  input: UpdateInvoiceLineItemInput
|};
export type LineItems_updateInvoiceLineItemMutationResponse = {|
  +updateInvoiceLineItem: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type LineItems_updateInvoiceLineItemMutation = {|
  variables: LineItems_updateInvoiceLineItemMutationVariables,
  response: LineItems_updateInvoiceLineItemMutationResponse,
|};
*/

/*
mutation LineItems_updateInvoiceLineItemMutation(
  $input: UpdateInvoiceLineItemInput!
) {
  updateInvoiceLineItem(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateInvoiceLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_updateInvoiceLineItemMutation",
    "id": null,
    "text": "mutation LineItems_updateInvoiceLineItemMutation(\n  $input: UpdateInvoiceLineItemInput!\n) {\n  updateInvoiceLineItem(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_updateInvoiceLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateInvoiceLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_updateInvoiceLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateInvoiceLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateInvoiceLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0844db88da958dbaf641ea425934606f';
module.exports = node;

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8583997a494957f531316e16b426164a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Invoice_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Invoice_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Invoice_Logo_updateBrandMutation = {|
  variables: Logo_Invoice_Logo_updateBrandMutationVariables,
  response: Logo_Invoice_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Invoice_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Invoice_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Invoice_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Invoice_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Invoice_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1dffd906925c72dcec4d0d17de14c111';
module.exports = node;

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0e29a334d76c5e30b4bc7316f448f6fa
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_Invoice_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_Invoice_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_Invoice_deleteLogo_updateBrandMutation = {|
  variables: Logo_Invoice_deleteLogo_updateBrandMutationVariables,
  response: Logo_Invoice_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_Invoice_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_Invoice_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_Invoice_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_Invoice_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_Invoice_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f6c180b190136a964c4984c263423164';
module.exports = node;

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 89ab38a6e84d4ef55a8de55bc23dc2a5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceBrandInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  brand_id: string,
};
export type Logo_updateInvoiceBrandMutationVariables = {|
  input: UpdateInvoiceBrandInput
|};
export type Logo_updateInvoiceBrandMutationResponse = {|
  +updateInvoiceBrand: ?{|
    +invoice: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateInvoiceBrandMutation = {|
  variables: Logo_updateInvoiceBrandMutationVariables,
  response: Logo_updateInvoiceBrandMutationResponse,
|};
*/

/*
mutation Logo_updateInvoiceBrandMutation(
  $input: UpdateInvoiceBrandInput!
) {
  updateInvoiceBrand(input: $input) {
    invoice {
      id
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoiceBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateInvoiceBrandInput!"
    }],
    "concreteType": "UpdateInvoiceBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_updateInvoiceBrandMutation",
    "id": null,
    "text": "mutation Logo_updateInvoiceBrandMutation(\n  $input: UpdateInvoiceBrandInput!\n) {\n  updateInvoiceBrand(input: $input) {\n    invoice {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_updateInvoiceBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_updateInvoiceBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '238b8919ff0f7b5deddbd417c3df1501';
module.exports = node;

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bd807da1805d3527650de226712208f7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type ChargeSquareInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  square_payment_method_id: string,
  name: string,
  amount_cents: number,
  amount_currency: string,
  nonce: string,
};
export type Pay_chargeSquareMutationVariables = {|
  input: ChargeSquareInput
|};
export type Pay_chargeSquareMutationResponse = {|
  +chargeSquare: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type Pay_chargeSquareMutation = {|
  variables: Pay_chargeSquareMutationVariables,
  response: Pay_chargeSquareMutationResponse,
|};
*/

/*
mutation Pay_chargeSquareMutation(
  $input: ChargeSquareInput!
) {
  chargeSquare(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "ChargeSquareInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "ChargeSquareInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Pay_chargeSquareMutation",
    "id": null,
    "text": "mutation Pay_chargeSquareMutation(\n  $input: ChargeSquareInput!\n) {\n  chargeSquare(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Pay_chargeSquareMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "chargeSquare",
        "storageKey": null,
        "args": v1,
        "concreteType": "ChargeSquarePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Pay_chargeSquareMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "chargeSquare",
        "storageKey": null,
        "args": v1,
        "concreteType": "ChargeSquarePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7e785428b699404ea48dd957188ff687';
module.exports = node;

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c78258e89e0582ee4cc4ad9e3ba0f4bd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
export type CreateManualPaymentInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  payment_method_id: string,
  name: string,
  notes?: ?string,
  amount_cents: number,
  amount_currency: string,
  paid_at?: ?any,
};
export type Pay_createManualPaymentMutationVariables = {|
  input: CreateManualPaymentInput
|};
export type Pay_createManualPaymentMutationResponse = {|
  +createManualPayment: ?{|
    +invoice: ?{|
      +$fragmentRefs: InvoiceContainer_node$ref
    |}
  |}
|};
export type Pay_createManualPaymentMutation = {|
  variables: Pay_createManualPaymentMutationVariables,
  response: Pay_createManualPaymentMutationResponse,
|};
*/

/*
mutation Pay_createManualPaymentMutation(
  $input: CreateManualPaymentInput!
) {
  createManualPayment(input: $input) {
    invoice {
      ...InvoiceContainer_node
      id
    }
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateManualPaymentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateManualPaymentInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v2, v9, v10, v13, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v19 = [v4, v9, v10, v16, v13, v11, v17, v18];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Pay_createManualPaymentMutation",
    "id": null,
    "text": "mutation Pay_createManualPaymentMutation(\n  $input: CreateManualPaymentInput!\n) {\n  createManualPayment(input: $input) {\n    invoice {\n      ...InvoiceContainer_node\n      id\n    }\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Pay_createManualPaymentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createManualPayment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateManualPaymentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "InvoiceContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Pay_createManualPaymentMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createManualPayment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateManualPaymentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "application_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v6, v7]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [v8, v5, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pay_to",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [v5, v7]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v9, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v12,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, v13, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v12,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, v14]
            }, v15]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v12,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v4, v2, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v4, v9, v10, v16, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v4, v9, v10, v16, v13, v11, v6, v17, v18]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v19
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v19
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v8, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1cce46ddd6788a90ef389c89a35a67bf';
module.exports = node;

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6b71c795393656c98f6615d060d5d474
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DownPaymentDistribution = "FIXED" | "PERCENT" | "%future added value";
export type PplanDistributionEnum = "EQUAL" | "FIXED" | "PERCENT" | "%future added value";
export type PplanStatusEnum = "INITIAL" | "PAID" | "%future added value";
export type UpdateIPplanInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  down_payment_cents?: ?number,
  down_payment_currency?: ?string,
  down_payment_distribution_type?: ?DownPaymentDistribution,
  down_payment_due_at?: ?any,
  down_payment_percent?: ?number,
  pplan_distribution_type?: ?PplanDistributionEnum,
  pplan_items?: ?$ReadOnlyArray<?PplanItemInput>,
  delete_pplan_items_with_ids?: ?$ReadOnlyArray<?string>,
};
export type PplanItemInput = {
  id?: ?string,
  due_at?: ?any,
  amount_cents?: ?number,
  amount_currency?: ?string,
};
export type PaymentPlan_Invoice_updateIPplanMutationVariables = {|
  input: UpdateIPplanInput
|};
export type PaymentPlan_Invoice_updateIPplanMutationResponse = {|
  +updateIPplan: ?{|
    +invoice: ?{|
      +down_payment_cents: ?number,
      +down_payment_due_at: ?any,
      +down_payment_percent: ?number,
      +down_payment_currency: ?string,
      +down_payment_distribution_type: ?DownPaymentDistribution,
      +pplan_distribution_type: ?PplanDistributionEnum,
      +i_pplan_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +amount_cents: ?number,
            +amount_currency: ?string,
            +due_at: ?any,
            +id: string,
            +locked: ?boolean,
            +percent: ?number,
            +status: ?PplanStatusEnum,
          |}
        |}>
      |},
    |}
  |}
|};
export type PaymentPlan_Invoice_updateIPplanMutation = {|
  variables: PaymentPlan_Invoice_updateIPplanMutationVariables,
  response: PaymentPlan_Invoice_updateIPplanMutationResponse,
|};
*/

/*
mutation PaymentPlan_Invoice_updateIPplanMutation(
  $input: UpdateIPplanInput!
) {
  updateIPplan(input: $input) {
    invoice {
      down_payment_cents
      down_payment_due_at
      down_payment_percent
      down_payment_currency
      down_payment_distribution_type
      pplan_distribution_type
      i_pplan_items {
        edges {
          node {
            amount_cents
            amount_currency
            due_at
            id
            locked
            percent
            status
          }
        }
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateIPplanInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateIPplanInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "down_payment_cents",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "down_payment_due_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "down_payment_percent",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "down_payment_currency",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "down_payment_distribution_type",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "pplan_distribution_type",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "i_pplan_items",
    "storageKey": null,
    "args": null,
    "concreteType": "IPplanItemConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "IPplanItemEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "IPplanItem",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "amount_cents",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount_currency",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "due_at",
          "args": null,
          "storageKey": null
        }, v8, {
          "kind": "ScalarField",
          "alias": null,
          "name": "locked",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "percent",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PaymentPlan_Invoice_updateIPplanMutation",
    "id": null,
    "text": "mutation PaymentPlan_Invoice_updateIPplanMutation(\n  $input: UpdateIPplanInput!\n) {\n  updateIPplan(input: $input) {\n    invoice {\n      down_payment_cents\n      down_payment_due_at\n      down_payment_percent\n      down_payment_currency\n      down_payment_distribution_type\n      pplan_distribution_type\n      i_pplan_items {\n        edges {\n          node {\n            amount_cents\n            amount_currency\n            due_at\n            id\n            locked\n            percent\n            status\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PaymentPlan_Invoice_updateIPplanMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateIPplan",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateIPplanPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v9]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PaymentPlan_Invoice_updateIPplanMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateIPplan",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateIPplanPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [v2, v3, v4, v5, v6, v7, v9, v8]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '41a9c4b4fd6570c6209225e6e973cde9';
module.exports = node;

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4b23a244a317c10030d4c3f435f86ee2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
};
export type Recipient_updateInvoiceMutationVariables = {|
  input: UpdateInvoiceInput
|};
export type Recipient_updateInvoiceMutationResponse = {|
  +updateInvoice: ?{|
    +invoice: ?{|
      +id: string,
      +recipient_first_name: ?string,
      +recipient_last_name: ?string,
      +recipient_company_name: ?string,
      +recipient_email: ?string,
      +recipient_phone: ?string,
      +recipient_address: ?string,
    |}
  |}
|};
export type Recipient_updateInvoiceMutation = {|
  variables: Recipient_updateInvoiceMutationVariables,
  response: Recipient_updateInvoiceMutationResponse,
|};
*/

/*
mutation Recipient_updateInvoiceMutation(
  $input: UpdateInvoiceInput!
) {
  updateInvoice(input: $input) {
    invoice {
      id
      recipient_first_name
      recipient_last_name
      recipient_company_name
      recipient_email
      recipient_phone
      recipient_address
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoice",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateInvoiceInput!"
    }],
    "concreteType": "UpdateInvoicePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_phone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "recipient_address",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Recipient_updateInvoiceMutation",
    "id": null,
    "text": "mutation Recipient_updateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoice {\n      id\n      recipient_first_name\n      recipient_last_name\n      recipient_company_name\n      recipient_email\n      recipient_phone\n      recipient_address\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Recipient_updateInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Recipient_updateInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8328e445242249f37ed99e911cb0b6bf';
module.exports = node;

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7964ec9bad19115ec07c6aa847989630
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateInvoiceEventSegmentInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_createInvoiceEventSegmentMutationVariables = {|
  input: CreateInvoiceEventSegmentInput
|};
export type Schedule_createInvoiceEventSegmentMutationResponse = {|
  +createInvoiceEventSegment: ?{|
    +new_invoice_event_segment_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}
  |}
|};
export type Schedule_createInvoiceEventSegmentMutation = {|
  variables: Schedule_createInvoiceEventSegmentMutationVariables,
  response: Schedule_createInvoiceEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_createInvoiceEventSegmentMutation(
  $input: CreateInvoiceEventSegmentInput!
) {
  createInvoiceEventSegment(input: $input) {
    new_invoice_event_segment_edge {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateInvoiceEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createInvoiceEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateInvoiceEventSegmentInput!"
    }],
    "concreteType": "CreateInvoiceEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_invoice_event_segment_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceEventSegmentEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEventSegment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "start_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "end_at",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "all_day",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "location",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "city",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "province",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "postal_code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "room",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_createInvoiceEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_createInvoiceEventSegmentMutation(\n  $input: CreateInvoiceEventSegmentInput!\n) {\n  createInvoiceEventSegment(input: $input) {\n    new_invoice_event_segment_edge {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_createInvoiceEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_createInvoiceEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6c9ad1d29424f34ba74bf225225b4f39';
module.exports = node;

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4b8553d54e9c76683a4b0979671ab416
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Schedule_deleteInvoiceEventSegmentMutationVariables = {|
  input: DeleteInvoiceEventSegmentInput
|};
export type Schedule_deleteInvoiceEventSegmentMutationResponse = {|
  +deleteInvoiceEventSegment: ?{|
    +deletedInvoiceEventSegmentId: ?string
  |}
|};
export type Schedule_deleteInvoiceEventSegmentMutation = {|
  variables: Schedule_deleteInvoiceEventSegmentMutationVariables,
  response: Schedule_deleteInvoiceEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_deleteInvoiceEventSegmentMutation(
  $input: DeleteInvoiceEventSegmentInput!
) {
  deleteInvoiceEventSegment(input: $input) {
    deletedInvoiceEventSegmentId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoiceEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteInvoiceEventSegmentInput!"
    }],
    "concreteType": "DeleteInvoiceEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedInvoiceEventSegmentId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_deleteInvoiceEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_deleteInvoiceEventSegmentMutation(\n  $input: DeleteInvoiceEventSegmentInput!\n) {\n  deleteInvoiceEventSegment(input: $input) {\n    deletedInvoiceEventSegmentId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_deleteInvoiceEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_deleteInvoiceEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cec96d7ceffed76e94ca703ecf0f99c1';
module.exports = node;

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c09d9cd74c90fdaad2b90e4b6a6ed8ef
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type Schedule_updateInvoiceEventSegmentMutationVariables = {|
  input: UpdateInvoiceEventSegmentInput
|};
export type Schedule_updateInvoiceEventSegmentMutationResponse = {|
  +updateInvoiceEventSegment: ?{|
    +invoice_event_segment: ?{|
      +id: string,
      +title: ?string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +all_day: ?boolean,
      +location: ?string,
      +line1: ?string,
      +line2: ?string,
      +city: ?string,
      +province: ?string,
      +postal_code: ?string,
      +room: ?string,
      +notes: ?string,
    |}
  |}
|};
export type Schedule_updateInvoiceEventSegmentMutation = {|
  variables: Schedule_updateInvoiceEventSegmentMutationVariables,
  response: Schedule_updateInvoiceEventSegmentMutationResponse,
|};
*/

/*
mutation Schedule_updateInvoiceEventSegmentMutation(
  $input: UpdateInvoiceEventSegmentInput!
) {
  updateInvoiceEventSegment(input: $input) {
    invoice_event_segment {
      id
      title
      start_at
      end_at
      time_zone
      all_day
      location
      line1
      line2
      city
      province
      postal_code
      room
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoiceEventSegment",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateInvoiceEventSegmentInput!"
    }],
    "concreteType": "UpdateInvoiceEventSegmentPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice_event_segment",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceEventSegment",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "line1",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "start_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "end_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "time_zone",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "all_day",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "location",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "line2",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "province",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "postal_code",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "room",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Schedule_updateInvoiceEventSegmentMutation",
    "id": null,
    "text": "mutation Schedule_updateInvoiceEventSegmentMutation(\n  $input: UpdateInvoiceEventSegmentInput!\n) {\n  updateInvoiceEventSegment(input: $input) {\n    invoice_event_segment {\n      id\n      title\n      start_at\n      end_at\n      time_zone\n      all_day\n      location\n      line1\n      line2\n      city\n      province\n      postal_code\n      room\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Schedule_updateInvoiceEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Schedule_updateInvoiceEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6bda95ef044493413dc5b209b3c98e25';
module.exports = node;

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 86b3f79d4c16fe3184dfb8601fd67d29
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailInvoiceLinkInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type Share_emailInvoiceLinkMutationVariables = {|
  input: EmailInvoiceLinkInput
|};
export type Share_emailInvoiceLinkMutationResponse = {|
  +emailInvoiceLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type Share_emailInvoiceLinkMutation = {|
  variables: Share_emailInvoiceLinkMutationVariables,
  response: Share_emailInvoiceLinkMutationResponse,
|};
*/

/*
mutation Share_emailInvoiceLinkMutation(
  $input: EmailInvoiceLinkInput!
) {
  emailInvoiceLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailInvoiceLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailInvoiceLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailInvoiceLinkInput!"
    }],
    "concreteType": "EmailInvoiceLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Share_emailInvoiceLinkMutation",
    "id": null,
    "text": "mutation Share_emailInvoiceLinkMutation(\n  $input: EmailInvoiceLinkInput!\n) {\n  emailInvoiceLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Share_emailInvoiceLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Share_emailInvoiceLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ce603a1569d65295fc47b396c23638f2';
module.exports = node;

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c8c7727f27aa3816e0a98d393caf322f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
};
export type Title_UpdateInvoiceMutationVariables = {|
  input: UpdateInvoiceInput
|};
export type Title_UpdateInvoiceMutationResponse = {|
  +updateInvoice: ?{|
    +invoice: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_UpdateInvoiceMutation = {|
  variables: Title_UpdateInvoiceMutationVariables,
  response: Title_UpdateInvoiceMutationResponse,
|};
*/

/*
mutation Title_UpdateInvoiceMutation(
  $input: UpdateInvoiceInput!
) {
  updateInvoice(input: $input) {
    invoice {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateInvoiceInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateInvoiceMutation",
    "id": null,
    "text": "mutation Title_UpdateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoice {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateInvoice",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateInvoicePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateInvoice",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateInvoicePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoice",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '94e28b2cce2e100dd86cac08c8c778c3';
module.exports = node;

/***/ }),
/* 3057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_4_filestack_js__["a" /* default */].init(apikey);

var MusicPlannerBrand = function (_React$Component) {
  _inherits(MusicPlannerBrand, _React$Component);

  function MusicPlannerBrand(props) {
    _classCallCheck(this, MusicPlannerBrand);

    var _this = _possibleConstructorReturn(this, (MusicPlannerBrand.__proto__ || Object.getPrototypeOf(MusicPlannerBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromMusicPlanner()
    };
    _this.getBrandFromMusicPlanner = _this.getBrandFromMusicPlanner.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.updateMusicPlannerBrand = _this.updateMusicPlannerBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerBrand, [{
    key: 'getBrandFromMusicPlanner',
    value: function getBrandFromMusicPlanner() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(this.props.node, ['brand_logo_url', 'brand_logo_size', 'brand_logo_mimetype', 'brand_logo_handle', 'brand_header']);
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        _this2.updateMusicPlannerBrand(successCb, failureCb);
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3071);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateMusicPlannerBrand',
    value: function updateMusicPlannerBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3073);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            music_planner_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromMusicPlanner();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this3.updateMusicPlannerBrand();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3072);
      });

      var environment = this.props.relay.environment;

      var brand = this.getBrandFromMusicPlanner();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id,
            header: brand.brand_header
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this4 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this4.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this5 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this5.updateMusicPlannerBrand();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3070);
      });

      var environment = this.props.relay.environment;

      var brand = this.getBrandFromMusicPlanner();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id,
            header: brand.brand_header
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        selectedBrand: this.getBrandFromMusicPlanner(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        openPicker: this.openPicker,
        updateBrand: this.updateBrand,
        viewer: this.props.viewer,
        uploadLogo: this.uploadLogo
      });
    }
  }]);

  return MusicPlannerBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MusicPlannerBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerBrand);

/***/ }),
/* 3058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Description_Description__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MusicPlannerDescription = function (_React$Component) {
  _inherits(MusicPlannerDescription, _React$Component);

  function MusicPlannerDescription(props) {
    _classCallCheck(this, MusicPlannerDescription);

    var _this = _possibleConstructorReturn(this, (MusicPlannerDescription.__proto__ || Object.getPrototypeOf(MusicPlannerDescription)).call(this, props));

    _this.state = {
      description: _this.props.node.description
    };
    _this.descriptionChangeHandler = _this.descriptionChangeHandler.bind(_this);
    _this.updateDescription = _this.updateDescription.bind(_this);
    _this.resetDescription = _this.resetDescription.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerDescription, [{
    key: 'descriptionChangeHandler',
    value: function descriptionChangeHandler(value) {
      this.setState({ description: value });
    }
  }, {
    key: 'updateDescription',
    value: function updateDescription(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update description',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated description',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default description if null
      var description = this.state.description === '<p><br></p>' ? null : this.state.description;
      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3074);
      });

      var optimisticResponse = {
        updateMusicPlanner: { music_planner: { id: id, description: description } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            description: description
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetDescription',
    value: function resetDescription() {
      this.setState({ description: this.props.node.description });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Description_Description__["a" /* default */], {
          canEdit: this.props.canEdit,
          localDescription: this.state.description,
          reset: this.resetDescription,
          description: this.props.node.description,
          descriptionChangeHandler: this.descriptionChangeHandler,
          updateDescription: this.updateDescription
        })
      );
    }
  }]);

  return MusicPlannerDescription;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerDescription.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerDescription);

/***/ }),
/* 3059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(3067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var MusicPlannerHeader = function (_React$Component) {
  _inherits(MusicPlannerHeader, _React$Component);

  function MusicPlannerHeader(props) {
    _classCallCheck(this, MusicPlannerHeader);

    var _this = _possibleConstructorReturn(this, (MusicPlannerHeader.__proto__ || Object.getPrototypeOf(MusicPlannerHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          router = _props.router,
          viewer = _props.viewer;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              this.props.document.workspaces.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return MusicPlannerHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerHeader);

/***/ }),
/* 3060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var MusicPlannerLogo = function (_React$Component) {
  _inherits(MusicPlannerLogo, _React$Component);

  function MusicPlannerLogo(props) {
    _classCallCheck(this, MusicPlannerLogo);

    var _this = _possibleConstructorReturn(this, (MusicPlannerLogo.__proto__ || Object.getPrototypeOf(MusicPlannerLogo)).call(this, props));

    _this.updateMusicPlannerLogo = _this.updateMusicPlannerLogo.bind(_this);
    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerLogo, [{
    key: 'updateMusicPlannerLogo',
    value: function updateMusicPlannerLogo(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3077);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            music_planner_id: this.props.node.id,
            brand_id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this2.updateMusicPlannerLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3075);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this3 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this4.updateMusicPlannerLogo();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3076);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand_logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return MusicPlannerLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerLogo);

/***/ }),
/* 3061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Actions__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(3059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Brand__ = __webpack_require__(3057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Logo__ = __webpack_require__(3060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Description__ = __webpack_require__(3058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Notes__ = __webpack_require__(3063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Playlist_Preview__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_utils_array__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























// eslint-disable-next-line new-cap
var SortableItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__["SortableElement"])(__WEBPACK_IMPORTED_MODULE_18__Playlist_Preview__["a" /* default */]);

// eslint-disable-next-line new-cap
var SortableList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__["SortableContainer"])(function (_ref) {
  var items = _ref.items,
      openPlaylist = _ref.openPlaylist;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    items.map(function (_ref2, index) {
      var playlist = _ref2.node;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableItem, {
        playlist: playlist,
        index: index,
        openPlaylist: openPlaylist,
        key: index
      });
    })
  );
});

var MusicPlanner = (_temp = _class = function (_React$Component) {
  _inherits(MusicPlanner, _React$Component);

  function MusicPlanner(props) {
    _classCallCheck(this, MusicPlanner);

    var _this = _possibleConstructorReturn(this, (MusicPlanner.__proto__ || Object.getPrototypeOf(MusicPlanner)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.openPlaylist = _this.openPlaylist.bind(_this);
    _this.closePlaylist = _this.closePlaylist.bind(_this);
    _this.createPlannerPlaylist = _this.createPlannerPlaylist.bind(_this);
    _this.reorderPlannerPlaylists = _this.reorderPlannerPlaylists.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(MusicPlanner, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.node && this.props.location.query.share_token) {
        this.addMusicPlannerToSession();
      }
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'addMusicPlannerToSession',
    value: function addMusicPlannerToSession() {
      var _this2 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this2.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null);
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3079);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPlannerPlaylist',
    value: function createPlannerPlaylist() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added playlist',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.openPlaylist(response.createPlannerPlaylist.new_planner_playlist_edge.node.id);
        __WEBPACK_IMPORTED_MODULE_12__Modules__["c" /* Analytics */].trackEvent('created-planner-playlist');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3080);
      });

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_planner_playlist_edge',
        connectionInfo: [{
          key: 'MusicPlannerContainer_planner_playlists',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            music_planner_id: parentID,
            title: '(Untitled Playlist)'
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'reorderPlannerPlaylists',
    value: function reorderPlannerPlaylists(_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist order',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["c" /* Analytics */].trackEvent('updated-planner-playlist-position');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3078);
      });

      var musicPlanner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      var movedPlaylistId = musicPlanner.planner_playlists.edges[oldIndex].node.id;
      musicPlanner.planner_playlists.edges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_utils_array__["a" /* arrayMove */])(musicPlanner.planner_playlists.edges, oldIndex, newIndex);

      var optimisticResponse = {
        updatePlannerPlaylist: {
          music_planner: musicPlanner
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { id: movedPlaylistId, position: newIndex + 1 }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'openPlaylist',
    value: function openPlaylist(id) {
      this.props.router.push('/docs/m/' + this.props.node.id + '/' + this.props.params.action + '/playlist/' + id);
    }
  }, {
    key: 'closePlaylist',
    value: function closePlaylist() {
      this.props.router.go(-1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          node = _props.node,
          params = _props.params,
          relay = _props.relay,
          router = _props.router,
          viewer = _props.viewer;

      var playlistOpen = this.props.params.playlist_id !== undefined;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref4) {
          var window = _ref4.window;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Actions__["a" /* default */], {
            node: node,
            params: params,
            relay: relay,
            router: router,
            windowDimensions: window
          });
        }
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref5) {
          var isComputer = _ref5.isComputer,
              isMobile = _ref5.isMobile,
              isLargeScreen = _ref5.isLargeScreen,
              window = _ref5.window;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_sidebar___default.a,
              {
                sidebar: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__App_SidebarComponent__["a" /* default */], {
                  setSidebarOpenState: _this4.onSetSidebarOpen,
                  router: router,
                  viewer: viewer
                }),
                sidebarClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.sidebar,
                open: _this4.state.sidebarOpen,
                onSetOpen: _this4.onSetSidebarOpen,
                touch: false,
                contentClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileSidebarContent,
                rootClassName: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileSidebarRoot
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["a" /* default */], {
                toggleSidebar: _this4.toggleSidebar,
                sidebarOpen: _this4.state.sidebarOpen,
                document: node,
                relay: relay,
                router: router,
                params: params,
                viewer: viewer,
                windowDimensions: window
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["s" /* Container */],
                { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.container },
                !isLargeScreen && isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                    {
                      columns: 'equal',
                      className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionsMenuTablet
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      ActionsMenu
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["t" /* Segment */],
                  {
                    className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.segment,
                    style: { maxWidth: '720px' }
                  },
                  isLargeScreen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["u" /* Rail */],
                    {
                      position: 'right',
                      close: true,
                      className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.actionsMenuDesktop
                    },
                    ActionsMenu
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */],
                    { padded: !isMobile, relaxed: !isMobile },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Logo__["a" /* default */], {
                          canEdit: _this4.canEdit(),
                          viewer: viewer,
                          node: node,
                          relay: relay
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Brand__["a" /* default */], {
                          canEdit: _this4.canEdit(),
                          viewer: viewer,
                          node: node,
                          relay: relay
                        })
                      )
                    ),
                    playlistOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'a',
                          { onClick: _this4.closePlaylist },
                          '< Back to All Playlists'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        _this4.props.children
                      )
                    ),
                    !playlistOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Description__["a" /* default */], {
                          node: _this4.props.node,
                          relay: _this4.props.relay,
                          canEdit: _this4.canEdit()
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        !playlistOpen && _this4.canEdit() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableList, {
                          items: node.planner_playlists.edges,
                          onSortEnd: _this4.reorderPlannerPlaylists,
                          helperClass: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.sortableHelper,
                          openPlaylist: _this4.openPlaylist,
                          pressDelay: 200
                        }),
                        !playlistOpen && !_this4.canEdit() && node.planner_playlists.edges.map(function (_ref6, index) {
                          var plannerPlaylist = _ref6.node;
                          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Playlist_Preview__["a" /* default */], {
                            playlist: plannerPlaylist,
                            openPlaylist: _this4.openPlaylist,
                            key: index
                          });
                        }),
                        isMobile && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_12__Modules__["f" /* MobileModal */],
                          {
                            open: playlistOpen,
                            onClose: _this4.closePlaylist
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_12__Modules__["f" /* MobileModal */].Content,
                            null,
                            _this4.props.children
                          )
                        ),
                        node.planner_playlists.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          {
                            style: { textAlign: 'center', padding: '2em' }
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'h3',
                            null,
                            'This music list has no playlists'
                          ),
                          _this4.canEdit() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["b" /* Button */], {
                            primary: true,
                            icon: 'plus',
                            labelPosition: 'left',
                            content: 'Add Playlist',
                            onClick: _this4.createPlannerPlaylist
                          })
                        ),
                        !playlistOpen && _this4.canEdit() && node.planner_playlists.edges.length !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["b" /* Button */], {
                          primary: true,
                          icon: 'plus',
                          labelPosition: 'left',
                          content: 'Add Playlist',
                          onClick: _this4.createPlannerPlaylist
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.heading },
                          'Notes'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Notes__["a" /* default */], { node: node, relay: relay })
                      )
                    )
                  )
                )
              )
            ),
            !node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              _this4.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App_404__["a" /* default */], { viewer: viewer }),
              !_this4.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["a" /* Loader */], null)
            )
          );
        }
      );
    }
  }]);

  return MusicPlanner;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(MusicPlanner));

/***/ }),
/* 3062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MusicPlannerComponent__ = __webpack_require__(3061);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__MusicPlannerComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3082);
  },
  viewer: function viewer() {
    return __webpack_require__(3083);
  }
}, function () {
  return __webpack_require__(3081);
}));

/***/ }),
/* 3063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Notepad_Notepad__ = __webpack_require__(1466);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MusicPlannerNotes = function (_Component) {
  _inherits(MusicPlannerNotes, _Component);

  function MusicPlannerNotes(props) {
    _classCallCheck(this, MusicPlannerNotes);

    var _this = _possibleConstructorReturn(this, (MusicPlannerNotes.__proto__ || Object.getPrototypeOf(MusicPlannerNotes)).call(this, props));

    _this.fillNotes = _this.fillNotes.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerNotes, [{
    key: 'fillNotes',
    value: function fillNotes(notes) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update notes',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-music-planner-notes');
      };

      // Update event if values have changed
      if (this.props.node.notes !== notes) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3084);
        });
        var id = this.props.node.id;

        var optimisticResponse = {
          fillMusicPlanner: { music_planner: { id: id, notes: notes } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              notes: notes
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var notes = this.props.node.notes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Notepad_Notepad__["a" /* default */], { notes: notes, update: this.fillNotes });
    }
  }]);

  return MusicPlannerNotes;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MusicPlannerNotes.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerNotes);

/***/ }),
/* 3064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6, _graphql7, _graphql8;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PlannerPlaylist = function (_React$Component) {
  _inherits(PlannerPlaylist, _React$Component);

  function PlannerPlaylist(props) {
    _classCallCheck(this, PlannerPlaylist);

    var _this = _possibleConstructorReturn(this, (PlannerPlaylist.__proto__ || Object.getPrototypeOf(PlannerPlaylist)).call(this, props));

    _this.state = {
      maxLengthWarningOpen: false
    };
    _this.canEdit = _this.canEdit.bind(_this);
    _this.goBack = _this.goBack.bind(_this);
    _this.updatePlannerPlaylist = _this.updatePlannerPlaylist.bind(_this);
    _this.updateMaxLength = _this.updateMaxLength.bind(_this);
    _this.deletePlannerPlaylist = _this.deletePlannerPlaylist.bind(_this);
    _this.deletePlannerPlaylistSong = _this.deletePlannerPlaylistSong.bind(_this);
    _this.playlistContainsSong = _this.playlistContainsSong.bind(_this);
    _this.createPlannerPlaylistSong = _this.createPlannerPlaylistSong.bind(_this);
    _this.addPlannerPlaylistRecommendations = _this.addPlannerPlaylistRecommendations.bind(_this);
    _this.removePlannerPlaylistRecommendation = _this.removePlannerPlaylistRecommendation.bind(_this);
    return _this;
  }

  _createClass(PlannerPlaylist, [{
    key: 'goBack',
    value: function goBack() {
      this.props.router.go(-1);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.params.action === 'edit' && this.props.node.music_planner.can_edit;
    }
  }, {
    key: 'deletePlannerPlaylist',
    value: function deletePlannerPlaylist(successCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-planner-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3093);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.params.id,
        pathToConnection: ['music_planner', 'planner_playlists'],
        deletedIDFieldName: 'deletedPlannerPlaylistId',
        connectionKeys: [{
          key: 'MusicPlannerContainer_planner_playlists',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError,
        configs: configs
      });
    }
  }, {
    key: 'deletePlannerPlaylistSong',
    value: function deletePlannerPlaylistSong(e, song, parent, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete song',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3094);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.node.id,
        pathToConnection: ['planner_playlist', 'playlist_songs'],
        deletedIDFieldName: 'deletedPlannerPlaylistSongId',
        connectionKeys: [{
          key: 'MusicPlannerContainer_planner_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: parent.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updatePlannerPlaylist',
    value: function updatePlannerPlaylist(data, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-planner-playlist');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3089);
      });

      var optimisticResponse = {
        updatePlannerPlaylist: {
          planner_playlist: _extends({}, this.props.node, _defineProperty({}, data.name, data.value))
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _defineProperty({
            id: this.props.node.id
          }, data.name, data.value)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateMaxLength',
    value: function updateMaxLength(data, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-planner-playlist');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3088);
      });

      var maxLength = data.value ? parseInt(data.value, 0) : null;

      var optimisticResponse = {
        updatePlannerPlaylist: {
          planner_playlist: _extends({}, this.props.node, {
            maxLength: maxLength
          })
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.id,
            max_length: maxLength
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPlannerPlaylistSong',
    value: function createPlannerPlaylistSong(e, song, parent, successCb, failureCb) {
      if (Array.isArray(song)) {
        this.createPlannerPlaylistSongs(e, song, parent, successCb, failureCb);
        return;
      }
      var maxLength = this.props.node.max_length;
      if (maxLength && this.props.node.playlist_songs.edges.length >= maxLength) {
        if (failureCb) failureCb();
        this.setState({ maxLengthWarningOpen: true });
        return;
      }
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add song to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3091);
      });

      var songParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id', '__typename'));
      if (songParams.external_source) {
        songParams.external_source = songParams.external_source.toUpperCase();
      }

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_planner_playlist_song_edge',
        connectionInfo: [{
          key: 'MusicPlannerContainer_planner_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            planner_playlist_id: parentID
          }, songParams, {
            song_images: songParams.song_images ? songParams.song_images.edges.map(function (_ref) {
              var image = _ref.node;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
            }) : []
          })
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPlannerPlaylistSongs',
    value: function createPlannerPlaylistSongs(e, songs, parent, successCb, failureCb) {
      var maxLength = this.props.node.max_length;
      if (maxLength && this.props.node.playlist_songs.edges.length + songs.length > maxLength) {
        if (failureCb) failureCb();
        var songsLeft = maxLength - this.props.node.playlist_songs.edges.length;
        this.setState({
          maxLengthWarningOpen: true,
          maxLengthMessage: songsLeft > 0 ? 'Please select up to ' + songsLeft + ' song' + (songsLeft !== 1 ? 's' : '') + '.' : null
        });
        return;
      }
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add songs to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3092);
      });

      var newSongs = songs.map(function (song) {
        var newSong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id', '__typename'));
        if (newSong.external_source) {
          newSong.external_source = newSong.external_source.toUpperCase();
        }
        newSong.song_images = newSong.song_images ? newSong.song_images.edges.map(function (_ref2) {
          var image = _ref2.node;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
        }) : [];
        return newSong;
      });

      var parentID = this.props.node.id;

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            planner_playlist_id: parentID,
            songs: newSongs
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'playlistContainsSong',
    value: function playlistContainsSong(song) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.node.playlist_songs.edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var playlistSong = _step.value;

          if (playlistSong.node.song.isrc === song.isrc) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'addPlannerPlaylistRecommendations',
    value: function addPlannerPlaylistRecommendations(playlistIds, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist recommendations',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('added-planner-playlist-recommendations');
      };

      var mutation = _graphql7 || (_graphql7 = function _graphql7() {
        return __webpack_require__(3090);
      });

      var environment = this.props.relay.environment;

      var allPlaylists = this.props.viewer.playlists.edges.concat(this.props.viewer.public_playlists.edges);
      var newRecs = playlistIds.map(function (id) {
        return allPlaylists.filter(function (p) {
          return p.node.id === id;
        })[0];
      });
      var plannerPlaylist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      plannerPlaylist.playlist_recommendations.edges = plannerPlaylist.playlist_recommendations.edges.concat(newRecs);

      var optimisticResponse = {
        addPlannerPlaylistRecommendations: {
          planner_playlist: plannerPlaylist
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            planner_playlist_id: this.props.node.id,
            playlist_ids: playlistIds
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'removePlannerPlaylistRecommendation',
    value: function removePlannerPlaylistRecommendation(playlistId, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to remove playlist recommendation',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql8 || (_graphql8 = function _graphql8() {
        return __webpack_require__(3095);
      });

      var environment = this.props.relay.environment;

      var plannerPlaylist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      plannerPlaylist.playlist_recommendations.edges = plannerPlaylist.playlist_recommendations.edges.filter(function (p) {
        return p.node.id !== playlistId;
      });

      var optimisticResponse = {
        removePlannerPlaylistRecommendation: {
          planner_playlist: plannerPlaylist
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            planner_playlist_id: this.props.node.id,
            playlist_id: playlistId
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          node = _props.node,
          relay = _props.relay,
          viewer = _props.viewer;
      var _state = this.state,
          maxLengthMessage = _state.maxLengthMessage,
          maxLengthWarningOpen = _state.maxLengthWarningOpen;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { paddingTop: '1em', paddingBottom: '3em' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */],
          {
            open: maxLengthWarningOpen,
            onClose: function onClose() {
              return _this2.setState({
                maxLengthWarningOpen: false,
                maxLengthMessage: null
              });
            },
            size: 'mini'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Header, { content: 'Song Limit Reached' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'You can only add up to ',
              ' ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                node.max_length,
                ' ',
                'song' + (node.max_length !== 1 ? 's' : '')
              ),
              ' ',
              'to this playlist.',
              ' ',
              maxLengthMessage || 'Please remove an existing song before adding a new one.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Actions,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["b" /* Button */], {
              content: 'Close',
              onClick: function onClick() {
                return _this2.setState({ maxLengthWarningOpen: false });
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Playlist__["a" /* default */], {
          playlist: node,
          goBack: this.goBack,
          relay: relay,
          searchResults: node.song_search.edges.map(function (edge) {
            return edge.node;
          }),
          refetchSearchResults: relay.refetch,
          viewer: viewer,
          editable: this.canEdit(),
          fillable: true,
          showControls: this.canEdit(),
          addPlaylistRecommendations: this.addPlannerPlaylistRecommendations,
          removePlaylistRecommendation: this.removePlannerPlaylistRecommendation,
          updatePlaylist: this.updatePlannerPlaylist,
          updateMaxLength: this.updateMaxLength,
          deletePlaylist: this.deletePlannerPlaylist,
          removeFromPlaylist: this.deletePlannerPlaylistSong,
          playlistContainsSong: this.playlistContainsSong,
          addToPlaylist: this.createPlannerPlaylistSong
        })
      );
    }
  }]);

  return PlannerPlaylist;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PlannerPlaylist.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (PlannerPlaylist);

/***/ }),
/* 3065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlannerPlaylist__ = __webpack_require__(3064);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__PlannerPlaylist__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3086);
  },
  viewer: function viewer() {
    return __webpack_require__(3087);
  }
}, function () {
  return __webpack_require__(3085);
}));

/***/ }),
/* 3066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__ = __webpack_require__(528);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MusicPlannerShare = function (_React$Component) {
  _inherits(MusicPlannerShare, _React$Component);

  function MusicPlannerShare(props) {
    _classCallCheck(this, MusicPlannerShare);

    var _this = _possibleConstructorReturn(this, (MusicPlannerShare.__proto__ || Object.getPrototypeOf(MusicPlannerShare)).call(this, props));

    _this.sendEmail = _this.sendEmail.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerShare, [{
    key: 'sendEmail',
    value: function sendEmail(formModel, successCb) {
      var subject = formModel.subject,
          to = formModel.to,
          message = formModel.message;

      var cc = formModel.cc === '' ? null : formModel.cc;
      var onCompleted = function onCompleted() {
        successCb();
      };
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3096);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { music_planner_id: this.props.document.id, to: to, cc: cc, subject: subject, message: message }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trigger = _props.trigger,
          onOpen = _props.onOpen,
          onClose = _props.onClose;

      var permissionsNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Anyone with the link ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'can fill out'
        ),
        ' this music list.'
      );
      var workspaces = this.props.document.workspaces.edges;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Actions_Share__["a" /* default */], {
        document: this.props.document,
        canEmail: this.props.document.can_email,
        event: workspaces.length > 0 ? workspaces[0].node.event : null,
        title: 'Share Music List',
        shareUrl: "https://www.cloverbook.com" + '/open/m/' + this.props.document.share_token,
        documentType: 'music list',
        permissionsNode: permissionsNode,
        sendEmail: this.sendEmail,
        trigger: trigger,
        onOpen: onOpen,
        onClose: onClose
      });
    }
  }]);

  return MusicPlannerShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerShare.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerShare);

/***/ }),
/* 3067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MusicPlannerTitle = function (_React$Component) {
  _inherits(MusicPlannerTitle, _React$Component);

  function MusicPlannerTitle(props) {
    _classCallCheck(this, MusicPlannerTitle);

    var _this = _possibleConstructorReturn(this, (MusicPlannerTitle.__proto__ || Object.getPrototypeOf(MusicPlannerTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(MusicPlannerTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update music list title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated music list title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Music List)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3097);
        });

        var optimisticResponse = {
          updateMusicPlanner: { music_planner: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return MusicPlannerTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MusicPlannerTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (MusicPlannerTitle);

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 51b8c03c708f9c34924aedbb4407e8ac
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteMusicPlannerMutationVariables = {|
  input: DeleteMusicPlannerInput
|};
export type ActionsComponent_deleteMusicPlannerMutationResponse = {|
  +deleteMusicPlanner: ?{|
    +deletedMusicPlannerId: ?string
  |}
|};
export type ActionsComponent_deleteMusicPlannerMutation = {|
  variables: ActionsComponent_deleteMusicPlannerMutationVariables,
  response: ActionsComponent_deleteMusicPlannerMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteMusicPlannerMutation(
  $input: DeleteMusicPlannerInput!
) {
  deleteMusicPlanner(input: $input) {
    deletedMusicPlannerId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMusicPlanner",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteMusicPlannerInput!"
    }],
    "concreteType": "DeleteMusicPlannerPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedMusicPlannerId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteMusicPlannerMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteMusicPlannerMutation(\n  $input: DeleteMusicPlannerInput!\n) {\n  deleteMusicPlanner(input: $input) {\n    deletedMusicPlannerId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cddd86624fed02e51b25eeff35fd9609';
module.exports = node;

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 95d15c655d42e6f66fb8b6c0060bda71
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SaveMusicPlannerAsTemplateInput = {
  clientMutationId?: ?string,
  music_planner_id: string,
};
export type ActionsComponent_saveMusicPlannerAsTemplateMutationVariables = {|
  input: SaveMusicPlannerAsTemplateInput
|};
export type ActionsComponent_saveMusicPlannerAsTemplateMutationResponse = {|
  +saveMusicPlannerAsTemplate: ?{|
    +mp_template: ?{|
      +id: string
    |}
  |}
|};
export type ActionsComponent_saveMusicPlannerAsTemplateMutation = {|
  variables: ActionsComponent_saveMusicPlannerAsTemplateMutationVariables,
  response: ActionsComponent_saveMusicPlannerAsTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_saveMusicPlannerAsTemplateMutation(
  $input: SaveMusicPlannerAsTemplateInput!
) {
  saveMusicPlannerAsTemplate(input: $input) {
    mp_template {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SaveMusicPlannerAsTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "saveMusicPlannerAsTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "SaveMusicPlannerAsTemplateInput!"
    }],
    "concreteType": "SaveMusicPlannerAsTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_saveMusicPlannerAsTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_saveMusicPlannerAsTemplateMutation(\n  $input: SaveMusicPlannerAsTemplateInput!\n) {\n  saveMusicPlannerAsTemplate(input: $input) {\n    mp_template {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_saveMusicPlannerAsTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_saveMusicPlannerAsTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7175f098e3f94bc2309ae3feeaa45cb9';
module.exports = node;

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 928b1c74756625541d44fdd5181161e1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_MP_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_MP_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
      +logo_handle: ?string,
      +logo_size: ?number,
      +logo_mimetype: ?string,
    |}
  |}
|};
export type Brand_MP_deleteLogo_updateBrandMutation = {|
  variables: Brand_MP_deleteLogo_updateBrandMutationVariables,
  response: Brand_MP_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_MP_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
      logo_handle
      logo_size
      logo_mimetype
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_handle",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_size",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_mimetype",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_MP_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_MP_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n      logo_handle\n      logo_size\n      logo_mimetype\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_MP_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_MP_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd77d71962b7a3786b8839bc3a3b3ec04';
module.exports = node;

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8c4a3a93c617cace36e8c1038feab935
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_MP_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_MP_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_MP_updateBrandMutation = {|
  variables: Brand_MP_updateBrandMutationVariables,
  response: Brand_MP_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_MP_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_MP_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_MP_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_MP_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_MP_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0dac375b68a34fc7fbae5c53907107e3';
module.exports = node;

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash eb6ebf370800c0784c53f5a57c047d56
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_MP_uploadLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_MP_uploadLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Brand_MP_uploadLogo_updateBrandMutation = {|
  variables: Brand_MP_uploadLogo_updateBrandMutationVariables,
  response: Brand_MP_uploadLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_MP_uploadLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_MP_uploadLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_MP_uploadLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_MP_uploadLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_MP_uploadLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5319ca896af9c6b1df21011c8494a3f1';
module.exports = node;

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ef762c15693fd0e32a350b5d2137b49d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMusicPlannerBrandInput = {
  clientMutationId?: ?string,
  music_planner_id: string,
  brand_id: string,
};
export type Brand_updateMusicPlannerBrandMutationVariables = {|
  input: UpdateMusicPlannerBrandInput
|};
export type Brand_updateMusicPlannerBrandMutationResponse = {|
  +updateMusicPlannerBrand: ?{|
    +music_planner: ?{|
      +id: string,
      +brand_header: ?string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Brand_updateMusicPlannerBrandMutation = {|
  variables: Brand_updateMusicPlannerBrandMutationVariables,
  response: Brand_updateMusicPlannerBrandMutationResponse,
|};
*/

/*
mutation Brand_updateMusicPlannerBrandMutation(
  $input: UpdateMusicPlannerBrandInput!
) {
  updateMusicPlannerBrand(input: $input) {
    music_planner {
      id
      brand_header
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMusicPlannerBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMusicPlannerBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMusicPlannerBrandInput!"
    }],
    "concreteType": "UpdateMusicPlannerBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_header",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_updateMusicPlannerBrandMutation",
    "id": null,
    "text": "mutation Brand_updateMusicPlannerBrandMutation(\n  $input: UpdateMusicPlannerBrandInput!\n) {\n  updateMusicPlannerBrand(input: $input) {\n    music_planner {\n      id\n      brand_header\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_updateMusicPlannerBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_updateMusicPlannerBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5e0220241d3d4bac5911976d4045193e';
module.exports = node;

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash cc1fabe44b0c66c8e54f8535ba8ef55d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Description_MusicPlanner_UpdateMusicPlannerMutationVariables = {|
  input: UpdateMusicPlannerInput
|};
export type Description_MusicPlanner_UpdateMusicPlannerMutationResponse = {|
  +updateMusicPlanner: ?{|
    +music_planner: ?{|
      +description: ?string
    |}
  |}
|};
export type Description_MusicPlanner_UpdateMusicPlannerMutation = {|
  variables: Description_MusicPlanner_UpdateMusicPlannerMutationVariables,
  response: Description_MusicPlanner_UpdateMusicPlannerMutationResponse,
|};
*/

/*
mutation Description_MusicPlanner_UpdateMusicPlannerMutation(
  $input: UpdateMusicPlannerInput!
) {
  updateMusicPlanner(input: $input) {
    music_planner {
      description
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateMusicPlannerInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Description_MusicPlanner_UpdateMusicPlannerMutation",
    "id": null,
    "text": "mutation Description_MusicPlanner_UpdateMusicPlannerMutation(\n  $input: UpdateMusicPlannerInput!\n) {\n  updateMusicPlanner(input: $input) {\n    music_planner {\n      description\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Description_MusicPlanner_UpdateMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMusicPlanner",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMusicPlannerPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Description_MusicPlanner_UpdateMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMusicPlanner",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMusicPlannerPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b71385665cd17937bf9c8a7912fe193e';
module.exports = node;

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 40ace25e536a72ad1152f02bfc8779e4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_MusicPlanner_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_MusicPlanner_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_MusicPlanner_Logo_updateBrandMutation = {|
  variables: Logo_MusicPlanner_Logo_updateBrandMutationVariables,
  response: Logo_MusicPlanner_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_MusicPlanner_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_MusicPlanner_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_MusicPlanner_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_MusicPlanner_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_MusicPlanner_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f57694d7db8ef6b7507dab94d18ba715';
module.exports = node;

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bd187d823c08757545fe446f5447bcc5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_MusicPlanner_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_MusicPlanner_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_MusicPlanner_deleteLogo_updateBrandMutation = {|
  variables: Logo_MusicPlanner_deleteLogo_updateBrandMutationVariables,
  response: Logo_MusicPlanner_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_MusicPlanner_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_MusicPlanner_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_MusicPlanner_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_MusicPlanner_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_MusicPlanner_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd661a328f77971b8ce7e0e22c5481a6c';
module.exports = node;

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e1235add59664b8428d95cabe52c52b5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMusicPlannerBrandInput = {
  clientMutationId?: ?string,
  music_planner_id: string,
  brand_id: string,
};
export type Logo_updateMusicPlannerBrandMutationVariables = {|
  input: UpdateMusicPlannerBrandInput
|};
export type Logo_updateMusicPlannerBrandMutationResponse = {|
  +updateMusicPlannerBrand: ?{|
    +music_planner: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateMusicPlannerBrandMutation = {|
  variables: Logo_updateMusicPlannerBrandMutationVariables,
  response: Logo_updateMusicPlannerBrandMutationResponse,
|};
*/

/*
mutation Logo_updateMusicPlannerBrandMutation(
  $input: UpdateMusicPlannerBrandInput!
) {
  updateMusicPlannerBrand(input: $input) {
    music_planner {
      id
      brand_logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMusicPlannerBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMusicPlannerBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMusicPlannerBrandInput!"
    }],
    "concreteType": "UpdateMusicPlannerBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "brand_logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_updateMusicPlannerBrandMutation",
    "id": null,
    "text": "mutation Logo_updateMusicPlannerBrandMutation(\n  $input: UpdateMusicPlannerBrandInput!\n) {\n  updateMusicPlannerBrand(input: $input) {\n    music_planner {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_updateMusicPlannerBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_updateMusicPlannerBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '58aceacfdbc7b5b32e2a3ccb52101224';
module.exports = node;

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 568429a2c7e74c26b4018ca8fe9818bd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MusicPlannerContainer_node$ref = any;
export type UpdatePlannerPlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutationVariables = {|
  input: UpdatePlannerPlaylistInput
|};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutationResponse = {|
  +updatePlannerPlaylist: ?{|
    +music_planner: ?{|
      +$fragmentRefs: MusicPlannerContainer_node$ref
    |}
  |}
|};
export type MusicPlannerComponent_UpdatePlannerPlaylistMutation = {|
  variables: MusicPlannerComponent_UpdatePlannerPlaylistMutationVariables,
  response: MusicPlannerComponent_UpdatePlannerPlaylistMutationResponse,
|};
*/

/*
mutation MusicPlannerComponent_UpdatePlannerPlaylistMutation(
  $input: UpdatePlannerPlaylistInput!
) {
  updatePlannerPlaylist(input: $input) {
    music_planner {
      ...MusicPlannerContainer_node
      id
    }
  }
}

fragment MusicPlannerContainer_node on MusicPlanner {
  id
  title
  description
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  planner_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlannerPlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlannerPlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
    "id": null,
    "text": "mutation MusicPlannerComponent_UpdatePlannerPlaylistMutation(\n  $input: UpdatePlannerPlaylistInput!\n) {\n  updatePlannerPlaylist(input: $input) {\n    music_planner {\n      ...MusicPlannerContainer_node\n      id\n    }\n  }\n}\n\nfragment MusicPlannerContainer_node on MusicPlanner {\n  id\n  title\n  description\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  planner_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlannerPlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MusicPlannerContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MusicPlannerComponent_UpdatePlannerPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlannerPlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlists",
            "storageKey": "planner_playlists(first:99999)",
            "args": v5,
            "concreteType": "PlannerPlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylist",
                "plural": false,
                "selections": [v2, v4, v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "thumbnail",
                  "storageKey": "thumbnail(height:240,width:240)",
                  "args": [{
                    "kind": "Literal",
                    "name": "height",
                    "value": 240,
                    "type": "Int"
                  }, {
                    "kind": "Literal",
                    "name": "width",
                    "value": 240,
                    "type": "Int"
                  }],
                  "concreteType": "SongImage",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "width",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "height",
                    "args": null,
                    "storageKey": null
                  }, v2]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "planner_playlists",
            "args": v5,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlists",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "first_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "last_name",
                          "args": null,
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '37be6231ee99f898b35f681037b445b1';
module.exports = node;

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 208ade13bf4e4fad97f14ae8869ed4f9
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddMusicPlannerToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type MusicPlannerComponent_addMusicPlannerToSessionMutationVariables = {|
  input: AddMusicPlannerToSessionInput
|};
export type MusicPlannerComponent_addMusicPlannerToSessionMutationResponse = {|
  +addMusicPlannerToSession: ?{|
    +music_planner: ?{|
      +id: string
    |}
  |}
|};
export type MusicPlannerComponent_addMusicPlannerToSessionMutation = {|
  variables: MusicPlannerComponent_addMusicPlannerToSessionMutationVariables,
  response: MusicPlannerComponent_addMusicPlannerToSessionMutationResponse,
|};
*/

/*
mutation MusicPlannerComponent_addMusicPlannerToSessionMutation(
  $input: AddMusicPlannerToSessionInput!
) {
  addMusicPlannerToSession(input: $input) {
    music_planner {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddMusicPlannerToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addMusicPlannerToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddMusicPlannerToSessionInput!"
    }],
    "concreteType": "AddMusicPlannerToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MusicPlannerComponent_addMusicPlannerToSessionMutation",
    "id": null,
    "text": "mutation MusicPlannerComponent_addMusicPlannerToSessionMutation(\n  $input: AddMusicPlannerToSessionInput!\n) {\n  addMusicPlannerToSession(input: $input) {\n    music_planner {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MusicPlannerComponent_addMusicPlannerToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MusicPlannerComponent_addMusicPlannerToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ba0c5aa9c6361551885cc06f6c4e7e60';
module.exports = node;

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9833ce6e5fd20960ac025dc551a83e69
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type CreatePlannerPlaylistInput = {
  clientMutationId?: ?string,
  music_planner_id: string,
  title: string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MusicPlannerComponent_createPlannerPlaylistMutationVariables = {|
  input: CreatePlannerPlaylistInput
|};
export type MusicPlannerComponent_createPlannerPlaylistMutationResponse = {|
  +createPlannerPlaylist: ?{|
    +new_planner_playlist_edge: ?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: PlannerPlaylistContainer_node$ref,
      |}
    |}
  |}
|};
export type MusicPlannerComponent_createPlannerPlaylistMutation = {|
  variables: MusicPlannerComponent_createPlannerPlaylistMutationVariables,
  response: MusicPlannerComponent_createPlannerPlaylistMutationResponse,
|};
*/

/*
mutation MusicPlannerComponent_createPlannerPlaylistMutation(
  $input: CreatePlannerPlaylistInput!
) {
  createPlannerPlaylist(input: $input) {
    new_planner_playlist_edge {
      node {
        id
        ...PlannerPlaylistContainer_node
      }
    }
  }
}

fragment PlannerPlaylistContainer_node on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlannerPlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlannerPlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v2]
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v7, v8, v9]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MusicPlannerComponent_createPlannerPlaylistMutation",
    "id": null,
    "text": "mutation MusicPlannerComponent_createPlannerPlaylistMutation(\n  $input: CreatePlannerPlaylistInput!\n) {\n  createPlannerPlaylist(input: $input) {\n    new_planner_playlist_edge {\n      node {\n        id\n        ...PlannerPlaylistContainer_node\n      }\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_node on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MusicPlannerComponent_createPlannerPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_planner_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [v2, {
              "kind": "FragmentSpread",
              "name": "PlannerPlaylistContainer_node",
              "args": null
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MusicPlannerComponent_createPlannerPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_planner_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [v3, v2, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "max_length",
              "args": null,
              "storageKey": null
            }, v5, v6, v10, {
              "kind": "LinkedField",
              "alias": null,
              "name": "playlist_recommendations",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Playlist",
                  "plural": false,
                  "selections": [v2, v6, v4, v10, v3]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": "playlist_songs",
              "name": "planner_playlist_songs",
              "storageKey": "planner_playlist_songs(first:99999)",
              "args": v11,
              "concreteType": "PlannerPlaylistSongConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSongEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PlannerPlaylistSong",
                  "plural": false,
                  "selections": [v2, v5, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [v12, v2, v13, v14, v15, v16, v17]
                  }, v12]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cursor",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "endCursor",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasNextPage",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }, {
              "kind": "LinkedHandle",
              "alias": "playlist_songs",
              "name": "planner_playlist_songs",
              "args": v11,
              "handle": "connection",
              "key": "MusicPlannerContainer_planner_playlist_songs",
              "filters": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "music_planner",
              "storageKey": null,
              "args": null,
              "concreteType": "MusicPlanner",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song_search",
              "storageKey": "song_search(first:10,query:\"\")",
              "args": [{
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "query",
                "value": "",
                "type": "String!"
              }],
              "concreteType": "SongConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SongEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v12, v2, v14, v15, v16, v13, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "duration_ms",
                    "args": null,
                    "storageKey": null
                  }, v17, {
                    "kind": "InlineFragment",
                    "type": "SpotifySong",
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_source",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_data",
                      "args": null,
                      "storageKey": null
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd4266ac69f7f75a14b68aed600e89b97';
module.exports = node;

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7d772a5650e91b16e3b9c009a5f7ea38
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MusicPlannerContainer_RefetchQueryVariables = {|
  id: string
|};
export type MusicPlannerContainer_RefetchQueryResponse = {|
  +node: ?{|
    +id?: string
  |}
|};
export type MusicPlannerContainer_RefetchQuery = {|
  variables: MusicPlannerContainer_RefetchQueryVariables,
  response: MusicPlannerContainer_RefetchQueryResponse,
|};
*/

/*
query MusicPlannerContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on MusicPlanner {
      id
    }
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "MusicPlannerContainer_RefetchQuery",
    "id": null,
    "text": "query MusicPlannerContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on MusicPlanner {\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MusicPlannerContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "type": "MusicPlanner",
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MusicPlannerContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5b59d13c05a1351732059209cbec2403';
module.exports = node;

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type Share_event$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MusicPlannerContainer_node$ref: FragmentReference;
export type MusicPlannerContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +notes: ?string,
  +can_edit: ?boolean,
  +can_email: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +planner_playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
        +num_songs: ?number,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +$fragmentRefs: Share_event$ref,
        |},
      |}
    |}>
  |},
  +$refType: MusicPlannerContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "MusicPlannerContainer_node",
    "type": "MusicPlanner",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["planner_playlists"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "can_email",
      "args": null,
      "storageKey": null
    }, v0, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "share_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "planner_playlists",
      "name": "__MusicPlannerContainer_planner_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlannerPlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlannerPlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v0, v2, v1, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "width",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "height",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "num_songs",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, {
              "kind": "FragmentSpread",
              "name": "Share_event",
              "args": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a7d6ad22143ba9658fc389975460bd72';
module.exports = node;

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MusicPlannerContainer_viewer$ref: FragmentReference;
export type MusicPlannerContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: MusicPlannerContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "MusicPlannerContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '8a60bd942ffde9e585d071e9963e6c6b';
module.exports = node;

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0b80ed2803e2fce1efc92499877d8376
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FillMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
  notes?: ?string,
};
export type Notes_FillMusicPlannerMutationVariables = {|
  input: FillMusicPlannerInput
|};
export type Notes_FillMusicPlannerMutationResponse = {|
  +fillMusicPlanner: ?{|
    +music_planner: ?{|
      +id: string,
      +notes: ?string,
    |}
  |}
|};
export type Notes_FillMusicPlannerMutation = {|
  variables: Notes_FillMusicPlannerMutationVariables,
  response: Notes_FillMusicPlannerMutationResponse,
|};
*/

/*
mutation Notes_FillMusicPlannerMutation(
  $input: FillMusicPlannerInput!
) {
  fillMusicPlanner(input: $input) {
    music_planner {
      id
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "FillMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "fillMusicPlanner",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "FillMusicPlannerInput!"
    }],
    "concreteType": "FillMusicPlannerPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Notes_FillMusicPlannerMutation",
    "id": null,
    "text": "mutation Notes_FillMusicPlannerMutation(\n  $input: FillMusicPlannerInput!\n) {\n  fillMusicPlanner(input: $input) {\n    music_planner {\n      id\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Notes_FillMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Notes_FillMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '53785c4ad2a66cff2b071545046f2277';
module.exports = node;

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9b450a0c5402f62f3ad075c948b0c0d5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type PlannerPlaylistContainer_RefetchQueryVariables = {|
  query: string,
  playlist_id: string,
|};
export type PlannerPlaylistContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: PlannerPlaylistContainer_node$ref
  |}
|};
export type PlannerPlaylistContainer_RefetchQuery = {|
  variables: PlannerPlaylistContainer_RefetchQueryVariables,
  response: PlannerPlaylistContainer_RefetchQueryResponse,
|};
*/

/*
query PlannerPlaylistContainer_RefetchQuery(
  $query: String!
  $playlist_id: ID!
) {
  node(id: $playlist_id) {
    __typename
    ...PlannerPlaylistContainer_node_1Qr5xf
    id
  }
}

fragment PlannerPlaylistContainer_node_1Qr5xf on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: $query) {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "playlist_id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "playlist_id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v8, v9, v10, v3]
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v8, v9, v10]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "PlannerPlaylistContainer_RefetchQuery",
    "id": null,
    "text": "query PlannerPlaylistContainer_RefetchQuery(\n  $query: String!\n  $playlist_id: ID!\n) {\n  node(id: $playlist_id) {\n    __typename\n    ...PlannerPlaylistContainer_node_1Qr5xf\n    id\n  }\n}\n\nfragment PlannerPlaylistContainer_node_1Qr5xf on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: $query) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylistContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PlannerPlaylistContainer_node",
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylistContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "PlannerPlaylist",
          "selections": [v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v6, v7, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v7, v5, v11, v4]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "storageKey": "planner_playlist_songs(first:99999)",
            "args": v12,
            "concreteType": "PlannerPlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [v3, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v13, v14, v15, v16, v17]
                }, v2]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "args": v12,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": null,
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Variable",
              "name": "query",
              "variableName": "query",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '22ab65c5a4def36a1543e128de711084';
module.exports = node;

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlannerPlaylistContainer_node$ref: FragmentReference;
export type PlannerPlaylistContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +max_length: ?number,
  +position: ?number,
  +num_songs: ?number,
  +thumbnail: ?{|
    +url: ?string,
    +width: ?number,
    +height: ?number,
  |},
  +playlist_recommendations: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
        +num_songs: ?number,
      |}
    |}>
  |},
  +playlist_songs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +__typename: string,
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +album: ?string,
          +artist: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +music_planner: ?{|
    +id: string,
    +can_edit: ?boolean,
  |},
  +song_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +album: ?string,
        +artist: ?string,
        +isrc: ?string,
        +duration_ms: ?number,
        +song_images: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +url: ?string,
              +width: ?number,
              +height: ?number,
            |}
          |}>
        |},
        +external_id?: ?string,
        +external_source?: ?string,
        +external_data?: ?string,
      |}
    |}>
  |},
  +$refType: PlannerPlaylistContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v5, v6, v7]
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v1, v5, v6, v7]
      }]
    }]
  };
  return {
    "kind": "Fragment",
    "name": "PlannerPlaylistContainer_node",
    "type": "PlannerPlaylist",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlist_songs"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    }],
    "selections": [v0, v1, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "max_length",
      "args": null,
      "storageKey": null
    }, v3, v4, v8, {
      "kind": "LinkedField",
      "alias": null,
      "name": "playlist_recommendations",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v1, v4, v2, v8, v0]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": "playlist_songs",
      "name": "__MusicPlannerContainer_planner_playlist_songs_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlannerPlaylistSongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlannerPlaylistSongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistSong",
          "plural": false,
          "selections": [v1, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v9, v1, v10, v11, v12, v13, v14]
          }, v9]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "can_edit",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "song_search",
      "storageKey": null,
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 10,
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String!"
      }],
      "concreteType": "SongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "SongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [v1, v11, v12, v13, v10, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration_ms",
            "args": null,
            "storageKey": null
          }, v14, {
            "kind": "InlineFragment",
            "type": "SpotifySong",
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "external_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_data",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '63f67c36c7364abab1dd8edcc8cedeb3';
module.exports = node;

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlannerPlaylistContainer_viewer$ref: FragmentReference;
export type PlannerPlaylistContainer_viewer = {|
  +id: string,
  +playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +public_playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +$refType: PlannerPlaylistContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "PlannerPlaylistContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlists"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "playlists",
      "name": "__PlannerPlaylistContainer_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, v1, v2, v3, v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "public_playlists",
      "storageKey": "public_playlists(first:99999)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 99999,
        "type": "Int"
      }],
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, v1, v2, v3, v4, v5]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '4a1ad43465957dbdb84b88fb81dcacd6';
module.exports = node;

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 65dce55431204db506ce54951b341b5c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlannerPlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutationVariables = {|
  input: UpdatePlannerPlaylistInput
|};
export type PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutationResponse = {|
  +updatePlannerPlaylist: ?{|
    +planner_playlist: ?{|
      +id: string,
      +max_length: ?number,
    |}
  |}
|};
export type PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation = {|
  variables: PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutationVariables,
  response: PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation(
  $input: UpdatePlannerPlaylistInput!
) {
  updatePlannerPlaylist(input: $input) {
    planner_playlist {
      id
      max_length
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlannerPlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePlannerPlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdatePlannerPlaylistInput!"
    }],
    "concreteType": "UpdatePlannerPlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "planner_playlist",
      "storageKey": null,
      "args": null,
      "concreteType": "PlannerPlaylist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "max_length",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation(\n  $input: UpdatePlannerPlaylistInput!\n) {\n  updatePlannerPlaylist(input: $input) {\n    planner_playlist {\n      id\n      max_length\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_MaxLength_UpdatePlannerPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7849c7c6c646d1aa89acaf2f87d401e9';
module.exports = node;

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9ef51a471832e787f45820ddf78fa1a7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlannerPlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type PlannerPlaylist_UpdatePlannerPlaylistMutationVariables = {|
  input: UpdatePlannerPlaylistInput
|};
export type PlannerPlaylist_UpdatePlannerPlaylistMutationResponse = {|
  +updatePlannerPlaylist: ?{|
    +planner_playlist: ?{|
      +id: string,
      +title: ?string,
      +description: ?string,
      +position: ?number,
      +max_length: ?number,
    |}
  |}
|};
export type PlannerPlaylist_UpdatePlannerPlaylistMutation = {|
  variables: PlannerPlaylist_UpdatePlannerPlaylistMutationVariables,
  response: PlannerPlaylist_UpdatePlannerPlaylistMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_UpdatePlannerPlaylistMutation(
  $input: UpdatePlannerPlaylistInput!
) {
  updatePlannerPlaylist(input: $input) {
    planner_playlist {
      id
      title
      description
      position
      max_length
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlannerPlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePlannerPlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdatePlannerPlaylistInput!"
    }],
    "concreteType": "UpdatePlannerPlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "planner_playlist",
      "storageKey": null,
      "args": null,
      "concreteType": "PlannerPlaylist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "position",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "max_length",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_UpdatePlannerPlaylistMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_UpdatePlannerPlaylistMutation(\n  $input: UpdatePlannerPlaylistInput!\n) {\n  updatePlannerPlaylist(input: $input) {\n    planner_playlist {\n      id\n      title\n      description\n      position\n      max_length\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_UpdatePlannerPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_UpdatePlannerPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f2b64790a0260928a7c26b0dca04a345';
module.exports = node;

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 30cb1c9ebc8d75ec1a7edab64d8cbd52
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type AddPlannerPlaylistRecommendationsInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  playlist_ids: $ReadOnlyArray<?string>,
};
export type PlannerPlaylist_addPlannerPlaylistRecommendationsMutationVariables = {|
  input: AddPlannerPlaylistRecommendationsInput
|};
export type PlannerPlaylist_addPlannerPlaylistRecommendationsMutationResponse = {|
  +addPlannerPlaylistRecommendations: ?{|
    +planner_playlist: ?{|
      +$fragmentRefs: PlannerPlaylistContainer_node$ref
    |}
  |}
|};
export type PlannerPlaylist_addPlannerPlaylistRecommendationsMutation = {|
  variables: PlannerPlaylist_addPlannerPlaylistRecommendationsMutationVariables,
  response: PlannerPlaylist_addPlannerPlaylistRecommendationsMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_addPlannerPlaylistRecommendationsMutation(
  $input: AddPlannerPlaylistRecommendationsInput!
) {
  addPlannerPlaylistRecommendations(input: $input) {
    planner_playlist {
      ...PlannerPlaylistContainer_node
      id
    }
  }
}

fragment PlannerPlaylistContainer_node on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddPlannerPlaylistRecommendationsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "AddPlannerPlaylistRecommendationsInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v3]
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v7, v8, v9]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_addPlannerPlaylistRecommendationsMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_addPlannerPlaylistRecommendationsMutation(\n  $input: AddPlannerPlaylistRecommendationsInput!\n) {\n  addPlannerPlaylistRecommendations(input: $input) {\n    planner_playlist {\n      ...PlannerPlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_node on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_addPlannerPlaylistRecommendationsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "addPlannerPlaylistRecommendations",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddPlannerPlaylistRecommendationsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "PlannerPlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_addPlannerPlaylistRecommendationsMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "addPlannerPlaylistRecommendations",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddPlannerPlaylistRecommendationsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v6, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v6, v4, v10, v2]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "storageKey": "planner_playlist_songs(first:99999)",
            "args": v11,
            "concreteType": "PlannerPlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [v3, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v12, v3, v13, v14, v15, v16, v17]
                }, v12]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "args": v11,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v12, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2f8347891ba60b0512f5e7a31dbd62ad';
module.exports = node;

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 03c5b6befac54e9353358ebe0b41b0fd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlannerPlaylistSongInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type PlannerPlaylist_createPlannerPlaylistSongMutationVariables = {|
  input: CreatePlannerPlaylistSongInput
|};
export type PlannerPlaylist_createPlannerPlaylistSongMutationResponse = {|
  +createPlannerPlaylistSong: ?{|
    +new_planner_playlist_song_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +artist: ?string,
          +album: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |},
    +planner_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type PlannerPlaylist_createPlannerPlaylistSongMutation = {|
  variables: PlannerPlaylist_createPlannerPlaylistSongMutationVariables,
  response: PlannerPlaylist_createPlannerPlaylistSongMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_createPlannerPlaylistSongMutation(
  $input: CreatePlannerPlaylistSongInput!
) {
  createPlannerPlaylistSong(input: $input) {
    new_planner_playlist_song_edge {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          artist
          album
          song_images {
            edges {
              node {
                url
                width
                height
                id
              }
            }
          }
        }
      }
    }
    planner_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlannerPlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlannerPlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v2, v9, v10]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_createPlannerPlaylistSongMutation(\n  $input: CreatePlannerPlaylistSongInput!\n) {\n  createPlannerPlaylistSong(input: $input) {\n    new_planner_playlist_song_edge {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          artist\n          album\n          song_images {\n            edges {\n              node {\n                url\n                width\n                height\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    planner_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_planner_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v2, v4, v5, v6, v7, {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_images",
                "storageKey": null,
                "args": null,
                "concreteType": "SongImageConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SongImageEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongImage",
                    "plural": false,
                    "selections": [v8, v9, v10]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v11]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_createPlannerPlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_planner_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }, v2, v4, v5, v6, v7, {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_images",
                "storageKey": null,
                "args": null,
                "concreteType": "SongImageConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SongImageEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongImage",
                    "plural": false,
                    "selections": [v8, v9, v10, v2]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v11, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2e5157c8651beb14689e82c37541ade9';
module.exports = node;

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e94affab696f708e81eb8b7568b86795
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlannerPlaylistSongsInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  songs: $ReadOnlyArray<?SongInput>,
};
export type SongInput = {
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type PlannerPlaylist_createPlannerPlaylistSongsMutationVariables = {|
  input: CreatePlannerPlaylistSongsInput
|};
export type PlannerPlaylist_createPlannerPlaylistSongsMutationResponse = {|
  +createPlannerPlaylistSongs: ?{|
    +planner_playlist: ?{|
      +$fragmentRefs: PlannerPlaylistContainer_node$ref
    |}
  |}
|};
export type PlannerPlaylist_createPlannerPlaylistSongsMutation = {|
  variables: PlannerPlaylist_createPlannerPlaylistSongsMutationVariables,
  response: PlannerPlaylist_createPlannerPlaylistSongsMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_createPlannerPlaylistSongsMutation(
  $input: CreatePlannerPlaylistSongsInput!
) {
  createPlannerPlaylistSongs(input: $input) {
    planner_playlist {
      ...PlannerPlaylistContainer_node
      id
    }
  }
}

fragment PlannerPlaylistContainer_node on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlannerPlaylistSongsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlannerPlaylistSongsInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v3]
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v7, v8, v9]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_createPlannerPlaylistSongsMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_createPlannerPlaylistSongsMutation(\n  $input: CreatePlannerPlaylistSongsInput!\n) {\n  createPlannerPlaylistSongs(input: $input) {\n    planner_playlist {\n      ...PlannerPlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_node on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_createPlannerPlaylistSongsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "PlannerPlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_createPlannerPlaylistSongsMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlannerPlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlannerPlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v6, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v6, v4, v10, v2]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "storageKey": "planner_playlist_songs(first:99999)",
            "args": v11,
            "concreteType": "PlannerPlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [v3, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v12, v3, v13, v14, v15, v16, v17]
                }, v12]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "args": v11,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v12, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2078e61f574d3d0fa3d230800962c29f';
module.exports = node;

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bc71a44f63299bceffa4fe859421459c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlannerPlaylistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type PlannerPlaylist_deletePlannerPlaylistMutationVariables = {|
  input: DeletePlannerPlaylistInput
|};
export type PlannerPlaylist_deletePlannerPlaylistMutationResponse = {|
  +deletePlannerPlaylist: ?{|
    +deletedPlannerPlaylistId: ?string
  |}
|};
export type PlannerPlaylist_deletePlannerPlaylistMutation = {|
  variables: PlannerPlaylist_deletePlannerPlaylistMutationVariables,
  response: PlannerPlaylist_deletePlannerPlaylistMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_deletePlannerPlaylistMutation(
  $input: DeletePlannerPlaylistInput!
) {
  deletePlannerPlaylist(input: $input) {
    deletedPlannerPlaylistId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlannerPlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlannerPlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePlannerPlaylistInput!"
    }],
    "concreteType": "DeletePlannerPlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedPlannerPlaylistId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_deletePlannerPlaylistMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_deletePlannerPlaylistMutation(\n  $input: DeletePlannerPlaylistInput!\n) {\n  deletePlannerPlaylist(input: $input) {\n    deletedPlannerPlaylistId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_deletePlannerPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_deletePlannerPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8899200cd2c11f3bb782112973e02bf5';
module.exports = node;

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0ccae365141625909a3d043a13a602a5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlannerPlaylistSongInput = {
  clientMutationId?: ?string,
  id: string,
};
export type PlannerPlaylist_deletePlannerPlaylistSongMutationVariables = {|
  input: DeletePlannerPlaylistSongInput
|};
export type PlannerPlaylist_deletePlannerPlaylistSongMutationResponse = {|
  +deletePlannerPlaylistSong: ?{|
    +deletedPlannerPlaylistSongId: ?string,
    +planner_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type PlannerPlaylist_deletePlannerPlaylistSongMutation = {|
  variables: PlannerPlaylist_deletePlannerPlaylistSongMutationVariables,
  response: PlannerPlaylist_deletePlannerPlaylistSongMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_deletePlannerPlaylistSongMutation(
  $input: DeletePlannerPlaylistSongInput!
) {
  deletePlannerPlaylistSong(input: $input) {
    deletedPlannerPlaylistSongId
    planner_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlannerPlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeletePlannerPlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedPlannerPlaylistSongId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_deletePlannerPlaylistSongMutation(\n  $input: DeletePlannerPlaylistSongInput!\n) {\n  deletePlannerPlaylistSong(input: $input) {\n    deletedPlannerPlaylistSongId\n    planner_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v4, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '323f8f1370fda0ce3e5d8d0b1f4afb83';
module.exports = node;

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 11cbfcff985c417a0803a62d8db939df
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type RemovePlannerPlaylistRecommendationInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  playlist_id: string,
};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutationVariables = {|
  input: RemovePlannerPlaylistRecommendationInput
|};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutationResponse = {|
  +removePlannerPlaylistRecommendation: ?{|
    +planner_playlist: ?{|
      +$fragmentRefs: PlannerPlaylistContainer_node$ref
    |}
  |}
|};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutation = {|
  variables: PlannerPlaylist_removePlannerPlaylistRecommendationMutationVariables,
  response: PlannerPlaylist_removePlannerPlaylistRecommendationMutationResponse,
|};
*/

/*
mutation PlannerPlaylist_removePlannerPlaylistRecommendationMutation(
  $input: RemovePlannerPlaylistRecommendationInput!
) {
  removePlannerPlaylistRecommendation(input: $input) {
    planner_playlist {
      ...PlannerPlaylistContainer_node
      id
    }
  }
}

fragment PlannerPlaylistContainer_node on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemovePlannerPlaylistRecommendationInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "RemovePlannerPlaylistRecommendationInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v3]
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v7, v8, v9]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
    "id": null,
    "text": "mutation PlannerPlaylist_removePlannerPlaylistRecommendationMutation(\n  $input: RemovePlannerPlaylistRecommendationInput!\n) {\n  removePlannerPlaylistRecommendation(input: $input) {\n    planner_playlist {\n      ...PlannerPlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_node on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "removePlannerPlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemovePlannerPlaylistRecommendationPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "PlannerPlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "removePlannerPlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemovePlannerPlaylistRecommendationPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "planner_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v6, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v6, v4, v10, v2]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "storageKey": "planner_playlist_songs(first:99999)",
            "args": v11,
            "concreteType": "PlannerPlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [v3, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v12, v3, v13, v14, v15, v16, v17]
                }, v12]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "args": v11,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v12, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c6dc96cd315da8a2e0135bbf433e7486';
module.exports = node;

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d69bb0419c263c86903e9970703bcb83
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailMusicPlannerLinkInput = {
  clientMutationId?: ?string,
  music_planner_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type Share_emailMusicPlannerLinkMutationVariables = {|
  input: EmailMusicPlannerLinkInput
|};
export type Share_emailMusicPlannerLinkMutationResponse = {|
  +emailMusicPlannerLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type Share_emailMusicPlannerLinkMutation = {|
  variables: Share_emailMusicPlannerLinkMutationVariables,
  response: Share_emailMusicPlannerLinkMutationResponse,
|};
*/

/*
mutation Share_emailMusicPlannerLinkMutation(
  $input: EmailMusicPlannerLinkInput!
) {
  emailMusicPlannerLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailMusicPlannerLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailMusicPlannerLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailMusicPlannerLinkInput!"
    }],
    "concreteType": "EmailMusicPlannerLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Share_emailMusicPlannerLinkMutation",
    "id": null,
    "text": "mutation Share_emailMusicPlannerLinkMutation(\n  $input: EmailMusicPlannerLinkInput!\n) {\n  emailMusicPlannerLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Share_emailMusicPlannerLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Share_emailMusicPlannerLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '23f15986cbba9382370485f5676b0732';
module.exports = node;

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 74fda8010af6370466e3553921d7015d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Title_UpdateMusicPlannerMutationVariables = {|
  input: UpdateMusicPlannerInput
|};
export type Title_UpdateMusicPlannerMutationResponse = {|
  +updateMusicPlanner: ?{|
    +music_planner: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_UpdateMusicPlannerMutation = {|
  variables: Title_UpdateMusicPlannerMutationVariables,
  response: Title_UpdateMusicPlannerMutationResponse,
|};
*/

/*
mutation Title_UpdateMusicPlannerMutation(
  $input: UpdateMusicPlannerInput!
) {
  updateMusicPlanner(input: $input) {
    music_planner {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateMusicPlannerInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateMusicPlannerMutation",
    "id": null,
    "text": "mutation Title_UpdateMusicPlannerMutation(\n  $input: UpdateMusicPlannerInput!\n) {\n  updateMusicPlanner(input: $input) {\n    music_planner {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMusicPlanner",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMusicPlannerPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMusicPlanner",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMusicPlannerPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "music_planner",
          "storageKey": null,
          "args": null,
          "concreteType": "MusicPlanner",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c7c26d1b321d8cb8d6256167dceade73';
module.exports = node;

/***/ }),
/* 3098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_AppComponent__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var RenameDocument = function (_React$Component) {
  _inherits(RenameDocument, _React$Component);

  function RenameDocument(props) {
    _classCallCheck(this, RenameDocument);

    var _this = _possibleConstructorReturn(this, (RenameDocument.__proto__ || Object.getPrototypeOf(RenameDocument)).call(this, props));

    _this.state = {
      loading: false,
      title: _this.props.initialTitle
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    return _this;
  }

  _createClass(RenameDocument, [{
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.setState({ loading: true });
      this.updateTitle(this.props.documentId, this.props.documentType, this.state.title);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to rename',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle(documentId, documentType, title) {
      var _this2 = this;

      var onCompleted = function onCompleted() {
        _this2.setState({ loading: false });
        _this2.props.onClose();
      };
      switch (documentType) {
        case 'Contract':
          this.updateContractTitle(documentId, title, onCompleted, onCompleted);
          break;
        case 'Estimate':
          this.updateEstimateTitle(documentId, title, onCompleted, onCompleted);
          break;
        case 'Invoice':
          this.updateInvoiceTitle(documentId, title, onCompleted, onCompleted);
          break;
        case 'Form':
          this.updateFormTitle(documentId, title, onCompleted, onCompleted);
          break;
        case 'MusicPlanner':
          this.updateMusicPlannerTitle(documentId, title, onCompleted, onCompleted);
          break;
        case 'Wupload':
          this.updateWuploadName(documentId, title, onCompleted, onCompleted);
          break;
        default:
          return;
      }
    }
  }, {
    key: 'updateContractTitle',
    value: function updateContractTitle(id, title, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update contract title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated contract title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-contract-title');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3228);
      });

      var optimisticResponse = {
        updateContract: { contract: { id: id, title: title } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            title: title
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateEstimateTitle',
    value: function updateEstimateTitle(id, title, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update estimate title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated estimate title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-estimate-title');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3229);
      });

      var optimisticResponse = {
        updateEstimate: { estimate: { id: id, title: title } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            title: title
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateInvoiceTitle',
    value: function updateInvoiceTitle(id, title, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update invoice title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated invoice title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-invoice-title');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3231);
      });

      var optimisticResponse = {
        updateInvoice: { invoice: { id: id, title: title } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            title: title
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateFormTitle',
    value: function updateFormTitle(id, title, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated form title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-form-title');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3230);
      });

      var optimisticResponse = {
        updateForm: { form: { id: id, title: title } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            title: title
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateMusicPlannerTitle',
    value: function updateMusicPlannerTitle(id, title, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update music list title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated music list title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-music-planner-title');
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3232);
      });

      var optimisticResponse = {
        updateMusicPlanner: { music_planner: { id: id, title: title } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            title: title
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateWuploadName',
    value: function updateWuploadName(id, name, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update file name',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated file name',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-wupload-name');
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3233);
      });

      var optimisticResponse = {
        updateWupload: { wupload: { id: id, name: name } }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            name: name
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          documentType = _props.documentType,
          onClose = _props.onClose;
      var loading = this.state.loading;

      var typeToLabel = {
        Contract: 'Contract',
        Estimate: 'Estimate',
        Invoice: 'Invoice',
        Form: 'Form',
        MusicPlanner: 'Music List',
        Wupload: 'File Upload'
      };

      var form = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          ref: 'form'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
          name: 'title',
          type: 'text',
          label: 'Name',
          onChange: this.titleChangeHandler,
          value: this.state.title,
          required: true,
          validationError: 'Name cannot be blank'
        })
      );

      var saveText = loading ? 'Saving...' : 'Save';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__App_AppComponent__["a" /* AppConsumer */],
        null,
        function (state) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            state.isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */],
              { open: true, onClose: onClose, size: 'small' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Header, { content: 'Rename ' + typeToLabel[documentType] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Content,
                null,
                form
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Actions,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    onClick: onClose,
                    className: __WEBPACK_IMPORTED_MODULE_7__Document_scss___default.a.modalSecondaryAction
                  },
                  'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
                  {
                    primary: true,
                    type: 'submit',
                    disabled: loading,
                    onClick: function onClick() {
                      return _this3.refs.form.submit();
                    }
                  },
                  saveText
                )
              )
            ),
            !state.isComputer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */],
              { open: true, onClose: onClose, inline: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'menu item', onClick: onClose },
                    'Cancel'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__Modules__["f" /* MobileModal */].Content,
                null,
                form,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */], {
                  primary: true,
                  onClick: function onClick() {
                    return _this3.refs.form.submit();
                  },
                  content: saveText,
                  disabled: loading
                })
              )
            )
          );
        }
      );
    }
  }]);

  return RenameDocument;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RenameDocument.propTypes = {
  documentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  documentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  initialTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RenameDocument);

/***/ }),
/* 3099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailConfirmation__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShareOptions__ = __webpack_require__(1459);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ShareDocument = function (_React$Component) {
  _inherits(ShareDocument, _React$Component);

  function ShareDocument(props) {
    _classCallCheck(this, ShareDocument);

    var _this = _possibleConstructorReturn(this, (ShareDocument.__proto__ || Object.getPrototypeOf(ShareDocument)).call(this, props));

    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.getWorkspaceContactEmails = _this.getWorkspaceContactEmails.bind(_this);
    _this.toggleLink = _this.toggleLink.bind(_this);
    _this.sendEmail = _this.sendEmail.bind(_this);
    _this.state = {
      showLink: !_this.props.canEmail,
      to: '',
      cc: ''
    };
    return _this;
  }

  _createClass(ShareDocument, [{
    key: 'onOpen',
    value: function onOpen() {
      this.setState({
        open: true,
        step: 0,
        showLink: !this.props.canEmail
      });
      if (this.props.onOpen) this.props.onOpen();
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({ open: false });
      if (this.props.onClose) this.props.onClose();
    }
  }, {
    key: 'getWorkspaceContactEmails',
    value: function getWorkspaceContactEmails() {
      var contacts = [];
      var event = this.props.event;

      if (event) {
        event.user_contacts.edges.map(function (_ref) {
          var uc = _ref.node;
          return uc.user_contact_emails.edges.map(function (_ref2) {
            var email = _ref2.node;

            contacts.push({
              title: uc.first_name + ' ' + uc.last_name,
              description: email.address,
              value: email.address
            });
            return email;
          });
        });
      }
      return contacts;
    }
  }, {
    key: 'toggleLink',
    value: function toggleLink() {
      this.setState(function (prevState) {
        return { showLink: !prevState.showLink };
      });
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(model, resetForm, invalidateForm, successCb) {
      this.setState({ to: model.to, cc: model.cc });
      this.props.sendEmail(model, successCb);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showLink = _state.showLink,
          to = _state.to,
          cc = _state.cc;
      var _props = this.props,
          canEmail = _props.canEmail,
          title = _props.title,
          shareUrl = _props.shareUrl,
          documentType = _props.documentType,
          permissionsNode = _props.permissionsNode,
          trigger = _props.trigger;


      var steps = [{
        component: __WEBPACK_IMPORTED_MODULE_4__ShareOptions__["a" /* default */],
        componentProps: {
          permissionsNode: permissionsNode,
          documentType: documentType,
          shareUrl: shareUrl,
          emailSuggestions: this.getWorkspaceContactEmails(),
          showLink: showLink,
          toggleLink: this.toggleLink,
          canEmail: canEmail
        },
        title: title,
        actions: {
          primary: {
            content: showLink ? 'Close' : 'Send Email',
            type: showLink ? 'button' : 'submit'
          },
          secondary: { hide: showLink }
        },
        formProps: {
          onValidSubmit: this.sendEmail,
          autoComplete: 'off'
        }
      }];

      if (!showLink) {
        steps.push({
          component: __WEBPACK_IMPORTED_MODULE_3__EmailConfirmation__["a" /* default */],
          componentProps: { documentType: documentType, to: to, cc: cc, onClose: this.onClose },
          title: title,
          hideActions: true
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["e" /* Wizard */], {
        steps: steps,
        trigger: trigger,
        onOpen: this.onOpen,
        onClose: this.onClose
      });
    }
  }]);

  return ShareDocument;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ShareDocument.propTypes = {
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  canEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shareUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  documentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  permissionsNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  sendEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ShareDocument);

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Share_event$ref: FragmentReference;
export type Share_event = {|
  +user_contacts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +address: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: Share_event$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Share_event",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "user_contacts",
    "storageKey": null,
    "args": null,
    "concreteType": "EventUserContactConnectionWithRole",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "EventUserContactEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContact",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_emails",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactEmailConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEmailEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactEmail",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '5426302ece3c04444e22dd69f680035a';
module.exports = node;

/***/ }),
/* 3101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Brand_scss__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Brand_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Brand_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BrandFields__ = __webpack_require__(1460);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BrandEditDesktop = function (_React$Component) {
  _inherits(BrandEditDesktop, _React$Component);

  function BrandEditDesktop(props) {
    _classCallCheck(this, BrandEditDesktop);

    var _this = _possibleConstructorReturn(this, (BrandEditDesktop.__proto__ || Object.getPrototypeOf(BrandEditDesktop)).call(this, props));

    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.state = {
      submitted: false
    };
    return _this;
  }

  _createClass(BrandEditDesktop, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.closeHandler);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update brand settings',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset();
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          className: __WEBPACK_IMPORTED_MODULE_5__Brand_scss___default.a.active
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { padded: true, relaxed: true, stackable: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { columns: 1 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BrandFields__["a" /* default */], {
                selectedBrand: this.props.selectedBrand,
                localBrand: this.props.localBrand,
                onChange: this.props.onChange,
                submitted: this.state.submitted
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], { reset: this.reset })
            )
          )
        )
      );
    }
  }]);

  return BrandEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrandEditDesktop.propTypes = {
  selectedBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (BrandEditDesktop);

/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrandFields__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BrandEditMobile = function (_React$Component) {
  _inherits(BrandEditMobile, _React$Component);

  function BrandEditMobile(props) {
    _classCallCheck(this, BrandEditMobile);

    var _this = _possibleConstructorReturn(this, (BrandEditMobile.__proto__ || Object.getPrototypeOf(BrandEditMobile)).call(this, props));

    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.state = {
      submitted: false
    };
    return _this;
  }

  _createClass(BrandEditMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(function () {
        setTimeout(function () {
          return _this2.props.closeHandler();
        }, 0);
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update brand settings',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this3 = this;

      this.props.reset();
      setTimeout(function () {
        return _this3.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        {
          ref: 'form',
          className: 'ui form',
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this4.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BrandFields__["a" /* default */], {
              selectedBrand: this.props.selectedBrand,
              localBrand: this.props.localBrand,
              onChange: this.props.onChange,
              submitted: this.state.submitted
            })
          )
        )
      );
    }
  }]);

  return BrandEditMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrandEditMobile.propTypes = {
  selectedBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (BrandEditMobile);

/***/ }),
/* 3103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_location__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Brand_scss__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Brand_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Brand_scss__);






var BrandShow = function BrandShow(_ref) {
  var selectedBrand = _ref.selectedBrand,
      readOnly = _ref.readOnly;

  var exists = selectedBrand.brand_header;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    exists && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: [__WEBPACK_IMPORTED_MODULE_4__Brand_scss___default.a.header, !readOnly ? __WEBPACK_IMPORTED_MODULE_4__Brand_scss___default.a.headerEdit : ''].join(' ') },
      selectedBrand.brand_header && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: selectedBrand.brand_header } })
    ),
    !exists && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Your Company Name'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.subtext },
        '(555) 555-1212'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.subtext },
        'info@yourcompany.com'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.subtext },
        '123 Elm Street'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.subtext },
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_location__["a" /* default */].getLocalityString('San Francisco', 'CA', '94105')
      )
    )
  );
};

BrandShow.propTypes = {
  selectedBrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (BrandShow);

/***/ }),
/* 3104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);





var DescriptionEditDesktop = function DescriptionEditDesktop(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      _reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
    { onSubmit: commitUpdate.bind(null, closeHandler) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
      extended: true,
      modules: {
        toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']]
      },
      formats: ['bold', 'italic', 'link', 'list', 'header'],
      value: value || '',
      onChange: onChange,
      placeholder: 'Description, message, or instructions...'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["j" /* DthcActions */], { reset: function reset(e) {
        _reset();closeHandler(e);e.stopPropagation();
      } })
  );
};

DescriptionEditDesktop.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (DescriptionEditDesktop);

/***/ }),
/* 3105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);





var DescriptionEditMobile = function DescriptionEditMobile(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      open = _ref.open,
      reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
    { open: open, onClose: closeHandler, inline: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: 'item',
            onClick: function onClick(e) {
              reset();
              setTimeout(function () {
                return closeHandler(e);
              }, 0);
            }
          },
          'Cancel'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'right menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'item', onClick: commitUpdate.bind(null, closeHandler) },
          'Save'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { onSubmit: commitUpdate.bind(null, closeHandler) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
          extended: true,
          modules: {
            toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']]
          },
          value: value || '',
          onChange: onChange,
          placeholder: 'Description, message, or instructions...'
        })
      )
    )
  );
};

DescriptionEditMobile.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (DescriptionEditMobile);

/***/ }),
/* 3106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LibraryDesktop__ = __webpack_require__(3107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LibraryMobile__ = __webpack_require__(3108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_SlideTransition_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_SlideTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_SlideTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LibraryItemEditMobile__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ServiceLibrary = function (_React$Component) {
  _inherits(ServiceLibrary, _React$Component);

  function ServiceLibrary(props) {
    _classCallCheck(this, ServiceLibrary);

    var _this = _possibleConstructorReturn(this, (ServiceLibrary.__proto__ || Object.getPrototypeOf(ServiceLibrary)).call(this, props));

    _this.serviceSelectHandler = _this.serviceSelectHandler.bind(_this);
    _this.toggleServiceSelect = _this.toggleServiceSelect.bind(_this);
    _this.selectAll = _this.selectAll.bind(_this);
    _this.selectNone = _this.selectNone.bind(_this);
    _this.addSelected = _this.addSelected.bind(_this);
    _this.getTotalSelected = _this.getTotalSelected.bind(_this);
    _this.toggleMobileLibrary = _this.toggleMobileLibrary.bind(_this);
    _this.toggleMobileAdd = _this.toggleMobileAdd.bind(_this);
    _this.getFilteredLibrary = _this.getFilteredLibrary.bind(_this);
    _this.updateSearchQuery = _this.updateSearchQuery.bind(_this);
    _this.lineItemChangeHandler = _this.lineItemChangeHandler.bind(_this);
    _this.lineItemCheckedHandler = _this.lineItemCheckedHandler.bind(_this);
    _this.updateLibraryLineItem = _this.updateLibraryLineItem.bind(_this);
    _this.deleteLibraryLineItem = _this.deleteLibraryLineItem.bind(_this);
    _this.resetEditLibraryLineItem = _this.resetEditLibraryLineItem.bind(_this);
    _this.getLocalLineItems = _this.getLocalLineItems.bind(_this);
    _this.state = {
      searchQuery: '',
      showMobileAdd: false,
      showMobileLibrary: false,
      localLibraryLineItems: _this.props.viewer ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.viewer.user_line_items.edges) : []
    };
    return _this;
  }

  _createClass(ServiceLibrary, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localLibraryLineItems if any edges are added/deleted
      if (this.state.localLibraryLineItems.length !== nextProps.viewer.user_line_items.edges.length) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
        obj.localLibraryLineItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.viewer.user_line_items.edges);
        this.setState(_extends({}, obj));
      }
    }
  }, {
    key: 'getLocalLineItems',
    value: function getLocalLineItems() {
      return this.getFilteredLibrary(this.state.localLibraryLineItems, this.state.searchQuery);
    }
  }, {
    key: 'getFilteredLibrary',
    value: function getFilteredLibrary(library, query) {
      return library.filter(function (item) {
        return item.node.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    }
  }, {
    key: 'getTotalSelected',
    value: function getTotalSelected() {
      var libraryLineItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.localLibraryLineItems);
      var selected = 0;
      libraryLineItems.map(function (lineItem) {
        if (lineItem.checked) selected += 1;
        return lineItem;
      });
      return selected;
    }

    // Handler for Semantic UI checkbox element

  }, {
    key: 'serviceSelectHandler',
    value: function serviceSelectHandler(idx, e, data) {
      var localLibraryItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.getLocalLineItems()[idx]);
      localLibraryItem.checked = data.checked;
      this.lineItemCheckedHandler(localLibraryItem, idx);
    }

    // Handler for selectable div touch target

  }, {
    key: 'toggleServiceSelect',
    value: function toggleServiceSelect(idx) {
      var localLibraryItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.getLocalLineItems()[idx]);
      localLibraryItem.checked = !localLibraryItem.checked;
      this.lineItemCheckedHandler(localLibraryItem, idx);
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var _this2 = this;

      this.getLocalLineItems().map(function (lineItem, idx) {
        _this2.lineItemCheckedHandler(Object.assign({}, lineItem, { checked: true }), idx);
        return lineItem;
      });
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      var localLibraryLineItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.localLibraryLineItems);
      localLibraryLineItems.map(function (lineItem, idx) {
        localLibraryLineItems[idx].checked = false;
        return lineItem;
      });
      this.setState({ localLibraryLineItems: localLibraryLineItems });
    }
  }, {
    key: 'addSelected',
    value: function addSelected() {
      var itemsToCopy = this.state.localLibraryLineItems.filter(function (lineItem) {
        return lineItem.checked;
      }).map(function (lineItem) {
        return lineItem.node.id;
      });
      this.props.copyLibraryLineItemsToDocument(itemsToCopy);
      this.selectNone();
    }
  }, {
    key: 'toggleMobileLibrary',
    value: function toggleMobileLibrary(showMobileLibrary) {
      if (typeof showMobileLibrary === 'boolean') {
        this.setState({ showMobileLibrary: showMobileLibrary });
      } else {
        this.setState({ showMobileLibrary: !this.state.showMobileLibrary });
      }
    }
  }, {
    key: 'toggleMobileAdd',
    value: function toggleMobileAdd(showMobileAdd) {
      var addToLibrary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (typeof showMobileAdd === 'boolean') {
        this.setState({ showMobileAdd: showMobileAdd });
      } else {
        this.setState({ showMobileAdd: !this.state.showMobileAdd });
      }
      this.props.newLibraryLineItemChangeHandler(Object.assign({}, this.props.newLibraryLineItem, { addToLibrary: addToLibrary }));
    }
  }, {
    key: 'updateSearchQuery',
    value: function updateSearchQuery(e) {
      this.setState({ searchQuery: e.target.value });
    }

    // Handles changes to a library line item node

  }, {
    key: 'lineItemChangeHandler',
    value: function lineItemChangeHandler(lineItem, idx) {
      var id = this.getLocalLineItems()[idx].node.id;
      var localLibraryLineItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.localLibraryLineItems);
      localLibraryLineItems.map(function (localLineItem, index) {
        if (localLineItem.node.id === id) {
          localLibraryLineItems[index].node = lineItem;
        }
        return localLineItem;
      });
      this.setState({ localLibraryLineItems: localLibraryLineItems });
    }

    // Handles whether a library line item is checked or not

  }, {
    key: 'lineItemCheckedHandler',
    value: function lineItemCheckedHandler(lineItem, idx) {
      var id = this.getLocalLineItems()[idx].node.id;
      this.setState(function (prevState) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(prevState);
        obj.localLibraryLineItems.map(function (localLineItem, index) {
          if (localLineItem.node.id === id) {
            obj.localLibraryLineItems[index] = lineItem;
          }
          return localLineItem;
        });
        return obj;
      });
    }
  }, {
    key: 'updateLibraryLineItem',
    value: function updateLibraryLineItem(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_11__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update line item',
          intent: __WEBPACK_IMPORTED_MODULE_11__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_11__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated line item',
          intent: __WEBPACK_IMPORTED_MODULE_11__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_11__Modules__["c" /* Analytics */].trackEvent('updated-library-line-item');
      };
      var lineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.getLocalLineItems()[idx].node), ['id', 'description', 'position', 'price_cents', 'price_currency', 'quantity', 'title']);

      lineItem.quantity = parseInt(lineItem.quantity, 10);

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3111);
      });

      var optimisticResponse = {
        updateUserLineItem: { user_line_item: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(lineItem) }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, lineItem)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteLibraryLineItem',
    value: function deleteLibraryLineItem(idx, successCb, failureCb) {
      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_11__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete line item',
          intent: __WEBPACK_IMPORTED_MODULE_11__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_11__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted line item',
          intent: __WEBPACK_IMPORTED_MODULE_11__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_11__Modules__["c" /* Analytics */].trackEvent('deleted-library-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3110);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.viewer.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['viewer', 'user_line_items'],
        deletedIDFieldName: 'deletedUserLineItemId',
        connectionKeys: [{
          key: 'LibraryContainer_user_line_items',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.getLocalLineItems()[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetEditLibraryLineItem',
    value: function resetEditLibraryLineItem(idx) {
      var _this3 = this;

      var id = this.getLocalLineItems()[idx].node.id;
      var localLibraryLineItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.localLibraryLineItems);
      localLibraryLineItems.map(function (localLineItem, index) {
        if (localLineItem.node.id === id) {
          localLibraryLineItems[index].node = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.props.viewer.user_line_items.edges[idx].node);
        }
        return localLineItem;
      });
      this.setState({ localLibraryLineItems: localLibraryLineItems });
    }
  }, {
    key: 'render',
    value: function render() {
      var userLineItems = this.props.viewer.user_line_items.edges;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__globals_scss___default.a.desktop },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LibraryDesktop__["a" /* default */], {
            serviceChangeHandler: this.lineItemChangeHandler,
            updateService: this.updateLibraryLineItem,
            resetEditService: this.resetEditLibraryLineItem,
            deleteService: this.deleteLibraryLineItem,
            newLibraryLineItemChangeHandler: this.props.newLibraryLineItemChangeHandler,
            createService: this.props.createLineItem,
            resetAddService: this.props.resetNewLibraryLineItem,
            library: this.getFilteredLibrary(userLineItems, this.state.searchQuery),
            searchQuery: this.state.searchQuery,
            updateSearchQuery: this.updateSearchQuery,
            localLibrary: this.getFilteredLibrary(this.state.localLibraryLineItems, this.state.searchQuery),
            serviceSelectHandler: this.serviceSelectHandler,
            toggleServiceSelect: this.toggleServiceSelect,
            selectAll: this.selectAll,
            selectNone: this.selectNone,
            addSelected: this.addSelected,
            getTotalSelected: this.getTotalSelected,
            initiallyExpanded: this.props.initiallyExpanded,
            newService: this.props.newLibraryLineItem,
            readOnly: this.props.readOnly
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__globals_scss___default.a.mobile, style: { textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */], {
            onClick: this.toggleMobileLibrary.bind(null, true),
            positive: true,
            content: 'Add from Library',
            fluid: true
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["v" /* Divider */],
            { horizontal: true },
            'Or'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["b" /* Button */], {
            onClick: this.toggleMobileAdd.bind(null, true, false),
            content: 'Add New Item',
            fluid: true
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 300
            },
            this.state.showMobileLibrary && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LibraryMobile__["a" /* default */], {
              serviceChangeHandler: this.lineItemChangeHandler,
              updateService: this.updateLibraryLineItem,
              resetEditService: this.resetEditLibraryLineItem,
              deleteService: this.deleteLibraryLineItem,
              library: this.getFilteredLibrary(userLineItems, this.state.searchQuery),
              searchQuery: this.state.searchQuery,
              updateSearchQuery: this.updateSearchQuery,
              localLibrary: this.getFilteredLibrary(this.state.localLibraryLineItems, this.state.searchQuery),
              serviceSelectHandler: this.serviceSelectHandler,
              toggleServiceSelect: this.toggleServiceSelect,
              selectAll: this.selectAll,
              selectNone: this.selectNone,
              addSelected: this.addSelected,
              getTotalSelected: this.getTotalSelected,
              open: this.state.showMobileLibrary,
              toggleMobileLibrary: this.toggleMobileLibrary,
              toggleMobileAdd: this.toggleMobileAdd,
              readOnly: this.props.readOnly
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 300
            },
            !this.props.readOnly && this.state.showMobileAdd && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LibraryItemEditMobile__["a" /* default */], {
              localService: this.props.newLibraryLineItem,
              commitUpdate: this.props.createLineItem,
              reset: this.props.resetNewLibraryLineItem,
              onChange: this.props.newLibraryLineItemChangeHandler,
              closeHandler: this.toggleMobileAdd.bind(null, false, false),
              isNew: true,
              open: this.state.showMobileAdd
            })
          )
        )
      );
    }
  }]);

  return ServiceLibrary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ServiceLibrary.propTypes = {
  initiallyExpanded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  newLibraryLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  createLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  copyLibraryLineItemsToDocument: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  newLibraryLineItemChangeHandler: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  resetNewLibraryLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ServiceLibrary);

/***/ }),
/* 3107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LibraryItemShow__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Proposal_scss__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Proposal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LineItems_LineItemEditMobile__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LibraryItemEditDesktop__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LineItems_LineItemShow__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var LibraryDesktop = function (_React$Component) {
  _inherits(LibraryDesktop, _React$Component);

  function LibraryDesktop(props) {
    _classCallCheck(this, LibraryDesktop);

    var _this = _possibleConstructorReturn(this, (LibraryDesktop.__proto__ || Object.getPrototypeOf(LibraryDesktop)).call(this, props));

    _this.state = {
      activeTab: 'library',
      expanded: _this.props.initiallyExpanded === undefined ? true : _this.props.initiallyExpanded
    };
    _this.setActiveTab = _this.setActiveTab.bind(_this);
    _this.toggleExpanded = _this.toggleExpanded.bind(_this);
    _this.addSelected = _this.addSelected.bind(_this);
    _this.addNewLineItem = _this.addNewLineItem.bind(_this);
    _this.addNewLibraryLineItem = _this.addNewLibraryLineItem.bind(_this);
    _this.createService = _this.createService.bind(_this);
    return _this;
  }

  _createClass(LibraryDesktop, [{
    key: 'setActiveTab',
    value: function setActiveTab(activeTab) {
      this.setState({ activeTab: activeTab });
      if (activeTab === 'library') this.props.resetAddService();
    }
  }, {
    key: 'createService',
    value: function createService(idx, onSuccess) {
      var _this2 = this;

      this.props.createService(idx, function () {
        _this2.setActiveTab('library');
        if (onSuccess) onSuccess();
      });
    }
  }, {
    key: 'addSelected',
    value: function addSelected() {
      this.toggleExpanded(false);
      this.props.addSelected();
    }
  }, {
    key: 'addNewLineItem',
    value: function addNewLineItem() {
      this.props.newLibraryLineItemChangeHandler(Object.assign({}, this.props.newService, { addToLibrary: false }));
      this.setActiveTab('new');
    }
  }, {
    key: 'addNewLibraryLineItem',
    value: function addNewLibraryLineItem() {
      this.props.newLibraryLineItemChangeHandler(Object.assign({}, this.props.newService, { addToLibrary: true }));
      this.setActiveTab('new');
    }
  }, {
    key: 'toggleExpanded',
    value: function toggleExpanded(expanded) {
      if (typeof expanded === 'boolean') {
        this.setState({ expanded: expanded });
      } else {
        this.setState({ expanded: !this.state.expanded });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var maxHeight = this.state.expanded ? '450px' : '280px';
      var searchQuery = this.props.searchQuery;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */],
          { tabular: true, attached: 'top', style: { marginLeft: '-1px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */].Item, {
            name: 'Add from Library',
            active: this.state.activeTab === 'library',
            onClick: this.setActiveTab.bind(null, 'library')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */].Item, {
            name: 'Add New Item',
            active: this.state.activeTab === 'new',
            onClick: this.addNewLineItem
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
          { fluid: true, className: __WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default.a.addService, style: { marginTop: 0 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
            { style: { padding: '0' } },
            this.state.activeTab === 'library' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                { container: true, padded: true, columns: 'equal', verticalAlign: 'middle' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_9_formsy_react___default.a.Form,
                      { style: { display: 'inline', paddingRight: '1em' }, autoComplete: 'off' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                        name: 'search',
                        type: 'text',
                        size: 'small',
                        icon: 'search',
                        placeholder: 'Filter...',
                        onChange: this.props.updateSearchQuery,
                        value: searchQuery
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { textAlign: 'right' },
                    this.props.getTotalSelected() > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      this.props.getTotalSelected(),
                      ' Selected',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
                        {
                          onClick: this.addSelected,
                          primary: true,
                          style: { marginLeft: '1em' }
                        },
                        'Add'
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { maxHeight: maxHeight, overflowY: 'auto' } },
                this.props.library.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'center', padding: '2em' } },
                  searchQuery === '' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'You have no saved line items.'
                  ),
                  searchQuery !== '' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'No results for "',
                    searchQuery,
                    '"'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                    onClick: this.addNewLibraryLineItem,
                    primary: true,
                    icon: 'plus',
                    labelPosition: 'left',
                    content: 'Add New Item'
                  })
                ),
                this.props.library.map(function (service, idx) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: service.node.id || idx },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        style: { display: 'table-cell', padding: '1em' },
                        className: [__WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default.a.libraryItem, _this3.props.localLibrary[idx].checked ? __WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default.a.itemSelected : ''].join(' '),
                        onClick: _this3.props.toggleServiceSelect.bind(null, idx)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
                        checked: _this3.props.localLibrary[idx].checked || false,
                        onChange: _this3.props.serviceSelectHandler.bind(null, idx)
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'table-cell', width: '100%' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__Modules__["k" /* Dthc */],
                        {
                          service: service.node,
                          localService: _this3.props.localLibrary[idx].node,
                          onChange: function onChange(svc) {
                            _this3.props.serviceChangeHandler(svc, idx);
                          },
                          commitUpdate: _this3.props.updateService,
                          desktop: __WEBPACK_IMPORTED_MODULE_7__LibraryItemEditDesktop__["a" /* default */],
                          mobile: __WEBPACK_IMPORTED_MODULE_3__LibraryItemShow__["a" /* default */],
                          index: idx,
                          reset: _this3.props.resetEditService,
                          'delete': _this3.props.deleteService
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LibraryItemShow__["a" /* default */], {
                          service: service.node,
                          index: idx
                        })
                      )
                    )
                  );
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                { container: true, padded: true, columns: 'equal', verticalAlign: 'middle' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    this.props.library.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { onClick: this.props.selectAll },
                        'Select All'
                      ),
                      ' ',
                      '\xA0/\xA0\xA0',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { onClick: this.props.selectNone },
                        'Deselect All'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { textAlign: 'center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { onClick: this.toggleExpanded },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron ' + (this.state.expanded ? 'up' : 'down') })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    { textAlign: 'right' },
                    this.props.getTotalSelected() > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      this.props.getTotalSelected(),
                      ' Selected',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
                        {
                          onClick: this.addSelected,
                          primary: true,
                          style: { marginLeft: '1em' }
                        },
                        'Add'
                      )
                    )
                  )
                )
              )
            ),
            this.state.activeTab === 'new' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["k" /* Dthc */],
              {
                service: this.props.newService,
                localService: this.props.newService,
                onChange: function onChange(service) {
                  _this3.props.newLibraryLineItemChangeHandler(service);
                },
                commitUpdate: this.createService,
                desktop: __WEBPACK_IMPORTED_MODULE_7__LibraryItemEditDesktop__["a" /* default */],
                mobile: __WEBPACK_IMPORTED_MODULE_6__LineItems_LineItemEditMobile__["a" /* default */],
                initiallyOpen: true,
                editorOpen: true,
                isNew: true
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItems_LineItemShow__["a" /* default */], { service: this.props.newService.node })
            )
          )
        )
      );
    }
  }]);

  return LibraryDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LibraryDesktop.propTypes = {
  serviceChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetEditService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  newLibraryLineItemChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  createService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetAddService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  serviceSelectHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  library: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  localLibrary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  selectAll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectNone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getTotalSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  initiallyExpanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  newService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  toggleServiceSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateSearchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LibraryDesktop);

/***/ }),
/* 3108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LibraryItemShow__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Proposal_scss__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Proposal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LibraryItemEditMobile__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LibraryItemEditDesktop__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LibraryMobile = function (_React$Component) {
  _inherits(LibraryMobile, _React$Component);

  function LibraryMobile(props) {
    _classCallCheck(this, LibraryMobile);

    var _this = _possibleConstructorReturn(this, (LibraryMobile.__proto__ || Object.getPrototypeOf(LibraryMobile)).call(this, props));

    _this.addSelected = _this.addSelected.bind(_this);
    return _this;
  }

  _createClass(LibraryMobile, [{
    key: 'addSelected',
    value: function addSelected() {
      this.props.toggleMobileLibrary(false);
      this.props.addSelected();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var searchQuery = this.props.searchQuery;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */],
        {
          open: this.props.open,
          onClose: this.props.toggleMobileLibrary.bind(null, false),
          inline: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item', onClick: this.props.toggleMobileLibrary.bind(null, false) },
              'Cancel'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item', onClick: this.addSelected },
              'Add'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingTop: '5em', height: '100%', overflowY: 'scroll' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
              { container: true, style: { paddingBottom: '1em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 10 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: this.props.selectAll },
                    'Select All'
                  ),
                  ' ',
                  '\xA0/\xA0\xA0',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { onClick: this.props.selectNone },
                    'Deselect All'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  { textAlign: 'right', width: 6 },
                  this.props.getTotalSelected(),
                  ' Selected'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                    { autoComplete: 'off' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                      name: 'search',
                      type: 'text',
                      size: 'small',
                      icon: 'search',
                      placeholder: 'Filter...',
                      onChange: this.props.updateSearchQuery,
                      value: searchQuery,
                      fluid: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            ),
            this.props.library.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center', padding: '2em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'You have no saved line items.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                onClick: this.props.toggleMobileAdd.bind(null, true, true),
                primary: true,
                icon: 'plus',
                labelPosition: 'left',
                content: 'Add New Item'
              })
            ),
            this.props.library.map(function (service, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: service.node.id || idx },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    style: { display: 'table-cell', padding: '1em 1.5em' },
                    className: [__WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default.a.libraryItem, _this2.props.localLibrary[idx].checked ? __WEBPACK_IMPORTED_MODULE_5__Proposal_scss___default.a.itemSelected : ''].join(' '),
                    onClick: _this2.props.toggleServiceSelect.bind(null, idx)
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
                    checked: _this2.props.localLibrary[idx].checked || false,
                    onChange: _this2.props.serviceSelectHandler.bind(null, idx)
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'table-cell', width: '100%' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__Modules__["k" /* Dthc */],
                    {
                      service: service.node,
                      localService: _this2.props.localLibrary[idx].node,
                      onChange: function onChange(svc) {
                        _this2.props.serviceChangeHandler(svc, idx);
                      },
                      commitUpdate: _this2.props.updateService,
                      desktop: __WEBPACK_IMPORTED_MODULE_7__LibraryItemEditDesktop__["a" /* default */],
                      mobile: __WEBPACK_IMPORTED_MODULE_6__LibraryItemEditMobile__["a" /* default */],
                      index: idx,
                      reset: _this2.props.resetEditService,
                      'delete': _this2.props.deleteService
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LibraryItemShow__["a" /* default */], {
                      service: service.node,
                      index: idx
                    })
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return LibraryMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LibraryMobile.propTypes = {
  serviceChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetEditService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteService: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  serviceSelectHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  library: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  localLibrary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  selectAll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectNone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getTotalSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggleMobileLibrary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  toggleMobileAdd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  toggleServiceSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateSearchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LibraryMobile);

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LibraryContainer_viewer$ref: FragmentReference;
export type LibraryContainer_viewer = {|
  +id: string,
  +user_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +$refType: LibraryContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "LibraryContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["user_line_items"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "user_line_items",
      "name": "__LibraryContainer_user_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserLineItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserLineItem",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '40c05596f7108685bba8f261e8a0e295';
module.exports = node;

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 20ab1b8a77c68a9f3b493917629f90aa
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUserLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Library_deleteUserLineItemMutationVariables = {|
  input: DeleteUserLineItemInput
|};
export type Library_deleteUserLineItemMutationResponse = {|
  +deleteUserLineItem: ?{|
    +deletedUserLineItemId: ?string
  |}
|};
export type Library_deleteUserLineItemMutation = {|
  variables: Library_deleteUserLineItemMutationVariables,
  response: Library_deleteUserLineItemMutationResponse,
|};
*/

/*
mutation Library_deleteUserLineItemMutation(
  $input: DeleteUserLineItemInput!
) {
  deleteUserLineItem(input: $input) {
    deletedUserLineItemId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteUserLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteUserLineItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteUserLineItemInput!"
    }],
    "concreteType": "DeleteUserLineItemPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedUserLineItemId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_deleteUserLineItemMutation",
    "id": null,
    "text": "mutation Library_deleteUserLineItemMutation(\n  $input: DeleteUserLineItemInput!\n) {\n  deleteUserLineItem(input: $input) {\n    deletedUserLineItemId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_deleteUserLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_deleteUserLineItemMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '02c325ef0bc630861ea0499e35f2f5c5';
module.exports = node;

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f3269c1bbcf348d6cc2fa586e72d754d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  description?: ?string,
};
export type Library_updateUserLineItemMutationVariables = {|
  input: UpdateUserLineItemInput
|};
export type Library_updateUserLineItemMutationResponse = {|
  +updateUserLineItem: ?{|
    +user_line_item: ?{|
      +id: string,
      +description: ?string,
      +price_cents: ?number,
      +price_currency: ?string,
      +quantity: ?number,
      +title: ?string,
    |}
  |}
|};
export type Library_updateUserLineItemMutation = {|
  variables: Library_updateUserLineItemMutationVariables,
  response: Library_updateUserLineItemMutationResponse,
|};
*/

/*
mutation Library_updateUserLineItemMutation(
  $input: UpdateUserLineItemInput!
) {
  updateUserLineItem(input: $input) {
    user_line_item {
      id
      description
      price_cents
      price_currency
      quantity
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserLineItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserLineItemInput!"
    }],
    "concreteType": "UpdateUserLineItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_line_item",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItem",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "price_cents",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "price_currency",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_updateUserLineItemMutation",
    "id": null,
    "text": "mutation Library_updateUserLineItemMutation(\n  $input: UpdateUserLineItemInput!\n) {\n  updateUserLineItem(input: $input) {\n    user_line_item {\n      id\n      description\n      price_cents\n      price_currency\n      quantity\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_updateUserLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_updateUserLineItemMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a9140713b0c36c6cb91427fb5cc776c5';
module.exports = node;

/***/ }),
/* 3112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_number_format__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LineItemEditDesktop = function (_React$Component) {
  _inherits(LineItemEditDesktop, _React$Component);

  function LineItemEditDesktop(props) {
    _classCallCheck(this, LineItemEditDesktop);

    var _this = _possibleConstructorReturn(this, (LineItemEditDesktop.__proto__ || Object.getPrototypeOf(LineItemEditDesktop)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.fieldChange = _this.fieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.commitUpdate = _this.commitUpdate.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.priceFieldChange = _this.priceFieldChange.bind(_this);
    _this.descriptionFieldChange = _this.descriptionFieldChange.bind(_this);
    return _this;
  }

  _createClass(LineItemEditDesktop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.refs.service.scrollIntoViewIfNeeded) this.refs.service.scrollIntoViewIfNeeded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        return _this2.props.closeHandler();
      });
    }
  }, {
    key: 'commitUpdate',
    value: function commitUpdate(e) {
      var _this3 = this;

      e.preventDefault();
      e.stopPropagation();
      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        return _this3.props.closeHandler();
      });
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset(this.props.index);
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this4 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this4.props.closeHandler;
      });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.fieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'fieldChange',
    value: function fieldChange(key, value) {
      var newValue = {};
      newValue[key] = value;
      this.props.onChange(Object.assign(this.props.localService, newValue));
    }
  }, {
    key: 'priceFieldChange',
    value: function priceFieldChange(e) {
      this.fieldChange('price_cents', e.target.value * 100);
    }
  }, {
    key: 'descriptionFieldChange',
    value: function descriptionFieldChange(value) {
      this.fieldChange('description', value);
    }
  }, {
    key: 'render',
    value: function render() {
      var service = this.props.localService;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
        { className: 'ui form', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { ref: 'service' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */],
            { fluid: true, style: { background: 'transparent' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["x" /* Card */].Content,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  { style: { paddingBottom: 0 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      computer: 8,
                      tablet: 8,
                      mobile: 16
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                      fluid: true,
                      rows: 1,
                      placeholder: 'Service name',
                      value: service.title || '',
                      onChange: this.textFieldChange,
                      name: 'title',
                      submitted: this.state.submitted,
                      className: 'strong',
                      required: true,
                      validationError: 'Service name is required'
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      width: 3,
                      textAlign: 'right',
                      only: 'computer tablet'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */],
                      {
                        name: 'price_cents',
                        type: 'currency',
                        placeholder: '$500.00',
                        value: service.price_cents ? service.price_cents / 100 : '',
                        onChange: this.priceFieldChange,
                        submitted: this.state.submitted,
                        required: true,
                        validationError: 'Price is required',
                        className: 'textAlignRight'
                      },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_number_format___default.a, {
                        thousandSeparator: true,
                        prefix: '$',
                        decimalScale: 2,
                        fixedDecimalScale: true
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      width: 2,
                      textAlign: 'right',
                      only: 'computer tablet'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
                      name: 'quantity',
                      type: 'number',
                      placeholder: '1',
                      value: service.quantity,
                      onChange: this.textFieldChange,
                      submitted: this.state.submitted,
                      className: 'textAlignRight'
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      width: 3,
                      textAlign: 'right',
                      only: 'computer tablet'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      { style: { paddingTop: '0.5em' } },
                      __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format((service.quantity || 1) * (service.price_cents || 0) / 100, {
                        code: service.price_currency
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', style: { paddingTop: 0 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["l" /* TextEditor */], {
                      onChange: this.descriptionFieldChange,
                      value: service.description || '',
                      placeholder: 'Short description of item'
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], {
                id: service.id,
                reset: this.reset,
                'delete': this.delete,
                isNew: this.props.isNew
              })
            )
          )
        )
      );
    }
  }]);

  return LineItemEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

LineItemEditDesktop.propTypes = {
  localService: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  closeEditor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemEditDesktop);

/***/ }),
/* 3113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */],
    { style: { padding: '1em' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Row,
      { only: 'computer tablet' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column, { computer: 8, tablet: 8, mobile: 16 }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 3, textAlign: 'right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Price'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 2, textAlign: 'right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Qty'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Grid */].Column,
        { width: 3, textAlign: 'right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Total'
        )
      )
    )
  );
});

/***/ }),
/* 3114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineItemShow__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_beautiful_dnd__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineItemEditMobile__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LineItemEditDesktop__ = __webpack_require__(3112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineItems_scss__ = __webpack_require__(3608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineItems_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LineItems_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// eslint-disable-next-line new-cap
var DragHandle = function DragHandle(_ref) {
  var className = _ref.className,
      dragHandleProps = _ref.dragHandleProps,
      rest = _objectWithoutProperties(_ref, ['className', 'dragHandleProps']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({
      className: [__WEBPACK_IMPORTED_MODULE_7__LineItems_scss___default.a.dragHandleContainer, className].join(' ')
    }, rest, dragHandleProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_7__LineItems_scss___default.a.dragHandle })
  );
};

DragHandle.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dragHandleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

// eslint-disable-next-line new-cap
var LineItemShowSortable = function LineItemShowSortable(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    props.lineItems.map(function (service, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_beautiful_dnd__["c" /* Draggable */],
        {
          draggableId: service.node.id,
          index: idx,
          key: service.node.id || idx
        },
        function (provided) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              _extends({}, provided.draggableProps, { ref: provided.innerRef }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_7__LineItems_scss___default.a.draggableElement },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DragHandle, {
                  dragHandleProps: provided.dragHandleProps,
                  className: props.draggingIndex !== null && props.draggingIndex !== idx ? __WEBPACK_IMPORTED_MODULE_7__LineItems_scss___default.a.inactiveDragHandle : null
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__Modules__["k" /* Dthc */],
                    {
                      service: service.node,
                      localService: props.localLineItems[idx].node,
                      onChange: function onChange(svc) {
                        props.lineItemChangeHandler(svc, idx);
                      },
                      commitUpdate: props.updateLineItem,
                      desktop: __WEBPACK_IMPORTED_MODULE_5__LineItemEditDesktop__["a" /* default */],
                      mobile: __WEBPACK_IMPORTED_MODULE_4__LineItemEditMobile__["a" /* default */],
                      index: idx,
                      reset: props.resetEditLineItem,
                      'delete': props.deleteLineItem
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LineItemShow__["a" /* default */], { service: service.node })
                  )
                )
              )
            ),
            provided.placeholder
          );
        }
      );
    })
  );
};

LineItemShowSortable.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  localLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  lineItemChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetEditLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  draggingIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (LineItemShowSortable);

/***/ }),
/* 3115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var LogoImage = function LogoImage(_ref) {
  var src = _ref.src;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
    src: src,
    alt: 'Logo',
    style: { display: 'block', maxWidth: '200px' }
  });
};

LogoImage.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LogoImage);

/***/ }),
/* 3116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotesEditDesktop__ = __webpack_require__(3117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotesEditMobile__ = __webpack_require__(3118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Notes_scss__ = __webpack_require__(3611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Notes_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Notes_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var NotesComponent = function (_React$Component) {
  _inherits(NotesComponent, _React$Component);

  function NotesComponent() {
    _classCallCheck(this, NotesComponent);

    return _possibleConstructorReturn(this, (NotesComponent.__proto__ || Object.getPrototypeOf(NotesComponent)).apply(this, arguments));
  }

  _createClass(NotesComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          canEdit = _props.canEdit,
          localNotes = _props.localNotes,
          reset = _props.reset,
          notes = _props.notes,
          notesChangeHandler = _props.notesChangeHandler,
          updateNotes = _props.updateNotes;

      var NotesShow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { style: { padding: '1em' }, onClick: this.addNew },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'em',
            null,
            'Click to add notes...'
          )
        ),
        notes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          style: { padding: '1em', wordBreak: 'break-word' },
          dangerouslySetInnerHTML: { __html: notes }
        })
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__Notes_scss___default.a.notes },
        canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
          {
            desktop: __WEBPACK_IMPORTED_MODULE_3__NotesEditDesktop__["a" /* default */],
            mobile: __WEBPACK_IMPORTED_MODULE_4__NotesEditMobile__["a" /* default */],
            onChange: notesChangeHandler,
            commitUpdate: updateNotes,
            reset: reset,
            value: localNotes
          },
          NotesShow
        ),
        !canEdit && NotesShow
      );
    }
  }]);

  return NotesComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NotesComponent.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  localNotes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notesChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateNotes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (NotesComponent);

/***/ }),
/* 3117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);






var NotesEditDesktop = function NotesEditDesktop(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      _reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
    { onSubmit: commitUpdate.bind(null, closeHandler) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
      { padded: true, relaxed: true, stackable: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 1 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
            value: value,
            onChange: onChange,
            placeholder: 'Enter notes or additional details'
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          { width: 16 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["j" /* DthcActions */], { reset: function reset(e) {
              _reset();closeHandler(e);e.stopPropagation();
            } })
        )
      )
    )
  );
};

NotesEditDesktop.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (NotesEditDesktop);

/***/ }),
/* 3118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);





var NotesEditMobile = function NotesEditMobile(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      open = _ref.open,
      reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
    { open: open, onClose: closeHandler, inline: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: 'item',
            onClick: function onClick(e) {
              reset();
              setTimeout(function () {
                return closeHandler(e);
              }, 0);
            }
          },
          'Cancel'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'right menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'item', onClick: commitUpdate.bind(null, closeHandler) },
          'Save'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { onSubmit: commitUpdate.bind(null, closeHandler) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
          value: value,
          onChange: onChange,
          placeholder: 'Enter notes or additional details'
        })
      )
    )
  );
};

NotesEditMobile.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (NotesEditMobile);

/***/ }),
/* 3119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_number_format__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DownPayment = function (_React$Component) {
  _inherits(DownPayment, _React$Component);

  function DownPayment(props) {
    _classCallCheck(this, DownPayment);

    var _this = _possibleConstructorReturn(this, (DownPayment.__proto__ || Object.getPrototypeOf(DownPayment)).call(this, props));

    _this.onDownPaymentDistributionChange = _this.onDownPaymentDistributionChange.bind(_this);
    return _this;
  }

  _createClass(DownPayment, [{
    key: 'onDownPaymentDistributionChange',
    value: function onDownPaymentDistributionChange(e) {
      this.fieldChange('down_payment_distribution_type', e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currencyFieldChange = _props.currencyFieldChange,
          dateFieldChange = _props.dateFieldChange,
          localInvoice = _props.localInvoice,
          numberFieldChange = _props.numberFieldChange,
          submitted = _props.submitted,
          DateInput = _props.DateInput;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              display: 'inline-block',
              marginTop: '1.75em',
              marginRight: '0.5em'
            }
          },
          'A down payment of'
        ),
        localInvoice.down_payment_distribution_type === 'FIXED' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */],
          {
            name: 'down_payment_cents',
            type: 'currency',
            placeholder: '$500.00',
            value: localInvoice.down_payment_cents ? (localInvoice.down_payment_cents || 0) / 100 : '',
            onChange: currencyFieldChange,
            submitted: submitted,
            inline: 'last',
            width: '80px',
            label: '',
            style: {
              marginTop: '1.25em'
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_number_format___default.a, {
            thousandSeparator: true,
            prefix: '$',
            decimalScale: 2,
            fixedDecimalScale: true
          })
        ),
        localInvoice.down_payment_distribution_type === 'PERCENT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */],
          {
            name: 'down_payment_percent',
            placeholder: '50%',
            type: 'currency',
            value: localInvoice.down_payment_percent || '',
            onChange: numberFieldChange,
            submitted: submitted,
            required: true,
            inline: 'last',
            width: '50px',
            label: '',
            style: {
              marginLeft: '1em',
              marginTop: '1.25em'
            },
            validationError: 'Required'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_number_format___default.a, {
            suffix: '%',
            allowNegative: false,
            isAllowed: function isAllowed(values) {
              return values.floatValue >= 0 && values.floatValue <= 100;
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: {
              display: 'inline-block',
              marginTop: '1.75em',
              marginLeft: '0.5em',
              marginRight: '0.5em'
            }
          },
          'is due on'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateInput, {
          dateOnly: true,
          value: localInvoice.down_payment_due_at || '',
          onChange: dateFieldChange,
          name: 'down_payment_due_at',
          label: '',
          style: {
            marginTop: '1.25em'
          },
          placeholder: 'Date',
          datePlaceholder: 'Date (optional)',
          inline: true,
          submitted: submitted,
          viewer: null
        })
      );
    }
  }]);

  return DownPayment;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DownPayment.propTypes = {
  currencyFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  DateInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  dateFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  numberFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (DownPayment);

/***/ }),
/* 3120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentPlanShow__ = __webpack_require__(3124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentPlanEditDesktop__ = __webpack_require__(3121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentPlanEditMobile__ = __webpack_require__(3122);







var PaymentPlan = function PaymentPlan(_ref) {
  var canEdit = _ref.canEdit,
      commitUpdate = _ref.commitUpdate,
      invoice = _ref.invoice,
      localInvoice = _ref.localInvoice,
      onChange = _ref.onChange,
      relay = _ref.relay,
      reset = _ref.reset,
      viewer = _ref.viewer;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["k" /* Dthc */],
      {
        desktop: __WEBPACK_IMPORTED_MODULE_4__PaymentPlanEditDesktop__["a" /* default */],
        mobile: __WEBPACK_IMPORTED_MODULE_5__PaymentPlanEditMobile__["a" /* default */],
        invoice: invoice,
        localInvoice: localInvoice,
        onChange: onChange,
        reset: reset,
        commitUpdate: commitUpdate
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PaymentPlanShow__["a" /* default */], { node: invoice, relay: relay, viewer: viewer })
    ),
    !canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PaymentPlanShow__["a" /* default */], { node: invoice })
  );
};

PaymentPlan.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (PaymentPlan);

/***/ }),
/* 3121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentPlanFields__ = __webpack_require__(1467);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PaymentPlanEditDesktop = function (_React$Component) {
  _inherits(PaymentPlanEditDesktop, _React$Component);

  function PaymentPlanEditDesktop(props) {
    _classCallCheck(this, PaymentPlanEditDesktop);

    var _this = _possibleConstructorReturn(this, (PaymentPlanEditDesktop.__proto__ || Object.getPrototypeOf(PaymentPlanEditDesktop)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.getRemainingBalance = _this.getRemainingBalance.bind(_this);
    _this.getDownPayment = _this.getDownPayment.bind(_this);
    _this.getAdditionalPayments = _this.getAdditionalPayments.bind(_this);
    _this.sumOfIPPlanItems = _this.sumOfIPPlanItems.bind(_this);
    return _this;
  }

  _createClass(PaymentPlanEditDesktop, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.setState({ submitted: true });
      if (this.getRemainingBalance() === 0) {
        this.props.commitUpdate(this.props.closeHandler);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment plan',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
      }
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update payment plan',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'getDownPayment',
    value: function getDownPayment() {
      var localInvoice = this.props.localInvoice;

      return localInvoice.down_payment_distribution_type === 'FIXED' ? localInvoice.down_payment_cents || 0 : (localInvoice.total_cents || 0) * localInvoice.down_payment_percent / 100;
    }
  }, {
    key: 'getAdditionalPayments',
    value: function getAdditionalPayments() {
      var localInvoice = this.props.localInvoice;

      return this.sumOfIPPlanItems(localInvoice.i_pplan_items.edges, 'amount_cents');
    }
  }, {
    key: 'getRemainingBalance',
    value: function getRemainingBalance() {
      var localInvoice = this.props.localInvoice;

      return localInvoice.total_cents - this.getDownPayment() - this.getAdditionalPayments();
    }
  }, {
    key: 'sumOfIPPlanItems',
    value: function sumOfIPPlanItems(items, field) {
      return items.reduce(function (sum, item) {
        return sum + (item.node[field] || 0);
      }, 0);
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset();
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */],
        { fluid: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
            {
              onValidSubmit: this.onValidSubmit,
              onInvalidSubmit: this.onInvalidSubmit,
              ref: 'form'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PaymentPlanFields__["a" /* default */], {
              invoice: this.props.invoice,
              localInvoice: this.props.localInvoice,
              onChange: this.props.onChange,
              getDownPayment: this.getDownPayment,
              getAdditionalPayments: this.getAdditionalPayments,
              getRemainingBalance: this.getRemainingBalance,
              submitted: this.state.submitted
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["j" /* DthcActions */], { reset: this.reset })
          )
        )
      );
    }
  }]);

  return PaymentPlanEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentPlanEditDesktop.propTypes = {
  invoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentPlanEditDesktop);

/***/ }),
/* 3122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentPlanFields__ = __webpack_require__(1467);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PaymentPlanEditDesktop = function (_React$Component) {
  _inherits(PaymentPlanEditDesktop, _React$Component);

  function PaymentPlanEditDesktop(props) {
    _classCallCheck(this, PaymentPlanEditDesktop);

    var _this = _possibleConstructorReturn(this, (PaymentPlanEditDesktop.__proto__ || Object.getPrototypeOf(PaymentPlanEditDesktop)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.getRemainingBalance = _this.getRemainingBalance.bind(_this);
    _this.getDownPayment = _this.getDownPayment.bind(_this);
    _this.getAdditionalPayments = _this.getAdditionalPayments.bind(_this);
    _this.sumOfIPPlanItems = _this.sumOfIPPlanItems.bind(_this);
    return _this;
  }

  _createClass(PaymentPlanEditDesktop, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      if (this.getRemainingBalance() === 0) {
        this.props.commitUpdate(function () {
          return _this2.props.closeHandler();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update payment plan',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
      }
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update payment plan',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'getDownPayment',
    value: function getDownPayment() {
      var localInvoice = this.props.localInvoice;

      return localInvoice.down_payment_distribution_type === 'FIXED' ? localInvoice.down_payment_cents || 0 : (localInvoice.total_cents || 0) * localInvoice.down_payment_percent / 100;
    }
  }, {
    key: 'getAdditionalPayments',
    value: function getAdditionalPayments() {
      var localInvoice = this.props.localInvoice;

      return this.sumOfIPPlanItems(localInvoice.i_pplan_items.edges, 'amount_cents');
    }
  }, {
    key: 'getRemainingBalance',
    value: function getRemainingBalance() {
      var localInvoice = this.props.localInvoice;

      return localInvoice.total_cents - this.getDownPayment() - this.getAdditionalPayments();
    }
  }, {
    key: 'sumOfIPPlanItems',
    value: function sumOfIPPlanItems(items, field) {
      return items.reduce(function (sum, item) {
        return sum + (item.node[field] || 0);
      }, 0);
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this3 = this;

      this.props.reset();
      setTimeout(function () {
        return _this3.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          ref: 'form'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this4.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PaymentPlanFields__["a" /* default */], {
              invoice: this.props.invoice,
              localInvoice: this.props.localInvoice,
              onChange: this.props.onChange,
              getDownPayment: this.getDownPayment,
              getAdditionalPayments: this.getAdditionalPayments,
              getRemainingBalance: this.getRemainingBalance,
              submitted: this.state.submitted
            })
          )
        )
      );
    }
  }]);

  return PaymentPlanEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentPlanEditDesktop.propTypes = {
  invoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentPlanEditDesktop);

/***/ }),
/* 3123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_number_format__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PaymentPlanItems = function (_React$Component) {
  _inherits(PaymentPlanItems, _React$Component);

  function PaymentPlanItems(props) {
    _classCallCheck(this, PaymentPlanItems);

    var _this = _possibleConstructorReturn(this, (PaymentPlanItems.__proto__ || Object.getPrototypeOf(PaymentPlanItems)).call(this, props));

    _this.addIPPlanItem = _this.addIPPlanItem.bind(_this);
    _this.onIPPlanItemCurrencyChange = _this.onIPPlanItemCurrencyChange.bind(_this);
    _this.deleteIPPlanItem = _this.deleteIPPlanItem.bind(_this);
    _this.generateId = _this.generateId.bind(_this);
    return _this;
  }

  _createClass(PaymentPlanItems, [{
    key: 'onIPPlanItemCurrencyChange',
    value: function onIPPlanItemCurrencyChange(e, idx) {
      var localInvoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localInvoice);
      localInvoice.i_pplan_items.edges[idx].node[e.target.name] = Math.round(e.target.value * 100);
      this.props.onChange(localInvoice);
    }
  }, {
    key: 'addIPPlanItem',
    value: function addIPPlanItem() {
      var localInvoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localInvoice);
      localInvoice.i_pplan_items.edges.push({
        node: {
          amount_cents: null,
          amount_currency: 'USD',
          due_at: null,
          locked: false,
          percent: null,
          tempId: this.generateId()
        }
      });
      this.props.onChange(localInvoice);
    }
  }, {
    key: 'deleteIPPlanItem',
    value: function deleteIPPlanItem(idx) {
      var localInvoice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.localInvoice);
      var existingIPPlanId = this.props.localInvoice.i_pplan_items.edges[idx].node.id;
      if (existingIPPlanId) {
        localInvoice.delete_pplan_items_with_ids = localInvoice.delete_pplan_items_with_ids ? localInvoice.delete_pplan_items_with_ids.push(existingIPPlanId) : [existingIPPlanId];
      }
      localInvoice.i_pplan_items.edges.splice(idx, 1);
      this.props.onChange(localInvoice);
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          localInvoice = _props.localInvoice,
          submitted = _props.submitted,
          DateInput = _props.DateInput;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          {
            style: { marginTop: '1.75em', marginBottom: '1.75em' }
          },
          'The remaining balance of',
          ' ',
          localInvoice.down_payment_distribution_type === 'FIXED' ? __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(((localInvoice.total_cents || 0) - (localInvoice.down_payment_cents || 0)) / 100, {
            code: 'USD'
          }) : __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((localInvoice.total_cents || 0) * (100 - localInvoice.down_payment_percent) / 10000, {
            code: 'USD'
          }),
          ' ',
          'is distributed across',
          ' ',
          localInvoice.i_pplan_items.edges.length,
          ' payment',
          localInvoice.i_pplan_items.edges.length !== 1 ? 's' : ''
        ),
        localInvoice.i_pplan_items.edges.map(function (iPPlanItem, idx) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              key: iPPlanItem.node.id || iPPlanItem.node.tempId,
              className: [__WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss___default.a.pplanItem, idx % 2 === 0 ? __WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss___default.a.altRow : ''].join(' ')
            },
            !iPPlanItem.node.locked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss___default.a.delete,
                onClick: _this2.deleteIPPlanItem.bind(null, idx)
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'close' })
            ),
            localInvoice.pplan_distribution_type === 'FIXED' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */],
              {
                name: 'amount_cents',
                type: 'currency',
                placeholder: '$500.00',
                value: iPPlanItem.node.amount_cents ? (iPPlanItem.node.amount_cents || 0) / 100 : '',
                onChange: function onChange(e) {
                  return _this2.onIPPlanItemCurrencyChange(e, idx);
                },
                submitted: submitted,
                required: true,
                disabled: iPPlanItem.node.locked,
                inline: 'last',
                width: '80px',
                label: '',
                style: {
                  marginTop: '1.25em'
                },
                validationError: 'Required'
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_number_format___default.a, {
                thousandSeparator: true,
                prefix: '$',
                decimalScale: 2,
                fixedDecimalScale: true
              })
            ),
            localInvoice.pplan_distribution_type === 'PERCENT' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements__["e" /* FloatingLabelInput */], {
              name: 'percent',
              placeholder: '50%',
              disabled: iPPlanItem.node.locked,
              value: iPPlanItem.node.percent || '',
              onChange: function onChange(e) {
                return _this2.props.onIPPlanItemChange(e, idx);
              },
              submitted: submitted,
              required: true,
              inline: 'last',
              width: '50px',
              label: '',
              style: {
                marginTop: '1.25em'
              },
              validationError: 'Required'
            }),
            localInvoice.pplan_distribution_type === 'PERCENT' ? 'percent' : '',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                style: {
                  display: 'inline-block',
                  marginTop: '1.75em',
                  marginLeft: '0.5em',
                  marginRight: '0.5em'
                },
                className: iPPlanItem.node.locked ? __WEBPACK_IMPORTED_MODULE_5__PaymentPlan_scss___default.a.locked : ''
              },
              'due on'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DateInput, {
              dateOnly: true,
              value: iPPlanItem.node.due_at || '',
              onChange: function onChange(e) {
                return _this2.props.onIPPlanItemChange(e, idx);
              },
              name: 'due_at',
              disabled: iPPlanItem.node.locked,
              datePlaceholder: 'Date',
              placeholder: 'Date',
              label: '',
              style: {
                marginTop: '1.25em'
              },
              inline: true,
              required: true,
              validationError: 'Required',
              submitted: submitted,
              viewer: null
            }),
            iPPlanItem.node.status === 'paid' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingBottom: '1em' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["y" /* Label */], { basic: true, size: 'small', color: 'green', content: 'Paid' })
            )
          );
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { style: { marginTop: '1em', marginBottom: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.addIPPlanItem },
            '+ Add Payment'
          )
        )
      );
    }
  }]);

  return PaymentPlanItems;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PaymentPlanItems.propTypes = {
  onIPPlanItemChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  DateInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  localInvoice: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  submitted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentPlanItems);

/***/ }),
/* 3124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_PaymentMethods_NoPaymentMethods__ = __webpack_require__(1444);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PaymentPlanShow = function (_React$Component) {
  _inherits(PaymentPlanShow, _React$Component);

  function PaymentPlanShow(props) {
    _classCallCheck(this, PaymentPlanShow);

    var _this = _possibleConstructorReturn(this, (PaymentPlanShow.__proto__ || Object.getPrototypeOf(PaymentPlanShow)).call(this, props));

    _this.state = {
      setupPaymentMethodsOpen: false
    };
    _this.closeSetupPaymentMethods = _this.closeSetupPaymentMethods.bind(_this);
    _this.openSetupPaymetnMethods = _this.openSetupPaymentMethods.bind(_this);
    return _this;
  }

  _createClass(PaymentPlanShow, [{
    key: 'closeSetupPaymentMethods',
    value: function closeSetupPaymentMethods() {
      this.setState({ setupPaymentMethodsOpen: false });
    }
  }, {
    key: 'openSetupPaymentMethods',
    value: function openSetupPaymentMethods() {
      this.setState({ setupPaymentMethodsOpen: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          node = _props.node,
          relay = _props.relay,
          viewer = _props.viewer;

      var downPaymentAmount = function () {
        switch (node.down_payment_distribution_type) {
          case 'PERCENT':
            return node.down_payment_percent + '%';
          default:
            return __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((node.down_payment_cents || 0) / 100, {
              code: node.down_payment_currency
            });
        }
      }();

      var getTitle = function getTitle(iPPlanItem) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          node.pplan_distribution_type === 'FIXED' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((iPPlanItem.node.amount_cents || 0) / 100, {
              code: node.down_payment_currency
            })
          ),
          node.pplan_distribution_type === 'PERCENT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            iPPlanItem.node.percent,
            '%'
          ),
          node.pplan_distribution_type === 'PERCENT' ? 'percent' : '',
          ' is due on',
          ' ',
          __WEBPACK_IMPORTED_MODULE_2_moment___default()(iPPlanItem.node.due_at).format('L')
        );
      };

      var downPaymentTitle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        downPaymentAmount,
        node.down_payment_due_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          ' ',
          'due on',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            __WEBPACK_IMPORTED_MODULE_2_moment___default()(node.down_payment_due_at).format('L')
          )
        )
      );

      var paymentItemDescription = function paymentItemDescription(status) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingBottom: '1em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["y" /* Label */], {
            basic: true,
            size: 'small',
            color: status === 'PAID' ? 'green' : 'grey',
            content: status === 'PAID' ? 'Paid' : 'Unpaid'
          })
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onClick: function onClick(e) {
            if (node.accepted_payment_methods.edges.length === 0) {
              _this2.openSetupPaymentMethods();
              e.stopPropagation();
            }
          }
        },
        node.i_pplan_items.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '2em' } },
          node.down_payment_distribution_type && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Down Payment'
            ),
            (node.down_payment_cents || node.down_payment_percent) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["m" /* Steps */],
                { direction: 'vertical' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["m" /* Steps */].Step, {
                  status: node.down_payment_status === 'PAID' ? 'finish' : 'wait',
                  title: downPaymentTitle,
                  description: paymentItemDescription(node.down_payment_status)
                })
              )
            ),
            !(node.down_payment_cents || node.down_payment_percent) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'No down payment is due'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                'Additional Payments'
              ),
              'Remaining balance of',
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(((node.total_cents || 0) - (node.down_payment_cents || 0)) / 100, {
                  code: node.down_payment_currency
                })
              ),
              ' ',
              node.i_pplan_items.edges.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'split across ',
                node.i_pplan_items.edges.length,
                ' payments'
              ),
              node.i_pplan_items.edges.length === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'due on',
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_moment___default()(node.i_pplan_items.edges[0].node.due_at).format('L')
                )
              ),
              node.i_pplan_items.edges.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: '4em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__Modules__["m" /* Steps */],
                  { direction: 'vertical' },
                  node.i_pplan_items.edges.map(function (iPPlanItem) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["m" /* Steps */].Step, {
                      key: iPPlanItem.node.id || iPPlanItem.node.tempId,
                      status: iPPlanItem.node.status === 'PAID' ? 'finish' : 'wait',
                      title: getTitle(iPPlanItem),
                      description: paymentItemDescription(iPPlanItem.node.status)
                    });
                  })
                )
              )
            )
          ),
          !node.down_payment_distribution_type && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Full Payment'
            ),
            'A full payment of',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format((node.i_pplan_items.edges[0].node.amount_cents || 0) / 100, {
                code: node.i_pplan_items.edges[0].node.amount_currency
              })
            ),
            ' ',
            'is due on',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              __WEBPACK_IMPORTED_MODULE_2_moment___default()(node.i_pplan_items.edges[0].node.due_at).format('L')
            )
          )
        ),
        this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__App_PaymentMethods_NoPaymentMethods__["a" /* default */], {
          viewer: viewer,
          relay: relay,
          node: node,
          open: this.state.setupPaymentMethodsOpen,
          onClose: this.closeSetupPaymentMethods
        }),
        node.i_pplan_items.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { textAlign: 'center', padding: '2em' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            'This invoice has no payment plan'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
            basic: true,
            icon: 'plus',
            labelPosition: 'left',
            content: 'Add Plan'
          })
        )
      );
    }
  }]);

  return PaymentPlanShow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentPlanShow.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentPlanShow);

/***/ }),
/* 3125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);





var PPlanSummaryTotals = function PPlanSummaryTotals(_ref) {
  var localInvoice = _ref.localInvoice,
      getDownPayment = _ref.getDownPayment,
      getAdditionalPayments = _ref.getAdditionalPayments,
      getRemainingBalance = _ref.getRemainingBalance;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */].Row, {
      label: 'Invoice Total',
      value: __WEBPACK_IMPORTED_MODULE_2_currency_formatter___default.a.format((localInvoice.total_cents || 0) / 100, {
        code: 'USD'
      })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */].Row, {
      label: 'Down Payment',
      minus: true,
      value: __WEBPACK_IMPORTED_MODULE_2_currency_formatter___default.a.format(getDownPayment() / 100, { code: 'USD' })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */].Row, {
      label: 'Additional Payments',
      minus: true,
      value: __WEBPACK_IMPORTED_MODULE_2_currency_formatter___default.a.format(getAdditionalPayments() / 100, {
        code: 'USD'
      })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */].Break, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["l" /* SummaryTotals */].Row, {
      style: { fontWeight: 'bold' },
      label: 'Remaining Balance',
      value: __WEBPACK_IMPORTED_MODULE_2_currency_formatter___default.a.format(getRemainingBalance() / 100, {
        code: 'USD'
      })
    })
  );
};

PPlanSummaryTotals.propTypes = {
  getRemainingBalance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getAdditionalPayments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getDownPayment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  localInvoice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PPlanSummaryTotals);

/***/ }),
/* 3126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recipient_scss__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recipient_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Recipient_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecipientFields__ = __webpack_require__(1469);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var RecipientEditDesktop = function (_React$Component) {
  _inherits(RecipientEditDesktop, _React$Component);

  function RecipientEditDesktop(props) {
    _classCallCheck(this, RecipientEditDesktop);

    var _this = _possibleConstructorReturn(this, (RecipientEditDesktop.__proto__ || Object.getPrototypeOf(RecipientEditDesktop)).call(this, props));

    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.state = {
      submitted: false
    };
    return _this;
  }

  _createClass(RecipientEditDesktop, [{
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.closeHandler);
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update recipient',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset();
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit,
          className: __WEBPACK_IMPORTED_MODULE_5__Recipient_scss___default.a.active
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { padded: true, relaxed: true, stackable: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { columns: 1 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RecipientFields__["a" /* default */], {
                localRecipient: this.props.localRecipient,
                onChange: this.props.onChange,
                submitted: this.state.submitted
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], { reset: this.reset })
            )
          )
        )
      );
    }
  }]);

  return RecipientEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RecipientEditDesktop.propTypes = {
  localRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RecipientEditDesktop);

/***/ }),
/* 3127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecipientFields__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RecipientEditMobile = function (_React$Component) {
  _inherits(RecipientEditMobile, _React$Component);

  function RecipientEditMobile(props) {
    _classCallCheck(this, RecipientEditMobile);

    var _this = _possibleConstructorReturn(this, (RecipientEditMobile.__proto__ || Object.getPrototypeOf(RecipientEditMobile)).call(this, props));

    _this.reset = _this.reset.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.state = {
      submitted: false
    };
    return _this;
  }

  _createClass(RecipientEditMobile, [{
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(function () {
        setTimeout(function () {
          return _this2.props.closeHandler();
        }, 0);
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update recipient',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this3 = this;

      this.props.reset();
      setTimeout(function () {
        return _this3.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        {
          ref: 'form',
          className: 'ui form',
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this4.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecipientFields__["a" /* default */], {
              localRecipient: this.props.localRecipient,
              onChange: this.props.onChange,
              submitted: this.state.submitted
            })
          )
        )
      );
    }
  }]);

  return RecipientEditMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RecipientEditMobile.propTypes = {
  localRecipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RecipientEditMobile);

/***/ }),
/* 3128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_location__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_phone__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recipient_scss__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recipient_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Recipient_scss__);







var RecipientShow = function RecipientShow(_ref) {
  var recipient = _ref.recipient,
      readOnly = _ref.readOnly;

  var exists = recipient.recipient_first_name || recipient.recipient_last_name || recipient.recipient_company_name || recipient.recipient_phone || recipient.recipient_email || recipient.recipient_address;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    exists && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: [__WEBPACK_IMPORTED_MODULE_5__Recipient_scss___default.a.header, !readOnly ? __WEBPACK_IMPORTED_MODULE_5__Recipient_scss___default.a.headerEdit : ''].join(' ')
      },
      (recipient.recipient_first_name || recipient.recipient_last_name) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          recipient.recipient_first_name,
          ' ',
          recipient.recipient_last_name
        )
      ),
      recipient.recipient_company_name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            fontWeight: recipient.recipient_first_name || recipient.recipient_last_name ? 'normal' : 'bold'
          }
        },
        recipient.recipient_company_name
      ),
      recipient.recipient_address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap' } },
        recipient.recipient_address
      ),
      recipient.recipient_email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'mailto:' + recipient.recipient_email },
          recipient.recipient_email
        )
      ),
      recipient.recipient_phone && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3__lib_utils_phone__["a" /* default */].formatPhoneNumber(recipient.recipient_phone)
      )
    ),
    !exists && !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Client Name'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.subtext },
        'Company Name'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.subtext },
        '(555) 555-1212'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.subtext },
        'info@yourcompany.com'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.subtext },
        '123 Elm Street'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.subtext },
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_location__["a" /* default */].getLocalityString('San Francisco', 'CA', '94105')
      )
    )
  );
};

RecipientShow.propTypes = {
  recipient: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (RecipientShow);

/***/ }),
/* 3129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignatureBlockFields__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SignatureBlockEditDesktop = function (_React$Component) {
  _inherits(SignatureBlockEditDesktop, _React$Component);

  function SignatureBlockEditDesktop(props) {
    _classCallCheck(this, SignatureBlockEditDesktop);

    var _this = _possibleConstructorReturn(this, (SignatureBlockEditDesktop.__proto__ || Object.getPrototypeOf(SignatureBlockEditDesktop)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  _createClass(SignatureBlockEditDesktop, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        return _this2.props.closeHandler();
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update signature block',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset(e) {
      this.props.reset(this.props.index);
      this.props.closeHandler(e);
      e.stopPropagation();
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this3 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this3.props.closeHandler;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__SignatureBlocks_scss___default.a.active },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
          {
            onValidSubmit: this.onValidSubmit,
            onInvalidSubmit: this.onInvalidSubmit,
            style: { padding: '2em 3em' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignatureBlockFields__["a" /* default */], {
            localSignatureBlock: this.props.localSignatureBlock,
            onChange: this.props.onChange,
            submitted: this.state.submitted,
            isTemplate: this.props.isTemplate
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["j" /* DthcActions */], {
            reset: this.reset,
            'delete': this.delete,
            id: this.props.localSignatureBlock.id,
            isNew: this.props.isNew
          })
        )
      );
    }
  }]);

  return SignatureBlockEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SignatureBlockEditDesktop.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  delete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  localSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  isTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isNew: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (SignatureBlockEditDesktop);

/***/ }),
/* 3130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignatureBlockFields__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SignatureBlockEditMobile = function (_React$Component) {
  _inherits(SignatureBlockEditMobile, _React$Component);

  function SignatureBlockEditMobile(props) {
    _classCallCheck(this, SignatureBlockEditMobile);

    var _this = _possibleConstructorReturn(this, (SignatureBlockEditMobile.__proto__ || Object.getPrototypeOf(SignatureBlockEditMobile)).call(this, props));

    _this.state = {
      submitted: false
    };
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  _createClass(SignatureBlockEditMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit() {
      var _this2 = this;

      this.setState({ submitted: true });
      this.props.commitUpdate(this.props.index, function () {
        return _this2.props.closeHandler();
      });
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update signature block',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this3 = this;

      this.props.reset(this.props.index);
      setTimeout(function () {
        return _this3.props.closeHandler();
      }, 0);
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      var _this4 = this;

      e.preventDefault();
      this.props.delete(this.props.index, function () {
        return _this4.props.closeHandler;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var deleteButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */],
        { negative: true, fluid: true, type: 'button' },
        'Delete Signature Block'
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { ref: 'form', onValidSubmit: this.onValidSubmit, onInvalidSubmit: this.onInvalidSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
          {
            open: this.props.open,
            onClose: this.props.closeHandler,
            inline: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.reset },
                'Cancel'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: function onClick() {
                    return _this5.refs.form.submit();
                  } },
                'Save'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0 2em' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignatureBlockFields__["a" /* default */], {
                localSignatureBlock: this.props.localSignatureBlock,
                onChange: this.props.onChange,
                submitted: this.state.submitted,
                isTemplate: this.props.isTemplate
              }),
              this.props.delete && !this.props.isNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'center', marginTop: '2em' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["i" /* DeleteConfirmation */], { trigger: deleteButton, 'delete': this.delete, id: this.props.localSignatureBlock.id })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SignatureBlockEditMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SignatureBlockEditMobile.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  delete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  localSignatureBlock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  isTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isNew: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (SignatureBlockEditMobile);

/***/ }),
/* 3131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);






var TermsEditDesktop = function TermsEditDesktop(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      _reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
    { onSubmit: commitUpdate.bind(null, closeHandler) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
      { padded: true, relaxed: true, stackable: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        { columns: 1 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
            extended: true,
            value: value,
            onChange: onChange,
            placeholder: 'Contract terms and conditions'
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          { width: 16 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["j" /* DthcActions */], { reset: function reset(e) {
              _reset();closeHandler(e);e.stopPropagation();
            } })
        )
      )
    )
  );
};

TermsEditDesktop.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TermsEditDesktop);

/***/ }),
/* 3132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);





var TermsEditMobile = function TermsEditMobile(_ref) {
  var closeHandler = _ref.closeHandler,
      commitUpdate = _ref.commitUpdate,
      onChange = _ref.onChange,
      open = _ref.open,
      reset = _ref.reset,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */],
    { open: open, onClose: closeHandler, inline: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Header,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: 'item',
            onClick: function onClick(e) {
              reset();
              setTimeout(function () {
                return closeHandler(e);
              }, 0);
            }
          },
          'Cancel'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'right menu' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'item', onClick: commitUpdate.bind(null, closeHandler) },
          'Save'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modules__["f" /* MobileModal */].Content,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { onSubmit: commitUpdate.bind(null, closeHandler) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["l" /* TextEditor */], {
          extended: true,
          value: value,
          onChange: onChange,
          placeholder: 'Contract terms and conditions'
        })
      )
    )
  );
};

TermsEditMobile.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TermsEditMobile);

/***/ }),
/* 3133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);





var Cancellation = function Cancellation(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'How many days in advance must a client notify you to cancel the event booking?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'cancellationBeforeDays',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.cancellationBeforeDays,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'days'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'If the client informs you before the above timeframe, what percent of the total fees does the client still owe?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'cancellationPenalty',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.cancellationPenalty,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'percent'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'If the client informs you after the above timeframe, what percent of the total fees does the client still owe?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'lateCancellationPenalty',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.lateCancellationPenalty,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'percent'
    )
  );
};

Cancellation.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Cancellation);

/***/ }),
/* 3134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Option__ = __webpack_require__(531);






var ClientResponsibilities = function ClientResponsibilities(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange,
      yesNoChange = _ref.yesNoChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'How many weeks in advance of the event will the client need to submit their requests and planning materials?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'planningDeadline',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.planningDeadline,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'weeks'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Do you require the client to provide you a meal?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
        name: 'mealRequired',
        content: 'Yes',
        value: 'yes',
        radio: true,
        checked: contractVariables.mealRequired,
        onChange: yesNoChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
        name: 'mealRequired',
        content: 'No',
        value: 'no',
        radio: true,
        checked: !contractVariables.mealRequired,
        onChange: yesNoChange
      })
    )
  );
};

ClientResponsibilities.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  yesNoChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ClientResponsibilities);

/***/ }),
/* 3135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_written_number__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_written_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_written_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_currency_formatter__);



var getListString = function getListString(list) {
  var listString = '';
  list.map(function (item, index) {
    var delimiter = '';
    if (list.length > 1 && index < list.length - 1) {
      if (index === list.length - 2) {
        delimiter = list.length === 2 ? ' or ' : ', or ';
      } else {
        delimiter = ', ';
      }
    }
    listString = listString + item + delimiter;
    return item;
  });
  return listString;
};

/* harmony default export */ __webpack_exports__["a"] = (function (variables) {
  return '\n<p>\n  This Disc-Jockey Agreement is entered into as of the date in the\n  Signatures block (\u201CEffective Date\u201D) by and between the Vendor (\u201CDJ\u201D),\n  and Client (\u201CClient\u201D) as both are listed in the Signatures block\n  (hereinafter collectively, \u201Cparties\u201D and individually, a \u201Cparty\u201D).\n  This Disc-Jockey Agreement, together with the Schedule, Line Items and\n  Signatures, collectively form the \u201CAgreement.\u201D\n</p>\n<br />\n<p>The parties to this Agreement agree as follows:</p>\n<br />\n<p>\n  <strong>DEFINITIONS</strong>\n  <ol>\n    <li>\n      \u201CProject\u201D or \u201CServices\u201D refers to the disc-jockey and related\n      services described in the Line Items that Client is specifically\n      commissioning DJ to perform.\n    </li>\n    <li>\n      \u201CCancellation\u201D means that the Project is cancelled by Client and\n      not rescheduled. In the event of cancellation, Client will be\n      responsible for such fees, costs and charges as set forth herein.\n    </li>\n    <li>\n      \u201CPostponement\u201D is the rescheduling of the Project by the Client at\n      least ' + variables.postponementBeforeDays + ' days prior to the Project\n      to a mutually agreeable date, and no more than\n      ' + variables.postponementAfterDays + ' calendar days after the original\n      Project date. In the event of Postponement, Client will be\n      responsible for such fees, costs and charges as set forth herein.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>PAYMENT TERMS AND CONDITIONS</strong>\n  <ol>\n    <li>\n      <strong>Fees.</strong> As compensation for the Services, Client\n      agrees to pay the fees as set forth and agreed upon in the Line\n      Items.\n    </li>\n    <li>\n      <strong>Deposit.</strong> A non-refundable deposit may be required\n      by DJ to hold scheduled event dates. The deposit will be due upon\n      receipt of deposit invoice and prior to the commencement of the\n      Services.\n    </li>\n    <li>\n      <strong>Estimates.</strong> DJ will provide the Client with a cost\n      estimate upon request. The fees and expenses estimated by DJ are\n      for the original job description as presented by the Client and\n      detailed in the Line Items. Subsequent changes or actual job\n      conditions may result in additional charges as further described\n      in the section below entitled Additional Expenses.\n    </li>\n    <li>\n      <strong>Payment.</strong> Payments may be made by\n      ' + getListString(variables.paymentMethods) + '.\n    </li>\n    <li>\n      <strong>Billing.</strong> Payments shall be due on the date\n      specified in the payment plan. In the absense of a payment plan,\n      deposits are due immediately upon booking and the remaining\n      balance must be paid ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.paymentDaysBefore) + '\n      (' + variables.paymentDaysBefore + ') days prior to the commencement\n      of the Services. All payments will be made withoutsetoff,\n      counterclaim, recourse or other defense.\n    </li>\n    <li>\n      <strong>Late Payments.</strong> DJ may assess Client a late\n      payment charge on any amount which remains unpaid\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.paymentGracePeriod) + ' (' + variables.paymentGracePeriod + ')\n      days after it is due, computed at the rate of\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.interest) + ' percent (' + variables.interest + '%)\n      per month or the highest allowable by law, whichever is lower, on\n      the unpaid amount for every month the amount remains unpaid. In\n      the event the Client fails to make timely payment, Client will be\n      responsible for all reasonable expenses (including attorneys\u2019\n      fees) incurred by DJ in collecting such amounts. Nothing mentioned\n      herein will limit any additional rights and remedies available to\n      DJ at law, in equity and / or otherwise arising due to the default\n      of payment by the Client.\n    </li>\n    <li>\n      <strong>Expenses.</strong> Client will promptly reimburse DJ for\n      any reasonable business or travel expenses, including but not\n      limited to parking, tolls, permits and meals incurred in\n      connection with the provision of Services. DJ will provide\n      receipts to Client for such expenses. Any event over\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.travelRadius) + ' (' + variables.travelRadius + ')\n      miles from ' + variables.travelOrigin + ' may be assessed a travel fee\n      and require overnight accommodations at Client\u2019s expense. ' + (variables.mealRequired ? 'Client agrees to provide meals at the event as well as adequate time for\n        the meal (i.e. during the regular meal). For events longer than\n        eight (8) hours, two (2) meals will be provided.' : '') + '\n    </li>\n    <li>\n      <strong>Taxes.</strong> Client will be responsible for, and agrees\n      to pay, all taxes imposed by the United States, any state or local\n      government, or other taxing authority, on all goods and/or\n      services provided under this Agreement.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>ADDITIONAL EXPENSES</strong>\n  <ol>\n    <li>\n      Client shall be responsible for any additional expenses and fees\n      that result from any requests by Client for changes or additions\n      to the Project. Changes or additions should be made in advance, in\n      writing (email acceptable), and may require the parties to add\n      additional Line Items. However, Client understands and agrees that\n      written approvals of modifications to the Project or a written\n      estimate of fees for the Services may not be possible due to the\n      time constraints. As such, Clients shall be bound by any oral\n      instructions provided to DJ or any of its representatives by\n      Client or any of Client\u2019s representatives at the time of the\n      Project or thereafter. While the DJ cannot guarantee availability\n      to perform longer than the agreed upon timeframe, if possible, the\n      DJ\u2019s overtime hours will be billed at ' + __WEBPACK_IMPORTED_MODULE_1_currency_formatter___default.a.format(variables.overtimeRate, { code: variables.overtimeCurrency }) + ' per\n      half-hour.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>RESPONSIBILITIES</strong>\n  <ol>\n    <li>\n      Each party represents and warrants that it has full power and\n      authority to enter into and perform this Agreement.\n    </li>\n    <li>\n      The Client(s) signing the contract will be the only person(s) with\n      authority over event decisions, including music choices,\n      timelines, etc.\n    </li>\n    <li>\n      Client is to provide addresses to all locations, emergency\n      telephone numbers, an itinerary of the day, special toasts,\n      readings and requested play lists or songs at least\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.planningDeadline) + ' (' + variables.planningDeadline + ')\n      ' + variables.planningDeadlineUnits + '\n      prior to the event. DJ shall make reasonable efforts to play music\n      requests, but shall not be held responsible if certain selections\n      are unavailable, including those that cannot be legally obtained.\n      The DJ will make extra effort to have music requests available\n      that are received in writing at least\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.planningDeadline) + ' (' + variables.planningDeadline + ')\n      ' + variables.planningDeadlineUnits + ' prior to the event. The DJ\n      reserves the right to deny inappropriate/explicit requests from\n      both the Client and the Client\u2019s guests.\n    </li>\n    <li>\n      The DJ will not be held accountable for any failure to play a\n      specific song.\n    </li>\n    <li>\n      ' + (variables.outdoorSurcharge ? 'Outdoor events may be subject to additional fees due to increased\n        labor costs and risk of damage to equipment.' : '') + '\n        The DJ reserves the right to protect DJ\u2019s equipment and not perform\n        if weather conditions pose a threat to the safety of the DJ or DJ\u2019s\n        equipment.\n    </li>\n    <li>\n      While the Parties agree to work together, the Client agrees to\n      grant the DJ final control of the entertainment timeline.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>VENUE</strong>\n  <ol>\n    <li>\n      The DJ is limited by the rules and guidelines of the location(s)\n      and site management. The Client agrees to accept the technical\n      results of their imposition on the DJ. Negotiation with the\n      officials for moderation of guidelines is the Client\u2019s\n      responsibility; the DJ will offer technical recommendations only.\n    </li>\n    <li>\n      The Client is responsible for acquiring all permits and necessary\n      permission for all locations on which the DJ will be performing\n      services.\n    </li>\n    <li>\n      ' + (variables.setupInstructionsRequired ? variables.setupInstructions : '') + '\n      Client will be solely responsible for any additional fees charged by\n      the venue, including fees for power supply, and other set-up, loading and\n      unloading of DJ equipment.\n    </li>\n    <li>\n      It is the client\u2019s responsibility to coordinate with the venue to\n      provide for proper setup and breakdown of the DJ equipment as well\n      as proper access for transport, as needed, via stairs, ramp and/or\n      elevator. There may be additional labor fees if there is no\n      elevator or ramp access.\n    </li>\n    <li>\n      The DJ reserves to right to leave the location of the event if the\n      DJ experiences inappropriate, threatening, hostile or offensive\n      behavior from person(s) at the event; or in the event that the\n      safety of the DJ is in question.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>\n    LATENESS, POSTPONEMENT, CANCELLATION & LIQUIDATED DAMAGES\n  </strong>\n  <ol>\n    <li>\n      <strong>Lateness.</strong> If the Client is late and/or delays an\n      event, the Client will be responsible for payment at DJ\u2019s standard\n      hourly rates for such period.\n    </li>\n    <li>\n      <strong>Postponement.</strong> Client shall provide DJ with notice\n      of a Postponement at least\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.postponementBeforeDays) + ' (' + variables.postponementBeforeDays + ')\n      days prior to the scheduled Project. In the event that Client\n      postpones less than ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.postponementBeforeDays) + '\n      (' + variables.postponementBeforeDays + ') days prior to the scheduled Project,\n      Client shall pay to DJ a Postponement fee in the amount of\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.postponementPenalty) + ' percent (' + variables.postponementPenalty + '%)\n      of the Fees plus any expenses incurred by DJ. Client agrees to be\n      solely responsible for all expenses incurred by DJ to reschedule\n      the Project due to Client\u2019s Postponement, regardless of whether or\n      not Client provided ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.postponementBeforeDays) + '\n      (' + variables.postponementBeforeDays + ') days\u2019 notice.\n    </li>\n    <li>\n      <strong>Cancellation.</strong> Therefore, Client agrees to notify\n      DJ of a Cancellation at least\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.cancellationBeforeDays) + ' (' + variables.cancellationBeforeDays + ')\n      days prior to the Project commencement date in order to minimize\n      DJ\u2019s costs, expenses, and loss of income. In the event that Client\n      cancels this Agreement at least\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.cancellationBeforeDays) + ' (' + variables.cancellationBeforeDays + ')\n      days prior to the date set for commencement of the Project, Client\n      agrees to pay a Cancellation fee in the amount of\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.cancellationPenalty) + ' percent (' + variables.cancellationPenalty + '%)\n      of the Fees in addition to all other costs incurred by DJ. Due to\n      the inability of DJ to perform other services during time reserved\n      for Client, if DJ receives notification of Client\u2019s Cancellation\n      of the Project hereunder with less than\n      ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.cancellationBeforeDays) + ' (' + variables.cancellationBeforeDays + ')\n      days\u2019 notice, Client shall be responsible for ' + __WEBPACK_IMPORTED_MODULE_0_written_number___default()(variables.lateCancellationPenalty) + '\n      percent (' + variables.lateCancellationPenalty + '%) of the Fees.\n      Said Cancellation fees are designed to cover\n      the loss that DJ would not otherwise have incurred had the Project\n      been commenced as scheduled. Client also agrees to bear sole\n      responsibility for any expenses incurred by DJ as a result of\n      Client\u2019s Cancellation of this Agreement at any time.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>TERMINATION</strong>\n  <ol>\n    <li>\n      Either party may terminate this Agreement upon fifteen (15) days\n      written notice if the other party materially breaches any\n      provisions of this Agreement, and such breach has not been cured\n      after notice of the same within such fifteen (15) day period.\n    </li>\n    <li>\n      DJ may suspend performance under this Agreement immediately upon\n      written notice to Client if Client neglects to make any required\n      payments when due.\n    </li>\n    <li>\n      If this Agreement is terminated for any reason, the rights of the\n      Client arising under the Agreement shall terminate with immediate\n      effect but the obligations of the Client that by their nature are\n      meant to survive (i.e. unpaid Fees), shall survive such\n      termination.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>WARRANTY</strong>\n  <ol>\n    <li>\n      Each party represents and warrants that: (a) it has full power and\n      authority to enter into this Agreement; (b) the person signing\n      this Agreement on such party\u2019s behalf has been duly authorized and\n      empowered to enter into this Agreement and (d) that it will\n      perform its obligations or exercise its rights hereunder in\n      conformance with all applicable laws, rules, regulations and\n      guidelines.\n    </li>\n    <li>\n      DJ hereby represents, warrants and covenants to Client that DJ\n      will perform the Services in a professional and workmanlike manner\n      and in accordance with all reasonable professional standards for\n      such services.\n    </li>\n    <li>\n      CLIENT UNDERSTANDS AND AGREES THAT, EXCEPT AS OTHERWISE SET FORTH\n      HEREIN, THE SERVICES AND WORK ARE PROVIDED ON AN \u201CAS IS\u201D AND \u201CAS\n      AVAILABLE\u201D BASIS ONLY, AND USE OF DJ\u2019S SERVICES IS AT ITS OWN\n      RISK. EXCEPT AS OTHERWISE SET FORTH HEREIN, DJ DOES NOT MAKE AND\n      HEREBY DISCLAIMS ANY AND ALL EXPRESS, IMPLIED OR STATUTORY\n      WARRANTIES, CONDITIONS, REPRESENTATIONS, INCLUDING BUT NOT LIMITED\n      TO, THE IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR\n      A PARTICULAR PURPOSE, ACCURACY, TIMELINESS, COMPLETENESS,\n      COMPLIANCE WITH LAW, ABSENCE OF VIRUSES OR OTHER MALICIOUS\n      SOFTWARE, ADEQUACY AND NON-INFRINGEMENT OR WARRANTY ARISING OUT OF\n      COURSE OF PERFORMANCE, COURSE OF DEALING OR USAGE OR TRADE\n      PRACTICE.\n    </li>\n    <li>\n      Client agrees that DJ has made no agreements, representations or\n      warranties other than those expressly set forth in this Agreement,\n      and that no future agreement, representation or warranty of DJ\n      with regard to Services provided under this agreement shall be\n      effective unless expressly stated in an amendment to this\n      Agreement signed by both parties.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>LIMITATION OF LIABILITY</strong>\n  <ol>\n    <li>\n      It is expressly agreed that in no event shall DJ be liable for any\n      special, indirect, consequential, or exemplary damages.\n    </li>\n    <li>\n      DJ\u2019s sole and exclusive liability and Client\u2019s sole and exclusive\n      remedy for all claims of defects in the Services will be, in DJ\u2019s\n      sole discretion, to either: (A) re-perform such Services; or (B)\n      partially credit or refund the Fees paid by Client for such\n      Services.\n    </li>\n    <li>\n      In the unlikely event of unforeseen illness or any other\n      circumstances beyond DJ\u2019s control, a substitute disc-jockey of\n      high qualifications, may be dispatched by DJ (if approved by\n      Client).\n    </li>\n    <li>\n      Because some states or jurisdictions do not allow the exclusion or\n      the limitation of liability for consequential or incidental\n      damages, in such states or jurisdictions, DJ\u2019s liability shall be\n      limited to the maximum extent permitted by law.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>INDEMNIFICATION</strong>\n  <ol>\n    <li>\n      Client agrees to indemnify, defend and hold harmless DJ, and its\n      directors, officers, employees, agents and representatives from\n      and against any and all losses, damages, demands, claims, costs,\n      penalties, injuries, interest, or expenses (including without\n      limitation reasonable attorney fees) (\u201CLosses\u201D) arising out of or\n      relating to: (i) any breach of any warranty, representation,\n      covenant or agreement made by Client in this Agreement, (ii) any\n      violation of federal, state or local laws, rules or regulations,\n      or (iii) any act or omission (negligent, willful or otherwise) or\n      misconduct by Client, its directors, officers, Clients, employees,\n      contractors, or agents.\n    </li>\n    <li>\n      If any equipment used by DJ during the event is damaged or\n      destroyed by Client, any of Client\'s invitees, guests, affiliates,\n      friends or family members or any other person hired by Client in\n      connection with the event, Client shall reimburse DJ for 100% of\n      the costs to fix such damage, including insurance deductibles or\n      in the case of destruction 100% of the replacement cost of such\n      equipment.\n    </li>\n  </ol>\n</p>\n<p>\n  <strong>MISCELLANEOUS PROVISIONS</strong>\n  <ol>\n    <li>\n      <strong>Independent Contractor:</strong> The parties to the\n      Agreement are independent contractors and nothing in the Agreement\n      shall be deemed to make either party an agent, employee, or\n      partner of the other party. Neither party shall have any authority\n      to bind, commit, or otherwise obligate the other party in any\n      manner whatsoever.\n    </li>\n    <li>\n      <strong>Publicity:</strong> The DJ may take videos and/or\n      photographs at the event and use such for its own business or\n      promotional purposes in any medium, including DJ\u2019s website, social\n      media platforms, advertisements, etc.\n    </li>\n    <li>\n      <strong>Entire Agreement:</strong> This Agreement constitutes the\n      entire agreement between the parties regarding the subject matter\n      hereof and supersedes all proposals, prior discussions and\n      writings between the parties with respect thereto.\n    </li>\n    <li>\n      <strong>Governing Law:</strong> This Agreement shall be governed\n      by and construed under the laws of the State of ' + variables.state + '\n      without regard to its conflict of law principles. The parties\n      agree that the application of the United Nations Convention on\n      Contracts for the International Sale of Goods does not apply to\n      this Agreement and is strictly excluded. The Parties irrevocably\n      consent and submit to personal jurisdiction in the state and\n      federal courts of ' + variables.county + ' County, ' + variables.state + ',\n      for all matters arising under this Agreement.\n    </li>\n    <li>\n      <strong>Arbitration:</strong> If any dispute, controversy or claim\n      arises between the parties with respect to this Agreement, the\n      parties agree that they will submit the matter to binding\n      arbitration before a single arbitrator with the American\n      Arbitration Association in ' + variables.county + ' County, in\n      accordance with the applicable rules promulgated by the American\n      Arbitration Association as permitted by the laws of the State of\n      ' + variables.state + '. The prevailing party in such arbitration shall\n      be awarded, in addition to costs, reasonable attorney\u2019s fees as\n      fixed by the arbitrator(s). Full rights of discovery, including\n      the right to depose, shall be allowed in the course of such\n      arbitration. The decision of the arbitrator will be final and\n      nonappealable and may be enforced according to the laws of the\n      State of ' + variables.state + '.\n    </li>\n    <li>\n      <strong>Expenses and Attorneys\u2019 Fees:</strong> In the event any\n      action is brought to enforce any provision of the Agreement or to\n      declare a breach of the Agreement, the prevailing party shall be\n      entitled to recover, in addition to any other amounts awarded,\n      reasonable legal and other related costs and expenses, including\n      attorney\u2019s fees, incurred thereby.\n    </li>\n    <li>\n      <strong>Modifications and Waivers:</strong> This Agreement may not\n      be modified except by a writing signed by authorized\n      representatives of both parties. A waiver by any party of its\n      rights under this Agreement shall not be binding unless contained\n      in a writing signed by an authorized representative of the party\n      waiving its rights. The non-enforcement or waiver of any provision\n      on any occasion shall not constitute a waiver of such provision on\n      any other occasions unless expressly so agreed in writing. It is\n      agreed that no usage of trade or other regular practice or method\n      of dealing between or among the parties to this Agreement shall be\n      used to modify, interpret, supplement, or alter in any manner the\n      terms of this Agreement.\n    </li>\n    <li>\n      <strong>Severability:</strong> It is understood and agreed by the\n      parties to this Agreement that it is their intention that if a\n      court of competent jurisdiction shall determine that any of the\n      terms of this Agreement are invalid or otherwise unenforceable,\n      that such court shall substitute terms, therefore, with such court\n      determines are enforceable, so as to result in the enforcement of\n      the original terms to the maximum extent permitted by law.\n    </li>\n    <li>\n      Notices: Any notice, approval or consent required or permitted\n      under this Agreement shall be in writing and sent to the email\n      addresses set forth in the Signatures block.\n    </li>\n    <li>\n      <strong>No Third party Beneficiaries:</strong> Nothing express or\n      implied in this Agreement is intended to confer, nor shall confer,\n      upon any person or entity other than the parties, their licensors,\n      and their respective successors or assigns any rights, remedies,\n      obligations, or liabilities whatsoever.\n    </li>\n    <li>\n      <strong>Assignment:</strong> Neither party may assign this\n      Agreement without the prior written consent of the other party.\n      Notwithstanding the foregoing, This Agreement shall be binding\n      upon and shall benefit the parties and their respective successors\n      and permitted assigns.\n    </li>\n    <li>\n      <strong>Interpretation:</strong> Section headings are for\n      reference only, and shall not be construed as substantive parts of\n      this Agreement. Each capitalized term used in this Agreement\n      (including any schedule or exhibit of this Agreement) shall have\n      the meaning attributed to it in any part of this Agreement\n      (including any such Line Items, schedules or exhibits).\n    </li>\n    <li>\n      <strong>Survival:</strong> Client acknowledges and agrees that all\n      provisions which by their terms contemplate survival shall survive\n      the termination or expiration of this Agreement regardless of the\n      cause of such termination.\n    </li>\n    <li>\n      <strong>Force Majeure:</strong> Neither party shall be liable to\n      the other party for any delay or failure of said party to perform\n      its obligations hereunder (except for payment obligations) if such\n      delay or failure arises from any cause or causes beyond the\n      reasonable control of such party. Such causes shall include, but\n      are not limited to, acts of God, floods, fires, theft, loss of\n      electricity or other utilities.\n    </li>\n    <li>\n      <strong>Counterparts:</strong> This Agreement may be signed in\n      several counterparts, and all counterparts so executed shall\n      constitute one Agreement, binding upon the parties hereto.\n    </li>\n    <li>\n      <strong>Electronic Document:</strong> This Agreement may be signed\n      electronically using a means reasonably designed to acknowledge\n      assent. If this Agreement is electronically signed, it: (a) is\n      considered a "writing" or "in writing," (b) is deemed for all\n      purposes as physically "signed," (c) is deemed an "original" when\n      printed or copied from electronic files or records established and\n      maintained in the normal course of business, and (d) satisfies any\n      legal formalities requiring that agreements be in writing. Neither\n      Party shall contest the admissibility of copies of this Agreement\n      (or printed version of same) under either the business records\n      exception to the hearsay rule or the best evidence rule or\n      otherwise on the basis that the Agreement was originated, signed\n      or maintained in electronic form. Other than an original hand\n      written signature or an electronic signature of the same formality\n      used to originally execute this Agreement, no other communication\n      between the Parties (such as email, voice mail or fax without a\n      signature) shall be construed as a signature to this Agreement (or\n      any amendments hereto or any waiver hereof).\n    </li>\n  </ol>\n</p>\n';
});

/***/ }),
/* 3136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Option__ = __webpack_require__(531);






var Fees = function Fees(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange,
      yesNoChange = _ref.yesNoChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What is your overtime fee per half hour?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */],
      {
        name: 'overtimeRate',
        type: 'currency',
        placeholder: '$100.00',
        value: contractVariables.overtimeRate,
        onChange: textFieldChange,
        required: true,
        validationError: 'Required',
        inline: true
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format___default.a, {
        thousandSeparator: true,
        prefix: '$',
        decimalScale: 2,
        fixedDecimalScale: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Do you charge an additional fee for outdoor events?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["g" /* SelectableBlock */], {
        name: 'outdoorSurcharge',
        content: 'Yes',
        value: 'yes',
        radio: true,
        checked: contractVariables.outdoorSurcharge,
        onChange: yesNoChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["g" /* SelectableBlock */], {
        name: 'outdoorSurcharge',
        content: 'No',
        value: 'no',
        radio: true,
        checked: !contractVariables.outdoorSurcharge,
        onChange: yesNoChange
      })
    )
  );
};

Fees.propTypes = {
  yesNoChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Fees);

/***/ }),
/* 3137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_states__ = __webpack_require__(3473);






var Geo = function Geo(_ref) {
  var contractVariables = _ref.contractVariables,
      stateFieldChange = _ref.stateFieldChange,
      textFieldChange = _ref.textFieldChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What state are you located in?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["f" /* FloatingLabelSelect */], {
      name: 'state',
      value: contractVariables.state,
      type: 'select',
      onChange: stateFieldChange,
      placeholder: 'Select State...',
      options: __WEBPACK_IMPORTED_MODULE_4__lib_utils_states__["a" /* default */],
      required: true,
      inline: true,
      style: { minWidth: '85px' },
      search: true,
      validationError: 'Required'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What county are you located in?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      name: 'county',
      type: 'text',
      inline: true,
      required: true,
      placeholder: 'Orange',
      validationError: 'Required',
      value: contractVariables.county,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'County'
    )
  );
};

Geo.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  stateFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Geo);

/***/ }),
/* 3138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);





var LateFees = function LateFees(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'How many days after an invoice is due will you charge a late fee?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'paymentGracePeriod',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.paymentGracePeriod,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'days'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What percentage interest will you charge, per month, for late payments?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'interest',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.interest,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'percent'
    )
  );
};

LateFees.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LateFees);

/***/ }),
/* 3139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Option__ = __webpack_require__(531);






var PaymentMethods = function PaymentMethods(_ref) {
  var checkboxChange = _ref.checkboxChange,
      contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange;

  var defaultPaymentMethods = [{ label: 'Cash', value: 'cash' }, { label: 'Check', value: 'check' }, { label: 'Credit Card', value: 'credit card' }];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What payment methods do you accept?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    defaultPaymentMethods.map(function (method, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__Option__["a" /* default */],
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
          name: 'paymentMethods',
          label: method.label,
          value: method.value,
          content: method.label,
          checkbox: true,
          checked: contractVariables.paymentMethods.includes(method.value),
          onChange: checkboxChange
        })
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'How many days prior to the event is the full balance due?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'paymentDaysBefore',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.paymentDaysBefore,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'days'
    )
  );
};

PaymentMethods.propTypes = {
  checkboxChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PaymentMethods);

/***/ }),
/* 3140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);





var Postponement = function Postponement(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'How many days in advance must a client notify you to reschedule the event?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'postponementBeforeDays',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.postponementBeforeDays,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'days'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'If the client notifies you later than the above timeframe, what additional charge is assessed, as a percentage of the original total?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'postponementPenalty',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.postponementPenalty,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'percent'
    )
  );
};

Postponement.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Postponement);

/***/ }),
/* 3141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutability_helper__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DJContract__ = __webpack_require__(3135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentMethods__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fees__ = __webpack_require__(3136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LateFees__ = __webpack_require__(3138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Travel__ = __webpack_require__(3142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Client__ = __webpack_require__(3134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Venue__ = __webpack_require__(3143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Postponement__ = __webpack_require__(3140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Cancellation__ = __webpack_require__(3133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Geo__ = __webpack_require__(3137);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var initialTerms = {
  postponementBeforeDays: 90,
  postponementAfterDays: 60,
  paymentGracePeriod: 7,
  paymentDaysBefore: 14,
  interest: 2,
  travelRadius: 30,
  travelOrigin: '',
  overtimeRate: 100,
  overtimeCurrency: 'USD',
  planningDeadline: 2,
  planningDeadlineUnits: 'weeks',
  postponementPenalty: 25,
  cancellationBeforeDays: 60,
  cancellationPenalty: 50,
  lateCancellationPenalty: 100,
  state: '',
  county: '',
  paymentMethods: ['cash', 'check', 'credit card'],
  mealRequired: false,
  outdoorSurcharge: true,
  setupInstructionsRequired: false,
  setupInstructions: 'Client will ensure DJ has adequate space for equipment and furnishings, and in any event, no less than a 6 x 6’ area with a 6’ table with skirting and linen. In addition, DJ table must be near or adjacent to the dance floor as well as be located within fifty (50) feet of at least (2) dedicated 20-amp circuits.'
};

var ContractBuilder = function (_React$Component) {
  _inherits(ContractBuilder, _React$Component);

  function ContractBuilder(props) {
    _classCallCheck(this, ContractBuilder);

    var _this = _possibleConstructorReturn(this, (ContractBuilder.__proto__ || Object.getPrototypeOf(ContractBuilder)).call(this, props));

    _this.state = {
      contractVariables: initialTerms
    };
    _this.openModal = _this.openModal.bind(_this);
    _this.checkboxChange = _this.checkboxChange.bind(_this);
    _this.stateFieldChange = _this.stateFieldChange.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.yesNoChange = _this.yesNoChange.bind(_this);
    _this.save = _this.save.bind(_this);
    return _this;
  }

  _createClass(ContractBuilder, [{
    key: 'openModal',
    value: function openModal() {
      this.setState({ contractVariables: initialTerms });
    }
  }, {
    key: 'checkboxChange',
    value: function checkboxChange(e, _ref) {
      var checked = _ref.checked,
          name = _ref.name,
          value = _ref.value;

      if (checked) {
        this.setState(__WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state, {
          contractVariables: _defineProperty({}, name, { $push: [value] })
        }));
      } else {
        this.setState(__WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state, {
          contractVariables: _defineProperty({}, name, {
            $splice: [[this.state.contractVariables[name].indexOf(value), 1]]
          })
        }));
      }
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.setState(__WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state, {
        contractVariables: _defineProperty({}, e.target.name, { $set: e.target.value })
      }));
    }
  }, {
    key: 'stateFieldChange',
    value: function stateFieldChange(e) {
      this.setState(__WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state, {
        contractVariables: {
          state: { $set: e.target.value }
        }
      }));
    }
  }, {
    key: 'yesNoChange',
    value: function yesNoChange(e, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;

      this.setState(__WEBPACK_IMPORTED_MODULE_3_immutability_helper___default()(this.state, {
        contractVariables: _defineProperty({}, name, { $set: value === 'yes' })
      }));
    }
  }, {
    key: 'save',
    value: function save(model, resetForm, invalidateForm, successCb) {
      this.props.save(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__DJContract__["a" /* default */])(this.state.contractVariables), successCb);
    }
  }, {
    key: 'render',
    value: function render() {
      var contractVariables = this.state.contractVariables;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["e" /* Wizard */], {
        closeOnDimmerClick: false,
        steps: [{
          component: __WEBPACK_IMPORTED_MODULE_5__PaymentMethods__["a" /* default */],
          componentProps: {
            checkboxChange: this.checkboxChange,
            contractVariables: contractVariables,
            textFieldChange: this.textFieldChange
          },
          title: 'Payment Methods'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_6__Fees__["a" /* default */],
          componentProps: {
            yesNoChange: this.yesNoChange,
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables
          },
          title: 'Overtime and Additional Fees'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_7__LateFees__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables
          },
          title: 'Late Fees'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_8__Travel__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables
          },
          title: 'Travel Fees'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_9__Client__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables,
            yesNoChange: this.yesNoChange
          },
          title: 'Client Responsibilities'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_10__Venue__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables,
            yesNoChange: this.yesNoChange
          },
          title: 'Venue Requirements'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_11__Postponement__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables
          },
          title: 'Postponement'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_12__Cancellation__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            contractVariables: contractVariables
          },
          title: 'Cancellation'
        }, {
          component: __WEBPACK_IMPORTED_MODULE_13__Geo__["a" /* default */],
          componentProps: {
            textFieldChange: this.textFieldChange,
            stateFieldChange: this.stateFieldChange,
            contractVariables: contractVariables
          },
          title: 'Your Location',
          actions: { primary: { type: 'submit' } },
          formProps: { onValidSubmit: this.save, onInvalidSubmit: this.save }
        }],
        trigger: this.props.trigger,
        onOpen: this.openModal,
        showProgress: true
      });
    }
  }]);

  return ContractBuilder;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractBuilder.propTypes = {
  save: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractBuilder);

/***/ }),
/* 3142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss__);





var Travel = function Travel(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Up to how many miles will you travel before charging a travel fee?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineField,
      name: 'travelRadius',
      type: 'number',
      inline: true,
      required: true,
      validationError: 'Required',
      value: contractVariables.travelRadius,
      onChange: textFieldChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__TermsBuilder_scss___default.a.inlineFieldLabel },
      'miles'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'What is the starting location when calculating travel distance?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
      name: 'travelOrigin',
      type: 'text',
      inline: true,
      required: true,
      placeholder: 'Albany, NY',
      validationError: 'Required',
      value: contractVariables.travelOrigin,
      onChange: textFieldChange
    })
  );
};

Travel.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Travel);

/***/ }),
/* 3143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Option__ = __webpack_require__(531);





var Venue = function Venue(_ref) {
  var contractVariables = _ref.contractVariables,
      textFieldChange = _ref.textFieldChange,
      yesNoChange = _ref.yesNoChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Do you have specific venue requirements for setup?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
        name: 'setupInstructionsRequired',
        content: 'Yes',
        value: 'yes',
        radio: true,
        checked: contractVariables.setupInstructionsRequired,
        onChange: yesNoChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Option__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["g" /* SelectableBlock */], {
        name: 'setupInstructionsRequired',
        content: 'No',
        value: 'no',
        radio: true,
        checked: !contractVariables.setupInstructionsRequired,
        onChange: yesNoChange
      })
    ),
    contractVariables.setupInstructionsRequired && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        'What are your setup requirements?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
        name: 'setupInstructions',
        type: 'text',
        autoHeight: true,
        required: true,
        validationError: 'Required',
        value: contractVariables.setupInstructions,
        onChange: textFieldChange
      })
    )
  );
};

Venue.propTypes = {
  contractVariables: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  textFieldChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  yesNoChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Venue);

/***/ }),
/* 3144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Document_Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DocumentTitleTextArea = function (_React$Component) {
  _inherits(DocumentTitleTextArea, _React$Component);

  function DocumentTitleTextArea(props) {
    _classCallCheck(this, DocumentTitleTextArea);

    var _this = _possibleConstructorReturn(this, (DocumentTitleTextArea.__proto__ || Object.getPrototypeOf(DocumentTitleTextArea)).call(this, props));

    _this.state = {
      title: _this.props.title
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(DocumentTitleTextArea, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.commitUpdate();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({ title: e.target.value });
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
        { onBlur: this.props.closeHandler },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["i" /* TextArea */], {
          value: this.state.title,
          placeholder: this.props.placeholder,
          rows: 1,
          name: 'title',
          autoComplete: 'off',
          autoFocus: true,
          fluid: true,
          onChange: this.handleChange,
          className: [__WEBPACK_IMPORTED_MODULE_3__Document_Document_scss___default.a.titleTextArea, this.props.textAlign === 'right' ? __WEBPACK_IMPORTED_MODULE_3__Document_Document_scss___default.a.alignRight : ''].join(' ')
        })
      );
    }
  }]);

  return DocumentTitleTextArea;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

DocumentTitleTextArea.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  textAlign: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DocumentTitleTextArea);

/***/ }),
/* 3145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContractTemplateBrand = function (_React$Component) {
  _inherits(ContractTemplateBrand, _React$Component);

  function ContractTemplateBrand(props) {
    _classCallCheck(this, ContractTemplateBrand);

    var _this = _possibleConstructorReturn(this, (ContractTemplateBrand.__proto__ || Object.getPrototypeOf(ContractTemplateBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromContractTemplate()
    };
    _this.getBrandFromContractTemplate = _this.getBrandFromContractTemplate.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateBrand, [{
    key: 'getBrandFromContractTemplate',
    value: function getBrandFromContractTemplate() {
      return {
        brand_header: this.props.node.brand.header
      };
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3156);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromContractTemplate();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromContractTemplate(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return ContractTemplateBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractTemplateBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateBrand);

/***/ }),
/* 3146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header__ = __webpack_require__(3148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Brand__ = __webpack_require__(3145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Logo__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LineItems__ = __webpack_require__(3150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SignatureBlocks__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Terms__ = __webpack_require__(3153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Actions__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Library__ = __webpack_require__(3149);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var ContractTemplateComponent = (_temp = _class = function (_React$Component) {
  _inherits(ContractTemplateComponent, _React$Component);

  function ContractTemplateComponent(props) {
    _classCallCheck(this, ContractTemplateComponent);

    var _this = _possibleConstructorReturn(this, (ContractTemplateComponent.__proto__ || Object.getPrototypeOf(ContractTemplateComponent)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(ContractTemplateComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.params.action === 'edit';
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isLargeScreen = this.state.window.width >= 1280;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Actions__["a" /* default */], {
        node: this.props.node,
        params: this.props.params,
        relay: this.props.relay,
        router: this.props.router,
        windowDimensions: this.state.window,
        viewer: this.props.viewer
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_sidebar___default.a,
          {
            sidebar: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App_SidebarComponent__["a" /* default */], {
              setSidebarOpenState: this.onSetSidebarOpen,
              router: this.props.router,
              viewer: this.props.viewer
            }),
            sidebarClassName: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.sidebar,
            open: this.state.sidebarOpen,
            onSetOpen: this.onSetSidebarOpen,
            touch: false
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Header__["a" /* default */], {
            toggleSidebar: this.toggleSidebar,
            sidebarOpen: this.state.sidebarOpen,
            document: this.props.node,
            relay: this.props.relay,
            windowDimensions: this.state.window,
            router: this.props.router,
            params: this.props.params,
            viewer: this.props.viewer
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["s" /* Container */],
            { className: [__WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.container].join(' ') },
            !isLargeScreen && this.state.window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                { columns: 'equal' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  ActionsMenu
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["t" /* Segment */],
              null,
              isLargeScreen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["u" /* Rail */],
                {
                  position: 'right',
                  close: true,
                  className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionsMenuDesktop
                },
                ActionsMenu
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */],
                { padded: true, relaxed: true, stackable: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Logo__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Brand__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column, null)
                ),
                (this.canEdit() || this.props.node.c_template_line_items.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.heading },
                      'Line Items'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__LineItems__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      canEdit: this.canEdit()
                    })
                  )
                ),
                this.canEdit() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Library__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      viewer: this.props.viewer
                    })
                  )
                ),
                (this.canEdit() || this.props.node.terms) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.heading },
                      'Terms and Conditions'
                    )
                  )
                ),
                (this.canEdit() || this.props.node.terms) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal', className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Terms__["a" /* default */], {
                      node: this.props.node,
                      relay: this.props.relay,
                      canEdit: this.canEdit()
                    })
                  )
                ),
                (this.canEdit() || this.props.node.c_template_signature_blocks.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.section },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 16 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.heading },
                      'Signatures'
                    )
                  )
                ),
                (this.canEdit() || this.props.node.c_template_signature_blocks.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SignatureBlocks__["a" /* default */], {
                      relay: this.props.relay,
                      node: this.props.node,
                      canEdit: this.canEdit()
                    })
                  )
                )
              )
            )
          )
        ),
        !this.props.node && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App_404__["a" /* default */], { viewer: this.props.viewer }),
          !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return ContractTemplateComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__App_Authenticate__["a" /* default */])(ContractTemplateComponent));

/***/ }),
/* 3147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContractTemplateComponent__ = __webpack_require__(3146);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__ContractTemplateComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3157);
  },
  viewer: function viewer() {
    return __webpack_require__(3158);
  }
}));

/***/ }),
/* 3148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Title__ = __webpack_require__(3154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var ContractTemplateHeader = function (_React$Component) {
  _inherits(ContractTemplateHeader, _React$Component);

  function ContractTemplateHeader(props) {
    _classCallCheck(this, ContractTemplateHeader);

    var _this = _possibleConstructorReturn(this, (ContractTemplateHeader.__proto__ || Object.getPrototypeOf(ContractTemplateHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.getHelp = _this.getHelp.bind(_this);
    _this.signOut = _this.signOut.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            {
              showSearch: false,
              router: this.props.router,
              closeSearchHandler: this.closeSearchHandler
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                viewer: this.props.viewer,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return ContractTemplateHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTemplateHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateHeader);

/***/ }),
/* 3149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__ = __webpack_require__(529);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ContractTemplateLibrary = function (_React$Component) {
  _inherits(ContractTemplateLibrary, _React$Component);

  function ContractTemplateLibrary(props) {
    _classCallCheck(this, ContractTemplateLibrary);

    var _this = _possibleConstructorReturn(this, (ContractTemplateLibrary.__proto__ || Object.getPrototypeOf(ContractTemplateLibrary)).call(this, props));

    _this.copyLibraryLineItemsToContractTemplate = _this.copyLibraryLineItemsToContractTemplate.bind(_this);
    _this.createLineItem = _this.createLineItem.bind(_this);
    _this.resetNewLibraryLineItem = _this.resetNewLibraryLineItem.bind(_this);
    _this.newLibraryLineItemChangeHandler = _this.newLibraryLineItemChangeHandler.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateLibrary, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Initialize new library line item
      this.resetNewLibraryLineItem();
    }
  }, {
    key: 'copyLibraryLineItemsToContractTemplate',
    value: function copyLibraryLineItemsToContractTemplate(itemsToCopy) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item' + (itemsToCopy.length > 1 ? 's' : ''),
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('added-line-items-from-library', {
          item_count: itemsToCopy.length
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3159);
      });

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        var contractTemplateProxy = store.get(_this2.props.node.id);
        var payload = store.getRootField('copyUserLineItemsToCTemplate');
        var newContractTemplateLineItems = payload.getLinkedRecord('c_template').getLinkedRecord('c_template_line_items');
        var conn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(contractTemplateProxy, 'ContractTemplateContainer_c_template_line_items');
        conn.copyFieldsFrom(newContractTemplateLineItems);
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            c_template_id: parentID,
            user_line_item_ids: itemsToCopy
          }
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createLineItem',
    value: function createLineItem(idx, successCb, failureCb) {
      var _this3 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this3.resetNewLibraryLineItem();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added line item',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3160);
      });

      var newLineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.newLibraryLineItem), 'title', 'description', 'price_cents', 'price_currency', 'quantity');

      newLineItem.quantity = parseInt(newLineItem.quantity, 10);

      var parentID = this.props.node.id;

      var updater = function updater(store) {
        // Update contract
        var contractTemplateProxy = store.get(_this3.props.node.id);
        var payload = store.getRootField('createCTemplateLineItem');
        var newContractTemplateLineItemEdge = payload.getLinkedRecord('new_c_template_line_item_edge');
        var contractLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(contractTemplateProxy, 'ContractTemplateContainer_c_template_line_items');
        __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(contractLineItemConn, newContractTemplateLineItemEdge);

        // Update viewer if adding to library
        if (_this3.state.newLibraryLineItem.addToLibrary) {
          var viewerProxy = store.get(_this3.props.viewer.id);
          var newUserLineItemEdge = payload.getLinkedRecord('new_user_line_item_edge');
          var userLineItemConn = __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].getConnection(viewerProxy, 'LibraryContainer_user_line_items');
          __WEBPACK_IMPORTED_MODULE_4_relay_runtime__["ConnectionHandler"].insertEdgeAfter(userLineItemConn, newUserLineItemEdge);
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            c_template_id: parentID
          }, newLineItem, {
            add_to_library: this.state.newLibraryLineItem.addToLibrary
          })
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetNewLibraryLineItem',
    value: function resetNewLibraryLineItem() {
      this.setState({
        newLibraryLineItem: {
          title: '',
          description: '',
          quantity: 1,
          price_cents: 0,
          price_currency: 'USD',
          addToLibrary: false
        }
      });
    }
  }, {
    key: 'newLibraryLineItemChangeHandler',
    value: function newLibraryLineItemChangeHandler(lineItem) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newLibraryLineItem = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'render',
    value: function render() {
      var contractTemplateLineItems = this.props.node.c_template_line_items.edges;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sections_Library_LibraryContainer__["a" /* default */], {
        initiallyExpanded: contractTemplateLineItems.length === 0,
        newLibraryLineItem: this.state.newLibraryLineItem,
        newLibraryLineItemChangeHandler: this.newLibraryLineItemChangeHandler,
        resetNewLibraryLineItem: this.resetNewLibraryLineItem,
        createLineItem: this.createLineItem,
        copyLibraryLineItemsToDocument: this.copyLibraryLineItemsToContractTemplate,
        viewer: this.props.viewer,
        relay: this.props.relay
      });
    }
  }]);

  return ContractTemplateLibrary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractTemplateLibrary.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateLibrary);

/***/ }),
/* 3150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_array__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ContractTemplateLineItems = function (_React$Component) {
  _inherits(ContractTemplateLineItems, _React$Component);

  function ContractTemplateLineItems(props) {
    _classCallCheck(this, ContractTemplateLineItems);

    var _this = _possibleConstructorReturn(this, (ContractTemplateLineItems.__proto__ || Object.getPrototypeOf(ContractTemplateLineItems)).call(this, props));

    _this.state = {
      localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.c_template_line_items.edges)
    };
    _this.deleteLineItem = _this.deleteLineItem.bind(_this);
    _this.resetEditLineItem = _this.resetEditLineItem.bind(_this);
    _this.lineItemChangeHandler = _this.lineItemChangeHandler.bind(_this);
    _this.updateLineItem = _this.updateLineItem.bind(_this);
    _this.moveLineItem = _this.moveLineItem.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateLineItems, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localLineItems if any edges are added/deleted
      this.setState({
        localLineItems: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.c_template_line_items.edges)
      });
    }
  }, {
    key: 'lineItemChangeHandler',
    value: function lineItemChangeHandler(lineItem, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx].node = lineItem;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'resetEditLineItem',
    value: function resetEditLineItem(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localLineItems[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.c_template_line_items.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'moveLineItem',
    value: function moveLineItem(source, destination) {
      var _this2 = this;

      var localLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_array__["a" /* arrayMove */])(this.state.localLineItems, source, destination);
      localLineItems[destination].node.position = destination + 1;
      this.setState({
        localLineItems: localLineItems
      }, function () {
        return _this2.updateLineItem(destination);
      });
    }
  }, {
    key: 'updateLineItem',
    value: function updateLineItem(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-line-item');
      };
      var lineItem = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localLineItems[idx].node), ['id', 'description', 'position', 'price_cents', 'price_currency', 'quantity', 'title']);

      lineItem.quantity = parseInt(lineItem.quantity, 10);
      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3162);
      });

      // eslint-disable-next-line camelcase
      var c_template = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node);
      c_template.c_template_line_items.edges = this.state.localLineItems;
      var optimisticResponse = {
        updateCTemplateLineItem: { c_template: c_template }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, lineItem)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteLineItem',
    value: function deleteLineItem(idx, successCb, failureCb) {
      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted line item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-line-item');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3161);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['c_template', 'c_template_line_items'],
        deletedIDFieldName: 'deletedCTemplateLineItemId',
        connectionKeys: [{
          key: 'ContractTemplateContainer_c_template_line_items',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.c_template_line_items.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_LineItems_LineItems__["a" /* default */], {
        lineItems: this.props.node.c_template_line_items.edges,
        localLineItems: this.state.localLineItems,
        updateLineItem: this.updateLineItem,
        deleteLineItem: this.deleteLineItem,
        resetEditLineItem: this.resetEditLineItem,
        lineItemChangeHandler: this.lineItemChangeHandler,
        readOnly: !this.props.canEdit,
        moveLineItem: this.moveLineItem
      });
    }
  }]);

  return ContractTemplateLineItems;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractTemplateLineItems.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateLineItems);

/***/ }),
/* 3151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var ContractTemplateLogo = function (_React$Component) {
  _inherits(ContractTemplateLogo, _React$Component);

  function ContractTemplateLogo(props) {
    _classCallCheck(this, ContractTemplateLogo);

    var _this = _possibleConstructorReturn(this, (ContractTemplateLogo.__proto__ || Object.getPrototypeOf(ContractTemplateLogo)).call(this, props));

    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateLogo, [{
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3163);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this2 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this2.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3164);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand.logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return ContractTemplateLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTemplateLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateLogo);

/***/ }),
/* 3152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlocks__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ContractTemplateSignatureBlocks = function (_React$Component) {
  _inherits(ContractTemplateSignatureBlocks, _React$Component);

  function ContractTemplateSignatureBlocks(props) {
    _classCallCheck(this, ContractTemplateSignatureBlocks);

    var _this = _possibleConstructorReturn(this, (ContractTemplateSignatureBlocks.__proto__ || Object.getPrototypeOf(ContractTemplateSignatureBlocks)).call(this, props));

    _this.state = {
      contract: {},
      localSignatureBlocks: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node.c_template_signature_blocks.edges),
      editingNewSignatureBlock: false
    };
    _this.reset = _this.reset.bind(_this);
    _this.deleteBlock = _this.deleteBlock.bind(_this);
    _this.update = _this.update.bind(_this);
    _this.onChange = _this.onChange.bind(_this);

    _this.newSignatureBlockChangeHandler = _this.newSignatureBlockChangeHandler.bind(_this);
    _this.closeNewSignatureBlockEditor = _this.closeNewSignatureBlockEditor.bind(_this);
    _this.addSignatureBlock = _this.addSignatureBlock.bind(_this);
    _this.resetAddSignatureBlock = _this.resetAddSignatureBlock.bind(_this);
    _this.createSignatureBlock = _this.createSignatureBlock.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateSignatureBlocks, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localSignatureBlocks if any edges are added/deleted
      if (this.state.localSignatureBlocks.length !== nextProps.node.c_template_signature_blocks.edges.length) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
        obj.localSignatureBlocks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.c_template_signature_blocks.edges);
        this.setState(_extends({}, obj));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(signatureBlock, idx) {
      this.setState(function (state) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
        obj.localSignatureBlocks[idx].node = signatureBlock;
        return obj;
      });
    }
  }, {
    key: 'reset',
    value: function reset(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localSignatureBlocks[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.c_template_signature_blocks.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'addSignatureBlock',
    value: function addSignatureBlock() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewSignatureBlock = true;
      if (!this.state.contract.newSignatureBlock) {
        obj.contract.newSignatureBlock = {
          node: {
            address_visibility: 'HIDE',
            company_name_visibility: 'HIDE',
            email_visibility: 'SHOW',
            name_visibility: 'SHOW',
            phone_visibility: 'SHOW',
            signing_party: '',
            title_visibility: 'HIDE'
          }
        };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newSignatureBlockChangeHandler',
    value: function newSignatureBlockChangeHandler(signatureBlock) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.contract.newSignatureBlock.node = signatureBlock;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewSignatureBlockEditor',
    value: function closeNewSignatureBlockEditor() {
      this.setState({ editingNewSignatureBlock: false });
    }
  }, {
    key: 'resetAddSignatureBlock',
    value: function resetAddSignatureBlock() {
      this.setState(function (state) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
        delete obj.contract.newSignatureBlock;
        return obj;
      });
    }
  }, {
    key: 'createSignatureBlock',
    value: function createSignatureBlock(index, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.state);
        delete obj.contract.newSignatureBlock;
        _this2.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-signature-block');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3165);
      });

      var signatureBlock = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.contract.newSignatureBlock.node), ['address_visibility', 'company_name_visibility', 'email_visibility', 'name_visibility', 'phone_visibility', 'signing_party', 'title_visibility']);

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_c_template_signature_block_edge',
        connectionInfo: [{
          key: 'ContractTemplateContainer_c_template_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            c_template_id: parentID
          }, signatureBlock)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'update',
    value: function update(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-signature-block');
      };

      var signatureBlock = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localSignatureBlocks[idx].node), ['id', 'address_visibility', 'company_name_visibility', 'email_visibility', 'name_visibility', 'phone_visibility', 'signing_party', 'title_visibility']);

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3167);
      });

      var optimisticResponse = {
        updateCTemplateSignatureBlock: {
          c_template_signature_block: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(signatureBlock)
        }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, signatureBlock)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteBlock',
    value: function deleteBlock(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted signature block',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-signature-block');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3166);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['c_template', 'c_template_signature_blocks'],
        deletedIDFieldName: 'deletedCTemplateSignatureBlockId',
        connectionKeys: [{
          key: 'ContractTemplateContainer_c_template_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.c_template_signature_blocks.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sections_SignatureBlocks_SignatureBlocks__["a" /* default */], {
        signatureBlocks: this.props.node.c_template_signature_blocks.edges,
        localSignatureBlocks: this.state.localSignatureBlocks,
        onChange: this.onChange,
        reset: this.reset,
        deleteBlock: this.deleteBlock,
        update: this.update,
        readOnly: !this.props.canEdit,
        resetAddSignatureBlock: this.resetAddSignatureBlock,
        newSignatureBlockChangeHandler: this.newSignatureBlockChangeHandler,
        closeNewSignatureBlockEditor: this.closeNewSignatureBlockEditor,
        addSignatureBlock: this.addSignatureBlock,
        newSignatureBlock: this.state.contract.newSignatureBlock,
        editingNewSignatureBlock: this.state.editingNewSignatureBlock,
        createSignatureBlock: this.createSignatureBlock,
        isTemplate: true
      });
    }
  }]);

  return ContractTemplateSignatureBlocks;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ContractTemplateSignatureBlocks.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateSignatureBlocks);

/***/ }),
/* 3153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Terms_Terms__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContractTemplateTerms = function (_React$Component) {
  _inherits(ContractTemplateTerms, _React$Component);

  function ContractTemplateTerms(props) {
    _classCallCheck(this, ContractTemplateTerms);

    var _this = _possibleConstructorReturn(this, (ContractTemplateTerms.__proto__ || Object.getPrototypeOf(ContractTemplateTerms)).call(this, props));

    _this.state = {
      terms: _this.props.node.terms
    };
    _this.termsChangeHandler = _this.termsChangeHandler.bind(_this);
    _this.updateTerms = _this.updateTerms.bind(_this);
    _this.resetTerms = _this.resetTerms.bind(_this);
    _this.createSignatureBlock = _this.createSignatureBlock.bind(_this);
    _this.insertGeneratedTerms = _this.insertGeneratedTerms.bind(_this);
    _this.builderSaveTerms = _this.builderSaveTerms.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateTerms, [{
    key: 'signatureBlockFactory',
    value: function signatureBlockFactory() {
      return {
        address_visibility: 'HIDE',
        company_name_visibility: 'HIDE',
        email_visibility: 'SHOW',
        name_visibility: 'SHOW',
        phone_visibility: 'SHOW',
        title_visibility: 'HIDE'
      };
    }
  }, {
    key: 'builderSaveTerms',
    value: function builderSaveTerms(terms, successCb) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to generate contract',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully generated contract terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.setState({ terms: _this2.props.node.terms });
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('used-contract-generator');
      };

      this.createSignatureBlock(Object.assign(this.signatureBlockFactory(), { signing_party: 'Client' }), function () {
        return _this2.createSignatureBlock(Object.assign(_this2.signatureBlockFactory(), { signing_party: 'DJ' }), function () {
          return _this2.insertGeneratedTerms(terms, onCompleted, onError);
        }, onError);
      }, onError);
    }
  }, {
    key: 'termsChangeHandler',
    value: function termsChangeHandler(value) {
      this.setState({ terms: value });
    }
  }, {
    key: 'insertGeneratedTerms',
    value: function insertGeneratedTerms(terms, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3170);
      });

      var optimisticResponse = {
        updateCTemplate: { c_template: { id: id, terms: terms } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            terms: terms
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createSignatureBlock',
    value: function createSignatureBlock(signatureBlock, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3169);
      });

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_c_template_signature_block_edge',
        connectionInfo: [{
          key: 'ContractTemplateContainer_c_template_signature_blocks',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            c_template_id: parentID
          }, signatureBlock)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateTerms',
    value: function updateTerms(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update template terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated template terms',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default terms if null
      var terms = this.state.terms === '<p><br></p>' ? null : this.state.terms;
      var id = this.props.node.id;


      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3168);
      });

      var optimisticResponse = {
        updateCTemplate: { c_template: { id: id, terms: terms } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            terms: terms
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetTerms',
    value: function resetTerms() {
      this.setState({ terms: this.props.node.terms });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Terms_Terms__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTerms: this.state.terms,
        reset: this.resetTerms,
        terms: this.props.node.terms,
        termsChangeHandler: this.termsChangeHandler,
        updateTerms: this.updateTerms,
        builderSaveTerms: this.builderSaveTerms
      });
    }
  }]);

  return ContractTemplateTerms;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTemplateTerms.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateTerms);

/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContractTemplateTitle = function (_React$Component) {
  _inherits(ContractTemplateTitle, _React$Component);

  function ContractTemplateTitle(props) {
    _classCallCheck(this, ContractTemplateTitle);

    var _this = _possibleConstructorReturn(this, (ContractTemplateTitle.__proto__ || Object.getPrototypeOf(ContractTemplateTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(ContractTemplateTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Contract Template)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3171);
        });

        var optimisticResponse = {
          updateCTemplate: { c_template: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return ContractTemplateTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContractTemplateTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ContractTemplateTitle);

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 88e4a8f4f6d8f28ac99fcff667f8ef1b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCTemplateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteCTemplateMutationVariables = {|
  input: DeleteCTemplateInput
|};
export type ActionsComponent_deleteCTemplateMutationResponse = {|
  +deleteCTemplate: ?{|
    +deletedCTemplateId: ?string
  |}
|};
export type ActionsComponent_deleteCTemplateMutation = {|
  variables: ActionsComponent_deleteCTemplateMutationVariables,
  response: ActionsComponent_deleteCTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteCTemplateMutation(
  $input: DeleteCTemplateInput!
) {
  deleteCTemplate(input: $input) {
    deletedCTemplateId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteCTemplateInput!"
    }],
    "concreteType": "DeleteCTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedCTemplateId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteCTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteCTemplateMutation(\n  $input: DeleteCTemplateInput!\n) {\n  deleteCTemplate(input: $input) {\n    deletedCTemplateId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteCTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteCTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ee91936032389dfc3b3867dff38f64cd';
module.exports = node;

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 13ba4d66018f7ab72090bbc2906ef086
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_ContractTemplate_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_ContractTemplate_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_ContractTemplate_updateBrandMutation = {|
  variables: Brand_ContractTemplate_updateBrandMutationVariables,
  response: Brand_ContractTemplate_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_ContractTemplate_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_ContractTemplate_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_ContractTemplate_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_ContractTemplate_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_ContractTemplate_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cbd0aae50d1765b0e8b93272adaab701';
module.exports = node;

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractTemplateContainer_node$ref: FragmentReference;
export type ContractTemplateContainer_node = {|
  +id: string,
  +title: ?string,
  +terms: ?string,
  +brand: ?{|
    +id: string,
    +logo_url: ?string,
    +header: ?string,
  |},
  +c_template_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +c_template_signature_blocks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signing_party: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}>
  |},
  +$refType: ContractTemplateContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "ContractTemplateContainer_node",
    "type": "CTemplate",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["c_template_line_items"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["c_template_signature_blocks"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "terms",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "c_template_line_items",
      "name": "__ContractTemplateContainer_c_template_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateLineItemConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateLineItemEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateLineItem",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          }, v1, v2]
        }, v3]
      }, v4]
    }, {
      "kind": "LinkedField",
      "alias": "c_template_signature_blocks",
      "name": "__ContractTemplateContainer_c_template_signature_blocks_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateSignatureBlockConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateSignatureBlockEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateSignatureBlock",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "address_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "email_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "name_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone_visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "signing_party",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title_visibility",
            "args": null,
            "storageKey": null
          }, v2]
        }, v3]
      }, v4]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '3f54ee450eeba2ad706282c7c3b7a121';
module.exports = node;

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type LibraryContainer_viewer$ref = any;
type SearchContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractTemplateContainer_viewer$ref: FragmentReference;
export type ContractTemplateContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: SearchContainer_viewer$ref & LibraryContainer_viewer$ref,
  +$refType: ContractTemplateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "ContractTemplateContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "LibraryContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cc1b6b2514a50cc2abbc37d56c243523';
module.exports = node;

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash eb862e0eed0b96e8fdd891ff4bdb46a4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToCTemplateInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutationVariables = {|
  input: CopyUserLineItemsToCTemplateInput
|};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutationResponse = {|
  +copyUserLineItemsToCTemplate: ?{|
    +c_template: ?{|
      +c_template_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutation = {|
  variables: Library_ContractTemplate_copyUserLineItemsToCTemplateMutationVariables,
  response: Library_ContractTemplate_copyUserLineItemsToCTemplateMutationResponse,
|};
*/

/*
mutation Library_ContractTemplate_copyUserLineItemsToCTemplateMutation(
  $input: CopyUserLineItemsToCTemplateInput!
) {
  copyUserLineItemsToCTemplate(input: $input) {
    c_template {
      c_template_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToCTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "c_template_line_items",
    "storageKey": null,
    "args": null,
    "concreteType": "CTemplateLineItemConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateLineItemEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateLineItem",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_cents",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "price_currency",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantity",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
    "id": null,
    "text": "mutation Library_ContractTemplate_copyUserLineItemsToCTemplateMutation(\n  $input: CopyUserLineItemsToCTemplateInput!\n) {\n  copyUserLineItemsToCTemplate(input: $input) {\n    c_template {\n      c_template_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v3, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '43b80b1a8dc02fbe027715a8868962bd';
module.exports = node;

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c66623eb00c5b8557a91f19ff38fd523
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateCTemplateLineItemInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  title: string,
  quantity: number,
  price_cents: number,
  price_currency: string,
  description?: ?string,
  add_to_library?: ?boolean,
};
export type Library_ContractTemplate_createCTemplateLineItemMutationVariables = {|
  input: CreateCTemplateLineItemInput
|};
export type Library_ContractTemplate_createCTemplateLineItemMutationResponse = {|
  +createCTemplateLineItem: ?{|
    +new_c_template_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
    +new_user_line_item_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
      |}
    |},
  |}
|};
export type Library_ContractTemplate_createCTemplateLineItemMutation = {|
  variables: Library_ContractTemplate_createCTemplateLineItemMutationVariables,
  response: Library_ContractTemplate_createCTemplateLineItemMutationResponse,
|};
*/

/*
mutation Library_ContractTemplate_createCTemplateLineItemMutation(
  $input: CreateCTemplateLineItemInput!
) {
  createCTemplateLineItem(input: $input) {
    new_c_template_line_item_edge {
      node {
        id
        title
        description
        position
        price_cents
        price_currency
        quantity
      }
    }
    new_user_line_item_edge {
      node {
        id
        title
        description
        price_cents
        price_currency
        quantity
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCTemplateLineItemInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createCTemplateLineItem",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateCTemplateLineItemInput!"
    }],
    "concreteType": "CreateCTemplateLineItemPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_c_template_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateLineItem",
        "plural": false,
        "selections": [v1, v2, v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "position",
          "args": null,
          "storageKey": null
        }, v4, v5, v6]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "new_user_line_item_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "UserLineItemEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserLineItem",
        "plural": false,
        "selections": [v1, v2, v3, v4, v5, v6]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Library_ContractTemplate_createCTemplateLineItemMutation",
    "id": null,
    "text": "mutation Library_ContractTemplate_createCTemplateLineItemMutation(\n  $input: CreateCTemplateLineItemInput!\n) {\n  createCTemplateLineItem(input: $input) {\n    new_c_template_line_item_edge {\n      node {\n        id\n        title\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n    new_user_line_item_edge {\n      node {\n        id\n        title\n        description\n        price_cents\n        price_currency\n        quantity\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Library_ContractTemplate_createCTemplateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v7
    },
    "operation": {
      "kind": "Operation",
      "name": "Library_ContractTemplate_createCTemplateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": v7
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2ceef5083fd1779c24f200ac0ea25311';
module.exports = node;

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a87169fe42adc97e5c0c180bde395acf
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractTemplateContainer_node$ref = any;
export type DeleteCTemplateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutationVariables = {|
  input: DeleteCTemplateLineItemInput
|};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutationResponse = {|
  +deleteCTemplateLineItem: ?{|
    +deletedCTemplateLineItemId: ?string,
    +c_template: ?{|
      +$fragmentRefs: ContractTemplateContainer_node$ref
    |},
  |}
|};
export type LineItems_ContractTemplate_deleteCTemplateLineItemMutation = {|
  variables: LineItems_ContractTemplate_deleteCTemplateLineItemMutationVariables,
  response: LineItems_ContractTemplate_deleteCTemplateLineItemMutationResponse,
|};
*/

/*
mutation LineItems_ContractTemplate_deleteCTemplateLineItemMutation(
  $input: DeleteCTemplateLineItemInput!
) {
  deleteCTemplateLineItem(input: $input) {
    deletedCTemplateLineItemId
    c_template {
      ...ContractTemplateContainer_node
      id
    }
  }
}

fragment ContractTemplateContainer_node on CTemplate {
  id
  title
  terms
  brand {
    id
    logo_url
    header
  }
  c_template_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  c_template_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCTemplateLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteCTemplateLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedCTemplateLineItemId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
    "id": null,
    "text": "mutation LineItems_ContractTemplate_deleteCTemplateLineItemMutation(\n  $input: DeleteCTemplateLineItemInput!\n) {\n  deleteCTemplateLineItem(input: $input) {\n    deletedCTemplateLineItemId\n    c_template {\n      ...ContractTemplateContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractTemplateContainer_node on CTemplate {\n  id\n  title\n  terms\n  brand {\n    id\n    logo_url\n    header\n  }\n  c_template_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  c_template_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteCTemplateLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "ContractTemplateContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_ContractTemplate_deleteCTemplateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteCTemplateLineItemPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "header",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_line_items",
            "storageKey": "c_template_line_items(first:99999)",
            "args": v5,
            "concreteType": "CTemplateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateLineItem",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v4, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_line_items",
            "args": v5,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_signature_blocks",
            "storageKey": "c_template_signature_blocks(first:99999)",
            "args": v5,
            "concreteType": "CTemplateSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateSignatureBlock",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v6]
              }, v7]
            }, v8]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_signature_blocks",
            "args": v5,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_signature_blocks",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b06c0b6c9208b0f69571bf84e7da2cd7';
module.exports = node;

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 10bb55a6d414d5bd233405e81758444d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractTemplateContainer_node$ref = any;
export type UpdateCTemplateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  position?: ?number,
  description?: ?string,
};
export type LineItems_ContractTemplate_updateCTemplateLineItemMutationVariables = {|
  input: UpdateCTemplateLineItemInput
|};
export type LineItems_ContractTemplate_updateCTemplateLineItemMutationResponse = {|
  +updateCTemplateLineItem: ?{|
    +c_template: ?{|
      +$fragmentRefs: ContractTemplateContainer_node$ref
    |}
  |}
|};
export type LineItems_ContractTemplate_updateCTemplateLineItemMutation = {|
  variables: LineItems_ContractTemplate_updateCTemplateLineItemMutationVariables,
  response: LineItems_ContractTemplate_updateCTemplateLineItemMutationResponse,
|};
*/

/*
mutation LineItems_ContractTemplate_updateCTemplateLineItemMutation(
  $input: UpdateCTemplateLineItemInput!
) {
  updateCTemplateLineItem(input: $input) {
    c_template {
      ...ContractTemplateContainer_node
      id
    }
  }
}

fragment ContractTemplateContainer_node on CTemplate {
  id
  title
  terms
  brand {
    id
    logo_url
    header
  }
  c_template_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  c_template_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCTemplateLineItemInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCTemplateLineItemInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LineItems_ContractTemplate_updateCTemplateLineItemMutation",
    "id": null,
    "text": "mutation LineItems_ContractTemplate_updateCTemplateLineItemMutation(\n  $input: UpdateCTemplateLineItemInput!\n) {\n  updateCTemplateLineItem(input: $input) {\n    c_template {\n      ...ContractTemplateContainer_node\n      id\n    }\n  }\n}\n\nfragment ContractTemplateContainer_node on CTemplate {\n  id\n  title\n  terms\n  brand {\n    id\n    logo_url\n    header\n  }\n  c_template_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  c_template_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LineItems_ContractTemplate_updateCTemplateLineItemMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplateLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "ContractTemplateContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "LineItems_ContractTemplate_updateCTemplateLineItemMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplateLineItemPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "header",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_line_items",
            "storageKey": "c_template_line_items(first:99999)",
            "args": v4,
            "concreteType": "CTemplateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateLineItem",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                }, v3, v5]
              }, v6]
            }, v7]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_line_items",
            "args": v4,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_signature_blocks",
            "storageKey": "c_template_signature_blocks(first:99999)",
            "args": v4,
            "concreteType": "CTemplateSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateSignatureBlock",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v5]
              }, v6]
            }, v7]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_signature_blocks",
            "args": v4,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_signature_blocks",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '983c4486fdf7f18b986d7623da6823ad';
module.exports = node;

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 598d0bdea5a3bf728e65491d786903c9
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_ContractTemplate_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_ContractTemplate_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_ContractTemplate_Logo_updateBrandMutation = {|
  variables: Logo_ContractTemplate_Logo_updateBrandMutationVariables,
  response: Logo_ContractTemplate_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_ContractTemplate_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_ContractTemplate_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_ContractTemplate_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_ContractTemplate_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_ContractTemplate_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '556f7c0aef86e248fd66cf7e6aff5a0d';
module.exports = node;

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7d463c582648ccce245a3d16ab9cdb62
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_ContractTemplate_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_ContractTemplate_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_ContractTemplate_deleteLogo_updateBrandMutation = {|
  variables: Logo_ContractTemplate_deleteLogo_updateBrandMutationVariables,
  response: Logo_ContractTemplate_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_ContractTemplate_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_ContractTemplate_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_ContractTemplate_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_ContractTemplate_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_ContractTemplate_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5c4347b59783fcf783467368358011a6';
module.exports = node;

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ed4f6d1352500c9efc166dae523469e5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type CreateCTemplateSignatureBlockInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  email_visibility: SignatureBlockFieldVisibility,
  title_visibility: SignatureBlockFieldVisibility,
  company_name_visibility: SignatureBlockFieldVisibility,
  phone_visibility: SignatureBlockFieldVisibility,
  address_visibility: SignatureBlockFieldVisibility,
};
export type SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutationVariables = {|
  input: CreateCTemplateSignatureBlockInput
|};
export type SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutationResponse = {|
  +createCTemplateSignatureBlock: ?{|
    +new_c_template_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signing_party: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation = {|
  variables: SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutationVariables,
  response: SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation(
  $input: CreateCTemplateSignatureBlockInput!
) {
  createCTemplateSignatureBlock(input: $input) {
    new_c_template_signature_block_edge {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCTemplateSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createCTemplateSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateCTemplateSignatureBlockInput!"
    }],
    "concreteType": "CreateCTemplateSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_c_template_signature_block_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateSignatureBlockEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateSignatureBlock",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signing_party",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title_visibility",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation(\n  $input: CreateCTemplateSignatureBlockInput!\n) {\n  createCTemplateSignatureBlock(input: $input) {\n    new_c_template_signature_block_edge {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_ContractTemplate_createCTemplateSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9aece62df22f79197306fb835d22b5d9';
module.exports = node;

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ea18e9688cf1326d36278d98ee4f4ace
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCTemplateSignatureBlockInput = {
  clientMutationId?: ?string,
  id: string,
};
export type SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutationVariables = {|
  input: DeleteCTemplateSignatureBlockInput
|};
export type SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutationResponse = {|
  +deleteCTemplateSignatureBlock: ?{|
    +deletedCTemplateSignatureBlockId: ?string
  |}
|};
export type SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation = {|
  variables: SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutationVariables,
  response: SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation(
  $input: DeleteCTemplateSignatureBlockInput!
) {
  deleteCTemplateSignatureBlock(input: $input) {
    deletedCTemplateSignatureBlockId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCTemplateSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCTemplateSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteCTemplateSignatureBlockInput!"
    }],
    "concreteType": "DeleteCTemplateSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedCTemplateSignatureBlockId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation(\n  $input: DeleteCTemplateSignatureBlockInput!\n) {\n  deleteCTemplateSignatureBlock(input: $input) {\n    deletedCTemplateSignatureBlockId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_ContractTemplate_deleteCTemplateSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd6c0159738b43387c1f85a7af1db6a5b';
module.exports = node;

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6a69432826557e8c2daa7beb622ad035
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type UpdateCTemplateSignatureBlockInput = {
  clientMutationId?: ?string,
  id: string,
  signing_party?: ?string,
  name_visibility?: ?SignatureBlockFieldVisibility,
  email_visibility?: ?SignatureBlockFieldVisibility,
  title_visibility?: ?SignatureBlockFieldVisibility,
  company_name_visibility?: ?SignatureBlockFieldVisibility,
  phone_visibility?: ?SignatureBlockFieldVisibility,
  address_visibility?: ?SignatureBlockFieldVisibility,
};
export type SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutationVariables = {|
  input: UpdateCTemplateSignatureBlockInput
|};
export type SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutationResponse = {|
  +updateCTemplateSignatureBlock: ?{|
    +c_template_signature_block: ?{|
      +id: string,
      +address_visibility: ?SignatureBlockFieldVisibility,
      +company_name_visibility: ?SignatureBlockFieldVisibility,
      +email_visibility: ?SignatureBlockFieldVisibility,
      +name_visibility: ?SignatureBlockFieldVisibility,
      +phone_visibility: ?SignatureBlockFieldVisibility,
      +signing_party: ?string,
      +title_visibility: ?SignatureBlockFieldVisibility,
    |}
  |}
|};
export type SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation = {|
  variables: SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutationVariables,
  response: SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutationResponse,
|};
*/

/*
mutation SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation(
  $input: UpdateCTemplateSignatureBlockInput!
) {
  updateCTemplateSignatureBlock(input: $input) {
    c_template_signature_block {
      id
      address_visibility
      company_name_visibility
      email_visibility
      name_visibility
      phone_visibility
      signing_party
      title_visibility
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCTemplateSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCTemplateSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateCTemplateSignatureBlockInput!"
    }],
    "concreteType": "UpdateCTemplateSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "c_template_signature_block",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateSignatureBlock",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "address_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "name_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "phone_visibility",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "signing_party",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title_visibility",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation",
    "id": null,
    "text": "mutation SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation(\n  $input: UpdateCTemplateSignatureBlockInput!\n) {\n  updateCTemplateSignatureBlock(input: $input) {\n    c_template_signature_block {\n      id\n      address_visibility\n      company_name_visibility\n      email_visibility\n      name_visibility\n      phone_visibility\n      signing_party\n      title_visibility\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SignatureBlocks_ContractTemplate_updateCTemplateSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c3cdec2ff97c2e32eb4f6669af18e851';
module.exports = node;

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5c1dfd5eb5a22057d21d599a9b7c9bae
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
  brand_id?: ?string,
};
export type Terms_ContractTemplate_UpdateContractMutationVariables = {|
  input: UpdateCTemplateInput
|};
export type Terms_ContractTemplate_UpdateContractMutationResponse = {|
  +updateCTemplate: ?{|
    +c_template: ?{|
      +terms: ?string
    |}
  |}
|};
export type Terms_ContractTemplate_UpdateContractMutation = {|
  variables: Terms_ContractTemplate_UpdateContractMutationVariables,
  response: Terms_ContractTemplate_UpdateContractMutationResponse,
|};
*/

/*
mutation Terms_ContractTemplate_UpdateContractMutation(
  $input: UpdateCTemplateInput!
) {
  updateCTemplate(input: $input) {
    c_template {
      terms
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "terms",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_ContractTemplate_UpdateContractMutation",
    "id": null,
    "text": "mutation Terms_ContractTemplate_UpdateContractMutation(\n  $input: UpdateCTemplateInput!\n) {\n  updateCTemplate(input: $input) {\n    c_template {\n      terms\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_ContractTemplate_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_ContractTemplate_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fb7fbe09997d359f3f90f4bdb45edf52';
module.exports = node;

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8422dbf87e57534619c5b7a87914b9e7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type CreateCTemplateSignatureBlockInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  signing_party: string,
  name_visibility: SignatureBlockFieldVisibility,
  email_visibility: SignatureBlockFieldVisibility,
  title_visibility: SignatureBlockFieldVisibility,
  company_name_visibility: SignatureBlockFieldVisibility,
  phone_visibility: SignatureBlockFieldVisibility,
  address_visibility: SignatureBlockFieldVisibility,
};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutationVariables = {|
  input: CreateCTemplateSignatureBlockInput
|};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutationResponse = {|
  +createCTemplateSignatureBlock: ?{|
    +new_c_template_signature_block_edge: ?{|
      +node: ?{|
        +id: string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signing_party: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}
  |}
|};
export type Terms_ContractTemplate_createCTemplateSignatureBlockMutation = {|
  variables: Terms_ContractTemplate_createCTemplateSignatureBlockMutationVariables,
  response: Terms_ContractTemplate_createCTemplateSignatureBlockMutationResponse,
|};
*/

/*
mutation Terms_ContractTemplate_createCTemplateSignatureBlockMutation(
  $input: CreateCTemplateSignatureBlockInput!
) {
  createCTemplateSignatureBlock(input: $input) {
    new_c_template_signature_block_edge {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCTemplateSignatureBlockInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createCTemplateSignatureBlock",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateCTemplateSignatureBlockInput!"
    }],
    "concreteType": "CreateCTemplateSignatureBlockPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_c_template_signature_block_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateSignatureBlockEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateSignatureBlock",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "phone_visibility",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "signing_party",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title_visibility",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
    "id": null,
    "text": "mutation Terms_ContractTemplate_createCTemplateSignatureBlockMutation(\n  $input: CreateCTemplateSignatureBlockInput!\n) {\n  createCTemplateSignatureBlock(input: $input) {\n    new_c_template_signature_block_edge {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_ContractTemplate_createCTemplateSignatureBlockMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c7441cc4ee2ec782b2358f7e890fef67';
module.exports = node;

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1fb44735f187695aaf50555b5eddbee6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
  brand_id?: ?string,
};
export type Terms_Generated_ContractTemplate_UpdateContractMutationVariables = {|
  input: UpdateCTemplateInput
|};
export type Terms_Generated_ContractTemplate_UpdateContractMutationResponse = {|
  +updateCTemplate: ?{|
    +c_template: ?{|
      +terms: ?string
    |}
  |}
|};
export type Terms_Generated_ContractTemplate_UpdateContractMutation = {|
  variables: Terms_Generated_ContractTemplate_UpdateContractMutationVariables,
  response: Terms_Generated_ContractTemplate_UpdateContractMutationResponse,
|};
*/

/*
mutation Terms_Generated_ContractTemplate_UpdateContractMutation(
  $input: UpdateCTemplateInput!
) {
  updateCTemplate(input: $input) {
    c_template {
      terms
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "terms",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Terms_Generated_ContractTemplate_UpdateContractMutation",
    "id": null,
    "text": "mutation Terms_Generated_ContractTemplate_UpdateContractMutation(\n  $input: UpdateCTemplateInput!\n) {\n  updateCTemplate(input: $input) {\n    c_template {\n      terms\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Terms_Generated_ContractTemplate_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Terms_Generated_ContractTemplate_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '985d0f913b5874f06c646680e005636d';
module.exports = node;

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash faa759fdd1a46fadaaf5d83c4ccef71e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
  brand_id?: ?string,
};
export type Title_ContractTemplate_UpdateCTemplateMutationVariables = {|
  input: UpdateCTemplateInput
|};
export type Title_ContractTemplate_UpdateCTemplateMutationResponse = {|
  +updateCTemplate: ?{|
    +c_template: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_ContractTemplate_UpdateCTemplateMutation = {|
  variables: Title_ContractTemplate_UpdateCTemplateMutationVariables,
  response: Title_ContractTemplate_UpdateCTemplateMutationResponse,
|};
*/

/*
mutation Title_ContractTemplate_UpdateCTemplateMutation(
  $input: UpdateCTemplateInput!
) {
  updateCTemplate(input: $input) {
    c_template {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateCTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_ContractTemplate_UpdateCTemplateMutation",
    "id": null,
    "text": "mutation Title_ContractTemplate_UpdateCTemplateMutation(\n  $input: UpdateCTemplateInput!\n) {\n  updateCTemplate(input: $input) {\n    c_template {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_ContractTemplate_UpdateCTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_ContractTemplate_UpdateCTemplateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateCTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "c_template",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fb61b9cb6c7dab8e9a69a39a8105cc47';
module.exports = node;

/***/ }),
/* 3172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FormTemplateBrand = function (_React$Component) {
  _inherits(FormTemplateBrand, _React$Component);

  function FormTemplateBrand(props) {
    _classCallCheck(this, FormTemplateBrand);

    var _this = _possibleConstructorReturn(this, (FormTemplateBrand.__proto__ || Object.getPrototypeOf(FormTemplateBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromFormTemplate()
    };
    _this.getBrandFromFormTemplate = _this.getBrandFromFormTemplate.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(FormTemplateBrand, [{
    key: 'getBrandFromFormTemplate',
    value: function getBrandFromFormTemplate() {
      return {
        brand_header: this.props.node.brand.header
      };
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3179);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromFormTemplate();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromFormTemplate(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return FormTemplateBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FormTemplateBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (FormTemplateBrand);

/***/ }),
/* 3173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header__ = __webpack_require__(3175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Brand__ = __webpack_require__(3172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Logo__ = __webpack_require__(3176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Actions__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Form_Renderer_Renderer__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form_Renderer_Controls__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Form_Builder_Builder__ = __webpack_require__(1448);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var FormTemplate = (_temp = _class = function (_React$Component) {
  _inherits(FormTemplate, _React$Component);

  function FormTemplate(props) {
    _classCallCheck(this, FormTemplate);

    var _this = _possibleConstructorReturn(this, (FormTemplate.__proto__ || Object.getPrototypeOf(FormTemplate)).call(this, props));

    _this.addContentBlock = _this.addContentBlock.bind(_this);
    _this.addQuestion = _this.addQuestion.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onResponseChange = _this.onResponseChange.bind(_this);
    _this.generateId = _this.generateId.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.deleteQuestion = _this.deleteQuestion.bind(_this);
    _this.updateForm = _this.updateForm.bind(_this);
    _this.canEdit = _this.canEdit.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.allChangesSaved = _this.allChangesSaved.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(FormTemplate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.updateWindowDimensions();
      if (this.props.node) {
        this.initializeForm(this.props);
      }
      if (this.props.params.action !== 'edit') {
        this.setState({
          dirtyChecker: setInterval(function () {
            return _this2.updateForm();
          }, 5000)
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.dirtyChecker) clearInterval(this.state.dirtyChecker);
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'onChange',
    value: function onChange(_ref, callback) {
      var schema = _ref.schema,
          uiSchema = _ref.uiSchema,
          formData = _ref.formData;

      this.setState({ schema: schema, uiSchema: uiSchema, formData: formData }, callback);
    }
  }, {
    key: 'onResponseChange',
    value: function onResponseChange(key, value) {
      this.setState({
        formData: Object.assign({}, this.state.formData, _defineProperty({}, key, value))
      });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.params.action === 'edit';
    }
  }, {
    key: 'generateId',
    value: function generateId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'addContentBlock',
    value: function addContentBlock() {
      var _this3 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var key = this.generateId();
      state.schema.properties[key] = { type: 'null', title: null };
      state.uiSchema['ui:order'].push(key);
      state.uiSchema[key] = { 'ui:widget': 'contentBlock', 'ui:content': '' };
      this.setState(state, function () {
        return _this3.updateForm();
      });
    }
  }, {
    key: 'addQuestion',
    value: function addQuestion() {
      var _this4 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var key = this.generateId();
      state.schema.properties[key] = { type: 'string', title: null };
      state.uiSchema['ui:order'].push(key);
      state.uiSchema[key] = { 'ui:widget': 'text', 'ui:description': '' };
      this.setState(state, function () {
        return _this4.updateForm();
      });
    }
  }, {
    key: 'initializeForm',
    value: function initializeForm(props) {
      if (props.node) {
        this.setState({
          schema: JSON.parse(props.node.schema),
          uiSchema: JSON.parse(props.node.ui_schema),
          formData: JSON.parse(props.node.data)
        });
      }
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'deleteQuestion',
    value: function deleteQuestion(key) {
      var _this5 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete state.schema.properties[key];
      delete state.uiSchema[key];
      state.uiSchema['ui:order'].splice(state.uiSchema['ui:order'].indexOf(key), 1);
      this.setState(state, function () {
        return _this5.updateForm();
      });
    }
  }, {
    key: 'updateForm',
    value: function updateForm(onSuccess, onFailure) {
      var onError = function onError() {
        if (onFailure) onFailure();
        __WEBPACK_IMPORTED_MODULE_15__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form template',
          intent: __WEBPACK_IMPORTED_MODULE_15__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (onSuccess) onSuccess();
      };

      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3180);
      });

      var schema = JSON.stringify(this.state.schema);
      var ui_schema = JSON.stringify(this.state.uiSchema); // eslint-disable-line camelcase
      var data = JSON.stringify(this.state.formData);

      var optimisticResponse = {
        updateFormTemplate: {
          form_template: { id: id, schema: schema, ui_schema: ui_schema, data: data }
        }
      };
      var environment = this.props.relay.environment;

      if (this.props.node.ui_schema !== JSON.stringify(this.state.uiSchema) || this.props.node.schema !== JSON.stringify(this.state.schema) || this.props.node.data !== JSON.stringify(this.state.formData)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              schema: schema,
              ui_schema: ui_schema,
              data: data
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      } else {
        if (onSuccess) onSuccess();
      }
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'allChangesSaved',
    value: function allChangesSaved() {
      return this.props.node.data === JSON.stringify(this.state.formData);
    }
  }, {
    key: 'render',
    value: function render() {
      var isLargeScreen = this.state.window.width >= 1280;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Actions__["a" /* default */], {
        node: this.props.node,
        params: this.props.params,
        relay: this.props.relay,
        router: this.props.router,
        viewer: this.props.viewer,
        windowDimensions: this.state.window
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_sidebar___default.a,
          {
            sidebar: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_SidebarComponent__["a" /* default */], {
              setSidebarOpenState: this.onSetSidebarOpen,
              router: this.props.router,
              viewer: this.props.viewer
            }),
            sidebarClassName: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.sidebar,
            open: this.state.sidebarOpen,
            onSetOpen: this.onSetSidebarOpen,
            touch: false,
            contentClassName: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.mobileSidebarContent,
            rootClassName: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.mobileSidebarRoot
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Header__["a" /* default */], {
            toggleSidebar: this.toggleSidebar,
            sidebarOpen: this.state.sidebarOpen,
            document: this.props.node,
            relay: this.props.relay,
            router: this.props.router,
            params: this.props.params,
            viewer: this.props.viewer,
            windowDimensions: this.state.window
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["s" /* Container */],
            { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.container },
            !isLargeScreen && this.state.window.width >= __WEBPACK_IMPORTED_MODULE_7__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Row,
                {
                  columns: 'equal',
                  className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionsMenuTablet
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  ActionsMenu
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["t" /* Segment */],
              { className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.segment },
              isLargeScreen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["u" /* Rail */],
                {
                  position: 'right',
                  close: true,
                  className: __WEBPACK_IMPORTED_MODULE_6__Document_scss___default.a.actionsMenuDesktop
                },
                ActionsMenu
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */],
                { padded: true, stackable: true, relaxed: true },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Logo__["a" /* default */], {
                      canEdit: this.canEdit(),
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Brand__["a" /* default */], {
                      viewer: this.props.viewer,
                      node: this.props.node,
                      relay: this.props.relay,
                      canEdit: this.canEdit()
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Form_Renderer_Controls__["a" /* default */], {
                      allChangesSaved: this.allChangesSaved(),
                      updateResponse: this.updateForm
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    this.props.params.action === 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Form_Builder_Builder__["a" /* default */], {
                        addContentBlock: this.addContentBlock,
                        addQuestion: this.addQuestion,
                        schema: this.state.schema,
                        uiSchema: this.state.uiSchema,
                        onChange: this.onChange,
                        updateForm: this.updateForm,
                        deleteQuestion: this.deleteQuestion,
                        formData: this.state.formData
                      })
                    ),
                    this.props.params.action !== 'edit' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Form_Renderer_Renderer__["a" /* default */], {
                      readOnly: true,
                      allChangesSaved: this.allChangesSaved(),
                      updateResponse: function updateResponse() {},
                      formData: this.state.formData,
                      onChange: this.onResponseChange,
                      schema: this.state.schema,
                      uiSchema: this.state.uiSchema
                    })
                  )
                )
              )
            )
          )
        ),
        !this.props.node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__App_404__["a" /* default */], { viewer: this.props.viewer }),
          !this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return FormTemplate;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  params: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__App_Authenticate__["a" /* default */])(FormTemplate)));

/***/ }),
/* 3174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormTemplateComponent__ = __webpack_require__(3173);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__FormTemplateComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3181);
  },
  viewer: function viewer() {
    return __webpack_require__(3182);
  }
}));

/***/ }),
/* 3175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(3177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var FormTemplateHeader = function (_React$Component) {
  _inherits(FormTemplateHeader, _React$Component);

  function FormTemplateHeader(props) {
    _classCallCheck(this, FormTemplateHeader);

    var _this = _possibleConstructorReturn(this, (FormTemplateHeader.__proto__ || Object.getPrototypeOf(FormTemplateHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(FormTemplateHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return FormTemplateHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormTemplateHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormTemplateHeader);

/***/ }),
/* 3176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var FormTemplateLogo = function (_React$Component) {
  _inherits(FormTemplateLogo, _React$Component);

  function FormTemplateLogo(props) {
    _classCallCheck(this, FormTemplateLogo);

    var _this = _possibleConstructorReturn(this, (FormTemplateLogo.__proto__ || Object.getPrototypeOf(FormTemplateLogo)).call(this, props));

    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(FormTemplateLogo, [{
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3183);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this2 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this2.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3184);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand.logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return FormTemplateLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormTemplateLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (FormTemplateLogo);

/***/ }),
/* 3177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FormTemplateTitle = function (_React$Component) {
  _inherits(FormTemplateTitle, _React$Component);

  function FormTemplateTitle(props) {
    _classCallCheck(this, FormTemplateTitle);

    var _this = _possibleConstructorReturn(this, (FormTemplateTitle.__proto__ || Object.getPrototypeOf(FormTemplateTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(FormTemplateTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated form template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Form Template)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3185);
        });

        var optimisticResponse = {
          updateFormTemplate: { form_template: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return FormTemplateTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FormTemplateTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (FormTemplateTitle);

/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 2c454bc4983f380df08df297339f29fa
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFormTemplateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteFormTemplateMutationVariables = {|
  input: DeleteFormTemplateInput
|};
export type ActionsComponent_deleteFormTemplateMutationResponse = {|
  +deleteFormTemplate: ?{|
    +deletedFormTemplateId: ?string
  |}
|};
export type ActionsComponent_deleteFormTemplateMutation = {|
  variables: ActionsComponent_deleteFormTemplateMutationVariables,
  response: ActionsComponent_deleteFormTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteFormTemplateMutation(
  $input: DeleteFormTemplateInput!
) {
  deleteFormTemplate(input: $input) {
    deletedFormTemplateId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFormTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteFormTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteFormTemplateInput!"
    }],
    "concreteType": "DeleteFormTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedFormTemplateId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteFormTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteFormTemplateMutation(\n  $input: DeleteFormTemplateInput!\n) {\n  deleteFormTemplate(input: $input) {\n    deletedFormTemplateId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteFormTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteFormTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9340dd6e333227cacd768ebf71840f88';
module.exports = node;

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 47396d016590311463ab2c367137bcde
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_FormTemplate_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_FormTemplate_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_FormTemplate_updateBrandMutation = {|
  variables: Brand_FormTemplate_updateBrandMutationVariables,
  response: Brand_FormTemplate_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_FormTemplate_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_FormTemplate_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_FormTemplate_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_FormTemplate_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_FormTemplate_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5a21e717087834fe8fa6847ac70c8af8';
module.exports = node;

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ad91a397a8891e8e42338ad2e85eaf1e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type FormTemplateComponent_UpdateFormTemplateMutationVariables = {|
  input: UpdateFormTemplateInput
|};
export type FormTemplateComponent_UpdateFormTemplateMutationResponse = {|
  +updateFormTemplate: ?{|
    +form_template: ?{|
      +schema: ?string,
      +ui_schema: ?string,
      +data: ?string,
    |}
  |}
|};
export type FormTemplateComponent_UpdateFormTemplateMutation = {|
  variables: FormTemplateComponent_UpdateFormTemplateMutationVariables,
  response: FormTemplateComponent_UpdateFormTemplateMutationResponse,
|};
*/

/*
mutation FormTemplateComponent_UpdateFormTemplateMutation(
  $input: UpdateFormTemplateInput!
) {
  updateFormTemplate(input: $input) {
    form_template {
      schema
      ui_schema
      data
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateFormTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "schema",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "ui_schema",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "FormTemplateComponent_UpdateFormTemplateMutation",
    "id": null,
    "text": "mutation FormTemplateComponent_UpdateFormTemplateMutation(\n  $input: UpdateFormTemplateInput!\n) {\n  updateFormTemplate(input: $input) {\n    form_template {\n      schema\n      ui_schema\n      data\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "FormTemplateComponent_UpdateFormTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateFormTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form_template",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplate",
          "plural": false,
          "selections": [v2, v3, v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "FormTemplateComponent_UpdateFormTemplateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateFormTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateFormTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "form_template",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplate",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '622a38eadd62635aa9f40915d4e182d9';
module.exports = node;

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormTemplateContainer_node$ref: FragmentReference;
export type FormTemplateContainer_node = {|
  +id: string,
  +title: ?string,
  +schema: ?string,
  +ui_schema: ?string,
  +data: ?string,
  +brand: ?{|
    +id: string,
    +logo_url: ?string,
    +header: ?string,
  |},
  +$refType: FormTemplateContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "FormTemplateContainer_node",
    "type": "FormTemplate",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "schema",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "ui_schema",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "data",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c474b7913904c8689c59b97e8dee25ae';
module.exports = node;

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormTemplateContainer_viewer$ref: FragmentReference;
export type FormTemplateContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: SearchContainer_viewer$ref,
  +$refType: FormTemplateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "FormTemplateContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '5ad46512837b2facc09f66550a632e01';
module.exports = node;

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c0fe538675ac323daf1c07182bceb23e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_FormTemplate_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_FormTemplate_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_FormTemplate_Logo_updateBrandMutation = {|
  variables: Logo_FormTemplate_Logo_updateBrandMutationVariables,
  response: Logo_FormTemplate_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_FormTemplate_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_FormTemplate_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_FormTemplate_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_FormTemplate_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_FormTemplate_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6011e997b2bad08dd1a2462167b3d5cd';
module.exports = node;

/***/ }),
/* 3184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ae19e1453e9f9ec3650a8d929f7bc2c6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_FormTemplate_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_FormTemplate_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_FormTemplate_deleteLogo_updateBrandMutation = {|
  variables: Logo_FormTemplate_deleteLogo_updateBrandMutationVariables,
  response: Logo_FormTemplate_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_FormTemplate_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_FormTemplate_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_FormTemplate_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_FormTemplate_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_FormTemplate_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ad8d18a16b6e0811e0fde52eb25a22b3';
module.exports = node;

/***/ }),
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5dd286c19ebf9d6132dfe595d40952a5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type Title_UpdateFormTemplateMutationVariables = {|
  input: UpdateFormTemplateInput
|};
export type Title_UpdateFormTemplateMutationResponse = {|
  +updateFormTemplate: ?{|
    +form_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type Title_UpdateFormTemplateMutation = {|
  variables: Title_UpdateFormTemplateMutationVariables,
  response: Title_UpdateFormTemplateMutationResponse,
|};
*/

/*
mutation Title_UpdateFormTemplateMutation(
  $input: UpdateFormTemplateInput!
) {
  updateFormTemplate(input: $input) {
    form_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFormTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateFormTemplateInput!"
    }],
    "concreteType": "UpdateFormTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form_template",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateFormTemplateMutation",
    "id": null,
    "text": "mutation Title_UpdateFormTemplateMutation(\n  $input: UpdateFormTemplateInput!\n) {\n  updateFormTemplate(input: $input) {\n    form_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateFormTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateFormTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'dc42252328e95ba2e6cba488191f4127';
module.exports = node;

/***/ }),
/* 3186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MpTemplateBrand = function (_React$Component) {
  _inherits(MpTemplateBrand, _React$Component);

  function MpTemplateBrand(props) {
    _classCallCheck(this, MpTemplateBrand);

    var _this = _possibleConstructorReturn(this, (MpTemplateBrand.__proto__ || Object.getPrototypeOf(MpTemplateBrand)).call(this, props));

    _this.state = {
      localBrand: _this.getBrandFromMpTemplate()
    };
    _this.getBrandFromMpTemplate = _this.getBrandFromMpTemplate.bind(_this);
    _this.updateBrand = _this.updateBrand.bind(_this);
    _this.resetBrand = _this.resetBrand.bind(_this);
    _this.brandChangeHandler = _this.brandChangeHandler.bind(_this);
    return _this;
  }

  _createClass(MpTemplateBrand, [{
    key: 'getBrandFromMpTemplate',
    value: function getBrandFromMpTemplate() {
      return {
        brand_header: this.props.node.brand.header
      };
    }
  }, {
    key: 'updateBrand',
    value: function updateBrand(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated brand information',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('updated-brand');
      };

      var localBrand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localBrand);

      var brand = {
        id: this.props.viewer.primary_brand.id,
        header: localBrand.brand_header === '<p><br></p>' ? null : localBrand.brand_header
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3199);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, brand)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetBrand',
    value: function resetBrand() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = this.getBrandFromMpTemplate();
      this.setState(obj);
    }
  }, {
    key: 'brandChangeHandler',
    value: function brandChangeHandler(brand) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localBrand = brand;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Brand_Brand__["a" /* default */], {
        canEdit: this.props.canEdit,
        selectedBrand: this.getBrandFromMpTemplate(),
        resetBrand: this.resetBrand,
        localBrand: this.state.localBrand,
        onChange: this.brandChangeHandler,
        updateBrand: this.updateBrand
      });
    }
  }]);

  return MpTemplateBrand;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MpTemplateBrand.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateBrand);

/***/ }),
/* 3187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);





var MpCopyConfirmation = function MpCopyConfirmation(_ref) {
  var onClose = _ref.onClose,
      node = _ref.node,
      router = _ref.router;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { textAlign: 'center', maxWidth: '400px', margin: '0 auto' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["j" /* Success */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { style: { textTransform: 'capitalize' } },
      node.title,
      ' Copied!'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { style: { marginBottom: '2em' } },
      'The template has been copied to your account.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
        primary: true,
        fluid: true,
        content: 'Edit Template',
        onClick: function onClick() {
          return router.push('/templates/m/' + node.id + '/edit');
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
        basic: true,
        fluid: true,
        content: 'Close',
        onClick: onClose
      })
    )
  );
};

MpCopyConfirmation.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MpCopyConfirmation);

/***/ }),
/* 3188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Description_Description__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MpTemplateDescription = function (_React$Component) {
  _inherits(MpTemplateDescription, _React$Component);

  function MpTemplateDescription(props) {
    _classCallCheck(this, MpTemplateDescription);

    var _this = _possibleConstructorReturn(this, (MpTemplateDescription.__proto__ || Object.getPrototypeOf(MpTemplateDescription)).call(this, props));

    _this.state = {
      description: _this.props.node.description
    };
    _this.descriptionChangeHandler = _this.descriptionChangeHandler.bind(_this);
    _this.updateDescription = _this.updateDescription.bind(_this);
    _this.resetDescription = _this.resetDescription.bind(_this);
    return _this;
  }

  _createClass(MpTemplateDescription, [{
    key: 'descriptionChangeHandler',
    value: function descriptionChangeHandler(value) {
      this.setState({ description: value });
    }
  }, {
    key: 'updateDescription',
    value: function updateDescription(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update description',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated description',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default description if null
      var description = this.state.description === '<p><br></p>' ? null : this.state.description;
      var id = this.props.node.id;


      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3200);
      });

      var optimisticResponse = {
        updateMpTemplate: { mp_template: { id: id, description: description } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            description: description
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetDescription',
    value: function resetDescription() {
      this.setState({ description: this.props.node.description });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Description_Description__["a" /* default */], {
          canEdit: this.props.canEdit,
          localDescription: this.state.description,
          reset: this.resetDescription,
          description: this.props.node.description,
          descriptionChangeHandler: this.descriptionChangeHandler,
          updateDescription: this.updateDescription
        })
      );
    }
  }]);

  return MpTemplateDescription;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MpTemplateDescription.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateDescription);

/***/ }),
/* 3189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Actions__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Title__ = __webpack_require__(3196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideDownUpTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__ = __webpack_require__(183);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Intercom */














var MpTemplateHeader = function (_React$Component) {
  _inherits(MpTemplateHeader, _React$Component);

  function MpTemplateHeader(props) {
    _classCallCheck(this, MpTemplateHeader);

    var _this = _possibleConstructorReturn(this, (MpTemplateHeader.__proto__ || Object.getPrototypeOf(MpTemplateHeader)).call(this, props));

    _this.state = {
      actionsMenuOpen: false
    };
    _this.signOut = _this.signOut.bind(_this);
    _this.getHelp = _this.getHelp.bind(_this);
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }

  _createClass(MpTemplateHeader, [{
    key: 'getHelp',
    value: function getHelp() {
      /* eslint-disable new-cap */
      if ((typeof Intercom === 'undefined' ? 'undefined' : _typeof(Intercom)) !== undefined) Intercom('show');
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/users/sign_out').then(function () {
        window.location = '/';
      });
    }
  }, {
    key: 'toggleActionsMenu',
    value: function toggleActionsMenu() {
      this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          viewer = _props.viewer,
          router = _props.router;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.windowDimensions.width >= __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer, __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.header].join(' ')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerNav' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 4 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    style: { padding: '0 1.5em 0 0.5em' },
                    onClick: function onClick() {
                      return _this2.props.router.go(-1);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: {
                  flex: 1,
                  textAlign: 'right'
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'inline-block', marginLeft: '2em' } },
                this.props.viewer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App_OptionsMenu__["a" /* default */], { viewer: viewer, router: router })
              )
            )
          )
        ),
        this.props.windowDimensions.width < __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'item',
                  style: { padding: '0 0.5em' },
                  onClick: function onClick() {
                    return _this2.props.router.go(-1);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'chevron left icon' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: (this.props.sidebarOpen ? 'active ' : '') + 'item',
                  onClick: this.props.toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'menu right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'item', onClick: this.toggleActionsMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'ellipsis vertical' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide-down-up',
              transitionEnterTimeout: 0,
              transitionLeaveTimeout: 300
            },
            this.state.actionsMenuOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__Document_scss___default.a.mobileActionMenu },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Title__["a" /* default */], {
                  node: this.props.document,
                  relay: this.props.relay,
                  canEdit: this.props.document.can_edit
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Actions__["a" /* default */], {
                node: this.props.document,
                params: this.props.params,
                relay: this.props.relay,
                router: this.props.router,
                onClose: this.toggleActionsMenu,
                windowDimensions: this.props.windowDimensions
              })
            )
          )
        )
      );
    }
  }]);

  return MpTemplateHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MpTemplateHeader.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  windowDimensions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateHeader);

/***/ }),
/* 3190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_3_filestack_js__["a" /* default */].init(apikey);

var MpTemplateLogo = function (_React$Component) {
  _inherits(MpTemplateLogo, _React$Component);

  function MpTemplateLogo(props) {
    _classCallCheck(this, MpTemplateLogo);

    var _this = _possibleConstructorReturn(this, (MpTemplateLogo.__proto__ || Object.getPrototypeOf(MpTemplateLogo)).call(this, props));

    _this.uploadLogo = _this.uploadLogo.bind(_this);
    _this.openPicker = _this.openPicker.bind(_this);
    _this.deleteLogo = _this.deleteLogo.bind(_this);
    return _this;
  }

  _createClass(MpTemplateLogo, [{
    key: 'uploadLogo',
    value: function uploadLogo(fields) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to upload logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-logo');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3201);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: fields.handle,
            logo_mimetype: fields.mimetype,
            logo_size: fields.size,
            logo_url: fields.url,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openPicker',
    value: function openPicker() {
      var _this2 = this;

      client.pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this2.uploadLogo({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
    }
  }, {
    key: 'deleteLogo',
    value: function deleteLogo() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete logo',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-logo');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3202);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            logo_handle: null,
            logo_mimetype: null,
            logo_size: null,
            logo_url: null,
            id: this.props.viewer.primary_brand.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Logo_Logo__["a" /* default */], {
        canEdit: this.props.canEdit,
        deleteLogo: this.deleteLogo,
        url: this.props.node.brand.logo_url,
        openPicker: this.openPicker
      });
    }
  }]);

  return MpTemplateLogo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MpTemplateLogo.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateLogo);

/***/ }),
/* 3191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_SidebarComponent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(3189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Brand__ = __webpack_require__(3186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Logo__ = __webpack_require__(3190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Description__ = __webpack_require__(3188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Actions__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Notes__ = __webpack_require__(3195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Playlist_Preview__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_utils_array__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RootComponent__ = __webpack_require__(54);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// eslint-disable-next-line new-cap
var SortableItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__["SortableElement"])(__WEBPACK_IMPORTED_MODULE_19__Playlist_Preview__["a" /* default */]);

// eslint-disable-next-line new-cap
var SortableList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_react_sortable_hoc__["SortableContainer"])(function (_ref) {
  var items = _ref.items,
      openPlaylist = _ref.openPlaylist;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    items.map(function (_ref2, index) {
      var playlist = _ref2.node;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableItem, {
        playlist: playlist,
        index: index,
        openPlaylist: openPlaylist,
        key: index
      });
    })
  );
});

var MpTemplateComponent = (_temp = _class = function (_React$Component) {
  _inherits(MpTemplateComponent, _React$Component);

  function MpTemplateComponent(props) {
    _classCallCheck(this, MpTemplateComponent);

    var _this = _possibleConstructorReturn(this, (MpTemplateComponent.__proto__ || Object.getPrototypeOf(MpTemplateComponent)).call(this, props));

    _this.canEdit = _this.canEdit.bind(_this);
    _this.onSetSidebarOpen = _this.onSetSidebarOpen.bind(_this);
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.openPlaylist = _this.openPlaylist.bind(_this);
    _this.closePlaylist = _this.closePlaylist.bind(_this);
    _this.createMpTemplatePlaylist = _this.createMpTemplatePlaylist.bind(_this);
    _this.reorderMpTemplatePlaylists = _this.reorderMpTemplatePlaylists.bind(_this);

    _this.state = {
      error: !_this.props.node,
      sidebarOpen: false
    };
    return _this;
  }

  _createClass(MpTemplateComponent, [{
    key: 'onSetSidebarOpen',
    value: function onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'toggleSidebar',
    value: function toggleSidebar(ev) {
      ev.preventDefault();
      this.onSetSidebarOpen(!this.state.sidebarOpen);
    }
  }, {
    key: 'openPlaylist',
    value: function openPlaylist(id) {
      this.props.router.push('/templates/m/' + this.props.node.id + '/' + this.props.params.action + '/playlist/' + id);
    }
  }, {
    key: 'closePlaylist',
    value: function closePlaylist() {
      this.props.router.go(-1);
    }
  }, {
    key: 'createMpTemplatePlaylist',
    value: function createMpTemplatePlaylist() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added playlist',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.openPlaylist(response.createMpTemplatePlaylist.new_mp_template_playlist_edge.node.id);
        __WEBPACK_IMPORTED_MODULE_12__Modules__["c" /* Analytics */].trackEvent('created-mp-template-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3204);
      });

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_mp_template_playlist_edge',
        connectionInfo: [{
          key: 'MpTemplateContainer_mp_template_playlists',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            mp_template_id: parentID,
            title: '(Untitled Playlist)'
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'reorderMpTemplatePlaylists',
    value: function reorderMpTemplatePlaylists(_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist order',
          intent: __WEBPACK_IMPORTED_MODULE_12__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_12__Modules__["c" /* Analytics */].trackEvent('updated-mp-template-playlist-position');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3203);
      });

      var mpTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      var movedPlaylistId = mpTemplate.mp_template_playlists.edges[oldIndex].node.id;
      mpTemplate.mp_template_playlists.edges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_utils_array__["a" /* arrayMove */])(mpTemplate.mp_template_playlists.edges, oldIndex, newIndex);

      var optimisticResponse = {
        updateMpTemplatePlaylist: {
          mp_template: mpTemplate
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { id: movedPlaylistId, position: newIndex + 1 }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          node = _props.node,
          params = _props.params,
          relay = _props.relay,
          router = _props.router,
          viewer = _props.viewer;
      var _state = this.state,
          error = _state.error,
          sidebarOpen = _state.sidebarOpen;

      var playlistOpen = this.props.params.playlist_id !== undefined;

      var ActionsMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref4) {
          var window = _ref4.window;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Actions__["a" /* default */], {
            node: node,
            params: params,
            relay: relay,
            router: router,
            viewer: viewer,
            windowDimensions: window
          });
        }
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref5) {
          var isComputer = _ref5.isComputer,
              isMobile = _ref5.isMobile,
              isLargeScreen = _ref5.isLargeScreen,
              window = _ref5.window;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_sidebar___default.a,
              {
                sidebar: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App_SidebarComponent__["a" /* default */], {
                  setSidebarOpenState: _this3.onSetSidebarOpen,
                  router: router,
                  viewer: viewer
                }),
                sidebarClassName: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.sidebar,
                open: sidebarOpen,
                onSetOpen: _this3.onSetSidebarOpen,
                touch: false,
                contentClassName: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.mobileSidebarContent,
                rootClassName: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.mobileSidebarRoot
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], {
                toggleSidebar: _this3.toggleSidebar,
                sidebarOpen: sidebarOpen,
                document: node,
                relay: relay,
                router: router,
                params: params,
                viewer: viewer,
                windowDimensions: window
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["s" /* Container */],
                { className: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.container },
                !isLargeScreen && isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                    {
                      columns: 'equal',
                      className: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.actionsMenuTablet
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      ActionsMenu
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["t" /* Segment */],
                  {
                    className: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.segment,
                    style: { maxWidth: '720px' }
                  },
                  isLargeScreen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["u" /* Rail */],
                    {
                      position: 'right',
                      close: true,
                      className: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.actionsMenuDesktop
                    },
                    ActionsMenu
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */],
                    { padded: !isMobile, relaxed: !isMobile },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      !node.public && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: viewer,
                          node: node,
                          relay: relay
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Brand__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: viewer,
                          node: node,
                          relay: relay
                        })
                      ),
                      node.public && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: viewer,
                          node: { brand: { header: viewer.primary_brand.logo_url } },
                          relay: relay
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Brand__["a" /* default */], {
                          canEdit: _this3.canEdit(),
                          viewer: viewer,
                          node: { brand: { header: viewer.primary_brand.header } },
                          relay: relay
                        })
                      )
                    ),
                    playlistOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'a',
                          { onClick: _this3.closePlaylist },
                          '< Back to All Playlists'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        _this3.props.children
                      )
                    ),
                    !playlistOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Description__["a" /* default */], {
                          node: _this3.props.node,
                          relay: _this3.props.relay,
                          canEdit: _this3.canEdit()
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      { columns: 'equal' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        !playlistOpen && _this3.canEdit() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SortableList, {
                          items: node.mp_template_playlists.edges,
                          onSortEnd: _this3.reorderMpTemplatePlaylists,
                          helperClass: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.sortableHelper,
                          openPlaylist: _this3.openPlaylist,
                          pressDelay: 200
                        }),
                        !playlistOpen && !_this3.canEdit() && node.mp_template_playlists.edges.map(function (_ref6, index) {
                          var mpTemplatePlaylist = _ref6.node;
                          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Playlist_Preview__["a" /* default */], {
                            playlist: mpTemplatePlaylist,
                            openPlaylist: _this3.openPlaylist,
                            key: index
                          });
                        }),
                        isMobile && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_12__Modules__["f" /* MobileModal */],
                          {
                            open: playlistOpen,
                            onClose: _this3.closePlaylist
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_12__Modules__["f" /* MobileModal */].Content,
                            null,
                            _this3.props.children
                          )
                        ),
                        node.mp_template_playlists.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          {
                            style: { textAlign: 'center', padding: '2em' }
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'h3',
                            null,
                            'This music list has no playlists'
                          ),
                          _this3.canEdit() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["b" /* Button */], {
                            primary: true,
                            icon: 'plus',
                            labelPosition: 'left',
                            content: 'Add Playlist',
                            onClick: _this3.createMpTemplatePlaylist
                          })
                        ),
                        !playlistOpen && _this3.canEdit() && node.mp_template_playlists.edges.length !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["b" /* Button */], {
                          primary: true,
                          icon: 'plus',
                          labelPosition: 'left',
                          content: 'Add Playlist',
                          onClick: _this3.createMpTemplatePlaylist
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["v" /* Divider */],
                          { horizontal: true, className: __WEBPACK_IMPORTED_MODULE_9__Document_scss___default.a.heading },
                          'Notes'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Notes__["a" /* default */], { node: node, relay: relay })
                      )
                    )
                  )
                )
              )
            ),
            !node && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App_404__["a" /* default */], { viewer: viewer }),
              !error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["a" /* Loader */], null)
            )
          );
        }
      );
    }
  }]);

  return MpTemplateComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__App_Authenticate__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_found__["withRouter"])(MpTemplateComponent)));

/***/ }),
/* 3192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MpTemplateComponent__ = __webpack_require__(3191);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__MpTemplateComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3206);
  },
  viewer: function viewer() {
    return __webpack_require__(3207);
  }
}, function () {
  return __webpack_require__(3205);
}));

/***/ }),
/* 3193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6, _graphql7, _graphql8;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MpTemplatePlaylist = function (_React$Component) {
  _inherits(MpTemplatePlaylist, _React$Component);

  function MpTemplatePlaylist(props) {
    _classCallCheck(this, MpTemplatePlaylist);

    var _this = _possibleConstructorReturn(this, (MpTemplatePlaylist.__proto__ || Object.getPrototypeOf(MpTemplatePlaylist)).call(this, props));

    _this.state = {
      maxLengthWarningOpen: false
    };
    _this.goBack = _this.goBack.bind(_this);
    _this.canEdit = _this.canEdit.bind(_this);
    _this.updatePlaylist = _this.updatePlaylist.bind(_this);
    _this.updateMaxLength = _this.updateMaxLength.bind(_this);
    _this.deleteMpTemplatePlaylist = _this.deleteMpTemplatePlaylist.bind(_this);
    _this.deleteMpTemplatePlaylistSong = _this.deleteMpTemplatePlaylistSong.bind(_this);
    _this.playlistContainsSong = _this.playlistContainsSong.bind(_this);
    _this.createMpTemplatePlaylistSong = _this.createMpTemplatePlaylistSong.bind(_this);
    _this.addMpTemplatePlaylistRecommendations = _this.addMpTemplatePlaylistRecommendations.bind(_this);
    _this.removeMpTemplatePlaylistRecommendation = _this.removeMpTemplatePlaylistRecommendation.bind(_this);
    return _this;
  }

  _createClass(MpTemplatePlaylist, [{
    key: 'goBack',
    value: function goBack() {
      this.props.router.go(-1);
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      return this.props.node.mp_template.can_edit && this.props.params.action === 'edit';
    }
  }, {
    key: 'deleteMpTemplatePlaylist',
    value: function deleteMpTemplatePlaylist(successCb) {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.goBack();
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-mp-template-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3216);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.params.id,
        pathToConnection: ['mp_template', 'mp_template_playlists'],
        deletedIDFieldName: 'deletedMpTemplatePlaylistId',
        connectionKeys: [{
          key: 'MpTemplateContainer_mp_template_playlists',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { id: this.props.node.id } },
        onCompleted: onCompleted,
        onError: onError,
        configs: configs
      });
    }
  }, {
    key: 'deleteMpTemplatePlaylistSong',
    value: function deleteMpTemplatePlaylistSong(e, song, parent, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete song',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3217);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.node.id,
        pathToConnection: ['mp_template_playlist', 'playlist_songs'],
        deletedIDFieldName: 'deletedMpTemplatePlaylistSongId',
        connectionKeys: [{
          key: 'MpTemplateContainer_mp_template_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: parent.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updatePlaylist',
    value: function updatePlaylist(data, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-mp-template-playlist');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3212);
      });

      var optimisticResponse = {
        updateMpTemplatePlaylist: {
          mp_template_playlist: _extends({}, this.props.node, _defineProperty({}, data.name, data.value))
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _defineProperty({
            id: this.props.node.id
          }, data.name, data.value)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateMaxLength',
    value: function updateMaxLength(data, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-mp-template-playlist');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3211);
      });

      var maxLength = data.value ? parseInt(data.value, 0) : null;

      var optimisticResponse = {
        updateMpTemplatePlaylist: {
          mp_template_playlist: _extends({}, this.props.node, {
            maxLength: maxLength
          })
        }
      };

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.id,
            max_length: maxLength
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createMpTemplatePlaylistSong',
    value: function createMpTemplatePlaylistSong(e, song, parent, successCb, failureCb) {
      if (Array.isArray(song)) {
        this.createMpTemplatePlaylistSongs(e, song, parent, successCb, failureCb);
        return;
      }
      var maxLength = this.props.node.max_length;
      if (maxLength && this.props.node.playlist_songs.edges.length >= maxLength) {
        if (failureCb) failureCb();
        this.setState({ maxLengthWarningOpen: true });
        return;
      }
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add song to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3214);
      });

      var songParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id', '__typename'));
      if (songParams.external_source) {
        songParams.external_source = songParams.external_source.toUpperCase();
      }

      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_mp_template_playlist_song_edge',
        connectionInfo: [{
          key: 'MpTemplateContainer_mp_template_playlist_songs',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            mp_template_playlist_id: parentID
          }, songParams, {
            song_images: songParams.song_images ? songParams.song_images.edges.map(function (_ref) {
              var image = _ref.node;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
            }) : []
          })
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createMpTemplatePlaylistSongs',
    value: function createMpTemplatePlaylistSongs(e, songs, parent, successCb, failureCb) {
      var maxLength = this.props.node.max_length;
      if (maxLength && this.props.node.playlist_songs.edges.length + songs.length > maxLength) {
        if (failureCb) failureCb();
        var songsLeft = maxLength - this.props.node.playlist_songs.edges.length;
        this.setState({
          maxLengthWarningOpen: true,
          maxLengthMessage: songsLeft > 0 ? 'Please select up to ' + songsLeft + ' song' + (songsLeft !== 1 ? 's' : '') + '.' : null
        });
        return;
      }
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add songs to playlist',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3215);
      });

      var newSongs = songs.map(function (song) {
        var newSong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(song, 'id', '__typename'));
        if (newSong.external_source) {
          newSong.external_source = newSong.external_source.toUpperCase();
        }
        newSong.song_images = newSong.song_images ? newSong.song_images.edges.map(function (_ref2) {
          var image = _ref2.node;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(image, 'url', 'width', 'height');
        }) : [];
        return newSong;
      });

      var parentID = this.props.node.id;

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            mp_template_playlist_id: parentID,
            songs: newSongs
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'playlistContainsSong',
    value: function playlistContainsSong(song) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.node.playlist_songs.edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var playlistSong = _step.value;

          if (playlistSong.node.song.isrc === song.isrc) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'addMpTemplatePlaylistRecommendations',
    value: function addMpTemplatePlaylistRecommendations(playlistIds, successCb, failureCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist recommendations',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
        if (failureCb) failureCb();
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('added-mp-template-playlist-recommendations');
      };

      var mutation = _graphql7 || (_graphql7 = function _graphql7() {
        return __webpack_require__(3213);
      });

      var environment = this.props.relay.environment;

      var allPlaylists = this.props.viewer.playlists.edges.concat(this.props.viewer.public_playlists.edges);
      var newRecs = playlistIds.map(function (id) {
        return allPlaylists.filter(function (p) {
          return p.node.id === id;
        })[0];
      });
      var mpTemplatePlaylist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      mpTemplatePlaylist.playlist_recommendations.edges = mpTemplatePlaylist.playlist_recommendations.edges.concat(newRecs);

      var optimisticResponse = {
        addMpTemplatePlaylistRecommendations: {
          mp_template_playlist: mpTemplatePlaylist
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            mp_template_playlist_id: this.props.node.id,
            playlist_ids: playlistIds
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'removeMpTemplatePlaylistRecommendation',
    value: function removeMpTemplatePlaylistRecommendation(playlistId, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to remove playlist recommendation',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql8 || (_graphql8 = function _graphql8() {
        return __webpack_require__(3218);
      });

      var environment = this.props.relay.environment;

      var mpTemplatePlaylist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.node);
      mpTemplatePlaylist.playlist_recommendations.edges = mpTemplatePlaylist.playlist_recommendations.edges.filter(function (p) {
        return p.node.id !== playlistId;
      });

      var optimisticResponse = {
        removeMpTemplatePlaylistRecommendation: {
          mp_template_playlist: mpTemplatePlaylist
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            mp_template_playlist_id: this.props.node.id,
            playlist_id: playlistId
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          node = _props.node,
          relay = _props.relay,
          viewer = _props.viewer;
      var _state = this.state,
          maxLengthMessage = _state.maxLengthMessage,
          maxLengthWarningOpen = _state.maxLengthWarningOpen;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { paddingTop: '1em', paddingBottom: '3em' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */],
          {
            open: maxLengthWarningOpen,
            onClose: function onClose() {
              return _this3.setState({ maxLengthWarningOpen: false });
            },
            size: 'mini'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Header, { content: 'Song Limit Reached' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'You can only add up to ',
              ' ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                null,
                node.max_length,
                ' ',
                'song' + (node.max_length !== 1 ? 's' : '')
              ),
              ' ',
              'to this playlist.',
              ' ',
              maxLengthMessage || 'Please remove an existing song before adding a new one.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["a" /* Modal */].Actions,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["b" /* Button */], {
              content: 'Close',
              onClick: function onClick() {
                return _this3.setState({ maxLengthWarningOpen: false });
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Playlist__["a" /* default */], {
          playlist: node,
          goBack: this.goBack,
          relay: relay,
          searchResults: node.song_search.edges.map(function (edge) {
            return edge.node;
          }),
          refetchSearchResults: relay.refetch,
          viewer: viewer,
          editable: this.canEdit(),
          fillable: node.mp_template.can_edit,
          showControls: this.canEdit(),
          addPlaylistRecommendations: this.addMpTemplatePlaylistRecommendations,
          removePlaylistRecommendation: this.removeMpTemplatePlaylistRecommendation,
          updatePlaylist: this.updatePlaylist,
          updateMaxLength: this.updateMaxLength,
          deletePlaylist: this.deleteMpTemplatePlaylist,
          removeFromPlaylist: this.deleteMpTemplatePlaylistSong,
          playlistContainsSong: this.playlistContainsSong,
          addToPlaylist: this.createMpTemplatePlaylistSong
        })
      );
    }
  }]);

  return MpTemplatePlaylist;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MpTemplatePlaylist.propTypes = {
  params: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplatePlaylist);

/***/ }),
/* 3194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MpTemplatePlaylist__ = __webpack_require__(3193);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__MpTemplatePlaylist__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3209);
  },
  viewer: function viewer() {
    return __webpack_require__(3210);
  }
}, function () {
  return __webpack_require__(3208);
}));

/***/ }),
/* 3195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sections_Notepad_Notepad__ = __webpack_require__(1466);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MpTemplateNotes = function (_Component) {
  _inherits(MpTemplateNotes, _Component);

  function MpTemplateNotes(props) {
    _classCallCheck(this, MpTemplateNotes);

    var _this = _possibleConstructorReturn(this, (MpTemplateNotes.__proto__ || Object.getPrototypeOf(MpTemplateNotes)).call(this, props));

    _this.updateNotes = _this.updateNotes.bind(_this);
    return _this;
  }

  _createClass(MpTemplateNotes, [{
    key: 'updateNotes',
    value: function updateNotes(notes) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update notes',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-mptemplate-notes');
      };

      // Update event if values have changed and can_edit
      if (this.props.node.notes !== notes && this.props.node.can_edit) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3219);
        });
        var id = this.props.node.id;

        var optimisticResponse = {
          updateMpTemplate: { mp_template: { id: id, notes: notes } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              notes: notes
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var notes = this.props.node.notes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Sections_Notepad_Notepad__["a" /* default */], { notes: notes, update: this.updateNotes });
    }
  }]);

  return MpTemplateNotes;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MpTemplateNotes.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MpTemplateNotes);

/***/ }),
/* 3196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MpTemplateTitle = function (_React$Component) {
  _inherits(MpTemplateTitle, _React$Component);

  function MpTemplateTitle(props) {
    _classCallCheck(this, MpTemplateTitle);

    var _this = _possibleConstructorReturn(this, (MpTemplateTitle.__proto__ || Object.getPrototypeOf(MpTemplateTitle)).call(this, props));

    _this.state = {
      title: _this.props.node.title
    };
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    return _this;
  }

  _createClass(MpTemplateTitle, [{
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update form template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated form template title',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var title = this.state.title ? this.state.title : '(Untitled Music List Template)';
      var id = this.props.node.id;


      if (this.props.node.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3220);
        });

        var optimisticResponse = {
          updateMpTemplate: { mp_template: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sections_Title_Title__["a" /* default */], {
        canEdit: this.props.canEdit,
        localTitle: this.state.title,
        title: this.props.node.title,
        titleChangeHandler: this.titleChangeHandler,
        updateTitle: this.updateTitle,
        rightAlign: this.props.rightAlign
      });
    }
  }]);

  return MpTemplateTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MpTemplateTitle.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  rightAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (MpTemplateTitle);

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a5b56a9927c25bb40af946f9294635bc
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyMpTemplateInput = {
  clientMutationId?: ?string,
  title: string,
  mp_template_id?: ?string,
};
export type ActionsComponent_copyMpTemplateMutationVariables = {|
  input: CopyMpTemplateInput
|};
export type ActionsComponent_copyMpTemplateMutationResponse = {|
  +copyMpTemplate: ?{|
    +mp_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type ActionsComponent_copyMpTemplateMutation = {|
  variables: ActionsComponent_copyMpTemplateMutationVariables,
  response: ActionsComponent_copyMpTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_copyMpTemplateMutation(
  $input: CopyMpTemplateInput!
) {
  copyMpTemplate(input: $input) {
    mp_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "copyMpTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CopyMpTemplateInput!"
    }],
    "concreteType": "CopyMpTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_copyMpTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_copyMpTemplateMutation(\n  $input: CopyMpTemplateInput!\n) {\n  copyMpTemplate(input: $input) {\n    mp_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_copyMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_copyMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd0110f6e03fe39076519f9b47e14e0c1';
module.exports = node;

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1cb5d7ae356e7c4bc5fcf5c43ee8de8d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMpTemplateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteMpTemplateMutationVariables = {|
  input: DeleteMpTemplateInput
|};
export type ActionsComponent_deleteMpTemplateMutationResponse = {|
  +deleteMpTemplate: ?{|
    +deletedMpTemplateId: ?string
  |}
|};
export type ActionsComponent_deleteMpTemplateMutation = {|
  variables: ActionsComponent_deleteMpTemplateMutationVariables,
  response: ActionsComponent_deleteMpTemplateMutationResponse,
|};
*/

/*
mutation ActionsComponent_deleteMpTemplateMutation(
  $input: DeleteMpTemplateInput!
) {
  deleteMpTemplate(input: $input) {
    deletedMpTemplateId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMpTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteMpTemplateInput!"
    }],
    "concreteType": "DeleteMpTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedMpTemplateId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ActionsComponent_deleteMpTemplateMutation",
    "id": null,
    "text": "mutation ActionsComponent_deleteMpTemplateMutation(\n  $input: DeleteMpTemplateInput!\n) {\n  deleteMpTemplate(input: $input) {\n    deletedMpTemplateId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ActionsComponent_deleteMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ActionsComponent_deleteMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '05d62185177549309907a8136a39f3c6';
module.exports = node;

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 87938bc80d4ed6b50c494dfd32b9ca00
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_MpTemplate_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_MpTemplate_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_MpTemplate_updateBrandMutation = {|
  variables: Brand_MpTemplate_updateBrandMutationVariables,
  response: Brand_MpTemplate_updateBrandMutationResponse,
|};
*/

/*
mutation Brand_MpTemplate_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Brand_MpTemplate_updateBrandMutation",
    "id": null,
    "text": "mutation Brand_MpTemplate_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Brand_MpTemplate_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Brand_MpTemplate_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fdad45ee6bf2314ad3cb4e7a6c8af07b';
module.exports = node;

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 07935c7ee5bffae0ddf24944c4a45103
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Description_MpTemplate_UpdateMpTemplateMutationVariables = {|
  input: UpdateMpTemplateInput
|};
export type Description_MpTemplate_UpdateMpTemplateMutationResponse = {|
  +updateMpTemplate: ?{|
    +mp_template: ?{|
      +description: ?string
    |}
  |}
|};
export type Description_MpTemplate_UpdateMpTemplateMutation = {|
  variables: Description_MpTemplate_UpdateMpTemplateMutationVariables,
  response: Description_MpTemplate_UpdateMpTemplateMutationResponse,
|};
*/

/*
mutation Description_MpTemplate_UpdateMpTemplateMutation(
  $input: UpdateMpTemplateInput!
) {
  updateMpTemplate(input: $input) {
    mp_template {
      description
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateMpTemplateInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Description_MpTemplate_UpdateMpTemplateMutation",
    "id": null,
    "text": "mutation Description_MpTemplate_UpdateMpTemplateMutation(\n  $input: UpdateMpTemplateInput!\n) {\n  updateMpTemplate(input: $input) {\n    mp_template {\n      description\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Description_MpTemplate_UpdateMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplate",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Description_MpTemplate_UpdateMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplate",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '815f089999d0378bbabec37742530f13';
module.exports = node;

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5d0cb626f2343db1409d093e2dc65292
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_MpTemplate_Logo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_MpTemplate_Logo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_MpTemplate_Logo_updateBrandMutation = {|
  variables: Logo_MpTemplate_Logo_updateBrandMutationVariables,
  response: Logo_MpTemplate_Logo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_MpTemplate_Logo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_MpTemplate_Logo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_MpTemplate_Logo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_MpTemplate_Logo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_MpTemplate_Logo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3cd0d9f24797436de4cd5ef577868204';
module.exports = node;

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a7e86fbb1e2e0c2861ab6f2e1c8512f5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Logo_MpTemplate_deleteLogo_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Logo_MpTemplate_deleteLogo_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +logo_url: ?string,
    |}
  |}
|};
export type Logo_MpTemplate_deleteLogo_updateBrandMutation = {|
  variables: Logo_MpTemplate_deleteLogo_updateBrandMutationVariables,
  response: Logo_MpTemplate_deleteLogo_updateBrandMutationResponse,
|};
*/

/*
mutation Logo_MpTemplate_deleteLogo_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      logo_url
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateBrandInput!"
    }],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Logo_MpTemplate_deleteLogo_updateBrandMutation",
    "id": null,
    "text": "mutation Logo_MpTemplate_deleteLogo_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      logo_url\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Logo_MpTemplate_deleteLogo_updateBrandMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Logo_MpTemplate_deleteLogo_updateBrandMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '03a449992b775f8c8423c31428e9e6b5';
module.exports = node;

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fe321d935ec007ed385f15e3f8a6c5f6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplateContainer_node$ref = any;
export type UpdateMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutationVariables = {|
  input: UpdateMpTemplatePlaylistInput
|};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutationResponse = {|
  +updateMpTemplatePlaylist: ?{|
    +mp_template: ?{|
      +$fragmentRefs: MpTemplateContainer_node$ref
    |}
  |}
|};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutation = {|
  variables: MpTemplateComponent_UpdateMpTemplatePlaylistMutationVariables,
  response: MpTemplateComponent_UpdateMpTemplatePlaylistMutationResponse,
|};
*/

/*
mutation MpTemplateComponent_UpdateMpTemplatePlaylistMutation(
  $input: UpdateMpTemplatePlaylistInput!
) {
  updateMpTemplatePlaylist(input: $input) {
    mp_template {
      ...MpTemplateContainer_node
      id
    }
  }
}

fragment MpTemplateContainer_node on MpTemplate {
  id
  title
  description
  notes
  can_edit
  public
  brand {
    id
    logo_url
    header
  }
  mp_template_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateMpTemplatePlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
    "id": null,
    "text": "mutation MpTemplateComponent_UpdateMpTemplatePlaylistMutation(\n  $input: UpdateMpTemplatePlaylistInput!\n) {\n  updateMpTemplatePlaylist(input: $input) {\n    mp_template {\n      ...MpTemplateContainer_node\n      id\n    }\n  }\n}\n\nfragment MpTemplateContainer_node on MpTemplate {\n  id\n  title\n  description\n  notes\n  can_edit\n  public\n  brand {\n    id\n    logo_url\n    header\n  }\n  mp_template_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplate",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MpTemplateContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplate",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "public",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "header",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template_playlists",
            "storageKey": "mp_template_playlists(first:99999)",
            "args": v5,
            "concreteType": "MpTemplatePlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylist",
                "plural": false,
                "selections": [v2, v3, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "thumbnail",
                  "storageKey": "thumbnail(height:240,width:240)",
                  "args": [{
                    "kind": "Literal",
                    "name": "height",
                    "value": 240,
                    "type": "Int"
                  }, {
                    "kind": "Literal",
                    "name": "width",
                    "value": 240,
                    "type": "Int"
                  }],
                  "concreteType": "SongImage",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "width",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "height",
                    "args": null,
                    "storageKey": null
                  }, v2]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "mp_template_playlists",
            "args": v5,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlists",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a08a93aa425086134895f1b7b4137aeb';
module.exports = node;

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e4ff602d344059f5e06196b345327b75
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type CreateMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  mp_template_id: string,
  title: string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MpTemplateComponent_createMpTemplatePlaylistMutationVariables = {|
  input: CreateMpTemplatePlaylistInput
|};
export type MpTemplateComponent_createMpTemplatePlaylistMutationResponse = {|
  +createMpTemplatePlaylist: ?{|
    +new_mp_template_playlist_edge: ?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: MpTemplatePlaylistContainer_node$ref,
      |}
    |}
  |}
|};
export type MpTemplateComponent_createMpTemplatePlaylistMutation = {|
  variables: MpTemplateComponent_createMpTemplatePlaylistMutationVariables,
  response: MpTemplateComponent_createMpTemplatePlaylistMutationResponse,
|};
*/

/*
mutation MpTemplateComponent_createMpTemplatePlaylistMutation(
  $input: CreateMpTemplatePlaylistInput!
) {
  createMpTemplatePlaylist(input: $input) {
    new_mp_template_playlist_edge {
      node {
        id
        ...MpTemplatePlaylistContainer_node
      }
    }
  }
}

fragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMpTemplatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateMpTemplatePlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v6, v7, v8, v2]
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v6, v7, v8]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplateComponent_createMpTemplatePlaylistMutation",
    "id": null,
    "text": "mutation MpTemplateComponent_createMpTemplatePlaylistMutation(\n  $input: CreateMpTemplatePlaylistInput!\n) {\n  createMpTemplatePlaylist(input: $input) {\n    new_mp_template_playlist_edge {\n      node {\n        id\n        ...MpTemplatePlaylistContainer_node\n      }\n    }\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplateComponent_createMpTemplatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_mp_template_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylist",
            "plural": false,
            "selections": [v2, {
              "kind": "FragmentSpread",
              "name": "MpTemplatePlaylistContainer_node",
              "args": null
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplateComponent_createMpTemplatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_mp_template_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylist",
            "plural": false,
            "selections": [v2, v3, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "max_length",
              "args": null,
              "storageKey": null
            }, v5, v9, {
              "kind": "LinkedField",
              "alias": null,
              "name": "playlist_recommendations",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Playlist",
                  "plural": false,
                  "selections": [v2, v3, v4, v9, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "num_songs",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": "playlist_songs",
              "name": "mp_template_playlist_songs",
              "storageKey": "mp_template_playlist_songs(first:99999)",
              "args": v10,
              "concreteType": "MpTemplatePlaylistSongConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSongEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MpTemplatePlaylistSong",
                  "plural": false,
                  "selections": [v2, v5, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [v11, v2, v12, v13, v14, v15, v16]
                  }, v11]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cursor",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "endCursor",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasNextPage",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }, {
              "kind": "LinkedHandle",
              "alias": "playlist_songs",
              "name": "mp_template_playlist_songs",
              "args": v10,
              "handle": "connection",
              "key": "MpTemplateContainer_mp_template_playlist_songs",
              "filters": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song_search",
              "storageKey": "song_search(first:10,query:\"\")",
              "args": [{
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "query",
                "value": "",
                "type": "String!"
              }],
              "concreteType": "SongConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SongEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v11, v2, v13, v14, v15, v12, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "duration_ms",
                    "args": null,
                    "storageKey": null
                  }, v16, {
                    "kind": "InlineFragment",
                    "type": "SpotifySong",
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_id",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_source",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_data",
                      "args": null,
                      "storageKey": null
                    }]
                  }]
                }]
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "mp_template",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplate",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "public",
                "args": null,
                "storageKey": null
              }, v2]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9c6cbbe96e48b6fcc5886de8f6641c9d';
module.exports = node;

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9b756154cd92cd7f2d1b5f1f05091479
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MpTemplateContainer_RefetchQueryVariables = {|
  id: string
|};
export type MpTemplateContainer_RefetchQueryResponse = {|
  +node: ?{|
    +id?: string
  |}
|};
export type MpTemplateContainer_RefetchQuery = {|
  variables: MpTemplateContainer_RefetchQueryVariables,
  response: MpTemplateContainer_RefetchQueryResponse,
|};
*/

/*
query MpTemplateContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on MpTemplate {
      id
    }
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "MpTemplateContainer_RefetchQuery",
    "id": null,
    "text": "query MpTemplateContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on MpTemplate {\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplateContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "type": "MpTemplate",
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplateContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '70ed81c6034147871bcf5171378809b1';
module.exports = node;

/***/ }),
/* 3206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MpTemplateContainer_node$ref: FragmentReference;
export type MpTemplateContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +notes: ?string,
  +can_edit: ?boolean,
  +public: ?boolean,
  +brand: ?{|
    +id: string,
    +logo_url: ?string,
    +header: ?string,
  |},
  +mp_template_playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
        +num_songs: ?number,
      |}
    |}>
  |},
  +$refType: MpTemplateContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "MpTemplateContainer_node",
    "type": "MpTemplate",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["mp_template_playlists"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, v1, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "public",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "mp_template_playlists",
      "name": "__MpTemplateContainer_mp_template_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplatePlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MpTemplatePlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v0, v1, v2, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail",
            "storageKey": "thumbnail(height:240,width:240)",
            "args": [{
              "kind": "Literal",
              "name": "height",
              "value": 240,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "width",
              "value": 240,
              "type": "Int"
            }],
            "concreteType": "SongImage",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "width",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "height",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "num_songs",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f7928058327fba6e104a0adc0753b036';
module.exports = node;

/***/ }),
/* 3207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type MpTemplatePlaylistContainer_viewer$ref = any;
type SearchContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MpTemplateContainer_viewer$ref: FragmentReference;
export type MpTemplateContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string,
    +header: ?string,
    +logo_url: ?string,
  |},
  +$fragmentRefs: MpTemplatePlaylistContainer_viewer$ref & SearchContainer_viewer$ref,
  +$refType: MpTemplateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "MpTemplateContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0, {
        "kind": "ScalarField",
        "alias": null,
        "name": "header",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "MpTemplatePlaylistContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'bec6a08ae8521e0cf63fb62d55f08d93';
module.exports = node;

/***/ }),
/* 3208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash cb801f189cf5b36ba7958f6e3d2b2652
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type MpTemplatePlaylistContainer_RefetchQueryVariables = {|
  query: string,
  playlist_id: string,
|};
export type MpTemplatePlaylistContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
  |}
|};
export type MpTemplatePlaylistContainer_RefetchQuery = {|
  variables: MpTemplatePlaylistContainer_RefetchQueryVariables,
  response: MpTemplatePlaylistContainer_RefetchQueryResponse,
|};
*/

/*
query MpTemplatePlaylistContainer_RefetchQuery(
  $query: String!
  $playlist_id: ID!
) {
  node(id: $playlist_id) {
    __typename
    ...MpTemplatePlaylistContainer_node_1Qr5xf
    id
  }
}

fragment MpTemplatePlaylistContainer_node_1Qr5xf on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: $query) {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "playlist_id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "playlist_id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v3]
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v7, v8, v9]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "MpTemplatePlaylistContainer_RefetchQuery",
    "id": null,
    "text": "query MpTemplatePlaylistContainer_RefetchQuery(\n  $query: String!\n  $playlist_id: ID!\n) {\n  node(id: $playlist_id) {\n    __typename\n    ...MpTemplatePlaylistContainer_node_1Qr5xf\n    id\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node_1Qr5xf on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: $query) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylistContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MpTemplatePlaylistContainer_node",
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylistContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "MpTemplatePlaylist",
          "selections": [v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v6, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v4, v5, v10, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "storageKey": "mp_template_playlist_songs(first:99999)",
            "args": v11,
            "concreteType": "MpTemplatePlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSong",
                "plural": false,
                "selections": [v3, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v12, v13, v14, v15, v16]
                }, v2]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "args": v11,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": null,
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Variable",
              "name": "query",
              "variableName": "query",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v13, v14, v15, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v16, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "public",
              "args": null,
              "storageKey": null
            }, v3]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8c88a511ff75ccea99452b7674f84686';
module.exports = node;

/***/ }),
/* 3209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MpTemplatePlaylistContainer_node$ref: FragmentReference;
export type MpTemplatePlaylistContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +max_length: ?number,
  +position: ?number,
  +thumbnail: ?{|
    +url: ?string,
    +width: ?number,
    +height: ?number,
  |},
  +playlist_recommendations: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
        +num_songs: ?number,
      |}
    |}>
  |},
  +playlist_songs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +__typename: string,
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +album: ?string,
          +artist: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +song_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +album: ?string,
        +artist: ?string,
        +isrc: ?string,
        +duration_ms: ?number,
        +song_images: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +url: ?string,
              +width: ?number,
              +height: ?number,
            |}
          |}>
        |},
        +external_id?: ?string,
        +external_source?: ?string,
        +external_data?: ?string,
      |}
    |}>
  |},
  +mp_template: ?{|
    +can_edit: ?boolean,
    +public: ?boolean,
  |},
  +$refType: MpTemplatePlaylistContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v4, v5, v6]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v0, v4, v5, v6]
      }]
    }]
  };
  return {
    "kind": "Fragment",
    "name": "MpTemplatePlaylistContainer_node",
    "type": "MpTemplatePlaylist",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlist_songs"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    }],
    "selections": [v0, v1, v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "max_length",
      "args": null,
      "storageKey": null
    }, v3, v7, {
      "kind": "LinkedField",
      "alias": null,
      "name": "playlist_recommendations",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, v1, v2, v7, {
            "kind": "ScalarField",
            "alias": null,
            "name": "num_songs",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": "playlist_songs",
      "name": "__MpTemplateContainer_mp_template_playlist_songs_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplatePlaylistSongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MpTemplatePlaylistSongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylistSong",
          "plural": false,
          "selections": [v0, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v8, v0, v9, v10, v11, v12, v13]
          }, v8]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "song_search",
      "storageKey": null,
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 10,
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String!"
      }],
      "concreteType": "SongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "SongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [v0, v10, v11, v12, v9, {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration_ms",
            "args": null,
            "storageKey": null
          }, v13, {
            "kind": "InlineFragment",
            "type": "SpotifySong",
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "external_id",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "external_data",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "can_edit",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "public",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f2893f5a049a67416c848a12ff0650df';
module.exports = node;

/***/ }),
/* 3210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MpTemplatePlaylistContainer_viewer$ref: FragmentReference;
export type MpTemplatePlaylistContainer_viewer = {|
  +id: string,
  +playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +public_playlists: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +can_edit: ?boolean,
        +title: ?string,
        +description: ?string,
        +num_songs: ?number,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
      |}
    |}>
  |},
  +$refType: MpTemplatePlaylistContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "MpTemplatePlaylistContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlists"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "playlists",
      "name": "__MpTemplateContainer_playlists_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, v1, v2, v3, v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "public_playlists",
      "storageKey": "public_playlists(first:99999)",
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 99999,
        "type": "Int"
      }],
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Playlist",
          "plural": false,
          "selections": [v0, v1, v2, v3, v4, v5]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '875730063eb5a82132ceaa0f7f89a245';
module.exports = node;

/***/ }),
/* 3211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 3bb6f134fc8d76586952a0a218054433
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutationVariables = {|
  input: UpdateMpTemplatePlaylistInput
|};
export type MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutationResponse = {|
  +updateMpTemplatePlaylist: ?{|
    +mp_template_playlist: ?{|
      +id: string,
      +max_length: ?number,
    |}
  |}
|};
export type MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation = {|
  variables: MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutationVariables,
  response: MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation(
  $input: UpdateMpTemplatePlaylistInput!
) {
  updateMpTemplatePlaylist(input: $input) {
    mp_template_playlist {
      id
      max_length
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMpTemplatePlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMpTemplatePlaylistInput!"
    }],
    "concreteType": "UpdateMpTemplatePlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template_playlist",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplatePlaylist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "max_length",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation(\n  $input: UpdateMpTemplatePlaylistInput!\n) {\n  updateMpTemplatePlaylist(input: $input) {\n    mp_template_playlist {\n      id\n      max_length\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_MaxLength_UpdateMpTemplatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b6d0a5870948c8cc4c18adfae9c1a76f';
module.exports = node;

/***/ }),
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4b55a4ee9008962aad751dc7ddc58835
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MpTemplatePlaylist_UpdateMpTemplatePlaylistMutationVariables = {|
  input: UpdateMpTemplatePlaylistInput
|};
export type MpTemplatePlaylist_UpdateMpTemplatePlaylistMutationResponse = {|
  +updateMpTemplatePlaylist: ?{|
    +mp_template_playlist: ?{|
      +id: string,
      +title: ?string,
      +description: ?string,
      +position: ?number,
      +max_length: ?number,
    |}
  |}
|};
export type MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation = {|
  variables: MpTemplatePlaylist_UpdateMpTemplatePlaylistMutationVariables,
  response: MpTemplatePlaylist_UpdateMpTemplatePlaylistMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation(
  $input: UpdateMpTemplatePlaylistInput!
) {
  updateMpTemplatePlaylist(input: $input) {
    mp_template_playlist {
      id
      title
      description
      position
      max_length
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMpTemplatePlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMpTemplatePlaylistInput!"
    }],
    "concreteType": "UpdateMpTemplatePlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template_playlist",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplatePlaylist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "position",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "max_length",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation(\n  $input: UpdateMpTemplatePlaylistInput!\n) {\n  updateMpTemplatePlaylist(input: $input) {\n    mp_template_playlist {\n      id\n      title\n      description\n      position\n      max_length\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_UpdateMpTemplatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5e45f8a3b0f9047508ea0314c4ef10ff';
module.exports = node;

/***/ }),
/* 3213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e4bcb8743c3baeb2166e371a0fee07f7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type AddMpTemplatePlaylistRecommendationsInput = {
  clientMutationId?: ?string,
  mp_template_playlist_id: string,
  playlist_ids: $ReadOnlyArray<?string>,
};
export type MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutationVariables = {|
  input: AddMpTemplatePlaylistRecommendationsInput
|};
export type MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutationResponse = {|
  +addMpTemplatePlaylistRecommendations: ?{|
    +mp_template_playlist: ?{|
      +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
    |}
  |}
|};
export type MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation = {|
  variables: MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutationVariables,
  response: MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation(
  $input: AddMpTemplatePlaylistRecommendationsInput!
) {
  addMpTemplatePlaylistRecommendations(input: $input) {
    mp_template_playlist {
      ...MpTemplatePlaylistContainer_node
      id
    }
  }
}

fragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddMpTemplatePlaylistRecommendationsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "AddMpTemplatePlaylistRecommendationsInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v6, v7, v8, v2]
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v6, v7, v8]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation(\n  $input: AddMpTemplatePlaylistRecommendationsInput!\n) {\n  addMpTemplatePlaylistRecommendations(input: $input) {\n    mp_template_playlist {\n      ...MpTemplatePlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "addMpTemplatePlaylistRecommendations",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddMpTemplatePlaylistRecommendationsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MpTemplatePlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_addMpTemplatePlaylistRecommendationsMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "addMpTemplatePlaylistRecommendations",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddMpTemplatePlaylistRecommendationsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v9, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v2, v3, v4, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "storageKey": "mp_template_playlist_songs(first:99999)",
            "args": v10,
            "concreteType": "MpTemplatePlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSong",
                "plural": false,
                "selections": [v2, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v11, v2, v12, v13, v14, v15, v16]
                }, v11]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "args": v10,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v11, v2, v13, v14, v15, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v16, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "public",
              "args": null,
              "storageKey": null
            }, v2]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ef31058d6315fe7d0e81b071169bdaa1';
module.exports = node;

/***/ }),
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 53bbadb95709180275d843c5f1bc9636
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreateMpTemplatePlaylistSongInput = {
  clientMutationId?: ?string,
  mp_template_playlist_id: string,
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongMutationVariables = {|
  input: CreateMpTemplatePlaylistSongInput
|};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongMutationResponse = {|
  +createMpTemplatePlaylistSong: ?{|
    +new_mp_template_playlist_song_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +artist: ?string,
          +album: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |},
    +mp_template_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |},
      +num_songs: ?number,
    |},
  |}
|};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongMutation = {|
  variables: MpTemplatePlaylist_createMpTemplatePlaylistSongMutationVariables,
  response: MpTemplatePlaylist_createMpTemplatePlaylistSongMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_createMpTemplatePlaylistSongMutation(
  $input: CreateMpTemplatePlaylistSongInput!
) {
  createMpTemplatePlaylistSong(input: $input) {
    new_mp_template_playlist_song_edge {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          artist
          album
          song_images {
            edges {
              node {
                url
                width
                height
                id
              }
            }
          }
        }
      }
    }
    mp_template_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      num_songs
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMpTemplatePlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateMpTemplatePlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v2, v9, v10]
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_createMpTemplatePlaylistSongMutation(\n  $input: CreateMpTemplatePlaylistSongInput!\n) {\n  createMpTemplatePlaylistSong(input: $input) {\n    new_mp_template_playlist_song_edge {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          artist\n          album\n          song_images {\n            edges {\n              node {\n                url\n                width\n                height\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    mp_template_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      num_songs\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_mp_template_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v2, v4, v5, v6, v7, {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_images",
                "storageKey": null,
                "args": null,
                "concreteType": "SongImageConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SongImageEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongImage",
                    "plural": false,
                    "selections": [v8, v9, v10]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v11, v12]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_mp_template_playlist_song_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylistSongEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylistSong",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }, v2, v4, v5, v6, v7, {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_images",
                "storageKey": null,
                "args": null,
                "concreteType": "SongImageConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SongImageEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongImage",
                    "plural": false,
                    "selections": [v8, v9, v10, v2]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v11, v12, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3c0e78290f1f38fcaad58104153f35b5';
module.exports = node;

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4793106a9cece78e11c45e0aa9d8348c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreateMpTemplatePlaylistSongsInput = {
  clientMutationId?: ?string,
  mp_template_playlist_id: string,
  songs: $ReadOnlyArray<?SongInput>,
};
export type SongInput = {
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongsMutationVariables = {|
  input: CreateMpTemplatePlaylistSongsInput
|};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongsMutationResponse = {|
  +createMpTemplatePlaylistSongs: ?{|
    +mp_template_playlist: ?{|
      +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
    |}
  |}
|};
export type MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation = {|
  variables: MpTemplatePlaylist_createMpTemplatePlaylistSongsMutationVariables,
  response: MpTemplatePlaylist_createMpTemplatePlaylistSongsMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation(
  $input: CreateMpTemplatePlaylistSongsInput!
) {
  createMpTemplatePlaylistSongs(input: $input) {
    mp_template_playlist {
      ...MpTemplatePlaylistContainer_node
      id
    }
  }
}

fragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMpTemplatePlaylistSongsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateMpTemplatePlaylistSongsInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v6, v7, v8, v2]
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v6, v7, v8]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation(\n  $input: CreateMpTemplatePlaylistSongsInput!\n) {\n  createMpTemplatePlaylistSongs(input: $input) {\n    mp_template_playlist {\n      ...MpTemplatePlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MpTemplatePlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_createMpTemplatePlaylistSongsMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createMpTemplatePlaylistSongs",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateMpTemplatePlaylistSongsPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v9, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v2, v3, v4, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "storageKey": "mp_template_playlist_songs(first:99999)",
            "args": v10,
            "concreteType": "MpTemplatePlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSong",
                "plural": false,
                "selections": [v2, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v11, v2, v12, v13, v14, v15, v16]
                }, v11]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "args": v10,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v11, v2, v13, v14, v15, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v16, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "public",
              "args": null,
              "storageKey": null
            }, v2]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8593591e58580c356e5155b9015d1e44';
module.exports = node;

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1557d6cbce9aad0fb8ab2e8fd2a89072
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistMutationVariables = {|
  input: DeleteMpTemplatePlaylistInput
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistMutationResponse = {|
  +deleteMpTemplatePlaylist: ?{|
    +deletedMpTemplatePlaylistId: ?string
  |}
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistMutation = {|
  variables: MpTemplatePlaylist_deleteMpTemplatePlaylistMutationVariables,
  response: MpTemplatePlaylist_deleteMpTemplatePlaylistMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_deleteMpTemplatePlaylistMutation(
  $input: DeleteMpTemplatePlaylistInput!
) {
  deleteMpTemplatePlaylist(input: $input) {
    deletedMpTemplatePlaylistId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMpTemplatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMpTemplatePlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteMpTemplatePlaylistInput!"
    }],
    "concreteType": "DeleteMpTemplatePlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedMpTemplatePlaylistId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_deleteMpTemplatePlaylistMutation(\n  $input: DeleteMpTemplatePlaylistInput!\n) {\n  deleteMpTemplatePlaylist(input: $input) {\n    deletedMpTemplatePlaylistId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c555308f8c74d380efb401192311e765';
module.exports = node;

/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 433d35eee8f3048e8a7a44a2c8bb0800
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMpTemplatePlaylistSongInput = {
  clientMutationId?: ?string,
  id: string,
};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationVariables = {|
  input: DeleteMpTemplatePlaylistSongInput
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationResponse = {|
  +deleteMpTemplatePlaylistSong: ?{|
    +deletedMpTemplatePlaylistSongId: ?string,
    +mp_template_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |},
      +num_songs: ?number,
    |},
  |}
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation = {|
  variables: MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationVariables,
  response: MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation(
  $input: DeleteMpTemplatePlaylistSongInput!
) {
  deleteMpTemplatePlaylistSong(input: $input) {
    deletedMpTemplatePlaylistSongId
    mp_template_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      num_songs
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMpTemplatePlaylistSongInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteMpTemplatePlaylistSongInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedMpTemplatePlaylistSongId",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }]
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation(\n  $input: DeleteMpTemplatePlaylistSongInput!\n) {\n  deleteMpTemplatePlaylistSong(input: $input) {\n    deletedMpTemplatePlaylistSongId\n    mp_template_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      num_songs\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v4, v5]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v4, v5, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e41bb4b370229e518dc55259d7c21170';
module.exports = node;

/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 30185986ef6ce86c24a8e3a4309b234f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
export type RemoveMpTemplatePlaylistRecommendationInput = {
  clientMutationId?: ?string,
  mp_template_playlist_id: string,
  playlist_id: string,
};
export type MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutationVariables = {|
  input: RemoveMpTemplatePlaylistRecommendationInput
|};
export type MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutationResponse = {|
  +removeMpTemplatePlaylistRecommendation: ?{|
    +mp_template_playlist: ?{|
      +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
    |}
  |}
|};
export type MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation = {|
  variables: MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutationVariables,
  response: MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutationResponse,
|};
*/

/*
mutation MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation(
  $input: RemoveMpTemplatePlaylistRecommendationInput!
) {
  removeMpTemplatePlaylistRecommendation(input: $input) {
    mp_template_playlist {
      ...MpTemplatePlaylistContainer_node
      id
    }
  }
}

fragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemoveMpTemplatePlaylistRecommendationInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "RemoveMpTemplatePlaylistRecommendationInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v6, v7, v8, v2]
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v2, v6, v7, v8]
      }]
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation",
    "id": null,
    "text": "mutation MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation(\n  $input: RemoveMpTemplatePlaylistRecommendationInput!\n) {\n  removeMpTemplatePlaylistRecommendation(input: $input) {\n    mp_template_playlist {\n      ...MpTemplatePlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "removeMpTemplatePlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemoveMpTemplatePlaylistRecommendationPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MpTemplatePlaylistContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MpTemplatePlaylist_removeMpTemplatePlaylistRecommendationMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "removeMpTemplatePlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemoveMpTemplatePlaylistRecommendationPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_template_playlist",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplatePlaylist",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v5, v9, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v2, v3, v4, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "storageKey": "mp_template_playlist_songs(first:99999)",
            "args": v10,
            "concreteType": "MpTemplatePlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSong",
                "plural": false,
                "selections": [v2, v5, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v11, v2, v12, v13, v14, v15, v16]
                }, v11]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "args": v10,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v11, v2, v13, v14, v15, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v16, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "can_edit",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "public",
              "args": null,
              "storageKey": null
            }, v2]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a081bdf5fea4a9eacf0c0387d0c1d88f';
module.exports = node;

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9b4d3e45f52aeeb6ec24a43fc077f25b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Notes_UpdateMpTemplateMutationVariables = {|
  input: UpdateMpTemplateInput
|};
export type Notes_UpdateMpTemplateMutationResponse = {|
  +updateMpTemplate: ?{|
    +mp_template: ?{|
      +id: string,
      +notes: ?string,
    |}
  |}
|};
export type Notes_UpdateMpTemplateMutation = {|
  variables: Notes_UpdateMpTemplateMutationVariables,
  response: Notes_UpdateMpTemplateMutationResponse,
|};
*/

/*
mutation Notes_UpdateMpTemplateMutation(
  $input: UpdateMpTemplateInput!
) {
  updateMpTemplate(input: $input) {
    mp_template {
      id
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMpTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMpTemplateInput!"
    }],
    "concreteType": "UpdateMpTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Notes_UpdateMpTemplateMutation",
    "id": null,
    "text": "mutation Notes_UpdateMpTemplateMutation(\n  $input: UpdateMpTemplateInput!\n) {\n  updateMpTemplate(input: $input) {\n    mp_template {\n      id\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Notes_UpdateMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Notes_UpdateMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fdf0b497958d0bccdcdf8f7e8fe8c5a4';
module.exports = node;

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0e0fe1b79fffde9fc25df5badbda4ace
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMpTemplateInput = {
  clientMutationId?: ?string,
  id: string,
  brand_id?: ?string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type Title_UpdateMpTemplateMutationVariables = {|
  input: UpdateMpTemplateInput
|};
export type Title_UpdateMpTemplateMutationResponse = {|
  +updateMpTemplate: ?{|
    +mp_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type Title_UpdateMpTemplateMutation = {|
  variables: Title_UpdateMpTemplateMutationVariables,
  response: Title_UpdateMpTemplateMutationResponse,
|};
*/

/*
mutation Title_UpdateMpTemplateMutation(
  $input: UpdateMpTemplateInput!
) {
  updateMpTemplate(input: $input) {
    mp_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMpTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMpTemplateInput!"
    }],
    "concreteType": "UpdateMpTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Title_UpdateMpTemplateMutation",
    "id": null,
    "text": "mutation Title_UpdateMpTemplateMutation(\n  $input: UpdateMpTemplateInput!\n) {\n  updateMpTemplate(input: $input) {\n    mp_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Title_UpdateMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Title_UpdateMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'db9e148b51f295a910896da044f5b5c7';
module.exports = node;

/***/ }),
/* 3221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Event_Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Event_Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Event_Event_scss__);






var TemplateGroup = function TemplateGroup(_ref) {
  var color = _ref.color,
      documentPath = _ref.documentPath,
      documentType = _ref.documentType,
      templates = _ref.templates;
  return templates.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
      { style: { margin: '1em 0' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          documentType,
          ' Templates'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
      { style: { marginBottom: '2em' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */].Group,
            { itemsPerRow: 4, doubling: true },
            templates.map(function (template) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_found__["Link"],
                {
                  to: '' + documentPath + template.node.id + '/edit',
                  Component: __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */],
                  className: __WEBPACK_IMPORTED_MODULE_4__Event_Event_scss___default.a.workspaceCard,
                  color: color,
                  key: template.node.id
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */].Content,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */].Header,
                    null,
                    template.node.title
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* Card */].Meta,
                    null,
                    documentType
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                )
              );
            })
          )
        )
      )
    )
  );
};

TemplateGroup.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  documentPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  documentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  templates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TemplateGroup);

/***/ }),
/* 3222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Event_Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TemplateGroup__ = __webpack_require__(3221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TemplateList = (_temp = _class = function (_React$Component) {
  _inherits(TemplateList, _React$Component);

  function TemplateList(props) {
    _classCallCheck(this, TemplateList);

    var _this = _possibleConstructorReturn(this, (TemplateList.__proto__ || Object.getPrototypeOf(TemplateList)).call(this, props));

    _this.state = {
      activeTab: 'my'
    };
    _this.createContractTemplate = _this.createContractTemplate.bind(_this);
    _this.createFormTemplate = _this.createFormTemplate.bind(_this);
    _this.createMpTemplate = _this.createMpTemplate.bind(_this);
    return _this;
  }

  _createClass(TemplateList, [{
    key: 'createFormTemplate',
    value: function createFormTemplate() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create form template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created form template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.router.push('/templates/f/' + response.createFormTemplate.form_template.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_9__Modules__["c" /* Analytics */].trackEvent('created-form-template');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3226);
      });

      var environment = this.props.relay.environment;

      // TODO: Use RANGE_ADD config

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            title: 'Form Template',
            brand_id: this.props.viewer.primary_brand.id,
            schema: JSON.stringify({
              type: 'object',
              properties: {}
            }),
            ui_schema: JSON.stringify({
              'ui:order': []
            }),
            user_id: this.props.viewer.id
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createContractTemplate',
    value: function createContractTemplate() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create contract template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created contract template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.props.router.push('/templates/c/' + response.createCTemplate.c_template.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_9__Modules__["c" /* Analytics */].trackEvent('created-contract-template');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3225);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            title: 'Contract Template'
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createMpTemplate',
    value: function createMpTemplate() {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create music list template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created music list template',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].SUCCESS
        });
        _this4.props.router.push('/templates/m/' + response.createMpTemplate.mp_template.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_9__Modules__["c" /* Analytics */].trackEvent('created-mp-template');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3227);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            brand_id: this.props.viewer.primary_brand.id,
            user_id: this.props.viewer.id,
            title: 'Music List Template'
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var activeTab = this.state.activeTab;
      var _props = this.props,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      var cTemplates = [];
      var formTemplates = [];
      var mpTemplates = [];
      if (activeTab === 'my') {
        cTemplates = viewer.c_templates.edges;
        formTemplates = viewer.form_templates.edges;
        mpTemplates = viewer.mp_templates.edges;
      } else {
        mpTemplates = viewer.public_mp_templates.edges;
      }
      var hasPublicTemplates = viewer.public_mp_templates.edges.length > 0;
      var hasTemplates = cTemplates.length > 0 || formTemplates.length > 0 || mpTemplates.length > 0;

      var NewTemplate = function NewTemplate(_ref) {
        var text = _ref.text,
            primary = _ref.primary;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */],
          {
            text: text,
            floating: true,
            labeled: true,
            button: true,
            className: 'icon ' + (primary ? 'primary' : 'basic')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */].Menu,
            { className: __WEBPACK_IMPORTED_MODULE_6__Event_Event_scss___default.a.menuRight },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */].Item, {
              onClick: _this5.createContractTemplate,
              text: 'Contract Template'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */].Item, {
              onClick: _this5.createFormTemplate,
              text: 'Form Template'
            }),
            viewer.features.music_lists && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */].Item, {
              onClick: _this5.createMpTemplate,
              text: 'Music List Template'
            })
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__App_MobileHeader__["a" /* default */],
          {
            viewer: viewer,
            router: router
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                className: sidebarOpen ? 'active ' : '',
                onClick: toggleSidebar
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
              { as: 'a', onClick: router.push.bind(null, '/search') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'search' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */],
          { container: true, stackable: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
            { rows: 'equal', style: { marginTop: '2em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */],
                { secondary: true, pointing: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                  name: 'My Templates',
                  active: activeTab === 'my',
                  onClick: function onClick() {
                    return _this5.setState({ activeTab: 'my' });
                  }
                }),
                hasPublicTemplates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                  name: 'Discover',
                  active: activeTab === 'discover',
                  onClick: function onClick() {
                    return _this5.setState({ activeTab: 'discover' });
                  }
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              hasTemplates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { align: 'right' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewTemplate, { text: 'New', primary: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TemplateGroup__["a" /* default */], {
                templates: cTemplates,
                documentType: 'Contract',
                color: 'green',
                documentPath: '/templates/c/'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TemplateGroup__["a" /* default */], {
                templates: formTemplates,
                documentType: 'Form',
                color: 'yellow',
                documentPath: '/templates/f/'
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TemplateGroup__["a" /* default */], {
                templates: mpTemplates,
                documentType: 'Music List',
                color: 'purple',
                documentPath: '/templates/m/'
              }),
              !hasTemplates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { style: { textAlign: 'center', margin: '2em' } },
                  'You have no saved templates'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  {
                    style: {
                      textAlign: 'center',
                      maxWidth: '400px',
                      margin: '0 auto'
                    }
                  },
                  hasPublicTemplates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */], {
                      icon: 'search',
                      labelPosition: 'left',
                      content: 'Browse Cloverbook Templates',
                      primary: true,
                      onClick: function onClick() {
                        return _this5.setState({ activeTab: 'discover' });
                      }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["v" /* Divider */],
                      { horizontal: true },
                      'Or'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewTemplate, { text: 'Create New' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TemplateList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__App_Authenticate__["a" /* default */])(TemplateList)));

/***/ }),
/* 3223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TemplateList__ = __webpack_require__(3222);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__TemplateList__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3224);
  }
}));

/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TemplateListContainer_viewer$ref: FragmentReference;
export type TemplateListContainer_viewer = {|
  +id: string,
  +c_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +form_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +mp_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +can_edit: ?boolean,
        +public: ?boolean,
      |}
    |}>
  |},
  +public_mp_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +can_edit: ?boolean,
        +public: ?boolean,
      |}
    |}>
  |},
  +primary_brand: ?{|
    +id: string
  |},
  +features: ?{|
    +music_lists: ?boolean
  |},
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: TemplateListContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = [v0, v1],
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "MpTemplateEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [v0, v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "can_edit",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "public",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Fragment",
    "name": "TemplateListContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }, v0, {
      "kind": "LinkedField",
      "alias": null,
      "name": "c_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": v2
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "form_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplateConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "FormTemplateEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplate",
          "plural": false,
          "selections": v2
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplateConnection",
      "plural": false,
      "selections": v3
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "public_mp_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplateConnection",
      "plural": false,
      "selections": v3
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [v0]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "features",
      "storageKey": null,
      "args": null,
      "concreteType": "Features",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "music_lists",
        "args": null,
        "storageKey": null
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '0ef34537d8b130f92190e46a7e7e6b05';
module.exports = node;

/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 22ec8e1cf111f762b5b0d1a82725939d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateCTemplateInput = {
  clientMutationId?: ?string,
  title: string,
};
export type TemplateList_CreateCTemplateMutationVariables = {|
  input: CreateCTemplateInput
|};
export type TemplateList_CreateCTemplateMutationResponse = {|
  +createCTemplate: ?{|
    +c_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type TemplateList_CreateCTemplateMutation = {|
  variables: TemplateList_CreateCTemplateMutationVariables,
  response: TemplateList_CreateCTemplateMutationResponse,
|};
*/

/*
mutation TemplateList_CreateCTemplateMutation(
  $input: CreateCTemplateInput!
) {
  createCTemplate(input: $input) {
    c_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createCTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateCTemplateInput!"
    }],
    "concreteType": "CreateCTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "c_template",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "TemplateList_CreateCTemplateMutation",
    "id": null,
    "text": "mutation TemplateList_CreateCTemplateMutation(\n  $input: CreateCTemplateInput!\n) {\n  createCTemplate(input: $input) {\n    c_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateList_CreateCTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateList_CreateCTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4eadc3e15d17605fd46cf61117e079f7';
module.exports = node;

/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e7949348bc902dbfd252bd70e94464b1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateFormTemplateInput = {
  clientMutationId?: ?string,
  user_id: string,
  brand_id: string,
  title: string,
  description?: ?string,
  data?: ?string,
  schema: string,
  ui_schema: string,
};
export type TemplateList_CreateFormTemplateMutationVariables = {|
  input: CreateFormTemplateInput
|};
export type TemplateList_CreateFormTemplateMutationResponse = {|
  +createFormTemplate: ?{|
    +form_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type TemplateList_CreateFormTemplateMutation = {|
  variables: TemplateList_CreateFormTemplateMutationVariables,
  response: TemplateList_CreateFormTemplateMutationResponse,
|};
*/

/*
mutation TemplateList_CreateFormTemplateMutation(
  $input: CreateFormTemplateInput!
) {
  createFormTemplate(input: $input) {
    form_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateFormTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createFormTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateFormTemplateInput!"
    }],
    "concreteType": "CreateFormTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form_template",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "TemplateList_CreateFormTemplateMutation",
    "id": null,
    "text": "mutation TemplateList_CreateFormTemplateMutation(\n  $input: CreateFormTemplateInput!\n) {\n  createFormTemplate(input: $input) {\n    form_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateList_CreateFormTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateList_CreateFormTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7eaa3386c73bd0ca1be73abe91c0cae5';
module.exports = node;

/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9a15f7eff294427ef766c481ae28cc9c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateMpTemplateInput = {
  clientMutationId?: ?string,
  user_id: string,
  brand_id: string,
  title: string,
  description?: ?string,
};
export type TemplateList_CreateMpTemplateMutationVariables = {|
  input: CreateMpTemplateInput
|};
export type TemplateList_CreateMpTemplateMutationResponse = {|
  +createMpTemplate: ?{|
    +mp_template: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type TemplateList_CreateMpTemplateMutation = {|
  variables: TemplateList_CreateMpTemplateMutationVariables,
  response: TemplateList_CreateMpTemplateMutationResponse,
|};
*/

/*
mutation TemplateList_CreateMpTemplateMutation(
  $input: CreateMpTemplateInput!
) {
  createMpTemplate(input: $input) {
    mp_template {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMpTemplateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createMpTemplate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateMpTemplateInput!"
    }],
    "concreteType": "CreateMpTemplatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_template",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "TemplateList_CreateMpTemplateMutation",
    "id": null,
    "text": "mutation TemplateList_CreateMpTemplateMutation(\n  $input: CreateMpTemplateInput!\n) {\n  createMpTemplate(input: $input) {\n    mp_template {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateList_CreateMpTemplateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateList_CreateMpTemplateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '682633008f0d87e834b239897e6cc4bd';
module.exports = node;

/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 78b9c43a197d27f923d0267e13fed9c2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  terms?: ?string,
};
export type RenameDocument_UpdateContractMutationVariables = {|
  input: UpdateContractInput
|};
export type RenameDocument_UpdateContractMutationResponse = {|
  +updateContract: ?{|
    +contract: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateContractMutation = {|
  variables: RenameDocument_UpdateContractMutationVariables,
  response: RenameDocument_UpdateContractMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateContractMutation(
  $input: UpdateContractInput!
) {
  updateContract(input: $input) {
    contract {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContract",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateContractInput!"
    }],
    "concreteType": "UpdateContractPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateContractMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateContractMutation(\n  $input: UpdateContractInput!\n) {\n  updateContract(input: $input) {\n    contract {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateContractMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '29a1fb8de1a65d2984e66f6aa66fffc3';
module.exports = node;

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d06beb340e14a3fc3e8b92971c3d90b7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type RenameDocument_UpdateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type RenameDocument_UpdateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateEstimateMutation = {|
  variables: RenameDocument_UpdateEstimateMutationVariables,
  response: RenameDocument_UpdateEstimateMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEstimateInput!"
    }],
    "concreteType": "UpdateEstimatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateEstimateMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b897c9374c8029e18b26695760d471ca';
module.exports = node;

/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9bc70b624c69c5339d08398a3cc4f231
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFormInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
};
export type RenameDocument_UpdateFormMutationVariables = {|
  input: UpdateFormInput
|};
export type RenameDocument_UpdateFormMutationResponse = {|
  +updateForm: ?{|
    +form: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateFormMutation = {|
  variables: RenameDocument_UpdateFormMutationVariables,
  response: RenameDocument_UpdateFormMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateFormMutation(
  $input: UpdateFormInput!
) {
  updateForm(input: $input) {
    form {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateForm",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateFormInput!"
    }],
    "concreteType": "UpdateFormPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateFormMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateFormMutation(\n  $input: UpdateFormInput!\n) {\n  updateForm(input: $input) {\n    form {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateFormMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '51fe39acc3bd5defe4b7241bde734b78';
module.exports = node;

/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 85c95abd7e67ef1e63de3a90d2125655
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
};
export type RenameDocument_UpdateInvoiceMutationVariables = {|
  input: UpdateInvoiceInput
|};
export type RenameDocument_UpdateInvoiceMutationResponse = {|
  +updateInvoice: ?{|
    +invoice: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateInvoiceMutation = {|
  variables: RenameDocument_UpdateInvoiceMutationVariables,
  response: RenameDocument_UpdateInvoiceMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateInvoiceMutation(
  $input: UpdateInvoiceInput!
) {
  updateInvoice(input: $input) {
    invoice {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoice",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateInvoiceInput!"
    }],
    "concreteType": "UpdateInvoicePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateInvoiceMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoice {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '26bdc394a93f411cdba9afa667960568';
module.exports = node;

/***/ }),
/* 3232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 38401f6031c66a69f23bd34d15feafa3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  notes?: ?string,
};
export type RenameDocument_UpdateMusicPlannerMutationVariables = {|
  input: UpdateMusicPlannerInput
|};
export type RenameDocument_UpdateMusicPlannerMutationResponse = {|
  +updateMusicPlanner: ?{|
    +music_planner: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateMusicPlannerMutation = {|
  variables: RenameDocument_UpdateMusicPlannerMutationVariables,
  response: RenameDocument_UpdateMusicPlannerMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateMusicPlannerMutation(
  $input: UpdateMusicPlannerInput!
) {
  updateMusicPlanner(input: $input) {
    music_planner {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateMusicPlanner",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateMusicPlannerInput!"
    }],
    "concreteType": "UpdateMusicPlannerPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateMusicPlannerMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateMusicPlannerMutation(\n  $input: UpdateMusicPlannerInput!\n) {\n  updateMusicPlanner(input: $input) {\n    music_planner {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f8d08bdeb553abc3ac48e7f5fabdc17d';
module.exports = node;

/***/ }),
/* 3233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash db79255f082b80a83e433d3e5dbeb7bb
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWuploadInput = {
  clientMutationId?: ?string,
  id: string,
  name?: ?string,
};
export type RenameDocument_UpdateWuploadMutationVariables = {|
  input: UpdateWuploadInput
|};
export type RenameDocument_UpdateWuploadMutationResponse = {|
  +updateWupload: ?{|
    +wupload: ?{|
      +id: string,
      +name: ?string,
    |}
  |}
|};
export type RenameDocument_UpdateWuploadMutation = {|
  variables: RenameDocument_UpdateWuploadMutationVariables,
  response: RenameDocument_UpdateWuploadMutationResponse,
|};
*/

/*
mutation RenameDocument_UpdateWuploadMutation(
  $input: UpdateWuploadInput!
) {
  updateWupload(input: $input) {
    wupload {
      id
      name
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWuploadInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateWupload",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateWuploadInput!"
    }],
    "concreteType": "UpdateWuploadPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "wupload",
      "storageKey": null,
      "args": null,
      "concreteType": "Wupload",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RenameDocument_UpdateWuploadMutation",
    "id": null,
    "text": "mutation RenameDocument_UpdateWuploadMutation(\n  $input: UpdateWuploadInput!\n) {\n  updateWupload(input: $input) {\n    wupload {\n      id\n      name\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RenameDocument_UpdateWuploadMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "RenameDocument_UpdateWuploadMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1ddf7943e6b658060c2b8a46f3748693';
module.exports = node;

/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardField__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CardCheckbox = function (_React$Component) {
  _inherits(CardCheckbox, _React$Component);

  function CardCheckbox(props) {
    _classCallCheck(this, CardCheckbox);

    var _this = _possibleConstructorReturn(this, (CardCheckbox.__proto__ || Object.getPrototypeOf(CardCheckbox)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(CardCheckbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(nextProps);
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e.target.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var rest = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omit(this.props, 'onChange', 'checked', 'type');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__CardField__["a" /* default */],
        _extends({ onChange: function onChange() {} }, rest),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'ui fitted checkbox ' + __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.checkboxOffset },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
            type: 'checkbox',
            tabIndex: 0,
            onChange: this.onChange,
            checked: this.props.checked
          }, rest)),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label', null)
        )
      );
    }
  }]);

  return CardCheckbox;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

CardCheckbox.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  checked: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CardCheckbox);

/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardField__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__placeholder_scss__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__placeholder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__placeholder_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DateTime = function (_React$Component) {
  _inherits(DateTime, _React$Component);

  function DateTime(props) {
    _classCallCheck(this, DateTime);

    var _this = _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).call(this, props));

    _this.state = {
      date: _this.formattedInput(),
      dateOnly: _this.props.dateOnly
    };
    _this.getClass = _this.getClass.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.formattedInput = _this.formattedInput.bind(_this);
    return _this;
  }

  _createClass(DateTime, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.dateOnly !== this.props.dateOnly || nextProps.timeZone !== this.props.timeZone) {
        // We must set the new value before changing the field type
        // See https://github.com/sankalpk/cloverbook-rails/issues/57
        this.setState({ date: this.formattedInput(nextProps) }, function () {
          _this2.setState({ dateOnly: nextProps.dateOnly });
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
      this.setState({ date: e.target.value });
    }
  }, {
    key: 'getClass',
    value: function getClass() {
      return this.props.value === '' ? '' : 'hasValue';
    }
  }, {
    key: 'formattedInput',
    value: function formattedInput() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var timeZone = props.timeZone || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.guess();
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(props.value).isValid()) {
        if (props.dateOnly) {
          return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(props.value).format('YYYY-MM-DD');
        }
        return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(props.value, timeZone).format('YYYY-MM-DDTHH:mm');
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var inputType = this.state.dateOnly ? 'date' : 'datetime-local';

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__CardField__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.datetimeOffset },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
            type: inputType,
            className: this.getClass(),
            onChange: this.onChange,
            value: this.state.date,
            placeholder: this.props.placeholder,
            name: this.props.name,
            style: {
              border: 'none',
              height: '1em',
              background: 'transparent',
              width: '100%',
              padding: '0.5em 0'
            }
          })
        )
      );
    }
  }]);

  return DateTime;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

DateTime.propTypes = {
  dateOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DateTime);

/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardFieldNoValidate__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DatePicker__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_formsy_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */








var DateTimePicker = (_temp = _class = function (_React$Component) {
  _inherits(DateTimePicker, _React$Component);

  function DateTimePicker(props) {
    _classCallCheck(this, DateTimePicker);

    var _this = _possibleConstructorReturn(this, (DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call(this, props));

    var timeZone = _this.props.timeZone || __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess();
    _this.state = {
      datepickerOpen: false,
      time: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this.props.getValue()).isValid() ? __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this.props.getValue()).tz(timeZone).format('LT') : '',
      timeView: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this.props.getValue()).isValid() ? __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this.props.getValue()).tz(timeZone).format('LT') : '',
      date: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this.props.getValue()).isValid() ? _this.getDateString(_this.props.getValue(), _this.props.dateOnly, timeZone) : '',
      month: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(timeZone).toDate()
    };
    _this.onDayClick = _this.onDayClick.bind(_this);
    _this.onDateInputChange = _this.onDateInputChange.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.showCurrentDate = _this.showCurrentDate.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.updateSelectedDay = _this.updateSelectedDay.bind(_this);
    _this.updateDateTime = _this.updateDateTime.bind(_this);
    _this.getIso8601Date = _this.getIso8601Date.bind(_this);
    _this.closeDatePicker = _this.closeDatePicker.bind(_this);
    _this.onTimeInputChange = _this.onTimeInputChange.bind(_this);
    _this.onTimeSelectChange = _this.onTimeSelectChange.bind(_this);
    _this.onTimeInputBlur = _this.onTimeInputBlur.bind(_this);
    _this.onDateTimePickerBlur = _this.onDateTimePickerBlur.bind(_this);
    return _this;
  }

  _createClass(DateTimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextValue = nextProps.value;
      var timeZone = nextProps.timeZone || __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess();
      if (nextProps.dateOnly !== this.props.dateOnly && __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(nextValue, __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.ISO_8601).isValid()) {
        // Update date in local state based on changes in mobile datepicker component
        this.setState({
          date: this.getDateString(nextValue, nextProps.dateOnly, timeZone),
          time: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(nextValue).tz(timeZone).format('LT')
        });
      }
      if ((nextValue !== this.props.value || !nextProps.dateOnly && timeZone !== this.props.timeZone) && __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(nextValue, __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.ISO_8601).isValid()) {
        this.setState({
          date: this.getDateString(nextValue, nextProps.dateOnly, timeZone),
          time: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(nextValue, timeZone).format('LT'),
          timeView: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(nextValue, timeZone).format('LT')
        });
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ datepickerOpen: true });
      this.showCurrentDate();
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var _this2 = this;

      var value = e.target.value;

      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess();
      var formattedDate = this.parseDate(value);

      // Change the current month only if the value entered by the user
      // is a valid date, according to the `L` format
      if (__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(formattedDate, 'L', true).isValid()) {
        this.setState({
          month: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(formattedDate, 'L', timeZone).toDate(),
          date: formattedDate
        }, function () {
          _this2.showCurrentDate();
          _this2.changeValue({
            target: {
              value: _this2.getIso8601Date({ dateOnly: _this2.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ date: '' }, this.showCurrentDate);
      }
      if (e.relatedTarget && !e.relatedTarget.className.match('DayPicker')) {
        this.closeDatePicker();
      }
    }
  }, {
    key: 'onDateTimePickerBlur',
    value: function onDateTimePickerBlur(e) {
      // Determine if blurring off DateTimePicker completely
      // or moving focusing onto DayPicker, which we still
      // consider part of this component
      if (e.relatedTarget && e.relatedTarget.className.match('DayPicker-Day')) {
        this.handleBlurringDatePicker(false);
      } else {
        this.handleBlurringDatePicker(true);
      }
    }
  }, {
    key: 'onTimeInputChange',
    value: function onTimeInputChange(e) {
      var value = e.currentTarget.value;

      this.setState({ timeView: value });
    }
  }, {
    key: 'onTimeInputBlur',
    value: function onTimeInputBlur(e) {
      var _this3 = this;

      var value = e.target.value;

      var formattedTime = this.parseTime(value);

      if (formattedTime) {
        this.setState({
          time: formattedTime,
          timeView: formattedTime
        }, function () {
          _this3.handleBlurringDatePicker(true);
          _this3.changeValue({
            target: {
              value: _this3.getIso8601Date({ dateOnly: _this3.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ time: '', timeView: '' });
      }
    }
  }, {
    key: 'onTimeSelectChange',
    value: function onTimeSelectChange(e, change) {
      var _this4 = this;

      e.stopPropagation();
      if (e.target.value === undefined) {
        this.setState({
          time: change.value,
          timeView: change.value
        }, function () {
          _this4.changeValue({
            target: {
              value: _this4.getIso8601Date({ dateOnly: _this4.props.dateOnly })
            }
          });
        });
      }
    }
  }, {
    key: 'onDateInputChange',
    value: function onDateInputChange(e) {
      var _this5 = this;

      var value = e.target.value;

      e.stopPropagation();

      // Change the current month only if the value entered by the user
      // is a valid date, according to the `L` format
      if (__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(value, 'L', true).isValid()) {
        this.setState({
          month: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(value, 'L').toDate(),
          date: value
        }, function () {
          _this5.showCurrentDate();
          _this5.changeValue({
            target: {
              value: _this5.getIso8601Date({ dateOnly: _this5.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ date: value }, this.showCurrentDate);
      }
    }
  }, {
    key: 'onDayClick',
    value: function onDayClick(e, day) {
      this.setState({
        date: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(day).format('L'),
        month: day
      });
    }
  }, {
    key: 'getDateString',
    value: function getDateString(date, dateOnly, timeZone) {
      if (dateOnly) {
        return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).format('L');
      }
      return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(date, timeZone).format('L');
    }
  }, {
    key: 'getIso8601Date',
    value: function getIso8601Date(options) {
      var dateOnly = options.dateOnly;

      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess();
      if (dateOnly) {
        if (__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(this.state.date, 'L').isValid()) {
          return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(this.state.date, 'L').format('YYYY-MM-DD');
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(this.state.date, 'L LT').isValid()) {
          return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(this.state.date + ' ' + this.state.time, 'L LT', timeZone).toISOString();
        }
      }
      return '';
    }
  }, {
    key: 'handleBlurringDatePicker',
    value: function handleBlurringDatePicker(blurring) {
      if (this.props.handleBlurringDatePicker) {
        if (!this.props.dateOnly && this.state.date !== '' && this.state.time !== '' || this.props.dateOnly && this.state.date !== '') {
          this.props.handleBlurringDatePicker(blurring);
        } else if (blurring) {
          this.props.handleBlurringDatePicker(true);
        } else {
          this.props.handleBlurringDatePicker(false);
        }
      }
    }
  }, {
    key: 'changeValue',
    value: function changeValue(e) {
      if (this.props.dateOnly) {
        if (this.state.date) {
          this.props.setValue(e.target.value);
          this.props.onChange(e);
        }
      } else {
        if (this.state.date && this.state.time) {
          this.props.setValue(e.target.value);
          this.props.onChange(e);
        }
      }
    }
  }, {
    key: 'closeDatePicker',
    value: function closeDatePicker() {
      this.setState({ datepickerOpen: false });
      this.handleBlurringDatePicker(true);
    }
  }, {
    key: 'nearestHalfHour',
    value: function nearestHalfHour(time) {
      var minutes = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(time).minutes();
      var momentTime = null;
      if (minutes >= 0 && minutes < 15) {
        momentTime = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(time).minutes(0);
      } else if (minutes >= 15 && minutes < 45) {
        momentTime = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(time).minutes(30);
      } else {
        momentTime = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(time).minutes(0).add(1, 'hour');
      }
      return momentTime.format('LT');
    }
  }, {
    key: 'parseTime',
    value: function parseTime(timeString) {
      // do parsing here and return appropriate value
      var timeParts = timeString.match(/([0-9]{1,2}):?([0-9]{1,2})?\s?([AaPp][Mm]?)?/);
      if (!timeParts) {
        return null;
      }
      var hours = parseInt(timeParts[1], 10);
      var minutes = parseInt(timeParts[2] || '0', 10);
      var hoursString = '';
      var minutesString = timeParts[2] || '00';
      var meridian = '';
      if (hours > 0 && hours <= 12) {
        hoursString = timeParts[1];
      } else {
        // Out of range
        return null;
      }
      if (minutes >= 0 && minutes <= 60) {
        while (minutesString.length < 2) {
          minutesString = '0' + minutesString;
        }
      } else {
        // Out of range
        return null;
      }
      if (timeParts[3]) {
        meridian = timeParts[3].length === 1 ? timeParts[3].toUpperCase() + 'M' : timeParts[3].toUpperCase();
      } else {
        meridian = hours > 0 && hours < 7 ? 'AM' : 'PM';
      }

      return hoursString + ':' + minutesString + ' ' + meridian;
    }
  }, {
    key: 'parseDate',
    value: function parseDate(date) {
      var dateParts = date.split('/');
      if (dateParts.length === 3) {
        if (dateParts[0].length === 1) {
          dateParts[0] = '0' + dateParts[0];
        }
        if (dateParts[1].length === 1) {
          dateParts[1] = '0' + dateParts[1];
        }
        if (dateParts[2].length === 2) {
          dateParts[2] = parseInt(new Date().getFullYear() / 100, 10) + dateParts[2];
        }
        return dateParts.join('/');
      }
      return date;
    }
  }, {
    key: 'showCurrentDate',
    value: function showCurrentDate() {
      // TODO: fix refs to call showMonth on child component
      this.setState({ month: this.state.date });
      // this.refs.daypicker.showMonth(this.state.month);
    }
  }, {
    key: 'updateSelectedDay',
    value: function updateSelectedDay(date) {
      var _this6 = this;

      this.setState({ date: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).format('L') }, function () {
        _this6.changeValue({
          target: {
            value: _this6.getIso8601Date({ dateOnly: _this6.props.dateOnly })
          }
        });
      });
    }
  }, {
    key: 'updateDateTime',
    value: function updateDateTime() {
      this.changeValue({
        target: { value: this.getIso8601Date({ dateOnly: this.props.dateOnly }) }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var times = [{ text: '12:00 AM', value: '12:00 AM' }, { text: '12:30 AM', value: '12:30 AM' }, { text: '1:00 AM', value: '1:00 AM' }, { text: '1:30 AM', value: '1:30 AM' }, { text: '2:00 AM', value: '2:00 AM' }, { text: '2:30 AM', value: '2:30 AM' }, { text: '3:00 AM', value: '3:00 AM' }, { text: '3:30 AM', value: '3:30 AM' }, { text: '4:00 AM', value: '4:00 AM' }, { text: '4:30 AM', value: '4:30 AM' }, { text: '5:00 AM', value: '5:00 AM' }, { text: '5:30 AM', value: '5:30 AM' }, { text: '6:00 AM', value: '6:00 AM' }, { text: '6:30 AM', value: '6:30 AM' }, { text: '7:00 AM', value: '7:00 AM' }, { text: '7:30 AM', value: '7:30 AM' }, { text: '8:00 AM', value: '8:00 AM' }, { text: '8:30 AM', value: '8:30 AM' }, { text: '9:00 AM', value: '9:00 AM' }, { text: '9:30 AM', value: '9:30 AM' }, { text: '10:00 AM', value: '10:00 AM' }, { text: '10:30 AM', value: '10:30 AM' }, { text: '11:00 AM', value: '11:00 AM' }, { text: '11:30 AM', value: '11:30 AM' }, { text: '12:00 PM', value: '12:00 PM' }, { text: '12:30 PM', value: '12:30 PM' }, { text: '1:00 PM', value: '1:00 PM' }, { text: '1:30 PM', value: '1:30 PM' }, { text: '2:00 PM', value: '2:00 PM' }, { text: '2:30 PM', value: '2:30 PM' }, { text: '3:00 PM', value: '3:00 PM' }, { text: '3:30 PM', value: '3:30 PM' }, { text: '4:00 PM', value: '4:00 PM' }, { text: '4:30 PM', value: '4:30 PM' }, { text: '5:00 PM', value: '5:00 PM' }, { text: '5:30 PM', value: '5:30 PM' }, { text: '6:00 PM', value: '6:00 PM' }, { text: '6:30 PM', value: '6:30 PM' }, { text: '7:00 PM', value: '7:00 PM' }, { text: '7:30 PM', value: '7:30 PM' }, { text: '8:00 PM', value: '8:00 PM' }, { text: '8:30 PM', value: '8:30 PM' }, { text: '9:00 PM', value: '9:00 PM' }, { text: '9:30 PM', value: '9:30 PM' }, { text: '10:00 PM', value: '10:00 PM' }, { text: '10:30 PM', value: '10:30 PM' }, { text: '11:00 PM', value: '11:00 PM' }, { text: '11:30 PM', value: '11:30 PM' }];

      var selectedDay = this.state.date ? new Date(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(this.state.date, 'L', true).toDate()) : new Date();

      var input = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: 'flex', flex: 1 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
          type: 'text',
          style: {
            border: 'none',
            outline: 'none',
            background: 'transparent',
            padding: '0',
            flex: 1
          },
          className: 'ignore-react-onclickoutside',
          value: this.state.date,
          placeholder: this.props.datePlaceholder || 'Date',
          onBlur: this.onBlur,
          onChange: this.onDateInputChange,
          onFocus: this.onFocus
        }),
        this.state.datepickerOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DatePicker__["a" /* default */], {
          close: this.closeDatePicker,
          style: { flex: 1 },
          initialMonth: this.state.month,
          selectedDay: selectedDay,
          updateSelectedDay: this.updateSelectedDay,
          onDayClick: this.onDayClick,
          viewer: this.props.viewer
        })
      );

      var timeInput = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
        type: 'text',
        style: {
          border: 'none',
          outline: 'none',
          background: 'transparent',
          padding: '0'
        },
        className: 'search',
        value: this.state.timeView,
        onBlur: this.onTimeInputBlur,
        onChange: this.onTimeInputChange,
        placeholder: this.props.timePlaceholder || 'Time'
      });

      var timeSelect = !this.props.dateOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["l" /* Dropdown */], {
        inline: true,
        basic: true,
        fluid: true,
        trigger: timeInput,
        placeholder: this.props.timePlaceholder || 'Time',
        scrolling: true,
        options: times,
        style: { display: 'flex', flex: 1, marginTop: '-1px' },
        value: this.nearestHalfHour(new Date(this.getIso8601Date({ dateOnly: false }))),
        onChange: this.onTimeSelectChange,
        tabIndex: -1
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__CardFieldNoValidate__["a" /* default */],
        _extends({}, this.props, { onBlur: this.onDateTimePickerBlur }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.datetimeOffset, style: { display: 'flex' } },
          input,
          timeSelect
        )
      );
    }
  }]);

  return DateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  dateOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  datePlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  timePlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  handleBlurringDatePicker: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_formsy_react__["HOC"])(DateTimePicker));

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CardDescriptionList = function (_React$Component) {
  _inherits(CardDescriptionList, _React$Component);

  function CardDescriptionList() {
    _classCallCheck(this, CardDescriptionList);

    return _possibleConstructorReturn(this, (CardDescriptionList.__proto__ || Object.getPrototypeOf(CardDescriptionList)).apply(this, arguments));
  }

  _createClass(CardDescriptionList, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.value && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { className: this.props.className },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.row },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 4, textAlign: 'right', className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.descriptionListItem },
              this.props.label && this.props.label + ':'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 12, className: __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.descriptionListItem },
              this.props.value || this.props.children
            )
          )
        )
      );
    }
  }]);

  return CardDescriptionList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

CardDescriptionList.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CardDescriptionList);

/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CardField_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CardInput = function (_React$Component) {
  _inherits(CardInput, _React$Component);

  function CardInput() {
    _classCallCheck(this, CardInput);

    return _possibleConstructorReturn(this, (CardInput.__proto__ || Object.getPrototypeOf(CardInput)).apply(this, arguments));
  }

  _createClass(CardInput, [{
    key: 'render',
    value: function render() {
      var _rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'label', 'children');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__CardField__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'ui input transparent fluid ' + __WEBPACK_IMPORTED_MODULE_4__CardField_scss___default.a.input },
          this.props.children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(this.props.children, _extends({}, _rest)),
          !this.props.children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', _rest)
        )
      );
    }
  }]);

  return CardInput;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CardInput.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (CardInput);

/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CardField_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CardSelect = function (_React$Component) {
  _inherits(CardSelect, _React$Component);

  function CardSelect() {
    _classCallCheck(this, CardSelect);

    return _possibleConstructorReturn(this, (CardSelect.__proto__ || Object.getPrototypeOf(CardSelect)).apply(this, arguments));
  }

  _createClass(CardSelect, [{
    key: 'render',
    value: function render() {
      var _rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'label', 'children');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__CardField__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__CardField_scss___default.a.input },
          this.props.children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(this.props.children, _extends({}, _rest)),
          !this.props.children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */], _extends({
            basic: true,
            fluid: true,
            search: true
          }, _rest, {
            className: 'cardFieldSelect'
          }))
        )
      );
    }
  }]);

  return CardSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CardSelect.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (CardSelect);

/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_timezones__ = __webpack_require__(827);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var CardTZSelect = function CardTZSelect(_ref) {
  var value = _ref.value,
      rest = _objectWithoutProperties(_ref, ['value']);

  var options = __WEBPACK_IMPORTED_MODULE_4__lib_utils_timezones__["a" /* default */].map(function (t) {
    return { value: t.name, text: t.text };
  });
  if (options.filter(function (o) {
    return o.value === value;
  }).length === 0) {
    options.push({ value: value, text: value });
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["d" /* CardSelect */], _extends({
    options: options,
    value: value,
    fluid: true,
    search: true
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(rest, 'options')));
};

CardTZSelect.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (CardTZSelect);

/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardField__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CardField_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CardTextArea = function (_React$Component) {
  _inherits(CardTextArea, _React$Component);

  function CardTextArea(props) {
    _classCallCheck(this, CardTextArea);

    var _this = _possibleConstructorReturn(this, (CardTextArea.__proto__ || Object.getPrototypeOf(CardTextArea)).call(this, props));

    _this.state = {
      fieldValue: ''
    };
    _this.onBlur = _this.onBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(CardTextArea, [{
    key: 'onBlur',
    value: function onBlur() {
      this.setState({
        fieldValue: this.state.fieldValue.trim()
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({ fieldValue: event.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__CardField__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__["a" /* default */], _extends({
          className: 'transparent fluid ' + __WEBPACK_IMPORTED_MODULE_3__CardField_scss___default.a.textArea,
          rows: 1,
          onBlur: this.onBlur,
          value: this.state.fieldValue,
          onChange: this.handleChange
        }, this.props))
      );
    }
  }]);

  return CardTextArea;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CardTextArea);

/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditableText_scss__ = __webpack_require__(3613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditableText_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditableText_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_textarea_autosize__ = __webpack_require__(356);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EditableText = function (_Component) {
  _inherits(EditableText, _Component);

  function EditableText(props) {
    _classCallCheck(this, EditableText);

    var _this = _possibleConstructorReturn(this, (EditableText.__proto__ || Object.getPrototypeOf(EditableText)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onSuccess = _this.onSuccess.bind(_this);
    _this.onError = _this.onError.bind(_this);
    _this.reset = _this.reset.bind(_this);
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  _createClass(EditableText, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.setState({ value: e.target.value.replace('\n', '') });
      if (this.props.onChange) this.props.onChange(e);
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.update();
      if (this.props.onBlur) this.props.onBlur();
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var _this2 = this;

      if (e.key === 'Enter') {
        this.update();
      } else if (e.key === 'Escape') {
        e.stopPropagation();
        this.reset(function () {
          return _this2.textarea.blur();
        });
      }
      if (this.props.onKeyDown) this.props.onKeyDown(e);
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      if (this.textarea) this.textarea.blur();
    }
  }, {
    key: 'onError',
    value: function onError() {
      if (this.textarea) this.textarea.focus();
    }
  }, {
    key: 'reset',
    value: function reset(callback) {
      this.setState({ value: this.props.value }, callback);
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.props.update && this.props.value !== this.state.value) {
        this.props.update({ value: this.state.value, name: this.props.name }, this.onSuccess, this.onError);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _omit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(this.props, ['value', 'update', 'onChange', 'onBlur', 'onKeyDown']),
          autoHeight = _omit.autoHeight,
          className = _omit.className,
          fluid = _omit.fluid,
          rest = _objectWithoutProperties(_omit, ['autoHeight', 'className', 'fluid']);

      var TextArea = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_textarea_autosize__["a" /* default */], _extends({
        onChange: this.onChange,
        onBlur: this.onBlur,
        className: [className, __WEBPACK_IMPORTED_MODULE_3__EditableText_scss___default.a.input, fluid ? __WEBPACK_IMPORTED_MODULE_3__EditableText_scss___default.a.fluid : null].join(' '),
        value: this.state.value ? '' + this.state.value : '',
        onKeyDown: this.onKeyDown,
        inputRef: function inputRef(tag) {
          return _this3.textarea = tag;
        }
      }, rest));
      var Input = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        onChange: this.onChange,
        onBlur: this.onBlur,
        className: [className, __WEBPACK_IMPORTED_MODULE_3__EditableText_scss___default.a.input, fluid ? __WEBPACK_IMPORTED_MODULE_3__EditableText_scss___default.a.fluid : null].join(' '),
        value: this.state.value || '',
        onKeyDown: this.onKeyDown,
        ref: function ref(tag) {
          return _this3.textarea = tag;
        }
      }, rest));
      return autoHeight ? TextArea : Input;
    }
  }]);

  return EditableText;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EditableText.propTypes = {
  autoHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  fluid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (EditableText);

/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fab_scss__ = __webpack_require__(3614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fab_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Fab_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Fab = function (_React$Component) {
  _inherits(Fab, _React$Component);

  function Fab() {
    _classCallCheck(this, Fab);

    return _possibleConstructorReturn(this, (Fab.__proto__ || Object.getPrototypeOf(Fab)).apply(this, arguments));
  }

  _createClass(Fab, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_found__["Link"],
        { to: '/events/new', style: { position: 'fixed', right: '20px', bottom: '20px', zIndex: 10 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: ['ui circular icon secondary button huge', __WEBPACK_IMPORTED_MODULE_2__Fab_scss___default.a.fab].join(' ') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'plus icon' })
        )
      );
    }
  }]);

  return Fab;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Fab);

/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var colors = {
  yellow: '#F9B142',
  blue: '#0088CC',
  green: '#85A91A',
  purple: '#BB68D9',
  red: '#C80000'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  /* Cloverbook */
  con: colors.blue,
  est: colors.yellow,
  pro: colors.purple,
  inv: colors.red,
  /* audio */
  mp3: colors.purple,
  aiff: colors.purple,
  wav: colors.purple,
  ogg: colors.purple,
  /* video */
  mov: colors.green,
  mp4: colors.green,
  mpg: colors.green,
  mpeg: colors.green,
  vob: colors.green,
  mkv: colors.green,
  avi: colors.green,
  m4v: colors.green,
  /* documents */
  doc: colors.blue,
  docx: colors.blue,
  xls: colors.green,
  xlsx: colors.green,
  csv: colors.green,
  ppt: colors.red,
  pptx: colors.red,
  key: colors.yellow,
  pdf: colors.red,
  txt: colors.blue,
  rtf: colors.yellow,
  odt: colors.blue,
  /* images */
  jpg: colors.yellow,
  jpeg: colors.yellow,
  gif: colors.yellow,
  png: colors.yellow,
  psd: colors.blue,
  bmp: colors.blue,
  svg: colors.blue,
  tif: colors.blue,
  tiff: colors.blue,
  /* executable and other */
  zip: colors.blue,
  dmg: colors.yellow,
  bin: colors.yellow,
  exe: colors.yellow,
  gz: colors.yellow
});

/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileIcon_scss__ = __webpack_require__(3615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileIcon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FileIcon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExtensionColors__ = __webpack_require__(3244);





var FileIconComponent = function FileIconComponent(_ref) {
  var type = _ref.type,
      width = _ref.width,
      height = _ref.height,
      background = _ref.background;

  var iconStyles = {};
  var cornerStyles = {};
  var typeStyles = {};
  if (width || height) {
    iconStyles.width = width || height.match(/^(\d+)/)[0] * 0.75 + height.match(/([a-z]+)$/)[0];
    iconStyles.height = height || width.match(/^(\d+)/)[0] * 4 / 3 + width.match(/([a-z]+)$/)[0];
    var scale = iconStyles.width.match(/^(\d+)/)[0] / 30;
    Object.assign(typeStyles, {
      bottom: 6 * scale + 'px',
      height: 10 * scale + 'px',
      width: 20 * scale + 'px',
      lineHeight: 10 * scale + 'px',
      fontSize: 6 * scale + 'px',
      left: -2 * scale + 'px'
    });
    Object.assign(cornerStyles, {
      borderLeftWidth: 10 * scale + 'px',
      borderTopWidth: 10 * scale + 'px'
    });
  }
  if (background) cornerStyles.borderTopColor = background;

  if (__WEBPACK_IMPORTED_MODULE_3__ExtensionColors__["a" /* default */][type]) typeStyles.background = __WEBPACK_IMPORTED_MODULE_3__ExtensionColors__["a" /* default */][type];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__FileIcon_scss___default.a.fileTypeIcon, style: iconStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_2__FileIcon_scss___default.a.corner, style: cornerStyles }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_2__FileIcon_scss___default.a.type, style: typeStyles },
      type
    )
  );
};

FileIconComponent.propTypes = {
  background: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FileIconComponent);

/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_placeholder_scss__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardField_placeholder_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CardField_placeholder_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DateTime = function (_React$Component) {
  _inherits(DateTime, _React$Component);

  function DateTime(props) {
    _classCallCheck(this, DateTime);

    var _this = _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).call(this, props));

    _this.state = {
      date: _this.formattedInput(),
      dateOnly: _this.props.dateOnly
    };
    _this.getClass = _this.getClass.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.formattedInput = _this.formattedInput.bind(_this);
    return _this;
  }

  _createClass(DateTime, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.dateOnly !== this.props.dateOnly || nextProps.timeZone !== this.props.timeZone) {
        // We must set the new value before changing the field type
        // See https://github.com/sankalpk/cloverbook-rails/issues/57
        this.setState({ date: this.formattedInput(nextProps) }, function () {
          _this2.setState({ dateOnly: nextProps.dateOnly });
        });
        // Propagate changes to HOC so desktop datepicker component updates
        this.props.onChange({
          target: { value: this.formattedInput(nextProps) }
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e);
      this.setState({ date: e.target.value });
    }
  }, {
    key: 'getClass',
    value: function getClass() {
      return this.props.value === '' ? '' : 'hasValue';
    }
  }, {
    key: 'formattedInput',
    value: function formattedInput() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var timeZone = props.timeZone || __WEBPACK_IMPORTED_MODULE_5_moment___default.a.tz.guess();
      if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(props.value).isValid()) {
        if (props.dateOnly) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(props.value).format('YYYY-MM-DD');
        }
        return __WEBPACK_IMPORTED_MODULE_5_moment___default.a.tz(props.value, timeZone).format('YYYY-MM-DDTHH:mm');
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var inputType = this.state.dateOnly ? 'date' : 'datetime-local';
      var rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, ['onChange', 'value', 'width', 'dateLabel']);
      var inputWidth = this.props.width || '145px';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["e" /* FloatingLabelInput */], _extends({
        type: inputType,
        label: this.props.dateLabel,
        inputRef: function inputRef(e) {
          var input = e;
          if (input) {
            input.className = _this3.getClass();
            input.style = Object.assign({}, input.style, {
              border: 'none',
              height: '1em',
              background: 'transparent',
              width: '100%',
              padding: '0.5em 0'
            });
          }
        },
        onChange: this.onChange,
        value: this.state.date,
        width: this.props.fluid ? '100%' : inputWidth
      }, rest));
    }
  }]);

  return DateTime;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

DateTime.propTypes = {
  dateOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dateLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  timeZone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DateTime);

/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardField_DatePicker__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */







var DateTimePicker = (_temp = _class = function (_React$Component) {
  _inherits(FloatingLabelDateTimePicker, _React$Component);

  function FloatingLabelDateTimePicker(props) {
    _classCallCheck(this, FloatingLabelDateTimePicker);

    var _this = _possibleConstructorReturn(this, (FloatingLabelDateTimePicker.__proto__ || Object.getPrototypeOf(FloatingLabelDateTimePicker)).call(this, props));

    var timeZone = _this.props.timeZone || __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess();
    _this.state = {
      datepickerOpen: false,
      time: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_this.props.getValue()).isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_this.props.getValue()).tz(timeZone).format('LT') : '',
      timeView: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_this.props.getValue()).isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_this.props.getValue()).tz(timeZone).format('LT') : '',
      date: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_this.props.getValue()).isValid() ? _this.getDateString(_this.props.getValue(), _this.props.dateOnly, timeZone) : '',
      month: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(timeZone).toDate()
    };
    _this.onDayClick = _this.onDayClick.bind(_this);
    _this.onDateInputChange = _this.onDateInputChange.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.showCurrentDate = _this.showCurrentDate.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.updateSelectedDay = _this.updateSelectedDay.bind(_this);
    _this.updateDateTime = _this.updateDateTime.bind(_this);
    _this.getIso8601Date = _this.getIso8601Date.bind(_this);
    _this.closeDatePicker = _this.closeDatePicker.bind(_this);
    _this.onTimeInputChange = _this.onTimeInputChange.bind(_this);
    _this.onTimeSelectChange = _this.onTimeSelectChange.bind(_this);
    _this.onTimeInputBlur = _this.onTimeInputBlur.bind(_this);
    _this.onDateTimePickerBlur = _this.onDateTimePickerBlur.bind(_this);
    return _this;
  }

  _createClass(FloatingLabelDateTimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextValue = nextProps.value;
      var timeZone = nextProps.timeZone || __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess();
      if (nextProps.dateOnly !== this.props.dateOnly && __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(nextValue, __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.ISO_8601).isValid()) {
        this.setState({
          date: this.getDateString(nextValue, nextProps.dateOnly, timeZone),
          time: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(nextValue).tz(timeZone).format('LT')
        });
      }
      if ((nextValue !== this.props.value || !nextProps.dateOnly && timeZone !== this.props.timeZone) && __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(nextValue, __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.ISO_8601).isValid()) {
        this.setState({
          date: this.getDateString(nextValue, nextProps.dateOnly, timeZone),
          time: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(nextValue, timeZone).format('LT'),
          timeView: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(nextValue, timeZone).format('LT')
        });
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ datepickerOpen: true });
      this.showCurrentDate();
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var _this2 = this;

      var value = e.target.value;

      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess();
      var formattedDate = this.parseDate(value);

      // Change the current month only if the value entered by the user
      // is a valid date, according to the `L` format
      if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(formattedDate, 'L', true).isValid()) {
        this.setState({
          month: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(formattedDate, 'L', timeZone).toDate(),
          date: formattedDate
        }, function () {
          _this2.showCurrentDate();
          _this2.changeValue({
            target: {
              value: _this2.getIso8601Date({ dateOnly: _this2.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ date: '' }, this.showCurrentDate);
      }
      if (e.relatedTarget && !e.relatedTarget.className.match('DayPicker')) {
        this.closeDatePicker();
      }
    }
  }, {
    key: 'onDateTimePickerBlur',
    value: function onDateTimePickerBlur(e) {
      // Determine if blurring off DateTimePicker completely
      // or moving focusing onto DayPicker, which we still
      // consider part of this component
      if (e.relatedTarget && e.relatedTarget.className.match('DayPicker-Day')) {
        this.handleBlurringDatePicker(false);
      } else {
        this.handleBlurringDatePicker(true);
      }
    }
  }, {
    key: 'onTimeInputChange',
    value: function onTimeInputChange(e) {
      var value = e.currentTarget.value;

      this.setState({ timeView: value });
    }
  }, {
    key: 'onTimeInputBlur',
    value: function onTimeInputBlur(e) {
      var _this3 = this;

      var value = e.target.value;

      var formattedTime = this.parseTime(value);

      if (formattedTime) {
        this.setState({
          time: formattedTime,
          timeView: formattedTime
        }, function () {
          _this3.handleBlurringDatePicker(true);
          _this3.changeValue({
            target: {
              value: _this3.getIso8601Date({ dateOnly: _this3.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ time: '', timeView: '' });
      }
    }
  }, {
    key: 'onTimeSelectChange',
    value: function onTimeSelectChange(e, change) {
      var _this4 = this;

      if (e.target.value === undefined) {
        this.setState({
          time: change.value,
          timeView: change.value
        }, function () {
          _this4.changeValue({
            target: {
              value: _this4.getIso8601Date({ dateOnly: _this4.props.dateOnly })
            }
          });
        });
      }
    }
  }, {
    key: 'onDateInputChange',
    value: function onDateInputChange(e) {
      var _this5 = this;

      var value = e.target.value;

      // Change the current month only if the value entered by the user
      // is a valid date, according to the `L` format

      if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(value, 'L', true).isValid()) {
        this.setState({
          month: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(value, 'L').toDate(),
          date: value
        }, function () {
          _this5.showCurrentDate();
          _this5.changeValue({
            target: {
              value: _this5.getIso8601Date({ dateOnly: _this5.props.dateOnly })
            }
          });
        });
      } else {
        this.setState({ date: null }, this.showCurrentDate);
      }
    }
  }, {
    key: 'onDayClick',
    value: function onDayClick(e, day) {
      this.setState({
        date: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(day).format('L'),
        month: day
      });
    }
  }, {
    key: 'getDateString',
    value: function getDateString(date, dateOnly, timeZone) {
      if (dateOnly) {
        return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(date).format('L');
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(date, timeZone).format('L');
    }
  }, {
    key: 'getIso8601Date',
    value: function getIso8601Date(options) {
      var dateOnly = options.dateOnly;

      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess();
      if (dateOnly) {
        if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(this.state.date, 'L').isValid()) {
          return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(this.state.date, 'L').format('YYYY-MM-DD');
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(this.state.date, 'L LT').isValid()) {
          return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(this.state.date + ' ' + this.state.time, 'L LT', timeZone).toISOString();
        }
      }
      return '';
    }
  }, {
    key: 'handleBlurringDatePicker',
    value: function handleBlurringDatePicker(blurring) {
      if (this.props.handleBlurringDatePicker) {
        if (!this.props.dateOnly && this.state.date !== '' && this.state.time !== '' || this.props.dateOnly && this.state.date !== '') {
          this.props.handleBlurringDatePicker(blurring);
        } else if (blurring) {
          this.props.handleBlurringDatePicker(true);
        } else {
          this.props.handleBlurringDatePicker(false);
        }
      }
    }
  }, {
    key: 'changeValue',
    value: function changeValue(e) {
      if (this.props.dateOnly) {
        if (this.state.date) {
          this.props.setValue(e.target.value);
          this.props.onChange({
            target: { value: e.target.value, name: this.props.name }
          });
        }
      } else {
        if (this.state.date && this.state.time) {
          this.props.setValue(e.target.value);
          this.props.onChange({
            target: { value: e.target.value, name: this.props.name }
          });
        }
      }
    }
  }, {
    key: 'closeDatePicker',
    value: function closeDatePicker() {
      this.setState({ datepickerOpen: false });
      this.handleBlurringDatePicker(true);
    }
  }, {
    key: 'nearestHalfHour',
    value: function nearestHalfHour(time) {
      var minutes = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(time).minutes();
      var momentTime = null;
      if (minutes >= 0 && minutes < 15) {
        momentTime = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(time).minutes(0);
      } else if (minutes >= 15 && minutes < 45) {
        momentTime = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(time).minutes(30);
      } else {
        momentTime = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(time).minutes(0).add(1, 'hour');
      }
      return momentTime.format('LT');
    }
  }, {
    key: 'parseTime',
    value: function parseTime(timeString) {
      // do parsing here and return appropriate value
      var timeParts = timeString.match(/([0-9]{1,2}):?([0-9]{1,2})?\s?([AaPp][Mm]?)?/);
      if (!timeParts) {
        return null;
      }
      var hours = parseInt(timeParts[1], 10);
      var minutes = parseInt(timeParts[2] || '0', 10);
      var hoursString = '';
      var minutesString = timeParts[2] || '00';
      var meridian = '';
      if (hours > 0 && hours <= 12) {
        hoursString = timeParts[1];
      } else {
        // Out of range
        return null;
      }
      if (minutes >= 0 && minutes <= 60) {
        while (minutesString.length < 2) {
          minutesString = '0' + minutesString;
        }
      } else {
        // Out of range
        return null;
      }
      if (timeParts[3]) {
        meridian = timeParts[3].length === 1 ? timeParts[3].toUpperCase() + 'M' : timeParts[3].toUpperCase();
      } else {
        meridian = hours > 0 && hours < 7 ? 'AM' : 'PM';
      }

      return hoursString + ':' + minutesString + ' ' + meridian;
    }
  }, {
    key: 'parseDate',
    value: function parseDate(date) {
      var dateParts = date.split('/');
      if (dateParts.length === 3) {
        if (dateParts[0].length === 1) {
          dateParts[0] = '0' + dateParts[0];
        }
        if (dateParts[1].length === 1) {
          dateParts[1] = '0' + dateParts[1];
        }
        if (dateParts[2].length === 2) {
          dateParts[2] = parseInt(new Date().getFullYear() / 100, 10) + dateParts[2];
        }
        return dateParts.join('/');
      }
      return date;
    }
  }, {
    key: 'showCurrentDate',
    value: function showCurrentDate() {
      // TODO: fix refs to call showMonth on child component
      this.setState({ month: this.state.date });
      // this.refs.daypicker.showMonth(this.state.month);
    }
  }, {
    key: 'updateSelectedDay',
    value: function updateSelectedDay(date) {
      var _this6 = this;

      this.setState({ date: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(date).format('L') }, function () {
        _this6.changeValue({
          target: {
            value: _this6.getIso8601Date({ dateOnly: _this6.props.dateOnly })
          }
        });
      });
    }
  }, {
    key: 'updateDateTime',
    value: function updateDateTime() {
      this.changeValue({
        target: { value: this.getIso8601Date({ dateOnly: this.props.dateOnly }) }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var times = [{ text: '12:00 AM', value: '12:00 AM' }, { text: '12:30 AM', value: '12:30 AM' }, { text: '1:00 AM', value: '1:00 AM' }, { text: '1:30 AM', value: '1:30 AM' }, { text: '2:00 AM', value: '2:00 AM' }, { text: '2:30 AM', value: '2:30 AM' }, { text: '3:00 AM', value: '3:00 AM' }, { text: '3:30 AM', value: '3:30 AM' }, { text: '4:00 AM', value: '4:00 AM' }, { text: '4:30 AM', value: '4:30 AM' }, { text: '5:00 AM', value: '5:00 AM' }, { text: '5:30 AM', value: '5:30 AM' }, { text: '6:00 AM', value: '6:00 AM' }, { text: '6:30 AM', value: '6:30 AM' }, { text: '7:00 AM', value: '7:00 AM' }, { text: '7:30 AM', value: '7:30 AM' }, { text: '8:00 AM', value: '8:00 AM' }, { text: '8:30 AM', value: '8:30 AM' }, { text: '9:00 AM', value: '9:00 AM' }, { text: '9:30 AM', value: '9:30 AM' }, { text: '10:00 AM', value: '10:00 AM' }, { text: '10:30 AM', value: '10:30 AM' }, { text: '11:00 AM', value: '11:00 AM' }, { text: '11:30 AM', value: '11:30 AM' }, { text: '12:00 PM', value: '12:00 PM' }, { text: '12:30 PM', value: '12:30 PM' }, { text: '1:00 PM', value: '1:00 PM' }, { text: '1:30 PM', value: '1:30 PM' }, { text: '2:00 PM', value: '2:00 PM' }, { text: '2:30 PM', value: '2:30 PM' }, { text: '3:00 PM', value: '3:00 PM' }, { text: '3:30 PM', value: '3:30 PM' }, { text: '4:00 PM', value: '4:00 PM' }, { text: '4:30 PM', value: '4:30 PM' }, { text: '5:00 PM', value: '5:00 PM' }, { text: '5:30 PM', value: '5:30 PM' }, { text: '6:00 PM', value: '6:00 PM' }, { text: '6:30 PM', value: '6:30 PM' }, { text: '7:00 PM', value: '7:00 PM' }, { text: '7:30 PM', value: '7:30 PM' }, { text: '8:00 PM', value: '8:00 PM' }, { text: '8:30 PM', value: '8:30 PM' }, { text: '9:00 PM', value: '9:00 PM' }, { text: '9:30 PM', value: '9:30 PM' }, { text: '10:00 PM', value: '10:00 PM' }, { text: '10:30 PM', value: '10:30 PM' }, { text: '11:00 PM', value: '11:00 PM' }, { text: '11:30 PM', value: '11:30 PM' }];

      var selectedDay = this.state.date ? new Date(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(this.state.date, 'L', true).toDate()) : new Date();

      var input = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: 'flex', flex: 1, position: 'relative' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["e" /* FloatingLabelInput */], {
          type: 'text',
          name: 'date',
          style: {
            border: 'none',
            outline: 'none',
            background: 'transparent',
            padding: '0',
            flex: 1
          },
          className: 'ignore-react-onclickoutside',
          value: this.state.date,
          placeholder: this.props.datePlaceholder || 'Date',
          label: this.props.dateLabel,
          onBlur: this.onBlur,
          onChange: this.onDateInputChange,
          required: this.props.required,
          validationError: this.props.validationError,
          onFocus: this.onFocus,
          disabled: this.props.disabled,
          autoComplete: 'off'
        }),
        this.state.datepickerOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CardField_DatePicker__["a" /* default */], {
          close: this.closeDatePicker,
          style: { flex: 1, top: '100%', left: 0 },
          initialMonth: this.state.month,
          selectedDay: selectedDay,
          updateSelectedDay: this.updateSelectedDay,
          onDayClick: this.onDayClick,
          viewer: this.props.viewer,
          tabIndex: -1
        })
      );

      var timeInput = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["e" /* FloatingLabelInput */], {
        type: 'text',
        name: 'time',
        style: {
          border: 'none',
          outline: 'none',
          background: 'transparent',
          padding: '0',
          marginRight: '-1em'
        },
        required: this.props.required,
        validationError: this.props.validationError,
        disabled: this.props.disabled,
        className: 'search',
        width: '100%',
        value: this.state.timeView,
        onBlur: this.onTimeInputBlur,
        onChange: this.onTimeInputChange,
        placeholder: this.props.timePlaceholder || 'Time'
      });

      var timeSelect = !this.props.dateOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */], {
        inline: true,
        basic: true,
        fluid: true,
        disabled: this.props.disabled,
        trigger: timeInput,
        placeholder: this.props.timePlaceholder || 'Time',
        scrolling: true,
        options: times,
        style: { display: 'flex', flex: 1 },
        value: this.nearestHalfHour(new Date(this.getIso8601Date({ dateOnly: false }))),
        onChange: this.onTimeSelectChange,
        tabIndex: -1,
        autoComplete: 'off'
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          onBlur: this.onDateTimePickerBlur,
          style: Object.assign({ display: 'flex', width: this.props.width }, this.props.inline ? { display: 'inline-block' } : {}, this.props.inline === 'last' ? {} : { marginRight: '0.5em' }),
          className: this.props.className
        },
        input,
        timeSelect
      );
    }
  }]);

  return FloatingLabelDateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  dateOnly: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  dateLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  datePlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['last', true, false]),
  required: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  timePlaceholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  handleBlurringDatePicker: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  validationError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_formsy_react__["HOC"])(DateTimePicker));

/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FloatingLabelInput__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_scss__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FloatingLabelSelect = function (_React$Component) {
  _inherits(FloatingLabelSelect, _React$Component);

  function FloatingLabelSelect(props) {
    _classCallCheck(this, FloatingLabelSelect);

    var _this = _possibleConstructorReturn(this, (FloatingLabelSelect.__proto__ || Object.getPrototypeOf(FloatingLabelSelect)).call(this, props));

    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(FloatingLabelSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({ window: { width: window.innerWidth, height: window.innerHeight } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inline = _props.inline,
          label = _props.label,
          name = _props.name,
          onChange = _props.onChange,
          placeholder = _props.placeholder,
          className = _props.className,
          value = _props.value,
          validations = _props.validations,
          validationError = _props.validationError,
          validationErrors = _props.validationErrors,
          required = _props.required,
          style = _props.style,
          submitted = _props.submitted,
          width = _props.width,
          rest = _objectWithoutProperties(_props, ['inline', 'label', 'name', 'onChange', 'placeholder', 'className', 'value', 'validations', 'validationError', 'validationErrors', 'required', 'style', 'submitted', 'width']);

      var selectField = this.state.window.width < __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* default */].tabletBreakpoint ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        { className: __WEBPACK_IMPORTED_MODULE_4__FloatingLabelInput_scss___default.a.nativeSelect },
        this.props.options.map(function (option, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: option.value, key: idx },
            option.text
          );
        })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["l" /* Dropdown */], _extends({
        selection: true,
        floating: true,
        style: Object.assign({}, {
          border: 0,
          lineHeight: '1.4285em',
          padding: 'calc(0.25rem - 1px) 2rem calc(0.25rem - 1px) 0',
          margin: 0,
          boxShadow: 'none',
          minHeight: 'auto'
        }, this.props.style),
        value: value
      }, rest));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__FloatingLabelInput__["a" /* default */],
        {
          className: className,
          label: label,
          name: name,
          value: value,
          type: 'select',
          onChange: onChange,
          validations: validations,
          validationError: validationError,
          validationErrors: validationErrors,
          required: required,
          width: width,
          inline: inline,
          style: style,
          submitted: submitted,
          placeholder: placeholder
        },
        selectField
      );
    }
  }]);

  return FloatingLabelSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FloatingLabelSelect.propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['last', true, false]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  validations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  validationError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  validationErrors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (FloatingLabelSelect);

/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_timezones__ = __webpack_require__(827);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var FloatingLabelTZSelect = function FloatingLabelTZSelect(_ref) {
  var value = _ref.value,
      rest = _objectWithoutProperties(_ref, ['value']);

  var options = __WEBPACK_IMPORTED_MODULE_4__lib_utils_timezones__["a" /* default */].map(function (t) {
    return { value: t.name, text: t.text };
  });
  if (options.filter(function (o) {
    return o.value === value;
  }).length === 0) {
    options.push({ value: value, text: value });
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["f" /* FloatingLabelSelect */], _extends({
    options: options,
    value: value,
    fluid: true,
    search: true
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(rest, 'options')));
};

FloatingLabelTZSelect.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (FloatingLabelTZSelect);

/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormsyProps__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FloatingLabelInput_FloatingLabelInput_scss__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FloatingLabelInput_FloatingLabelInput_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FloatingLabelInput_FloatingLabelInput_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */








var InputElement = (_temp = _class = function (_React$Component) {
  _inherits(InputElement, _React$Component);

  function InputElement(props) {
    _classCallCheck(this, InputElement);

    var _this = _possibleConstructorReturn(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).call(this, props));

    _this.state = {
      initialBlur: false
    };
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(InputElement, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Ties `value` field to HOC value functions
      if (nextProps.value && nextProps.value !== this.props.getValue()) {
        this.props.setValue(nextProps.value);
        this.setState({ isActive: nextProps.value !== null && nextProps.value !== '' });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.getValue() === nextProps.value;
    }
  }, {
    key: 'onChange',
    value: function onChange(e, _ref) {
      var value = _ref.value;

      if (this.props.onChange) this.props.onChange(e);
      this.props.setValue(value);
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      this.setState({ initialBlur: true });
      if (this.props.onBlur) this.props.onBlur(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          showError = _props.showError,
          hasValue = _props.hasValue,
          validationError = _props.validationError;

      var hasError = (this.state.initialBlur || this.props.submitted) && (showError() || this.props.required && !hasValue());
      var errorMessage = hasError ? validationError : null;

      var eventHandlers = {
        onChange: this.onChange,
        onBlur: this.onBlur
      };

      // Remove formsy props

      var _$omit = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit.apply(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a, [this.props].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__FormsyProps__["a" /* default */]))),
          label = _$omit.label,
          _rest = _objectWithoutProperties(_$omit, ['label']);

      var margin = '0.25em';

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { style: { width: '100%' } },
        label && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { marginBottom: margin } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'strong',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'label',
              { htmlFor: name },
              label
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["k" /* Input */], _extends({}, _rest, eventHandlers)),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__FloatingLabelInput_FloatingLabelInput_scss___default.a.error, style: { marginTop: margin } },
          errorMessage
        )
      );
    }
  }]);

  return InputElement;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  validationError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_formsy_react__["HOC"])(InputElement));

/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputWithSuggestions_scss__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputWithSuggestions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputWithSuggestions_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Suggestion__ = __webpack_require__(3252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InputWithSuggestions = function (_Component) {
  _inherits(InputWithSuggestions, _Component);

  function InputWithSuggestions(props) {
    _classCallCheck(this, InputWithSuggestions);

    var _this = _possibleConstructorReturn(this, (InputWithSuggestions.__proto__ || Object.getPrototypeOf(InputWithSuggestions)).call(this, props));

    _this.state = {
      selectedIndex: -1,
      showSuggestions: false
    };
    _this.suggestionsContainer = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();
    _this.updateRefs();
    _this.onChange = _this.onChange.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.filteredOptions = _this.filteredOptions.bind(_this);
    _this.hideSuggestions = _this.hideSuggestions.bind(_this);
    _this.showSuggestions = _this.showSuggestions.bind(_this);
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.updateRefs = _this.updateRefs.bind(_this);
    return _this;
  }

  _createClass(InputWithSuggestions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(nextProps.options, this.props.options)) {
        this.updateRefs();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'onChange',
    value: function onChange(e, value) {
      this.props.onChange(e, { value: value, name: this.props.name });
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(e) {
      this.setState({ selectedOptionIndex: -1, showSuggestions: true });
      this.onChange(e, e.target.value);
      this.updateRefs();
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.key === 'ArrowUp') {
        this.moveCursor(-1);
      } else if (e.key === 'ArrowDown') {
        this.moveCursor(1);
      } else if (e.key === 'Enter') {
        var options = this.filteredOptions();
        var selectedIndex = this.state.selectedIndex;

        if (this.state.showSuggestions && options.length > 0 && selectedIndex >= 0) {
          this.onChange(e, options[selectedIndex].value);
          this.setState({ showSuggestions: false });
          e.preventDefault();
        }
      } else if (e.key === 'Tab') {
        this.setState({ showSuggestions: false });
      }
      if (this.props.onKeyDown) this.props.onKeyDown(e);
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.hideSuggestions();
      }
    }
  }, {
    key: 'filteredOptions',
    value: function filteredOptions() {
      var value = this.props.value;

      return this.props.options.filter(function (e) {
        return e.value.startsWith(value) || e.title && e.title.toLowerCase().startsWith(value);
      }).filter(function (e) {
        return e.value !== value;
      });
    }
  }, {
    key: 'hideSuggestions',
    value: function hideSuggestions() {
      this.setState({ selectedIndex: -1, showSuggestions: false });
    }
  }, {
    key: 'moveCursor',
    value: function moveCursor(offset) {
      var _this2 = this;

      this.setState(function (prevState) {
        var selectedIndex = prevState.selectedIndex;

        var options = _this2.filteredOptions();
        var lastIndex = options.length - 1;
        var nextIndex = selectedIndex + offset;
        if (nextIndex > lastIndex) nextIndex = 0;
        if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
        if (options.length > 0) {
          // Scroll element into view if necessary
          var containerBounds = _this2.suggestionsContainer.current.getBoundingClientRect();
          var selectedNode = _this2[options[nextIndex].value + '_ref'].current;
          var selectedNodeTop = selectedNode.getBoundingClientRect().top;
          if (selectedNodeTop - containerBounds.height > containerBounds.height || selectedNodeTop < containerBounds.height) {
            selectedNode.scrollIntoView();
          }
        }
        return { selectedIndex: nextIndex };
      });
    }
  }, {
    key: 'showSuggestions',
    value: function showSuggestions() {
      this.setState({ showSuggestions: true });
    }
  }, {
    key: 'updateRefs',
    value: function updateRefs() {
      var _this3 = this;

      this.filteredOptions().map(function (option) {
        _this3[option.value + '_ref'] = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();
        return option;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(this.props, 'onChange', 'onKeyDown', 'options');
      var _state = this.state,
          selectedIndex = _state.selectedIndex,
          showSuggestions = _state.showSuggestions;

      var options = this.filteredOptions();
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { onFocus: this.showSuggestions, ref: this.setWrapperRef },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["c" /* Input */], _extends({
          onChange: this.onInputChange,
          onKeyDown: this.onKeyDown
        }, rest)),
        showSuggestions && options.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__InputWithSuggestions_scss___default.a.suggestions, ref: this.suggestionsContainer },
          options.map(function (option, index) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: option.value,
                ref: _this4[option.value + '_ref'],
                onClick: function onClick(e) {
                  return _this4.onChange(e, option.value);
                },
                onMouseEnter: function onMouseEnter() {
                  return _this4.setState({ selectedIndex: index });
                }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Suggestion__["a" /* default */], {
                title: option.title,
                description: option.description,
                active: index === selectedIndex
              })
            );
          })
        )
      );
    }
  }]);

  return InputWithSuggestions;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

InputWithSuggestions.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.exact({
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  })).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (InputWithSuggestions);

/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss__);




var Suggestion = function Suggestion(_ref) {
  var active = _ref.active,
      description = _ref.description,
      title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: [__WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss___default.a.option, active ? __WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss___default.a.selected : ''].join(' ') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss___default.a.title },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__InputWithSuggestions_scss___default.a.description },
      description
    )
  );
};

Suggestion.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Suggestion);

/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ContentLoader = function (_React$Component) {
  _inherits(ContentLoader, _React$Component);

  function ContentLoader() {
    _classCallCheck(this, ContentLoader);

    return _possibleConstructorReturn(this, (ContentLoader.__proto__ || Object.getPrototypeOf(ContentLoader)).apply(this, arguments));
  }

  _createClass(ContentLoader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { padding: '4em', margin: '0 auto' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["j" /* Loader */], { active: true, inline: 'centered' })
      );
    }
  }]);

  return ContentLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ContentLoader);

/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss__ = __webpack_require__(3616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);





var SelectableBlock = function SelectableBlock(_ref) {
  var cardBorder = _ref.cardBorder,
      checked = _ref.checked,
      checkbox = _ref.checkbox,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      content = _ref.content,
      disabled = _ref.disabled,
      name = _ref.name,
      onChange = _ref.onChange,
      radio = _ref.radio,
      style = _ref.style,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: [className, checked ? __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.selectableBlockSelected : __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.selectableBlock, radio || checkbox ? __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.showIndicator : '', disabled ? __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.selectableBlockDisabled : '', cardBorder ? __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.cardBorder : '', color && checked ? __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a[color] : ''].join(' '),
      style: style,
      onClick: function onClick(e) {
        if (!disabled) {
          onChange(e, { checked: !checked, name: name, value: value });
        }
      }
    },
    content || children,
    (checkbox || radio) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_2__SelectableBlock_scss___default.a.checkbox },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], {
        radio: radio,
        onClick: function onClick(e, data) {
          if (!disabled) {
            onChange(e, Object.assign(data, { checked: !checked }));
          }
        },
        checked: checked,
        disabled: disabled,
        name: name,
        value: value
      })
    )
  );
};

SelectableBlock.propTypes = {
  cardBorder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['grey']),
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  radio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (SelectableBlock);

/***/ }),
/* 3255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Success_scss__ = __webpack_require__(3617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Success_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Success_scss__);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { className: __WEBPACK_IMPORTED_MODULE_1__Success_scss___default.a.checkmark, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 52 52' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { className: __WEBPACK_IMPORTED_MODULE_1__Success_scss___default.a.checkmark__circle, cx: 26, cy: 26, r: 25, fill: 'none' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: 'checkmark__check', fill: 'none', d: 'M14.1 27.2l7.1 7.2 16.7-16.8' })
  );
});

/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss__ = __webpack_require__(3618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'tr',
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss___default.a.divider })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss___default.a.divider })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1__SummaryTotals_scss___default.a.divider })
    )
  );
});

/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Rows = function Rows(_ref) {
  var label = _ref.label,
      minus = _ref.minus,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ['label', 'minus', 'value']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'tr',
    rest,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { width: '100%' } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      { style: { whiteSpace: 'nowrap' } },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      { style: { paddingLeft: '2em' } },
      minus ? '-' : ''
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'td',
      { style: { paddingLeft: '0.75em' } },
      value
    )
  );
};

Rows.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  minus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

/* harmony default export */ __webpack_exports__["a"] = (Rows);

/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Break__ = __webpack_require__(3256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Row__ = __webpack_require__(3257);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SummaryTotals = function (_React$Component) {
  _inherits(SummaryTotals, _React$Component);

  function SummaryTotals() {
    _classCallCheck(this, SummaryTotals);

    return _possibleConstructorReturn(this, (SummaryTotals.__proto__ || Object.getPrototypeOf(SummaryTotals)).apply(this, arguments));
  }

  _createClass(SummaryTotals, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['children', 'style']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'table',
        _extends({ style: Object.assign({ textAlign: 'right' }, style) }, rest),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tbody',
          null,
          children
        )
      );
    }
  }]);

  return SummaryTotals;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SummaryTotals.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
SummaryTotals.Break = __WEBPACK_IMPORTED_MODULE_2__Break__["a" /* default */];
SummaryTotals.Row = __WEBPACK_IMPORTED_MODULE_3__Row__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (SummaryTotals);

/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_textarea_autosize__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormsyProps__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardField_CardField_scss__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardField_CardField_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CardField_CardField_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */






var TextArea = (_temp = _class = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props) {
    _classCallCheck(this, TextArea);

    var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

    _this.changeValue = _this.changeValue.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.state = {
      initialBlur: false
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.activeElement) {
        document.activeElement.blur();
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      this.setState({ initialBlur: true });
      if (this.props.onBlur) this.props.onBlur(e);
    }
  }, {
    key: 'changeValue',
    value: function changeValue(e) {
      this.props.setValue(e.target.value);
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showError = _props.showError,
          hasValue = _props.hasValue,
          validationError = _props.validationError;

      var hasError = (this.state.initialBlur || this.props.submitted) && (showError() || this.props.required && !hasValue());
      var errorMessage = hasError ? validationError : null;
      var _rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, __WEBPACK_IMPORTED_MODULE_4__FormsyProps__["a" /* default */]);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_textarea_autosize__["a" /* default */], _extends({}, _rest, {
          onChange: this.changeValue,
          onBlur: this.onBlur,
          value: this.props.getValue()
        })),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__CardField_CardField_scss___default.a.errorMessage },
          errorMessage
        )
      );
    }
  }]);

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  validationError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_formsy_react__["HOC"])(TextArea));

/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(3263);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3262);
  }
}));

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b8a4669e8b7872a2c8b737bff2df0c21
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type CreateEventFormInput = {
  clientMutationId?: ?string,
  title: string,
  user_id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  contacts?: ?$ReadOnlyArray<?EventCreateContact>,
  user_event_segments?: ?$ReadOnlyArray<?EventCreateUserEventSegment>,
};
export type EventCreateContact = {
  role: string,
  first_name: string,
  last_name?: ?string,
  emails?: ?$ReadOnlyArray<?UserContactEmailInput>,
  addresses?: ?$ReadOnlyArray<?UserContactAddressInput>,
  phones?: ?$ReadOnlyArray<?UserContactPhoneInput>,
};
export type UserContactEmailInput = {
  label: string,
  address: string,
};
export type UserContactAddressInput = {
  label: string,
  line1: string,
  line2?: ?string,
  city?: ?string,
  province: string,
  postal_code: string,
  country: string,
};
export type UserContactPhoneInput = {
  label: string,
  number: string,
};
export type EventCreateUserEventSegment = {
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type CreateEvent_CreateEventFormMutationVariables = {|
  input: CreateEventFormInput
|};
export type CreateEvent_CreateEventFormMutationResponse = {|
  +createEventForm: ?{|
    +event: ?{|
      +id: string
    |}
  |}
|};
export type CreateEvent_CreateEventFormMutation = {|
  variables: CreateEvent_CreateEventFormMutationVariables,
  response: CreateEvent_CreateEventFormMutationResponse,
|};
*/

/*
mutation CreateEvent_CreateEventFormMutation(
  $input: CreateEventFormInput!
) {
  createEventForm(input: $input) {
    event {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEventFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createEventForm",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateEventFormInput!"
    }],
    "concreteType": "CreateEventFormPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": null,
      "concreteType": "Event",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "CreateEvent_CreateEventFormMutation",
    "id": null,
    "text": "mutation CreateEvent_CreateEventFormMutation(\n  $input: CreateEventFormInput!\n) {\n  createEventForm(input: $input) {\n    event {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "CreateEvent_CreateEventFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "CreateEvent_CreateEventFormMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b27500604c62023cfc11ff1e0b0109f3';
module.exports = node;

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventCreateContainer_viewer$ref: FragmentReference;
export type EventCreateContainer_viewer = {|
  +id: string,
  +past_referral_sources: ?$ReadOnlyArray<?string>,
  +s_time_zone: ?string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventCreateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "EventCreateContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "past_referral_sources",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCalendarContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '4b073d055d8c57b460d7b37d2dc6f2a0';
module.exports = node;

/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventCreate_scss__ = __webpack_require__(3619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventCreate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EventCreate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Show_ContactFields__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Show_ReferralSource__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EventSegment_EventSegmentShow__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EventSegment_EventSegmentMobile__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EventSegment_EventSegmentDesktop__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_relay__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















__WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.addValidationRule('requireIfExists', function (values, value, otherField) {
  return values[otherField] ? values[otherField] !== '' && value !== '' : true;
});

__WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.addValidationRule('requireIfAnyExist', function (values, value) {
  var valueExists = false;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (values[key] !== null && values[key] !== '') {
        valueExists = true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return valueExists ? value && valueExists : true;
});

var CreateEventComponent = (_temp = _class = function (_React$Component) {
  _inherits(CreateEvent, _React$Component);

  function CreateEvent(props) {
    _classCallCheck(this, CreateEvent);

    var _this = _possibleConstructorReturn(this, (CreateEvent.__proto__ || Object.getPrototypeOf(CreateEvent)).call(this, props));

    _this.state = {
      availabilityView: 'date',
      selectedDay: new Date(),
      submissionAttempts: 0,
      event: {
        title: '',
        booking_status: 'INITIAL',
        referral_source: '',
        notes: '',
        visibility: 'SHOW',
        contacts: [{
          node: {
            first_name: '',
            last_name: '',
            user_contact_emails: { edges: [] },
            user_contact_phones: { edges: [] },
            user_contact_addresses: { edges: [] }
          },
          role: ''
        }],
        user_event_segments: []
      },
      cachedEventSegments: [],
      editingNewEventSegment: false,
      newEventSegment: {
        id: _this.generateKey(),
        all_day: true,
        title: '',
        start_at: '',
        end_at: '',
        time_zone: _this.props.viewer.s_time_zone,
        location: '',
        room: '',
        notes: ''
      },
      submitting: false
    };
    _this.toggleAvailabilityView = _this.toggleAvailabilityView.bind(_this);
    _this.updateSelectedDay = _this.updateSelectedDay.bind(_this);
    _this.eventChangeHandler = _this.eventChangeHandler.bind(_this);
    _this.contactChangeHandler = _this.contactChangeHandler.bind(_this);
    _this.createEvent = _this.createEvent.bind(_this);
    _this.addEventSegment = _this.addEventSegment.bind(_this);
    _this.eventSegmentChangeHandler = _this.eventSegmentChangeHandler.bind(_this);
    _this.generateKey = _this.generateKey.bind(_this);
    _this.resetAddEventSegment = _this.resetAddEventSegment.bind(_this);
    _this.resetEditEventSegment = _this.resetEditEventSegment.bind(_this);
    _this.saveEventSegment = _this.saveEventSegment.bind(_this);
    _this.newEventSegmentChangeHandler = _this.newEventSegmentChangeHandler.bind(_this);
    _this.createEventSegment = _this.createEventSegment.bind(_this);
    _this.closeNewEventSegmentEditor = _this.closeNewEventSegmentEditor.bind(_this);
    _this.deleteEventSegment = _this.deleteEventSegment.bind(_this);
    _this.referralChangeHandler = _this.referralChangeHandler.bind(_this);
    _this.deleteUserContactEmail = _this.deleteUserContactEmail.bind(_this);
    _this.deleteUserContactPhone = _this.deleteUserContactPhone.bind(_this);
    _this.deleteUserContactAddress = _this.deleteUserContactAddress.bind(_this);
    return _this;
  }

  _createClass(CreateEvent, [{
    key: 'toggleAvailabilityView',
    value: function toggleAvailabilityView() {
      this.setState({
        availabilityView: this.state.availabilityView === 'date' ? 'time' : 'date'
      });
      return false;
    }
  }, {
    key: 'updateSelectedDay',
    value: function updateSelectedDay(date) {
      this.setState({ selectedDay: date });
    }
  }, {
    key: 'addEventSegment',
    value: function addEventSegment(e) {
      e.preventDefault();
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      if (!this.state.newEventSegment) {
        obj.newEventSegment = {
          id: this.generateKey(),
          all_day: true,
          title: '',
          start_at: '',
          end_at: '',
          time_zone: this.props.viewer.s_time_zone,
          location: '',
          room: '',
          notes: ''
        };
      }
      obj.editingNewEventSegment = true;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewEventSegmentEditor',
    value: function closeNewEventSegmentEditor() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewEventSegment = false;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'createEventSegment',
    value: function createEventSegment(index, successCb) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var eventSegment = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.newEventSegment);
      eventSegment.title = eventSegment.title ? eventSegment.title : '(Untitled Agenda Item)';
      obj.event.user_event_segments.push(eventSegment);
      obj.cachedEventSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(obj.event.user_event_segments);
      obj.newEventSegment = undefined;
      this.setState(_extends({}, obj), successCb);
    }
  }, {
    key: 'deleteEventSegment',
    value: function deleteEventSegment(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.user_event_segments.splice(idx, 1);
      obj.cachedEventSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(obj.event.user_event_segments);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'eventChangeHandler',
    value: function eventChangeHandler(e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;

      var newValue = {};
      newValue[name] = value;
      this.setState({ event: Object.assign(this.state.event, newValue) });
    }
  }, {
    key: 'referralChangeHandler',
    value: function referralChangeHandler(e, data) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.referral_source = data.value;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'contactChangeHandler',
    value: function contactChangeHandler(contact) {
      var obj = this.state;
      obj.event.contacts[0] = contact;
      this.setState(obj);
    }
  }, {
    key: 'eventSegmentChangeHandler',
    value: function eventSegmentChangeHandler(eventSegment, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.cachedEventSegments[idx] = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newEventSegmentChangeHandler',
    value: function newEventSegmentChangeHandler(eventSegment) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newEventSegment = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'saveEventSegment',
    value: function saveEventSegment(idx, successCb) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var eventSegment = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(obj.cachedEventSegments[idx]);
      eventSegment.title = eventSegment.title ? eventSegment.title : '(Untitled Agenda Item)';
      obj.event.user_event_segments[idx] = eventSegment;
      this.setState(_extends({}, obj), successCb);
    }
  }, {
    key: 'resetAddEventSegment',
    value: function resetAddEventSegment() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newEventSegment = undefined;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'resetEditEventSegment',
    value: function resetEditEventSegment(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.cachedEventSegments[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(obj.event.user_event_segments[idx]);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'deleteUserContactEmail',
    value: function deleteUserContactEmail(contactIdx, emailIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.contacts[contactIdx].node.user_contact_emails.edges.splice(emailIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteUserContactPhone',
    value: function deleteUserContactPhone(contactIdx, phoneIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.contacts[contactIdx].node.user_contact_phones.edges.splice(phoneIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteUserContactAddress',
    value: function deleteUserContactAddress(contactIdx, addressIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.contacts[contactIdx].node.user_contact_addresses.edges.splice(addressIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'createEvent',
    value: function createEvent(e) {
      var _this2 = this;

      e.preventDefault();
      this.setState({
        submissionAttempts: this.state.submissionAttempts + 1,
        submitting: true
      });
      var onError = function onError() {
        _this2.setState({ submitting: false });
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create event',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        _this2.props.router.push('/events/' + response.createEventForm.event.id);
        __WEBPACK_IMPORTED_MODULE_9__Modules__["c" /* Analytics */].trackEvent('created-event', {
          event_id: atob(response.createEventForm.event.id).match(/(\d+)/)[0]
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3261);
      });

      var environment = this.props.relay.environment;

      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_utils_nullifyEmptyStrings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.event));
      event.title = event.title ? event.title : '(Untitled Event)';
      event.user_event_segments = event.user_event_segments.map(function (segment) {
        var modifiedSegment = __WEBPACK_IMPORTED_MODULE_14__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(segment);
        delete modifiedSegment.all_day;
        delete modifiedSegment.id;
        return modifiedSegment;
      });

      if (!(event.contacts[0].node.first_name || event.contacts[0].node.last_name || event.contacts[0].node.user_contact_emails.edges.length !== 0 || event.contacts[0].node.user_contact_phones.edges.length !== 0 || event.contacts[0].node.user_contact_addresses.edges.length !== 0 || event.contacts[0].role)) {
        delete event.contacts;
      } else {
        var _event$contacts$0$nod = event.contacts[0].node,
            first_name = _event$contacts$0$nod.first_name,
            last_name = _event$contacts$0$nod.last_name;

        var phones = event.contacts[0].node.user_contact_phones.edges.map(function (userContactPhone) {
          var number = userContactPhone.node.number;
          var reformattedNumber = number ? number.replace(/\D/g, '') : null;
          return {
            label: userContactPhone.node.label,
            number: reformattedNumber === '' ? null : reformattedNumber
          };
        });
        var emails = event.contacts[0].node.user_contact_emails.edges.map(function (userContactEmail) {
          return {
            label: userContactEmail.node.label,
            address: userContactEmail.node.address
          };
        });
        var addresses = event.contacts[0].node.user_contact_addresses.edges.map(function (userContactAddress) {
          return {
            label: userContactAddress.node.label,
            line1: userContactAddress.node.line1,
            line2: userContactAddress.node.line2,
            city: userContactAddress.node.city,
            province: userContactAddress.node.province,
            postal_code: userContactAddress.node.postal_code,
            country: userContactAddress.node.country
          };
        });
        event.contacts = [{
          first_name: first_name,
          last_name: last_name,
          phones: phones,
          emails: emails,
          addresses: addresses,
          role: event.contacts[0].role
        }];
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, event, {
            user_id: this.props.viewer.id
          })
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'generateKey',
    value: function generateKey() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var event = this.state.event;
      var _props = this.props,
          router = _props.router,
          viewer = _props.viewer;

      var submitted = this.state.submissionAttempts > 0;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__App_MobileHeader__["a" /* default */],
          { router: router, viewer: viewer },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
              { as: 'a', onClick: router.go.bind(null, -1) },
              'Cancel'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                onClick: this.state.submitting ? function () {} : this.createEvent
              },
              !this.state.submitting && 'Save',
              this.state.submitting && 'Saving...'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["s" /* Container */],
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
            { style: { marginTop: '2em' } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
                { stackable: true, padded: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                  null,
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 11, floated: 'left' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
                      null,
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["e" /* FloatingLabelInput */], {
                        autoFocus: true,
                        placeholder: '(Untitled Event)',
                        name: 'title',
                        value: event.title,
                        onChange: this.eventChangeHandler,
                        fluid: true,
                        submitted: submitted,
                        autoHeight: true,
                        inputRef: function inputRef(e) {
                          var element = e;
                          if (element) {
                            element.className = __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.title;
                          }
                        }
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      width: 5,
                      floated: 'right',
                      textAlign: 'right',
                      only: 'computer'
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'a',
                      {
                        className: __WEBPACK_IMPORTED_MODULE_6__EventCreate_scss___default.a.cancel,
                        onClick: router.go.bind(null, -1)
                      },
                      'Cancel'
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                      onClick: this.createEvent,
                      disabled: this.state.submitting,
                      primary: true,
                      content: this.state.submitting ? 'Saving...' : 'Save Event'
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row, null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                  { columns: 'equal' },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'h3',
                      null,
                      'Notes'
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
                      { className: 'ui form field ' + __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.notepad },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["i" /* TextArea */], {
                        name: 'notes',
                        rows: 18,
                        value: event.notes,
                        onChange: this.eventChangeHandler,
                        submitted: submitted
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'h3',
                      null,
                      'Contact Information'
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { style: { paddingLeft: '1em' } },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Show_ContactFields__["a" /* default */], {
                        localContact: this.state.event.contacts[0],
                        onChange: this.contactChangeHandler,
                        submissionAttempts: this.state.submissionAttempts,
                        hideActions: true,
                        index: 0,
                        isNew: true,
                        reset: function reset() {},
                        deleteUserContactEmail: this.deleteUserContactEmail,
                        deleteUserContactPhone: this.deleteUserContactPhone,
                        deleteUserContactAddress: this.deleteUserContactAddress
                      }),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing }),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_formsy_react___default.a.Form,
                        null,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Show_ReferralSource__["a" /* default */], {
                          onChange: this.referralChangeHandler,
                          value: event.referral_source,
                          pastReferralSources: viewer.past_referral_sources,
                          label: 'Referral Source'
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'h3',
                      null,
                      'Event Schedule'
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing },
                      event.user_event_segments.length === 0 && !this.state.editingNewEventSegment && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { style: { padding: '2em 0' } },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          'h4',
                          null,
                          'This event has no agenda items'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
                          {
                            className: 'basic',
                            onClick: this.addEventSegment
                          },
                          '+ Add Time and Place'
                        )
                      ),
                      event.user_event_segments.map(function (eventSegment, idx) {
                        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          'div',
                          { className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing, key: idx },
                          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9__Modules__["k" /* Dthc */],
                            {
                              eventSegment: eventSegment,
                              localEventSegment: _this3.state.cachedEventSegments[idx],
                              onChange: function onChange(segment) {
                                _this3.eventSegmentChangeHandler(segment, idx);
                              },
                              commitUpdate: _this3.saveEventSegment,
                              desktop: __WEBPACK_IMPORTED_MODULE_18__EventSegment_EventSegmentDesktop__["a" /* default */],
                              mobile: __WEBPACK_IMPORTED_MODULE_17__EventSegment_EventSegmentMobile__["a" /* default */],
                              index: idx,
                              viewer: viewer,
                              'delete': _this3.deleteEventSegment,
                              reset: _this3.resetEditEventSegment,
                              submissionAttempts: _this3.state.submissionAttempts
                            },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EventSegment_EventSegmentShow__["a" /* default */], {
                              eventSegment: eventSegment,
                              compact: true
                            })
                          )
                        );
                      }),
                      this.state.newEventSegment && this.state.editingNewEventSegment && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_9__Modules__["k" /* Dthc */],
                          {
                            eventSegment: this.state.newEventSegment,
                            localEventSegment: this.state.newEventSegment,
                            onChange: function onChange(segment) {
                              _this3.newEventSegmentChangeHandler(segment);
                            },
                            commitUpdate: this.createEventSegment,
                            desktop: __WEBPACK_IMPORTED_MODULE_18__EventSegment_EventSegmentDesktop__["a" /* default */],
                            mobile: __WEBPACK_IMPORTED_MODULE_17__EventSegment_EventSegmentMobile__["a" /* default */],
                            'delete': this.resetAddEventSegment,
                            reset: this.resetAddEventSegment,
                            initiallyOpen: true,
                            isNew: true,
                            viewer: viewer,
                            disableOnClickOutside: event.user_event_segments.length === 0,
                            closeEditor: this.closeNewEventSegmentEditor,
                            editorOpen: this.state.editingNewEventSegment,
                            submissionAttempts: this.state.submissionAttempts
                          },
                          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EventSegment_EventSegmentShow__["a" /* default */], {
                            eventSegment: this.state.newEventSegment
                          })
                        )
                      )
                    ),
                    event.user_event_segments.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
                        {
                          className: 'basic',
                          onClick: this.addEventSegment
                        },
                        '+ Add Time and Place'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CreateEvent;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__App_Authenticate__["a" /* default */])(CreateEventComponent)));

/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules_AvailabilityChecker_AvailabilityDetails__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_big_calendar_lib_css_react_big_calendar_css__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_big_calendar_lib_css_react_big_calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_big_calendar_lib_css_react_big_calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_bigCalendar__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils_events__ = __webpack_require__(826);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var EventCalendar = (_temp = _class = function (_React$Component) {
  _inherits(EventCalendar, _React$Component);

  function EventCalendar(props) {
    _classCallCheck(this, EventCalendar);

    var _this = _possibleConstructorReturn(this, (EventCalendar.__proto__ || Object.getPrototypeOf(EventCalendar)).call(this, props));

    _this.toggleSearch = _this.toggleSearch.bind(_this);
    _this.closeSearchHandler = _this.closeSearchHandler.bind(_this);
    _this.selectEvent = _this.selectEvent.bind(_this);
    _this.openAvailabilityChecker = _this.openAvailabilityChecker.bind(_this);
    _this.closeAvailabilityChecker = _this.closeAvailabilityChecker.bind(_this);
    _this.openAvailabilityDetails = _this.openAvailabilityDetails.bind(_this);
    _this.closeAvailabilityDetails = _this.closeAvailabilityDetails.bind(_this);
    _this.updateSelectedDay = _this.updateSelectedDay.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onSuccessfulCopy = _this.onSuccessfulCopy.bind(_this);
    _this.getCalUrl = _this.getCalUrl.bind(_this);
    _this.closeSyncInstructions = _this.closeSyncInstructions.bind(_this);
    _this.openSyncInstructions = _this.openSyncInstructions.bind(_this);
    _this.updateCalendarView = _this.updateCalendarView.bind(_this);
    _this.onNavigate = _this.onNavigate.bind(_this);
    _this.onViewChange = _this.onViewChange.bind(_this);
    _this.setQuery = _this.setQuery.bind(_this);
    _this.getSelectedDay = _this.getSelectedDay.bind(_this);

    _this.state = {
      showSearch: false,
      showAvailabilityChecker: false,
      showAvailabilityDetails: false,
      eventsOnDay: [],
      syncInstructionsOpen: false,
      eventsByDate: {},
      flattenedEventSegments: []
    };
    return _this;
  }

  _createClass(EventCalendar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.props.relay.refetch(function (fragmentVariables) {
        return Object.assign({}, fragmentVariables, {
          afterTime: __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this2.getSelectedDay()).startOf('month').subtract(1, 'month').toISOString(),
          beforeTime: __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this2.getSelectedDay()).startOf('month').add(1, 'month').toISOString(),
          returnEmptyConnection: false
        });
      });
      var userEvents = this.props.viewer ? this.props.viewer.EventCalendar_user_events.edges : [];
      this.setState({
        flattenedEventSegments: __WEBPACK_IMPORTED_MODULE_10__lib_utils_bigCalendar__["a" /* default */].getFlattenedEventSegments(userEvents)
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var userEvents = nextProps.viewer ? nextProps.viewer.EventCalendar_user_events.edges : [];
      this.setState({
        flattenedEventSegments: __WEBPACK_IMPORTED_MODULE_10__lib_utils_bigCalendar__["a" /* default */].getFlattenedEventSegments(userEvents)
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('viewed-calendar');
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      e.target.select();
    }
  }, {
    key: 'onSuccessfulCopy',
    value: function onSuccessfulCopy() {
      __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
        message: 'Successfully copied calendar URL',
        intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
      });
    }
  }, {
    key: 'getCalUrl',
    value: function getCalUrl(status) {
      return "https://www.cloverbook.com" + '/calendars/' + this.props.viewer.calendar_token + '/' + status + '.ics';
    }
  }, {
    key: 'getSelectedDay',
    value: function getSelectedDay() {
      var selectedDay = this.props.location.query.selectedDay;

      return selectedDay ? new Date(selectedDay) : new Date();
    }
  }, {
    key: 'setQuery',
    value: function setQuery(key, value) {
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      query[key] = value;
      this.props.router.replace({ pathname: pathname, query: query });
    }
  }, {
    key: 'openAvailabilityChecker',
    value: function openAvailabilityChecker() {
      this.setState({ showAvailabilityChecker: true });
    }
  }, {
    key: 'closeAvailabilityChecker',
    value: function closeAvailabilityChecker() {
      this.setState({ showAvailabilityChecker: false });
    }
  }, {
    key: 'openAvailabilityDetails',
    value: function openAvailabilityDetails(props) {
      this.setState(_extends({
        showAvailabilityChecker: this.props.mobile,
        showAvailabilityDetails: true
      }, props));
    }
  }, {
    key: 'closeAvailabilityDetails',
    value: function closeAvailabilityDetails() {
      this.setState({ showAvailabilityDetails: false });
    }
  }, {
    key: 'updateSelectedDay',
    value: function updateSelectedDay(selectedDay) {
      this.setQuery('selectedDay', selectedDay.toISOString());
      this.setState({
        eventsOnDay: __WEBPACK_IMPORTED_MODULE_11__lib_utils_events__["a" /* default */].groupEventsByDate(this.props.viewer.EventCalendar_user_events.edges, selectedDay, this.props.viewer.s_time_zone)[selectedDay.getDate()]
      });
      // If within a month of range, make a new request
      this.props.relay.refetch(function (fragmentVariables) {
        return Object.assign({}, fragmentVariables, {
          afterTime: __WEBPACK_IMPORTED_MODULE_7_moment___default()(selectedDay).startOf('month').subtract(1, 'month').toISOString(),
          beforeTime: __WEBPACK_IMPORTED_MODULE_7_moment___default()(selectedDay).startOf('month').add(1, 'month').toISOString(),
          returnEmptyConnection: false
        });
      });
    }
  }, {
    key: 'updateCalendarView',
    value: function updateCalendarView(calendarView) {
      this.setQuery('calendarView', calendarView);
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ showSearch: !this.state.showSearch });
    }
  }, {
    key: 'closeSearchHandler',
    value: function closeSearchHandler() {
      this.setState({ showSearch: false });
    }
  }, {
    key: 'selectEvent',
    value: function selectEvent(event) {
      this.props.router.push('/events/' + event.id);
    }
  }, {
    key: 'closeSyncInstructions',
    value: function closeSyncInstructions() {
      this.setState({ syncInstructionsOpen: false });
    }
  }, {
    key: 'openSyncInstructions',
    value: function openSyncInstructions() {
      this.setState({ syncInstructionsOpen: true });
    }
  }, {
    key: 'onNavigate',
    value: function onNavigate(date) {
      this.updateSelectedDay(date);
    }
  }, {
    key: 'onViewChange',
    value: function onViewChange(view) {
      this.updateCalendarView(view);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var Event = function Event(_ref) {
        var event = _ref.event;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Popup */], {
          trigger: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'strong',
              null,
              event.title
            )
          ),
          on: 'hover',
          inverted: true,
          content: event.title
        });
      };

      var events = this.state.flattenedEventSegments;

      var copyButton = function copyButton(status) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js___default.a,
          {
            'option-text': _this3.getCalUrl.bind(null, status),
            onSuccess: _this3.onSuccessfulCopy,
            className: 'ui right icon button button'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            'Copy \xA0',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' })
          )
        );
      };

      var CalendarHeader = function CalendarHeader(_ref2) {
        var view = _ref2.view,
            label = _ref2.label;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { style: { marginTop: '1em', marginBottom: '1em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { columns: 'equal' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,
                { basic: true, size: 'small' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  content: 'Day',
                  active: view === 'day',
                  onClick: _this3.updateCalendarView.bind(null, 'day')
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  content: 'Week',
                  active: view === 'week',
                  onClick: _this3.updateCalendarView.bind(null, 'week')
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  content: 'Month',
                  active: view === 'month',
                  onClick: _this3.updateCalendarView.bind(null, 'month')
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { textAlign: 'center' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                label
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { textAlign: 'right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,
                { basic: true, size: 'small', style: { marginLeft: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  icon: 'chevron left',
                  onClick: _this3.updateSelectedDay.bind(null, __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this3.getSelectedDay()).subtract(1, view).toDate())
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  content: 'Today',
                  onClick: _this3.updateSelectedDay.bind(null, new Date())
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  icon: 'chevron right',
                  onClick: _this3.updateSelectedDay.bind(null, __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this3.getSelectedDay()).add(1, view).toDate())
                })
              )
            )
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { width: '100%' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { stackable: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.desktop },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["h" /* BigCalendarInTimeZone */], {
                    events: events,
                    step: 60,
                    timeslots: 2,
                    defaultView: 'month',
                    showMultiDayTimes: true,
                    view: this.props.location.query.calendarView || 'month',
                    defaultDate: new Date(),
                    timeZone: this.props.viewer.s_time_zone,
                    date: this.getSelectedDay(),
                    eventPropGetter: __WEBPACK_IMPORTED_MODULE_10__lib_utils_bigCalendar__["a" /* default */].eventPropGetter,
                    style: { minHeight: '600px' },
                    components: {
                      event: Event,
                      toolbar: CalendarHeader
                    },
                    formats: {
                      timeGutterFormat: 'h A',
                      dayFormat: 'ddd M/D',
                      dayHeaderFormat: 'dddd MMM D, Y',
                      dayRangeHeaderFormat: function dayRangeHeaderFormat(_ref3, culture, local) {
                        var start = _ref3.start,
                            end = _ref3.end;
                        return '' + local.format(start, 'MMMM D', culture) + (__WEBPACK_IMPORTED_MODULE_7_moment___default()(start).isSame(end, 'year') ? '' : local.format(start, ', Y', culture)) + ' -\n                        ' + local.format(end, __WEBPACK_IMPORTED_MODULE_7_moment___default()(start).isSame(end, 'month') ? 'D' : 'MMMM D', culture) + ',\n                        ' + local.format(end, 'Y', culture);
                      }
                    },
                    onSelectEvent: this.selectEvent,
                    onNavigate: this.onNavigate,
                    onView: this.onViewChange,
                    views: ['month', 'week', 'day']
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.mobile },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["g" /* AvailabilityCalendar */], {
                    initialMonth: this.getSelectedDay(),
                    selectedDay: this.getSelectedDay(),
                    onDayClick: function onDayClick() {},
                    updateSelectedDay: this.updateSelectedDay,
                    viewer: this.props.viewer,
                    close: this.closeAvailabilityChecker,
                    openAvailabilityDetails: this.openAvailabilityDetails,
                    showDetails: true,
                    mobile: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modules_AvailabilityChecker_AvailabilityDetails__["a" /* default */], {
                    isOpen: this.state.showAvailabilityDetails,
                    close: this.closeAvailabilityDetails,
                    eventsOnDay: this.state.eventsOnDay,
                    updateSelectedDay: this.updateSelectedDay,
                    selectedDay: this.getSelectedDay(),
                    viewer: this.props.viewer
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */],
                {
                  trigger: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { onClick: this.openSyncInstructions },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                      basic: true,
                      icon: 'refresh',
                      content: 'Sync Calendar to Other Devices'
                    })
                  ),
                  open: this.state.syncInstructionsOpen,
                  onClose: this.closeSyncInstructions
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Header */], { content: 'Syncing to Your Devices' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Content,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                    { columns: 'equal', stackable: true },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'h4',
                          null,
                          'You can sync Cloverbook events with all your devices. Here are some tutorials to help you get setup:'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'h3',
                          null,
                          'Apple'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://support.apple.com/en-us/HT202361',
                              target: 'blank'
                            },
                            'iCloud (All Apple Devices)'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://support.apple.com/kb/PH11523?viewlocale=en_US&locale=en_US',
                              target: 'blank'
                            },
                            'Mac'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://discussions.apple.com/thread/7759000?language=en',
                              target: 'blank'
                            },
                            'iPhone'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'h3',
                          null,
                          'Android'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DAndroid&oco=1',
                              target: 'blank'
                            },
                            'Android'
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'h3',
                          null,
                          'Other'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://support.office.com/en-us/article/Import-or-subscribe-to-a-calendar-in-Outlook-com-or-Outlook-on-the-web-CFF1429C-5AF6-41EC-A5B4-74F2C278E98C',
                              target: 'blank'
                            },
                            'Outlook'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                              href: 'https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DiOS&oco=1',
                              target: 'blank'
                            },
                            'Google Calendar'
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["v" /* Divider */], { section: true }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'h4',
                          null,
                          'Copy and paste the URLs below into your favorite calendar app to get the latest updates on any device.'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'strong',
                            null,
                            'Booked Events'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                          onFocus: this.onFocus,
                          value: this.getCalUrl('booked'),
                          action: copyButton('booked'),
                          onChange: function onChange() {}
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'strong',
                            null,
                            'Not Booked Events'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                          onFocus: this.onFocus,
                          value: this.getCalUrl('not_booked'),
                          action: copyButton('not_booked'),
                          onChange: function onChange() {}
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          null,
                          '*This is the private address for this calendar. Don\'t share this address with others unless you want them to see all the events on this calendar.'
                        )
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Actions,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
                    { onClick: this.closeSyncInstructions },
                    'Close'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventCalendar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  mobile: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_found__["withRouter"])(EventCalendar));

/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventCalendar__ = __webpack_require__(3264);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__EventCalendar__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3269);
  }
}, function () {
  return __webpack_require__(3270);
}));

/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(3274);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3272);
  }
}));

/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventCard__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_waypoint__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EventListComponent = (_temp = _class = function (_React$Component) {
  _inherits(EventList, _React$Component);

  function EventList(props) {
    _classCallCheck(this, EventList);

    var _this = _possibleConstructorReturn(this, (EventList.__proto__ || Object.getPrototypeOf(EventList)).call(this, props));

    _this.state = {
      listSize: 10,
      loading: false
    };
    _this.showHidden = _this.showHidden.bind(_this);
    _this.groupByMonth = _this.groupByMonth.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(EventList, [{
    key: 'showHidden',
    value: function showHidden(e) {
      var query = this.props.location.query;

      query.hidden = 'true';
      this.props.router.push({ pathname: '/', query: query });
      e.preventDefault();
    }
  }, {
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(5, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 5 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'groupByMonth',
    value: function groupByMonth(events) {
      var timeZone = this.props.viewer.s_time_zone;
      if (events.length > 0) {
        var currentMonth = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(events[0].node.start_at, timeZone).startOf('month');
        var groupedEvents = [[]];
        var sortBy = this.props.location.query.sortBy;
        var idx = 0;
        // Do not group events if viewing recent events
        if (sortBy === 'RECENT') {
          // Return array of flattened event nodes
          return [events.map(function (edge) {
            return edge.node;
          })];
        }
        events.map(function (edge) {
          var event = edge.node;
          if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(event.start_at, timeZone).isBetween(currentMonth, currentMonth.clone().add(1, 'months'), null, '[)')) {
            groupedEvents[idx].push(event);
          } else {
            groupedEvents.push([event]);
            currentMonth = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(event.start_at, timeZone).startOf('month');
            idx++;
          }
          return edge;
        });
        return groupedEvents;
      }
      return [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var timeZone = this.props.viewer.s_time_zone;
      var events = this.props.viewer.user_events.edges;
      var query = this.props.location.query;

      var sortBy = query.sortBy || 'UPCOMING';
      var status = query.status || 'ALL';
      var showDateLabel = sortBy !== 'RECENT';

      var sortByText = sortBy.toLowerCase();
      var groupedEvents = this.groupByMonth(events);
      var groupMargin = sortBy === 'RECENT' ? {} : { marginBottom: '3em' };
      var withBookingStatus = function (bookingStatus) {
        switch (bookingStatus) {
          case 'BOOKED':
            return ' that are booked';
          case 'INITIAL':
            return ' that are not booked';
          case 'CANCELED':
            return ' that are canceled';
          default:
            return '';
        }
      }(status);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { width: '100%' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            null,
            groupedEvents.map(function (group, groupIdx) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: groupIdx, style: groupMargin },
                sortBy !== 'RECENT' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h2',
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(group[0].start_at, timeZone).format('MMMM YYYY')
                ),
                group.map(function (event, idx) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EventCard__["a" /* default */], {
                    showDateLabel: showDateLabel,
                    event: event,
                    timeZone: timeZone,
                    key: idx,
                    index: idx,
                    link: true,
                    location: _this3.props.location,
                    listSize: _this3.state.listSize,
                    relay: _this3.props.relay
                  });
                })
              );
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center', padding: '2em' } },
              events.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h2',
                  null,
                  'You have no ' + sortByText + ' events' + withBookingStatus
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { padding: '2em' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_found__["Link"],
                    { to: '/events/new' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                      primary: true,
                      icon: 'plus',
                      labelPosition: 'left',
                      content: 'Create New Event'
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -200 }),
              this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginBottom: '2em' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* Loader */], {
                  active: true,
                  inline: true,
                  size: 'tiny',
                  style: { marginRight: '1em' }
                }),
                ' ',
                'Loading More...'
              ),
              query.hidden !== 'true' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'Excluding hidden events. \xA0',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    onClick: this.showHidden,
                    style: { borderBottom: '1px solid' },
                    href: ''
                  },
                  'Show all.'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EventList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  showFilters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  toggleFilters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(EventListComponent));

/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventList__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_EventListQuery__ = __webpack_require__(1491);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__EventList__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3273);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.user_events;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return {
      count: count,
      cursor: cursor,
      visibility: fragmentVariables.visibility,
      sortBy: fragmentVariables.sortBy,
      booking_status: fragmentVariables.booking_status
    };
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_EventListQuery__["a" /* default */]
}));

/***/ }),
/* 3269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventCalendarContainer_viewer$ref: FragmentReference;
export type EventCalendarContainer_viewer = {|
  +id: string,
  +calendar_token: ?string,
  +s_time_zone: ?string,
  +EventCalendar_user_events: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +all_day: ?boolean,
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventCalendarContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "EventCalendarContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "visibility",
      "type": "[UserEventVisibility]",
      "defaultValue": ["SHOW"]
    }, {
      "kind": "LocalArgument",
      "name": "booking_status",
      "type": "[BookingStatus]",
      "defaultValue": ["BOOKED", "INITIAL", "CANCELED"]
    }, {
      "kind": "LocalArgument",
      "name": "afterTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "beforeTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "returnEmptyConnection",
      "type": "Boolean",
      "defaultValue": true
    }],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "calendar_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": [{
        "kind": "Variable",
        "name": "booking_status",
        "variableName": "booking_status",
        "type": null
      }, {
        "kind": "Variable",
        "name": "return_empty_connection",
        "variableName": "returnEmptyConnection",
        "type": null
      }, {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility",
        "type": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "EventCalendar_user_events",
      "name": "user_events",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "afterTime",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "beforeTime",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "booking_status",
        "variableName": "booking_status",
        "type": "[BookingStatus]"
      }, {
        "kind": "Variable",
        "name": "return_empty_connection",
        "variableName": "returnEmptyConnection",
        "type": "Boolean"
      }, {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility",
        "type": "[UserEventVisibility]"
      }],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, v1]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 99999,
              "type": "Int"
            }],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '33b8cf2deec307774bb55a2831d9d415';
module.exports = node;

/***/ }),
/* 3270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0acbf32da1c304e5566399254a4cb371
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type EventCalendarContainer_viewer_RefetchQueryVariables = {|
  afterTime: any,
  beforeTime: any,
  booking_status?: ?$ReadOnlyArray<?BookingStatus>,
  returnEmptyConnection?: ?boolean,
  visibility?: ?$ReadOnlyArray<?UserEventVisibility>,
|};
export type EventCalendarContainer_viewer_RefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventCalendarContainer_viewer$ref
  |}
|};
export type EventCalendarContainer_viewer_RefetchQuery = {|
  variables: EventCalendarContainer_viewer_RefetchQueryVariables,
  response: EventCalendarContainer_viewer_RefetchQueryResponse,
|};
*/

/*
query EventCalendarContainer_viewer_RefetchQuery(
  $afterTime: ISO8601Type!
  $beforeTime: ISO8601Type!
  $booking_status: [BookingStatus]
  $returnEmptyConnection: Boolean
  $visibility: [UserEventVisibility]
) {
  viewer {
    ...EventCalendarContainer_viewer_RvbYK
    id
  }
}

fragment EventCalendarContainer_viewer_RvbYK on User {
  id
  calendar_token
  s_time_zone
  ...AvailabilityCalendarContainer_viewer_2L92PV
  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        user_event_segments(first: 99999) {
          edges {
            node {
              all_day
              title
              start_at
              end_at
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer_2L92PV on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "afterTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "beforeTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "booking_status",
    "type": "[BookingStatus]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "returnEmptyConnection",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "visibility",
    "type": "[UserEventVisibility]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "Variable",
    "name": "booking_status",
    "variableName": "booking_status",
    "type": "[BookingStatus]"
  },
      v3 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v4 = {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility",
    "type": "[UserEventVisibility]"
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "event",
    "storageKey": null,
    "args": null,
    "concreteType": "Event",
    "plural": false,
    "selections": [v1, v5]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v10 = [v3],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventCalendarContainer_viewer_RefetchQuery",
    "id": null,
    "text": "query EventCalendarContainer_viewer_RefetchQuery(\n  $afterTime: ISO8601Type!\n  $beforeTime: ISO8601Type!\n  $booking_status: [BookingStatus]\n  $returnEmptyConnection: Boolean\n  $visibility: [UserEventVisibility]\n) {\n  viewer {\n    ...EventCalendarContainer_viewer_RvbYK\n    id\n  }\n}\n\nfragment EventCalendarContainer_viewer_RvbYK on User {\n  id\n  calendar_token\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer_2L92PV\n  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              all_day\n              title\n              start_at\n              end_at\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer_2L92PV on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventCalendarContainer_viewer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventCalendarContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "afterTime",
            "variableName": "afterTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "beforeTime",
            "variableName": "beforeTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "booking_status",
            "variableName": "booking_status",
            "type": null
          }, {
            "kind": "Variable",
            "name": "returnEmptyConnection",
            "variableName": "returnEmptyConnection",
            "type": null
          }, {
            "kind": "Variable",
            "name": "visibility",
            "variableName": "visibility",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventCalendarContainer_viewer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "calendar_token",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [v2, v3, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, v4],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [v6, v7, v8, v9, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v10,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v5, v8, v9, v11, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }, v1]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": "EventCalendar_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "after_time",
            "variableName": "afterTime",
            "type": "ISO8601Type"
          }, {
            "kind": "Variable",
            "name": "before_time",
            "variableName": "beforeTime",
            "type": "ISO8601Type"
          }, v2, {
            "kind": "Variable",
            "name": "return_empty_connection",
            "variableName": "returnEmptyConnection",
            "type": "Boolean"
          }, v4],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [v6, v7, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v10,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v11, v5, v8, v9, v1]
                  }]
                }]
              }, v1]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b463e9b5b6542ed0fe1c8c315a0319aa';
module.exports = node;

/***/ }),
/* 3271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 30c7e790794b666e8b64718e4c46da81
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type UpdateUserEventInput = {
  clientMutationId?: ?string,
  id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
};
export type EventCard_UpdateUserEventMutationVariables = {|
  input: UpdateUserEventInput
|};
export type EventCard_UpdateUserEventMutationResponse = {|
  +updateUserEvent: ?{|
    +user_event: ?{|
      +id: string,
      +start_at: ?any,
      +end_at: ?any,
      +booking_status: ?BookingStatus,
      +event: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
      |},
      +visibility: ?UserEventVisibility,
    |}
  |}
|};
export type EventCard_UpdateUserEventMutation = {|
  variables: EventCard_UpdateUserEventMutationVariables,
  response: EventCard_UpdateUserEventMutationResponse,
|};
*/

/*
mutation EventCard_UpdateUserEventMutation(
  $input: UpdateUserEventInput!
) {
  updateUserEvent(input: $input) {
    user_event {
      id
      start_at
      end_at
      booking_status
      event {
        id
        title
        start_at
        end_at
      }
      visibility
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v4 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserEventInput!"
    }],
    "concreteType": "UpdateUserEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [v1, v2, v3, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, v2, v3]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "visibility",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "EventCard_UpdateUserEventMutation",
    "id": null,
    "text": "mutation EventCard_UpdateUserEventMutation(\n  $input: UpdateUserEventInput!\n) {\n  updateUserEvent(input: $input) {\n    user_event {\n      id\n      start_at\n      end_at\n      booking_status\n      event {\n        id\n        title\n        start_at\n        end_at\n      }\n      visibility\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventCard_UpdateUserEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v4
    },
    "operation": {
      "kind": "Operation",
      "name": "EventCard_UpdateUserEventMutation",
      "argumentDefinitions": v0,
      "selections": v4
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2163c2753bd35d59dbc3511b6b2281da';
module.exports = node;

/***/ }),
/* 3272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventIndexContainer_viewer$ref: FragmentReference;
export type EventIndexContainer_viewer = {|
  +id: string,
  +needs_square_scopes: ?boolean,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: EventIndexContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "EventIndexContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "needs_square_scopes",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '831f5f1a9d5e24566f382daa143e2449';
module.exports = node;

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventListContainer_viewer$ref: FragmentReference;
export type EventListContainer_viewer = {|
  +id: string,
  +s_time_zone: ?string,
  +user_events: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +title: ?string,
          +start_at: ?any,
          +end_at: ?any,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +visibility: ?UserEventVisibility,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +location: ?string,
              +room: ?string,
            |}
          |}>
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: EventListContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "EventListContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["user_events"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    }, {
      "kind": "RootArgument",
      "name": "cursor",
      "type": "String"
    }, {
      "kind": "RootArgument",
      "name": "visibility",
      "type": "[UserEventVisibility]"
    }, {
      "kind": "RootArgument",
      "name": "sortBy",
      "type": "EventFilterAndSort"
    }, {
      "kind": "RootArgument",
      "name": "booking_status",
      "type": "[BookingStatus]"
    }],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "user_events",
      "name": "__EventList_user_events_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "booking_status",
        "variableName": "booking_status",
        "type": "[BookingStatus]"
      }, {
        "kind": "Variable",
        "name": "filter_and_sort",
        "variableName": "sortBy",
        "type": "EventFilterAndSort"
      }, {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility",
        "type": "[UserEventVisibility]"
      }],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v0, {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }, v1, v2]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          }, v1, v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "visibility",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 99999,
              "type": "Int"
            }],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '4db8d33ef370531cefab776f53b92b88';
module.exports = node;

/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventList_scss__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EventList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lib_stylesheets_ExpandCollapseTransition_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var EventIndexComponent = (_temp = _class = function (_React$Component) {
  _inherits(EventIndex, _React$Component);

  function EventIndex(props) {
    _classCallCheck(this, EventIndex);

    var _this = _possibleConstructorReturn(this, (EventIndex.__proto__ || Object.getPrototypeOf(EventIndex)).call(this, props));

    _this.state = {
      showFilters: false
    };
    _this.handleHidden = _this.handleHidden.bind(_this);
    _this.statusChange = _this.statusChange.bind(_this);
    _this.statusChangeMobile = _this.statusChangeMobile.bind(_this);
    _this.toggleFilters = _this.toggleFilters.bind(_this);
    _this.handleSortByDropdownChange = _this.handleSortByDropdownChange.bind(_this);
    _this.changeView = _this.changeView.bind(_this);
    return _this;
  }

  _createClass(EventIndex, [{
    key: 'setQuery',
    value: function setQuery(key, value) {
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      query[key] = value;
      this.props.router.replace({ pathname: pathname, query: query });
    }
  }, {
    key: 'handleHidden',
    value: function handleHidden(e, props) {
      this.setQuery('hidden', props.checked ? 'true' : 'false');
    }
  }, {
    key: 'sortBy',
    value: function sortBy(filter) {
      this.setQuery('sortBy', filter);
    }
  }, {
    key: 'handleSortByDropdownChange',
    value: function handleSortByDropdownChange(e, selection) {
      this.setQuery('sortBy', selection.value);
    }
  }, {
    key: 'statusChangeMobile',
    value: function statusChangeMobile(e) {
      this.setQuery('status', e.target.value);
    }
  }, {
    key: 'statusChange',
    value: function statusChange(e, input) {
      this.setQuery('status', input.value);
    }
  }, {
    key: 'toggleFilters',
    value: function toggleFilters() {
      this.setState({ showFilters: !this.state.showFilters });
    }
  }, {
    key: 'changeView',
    value: function changeView(pathname) {
      var query = this.props.location.query;

      if (pathname === '/calendar') query.sortBy = 'RECENT';
      this.props.router.push({ pathname: pathname, query: query });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$location2 = this.props.location,
          query = _props$location2.query,
          pathname = _props$location2.pathname;
      var _props = this.props,
          children = _props.children,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      var hiddenHelp = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'help circle', className: __WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.borderGrey });

      var bookingStatusMappings = {
        ALL: 'All',
        BOOKED: 'Booked',
        INITIAL: 'Not Booked',
        CANCELED: 'Canceled'
      };

      var bookingStatusOptions = [{ text: bookingStatusMappings.ALL, value: 'ALL' }, { text: bookingStatusMappings.BOOKED, value: 'BOOKED' }, { text: bookingStatusMappings.INITIAL, value: 'INITIAL' }, { text: bookingStatusMappings.CANCELED, value: 'CANCELED' }];

      var sortByButtons = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,
        { basic: true, size: 'small' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
          {
            onClick: this.sortBy.bind(this, 'RECENT'),
            active: query.sortBy === 'RECENT'
          },
          'All'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
          {
            onClick: this.sortBy.bind(this, 'UPCOMING'),
            active: query.sortBy === 'UPCOMING' || !query.sortBy
          },
          'Upcoming'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
          {
            onClick: this.sortBy.bind(this, 'PAST'),
            active: query.sortBy === 'PAST'
          },
          'Past'
        )
      );

      var sortByOptions = [{ text: 'All Events', value: 'RECENT' }, { text: 'Upcoming Events', value: 'UPCOMING' }, { text: 'Past Events', value: 'PAST' }];

      var viewPicker = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,
        { basic: true, size: 'small' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
          icon: 'list',
          active: pathname === '/',
          onClick: this.changeView.bind(null, '/')
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
          icon: 'calendar alternate outline',
          active: pathname === '/calendar',
          onClick: this.changeView.bind(null, '/calendar')
        })
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__EventList_scss___default.a.scrollContainer },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__App_MobileHeader__["a" /* default */],
          {
            viewer: viewer,
            router: router
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                className: sidebarOpen ? 'active ' : '',
                onClick: toggleSidebar
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["C" /* Item */],
              { as: 'a', onClick: router.push.bind(null, '/search') },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'search' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["C" /* Item */],
              { as: __WEBPACK_IMPORTED_MODULE_4_found__["Link"], to: '/events/new' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'add' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
          { container: true, verticalAlign: 'middle' },
          this.props.viewer.needs_square_scopes && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["B" /* Message */],
                { negative: true },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["B" /* Message */].Header,
                  null,
                  'Please login to your Square account'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'We have made some updates to our Square integration. In order to continue accepting credit card payments, you must log into your Square account by ',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'strong',
                    null,
                    'March 19th, 2021,'
                  ),
                  ' and reauthorize Cloverbook.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], { color: 'blue', content: 'Connect with Square', onClick: function onClick() {
                    window.location = '/auth/square';
                  } })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { only: 'computer', style: { padding: '2em 0' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 5 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                viewPicker,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { paddingLeft: '2em' } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
                    onChange: this.handleHidden,
                    checked: query.hidden === 'true',
                    label: 'Include Archived'
                  }),
                  '\xA0',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Popup */], {
                    trigger: hiddenHelp,
                    on: 'hover',
                    position: 'right center',
                    inverted: true,
                    content: 'This includes events you may have hidden by archiving'
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 6, textAlign: 'center' },
              pathname === '/' && sortByButtons
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              { width: 5, textAlign: 'right' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { paddingRight: '1em' } },
                'Booking Status:'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */], {
                style: { minWidth: '8em' },
                selection: true,
                options: bookingStatusOptions,
                name: 'status',
                value: query.status || 'ALL',
                text: bookingStatusMappings[query.status],
                onChange: this.statusChange
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
            { only: 'tablet mobile', style: { paddingBottom: '2em' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { display: 'table' } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        {
                          style: { display: 'table-cell', paddingRight: '1em' }
                        },
                        viewPicker
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: 'table-cell', width: '100%' } },
                        pathname === '/' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */], {
                          selection: true,
                          button: true,
                          basic: true,
                          fluid: true,
                          onChange: this.handleSortByDropdownChange,
                          options: sortByOptions,
                          value: query.sortBy || 'UPCOMING'
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        {
                          style: { display: 'table-cell', paddingLeft: '1em' }
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,
                          { basic: true },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
                            {
                              active: this.state.showFilters,
                              onClick: this.toggleFilters,
                              style: {
                                padding: '0.78571429em'
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], {
                              name: 'filter',
                              className: [__WEBPACK_IMPORTED_MODULE_7__EventList_scss___default.a.filter, query.status && query.status !== 'ALL' || query.hidden === 'true' ? __WEBPACK_IMPORTED_MODULE_7__EventList_scss___default.a.filterActive : ''].join(' ')
                            })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_addons_css_transition_group___default.a,
                {
                  transitionName: 'background',
                  transitionEnterTimeout: 500,
                  transitionLeaveTimeout: 500
                },
                this.state.showFilters && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: 'mobileFilters' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_7__EventList_scss___default.a.mobileFilters },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */],
                      { columns: 'equal', verticalAlign: 'middle' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                          { textAlign: 'left' },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            'Booking Status'
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'select',
                            {
                              value: query.status || 'ALL',
                              style: { minWidth: '8em' },
                              name: 'status',
                              className: 'ui selection dropdown',
                              onChange: this.statusChangeMobile
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'option',
                              { value: 'ALL' },
                              'All'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'option',
                              { value: 'BOOKED' },
                              'Booked'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'option',
                              { value: 'INITIAL' },
                              'Not Booked'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Grid */].Column,
                          { textAlign: 'right' },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            'Include Archived'
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], {
                            toggle: true,
                            onChange: this.handleHidden,
                            checked: query.hidden === 'true'
                          })
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
            toggleFilters: this.toggleFilters,
            showFilters: this.state.showFilters,
            toggleSidebar: toggleSidebar,
            sidebarOpen: sidebarOpen
          })
        )
      );
    }
  }]);

  return EventIndex;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__App_Authenticate__["a" /* default */])(EventIndexComponent)));

/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListTitleInput__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pipelines_scss__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pipelines_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pipelines_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PipelineListTitle = function (_React$Component) {
  _inherits(PipelineListTitle, _React$Component);

  function PipelineListTitle(props) {
    _classCallCheck(this, PipelineListTitle);

    var _this = _possibleConstructorReturn(this, (PipelineListTitle.__proto__ || Object.getPrototypeOf(PipelineListTitle)).call(this, props));

    _this.updateListTitle = _this.updateListTitle.bind(_this);
    return _this;
  }

  _createClass(PipelineListTitle, [{
    key: 'updateListTitle',
    value: function updateListTitle(props) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-plist-title');
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
      };

      var id = props.id,
          title = props.title;


      if (this.props.list.title !== title) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3279);
        });

        var optimisticResponse = {
          updatePlist: { plist: { id: id, title: title } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var list = this.props.list;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
        {
          desktop: __WEBPACK_IMPORTED_MODULE_4__ListTitleInput__["a" /* default */],
          mobile: __WEBPACK_IMPORTED_MODULE_4__ListTitleInput__["a" /* default */],
          placeholder: '(Untitled)',
          title: list.title,
          listId: list.id,
          commitUpdate: this.updateListTitle,
          handleClickOutside: true,
          iconStyle: { top: 0 }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: __WEBPACK_IMPORTED_MODULE_5__Pipelines_scss___default.a.listTitle },
          list.title
        )
      );
    }
  }]);

  return PipelineListTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PipelineListTitle.propTypes = {
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PipelineListTitle);

/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ListTitleInput = function (_React$Component) {
  _inherits(ListTitleInput, _React$Component);

  function ListTitleInput(props) {
    _classCallCheck(this, ListTitleInput);

    var _this = _possibleConstructorReturn(this, (ListTitleInput.__proto__ || Object.getPrototypeOf(ListTitleInput)).call(this, props));

    _this.state = {
      title: _this.props.title
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.moveCaretAtEnd = _this.moveCaretAtEnd.bind(_this);
    return _this;
  }

  _createClass(ListTitleInput, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.commitUpdate({ id: this.props.listId, title: this.state.title });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.setState({ title: e.target.value });
    }
  }, {
    key: 'moveCaretAtEnd',
    value: function moveCaretAtEnd() {
      var _this2 = this;

      // Hack to move cursor to end of input
      var title = this.state.title;
      this.setState({ title: '' }, function () {
        return _this2.setState({ title: title });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formsy_react___default.a.Form,
        { onBlur: this.props.closeHandler },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
            value: this.state.title,
            placeholder: this.props.placeholder,
            rows: 1,
            name: 'title',
            autoComplete: 'off',
            transparent: true,
            autoFocus: true,
            onFocus: this.moveCaretAtEnd,
            fluid: true,
            onChange: this.onChange,
            style: { fontWeight: 'bold', paddingTop: '1px' }
          })
        )
      );
    }
  }]);

  return ListTitleInput;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ListTitleInput.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  listId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  closeHandler: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ListTitleInput);

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Pipelines_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_SearchContainer__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__variables__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__List_EventCard__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListTitle__ = __webpack_require__(3275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_utils_array__ = __webpack_require__(261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6, _graphql7, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Pipelines = (_temp = _class = function (_React$Component) {
  _inherits(Pipelines, _React$Component);

  function Pipelines(props) {
    _classCallCheck(this, Pipelines);

    var _this = _possibleConstructorReturn(this, (Pipelines.__proto__ || Object.getPrototypeOf(Pipelines)).call(this, props));

    var pipelines = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.viewer.pipelines);
    _this.state = {
      addingPipeline: false,
      addEventModalOpen: false,
      moveEventModalOpen: false,
      addListModalOpen: false,
      listDeleteModalOpen: false,
      newListTitle: '',
      pipelines: _this.sortPlistsAndEvents(pipelines)
    };
    _this.onValidAddListSubmit = _this.onValidAddListSubmit.bind(_this);
    _this.onInvalidAddListSubmit = _this.onInvalidAddListSubmit.bind(_this);
    _this.closeListDeleteModal = _this.closeListDeleteModal.bind(_this);
    _this.openListDeleteModal = _this.openListDeleteModal.bind(_this);
    _this.createList = _this.createList.bind(_this);
    _this.createPipeline = _this.createPipeline.bind(_this);
    _this.deleteList = _this.deleteList.bind(_this);
    _this.openAddEventModal = _this.openAddEventModal.bind(_this);
    _this.closeAddEventModal = _this.closeAddEventModal.bind(_this);
    _this.openMoveEventModal = _this.openMoveEventModal.bind(_this);
    _this.closeMoveEventModal = _this.closeMoveEventModal.bind(_this);
    _this.openAddListModal = _this.openAddListModal.bind(_this);
    _this.closeAddListModal = _this.closeAddListModal.bind(_this);
    _this.removeEvent = _this.removeEvent.bind(_this);
    _this.updateList = _this.updateList.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    return _this;
  }

  _createClass(Pipelines, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update pipelines as they are changed
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.pipelines = this.sortPlistsAndEvents(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.viewer.pipelines));
      this.setState(obj);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onValidAddListSubmit',
    value: function onValidAddListSubmit() {
      this.createList({
        pipelineId: this.state.activePipelineId,
        title: this.state.newListTitle
      }, this.closeAddListModal);
    }
  }, {
    key: 'onInvalidAddListSubmit',
    value: function onInvalidAddListSubmit() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add list',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onDragEnd',
    value: function onDragEnd(result) {
      var source = result.source,
          destination = result.destination;

      // Not dropped on a droppable

      if (!source || !destination) {
        return;
      }

      // No movement
      if (source.droppableId === destination.droppableId && source.index === destination.index) {
        return;
      }

      // Reorder Columns
      if (result.type === 'COLUMN') {
        this.moveList(source.index, destination.index);
        return;
      }

      // Moving Events
      if (result.type === 'EVENT') {
        // Move events within a list
        if (source.droppableId === destination.droppableId) {
          this.moveEventWithinList({
            source: { listId: source.droppableId, index: source.index },
            destination: { index: destination.index }
          });
          return;
        }

        // Move events between lists
        this.moveEventBetweenLists({
          source: { listId: source.droppableId, index: source.index },
          destination: { listId: destination.droppableId, index: destination.index }
        });
        return;
      }
    }
  }, {
    key: 'getListFromPipeline',
    value: function getListFromPipeline(id, pipeline) {
      return pipeline.plists.edges.filter(function (list) {
        return list.node.id === id;
      })[0].node;
    }
  }, {
    key: 'moveList',
    value: function moveList(sourceIndex, destinationIndex) {
      var _this2 = this;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var pipeline = state.pipelines.edges[0].node;
      pipeline.plists.edges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_utils_array__["a" /* arrayMove */])(pipeline.plists.edges, sourceIndex, destinationIndex);
      pipeline.plists.edges[destinationIndex].node.position = destinationIndex;
      this.setState(state, function () {
        return _this2.updateList(pipeline.plists.edges[destinationIndex]);
      });
    }
  }, {
    key: 'moveEventWithinList',
    value: function moveEventWithinList(_ref) {
      var _this3 = this;

      var source = _ref.source,
          destination = _ref.destination;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var pipeline = state.pipelines.edges[0].node;
      var sourceList = this.getListFromPipeline(source.listId, pipeline);
      var sourceListEvents = sourceList.plist_events.edges;

      // Move event to correct position
      sourceListEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_utils_array__["a" /* arrayMove */])(sourceListEvents, source.index, destination.index);

      var updatedListEvent = sourceListEvents[destination.index].node;

      // Update position of all items in the list
      sourceListEvents = sourceListEvents.map(function (event, index) {
        var node = event.node;
        node.position = index;
        return { node: node };
      });

      // Update local state and call mutation
      this.setState(state, function () {
        return _this3.updateListEvent({
          id: updatedListEvent.id,
          position: updatedListEvent.position,
          sourceList: sourceList,
          destinationList: sourceList
        });
      });
    }
  }, {
    key: 'moveEventBetweenLists',
    value: function moveEventBetweenLists(_ref2) {
      var _this4 = this;

      var source = _ref2.source,
          destination = _ref2.destination;

      var state = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var pipeline = state.pipelines.edges[0].node;
      var sourceList = this.getListFromPipeline(source.listId, pipeline);
      var destinationList = this.getListFromPipeline(destination.listId, pipeline);
      var sourceListEvents = sourceList.plist_events.edges;
      var destinationListEvents = destinationList.plist_events.edges;

      // First, add event to destination list
      destinationListEvents.splice(destination.index, 0, sourceListEvents[source.index]);

      // Next, remove event from source list
      sourceListEvents.splice(source.index, 1);

      // Update position of all items in source list
      sourceListEvents = sourceListEvents.map(function (event, index) {
        var node = event.node;
        node.position = index;
        return { node: node };
      });

      // Update position of all items in destination list
      destinationListEvents = destinationListEvents.map(function (event, index) {
        var node = event.node;
        node.position = index;
        return { node: node };
      });

      var updatedListEvent = destinationListEvents[destination.index].node;

      // Update local state and call mutation
      this.setState(state, function () {
        return _this4.updateListEvent({
          id: updatedListEvent.id,
          position: updatedListEvent.position,
          sourceList: sourceList,
          destinationList: destinationList
        });
      });
    }
  }, {
    key: 'sortPlistsAndEvents',
    value: function sortPlistsAndEvents(pipelines) {
      // Used to ensure arrays are ordered by element position
      // since Relay updater doesn't seem to guarantee order
      var sortedPipelines = pipelines;
      sortedPipelines.edges = sortedPipelines.edges.map(function (pipeline) {
        var sortedPipeline = pipeline;
        sortedPipeline.node.plists.edges = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(sortedPipelines.edges[0].node.plists.edges, function (o) {
          return o.node.position;
        }).map(function (plist) {
          var withSortedEvents = plist;
          withSortedEvents.node.plist_events.edges = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(plist.node.plist_events.edges, function (o) {
            return o.node.position;
          });
          return withSortedEvents;
        });
        return sortedPipeline;
      });
      return sortedPipelines;
    }
  }, {
    key: 'openListDeleteModal',
    value: function openListDeleteModal(_ref3) {
      var activePipelineId = _ref3.activePipelineId,
          activeList = _ref3.activeList;

      this.setState({
        listDeleteModalOpen: true,
        activePipelineId: activePipelineId,
        activeList: activeList
      });
    }
  }, {
    key: 'closeListDeleteModal',
    value: function closeListDeleteModal() {
      this.setState({ listDeleteModalOpen: false });
    }
  }, {
    key: 'openAddEventModal',
    value: function openAddEventModal(activeList) {
      this.setState({ addEventModalOpen: true, activeList: activeList });
    }
  }, {
    key: 'closeAddEventModal',
    value: function closeAddEventModal() {
      this.setState({ addEventModalOpen: false });
    }
  }, {
    key: 'openMoveEventModal',
    value: function openMoveEventModal(_ref4) {
      var plist = _ref4.plist,
          plistEvent = _ref4.plistEvent;

      this.setState({
        moveEventModalOpen: true,
        activeEvent: plistEvent,
        activeList: plist,
        moveEventToList: plist
      });
    }
  }, {
    key: 'closeMoveEventModal',
    value: function closeMoveEventModal() {
      this.setState({ moveEventModalOpen: false });
    }
  }, {
    key: 'openAddListModal',
    value: function openAddListModal(activePipelineId) {
      this.setState({ addListModalOpen: true, activePipelineId: activePipelineId });
    }
  }, {
    key: 'closeAddListModal',
    value: function closeAddListModal() {
      this.setState({ addListModalOpen: false, newListTitle: '' });
    }
  }, {
    key: 'addEventToList',
    value: function addEventToList(_ref5, successCb, failureCb) {
      var eventId = _ref5.eventId,
          plistId = _ref5.plistId;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add event to pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added event to pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('added-event-to-pipeline');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3283);
      });

      var configs = [{
        type: 'RANGE_ADD',
        parentID: plistId,
        edgeName: 'new_plist_event_edge',
        connectionInfo: [{
          key: 'PipelinesContainer_plist_events',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            plist_id: plistId,
            event_id: eventId
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createList',
    value: function createList(_ref6, successCb, failureCb) {
      var pipelineId = _ref6.pipelineId,
          title = _ref6.title;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-pipeline-list');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3284);
      });

      var configs = [{
        type: 'RANGE_ADD',
        parentID: pipelineId,
        edgeName: 'new_plist_edge',
        connectionInfo: [{
          key: 'PipelinesContainer_plists',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            pipeline_id: pipelineId,
            title: title
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createPipeline',
    value: function createPipeline() {
      var _this5 = this;

      this.setState({ addingPipeline: true });
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this5.setState({ addingPipeline: false });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-pipeline');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3282);
      });

      var configs = [{
        type: 'RANGE_ADD',
        parentID: this.props.viewer.id,
        edgeName: 'new_pipeline_edge',
        connectionInfo: [{
          key: 'PipelinesContainer_pipelines',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            user_id: this.props.viewer.id,
            title: 'Default Pipeline'
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'removeEvent',
    value: function removeEvent(_ref7, successCb, failureCb) {
      var plist = _ref7.plist,
          plistEvent = _ref7.plistEvent;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to remove event',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully removed event',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-plist-event');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3285);
      });

      var environment = this.props.relay.environment;
      var parentID = plist.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['plists', 'plist_events'],
        deletedIDFieldName: 'deletedPlistEventId',
        connectionKeys: [{
          key: 'PipelinesContainer_plist_events',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: plistEvent.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateList',
    value: function updateList(list, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3281);
      });

      var plist = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(list.node, ['id', 'position', 'title']);

      var optimisticResponse = {
        updatePlist: {
          plist: plist
        }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, plist)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateListEvent',
    value: function updateListEvent(_ref8, successCb, failureCb) {
      var id = _ref8.id,
          position = _ref8.position,
          sourceList = _ref8.sourceList,
          destinationList = _ref8.destinationList;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update pipeline',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3280);
      });

      var optimisticResponse = {
        updatePlistEvent: {
          current_plist: destinationList,
          old_plist: sourceList
        }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            plist_id: destinationList.id,
            position: position
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'deleteList',
    value: function deleteList(successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('deleted-plist');
      };

      var mutation = _graphql7 || (_graphql7 = function _graphql7() {
        return __webpack_require__(3286);
      });

      var environment = this.props.relay.environment;
      var parentID = this.state.activePipelineId;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['pipelines', 'plists'],
        deletedIDFieldName: 'deletedPlistId',
        connectionKeys: [{
          key: 'PipelinesContainer_plists',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.state.activeList.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      var AddEventModalContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'Please select the event you would like to add'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__App_SearchContainer__["a" /* default */], {
          viewer: viewer,
          handleResultSelect: function handleResultSelect(e, data) {
            return _this6.addEventToList({
              eventId: data.result.eventId,
              plistId: _this6.state.activeList
            }, _this6.closeAddEventModal);
          },
          fluid: true
        })
      );

      var MoveEventModalContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'Please select the list you would like to move this event to'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
        viewer.pipelines.edges.length > 0 && viewer.pipelines.edges[0].node.plists.edges.map(function (plist) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__Elements__["g" /* SelectableBlock */],
            {
              key: plist.node.id,
              checked: (_this6.state.moveEventToList && _this6.state.moveEventToList.id) === plist.node.id,
              onChange: function onChange() {
                return _this6.setState({ moveEventToList: plist.node });
              },
              style: { marginBottom: '2em' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              null,
              plist.node.title
            )
          );
        })
      );

      var AddListModalContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'Give your list a title'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_formsy_react___default.a.Form,
          {
            onValidSubmit: this.onValidAddListSubmit,
            onInvalidSubmit: this.onInvalidAddListSubmit,
            ref: 'addListForm'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
            name: 'title',
            autoFocus: true,
            value: this.state.newListTitle,
            onChange: function onChange(e) {
              return _this6.setState({ newListTitle: e.target.value });
            },
            required: true,
            validationError: 'Title is required'
          })
        )
      );

      var eventSettingsMenu = function eventSettingsMenu(_ref9) {
        var plist = _ref9.plist,
            plistEvent = _ref9.plistEvent;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.eventSettingsMenu },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
            { floating: true, basic: true, icon: 'ellipsis vertical' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Menu,
              { style: { right: 0, left: 'auto' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item, {
                text: 'Move To List...',
                onClick: function onClick() {
                  return _this6.openMoveEventModal({ plist: plist, plistEvent: plistEvent });
                }
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Divider, null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item, {
                text: 'Remove From List',
                className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.negative,
                onClick: function onClick() {
                  return _this6.removeEvent({ plist: plist, plistEvent: plistEvent });
                }
              })
            )
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__App_MobileHeader__["a" /* default */],
          {
            viewer: viewer,
            router: router
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                className: sidebarOpen ? 'active ' : '',
                onClick: toggleSidebar
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["i" /* DeleteConfirmation */], {
            'delete': function _delete() {
              return _this6.deleteList();
            },
            key: this.state.activeList,
            open: this.state.listDeleteModalOpen,
            onClose: this.closeListDeleteModal,
            content: 'All your cards will be removed from this list. Are you sure you want to delete this list?'
          }),
          this.state.window.width >= __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.moveEventModalOpen,
              size: 'small',
              onClose: this.closeMoveEventModal
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["h" /* Header */], { content: 'Move Event To Another List' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
              null,
              MoveEventModalContent
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.modalCancel,
                  onClick: this.closeMoveEventModal
                },
                'Cancel'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                primary: true,
                content: 'Move Event',
                onClick: function onClick() {
                  _this6.moveEventBetweenLists({
                    source: {
                      listId: _this6.state.activeList.id,
                      index: _this6.state.activeEvent.position
                    },
                    destination: {
                      listId: _this6.state.moveEventToList.id,
                      index: 0
                    }
                  });
                  _this6.closeMoveEventModal();
                }
              })
            )
          ),
          this.state.window.width < __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
            { open: this.state.moveEventModalOpen },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                  { as: 'a', onClick: this.closeMoveEventModal },
                  'Cancel'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu right' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                  {
                    as: 'a',
                    onClick: function onClick() {
                      _this6.moveEventBetweenLists({
                        source: {
                          listId: _this6.state.activeList.id,
                          index: _this6.state.activeEvent.position
                        },
                        destination: {
                          listId: _this6.state.moveEventToList.id,
                          index: 0
                        }
                      });
                      _this6.closeMoveEventModal();
                    }
                  },
                  'Move'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
              null,
              MoveEventModalContent
            )
          ),
          this.state.window.width >= __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.addEventModalOpen,
              size: 'small',
              onClose: this.closeAddEventModal
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["h" /* Header */], { content: 'Add Event' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
              null,
              AddEventModalContent
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
              { style: { textAlign: 'left' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                basic: true,
                content: 'Cancel',
                onClick: this.closeAddEventModal
              })
            )
          ),
          this.state.window.width < __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
            { open: this.state.addEventModalOpen },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                  { as: 'a', onClick: this.closeAddEventModal },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
              null,
              AddEventModalContent
            )
          ),
          this.state.window.width >= __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */],
            {
              open: this.state.addListModalOpen,
              size: 'small',
              onClose: this.closeAddListModal
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["h" /* Header */], { content: 'Add New List' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Content,
              null,
              AddListModalContent
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.modalCancel,
                  onClick: this.closeAddListModal
                },
                'Cancel'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                primary: true,
                content: 'Create List',
                onClick: function onClick() {
                  return _this6.refs.addListForm.submit();
                }
              })
            )
          ),
          this.state.window.width < __WEBPACK_IMPORTED_MODULE_11__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
            { open: this.state.addListModalOpen },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                  { as: 'a', onClick: this.closeAddListModal },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
              null,
              AddListModalContent,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                primary: true,
                content: 'Create List',
                onClick: function onClick() {
                  return _this6.refs.addListForm.submit();
                }
              })
            )
          ),
          viewer.pipelines.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { textAlign: 'center', padding: '2em' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                null,
                'You have no pipelines'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                basic: true,
                icon: 'plus',
                disabled: this.state.addingPipeline,
                onClick: this.createPipeline,
                labelPosition: 'left',
                content: 'Add Pipeline'
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__["a" /* DragDropContext */],
            { onDragEnd: this.onDragEnd },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__["b" /* Droppable */],
              {
                droppableId: 'pipeline',
                type: 'COLUMN',
                direction: 'horizontal'
              },
              function (boardProvided) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  _extends({
                    className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.pipelineWrapper,
                    ref: boardProvided.innerRef
                  }, boardProvided.droppableProps),
                  _this6.state.pipelines.edges.map(function (pipeline) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { key: pipeline.node.id, className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.pipeline },
                      pipeline.node.plists.edges.map(function (plist, index) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__["c" /* Draggable */],
                          {
                            draggableId: plist.node.id,
                            key: plist.node.id,
                            index: index
                          },
                          function (provided) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'div',
                              { style: { display: 'flex' } },
                              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                _extends({
                                  className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.list,
                                  ref: provided.innerRef
                                }, provided.draggableProps),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  'div',
                                  _extends({ style: { marginBottom: '1em' } }, provided.dragHandleProps),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { style: { marginRight: '2em' } },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ListTitle__["a" /* default */], {
                                      list: plist.node,
                                      relay: relay
                                    })
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'span',
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.listMenu },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
                                      {
                                        floating: true,
                                        basic: true,
                                        icon: 'ellipsis horizontal'
                                      },
                                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Menu,
                                        {
                                          style: { right: 0, left: 'auto' }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item, {
                                          text: 'Add Event',
                                          onClick: _this6.openAddEventModal.bind(null, plist.node.id)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Divider, null),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item, {
                                          text: 'Delete List',
                                          className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.negative,
                                          onClick: function onClick() {
                                            return _this6.openListDeleteModal({
                                              activePipelineId: pipeline.node.id,
                                              activeList: plist.node
                                            });
                                          }
                                        })
                                      )
                                    )
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  'div',
                                  { className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.listScrollWrapper },
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__["b" /* Droppable */],
                                    {
                                      droppableId: plist.node.id,
                                      type: 'EVENT'
                                    },
                                    function (dropProvided) {
                                      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        _extends({}, dropProvided.droppableProps, { style: { minHeight: '60vh' }, ref: dropProvided.innerRef }),
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                          'div',
                                          null,
                                          plist.node.plist_events.edges.map(function (event, eventIndex) {
                                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                              __WEBPACK_IMPORTED_MODULE_15_react_beautiful_dnd__["c" /* Draggable */],
                                              { key: event.node.id, draggableId: event.node.id, index: eventIndex },
                                              function (dragProvided) {
                                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                  'div',
                                                  null,
                                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                                    'div',
                                                    _extends({
                                                      ref: dragProvided.innerRef
                                                    }, dragProvided.draggableProps, dragProvided.dragHandleProps),
                                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__List_EventCard__["a" /* default */], {
                                                      basic: true,
                                                      sortable: true,
                                                      showDateLabel: false,
                                                      event: event.node.event.user_event,
                                                      timeZone: viewer.s_time_zone,
                                                      key: event.node.id,
                                                      relay: relay,
                                                      menu: eventSettingsMenu({
                                                        plist: plist.node,
                                                        plistEvent: event.node
                                                      })
                                                    })
                                                  ),
                                                  dragProvided.placeholder
                                                );
                                              }
                                            );
                                          })
                                        ),
                                        dropProvided.placeholder
                                      );
                                    }
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  'div',
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
                                    basic: true,
                                    fluid: true,
                                    onClick: _this6.openAddEventModal.bind(null, plist.node.id),
                                    content: '+ Add Event to List'
                                  })
                                )
                              ),
                              provided.placeholder
                            );
                          }
                        );
                      }),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: 'block' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          {
                            className: __WEBPACK_IMPORTED_MODULE_9__Pipelines_scss___default.a.list,
                            onClick: _this6.openAddListModal.bind(null, pipeline.node.id),
                            style: { cursor: 'pointer' }
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'h3',
                            null,
                            '+ Add New List'
                          )
                        )
                      )
                    );
                  })
                );
              }
            )
          )
        )
      );
    }
  }]);

  return Pipelines;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__App_Authenticate__["a" /* default */])(Pipelines));

/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PipelinesComponent__ = __webpack_require__(3277);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__PipelinesComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3287);
  }
}));

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b92990031e9e6b38817002640e2d4c31
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  position?: ?number,
};
export type ListTitle_UpdatePlistMutationVariables = {|
  input: UpdatePlistInput
|};
export type ListTitle_UpdatePlistMutationResponse = {|
  +updatePlist: ?{|
    +plist: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type ListTitle_UpdatePlistMutation = {|
  variables: ListTitle_UpdatePlistMutationVariables,
  response: ListTitle_UpdatePlistMutationResponse,
|};
*/

/*
mutation ListTitle_UpdatePlistMutation(
  $input: UpdatePlistInput!
) {
  updatePlist(input: $input) {
    plist {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePlist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdatePlistInput!"
    }],
    "concreteType": "UpdatePlistPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "plist",
      "storageKey": null,
      "args": null,
      "concreteType": "Plist",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ListTitle_UpdatePlistMutation",
    "id": null,
    "text": "mutation ListTitle_UpdatePlistMutation(\n  $input: UpdatePlistInput!\n) {\n  updatePlist(input: $input) {\n    plist {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ListTitle_UpdatePlistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ListTitle_UpdatePlistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7de0b62a217f8d97df968a5e0d5a1d05';
module.exports = node;

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0b5578f257f6da71b998087d22f3349c
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlistEventInput = {
  clientMutationId?: ?string,
  id: string,
  plist_id?: ?string,
  position?: ?number,
};
export type PipelinesComponent_UpdatePlistEventMutationVariables = {|
  input: UpdatePlistEventInput
|};
export type PipelinesComponent_UpdatePlistEventMutationResponse = {|
  +updatePlistEvent: ?{|
    +current_plist: ?{|
      +id: string,
      +plist_events: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +position: ?number,
          |}
        |}>
      |},
    |},
    +old_plist: ?{|
      +id: string,
      +plist_events: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +position: ?number,
          |}
        |}>
      |},
    |},
  |}
|};
export type PipelinesComponent_UpdatePlistEventMutation = {|
  variables: PipelinesComponent_UpdatePlistEventMutationVariables,
  response: PipelinesComponent_UpdatePlistEventMutationResponse,
|};
*/

/*
mutation PipelinesComponent_UpdatePlistEventMutation(
  $input: UpdatePlistEventInput!
) {
  updatePlistEvent(input: $input) {
    current_plist {
      id
      plist_events(first: 99999) {
        edges {
          node {
            id
            position
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    old_plist {
      id
      plist_events(first: 99999) {
        edges {
          node {
            id
            position
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlistEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlistEventInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "PlistEvent",
      "plural": false,
      "selections": [v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "position",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "cursor",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  }],
      v4 = [v2, {
    "kind": "LinkedField",
    "alias": "plist_events",
    "name": "__PipelinesContainer_plist_events_connection",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEventConnection",
    "plural": false,
    "selections": v3
  }],
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = [v2, {
    "kind": "LinkedField",
    "alias": null,
    "name": "plist_events",
    "storageKey": "plist_events(first:99999)",
    "args": v5,
    "concreteType": "PlistEventConnection",
    "plural": false,
    "selections": v3
  }, {
    "kind": "LinkedHandle",
    "alias": null,
    "name": "plist_events",
    "args": v5,
    "handle": "connection",
    "key": "PipelinesContainer_plist_events",
    "filters": null
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_UpdatePlistEventMutation",
    "id": null,
    "text": "mutation PipelinesComponent_UpdatePlistEventMutation(\n  $input: UpdatePlistEventInput!\n) {\n  updatePlistEvent(input: $input) {\n    current_plist {\n      id\n      plist_events(first: 99999) {\n        edges {\n          node {\n            id\n            position\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    old_plist {\n      id\n      plist_events(first: 99999) {\n        edges {\n          node {\n            id\n            position\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["updatePlistEvent", "current_plist", "plist_events"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["updatePlistEvent", "old_plist", "plist_events"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_UpdatePlistEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlistEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "current_plist",
          "storageKey": null,
          "args": null,
          "concreteType": "Plist",
          "plural": false,
          "selections": v4
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "old_plist",
          "storageKey": null,
          "args": null,
          "concreteType": "Plist",
          "plural": false,
          "selections": v4
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_UpdatePlistEventMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlistEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "current_plist",
          "storageKey": null,
          "args": null,
          "concreteType": "Plist",
          "plural": false,
          "selections": v6
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "old_plist",
          "storageKey": null,
          "args": null,
          "concreteType": "Plist",
          "plural": false,
          "selections": v6
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd51f9d3595e255e7f67e6da74419e96c';
module.exports = node;

/***/ }),
/* 3281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c6725fe92b4d3124ca6a3bc5d8316657
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePlistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  position?: ?number,
};
export type PipelinesComponent_UpdatePlistMutationVariables = {|
  input: UpdatePlistInput
|};
export type PipelinesComponent_UpdatePlistMutationResponse = {|
  +updatePlist: ?{|
    +pipeline: ?{|
      +id: string,
      +plists: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +position: ?number,
          |}
        |}>
      |},
    |}
  |}
|};
export type PipelinesComponent_UpdatePlistMutation = {|
  variables: PipelinesComponent_UpdatePlistMutationVariables,
  response: PipelinesComponent_UpdatePlistMutationResponse,
|};
*/

/*
mutation PipelinesComponent_UpdatePlistMutation(
  $input: UpdatePlistInput!
) {
  updatePlist(input: $input) {
    pipeline {
      id
      plists(first: 99999) {
        edges {
          node {
            id
            title
            position
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdatePlistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Plist",
      "plural": false,
      "selections": [v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "position",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "cursor",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  }],
      v4 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_UpdatePlistMutation",
    "id": null,
    "text": "mutation PipelinesComponent_UpdatePlistMutation(\n  $input: UpdatePlistInput!\n) {\n  updatePlist(input: $input) {\n    pipeline {\n      id\n      plists(first: 99999) {\n        edges {\n          node {\n            id\n            title\n            position\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["updatePlist", "pipeline", "plists"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_UpdatePlistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "pipeline",
          "storageKey": null,
          "args": null,
          "concreteType": "Pipeline",
          "plural": false,
          "selections": [v2, {
            "kind": "LinkedField",
            "alias": "plists",
            "name": "__PipelinesContainer_plists_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistConnection",
            "plural": false,
            "selections": v3
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_UpdatePlistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updatePlist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdatePlistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "pipeline",
          "storageKey": null,
          "args": null,
          "concreteType": "Pipeline",
          "plural": false,
          "selections": [v2, {
            "kind": "LinkedField",
            "alias": null,
            "name": "plists",
            "storageKey": "plists(first:99999)",
            "args": v4,
            "concreteType": "PlistConnection",
            "plural": false,
            "selections": v3
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "plists",
            "args": v4,
            "handle": "connection",
            "key": "PipelinesContainer_plists",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c64a4f260cbf0ffaf413c27d93100ebf';
module.exports = node;

/***/ }),
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a871a86868170c3da90cb9254e80cfec
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePipelineInput = {
  clientMutationId?: ?string,
  user_id: string,
  title: string,
};
export type PipelinesComponent_createPipelineMutationVariables = {|
  input: CreatePipelineInput
|};
export type PipelinesComponent_createPipelineMutationResponse = {|
  +createPipeline: ?{|
    +new_pipeline_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +plists: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +position: ?number,
              +plist_events: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string
                  |}
                |}>
              |},
            |}
          |}>
        |},
      |}
    |}
  |}
|};
export type PipelinesComponent_createPipelineMutation = {|
  variables: PipelinesComponent_createPipelineMutationVariables,
  response: PipelinesComponent_createPipelineMutationResponse,
|};
*/

/*
mutation PipelinesComponent_createPipelineMutation(
  $input: CreatePipelineInput!
) {
  createPipeline(input: $input) {
    new_pipeline_edge {
      node {
        id
        title
        plists(first: 99999) {
          edges {
            node {
              id
              title
              position
              plist_events(first: 99999) {
                edges {
                  node {
                    id
                    __typename
                  }
                  cursor
                }
                pageInfo {
                  endCursor
                  hasNextPage
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePipelineInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePipelineInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "PlistEvent",
      "plural": false,
      "selections": [v2, v5]
    }, v6]
  }, v7],
      v9 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_createPipelineMutation",
    "id": null,
    "text": "mutation PipelinesComponent_createPipelineMutation(\n  $input: CreatePipelineInput!\n) {\n  createPipeline(input: $input) {\n    new_pipeline_edge {\n      node {\n        id\n        title\n        plists(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              position\n              plist_events(first: 99999) {\n                edges {\n                  node {\n                    id\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": null
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["createPipeline", "new_pipeline_edge", "node", "plists"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_createPipelineMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPipeline",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePipelinePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_pipeline_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PipelineEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Pipeline",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": "plists",
              "name": "__PipelinesContainer_plists_connection",
              "storageKey": null,
              "args": null,
              "concreteType": "PlistConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlistEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Plist",
                  "plural": false,
                  "selections": [v2, v3, v4, {
                    "kind": "LinkedField",
                    "alias": "plist_events",
                    "name": "__PipelinesContainer_plist_events_connection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlistEventConnection",
                    "plural": false,
                    "selections": v8
                  }, v5]
                }, v6]
              }, v7]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_createPipelineMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPipeline",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePipelinePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_pipeline_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PipelineEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Pipeline",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "plists",
              "storageKey": "plists(first:99999)",
              "args": v9,
              "concreteType": "PlistConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlistEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Plist",
                  "plural": false,
                  "selections": [v2, v3, v4, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "plist_events",
                    "storageKey": "plist_events(first:99999)",
                    "args": v9,
                    "concreteType": "PlistEventConnection",
                    "plural": false,
                    "selections": v8
                  }, {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "plist_events",
                    "args": v9,
                    "handle": "connection",
                    "key": "PipelinesContainer_plist_events",
                    "filters": null
                  }, v5]
                }, v6]
              }, v7]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "plists",
              "args": v9,
              "handle": "connection",
              "key": "PipelinesContainer_plists",
              "filters": null
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fa72a027efffbcf4a89f4adb24f56cf9';
module.exports = node;

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 2e3d3f6fe44f786e2dce5a460836dc1d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type CreatePlistEventInput = {
  clientMutationId?: ?string,
  plist_id: string,
  event_id: string,
  position?: ?number,
};
export type PipelinesComponent_createPlistEventMutationVariables = {|
  input: CreatePlistEventInput
|};
export type PipelinesComponent_createPlistEventMutationResponse = {|
  +createPlistEvent: ?{|
    +new_plist_event_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +event: ?{|
          +id: string,
          +user_event: ?{|
            +booking_status: ?BookingStatus,
            +start_at: ?any,
            +end_at: ?any,
            +user_event_segments: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +location: ?string,
                  +room: ?string,
                |}
              |}>
            |},
            +event: ?{|
              +id: string,
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
            |},
          |},
        |},
      |}
    |}
  |}
|};
export type PipelinesComponent_createPlistEventMutation = {|
  variables: PipelinesComponent_createPlistEventMutationVariables,
  response: PipelinesComponent_createPlistEventMutationResponse,
|};
*/

/*
mutation PipelinesComponent_createPlistEventMutation(
  $input: CreatePlistEventInput!
) {
  createPlistEvent(input: $input) {
    new_plist_event_edge {
      node {
        id
        position
        event {
          id
          user_event {
            booking_status
            start_at
            end_at
            user_event_segments(first: 99999) {
              edges {
                node {
                  location
                  room
                  id
                }
              }
            }
            event {
              id
              title
              start_at
              end_at
            }
            id
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlistEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlistEventInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "event",
    "storageKey": null,
    "args": null,
    "concreteType": "Event",
    "plural": false,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, v5, v6]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_createPlistEventMutation",
    "id": null,
    "text": "mutation PipelinesComponent_createPlistEventMutation(\n  $input: CreatePlistEventInput!\n) {\n  createPlistEvent(input: $input) {\n    new_plist_event_edge {\n      node {\n        id\n        position\n        event {\n          id\n          user_event {\n            booking_status\n            start_at\n            end_at\n            user_event_segments(first: 99999) {\n              edges {\n                node {\n                  location\n                  room\n                  id\n                }\n              }\n            }\n            event {\n              id\n              title\n              start_at\n              end_at\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_createPlistEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_plist_event_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlistEventEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistEvent",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "event",
              "storageKey": null,
              "args": null,
              "concreteType": "Event",
              "plural": false,
              "selections": [v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEvent",
                "plural": false,
                "selections": [v4, v5, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_event_segments",
                  "storageKey": "user_event_segments(first:99999)",
                  "args": v7,
                  "concreteType": "UserEventSegmentConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegmentEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserEventSegment",
                      "plural": false,
                      "selections": [v8, v9]
                    }]
                  }]
                }, v10]
              }]
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_createPlistEventMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlistEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_plist_event_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlistEventEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistEvent",
            "plural": false,
            "selections": [v2, v3, {
              "kind": "LinkedField",
              "alias": null,
              "name": "event",
              "storageKey": null,
              "args": null,
              "concreteType": "Event",
              "plural": false,
              "selections": [v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEvent",
                "plural": false,
                "selections": [v4, v5, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_event_segments",
                  "storageKey": "user_event_segments(first:99999)",
                  "args": v7,
                  "concreteType": "UserEventSegmentConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegmentEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserEventSegment",
                      "plural": false,
                      "selections": [v8, v9, v2]
                    }]
                  }]
                }, v10, v2]
              }]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0930b289209e9ce0a70019ae89eb778c';
module.exports = node;

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b16ecabbd84b5a052172bc0a149c0424
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePlistInput = {
  clientMutationId?: ?string,
  pipeline_id: string,
  title: string,
};
export type PipelinesComponent_createPlistMutationVariables = {|
  input: CreatePlistInput
|};
export type PipelinesComponent_createPlistMutationResponse = {|
  +createPlist: ?{|
    +new_plist_edge: ?{|
      +node: ?{|
        +id: string,
        +plist_events: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string
            |}
          |}>
        |},
        +position: ?number,
        +title: ?string,
      |}
    |}
  |}
|};
export type PipelinesComponent_createPlistMutation = {|
  variables: PipelinesComponent_createPlistMutationVariables,
  response: PipelinesComponent_createPlistMutationResponse,
|};
*/

/*
mutation PipelinesComponent_createPlistMutation(
  $input: CreatePlistInput!
) {
  createPlist(input: $input) {
    new_plist_edge {
      node {
        id
        plist_events(first: 99999) {
          edges {
            node {
              id
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        position
        title
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlistEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "PlistEvent",
      "plural": false,
      "selections": [v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "cursor",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  }],
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_createPlistMutation",
    "id": null,
    "text": "mutation PipelinesComponent_createPlistMutation(\n  $input: CreatePlistInput!\n) {\n  createPlist(input: $input) {\n    new_plist_edge {\n      node {\n        id\n        plist_events(first: 99999) {\n          edges {\n            node {\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        position\n        title\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["createPlist", "new_plist_edge", "node", "plist_events"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_createPlistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_plist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Plist",
            "plural": false,
            "selections": [v2, {
              "kind": "LinkedField",
              "alias": "plist_events",
              "name": "__PipelinesContainer_plist_events_connection",
              "storageKey": null,
              "args": null,
              "concreteType": "PlistEventConnection",
              "plural": false,
              "selections": v3
            }, v4, v5]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_createPlistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_plist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Plist",
            "plural": false,
            "selections": [v2, {
              "kind": "LinkedField",
              "alias": null,
              "name": "plist_events",
              "storageKey": "plist_events(first:99999)",
              "args": v6,
              "concreteType": "PlistEventConnection",
              "plural": false,
              "selections": v3
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "plist_events",
              "args": v6,
              "handle": "connection",
              "key": "PipelinesContainer_plist_events",
              "filters": null
            }, v4, v5]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7000f16a9c5eb30f045be11f752ca8b2';
module.exports = node;

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ca8bde3467c3fcf22b7c3925c9e74b92
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlistEventInput = {
  clientMutationId?: ?string,
  id: string,
};
export type PipelinesComponent_deletePlistEventMutationVariables = {|
  input: DeletePlistEventInput
|};
export type PipelinesComponent_deletePlistEventMutationResponse = {|
  +deletePlistEvent: ?{|
    +deletedPlistEventId: ?string
  |}
|};
export type PipelinesComponent_deletePlistEventMutation = {|
  variables: PipelinesComponent_deletePlistEventMutationVariables,
  response: PipelinesComponent_deletePlistEventMutationResponse,
|};
*/

/*
mutation PipelinesComponent_deletePlistEventMutation(
  $input: DeletePlistEventInput!
) {
  deletePlistEvent(input: $input) {
    deletedPlistEventId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlistEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlistEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePlistEventInput!"
    }],
    "concreteType": "DeletePlistEventPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedPlistEventId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_deletePlistEventMutation",
    "id": null,
    "text": "mutation PipelinesComponent_deletePlistEventMutation(\n  $input: DeletePlistEventInput!\n) {\n  deletePlistEvent(input: $input) {\n    deletedPlistEventId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_deletePlistEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_deletePlistEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '46a7d74a89f11297a962b8deedda2dd9';
module.exports = node;

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 676b5d9b65d4aa51d6a519483cbe318d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type PipelinesComponent_deletePlistMutationVariables = {|
  input: DeletePlistInput
|};
export type PipelinesComponent_deletePlistMutationResponse = {|
  +deletePlist: ?{|
    +deletedPlistId: ?string
  |}
|};
export type PipelinesComponent_deletePlistMutation = {|
  variables: PipelinesComponent_deletePlistMutationVariables,
  response: PipelinesComponent_deletePlistMutationResponse,
|};
*/

/*
mutation PipelinesComponent_deletePlistMutation(
  $input: DeletePlistInput!
) {
  deletePlist(input: $input) {
    deletedPlistId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePlistInput!"
    }],
    "concreteType": "DeletePlistPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedPlistId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "PipelinesComponent_deletePlistMutation",
    "id": null,
    "text": "mutation PipelinesComponent_deletePlistMutation(\n  $input: DeletePlistInput!\n) {\n  deletePlist(input: $input) {\n    deletedPlistId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PipelinesComponent_deletePlistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "PipelinesComponent_deletePlistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '28b192ba6b2f6bcc2745800cd9e70ab4';
module.exports = node;

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PipelinesContainer_viewer$ref: FragmentReference;
export type PipelinesContainer_viewer = {|
  +id: string,
  +s_time_zone: ?string,
  +pipelines: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +plists: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +position: ?number,
              +plist_events: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string,
                    +position: ?number,
                    +event: ?{|
                      +id: string,
                      +user_event: ?{|
                        +booking_status: ?BookingStatus,
                        +start_at: ?any,
                        +end_at: ?any,
                        +user_event_segments: ?{|
                          +edges: ?$ReadOnlyArray<?{|
                            +node: ?{|
                              +location: ?string,
                              +room: ?string,
                            |}
                          |}>
                        |},
                        +event: ?{|
                          +id: string,
                          +title: ?string,
                          +start_at: ?any,
                          +end_at: ?any,
                        |},
                      |},
                    |},
                  |}
                |}>
              |},
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: SearchContainer_viewer$ref,
  +$refType: PipelinesContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "count": null,
    "cursor": null,
    "direction": "forward",
    "path": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "PipelinesContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [v0, v0, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["pipelines"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v1, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "pipelines",
      "name": "__PipelinesContainer_pipelines_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PipelineConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PipelineEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Pipeline",
          "plural": false,
          "selections": [v1, v2, {
            "kind": "LinkedField",
            "alias": "plists",
            "name": "__PipelinesContainer_plists_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "PlistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Plist",
                "plural": false,
                "selections": [v1, v2, v3, {
                  "kind": "LinkedField",
                  "alias": "plist_events",
                  "name": "__PipelinesContainer_plist_events_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PlistEventConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlistEventEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PlistEvent",
                      "plural": false,
                      "selections": [v1, v3, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [v1, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_event",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserEvent",
                          "plural": false,
                          "selections": [{
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "booking_status",
                            "args": null,
                            "storageKey": null
                          }, v4, v5, {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_event_segments",
                            "storageKey": "user_event_segments(first:99999)",
                            "args": [{
                              "kind": "Literal",
                              "name": "first",
                              "value": 99999,
                              "type": "Int"
                            }],
                            "concreteType": "UserEventSegmentConnection",
                            "plural": false,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "edges",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserEventSegmentEdge",
                              "plural": true,
                              "selections": [{
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [{
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "location",
                                  "args": null,
                                  "storageKey": null
                                }, {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "room",
                                  "args": null,
                                  "storageKey": null
                                }]
                              }]
                            }]
                          }, {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [v1, v2, v4, v5]
                          }]
                        }]
                      }, v6]
                    }, v7]
                  }, v8]
                }, v6]
              }, v7]
            }, v8]
          }, v6]
        }, v7]
      }, v8]
    }, {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b0a3c85bedcfa5fe716bd05bb709fb30';
module.exports = node;

/***/ }),
/* 3288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BookingStatus = function (_React$Component) {
  _inherits(BookingStatus, _React$Component);

  function BookingStatus(props) {
    _classCallCheck(this, BookingStatus);

    var _this = _possibleConstructorReturn(this, (BookingStatus.__proto__ || Object.getPrototypeOf(BookingStatus)).call(this, props));

    _this.state = {
      user_event: _extends({}, _this.props.event.user_event)
    };
    _this.getBookingStatusLabel = _this.getBookingStatusLabel.bind(_this);
    _this.getBookingStatusIndicator = _this.getBookingStatusIndicator.bind(_this);
    _this.changeEventStatus = _this.changeEventStatus.bind(_this);
    _this.toggleVisibility = _this.toggleVisibility.bind(_this);
    _this.updateUserEvent = _this.updateUserEvent.bind(_this);
    return _this;
  }

  _createClass(BookingStatus, [{
    key: 'getBookingStatusLabel',
    value: function getBookingStatusLabel(status) {
      switch (status) {
        case 'BOOKED':
          return 'Booked';
        case 'INITIAL':
          return 'Not Booked';
        case 'CANCELED':
          return 'Canceled';
        default:
          return null;
      }
    }
  }, {
    key: 'getBookingStatusIndicator',
    value: function getBookingStatusIndicator(status) {
      switch (status) {
        case 'BOOKED':
          return __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.bookedIndicator;
        case 'INITIAL':
          return __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.notBookedIndicator;
        case 'CANCELED':
          return __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.canceledIndicator;
        default:
          return null;
      }
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'changeEventStatus',
    value: function changeEventStatus(booking_status) {
      this.setState({ user_event: _extends({}, this.state.user_event, { booking_status: booking_status }) }, this.updateUserEvent);
    }
  }, {
    key: 'toggleVisibility',
    value: function toggleVisibility() {
      var visibility = this.state.user_event.visibility === 'SHOW' ? 'HIDDEN' : 'SHOW';
      this.setState({ user_event: _extends({}, this.state.user_event, { visibility: visibility }) }, this.updateUserEvent);
    }
  }, {
    key: 'updateUserEvent',
    value: function updateUserEvent() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3325);
      });
      // eslint-disable-next-line camelcase
      var user_event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(this.state.user_event, ['id', 'booking_status', 'visibility']);
      var optimisticResponse = {
        updateUserEvent: { user_event: this.state.user_event }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, user_event)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var event = this.props.event;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        event.user_event && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */],
          {
            basic: true,
            floating: true,
            className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.statusLabel,
            trigger: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
                className: this.getBookingStatusIndicator(event.user_event.booking_status)
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { marginLeft: '0.5em' } },
                this.getBookingStatusLabel(event.user_event.booking_status),
                event.user_event && event.user_event.visibility === 'HIDDEN' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["y" /* Label */], {
                  size: 'small',
                  style: { marginLeft: '1em' },
                  content: '(Archived)'
                })
              )
            )
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Menu,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
              {
                value: 'BOOKED',
                selected: event.user_event.booking_status === 'BOOKED',
                onClick: this.changeEventStatus.bind(null, 'BOOKED')
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                radio: true,
                label: 'Booked',
                checked: event.user_event.booking_status === 'BOOKED'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
              {
                value: 'INITIAL',
                selected: event.user_event.booking_status === 'INITIAL',
                onClick: this.changeEventStatus.bind(null, 'INITIAL')
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                radio: true,
                label: 'Not Booked',
                checked: event.user_event.booking_status === 'INITIAL'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
              {
                value: 'BOOKED',
                selected: event.user_event.booking_status === 'CANCELED',
                onClick: this.changeEventStatus.bind(null, 'CANCELED')
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                radio: true,
                label: 'Canceled',
                checked: event.user_event.booking_status === 'CANCELED'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Divider, null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */].Item,
              { onClick: this.toggleVisibility },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["i" /* Checkbox */], {
                label: 'Archived',
                checked: event.user_event.visibility === 'HIDDEN'
              })
            )
          )
        )
      );
    }
  }]);

  return BookingStatus;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BookingStatus.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BookingStatus);

/***/ }),
/* 3289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_phone__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_location__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactShow__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContactFields__ = __webpack_require__(820);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ContactEditDesktop = function (_React$Component) {
  _inherits(ContactEditDesktop, _React$Component);

  function ContactEditDesktop(props) {
    _classCallCheck(this, ContactEditDesktop);

    var _this = _possibleConstructorReturn(this, (ContactEditDesktop.__proto__ || Object.getPrototypeOf(ContactEditDesktop)).call(this, props));

    _this.state = {
      editing: _this.props.initiallyOpen
    };
    _this.toggleEditing = _this.toggleEditing.bind(_this);
    return _this;
  }

  _createClass(ContactEditDesktop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if (this.refs.contact.node.scrollIntoViewIfNeeded) this.refs.contact.node.scrollIntoViewIfNeeded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeEditor) this.props.closeEditor();
    }
  }, {
    key: 'toggleEditing',
    value: function toggleEditing() {
      this.setState({ editing: !this.state.editing });
    }
  }, {
    key: 'render',
    value: function render() {
      var contact = this.props.contact;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.active },
        !this.state.editing && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'a',
            {
              className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.editButton,
              onClick: this.toggleEditing
            },
            'Edit'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactShow__["a" /* default */], {
            contact: contact,
            avatarCache: this.props.avatarCache,
            updateAvatarCache: this.props.updateAvatarCache,
            extended: true
          }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            {
              className: contact.node.user_contact_phones.edges.length > 0 ? __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.section : ''
            },
            contact.node.user_contact_phones.edges.map(function (userContactPhone, idx) {
              var number = userContactPhone.node.number;
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { style: { display: 'flex' }, key: idx },
                contact.node.user_contact_phones.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.type },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'phone' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  {
                    key: userContactPhone.node.id || idx,
                    className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.expanding
                  },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'a',
                    { href: 'tel:' + number },
                    __WEBPACK_IMPORTED_MODULE_4__lib_utils_phone__["a" /* default */].formatPhoneNumber(number)
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.label },
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(userContactPhone.node.label)
                  ),
                  idx === contact.node.user_contact_phones.edges.length - 1 && (contact.node.user_contact_emails.edges.length > 0 || contact.node.user_contact_addresses.edges.length > 0) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["v" /* Divider */], { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.divider })
                )
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            {
              className: contact.node.user_contact_emails.edges.length > 0 ? __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.section : ''
            },
            contact.node.user_contact_emails.edges.map(function (userContactEmail, idx) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { style: { display: 'flex' }, key: idx },
                contact.node.user_contact_emails.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.type },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'envelope' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  {
                    key: userContactEmail.node.id || idx,
                    className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.expanding
                  },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'a',
                    {
                      onClick: function onClick(e) {
                        return e.stopPropagation();
                      },
                      href: 'mailto:' + userContactEmail.node.address
                    },
                    userContactEmail.node.address
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.label },
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(userContactEmail.node.label)
                  ),
                  idx === contact.node.user_contact_emails.edges.length - 1 && contact.node.user_contact_addresses.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["v" /* Divider */], { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.divider })
                )
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            {
              className: contact.node.user_contact_addresses.edges.length > 0 ? __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.section : ''
            },
            contact.node.user_contact_addresses.edges.map(function (userContactAddress, idx) {
              return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { style: { display: 'flex' }, key: idx },
                contact.node.user_contact_addresses.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.type },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], { name: 'map marker alternate' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'div',
                  {
                    key: userContactAddress.node.id || idx,
                    className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.expanding
                  },
                  userContactAddress.node.line1 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    userContactAddress.node.line1
                  ),
                  userContactAddress.node.line2 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    userContactAddress.node.line2
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_5__lib_utils_location__["a" /* default */].getLocalityString({
                      city: userContactAddress.node.city,
                      province: userContactAddress.node.province,
                      postal_code: userContactAddress.node.postal_code
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_3__ContactStyles_scss___default.a.label },
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(userContactAddress.node.label)
                  )
                )
              );
            })
          )
        ),
        this.state.editing && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { padding: '2em 3em' } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ContactFields__["a" /* default */], {
            deleteUserContactEmail: this.props.deleteUserContactEmail,
            deleteUserContactPhone: this.props.deleteUserContactPhone,
            deleteUserContactAddress: this.props.deleteUserContactAddress,
            'delete': this.props.delete,
            reset: this.props.reset,
            commitUpdate: this.props.commitUpdate,
            onChange: this.props.onChange,
            contact: this.props.contact,
            localContact: this.props.localContact,
            index: this.props.index,
            closeHandler: this.toggleEditing
          })
        )
      );
    }
  }]);

  return ContactEditDesktop;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

ContactEditDesktop.propTypes = {
  avatarCache: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  updateAvatarCache: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  localContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  localRole: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  roleChangeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  closeEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isNew: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initiallyOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  deleteUserContactEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteUserContactPhone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deleteUserContactAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ContactEditDesktop);

/***/ }),
/* 3290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_onclickoutside__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_onclickoutside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_onclickoutside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_phone__ = __webpack_require__(383);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SearchComponent = (_temp = _class = function (_React$Component) {
  _inherits(SearchComponent, _React$Component);

  function SearchComponent(props) {
    _classCallCheck(this, SearchComponent);

    var _this = _possibleConstructorReturn(this, (SearchComponent.__proto__ || Object.getPrototypeOf(SearchComponent)).call(this, props));

    _this.state = {
      isLoading: false,
      value: '',
      results: [],
      lastRequest: new Date(),
      cachedQuery: ''
    };
    _this.handleSearchChange = _this.handleSearchChange.bind(_this);
    _this.handleResultSelect = _this.handleResultSelect.bind(_this);
    return _this;
  }

  _createClass(SearchComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.viewer !== this.props.viewer) {
        this.parseResults(nextProps.viewer.user_contact_search.edges);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.activeElement) {
        document.activeElement.blur();
      }
    }
  }, {
    key: 'parseResults',
    value: function parseResults(results) {
      var flattenedResults = results.map(function (result, index) {
        return {
          id: result.node.id,
          name: result.node.first_name + ' ' + (result.node.last_name ? result.node.last_name : ''),
          email: result.node.user_contact_emails.edges.length > 0 ? result.node.user_contact_emails.edges[0].node.address : '',
          phone: result.node.user_contact_phones.edges.length > 0 ? result.node.user_contact_phones.edges[0].node.number : '',
          childKey: index
        };
      });
      this.setState({ results: flattenedResults });
    }
  }, {
    key: 'handleSearchChange',
    value: function handleSearchChange(e, data) {
      var _this2 = this;

      this.setState({ value: data.value });
      if (data.value && data.value.length > 0) {
        this.setState({ cachedQuery: data.value, isLoading: true });
        this.trackAnalytics();
        this.props.relay.refetch({ query: data.value }, null, function () {
          return _this2.setState({ isLoading: false });
        });
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      if (this.props.closeHandler) this.props.closeHandler();
    }
  }, {
    key: 'handleResultSelect',
    value: function handleResultSelect(e, data) {
      this.props.handleResultSelect(data);
      this.setState({ value: '' });
    }
  }, {
    key: 'trackAnalytics',
    value: function trackAnalytics() {
      var _this3 = this;

      if (new Date() - this.state.lastRequest > 5000) {
        this.setState({ lastRequest: new Date() }, function () {
          return setTimeout(function () {
            return __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('searched-contact', {
              query: _this3.state.cachedQuery
            });
          }, 5000);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          isLoading = _state.isLoading,
          value = _state.value;


      var resultRenderer = function resultRenderer(_ref) {
        var name = _ref.name,
            email = _ref.email,
            phone = _ref.phone;
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { position: 'relative' } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'title' },
              name
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'description' },
              __WEBPACK_IMPORTED_MODULE_6__lib_utils_phone__["a" /* default */].formatPhoneNumber(phone)
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'description' },
              email
            )
          )
        );
      };

      var rest = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(this.props, 'viewer', 'results', 'relay', 'disableOnClickOutside', 'enableOnClickOutside', 'closeHandler', 'outsideClickIgnoreClass', 'router');

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* Search */], _extends({
        loading: isLoading,
        onSearchChange: this.handleSearchChange,
        onResultSelect: this.handleResultSelect,
        results: this.state.results,
        value: value,
        onFocus: function onFocus(e) {
          return _this4.handleSearchChange(e, e.target.value);
        },
        resultRenderer: resultRenderer,
        placeholder: 'Search existing contacts...',
        fluid: true,
        className: 'transparent globalHeaderSearch'
      }, rest));
    }
  }]);

  return SearchComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  handleResultSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react_onclickoutside___default()(SearchComponent));

/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactSearch__ = __webpack_require__(3290);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__ContactSearch__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3327);
  }
}, function () {
  return __webpack_require__(3326);
}));

/***/ }),
/* 3292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactEditDesktop__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactShow__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewContactDesktop__ = __webpack_require__(3300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_relay_runtime__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_relay_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_relay_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Contacts = function (_React$Component) {
  _inherits(Contacts, _React$Component);

  function Contacts(props) {
    _classCallCheck(this, Contacts);

    var _this = _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this, props));

    _this.state = {
      avatarCache: {},
      localContacts: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.event.user_contacts.edges),
      editorOpen: false,
      newContact: {
        node: {
          first_name: '',
          last_name: '',
          company_name: '',
          user_contact_phones: { edges: [] },
          user_contact_addresses: { edges: [] },
          user_contact_emails: { edges: [] }
        },
        role: ''
      }
    };
    _this.updateAvatarCache = _this.updateAvatarCache.bind(_this);
    _this.contactChangeHandler = _this.contactChangeHandler.bind(_this);
    _this.newContactChangeHandler = _this.newContactChangeHandler.bind(_this);
    _this.updateContact = _this.updateContact.bind(_this);
    _this.deleteContact = _this.deleteContact.bind(_this);
    _this.deleteUserContactEmail = _this.deleteUserContactEmail.bind(_this);
    _this.deleteUserContactPhone = _this.deleteUserContactPhone.bind(_this);
    _this.deleteUserContactAddress = _this.deleteUserContactAddress.bind(_this);
    _this.deleteNewUserContactEmail = _this.deleteNewUserContactEmail.bind(_this);
    _this.deleteNewUserContactPhone = _this.deleteNewUserContactPhone.bind(_this);
    _this.deleteNewUserContactAddress = _this.deleteNewUserContactAddress.bind(_this);
    _this.addContact = _this.addContact.bind(_this);
    _this.resetContact = _this.resetContact.bind(_this);
    _this.resetNewContact = _this.resetNewContact.bind(_this);
    _this.createContact = _this.createContact.bind(_this);
    return _this;
  }

  _createClass(Contacts, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localContacts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.event.user_contacts.edges);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.props.event.user_contacts.edges.length === this.state.localContacts.length;
    }
  }, {
    key: 'contactChangeHandler',
    value: function contactChangeHandler(contact, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localContacts[idx] = contact;
      this.setState(obj);
    }
  }, {
    key: 'newContactChangeHandler',
    value: function newContactChangeHandler(contact) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newContact = contact;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateAvatarCache',
    value: function updateAvatarCache(hash, avatarLoaded) {
      var newAvatar = {};
      newAvatar[hash] = avatarLoaded;
      this.setState({
        avatarCache: Object.assign(this.state.avatarCache, newAvatar)
      });
    }
  }, {
    key: 'resetContact',
    value: function resetContact(idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localContacts[idx] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.event.user_contacts.edges[idx]);
      this.setState(obj);
    }
  }, {
    key: 'resetNewContact',
    value: function resetNewContact() {
      this.setState(function (prevState) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(prevState);
        obj.newContact = {
          node: {
            first_name: '',
            last_name: '',
            company_name: '',
            user_contact_phones: { edges: [] },
            user_contact_addresses: { edges: [] },
            user_contact_emails: { edges: [] }
          },
          role: ''
        };
        obj.editorOpen = false;
        return obj;
      });
    }
  }, {
    key: 'updateContact',
    value: function updateContact(idx, successCb, failureCb) {
      var _this2 = this;

      var contact = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localContacts[idx].node);
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.refetchEvent();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-contact');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3329);
      });
      // eslint-disable-next-line camelcase
      var user_contact = {
        id: contact.id,
        first_name: contact.first_name,
        last_name: contact.last_name,
        company_name: contact.company_name,
        phones: contact.user_contact_phones.edges.map(function (userContactPhone) {
          var number = userContactPhone.node.number;
          var reformattedNumber = number ? number.replace(/\D/g, '') : null;
          return {
            id: userContactPhone.node.id,
            label: userContactPhone.node.label,
            number: reformattedNumber === '' ? null : reformattedNumber
          };
        }),
        emails: contact.user_contact_emails.edges.map(function (userContactEmail) {
          return {
            id: userContactEmail.node.id,
            label: userContactEmail.node.label,
            address: userContactEmail.node.address
          };
        }),
        addresses: contact.user_contact_addresses.edges.map(function (userContactAddress) {
          return {
            id: userContactAddress.node.id,
            label: userContactAddress.node.label,
            line1: userContactAddress.node.line1,
            line2: userContactAddress.node.line2,
            city: userContactAddress.node.city,
            province: userContactAddress.node.province,
            postal_code: userContactAddress.node.postal_code,
            country: userContactAddress.node.country
          };
        }),
        roles: [{ id: this.state.localContacts[idx].id, role: this.state.localContacts[idx].role }],
        delete_phones_with_ids: contact.deletePhonesWithIds,
        delete_emails_with_ids: contact.deleteEmailsWithIds,
        delete_addresses_with_ids: contact.deleteAddressesWithIds
      };
      var optimisticResponse = {
        updateUserContact: { user_contact: contact }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, user_contact)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-contact');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3330);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.event.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['event', 'user_contact'],
        deletedIDFieldName: 'deletedUserContactId',
        connectionKeys: [{
          key: 'EventSummaryContainer_user_contacts',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.event.user_contacts.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteUserContactEmail',
    value: function deleteUserContactEmail(contactIdx, emailIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var existingContactEmailId = this.state.localContacts[contactIdx].node.user_contact_emails.edges[emailIdx].node.id;
      var contactNode = obj.localContacts[contactIdx].node;
      if (existingContactEmailId) {
        contactNode.deleteEmailsWithIds = contactNode.deleteEmailsWithIds ? contactNode.deleteEmailsWithIds.push(existingContactEmailId) : [existingContactEmailId];
      }
      obj.localContacts[contactIdx].node.user_contact_emails.edges.splice(emailIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteUserContactPhone',
    value: function deleteUserContactPhone(contactIdx, phoneIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var existingContactPhoneId = this.state.localContacts[contactIdx].node.user_contact_phones.edges[phoneIdx].node.id;
      var contactNode = obj.localContacts[contactIdx].node;
      if (existingContactPhoneId) {
        contactNode.deletePhonesWithIds = contactNode.deletePhonesWithIds ? contactNode.deletePhonesWithIds.push(existingContactPhoneId) : [existingContactPhoneId];
      }
      obj.localContacts[contactIdx].node.user_contact_phones.edges.splice(phoneIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteUserContactAddress',
    value: function deleteUserContactAddress(contactIdx, addressIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      var existingContactAddressId = this.state.localContacts[contactIdx].node.user_contact_addresses.edges[addressIdx].node.id;
      var contactNode = obj.localContacts[contactIdx].node;
      if (existingContactAddressId) {
        contactNode.deleteAddressesWithIds = contactNode.deleteAddressesWithIds ? contactNode.deleteAddressesWithIds.push(existingContactAddressId) : [existingContactAddressId];
      }
      obj.localContacts[contactIdx].node.user_contact_addresses.edges.splice(addressIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'addContact',
    value: function addContact() {
      this.setState({ editorOpen: true });
    }
  }, {
    key: 'createContact',
    value: function createContact(idx, successCb, failureCb) {
      var _this3 = this;

      var contact = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state.newContact.node);
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created contact',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        _this3.resetNewContact();
        _this3.props.refetchEvent();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('created-contact');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3328);
      });
      // eslint-disable-next-line camelcase
      var user_contact = {
        user_id: this.props.viewer.id,
        first_name: contact.first_name,
        last_name: contact.last_name,
        company_name: contact.company_name,
        phones: contact.user_contact_phones.edges.map(function (userContactPhone) {
          var number = userContactPhone.node.number;
          var reformattedNumber = number ? number.replace(/\D/g, '') : null;
          return {
            label: userContactPhone.node.label,
            number: reformattedNumber === '' ? null : reformattedNumber
          };
        }),
        emails: contact.user_contact_emails.edges.map(function (userContactEmail) {
          return {
            label: userContactEmail.node.label,
            address: userContactEmail.node.address
          };
        }),
        addresses: contact.user_contact_addresses.edges.map(function (userContactAddress) {
          return {
            label: userContactAddress.node.label,
            line1: userContactAddress.node.line1,
            line2: userContactAddress.node.line2,
            city: userContactAddress.node.city,
            province: userContactAddress.node.province,
            postal_code: userContactAddress.node.postal_code,
            country: userContactAddress.node.country
          };
        }),
        events: [{ role: this.state.newContact.role, event_id: this.props.event.id }]
      };

      // const optimisticResponse = {
      //   createUserContact: { user_contact: contact, new_user_contact_edge: { node: contact } }
      // };

      var environment = this.props.relay.environment;
      // const parentID = this.props.event.id;

      // const configs = [
      //   {
      //     type: 'RANGE_ADD',
      //     parentID,
      //     edgeName: 'new_user_contact_edge',
      //     connectionInfo: [
      //       {
      //         key: 'EventSummaryContainer_user_contacts',
      //         rangeBehavior: 'append'
      //       }
      //     ]
      //   }
      // ];

      var updater = function updater(store) {
        var eventProxy = store.get(_this3.props.event.id);
        var payload = store.getRootField('createUserContact');
        var newNode = payload.getLinkedRecord('user_contact');
        var conn = __WEBPACK_IMPORTED_MODULE_9_relay_runtime__["ConnectionHandler"].getConnection(eventProxy, 'EventSummaryContainer_user_contacts');
        var newEdge = __WEBPACK_IMPORTED_MODULE_9_relay_runtime__["ConnectionHandler"].createEdge(store, newNode, newNode, 'EventUserContactEdge');
        newEdge.setValue(_this3.state.newContact.role, 'role');
        __WEBPACK_IMPORTED_MODULE_9_relay_runtime__["ConnectionHandler"].insertEdgeAfter(conn, newEdge);
        // const emailConnection = ConnectionHandler.getConnection(
        //   eventProxy,
        //   'EventSummaryContainer_user_contact_emails'
        // );
        // const user_contact_email_edges = newEdge.getLinkedRecord('node').getLinkedRecord('user_contact_emails').getLinkedRecords('edges');
        // console.log('user_contact_email_edges', user_contact_email_edges);
        // user_contact_email_edges.map(email => {
        //   ConnectionHandler.insertEdgeAfter(emailConnection, email);
        //   return email;
        // })
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, user_contact)
        },
        updater: updater,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteNewUserContactPhone',
    value: function deleteNewUserContactPhone(contactIdx, emailIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newContact.node.user_contact_phones.edges.splice(emailIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteNewUserContactEmail',
    value: function deleteNewUserContactEmail(contactIdx, emailIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newContact.node.user_contact_emails.edges.splice(emailIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'deleteNewUserContactAddress',
    value: function deleteNewUserContactAddress(contactIdx, emailIdx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.newContact.node.user_contact_addresses.edges.splice(emailIdx, 1);
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var newContact = this.state.newContact;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        this.props.event.user_contacts.edges.length === 0 && !this.state.editorOpen && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { padding: '2em', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h4',
            null,
            'This event has no contacts'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_semantic_ui_react__["b" /* Button */], {
            basic: true,
            icon: 'plus',
            labelPosition: 'left',
            content: 'Add Contact',
            onClick: this.addContact
          })
        ),
        this.props.event.user_contacts.edges.map(function (contact, idx) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
            {
              desktop: __WEBPACK_IMPORTED_MODULE_4__ContactEditDesktop__["a" /* default */],
              mobile: __WEBPACK_IMPORTED_MODULE_4__ContactEditDesktop__["a" /* default */],
              key: contact.node.id || idx,
              index: idx,
              contact: contact,
              localContact: _this4.state.localContacts[idx],
              onChange: function onChange(c) {
                _this4.contactChangeHandler(c, idx);
              },
              commitUpdate: _this4.updateContact,
              'delete': _this4.deleteContact,
              deleteUserContactEmail: _this4.deleteUserContactEmail,
              deleteUserContactPhone: _this4.deleteUserContactPhone,
              deleteUserContactAddress: _this4.deleteUserContactAddress,
              reset: _this4.resetContact,
              handleClickOutside: true,
              avatarCache: _this4.state.avatarCache,
              updateAvatarCache: _this4.updateAvatarCache,
              iconStyle: { display: 'none' }
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ContactShow__["a" /* default */], {
              contact: contact,
              avatarCache: _this4.state.avatarCache,
              updateAvatarCache: _this4.updateAvatarCache
            })
          );
        }),
        this.state.editorOpen && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
          {
            desktop: __WEBPACK_IMPORTED_MODULE_6__NewContactDesktop__["a" /* default */],
            mobile: __WEBPACK_IMPORTED_MODULE_6__NewContactDesktop__["a" /* default */],
            contact: newContact,
            localContact: newContact,
            onChange: function onChange(c) {
              _this4.newContactChangeHandler(c);
            },
            commitUpdate: this.createContact,
            initiallyOpen: true,
            isNew: true,
            avatarCache: this.state.avatarCache,
            updateAvatarCache: this.updateAvatarCache,
            onClickOutside: true,
            deleteUserContactEmail: this.deleteNewUserContactEmail,
            deleteUserContactPhone: this.deleteNewUserContactPhone,
            deleteUserContactAddress: this.deleteNewUserContactAddress,
            reset: this.resetNewContact,
            viewer: this.props.viewer,
            event: this.props.event,
            refetchEvent: this.props.refetchEvent,
            relay: this.props.relay
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null)
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
        !this.state.editorOpen && this.props.event.user_contacts.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { onClick: this.addContact },
          '+ Add Contact'
        )
      );
    }
  }]);

  return Contacts;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Contacts.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  refetchEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Contacts);

/***/ }),
/* 3293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__globals_scss__);





var DividedComponents = function DividedComponents(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    children.map(function (child, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { key: index },
        child,
        index !== children.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: [__WEBPACK_IMPORTED_MODULE_3__globals_scss___default.a.desktop, __WEBPACK_IMPORTED_MODULE_2__Event_scss___default.a.verticalDivider].join(' ')
          },
          '\xA0'
        )
      );
    })
  );
};

DividedComponents.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DividedComponents);

/***/ }),
/* 3294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UpdateEventDate__ = __webpack_require__(3307);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var EventDates = function (_React$Component) {
  _inherits(EventDates, _React$Component);

  function EventDates(props) {
    _classCallCheck(this, EventDates);

    var _this = _possibleConstructorReturn(this, (EventDates.__proto__ || Object.getPrototypeOf(EventDates)).call(this, props));

    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    return _this;
  }

  _createClass(EventDates, [{
    key: 'onValidSubmit',
    value: function onValidSubmit(model, resetForm, invalidateForm, successCb) {
      if (new Date(model.end_at) < new Date(model.start_at)) {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].DANGER
        });
        invalidateForm({ end_at: 'Event must end later than it starts' });
      } else {
        this.updateEvent(model, successCb);
      }
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update event information',
        intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'updateEvent',
    value: function updateEvent(model, successCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event times',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event times',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
      };

      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_utils_nullifyEmptyStrings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(model));

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3331);
      });

      var start_at = event.start_at,
          end_at = event.end_at,
          time_zone = event.time_zone;

      var optimisticResponse = {
        updateEvent: {
          event: { id: this.props.event.id, start_at: start_at, end_at: end_at, time_zone: time_zone }
        }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.event.id,
            start_at: start_at,
            end_at: end_at,
            time_zone: time_zone
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          event = _props.event,
          relay = _props.relay,
          viewer = _props.viewer;

      var timeZone = event && (event.time_zone || event.user_event && event.user_event.time_zone);
      var startAtString = function () {
        if (event && event.start_at) {
          return event.start_at;
        } else if (event && event.user_event && event.user_event.start_at) {
          return event.user_event.start_at;
        }
        return null;
      }();

      var endAtString = function () {
        if (event && event.end_at) {
          return event.end_at;
        } else if (event && event.user_event && event.user_event.end_at) {
          return event.user_event.end_at;
        }
        return null;
      }();
      // Since user_event does not return all_day, we infer property based on
      // the format of the date string returned (eg. `2020-01-01` infers
      // a Date while `2020-01-01T00:00:00Z` infers a DateTime)
      var allDay = startAtString && startAtString.length === 10;
      var startAt = __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].isoStringToMoment(startAtString, allDay, timeZone);
      var endAt = __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].isoStringToMoment(endAtString, allDay, timeZone);
      var hasDates = startAtString && endAtString;
      var hasEventDates = event.start_at && event.end_at;
      var multiDay = !(hasDates && startAt.isSame(endAt, 'day') || startAt.isSame(__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(endAt).subtract(6, 'hours'), 'day') && !allDay);
      var trigger = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: [__WEBPACK_IMPORTED_MODULE_4__Event_scss___default.a.publicDates, hasEventDates ? __WEBPACK_IMPORTED_MODULE_4__Event_scss___default.a.pointer : ''].join(' '),
          onClick: this.onOpen
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["d" /* Icon */], {
          name: 'calendar outline alternate',
          style: { paddingRight: '1em' }
        }),
        '' + startAt.format('LL') + (multiDay ? ' - ' + endAt.format('LL') : '')
      );
      var steps = [{
        title: 'Update Event Times',
        component: __WEBPACK_IMPORTED_MODULE_9__UpdateEventDate__["a" /* default */],
        componentProps: { relay: relay, viewer: viewer, event: event },
        formProps: {
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit
        },
        actions: {
          primary: {
            content: 'Save',
            type: 'submit'
          }
        }
      }];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        hasDates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          !hasEventDates && trigger,
          hasEventDates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules__["e" /* Wizard */], {
            steps: steps,
            trigger: trigger,
            onOpen: this.onOpen,
            onClose: this.onClose
          })
        )
      );
    }
  }]);

  return EventDates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EventDates.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EventDates);

/***/ }),
/* 3295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Authenticate__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EventOverview = (_temp = _class = function (_React$Component) {
  _inherits(EventOverview, _React$Component);

  function EventOverview() {
    _classCallCheck(this, EventOverview);

    return _possibleConstructorReturn(this, (EventOverview.__proto__ || Object.getPrototypeOf(EventOverview)).apply(this, arguments));
  }

  _createClass(EventOverview, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Segment */],
          null,
          this.props.children
        )
      );
    }
  }]);

  return EventOverview;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__App_Authenticate__["a" /* default */])(EventOverview));

/***/ }),
/* 3296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventOverviewComponent__ = __webpack_require__(3295);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__EventOverviewComponent__["a" /* default */], {
  node: function node() {
    return __webpack_require__(3332);
  },
  viewer: function viewer() {
    return __webpack_require__(3333);
  }
}));

/***/ }),
/* 3297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(3358);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3336);
  },
  node: function node() {
    return __webpack_require__(3335);
  }
}, function () {
  return __webpack_require__(3334);
}));

/***/ }),
/* 3298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReferralSource__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Contacts__ = __webpack_require__(3292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ScheduleContainer__ = __webpack_require__(3306);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var EventSummary = function (_React$Component) {
  _inherits(EventSummary, _React$Component);

  function EventSummary(props) {
    _classCallCheck(this, EventSummary);

    var _this = _possibleConstructorReturn(this, (EventSummary.__proto__ || Object.getPrototypeOf(EventSummary)).call(this, props));

    _this.updateEventNotes = _this.updateEventNotes.bind(_this);
    _this.notesChangeHandler = _this.notesChangeHandler.bind(_this);
    _this.refetchEvent = _this.refetchEvent.bind(_this);
    _this.referralChangeHandler = _this.referralChangeHandler.bind(_this);

    _this.state = {
      event: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node),
      editingNewContact: false
    };
    return _this;
  }

  _createClass(EventSummary, [{
    key: 'refetchEvent',
    value: function refetchEvent() {
      this.props.relay.refetch(function (fragmentVariables) {
        return fragmentVariables;
      }, null);
    }
  }, {
    key: 'referralChangeHandler',
    value: function referralChangeHandler(e, data) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update referral source',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated referral source',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_8__Modules__["c" /* Analytics */].trackEvent('updated-referral-source');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3338);
      });
      var id = this.props.node.user_event.id;
      // eslint-disable-next-line camelcase
      var referral_source = data.value;
      var optimisticResponse = {
        updateUserEvent: { user_event: { id: id, referral_source: referral_source } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id,
            referral_source: referral_source
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'notesChangeHandler',
    value: function notesChangeHandler(e) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.user_event.notes = e.target.value;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateEventNotes',
    value: function updateEventNotes() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event notes',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_8__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event notes',
          intent: __WEBPACK_IMPORTED_MODULE_8__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_8__Modules__["c" /* Analytics */].trackEvent('updated-event-notes');
      };

      // Update event if values have changed
      if (this.props.node.user_event.notes !== this.state.event.user_event.notes) {
        var mutation = _graphql2 || (_graphql2 = function _graphql2() {
          return __webpack_require__(3337);
        });
        // eslint-disable-next-line camelcase
        var _state$event$user_eve = this.state.event.user_event,
            id = _state$event$user_eve.id,
            notes = _state$event$user_eve.notes;

        var optimisticResponse = {
          updateUserEvent: { user_event: { id: id, notes: notes } }
        };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              notes: notes
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var event = this.props.node;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.children,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
          { stackable: true, padded: true },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
            { columns: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Notes'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
                { className: 'ui form field ' + __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.notepad },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["i" /* TextArea */], {
                  name: 'notes',
                  rows: 12,
                  onBlur: this.updateEventNotes,
                  onChange: this.notesChangeHandler,
                  value: this.state.event.user_event.notes || ''
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h3',
                  null,
                  'Referral Source'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReferralSource__["a" /* default */], {
                  onChange: this.referralChangeHandler,
                  label: '',
                  value: this.props.node.user_event.referral_source,
                  pastReferralSources: this.props.viewer.past_referral_sources
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Schedule'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ScheduleContainer__["a" /* default */], { viewer: this.props.viewer, node: this.props.node.user_event })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Contacts'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Contacts__["a" /* default */], {
                event: event,
                relay: this.props.relay,
                viewer: this.props.viewer,
                refetchEvent: this.refetchEvent
              })
            )
          )
        )
      );
    }
  }]);

  return EventSummary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventSummary.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (EventSummary);

/***/ }),
/* 3299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventSummaryComponent__ = __webpack_require__(3298);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__EventSummaryComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3341);
  },
  node: function node() {
    return __webpack_require__(3340);
  }
}, function () {
  return __webpack_require__(3339);
}));

/***/ }),
/* 3300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactSearchContainer__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactFields__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_phone__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_formsy_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NewContactDesktop = function (_React$Component) {
  _inherits(NewContactDesktop, _React$Component);

  function NewContactDesktop(props) {
    _classCallCheck(this, NewContactDesktop);

    var _this = _possibleConstructorReturn(this, (NewContactDesktop.__proto__ || Object.getPrototypeOf(NewContactDesktop)).call(this, props));

    _this.state = {
      step: 'initial',
      role: '',
      contact: {}
    };
    _this.goToStep = _this.goToStep.bind(_this);
    _this.handleResultSelect = _this.handleResultSelect.bind(_this);
    _this.onRoleChange = _this.onRoleChange.bind(_this);
    _this.createUserContactEvent = _this.createUserContactEvent.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    return _this;
  }

  _createClass(NewContactDesktop, [{
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to add contact',
        intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onRoleChange',
    value: function onRoleChange(e) {
      this.setState({ role: e.target.value });
    }
  }, {
    key: 'createUserContactEvent',
    value: function createUserContactEvent() {
      var _this2 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add contact',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_9__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added contact',
          intent: __WEBPACK_IMPORTED_MODULE_9__Modules__["b" /* Intent */].SUCCESS
        });
        _this2.props.reset();
        _this2.props.refetchEvent();
        __WEBPACK_IMPORTED_MODULE_9__Modules__["c" /* Analytics */].trackEvent('added-existing-contact');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3342);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.event.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_event_user_contact_edge',
        connectionInfo: [{
          key: 'EventSummaryContainer_user_contacts',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            user_contact_id: this.state.contact.id,
            event_id: this.props.event.id,
            role: this.state.role
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'goToStep',
    value: function goToStep(step) {
      this.setState({ step: step });
    }
  }, {
    key: 'handleResultSelect',
    value: function handleResultSelect(data) {
      this.setState({ step: 'addExisting', contact: data.result });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss___default.a.active, style: { padding: '1em' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Add Contact'
        ),
        this.state.step === 'initial' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ContactSearchContainer__["a" /* default */], {
            viewer: this.props.viewer,
            handleResultSelect: this.handleResultSelect
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["v" /* Divider */],
            { horizontal: true },
            'Or'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["b" /* Button */], {
              primary: true,
              content: 'Create New Contact',
              icon: 'plus',
              labelPosition: 'left',
              onClick: this.goToStep.bind(null, 'new')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss___default.a.cancel },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.props.reset },
              'Cancel'
            )
          )
        ),
        this.state.step === 'new' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '1em 2em' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ContactFields__["a" /* default */], {
            deleteUserContactEmail: this.props.deleteUserContactEmail,
            deleteUserContactPhone: this.props.deleteUserContactPhone,
            deleteUserContactAddress: this.props.deleteUserContactAddress,
            'delete': this.props.delete,
            reset: this.props.reset,
            commitUpdate: this.props.commitUpdate,
            onChange: this.props.onChange,
            contact: this.props.contact,
            localContact: this.props.localContact,
            index: this.props.index,
            closeHandler: this.props.closeHandler
          })
        ),
        this.state.step === 'addExisting' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'blockquote',
            { style: { fontSize: '1rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              this.state.contact.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss___default.a.description },
              __WEBPACK_IMPORTED_MODULE_7__lib_utils_phone__["a" /* default */].formatPhoneNumber(this.state.contact.phone)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__ContactStyles_scss___default.a.description },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  onClick: function onClick(e) {
                    return e.stopPropagation();
                  },
                  href: 'mailto:' + this.state.contact.email
                },
                this.state.contact.email
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'What is ',
            this.state.contact.name,
            '\'s role during this event?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_formsy_react___default.a.Form,
            { onValidSubmit: this.createUserContactEvent, onInvalidSubmit: this.onInvalidSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements__["e" /* FloatingLabelInput */], {
              label: 'Role',
              placeholder: 'Bride',
              type: 'text',
              name: 'role',
              fluid: true,
              autoFocus: true,
              value: this.state.role,
              onChange: this.onRoleChange,
              required: true,
              validationError: 'Role is required'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modules__["j" /* DthcActions */], {
              reset: this.props.reset,
              id: this.state.contact.childKey
            })
          )
        )
      );
    }
  }]);

  return NewContactDesktop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewContactDesktop.propTypes = {
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  deleteUserContactEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deleteUserContactPhone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deleteUserContactAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  commitUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  localContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  closeHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  refetchEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (NewContactDesktop);

/***/ }),
/* 3301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_filestack_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RootComponent__ = __webpack_require__(54);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var apikey = "APuzhYdNWQSenbreru4Iuz";
var client = __WEBPACK_IMPORTED_MODULE_8_filestack_js__["a" /* default */].init(apikey);
var DOCUMENT_SECTIONS = {
  Contract: ['BRAND', 'EVENT_SEGMENTS', 'LINE_ITEMS', 'TERMS', 'SIGNATURE_BLOCKS'],
  Estimate: ['BRAND', 'RECIPIENT', 'EVENT_SEGMENTS', 'LINE_ITEMS', 'NOTES'],
  Invoice: ['BRAND', 'RECIPIENT', 'EVENT_SEGMENTS', 'LINE_ITEMS', 'PAYMENT_PLAN'],
  Form: ['BRAND', 'FORM'],
  MusicPlanner: ['BRAND', 'DESCRIPTION', 'PLAYLISTS', 'NOTES']
};
var SECTION_LABELS = {
  BRAND: 'Brand',
  DESCRIPTION: 'Description',
  RECIPIENT: 'Recipient',
  FORM: 'Form Questions',
  EVENT_SEGMENTS: 'Schedule',
  LINE_ITEMS: 'Line Items',
  NOTES: 'Notes',
  PLAYLISTS: 'Playlists',
  SIGNATURE_BLOCKS: 'Signature Blocks',
  TERMS: 'Terms',
  PAYMENT_PLAN: 'Payment Plan'
};

var NewDocument = function (_React$Component) {
  _inherits(NewDocument, _React$Component);

  function NewDocument(props) {
    _classCallCheck(this, NewDocument);

    var _this = _possibleConstructorReturn(this, (NewDocument.__proto__ || Object.getPrototypeOf(NewDocument)).call(this, props));

    _this.state = {
      selectedWorkspace: _this.props.node && _this.props.node.workspaces.edges.length > 0 ? _this.props.node.workspaces.edges[0].node.id : '__new_ws__',
      selectedContractTemplate: _this.props.location.query.id || '__none__',
      selectedFormTemplate: _this.props.location.query.id || '__none__',
      selectedMpTemplate: _this.props.location.query.id || '__none__',
      selectedSections: [],
      selectedDocument: '__none__',
      lastUploaded: new Date()
    };

    _this.getDocument = _this.getDocument.bind(_this);
    _this.getCopiableSections = _this.getCopiableSections.bind(_this);
    _this.getWorkspaceDocuments = _this.getWorkspaceDocuments.bind(_this);

    _this.handleContractTemplateChange = _this.handleContractTemplateChange.bind(_this);
    _this.handleWorkspaceChange = _this.handleWorkspaceChange.bind(_this);
    _this.handleFormTemplateChange = _this.handleFormTemplateChange.bind(_this);
    _this.handleMpTemplateChange = _this.handleMpTemplateChange.bind(_this);
    _this.handleDocumentChange = _this.handleDocumentChange.bind(_this);

    _this.onValidDocumentSubmit = _this.onValidDocumentSubmit.bind(_this);
    _this.onInvalidDocumentSubmit = _this.onInvalidDocumentSubmit.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onSectionToggle = _this.onSectionToggle.bind(_this);

    _this.openPicker = _this.openPicker.bind(_this);
    _this.createWupload = _this.createWupload.bind(_this);
    _this.createContract = _this.createContract.bind(_this);
    _this.createEstimate = _this.createEstimate.bind(_this);
    _this.createInvoice = _this.createInvoice.bind(_this);
    _this.createForm = _this.createForm.bind(_this);
    _this.createMusicPlanner = _this.createMusicPlanner.bind(_this);
    _this.isCopiable = _this.isCopiable.bind(_this);
    return _this;
  }

  _createClass(NewDocument, [{
    key: 'onValidDocumentSubmit',
    value: function onValidDocumentSubmit() {
      var _this2 = this;

      var createDocument = function (documentType) {
        switch (documentType) {
          case 'contract':
            return _this2.createContract;
          case 'estimate':
            return _this2.createEstimate;
          case 'invoice':
            return _this2.createInvoice;
          case 'form':
            return _this2.createForm;
          case 'file':
            return _this2.openPicker;
          case 'music list':
            return _this2.createMusicPlanner;
          default:
            return _this2.createEstimate;
        }
      }(this.props.documentType);

      if (this.state.selectedWorkspace === '__new_ws__') {
        this.props.createWorkspace(createDocument);
      } else {
        createDocument(this.state.selectedWorkspace);
        this.onClose();
      }
    }
  }, {
    key: 'onInvalidDocumentSubmit',
    value: function onInvalidDocumentSubmit() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to create ' + this.props.documentType,
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({
        selectedDocument: '__none__',
        selectedContractTemplate: '__none__',
        selectedFormTemplate: '__none__',
        selectedMpTemplate: '__none__',
        selectedSections: [],
        selectedWorkspace: this.props.node && this.props.node.workspaces.edges.length > 0 ? this.props.node.workspaces.edges[0].node.id : '__new_ws__'
      });
      this.props.closeNewDocumentModal();
    }
  }, {
    key: 'onSectionToggle',
    value: function onSectionToggle(e, data) {
      var selectedSections = this.state.selectedSections;
      if (data.checked) {
        this.setState({ selectedSections: selectedSections.concat(data.name) });
      } else {
        this.setState({
          selectedSections: selectedSections.filter(function (s) {
            return s !== data.name;
          })
        });
      }
    }
  }, {
    key: 'getDocument',
    value: function getDocument(id) {
      var matches = this.getWorkspaceDocuments().filter(function (document) {
        return document.node.id === id;
      });
      return matches.length > 0 ? matches[0] : null;
    }
  }, {
    key: 'getCopiableSections',
    value: function getCopiableSections() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["intersection"])(DOCUMENT_SECTIONS[
      // eslint-disable-next-line no-underscore-dangle
      this.getDocument(this.state.selectedDocument).node.__typename], DOCUMENT_SECTIONS[this.props.documentType.toLowerCase().split(' ').map(function (type) {
        return type.charAt(0).toUpperCase() + type.slice(1);
      }).join('')]);
    }
  }, {
    key: 'getWorkspaceDocuments',
    value: function getWorkspaceDocuments() {
      var workspaceDocuments = [];
      this.props.node.workspaces.edges.map(function (workspace) {
        var contracts = workspace.node.contracts.edges;
        var forms = workspace.node.forms.edges;
        var estimates = workspace.node.estimates.edges;
        var invoices = workspace.node.invoices.edges;
        var musicPlanners = workspace.node.music_planners.edges;
        if (contracts.length > 0) workspaceDocuments.push.apply(workspaceDocuments, _toConsumableArray(contracts));
        if (forms.length > 0) workspaceDocuments.push.apply(workspaceDocuments, _toConsumableArray(forms));
        if (estimates.length > 0) workspaceDocuments.push.apply(workspaceDocuments, _toConsumableArray(estimates));
        if (invoices.length > 0) workspaceDocuments.push.apply(workspaceDocuments, _toConsumableArray(invoices));
        if (musicPlanners.length > 0) workspaceDocuments.push.apply(workspaceDocuments, _toConsumableArray(musicPlanners));
        return workspace;
      });
      return workspaceDocuments;
    }
  }, {
    key: 'handleContractTemplateChange',
    value: function handleContractTemplateChange(e) {
      this.setState({ selectedContractTemplate: e.target.value });
    }
  }, {
    key: 'handleFormTemplateChange',
    value: function handleFormTemplateChange(e) {
      this.setState({ selectedFormTemplate: e.target.value });
    }
  }, {
    key: 'handleMpTemplateChange',
    value: function handleMpTemplateChange(e) {
      this.setState({ selectedMpTemplate: e.target.value });
    }
  }, {
    key: 'handleWorkspaceChange',
    value: function handleWorkspaceChange(e) {
      this.setState({ selectedWorkspace: e.target.value });
    }
  }, {
    key: 'handleDocumentChange',
    value: function handleDocumentChange(e) {
      this.setState({
        selectedDocument: e.target.value,
        selectedSections: e.target.value === '__none__' ? [] : // eslint-disable-next-line no-underscore-dangle
        DOCUMENT_SECTIONS[this.getDocument(e.target.value).node.__typename]
      });
    }
  }, {
    key: 'isCopiable',
    value: function isCopiable(documentType) {
      return ['contract', 'estimate', 'form', 'music list', 'invoice'].includes(documentType);
    }
  }, {
    key: 'openPicker',
    value: function openPicker(workspaceId) {
      var _this3 = this;

      client.pick({
        maxFiles: 5,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        }
      }).then(function (res) {
        res.filesUploaded.map(function (file) {
          _this3.createWupload({
            name: file.filename,
            url: 'https://s3.amazonaws.com/cb-user-uploads/' + file.key,
            mimetype: file.mimetype,
            source: file.source,
            size: file.size,
            handle: file.handle
          }, workspaceId);
          return file;
        });
      });
    }
  }, {
    key: 'createContract',
    value: function createContract(workspaceId) {
      var _this4 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create contract',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created contract',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this4.props.router.push('/docs/c/' + response.createContract.contract.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-contract', { origin: 'overview' });
        _this4.onClose();
      };

      var cTemplateId = this.state.selectedContractTemplate !== '__none__' ? this.state.selectedContractTemplate : null;

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3343);
      });

      var environment = this.props.relay.environment;
      var copyDocument = this.state.selectedSections.length === 0 ? null : {
        document_id: this.getDocument(this.state.selectedDocument).node.id,
        include_only: this.state.selectedSections
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            copy_document: copyDocument,
            workspace_ids: [workspaceId],
            title: this.props.title,
            copy_user_event_segments: true,
            add_default_signature_block: false,
            c_template_id: cTemplateId
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createEstimate',
    value: function createEstimate(workspaceId) {
      var _this5 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create estimate',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created estimate',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this5.props.router.push('/docs/e/' + response.createEstimate.estimate.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-estimate', { origin: 'overview' });
        _this5.onClose();
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3344);
      });

      var environment = this.props.relay.environment;
      var copyDocument = this.state.selectedSections.length === 0 ? null : {
        document_id: this.getDocument(this.state.selectedDocument).node.id,
        include_only: this.state.selectedSections
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            copy_document: copyDocument,
            workspace_ids: [workspaceId],
            title: this.props.title,
            copy_user_event_segments: true
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createInvoice',
    value: function createInvoice(workspaceId) {
      var _this6 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create invoice',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created invoice',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this6.props.router.push('/docs/i/' + response.createInvoice.invoice.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-invoice', { origin: 'overview' });
        _this6.onClose();
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3346);
      });

      var environment = this.props.relay.environment;
      var copyDocument = this.state.selectedSections.length === 0 ? null : {
        document_id: this.getDocument(this.state.selectedDocument).node.id,
        include_only: this.state.selectedSections
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            copy_document: copyDocument,
            workspace_ids: [workspaceId],
            title: this.props.title,
            copy_user_event_segments: true
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createForm',
    value: function createForm(workspaceId) {
      var _this7 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create form',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created form',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this7.props.router.push('/docs/f/' + response.createForm.form.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-form', { origin: 'overview' });
        _this7.onClose();
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3345);
      });

      var environment = this.props.relay.environment;

      var formTemplateId = this.state.selectedFormTemplate !== '__none__' ? this.state.selectedFormTemplate : null;

      var copyDocument = this.state.selectedSections.length === 0 ? null : {
        document_id: this.getDocument(this.state.selectedDocument).node.id,
        include_only: this.state.selectedSections
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            copy_document: copyDocument,
            workspace_id: workspaceId,
            title: this.props.title,
            form_template_id: formTemplateId,
            data: formTemplateId ? null : JSON.stringify({}),
            schema: formTemplateId ? null : JSON.stringify({
              type: 'object',
              properties: {}
            }),
            ui_schema: formTemplateId ? null : JSON.stringify({
              'ui:order': []
            })
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createMusicPlanner',
    value: function createMusicPlanner(workspaceId) {
      var _this8 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create music list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted(response) {
        __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully created music list',
          intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
        });
        _this8.props.router.push('/docs/m/' + response.createMusicPlanner.music_planner.id + '/edit');
        __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('created-music-planner', { origin: 'overview' });
        _this8.onClose();
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3347);
      });

      var environment = this.props.relay.environment;

      var mpTemplateId = this.state.selectedMpTemplate !== '__none__' ? this.state.selectedMpTemplate : null;

      var copyDocument = this.state.selectedSections.length === 0 ? null : {
        document_id: this.getDocument(this.state.selectedDocument).node.id,
        include_only: this.state.selectedSections
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            copy_document: copyDocument,
            mp_template_id: mpTemplateId,
            workspace_id: workspaceId,
            title: this.props.title
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'createWupload',
    value: function createWupload(fields, workspaceId) {
      var _this9 = this;

      var onError = function onError() {
        if (new Date() - _this9.state.lastUploaded > 3000) {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Unable to upload file',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
          });
          _this9.setState({ lastUploaded: new Date() });
        }
      };
      var onCompleted = function onCompleted() {
        if (new Date() - _this9.state.lastUploaded > 3000) {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Successfully uploaded files',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
          });
          _this9.setState({ lastUploaded: new Date() });
          __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('uploaded-file');
        }
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3348);
      });

      var environment = this.props.relay.environment;
      var parentID = workspaceId || this.state.selectedWorkspace;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_wupload_edge',
        connectionInfo: [{
          key: 'WorkspacesContainer_wuploads',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            workspace_id: parentID
          }, fields)
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      var event = this.props.node;
      var workspaceOptions = event ? event.workspaces.edges.slice().map(function (workspace) {
        return {
          text: workspace.node.title,
          value: workspace.node.id
        };
      }).concat({ text: 'Add New', value: '__new_ws__' }) : [];

      var contractTemplateOptions = [{ text: 'None', value: '__none__' }].concat(this.props.viewer ? this.props.viewer.c_templates.edges.slice().map(function (template) {
        return {
          text: template.node.title,
          value: template.node.id
        };
      }) : []);

      var formTemplateOptions = [{ text: 'None', value: '__none__' }].concat(this.props.viewer ? this.props.viewer.form_templates.edges.slice().map(function (template) {
        return {
          text: template.node.title,
          value: template.node.id
        };
      }) : []);

      var mpTemplateOptions = [{ text: 'None', value: '__none__' }].concat(this.props.viewer ? this.props.viewer.mp_templates.edges.slice().map(function (template) {
        return {
          text: template.node.title,
          value: template.node.id
        };
      }) : []);

      var helpIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'help circle' });

      var workspaceHelpContent = 'A workspace is a folder that you can\n    optionally share with your client, team, or other vendors.';

      var documentOptions = [{ text: 'None', value: '__none__' }].concat(this.getWorkspaceDocuments().map(function (workspaceDocument) {
        return {
          value: workspaceDocument.node.id,
          text: workspaceDocument.node.title
        };
      }));

      var createDocumentForm = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
        {
          onValidSubmit: this.onValidDocumentSubmit,
          onInvalidSubmit: this.onInvalidDocumentSubmit,
          ref: 'form'
        },
        this.props.documentType !== 'file' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Give your ',
            this.props.documentType,
            ' a title'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
            label: 'Title',
            name: 'title',
            value: this.props.title,
            onChange: this.props.handleTitleChange,
            required: true,
            validationError: 'Title is required',
            submitted: this.state.submitted
          })
        ),
        this.props.documentType === 'contract' && this.props.viewer.c_templates.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Select a template'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
            label: 'Template',
            name: 'c_template_id',
            value: this.state.selectedContractTemplate || '__none__',
            onChange: this.handleContractTemplateChange,
            submitted: this.state.submitted,
            options: contractTemplateOptions,
            fluid: true
          })
        ),
        this.props.documentType === 'form' && this.props.viewer.form_templates.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Select a template'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
            label: 'Template',
            name: 'form_template_id',
            value: this.state.selectedFormTemplate || '__none__',
            onChange: this.handleFormTemplateChange,
            submitted: this.state.submitted,
            options: formTemplateOptions,
            fluid: true
          })
        ),
        this.props.documentType === 'music list' && this.props.viewer.mp_templates.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Select a template'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
            label: 'Template',
            name: 'mp_template_id',
            value: this.state.selectedMpTemplate || '__none__',
            onChange: this.handleMpTemplateChange,
            submitted: this.state.submitted,
            options: mpTemplateOptions,
            fluid: true
          })
        ),
        this.getWorkspaceDocuments().length > 0 && this.isCopiable(this.props.documentType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Copy information from existing document'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
            label: 'Document',
            name: 'document_id',
            value: this.state.selectedDocument || '__none__',
            onChange: this.handleDocumentChange,
            submitted: this.state.submitted,
            options: documentOptions,
            fluid: true
          }),
          this.getDocument(this.state.selectedDocument) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.getCopiableSections().map(function (section, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, style: { marginTop: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Checkbox */], {
                  checked: _this10.state.selectedSections.includes(section),
                  label: SECTION_LABELS[section],
                  name: section,
                  onChange: _this10.onSectionToggle
                })
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Save ',
          this.props.documentType,
          ' to a workspace ',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Popup */], {
            trigger: helpIcon,
            on: 'hover',
            inverted: true,
            content: workspaceHelpContent,
            size: 'large'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["f" /* FloatingLabelSelect */], {
          label: 'Workspace',
          name: 'workspace',
          value: this.state.selectedWorkspace,
          onChange: this.handleWorkspaceChange,
          submitted: this.state.submitted,
          placeholder: 'Type...',
          options: workspaceOptions,
          fluid: true
        }),
        this.state.selectedWorkspace === '__new_ws__' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["e" /* FloatingLabelInput */], {
          label: 'Workspace Title',
          name: 'workspace',
          placeholder: '(Eg. Client)',
          value: this.props.newWorkspaceTitle,
          onChange: this.props.handleNewWorkspaceTitleChange,
          required: true,
          validationError: 'Title is required',
          submitted: this.state.submitted
        })
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */],
              {
                open: _this10.props.newDocumentModalOpen,
                onClose: _this10.onClose,
                size: 'small'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Header */], { content: 'Create ' + _this10.props.documentType }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Content,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { maxWidth: '480px', margin: '0 auto' } },
                  createDocumentForm
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Modal */].Actions,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: _this10.onClose, className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.modalCancel },
                  'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                  primary: true,
                  content: 'Create ' + _this10.props.documentType,
                  onClick: function onClick() {
                    return _this10.refs.form.submit();
                  }
                })
              )
            ),
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */],
              {
                open: _this10.props.newDocumentModalOpen,
                onClose: _this10.onClose
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'item', onClick: _this10.onClose },
                    'Cancel'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Content,
                null,
                createDocumentForm,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
                  primary: true,
                  fluid: true,
                  onClick: function onClick() {
                    return _this10.refs.form.submit();
                  },
                  content: 'Create ' + _this10.props.documentType
                })
              )
            )
          );
        }
      );
    }
  }]);

  return NewDocument;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewDocument.propTypes = {
  closeNewDocumentModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  createWorkspace: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  documentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  handleNewWorkspaceTitleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleTitleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  newDocumentModalOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  newWorkspaceTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (NewDocument);

/***/ }),
/* 3302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_estimate_icon_svg__ = __webpack_require__(3640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_estimate_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_estimate_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_invoice_icon_svg__ = __webpack_require__(3643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_invoice_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_invoice_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_contract_icon_svg__ = __webpack_require__(3639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_contract_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_contract_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_form_icon_svg__ = __webpack_require__(3642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_form_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_form_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_file_icon_svg__ = __webpack_require__(3641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_file_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_file_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_workspace_icon_svg__ = __webpack_require__(3660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_workspace_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_workspace_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_music_planner_icon_svg__ = __webpack_require__(3644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_music_planner_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_music_planner_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__ = __webpack_require__(3303);












var NewDocumentMenu = function NewDocumentMenu(_ref) {
  var openNewDocumentModal = _ref.openNewDocumentModal,
      openNewWorkspaceModal = _ref.openNewWorkspaceModal,
      viewer = _ref.viewer;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a.menu },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_estimate_icon_svg___default.a,
        title: 'Estimate',
        description: 'Send pricing information to clients',
        onClick: function onClick() {
          return openNewDocumentModal('estimate');
        },
        color: 'blue',
        style: { paddingTop: 0 }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_5__assets_contract_icon_svg___default.a,
        title: 'Contract',
        description: 'Create an agreement that can be signed online',
        onClick: function onClick() {
          return openNewDocumentModal('contract');
        },
        color: 'purple'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_invoice_icon_svg___default.a,
        title: 'Invoice',
        description: 'Set up a payment schedule and get paid',
        onClick: function onClick() {
          return openNewDocumentModal('invoice');
        },
        color: 'lavender'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_6__assets_form_icon_svg___default.a,
        title: 'Form',
        description: 'Send customized questionnaires',
        onClick: function onClick() {
          return openNewDocumentModal('form');
        },
        color: 'green'
      }),
      viewer.features.music_lists && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_music_planner_icon_svg___default.a,
        title: 'Music List',
        description: 'Collect music requests for your event',
        onClick: function onClick() {
          return openNewDocumentModal('music list');
        },
        color: 'peach'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_file_icon_svg___default.a,
        title: 'File Upload',
        description: 'Upload files that can be shared',
        onClick: function onClick() {
          return openNewDocumentModal('file');
        },
        color: 'orange'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewDocumentMenuItem__["a" /* default */], {
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_workspace_icon_svg___default.a,
        title: 'Workspace',
        description: 'Portal to collaborate with clients & team members',
        onClick: openNewWorkspaceModal,
        color: 'teal',
        style: { paddingBottom: 0 }
      })
    )
  );
};

NewDocumentMenu.propTypes = {
  openNewDocumentModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openNewWorkspaceModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (NewDocumentMenu);

/***/ }),
/* 3303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);





var NewDocumentMenuItem = function NewDocumentMenuItem(_ref) {
  var color = _ref.color,
      description = _ref.description,
      icon = _ref.icon,
      onClick = _ref.onClick,
      style = _ref.style,
      title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a.item, onClick: onClick, style: style },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a.icon },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["e" /* Image */], { src: icon })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: [__WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a.title, __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a[color]].join(' ') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__NewDocumentMenu_scss___default.a.description },
        description
      )
    )
  );
};

NewDocumentMenuItem.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (NewDocumentMenuItem);

/***/ }),
/* 3304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Event_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var NewWorkspace = function (_React$Component) {
  _inherits(NewWorkspace, _React$Component);

  function NewWorkspace(props) {
    _classCallCheck(this, NewWorkspace);

    var _this = _possibleConstructorReturn(this, (NewWorkspace.__proto__ || Object.getPrototypeOf(NewWorkspace)).call(this, props));

    _this.onValidWorkspaceSubmit = _this.onValidWorkspaceSubmit.bind(_this);
    _this.onInvalidWorkspaceSubmit = _this.onInvalidWorkspaceSubmit.bind(_this);
    return _this;
  }

  _createClass(NewWorkspace, [{
    key: 'onValidWorkspaceSubmit',
    value: function onValidWorkspaceSubmit() {
      this.props.createWorkspace();
    }
  }, {
    key: 'onInvalidWorkspaceSubmit',
    value: function onInvalidWorkspaceSubmit() {
      __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to create workspace',
        intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */],
        {
          open: this.props.newWorkspaceModalOpen,
          onClose: this.props.closeNewWorkspaceModal,
          size: 'small'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Header */], { content: 'New workspace' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Content,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_formsy_react___default.a.Form,
            {
              ref: 'newWorkspaceForm',
              onValidSubmit: this.onValidWorkspaceSubmit,
              onInvalidSubmit: this.onInvalidWorkspaceSubmit
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Create a workspace where you can collaborate with your client, team, or other vendors. You can upload files or add estimates and they\'ll be visible to the people you share this workspace with.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["e" /* FloatingLabelInput */], {
                autoFocus: true,
                label: 'Workspace Title',
                type: 'text',
                name: 'title',
                fluid: true,
                autoComplete: 'off',
                value: this.props.newWorkspaceTitle,
                onChange: this.props.handleNewWorkspaceTitleChange,
                required: true,
                validationError: 'Workspace title is required'
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Actions,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              onClick: this.props.closeNewWorkspaceModal,
              className: __WEBPACK_IMPORTED_MODULE_6__Event_scss___default.a.modalCancel
            },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
            primary: true,
            type: 'submit',
            onClick: function onClick() {
              _this2.refs.newWorkspaceForm.submit();
            },
            content: 'Create Workspace',
            disabled: this.props.newWorkspaceTitle === ''
          })
        )
      );
    }
  }]);

  return NewWorkspace;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewWorkspace.propTypes = {
  createWorkspace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleNewWorkspaceTitleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  newWorkspaceModalOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  newWorkspaceTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  closeNewWorkspaceModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (NewWorkspace);

/***/ }),
/* 3305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EventSegment_EventSegmentShow__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EventSegment_EventSegmentMobile__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EventSegment_EventSegmentDesktop__ = __webpack_require__(816);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ScheduleComponent = function (_React$Component) {
  _inherits(ScheduleComponent, _React$Component);

  function ScheduleComponent(props) {
    _classCallCheck(this, ScheduleComponent);

    var _this = _possibleConstructorReturn(this, (ScheduleComponent.__proto__ || Object.getPrototypeOf(ScheduleComponent)).call(this, props));

    _this.toggleSearch = _this.toggleSearch.bind(_this);
    _this.closeSearchHandler = _this.closeSearchHandler.bind(_this);
    _this.eventSegmentChangeHandler = _this.eventSegmentChangeHandler.bind(_this);
    _this.updateEventSegment = _this.updateEventSegment.bind(_this);
    _this.resetEditEventSegment = _this.resetEditEventSegment.bind(_this);
    _this.deleteEventSegment = _this.deleteEventSegment.bind(_this);
    _this.newEventSegmentChangeHandler = _this.newEventSegmentChangeHandler.bind(_this);
    _this.closeNewEventSegmentEditor = _this.closeNewEventSegmentEditor.bind(_this);
    _this.createEventSegment = _this.createEventSegment.bind(_this);
    _this.addEventSegment = _this.addEventSegment.bind(_this);
    _this.resetAddEventSegment = _this.resetAddEventSegment.bind(_this);
    _this.state = {
      showSearch: false,
      localEvent: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node),
      editingNewEventSegment: false
    };
    return _this;
  }

  _createClass(ScheduleComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Update localEvent if any edges are added/deleted
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localEvent.user_event_segments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node.user_event_segments);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      this.setState({ showSearch: !this.state.showSearch });
    }
  }, {
    key: 'closeSearchHandler',
    value: function closeSearchHandler() {
      this.setState({ showSearch: false });
    }
  }, {
    key: 'eventSegmentChangeHandler',
    value: function eventSegmentChangeHandler(eventSegment, idx) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localEvent.user_event_segments.edges[idx].node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'updateEventSegment',
    value: function updateEventSegment(idx, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('updated-event-segment');
      };
      var eventSegment = __WEBPACK_IMPORTED_MODULE_8__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localEvent.user_event_segments.edges[idx].node), ['id', 'title', 'start_at', 'end_at', 'time_zone', 'location', 'line1', 'city', 'province', 'postal_code', 'room', 'notes']));

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3351);
      });

      var optimisticResponse = {
        updateUserEventSegment: { user_event_segment: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(eventSegment) }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({}, eventSegment)
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetEditEventSegment',
    value: function resetEditEventSegment(index) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localEvent.user_event_segments.edges[index] = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.node.user_event_segments.edges[index]);
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'deleteEventSegment',
    value: function deleteEventSegment(idx, successCb, failureCb) {
      var _this2 = this;

      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        _this2.resetEditEventSegment();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted agenda item',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('deleted-event-segment');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3350);
      });

      var environment = this.props.relay.environment;
      var parentID = this.props.node.id;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['user_event', 'user_event_segments'],
        deletedIDFieldName: 'deletedUserEventSegmentId',
        connectionKeys: [{
          key: 'ScheduleContainer_user_event_segments',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.node.user_event_segments.edges[idx].node.id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'resetAddEventSegment',
    value: function resetAddEventSegment() {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      delete obj.localEvent.newEventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'createEventSegment',
    value: function createEventSegment(index, successCb, failureCb) {
      var _this3 = this;

      /* eslint-disable no-unused-vars */
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.state);
        delete obj.localEvent.newEventSegment;
        _this3.setState(_extends({}, obj));
        __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully added event information',
          intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_4__Modules__["c" /* Analytics */].trackEvent('created-event-segment');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3349);
      });

      var eventSegment = __WEBPACK_IMPORTED_MODULE_8__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.localEvent.newEventSegment.node), 'all_day'));

      eventSegment.title = eventSegment.title || '(Untitled Agenda Item)';

      var parentID = this.props.node.id;

      var environment = this.props.relay.environment;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: _extends({
            user_event_id: parentID
          }, eventSegment)
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'addEventSegment',
    value: function addEventSegment(e) {
      e.preventDefault();
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.editingNewEventSegment = true;
      if (!this.state.localEvent.newEventSegment) {
        obj.localEvent.newEventSegment = { node: { all_day: true } };
      }
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'newEventSegmentChangeHandler',
    value: function newEventSegmentChangeHandler(eventSegment) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.localEvent.newEventSegment.node = eventSegment;
      this.setState(_extends({}, obj));
    }
  }, {
    key: 'closeNewEventSegmentEditor',
    value: function closeNewEventSegmentEditor() {
      this.setState({ editingNewEventSegment: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var event = this.props.node;
      var _state = this.state,
          localEvent = _state.localEvent,
          editingNewEventSegment = _state.editingNewEventSegment;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        event.user_event_segments.edges.length === 0 && !localEvent.newEventSegment && !this.props.readOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { textAlign: 'center', padding: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            null,
            'This event has no agenda items'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_semantic_ui_react__["b" /* Button */], {
            basic: true,
            icon: 'plus',
            labelPosition: 'left',
            content: 'Add Time and Place',
            onClick: this.addEventSegment
          })
        ),
        !this.props.readOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          event.user_event_segments.edges.map(function (eventSegment, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: eventSegment.node.id || idx,
                className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__Modules__["k" /* Dthc */],
                {
                  eventSegment: eventSegment.node,
                  localEventSegment: localEvent.user_event_segments.edges[idx].node,
                  onChange: function onChange(segment) {
                    _this4.eventSegmentChangeHandler(segment, idx);
                  },
                  commitUpdate: _this4.updateEventSegment,
                  desktop: __WEBPACK_IMPORTED_MODULE_12__EventSegment_EventSegmentDesktop__["a" /* default */],
                  mobile: __WEBPACK_IMPORTED_MODULE_11__EventSegment_EventSegmentMobile__["a" /* default */],
                  index: idx,
                  reset: _this4.resetEditEventSegment,
                  'delete': _this4.deleteEventSegment,
                  viewer: _this4.props.viewer
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__EventSegment_EventSegmentShow__["a" /* default */], { noBorder: true, compact: true, eventSegment: eventSegment.node })
              )
            );
          })
        ),
        this.props.readOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          event.user_event_segments.edges.map(function (eventSegment, idx) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                key: eventSegment.node.id || idx,
                className: __WEBPACK_IMPORTED_MODULE_5__Event_scss___default.a.verticalSpacing
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__EventSegment_EventSegmentShow__["a" /* default */], {
                noBorder: true,
                readOnly: _this4.props.readOnly,
                eventSegment: eventSegment.node
              })
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default.a,
          {
            transitionName: 'slide',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
          },
          localEvent.newEventSegment && editingNewEventSegment && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["k" /* Dthc */],
              {
                eventSegment: localEvent.newEventSegment.node,
                localEventSegment: localEvent.newEventSegment.node,
                onChange: function onChange(segment) {
                  _this4.newEventSegmentChangeHandler(segment);
                },
                commitUpdate: this.createEventSegment,
                desktop: __WEBPACK_IMPORTED_MODULE_12__EventSegment_EventSegmentDesktop__["a" /* default */],
                mobile: __WEBPACK_IMPORTED_MODULE_11__EventSegment_EventSegmentMobile__["a" /* default */],
                reset: this.resetAddEventSegment,
                initiallyOpen: true,
                isNew: true,
                'delete': this.resetAddEventSegment,
                closeEditor: this.closeNewEventSegmentEditor,
                editorOpen: editingNewEventSegment,
                viewer: this.props.viewer
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__EventSegment_EventSegmentShow__["a" /* default */], {
                eventSegment: localEvent.newEventSegment.node
              })
            )
          )
        ),
        event.user_event_segments.edges.length > 0 && !this.props.readOnly && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginTop: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { onClick: this.addEventSegment },
            '+ Add Time and Place'
          )
        )
      );
    }
  }]);

  return ScheduleComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ScheduleComponent.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ScheduleComponent);

/***/ }),
/* 3306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleComponent__ = __webpack_require__(3305);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__ScheduleComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3353);
  },
  node: function node() {
    return __webpack_require__(3352);
  }
}));

/***/ }),
/* 3307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_AppComponent__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__ = __webpack_require__(106);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var blurringStartsAt = false;

var UpdateEventDate = function (_Component) {
  _inherits(UpdateEventDate, _Component);

  function UpdateEventDate(props) {
    _classCallCheck(this, UpdateEventDate);

    var _this = _possibleConstructorReturn(this, (UpdateEventDate.__proto__ || Object.getPrototypeOf(UpdateEventDate)).call(this, props));

    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.eventFieldChange = _this.eventFieldChange.bind(_this);
    _this.allDayChange = _this.allDayChange.bind(_this);
    _this.startAtChange = _this.startAtChange.bind(_this);
    _this.endAtChange = _this.endAtChange.bind(_this);
    _this.tzChange = _this.tzChange.bind(_this);
    _this.generateKey = _this.generateKey.bind(_this);
    _this.handleBlurringStartsAt = _this.handleBlurringStartsAt.bind(_this);
    _this.state = {
      event: _this.getEventDefaults(),
      endAtKey: _this.generateKey()
    };
    return _this;
  }

  _createClass(UpdateEventDate, [{
    key: 'getEventDefaults',
    value: function getEventDefaults() {
      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.event);
      var hasTimes = event.start_at && event.end_at;
      if (!hasTimes && event.user_event) {
        event.start_at = event.user_event.start_at;
        event.end_at = event.user_event.end_at;
        event.time_zone = event.user_event.time_zone;
        event.all_day = event.user_event.start_at && event.user_event.start_at.length === 10;
      }
      event.time_zone = event.time_zone || this.props.viewer && this.props.viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.guess();
      return event;
    }
  }, {
    key: 'endAtChange',
    value: function endAtChange(e) {
      this.eventFieldChange('end_at', e.target.value);
    }
  }, {
    key: 'startAtChange',
    value: function startAtChange(e) {
      this.eventFieldChange('start_at', e.target.value);
      if ((!this.state.event.end_at || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.end_at) <= __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value)) && blurringStartsAt) {
        var isDate = e.target.value.length === 10;
        if (isDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
          this.eventFieldChange('end_at', e.target.value);
        } else if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).isValid()) {
          this.eventFieldChange('end_at', __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).add(4, 'hours').toDate().toISOString());
          this.setState({ endAtKey: this.generateKey() });
        }
      }
    }
  }, {
    key: 'handleBlurringStartsAt',
    value: function handleBlurringStartsAt(blurring) {
      blurringStartsAt = blurring;
    }
  }, {
    key: 'tzChange',
    value: function tzChange(e, _ref) {
      var value = _ref.value;
      var _state$event = this.state.event,
          all_day = _state$event.all_day,
          start_at = _state$event.start_at,
          end_at = _state$event.end_at,
          time_zone = _state$event.time_zone;

      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(start_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.eventFieldChange('start_at', __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(start_at, all_day, time_zone));
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(end_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.eventFieldChange('end_at', __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(end_at, all_day, time_zone));
      }
      this.eventFieldChange('time_zone', value);
    }
  }, {
    key: 'allDayChange',
    value: function allDayChange(allDay) {
      this.eventFieldChange('all_day', allDay);
      var timeZone = this.state.event.time_zone;
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.start_at).isValid()) {
        var startAt = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(this.state.event.start_at, allDay, timeZone);
        this.eventFieldChange('start_at', startAt);
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.end_at).isValid()) {
        var endAt = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(this.state.event.end_at, allDay, timeZone);
        this.eventFieldChange('end_at', endAt);
      }
    }
  }, {
    key: 'generateKey',
    value: function generateKey() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.eventFieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'eventFieldChange',
    value: function eventFieldChange(key, value) {
      this.setState(function (previousState) {
        var obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(previousState);
        obj.event[key] = value;
        return obj;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          endAtKey = _state.endAtKey,
          event = _state.event;
      var submitted = this.props.submitted;
      var viewer = this.props.viewer;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__App_AppComponent__["a" /* AppConsumer */],
        null,
        function (_ref2) {
          var isComputer = _ref2.isComputer;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { marginBottom: '2em' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'When you share this event, collaborators will be able to see the event dates below.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["m" /* CardCheckbox */], {
                label: 'All-day',
                name: 'all_day',
                checked: event.all_day || false,
                onChange: _this2.allDayChange,
                submitted: submitted
              }),
              !isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["n" /* CardDateTime */], {
                  label: 'Starts',
                  name: 'start_at',
                  placeholder: 'Start Time',
                  timeZone: event.time_zone,
                  value: event.start_at || '',
                  dateOnly: event.all_day || false,
                  onChange: _this2.startAtChange,
                  submitted: submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["n" /* CardDateTime */], {
                  label: 'Ends',
                  name: 'end_at',
                  placeholder: 'End Time',
                  timeZone: event.time_zone,
                  value: event.end_at || '',
                  dateOnly: event.all_day || false,
                  onChange: _this2.endAtChange,
                  submitted: submitted,
                  key: endAtKey,
                  validationError: 'Event must end later than it starts'
                })
              ),
              isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                  label: 'Starts',
                  name: 'start_at',
                  datePlaceholder: 'Start Date',
                  timePlaceholder: 'Start Time',
                  dateOnly: event.all_day,
                  value: event.start_at || '',
                  timeZone: event.time_zone,
                  onChange: _this2.startAtChange,
                  viewer: viewer,
                  submitted: submitted,
                  handleBlurringDatePicker: _this2.handleBlurringStartsAt
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                  label: 'Ends',
                  name: 'end_at',
                  datePlaceholder: 'End Date',
                  timePlaceholder: 'End Time',
                  dateOnly: event.all_day,
                  key: endAtKey,
                  value: event.end_at || '',
                  timeZone: event.time_zone,
                  onChange: _this2.endAtChange,
                  viewer: viewer,
                  submitted: submitted,
                  validationError: 'Event must end later than it starts'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["o" /* CardTZSelect */], {
                label: 'Time Zone',
                name: 'time_zone',
                value: event.time_zone,
                onChange: _this2.tzChange,
                submitted: submitted,
                validationError: 'Time zone is required'
              })
            )
          );
        }
      );
    }
  }]);

  return UpdateEventDate;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UpdateEventDate.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  submitted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (UpdateEventDate);

/***/ }),
/* 3308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_AppComponent__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__ = __webpack_require__(106);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var blurringStartsAt = false;

var ConfirmEventDetails = function (_Component) {
  _inherits(ConfirmEventDetails, _Component);

  function ConfirmEventDetails(props) {
    _classCallCheck(this, ConfirmEventDetails);

    var _this = _possibleConstructorReturn(this, (ConfirmEventDetails.__proto__ || Object.getPrototypeOf(ConfirmEventDetails)).call(this, props));

    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.eventFieldChange = _this.eventFieldChange.bind(_this);
    _this.allDayChange = _this.allDayChange.bind(_this);
    _this.startAtChange = _this.startAtChange.bind(_this);
    _this.endAtChange = _this.endAtChange.bind(_this);
    _this.tzChange = _this.tzChange.bind(_this);
    _this.generateKey = _this.generateKey.bind(_this);
    _this.handleBlurringStartsAt = _this.handleBlurringStartsAt.bind(_this);
    _this.state = {
      event: _this.getEventDefaults(),
      endAtKey: _this.generateKey()
    };
    return _this;
  }

  _createClass(ConfirmEventDetails, [{
    key: 'getEventDefaults',
    value: function getEventDefaults() {
      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.event);
      var hasTimes = event.start_at && event.end_at;
      if (!hasTimes && event.user_event) {
        event.start_at = event.user_event.start_at;
        event.end_at = event.user_event.end_at;
        event.time_zone = event.user_event.time_zone;
        event.all_day = event.user_event.start_at && event.user_event.start_at.length === 10;
      }
      event.time_zone = event.time_zone || this.props.viewer && this.props.viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz.guess();
      return event;
    }
  }, {
    key: 'endAtChange',
    value: function endAtChange(e) {
      this.eventFieldChange('end_at', e.target.value);
    }
  }, {
    key: 'startAtChange',
    value: function startAtChange(e) {
      this.eventFieldChange('start_at', e.target.value);
      if ((!this.state.event.end_at || __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.end_at) <= __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value)) && blurringStartsAt) {
        var isDate = e.target.value.length === 10;
        if (isDate && __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
          this.eventFieldChange('end_at', e.target.value);
        } else if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).isValid()) {
          this.eventFieldChange('end_at', __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(e.target.value).add(4, 'hours').toDate().toISOString());
          this.setState({ endAtKey: this.generateKey() });
        }
      }
    }
  }, {
    key: 'handleBlurringStartsAt',
    value: function handleBlurringStartsAt(blurring) {
      blurringStartsAt = blurring;
    }
  }, {
    key: 'tzChange',
    value: function tzChange(e, _ref) {
      var value = _ref.value;
      var _state$event = this.state.event,
          all_day = _state$event.all_day,
          start_at = _state$event.start_at,
          end_at = _state$event.end_at,
          time_zone = _state$event.time_zone;

      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(start_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.eventFieldChange('start_at', __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(start_at, all_day, time_zone));
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(end_at, __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.ISO_8601).isValid()) {
        this.eventFieldChange('end_at', __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(end_at, all_day, time_zone));
      }
      this.eventFieldChange('time_zone', value);
    }
  }, {
    key: 'allDayChange',
    value: function allDayChange(allDay) {
      this.eventFieldChange('all_day', allDay);
      var timeZone = this.state.event.time_zone;
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.start_at).isValid()) {
        var startAt = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(this.state.event.start_at, allDay, timeZone);
        this.eventFieldChange('start_at', startAt);
      }
      if (__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(this.state.event.end_at).isValid()) {
        var endAt = __WEBPACK_IMPORTED_MODULE_6__lib_utils_date__["a" /* default */].dateToISOString(this.state.event.end_at, allDay, timeZone);
        this.eventFieldChange('end_at', endAt);
      }
    }
  }, {
    key: 'generateKey',
    value: function generateKey() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      this.eventFieldChange(e.target.name, e.target.value);
    }
  }, {
    key: 'eventFieldChange',
    value: function eventFieldChange(key, value) {
      this.setState(function (previousState) {
        var obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(previousState);
        obj.event[key] = value;
        return obj;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          endAtKey = _state.endAtKey,
          event = _state.event;
      var submitted = this.props.submitted;
      var viewer = this.props.viewer;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__App_AppComponent__["a" /* AppConsumer */],
        null,
        function (_ref2) {
          var isComputer = _ref2.isComputer;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { marginBottom: '4em' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                null,
                'Please confirm event details.'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'This information will be shared with any collaborators in this workspace.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["p" /* CardTextArea */], {
                autoFocus: true,
                label: 'Event Title',
                name: 'title',
                placeholder: "Jane's wedding",
                value: event.title || '',
                onChange: _this2.eventFieldChange,
                submitted: submitted,
                validationError: 'Event title is required',
                required: true
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["m" /* CardCheckbox */], {
                label: 'All-day',
                name: 'all_day',
                checked: event.all_day || false,
                onChange: _this2.allDayChange,
                submitted: submitted
              }),
              !isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["n" /* CardDateTime */], {
                  label: 'Starts',
                  name: 'start_at',
                  placeholder: 'Start Time',
                  timeZone: event.time_zone,
                  value: event.start_at || '',
                  dateOnly: event.all_day || false,
                  onChange: _this2.startAtChange,
                  submitted: submitted
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["n" /* CardDateTime */], {
                  label: 'Ends',
                  name: 'end_at',
                  placeholder: 'End Time',
                  timeZone: event.time_zone,
                  value: event.end_at || '',
                  dateOnly: event.all_day || false,
                  onChange: _this2.endAtChange,
                  submitted: submitted,
                  key: endAtKey,
                  validationError: 'Event must end later than it starts'
                })
              ),
              isComputer && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { margin: '1em 0' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                  label: 'Starts',
                  name: 'start_at',
                  datePlaceholder: 'Start Date',
                  timePlaceholder: 'Start Time',
                  dateOnly: event.all_day,
                  value: event.start_at || '',
                  timeZone: event.time_zone,
                  onChange: _this2.startAtChange,
                  viewer: viewer,
                  submitted: submitted,
                  handleBlurringDatePicker: _this2.handleBlurringStartsAt
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["r" /* CardDateTimePicker */], {
                  label: 'Ends',
                  name: 'end_at',
                  datePlaceholder: 'End Date',
                  timePlaceholder: 'End Time',
                  dateOnly: event.all_day,
                  key: endAtKey,
                  value: event.end_at || '',
                  timeZone: event.time_zone,
                  onChange: _this2.endAtChange,
                  viewer: viewer,
                  submitted: submitted,
                  validationError: 'Event must end later than it starts'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["o" /* CardTZSelect */], {
                label: 'Time Zone',
                name: 'time_zone',
                value: event.time_zone,
                onChange: _this2.tzChange,
                submitted: submitted,
                validationError: 'Time zone is required'
              })
            )
          );
        }
      );
    }
  }]);

  return ConfirmEventDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ConfirmEventDetails.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  submitted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConfirmEventDetails);

/***/ }),
/* 3309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 78ee54b8199e8f8db798f977912a613b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEventInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
};
export type ShareWorkspace_UpdateEventMutationVariables = {|
  input: UpdateEventInput
|};
export type ShareWorkspace_UpdateEventMutationResponse = {|
  +updateEvent: ?{|
    +event: ?{|
      +id: string,
      +title: ?string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
    |}
  |}
|};
export type ShareWorkspace_UpdateEventMutation = {|
  variables: ShareWorkspace_UpdateEventMutationVariables,
  response: ShareWorkspace_UpdateEventMutationResponse,
|};
*/

/*
mutation ShareWorkspace_UpdateEventMutation(
  $input: UpdateEventInput!
) {
  updateEvent(input: $input) {
    event {
      id
      title
      start_at
      end_at
      time_zone
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEventInput!"
    }],
    "concreteType": "UpdateEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": null,
      "concreteType": "Event",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "start_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "end_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "time_zone",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShareWorkspace_UpdateEventMutation",
    "id": null,
    "text": "mutation ShareWorkspace_UpdateEventMutation(\n  $input: UpdateEventInput!\n) {\n  updateEvent(input: $input) {\n    event {\n      id\n      title\n      start_at\n      end_at\n      time_zone\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShareWorkspace_UpdateEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ShareWorkspace_UpdateEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6839a4b9055cb4a2d7c25cdc5e9ea237';
module.exports = node;

/***/ }),
/* 3310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b6b365c4e50b9ad1a9d04377e4dce520
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailWorkspaceLinkInput = {
  clientMutationId?: ?string,
  workspace_id: string,
  to: string,
  cc?: ?string,
  subject: string,
  message?: ?string,
};
export type ShareWorkspace_emailWorkspaceLinkMutationVariables = {|
  input: EmailWorkspaceLinkInput
|};
export type ShareWorkspace_emailWorkspaceLinkMutationResponse = {|
  +emailWorkspaceLink: ?{|
    +sent_email_to: ?string,
    +sent_email_cc: ?string,
  |}
|};
export type ShareWorkspace_emailWorkspaceLinkMutation = {|
  variables: ShareWorkspace_emailWorkspaceLinkMutationVariables,
  response: ShareWorkspace_emailWorkspaceLinkMutationResponse,
|};
*/

/*
mutation ShareWorkspace_emailWorkspaceLinkMutation(
  $input: EmailWorkspaceLinkInput!
) {
  emailWorkspaceLink(input: $input) {
    sent_email_to
    sent_email_cc
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailWorkspaceLinkInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "emailWorkspaceLink",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "EmailWorkspaceLinkInput!"
    }],
    "concreteType": "EmailWorkspaceLinkPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_to",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "sent_email_cc",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShareWorkspace_emailWorkspaceLinkMutation",
    "id": null,
    "text": "mutation ShareWorkspace_emailWorkspaceLinkMutation(\n  $input: EmailWorkspaceLinkInput!\n) {\n  emailWorkspaceLink(input: $input) {\n    sent_email_to\n    sent_email_cc\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShareWorkspace_emailWorkspaceLinkMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ShareWorkspace_emailWorkspaceLinkMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '25f558a674d5189bbf9879ccfe6a48fb';
module.exports = node;

/***/ }),
/* 3311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmEventDetails__ = __webpack_require__(3308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Document_Sections_Actions_Share_EmailConfirmation__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Document_Sections_Actions_Share_ShareOptions__ = __webpack_require__(1459);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ShareWorkspace = function (_Component) {
  _inherits(ShareWorkspace, _Component);

  function ShareWorkspace(props) {
    _classCallCheck(this, ShareWorkspace);

    var _this = _possibleConstructorReturn(this, (ShareWorkspace.__proto__ || Object.getPrototypeOf(ShareWorkspace)).call(this, props));

    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.getUserContactEmails = _this.getUserContactEmails.bind(_this);
    _this.toggleLink = _this.toggleLink.bind(_this);
    _this.sendEmail = _this.sendEmail.bind(_this);
    _this.updateEvent = _this.updateEvent.bind(_this);
    _this.state = {
      needsEventInfo: _this.needsEventInfo(),
      showLink: !_this.props.workspace.can_email,
      open: false,
      to: ''
    };
    return _this;
  }

  _createClass(ShareWorkspace, [{
    key: 'onOpen',
    value: function onOpen() {
      this.setState({
        open: true,
        needsEventInfo: this.needsEventInfo(),
        showLink: !this.props.workspace.can_email,
        to: ''
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.setState({ open: false });
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit(model, resetForm, invalidateForm, successCb) {
      if (new Date(model.end_at) < new Date(model.start_at)) {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
        invalidateForm({ end_at: 'Event must end later than it starts' });
      } else {
        this.updateEvent(model, successCb);
      }
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
        message: 'Unable to update event information',
        intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
      });
    }
  }, {
    key: 'getUserContactEmails',
    value: function getUserContactEmails() {
      var contacts = [];
      var event = this.props.event;

      if (event) {
        event.user_contacts.edges.map(function (_ref) {
          var uc = _ref.node;
          return uc.user_contact_emails.edges.map(function (_ref2) {
            var email = _ref2.node;

            contacts.push({
              title: uc.first_name + ' ' + uc.last_name,
              description: email.address,
              value: email.address
            });
            return email;
          });
        });
      }
      return contacts;
    }
  }, {
    key: 'toggleLink',
    value: function toggleLink() {
      this.setState(function (prevState) {
        return { showLink: !prevState.showLink };
      });
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(model, resetForm, invalidateForm, successCb) {
      this.setState({ to: model.to, cc: model.cc });
      var subject = model.subject,
          to = model.to,
          message = model.message;

      var cc = model.cc === '' ? null : model.cc;
      var onCompleted = function onCompleted() {
        successCb();
      };
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to send email',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3310);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: { workspace_id: this.props.workspace.id, to: to, cc: cc, subject: subject, message: message }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'needsEventInfo',
    value: function needsEventInfo() {
      var event = this.props.event;

      return event.can_edit && !(event.start_at && event.end_at && event.title);
    }
  }, {
    key: 'updateEvent',
    value: function updateEvent(model, successCb) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event information',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_2__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event information',
          intent: __WEBPACK_IMPORTED_MODULE_2__Modules__["b" /* Intent */].SUCCESS
        });
        if (successCb) successCb();
      };

      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_utils_nullifyEmptyStrings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].omitTimeZoneWithoutTimes(model));

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3309);
      });

      var title = event.title,
          start_at = event.start_at,
          end_at = event.end_at,
          time_zone = event.time_zone;

      var optimisticResponse = {
        updateEvent: { event: { id: this.props.event.id, title: title, start_at: start_at, end_at: end_at, time_zone: time_zone } }
      };
      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.props.event.id,
            title: title,
            start_at: start_at,
            end_at: end_at,
            time_zone: time_zone
          }
        },
        optimisticResponse: optimisticResponse,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          event = _props.event,
          relay = _props.relay,
          viewer = _props.viewer;
      var _state = this.state,
          needsEventInfo = _state.needsEventInfo,
          showLink = _state.showLink,
          to = _state.to,
          cc = _state.cc;

      var title = 'Share Workspace';
      var documentType = 'workspace';
      var shareButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
        content: 'Share',
        basic: true,
        style: { marginRight: '1em' }
      });
      var permissionsNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Anyone with the link ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'can view'
        ),
        ' this workspace.'
      );
      var steps = [{
        component: __WEBPACK_IMPORTED_MODULE_9__Document_Sections_Actions_Share_ShareOptions__["a" /* default */],
        componentProps: {
          permissionsNode: permissionsNode,
          documentType: documentType,
          shareUrl: "https://www.cloverbook.com" + '/open/w/' + this.props.workspace.share_token,
          emailSuggestions: this.getUserContactEmails(),
          showLink: showLink,
          toggleLink: this.toggleLink,
          canEmail: this.props.workspace.can_email
        },
        title: title,
        actions: {
          primary: {
            content: showLink ? 'Close' : 'Send Email',
            type: showLink ? 'button' : 'submit'
          },
          secondary: { hide: showLink }
        },
        formProps: {
          onValidSubmit: this.sendEmail,
          autoComplete: 'off'
        }
      }];

      if (!showLink) {
        steps.push({
          component: __WEBPACK_IMPORTED_MODULE_8__Document_Sections_Actions_Share_EmailConfirmation__["a" /* default */],
          componentProps: { documentType: documentType, to: to, cc: cc, onClose: this.onClose },
          title: title,
          hideActions: true
        });
      }

      if (needsEventInfo) {
        steps.unshift({
          title: title,
          component: __WEBPACK_IMPORTED_MODULE_4__ConfirmEventDetails__["a" /* default */],
          componentProps: { relay: relay, viewer: viewer, event: event },
          formProps: {
            onValidSubmit: this.onValidSubmit,
            onInvalidSubmit: this.onInvalidSubmit
          },
          actions: {
            primary: {
              content: 'Next',
              type: 'submit'
            },
            secondary: { hide: !needsEventInfo }
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["e" /* Wizard */], {
        steps: steps,
        trigger: shareButton,
        onOpen: this.onOpen,
        onClose: this.onClose
      });
    }
  }]);

  return ShareWorkspace;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ShareWorkspace.propTypes = {
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  workspace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (ShareWorkspace);

/***/ }),
/* 3312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_404__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_chat_png__ = __webpack_require__(3635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_chat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_chat_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideTransition_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_stylesheets_SlideTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TitleInput__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Document_RenameDocument__ = __webpack_require__(3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Share__ = __webpack_require__(3311);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _graphql5, _graphql6, _graphql7, _graphql8;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EventWorkspaces = function (_React$Component) {
  _inherits(EventWorkspaces, _React$Component);

  function EventWorkspaces(props) {
    _classCallCheck(this, EventWorkspaces);

    var _this = _possibleConstructorReturn(this, (EventWorkspaces.__proto__ || Object.getPrototypeOf(EventWorkspaces)).call(this, props));

    _this.state = {
      lastUploaded: new Date(),
      event: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node),
      error: !_this.props.node,
      titleEditor: {
        open: false
      }
    };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.workspaceTitleChangeHandler = _this.workspaceTitleChangeHandler.bind(_this);
    _this.updateWorkspaceTitle = _this.updateWorkspaceTitle.bind(_this);
    _this.getAlreadySigned = _this.getAlreadySigned.bind(_this);
    _this.transition = _this.transition.bind(_this);
    _this.deleteWupload = _this.deleteWupload.bind(_this);
    _this.deleteEstimate = _this.deleteEstimate.bind(_this);
    _this.deleteInvoice = _this.deleteInvoice.bind(_this);
    _this.deleteForm = _this.deleteForm.bind(_this);
    _this.deleteMusicPlanner = _this.deleteMusicPlanner.bind(_this);
    _this.deleteContract = _this.deleteContract.bind(_this);
    _this.openTitleEditor = _this.openTitleEditor.bind(_this);
    _this.closeTitleEditor = _this.closeTitleEditor.bind(_this);
    return _this;
  }

  _createClass(EventWorkspaces, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.node && this.props.location.query.share_token) {
        this.addWorkspaceToSession();
      }
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If adding/removing workspaces, update local copy
      if (nextProps.node.workspaces.edges.length !== this.props.node.workspaces.edges.length) {
        this.setState({ event: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(nextProps.node) });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'getAlreadySigned',
    value: function getAlreadySigned(contract) {
      var alreadySigned = 0;
      contract.contract_signature_blocks.edges.map(function (signatureBlock) {
        if (signatureBlock.node.signed_at) {
          ++alreadySigned;
        }
        return signatureBlock;
      });
      return alreadySigned;
    }
  }, {
    key: 'transition',
    value: function transition(e, location) {
      this.props.router.push(location || '/');
    }
  }, {
    key: 'addWorkspaceToSession',
    value: function addWorkspaceToSession() {
      var _this2 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this2.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null, function () {
          _this2.setState({
            lastUploaded: new Date(),
            event: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.props.node),
            error: !_this2.props.node
          });
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3315);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'openTitleEditor',
    value: function openTitleEditor(e, documentId, documentType, initialTitle) {
      this.setState({
        titleEditor: {
          open: true,
          documentId: documentId,
          documentType: documentType,
          initialTitle: initialTitle
        }
      });
    }
  }, {
    key: 'closeTitleEditor',
    value: function closeTitleEditor() {
      this.setState({ titleEditor: { open: false } });
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'updateWorkspaceTitle',
    value: function updateWorkspaceTitle(index) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update workspace title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated workspace title',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('updated-workspace-title');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3314);
      });
      // eslint-disable-next-line camelcase
      var _state$event$workspac = this.state.event.workspaces.edges[index].node,
          id = _state$event$workspac.id,
          title = _state$event$workspac.title;

      var optimisticResponse = {
        updateWorkspace: { workspace: { id: id, title: title } }
      };
      var environment = this.props.relay.environment;

      if (title !== this.props.node.workspaces.edges[index].node.title) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'deleteWupload',
    value: function deleteWupload(id, parentID) {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete file',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted file',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-wupload');
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3321);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'wuploads'],
        deletedIDFieldName: 'deletedWuploadId',
        connectionKeys: [{
          key: 'WorkspacesContainer_wuploads',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteEstimate',
    value: function deleteEstimate(id, parentID, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete estimate',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted estimate',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-estimate');
      };

      var mutation = _graphql4 || (_graphql4 = function _graphql4() {
        return __webpack_require__(3317);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'estimates'],
        deletedIDFieldName: 'deletedEstimateId',
        connectionKeys: [{
          key: 'EventShowContainer_estimates',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteInvoice',
    value: function deleteInvoice(id, parentID, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete invoice',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted invoice',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-invoice');
      };

      var mutation = _graphql5 || (_graphql5 = function _graphql5() {
        return __webpack_require__(3319);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'invoices'],
        deletedIDFieldName: 'deletedInvoiceId',
        connectionKeys: [{
          key: 'EventShowContainer_invoices',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteContract',
    value: function deleteContract(id, parentID, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete contract',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted contract',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-contract');
      };

      var mutation = _graphql6 || (_graphql6 = function _graphql6() {
        return __webpack_require__(3316);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'contracts'],
        deletedIDFieldName: 'deletedContractId',
        connectionKeys: [{
          key: 'EventShowContainer_contracts',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteForm',
    value: function deleteForm(id, parentID, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete form',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted form',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-form');
      };

      var mutation = _graphql7 || (_graphql7 = function _graphql7() {
        return __webpack_require__(3318);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'forms'],
        deletedIDFieldName: 'deletedFormId',
        connectionKeys: [{
          key: 'WorkspacesContainer_forms',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deleteMusicPlanner',
    value: function deleteMusicPlanner(id, parentID, successCb, failureCb) {
      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete music list',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        if (successCb) successCb();
        __WEBPACK_IMPORTED_MODULE_3__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully deleted music list',
          intent: __WEBPACK_IMPORTED_MODULE_3__Modules__["b" /* Intent */].SUCCESS
        });
        __WEBPACK_IMPORTED_MODULE_3__Modules__["c" /* Analytics */].trackEvent('deleted-music-planner');
      };

      var mutation = _graphql8 || (_graphql8 = function _graphql8() {
        return __webpack_require__(3320);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: parentID,
        pathToConnection: ['workspace', 'music_planners'],
        deletedIDFieldName: 'deletedMusicPlannerId',
        connectionKeys: [{
          key: 'WorkspacesContainer_music_planners',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: id
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'workspaceTitleChangeHandler',
    value: function workspaceTitleChangeHandler(e, index) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.state);
      obj.event.workspaces.edges[index].node.title = e.target.value;
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var titleEditor = this.state.titleEditor;
      var _props = this.props,
          event = _props.node,
          relay = _props.relay,
          viewer = _props.viewer;


      var DocumentSettingsMenu = function DocumentSettingsMenu(_ref) {
        var deletable = _ref.deletable,
            deleteDocument = _ref.deleteDocument,
            document = _ref.document,
            openTitleEditor = _ref.openTitleEditor;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.documentSettingsMenu },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["l" /* Dropdown */],
            {
              floating: true,
              basic: true,
              icon: 'ellipsis vertical',
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["l" /* Dropdown */].Menu,
              { style: { right: 0, left: 'auto' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["l" /* Dropdown */].Item, {
                text: 'Rename',
                onClick: function onClick(e) {
                  return openTitleEditor(e, document.id,
                  // eslint-disable-next-line no-underscore-dangle
                  document.__typename,
                  // eslint-disable-next-line no-underscore-dangle
                  document.__typename === 'Wupload' ? document.name : document.title);
                }
              }),
              deletable && deleteDocument && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["l" /* Dropdown */].Item, {
                text: 'Delete',
                className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.negative,
                onClick: deleteDocument
              })
            )
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        event && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          titleEditor.open && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Document_RenameDocument__["a" /* default */], {
            documentId: titleEditor.documentId,
            documentType: titleEditor.documentType,
            initialTitle: titleEditor.initialTitle,
            onClose: this.closeTitleEditor,
            relay: relay
          }),
          event.workspaces.edges.map(function (workspace, index) {
            var _React$createElement;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */],
              (_React$createElement = {
                padded: true,
                verticalAlign: 'middle',
                key: workspace.id || index,
                style: { paddingBottom: '4em' }
              }, _defineProperty(_React$createElement, 'verticalAlign', 'top'), _defineProperty(_React$createElement, 'stackable', true), _React$createElement),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Row,
                { columns: 'equal' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  event.can_edit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_formsy_react___default.a.Form,
                    { className: 'ui form' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'ui transparent fluid massive' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3__Modules__["k" /* Dthc */],
                        {
                          desktop: __WEBPACK_IMPORTED_MODULE_12__TitleInput__["a" /* default */],
                          mobile: __WEBPACK_IMPORTED_MODULE_12__TitleInput__["a" /* default */],
                          title: workspace.node.title,
                          onChange: function onChange(e) {
                            _this3.workspaceTitleChangeHandler(e, index);
                          },
                          commitUpdate: _this3.updateWorkspaceTitle.bind(null, index),
                          handleClickOutside: true
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.title },
                          workspace.node.title
                        )
                      )
                    )
                  ),
                  !event.can_edit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.title },
                    workspace.node.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                  { textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Share__["a" /* default */], {
                    workspace: workspace.node,
                    event: event,
                    relay: relay,
                    viewer: viewer
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Row,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["t" /* Segment */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 16 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Group,
                            {
                              itemsPerRow: 4,
                              doubling: true,
                              style: { wordBreak: 'break-word' }
                            },
                            workspace.node.contracts.edges.map(function (contract) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick(e) {
                                    return _this3.transition(e, '/docs/c/' + contract.node.id);
                                  },
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard,
                                  color: 'green',
                                  key: contract.node.id
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: contract.node.editable,
                                  deleteDocument: function deleteDocument() {
                                    return _this3.deleteContract(contract.node.id, workspace.node.id);
                                  },
                                  document: contract.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    contract.node.title
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'Contract'
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                                  contract.node.contract_signature_blocks.edges.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    null,
                                    _this3.getAlreadySigned(contract.node) === contract.node.contract_signature_blocks.edges.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                      null,
                                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'em',
                                        null,
                                        'All Parties Signed'
                                      ),
                                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["d" /* Icon */], {
                                        name: 'check circle',
                                        color: 'green'
                                      })
                                    ),
                                    _this3.getAlreadySigned(contract.node) !== contract.node.contract_signature_blocks.edges.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                      null,
                                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'em',
                                        null,
                                        'Awaiting Signatures -',
                                        ' ',
                                        _this3.getAlreadySigned(contract.node),
                                        '/',
                                        contract.node.contract_signature_blocks.edges.length,
                                        ' ',
                                        'Signed'
                                      )
                                    )
                                  ),
                                  contract.node.contract_signature_blocks.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                      'em',
                                      null,
                                      'No Signature Requested'
                                    )
                                  )
                                )
                              );
                            }),
                            workspace.node.estimates.edges.map(function (estimate) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick(e) {
                                    return _this3.transition(e, '/docs/e/' + estimate.node.id);
                                  },
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard,
                                  color: 'orange',
                                  key: estimate.node.id
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: true,
                                  deleteDocument: function deleteDocument() {
                                    return _this3.deleteEstimate(estimate.node.id, workspace.node.id);
                                  },
                                  document: estimate.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    estimate.node.title
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'Estimate'
                                  )
                                )
                              );
                            }),
                            workspace.node.invoices.edges.map(function (invoice) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick(e) {
                                    return _this3.transition(e, '/docs/i/' + invoice.node.id);
                                  },
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard,
                                  color: 'blue',
                                  key: invoice.node.id
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: true,
                                  deleteDocument: function deleteDocument() {
                                    return _this3.deleteInvoice(invoice.node.id, workspace.node.id);
                                  },
                                  document: invoice.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    invoice.node.title
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'Invoice'
                                  )
                                )
                              );
                            }),
                            workspace.node.forms.edges.map(function (form) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick(e) {
                                    return _this3.transition(e, '/docs/f/' + form.node.id);
                                  },
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard,
                                  color: 'yellow',
                                  key: form.node.id
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: true,
                                  deleteDocument: function deleteDocument() {
                                    return _this3.deleteForm(form.node.id, workspace.node.id);
                                  },
                                  document: form.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    form.node.title
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'Form'
                                  )
                                )
                              );
                            }),
                            workspace.node.music_planners.edges.map(function (musicPlanner) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick(e) {
                                    return _this3.transition(e, '/docs/m/' + musicPlanner.node.id + '/' + (musicPlanner.node.can_edit ? 'edit' : 'preview'));
                                  },
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard,
                                  color: 'yellow',
                                  key: musicPlanner.node.id
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: true,
                                  deleteDocument: function deleteDocument() {
                                    return _this3.deleteMusicPlanner(musicPlanner.node.id, workspace.node.id);
                                  },
                                  document: musicPlanner.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    musicPlanner.node.title
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'Music List'
                                  )
                                )
                              );
                            }),
                            workspace.node.wuploads.edges.map(function (wupload) {
                              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */],
                                {
                                  onClick: function onClick() {
                                    window.location = wupload.node.url;
                                  },
                                  key: wupload.node.id,
                                  color: 'grey',
                                  className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.workspaceCard
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DocumentSettingsMenu, {
                                  deletable: true,
                                  deleteDocument: _this3.deleteWupload.bind(null, wupload.node.id, workspace.node.id),
                                  document: wupload.node,
                                  openTitleEditor: _this3.openTitleEditor
                                }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Content,
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Header,
                                    { className: __WEBPACK_IMPORTED_MODULE_9__Event_scss___default.a.cardTitle },
                                    wupload.node.name
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["x" /* Card */].Meta,
                                    null,
                                    'File Upload'
                                  )
                                )
                              );
                            })
                          ),
                          workspace.node.contracts.edges.length === 0 && workspace.node.estimates.edges.length === 0 && workspace.node.invoices.edges.length === 0 && workspace.node.forms.edges.length === 0 && workspace.node.music_planners.edges.length === 0 && workspace.node.wuploads.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            {
                              style: { textAlign: 'center', padding: '2em' }
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_semantic_ui_react__["e" /* Image */], {
                              src: __WEBPACK_IMPORTED_MODULE_8__assets_chat_png___default.a,
                              style: {
                                margin: '0 auto',
                                marginBottom: '2em'
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'p',
                              {
                                style: {
                                  color: 'rgba(0,0,0,0.65)',
                                  maxWidth: '600px',
                                  fontSize: '1.28rem',
                                  margin: '0 auto'
                                }
                              },
                              'This is a shared space where you can collaborate with your client, team, or other vendors. You can upload files or add estimates here and they\'ll be visible to the people you share this space with.'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            );
          })
        ),
        !event && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App_404__["a" /* default */], { viewer: viewer }),
          !this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return EventWorkspaces;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

EventWorkspaces.propTypes = {
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  relay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EventWorkspaces);

/***/ }),
/* 3313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkspacesComponent__ = __webpack_require__(3312);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__WorkspacesComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3324);
  },
  node: function node() {
    return __webpack_require__(3323);
  }
}, function () {
  return __webpack_require__(3322);
}));

/***/ }),
/* 3314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e730780cb514c5cbc43fab492e2018c7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWorkspaceInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
};
export type WorkspacesComponent_UpdateWorkspaceMutationVariables = {|
  input: UpdateWorkspaceInput
|};
export type WorkspacesComponent_UpdateWorkspaceMutationResponse = {|
  +updateWorkspace: ?{|
    +workspace: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type WorkspacesComponent_UpdateWorkspaceMutation = {|
  variables: WorkspacesComponent_UpdateWorkspaceMutationVariables,
  response: WorkspacesComponent_UpdateWorkspaceMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_UpdateWorkspaceMutation(
  $input: UpdateWorkspaceInput!
) {
  updateWorkspace(input: $input) {
    workspace {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWorkspaceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateWorkspace",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateWorkspaceInput!"
    }],
    "concreteType": "UpdateWorkspacePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "workspace",
      "storageKey": null,
      "args": null,
      "concreteType": "Workspace",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_UpdateWorkspaceMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_UpdateWorkspaceMutation(\n  $input: UpdateWorkspaceInput!\n) {\n  updateWorkspace(input: $input) {\n    workspace {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_UpdateWorkspaceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_UpdateWorkspaceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ffb352fd7f8cba2e0c696c1bbac09189';
module.exports = node;

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a6cf14a022fcf75f791f4450e2fc47e4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddWorkspaceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type WorkspacesComponent_addWorkspaceToSessionMutationVariables = {|
  input: AddWorkspaceToSessionInput
|};
export type WorkspacesComponent_addWorkspaceToSessionMutationResponse = {|
  +addWorkspaceToSession: ?{|
    +workspace: ?{|
      +id: string
    |}
  |}
|};
export type WorkspacesComponent_addWorkspaceToSessionMutation = {|
  variables: WorkspacesComponent_addWorkspaceToSessionMutationVariables,
  response: WorkspacesComponent_addWorkspaceToSessionMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_addWorkspaceToSessionMutation(
  $input: AddWorkspaceToSessionInput!
) {
  addWorkspaceToSession(input: $input) {
    workspace {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddWorkspaceToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addWorkspaceToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddWorkspaceToSessionInput!"
    }],
    "concreteType": "AddWorkspaceToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "workspace",
      "storageKey": null,
      "args": null,
      "concreteType": "Workspace",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_addWorkspaceToSessionMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_addWorkspaceToSessionMutation(\n  $input: AddWorkspaceToSessionInput!\n) {\n  addWorkspaceToSession(input: $input) {\n    workspace {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_addWorkspaceToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_addWorkspaceToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f0f34643c0e824b635ebec58425c5af6';
module.exports = node;

/***/ }),
/* 3316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b55f162175d7ee05f4b0d8bcdaeaa880
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContractInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteContractMutationVariables = {|
  input: DeleteContractInput
|};
export type WorkspacesComponent_deleteContractMutationResponse = {|
  +deleteContract: ?{|
    +deletedContractId: ?string
  |}
|};
export type WorkspacesComponent_deleteContractMutation = {|
  variables: WorkspacesComponent_deleteContractMutationVariables,
  response: WorkspacesComponent_deleteContractMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteContractMutation(
  $input: DeleteContractInput!
) {
  deleteContract(input: $input) {
    deletedContractId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContract",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteContractInput!"
    }],
    "concreteType": "DeleteContractPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedContractId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteContractMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteContractMutation(\n  $input: DeleteContractInput!\n) {\n  deleteContract(input: $input) {\n    deletedContractId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteContractMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd5e760a475cec0762f919f18b9c8efbd';
module.exports = node;

/***/ }),
/* 3317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 766a3ee7d213e49409bd306880183913
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteEstimateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteEstimateMutationVariables = {|
  input: DeleteEstimateInput
|};
export type WorkspacesComponent_deleteEstimateMutationResponse = {|
  +deleteEstimate: ?{|
    +deletedEstimateId: ?string
  |}
|};
export type WorkspacesComponent_deleteEstimateMutation = {|
  variables: WorkspacesComponent_deleteEstimateMutationVariables,
  response: WorkspacesComponent_deleteEstimateMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteEstimateMutation(
  $input: DeleteEstimateInput!
) {
  deleteEstimate(input: $input) {
    deletedEstimateId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteEstimate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteEstimateInput!"
    }],
    "concreteType": "DeleteEstimatePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedEstimateId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteEstimateMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteEstimateMutation(\n  $input: DeleteEstimateInput!\n) {\n  deleteEstimate(input: $input) {\n    deletedEstimateId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteEstimateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c39b62374858978b10564840697aafbd';
module.exports = node;

/***/ }),
/* 3318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f5758cf47ba7a2920f2d0834d85322fa
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFormInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteFormMutationVariables = {|
  input: DeleteFormInput
|};
export type WorkspacesComponent_deleteFormMutationResponse = {|
  +deleteForm: ?{|
    +deletedFormId: ?string
  |}
|};
export type WorkspacesComponent_deleteFormMutation = {|
  variables: WorkspacesComponent_deleteFormMutationVariables,
  response: WorkspacesComponent_deleteFormMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteFormMutation(
  $input: DeleteFormInput!
) {
  deleteForm(input: $input) {
    deletedFormId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteForm",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteFormInput!"
    }],
    "concreteType": "DeleteFormPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedFormId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteFormMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteFormMutation(\n  $input: DeleteFormInput!\n) {\n  deleteForm(input: $input) {\n    deletedFormId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteFormMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a70e6c7491a9c6b4f18b4276e8160cf5';
module.exports = node;

/***/ }),
/* 3319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 012ff9557047a9670b02f4def8f30d76
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteInvoiceMutationVariables = {|
  input: DeleteInvoiceInput
|};
export type WorkspacesComponent_deleteInvoiceMutationResponse = {|
  +deleteInvoice: ?{|
    +deletedInvoiceId: ?string
  |}
|};
export type WorkspacesComponent_deleteInvoiceMutation = {|
  variables: WorkspacesComponent_deleteInvoiceMutationVariables,
  response: WorkspacesComponent_deleteInvoiceMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteInvoiceMutation(
  $input: DeleteInvoiceInput!
) {
  deleteInvoice(input: $input) {
    deletedInvoiceId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoice",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteInvoiceInput!"
    }],
    "concreteType": "DeleteInvoicePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedInvoiceId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteInvoiceMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteInvoiceMutation(\n  $input: DeleteInvoiceInput!\n) {\n  deleteInvoice(input: $input) {\n    deletedInvoiceId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e9dc5c1b6d8666958688998d7636aee7';
module.exports = node;

/***/ }),
/* 3320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5fc3376696c32b3c6e791e8c61a2c592
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMusicPlannerInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteMusicPlannerMutationVariables = {|
  input: DeleteMusicPlannerInput
|};
export type WorkspacesComponent_deleteMusicPlannerMutationResponse = {|
  +deleteMusicPlanner: ?{|
    +deletedMusicPlannerId: ?string
  |}
|};
export type WorkspacesComponent_deleteMusicPlannerMutation = {|
  variables: WorkspacesComponent_deleteMusicPlannerMutationVariables,
  response: WorkspacesComponent_deleteMusicPlannerMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteMusicPlannerMutation(
  $input: DeleteMusicPlannerInput!
) {
  deleteMusicPlanner(input: $input) {
    deletedMusicPlannerId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMusicPlanner",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteMusicPlannerInput!"
    }],
    "concreteType": "DeleteMusicPlannerPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedMusicPlannerId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteMusicPlannerMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteMusicPlannerMutation(\n  $input: DeleteMusicPlannerInput!\n) {\n  deleteMusicPlanner(input: $input) {\n    deletedMusicPlannerId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f6cd954c8571e2a5c88080df11cae5ef';
module.exports = node;

/***/ }),
/* 3321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1dd7ad79342ab9ab7b8cac58a3757eb2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteWuploadInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteWuploadMutationVariables = {|
  input: DeleteWuploadInput
|};
export type WorkspacesComponent_deleteWuploadMutationResponse = {|
  +deleteWupload: ?{|
    +deletedWuploadId: ?string
  |}
|};
export type WorkspacesComponent_deleteWuploadMutation = {|
  variables: WorkspacesComponent_deleteWuploadMutationVariables,
  response: WorkspacesComponent_deleteWuploadMutationResponse,
|};
*/

/*
mutation WorkspacesComponent_deleteWuploadMutation(
  $input: DeleteWuploadInput!
) {
  deleteWupload(input: $input) {
    deletedWuploadId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteWuploadInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteWupload",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteWuploadInput!"
    }],
    "concreteType": "DeleteWuploadPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedWuploadId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "WorkspacesComponent_deleteWuploadMutation",
    "id": null,
    "text": "mutation WorkspacesComponent_deleteWuploadMutation(\n  $input: DeleteWuploadInput!\n) {\n  deleteWupload(input: $input) {\n    deletedWuploadId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesComponent_deleteWuploadMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesComponent_deleteWuploadMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0b7031487f14a79fda8b50baa7efaeba';
module.exports = node;

/***/ }),
/* 3322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 3119c943563421db9152b5f12acfdc63
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type WorkspacesContainer_node$ref = any;
export type WorkspacesContainer_RefetchQueryVariables = {|
  id: string
|};
export type WorkspacesContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: WorkspacesContainer_node$ref
  |}
|};
export type WorkspacesContainer_RefetchQuery = {|
  variables: WorkspacesContainer_RefetchQueryVariables,
  response: WorkspacesContainer_RefetchQueryResponse,
|};
*/

/*
query WorkspacesContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...WorkspacesContainer_node
    id
  }
}

fragment WorkspacesContainer_node on Event {
  id
  title
  start_at
  end_at
  time_zone
  can_edit
  user_contacts(first: 99999) {
    edges {
      node {
        first_name
        last_name
        user_contact_emails(first: 99999) {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
  user_event {
    start_at
    end_at
    time_zone
    id
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        share_token
        permissions
        can_email
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              can_edit
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              editable
              contract_signature_blocks {
                edges {
                  node {
                    signed_at
                    id
                  }
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        wuploads(first: 99999) {
          edges {
            node {
              id
              mimetype
              name
              url
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v9 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v10 = [v3, v4, v2],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "WorkspacesContainer_RefetchQuery",
    "id": null,
    "text": "query WorkspacesContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...WorkspacesContainer_node\n    id\n  }\n}\n\nfragment WorkspacesContainer_node on Event {\n  id\n  title\n  start_at\n  end_at\n  time_zone\n  can_edit\n  user_contacts(first: 99999) {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n  user_event {\n    start_at\n    end_at\n    time_zone\n    id\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        share_token\n        permissions\n        can_email\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              can_edit\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              editable\n              contract_signature_blocks {\n                edges {\n                  node {\n                    signed_at\n                    id\n                  }\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        wuploads(first: 99999) {\n          edges {\n            node {\n              id\n              mimetype\n              name\n              url\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WorkspacesContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "WorkspacesContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "WorkspacesContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [v4, v5, v6, v7, v8, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v9,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v9,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [{
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "address",
                        "args": null,
                        "storageKey": null
                      }, v3]
                    }]
                  }]
                }, v3]
              }, v3]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v5, v6, v7, v3]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v9,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoices",
                  "storageKey": "invoices(first:99999)",
                  "args": v9,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Invoice",
                      "plural": false,
                      "selections": v10
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "invoices",
                  "args": v9,
                  "handle": "connection",
                  "key": "EventShowContainer_invoices",
                  "filters": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "share_token",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "permissions",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "can_email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "estimates",
                  "storageKey": "estimates(first:99999)",
                  "args": v9,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Estimate",
                      "plural": false,
                      "selections": v10
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "estimates",
                  "args": v9,
                  "handle": "connection",
                  "key": "EventShowContainer_estimates",
                  "filters": null
                }, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "forms",
                  "storageKey": "forms(first:99999)",
                  "args": v9,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Form",
                      "plural": false,
                      "selections": v10
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v9,
                  "handle": "connection",
                  "key": "WorkspacesContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "music_planners",
                  "storageKey": "music_planners(first:99999)",
                  "args": v9,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MusicPlannerEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlanner",
                      "plural": false,
                      "selections": [v3, v4, v8, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v9,
                  "handle": "connection",
                  "key": "WorkspacesContainer_music_planners",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contracts",
                  "storageKey": "contracts(first:99999)",
                  "args": v9,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Contract",
                      "plural": false,
                      "selections": [v3, v4, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "editable",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract_signature_blocks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractSignatureBlockConnection",
                        "plural": false,
                        "selections": [{
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractSignatureBlockEdge",
                          "plural": true,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractSignatureBlock",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "signed_at",
                              "args": null,
                              "storageKey": null
                            }, v3]
                          }]
                        }]
                      }, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "contracts",
                  "args": v9,
                  "handle": "connection",
                  "key": "EventShowContainer_contracts",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "wuploads",
                  "storageKey": "wuploads(first:99999)",
                  "args": v9,
                  "concreteType": "WuploadConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WuploadEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Wupload",
                      "plural": false,
                      "selections": [v3, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mimetype",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "wuploads",
                  "args": v9,
                  "handle": "connection",
                  "key": "WorkspacesContainer_wuploads",
                  "filters": null
                }, v2]
              }, v11]
            }, v12]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v9,
            "handle": "connection",
            "key": "WorkspacesContainer_workspaces",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e1a59341763e7db1f7f2def7b6f5dee8';
module.exports = node;

/***/ }),
/* 3323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WorkspacesContainer_node$ref: FragmentReference;
export type WorkspacesContainer_node = {|
  +id: string,
  +title: ?string,
  +start_at: ?any,
  +end_at: ?any,
  +time_zone: ?string,
  +can_edit: ?boolean,
  +user_contacts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +address: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +user_event: ?{|
    +start_at: ?any,
    +end_at: ?any,
    +time_zone: ?string,
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +share_token: ?string,
        +permissions: ?$ReadOnlyArray<?string>,
        +can_email: ?boolean,
        +estimates: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +invoices: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +forms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +music_planners: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +can_edit: ?boolean,
            |}
          |}>
        |},
        +contracts: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +editable: ?boolean,
              +contract_signature_blocks: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +signed_at: ?any
                  |}
                |}>
              |},
            |}
          |}>
        |},
        +wuploads: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +mimetype: ?string,
              +name: ?string,
              +url: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: WorkspacesContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "count": null,
    "cursor": null,
    "direction": "forward",
    "path": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = [v1, v2, v8],
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "WorkspacesContainer_node",
    "type": "Event",
    "metadata": {
      "connection": [v0, v0, v0, v0, v0, v0, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["workspaces"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v1, v2, v3, v4, v5, v6, {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_contacts",
      "storageKey": "user_contacts(first:99999)",
      "args": v7,
      "concreteType": "EventUserContactConnectionWithRole",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EventUserContactEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContact",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contact_emails",
            "storageKey": "user_contact_emails(first:99999)",
            "args": v7,
            "concreteType": "UserContactEmailConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactEmailEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmail",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }]
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [v3, v4, v5]
    }, {
      "kind": "LinkedField",
      "alias": "workspaces",
      "name": "__WorkspacesContainer_workspaces_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": "invoices",
            "name": "__EventShowContainer_invoices_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "InvoiceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": v9
              }, v10]
            }, v11]
          }, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "permissions",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "estimates",
            "name": "__EventShowContainer_estimates_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "EstimateConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Estimate",
                "plural": false,
                "selections": v9
              }, v10]
            }, v11]
          }, v2, {
            "kind": "LinkedField",
            "alias": "forms",
            "name": "__WorkspacesContainer_forms_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "FormConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "FormEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": v9
              }, v10]
            }, v11]
          }, {
            "kind": "LinkedField",
            "alias": "music_planners",
            "name": "__WorkspacesContainer_music_planners_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlannerConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MusicPlannerEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MusicPlanner",
                "plural": false,
                "selections": [v1, v2, v6, v8]
              }, v10]
            }, v11]
          }, {
            "kind": "LinkedField",
            "alias": "contracts",
            "name": "__EventShowContainer_contracts_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Contract",
                "plural": false,
                "selections": [v1, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "editable",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contract_signature_blocks",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ContractSignatureBlockConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractSignatureBlockEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ContractSignatureBlock",
                      "plural": false,
                      "selections": [{
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "signed_at",
                        "args": null,
                        "storageKey": null
                      }]
                    }]
                  }]
                }, v8]
              }, v10]
            }, v11]
          }, {
            "kind": "LinkedField",
            "alias": "wuploads",
            "name": "__WorkspacesContainer_wuploads_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "WuploadConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WuploadEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Wupload",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "mimetype",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": null,
                  "storageKey": null
                }, v8]
              }, v10]
            }, v11]
          }, v8]
        }, v10]
      }, v11]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '5181045c8217443acf63593ec3d77168';
module.exports = node;

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WorkspacesContainer_viewer$ref: FragmentReference;
export type WorkspacesContainer_viewer = {|
  +id: string,
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: WorkspacesContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WorkspacesContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCalendarContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '7c6beaa9aca1d193801b5706eb6fdb56';
module.exports = node;

/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 329771408f63f3b848a0baf52d2e6933
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type UpdateUserEventInput = {
  clientMutationId?: ?string,
  id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
};
export type BookingStatus_UpdateUserEventMutationVariables = {|
  input: UpdateUserEventInput
|};
export type BookingStatus_UpdateUserEventMutationResponse = {|
  +updateUserEvent: ?{|
    +user_event: ?{|
      +booking_status: ?BookingStatus,
      +visibility: ?UserEventVisibility,
    |}
  |}
|};
export type BookingStatus_UpdateUserEventMutation = {|
  variables: BookingStatus_UpdateUserEventMutationVariables,
  response: BookingStatus_UpdateUserEventMutationResponse,
|};
*/

/*
mutation BookingStatus_UpdateUserEventMutation(
  $input: UpdateUserEventInput!
) {
  updateUserEvent(input: $input) {
    user_event {
      booking_status
      visibility
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserEventInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "visibility",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "BookingStatus_UpdateUserEventMutation",
    "id": null,
    "text": "mutation BookingStatus_UpdateUserEventMutation(\n  $input: UpdateUserEventInput!\n) {\n  updateUserEvent(input: $input) {\n    user_event {\n      booking_status\n      visibility\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "BookingStatus_UpdateUserEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "BookingStatus_UpdateUserEventMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ee14a63a6422ba654cfc532192e935fb';
module.exports = node;

/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c97435298b88f2fc251a95c9b6d6934b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContactSearchContainer_viewer$ref = any;
export type ContactSearchContainerRefetchQueryVariables = {|
  query: string
|};
export type ContactSearchContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ContactSearchContainer_viewer$ref
  |}
|};
export type ContactSearchContainerRefetchQuery = {|
  variables: ContactSearchContainerRefetchQueryVariables,
  response: ContactSearchContainerRefetchQueryResponse,
|};
*/

/*
query ContactSearchContainerRefetchQuery(
  $query: String!
) {
  viewer {
    ...ContactSearchContainer_viewer_1Qr5xf
    id
  }
}

fragment ContactSearchContainer_viewer_1Qr5xf on User {
  user_contact_search(first: 3, query: $query) {
    edges {
      node {
        id
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              number
              id
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ContactSearchContainerRefetchQuery",
    "id": null,
    "text": "query ContactSearchContainerRefetchQuery(\n  $query: String!\n) {\n  viewer {\n    ...ContactSearchContainer_viewer_1Qr5xf\n    id\n  }\n}\n\nfragment ContactSearchContainer_viewer_1Qr5xf on User {\n  user_contact_search(first: 3, query: $query) {\n    edges {\n      node {\n        id\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              number\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ContactSearchContainerRefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContactSearchContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ContactSearchContainerRefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_search",
          "storageKey": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String!"
          }],
          "concreteType": "UserContactConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContact",
              "plural": false,
              "selections": [v1, {
                "kind": "ScalarField",
                "alias": null,
                "name": "first_name",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_name",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_emails",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmailConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactEmailEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmail",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "address",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_phones",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactPhoneConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactPhoneEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhone",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "number",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }]
            }]
          }]
        }, v1]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3a0849079c272046b48419937b17cd36';
module.exports = node;

/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContactSearchContainer_viewer$ref: FragmentReference;
export type ContactSearchContainer_viewer = {|
  +user_contact_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +address: ?string
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +number: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: ContactSearchContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ContactSearchContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": 3
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": ""
  }],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "user_contact_search",
    "storageKey": null,
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 3,
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "query",
      "variableName": "query",
      "type": "String!"
    }],
    "concreteType": "UserContactConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContactEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContact",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_emails",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactEmailConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEmailEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactEmail",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_phones",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactPhoneConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactPhoneEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactPhone",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "number",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '1acbc2d34630c3fc59ad5ce83e0bfcb6';
module.exports = node;

/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 79fb3dd26a6166be56566b1efc5ce38e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateUserContactInput = {
  clientMutationId?: ?string,
  user_id: string,
  first_name: string,
  last_name?: ?string,
  company_name?: ?string,
  notes?: ?string,
  phones?: ?$ReadOnlyArray<?UserContactPhoneInput>,
  addresses?: ?$ReadOnlyArray<?UserContactAddressInput>,
  emails?: ?$ReadOnlyArray<?UserContactEmailInput>,
  events?: ?$ReadOnlyArray<?UserContactEventInput>,
};
export type UserContactPhoneInput = {
  label: string,
  number: string,
};
export type UserContactAddressInput = {
  label: string,
  line1: string,
  line2?: ?string,
  city?: ?string,
  province: string,
  postal_code: string,
  country: string,
};
export type UserContactEmailInput = {
  label: string,
  address: string,
};
export type UserContactEventInput = {
  role: string,
  event_id: string,
};
export type Contacts_CreateUserContactMutationVariables = {|
  input: CreateUserContactInput
|};
export type Contacts_CreateUserContactMutationResponse = {|
  +createUserContact: ?{|
    +user_contact: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +company_name: ?string,
      +user_contact_addresses: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +line1: ?string,
            +line2: ?string,
            +city: ?string,
            +province: ?string,
            +postal_code: ?string,
            +country: ?string,
          |}
        |}>
      |},
      +user_contact_emails: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +address: ?string,
          |}
        |}>
      |},
      +user_contact_phones: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +number: ?string,
          |}
        |}>
      |},
    |},
    +new_user_contact_edge: ?{|
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +company_name: ?string,
        +user_contact_addresses: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +line1: ?string,
              +line2: ?string,
              +city: ?string,
              +province: ?string,
              +postal_code: ?string,
              +country: ?string,
            |}
          |}>
        |},
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +address: ?string,
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +number: ?string,
            |}
          |}>
        |},
      |}
    |},
  |}
|};
export type Contacts_CreateUserContactMutation = {|
  variables: Contacts_CreateUserContactMutationVariables,
  response: Contacts_CreateUserContactMutationResponse,
|};
*/

/*
mutation Contacts_CreateUserContactMutation(
  $input: CreateUserContactInput!
) {
  createUserContact(input: $input) {
    user_contact {
      id
      first_name
      last_name
      company_name
      user_contact_addresses {
        edges {
          node {
            id
            label
            line1
            line2
            city
            province
            postal_code
            country
          }
        }
      }
      user_contact_emails {
        edges {
          node {
            id
            label
            address
          }
        }
      }
      user_contact_phones {
        edges {
          node {
            id
            label
            number
          }
        }
      }
    }
    new_user_contact_edge {
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
            }
          }
        }
        user_contact_emails {
          edges {
            node {
              id
              label
              address
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              id
              label
              number
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserContactInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v3 = [v1, {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "company_name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_contact_addresses",
    "storageKey": null,
    "args": null,
    "concreteType": "UserContactAddressConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContactAddressEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactAddress",
        "plural": false,
        "selections": [v1, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "city",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "province",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "postal_code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "country",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_contact_emails",
    "storageKey": null,
    "args": null,
    "concreteType": "UserContactEmailConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContactEmailEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactEmail",
        "plural": false,
        "selections": [v1, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "address",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_contact_phones",
    "storageKey": null,
    "args": null,
    "concreteType": "UserContactPhoneConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContactPhoneEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactPhone",
        "plural": false,
        "selections": [v1, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "number",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }],
      v4 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createUserContact",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateUserContactInput!"
    }],
    "concreteType": "CreateUserContactPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_contact",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContact",
      "plural": false,
      "selections": v3
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "new_user_contact_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContactEdge",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContact",
        "plural": false,
        "selections": v3
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Contacts_CreateUserContactMutation",
    "id": null,
    "text": "mutation Contacts_CreateUserContactMutation(\n  $input: CreateUserContactInput!\n) {\n  createUserContact(input: $input) {\n    user_contact {\n      id\n      first_name\n      last_name\n      company_name\n      user_contact_addresses {\n        edges {\n          node {\n            id\n            label\n            line1\n            line2\n            city\n            province\n            postal_code\n            country\n          }\n        }\n      }\n      user_contact_emails {\n        edges {\n          node {\n            id\n            label\n            address\n          }\n        }\n      }\n      user_contact_phones {\n        edges {\n          node {\n            id\n            label\n            number\n          }\n        }\n      }\n    }\n    new_user_contact_edge {\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n            }\n          }\n        }\n        user_contact_emails {\n          edges {\n            node {\n              id\n              label\n              address\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              id\n              label\n              number\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Contacts_CreateUserContactMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v4
    },
    "operation": {
      "kind": "Operation",
      "name": "Contacts_CreateUserContactMutation",
      "argumentDefinitions": v0,
      "selections": v4
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '98537a198c297b23c1a91704d7f17e60';
module.exports = node;

/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d1e4305de564f3a75a89538d005b545a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserContactInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  notes?: ?string,
  phones?: ?$ReadOnlyArray<?UserContactPhoneUpdateInput>,
  addresses?: ?$ReadOnlyArray<?UserContactAddressUpdateInput>,
  emails?: ?$ReadOnlyArray<?UserContactEmailUpdateInput>,
  roles?: ?$ReadOnlyArray<?UserContactEventRoleUpdateInput>,
  delete_phones_with_ids?: ?$ReadOnlyArray<?string>,
  delete_addresses_with_ids?: ?$ReadOnlyArray<?string>,
  delete_emails_with_ids?: ?$ReadOnlyArray<?string>,
};
export type UserContactPhoneUpdateInput = {
  id?: ?string,
  label?: ?string,
  number?: ?string,
};
export type UserContactAddressUpdateInput = {
  id?: ?string,
  label?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
};
export type UserContactEmailUpdateInput = {
  id?: ?string,
  label?: ?string,
  address?: ?string,
};
export type UserContactEventRoleUpdateInput = {
  id: string,
  role: string,
};
export type Contacts_UpdateUserContactMutationVariables = {|
  input: UpdateUserContactInput
|};
export type Contacts_UpdateUserContactMutationResponse = {|
  +updateUserContact: ?{|
    +user_contact: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +company_name: ?string,
      +user_contact_addresses: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +line1: ?string,
            +line2: ?string,
            +city: ?string,
            +province: ?string,
            +postal_code: ?string,
            +country: ?string,
          |}
        |}>
      |},
      +user_contact_emails: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +address: ?string,
          |}
        |}>
      |},
      +user_contact_phones: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?string,
            +number: ?string,
          |}
        |}>
      |},
    |}
  |}
|};
export type Contacts_UpdateUserContactMutation = {|
  variables: Contacts_UpdateUserContactMutationVariables,
  response: Contacts_UpdateUserContactMutationResponse,
|};
*/

/*
mutation Contacts_UpdateUserContactMutation(
  $input: UpdateUserContactInput!
) {
  updateUserContact(input: $input) {
    user_contact {
      id
      first_name
      last_name
      company_name
      user_contact_addresses {
        edges {
          node {
            id
            label
            line1
            line2
            city
            province
            postal_code
            country
          }
        }
      }
      user_contact_emails {
        edges {
          node {
            id
            label
            address
          }
        }
      }
      user_contact_phones {
        edges {
          node {
            id
            label
            number
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserContactInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserContact",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserContactInput!"
    }],
    "concreteType": "UpdateUserContactPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_contact",
      "storageKey": null,
      "args": null,
      "concreteType": "UserContact",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "first_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "last_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "company_name",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_contact_addresses",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactAddressConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactAddressEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactAddress",
            "plural": false,
            "selections": [v1, v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "line1",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "line2",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "city",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "province",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "postal_code",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "country",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_contact_emails",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactEmailConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactEmailEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEmail",
            "plural": false,
            "selections": [v1, v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "address",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_contact_phones",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContactPhoneConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactPhoneEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactPhone",
            "plural": false,
            "selections": [v1, v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "number",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Contacts_UpdateUserContactMutation",
    "id": null,
    "text": "mutation Contacts_UpdateUserContactMutation(\n  $input: UpdateUserContactInput!\n) {\n  updateUserContact(input: $input) {\n    user_contact {\n      id\n      first_name\n      last_name\n      company_name\n      user_contact_addresses {\n        edges {\n          node {\n            id\n            label\n            line1\n            line2\n            city\n            province\n            postal_code\n            country\n          }\n        }\n      }\n      user_contact_emails {\n        edges {\n          node {\n            id\n            label\n            address\n          }\n        }\n      }\n      user_contact_phones {\n        edges {\n          node {\n            id\n            label\n            number\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Contacts_UpdateUserContactMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v3
    },
    "operation": {
      "kind": "Operation",
      "name": "Contacts_UpdateUserContactMutation",
      "argumentDefinitions": v0,
      "selections": v3
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7ca2626b685562af0c992eac7d9f0e60';
module.exports = node;

/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 855d6abdff2aeb38cdde778b66c673d6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUserContactInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Contacts_deleteUserContactMutationVariables = {|
  input: DeleteUserContactInput
|};
export type Contacts_deleteUserContactMutationResponse = {|
  +deleteUserContact: ?{|
    +deletedUserContactId: ?string
  |}
|};
export type Contacts_deleteUserContactMutation = {|
  variables: Contacts_deleteUserContactMutationVariables,
  response: Contacts_deleteUserContactMutationResponse,
|};
*/

/*
mutation Contacts_deleteUserContactMutation(
  $input: DeleteUserContactInput!
) {
  deleteUserContact(input: $input) {
    deletedUserContactId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteUserContactInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteUserContact",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeleteUserContactInput!"
    }],
    "concreteType": "DeleteUserContactPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedUserContactId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "Contacts_deleteUserContactMutation",
    "id": null,
    "text": "mutation Contacts_deleteUserContactMutation(\n  $input: DeleteUserContactInput!\n) {\n  deleteUserContact(input: $input) {\n    deletedUserContactId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Contacts_deleteUserContactMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "Contacts_deleteUserContactMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '201a67a7b91c4d6a6171919101c45099';
module.exports = node;

/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 63845893aa048baa53f972bf618bc165
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEventInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
};
export type EventDates_UpdateEventMutationVariables = {|
  input: UpdateEventInput
|};
export type EventDates_UpdateEventMutationResponse = {|
  +updateEvent: ?{|
    +event: ?{|
      +id: string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
    |}
  |}
|};
export type EventDates_UpdateEventMutation = {|
  variables: EventDates_UpdateEventMutationVariables,
  response: EventDates_UpdateEventMutationResponse,
|};
*/

/*
mutation EventDates_UpdateEventMutation(
  $input: UpdateEventInput!
) {
  updateEvent(input: $input) {
    event {
      id
      start_at
      end_at
      time_zone
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateEventInput!"
    }],
    "concreteType": "UpdateEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": null,
      "concreteType": "Event",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "start_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "end_at",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "time_zone",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "EventDates_UpdateEventMutation",
    "id": null,
    "text": "mutation EventDates_UpdateEventMutation(\n  $input: UpdateEventInput!\n) {\n  updateEvent(input: $input) {\n    event {\n      id\n      start_at\n      end_at\n      time_zone\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventDates_UpdateEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "EventDates_UpdateEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'af7c2fd962e1d4f3deb33289d6746327';
module.exports = node;

/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventOverviewContainer_node$ref: FragmentReference;
export type EventOverviewContainer_node = {|
  +id: string,
  +title: ?string,
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +$refType: EventOverviewContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "EventOverviewContainer_node",
    "type": "Event",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["workspaces"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, v1, {
      "kind": "LinkedField",
      "alias": "workspaces",
      "name": "__EventOverviewContainer_workspaces_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v0, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '91995ef4f9223f636445b88b234217fa';
module.exports = node;

/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventOverviewContainer_viewer$ref: FragmentReference;
export type EventOverviewContainer_viewer = {|
  +id: string,
  +$refType: EventOverviewContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "EventOverviewContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ea6ef0208d489c32e99e10cd2a555b67';
module.exports = node;

/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6cecf62ea38c86cf00b6971f84852fe7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventShowContainer_node$ref = any;
export type EventShowContainer_RefetchQueryVariables = {|
  id: string
|};
export type EventShowContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EventShowContainer_node$ref
  |}
|};
export type EventShowContainer_RefetchQuery = {|
  variables: EventShowContainer_RefetchQueryVariables,
  response: EventShowContainer_RefetchQueryResponse,
|};
*/

/*
query EventShowContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EventShowContainer_node
    id
  }
}

fragment EventShowContainer_node on Event {
  id
  start_at
  end_at
  all_day
  time_zone
  title
  can_edit
  user_event {
    id
    booking_status
    visibility
    start_at
    end_at
    time_zone
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...EventSummaryContainer_node
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line1",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line2",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "province",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v18 = [v3, v8, v2],
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventShowContainer_RefetchQuery",
    "id": null,
    "text": "query EventShowContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EventShowContainer_node\n    id\n  }\n}\n\nfragment EventShowContainer_node on Event {\n  id\n  start_at\n  end_at\n  all_day\n  time_zone\n  title\n  can_edit\n  user_event {\n    id\n    booking_status\n    visibility\n    start_at\n    end_at\n    time_zone\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...EventSummaryContainer_node\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventShowContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventShowContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventShowContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [v4, v5, v6, v7, v8, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "booking_status",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "visibility",
              "args": null,
              "storageKey": null
            }, v4, v5, v7, v9, {
              "kind": "ScalarField",
              "alias": null,
              "name": "referral_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_event_segments",
              "storageKey": "user_event_segments(first:99999)",
              "args": v10,
              "concreteType": "UserEventSegmentConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegment",
                  "plural": false,
                  "selections": [v11, v3, v4, v5, v7, v6, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }, v8, v12, v13, v14, v15, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "room",
                    "args": null,
                    "storageKey": null
                  }, v9, v2]
                }, v16]
              }, v17]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "user_event_segments",
              "args": v10,
              "handle": "connection",
              "key": "ScheduleContainer_user_event_segments",
              "filters": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v10,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, v8, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contracts",
                  "storageKey": "contracts(first:99999)",
                  "args": v10,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Contract",
                      "plural": false,
                      "selections": v18
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "contracts",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventShowContainer_contracts",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "estimates",
                  "storageKey": "estimates(first:99999)",
                  "args": v10,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Estimate",
                      "plural": false,
                      "selections": v18
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "estimates",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventShowContainer_estimates",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "forms",
                  "storageKey": "forms(first:99999)",
                  "args": v10,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Form",
                      "plural": false,
                      "selections": v18
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventShowContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoices",
                  "storageKey": "invoices(first:99999)",
                  "args": v10,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Invoice",
                      "plural": false,
                      "selections": v18
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "invoices",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventShowContainer_invoices",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "music_planners",
                  "storageKey": "music_planners(first:99999)",
                  "args": v10,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MusicPlannerEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlanner",
                      "plural": false,
                      "selections": v18
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventShowContainer_music_planners",
                  "filters": null
                }, v2]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v10,
            "handle": "connection",
            "key": "EventShowContainer_workspaces",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v10,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "storageKey": "user_contact_addresses(first:99999)",
                  "args": v10,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddress",
                      "plural": false,
                      "selections": [v3, v19, v11, v12, v13, v14, v15, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_addresses",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v10,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [v3, v19, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "address",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_emails",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_emails",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_phones",
                  "storageKey": "user_contact_phones(first:99999)",
                  "args": v10,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhone",
                      "plural": false,
                      "selections": [v3, v19, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "number",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v16]
                  }, v17]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_phones",
                  "args": v10,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_phones",
                  "filters": null
                }, v2]
              }, v16]
            }, v17]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_contacts",
            "args": v10,
            "handle": "connection",
            "key": "EventSummaryContainer_user_contacts",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '044cdaf517eb4d18aea569bffd495718';
module.exports = node;

/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type EventSummaryContainer_node$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventShowContainer_node$ref: FragmentReference;
export type EventShowContainer_node = {|
  +id: string,
  +start_at: ?any,
  +end_at: ?any,
  +all_day: ?boolean,
  +time_zone: ?string,
  +title: ?string,
  +can_edit: ?boolean,
  +user_event: ?{|
    +id: string,
    +booking_status: ?BookingStatus,
    +visibility: ?UserEventVisibility,
    +start_at: ?any,
    +end_at: ?any,
    +time_zone: ?string,
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +contracts: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +estimates: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +forms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +invoices: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +music_planners: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: EventSummaryContainer_node$ref,
  +$refType: EventShowContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "count": null,
    "cursor": null,
    "direction": "forward",
    "path": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v7 = [v1, v5, v6],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "EventShowContainer_node",
    "type": "Event",
    "metadata": {
      "connection": [v0, v0, v0, v0, v0, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["workspaces"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v1, v2, v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "all_day",
      "args": null,
      "storageKey": null
    }, v4, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "visibility",
        "args": null,
        "storageKey": null
      }, v2, v3, v4]
    }, {
      "kind": "LinkedField",
      "alias": "workspaces",
      "name": "__EventShowContainer_workspaces_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v1, v5, {
            "kind": "LinkedField",
            "alias": "contracts",
            "name": "__EventShowContainer_contracts_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Contract",
                "plural": false,
                "selections": v7
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedField",
            "alias": "estimates",
            "name": "__EventShowContainer_estimates_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "EstimateConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Estimate",
                "plural": false,
                "selections": v7
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedField",
            "alias": "forms",
            "name": "__EventShowContainer_forms_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "FormConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "FormEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": v7
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedField",
            "alias": "invoices",
            "name": "__EventShowContainer_invoices_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "InvoiceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": v7
              }, v8]
            }, v9]
          }, {
            "kind": "LinkedField",
            "alias": "music_planners",
            "name": "__EventShowContainer_music_planners_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlannerConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MusicPlannerEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MusicPlanner",
                "plural": false,
                "selections": v7
              }, v8]
            }, v9]
          }, v6]
        }, v8]
      }, v9]
    }, {
      "kind": "FragmentSpread",
      "name": "EventSummaryContainer_node",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '3d6fd0c0b121a22f01f17cf66914d4c1';
module.exports = node;

/***/ }),
/* 3336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
type EventSummaryContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventShowContainer_viewer$ref: FragmentReference;
export type EventShowContainer_viewer = {|
  +id: string,
  +past_referral_sources: ?$ReadOnlyArray<?string>,
  +c_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +form_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +mp_templates: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
      |}
    |}>
  |},
  +features: ?{|
    +music_lists: ?boolean
  |},
  +$fragmentRefs: EventSummaryContainer_viewer$ref & AvailabilityCheckerContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventShowContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [v0, {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Fragment",
    "name": "EventShowContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "past_referral_sources",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "c_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CTemplateEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplate",
          "plural": false,
          "selections": v1
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "form_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "FormTemplateConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "FormTemplateEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplate",
          "plural": false,
          "selections": v1
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "mp_templates",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplateConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MpTemplateEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplate",
          "plural": false,
          "selections": v1
        }]
      }]
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "features",
      "storageKey": null,
      "args": null,
      "concreteType": "Features",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "music_lists",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "FragmentSpread",
      "name": "EventSummaryContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '75626512269a9c3a590894b56e796b22';
module.exports = node;

/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash cfec993bb9a27194960cc69415bcbfda
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type UpdateUserEventInput = {
  clientMutationId?: ?string,
  id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
};
export type EventSummaryComponent_Notes_UpdateUserEventMutationVariables = {|
  input: UpdateUserEventInput
|};
export type EventSummaryComponent_Notes_UpdateUserEventMutationResponse = {|
  +updateUserEvent: ?{|
    +user_event: ?{|
      +id: string,
      +referral_source: ?string,
      +notes: ?string,
    |}
  |}
|};
export type EventSummaryComponent_Notes_UpdateUserEventMutation = {|
  variables: EventSummaryComponent_Notes_UpdateUserEventMutationVariables,
  response: EventSummaryComponent_Notes_UpdateUserEventMutationResponse,
|};
*/

/*
mutation EventSummaryComponent_Notes_UpdateUserEventMutation(
  $input: UpdateUserEventInput!
) {
  updateUserEvent(input: $input) {
    user_event {
      id
      referral_source
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserEventInput!"
    }],
    "concreteType": "UpdateUserEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "referral_source",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "EventSummaryComponent_Notes_UpdateUserEventMutation",
    "id": null,
    "text": "mutation EventSummaryComponent_Notes_UpdateUserEventMutation(\n  $input: UpdateUserEventInput!\n) {\n  updateUserEvent(input: $input) {\n    user_event {\n      id\n      referral_source\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventSummaryComponent_Notes_UpdateUserEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "EventSummaryComponent_Notes_UpdateUserEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '65028af58587524bf55c076ffa58b9fb';
module.exports = node;

/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 805083b7288830f2b6541402f4887a8f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type UpdateUserEventInput = {
  clientMutationId?: ?string,
  id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
};
export type EventSummaryComponent_Referral_UpdateUserEventMutationVariables = {|
  input: UpdateUserEventInput
|};
export type EventSummaryComponent_Referral_UpdateUserEventMutationResponse = {|
  +updateUserEvent: ?{|
    +user_event: ?{|
      +id: string,
      +referral_source: ?string,
      +notes: ?string,
    |}
  |}
|};
export type EventSummaryComponent_Referral_UpdateUserEventMutation = {|
  variables: EventSummaryComponent_Referral_UpdateUserEventMutationVariables,
  response: EventSummaryComponent_Referral_UpdateUserEventMutationResponse,
|};
*/

/*
mutation EventSummaryComponent_Referral_UpdateUserEventMutation(
  $input: UpdateUserEventInput!
) {
  updateUserEvent(input: $input) {
    user_event {
      id
      referral_source
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserEventInput!"
    }],
    "concreteType": "UpdateUserEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "referral_source",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "EventSummaryComponent_Referral_UpdateUserEventMutation",
    "id": null,
    "text": "mutation EventSummaryComponent_Referral_UpdateUserEventMutation(\n  $input: UpdateUserEventInput!\n) {\n  updateUserEvent(input: $input) {\n    user_event {\n      id\n      referral_source\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventSummaryComponent_Referral_UpdateUserEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "EventSummaryComponent_Referral_UpdateUserEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '290f37d014721ce75ef957af808283a3';
module.exports = node;

/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4ce7aca6666249a21f2890a4bb082692
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventSummaryContainer_node$ref = any;
export type EventSummaryContainer_RefetchQueryVariables = {|
  id: string
|};
export type EventSummaryContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EventSummaryContainer_node$ref
  |}
|};
export type EventSummaryContainer_RefetchQuery = {|
  variables: EventSummaryContainer_RefetchQueryVariables,
  response: EventSummaryContainer_RefetchQueryResponse,
|};
*/

/*
query EventSummaryContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EventSummaryContainer_node
    id
  }
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line1",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line2",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "province",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventSummaryContainer_RefetchQuery",
    "id": null,
    "text": "query EventSummaryContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EventSummaryContainer_node\n    id\n  }\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventSummaryContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventSummaryContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventSummaryContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v3, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "referral_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_event_segments",
              "storageKey": "user_event_segments(first:99999)",
              "args": v5,
              "concreteType": "UserEventSegmentConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegment",
                  "plural": false,
                  "selections": [v6, v3, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "start_at",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "end_at",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "time_zone",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "all_day",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  }, v7, v8, v9, v10, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "room",
                    "args": null,
                    "storageKey": null
                  }, v4, v2]
                }, v11]
              }, v12]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "user_event_segments",
              "args": v5,
              "handle": "connection",
              "key": "ScheduleContainer_user_event_segments",
              "filters": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v5,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "storageKey": "user_contact_addresses(first:99999)",
                  "args": v5,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddress",
                      "plural": false,
                      "selections": [v3, v13, v6, v7, v8, v9, v10, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "args": v5,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_addresses",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v5,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [v3, v13, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "address",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_emails",
                  "args": v5,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_emails",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_phones",
                  "storageKey": "user_contact_phones(first:99999)",
                  "args": v5,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhone",
                      "plural": false,
                      "selections": [v3, v13, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "number",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }, v11]
                  }, v12]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_phones",
                  "args": v5,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_phones",
                  "filters": null
                }, v2]
              }, v11]
            }, v12]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_contacts",
            "args": v5,
            "handle": "connection",
            "key": "EventSummaryContainer_user_contacts",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7ffd79a92600cb140522917ffa9b071f';
module.exports = node;

/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type ScheduleContainer_node$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventSummaryContainer_node$ref: FragmentReference;
export type EventSummaryContainer_node = {|
  +id: string,
  +user_event: ?{|
    +id: string,
    +notes: ?string,
    +referral_source: ?string,
    +$fragmentRefs: ScheduleContainer_node$ref,
  |},
  +user_contacts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +id: ?string,
      +role: ?string,
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +company_name: ?string,
        +user_contact_addresses: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +line1: ?string,
              +line2: ?string,
              +city: ?string,
              +province: ?string,
              +postal_code: ?string,
              +country: ?string,
            |}
          |}>
        |},
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +address: ?string,
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +number: ?string,
            |}
          |}>
        |},
      |},
    |}>
  |},
  +$refType: EventSummaryContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "count": null,
    "cursor": null,
    "direction": "forward",
    "path": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "EventSummaryContainer_node",
    "type": "Event",
    "metadata": {
      "connection": [v0, v0, v0, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["user_contacts"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v1, {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "referral_source",
        "args": null,
        "storageKey": null
      }, {
        "kind": "FragmentSpread",
        "name": "ScheduleContainer_node",
        "args": null
      }]
    }, {
      "kind": "LinkedField",
      "alias": "user_contacts",
      "name": "__EventSummaryContainer_user_contacts_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "EventUserContactConnectionWithRole",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EventUserContactEdge",
        "plural": true,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "role",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContact",
          "plural": false,
          "selections": [v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "user_contact_addresses",
            "name": "__EventSummaryContainer_user_contact_addresses_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactAddressConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactAddressEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactAddress",
                "plural": false,
                "selections": [v1, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "country",
                  "args": null,
                  "storageKey": null
                }, v3]
              }, v4]
            }, v5]
          }, {
            "kind": "LinkedField",
            "alias": "user_contact_emails",
            "name": "__EventSummaryContainer_user_contact_emails_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEmailConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactEmailEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmail",
                "plural": false,
                "selections": [v1, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address",
                  "args": null,
                  "storageKey": null
                }, v3]
              }, v4]
            }, v5]
          }, {
            "kind": "LinkedField",
            "alias": "user_contact_phones",
            "name": "__EventSummaryContainer_user_contact_phones_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactPhoneConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactPhoneEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactPhone",
                "plural": false,
                "selections": [v1, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "number",
                  "args": null,
                  "storageKey": null
                }, v3]
              }, v4]
            }, v5]
          }, v3]
        }, v4]
      }, v5]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '1c8b39f7ca8ff54d7dd2ce49f5f29b39';
module.exports = node;

/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type ContactSearchContainer_viewer$ref = any;
type ScheduleContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventSummaryContainer_viewer$ref: FragmentReference;
export type EventSummaryContainer_viewer = {|
  +id: string,
  +past_referral_sources: ?$ReadOnlyArray<?string>,
  +$fragmentRefs: ContactSearchContainer_viewer$ref & ScheduleContainer_viewer$ref,
  +$refType: EventSummaryContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "EventSummaryContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "past_referral_sources",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "ContactSearchContainer_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "ScheduleContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'a860df5265d6429eea30e1bf91f04c78';
module.exports = node;

/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b8cf5e6fd7ce67a8cab20c2f84132c7e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateUserContactEventInput = {
  clientMutationId?: ?string,
  user_contact_id: string,
  event_id: string,
  role: string,
};
export type NewContactDesktop_createUserContactEventMutationVariables = {|
  input: CreateUserContactEventInput
|};
export type NewContactDesktop_createUserContactEventMutationResponse = {|
  +createUserContactEvent: ?{|
    +new_event_user_contact_edge: ?{|
      +id: ?string,
      +role: ?string,
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_addresses: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +line1: ?string,
              +line2: ?string,
              +city: ?string,
              +province: ?string,
              +postal_code: ?string,
              +country: ?string,
            |}
          |}>
        |},
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +address: ?string,
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +number: ?string,
            |}
          |}>
        |},
      |},
    |}
  |}
|};
export type NewContactDesktop_createUserContactEventMutation = {|
  variables: NewContactDesktop_createUserContactEventMutationVariables,
  response: NewContactDesktop_createUserContactEventMutationResponse,
|};
*/

/*
mutation NewContactDesktop_createUserContactEventMutation(
  $input: CreateUserContactEventInput!
) {
  createUserContactEvent(input: $input) {
    new_event_user_contact_edge {
      id
      role
      node {
        id
        first_name
        last_name
        user_contact_addresses {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
            }
          }
        }
        user_contact_emails {
          edges {
            node {
              id
              label
              address
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              id
              label
              number
            }
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserContactEventInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createUserContactEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateUserContactEventInput!"
    }],
    "concreteType": "CreateUserContactEventPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "new_event_user_contact_edge",
      "storageKey": null,
      "args": null,
      "concreteType": "EventUserContactEdge",
      "plural": false,
      "selections": [v1, {
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserContact",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_addresses",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactAddressConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactAddressEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactAddress",
              "plural": false,
              "selections": [v1, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "line1",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "line2",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "city",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "province",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "postal_code",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "country",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_emails",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactEmailConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEmailEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactEmail",
              "plural": false,
              "selections": [v1, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_phones",
          "storageKey": null,
          "args": null,
          "concreteType": "UserContactPhoneConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactPhoneEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContactPhone",
              "plural": false,
              "selections": [v1, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "number",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewContactDesktop_createUserContactEventMutation",
    "id": null,
    "text": "mutation NewContactDesktop_createUserContactEventMutation(\n  $input: CreateUserContactEventInput!\n) {\n  createUserContactEvent(input: $input) {\n    new_event_user_contact_edge {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        user_contact_addresses {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n            }\n          }\n        }\n        user_contact_emails {\n          edges {\n            node {\n              id\n              label\n              address\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              id\n              label\n              number\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewContactDesktop_createUserContactEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v3
    },
    "operation": {
      "kind": "Operation",
      "name": "NewContactDesktop_createUserContactEventMutation",
      "argumentDefinitions": v0,
      "selections": v3
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fb32fcd70010979fb62c1d7ae4e0c829';
module.exports = node;

/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d894ba018d348f681aadaf8afe358ed1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateContractInput = {
  clientMutationId?: ?string,
  title: string,
  terms?: ?string,
  workspace_ids: $ReadOnlyArray<?string>,
  copy_user_event_segments: boolean,
  copy_document?: ?CopyDocumentInput,
  brand_id?: ?string,
  add_default_signature_block?: ?boolean,
  c_template_id?: ?string,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateContractMutationVariables = {|
  input: CreateContractInput
|};
export type NewDocument_CreateContractMutationResponse = {|
  +createContract: ?{|
    +contract: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateContractMutation = {|
  variables: NewDocument_CreateContractMutationVariables,
  response: NewDocument_CreateContractMutationResponse,
|};
*/

/*
mutation NewDocument_CreateContractMutation(
  $input: CreateContractInput!
) {
  createContract(input: $input) {
    contract {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateContractInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createContract",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateContractInput!"
    }],
    "concreteType": "CreateContractPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateContractMutation",
    "id": null,
    "text": "mutation NewDocument_CreateContractMutation(\n  $input: CreateContractInput!\n) {\n  createContract(input: $input) {\n    contract {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateContractMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateContractMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8ab28d3c554367b191c7c0da2a91a46b';
module.exports = node;

/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b45ea04784fb52ac06e6a68e1434f5cd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateEstimateInput = {
  clientMutationId?: ?string,
  title: string,
  workspace_ids: $ReadOnlyArray<?string>,
  copy_user_event_segments: boolean,
  copy_document?: ?CopyDocumentInput,
  brand_id?: ?string,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateEstimateMutationVariables = {|
  input: CreateEstimateInput
|};
export type NewDocument_CreateEstimateMutationResponse = {|
  +createEstimate: ?{|
    +estimate: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateEstimateMutation = {|
  variables: NewDocument_CreateEstimateMutationVariables,
  response: NewDocument_CreateEstimateMutationResponse,
|};
*/

/*
mutation NewDocument_CreateEstimateMutation(
  $input: CreateEstimateInput!
) {
  createEstimate(input: $input) {
    estimate {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEstimateInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createEstimate",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateEstimateInput!"
    }],
    "concreteType": "CreateEstimatePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateEstimateMutation",
    "id": null,
    "text": "mutation NewDocument_CreateEstimateMutation(\n  $input: CreateEstimateInput!\n) {\n  createEstimate(input: $input) {\n    estimate {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateEstimateMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateEstimateMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'bbf03939d40433b2b0a6e1ca3de13564';
module.exports = node;

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fee60d77cfd5d7962cbb2d581362106f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateFormInput = {
  clientMutationId?: ?string,
  title: string,
  workspace_id: string,
  description?: ?string,
  data?: ?string,
  schema?: ?string,
  ui_schema?: ?string,
  form_template_id?: ?string,
  brand_id?: ?string,
  copy_document?: ?CopyDocumentInput,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateFormMutationVariables = {|
  input: CreateFormInput
|};
export type NewDocument_CreateFormMutationResponse = {|
  +createForm: ?{|
    +form: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateFormMutation = {|
  variables: NewDocument_CreateFormMutationVariables,
  response: NewDocument_CreateFormMutationResponse,
|};
*/

/*
mutation NewDocument_CreateFormMutation(
  $input: CreateFormInput!
) {
  createForm(input: $input) {
    form {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateFormInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createForm",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateFormInput!"
    }],
    "concreteType": "CreateFormPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateFormMutation",
    "id": null,
    "text": "mutation NewDocument_CreateFormMutation(\n  $input: CreateFormInput!\n) {\n  createForm(input: $input) {\n    form {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateFormMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateFormMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4a980321cfe10ab24cd09c3256470b7e';
module.exports = node;

/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 55b96c644a9052abc9c8102caf6cf369
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateInvoiceInput = {
  clientMutationId?: ?string,
  title: string,
  workspace_ids: $ReadOnlyArray<?string>,
  copy_user_event_segments: boolean,
  copy_document?: ?CopyDocumentInput,
  brand_id?: ?string,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateInvoiceMutationVariables = {|
  input: CreateInvoiceInput
|};
export type NewDocument_CreateInvoiceMutationResponse = {|
  +createInvoice: ?{|
    +invoice: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateInvoiceMutation = {|
  variables: NewDocument_CreateInvoiceMutationVariables,
  response: NewDocument_CreateInvoiceMutationResponse,
|};
*/

/*
mutation NewDocument_CreateInvoiceMutation(
  $input: CreateInvoiceInput!
) {
  createInvoice(input: $input) {
    invoice {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateInvoiceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createInvoice",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateInvoiceInput!"
    }],
    "concreteType": "CreateInvoicePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateInvoiceMutation",
    "id": null,
    "text": "mutation NewDocument_CreateInvoiceMutation(\n  $input: CreateInvoiceInput!\n) {\n  createInvoice(input: $input) {\n    invoice {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateInvoiceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateInvoiceMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '17fe725f7ff6208022cbaea8146396d8';
module.exports = node;

/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d682e6cae063c5f057235f5e66c876b0
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentSections = "BRAND" | "DESCRIPTION" | "EVENT_SEGMENTS" | "FORM" | "LINE_ITEMS" | "NOTES" | "PAYMENT_PLAN" | "PLAYLISTS" | "RECIPIENT" | "SIGNATURE_BLOCKS" | "TERMS" | "%future added value";
export type CreateMusicPlannerInput = {
  clientMutationId?: ?string,
  title: string,
  description?: ?string,
  workspace_id: string,
  copy_document?: ?CopyDocumentInput,
  brand_id?: ?string,
  mp_template_id?: ?string,
};
export type CopyDocumentInput = {
  document_id?: ?string,
  include_only?: ?$ReadOnlyArray<?DocumentSections>,
  exclude?: ?$ReadOnlyArray<?DocumentSections>,
};
export type NewDocument_CreateMusicPlannerMutationVariables = {|
  input: CreateMusicPlannerInput
|};
export type NewDocument_CreateMusicPlannerMutationResponse = {|
  +createMusicPlanner: ?{|
    +music_planner: ?{|
      +id: string,
      +title: ?string,
    |}
  |}
|};
export type NewDocument_CreateMusicPlannerMutation = {|
  variables: NewDocument_CreateMusicPlannerMutationVariables,
  response: NewDocument_CreateMusicPlannerMutationResponse,
|};
*/

/*
mutation NewDocument_CreateMusicPlannerMutation(
  $input: CreateMusicPlannerInput!
) {
  createMusicPlanner(input: $input) {
    music_planner {
      id
      title
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMusicPlannerInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createMusicPlanner",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateMusicPlannerInput!"
    }],
    "concreteType": "CreateMusicPlannerPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateMusicPlannerMutation",
    "id": null,
    "text": "mutation NewDocument_CreateMusicPlannerMutation(\n  $input: CreateMusicPlannerInput!\n) {\n  createMusicPlanner(input: $input) {\n    music_planner {\n      id\n      title\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateMusicPlannerMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateMusicPlannerMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '351d74b31d5523dca36ad9a98f6cdc89';
module.exports = node;

/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 86d2a6a678c421f7a2d6217c094e52c1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateWuploadInput = {
  clientMutationId?: ?string,
  workspace_id: string,
  name: string,
  mimetype: string,
  source: string,
  url: string,
  size: number,
  handle: string,
};
export type NewDocument_CreateWuploadMutationVariables = {|
  input: CreateWuploadInput
|};
export type NewDocument_CreateWuploadMutationResponse = {|
  +createWupload: ?{|
    +workspace: ?{|
      +wuploads: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +mimetype: ?string,
            +name: ?string,
            +url: ?string,
          |}
        |}>
      |}
    |},
    +new_wupload_edge: ?{|
      +node: ?{|
        +id: string,
        +mimetype: ?string,
        +name: ?string,
        +url: ?string,
      |}
    |},
  |}
|};
export type NewDocument_CreateWuploadMutation = {|
  variables: NewDocument_CreateWuploadMutationVariables,
  response: NewDocument_CreateWuploadMutationResponse,
|};
*/

/*
mutation NewDocument_CreateWuploadMutation(
  $input: CreateWuploadInput!
) {
  createWupload(input: $input) {
    workspace {
      wuploads {
        edges {
          node {
            id
            mimetype
            name
            url
          }
        }
      }
      id
    }
    new_wupload_edge {
      node {
        id
        mimetype
        name
        url
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWuploadInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateWuploadInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "node",
    "storageKey": null,
    "args": null,
    "concreteType": "Wupload",
    "plural": false,
    "selections": [v2, {
      "kind": "ScalarField",
      "alias": null,
      "name": "mimetype",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }]
  }],
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "wuploads",
    "storageKey": null,
    "args": null,
    "concreteType": "WuploadConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "WuploadEdge",
      "plural": true,
      "selections": v3
    }]
  },
      v5 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "new_wupload_edge",
    "storageKey": null,
    "args": null,
    "concreteType": "WuploadEdge",
    "plural": false,
    "selections": v3
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "NewDocument_CreateWuploadMutation",
    "id": null,
    "text": "mutation NewDocument_CreateWuploadMutation(\n  $input: CreateWuploadInput!\n) {\n  createWupload(input: $input) {\n    workspace {\n      wuploads {\n        edges {\n          node {\n            id\n            mimetype\n            name\n            url\n          }\n        }\n      }\n      id\n    }\n    new_wupload_edge {\n      node {\n        id\n        mimetype\n        name\n        url\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "NewDocument_CreateWuploadMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createWupload",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWuploadPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "workspace",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v4]
        }, v5]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "NewDocument_CreateWuploadMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createWupload",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWuploadPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "workspace",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [v4, v2]
        }, v5]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'caee2b16835050db71f2774d0c748167';
module.exports = node;

/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 11f7059d908c8c2be23e4aaf55fd399d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ScheduleContainer_node$ref = any;
export type CreateUserEventSegmentInput = {
  clientMutationId?: ?string,
  user_event_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type ScheduleComponent_createUserEventSegmentMutationVariables = {|
  input: CreateUserEventSegmentInput
|};
export type ScheduleComponent_createUserEventSegmentMutationResponse = {|
  +createUserEventSegment: ?{|
    +user_event: ?{|
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +$fragmentRefs: ScheduleContainer_node$ref,
    |}
  |}
|};
export type ScheduleComponent_createUserEventSegmentMutation = {|
  variables: ScheduleComponent_createUserEventSegmentMutationVariables,
  response: ScheduleComponent_createUserEventSegmentMutationResponse,
|};
*/

/*
mutation ScheduleComponent_createUserEventSegmentMutation(
  $input: CreateUserEventSegmentInput!
) {
  createUserEventSegment(input: $input) {
    user_event {
      start_at
      end_at
      time_zone
      ...ScheduleContainer_node
      id
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateUserEventSegmentInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ScheduleComponent_createUserEventSegmentMutation",
    "id": null,
    "text": "mutation ScheduleComponent_createUserEventSegmentMutation(\n  $input: CreateUserEventSegmentInput!\n) {\n  createUserEventSegment(input: $input) {\n    user_event {\n      start_at\n      end_at\n      time_zone\n      ...ScheduleContainer_node\n      id\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ScheduleComponent_createUserEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "FragmentSpread",
            "name": "ScheduleContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ScheduleComponent_createUserEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4, v5, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": v6,
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v5, v2, v3, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_event_segments",
            "args": v6,
            "handle": "connection",
            "key": "ScheduleContainer_user_event_segments",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c069f1a97fe9f64586b141a5fb7189b6';
module.exports = node;

/***/ }),
/* 3350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 926753a9b37b7e52f2eca96a2a3a67e0
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUserEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ScheduleComponent_deleteUserEventSegmentMutationVariables = {|
  input: DeleteUserEventSegmentInput
|};
export type ScheduleComponent_deleteUserEventSegmentMutationResponse = {|
  +deleteUserEventSegment: ?{|
    +user_event: ?{|
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +user_event_segments: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +start_at: ?any,
            +end_at: ?any,
            +time_zone: ?string,
            +all_day: ?boolean,
            +location: ?string,
            +line1: ?string,
            +line2: ?string,
            +city: ?string,
            +province: ?string,
            +postal_code: ?string,
            +room: ?string,
            +notes: ?string,
          |}
        |}>
      |},
    |},
    +deletedUserEventSegmentId: ?string,
  |}
|};
export type ScheduleComponent_deleteUserEventSegmentMutation = {|
  variables: ScheduleComponent_deleteUserEventSegmentMutationVariables,
  response: ScheduleComponent_deleteUserEventSegmentMutationResponse,
|};
*/

/*
mutation ScheduleComponent_deleteUserEventSegmentMutation(
  $input: DeleteUserEventSegmentInput!
) {
  deleteUserEventSegment(input: $input) {
    user_event {
      start_at
      end_at
      time_zone
      user_event_segments {
        edges {
          node {
            id
            title
            start_at
            end_at
            time_zone
            all_day
            location
            line1
            line2
            city
            province
            postal_code
            room
            notes
          }
        }
      }
      id
    }
    deletedUserEventSegmentId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteUserEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteUserEventSegmentInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_event_segments",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventSegmentConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEventSegmentEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventSegment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        }, v5, v2, v3, v4, {
          "kind": "ScalarField",
          "alias": null,
          "name": "all_day",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "location",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "city",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "province",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "postal_code",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "room",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "deletedUserEventSegmentId",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ScheduleComponent_deleteUserEventSegmentMutation",
    "id": null,
    "text": "mutation ScheduleComponent_deleteUserEventSegmentMutation(\n  $input: DeleteUserEventSegmentInput!\n) {\n  deleteUserEventSegment(input: $input) {\n    user_event {\n      start_at\n      end_at\n      time_zone\n      user_event_segments {\n        edges {\n          node {\n            id\n            title\n            start_at\n            end_at\n            time_zone\n            all_day\n            location\n            line1\n            line2\n            city\n            province\n            postal_code\n            room\n            notes\n          }\n        }\n      }\n      id\n    }\n    deletedUserEventSegmentId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ScheduleComponent_deleteUserEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4, v6]
        }, v7]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ScheduleComponent_deleteUserEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4, v6, v5]
        }, v7]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '21d8761d515cd5a56a7c044b26ea844e';
module.exports = node;

/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b507dbc2900a7f5dfe066c57be66095a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserEventSegmentInput = {
  clientMutationId?: ?string,
  id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type ScheduleComponent_updateUserEventSegmentMutationVariables = {|
  input: UpdateUserEventSegmentInput
|};
export type ScheduleComponent_updateUserEventSegmentMutationResponse = {|
  +updateUserEventSegment: ?{|
    +user_event: ?{|
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
    |},
    +user_event_segment: ?{|
      +id: string,
      +title: ?string,
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +all_day: ?boolean,
      +location: ?string,
      +line1: ?string,
      +line2: ?string,
      +city: ?string,
      +province: ?string,
      +postal_code: ?string,
      +room: ?string,
      +notes: ?string,
    |},
  |}
|};
export type ScheduleComponent_updateUserEventSegmentMutation = {|
  variables: ScheduleComponent_updateUserEventSegmentMutationVariables,
  response: ScheduleComponent_updateUserEventSegmentMutationResponse,
|};
*/

/*
mutation ScheduleComponent_updateUserEventSegmentMutation(
  $input: UpdateUserEventSegmentInput!
) {
  updateUserEventSegment(input: $input) {
    user_event {
      start_at
      end_at
      time_zone
      id
    }
    user_event_segment {
      id
      title
      start_at
      end_at
      time_zone
      all_day
      location
      line1
      line2
      city
      province
      postal_code
      room
      notes
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventSegmentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserEventSegmentInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "user_event_segment",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventSegment",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "line1",
      "args": null,
      "storageKey": null
    }, v5, v2, v3, v4, {
      "kind": "ScalarField",
      "alias": null,
      "name": "all_day",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "line2",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "city",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "province",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "postal_code",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "room",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ScheduleComponent_updateUserEventSegmentMutation",
    "id": null,
    "text": "mutation ScheduleComponent_updateUserEventSegmentMutation(\n  $input: UpdateUserEventSegmentInput!\n) {\n  updateUserEventSegment(input: $input) {\n    user_event {\n      start_at\n      end_at\n      time_zone\n      id\n    }\n    user_event_segment {\n      id\n      title\n      start_at\n      end_at\n      time_zone\n      all_day\n      location\n      line1\n      line2\n      city\n      province\n      postal_code\n      room\n      notes\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ScheduleComponent_updateUserEventSegmentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4]
        }, v6]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ScheduleComponent_updateUserEventSegmentMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventSegmentPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [v2, v3, v4, v5]
        }, v6]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '222af9296f4638d4e9584f8e747d809f';
module.exports = node;

/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ScheduleContainer_node$ref: FragmentReference;
export type ScheduleContainer_node = {|
  +id: string,
  +user_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +$refType: ScheduleContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "ScheduleContainer_node",
    "type": "UserEvent",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["user_event_segments"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "LinkedField",
      "alias": "user_event_segments",
      "name": "__ScheduleContainer_user_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEventSegmentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventSegmentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegment",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "line1",
            "args": null,
            "storageKey": null
          }, v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "start_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "end_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "time_zone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "all_day",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "line2",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "province",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "postal_code",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "room",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '233f833acfbc498f07975264cf2629a9';
module.exports = node;

/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ScheduleContainer_viewer$ref: FragmentReference;
export type ScheduleContainer_viewer = {|
  +id: string,
  +s_time_zone: ?string,
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: ScheduleContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ScheduleContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_time_zone",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCalendarContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '29c9f407ed9eb5a39455eb9a155a5521';
module.exports = node;

/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a35dc90b7334f18b0e2118e30cf34a3e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddWorkspaceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type ShowComponent_addWorkspaceToSessionMutationVariables = {|
  input: AddWorkspaceToSessionInput
|};
export type ShowComponent_addWorkspaceToSessionMutationResponse = {|
  +addWorkspaceToSession: ?{|
    +workspace: ?{|
      +id: string
    |}
  |}
|};
export type ShowComponent_addWorkspaceToSessionMutation = {|
  variables: ShowComponent_addWorkspaceToSessionMutationVariables,
  response: ShowComponent_addWorkspaceToSessionMutationResponse,
|};
*/

/*
mutation ShowComponent_addWorkspaceToSessionMutation(
  $input: AddWorkspaceToSessionInput!
) {
  addWorkspaceToSession(input: $input) {
    workspace {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddWorkspaceToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addWorkspaceToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddWorkspaceToSessionInput!"
    }],
    "concreteType": "AddWorkspaceToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "workspace",
      "storageKey": null,
      "args": null,
      "concreteType": "Workspace",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShowComponent_addWorkspaceToSessionMutation",
    "id": null,
    "text": "mutation ShowComponent_addWorkspaceToSessionMutation(\n  $input: AddWorkspaceToSessionInput!\n) {\n  addWorkspaceToSession(input: $input) {\n    workspace {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShowComponent_addWorkspaceToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ShowComponent_addWorkspaceToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a48e1b2c21a0401b82e67cd933e8a7f3';
module.exports = node;

/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 3f720e3479d270d5d2cf9086a85e2611
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventShowContainer_node$ref = any;
type WorkspacesContainer_node$ref = any;
export type CreateWorkspaceInput = {
  clientMutationId?: ?string,
  event_id: string,
  title: string,
};
export type ShowEvent_CreateWorkspaceMutationVariables = {|
  input: CreateWorkspaceInput
|};
export type ShowEvent_CreateWorkspaceMutationResponse = {|
  +createWorkspace: ?{|
    +workspace: ?{|
      +id: string
    |},
    +event: ?{|
      +$fragmentRefs: EventShowContainer_node$ref & WorkspacesContainer_node$ref
    |},
  |}
|};
export type ShowEvent_CreateWorkspaceMutation = {|
  variables: ShowEvent_CreateWorkspaceMutationVariables,
  response: ShowEvent_CreateWorkspaceMutationResponse,
|};
*/

/*
mutation ShowEvent_CreateWorkspaceMutation(
  $input: CreateWorkspaceInput!
) {
  createWorkspace(input: $input) {
    workspace {
      id
    }
    event {
      ...EventShowContainer_node
      ...WorkspacesContainer_node
      id
    }
  }
}

fragment EventShowContainer_node on Event {
  id
  start_at
  end_at
  all_day
  time_zone
  title
  can_edit
  user_event {
    id
    booking_status
    visibility
    start_at
    end_at
    time_zone
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...EventSummaryContainer_node
}

fragment WorkspacesContainer_node on Event {
  id
  title
  start_at
  end_at
  time_zone
  can_edit
  user_contacts(first: 99999) {
    edges {
      node {
        first_name
        last_name
        user_contact_emails(first: 99999) {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
  user_event {
    start_at
    end_at
    time_zone
    id
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        share_token
        permissions
        can_email
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              can_edit
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              editable
              contract_signature_blocks {
                edges {
                  node {
                    signed_at
                    id
                  }
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        wuploads(first: 99999) {
          edges {
            node {
              id
              mimetype
              name
              url
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWorkspaceInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateWorkspaceInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "workspace",
    "storageKey": null,
    "args": null,
    "concreteType": "Workspace",
    "plural": false,
    "selections": [v2]
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v11 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line1",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line2",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "province",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v20 = [v2, v8, v17],
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShowEvent_CreateWorkspaceMutation",
    "id": null,
    "text": "mutation ShowEvent_CreateWorkspaceMutation(\n  $input: CreateWorkspaceInput!\n) {\n  createWorkspace(input: $input) {\n    workspace {\n      id\n    }\n    event {\n      ...EventShowContainer_node\n      ...WorkspacesContainer_node\n      id\n    }\n  }\n}\n\nfragment EventShowContainer_node on Event {\n  id\n  start_at\n  end_at\n  all_day\n  time_zone\n  title\n  can_edit\n  user_event {\n    id\n    booking_status\n    visibility\n    start_at\n    end_at\n    time_zone\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...EventSummaryContainer_node\n}\n\nfragment WorkspacesContainer_node on Event {\n  id\n  title\n  start_at\n  end_at\n  time_zone\n  can_edit\n  user_contacts(first: 99999) {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n  user_event {\n    start_at\n    end_at\n    time_zone\n    id\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        share_token\n        permissions\n        can_email\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              can_edit\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              editable\n              contract_signature_blocks {\n                edges {\n                  node {\n                    signed_at\n                    id\n                  }\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        wuploads(first: 99999) {\n          edges {\n            node {\n              id\n              mimetype\n              name\n              url\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShowEvent_CreateWorkspaceMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createWorkspace",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWorkspacePayload",
        "plural": false,
        "selections": [v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [{
            "kind": "FragmentSpread",
            "name": "EventShowContainer_node",
            "args": null
          }, {
            "kind": "FragmentSpread",
            "name": "WorkspacesContainer_node",
            "args": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ShowEvent_CreateWorkspaceMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createWorkspace",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWorkspacePayload",
        "plural": false,
        "selections": [v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [v2, v4, v5, v6, v7, v8, v9, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "booking_status",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "visibility",
              "args": null,
              "storageKey": null
            }, v4, v5, v7, v10, {
              "kind": "ScalarField",
              "alias": null,
              "name": "referral_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_event_segments",
              "storageKey": "user_event_segments(first:99999)",
              "args": v11,
              "concreteType": "UserEventSegmentConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegment",
                  "plural": false,
                  "selections": [v12, v2, v4, v5, v7, v6, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }, v8, v13, v14, v15, v16, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "room",
                    "args": null,
                    "storageKey": null
                  }, v10, v17]
                }, v18]
              }, v19]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "user_event_segments",
              "args": v11,
              "handle": "connection",
              "key": "ScheduleContainer_user_event_segments",
              "filters": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v11,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "music_planners",
                  "storageKey": "music_planners(first:99999)",
                  "args": v11,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MusicPlannerEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlanner",
                      "plural": false,
                      "selections": [v2, v8, v17, v9]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventShowContainer_music_planners",
                  "filters": null
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v11,
                  "handle": "connection",
                  "key": "WorkspacesContainer_music_planners",
                  "filters": null
                }, v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contracts",
                  "storageKey": "contracts(first:99999)",
                  "args": v11,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Contract",
                      "plural": false,
                      "selections": [v2, v8, v17, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "editable",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract_signature_blocks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractSignatureBlockConnection",
                        "plural": false,
                        "selections": [{
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractSignatureBlockEdge",
                          "plural": true,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractSignatureBlock",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "signed_at",
                              "args": null,
                              "storageKey": null
                            }, v2]
                          }]
                        }]
                      }]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "contracts",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventShowContainer_contracts",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "estimates",
                  "storageKey": "estimates(first:99999)",
                  "args": v11,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Estimate",
                      "plural": false,
                      "selections": v20
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "estimates",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventShowContainer_estimates",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "forms",
                  "storageKey": "forms(first:99999)",
                  "args": v11,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Form",
                      "plural": false,
                      "selections": v20
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventShowContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v11,
                  "handle": "connection",
                  "key": "WorkspacesContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoices",
                  "storageKey": "invoices(first:99999)",
                  "args": v11,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Invoice",
                      "plural": false,
                      "selections": v20
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "invoices",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventShowContainer_invoices",
                  "filters": null
                }, v8, v17, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "share_token",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "permissions",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "can_email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "wuploads",
                  "storageKey": "wuploads(first:99999)",
                  "args": v11,
                  "concreteType": "WuploadConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WuploadEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Wupload",
                      "plural": false,
                      "selections": [v2, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mimetype",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      }, v17]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "wuploads",
                  "args": v11,
                  "handle": "connection",
                  "key": "WorkspacesContainer_wuploads",
                  "filters": null
                }]
              }, v18]
            }, v19]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v11,
            "handle": "connection",
            "key": "EventShowContainer_workspaces",
            "filters": null
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v11,
            "handle": "connection",
            "key": "WorkspacesContainer_workspaces",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v11,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "storageKey": "user_contact_addresses(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddress",
                      "plural": false,
                      "selections": [v2, v21, v12, v13, v14, v15, v16, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      }, v17]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_addresses",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [v2, v21, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "address",
                        "args": null,
                        "storageKey": null
                      }, v17]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_emails",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_emails",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_phones",
                  "storageKey": "user_contact_phones(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhone",
                      "plural": false,
                      "selections": [v2, v21, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "number",
                        "args": null,
                        "storageKey": null
                      }, v17]
                    }, v18]
                  }, v19]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_phones",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_phones",
                  "filters": null
                }, v17]
              }, v18]
            }, v19]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_contacts",
            "args": v11,
            "handle": "connection",
            "key": "EventSummaryContainer_user_contacts",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6454d67ed486a1451cc4422dd767da1d';
module.exports = node;

/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 97378bc558326225a8dab9e1ff073b87
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEventInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
};
export type ShowEvent_UpdateEventMutationVariables = {|
  input: UpdateEventInput
|};
export type ShowEvent_UpdateEventMutationResponse = {|
  +updateEvent: ?{|
    +event: ?{|
      +title: ?string
    |}
  |}
|};
export type ShowEvent_UpdateEventMutation = {|
  variables: ShowEvent_UpdateEventMutationVariables,
  response: ShowEvent_UpdateEventMutationResponse,
|};
*/

/*
mutation ShowEvent_UpdateEventMutation(
  $input: UpdateEventInput!
) {
  updateEvent(input: $input) {
    event {
      title
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEventInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShowEvent_UpdateEventMutation",
    "id": null,
    "text": "mutation ShowEvent_UpdateEventMutation(\n  $input: UpdateEventInput!\n) {\n  updateEvent(input: $input) {\n    event {\n      title\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShowEvent_UpdateEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ShowEvent_UpdateEventMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEventPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": null,
          "concreteType": "Event",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a61bcdf9683c48ef71a414f251d89b33';
module.exports = node;

/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 37d080116d2e01732bb3e4afe083d067
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogViewUserEventInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ShowEvent_logViewUserEventMutationVariables = {|
  input: LogViewUserEventInput
|};
export type ShowEvent_logViewUserEventMutationResponse = {|
  +logViewUserEvent: ?{|
    +success: ?boolean
  |}
|};
export type ShowEvent_logViewUserEventMutation = {|
  variables: ShowEvent_logViewUserEventMutationVariables,
  response: ShowEvent_logViewUserEventMutationResponse,
|};
*/

/*
mutation ShowEvent_logViewUserEventMutation(
  $input: LogViewUserEventInput!
) {
  logViewUserEvent(input: $input) {
    success
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogViewUserEventInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logViewUserEvent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogViewUserEventInput!"
    }],
    "concreteType": "LogViewUserEventPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "success",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "ShowEvent_logViewUserEventMutation",
    "id": null,
    "text": "mutation ShowEvent_logViewUserEventMutation(\n  $input: LogViewUserEventInput!\n) {\n  logViewUserEvent(input: $input) {\n    success\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ShowEvent_logViewUserEventMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "ShowEvent_logViewUserEventMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7ffa7975858abb6d31a76e3752fdbd98';
module.exports = node;

/***/ }),
/* 3358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Event_scss__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Event_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Event_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TitleInput__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EventDates__ = __webpack_require__(3294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NewDocument__ = __webpack_require__(3301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NewDocumentMenu__ = __webpack_require__(3302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NewWorkspace__ = __webpack_require__(3304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__BookingStatus_js__ = __webpack_require__(3288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_utils_nullifyEmptyStrings__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DividedComponents__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__blueprintjs_core__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__blueprintjs_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__blueprintjs_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_stylesheets_SlideTransition_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_stylesheets_SlideTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__lib_stylesheets_SlideTransition_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2, _graphql3, _graphql4, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable global-require */
























var ShowEventComponent = (_temp = _class = function (_React$Component) {
  _inherits(ShowEvent, _React$Component);

  function ShowEvent(props) {
    _classCallCheck(this, ShowEvent);

    var _this = _possibleConstructorReturn(this, (ShowEvent.__proto__ || Object.getPrototypeOf(ShowEvent)).call(this, props));

    _this.state = {
      error: !_this.props.node,
      event: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.node),
      documentType: _this.props.location.query.type,
      documentTitle: '',
      newDocumentMenuOpen: false,
      newDocumentModalOpen: _this.props.location.query.action === 'new',
      newWorkspaceModalOpen: false,
      editWorkspaceOpen: false,
      editWorkspaceTitle: '',
      newWorkspaceTitle: '',
      submitted: false
    };
    _this.hasDates = _this.hasDates.bind(_this);
    _this.titleChangeHandler = _this.titleChangeHandler.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);

    _this.handleNewWorkspaceTitleChange = _this.handleNewWorkspaceTitleChange.bind(_this);
    _this.handleTitleChange = _this.handleTitleChange.bind(_this);

    _this.openNewDocumentMenu = _this.openNewDocumentMenu.bind(_this);
    _this.closeNewDocumentMenu = _this.closeNewDocumentMenu.bind(_this);
    _this.openNewDocumentModal = _this.openNewDocumentModal.bind(_this);
    _this.closeNewDocumentModal = _this.closeNewDocumentModal.bind(_this);
    _this.openNewWorkspaceModal = _this.openNewWorkspaceModal.bind(_this);
    _this.closeNewWorkspaceModal = _this.closeNewWorkspaceModal.bind(_this);

    _this.workspaceDropdownChangeHandler = _this.workspaceDropdownChangeHandler.bind(_this);
    _this.editWorkspaceTitleChangeHandler = _this.editWorkspaceTitleChangeHandler.bind(_this);
    _this.createWorkspace = _this.createWorkspace.bind(_this);
    return _this;
  }

  _createClass(ShowEvent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.node && this.props.location.query.share_token) {
        this.addWorkspaceToSession();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.node && this.props.node.user_event) {
        var mutation = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(3357);
        });

        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: { input: { id: this.props.node.user_event.id } }
        });
        // Send decoded event id to Analytics service
        __WEBPACK_IMPORTED_MODULE_10__Modules__["c" /* Analytics */].trackEvent('viewed-event', {
          event_id: atob(this.props.node.id).match(/(\d+)/)[0]
        });
      }
    }
  }, {
    key: 'addWorkspaceToSession',
    value: function addWorkspaceToSession() {
      var _this2 = this;

      this.setState({ error: false });
      var onCompleted = function onCompleted() {
        _this2.props.relay.refetch(function (fragmentVariables) {
          return fragmentVariables;
        }, null);
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3354);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.location.query.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'transition',
    value: function transition(e) {
      e.preventDefault();
      this.props.router.push(e.target.getAttribute('to') || '/');
    }
  }, {
    key: 'handleTitleChange',
    value: function handleTitleChange(e) {
      this.setState({ documentTitle: e.target.value });
    }
  }, {
    key: 'createWorkspace',
    value: function createWorkspace(successCb) {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_10__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to create workspace',
          intent: __WEBPACK_IMPORTED_MODULE_10__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        var newWorkspaceId = response.createWorkspace.workspace.id;
        if (successCb) {
          successCb(newWorkspaceId);
        } else {
          __WEBPACK_IMPORTED_MODULE_10__Modules__["a" /* GlobalNotifications */].show({
            message: 'Successfully created workspace',
            intent: __WEBPACK_IMPORTED_MODULE_10__Modules__["b" /* Intent */].SUCCESS
          });
          _this3.closeNewWorkspaceModal();
        }
        _this3.props.router.push('/events/' + _this3.props.node.id + '/workspaces');
        __WEBPACK_IMPORTED_MODULE_10__Modules__["c" /* Analytics */].trackEvent('created-workspace');
        _this3.setState({
          newWorkspaceTitle: ''
        });
      };

      var mutation = _graphql3 || (_graphql3 = function _graphql3() {
        return __webpack_require__(3355);
      });

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            event_id: this.props.node.id,
            title: this.state.newWorkspaceTitle
          }
        },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_10__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to update event title',
          intent: __WEBPACK_IMPORTED_MODULE_10__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted() {
        __WEBPACK_IMPORTED_MODULE_10__Modules__["a" /* GlobalNotifications */].show({
          message: 'Successfully updated event title',
          intent: __WEBPACK_IMPORTED_MODULE_10__Modules__["b" /* Intent */].SUCCESS
        });
      };

      // Set default title if null
      var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_utils_nullifyEmptyStrings__["a" /* default */])(this.state.event);
      event.title = event.title ? event.title : '(Untitled Event)';

      if (this.props.node.title !== event.title) {
        var mutation = _graphql4 || (_graphql4 = function _graphql4() {
          return __webpack_require__(3356);
        });

        var _state$event = this.state.event,
            id = _state$event.id,
            title = _state$event.title;

        var optimisticResponse = { updateEvent: { event: { id: id, title: title } } };
        var environment = this.props.relay.environment;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
          mutation: mutation,
          variables: {
            input: {
              id: id,
              title: title
            }
          },
          optimisticResponse: optimisticResponse,
          onCompleted: onCompleted,
          onError: onError
        });
      }
    }
  }, {
    key: 'titleChangeHandler',
    value: function titleChangeHandler(e) {
      this.setState({
        event: Object.assign(this.state.event, { title: e.target.value })
      });
    }
  }, {
    key: 'editWorkspaceTitleChangeHandler',
    value: function editWorkspaceTitleChangeHandler(e) {
      this.setState({ editWorkspaceTitle: e.target.value });
    }
  }, {
    key: 'workspaceDropdownChangeHandler',
    value: function workspaceDropdownChangeHandler(e, selection) {
      this.props.router.push(selection.value);
    }
  }, {
    key: 'openNewWorkspaceModal',
    value: function openNewWorkspaceModal() {
      this.setState({ newWorkspaceModalOpen: true });
    }
  }, {
    key: 'closeNewWorkspaceModal',
    value: function closeNewWorkspaceModal() {
      this.setState({ newWorkspaceModalOpen: false });
    }
  }, {
    key: 'openNewDocumentMenu',
    value: function openNewDocumentMenu() {
      this.setState({ newDocumentMenuOpen: true });
    }
  }, {
    key: 'closeNewDocumentMenu',
    value: function closeNewDocumentMenu() {
      this.setState({ newDocumentMenuOpen: false });
    }
  }, {
    key: 'openNewDocumentModal',
    value: function openNewDocumentModal(documentType) {
      this.setState({
        newDocumentModalOpen: true,
        documentType: documentType,
        documentTitle: this.props.node.title + ' ' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toLower(documentType))
      });
    }
  }, {
    key: 'closeNewDocumentModal',
    value: function closeNewDocumentModal() {
      this.setState({
        newDocumentModalOpen: false,
        documentType: null,
        newWorkspaceTitle: ''
      });
    }
  }, {
    key: 'handleNewWorkspaceTitleChange',
    value: function handleNewWorkspaceTitleChange(e) {
      this.setState({ newWorkspaceTitle: e.target.value });
    }
  }, {
    key: 'hasDates',
    value: function hasDates(event) {
      var userEventHasDates = event.user_event && event.user_event.start_at && event.user_event.end_at;
      var eventHasDates = event.start_at && event.end_at;
      return Boolean(userEventHasDates || eventHasDates);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          event = _props.node,
          params = _props.params,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      var location = Object.assign({}, this.props.location, {
        query: {},
        search: ''
      });

      var workspaceDropdownOptions = [{
        text: 'Workspaces',
        value: '/events/' + params.event_id + '/workspaces'
      }];
      if (event && event.user_event) {
        workspaceDropdownOptions.unshift({
          text: 'Summary',
          value: '/events/' + params.event_id
        });
      }

      var eventDates = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EventDates__["a" /* default */], { event: event, relay: relay, viewer: viewer });

      var bookingStatus = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__BookingStatus_js__["a" /* default */], { event: event, relay: relay });

      var eventMetaData = [];
      if (event && this.hasDates(event)) eventMetaData.push(eventDates);
      if (event && event.user_event) eventMetaData.push(bookingStatus);

      var newDocumentMenu = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__NewDocumentMenu__["a" /* default */], {
        button: true,
        text: 'New',
        className: 'icon primary',
        icon: 'plus',
        labeled: true,
        openNewDocumentModal: this.openNewDocumentModal,
        openNewWorkspaceModal: this.openNewWorkspaceModal,
        viewer: viewer
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        event && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          viewer && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__App_MobileHeader__["a" /* default */],
            { viewer: viewer, router: router },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
                {
                  as: 'a',
                  className: sidebarOpen ? 'active ' : '',
                  onClick: toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.headerSection },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["s" /* Container */],
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */],
                { stackable: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
                  { style: { paddingBottom: 0 } },
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                    {
                      computer: 13,
                      tablet: 13,
                      mobile: 16,
                      floated: 'left'
                    },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_formsy_react___default.a.Form,
                      { className: 'ui form' },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'ui transparent fluid massive' },
                        event.can_edit && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_10__Modules__["k" /* Dthc */],
                          {
                            desktop: __WEBPACK_IMPORTED_MODULE_12__TitleInput__["a" /* default */],
                            mobile: __WEBPACK_IMPORTED_MODULE_12__TitleInput__["a" /* default */],
                            title: event.title,
                            onChange: this.titleChangeHandler,
                            commitUpdate: this.updateTitle,
                            handleClickOutside: true
                          },
                          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.title },
                            event.title
                          )
                        ),
                        !event.can_edit && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          'div',
                          { className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.title },
                          event.title
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { style: { margin: '1em 0 0 0' } },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: [__WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.statusContainer].join(' ') },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DividedComponents__["a" /* default */], { children: eventMetaData })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      {
                        style: { display: 'table', width: '100%' },
                        className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.mobile
                      },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { style: { display: 'table-cell', width: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Dropdown */], {
                          selection: true,
                          button: true,
                          basic: true,
                          fluid: true,
                          onChange: this.workspaceDropdownChangeHandler,
                          options: workspaceDropdownOptions,
                          value: location.pathname,
                          style: { marginBottom: '1em' }
                        })
                      ),
                      event.user_event && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        {
                          style: {
                            display: 'table-cell',
                            paddingLeft: '1em'
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */], {
                          basic: true,
                          icon: 'plus',
                          onClick: this.openNewDocumentMenu
                        }),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_21_react_addons_css_transition_group___default.a,
                          {
                            transitionName: 'slide',
                            transitionEnterTimeout: 300,
                            transitionLeaveTimeout: 300
                          },
                          this.state.newDocumentMenuOpen && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_10__Modules__["f" /* MobileModal */],
                            {
                              open: this.state.newDocumentMenuOpen,
                              onClose: this.closeNewDocumentMenu,
                              inline: true
                            },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_10__Modules__["f" /* MobileModal */].Header,
                              null,
                              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { className: 'menu' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
                                  {
                                    as: 'a',
                                    onClick: this.closeNewDocumentMenu
                                  },
                                  'Cancel'
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_10__Modules__["f" /* MobileModal */].Content,
                              null,
                              newDocumentMenu
                            )
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */],
                      {
                        pointing: true,
                        secondary: true,
                        className: __WEBPACK_IMPORTED_MODULE_8__globals_scss___default.a.desktop,
                        style: {
                          borderBottom: 0,
                          marginBottom: 0,
                          marginTop: '2em'
                        }
                      },
                      event.user_event && [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                        as: __WEBPACK_IMPORTED_MODULE_4_found__["Link"],
                        to: '/events/' + params.event_id,
                        name: 'Summary',
                        className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.noOutline,
                        active: router.isActive({
                          location: {
                            pathname: '/events/' + params.event_id
                          }
                        }, location, { exact: true }),
                        key: 'summary'
                      })],
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                        as: __WEBPACK_IMPORTED_MODULE_4_found__["Link"],
                        className: __WEBPACK_IMPORTED_MODULE_7__Event_scss___default.a.noOutline,
                        name: 'Workspaces',
                        to: '/events/' + event.id + '/workspaces',
                        active: router.isActive({
                          location: {
                            pathname: '/events/' + params.event_id + '/workspaces'
                          }
                        }, location, { exact: true })
                      })
                    ),
                    event.user_event && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NewWorkspace__["a" /* default */], {
                        closeNewWorkspaceModal: this.closeNewWorkspaceModal,
                        createWorkspace: this.createWorkspace,
                        handleNewWorkspaceTitleChange: this.handleNewWorkspaceTitleChange,
                        newWorkspaceModalOpen: this.state.newWorkspaceModalOpen,
                        newWorkspaceTitle: this.state.newWorkspaceTitle
                      }),
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__NewDocument__["a" /* default */], {
                        location: location,
                        newDocumentModalOpen: this.state.newDocumentModalOpen,
                        newWorkspaceTitle: this.state.newWorkspaceTitle,
                        closeNewDocumentModal: this.closeNewDocumentModal,
                        createWorkspace: this.createWorkspace,
                        documentType: this.state.documentType,
                        handleNewWorkspaceTitleChange: this.handleNewWorkspaceTitleChange,
                        handleTitleChange: this.handleTitleChange,
                        node: event,
                        relay: relay,
                        router: router,
                        title: this.state.documentTitle,
                        viewer: viewer
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                    { width: 3, only: 'computer tablet' },
                    event.can_edit && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                      'div',
                      { style: { float: 'right' } },
                      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_20__blueprintjs_core__["Popover"],
                        {
                          content: newDocumentMenu,
                          interactionKind: __WEBPACK_IMPORTED_MODULE_20__blueprintjs_core__["PopoverInteractionKind"].CLICK,
                          popoverClassName: 'pt-popover-content-sizing',
                          position: __WEBPACK_IMPORTED_MODULE_20__blueprintjs_core__["Position"].BOTTOM_RIGHT,
                          inline: true,
                          popoverWillOpen: this.openNewDocumentMenu,
                          popoverWillClose: this.closeNewDocumentMenu
                        },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
                          {
                            primary: true,
                            icon: true,
                            labelPosition: 'left',
                            onClick: this.openNewDocumentMenu
                          },
                          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'plus' }),
                          'New'
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */],
            { container: true },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16 },
                children
              )
            )
          )
        ),
        !event && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          this.state.error && children,
          !this.state.error && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements__["a" /* Loader */], null)
        )
      );
    }
  }]);

  return ShowEvent;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_found__["withRouter"])(ShowEventComponent));

/***/ }),
/* 3359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FinancialComponent = (_temp = _class = function (_React$Component) {
  _inherits(FinancialComponent, _React$Component);

  function FinancialComponent() {
    _classCallCheck(this, FinancialComponent);

    return _possibleConstructorReturn(this, (FinancialComponent.__proto__ || Object.getPrototypeOf(FinancialComponent)).apply(this, arguments));
  }

  _createClass(FinancialComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          location = _props.location,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__["a" /* default */],
          { viewer: viewer, router: router },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
              {
                as: 'a',
                className: sidebarOpen ? 'active ' : '',
                onClick: toggleSidebar
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'right menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["C" /* Item */],
              { as: 'a', onClick: router.push.bind(null, '/search') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["d" /* Icon */], { name: 'search' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */],
          { container: true, stackable: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
            { rows: 'equal', style: { marginTop: '2em' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */],
                { secondary: true, pointing: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                  name: 'Overview',
                  active: router.isActive({
                    location: {
                      pathname: '/financials'
                    }
                  }, location, { exact: true }),
                  onClick: function onClick() {
                    return router.push('/financials');
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                  name: 'Invoices',
                  onClick: function onClick() {
                    return router.push('/financials/invoices');
                  },
                  active: location.pathname === '/financials/invoices'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Menu */].Item, {
                  name: 'Payments',
                  onClick: function onClick() {
                    return router.push('/financials/payments');
                  },
                  active: router.isActive({
                    location: {
                      pathname: '/financials/payments'
                    }
                  }, location, { exact: true }) || router.isActive({
                    location: {
                      pathname: '/financials/payments/outstanding'
                    }
                  }, location, { exact: true }) || router.isActive({
                    location: {
                      pathname: '/financials/payments/refunds'
                    }
                  }, location, { exact: true })
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
            { style: { margin: '2em 0' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
              { width: 16 },
              children
            )
          )
        )
      );
    }
  }]);

  return FinancialComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__App_Authenticate__["a" /* default */])(FinancialComponent)));

/***/ }),
/* 3360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FinancialComponent__ = __webpack_require__(3359);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__FinancialComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3382);
  }
}));

/***/ }),
/* 3361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Financial_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceListHeader__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_waypoint__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InvoiceList = (_temp = _class = function (_React$Component) {
  _inherits(InvoiceList, _React$Component);

  function InvoiceList(props) {
    _classCallCheck(this, InvoiceList);

    var _this = _possibleConstructorReturn(this, (InvoiceList.__proto__ || Object.getPrototypeOf(InvoiceList)).call(this, props));

    _this.getLabel = _this.getLabel.bind(_this);
    _this.transition = _this.transition.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    _this.state = {
      loading: false,
      listSize: 20,
      showSearch: false
    };
    return _this;
  }

  _createClass(InvoiceList, [{
    key: 'getLabel',
    value: function getLabel(status) {
      switch (status) {
        case 'paid':
          return { color: 'black', text: 'Paid' };
        case 'past_due':
          return { color: 'red', text: 'Past Due' };
        default:
          return { color: null, text: 'Outstanding' };
      }
    }
  }, {
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(20, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 20 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'transition',
    value: function transition(to) {
      this.props.router.push(to);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var invoices = this.props.viewer.invoices;
      var query = this.props.location.query;

      var currency = 'USD';
      var statusMappings = {
        ALL: '',
        OUTSTANDING: 'outstanding',
        PAID: 'paid',
        PAST_DUE: 'past due'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Segment */],
          { className: __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InvoiceListHeader__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */],
            null,
            invoices.edges.map(function (invoice) {
              return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
                {
                  only: 'mobile',
                  onClick: _this3.transition.bind(null, '/docs/i/' + invoice.node.id),
                  key: invoice.node.id + '_mobile',
                  className: __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default.a.tableRow
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        invoice.node.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default.a.eventTitleMobile },
                        invoice.node.workspaces.edges[0].node.event.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default.a.paymentSummary },
                        __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(invoice.node.outstanding_cents / 100, { code: currency }),
                        ' remaining \xA0/ \xA0',
                        __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(invoice.node.total_cents / 100, { code: currency })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { textAlign: 'right' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["y" /* Label */],
                        {
                          style: { marginTop: '0.5em' },
                          basic: true,
                          color: _this3.getLabel(invoice.node.status).color,
                          size: 'small'
                        },
                        _this3.getLabel(invoice.node.status).text
                      )
                    )
                  )
                )
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
                {
                  onClick: _this3.transition.bind(null, '/docs/i/' + invoice.node.id),
                  className: __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default.a.tableRow,
                  only: 'computer tablet',
                  key: invoice.node.id + '_computer'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      invoice.node.title
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_4__Financial_scss___default.a.mutedText },
                    invoice.node.workspaces.edges[0].node.event.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["y" /* Label */],
                    {
                      basic: true,
                      color: _this3.getLabel(invoice.node.status).color
                    },
                    _this3.getLabel(invoice.node.status).text
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(invoice.node.total_cents / 100, { code: currency })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(invoice.node.outstanding_cents / 100, { code: currency })
                )
              )];
            }),
            invoices.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { style: { textAlign: 'center', margin: '2em' } },
                  'You have no ',
                  statusMappings[query.status],
                  ' invoices'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -200 }),
        this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: '2em', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["j" /* Loader */], {
            active: true,
            inline: true,
            size: 'tiny',
            style: { marginRight: '1em' }
          }),
          ' ',
          'Loading More...'
        )
      );
    }
  }]);

  return InvoiceList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(InvoiceList));

/***/ }),
/* 3362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InvoiceList__ = __webpack_require__(3361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_InvoiceQuery__ = __webpack_require__(1492);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__InvoiceList__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3366);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.invoices;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return {
      count: count,
      cursor: cursor,
      status: fragmentVariables.status
    };
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_InvoiceQuery__["a" /* default */]
}));

/***/ }),
/* 3363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvoiceListHeader__ = __webpack_require__(1484);






/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["t" /* Segment */],
    { className: __WEBPACK_IMPORTED_MODULE_3__App_App_scss___default.a.segmentContainer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InvoiceListHeader__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["a" /* Loader */], null)
  );
});

/***/ }),
/* 3364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Financial_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InvoicesComponent = function (_Component) {
  _inherits(InvoicesComponent, _Component);

  function InvoicesComponent(props) {
    _classCallCheck(this, InvoicesComponent);

    var _this = _possibleConstructorReturn(this, (InvoicesComponent.__proto__ || Object.getPrototypeOf(InvoicesComponent)).call(this, props));

    _this.toggleStatus = _this.toggleStatus.bind(_this);
    _this.handleStatusFilterChange = _this.handleStatusFilterChange.bind(_this);
    _this.setQuery = _this.setQuery.bind(_this);
    return _this;
  }

  _createClass(InvoicesComponent, [{
    key: 'setQuery',
    value: function setQuery(key, value) {
      var _$cloneDeep = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.location),
          pathname = _$cloneDeep.pathname,
          query = _$cloneDeep.query;

      query[key] = value;
      this.props.router.replace({ pathname: pathname, query: query });
    }
  }, {
    key: 'handleStatusFilterChange',
    value: function handleStatusFilterChange(e, selection) {
      this.setQuery('status', selection.value);
    }
  }, {
    key: 'toggleStatus',
    value: function toggleStatus(e, status) {
      var updatedStatus = this.props.location.query.status === status ? 'ALL' : status;
      this.setQuery('status', updatedStatus);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var query = this.props.location.query;

      var currency = 'USD';
      var viewer = this.props.viewer;


      var statusOptions = [{ text: 'All Invoices', value: 'ALL' }, { text: 'Outstanding Invoices', value: 'OUTSTANDING' }, { text: 'Paid Invoices', value: 'PAID' }, { text: 'Past Due Invoices', value: 'PAST_DUE' }];
      var statusMappings = {
        ALL: 'All Invoices',
        OUTSTANDING: 'Outstanding Invoices',
        PAID: 'Paid Invoices',
        PAST_DUE: 'Past Due Invoices'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
        { stackable: true },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { width: 8 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                { columns: 'equal' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
                    {
                      onChange: function onChange(e) {
                        return _this2.toggleStatus(e, 'OUTSTANDING');
                      },
                      checked: query.status === 'OUTSTANDING',
                      className: __WEBPACK_IMPORTED_MODULE_7__Financial_scss___default.a.statusBlock,
                      color: 'grey'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'h3',
                      null,
                      'Outstanding Payments'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      { className: __WEBPACK_IMPORTED_MODULE_7__Financial_scss___default.a.statusBlockAmount },
                      __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(viewer.outstanding_payments_cents / 100, { code: currency })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__Elements__["g" /* SelectableBlock */],
                    {
                      onChange: function onChange(e) {
                        return _this2.toggleStatus(e, 'PAST_DUE');
                      },
                      checked: query.status === 'PAST_DUE',
                      className: __WEBPACK_IMPORTED_MODULE_7__Financial_scss___default.a.statusBlock,
                      color: 'grey'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'h3',
                      null,
                      'Past Due Payments'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      {
                        className: [__WEBPACK_IMPORTED_MODULE_7__Financial_scss___default.a.statusBlockAmount, viewer.past_due_payments_cents > 0 ? __WEBPACK_IMPORTED_MODULE_7__Financial_scss___default.a.red : null].join(' ')
                      },
                      __WEBPACK_IMPORTED_MODULE_6_currency_formatter___default.a.format(viewer.past_due_payments_cents / 100, { code: currency })
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column, { width: 8 })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal', only: 'computer tablet' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */], {
              button: true,
              basic: true,
              floating: true,
              trigger: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'filter' }),
                ' ',
                statusMappings[query.status] || 'All Invoices'
              ),
              onChange: this.handleStatusFilterChange,
              options: statusOptions,
              value: query.status || 'ALL'
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal', only: 'mobile' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */], {
              button: true,
              basic: true,
              fluid: true,
              floating: true,
              trigger: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'filter' }),
                ' ',
                statusMappings[query.status] || 'All Invoices'
              ),
              onChange: this.handleStatusFilterChange,
              options: statusOptions,
              value: query.status || 'ALL'
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            { width: 16 },
            this.props.children
          )
        )
      );
    }
  }]);

  return InvoicesComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

InvoicesComponent.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_found__["withRouter"])(InvoicesComponent));

/***/ }),
/* 3365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InvoicesComponent__ = __webpack_require__(3364);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__InvoicesComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3367);
  }
}));

/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceListContainer_viewer$ref: FragmentReference;
export type InvoiceListContainer_viewer = {|
  +invoices: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +status: ?string,
        +total_cents: ?number,
        +outstanding_cents: ?number,
        +workspaces: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +event: ?{|
                +id: string,
                +title: ?string,
              |}
            |}
          |}>
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: InvoiceListContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "InvoiceListContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["invoices"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "status",
      "type": "InvoiceStatus",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": "invoices",
      "name": "__InvoiceList_invoices_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "status",
        "variableName": "status",
        "type": "InvoiceStatus"
      }],
      "concreteType": "InvoiceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Invoice",
          "plural": false,
          "selections": [v0, v1, {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "outstanding_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:1)",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 1,
              "type": "Int"
            }],
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v0, v1]
                }]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a6bc72f878afa18263553894f37967f4';
module.exports = node;

/***/ }),
/* 3367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoicesContainer_viewer$ref: FragmentReference;
export type InvoicesContainer_viewer = {|
  +past_due_payments_cents: ?number,
  +outstanding_payments_cents: ?number,
  +$refType: InvoicesContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InvoicesContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "past_due_payments_cents",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "outstanding_payments_cents",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '3b9d0fffc287fd75df9a74eb2434925b';
module.exports = node;

/***/ }),
/* 3368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Financial_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__ = __webpack_require__(262);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CompletedPayments = function (_Component) {
  _inherits(CompletedPayments, _Component);

  function CompletedPayments(props) {
    _classCallCheck(this, CompletedPayments);

    var _this = _possibleConstructorReturn(this, (CompletedPayments.__proto__ || Object.getPrototypeOf(CompletedPayments)).call(this, props));

    _this.state = {
      loading: false,
      listSize: 20
    };
    _this.transition = _this.transition.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(CompletedPayments, [{
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(20, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 20 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'transition',
    value: function transition(to) {
      this.props.router.push(to);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var timeZone = this.props.viewer.s_time_zone;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
          { className: __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default.a.segmentContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { only: 'computer tablet', className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableHeader },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Invoice'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Paid By'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Payment Amount'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Date Paid'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Payment Method'
                )
              )
            ),
            this.props.viewer.completed_payments.edges.map(function (payment) {
              return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  only: 'mobile',
                  onClick: _this3.transition.bind(null, '/docs/i/' + payment.node.invoice.id),
                  key: payment.node.id + '_mobile',
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        payment.node.invoice.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.eventTitleMobile },
                        payment.node.invoice.workspaces.edges[0].node.event.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.paymentSummary },
                        'Paid by ',
                        payment.node.name,
                        ' on',
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          {
                            title: __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(timeZone).format('z')
                          },
                          __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('L')
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { textAlign: 'right' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(payment.node.amount_cents / 100, { code: payment.node.amount_currency })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["y" /* Label */],
                        {
                          style: { marginTop: '0.5em' },
                          basic: true,
                          size: 'small',
                          color: 'black'
                        },
                        __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__["a" /* default */].payments(payment.node)
                      )
                    )
                  )
                )
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  onClick: _this3.transition.bind(null, '/docs/i/' + payment.node.invoice.id),
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow,
                  only: 'computer tablet',
                  key: payment.node.id + '_computer'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      payment.node.invoice.title
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.mutedText },
                    payment.node.invoice.workspaces.edges[0].node.event.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3 },
                  payment.node.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(payment.node.amount_cents / 100, {
                    code: payment.node.amount_currency
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    {
                      title: __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(timeZone).format('z')
                    },
                    __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(payment.node.paid_at, timeZone).format('L')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__["a" /* default */].payments(payment.node)
                )
              )];
            }),
            this.props.viewer.completed_payments.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { style: { textAlign: 'center', margin: '2em' } },
                  'You have no completed payments'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -200 }),
        this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: '2em', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], {
            active: true,
            inline: true,
            size: 'tiny',
            style: { marginRight: '1em' }
          }),
          ' ',
          'Loading More...'
        )
      );
    }
  }]);

  return CompletedPayments;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CompletedPayments.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(CompletedPayments));

/***/ }),
/* 3369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompletedPaymentsComponent__ = __webpack_require__(3368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_CompletedPaymentsQuery__ = __webpack_require__(1490);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__CompletedPaymentsComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3375);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.completed_payments;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return _extends({}, fragmentVariables, {
      count: count,
      cursor: cursor

    });
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_CompletedPaymentsQuery__["a" /* default */]
}));

/***/ }),
/* 3370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Financial_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var OutstandingPayments = function (_Component) {
  _inherits(OutstandingPayments, _Component);

  function OutstandingPayments(props) {
    _classCallCheck(this, OutstandingPayments);

    var _this = _possibleConstructorReturn(this, (OutstandingPayments.__proto__ || Object.getPrototypeOf(OutstandingPayments)).call(this, props));

    _this.state = {
      loading: false,
      listSize: 20
    };
    _this.transition = _this.transition.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(OutstandingPayments, [{
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(20, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 20 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'transition',
    value: function transition(to) {
      this.props.router.push(to);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
          { className: __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default.a.segmentContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { only: 'computer tablet', className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableHeader },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 10 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Invoice'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Amount Due'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Due On'
                )
              )
            ),
            this.props.viewer.outstanding_payments.edges.map(function (payment) {
              return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  only: 'mobile',
                  onClick: _this3.transition.bind(null, '/docs/i/' + payment.node.invoice.id),
                  key: payment.node.id + '_mobile',
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        payment.node.invoice.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.eventTitleMobile },
                        payment.node.invoice.workspaces.edges[0].node.event.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.paymentSummary },
                        'Due on ',
                        __WEBPACK_IMPORTED_MODULE_9_moment___default()(payment.node.payment_date).format('L')
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { textAlign: 'right' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(payment.node.amount_cents / 100, { code: payment.node.amount_currency })
                      )
                    )
                  )
                )
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  onClick: _this3.transition.bind(null, '/docs/i/' + payment.node.invoice.id),
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow,
                  only: 'computer tablet',
                  key: payment.node.id + '_computer'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 10 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      payment.node.invoice.title
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.mutedText },
                    payment.node.invoice.workspaces.edges[0].node.event.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(payment.node.amount_cents / 100, { code: payment.node.amount_currency })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_9_moment___default()(payment.node.payment_date).format('L')
                )
              )];
            }),
            this.props.viewer.outstanding_payments.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { style: { textAlign: 'center', margin: '2em' } },
                  'You have no outstanding payments'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -200 }),
        this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: '2em', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], {
            active: true,
            inline: true,
            size: 'tiny',
            style: { marginRight: '1em' }
          }),
          ' ',
          'Loading More...'
        )
      );
    }
  }]);

  return OutstandingPayments;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

OutstandingPayments.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OutstandingPayments));

/***/ }),
/* 3371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OutstandingPaymentsComponent__ = __webpack_require__(3370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_OutstandingPaymentsQuery__ = __webpack_require__(1493);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__OutstandingPaymentsComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3376);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.outstanding_payments;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return _extends({}, fragmentVariables, {
      count: count,
      cursor: cursor

    });
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_OutstandingPaymentsQuery__["a" /* default */]
}));

/***/ }),
/* 3372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PaymentsComponent = function (_Component) {
  _inherits(PaymentsComponent, _Component);

  function PaymentsComponent(props) {
    _classCallCheck(this, PaymentsComponent);

    var _this = _possibleConstructorReturn(this, (PaymentsComponent.__proto__ || Object.getPrototypeOf(PaymentsComponent)).call(this, props));

    _this.handleStatusFilterChange = _this.handleStatusFilterChange.bind(_this);
    return _this;
  }

  _createClass(PaymentsComponent, [{
    key: 'handleStatusFilterChange',
    value: function handleStatusFilterChange(e, _ref) {
      var value = _ref.value;

      switch (value) {
        case 'outstanding':
          this.props.router.replace('/financials/payments/outstanding');
          break;
        case 'refunds':
          this.props.router.replace('/financials/payments/refunds');
          break;
        default:
          this.props.router.replace('/financials/payments');
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var statusOptions = [{ text: 'Completed Payments', value: 'completed' }, { text: 'Outstanding Payments', value: 'outstanding' }, { text: 'Refunds', value: 'refunds' }];
      var statusMappings = {
        completed: 'Completed Payments',
        outstanding: 'Outstanding Payments',
        refunds: 'Refunds'
      };
      var status = function (pathname) {
        switch (pathname) {
          case '/financials/payments/outstanding':
            return 'outstanding';
          case '/financials/payments/refunds':
            return 'refunds';
          default:
            return 'completed';
        }
      }(this.props.location.pathname);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
        { stackable: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal', only: 'computer tablet' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["l" /* Dropdown */], {
              button: true,
              basic: true,
              floating: true,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'filter' }),
                ' ',
                statusMappings[status]
              ),
              onChange: this.handleStatusFilterChange,
              options: statusOptions,
              value: status
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal', only: 'mobile' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["l" /* Dropdown */], {
              button: true,
              basic: true,
              fluid: true,
              floating: true,
              trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'filter' }),
                ' ',
                statusMappings[status]
              ),
              onChange: this.handleStatusFilterChange,
              options: statusOptions,
              value: status
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
            { width: 16 },
            this.props.children
          )
        )
      );
    }
  }]);

  return PaymentsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PaymentsComponent.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(PaymentsComponent));

/***/ }),
/* 3373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Financial_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__ = __webpack_require__(262);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Refunds = function (_Component) {
  _inherits(Refunds, _Component);

  function Refunds(props) {
    _classCallCheck(this, Refunds);

    var _this = _possibleConstructorReturn(this, (Refunds.__proto__ || Object.getPrototypeOf(Refunds)).call(this, props));

    _this.state = {
      loading: false,
      listSize: 20
    };
    _this.transition = _this.transition.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(Refunds, [{
    key: 'loadMore',
    value: function loadMore() {
      var _this2 = this;

      if (this.props.relay.hasMore() && !this.state.loading) {
        this.props.relay.loadMore(20, function () {
          _this2.setState({ loading: false, listSize: _this2.state.listSize + 20 });
        });
        this.setState({ loading: true });
      }
    }
  }, {
    key: 'transition',
    value: function transition(to) {
      this.props.router.push(to);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var timeZone = this.props.viewer.s_time_zone;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
          { className: __WEBPACK_IMPORTED_MODULE_5__App_App_scss___default.a.segmentContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { only: 'computer tablet', className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableHeader },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 7 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Invoice'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Refund Amount'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Date Refunded'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 3, textAlign: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Payment Method'
                )
              )
            ),
            this.props.viewer.refunds.edges.map(function (refund) {
              return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  only: 'mobile',
                  onClick: _this3.transition.bind(null, '/docs/i/' + refund.node.invoice.id),
                  key: refund.node.id + '_mobile',
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 16 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        refund.node.invoice.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.eventTitleMobile },
                        refund.node.invoice.workspaces.edges[0].node.event.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.paymentSummary },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          {
                            title: __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(timeZone).format('z')
                          },
                          __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('L')
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { textAlign: 'right' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.red },
                        '(',
                        __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(refund.node.amount_cents / 100, { code: refund.node.amount_currency }),
                        ')'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["y" /* Label */],
                        {
                          style: { marginTop: '0.5em' },
                          basic: true,
                          size: 'small',
                          color: 'black'
                        },
                        __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__["a" /* default */].payments(refund.node.payment)
                      )
                    )
                  )
                )
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                {
                  onClick: _this3.transition.bind(null, '/docs/i/' + refund.node.invoice.id),
                  className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.tableRow,
                  only: 'computer tablet',
                  key: refund.node.id + '_computer'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 7 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      refund.node.invoice.title
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.mutedText },
                    refund.node.invoice.workspaces.edges[0].node.event.title
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right', className: __WEBPACK_IMPORTED_MODULE_6__Financial_scss___default.a.red },
                  '(',
                  __WEBPACK_IMPORTED_MODULE_7_currency_formatter___default.a.format(refund.node.amount_cents / 100, {
                    code: refund.node.amount_currency
                  }),
                  ')'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    {
                      title: __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('MMM D, YYYY [at] LT') + ' ' + __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(timeZone).format('z')
                    },
                    __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.tz(refund.node.refunded_at, timeZone).format('L')
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                  { width: 3, textAlign: 'right' },
                  __WEBPACK_IMPORTED_MODULE_10__lib_utils_payments__["a" /* default */].payments(refund.node.payment)
                )
              )];
            }),
            this.props.viewer.refunds.edges.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { style: { textAlign: 'center', margin: '2em' } },
                  'You have issued no refunds'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_waypoint___default.a, { onEnter: this.loadMore, bottomOffset: -200 }),
        this.props.relay.hasMore() && this.state.loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginBottom: '2em', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], {
            active: true,
            inline: true,
            size: 'tiny',
            style: { marginRight: '1em' }
          }),
          ' ',
          'Loading More...'
        )
      );
    }
  }]);

  return Refunds;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Refunds.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(Refunds));

/***/ }),
/* 3374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefundsComponent__ = __webpack_require__(3373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_RefundsQuery__ = __webpack_require__(1494);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createPaginationContainer"])(__WEBPACK_IMPORTED_MODULE_1__RefundsComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3377);
  }
}, {
  direction: 'forward',
  getConnectionFromProps: function getConnectionFromProps(props) {
    return props.viewer && props.viewer.refunds;
  },
  getFragmentVariables: function getFragmentVariables(prevVars, totalCount) {
    return _extends({}, prevVars, {
      count: totalCount
    });
  },
  getVariables: function getVariables(props, _ref, fragmentVariables) {
    var count = _ref.count,
        cursor = _ref.cursor;

    return _extends({}, fragmentVariables, {
      count: count,
      cursor: cursor

    });
  },

  query: __WEBPACK_IMPORTED_MODULE_2__routes_RefundsQuery__["a" /* default */]
}));

/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CompletedPaymentsContainer_viewer$ref: FragmentReference;
export type CompletedPaymentsContainer_viewer = {|
  +s_time_zone: ?string,
  +completed_payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id?: string,
        +amount_cents?: ?number,
        +amount_currency?: ?string,
        +name?: ?string,
        +paid_at?: ?any,
        +invoice?: ?{|
          +id: string,
          +title: ?string,
          +workspaces: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +event: ?{|
                  +title: ?string
                |}
              |}
            |}>
          |},
        |},
        +label?: ?string,
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: CompletedPaymentsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "invoice",
    "storageKey": null,
    "args": null,
    "concreteType": "Invoice",
    "plural": false,
    "selections": [v0, v5, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v5]
          }]
        }]
      }]
    }]
  },
      v7 = [v0, v1, v2, v3, v4, v6];
  return {
    "kind": "Fragment",
    "name": "CompletedPaymentsContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["completed_payments"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "completed_payments_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "completed_payments_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "completed_payments",
      "name": "__CompletedPayments_completed_payments_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "completed_payments_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "completed_payments_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "PaymentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "type": "SquarePayment",
            "selections": v7
          }, {
            "kind": "InlineFragment",
            "type": "CustomPayment",
            "selections": [v0, v1, v2, v3, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }, v6]
          }, {
            "kind": "InlineFragment",
            "type": "CheckPayment",
            "selections": v7
          }, {
            "kind": "InlineFragment",
            "type": "CashPayment",
            "selections": v7
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e8e62d960c7334ffc8933a3e4889add9';
module.exports = node;

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutstandingPaymentsContainer_viewer$ref: FragmentReference;
export type OutstandingPaymentsContainer_viewer = {|
  +outstanding_payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: number,
        +amount_currency: string,
        +payment_date: any,
        +invoice: ?{|
          +id: string,
          +title: ?string,
          +workspaces: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +event: ?{|
                  +title: ?string
                |}
              |}
            |}>
          |},
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: OutstandingPaymentsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "OutstandingPaymentsContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["outstanding_payments"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "outstanding_payments_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "outstanding_payments_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "LinkedField",
      "alias": "outstanding_payments",
      "name": "__OutstandingPayments_outstanding_payments_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "outstanding_payments_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "outstanding_payments_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "OutstandingPaymentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "OutstandingPaymentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "OutstandingPayment",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [v0, v1, {
              "kind": "LinkedField",
              "alias": null,
              "name": "workspaces",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Workspace",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "event",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Event",
                    "plural": false,
                    "selections": [v1]
                  }]
                }]
              }]
            }]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd0720ef90fab38329d8d7251dac45675';
module.exports = node;

/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RefundsContainer_viewer$ref: FragmentReference;
export type RefundsContainer_viewer = {|
  +s_time_zone: ?string,
  +refunds: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: ?number,
        +amount_currency: ?string,
        +refunded_at: ?any,
        +payment: ?({|
          +__typename: "CustomPayment",
          +label: ?string,
        |} | {|
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          +__typename: "%other"
        |}),
        +invoice: ?{|
          +id: string,
          +title: ?string,
          +workspaces: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +event: ?{|
                  +title: ?string
                |}
              |}
            |}>
          |},
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: RefundsContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "RefundsContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["refunds"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "refunds_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "refunds_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "refunds",
      "name": "__Refunds_refunds_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "refunds_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "refunds_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "RefundConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "RefundEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Refund",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "refunded_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payment",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v1, {
              "kind": "InlineFragment",
              "type": "CustomPayment",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "label",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [v0, v2, {
              "kind": "LinkedField",
              "alias": null,
              "name": "workspaces",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Workspace",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "event",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Event",
                    "plural": false,
                    "selections": [v2]
                  }]
                }]
              }]
            }]
          }, v1]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '772404aa7324926d68e5fa324ec6b49a';
module.exports = node;

/***/ }),
/* 3378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nivo_line__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nivo_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__nivo_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_currency_formatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss__ = __webpack_require__(3622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var quarters = ['Q1', 'Q2', 'Q3', 'Q4'];

var PaymentsGraph = function (_React$Component) {
  _inherits(PaymentsGraph, _React$Component);

  function PaymentsGraph(props) {
    _classCallCheck(this, PaymentsGraph);

    var _this = _possibleConstructorReturn(this, (PaymentsGraph.__proto__ || Object.getPrototypeOf(PaymentsGraph)).call(this, props));

    _this.state = {
      revenueYear: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(_this.props.viewer.s_time_zone).year()
    };
    _this.onRevenueYearChange = _this.onRevenueYearChange.bind(_this);
    _this.dateField = _this.dateField.bind(_this);
    _this.totalOutstandingPayments = _this.totalOutstandingPayments.bind(_this);
    _this.totalCompletedPayments = _this.totalCompletedPayments.bind(_this);
    _this.totalRefunds = _this.totalRefunds.bind(_this);
    _this.totalRevenue = _this.totalRevenue.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(PaymentsGraph, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initGraphData();
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onRevenueYearChange',
    value: function onRevenueYearChange(e, _ref) {
      var _this2 = this;

      var value = _ref.value;

      this.setState({ revenueYear: value });
      var startTime = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(value, 'Y', this.timeZone()).startOf('year').toISOString();
      var endTime = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(value, 'Y', this.timeZone()).endOf('year').toISOString();
      this.props.relay.refetch({
        completed_payments_before: endTime,
        completed_payments_after: startTime,
        outstanding_payments_before: endTime,
        outstanding_payments_after: startTime,
        refunds_before: endTime,
        refunds_after: startTime
      }, null, function () {
        _this2.initGraphData();
      });
    }
  }, {
    key: 'groupByQuarter',
    value: function groupByQuarter(payments, type) {
      var byQuarter = {};
      var byMonth = this.groupByMonth(payments, type);
      byQuarter.Q1 = byMonth.Jan + byMonth.Feb + byMonth.Mar;
      byQuarter.Q2 = byMonth.Apr + byMonth.May + byMonth.Jun;
      byQuarter.Q3 = byMonth.Jul + byMonth.Aug + byMonth.Sep;
      byQuarter.Q4 = byMonth.Oct + byMonth.Nov + byMonth.Dec;
      return byQuarter;
    }
  }, {
    key: 'groupByMonth',
    value: function groupByMonth(payments, type) {
      var _this3 = this;

      var byMonth = {};
      months.map(function (month) {
        byMonth[month] = 0;
        return month;
      });
      payments.map(function (payment) {
        var month = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(payment.node[_this3.dateField(type)], _this3.timeZone()).format('MMM');
        byMonth[month] = byMonth[month] + payment.node.amount_cents;
        return payment;
      });
      return byMonth;
    }
  }, {
    key: 'dateField',
    value: function dateField(type) {
      switch (type) {
        case 'outstanding':
          return 'payment_date';
        case 'completed':
          return 'paid_at';
        case 'refunds':
          return 'refunded_at';
        default:
          return null;
      }
    }
  }, {
    key: 'initGraphData',
    value: function initGraphData() {
      var completedByMonth = this.groupByMonth(this.props.viewer.completed_payments.edges, 'completed');
      var outstandingByMonth = this.groupByMonth(this.props.viewer.outstanding_payments.edges, 'outstanding');
      var refundsByMonth = this.groupByMonth(this.props.viewer.refunds.edges, 'refunds');
      var completedByQuarter = this.groupByQuarter(this.props.viewer.completed_payments.edges, 'completed');
      var outstandingByQuarter = this.groupByQuarter(this.props.viewer.outstanding_payments.edges, 'outstanding');
      var refundsByQuarter = this.groupByQuarter(this.props.viewer.refunds.edges, 'refunds');
      var graphDataByQuarter = [{
        id: 'Paid',
        color: '#547687',
        data: quarters.map(function (quarter) {
          return { x: quarter, y: (completedByQuarter[quarter] - refundsByQuarter[quarter]) / 100 };
        })
      }, {
        id: 'Outstanding',
        color: '#7f98a5',
        data: quarters.map(function (quarter) {
          return { x: quarter, y: outstandingByQuarter[quarter] / 100 };
        })
      }];
      var graphDataByMonth = [{
        id: 'Paid',
        color: '#547687',
        data: months.map(function (month) {
          return { x: month, y: (completedByMonth[month] - refundsByMonth[month]) / 100 };
        })
      }, {
        id: 'Outstanding',
        color: '#7f98a5',
        data: months.map(function (month) {
          return { x: month, y: outstandingByMonth[month] / 100 };
        })
      }];
      this.setState({ graphDataByMonth: graphDataByMonth, graphDataByQuarter: graphDataByQuarter });
    }
  }, {
    key: 'timeZone',
    value: function timeZone() {
      return this.props.viewer.s_time_zone;
    }
  }, {
    key: 'totalCompletedPayments',
    value: function totalCompletedPayments() {
      return this.props.viewer.completed_payments.edges.reduce(function (acc, p) {
        return acc + p.node.amount_cents;
      }, 0);
    }
  }, {
    key: 'totalOutstandingPayments',
    value: function totalOutstandingPayments() {
      return this.props.viewer.outstanding_payments.edges.reduce(function (acc, p) {
        return acc + p.node.amount_cents;
      }, 0);
    }
  }, {
    key: 'totalRefunds',
    value: function totalRefunds() {
      return this.props.viewer.refunds.edges.reduce(function (acc, r) {
        return acc + r.node.amount_cents;
      }, 0);
    }
  }, {
    key: 'totalRevenue',
    value: function totalRevenue() {
      return this.totalCompletedPayments() + this.totalOutstandingPayments() - this.totalRefunds();
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({
        window: { width: window.innerWidth, height: window.innerHeight }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var currency = 'USD';
      var tooltip = function tooltip(_ref2) {
        var data = _ref2.data;

        var outstanding = data[0].data.y;
        var paid = data[1].data.y;
        var total = outstanding + paid;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.outstandingLegend }),
                'Outstanding'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.tooltipNumber },
                __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(outstanding, { code: currency })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.paidLegend }),
                'Paid'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.tooltipNumber },
                __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(paid, { code: currency })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.legendLabel }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Total Sales'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.tooltipNumber },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(total, { code: currency })
                )
              )
            )
          )
        );
      };
      var years = [{ text: '2014', value: 2014 }, { text: '2015', value: 2015 }, { text: '2016', value: 2016 }, { text: '2017', value: 2017 }, { text: '2018', value: 2018 }, { text: '2019', value: 2019 }, { text: '2020', value: 2020 }, { text: '2021', value: 2021 }, { text: '2022', value: 2022 }, { text: '2023', value: 2023 }];
      var theme = {
        axis: {
          ticks: {
            text: {
              fontSize: 14
            }
          }
        }
      };
      var isLargeScreen = this.state.window.width >= 1280;
      var dateRange = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Date Range \xA0'
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
        { stackable: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
          { columns: 'equal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["t" /* Segment */],
              { style: { background: 'white' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: isLargeScreen ? { textAlign: 'right' } : {} },
                isLargeScreen && dateRange,
                !isLargeScreen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { marginBottom: '0.5em' } },
                  dateRange
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["l" /* Dropdown */], {
                  fluid: !isLargeScreen,
                  options: years,
                  basic: true,
                  button: true,
                  floating: true,
                  value: this.state.revenueYear,
                  onChange: this.onRevenueYearChange
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 400 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__nivo_line__["ResponsiveLine"], {
                  margin: {
                    top: 20,
                    right: 20,
                    bottom: 60,
                    left: 80
                  },
                  axisLeft: {
                    format: function format(v) {
                      return __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(v, { code: currency });
                    }
                  },
                  tooltip: tooltip,
                  data: isLargeScreen ? this.state.graphDataByMonth : this.state.graphDataByQuarter,
                  animate: true,
                  enableArea: true,
                  enableGridY: false,
                  enableGridX: false,
                  yScale: { type: 'linear', stacked: true },
                  curve: 'monotoneX',
                  colorBy: function colorBy(d) {
                    return d.color;
                  },
                  dotSize: 8,
                  dotColor: '#fff',
                  dotBorderWidth: 2,
                  theme: theme
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginLeft: '80px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
                  { stackable: true, container: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                    { columns: 'equal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.legend },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.outstandingLegend }),
                          'Outstanding'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.paidLegend }),
                          'Paid'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.total },
                        __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(this.totalRevenue() / 100, { code: currency })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.totalLabel },
                        'Total Sales'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.total },
                        __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format((this.totalCompletedPayments() - this.totalRefunds()) / 100, { code: currency })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.totalLabel },
                        'Total Paid'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.total },
                        __WEBPACK_IMPORTED_MODULE_5_currency_formatter___default.a.format(this.totalOutstandingPayments() / 100, { code: currency })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: __WEBPACK_IMPORTED_MODULE_6__PaymentsGraph_scss___default.a.totalLabel },
                        'Outstanding Payments'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentsGraph;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentsGraph.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentsGraph);

/***/ }),
/* 3379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentsGraph__ = __webpack_require__(3378);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__PaymentsGraph__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3381);
  }
}, function () {
  return __webpack_require__(3380);
}));

/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d61076bc19bde4249239a81ec9209fa9
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaymentsGraphContainer_viewer$ref = any;
export type PaymentsGraphContainer_RefethQueryVariables = {|
  completed_payments_before?: ?any,
  completed_payments_after?: ?any,
  outstanding_payments_before?: ?any,
  outstanding_payments_after?: ?any,
  refunds_before?: ?any,
  refunds_after?: ?any,
|};
export type PaymentsGraphContainer_RefethQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PaymentsGraphContainer_viewer$ref
  |}
|};
export type PaymentsGraphContainer_RefethQuery = {|
  variables: PaymentsGraphContainer_RefethQueryVariables,
  response: PaymentsGraphContainer_RefethQueryResponse,
|};
*/

/*
query PaymentsGraphContainer_RefethQuery(
  $completed_payments_before: ISO8601Type
  $completed_payments_after: ISO8601Type
  $outstanding_payments_before: ISO8601Type
  $outstanding_payments_after: ISO8601Type
  $refunds_before: ISO8601Type
  $refunds_after: ISO8601Type
) {
  viewer {
    ...PaymentsGraphContainer_viewer_2qQdGx
    id
  }
}

fragment PaymentsGraphContainer_viewer_2qQdGx on User {
  s_time_zone
  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: 99999) {
    edges {
      node {
        ... on CashPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on CheckPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on CustomPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on SquarePayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: 99999) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        payment_date
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  refunds(before_time: $refunds_before, after_time: $refunds_after, first: 99999) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        refunded_at
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "completed_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "completed_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "outstanding_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "outstanding_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "refunds_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "refunds_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }],
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "completed_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "completed_payments_before",
    "type": "ISO8601Type"
  }, v1],
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v7 = [v5, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v10 = ["before_time", "after_time"],
      v11 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "outstanding_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "outstanding_payments_before",
    "type": "ISO8601Type"
  }, v1],
      v12 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "refunds_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "refunds_before",
    "type": "ISO8601Type"
  }, v1];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "PaymentsGraphContainer_RefethQuery",
    "id": null,
    "text": "query PaymentsGraphContainer_RefethQuery(\n  $completed_payments_before: ISO8601Type\n  $completed_payments_after: ISO8601Type\n  $outstanding_payments_before: ISO8601Type\n  $outstanding_payments_after: ISO8601Type\n  $refunds_before: ISO8601Type\n  $refunds_after: ISO8601Type\n) {\n  viewer {\n    ...PaymentsGraphContainer_viewer_2qQdGx\n    id\n  }\n}\n\nfragment PaymentsGraphContainer_viewer_2qQdGx on User {\n  s_time_zone\n  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: 99999) {\n    edges {\n      node {\n        ... on CashPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on CheckPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on CustomPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on SquarePayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: 99999) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        payment_date\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  refunds(before_time: $refunds_before, after_time: $refunds_after, first: 99999) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        refunded_at\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "PaymentsGraphContainer_RefethQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PaymentsGraphContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "completed_payments_after",
            "variableName": "completed_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "completed_payments_before",
            "variableName": "completed_payments_before",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_after",
            "variableName": "outstanding_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_before",
            "variableName": "outstanding_payments_before",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_after",
            "variableName": "refunds_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_before",
            "variableName": "refunds_before",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "PaymentsGraphContainer_RefethQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "completed_payments",
          "storageKey": null,
          "args": v2,
          "concreteType": "PaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v3, v4, {
                "kind": "InlineFragment",
                "type": "SquarePayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CustomPayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CheckPayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CashPayment",
                "selections": v7
              }]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "completed_payments",
          "args": v2,
          "handle": "connection",
          "key": "PaymentsGraph_completed_payments",
          "filters": v10
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "outstanding_payments",
          "storageKey": null,
          "args": v11,
          "concreteType": "OutstandingPaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OutstandingPaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OutstandingPayment",
              "plural": false,
              "selections": [v3, v5, v6, {
                "kind": "ScalarField",
                "alias": null,
                "name": "payment_date",
                "args": null,
                "storageKey": null
              }, v4]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "outstanding_payments",
          "args": v11,
          "handle": "connection",
          "key": "PaymentsGraph_outstanding_payments",
          "filters": v10
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "refunds",
          "storageKey": null,
          "args": v12,
          "concreteType": "RefundConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "RefundEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Refund",
              "plural": false,
              "selections": [v3, v5, v6, {
                "kind": "ScalarField",
                "alias": null,
                "name": "refunded_at",
                "args": null,
                "storageKey": null
              }, v4]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "refunds",
          "args": v12,
          "handle": "connection",
          "key": "PaymentsGraph_refunds",
          "filters": v10
        }, v3]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '894bcd7fb059728199ab700d50c57530';
module.exports = node;

/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaymentsGraphContainer_viewer$ref: FragmentReference;
export type PaymentsGraphContainer_viewer = {|
  +s_time_zone: ?string,
  +completed_payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id?: string,
        +amount_cents?: ?number,
        +amount_currency?: ?string,
        +paid_at?: ?any,
      |}
    |}>
  |},
  +outstanding_payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: number,
        +amount_currency: string,
        +payment_date: any,
      |}
    |}>
  |},
  +refunds: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: ?number,
        +amount_currency: ?string,
        +refunded_at: ?any,
      |}
    |}>
  |},
  +$refType: PaymentsGraphContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v4 = [v1, v2, v3, {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  }],
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Fragment",
    "name": "PaymentsGraphContainer_viewer",
    "type": "User",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["completed_payments"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["outstanding_payments"]
      }, {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["refunds"]
      }]
    },
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "completed_payments_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "completed_payments_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "outstanding_payments_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "outstanding_payments_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "refunds_after",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "refunds_before",
      "type": "ISO8601Type",
      "defaultValue": null
    }],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "completed_payments",
      "name": "__PaymentsGraph_completed_payments_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "completed_payments_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "completed_payments_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "PaymentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PaymentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [v0, {
            "kind": "InlineFragment",
            "type": "SquarePayment",
            "selections": v4
          }, {
            "kind": "InlineFragment",
            "type": "CustomPayment",
            "selections": v4
          }, {
            "kind": "InlineFragment",
            "type": "CheckPayment",
            "selections": v4
          }, {
            "kind": "InlineFragment",
            "type": "CashPayment",
            "selections": v4
          }]
        }, v5]
      }, v6]
    }, {
      "kind": "LinkedField",
      "alias": "outstanding_payments",
      "name": "__PaymentsGraph_outstanding_payments_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "outstanding_payments_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "outstanding_payments_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "OutstandingPaymentConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "OutstandingPaymentEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "OutstandingPayment",
          "plural": false,
          "selections": [v1, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_date",
            "args": null,
            "storageKey": null
          }, v0]
        }, v5]
      }, v6]
    }, {
      "kind": "LinkedField",
      "alias": "refunds",
      "name": "__PaymentsGraph_refunds_connection",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "refunds_after",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "refunds_before",
        "type": "ISO8601Type"
      }],
      "concreteType": "RefundConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "RefundEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Refund",
          "plural": false,
          "selections": [v1, v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "refunded_at",
            "args": null,
            "storageKey": null
          }, v0]
        }, v5]
      }, v6]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '71148bb03a4608fa98dc53eefe43b40e';
module.exports = node;

/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
type InvoicesContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FinancialContainer_viewer$ref: FragmentReference;
export type FinancialContainer_viewer = {|
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref & InvoicesContainer_viewer$ref,
  +$refType: FinancialContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "FinancialContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "InvoicesContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'b2e4c985968211ab28a95c2c9ac23d99';
module.exports = node;

/***/ }),
/* 3383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Leads_scss__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Leads_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Leads_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SMSNotifications__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RecaptchaSettings__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_load_script__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_load_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_load_script__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var EmbedComponent = (_temp = _class = function (_React$Component) {
  _inherits(Embed, _React$Component);

  function Embed(props) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, props));

    _this.selectEmbedCode = _this.selectEmbedCode.bind(_this);
    _this.onAccordionClick = _this.onAccordionClick.bind(_this);
    _this.onSuccessfulCopy = _this.onSuccessfulCopy.bind(_this);
    _this.getEmbedCode = _this.getEmbedCode.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.state = {
      title: '',
      redirectURI: '',
      activeIndex: 0
    };
    return _this;
  }

  _createClass(Embed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('viewed-lead-embed');
    }
  }, {
    key: 'onAccordionClick',
    value: function onAccordionClick(e, titleProps) {
      var index = titleProps.index;
      var activeIndex = this.state.activeIndex;

      var newIndex = activeIndex === index ? -1 : index;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'onSuccessfulCopy',
    value: function onSuccessfulCopy() {
      __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
        message: 'Successfully copied embed code',
        intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].SUCCESS
      });
    }
  }, {
    key: 'getEmbedCode',
    value: function getEmbedCode() {
      return '<form action="' + "https://www.cloverbook.com" + '/embed_widgets/' + this.props.viewer.embed_token + '?' + (this.state.redirectURI !== '' ? 'redirect_uri=' + encodeURIComponent(this.state.redirectURI) : '') + '" accept-charset="UTF-8" method="post">\n<div>\n  <label for="embed_widget_form_first_name"><abbr title="required">*</abbr> First name</label>\n  <input type="text" name="embed_widget_form[first_name]" id="embed_widget_form_first_name" placeholder="Jane" />\n</div>\n<div>\n  <label for="embed_widget_form_last_name">Last name</label>\n  <input type="text" name="embed_widget_form[last_name]" id="embed_widget_form_last_name" placeholder="Smith" />\n</div>\n<div>\n  <label for="embed_widget_form_email">Email</label>\n  <input type="email" name="embed_widget_form[email]" id="embed_widget_form_email" placeholder="jane.smith@example.com" />\n</div>\n<div>\n  <label for="embed_widget_form_phone">Phone</label>\n  <input type="tel" name="embed_widget_form[phone]" id="embed_widget_form_phone" placeholder="555-555-5555" />\n</div>\n<div>\n  <label for="embed_widget_form_role">Role</label>\n  <input type="text" name="embed_widget_form[role]" id="embed_widget_form_role" placeholder="Bride" />\n</div>\n<div>\n  <label for="embed_widget_form_all_day_date">Date</label>\n  <input type="text" name="embed_widget_form[all_day_date]" id="embed_widget_form_all_day_date" placeholder="2/20/2017" />\n</div>\n<div>\n  <label for="embed_widget_form_location">Venue Name</label>\n  <input type="text" name="embed_widget_form[location]" id="embed_widget_form_location" placeholder="Hyatt Regency San Francisco" />\n</div>\n<div>\n  <label for="embed_widget_form_street1">Venue Address</label>\n  <input type="text" name="embed_widget_form[street1]" id="embed_widget_form_street1" placeholder="1 Embarcadero Center" />\n</div>\n<div>\n  <label for="embed_widget_form_city">Venue City</label>\n  <input type="text" name="embed_widget_form[city]" id="embed_widget_form_city" placeholder="San Francisco" />\n</div>\n<div>\n  <label for="embed_widget_form_state">Venue State/Province</label>\n  <input type="text" name="embed_widget_form[state]" id="embed_widget_form_state" placeholder="California" />\n</div>\n<div>\n  <label for="embed_widget_form_zip">Venue Postal Code</label>\n  <input type="text" name="embed_widget_form[zip]" id="embed_widget_form_zip" placeholder="94105" />\n</div>\n<div>\n  <label for="embed_widget_form_referral_source">Where\'d you hear about us?</label>\n  <input type="text" name="embed_widget_form[referral_source]" id="embed_widget_form_referral_source" placeholder="Google" />\n</div>\n<div>\n  <input type="hidden" name="embed_widget_form[time_zone]" id="embed_widget_form_time_zone" value="' + this.props.viewer.s_time_zone + '" />\n</div>\n<div>\n  <label for="embed_widget_form_notes">Comments</label>\n  <textarea name="embed_widget_form[notes]" id="embed_widget_form_notes" placeholder="Event will be outdoors. 200+ guests attending."></textarea>\n</div>\n' + (this.props.viewer.s_recaptcha_enabled ? '<div>\n  <script src="https://www.google.com/recaptcha/api.js" async defer></script>\n  <div class="g-recaptcha" data-sitekey="' + this.props.viewer.s_recaptcha_site_key + '"></div>\n</div>' : '') + '\n<div style="position: absolute; left: -5000px;" aria-hidden="true">\n  <input type="text" name="embed_widget_form[honey]" tabindex="-1" value="" />\n</div>\n<input type="submit" name="commit" value="Submit" data-disable-with="Submit" />\n</form>\n<script>\nfunction get_zone(){var a,b;if("undefined"!=typeof Intl&&"undefined"!=typeof Intl.DateTimeFormat&&(a=Intl.DateTimeFormat(),"undefined"!=typeof a&&"undefined"!=typeof a.resolvedOptions))return b=a.resolvedOptions().timeZone,b&&(b.indexOf("/")>-1||"UTC"===b)?b:void 0}\ndocument.getElementById("embed_widget_form_time_zone").value = get_zone();\n</script>';
    }
  }, {
    key: 'selectEmbedCode',
    value: function selectEmbedCode() {
      if (document.selection) {
        var range = document.body.createTextRange();
        range.moveToElementText(document.getElementById('embedCode'));
        range.select();
      } else if (window.getSelection) {
        var _range = document.createRange();
        _range.selectNode(document.getElementById('embedCode'));
        window.getSelection().addRange(_range);
      }
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      var newValue = {};
      newValue[e.target.name] = e.target.value;
      this.setState(Object.assign(this.state, newValue));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;
      var activeIndex = this.state.activeIndex;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["s" /* Container */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["t" /* Segment */],
          { style: { marginTop: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__["a" /* default */],
            {
              viewer: viewer,
              router: router
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                {
                  as: 'a',
                  className: sidebarOpen ? 'active ' : '',
                  onClick: toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
            { padded: true, stackable: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h1',
                  null,
                  'Custom Website Embed'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */],
                  { styled: true, fluid: true },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 0,
                      active: activeIndex === 0,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'Settings'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 0 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
                      { padded: true, relaxed: true, stackable: true },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          {
                            width: 5,
                            className: __WEBPACK_IMPORTED_MODULE_10__Leads_scss___default.a.settingsLabels
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Redirect URL'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_10__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'When users submit your form, we will automatically redirect them to the URL provided'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                            { className: 'ui form' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
                              label: 'Redirect URL',
                              type: 'text',
                              name: 'redirectURI',
                              value: this.state.redirectURI,
                              onChange: this.textFieldChange,
                              validations: 'isUrl',
                              validationError: 'Must be a valid URL (Ex. http://www.example.com)'
                            })
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          {
                            width: 5,
                            className: __WEBPACK_IMPORTED_MODULE_10__Leads_scss___default.a.settingsLabels
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'SMS Notifications'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_10__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'Receive an SMS text message immediately after a user submits an inquiry through your form.'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SMSNotifications__["a" /* default */], {
                            viewer: viewer,
                            relay: relay
                          })
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 1,
                      active: activeIndex === 1,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'reCAPTCHA Spam Protection'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 1 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RecaptchaSettings__["a" /* default */], {
                      viewer: viewer,
                      relay: relay
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 2,
                      active: activeIndex === 2,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'Website Embed Code'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 2 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
                      { padded: true, relaxed: true, stackable: true },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 16 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Copy and paste the embed code wherever you want the contact form to appear on your website.'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_react_clipboard_js___default.a,
                            {
                              'option-text': this.getEmbedCode,
                              onSuccess: this.onSuccessfulCopy,
                              className: 'ui right icon button primary button'
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'span',
                              null,
                              'Copy Embed Code\xA0',
                              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' })
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["B" /* Message */],
                            { warning: true, style: { marginTop: '3em' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["B" /* Message */].Header,
                              null,
                              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'exclamation triangle' }),
                              'Unstyled Content'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'p',
                              null,
                              'This code contains no styling. You can add your own CSS or inherit from the default styles on your website.'
                            )
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 16 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'pre',
                            {
                              style: {
                                maxHeight: '400px',
                                whiteSpace: 'pre-line',
                                overflowY: 'scroll'
                              },
                              onClick: this.selectEmbedCode,
                              id: 'embedCode'
                            },
                            this.getEmbedCode()
                          )
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 3,
                      active: activeIndex === 3,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'Preview Form'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 3 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
                      { padded: true, stackable: true },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        { columns: 'equal' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Here is a preview of the form fields that you are copying to your website:'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_load_script___default.a, { url: 'https://www.google.com/recaptcha/api.js' }),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
                            className: 'ui form',
                            dangerouslySetInnerHTML: {
                              __html: this.getEmbedCode()
                            }
                          })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__App_Authenticate__["a" /* default */])(EmbedComponent)));

/***/ }),
/* 3384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmbedComponent__ = __webpack_require__(3383);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__EmbedComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3391);
  }
}));

/***/ }),
/* 3385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Leads_scss__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Leads_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RecaptchaSettings__ = __webpack_require__(821);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var KioskComponent = (_temp = _class = function (_React$Component) {
  _inherits(Kiosk, _React$Component);

  function Kiosk(props) {
    _classCallCheck(this, Kiosk);

    var _this = _possibleConstructorReturn(this, (Kiosk.__proto__ || Object.getPrototypeOf(Kiosk)).call(this, props));

    _this.onAccordionClick = _this.onAccordionClick.bind(_this);
    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.state = {
      title: 'Contact Us',
      activeIndex: 0
    };
    return _this;
  }

  _createClass(Kiosk, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('viewed-lead-kiosk');
    }
  }, {
    key: 'onAccordionClick',
    value: function onAccordionClick(e, titleProps) {
      var index = titleProps.index;
      var activeIndex = this.state.activeIndex;

      var newIndex = activeIndex === index ? -1 : index;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      var newValue = {};
      newValue[e.target.name] = e.target.value;
      this.setState(Object.assign(this.state, newValue));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;
      var _state = this.state,
          activeIndex = _state.activeIndex,
          title = _state.title;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["s" /* Container */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["t" /* Segment */],
          { style: { marginTop: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__App_MobileHeader__["a" /* default */],
            { router: router, viewer: viewer },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                { as: 'a', className: sidebarOpen ? 'active ' : '', onClick: toggleSidebar },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["n" /* AvailabilityChecker */], {
                viewer: viewer,
                mobile: true
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
            { padded: true, stackable: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h1',
                  null,
                  'Bridal Show Kiosk'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'The Cloverbook live kiosk allows you to easily collect leads at bridal shows and other events. It\'s the easiest way to get events into Cloverbook and onto your calendar. Once a user submits the form, it will automatically reset so the next user can add her event information.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */],
                  { styled: true, fluid: true },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 0,
                      active: activeIndex === 0,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'Settings'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 0 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */],
                      { padded: true, relaxed: true, stackable: true },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 5, className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.settingsLabels },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Title'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'Customize the title of your form'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                            { className: 'ui form' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
                              label: 'Title',
                              type: 'text',
                              name: 'title',
                              value: title,
                              onChange: this.textFieldChange
                            })
                          )
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 1,
                      active: activeIndex === 1,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'reCAPTCHA Spam Protection'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 1 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RecaptchaSettings__["a" /* default */], {
                      viewer: viewer,
                      relay: relay
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: "https://www.cloverbook.com" + '/embed_widgets/' + viewer.embed_token + '?bridal_show=true' + (title !== '' ? '&title=' + encodeURIComponent(title) : '') },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], { primary: true, content: 'Go to Kiosk Mode' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Kiosk;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__App_Authenticate__["a" /* default */])(KioskComponent)));

/***/ }),
/* 3386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KioskComponent__ = __webpack_require__(3385);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__KioskComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3392);
  }
}));

/***/ }),
/* 3387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Leads_scss__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Leads_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LeadCaptureComponent = (_temp = _class = function (_React$Component) {
  _inherits(LeadCaptureComponent, _React$Component);

  function LeadCaptureComponent() {
    _classCallCheck(this, LeadCaptureComponent);

    return _possibleConstructorReturn(this, (LeadCaptureComponent.__proto__ || Object.getPrototypeOf(LeadCaptureComponent)).apply(this, arguments));
  }

  _createClass(LeadCaptureComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('viewed-lead-capture');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["s" /* Container */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
          { style: { marginTop: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__["a" /* default */],
            { viewer: viewer, router: router },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
                {
                  as: 'a',
                  className: sidebarOpen ? 'active ' : '',
                  onClick: toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
            {
              padded: true,
              relaxed: true,
              stackable: true,
              style: { textAlign: 'center', padding: '2em' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h1',
                  null,
                  'Collect event leads from anywhere.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h3',
                  { style: { fontWeight: 'normal' } },
                  'Please select an option to continue.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal', style: { paddingTop: '3em' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_found__["Link"],
                  { to: '/leads/link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'linkify' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    null,
                    'Contact Link'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.description },
                    'Add a link anywhere to send prospects to your contact form'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.easy },
                    'Easy Setup \u2014 Non-Technical'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_found__["Link"],
                  { to: '/leads/kiosk' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'tablet alternate' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    null,
                    'Bridal Show Kiosk'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.description },
                    'Set up a kiosk to collect leads directly from prospects at shows'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.easy },
                    'Easy Setup \u2014 Non-Technical'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_found__["Link"],
                  { to: '/leads/embed' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'code' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    null,
                    'Custom Website Embed'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.description },
                    'Collect leads directly from your website contact form'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: __WEBPACK_IMPORTED_MODULE_7__Leads_scss___default.a.difficult },
                    'Advanced Setup \u2014 Technical'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LeadCaptureComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__App_Authenticate__["a" /* default */])(LeadCaptureComponent)));

/***/ }),
/* 3388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeadCaptureComponent__ = __webpack_require__(3387);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__LeadCaptureComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3393);
  }
}));

/***/ }),
/* 3389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_Authenticate__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Leads_scss__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Leads_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SMSNotifications__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_clipboard_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RecaptchaSettings__ = __webpack_require__(821);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var LinkComponent = (_temp = _class = function (_React$Component) {
  _inherits(LeadLink, _React$Component);

  function LeadLink(props) {
    _classCallCheck(this, LeadLink);

    var _this = _possibleConstructorReturn(this, (LeadLink.__proto__ || Object.getPrototypeOf(LeadLink)).call(this, props));

    _this.textFieldChange = _this.textFieldChange.bind(_this);
    _this.getLink = _this.getLink.bind(_this);
    _this.onAccordionClick = _this.onAccordionClick.bind(_this);
    _this.onSuccessfulCopy = _this.onSuccessfulCopy.bind(_this);
    _this.state = {
      title: 'Contact Us',
      redirectURI: '',
      activeIndex: 0
    };
    return _this;
  }

  _createClass(LeadLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["c" /* Analytics */].trackEvent('viewed-lead-link');
    }
  }, {
    key: 'onAccordionClick',
    value: function onAccordionClick(e, titleProps) {
      var index = titleProps.index;
      var activeIndex = this.state.activeIndex;

      var newIndex = activeIndex === index ? -1 : index;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'onSuccessfulCopy',
    value: function onSuccessfulCopy() {
      __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
        message: 'Successfully copied link',
        intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].SUCCESS
      });
    }
  }, {
    key: 'getLink',
    value: function getLink() {
      return "https://www.cloverbook.com" + '/embed_widgets/' + this.props.viewer.embed_token + '?' + (this.state.title !== '' ? '&title=' + encodeURIComponent(this.state.title) : '') + (this.state.redirectURI !== '' ? '&redirect_uri=' + encodeURIComponent(this.state.redirectURI) : '');
    }
  }, {
    key: 'textFieldChange',
    value: function textFieldChange(e) {
      var newValue = {};
      newValue[e.target.name] = e.target.value;
      this.setState(Object.assign(this.state, newValue));
    }
  }, {
    key: 'render',
    value: function render() {
      var link = this.getLink();
      var _props = this.props,
          relay = _props.relay,
          router = _props.router,
          sidebarOpen = _props.sidebarOpen,
          toggleSidebar = _props.toggleSidebar,
          viewer = _props.viewer;
      var activeIndex = this.state.activeIndex;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["s" /* Container */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["t" /* Segment */],
          { style: { marginTop: '2em' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__App_MobileHeader__["a" /* default */],
            { viewer: viewer, router: router },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
                {
                  as: 'a',
                  className: sidebarOpen ? 'active ' : '',
                  onClick: toggleSidebar
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'sidebar' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'right menu' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["n" /* AvailabilityChecker */], { viewer: viewer, mobile: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["C" /* Item */],
                { as: 'a', onClick: router.push.bind(null, '/search') },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'search' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
            { padded: true, stackable: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              { columns: 'equal' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'h1',
                  null,
                  'Contact Link'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                { width: 16 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  'This is one of the fastest and easiest ways to integrate your website with Cloverbook. Just create a link on your website that points to the URL below. When a user clicks on the link, they are taken to your personal Cloverbook contact form. Once they submit the form, they can be redirected back to the URL of your choice.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
                    name: 'link',
                    value: link,
                    label: 'Contact Link',
                    type: 'text',
                    fluid: true,
                    onChange: function onChange() {},
                    onFocus: function onFocus(e) {
                      e.target.select();
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_react_clipboard_js___default.a,
                    {
                      'option-text': this.getLink,
                      onSuccess: this.onSuccessfulCopy,
                      className: 'ui right icon button primary button'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      null,
                      'Copy Link\xA0',
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'copy outline' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { href: link },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], { basic: true, content: 'Test Link' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["D" /* Accordion */],
                  { styled: true, fluid: true },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 0,
                      active: activeIndex === 0,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'Settings'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 0 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */],
                      { padded: true, relaxed: true, stackable: true },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          {
                            width: 5,
                            className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.settingsLabels
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Title'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'Customize the title of your form'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                            { className: 'ui form' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
                              label: 'Title',
                              type: 'text',
                              name: 'title',
                              value: this.state.title,
                              onChange: this.textFieldChange
                            })
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          {
                            width: 5,
                            className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.settingsLabels
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'Redirect URL'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'When users submit your form, we will automatically redirect them to the URL provided'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_formsy_react___default.a.Form,
                            { className: 'ui form' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements__["e" /* FloatingLabelInput */], {
                              label: 'Redirect URL',
                              type: 'text',
                              name: 'redirectURI',
                              value: this.state.redirectURI,
                              onChange: this.textFieldChange,
                              validations: 'isUrl',
                              validationError: 'Must be a valid URL (Ex. http://www.example.com)'
                            })
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Row,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          {
                            width: 5,
                            className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.settingsLabels
                          },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'strong',
                              null,
                              'SMS Notifications'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: __WEBPACK_IMPORTED_MODULE_9__Leads_scss___default.a.helperText },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                              'em',
                              null,
                              'Receive an SMS text message immediately after a user submits an inquiry through your form.'
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Grid */].Column,
                          { width: 11 },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SMSNotifications__["a" /* default */], { viewer: viewer, relay: relay })
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["D" /* Accordion */].Title,
                    {
                      index: 1,
                      active: activeIndex === 1,
                      onClick: this.onAccordionClick
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'dropdown' }),
                    'reCAPTCHA Spam Protection'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["D" /* Accordion */].Content,
                    { active: activeIndex === 1 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RecaptchaSettings__["a" /* default */], { viewer: viewer, relay: relay })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LeadLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  toggleSidebar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  sidebarOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__App_Authenticate__["a" /* default */])(LinkComponent)));

/***/ }),
/* 3390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinkComponent__ = __webpack_require__(3389);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__LinkComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3394);
  }
}));

/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EmbedContainer_viewer$ref: FragmentReference;
export type EmbedContainer_viewer = {|
  +id: string,
  +embed_token: ?string,
  +s_recaptcha_enabled: ?boolean,
  +s_recaptcha_site_key: ?string,
  +s_recaptcha_secret_key: ?string,
  +s_time_zone: ?string,
  +phones: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +number: ?string,
        +verified: ?boolean,
      |}
    |}>
  |},
  +s_text_on_embed_submit: ?boolean,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: EmbedContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "EmbedContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "embed_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_enabled",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_site_key",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_secret_key",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "phones",
      "storageKey": null,
      "args": null,
      "concreteType": "PhoneConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PhoneEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Phone",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "verified",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_text_on_embed_submit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '168b07bb66811875354b9d4473cc5021';
module.exports = node;

/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type KioskContainer_viewer$ref: FragmentReference;
export type KioskContainer_viewer = {|
  +id: string,
  +embed_token: ?string,
  +s_recaptcha_enabled: ?boolean,
  +s_recaptcha_site_key: ?string,
  +s_recaptcha_secret_key: ?string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: KioskContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "KioskContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "embed_token",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_site_key",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_secret_key",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'efc2835779931a9a71da26c13a93ad42';
module.exports = node;

/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LeadCaptureContainer_viewer$ref: FragmentReference;
export type LeadCaptureContainer_viewer = {|
  +id: string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: LeadCaptureContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LeadCaptureContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AvailabilityCheckerContainer_viewer",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '7ef46beebe3d0e2eabc0b2a48b100b80';
module.exports = node;

/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LinkContainer_viewer$ref: FragmentReference;
export type LinkContainer_viewer = {|
  +id: string,
  +embed_token: ?string,
  +s_recaptcha_enabled: ?boolean,
  +s_recaptcha_site_key: ?string,
  +s_recaptcha_secret_key: ?string,
  +phones: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +number: ?string,
        +verified: ?boolean,
      |}
    |}>
  |},
  +s_text_on_embed_submit: ?boolean,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: LinkContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "LinkContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "embed_token",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_enabled",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_site_key",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_secret_key",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "phones",
      "storageKey": null,
      "args": null,
      "concreteType": "PhoneConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PhoneEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Phone",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "verified",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_text_on_embed_submit",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cb4382d8068f7cb2ca4b8ad80902eb71';
module.exports = node;

/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f482f19b9735494af3a3d350f3763091
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  s_text_on_embed_submit?: ?boolean,
  s_country?: ?string,
  s_currency?: ?string,
  s_time_zone?: ?string,
  s_recaptcha_enabled?: ?boolean,
  s_recaptcha_site_key?: ?string,
  s_recaptcha_secret_key?: ?string,
};
export type RecaptchaSettings_UpdateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type RecaptchaSettings_UpdateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +s_recaptcha_enabled: ?boolean,
      +s_recaptcha_site_key: ?string,
      +s_recaptcha_secret_key: ?string,
    |}
  |}
|};
export type RecaptchaSettings_UpdateUserMutation = {|
  variables: RecaptchaSettings_UpdateUserMutationVariables,
  response: RecaptchaSettings_UpdateUserMutationResponse,
|};
*/

/*
mutation RecaptchaSettings_UpdateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      s_recaptcha_enabled
      s_recaptcha_site_key
      s_recaptcha_secret_key
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_enabled",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_site_key",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_recaptcha_secret_key",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "RecaptchaSettings_UpdateUserMutation",
    "id": null,
    "text": "mutation RecaptchaSettings_UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      s_recaptcha_enabled\n      s_recaptcha_site_key\n      s_recaptcha_secret_key\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RecaptchaSettings_UpdateUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3, v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "RecaptchaSettings_UpdateUserMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9a32a6d2e562f2bb77dde6cb861d2b09';
module.exports = node;

/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8af3c8d26f088424a4aafa06e50213a5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendPhoneVerificationCodeInput = {
  clientMutationId?: ?string,
  id: string,
};
export type SMSNotifications_sendPhoneVerificationCodeMutationVariables = {|
  input: SendPhoneVerificationCodeInput
|};
export type SMSNotifications_sendPhoneVerificationCodeMutationResponse = {|
  +sendPhoneVerificationCode: ?{|
    +phone: ?{|
      +id: string,
      +number: ?string,
      +verified: ?boolean,
    |}
  |}
|};
export type SMSNotifications_sendPhoneVerificationCodeMutation = {|
  variables: SMSNotifications_sendPhoneVerificationCodeMutationVariables,
  response: SMSNotifications_sendPhoneVerificationCodeMutationResponse,
|};
*/

/*
mutation SMSNotifications_sendPhoneVerificationCodeMutation(
  $input: SendPhoneVerificationCodeInput!
) {
  sendPhoneVerificationCode(input: $input) {
    phone {
      id
      number
      verified
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendPhoneVerificationCodeInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "sendPhoneVerificationCode",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "SendPhoneVerificationCodeInput!"
    }],
    "concreteType": "SendPhoneVerificationCodePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "phone",
      "storageKey": null,
      "args": null,
      "concreteType": "Phone",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "verified",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SMSNotifications_sendPhoneVerificationCodeMutation",
    "id": null,
    "text": "mutation SMSNotifications_sendPhoneVerificationCodeMutation(\n  $input: SendPhoneVerificationCodeInput!\n) {\n  sendPhoneVerificationCode(input: $input) {\n    phone {\n      id\n      number\n      verified\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SMSNotifications_sendPhoneVerificationCodeMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SMSNotifications_sendPhoneVerificationCodeMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1d7bce981ac269adc00b8006082d38ac';
module.exports = node;

/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 2f9502be3409c906a98d2dcced5c35c1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePhoneInput = {
  clientMutationId?: ?string,
  id: string,
  number?: ?string,
};
export type SMSNotifications_updatePhoneMutationVariables = {|
  input: UpdatePhoneInput
|};
export type SMSNotifications_updatePhoneMutationResponse = {|
  +updatePhone: ?{|
    +phone: ?{|
      +id: string,
      +number: ?string,
      +verified: ?boolean,
    |}
  |}
|};
export type SMSNotifications_updatePhoneMutation = {|
  variables: SMSNotifications_updatePhoneMutationVariables,
  response: SMSNotifications_updatePhoneMutationResponse,
|};
*/

/*
mutation SMSNotifications_updatePhoneMutation(
  $input: UpdatePhoneInput!
) {
  updatePhone(input: $input) {
    phone {
      id
      number
      verified
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePhoneInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePhone",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdatePhoneInput!"
    }],
    "concreteType": "UpdatePhonePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "phone",
      "storageKey": null,
      "args": null,
      "concreteType": "Phone",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "verified",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SMSNotifications_updatePhoneMutation",
    "id": null,
    "text": "mutation SMSNotifications_updatePhoneMutation(\n  $input: UpdatePhoneInput!\n) {\n  updatePhone(input: $input) {\n    phone {\n      id\n      number\n      verified\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SMSNotifications_updatePhoneMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SMSNotifications_updatePhoneMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2baada083ae8439543215299f61bb7bd';
module.exports = node;

/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c70022757a751157699d09edd11d1f09
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  s_text_on_embed_submit?: ?boolean,
  s_country?: ?string,
  s_currency?: ?string,
  s_time_zone?: ?string,
  s_recaptcha_enabled?: ?boolean,
  s_recaptcha_site_key?: ?string,
  s_recaptcha_secret_key?: ?string,
};
export type SMSNotifications_updateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type SMSNotifications_updateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +s_text_on_embed_submit: ?boolean
    |}
  |}
|};
export type SMSNotifications_updateUserMutation = {|
  variables: SMSNotifications_updateUserMutationVariables,
  response: SMSNotifications_updateUserMutationResponse,
|};
*/

/*
mutation SMSNotifications_updateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      s_text_on_embed_submit
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "s_text_on_embed_submit",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SMSNotifications_updateUserMutation",
    "id": null,
    "text": "mutation SMSNotifications_updateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      s_text_on_embed_submit\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SMSNotifications_updateUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SMSNotifications_updateUserMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUser",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd9d4731d7258dfe7b1001e610223f62d';
module.exports = node;

/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6db8fe2f29c6c3c28862af0f847015e8
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyPhoneInput = {
  clientMutationId?: ?string,
  id: string,
  verification_code: string,
};
export type SMSNotifications_verifyPhoneMutationVariables = {|
  input: VerifyPhoneInput
|};
export type SMSNotifications_verifyPhoneMutationResponse = {|
  +verifyPhone: ?{|
    +phone: ?{|
      +id: string,
      +number: ?string,
      +verified: ?boolean,
    |}
  |}
|};
export type SMSNotifications_verifyPhoneMutation = {|
  variables: SMSNotifications_verifyPhoneMutationVariables,
  response: SMSNotifications_verifyPhoneMutationResponse,
|};
*/

/*
mutation SMSNotifications_verifyPhoneMutation(
  $input: VerifyPhoneInput!
) {
  verifyPhone(input: $input) {
    phone {
      id
      number
      verified
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyPhoneInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "verifyPhone",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "VerifyPhoneInput!"
    }],
    "concreteType": "VerifyPhonePayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "phone",
      "storageKey": null,
      "args": null,
      "concreteType": "Phone",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "number",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "verified",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SMSNotifications_verifyPhoneMutation",
    "id": null,
    "text": "mutation SMSNotifications_verifyPhoneMutation(\n  $input: VerifyPhoneInput!\n) {\n  verifyPhone(input: $input) {\n    phone {\n      id\n      number\n      verified\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SMSNotifications_verifyPhoneMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "SMSNotifications_verifyPhoneMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b7bae802153826e66c6be3d999dd9569';
module.exports = node;

/***/ }),
/* 3400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global Intercom */
/* eslint-disable new-cap */

var submitInterval = 2000;

function retry(callback) {
  submitInterval *= 2;
  // eslint-disable-next-line no-use-before-define
  setTimeout(function () {
    return sendToProvider(callback);
  }, submitInterval);
}

function sendToProvider(callback) {
  try {
    callback();
  } catch (e) {
    retry(callback);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  trackEvent: function trackEvent(event, metadata) {
    sendToProvider(function () {
      return Intercom('trackEvent', event, metadata);
    });
  }
});

/***/ }),
/* 3401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_day_picker__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_day_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_day_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_day_picker_lib_style_css__ = __webpack_require__(3601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_day_picker_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_day_picker_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Calendar_css__ = __webpack_require__(3604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateCell__ = __webpack_require__(3403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_events__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AvailabilityCalendar = function (_React$Component) {
  _inherits(AvailabilityCalendar, _React$Component);

  function AvailabilityCalendar(props) {
    _classCallCheck(this, AvailabilityCalendar);

    var _this = _possibleConstructorReturn(this, (AvailabilityCalendar.__proto__ || Object.getPrototypeOf(AvailabilityCalendar)).call(this, props));

    _this.state = {
      visibleMonth: _this.props.selectedDay || new Date(),
      eventsByDate: {}
    };
    _this.isTentative = _this.isTentative.bind(_this);
    _this.isBooked = _this.isBooked.bind(_this);
    _this.isCanceled = _this.isCanceled.bind(_this);
    _this.renderDay = _this.renderDay.bind(_this);
    _this.onMonthChange = _this.onMonthChange.bind(_this);
    _this.selectDay = _this.selectDay.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  _createClass(AvailabilityCalendar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var timeZone = this.getTimeZone();
      this.props.relay.refetch(function (fragmentVariables) {
        return Object.assign({}, fragmentVariables, {
          afterTime: __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz(_this2.state.visibleMonth, timeZone).startOf('month').subtract(1, 'month').toISOString(),
          beforeTime: __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz(_this2.state.visibleMonth, timeZone).startOf('month').add(1, 'month').toISOString(),
          returnEmptyConnection: false
        });
      });
      var userEvents = this.props.viewer ? this.props.viewer.AvailabilityCalendarContainer_user_events.edges : [];
      this.setState({
        eventsByDate: __WEBPACK_IMPORTED_MODULE_6__lib_utils_events__["a" /* default */].groupEventsByDate(userEvents, this.state.visibleMonth, this.getTimeZone())
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var userEvents = nextProps.viewer ? nextProps.viewer.AvailabilityCalendarContainer_user_events.edges : [];
      this.setState({
        eventsByDate: __WEBPACK_IMPORTED_MODULE_6__lib_utils_events__["a" /* default */].groupEventsByDate(userEvents, this.state.visibleMonth, this.getTimeZone())
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      if (e.relatedTarget && !e.relatedTarget.className.match('DayPicker')) {
        if (this.props.close) this.props.close(e);
      }
    }
  }, {
    key: 'onMonthChange',
    value: function onMonthChange(month) {
      var timeZone = this.getTimeZone();
      this.props.relay.refetch(function (fragmentVariables) {
        return Object.assign({}, fragmentVariables, {
          afterTime: __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz(month, timeZone).startOf('month').subtract(1, month).toISOString(),
          beforeTime: __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz(month, timeZone).startOf('month').add(1, 'month').toISOString(),
          returnEmptyConnection: false
        });
      });
      var userEvents = this.props.viewer ? this.props.viewer.AvailabilityCalendarContainer_user_events.edges : [];
      this.setState({
        visibleMonth: month,
        eventsByDate: __WEBPACK_IMPORTED_MODULE_6__lib_utils_events__["a" /* default */].groupEventsByDate(userEvents, month, this.getTimeZone())
      });
    }
  }, {
    key: 'getTimeZone',
    value: function getTimeZone() {
      return this.props.viewer && this.props.viewer.s_time_zone || __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz.guess();
    }
  }, {
    key: 'selectDay',
    value: function selectDay() {
      this.props.updateSelectedDay(this.props.selectedDay);
      this.props.openAvailabilityDetails();
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day) {
      this.props.updateSelectedDay(day);
      if (this.props.closeOnSelect) this.props.close();
    }
  }, {
    key: 'isBooked',
    value: function isBooked(day) {
      var isBooked = false;
      var eventsByDate = this.state.eventsByDate[day.getDate()];
      for (var i = 0; i < eventsByDate.length; i++) {
        if (eventsByDate[i].node.booking_status === 'BOOKED') {
          isBooked = true;
        }
      }
      return isBooked;
    }
  }, {
    key: 'isTentative',
    value: function isTentative(day) {
      var isTentative = false;
      var eventsByDate = this.state.eventsByDate[day.getDate()];
      for (var i = 0; i < eventsByDate.length; i++) {
        if (eventsByDate[i].node.booking_status === 'INITIAL') {
          isTentative = true;
        }
      }
      return isTentative && !this.isBooked(day);
    }
  }, {
    key: 'isCanceled',
    value: function isCanceled(day) {
      var isCanceled = false;
      var eventsByDate = this.state.eventsByDate[day.getDate()];
      for (var i = 0; i < eventsByDate.length; i++) {
        if (eventsByDate[i].node.booking_status === 'CANCELED') {
          isCanceled = true;
        }
      }
      return isCanceled && !(this.isTentative(day) || this.isBooked(day));
    }
  }, {
    key: 'renderDay',
    value: function renderDay(day) {
      var date = day.getDate();

      var eventsOnDay = this.state.eventsByDate[day.getDate()];

      if (eventsOnDay.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.props.showDetails && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateCell__["a" /* default */], { date: date, toggleAvailabilityView: this.selectDay }),
          !this.props.showDetails && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateCell__["a" /* default */], { date: date })
        );
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DateCell__["a" /* default */], { date: date })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_day_picker___default.a, {
        onDayClick: this.handleDayClick.bind(this),
        onBlur: this.onBlur,
        selectedDays: function selectedDays(day) {
          return __WEBPACK_IMPORTED_MODULE_2_react_day_picker__["DateUtils"].isSameDay(day, _this3.props.selectedDay);
        },
        modifiers: {
          isTentative: this.isTentative,
          isBooked: this.isBooked,
          isCanceled: this.isCanceled
        },
        renderDay: this.renderDay,
        onMonthChange: this.onMonthChange,
        initialMonth: this.state.visibleMonth,
        ref: 'daypicker',
        tabIndex: -1
      });
    }
  }]);

  return AvailabilityCalendar;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AvailabilityCalendar.propTypes = {
  toggleAvailabilityView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  selectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  updateSelectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  closeOnSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  openAvailabilityDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  showDetails: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AvailabilityCalendar);

/***/ }),
/* 3402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvailabilityCalendar__ = __webpack_require__(3401);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__AvailabilityCalendar__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3405);
  }
}, function () {
  return __webpack_require__(3404);
}));

/***/ }),
/* 3403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DateCell = function (_React$Component) {
  _inherits(DateCell, _React$Component);

  function DateCell() {
    _classCallCheck(this, DateCell);

    return _possibleConstructorReturn(this, (DateCell.__proto__ || Object.getPrototypeOf(DateCell)).apply(this, arguments));
  }

  _createClass(DateCell, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'DayPicker-Day--wrapper', onClick: this.props.toggleAvailabilityView },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { transform: 'translateY(-50%)' } },
          this.props.date
        )
      );
    }
  }]);

  return DateCell;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

DateCell.propTypes = {
  toggleAvailabilityView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  date: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (DateCell);

/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash afcd0dc68290ea250cdfb707465da626
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type AvailabilityCalendarContainer_RefetchQueryVariables = {|
  afterTime: any,
  beforeTime: any,
  booking_status?: ?$ReadOnlyArray<?BookingStatus>,
  returnEmptyConnection?: ?boolean,
  visibility?: ?$ReadOnlyArray<?UserEventVisibility>,
|};
export type AvailabilityCalendarContainer_RefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref
  |}
|};
export type AvailabilityCalendarContainer_RefetchQuery = {|
  variables: AvailabilityCalendarContainer_RefetchQueryVariables,
  response: AvailabilityCalendarContainer_RefetchQueryResponse,
|};
*/

/*
query AvailabilityCalendarContainer_RefetchQuery(
  $afterTime: ISO8601Type!
  $beforeTime: ISO8601Type!
  $booking_status: [BookingStatus]
  $returnEmptyConnection: Boolean
  $visibility: [UserEventVisibility]
) {
  viewer {
    ...AvailabilityCalendarContainer_viewer_RvbYK
    id
  }
}

fragment AvailabilityCalendarContainer_viewer_RvbYK on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "afterTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "beforeTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "booking_status",
    "type": "[BookingStatus]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "returnEmptyConnection",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "visibility",
    "type": "[UserEventVisibility]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "AvailabilityCalendarContainer_RefetchQuery",
    "id": null,
    "text": "query AvailabilityCalendarContainer_RefetchQuery(\n  $afterTime: ISO8601Type!\n  $beforeTime: ISO8601Type!\n  $booking_status: [BookingStatus]\n  $returnEmptyConnection: Boolean\n  $visibility: [UserEventVisibility]\n) {\n  viewer {\n    ...AvailabilityCalendarContainer_viewer_RvbYK\n    id\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer_RvbYK on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AvailabilityCalendarContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "AvailabilityCalendarContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "afterTime",
            "variableName": "afterTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "beforeTime",
            "variableName": "beforeTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "booking_status",
            "variableName": "booking_status",
            "type": null
          }, {
            "kind": "Variable",
            "name": "returnEmptyConnection",
            "variableName": "returnEmptyConnection",
            "type": null
          }, {
            "kind": "Variable",
            "name": "visibility",
            "variableName": "visibility",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AvailabilityCalendarContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "after_time",
            "variableName": "afterTime",
            "type": "ISO8601Type"
          }, {
            "kind": "Variable",
            "name": "before_time",
            "variableName": "beforeTime",
            "type": "ISO8601Type"
          }, {
            "kind": "Variable",
            "name": "booking_status",
            "variableName": "booking_status",
            "type": "[BookingStatus]"
          }, v1, {
            "kind": "Variable",
            "name": "return_empty_connection",
            "variableName": "returnEmptyConnection",
            "type": "Boolean"
          }, {
            "kind": "Variable",
            "name": "visibility",
            "variableName": "visibility",
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v2, v3]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v4, v5, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": [v1],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v3, v4, v5, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "all_day",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v2]
                  }]
                }]
              }, v2]
            }]
          }]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b98c1d8fb90f7847b47121b8648aec20';
module.exports = node;

/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AvailabilityCalendarContainer_viewer$ref: FragmentReference;
export type AvailabilityCalendarContainer_viewer = {|
  +s_time_zone: ?string,
  +AvailabilityCalendarContainer_user_events: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
              +all_day: ?boolean,
              +location: ?string,
              +room: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: AvailabilityCalendarContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "AvailabilityCalendarContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "visibility",
      "type": "[UserEventVisibility]",
      "defaultValue": ["SHOW"]
    }, {
      "kind": "LocalArgument",
      "name": "booking_status",
      "type": "[BookingStatus]",
      "defaultValue": ["BOOKED", "INITIAL", "CANCELED"]
    }, {
      "kind": "LocalArgument",
      "name": "afterTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "beforeTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "returnEmptyConnection",
      "type": "Boolean",
      "defaultValue": true
    }],
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "AvailabilityCalendarContainer_user_events",
      "name": "user_events",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "afterTime",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "beforeTime",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "booking_status",
        "variableName": "booking_status",
        "type": "[BookingStatus]"
      }, v0, {
        "kind": "Variable",
        "name": "return_empty_connection",
        "variableName": "returnEmptyConnection",
        "type": "Boolean"
      }, {
        "kind": "Variable",
        "name": "visibility",
        "variableName": "visibility",
        "type": "[UserEventVisibility]"
      }],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            }, v1]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [v0],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegment",
                "plural": false,
                "selections": [v1, v2, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '2336432f476400d21cff368a83c42dd0';
module.exports = node;

/***/ }),
/* 3406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvailabilityChecker_scss__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvailabilityChecker_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AvailabilityChecker_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_location__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__ = __webpack_require__(106);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AgendaViewComponent = (_temp = _class = function (_React$Component) {
  _inherits(AgendaView, _React$Component);

  function AgendaView(props) {
    _classCallCheck(this, AgendaView);

    var _this = _possibleConstructorReturn(this, (AgendaView.__proto__ || Object.getPrototypeOf(AgendaView)).call(this, props));

    _this.openEvent = _this.openEvent.bind(_this);
    return _this;
  }

  _createClass(AgendaView, [{
    key: 'openEvent',
    value: function openEvent(event) {
      /* eslint-disable no-underscore-dangle */
      this.props.router.push('/events/' + event.event.id);
      if (this.props.close && this.props.closeAvailabilityChecker) {
        this.props.close();
        this.props.closeAvailabilityChecker();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess();
      var getVenueTitle = function getVenueTitle(eventSegment) {
        return (eventSegment.node.location || '') + (eventSegment.node.room ? ' (' + eventSegment.node.room + ')' : '');
      };
      var getDateFormat = function getDateFormat(eventSegment) {
        return eventSegment.node.all_day ? 'L' : 'L [at] LT';
      };
      var getVenueText = function getVenueText(eventSegment) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          getVenueTitle(eventSegment),
          eventSegment.node.line1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          eventSegment.node.line1,
          (eventSegment.node.city || eventSegment.node.province || eventSegment.node.postal_code) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_6__lib_utils_location__["a" /* default */].getLocalityString({
            city: eventSegment.node.city,
            province: eventSegment.node.province,
            postal_code: eventSegment.node.postal_code
          })
        );
      };

      var events = this.props.eventsOnDay.map(function (eventOnDay, eventIndex) {
        var event = eventOnDay.node;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: eventIndex, style: { textAlign: 'left', margin: '2em 0' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h4',
            {
              onClick: _this2.openEvent.bind(null, event),
              className: __WEBPACK_IMPORTED_MODULE_2__AvailabilityChecker_scss___default.a.eventName,
              style: { cursor: 'pointer' }
            },
            event.event.title
          ),
          event.user_event_segments.edges.map(function (eventSegment, segmentIndex) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: segmentIndex, className: __WEBPACK_IMPORTED_MODULE_2__AvailabilityChecker_scss___default.a.cardSection },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h5',
                null,
                eventSegment.node.title
              ),
              __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(eventSegment.node.start_at).isValid() && __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(eventSegment.node.end_at).isValid && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["b" /* CardDescriptionList */], {
                  label: 'Starts',
                  value: __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].isoStringToMoment(eventSegment.node.start_at, eventSegment.node.all_day, timeZone).format(getDateFormat(eventSegment))
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["b" /* CardDescriptionList */], {
                  label: 'Ends',
                  value: __WEBPACK_IMPORTED_MODULE_7__lib_utils_date__["a" /* default */].isoStringToMoment(eventSegment.node.end_at, eventSegment.node.all_day, timeZone).format(getDateFormat(eventSegment))
                })
              ),
              eventSegment.node.location && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Elements__["b" /* CardDescriptionList */], {
                  label: 'Venue',
                  value: getVenueText(eventSegment)
                })
              )
            );
          })
        );
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        events.length === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h4',
          { style: { textAlign: 'center', marginTop: '2em' } },
          'No events on',
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(this.props.selectedDay).format('MMMM Do, YYYY')
        ),
        events
      );
    }
  }]);

  return AgendaView;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  eventsOnDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  selectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  closeAvailabilityChecker: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_found__["withRouter"])(AgendaViewComponent));

/***/ }),
/* 3407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvailabilityChecker_scss__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvailabilityChecker_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AvailabilityChecker_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideTransition_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blueprintjs_core__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blueprintjs_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__blueprintjs_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AvailabilityDetails__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_events__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var AvailabilityChecker = function (_React$Component) {
  _inherits(AvailabilityChecker, _React$Component);

  function AvailabilityChecker(props) {
    _classCallCheck(this, AvailabilityChecker);

    var _this = _possibleConstructorReturn(this, (AvailabilityChecker.__proto__ || Object.getPrototypeOf(AvailabilityChecker)).call(this, props));

    _this.state = {
      showAvailabilityChecker: false,
      showAvailabilityDetails: false,
      eventsOnDay: [],
      selectedDay: new Date()
    };
    _this.openAvailabilityChecker = _this.openAvailabilityChecker.bind(_this);
    _this.closeAvailabilityChecker = _this.closeAvailabilityChecker.bind(_this);
    _this.openAvailabilityDetails = _this.openAvailabilityDetails.bind(_this);
    _this.closeAvailabilityDetails = _this.closeAvailabilityDetails.bind(_this);
    _this.updateSelectedDay = _this.updateSelectedDay.bind(_this);
    return _this;
  }

  _createClass(AvailabilityChecker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.relay.refetch({
        afterTime: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.state.selectedDay).startOf('month').subtract(1, 'month').toISOString(),
        beforeTime: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.state.selectedDay).startOf('month').add(1, 'month').toISOString(),
        returnEmptyConnection: false
      });
    }
  }, {
    key: 'openAvailabilityChecker',
    value: function openAvailabilityChecker() {
      this.setState({ showAvailabilityChecker: true });
      __WEBPACK_IMPORTED_MODULE_2____["c" /* Analytics */].trackEvent('viewed-availability-checker');
    }
  }, {
    key: 'closeAvailabilityChecker',
    value: function closeAvailabilityChecker() {
      this.setState({ showAvailabilityChecker: false });
    }
  }, {
    key: 'openAvailabilityDetails',
    value: function openAvailabilityDetails() {
      this.setState({
        showAvailabilityChecker: this.props.mobile,
        showAvailabilityDetails: true
      });
    }
  }, {
    key: 'closeAvailabilityDetails',
    value: function closeAvailabilityDetails() {
      this.setState({ showAvailabilityDetails: false });
    }
  }, {
    key: 'updateSelectedDay',
    value: function updateSelectedDay(selectedDay) {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_11_moment___default()(this.state.selectedDay).isSame(selectedDay, 'day')) {
        this.props.relay.refetch({
          afterTime: __WEBPACK_IMPORTED_MODULE_11_moment___default()(selectedDay).startOf('month').subtract(1, 'month').toISOString(),
          beforeTime: __WEBPACK_IMPORTED_MODULE_11_moment___default()(selectedDay).startOf('month').add(1, 'month').toISOString(),
          returnEmptyConnection: false
        }, null, function () {
          _this2.setState({
            selectedDay: selectedDay,
            eventsOnDay: __WEBPACK_IMPORTED_MODULE_10__lib_utils_events__["a" /* default */].groupEventsByDate(_this2.props.viewer.AvailabilityCheckerContainer_user_events.edges, selectedDay, _this2.props.viewer.s_time_zone)[selectedDay.getDate()]
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var desktopTrigger = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          className: [__WEBPACK_IMPORTED_MODULE_3__AvailabilityChecker_scss___default.a.calendarIcon, this.state.showAvailabilityChecker ? __WEBPACK_IMPORTED_MODULE_3__AvailabilityChecker_scss___default.a.calendarIconActive : ''].join(' ')
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_semantic_ui_react__["d" /* Icon */], { name: 'calendar alternate outline' })
      );

      var mobileTrigger = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'item', onClick: this.openAvailabilityChecker },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'calendar alternate outline icon' })
      );

      var desktopAvailabilityCalendar = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["g" /* AvailabilityCalendar */], {
        initialMonth: this.state.selectedDay,
        selectedDay: this.state.selectedDay,
        onDayClick: function onDayClick() {},
        updateSelectedDay: this.updateSelectedDay,
        openAvailabilityDetails: this.openAvailabilityDetails,
        showDetails: true,
        viewer: this.props.viewer
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: 'inline-block', margin: 'auto' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.desktop },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__blueprintjs_core__["Popover"],
            {
              content: desktopAvailabilityCalendar,
              interactionKind: __WEBPACK_IMPORTED_MODULE_7__blueprintjs_core__["PopoverInteractionKind"].CLICK,
              popoverClassName: 'pt-popover-content-sizing',
              position: __WEBPACK_IMPORTED_MODULE_7__blueprintjs_core__["Position"].BOTTOM,
              inline: true,
              popoverWillOpen: this.openAvailabilityChecker,
              popoverWillClose: this.closeAvailabilityChecker
            },
            desktopTrigger
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AvailabilityDetails__["a" /* default */], {
            isOpen: this.state.showAvailabilityDetails,
            close: this.closeAvailabilityDetails,
            closeAvailabilityChecker: this.closeAvailabilityChecker,
            eventsOnDay: this.state.eventsOnDay,
            updateSelectedDay: this.updateSelectedDay,
            selectedDay: this.state.selectedDay,
            viewer: this.props.viewer
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__globals_scss___default.a.mobile },
          mobileTrigger,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group___default.a,
            {
              transitionName: 'slide',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 300
            },
            this.state.showAvailabilityChecker && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */],
              {
                open: this.state.showAvailabilityChecker,
                onClose: this.closeAvailabilityChecker,
                inline: true
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'menu' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { className: 'item', onClick: this.closeAvailabilityChecker },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'left chevron icon' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2____["f" /* MobileModal */].Content,
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["g" /* AvailabilityCalendar */], {
                  initialMonth: this.state.selectedDay,
                  selectedDay: this.state.selectedDay,
                  onDayClick: function onDayClick() {},
                  updateSelectedDay: this.updateSelectedDay,
                  viewer: this.props.viewer,
                  close: this.closeAvailabilityChecker,
                  openAvailabilityDetails: this.openAvailabilityDetails,
                  showDetails: true,
                  mobile: true
                })
              )
            )
          )
        )
      );
    }
  }]);

  return AvailabilityChecker;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AvailabilityChecker.propTypes = {
  viewer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  mobile: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  relay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AvailabilityChecker);

/***/ }),
/* 3408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvailabilityChecker__ = __webpack_require__(3407);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createRefetchContainer"])(__WEBPACK_IMPORTED_MODULE_1__AvailabilityChecker__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3411);
  }
}, function () {
  return __webpack_require__(3410);
}));

/***/ }),
/* 3409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_big_calendar_lib_css_react_big_calendar_css__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_big_calendar_lib_css_react_big_calendar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_big_calendar_lib_css_react_big_calendar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DayView_scss__ = __webpack_require__(3624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DayView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DayView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss__ = __webpack_require__(3623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils_bigCalendar__ = __webpack_require__(1489);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* eslint-disable no-underscore-dangle */









var DayViewComponent = (_temp = _class = function (_React$Component) {
  _inherits(DayView, _React$Component);

  function DayView(props) {
    _classCallCheck(this, DayView);

    var _this = _possibleConstructorReturn(this, (DayView.__proto__ || Object.getPrototypeOf(DayView)).call(this, props));

    _this.nextDay = _this.nextDay.bind(_this);
    _this.prevDay = _this.prevDay.bind(_this);
    _this.selectEvent = _this.selectEvent.bind(_this);
    return _this;
  }

  _createClass(DayView, [{
    key: 'generateEventId',
    value: function generateEventId() {
      return (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2);
    }
  }, {
    key: 'nextDay',
    value: function nextDay() {
      this.props.updateSelectedDay(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).add(1, 'days').toDate());
    }
  }, {
    key: 'prevDay',
    value: function prevDay() {
      this.props.updateSelectedDay(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).subtract(1, 'days').toDate());
    }
  }, {
    key: 'selectEvent',
    value: function selectEvent(event) {
      var _this2 = this;

      this.props.router.push('/events/' + event.id);
      setTimeout(function () {
        _this2.props.close();
        if (_this2.props.closeAvailabilityChecker) _this2.props.closeAvailabilityChecker();
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var events = __WEBPACK_IMPORTED_MODULE_8__lib_utils_bigCalendar__["a" /* default */].getFlattenedEventSegments(this.props.events);
      var timeZone = this.props.timeZone || __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess();
      var Event = function Event(_ref) {
        var event = _ref.event;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            null,
            event.title
          )
        );
      };

      var firstEvent = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).endOf('day');
      events.slice().map(function (event) {
        if (__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(event.start).isSame(firstEvent, 'day')) {
          firstEvent = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.min(firstEvent, __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(event.start));
        }
        return event;
      });
      if (events.length === 0) {
        firstEvent = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).startOf('day');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { margin: '2em 0' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.timepicker },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
            className: [__WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.timepickerButton, __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.timepickerPrev].join(' '),
            onClick: this.prevDay
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
            className: [__WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.timepickerButton, __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.timepickerNext].join(' '),
            onClick: this.nextDay
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.selectedDay },
            __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).format('dddd')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: __WEBPACK_IMPORTED_MODULE_6__BigCalendar_scss___default.a.selectedDate },
            __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.props.selectedDay).format('MMMM Do, YYYY')
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modules__["h" /* BigCalendarInTimeZone */], {
            date: this.props.selectedDay,
            components: { event: Event },
            events: events,
            timeZone: timeZone,
            showMultiDayTimes: true,
            formats: { timeGutterFormat: 'h A', dayFormat: ' ' },
            timeslots: 2,
            view: 'day',
            onView: function onView() {},
            onNavigate: function onNavigate() {},
            toolbar: false,
            defaultDate: this.props.selectedDay,
            onSelectEvent: this.selectEvent,
            eventPropGetter: __WEBPACK_IMPORTED_MODULE_8__lib_utils_bigCalendar__["a" /* default */].eventPropGetter,
            style: { height: '360px' },
            className: 'dayView',
            key: firstEvent.toDate(),
            scrollToTime: firstEvent.toDate()
          })
        )
      );
    }
  }]);

  return DayView;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  selectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  updateSelectedDay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  closeAvailabilityChecker: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  events: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  timeZone: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_found__["withRouter"])(DayViewComponent));

/***/ }),
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5dfe04b00807870475aabd29c8bf40c1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
export type AvailabilityCheckerContainer_RefetchQueryVariables = {|
  afterTime: any,
  beforeTime: any,
  returnEmptyConnection?: ?boolean,
|};
export type AvailabilityCheckerContainer_RefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref
  |}
|};
export type AvailabilityCheckerContainer_RefetchQuery = {|
  variables: AvailabilityCheckerContainer_RefetchQueryVariables,
  response: AvailabilityCheckerContainer_RefetchQueryResponse,
|};
*/

/*
query AvailabilityCheckerContainer_RefetchQuery(
  $afterTime: ISO8601Type!
  $beforeTime: ISO8601Type!
  $returnEmptyConnection: Boolean
) {
  viewer {
    ...AvailabilityCheckerContainer_viewer_2Pfr0E
    id
  }
}

fragment AvailabilityCheckerContainer_viewer_2Pfr0E on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "afterTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "beforeTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "returnEmptyConnection",
    "type": "Boolean",
    "defaultValue": null
  }],
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v3, v4]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v5, v6, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": [v1],
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v4, v5, v6, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v3]
          }]
        }]
      }, v3]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "AvailabilityCheckerContainer_RefetchQuery",
    "id": null,
    "text": "query AvailabilityCheckerContainer_RefetchQuery(\n  $afterTime: ISO8601Type!\n  $beforeTime: ISO8601Type!\n  $returnEmptyConnection: Boolean\n) {\n  viewer {\n    ...AvailabilityCheckerContainer_viewer_2Pfr0E\n    id\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer_2Pfr0E on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AvailabilityCheckerContainer_RefetchQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "AvailabilityCheckerContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "afterTime",
            "variableName": "afterTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "beforeTime",
            "variableName": "beforeTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "returnEmptyConnection",
            "variableName": "returnEmptyConnection",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AvailabilityCheckerContainer_RefetchQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v1, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "after_time",
            "variableName": "afterTime",
            "type": "ISO8601Type"
          }, {
            "kind": "Variable",
            "name": "before_time",
            "variableName": "beforeTime",
            "type": "ISO8601Type"
          }, v1, {
            "kind": "Variable",
            "name": "return_empty_connection",
            "variableName": "returnEmptyConnection",
            "type": "Boolean"
          }, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }, v3]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f4c1acd81ced34528cc6a3ba03b860cd';
module.exports = node;

/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AvailabilityCheckerContainer_viewer$ref: FragmentReference;
export type AvailabilityCheckerContainer_viewer = {|
  +s_time_zone: ?string,
  +AvailabilityCheckerContainer_user_events: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
              +all_day: ?boolean,
              +location: ?string,
              +room: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: AvailabilityCheckerContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "AvailabilityCheckerContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "afterTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "beforeTime",
      "type": "ISO8601Type",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "returnEmptyConnection",
      "type": "Boolean",
      "defaultValue": true
    }],
    "selections": [{
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "AvailabilityCheckerContainer_user_events",
      "name": "user_events",
      "storageKey": null,
      "args": [{
        "kind": "Variable",
        "name": "after_time",
        "variableName": "afterTime",
        "type": "ISO8601Type"
      }, {
        "kind": "Variable",
        "name": "before_time",
        "variableName": "beforeTime",
        "type": "ISO8601Type"
      }, v0, {
        "kind": "Variable",
        "name": "return_empty_connection",
        "variableName": "returnEmptyConnection",
        "type": "Boolean"
      }, {
        "kind": "Literal",
        "name": "visibility",
        "value": ["SHOW"],
        "type": "[UserEventVisibility]"
      }],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEventEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEvent",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            }, v1]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          }, v2, v3, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [v0],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegment",
                "plural": false,
                "selections": [v1, v2, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                }]
              }]
            }]
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '996f424abc5fa3ccd910c021804674a7';
module.exports = node;

/***/ }),
/* 3412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_big_calendar__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_big_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_date__ = __webpack_require__(106);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







// remember the browser's local timezone, as it might by used later on
__WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.tz = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess();
// format all dates in BigCalendar as they would be rendered
// in browser's local timezone (even if later on they won't)
// eslint-disable-next-line no-underscore-dangle
var _m = function _m() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.apply(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a, args.concat([__WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.tz]));
};
_m.localeData = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.localeData;

__WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.setLocalizer(__WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.momentLocalizer(_m));

var BigCalendarInTimeZone = function BigCalendarInTimeZone(_ref) {
  var events = _ref.events,
      onSelectSlot = _ref.onSelectSlot,
      onEventDrop = _ref.onEventDrop,
      timeZone = _ref.timeZone,
      props = _objectWithoutProperties(_ref, ['events', 'onSelectSlot', 'onEventDrop', 'timeZone']);

  var convertDateTimeToDate = function convertDateTimeToDate(datetime, allDay, tz, dateType) {
    var m = __WEBPACK_IMPORTED_MODULE_4__lib_utils_date__["a" /* default */].isoStringToMoment(datetime, allDay, tz);
    // Adds extra day since BigCalendar allDay rendering
    // is not inclusive of end date
    if (allDay && dateType === 'end') m.add(1, 'day');
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
  };

  var convertDateToDateTime = function convertDateToDateTime(date) {
    var dateM = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(date, __WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.tz);
    var m = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz({
      year: dateM.year(),
      month: dateM.month(),
      date: dateM.date(),
      hour: dateM.hour(),
      minute: dateM.minute()
    }, __WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a.tz);
    return m;
  };
  var bigCalendarProps = _extends({}, props, {
    events: events.map(function (event) {
      return _extends({}, event, {
        start: convertDateTimeToDate(event.start, event.allDay, timeZone),
        end: convertDateTimeToDate(event.end, event.allDay, timeZone, 'end')
      });
    }),
    onSelectSlot: onSelectSlot && function (_ref2) {
      var start = _ref2.start,
          end = _ref2.end,
          slots = _ref2.slots;

      onSelectSlot({
        start: convertDateToDateTime(start, timeZone),
        end: convertDateToDateTime(end, timeZone),
        slots: slots.map(function (date) {
          return convertDateToDateTime(date, timeZone);
        })
      });
    },
    onEventDrop: onEventDrop &&
    // eslint-disable-next-line react/prop-types
    function (_ref3) {
      var event = _ref3.event,
          start = _ref3.start,
          end = _ref3.end;

      onEventDrop({
        event: event,
        start: convertDateToDateTime(start, timeZone),
        end: convertDateToDateTime(end, timeZone)
      });
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_big_calendar___default.a, bigCalendarProps);
};

BigCalendarInTimeZone.propTypes = {
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  onSelectSlot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEventDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  timeZone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (BigCalendarInTimeZone);

/***/ }),
/* 3413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DeleteConfirmation = function (_React$Component) {
  _inherits(DeleteConfirmation, _React$Component);

  function DeleteConfirmation(props) {
    _classCallCheck(this, DeleteConfirmation);

    var _this = _possibleConstructorReturn(this, (DeleteConfirmation.__proto__ || Object.getPrototypeOf(DeleteConfirmation)).call(this, props));

    _this.state = {
      modalOpen: false,
      deleting: false,
      mounted: false
    };
    _this.closeModal = _this.closeModal.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  _createClass(DeleteConfirmation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted();
    }
  }, {
    key: 'mounted',
    value: function mounted() {
      this.setState({ mounted: true });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(e) {
      this.setState({ modalOpen: false });
      if (this.props.onClose) this.props.onClose(e);
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({ modalOpen: true });
    }
  }, {
    key: 'delete',
    value: function _delete(e) {
      this.setState({ deleting: true, modalOpen: false });
      if (this.props.onClose) this.props.onClose(e);
      this.props.delete(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { ref: 'mountNode', className: 'ignore-react-onclickoutside' },
        this.state.mounted && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */],
          {
            trigger: this.props.trigger ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.trigger, {
              onClick: this.openModal
            }) : undefined,
            open: this.props.open || this.state.modalOpen,
            onClose: this.props.onClose,
            mountNode: this.refs.mountNode,
            size: 'small'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Header */], {
            content: this.props.title ? this.props.title : 'Delete confirmation'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Content,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h3',
              null,
              this.props.content ? this.props.content : 'Are you sure you want to delete this item?'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */].Actions,
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
              { basic: true, onClick: this.closeModal },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],
              {
                color: 'red',
                onClick: this.delete,
                disabled: this.state.deleting
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'delete' }),
              ' Delete'
            )
          )
        )
      );
    }
  }]);

  return DeleteConfirmation;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

DeleteConfirmation.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  trigger: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  open: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DeleteConfirmation);

/***/ }),
/* 3414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RootComponent__ = __webpack_require__(54);





var Drawer = function Drawer(_ref) {
  var children = _ref.children,
      onHide = _ref.onHide,
      style = _ref.style,
      visible = _ref.visible;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Transition */],
      { visible: visible, animation: 'fade', duration: 200 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.8)',
          zIndex: 1
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
      null,
      function (_ref2) {
        var isMobile = _ref2.isMobile;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Sidebar */],
          {
            animation: 'overlay',
            onHide: onHide,
            direction: 'right',
            visible: visible,
            style: Object.assign({
              width: isMobile ? '100%' : '80%',
              height: '100%',
              background: 'white',
              boxShadow: '0px 0px 20px rgba(0,0,0,0.5)'
            }, style || {})
          },
          children
        );
      }
    )
  );
};

var Content = function Content(_ref3) {
  var children = _ref3.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
    null,
    function (_ref4) {
      var isMobile = _ref4.isMobile;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { padding: isMobile ? '1em' : '2em', flex: 1 } },
        children
      );
    }
  );
};

var Footer = function Footer(_ref5) {
  var children = _ref5.children,
      style = _ref5.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      style: Object.assign({
        borderTop: '1px solid rgba(34,36,38,.15)',
        textAlign: 'right',
        position: 'sticky',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '1em',
        background: '#f9fafb',
        zIndex: 1
      }, style || {})
    },
    children
  );
};

Drawer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

Content.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};

Footer.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Drawer.Content = Content;
Drawer.Footer = Footer;

/* harmony default export */ __webpack_exports__["a"] = (Drawer);

/***/ }),
/* 3415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_scss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__globals_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dthc_scss__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dthc_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dthc_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_stylesheets_SlideTransition_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_stylesheets_SlideTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_stylesheets_SlideTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_onclickoutside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__variables__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Dthc = (_temp = _class = function (_React$Component) {
  _inherits(Dthc, _React$Component);

  function Dthc(props) {
    _classCallCheck(this, Dthc);

    var _this = _possibleConstructorReturn(this, (Dthc.__proto__ || Object.getPrototypeOf(Dthc)).call(this, props));

    _this.state = {
      selected: false,
      editing: false,
      openingModal: false
    };
    _this.onSelect = _this.onSelect.bind(_this);
    _this.onDeselect = _this.onDeselect.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onTap = _this.onTap.bind(_this);
    _this.closeHandler = _this.closeHandler.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(Dthc, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.initiallyOpen) this.setState({ editing: true });
      this.updateWindowDimensions();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.setState({ editing: true });
    }
  }, {
    key: 'onTap',
    value: function onTap() {
      var _this2 = this;

      if (this.state.selected) {
        this.setState({ editing: true, selected: false, openingModal: true });
        setTimeout(function () {
          _this2.setState({ openingModal: false });
        }, 300);
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      if (!this.state.openingModal && this.props.handleClickOutside) {
        this.setState({ editing: false, selected: false });
      }
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      this.setState({ selected: true });
    }
  }, {
    key: 'onDeselect',
    value: function onDeselect() {
      this.setState({ selected: false });
    }
  }, {
    key: 'closeHandler',
    value: function closeHandler() {
      this.setState({ editing: false, selected: false });
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({ window: { width: window.innerWidth, height: window.innerHeight } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          Mobile = _props.mobile,
          Desktop = _props.desktop,
          Children = _props.children,
          rest = _objectWithoutProperties(_props, ['mobile', 'desktop', 'children']);

      var desktopView = this.state.editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Desktop, _extends({
        closeHandler: this.closeHandler
      }, rest)) : Children;
      var mobileView = this.state.editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default.a,
        {
          transitionName: 'slide',
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 300
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Mobile, _extends({}, rest, {
          open: this.state.editing,
          closeHandler: this.closeHandler
        }))
      ) : Children;

      var editIconVisible = this.state.selected && !this.state.editing ? __WEBPACK_IMPORTED_MODULE_2__globals_scss___default.a.visible : __WEBPACK_IMPORTED_MODULE_2__globals_scss___default.a.invisible;

      var hoverClass = function () {
        if (_this3.state.selected && !_this3.state.editing) {
          return _this3.props.hoverClass ? _this3.props.hoverClass : __WEBPACK_IMPORTED_MODULE_4__Dthc_scss___default.a.hover;
        }
        return '';
      }();
      var iconClass = [__WEBPACK_IMPORTED_MODULE_4__Dthc_scss___default.a.cardEdit, editIconVisible].join(' ');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: this.props.style },
        this.state.window.width >= __WEBPACK_IMPORTED_MODULE_8__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            onMouseOver: this.onSelect,
            onMouseOut: this.onDeselect,
            onClick: this.onClick,
            className: __WEBPACK_IMPORTED_MODULE_2__globals_scss___default.a.desktop,
            style: { position: 'relative' }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: hoverClass },
            desktopView
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { className: iconClass, style: this.props.iconStyle, name: 'write' })
        ),
        this.state.window.width < __WEBPACK_IMPORTED_MODULE_8__variables__["a" /* default */].tabletBreakpoint && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            onMouseOver: this.onSelect,
            onMouseOut: this.onDeselect,
            onClick: this.onTap,
            className: __WEBPACK_IMPORTED_MODULE_2__globals_scss___default.a.mobile,
            style: { position: 'relative' }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: hoverClass },
            mobileView
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { className: iconClass, style: this.props.iconStyle, name: 'write' })
        )
      );
    }
  }]);

  return Dthc;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
  mobile: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  desktop: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,
  hoverClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  initiallyOpen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  iconStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  handleClickOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_onclickoutside___default()(Dthc));

/***/ }),
/* 3416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dthc_scss__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dthc_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DthcActions = function (_React$Component) {
  _inherits(DthcActions, _React$Component);

  function DthcActions() {
    _classCallCheck(this, DthcActions);

    return _possibleConstructorReturn(this, (DthcActions.__proto__ || Object.getPrototypeOf(DthcActions)).apply(this, arguments));
  }

  _createClass(DthcActions, [{
    key: 'render',
    value: function render() {
      var deleteButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          className: __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.actionsMenuSecondaryItem,
          style: { fontSize: '1.25em' }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], { name: 'trash alternate' })
      );
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.actionsMenu },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.tableCell },
          this.props.delete && !this.props.isNew && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["i" /* DeleteConfirmation */], {
            'delete': this.props.delete,
            trigger: deleteButton,
            key: this.props.id ? this.props.id : (Math.random().toString(36) + '00000000000000000').slice(2, 16 + 2)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: [__WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.actionsMenuMiddle, __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.tableCell].join(' ') },
          this.props.reset && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.actionsMenuSecondaryItem, onClick: this.props.reset },
            'Cancel'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],
          { primary: true, type: 'submit', onClick: this.props.save, className: __WEBPACK_IMPORTED_MODULE_2__Dthc_scss___default.a.tableCell },
          'Save'
        )
      );
    }
  }]);

  return DthcActions;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

DthcActions.propTypes = {
  delete: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  save: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  reset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (DthcActions);

/***/ }),
/* 3417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dthc__ = __webpack_require__(3415);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DthcContainer = function (_React$Component) {
  _inherits(DthcContainer, _React$Component);

  function DthcContainer() {
    _classCallCheck(this, DthcContainer);

    return _possibleConstructorReturn(this, (DthcContainer.__proto__ || Object.getPrototypeOf(DthcContainer)).apply(this, arguments));
  }

  _createClass(DthcContainer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Dthc__["a" /* default */], _extends({}, this.props, { outsideClickIgnoreClass: 'dthcIgnoreOnClickOutside' }));
    }
  }]);

  return DthcContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DthcContainer);

/***/ }),
/* 3418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_scss__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ModalContent = function (_React$Component) {
  _inherits(ModalContent, _React$Component);

  function ModalContent() {
    _classCallCheck(this, ModalContent);

    return _possibleConstructorReturn(this, (ModalContent.__proto__ || Object.getPrototypeOf(ModalContent)).apply(this, arguments));
  }

  _createClass(ModalContent, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: '' + __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a.mobileModalContent },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'row ' + __WEBPACK_IMPORTED_MODULE_2__Modal_scss___default.a.mobileModalBody },
          this.props.children
        )
      );
    }
  }]);

  return ModalContent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ModalContent.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ModalContent);

/***/ }),
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ModalHeader = function (_React$Component) {
  _inherits(ModalHeader, _React$Component);

  function ModalHeader() {
    _classCallCheck(this, ModalHeader);

    return _possibleConstructorReturn(this, (ModalHeader.__proto__ || Object.getPrototypeOf(ModalHeader)).apply(this, arguments));
  }

  _createClass(ModalHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'ui top fixed huge menu borderless' },
        this.props.children
      );
    }
  }]);

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ModalHeader.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 3420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(3419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Content__ = __webpack_require__(3418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_scss__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Modal_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/* eslint-disable no-did-mount-set-state */






var MobileModal = function (_React$Component) {
  _inherits(MobileModal, _React$Component);

  function MobileModal(props) {
    _classCallCheck(this, MobileModal);

    var _this = _possibleConstructorReturn(this, (MobileModal.__proto__ || Object.getPrototypeOf(MobileModal)).call(this, props));

    _this.state = {
      mounted: false
    };
    return _this;
  }

  _createClass(MobileModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted();
    }
  }, {
    key: 'mounted',
    value: function mounted() {
      this.setState({ mounted: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inline = _props.inline,
          rest = _objectWithoutProperties(_props, ['inline']);

      return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
        ref: 'mountNode',
        key: 'mountNode',
        className: 'dthcIgnoreOnClickOutside'
      }), this.state.mounted && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Modal */], _extends({
        key: 'modal',
        dimmer: 'inverted',
        className: __WEBPACK_IMPORTED_MODULE_5__Modal_scss___default.a.mobileModal,
        mountNode: inline ? this.refs.mountNode : document.body
      }, rest))];
    }
  }]);

  return MobileModal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MobileModal.propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
MobileModal.Header = __WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */];
MobileModal.Content = __WEBPACK_IMPORTED_MODULE_4__Content__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (MobileModal);

/***/ }),
/* 3421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Intent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_blueprintjs_core_dist_blueprint_css__ = __webpack_require__(3598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_blueprintjs_core_dist_blueprint_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_blueprintjs_core_dist_blueprint_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToastOverrides_scss__ = __webpack_require__(3625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToastOverrides_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ToastOverrides_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__);




var GlobalNotifications = __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["Toaster"].create({ className: 'dthcIgnoreOnClickOutside' });
var Intent = __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["Intent"];

/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_steps__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rc_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_steps_assets_index_css__ = __webpack_require__(3600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_steps_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rc_steps_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_steps_assets_iconfont_css__ = __webpack_require__(3599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_steps_assets_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rc_steps_assets_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Steps_scss__ = __webpack_require__(3626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Steps_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Steps_scss__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_rc_steps___default.a);

/***/ }),
/* 3423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_quill__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css__ = __webpack_require__(3602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextEditor_scss__ = __webpack_require__(3627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextEditor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TextEditor_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TextEditor = function TextEditor(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      extended = _ref.extended,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ['label', 'onChange', 'extended', 'value']);

  var toolbar = extended ? [['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']] : [['bold', 'italic'], ['link']];
  var formats = extended ? ['bold', 'italic', 'link', 'list'] : ['bold', 'italic', 'link'];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { marginBottom: '1em' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: __WEBPACK_IMPORTED_MODULE_4__TextEditor_scss___default.a.label },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_quill___default.a, _extends({
      theme: 'snow',
      modules: {
        clipboard: { matchVisual: false },
        toolbar: toolbar
      },
      formats: formats,
      value: value,
      onChange: onChange
    }, rest))
  );
};

TextEditor.propTypes = {
  extended: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TextEditor);

/***/ }),
/* 3424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_Document_scss__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Document_Document_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Document_Document_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_formsy_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Wizard = function (_React$Component) {
  _inherits(Wizard, _React$Component);

  function Wizard(props) {
    _classCallCheck(this, Wizard);

    var _this = _possibleConstructorReturn(this, (Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call(this, props));

    _this.state = {
      activeStep: 0,
      open: false,
      submitted: false
    };
    _this.form = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onValidSubmit = _this.onValidSubmit.bind(_this);
    _this.onInvalidSubmit = _this.onInvalidSubmit.bind(_this);
    _this.onPrimaryButtonClick = _this.onPrimaryButtonClick.bind(_this);
    _this.onSecondaryButtonClick = _this.onSecondaryButtonClick.bind(_this);
    _this.hasPreviousStep = _this.hasPreviousStep.bind(_this);
    _this.hasNextStep = _this.hasNextStep.bind(_this);
    _this.primaryButtonText = _this.primaryButtonText.bind(_this);
    _this.secondaryButtonText = _this.secondaryButtonText.bind(_this);
    _this.progress = _this.progress.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.title = _this.title.bind(_this);
    return _this;
  }

  _createClass(Wizard, [{
    key: 'onSubmit',
    value: function onSubmit(model, resetForm, invalidateForm) {
      this.setState({ submitted: true });
      var onSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.props.steps[this.state.activeStep], 'formProps.onSubmit');
      var callback = this.hasNextStep() ? this.next : this.closeModal;
      if (onSubmit) {
        onSubmit(model, resetForm, invalidateForm, callback);
      }
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit(model, resetForm, invalidateForm) {
      this.setState({ submitted: true });
      var onValidSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.props.steps[this.state.activeStep], 'formProps.onValidSubmit');
      var callback = this.hasNextStep() ? this.next : this.closeModal;
      if (onValidSubmit) {
        onValidSubmit(model, resetForm, invalidateForm, callback);
      }
    }
  }, {
    key: 'onInvalidSubmit',
    value: function onInvalidSubmit() {
      this.setState({ submitted: true });
      var onInvalidSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.props.steps[this.state.activeStep], 'formProps.onInvalidSubmit');
      if (onInvalidSubmit) onInvalidSubmit.apply(undefined, arguments);
    }
  }, {
    key: 'onSecondaryButtonClick',
    value: function onSecondaryButtonClick() {
      return this.hasPreviousStep() ? this.previous() : this.closeModal();
    }
  }, {
    key: 'onPrimaryButtonClick',
    value: function onPrimaryButtonClick() {
      var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.currentStep().actions, 'primary.type');
      if (type === 'submit') {
        this.form.current.submit();
      } else if (this.hasNextStep()) {
        this.next();
      } else {
        this.closeModal();
      }
    }
  }, {
    key: 'secondaryButtonText',
    value: function secondaryButtonText() {
      var content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.currentStep(), 'actions.secondary.content');
      if (content) {
        return content;
      } else if (this.hasPreviousStep()) {
        return 'Back';
      }
      return 'Cancel';
    }
  }, {
    key: 'primaryButtonText',
    value: function primaryButtonText() {
      var content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.currentStep(), 'actions.primary.content');
      if (content) {
        return content;
      } else if (this.hasNextStep()) {
        return 'Next';
      }
      return 'Finish';
    }
  }, {
    key: 'progress',
    value: function progress() {
      return (this.state.activeStep + 1) / this.props.steps.length * 100;
    }
  }, {
    key: 'currentStep',
    value: function currentStep() {
      return this.props.steps[this.state.activeStep];
    }
  }, {
    key: 'hasNextStep',
    value: function hasNextStep() {
      return this.state.activeStep < this.props.steps.length - 1;
    }
  }, {
    key: 'hasPreviousStep',
    value: function hasPreviousStep() {
      return this.state.activeStep > 0;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.hasNextStep()) {
        this.setState(function (prevState) {
          return {
            activeStep: prevState.activeStep + 1,
            submitted: false
          };
        });
      }
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.hasPreviousStep()) {
        this.setState(function (prevState) {
          return {
            activeStep: prevState.activeStep - 1,
            submitted: false
          };
        });
      }
    }
  }, {
    key: 'title',
    value: function title() {
      return this.props.steps[this.state.activeStep].title;
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({ open: true, activeStep: 0, submitted: false });
      if (this.props.onOpen) this.props.onOpen();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({ open: false, activeStep: 0 });
      if (this.props.onClose) this.props.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          closeIcon = _props.closeIcon,
          closeOnDimmerClick = _props.closeOnDimmerClick,
          modalSize = _props.modalSize,
          showProgress = _props.showProgress,
          trigger = _props.trigger;
      var submitted = this.state.submitted;

      var open = this.props.open || this.state.open;
      var progressBar = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Progress */], { percent: this.progress(), indicating: true });

      var _currentStep = this.currentStep(),
          actions = _currentStep.actions,
          componentProps = _currentStep.componentProps,
          formProps = _currentStep.formProps,
          hideActions = _currentStep.hideActions;

      var Component = this.currentStep().component;
      var modalContent = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_formsy_react___default.a.Form,
        _extends({}, formProps, {
          ref: this.form,
          onSubmit: this.onSubmit,
          onValidSubmit: this.onValidSubmit,
          onInvalidSubmit: this.onInvalidSubmit
        }),
        showProgress && progressBar,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, _extends({}, componentProps, {
          goBack: this.previous,
          goForward: this.next,
          onClose: this.closeModal,
          submitted: submitted
        }))
      );
      var hideSecondaryButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(actions, 'secondary.hide') && true;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return [trigger ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(trigger, {
            onClick: _this2.openModal,
            key: 'trigger'
          }) : null, !isMobile && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */],
            {
              onClose: _this2.closeModal,
              onOpen: _this2.openModal,
              open: open,
              size: modalSize || 'small',
              key: 'desktop',
              closeIcon: closeIcon,
              closeOnDimmerClick: closeOnDimmerClick
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Header, { content: _this2.title() }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Content,
              null,
              modalContent
            ),
            !hideActions && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Modal */].Actions,
              null,
              !hideSecondaryButton && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  onClick: _this2.onSecondaryButtonClick,
                  className: __WEBPACK_IMPORTED_MODULE_4__Document_Document_scss___default.a.modalSecondaryAction
                },
                _this2.secondaryButtonText()
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
                {
                  primary: true,
                  onClick: _this2.onPrimaryButtonClick,
                  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(actions, 'primary.disabled')
                },
                _this2.primaryButtonText()
              )
            )
          ), isMobile && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */],
            {
              onClose: _this2.closeModal,
              onOpen: _this2.openModal,
              open: open,
              key: 'mobile'
            },
            !hideActions && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'menu' },
                !hideSecondaryButton && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: _this2.onSecondaryButtonClick },
                  _this2.secondaryButtonText()
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Content,
              { key: 'content' },
              modalContent,
              !hideActions && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],
                {
                  primary: true,
                  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(actions, 'primary.disabled'),
                  style: { marginTop: '2em' },
                  onClick: _this2.onPrimaryButtonClick
                },
                _this2.primaryButtonText()
              )
            )
          )];
        }
      );
    }
  }]);

  return Wizard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Wizard.propTypes = {
  closeIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  closeOnDimmerClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  modalSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  showProgress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  steps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]).isRequired,
    componentProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    hideActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    actions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      primary: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
        content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
        type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
        disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
      }),
      secondary: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
        content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
        hide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
      })
    }),
    formProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      onValidSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      onInvalidSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
    })
  })).isRequired,
  trigger: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (Wizard);

/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Playlist_scss__);






var PlaylistArtwork = function PlaylistArtwork(_ref) {
  var playlist = _ref.playlist;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
    null,
    function (_ref2) {
      var isMobile = _ref2.isMobile;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: isMobile ? __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default.a.playlistThumbnailMobile : __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default.a.playlistThumbnail
        },
        !playlist.thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'music' }),
        playlist.thumbnail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { src: playlist.thumbnail.url })
      );
    }
  );
};

PlaylistArtwork.propTypes = {
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PlaylistArtwork);

/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Playlist_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SelectPlaylist = function (_React$Component) {
  _inherits(SelectPlaylist, _React$Component);

  function SelectPlaylist(props) {
    _classCallCheck(this, SelectPlaylist);

    var _this = _possibleConstructorReturn(this, (SelectPlaylist.__proto__ || Object.getPrototypeOf(SelectPlaylist)).call(this, props));

    _this.state = {
      query: ''
    };
    _this.filterByQuery = _this.filterByQuery.bind(_this);
    _this.removeLinks = _this.removeLinks.bind(_this);
    return _this;
  }

  _createClass(SelectPlaylist, [{
    key: 'filterByQuery',
    value: function filterByQuery(playlists) {
      var query = this.state.query;

      return playlists.filter(function (playlist) {
        return playlist.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    }
  }, {
    key: 'removeLinks',
    value: function removeLinks(str) {
      return str.replace(/<\/?a[^>]*>/g, '');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          goForward = _props.goForward,
          onClose = _props.onClose,
          playlists = _props.playlists,
          selectedPlaylistId = _props.selectedPlaylistId,
          onPlaylistSelect = _props.onPlaylistSelect;
      var query = this.state.query;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: onClose },
                  'Cancel'
                )
              ),
              selectedPlaylistId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: goForward },
                  'Next'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Select a playlist'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
              name: 'search',
              type: 'text',
              size: 'small',
              icon: {
                name: query === '' ? 'search' : 'close',
                onClick: function onClick() {
                  return _this2.setState({ query: '' });
                },
                link: query !== ''
              },
              placeholder: 'Filter...',
              onChange: function onChange(e) {
                return _this2.setState({ query: e.target.value });
              },
              value: query,
              style: { marginBottom: '1em' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: isMobile ? {} : { maxHeight: '300px', overflowY: 'auto' }
              },
              _this2.filterByQuery(playlists).map(function (playlist, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__Elements__["g" /* SelectableBlock */],
                  {
                    key: index,
                    radio: true,
                    checked: selectedPlaylistId === playlist.id,
                    onChange: function onChange() {
                      return onPlaylistSelect(playlist.id);
                    },
                    style: { marginBottom: '1em' }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        className: __WEBPACK_IMPORTED_MODULE_6__Playlist_scss___default.a.songThumbnail,
                        style: { minWidth: '64px' }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { src: 'https://mosaic.scdn.co/60/ab67616d0000b273146f0228683dc97769498290ab67616d0000b273365b3fb800c19f7ff72602daab67616d0000b273a6a335d613d151c626895a83ab67616d0000b273d785fa246cca092598fe3c3b' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { marginLeft: '1em', wordBreak: 'break-word' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        playlist.name
                      ),
                      playlist.description !== '' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: __WEBPACK_IMPORTED_MODULE_6__Playlist_scss___default.a.muted, style: { margin: 0 } },
                        _this2.removeLinks(playlist.description)
                      )
                    )
                  )
                );
              })
            ),
            !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: '2em', textAlign: 'right' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  className: __WEBPACK_IMPORTED_MODULE_6__Playlist_scss___default.a.muted,
                  style: { cursor: 'pointer', marginRight: '2em' },
                  onClick: onClose
                },
                'Cancel'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                primary: true,
                content: 'Next',
                disabled: !selectedPlaylistId,
                onClick: goForward
              })
            )
          );
        }
      );
    }
  }]);

  return SelectPlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectPlaylist.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playlists: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  selectedPlaylistId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onPlaylistSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (SelectPlaylist);

/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immer__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Playlist_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SelectSongs = function (_React$Component) {
  _inherits(SelectSongs, _React$Component);

  function SelectSongs(props) {
    _classCallCheck(this, SelectSongs);

    var _this = _possibleConstructorReturn(this, (SelectSongs.__proto__ || Object.getPrototypeOf(SelectSongs)).call(this, props));

    _this.state = {
      items: null,
      query: '',
      submitting: false
    };
    _this.onSuccess = _this.onSuccess.bind(_this);
    _this.onError = _this.onError.bind(_this);
    _this.getPlaylistItems = _this.getPlaylistItems.bind(_this);
    _this.getTotalSelected = _this.getTotalSelected.bind(_this);
    _this.addSelectedSongs = _this.addSelectedSongs.bind(_this);
    _this.filterByQuery = _this.filterByQuery.bind(_this);
    _this.selectAll = _this.selectAll.bind(_this);
    _this.selectNone = _this.selectNone.bind(_this);
    _this.toggleSong = _this.toggleSong.bind(_this);
    return _this;
  }

  _createClass(SelectSongs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getPlaylistItems({ playlistId: this.props.selectedPlaylistId });
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess() {
      this.setState({ submitting: false });
      this.props.onClose();
    }
  }, {
    key: 'onError',
    value: function onError() {
      this.setState({ submitting: false });
    }
  }, {
    key: 'getPlaylistItems',
    value: function getPlaylistItems(_ref) {
      var _this2 = this;

      var playlistId = _ref.playlistId,
          _ref$limit = _ref.limit,
          limit = _ref$limit === undefined ? 100 : _ref$limit,
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          _ref$items = _ref.items,
          items = _ref$items === undefined ? [] : _ref$items;

      var config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('spotify_access_token')
        },
        params: { limit: limit, offset: offset }
      };
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://api.spotify.com/v1/playlists/' + playlistId + '/tracks', config).then(function (response) {
        if (response.data.next) {
          _this2.getPlaylistItems({
            limit: limit,
            playlistId: playlistId,
            offset: offset + limit,
            items: items.concat(response.data.items)
          });
        } else {
          _this2.setState({
            items: items.concat(response.data.items).map(function (item) {
              return Object.assign({ selected: true }, item);
            }),
            selectPlaylistOpen: true
          });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _this2.props.authenticateSpotify(function () {
            return _this2.getPlaylistItems({ playlistId: playlistId });
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* GlobalNotifications */].show({
            message: 'Unable to get playlist from Spotify',
            intent: __WEBPACK_IMPORTED_MODULE_4__Modules__["b" /* Intent */].DANGER
          });
        }
      });
    }
  }, {
    key: 'getTotalSelected',
    value: function getTotalSelected() {
      return this.state.items.filter(function (item) {
        return item.selected;
      }).length;
    }
  }, {
    key: 'addSelectedSongs',
    value: function addSelectedSongs(e) {
      var items = this.state.items;

      var tracks = items.filter(function (item) {
        return item.selected;
      }).map(function (_ref2) {
        var track = _ref2.track;
        return track;
      });
      var songs = tracks.map(function (track) {
        return {
          name: track.name,
          album: track.album.name,
          artist: track.artists[0].name,
          duration_ms: track.duration_ms,
          isrc: track.external_ids.isrc,
          song_images: {
            edges: track.album.images.map(function (image) {
              return { node: image };
            })
          },
          external_data: JSON.stringify(track),
          external_source: 'spotify',
          external_id: track.id
        };
      });
      this.setState({ submitting: true });
      this.props.addToPlaylist(e, songs, null, this.onSuccess, this.onError);
    }
  }, {
    key: 'toggleSong',
    value: function toggleSong(trackId) {
      this.setState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immer__["a" /* produce */])(function (draft) {
        draft.items.map(function (item) {
          if (item.track.id === trackId) {
            /* eslint-disable no-param-reassign */
            item.selected = !item.selected;
          }
          return item;
        });
      }));
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      this.setState({
        items: this.state.items.map(function (item) {
          return Object.assign({}, item, { selected: true });
        })
      });
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      this.setState({
        items: this.state.items.map(function (item) {
          return Object.assign({}, item, { selected: false });
        })
      });
    }
  }, {
    key: 'filterByQuery',
    value: function filterByQuery(items) {
      var query = this.state.query;

      return items.filter(function (item) {
        return item.track.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var goBack = this.props.goBack;
      var _state = this.state,
          items = _state.items,
          query = _state.query,
          submitting = _state.submitting;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref3) {
          var isMobile = _ref3.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: goBack },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    onClick: submitting ? null : _this3.addSelectedSongs
                  },
                  submitting ? 'Importing...' : 'Import'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Select the songs you would like to import'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: { display: isMobile ? null : 'flex', marginBottom: '1em' }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
                  name: 'search',
                  type: 'text',
                  size: 'small',
                  icon: {
                    name: query === '' ? 'search' : 'close',
                    onClick: function onClick() {
                      return _this3.setState({ query: '' });
                    },
                    link: query !== ''
                  },
                  placeholder: 'Filter...',
                  onChange: function onChange(e) {
                    return _this3.setState({ query: e.target.value });
                  },
                  value: query,
                  style: { marginBottom: '1em' }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: _this3.selectAll },
                  'Select All'
                ),
                ' \xA0/\xA0\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: _this3.selectNone },
                  'Deselect All'
                ),
                items && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    style: isMobile ? { marginTop: '0.5em' } : { textAlign: 'right' },
                    className: __WEBPACK_IMPORTED_MODULE_7__Playlist_scss___default.a.muted
                  },
                  'Total Selected: ',
                  _this3.getTotalSelected()
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                style: isMobile ? {} : { maxHeight: '300px', overflowY: 'auto' }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */],
                { striped: true, stackable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Body,
                  null,
                  items && _this3.filterByQuery(items).map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Row,
                      {
                        key: item.track.id,
                        onClick: function onClick() {
                          return _this3.toggleSong(item.track.id);
                        },
                        style: { cursor: 'pointer' }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Table */].Cell,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          {
                            style: { display: 'flex', alignItems: 'center' }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { flex: 1 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'strong',
                              null,
                              item.track.name
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'p',
                              { className: __WEBPACK_IMPORTED_MODULE_7__Playlist_scss___default.a.muted },
                              item.track.artists[0].name
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["i" /* Checkbox */], { checked: item.selected })
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            !items && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'loading'
            ),
            !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: '2em', textAlign: 'right' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  className: __WEBPACK_IMPORTED_MODULE_7__Playlist_scss___default.a.muted,
                  style: { cursor: 'pointer', marginRight: '2em' },
                  onClick: goBack
                },
                'Back'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                primary: true,
                content: submitting ? 'Importing...' : 'Import',
                disabled: submitting,
                onClick: _this3.addSelectedSongs
              })
            )
          );
        }
      );
    }
  }]);

  return SelectSongs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectSongs.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  authenticateSpotify: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedPlaylistId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (SelectSongs);

/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_spotify_icon_green_svg__ = __webpack_require__(3659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_spotify_icon_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_spotify_icon_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectPlaylist__ = __webpack_require__(3426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectSongs__ = __webpack_require__(3427);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ImportPlaylist = function (_Component) {
  _inherits(ImportPlaylist, _Component);

  function ImportPlaylist(props) {
    _classCallCheck(this, ImportPlaylist);

    var _this = _possibleConstructorReturn(this, (ImportPlaylist.__proto__ || Object.getPrototypeOf(ImportPlaylist)).call(this, props));

    _this.state = {
      selectPlaylistOpen: false
    };
    _this.getPlaylists = _this.getPlaylists.bind(_this);
    _this.authenticateSpotify = _this.authenticateSpotify.bind(_this);
    _this.browseSpotifyPlaylists = _this.browseSpotifyPlaylists.bind(_this);
    return _this;
  }

  _createClass(ImportPlaylist, [{
    key: 'getPlaylists',
    value: function getPlaylists(_ref) {
      var _this2 = this;

      var _ref$limit = _ref.limit,
          limit = _ref$limit === undefined ? 50 : _ref$limit,
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          _ref$playlists = _ref.playlists,
          playlists = _ref$playlists === undefined ? [] : _ref$playlists;

      var config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('spotify_access_token')
        },
        params: { limit: limit, offset: offset }
      };
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://api.spotify.com/v1/me/playlists', config).then(function (response) {
        if (response.data.next) {
          _this2.getPlaylists({
            limit: limit,
            offset: offset + limit,
            playlists: playlists.concat(response.data.items)
          });
        } else {
          _this2.setState({
            spotifyPlaylists: playlists.concat(response.data.items),
            selectPlaylistOpen: true
          });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _this2.authenticateSpotify(function () {
            return _this2.getPlaylists({});
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__Modules__["a" /* GlobalNotifications */].show({
            message: 'Unable to connect to Spotify',
            intent: __WEBPACK_IMPORTED_MODULE_5__Modules__["b" /* Intent */].DANGER
          });
        }
      });
    }
  }, {
    key: 'authenticateSpotify',
    value: function authenticateSpotify(onSuccess, onError) {
      localStorage.removeItem('spotify_access_token');
      var spotifyAuth = window.open('https://accounts.spotify.com/en/authorize?client_id=' + "6bee432e89a046a6927b6d9e824c6511" + '&redirect_uri=' + encodeURIComponent("https://www.cloverbook.com") + '%2Fspotify&scope=playlist-read-private+playlist-read-collaborative&response_type=token&show_dialog=true');
      var timer = setInterval(function () {
        if (spotifyAuth.closed) {
          clearInterval(timer);
          if (localStorage.getItem('spotify_access_token')) {
            if (onSuccess) onSuccess();
          } else {
            if (onError) onError();
          }
        }
      }, 1000);
    }
  }, {
    key: 'browseSpotifyPlaylists',
    value: function browseSpotifyPlaylists() {
      this.getPlaylists({});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          spotifyPlaylists = _state.spotifyPlaylists,
          selectPlaylistOpen = _state.selectPlaylistOpen,
          selectedPlaylistId = _state.selectedPlaylistId;
      var _props = this.props,
          addToPlaylist = _props.addToPlaylist,
          importSpotifyRef = _props.importSpotifyRef;

      var title = 'Import Playlist from Spotify';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */],
          {
            button: true,
            basic: true,
            icon: 'plus',
            compact: true,
            className: 'icon selection',
            floating: true,
            style: { padding: '0.75em' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Menu,
            { style: { left: 'auto', right: 0, width: 'auto' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Header, { content: 'Import From' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["p" /* Ref */],
              { innerRef: importSpotifyRef },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Dropdown */].Item,
                { onClick: this.browseSpotifyPlaylists },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Image */], { style: { marginRight: '0.5em' }, src: __WEBPACK_IMPORTED_MODULE_3__assets_spotify_icon_green_svg___default.a }),
                  'Spotify'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modules__["e" /* Wizard */], {
          steps: [{
            component: __WEBPACK_IMPORTED_MODULE_6__SelectPlaylist__["a" /* default */],
            componentProps: {
              playlists: spotifyPlaylists || [],
              selectedPlaylistId: selectedPlaylistId,
              onPlaylistSelect: function onPlaylistSelect(id) {
                return _this3.setState({ selectedPlaylistId: id });
              }
            },
            hideActions: true,
            title: title
          }, {
            component: __WEBPACK_IMPORTED_MODULE_7__SelectSongs__["a" /* default */],
            componentProps: {
              addToPlaylist: addToPlaylist,
              selectedPlaylistId: selectedPlaylistId,
              authenticateSpotify: this.authenticateSpotify
            },
            hideActions: true,
            title: title
          }],
          open: selectPlaylistOpen,
          onClose: function onClose() {
            return _this3.setState({
              selectPlaylistOpen: false,
              selectedPlaylistId: null
            });
          }
        })
      );
    }
  }]);

  return ImportPlaylist;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ImportPlaylist.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  importSpotifyRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ImportPlaylist);

/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_UserPlaylistQuery__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MyPlaylists__ = __webpack_require__(3431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DiscoverPlaylists__ = __webpack_require__(3430);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AddRecommendations = function (_React$Component) {
  _inherits(AddRecommendations, _React$Component);

  function AddRecommendations(props) {
    _classCallCheck(this, AddRecommendations);

    var _this = _possibleConstructorReturn(this, (AddRecommendations.__proto__ || Object.getPrototypeOf(AddRecommendations)).call(this, props));

    _this.state = {
      activeTab: _this.getMyPlaylists().length > 0 ? 'my' : 'discover'
    };
    _this.getActivePlaylist = _this.getActivePlaylist.bind(_this);
    _this.getAllPlaylists = _this.getAllPlaylists.bind(_this);
    _this.getMyPlaylists = _this.getMyPlaylists.bind(_this);
    _this.getPublicPlaylists = _this.getPublicPlaylists.bind(_this);
    _this.isSelected = _this.isSelected.bind(_this);
    return _this;
  }

  _createClass(AddRecommendations, [{
    key: 'getActivePlaylist',
    value: function getActivePlaylist() {
      var _this2 = this;

      var filtered = this.getAllPlaylists().filter(function (p) {
        return p.node.id === _this2.props.activePlaylist;
      });
      return filtered[0].node;
    }
  }, {
    key: 'getAllPlaylists',
    value: function getAllPlaylists() {
      return this.props.viewer.public_playlists.edges.concat(this.props.viewer.playlists.edges);
    }
  }, {
    key: 'getMyPlaylists',
    value: function getMyPlaylists() {
      var _this3 = this;

      return this.props.viewer.playlists.edges.filter(function (p) {
        return !_this3.getPublicPlaylists().map(function (publicPlaylist) {
          return publicPlaylist.node.id;
        }).includes(p.node.id);
      });
    }
  }, {
    key: 'getPublicPlaylists',
    value: function getPublicPlaylists() {
      return this.props.viewer.public_playlists.edges;
    }
  }, {
    key: 'isSelected',
    value: function isSelected(playlistId) {
      return this.props.playlistRecommendations.map(function (_ref) {
        var r = _ref.node;
        return r.id;
      }).includes(playlistId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          activePlaylist = _props.activePlaylist,
          onClose = _props.onClose,
          parentID = _props.parentID,
          relay = _props.relay,
          togglePlaylist = _props.togglePlaylist,
          viewPlaylist = _props.viewPlaylist,
          viewer = _props.viewer;
      var activeTab = this.state.activeTab;


      var Tabs = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref2) {
          var isMobile = _ref2.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */],
            {
              secondary: true,
              pointing: true,
              style: { marginTop: isMobile ? '48px' : 'auto' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */].Item, {
              name: 'Discover',
              onClick: function onClick() {
                return _this4.setState({ activeTab: 'discover' });
              },
              active: activeTab === 'discover'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["o" /* Menu */].Item, {
              name: 'My Playlists',
              onClick: function onClick() {
                return _this4.setState({ activeTab: 'my' });
              },
              active: activeTab === 'my'
            })
          );
        }
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref3) {
          var isMobile = _ref3.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { display: 'flex', flexDirection: 'column', height: '100%' }
            },
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'item',
                    onClick: activePlaylist ? function () {
                      return viewPlaylist(null, null);
                    } : onClose
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              )
            ),
            !activePlaylist && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: isMobile ? '1em' : '2em' } },
                Tabs
              ),
              activeTab === 'my' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MyPlaylists__["a" /* default */], {
                playlists: _this4.getMyPlaylists(),
                togglePlaylist: togglePlaylist,
                isSelected: _this4.isSelected,
                onClose: onClose,
                relay: relay,
                viewer: viewer,
                parentID: parentID
              }),
              activeTab === 'discover' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DiscoverPlaylists__["a" /* default */], {
                playlists: _this4.getPublicPlaylists(),
                togglePlaylist: togglePlaylist,
                isSelected: _this4.isSelected,
                onClose: onClose
              })
            ),
            activePlaylist && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              !isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: function onClick() {
                      return viewPlaylist(null, null);
                    } },
                  '< Back to Playlists'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App_UserPlaylistQuery__["a" /* default */], {
                playlistId: _this4.getActivePlaylist().id,
                relay: relay,
                parentID: parentID,
                goBack: function goBack() {
                  return viewPlaylist(null, null);
                }
              })
            )
          );
        }
      );
    }
  }]);

  return AddRecommendations;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AddRecommendations.propTypes = {
  activePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  parentID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  playlistRecommendations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  togglePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  viewPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AddRecommendations);

/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectablePlaylist__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);






var DiscoverPlaylists = function DiscoverPlaylists(_ref) {
  var isSelected = _ref.isSelected,
      onClose = _ref.onClose,
      playlists = _ref.playlists,
      togglePlaylist = _ref.togglePlaylist;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Modules__["d" /* Drawer */].Content,
      null,
      playlists.map(function (_ref2) {
        var playlist = _ref2.node;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SelectablePlaylist__["a" /* default */], {
          playlist: playlist,
          key: playlist.id,
          togglePlaylist: togglePlaylist,
          isSelected: isSelected
        });
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Modules__["d" /* Drawer */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["b" /* Button */], {
        onClick: onClose,
        primary: true,
        content: 'Done'
      })
    )
  );
};

DiscoverPlaylists.propTypes = {
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playlists: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  togglePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DiscoverPlaylists);

/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectablePlaylist__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_UserPlaylistQuery__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Thumbnail__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_pencil_icon_svg__ = __webpack_require__(3645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_pencil_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_pencil_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_relay__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _graphql2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MyPlaylists = function (_React$Component) {
  _inherits(MyPlaylists, _React$Component);

  function MyPlaylists(props) {
    _classCallCheck(this, MyPlaylists);

    var _this = _possibleConstructorReturn(this, (MyPlaylists.__proto__ || Object.getPrototypeOf(MyPlaylists)).call(this, props));

    _this.state = {
      activePlaylist: null,
      managePlaylists: false
    };
    _this.getActionText = _this.getActionText.bind(_this);
    _this.backAction = _this.backAction.bind(_this);
    _this.createPlaylist = _this.createPlaylist.bind(_this);
    _this.deletePlaylist = _this.deletePlaylist.bind(_this);
    return _this;
  }

  _createClass(MyPlaylists, [{
    key: 'getActionText',
    value: function getActionText() {
      var _state = this.state,
          activePlaylist = _state.activePlaylist,
          managePlaylists = _state.managePlaylists;

      return managePlaylists && !activePlaylist ? 'Back To Recommendations' : 'Done';
    }
  }, {
    key: 'backAction',
    value: function backAction() {
      var _state2 = this.state,
          activePlaylist = _state2.activePlaylist,
          managePlaylists = _state2.managePlaylists;

      if (managePlaylists) {
        if (activePlaylist) {
          this.setState({ activePlaylist: null });
        } else {
          this.setState({ managePlaylists: false });
        }
      } else {
        this.props.onClose();
      }
    }
  }, {
    key: 'createPlaylist',
    value: function createPlaylist(playlist, successCb, failureCb) {
      var _this2 = this;

      var onError = function onError() {
        if (failureCb) failureCb();
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to add playlist',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };
      var onCompleted = function onCompleted(response) {
        if (successCb) successCb();
        _this2.setState({
          activePlaylist: response.createPlaylist.new_playlist_edge.node.id
        });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('created-playlist');
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3434);
      });

      var parentID = this.props.viewer.id;

      var configs = [{
        type: 'RANGE_ADD',
        parentID: parentID,
        edgeName: 'new_playlist_edge',
        connectionInfo: [{
          key: 'PlaylistsContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'PlannerPlaylistContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'MpTemplateContainer_playlists',
          rangeBehavior: 'append'
        }]
      }];

      var environment = this.props.relay.environment;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            title: '(Untitled Playlist)'
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'deletePlaylist',
    value: function deletePlaylist() {
      var _this3 = this;

      var onError = function onError() {
        __WEBPACK_IMPORTED_MODULE_6__Modules__["a" /* GlobalNotifications */].show({
          message: 'Unable to delete playlist',
          intent: __WEBPACK_IMPORTED_MODULE_6__Modules__["b" /* Intent */].DANGER
        });
      };

      var onCompleted = function onCompleted() {
        _this3.setState({ activePlaylist: null });
        __WEBPACK_IMPORTED_MODULE_6__Modules__["c" /* Analytics */].trackEvent('deleted-playlist');
      };

      var mutation = _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(3435);
      });

      var environment = this.props.relay.environment;

      var configs = [{
        type: 'RANGE_DELETE',
        parentID: this.props.viewer.id,
        pathToConnection: ['viewer', 'playlists'],
        deletedIDFieldName: 'deletedPlaylistId',
        connectionKeys: [{
          key: 'PlaylistsContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'PlannerPlaylistContainer_playlists',
          rangeBehavior: 'append'
        }, {
          key: 'MpTemplateContainer_playlists',
          rangeBehavior: 'append'
        }]
      }];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: {
          input: {
            id: this.state.activePlaylist
          }
        },
        configs: configs,
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          isSelected = _props.isSelected,
          parentID = _props.parentID,
          playlists = _props.playlists,
          relay = _props.relay,
          togglePlaylist = _props.togglePlaylist;
      var _state3 = this.state,
          activePlaylist = _state3.activePlaylist,
          managePlaylists = _state3.managePlaylists;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref) {
          var isMobile = _ref.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: _this4.backAction },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["d" /* Drawer */].Content,
              null,
              !managePlaylists && playlists.map(function (_ref2) {
                var playlist = _ref2.node;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SelectablePlaylist__["a" /* default */], {
                  playlist: playlist,
                  key: playlist.id,
                  togglePlaylist: togglePlaylist,
                  isSelected: isSelected
                });
              }),
              managePlaylists && !activePlaylist && playlists.map(function (_ref3) {
                var playlist = _ref3.node;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Thumbnail__["a" /* default */], {
                  key: playlist.id,
                  playlist: playlist,
                  onClick: function onClick() {
                    return _this4.setState({ activePlaylist: playlist.id });
                  },
                  actionIcon: __WEBPACK_IMPORTED_MODULE_8__assets_pencil_icon_svg___default.a,
                  action: function action() {
                    return _this4.setState({ activePlaylist: playlist.id });
                  },
                  actionClassName: __WEBPACK_IMPORTED_MODULE_9__Playlist_scss___default.a.toggleRecommendation
                });
              }),
              managePlaylists && activePlaylist && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App_UserPlaylistQuery__["a" /* default */], {
                playlistId: activePlaylist,
                relay: relay,
                parentID: parentID,
                showControls: true,
                deletePlaylist: _this4.deletePlaylist,
                goBack: function goBack() {
                  return _this4.setState({ activePlaylist: null });
                }
              }),
              managePlaylists && !activePlaylist && playlists.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { marginTop: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { onClick: _this4.createPlaylist },
                  '+ Add Playlist'
                )
              ),
              playlists.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '2em', textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  'You have no playlists'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'You have no playlists saved to your account.',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  'Get started by creating your first playlist.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  primary: true,
                  icon: 'plus',
                  onClick: function onClick() {
                    _this4.setState({ managePlaylists: true });
                    _this4.createPlaylist();
                  },
                  labelPosition: 'left',
                  content: 'Create Playlist'
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__Modules__["d" /* Drawer */].Footer,
              null,
              !managePlaylists && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                icon: 'pencil',
                basic: true,
                content: 'Edit Playlists',
                onClick: function onClick() {
                  return _this4.setState({ managePlaylists: true });
                },
                style: { marginRight: '1em' }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                onClick: _this4.backAction,
                primary: true,
                content: _this4.getActionText()
              })
            )
          );
        }
      );
    }
  }]);

  return MyPlaylists;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MyPlaylists.propTypes = {
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  parentID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  playlists: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  togglePlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MyPlaylists);

/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(3437);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
  node: function node() {
    return __webpack_require__(3436);
  }
}));

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddRecommendations__ = __webpack_require__(3429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_circle_close_icon_svg__ = __webpack_require__(3637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_circle_close_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_circle_close_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Thumbnail__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_UserPlaylistQuery__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RecommendationContainer__ = __webpack_require__(3432);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PlaylistRecommendations = function (_React$Component) {
  _inherits(PlaylistRecommendations, _React$Component);

  function PlaylistRecommendations(props) {
    _classCallCheck(this, PlaylistRecommendations);

    var _this = _possibleConstructorReturn(this, (PlaylistRecommendations.__proto__ || Object.getPrototypeOf(PlaylistRecommendations)).call(this, props));

    _this.recommendationsRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();

    _this.state = {
      activePlaylist: null,
      addRecommendationsOpen: false,
      scrolledToEnd: false
    };
    _this.getAllPlaylists = _this.getAllPlaylists.bind(_this);
    _this.isSelected = _this.isSelected.bind(_this);
    _this.hasOverflow = _this.hasOverflow.bind(_this);
    _this.scrollX = _this.scrollX.bind(_this);
    _this.viewPlaylist = _this.viewPlaylist.bind(_this);
    _this.togglePlaylist = _this.togglePlaylist.bind(_this);
    _this.updateScrollPosition = _this.updateScrollPosition.bind(_this);
    return _this;
  }

  _createClass(PlaylistRecommendations, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Force re-render after DOM has loaded recommendations carousel
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ scrolledToBeginning: true });
      this.recommendationsRef.current.addEventListener('scroll', this.updateScrollPosition);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.recommendationsRef.current.removeEventListener('scroll', this.updateScrollPosition);
    }
  }, {
    key: 'getAllPlaylists',
    value: function getAllPlaylists() {
      return this.props.viewer.public_playlists.edges.concat(this.props.viewer.playlists.edges);
    }
  }, {
    key: 'isSelected',
    value: function isSelected(playlistId) {
      return this.props.playlistRecommendations.map(function (_ref) {
        var r = _ref.node;
        return r.id;
      }).includes(playlistId);
    }
  }, {
    key: 'hasOverflow',
    value: function hasOverflow(numItems) {
      var current = this.recommendationsRef.current;

      var itemWidth = 174;
      if (current && numItems * itemWidth > current.offsetWidth) {
        return true;
      }
      return false;
    }
  }, {
    key: 'scrollX',
    value: function scrollX(distance) {
      var current = this.recommendationsRef.current;

      current.scrollTo({
        left: current.scrollLeft + distance,
        top: 0,
        behavior: 'smooth'
      });
      this.updateScrollPosition();
    }
  }, {
    key: 'togglePlaylist',
    value: function togglePlaylist(e, data) {
      var id = data.value;
      if (this.isSelected(id)) {
        this.props.removePlaylistRecommendation(id);
      } else {
        this.props.addPlaylistRecommendations([id]);
      }
    }
  }, {
    key: 'viewPlaylist',
    value: function viewPlaylist(e, id) {
      this.setState({ activePlaylist: id });
    }
  }, {
    key: 'updateScrollPosition',
    value: function updateScrollPosition() {
      var current = this.recommendationsRef.current;

      this.setState({
        scrolledToBeginning: current.scrollLeft === 0,
        scrolledToEnd: current.scrollLeft + this.recommendationsRef.current.offsetWidth === this.recommendationsRef.current.scrollWidth
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          addToPlaylist = _props.addToPlaylist,
          playlistRecommendations = _props.playlistRecommendations,
          removePlaylistRecommendation = _props.removePlaylistRecommendation,
          editable = _props.editable,
          relay = _props.relay,
          viewer = _props.viewer;
      var _state = this.state,
          activePlaylist = _state.activePlaylist,
          addRecommendationsOpen = _state.addRecommendationsOpen,
          scrolledToBeginning = _state.scrolledToBeginning,
          scrolledToEnd = _state.scrolledToEnd;

      var AddRecommendationsWizard = editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modules__["d" /* Drawer */],
          {
            visible: addRecommendationsOpen,
            onHide: function onHide() {}
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AddRecommendations__["a" /* default */], {
            activePlaylist: activePlaylist,
            playlistRecommendations: playlistRecommendations,
            viewer: viewer,
            relay: relay,
            parentID: this.props.playlist.id,
            togglePlaylist: this.togglePlaylist,
            viewPlaylist: this.viewPlaylist,
            onClose: function onClose() {
              return _this2.setState({
                addRecommendationsOpen: false,
                activePlaylist: null
              });
            }
          })
        )
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref2) {
          var isMobile = _ref2.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: '3em', position: 'relative' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: __WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default.a.playlistLabel },
              'Recommended Music',
              _this2.hasOverflow(playlistRecommendations.length) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { position: 'absolute', right: 0, top: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], {
                  name: 'chevron left',
                  style: {
                    cursor: !scrolledToBeginning ? 'pointer' : null,
                    color: scrolledToBeginning ? '#DEDEDF' : null,
                    transition: 'color 0.2s ease-in-out'
                  },
                  onClick: _this2.scrollX.bind(null, -300)
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["d" /* Icon */], {
                  name: 'chevron right',
                  style: {
                    cursor: !scrolledToEnd ? 'pointer' : null,
                    marginLeft: '0.5em',
                    color: scrolledToEnd ? '#DEDEDF' : null,
                    transition: 'color 0.2s ease-in-out'
                  },
                  onClick: _this2.scrollX.bind(null, 300)
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default.a.recommendations,
                ref: _this2.recommendationsRef
              },
              playlistRecommendations.map(function (_ref3) {
                var playlist = _ref3.node;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["e" /* Wizard */], {
                  closeIcon: true,
                  key: playlist.id,
                  steps: [{
                    component: __WEBPACK_IMPORTED_MODULE_8__App_UserPlaylistQuery__["a" /* default */],
                    componentProps: {
                      addToPlaylist: addToPlaylist,
                      playlistId: playlist.id,
                      relay: relay,
                      parent: _this2.props.playlist,
                      component: __WEBPACK_IMPORTED_MODULE_10__RecommendationContainer__["a" /* default */]
                    },
                    title: 'Browse Recommendations',
                    hideActions: true
                  }],
                  trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Thumbnail__["a" /* default */], {
                    playlist: playlist,
                    action: editable ? removePlaylistRecommendation : null,
                    actionClassName: [__WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default.a.deleteRecommendation, isMobile ? null : __WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default.a.showOnHover].join(' '),
                    actionIcon: __WEBPACK_IMPORTED_MODULE_6__assets_circle_close_icon_svg___default.a
                  }),
                  onClose: function onClose() {
                    return _this2.setState({ viewPlaylist: null });
                  }
                });
              }),
              editable && playlistRecommendations.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_2__Playlist_scss___default.a.emptyList },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'You have not recommended any music to your clients.',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  'Give them some inspiration by',
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                      onClick: function onClick() {
                        return _this2.setState({ addRecommendationsOpen: true });
                      }
                    },
                    'recommending a playlist'
                  ),
                  '.'
                )
              )
            ),
            editable && playlistRecommendations.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                onClick: function onClick() {
                  return _this2.setState({ addRecommendationsOpen: true });
                }
              },
              'Edit Recommendations'
            ),
            AddRecommendationsWizard
          );
        }
      );
    }
  }]);

  return PlaylistRecommendations;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PlaylistRecommendations.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addPlaylistRecommendations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  removePlaylistRecommendation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playlistRecommendations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (PlaylistRecommendations);

/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bdc66daa956fb167163f86f8aa61f0cd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePlaylistInput = {
  clientMutationId?: ?string,
  title: string,
  description?: ?string,
};
export type MyPlaylists_createPlaylistMutationVariables = {|
  input: CreatePlaylistInput
|};
export type MyPlaylists_createPlaylistMutationResponse = {|
  +createPlaylist: ?{|
    +new_playlist_edge: ?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +can_edit: ?boolean,
        +playlist_songs: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string
            |}
          |}>
        |},
      |}
    |}
  |}
|};
export type MyPlaylists_createPlaylistMutation = {|
  variables: MyPlaylists_createPlaylistMutationVariables,
  response: MyPlaylists_createPlaylistMutationResponse,
|};
*/

/*
mutation MyPlaylists_createPlaylistMutation(
  $input: CreatePlaylistInput!
) {
  createPlaylist(input: $input) {
    new_playlist_edge {
      node {
        id
        title
        description
        can_edit
        playlist_songs(first: 99999) {
          edges {
            node {
              id
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v6 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PlaylistSongEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistSong",
      "plural": false,
      "selections": [v2, {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }]
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "cursor",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  }],
      v7 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MyPlaylists_createPlaylistMutation",
    "id": null,
    "text": "mutation MyPlaylists_createPlaylistMutation(\n  $input: CreatePlaylistInput!\n) {\n  createPlaylist(input: $input) {\n    new_playlist_edge {\n      node {\n        id\n        title\n        description\n        can_edit\n        playlist_songs(first: 99999) {\n          edges {\n            node {\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["createPlaylist", "new_playlist_edge", "node", "playlist_songs"]
      }]
    },
    "fragment": {
      "kind": "Fragment",
      "name": "MyPlaylists_createPlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": "playlist_songs",
              "name": "__UserPlaylistContainer_playlist_songs_connection",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistSongConnection",
              "plural": false,
              "selections": v6
            }]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "MyPlaylists_createPlaylistMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "new_playlist_edge",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [v2, v3, v4, v5, {
              "kind": "LinkedField",
              "alias": null,
              "name": "playlist_songs",
              "storageKey": "playlist_songs(first:99999)",
              "args": v7,
              "concreteType": "PlaylistSongConnection",
              "plural": false,
              "selections": v6
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "playlist_songs",
              "args": v7,
              "handle": "connection",
              "key": "UserPlaylistContainer_playlist_songs",
              "filters": null
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4373263a578db7bd946d2820b3f32d5b';
module.exports = node;

/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash e6bd42018fa0f34679148b3ca8718e53
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type MyPlaylists_deletePlaylistMutationVariables = {|
  input: DeletePlaylistInput
|};
export type MyPlaylists_deletePlaylistMutationResponse = {|
  +deletePlaylist: ?{|
    +deletedPlaylistId: ?string
  |}
|};
export type MyPlaylists_deletePlaylistMutation = {|
  variables: MyPlaylists_deletePlaylistMutationVariables,
  response: MyPlaylists_deletePlaylistMutationResponse,
|};
*/

/*
mutation MyPlaylists_deletePlaylistMutation(
  $input: DeletePlaylistInput!
) {
  deletePlaylist(input: $input) {
    deletedPlaylistId
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaylistInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlaylist",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "DeletePlaylistInput!"
    }],
    "concreteType": "DeletePlaylistPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "deletedPlaylistId",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MyPlaylists_deletePlaylistMutation",
    "id": null,
    "text": "mutation MyPlaylists_deletePlaylistMutation(\n  $input: DeletePlaylistInput!\n) {\n  deletePlaylist(input: $input) {\n    deletedPlaylistId\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MyPlaylists_deletePlaylistMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MyPlaylists_deletePlaylistMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '1e4ef7dd71eaf70a8aa842ddddc101c1';
module.exports = node;

/***/ }),
/* 3436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RecommendationContainer_node$ref: FragmentReference;
export type RecommendationContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +thumbnail: ?{|
    +url: ?string,
    +width: ?number,
    +height: ?number,
  |},
  +playlist_songs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +__typename: string,
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +album: ?string,
          +artist: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +$refType: RecommendationContainer_node$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "RecommendationContainer_node",
    "type": "Playlist",
    "metadata": {
      "connection": [{
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": ["playlist_songs"]
      }]
    },
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "thumbnail",
      "storageKey": "thumbnail(height:240,width:240)",
      "args": [{
        "kind": "Literal",
        "name": "height",
        "value": 240,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "width",
        "value": 240,
        "type": "Int"
      }],
      "concreteType": "SongImage",
      "plural": false,
      "selections": [v1, v2, v3]
    }, {
      "kind": "LinkedField",
      "alias": "playlist_songs",
      "name": "__UserPlaylistContainer_playlist_songs_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistSongConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "PlaylistSongEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistSong",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "position",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [v4, v0, {
              "kind": "ScalarField",
              "alias": null,
              "name": "isrc",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "album",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "artist",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "song_images",
              "storageKey": null,
              "args": null,
              "concreteType": "SongImageConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SongImageEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SongImage",
                  "plural": false,
                  "selections": [v0, v1, v2, v3]
                }]
              }]
            }]
          }, v4]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "cursor",
          "args": null,
          "storageKey": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "endCursor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = '53fa380b6c5eb68bddf54501f082f7f9';
module.exports = node;

/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Song__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modules__ = __webpack_require__(6);









var PlaylistRecommendation = function PlaylistRecommendation(_ref) {
  var addToPlaylist = _ref.addToPlaylist,
      onClose = _ref.onClose,
      node = _ref.node,
      parent = _ref.parent;

  var addedLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
    className: __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default.a.noBoxShadow,
    circular: true,
    basic: true,
    size: 'small',
    icon: 'check',
    disabled: true
  });

  var addButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Popup */], {
    content: 'Add to Playlist',
    inverted: true,
    position: 'top center',
    trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */], {
      className: __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default.a.noBoxShadow,
      circular: true,
      basic: true,
      type: 'button',
      size: 'small',
      icon: 'add'
    })
  });

  var playlistContainsSong = function playlistContainsSong(song) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = parent.playlist_songs.edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var playlistSong = _step.value;

        if (playlistSong.node.song.isrc === song.isrc) return true;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__RootComponent__["b" /* RootConsumer */],
    null,
    function (_ref2) {
      var isMobile = _ref2.isMobile;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */], { playlist: node }),
        isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Modules__["f" /* MobileModal */].Header,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'menu' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'item', onClick: onClose },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Icon */], {
                name: 'chevron left'
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: __WEBPACK_IMPORTED_MODULE_4__Playlist_scss___default.a.playlistLabel, style: { marginTop: '2em' } },
          'Playlist'
        ),
        node.playlist_songs.edges.map(function (_ref3) {
          var song = _ref3.node.song;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Song__["a" /* default */], {
            key: song.id,
            song: song,
            actionCallback: playlistContainsSong(song) ? function () {} : addToPlaylist,
            actionTrigger: playlistContainsSong(song) ? addedLabel : addButton
          });
        })
      );
    }
  );
};

PlaylistRecommendation.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PlaylistRecommendation);

/***/ }),
/* 3438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideUpDownTransition_scss__ = __webpack_require__(3628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideUpDownTransition_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_stylesheets_SlideUpDownTransition_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils_dom__ = __webpack_require__(3470);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var MobileSongSearch = function (_Component) {
  _inherits(MobileSongSearch, _Component);

  function MobileSongSearch(props) {
    _classCallCheck(this, MobileSongSearch);

    var _this = _possibleConstructorReturn(this, (MobileSongSearch.__proto__ || Object.getPrototypeOf(MobileSongSearch)).call(this, props));

    _this.state = {
      showMask: false,
      fixed: false,
      newPos: null
    };
    _this.onOpen = _this.onOpen.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    return _this;
  }

  _createClass(MobileSongSearch, [{
    key: 'onOpen',
    value: function onOpen() {
      var _this2 = this;

      if (this.state.fixed) {
        return;
      }
      this.refs.input.inputRef.current.blur();
      this.setState({ fixed: true, origin: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_utils_dom__["a" /* getPosition */])(this.refs.search).y }, function () {
        _this2.setState({ showMask: true }, function () {
          _this2.refs.input.inputRef.current.focus();
        });
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      var _this3 = this;

      this.setState({ showMask: false }, function () {
        _this3.setState({ fixed: false });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          addToPlaylist = _props.addToPlaylist,
          clearSearch = _props.clearSearch,
          loading = _props.loading,
          onChange = _props.onChange,
          playlist = _props.playlist,
          playlistContainsSong = _props.playlistContainsSong,
          query = _props.query,
          searchResults = _props.searchResults;
      var _state = this.state,
          fixed = _state.fixed,
          origin = _state.origin,
          showMask = _state.showMask;

      var queryPresent = query !== '';
      var fixedStyles = fixed ? {
        position: 'fixed',
        top: showMask ? 85 : origin,
        zIndex: 102,
        width: 'calc(100% - 2.5rem)',
        transition: 'all .3s ease-in-out'
      } : {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_addons_css_transition_group___default.a,
          {
            transitionName: 'slide',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
          },
          showMask && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                background: '#ffffff',
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 101,
                padding: '1.25rem',
                paddingTop: '150px'
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modules__["f" /* MobileModal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'menu' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'item', onClick: this.onClose },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["d" /* Icon */], { name: 'chevron left' })
                )
              )
            ),
            queryPresent && searchResults.map(function (result) {
              var addedLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                className: __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.noBoxShadow,
                circular: true,
                basic: true,
                size: 'small',
                icon: 'check',
                disabled: true
              });

              var addButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Popup */], {
                content: 'Add to Playlist',
                inverted: true,
                position: 'top right',
                trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
                  className: __WEBPACK_IMPORTED_MODULE_5__Playlist_scss___default.a.noBoxShadow,
                  circular: true,
                  basic: true,
                  type: 'button',
                  size: 'small',
                  icon: 'add'
                })
              });
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */], {
                key: result.id,
                song: result,
                actionCallback: playlistContainsSong(result) ? function () {} : addToPlaylist,
                actionTrigger: playlistContainsSong(result) ? addedLabel : addButton,
                parent: playlist
              });
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { ref: 'search' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["k" /* Input */], {
            style: fixedStyles,
            onFocus: this.onOpen,
            loading: loading,
            size: 'small',
            fluid: true,
            ref: 'input',
            onChange: onChange,
            value: query,
            icon: {
              name: queryPresent ? 'delete' : 'search',
              onClick: clearSearch,
              link: queryPresent
            },
            placeholder: 'Search track title, artist, or album...'
          })
        )
      );
    }
  }]);

  return MobileSongSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MobileSongSearch.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  playlistContainsSong: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  clearSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  searchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MobileSongSearch);

/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formsy_react__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formsy_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_formsy_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NewSong = function (_Component) {
  _inherits(NewSong, _Component);

  function NewSong() {
    _classCallCheck(this, NewSong);

    return _possibleConstructorReturn(this, (NewSong.__proto__ || Object.getPrototypeOf(NewSong)).apply(this, arguments));
  }

  _createClass(NewSong, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          addToPlaylist = _props.addToPlaylist,
          closeNewSongForm = _props.closeNewSongForm,
          newSong = _props.newSong,
          newSongFieldChange = _props.newSongFieldChange;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_formsy_react___default.a.Form,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          autoFocus: true,
          name: 'name',
          label: 'Song Name',
          value: newSong.name || '',
          onChange: newSongFieldChange,
          required: true,
          validationError: 'Song name is required'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Elements__["e" /* FloatingLabelInput */], {
          name: 'artist',
          label: 'Artist',
          value: newSong.artist || '',
          onChange: newSongFieldChange
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modules__["j" /* DthcActions */], {
          save: function save(e) {
            return addToPlaylist(e, newSong, null, closeNewSongForm);
          },
          reset: closeNewSongForm
        })
      );
    }
  }]);

  return NewSong;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

NewSong.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  newSong: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  newSongFieldChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  closeNewSongForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (NewSong);

/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewSong__ = __webpack_require__(3439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MobileSearch__ = __webpack_require__(3438);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SongSearch = function (_React$Component) {
  _inherits(SongSearch, _React$Component);

  function SongSearch(props) {
    _classCallCheck(this, SongSearch);

    var _this = _possibleConstructorReturn(this, (SongSearch.__proto__ || Object.getPrototypeOf(SongSearch)).call(this, props));

    _this.state = {
      loading: false,
      newSong: {},
      newSongFormOpen: false,
      query: '',
      searchResults: []
    };
    _this.search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["throttle"])(_this.search, 500, {
      trailing: true
    }).bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.addToPlaylist = _this.addToPlaylist.bind(_this);
    _this.openNewSongForm = _this.openNewSongForm.bind(_this);
    _this.closeNewSongForm = _this.closeNewSongForm.bind(_this);
    _this.newSongFieldChange = _this.newSongFieldChange.bind(_this);
    _this.updateResults = _this.updateResults.bind(_this);
    _this.clearSearch = _this.clearSearch.bind(_this);
    _this.onResultSelect = _this.onResultSelect.bind(_this);
    _this.playlistContainsSong = _this.playlistContainsSong.bind(_this);
    return _this;
  }

  _createClass(SongSearch, [{
    key: 'onChange',
    value: function onChange(e, _ref) {
      var value = _ref.value;

      if (value === '') {
        this.clearSearch();
      } else {
        this.setState({ query: value }, this.search);
      }
    }
  }, {
    key: 'onResultSelect',
    value: function onResultSelect(e, _ref2) {
      var result = _ref2.result;

      var song = this.state.searchResults.find(function (s) {
        return s.id === result.id;
      });
      this.addToPlaylist(e, song, this.props.playlist);
    }
  }, {
    key: 'addToPlaylist',
    value: function addToPlaylist(e, song, parent, onSuccess, onFailure) {
      var _this2 = this;

      this.props.addToPlaylist(e, song, parent, function () {
        _this2.clearSearch();
        // this.scrollToEnd();
        if (onSuccess) onSuccess();
      }, onFailure);
    }
  }, {
    key: 'openNewSongForm',
    value: function openNewSongForm() {
      this.setState({
        newSongFormOpen: true,
        newSong: { name: this.state.query },
        query: ''
      });
    }
  }, {
    key: 'closeNewSongForm',
    value: function closeNewSongForm() {
      this.clearSearch();
      this.setState({ newSongFormOpen: false, newSong: {} });
    }
  }, {
    key: 'newSongFieldChange',
    value: function newSongFieldChange(e) {
      this.setState({
        newSong: Object.assign({}, this.state.newSong, _defineProperty({}, e.target.name, e.target.value))
      });
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var query = '';
      this.setState({ query: query, searchResults: [], loading: false });
    }
  }, {
    key: 'scrollToEnd',
    value: function scrollToEnd() {
      var current = this.props.listRef.current;

      current.scrollToItem(this.props.playlist.playlist_songs.edges.length - 1);
    }
  }, {
    key: 'search',
    value: function search() {
      var _this3 = this;

      this.setState({ loading: true });
      this.props.refetchSearchResults({ query: this.state.query }, null, function () {
        _this3.setState({ loading: false });
        _this3.updateResults(_this3.props.searchResults);
      });
    }
  }, {
    key: 'updateResults',
    value: function updateResults(searchResults) {
      this.setState({ searchResults: searchResults, loading: false });
    }
  }, {
    key: 'playlistContainsSong',
    value: function playlistContainsSong(song) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.playlist.playlist_songs.edges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var playlistSong = _step.value;

          if (playlistSong.node.song.isrc === song.isrc) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          loading = _state.loading,
          newSong = _state.newSong,
          newSongFormOpen = _state.newSongFormOpen,
          query = _state.query,
          searchResults = _state.searchResults;
      var _props = this.props,
          addToPlaylist = _props.addToPlaylist,
          playlist = _props.playlist;

      var queryPresent = query !== '';
      var results = searchResults.map(function (result) {
        return {
          id: result.id,
          key: result.id,
          title: result.name,
          description: result.artist
        };
      });

      var DesktopSearch = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' }, id: 'songSearch' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* Search */], {
          icon: {
            name: queryPresent ? 'delete' : 'search',
            onClick: this.clearSearch,
            link: queryPresent
          },
          className: 'songSearch',
          autoComplete: 'off',
          autoFocus: true,
          placeholder: 'Add track by title, artist, or album...',
          loading: loading,
          fluid: true,
          results: results,
          onSearchChange: this.onChange,
          onResultSelect: this.onResultSelect,
          value: query
        }),
        newSongFormOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NewSong__["a" /* default */], {
          newSong: newSong,
          newSongFieldChange: this.newSongFieldChange,
          closeNewSongForm: this.closeNewSongForm,
          addToPlaylist: this.addToPlaylist
        })
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__RootComponent__["b" /* RootConsumer */],
        null,
        function (_ref3) {
          var isMobile = _ref3.isMobile;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            isMobile ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MobileSearch__["a" /* default */], {
              playlist: playlist,
              addToPlaylist: addToPlaylist,
              loading: loading,
              query: query,
              playlistContainsSong: _this4.playlistContainsSong,
              onChange: _this4.onChange,
              clearSearch: _this4.clearSearch,
              searchResults: searchResults
            }) : DesktopSearch
          );
        }
      );
    }
  }]);

  return SongSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SongSearch.propTypes = {
  addToPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  refetchSearchResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  listRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  // we include playlist so the add icon updates when a new song is added
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SongSearch);

/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Playlist_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_window__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_virtualized_auto_sizer__ = __webpack_require__(2449);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SongList = function (_Component) {
  _inherits(SongList, _Component);

  function SongList(props) {
    _classCallCheck(this, SongList);

    var _this = _possibleConstructorReturn(this, (SongList.__proto__ || Object.getPrototypeOf(SongList)).call(this, props));

    _this.focusSearch = _this.focusSearch.bind(_this);
    _this.importSpotify = _this.importSpotify.bind(_this);
    return _this;
  }

  _createClass(SongList, [{
    key: 'focusSearch',
    value: function focusSearch() {
      document.querySelector('#songSearch input').focus();
    }
  }, {
    key: 'importSpotify',
    value: function importSpotify() {
      this.props.importSpotifyRef.current.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          innerRef = _props.innerRef,
          playlist = _props.playlist,
          removeFromPlaylist = _props.removeFromPlaylist;

      var numSongs = playlist.playlist_songs.edges.length;

      var deleteButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Popup */], {
        content: 'Remove from Playlist',
        inverted: true,
        position: 'left center',
        trigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */], {
          className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.noBoxShadow,
          circular: true,
          basic: true,
          type: 'button',
          size: 'small',
          icon: 'delete'
        })
      });

      var Row = function Row(_ref) {
        var index = _ref.index,
            style = _ref.style;

        var playlistSong = playlist.playlist_songs.edges[index].node;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: style },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], {
            key: index,
            song: playlistSong.song,
            actionCallback: removeFromPlaylist,
            actionTrigger: deleteButton,
            parent: playlistSong
          })
        );
      };

      var itemSize = 120;
      var maxHeight = 270;
      var playlistHeight = playlist.playlist_songs.edges.length * itemSize;
      if (playlistHeight > maxHeight) playlistHeight = maxHeight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        numSongs === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '2em 0' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: __WEBPACK_IMPORTED_MODULE_3__Playlist_scss___default.a.emptyList },
            'This playlist has no songs.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.focusSearch },
              'Search'
            ),
            ' or',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { onClick: this.importSpotify },
              'import from Spotify'
            ),
            ' to add songs.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: playlistHeight + 'px', width: '100%' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_virtualized_auto_sizer__["a" /* default */],
            null,
            function (_ref2) {
              var height = _ref2.height,
                  width = _ref2.width;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_window__["a" /* FixedSizeList */],
                {
                  height: height,
                  width: width + 16,
                  itemCount: playlist.playlist_songs.edges.length,
                  itemSize: 78,
                  ref: innerRef
                },
                Row
              );
            }
          )
        )
      );
    }
  }]);

  return SongList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SongList.propTypes = {
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  playlist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  removeFromPlaylist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  importSpotifyRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SongList, _extends({ innerRef: ref }, props));
}));

/***/ }),
/* 3442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenContract = (_temp = _class = function (_React$Component) {
  _inherits(OpenContract, _React$Component);

  function OpenContract(props) {
    _classCallCheck(this, OpenContract);

    var _this = _possibleConstructorReturn(this, (OpenContract.__proto__ || Object.getPrototypeOf(OpenContract)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenContract, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var contract = response.addContractToSession.contract;

        _this2.props.router.push({
          pathname: '/docs/c/' + contract.id,
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3456);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenContract;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenContract));

/***/ }),
/* 3443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenContractComponent__ = __webpack_require__(3442);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenContractComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3457);
  }
}));

/***/ }),
/* 3444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenEstimate = (_temp = _class = function (_React$Component) {
  _inherits(OpenEstimate, _React$Component);

  function OpenEstimate(props) {
    _classCallCheck(this, OpenEstimate);

    var _this = _possibleConstructorReturn(this, (OpenEstimate.__proto__ || Object.getPrototypeOf(OpenEstimate)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenEstimate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var estimate = response.addEstimateToSession.estimate;

        _this2.props.router.push({
          pathname: '/docs/e/' + estimate.id,
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3458);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenEstimate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenEstimate));

/***/ }),
/* 3445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenEstimateComponent__ = __webpack_require__(3444);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenEstimateComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3459);
  }
}));

/***/ }),
/* 3446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenForm = (_temp = _class = function (_React$Component) {
  _inherits(OpenForm, _React$Component);

  function OpenForm(props) {
    _classCallCheck(this, OpenForm);

    var _this = _possibleConstructorReturn(this, (OpenForm.__proto__ || Object.getPrototypeOf(OpenForm)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var form = response.addFormToSession.form;

        _this2.props.router.push({
          pathname: '/docs/f/' + form.id,
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3460);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenForm));

/***/ }),
/* 3447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenFormComponent__ = __webpack_require__(3446);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenFormComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3461);
  }
}));

/***/ }),
/* 3448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenInvoice = (_temp = _class = function (_React$Component) {
  _inherits(OpenInvoice, _React$Component);

  function OpenInvoice(props) {
    _classCallCheck(this, OpenInvoice);

    var _this = _possibleConstructorReturn(this, (OpenInvoice.__proto__ || Object.getPrototypeOf(OpenInvoice)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenInvoice, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var invoice = response.addInvoiceToSession.invoice;

        _this2.props.router.push({
          pathname: '/docs/i/' + invoice.id,
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3462);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenInvoice;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenInvoice));

/***/ }),
/* 3449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenInvoiceComponent__ = __webpack_require__(3448);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenInvoiceComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3463);
  }
}));

/***/ }),
/* 3450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenMusicPlanner = (_temp = _class = function (_React$Component) {
  _inherits(OpenMusicPlanner, _React$Component);

  function OpenMusicPlanner(props) {
    _classCallCheck(this, OpenMusicPlanner);

    var _this = _possibleConstructorReturn(this, (OpenMusicPlanner.__proto__ || Object.getPrototypeOf(OpenMusicPlanner)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenMusicPlanner, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var music_planner = response.addMusicPlannerToSession.music_planner;

        _this2.props.router.push({
          pathname: '/docs/m/' + music_planner.id + '/preview',
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3464);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenMusicPlanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenMusicPlanner));

/***/ }),
/* 3451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenMusicPlannerComponent__ = __webpack_require__(3450);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenMusicPlannerComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3465);
  }
}));

/***/ }),
/* 3452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SignContract = (_temp = _class = function (_React$Component) {
  _inherits(SignContract, _React$Component);

  function SignContract(props) {
    _classCallCheck(this, SignContract);

    var _this = _possibleConstructorReturn(this, (SignContract.__proto__ || Object.getPrototypeOf(SignContract)).call(this, props));

    _this.state = {
      error: false,
      loading: true
    };
    return _this;
  }

  _createClass(SignContract, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var _response$addContract = response.addContractSignToSession,
            contract = _response$addContract.contract,
            contract_signature_block = _response$addContract.contract_signature_block;

        _this2.props.router.push('/docs/c/' + contract.id + '/sign/' + contract_signature_block.id);
      };

      var onError = function onError() {
        _this2.setState({ error: true, loading: false });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3466);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        this.state.loading && !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return SignContract;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  viewer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_found__["withRouter"])(SignContract));

/***/ }),
/* 3453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenSignContractComponent__ = __webpack_require__(3452);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenSignContractComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3467);
  }
}));

/***/ }),
/* 3454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OpenWorkspace = (_temp = _class = function (_React$Component) {
  _inherits(OpenWorkspace, _React$Component);

  function OpenWorkspace(props) {
    _classCallCheck(this, OpenWorkspace);

    var _this = _possibleConstructorReturn(this, (OpenWorkspace.__proto__ || Object.getPrototypeOf(OpenWorkspace)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  _createClass(OpenWorkspace, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var onCompleted = function onCompleted(response) {
        var workspace = response.addWorkspaceToSession.workspace;

        _this2.props.router.push({
          pathname: '/events/' + workspace.event.id + '/workspaces',
          query: { share_token: _this2.props.params.share_token }
        });
      };

      var onError = function onError() {
        _this2.setState({ error: true });
      };

      var mutation = _graphql || (_graphql = function _graphql() {
        return __webpack_require__(3468);
      });

      var environment = this.props.relay.environment;
      var share_token = this.props.params.share_token;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_relay__["commitMutation"])(environment, {
        mutation: mutation,
        variables: { input: { share_token: share_token } },
        onCompleted: onCompleted,
        onError: onError
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { style: { textAlign: 'center', marginTop: '120px' } },
          'Page not found'
        ),
        !this.state.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements__["a" /* Loader */], null)
      );
    }
  }]);

  return OpenWorkspace;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
  relay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
}, _temp);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_found__["withRouter"])(OpenWorkspace));

/***/ }),
/* 3455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenWorkspaceComponent__ = __webpack_require__(3454);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_relay__["createFragmentContainer"])(__WEBPACK_IMPORTED_MODULE_1__OpenWorkspaceComponent__["a" /* default */], {
  viewer: function viewer() {
    return __webpack_require__(3469);
  }
}));

/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 38b70c1c17bf5fe323a739881235e1a4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddContractToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenContractComponent_addContractToSessionMutationVariables = {|
  input: AddContractToSessionInput
|};
export type OpenContractComponent_addContractToSessionMutationResponse = {|
  +addContractToSession: ?{|
    +contract: ?{|
      +id: string
    |}
  |}
|};
export type OpenContractComponent_addContractToSessionMutation = {|
  variables: OpenContractComponent_addContractToSessionMutationVariables,
  response: OpenContractComponent_addContractToSessionMutationResponse,
|};
*/

/*
mutation OpenContractComponent_addContractToSessionMutation(
  $input: AddContractToSessionInput!
) {
  addContractToSession(input: $input) {
    contract {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddContractToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addContractToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddContractToSessionInput!"
    }],
    "concreteType": "AddContractToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenContractComponent_addContractToSessionMutation",
    "id": null,
    "text": "mutation OpenContractComponent_addContractToSessionMutation(\n  $input: AddContractToSessionInput!\n) {\n  addContractToSession(input: $input) {\n    contract {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenContractComponent_addContractToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenContractComponent_addContractToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '47e08e6526362d271496ad4f5266bb91';
module.exports = node;

/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenContractContainer_viewer$ref: FragmentReference;
export type OpenContractContainer_viewer = {|
  +id: string,
  +$refType: OpenContractContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenContractContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '09bb913b0aaeb3d19d34c6d78b9ed62b';
module.exports = node;

/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a73cec56da8e9f3422e8bf2f6860aa25
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddEstimateToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenEstimateComponent_addEstimateToSessionMutationVariables = {|
  input: AddEstimateToSessionInput
|};
export type OpenEstimateComponent_addEstimateToSessionMutationResponse = {|
  +addEstimateToSession: ?{|
    +estimate: ?{|
      +id: string
    |}
  |}
|};
export type OpenEstimateComponent_addEstimateToSessionMutation = {|
  variables: OpenEstimateComponent_addEstimateToSessionMutationVariables,
  response: OpenEstimateComponent_addEstimateToSessionMutationResponse,
|};
*/

/*
mutation OpenEstimateComponent_addEstimateToSessionMutation(
  $input: AddEstimateToSessionInput!
) {
  addEstimateToSession(input: $input) {
    estimate {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddEstimateToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addEstimateToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddEstimateToSessionInput!"
    }],
    "concreteType": "AddEstimateToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "estimate",
      "storageKey": null,
      "args": null,
      "concreteType": "Estimate",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenEstimateComponent_addEstimateToSessionMutation",
    "id": null,
    "text": "mutation OpenEstimateComponent_addEstimateToSessionMutation(\n  $input: AddEstimateToSessionInput!\n) {\n  addEstimateToSession(input: $input) {\n    estimate {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenEstimateComponent_addEstimateToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenEstimateComponent_addEstimateToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ac28b9b367ec3cc2eb712753ecda3412';
module.exports = node;

/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenEstimateContainer_viewer$ref: FragmentReference;
export type OpenEstimateContainer_viewer = {|
  +id: string,
  +$refType: OpenEstimateContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenEstimateContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '08bfc8a797fbaf2f6bc238a28dab5b0e';
module.exports = node;

/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5e57a328d2c736b5405bb65d904338ad
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddFormToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenFormComponent_addFormToSessionMutationVariables = {|
  input: AddFormToSessionInput
|};
export type OpenFormComponent_addFormToSessionMutationResponse = {|
  +addFormToSession: ?{|
    +form: ?{|
      +id: string
    |}
  |}
|};
export type OpenFormComponent_addFormToSessionMutation = {|
  variables: OpenFormComponent_addFormToSessionMutationVariables,
  response: OpenFormComponent_addFormToSessionMutationResponse,
|};
*/

/*
mutation OpenFormComponent_addFormToSessionMutation(
  $input: AddFormToSessionInput!
) {
  addFormToSession(input: $input) {
    form {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddFormToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addFormToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddFormToSessionInput!"
    }],
    "concreteType": "AddFormToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "form",
      "storageKey": null,
      "args": null,
      "concreteType": "Form",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenFormComponent_addFormToSessionMutation",
    "id": null,
    "text": "mutation OpenFormComponent_addFormToSessionMutation(\n  $input: AddFormToSessionInput!\n) {\n  addFormToSession(input: $input) {\n    form {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenFormComponent_addFormToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenFormComponent_addFormToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '34ea6e32389965d0423235fee41c5b2d';
module.exports = node;

/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenFormContainer_viewer$ref: FragmentReference;
export type OpenFormContainer_viewer = {|
  +id: string,
  +$refType: OpenFormContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenFormContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '07c2f4318a64e267ea352f4797c65cc7';
module.exports = node;

/***/ }),
/* 3462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4d29231fb1a94a483145eea145386898
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddInvoiceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenInvoiceComponent_addInvoiceToSessionMutationVariables = {|
  input: AddInvoiceToSessionInput
|};
export type OpenInvoiceComponent_addInvoiceToSessionMutationResponse = {|
  +addInvoiceToSession: ?{|
    +invoice: ?{|
      +id: string
    |}
  |}
|};
export type OpenInvoiceComponent_addInvoiceToSessionMutation = {|
  variables: OpenInvoiceComponent_addInvoiceToSessionMutationVariables,
  response: OpenInvoiceComponent_addInvoiceToSessionMutationResponse,
|};
*/

/*
mutation OpenInvoiceComponent_addInvoiceToSessionMutation(
  $input: AddInvoiceToSessionInput!
) {
  addInvoiceToSession(input: $input) {
    invoice {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddInvoiceToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addInvoiceToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddInvoiceToSessionInput!"
    }],
    "concreteType": "AddInvoiceToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "invoice",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenInvoiceComponent_addInvoiceToSessionMutation",
    "id": null,
    "text": "mutation OpenInvoiceComponent_addInvoiceToSessionMutation(\n  $input: AddInvoiceToSessionInput!\n) {\n  addInvoiceToSession(input: $input) {\n    invoice {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenInvoiceComponent_addInvoiceToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenInvoiceComponent_addInvoiceToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '392d2ab5526313bb5a7e2de4f70e78ca';
module.exports = node;

/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenInvoiceContainer_viewer$ref: FragmentReference;
export type OpenInvoiceContainer_viewer = {|
  +id: string,
  +$refType: OpenInvoiceContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenInvoiceContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '7a9743fea274c754d5d2639a1ffe062d';
module.exports = node;

/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 423588aef38a9616c18a422209ab084a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddMusicPlannerToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenMusicPlannerComponent_addMusicPlannerToSessionMutationVariables = {|
  input: AddMusicPlannerToSessionInput
|};
export type OpenMusicPlannerComponent_addMusicPlannerToSessionMutationResponse = {|
  +addMusicPlannerToSession: ?{|
    +music_planner: ?{|
      +id: string
    |}
  |}
|};
export type OpenMusicPlannerComponent_addMusicPlannerToSessionMutation = {|
  variables: OpenMusicPlannerComponent_addMusicPlannerToSessionMutationVariables,
  response: OpenMusicPlannerComponent_addMusicPlannerToSessionMutationResponse,
|};
*/

/*
mutation OpenMusicPlannerComponent_addMusicPlannerToSessionMutation(
  $input: AddMusicPlannerToSessionInput!
) {
  addMusicPlannerToSession(input: $input) {
    music_planner {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddMusicPlannerToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addMusicPlannerToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddMusicPlannerToSessionInput!"
    }],
    "concreteType": "AddMusicPlannerToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenMusicPlannerComponent_addMusicPlannerToSessionMutation",
    "id": null,
    "text": "mutation OpenMusicPlannerComponent_addMusicPlannerToSessionMutation(\n  $input: AddMusicPlannerToSessionInput!\n) {\n  addMusicPlannerToSession(input: $input) {\n    music_planner {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenMusicPlannerComponent_addMusicPlannerToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenMusicPlannerComponent_addMusicPlannerToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '825168aafe5bd341145c1d7e45f275b7';
module.exports = node;

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenMusicPlannerContainer_viewer$ref: FragmentReference;
export type OpenMusicPlannerContainer_viewer = {|
  +id: string,
  +$refType: OpenMusicPlannerContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenMusicPlannerContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '809f15cd95da06da39008f2f5c37821f';
module.exports = node;

/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 372a6d6f04a067da45907707db063817
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddContractSignToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenSignContractComponent_addContractSignToSessionMutationVariables = {|
  input: AddContractSignToSessionInput
|};
export type OpenSignContractComponent_addContractSignToSessionMutationResponse = {|
  +addContractSignToSession: ?{|
    +contract: ?{|
      +id: string
    |},
    +contract_signature_block: ?{|
      +id: string
    |},
  |}
|};
export type OpenSignContractComponent_addContractSignToSessionMutation = {|
  variables: OpenSignContractComponent_addContractSignToSessionMutationVariables,
  response: OpenSignContractComponent_addContractSignToSessionMutationResponse,
|};
*/

/*
mutation OpenSignContractComponent_addContractSignToSessionMutation(
  $input: AddContractSignToSessionInput!
) {
  addContractSignToSession(input: $input) {
    contract {
      id
    }
    contract_signature_block {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddContractSignToSessionInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }],
      v2 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addContractSignToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddContractSignToSessionInput!"
    }],
    "concreteType": "AddContractSignToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "contract",
      "storageKey": null,
      "args": null,
      "concreteType": "Contract",
      "plural": false,
      "selections": v1
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "contract_signature_block",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlock",
      "plural": false,
      "selections": v1
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenSignContractComponent_addContractSignToSessionMutation",
    "id": null,
    "text": "mutation OpenSignContractComponent_addContractSignToSessionMutation(\n  $input: AddContractSignToSessionInput!\n) {\n  addContractSignToSession(input: $input) {\n    contract {\n      id\n    }\n    contract_signature_block {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenSignContractComponent_addContractSignToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v2
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenSignContractComponent_addContractSignToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v2
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '7254b02cd3d41fb4f4d7fc21d8ce8b16';
module.exports = node;

/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenSignContractContainer_viewer$ref: FragmentReference;
export type OpenSignContractContainer_viewer = {|
  +id: string,
  +$refType: OpenSignContractContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenSignContractContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ee160e43e33c9d3600fa10a6de90d283';
module.exports = node;

/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 08e903cd2387a1727d053284cbb6c530
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddWorkspaceToSessionInput = {
  clientMutationId?: ?string,
  share_token: string,
};
export type OpenWorkspaceComponent_addWorkspaceToSessionMutationVariables = {|
  input: AddWorkspaceToSessionInput
|};
export type OpenWorkspaceComponent_addWorkspaceToSessionMutationResponse = {|
  +addWorkspaceToSession: ?{|
    +workspace: ?{|
      +id: string,
      +event: ?{|
        +id: string
      |},
    |}
  |}
|};
export type OpenWorkspaceComponent_addWorkspaceToSessionMutation = {|
  variables: OpenWorkspaceComponent_addWorkspaceToSessionMutationVariables,
  response: OpenWorkspaceComponent_addWorkspaceToSessionMutationResponse,
|};
*/

/*
mutation OpenWorkspaceComponent_addWorkspaceToSessionMutation(
  $input: AddWorkspaceToSessionInput!
) {
  addWorkspaceToSession(input: $input) {
    workspace {
      id
      event {
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddWorkspaceToSessionInput!",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "addWorkspaceToSession",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "AddWorkspaceToSessionInput!"
    }],
    "concreteType": "AddWorkspaceToSessionPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "workspace",
      "storageKey": null,
      "args": null,
      "concreteType": "Workspace",
      "plural": false,
      "selections": [v1, {
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v1]
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "OpenWorkspaceComponent_addWorkspaceToSessionMutation",
    "id": null,
    "text": "mutation OpenWorkspaceComponent_addWorkspaceToSessionMutation(\n  $input: AddWorkspaceToSessionInput!\n) {\n  addWorkspaceToSession(input: $input) {\n    workspace {\n      id\n      event {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OpenWorkspaceComponent_addWorkspaceToSessionMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v2
    },
    "operation": {
      "kind": "Operation",
      "name": "OpenWorkspaceComponent_addWorkspaceToSessionMutation",
      "argumentDefinitions": v0,
      "selections": v2
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'abd1e12d70b59a2006975a60ed4f62c6';
module.exports = node;

/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenWorkspaceContainer_viewer$ref: FragmentReference;
export type OpenWorkspaceContainer_viewer = {|
  +id: string,
  +$refType: OpenWorkspaceContainer_viewer$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenWorkspaceContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'cce6702ad1a90fa18236ae6210b16abe';
module.exports = node;

/***/ }),
/* 3470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
function getPosition(e) {
  var xPosition = 0;
  var yPosition = 0;
  var element = e;

  while (element) {
    xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
    yPosition += element.offsetTop - element.scrollTop + element.clientTop;
    element = element.offsetParent;
  }

  return { x: xPosition, y: yPosition };
}

/***/ }),
/* 3471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPlaylistImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSongImage; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getSongImage = function getSongImage(song, width, height) {
  var imagesLargeEnough = song.song_images.edges.filter(function (_ref) {
    var image = _ref.node;
    return image.width >= width && image.height >= height;
  });
  var imageAreas = imagesLargeEnough.map(function (_ref2) {
    var image = _ref2.node;
    return image.width * image.height;
  });
  if (imagesLargeEnough.length > 0) {
    return imagesLargeEnough[imageAreas.indexOf(Math.min.apply(Math, _toConsumableArray(imageAreas)))].node;
  }
  return null;
};

var getPlaylistImage = function getPlaylistImage(playlist, width, height) {
  var playlistSongs = playlist.playlist_songs.edges;
  var i = 0;
  var songImage = null;
  while (!songImage && i < playlistSongs.length) {
    songImage = getSongImage(playlistSongs[i].node.song, width, height);
    i++;
  }
  return songImage;
};



/***/ }),
/* 3472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var polyfill = function () {
  (function (global) {
    if (!('HTMLCanvasElement' in global)) return;
    if (!('toDataURL' in global.HTMLCanvasElement.prototype)) return;
    if ('toBlob' in global.HTMLCanvasElement.prototype) return;
    Object.defineProperty(global.HTMLCanvasElement.prototype, 'toBlob', {
      value: function value(callback /*, type, encoderOptions*/) {
        var url = this.toDataURL.apply(this, [].slice.call(arguments, 1));
        var m = /^data:(.*?);base64,(.*)$/.exec(url),
            type = m[1],
            b64 = m[2];
        setTimeout(function () {
          callback(new Blob([new Uint8Array(global.atob(b64).split('').map(function (c) {
            return c.charCodeAt(0);
          }))], { type: type }));
        }, 0);
      }, writable: true, enumerable: true, configurable: true });
  })(self);
}();

/* unused harmony default export */ var _unused_webpack_default_export = (polyfill);

/***/ }),
/* 3473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  text: 'Alabama',
  value: 'Alabama'
}, {
  text: 'Alaska',
  value: 'Alaska'
}, {
  text: 'Arizona',
  value: 'Arizona'
}, {
  text: 'Arkansas',
  value: 'Arkansas'
}, {
  text: 'California',
  value: 'California'
}, {
  text: 'Colorado',
  value: 'Colorado'
}, {
  text: 'Connecticut',
  value: 'Connecticut'
}, {
  text: 'Delaware',
  value: 'Delaware'
}, {
  text: 'District of Columbia',
  value: 'District of Columbia'
}, {
  text: 'Florida',
  value: 'Florida'
}, {
  text: 'Georgia',
  value: 'Georgia'
}, {
  text: 'Hawaii',
  value: 'Hawaii'
}, {
  text: 'Idaho',
  value: 'Idaho'
}, {
  text: 'Illinois',
  value: 'Illinois'
}, {
  text: 'Indiana',
  value: 'Indiana'
}, {
  text: 'Iowa',
  value: 'Iowa'
}, {
  text: 'Kansas',
  value: 'Kansas'
}, {
  text: 'Kentucky',
  value: 'Kentucky'
}, {
  text: 'Louisiana',
  value: 'Louisiana'
}, {
  text: 'Maine',
  value: 'Maine'
}, {
  text: 'Maryland',
  value: 'Maryland'
}, {
  text: 'Massachusetts',
  value: 'Massachusetts'
}, {
  text: 'Michigan',
  value: 'Michigan'
}, {
  text: 'Minnesota',
  value: 'Minnesota'
}, {
  text: 'Mississippi',
  value: 'Mississippi'
}, {
  text: 'Missouri',
  value: 'Missouri'
}, {
  text: 'Montana',
  value: 'Montana'
}, {
  text: 'Nebraska',
  value: 'Nebraska'
}, {
  text: 'Nevada',
  value: 'Nevada'
}, {
  text: 'New Hampshire',
  value: 'New Hampshire'
}, {
  text: 'New Jersey',
  value: 'New Jersey'
}, {
  text: 'New Mexico',
  value: 'New Mexico'
}, {
  text: 'New York',
  value: 'New York'
}, {
  text: 'North Carolina',
  value: 'North Carolina'
}, {
  text: 'North Dakota',
  value: 'North Dakota'
}, {
  text: 'Ohio',
  value: 'Ohio'
}, {
  text: 'Oklahoma',
  value: 'Oklahoma'
}, {
  text: 'Oregon',
  value: 'Oregon'
}, {
  text: 'Pennsylvania',
  value: 'Pennsylvania'
}, {
  text: 'Rhode Island',
  value: 'Rhode Island'
}, {
  text: 'South Carolina',
  value: 'South Carolina'
}, {
  text: 'South Dakota',
  value: 'South Dakota'
}, {
  text: 'Tennessee',
  value: 'Tennessee'
}, {
  text: 'Texas',
  value: 'Texas'
}, {
  text: 'Utah',
  value: 'Utah'
}, {
  text: 'Vermont',
  value: 'Vermont'
}, {
  text: 'Virginia',
  value: 'Virginia'
}, {
  text: 'Washington',
  value: 'Washington'
}, {
  text: 'West Virginia',
  value: 'West Virginia'
}, {
  text: 'Wisconsin',
  value: 'Wisconsin'
}, {
  text: 'Wyoming',
  value: 'Wyoming'
}]);

/***/ }),
/* 3474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Document_Estimate_EstimateContainer__ = __webpack_require__(2883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Document_Invoice_InvoiceContainer__ = __webpack_require__(3017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Document_Contract_ContractContainer__ = __webpack_require__(2839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Document_Form_FormContainer__ = __webpack_require__(2981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Document_MusicPlanner_MusicPlannerContainer__ = __webpack_require__(3062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Document_MusicPlanner_PlannerPlaylistContainer__ = __webpack_require__(3065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_relay__);











var DocumentRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  { path: 'docs' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'e/:id/:action?',
    Component: __WEBPACK_IMPORTED_MODULE_2__components_Document_Estimate_EstimateContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3485);
    },
    render: function render(_ref) {
      var props = _ref.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Document_Estimate_EstimateContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'i/:id/:action?',
    Component: __WEBPACK_IMPORTED_MODULE_3__components_Document_Invoice_InvoiceContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3487);
    },
    render: function render(_ref2) {
      var props = _ref2.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Document_Invoice_InvoiceContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'c/:id/:action?/:signer_id?',
    Component: __WEBPACK_IMPORTED_MODULE_4__components_Document_Contract_ContractContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3484);
    },
    render: function render(_ref3) {
      var props = _ref3.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Document_Contract_ContractContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'f/:id/:action?',
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Document_Form_FormContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3486);
    },
    render: function render(_ref4) {
      var props = _ref4.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Document_Form_FormContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
    {
      path: 'm/:id/:action?',
      Component: __WEBPACK_IMPORTED_MODULE_6__components_Document_MusicPlanner_MusicPlannerContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3488);
      },
      render: function render(_ref5) {
        var props = _ref5.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Document_MusicPlanner_MusicPlannerContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
      path: 'playlist/:playlist_id',
      Component: __WEBPACK_IMPORTED_MODULE_7__components_Document_MusicPlanner_PlannerPlaylistContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3489);
      },
      render: function render(_ref6) {
        var props = _ref6.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Document_MusicPlanner_PlannerPlaylistContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Elements__["a" /* Loader */], null);
      }
    })
  )
);

/* harmony default export */ __webpack_exports__["a"] = (DocumentRoutes);

/***/ }),
/* 3475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_relay__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __webpack_require__(3490);
});

/***/ }),
/* 3476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewerQuery__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventListRoute__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Event_Create_EventCreateContainer__ = __webpack_require__(3260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Event_Show_EventShowContainer__ = __webpack_require__(3297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Event_Show_EventOverviewContainer__ = __webpack_require__(3296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Event_Show_EventSummaryContainer__ = __webpack_require__(3299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Event_Show_Workspace_WorkspacesContainer__ = __webpack_require__(3313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_relay__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var EventRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  { path: '/events' },
  __WEBPACK_IMPORTED_MODULE_4__EventListRoute__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'new',
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Event_Create_EventCreateContainer__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_2__ViewerQuery__["a" /* default */],
    render: function render(_ref) {
      var props = _ref.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Event_Create_EventCreateContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
    {
      path: ':event_id',
      prepareVariables: function prepareVariables(params) {
        return _extends({}, params, {
          id: params.event_id
        });
      },
      Component: __WEBPACK_IMPORTED_MODULE_6__components_Event_Show_EventShowContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3494);
      },
      render: function render(_ref2) {
        var props = _ref2.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Event_Show_EventShowContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
      {
        Component: __WEBPACK_IMPORTED_MODULE_7__components_Event_Show_EventOverviewContainer__["a" /* default */],
        prepareVariables: function prepareVariables(params) {
          return _extends({}, params, {
            id: params.event_id
          });
        },
        query: function query() {
          return __webpack_require__(3493);
        },
        render: function render(_ref3) {
          var props = _ref3.props;
          return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Event_Show_EventOverviewContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
        Component: __WEBPACK_IMPORTED_MODULE_8__components_Event_Show_EventSummaryContainer__["a" /* default */],
        prepareVariables: function prepareVariables(params) {
          return _extends({}, params, {
            id: params.event_id
          });
        },
        query: function query() {
          return __webpack_require__(3495);
        },
        render: function render(_ref4) {
          var props = _ref4.props;
          return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Event_Show_EventSummaryContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
      path: 'workspaces',
      Component: __WEBPACK_IMPORTED_MODULE_9__components_Event_Show_Workspace_WorkspacesContainer__["a" /* default */],
      prepareVariables: function prepareVariables(params) {
        return _extends({}, params, {
          id: params.event_id
        });
      },
      query: function query() {
        return __webpack_require__(3496);
      },
      render: function render(_ref5) {
        var props = _ref5.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Event_Show_Workspace_WorkspacesContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
      }
    })
  )
);

/* harmony default export */ __webpack_exports__["a"] = (EventRoutes);

/***/ }),
/* 3477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Leads_LeadCaptureContainer__ = __webpack_require__(3388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Leads_KioskContainer__ = __webpack_require__(3386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Leads_LinkContainer__ = __webpack_require__(3390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Leads_EmbedContainer__ = __webpack_require__(3384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ViewerQuery__ = __webpack_require__(828);









var LeadRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  { path: 'leads' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    Component: __WEBPACK_IMPORTED_MODULE_2__components_Leads_LeadCaptureContainer__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_7__ViewerQuery__["a" /* default */],
    render: function render(_ref) {
      var props = _ref.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Leads_LeadCaptureContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'embed',
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Leads_EmbedContainer__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_7__ViewerQuery__["a" /* default */],
    render: function render(_ref2) {
      var props = _ref2.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Leads_EmbedContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'kiosk',
    Component: __WEBPACK_IMPORTED_MODULE_3__components_Leads_KioskContainer__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_7__ViewerQuery__["a" /* default */],
    render: function render(_ref3) {
      var props = _ref3.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Leads_KioskContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'link',
    Component: __WEBPACK_IMPORTED_MODULE_4__components_Leads_LinkContainer__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_7__ViewerQuery__["a" /* default */],
    render: function render(_ref4) {
      var props = _ref4.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Leads_LinkContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Elements__["a" /* Loader */], null);
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = (LeadRoutes);

/***/ }),
/* 3478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_found__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_found___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_found__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoiceQuery__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App_AppContainer__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RootComponent__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_SettingsContainer__ = __webpack_require__(2817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Financial_FinancialContainer__ = __webpack_require__(3360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Financial_Invoices_InvoicesContainer__ = __webpack_require__(3365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Financial_Invoices_InvoiceListContainer__ = __webpack_require__(3362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Financial_Invoices_InvoiceListLoader__ = __webpack_require__(3363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Financial_PaymentsGraph_PaymentsGraphContainer__ = __webpack_require__(3379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Financial_Payments_PaymentsComponent__ = __webpack_require__(3372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Financial_Payments_CompletedPaymentsContainer__ = __webpack_require__(3369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Financial_Payments_OutstandingPaymentsContainer__ = __webpack_require__(3371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Financial_Payments_RefundsContainer__ = __webpack_require__(3374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeadRoutes__ = __webpack_require__(3477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ShareRoutes__ = __webpack_require__(3479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DocumentRoutes__ = __webpack_require__(3474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EventRoutes__ = __webpack_require__(3476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TemplateRoutes__ = __webpack_require__(3480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EventListRoute__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TemplateListRoute__ = __webpack_require__(3482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__params_InvoiceListParams__ = __webpack_require__(3523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__params_PaymentsGraphParams__ = __webpack_require__(3525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__params_CompletedPaymentsParams__ = __webpack_require__(3520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CompletedPaymentsQuery__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__params_OutstandingPaymentsParams__ = __webpack_require__(3524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__OutstandingPaymentsQuery__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__params_RefundsParams__ = __webpack_require__(3526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__RefundsQuery__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SearchRoute__ = __webpack_require__(3481);


































/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_found__["makeRouteConfig"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_0_found__["Route"],
  { Component: __WEBPACK_IMPORTED_MODULE_5__components_RootComponent__["a" /* default */] },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_found__["Route"],
    {
      path: '/',
      Component: __WEBPACK_IMPORTED_MODULE_4__components_App_AppContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3500);
      },
      render: function render(_ref) {
        var props = _ref.props;
        return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_App_AppContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
      }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
      path: 'settings',
      Component: __WEBPACK_IMPORTED_MODULE_6__components_App_SettingsContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3504);
      },
      render: function render(_ref2) {
        var props = _ref2.props;
        return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_App_SettingsContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
      }
    }),
    __WEBPACK_IMPORTED_MODULE_32__SearchRoute__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_22__EventListRoute__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_20__EventRoutes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_17__LeadRoutes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_18__ShareRoutes__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_23__TemplateListRoute__["a" /* default */],
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_found__["Route"],
      {
        Component: __WEBPACK_IMPORTED_MODULE_7__components_Financial_FinancialContainer__["a" /* default */],
        path: 'financials',
        query: function query() {
          return __webpack_require__(3501);
        },
        render: function render(_ref3) {
          var props = _ref3.props;
          return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Financial_FinancialContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
        }
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
        Component: __WEBPACK_IMPORTED_MODULE_11__components_Financial_PaymentsGraph_PaymentsGraphContainer__["a" /* default */],
        prepareVariables: __WEBPACK_IMPORTED_MODULE_25__params_PaymentsGraphParams__["a" /* default */],
        query: function query() {
          return __webpack_require__(3503);
        },
        render: function render(_ref4) {
          var props = _ref4.props;
          return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Financial_PaymentsGraph_PaymentsGraphContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_found__["Route"],
        {
          path: 'invoices',
          Component: __WEBPACK_IMPORTED_MODULE_8__components_Financial_Invoices_InvoicesContainer__["a" /* default */],
          query: function query() {
            return __webpack_require__(3502);
          },
          render: function render(_ref5) {
            var props = _ref5.props;
            return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Financial_Invoices_InvoicesContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
          prepareVariables: __WEBPACK_IMPORTED_MODULE_24__params_InvoiceListParams__["a" /* default */],
          Component: __WEBPACK_IMPORTED_MODULE_9__components_Financial_Invoices_InvoiceListContainer__["a" /* default */],
          query: __WEBPACK_IMPORTED_MODULE_3__InvoiceQuery__["a" /* default */],
          render: function render(_ref6) {
            var props = _ref6.props;
            return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Financial_Invoices_InvoiceListContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Financial_Invoices_InvoiceListLoader__["a" /* default */], null);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_found__["Route"],
        {
          path: 'payments',
          Component: __WEBPACK_IMPORTED_MODULE_12__components_Financial_Payments_PaymentsComponent__["a" /* default */]
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
          Component: __WEBPACK_IMPORTED_MODULE_13__components_Financial_Payments_CompletedPaymentsContainer__["a" /* default */],
          prepareVariables: __WEBPACK_IMPORTED_MODULE_26__params_CompletedPaymentsParams__["a" /* default */],
          query: __WEBPACK_IMPORTED_MODULE_27__CompletedPaymentsQuery__["a" /* default */],
          render: function render(_ref7) {
            var props = _ref7.props;
            return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Financial_Payments_CompletedPaymentsContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
          path: 'outstanding',
          Component: __WEBPACK_IMPORTED_MODULE_14__components_Financial_Payments_OutstandingPaymentsContainer__["a" /* default */],
          prepareVariables: __WEBPACK_IMPORTED_MODULE_28__params_OutstandingPaymentsParams__["a" /* default */],
          query: __WEBPACK_IMPORTED_MODULE_29__OutstandingPaymentsQuery__["a" /* default */],
          render: function render(_ref8) {
            var props = _ref8.props;
            return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Financial_Payments_OutstandingPaymentsContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_found__["Route"], {
          path: 'refunds',
          Component: __WEBPACK_IMPORTED_MODULE_15__components_Financial_Payments_RefundsContainer__["a" /* default */],
          prepareVariables: __WEBPACK_IMPORTED_MODULE_30__params_RefundsParams__["a" /* default */],
          query: __WEBPACK_IMPORTED_MODULE_31__RefundsQuery__["a" /* default */],
          render: function render(_ref9) {
            var props = _ref9.props;
            return props ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Financial_Payments_RefundsContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Elements__["a" /* Loader */], null);
          }
        })
      )
    )
  ),
  __WEBPACK_IMPORTED_MODULE_21__TemplateRoutes__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_19__DocumentRoutes__["a" /* default */]
)));

/***/ }),
/* 3479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Share_OpenWorkspaceContainer__ = __webpack_require__(3455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Share_OpenEstimateContainer__ = __webpack_require__(3445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Share_OpenInvoiceContainer__ = __webpack_require__(3449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Share_OpenFormContainer__ = __webpack_require__(3447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Share_OpenMusicPlannerContainer__ = __webpack_require__(3451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Share_OpenContractContainer__ = __webpack_require__(3443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Share_OpenSignContractContainer__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_relay__);











var ShareRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  { path: 'open' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'w/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_2__components_Share_OpenWorkspaceContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3512);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'e/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_3__components_Share_OpenEstimateContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3508);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'i/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_4__components_Share_OpenInvoiceContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3510);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'f/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Share_OpenFormContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3509);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'm/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_6__components_Share_OpenMusicPlannerContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3511);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'c/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_7__components_Share_OpenContractContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3507);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'sign/:share_token',
    Component: __WEBPACK_IMPORTED_MODULE_8__components_Share_OpenSignContractContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3513);
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = (ShareRoutes);

/***/ }),
/* 3480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Document_Template_Contract_ContractTemplateContainer__ = __webpack_require__(3147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Document_Template_Form_FormTemplateContainer__ = __webpack_require__(3174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Document_Template_MusicPlanner_MpTemplateContainer__ = __webpack_require__(3192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Document_Template_MusicPlanner_MpTemplatePlaylistContainer__ = __webpack_require__(3194);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var TemplateRoutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  { path: 'templates' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'c/:template_id/:action?',
    prepareVariables: function prepareVariables(params) {
      return _extends({}, params, {
        id: params.template_id
      });
    },
    Component: __WEBPACK_IMPORTED_MODULE_4__components_Document_Template_Contract_ContractTemplateContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3515);
    },
    render: function render(_ref) {
      var props = _ref.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Document_Template_Contract_ContractTemplateContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    path: 'f/:template_id/:action?',
    prepareVariables: function prepareVariables(params) {
      return _extends({}, params, {
        id: params.template_id
      });
    },
    Component: __WEBPACK_IMPORTED_MODULE_5__components_Document_Template_Form_FormTemplateContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3516);
    },
    render: function render(_ref2) {
      var props = _ref2.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Document_Template_Form_FormTemplateContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Elements__["a" /* Loader */], null);
    }
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
    {
      path: 'm/:template_id/:action?',
      prepareVariables: function prepareVariables(params) {
        return _extends({}, params, {
          id: params.template_id
        });
      },
      Component: __WEBPACK_IMPORTED_MODULE_6__components_Document_Template_MusicPlanner_MpTemplateContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3518);
      },
      render: function render(_ref3) {
        var props = _ref3.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Document_Template_MusicPlanner_MpTemplateContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Elements__["a" /* Loader */], null);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
      path: 'playlist/:playlist_id',
      Component: __WEBPACK_IMPORTED_MODULE_7__components_Document_Template_MusicPlanner_MpTemplatePlaylistContainer__["a" /* default */],
      query: function query() {
        return __webpack_require__(3517);
      },
      render: function render(_ref4) {
        var props = _ref4.props;
        return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Document_Template_MusicPlanner_MpTemplatePlaylistContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Elements__["a" /* Loader */], null);
      }
    })
  )
);

/* harmony default export */ __webpack_exports__["a"] = (TemplateRoutes);

/***/ }),
/* 3481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App_Search_SearchResultsContainer__ = __webpack_require__(2812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App_Search_SearchPageContainer__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__params_SearchParams__ = __webpack_require__(3527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchResultsQuery__ = __webpack_require__(1495);









var SearchRoute = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a,
  {
    path: 'search',
    Component: __WEBPACK_IMPORTED_MODULE_4__components_App_Search_SearchPageContainer__["a" /* default */],
    query: function query() {
      return __webpack_require__(3506);
    }
  },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
    Component: __WEBPACK_IMPORTED_MODULE_3__components_App_Search_SearchResultsContainer__["a" /* default */],
    prepareVariables: __WEBPACK_IMPORTED_MODULE_5__params_SearchParams__["a" /* default */],
    query: __WEBPACK_IMPORTED_MODULE_7__SearchResultsQuery__["a" /* default */],
    render: function render(_ref) {
      var props = _ref.props;
      return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_App_Search_SearchResultsContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Elements__["a" /* Loader */], null);
    }
  })
);

/* harmony default export */ __webpack_exports__["a"] = (SearchRoute);

/***/ }),
/* 3482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_relay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_relay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Elements__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Document_Template_TemplateListContainer__ = __webpack_require__(3223);






var TemplateListRoute = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_found_lib_Route___default.a, {
  path: 'templates',
  Component: __WEBPACK_IMPORTED_MODULE_4__components_Document_Template_TemplateListContainer__["a" /* default */],
  query: function query() {
    return __webpack_require__(3514);
  },
  render: function render(_ref) {
    var props = _ref.props;
    return props ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Document_Template_TemplateListContainer__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Elements__["a" /* Loader */], null);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TemplateListRoute);

/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bc7af0a4c67ccda7517ec3403f428759
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type CompletedPaymentsContainer_viewer$ref = any;
export type CompletedPaymentsQuery_CompletedPayments_QueryVariables = {|
  completed_payments_before?: ?any,
  completed_payments_after?: ?any,
  count: number,
  cursor?: ?string,
|};
export type CompletedPaymentsQuery_CompletedPayments_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CompletedPaymentsContainer_viewer$ref
  |}
|};
export type CompletedPaymentsQuery_CompletedPayments_Query = {|
  variables: CompletedPaymentsQuery_CompletedPayments_QueryVariables,
  response: CompletedPaymentsQuery_CompletedPayments_QueryResponse,
|};
*/

/*
query CompletedPaymentsQuery_CompletedPayments_Query(
  $completed_payments_before: ISO8601Type
  $completed_payments_after: ISO8601Type
  $count: Int!
  $cursor: String
) {
  viewer {
    ...CompletedPaymentsContainer_viewer_11BmFI
    id
  }
}

fragment CompletedPaymentsContainer_viewer_11BmFI on User {
  s_time_zone
  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: $count, after: $cursor) {
    edges {
      node {
        ... on CashPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on CheckPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on CustomPayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          label
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on SquarePayment {
          id
          amount_cents
          amount_currency
          name
          paid_at
          invoice {
            id
            title
            workspaces {
              edges {
                node {
                  event {
                    title
                    id
                  }
                  id
                }
              }
            }
          }
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "completed_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "completed_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "after_time",
    "variableName": "completed_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "completed_payments_before",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "invoice",
    "storageKey": null,
    "args": null,
    "concreteType": "Invoice",
    "plural": false,
    "selections": [v2, v7, {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkspaceEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Workspace",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [v7, v2]
          }, v2]
        }]
      }]
    }]
  },
      v9 = [v3, v4, v5, v6, v8];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "CompletedPaymentsQuery_CompletedPayments_Query",
    "id": null,
    "text": "query CompletedPaymentsQuery_CompletedPayments_Query(\n  $completed_payments_before: ISO8601Type\n  $completed_payments_after: ISO8601Type\n  $count: Int!\n  $cursor: String\n) {\n  viewer {\n    ...CompletedPaymentsContainer_viewer_11BmFI\n    id\n  }\n}\n\nfragment CompletedPaymentsContainer_viewer_11BmFI on User {\n  s_time_zone\n  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: $count, after: $cursor) {\n    edges {\n      node {\n        ... on CashPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          label\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          invoice {\n            id\n            title\n            workspaces {\n              edges {\n                node {\n                  event {\n                    title\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "CompletedPaymentsQuery_CompletedPayments_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "CompletedPaymentsContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "completed_payments_after",
            "variableName": "completed_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "completed_payments_before",
            "variableName": "completed_payments_before",
            "type": null
          }, {
            "kind": "Variable",
            "name": "count",
            "variableName": "count",
            "type": null
          }, {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "CompletedPaymentsQuery_CompletedPayments_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "completed_payments",
          "storageKey": null,
          "args": v1,
          "concreteType": "PaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "type": "SquarePayment",
                "selections": v9
              }, {
                "kind": "InlineFragment",
                "type": "CustomPayment",
                "selections": [v3, v4, v5, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "label",
                  "args": null,
                  "storageKey": null
                }, v8]
              }, {
                "kind": "InlineFragment",
                "type": "CheckPayment",
                "selections": v9
              }, {
                "kind": "InlineFragment",
                "type": "CashPayment",
                "selections": v9
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "completed_payments",
          "args": v1,
          "handle": "connection",
          "key": "CompletedPayments_completed_payments",
          "filters": ["before_time", "after_time"]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '136ca6ae341d65b58d8d0131a1dfb2fc';
module.exports = node;

/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 54743e5647ab0df682130ff33c869f57
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractContainer_node$ref = any;
type ContractContainer_viewer$ref = any;
export type DocumentRoutes_Contract_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_Contract_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: ContractContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: ContractContainer_viewer$ref
  |},
|};
export type DocumentRoutes_Contract_Query = {|
  variables: DocumentRoutes_Contract_QueryVariables,
  response: DocumentRoutes_Contract_QueryResponse,
|};
*/

/*
query DocumentRoutes_Contract_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...ContractContainer_node
    id
  }
  viewer {
    ...ContractContainer_viewer
    id
  }
}

fragment ContractContainer_node on Contract {
  id
  title
  terms
  can_edit
  deletable
  editable
  share_token
  brand_logo_url
  brand_header
  contract_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  contract_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address
        address_visibility
        company_name
        company_name_visibility
        email
        email_visibility
        name
        name_visibility
        phone
        phone_visibility
        signature_type
        signature_typed_name
        signature_url
        signed_at
        signer_fills_fields
        signing_party
        share_token
        title
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          user_contacts {
            edges {
              node {
                first_name
                last_name
                user_contact_emails {
                  edges {
                    node {
                      address
                      id
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
      }
    }
  }
}

fragment ContractContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
  ...ScheduleContainer_viewer
  primary_brand {
    id
  }
  ...LibraryContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "share_token",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v7 = [v6],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_Contract_Query",
    "id": null,
    "text": "query DocumentRoutes_Contract_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContractContainer_node\n    id\n  }\n  viewer {\n    ...ContractContainer_viewer\n    id\n  }\n}\n\nfragment ContractContainer_node on Contract {\n  id\n  title\n  terms\n  can_edit\n  deletable\n  editable\n  share_token\n  brand_logo_url\n  brand_header\n  contract_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  contract_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address\n        address_visibility\n        company_name\n        company_name_visibility\n        email\n        email_visibility\n        name\n        name_visibility\n        phone\n        phone_visibility\n        signature_type\n        signature_typed_name\n        signature_url\n        signed_at\n        signer_fills_fields\n        signing_party\n        share_token\n        title\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          user_contacts {\n            edges {\n              node {\n                first_name\n                last_name\n                user_contact_emails {\n                  edges {\n                    node {\n                      address\n                      id\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContractContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n  ...ScheduleContainer_viewer\n  primary_brand {\n    id\n  }\n  ...LibraryContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_Contract_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContractContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContractContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_Contract_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Contract",
          "selections": [v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "editable",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_event_segments",
            "storageKey": "contract_event_segments(first:99999)",
            "args": v7,
            "concreteType": "ContractEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, v8, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, v10, v11, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, v12, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, v13]
            }, v14]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_event_segments",
            "args": v7,
            "handle": "connection",
            "key": "ContractContainer_contract_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_line_items",
            "storageKey": "contract_line_items(first:99999)",
            "args": v7,
            "concreteType": "ContractLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractLineItem",
                "plural": false,
                "selections": [v3, v15, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, v16, v17, v18, v5, v2]
              }, v13]
            }, v14]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_line_items",
            "args": v7,
            "handle": "connection",
            "key": "ContractContainer_contract_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract_signature_blocks",
            "storageKey": "contract_signature_blocks(first:99999)",
            "args": v7,
            "concreteType": "ContractSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractSignatureBlock",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                }, v19, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, v4, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, v13]
            }, v14]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "contract_signature_blocks",
            "args": v7,
            "handle": "connection",
            "key": "ContractContainer_contract_signature_blocks",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [v20, v21, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v19, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, v20, v21, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v6, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v5]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v8, v9, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v7,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v5, v8, v9, v10, v11, v12, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_line_items",
          "storageKey": "user_line_items(first:99999)",
          "args": v7,
          "concreteType": "UserLineItemConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserLineItemEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserLineItem",
              "plural": false,
              "selections": [v3, v15, v16, v17, v18, v5, v2]
            }, v13]
          }, v14]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_line_items",
          "args": v7,
          "handle": "connection",
          "key": "LibraryContainer_user_line_items",
          "filters": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '9bf8320214b3fa61c05f8e40164bc187';
module.exports = node;

/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 180ff7528a94c524c204237d3cba16a1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
type EstimateContainer_viewer$ref = any;
export type DocumentRoutes_Estimate_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_Estimate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EstimateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: EstimateContainer_viewer$ref
  |},
|};
export type DocumentRoutes_Estimate_Query = {|
  variables: DocumentRoutes_Estimate_QueryVariables,
  response: DocumentRoutes_Estimate_QueryResponse,
|};
*/

/*
query DocumentRoutes_Estimate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EstimateContainer_node
    id
  }
  viewer {
    ...EstimateContainer_viewer
    id
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment EstimateContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
  ...ScheduleContainer_viewer
  primary_brand {
    id
  }
  features {
    hide_estimate_total
    id
  }
  ...LibraryContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v7 = [v6],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_Estimate_Query",
    "id": null,
    "text": "query DocumentRoutes_Estimate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EstimateContainer_node\n    id\n  }\n  viewer {\n    ...EstimateContainer_viewer\n    id\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment EstimateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n  ...ScheduleContainer_viewer\n  primary_brand {\n    id\n  }\n  features {\n    hide_estimate_total\n    id\n  }\n  ...LibraryContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_Estimate_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EstimateContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EstimateContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_Estimate_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Estimate",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "hide_total",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_event_segments",
            "storageKey": "estimate_event_segments(first:99999)",
            "args": v7,
            "concreteType": "EstimateEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, v8, v9, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, v10, v11, v5, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, v12, v4, v2]
              }, v13]
            }, v14]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_event_segments",
            "args": v7,
            "handle": "connection",
            "key": "EstimateContainer_estimate_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate_line_items",
            "storageKey": "estimate_line_items(first:99999)",
            "args": v7,
            "concreteType": "EstimateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EstimateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateLineItem",
                "plural": false,
                "selections": [v3, v15, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, v16, v17, v18, v5, v2]
              }, v13]
            }, v14]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "estimate_line_items",
            "args": v7,
            "handle": "connection",
            "key": "EstimateContainer_estimate_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [v19, v20, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, v19, v20, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v6, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v5]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v8, v9, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v7,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v5, v8, v9, v10, v11, v12, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "features",
          "storageKey": null,
          "args": null,
          "concreteType": "Features",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "hide_estimate_total",
            "args": null,
            "storageKey": null
          }, v3]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_line_items",
          "storageKey": "user_line_items(first:99999)",
          "args": v7,
          "concreteType": "UserLineItemConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserLineItemEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserLineItem",
              "plural": false,
              "selections": [v3, v15, v16, v17, v18, v5, v2]
            }, v13]
          }, v14]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_line_items",
          "args": v7,
          "handle": "connection",
          "key": "LibraryContainer_user_line_items",
          "filters": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8ca5ee116c2531f140027a6c4be6dc40';
module.exports = node;

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b970c57844a9e6d513cf08f9508818f5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type FormContainer_node$ref = any;
type FormContainer_viewer$ref = any;
export type DocumentRoutes_Form_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_Form_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: FormContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: FormContainer_viewer$ref
  |},
|};
export type DocumentRoutes_Form_Query = {|
  variables: DocumentRoutes_Form_QueryVariables,
  response: DocumentRoutes_Form_QueryResponse,
|};
*/

/*
query DocumentRoutes_Form_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...FormContainer_node
    id
  }
  viewer {
    ...FormContainer_viewer
    id
  }
}

fragment FormContainer_node on Form {
  id
  brand_logo_url
  brand_header
  title
  can_edit
  can_email
  share_token
  data
  schema
  ui_schema
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment FormContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_Form_Query",
    "id": null,
    "text": "query DocumentRoutes_Form_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...FormContainer_node\n    id\n  }\n  viewer {\n    ...FormContainer_viewer\n    id\n  }\n}\n\nfragment FormContainer_node on Form {\n  id\n  brand_logo_url\n  brand_header\n  title\n  can_edit\n  can_email\n  share_token\n  data\n  schema\n  ui_schema\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment FormContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_Form_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FormContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FormContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_Form_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "InlineFragment",
          "type": "Form",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "data",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "ui_schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v2, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [v3, v4, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v2]
                            }]
                          }]
                        }, v2]
                      }, v2]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, v3, v4, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '62ee11663437b024af5553544675a56d';
module.exports = node;

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c6d12d4ea602db5b7d8d05e614614ded
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceContainer_node$ref = any;
type InvoiceContainer_viewer$ref = any;
export type DocumentRoutes_Invoice_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_Invoice_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: InvoiceContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: InvoiceContainer_viewer$ref
  |},
|};
export type DocumentRoutes_Invoice_Query = {|
  variables: DocumentRoutes_Invoice_QueryVariables,
  response: DocumentRoutes_Invoice_QueryResponse,
|};
*/

/*
query DocumentRoutes_Invoice_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...InvoiceContainer_node
    id
  }
  viewer {
    ...InvoiceContainer_viewer
    id
  }
}

fragment InvoiceContainer_node on Invoice {
  id
  title
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  deletable
  down_payment_cents
  down_payment_currency
  down_payment_distribution_type
  down_payment_due_at
  down_payment_percent
  down_payment_status
  number
  pplan_distribution_type
  total_cents
  total_paid_cents
  accepted_payment_methods {
    edges {
      node {
        __typename
        ... on CashPaymentMethod {
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          id
          enabled
          label
          instructions
        }
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
          location_name
        }
        ... on Node {
          id
        }
      }
    }
  }
  i_pplan_items {
    edges {
      node {
        amount_cents
        amount_currency
        due_at
        id
        locked
        status
      }
    }
  }
  invoice_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  invoice_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  payments {
    edges {
      node {
        __typename
        ... on CashPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CheckPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on CustomPayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          notes
          status
          label
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on SquarePayment {
          __typename
          id
          amount_cents
          amount_currency
          name
          paid_at
          refunds {
            edges {
              node {
                id
                amount_cents
                amount_currency
                notes
                refunded_at
              }
            }
          }
        }
        ... on Node {
          id
        }
      }
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment InvoiceContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  payment_methods(first: 99999) {
    edges {
      node {
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
          application_id
          location_id
        }
        ... on CashPaymentMethod {
          __typename
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          __typename
          id
          label
          enabled
          instructions
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...AvailabilityCalendarContainer_viewer
  ...ScheduleContainer_viewer
  primary_brand {
    id
  }
  ...LibraryContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "application_id",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location_id",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "InlineFragment",
    "type": "CheckPaymentMethod",
    "selections": [v10, v5, {
      "kind": "ScalarField",
      "alias": null,
      "name": "pay_to",
      "args": null,
      "storageKey": null
    }]
  },
      v12 = {
    "kind": "InlineFragment",
    "type": "CashPaymentMethod",
    "selections": [v5, v9]
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "status",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v17 = [v16],
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v22 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v23 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v24 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v25 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v26 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v27 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v28 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v29 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v30 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v31 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  },
      v32 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "refunds",
    "storageKey": null,
    "args": null,
    "concreteType": "RefundConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Refund",
        "plural": false,
        "selections": [v3, v13, v14, v23, {
          "kind": "ScalarField",
          "alias": null,
          "name": "refunded_at",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  },
      v33 = [v2, v13, v14, v30, v23, v15, v31, v32],
      v34 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v35 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_Invoice_Query",
    "id": null,
    "text": "query DocumentRoutes_Invoice_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...InvoiceContainer_node\n    id\n  }\n  viewer {\n    ...InvoiceContainer_viewer\n    id\n  }\n}\n\nfragment InvoiceContainer_node on Invoice {\n  id\n  title\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  deletable\n  down_payment_cents\n  down_payment_currency\n  down_payment_distribution_type\n  down_payment_due_at\n  down_payment_percent\n  down_payment_status\n  number\n  pplan_distribution_type\n  total_cents\n  total_paid_cents\n  accepted_payment_methods {\n    edges {\n      node {\n        __typename\n        ... on CashPaymentMethod {\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n          location_name\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  i_pplan_items {\n    edges {\n      node {\n        amount_cents\n        amount_currency\n        due_at\n        id\n        locked\n        status\n      }\n    }\n  }\n  invoice_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  invoice_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  payments {\n    edges {\n      node {\n        __typename\n        ... on CashPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CheckPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on CustomPayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          notes\n          status\n          label\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on SquarePayment {\n          __typename\n          id\n          amount_cents\n          amount_currency\n          name\n          paid_at\n          refunds {\n            edges {\n              node {\n                id\n                amount_cents\n                amount_currency\n                notes\n                refunded_at\n              }\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment InvoiceContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  payment_methods(first: 99999) {\n    edges {\n      node {\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n          application_id\n          location_id\n        }\n        ... on CashPaymentMethod {\n          __typename\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          __typename\n          id\n          label\n          enabled\n          instructions\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...AvailabilityCalendarContainer_viewer\n  ...ScheduleContainer_viewer\n  primary_brand {\n    id\n  }\n  ...LibraryContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_Invoice_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "InvoiceContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "InvoiceContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_Invoice_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "Invoice",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_currency",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "deletable",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_cents",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_due_at",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_percent",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "down_payment_status",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "pplan_distribution_type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_paid_cents",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "accepted_payment_methods",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentMethodEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [v5, v6, v7, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location_name",
                    "args": null,
                    "storageKey": null
                  }]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [v5, v8, v9]
                }, v11, v12]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "i_pplan_items",
            "storageKey": null,
            "args": null,
            "concreteType": "IPplanItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "IPplanItem",
                "plural": false,
                "selections": [v13, v14, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                }, v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                }, v15]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_event_segments",
            "storageKey": "invoice_event_segments(first:99999)",
            "args": v17,
            "concreteType": "InvoiceEventSegmentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegmentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceEventSegment",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                }, v3, v18, v19, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                }, v20, v21, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                }, v22, v23, v2]
              }, v24]
            }, v25]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_event_segments",
            "args": v17,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_event_segments",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice_line_items",
            "storageKey": "invoice_line_items(first:99999)",
            "args": v17,
            "concreteType": "InvoiceLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "InvoiceLineItem",
                "plural": false,
                "selections": [v3, v26, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, v27, v28, v29, v4, v2]
              }, v24]
            }, v25]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "invoice_line_items",
            "args": v17,
            "handle": "connection",
            "key": "InvoiceContainer_invoice_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "payments",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PaymentEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [v2, v13, v14, v30, v31, v32]
                }, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [v2, v13, v14, v30, v23, v15, v8, v31, v32]
                }, {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v33
                }, {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v33
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [v34, v35, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [v10, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, v34, v35, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "payment_methods",
          "storageKey": "payment_methods(first:99999)",
          "args": v17,
          "concreteType": "PaymentMethodConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v3, v2, {
                "kind": "InlineFragment",
                "type": "CustomPaymentMethod",
                "selections": [v8, v5, v9]
              }, v11, v12, {
                "kind": "InlineFragment",
                "type": "SquarePaymentMethod",
                "selections": [v5, v6, v7]
              }]
            }, v24]
          }, v25]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "payment_methods",
          "args": v17,
          "handle": "connection",
          "key": "InvoiceContainer_payment_methods",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v16, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v4]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v18, v19, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v17,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v4, v18, v19, v20, v21, v22, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_line_items",
          "storageKey": "user_line_items(first:99999)",
          "args": v17,
          "concreteType": "UserLineItemConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserLineItemEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserLineItem",
              "plural": false,
              "selections": [v3, v26, v27, v28, v29, v4, v2]
            }, v24]
          }, v25]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_line_items",
          "args": v17,
          "handle": "connection",
          "key": "LibraryContainer_user_line_items",
          "filters": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f4245bef0e1736489de0717c20cbb9dd';
module.exports = node;

/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fc09a05deddf12fd4c47db98caaf13cf
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MusicPlannerContainer_node$ref = any;
type MusicPlannerContainer_viewer$ref = any;
export type DocumentRoutes_MusicPlanner_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_MusicPlanner_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MusicPlannerContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: MusicPlannerContainer_viewer$ref
  |},
|};
export type DocumentRoutes_MusicPlanner_Query = {|
  variables: DocumentRoutes_MusicPlanner_QueryVariables,
  response: DocumentRoutes_MusicPlanner_QueryResponse,
|};
*/

/*
query DocumentRoutes_MusicPlanner_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...MusicPlannerContainer_node
    id
  }
  viewer {
    ...MusicPlannerContainer_viewer
    id
  }
}

fragment MusicPlannerContainer_node on MusicPlanner {
  id
  title
  description
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  planner_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment MusicPlannerContainer_viewer on User {
  id
  first_name
  last_name
  ...AvailabilityCalendarContainer_viewer
  primary_brand {
    id
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v7 = [v6],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_MusicPlanner_Query",
    "id": null,
    "text": "query DocumentRoutes_MusicPlanner_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MusicPlannerContainer_node\n    id\n  }\n  viewer {\n    ...MusicPlannerContainer_viewer\n    id\n  }\n}\n\nfragment MusicPlannerContainer_node on MusicPlanner {\n  id\n  title\n  description\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  planner_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment MusicPlannerContainer_viewer on User {\n  id\n  first_name\n  last_name\n  ...AvailabilityCalendarContainer_viewer\n  primary_brand {\n    id\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_MusicPlanner_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MusicPlannerContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MusicPlannerContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_MusicPlanner_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "MusicPlanner",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "can_email",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "share_token",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_header",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlists",
            "storageKey": "planner_playlists(first:99999)",
            "args": v7,
            "concreteType": "PlannerPlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylist",
                "plural": false,
                "selections": [v3, v5, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "thumbnail",
                  "storageKey": "thumbnail(height:240,width:240)",
                  "args": [{
                    "kind": "Literal",
                    "name": "height",
                    "value": 240,
                    "type": "Int"
                  }, {
                    "kind": "Literal",
                    "name": "width",
                    "value": 240,
                    "type": "Int"
                  }],
                  "concreteType": "SongImage",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "width",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "height",
                    "args": null,
                    "storageKey": null
                  }, v3]
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "num_songs",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "planner_playlists",
            "args": v7,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlists",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [v3, {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_contacts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactConnectionWithRole",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactEdge",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [v8, v9, {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "user_contact_emails",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmailConnection",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserContactEmailEdge",
                            "plural": true,
                            "selections": [{
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContactEmail",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                              }, v3]
                            }]
                          }]
                        }, v3]
                      }, v3]
                    }]
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, v8, v9, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v6, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v5]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v10, v11, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v7,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v5, v10, v11, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "all_day",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0ca681317554eb2dc58c8238bec9b100';
module.exports = node;

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 29217658abcaeef140ace72532ab9176
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
type PlannerPlaylistContainer_viewer$ref = any;
export type DocumentRoutes_PlannerPlaylist_QueryVariables = {|
  playlist_id: string
|};
export type DocumentRoutes_PlannerPlaylist_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: PlannerPlaylistContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: PlannerPlaylistContainer_viewer$ref
  |},
|};
export type DocumentRoutes_PlannerPlaylist_Query = {|
  variables: DocumentRoutes_PlannerPlaylist_QueryVariables,
  response: DocumentRoutes_PlannerPlaylist_QueryResponse,
|};
*/

/*
query DocumentRoutes_PlannerPlaylist_Query(
  $playlist_id: ID!
) {
  node(id: $playlist_id) {
    __typename
    ...PlannerPlaylistContainer_node_2S1MTY
    id
  }
  viewer {
    ...PlannerPlaylistContainer_viewer
    id
  }
}

fragment PlannerPlaylistContainer_node_2S1MTY on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}

fragment PlannerPlaylistContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  public_playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "playlist_id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "playlist_id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v8, v9, v10, v3]
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v8, v9, v10]
      }]
    }]
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DocumentRoutes_PlannerPlaylist_Query",
    "id": null,
    "text": "query DocumentRoutes_PlannerPlaylist_Query(\n  $playlist_id: ID!\n) {\n  node(id: $playlist_id) {\n    __typename\n    ...PlannerPlaylistContainer_node_2S1MTY\n    id\n  }\n  viewer {\n    ...PlannerPlaylistContainer_viewer\n    id\n  }\n}\n\nfragment PlannerPlaylistContainer_node_2S1MTY on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  public_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DocumentRoutes_PlannerPlaylist_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PlannerPlaylistContainer_node",
          "args": [{
            "kind": "Variable",
            "name": "id",
            "variableName": "playlist_id",
            "type": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PlannerPlaylistContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DocumentRoutes_PlannerPlaylist_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "PlannerPlaylist",
          "selections": [v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v6, v7, v11, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v7, v5, v11, v4]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "storageKey": "planner_playlist_songs(first:99999)",
            "args": v12,
            "concreteType": "PlannerPlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlannerPlaylistSong",
                "plural": false,
                "selections": [v3, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v13, v14, v15, v16, v17]
                }, v2]
              }, v18]
            }, v19]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "planner_playlist_songs",
            "args": v12,
            "handle": "connection",
            "key": "MusicPlannerContainer_planner_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "music_planner",
            "storageKey": null,
            "args": null,
            "concreteType": "MusicPlanner",
            "plural": false,
            "selections": [v3, v20]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlists",
          "storageKey": "playlists(first:99999)",
          "args": v12,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v20, v7, v5, v4, v11, v2]
            }, v18]
          }, v19]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "playlists",
          "args": v12,
          "handle": "connection",
          "key": "PlannerPlaylistContainer_playlists",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "public_playlists",
          "storageKey": "public_playlists(first:99999)",
          "args": v12,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v20, v7, v5, v4, v11]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '39d626f32cfa517f10b07452f57ab588';
module.exports = node;

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ba9d1a24cba3d4973967420e33bd73c1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type EventCalendarQuery_UserEvent_Refetch_QueryVariables = {|
  visibility?: ?$ReadOnlyArray<?UserEventVisibility>,
  booking_status?: ?$ReadOnlyArray<?BookingStatus>,
|};
export type EventCalendarQuery_UserEvent_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventCalendarContainer_viewer$ref
  |}
|};
export type EventCalendarQuery_UserEvent_Refetch_Query = {|
  variables: EventCalendarQuery_UserEvent_Refetch_QueryVariables,
  response: EventCalendarQuery_UserEvent_Refetch_QueryResponse,
|};
*/

/*
query EventCalendarQuery_UserEvent_Refetch_Query(
  $visibility: [UserEventVisibility]
  $booking_status: [BookingStatus]
) {
  viewer {
    ...EventCalendarContainer_viewer_24sXjm
    id
  }
}

fragment EventCalendarContainer_viewer_24sXjm on User {
  id
  calendar_token
  s_time_zone
  ...AvailabilityCalendarContainer_viewer_1Ki8vT
  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        user_event_segments(first: 99999) {
          edges {
            node {
              all_day
              title
              start_at
              end_at
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer_1Ki8vT on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "visibility",
    "type": "[UserEventVisibility]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "booking_status",
    "type": "[BookingStatus]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = {
    "kind": "Variable",
    "name": "booking_status",
    "variableName": "booking_status",
    "type": "[BookingStatus]"
  },
      v3 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v4 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v5 = {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility",
    "type": "[UserEventVisibility]"
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "event",
    "storageKey": null,
    "args": null,
    "concreteType": "Event",
    "plural": false,
    "selections": [v1, v6]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v11 = [v3],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventCalendarQuery_UserEvent_Refetch_Query",
    "id": null,
    "text": "query EventCalendarQuery_UserEvent_Refetch_Query(\n  $visibility: [UserEventVisibility]\n  $booking_status: [BookingStatus]\n) {\n  viewer {\n    ...EventCalendarContainer_viewer_24sXjm\n    id\n  }\n}\n\nfragment EventCalendarContainer_viewer_24sXjm on User {\n  id\n  calendar_token\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer_1Ki8vT\n  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              all_day\n              title\n              start_at\n              end_at\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer_1Ki8vT on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventCalendarQuery_UserEvent_Refetch_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventCalendarContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "booking_status",
            "variableName": "booking_status",
            "type": null
          }, {
            "kind": "Variable",
            "name": "visibility",
            "variableName": "visibility",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventCalendarQuery_UserEvent_Refetch_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "calendar_token",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [v2, v3, v4, v5],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [v7, v8, v9, v10, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v11,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v6, v9, v10, v12, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }, v1]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": "EventCalendar_user_events",
          "name": "user_events",
          "storageKey": null,
          "args": [v2, v4, v5],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [v7, v8, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v11,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v12, v6, v9, v10, v1]
                  }]
                }]
              }, v1]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8fcf5d8eb6cdb32a2cb7b051d5b8b96f';
module.exports = node;

/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0cc9d80f34bd62f8999fc7185786617d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventListContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type EventFilterAndSort = "PAST" | "RECENT" | "UPCOMING" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type EventListQuery_UserEvent_Pagination_QueryVariables = {|
  count: number,
  cursor?: ?string,
  visibility?: ?$ReadOnlyArray<?UserEventVisibility>,
  sortBy?: ?EventFilterAndSort,
  booking_status?: ?$ReadOnlyArray<?BookingStatus>,
|};
export type EventListQuery_UserEvent_Pagination_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventListContainer_viewer$ref
  |}
|};
export type EventListQuery_UserEvent_Pagination_Query = {|
  variables: EventListQuery_UserEvent_Pagination_QueryVariables,
  response: EventListQuery_UserEvent_Pagination_QueryResponse,
|};
*/

/*
query EventListQuery_UserEvent_Pagination_Query(
  $count: Int!
  $cursor: String
  $visibility: [UserEventVisibility]
  $sortBy: EventFilterAndSort
  $booking_status: [BookingStatus]
) {
  viewer {
    ...EventListContainer_viewer
    id
  }
}

fragment EventListContainer_viewer on User {
  id
  s_time_zone
  user_events(first: $count, after: $cursor, visibility: $visibility, filter_and_sort: $sortBy, booking_status: $booking_status) {
    edges {
      node {
        id
        event {
          id
          title
          start_at
          end_at
        }
        booking_status
        start_at
        end_at
        visibility
        user_event_segments(first: 99999) {
          edges {
            node {
              location
              room
              id
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "visibility",
    "type": "[UserEventVisibility]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "EventFilterAndSort",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "booking_status",
    "type": "[BookingStatus]",
    "defaultValue": null
  }],
      v1 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v2 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "booking_status",
    "variableName": "booking_status",
    "type": "[BookingStatus]"
  }, {
    "kind": "Variable",
    "name": "filter_and_sort",
    "variableName": "sortBy",
    "type": "EventFilterAndSort"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }, {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility",
    "type": "[UserEventVisibility]"
  }],
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventListQuery_UserEvent_Pagination_Query",
    "id": null,
    "text": "query EventListQuery_UserEvent_Pagination_Query(\n  $count: Int!\n  $cursor: String\n  $visibility: [UserEventVisibility]\n  $sortBy: EventFilterAndSort\n  $booking_status: [BookingStatus]\n) {\n  viewer {\n    ...EventListContainer_viewer\n    id\n  }\n}\n\nfragment EventListContainer_viewer on User {\n  id\n  s_time_zone\n  user_events(first: $count, after: $cursor, visibility: $visibility, filter_and_sort: $sortBy, booking_status: $booking_status) {\n    edges {\n      node {\n        id\n        event {\n          id\n          title\n          start_at\n          end_at\n        }\n        booking_status\n        start_at\n        end_at\n        visibility\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              location\n              room\n              id\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventListQuery_UserEvent_Pagination_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventListContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventListQuery_UserEvent_Pagination_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v1, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_events",
          "storageKey": null,
          "args": v2,
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [v1, {
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v1, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }, v3, v4]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v3, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "visibility",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 99999,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v1]
                  }]
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_events",
          "args": v2,
          "handle": "connection",
          "key": "EventList_user_events",
          "filters": ["visibility", "filter_and_sort", "booking_status"]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '08c4b98d043230759b41ff9a3e0ae53f';
module.exports = node;

/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8d4e43cd8d68941980e1807eddbeb7c5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PipelinesContainer_viewer$ref = any;
export type EventListRoute_Pipelines_QueryVariables = {||};
export type EventListRoute_Pipelines_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PipelinesContainer_viewer$ref
  |}
|};
export type EventListRoute_Pipelines_Query = {|
  variables: EventListRoute_Pipelines_QueryVariables,
  response: EventListRoute_Pipelines_QueryResponse,
|};
*/

/*
query EventListRoute_Pipelines_Query {
  viewer {
    ...PipelinesContainer_viewer
    id
  }
}

fragment PipelinesContainer_viewer on User {
  id
  s_time_zone
  pipelines(first: 99999) {
    edges {
      node {
        id
        title
        plists(first: 99999) {
          edges {
            node {
              id
              title
              position
              plist_events(first: 99999) {
                edges {
                  node {
                    id
                    position
                    event {
                      id
                      user_event {
                        booking_status
                        start_at
                        end_at
                        user_event_segments(first: 99999) {
                          edges {
                            node {
                              location
                              room
                              id
                            }
                          }
                        }
                        event {
                          id
                          title
                          start_at
                          end_at
                        }
                        id
                      }
                    }
                    __typename
                  }
                  cursor
                }
                pageInfo {
                  endCursor
                  hasNextPage
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...SearchContainer_viewer
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventListRoute_Pipelines_Query",
    "id": null,
    "text": "query EventListRoute_Pipelines_Query {\n  viewer {\n    ...PipelinesContainer_viewer\n    id\n  }\n}\n\nfragment PipelinesContainer_viewer on User {\n  id\n  s_time_zone\n  pipelines(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        plists(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              position\n              plist_events(first: 99999) {\n                edges {\n                  node {\n                    id\n                    position\n                    event {\n                      id\n                      user_event {\n                        booking_status\n                        start_at\n                        end_at\n                        user_event_segments(first: 99999) {\n                          edges {\n                            node {\n                              location\n                              room\n                              id\n                            }\n                          }\n                        }\n                        event {\n                          id\n                          title\n                          start_at\n                          end_at\n                        }\n                        id\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...SearchContainer_viewer\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventListRoute_Pipelines_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PipelinesContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventListRoute_Pipelines_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "pipelines",
          "storageKey": "pipelines(first:99999)",
          "args": v1,
          "concreteType": "PipelineConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PipelineEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Pipeline",
              "plural": false,
              "selections": [v0, v2, {
                "kind": "LinkedField",
                "alias": null,
                "name": "plists",
                "storageKey": "plists(first:99999)",
                "args": v1,
                "concreteType": "PlistConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PlistEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Plist",
                    "plural": false,
                    "selections": [v0, v2, v3, {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "plist_events",
                      "storageKey": "plist_events(first:99999)",
                      "args": v1,
                      "concreteType": "PlistEventConnection",
                      "plural": false,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlistEventEdge",
                        "plural": true,
                        "selections": [{
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PlistEvent",
                          "plural": false,
                          "selections": [v0, v3, {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [v0, {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "user_event",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserEvent",
                              "plural": false,
                              "selections": [v4, v5, v6, {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_event_segments",
                                "storageKey": "user_event_segments(first:99999)",
                                "args": v1,
                                "concreteType": "UserEventSegmentConnection",
                                "plural": false,
                                "selections": [{
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "edges",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "UserEventSegmentEdge",
                                  "plural": true,
                                  "selections": [{
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserEventSegment",
                                    "plural": false,
                                    "selections": [v7, {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "room",
                                      "args": null,
                                      "storageKey": null
                                    }, v0]
                                  }]
                                }]
                              }, {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "event",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Event",
                                "plural": false,
                                "selections": [v0, v2, v5, v6]
                              }, v0]
                            }]
                          }, v8]
                        }, v9]
                      }, v10]
                    }, {
                      "kind": "LinkedHandle",
                      "alias": null,
                      "name": "plist_events",
                      "args": v1,
                      "handle": "connection",
                      "key": "PipelinesContainer_plist_events",
                      "filters": null
                    }, v8]
                  }, v9]
                }, v10]
              }, {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "plists",
                "args": v1,
                "handle": "connection",
                "key": "PipelinesContainer_plists",
                "filters": null
              }, v8]
            }, v9]
          }, v10]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "pipelines",
          "args": v1,
          "handle": "connection",
          "key": "PipelinesContainer_pipelines",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": "user_event_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v0, v2]
              }, v4, v5, v6, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v7, v0]
                  }]
                }]
              }, v0]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '535a2a312817f14b27d32e568982a2f3';
module.exports = node;

/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 09f3512e28e13d6fb16c2e0eea31e8bc
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventOverviewContainer_node$ref = any;
type EventOverviewContainer_viewer$ref = any;
export type EventRoutes_EventOverview_QueryVariables = {|
  id: string
|};
export type EventRoutes_EventOverview_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventOverviewContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: EventOverviewContainer_node$ref
  |},
|};
export type EventRoutes_EventOverview_Query = {|
  variables: EventRoutes_EventOverview_QueryVariables,
  response: EventRoutes_EventOverview_QueryResponse,
|};
*/

/*
query EventRoutes_EventOverview_Query(
  $id: ID!
) {
  viewer {
    ...EventOverviewContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...EventOverviewContainer_node
    id
  }
}

fragment EventOverviewContainer_viewer on User {
  id
}

fragment EventOverviewContainer_node on Event {
  id
  title
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventRoutes_EventOverview_Query",
    "id": null,
    "text": "query EventRoutes_EventOverview_Query(\n  $id: ID!\n) {\n  viewer {\n    ...EventOverviewContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...EventOverviewContainer_node\n    id\n  }\n}\n\nfragment EventOverviewContainer_viewer on User {\n  id\n}\n\nfragment EventOverviewContainer_node on Event {\n  id\n  title\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventRoutes_EventOverview_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventOverviewContainer_viewer",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventOverviewContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventRoutes_EventOverview_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v3, v2, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [v4, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v5,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, v4, v3]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "pageInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "PageInfo",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }]
            }]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v5,
            "handle": "connection",
            "key": "EventOverviewContainer_workspaces",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8cd4326537158460731fcc0cdaa3100e';
module.exports = node;

/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 291e9e3769a5157a0285969538e1a531
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventShowContainer_node$ref = any;
type EventShowContainer_viewer$ref = any;
export type EventRoutes_EventShow_QueryVariables = {|
  id: string
|};
export type EventRoutes_EventShow_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventShowContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: EventShowContainer_node$ref
  |},
|};
export type EventRoutes_EventShow_Query = {|
  variables: EventRoutes_EventShow_QueryVariables,
  response: EventRoutes_EventShow_QueryResponse,
|};
*/

/*
query EventRoutes_EventShow_Query(
  $id: ID!
) {
  viewer {
    ...EventShowContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...EventShowContainer_node
    id
  }
}

fragment EventShowContainer_viewer on User {
  id
  past_referral_sources
  c_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  form_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  mp_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  features {
    music_lists
    id
  }
  ...EventSummaryContainer_viewer
  ...AvailabilityCheckerContainer_viewer
  ...AvailabilityCalendarContainer_viewer
}

fragment EventShowContainer_node on Event {
  id
  start_at
  end_at
  all_day
  time_zone
  title
  can_edit
  user_event {
    id
    booking_status
    visibility
    start_at
    end_at
    time_zone
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...EventSummaryContainer_node
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment EventSummaryContainer_viewer on User {
  id
  past_referral_sources
  ...ContactSearchContainer_viewer
  ...ScheduleContainer_viewer
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ContactSearchContainer_viewer on User {
  user_contact_search(first: 3, query: "") {
    edges {
      node {
        id
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              number
              id
            }
          }
        }
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v4 = [v2, v3],
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v10 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v11 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "booking_status",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v15 = [v9],
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v19 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": v4
      }, v12, v13, v14, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": v15,
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v3, v13, v14, v16, v17, v18, v2]
          }]
        }]
      }, v2]
    }]
  }],
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v22 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v23 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line1",
    "args": null,
    "storageKey": null
  },
      v24 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line2",
    "args": null,
    "storageKey": null
  },
      v25 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
      v26 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "province",
    "args": null,
    "storageKey": null
  },
      v27 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
      v28 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v29 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v30 = [v2, v3, v20],
      v31 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventRoutes_EventShow_Query",
    "id": null,
    "text": "query EventRoutes_EventShow_Query(\n  $id: ID!\n) {\n  viewer {\n    ...EventShowContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...EventShowContainer_node\n    id\n  }\n}\n\nfragment EventShowContainer_viewer on User {\n  id\n  past_referral_sources\n  c_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  form_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  mp_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  features {\n    music_lists\n    id\n  }\n  ...EventSummaryContainer_viewer\n  ...AvailabilityCheckerContainer_viewer\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment EventShowContainer_node on Event {\n  id\n  start_at\n  end_at\n  all_day\n  time_zone\n  title\n  can_edit\n  user_event {\n    id\n    booking_status\n    visibility\n    start_at\n    end_at\n    time_zone\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...EventSummaryContainer_node\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment EventSummaryContainer_viewer on User {\n  id\n  past_referral_sources\n  ...ContactSearchContainer_viewer\n  ...ScheduleContainer_viewer\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ContactSearchContainer_viewer on User {\n  user_contact_search(first: 3, query: \"\") {\n    edges {\n      node {\n        id\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              number\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventRoutes_EventShow_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventShowContainer_viewer",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventShowContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventRoutes_EventShow_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "past_referral_sources",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "c_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplate",
              "plural": false,
              "selections": v4
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "form_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "FormTemplate",
              "plural": false,
              "selections": v4
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplate",
              "plural": false,
              "selections": v4
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "features",
          "storageKey": null,
          "args": null,
          "concreteType": "Features",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "music_lists",
            "args": null,
            "storageKey": null
          }, v2]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_search",
          "storageKey": "user_contact_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserContactConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContact",
              "plural": false,
              "selections": [v2, v5, v6, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_emails",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmailConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactEmailEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmail",
                    "plural": false,
                    "selections": [v7, v2]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_phones",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactPhoneConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactPhoneEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhone",
                    "plural": false,
                    "selections": [v8, v2]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v9, v10, v11],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v19
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v9, v10, v11],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v19
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v20, v2, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [v13, v14, v16, v21, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "can_edit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v2, v12, {
              "kind": "ScalarField",
              "alias": null,
              "name": "visibility",
              "args": null,
              "storageKey": null
            }, v13, v14, v21, v22, {
              "kind": "ScalarField",
              "alias": null,
              "name": "referral_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_event_segments",
              "storageKey": "user_event_segments(first:99999)",
              "args": v15,
              "concreteType": "UserEventSegmentConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegment",
                  "plural": false,
                  "selections": [v23, v2, v13, v14, v21, v16, v17, v3, v24, v25, v26, v27, v18, v22, v20]
                }, v28]
              }, v29]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "user_event_segments",
              "args": v15,
              "handle": "connection",
              "key": "ScheduleContainer_user_event_segments",
              "filters": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v15,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contracts",
                  "storageKey": "contracts(first:99999)",
                  "args": v15,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Contract",
                      "plural": false,
                      "selections": v30
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "contracts",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventShowContainer_contracts",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "estimates",
                  "storageKey": "estimates(first:99999)",
                  "args": v15,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Estimate",
                      "plural": false,
                      "selections": v30
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "estimates",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventShowContainer_estimates",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "forms",
                  "storageKey": "forms(first:99999)",
                  "args": v15,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Form",
                      "plural": false,
                      "selections": v30
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventShowContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoices",
                  "storageKey": "invoices(first:99999)",
                  "args": v15,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Invoice",
                      "plural": false,
                      "selections": v30
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "invoices",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventShowContainer_invoices",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "music_planners",
                  "storageKey": "music_planners(first:99999)",
                  "args": v15,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MusicPlannerEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlanner",
                      "plural": false,
                      "selections": v30
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventShowContainer_music_planners",
                  "filters": null
                }, v20]
              }, v28]
            }, v29]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v15,
            "handle": "connection",
            "key": "EventShowContainer_workspaces",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v15,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [v2, v5, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "storageKey": "user_contact_addresses(first:99999)",
                  "args": v15,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddress",
                      "plural": false,
                      "selections": [v2, v31, v23, v24, v25, v26, v27, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      }, v20]
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_addresses",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v15,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [v2, v31, v7, v20]
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_emails",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_emails",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_phones",
                  "storageKey": "user_contact_phones(first:99999)",
                  "args": v15,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhone",
                      "plural": false,
                      "selections": [v2, v31, v8, v20]
                    }, v28]
                  }, v29]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_phones",
                  "args": v15,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_phones",
                  "filters": null
                }, v20]
              }, v28]
            }, v29]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_contacts",
            "args": v15,
            "handle": "connection",
            "key": "EventSummaryContainer_user_contacts",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f3f563190842c0231d5b6407aa7946d9';
module.exports = node;

/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9e4ee7e4a8ff1a06e168d55408a8743a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventSummaryContainer_node$ref = any;
type EventSummaryContainer_viewer$ref = any;
export type EventRoutes_EventSummary_QueryVariables = {|
  id: string
|};
export type EventRoutes_EventSummary_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventSummaryContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: EventSummaryContainer_node$ref
  |},
|};
export type EventRoutes_EventSummary_Query = {|
  variables: EventRoutes_EventSummary_QueryVariables,
  response: EventRoutes_EventSummary_QueryResponse,
|};
*/

/*
query EventRoutes_EventSummary_Query(
  $id: ID!
) {
  viewer {
    ...EventSummaryContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...EventSummaryContainer_node
    id
  }
}

fragment EventSummaryContainer_viewer on User {
  id
  past_referral_sources
  ...ContactSearchContainer_viewer
  ...ScheduleContainer_viewer
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ContactSearchContainer_viewer on User {
  user_contact_search(first: 3, query: "") {
    edges {
      node {
        id
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        user_contact_phones {
          edges {
            node {
              number
              id
            }
          }
        }
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "first_name",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "last_name",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v11 = [v7],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "all_day",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "location",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "room",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "notes",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line1",
    "args": null,
    "storageKey": null
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "line2",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "city",
    "args": null,
    "storageKey": null
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "province",
    "args": null,
    "storageKey": null
  },
      v21 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "postal_code",
    "args": null,
    "storageKey": null
  },
      v22 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v23 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v24 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventRoutes_EventSummary_Query",
    "id": null,
    "text": "query EventRoutes_EventSummary_Query(\n  $id: ID!\n) {\n  viewer {\n    ...EventSummaryContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...EventSummaryContainer_node\n    id\n  }\n}\n\nfragment EventSummaryContainer_viewer on User {\n  id\n  past_referral_sources\n  ...ContactSearchContainer_viewer\n  ...ScheduleContainer_viewer\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ContactSearchContainer_viewer on User {\n  user_contact_search(first: 3, query: \"\") {\n    edges {\n      node {\n        id\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        user_contact_phones {\n          edges {\n            node {\n              number\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventRoutes_EventSummary_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventSummaryContainer_viewer",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventSummaryContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventRoutes_EventSummary_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "past_referral_sources",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_contact_search",
          "storageKey": "user_contact_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserContactConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserContactEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContact",
              "plural": false,
              "selections": [v2, v3, v4, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_emails",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactEmailConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactEmailEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmail",
                    "plural": false,
                    "selections": [v5, v2]
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contact_phones",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContactPhoneConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactPhoneEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhone",
                    "plural": false,
                    "selections": [v6, v2]
                  }]
                }]
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v7, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v2, v8]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v9, v10, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v11,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v8, v9, v10, v12, v13, v14, v2]
                  }]
                }]
              }, v2]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v15, v2, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v2, v16, {
              "kind": "ScalarField",
              "alias": null,
              "name": "referral_source",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "user_event_segments",
              "storageKey": "user_event_segments(first:99999)",
              "args": v11,
              "concreteType": "UserEventSegmentConnection",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegment",
                  "plural": false,
                  "selections": [v17, v2, v9, v10, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "time_zone",
                    "args": null,
                    "storageKey": null
                  }, v12, v13, v8, v18, v19, v20, v21, v14, v16, v15]
                }, v22]
              }, v23]
            }, {
              "kind": "LinkedHandle",
              "alias": null,
              "name": "user_event_segments",
              "args": v11,
              "handle": "connection",
              "key": "ScheduleContainer_user_event_segments",
              "filters": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v11,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [v2, v3, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "storageKey": "user_contact_addresses(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactAddressEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddress",
                      "plural": false,
                      "selections": [v2, v24, v17, v18, v19, v20, v21, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                      }, v15]
                    }, v22]
                  }, v23]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_addresses",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_addresses",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [v2, v24, v5, v15]
                    }, v22]
                  }, v23]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_emails",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_emails",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_phones",
                  "storageKey": "user_contact_phones(first:99999)",
                  "args": v11,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactPhoneEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhone",
                      "plural": false,
                      "selections": [v2, v24, v6, v15]
                    }, v22]
                  }, v23]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "user_contact_phones",
                  "args": v11,
                  "handle": "connection",
                  "key": "EventSummaryContainer_user_contact_phones",
                  "filters": null
                }, v15]
              }, v22]
            }, v23]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_contacts",
            "args": v11,
            "handle": "connection",
            "key": "EventSummaryContainer_user_contacts",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'db1e1792d4c17987d195756f15ccb17b';
module.exports = node;

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9368141aee024cf1ba30ec2338c592bc
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type WorkspacesContainer_node$ref = any;
type WorkspacesContainer_viewer$ref = any;
export type EventRoutes_Workspace_QueryVariables = {|
  id: string
|};
export type EventRoutes_Workspace_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: WorkspacesContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: WorkspacesContainer_node$ref
  |},
|};
export type EventRoutes_Workspace_Query = {|
  variables: EventRoutes_Workspace_QueryVariables,
  response: EventRoutes_Workspace_QueryResponse,
|};
*/

/*
query EventRoutes_Workspace_Query(
  $id: ID!
) {
  viewer {
    ...WorkspacesContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...WorkspacesContainer_node
    id
  }
}

fragment WorkspacesContainer_viewer on User {
  id
  ...AvailabilityCalendarContainer_viewer
}

fragment WorkspacesContainer_node on Event {
  id
  title
  start_at
  end_at
  time_zone
  can_edit
  user_contacts(first: 99999) {
    edges {
      node {
        first_name
        last_name
        user_contact_emails(first: 99999) {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
  user_event {
    start_at
    end_at
    time_zone
    id
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        share_token
        permissions
        can_email
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              can_edit
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              editable
              contract_signature_blocks {
                edges {
                  node {
                    signed_at
                    id
                  }
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        wuploads(first: 99999) {
          edges {
            node {
              id
              mimetype
              name
              url
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = [v3],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "time_zone",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v11 = [v2, v4, v8],
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "EventRoutes_Workspace_Query",
    "id": null,
    "text": "query EventRoutes_Workspace_Query(\n  $id: ID!\n) {\n  viewer {\n    ...WorkspacesContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...WorkspacesContainer_node\n    id\n  }\n}\n\nfragment WorkspacesContainer_viewer on User {\n  id\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment WorkspacesContainer_node on Event {\n  id\n  title\n  start_at\n  end_at\n  time_zone\n  can_edit\n  user_contacts(first: 99999) {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n  user_event {\n    start_at\n    end_at\n    time_zone\n    id\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        share_token\n        permissions\n        can_email\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              can_edit\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              editable\n              contract_signature_blocks {\n                edges {\n                  node {\n                    signed_at\n                    id\n                  }\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        wuploads(first: 99999) {\n          edges {\n            node {\n              id\n              mimetype\n              name\n              url\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "EventRoutes_Workspace_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "WorkspacesContainer_viewer",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "WorkspacesContainer_node",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "EventRoutes_Workspace_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v3, {
            "kind": "Literal",
            "name": "return_empty_connection",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "visibility",
            "value": ["SHOW"],
            "type": "[UserEventVisibility]"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v2, v4]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, v5, v6, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v7,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [v4, v5, v6, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "all_day",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "room",
                      "args": null,
                      "storageKey": null
                    }, v2]
                  }]
                }]
              }, v2]
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v8, v2, {
          "kind": "InlineFragment",
          "type": "Event",
          "selections": [v4, v5, v6, v9, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_contacts",
            "storageKey": "user_contacts(first:99999)",
            "args": v7,
            "concreteType": "EventUserContactConnectionWithRole",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EventUserContactEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "UserContact",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v7,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserContactEmailEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmail",
                      "plural": false,
                      "selections": [{
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "address",
                        "args": null,
                        "storageKey": null
                      }, v2]
                    }]
                  }]
                }, v2]
              }, v2]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [v5, v6, v9, v2]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspaces",
            "storageKey": "workspaces(first:99999)",
            "args": v7,
            "concreteType": "WorkspaceConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkspaceEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workspace",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoices",
                  "storageKey": "invoices(first:99999)",
                  "args": v7,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InvoiceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Invoice",
                      "plural": false,
                      "selections": v11
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "invoices",
                  "args": v7,
                  "handle": "connection",
                  "key": "EventShowContainer_invoices",
                  "filters": null
                }, v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "share_token",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "permissions",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "can_email",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "estimates",
                  "storageKey": "estimates(first:99999)",
                  "args": v7,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Estimate",
                      "plural": false,
                      "selections": v11
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "estimates",
                  "args": v7,
                  "handle": "connection",
                  "key": "EventShowContainer_estimates",
                  "filters": null
                }, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "forms",
                  "storageKey": "forms(first:99999)",
                  "args": v7,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FormEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Form",
                      "plural": false,
                      "selections": v11
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "forms",
                  "args": v7,
                  "handle": "connection",
                  "key": "WorkspacesContainer_forms",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "music_planners",
                  "storageKey": "music_planners(first:99999)",
                  "args": v7,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MusicPlannerEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlanner",
                      "plural": false,
                      "selections": [v2, v4, v10, v8]
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "music_planners",
                  "args": v7,
                  "handle": "connection",
                  "key": "WorkspacesContainer_music_planners",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "contracts",
                  "storageKey": "contracts(first:99999)",
                  "args": v7,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Contract",
                      "plural": false,
                      "selections": [v2, v4, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "editable",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract_signature_blocks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractSignatureBlockConnection",
                        "plural": false,
                        "selections": [{
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractSignatureBlockEdge",
                          "plural": true,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractSignatureBlock",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "signed_at",
                              "args": null,
                              "storageKey": null
                            }, v2]
                          }]
                        }]
                      }, v8]
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "contracts",
                  "args": v7,
                  "handle": "connection",
                  "key": "EventShowContainer_contracts",
                  "filters": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "wuploads",
                  "storageKey": "wuploads(first:99999)",
                  "args": v7,
                  "concreteType": "WuploadConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WuploadEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Wupload",
                      "plural": false,
                      "selections": [v2, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mimetype",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      }, v8]
                    }, v12]
                  }, v13]
                }, {
                  "kind": "LinkedHandle",
                  "alias": null,
                  "name": "wuploads",
                  "args": v7,
                  "handle": "connection",
                  "key": "WorkspacesContainer_wuploads",
                  "filters": null
                }, v8]
              }, v12]
            }, v13]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "workspaces",
            "args": v7,
            "handle": "connection",
            "key": "WorkspacesContainer_workspaces",
            "filters": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '976f86882954f77ad37f6de2592586dd';
module.exports = node;

/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 334cc549226f3a4e15c5d8528646f561
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceListContainer_viewer$ref = any;
export type InvoiceStatus = "ALL" | "OUTSTANDING" | "PAID" | "PAST_DUE" | "%future added value";
export type InvoiceQuery_Invoices_QueryVariables = {|
  count: number,
  cursor?: ?string,
  status?: ?InvoiceStatus,
|};
export type InvoiceQuery_Invoices_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: InvoiceListContainer_viewer$ref
  |}
|};
export type InvoiceQuery_Invoices_Query = {|
  variables: InvoiceQuery_Invoices_QueryVariables,
  response: InvoiceQuery_Invoices_QueryResponse,
|};
*/

/*
query InvoiceQuery_Invoices_Query(
  $count: Int!
  $cursor: String
  $status: InvoiceStatus
) {
  viewer {
    ...InvoiceListContainer_viewer_4qXjrI
    id
  }
}

fragment InvoiceListContainer_viewer_4qXjrI on User {
  invoices(status: $status, first: $count, after: $cursor) {
    edges {
      node {
        id
        title
        status
        total_cents
        outstanding_cents
        workspaces(first: 1) {
          edges {
            node {
              event {
                id
                title
              }
              id
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "status",
    "type": "InvoiceStatus",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }, {
    "kind": "Variable",
    "name": "status",
    "variableName": "status",
    "type": "InvoiceStatus"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "InvoiceQuery_Invoices_Query",
    "id": null,
    "text": "query InvoiceQuery_Invoices_Query(\n  $count: Int!\n  $cursor: String\n  $status: InvoiceStatus\n) {\n  viewer {\n    ...InvoiceListContainer_viewer_4qXjrI\n    id\n  }\n}\n\nfragment InvoiceListContainer_viewer_4qXjrI on User {\n  invoices(status: $status, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        title\n        status\n        total_cents\n        outstanding_cents\n        workspaces(first: 1) {\n          edges {\n            node {\n              event {\n                id\n                title\n              }\n              id\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "InvoiceQuery_Invoices_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "InvoiceListContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "count",
            "variableName": "count",
            "type": null
          }, {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor",
            "type": null
          }, {
            "kind": "Variable",
            "name": "status",
            "variableName": "status",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "InvoiceQuery_Invoices_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "invoices",
          "storageKey": null,
          "args": v1,
          "concreteType": "InvoiceConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "InvoiceEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Invoice",
              "plural": false,
              "selections": [v2, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "total_cents",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "outstanding_cents",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": "workspaces(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WorkspaceEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workspace",
                    "plural": false,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "event",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Event",
                      "plural": false,
                      "selections": [v2, v3]
                    }, v2]
                  }]
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "invoices",
          "args": v1,
          "handle": "connection",
          "key": "InvoiceList_invoices",
          "filters": ["status"]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '85f9c21b3c8cf23d9d2246126518156e';
module.exports = node;

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 67e17351cfdd4a0cb9ecff486a3715f2
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OutstandingPaymentsContainer_viewer$ref = any;
export type OutstandingPaymentsQuery_OutstandingPayments_QueryVariables = {|
  outstanding_payments_before?: ?any,
  outstanding_payments_after?: ?any,
  count: number,
  cursor?: ?string,
|};
export type OutstandingPaymentsQuery_OutstandingPayments_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OutstandingPaymentsContainer_viewer$ref
  |}
|};
export type OutstandingPaymentsQuery_OutstandingPayments_Query = {|
  variables: OutstandingPaymentsQuery_OutstandingPayments_QueryVariables,
  response: OutstandingPaymentsQuery_OutstandingPayments_QueryResponse,
|};
*/

/*
query OutstandingPaymentsQuery_OutstandingPayments_Query(
  $outstanding_payments_before: ISO8601Type
  $outstanding_payments_after: ISO8601Type
  $count: Int!
  $cursor: String
) {
  viewer {
    ...OutstandingPaymentsContainer_viewer_4vsBHL
    id
  }
}

fragment OutstandingPaymentsContainer_viewer_4vsBHL on User {
  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: $count, after: $cursor) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        payment_date
        invoice {
          id
          title
          workspaces {
            edges {
              node {
                event {
                  title
                  id
                }
                id
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "outstanding_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "outstanding_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "after_time",
    "variableName": "outstanding_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "outstanding_payments_before",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "OutstandingPaymentsQuery_OutstandingPayments_Query",
    "id": null,
    "text": "query OutstandingPaymentsQuery_OutstandingPayments_Query(\n  $outstanding_payments_before: ISO8601Type\n  $outstanding_payments_after: ISO8601Type\n  $count: Int!\n  $cursor: String\n) {\n  viewer {\n    ...OutstandingPaymentsContainer_viewer_4vsBHL\n    id\n  }\n}\n\nfragment OutstandingPaymentsContainer_viewer_4vsBHL on User {\n  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        payment_date\n        invoice {\n          id\n          title\n          workspaces {\n            edges {\n              node {\n                event {\n                  title\n                  id\n                }\n                id\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "OutstandingPaymentsQuery_OutstandingPayments_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "OutstandingPaymentsContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "count",
            "variableName": "count",
            "type": null
          }, {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_after",
            "variableName": "outstanding_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_before",
            "variableName": "outstanding_payments_before",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "OutstandingPaymentsQuery_OutstandingPayments_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "outstanding_payments",
          "storageKey": null,
          "args": v1,
          "concreteType": "OutstandingPaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OutstandingPaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OutstandingPayment",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "amount_cents",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "amount_currency",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "payment_date",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "invoice",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": [v2, v3, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "workspaces",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WorkspaceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Workspace",
                      "plural": false,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [v3, v2]
                      }, v2]
                    }]
                  }]
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "outstanding_payments",
          "args": v1,
          "handle": "connection",
          "key": "OutstandingPayments_outstanding_payments",
          "filters": ["before_time", "after_time"]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'bdec0cc65ea0e190ab2b32b83ed7fa1f';
module.exports = node;

/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 44a7d005ef682f27af8f1dd429ae47b1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type RefundsContainer_viewer$ref = any;
export type RefundsQuery_Refunds_QueryVariables = {|
  refunds_before?: ?any,
  refunds_after?: ?any,
  count: number,
  cursor?: ?string,
|};
export type RefundsQuery_Refunds_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: RefundsContainer_viewer$ref
  |}
|};
export type RefundsQuery_Refunds_Query = {|
  variables: RefundsQuery_Refunds_QueryVariables,
  response: RefundsQuery_Refunds_QueryResponse,
|};
*/

/*
query RefundsQuery_Refunds_Query(
  $refunds_before: ISO8601Type
  $refunds_after: ISO8601Type
  $count: Int!
  $cursor: String
) {
  viewer {
    ...RefundsContainer_viewer_45USx8
    id
  }
}

fragment RefundsContainer_viewer_45USx8 on User {
  s_time_zone
  refunds(before_time: $refunds_before, after_time: $refunds_after, first: $count, after: $cursor) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        refunded_at
        payment {
          __typename
          ... on CustomPayment {
            label
          }
          ... on Node {
            id
          }
        }
        invoice {
          id
          title
          workspaces {
            edges {
              node {
                event {
                  title
                  id
                }
                id
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "refunds_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "refunds_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "after_time",
    "variableName": "refunds_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "refunds_before",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "RefundsQuery_Refunds_Query",
    "id": null,
    "text": "query RefundsQuery_Refunds_Query(\n  $refunds_before: ISO8601Type\n  $refunds_after: ISO8601Type\n  $count: Int!\n  $cursor: String\n) {\n  viewer {\n    ...RefundsContainer_viewer_45USx8\n    id\n  }\n}\n\nfragment RefundsContainer_viewer_45USx8 on User {\n  s_time_zone\n  refunds(before_time: $refunds_before, after_time: $refunds_after, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        refunded_at\n        payment {\n          __typename\n          ... on CustomPayment {\n            label\n          }\n          ... on Node {\n            id\n          }\n        }\n        invoice {\n          id\n          title\n          workspaces {\n            edges {\n              node {\n                event {\n                  title\n                  id\n                }\n                id\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "RefundsQuery_Refunds_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "RefundsContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "count",
            "variableName": "count",
            "type": null
          }, {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_after",
            "variableName": "refunds_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_before",
            "variableName": "refunds_before",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "RefundsQuery_Refunds_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "refunds",
          "storageKey": null,
          "args": v1,
          "concreteType": "RefundConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "RefundEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Refund",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "amount_cents",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "amount_currency",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "refunded_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "payment",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v3, v2, {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "invoice",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": [v2, v4, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "workspaces",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WorkspaceConnection",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Workspace",
                      "plural": false,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [v4, v2]
                      }, v2]
                    }]
                  }]
                }]
              }, v3]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "refunds",
          "args": v1,
          "handle": "connection",
          "key": "Refunds_refunds",
          "filters": ["before_time", "after_time"]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '4149fc9624e1f3883c95a1cab8c375ee';
module.exports = node;

/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c3f0019cc4df7e263a88debac2984a54
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AppContainer_viewer$ref = any;
export type Route_App_QueryVariables = {||};
export type Route_App_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AppContainer_viewer$ref
  |}
|};
export type Route_App_Query = {|
  variables: Route_App_QueryVariables,
  response: Route_App_QueryResponse,
|};
*/

/*
query Route_App_Query {
  viewer {
    ...AppContainer_viewer
    id
  }
}

fragment AppContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  ...AvailabilityCheckerContainer_viewer
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v3 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v0, v4]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v5, v6, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": [v1],
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v4, v5, v6, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v0]
          }]
        }]
      }, v0]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "Route_App_Query",
    "id": null,
    "text": "query Route_App_Query {\n  viewer {\n    ...AppContainer_viewer\n    id\n  }\n}\n\nfragment AppContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Route_App_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "AppContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Route_App_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v1, v2, v3],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v1, v2, v3],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '0adaf99a9e0815b2ce2262b317f5739a';
module.exports = node;

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 77a1008160a269bc7fb69f29829b4fd7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type FinancialContainer_viewer$ref = any;
export type Route_Financials_QueryVariables = {||};
export type Route_Financials_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FinancialContainer_viewer$ref
  |}
|};
export type Route_Financials_Query = {|
  variables: Route_Financials_QueryVariables,
  response: Route_Financials_QueryResponse,
|};
*/

/*
query Route_Financials_Query {
  viewer {
    ...FinancialContainer_viewer
    id
  }
}

fragment FinancialContainer_viewer on User {
  ...AvailabilityCheckerContainer_viewer
  ...InvoicesContainer_viewer
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment InvoicesContainer_viewer on User {
  past_due_payments_cents
  outstanding_payments_cents
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v1 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v2 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v7 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v3, v4]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v5, v6, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": [v0],
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v4, v5, v6, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v3]
          }]
        }]
      }, v3]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "Route_Financials_Query",
    "id": null,
    "text": "query Route_Financials_Query {\n  viewer {\n    ...FinancialContainer_viewer\n    id\n  }\n}\n\nfragment FinancialContainer_viewer on User {\n  ...AvailabilityCheckerContainer_viewer\n  ...InvoicesContainer_viewer\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment InvoicesContainer_viewer on User {\n  past_due_payments_cents\n  outstanding_payments_cents\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Route_Financials_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FinancialContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Route_Financials_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v0, v1, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v0, v1, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v7
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "past_due_payments_cents",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "outstanding_payments_cents",
          "args": null,
          "storageKey": null
        }, v3]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f0c1f2b64c15906fdfa0e746edf41118';
module.exports = node;

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a49a00f2360550aeab700bdc669768ba
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoicesContainer_viewer$ref = any;
export type Route_Invoice_QueryVariables = {||};
export type Route_Invoice_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: InvoicesContainer_viewer$ref
  |}
|};
export type Route_Invoice_Query = {|
  variables: Route_Invoice_QueryVariables,
  response: Route_Invoice_QueryResponse,
|};
*/

/*
query Route_Invoice_Query {
  viewer {
    ...InvoicesContainer_viewer
    id
  }
}

fragment InvoicesContainer_viewer on User {
  past_due_payments_cents
  outstanding_payments_cents
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "Route_Invoice_Query",
  "id": null,
  "text": "query Route_Invoice_Query {\n  viewer {\n    ...InvoicesContainer_viewer\n    id\n  }\n}\n\nfragment InvoicesContainer_viewer on User {\n  past_due_payments_cents\n  outstanding_payments_cents\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Route_Invoice_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "InvoicesContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "Route_Invoice_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "past_due_payments_cents",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "outstanding_payments_cents",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '91c23dc7641aab73b8436b7e8959d8ba';
module.exports = node;

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8b670d311407369260815ccb4371266d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaymentsGraphContainer_viewer$ref = any;
export type Route_PaymentsGraph_QueryVariables = {|
  completed_payments_before?: ?any,
  completed_payments_after?: ?any,
  outstanding_payments_before?: ?any,
  outstanding_payments_after?: ?any,
  refunds_before?: ?any,
  refunds_after?: ?any,
|};
export type Route_PaymentsGraph_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PaymentsGraphContainer_viewer$ref
  |}
|};
export type Route_PaymentsGraph_Query = {|
  variables: Route_PaymentsGraph_QueryVariables,
  response: Route_PaymentsGraph_QueryResponse,
|};
*/

/*
query Route_PaymentsGraph_Query(
  $completed_payments_before: ISO8601Type
  $completed_payments_after: ISO8601Type
  $outstanding_payments_before: ISO8601Type
  $outstanding_payments_after: ISO8601Type
  $refunds_before: ISO8601Type
  $refunds_after: ISO8601Type
) {
  viewer {
    ...PaymentsGraphContainer_viewer_2qQdGx
    id
  }
}

fragment PaymentsGraphContainer_viewer_2qQdGx on User {
  s_time_zone
  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: 99999) {
    edges {
      node {
        ... on CashPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on CheckPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on CustomPayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on SquarePayment {
          id
          amount_cents
          amount_currency
          paid_at
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: 99999) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        payment_date
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  refunds(before_time: $refunds_before, after_time: $refunds_after, first: 99999) {
    edges {
      node {
        id
        amount_cents
        amount_currency
        refunded_at
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "completed_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "completed_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "outstanding_payments_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "outstanding_payments_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "refunds_before",
    "type": "ISO8601Type",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "refunds_after",
    "type": "ISO8601Type",
    "defaultValue": null
  }],
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "completed_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "completed_payments_before",
    "type": "ISO8601Type"
  }, v1],
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_cents",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount_currency",
    "args": null,
    "storageKey": null
  },
      v7 = [v5, v6, {
    "kind": "ScalarField",
    "alias": null,
    "name": "paid_at",
    "args": null,
    "storageKey": null
  }],
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v10 = ["before_time", "after_time"],
      v11 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "outstanding_payments_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "outstanding_payments_before",
    "type": "ISO8601Type"
  }, v1],
      v12 = [{
    "kind": "Variable",
    "name": "after_time",
    "variableName": "refunds_after",
    "type": "ISO8601Type"
  }, {
    "kind": "Variable",
    "name": "before_time",
    "variableName": "refunds_before",
    "type": "ISO8601Type"
  }, v1];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "Route_PaymentsGraph_Query",
    "id": null,
    "text": "query Route_PaymentsGraph_Query(\n  $completed_payments_before: ISO8601Type\n  $completed_payments_after: ISO8601Type\n  $outstanding_payments_before: ISO8601Type\n  $outstanding_payments_after: ISO8601Type\n  $refunds_before: ISO8601Type\n  $refunds_after: ISO8601Type\n) {\n  viewer {\n    ...PaymentsGraphContainer_viewer_2qQdGx\n    id\n  }\n}\n\nfragment PaymentsGraphContainer_viewer_2qQdGx on User {\n  s_time_zone\n  completed_payments(before_time: $completed_payments_before, after_time: $completed_payments_after, first: 99999) {\n    edges {\n      node {\n        ... on CashPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on CheckPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on CustomPayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on SquarePayment {\n          id\n          amount_cents\n          amount_currency\n          paid_at\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  outstanding_payments(before_time: $outstanding_payments_before, after_time: $outstanding_payments_after, first: 99999) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        payment_date\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  refunds(before_time: $refunds_before, after_time: $refunds_after, first: 99999) {\n    edges {\n      node {\n        id\n        amount_cents\n        amount_currency\n        refunded_at\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Route_PaymentsGraph_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "PaymentsGraphContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "completed_payments_after",
            "variableName": "completed_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "completed_payments_before",
            "variableName": "completed_payments_before",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_after",
            "variableName": "outstanding_payments_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "outstanding_payments_before",
            "variableName": "outstanding_payments_before",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_after",
            "variableName": "refunds_after",
            "type": null
          }, {
            "kind": "Variable",
            "name": "refunds_before",
            "variableName": "refunds_before",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Route_PaymentsGraph_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "completed_payments",
          "storageKey": null,
          "args": v2,
          "concreteType": "PaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v3, v4, {
                "kind": "InlineFragment",
                "type": "SquarePayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CustomPayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CheckPayment",
                "selections": v7
              }, {
                "kind": "InlineFragment",
                "type": "CashPayment",
                "selections": v7
              }]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "completed_payments",
          "args": v2,
          "handle": "connection",
          "key": "PaymentsGraph_completed_payments",
          "filters": v10
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "outstanding_payments",
          "storageKey": null,
          "args": v11,
          "concreteType": "OutstandingPaymentConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "OutstandingPaymentEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OutstandingPayment",
              "plural": false,
              "selections": [v3, v5, v6, {
                "kind": "ScalarField",
                "alias": null,
                "name": "payment_date",
                "args": null,
                "storageKey": null
              }, v4]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "outstanding_payments",
          "args": v11,
          "handle": "connection",
          "key": "PaymentsGraph_outstanding_payments",
          "filters": v10
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "refunds",
          "storageKey": null,
          "args": v12,
          "concreteType": "RefundConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "RefundEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Refund",
              "plural": false,
              "selections": [v3, v5, v6, {
                "kind": "ScalarField",
                "alias": null,
                "name": "refunded_at",
                "args": null,
                "storageKey": null
              }, v4]
            }, v8]
          }, v9]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "refunds",
          "args": v12,
          "handle": "connection",
          "key": "PaymentsGraph_refunds",
          "filters": v10
        }, v3]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '340c7fe8572d3e8972a470fb7480ea38';
module.exports = node;

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 93c1f7c56433e9b443e72cfb5ec4eb85
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SettingsContainer_viewer$ref = any;
export type Route_Settings_QueryVariables = {||};
export type Route_Settings_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SettingsContainer_viewer$ref
  |}
|};
export type Route_Settings_Query = {|
  variables: Route_Settings_QueryVariables,
  response: Route_Settings_QueryResponse,
|};
*/

/*
query Route_Settings_Query {
  viewer {
    ...SettingsContainer_viewer
    id
  }
}

fragment SettingsContainer_viewer on User {
  id
  first_name
  last_name
  company_name
  s_time_zone
  features {
    music_lists
    id
  }
  payment_methods(first: 99999) {
    edges {
      node {
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
        }
        ... on CashPaymentMethod {
          __typename
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          __typename
          id
          enabled
          label
          instructions
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PlaylistsContainer_viewer
  ...AvailabilityCheckerContainer_viewer
}

fragment PlaylistsContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = [v1],
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "instructions",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v10 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v13 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [v0, v8]
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v11, v12, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": v2,
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v8, v11, v12, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v0]
          }]
        }]
      }, v0]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "Route_Settings_Query",
    "id": null,
    "text": "query Route_Settings_Query {\n  viewer {\n    ...SettingsContainer_viewer\n    id\n  }\n}\n\nfragment SettingsContainer_viewer on User {\n  id\n  first_name\n  last_name\n  company_name\n  s_time_zone\n  features {\n    music_lists\n    id\n  }\n  payment_methods(first: 99999) {\n    edges {\n      node {\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n        }\n        ... on CashPaymentMethod {\n          __typename\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          __typename\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...PlaylistsContainer_viewer\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment PlaylistsContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "Route_Settings_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SettingsContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "Route_Settings_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "company_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "features",
          "storageKey": null,
          "args": null,
          "concreteType": "Features",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "music_lists",
            "args": null,
            "storageKey": null
          }, v0]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "payment_methods",
          "storageKey": "payment_methods(first:99999)",
          "args": v2,
          "concreteType": "PaymentMethodConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PaymentMethodEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [v0, v3, {
                "kind": "InlineFragment",
                "type": "CustomPaymentMethod",
                "selections": [v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "label",
                  "args": null,
                  "storageKey": null
                }, v5]
              }, {
                "kind": "InlineFragment",
                "type": "CheckPaymentMethod",
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address",
                  "args": null,
                  "storageKey": null
                }, v4, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "pay_to",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "InlineFragment",
                "type": "CashPaymentMethod",
                "selections": [v4, v5]
              }, {
                "kind": "InlineFragment",
                "type": "SquarePaymentMethod",
                "selections": [v4]
              }]
            }, v6]
          }, v7]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "payment_methods",
          "args": v2,
          "handle": "connection",
          "key": "SettingsContainer_payment_methods",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlists",
          "storageKey": "playlists(first:99999)",
          "args": v2,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              }, v8, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "num_songs",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "thumbnail",
                "storageKey": "thumbnail(height:240,width:240)",
                "args": [{
                  "kind": "Literal",
                  "name": "height",
                  "value": 240,
                  "type": "Int"
                }, {
                  "kind": "Literal",
                  "name": "width",
                  "value": 240,
                  "type": "Int"
                }],
                "concreteType": "SongImage",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "width",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "height",
                  "args": null,
                  "storageKey": null
                }, v0]
              }, v3]
            }, v6]
          }, v7]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "playlists",
          "args": v2,
          "handle": "connection",
          "key": "PlaylistsContainer_playlists",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v1, v9, v10],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v13
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v1, v9, v10],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v13
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd6e7618f26f6638a3a90ed150548a77d';
module.exports = node;

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8e99eeef71d627c38fa187f73ae6fd99
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchResultsContainer_viewer$ref = any;
export type SearchResultsQuery_UserEvent_Pagination_QueryVariables = {|
  count: number,
  query: string,
  cursor?: ?string,
|};
export type SearchResultsQuery_UserEvent_Pagination_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchResultsContainer_viewer$ref
  |}
|};
export type SearchResultsQuery_UserEvent_Pagination_Query = {|
  variables: SearchResultsQuery_UserEvent_Pagination_QueryVariables,
  response: SearchResultsQuery_UserEvent_Pagination_QueryResponse,
|};
*/

/*
query SearchResultsQuery_UserEvent_Pagination_Query(
  $count: Int!
  $query: String!
  $cursor: String
) {
  viewer {
    ...SearchResultsContainer_viewer_1jWD3d
    id
  }
}

fragment SearchResultsContainer_viewer_1jWD3d on User {
  s_time_zone
  user_event_search(first: $count, after: $cursor, query: $query) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  }, {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  }, {
    "kind": "Variable",
    "name": "query",
    "variableName": "query",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "SearchResultsQuery_UserEvent_Pagination_Query",
    "id": null,
    "text": "query SearchResultsQuery_UserEvent_Pagination_Query(\n  $count: Int!\n  $query: String!\n  $cursor: String\n) {\n  viewer {\n    ...SearchResultsContainer_viewer_1jWD3d\n    id\n  }\n}\n\nfragment SearchResultsContainer_viewer_1jWD3d on User {\n  s_time_zone\n  user_event_search(first: $count, after: $cursor, query: $query) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SearchResultsQuery_UserEvent_Pagination_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SearchResultsContainer_viewer",
          "args": [{
            "kind": "Variable",
            "name": "count",
            "variableName": "count",
            "type": null
          }, {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor",
            "type": null
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": null
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SearchResultsQuery_UserEvent_Pagination_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": null,
          "args": v1,
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v2, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v2]
                  }]
                }]
              }, v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_event_search",
          "args": v1,
          "handle": "connection",
          "key": "SearchResultsContainer_user_event_search",
          "filters": ["query"]
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5a3db88de880799eb9cf85083e9a77b8';
module.exports = node;

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fbd0657e30d10e611a8a347206baee38
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchPageContainer_viewer$ref = any;
export type SearchRoute_Viewer_QueryVariables = {||};
export type SearchRoute_Viewer_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchPageContainer_viewer$ref
  |}
|};
export type SearchRoute_Viewer_Query = {|
  variables: SearchRoute_Viewer_QueryVariables,
  response: SearchRoute_Viewer_QueryResponse,
|};
*/

/*
query SearchRoute_Viewer_Query {
  viewer {
    ...SearchPageContainer_viewer
    id
  }
}

fragment SearchPageContainer_viewer on User {
  id
  ...SearchResultsContainer_viewer
}

fragment SearchResultsContainer_viewer on User {
  s_time_zone
  user_event_search(query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = [{
    "kind": "Literal",
    "name": "query",
    "value": "",
    "type": "String!"
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "SearchRoute_Viewer_Query",
    "id": null,
    "text": "query SearchRoute_Viewer_Query {\n  viewer {\n    ...SearchPageContainer_viewer\n    id\n  }\n}\n\nfragment SearchPageContainer_viewer on User {\n  id\n  ...SearchResultsContainer_viewer\n}\n\nfragment SearchResultsContainer_viewer on User {\n  s_time_zone\n  user_event_search(query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SearchRoute_Viewer_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SearchPageContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SearchRoute_Viewer_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": "user_event_search(query:\"\")",
          "args": v1,
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v0, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                }]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v0]
                  }]
                }]
              }, v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              }]
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }]
          }]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_event_search",
          "args": v1,
          "handle": "connection",
          "key": "SearchResultsContainer_user_event_search",
          "filters": ["query"]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '575f3d496f49043c347671626b18d886';
module.exports = node;

/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 2820cb6e355d4c320eacf1c6bc26f9bd
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenContractContainer_viewer$ref = any;
export type ShareRoutes_OpenContract_QueryVariables = {||};
export type ShareRoutes_OpenContract_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenContractContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenContract_Query = {|
  variables: ShareRoutes_OpenContract_QueryVariables,
  response: ShareRoutes_OpenContract_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenContract_Query {
  viewer {
    ...OpenContractContainer_viewer
    id
  }
}

fragment OpenContractContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenContract_Query",
  "id": null,
  "text": "query ShareRoutes_OpenContract_Query {\n  viewer {\n    ...OpenContractContainer_viewer\n    id\n  }\n}\n\nfragment OpenContractContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenContract_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenContractContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenContract_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '96d8569c9f3bb92748c65476d29bf891';
module.exports = node;

/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bd227f8ac2049641b728be7b45dbe274
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenEstimateContainer_viewer$ref = any;
export type ShareRoutes_OpenEstimate_QueryVariables = {||};
export type ShareRoutes_OpenEstimate_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenEstimateContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenEstimate_Query = {|
  variables: ShareRoutes_OpenEstimate_QueryVariables,
  response: ShareRoutes_OpenEstimate_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenEstimate_Query {
  viewer {
    ...OpenEstimateContainer_viewer
    id
  }
}

fragment OpenEstimateContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenEstimate_Query",
  "id": null,
  "text": "query ShareRoutes_OpenEstimate_Query {\n  viewer {\n    ...OpenEstimateContainer_viewer\n    id\n  }\n}\n\nfragment OpenEstimateContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenEstimate_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenEstimateContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenEstimate_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '43125c13a8aa08d1011a5fee2fa54e89';
module.exports = node;

/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5696bc74405354ef83e30560161f344e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenFormContainer_viewer$ref = any;
export type ShareRoutes_OpenForm_QueryVariables = {||};
export type ShareRoutes_OpenForm_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenFormContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenForm_Query = {|
  variables: ShareRoutes_OpenForm_QueryVariables,
  response: ShareRoutes_OpenForm_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenForm_Query {
  viewer {
    ...OpenFormContainer_viewer
    id
  }
}

fragment OpenFormContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenForm_Query",
  "id": null,
  "text": "query ShareRoutes_OpenForm_Query {\n  viewer {\n    ...OpenFormContainer_viewer\n    id\n  }\n}\n\nfragment OpenFormContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenForm_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenFormContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenForm_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = 'e7df34783046b597a11670e1f2c8f67a';
module.exports = node;

/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 98793ef797e5263b8b8e6e5a58b9c865
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenInvoiceContainer_viewer$ref = any;
export type ShareRoutes_OpenInvoice_QueryVariables = {||};
export type ShareRoutes_OpenInvoice_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenInvoiceContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenInvoice_Query = {|
  variables: ShareRoutes_OpenInvoice_QueryVariables,
  response: ShareRoutes_OpenInvoice_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenInvoice_Query {
  viewer {
    ...OpenInvoiceContainer_viewer
    id
  }
}

fragment OpenInvoiceContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenInvoice_Query",
  "id": null,
  "text": "query ShareRoutes_OpenInvoice_Query {\n  viewer {\n    ...OpenInvoiceContainer_viewer\n    id\n  }\n}\n\nfragment OpenInvoiceContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenInvoice_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenInvoiceContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenInvoice_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = 'adb57468d8e838872f22fe8e0d64ee66';
module.exports = node;

/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ff635f81604ddf618df34e81692e4044
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenMusicPlannerContainer_viewer$ref = any;
export type ShareRoutes_OpenMusicPlanner_QueryVariables = {||};
export type ShareRoutes_OpenMusicPlanner_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenMusicPlannerContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenMusicPlanner_Query = {|
  variables: ShareRoutes_OpenMusicPlanner_QueryVariables,
  response: ShareRoutes_OpenMusicPlanner_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenMusicPlanner_Query {
  viewer {
    ...OpenMusicPlannerContainer_viewer
    id
  }
}

fragment OpenMusicPlannerContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenMusicPlanner_Query",
  "id": null,
  "text": "query ShareRoutes_OpenMusicPlanner_Query {\n  viewer {\n    ...OpenMusicPlannerContainer_viewer\n    id\n  }\n}\n\nfragment OpenMusicPlannerContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenMusicPlanner_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenMusicPlannerContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenMusicPlanner_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '7c7f4af4e47a61a69c6c482d38a0e9b7';
module.exports = node;

/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7a03111aee4aeb4b35fb6d43a342a225
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenWorkspaceContainer_viewer$ref = any;
export type ShareRoutes_OpenWorkspace_QueryVariables = {||};
export type ShareRoutes_OpenWorkspace_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenWorkspaceContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenWorkspace_Query = {|
  variables: ShareRoutes_OpenWorkspace_QueryVariables,
  response: ShareRoutes_OpenWorkspace_QueryResponse,
|};
*/

/*
query ShareRoutes_OpenWorkspace_Query {
  viewer {
    ...OpenWorkspaceContainer_viewer
    id
  }
}

fragment OpenWorkspaceContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenWorkspace_Query",
  "id": null,
  "text": "query ShareRoutes_OpenWorkspace_Query {\n  viewer {\n    ...OpenWorkspaceContainer_viewer\n    id\n  }\n}\n\nfragment OpenWorkspaceContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenWorkspace_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenWorkspaceContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenWorkspace_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '67ed106bf9c174c034132e380cf75f47';
module.exports = node;

/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c6f97f66808204b9fe32896fa9691ba6
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenSignContractContainer_viewer$ref = any;
export type ShareRoutes_Sign_QueryVariables = {||};
export type ShareRoutes_Sign_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenSignContractContainer_viewer$ref
  |}
|};
export type ShareRoutes_Sign_Query = {|
  variables: ShareRoutes_Sign_QueryVariables,
  response: ShareRoutes_Sign_QueryResponse,
|};
*/

/*
query ShareRoutes_Sign_Query {
  viewer {
    ...OpenSignContractContainer_viewer
    id
  }
}

fragment OpenSignContractContainer_viewer on User {
  id
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_Sign_Query",
  "id": null,
  "text": "query ShareRoutes_Sign_Query {\n  viewer {\n    ...OpenSignContractContainer_viewer\n    id\n  }\n}\n\nfragment OpenSignContractContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_Sign_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "OpenSignContractContainer_viewer",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_Sign_Query",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "viewer",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = 'c34cda0b8d72285554561a2fe372d075';
module.exports = node;

/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9ce39c64c435130f4691089967dae00a
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type TemplateListContainer_viewer$ref = any;
export type TemplateListRoute_TemplateList_QueryVariables = {||};
export type TemplateListRoute_TemplateList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TemplateListContainer_viewer$ref
  |}
|};
export type TemplateListRoute_TemplateList_Query = {|
  variables: TemplateListRoute_TemplateList_QueryVariables,
  response: TemplateListRoute_TemplateList_QueryResponse,
|};
*/

/*
query TemplateListRoute_TemplateList_Query {
  viewer {
    ...TemplateListContainer_viewer
    id
  }
}

fragment TemplateListContainer_viewer on User {
  ...AvailabilityCheckerContainer_viewer
  id
  c_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  form_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  public_mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  primary_brand {
    id
  }
  features {
    music_lists
    id
  }
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v1 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v2 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [v3, v4],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v8 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": v5
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v6, v7, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": [v0],
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v4, v6, v7, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v3]
          }]
        }]
      }, v3]
    }]
  }],
      v9 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "MpTemplateEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [v3, v4, {
        "kind": "ScalarField",
        "alias": null,
        "name": "can_edit",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "public",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "TemplateListRoute_TemplateList_Query",
    "id": null,
    "text": "query TemplateListRoute_TemplateList_Query {\n  viewer {\n    ...TemplateListContainer_viewer\n    id\n  }\n}\n\nfragment TemplateListContainer_viewer on User {\n  ...AvailabilityCheckerContainer_viewer\n  id\n  c_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  form_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  public_mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  primary_brand {\n    id\n  }\n  features {\n    music_lists\n    id\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateListRoute_TemplateList_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "TemplateListContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateListRoute_TemplateList_Query",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v0, v1, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v0, v1, v2],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v8
        }, v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "c_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplate",
              "plural": false,
              "selections": v5
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "form_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "FormTemplate",
              "plural": false,
              "selections": v5
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateConnection",
          "plural": false,
          "selections": v9
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "public_mp_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateConnection",
          "plural": false,
          "selections": v9
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "features",
          "storageKey": null,
          "args": null,
          "concreteType": "Features",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "music_lists",
            "args": null,
            "storageKey": null
          }, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '5b37792ba75c5c7cf1ad535a75146368';
module.exports = node;

/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5833c62063cd03a7f75b088ed811c298
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractTemplateContainer_node$ref = any;
type ContractTemplateContainer_viewer$ref = any;
export type TemplateRoutes_ContractTemplate_QueryVariables = {|
  id: string
|};
export type TemplateRoutes_ContractTemplate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: ContractTemplateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: ContractTemplateContainer_viewer$ref
  |},
|};
export type TemplateRoutes_ContractTemplate_Query = {|
  variables: TemplateRoutes_ContractTemplate_QueryVariables,
  response: TemplateRoutes_ContractTemplate_QueryResponse,
|};
*/

/*
query TemplateRoutes_ContractTemplate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...ContractTemplateContainer_node
    id
  }
  viewer {
    ...ContractTemplateContainer_viewer
    id
  }
}

fragment ContractTemplateContainer_node on CTemplate {
  id
  title
  terms
  brand {
    id
    logo_url
    header
  }
  c_template_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  c_template_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ContractTemplateContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
  }
  ...SearchContainer_viewer
  ...LibraryContainer_viewer
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_cents",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "price_currency",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "quantity",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v11 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "TemplateRoutes_ContractTemplate_Query",
    "id": null,
    "text": "query TemplateRoutes_ContractTemplate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContractTemplateContainer_node\n    id\n  }\n  viewer {\n    ...ContractTemplateContainer_viewer\n    id\n  }\n}\n\nfragment ContractTemplateContainer_node on CTemplate {\n  id\n  title\n  terms\n  brand {\n    id\n    logo_url\n    header\n  }\n  c_template_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  c_template_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ContractTemplateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n  }\n  ...SearchContainer_viewer\n  ...LibraryContainer_viewer\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateRoutes_ContractTemplate_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContractTemplateContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ContractTemplateContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateRoutes_ContractTemplate_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "CTemplate",
          "selections": [v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "terms",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v3, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "header",
              "args": null,
              "storageKey": null
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_line_items",
            "storageKey": "c_template_line_items(first:99999)",
            "args": v5,
            "concreteType": "CTemplateLineItemConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateLineItemEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateLineItem",
                "plural": false,
                "selections": [v3, v6, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }, v7, v8, v9, v4, v2]
              }, v10]
            }, v11]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_line_items",
            "args": v5,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_line_items",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template_signature_blocks",
            "storageKey": "c_template_signature_blocks(first:99999)",
            "args": v5,
            "concreteType": "CTemplateSignatureBlockConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplateSignatureBlockEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CTemplateSignatureBlock",
                "plural": false,
                "selections": [v3, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                }, v2]
              }, v10]
            }, v11]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "c_template_signature_blocks",
            "args": v5,
            "handle": "connection",
            "key": "ContractTemplateContainer_c_template_signature_blocks",
            "filters": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": "user_event_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v4]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_line_items",
          "storageKey": "user_line_items(first:99999)",
          "args": v5,
          "concreteType": "UserLineItemConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserLineItemEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserLineItem",
              "plural": false,
              "selections": [v3, v6, v7, v8, v9, v4, v2]
            }, v10]
          }, v11]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "user_line_items",
          "args": v5,
          "handle": "connection",
          "key": "LibraryContainer_user_line_items",
          "filters": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e82ae64885d914cce0576be8c4860225';
module.exports = node;

/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d2ade1124e9c8934e1659929fb342df5
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type FormTemplateContainer_node$ref = any;
type FormTemplateContainer_viewer$ref = any;
export type TemplateRoutes_FormTemplate_QueryVariables = {|
  id: string
|};
export type TemplateRoutes_FormTemplate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: FormTemplateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: FormTemplateContainer_viewer$ref
  |},
|};
export type TemplateRoutes_FormTemplate_Query = {|
  variables: TemplateRoutes_FormTemplate_QueryVariables,
  response: TemplateRoutes_FormTemplate_QueryResponse,
|};
*/

/*
query TemplateRoutes_FormTemplate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...FormTemplateContainer_node
    id
  }
  viewer {
    ...FormTemplateContainer_viewer
    id
  }
}

fragment FormTemplateContainer_node on FormTemplate {
  id
  title
  schema
  ui_schema
  data
  brand {
    id
    logo_url
    header
  }
}

fragment FormTemplateContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
  }
  ...SearchContainer_viewer
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "TemplateRoutes_FormTemplate_Query",
    "id": null,
    "text": "query TemplateRoutes_FormTemplate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...FormTemplateContainer_node\n    id\n  }\n  viewer {\n    ...FormTemplateContainer_viewer\n    id\n  }\n}\n\nfragment FormTemplateContainer_node on FormTemplate {\n  id\n  title\n  schema\n  ui_schema\n  data\n  brand {\n    id\n    logo_url\n    header\n  }\n}\n\nfragment FormTemplateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n  }\n  ...SearchContainer_viewer\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateRoutes_FormTemplate_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FormTemplateContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "FormTemplateContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateRoutes_FormTemplate_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "InlineFragment",
          "type": "FormTemplate",
          "selections": [v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "ui_schema",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "data",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v2, {
              "kind": "ScalarField",
              "alias": null,
              "name": "logo_url",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "header",
              "args": null,
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v2]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": "user_event_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v2, v3]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v2]
                  }]
                }]
              }, v2]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '61e24e8f87c0a2902675f4d9174f226e';
module.exports = node;

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d268bb45c2140cbecb9992c0fbc25377
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplatePlaylistContainer_node$ref = any;
type MpTemplatePlaylistContainer_viewer$ref = any;
export type TemplateRoutes_MpTemplatePlaylist_QueryVariables = {|
  playlist_id: string
|};
export type TemplateRoutes_MpTemplatePlaylist_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MpTemplatePlaylistContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: MpTemplatePlaylistContainer_viewer$ref
  |},
|};
export type TemplateRoutes_MpTemplatePlaylist_Query = {|
  variables: TemplateRoutes_MpTemplatePlaylist_QueryVariables,
  response: TemplateRoutes_MpTemplatePlaylist_QueryResponse,
|};
*/

/*
query TemplateRoutes_MpTemplatePlaylist_Query(
  $playlist_id: ID!
) {
  node(id: $playlist_id) {
    __typename
    ...MpTemplatePlaylistContainer_node_2S1MTY
    id
  }
  viewer {
    ...MpTemplatePlaylistContainer_viewer
    id
  }
}

fragment MpTemplatePlaylistContainer_node_2S1MTY on MpTemplatePlaylist {
  id
  title
  description
  max_length
  position
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: mp_template_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
  mp_template {
    can_edit
    public
    id
  }
}

fragment MpTemplatePlaylistContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  public_playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "playlist_id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "playlist_id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "position",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "width",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "height",
    "args": null,
    "storageKey": null
  },
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [v7, v8, v9, v3]
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v12 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v13 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "isrc",
    "args": null,
    "storageKey": null
  },
      v14 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v15 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "album",
    "args": null,
    "storageKey": null
  },
      v16 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artist",
    "args": null,
    "storageKey": null
  },
      v17 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "song_images",
    "storageKey": null,
    "args": null,
    "concreteType": "SongImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "SongImage",
        "plural": false,
        "selections": [v3, v7, v8, v9]
      }]
    }]
  },
      v18 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v19 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v20 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "TemplateRoutes_MpTemplatePlaylist_Query",
    "id": null,
    "text": "query TemplateRoutes_MpTemplatePlaylist_Query(\n  $playlist_id: ID!\n) {\n  node(id: $playlist_id) {\n    __typename\n    ...MpTemplatePlaylistContainer_node_2S1MTY\n    id\n  }\n  viewer {\n    ...MpTemplatePlaylistContainer_viewer\n    id\n  }\n}\n\nfragment MpTemplatePlaylistContainer_node_2S1MTY on MpTemplatePlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: mp_template_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n  mp_template {\n    can_edit\n    public\n    id\n  }\n}\n\nfragment MpTemplatePlaylistContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  public_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateRoutes_MpTemplatePlaylist_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MpTemplatePlaylistContainer_node",
          "args": [{
            "kind": "Variable",
            "name": "id",
            "variableName": "playlist_id",
            "type": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MpTemplatePlaylistContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateRoutes_MpTemplatePlaylist_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "MpTemplatePlaylist",
          "selections": [v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "max_length",
            "args": null,
            "storageKey": null
          }, v6, v10, {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist_recommendations",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Playlist",
                "plural": false,
                "selections": [v3, v4, v5, v10, v11]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "storageKey": "mp_template_playlist_songs(first:99999)",
            "args": v12,
            "concreteType": "MpTemplatePlaylistSongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistSongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylistSong",
                "plural": false,
                "selections": [v3, v6, {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [v2, v3, v13, v14, v15, v16, v17]
                }, v2]
              }, v18]
            }, v19]
          }, {
            "kind": "LinkedHandle",
            "alias": "playlist_songs",
            "name": "mp_template_playlist_songs",
            "args": v12,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlist_songs",
            "filters": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "song_search",
            "storageKey": "song_search(first:10,query:\"\")",
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }, {
              "kind": "Literal",
              "name": "query",
              "value": "",
              "type": "String!"
            }],
            "concreteType": "SongConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "SongEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [v2, v3, v14, v15, v16, v13, {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                }, v17, {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_id",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_source",
                    "args": null,
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "external_data",
                    "args": null,
                    "storageKey": null
                  }]
                }]
              }]
            }]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [v20, {
              "kind": "ScalarField",
              "alias": null,
              "name": "public",
              "args": null,
              "storageKey": null
            }, v3]
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlists",
          "storageKey": "playlists(first:99999)",
          "args": v12,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v20, v4, v5, v11, v10, v2]
            }, v18]
          }, v19]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "playlists",
          "args": v12,
          "handle": "connection",
          "key": "MpTemplateContainer_playlists",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "public_playlists",
          "storageKey": "public_playlists(first:99999)",
          "args": v12,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v20, v4, v5, v11, v10]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a2c4f1ef1051fefa7833c91bfd3a5ca5';
module.exports = node;

/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d10b7e0a25e49bfd52dad3790b06c764
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplateContainer_node$ref = any;
type MpTemplateContainer_viewer$ref = any;
export type TemplateRoutes_MpTemplate_QueryVariables = {|
  id: string
|};
export type TemplateRoutes_MpTemplate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: MpTemplateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: MpTemplateContainer_viewer$ref
  |},
|};
export type TemplateRoutes_MpTemplate_Query = {|
  variables: TemplateRoutes_MpTemplate_QueryVariables,
  response: TemplateRoutes_MpTemplate_QueryResponse,
|};
*/

/*
query TemplateRoutes_MpTemplate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...MpTemplateContainer_node
    id
  }
  viewer {
    ...MpTemplateContainer_viewer
    id
  }
}

fragment MpTemplateContainer_node on MpTemplate {
  id
  title
  description
  notes
  can_edit
  public
  brand {
    id
    logo_url
    header
  }
  mp_template_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment MpTemplateContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
    header
    logo_url
  }
  ...MpTemplatePlaylistContainer_viewer
  ...SearchContainer_viewer
}

fragment MpTemplatePlaylistContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  public_playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
      }
    }
  }
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "can_edit",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "logo_url",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "header",
    "args": null,
    "storageKey": null
  },
      v9 = [{
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }],
      v10 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "thumbnail",
    "storageKey": "thumbnail(height:240,width:240)",
    "args": [{
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }],
    "concreteType": "SongImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }, v3]
  },
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "num_songs",
    "args": null,
    "storageKey": null
  },
      v12 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v13 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "TemplateRoutes_MpTemplate_Query",
    "id": null,
    "text": "query TemplateRoutes_MpTemplate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MpTemplateContainer_node\n    id\n  }\n  viewer {\n    ...MpTemplateContainer_viewer\n    id\n  }\n}\n\nfragment MpTemplateContainer_node on MpTemplate {\n  id\n  title\n  description\n  notes\n  can_edit\n  public\n  brand {\n    id\n    logo_url\n    header\n  }\n  mp_template_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MpTemplateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n    header\n    logo_url\n  }\n  ...MpTemplatePlaylistContainer_viewer\n  ...SearchContainer_viewer\n}\n\nfragment MpTemplatePlaylistContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  public_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "TemplateRoutes_MpTemplate_Query",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MpTemplateContainer_node",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "MpTemplateContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "TemplateRoutes_MpTemplate_Query",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [v2, v3, {
          "kind": "InlineFragment",
          "type": "MpTemplate",
          "selections": [v4, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          }, v6, {
            "kind": "ScalarField",
            "alias": null,
            "name": "public",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [v3, v7, v8]
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template_playlists",
            "storageKey": "mp_template_playlists(first:99999)",
            "args": v9,
            "concreteType": "MpTemplatePlaylistConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "MpTemplatePlaylistEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MpTemplatePlaylist",
                "plural": false,
                "selections": [v3, v4, v5, v10, v11, v2]
              }, v12]
            }, v13]
          }, {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "mp_template_playlists",
            "args": v9,
            "handle": "connection",
            "key": "MpTemplateContainer_mp_template_playlists",
            "filters": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, {
          "kind": "ScalarField",
          "alias": null,
          "name": "first_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "last_name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v3, v8, v7]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "playlists",
          "storageKey": "playlists(first:99999)",
          "args": v9,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v6, v4, v5, v11, v10, v2]
            }, v12]
          }, v13]
        }, {
          "kind": "LinkedHandle",
          "alias": null,
          "name": "playlists",
          "args": v9,
          "handle": "connection",
          "key": "MpTemplateContainer_playlists",
          "filters": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "public_playlists",
          "storageKey": "public_playlists(first:99999)",
          "args": v9,
          "concreteType": "PlaylistConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [v3, v6, v4, v5, v11, v10]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "user_event_search",
          "storageKey": "user_event_search(first:3,query:\"\")",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "query",
            "value": "",
            "type": "String!"
          }],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "event",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [v3, v4]
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_status",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "start_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "end_at",
                "args": null,
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:1)",
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 1,
                  "type": "Int"
                }],
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserEventSegmentEdge",
                  "plural": true,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location",
                      "args": null,
                      "storageKey": null
                    }, v3]
                  }]
                }]
              }, v3]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2676f8a2b74f1966bd6bc682f3fb0c6b';
module.exports = node;

/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 71ec7922c6cc12a2a732ee0ab5c13ea4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
type EmbedContainer_viewer$ref = any;
type EventCreateContainer_viewer$ref = any;
type EventIndexContainer_viewer$ref = any;
type KioskContainer_viewer$ref = any;
type LeadCaptureContainer_viewer$ref = any;
type LinkContainer_viewer$ref = any;
type TemplateListContainer_viewer$ref = any;
export type ViewerQueryVariables = {||};
export type ViewerQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventIndexContainer_viewer$ref & EventCreateContainer_viewer$ref & LeadCaptureContainer_viewer$ref & LinkContainer_viewer$ref & KioskContainer_viewer$ref & EmbedContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref & AvailabilityCheckerContainer_viewer$ref & TemplateListContainer_viewer$ref
  |}
|};
export type ViewerQuery = {|
  variables: ViewerQueryVariables,
  response: ViewerQueryResponse,
|};
*/

/*
query ViewerQuery {
  viewer {
    ...EventIndexContainer_viewer
    ...EventCreateContainer_viewer
    ...LeadCaptureContainer_viewer
    ...LinkContainer_viewer
    ...KioskContainer_viewer
    ...EmbedContainer_viewer
    ...AvailabilityCalendarContainer_viewer
    ...AvailabilityCheckerContainer_viewer
    ...TemplateListContainer_viewer
    id
  }
}

fragment EventIndexContainer_viewer on User {
  id
  needs_square_scopes
  ...AvailabilityCheckerContainer_viewer
}

fragment EventCreateContainer_viewer on User {
  id
  past_referral_sources
  s_time_zone
  ...AvailabilityCheckerContainer_viewer
  ...AvailabilityCalendarContainer_viewer
}

fragment LeadCaptureContainer_viewer on User {
  id
  ...AvailabilityCheckerContainer_viewer
}

fragment LinkContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  phones {
    edges {
      node {
        id
        number
        verified
      }
    }
  }
  s_text_on_embed_submit
  ...AvailabilityCheckerContainer_viewer
}

fragment KioskContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  ...AvailabilityCheckerContainer_viewer
}

fragment EmbedContainer_viewer on User {
  id
  embed_token
  s_recaptcha_enabled
  s_recaptcha_site_key
  s_recaptcha_secret_key
  s_time_zone
  phones {
    edges {
      node {
        id
        number
        verified
      }
    }
  }
  s_text_on_embed_submit
  ...AvailabilityCheckerContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment TemplateListContainer_viewer on User {
  ...AvailabilityCheckerContainer_viewer
  id
  c_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  form_templates {
    edges {
      node {
        id
        title
      }
    }
  }
  mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  public_mp_templates {
    edges {
      node {
        id
        title
        can_edit
        public
      }
    }
  }
  primary_brand {
    id
  }
  features {
    music_lists
    id
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  },
      v2 = {
    "kind": "Literal",
    "name": "return_empty_connection",
    "value": true,
    "type": "Boolean"
  },
      v3 = {
    "kind": "Literal",
    "name": "visibility",
    "value": ["SHOW"],
    "type": "[UserEventVisibility]"
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
      v5 = [v0, v4],
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "start_at",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "end_at",
    "args": null,
    "storageKey": null
  },
      v8 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": v5
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_status",
        "args": null,
        "storageKey": null
      }, v6, v7, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user_event_segments",
        "storageKey": "user_event_segments(first:99999)",
        "args": [v1],
        "concreteType": "UserEventSegmentConnection",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventSegmentEdge",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEventSegment",
            "plural": false,
            "selections": [v4, v6, v7, {
              "kind": "ScalarField",
              "alias": null,
              "name": "all_day",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "location",
              "args": null,
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "name": "room",
              "args": null,
              "storageKey": null
            }, v0]
          }]
        }]
      }, v0]
    }]
  }],
      v9 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "MpTemplateEdge",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "MpTemplate",
      "plural": false,
      "selections": [v0, v4, {
        "kind": "ScalarField",
        "alias": null,
        "name": "can_edit",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "public",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ViewerQuery",
    "id": null,
    "text": "query ViewerQuery {\n  viewer {\n    ...EventIndexContainer_viewer\n    ...EventCreateContainer_viewer\n    ...LeadCaptureContainer_viewer\n    ...LinkContainer_viewer\n    ...KioskContainer_viewer\n    ...EmbedContainer_viewer\n    ...AvailabilityCalendarContainer_viewer\n    ...AvailabilityCheckerContainer_viewer\n    ...TemplateListContainer_viewer\n    id\n  }\n}\n\nfragment EventIndexContainer_viewer on User {\n  id\n  needs_square_scopes\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment EventCreateContainer_viewer on User {\n  id\n  past_referral_sources\n  s_time_zone\n  ...AvailabilityCheckerContainer_viewer\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LeadCaptureContainer_viewer on User {\n  id\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment LinkContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  phones {\n    edges {\n      node {\n        id\n        number\n        verified\n      }\n    }\n  }\n  s_text_on_embed_submit\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment KioskContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment EmbedContainer_viewer on User {\n  id\n  embed_token\n  s_recaptcha_enabled\n  s_recaptcha_site_key\n  s_recaptcha_secret_key\n  s_time_zone\n  phones {\n    edges {\n      node {\n        id\n        number\n        verified\n      }\n    }\n  }\n  s_text_on_embed_submit\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TemplateListContainer_viewer on User {\n  ...AvailabilityCheckerContainer_viewer\n  id\n  c_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  form_templates {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  public_mp_templates {\n    edges {\n      node {\n        id\n        title\n        can_edit\n        public\n      }\n    }\n  }\n  primary_brand {\n    id\n  }\n  features {\n    music_lists\n    id\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ViewerQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "EventIndexContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "EventCreateContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "LeadCaptureContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "LinkContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "KioskContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "EmbedContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "AvailabilityCalendarContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "AvailabilityCheckerContainer_viewer",
          "args": null
        }, {
          "kind": "FragmentSpread",
          "name": "TemplateListContainer_viewer",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ViewerQuery",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "s_recaptcha_secret_key",
          "args": null,
          "storageKey": null
        }, v0, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_time_zone",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCalendarContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [{
            "kind": "Literal",
            "name": "booking_status",
            "value": ["BOOKED", "INITIAL", "CANCELED"],
            "type": "[BookingStatus]"
          }, v1, v2, v3],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": "AvailabilityCheckerContainer_user_events",
          "name": "user_events",
          "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
          "args": [v1, v2, v3],
          "concreteType": "UserEventConnection",
          "plural": false,
          "selections": v8
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "past_referral_sources",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "embed_token",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_recaptcha_enabled",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_recaptcha_site_key",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "needs_square_scopes",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "phones",
          "storageKey": null,
          "args": null,
          "concreteType": "PhoneConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PhoneEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Phone",
              "plural": false,
              "selections": [v0, {
                "kind": "ScalarField",
                "alias": null,
                "name": "number",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "verified",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "s_text_on_embed_submit",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "c_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CTemplate",
              "plural": false,
              "selections": v5
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "form_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "FormTemplateConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormTemplateEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "FormTemplate",
              "plural": false,
              "selections": v5
            }]
          }]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "mp_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateConnection",
          "plural": false,
          "selections": v9
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "public_mp_templates",
          "storageKey": null,
          "args": null,
          "concreteType": "MpTemplateConnection",
          "plural": false,
          "selections": v9
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "primary_brand",
          "storageKey": null,
          "args": null,
          "concreteType": "Brand",
          "plural": false,
          "selections": [v0]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "features",
          "storageKey": null,
          "args": null,
          "concreteType": "Features",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "music_lists",
            "args": null,
            "storageKey": null
          }, v0]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6d7dc36878ca1d3ea9b833c869a9ccee';
module.exports = node;

/***/ }),
/* 3520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* harmony default export */ __webpack_exports__["a"] = (function (params) {
  return _extends({}, params, {
    completed_payments_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(100, 'years').endOf('year').toDate().toISOString(),
    completed_payments_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').subtract(100, 'years').toDate().toISOString(),
    count: 20
  });
});

/***/ }),
/* 3521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ __webpack_exports__["a"] = (function (params, _ref) {
  var location = _ref.location;
  var _location$query = location.query,
      hidden = _location$query.hidden,
      status = _location$query.status;

  return _extends({}, params, {
    count: 20,
    visibility: hidden === 'true' ? ['SHOW', 'HIDDEN'] : ['SHOW'],
    booking_status: status && status !== 'ALL' ? [status] : ['BOOKED', 'INITIAL', 'CANCELED']
  });
});

/***/ }),
/* 3522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ __webpack_exports__["a"] = (function (params, _ref) {
  var location = _ref.location;
  var _location$query = location.query,
      hidden = _location$query.hidden,
      sortBy = _location$query.sortBy,
      status = _location$query.status;

  return _extends({}, params, {
    count: 10,
    visibility: hidden === 'true' ? ['SHOW', 'HIDDEN'] : ['SHOW'],
    sortBy: sortBy || 'UPCOMING',
    booking_status: status && status !== 'ALL' ? [status] : ['BOOKED', 'INITIAL', 'CANCELED']
  });
});

/***/ }),
/* 3523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ __webpack_exports__["a"] = (function (params, _ref) {
  var location = _ref.location;
  var status = location.query.status;

  return _extends({}, params, {
    count: 20,
    status: status !== 'ALL' ? status : null
  });
});

/***/ }),
/* 3524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* harmony default export */ __webpack_exports__["a"] = (function (params) {
  return _extends({}, params, {
    outstanding_payments_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(100, 'years').endOf('year').toDate().toISOString(),
    outstanding_payments_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').subtract(100, 'years').toDate().toISOString(),
    count: 20
  });
});

/***/ }),
/* 3525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* harmony default export */ __webpack_exports__["a"] = (function (params) {
  return _extends({}, params, {
    completed_payments_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('year').toDate().toISOString(),
    completed_payments_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').toDate().toISOString(),
    outstanding_payments_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('year').toDate().toISOString(),
    outstanding_payments_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').toDate().toISOString(),
    refunds_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('year').toDate().toISOString(),
    refunds_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').toDate().toISOString()
  });
});

/***/ }),
/* 3526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/* harmony default export */ __webpack_exports__["a"] = (function (params) {
  return _extends({}, params, {
    refunds_before: __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(100, 'years').endOf('year').toDate().toISOString(),
    refunds_after: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').subtract(100, 'years').toDate().toISOString(),
    count: 20
  });
});

/***/ }),
/* 3527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ __webpack_exports__["a"] = (function (params, _ref) {
  var location = _ref.location;
  var q = location.query.q;

  return _extends({}, params, {
    count: params.count || 10,
    query: q || '',
    cursor: params.cursor
  });
});

/***/ }),
/* 3528 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"AC","alpha3":"","countryCallingCodes":["+247"],"currencies":["USD"],"emoji":"","ioc":"SHP","languages":["eng"],"name":"Ascension Island","status":"reserved"},{"alpha2":"AD","alpha3":"AND","countryCallingCodes":["+376"],"currencies":["EUR"],"emoji":"🇦🇩","ioc":"AND","languages":["cat"],"name":"Andorra","status":"assigned"},{"alpha2":"AE","alpha3":"ARE","countryCallingCodes":["+971"],"currencies":["AED"],"emoji":"🇦🇪","ioc":"UAE","languages":["ara"],"name":"United Arab Emirates","status":"assigned"},{"alpha2":"AF","alpha3":"AFG","countryCallingCodes":["+93"],"currencies":["AFN"],"emoji":"🇦🇫","ioc":"AFG","languages":["pus"],"name":"Afghanistan","status":"assigned"},{"alpha2":"AG","alpha3":"ATG","countryCallingCodes":["+1 268"],"currencies":["XCD"],"emoji":"🇦🇬","ioc":"ANT","languages":["eng"],"name":"Antigua And Barbuda","status":"assigned"},{"alpha2":"AI","alpha3":"AIA","countryCallingCodes":["+1 264"],"currencies":["XCD"],"emoji":"🇦🇮","ioc":"","languages":["eng"],"name":"Anguilla","status":"assigned"},{"alpha2":"AI","alpha3":"AFI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Afar and Issas","status":"deleted"},{"alpha2":"AL","alpha3":"ALB","countryCallingCodes":["+355"],"currencies":["ALL"],"emoji":"🇦🇱","ioc":"ALB","languages":["sqi"],"name":"Albania","status":"assigned"},{"alpha2":"AM","alpha3":"ARM","countryCallingCodes":["+374"],"currencies":["AMD"],"emoji":"🇦🇲","ioc":"ARM","languages":["hye","rus"],"name":"Armenia","status":"assigned"},{"alpha2":"AN","alpha3":"ANT","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Netherlands Antilles","status":"deleted"},{"alpha2":"AO","alpha3":"AGO","countryCallingCodes":["+244"],"currencies":["AOA"],"emoji":"🇦🇴","ioc":"ANG","languages":["por"],"name":"Angola","status":"assigned"},{"alpha2":"AQ","alpha3":"ATA","countryCallingCodes":["+672"],"currencies":[],"emoji":"🇦🇶","ioc":"","languages":[],"name":"Antarctica","status":"assigned"},{"alpha2":"AR","alpha3":"ARG","countryCallingCodes":["+54"],"currencies":["ARS"],"emoji":"🇦🇷","ioc":"ARG","languages":["spa"],"name":"Argentina","status":"assigned"},{"alpha2":"AS","alpha3":"ASM","countryCallingCodes":["+1 684"],"currencies":["USD"],"emoji":"🇦🇸","ioc":"ASA","languages":["eng","smo"],"name":"American Samoa","status":"assigned"},{"alpha2":"AT","alpha3":"AUT","countryCallingCodes":["+43"],"currencies":["EUR"],"emoji":"🇦🇹","ioc":"AUT","languages":["deu"],"name":"Austria","status":"assigned"},{"alpha2":"AU","alpha3":"AUS","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇦🇺","ioc":"AUS","languages":["eng"],"name":"Australia","status":"assigned"},{"alpha2":"AW","alpha3":"ABW","countryCallingCodes":["+297"],"currencies":["AWG"],"emoji":"🇦🇼","ioc":"ARU","languages":["nld"],"name":"Aruba","status":"assigned"},{"alpha2":"AX","alpha3":"ALA","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇦🇽","ioc":"","languages":["swe"],"name":"Åland Islands","status":"assigned"},{"alpha2":"AZ","alpha3":"AZE","countryCallingCodes":["+994"],"currencies":["AZN"],"emoji":"🇦🇿","ioc":"AZE","languages":["aze"],"name":"Azerbaijan","status":"assigned"},{"alpha2":"BA","alpha3":"BIH","countryCallingCodes":["+387"],"currencies":["BAM"],"emoji":"🇧🇦","ioc":"BIH","languages":["bos","cre","srp"],"name":"Bosnia & Herzegovina","status":"assigned"},{"alpha2":"BB","alpha3":"BRB","countryCallingCodes":["+1 246"],"currencies":["BBD"],"emoji":"🇧🇧","ioc":"BAR","languages":["eng"],"name":"Barbados","status":"assigned"},{"alpha2":"BD","alpha3":"BGD","countryCallingCodes":["+880"],"currencies":["BDT"],"emoji":"🇧🇩","ioc":"BAN","languages":["ben"],"name":"Bangladesh","status":"assigned"},{"alpha2":"BE","alpha3":"BEL","countryCallingCodes":["+32"],"currencies":["EUR"],"emoji":"🇧🇪","ioc":"BEL","languages":["nld","fra","deu"],"name":"Belgium","status":"assigned"},{"alpha2":"BF","alpha3":"BFA","countryCallingCodes":["+226"],"currencies":["XOF"],"emoji":"🇧🇫","ioc":"BUR","languages":["fra"],"name":"Burkina Faso","status":"assigned"},{"alpha2":"BG","alpha3":"BGR","countryCallingCodes":["+359"],"currencies":["BGN"],"emoji":"🇧🇬","ioc":"BUL","languages":["bul"],"name":"Bulgaria","status":"assigned"},{"alpha2":"BH","alpha3":"BHR","countryCallingCodes":["+973"],"currencies":["BHD"],"emoji":"🇧🇭","ioc":"BRN","languages":["ara"],"name":"Bahrain","status":"assigned"},{"alpha2":"BI","alpha3":"BDI","countryCallingCodes":["+257"],"currencies":["BIF"],"emoji":"🇧🇮","ioc":"BDI","languages":["fra"],"name":"Burundi","status":"assigned"},{"alpha2":"BJ","alpha3":"BEN","countryCallingCodes":["+229"],"currencies":["XOF"],"emoji":"🇧🇯","ioc":"BEN","languages":["fra"],"name":"Benin","status":"assigned"},{"alpha2":"BL","alpha3":"BLM","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇧🇱","ioc":"","languages":["fra"],"name":"Saint Barthélemy","status":"assigned"},{"alpha2":"BM","alpha3":"BMU","countryCallingCodes":["+1 441"],"currencies":["BMD"],"emoji":"🇧🇲","ioc":"BER","languages":["eng"],"name":"Bermuda","status":"assigned"},{"alpha2":"BN","alpha3":"BRN","countryCallingCodes":["+673"],"currencies":["BND"],"emoji":"🇧🇳","ioc":"BRU","languages":["msa","eng"],"name":"Brunei Darussalam","status":"assigned"},{"alpha2":"BO","alpha3":"BOL","countryCallingCodes":["+591"],"currencies":["BOB","BOV"],"emoji":"🇧🇴","ioc":"BOL","languages":["spa","aym","que"],"name":"Bolivia, Plurinational State Of","status":"assigned"},{"alpha2":"BQ","alpha3":"BES","countryCallingCodes":["+599"],"currencies":["USD"],"emoji":"🇧🇶","ioc":"","languages":["nld"],"name":"Bonaire, Saint Eustatius And Saba","status":"assigned"},{"alpha2":"BQ","alpha3":"ATB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"British Antarctic Territory","status":"deleted"},{"alpha2":"BR","alpha3":"BRA","countryCallingCodes":["+55"],"currencies":["BRL"],"emoji":"🇧🇷","ioc":"BRA","languages":["por"],"name":"Brazil","status":"assigned"},{"alpha2":"BS","alpha3":"BHS","countryCallingCodes":["+1 242"],"currencies":["BSD"],"emoji":"🇧🇸","ioc":"BAH","languages":["eng"],"name":"Bahamas","status":"assigned"},{"alpha2":"BT","alpha3":"BTN","countryCallingCodes":["+975"],"currencies":["INR","BTN"],"emoji":"🇧🇹","ioc":"BHU","languages":["dzo"],"name":"Bhutan","status":"assigned"},{"alpha2":"BU","alpha3":"BUR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Burma","status":"deleted"},{"alpha2":"BV","alpha3":"BVT","countryCallingCodes":[],"currencies":["NOK"],"emoji":"🇧🇻","ioc":"","languages":[],"name":"Bouvet Island","status":"assigned"},{"alpha2":"BW","alpha3":"BWA","countryCallingCodes":["+267"],"currencies":["BWP"],"emoji":"🇧🇼","ioc":"BOT","languages":["eng","tsn"],"name":"Botswana","status":"assigned"},{"alpha2":"BY","alpha3":"BLR","countryCallingCodes":["+375"],"currencies":["BYR"],"emoji":"🇧🇾","ioc":"BLR","languages":["bel","rus"],"name":"Belarus","status":"assigned"},{"alpha2":"BY","alpha3":"BYS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Byelorussian SSR","status":"deleted"},{"alpha2":"BZ","alpha3":"BLZ","countryCallingCodes":["+501"],"currencies":["BZD"],"emoji":"🇧🇿","ioc":"BIZ","languages":["eng"],"name":"Belize","status":"assigned"},{"alpha2":"CA","alpha3":"CAN","countryCallingCodes":["+1"],"currencies":["CAD"],"emoji":"🇨🇦","ioc":"CAN","languages":["eng","fra"],"name":"Canada","status":"assigned"},{"alpha2":"CC","alpha3":"CCK","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇨","ioc":"","languages":["eng"],"name":"Cocos (Keeling) Islands","status":"assigned"},{"alpha2":"CD","alpha3":"COD","countryCallingCodes":["+243"],"currencies":["CDF"],"emoji":"🇨🇩","ioc":"COD","languages":["fra","lin","kon","swa"],"name":"Democratic Republic Of Congo","status":"assigned"},{"alpha2":"CF","alpha3":"CAF","countryCallingCodes":["+236"],"currencies":["XAF"],"emoji":"🇨🇫","ioc":"CAF","languages":["fra","sag"],"name":"Central African Republic","status":"assigned"},{"alpha2":"CG","alpha3":"COG","countryCallingCodes":["+242"],"currencies":["XAF"],"emoji":"🇨🇬","ioc":"CGO","languages":["fra","lin"],"name":"Republic Of Congo","status":"assigned"},{"alpha2":"CH","alpha3":"CHE","countryCallingCodes":["+41"],"currencies":["CHF","CHE","CHW"],"emoji":"🇨🇭","ioc":"SUI","languages":["deu","fra","ita","roh"],"name":"Switzerland","status":"assigned"},{"alpha2":"CI","alpha3":"CIV","countryCallingCodes":["+225"],"currencies":["XOF"],"emoji":"🇨🇮","ioc":"CIV","languages":["fra"],"name":"Côte d'Ivoire","status":"assigned"},{"alpha2":"CK","alpha3":"COK","countryCallingCodes":["+682"],"currencies":["NZD"],"emoji":"🇨🇰","ioc":"COK","languages":["eng","mri"],"name":"Cook Islands","status":"assigned"},{"alpha2":"CL","alpha3":"CHL","countryCallingCodes":["+56"],"currencies":["CLP","CLF"],"emoji":"🇨🇱","ioc":"CHI","languages":["spa"],"name":"Chile","status":"assigned"},{"alpha2":"CM","alpha3":"CMR","countryCallingCodes":["+237"],"currencies":["XAF"],"emoji":"🇨🇲","ioc":"CMR","languages":["eng","fra"],"name":"Cameroon","status":"assigned"},{"alpha2":"CN","alpha3":"CHN","countryCallingCodes":["+86"],"currencies":["CNY"],"emoji":"🇨🇳","ioc":"CHN","languages":["zho"],"name":"China","status":"assigned"},{"alpha2":"CO","alpha3":"COL","countryCallingCodes":["+57"],"currencies":["COP","COU"],"emoji":"🇨🇴","ioc":"COL","languages":["spa"],"name":"Colombia","status":"assigned"},{"alpha2":"CP","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Clipperton Island","status":"reserved"},{"alpha2":"CR","alpha3":"CRI","countryCallingCodes":["+506"],"currencies":["CRC"],"emoji":"🇨🇷","ioc":"CRC","languages":["spa"],"name":"Costa Rica","status":"assigned"},{"alpha2":"CS","alpha3":"CSK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Czechoslovakia","status":"deleted"},{"alpha2":"CS","alpha3":"SCG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Serbia and Montenegro","status":"deleted"},{"alpha2":"CT","alpha3":"CTE","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Canton and Enderbury Islands","status":"deleted"},{"alpha2":"CU","alpha3":"CUB","countryCallingCodes":["+53"],"currencies":["CUP","CUC"],"emoji":"🇨🇺","ioc":"CUB","languages":["spa"],"name":"Cuba","status":"assigned"},{"alpha2":"CV","alpha3":"CPV","countryCallingCodes":["+238"],"currencies":["CVE"],"emoji":"🇨🇻","ioc":"CPV","languages":["por"],"name":"Cabo Verde","status":"assigned"},{"alpha2":"CW","alpha3":"CUW","countryCallingCodes":["+599"],"currencies":["ANG"],"emoji":"🇨🇼","ioc":"","languages":["nld"],"name":"Curacao","status":"assigned"},{"alpha2":"CX","alpha3":"CXR","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇽","ioc":"","languages":["eng"],"name":"Christmas Island","status":"assigned"},{"alpha2":"CY","alpha3":"CYP","countryCallingCodes":["+357"],"currencies":["EUR"],"emoji":"🇨🇾","ioc":"CYP","languages":["ell","tur"],"name":"Cyprus","status":"assigned"},{"alpha2":"CZ","alpha3":"CZE","countryCallingCodes":["+420"],"currencies":["CZK"],"emoji":"🇨🇿","ioc":"CZE","languages":["ces"],"name":"Czech Republic","status":"assigned"},{"alpha2":"DD","alpha3":"DDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"German Democratic Republic","status":"deleted"},{"alpha2":"DE","alpha3":"DEU","countryCallingCodes":["+49"],"currencies":["EUR"],"emoji":"🇩🇪","ioc":"GER","languages":["deu"],"name":"Germany","status":"assigned"},{"alpha2":"DG","alpha3":"","countryCallingCodes":[],"currencies":["USD"],"emoji":"","ioc":"","languages":[],"name":"Diego Garcia","status":"reserved"},{"alpha2":"DJ","alpha3":"DJI","countryCallingCodes":["+253"],"currencies":["DJF"],"emoji":"🇩🇯","ioc":"DJI","languages":["ara","fra"],"name":"Djibouti","status":"assigned"},{"alpha2":"DK","alpha3":"DNK","countryCallingCodes":["+45"],"currencies":["DKK"],"emoji":"🇩🇰","ioc":"DEN","languages":["dan"],"name":"Denmark","status":"assigned"},{"alpha2":"DM","alpha3":"DMA","countryCallingCodes":["+1 767"],"currencies":["XCD"],"emoji":"🇩🇲","ioc":"DMA","languages":["eng"],"name":"Dominica","status":"assigned"},{"alpha2":"DO","alpha3":"DOM","countryCallingCodes":["+1 809","+1 829","+1 849"],"currencies":["DOP"],"emoji":"🇩🇴","ioc":"DOM","languages":["spa"],"name":"Dominican Republic","status":"assigned"},{"alpha2":"DY","alpha3":"DHY","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dahomey","status":"deleted"},{"alpha2":"DZ","alpha3":"DZA","countryCallingCodes":["+213"],"currencies":["DZD"],"emoji":"🇩🇿","ioc":"ALG","languages":["ara"],"name":"Algeria","status":"assigned"},{"alpha2":"EA","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Ceuta, Mulilla","status":"reserved"},{"alpha2":"EC","alpha3":"ECU","countryCallingCodes":["+593"],"currencies":["USD"],"emoji":"🇪🇨","ioc":"ECU","languages":["spa","que"],"name":"Ecuador","status":"assigned"},{"alpha2":"EE","alpha3":"EST","countryCallingCodes":["+372"],"currencies":["EUR"],"emoji":"🇪🇪","ioc":"EST","languages":["est"],"name":"Estonia","status":"assigned"},{"alpha2":"EG","alpha3":"EGY","countryCallingCodes":["+20"],"currencies":["EGP"],"emoji":"🇪🇬","ioc":"EGY","languages":["ara"],"name":"Egypt","status":"assigned"},{"alpha2":"EH","alpha3":"ESH","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇪🇭","ioc":"","languages":[],"name":"Western Sahara","status":"assigned"},{"alpha2":"ER","alpha3":"ERI","countryCallingCodes":["+291"],"currencies":["ERN"],"emoji":"🇪🇷","ioc":"ERI","languages":["eng","ara","tir"],"name":"Eritrea","status":"assigned"},{"alpha2":"ES","alpha3":"ESP","countryCallingCodes":["+34"],"currencies":["EUR"],"emoji":"🇪🇸","ioc":"ESP","languages":["spa"],"name":"Spain","status":"assigned"},{"alpha2":"ET","alpha3":"ETH","countryCallingCodes":["+251"],"currencies":["ETB"],"emoji":"🇪🇹","ioc":"ETH","languages":["amh"],"name":"Ethiopia","status":"assigned"},{"alpha2":"EU","alpha3":"","countryCallingCodes":["+388"],"currencies":["EUR"],"emoji":"🇪🇺","ioc":"","languages":[],"name":"European Union","status":"reserved"},{"alpha2":"FI","alpha3":"FIN","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇫🇮","ioc":"FIN","languages":["fin","swe"],"name":"Finland","status":"assigned"},{"alpha2":"FJ","alpha3":"FJI","countryCallingCodes":["+679"],"currencies":["FJD"],"emoji":"🇫🇯","ioc":"FIJ","languages":["eng","fij"],"name":"Fiji","status":"assigned"},{"alpha2":"FK","alpha3":"FLK","countryCallingCodes":["+500"],"currencies":["FKP"],"emoji":"🇫🇰","ioc":"","languages":["eng"],"name":"Falkland Islands","status":"assigned"},{"alpha2":"FM","alpha3":"FSM","countryCallingCodes":["+691"],"currencies":["USD"],"emoji":"🇫🇲","ioc":"FSM","languages":["eng"],"name":"Micronesia, Federated States Of","status":"assigned"},{"alpha2":"FO","alpha3":"FRO","countryCallingCodes":["+298"],"currencies":["DKK"],"emoji":"🇫🇴","ioc":"FAI","languages":["fao","dan"],"name":"Faroe Islands","status":"assigned"},{"alpha2":"FQ","alpha3":"ATF","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Southern and Antarctic Territories","status":"deleted"},{"alpha2":"FR","alpha3":"FRA","countryCallingCodes":["+33"],"currencies":["EUR"],"emoji":"🇫🇷","ioc":"FRA","languages":["fra"],"name":"France","status":"assigned"},{"alpha2":"FX","alpha3":"","countryCallingCodes":["+241"],"currencies":["EUR"],"emoji":"","ioc":"","languages":["fra"],"name":"France, Metropolitan","status":"reserved"},{"alpha2":"GA","alpha3":"GAB","countryCallingCodes":["+241"],"currencies":["XAF"],"emoji":"🇬🇦","ioc":"GAB","languages":["fra"],"name":"Gabon","status":"assigned"},{"alpha2":"GB","alpha3":"GBR","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇧","ioc":"GBR","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"assigned"},{"alpha2":"GD","alpha3":"GRD","countryCallingCodes":["+473"],"currencies":["XCD"],"emoji":"🇬🇩","ioc":"GRN","languages":["eng"],"name":"Grenada","status":"assigned"},{"alpha2":"GE","alpha3":"GEO","countryCallingCodes":["+995"],"currencies":["GEL"],"emoji":"🇬🇪","ioc":"GEO","languages":["kat"],"name":"Georgia","status":"assigned"},{"alpha2":"GE","alpha3":"GEL","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Gilbert and Ellice Islands","status":"deleted"},{"alpha2":"GF","alpha3":"GUF","countryCallingCodes":["+594"],"currencies":["EUR"],"emoji":"🇬🇫","ioc":"","languages":["fra"],"name":"French Guiana","status":"assigned"},{"alpha2":"GG","alpha3":"GGY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇬","ioc":"GCI","languages":["fra"],"name":"Guernsey","status":"assigned"},{"alpha2":"GH","alpha3":"GHA","countryCallingCodes":["+233"],"currencies":["GHS"],"emoji":"🇬🇭","ioc":"GHA","languages":["eng"],"name":"Ghana","status":"assigned"},{"alpha2":"GI","alpha3":"GIB","countryCallingCodes":["+350"],"currencies":["GIP"],"emoji":"🇬🇮","ioc":"","languages":["eng"],"name":"Gibraltar","status":"assigned"},{"alpha2":"GL","alpha3":"GRL","countryCallingCodes":["+299"],"currencies":["DKK"],"emoji":"🇬🇱","ioc":"","languages":["kal"],"name":"Greenland","status":"assigned"},{"alpha2":"GM","alpha3":"GMB","countryCallingCodes":["+220"],"currencies":["GMD"],"emoji":"🇬🇲","ioc":"GAM","languages":["eng"],"name":"Gambia","status":"assigned"},{"alpha2":"GN","alpha3":"GIN","countryCallingCodes":["+224"],"currencies":["GNF"],"emoji":"🇬🇳","ioc":"GUI","languages":["fra"],"name":"Guinea","status":"assigned"},{"alpha2":"GP","alpha3":"GLP","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇬🇵","ioc":"","languages":["fra"],"name":"Guadeloupe","status":"assigned"},{"alpha2":"GQ","alpha3":"GNQ","countryCallingCodes":["+240"],"currencies":["XAF"],"emoji":"🇬🇶","ioc":"GEQ","languages":["spa","fra","por"],"name":"Equatorial Guinea","status":"assigned"},{"alpha2":"GR","alpha3":"GRC","countryCallingCodes":["+30"],"currencies":["EUR"],"emoji":"🇬🇷","ioc":"GRE","languages":["ell"],"name":"Greece","status":"assigned"},{"alpha2":"GS","alpha3":"SGS","countryCallingCodes":[],"currencies":["GBP"],"emoji":"🇬🇸","ioc":"","languages":["eng"],"name":"South Georgia And The South Sandwich Islands","status":"assigned"},{"alpha2":"GT","alpha3":"GTM","countryCallingCodes":["+502"],"currencies":["GTQ"],"emoji":"🇬🇹","ioc":"GUA","languages":["spa"],"name":"Guatemala","status":"assigned"},{"alpha2":"GU","alpha3":"GUM","countryCallingCodes":["+1 671"],"currencies":["USD"],"emoji":"🇬🇺","ioc":"GUM","languages":["eng"],"name":"Guam","status":"assigned"},{"alpha2":"GW","alpha3":"GNB","countryCallingCodes":["+245"],"currencies":["XOF"],"emoji":"🇬🇼","ioc":"GBS","languages":["por"],"name":"Guinea-bissau","status":"assigned"},{"alpha2":"GY","alpha3":"GUY","countryCallingCodes":["+592"],"currencies":["GYD"],"emoji":"🇬🇾","ioc":"GUY","languages":["eng"],"name":"Guyana","status":"assigned"},{"alpha2":"HK","alpha3":"HKG","countryCallingCodes":["+852"],"currencies":["HKD"],"emoji":"🇭🇰","ioc":"HKG","languages":["zho","eng"],"name":"Hong Kong","status":"assigned"},{"alpha2":"HM","alpha3":"HMD","countryCallingCodes":[],"currencies":["AUD"],"emoji":"🇭🇲","ioc":"","languages":[],"name":"Heard Island And McDonald Islands","status":"assigned"},{"alpha2":"HN","alpha3":"HND","countryCallingCodes":["+504"],"currencies":["HNL"],"emoji":"🇭🇳","ioc":"HON","languages":["spa"],"name":"Honduras","status":"assigned"},{"alpha2":"HR","alpha3":"HRV","countryCallingCodes":["+385"],"currencies":["HRK"],"emoji":"🇭🇷","ioc":"CRO","languages":["hrv"],"name":"Croatia","status":"assigned"},{"alpha2":"HT","alpha3":"HTI","countryCallingCodes":["+509"],"currencies":["HTG","USD"],"emoji":"🇭🇹","ioc":"HAI","languages":["fra","hat"],"name":"Haiti","status":"assigned"},{"alpha2":"HU","alpha3":"HUN","countryCallingCodes":["+36"],"currencies":["HUF"],"emoji":"🇭🇺","ioc":"HUN","languages":["hun"],"name":"Hungary","status":"assigned"},{"alpha2":"HV","alpha3":"HVO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Upper Volta","status":"deleted"},{"alpha2":"IC","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Canary Islands","status":"reserved"},{"alpha2":"ID","alpha3":"IDN","countryCallingCodes":["+62"],"currencies":["IDR"],"emoji":"🇮🇩","ioc":"INA","languages":["ind"],"name":"Indonesia","status":"assigned"},{"alpha2":"IE","alpha3":"IRL","countryCallingCodes":["+353"],"currencies":["EUR"],"emoji":"🇮🇪","ioc":"IRL","languages":["eng","gle"],"name":"Ireland","status":"assigned"},{"alpha2":"IL","alpha3":"ISR","countryCallingCodes":["+972"],"currencies":["ILS"],"emoji":"🇮🇱","ioc":"ISR","languages":["heb","ara","eng"],"name":"Israel","status":"assigned"},{"alpha2":"IM","alpha3":"IMN","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇮🇲","ioc":"","languages":["eng","glv"],"name":"Isle Of Man","status":"assigned"},{"alpha2":"IN","alpha3":"IND","countryCallingCodes":["+91"],"currencies":["INR"],"emoji":"🇮🇳","ioc":"IND","languages":["eng","hin"],"name":"India","status":"assigned"},{"alpha2":"IO","alpha3":"IOT","countryCallingCodes":["+246"],"currencies":["USD"],"emoji":"🇮🇴","ioc":"","languages":["eng"],"name":"British Indian Ocean Territory","status":"assigned"},{"alpha2":"IQ","alpha3":"IRQ","countryCallingCodes":["+964"],"currencies":["IQD"],"emoji":"🇮🇶","ioc":"IRQ","languages":["ara","kur"],"name":"Iraq","status":"assigned"},{"alpha2":"IR","alpha3":"IRN","countryCallingCodes":["+98"],"currencies":["IRR"],"emoji":"🇮🇷","ioc":"IRI","languages":["fas"],"name":"Iran, Islamic Republic Of","status":"assigned"},{"alpha2":"IS","alpha3":"ISL","countryCallingCodes":["+354"],"currencies":["ISK"],"emoji":"🇮🇸","ioc":"ISL","languages":["isl"],"name":"Iceland","status":"assigned"},{"alpha2":"IT","alpha3":"ITA","countryCallingCodes":["+39"],"currencies":["EUR"],"emoji":"🇮🇹","ioc":"ITA","languages":["ita"],"name":"Italy","status":"assigned"},{"alpha2":"JE","alpha3":"JEY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇯🇪","ioc":"JCI","languages":["eng","fra"],"name":"Jersey","status":"assigned"},{"alpha2":"JM","alpha3":"JAM","countryCallingCodes":["+1 876"],"currencies":["JMD"],"emoji":"🇯🇲","ioc":"JAM","languages":["eng"],"name":"Jamaica","status":"assigned"},{"alpha2":"JO","alpha3":"JOR","countryCallingCodes":["+962"],"currencies":["JOD"],"emoji":"🇯🇴","ioc":"JOR","languages":["ara"],"name":"Jordan","status":"assigned"},{"alpha2":"JP","alpha3":"JPN","countryCallingCodes":["+81"],"currencies":["JPY"],"emoji":"🇯🇵","ioc":"JPN","languages":["jpn"],"name":"Japan","status":"assigned"},{"alpha2":"JT","alpha3":"JTN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Johnston Island","status":"deleted"},{"alpha2":"KE","alpha3":"KEN","countryCallingCodes":["+254"],"currencies":["KES"],"emoji":"🇰🇪","ioc":"KEN","languages":["eng","swa"],"name":"Kenya","status":"assigned"},{"alpha2":"KG","alpha3":"KGZ","countryCallingCodes":["+996"],"currencies":["KGS"],"emoji":"🇰🇬","ioc":"KGZ","languages":["rus"],"name":"Kyrgyzstan","status":"assigned"},{"alpha2":"KH","alpha3":"KHM","countryCallingCodes":["+855"],"currencies":["KHR"],"emoji":"🇰🇭","ioc":"CAM","languages":["khm"],"name":"Cambodia","status":"assigned"},{"alpha2":"KI","alpha3":"KIR","countryCallingCodes":["+686"],"currencies":["AUD"],"emoji":"🇰🇮","ioc":"KIR","languages":["eng"],"name":"Kiribati","status":"assigned"},{"alpha2":"KM","alpha3":"COM","countryCallingCodes":["+269"],"currencies":["KMF"],"emoji":"🇰🇲","ioc":"COM","languages":["ara","fra"],"name":"Comoros","status":"assigned"},{"alpha2":"KN","alpha3":"KNA","countryCallingCodes":["+1 869"],"currencies":["XCD"],"emoji":"🇰🇳","ioc":"SKN","languages":["eng"],"name":"Saint Kitts And Nevis","status":"assigned"},{"alpha2":"KP","alpha3":"PRK","countryCallingCodes":["+850"],"currencies":["KPW"],"emoji":"🇰🇵","ioc":"PRK","languages":["kor"],"name":"Korea, Democratic People's Republic Of","status":"assigned"},{"alpha2":"KR","alpha3":"KOR","countryCallingCodes":["+82"],"currencies":["KRW"],"emoji":"🇰🇷","ioc":"KOR","languages":["kor"],"name":"Korea, Republic Of","status":"assigned"},{"alpha2":"KW","alpha3":"KWT","countryCallingCodes":["+965"],"currencies":["KWD"],"emoji":"🇰🇼","ioc":"KUW","languages":["ara"],"name":"Kuwait","status":"assigned"},{"alpha2":"KY","alpha3":"CYM","countryCallingCodes":["+1 345"],"currencies":["KYD"],"emoji":"🇰🇾","ioc":"CAY","languages":["eng"],"name":"Cayman Islands","status":"assigned"},{"alpha2":"KZ","alpha3":"KAZ","countryCallingCodes":["+7","+7 6","+7 7"],"currencies":["KZT"],"emoji":"🇰🇿","ioc":"KAZ","languages":["kaz","rus"],"name":"Kazakhstan","status":"assigned"},{"alpha2":"LA","alpha3":"LAO","countryCallingCodes":["+856"],"currencies":["LAK"],"emoji":"🇱🇦","ioc":"LAO","languages":["lao"],"name":"Lao People's Democratic Republic","status":"assigned"},{"alpha2":"LB","alpha3":"LBN","countryCallingCodes":["+961"],"currencies":["LBP"],"emoji":"🇱🇧","ioc":"LIB","languages":["ara","hye"],"name":"Lebanon","status":"assigned"},{"alpha2":"LC","alpha3":"LCA","countryCallingCodes":["+1 758"],"currencies":["XCD"],"emoji":"🇱🇨","ioc":"LCA","languages":["eng"],"name":"Saint Lucia","status":"assigned"},{"alpha2":"LI","alpha3":"LIE","countryCallingCodes":["+423"],"currencies":["CHF"],"emoji":"🇱🇮","ioc":"LIE","languages":["deu"],"name":"Liechtenstein","status":"assigned"},{"alpha2":"LK","alpha3":"LKA","countryCallingCodes":["+94"],"currencies":["LKR"],"emoji":"🇱🇰","ioc":"SRI","languages":["sin","tam"],"name":"Sri Lanka","status":"assigned"},{"alpha2":"LR","alpha3":"LBR","countryCallingCodes":["+231"],"currencies":["LRD"],"emoji":"🇱🇷","ioc":"LBR","languages":["eng"],"name":"Liberia","status":"assigned"},{"alpha2":"LS","alpha3":"LSO","countryCallingCodes":["+266"],"currencies":["LSL","ZAR"],"emoji":"🇱🇸","ioc":"LES","languages":["eng","sot"],"name":"Lesotho","status":"assigned"},{"alpha2":"LT","alpha3":"LTU","countryCallingCodes":["+370"],"currencies":["EUR"],"emoji":"🇱🇹","ioc":"LTU","languages":["lit"],"name":"Lithuania","status":"assigned"},{"alpha2":"LU","alpha3":"LUX","countryCallingCodes":["+352"],"currencies":["EUR"],"emoji":"🇱🇺","ioc":"LUX","languages":["fra","deu","ltz"],"name":"Luxembourg","status":"assigned"},{"alpha2":"LV","alpha3":"LVA","countryCallingCodes":["+371"],"currencies":["EUR"],"emoji":"🇱🇻","ioc":"LAT","languages":["lav"],"name":"Latvia","status":"assigned"},{"alpha2":"LY","alpha3":"LBY","countryCallingCodes":["+218"],"currencies":["LYD"],"emoji":"🇱🇾","ioc":"LBA","languages":["ara"],"name":"Libya","status":"assigned"},{"alpha2":"MA","alpha3":"MAR","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇲🇦","ioc":"MAR","languages":["ara"],"name":"Morocco","status":"assigned"},{"alpha2":"MC","alpha3":"MCO","countryCallingCodes":["+377"],"currencies":["EUR"],"emoji":"🇲🇨","ioc":"MON","languages":["fra"],"name":"Monaco","status":"assigned"},{"alpha2":"MD","alpha3":"MDA","countryCallingCodes":["+373"],"currencies":["MDL"],"emoji":"🇲🇩","ioc":"MDA","languages":["ron"],"name":"Moldova","status":"assigned"},{"alpha2":"ME","alpha3":"MNE","countryCallingCodes":["+382"],"currencies":["EUR"],"emoji":"🇲🇪","ioc":"MNE","languages":["mot"],"name":"Montenegro","status":"assigned"},{"alpha2":"MF","alpha3":"MAF","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇲🇫","ioc":"","languages":["fra"],"name":"Saint Martin","status":"assigned"},{"alpha2":"MG","alpha3":"MDG","countryCallingCodes":["+261"],"currencies":["MGA"],"emoji":"🇲🇬","ioc":"MAD","languages":["fra","mlg"],"name":"Madagascar","status":"assigned"},{"alpha2":"MH","alpha3":"MHL","countryCallingCodes":["+692"],"currencies":["USD"],"emoji":"🇲🇭","ioc":"MHL","languages":["eng","mah"],"name":"Marshall Islands","status":"assigned"},{"alpha2":"MI","alpha3":"MID","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Midway Islands","status":"deleted"},{"alpha2":"MK","alpha3":"MKD","countryCallingCodes":["+389"],"currencies":["MKD"],"emoji":"🇲🇰","ioc":"MKD","languages":["mkd"],"name":"Macedonia, The Former Yugoslav Republic Of","status":"assigned"},{"alpha2":"ML","alpha3":"MLI","countryCallingCodes":["+223"],"currencies":["XOF"],"emoji":"🇲🇱","ioc":"MLI","languages":["fra"],"name":"Mali","status":"assigned"},{"alpha2":"MM","alpha3":"MMR","countryCallingCodes":["+95"],"currencies":["MMK"],"emoji":"🇲🇲","ioc":"MYA","languages":["mya"],"name":"Myanmar","status":"assigned"},{"alpha2":"MN","alpha3":"MNG","countryCallingCodes":["+976"],"currencies":["MNT"],"emoji":"🇲🇳","ioc":"MGL","languages":["mon"],"name":"Mongolia","status":"assigned"},{"alpha2":"MO","alpha3":"MAC","countryCallingCodes":["+853"],"currencies":["MOP"],"emoji":"🇲🇴","ioc":"MAC","languages":["zho","por"],"name":"Macao","status":"assigned"},{"alpha2":"MP","alpha3":"MNP","countryCallingCodes":["+1 670"],"currencies":["USD"],"emoji":"🇲🇵","ioc":"","languages":["eng"],"name":"Northern Mariana Islands","status":"assigned"},{"alpha2":"MQ","alpha3":"MTQ","countryCallingCodes":["+596"],"currencies":["EUR"],"emoji":"🇲🇶","ioc":"","languages":[],"name":"Martinique","status":"assigned"},{"alpha2":"MR","alpha3":"MRT","countryCallingCodes":["+222"],"currencies":["MRO"],"emoji":"🇲🇷","ioc":"MTN","languages":["ara","fra"],"name":"Mauritania","status":"assigned"},{"alpha2":"MS","alpha3":"MSR","countryCallingCodes":["+1 664"],"currencies":["XCD"],"emoji":"🇲🇸","ioc":"","languages":[],"name":"Montserrat","status":"assigned"},{"alpha2":"MT","alpha3":"MLT","countryCallingCodes":["+356"],"currencies":["EUR"],"emoji":"🇲🇹","ioc":"MLT","languages":["mlt","eng"],"name":"Malta","status":"assigned"},{"alpha2":"MU","alpha3":"MUS","countryCallingCodes":["+230"],"currencies":["MUR"],"emoji":"🇲🇺","ioc":"MRI","languages":["eng","fra"],"name":"Mauritius","status":"assigned"},{"alpha2":"MV","alpha3":"MDV","countryCallingCodes":["+960"],"currencies":["MVR"],"emoji":"🇲🇻","ioc":"MDV","languages":["div"],"name":"Maldives","status":"assigned"},{"alpha2":"MW","alpha3":"MWI","countryCallingCodes":["+265"],"currencies":["MWK"],"emoji":"🇲🇼","ioc":"MAW","languages":["eng","nya"],"name":"Malawi","status":"assigned"},{"alpha2":"MX","alpha3":"MEX","countryCallingCodes":["+52"],"currencies":["MXN","MXV"],"emoji":"🇲🇽","ioc":"MEX","languages":["spa"],"name":"Mexico","status":"assigned"},{"alpha2":"MY","alpha3":"MYS","countryCallingCodes":["+60"],"currencies":["MYR"],"emoji":"🇲🇾","ioc":"MAS","languages":["msa","eng"],"name":"Malaysia","status":"assigned"},{"alpha2":"MZ","alpha3":"MOZ","countryCallingCodes":["+258"],"currencies":["MZN"],"emoji":"🇲🇿","ioc":"MOZ","languages":["por"],"name":"Mozambique","status":"assigned"},{"alpha2":"NA","alpha3":"NAM","countryCallingCodes":["+264"],"currencies":["NAD","ZAR"],"emoji":"🇳🇦","ioc":"NAM","languages":["eng"],"name":"Namibia","status":"assigned"},{"alpha2":"NC","alpha3":"NCL","countryCallingCodes":["+687"],"currencies":["XPF"],"emoji":"🇳🇨","ioc":"","languages":["fra"],"name":"New Caledonia","status":"assigned"},{"alpha2":"NE","alpha3":"NER","countryCallingCodes":["+227"],"currencies":["XOF"],"emoji":"🇳🇪","ioc":"NIG","languages":["fra"],"name":"Niger","status":"assigned"},{"alpha2":"NF","alpha3":"NFK","countryCallingCodes":["+672"],"currencies":["AUD"],"emoji":"🇳🇫","ioc":"","languages":["eng"],"name":"Norfolk Island","status":"assigned"},{"alpha2":"NG","alpha3":"NGA","countryCallingCodes":["+234"],"currencies":["NGN"],"emoji":"🇳🇬","ioc":"NGR","languages":["eng"],"name":"Nigeria","status":"assigned"},{"alpha2":"NH","alpha3":"NHB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"New Hebrides","status":"deleted"},{"alpha2":"NI","alpha3":"NIC","countryCallingCodes":["+505"],"currencies":["NIO"],"emoji":"🇳🇮","ioc":"NCA","languages":["spa"],"name":"Nicaragua","status":"assigned"},{"alpha2":"NL","alpha3":"NLD","countryCallingCodes":["+31"],"currencies":["EUR"],"emoji":"🇳🇱","ioc":"NED","languages":["nld"],"name":"Netherlands","status":"assigned"},{"alpha2":"NO","alpha3":"NOR","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇳🇴","ioc":"NOR","languages":["nor"],"name":"Norway","status":"assigned"},{"alpha2":"NP","alpha3":"NPL","countryCallingCodes":["+977"],"currencies":["NPR"],"emoji":"🇳🇵","ioc":"NEP","languages":["nep"],"name":"Nepal","status":"assigned"},{"alpha2":"NQ","alpha3":"ATN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dronning Maud Land","status":"deleted"},{"alpha2":"NR","alpha3":"NRU","countryCallingCodes":["+674"],"currencies":["AUD"],"emoji":"🇳🇷","ioc":"NRU","languages":["eng","nau"],"name":"Nauru","status":"assigned"},{"alpha2":"NT","alpha3":"NTZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Neutral Zone","status":"deleted"},{"alpha2":"NU","alpha3":"NIU","countryCallingCodes":["+683"],"currencies":["NZD"],"emoji":"🇳🇺","ioc":"","languages":["eng"],"name":"Niue","status":"assigned"},{"alpha2":"NZ","alpha3":"NZL","countryCallingCodes":["+64"],"currencies":["NZD"],"emoji":"🇳🇿","ioc":"NZL","languages":["eng"],"name":"New Zealand","status":"assigned"},{"alpha2":"OM","alpha3":"OMN","countryCallingCodes":["+968"],"currencies":["OMR"],"emoji":"🇴🇲","ioc":"OMA","languages":["ara"],"name":"Oman","status":"assigned"},{"alpha2":"PA","alpha3":"PAN","countryCallingCodes":["+507"],"currencies":["PAB","USD"],"emoji":"🇵🇦","ioc":"PAN","languages":["spa"],"name":"Panama","status":"assigned"},{"alpha2":"PC","alpha3":"PCI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Pacific Islands, Trust Territory of the","status":"deleted"},{"alpha2":"PE","alpha3":"PER","countryCallingCodes":["+51"],"currencies":["PEN"],"emoji":"🇵🇪","ioc":"PER","languages":["spa","aym","que"],"name":"Peru","status":"assigned"},{"alpha2":"PF","alpha3":"PYF","countryCallingCodes":["+689"],"currencies":["XPF"],"emoji":"🇵🇫","ioc":"","languages":["fra"],"name":"French Polynesia","status":"assigned"},{"alpha2":"PG","alpha3":"PNG","countryCallingCodes":["+675"],"currencies":["PGK"],"emoji":"🇵🇬","ioc":"PNG","languages":["eng"],"name":"Papua New Guinea","status":"assigned"},{"alpha2":"PH","alpha3":"PHL","countryCallingCodes":["+63"],"currencies":["PHP"],"emoji":"🇵🇭","ioc":"PHI","languages":["eng"],"name":"Philippines","status":"assigned"},{"alpha2":"PK","alpha3":"PAK","countryCallingCodes":["+92"],"currencies":["PKR"],"emoji":"🇵🇰","ioc":"PAK","languages":["urd","eng"],"name":"Pakistan","status":"assigned"},{"alpha2":"PL","alpha3":"POL","countryCallingCodes":["+48"],"currencies":["PLN"],"emoji":"🇵🇱","ioc":"POL","languages":["pol"],"name":"Poland","status":"assigned"},{"alpha2":"PM","alpha3":"SPM","countryCallingCodes":["+508"],"currencies":["EUR"],"emoji":"🇵🇲","ioc":"","languages":["eng"],"name":"Saint Pierre And Miquelon","status":"assigned"},{"alpha2":"PN","alpha3":"PCN","countryCallingCodes":["+872"],"currencies":["NZD"],"emoji":"🇵🇳","ioc":"","languages":["eng"],"name":"Pitcairn","status":"assigned"},{"alpha2":"PR","alpha3":"PRI","countryCallingCodes":["+1 787","+1 939"],"currencies":["USD"],"emoji":"🇵🇷","ioc":"PUR","languages":["spa","eng"],"name":"Puerto Rico","status":"assigned"},{"alpha2":"PS","alpha3":"PSE","countryCallingCodes":["+970"],"currencies":["JOD","EGP","ILS"],"emoji":"🇵🇸","ioc":"PLE","languages":["ara"],"name":"Palestinian Territory, Occupied","status":"assigned"},{"alpha2":"PT","alpha3":"PRT","countryCallingCodes":["+351"],"currencies":["EUR"],"emoji":"🇵🇹","ioc":"POR","languages":["por"],"name":"Portugal","status":"assigned"},{"alpha2":"PU","alpha3":"PUS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"U.S. Miscellaneous Pacific Islands","status":"deleted"},{"alpha2":"PW","alpha3":"PLW","countryCallingCodes":["+680"],"currencies":["USD"],"emoji":"🇵🇼","ioc":"PLW","languages":["eng"],"name":"Palau","status":"assigned"},{"alpha2":"PY","alpha3":"PRY","countryCallingCodes":["+595"],"currencies":["PYG"],"emoji":"🇵🇾","ioc":"PAR","languages":["spa"],"name":"Paraguay","status":"assigned"},{"alpha2":"PZ","alpha3":"PCZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Panama Canal Zone","status":"deleted"},{"alpha2":"QA","alpha3":"QAT","countryCallingCodes":["+974"],"currencies":["QAR"],"emoji":"🇶🇦","ioc":"QAT","languages":["ara"],"name":"Qatar","status":"assigned"},{"alpha2":"RE","alpha3":"REU","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇷🇪","ioc":"","languages":["fra"],"name":"Reunion","status":"assigned"},{"alpha2":"RH","alpha3":"RHO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Southern Rhodesia","status":"deleted"},{"alpha2":"RO","alpha3":"ROU","countryCallingCodes":["+40"],"currencies":["RON"],"emoji":"🇷🇴","ioc":"ROU","languages":["ron"],"name":"Romania","status":"assigned"},{"alpha2":"RS","alpha3":"SRB","countryCallingCodes":["+381"],"currencies":["RSD"],"emoji":"🇷🇸","ioc":"SRB","languages":["srp"],"name":"Serbia","status":"assigned"},{"alpha2":"RU","alpha3":"RUS","countryCallingCodes":["+7","+7 3","+7 4","+7 8"],"currencies":["RUB"],"emoji":"🇷🇺","ioc":"RUS","languages":["rus"],"name":"Russian Federation","status":"assigned"},{"alpha2":"RW","alpha3":"RWA","countryCallingCodes":["+250"],"currencies":["RWF"],"emoji":"🇷🇼","ioc":"RWA","languages":["eng","fra","kin"],"name":"Rwanda","status":"assigned"},{"alpha2":"SA","alpha3":"SAU","countryCallingCodes":["+966"],"currencies":["SAR"],"emoji":"🇸🇦","ioc":"KSA","languages":["ara"],"name":"Saudi Arabia","status":"assigned"},{"alpha2":"SB","alpha3":"SLB","countryCallingCodes":["+677"],"currencies":["SBD"],"emoji":"🇸🇧","ioc":"SOL","languages":["eng"],"name":"Solomon Islands","status":"assigned"},{"alpha2":"SC","alpha3":"SYC","countryCallingCodes":["+248"],"currencies":["SCR"],"emoji":"🇸🇨","ioc":"SEY","languages":["eng","fra"],"name":"Seychelles","status":"assigned"},{"alpha2":"SD","alpha3":"SDN","countryCallingCodes":["+249"],"currencies":["SDG"],"emoji":"🇸🇩","ioc":"SUD","languages":["ara","eng"],"name":"Sudan","status":"assigned"},{"alpha2":"SE","alpha3":"SWE","countryCallingCodes":["+46"],"currencies":["SEK"],"emoji":"🇸🇪","ioc":"SWE","languages":["swe"],"name":"Sweden","status":"assigned"},{"alpha2":"SG","alpha3":"SGP","countryCallingCodes":["+65"],"currencies":["SGD"],"emoji":"🇸🇬","ioc":"SIN","languages":["eng","zho","msa","tam"],"name":"Singapore","status":"assigned"},{"alpha2":"SH","alpha3":"SHN","countryCallingCodes":["+290"],"currencies":["SHP"],"emoji":"🇸🇭","ioc":"","languages":["eng"],"name":"Saint Helena, Ascension And Tristan Da Cunha","status":"assigned"},{"alpha2":"SI","alpha3":"SVN","countryCallingCodes":["+386"],"currencies":["EUR"],"emoji":"🇸🇮","ioc":"SLO","languages":["slv"],"name":"Slovenia","status":"assigned"},{"alpha2":"SJ","alpha3":"SJM","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇸🇯","ioc":"","languages":[],"name":"Svalbard And Jan Mayen","status":"assigned"},{"alpha2":"SK","alpha3":"SVK","countryCallingCodes":["+421"],"currencies":["EUR"],"emoji":"🇸🇰","ioc":"SVK","languages":["slk"],"name":"Slovakia","status":"assigned"},{"alpha2":"SK","alpha3":"SKM","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Sikkim","status":"deleted"},{"alpha2":"SL","alpha3":"SLE","countryCallingCodes":["+232"],"currencies":["SLL"],"emoji":"🇸🇱","ioc":"SLE","languages":["eng"],"name":"Sierra Leone","status":"assigned"},{"alpha2":"SM","alpha3":"SMR","countryCallingCodes":["+378"],"currencies":["EUR"],"emoji":"🇸🇲","ioc":"SMR","languages":["ita"],"name":"San Marino","status":"assigned"},{"alpha2":"SN","alpha3":"SEN","countryCallingCodes":["+221"],"currencies":["XOF"],"emoji":"🇸🇳","ioc":"SEN","languages":["fra"],"name":"Senegal","status":"assigned"},{"alpha2":"SO","alpha3":"SOM","countryCallingCodes":["+252"],"currencies":["SOS"],"emoji":"🇸🇴","ioc":"SOM","languages":["som"],"name":"Somalia","status":"assigned"},{"alpha2":"SR","alpha3":"SUR","countryCallingCodes":["+597"],"currencies":["SRD"],"emoji":"🇸🇷","ioc":"SUR","languages":["nld"],"name":"Suriname","status":"assigned"},{"alpha2":"SS","alpha3":"SSD","countryCallingCodes":["+211"],"currencies":["SSP"],"emoji":"🇸🇸","ioc":"SSD","languages":["eng"],"name":"South Sudan","status":"assigned"},{"alpha2":"ST","alpha3":"STP","countryCallingCodes":["+239"],"currencies":["STD"],"emoji":"🇸🇹","ioc":"STP","languages":["por"],"name":"Sao Tome and Principe","status":"assigned"},{"alpha2":"SU","alpha3":"","countryCallingCodes":[],"currencies":["RUB"],"emoji":"","ioc":"","languages":["rus"],"name":"USSR","status":"reserved"},{"alpha2":"SV","alpha3":"SLV","countryCallingCodes":["+503"],"currencies":["USD"],"emoji":"🇸🇻","ioc":"ESA","languages":["spa"],"name":"El Salvador","status":"assigned"},{"alpha2":"SX","alpha3":"SXM","countryCallingCodes":["+1 721"],"currencies":["ANG"],"emoji":"🇸🇽","ioc":"","languages":["nld"],"name":"Sint Maarten","status":"assigned"},{"alpha2":"SY","alpha3":"SYR","countryCallingCodes":["+963"],"currencies":["SYP"],"emoji":"🇸🇾","ioc":"SYR","languages":["ara"],"name":"Syrian Arab Republic","status":"assigned"},{"alpha2":"SZ","alpha3":"SWZ","countryCallingCodes":["+268"],"currencies":["SZL"],"emoji":"🇸🇿","ioc":"SWZ","languages":["eng","ssw"],"name":"Swaziland","status":"assigned"},{"alpha2":"TA","alpha3":"","countryCallingCodes":["+290"],"currencies":["GBP"],"emoji":"","ioc":"","languages":[],"name":"Tristan de Cunha","status":"reserved"},{"alpha2":"TC","alpha3":"TCA","countryCallingCodes":["+1 649"],"currencies":["USD"],"emoji":"🇹🇨","ioc":"","languages":["eng"],"name":"Turks And Caicos Islands","status":"assigned"},{"alpha2":"TD","alpha3":"TCD","countryCallingCodes":["+235"],"currencies":["XAF"],"emoji":"🇹🇩","ioc":"CHA","languages":["ara","fra"],"name":"Chad","status":"assigned"},{"alpha2":"TF","alpha3":"ATF","countryCallingCodes":[],"currencies":["EUR"],"emoji":"🇹🇫","ioc":"","languages":["fra"],"name":"French Southern Territories","status":"assigned"},{"alpha2":"TG","alpha3":"TGO","countryCallingCodes":["+228"],"currencies":["XOF"],"emoji":"🇹🇬","ioc":"TOG","languages":["fra"],"name":"Togo","status":"assigned"},{"alpha2":"TH","alpha3":"THA","countryCallingCodes":["+66"],"currencies":["THB"],"emoji":"🇹🇭","ioc":"THA","languages":["tha"],"name":"Thailand","status":"assigned"},{"alpha2":"TJ","alpha3":"TJK","countryCallingCodes":["+992"],"currencies":["TJS"],"emoji":"🇹🇯","ioc":"TJK","languages":["tgk","rus"],"name":"Tajikistan","status":"assigned"},{"alpha2":"TK","alpha3":"TKL","countryCallingCodes":["+690"],"currencies":["NZD"],"emoji":"🇹🇰","ioc":"","languages":["eng"],"name":"Tokelau","status":"assigned"},{"alpha2":"TL","alpha3":"TLS","countryCallingCodes":["+670"],"currencies":["USD"],"emoji":"🇹🇱","ioc":"TLS","languages":["por"],"name":"Timor-Leste, Democratic Republic of","status":"assigned"},{"alpha2":"TM","alpha3":"TKM","countryCallingCodes":["+993"],"currencies":["TMT"],"emoji":"🇹🇲","ioc":"TKM","languages":["tuk","rus"],"name":"Turkmenistan","status":"assigned"},{"alpha2":"TN","alpha3":"TUN","countryCallingCodes":["+216"],"currencies":["TND"],"emoji":"🇹🇳","ioc":"TUN","languages":["ara"],"name":"Tunisia","status":"assigned"},{"alpha2":"TO","alpha3":"TON","countryCallingCodes":["+676"],"currencies":["TOP"],"emoji":"🇹🇴","ioc":"TGA","languages":["eng"],"name":"Tonga","status":"assigned"},{"alpha2":"TP","alpha3":"TMP","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"East Timor","status":"deleted"},{"alpha2":"TR","alpha3":"TUR","countryCallingCodes":["+90"],"currencies":["TRY"],"emoji":"🇹🇷","ioc":"TUR","languages":["tur"],"name":"Turkey","status":"assigned"},{"alpha2":"TT","alpha3":"TTO","countryCallingCodes":["+1 868"],"currencies":["TTD"],"emoji":"🇹🇹","ioc":"TTO","languages":["eng"],"name":"Trinidad And Tobago","status":"assigned"},{"alpha2":"TV","alpha3":"TUV","countryCallingCodes":["+688"],"currencies":["AUD"],"emoji":"🇹🇻","ioc":"TUV","languages":["eng"],"name":"Tuvalu","status":"assigned"},{"alpha2":"TW","alpha3":"TWN","countryCallingCodes":["+886"],"currencies":["TWD"],"emoji":"🇹🇼","ioc":"TPE","languages":["zho"],"name":"Taiwan","status":"assigned"},{"alpha2":"TZ","alpha3":"TZA","countryCallingCodes":["+255"],"currencies":["TZS"],"emoji":"🇹🇿","ioc":"TAN","languages":["swa","eng"],"name":"Tanzania, United Republic Of","status":"assigned"},{"alpha2":"UA","alpha3":"UKR","countryCallingCodes":["+380"],"currencies":["UAH"],"emoji":"🇺🇦","ioc":"UKR","languages":["ukr","rus"],"name":"Ukraine","status":"assigned"},{"alpha2":"UG","alpha3":"UGA","countryCallingCodes":["+256"],"currencies":["UGX"],"emoji":"🇺🇬","ioc":"UGA","languages":["eng","swa"],"name":"Uganda","status":"assigned"},{"alpha2":"UK","alpha3":"","countryCallingCodes":[],"currencies":["GBP"],"emoji":"","ioc":"","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"reserved"},{"alpha2":"UM","alpha3":"UMI","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇲","ioc":"","languages":["eng"],"name":"United States Minor Outlying Islands","status":"assigned"},{"alpha2":"US","alpha3":"USA","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇸","ioc":"USA","languages":["eng"],"name":"United States","status":"assigned"},{"alpha2":"UY","alpha3":"URY","countryCallingCodes":["+598"],"currencies":["UYU","UYI"],"emoji":"🇺🇾","ioc":"URU","languages":["spa"],"name":"Uruguay","status":"assigned"},{"alpha2":"UZ","alpha3":"UZB","countryCallingCodes":["+998"],"currencies":["UZS"],"emoji":"🇺🇿","ioc":"UZB","languages":["uzb","rus"],"name":"Uzbekistan","status":"assigned"},{"alpha2":"VA","alpha3":"VAT","countryCallingCodes":["+379","+39"],"currencies":["EUR"],"emoji":"🇻🇦","ioc":"","languages":["ita"],"name":"Vatican City State","status":"assigned"},{"alpha2":"VC","alpha3":"VCT","countryCallingCodes":["+1 784"],"currencies":["XCD"],"emoji":"🇻🇨","ioc":"VIN","languages":["eng"],"name":"Saint Vincent And The Grenadines","status":"assigned"},{"alpha2":"VD","alpha3":"VDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Viet-Nam, Democratic Republic of","status":"deleted"},{"alpha2":"VE","alpha3":"VEN","countryCallingCodes":["+58"],"currencies":["VEF"],"emoji":"🇻🇪","ioc":"VEN","languages":["spa"],"name":"Venezuela, Bolivarian Republic Of","status":"assigned"},{"alpha2":"VG","alpha3":"VGB","countryCallingCodes":["+1 284"],"currencies":["USD"],"emoji":"🇻🇬","ioc":"IVB","languages":["eng"],"name":"Virgin Islands (British)","status":"assigned"},{"alpha2":"VI","alpha3":"VIR","countryCallingCodes":["+1 340"],"currencies":["USD"],"emoji":"🇻🇮","ioc":"ISV","languages":["eng"],"name":"Virgin Islands (US)","status":"assigned"},{"alpha2":"VN","alpha3":"VNM","countryCallingCodes":["+84"],"currencies":["VND"],"emoji":"🇻🇳","ioc":"VIE","languages":["vie"],"name":"Viet Nam","status":"assigned"},{"alpha2":"VU","alpha3":"VUT","countryCallingCodes":["+678"],"currencies":["VUV"],"emoji":"🇻🇺","ioc":"VAN","languages":["bis","eng","fra"],"name":"Vanuatu","status":"assigned"},{"alpha2":"WF","alpha3":"WLF","countryCallingCodes":["+681"],"currencies":["XPF"],"emoji":"🇼🇫","ioc":"","languages":["fra"],"name":"Wallis And Futuna","status":"assigned"},{"alpha2":"WK","alpha3":"WAK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Wake Island","status":"deleted"},{"alpha2":"WS","alpha3":"WSM","countryCallingCodes":["+685"],"currencies":["WST"],"emoji":"🇼🇸","ioc":"SAM","languages":["eng","smo"],"name":"Samoa","status":"assigned"},{"alpha2":"XK","alpha3":"","countryCallingCodes":["+383"],"currencies":["EUR"],"emoji":"","ioc":"KOS","languages":["sqi","srp","bos","tur","rom"],"name":"Kosovo","status":"user assigned"},{"alpha2":"YD","alpha3":"YMD","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yemen, Democratic","status":"deleted"},{"alpha2":"YE","alpha3":"YEM","countryCallingCodes":["+967"],"currencies":["YER"],"emoji":"🇾🇪","ioc":"YEM","languages":["ara"],"name":"Yemen","status":"assigned"},{"alpha2":"YT","alpha3":"MYT","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇾🇹","ioc":"","languages":["fra"],"name":"Mayotte","status":"assigned"},{"alpha2":"YU","alpha3":"YUG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yugoslavia","status":"deleted"},{"alpha2":"ZA","alpha3":"ZAF","countryCallingCodes":["+27"],"currencies":["ZAR"],"emoji":"🇿🇦","ioc":"RSA","languages":["afr","eng","nbl","som","tso","ven","xho","zul"],"name":"South Africa","status":"assigned"},{"alpha2":"ZM","alpha3":"ZMB","countryCallingCodes":["+260"],"currencies":["ZMW"],"emoji":"🇿🇲","ioc":"ZAM","languages":["eng"],"name":"Zambia","status":"assigned"},{"alpha2":"ZR","alpha3":"ZAR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Zaire","status":"deleted"},{"alpha2":"ZW","alpha3":"ZWE","countryCallingCodes":["+263"],"currencies":["USD","ZAR","BWP","GBP","EUR"],"emoji":"🇿🇼","ioc":"ZIM","languages":["eng","sna","nde"],"name":"Zimbabwe","status":"assigned"}]

/***/ }),
/* 3529 */
/***/ (function(module, exports) {

module.exports = [{"code":"AED","decimals":2,"name":"United Arab Emirates dirham","number":"784"},{"code":"AFN","decimals":2,"name":"Afghan afghani","number":"971"},{"code":"ALL","decimals":2,"name":"Albanian lek","number":"8"},{"code":"AMD","decimals":2,"name":"Armenian dram","number":"51"},{"code":"ANG","decimals":2,"name":"Netherlands Antillean guilder","number":"532"},{"code":"AOA","decimals":2,"name":"Angolan kwanza","number":"973"},{"code":"ARS","decimals":2,"name":"Argentine peso","number":"32"},{"code":"AUD","decimals":2,"name":"Australian dollar","number":"36"},{"code":"AWG","decimals":2,"name":"Aruban florin","number":"533"},{"code":"AZN","decimals":2,"name":"Azerbaijani manat","number":"944"},{"code":"BAM","decimals":2,"name":"Bosnia and Herzegovina convertible mark","number":"977"},{"code":"BBD","decimals":2,"name":"Barbados dollar","number":"52"},{"code":"BDT","decimals":2,"name":"Bangladeshi taka","number":"50"},{"code":"BGN","decimals":2,"name":"Bulgarian lev","number":"975"},{"code":"BHD","decimals":3,"name":"Bahraini dinar","number":"48"},{"code":"BIF","decimals":0,"name":"Burundian franc","number":"108"},{"code":"BMD","decimals":2,"name":"Bermudian dollar (customarily known as Bermuda dollar)","number":"60"},{"code":"BND","decimals":2,"name":"Brunei dollar","number":"96"},{"code":"BOB","decimals":2,"name":"Boliviano","number":"68"},{"code":"BOV","decimals":2,"name":"Bolivian Mvdol (funds code)","number":"984"},{"code":"BRL","decimals":2,"name":"Brazilian real","number":"986"},{"code":"BSD","decimals":2,"name":"Bahamian dollar","number":"44"},{"code":"BTN","decimals":2,"name":"Bhutanese ngultrum","number":"64"},{"code":"BWP","decimals":2,"name":"Botswana pula","number":"72"},{"code":"BYR","decimals":0,"name":"Belarusian ruble","number":"974"},{"code":"BZD","decimals":2,"name":"Belize dollar","number":"84"},{"code":"CAD","decimals":2,"name":"Canadian dollar","number":"124"},{"code":"CDF","decimals":2,"name":"Congolese franc","number":"976"},{"code":"CHE","decimals":2,"name":"WIR Euro (complementary currency)","number":"947"},{"code":"CHF","decimals":2,"name":"Swiss franc","number":"756"},{"code":"CHW","decimals":2,"name":"WIR Franc (complementary currency)","number":"948"},{"code":"CLF","decimals":0,"name":"Unidad de Fomento (funds code)","number":"990"},{"code":"CLP","decimals":0,"name":"Chilean peso","number":"152"},{"code":"CNY","decimals":2,"name":"Chinese yuan","number":"156"},{"code":"COP","decimals":2,"name":"Colombian peso","number":"170"},{"code":"COU","decimals":2,"name":"Unidad de Valor Real","number":"970"},{"code":"CRC","decimals":2,"name":"Costa Rican colon","number":"188"},{"code":"CUC","decimals":2,"name":"Cuban convertible peso","number":"931"},{"code":"CUP","decimals":2,"name":"Cuban peso","number":"192"},{"code":"CVE","decimals":0,"name":"Cape Verde escudo","number":"132"},{"code":"CZK","decimals":2,"name":"Czech koruna","number":"203"},{"code":"DJF","decimals":0,"name":"Djiboutian franc","number":"262"},{"code":"DKK","decimals":2,"name":"Danish krone","number":"208"},{"code":"DOP","decimals":2,"name":"Dominican peso","number":"214"},{"code":"DZD","decimals":2,"name":"Algerian dinar","number":"12"},{"code":"EGP","decimals":2,"name":"Egyptian pound","number":"818"},{"code":"ERN","decimals":2,"name":"Eritrean nakfa","number":"232"},{"code":"ETB","decimals":2,"name":"Ethiopian birr","number":"230"},{"code":"EUR","decimals":2,"name":"Euro","number":"978"},{"code":"FJD","decimals":2,"name":"Fiji dollar","number":"242"},{"code":"FKP","decimals":2,"name":"Falkland Islands pound","number":"238"},{"code":"GBP","decimals":2,"name":"Pound sterling","number":"826"},{"code":"GEL","decimals":2,"name":"Georgian lari","number":"981"},{"code":"GHS","decimals":2,"name":"Ghanaian cedi","number":"936"},{"code":"GIP","decimals":2,"name":"Gibraltar pound","number":"292"},{"code":"GMD","decimals":2,"name":"Gambian dalasi","number":"270"},{"code":"GNF","decimals":0,"name":"Guinean franc","number":"324"},{"code":"GTQ","decimals":2,"name":"Guatemalan quetzal","number":"320"},{"code":"GYD","decimals":2,"name":"Guyanese dollar","number":"328"},{"code":"HKD","decimals":2,"name":"Hong Kong dollar","number":"344"},{"code":"HNL","decimals":2,"name":"Honduran lempira","number":"340"},{"code":"HRK","decimals":2,"name":"Croatian kuna","number":"191"},{"code":"HTG","decimals":2,"name":"Haitian gourde","number":"332"},{"code":"HUF","decimals":2,"name":"Hungarian forint","number":"348"},{"code":"IDR","decimals":2,"name":"Indonesian rupiah","number":"360"},{"code":"ILS","decimals":2,"name":"Israeli new shekel","number":"376"},{"code":"INR","decimals":2,"name":"Indian rupee","number":"356"},{"code":"IQD","decimals":3,"name":"Iraqi dinar","number":"368"},{"code":"IRR","decimals":0,"name":"Iranian rial","number":"364"},{"code":"ISK","decimals":0,"name":"Icelandic króna","number":"352"},{"code":"JMD","decimals":2,"name":"Jamaican dollar","number":"388"},{"code":"JOD","decimals":3,"name":"Jordanian dinar","number":"400"},{"code":"JPY","decimals":0,"name":"Japanese yen","number":"392"},{"code":"KES","decimals":2,"name":"Kenyan shilling","number":"404"},{"code":"KGS","decimals":2,"name":"Kyrgyzstani som","number":"417"},{"code":"KHR","decimals":2,"name":"Cambodian riel","number":"116"},{"code":"KMF","decimals":0,"name":"Comoro franc","number":"174"},{"code":"KPW","decimals":0,"name":"North Korean won","number":"408"},{"code":"KRW","decimals":0,"name":"South Korean won","number":"410"},{"code":"KWD","decimals":3,"name":"Kuwaiti dinar","number":"414"},{"code":"KYD","decimals":2,"name":"Cayman Islands dollar","number":"136"},{"code":"KZT","decimals":2,"name":"Kazakhstani tenge","number":"398"},{"code":"LAK","decimals":0,"name":"Lao kip","number":"418"},{"code":"LBP","decimals":0,"name":"Lebanese pound","number":"422"},{"code":"LKR","decimals":2,"name":"Sri Lankan rupee","number":"144"},{"code":"LRD","decimals":2,"name":"Liberian dollar","number":"430"},{"code":"LSL","decimals":2,"name":"Lesotho loti","number":"426"},{"code":"LTL","decimals":2,"name":"Lithuanian litas","number":"440"},{"code":"LVL","decimals":2,"name":"Latvian lats","number":"428"},{"code":"LYD","decimals":3,"name":"Libyan dinar","number":"434"},{"code":"MAD","decimals":2,"name":"Moroccan dirham","number":"504"},{"code":"MDL","decimals":2,"name":"Moldovan leu","number":"498"},{"code":"MGA","decimals":0,"name":"Malagasy ariary","number":"969"},{"code":"MKD","decimals":0,"name":"Macedonian denar","number":"807"},{"code":"MMK","decimals":0,"name":"Myanma kyat","number":"104"},{"code":"MNT","decimals":2,"name":"Mongolian tugrik","number":"496"},{"code":"MOP","decimals":2,"name":"Macanese pataca","number":"446"},{"code":"MRO","decimals":0,"name":"Mauritanian ouguiya","number":"478"},{"code":"MUR","decimals":2,"name":"Mauritian rupee","number":"480"},{"code":"MVR","decimals":2,"name":"Maldivian rufiyaa","number":"462"},{"code":"MWK","decimals":2,"name":"Malawian kwacha","number":"454"},{"code":"MXN","decimals":2,"name":"Mexican peso","number":"484"},{"code":"MXV","decimals":2,"name":"Mexican Unidad de Inversion (UDI) (funds code)","number":"979"},{"code":"MYR","decimals":2,"name":"Malaysian ringgit","number":"458"},{"code":"MZN","decimals":2,"name":"Mozambican metical","number":"943"},{"code":"NAD","decimals":2,"name":"Namibian dollar","number":"516"},{"code":"NGN","decimals":2,"name":"Nigerian naira","number":"566"},{"code":"NIO","decimals":2,"name":"Nicaraguan córdoba","number":"558"},{"code":"NOK","decimals":2,"name":"Norwegian krone","number":"578"},{"code":"NPR","decimals":2,"name":"Nepalese rupee","number":"524"},{"code":"NZD","decimals":2,"name":"New Zealand dollar","number":"554"},{"code":"OMR","decimals":3,"name":"Omani rial","number":"512"},{"code":"PAB","decimals":2,"name":"Panamanian balboa","number":"590"},{"code":"PEN","decimals":2,"name":"Peruvian nuevo sol","number":"604"},{"code":"PGK","decimals":2,"name":"Papua New Guinean kina","number":"598"},{"code":"PHP","decimals":2,"name":"Philippine peso","number":"608"},{"code":"PKR","decimals":2,"name":"Pakistani rupee","number":"586"},{"code":"PLN","decimals":2,"name":"Polish złoty","number":"985"},{"code":"PYG","decimals":0,"name":"Paraguayan guaraní","number":"600"},{"code":"QAR","decimals":2,"name":"Qatari riyal","number":"634"},{"code":"RON","decimals":2,"name":"Romanian new leu","number":"946"},{"code":"RSD","decimals":2,"name":"Serbian dinar","number":"941"},{"code":"RUB","decimals":2,"name":"Russian rouble","number":"643"},{"code":"RWF","decimals":0,"name":"Rwandan franc","number":"646"},{"code":"SAR","decimals":2,"name":"Saudi riyal","number":"682"},{"code":"SBD","decimals":2,"name":"Solomon Islands dollar","number":"90"},{"code":"SCR","decimals":2,"name":"Seychelles rupee","number":"690"},{"code":"SDG","decimals":2,"name":"Sudanese pound","number":"938"},{"code":"SEK","decimals":2,"name":"Swedish krona/kronor","number":"752"},{"code":"SGD","decimals":2,"name":"Singapore dollar","number":"702"},{"code":"SHP","decimals":2,"name":"Saint Helena pound","number":"654"},{"code":"SLL","decimals":0,"name":"Sierra Leonean leone","number":"694"},{"code":"SOS","decimals":2,"name":"Somali shilling","number":"706"},{"code":"SRD","decimals":2,"name":"Surinamese dollar","number":"968"},{"code":"SSP","decimals":2,"name":"South Sudanese pound","number":"728"},{"code":"STD","decimals":0,"name":"São Tomé and Príncipe dobra","number":"678"},{"code":"SYP","decimals":2,"name":"Syrian pound","number":"760"},{"code":"SZL","decimals":2,"name":"Swazi lilangeni","number":"748"},{"code":"THB","decimals":2,"name":"Thai baht","number":"764"},{"code":"TJS","decimals":2,"name":"Tajikistani somoni","number":"972"},{"code":"TMT","decimals":2,"name":"Turkmenistani manat","number":"934"},{"code":"TND","decimals":3,"name":"Tunisian dinar","number":"788"},{"code":"TOP","decimals":2,"name":"Tongan paʻanga","number":"776"},{"code":"TRY","decimals":2,"name":"Turkish lira","number":"949"},{"code":"TTD","decimals":2,"name":"Trinidad and Tobago dollar","number":"780"},{"code":"TWD","decimals":2,"name":"New Taiwan dollar","number":"901"},{"code":"TZS","decimals":2,"name":"Tanzanian shilling","number":"834"},{"code":"UAH","decimals":2,"name":"Ukrainian hryvnia","number":"980"},{"code":"UGX","decimals":2,"name":"Ugandan shilling","number":"800"},{"code":"USD","decimals":2,"name":"United States dollar","number":"840"},{"code":"USN","decimals":2,"name":"United States dollar (next day) (funds code)","number":"997"},{"code":"USS","decimals":2,"name":"United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)","number":"998"},{"code":"UYI","decimals":0,"name":"Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)","number":"940"},{"code":"UYU","decimals":2,"name":"Uruguayan peso","number":"858"},{"code":"UZS","decimals":2,"name":"Uzbekistan som","number":"860"},{"code":"VEF","decimals":2,"name":"Venezuelan bolívar fuerte","number":"937"},{"code":"VND","decimals":0,"name":"Vietnamese dong","number":"704"},{"code":"VUV","decimals":0,"name":"Vanuatu vatu","number":"548"},{"code":"WST","decimals":2,"name":"Samoan tala","number":"882"},{"code":"XAF","decimals":0,"name":"CFA franc BEAC","number":"950"},{"code":"XAG","decimals":null,"name":"Silver (one troy ounce)","number":"961"},{"code":"XAU","decimals":null,"name":"Gold (one troy ounce)","number":"959"},{"code":"XBA","decimals":null,"name":"European Composite Unit (EURCO) (bond market unit)","number":"955"},{"code":"XBB","decimals":null,"name":"European Monetary Unit (E.M.U.-6) (bond market unit)","number":"956"},{"code":"XBC","decimals":null,"name":"European Unit of Account 9 (E.U.A.-9) (bond market unit)","number":"957"},{"code":"XBD","decimals":null,"name":"European Unit of Account 17 (E.U.A.-17) (bond market unit)","number":"958"},{"code":"XCD","decimals":2,"name":"East Caribbean dollar","number":"951"},{"code":"XDR","decimals":null,"name":"Special drawing rights","number":"960"},{"code":"XFU","decimals":null,"name":"UIC franc (special settlement currency)","number":"Nil"},{"code":"XOF","decimals":0,"name":"CFA franc BCEAO","number":"952"},{"code":"XPD","decimals":null,"name":"Palladium (one troy ounce)","number":"964"},{"code":"XPF","decimals":0,"name":"CFP franc","number":"953"},{"code":"XPT","decimals":null,"name":"Platinum (one troy ounce)","number":"962"},{"code":"XTS","decimals":null,"name":"Code reserved for testing purposes","number":"963"},{"code":"XXX","decimals":null,"name":"No currency","number":"999"},{"code":"YER","decimals":2,"name":"Yemeni rial","number":"886"},{"code":"ZAR","decimals":2,"name":"South African rand","number":"710"},{"code":"ZMW","decimals":2,"name":"Zambian kwacha","number":"967"}]

/***/ }),
/* 3530 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"aa","alpha3":"aar","bibliographic":"","name":"Afar"},{"alpha2":"ab","alpha3":"abk","bibliographic":"","name":"Abkhazian"},{"alpha2":"","alpha3":"ace","bibliographic":"","name":"Achinese"},{"alpha2":"","alpha3":"ach","bibliographic":"","name":"Acoli"},{"alpha2":"","alpha3":"ada","bibliographic":"","name":"Adangme"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adygei"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adyghe"},{"alpha2":"","alpha3":"afa","bibliographic":"","name":"Afro-Asiatic languages"},{"alpha2":"","alpha3":"afh","bibliographic":"","name":"Afrihili"},{"alpha2":"af","alpha3":"afr","bibliographic":"","name":"Afrikaans"},{"alpha2":"","alpha3":"ain","bibliographic":"","name":"Ainu"},{"alpha2":"ak","alpha3":"aka","bibliographic":"","name":"Akan"},{"alpha2":"","alpha3":"akk","bibliographic":"","name":"Akkadian"},{"alpha2":"","alpha3":"ale","bibliographic":"","name":"Aleut"},{"alpha2":"","alpha3":"alg","bibliographic":"","name":"Algonquian languages"},{"alpha2":"","alpha3":"alt","bibliographic":"","name":"Southern Altai"},{"alpha2":"am","alpha3":"amh","bibliographic":"","name":"Amharic"},{"alpha2":"","alpha3":"ang","bibliographic":"","name":"English, Old (ca.450-1100)"},{"alpha2":"","alpha3":"anp","bibliographic":"","name":"Angika"},{"alpha2":"","alpha3":"apa","bibliographic":"","name":"Apache languages"},{"alpha2":"ar","alpha3":"ara","bibliographic":"","name":"Arabic"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Imperial Aramaic (700-300 BCE)"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Official Aramaic (700-300 BCE)"},{"alpha2":"an","alpha3":"arg","bibliographic":"","name":"Aragonese"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapuche"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapudungun"},{"alpha2":"","alpha3":"arp","bibliographic":"","name":"Arapaho"},{"alpha2":"","alpha3":"art","bibliographic":"","name":"Artificial languages"},{"alpha2":"","alpha3":"arw","bibliographic":"","name":"Arawak"},{"alpha2":"as","alpha3":"asm","bibliographic":"","name":"Assamese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturian"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturleonese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Bable"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Leonese"},{"alpha2":"","alpha3":"ath","bibliographic":"","name":"Athapascan languages"},{"alpha2":"","alpha3":"aus","bibliographic":"","name":"Australian languages"},{"alpha2":"av","alpha3":"ava","bibliographic":"","name":"Avaric"},{"alpha2":"ae","alpha3":"ave","bibliographic":"","name":"Avestan"},{"alpha2":"","alpha3":"awa","bibliographic":"","name":"Awadhi"},{"alpha2":"ay","alpha3":"aym","bibliographic":"","name":"Aymara"},{"alpha2":"az","alpha3":"aze","bibliographic":"","name":"Azerbaijani"},{"alpha2":"","alpha3":"bad","bibliographic":"","name":"Banda languages"},{"alpha2":"","alpha3":"bai","bibliographic":"","name":"Bamileke languages"},{"alpha2":"ba","alpha3":"bak","bibliographic":"","name":"Bashkir"},{"alpha2":"","alpha3":"bal","bibliographic":"","name":"Baluchi"},{"alpha2":"bm","alpha3":"bam","bibliographic":"","name":"Bambara"},{"alpha2":"","alpha3":"ban","bibliographic":"","name":"Balinese"},{"alpha2":"","alpha3":"bas","bibliographic":"","name":"Basa"},{"alpha2":"","alpha3":"bat","bibliographic":"","name":"Baltic languages"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Bedawiyet"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Beja"},{"alpha2":"be","alpha3":"bel","bibliographic":"","name":"Belarusian"},{"alpha2":"","alpha3":"bem","bibliographic":"","name":"Bemba"},{"alpha2":"bn","alpha3":"ben","bibliographic":"","name":"Bengali"},{"alpha2":"","alpha3":"ber","bibliographic":"","name":"Berber languages"},{"alpha2":"","alpha3":"bho","bibliographic":"","name":"Bhojpuri"},{"alpha2":"bh","alpha3":"bih","bibliographic":"","name":"Bihari languages"},{"alpha2":"","alpha3":"bik","bibliographic":"","name":"Bikol"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Bini"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Edo"},{"alpha2":"bi","alpha3":"bis","bibliographic":"","name":"Bislama"},{"alpha2":"","alpha3":"bla","bibliographic":"","name":"Siksika"},{"alpha2":"","alpha3":"bnt","bibliographic":"","name":"Bantu languages"},{"alpha2":"bo","alpha3":"bod","bibliographic":"tib","name":"Tibetan"},{"alpha2":"bs","alpha3":"bos","bibliographic":"","name":"Bosnian"},{"alpha2":"","alpha3":"bra","bibliographic":"","name":"Braj"},{"alpha2":"br","alpha3":"bre","bibliographic":"","name":"Breton"},{"alpha2":"","alpha3":"btk","bibliographic":"","name":"Batak languages"},{"alpha2":"","alpha3":"bua","bibliographic":"","name":"Buriat"},{"alpha2":"","alpha3":"bug","bibliographic":"","name":"Buginese"},{"alpha2":"bg","alpha3":"bul","bibliographic":"","name":"Bulgarian"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Bilin"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Blin"},{"alpha2":"","alpha3":"cad","bibliographic":"","name":"Caddo"},{"alpha2":"","alpha3":"cai","bibliographic":"","name":"Central American Indian languages"},{"alpha2":"","alpha3":"car","bibliographic":"","name":"Galibi Carib"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Catalan"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Valencian"},{"alpha2":"","alpha3":"cau","bibliographic":"","name":"Caucasian languages"},{"alpha2":"","alpha3":"ceb","bibliographic":"","name":"Cebuano"},{"alpha2":"","alpha3":"cel","bibliographic":"","name":"Celtic languages"},{"alpha2":"cs","alpha3":"ces","bibliographic":"cze","name":"Czech"},{"alpha2":"ch","alpha3":"cha","bibliographic":"","name":"Chamorro"},{"alpha2":"","alpha3":"chb","bibliographic":"","name":"Chibcha"},{"alpha2":"ce","alpha3":"che","bibliographic":"","name":"Chechen"},{"alpha2":"","alpha3":"chg","bibliographic":"","name":"Chagatai"},{"alpha2":"","alpha3":"chk","bibliographic":"","name":"Chuukese"},{"alpha2":"","alpha3":"chm","bibliographic":"","name":"Mari"},{"alpha2":"","alpha3":"chn","bibliographic":"","name":"Chinook jargon"},{"alpha2":"","alpha3":"cho","bibliographic":"","name":"Choctaw"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Chipewyan"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Dene Suline"},{"alpha2":"","alpha3":"chr","bibliographic":"","name":"Cherokee"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Bulgarian"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Slavonic"},{"alpha2":"cv","alpha3":"chv","bibliographic":"","name":"Chuvash"},{"alpha2":"","alpha3":"chy","bibliographic":"","name":"Cheyenne"},{"alpha2":"","alpha3":"cmc","bibliographic":"","name":"Chamic languages"},{"alpha2":"","alpha3":"cop","bibliographic":"","name":"Coptic"},{"alpha2":"kw","alpha3":"cor","bibliographic":"","name":"Cornish"},{"alpha2":"co","alpha3":"cos","bibliographic":"","name":"Corsican"},{"alpha2":"","alpha3":"cpe","bibliographic":"","name":"Creoles and pidgins, English based"},{"alpha2":"","alpha3":"cpf","bibliographic":"","name":"Creoles and pidgins, French-based"},{"alpha2":"","alpha3":"cpp","bibliographic":"","name":"Creoles and pidgins, Portuguese-based"},{"alpha2":"cr","alpha3":"cre","bibliographic":"","name":"Cree"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Tatar"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Turkish"},{"alpha2":"","alpha3":"crp","bibliographic":"","name":"Creoles and pidgins"},{"alpha2":"","alpha3":"csb","bibliographic":"","name":"Kashubian"},{"alpha2":"","alpha3":"cus","bibliographic":"","name":"Cushitic languages"},{"alpha2":"cy","alpha3":"cym","bibliographic":"wel","name":"Welsh"},{"alpha2":"","alpha3":"dak","bibliographic":"","name":"Dakota"},{"alpha2":"da","alpha3":"dan","bibliographic":"","name":"Danish"},{"alpha2":"","alpha3":"dar","bibliographic":"","name":"Dargwa"},{"alpha2":"","alpha3":"day","bibliographic":"","name":"Land Dayak languages"},{"alpha2":"","alpha3":"del","bibliographic":"","name":"Delaware"},{"alpha2":"","alpha3":"den","bibliographic":"","name":"Slave (Athapascan)"},{"alpha2":"de","alpha3":"deu","bibliographic":"ger","name":"German"},{"alpha2":"","alpha3":"dgr","bibliographic":"","name":"Dogrib"},{"alpha2":"","alpha3":"din","bibliographic":"","name":"Dinka"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Dhivehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Divehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Maldivian"},{"alpha2":"","alpha3":"doi","bibliographic":"","name":"Dogri"},{"alpha2":"","alpha3":"dra","bibliographic":"","name":"Dravidian languages"},{"alpha2":"","alpha3":"dsb","bibliographic":"","name":"Lower Sorbian"},{"alpha2":"","alpha3":"dua","bibliographic":"","name":"Duala"},{"alpha2":"","alpha3":"dum","bibliographic":"","name":"Dutch, Middle (ca.1050-1350)"},{"alpha2":"","alpha3":"dyu","bibliographic":"","name":"Dyula"},{"alpha2":"dz","alpha3":"dzo","bibliographic":"","name":"Dzongkha"},{"alpha2":"","alpha3":"efi","bibliographic":"","name":"Efik"},{"alpha2":"","alpha3":"egy","bibliographic":"","name":"Egyptian (Ancient)"},{"alpha2":"","alpha3":"eka","bibliographic":"","name":"Ekajuk"},{"alpha2":"el","alpha3":"ell","bibliographic":"gre","name":"Greek, Modern (1453-)"},{"alpha2":"","alpha3":"elx","bibliographic":"","name":"Elamite"},{"alpha2":"en","alpha3":"eng","bibliographic":"","name":"English"},{"alpha2":"","alpha3":"enm","bibliographic":"","name":"English, Middle (1100-1500)"},{"alpha2":"eo","alpha3":"epo","bibliographic":"","name":"Esperanto"},{"alpha2":"et","alpha3":"est","bibliographic":"","name":"Estonian"},{"alpha2":"eu","alpha3":"eus","bibliographic":"baq","name":"Basque"},{"alpha2":"ee","alpha3":"ewe","bibliographic":"","name":"Ewe"},{"alpha2":"","alpha3":"ewo","bibliographic":"","name":"Ewondo"},{"alpha2":"","alpha3":"fan","bibliographic":"","name":"Fang"},{"alpha2":"fo","alpha3":"fao","bibliographic":"","name":"Faroese"},{"alpha2":"fa","alpha3":"fas","bibliographic":"per","name":"Persian"},{"alpha2":"","alpha3":"fat","bibliographic":"","name":"Fanti"},{"alpha2":"fj","alpha3":"fij","bibliographic":"","name":"Fijian"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Filipino"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Pilipino"},{"alpha2":"fi","alpha3":"fin","bibliographic":"","name":"Finnish"},{"alpha2":"","alpha3":"fiu","bibliographic":"","name":"Finno-Ugrian languages"},{"alpha2":"","alpha3":"fon","bibliographic":"","name":"Fon"},{"alpha2":"fr","alpha3":"fra","bibliographic":"fre","name":"French"},{"alpha2":"","alpha3":"frm","bibliographic":"","name":"French, Middle (ca.1400-1600)"},{"alpha2":"","alpha3":"fro","bibliographic":"","name":"French, Old (842-ca.1400)"},{"alpha2":"","alpha3":"frr","bibliographic":"","name":"Northern Frisian"},{"alpha2":"","alpha3":"frs","bibliographic":"","name":"Eastern Frisian"},{"alpha2":"fy","alpha3":"fry","bibliographic":"","name":"Western Frisian"},{"alpha2":"ff","alpha3":"ful","bibliographic":"","name":"Fulah"},{"alpha2":"","alpha3":"fur","bibliographic":"","name":"Friulian"},{"alpha2":"","alpha3":"gaa","bibliographic":"","name":"Ga"},{"alpha2":"","alpha3":"gay","bibliographic":"","name":"Gayo"},{"alpha2":"","alpha3":"gba","bibliographic":"","name":"Gbaya"},{"alpha2":"","alpha3":"gem","bibliographic":"","name":"Germanic languages"},{"alpha2":"","alpha3":"gez","bibliographic":"","name":"Geez"},{"alpha2":"","alpha3":"gil","bibliographic":"","name":"Gilbertese"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Gaelic"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Scottish Gaelic"},{"alpha2":"ga","alpha3":"gle","bibliographic":"","name":"Irish"},{"alpha2":"gl","alpha3":"glg","bibliographic":"","name":"Galician"},{"alpha2":"gv","alpha3":"glv","bibliographic":"","name":"Manx"},{"alpha2":"","alpha3":"gmh","bibliographic":"","name":"German, Middle High (ca.1050-1500)"},{"alpha2":"","alpha3":"goh","bibliographic":"","name":"German, Old High (ca.750-1050)"},{"alpha2":"","alpha3":"gon","bibliographic":"","name":"Gondi"},{"alpha2":"","alpha3":"gor","bibliographic":"","name":"Gorontalo"},{"alpha2":"","alpha3":"got","bibliographic":"","name":"Gothic"},{"alpha2":"","alpha3":"grb","bibliographic":"","name":"Grebo"},{"alpha2":"","alpha3":"grc","bibliographic":"","name":"Greek, Ancient (to 1453)"},{"alpha2":"gn","alpha3":"grn","bibliographic":"","name":"Guarani"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alemannic"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alsatian"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Swiss German"},{"alpha2":"gu","alpha3":"guj","bibliographic":"","name":"Gujarati"},{"alpha2":"","alpha3":"gwi","bibliographic":"","name":"Gwich'in"},{"alpha2":"","alpha3":"hai","bibliographic":"","name":"Haida"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian Creole"},{"alpha2":"ha","alpha3":"hau","bibliographic":"","name":"Hausa"},{"alpha2":"","alpha3":"haw","bibliographic":"","name":"Hawaiian"},{"alpha2":"he","alpha3":"heb","bibliographic":"","name":"Hebrew"},{"alpha2":"hz","alpha3":"her","bibliographic":"","name":"Herero"},{"alpha2":"","alpha3":"hil","bibliographic":"","name":"Hiligaynon"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Himachali languages"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Western Pahari languages"},{"alpha2":"hi","alpha3":"hin","bibliographic":"","name":"Hindi"},{"alpha2":"","alpha3":"hit","bibliographic":"","name":"Hittite"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Hmong"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Mong"},{"alpha2":"ho","alpha3":"hmo","bibliographic":"","name":"Hiri Motu"},{"alpha2":"hr","alpha3":"hrv","bibliographic":"","name":"Croatian"},{"alpha2":"","alpha3":"hsb","bibliographic":"","name":"Upper Sorbian"},{"alpha2":"hu","alpha3":"hun","bibliographic":"","name":"Hungarian"},{"alpha2":"","alpha3":"hup","bibliographic":"","name":"Hupa"},{"alpha2":"hy","alpha3":"hye","bibliographic":"arm","name":"Armenian"},{"alpha2":"","alpha3":"iba","bibliographic":"","name":"Iban"},{"alpha2":"ig","alpha3":"ibo","bibliographic":"","name":"Igbo"},{"alpha2":"io","alpha3":"ido","bibliographic":"","name":"Ido"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Nuosu"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Sichuan Yi"},{"alpha2":"","alpha3":"ijo","bibliographic":"","name":"Ijo languages"},{"alpha2":"iu","alpha3":"iku","bibliographic":"","name":"Inuktitut"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Interlingue"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Occidental"},{"alpha2":"","alpha3":"ilo","bibliographic":"","name":"Iloko"},{"alpha2":"ia","alpha3":"ina","bibliographic":"","name":"Interlingua (International Auxiliary Language Association)"},{"alpha2":"","alpha3":"inc","bibliographic":"","name":"Indic languages"},{"alpha2":"id","alpha3":"ind","bibliographic":"","name":"Indonesian"},{"alpha2":"","alpha3":"ine","bibliographic":"","name":"Indo-European languages"},{"alpha2":"","alpha3":"inh","bibliographic":"","name":"Ingush"},{"alpha2":"ik","alpha3":"ipk","bibliographic":"","name":"Inupiaq"},{"alpha2":"","alpha3":"ira","bibliographic":"","name":"Iranian languages"},{"alpha2":"","alpha3":"iro","bibliographic":"","name":"Iroquoian languages"},{"alpha2":"is","alpha3":"isl","bibliographic":"ice","name":"Icelandic"},{"alpha2":"it","alpha3":"ita","bibliographic":"","name":"Italian"},{"alpha2":"jv","alpha3":"jav","bibliographic":"","name":"Javanese"},{"alpha2":"","alpha3":"jbo","bibliographic":"","name":"Lojban"},{"alpha2":"ja","alpha3":"jpn","bibliographic":"","name":"Japanese"},{"alpha2":"","alpha3":"jpr","bibliographic":"","name":"Judeo-Persian"},{"alpha2":"","alpha3":"jrb","bibliographic":"","name":"Judeo-Arabic"},{"alpha2":"","alpha3":"kaa","bibliographic":"","name":"Kara-Kalpak"},{"alpha2":"","alpha3":"kab","bibliographic":"","name":"Kabyle"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Jingpho"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Kachin"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Greenlandic"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Kalaallisut"},{"alpha2":"","alpha3":"kam","bibliographic":"","name":"Kamba"},{"alpha2":"kn","alpha3":"kan","bibliographic":"","name":"Kannada"},{"alpha2":"","alpha3":"kar","bibliographic":"","name":"Karen languages"},{"alpha2":"ks","alpha3":"kas","bibliographic":"","name":"Kashmiri"},{"alpha2":"ka","alpha3":"kat","bibliographic":"geo","name":"Georgian"},{"alpha2":"kr","alpha3":"kau","bibliographic":"","name":"Kanuri"},{"alpha2":"","alpha3":"kaw","bibliographic":"","name":"Kawi"},{"alpha2":"kk","alpha3":"kaz","bibliographic":"","name":"Kazakh"},{"alpha2":"","alpha3":"kbd","bibliographic":"","name":"Kabardian"},{"alpha2":"","alpha3":"kha","bibliographic":"","name":"Khasi"},{"alpha2":"","alpha3":"khi","bibliographic":"","name":"Khoisan languages"},{"alpha2":"km","alpha3":"khm","bibliographic":"","name":"Central Khmer"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Khotanese"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Sakan"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Gikuyu"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Kikuyu"},{"alpha2":"rw","alpha3":"kin","bibliographic":"","name":"Kinyarwanda"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kirghiz"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kyrgyz"},{"alpha2":"","alpha3":"kmb","bibliographic":"","name":"Kimbundu"},{"alpha2":"","alpha3":"kok","bibliographic":"","name":"Konkani"},{"alpha2":"kv","alpha3":"kom","bibliographic":"","name":"Komi"},{"alpha2":"kg","alpha3":"kon","bibliographic":"","name":"Kongo"},{"alpha2":"ko","alpha3":"kor","bibliographic":"","name":"Korean"},{"alpha2":"","alpha3":"kos","bibliographic":"","name":"Kosraean"},{"alpha2":"","alpha3":"kpe","bibliographic":"","name":"Kpelle"},{"alpha2":"","alpha3":"krc","bibliographic":"","name":"Karachay-Balkar"},{"alpha2":"","alpha3":"krl","bibliographic":"","name":"Karelian"},{"alpha2":"","alpha3":"kro","bibliographic":"","name":"Kru languages"},{"alpha2":"","alpha3":"kru","bibliographic":"","name":"Kurukh"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kuanyama"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kwanyama"},{"alpha2":"","alpha3":"kum","bibliographic":"","name":"Kumyk"},{"alpha2":"ku","alpha3":"kur","bibliographic":"","name":"Kurdish"},{"alpha2":"","alpha3":"kut","bibliographic":"","name":"Kutenai"},{"alpha2":"","alpha3":"lad","bibliographic":"","name":"Ladino"},{"alpha2":"","alpha3":"lah","bibliographic":"","name":"Lahnda"},{"alpha2":"","alpha3":"lam","bibliographic":"","name":"Lamba"},{"alpha2":"lo","alpha3":"lao","bibliographic":"","name":"Lao"},{"alpha2":"la","alpha3":"lat","bibliographic":"","name":"Latin"},{"alpha2":"lv","alpha3":"lav","bibliographic":"","name":"Latvian"},{"alpha2":"","alpha3":"lez","bibliographic":"","name":"Lezghian"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgan"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburger"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgish"},{"alpha2":"ln","alpha3":"lin","bibliographic":"","name":"Lingala"},{"alpha2":"lt","alpha3":"lit","bibliographic":"","name":"Lithuanian"},{"alpha2":"","alpha3":"lol","bibliographic":"","name":"Mongo"},{"alpha2":"","alpha3":"loz","bibliographic":"","name":"Lozi"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Letzeburgesch"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Luxembourgish"},{"alpha2":"","alpha3":"lua","bibliographic":"","name":"Luba-Lulua"},{"alpha2":"lu","alpha3":"lub","bibliographic":"","name":"Luba-Katanga"},{"alpha2":"lg","alpha3":"lug","bibliographic":"","name":"Ganda"},{"alpha2":"","alpha3":"lui","bibliographic":"","name":"Luiseno"},{"alpha2":"","alpha3":"lun","bibliographic":"","name":"Lunda"},{"alpha2":"","alpha3":"luo","bibliographic":"","name":"Luo (Kenya and Tanzania)"},{"alpha2":"","alpha3":"lus","bibliographic":"","name":"Lushai"},{"alpha2":"","alpha3":"mad","bibliographic":"","name":"Madurese"},{"alpha2":"","alpha3":"mag","bibliographic":"","name":"Magahi"},{"alpha2":"mh","alpha3":"mah","bibliographic":"","name":"Marshallese"},{"alpha2":"","alpha3":"mai","bibliographic":"","name":"Maithili"},{"alpha2":"","alpha3":"mak","bibliographic":"","name":"Makasar"},{"alpha2":"ml","alpha3":"mal","bibliographic":"","name":"Malayalam"},{"alpha2":"","alpha3":"man","bibliographic":"","name":"Mandingo"},{"alpha2":"","alpha3":"map","bibliographic":"","name":"Austronesian languages"},{"alpha2":"mr","alpha3":"mar","bibliographic":"","name":"Marathi"},{"alpha2":"","alpha3":"mas","bibliographic":"","name":"Masai"},{"alpha2":"","alpha3":"mdf","bibliographic":"","name":"Moksha"},{"alpha2":"","alpha3":"mdr","bibliographic":"","name":"Mandar"},{"alpha2":"","alpha3":"men","bibliographic":"","name":"Mende"},{"alpha2":"","alpha3":"mga","bibliographic":"","name":"Irish, Middle (900-1200)"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Mi'kmaq"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Micmac"},{"alpha2":"","alpha3":"min","bibliographic":"","name":"Minangkabau"},{"alpha2":"","alpha3":"mis","bibliographic":"","name":"Uncoded languages"},{"alpha2":"mk","alpha3":"mkd","bibliographic":"mac","name":"Macedonian"},{"alpha2":"","alpha3":"mkh","bibliographic":"","name":"Mon-Khmer languages"},{"alpha2":"mg","alpha3":"mlg","bibliographic":"","name":"Malagasy"},{"alpha2":"mt","alpha3":"mlt","bibliographic":"","name":"Maltese"},{"alpha2":"","alpha3":"mnc","bibliographic":"","name":"Manchu"},{"alpha2":"","alpha3":"mni","bibliographic":"","name":"Manipuri"},{"alpha2":"","alpha3":"mno","bibliographic":"","name":"Manobo languages"},{"alpha2":"","alpha3":"moh","bibliographic":"","name":"Mohawk"},{"alpha2":"mn","alpha3":"mon","bibliographic":"","name":"Mongolian"},{"alpha2":"","alpha3":"mos","bibliographic":"","name":"Mossi"},{"alpha2":"","alpha3":"mot","bibliographic":"","name":"Montenegrin"},{"alpha2":"mi","alpha3":"mri","bibliographic":"mao","name":"Maori"},{"alpha2":"ms","alpha3":"msa","bibliographic":"may","name":"Malay"},{"alpha2":"","alpha3":"mul","bibliographic":"","name":"Multiple languages"},{"alpha2":"","alpha3":"mun","bibliographic":"","name":"Munda languages"},{"alpha2":"","alpha3":"mus","bibliographic":"","name":"Creek"},{"alpha2":"","alpha3":"mwl","bibliographic":"","name":"Mirandese"},{"alpha2":"","alpha3":"mwr","bibliographic":"","name":"Marwari"},{"alpha2":"my","alpha3":"mya","bibliographic":"bur","name":"Burmese"},{"alpha2":"","alpha3":"myn","bibliographic":"","name":"Mayan languages"},{"alpha2":"","alpha3":"myv","bibliographic":"","name":"Erzya"},{"alpha2":"","alpha3":"nah","bibliographic":"","name":"Nahuatl languages"},{"alpha2":"","alpha3":"nai","bibliographic":"","name":"North American Indian languages"},{"alpha2":"","alpha3":"nap","bibliographic":"","name":"Neapolitan"},{"alpha2":"na","alpha3":"nau","bibliographic":"","name":"Nauru"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navaho"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navajo"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"Ndebele, South"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"South Ndebele"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"Ndebele, North"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"North Ndebele"},{"alpha2":"ng","alpha3":"ndo","bibliographic":"","name":"Ndonga"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"German, Low"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low German"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low Saxon"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Saxon, Low"},{"alpha2":"ne","alpha3":"nep","bibliographic":"","name":"Nepali"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Nepal Bhasa"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Newari"},{"alpha2":"","alpha3":"nia","bibliographic":"","name":"Nias"},{"alpha2":"","alpha3":"nic","bibliographic":"","name":"Niger-Kordofanian languages"},{"alpha2":"","alpha3":"niu","bibliographic":"","name":"Niuean"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Dutch"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Flemish"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Norwegian Nynorsk"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Nynorsk, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Bokmål, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Norwegian Bokmål"},{"alpha2":"","alpha3":"nog","bibliographic":"","name":"Nogai"},{"alpha2":"","alpha3":"non","bibliographic":"","name":"Norse, Old"},{"alpha2":"no","alpha3":"nor","bibliographic":"","name":"Norwegian"},{"alpha2":"","alpha3":"nqo","bibliographic":"","name":"N'Ko"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Northern Sotho"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Pedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sepedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sotho, Northern"},{"alpha2":"","alpha3":"nub","bibliographic":"","name":"Nubian languages"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Nepal Bhasa"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Newari"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Old Newari"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chichewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Nyanja"},{"alpha2":"","alpha3":"nym","bibliographic":"","name":"Nyamwezi"},{"alpha2":"","alpha3":"nyn","bibliographic":"","name":"Nyankole"},{"alpha2":"","alpha3":"nyo","bibliographic":"","name":"Nyoro"},{"alpha2":"","alpha3":"nzi","bibliographic":"","name":"Nzima"},{"alpha2":"oc","alpha3":"oci","bibliographic":"","name":"Occitan (post 1500)"},{"alpha2":"oj","alpha3":"oji","bibliographic":"","name":"Ojibwa"},{"alpha2":"or","alpha3":"ori","bibliographic":"","name":"Oriya"},{"alpha2":"om","alpha3":"orm","bibliographic":"","name":"Oromo"},{"alpha2":"","alpha3":"osa","bibliographic":"","name":"Osage"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetian"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetic"},{"alpha2":"","alpha3":"ota","bibliographic":"","name":"Turkish, Ottoman (1500-1928)"},{"alpha2":"","alpha3":"oto","bibliographic":"","name":"Otomian languages"},{"alpha2":"","alpha3":"paa","bibliographic":"","name":"Papuan languages"},{"alpha2":"","alpha3":"pag","bibliographic":"","name":"Pangasinan"},{"alpha2":"","alpha3":"pal","bibliographic":"","name":"Pahlavi"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Kapampangan"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Pampanga"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Panjabi"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Punjabi"},{"alpha2":"","alpha3":"pap","bibliographic":"","name":"Papiamento"},{"alpha2":"","alpha3":"pau","bibliographic":"","name":"Palauan"},{"alpha2":"","alpha3":"peo","bibliographic":"","name":"Persian, Old (ca.600-400 B.C.)"},{"alpha2":"","alpha3":"phi","bibliographic":"","name":"Philippine languages"},{"alpha2":"","alpha3":"phn","bibliographic":"","name":"Phoenician"},{"alpha2":"pi","alpha3":"pli","bibliographic":"","name":"Pali"},{"alpha2":"pl","alpha3":"pol","bibliographic":"","name":"Polish"},{"alpha2":"","alpha3":"pon","bibliographic":"","name":"Pohnpeian"},{"alpha2":"pt","alpha3":"por","bibliographic":"","name":"Portuguese"},{"alpha2":"","alpha3":"pra","bibliographic":"","name":"Prakrit languages"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Occitan, Old (to 1500)"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Provençal, Old (to 1500)"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pashto"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pushto"},{"alpha2":"qu","alpha3":"que","bibliographic":"","name":"Quechua"},{"alpha2":"","alpha3":"raj","bibliographic":"","name":"Rajasthani"},{"alpha2":"","alpha3":"rap","bibliographic":"","name":"Rapanui"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Cook Islands Maori"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Rarotongan"},{"alpha2":"","alpha3":"roa","bibliographic":"","name":"Romance languages"},{"alpha2":"rm","alpha3":"roh","bibliographic":"","name":"Romansh"},{"alpha2":"","alpha3":"rom","bibliographic":"","name":"Romany"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Moldavian"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Romanian"},{"alpha2":"rn","alpha3":"run","bibliographic":"","name":"Rundi"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Aromanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Arumanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Macedo-Romanian"},{"alpha2":"ru","alpha3":"rus","bibliographic":"","name":"Russian"},{"alpha2":"","alpha3":"sad","bibliographic":"","name":"Sandawe"},{"alpha2":"sg","alpha3":"sag","bibliographic":"","name":"Sango"},{"alpha2":"","alpha3":"sah","bibliographic":"","name":"Yakut"},{"alpha2":"","alpha3":"sai","bibliographic":"","name":"South American Indian languages"},{"alpha2":"","alpha3":"sal","bibliographic":"","name":"Salishan languages"},{"alpha2":"","alpha3":"sam","bibliographic":"","name":"Samaritan Aramaic"},{"alpha2":"sa","alpha3":"san","bibliographic":"","name":"Sanskrit"},{"alpha2":"","alpha3":"sas","bibliographic":"","name":"Sasak"},{"alpha2":"","alpha3":"sat","bibliographic":"","name":"Santali"},{"alpha2":"","alpha3":"scn","bibliographic":"","name":"Sicilian"},{"alpha2":"","alpha3":"sco","bibliographic":"","name":"Scots"},{"alpha2":"","alpha3":"sel","bibliographic":"","name":"Selkup"},{"alpha2":"","alpha3":"sem","bibliographic":"","name":"Semitic languages"},{"alpha2":"","alpha3":"sga","bibliographic":"","name":"Irish, Old (to 900)"},{"alpha2":"","alpha3":"sgn","bibliographic":"","name":"Sign Languages"},{"alpha2":"","alpha3":"shn","bibliographic":"","name":"Shan"},{"alpha2":"","alpha3":"sid","bibliographic":"","name":"Sidamo"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhala"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhalese"},{"alpha2":"","alpha3":"sio","bibliographic":"","name":"Siouan languages"},{"alpha2":"","alpha3":"sit","bibliographic":"","name":"Sino-Tibetan languages"},{"alpha2":"","alpha3":"sla","bibliographic":"","name":"Slavic languages"},{"alpha2":"sk","alpha3":"slk","bibliographic":"slo","name":"Slovak"},{"alpha2":"sl","alpha3":"slv","bibliographic":"","name":"Slovenian"},{"alpha2":"","alpha3":"sma","bibliographic":"","name":"Southern Sami"},{"alpha2":"se","alpha3":"sme","bibliographic":"","name":"Northern Sami"},{"alpha2":"","alpha3":"smi","bibliographic":"","name":"Sami languages"},{"alpha2":"","alpha3":"smj","bibliographic":"","name":"Lule Sami"},{"alpha2":"","alpha3":"smn","bibliographic":"","name":"Inari Sami"},{"alpha2":"sm","alpha3":"smo","bibliographic":"","name":"Samoan"},{"alpha2":"","alpha3":"sms","bibliographic":"","name":"Skolt Sami"},{"alpha2":"sn","alpha3":"sna","bibliographic":"","name":"Shona"},{"alpha2":"sd","alpha3":"snd","bibliographic":"","name":"Sindhi"},{"alpha2":"","alpha3":"snk","bibliographic":"","name":"Soninke"},{"alpha2":"","alpha3":"sog","bibliographic":"","name":"Sogdian"},{"alpha2":"so","alpha3":"som","bibliographic":"","name":"Somali"},{"alpha2":"","alpha3":"son","bibliographic":"","name":"Songhai languages"},{"alpha2":"st","alpha3":"sot","bibliographic":"","name":"Sotho, Southern"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Castilian"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Spanish"},{"alpha2":"sq","alpha3":"sqi","bibliographic":"alb","name":"Albanian"},{"alpha2":"sc","alpha3":"srd","bibliographic":"","name":"Sardinian"},{"alpha2":"","alpha3":"srn","bibliographic":"","name":"Sranan Tongo"},{"alpha2":"sr","alpha3":"srp","bibliographic":"","name":"Serbian"},{"alpha2":"","alpha3":"srr","bibliographic":"","name":"Serer"},{"alpha2":"","alpha3":"ssa","bibliographic":"","name":"Nilo-Saharan languages"},{"alpha2":"ss","alpha3":"ssw","bibliographic":"","name":"Swati"},{"alpha2":"","alpha3":"suk","bibliographic":"","name":"Sukuma"},{"alpha2":"su","alpha3":"sun","bibliographic":"","name":"Sundanese"},{"alpha2":"","alpha3":"sus","bibliographic":"","name":"Susu"},{"alpha2":"","alpha3":"sux","bibliographic":"","name":"Sumerian"},{"alpha2":"sw","alpha3":"swa","bibliographic":"","name":"Swahili"},{"alpha2":"sv","alpha3":"swe","bibliographic":"","name":"Swedish"},{"alpha2":"","alpha3":"syc","bibliographic":"","name":"Classical Syriac"},{"alpha2":"","alpha3":"syr","bibliographic":"","name":"Syriac"},{"alpha2":"ty","alpha3":"tah","bibliographic":"","name":"Tahitian"},{"alpha2":"","alpha3":"tai","bibliographic":"","name":"Tai languages"},{"alpha2":"ta","alpha3":"tam","bibliographic":"","name":"Tamil"},{"alpha2":"tt","alpha3":"tat","bibliographic":"","name":"Tatar"},{"alpha2":"te","alpha3":"tel","bibliographic":"","name":"Telugu"},{"alpha2":"","alpha3":"tem","bibliographic":"","name":"Timne"},{"alpha2":"","alpha3":"ter","bibliographic":"","name":"Tereno"},{"alpha2":"","alpha3":"tet","bibliographic":"","name":"Tetum"},{"alpha2":"tg","alpha3":"tgk","bibliographic":"","name":"Tajik"},{"alpha2":"tl","alpha3":"tgl","bibliographic":"","name":"Tagalog"},{"alpha2":"th","alpha3":"tha","bibliographic":"","name":"Thai"},{"alpha2":"","alpha3":"tig","bibliographic":"","name":"Tigre"},{"alpha2":"ti","alpha3":"tir","bibliographic":"","name":"Tigrinya"},{"alpha2":"","alpha3":"tiv","bibliographic":"","name":"Tiv"},{"alpha2":"","alpha3":"tkl","bibliographic":"","name":"Tokelau"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"Klingon"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"tlhIngan-Hol"},{"alpha2":"","alpha3":"tli","bibliographic":"","name":"Tlingit"},{"alpha2":"","alpha3":"tmh","bibliographic":"","name":"Tamashek"},{"alpha2":"","alpha3":"tog","bibliographic":"","name":"Tonga (Nyasa)"},{"alpha2":"to","alpha3":"ton","bibliographic":"","name":"Tonga (Tonga Islands)"},{"alpha2":"","alpha3":"tpi","bibliographic":"","name":"Tok Pisin"},{"alpha2":"","alpha3":"tsi","bibliographic":"","name":"Tsimshian"},{"alpha2":"tn","alpha3":"tsn","bibliographic":"","name":"Tswana"},{"alpha2":"ts","alpha3":"tso","bibliographic":"","name":"Tsonga"},{"alpha2":"tk","alpha3":"tuk","bibliographic":"","name":"Turkmen"},{"alpha2":"","alpha3":"tum","bibliographic":"","name":"Tumbuka"},{"alpha2":"","alpha3":"tup","bibliographic":"","name":"Tupi languages"},{"alpha2":"tr","alpha3":"tur","bibliographic":"","name":"Turkish"},{"alpha2":"","alpha3":"tut","bibliographic":"","name":"Altaic languages"},{"alpha2":"","alpha3":"tvl","bibliographic":"","name":"Tuvalu"},{"alpha2":"tw","alpha3":"twi","bibliographic":"","name":"Twi"},{"alpha2":"","alpha3":"tyv","bibliographic":"","name":"Tuvinian"},{"alpha2":"","alpha3":"udm","bibliographic":"","name":"Udmurt"},{"alpha2":"","alpha3":"uga","bibliographic":"","name":"Ugaritic"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uighur"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uyghur"},{"alpha2":"uk","alpha3":"ukr","bibliographic":"","name":"Ukrainian"},{"alpha2":"","alpha3":"umb","bibliographic":"","name":"Umbundu"},{"alpha2":"","alpha3":"und","bibliographic":"","name":"Undetermined"},{"alpha2":"ur","alpha3":"urd","bibliographic":"","name":"Urdu"},{"alpha2":"uz","alpha3":"uzb","bibliographic":"","name":"Uzbek"},{"alpha2":"","alpha3":"vai","bibliographic":"","name":"Vai"},{"alpha2":"ve","alpha3":"ven","bibliographic":"","name":"Venda"},{"alpha2":"vi","alpha3":"vie","bibliographic":"","name":"Vietnamese"},{"alpha2":"vo","alpha3":"vol","bibliographic":"","name":"Volapük"},{"alpha2":"","alpha3":"vot","bibliographic":"","name":"Votic"},{"alpha2":"","alpha3":"wak","bibliographic":"","name":"Wakashan languages"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaitta"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaytta"},{"alpha2":"","alpha3":"war","bibliographic":"","name":"Waray"},{"alpha2":"","alpha3":"was","bibliographic":"","name":"Washo"},{"alpha2":"","alpha3":"wen","bibliographic":"","name":"Sorbian languages"},{"alpha2":"wa","alpha3":"wln","bibliographic":"","name":"Walloon"},{"alpha2":"wo","alpha3":"wol","bibliographic":"","name":"Wolof"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Kalmyk"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Oirat"},{"alpha2":"xh","alpha3":"xho","bibliographic":"","name":"Xhosa"},{"alpha2":"","alpha3":"yao","bibliographic":"","name":"Yao"},{"alpha2":"","alpha3":"yap","bibliographic":"","name":"Yapese"},{"alpha2":"yi","alpha3":"yid","bibliographic":"","name":"Yiddish"},{"alpha2":"yo","alpha3":"yor","bibliographic":"","name":"Yoruba"},{"alpha2":"","alpha3":"ypk","bibliographic":"","name":"Yupik languages"},{"alpha2":"","alpha3":"zap","bibliographic":"","name":"Zapotec"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Bliss"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbolics"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbols"},{"alpha2":"","alpha3":"zen","bibliographic":"","name":"Zenaga"},{"alpha2":"","alpha3":"zgh","bibliographic":"","name":"Standard Moroccan Tamazight"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Chuang"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Zhuang"},{"alpha2":"zh","alpha3":"zho","bibliographic":"chi","name":"Chinese"},{"alpha2":"","alpha3":"znd","bibliographic":"","name":"Zande languages"},{"alpha2":"zu","alpha3":"zul","bibliographic":"","name":"Zulu"},{"alpha2":"","alpha3":"zun","bibliographic":"","name":"Zuni"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"No linguistic content"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"Not applicable"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimili"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimli"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirdki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirmanjki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zaza"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zazaki"}]

/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n@charset \"UTF-8\";\n/**\n * Copyright 2015 Palantir Technologies, Inc. All rights reserved.\n * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy\n * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE\n * and https://github.com/palantir/blueprint/blob/master/PATENTS\n */\nhtml {\n  box-sizing: border-box; }\n\n*, *::before, *::after {\n  box-sizing: inherit; }\n\n@font-face {\n  font-family: \"Icons16\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(" + __webpack_require__(3629) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(3631) + ") format(\"woff\"), url(" + __webpack_require__(3630) + ") format(\"truetype\"); }\n\n@font-face {\n  font-family: \"Icons20\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(" + __webpack_require__(3632) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(3634) + ") format(\"woff\"), url(" + __webpack_require__(3633) + ") format(\"truetype\"); }\n\nhr {\n  margin: 20px 0;\n  border: none;\n  border-bottom: 1px solid rgba(16, 22, 26, 0.15); }\n  .pt-dark hr {\n    border-color: rgba(255, 255, 255, 0.15); }\n\n::-moz-selection {\n  background: rgba(125, 188, 255, 0.6); }\n\n::selection {\n  background: rgba(125, 188, 255, 0.6); }\n\nbody {\n  text-transform: none;\n  line-height: 1.28581;\n  letter-spacing: 0;\n  font-family: -apple-system, \"BlinkMacSystemFont\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Open Sans\", \"Helvetica Neue\", \"Icons16\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #182026; }\n\nsmall {\n  font-size: 12px; }\n\n.pt-monospace-text {\n  text-transform: none;\n  font-family: monospace;\n  font-size: smaller; }\n\nh1 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.8em;\n  font-size: 40px; }\n\nh2 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.8em;\n  font-size: 27px; }\n\nh3 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.8em;\n  font-size: 24px; }\n\nh4 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.9em;\n  font-size: 20px; }\n\nh5 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.9em;\n  font-size: 17px; }\n\nh6 {\n  color: #182026;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n  line-height: 0.9em;\n  font-size: 15px; }\n\n.pt-ui-text {\n  text-transform: none;\n  line-height: 1.28581;\n  letter-spacing: 0;\n  font-family: -apple-system, \"BlinkMacSystemFont\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Open Sans\", \"Helvetica Neue\", \"Icons16\", sans-serif;\n  font-size: 14px;\n  font-weight: 400; }\n\n.pt-ui-text-large {\n  line-height: 1.25;\n  font-size: 16px; }\n\n.pt-running-text {\n  line-height: 1.5;\n  font-size: 16px; }\n  .pt-running-text h1 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n  .pt-running-text h2 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n  .pt-running-text h3 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n  .pt-running-text h4 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n  .pt-running-text h5 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n  .pt-running-text h6 {\n    margin-top: 40px;\n    margin-bottom: 20px; }\n\n.pt-running-text-small {\n  line-height: 1.5;\n  font-size: 14px; }\n\np {\n  margin: 0 0 10px;\n  padding: 0; }\n\na {\n  text-decoration: none;\n  color: #106ba3; }\n  a:hover {\n    cursor: pointer;\n    text-decoration: underline;\n    color: #106ba3; }\n  a .pt-icon, a .pt-icon-standard, a .pt-icon-large {\n    color: inherit; }\n  a code, .pt-dark a code {\n    color: inherit; }\n  .pt-dark a, .pt-dark a:hover {\n    color: #48aff0; }\n    .pt-dark a .pt-icon, .pt-dark a .pt-icon-standard, .pt-dark a .pt-icon-large, .pt-dark a:hover .pt-icon, .pt-dark a:hover .pt-icon-standard, .pt-dark a:hover .pt-icon-large {\n      color: inherit; }\n\npre, code {\n  text-transform: none;\n  font-family: monospace;\n  font-size: smaller; }\n\ncode {\n  border-radius: 3px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2);\n  background: rgba(255, 255, 255, 0.7);\n  padding: 2px 5px;\n  color: #5c7080; }\n  .pt-dark code {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background: rgba(16, 22, 26, 0.3);\n    color: #bfccd6; }\n\npre {\n  display: block;\n  margin: 10px 0;\n  border-radius: 3px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15);\n  background: rgba(255, 255, 255, 0.7);\n  padding: 13px 15px 12px;\n  line-height: 1.4;\n  color: #182026;\n  font-size: 13px;\n  word-break: break-all;\n  word-wrap: break-word; }\n  pre > code {\n    border-radius: 0;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    white-space: pre-wrap;\n    color: inherit;\n    font-size: inherit; }\n  .pt-dark pre {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background: rgba(16, 22, 26, 0.3);\n    color: #f5f8fa; }\n    .pt-dark pre > code {\n      box-shadow: none;\n      background: transparent; }\n\nblockquote {\n  line-height: 1.5;\n  font-size: 16px;\n  margin: 0 0 10px;\n  border-left: solid 4px rgba(167, 182, 194, 0.5);\n  padding: 0 20px; }\n  blockquote p:last-child {\n    margin-bottom: 0; }\n  .pt-dark blockquote {\n    border-color: rgba(115, 134, 148, 0.5); }\n\nol, ul {\n  margin: 10px 0;\n  padding-left: 40px; }\n\n.pt-list li:not(:last-child), .pt-running-text ul li:not(:last-child), .pt-running-text ol li:not(:last-child) {\n  padding-bottom: 5px; }\n\n.pt-list li :last-child, .pt-running-text ul li :last-child, .pt-running-text ol li :last-child {\n  margin-bottom: 0; }\n\n.pt-list ol, .pt-list ul, .pt-running-text ul ol, .pt-running-text ul ul, .pt-running-text ol ol, .pt-running-text ol ul {\n  margin-top: 5px; }\n\n.pt-list-unstyled {\n  margin: 0;\n  padding: 0;\n  list-style: none; }\n  .pt-list-unstyled li {\n    padding: 0; }\n\n.pt-text-muted {\n  color: #5c7080; }\n  .pt-dark .pt-text-muted {\n    color: #bfccd6; }\n\n.pt-text-overflow-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal; }\n\n.pt-rtl {\n  text-align: right; }\n\n.pt-dark {\n  color: #f5f8fa; }\n  .pt-dark h1 {\n    color: #f5f8fa; }\n  .pt-dark h2 {\n    color: #f5f8fa; }\n  .pt-dark h3 {\n    color: #f5f8fa; }\n  .pt-dark h4 {\n    color: #f5f8fa; }\n  .pt-dark h5 {\n    color: #f5f8fa; }\n  .pt-dark h6 {\n    color: #f5f8fa; }\n\n:focus {\n  outline: rgba(19, 124, 189, 0.5) auto 2px;\n  outline-offset: 2px;\n  -moz-outline-radius: 6px; }\n\n.pt-focus-disabled :focus {\n  outline: none !important; }\n  .pt-focus-disabled :focus ~ .pt-control-indicator {\n    outline: none !important; }\n\n.pt-alert {\n  max-width: 400px;\n  padding: 20px; }\n\n.pt-alert-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .pt-alert-body .pt-icon {\n    margin-right: 20px;\n    font-size: 40px; }\n\n.pt-alert-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n  margin-top: 10px; }\n  .pt-alert-footer .pt-button {\n    margin-left: 10px; }\n\n.pt-breadcrumbs {\n  display: inline-block;\n  margin: 0;\n  cursor: default;\n  padding: 0;\n  list-style: none;\n  vertical-align: top;\n  line-height: 30px; }\n  .pt-breadcrumbs > li {\n    float: left; }\n    .pt-breadcrumbs > li::after {\n      line-height: 1;\n      font-family: \"Icons16\", sans-serif;\n      font-size: 16px;\n      font-weight: 400;\n      font-style: normal;\n      -moz-osx-font-smoothing: grayscale;\n      -webkit-font-smoothing: antialiased;\n      padding: 0 5px;\n      color: #5c7080;\n      content: \"\\E695\"; }\n    .pt-breadcrumbs > li:last-child::after {\n      display: none; }\n\n.pt-breadcrumb, .pt-breadcrumb-current, .pt-breadcrumbs-collapsed {\n  display: inline-block;\n  line-height: 19px;\n  font-size: 16px; }\n\n.pt-breadcrumb, .pt-breadcrumbs-collapsed {\n  color: #5c7080; }\n\n.pt-breadcrumb:hover {\n  text-decoration: none; }\n\n.pt-breadcrumb.pt-disabled {\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-breadcrumb-current {\n  color: inherit;\n  font-weight: 600; }\n  .pt-breadcrumb-current .pt-input {\n    vertical-align: baseline;\n    font-size: inherit;\n    font-weight: inherit; }\n\n.pt-breadcrumbs-collapsed {\n  margin-right: 2px;\n  border: none;\n  border-radius: 3px;\n  background: #ced9e0;\n  cursor: pointer;\n  padding: 0 5px; }\n  .pt-breadcrumbs-collapsed::before {\n    line-height: 1;\n    font-family: \"Icons20\", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    font-style: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    line-height: 19px;\n    content: \"\\E62A\"; }\n  .pt-breadcrumbs-collapsed:hover {\n    background: #bfccd6;\n    text-decoration: none;\n    color: #182026; }\n\n.pt-dark .pt-breadcrumb, .pt-dark .pt-breadcrumbs-collapsed {\n  color: #bfccd6; }\n\n.pt-dark .pt-breadcrumbs > li::after {\n  color: #bfccd6; }\n\n.pt-dark .pt-breadcrumb.pt-disabled {\n  color: rgba(191, 204, 214, 0.5); }\n\n.pt-dark .pt-breadcrumb-current {\n  color: #f5f8fa; }\n\n.pt-dark .pt-breadcrumbs-collapsed {\n  background: rgba(16, 22, 26, 0.4); }\n  .pt-dark .pt-breadcrumbs-collapsed:hover {\n    background: rgba(16, 22, 26, 0.6);\n    color: #f5f8fa; }\n\n.pt-button {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  min-width: 30px;\n  min-height: 30px;\n  line-height: 30px;\n  \n  \n   }\n  .pt-button:disabled, .pt-button.pt-disabled {\n    cursor: not-allowed; }\n  .pt-button.pt-fill {\n    width: 100%; }\n  .pt-button:not([class*=\"pt-intent-\"]) {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-color: #f5f8fa;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n    color: #182026; }\n    .pt-button:not([class*=\"pt-intent-\"]):hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n      background-clip: padding-box;\n      background-color: #ebf1f5; }\n    .pt-button:not([class*=\"pt-intent-\"]):active, .pt-button:not([class*=\"pt-intent-\"]).pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #d8e1e8;\n      background-image: none; }\n    .pt-button:not([class*=\"pt-intent-\"]):disabled, .pt-button:not([class*=\"pt-intent-\"]).pt-disabled {\n      outline: none;\n      box-shadow: none;\n      background-color: rgba(206, 217, 224, 0.5);\n      background-image: none;\n      cursor: not-allowed;\n      color: rgba(92, 112, 128, 0.5); }\n      .pt-button:not([class*=\"pt-intent-\"]):disabled.pt-active, .pt-button:not([class*=\"pt-intent-\"]).pt-disabled.pt-active {\n        background: rgba(206, 217, 224, 0.7); }\n  .pt-button.pt-intent-primary {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #137cbd;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    color: #ffffff; }\n    .pt-button.pt-intent-primary:hover, .pt-button.pt-intent-primary:active, .pt-button.pt-intent-primary.pt-active {\n      color: #ffffff; }\n    .pt-button.pt-intent-primary:hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n      background-color: #106ba3; }\n    .pt-button.pt-intent-primary:active, .pt-button.pt-intent-primary.pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #0e5a8a;\n      background-image: none; }\n    .pt-button.pt-intent-primary:disabled, .pt-button.pt-intent-primary.pt-disabled {\n      border-color: transparent;\n      box-shadow: none;\n      background-color: rgba(19, 124, 189, 0.5);\n      background-image: none;\n      color: rgba(255, 255, 255, 0.6); }\n  .pt-button.pt-intent-success {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #0f9960;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    color: #ffffff; }\n    .pt-button.pt-intent-success:hover, .pt-button.pt-intent-success:active, .pt-button.pt-intent-success.pt-active {\n      color: #ffffff; }\n    .pt-button.pt-intent-success:hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n      background-color: #0d8050; }\n    .pt-button.pt-intent-success:active, .pt-button.pt-intent-success.pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #0a6640;\n      background-image: none; }\n    .pt-button.pt-intent-success:disabled, .pt-button.pt-intent-success.pt-disabled {\n      border-color: transparent;\n      box-shadow: none;\n      background-color: rgba(15, 153, 96, 0.5);\n      background-image: none;\n      color: rgba(255, 255, 255, 0.6); }\n  .pt-button.pt-intent-warning {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #d9822b;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    color: #ffffff; }\n    .pt-button.pt-intent-warning:hover, .pt-button.pt-intent-warning:active, .pt-button.pt-intent-warning.pt-active {\n      color: #ffffff; }\n    .pt-button.pt-intent-warning:hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n      background-color: #bf7326; }\n    .pt-button.pt-intent-warning:active, .pt-button.pt-intent-warning.pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #a66321;\n      background-image: none; }\n    .pt-button.pt-intent-warning:disabled, .pt-button.pt-intent-warning.pt-disabled {\n      border-color: transparent;\n      box-shadow: none;\n      background-color: rgba(217, 130, 43, 0.5);\n      background-image: none;\n      color: rgba(255, 255, 255, 0.6); }\n  .pt-button.pt-intent-danger {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #db3737;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    color: #ffffff; }\n    .pt-button.pt-intent-danger:hover, .pt-button.pt-intent-danger:active, .pt-button.pt-intent-danger.pt-active {\n      color: #ffffff; }\n    .pt-button.pt-intent-danger:hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n      background-color: #c23030; }\n    .pt-button.pt-intent-danger:active, .pt-button.pt-intent-danger.pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #a82a2a;\n      background-image: none; }\n    .pt-button.pt-intent-danger:disabled, .pt-button.pt-intent-danger.pt-disabled {\n      border-color: transparent;\n      box-shadow: none;\n      background-color: rgba(219, 55, 55, 0.5);\n      background-image: none;\n      color: rgba(255, 255, 255, 0.6); }\n  .pt-button[class*=\"pt-intent-\"] .pt-button-spinner .pt-spinner-head {\n    stroke: #ffffff; }\n  .pt-button.pt-loading {\n    position: relative; }\n    .pt-button.pt-loading[class*=\"pt-icon-\"]::before {\n      visibility: hidden; }\n    .pt-button.pt-loading .pt-button-spinner {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      -webkit-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%); }\n    .pt-button.pt-loading > :not(.pt-button-spinner) {\n      visibility: hidden; }\n  .pt-button[class*=\"pt-icon-\"]::before {\n    line-height: 1;\n    font-family: \"Icons16\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    margin-right: 7px;\n    color: #5c7080; }\n  .pt-button .pt-icon, .pt-button .pt-icon-standard, .pt-button .pt-icon-large {\n    margin-right: 7px;\n    color: #5c7080; }\n    .pt-button .pt-icon.pt-align-right, .pt-button .pt-icon-standard.pt-align-right, .pt-button .pt-icon-large.pt-align-right {\n      margin-right: 0;\n      margin-left: 7px; }\n  .pt-dark .pt-button:not([class*=\"pt-intent-\"]) {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #394b59;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n    color: #f5f8fa; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]):hover, .pt-dark .pt-button:not([class*=\"pt-intent-\"]):active, .pt-dark .pt-button:not([class*=\"pt-intent-\"]).pt-active {\n      color: #f5f8fa; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]):hover {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n      background-color: #30404d; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]):active, .pt-dark .pt-button:not([class*=\"pt-intent-\"]).pt-active {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #202b33;\n      background-image: none; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]):disabled, .pt-dark .pt-button:not([class*=\"pt-intent-\"]).pt-disabled {\n      box-shadow: none;\n      background-color: rgba(57, 75, 89, 0.5);\n      background-image: none;\n      color: rgba(191, 204, 214, 0.5); }\n      .pt-dark .pt-button:not([class*=\"pt-intent-\"]):disabled.pt-active, .pt-dark .pt-button:not([class*=\"pt-intent-\"]).pt-disabled.pt-active {\n        background: rgba(57, 75, 89, 0.7); }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]) .pt-button-spinner .pt-spinner-head {\n      background: rgba(16, 22, 26, 0.5);\n      stroke: #8a9ba8; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"])[class*=\"pt-icon-\"]::before {\n      color: #bfccd6; }\n    .pt-dark .pt-button:not([class*=\"pt-intent-\"]) .pt-icon, .pt-dark .pt-button:not([class*=\"pt-intent-\"]) .pt-icon-standard, .pt-dark .pt-button:not([class*=\"pt-intent-\"]) .pt-icon-large {\n      color: #bfccd6; }\n  .pt-dark .pt-button[class*=\"pt-intent-\"] {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-button[class*=\"pt-intent-\"]:hover {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-button[class*=\"pt-intent-\"]:active, .pt-dark .pt-button[class*=\"pt-intent-\"].pt-active {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2); }\n    .pt-dark .pt-button[class*=\"pt-intent-\"]:disabled, .pt-dark .pt-button[class*=\"pt-intent-\"].pt-disabled {\n      box-shadow: none;\n      background-image: none;\n      color: rgba(255, 255, 255, 0.3); }\n    .pt-dark .pt-button[class*=\"pt-intent-\"] .pt-button-spinner .pt-spinner-head {\n      stroke: #8a9ba8; }\n  .pt-button:disabled::before, .pt-button.pt-disabled::before, .pt-button[class*=\"pt-intent-\"]::before {\n    color: inherit !important; }\n  .pt-button:disabled .pt-icon, .pt-button:disabled .pt-icon-standard, .pt-button:disabled .pt-icon-large, .pt-button.pt-disabled .pt-icon, .pt-button.pt-disabled .pt-icon-standard, .pt-button.pt-disabled .pt-icon-large, .pt-button[class*=\"pt-intent-\"] .pt-icon, .pt-button[class*=\"pt-intent-\"] .pt-icon-standard, .pt-button[class*=\"pt-intent-\"] .pt-icon-large {\n    color: inherit !important; }\n  .pt-button.pt-minimal {\n    box-shadow: none;\n    background: none; }\n    .pt-button.pt-minimal:hover {\n      box-shadow: none;\n      background: rgba(167, 182, 194, 0.3);\n      text-decoration: none;\n      color: #182026; }\n    .pt-button.pt-minimal:active, .pt-button.pt-minimal.pt-active {\n      box-shadow: none;\n      background: rgba(115, 134, 148, 0.3);\n      color: #182026; }\n    .pt-button.pt-minimal:disabled, .pt-button.pt-minimal:disabled:hover, .pt-button.pt-minimal.pt-disabled, .pt-button.pt-minimal.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(92, 112, 128, 0.5); }\n    .pt-dark .pt-button.pt-minimal {\n      box-shadow: none;\n      background: none;\n      color: inherit; }\n      .pt-dark .pt-button.pt-minimal:hover, .pt-dark .pt-button.pt-minimal:active, .pt-dark .pt-button.pt-minimal.pt-active {\n        box-shadow: none;\n        background: none; }\n      .pt-dark .pt-button.pt-minimal:hover {\n        background: rgba(138, 155, 168, 0.15); }\n      .pt-dark .pt-button.pt-minimal:active, .pt-dark .pt-button.pt-minimal.pt-active {\n        background: rgba(138, 155, 168, 0.3);\n        color: #f5f8fa; }\n      .pt-dark .pt-button.pt-minimal:disabled, .pt-dark .pt-button.pt-minimal:disabled:hover, .pt-dark .pt-button.pt-minimal.pt-disabled, .pt-dark .pt-button.pt-minimal.pt-disabled:hover {\n        background: none;\n        cursor: not-allowed;\n        color: rgba(191, 204, 214, 0.5); }\n    .pt-button.pt-minimal.pt-intent-primary {\n      color: #106ba3; }\n      .pt-button.pt-minimal.pt-intent-primary:hover, .pt-button.pt-minimal.pt-intent-primary:active, .pt-button.pt-minimal.pt-intent-primary.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #106ba3; }\n      .pt-button.pt-minimal.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.15);\n        color: #106ba3; }\n      .pt-button.pt-minimal.pt-intent-primary:active, .pt-button.pt-minimal.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #106ba3; }\n      .pt-button.pt-minimal.pt-intent-primary:disabled, .pt-button.pt-minimal.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(16, 107, 163, 0.5); }\n      .pt-button.pt-minimal.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n        stroke: #106ba3; }\n      .pt-dark .pt-button.pt-minimal.pt-intent-primary {\n        color: #48aff0; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-primary:hover {\n          background: rgba(19, 124, 189, 0.2);\n          color: #48aff0; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-primary:active, .pt-dark .pt-button.pt-minimal.pt-intent-primary.pt-active {\n          background: rgba(19, 124, 189, 0.3);\n          color: #48aff0; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-primary:disabled, .pt-dark .pt-button.pt-minimal.pt-intent-primary.pt-disabled {\n          background: none;\n          color: rgba(72, 175, 240, 0.5); }\n    .pt-button.pt-minimal.pt-intent-success {\n      color: #0d8050; }\n      .pt-button.pt-minimal.pt-intent-success:hover, .pt-button.pt-minimal.pt-intent-success:active, .pt-button.pt-minimal.pt-intent-success.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #0d8050; }\n      .pt-button.pt-minimal.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.15);\n        color: #0d8050; }\n      .pt-button.pt-minimal.pt-intent-success:active, .pt-button.pt-minimal.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #0d8050; }\n      .pt-button.pt-minimal.pt-intent-success:disabled, .pt-button.pt-minimal.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(13, 128, 80, 0.5); }\n      .pt-button.pt-minimal.pt-intent-success .pt-button-spinner .pt-spinner-head {\n        stroke: #0d8050; }\n      .pt-dark .pt-button.pt-minimal.pt-intent-success {\n        color: #3dcc91; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-success:hover {\n          background: rgba(15, 153, 96, 0.2);\n          color: #3dcc91; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-success:active, .pt-dark .pt-button.pt-minimal.pt-intent-success.pt-active {\n          background: rgba(15, 153, 96, 0.3);\n          color: #3dcc91; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-success:disabled, .pt-dark .pt-button.pt-minimal.pt-intent-success.pt-disabled {\n          background: none;\n          color: rgba(61, 204, 145, 0.5); }\n    .pt-button.pt-minimal.pt-intent-warning {\n      color: #bf7326; }\n      .pt-button.pt-minimal.pt-intent-warning:hover, .pt-button.pt-minimal.pt-intent-warning:active, .pt-button.pt-minimal.pt-intent-warning.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #bf7326; }\n      .pt-button.pt-minimal.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.15);\n        color: #bf7326; }\n      .pt-button.pt-minimal.pt-intent-warning:active, .pt-button.pt-minimal.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #bf7326; }\n      .pt-button.pt-minimal.pt-intent-warning:disabled, .pt-button.pt-minimal.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(191, 115, 38, 0.5); }\n      .pt-button.pt-minimal.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n        stroke: #bf7326; }\n      .pt-dark .pt-button.pt-minimal.pt-intent-warning {\n        color: #ffb366; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-warning:hover {\n          background: rgba(217, 130, 43, 0.2);\n          color: #ffb366; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-warning:active, .pt-dark .pt-button.pt-minimal.pt-intent-warning.pt-active {\n          background: rgba(217, 130, 43, 0.3);\n          color: #ffb366; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-warning:disabled, .pt-dark .pt-button.pt-minimal.pt-intent-warning.pt-disabled {\n          background: none;\n          color: rgba(255, 179, 102, 0.5); }\n    .pt-button.pt-minimal.pt-intent-danger {\n      color: #c23030; }\n      .pt-button.pt-minimal.pt-intent-danger:hover, .pt-button.pt-minimal.pt-intent-danger:active, .pt-button.pt-minimal.pt-intent-danger.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #c23030; }\n      .pt-button.pt-minimal.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.15);\n        color: #c23030; }\n      .pt-button.pt-minimal.pt-intent-danger:active, .pt-button.pt-minimal.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #c23030; }\n      .pt-button.pt-minimal.pt-intent-danger:disabled, .pt-button.pt-minimal.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(194, 48, 48, 0.5); }\n      .pt-button.pt-minimal.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n        stroke: #c23030; }\n      .pt-dark .pt-button.pt-minimal.pt-intent-danger {\n        color: #ff7373; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-danger:hover {\n          background: rgba(219, 55, 55, 0.2);\n          color: #ff7373; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-danger:active, .pt-dark .pt-button.pt-minimal.pt-intent-danger.pt-active {\n          background: rgba(219, 55, 55, 0.3);\n          color: #ff7373; }\n        .pt-dark .pt-button.pt-minimal.pt-intent-danger:disabled, .pt-dark .pt-button.pt-minimal.pt-intent-danger.pt-disabled {\n          background: none;\n          color: rgba(255, 115, 115, 0.5); }\n  .pt-button.pt-large, .pt-large .pt-button {\n    min-width: 40px;\n    min-height: 40px;\n    line-height: 40px;\n    padding: 0 15px;\n    font-size: 16px; }\n    .pt-button.pt-large[class*=\"pt-icon-\"]::before, .pt-large .pt-button[class*=\"pt-icon-\"]::before {\n      margin-right: 10px; }\n    .pt-button.pt-large .pt-icon, .pt-button.pt-large .pt-icon-standard, .pt-button.pt-large .pt-icon-large, .pt-large .pt-button .pt-icon, .pt-large .pt-button .pt-icon-standard, .pt-large .pt-button .pt-icon-large {\n      margin-right: 10px; }\n      .pt-button.pt-large .pt-icon.pt-align-right, .pt-button.pt-large .pt-icon-standard.pt-align-right, .pt-button.pt-large .pt-icon-large.pt-align-right, .pt-large .pt-button .pt-icon.pt-align-right, .pt-large .pt-button .pt-icon-standard.pt-align-right, .pt-large .pt-button .pt-icon-large.pt-align-right {\n        margin-right: 0;\n        margin-left: 10px; }\n  .pt-button.pt-small, .pt-small .pt-button {\n    min-width: 24px;\n    min-height: 24px;\n    line-height: 24px;\n    padding: 0 7px; }\n  .pt-button[class*=\"pt-icon-\"]:empty {\n    padding: 0; }\n    .pt-button[class*=\"pt-icon-\"]:empty::before {\n      margin-right: 0; }\n\na.pt-button {\n  text-align: center;\n  text-decoration: none;\n  transition: none; }\n  a.pt-button, a.pt-button:hover, a.pt-button:active {\n    color: #182026; }\n  a.pt-button.pt-disabled {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-select select {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px; }\n  .pt-select select:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-select select:active, .pt-select select.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-select select:disabled, .pt-select select.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-select select:disabled.pt-active, .pt-select select.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n\n.pt-select.pt-minimal select {\n  box-shadow: none;\n  background: none; }\n  .pt-select.pt-minimal select:hover {\n    box-shadow: none;\n    background: rgba(167, 182, 194, 0.3);\n    text-decoration: none;\n    color: #182026; }\n  .pt-select.pt-minimal select:active, .pt-select.pt-minimal select.pt-active {\n    box-shadow: none;\n    background: rgba(115, 134, 148, 0.3);\n    color: #182026; }\n  .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal select.pt-disabled:hover {\n    background: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-select.pt-minimal select, .pt-select.pt-minimal .pt-dark select {\n    box-shadow: none;\n    background: none;\n    color: inherit; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover, .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      box-shadow: none;\n      background: none; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover {\n      background: rgba(138, 155, 168, 0.15); }\n    .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      background: rgba(138, 155, 168, 0.3);\n      color: #f5f8fa; }\n    .pt-dark .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal .pt-dark select:disabled, .pt-dark .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal .pt-dark select:disabled:hover, .pt-dark .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-disabled, .pt-dark .pt-select.pt-minimal select.pt-disabled:hover, .pt-select.pt-minimal .pt-dark select.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-primary {\n    color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover {\n      background: rgba(19, 124, 189, 0.15);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      background: rgba(19, 124, 189, 0.3);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal select.pt-intent-primary.pt-disabled {\n      background: none;\n      color: rgba(16, 107, 163, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n      stroke: #106ba3; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-primary, .pt-select.pt-minimal .pt-dark select.pt-intent-primary {\n      color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.2);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:active, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(72, 175, 240, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-success {\n    color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover {\n      background: rgba(15, 153, 96, 0.15);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      background: rgba(15, 153, 96, 0.3);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal select.pt-intent-success.pt-disabled {\n      background: none;\n      color: rgba(13, 128, 80, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-success .pt-button-spinner .pt-spinner-head {\n      stroke: #0d8050; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-success, .pt-select.pt-minimal .pt-dark select.pt-intent-success {\n      color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.2);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal .pt-dark select.pt-intent-success:active, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(61, 204, 145, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-warning {\n    color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover {\n      background: rgba(217, 130, 43, 0.15);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      background: rgba(217, 130, 43, 0.3);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal select.pt-intent-warning.pt-disabled {\n      background: none;\n      color: rgba(191, 115, 38, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n      stroke: #bf7326; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-warning, .pt-select.pt-minimal .pt-dark select.pt-intent-warning {\n      color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.2);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:active, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(255, 179, 102, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-danger {\n    color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover {\n      background: rgba(219, 55, 55, 0.15);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      background: rgba(219, 55, 55, 0.3);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal select.pt-intent-danger.pt-disabled {\n      background: none;\n      color: rgba(194, 48, 48, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n      stroke: #c23030; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-danger, .pt-select.pt-minimal .pt-dark select.pt-intent-danger {\n      color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.2);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:active, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(255, 115, 115, 0.5); }\n\n.pt-select.pt-large select {\n  height: 40px;\n  padding-right: 35px;\n  font-size: 16px; }\n\n.pt-dark .pt-select select {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  background-color: #394b59;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  color: #f5f8fa; }\n  .pt-dark .pt-select select:hover, .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    color: #f5f8fa; }\n  .pt-dark .pt-select select:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #30404d; }\n  .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #202b33;\n    background-image: none; }\n  .pt-dark .pt-select select:disabled, .pt-dark .pt-select select.pt-disabled {\n    box-shadow: none;\n    background-color: rgba(57, 75, 89, 0.5);\n    background-image: none;\n    color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-select select:disabled.pt-active, .pt-dark .pt-select select.pt-disabled.pt-active {\n      background: rgba(57, 75, 89, 0.7); }\n  .pt-dark .pt-select select .pt-button-spinner .pt-spinner-head {\n    background: rgba(16, 22, 26, 0.5);\n    stroke: #8a9ba8; }\n\n.pt-select select:disabled {\n  box-shadow: none;\n  background-color: rgba(206, 217, 224, 0.5);\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-select::after {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  line-height: 30px;\n  color: #5c7080;\n  content: \"\\E6C6\";\n  pointer-events: none; }\n  .pt-disabled.pt-select::after {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-button-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  \n   }\n  .pt-button-group .pt-button {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    position: relative;\n    z-index: 4; }\n    .pt-button-group .pt-button:focus {\n      z-index: 5; }\n    .pt-button-group .pt-button:hover {\n      z-index: 6; }\n    .pt-button-group .pt-button:active, .pt-button-group .pt-button.pt-active {\n      z-index: 7; }\n    .pt-button-group .pt-button:disabled, .pt-button-group .pt-button.pt-disabled {\n      z-index: 3; }\n    .pt-button-group .pt-button[class*=\"pt-intent-\"] {\n      z-index: 9; }\n      .pt-button-group .pt-button[class*=\"pt-intent-\"]:focus {\n        z-index: 10; }\n      .pt-button-group .pt-button[class*=\"pt-intent-\"]:hover {\n        z-index: 11; }\n      .pt-button-group .pt-button[class*=\"pt-intent-\"]:active, .pt-button-group .pt-button[class*=\"pt-intent-\"].pt-active {\n        z-index: 12; }\n      .pt-button-group .pt-button[class*=\"pt-intent-\"]:disabled, .pt-button-group .pt-button[class*=\"pt-intent-\"].pt-disabled {\n        z-index: 8; }\n  .pt-button-group:not(.pt-minimal) > .pt-popover-target:not(:first-child) .pt-button, .pt-button-group:not(.pt-minimal) > .pt-button:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .pt-button-group:not(.pt-minimal) > .pt-popover-target:not(:last-child) .pt-button, .pt-button-group:not(.pt-minimal) > .pt-button:not(:last-child) {\n    margin-right: -1px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .pt-button-group.pt-minimal .pt-button {\n    box-shadow: none;\n    background: none;\n    margin-right: 11px;\n    border-radius: 3px !important;\n    overflow: visible; }\n    .pt-button-group.pt-minimal .pt-button:hover {\n      box-shadow: none;\n      background: rgba(167, 182, 194, 0.3);\n      text-decoration: none;\n      color: #182026; }\n    .pt-button-group.pt-minimal .pt-button:active, .pt-button-group.pt-minimal .pt-button.pt-active {\n      box-shadow: none;\n      background: rgba(115, 134, 148, 0.3);\n      color: #182026; }\n    .pt-button-group.pt-minimal .pt-button:disabled, .pt-button-group.pt-minimal .pt-button:disabled:hover, .pt-button-group.pt-minimal .pt-button.pt-disabled, .pt-button-group.pt-minimal .pt-button.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(92, 112, 128, 0.5); }\n    .pt-dark .pt-button-group.pt-minimal .pt-button {\n      box-shadow: none;\n      background: none;\n      color: inherit; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button:hover, .pt-dark .pt-button-group.pt-minimal .pt-button:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-active {\n        box-shadow: none;\n        background: none; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button:hover {\n        background: rgba(138, 155, 168, 0.15); }\n      .pt-dark .pt-button-group.pt-minimal .pt-button:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-active {\n        background: rgba(138, 155, 168, 0.3);\n        color: #f5f8fa; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button:disabled, .pt-dark .pt-button-group.pt-minimal .pt-button:disabled:hover, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-disabled, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-disabled:hover {\n        background: none;\n        cursor: not-allowed;\n        color: rgba(191, 204, 214, 0.5); }\n    .pt-button-group.pt-minimal .pt-button.pt-intent-primary {\n      color: #106ba3; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-primary:hover, .pt-button-group.pt-minimal .pt-button.pt-intent-primary:active, .pt-button-group.pt-minimal .pt-button.pt-intent-primary.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #106ba3; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.15);\n        color: #106ba3; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-primary:active, .pt-button-group.pt-minimal .pt-button.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #106ba3; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-primary:disabled, .pt-button-group.pt-minimal .pt-button.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(16, 107, 163, 0.5); }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n        stroke: #106ba3; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary {\n        color: #48aff0; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary:hover {\n          background: rgba(19, 124, 189, 0.2);\n          color: #48aff0; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary.pt-active {\n          background: rgba(19, 124, 189, 0.3);\n          color: #48aff0; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary:disabled, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-primary.pt-disabled {\n          background: none;\n          color: rgba(72, 175, 240, 0.5); }\n    .pt-button-group.pt-minimal .pt-button.pt-intent-success {\n      color: #0d8050; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-success:hover, .pt-button-group.pt-minimal .pt-button.pt-intent-success:active, .pt-button-group.pt-minimal .pt-button.pt-intent-success.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #0d8050; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.15);\n        color: #0d8050; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-success:active, .pt-button-group.pt-minimal .pt-button.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #0d8050; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-success:disabled, .pt-button-group.pt-minimal .pt-button.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(13, 128, 80, 0.5); }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-success .pt-button-spinner .pt-spinner-head {\n        stroke: #0d8050; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success {\n        color: #3dcc91; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success:hover {\n          background: rgba(15, 153, 96, 0.2);\n          color: #3dcc91; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success.pt-active {\n          background: rgba(15, 153, 96, 0.3);\n          color: #3dcc91; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success:disabled, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-success.pt-disabled {\n          background: none;\n          color: rgba(61, 204, 145, 0.5); }\n    .pt-button-group.pt-minimal .pt-button.pt-intent-warning {\n      color: #bf7326; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-warning:hover, .pt-button-group.pt-minimal .pt-button.pt-intent-warning:active, .pt-button-group.pt-minimal .pt-button.pt-intent-warning.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #bf7326; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.15);\n        color: #bf7326; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-warning:active, .pt-button-group.pt-minimal .pt-button.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #bf7326; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-warning:disabled, .pt-button-group.pt-minimal .pt-button.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(191, 115, 38, 0.5); }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n        stroke: #bf7326; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning {\n        color: #ffb366; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning:hover {\n          background: rgba(217, 130, 43, 0.2);\n          color: #ffb366; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning.pt-active {\n          background: rgba(217, 130, 43, 0.3);\n          color: #ffb366; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning:disabled, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-warning.pt-disabled {\n          background: none;\n          color: rgba(255, 179, 102, 0.5); }\n    .pt-button-group.pt-minimal .pt-button.pt-intent-danger {\n      color: #c23030; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-danger:hover, .pt-button-group.pt-minimal .pt-button.pt-intent-danger:active, .pt-button-group.pt-minimal .pt-button.pt-intent-danger.pt-active {\n        box-shadow: none;\n        background: none;\n        color: #c23030; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.15);\n        color: #c23030; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-danger:active, .pt-button-group.pt-minimal .pt-button.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #c23030; }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-danger:disabled, .pt-button-group.pt-minimal .pt-button.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(194, 48, 48, 0.5); }\n      .pt-button-group.pt-minimal .pt-button.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n        stroke: #c23030; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger {\n        color: #ff7373; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger:hover {\n          background: rgba(219, 55, 55, 0.2);\n          color: #ff7373; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger:active, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger.pt-active {\n          background: rgba(219, 55, 55, 0.3);\n          color: #ff7373; }\n        .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger:disabled, .pt-dark .pt-button-group.pt-minimal .pt-button.pt-intent-danger.pt-disabled {\n          background: none;\n          color: rgba(255, 115, 115, 0.5); }\n    .pt-button-group.pt-minimal .pt-button:focus {\n      outline-style: solid; }\n    .pt-button-group.pt-minimal .pt-button::after {\n      margin: 5px;\n      background: rgba(16, 22, 26, 0.15);\n      width: 1px;\n      display: inline-block;\n      position: absolute;\n      top: 10%;\n      bottom: 10%;\n      left: 100%;\n      content: \"\"; }\n      .pt-dark .pt-button-group.pt-minimal .pt-button::after {\n        background: rgba(255, 255, 255, 0.15); }\n  .pt-button-group.pt-minimal > .pt-popover-target:last-child .pt-button, .pt-button-group.pt-minimal > .pt-button:last-child {\n    margin-right: 0; }\n    .pt-button-group.pt-minimal > .pt-popover-target:last-child .pt-button::after, .pt-button-group.pt-minimal > .pt-button:last-child::after {\n      display: none; }\n  .pt-button-group.pt-fill {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n  .pt-button-group .pt-button.pt-fill, .pt-button-group.pt-fill .pt-button:not(.pt-fixed) {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; }\n  .pt-button-group.pt-vertical {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: stretch;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n    vertical-align: top; }\n    .pt-button-group.pt-vertical .pt-button {\n      margin-right: 0 !important; }\n    .pt-button-group.pt-vertical > .pt-popover-target:first-child .pt-button, .pt-button-group.pt-vertical > .pt-button:first-child {\n      border-radius: 3px 3px 0 0; }\n    .pt-button-group.pt-vertical > .pt-popover-target:last-child .pt-button, .pt-button-group.pt-vertical > .pt-button:last-child {\n      border-radius: 0 0 3px 3px; }\n    .pt-button-group.pt-vertical > .pt-popover-target:not(:last-child) .pt-button, .pt-button-group.pt-vertical > .pt-button:not(:last-child) {\n      margin-bottom: -1px; }\n    .pt-button-group.pt-vertical.pt-minimal .pt-button:not(:last-child) {\n      margin-bottom: 11px; }\n    .pt-button-group.pt-vertical.pt-minimal .pt-button::after {\n      top: 100%;\n      right: 0;\n      bottom: auto;\n      left: 0;\n      width: auto;\n      height: 1px; }\n  .pt-button-group.pt-align-left .pt-button {\n    text-align: left; }\n  .pt-dark .pt-button-group:not(.pt-minimal) > .pt-popover-target:not(:last-child) .pt-button, .pt-dark .pt-button-group:not(.pt-minimal) > .pt-button:not(:last-child) {\n    margin-right: 1px; }\n  .pt-dark .pt-button-group.pt-vertical > .pt-popover-target:not(:last-child) .pt-button, .pt-dark .pt-button-group.pt-vertical > .pt-button:not(:last-child) {\n    margin-bottom: 1px; }\n\n.pt-callout {\n  line-height: 1.5;\n  font-size: 14px;\n  position: relative;\n  border-radius: 3px;\n  background-color: rgba(138, 155, 168, 0.15);\n  padding: 10px 12px 9px; }\n  .pt-callout[class*=\"pt-icon-\"] {\n    padding-left: 40px; }\n    .pt-callout[class*=\"pt-icon-\"]::before {\n      line-height: 1;\n      font-family: \"Icons20\", sans-serif;\n      font-size: 20px;\n      font-weight: 400;\n      font-style: normal;\n      -moz-osx-font-smoothing: grayscale;\n      -webkit-font-smoothing: antialiased;\n      position: absolute;\n      top: 10px;\n      left: 10px;\n      color: #5c7080; }\n  .pt-callout h5 {\n    margin-top: 0;\n    margin-bottom: 5px;\n    line-height: 20px; }\n  .pt-dark .pt-callout {\n    background-color: rgba(138, 155, 168, 0.2); }\n    .pt-dark .pt-callout[class*=\"pt-icon-\"]::before {\n      color: #bfccd6; }\n  .pt-callout.pt-intent-primary {\n    background-color: rgba(19, 124, 189, 0.15); }\n    .pt-callout.pt-intent-primary[class*=\"pt-icon-\"]::before, .pt-callout.pt-intent-primary h5 {\n      color: #106ba3; }\n    .pt-dark .pt-callout.pt-intent-primary {\n      background-color: rgba(19, 124, 189, 0.25); }\n      .pt-dark .pt-callout.pt-intent-primary[class*=\"pt-icon-\"]::before, .pt-dark .pt-callout.pt-intent-primary h5 {\n        color: #48aff0; }\n  .pt-callout.pt-intent-success {\n    background-color: rgba(15, 153, 96, 0.15); }\n    .pt-callout.pt-intent-success[class*=\"pt-icon-\"]::before, .pt-callout.pt-intent-success h5 {\n      color: #0d8050; }\n    .pt-dark .pt-callout.pt-intent-success {\n      background-color: rgba(15, 153, 96, 0.25); }\n      .pt-dark .pt-callout.pt-intent-success[class*=\"pt-icon-\"]::before, .pt-dark .pt-callout.pt-intent-success h5 {\n        color: #3dcc91; }\n  .pt-callout.pt-intent-warning {\n    background-color: rgba(217, 130, 43, 0.15); }\n    .pt-callout.pt-intent-warning[class*=\"pt-icon-\"]::before, .pt-callout.pt-intent-warning h5 {\n      color: #bf7326; }\n    .pt-dark .pt-callout.pt-intent-warning {\n      background-color: rgba(217, 130, 43, 0.25); }\n      .pt-dark .pt-callout.pt-intent-warning[class*=\"pt-icon-\"]::before, .pt-dark .pt-callout.pt-intent-warning h5 {\n        color: #ffb366; }\n  .pt-callout.pt-intent-danger {\n    background-color: rgba(219, 55, 55, 0.15); }\n    .pt-callout.pt-intent-danger[class*=\"pt-icon-\"]::before, .pt-callout.pt-intent-danger h5 {\n      color: #c23030; }\n    .pt-dark .pt-callout.pt-intent-danger {\n      background-color: rgba(219, 55, 55, 0.25); }\n      .pt-dark .pt-callout.pt-intent-danger[class*=\"pt-icon-\"]::before, .pt-dark .pt-callout.pt-intent-danger h5 {\n        color: #ff7373; }\n  .pt-running-text .pt-callout {\n    margin: 20px 0; }\n\n.pt-card {\n  border-radius: 3px;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n  background-color: #ffffff;\n  padding: 20px;\n  transition: box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n  .pt-card.pt-dark, .pt-dark .pt-card {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0);\n    background-color: #30404d; }\n\n.pt-elevation-0 {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0); }\n  .pt-elevation-0.pt-dark, .pt-dark .pt-elevation-0 {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), 0 0 0 rgba(16, 22, 26, 0), 0 0 0 rgba(16, 22, 26, 0); }\n\n.pt-elevation-1 {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-elevation-1.pt-dark, .pt-dark .pt-elevation-1 {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.pt-elevation-2 {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 1px 1px rgba(16, 22, 26, 0.2), 0 2px 6px rgba(16, 22, 26, 0.2); }\n  .pt-elevation-2.pt-dark, .pt-dark .pt-elevation-2 {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.4), 0 2px 6px rgba(16, 22, 26, 0.4); }\n\n.pt-elevation-3 {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2); }\n  .pt-elevation-3.pt-dark, .pt-dark .pt-elevation-3 {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.pt-elevation-4 {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2); }\n  .pt-elevation-4.pt-dark, .pt-dark .pt-elevation-4 {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4); }\n\n.pt-card.pt-interactive:hover {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  cursor: pointer; }\n  .pt-card.pt-interactive:hover.pt-dark, .pt-dark .pt-card.pt-interactive:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n\n.pt-card.pt-interactive:active {\n  opacity: 0.9;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  transition-duration: 0; }\n  .pt-card.pt-interactive:active.pt-dark, .pt-dark .pt-card.pt-interactive:active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.pt-collapse {\n  height: 0;\n  overflow-y: hidden;\n  transition: height 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n  .pt-collapse .pt-collapse-body {\n    transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n\n.pt-context-menu .pt-popover-target {\n  display: block; }\n\n.pt-context-menu-popover-target {\n  position: fixed; }\n\n.pt-dialog-container {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-dialog-container.pt-overlay-enter > .pt-dialog, .pt-dialog-container.pt-overlay-appear > .pt-dialog {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); }\n  .pt-dialog-container.pt-overlay-enter-active > .pt-dialog, .pt-dialog-container.pt-overlay-appear-active > .pt-dialog {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    transition-property: opacity, -webkit-transform;\n    transition-property: opacity, transform;\n    transition-property: opacity, transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-dialog-container.pt-overlay-leave > .pt-dialog {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  .pt-dialog-container.pt-overlay-leave-active > .pt-dialog {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    transition-property: opacity, -webkit-transform;\n    transition-property: opacity, transform;\n    transition-property: opacity, transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-dialog-container .pt-dialog {\n    position: static !important;\n    -webkit-transform: none;\n            transform: none; }\n\n.pt-dialog {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 30px 0;\n  border-radius: 6px;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2), 0 18px 46px 6px rgba(16, 22, 26, 0.2);\n  background: #ebf1f5;\n  width: 500px;\n  padding-bottom: 20px;\n  -webkit-user-select: initial;\n     -moz-user-select: initial;\n      -ms-user-select: initial;\n          user-select: initial; }\n  .pt-dialog:focus {\n    outline: 0; }\n  .pt-dialog.pt-dark, .pt-dark .pt-dialog {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 4px 8px rgba(16, 22, 26, 0.4), 0 18px 46px 6px rgba(16, 22, 26, 0.4);\n    background: #293742;\n    color: #f5f8fa; }\n\n.pt-dialog-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 6px 6px 0 0;\n  box-shadow: 0 1px 0 rgba(16, 22, 26, 0.15);\n  background: #ffffff;\n  min-height: 40px;\n  padding-left: 20px; }\n  .pt-dialog-header .pt-icon-large {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    margin-right: 10px;\n    color: #5c7080; }\n  .pt-dialog-header h5 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    word-wrap: normal;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    margin: 0;\n    line-height: inherit; }\n    .pt-dialog-header h5:last-child {\n      margin-right: 20px; }\n  .pt-dark .pt-dialog-header {\n    box-shadow: 0 1px 0 rgba(16, 22, 26, 0.4);\n    background: #30404d; }\n    .pt-dark .pt-dialog-header .pt-icon-large {\n      color: #bfccd6; }\n    .pt-dark .pt-dialog-header h5 {\n      color: #f5f8fa; }\n\n.pt-dialog-close-button {\n  line-height: 1;\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  color: #5c7080;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 10px; }\n  .pt-dialog-close-button:hover {\n    color: #182026; }\n  .pt-dark .pt-dialog-close-button {\n    color: #bfccd6; }\n    .pt-dark .pt-dialog-close-button:hover {\n      color: #f5f8fa; }\n\n.pt-dialog-body {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  margin: 20px;\n  line-height: 18px; }\n\n.pt-dialog-footer {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  margin: 0 20px; }\n\n.pt-dialog-footer-actions {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n  .pt-dialog-footer-actions .pt-button {\n    margin-left: 10px; }\n\n.pt-select select {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px; }\n  .pt-select select:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-select select:active, .pt-select select.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-select select:disabled, .pt-select select.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-select select:disabled.pt-active, .pt-select select.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n\n.pt-select.pt-minimal select {\n  box-shadow: none;\n  background: none; }\n  .pt-select.pt-minimal select:hover {\n    box-shadow: none;\n    background: rgba(167, 182, 194, 0.3);\n    text-decoration: none;\n    color: #182026; }\n  .pt-select.pt-minimal select:active, .pt-select.pt-minimal select.pt-active {\n    box-shadow: none;\n    background: rgba(115, 134, 148, 0.3);\n    color: #182026; }\n  .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal select.pt-disabled:hover {\n    background: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-select.pt-minimal select, .pt-select.pt-minimal .pt-dark select {\n    box-shadow: none;\n    background: none;\n    color: inherit; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover, .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      box-shadow: none;\n      background: none; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover {\n      background: rgba(138, 155, 168, 0.15); }\n    .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      background: rgba(138, 155, 168, 0.3);\n      color: #f5f8fa; }\n    .pt-dark .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal .pt-dark select:disabled, .pt-dark .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal .pt-dark select:disabled:hover, .pt-dark .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-disabled, .pt-dark .pt-select.pt-minimal select.pt-disabled:hover, .pt-select.pt-minimal .pt-dark select.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-primary {\n    color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover {\n      background: rgba(19, 124, 189, 0.15);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      background: rgba(19, 124, 189, 0.3);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal select.pt-intent-primary.pt-disabled {\n      background: none;\n      color: rgba(16, 107, 163, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n      stroke: #106ba3; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-primary, .pt-select.pt-minimal .pt-dark select.pt-intent-primary {\n      color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.2);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:active, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(72, 175, 240, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-success {\n    color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover {\n      background: rgba(15, 153, 96, 0.15);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      background: rgba(15, 153, 96, 0.3);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal select.pt-intent-success.pt-disabled {\n      background: none;\n      color: rgba(13, 128, 80, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-success .pt-button-spinner .pt-spinner-head {\n      stroke: #0d8050; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-success, .pt-select.pt-minimal .pt-dark select.pt-intent-success {\n      color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.2);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal .pt-dark select.pt-intent-success:active, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(61, 204, 145, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-warning {\n    color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover {\n      background: rgba(217, 130, 43, 0.15);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      background: rgba(217, 130, 43, 0.3);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal select.pt-intent-warning.pt-disabled {\n      background: none;\n      color: rgba(191, 115, 38, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n      stroke: #bf7326; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-warning, .pt-select.pt-minimal .pt-dark select.pt-intent-warning {\n      color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.2);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:active, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(255, 179, 102, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-danger {\n    color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover {\n      background: rgba(219, 55, 55, 0.15);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      background: rgba(219, 55, 55, 0.3);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal select.pt-intent-danger.pt-disabled {\n      background: none;\n      color: rgba(194, 48, 48, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n      stroke: #c23030; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-danger, .pt-select.pt-minimal .pt-dark select.pt-intent-danger {\n      color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.2);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:active, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(255, 115, 115, 0.5); }\n\n.pt-select.pt-large select {\n  height: 40px;\n  padding-right: 35px;\n  font-size: 16px; }\n\n.pt-dark .pt-select select {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  background-color: #394b59;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  color: #f5f8fa; }\n  .pt-dark .pt-select select:hover, .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    color: #f5f8fa; }\n  .pt-dark .pt-select select:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #30404d; }\n  .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #202b33;\n    background-image: none; }\n  .pt-dark .pt-select select:disabled, .pt-dark .pt-select select.pt-disabled {\n    box-shadow: none;\n    background-color: rgba(57, 75, 89, 0.5);\n    background-image: none;\n    color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-select select:disabled.pt-active, .pt-dark .pt-select select.pt-disabled.pt-active {\n      background: rgba(57, 75, 89, 0.7); }\n  .pt-dark .pt-select select .pt-button-spinner .pt-spinner-head {\n    background: rgba(16, 22, 26, 0.5);\n    stroke: #8a9ba8; }\n\n.pt-select select:disabled {\n  box-shadow: none;\n  background-color: rgba(206, 217, 224, 0.5);\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-select::after {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  line-height: 30px;\n  color: #5c7080;\n  content: \"\\E6C6\";\n  pointer-events: none; }\n  .pt-disabled.pt-select::after {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-editable-text {\n  display: inline-block;\n  position: relative;\n  cursor: text;\n  max-width: 100%;\n  vertical-align: top;\n  white-space: nowrap; }\n  .pt-editable-text::before {\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    bottom: -3px;\n    left: -3px;\n    border-radius: 3px;\n    content: \"\";\n    transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n  .pt-editable-text:hover::before {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n  .pt-editable-text.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n    background-color: #ffffff; }\n  .pt-editable-text.pt-disabled::before {\n    box-shadow: none; }\n  .pt-editable-text.pt-intent-primary .pt-editable-input, .pt-editable-text.pt-intent-primary .pt-editable-content {\n    color: #137cbd; }\n  .pt-editable-text.pt-intent-primary:hover::before {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(19, 124, 189, 0.4); }\n  .pt-editable-text.pt-intent-primary.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-editable-text.pt-intent-success .pt-editable-input, .pt-editable-text.pt-intent-success .pt-editable-content {\n    color: #0f9960; }\n  .pt-editable-text.pt-intent-success:hover::before {\n    box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px rgba(15, 153, 96, 0.4); }\n  .pt-editable-text.pt-intent-success.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-editable-text.pt-intent-warning .pt-editable-input, .pt-editable-text.pt-intent-warning .pt-editable-content {\n    color: #d9822b; }\n  .pt-editable-text.pt-intent-warning:hover::before {\n    box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px rgba(217, 130, 43, 0.4); }\n  .pt-editable-text.pt-intent-warning.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-editable-text.pt-intent-danger .pt-editable-input, .pt-editable-text.pt-intent-danger .pt-editable-content {\n    color: #db3737; }\n  .pt-editable-text.pt-intent-danger:hover::before {\n    box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px rgba(219, 55, 55, 0.4); }\n  .pt-editable-text.pt-intent-danger.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-dark .pt-editable-text:hover::before {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.15); }\n  .pt-dark .pt-editable-text.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n    background-color: rgba(16, 22, 26, 0.3); }\n  .pt-dark .pt-editable-text.pt-disabled::before {\n    box-shadow: none; }\n  .pt-dark .pt-editable-text.pt-intent-primary .pt-editable-content {\n    color: #48aff0; }\n  .pt-dark .pt-editable-text.pt-intent-primary:hover::before {\n    box-shadow: 0 0 0 0 rgba(72, 175, 240, 0), 0 0 0 0 rgba(72, 175, 240, 0), inset 0 0 0 1px rgba(72, 175, 240, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-primary.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #48aff0, 0 0 0 3px rgba(72, 175, 240, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-success .pt-editable-content {\n    color: #3dcc91; }\n  .pt-dark .pt-editable-text.pt-intent-success:hover::before {\n    box-shadow: 0 0 0 0 rgba(61, 204, 145, 0), 0 0 0 0 rgba(61, 204, 145, 0), inset 0 0 0 1px rgba(61, 204, 145, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-success.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #3dcc91, 0 0 0 3px rgba(61, 204, 145, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-warning .pt-editable-content {\n    color: #ffb366; }\n  .pt-dark .pt-editable-text.pt-intent-warning:hover::before {\n    box-shadow: 0 0 0 0 rgba(255, 179, 102, 0), 0 0 0 0 rgba(255, 179, 102, 0), inset 0 0 0 1px rgba(255, 179, 102, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-warning.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #ffb366, 0 0 0 3px rgba(255, 179, 102, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-danger .pt-editable-content {\n    color: #ff7373; }\n  .pt-dark .pt-editable-text.pt-intent-danger:hover::before {\n    box-shadow: 0 0 0 0 rgba(255, 115, 115, 0), 0 0 0 0 rgba(255, 115, 115, 0), inset 0 0 0 1px rgba(255, 115, 115, 0.4); }\n  .pt-dark .pt-editable-text.pt-intent-danger.pt-editable-editing::before {\n    box-shadow: 0 0 0 1px #ff7373, 0 0 0 3px rgba(255, 115, 115, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n\n.pt-editable-input, .pt-editable-content {\n  display: inherit;\n  position: relative;\n  min-width: inherit;\n  max-width: inherit;\n  vertical-align: top;\n  text-transform: inherit;\n  letter-spacing: inherit;\n  color: inherit;\n  font: inherit;\n  resize: none; }\n\n.pt-editable-input {\n  border: none;\n  box-shadow: none;\n  background: none;\n  width: 100%;\n  padding: 0;\n  white-space: pre-wrap; }\n  .pt-editable-input:focus {\n    outline: none; }\n  .pt-editable-input::-ms-clear {\n    display: none; }\n\n.pt-editable-content {\n  overflow: hidden;\n  padding-right: 2px;\n  text-overflow: ellipsis;\n  white-space: pre; }\n  .pt-editable-editing > .pt-editable-content {\n    position: absolute;\n    left: 0;\n    visibility: hidden; }\n  .pt-editable-placeholder > .pt-editable-content {\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-dark .pt-editable-placeholder > .pt-editable-content {\n      color: rgba(191, 204, 214, 0.5); }\n\n.pt-editable-text.pt-multiline {\n  display: block; }\n  .pt-editable-text.pt-multiline .pt-editable-content {\n    overflow: auto;\n    white-space: pre-wrap; }\n\n.pt-select select {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px; }\n  .pt-select select:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-select select:active, .pt-select select.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-select select:disabled, .pt-select select.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-select select:disabled.pt-active, .pt-select select.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n\n.pt-select.pt-minimal select {\n  box-shadow: none;\n  background: none; }\n  .pt-select.pt-minimal select:hover {\n    box-shadow: none;\n    background: rgba(167, 182, 194, 0.3);\n    text-decoration: none;\n    color: #182026; }\n  .pt-select.pt-minimal select:active, .pt-select.pt-minimal select.pt-active {\n    box-shadow: none;\n    background: rgba(115, 134, 148, 0.3);\n    color: #182026; }\n  .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal select.pt-disabled:hover {\n    background: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-select.pt-minimal select, .pt-select.pt-minimal .pt-dark select {\n    box-shadow: none;\n    background: none;\n    color: inherit; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover, .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      box-shadow: none;\n      background: none; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover {\n      background: rgba(138, 155, 168, 0.15); }\n    .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      background: rgba(138, 155, 168, 0.3);\n      color: #f5f8fa; }\n    .pt-dark .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal .pt-dark select:disabled, .pt-dark .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal .pt-dark select:disabled:hover, .pt-dark .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-disabled, .pt-dark .pt-select.pt-minimal select.pt-disabled:hover, .pt-select.pt-minimal .pt-dark select.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-primary {\n    color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover {\n      background: rgba(19, 124, 189, 0.15);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      background: rgba(19, 124, 189, 0.3);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal select.pt-intent-primary.pt-disabled {\n      background: none;\n      color: rgba(16, 107, 163, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n      stroke: #106ba3; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-primary, .pt-select.pt-minimal .pt-dark select.pt-intent-primary {\n      color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.2);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:active, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(72, 175, 240, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-success {\n    color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover {\n      background: rgba(15, 153, 96, 0.15);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      background: rgba(15, 153, 96, 0.3);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal select.pt-intent-success.pt-disabled {\n      background: none;\n      color: rgba(13, 128, 80, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-success .pt-button-spinner .pt-spinner-head {\n      stroke: #0d8050; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-success, .pt-select.pt-minimal .pt-dark select.pt-intent-success {\n      color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.2);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal .pt-dark select.pt-intent-success:active, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(61, 204, 145, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-warning {\n    color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover {\n      background: rgba(217, 130, 43, 0.15);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      background: rgba(217, 130, 43, 0.3);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal select.pt-intent-warning.pt-disabled {\n      background: none;\n      color: rgba(191, 115, 38, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n      stroke: #bf7326; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-warning, .pt-select.pt-minimal .pt-dark select.pt-intent-warning {\n      color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.2);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:active, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(255, 179, 102, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-danger {\n    color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover {\n      background: rgba(219, 55, 55, 0.15);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      background: rgba(219, 55, 55, 0.3);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal select.pt-intent-danger.pt-disabled {\n      background: none;\n      color: rgba(194, 48, 48, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n      stroke: #c23030; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-danger, .pt-select.pt-minimal .pt-dark select.pt-intent-danger {\n      color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.2);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:active, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(255, 115, 115, 0.5); }\n\n.pt-select.pt-large select {\n  height: 40px;\n  padding-right: 35px;\n  font-size: 16px; }\n\n.pt-dark .pt-select select {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  background-color: #394b59;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  color: #f5f8fa; }\n  .pt-dark .pt-select select:hover, .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    color: #f5f8fa; }\n  .pt-dark .pt-select select:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #30404d; }\n  .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #202b33;\n    background-image: none; }\n  .pt-dark .pt-select select:disabled, .pt-dark .pt-select select.pt-disabled {\n    box-shadow: none;\n    background-color: rgba(57, 75, 89, 0.5);\n    background-image: none;\n    color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-select select:disabled.pt-active, .pt-dark .pt-select select.pt-disabled.pt-active {\n      background: rgba(57, 75, 89, 0.7); }\n  .pt-dark .pt-select select .pt-button-spinner .pt-spinner-head {\n    background: rgba(16, 22, 26, 0.5);\n    stroke: #8a9ba8; }\n\n.pt-select select:disabled {\n  box-shadow: none;\n  background-color: rgba(206, 217, 224, 0.5);\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-select::after {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  line-height: 30px;\n  color: #5c7080;\n  content: \"\\E6C6\";\n  pointer-events: none; }\n  .pt-disabled.pt-select::after {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-select select {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px; }\n  .pt-select select:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-select select:active, .pt-select select.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-select select:disabled, .pt-select select.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-select select:disabled.pt-active, .pt-select select.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n\n.pt-select.pt-minimal select {\n  box-shadow: none;\n  background: none; }\n  .pt-select.pt-minimal select:hover {\n    box-shadow: none;\n    background: rgba(167, 182, 194, 0.3);\n    text-decoration: none;\n    color: #182026; }\n  .pt-select.pt-minimal select:active, .pt-select.pt-minimal select.pt-active {\n    box-shadow: none;\n    background: rgba(115, 134, 148, 0.3);\n    color: #182026; }\n  .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal select.pt-disabled:hover {\n    background: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-select.pt-minimal select, .pt-select.pt-minimal .pt-dark select {\n    box-shadow: none;\n    background: none;\n    color: inherit; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover, .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      box-shadow: none;\n      background: none; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover {\n      background: rgba(138, 155, 168, 0.15); }\n    .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      background: rgba(138, 155, 168, 0.3);\n      color: #f5f8fa; }\n    .pt-dark .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal .pt-dark select:disabled, .pt-dark .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal .pt-dark select:disabled:hover, .pt-dark .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-disabled, .pt-dark .pt-select.pt-minimal select.pt-disabled:hover, .pt-select.pt-minimal .pt-dark select.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-primary {\n    color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover {\n      background: rgba(19, 124, 189, 0.15);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      background: rgba(19, 124, 189, 0.3);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal select.pt-intent-primary.pt-disabled {\n      background: none;\n      color: rgba(16, 107, 163, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n      stroke: #106ba3; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-primary, .pt-select.pt-minimal .pt-dark select.pt-intent-primary {\n      color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.2);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:active, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(72, 175, 240, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-success {\n    color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover {\n      background: rgba(15, 153, 96, 0.15);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      background: rgba(15, 153, 96, 0.3);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal select.pt-intent-success.pt-disabled {\n      background: none;\n      color: rgba(13, 128, 80, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-success .pt-button-spinner .pt-spinner-head {\n      stroke: #0d8050; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-success, .pt-select.pt-minimal .pt-dark select.pt-intent-success {\n      color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.2);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal .pt-dark select.pt-intent-success:active, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(61, 204, 145, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-warning {\n    color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover {\n      background: rgba(217, 130, 43, 0.15);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      background: rgba(217, 130, 43, 0.3);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal select.pt-intent-warning.pt-disabled {\n      background: none;\n      color: rgba(191, 115, 38, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n      stroke: #bf7326; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-warning, .pt-select.pt-minimal .pt-dark select.pt-intent-warning {\n      color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.2);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:active, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(255, 179, 102, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-danger {\n    color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover {\n      background: rgba(219, 55, 55, 0.15);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      background: rgba(219, 55, 55, 0.3);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal select.pt-intent-danger.pt-disabled {\n      background: none;\n      color: rgba(194, 48, 48, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n      stroke: #c23030; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-danger, .pt-select.pt-minimal .pt-dark select.pt-intent-danger {\n      color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.2);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:active, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(255, 115, 115, 0.5); }\n\n.pt-select.pt-large select {\n  height: 40px;\n  padding-right: 35px;\n  font-size: 16px; }\n\n.pt-dark .pt-select select {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  background-color: #394b59;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  color: #f5f8fa; }\n  .pt-dark .pt-select select:hover, .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    color: #f5f8fa; }\n  .pt-dark .pt-select select:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #30404d; }\n  .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #202b33;\n    background-image: none; }\n  .pt-dark .pt-select select:disabled, .pt-dark .pt-select select.pt-disabled {\n    box-shadow: none;\n    background-color: rgba(57, 75, 89, 0.5);\n    background-image: none;\n    color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-select select:disabled.pt-active, .pt-dark .pt-select select.pt-disabled.pt-active {\n      background: rgba(57, 75, 89, 0.7); }\n  .pt-dark .pt-select select .pt-button-spinner .pt-spinner-head {\n    background: rgba(16, 22, 26, 0.5);\n    stroke: #8a9ba8; }\n\n.pt-select select:disabled {\n  box-shadow: none;\n  background-color: rgba(206, 217, 224, 0.5);\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-select::after {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  line-height: 30px;\n  color: #5c7080;\n  content: \"\\E6C6\";\n  pointer-events: none; }\n  .pt-disabled.pt-select::after {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-control-group {\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  \n   }\n  .pt-control-group > * {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto; }\n  .pt-control-group .pt-button, .pt-control-group .pt-input, .pt-control-group .pt-select {\n    position: relative; }\n  .pt-control-group .pt-input {\n    z-index: 2;\n    border-radius: inherit; }\n    .pt-control-group .pt-input:focus {\n      z-index: 14;\n      border-radius: 3px; }\n    .pt-control-group .pt-input[class*=\"pt-intent\"] {\n      z-index: 13; }\n      .pt-control-group .pt-input[class*=\"pt-intent\"]:focus {\n        z-index: 15; }\n    .pt-control-group .pt-input[readonly], .pt-control-group .pt-input:disabled, .pt-control-group .pt-input.pt-disabled {\n      z-index: 1; }\n  .pt-control-group .pt-input-group[class*=\"pt-intent\"] .pt-input {\n    z-index: 13; }\n    .pt-control-group .pt-input-group[class*=\"pt-intent\"] .pt-input:focus {\n      z-index: 15; }\n  .pt-control-group .pt-button, .pt-control-group .pt-select select {\n    z-index: 4;\n    border-radius: inherit; }\n    .pt-control-group .pt-button:focus, .pt-control-group .pt-select select:focus {\n      position: relative;\n      z-index: 5; }\n    .pt-control-group .pt-button:hover, .pt-control-group .pt-select select:hover {\n      z-index: 6; }\n    .pt-control-group .pt-button:active, .pt-control-group .pt-select select:active {\n      z-index: 7; }\n    .pt-control-group .pt-button[readonly], .pt-control-group .pt-button:disabled, .pt-control-group .pt-button.pt-disabled, .pt-control-group .pt-select select[readonly], .pt-control-group .pt-select select:disabled, .pt-control-group .pt-select select.pt-disabled {\n      z-index: 3; }\n    .pt-control-group .pt-button[class*=\"pt-intent\"], .pt-control-group .pt-select select[class*=\"pt-intent\"] {\n      z-index: 9; }\n      .pt-control-group .pt-button[class*=\"pt-intent\"]:focus, .pt-control-group .pt-select select[class*=\"pt-intent\"]:focus {\n        z-index: 10; }\n      .pt-control-group .pt-button[class*=\"pt-intent\"]:hover, .pt-control-group .pt-select select[class*=\"pt-intent\"]:hover {\n        z-index: 11; }\n      .pt-control-group .pt-button[class*=\"pt-intent\"]:active, .pt-control-group .pt-select select[class*=\"pt-intent\"]:active {\n        z-index: 12; }\n      .pt-control-group .pt-button[class*=\"pt-intent\"][readonly], .pt-control-group .pt-button[class*=\"pt-intent\"]:disabled, .pt-control-group .pt-button[class*=\"pt-intent\"].pt-disabled, .pt-control-group .pt-select select[class*=\"pt-intent\"][readonly], .pt-control-group .pt-select select[class*=\"pt-intent\"]:disabled, .pt-control-group .pt-select select[class*=\"pt-intent\"].pt-disabled {\n        z-index: 8; }\n  .pt-control-group .pt-input-group > .pt-icon, .pt-control-group .pt-input-group > .pt-button, .pt-control-group .pt-input-group > .pt-input-action {\n    z-index: 16; }\n  .pt-control-group .pt-select::after {\n    z-index: 17; }\n  .pt-control-group:not(.pt-vertical) > * {\n    margin-right: -1px; }\n  .pt-dark .pt-control-group:not(.pt-vertical) > * {\n    margin-right: 0; }\n  .pt-dark .pt-control-group:not(.pt-vertical) > .pt-button + .pt-button {\n    margin-left: 1px; }\n  .pt-control-group > :first-child {\n    border-radius: 3px 0 0 3px; }\n  .pt-control-group > :last-child {\n    margin-right: 0;\n    border-radius: 0 3px 3px 0; }\n  .pt-control-group .pt-input-group .pt-button {\n    border-radius: 3px; }\n  .pt-control-group > .pt-fill {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; }\n  .pt-control-group.pt-fill > *:not(.pt-fixed) {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; }\n  .pt-control-group.pt-vertical {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n    .pt-control-group.pt-vertical > * {\n      margin-top: -1px;\n      width: 100%; }\n    .pt-control-group.pt-vertical > :first-child {\n      margin-top: 0;\n      border-radius: 3px 3px 0 0; }\n    .pt-control-group.pt-vertical > :last-child {\n      border-radius: 0 0 3px 3px; }\n\n.pt-control {\n  display: block;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  min-height: 16px;\n  padding-left: 26px;\n  text-transform: none;\n  line-height: 16px;\n  \n  \n  \n   }\n  .pt-control.pt-disabled {\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-control.pt-inline {\n    display: inline-block;\n    margin-right: 20px; }\n  .pt-control input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    z-index: -1; }\n  .pt-control .pt-control-indicator {\n    line-height: 1;\n    font-family: \"Icons16\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: 0;\n    border: none;\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #f5f8fa;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n    .pt-control .pt-control-indicator::before {\n      position: relative;\n      content: \"\"; }\n  .pt-control input:checked ~ .pt-control-indicator, .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #137cbd;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    color: #ffffff; }\n  .pt-control:hover .pt-control-indicator {\n    background-color: #ebf1f5; }\n  .pt-control:hover input:checked ~ .pt-control-indicator, .pt-control:hover .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control:hover input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox:hover input:indeterminate ~ .pt-control-indicator {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 -1px 0 rgba(16, 22, 26, 0.2);\n    background-color: #106ba3; }\n  .pt-control input:not(:disabled):active ~ .pt-control-indicator {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background: #d8e1e8; }\n  .pt-control input:not(:disabled):active:checked ~ .pt-control-indicator, .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background: #0e5a8a; }\n  .pt-control input:focus ~ .pt-control-indicator {\n    outline: rgba(19, 124, 189, 0.5) auto 2px;\n    outline-offset: 2px;\n    -moz-outline-radius: 6px; }\n  .pt-control input:disabled ~ .pt-control-indicator {\n    box-shadow: none;\n    background: rgba(206, 217, 224, 0.5);\n    cursor: not-allowed; }\n  .pt-control input:disabled:checked ~ .pt-control-indicator, .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator {\n    box-shadow: none;\n    background: rgba(19, 124, 189, 0.5); }\n  .pt-control.pt-checkbox .pt-control-indicator {\n    border-radius: 3px;\n    font-size: 16px; }\n  .pt-control.pt-checkbox input:checked ~ .pt-control-indicator::before, .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before {\n    content: \"\\E6D8\"; }\n  .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before {\n    content: \"\\E70E\"; }\n  .pt-control.pt-radio .pt-control-indicator {\n    border-radius: 50%;\n    font-size: 6px; }\n  .pt-control.pt-radio input:checked ~ .pt-control-indicator::before, .pt-control.pt-radio .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-control.pt-radio input:indeterminate ~ .pt-control-indicator::before {\n    display: inline-block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    border-radius: 50%;\n    background: #ffffff;\n    width: 1em;\n    height: 1em;\n    content: \"\"; }\n  .pt-control.pt-radio input:checked:disabled ~ .pt-control-indicator::before, .pt-control.pt-radio .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-control.pt-radio input:disabled:indeterminate ~ .pt-control-indicator::before {\n    box-shadow: none; }\n  .pt-control.pt-radio input:focus ~ .pt-control-indicator {\n    -moz-outline-radius: 16px; }\n  .pt-control.pt-switch {\n    padding-left: 38px; }\n    .pt-control.pt-switch .pt-control-indicator {\n      border: none;\n      border-radius: 28px;\n      box-shadow: none;\n      background: rgba(167, 182, 194, 0.5);\n      width: 28px;\n      height: 16px;\n      transition: background 100ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n      .pt-control.pt-switch .pt-control-indicator::before {\n        display: block;\n        top: 2px;\n        left: 2px;\n        border-radius: 16px;\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n        background: #ffffff;\n        background-clip: padding-box;\n        width: 12px;\n        height: 12px;\n        content: \"\";\n        transition: left 100ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n    .pt-control.pt-switch input:checked ~ .pt-control-indicator, .pt-control.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control.pt-switch input:indeterminate ~ .pt-control-indicator {\n      box-shadow: none;\n      background-color: #137cbd;\n      width: 28px;\n      height: 16px; }\n      .pt-control.pt-switch input:checked ~ .pt-control-indicator::before, .pt-control.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-control.pt-switch input:indeterminate ~ .pt-control-indicator::before {\n        left: 14px;\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-control.pt-switch:hover .pt-control-indicator {\n      background-color: rgba(115, 134, 148, 0.5); }\n    .pt-control.pt-switch:hover input:checked ~ .pt-control-indicator, .pt-control.pt-switch:hover .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control.pt-switch:hover input:indeterminate ~ .pt-control-indicator {\n      background-color: #106ba3; }\n    .pt-control.pt-switch input:not(:disabled):active ~ .pt-control-indicator {\n      box-shadow: none;\n      background-color: rgba(92, 112, 128, 0.5); }\n    .pt-control.pt-switch input:not(:disabled):active:checked ~ .pt-control-indicator, .pt-control.pt-switch .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control.pt-switch input:not(:disabled):active:indeterminate ~ .pt-control-indicator {\n      background-color: #0e5a8a; }\n      .pt-control.pt-switch input:not(:disabled):active:checked ~ .pt-control-indicator::before, .pt-control.pt-switch .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-control.pt-switch input:not(:disabled):active:indeterminate ~ .pt-control-indicator::before {\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-control.pt-switch input:disabled ~ .pt-control-indicator {\n      background-color: rgba(206, 217, 224, 0.5); }\n      .pt-control.pt-switch input:disabled ~ .pt-control-indicator::before {\n        box-shadow: none;\n        background-color: rgba(255, 255, 255, 0.8); }\n    .pt-control.pt-switch input:disabled:checked ~ .pt-control-indicator, .pt-control.pt-switch .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control.pt-switch input:disabled:indeterminate ~ .pt-control-indicator {\n      background-color: rgba(19, 124, 189, 0.5); }\n  .pt-control.pt-align-right {\n    padding-right: 26px;\n    padding-left: 0; }\n    .pt-control.pt-align-right .pt-control-indicator {\n      right: 0;\n      left: auto; }\n  .pt-control.pt-large {\n    min-height: 20px;\n    padding-left: 30px;\n    line-height: 20px;\n    font-size: 16px; }\n    .pt-control.pt-large .pt-control-indicator {\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n      font-family: \"Icons20\";\n      font-size: 20px; }\n    .pt-control.pt-large.pt-checkbox input:checked ~ .pt-control-indicator::before, .pt-control.pt-large.pt-checkbox input:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-large.pt-checkbox\n    .pt-control.pt-checkbox:hover input:indeterminate ~ .pt-control-indicator::before {\n      top: 1px; }\n    .pt-control.pt-large.pt-radio .pt-control-indicator {\n      font-size: 8px; }\n    .pt-control.pt-large.pt-switch {\n      padding-left: 42px; }\n      .pt-control.pt-large.pt-switch .pt-control-indicator {\n        width: 32px;\n        height: 20px; }\n        .pt-control.pt-large.pt-switch .pt-control-indicator::before {\n          width: 16px;\n          height: 16px; }\n      .pt-control.pt-large.pt-switch input:checked ~ .pt-control-indicator, .pt-control.pt-large.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-control.pt-large.pt-switch input:indeterminate ~ .pt-control-indicator {\n        width: 32px;\n        height: 20px; }\n        .pt-control.pt-large.pt-switch input:checked ~ .pt-control-indicator::before, .pt-control.pt-large.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-control.pt-large.pt-switch input:indeterminate ~ .pt-control-indicator::before {\n          left: 14px; }\n  .pt-dark .pt-control {\n    color: #f5f8fa; }\n    .pt-dark .pt-control.pt-disabled {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-control .pt-control-indicator {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n      background-color: #394b59;\n      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0)); }\n    .pt-dark .pt-control input:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-control:hover .pt-control-indicator {\n      background-color: #30404d; }\n    .pt-dark .pt-control input:not(:disabled):active ~ .pt-control-indicator {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background: #202b33; }\n    .pt-dark .pt-control input:not(:disabled):active:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #0e5a8a; }\n    .pt-dark .pt-control input:disabled ~ .pt-control-indicator {\n      box-shadow: none;\n      background: rgba(57, 75, 89, 0.5);\n      cursor: not-allowed; }\n    .pt-dark .pt-control input:disabled:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator {\n      box-shadow: none;\n      background: rgba(14, 90, 138, 0.5); }\n    .pt-dark .pt-control.pt-checkbox input:checked:disabled ~ .pt-control-indicator::before, .pt-dark .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator::before {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-control.pt-radio input:checked:disabled ~ .pt-control-indicator::before, .pt-dark .pt-control.pt-radio .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-dark .pt-control.pt-radio input:disabled:indeterminate ~ .pt-control-indicator::before {\n      background: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-control.pt-switch .pt-control-indicator {\n      box-shadow: none;\n      background: rgba(16, 22, 26, 0.5); }\n      .pt-dark .pt-control.pt-switch .pt-control-indicator::before {\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n        background: #30404d; }\n    .pt-dark .pt-control.pt-switch input:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch input:indeterminate ~ .pt-control-indicator {\n      box-shadow: none;\n      background-color: #137cbd; }\n      .pt-dark .pt-control.pt-switch input:checked ~ .pt-control-indicator::before, .pt-dark .pt-control.pt-switch .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch input:indeterminate ~ .pt-control-indicator::before {\n        box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-control.pt-switch:hover .pt-control-indicator {\n      background: rgba(16, 22, 26, 0.7); }\n    .pt-dark .pt-control.pt-switch:hover input:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-switch:hover .pt-control.pt-checkbox input:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch:hover input:indeterminate ~ .pt-control-indicator {\n      background: #2b95d6; }\n    .pt-dark .pt-control.pt-switch input:not(:disabled):active ~ .pt-control-indicator {\n      box-shadow: none;\n      background: rgba(16, 22, 26, 0.9); }\n      .pt-dark .pt-control.pt-switch input:not(:disabled):active ~ .pt-control-indicator::before {\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-control.pt-switch input:not(:disabled):active:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-switch .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch input:not(:disabled):active:indeterminate ~ .pt-control-indicator {\n      background: #48aff0; }\n      .pt-dark .pt-control.pt-switch input:not(:disabled):active:checked ~ .pt-control-indicator::before, .pt-dark .pt-control.pt-switch .pt-control.pt-checkbox input:not(:disabled):active:indeterminate ~ .pt-control-indicator::before, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch input:not(:disabled):active:indeterminate ~ .pt-control-indicator::before {\n        box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-control.pt-switch input:disabled ~ .pt-control-indicator {\n      background: rgba(57, 75, 89, 0.5); }\n      .pt-dark .pt-control.pt-switch input:disabled ~ .pt-control-indicator::before {\n        box-shadow: none;\n        background: rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-control.pt-switch input:disabled:checked ~ .pt-control-indicator, .pt-dark .pt-control.pt-switch .pt-control.pt-checkbox input:disabled:indeterminate ~ .pt-control-indicator, .pt-control.pt-checkbox .pt-dark .pt-control.pt-switch input:disabled:indeterminate ~ .pt-control-indicator {\n      background: rgba(14, 90, 138, 0.5); }\n\n.pt-file-upload {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  height: 30px; }\n  .pt-file-upload input {\n    opacity: 0;\n    margin: 0;\n    min-width: 200px; }\n    .pt-file-upload input:disabled + .pt-file-upload-input, .pt-file-upload input.pt-disabled + .pt-file-upload-input {\n      box-shadow: none;\n      background: rgba(206, 217, 224, 0.5);\n      cursor: not-allowed;\n      color: rgba(92, 112, 128, 0.5);\n      resize: none; }\n      .pt-file-upload input:disabled + .pt-file-upload-input::after, .pt-file-upload input.pt-disabled + .pt-file-upload-input::after {\n        outline: none;\n        box-shadow: none;\n        background-color: rgba(206, 217, 224, 0.5);\n        background-image: none;\n        cursor: not-allowed;\n        color: rgba(92, 112, 128, 0.5); }\n        .pt-file-upload input:disabled + .pt-file-upload-input::after.pt-active, .pt-file-upload input.pt-disabled + .pt-file-upload-input::after.pt-active {\n          background: rgba(206, 217, 224, 0.7); }\n      .pt-dark .pt-file-upload input:disabled + .pt-file-upload-input, .pt-dark\n      .pt-file-upload input.pt-disabled + .pt-file-upload-input {\n        box-shadow: none;\n        background: rgba(57, 75, 89, 0.5);\n        color: rgba(191, 204, 214, 0.5); }\n        .pt-dark .pt-file-upload input:disabled + .pt-file-upload-input::after, .pt-dark\n        .pt-file-upload input.pt-disabled + .pt-file-upload-input::after {\n          box-shadow: none;\n          background-color: rgba(57, 75, 89, 0.5);\n          background-image: none;\n          color: rgba(191, 204, 214, 0.5); }\n          .pt-dark .pt-file-upload input:disabled + .pt-file-upload-input::after.pt-active, .pt-dark\n          .pt-file-upload input.pt-disabled + .pt-file-upload-input::after.pt-active {\n            background: rgba(57, 75, 89, 0.7); }\n  .pt-file-upload.pt-fill {\n    width: 100%; }\n\n.pt-file-upload-input {\n  outline: none;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  background: #ffffff;\n  height: 30px;\n  padding: 0 10px;\n  vertical-align: middle;\n  line-height: 30px;\n  color: #182026;\n  font-size: 14px;\n  font-weight: 400;\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  margin-right: 70px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  height: 30px;\n  line-height: 30px;\n  color: #5c7080;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-file-upload-input::-webkit-input-placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-file-upload-input:-ms-input-placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-file-upload-input::placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-file-upload-input:focus, .pt-file-upload-input.pt-active {\n    box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-file-upload-input[type=\"search\"], .pt-file-upload-input.pt-round {\n    border-radius: 30px;\n    box-sizing: border-box;\n    padding-left: 10px; }\n  .pt-file-upload-input[readonly] {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n  .pt-file-upload-input:disabled, .pt-file-upload-input.pt-disabled {\n    box-shadow: none;\n    background: rgba(206, 217, 224, 0.5);\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5);\n    resize: none; }\n  .pt-file-upload-input::after {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-color: #f5f8fa;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n    color: #182026;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 100%;\n    margin-left: -1px;\n    border-radius: 3px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    width: 70px;\n    height: 30px;\n    padding: 0 10px;\n    text-align: center;\n    line-height: 30px;\n    content: \"Browse\"; }\n    .pt-file-upload-input::after:hover {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n      background-clip: padding-box;\n      background-color: #ebf1f5; }\n    .pt-file-upload-input::after:active, .pt-file-upload-input::after.pt-active {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #d8e1e8;\n      background-image: none; }\n    .pt-file-upload-input::after:disabled, .pt-file-upload-input::after.pt-disabled {\n      outline: none;\n      box-shadow: none;\n      background-color: rgba(206, 217, 224, 0.5);\n      background-image: none;\n      cursor: not-allowed;\n      color: rgba(92, 112, 128, 0.5); }\n      .pt-file-upload-input::after:disabled.pt-active, .pt-file-upload-input::after.pt-disabled.pt-active {\n        background: rgba(206, 217, 224, 0.7); }\n  .pt-file-upload-input:hover::after {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-file-upload-input:active::after {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-large .pt-file-upload-input {\n    margin-right: 85px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 16px; }\n    .pt-large .pt-file-upload-input::after {\n      width: 85px;\n      height: 40px;\n      padding: 0 15px;\n      line-height: 40px;\n      font-size: 16px; }\n  .pt-dark .pt-file-upload-input {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n    background: rgba(16, 22, 26, 0.3);\n    color: #f5f8fa;\n    color: #bfccd6; }\n    .pt-dark .pt-file-upload-input::-webkit-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-file-upload-input:-ms-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-file-upload-input::placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-file-upload-input:focus {\n      box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-file-upload-input[readonly] {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-file-upload-input:disabled, .pt-dark .pt-file-upload-input.pt-disabled {\n      box-shadow: none;\n      background: rgba(57, 75, 89, 0.5);\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-file-upload-input::after {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n      background-color: #394b59;\n      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n      color: #f5f8fa; }\n      .pt-dark .pt-file-upload-input::after:hover, .pt-dark .pt-file-upload-input::after:active, .pt-dark .pt-file-upload-input::after.pt-active {\n        color: #f5f8fa; }\n      .pt-dark .pt-file-upload-input::after:hover {\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n        background-color: #30404d; }\n      .pt-dark .pt-file-upload-input::after:active, .pt-dark .pt-file-upload-input::after.pt-active {\n        box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n        background-color: #202b33;\n        background-image: none; }\n      .pt-dark .pt-file-upload-input::after:disabled, .pt-dark .pt-file-upload-input::after.pt-disabled {\n        box-shadow: none;\n        background-color: rgba(57, 75, 89, 0.5);\n        background-image: none;\n        color: rgba(191, 204, 214, 0.5); }\n        .pt-dark .pt-file-upload-input::after:disabled.pt-active, .pt-dark .pt-file-upload-input::after.pt-disabled.pt-active {\n          background: rgba(57, 75, 89, 0.7); }\n      .pt-dark .pt-file-upload-input::after .pt-button-spinner .pt-spinner-head {\n        background: rgba(16, 22, 26, 0.5);\n        stroke: #8a9ba8; }\n    .pt-dark .pt-file-upload-input:hover::after {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n      background-color: #30404d; }\n    .pt-dark .pt-file-upload-input:active::after {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #202b33;\n      background-image: none; }\n\n.pt-form-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0 0 15px; }\n  .pt-form-group label.pt-label {\n    margin-bottom: 5px; }\n  .pt-form-group .pt-control {\n    margin-top: 5px; }\n  .pt-form-group .pt-form-helper-text {\n    margin-top: 5px;\n    color: #5c7080;\n    font-size: 12px; }\n  .pt-form-group.pt-intent-primary .pt-form-helper-text {\n    color: #106ba3; }\n  .pt-form-group.pt-intent-success .pt-form-helper-text {\n    color: #0d8050; }\n  .pt-form-group.pt-intent-warning .pt-form-helper-text {\n    color: #bf7326; }\n  .pt-form-group.pt-intent-danger .pt-form-helper-text {\n    color: #c23030; }\n  .pt-form-group.pt-inline {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline; }\n    .pt-form-group.pt-inline.pt-large label.pt-label {\n      margin: 0 10px 0 0;\n      line-height: 40px; }\n    .pt-form-group.pt-inline label.pt-label {\n      margin: 0 10px 0 0;\n      line-height: 30px; }\n  .pt-form-group.pt-disabled .pt-label, .pt-form-group.pt-disabled .pt-text-muted, .pt-form-group.pt-disabled .pt-form-helper-text {\n    color: rgba(92, 112, 128, 0.5) !important; }\n  .pt-dark .pt-form-group.pt-intent-primary .pt-form-helper-text {\n    color: #48aff0; }\n  .pt-dark .pt-form-group.pt-intent-success .pt-form-helper-text {\n    color: #3dcc91; }\n  .pt-dark .pt-form-group.pt-intent-warning .pt-form-helper-text {\n    color: #ffb366; }\n  .pt-dark .pt-form-group.pt-intent-danger .pt-form-helper-text {\n    color: #ff7373; }\n  .pt-dark .pt-form-group .pt-form-helper-text {\n    color: #bfccd6; }\n  .pt-dark .pt-form-group.pt-disabled .pt-label, .pt-dark .pt-form-group.pt-disabled .pt-text-muted, .pt-dark .pt-form-group.pt-disabled .pt-form-helper-text {\n    color: rgba(191, 204, 214, 0.5) !important; }\n\n.pt-input-group {\n  display: block;\n  position: relative; }\n  .pt-input-group .pt-input {\n    position: relative;\n    width: 100%; }\n    .pt-input-group .pt-input:not(:first-child) {\n      padding-left: 30px; }\n    .pt-input-group .pt-input:not(:last-child) {\n      padding-right: 30px; }\n  .pt-input-group .pt-input-action, .pt-input-group > .pt-button, .pt-input-group > .pt-icon {\n    position: absolute;\n    top: 0; }\n    .pt-input-group .pt-input-action:first-child, .pt-input-group > .pt-button:first-child, .pt-input-group > .pt-icon:first-child {\n      left: 0; }\n    .pt-input-group .pt-input-action:last-child, .pt-input-group > .pt-button:last-child, .pt-input-group > .pt-icon:last-child {\n      right: 0; }\n  .pt-input-group .pt-button {\n    min-width: 24px;\n    min-height: 24px;\n    line-height: 24px;\n    margin: 3px;\n    padding-top: 0;\n    padding-bottom: 0; }\n  .pt-input-group .pt-icon {\n    line-height: 1;\n    font-family: \"Icons16\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    z-index: 1;\n    margin: 0 7px;\n    line-height: 30px;\n    color: #5c7080; }\n  .pt-input-group .pt-spinner {\n    margin: 3px; }\n  .pt-input-group .pt-tag {\n    margin: 5px; }\n  .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:not(:hover):not(:focus), .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:not(:hover):not(:focus) {\n    color: #5c7080; }\n    .pt-dark .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:not(:hover):not(:focus), .pt-dark\n    .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:not(:hover):not(:focus) {\n      color: #bfccd6; }\n    .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon, .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon-standard, .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon-large, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon-standard, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:not(:hover):not(:focus) .pt-icon-large {\n      color: #5c7080; }\n  .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:disabled, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:disabled {\n    color: rgba(92, 112, 128, 0.5) !important; }\n    .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:disabled .pt-icon, .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:disabled .pt-icon-standard, .pt-input-group .pt-input:not(:focus) + .pt-button.pt-minimal:disabled .pt-icon-large, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:disabled .pt-icon, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:disabled .pt-icon-standard, .pt-input-group .pt-input:not(:focus) + .pt-input-action .pt-button.pt-minimal:disabled .pt-icon-large {\n      color: rgba(92, 112, 128, 0.5) !important; }\n  .pt-input-group.pt-disabled {\n    cursor: not-allowed; }\n    .pt-input-group.pt-disabled .pt-icon {\n      color: rgba(92, 112, 128, 0.5); }\n  .pt-input-group.pt-large .pt-button {\n    min-width: 30px;\n    min-height: 30px;\n    line-height: 30px;\n    margin: 5px;\n    line-height: 0; }\n  .pt-input-group.pt-large .pt-icon {\n    margin: 0 12px;\n    line-height: 40px; }\n  .pt-input-group.pt-large .pt-input {\n    height: 40px;\n    line-height: 40px;\n    font-size: 16px; }\n    .pt-input-group.pt-large .pt-input[type=\"search\"], .pt-input-group.pt-large .pt-input.pt-round {\n      padding: 0 15px; }\n    .pt-input-group.pt-large .pt-input:not(:first-child) {\n      padding-left: 40px; }\n    .pt-input-group.pt-large .pt-input:not(:last-child) {\n      padding-right: 40px; }\n  .pt-input-group.pt-large .pt-spinner {\n    margin: 8px; }\n  .pt-input-group.pt-round .pt-button, .pt-input-group.pt-round .pt-input, .pt-input-group.pt-round .pt-tag {\n    border-radius: 30px; }\n  .pt-dark .pt-input-group .pt-icon {\n    color: #bfccd6; }\n  .pt-dark .pt-input-group.pt-disabled .pt-icon {\n    color: rgba(191, 204, 214, 0.5); }\n  .pt-input-group.pt-intent-primary .pt-input {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-primary .pt-input:focus {\n      box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-primary .pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px #137cbd; }\n    .pt-input-group.pt-intent-primary .pt-input:disabled, .pt-input-group.pt-intent-primary .pt-input.pt-disabled {\n      box-shadow: none; }\n  .pt-input-group.pt-intent-primary .pt-icon {\n    color: #106ba3; }\n    .pt-dark .pt-input-group.pt-intent-primary .pt-icon {\n      color: #48aff0; }\n  .pt-input-group.pt-intent-success .pt-input {\n    box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-success .pt-input:focus {\n      box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-success .pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px #0f9960; }\n    .pt-input-group.pt-intent-success .pt-input:disabled, .pt-input-group.pt-intent-success .pt-input.pt-disabled {\n      box-shadow: none; }\n  .pt-input-group.pt-intent-success .pt-icon {\n    color: #0d8050; }\n    .pt-dark .pt-input-group.pt-intent-success .pt-icon {\n      color: #3dcc91; }\n  .pt-input-group.pt-intent-warning .pt-input {\n    box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-warning .pt-input:focus {\n      box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-warning .pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px #d9822b; }\n    .pt-input-group.pt-intent-warning .pt-input:disabled, .pt-input-group.pt-intent-warning .pt-input.pt-disabled {\n      box-shadow: none; }\n  .pt-input-group.pt-intent-warning .pt-icon {\n    color: #bf7326; }\n    .pt-dark .pt-input-group.pt-intent-warning .pt-icon {\n      color: #ffb366; }\n  .pt-input-group.pt-intent-danger .pt-input {\n    box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-danger .pt-input:focus {\n      box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input-group.pt-intent-danger .pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px #db3737; }\n    .pt-input-group.pt-intent-danger .pt-input:disabled, .pt-input-group.pt-intent-danger .pt-input.pt-disabled {\n      box-shadow: none; }\n  .pt-input-group.pt-intent-danger .pt-icon {\n    color: #c23030; }\n    .pt-dark .pt-input-group.pt-intent-danger .pt-icon {\n      color: #ff7373; }\n\n.pt-input {\n  outline: none;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2);\n  background: #ffffff;\n  height: 30px;\n  padding: 0 10px;\n  vertical-align: middle;\n  line-height: 30px;\n  color: #182026;\n  font-size: 14px;\n  font-weight: 400;\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none; }\n  .pt-input::-webkit-input-placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-input:-ms-input-placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-input::placeholder {\n    opacity: 1;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-input:focus, .pt-input.pt-active {\n    box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n  .pt-input[type=\"search\"], .pt-input.pt-round {\n    border-radius: 30px;\n    box-sizing: border-box;\n    padding-left: 10px; }\n  .pt-input[readonly] {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.15); }\n  .pt-input:disabled, .pt-input.pt-disabled {\n    box-shadow: none;\n    background: rgba(206, 217, 224, 0.5);\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5);\n    resize: none; }\n  .pt-input.pt-large {\n    height: 40px;\n    line-height: 40px;\n    font-size: 16px; }\n    .pt-input.pt-large[type=\"search\"], .pt-input.pt-large.pt-round {\n      padding: 0 15px; }\n  .pt-input.pt-fill {\n    width: 100%; }\n  .pt-dark .pt-input {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n    background: rgba(16, 22, 26, 0.3);\n    color: #f5f8fa; }\n    .pt-dark .pt-input::-webkit-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-input:-ms-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-input::placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-input:focus {\n      box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark .pt-input:disabled, .pt-dark .pt-input.pt-disabled {\n      box-shadow: none;\n      background: rgba(57, 75, 89, 0.5);\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-input.pt-intent-primary {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-primary:focus {\n      box-shadow: 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-primary[readonly] {\n      box-shadow: inset 0 0 0 1px #137cbd; }\n    .pt-input.pt-intent-primary:disabled, .pt-input.pt-intent-primary.pt-disabled {\n      box-shadow: none; }\n    .pt-dark .pt-input.pt-intent-primary {\n      box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px #137cbd, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-primary:focus {\n        box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-primary[readonly] {\n        box-shadow: inset 0 0 0 1px #137cbd; }\n      .pt-dark .pt-input.pt-intent-primary:disabled, .pt-dark .pt-input.pt-intent-primary.pt-disabled {\n        box-shadow: none; }\n  .pt-input.pt-intent-success {\n    box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-success:focus {\n      box-shadow: 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-success[readonly] {\n      box-shadow: inset 0 0 0 1px #0f9960; }\n    .pt-input.pt-intent-success:disabled, .pt-input.pt-intent-success.pt-disabled {\n      box-shadow: none; }\n    .pt-dark .pt-input.pt-intent-success {\n      box-shadow: 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), 0 0 0 0 rgba(15, 153, 96, 0), inset 0 0 0 1px #0f9960, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-success:focus {\n        box-shadow: 0 0 0 1px #0f9960, 0 0 0 1px #0f9960, 0 0 0 3px rgba(15, 153, 96, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-success[readonly] {\n        box-shadow: inset 0 0 0 1px #0f9960; }\n      .pt-dark .pt-input.pt-intent-success:disabled, .pt-dark .pt-input.pt-intent-success.pt-disabled {\n        box-shadow: none; }\n  .pt-input.pt-intent-warning {\n    box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-warning:focus {\n      box-shadow: 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-warning[readonly] {\n      box-shadow: inset 0 0 0 1px #d9822b; }\n    .pt-input.pt-intent-warning:disabled, .pt-input.pt-intent-warning.pt-disabled {\n      box-shadow: none; }\n    .pt-dark .pt-input.pt-intent-warning {\n      box-shadow: 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), 0 0 0 0 rgba(217, 130, 43, 0), inset 0 0 0 1px #d9822b, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-warning:focus {\n        box-shadow: 0 0 0 1px #d9822b, 0 0 0 1px #d9822b, 0 0 0 3px rgba(217, 130, 43, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-warning[readonly] {\n        box-shadow: inset 0 0 0 1px #d9822b; }\n      .pt-dark .pt-input.pt-intent-warning:disabled, .pt-dark .pt-input.pt-intent-warning.pt-disabled {\n        box-shadow: none; }\n  .pt-input.pt-intent-danger {\n    box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-danger:focus {\n      box-shadow: 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.2); }\n    .pt-input.pt-intent-danger[readonly] {\n      box-shadow: inset 0 0 0 1px #db3737; }\n    .pt-input.pt-intent-danger:disabled, .pt-input.pt-intent-danger.pt-disabled {\n      box-shadow: none; }\n    .pt-dark .pt-input.pt-intent-danger {\n      box-shadow: 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), 0 0 0 0 rgba(219, 55, 55, 0), inset 0 0 0 1px #db3737, inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-danger:focus {\n        box-shadow: 0 0 0 1px #db3737, 0 0 0 1px #db3737, 0 0 0 3px rgba(219, 55, 55, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n      .pt-dark .pt-input.pt-intent-danger[readonly] {\n        box-shadow: inset 0 0 0 1px #db3737; }\n      .pt-dark .pt-input.pt-intent-danger:disabled, .pt-dark .pt-input.pt-intent-danger.pt-disabled {\n        box-shadow: none; }\n  .pt-input::-ms-clear {\n    display: none; }\n\ntextarea.pt-input {\n  max-width: 100%;\n  height: auto;\n  padding: 10px;\n  line-height: 1.28581; }\n  textarea.pt-input.pt-large {\n    line-height: 1.28581;\n    font-size: 16px; }\n  .pt-dark textarea.pt-input {\n    box-shadow: 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), 0 0 0 0 rgba(19, 124, 189, 0), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4);\n    background: rgba(16, 22, 26, 0.3);\n    color: #f5f8fa; }\n    .pt-dark textarea.pt-input::-webkit-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark textarea.pt-input:-ms-input-placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark textarea.pt-input::placeholder {\n      color: rgba(191, 204, 214, 0.5); }\n    .pt-dark textarea.pt-input:focus {\n      box-shadow: 0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19, 124, 189, 0.3), inset 0 0 0 1px rgba(16, 22, 26, 0.3), inset 0 1px 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark textarea.pt-input[readonly] {\n      box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4); }\n    .pt-dark textarea.pt-input:disabled, .pt-dark textarea.pt-input.pt-disabled {\n      box-shadow: none;\n      background: rgba(57, 75, 89, 0.5);\n      color: rgba(191, 204, 214, 0.5); }\n\nlabel.pt-label {\n  display: block;\n  margin: 0 0 15px;\n   }\n  label.pt-label .pt-input, label.pt-label .pt-select {\n    display: block;\n    margin-top: 5px;\n    text-transform: none; }\n  label.pt-label .pt-select select {\n    width: 100%;\n    vertical-align: top;\n    font-weight: 400; }\n  label.pt-label.pt-inline {\n    line-height: 30px; }\n    label.pt-label.pt-inline .pt-input, label.pt-label.pt-inline .pt-input-group, label.pt-label.pt-inline .pt-select {\n      display: inline-block;\n      margin: 0 0 0 5px;\n      vertical-align: top; }\n    label.pt-label.pt-inline .pt-input-group .pt-input {\n      margin-left: 0; }\n    label.pt-label.pt-inline.pt-large {\n      line-height: 40px; }\n  label.pt-label.pt-disabled, label.pt-label.pt-disabled .pt-text-muted {\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark label.pt-label {\n    color: #f5f8fa; }\n    .pt-dark label.pt-label.pt-disabled, .pt-dark label.pt-label.pt-disabled .pt-text-muted {\n      color: rgba(191, 204, 214, 0.5); }\n\n.pt-select {\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  letter-spacing: normal; }\n  .pt-select select::-ms-expand {\n    display: none; }\n  .pt-select.pt-large::after {\n    top: 0;\n    right: 12px;\n    line-height: 40px; }\n  .pt-select.pt-fill, .pt-select.pt-fill select {\n    width: 100%; }\n  .pt-dark .pt-select option {\n    background-color: #30404d;\n    color: #f5f8fa; }\n  .pt-dark .pt-select::after {\n    color: #bfccd6; }\n\n.pt-select select {\n  display: inline-block;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 10px;\n  vertical-align: middle;\n  font-size: 14px;\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border-radius: 3px;\n  height: 30px;\n  padding: 0 25px 0 10px; }\n  .pt-select select:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-select select:active, .pt-select select.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-select select:disabled, .pt-select select.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-select select:disabled.pt-active, .pt-select select.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n\n.pt-select.pt-minimal select {\n  box-shadow: none;\n  background: none; }\n  .pt-select.pt-minimal select:hover {\n    box-shadow: none;\n    background: rgba(167, 182, 194, 0.3);\n    text-decoration: none;\n    color: #182026; }\n  .pt-select.pt-minimal select:active, .pt-select.pt-minimal select.pt-active {\n    box-shadow: none;\n    background: rgba(115, 134, 148, 0.3);\n    color: #182026; }\n  .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal select.pt-disabled:hover {\n    background: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-select.pt-minimal select, .pt-select.pt-minimal .pt-dark select {\n    box-shadow: none;\n    background: none;\n    color: inherit; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover, .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      box-shadow: none;\n      background: none; }\n    .pt-dark .pt-select.pt-minimal select:hover, .pt-select.pt-minimal .pt-dark select:hover {\n      background: rgba(138, 155, 168, 0.15); }\n    .pt-dark .pt-select.pt-minimal select:active, .pt-select.pt-minimal .pt-dark select:active, .pt-dark .pt-select.pt-minimal select.pt-active, .pt-select.pt-minimal .pt-dark select.pt-active {\n      background: rgba(138, 155, 168, 0.3);\n      color: #f5f8fa; }\n    .pt-dark .pt-select.pt-minimal select:disabled, .pt-select.pt-minimal .pt-dark select:disabled, .pt-dark .pt-select.pt-minimal select:disabled:hover, .pt-select.pt-minimal .pt-dark select:disabled:hover, .pt-dark .pt-select.pt-minimal select.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-disabled, .pt-dark .pt-select.pt-minimal select.pt-disabled:hover, .pt-select.pt-minimal .pt-dark select.pt-disabled:hover {\n      background: none;\n      cursor: not-allowed;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-primary {\n    color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:hover {\n      background: rgba(19, 124, 189, 0.15);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal select.pt-intent-primary.pt-active {\n      background: rgba(19, 124, 189, 0.3);\n      color: #106ba3; }\n    .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal select.pt-intent-primary.pt-disabled {\n      background: none;\n      color: rgba(16, 107, 163, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-primary .pt-button-spinner .pt-spinner-head {\n      stroke: #106ba3; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-primary, .pt-select.pt-minimal .pt-dark select.pt-intent-primary {\n      color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:hover {\n        background: rgba(19, 124, 189, 0.2);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:active, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-active {\n        background: rgba(19, 124, 189, 0.3);\n        color: #48aff0; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-primary:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-primary.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-primary.pt-disabled {\n        background: none;\n        color: rgba(72, 175, 240, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-success {\n    color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:hover {\n      background: rgba(15, 153, 96, 0.15);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal select.pt-intent-success.pt-active {\n      background: rgba(15, 153, 96, 0.3);\n      color: #0d8050; }\n    .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal select.pt-intent-success.pt-disabled {\n      background: none;\n      color: rgba(13, 128, 80, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-success .pt-button-spinner .pt-spinner-head {\n      stroke: #0d8050; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-success, .pt-select.pt-minimal .pt-dark select.pt-intent-success {\n      color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-success:hover {\n        background: rgba(15, 153, 96, 0.2);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:active, .pt-select.pt-minimal .pt-dark select.pt-intent-success:active, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-active {\n        background: rgba(15, 153, 96, 0.3);\n        color: #3dcc91; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-success:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-success.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-success.pt-disabled {\n        background: none;\n        color: rgba(61, 204, 145, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-warning {\n    color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:hover {\n      background: rgba(217, 130, 43, 0.15);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal select.pt-intent-warning.pt-active {\n      background: rgba(217, 130, 43, 0.3);\n      color: #bf7326; }\n    .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal select.pt-intent-warning.pt-disabled {\n      background: none;\n      color: rgba(191, 115, 38, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-warning .pt-button-spinner .pt-spinner-head {\n      stroke: #bf7326; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-warning, .pt-select.pt-minimal .pt-dark select.pt-intent-warning {\n      color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:hover {\n        background: rgba(217, 130, 43, 0.2);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:active, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-active {\n        background: rgba(217, 130, 43, 0.3);\n        color: #ffb366; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-warning:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-warning.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-warning.pt-disabled {\n        background: none;\n        color: rgba(255, 179, 102, 0.5); }\n  .pt-select.pt-minimal select.pt-intent-danger {\n    color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      box-shadow: none;\n      background: none;\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:hover {\n      background: rgba(219, 55, 55, 0.15);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal select.pt-intent-danger.pt-active {\n      background: rgba(219, 55, 55, 0.3);\n      color: #c23030; }\n    .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal select.pt-intent-danger.pt-disabled {\n      background: none;\n      color: rgba(194, 48, 48, 0.5); }\n    .pt-select.pt-minimal select.pt-intent-danger .pt-button-spinner .pt-spinner-head {\n      stroke: #c23030; }\n    .pt-dark .pt-select.pt-minimal select.pt-intent-danger, .pt-select.pt-minimal .pt-dark select.pt-intent-danger {\n      color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:hover, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:hover {\n        background: rgba(219, 55, 55, 0.2);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:active, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-active, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-active {\n        background: rgba(219, 55, 55, 0.3);\n        color: #ff7373; }\n      .pt-dark .pt-select.pt-minimal select.pt-intent-danger:disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger:disabled, .pt-dark .pt-select.pt-minimal select.pt-intent-danger.pt-disabled, .pt-select.pt-minimal .pt-dark select.pt-intent-danger.pt-disabled {\n        background: none;\n        color: rgba(255, 115, 115, 0.5); }\n\n.pt-select.pt-large select {\n  height: 40px;\n  padding-right: 35px;\n  font-size: 16px; }\n\n.pt-dark .pt-select select {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n  background-color: #394b59;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n  color: #f5f8fa; }\n  .pt-dark .pt-select select:hover, .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    color: #f5f8fa; }\n  .pt-dark .pt-select select:hover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #30404d; }\n  .pt-dark .pt-select select:active, .pt-dark .pt-select select.pt-active {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #202b33;\n    background-image: none; }\n  .pt-dark .pt-select select:disabled, .pt-dark .pt-select select.pt-disabled {\n    box-shadow: none;\n    background-color: rgba(57, 75, 89, 0.5);\n    background-image: none;\n    color: rgba(191, 204, 214, 0.5); }\n    .pt-dark .pt-select select:disabled.pt-active, .pt-dark .pt-select select.pt-disabled.pt-active {\n      background: rgba(57, 75, 89, 0.7); }\n  .pt-dark .pt-select select .pt-button-spinner .pt-spinner-head {\n    background: rgba(16, 22, 26, 0.5);\n    stroke: #8a9ba8; }\n\n.pt-select select:disabled {\n  box-shadow: none;\n  background-color: rgba(206, 217, 224, 0.5);\n  cursor: not-allowed;\n  color: rgba(92, 112, 128, 0.5); }\n\n.pt-select::after {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 7px;\n  line-height: 30px;\n  color: #5c7080;\n  content: \"\\E6C6\";\n  pointer-events: none; }\n  .pt-disabled.pt-select::after {\n    color: rgba(92, 112, 128, 0.5); }\n\n.pt-numeric-input .pt-button-group.pt-vertical > .pt-button:first-child {\n  min-height: 16px; }\n\n.pt-numeric-input .pt-button-group.pt-vertical > .pt-button:last-child {\n  min-height: 15px; }\n\n.pt-numeric-input .pt-button-group.pt-vertical > .pt-button:first-child {\n  border-radius: 0 3px 0 0; }\n\n.pt-numeric-input .pt-button-group.pt-vertical > .pt-button:last-child {\n  border-radius: 0 0 3px 0; }\n\n.pt-numeric-input .pt-button-group.pt-vertical > .pt-button[class*=\"pt-icon-\"]::before {\n  display: block;\n  height: 14px;\n  overflow: hidden;\n  line-height: 14px; }\n\n.pt-numeric-input .pt-button-group.pt-vertical:first-child > .pt-button:first-child {\n  border-radius: 3px 0 0 0; }\n\n.pt-numeric-input .pt-button-group.pt-vertical:first-child > .pt-button:last-child {\n  border-radius: 0 0 0 3px; }\n\n.pt-numeric-input.pt-large .pt-button-group.pt-vertical > .pt-button:first-child {\n  min-height: 21px; }\n\n.pt-numeric-input.pt-large .pt-button-group.pt-vertical > .pt-button:last-child {\n  min-height: 20px; }\n\n.pt-dark .pt-numeric-input .pt-button-group.pt-vertical > .pt-button {\n  line-height: 14px; }\n  .pt-dark .pt-numeric-input .pt-button-group.pt-vertical > .pt-button:first-child {\n    min-height: 15px; }\n  .pt-dark .pt-numeric-input .pt-button-group.pt-vertical > .pt-button:last-child {\n    min-height: 14px; }\n\n.pt-dark .pt-numeric-input.pt-large .pt-button-group.pt-vertical > .pt-button:first-child {\n  min-height: 20px; }\n\n.pt-dark .pt-numeric-input.pt-large .pt-button-group.pt-vertical > .pt-button:last-child {\n  min-height: 19px; }\n\nform {\n  display: block; }\n\n.pt-key {\n  display: inline-block;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 1px 1px rgba(16, 22, 26, 0.2), 0 2px 6px rgba(16, 22, 26, 0.2);\n  background: #ffffff;\n  min-width: 25px;\n  height: 25px;\n  padding: 3px 5px;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 20px;\n  color: #5c7080;\n  font-family: -apple-system, \"BlinkMacSystemFont\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Open Sans\", \"Helvetica Neue\", \"Icons16\", sans-serif;\n  font-size: 12px; }\n  .pt-key.pt-modifier-key {\n    padding: 3px 8px 3px 6px; }\n    .pt-key.pt-modifier-key .pt-icon-standard {\n      margin-right: 5px; }\n  .pt-dark .pt-key {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.4), 0 2px 6px rgba(16, 22, 26, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    background: #394b59;\n    color: #bfccd6; }\n\n.pt-key-combo .pt-key:not(:last-child) {\n  margin-right: 5px; }\n\n.pt-hotkey-dialog {\n  top: 40px;\n  padding-bottom: 0; }\n  .pt-hotkey-dialog .pt-dialog-body {\n    margin: 0;\n    padding: 0; }\n  .pt-hotkey-dialog .pt-key-combo {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 0 auto;\n            flex: 1 0 auto;\n    width: 160px;\n    text-align: right; }\n\n.pt-hotkey-column {\n  margin: auto;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding: 30px; }\n  .pt-hotkey-column .pt-hotkey-group {\n    margin-bottom: 30px; }\n    .pt-hotkey-column .pt-hotkey-group:not(:first-child) {\n      margin-top: 50px; }\n\n.pt-hotkey {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-right: 0;\n  margin-left: 0; }\n  .pt-hotkey:not(:last-child) {\n    margin-bottom: 10px; }\n\n.pt-icon, .pt-icon-standard, .pt-icon-large {\n  display: inline-block; }\n  .pt-icon.pt-intent-primary, .pt-icon-standard.pt-intent-primary, .pt-icon-large.pt-intent-primary {\n    color: #137cbd; }\n  .pt-icon.pt-intent-success, .pt-icon-standard.pt-intent-success, .pt-icon-large.pt-intent-success {\n    color: #0f9960; }\n  .pt-icon.pt-intent-warning, .pt-icon-standard.pt-intent-warning, .pt-icon-large.pt-intent-warning {\n    color: #d9822b; }\n  .pt-icon.pt-intent-danger, .pt-icon-standard.pt-intent-danger, .pt-icon-large.pt-intent-danger {\n    color: #db3737; }\n\nspan.pt-icon-standard {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased; }\n\nspan.pt-icon-large {\n  line-height: 1;\n  font-family: \"Icons20\", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased; }\n\nspan.pt-icon {\n  line-height: 1;\n  font-family: \"Icons20\";\n  font-size: inherit;\n  font-weight: 400;\n  font-style: normal; }\n  span.pt-icon::before {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased; }\n\n.pt-icon-blank::before {\n  content: \"\\E900\"; }\n\n.pt-icon-style::before {\n  content: \"\\E601\"; }\n\n.pt-icon-align-left::before {\n  content: \"\\E602\"; }\n\n.pt-icon-align-center::before {\n  content: \"\\E603\"; }\n\n.pt-icon-align-right::before {\n  content: \"\\E604\"; }\n\n.pt-icon-align-justify::before {\n  content: \"\\E605\"; }\n\n.pt-icon-bold::before {\n  content: \"\\E606\"; }\n\n.pt-icon-italic::before {\n  content: \"\\E607\"; }\n\n.pt-icon-underline::before {\n  content: \"\\2381\"; }\n\n.pt-icon-search-around::before {\n  content: \"\\E608\"; }\n\n.pt-icon-graph-remove::before {\n  content: \"\\E609\"; }\n\n.pt-icon-group-objects::before {\n  content: \"\\E60A\"; }\n\n.pt-icon-merge-links::before {\n  content: \"\\E60B\"; }\n\n.pt-icon-layout::before {\n  content: \"\\E60C\"; }\n\n.pt-icon-layout-auto::before {\n  content: \"\\E60D\"; }\n\n.pt-icon-layout-circle::before {\n  content: \"\\E60E\"; }\n\n.pt-icon-layout-hierarchy::before {\n  content: \"\\E60F\"; }\n\n.pt-icon-layout-grid::before {\n  content: \"\\E610\"; }\n\n.pt-icon-layout-group-by::before {\n  content: \"\\E611\"; }\n\n.pt-icon-layout-skew-grid::before {\n  content: \"\\E612\"; }\n\n.pt-icon-geosearch::before {\n  content: \"\\E613\"; }\n\n.pt-icon-heatmap::before {\n  content: \"\\E614\"; }\n\n.pt-icon-drive-time::before {\n  content: \"\\E615\"; }\n\n.pt-icon-select::before {\n  content: \"\\E616\"; }\n\n.pt-icon-predictive-analysis::before {\n  content: \"\\E617\"; }\n\n.pt-icon-layers::before {\n  content: \"\\E618\"; }\n\n.pt-icon-locate::before {\n  content: \"\\E619\"; }\n\n.pt-icon-bookmark::before {\n  content: \"\\E61A\"; }\n\n.pt-icon-citation::before {\n  content: \"\\E61B\"; }\n\n.pt-icon-tag::before {\n  content: \"\\E61C\"; }\n\n.pt-icon-clipboard::before {\n  content: \"\\E61D\"; }\n\n.pt-icon-selection::before {\n  content: \"\\29BF\"; }\n\n.pt-icon-timeline-events::before {\n  content: \"\\E61E\"; }\n\n.pt-icon-timeline-line-chart::before {\n  content: \"\\E61F\"; }\n\n.pt-icon-timeline-bar-chart::before {\n  content: \"\\E620\"; }\n\n.pt-icon-applications::before {\n  content: \"\\E621\"; }\n\n.pt-icon-projects::before {\n  content: \"\\E622\"; }\n\n.pt-icon-changes::before {\n  content: \"\\E623\"; }\n\n.pt-icon-notifications::before {\n  content: \"\\E624\"; }\n\n.pt-icon-lock::before {\n  content: \"\\E625\"; }\n\n.pt-icon-unlock::before {\n  content: \"\\E626\"; }\n\n.pt-icon-user::before {\n  content: \"\\E627\"; }\n\n.pt-icon-search-template::before {\n  content: \"\\E628\"; }\n\n.pt-icon-inbox::before {\n  content: \"\\E629\"; }\n\n.pt-icon-more::before {\n  content: \"\\E62A\"; }\n\n.pt-icon-help::before {\n  content: \"?\"; }\n\n.pt-icon-calendar::before {\n  content: \"\\E62B\"; }\n\n.pt-icon-media::before {\n  content: \"\\E62C\"; }\n\n.pt-icon-link::before {\n  content: \"\\E62D\"; }\n\n.pt-icon-share::before {\n  content: \"\\E62E\"; }\n\n.pt-icon-download::before {\n  content: \"\\E62F\"; }\n\n.pt-icon-document::before {\n  content: \"\\E630\"; }\n\n.pt-icon-properties::before {\n  content: \"\\E631\"; }\n\n.pt-icon-import::before {\n  content: \"\\E632\"; }\n\n.pt-icon-export::before {\n  content: \"\\E633\"; }\n\n.pt-icon-minimize::before {\n  content: \"\\E634\"; }\n\n.pt-icon-maximize::before {\n  content: \"\\E635\"; }\n\n.pt-icon-tick::before {\n  content: \"\\2713\"; }\n\n.pt-icon-cross::before {\n  content: \"\\2717\"; }\n\n.pt-icon-plus::before {\n  content: \"+\"; }\n\n.pt-icon-minus::before {\n  content: \"\\2212\"; }\n\n.pt-icon-arrow-left::before {\n  content: \"\\2190\"; }\n\n.pt-icon-arrow-right::before {\n  content: \"\\2192\"; }\n\n.pt-icon-exchange::before {\n  content: \"\\E636\"; }\n\n.pt-icon-comparison::before {\n  content: \"\\E637\"; }\n\n.pt-icon-list::before {\n  content: \"\\2630\"; }\n\n.pt-icon-filter::before {\n  content: \"\\E638\"; }\n\n.pt-icon-confirm::before {\n  content: \"\\E639\"; }\n\n.pt-icon-fork::before {\n  content: \"\\E63A\"; }\n\n.pt-icon-trash::before {\n  content: \"\\E63B\"; }\n\n.pt-icon-person::before {\n  content: \"\\E63C\"; }\n\n.pt-icon-people::before {\n  content: \"\\E63D\"; }\n\n.pt-icon-add::before {\n  content: \"\\E63E\"; }\n\n.pt-icon-remove::before {\n  content: \"\\E63F\"; }\n\n.pt-icon-geolocation::before {\n  content: \"\\E640\"; }\n\n.pt-icon-zoom-in::before {\n  content: \"\\E641\"; }\n\n.pt-icon-zoom-out::before {\n  content: \"\\E642\"; }\n\n.pt-icon-refresh::before {\n  content: \"\\E643\"; }\n\n.pt-icon-delete::before {\n  content: \"\\E644\"; }\n\n.pt-icon-cog::before {\n  content: \"\\E645\"; }\n\n.pt-icon-flag::before {\n  content: \"\\2691\"; }\n\n.pt-icon-pin::before {\n  content: \"\\E646\"; }\n\n.pt-icon-warning-sign::before {\n  content: \"\\E647\"; }\n\n.pt-icon-error::before {\n  content: \"\\E648\"; }\n\n.pt-icon-info-sign::before {\n  content: \"\\2139\"; }\n\n.pt-icon-credit-card::before {\n  content: \"\\E649\"; }\n\n.pt-icon-edit::before {\n  content: \"\\270E\"; }\n\n.pt-icon-history::before {\n  content: \"\\E64A\"; }\n\n.pt-icon-search::before {\n  content: \"\\E64B\"; }\n\n.pt-icon-log-out::before {\n  content: \"\\E64C\"; }\n\n.pt-icon-star::before {\n  content: \"\\2605\"; }\n\n.pt-icon-star-empty::before {\n  content: \"\\2606\"; }\n\n.pt-icon-sort-alphabetical::before {\n  content: \"\\E64D\"; }\n\n.pt-icon-sort-numerical::before {\n  content: \"\\E64E\"; }\n\n.pt-icon-sort::before {\n  content: \"\\E64F\"; }\n\n.pt-icon-folder-open::before {\n  content: \"\\E651\"; }\n\n.pt-icon-folder-close::before {\n  content: \"\\E652\"; }\n\n.pt-icon-folder-shared::before {\n  content: \"\\E653\"; }\n\n.pt-icon-caret-up::before {\n  content: \"\\2303\"; }\n\n.pt-icon-caret-right::before {\n  content: \"\\232A\"; }\n\n.pt-icon-caret-down::before {\n  content: \"\\2304\"; }\n\n.pt-icon-caret-left::before {\n  content: \"\\2329\"; }\n\n.pt-icon-menu-open::before {\n  content: \"\\E654\"; }\n\n.pt-icon-menu-closed::before {\n  content: \"\\E655\"; }\n\n.pt-icon-feed::before {\n  content: \"\\E656\"; }\n\n.pt-icon-two-columns::before {\n  content: \"\\E657\"; }\n\n.pt-icon-one-column::before {\n  content: \"\\E658\"; }\n\n.pt-icon-dot::before {\n  content: \"\\2022\"; }\n\n.pt-icon-property::before {\n  content: \"\\E65A\"; }\n\n.pt-icon-time::before {\n  content: \"\\23F2\"; }\n\n.pt-icon-disable::before {\n  content: \"\\E600\"; }\n\n.pt-icon-unpin::before {\n  content: \"\\E650\"; }\n\n.pt-icon-flows::before {\n  content: \"\\E659\"; }\n\n.pt-icon-new-text-box::before {\n  content: \"\\E65B\"; }\n\n.pt-icon-new-link::before {\n  content: \"\\E65C\"; }\n\n.pt-icon-new-object::before {\n  content: \"\\E65D\"; }\n\n.pt-icon-path-search::before {\n  content: \"\\E65E\"; }\n\n.pt-icon-automatic-updates::before {\n  content: \"\\E65F\"; }\n\n.pt-icon-page-layout::before {\n  content: \"\\E660\"; }\n\n.pt-icon-code::before {\n  content: \"\\E661\"; }\n\n.pt-icon-map::before {\n  content: \"\\E662\"; }\n\n.pt-icon-search-text::before {\n  content: \"\\E663\"; }\n\n.pt-icon-envelope::before {\n  content: \"\\2709\"; }\n\n.pt-icon-paperclip::before {\n  content: \"\\E664\"; }\n\n.pt-icon-label::before {\n  content: \"\\E665\"; }\n\n.pt-icon-globe::before {\n  content: \"\\E666\"; }\n\n.pt-icon-home::before {\n  content: \"\\2302\"; }\n\n.pt-icon-th::before {\n  content: \"\\E667\"; }\n\n.pt-icon-th-list::before {\n  content: \"\\E668\"; }\n\n.pt-icon-th-derived::before {\n  content: \"\\E669\"; }\n\n.pt-icon-circle::before {\n  content: \"\\E66A\"; }\n\n.pt-icon-draw::before {\n  content: \"\\E66B\"; }\n\n.pt-icon-insert::before {\n  content: \"\\E66C\"; }\n\n.pt-icon-helper-management::before {\n  content: \"\\E66D\"; }\n\n.pt-icon-send-to::before {\n  content: \"\\E66E\"; }\n\n.pt-icon-eye-open::before {\n  content: \"\\E66F\"; }\n\n.pt-icon-folder-shared-open::before {\n  content: \"\\E670\"; }\n\n.pt-icon-social-media::before {\n  content: \"\\E671\"; }\n\n.pt-icon-arrow-up::before {\n  content: \"\\2191\"; }\n\n.pt-icon-arrow-down::before {\n  content: \"\\2193\"; }\n\n.pt-icon-arrows-horizontal::before {\n  content: \"\\2194\"; }\n\n.pt-icon-arrows-vertical::before {\n  content: \"\\2195\"; }\n\n.pt-icon-resolve::before {\n  content: \"\\E672\"; }\n\n.pt-icon-graph::before {\n  content: \"\\E673\"; }\n\n.pt-icon-briefcase::before {\n  content: \"\\E674\"; }\n\n.pt-icon-dollar::before {\n  content: \"$\"; }\n\n.pt-icon-ninja::before {\n  content: \"\\E675\"; }\n\n.pt-icon-delta::before {\n  content: \"\\394\"; }\n\n.pt-icon-barcode::before {\n  content: \"\\E676\"; }\n\n.pt-icon-torch::before {\n  content: \"\\E677\"; }\n\n.pt-icon-widget::before {\n  content: \"\\E678\"; }\n\n.pt-icon-unresolve::before {\n  content: \"\\E679\"; }\n\n.pt-icon-offline::before {\n  content: \"\\E67A\"; }\n\n.pt-icon-zoom-to-fit::before {\n  content: \"\\E67B\"; }\n\n.pt-icon-add-to-artifact::before {\n  content: \"\\E67C\"; }\n\n.pt-icon-map-marker::before {\n  content: \"\\E67D\"; }\n\n.pt-icon-chart::before {\n  content: \"\\E67E\"; }\n\n.pt-icon-control::before {\n  content: \"\\E67F\"; }\n\n.pt-icon-multi-select::before {\n  content: \"\\E680\"; }\n\n.pt-icon-direction-left::before {\n  content: \"\\E681\"; }\n\n.pt-icon-direction-right::before {\n  content: \"\\E682\"; }\n\n.pt-icon-database::before {\n  content: \"\\E683\"; }\n\n.pt-icon-pie-chart::before {\n  content: \"\\E684\"; }\n\n.pt-icon-full-circle::before {\n  content: \"\\E685\"; }\n\n.pt-icon-square::before {\n  content: \"\\E686\"; }\n\n.pt-icon-print::before {\n  content: \"\\2399\"; }\n\n.pt-icon-presentation::before {\n  content: \"\\E687\"; }\n\n.pt-icon-ungroup-objects::before {\n  content: \"\\E688\"; }\n\n.pt-icon-chat::before {\n  content: \"\\E689\"; }\n\n.pt-icon-comment::before {\n  content: \"\\E68A\"; }\n\n.pt-icon-circle-arrow-right::before {\n  content: \"\\E68B\"; }\n\n.pt-icon-circle-arrow-left::before {\n  content: \"\\E68C\"; }\n\n.pt-icon-circle-arrow-up::before {\n  content: \"\\E68D\"; }\n\n.pt-icon-circle-arrow-down::before {\n  content: \"\\E68E\"; }\n\n.pt-icon-upload::before {\n  content: \"\\E68F\"; }\n\n.pt-icon-asterisk::before {\n  content: \"*\"; }\n\n.pt-icon-cloud::before {\n  content: \"\\2601\"; }\n\n.pt-icon-cloud-download::before {\n  content: \"\\E690\"; }\n\n.pt-icon-cloud-upload::before {\n  content: \"\\E691\"; }\n\n.pt-icon-repeat::before {\n  content: \"\\E692\"; }\n\n.pt-icon-move::before {\n  content: \"\\E693\"; }\n\n.pt-icon-chevron-left::before {\n  content: \"\\E694\"; }\n\n.pt-icon-chevron-right::before {\n  content: \"\\E695\"; }\n\n.pt-icon-chevron-up::before {\n  content: \"\\E696\"; }\n\n.pt-icon-chevron-down::before {\n  content: \"\\E697\"; }\n\n.pt-icon-random::before {\n  content: \"\\E698\"; }\n\n.pt-icon-fullscreen::before {\n  content: \"\\E699\"; }\n\n.pt-icon-log-in::before {\n  content: \"\\E69A\"; }\n\n.pt-icon-heart::before {\n  content: \"\\2665\"; }\n\n.pt-icon-office::before {\n  content: \"\\E69B\"; }\n\n.pt-icon-duplicate::before {\n  content: \"\\E69C\"; }\n\n.pt-icon-ban-circle::before {\n  content: \"\\E69D\"; }\n\n.pt-icon-camera::before {\n  content: \"\\E69E\"; }\n\n.pt-icon-mobile-video::before {\n  content: \"\\E69F\"; }\n\n.pt-icon-video::before {\n  content: \"\\E6A0\"; }\n\n.pt-icon-film::before {\n  content: \"\\E6A1\"; }\n\n.pt-icon-settings::before {\n  content: \"\\E6A2\"; }\n\n.pt-icon-volume-off::before {\n  content: \"\\E6A3\"; }\n\n.pt-icon-volume-down::before {\n  content: \"\\E6A4\"; }\n\n.pt-icon-volume-up::before {\n  content: \"\\E6A5\"; }\n\n.pt-icon-music::before {\n  content: \"\\E6A6\"; }\n\n.pt-icon-step-backward::before {\n  content: \"\\E6A7\"; }\n\n.pt-icon-fast-backward::before {\n  content: \"\\E6A8\"; }\n\n.pt-icon-pause::before {\n  content: \"\\E6A9\"; }\n\n.pt-icon-stop::before {\n  content: \"\\E6AA\"; }\n\n.pt-icon-play::before {\n  content: \"\\E6AB\"; }\n\n.pt-icon-fast-forward::before {\n  content: \"\\E6AC\"; }\n\n.pt-icon-step-forward::before {\n  content: \"\\E6AD\"; }\n\n.pt-icon-eject::before {\n  content: \"\\23CF\"; }\n\n.pt-icon-record::before {\n  content: \"\\E6AE\"; }\n\n.pt-icon-desktop::before {\n  content: \"\\E6AF\"; }\n\n.pt-icon-phone::before {\n  content: \"\\260E\"; }\n\n.pt-icon-lightbulb::before {\n  content: \"\\E6B0\"; }\n\n.pt-icon-glass::before {\n  content: \"\\E6B1\"; }\n\n.pt-icon-tint::before {\n  content: \"\\E6B2\"; }\n\n.pt-icon-flash::before {\n  content: \"\\E6B3\"; }\n\n.pt-icon-font::before {\n  content: \"\\E6B4\"; }\n\n.pt-icon-header::before {\n  content: \"\\E6B5\"; }\n\n.pt-icon-saved::before {\n  content: \"\\E6B6\"; }\n\n.pt-icon-floppy-disk::before {\n  content: \"\\E6B7\"; }\n\n.pt-icon-book::before {\n  content: \"\\E6B8\"; }\n\n.pt-icon-hand-right::before {\n  content: \"\\E6B9\"; }\n\n.pt-icon-hand-up::before {\n  content: \"\\E6BA\"; }\n\n.pt-icon-hand-down::before {\n  content: \"\\E6BB\"; }\n\n.pt-icon-hand-left::before {\n  content: \"\\E6BC\"; }\n\n.pt-icon-thumbs-up::before {\n  content: \"\\E6BD\"; }\n\n.pt-icon-thumbs-down::before {\n  content: \"\\E6BE\"; }\n\n.pt-icon-box::before {\n  content: \"\\E6BF\"; }\n\n.pt-icon-compressed::before {\n  content: \"\\E6C0\"; }\n\n.pt-icon-shopping-cart::before {\n  content: \"\\E6C1\"; }\n\n.pt-icon-shop::before {\n  content: \"\\E6C2\"; }\n\n.pt-icon-layout-linear::before {\n  content: \"\\E6C3\"; }\n\n.pt-icon-undo::before {\n  content: \"\\238C\"; }\n\n.pt-icon-redo::before {\n  content: \"\\E6C4\"; }\n\n.pt-icon-code-block::before {\n  content: \"\\E6C5\"; }\n\n.pt-icon-double-caret-vertical::before {\n  content: \"\\E6C6\"; }\n\n.pt-icon-double-caret-horizontal::before {\n  content: \"\\E6C7\"; }\n\n.pt-icon-sort-alphabetical-desc::before {\n  content: \"\\E6C8\"; }\n\n.pt-icon-sort-numerical-desc::before {\n  content: \"\\E6C9\"; }\n\n.pt-icon-take-action::before {\n  content: \"\\E6CA\"; }\n\n.pt-icon-contrast::before {\n  content: \"\\E6CB\"; }\n\n.pt-icon-eye-off::before {\n  content: \"\\E6CC\"; }\n\n.pt-icon-timeline-area-chart::before {\n  content: \"\\E6CD\"; }\n\n.pt-icon-doughnut-chart::before {\n  content: \"\\E6CE\"; }\n\n.pt-icon-layer::before {\n  content: \"\\E6CF\"; }\n\n.pt-icon-grid::before {\n  content: \"\\E6D0\"; }\n\n.pt-icon-polygon-filter::before {\n  content: \"\\E6D1\"; }\n\n.pt-icon-add-to-folder::before {\n  content: \"\\E6D2\"; }\n\n.pt-icon-layout-balloon::before {\n  content: \"\\E6D3\"; }\n\n.pt-icon-layout-sorted-clusters::before {\n  content: \"\\E6D4\"; }\n\n.pt-icon-sort-asc::before {\n  content: \"\\E6D5\"; }\n\n.pt-icon-sort-desc::before {\n  content: \"\\E6D6\"; }\n\n.pt-icon-small-cross::before {\n  content: \"\\E6D7\"; }\n\n.pt-icon-small-tick::before {\n  content: \"\\E6D8\"; }\n\n.pt-icon-power::before {\n  content: \"\\E6D9\"; }\n\n.pt-icon-column-layout::before {\n  content: \"\\E6DA\"; }\n\n.pt-icon-arrow-top-left::before {\n  content: \"\\2196\"; }\n\n.pt-icon-arrow-top-right::before {\n  content: \"\\2197\"; }\n\n.pt-icon-arrow-bottom-right::before {\n  content: \"\\2198\"; }\n\n.pt-icon-arrow-bottom-left::before {\n  content: \"\\2199\"; }\n\n.pt-icon-mugshot::before {\n  content: \"\\E6DB\"; }\n\n.pt-icon-headset::before {\n  content: \"\\E6DC\"; }\n\n.pt-icon-text-highlight::before {\n  content: \"\\E6DD\"; }\n\n.pt-icon-hand::before {\n  content: \"\\E6DE\"; }\n\n.pt-icon-chevron-backward::before {\n  content: \"\\E6DF\"; }\n\n.pt-icon-chevron-forward::before {\n  content: \"\\E6E0\"; }\n\n.pt-icon-rotate-document::before {\n  content: \"\\E6E1\"; }\n\n.pt-icon-rotate-page::before {\n  content: \"\\E6E2\"; }\n\n.pt-icon-badge::before {\n  content: \"\\E6E3\"; }\n\n.pt-icon-grid-view::before {\n  content: \"\\E6E4\"; }\n\n.pt-icon-function::before {\n  content: \"\\E6E5\"; }\n\n.pt-icon-waterfall-chart::before {\n  content: \"\\E6E6\"; }\n\n.pt-icon-stacked-chart::before {\n  content: \"\\E6E7\"; }\n\n.pt-icon-pulse::before {\n  content: \"\\E6E8\"; }\n\n.pt-icon-new-person::before {\n  content: \"\\E6E9\"; }\n\n.pt-icon-exclude-row::before {\n  content: \"\\E6EA\"; }\n\n.pt-icon-pivot-table::before {\n  content: \"\\E6EB\"; }\n\n.pt-icon-segmented-control::before {\n  content: \"\\E6EC\"; }\n\n.pt-icon-highlight::before {\n  content: \"\\E6ED\"; }\n\n.pt-icon-filter-list::before {\n  content: \"\\E6EE\"; }\n\n.pt-icon-cut::before {\n  content: \"\\E6EF\"; }\n\n.pt-icon-annotation::before {\n  content: \"\\E6F0\"; }\n\n.pt-icon-pivot::before {\n  content: \"\\E6F1\"; }\n\n.pt-icon-ring::before {\n  content: \"\\E6F2\"; }\n\n.pt-icon-heat-grid::before {\n  content: \"\\E6F3\"; }\n\n.pt-icon-gantt-chart::before {\n  content: \"\\E6F4\"; }\n\n.pt-icon-variable::before {\n  content: \"\\E6F5\"; }\n\n.pt-icon-manual::before {\n  content: \"\\E6F6\"; }\n\n.pt-icon-add-row-top::before {\n  content: \"\\E6F7\"; }\n\n.pt-icon-add-row-bottom::before {\n  content: \"\\E6F8\"; }\n\n.pt-icon-add-column-left::before {\n  content: \"\\E6F9\"; }\n\n.pt-icon-add-column-right::before {\n  content: \"\\E6FA\"; }\n\n.pt-icon-remove-row-top::before {\n  content: \"\\E6FB\"; }\n\n.pt-icon-remove-row-bottom::before {\n  content: \"\\E6FC\"; }\n\n.pt-icon-remove-column-left::before {\n  content: \"\\E6FD\"; }\n\n.pt-icon-remove-column-right::before {\n  content: \"\\E6FE\"; }\n\n.pt-icon-double-chevron-left::before {\n  content: \"\\E6FF\"; }\n\n.pt-icon-double-chevron-right::before {\n  content: \"\\E701\"; }\n\n.pt-icon-double-chevron-up::before {\n  content: \"\\E702\"; }\n\n.pt-icon-double-chevron-down::before {\n  content: \"\\E703\"; }\n\n.pt-icon-key-control::before {\n  content: \"\\E704\"; }\n\n.pt-icon-key-command::before {\n  content: \"\\E705\"; }\n\n.pt-icon-key-shift::before {\n  content: \"\\E706\"; }\n\n.pt-icon-key-backspace::before {\n  content: \"\\E707\"; }\n\n.pt-icon-key-delete::before {\n  content: \"\\E708\"; }\n\n.pt-icon-key-escape::before {\n  content: \"\\E709\"; }\n\n.pt-icon-key-enter::before {\n  content: \"\\E70A\"; }\n\n.pt-icon-calculator::before {\n  content: \"\\E70B\"; }\n\n.pt-icon-horizontal-bar-chart::before {\n  content: \"\\E70C\"; }\n\n.pt-icon-small-plus::before {\n  content: \"\\E70D\"; }\n\n.pt-icon-small-minus::before {\n  content: \"\\E70E\"; }\n\n.pt-icon-step-chart::before {\n  content: \"\\E70F\"; }\n\n.pt-icon-euro::before {\n  content: \"\\20AC\"; }\n\n.pt-icon-drag-handle-vertical::before {\n  content: \"\\E715\"; }\n\n.pt-icon-drag-handle-horizontal::before {\n  content: \"\\E716\"; }\n\n.pt-icon-mobile-phone::before {\n  content: \"\\E717\"; }\n\n.pt-icon-sim-card::before {\n  content: \"\\E718\"; }\n\n.pt-icon-trending-up::before {\n  content: \"\\E719\"; }\n\n.pt-icon-trending-down::before {\n  content: \"\\E71A\"; }\n\n.pt-icon-curved-range-chart::before {\n  content: \"\\E71B\"; }\n\n.pt-icon-vertical-bar-chart-desc::before {\n  content: \"\\E71C\"; }\n\n.pt-icon-horizontal-bar-chart-desc::before {\n  content: \"\\E71D\"; }\n\n.pt-icon-document-open::before {\n  content: \"\\E71E\"; }\n\n.pt-icon-document-share::before {\n  content: \"\\E71F\"; }\n\n.pt-icon-horizontal-distribution::before {\n  content: \"\\E720\"; }\n\n.pt-icon-vertical-distribution::before {\n  content: \"\\E721\"; }\n\n.pt-icon-alignment-left::before {\n  content: \"\\E722\"; }\n\n.pt-icon-alignment-vertical-center::before {\n  content: \"\\E723\"; }\n\n.pt-icon-alignment-right::before {\n  content: \"\\E724\"; }\n\n.pt-icon-alignment-top::before {\n  content: \"\\E725\"; }\n\n.pt-icon-alignment-horizontal-center::before {\n  content: \"\\E726\"; }\n\n.pt-icon-alignment-bottom::before {\n  content: \"\\E727\"; }\n\n.pt-icon-git-pull::before {\n  content: \"\\E728\"; }\n\n.pt-icon-git-merge::before {\n  content: \"\\E729\"; }\n\n.pt-icon-git-branch::before {\n  content: \"\\E72A\"; }\n\n.pt-icon-git-commit::before {\n  content: \"\\E72B\"; }\n\n.pt-icon-git-push::before {\n  content: \"\\E72C\"; }\n\n.pt-icon-build::before {\n  content: \"\\E72D\"; }\n\n.pt-icon-symbol-circle::before {\n  content: \"\\E72E\"; }\n\n.pt-icon-symbol-square::before {\n  content: \"\\E72F\"; }\n\n.pt-icon-symbol-diamond::before {\n  content: \"\\E730\"; }\n\n.pt-icon-symbol-cross::before {\n  content: \"\\E731\"; }\n\n.pt-icon-symbol-triangle-up::before {\n  content: \"\\E732\"; }\n\n.pt-icon-symbol-triangle-down::before {\n  content: \"\\E733\"; }\n\n.pt-icon-wrench::before {\n  content: \"\\E734\"; }\n\n.pt-icon-application::before {\n  content: \"\\E735\"; }\n\n.pt-icon-send-to-graph::before {\n  content: \"\\E736\"; }\n\n.pt-icon-send-to-map::before {\n  content: \"\\E737\"; }\n\n.pt-icon-join-table::before {\n  content: \"\\E738\"; }\n\n.pt-icon-derive-column::before {\n  content: \"\\E739\"; }\n\n.pt-icon-image-rotate-left::before {\n  content: \"\\E73A\"; }\n\n.pt-icon-image-rotate-right::before {\n  content: \"\\E73B\"; }\n\n.pt-icon-known-vehicle::before {\n  content: \"\\E73C\"; }\n\n.pt-icon-unknown-vehicle::before {\n  content: \"\\E73D\"; }\n\n.pt-icon-scatter-plot::before {\n  content: \"\\E73E\"; }\n\n.pt-icon-oil-field::before {\n  content: \"\\E73F\"; }\n\n.pt-icon-rig::before {\n  content: \"\\E740\"; }\n\n.pt-icon-map-create::before {\n  content: \"\\E741\"; }\n\n.pt-icon-key-option::before {\n  content: \"\\E742\"; }\n\n.pt-icon-list-detail-view::before {\n  content: \"\\E743\"; }\n\n.pt-icon-swap-vertical::before {\n  content: \"\\E744\"; }\n\n.pt-icon-swap-horizontal::before {\n  content: \"\\E745\"; }\n\n.pt-icon-numbered-list::before {\n  content: \"\\E746\"; }\n\n.pt-icon-new-grid-item::before {\n  content: \"\\E747\"; }\n\n.pt-icon-git-repo::before {\n  content: \"\\E748\"; }\n\n.pt-icon-git-new-branch::before {\n  content: \"\\E749\"; }\n\n.pt-icon-manually-entered-data::before {\n  content: \"\\E74A\"; }\n\n.pt-icon-airplane::before {\n  content: \"\\E74B\"; }\n\n.pt-icon-merge-columns::before {\n  content: \"\\E74F\"; }\n\n.pt-icon-split-columns::before {\n  content: \"\\E750\"; }\n\n.pt-icon-dashboard::before {\n  content: \"\\E751\"; }\n\n.pt-icon-publish-function::before {\n  content: \"\\E752\"; }\n\n.pt-icon-path::before {\n  content: \"\\E753\"; }\n\n.pt-icon-moon::before {\n  content: \"\\E754\"; }\n\n.pt-icon-remove-column::before {\n  content: \"\\E755\"; }\n\n.pt-icon-numerical::before {\n  content: \"\\E756\"; }\n\n.pt-icon-key-tab::before {\n  content: \"\\E757\"; }\n\n.pt-icon-regression-chart::before {\n  content: \"\\E758\"; }\n\n.pt-icon-translate::before {\n  content: \"\\E759\"; }\n\n.pt-icon-eye-on::before {\n  content: \"\\E75A\"; }\n\n.pt-icon-vertical-bar-chart-asc::before {\n  content: \"\\E75B\"; }\n\n.pt-icon-horizontal-bar-chart-asc::before {\n  content: \"\\E75C\"; }\n\n.pt-icon-grouped-bar-chart::before {\n  content: \"\\E75D\"; }\n\n.pt-icon-full-stacked-chart::before {\n  content: \"\\E75E\"; }\n\n.pt-icon-endorsed::before {\n  content: \"\\E75F\"; }\n\n.pt-icon-follower::before {\n  content: \"\\E760\"; }\n\n.pt-icon-following::before {\n  content: \"\\E761\"; }\n\n.pt-icon-menu::before {\n  content: \"\\E762\"; }\n\n.pt-icon-collapse-all::before {\n  content: \"\\E763\"; }\n\n.pt-icon-expand-all::before {\n  content: \"\\E764\"; }\n\n.pt-icon-intersection::before {\n  content: \"\\E765\"; }\n\n.pt-icon-blocked-person::before {\n  content: \"\\E768\"; }\n\n.pt-icon-slash::before {\n  content: \"\\E769\"; }\n\n.pt-icon-percentage::before {\n  content: \"\\E76A\"; }\n\n.pt-icon-satellite::before {\n  content: \"\\E76B\"; }\n\n.pt-icon-paragraph::before {\n  content: \"\\E76C\"; }\n\n.pt-icon-banl-account::before {\n  content: \"\\E76F\"; }\n\n.pt-icon-cell-tower::before {\n  content: \"\\E770\"; }\n\n.pt-icon-id-number::before {\n  content: \"\\E771\"; }\n\n.pt-icon-ip-address::before {\n  content: \"\\E772\"; }\n\n.pt-icon-eraser::before {\n  content: \"\\E773\"; }\n\n.pt-icon-issue::before {\n  content: \"\\E774\"; }\n\n.pt-icon-issue-new::before {\n  content: \"\\E775\"; }\n\n.pt-icon-issue-closed::before {\n  content: \"\\E776\"; }\n\n.pt-icon-panel-stats::before {\n  content: \"\\E777\"; }\n\n.pt-icon-panel-table::before {\n  content: \"\\E778\"; }\n\n.pt-icon-tick-circle::before {\n  content: \"\\E779\"; }\n\n.pt-icon-prescription::before {\n  content: \"\\E78A\"; }\n\n.pt-icon-new-prescription::before {\n  content: \"\\E78B\"; }\n\n.pt-submenu > .pt-popover-target {\n  display: inherit; }\n  .pt-submenu > .pt-popover-target > .pt-menu-item {\n    padding-right: 26px; }\n    .pt-submenu > .pt-popover-target > .pt-menu-item::after {\n      line-height: 1;\n      font-family: \"Icons16\", sans-serif;\n      font-size: 16px;\n      font-weight: 400;\n      font-style: normal;\n      -moz-osx-font-smoothing: grayscale;\n      -webkit-font-smoothing: antialiased;\n      position: absolute;\n      right: 5px;\n      content: \"\\232A\"; }\n      .pt-large .pt-submenu > .pt-popover-target > .pt-menu-item::after {\n        line-height: 20px; }\n\n.pt-submenu .pt-popover {\n  position: relative;\n  top: -5px;\n  left: 5px; }\n  .pt-submenu .pt-popover.pt-align-left {\n    right: 5px;\n    left: auto; }\n\n.pt-menu {\n  margin: 0;\n  border-radius: 3px;\n  background: #ffffff;\n  min-width: 180px;\n  padding: 5px;\n  list-style: none;\n  text-align: left;\n  color: #182026; }\n\n.pt-menu-divider {\n  display: block;\n  margin: 5px;\n  border-top: 1px solid rgba(16, 22, 26, 0.15); }\n  .pt-dark .pt-menu-divider {\n    border-top-color: rgba(255, 255, 255, 0.15); }\n\n.pt-menu-item {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  display: block;\n  border-radius: 2px;\n  padding: 7px;\n  line-height: 16px;\n  color: inherit;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-menu-item:hover, .pt-submenu > .pt-popover-open > .pt-menu-item {\n    background-color: rgba(167, 182, 194, 0.3);\n    cursor: pointer; }\n  .pt-menu-item.pt-disabled {\n    background-color: inherit;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-dark .pt-menu-item {\n    color: inherit; }\n    .pt-dark .pt-menu-item:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-menu-item {\n      background-color: rgba(138, 155, 168, 0.15);\n      color: inherit; }\n    .pt-dark .pt-menu-item.pt-disabled {\n      background-color: inherit;\n      color: rgba(191, 204, 214, 0.5); }\n  .pt-menu-item.pt-intent-primary {\n    color: #106ba3; }\n    .pt-menu-item.pt-intent-primary::before, .pt-menu-item.pt-intent-primary::after, .pt-menu-item.pt-intent-primary .pt-menu-item-label {\n      color: #106ba3; }\n    .pt-menu-item.pt-intent-primary:hover, .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item, .pt-menu-item.pt-intent-primary.pt-active {\n      background-color: #137cbd; }\n    .pt-menu-item.pt-intent-primary:active {\n      background-color: #106ba3; }\n    .pt-menu-item.pt-intent-primary:hover, .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item, .pt-menu-item.pt-intent-primary:hover::before, .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item::before, .pt-menu-item.pt-intent-primary:hover::after, .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item::after, .pt-menu-item.pt-intent-primary:hover .pt-menu-item-label, .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item .pt-menu-item-label, .pt-menu-item.pt-intent-primary:active, .pt-menu-item.pt-intent-primary:active::before, .pt-menu-item.pt-intent-primary:active::after, .pt-menu-item.pt-intent-primary:active .pt-menu-item-label, .pt-menu-item.pt-intent-primary.pt-active, .pt-menu-item.pt-intent-primary.pt-active::before, .pt-menu-item.pt-intent-primary.pt-active::after, .pt-menu-item.pt-intent-primary.pt-active .pt-menu-item-label {\n      color: #ffffff; }\n  .pt-menu-item.pt-intent-success {\n    color: #0d8050; }\n    .pt-menu-item.pt-intent-success::before, .pt-menu-item.pt-intent-success::after, .pt-menu-item.pt-intent-success .pt-menu-item-label {\n      color: #0d8050; }\n    .pt-menu-item.pt-intent-success:hover, .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item, .pt-menu-item.pt-intent-success.pt-active {\n      background-color: #0f9960; }\n    .pt-menu-item.pt-intent-success:active {\n      background-color: #0d8050; }\n    .pt-menu-item.pt-intent-success:hover, .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item, .pt-menu-item.pt-intent-success:hover::before, .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item::before, .pt-menu-item.pt-intent-success:hover::after, .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item::after, .pt-menu-item.pt-intent-success:hover .pt-menu-item-label, .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item .pt-menu-item-label, .pt-menu-item.pt-intent-success:active, .pt-menu-item.pt-intent-success:active::before, .pt-menu-item.pt-intent-success:active::after, .pt-menu-item.pt-intent-success:active .pt-menu-item-label, .pt-menu-item.pt-intent-success.pt-active, .pt-menu-item.pt-intent-success.pt-active::before, .pt-menu-item.pt-intent-success.pt-active::after, .pt-menu-item.pt-intent-success.pt-active .pt-menu-item-label {\n      color: #ffffff; }\n  .pt-menu-item.pt-intent-warning {\n    color: #bf7326; }\n    .pt-menu-item.pt-intent-warning::before, .pt-menu-item.pt-intent-warning::after, .pt-menu-item.pt-intent-warning .pt-menu-item-label {\n      color: #bf7326; }\n    .pt-menu-item.pt-intent-warning:hover, .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item, .pt-menu-item.pt-intent-warning.pt-active {\n      background-color: #d9822b; }\n    .pt-menu-item.pt-intent-warning:active {\n      background-color: #bf7326; }\n    .pt-menu-item.pt-intent-warning:hover, .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item, .pt-menu-item.pt-intent-warning:hover::before, .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item::before, .pt-menu-item.pt-intent-warning:hover::after, .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item::after, .pt-menu-item.pt-intent-warning:hover .pt-menu-item-label, .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item .pt-menu-item-label, .pt-menu-item.pt-intent-warning:active, .pt-menu-item.pt-intent-warning:active::before, .pt-menu-item.pt-intent-warning:active::after, .pt-menu-item.pt-intent-warning:active .pt-menu-item-label, .pt-menu-item.pt-intent-warning.pt-active, .pt-menu-item.pt-intent-warning.pt-active::before, .pt-menu-item.pt-intent-warning.pt-active::after, .pt-menu-item.pt-intent-warning.pt-active .pt-menu-item-label {\n      color: #ffffff; }\n  .pt-menu-item.pt-intent-danger {\n    color: #c23030; }\n    .pt-menu-item.pt-intent-danger::before, .pt-menu-item.pt-intent-danger::after, .pt-menu-item.pt-intent-danger .pt-menu-item-label {\n      color: #c23030; }\n    .pt-menu-item.pt-intent-danger:hover, .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item, .pt-menu-item.pt-intent-danger.pt-active {\n      background-color: #db3737; }\n    .pt-menu-item.pt-intent-danger:active {\n      background-color: #c23030; }\n    .pt-menu-item.pt-intent-danger:hover, .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item, .pt-menu-item.pt-intent-danger:hover::before, .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item::before, .pt-menu-item.pt-intent-danger:hover::after, .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item::after, .pt-menu-item.pt-intent-danger:hover .pt-menu-item-label, .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item .pt-menu-item-label, .pt-menu-item.pt-intent-danger:active, .pt-menu-item.pt-intent-danger:active::before, .pt-menu-item.pt-intent-danger:active::after, .pt-menu-item.pt-intent-danger:active .pt-menu-item-label, .pt-menu-item.pt-intent-danger.pt-active, .pt-menu-item.pt-intent-danger.pt-active::before, .pt-menu-item.pt-intent-danger.pt-active::after, .pt-menu-item.pt-intent-danger.pt-active .pt-menu-item-label {\n      color: #ffffff; }\n  .pt-menu-item::before {\n    line-height: 1;\n    font-family: \"Icons16\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    float: left;\n    margin-right: 7px; }\n  .pt-menu-item::before, .pt-menu-item::after {\n    color: #5c7080; }\n  .pt-menu-item .pt-menu-item-label {\n    color: #5c7080; }\n  .pt-menu-item:hover, .pt-submenu > .pt-popover-open > .pt-menu-item {\n    color: inherit; }\n  .pt-menu-item.pt-active, .pt-menu-item:active {\n    background-color: rgba(115, 134, 148, 0.3); }\n  .pt-menu-item.pt-disabled {\n    outline: none !important;\n    background-color: inherit !important;\n    cursor: not-allowed !important;\n    color: rgba(92, 112, 128, 0.5) !important; }\n    .pt-menu-item.pt-disabled::before, .pt-menu-item.pt-disabled::after, .pt-menu-item.pt-disabled .pt-menu-item-label {\n      color: rgba(92, 112, 128, 0.5) !important; }\n  .pt-large .pt-menu-item {\n    padding: 10px 7px;\n    line-height: 20px;\n    font-size: 16px; }\n    .pt-large .pt-menu-item::before {\n      line-height: 1;\n      font-family: \"Icons20\", sans-serif;\n      font-size: 20px;\n      font-weight: 400;\n      font-style: normal;\n      -moz-osx-font-smoothing: grayscale;\n      -webkit-font-smoothing: antialiased;\n      margin-right: 10px; }\n\na.pt-menu-item, a.pt-menu-item:hover, .pt-submenu > .pt-popover-open > a.pt-menu-item {\n  text-decoration: none; }\n\nbutton.pt-menu-item {\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left; }\n\n.pt-menu-item-label {\n  float: right;\n  margin-left: 7px; }\n\n.pt-menu-header {\n  display: block;\n  margin: 5px;\n  border-top: 1px solid rgba(16, 22, 26, 0.15);\n  cursor: default;\n  padding-left: 2px; }\n  .pt-dark .pt-menu-header {\n    border-top-color: rgba(255, 255, 255, 0.15); }\n  .pt-menu-header:first-of-type {\n    border-top: none; }\n  .pt-menu-header > h6 {\n    color: #182026;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    word-wrap: normal;\n    margin: 0;\n    padding: 10px 7px 0 1px;\n    line-height: 17px; }\n  .pt-menu-header:first-of-type > h6 {\n    padding-top: 0; }\n  .pt-large .pt-menu-header > h6 {\n    padding-top: 15px;\n    padding-bottom: 5px;\n    font-size: 18px; }\n  .pt-large .pt-menu-header:first-of-type > h6 {\n    padding-top: 0; }\n\n.pt-dark .pt-menu {\n  background: #30404d;\n  color: #f5f8fa; }\n\n.pt-dark .pt-menu-item.pt-intent-primary {\n  color: #48aff0; }\n  .pt-dark .pt-menu-item.pt-intent-primary::before, .pt-dark .pt-menu-item.pt-intent-primary::after, .pt-dark .pt-menu-item.pt-intent-primary .pt-menu-item-label {\n    color: #48aff0; }\n  .pt-dark .pt-menu-item.pt-intent-primary:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-primary.pt-active {\n    background-color: #137cbd; }\n  .pt-dark .pt-menu-item.pt-intent-primary:active {\n    background-color: #106ba3; }\n  .pt-dark .pt-menu-item.pt-intent-primary:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-primary:hover::before, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item::before, .pt-dark .pt-menu-item.pt-intent-primary:hover::after, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item::after, .pt-dark .pt-menu-item.pt-intent-primary:hover .pt-menu-item-label, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-primary.pt-menu-item .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-primary:active, .pt-dark .pt-menu-item.pt-intent-primary:active::before, .pt-dark .pt-menu-item.pt-intent-primary:active::after, .pt-dark .pt-menu-item.pt-intent-primary:active .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-primary.pt-active, .pt-dark .pt-menu-item.pt-intent-primary.pt-active::before, .pt-dark .pt-menu-item.pt-intent-primary.pt-active::after, .pt-dark .pt-menu-item.pt-intent-primary.pt-active .pt-menu-item-label {\n    color: #ffffff; }\n\n.pt-dark .pt-menu-item.pt-intent-success {\n  color: #3dcc91; }\n  .pt-dark .pt-menu-item.pt-intent-success::before, .pt-dark .pt-menu-item.pt-intent-success::after, .pt-dark .pt-menu-item.pt-intent-success .pt-menu-item-label {\n    color: #3dcc91; }\n  .pt-dark .pt-menu-item.pt-intent-success:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-success.pt-active {\n    background-color: #0f9960; }\n  .pt-dark .pt-menu-item.pt-intent-success:active {\n    background-color: #0d8050; }\n  .pt-dark .pt-menu-item.pt-intent-success:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-success:hover::before, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item::before, .pt-dark .pt-menu-item.pt-intent-success:hover::after, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item::after, .pt-dark .pt-menu-item.pt-intent-success:hover .pt-menu-item-label, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-success.pt-menu-item .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-success:active, .pt-dark .pt-menu-item.pt-intent-success:active::before, .pt-dark .pt-menu-item.pt-intent-success:active::after, .pt-dark .pt-menu-item.pt-intent-success:active .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-success.pt-active, .pt-dark .pt-menu-item.pt-intent-success.pt-active::before, .pt-dark .pt-menu-item.pt-intent-success.pt-active::after, .pt-dark .pt-menu-item.pt-intent-success.pt-active .pt-menu-item-label {\n    color: #ffffff; }\n\n.pt-dark .pt-menu-item.pt-intent-warning {\n  color: #ffb366; }\n  .pt-dark .pt-menu-item.pt-intent-warning::before, .pt-dark .pt-menu-item.pt-intent-warning::after, .pt-dark .pt-menu-item.pt-intent-warning .pt-menu-item-label {\n    color: #ffb366; }\n  .pt-dark .pt-menu-item.pt-intent-warning:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-warning.pt-active {\n    background-color: #d9822b; }\n  .pt-dark .pt-menu-item.pt-intent-warning:active {\n    background-color: #bf7326; }\n  .pt-dark .pt-menu-item.pt-intent-warning:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-warning:hover::before, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item::before, .pt-dark .pt-menu-item.pt-intent-warning:hover::after, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item::after, .pt-dark .pt-menu-item.pt-intent-warning:hover .pt-menu-item-label, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-warning.pt-menu-item .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-warning:active, .pt-dark .pt-menu-item.pt-intent-warning:active::before, .pt-dark .pt-menu-item.pt-intent-warning:active::after, .pt-dark .pt-menu-item.pt-intent-warning:active .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-warning.pt-active, .pt-dark .pt-menu-item.pt-intent-warning.pt-active::before, .pt-dark .pt-menu-item.pt-intent-warning.pt-active::after, .pt-dark .pt-menu-item.pt-intent-warning.pt-active .pt-menu-item-label {\n    color: #ffffff; }\n\n.pt-dark .pt-menu-item.pt-intent-danger {\n  color: #ff7373; }\n  .pt-dark .pt-menu-item.pt-intent-danger::before, .pt-dark .pt-menu-item.pt-intent-danger::after, .pt-dark .pt-menu-item.pt-intent-danger .pt-menu-item-label {\n    color: #ff7373; }\n  .pt-dark .pt-menu-item.pt-intent-danger:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-danger.pt-active {\n    background-color: #db3737; }\n  .pt-dark .pt-menu-item.pt-intent-danger:active {\n    background-color: #c23030; }\n  .pt-dark .pt-menu-item.pt-intent-danger:hover, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item, .pt-dark .pt-menu-item.pt-intent-danger:hover::before, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item::before, .pt-dark .pt-menu-item.pt-intent-danger:hover::after, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item::after, .pt-dark .pt-menu-item.pt-intent-danger:hover .pt-menu-item-label, .pt-dark .pt-submenu > .pt-popover-open > .pt-intent-danger.pt-menu-item .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-danger:active, .pt-dark .pt-menu-item.pt-intent-danger:active::before, .pt-dark .pt-menu-item.pt-intent-danger:active::after, .pt-dark .pt-menu-item.pt-intent-danger:active .pt-menu-item-label, .pt-dark .pt-menu-item.pt-intent-danger.pt-active, .pt-dark .pt-menu-item.pt-intent-danger.pt-active::before, .pt-dark .pt-menu-item.pt-intent-danger.pt-active::after, .pt-dark .pt-menu-item.pt-intent-danger.pt-active .pt-menu-item-label {\n    color: #ffffff; }\n\n.pt-dark .pt-menu-item::before, .pt-dark .pt-menu-item::after {\n  color: #bfccd6; }\n\n.pt-dark .pt-menu-item .pt-menu-item-label {\n  color: #bfccd6; }\n\n.pt-dark .pt-menu-item:hover::before, .pt-dark .pt-submenu > .pt-popover-open > .pt-menu-item::before, .pt-dark .pt-menu-item:hover::after, .pt-dark .pt-submenu > .pt-popover-open > .pt-menu-item::after {\n  color: #ffffff; }\n\n.pt-dark .pt-menu-item.pt-active, .pt-dark .pt-menu-item:active {\n  background-color: rgba(138, 155, 168, 0.3); }\n\n.pt-dark .pt-menu-item.pt-disabled {\n  color: rgba(191, 204, 214, 0.5) !important; }\n  .pt-dark .pt-menu-item.pt-disabled::before, .pt-dark .pt-menu-item.pt-disabled::after, .pt-dark .pt-menu-item.pt-disabled .pt-menu-item-label {\n    color: rgba(191, 204, 214, 0.5) !important; }\n\n.pt-dark .pt-menu-divider, .pt-dark .pt-menu-header {\n  border-color: rgba(255, 255, 255, 0.15); }\n\n.pt-dark .pt-menu-header > h6 {\n  color: #f5f8fa; }\n\n.pt-label .pt-menu {\n  margin-top: 5px; }\n\n.pt-navbar {\n  position: relative;\n  z-index: 10;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.2);\n  background-color: #ffffff;\n  height: 50px;\n  padding: 0 15px; }\n  .pt-navbar.pt-dark, .pt-dark .pt-navbar {\n    background-color: #394b59; }\n  .pt-navbar.pt-dark {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n  .pt-dark .pt-navbar {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 0 0 rgba(16, 22, 26, 0), 0 1px 1px rgba(16, 22, 26, 0.4); }\n  .pt-navbar.pt-fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0; }\n  .pt-navbar .pt-logo {\n    margin-right: 15px;\n    width: 20px; }\n\n.pt-navbar-heading {\n  margin-right: 15px;\n  font-size: 16px; }\n\n.pt-navbar-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 50px; }\n  .pt-navbar-group.pt-align-left {\n    float: left; }\n  .pt-navbar-group.pt-align-right {\n    float: right; }\n\n.pt-navbar-divider {\n  margin: 0 10px;\n  border-left: 1px solid rgba(16, 22, 26, 0.15);\n  height: 20px; }\n  .pt-dark .pt-navbar-divider {\n    border-left-color: rgba(255, 255, 255, 0.15); }\n\n.pt-non-ideal-state {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 400px;\n  height: 100%; }\n\n.pt-non-ideal-state > :not(:last-child) {\n  margin-bottom: 20px; }\n\n.pt-non-ideal-state-icon .pt-icon {\n  color: rgba(92, 112, 128, 0.5);\n  font-size: 60px; }\n  .pt-dark .pt-non-ideal-state-icon .pt-icon {\n    color: rgba(191, 204, 214, 0.5); }\n\n.pt-non-ideal-state-title, .pt-non-ideal-state-description {\n  text-align: center; }\n\nbody.pt-overlay-open {\n  overflow: hidden; }\n\n.pt-overlay {\n  position: static;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 20; }\n  .pt-overlay:not(.pt-overlay-open) {\n    pointer-events: none; }\n  .pt-overlay.pt-overlay-scroll-container {\n    position: fixed;\n    overflow: auto; }\n    .pt-overlay.pt-overlay-scroll-container.pt-overlay-inline {\n      position: absolute; }\n  .pt-overlay.pt-overlay-inline {\n    overflow: visible; }\n\n.pt-overlay-content {\n  position: fixed;\n  z-index: 20; }\n  .pt-overlay-inline .pt-overlay-content, .pt-overlay-scroll-container .pt-overlay-content {\n    position: absolute; }\n\n.pt-overlay-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  z-index: 20;\n  background-color: rgba(16, 22, 26, 0.7);\n  overflow: auto;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-overlay-backdrop.pt-overlay-enter, .pt-overlay-backdrop.pt-overlay-appear {\n    opacity: 0; }\n  .pt-overlay-backdrop.pt-overlay-enter-active, .pt-overlay-backdrop.pt-overlay-appear-active {\n    opacity: 1;\n    transition-property: opacity;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-overlay-backdrop.pt-overlay-leave {\n    opacity: 1; }\n  .pt-overlay-backdrop.pt-overlay-leave-active {\n    opacity: 0;\n    transition-property: opacity;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-overlay-backdrop:focus {\n    outline: none; }\n  .pt-overlay-inline .pt-overlay-backdrop {\n    position: absolute; }\n\n.pt-popover {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  display: inline-block;\n  z-index: 20;\n  border-radius: 3px; }\n  .pt-popover .pt-popover-arrow {\n    position: absolute;\n    width: 30px;\n    height: 30px; }\n    .pt-popover .pt-popover-arrow::before {\n      margin: 5px;\n      width: 20px;\n      height: 20px; }\n  .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-popover {\n    margin-top: -17px;\n    margin-bottom: 17px; }\n    .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-popover > .pt-popover-arrow {\n      bottom: -11px; }\n      .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-popover > .pt-popover-arrow svg {\n        -webkit-transform: rotate(-90deg);\n                transform: rotate(-90deg); }\n  .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-popover {\n    margin-left: 17px; }\n    .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-popover > .pt-popover-arrow {\n      left: -11px; }\n      .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-popover > .pt-popover-arrow svg {\n        -webkit-transform: rotate(0);\n                transform: rotate(0); }\n  .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-popover {\n    margin-top: 17px; }\n    .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-popover > .pt-popover-arrow {\n      top: -11px; }\n      .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-popover > .pt-popover-arrow svg {\n        -webkit-transform: rotate(90deg);\n                transform: rotate(90deg); }\n  .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-popover {\n    margin-right: 17px;\n    margin-left: -17px; }\n    .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-popover > .pt-popover-arrow {\n      right: -11px; }\n      .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-popover > .pt-popover-arrow svg {\n        -webkit-transform: rotate(180deg);\n                transform: rotate(180deg); }\n  .pt-tether-element-attached-middle > .pt-popover > .pt-popover-arrow {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  .pt-tether-element-attached-center > .pt-popover > .pt-popover-arrow {\n    right: 50%;\n    -webkit-transform: translateX(50%);\n            transform: translateX(50%); }\n  .pt-tether-element-attached-top.pt-tether-target-attached-top > .pt-popover > .pt-popover-arrow {\n    top: -0.3934px; }\n  .pt-tether-element-attached-right.pt-tether-target-attached-right > .pt-popover > .pt-popover-arrow {\n    right: -0.3934px; }\n  .pt-tether-element-attached-left.pt-tether-target-attached-left > .pt-popover > .pt-popover-arrow {\n    left: -0.3934px; }\n  .pt-tether-element-attached-bottom.pt-tether-target-attached-bottom > .pt-popover > .pt-popover-arrow {\n    bottom: -0.3934px; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-left > .pt-popover {\n    -webkit-transform-origin: top left;\n            transform-origin: top left; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-center > .pt-popover {\n    -webkit-transform-origin: top center;\n            transform-origin: top center; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-right > .pt-popover {\n    -webkit-transform-origin: top right;\n            transform-origin: top right; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-left > .pt-popover {\n    -webkit-transform-origin: center left;\n            transform-origin: center left; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-center > .pt-popover {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-right > .pt-popover {\n    -webkit-transform-origin: center right;\n            transform-origin: center right; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-left > .pt-popover {\n    -webkit-transform-origin: bottom left;\n            transform-origin: bottom left; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-center > .pt-popover {\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-right > .pt-popover {\n    -webkit-transform-origin: bottom right;\n            transform-origin: bottom right; }\n  .pt-popover .pt-popover-content {\n    background: #ffffff;\n    color: inherit; }\n  .pt-popover .pt-popover-arrow::before {\n    box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2); }\n  .pt-popover .pt-popover-arrow-border {\n    fill: #10161a;\n    fill-opacity: 0.1; }\n  .pt-popover .pt-popover-arrow-fill {\n    fill: #ffffff; }\n  .pt-popover-enter > .pt-popover, .pt-popover-appear > .pt-popover {\n    -webkit-transform: scale(0.3);\n            transform: scale(0.3); }\n  .pt-popover-enter-active > .pt-popover, .pt-popover-appear-active > .pt-popover {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-popover-leave > .pt-popover {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  .pt-popover-leave-active > .pt-popover {\n    -webkit-transform: scale(0.3);\n            transform: scale(0.3);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-popover .pt-popover-content {\n    position: relative;\n    border-radius: 3px; }\n  .pt-popover.pt-popover-content-sizing .pt-popover-content {\n    max-width: 350px;\n    padding: 20px; }\n  .pt-popover-target .pt-popover.pt-popover-content-sizing {\n    width: 350px; }\n  .pt-popover.pt-minimal {\n    margin: 0 !important; }\n    .pt-popover.pt-minimal .pt-popover-arrow {\n      display: none; }\n    .pt-popover.pt-minimal.pt-popover {\n      -webkit-transform: scale(1);\n              transform: scale(1); }\n      .pt-popover-enter > .pt-popover.pt-minimal.pt-popover, .pt-popover-appear > .pt-popover.pt-minimal.pt-popover {\n        -webkit-transform: scale(1);\n                transform: scale(1); }\n      .pt-popover-enter-active > .pt-popover.pt-minimal.pt-popover, .pt-popover-appear-active > .pt-popover.pt-minimal.pt-popover {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        transition-property: -webkit-transform;\n        transition-property: transform;\n        transition-property: transform, -webkit-transform;\n        transition-duration: 100ms;\n        transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n        transition-delay: 0; }\n      .pt-popover-leave > .pt-popover.pt-minimal.pt-popover {\n        -webkit-transform: scale(1);\n                transform: scale(1); }\n      .pt-popover-leave-active > .pt-popover.pt-minimal.pt-popover {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        transition-property: -webkit-transform;\n        transition-property: transform;\n        transition-property: transform, -webkit-transform;\n        transition-duration: 100ms;\n        transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n        transition-delay: 0; }\n  .pt-popover.pt-dark, .pt-dark .pt-popover {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n    .pt-popover.pt-dark .pt-popover-content, .pt-dark .pt-popover .pt-popover-content {\n      background: #30404d;\n      color: inherit; }\n    .pt-popover.pt-dark .pt-popover-arrow::before, .pt-dark .pt-popover .pt-popover-arrow::before {\n      box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4); }\n    .pt-popover.pt-dark .pt-popover-arrow-border, .pt-dark .pt-popover .pt-popover-arrow-border {\n      fill: #10161a;\n      fill-opacity: 0.2; }\n    .pt-popover.pt-dark .pt-popover-arrow-fill, .pt-dark .pt-popover .pt-popover-arrow-fill {\n      fill: #30404d; }\n\n.pt-popover-arrow::before {\n  display: block;\n  position: absolute;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  border-radius: 2px;\n  content: \"\"; }\n\n.pt-tether-pinned .pt-popover-arrow {\n  display: none; }\n\n.pt-popover-backdrop {\n  background: rgba(255, 255, 255, 0); }\n\n.pt-transition-container {\n  opacity: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 20; }\n  .pt-transition-container.pt-popover-enter, .pt-transition-container.pt-popover-appear {\n    opacity: 0; }\n  .pt-transition-container.pt-popover-enter-active, .pt-transition-container.pt-popover-appear-active {\n    opacity: 1;\n    transition-property: opacity;\n    transition-duration: 100ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-transition-container.pt-popover-leave {\n    opacity: 1; }\n  .pt-transition-container.pt-popover-leave-active {\n    opacity: 0;\n    transition-property: opacity;\n    transition-duration: 100ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-transition-container:focus {\n    outline: none; }\n  .pt-transition-container.pt-popover-leave .pt-popover-content {\n    pointer-events: none; }\n\n.pt-popover-target {\n  display: inline-block;\n  position: relative;\n  vertical-align: top; }\n  .pt-popover-target > .pt-popover-target {\n    display: inline-block; }\n  .pt-popover-target .pt-transition-container {\n    position: absolute; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-bottom.pt-tether-target-attached-top {\n      bottom: 100%; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-left.pt-tether-target-attached-right {\n      left: 100%; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-top.pt-tether-target-attached-bottom {\n      top: 100%; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-right.pt-tether-target-attached-left {\n      right: 100%; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-top.pt-tether-target-attached-top {\n      top: 0; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-right.pt-tether-target-attached-right {\n      right: 0; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-bottom.pt-tether-target-attached-bottom {\n      bottom: 0; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-left.pt-tether-target-attached-left {\n      left: 0; }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-middle {\n      top: 50%;\n      -webkit-transform: translateY(-50%);\n              transform: translateY(-50%); }\n    .pt-popover-target .pt-transition-container.pt-tether-element-attached-center {\n      left: 50%;\n      -webkit-transform: translateX(-50%);\n              transform: translateX(-50%); }\n  .pt-popover-target .pt-overlay-inline {\n    position: static; }\n\n.pt-button-group.pt-vertical .pt-popover-target {\n  display: block; }\n\n.pt-button-group:not(.pt-vertical) .pt-popover-target, .pt-button-group:not(.pt-vertical) .pt-tether-target {\n  float: left; }\n\n.pt-portal {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0; }\n\n@-webkit-keyframes linear-progress-bar-stripes {\n  from {\n    background-position: 0 0; }\n  to {\n    background-position: 30px 0; } }\n@keyframes linear-progress-bar-stripes {\n  from {\n    background-position: 0 0; }\n  to {\n    background-position: 30px 0; } }\n\n.pt-progress-bar {\n  display: block;\n  position: relative;\n  border-radius: 40px;\n  background: rgba(92, 112, 128, 0.2);\n  width: 100%;\n  height: 8px;\n  overflow: hidden; }\n  .pt-progress-bar .pt-progress-meter {\n    display: inline-block;\n    position: absolute;\n    border-radius: 40px;\n    background: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%);\n    background-color: rgba(92, 112, 128, 0.8);\n    background-size: 30px 30px;\n    width: 100%;\n    height: 100%;\n    transition: width 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n  .pt-progress-bar:not(.pt-no-animation):not(.pt-no-stripes) .pt-progress-meter {\n    -webkit-animation: linear-progress-bar-stripes 300ms linear infinite reverse;\n            animation: linear-progress-bar-stripes 300ms linear infinite reverse; }\n  .pt-progress-bar.pt-no-stripes .pt-progress-meter {\n    background-image: none; }\n\n.pt-dark .pt-progress-bar, .pt-progress-bar.pt-dark {\n  background: rgba(16, 22, 26, 0.5); }\n  .pt-dark .pt-progress-bar .pt-progress-meter, .pt-progress-bar.pt-dark .pt-progress-meter {\n    background-color: #8a9ba8; }\n\n.pt-progress-bar.pt-intent-primary .pt-progress-meter {\n  background-color: #137cbd; }\n\n.pt-progress-bar.pt-intent-success .pt-progress-meter {\n  background-color: #0f9960; }\n\n.pt-progress-bar.pt-intent-warning .pt-progress-meter {\n  background-color: #d9822b; }\n\n.pt-progress-bar.pt-intent-danger .pt-progress-meter {\n  background-color: #db3737; }\n\n@-webkit-keyframes glow {\n  0%, 100% {\n    border-color: rgba(167, 182, 194, 0.2);\n    background-color: rgba(167, 182, 194, 0.2); }\n  50% {\n    border-color: rgba(92, 112, 128, 0.2);\n    background-color: rgba(92, 112, 128, 0.2); } }\n@keyframes glow {\n  0%, 100% {\n    border-color: rgba(167, 182, 194, 0.2);\n    background-color: rgba(167, 182, 194, 0.2); }\n  50% {\n    border-color: rgba(92, 112, 128, 0.2);\n    background-color: rgba(92, 112, 128, 0.2); } }\n\n.pt-skeleton {\n  border-color: rgba(167, 182, 194, 0.2) !important;\n  border-radius: 2px;\n  box-shadow: none !important;\n  background: rgba(167, 182, 194, 0.2) !important;\n  background-clip: padding-box !important;\n  cursor: default;\n  color: transparent !important;\n  -webkit-animation: 2000ms linear infinite glow;\n          animation: 2000ms linear infinite glow;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.pt-slider {\n  position: relative;\n  cursor: default;\n  width: 100%;\n  min-width: 150px;\n  height: 40px;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-slider:hover {\n    cursor: pointer; }\n  .pt-slider:active {\n    cursor: -webkit-grabbing;\n    cursor: grabbing; }\n  .pt-slider.pt-disabled {\n    opacity: 0.5;\n    cursor: not-allowed; }\n  .pt-slider.pt-slider-unlabeled {\n    height: 16px; }\n\n.pt-slider-track, .pt-slider-progress {\n  position: absolute;\n  top: 5px;\n  right: 0;\n  left: 0;\n  border-radius: 3px;\n  background: rgba(92, 112, 128, 0.2);\n  height: 6px; }\n  .pt-dark .pt-slider-track, .pt-dark\n  .pt-slider-progress {\n    background: rgba(16, 22, 26, 0.5); }\n\n.pt-slider-progress, .pt-dark .pt-slider-progress {\n  background: #137cbd; }\n\n.pt-slider-handle {\n  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n  background-color: #f5f8fa;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));\n  color: #182026;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 3px;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n  cursor: pointer;\n  width: 16px;\n  height: 16px; }\n  .pt-slider-handle:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5; }\n  .pt-slider-handle:active, .pt-slider-handle.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none; }\n  .pt-slider-handle:disabled, .pt-slider-handle.pt-disabled {\n    outline: none;\n    box-shadow: none;\n    background-color: rgba(206, 217, 224, 0.5);\n    background-image: none;\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n    .pt-slider-handle:disabled.pt-active, .pt-slider-handle.pt-disabled.pt-active {\n      background: rgba(206, 217, 224, 0.7); }\n  .pt-slider-handle:focus {\n    z-index: 1; }\n  .pt-slider-handle:hover {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 -1px 0 rgba(16, 22, 26, 0.1);\n    background-clip: padding-box;\n    background-color: #ebf1f5;\n    z-index: 2;\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2);\n    cursor: -webkit-grab;\n    cursor: grab; }\n  .pt-slider-handle.pt-active {\n    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n    background-color: #d8e1e8;\n    background-image: none;\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), inset 0 1px 1px rgba(16, 22, 26, 0.1);\n    cursor: -webkit-grabbing;\n    cursor: grabbing; }\n  .pt-disabled .pt-slider-handle {\n    box-shadow: none;\n    background: #bfccd6;\n    pointer-events: none; }\n  .pt-dark .pt-slider-handle {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n    background-color: #394b59;\n    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));\n    color: #f5f8fa; }\n    .pt-dark .pt-slider-handle:hover, .pt-dark .pt-slider-handle:active, .pt-dark .pt-slider-handle.pt-active {\n      color: #f5f8fa; }\n    .pt-dark .pt-slider-handle:hover {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.4);\n      background-color: #30404d; }\n    .pt-dark .pt-slider-handle:active, .pt-dark .pt-slider-handle.pt-active {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.6), inset 0 1px 2px rgba(16, 22, 26, 0.2);\n      background-color: #202b33;\n      background-image: none; }\n    .pt-dark .pt-slider-handle:disabled, .pt-dark .pt-slider-handle.pt-disabled {\n      box-shadow: none;\n      background-color: rgba(57, 75, 89, 0.5);\n      background-image: none;\n      color: rgba(191, 204, 214, 0.5); }\n      .pt-dark .pt-slider-handle:disabled.pt-active, .pt-dark .pt-slider-handle.pt-disabled.pt-active {\n        background: rgba(57, 75, 89, 0.7); }\n    .pt-dark .pt-slider-handle .pt-button-spinner .pt-spinner-head {\n      background: rgba(16, 22, 26, 0.5);\n      stroke: #8a9ba8; }\n    .pt-dark .pt-slider-handle, .pt-dark .pt-slider-handle:hover {\n      background-color: #394b59; }\n    .pt-dark .pt-slider-handle.pt-active {\n      background-color: #293742; }\n  .pt-dark .pt-disabled .pt-slider-handle {\n    border-color: #5c7080;\n    box-shadow: none;\n    background: #5c7080; }\n  .pt-slider-handle .pt-slider-label {\n    -webkit-transform: translate(-50%, 20px);\n            transform: translate(-50%, 20px);\n    margin-left: 8px;\n    border-radius: 3px;\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n    background: #394b59;\n    color: #f5f8fa; }\n    .pt-dark .pt-slider-handle .pt-slider-label {\n      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n      background: #e1e8ed;\n      color: #394b59; }\n    .pt-disabled .pt-slider-handle .pt-slider-label {\n      box-shadow: none; }\n\n.pt-slider-label {\n  display: inline-block;\n  padding: 2px 5px;\n  vertical-align: top;\n  line-height: 1;\n  font-size: 12px;\n  position: absolute;\n  -webkit-transform: translate(-50%, 20px);\n          transform: translate(-50%, 20px); }\n\n.pt-range-slider .pt-slider-handle {\n  width: 8px; }\n  .pt-range-slider .pt-slider-handle:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .pt-range-slider .pt-slider-handle:last-of-type {\n    margin-left: 8px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n    .pt-range-slider .pt-slider-handle:last-of-type .pt-slider-label {\n      margin-left: 0; }\n\n.pt-range-slider .pt-slider-progress {\n  border-radius: 0; }\n\n@-webkit-keyframes pt-spinner-animation {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n@keyframes pt-spinner-animation {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.pt-spinner:not(.pt-svg-spinner) {\n  width: 50px; }\n  .pt-spinner:not(.pt-svg-spinner) .pt-spinner-svg-container {\n    -webkit-animation-duration: 400ms;\n            animation-duration: 400ms; }\n\n.pt-spinner.pt-svg-spinner {\n  -webkit-animation-duration: 400ms;\n          animation-duration: 400ms; }\n\n.pt-spinner .pt-svg-spinner-transform-group {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5); }\n\n.pt-spinner path {\n  stroke-width: 5; }\n\n.pt-spinner path {\n  fill-opacity: 0; }\n\n.pt-spinner .pt-spinner-head {\n  transition: stroke-dashoffset 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  stroke: rgba(92, 112, 128, 0.8);\n  stroke-linecap: round; }\n\n.pt-spinner .pt-spinner-track {\n  stroke: rgba(92, 112, 128, 0.2); }\n\n.pt-spinner.pt-small:not(.pt-svg-spinner) {\n  width: 24px; }\n  .pt-spinner.pt-small:not(.pt-svg-spinner) .pt-spinner-svg-container {\n    -webkit-animation-duration: 400ms;\n            animation-duration: 400ms; }\n\n.pt-spinner.pt-small.pt-svg-spinner {\n  -webkit-animation-duration: 400ms;\n          animation-duration: 400ms; }\n\n.pt-spinner.pt-small .pt-svg-spinner-transform-group {\n  -webkit-transform: scale(0.24);\n          transform: scale(0.24); }\n\n.pt-spinner.pt-small path {\n  stroke-width: 12; }\n\n.pt-spinner.pt-large:not(.pt-svg-spinner) {\n  width: 100px; }\n  .pt-spinner.pt-large:not(.pt-svg-spinner) .pt-spinner-svg-container {\n    -webkit-animation-duration: 450ms;\n            animation-duration: 450ms; }\n\n.pt-spinner.pt-large.pt-svg-spinner {\n  -webkit-animation-duration: 450ms;\n          animation-duration: 450ms; }\n\n.pt-spinner.pt-large .pt-svg-spinner-transform-group {\n  -webkit-transform: scale(1);\n          transform: scale(1); }\n\n.pt-spinner.pt-large path {\n  stroke-width: 3; }\n\n.pt-spinner:not(.pt-svg-spinner) {\n  display: inline-block; }\n  .pt-spinner:not(.pt-svg-spinner) .pt-spinner-svg-container {\n    position: relative;\n    width: 100%;\n    height: 0;\n    padding: 0;\n    padding-bottom: 100%;\n    -webkit-animation: pt-spinner-animation 400ms linear infinite;\n            animation: pt-spinner-animation 400ms linear infinite; }\n  .pt-spinner:not(.pt-svg-spinner).pt-no-spin .pt-spinner-svg-container {\n    -webkit-animation: none;\n            animation: none; }\n  .pt-spinner:not(.pt-svg-spinner) svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n\n.pt-svg-spinner {\n  -webkit-transform-origin: center;\n          transform-origin: center;\n  -webkit-animation: pt-spinner-animation 400ms linear infinite;\n          animation: pt-spinner-animation 400ms linear infinite; }\n  .pt-svg-spinner.pt-no-spin {\n    -webkit-animation: none;\n            animation: none; }\n\n.pt-svg-spinner-transform-group {\n  -webkit-transform-origin: center;\n          transform-origin: center; }\n\n.pt-dark .pt-spinner .pt-spinner-head {\n  stroke: #8a9ba8; }\n\n.pt-dark .pt-spinner .pt-spinner-track {\n  stroke: rgba(16, 22, 26, 0.5); }\n\n.pt-spinner.pt-intent-primary .pt-spinner-head {\n  stroke: #137cbd; }\n\n.pt-spinner.pt-intent-success .pt-spinner-head {\n  stroke: #0f9960; }\n\n.pt-spinner.pt-intent-warning .pt-spinner-head {\n  stroke: #d9822b; }\n\n.pt-spinner.pt-intent-danger .pt-spinner-head {\n  stroke: #db3737; }\n\ntable.pt-table {\n  border-spacing: 0;\n  font-size: 14px; }\n  table.pt-table th, table.pt-table td {\n    padding: 11px;\n    vertical-align: top;\n    text-align: left; }\n  table.pt-table th {\n    color: #182026;\n    font-weight: 600; }\n  table.pt-table td {\n    color: #182026; }\n  table.pt-table tbody tr:first-child td {\n    box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15); }\n  table.pt-table.pt-condensed th, table.pt-table.pt-condensed td {\n    padding-top: 6px;\n    padding-bottom: 6px; }\n  table.pt-table.pt-striped tbody tr:nth-child(odd) td {\n    background: rgba(191, 204, 214, 0.2); }\n  table.pt-table.pt-bordered th:not(:first-child) {\n    box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15); }\n  table.pt-table.pt-bordered tbody tr td {\n    box-shadow: inset 0 1px 0 0 rgba(16, 22, 26, 0.15); }\n    table.pt-table.pt-bordered tbody tr td:not(:first-child) {\n      box-shadow: inset 1px 1px 0 0 rgba(16, 22, 26, 0.15); }\n  table.pt-table.pt-bordered.pt-striped tbody tr:not(:first-child) td {\n    box-shadow: none; }\n    table.pt-table.pt-bordered.pt-striped tbody tr:not(:first-child) td:not(:first-child) {\n      box-shadow: inset 1px 0 0 0 rgba(16, 22, 26, 0.15); }\n  table.pt-table.pt-interactive tbody tr:hover td {\n    background-color: rgba(191, 204, 214, 0.4);\n    cursor: pointer; }\n  .pt-dark table.pt-table th {\n    color: #f5f8fa; }\n  .pt-dark table.pt-table td {\n    color: #f5f8fa; }\n  .pt-dark table.pt-table tbody tr:first-child td {\n    box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15); }\n  .pt-dark table.pt-table.pt-striped tbody tr:nth-child(odd) td {\n    background: rgba(92, 112, 128, 0.15); }\n  .pt-dark table.pt-table.pt-bordered th:not(:first-child) {\n    box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15); }\n  .pt-dark table.pt-table.pt-bordered tbody tr td {\n    box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15); }\n    .pt-dark table.pt-table.pt-bordered tbody tr td:not(:first-child) {\n      box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.15); }\n  .pt-dark table.pt-table.pt-bordered.pt-striped tbody tr:not(:first-child) td {\n    box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.15); }\n    .pt-dark table.pt-table.pt-bordered.pt-striped tbody tr:not(:first-child) td:first-child {\n      box-shadow: none; }\n  .pt-dark table.pt-table.pt-interactive tbody tr:hover td {\n    background-color: rgba(92, 112, 128, 0.3);\n    cursor: pointer; }\n\n.pt-tabs.pt-vertical {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .pt-tabs.pt-vertical > .pt-tab-list {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n    .pt-tabs.pt-vertical > .pt-tab-list .pt-tab {\n      width: 100%;\n      padding: 0 10px; }\n    .pt-tabs.pt-vertical > .pt-tab-list .pt-tab-indicator-wrapper .pt-tab-indicator {\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      border-radius: 3px;\n      background-color: rgba(19, 124, 189, 0.2);\n      height: auto; }\n  .pt-tabs.pt-vertical > .pt-tab-panel {\n    margin-top: 0;\n    padding-left: 20px; }\n\n.pt-tab-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  position: relative;\n  margin: 0;\n  border: none;\n  padding: 0;\n  list-style: none; }\n  .pt-tab-list > *:not(:last-child) {\n    margin-right: 20px; }\n\n.pt-tab {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  position: relative;\n  cursor: pointer;\n  max-width: 100%;\n  vertical-align: top;\n  line-height: 30px;\n  color: #182026;\n  font-size: 14px; }\n  .pt-tab-indicator-wrapper ~ .pt-tab {\n    box-shadow: none !important; }\n  .pt-tab[aria-disabled=\"true\"] {\n    cursor: not-allowed;\n    color: rgba(92, 112, 128, 0.5); }\n  .pt-tab[aria-selected=\"true\"] {\n    border-radius: 0;\n    box-shadow: inset 0 -3px 0 #106ba3; }\n  .pt-tab[aria-selected=\"true\"], .pt-tab:not([aria-disabled=\"true\"]):hover {\n    color: #106ba3; }\n  .pt-tab:focus {\n    -moz-outline-radius: 0; }\n  .pt-large .pt-tab {\n    line-height: 40px;\n    font-size: 16px; }\n\n.pt-tab-panel {\n  margin-top: 20px; }\n  .pt-tab-panel[aria-hidden=\"true\"] {\n    display: none; }\n\n.pt-tab-indicator-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-transform: translateX(0), translateY(0);\n          transform: translateX(0), translateY(0);\n  transition: height, width, -webkit-transform;\n  transition: height, transform, width;\n  transition: height, transform, width, -webkit-transform;\n  transition-duration: 200ms;\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n  pointer-events: none; }\n  .pt-tab-indicator-wrapper .pt-tab-indicator {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: #106ba3;\n    height: 3px; }\n  .pt-tab-indicator-wrapper.pt-no-animation {\n    transition: none; }\n\n.pt-dark .pt-tab {\n  color: #f5f8fa; }\n  .pt-dark .pt-tab[aria-disabled=\"true\"] {\n    color: rgba(191, 204, 214, 0.5); }\n  .pt-dark .pt-tab[aria-selected=\"true\"] {\n    box-shadow: inset 0 -3px 0 #48aff0; }\n  .pt-dark .pt-tab[aria-selected=\"true\"], .pt-dark .pt-tab:not([aria-disabled=\"true\"]):hover {\n    color: #48aff0; }\n\n.pt-dark .pt-tab-indicator {\n  background-color: #48aff0; }\n\n.pt-flex-expander {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1;\n          flex: 1 1; }\n\n.pt-tag {\n  display: inline-block;\n  position: relative;\n  border: none;\n  border-radius: 3px;\n  box-shadow: none;\n  background-color: #5c7080;\n  min-width: 20px;\n  padding: 2px 6px;\n  line-height: 16px;\n  color: #f5f8fa;\n  font-size: 12px;\n   }\n  .pt-tag.pt-round {\n    border-radius: 10px; }\n  .pt-dark .pt-tag {\n    background-color: #bfccd6;\n    color: #182026; }\n  .pt-tag.pt-tag-removable {\n    padding-right: 20px; }\n  .pt-tag.pt-active {\n    outline: rgba(19, 124, 189, 0.5) auto 2px;\n    outline-offset: 0;\n    -moz-outline-radius: 6px; }\n  .pt-tag.pt-large, .pt-large .pt-tag {\n    min-width: 30px;\n    padding: 5px 10px;\n    line-height: 20px;\n    font-size: 14px; }\n    .pt-tag.pt-large.pt-round, .pt-large .pt-tag.pt-round {\n      border-radius: 15px; }\n    .pt-tag.pt-large.pt-tag-removable, .pt-large .pt-tag.pt-tag-removable {\n      padding-right: 30px; }\n  .pt-tag.pt-intent-primary {\n    background: #137cbd;\n    color: #ffffff; }\n  .pt-tag.pt-intent-success {\n    background: #0f9960;\n    color: #ffffff; }\n  .pt-tag.pt-intent-warning {\n    background: #d9822b;\n    color: #ffffff; }\n  .pt-tag.pt-intent-danger {\n    background: #db3737;\n    color: #ffffff; }\n  .pt-tag.pt-minimal:not([class*=\"pt-intent-\"]) {\n    background-color: rgba(138, 155, 168, 0.2);\n    color: #182026; }\n    .pt-dark .pt-tag.pt-minimal:not([class*=\"pt-intent-\"]) {\n      color: #f5f8fa; }\n  .pt-tag.pt-minimal.pt-intent-primary {\n    background-color: rgba(19, 124, 189, 0.15);\n    color: #106ba3; }\n    .pt-dark .pt-tag.pt-minimal.pt-intent-primary {\n      background-color: rgba(19, 124, 189, 0.25);\n      color: #48aff0; }\n  .pt-tag.pt-minimal.pt-intent-success {\n    background-color: rgba(15, 153, 96, 0.15);\n    color: #0d8050; }\n    .pt-dark .pt-tag.pt-minimal.pt-intent-success {\n      background-color: rgba(15, 153, 96, 0.25);\n      color: #3dcc91; }\n  .pt-tag.pt-minimal.pt-intent-warning {\n    background-color: rgba(217, 130, 43, 0.15);\n    color: #bf7326; }\n    .pt-dark .pt-tag.pt-minimal.pt-intent-warning {\n      background-color: rgba(217, 130, 43, 0.25);\n      color: #ffb366; }\n  .pt-tag.pt-minimal.pt-intent-danger {\n    background-color: rgba(219, 55, 55, 0.15);\n    color: #c23030; }\n    .pt-dark .pt-tag.pt-minimal.pt-intent-danger {\n      background-color: rgba(219, 55, 55, 0.25);\n      color: #ff7373; }\n\n.pt-tag-remove {\n  line-height: 1;\n  font-family: \"Icons16\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 2px;\n  color: inherit; }\n  .pt-tag-remove:hover {\n    opacity: 0.8;\n    background: none;\n    text-decoration: none; }\n  .pt-tag-remove:active {\n    opacity: 1; }\n  .pt-tag-remove::before {\n    content: \"\\E6D7\"; }\n  .pt-large .pt-tag-remove {\n    line-height: 1;\n    font-family: \"Icons20\", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    font-style: normal;\n    padding: 5px; }\n\n.pt-toast {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  position: relative !important;\n  margin: 20px 0 0;\n  border-radius: 3px;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  background-color: #ffffff;\n  min-width: 300px;\n  max-width: 500px;\n  pointer-events: all; }\n  .pt-toast.pt-toast-enter, .pt-toast.pt-toast-appear {\n    -webkit-transform: translateY(-40px);\n            transform: translateY(-40px); }\n  .pt-toast.pt-toast-enter-active, .pt-toast.pt-toast-appear-active {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-toast.pt-toast-enter ~ .pt-toast, .pt-toast.pt-toast-appear ~ .pt-toast {\n    -webkit-transform: translateY(-40px);\n            transform: translateY(-40px); }\n  .pt-toast.pt-toast-enter-active ~ .pt-toast, .pt-toast.pt-toast-appear-active ~ .pt-toast {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n    transition-delay: 0; }\n  .pt-toast.pt-toast-leave {\n    opacity: 1;\n    -webkit-filter: blur(0);\n            filter: blur(0); }\n  .pt-toast.pt-toast-leave-active {\n    opacity: 0;\n    -webkit-filter: blur(10px);\n            filter: blur(10px);\n    transition-property: opacity, -webkit-filter;\n    transition-property: opacity, filter;\n    transition-property: opacity, filter, -webkit-filter;\n    transition-duration: 300ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-toast.pt-toast-leave ~ .pt-toast {\n    -webkit-transform: translateY(0);\n            transform: translateY(0); }\n  .pt-toast.pt-toast-leave-active ~ .pt-toast {\n    -webkit-transform: translateY(-40px);\n            transform: translateY(-40px);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 100ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 50ms; }\n  .pt-toast .pt-button-group {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    padding: 5px;\n    padding-left: 0; }\n  .pt-toast > .pt-icon-standard {\n    padding: 12px;\n    padding-right: 0;\n    color: #5c7080; }\n  .pt-toast.pt-dark, .pt-dark .pt-toast {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4);\n    background-color: #394b59; }\n    .pt-toast.pt-dark > .pt-icon-standard, .pt-dark .pt-toast > .pt-icon-standard {\n      color: #bfccd6; }\n  .pt-toast[class*=\"pt-intent-\"] a {\n    color: rgba(255, 255, 255, 0.7); }\n    .pt-toast[class*=\"pt-intent-\"] a:hover {\n      color: #ffffff; }\n  .pt-toast[class*=\"pt-intent-\"] > .pt-icon-standard {\n    color: #ffffff; }\n  .pt-toast[class*=\"pt-intent-\"] .pt-button, .pt-toast[class*=\"pt-intent-\"] .pt-button::before, .pt-toast[class*=\"pt-intent-\"] .pt-button:active {\n    color: rgba(255, 255, 255, 0.7) !important; }\n  .pt-toast[class*=\"pt-intent-\"] .pt-button:focus {\n    outline-color: rgba(255, 255, 255, 0.5); }\n  .pt-toast[class*=\"pt-intent-\"] .pt-button:hover {\n    background-color: rgba(255, 255, 255, 0.15) !important;\n    color: #ffffff !important; }\n  .pt-toast[class*=\"pt-intent-\"] .pt-button:active {\n    background-color: rgba(255, 255, 255, 0.3) !important;\n    color: #ffffff !important; }\n  .pt-toast[class*=\"pt-intent-\"] .pt-button::after {\n    background: rgba(255, 255, 255, 0.3) !important; }\n  .pt-toast.pt-intent-primary {\n    background-color: #137cbd;\n    color: #ffffff; }\n  .pt-toast.pt-intent-success {\n    background-color: #0f9960;\n    color: #ffffff; }\n  .pt-toast.pt-intent-warning {\n    background-color: #d9822b;\n    color: #ffffff; }\n  .pt-toast.pt-intent-danger {\n    background-color: #db3737;\n    color: #ffffff; }\n\n.pt-toast-message {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  padding: 11px; }\n\n.pt-toast-container {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 40;\n  pointer-events: none; }\n  .pt-toast-container > span {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    overflow: hidden;\n    padding: 0 20px 20px; }\n  .pt-toast-container.pt-toast-container-top {\n    top: 0;\n    bottom: auto; }\n  .pt-toast-container.pt-toast-container-bottom {\n    top: auto;\n    bottom: 0; }\n    .pt-toast-container.pt-toast-container-bottom > span {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: reverse;\n          -ms-flex-direction: column-reverse;\n              flex-direction: column-reverse; }\n  .pt-toast-container.pt-toast-container-left > span {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start; }\n  .pt-toast-container.pt-toast-container-right > span {\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end; }\n\n.pt-toast-container-bottom .pt-toast.pt-toast-enter:not(.pt-toast-enter-active), .pt-toast-container-bottom .pt-toast.pt-toast-enter:not(.pt-toast-enter-active) ~ .pt-toast, .pt-toast-container-bottom .pt-toast.pt-toast-leave-active ~ .pt-toast {\n  -webkit-transform: translateY(60px);\n          transform: translateY(60px); }\n\n.pt-tooltip {\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  -webkit-transform: scale(1);\n          transform: scale(1); }\n  .pt-tooltip .pt-popover-arrow {\n    position: absolute;\n    width: 22px;\n    height: 22px; }\n    .pt-tooltip .pt-popover-arrow::before {\n      margin: 4px;\n      width: 14px;\n      height: 14px; }\n  .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-tooltip {\n    margin-top: -11px;\n    margin-bottom: 11px; }\n    .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-tooltip > .pt-popover-arrow {\n      bottom: -8px; }\n      .pt-tether-element-attached-bottom.pt-tether-target-attached-top > .pt-tooltip > .pt-popover-arrow svg {\n        -webkit-transform: rotate(-90deg);\n                transform: rotate(-90deg); }\n  .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-tooltip {\n    margin-left: 11px; }\n    .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-tooltip > .pt-popover-arrow {\n      left: -8px; }\n      .pt-tether-element-attached-left.pt-tether-target-attached-right > .pt-tooltip > .pt-popover-arrow svg {\n        -webkit-transform: rotate(0);\n                transform: rotate(0); }\n  .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-tooltip {\n    margin-top: 11px; }\n    .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-tooltip > .pt-popover-arrow {\n      top: -8px; }\n      .pt-tether-element-attached-top.pt-tether-target-attached-bottom > .pt-tooltip > .pt-popover-arrow svg {\n        -webkit-transform: rotate(90deg);\n                transform: rotate(90deg); }\n  .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-tooltip {\n    margin-right: 11px;\n    margin-left: -11px; }\n    .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-tooltip > .pt-popover-arrow {\n      right: -8px; }\n      .pt-tether-element-attached-right.pt-tether-target-attached-left > .pt-tooltip > .pt-popover-arrow svg {\n        -webkit-transform: rotate(180deg);\n                transform: rotate(180deg); }\n  .pt-tether-element-attached-middle > .pt-tooltip > .pt-popover-arrow {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n  .pt-tether-element-attached-center > .pt-tooltip > .pt-popover-arrow {\n    right: 50%;\n    -webkit-transform: translateX(50%);\n            transform: translateX(50%); }\n  .pt-tether-element-attached-top.pt-tether-target-attached-top > .pt-tooltip > .pt-popover-arrow {\n    top: -0.22183px; }\n  .pt-tether-element-attached-right.pt-tether-target-attached-right > .pt-tooltip > .pt-popover-arrow {\n    right: -0.22183px; }\n  .pt-tether-element-attached-left.pt-tether-target-attached-left > .pt-tooltip > .pt-popover-arrow {\n    left: -0.22183px; }\n  .pt-tether-element-attached-bottom.pt-tether-target-attached-bottom > .pt-tooltip > .pt-popover-arrow {\n    bottom: -0.22183px; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-left > .pt-tooltip {\n    -webkit-transform-origin: top left;\n            transform-origin: top left; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-center > .pt-tooltip {\n    -webkit-transform-origin: top center;\n            transform-origin: top center; }\n  .pt-tether-element-attached-top.pt-tether-element-attached-right > .pt-tooltip {\n    -webkit-transform-origin: top right;\n            transform-origin: top right; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-left > .pt-tooltip {\n    -webkit-transform-origin: center left;\n            transform-origin: center left; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-center > .pt-tooltip {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n  .pt-tether-element-attached-middle.pt-tether-element-attached-right > .pt-tooltip {\n    -webkit-transform-origin: center right;\n            transform-origin: center right; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-left > .pt-tooltip {\n    -webkit-transform-origin: bottom left;\n            transform-origin: bottom left; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-center > .pt-tooltip {\n    -webkit-transform-origin: bottom center;\n            transform-origin: bottom center; }\n  .pt-tether-element-attached-bottom.pt-tether-element-attached-right > .pt-tooltip {\n    -webkit-transform-origin: bottom right;\n            transform-origin: bottom right; }\n  .pt-tooltip .pt-popover-content {\n    background: #394b59;\n    color: #f5f8fa; }\n  .pt-tooltip .pt-popover-arrow::before {\n    box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.2); }\n  .pt-tooltip .pt-popover-arrow-border {\n    fill: #10161a;\n    fill-opacity: 0.1; }\n  .pt-tooltip .pt-popover-arrow-fill {\n    fill: #394b59; }\n  .pt-popover-enter > .pt-tooltip, .pt-popover-appear > .pt-tooltip {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8); }\n  .pt-popover-enter-active > .pt-tooltip, .pt-popover-appear-active > .pt-tooltip {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 100ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-popover-leave > .pt-tooltip {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  .pt-popover-leave-active > .pt-tooltip {\n    -webkit-transform: scale(0.8);\n            transform: scale(0.8);\n    transition-property: -webkit-transform;\n    transition-property: transform;\n    transition-property: transform, -webkit-transform;\n    transition-duration: 100ms;\n    transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition-delay: 0; }\n  .pt-tooltip .pt-popover-content {\n    padding: 10px 12px; }\n  .pt-tooltip.pt-dark, .pt-dark .pt-tooltip {\n    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.4), 0 8px 24px rgba(16, 22, 26, 0.4); }\n    .pt-tooltip.pt-dark .pt-popover-content, .pt-dark .pt-tooltip .pt-popover-content {\n      background: #e1e8ed;\n      color: #394b59; }\n    .pt-tooltip.pt-dark .pt-popover-arrow::before, .pt-dark .pt-tooltip .pt-popover-arrow::before {\n      box-shadow: 1px 1px 6px rgba(16, 22, 26, 0.4); }\n    .pt-tooltip.pt-dark .pt-popover-arrow-border, .pt-dark .pt-tooltip .pt-popover-arrow-border {\n      fill: #10161a;\n      fill-opacity: 0.2; }\n    .pt-tooltip.pt-dark .pt-popover-arrow-fill, .pt-dark .pt-tooltip .pt-popover-arrow-fill {\n      fill: #e1e8ed; }\n  .pt-tooltip.pt-intent-primary .pt-popover-content {\n    background: #137cbd;\n    color: #ffffff; }\n  .pt-tooltip.pt-intent-primary .pt-popover-arrow-fill {\n    fill: #137cbd; }\n  .pt-tooltip.pt-intent-success .pt-popover-content {\n    background: #0f9960;\n    color: #ffffff; }\n  .pt-tooltip.pt-intent-success .pt-popover-arrow-fill {\n    fill: #0f9960; }\n  .pt-tooltip.pt-intent-warning .pt-popover-content {\n    background: #d9822b;\n    color: #ffffff; }\n  .pt-tooltip.pt-intent-warning .pt-popover-arrow-fill {\n    fill: #d9822b; }\n  .pt-tooltip.pt-intent-danger .pt-popover-content {\n    background: #db3737;\n    color: #ffffff; }\n  .pt-tooltip.pt-intent-danger .pt-popover-arrow-fill {\n    fill: #db3737; }\n\n.pt-popover-target .pt-tooltip {\n  white-space: nowrap; }\n\n.pt-tooltip-indicator {\n  border-bottom: dotted 1px;\n  cursor: help; }\n\n.pt-tree-node-list {\n  margin: 0;\n  padding-left: 0;\n  list-style: none; }\n\n.pt-tree-root {\n  position: relative;\n  background-color: transparent;\n  cursor: default;\n  padding-left: 0; }\n\n.pt-tree-node-content-0 {\n  padding-left: 0px; }\n\n.pt-tree-node-content-1 {\n  padding-left: 23px; }\n\n.pt-tree-node-content-2 {\n  padding-left: 46px; }\n\n.pt-tree-node-content-3 {\n  padding-left: 69px; }\n\n.pt-tree-node-content-4 {\n  padding-left: 92px; }\n\n.pt-tree-node-content-5 {\n  padding-left: 115px; }\n\n.pt-tree-node-content-6 {\n  padding-left: 138px; }\n\n.pt-tree-node-content-7 {\n  padding-left: 161px; }\n\n.pt-tree-node-content-8 {\n  padding-left: 184px; }\n\n.pt-tree-node-content-9 {\n  padding-left: 207px; }\n\n.pt-tree-node-content-10 {\n  padding-left: 230px; }\n\n.pt-tree-node-content-11 {\n  padding-left: 253px; }\n\n.pt-tree-node-content-12 {\n  padding-left: 276px; }\n\n.pt-tree-node-content-13 {\n  padding-left: 299px; }\n\n.pt-tree-node-content-14 {\n  padding-left: 322px; }\n\n.pt-tree-node-content-15 {\n  padding-left: 345px; }\n\n.pt-tree-node-content-16 {\n  padding-left: 368px; }\n\n.pt-tree-node-content-17 {\n  padding-left: 391px; }\n\n.pt-tree-node-content-18 {\n  padding-left: 414px; }\n\n.pt-tree-node-content-19 {\n  padding-left: 437px; }\n\n.pt-tree-node-content-20 {\n  padding-left: 460px; }\n\n.pt-tree-node-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  height: 30px;\n  padding-right: 5px; }\n  .pt-tree-node-content:hover {\n    background-color: rgba(191, 204, 214, 0.4); }\n\n.pt-tree-node-caret, .pt-tree-node-caret-none {\n  position: relative;\n  min-width: 30px;\n  line-height: 30px !important; }\n\n.pt-tree-node-caret {\n  color: #5c7080;\n  cursor: pointer;\n  text-align: center; }\n  .pt-tree-node-caret:hover {\n    color: #182026; }\n  .pt-dark .pt-tree-node-caret {\n    color: #bfccd6; }\n    .pt-dark .pt-tree-node-caret:hover {\n      color: #f5f8fa; }\n  .pt-tree-node-caret::before {\n    display: inline-block;\n    content: \"\\E695\";\n    transition: -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n    transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), -webkit-transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9); }\n  .pt-tree-node-caret.pt-tree-node-caret-open::before {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg); }\n\n.pt-tree-node-icon {\n  position: relative;\n  margin-right: 7px;\n  color: #5c7080; }\n\n.pt-tree-node-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .pt-tree-node-label span {\n    display: inline; }\n\n.pt-tree-node-secondary-label {\n  padding: 0 5px;\n  line-height: 30px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.pt-tree-node.pt-tree-node-selected > .pt-tree-node-content {\n  background-color: #137cbd; }\n  .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content, .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content .pt-icon, .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content .pt-icon-standard, .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content .pt-icon-large {\n    color: #ffffff; }\n  .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content .pt-tree-node-caret::before {\n    color: rgba(255, 255, 255, 0.7); }\n  .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content .pt-tree-node-caret:hover::before {\n    color: #ffffff; }\n\n.pt-dark .pt-tree-node-content:hover {\n  background-color: rgba(92, 112, 128, 0.3); }\n\n.pt-dark .pt-tree-node-icon {\n  color: #bfccd6; }\n\n.pt-dark .pt-tree-node.pt-tree-node-selected > .pt-tree-node-content {\n  background-color: #137cbd; }\n", ""]);

// exports


/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n@font-face {\n  font-family: 'anticon';\n  src: url('//at.alicdn.com/t/font_1434092639_4910953.eot');\n  /* IE9*/\n  src: url('//at.alicdn.com/t/font_1434092639_4910953.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('//at.alicdn.com/t/font_1434092639_4910953.woff') format('woff'), /* chrome、firefox */ url('//at.alicdn.com/t/font_1434092639_4910953.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('//at.alicdn.com/t/font_1434092639_4910953.svg#iconfont') format('svg');\n  /* iOS 4.1- */\n}\n.rcicon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -webkit-text-stroke-width: 0px;\n  -moz-osx-font-smoothing: grayscale;\n}\n.rcicon:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n.rcicon-step-backward:before {\n  content: \"\\E662\";\n}\n.rcicon-step-forward {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-step-forward:before {\n  content: \"\\E662\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-fast-backward:before {\n  content: \"\\E62A\";\n}\n.rcicon-fast-forward {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-fast-forward:before {\n  content: \"\\E62A\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-shrink:before {\n  content: \"\\E65F\";\n}\n.rcicon-arrow-salt:before {\n  content: \"\\E608\";\n}\n.rcicon-caret-down:before {\n  content: \"\\E60F\";\n}\n.rcicon-caret-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n.rcicon-caret-left:before {\n  content: \"\\E60F\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.rcicon-caret-up {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-caret-up:before {\n  content: \"\\E60F\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-caret-right {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n.rcicon-caret-right:before {\n  content: \"\\E60F\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.rcicon-caret-circle-right:before {\n  content: \"\\E60D\";\n}\n.rcicon-caret-circle-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-caret-circle-left:before {\n  content: \"\\E60D\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-caret-circle-o-right:before {\n  content: \"\\E60E\";\n}\n.rcicon-caret-circle-o-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-caret-circle-o-left:before {\n  content: \"\\E60E\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-circle-right:before {\n  content: \"\\E602\";\n}\n.rcicon-circle-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-circle-left:before {\n  content: \"\\E602\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-circle-o-right:before {\n  content: \"\\E603\";\n}\n.rcicon-circle-o-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-circle-o-left:before {\n  content: \"\\E603\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-double-right:before {\n  content: \"\\E604\";\n}\n.rcicon-double-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-double-left:before {\n  content: \"\\E604\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-verticle-right:before {\n  content: \"\\E605\";\n}\n.rcicon-verticle-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-verticle-left:before {\n  content: \"\\E605\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-forward:before {\n  content: \"\\E630\";\n}\n.rcicon-backward {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-backward:before {\n  content: \"\\E630\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-rollback:before {\n  content: \"\\E65A\";\n}\n.rcicon-retweet:before {\n  content: \"\\E659\";\n}\n.rcicon-right:before {\n  content: \"\\E611\";\n}\n.rcicon-down {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n.rcicon-down:before {\n  content: \"\\E611\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.rcicon-left {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n.rcicon-left:before {\n  content: \"\\E611\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.rcicon-up {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n.rcicon-up:before {\n  content: \"\\E611\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.rcicon-question:before {\n  content: \"\\E655\";\n}\n.rcicon-question-circle:before {\n  content: \"\\E656\";\n}\n.rcicon-question-circle-o:before {\n  content: \"\\E657\";\n}\n.rcicon-plus:before {\n  content: \"\\E651\";\n}\n.rcicon-plus-circle:before {\n  content: \"\\E652\";\n}\n.rcicon-plus-circle-o:before {\n  content: \"\\E653\";\n}\n.rcicon-pause:before {\n  content: \"\\E64C\";\n}\n.rcicon-pause-circle:before {\n  content: \"\\E64D\";\n}\n.rcicon-pause-circle-o:before {\n  content: \"\\E64E\";\n}\n.rcicon-minus:before {\n  content: \"\\E646\";\n}\n.rcicon-minus-circle:before {\n  content: \"\\E647\";\n}\n.rcicon-minus-circle-o:before {\n  content: \"\\E648\";\n}\n.rcicon-info-circle:before {\n  content: \"\\E637\";\n}\n.rcicon-info-circle-o:before {\n  content: \"\\E638\";\n}\n.rcicon-info:before {\n  content: \"\\E63A\";\n}\n.rcicon-exclamation:before {\n  content: \"\\E627\";\n}\n.rcicon-exclamation-circle:before {\n  content: \"\\E628\";\n}\n.rcicon-exclamation-circle-o:before {\n  content: \"\\E629\";\n}\n.rcicon-cross:before {\n  content: \"\\E61E\";\n}\n.rcicon-cross-circle:before {\n  content: \"\\E61F\";\n}\n.rcicon-cross-circle-o:before {\n  content: \"\\E620\";\n}\n.rcicon-check:before {\n  content: \"\\E613\";\n}\n.rcicon-check-circle:before {\n  content: \"\\E614\";\n}\n.rcicon-check-circle-o:before {\n  content: \"\\E615\";\n}\n.rcicon-clock-circle:before {\n  content: \"\\E616\";\n}\n.rcicon-clock-circle-o:before {\n  content: \"\\E617\";\n}\n.rcicon-lock:before {\n  content: \"\\E641\";\n}\n.rcicon-android:before {\n  content: \"\\E601\";\n}\n.rcicon-apple:before {\n  content: \"\\E606\";\n}\n.rcicon-area-chart:before {\n  content: \"\\E607\";\n}\n.rcicon-bar-chart:before {\n  content: \"\\E609\";\n}\n.rcicon-bars:before {\n  content: \"\\E60A\";\n}\n.rcicon-book:before {\n  content: \"\\E60B\";\n}\n.rcicon-calendar:before {\n  content: \"\\E60C\";\n}\n.rcicon-cloud:before {\n  content: \"\\E618\";\n}\n.rcicon-cloud-download:before {\n  content: \"\\E619\";\n}\n.rcicon-code:before {\n  content: \"\\E61A\";\n}\n.rcicon-copy:before {\n  content: \"\\E61C\";\n}\n.rcicon-credit-card:before {\n  content: \"\\E61D\";\n}\n.rcicon-delete:before {\n  content: \"\\E621\";\n}\n.rcicon-desktop:before {\n  content: \"\\E622\";\n}\n.rcicon-download-line:before {\n  content: \"\\E623\";\n}\n.rcicon-edit:before {\n  content: \"\\E624\";\n}\n.rcicon-ellipsis:before {\n  content: \"\\E625\";\n}\n.rcicon-environment:before {\n  content: \"\\E626\";\n}\n.rcicon-file:before {\n  content: \"\\E62C\";\n}\n.rcicon-file-text:before {\n  content: \"\\E62D\";\n}\n.rcicon-folder:before {\n  content: \"\\E62E\";\n}\n.rcicon-folder-open:before {\n  content: \"\\E62F\";\n}\n.rcicon-github:before {\n  content: \"\\E631\";\n}\n.rcicon-hdd:before {\n  content: \"\\E632\";\n}\n.rcicon-frown:before {\n  content: \"\\E633\";\n}\n.rcicon-meh:before {\n  content: \"\\E634\";\n}\n.rcicon-inbox:before {\n  content: \"\\E635\";\n}\n.rcicon-laptop:before {\n  content: \"\\E63D\";\n}\n.rcicon-large:before {\n  content: \"\\E63E\";\n}\n.rcicon-line-chart:before {\n  content: \"\\E63F\";\n}\n.rcicon-link:before {\n  content: \"\\E640\";\n}\n.rcicon-logout:before {\n  content: \"\\E642\";\n}\n.rcicon-mail:before {\n  content: \"\\E643\";\n}\n.rcicon-menu-fold:before {\n  content: \"\\E644\";\n}\n.rcicon-menu-unfold:before {\n  content: \"\\E645\";\n}\n.rcicon-mobile:before {\n  content: \"\\E649\";\n}\n.rcicon-notification:before {\n  content: \"\\E64A\";\n}\n.rcicon-paper-clip:before {\n  content: \"\\E64B\";\n}\n.rcicon-picture:before {\n  content: \"\\E64F\";\n}\n.rcicon-pie-chart:before {\n  content: \"\\E650\";\n}\n.rcicon-poweroff:before {\n  content: \"\\E654\";\n}\n.rcicon-reload:before {\n  content: \"\\E658\";\n}\n.rcicon-search:before {\n  content: \"\\E65B\";\n}\n.rcicon-setting:before {\n  content: \"\\E65C\";\n}\n.rcicon-share-alt:before {\n  content: \"\\E65D\";\n}\n.rcicon-shopping-cart:before {\n  content: \"\\E65E\";\n}\n.rcicon-smile:before {\n  content: \"\\E661\";\n}\n.rcicon-tablet:before {\n  content: \"\\E664\";\n}\n.rcicon-tag:before {\n  content: \"\\E665\";\n}\n.rcicon-tags:before {\n  content: \"\\E666\";\n}\n.rcicon-to-top:before {\n  content: \"\\E667\";\n}\n.rcicon-unlock:before {\n  content: \"\\E668\";\n}\n.rcicon-upload:before {\n  content: \"\\E669\";\n}\n.rcicon-user:before {\n  content: \"\\E66A\";\n}\n.rcicon-video-camera:before {\n  content: \"\\E66B\";\n}\n.rcicon-windows:before {\n  content: \"\\E66C\";\n}\n.rcicon-loading:before {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n  content: \"\\E610\";\n}\n:root .rcicon-step-forward, :root .rcicon-fast-forward, :root .rcicon-left, :root .rcicon-up, :root .rcicon-down, :root .rcicon-caret-left, :root .rcicon-caret-up, :root .rcicon-caret-right, :root .rcicon-caret-circle-left, :root .rcicon-caret-circle-o-left, :root .rcicon-circle-left, :root .rcicon-circle-o-left, :root .rcicon-double-left, :root .rcicon-verticle-left, :root .rcicon-backward {\n  -webkit-filter: none;\n          filter: none;\n}\n", ""]);

// exports


/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n.rc-steps, .rc-steps * {\n  box-sizing: border-box;\n}\n.rc-steps {\n  line-height: 1.5;\n}\n.rc-steps {\n  font-size: 0;\n  width: 100%;\n  line-height: 1.5;\n}\n.rc-steps .rc-steps-item {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.rc-steps .rc-steps-item .rc-steps-item:last-child {\n  position: absolute;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-head-inner {\n  border-color: #ccc;\n  background-color: #fff;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-head-inner > .rc-steps-icon {\n  color: #ccc;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-head-inner > .rc-steps-icon .rc-steps-icon-dot {\n  background: #ccc;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-title {\n  color: #999;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-description {\n  color: #999;\n}\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-head-inner {\n  border-color: #2db7f5;\n  background-color: #2db7f5;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-head-inner > .rc-steps-icon {\n  color: #fff;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-head-inner > .rc-steps-icon .rc-steps-icon-dot {\n  background: #2db7f5;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-title {\n  color: #666;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-description {\n  color: #666;\n}\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-head-inner {\n  border-color: #2db7f5;\n  background-color: #fff;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-head-inner > .rc-steps-icon {\n  color: #2db7f5;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-head-inner > .rc-steps-icon .rc-steps-icon-dot {\n  background: #2db7f5;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-tail > i {\n  background-color: #2db7f5;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-title {\n  color: #999;\n}\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-description {\n  color: #999;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-head-inner {\n  border-color: #f50;\n  background-color: #fff;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-head-inner > .rc-steps-icon {\n  color: #f50;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-head-inner > .rc-steps-icon .rc-steps-icon-dot {\n  background: #f50;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-title {\n  color: #f50;\n}\n.rc-steps .rc-steps-item.rc-steps-status-error .rc-steps-description {\n  color: #999;\n}\n.rc-steps .rc-steps-item.rc-steps-next-error .rc-steps-tail > i {\n  background-color: #f50;\n}\n.rc-steps .rc-steps-item.rc-steps-custom .rc-steps-head-inner {\n  background: none;\n  border: 0;\n  width: auto;\n  height: auto;\n}\n.rc-steps .rc-steps-item.rc-steps-custom .rc-steps-head-inner > .rc-steps-icon {\n  font-size: 20px;\n  top: 2px;\n  width: 20px;\n  height: 20px;\n}\n.rc-steps .rc-steps-item.rc-steps-custom.rc-steps-status-process .rc-steps-head-inner > .rc-steps-icon {\n  color: #2db7f5;\n}\n.rc-steps .rc-steps-head, .rc-steps .rc-steps-main {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.rc-steps .rc-steps-head {\n  background: #fff;\n}\n.rc-steps .rc-steps-head-inner {\n  display: block;\n  border: 1px solid #ccc;\n  width: 26px;\n  height: 26px;\n  line-height: 26px;\n  text-align: center;\n  border-radius: 26px;\n  font-size: 14px;\n  margin-right: 8px;\n  transition: background-color 0.3s ease;\n  transition: border-color 0.3s ease;\n  -webkit-transition: border-color 0.3s ease;\n  -moz-transition: border-color 0.3s ease;\n}\n.rc-steps .rc-steps-head-inner > .rc-steps-icon {\n  line-height: 1;\n  top: -1px;\n  color: #2db7f5;\n  position: relative;\n}\n.rc-steps .rc-steps-head-inner > .rc-steps-icon.rcicon {\n  font-size: 12px;\n  position: relative;\n  top: -2px;\n}\n.rc-steps .rc-steps-main {\n  margin-top: 3px;\n}\n.rc-steps .rc-steps-title {\n  font-size: 14px;\n  margin-bottom: 4px;\n  color: #666;\n  font-weight: bold;\n  background: #fff;\n  display: inline-block;\n  padding-right: 10px;\n}\n.rc-steps .rc-steps-item:last-child .rc-steps-title {\n  padding-right: 0;\n}\n.rc-steps .rc-steps-item:last-child .rc-steps-tail {\n  display: none;\n}\n.rc-steps .rc-steps-description {\n  font-size: 12px;\n  color: #999;\n}\n.rc-steps .rc-steps-tail {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 12px;\n  padding: 0 10px;\n}\n.rc-steps .rc-steps-tail > i {\n  display: inline-block;\n  background: #e9e9e9;\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n  transition: background 0.3s ease;\n  -webkit-transition: background 0.3s ease;\n  -moz-transition: background 0.3s ease;\n}\n.rc-steps.rc-steps-small .rc-steps-head-inner {\n  border: 1px solid #ccc;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  text-align: center;\n  border-radius: 18px;\n  font-size: 12px;\n  margin-right: 10px;\n}\n.rc-steps.rc-steps-small .rc-steps-head-inner > .rc-steps-icon.rcicon {\n  font-size: 12px;\n  font-size: 9px \\9;\n  -webkit-transform: scale(0.75);\n  transform: scale(0.75);\n  top: -1px;\n}\n.rc-steps.rc-steps-small .rc-steps-main {\n  margin-top: 0;\n}\n.rc-steps.rc-steps-small .rc-steps-title {\n  font-size: 12px;\n  margin-bottom: 4px;\n  color: #666;\n  font-weight: bold;\n}\n.rc-steps.rc-steps-small .rc-steps-description {\n  font-size: 12px;\n  color: #999;\n}\n.rc-steps.rc-steps-small .rc-steps-tail {\n  top: 8px;\n  padding: 0 8px;\n}\n.rc-steps.rc-steps-small .rc-steps-tail > i {\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n}\n.rc-steps.rc-steps-small .rc-steps-item.rc-steps-custom .rc-steps-head-inner, .rc-steps .rc-steps-item.rc-steps-custom .rc-steps-head-inner {\n  width: inherit;\n  height: inherit;\n  line-height: inherit;\n  border-radius: 0;\n  border: 0;\n  background: none;\n}\n.rc-steps-vertical .rc-steps-item {\n  display: block;\n}\n.rc-steps-vertical .rc-steps-tail {\n  position: absolute;\n  left: 13px;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  padding: 30px 0 4px 0;\n}\n.rc-steps-vertical .rc-steps-tail > i {\n  height: 100%;\n  width: 1px;\n}\n.rc-steps-vertical .rc-steps-head {\n  float: left;\n}\n.rc-steps-vertical .rc-steps-head-inner {\n  margin-right: 16px;\n}\n.rc-steps-vertical .rc-steps-main {\n  min-height: 47px;\n  overflow: hidden;\n  display: block;\n}\n.rc-steps-vertical .rc-steps-main .rc-steps-title {\n  line-height: 26px;\n}\n.rc-steps-vertical .rc-steps-main .rc-steps-description {\n  padding-bottom: 12px;\n}\n.rc-steps-vertical.rc-steps-small .rc-steps-tail {\n  position: absolute;\n  left: 9px;\n  top: 0;\n  padding: 22px 0 4px 0;\n}\n.rc-steps-vertical.rc-steps-small .rc-steps-tail > i {\n  height: 100%;\n  width: 1px;\n}\n.rc-steps-vertical.rc-steps-small .rc-steps-title {\n  line-height: 18px;\n}\n.rc-steps-horizontal.rc-steps-hidden {\n  visibility: hidden;\n}\n.rc-steps-horizontal .rc-steps-description {\n  max-width: 100px;\n}\n.rc-steps-horizontal .rc-steps-item:not(:first-child) .rc-steps-head {\n  position: relative;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n.rc-steps-label-vertical .rc-steps-tail {\n  padding: 0 32px;\n  margin-left: 22px;\n}\n.rc-steps-label-vertical .rc-steps-item .rc-steps-step {\n  display: inline-block;\n  text-align: center;\n  width: 100px;\n}\n.rc-steps-label-vertical .rc-steps-item:not(:first-child) .rc-steps-head {\n  margin-left: 0;\n  padding-left: 0;\n}\n.rc-steps-label-vertical .rc-steps-head {\n  display: inline-block;\n  padding-right: 10px;\n}\n.rc-steps-label-vertical .rc-steps-head-inner {\n  margin: 0 auto;\n}\n.rc-steps-label-vertical .rc-steps-main {\n  display: block;\n  margin-top: 10px;\n}\n.rc-steps-label-vertical .rc-steps-main .rc-steps-title {\n  padding-right: 0;\n}\n.rc-steps-label-vertical .rc-steps-main .rc-steps-description {\n  text-align: left;\n}\n.rc-steps-dot .rc-steps-tail {\n  width: 100%;\n  top: 1px;\n  margin: 0 0 0 50px;\n  padding: 0;\n}\n.rc-steps-dot .rc-steps-tail > i {\n  height: 3px;\n}\n.rc-steps-dot .rc-steps-head {\n  padding-right: 0;\n}\n.rc-steps-dot .rc-steps-head-inner {\n  width: 5px;\n  height: 5px;\n  line-height: 5px;\n  border: 0;\n}\n.rc-steps-dot .rc-steps-head-inner .rc-steps-icon-dot {\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 2.5px;\n}\n.rc-steps-dot .rc-steps-status-process .rc-steps-head {\n  top: -1px;\n}\n.rc-steps-dot .rc-steps-status-process .rc-steps-head-inner {\n  width: 7px;\n  height: 7px;\n  line-height: 7px;\n}\n.rc-steps-dot .rc-steps-status-process .rc-steps-head-inner .rc-steps-icon-dot {\n  border-radius: 3.5px;\n}\n.rc-steps-dot.rc-steps-vertical .rc-steps-tail {\n  left: 2px;\n  height: 100%;\n  padding: 0;\n  top: 15px;\n}\n.rc-steps-dot.rc-steps-vertical .rc-steps-tail > i {\n  height: 100%;\n  width: 3px;\n}\n.rc-steps-dot.rc-steps-vertical .rc-steps-head {\n  top: 12px;\n  left: 1px;\n}\n.rc-steps-dot.rc-steps-vertical .rc-steps-status-process .rc-steps-head {\n  left: 0;\n}\n.hidden {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  -ms-flex-align: stretch;\n      -webkit-box-align: stretch;\n          align-items: stretch;\n}\n.rbc-calendar *, .rbc-calendar *:before, .rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis, .rbc-event-label, .rbc-row-segment .rbc-event-content, .rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #999999;\n}\n.rbc-off-range-bg {\n  background: #e5e5e5;\n}\n.rbc-header {\n  overflow: hidden;\n  -ms-flex: 1 0 0%;\n      -webkit-box-flex: 1;\n          flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid #DDD;\n}\n.rbc-header + .rbc-header {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n.rbc-today {\n  background-color: #eaf6ff;\n}\n.rbc-toolbar {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n      -webkit-box-align: center;\n          align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -ms-flex-positive: 1;\n      -webkit-box-flex: 1;\n          flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #373a3c;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  padding: .375rem 1rem;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-toolbar button:active:hover, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:focus {\n  color: #373a3c;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.rbc-toolbar button:focus {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-toolbar button:hover {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {\n  margin-left: 10px;\n}\n.rbc-event {\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n}\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-row {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: row;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #DDD;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  -ms-flex: 1 0 0px;\n      -webkit-box-flex: 1;\n          flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n}\n.rbc-month-header {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: row;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.rbc-month-row {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  position: relative;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  -ms-flex: 1 0 0px;\n      -webkit-box-flex: 1;\n          flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n      flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #DDD;\n}\n.rbc-date-cell {\n  -ms-flex: 1 1 0px;\n      -webkit-box-flex: 1;\n          flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: row;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          flex-direction: row;\n  -ms-flex: 1 0 0px;\n      -webkit-box-flex: 1;\n          flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -ms-flex: 1 0 0%;\n      -webkit-box-flex: 1;\n          flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  -ms-flex: 1 0 0px;\n      -webkit-box-flex: 1;\n          flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #DDD;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: ' \\BB';\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: '\\AB   ';\n}\n.rbc-agenda-date-cell, .rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -ms-flex: 1;\n      -webkit-box-flex: 1;\n          flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #DDD;\n  min-height: 40px;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-flow: column nowrap;\n}\n.rbc-time-gutter, .rbc-header-gutter {\n  -ms-flex: none;\n      -webkit-box-flex: 0;\n          flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  border: 1px solid #265985;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -ms-flex-flow: column wrap;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-flow: column wrap;\n  -ms-flex-align: start;\n      -webkit-box-align: start;\n          align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -ms-flex: none;\n      -webkit-box-flex: 0;\n          flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -ms-flex: 1 1 0px;\n      -webkit-box-flex: 1;\n          flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #f7f7f7;\n}\n.rbc-time-slot {\n  -ms-flex: 1 0 0px;\n      -webkit-box-flex: 1;\n          flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  -ms-flex: 1;\n      -webkit-box-flex: 1;\n          flex: 1;\n  width: 100%;\n  border: 1px solid #DDD;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex: 0 0 auto;\n      -webkit-box-flex: 0;\n          flex: 0 0 auto;\n  -ms-flex-direction: row;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header-content {\n  -ms-flex: 1;\n      -webkit-box-flex: 1;\n          flex: 1;\n  min-width: 0;\n  -ms-flex-direction: column;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          flex-direction: column;\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex: 1 0 0%;\n      -webkit-box-flex: 1;\n          flex: 1 0 0%;\n  -ms-flex-align: start;\n      -webkit-box-align: start;\n          align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #DDD;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -ms-flex: none;\n      -webkit-box-flex: 0;\n          flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n", ""]);

// exports


/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* DayPicker styles */\n\n.DayPicker {\n  display: inline-block;\n  font-size: 1rem;\n}\n\n.DayPicker-wrapper {\n  position: relative;\n\n  -webkit-box-orient: horizontal;\n\n  -webkit-box-direction: normal;\n\n      -ms-flex-direction: row;\n\n          flex-direction: row;\n  padding-bottom: 1em;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-Months {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.DayPicker-Month {\n  display: table;\n  margin: 0 1em;\n  margin-top: 1em;\n  border-spacing: 0;\n  border-collapse: collapse;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-NavBar {\n}\n\n.DayPicker-NavButton {\n  position: absolute;\n  top: 1em;\n  right: 1.5em;\n  left: auto;\n\n  display: inline-block;\n  margin-top: 2px;\n  width: 1.25em;\n  height: 1.25em;\n  background-position: center;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  color: #8B9898;\n  cursor: pointer;\n}\n\n.DayPicker-NavButton:hover {\n  opacity: 0.8;\n}\n\n.DayPicker-NavButton--prev {\n  margin-right: 1.5em;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');\n}\n\n.DayPicker-NavButton--next {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');\n}\n\n.DayPicker-NavButton--interactionDisabled {\n  display: none;\n}\n\n.DayPicker-Caption {\n  display: table-caption;\n  margin-bottom: 0.5em;\n  padding: 0 0.5em;\n  text-align: left;\n}\n\n.DayPicker-Caption > div {\n  font-weight: 500;\n  font-size: 1.15em;\n}\n\n.DayPicker-Weekdays {\n  display: table-header-group;\n  margin-top: 1em;\n}\n\n.DayPicker-WeekdaysRow {\n  display: table-row;\n}\n\n.DayPicker-Weekday {\n  display: table-cell;\n  padding: 0.5em;\n  color: #8B9898;\n  text-align: center;\n  font-size: 0.875em;\n}\n\n.DayPicker-Weekday abbr[title] {\n  border-bottom: none;\n  text-decoration: none;\n}\n\n.DayPicker-Body {\n  display: table-row-group;\n}\n\n.DayPicker-Week {\n  display: table-row;\n}\n\n.DayPicker-Day {\n  display: table-cell;\n  padding: 0.5em;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n\n.DayPicker-WeekNumber {\n  display: table-cell;\n  padding: 0.5em;\n  min-width: 1em;\n  border-right: 1px solid #EAECEC;\n  color: #8B9898;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 0.75em;\n  cursor: pointer;\n}\n\n.DayPicker--interactionDisabled .DayPicker-Day {\n  cursor: default;\n}\n\n.DayPicker-Footer {\n  padding-top: 0.5em;\n}\n\n.DayPicker-TodayButton {\n  border: none;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  color: #4A90E2;\n  font-size: 0.875em;\n  cursor: pointer;\n}\n\n/* Default modifiers */\n\n.DayPicker-Day--today {\n  color: #D0021B;\n  font-weight: 700;\n}\n\n.DayPicker-Day--outside {\n  color: #8B9898;\n  cursor: default;\n}\n\n.DayPicker-Day--disabled {\n  color: #DCE0E0;\n  cursor: default;\n  /* background-color: #eff1f1; */\n}\n\n/* Example modifiers */\n\n.DayPicker-Day--sunday {\n  background-color: #F7F8F8;\n}\n\n.DayPicker-Day--sunday:not(.DayPicker-Day--today) {\n  color: #DCE0E0;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  position: relative;\n\n  background-color: #4A90E2;\n  color: #F0F8FF;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {\n  background-color: #51A0FA;\n}\n\n.DayPicker:not(.DayPicker--interactionDisabled)\n  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n  background-color: #F0F8FF;\n}\n\n/* DayPickerInput */\n\n.DayPickerInput {\n  display: inline-block;\n}\n\n.DayPickerInput-OverlayWrapper {\n  position: relative;\n}\n\n.DayPickerInput-Overlay {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n\n  background: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}\n", ""]);

// exports


/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/*!\n * Quill Editor v1.3.0\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  -o-tab-size: 4;\n     tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p, .ql-editor ol, .ql-editor ul, .ql-editor pre, .ql-editor blockquote, .ql-editor h1, .ql-editor h2, .ql-editor h3, .ql-editor h4, .ql-editor h5, .ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol, .ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li, .ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true], .ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *, .ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before, .ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl, .ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor .ql-embed-selected {\n  border: 1px solid #777;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  pointer-events: none;\n  position: absolute;\n}\n.ql-snow.ql-toolbar:after, .ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button, .ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg, .ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover, .ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file], .ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover, .ql-snow .ql-toolbar button:hover, .ql-snow.ql-toolbar button:focus, .ql-snow .ql-toolbar button:focus, .ql-snow.ql-toolbar button.ql-active, .ql-snow .ql-toolbar button.ql-active, .ql-snow.ql-toolbar .ql-picker-label:hover, .ql-snow .ql-toolbar .ql-picker-label:hover, .ql-snow.ql-toolbar .ql-picker-label.ql-active, .ql-snow .ql-toolbar .ql-picker-label.ql-active, .ql-snow.ql-toolbar .ql-picker-item:hover, .ql-snow .ql-toolbar .ql-picker-item:hover, .ql-snow.ql-toolbar .ql-picker-item.ql-selected, .ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill, .ql-snow .ql-toolbar button:hover .ql-fill, .ql-snow.ql-toolbar button:focus .ql-fill, .ql-snow .ql-toolbar button:focus .ql-fill, .ql-snow.ql-toolbar button.ql-active .ql-fill, .ql-snow .ql-toolbar button.ql-active .ql-fill, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill, .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill, .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill, .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke, .ql-snow .ql-toolbar button:hover .ql-stroke, .ql-snow.ql-toolbar button:focus .ql-stroke, .ql-snow .ql-toolbar button:focus .ql-stroke, .ql-snow.ql-toolbar button.ql-active .ql-stroke, .ql-snow .ql-toolbar button.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke, .ql-snow.ql-toolbar button:hover .ql-stroke-miter, .ql-snow .ql-toolbar button:hover .ql-stroke-miter, .ql-snow.ql-toolbar button:focus .ql-stroke-miter, .ql-snow .ql-toolbar button:focus .ql-stroke-miter, .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter, .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active), .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill, .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke, .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  box-sizing: border-box;\n}\n.ql-snow * {\n  box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom, .ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  -webkit-transform: translateY(10px);\n          transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  -webkit-transform: translateY(-10px);\n          transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin, .ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code, .ql-snow .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding-bottom: 2px;\n  padding-top: 2px;\n}\n.ql-snow .ql-editor code:before, .ql-snow .ql-editor code:after {\n  content: \"\\A0\";\n  letter-spacing: -2px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker, .ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label, .ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before, .ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before, .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected, .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview, .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n", ""]);

// exports


/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic&subset=latin);", ""]);

// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/*\n * # Semantic UI - 2.4.2\n * https://github.com/Semantic-Org/Semantic-UI\n * http://www.semantic-ui.com/\n *\n * Copyright 2014 Contributors\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n/*!\n * # Semantic UI 2.4.2 - Reset\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Reset\n*******************************/\n\n/* Border-Box */\n\n*, *:before, *:after {\n  box-sizing: inherit;\n}\n\nhtml {\n  box-sizing: border-box;\n}\n\n/* iPad Input Shadows */\n\ninput[type=\"text\"], input[type=\"email\"], input[type=\"search\"], input[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  /* mobile firefox too! */\n}\n\n/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 1.15;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle, aside, footer, header, nav, section {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption, figure, main {\n  /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box;\n  /* 1 */\n  height: 0;\n  /* 1 */\n  overflow: visible;\n  /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent;\n  /* 1 */\n  -webkit-text-decoration-skip: objects;\n  /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none;\n  /* 1 */\n  text-decoration: underline;\n  /* 2 */\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb, strong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb, strong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode, kbd, samp {\n  font-family: monospace, monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio, video {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton, input, optgroup, select, textarea {\n  font-family: sans-serif;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  line-height: 1.15;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton, input {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton, select {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  display: table;\n  /* 1 */\n  max-width: 100%;\n  /* 1 */\n  padding: 0;\n  /* 3 */\n  white-space: normal;\n  /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, menu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Site\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Page\n*******************************/\n\nhtml, body {\n  height: 100%;\n}\n\nhtml {\n  font-size: 14px;\n}\n\nbody {\n  margin: 0px;\n  padding: 0px;\n  overflow-x: hidden;\n  min-width: 320px;\n  background: #FAFBFA;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 14px;\n  line-height: 1.4285em;\n  color: rgba(0, 0, 0, 0.8);\n  font-smoothing: antialiased;\n}\n\n/*******************************\n             Headers\n*******************************/\n\nh1, h2, h3, h4, h5 {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  line-height: 1.28571429em;\n  margin: calc(2rem -  0.14285714em ) 0em 1rem;\n  font-weight: bold;\n  padding: 0em;\n}\n\nh1 {\n  min-height: 1rem;\n  font-size: 2rem;\n}\n\nh2 {\n  font-size: 1.71428571rem;\n}\n\nh3 {\n  font-size: 1.28571429rem;\n}\n\nh4 {\n  font-size: 1.07142857rem;\n}\n\nh5 {\n  font-size: 1rem;\n}\n\nh1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child {\n  margin-top: 0em;\n}\n\nh1:last-child, h2:last-child, h3:last-child, h4:last-child, h5:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n             Text\n*******************************/\n\np {\n  margin: 0em 0em 1em;\n  line-height: 1.4285em;\n}\n\np:first-child {\n  margin-top: 0em;\n}\n\np:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n        Links\n--------------------*/\n\na {\n  color: #FF9F5B;\n  text-decoration: none;\n}\n\na:hover {\n  color: #ff8127;\n  text-decoration: none;\n}\n\n/*******************************\n         Scrollbars\n*******************************/\n\n/*******************************\n          Highlighting\n*******************************/\n\n/* Site */\n\n::-webkit-selection {\n  background-color: #CCE2FF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n::-moz-selection {\n  background-color: #CCE2FF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n::selection {\n  background-color: #CCE2FF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Form */\n\ntextarea::-webkit-selection, input::-webkit-selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(0, 0, 0, 0.8);\n}\n\ntextarea::-moz-selection, input::-moz-selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(0, 0, 0, 0.8);\n}\n\ntextarea::-moz-selection, input::-moz-selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(0, 0, 0, 0.8);\n}\n\ntextarea::selection, input::selection {\n  background-color: rgba(100, 100, 100, 0.4);\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Force Simple Scrollbars */\n\nbody ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 10px;\n  height: 10px;\n}\n\nbody ::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 0px;\n}\n\nbody ::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, 0.25);\n  transition: color 0.2s ease;\n}\n\nbody ::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(0, 0, 0, 0.15);\n}\n\nbody ::-webkit-scrollbar-thumb:hover {\n  background: rgba(128, 135, 139, 0.8);\n}\n\n/* Inverted UI */\n\nbody .ui.inverted::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody .ui.inverted::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n\nbody .ui.inverted::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(255, 255, 255, 0.15);\n}\n\nbody .ui.inverted::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n/*******************************\n        Global Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n\n@media only screen and (max-width: 767px) {\n  html {\n    font-size: 16px !important;\n  }\n}\n\ntextarea {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n}\n/*!\n * # Semantic UI 2.4.2 - Button\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Button\n*******************************/\n\n.ui.button {\n  cursor: pointer;\n  display: inline-block;\n  min-height: 1em;\n  outline: none;\n  border: none;\n  vertical-align: baseline;\n  background: #E0E1E2 none;\n  color: rgba(0, 0, 0, 0.6);\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  margin: 0em 0.25em 0em 0em;\n  padding: 0.78571429em 1.5em 0.78571429em;\n  text-transform: none;\n  text-shadow: none;\n  font-weight: normal;\n  line-height: 1em;\n  font-style: normal;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 0.21428571rem;\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px #DEDEDF inset;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;\n  will-change: '';\n  -webkit-tap-highlight-color: transparent;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.button:hover {\n  background-color: #CACBCD;\n  background-image: none;\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px #DEDEDF inset;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.button:hover .icon {\n  opacity: 0.85;\n}\n\n/*--------------\n      Focus\n---------------*/\n\n.ui.button:focus {\n  background-color: #CACBCD;\n  color: rgba(0, 0, 0, 0.8);\n  background-image: '' !important;\n  box-shadow: '' !important;\n}\n\n.ui.button:focus .icon {\n  opacity: 0.85;\n}\n\n/*--------------\n      Down\n---------------*/\n\n.ui.button:active, .ui.active.button:active {\n  background-color: #BABBBC;\n  background-image: '';\n  color: rgba(0, 0, 0, 0.9);\n  box-shadow: 0px 0px 0px 1px transparent inset, none;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.button {\n  background-color: #C0C1C2;\n  background-image: none;\n  box-shadow: 0px 0px 0px 1px transparent inset;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.active.button:hover {\n  background-color: #C0C1C2;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.active.button:active {\n  background-color: #C0C1C2;\n  background-image: none;\n}\n\n/*--------------\n    Loading\n---------------*/\n\n/* Specificity hack */\n\n.ui.loading.loading.loading.loading.loading.loading.button {\n  position: relative;\n  cursor: default;\n  text-shadow: none !important;\n  color: transparent !important;\n  opacity: 1;\n  pointer-events: auto;\n  transition: all 0s linear, opacity 0.1s ease;\n}\n\n.ui.loading.button:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n\n.ui.loading.button:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  -webkit-animation: button-spin 0.6s linear;\n  animation: button-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #FFFFFF transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n.ui.labeled.icon.loading.button .icon {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n@-webkit-keyframes button-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes button-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.ui.basic.loading.button:not(.inverted):before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.ui.basic.loading.button:not(.inverted):after {\n  border-top-color: rgba(0, 0, 0, 0.4);\n}\n\n/*-------------------\n      Disabled\n--------------------*/\n\n.ui.buttons .disabled.button, .ui.disabled.button, .ui.button:disabled, .ui.disabled.button:hover, .ui.disabled.active.button {\n  cursor: default;\n  opacity: 0.45 !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n}\n\n/* Basic Group With Disabled */\n\n.ui.basic.buttons .ui.disabled.button {\n  border-color: rgba(34, 36, 38, 0.5);\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n       Animated\n--------------------*/\n\n.ui.animated.button {\n  position: relative;\n  overflow: hidden;\n  padding-right: 0em !important;\n  vertical-align: middle;\n  z-index: 1;\n}\n\n.ui.animated.button .content {\n  will-change: transform, opacity;\n}\n\n.ui.animated.button .visible.content {\n  position: relative;\n  margin-right: 1.5em;\n}\n\n.ui.animated.button .hidden.content {\n  position: absolute;\n  width: 100%;\n}\n\n/* Horizontal */\n\n.ui.animated.button .visible.content, .ui.animated.button .hidden.content {\n  transition: right 0.3s ease 0s;\n}\n\n.ui.animated.button .visible.content {\n  left: auto;\n  right: 0%;\n}\n\n.ui.animated.button .hidden.content {\n  top: 50%;\n  left: auto;\n  right: -100%;\n  margin-top: -0.5em;\n}\n\n.ui.animated.button:focus .visible.content, .ui.animated.button:hover .visible.content {\n  left: auto;\n  right: 200%;\n}\n\n.ui.animated.button:focus .hidden.content, .ui.animated.button:hover .hidden.content {\n  left: auto;\n  right: 0%;\n}\n\n/* Vertical */\n\n.ui.vertical.animated.button .visible.content, .ui.vertical.animated.button .hidden.content {\n  transition: top 0.3s ease, -webkit-transform 0.3s ease;\n  transition: top 0.3s ease, transform 0.3s ease;\n  transition: top 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;\n}\n\n.ui.vertical.animated.button .visible.content {\n  -webkit-transform: translateY(0%);\n  transform: translateY(0%);\n  right: auto;\n}\n\n.ui.vertical.animated.button .hidden.content {\n  top: -50%;\n  left: 0%;\n  right: auto;\n}\n\n.ui.vertical.animated.button:focus .visible.content, .ui.vertical.animated.button:hover .visible.content {\n  -webkit-transform: translateY(200%);\n  transform: translateY(200%);\n  right: auto;\n}\n\n.ui.vertical.animated.button:focus .hidden.content, .ui.vertical.animated.button:hover .hidden.content {\n  top: 50%;\n  right: auto;\n}\n\n/* Fade */\n\n.ui.fade.animated.button .visible.content, .ui.fade.animated.button .hidden.content {\n  transition: opacity 0.3s ease, -webkit-transform 0.3s ease;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  transition: opacity 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;\n}\n\n.ui.fade.animated.button .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.ui.fade.animated.button .hidden.content {\n  opacity: 0;\n  left: 0%;\n  right: auto;\n  -webkit-transform: scale(1.5);\n  transform: scale(1.5);\n}\n\n.ui.fade.animated.button:focus .visible.content, .ui.fade.animated.button:hover .visible.content {\n  left: auto;\n  right: auto;\n  opacity: 0;\n  -webkit-transform: scale(0.75);\n  transform: scale(0.75);\n}\n\n.ui.fade.animated.button:focus .hidden.content, .ui.fade.animated.button:hover .hidden.content {\n  left: 0%;\n  right: auto;\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.button {\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  background: transparent none;\n  color: #FFFFFF;\n  text-shadow: none !important;\n}\n\n/* Group */\n\n.ui.inverted.buttons .button {\n  margin: 0px 0px 0px -2px;\n}\n\n.ui.inverted.buttons .button:first-child {\n  margin-left: 0em;\n}\n\n.ui.inverted.vertical.buttons .button {\n  margin: 0px 0px -2px 0px;\n}\n\n.ui.inverted.vertical.buttons .button:first-child {\n  margin-top: 0em;\n}\n\n/* States */\n\n/* Hover */\n\n.ui.inverted.button:hover {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active / Focus */\n\n.ui.inverted.button:focus, .ui.inverted.button.active {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 0px 2px #FFFFFF inset !important;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active Focus */\n\n.ui.inverted.button.active:focus {\n  background: #DCDDDE;\n  box-shadow: 0px 0px 0px 2px #DCDDDE inset !important;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*-------------------\n    Labeled Button\n--------------------*/\n\n.ui.labeled.button:not(.icon) {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  background: none !important;\n  padding: 0px !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.ui.labeled.button > .button {\n  margin: 0px;\n}\n\n.ui.labeled.button > .label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin: 0px 0px 0px -1px !important;\n  padding: '';\n  font-size: 1em;\n  border-color: #DEDEDF;\n}\n\n/* Tag */\n\n.ui.labeled.button > .tag.label:before {\n  width: 1.85em;\n  height: 1.85em;\n}\n\n/* Right */\n\n.ui.labeled.button:not([class*=\"left labeled\"]) > .button {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.ui.labeled.button:not([class*=\"left labeled\"]) > .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n/* Left Side */\n\n.ui[class*=\"left labeled\"].button > .button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.ui[class*=\"left labeled\"].button > .label {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n/*-------------------\n       Social\n--------------------*/\n\n/* Facebook */\n\n.ui.facebook.button {\n  background-color: #3B5998;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.facebook.button:hover {\n  background-color: #304d8a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.facebook.button:active {\n  background-color: #2d4373;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Twitter */\n\n.ui.twitter.button {\n  background-color: #55ACEE;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.twitter.button:hover {\n  background-color: #35a2f4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.twitter.button:active {\n  background-color: #2795e9;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Google Plus */\n\n.ui.google.plus.button {\n  background-color: #DD4B39;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.google.plus.button:hover {\n  background-color: #e0321c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.google.plus.button:active {\n  background-color: #c23321;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Linked In */\n\n.ui.linkedin.button {\n  background-color: #1F88BE;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.linkedin.button:hover {\n  background-color: #147baf;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.linkedin.button:active {\n  background-color: #186992;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* YouTube */\n\n.ui.youtube.button {\n  background-color: #FF0000;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.youtube.button:hover {\n  background-color: #e60000;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.youtube.button:active {\n  background-color: #cc0000;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Instagram */\n\n.ui.instagram.button {\n  background-color: #49769C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.instagram.button:hover {\n  background-color: #3d698e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.instagram.button:active {\n  background-color: #395c79;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Pinterest */\n\n.ui.pinterest.button {\n  background-color: #BD081C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.pinterest.button:hover {\n  background-color: #ac0013;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.pinterest.button:active {\n  background-color: #8c0615;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* VK */\n\n.ui.vk.button {\n  background-color: #4D7198;\n  color: #FFFFFF;\n  background-image: none;\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.vk.button:hover {\n  background-color: #41648a;\n  color: #FFFFFF;\n}\n\n.ui.vk.button:active {\n  background-color: #3c5876;\n  color: #FFFFFF;\n}\n\n/*--------------\n     Icon\n---------------*/\n\n.ui.button > .icon:not(.button) {\n  height: 0.85714286em;\n  opacity: 0.8;\n  margin: 0em 0.42857143em 0em -0.21428571em;\n  transition: opacity 0.1s ease;\n  vertical-align: '';\n  color: '';\n}\n\n.ui.button:not(.icon) > .icon:not(.button):not(.dropdown) {\n  margin: 0em 0.42857143em 0em -0.21428571em;\n}\n\n.ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {\n  margin: 0em -0.21428571em 0em 0.42857143em;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui[class*=\"left floated\"].buttons, .ui[class*=\"left floated\"].button {\n  float: left;\n  margin-left: 0em;\n  margin-right: 0.25em;\n}\n\n.ui[class*=\"right floated\"].buttons, .ui[class*=\"right floated\"].button {\n  float: right;\n  margin-right: 0em;\n  margin-left: 0.25em;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.buttons .button, .ui.compact.button {\n  padding: 0.58928571em 1.125em 0.58928571em;\n}\n\n.ui.compact.icon.buttons .button, .ui.compact.icon.button {\n  padding: 0.58928571em 0.58928571em 0.58928571em;\n}\n\n.ui.compact.labeled.icon.buttons .button, .ui.compact.labeled.icon.button {\n  padding: 0.58928571em 3.69642857em 0.58928571em;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.buttons .button, .ui.mini.buttons .or, .ui.mini.button {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.buttons .button, .ui.tiny.buttons .or, .ui.tiny.button {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.buttons .button, .ui.small.buttons .or, .ui.small.button {\n  font-size: 0.92857143rem;\n}\n\n.ui.buttons .button, .ui.buttons .or, .ui.button {\n  font-size: 1rem;\n}\n\n.ui.large.buttons .button, .ui.large.buttons .or, .ui.large.button {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.buttons .button, .ui.big.buttons .or, .ui.big.button {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.buttons .button, .ui.huge.buttons .or, .ui.huge.button {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.buttons .button, .ui.massive.buttons .or, .ui.massive.button {\n  font-size: 1.71428571rem;\n}\n\n/*--------------\n    Icon Only\n---------------*/\n\n.ui.icon.buttons .button, .ui.icon.button {\n  padding: 0.78571429em 0.78571429em 0.78571429em;\n}\n\n.ui.icon.buttons .button > .icon, .ui.icon.button > .icon {\n  opacity: 0.9;\n  margin: 0em !important;\n  vertical-align: top;\n}\n\n/*-------------------\n        Basic\n--------------------*/\n\n.ui.basic.buttons .button, .ui.basic.button {\n  background: transparent none !important;\n  color: rgba(0, 0, 0, 0.6) !important;\n  font-weight: normal;\n  border-radius: 0.21428571rem;\n  text-transform: none;\n  text-shadow: none !important;\n  box-shadow: 0px 0px 0px 1px #DEDEDF inset;\n}\n\n.ui.basic.buttons {\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n  border-radius: 0.21428571rem;\n}\n\n.ui.basic.buttons .button {\n  border-radius: 0em;\n}\n\n.ui.basic.buttons .button:hover, .ui.basic.button:hover {\n  background: #FFFFFF !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n  box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px #DEDEDF inset;\n}\n\n.ui.basic.buttons .button:focus, .ui.basic.button:focus {\n  background: #FFFFFF !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n  box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px #DEDEDF inset;\n}\n\n.ui.basic.buttons .button:active, .ui.basic.button:active {\n  background: #F8F8F8 !important;\n  color: rgba(0, 0, 0, 0.9) !important;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px #DEDEDF inset;\n}\n\n.ui.basic.buttons .active.button, .ui.basic.active.button {\n  background: rgba(0, 0, 0, 0.05) !important;\n  box-shadow: '' !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.ui.basic.buttons .active.button:hover, .ui.basic.active.button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Vertical */\n\n.ui.basic.buttons .button:hover {\n  box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.35) inset, 0px 0px 0px 0px #DEDEDF inset inset;\n}\n\n.ui.basic.buttons .button:active {\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15) inset, 0px 1px 4px 0px #DEDEDF inset inset;\n}\n\n.ui.basic.buttons .active.button {\n  box-shadow: '' !important;\n}\n\n/* Standard Basic Inverted */\n\n.ui.basic.inverted.buttons .button, .ui.basic.inverted.button {\n  background-color: transparent !important;\n  color: #F9FAFB !important;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n}\n\n.ui.basic.inverted.buttons .button:hover, .ui.basic.inverted.button:hover {\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n\n.ui.basic.inverted.buttons .button:focus, .ui.basic.inverted.button:focus {\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n\n.ui.basic.inverted.buttons .button:active, .ui.basic.inverted.button:active {\n  background-color: rgba(255, 255, 255, 0.08) !important;\n  color: #FFFFFF !important;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.9) inset !important;\n}\n\n.ui.basic.inverted.buttons .active.button, .ui.basic.inverted.active.button {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #FFFFFF;\n  text-shadow: none;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.7) inset;\n}\n\n.ui.basic.inverted.buttons .active.button:hover, .ui.basic.inverted.active.button:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0px 0px 0px 2px #ffffff inset !important;\n}\n\n/* Basic Group */\n\n.ui.basic.buttons .button {\n  border-left: 1px solid #DEDEDF;\n  box-shadow: none;\n}\n\n.ui.basic.vertical.buttons .button {\n  border-left: none;\n}\n\n.ui.basic.vertical.buttons .button {\n  border-left-width: 0px;\n  border-top: 1px solid #DEDEDF;\n}\n\n.ui.basic.vertical.buttons .button:first-child {\n  border-top-width: 0px;\n}\n\n/*--------------\n  Labeled Icon\n---------------*/\n\n.ui.labeled.icon.buttons .button, .ui.labeled.icon.button {\n  position: relative;\n  padding-left: 4.07142857em !important;\n  padding-right: 1.5em !important;\n}\n\n/* Left Labeled */\n\n.ui.labeled.icon.buttons > .button > .icon, .ui.labeled.icon.button > .icon {\n  position: absolute;\n  height: 100%;\n  line-height: 1;\n  border-radius: 0px;\n  border-top-left-radius: inherit;\n  border-bottom-left-radius: inherit;\n  text-align: center;\n  margin: 0em;\n  width: 2.57142857em;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: '';\n  box-shadow: -1px 0px 0px 0px transparent inset;\n}\n\n/* Left Labeled */\n\n.ui.labeled.icon.buttons > .button > .icon, .ui.labeled.icon.button > .icon {\n  top: 0em;\n  left: 0em;\n}\n\n/* Right Labeled */\n\n.ui[class*=\"right labeled\"].icon.button {\n  padding-right: 4.07142857em !important;\n  padding-left: 1.5em !important;\n}\n\n.ui[class*=\"right labeled\"].icon.button > .icon {\n  left: auto;\n  right: 0em;\n  border-radius: 0px;\n  border-top-right-radius: inherit;\n  border-bottom-right-radius: inherit;\n  box-shadow: 1px 0px 0px 0px transparent inset;\n}\n\n.ui.labeled.icon.buttons > .button > .icon:before, .ui.labeled.icon.button > .icon:before, .ui.labeled.icon.buttons > .button > .icon:after, .ui.labeled.icon.button > .icon:after {\n  display: block;\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  text-align: center;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.ui.labeled.icon.buttons .button > .icon {\n  border-radius: 0em;\n}\n\n.ui.labeled.icon.buttons .button:first-child > .icon {\n  border-top-left-radius: 0.21428571rem;\n  border-bottom-left-radius: 0.21428571rem;\n}\n\n.ui.labeled.icon.buttons .button:last-child > .icon {\n  border-top-right-radius: 0.21428571rem;\n  border-bottom-right-radius: 0.21428571rem;\n}\n\n.ui.vertical.labeled.icon.buttons .button:first-child > .icon {\n  border-radius: 0em;\n  border-top-left-radius: 0.21428571rem;\n}\n\n.ui.vertical.labeled.icon.buttons .button:last-child > .icon {\n  border-radius: 0em;\n  border-bottom-left-radius: 0.21428571rem;\n}\n\n/* Fluid Labeled */\n\n.ui.fluid[class*=\"left labeled\"].icon.button, .ui.fluid[class*=\"right labeled\"].icon.button {\n  padding-left: 1.5em !important;\n  padding-right: 1.5em !important;\n}\n\n/*--------------\n     Toggle\n---------------*/\n\n/* Toggle (Modifies active state to give affordances) */\n\n.ui.toggle.buttons .active.button, .ui.buttons .button.toggle.active, .ui.button.toggle.active {\n  background-color: #59D98D !important;\n  box-shadow: none !important;\n  text-shadow: none;\n  color: #FFFFFF !important;\n}\n\n.ui.button.toggle.active:hover {\n  background-color: #3ddb7d !important;\n  text-shadow: none;\n  color: #FFFFFF !important;\n}\n\n/*--------------\n    Circular\n---------------*/\n\n.ui.circular.button {\n  border-radius: 10em;\n}\n\n.ui.circular.button > .icon {\n  width: 1em;\n  vertical-align: baseline;\n}\n\n/*-------------------\n      Or Buttons\n--------------------*/\n\n.ui.buttons .or {\n  position: relative;\n  width: 0.3em;\n  height: 2.57142857em;\n  z-index: 3;\n}\n\n.ui.buttons .or:before {\n  position: absolute;\n  text-align: center;\n  border-radius: 500rem;\n  content: 'or';\n  top: 50%;\n  left: 50%;\n  background-color: #FFFFFF;\n  text-shadow: none;\n  margin-top: -0.89285714em;\n  margin-left: -0.89285714em;\n  width: 1.78571429em;\n  height: 1.78571429em;\n  line-height: 1.78571429em;\n  color: rgba(0, 0, 0, 0.4);\n  font-style: normal;\n  font-weight: bold;\n  box-shadow: 0px 0px 0px 1px transparent inset;\n}\n\n.ui.buttons .or[data-text]:before {\n  content: attr(data-text);\n}\n\n/* Fluid Or */\n\n.ui.fluid.buttons .or {\n  width: 0em !important;\n}\n\n.ui.fluid.buttons .or:after {\n  display: none;\n}\n\n/*-------------------\n       Attached\n--------------------*/\n\n/* Singular */\n\n.ui.attached.button {\n  position: relative;\n  display: block;\n  margin: 0em;\n  border-radius: 0em;\n  box-shadow: 0px 0px 0px 1px #DEDEDF !important;\n}\n\n/* Top / Bottom */\n\n.ui.attached.top.button {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.attached.bottom.button {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n/* Left / Right */\n\n.ui.left.attached.button {\n  display: inline-block;\n  border-left: none;\n  text-align: right;\n  padding-right: 0.75em;\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n.ui.right.attached.button {\n  display: inline-block;\n  text-align: left;\n  padding-left: 0.75em;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n/* Plural */\n\n.ui.attached.buttons {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 0em;\n  width: auto !important;\n  z-index: 2;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.ui.attached.buttons .button {\n  margin: 0em;\n}\n\n.ui.attached.buttons .button:first-child {\n  border-radius: 0em;\n}\n\n.ui.attached.buttons .button:last-child {\n  border-radius: 0em;\n}\n\n/* Top / Bottom */\n\n.ui[class*=\"top attached\"].buttons {\n  margin-bottom: -1px;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui[class*=\"top attached\"].buttons .button:first-child {\n  border-radius: 0.21428571rem 0em 0em 0em;\n}\n\n.ui[class*=\"top attached\"].buttons .button:last-child {\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n.ui[class*=\"bottom attached\"].buttons {\n  margin-top: -1px;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui[class*=\"bottom attached\"].buttons .button:first-child {\n  border-radius: 0em 0em 0em 0.21428571rem;\n}\n\n.ui[class*=\"bottom attached\"].buttons .button:last-child {\n  border-radius: 0em 0em 0.21428571rem 0em;\n}\n\n/* Left / Right */\n\n.ui[class*=\"left attached\"].buttons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 0em;\n  margin-left: -1px;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n.ui[class*=\"left attached\"].buttons .button:first-child {\n  margin-left: -1px;\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n.ui[class*=\"left attached\"].buttons .button:last-child {\n  margin-left: -1px;\n  border-radius: 0em 0em 0.21428571rem 0em;\n}\n\n.ui[class*=\"right attached\"].buttons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-left: 0em;\n  margin-right: -1px;\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n.ui[class*=\"right attached\"].buttons .button:first-child {\n  margin-left: -1px;\n  border-radius: 0.21428571rem 0em 0em 0em;\n}\n\n.ui[class*=\"right attached\"].buttons .button:last-child {\n  margin-left: -1px;\n  border-radius: 0em 0em 0em 0.21428571rem;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.buttons, .ui.fluid.button {\n  width: 100%;\n}\n\n.ui.fluid.button {\n  display: block;\n}\n\n.ui.two.buttons {\n  width: 100%;\n}\n\n.ui.two.buttons > .button {\n  width: 50%;\n}\n\n.ui.three.buttons {\n  width: 100%;\n}\n\n.ui.three.buttons > .button {\n  width: 33.333%;\n}\n\n.ui.four.buttons {\n  width: 100%;\n}\n\n.ui.four.buttons > .button {\n  width: 25%;\n}\n\n.ui.five.buttons {\n  width: 100%;\n}\n\n.ui.five.buttons > .button {\n  width: 20%;\n}\n\n.ui.six.buttons {\n  width: 100%;\n}\n\n.ui.six.buttons > .button {\n  width: 16.666%;\n}\n\n.ui.seven.buttons {\n  width: 100%;\n}\n\n.ui.seven.buttons > .button {\n  width: 14.285%;\n}\n\n.ui.eight.buttons {\n  width: 100%;\n}\n\n.ui.eight.buttons > .button {\n  width: 12.5%;\n}\n\n.ui.nine.buttons {\n  width: 100%;\n}\n\n.ui.nine.buttons > .button {\n  width: 11.11%;\n}\n\n.ui.ten.buttons {\n  width: 100%;\n}\n\n.ui.ten.buttons > .button {\n  width: 10%;\n}\n\n.ui.eleven.buttons {\n  width: 100%;\n}\n\n.ui.eleven.buttons > .button {\n  width: 9.09%;\n}\n\n.ui.twelve.buttons {\n  width: 100%;\n}\n\n.ui.twelve.buttons > .button {\n  width: 8.3333%;\n}\n\n/* Fluid Vertical Buttons */\n\n.ui.fluid.vertical.buttons, .ui.fluid.vertical.buttons > .button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: auto;\n}\n\n.ui.two.vertical.buttons > .button {\n  height: 50%;\n}\n\n.ui.three.vertical.buttons > .button {\n  height: 33.333%;\n}\n\n.ui.four.vertical.buttons > .button {\n  height: 25%;\n}\n\n.ui.five.vertical.buttons > .button {\n  height: 20%;\n}\n\n.ui.six.vertical.buttons > .button {\n  height: 16.666%;\n}\n\n.ui.seven.vertical.buttons > .button {\n  height: 14.285%;\n}\n\n.ui.eight.vertical.buttons > .button {\n  height: 12.5%;\n}\n\n.ui.nine.vertical.buttons > .button {\n  height: 11.11%;\n}\n\n.ui.ten.vertical.buttons > .button {\n  height: 10%;\n}\n\n.ui.eleven.vertical.buttons > .button {\n  height: 9.09%;\n}\n\n.ui.twelve.vertical.buttons > .button {\n  height: 8.3333%;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Black ---*/\n\n.ui.black.buttons .button, .ui.black.button {\n  background-color: #1B1C1D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.black.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.black.buttons .button:hover, .ui.black.button:hover {\n  background-color: #27292a;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.black.buttons .button:focus, .ui.black.button:focus {\n  background-color: #2f3032;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.black.buttons .button:active, .ui.black.button:active {\n  background-color: #343637;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.black.buttons .active.button, .ui.black.buttons .active.button:active, .ui.black.active.button, .ui.black.button .active.button:active {\n  background-color: #0f0f10;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.black.buttons .button, .ui.basic.black.button {\n  box-shadow: 0px 0px 0px 1px #1B1C1D inset !important;\n  color: #1B1C1D !important;\n}\n\n.ui.basic.black.buttons .button:hover, .ui.basic.black.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #27292a inset !important;\n  color: #27292a !important;\n}\n\n.ui.basic.black.buttons .button:focus, .ui.basic.black.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #2f3032 inset !important;\n  color: #27292a !important;\n}\n\n.ui.basic.black.buttons .active.button, .ui.basic.black.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0f0f10 inset !important;\n  color: #343637 !important;\n}\n\n.ui.basic.black.buttons .button:active, .ui.basic.black.button:active {\n  box-shadow: 0px 0px 0px 1px #343637 inset !important;\n  color: #343637 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.black.buttons .button, .ui.inverted.black.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #DEDEDF inset !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.black.buttons .button:hover, .ui.inverted.black.button:hover, .ui.inverted.black.buttons .button:focus, .ui.inverted.black.button:focus, .ui.inverted.black.buttons .button.active, .ui.inverted.black.button.active, .ui.inverted.black.buttons .button:active, .ui.inverted.black.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.black.buttons .button:hover, .ui.inverted.black.button:hover {\n  background-color: #000000;\n}\n\n.ui.inverted.black.buttons .button:focus, .ui.inverted.black.button:focus {\n  background-color: #000000;\n}\n\n.ui.inverted.black.buttons .active.button, .ui.inverted.black.active.button {\n  background-color: #000000;\n}\n\n.ui.inverted.black.buttons .button:active, .ui.inverted.black.button:active {\n  background-color: #000000;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.black.basic.buttons .button, .ui.inverted.black.buttons .basic.button, .ui.inverted.black.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.black.basic.buttons .button:hover, .ui.inverted.black.buttons .basic.button:hover, .ui.inverted.black.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.black.basic.buttons .button:focus, .ui.inverted.black.basic.buttons .button:focus, .ui.inverted.black.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #545454 !important;\n}\n\n.ui.inverted.black.basic.buttons .active.button, .ui.inverted.black.buttons .basic.active.button, .ui.inverted.black.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.black.basic.buttons .button:active, .ui.inverted.black.buttons .basic.button:active, .ui.inverted.black.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #000000 inset !important;\n  color: #FFFFFF !important;\n}\n\n/*--- Grey ---*/\n\n.ui.grey.buttons .button, .ui.grey.button {\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.grey.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.grey.buttons .button:hover, .ui.grey.button:hover {\n  background-color: rgba(13, 13, 13, 0.4);\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.grey.buttons .button:focus, .ui.grey.button:focus {\n  background-color: rgba(20, 20, 20, 0.4);\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.grey.buttons .button:active, .ui.grey.button:active {\n  background-color: rgba(26, 26, 26, 0.4);\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.grey.buttons .active.button, .ui.grey.buttons .active.button:active, .ui.grey.active.button, .ui.grey.button .active.button:active {\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.grey.buttons .button, .ui.basic.grey.button {\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.4) inset !important;\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.ui.basic.grey.buttons .button:hover, .ui.basic.grey.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px rgba(13, 13, 13, 0.4) inset !important;\n  color: rgba(13, 13, 13, 0.4) !important;\n}\n\n.ui.basic.grey.buttons .button:focus, .ui.basic.grey.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px rgba(20, 20, 20, 0.4) inset !important;\n  color: rgba(13, 13, 13, 0.4) !important;\n}\n\n.ui.basic.grey.buttons .active.button, .ui.basic.grey.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.4) inset !important;\n  color: rgba(26, 26, 26, 0.4) !important;\n}\n\n.ui.basic.grey.buttons .button:active, .ui.basic.grey.button:active {\n  box-shadow: 0px 0px 0px 1px rgba(26, 26, 26, 0.4) inset !important;\n  color: rgba(26, 26, 26, 0.4) !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.grey.buttons .button, .ui.inverted.grey.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #DEDEDF inset !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.grey.buttons .button:hover, .ui.inverted.grey.button:hover, .ui.inverted.grey.buttons .button:focus, .ui.inverted.grey.button:focus, .ui.inverted.grey.buttons .button.active, .ui.inverted.grey.button.active, .ui.inverted.grey.buttons .button:active, .ui.inverted.grey.button:active {\n  box-shadow: none !important;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.inverted.grey.buttons .button:hover, .ui.inverted.grey.button:hover {\n  background-color: #d1d1d3;\n}\n\n.ui.inverted.grey.buttons .button:focus, .ui.inverted.grey.button:focus {\n  background-color: #c9c9cb;\n}\n\n.ui.inverted.grey.buttons .active.button, .ui.inverted.grey.active.button {\n  background-color: #d1d1d3;\n}\n\n.ui.inverted.grey.buttons .button:active, .ui.inverted.grey.button:active {\n  background-color: #c4c4c6;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.grey.basic.buttons .button, .ui.inverted.grey.buttons .basic.button, .ui.inverted.grey.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.grey.basic.buttons .button:hover, .ui.inverted.grey.buttons .basic.button:hover, .ui.inverted.grey.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #d1d1d3 inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.grey.basic.buttons .button:focus, .ui.inverted.grey.basic.buttons .button:focus, .ui.inverted.grey.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #c9c9cb inset !important;\n  color: #DEDEDF !important;\n}\n\n.ui.inverted.grey.basic.buttons .active.button, .ui.inverted.grey.buttons .basic.active.button, .ui.inverted.grey.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #d1d1d3 inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.grey.basic.buttons .button:active, .ui.inverted.grey.buttons .basic.button:active, .ui.inverted.grey.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #c4c4c6 inset !important;\n  color: #FFFFFF !important;\n}\n\n/*--- Brown ---*/\n\n.ui.brown.buttons .button, .ui.brown.button {\n  background-color: #A5673F;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.brown.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.brown.buttons .button:hover, .ui.brown.button:hover {\n  background-color: #975b33;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.brown.buttons .button:focus, .ui.brown.button:focus {\n  background-color: #90532b;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.brown.buttons .button:active, .ui.brown.button:active {\n  background-color: #805031;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.brown.buttons .active.button, .ui.brown.buttons .active.button:active, .ui.brown.active.button, .ui.brown.button .active.button:active {\n  background-color: #995a31;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.brown.buttons .button, .ui.basic.brown.button {\n  box-shadow: 0px 0px 0px 1px #A5673F inset !important;\n  color: #A5673F !important;\n}\n\n.ui.basic.brown.buttons .button:hover, .ui.basic.brown.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #975b33 inset !important;\n  color: #975b33 !important;\n}\n\n.ui.basic.brown.buttons .button:focus, .ui.basic.brown.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #90532b inset !important;\n  color: #975b33 !important;\n}\n\n.ui.basic.brown.buttons .active.button, .ui.basic.brown.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #995a31 inset !important;\n  color: #805031 !important;\n}\n\n.ui.basic.brown.buttons .button:active, .ui.basic.brown.button:active {\n  box-shadow: 0px 0px 0px 1px #805031 inset !important;\n  color: #805031 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.brown.buttons .button, .ui.inverted.brown.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D67C1C inset !important;\n  color: #D67C1C;\n}\n\n.ui.inverted.brown.buttons .button:hover, .ui.inverted.brown.button:hover, .ui.inverted.brown.buttons .button:focus, .ui.inverted.brown.button:focus, .ui.inverted.brown.buttons .button.active, .ui.inverted.brown.button.active, .ui.inverted.brown.buttons .button:active, .ui.inverted.brown.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.brown.buttons .button:hover, .ui.inverted.brown.button:hover {\n  background-color: #c86f11;\n}\n\n.ui.inverted.brown.buttons .button:focus, .ui.inverted.brown.button:focus {\n  background-color: #c16808;\n}\n\n.ui.inverted.brown.buttons .active.button, .ui.inverted.brown.active.button {\n  background-color: #cc6f0d;\n}\n\n.ui.inverted.brown.buttons .button:active, .ui.inverted.brown.button:active {\n  background-color: #a96216;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.brown.basic.buttons .button, .ui.inverted.brown.buttons .basic.button, .ui.inverted.brown.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.brown.basic.buttons .button:hover, .ui.inverted.brown.buttons .basic.button:hover, .ui.inverted.brown.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #c86f11 inset !important;\n  color: #D67C1C !important;\n}\n\n.ui.inverted.brown.basic.buttons .button:focus, .ui.inverted.brown.basic.buttons .button:focus, .ui.inverted.brown.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #c16808 inset !important;\n  color: #D67C1C !important;\n}\n\n.ui.inverted.brown.basic.buttons .active.button, .ui.inverted.brown.buttons .basic.active.button, .ui.inverted.brown.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #cc6f0d inset !important;\n  color: #D67C1C !important;\n}\n\n.ui.inverted.brown.basic.buttons .button:active, .ui.inverted.brown.buttons .basic.button:active, .ui.inverted.brown.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #a96216 inset !important;\n  color: #D67C1C !important;\n}\n\n/*--- Blue ---*/\n\n.ui.blue.buttons .button, .ui.blue.button {\n  background-color: #2185D0;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.blue.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.blue.buttons .button:hover, .ui.blue.button:hover {\n  background-color: #1678c2;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.blue.buttons .button:focus, .ui.blue.button:focus {\n  background-color: #0d71bb;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.blue.buttons .button:active, .ui.blue.button:active {\n  background-color: #1a69a4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.blue.buttons .active.button, .ui.blue.buttons .active.button:active, .ui.blue.active.button, .ui.blue.button .active.button:active {\n  background-color: #1279c6;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.blue.buttons .button, .ui.basic.blue.button {\n  box-shadow: 0px 0px 0px 1px #2185D0 inset !important;\n  color: #2185D0 !important;\n}\n\n.ui.basic.blue.buttons .button:hover, .ui.basic.blue.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1678c2 inset !important;\n  color: #1678c2 !important;\n}\n\n.ui.basic.blue.buttons .button:focus, .ui.basic.blue.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #0d71bb inset !important;\n  color: #1678c2 !important;\n}\n\n.ui.basic.blue.buttons .active.button, .ui.basic.blue.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #1279c6 inset !important;\n  color: #1a69a4 !important;\n}\n\n.ui.basic.blue.buttons .button:active, .ui.basic.blue.button:active {\n  box-shadow: 0px 0px 0px 1px #1a69a4 inset !important;\n  color: #1a69a4 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.blue.buttons .button, .ui.inverted.blue.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;\n  color: #54C8FF;\n}\n\n.ui.inverted.blue.buttons .button:hover, .ui.inverted.blue.button:hover, .ui.inverted.blue.buttons .button:focus, .ui.inverted.blue.button:focus, .ui.inverted.blue.buttons .button.active, .ui.inverted.blue.button.active, .ui.inverted.blue.buttons .button:active, .ui.inverted.blue.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.blue.buttons .button:hover, .ui.inverted.blue.button:hover {\n  background-color: #3ac0ff;\n}\n\n.ui.inverted.blue.buttons .button:focus, .ui.inverted.blue.button:focus {\n  background-color: #2bbbff;\n}\n\n.ui.inverted.blue.buttons .active.button, .ui.inverted.blue.active.button {\n  background-color: #3ac0ff;\n}\n\n.ui.inverted.blue.buttons .button:active, .ui.inverted.blue.button:active {\n  background-color: #21b8ff;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.blue.basic.buttons .button, .ui.inverted.blue.buttons .basic.button, .ui.inverted.blue.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.blue.basic.buttons .button:hover, .ui.inverted.blue.buttons .basic.button:hover, .ui.inverted.blue.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.blue.basic.buttons .button:focus, .ui.inverted.blue.basic.buttons .button:focus, .ui.inverted.blue.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.blue.basic.buttons .active.button, .ui.inverted.blue.buttons .basic.active.button, .ui.inverted.blue.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.blue.basic.buttons .button:active, .ui.inverted.blue.buttons .basic.button:active, .ui.inverted.blue.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;\n  color: #54C8FF !important;\n}\n\n/*--- Green ---*/\n\n.ui.green.buttons .button, .ui.green.button {\n  background-color: #59D98D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.green.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.green.buttons .button:hover, .ui.green.button:hover {\n  background-color: #3ddb7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.green.buttons .button:focus, .ui.green.button:focus {\n  background-color: #28e173;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.green.buttons .button:active, .ui.green.button:active {\n  background-color: #30d071;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.green.buttons .active.button, .ui.green.buttons .active.button:active, .ui.green.active.button, .ui.green.button .active.button:active {\n  background-color: #39df7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.green.buttons .button, .ui.basic.green.button {\n  box-shadow: 0px 0px 0px 1px #59D98D inset !important;\n  color: #59D98D !important;\n}\n\n.ui.basic.green.buttons .button:hover, .ui.basic.green.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #3ddb7d inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.green.buttons .button:focus, .ui.basic.green.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #28e173 inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.green.buttons .active.button, .ui.basic.green.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #39df7d inset !important;\n  color: #30d071 !important;\n}\n\n.ui.basic.green.buttons .button:active, .ui.basic.green.button:active {\n  box-shadow: 0px 0px 0px 1px #30d071 inset !important;\n  color: #30d071 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.green.buttons .button, .ui.inverted.green.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #2ECC40 inset !important;\n  color: #2ECC40;\n}\n\n.ui.inverted.green.buttons .button:hover, .ui.inverted.green.button:hover, .ui.inverted.green.buttons .button:focus, .ui.inverted.green.button:focus, .ui.inverted.green.buttons .button.active, .ui.inverted.green.button.active, .ui.inverted.green.buttons .button:active, .ui.inverted.green.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.green.buttons .button:hover, .ui.inverted.green.button:hover {\n  background-color: #22be34;\n}\n\n.ui.inverted.green.buttons .button:focus, .ui.inverted.green.button:focus {\n  background-color: #19b82b;\n}\n\n.ui.inverted.green.buttons .active.button, .ui.inverted.green.active.button {\n  background-color: #1fc231;\n}\n\n.ui.inverted.green.buttons .button:active, .ui.inverted.green.button:active {\n  background-color: #25a233;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.green.basic.buttons .button, .ui.inverted.green.buttons .basic.button, .ui.inverted.green.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.green.basic.buttons .button:hover, .ui.inverted.green.buttons .basic.button:hover, .ui.inverted.green.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #22be34 inset !important;\n  color: #2ECC40 !important;\n}\n\n.ui.inverted.green.basic.buttons .button:focus, .ui.inverted.green.basic.buttons .button:focus, .ui.inverted.green.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #19b82b inset !important;\n  color: #2ECC40 !important;\n}\n\n.ui.inverted.green.basic.buttons .active.button, .ui.inverted.green.buttons .basic.active.button, .ui.inverted.green.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #1fc231 inset !important;\n  color: #2ECC40 !important;\n}\n\n.ui.inverted.green.basic.buttons .button:active, .ui.inverted.green.buttons .basic.button:active, .ui.inverted.green.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #25a233 inset !important;\n  color: #2ECC40 !important;\n}\n\n/*--- Orange ---*/\n\n.ui.orange.buttons .button, .ui.orange.button {\n  background-color: #FF9F5B;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.orange.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.orange.buttons .button:hover, .ui.orange.button:hover {\n  background-color: #ff9042;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.orange.buttons .button:focus, .ui.orange.button:focus {\n  background-color: #ff8732;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.orange.buttons .button:active, .ui.orange.button:active {\n  background-color: #ff8128;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.orange.buttons .active.button, .ui.orange.buttons .active.button:active, .ui.orange.active.button, .ui.orange.button .active.button:active {\n  background-color: #ff9042;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.orange.buttons .button, .ui.basic.orange.button {\n  box-shadow: 0px 0px 0px 1px #FF9F5B inset !important;\n  color: #FF9F5B !important;\n}\n\n.ui.basic.orange.buttons .button:hover, .ui.basic.orange.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ff9042 inset !important;\n  color: #ff9042 !important;\n}\n\n.ui.basic.orange.buttons .button:focus, .ui.basic.orange.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ff8732 inset !important;\n  color: #ff9042 !important;\n}\n\n.ui.basic.orange.buttons .active.button, .ui.basic.orange.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ff9042 inset !important;\n  color: #ff8128 !important;\n}\n\n.ui.basic.orange.buttons .button:active, .ui.basic.orange.button:active {\n  box-shadow: 0px 0px 0px 1px #ff8128 inset !important;\n  color: #ff8128 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.orange.buttons .button, .ui.inverted.orange.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF851B inset !important;\n  color: #FF851B;\n}\n\n.ui.inverted.orange.buttons .button:hover, .ui.inverted.orange.button:hover, .ui.inverted.orange.buttons .button:focus, .ui.inverted.orange.button:focus, .ui.inverted.orange.buttons .button.active, .ui.inverted.orange.button.active, .ui.inverted.orange.buttons .button:active, .ui.inverted.orange.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.orange.buttons .button:hover, .ui.inverted.orange.button:hover {\n  background-color: #ff7701;\n}\n\n.ui.inverted.orange.buttons .button:focus, .ui.inverted.orange.button:focus {\n  background-color: #f17000;\n}\n\n.ui.inverted.orange.buttons .active.button, .ui.inverted.orange.active.button {\n  background-color: #ff7701;\n}\n\n.ui.inverted.orange.buttons .button:active, .ui.inverted.orange.button:active {\n  background-color: #e76b00;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.orange.basic.buttons .button, .ui.inverted.orange.buttons .basic.button, .ui.inverted.orange.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.orange.basic.buttons .button:hover, .ui.inverted.orange.buttons .basic.button:hover, .ui.inverted.orange.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;\n  color: #FF851B !important;\n}\n\n.ui.inverted.orange.basic.buttons .button:focus, .ui.inverted.orange.basic.buttons .button:focus, .ui.inverted.orange.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #f17000 inset !important;\n  color: #FF851B !important;\n}\n\n.ui.inverted.orange.basic.buttons .active.button, .ui.inverted.orange.buttons .basic.active.button, .ui.inverted.orange.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff7701 inset !important;\n  color: #FF851B !important;\n}\n\n.ui.inverted.orange.basic.buttons .button:active, .ui.inverted.orange.buttons .basic.button:active, .ui.inverted.orange.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #e76b00 inset !important;\n  color: #FF851B !important;\n}\n\n/*--- Pink ---*/\n\n.ui.pink.buttons .button, .ui.pink.button {\n  background-color: #E03997;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.pink.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.pink.buttons .button:hover, .ui.pink.button:hover {\n  background-color: #e61a8d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.pink.buttons .button:focus, .ui.pink.button:focus {\n  background-color: #e10f85;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.pink.buttons .button:active, .ui.pink.button:active {\n  background-color: #c71f7e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.pink.buttons .active.button, .ui.pink.buttons .active.button:active, .ui.pink.active.button, .ui.pink.button .active.button:active {\n  background-color: #ea158d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.pink.buttons .button, .ui.basic.pink.button {\n  box-shadow: 0px 0px 0px 1px #E03997 inset !important;\n  color: #E03997 !important;\n}\n\n.ui.basic.pink.buttons .button:hover, .ui.basic.pink.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #e61a8d inset !important;\n  color: #e61a8d !important;\n}\n\n.ui.basic.pink.buttons .button:focus, .ui.basic.pink.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #e10f85 inset !important;\n  color: #e61a8d !important;\n}\n\n.ui.basic.pink.buttons .active.button, .ui.basic.pink.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ea158d inset !important;\n  color: #c71f7e !important;\n}\n\n.ui.basic.pink.buttons .button:active, .ui.basic.pink.button:active {\n  box-shadow: 0px 0px 0px 1px #c71f7e inset !important;\n  color: #c71f7e !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.pink.buttons .button, .ui.inverted.pink.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF8EDF inset !important;\n  color: #FF8EDF;\n}\n\n.ui.inverted.pink.buttons .button:hover, .ui.inverted.pink.button:hover, .ui.inverted.pink.buttons .button:focus, .ui.inverted.pink.button:focus, .ui.inverted.pink.buttons .button.active, .ui.inverted.pink.button.active, .ui.inverted.pink.buttons .button:active, .ui.inverted.pink.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.pink.buttons .button:hover, .ui.inverted.pink.button:hover {\n  background-color: #ff74d8;\n}\n\n.ui.inverted.pink.buttons .button:focus, .ui.inverted.pink.button:focus {\n  background-color: #ff65d3;\n}\n\n.ui.inverted.pink.buttons .active.button, .ui.inverted.pink.active.button {\n  background-color: #ff74d8;\n}\n\n.ui.inverted.pink.buttons .button:active, .ui.inverted.pink.button:active {\n  background-color: #ff5bd1;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.pink.basic.buttons .button, .ui.inverted.pink.buttons .basic.button, .ui.inverted.pink.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.pink.basic.buttons .button:hover, .ui.inverted.pink.buttons .basic.button:hover, .ui.inverted.pink.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;\n  color: #FF8EDF !important;\n}\n\n.ui.inverted.pink.basic.buttons .button:focus, .ui.inverted.pink.basic.buttons .button:focus, .ui.inverted.pink.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #ff65d3 inset !important;\n  color: #FF8EDF !important;\n}\n\n.ui.inverted.pink.basic.buttons .active.button, .ui.inverted.pink.buttons .basic.active.button, .ui.inverted.pink.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff74d8 inset !important;\n  color: #FF8EDF !important;\n}\n\n.ui.inverted.pink.basic.buttons .button:active, .ui.inverted.pink.buttons .basic.button:active, .ui.inverted.pink.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ff5bd1 inset !important;\n  color: #FF8EDF !important;\n}\n\n/*--- Violet ---*/\n\n.ui.violet.buttons .button, .ui.violet.button {\n  background-color: #6435C9;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.violet.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.violet.buttons .button:hover, .ui.violet.button:hover {\n  background-color: #5829bb;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.violet.buttons .button:focus, .ui.violet.button:focus {\n  background-color: #4f20b5;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.violet.buttons .button:active, .ui.violet.button:active {\n  background-color: #502aa1;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.violet.buttons .active.button, .ui.violet.buttons .active.button:active, .ui.violet.active.button, .ui.violet.button .active.button:active {\n  background-color: #5626bf;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.violet.buttons .button, .ui.basic.violet.button {\n  box-shadow: 0px 0px 0px 1px #6435C9 inset !important;\n  color: #6435C9 !important;\n}\n\n.ui.basic.violet.buttons .button:hover, .ui.basic.violet.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #5829bb inset !important;\n  color: #5829bb !important;\n}\n\n.ui.basic.violet.buttons .button:focus, .ui.basic.violet.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #4f20b5 inset !important;\n  color: #5829bb !important;\n}\n\n.ui.basic.violet.buttons .active.button, .ui.basic.violet.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #5626bf inset !important;\n  color: #502aa1 !important;\n}\n\n.ui.basic.violet.buttons .button:active, .ui.basic.violet.button:active {\n  box-shadow: 0px 0px 0px 1px #502aa1 inset !important;\n  color: #502aa1 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.violet.buttons .button, .ui.inverted.violet.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #A291FB inset !important;\n  color: #A291FB;\n}\n\n.ui.inverted.violet.buttons .button:hover, .ui.inverted.violet.button:hover, .ui.inverted.violet.buttons .button:focus, .ui.inverted.violet.button:focus, .ui.inverted.violet.buttons .button.active, .ui.inverted.violet.button.active, .ui.inverted.violet.buttons .button:active, .ui.inverted.violet.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.violet.buttons .button:hover, .ui.inverted.violet.button:hover {\n  background-color: #8a73ff;\n}\n\n.ui.inverted.violet.buttons .button:focus, .ui.inverted.violet.button:focus {\n  background-color: #7d64ff;\n}\n\n.ui.inverted.violet.buttons .active.button, .ui.inverted.violet.active.button {\n  background-color: #8a73ff;\n}\n\n.ui.inverted.violet.buttons .button:active, .ui.inverted.violet.button:active {\n  background-color: #7860f9;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.violet.basic.buttons .button, .ui.inverted.violet.buttons .basic.button, .ui.inverted.violet.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.violet.basic.buttons .button:hover, .ui.inverted.violet.buttons .basic.button:hover, .ui.inverted.violet.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;\n  color: #A291FB !important;\n}\n\n.ui.inverted.violet.basic.buttons .button:focus, .ui.inverted.violet.basic.buttons .button:focus, .ui.inverted.violet.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #7d64ff inset !important;\n  color: #A291FB !important;\n}\n\n.ui.inverted.violet.basic.buttons .active.button, .ui.inverted.violet.buttons .basic.active.button, .ui.inverted.violet.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #8a73ff inset !important;\n  color: #A291FB !important;\n}\n\n.ui.inverted.violet.basic.buttons .button:active, .ui.inverted.violet.buttons .basic.button:active, .ui.inverted.violet.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #7860f9 inset !important;\n  color: #A291FB !important;\n}\n\n/*--- Purple ---*/\n\n.ui.purple.buttons .button, .ui.purple.button {\n  background-color: #A333C8;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.purple.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.purple.buttons .button:hover, .ui.purple.button:hover {\n  background-color: #9627ba;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.purple.buttons .button:focus, .ui.purple.button:focus {\n  background-color: #8f1eb4;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.purple.buttons .button:active, .ui.purple.button:active {\n  background-color: #82299f;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.purple.buttons .active.button, .ui.purple.buttons .active.button:active, .ui.purple.active.button, .ui.purple.button .active.button:active {\n  background-color: #9724be;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.purple.buttons .button, .ui.basic.purple.button {\n  box-shadow: 0px 0px 0px 1px #A333C8 inset !important;\n  color: #A333C8 !important;\n}\n\n.ui.basic.purple.buttons .button:hover, .ui.basic.purple.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #9627ba inset !important;\n  color: #9627ba !important;\n}\n\n.ui.basic.purple.buttons .button:focus, .ui.basic.purple.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #8f1eb4 inset !important;\n  color: #9627ba !important;\n}\n\n.ui.basic.purple.buttons .active.button, .ui.basic.purple.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #9724be inset !important;\n  color: #82299f !important;\n}\n\n.ui.basic.purple.buttons .button:active, .ui.basic.purple.button:active {\n  box-shadow: 0px 0px 0px 1px #82299f inset !important;\n  color: #82299f !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.purple.buttons .button, .ui.inverted.purple.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #DC73FF inset !important;\n  color: #DC73FF;\n}\n\n.ui.inverted.purple.buttons .button:hover, .ui.inverted.purple.button:hover, .ui.inverted.purple.buttons .button:focus, .ui.inverted.purple.button:focus, .ui.inverted.purple.buttons .button.active, .ui.inverted.purple.button.active, .ui.inverted.purple.buttons .button:active, .ui.inverted.purple.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.purple.buttons .button:hover, .ui.inverted.purple.button:hover {\n  background-color: #d65aff;\n}\n\n.ui.inverted.purple.buttons .button:focus, .ui.inverted.purple.button:focus {\n  background-color: #d24aff;\n}\n\n.ui.inverted.purple.buttons .active.button, .ui.inverted.purple.active.button {\n  background-color: #d65aff;\n}\n\n.ui.inverted.purple.buttons .button:active, .ui.inverted.purple.button:active {\n  background-color: #cf40ff;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.purple.basic.buttons .button, .ui.inverted.purple.buttons .basic.button, .ui.inverted.purple.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.purple.basic.buttons .button:hover, .ui.inverted.purple.buttons .basic.button:hover, .ui.inverted.purple.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #d65aff inset !important;\n  color: #DC73FF !important;\n}\n\n.ui.inverted.purple.basic.buttons .button:focus, .ui.inverted.purple.basic.buttons .button:focus, .ui.inverted.purple.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #d24aff inset !important;\n  color: #DC73FF !important;\n}\n\n.ui.inverted.purple.basic.buttons .active.button, .ui.inverted.purple.buttons .basic.active.button, .ui.inverted.purple.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #d65aff inset !important;\n  color: #DC73FF !important;\n}\n\n.ui.inverted.purple.basic.buttons .button:active, .ui.inverted.purple.buttons .basic.button:active, .ui.inverted.purple.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #cf40ff inset !important;\n  color: #DC73FF !important;\n}\n\n/*--- Red ---*/\n\n.ui.red.buttons .button, .ui.red.button {\n  background-color: #DB2828;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.red.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.red.buttons .button:hover, .ui.red.button:hover {\n  background-color: #d01919;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.red.buttons .button:focus, .ui.red.button:focus {\n  background-color: #ca1010;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.red.buttons .button:active, .ui.red.button:active {\n  background-color: #b21e1e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.red.buttons .active.button, .ui.red.buttons .active.button:active, .ui.red.active.button, .ui.red.button .active.button:active {\n  background-color: #d41515;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.red.buttons .button, .ui.basic.red.button {\n  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;\n  color: #DB2828 !important;\n}\n\n.ui.basic.red.buttons .button:hover, .ui.basic.red.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d01919 inset !important;\n  color: #d01919 !important;\n}\n\n.ui.basic.red.buttons .button:focus, .ui.basic.red.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;\n  color: #d01919 !important;\n}\n\n.ui.basic.red.buttons .active.button, .ui.basic.red.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d41515 inset !important;\n  color: #b21e1e !important;\n}\n\n.ui.basic.red.buttons .button:active, .ui.basic.red.button:active {\n  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;\n  color: #b21e1e !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.red.buttons .button, .ui.inverted.red.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FF695E inset !important;\n  color: #FF695E;\n}\n\n.ui.inverted.red.buttons .button:hover, .ui.inverted.red.button:hover, .ui.inverted.red.buttons .button:focus, .ui.inverted.red.button:focus, .ui.inverted.red.buttons .button.active, .ui.inverted.red.button.active, .ui.inverted.red.buttons .button:active, .ui.inverted.red.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.red.buttons .button:hover, .ui.inverted.red.button:hover {\n  background-color: #ff5144;\n}\n\n.ui.inverted.red.buttons .button:focus, .ui.inverted.red.button:focus {\n  background-color: #ff4335;\n}\n\n.ui.inverted.red.buttons .active.button, .ui.inverted.red.active.button {\n  background-color: #ff5144;\n}\n\n.ui.inverted.red.buttons .button:active, .ui.inverted.red.button:active {\n  background-color: #ff392b;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.red.basic.buttons .button, .ui.inverted.red.buttons .basic.button, .ui.inverted.red.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.red.basic.buttons .button:hover, .ui.inverted.red.buttons .basic.button:hover, .ui.inverted.red.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;\n  color: #FF695E !important;\n}\n\n.ui.inverted.red.basic.buttons .button:focus, .ui.inverted.red.basic.buttons .button:focus, .ui.inverted.red.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #ff4335 inset !important;\n  color: #FF695E !important;\n}\n\n.ui.inverted.red.basic.buttons .active.button, .ui.inverted.red.buttons .basic.active.button, .ui.inverted.red.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ff5144 inset !important;\n  color: #FF695E !important;\n}\n\n.ui.inverted.red.basic.buttons .button:active, .ui.inverted.red.buttons .basic.button:active, .ui.inverted.red.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ff392b inset !important;\n  color: #FF695E !important;\n}\n\n/*--- Teal ---*/\n\n.ui.teal.buttons .button, .ui.teal.button {\n  background-color: #00B5AD;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.teal.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.teal.buttons .button:hover, .ui.teal.button:hover {\n  background-color: #009c95;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.teal.buttons .button:focus, .ui.teal.button:focus {\n  background-color: #008c86;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.teal.buttons .button:active, .ui.teal.button:active {\n  background-color: #00827c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.teal.buttons .active.button, .ui.teal.buttons .active.button:active, .ui.teal.active.button, .ui.teal.button .active.button:active {\n  background-color: #009c95;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.teal.buttons .button, .ui.basic.teal.button {\n  box-shadow: 0px 0px 0px 1px #00B5AD inset !important;\n  color: #00B5AD !important;\n}\n\n.ui.basic.teal.buttons .button:hover, .ui.basic.teal.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #009c95 inset !important;\n  color: #009c95 !important;\n}\n\n.ui.basic.teal.buttons .button:focus, .ui.basic.teal.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #008c86 inset !important;\n  color: #009c95 !important;\n}\n\n.ui.basic.teal.buttons .active.button, .ui.basic.teal.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #009c95 inset !important;\n  color: #00827c !important;\n}\n\n.ui.basic.teal.buttons .button:active, .ui.basic.teal.button:active {\n  box-shadow: 0px 0px 0px 1px #00827c inset !important;\n  color: #00827c !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.teal.buttons .button, .ui.inverted.teal.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #6DFFFF inset !important;\n  color: #6DFFFF;\n}\n\n.ui.inverted.teal.buttons .button:hover, .ui.inverted.teal.button:hover, .ui.inverted.teal.buttons .button:focus, .ui.inverted.teal.button:focus, .ui.inverted.teal.buttons .button.active, .ui.inverted.teal.button.active, .ui.inverted.teal.buttons .button:active, .ui.inverted.teal.button:active {\n  box-shadow: none !important;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.inverted.teal.buttons .button:hover, .ui.inverted.teal.button:hover {\n  background-color: #54ffff;\n}\n\n.ui.inverted.teal.buttons .button:focus, .ui.inverted.teal.button:focus {\n  background-color: #44ffff;\n}\n\n.ui.inverted.teal.buttons .active.button, .ui.inverted.teal.active.button {\n  background-color: #54ffff;\n}\n\n.ui.inverted.teal.buttons .button:active, .ui.inverted.teal.button:active {\n  background-color: #3affff;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.teal.basic.buttons .button, .ui.inverted.teal.buttons .basic.button, .ui.inverted.teal.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.teal.basic.buttons .button:hover, .ui.inverted.teal.buttons .basic.button:hover, .ui.inverted.teal.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #54ffff inset !important;\n  color: #6DFFFF !important;\n}\n\n.ui.inverted.teal.basic.buttons .button:focus, .ui.inverted.teal.basic.buttons .button:focus, .ui.inverted.teal.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #44ffff inset !important;\n  color: #6DFFFF !important;\n}\n\n.ui.inverted.teal.basic.buttons .active.button, .ui.inverted.teal.buttons .basic.active.button, .ui.inverted.teal.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #54ffff inset !important;\n  color: #6DFFFF !important;\n}\n\n.ui.inverted.teal.basic.buttons .button:active, .ui.inverted.teal.buttons .basic.button:active, .ui.inverted.teal.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #3affff inset !important;\n  color: #6DFFFF !important;\n}\n\n/*--- Olive ---*/\n\n.ui.olive.buttons .button, .ui.olive.button {\n  background-color: #B5CC18;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.olive.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.olive.buttons .button:hover, .ui.olive.button:hover {\n  background-color: #a7bd0d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.olive.buttons .button:focus, .ui.olive.button:focus {\n  background-color: #a0b605;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.olive.buttons .button:active, .ui.olive.button:active {\n  background-color: #8d9e13;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.olive.buttons .active.button, .ui.olive.buttons .active.button:active, .ui.olive.active.button, .ui.olive.button .active.button:active {\n  background-color: #aac109;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.olive.buttons .button, .ui.basic.olive.button {\n  box-shadow: 0px 0px 0px 1px #B5CC18 inset !important;\n  color: #B5CC18 !important;\n}\n\n.ui.basic.olive.buttons .button:hover, .ui.basic.olive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #a7bd0d inset !important;\n  color: #a7bd0d !important;\n}\n\n.ui.basic.olive.buttons .button:focus, .ui.basic.olive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #a0b605 inset !important;\n  color: #a7bd0d !important;\n}\n\n.ui.basic.olive.buttons .active.button, .ui.basic.olive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #aac109 inset !important;\n  color: #8d9e13 !important;\n}\n\n.ui.basic.olive.buttons .button:active, .ui.basic.olive.button:active {\n  box-shadow: 0px 0px 0px 1px #8d9e13 inset !important;\n  color: #8d9e13 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.olive.buttons .button, .ui.inverted.olive.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #D9E778 inset !important;\n  color: #D9E778;\n}\n\n.ui.inverted.olive.buttons .button:hover, .ui.inverted.olive.button:hover, .ui.inverted.olive.buttons .button:focus, .ui.inverted.olive.button:focus, .ui.inverted.olive.buttons .button.active, .ui.inverted.olive.button.active, .ui.inverted.olive.buttons .button:active, .ui.inverted.olive.button:active {\n  box-shadow: none !important;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.inverted.olive.buttons .button:hover, .ui.inverted.olive.button:hover {\n  background-color: #d8ea5c;\n}\n\n.ui.inverted.olive.buttons .button:focus, .ui.inverted.olive.button:focus {\n  background-color: #daef47;\n}\n\n.ui.inverted.olive.buttons .active.button, .ui.inverted.olive.active.button {\n  background-color: #daed59;\n}\n\n.ui.inverted.olive.buttons .button:active, .ui.inverted.olive.button:active {\n  background-color: #cddf4d;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.olive.basic.buttons .button, .ui.inverted.olive.buttons .basic.button, .ui.inverted.olive.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.olive.basic.buttons .button:hover, .ui.inverted.olive.buttons .basic.button:hover, .ui.inverted.olive.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #d8ea5c inset !important;\n  color: #D9E778 !important;\n}\n\n.ui.inverted.olive.basic.buttons .button:focus, .ui.inverted.olive.basic.buttons .button:focus, .ui.inverted.olive.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #daef47 inset !important;\n  color: #D9E778 !important;\n}\n\n.ui.inverted.olive.basic.buttons .active.button, .ui.inverted.olive.buttons .basic.active.button, .ui.inverted.olive.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #daed59 inset !important;\n  color: #D9E778 !important;\n}\n\n.ui.inverted.olive.basic.buttons .button:active, .ui.inverted.olive.buttons .basic.button:active, .ui.inverted.olive.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #cddf4d inset !important;\n  color: #D9E778 !important;\n}\n\n/*--- Yellow ---*/\n\n.ui.yellow.buttons .button, .ui.yellow.button {\n  background-color: #F9DC5C;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.yellow.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.yellow.buttons .button:hover, .ui.yellow.button:hover {\n  background-color: #ffdb3c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.yellow.buttons .button:focus, .ui.yellow.button:focus {\n  background-color: #ffd82d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.yellow.buttons .button:active, .ui.yellow.button:active {\n  background-color: #f7d12b;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.yellow.buttons .active.button, .ui.yellow.buttons .active.button:active, .ui.yellow.active.button, .ui.yellow.button .active.button:active {\n  background-color: #ffdb3c;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.yellow.buttons .button, .ui.basic.yellow.button {\n  box-shadow: 0px 0px 0px 1px #F9DC5C inset !important;\n  color: #F9DC5C !important;\n}\n\n.ui.basic.yellow.buttons .button:hover, .ui.basic.yellow.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffdb3c inset !important;\n  color: #ffdb3c !important;\n}\n\n.ui.basic.yellow.buttons .button:focus, .ui.basic.yellow.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffd82d inset !important;\n  color: #ffdb3c !important;\n}\n\n.ui.basic.yellow.buttons .active.button, .ui.basic.yellow.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffdb3c inset !important;\n  color: #f7d12b !important;\n}\n\n.ui.basic.yellow.buttons .button:active, .ui.basic.yellow.button:active {\n  box-shadow: 0px 0px 0px 1px #f7d12b inset !important;\n  color: #f7d12b !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.yellow.buttons .button, .ui.inverted.yellow.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #FFE21F inset !important;\n  color: #FFE21F;\n}\n\n.ui.inverted.yellow.buttons .button:hover, .ui.inverted.yellow.button:hover, .ui.inverted.yellow.buttons .button:focus, .ui.inverted.yellow.button:focus, .ui.inverted.yellow.buttons .button.active, .ui.inverted.yellow.button.active, .ui.inverted.yellow.buttons .button:active, .ui.inverted.yellow.button:active {\n  box-shadow: none !important;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.inverted.yellow.buttons .button:hover, .ui.inverted.yellow.button:hover {\n  background-color: #ffdf05;\n}\n\n.ui.inverted.yellow.buttons .button:focus, .ui.inverted.yellow.button:focus {\n  background-color: #f5d500;\n}\n\n.ui.inverted.yellow.buttons .active.button, .ui.inverted.yellow.active.button {\n  background-color: #ffdf05;\n}\n\n.ui.inverted.yellow.buttons .button:active, .ui.inverted.yellow.button:active {\n  background-color: #ebcd00;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.yellow.basic.buttons .button, .ui.inverted.yellow.buttons .basic.button, .ui.inverted.yellow.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.yellow.basic.buttons .button:hover, .ui.inverted.yellow.buttons .basic.button:hover, .ui.inverted.yellow.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;\n  color: #FFE21F !important;\n}\n\n.ui.inverted.yellow.basic.buttons .button:focus, .ui.inverted.yellow.basic.buttons .button:focus, .ui.inverted.yellow.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #f5d500 inset !important;\n  color: #FFE21F !important;\n}\n\n.ui.inverted.yellow.basic.buttons .active.button, .ui.inverted.yellow.buttons .basic.active.button, .ui.inverted.yellow.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #ffdf05 inset !important;\n  color: #FFE21F !important;\n}\n\n.ui.inverted.yellow.basic.buttons .button:active, .ui.inverted.yellow.buttons .basic.button:active, .ui.inverted.yellow.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #ebcd00 inset !important;\n  color: #FFE21F !important;\n}\n\n/*-------------------\n       Primary\n--------------------*/\n\n/*--- Standard ---*/\n\n.ui.primary.buttons .button, .ui.primary.button {\n  background-color: #59D98D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.primary.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.primary.buttons .button:hover, .ui.primary.button:hover {\n  background-color: #3ddb7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.primary.buttons .button:focus, .ui.primary.button:focus {\n  background-color: #28e173;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.primary.buttons .button:active, .ui.primary.button:active {\n  background-color: #30d071;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.primary.buttons .active.button, .ui.primary.buttons .active.button:active, .ui.primary.active.button, .ui.primary.button .active.button:active {\n  background-color: #39df7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.primary.buttons .button, .ui.basic.primary.button {\n  box-shadow: 0px 0px 0px 1px #59D98D inset !important;\n  color: #59D98D !important;\n}\n\n.ui.basic.primary.buttons .button:hover, .ui.basic.primary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #3ddb7d inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.primary.buttons .button:focus, .ui.basic.primary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #28e173 inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.primary.buttons .active.button, .ui.basic.primary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #39df7d inset !important;\n  color: #30d071 !important;\n}\n\n.ui.basic.primary.buttons .button:active, .ui.basic.primary.button:active {\n  box-shadow: 0px 0px 0px 1px #30d071 inset !important;\n  color: #30d071 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.primary.buttons .button, .ui.inverted.primary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #54C8FF inset !important;\n  color: #54C8FF;\n}\n\n.ui.inverted.primary.buttons .button:hover, .ui.inverted.primary.button:hover, .ui.inverted.primary.buttons .button:focus, .ui.inverted.primary.button:focus, .ui.inverted.primary.buttons .button.active, .ui.inverted.primary.button.active, .ui.inverted.primary.buttons .button:active, .ui.inverted.primary.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.primary.buttons .button:hover, .ui.inverted.primary.button:hover {\n  background-color: #3ac0ff;\n}\n\n.ui.inverted.primary.buttons .button:focus, .ui.inverted.primary.button:focus {\n  background-color: #2bbbff;\n}\n\n.ui.inverted.primary.buttons .active.button, .ui.inverted.primary.active.button {\n  background-color: #3ac0ff;\n}\n\n.ui.inverted.primary.buttons .button:active, .ui.inverted.primary.button:active {\n  background-color: #21b8ff;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.primary.basic.buttons .button, .ui.inverted.primary.buttons .basic.button, .ui.inverted.primary.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.primary.basic.buttons .button:hover, .ui.inverted.primary.buttons .basic.button:hover, .ui.inverted.primary.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.primary.basic.buttons .button:focus, .ui.inverted.primary.basic.buttons .button:focus, .ui.inverted.primary.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #2bbbff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.primary.basic.buttons .active.button, .ui.inverted.primary.buttons .basic.active.button, .ui.inverted.primary.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #3ac0ff inset !important;\n  color: #54C8FF !important;\n}\n\n.ui.inverted.primary.basic.buttons .button:active, .ui.inverted.primary.buttons .basic.button:active, .ui.inverted.primary.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #21b8ff inset !important;\n  color: #54C8FF !important;\n}\n\n/*-------------------\n      Secondary\n--------------------*/\n\n/* Standard */\n\n.ui.secondary.buttons .button, .ui.secondary.button {\n  background-color: #FF9F5B;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.secondary.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.secondary.buttons .button:hover, .ui.secondary.button:hover {\n  background-color: #ffae75;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.secondary.buttons .button:focus, .ui.secondary.button:focus {\n  background-color: #ffb784;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.secondary.buttons .button:active, .ui.secondary.button:active {\n  background-color: #ffbd8e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.secondary.buttons .active.button, .ui.secondary.buttons .active.button:active, .ui.secondary.active.button, .ui.secondary.button .active.button:active {\n  background-color: #ffae75;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.secondary.buttons .button, .ui.basic.secondary.button {\n  box-shadow: 0px 0px 0px 1px #FF9F5B inset !important;\n  color: #FF9F5B !important;\n}\n\n.ui.basic.secondary.buttons .button:hover, .ui.basic.secondary.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffae75 inset !important;\n  color: #ffae75 !important;\n}\n\n.ui.basic.secondary.buttons .button:focus, .ui.basic.secondary.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffb784 inset !important;\n  color: #ffae75 !important;\n}\n\n.ui.basic.secondary.buttons .active.button, .ui.basic.secondary.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ffae75 inset !important;\n  color: #ffbd8e !important;\n}\n\n.ui.basic.secondary.buttons .button:active, .ui.basic.secondary.button:active {\n  box-shadow: 0px 0px 0px 1px #ffbd8e inset !important;\n  color: #ffbd8e !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/* Inverted */\n\n.ui.inverted.secondary.buttons .button, .ui.inverted.secondary.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px #545454 inset !important;\n  color: #545454;\n}\n\n.ui.inverted.secondary.buttons .button:hover, .ui.inverted.secondary.button:hover, .ui.inverted.secondary.buttons .button:focus, .ui.inverted.secondary.button:focus, .ui.inverted.secondary.buttons .button.active, .ui.inverted.secondary.button.active, .ui.inverted.secondary.buttons .button:active, .ui.inverted.secondary.button:active {\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.inverted.secondary.buttons .button:hover, .ui.inverted.secondary.button:hover {\n  background-color: #616161;\n}\n\n.ui.inverted.secondary.buttons .button:focus, .ui.inverted.secondary.button:focus {\n  background-color: #686868;\n}\n\n.ui.inverted.secondary.buttons .active.button, .ui.inverted.secondary.active.button {\n  background-color: #616161;\n}\n\n.ui.inverted.secondary.buttons .button:active, .ui.inverted.secondary.button:active {\n  background-color: #6e6e6e;\n}\n\n/* Inverted Basic */\n\n.ui.inverted.secondary.basic.buttons .button, .ui.inverted.secondary.buttons .basic.button, .ui.inverted.secondary.basic.button {\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5) inset !important;\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.secondary.basic.buttons .button:hover, .ui.inverted.secondary.buttons .basic.button:hover, .ui.inverted.secondary.basic.button:hover {\n  box-shadow: 0px 0px 0px 2px #616161 inset !important;\n  color: #545454 !important;\n}\n\n.ui.inverted.secondary.basic.buttons .button:focus, .ui.inverted.secondary.basic.buttons .button:focus, .ui.inverted.secondary.basic.button:focus {\n  box-shadow: 0px 0px 0px 2px #686868 inset !important;\n  color: #545454 !important;\n}\n\n.ui.inverted.secondary.basic.buttons .active.button, .ui.inverted.secondary.buttons .basic.active.button, .ui.inverted.secondary.basic.active.button {\n  box-shadow: 0px 0px 0px 2px #616161 inset !important;\n  color: #545454 !important;\n}\n\n.ui.inverted.secondary.basic.buttons .button:active, .ui.inverted.secondary.buttons .basic.button:active, .ui.inverted.secondary.basic.button:active {\n  box-shadow: 0px 0px 0px 2px #6e6e6e inset !important;\n  color: #545454 !important;\n}\n\n/*---------------\n    Positive\n----------------*/\n\n/* Standard */\n\n.ui.positive.buttons .button, .ui.positive.button {\n  background-color: #59D98D;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.positive.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.positive.buttons .button:hover, .ui.positive.button:hover {\n  background-color: #3ddb7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.positive.buttons .button:focus, .ui.positive.button:focus {\n  background-color: #28e173;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.positive.buttons .button:active, .ui.positive.button:active {\n  background-color: #30d071;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.positive.buttons .active.button, .ui.positive.buttons .active.button:active, .ui.positive.active.button, .ui.positive.button .active.button:active {\n  background-color: #39df7d;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.positive.buttons .button, .ui.basic.positive.button {\n  box-shadow: 0px 0px 0px 1px #59D98D inset !important;\n  color: #59D98D !important;\n}\n\n.ui.basic.positive.buttons .button:hover, .ui.basic.positive.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #3ddb7d inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.positive.buttons .button:focus, .ui.basic.positive.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #28e173 inset !important;\n  color: #3ddb7d !important;\n}\n\n.ui.basic.positive.buttons .active.button, .ui.basic.positive.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #39df7d inset !important;\n  color: #30d071 !important;\n}\n\n.ui.basic.positive.buttons .button:active, .ui.basic.positive.button:active {\n  box-shadow: 0px 0px 0px 1px #30d071 inset !important;\n  color: #30d071 !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/*---------------\n     Negative\n----------------*/\n\n/* Standard */\n\n.ui.negative.buttons .button, .ui.negative.button {\n  background-color: #DB2828;\n  color: #FFFFFF;\n  text-shadow: none;\n  background-image: none;\n}\n\n.ui.negative.button {\n  box-shadow: 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.negative.buttons .button:hover, .ui.negative.button:hover {\n  background-color: #d01919;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.negative.buttons .button:focus, .ui.negative.button:focus {\n  background-color: #ca1010;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.negative.buttons .button:active, .ui.negative.button:active {\n  background-color: #b21e1e;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n.ui.negative.buttons .active.button, .ui.negative.buttons .active.button:active, .ui.negative.active.button, .ui.negative.button .active.button:active {\n  background-color: #d41515;\n  color: #FFFFFF;\n  text-shadow: none;\n}\n\n/* Basic */\n\n.ui.basic.negative.buttons .button, .ui.basic.negative.button {\n  box-shadow: 0px 0px 0px 1px #DB2828 inset !important;\n  color: #DB2828 !important;\n}\n\n.ui.basic.negative.buttons .button:hover, .ui.basic.negative.button:hover {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d01919 inset !important;\n  color: #d01919 !important;\n}\n\n.ui.basic.negative.buttons .button:focus, .ui.basic.negative.button:focus {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #ca1010 inset !important;\n  color: #d01919 !important;\n}\n\n.ui.basic.negative.buttons .active.button, .ui.basic.negative.active.button {\n  background: transparent !important;\n  box-shadow: 0px 0px 0px 1px #d41515 inset !important;\n  color: #b21e1e !important;\n}\n\n.ui.basic.negative.buttons .button:active, .ui.basic.negative.button:active {\n  box-shadow: 0px 0px 0px 1px #b21e1e inset !important;\n  color: #b21e1e !important;\n}\n\n.ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {\n  margin-left: -1px;\n}\n\n/*******************************\n            Groups\n*******************************/\n\n.ui.buttons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  font-size: 0em;\n  vertical-align: baseline;\n  margin: 0em 0.25em 0em 0em;\n}\n\n.ui.buttons:not(.basic):not(.inverted) {\n  box-shadow: none;\n}\n\n/* Clearfix */\n\n.ui.buttons:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\n/* Standard Group */\n\n.ui.buttons .button {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  margin: 0em;\n  border-radius: 0em;\n  margin: 0px 0px 0px 0px;\n}\n\n.ui.buttons > .ui.button:not(.basic):not(.inverted), .ui.buttons:not(.basic):not(.inverted) > .button {\n  box-shadow: 0px 0px 0px 1px transparent inset, 0px 0em 0px 0px #DEDEDF inset;\n}\n\n.ui.buttons .button:first-child {\n  border-left: none;\n  margin-left: 0em;\n  border-top-left-radius: 0.21428571rem;\n  border-bottom-left-radius: 0.21428571rem;\n}\n\n.ui.buttons .button:last-child {\n  border-top-right-radius: 0.21428571rem;\n  border-bottom-right-radius: 0.21428571rem;\n}\n\n/* Vertical  Style */\n\n.ui.vertical.buttons {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.ui.vertical.buttons .button {\n  display: block;\n  float: none;\n  width: 100%;\n  margin: 0px 0px 0px 0px;\n  box-shadow: none;\n  border-radius: 0em;\n}\n\n.ui.vertical.buttons .button:first-child {\n  border-top-left-radius: 0.21428571rem;\n  border-top-right-radius: 0.21428571rem;\n}\n\n.ui.vertical.buttons .button:last-child {\n  margin-bottom: 0px;\n  border-bottom-left-radius: 0.21428571rem;\n  border-bottom-right-radius: 0.21428571rem;\n}\n\n.ui.vertical.buttons .button:only-child {\n  border-radius: 0.21428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Container\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Container\n*******************************/\n\n/* All Sizes */\n\n.ui.container {\n  display: block;\n  max-width: 100% !important;\n}\n\n/* Mobile */\n\n@media only screen and (max-width: 767px) {\n  .ui.container {\n    width: auto !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .ui.grid.container {\n    width: auto !important;\n  }\n\n  .ui.relaxed.grid.container {\n    width: auto !important;\n  }\n\n  .ui.very.relaxed.grid.container {\n    width: auto !important;\n  }\n}\n\n/* Tablet */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.container {\n    width: 723px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  .ui.grid.container {\n    width: calc( 723px  +  2rem ) !important;\n  }\n\n  .ui.relaxed.grid.container {\n    width: calc( 723px  +  3rem ) !important;\n  }\n\n  .ui.very.relaxed.grid.container {\n    width: calc( 723px  +  5rem ) !important;\n  }\n}\n\n/* Small Monitor */\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui.container {\n    width: 933px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  .ui.grid.container {\n    width: calc( 933px  +  2rem ) !important;\n  }\n\n  .ui.relaxed.grid.container {\n    width: calc( 933px  +  3rem ) !important;\n  }\n\n  .ui.very.relaxed.grid.container {\n    width: calc( 933px  +  5rem ) !important;\n  }\n}\n\n/* Large Monitor */\n\n@media only screen and (min-width: 1200px) {\n  .ui.container {\n    width: 1127px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n\n  .ui.grid.container {\n    width: calc( 1127px  +  2rem ) !important;\n  }\n\n  .ui.relaxed.grid.container {\n    width: calc( 1127px  +  3rem ) !important;\n  }\n\n  .ui.very.relaxed.grid.container {\n    width: calc( 1127px  +  5rem ) !important;\n  }\n}\n\n/*******************************\n             Types\n*******************************/\n\n/* Text Container */\n\n.ui.text.container {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  max-width: 700px !important;\n  line-height: 1.5;\n}\n\n.ui.text.container {\n  font-size: 1.14285714rem;\n}\n\n/* Fluid */\n\n.ui.fluid.container {\n  width: 100%;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n.ui[class*=\"left aligned\"].container {\n  text-align: left;\n}\n\n.ui[class*=\"center aligned\"].container {\n  text-align: center;\n}\n\n.ui[class*=\"right aligned\"].container {\n  text-align: right;\n}\n\n.ui.justified.container {\n  text-align: justify;\n  -webkit-hyphens: auto;\n  -ms-hyphens: auto;\n  hyphens: auto;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Divider\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Divider\n*******************************/\n\n.ui.divider {\n  margin: 1rem 0rem;\n  line-height: 1;\n  height: 0em;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: rgba(0, 0, 0, 0.85);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/*--------------\n      Basic\n---------------*/\n\n.ui.divider:not(.vertical):not(.horizontal) {\n  border-top: 1px solid #DEDEDF;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n/* Allow divider between each column row */\n\n.ui.grid > .column + .divider, .ui.grid > .row > .column + .divider {\n  left: auto;\n}\n\n/*--------------\n   Horizontal\n---------------*/\n\n.ui.horizontal.divider {\n  display: table;\n  white-space: nowrap;\n  height: auto;\n  margin: '';\n  line-height: 1;\n  text-align: center;\n}\n\n.ui.horizontal.divider:before, .ui.horizontal.divider:after {\n  content: '';\n  display: table-cell;\n  position: relative;\n  top: 50%;\n  width: 50%;\n  background-repeat: no-repeat;\n}\n\n.ui.horizontal.divider:before {\n  background-position: right 1em top 50%;\n}\n\n.ui.horizontal.divider:after {\n  background-position: left 1em top 50%;\n}\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.divider {\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n  left: 50%;\n  margin: 0rem;\n  padding: 0em;\n  width: auto;\n  height: 50%;\n  line-height: 0em;\n  text-align: center;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.ui.vertical.divider:before, .ui.vertical.divider:after {\n  position: absolute;\n  left: 50%;\n  content: '';\n  z-index: 3;\n  border-left: 1px solid #DEDEDF;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  width: 0%;\n  height: calc(100% -  1rem );\n}\n\n.ui.vertical.divider:before {\n  top: -100%;\n}\n\n.ui.vertical.divider:after {\n  top: auto;\n  bottom: 0px;\n}\n\n/* Inside grid */\n\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid .ui.vertical.divider, .ui.grid .stackable.row .ui.vertical.divider {\n    display: table;\n    white-space: nowrap;\n    height: auto;\n    margin: '';\n    overflow: hidden;\n    line-height: 1;\n    text-align: center;\n    position: static;\n    top: 0;\n    left: 0;\n    -webkit-transform: none;\n    transform: none;\n  }\n\n  .ui.stackable.grid .ui.vertical.divider:before, .ui.grid .stackable.row .ui.vertical.divider:before, .ui.stackable.grid .ui.vertical.divider:after, .ui.grid .stackable.row .ui.vertical.divider:after {\n    position: static;\n    left: 0;\n    border-left: none;\n    border-right: none;\n    content: '';\n    display: table-cell;\n    position: relative;\n    top: 50%;\n    width: 50%;\n    background-repeat: no-repeat;\n  }\n\n  .ui.stackable.grid .ui.vertical.divider:before, .ui.grid .stackable.row .ui.vertical.divider:before {\n    background-position: right 1em top 50%;\n  }\n\n  .ui.stackable.grid .ui.vertical.divider:after, .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-position: left 1em top 50%;\n  }\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.divider > .icon {\n  margin: 0rem;\n  font-size: 1rem;\n  height: 1em;\n  vertical-align: middle;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n    Hidden\n---------------*/\n\n.ui.hidden.divider {\n  border-color: transparent !important;\n}\n\n.ui.hidden.divider:before, .ui.hidden.divider:after {\n  display: none;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.divider.inverted, .ui.vertical.inverted.divider, .ui.horizontal.inverted.divider {\n  color: #FFFFFF;\n}\n\n.ui.divider.inverted, .ui.divider.inverted:after, .ui.divider.inverted:before {\n  border-top-color: #DEDEDF !important;\n  border-left-color: #DEDEDF !important;\n  border-bottom-color: rgba(255, 255, 255, 0.15) !important;\n  border-right-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n/*--------------\n    Fitted\n---------------*/\n\n.ui.fitted.divider {\n  margin: 0em;\n}\n\n/*--------------\n    Clearing\n---------------*/\n\n.ui.clearing.divider {\n  clear: both;\n}\n\n/*--------------\n    Section\n---------------*/\n\n.ui.section.divider {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.divider {\n  font-size: 1rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n.ui.horizontal.divider:before, .ui.horizontal.divider:after {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid .ui.vertical.divider:before, .ui.grid .stackable.row .ui.vertical.divider:before, .ui.stackable.grid .ui.vertical.divider:after, .ui.grid .stackable.row .ui.vertical.divider:after {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n  }\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Flag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Flag\n*******************************/\n\ni.flag:not(.icon) {\n  display: inline-block;\n  width: 16px;\n  height: 11px;\n  line-height: 11px;\n  vertical-align: baseline;\n  margin: 0em 0.5em 0em 0em;\n  text-decoration: inherit;\n  speak: none;\n  font-smoothing: antialiased;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n/* Sprite */\n\ni.flag:not(.icon):before {\n  display: inline-block;\n  content: '';\n  background: url(" + __webpack_require__(3658) + ") no-repeat -108px -1976px;\n  width: 16px;\n  height: 11px;\n}\n\n/* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */\n\n/*******************************\n         Theme Overrides\n*******************************/\n\ni.flag.ad:before, i.flag.andorra:before {\n  background-position: 0px 0px;\n}\n\ni.flag.ae:before, i.flag.united.arab.emirates:before, i.flag.uae:before {\n  background-position: 0px -26px;\n}\n\ni.flag.af:before, i.flag.afghanistan:before {\n  background-position: 0px -52px;\n}\n\ni.flag.ag:before, i.flag.antigua:before {\n  background-position: 0px -78px;\n}\n\ni.flag.ai:before, i.flag.anguilla:before {\n  background-position: 0px -104px;\n}\n\ni.flag.al:before, i.flag.albania:before {\n  background-position: 0px -130px;\n}\n\ni.flag.am:before, i.flag.armenia:before {\n  background-position: 0px -156px;\n}\n\ni.flag.an:before, i.flag.netherlands.antilles:before {\n  background-position: 0px -182px;\n}\n\ni.flag.ao:before, i.flag.angola:before {\n  background-position: 0px -208px;\n}\n\ni.flag.ar:before, i.flag.argentina:before {\n  background-position: 0px -234px;\n}\n\ni.flag.as:before, i.flag.american.samoa:before {\n  background-position: 0px -260px;\n}\n\ni.flag.at:before, i.flag.austria:before {\n  background-position: 0px -286px;\n}\n\ni.flag.au:before, i.flag.australia:before {\n  background-position: 0px -312px;\n}\n\ni.flag.aw:before, i.flag.aruba:before {\n  background-position: 0px -338px;\n}\n\ni.flag.ax:before, i.flag.aland.islands:before {\n  background-position: 0px -364px;\n}\n\ni.flag.az:before, i.flag.azerbaijan:before {\n  background-position: 0px -390px;\n}\n\ni.flag.ba:before, i.flag.bosnia:before {\n  background-position: 0px -416px;\n}\n\ni.flag.bb:before, i.flag.barbados:before {\n  background-position: 0px -442px;\n}\n\ni.flag.bd:before, i.flag.bangladesh:before {\n  background-position: 0px -468px;\n}\n\ni.flag.be:before, i.flag.belgium:before {\n  background-position: 0px -494px;\n}\n\ni.flag.bf:before, i.flag.burkina.faso:before {\n  background-position: 0px -520px;\n}\n\ni.flag.bg:before, i.flag.bulgaria:before {\n  background-position: 0px -546px;\n}\n\ni.flag.bh:before, i.flag.bahrain:before {\n  background-position: 0px -572px;\n}\n\ni.flag.bi:before, i.flag.burundi:before {\n  background-position: 0px -598px;\n}\n\ni.flag.bj:before, i.flag.benin:before {\n  background-position: 0px -624px;\n}\n\ni.flag.bm:before, i.flag.bermuda:before {\n  background-position: 0px -650px;\n}\n\ni.flag.bn:before, i.flag.brunei:before {\n  background-position: 0px -676px;\n}\n\ni.flag.bo:before, i.flag.bolivia:before {\n  background-position: 0px -702px;\n}\n\ni.flag.br:before, i.flag.brazil:before {\n  background-position: 0px -728px;\n}\n\ni.flag.bs:before, i.flag.bahamas:before {\n  background-position: 0px -754px;\n}\n\ni.flag.bt:before, i.flag.bhutan:before {\n  background-position: 0px -780px;\n}\n\ni.flag.bv:before, i.flag.bouvet.island:before {\n  background-position: 0px -806px;\n}\n\ni.flag.bw:before, i.flag.botswana:before {\n  background-position: 0px -832px;\n}\n\ni.flag.by:before, i.flag.belarus:before {\n  background-position: 0px -858px;\n}\n\ni.flag.bz:before, i.flag.belize:before {\n  background-position: 0px -884px;\n}\n\ni.flag.ca:before, i.flag.canada:before {\n  background-position: 0px -910px;\n}\n\ni.flag.cc:before, i.flag.cocos.islands:before {\n  background-position: 0px -962px;\n}\n\ni.flag.cd:before, i.flag.congo:before {\n  background-position: 0px -988px;\n}\n\ni.flag.cf:before, i.flag.central.african.republic:before {\n  background-position: 0px -1014px;\n}\n\ni.flag.cg:before, i.flag.congo.brazzaville:before {\n  background-position: 0px -1040px;\n}\n\ni.flag.ch:before, i.flag.switzerland:before {\n  background-position: 0px -1066px;\n}\n\ni.flag.ci:before, i.flag.cote.divoire:before {\n  background-position: 0px -1092px;\n}\n\ni.flag.ck:before, i.flag.cook.islands:before {\n  background-position: 0px -1118px;\n}\n\ni.flag.cl:before, i.flag.chile:before {\n  background-position: 0px -1144px;\n}\n\ni.flag.cm:before, i.flag.cameroon:before {\n  background-position: 0px -1170px;\n}\n\ni.flag.cn:before, i.flag.china:before {\n  background-position: 0px -1196px;\n}\n\ni.flag.co:before, i.flag.colombia:before {\n  background-position: 0px -1222px;\n}\n\ni.flag.cr:before, i.flag.costa.rica:before {\n  background-position: 0px -1248px;\n}\n\ni.flag.cs:before, i.flag.serbia:before {\n  background-position: 0px -1274px;\n}\n\ni.flag.cu:before, i.flag.cuba:before {\n  background-position: 0px -1300px;\n}\n\ni.flag.cv:before, i.flag.cape.verde:before {\n  background-position: 0px -1326px;\n}\n\ni.flag.cx:before, i.flag.christmas.island:before {\n  background-position: 0px -1352px;\n}\n\ni.flag.cy:before, i.flag.cyprus:before {\n  background-position: 0px -1378px;\n}\n\ni.flag.cz:before, i.flag.czech.republic:before {\n  background-position: 0px -1404px;\n}\n\ni.flag.de:before, i.flag.germany:before {\n  background-position: 0px -1430px;\n}\n\ni.flag.dj:before, i.flag.djibouti:before {\n  background-position: 0px -1456px;\n}\n\ni.flag.dk:before, i.flag.denmark:before {\n  background-position: 0px -1482px;\n}\n\ni.flag.dm:before, i.flag.dominica:before {\n  background-position: 0px -1508px;\n}\n\ni.flag.do:before, i.flag.dominican.republic:before {\n  background-position: 0px -1534px;\n}\n\ni.flag.dz:before, i.flag.algeria:before {\n  background-position: 0px -1560px;\n}\n\ni.flag.ec:before, i.flag.ecuador:before {\n  background-position: 0px -1586px;\n}\n\ni.flag.ee:before, i.flag.estonia:before {\n  background-position: 0px -1612px;\n}\n\ni.flag.eg:before, i.flag.egypt:before {\n  background-position: 0px -1638px;\n}\n\ni.flag.eh:before, i.flag.western.sahara:before {\n  background-position: 0px -1664px;\n}\n\ni.flag.gb.eng:before, i.flag.england:before {\n  background-position: 0px -1690px;\n}\n\ni.flag.er:before, i.flag.eritrea:before {\n  background-position: 0px -1716px;\n}\n\ni.flag.es:before, i.flag.spain:before {\n  background-position: 0px -1742px;\n}\n\ni.flag.et:before, i.flag.ethiopia:before {\n  background-position: 0px -1768px;\n}\n\ni.flag.eu:before, i.flag.european.union:before {\n  background-position: 0px -1794px;\n}\n\ni.flag.fi:before, i.flag.finland:before {\n  background-position: 0px -1846px;\n}\n\ni.flag.fj:before, i.flag.fiji:before {\n  background-position: 0px -1872px;\n}\n\ni.flag.fk:before, i.flag.falkland.islands:before {\n  background-position: 0px -1898px;\n}\n\ni.flag.fm:before, i.flag.micronesia:before {\n  background-position: 0px -1924px;\n}\n\ni.flag.fo:before, i.flag.faroe.islands:before {\n  background-position: 0px -1950px;\n}\n\ni.flag.fr:before, i.flag.france:before {\n  background-position: 0px -1976px;\n}\n\ni.flag.ga:before, i.flag.gabon:before {\n  background-position: -36px 0px;\n}\n\ni.flag.gb:before, i.flag.uk:before, i.flag.united.kingdom:before {\n  background-position: -36px -26px;\n}\n\ni.flag.gd:before, i.flag.grenada:before {\n  background-position: -36px -52px;\n}\n\ni.flag.ge:before, i.flag.georgia:before {\n  background-position: -36px -78px;\n}\n\ni.flag.gf:before, i.flag.french.guiana:before {\n  background-position: -36px -104px;\n}\n\ni.flag.gh:before, i.flag.ghana:before {\n  background-position: -36px -130px;\n}\n\ni.flag.gi:before, i.flag.gibraltar:before {\n  background-position: -36px -156px;\n}\n\ni.flag.gl:before, i.flag.greenland:before {\n  background-position: -36px -182px;\n}\n\ni.flag.gm:before, i.flag.gambia:before {\n  background-position: -36px -208px;\n}\n\ni.flag.gn:before, i.flag.guinea:before {\n  background-position: -36px -234px;\n}\n\ni.flag.gp:before, i.flag.guadeloupe:before {\n  background-position: -36px -260px;\n}\n\ni.flag.gq:before, i.flag.equatorial.guinea:before {\n  background-position: -36px -286px;\n}\n\ni.flag.gr:before, i.flag.greece:before {\n  background-position: -36px -312px;\n}\n\ni.flag.gs:before, i.flag.sandwich.islands:before {\n  background-position: -36px -338px;\n}\n\ni.flag.gt:before, i.flag.guatemala:before {\n  background-position: -36px -364px;\n}\n\ni.flag.gu:before, i.flag.guam:before {\n  background-position: -36px -390px;\n}\n\ni.flag.gw:before, i.flag.guinea-bissau:before {\n  background-position: -36px -416px;\n}\n\ni.flag.gy:before, i.flag.guyana:before {\n  background-position: -36px -442px;\n}\n\ni.flag.hk:before, i.flag.hong.kong:before {\n  background-position: -36px -468px;\n}\n\ni.flag.hm:before, i.flag.heard.island:before {\n  background-position: -36px -494px;\n}\n\ni.flag.hn:before, i.flag.honduras:before {\n  background-position: -36px -520px;\n}\n\ni.flag.hr:before, i.flag.croatia:before {\n  background-position: -36px -546px;\n}\n\ni.flag.ht:before, i.flag.haiti:before {\n  background-position: -36px -572px;\n}\n\ni.flag.hu:before, i.flag.hungary:before {\n  background-position: -36px -598px;\n}\n\ni.flag.id:before, i.flag.indonesia:before {\n  background-position: -36px -624px;\n}\n\ni.flag.ie:before, i.flag.ireland:before {\n  background-position: -36px -650px;\n}\n\ni.flag.il:before, i.flag.israel:before {\n  background-position: -36px -676px;\n}\n\ni.flag.in:before, i.flag.india:before {\n  background-position: -36px -702px;\n}\n\ni.flag.io:before, i.flag.indian.ocean.territory:before {\n  background-position: -36px -728px;\n}\n\ni.flag.iq:before, i.flag.iraq:before {\n  background-position: -36px -754px;\n}\n\ni.flag.ir:before, i.flag.iran:before {\n  background-position: -36px -780px;\n}\n\ni.flag.is:before, i.flag.iceland:before {\n  background-position: -36px -806px;\n}\n\ni.flag.it:before, i.flag.italy:before {\n  background-position: -36px -832px;\n}\n\ni.flag.jm:before, i.flag.jamaica:before {\n  background-position: -36px -858px;\n}\n\ni.flag.jo:before, i.flag.jordan:before {\n  background-position: -36px -884px;\n}\n\ni.flag.jp:before, i.flag.japan:before {\n  background-position: -36px -910px;\n}\n\ni.flag.ke:before, i.flag.kenya:before {\n  background-position: -36px -936px;\n}\n\ni.flag.kg:before, i.flag.kyrgyzstan:before {\n  background-position: -36px -962px;\n}\n\ni.flag.kh:before, i.flag.cambodia:before {\n  background-position: -36px -988px;\n}\n\ni.flag.ki:before, i.flag.kiribati:before {\n  background-position: -36px -1014px;\n}\n\ni.flag.km:before, i.flag.comoros:before {\n  background-position: -36px -1040px;\n}\n\ni.flag.kn:before, i.flag.saint.kitts.and.nevis:before {\n  background-position: -36px -1066px;\n}\n\ni.flag.kp:before, i.flag.north.korea:before {\n  background-position: -36px -1092px;\n}\n\ni.flag.kr:before, i.flag.south.korea:before {\n  background-position: -36px -1118px;\n}\n\ni.flag.kw:before, i.flag.kuwait:before {\n  background-position: -36px -1144px;\n}\n\ni.flag.ky:before, i.flag.cayman.islands:before {\n  background-position: -36px -1170px;\n}\n\ni.flag.kz:before, i.flag.kazakhstan:before {\n  background-position: -36px -1196px;\n}\n\ni.flag.la:before, i.flag.laos:before {\n  background-position: -36px -1222px;\n}\n\ni.flag.lb:before, i.flag.lebanon:before {\n  background-position: -36px -1248px;\n}\n\ni.flag.lc:before, i.flag.saint.lucia:before {\n  background-position: -36px -1274px;\n}\n\ni.flag.li:before, i.flag.liechtenstein:before {\n  background-position: -36px -1300px;\n}\n\ni.flag.lk:before, i.flag.sri.lanka:before {\n  background-position: -36px -1326px;\n}\n\ni.flag.lr:before, i.flag.liberia:before {\n  background-position: -36px -1352px;\n}\n\ni.flag.ls:before, i.flag.lesotho:before {\n  background-position: -36px -1378px;\n}\n\ni.flag.lt:before, i.flag.lithuania:before {\n  background-position: -36px -1404px;\n}\n\ni.flag.lu:before, i.flag.luxembourg:before {\n  background-position: -36px -1430px;\n}\n\ni.flag.lv:before, i.flag.latvia:before {\n  background-position: -36px -1456px;\n}\n\ni.flag.ly:before, i.flag.libya:before {\n  background-position: -36px -1482px;\n}\n\ni.flag.ma:before, i.flag.morocco:before {\n  background-position: -36px -1508px;\n}\n\ni.flag.mc:before, i.flag.monaco:before {\n  background-position: -36px -1534px;\n}\n\ni.flag.md:before, i.flag.moldova:before {\n  background-position: -36px -1560px;\n}\n\ni.flag.me:before, i.flag.montenegro:before {\n  background-position: -36px -1586px;\n}\n\ni.flag.mg:before, i.flag.madagascar:before {\n  background-position: -36px -1613px;\n}\n\ni.flag.mh:before, i.flag.marshall.islands:before {\n  background-position: -36px -1639px;\n}\n\ni.flag.mk:before, i.flag.macedonia:before {\n  background-position: -36px -1665px;\n}\n\ni.flag.ml:before, i.flag.mali:before {\n  background-position: -36px -1691px;\n}\n\ni.flag.mm:before, i.flag.myanmar:before, i.flag.burma:before {\n  background-position: -73px -1821px;\n}\n\ni.flag.mn:before, i.flag.mongolia:before {\n  background-position: -36px -1743px;\n}\n\ni.flag.mo:before, i.flag.macau:before {\n  background-position: -36px -1769px;\n}\n\ni.flag.mp:before, i.flag.northern.mariana.islands:before {\n  background-position: -36px -1795px;\n}\n\ni.flag.mq:before, i.flag.martinique:before {\n  background-position: -36px -1821px;\n}\n\ni.flag.mr:before, i.flag.mauritania:before {\n  background-position: -36px -1847px;\n}\n\ni.flag.ms:before, i.flag.montserrat:before {\n  background-position: -36px -1873px;\n}\n\ni.flag.mt:before, i.flag.malta:before {\n  background-position: -36px -1899px;\n}\n\ni.flag.mu:before, i.flag.mauritius:before {\n  background-position: -36px -1925px;\n}\n\ni.flag.mv:before, i.flag.maldives:before {\n  background-position: -36px -1951px;\n}\n\ni.flag.mw:before, i.flag.malawi:before {\n  background-position: -36px -1977px;\n}\n\ni.flag.mx:before, i.flag.mexico:before {\n  background-position: -72px 0px;\n}\n\ni.flag.my:before, i.flag.malaysia:before {\n  background-position: -72px -26px;\n}\n\ni.flag.mz:before, i.flag.mozambique:before {\n  background-position: -72px -52px;\n}\n\ni.flag.na:before, i.flag.namibia:before {\n  background-position: -72px -78px;\n}\n\ni.flag.nc:before, i.flag.new.caledonia:before {\n  background-position: -72px -104px;\n}\n\ni.flag.ne:before, i.flag.niger:before {\n  background-position: -72px -130px;\n}\n\ni.flag.nf:before, i.flag.norfolk.island:before {\n  background-position: -72px -156px;\n}\n\ni.flag.ng:before, i.flag.nigeria:before {\n  background-position: -72px -182px;\n}\n\ni.flag.ni:before, i.flag.nicaragua:before {\n  background-position: -72px -208px;\n}\n\ni.flag.nl:before, i.flag.netherlands:before {\n  background-position: -72px -234px;\n}\n\ni.flag.no:before, i.flag.norway:before {\n  background-position: -72px -260px;\n}\n\ni.flag.np:before, i.flag.nepal:before {\n  background-position: -72px -286px;\n}\n\ni.flag.nr:before, i.flag.nauru:before {\n  background-position: -72px -312px;\n}\n\ni.flag.nu:before, i.flag.niue:before {\n  background-position: -72px -338px;\n}\n\ni.flag.nz:before, i.flag.new.zealand:before {\n  background-position: -72px -364px;\n}\n\ni.flag.om:before, i.flag.oman:before {\n  background-position: -72px -390px;\n}\n\ni.flag.pa:before, i.flag.panama:before {\n  background-position: -72px -416px;\n}\n\ni.flag.pe:before, i.flag.peru:before {\n  background-position: -72px -442px;\n}\n\ni.flag.pf:before, i.flag.french.polynesia:before {\n  background-position: -72px -468px;\n}\n\ni.flag.pg:before, i.flag.new.guinea:before {\n  background-position: -72px -494px;\n}\n\ni.flag.ph:before, i.flag.philippines:before {\n  background-position: -72px -520px;\n}\n\ni.flag.pk:before, i.flag.pakistan:before {\n  background-position: -72px -546px;\n}\n\ni.flag.pl:before, i.flag.poland:before {\n  background-position: -72px -572px;\n}\n\ni.flag.pm:before, i.flag.saint.pierre:before {\n  background-position: -72px -598px;\n}\n\ni.flag.pn:before, i.flag.pitcairn.islands:before {\n  background-position: -72px -624px;\n}\n\ni.flag.pr:before, i.flag.puerto.rico:before {\n  background-position: -72px -650px;\n}\n\ni.flag.ps:before, i.flag.palestine:before {\n  background-position: -72px -676px;\n}\n\ni.flag.pt:before, i.flag.portugal:before {\n  background-position: -72px -702px;\n}\n\ni.flag.pw:before, i.flag.palau:before {\n  background-position: -72px -728px;\n}\n\ni.flag.py:before, i.flag.paraguay:before {\n  background-position: -72px -754px;\n}\n\ni.flag.qa:before, i.flag.qatar:before {\n  background-position: -72px -780px;\n}\n\ni.flag.re:before, i.flag.reunion:before {\n  background-position: -72px -806px;\n}\n\ni.flag.ro:before, i.flag.romania:before {\n  background-position: -72px -832px;\n}\n\ni.flag.rs:before, i.flag.serbia:before {\n  background-position: -72px -858px;\n}\n\ni.flag.ru:before, i.flag.russia:before {\n  background-position: -72px -884px;\n}\n\ni.flag.rw:before, i.flag.rwanda:before {\n  background-position: -72px -910px;\n}\n\ni.flag.sa:before, i.flag.saudi.arabia:before {\n  background-position: -72px -936px;\n}\n\ni.flag.sb:before, i.flag.solomon.islands:before {\n  background-position: -72px -962px;\n}\n\ni.flag.sc:before, i.flag.seychelles:before {\n  background-position: -72px -988px;\n}\n\ni.flag.gb.sct:before, i.flag.scotland:before {\n  background-position: -72px -1014px;\n}\n\ni.flag.sd:before, i.flag.sudan:before {\n  background-position: -72px -1040px;\n}\n\ni.flag.se:before, i.flag.sweden:before {\n  background-position: -72px -1066px;\n}\n\ni.flag.sg:before, i.flag.singapore:before {\n  background-position: -72px -1092px;\n}\n\ni.flag.sh:before, i.flag.saint.helena:before {\n  background-position: -72px -1118px;\n}\n\ni.flag.si:before, i.flag.slovenia:before {\n  background-position: -72px -1144px;\n}\n\ni.flag.sj:before, i.flag.svalbard:before, i.flag.jan.mayen:before {\n  background-position: -72px -1170px;\n}\n\ni.flag.sk:before, i.flag.slovakia:before {\n  background-position: -72px -1196px;\n}\n\ni.flag.sl:before, i.flag.sierra.leone:before {\n  background-position: -72px -1222px;\n}\n\ni.flag.sm:before, i.flag.san.marino:before {\n  background-position: -72px -1248px;\n}\n\ni.flag.sn:before, i.flag.senegal:before {\n  background-position: -72px -1274px;\n}\n\ni.flag.so:before, i.flag.somalia:before {\n  background-position: -72px -1300px;\n}\n\ni.flag.sr:before, i.flag.suriname:before {\n  background-position: -72px -1326px;\n}\n\ni.flag.st:before, i.flag.sao.tome:before {\n  background-position: -72px -1352px;\n}\n\ni.flag.sv:before, i.flag.el.salvador:before {\n  background-position: -72px -1378px;\n}\n\ni.flag.sy:before, i.flag.syria:before {\n  background-position: -72px -1404px;\n}\n\ni.flag.sz:before, i.flag.swaziland:before {\n  background-position: -72px -1430px;\n}\n\ni.flag.tc:before, i.flag.caicos.islands:before {\n  background-position: -72px -1456px;\n}\n\ni.flag.td:before, i.flag.chad:before {\n  background-position: -72px -1482px;\n}\n\ni.flag.tf:before, i.flag.french.territories:before {\n  background-position: -72px -1508px;\n}\n\ni.flag.tg:before, i.flag.togo:before {\n  background-position: -72px -1534px;\n}\n\ni.flag.th:before, i.flag.thailand:before {\n  background-position: -72px -1560px;\n}\n\ni.flag.tj:before, i.flag.tajikistan:before {\n  background-position: -72px -1586px;\n}\n\ni.flag.tk:before, i.flag.tokelau:before {\n  background-position: -72px -1612px;\n}\n\ni.flag.tl:before, i.flag.timorleste:before {\n  background-position: -72px -1638px;\n}\n\ni.flag.tm:before, i.flag.turkmenistan:before {\n  background-position: -72px -1664px;\n}\n\ni.flag.tn:before, i.flag.tunisia:before {\n  background-position: -72px -1690px;\n}\n\ni.flag.to:before, i.flag.tonga:before {\n  background-position: -72px -1716px;\n}\n\ni.flag.tr:before, i.flag.turkey:before {\n  background-position: -72px -1742px;\n}\n\ni.flag.tt:before, i.flag.trinidad:before {\n  background-position: -72px -1768px;\n}\n\ni.flag.tv:before, i.flag.tuvalu:before {\n  background-position: -72px -1794px;\n}\n\ni.flag.tw:before, i.flag.taiwan:before {\n  background-position: -72px -1820px;\n}\n\ni.flag.tz:before, i.flag.tanzania:before {\n  background-position: -72px -1846px;\n}\n\ni.flag.ua:before, i.flag.ukraine:before {\n  background-position: -72px -1872px;\n}\n\ni.flag.ug:before, i.flag.uganda:before {\n  background-position: -72px -1898px;\n}\n\ni.flag.um:before, i.flag.us.minor.islands:before {\n  background-position: -72px -1924px;\n}\n\ni.flag.us:before, i.flag.america:before, i.flag.united.states:before {\n  background-position: -72px -1950px;\n}\n\ni.flag.uy:before, i.flag.uruguay:before {\n  background-position: -72px -1976px;\n}\n\ni.flag.uz:before, i.flag.uzbekistan:before {\n  background-position: -108px 0px;\n}\n\ni.flag.va:before, i.flag.vatican.city:before {\n  background-position: -108px -26px;\n}\n\ni.flag.vc:before, i.flag.saint.vincent:before {\n  background-position: -108px -52px;\n}\n\ni.flag.ve:before, i.flag.venezuela:before {\n  background-position: -108px -78px;\n}\n\ni.flag.vg:before, i.flag.british.virgin.islands:before {\n  background-position: -108px -104px;\n}\n\ni.flag.vi:before, i.flag.us.virgin.islands:before {\n  background-position: -108px -130px;\n}\n\ni.flag.vn:before, i.flag.vietnam:before {\n  background-position: -108px -156px;\n}\n\ni.flag.vu:before, i.flag.vanuatu:before {\n  background-position: -108px -182px;\n}\n\ni.flag.gb.wls:before, i.flag.wales:before {\n  background-position: -108px -208px;\n}\n\ni.flag.wf:before, i.flag.wallis.and.futuna:before {\n  background-position: -108px -234px;\n}\n\ni.flag.ws:before, i.flag.samoa:before {\n  background-position: -108px -260px;\n}\n\ni.flag.ye:before, i.flag.yemen:before {\n  background-position: -108px -286px;\n}\n\ni.flag.yt:before, i.flag.mayotte:before {\n  background-position: -108px -312px;\n}\n\ni.flag.za:before, i.flag.south.africa:before {\n  background-position: -108px -338px;\n}\n\ni.flag.zm:before, i.flag.zambia:before {\n  background-position: -108px -364px;\n}\n\ni.flag.zw:before, i.flag.zimbabwe:before {\n  background-position: -108px -390px;\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Header\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Header\n*******************************/\n\n/* Standard */\n\n.ui.header {\n  border: none;\n  margin: calc(2rem -  0.14285714em ) 0em 1rem;\n  padding: 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  line-height: 1.28571429em;\n  text-transform: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.header:first-child {\n  margin-top: -0.14285714em;\n}\n\n.ui.header:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n   Sub Header\n---------------*/\n\n.ui.header .sub.header {\n  display: block;\n  font-weight: normal;\n  padding: 0em;\n  margin: 0em;\n  font-size: 1rem;\n  line-height: 1.2em;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.header > .icon {\n  display: table-cell;\n  opacity: 1;\n  font-size: 1.5em;\n  padding-top: 0em;\n  vertical-align: middle;\n}\n\n/* With Text Node */\n\n.ui.header .icon:only-child {\n  display: inline-block;\n  padding: 0em;\n  margin-right: 0.75rem;\n}\n\n/*-------------------\n        Image\n--------------------*/\n\n.ui.header > .image:not(.icon), .ui.header > img {\n  display: inline-block;\n  margin-top: 0.14285714em;\n  width: 2.5em;\n  height: auto;\n  vertical-align: middle;\n}\n\n.ui.header > .image:not(.icon):only-child, .ui.header > img:only-child {\n  margin-right: 0.75rem;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.header .content {\n  display: inline-block;\n  vertical-align: top;\n}\n\n/* After Image */\n\n.ui.header > img + .content, .ui.header > .image + .content {\n  padding-left: 0.75rem;\n  vertical-align: middle;\n}\n\n/* After Icon */\n\n.ui.header > .icon + .content {\n  padding-left: 0.75rem;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n/*--------------\n Loose Coupling\n---------------*/\n\n.ui.header .ui.label {\n  font-size: '';\n  margin-left: 0.5rem;\n  vertical-align: middle;\n}\n\n/* Positioning */\n\n.ui.header + p {\n  margin-top: 0em;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n     Page\n---------------*/\n\nh1.ui.header {\n  font-size: 2rem;\n}\n\nh2.ui.header {\n  font-size: 1.71428571rem;\n}\n\nh3.ui.header {\n  font-size: 1.28571429rem;\n}\n\nh4.ui.header {\n  font-size: 1.07142857rem;\n}\n\nh5.ui.header {\n  font-size: 1rem;\n}\n\n/* Sub Header */\n\nh1.ui.header .sub.header {\n  font-size: 1.14285714rem;\n}\n\nh2.ui.header .sub.header {\n  font-size: 1.14285714rem;\n}\n\nh3.ui.header .sub.header {\n  font-size: 1rem;\n}\n\nh4.ui.header .sub.header {\n  font-size: 1rem;\n}\n\nh5.ui.header .sub.header {\n  font-size: 0.92857143rem;\n}\n\n/*--------------\n Content Heading\n---------------*/\n\n.ui.huge.header {\n  min-height: 1em;\n  font-size: 2em;\n}\n\n.ui.large.header {\n  font-size: 1.71428571em;\n}\n\n.ui.medium.header {\n  font-size: 1.28571429em;\n}\n\n.ui.small.header {\n  font-size: 1.07142857em;\n}\n\n.ui.tiny.header {\n  font-size: 1em;\n}\n\n/* Sub Header */\n\n.ui.huge.header .sub.header {\n  font-size: 1.14285714rem;\n}\n\n.ui.large.header .sub.header {\n  font-size: 1.14285714rem;\n}\n\n.ui.header .sub.header {\n  font-size: 1rem;\n}\n\n.ui.small.header .sub.header {\n  font-size: 1rem;\n}\n\n.ui.tiny.header .sub.header {\n  font-size: 0.92857143rem;\n}\n\n/*--------------\n   Sub Heading\n---------------*/\n\n.ui.sub.header {\n  padding: 0em;\n  margin-bottom: 0.14285714rem;\n  font-weight: bold;\n  font-size: 0.85714286em;\n  text-transform: uppercase;\n  color: '';\n}\n\n.ui.small.sub.header {\n  font-size: 0.78571429em;\n}\n\n.ui.sub.header {\n  font-size: 0.85714286em;\n}\n\n.ui.large.sub.header {\n  font-size: 0.92857143em;\n}\n\n.ui.huge.sub.header {\n  font-size: 1em;\n}\n\n/*-------------------\n        Icon\n--------------------*/\n\n.ui.icon.header {\n  display: inline-block;\n  text-align: center;\n  margin: 2rem 0em 1rem;\n}\n\n.ui.icon.header:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n\n.ui.icon.header:first-child {\n  margin-top: 0em;\n}\n\n.ui.icon.header .icon {\n  float: none;\n  display: block;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 0em;\n  font-size: 3em;\n  margin: 0em auto 0.5rem;\n  opacity: 1;\n}\n\n.ui.icon.header .content {\n  display: block;\n  padding: 0em;\n}\n\n.ui.icon.header .circular.icon {\n  font-size: 2em;\n}\n\n.ui.icon.header .square.icon {\n  font-size: 2em;\n}\n\n.ui.block.icon.header .icon {\n  margin-bottom: 0em;\n}\n\n.ui.icon.header.aligned {\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.disabled.header {\n  opacity: 0.45;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n      Inverted\n--------------------*/\n\n.ui.inverted.header {\n  color: #FFFFFF;\n}\n\n.ui.inverted.header .sub.header {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.ui.inverted.attached.header {\n  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  box-shadow: none;\n  border-color: transparent;\n}\n\n.ui.inverted.block.header {\n  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  box-shadow: none;\n}\n\n.ui.inverted.block.header {\n  border-bottom: none;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Red ---*/\n\n.ui.red.header {\n  color: #DB2828 !important;\n}\n\na.ui.red.header:hover {\n  color: #d01919 !important;\n}\n\n.ui.red.dividing.header {\n  border-bottom: 2px solid #DB2828;\n}\n\n/* Inverted */\n\n.ui.inverted.red.header {\n  color: #FF695E !important;\n}\n\na.ui.inverted.red.header:hover {\n  color: #ff5144 !important;\n}\n\n/*--- Orange ---*/\n\n.ui.orange.header {\n  color: #FF9F5B !important;\n}\n\na.ui.orange.header:hover {\n  color: #ff9042 !important;\n}\n\n.ui.orange.dividing.header {\n  border-bottom: 2px solid #FF9F5B;\n}\n\n/* Inverted */\n\n.ui.inverted.orange.header {\n  color: #FF851B !important;\n}\n\na.ui.inverted.orange.header:hover {\n  color: #ff7701 !important;\n}\n\n/*--- Olive ---*/\n\n.ui.olive.header {\n  color: #B5CC18 !important;\n}\n\na.ui.olive.header:hover {\n  color: #a7bd0d !important;\n}\n\n.ui.olive.dividing.header {\n  border-bottom: 2px solid #B5CC18;\n}\n\n/* Inverted */\n\n.ui.inverted.olive.header {\n  color: #D9E778 !important;\n}\n\na.ui.inverted.olive.header:hover {\n  color: #d8ea5c !important;\n}\n\n/*--- Yellow ---*/\n\n.ui.yellow.header {\n  color: #F9DC5C !important;\n}\n\na.ui.yellow.header:hover {\n  color: #ffdb3c !important;\n}\n\n.ui.yellow.dividing.header {\n  border-bottom: 2px solid #F9DC5C;\n}\n\n/* Inverted */\n\n.ui.inverted.yellow.header {\n  color: #FFE21F !important;\n}\n\na.ui.inverted.yellow.header:hover {\n  color: #ffdf05 !important;\n}\n\n/*--- Green ---*/\n\n.ui.green.header {\n  color: #59D98D !important;\n}\n\na.ui.green.header:hover {\n  color: #3ddb7d !important;\n}\n\n.ui.green.dividing.header {\n  border-bottom: 2px solid #59D98D;\n}\n\n/* Inverted */\n\n.ui.inverted.green.header {\n  color: #2ECC40 !important;\n}\n\na.ui.inverted.green.header:hover {\n  color: #22be34 !important;\n}\n\n/*--- Teal ---*/\n\n.ui.teal.header {\n  color: #00B5AD !important;\n}\n\na.ui.teal.header:hover {\n  color: #009c95 !important;\n}\n\n.ui.teal.dividing.header {\n  border-bottom: 2px solid #00B5AD;\n}\n\n/* Inverted */\n\n.ui.inverted.teal.header {\n  color: #6DFFFF !important;\n}\n\na.ui.inverted.teal.header:hover {\n  color: #54ffff !important;\n}\n\n/*--- Blue ---*/\n\n.ui.blue.header {\n  color: #2185D0 !important;\n}\n\na.ui.blue.header:hover {\n  color: #1678c2 !important;\n}\n\n.ui.blue.dividing.header {\n  border-bottom: 2px solid #2185D0;\n}\n\n/* Inverted */\n\n.ui.inverted.blue.header {\n  color: #54C8FF !important;\n}\n\na.ui.inverted.blue.header:hover {\n  color: #3ac0ff !important;\n}\n\n/*--- Violet ---*/\n\n.ui.violet.header {\n  color: #6435C9 !important;\n}\n\na.ui.violet.header:hover {\n  color: #5829bb !important;\n}\n\n.ui.violet.dividing.header {\n  border-bottom: 2px solid #6435C9;\n}\n\n/* Inverted */\n\n.ui.inverted.violet.header {\n  color: #A291FB !important;\n}\n\na.ui.inverted.violet.header:hover {\n  color: #8a73ff !important;\n}\n\n/*--- Purple ---*/\n\n.ui.purple.header {\n  color: #A333C8 !important;\n}\n\na.ui.purple.header:hover {\n  color: #9627ba !important;\n}\n\n.ui.purple.dividing.header {\n  border-bottom: 2px solid #A333C8;\n}\n\n/* Inverted */\n\n.ui.inverted.purple.header {\n  color: #DC73FF !important;\n}\n\na.ui.inverted.purple.header:hover {\n  color: #d65aff !important;\n}\n\n/*--- Pink ---*/\n\n.ui.pink.header {\n  color: #E03997 !important;\n}\n\na.ui.pink.header:hover {\n  color: #e61a8d !important;\n}\n\n.ui.pink.dividing.header {\n  border-bottom: 2px solid #E03997;\n}\n\n/* Inverted */\n\n.ui.inverted.pink.header {\n  color: #FF8EDF !important;\n}\n\na.ui.inverted.pink.header:hover {\n  color: #ff74d8 !important;\n}\n\n/*--- Brown ---*/\n\n.ui.brown.header {\n  color: #A5673F !important;\n}\n\na.ui.brown.header:hover {\n  color: #975b33 !important;\n}\n\n.ui.brown.dividing.header {\n  border-bottom: 2px solid #A5673F;\n}\n\n/* Inverted */\n\n.ui.inverted.brown.header {\n  color: #D67C1C !important;\n}\n\na.ui.inverted.brown.header:hover {\n  color: #c86f11 !important;\n}\n\n/*--- Grey ---*/\n\n.ui.grey.header {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\na.ui.grey.header:hover {\n  color: rgba(13, 13, 13, 0.4) !important;\n}\n\n.ui.grey.dividing.header {\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n}\n\n/* Inverted */\n\n.ui.inverted.grey.header {\n  color: #DEDEDF !important;\n}\n\na.ui.inverted.grey.header:hover {\n  color: #d1d1d3 !important;\n}\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.left.aligned.header {\n  text-align: left;\n}\n\n.ui.right.aligned.header {\n  text-align: right;\n}\n\n.ui.centered.header, .ui.center.aligned.header {\n  text-align: center;\n}\n\n.ui.justified.header {\n  text-align: justify;\n}\n\n.ui.justified.header:after {\n  display: inline-block;\n  content: '';\n  width: 100%;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.header, .ui[class*=\"left floated\"].header {\n  float: left;\n  margin-top: 0em;\n  margin-right: 0.5em;\n}\n\n.ui[class*=\"right floated\"].header {\n  float: right;\n  margin-top: 0em;\n  margin-left: 0.5em;\n}\n\n/*-------------------\n       Fitted\n--------------------*/\n\n.ui.fitted.header {\n  padding: 0em;\n}\n\n/*-------------------\n      Dividing\n--------------------*/\n\n.ui.dividing.header {\n  padding-bottom: 0.21428571rem;\n  border-bottom: 1px solid #DEDEDF;\n}\n\n.ui.dividing.header .sub.header {\n  padding-bottom: 0.21428571rem;\n}\n\n.ui.dividing.header .icon {\n  margin-bottom: 0em;\n}\n\n.ui.inverted.dividing.header {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\n/*-------------------\n        Block\n--------------------*/\n\n.ui.block.header {\n  background: #F3F4F5;\n  padding: 0.78571429rem 1rem;\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n  border-radius: 0.21428571rem;\n}\n\n.ui.tiny.block.header {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.block.header {\n  font-size: 0.92857143rem;\n}\n\n.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1rem;\n}\n\n.ui.large.block.header {\n  font-size: 1.14285714rem;\n}\n\n.ui.huge.block.header {\n  font-size: 1.42857143rem;\n}\n\n/*-------------------\n       Attached\n--------------------*/\n\n.ui.attached.header {\n  background: #FFFFFF;\n  padding: 0.78571429rem 1rem;\n  margin-left: -1px;\n  margin-right: -1px;\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n}\n\n.ui.attached.block.header {\n  background: #F3F4F5;\n}\n\n.ui.attached:not(.top):not(.bottom).header {\n  margin-top: 0em;\n  margin-bottom: 0em;\n  border-top: none;\n  border-radius: 0em;\n}\n\n.ui.top.attached.header {\n  margin-bottom: 0em;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.bottom.attached.header {\n  margin-top: 0em;\n  border-top: none;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n/* Attached Sizes */\n\n.ui.tiny.attached.header {\n  font-size: 0.85714286em;\n}\n\n.ui.small.attached.header {\n  font-size: 0.92857143em;\n}\n\n.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1em;\n}\n\n.ui.large.attached.header {\n  font-size: 1.14285714em;\n}\n\n.ui.huge.attached.header {\n  font-size: 1.42857143em;\n}\n\n/*-------------------\n        Sizing\n--------------------*/\n\n.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n  font-size: 1.28571429em;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n\nh1, h2, h3, h4, h5, h6 {\n  color: rgba(0, 0, 0, 0.65);\n}\n/*!\n * # Semantic UI 2.4.2 - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Icon\n*******************************/\n\n@font-face {\n  font-family: 'Icons';\n  src: url(" + __webpack_require__(1510) + ");\n  src: url(" + __webpack_require__(1510) + "?#iefix) format('embedded-opentype'), url(" + __webpack_require__(3653) + ") format('woff2'), url(" + __webpack_require__(3652) + ") format('woff'), url(" + __webpack_require__(3651) + ") format('truetype'), url(" + __webpack_require__(3650) + "#icons) format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\n\ni.icon {\n  display: inline-block;\n  opacity: 1;\n  margin: 0em 0.25rem 0em 0em;\n  width: 1.18em;\n  height: 1em;\n  font-family: 'Icons';\n  font-style: normal;\n  font-weight: normal;\n  text-decoration: inherit;\n  text-align: center;\n  speak: none;\n  font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\ni.icon:before {\n  background: none !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n    Loading\n---------------*/\n\ni.icon.loading {\n  height: 1em;\n  line-height: 1;\n  -webkit-animation: icon-loading 2s linear infinite;\n  animation: icon-loading 2s linear infinite;\n}\n\n@-webkit-keyframes icon-loading {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes icon-loading {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*******************************\n             States\n*******************************/\n\ni.icon.hover {\n  opacity: 1 !important;\n}\n\ni.icon.active {\n  opacity: 1 !important;\n}\n\ni.emphasized.icon {\n  opacity: 1 !important;\n}\n\ni.disabled.icon {\n  opacity: 0.45 !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n        Fitted\n--------------------*/\n\ni.fitted.icon {\n  width: auto;\n  margin: 0em !important;\n}\n\n/*-------------------\n         Link\n--------------------*/\n\ni.link.icon, i.link.icons {\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n\ni.link.icon:hover, i.link.icons:hover {\n  opacity: 1 !important;\n}\n\n/*-------------------\n      Circular\n--------------------*/\n\ni.circular.icon {\n  border-radius: 500em !important;\n  line-height: 1 !important;\n  padding: 0.5em 0em !important;\n  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;\n  width: 2em !important;\n  height: 2em !important;\n}\n\ni.circular.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n\n/*-------------------\n      Flipped\n--------------------*/\n\ni.flipped.icon, i.horizontally.flipped.icon {\n  -webkit-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\ni.vertically.flipped.icon {\n  -webkit-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/*-------------------\n      Rotated\n--------------------*/\n\ni.rotated.icon, i.right.rotated.icon, i.clockwise.rotated.icon {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\ni.left.rotated.icon, i.counterclockwise.rotated.icon {\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n/*-------------------\n      Bordered\n--------------------*/\n\ni.bordered.icon {\n  line-height: 1;\n  vertical-align: baseline;\n  width: 2em;\n  height: 2em;\n  padding: 0.5em 0em !important;\n  box-shadow: 0em 0em 0em 0.1em rgba(0, 0, 0, 0.1) inset;\n}\n\ni.bordered.inverted.icon {\n  border: none;\n  box-shadow: none;\n}\n\n/*-------------------\n      Inverted\n--------------------*/\n\n/* Inverted Shapes */\n\ni.inverted.bordered.icon, i.inverted.circular.icon {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n\ni.inverted.icon {\n  color: #FFFFFF;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n\ni.red.icon {\n  color: #DB2828 !important;\n}\n\ni.inverted.red.icon {\n  color: #FF695E !important;\n}\n\ni.inverted.bordered.red.icon, i.inverted.circular.red.icon {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n\n/* Orange */\n\ni.orange.icon {\n  color: #FF9F5B !important;\n}\n\ni.inverted.orange.icon {\n  color: #FF851B !important;\n}\n\ni.inverted.bordered.orange.icon, i.inverted.circular.orange.icon {\n  background-color: #FF9F5B !important;\n  color: #FFFFFF !important;\n}\n\n/* Yellow */\n\ni.yellow.icon {\n  color: #F9DC5C !important;\n}\n\ni.inverted.yellow.icon {\n  color: #FFE21F !important;\n}\n\ni.inverted.bordered.yellow.icon, i.inverted.circular.yellow.icon {\n  background-color: #F9DC5C !important;\n  color: #FFFFFF !important;\n}\n\n/* Olive */\n\ni.olive.icon {\n  color: #B5CC18 !important;\n}\n\ni.inverted.olive.icon {\n  color: #D9E778 !important;\n}\n\ni.inverted.bordered.olive.icon, i.inverted.circular.olive.icon {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n\n/* Green */\n\ni.green.icon {\n  color: #59D98D !important;\n}\n\ni.inverted.green.icon {\n  color: #2ECC40 !important;\n}\n\ni.inverted.bordered.green.icon, i.inverted.circular.green.icon {\n  background-color: #59D98D !important;\n  color: #FFFFFF !important;\n}\n\n/* Teal */\n\ni.teal.icon {\n  color: #00B5AD !important;\n}\n\ni.inverted.teal.icon {\n  color: #6DFFFF !important;\n}\n\ni.inverted.bordered.teal.icon, i.inverted.circular.teal.icon {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n\n/* Blue */\n\ni.blue.icon {\n  color: #2185D0 !important;\n}\n\ni.inverted.blue.icon {\n  color: #54C8FF !important;\n}\n\ni.inverted.bordered.blue.icon, i.inverted.circular.blue.icon {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n\n/* Violet */\n\ni.violet.icon {\n  color: #6435C9 !important;\n}\n\ni.inverted.violet.icon {\n  color: #A291FB !important;\n}\n\ni.inverted.bordered.violet.icon, i.inverted.circular.violet.icon {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n\n/* Purple */\n\ni.purple.icon {\n  color: #A333C8 !important;\n}\n\ni.inverted.purple.icon {\n  color: #DC73FF !important;\n}\n\ni.inverted.bordered.purple.icon, i.inverted.circular.purple.icon {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n\n/* Pink */\n\ni.pink.icon {\n  color: #E03997 !important;\n}\n\ni.inverted.pink.icon {\n  color: #FF8EDF !important;\n}\n\ni.inverted.bordered.pink.icon, i.inverted.circular.pink.icon {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n\n/* Brown */\n\ni.brown.icon {\n  color: #A5673F !important;\n}\n\ni.inverted.brown.icon {\n  color: #D67C1C !important;\n}\n\ni.inverted.bordered.brown.icon, i.inverted.circular.brown.icon {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n\n/* Grey */\n\ni.grey.icon {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\ni.inverted.grey.icon {\n  color: #DEDEDF !important;\n}\n\ni.inverted.bordered.grey.icon, i.inverted.circular.grey.icon {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n  color: #FFFFFF !important;\n}\n\n/* Black */\n\ni.black.icon {\n  color: #1B1C1D !important;\n}\n\ni.inverted.black.icon {\n  color: #545454 !important;\n}\n\ni.inverted.bordered.black.icon, i.inverted.circular.black.icon {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\ni.mini.icon, i.mini.icons {\n  line-height: 1;\n  font-size: 0.4em;\n}\n\ni.tiny.icon, i.tiny.icons {\n  line-height: 1;\n  font-size: 0.5em;\n}\n\ni.small.icon, i.small.icons {\n  line-height: 1;\n  font-size: 0.75em;\n}\n\ni.icon, i.icons {\n  font-size: 1em;\n}\n\ni.large.icon, i.large.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 1.5em;\n}\n\ni.big.icon, i.big.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 2em;\n}\n\ni.huge.icon, i.huge.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 4em;\n}\n\ni.massive.icon, i.massive.icons {\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 8em;\n}\n\n/*******************************\n            Groups\n*******************************/\n\ni.icons {\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n}\n\ni.icons .icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  margin: 0em;\n  margin: 0;\n}\n\ni.icons .icon:first-child {\n  position: static;\n  width: auto;\n  height: auto;\n  vertical-align: top;\n  -webkit-transform: none;\n  transform: none;\n  margin-right: 0.25rem;\n}\n\n/* Corner Icon */\n\ni.icons .corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  -webkit-transform: none;\n  transform: none;\n  font-size: 0.45em;\n  text-shadow: -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF;\n}\n\ni.icons .top.right.corner.icon {\n  top: 0;\n  left: auto;\n  right: 0;\n  bottom: auto;\n}\n\ni.icons .top.left.corner.icon {\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: auto;\n}\n\ni.icons .bottom.left.corner.icon {\n  top: auto;\n  left: 0;\n  right: auto;\n  bottom: 0;\n}\n\ni.icons .bottom.right.corner.icon {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 0;\n}\n\ni.icons .inverted.corner.icon {\n  text-shadow: -1px -1px 0 #1B1C1D, 1px -1px 0 #1B1C1D, -1px 1px 0 #1B1C1D, 1px 1px 0 #1B1C1D;\n}\n\n/*\n * Font Awesome 5.0.8 by @fontawesome - http://fontawesome.io - @fontawesome\n * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)\n */\n\n/*******************************\n\nSemantic-UI integration of font-awesome :\n\n///class names are separated\ni.icon.circle => i.icon.circle\ni.icon.circle-o => i.icon.circle.outline\n\n//abbreviation are replaced by full letters:\ni.icon.ellipsis-h => i.icon.ellipsis.horizontal\ni.icon.ellipsis-v => i.icon.ellipsis.vertical\n.alpha => .i.icon.alphabet\n.asc => .i.icon.ascending\n.desc => .i.icon.descending\n.alt =>.alternate\n\nASCII order is conserved for easier maintenance.\n\nIcons that only have one style 'outline', 'square' etc do not require this class\nfor instance `lemon icon` not `lemon outline icon` since there is only one lemon\n\n*******************************/\n\n/*******************************\n            Icons\n*******************************/\n\n/* Deprecated *In/Out Naming Conflict) */\n\ni.icon.linkedin.in:before {\n  content: \"\\F0E1\";\n}\n\ni.icon.zoom.in:before {\n  content: \"\\F00E\";\n}\n\ni.icon.zoom.out:before {\n  content: \"\\F010\";\n}\n\ni.icon.sign.in:before {\n  content: \"\\F2F6\";\n}\n\ni.icon.in.cart:before {\n  content: \"\\F218\";\n}\n\ni.icon.log.out:before {\n  content: \"\\F2F5\";\n}\n\ni.icon.sign.out:before {\n  content: \"\\F2F5\";\n}\n\n/* Icons */\n\ni.icon.\\35 00px:before {\n  content: \"\\F26E\";\n}\n\ni.icon.accessible.icon:before {\n  content: \"\\F368\";\n}\n\ni.icon.accusoft:before {\n  content: \"\\F369\";\n}\n\ni.icon.address.book:before {\n  content: \"\\F2B9\";\n}\n\ni.icon.address.card:before {\n  content: \"\\F2BB\";\n}\n\ni.icon.adjust:before {\n  content: \"\\F042\";\n}\n\ni.icon.adn:before {\n  content: \"\\F170\";\n}\n\ni.icon.adversal:before {\n  content: \"\\F36A\";\n}\n\ni.icon.affiliatetheme:before {\n  content: \"\\F36B\";\n}\n\ni.icon.algolia:before {\n  content: \"\\F36C\";\n}\n\ni.icon.align.center:before {\n  content: \"\\F037\";\n}\n\ni.icon.align.justify:before {\n  content: \"\\F039\";\n}\n\ni.icon.align.left:before {\n  content: \"\\F036\";\n}\n\ni.icon.align.right:before {\n  content: \"\\F038\";\n}\n\ni.icon.amazon:before {\n  content: \"\\F270\";\n}\n\ni.icon.amazon.pay:before {\n  content: \"\\F42C\";\n}\n\ni.icon.ambulance:before {\n  content: \"\\F0F9\";\n}\n\ni.icon.american.sign.language.interpreting:before {\n  content: \"\\F2A3\";\n}\n\ni.icon.amilia:before {\n  content: \"\\F36D\";\n}\n\ni.icon.anchor:before {\n  content: \"\\F13D\";\n}\n\ni.icon.android:before {\n  content: \"\\F17B\";\n}\n\ni.icon.angellist:before {\n  content: \"\\F209\";\n}\n\ni.icon.angle.double.down:before {\n  content: \"\\F103\";\n}\n\ni.icon.angle.double.left:before {\n  content: \"\\F100\";\n}\n\ni.icon.angle.double.right:before {\n  content: \"\\F101\";\n}\n\ni.icon.angle.double.up:before {\n  content: \"\\F102\";\n}\n\ni.icon.angle.down:before {\n  content: \"\\F107\";\n}\n\ni.icon.angle.left:before {\n  content: \"\\F104\";\n}\n\ni.icon.angle.right:before {\n  content: \"\\F105\";\n}\n\ni.icon.angle.up:before {\n  content: \"\\F106\";\n}\n\ni.icon.angrycreative:before {\n  content: \"\\F36E\";\n}\n\ni.icon.angular:before {\n  content: \"\\F420\";\n}\n\ni.icon.app.store:before {\n  content: \"\\F36F\";\n}\n\ni.icon.app.store.ios:before {\n  content: \"\\F370\";\n}\n\ni.icon.apper:before {\n  content: \"\\F371\";\n}\n\ni.icon.apple:before {\n  content: \"\\F179\";\n}\n\ni.icon.apple.pay:before {\n  content: \"\\F415\";\n}\n\ni.icon.archive:before {\n  content: \"\\F187\";\n}\n\ni.icon.arrow.alternate.circle.down:before {\n  content: \"\\F358\";\n}\n\ni.icon.arrow.alternate.circle.left:before {\n  content: \"\\F359\";\n}\n\ni.icon.arrow.alternate.circle.right:before {\n  content: \"\\F35A\";\n}\n\ni.icon.arrow.alternate.circle.up:before {\n  content: \"\\F35B\";\n}\n\ni.icon.arrow.circle.down:before {\n  content: \"\\F0AB\";\n}\n\ni.icon.arrow.circle.left:before {\n  content: \"\\F0A8\";\n}\n\ni.icon.arrow.circle.right:before {\n  content: \"\\F0A9\";\n}\n\ni.icon.arrow.circle.up:before {\n  content: \"\\F0AA\";\n}\n\ni.icon.arrow.down:before {\n  content: \"\\F063\";\n}\n\ni.icon.arrow.left:before {\n  content: \"\\F060\";\n}\n\ni.icon.arrow.right:before {\n  content: \"\\F061\";\n}\n\ni.icon.arrow.up:before {\n  content: \"\\F062\";\n}\n\ni.icon.arrows.alternate:before {\n  content: \"\\F0B2\";\n}\n\ni.icon.arrows.alternate.horizontal:before {\n  content: \"\\F337\";\n}\n\ni.icon.arrows.alternate.vertical:before {\n  content: \"\\F338\";\n}\n\ni.icon.assistive.listening.systems:before {\n  content: \"\\F2A2\";\n}\n\ni.icon.asterisk:before {\n  content: \"\\F069\";\n}\n\ni.icon.asymmetrik:before {\n  content: \"\\F372\";\n}\n\ni.icon.at:before {\n  content: \"\\F1FA\";\n}\n\ni.icon.audible:before {\n  content: \"\\F373\";\n}\n\ni.icon.audio.description:before {\n  content: \"\\F29E\";\n}\n\ni.icon.autoprefixer:before {\n  content: \"\\F41C\";\n}\n\ni.icon.avianex:before {\n  content: \"\\F374\";\n}\n\ni.icon.aviato:before {\n  content: \"\\F421\";\n}\n\ni.icon.aws:before {\n  content: \"\\F375\";\n}\n\ni.icon.backward:before {\n  content: \"\\F04A\";\n}\n\ni.icon.balance.scale:before {\n  content: \"\\F24E\";\n}\n\ni.icon.ban:before {\n  content: \"\\F05E\";\n}\n\ni.icon.band.aid:before {\n  content: \"\\F462\";\n}\n\ni.icon.bandcamp:before {\n  content: \"\\F2D5\";\n}\n\ni.icon.barcode:before {\n  content: \"\\F02A\";\n}\n\ni.icon.bars:before {\n  content: \"\\F0C9\";\n}\n\ni.icon.baseball.ball:before {\n  content: \"\\F433\";\n}\n\ni.icon.basketball.ball:before {\n  content: \"\\F434\";\n}\n\ni.icon.bath:before {\n  content: \"\\F2CD\";\n}\n\ni.icon.battery.empty:before {\n  content: \"\\F244\";\n}\n\ni.icon.battery.full:before {\n  content: \"\\F240\";\n}\n\ni.icon.battery.half:before {\n  content: \"\\F242\";\n}\n\ni.icon.battery.quarter:before {\n  content: \"\\F243\";\n}\n\ni.icon.battery.three.quarters:before {\n  content: \"\\F241\";\n}\n\ni.icon.bed:before {\n  content: \"\\F236\";\n}\n\ni.icon.beer:before {\n  content: \"\\F0FC\";\n}\n\ni.icon.behance:before {\n  content: \"\\F1B4\";\n}\n\ni.icon.behance.square:before {\n  content: \"\\F1B5\";\n}\n\ni.icon.bell:before {\n  content: \"\\F0F3\";\n}\n\ni.icon.bell.slash:before {\n  content: \"\\F1F6\";\n}\n\ni.icon.bicycle:before {\n  content: \"\\F206\";\n}\n\ni.icon.bimobject:before {\n  content: \"\\F378\";\n}\n\ni.icon.binoculars:before {\n  content: \"\\F1E5\";\n}\n\ni.icon.birthday.cake:before {\n  content: \"\\F1FD\";\n}\n\ni.icon.bitbucket:before {\n  content: \"\\F171\";\n}\n\ni.icon.bitcoin:before {\n  content: \"\\F379\";\n}\n\ni.icon.bity:before {\n  content: \"\\F37A\";\n}\n\ni.icon.black.tie:before {\n  content: \"\\F27E\";\n}\n\ni.icon.blackberry:before {\n  content: \"\\F37B\";\n}\n\ni.icon.blind:before {\n  content: \"\\F29D\";\n}\n\ni.icon.blogger:before {\n  content: \"\\F37C\";\n}\n\ni.icon.blogger.b:before {\n  content: \"\\F37D\";\n}\n\ni.icon.bluetooth:before {\n  content: \"\\F293\";\n}\n\ni.icon.bluetooth.b:before {\n  content: \"\\F294\";\n}\n\ni.icon.bold:before {\n  content: \"\\F032\";\n}\n\ni.icon.bolt:before {\n  content: \"\\F0E7\";\n}\n\ni.icon.bomb:before {\n  content: \"\\F1E2\";\n}\n\ni.icon.book:before {\n  content: \"\\F02D\";\n}\n\ni.icon.bookmark:before {\n  content: \"\\F02E\";\n}\n\ni.icon.bowling.ball:before {\n  content: \"\\F436\";\n}\n\ni.icon.box:before {\n  content: \"\\F466\";\n}\n\ni.icon.boxes:before {\n  content: \"\\F468\";\n}\n\ni.icon.braille:before {\n  content: \"\\F2A1\";\n}\n\ni.icon.briefcase:before {\n  content: \"\\F0B1\";\n}\n\ni.icon.btc:before {\n  content: \"\\F15A\";\n}\n\ni.icon.bug:before {\n  content: \"\\F188\";\n}\n\ni.icon.building:before {\n  content: \"\\F1AD\";\n}\n\ni.icon.bullhorn:before {\n  content: \"\\F0A1\";\n}\n\ni.icon.bullseye:before {\n  content: \"\\F140\";\n}\n\ni.icon.buromobelexperte:before {\n  content: \"\\F37F\";\n}\n\ni.icon.bus:before {\n  content: \"\\F207\";\n}\n\ni.icon.buysellads:before {\n  content: \"\\F20D\";\n}\n\ni.icon.calculator:before {\n  content: \"\\F1EC\";\n}\n\ni.icon.calendar:before {\n  content: \"\\F133\";\n}\n\ni.icon.calendar.alternate:before {\n  content: \"\\F073\";\n}\n\ni.icon.calendar.check:before {\n  content: \"\\F274\";\n}\n\ni.icon.calendar.minus:before {\n  content: \"\\F272\";\n}\n\ni.icon.calendar.plus:before {\n  content: \"\\F271\";\n}\n\ni.icon.calendar.times:before {\n  content: \"\\F273\";\n}\n\ni.icon.camera:before {\n  content: \"\\F030\";\n}\n\ni.icon.camera.retro:before {\n  content: \"\\F083\";\n}\n\ni.icon.car:before {\n  content: \"\\F1B9\";\n}\n\ni.icon.caret.down:before {\n  content: \"\\F0D7\";\n}\n\ni.icon.caret.left:before {\n  content: \"\\F0D9\";\n}\n\ni.icon.caret.right:before {\n  content: \"\\F0DA\";\n}\n\ni.icon.caret.square.down:before {\n  content: \"\\F150\";\n}\n\ni.icon.caret.square.left:before {\n  content: \"\\F191\";\n}\n\ni.icon.caret.square.right:before {\n  content: \"\\F152\";\n}\n\ni.icon.caret.square.up:before {\n  content: \"\\F151\";\n}\n\ni.icon.caret.up:before {\n  content: \"\\F0D8\";\n}\n\ni.icon.cart.arrow.down:before {\n  content: \"\\F218\";\n}\n\ni.icon.cart.plus:before {\n  content: \"\\F217\";\n}\n\ni.icon.cc.amazon.pay:before {\n  content: \"\\F42D\";\n}\n\ni.icon.cc.amex:before {\n  content: \"\\F1F3\";\n}\n\ni.icon.cc.apple.pay:before {\n  content: \"\\F416\";\n}\n\ni.icon.cc.diners.club:before {\n  content: \"\\F24C\";\n}\n\ni.icon.cc.discover:before {\n  content: \"\\F1F2\";\n}\n\ni.icon.cc.jcb:before {\n  content: \"\\F24B\";\n}\n\ni.icon.cc.mastercard:before {\n  content: \"\\F1F1\";\n}\n\ni.icon.cc.paypal:before {\n  content: \"\\F1F4\";\n}\n\ni.icon.cc.stripe:before {\n  content: \"\\F1F5\";\n}\n\ni.icon.cc.visa:before {\n  content: \"\\F1F0\";\n}\n\ni.icon.centercode:before {\n  content: \"\\F380\";\n}\n\ni.icon.certificate:before {\n  content: \"\\F0A3\";\n}\n\ni.icon.chart.area:before {\n  content: \"\\F1FE\";\n}\n\ni.icon.chart.bar:before {\n  content: \"\\F080\";\n}\n\ni.icon.chart.line:before {\n  content: \"\\F201\";\n}\n\ni.icon.chart.pie:before {\n  content: \"\\F200\";\n}\n\ni.icon.check:before {\n  content: \"\\F00C\";\n}\n\ni.icon.check.circle:before {\n  content: \"\\F058\";\n}\n\ni.icon.check.square:before {\n  content: \"\\F14A\";\n}\n\ni.icon.chess:before {\n  content: \"\\F439\";\n}\n\ni.icon.chess.bishop:before {\n  content: \"\\F43A\";\n}\n\ni.icon.chess.board:before {\n  content: \"\\F43C\";\n}\n\ni.icon.chess.king:before {\n  content: \"\\F43F\";\n}\n\ni.icon.chess.knight:before {\n  content: \"\\F441\";\n}\n\ni.icon.chess.pawn:before {\n  content: \"\\F443\";\n}\n\ni.icon.chess.queen:before {\n  content: \"\\F445\";\n}\n\ni.icon.chess.rook:before {\n  content: \"\\F447\";\n}\n\ni.icon.chevron.circle.down:before {\n  content: \"\\F13A\";\n}\n\ni.icon.chevron.circle.left:before {\n  content: \"\\F137\";\n}\n\ni.icon.chevron.circle.right:before {\n  content: \"\\F138\";\n}\n\ni.icon.chevron.circle.up:before {\n  content: \"\\F139\";\n}\n\ni.icon.chevron.down:before {\n  content: \"\\F078\";\n}\n\ni.icon.chevron.left:before {\n  content: \"\\F053\";\n}\n\ni.icon.chevron.right:before {\n  content: \"\\F054\";\n}\n\ni.icon.chevron.up:before {\n  content: \"\\F077\";\n}\n\ni.icon.child:before {\n  content: \"\\F1AE\";\n}\n\ni.icon.chrome:before {\n  content: \"\\F268\";\n}\n\ni.icon.circle:before {\n  content: \"\\F111\";\n}\n\ni.icon.circle.notch:before {\n  content: \"\\F1CE\";\n}\n\ni.icon.clipboard:before {\n  content: \"\\F328\";\n}\n\ni.icon.clipboard.check:before {\n  content: \"\\F46C\";\n}\n\ni.icon.clipboard.list:before {\n  content: \"\\F46D\";\n}\n\ni.icon.clock:before {\n  content: \"\\F017\";\n}\n\ni.icon.clone:before {\n  content: \"\\F24D\";\n}\n\ni.icon.closed.captioning:before {\n  content: \"\\F20A\";\n}\n\ni.icon.cloud:before {\n  content: \"\\F0C2\";\n}\n\ni.icon.cloudscale:before {\n  content: \"\\F383\";\n}\n\ni.icon.cloudsmith:before {\n  content: \"\\F384\";\n}\n\ni.icon.cloudversify:before {\n  content: \"\\F385\";\n}\n\ni.icon.code:before {\n  content: \"\\F121\";\n}\n\ni.icon.code.branch:before {\n  content: \"\\F126\";\n}\n\ni.icon.codepen:before {\n  content: \"\\F1CB\";\n}\n\ni.icon.codiepie:before {\n  content: \"\\F284\";\n}\n\ni.icon.coffee:before {\n  content: \"\\F0F4\";\n}\n\ni.icon.cog:before {\n  content: \"\\F013\";\n}\n\ni.icon.cogs:before {\n  content: \"\\F085\";\n}\n\ni.icon.columns:before {\n  content: \"\\F0DB\";\n}\n\ni.icon.comment:before {\n  content: \"\\F075\";\n}\n\ni.icon.comment.alternate:before {\n  content: \"\\F27A\";\n}\n\ni.icon.comments:before {\n  content: \"\\F086\";\n}\n\ni.icon.compass:before {\n  content: \"\\F14E\";\n}\n\ni.icon.compress:before {\n  content: \"\\F066\";\n}\n\ni.icon.connectdevelop:before {\n  content: \"\\F20E\";\n}\n\ni.icon.contao:before {\n  content: \"\\F26D\";\n}\n\ni.icon.copy:before {\n  content: \"\\F0C5\";\n}\n\ni.icon.copyright:before {\n  content: \"\\F1F9\";\n}\n\ni.icon.cpanel:before {\n  content: \"\\F388\";\n}\n\ni.icon.creative.commons:before {\n  content: \"\\F25E\";\n}\n\ni.icon.credit.card:before {\n  content: \"\\F09D\";\n}\n\ni.icon.crop:before {\n  content: \"\\F125\";\n}\n\ni.icon.crosshairs:before {\n  content: \"\\F05B\";\n}\n\ni.icon.css3:before {\n  content: \"\\F13C\";\n}\n\ni.icon.css3.alternate:before {\n  content: \"\\F38B\";\n}\n\ni.icon.cube:before {\n  content: \"\\F1B2\";\n}\n\ni.icon.cubes:before {\n  content: \"\\F1B3\";\n}\n\ni.icon.cut:before {\n  content: \"\\F0C4\";\n}\n\ni.icon.cuttlefish:before {\n  content: \"\\F38C\";\n}\n\ni.icon.d.and.d:before {\n  content: \"\\F38D\";\n}\n\ni.icon.dashcube:before {\n  content: \"\\F210\";\n}\n\ni.icon.database:before {\n  content: \"\\F1C0\";\n}\n\ni.icon.deaf:before {\n  content: \"\\F2A4\";\n}\n\ni.icon.delicious:before {\n  content: \"\\F1A5\";\n}\n\ni.icon.deploydog:before {\n  content: \"\\F38E\";\n}\n\ni.icon.deskpro:before {\n  content: \"\\F38F\";\n}\n\ni.icon.desktop:before {\n  content: \"\\F108\";\n}\n\ni.icon.deviantart:before {\n  content: \"\\F1BD\";\n}\n\ni.icon.digg:before {\n  content: \"\\F1A6\";\n}\n\ni.icon.digital.ocean:before {\n  content: \"\\F391\";\n}\n\ni.icon.discord:before {\n  content: \"\\F392\";\n}\n\ni.icon.discourse:before {\n  content: \"\\F393\";\n}\n\ni.icon.dna:before {\n  content: \"\\F471\";\n}\n\ni.icon.dochub:before {\n  content: \"\\F394\";\n}\n\ni.icon.docker:before {\n  content: \"\\F395\";\n}\n\ni.icon.dollar.sign:before {\n  content: \"\\F155\";\n}\n\ni.icon.dolly:before {\n  content: \"\\F472\";\n}\n\ni.icon.dolly.flatbed:before {\n  content: \"\\F474\";\n}\n\ni.icon.dot.circle:before {\n  content: \"\\F192\";\n}\n\ni.icon.download:before {\n  content: \"\\F019\";\n}\n\ni.icon.draft2digital:before {\n  content: \"\\F396\";\n}\n\ni.icon.dribbble:before {\n  content: \"\\F17D\";\n}\n\ni.icon.dribbble.square:before {\n  content: \"\\F397\";\n}\n\ni.icon.dropbox:before {\n  content: \"\\F16B\";\n}\n\ni.icon.drupal:before {\n  content: \"\\F1A9\";\n}\n\ni.icon.dyalog:before {\n  content: \"\\F399\";\n}\n\ni.icon.earlybirds:before {\n  content: \"\\F39A\";\n}\n\ni.icon.edge:before {\n  content: \"\\F282\";\n}\n\ni.icon.edit:before {\n  content: \"\\F044\";\n}\n\ni.icon.eject:before {\n  content: \"\\F052\";\n}\n\ni.icon.elementor:before {\n  content: \"\\F430\";\n}\n\ni.icon.ellipsis.horizontal:before {\n  content: \"\\F141\";\n}\n\ni.icon.ellipsis.vertical:before {\n  content: \"\\F142\";\n}\n\ni.icon.ember:before {\n  content: \"\\F423\";\n}\n\ni.icon.empire:before {\n  content: \"\\F1D1\";\n}\n\ni.icon.envelope:before {\n  content: \"\\F0E0\";\n}\n\ni.icon.envelope.open:before {\n  content: \"\\F2B6\";\n}\n\ni.icon.envelope.square:before {\n  content: \"\\F199\";\n}\n\ni.icon.envira:before {\n  content: \"\\F299\";\n}\n\ni.icon.eraser:before {\n  content: \"\\F12D\";\n}\n\ni.icon.erlang:before {\n  content: \"\\F39D\";\n}\n\ni.icon.ethereum:before {\n  content: \"\\F42E\";\n}\n\ni.icon.etsy:before {\n  content: \"\\F2D7\";\n}\n\ni.icon.euro.sign:before {\n  content: \"\\F153\";\n}\n\ni.icon.exchange.alternate:before {\n  content: \"\\F362\";\n}\n\ni.icon.exclamation:before {\n  content: \"\\F12A\";\n}\n\ni.icon.exclamation.circle:before {\n  content: \"\\F06A\";\n}\n\ni.icon.exclamation.triangle:before {\n  content: \"\\F071\";\n}\n\ni.icon.expand:before {\n  content: \"\\F065\";\n}\n\ni.icon.expand.arrows.alternate:before {\n  content: \"\\F31E\";\n}\n\ni.icon.expeditedssl:before {\n  content: \"\\F23E\";\n}\n\ni.icon.external.alternate:before {\n  content: \"\\F35D\";\n}\n\ni.icon.external.square.alternate:before {\n  content: \"\\F360\";\n}\n\ni.icon.eye:before {\n  content: \"\\F06E\";\n}\n\ni.icon.eye.dropper:before {\n  content: \"\\F1FB\";\n}\n\ni.icon.eye.slash:before {\n  content: \"\\F070\";\n}\n\ni.icon.facebook:before {\n  content: \"\\F09A\";\n}\n\ni.icon.facebook.f:before {\n  content: \"\\F39E\";\n}\n\ni.icon.facebook.messenger:before {\n  content: \"\\F39F\";\n}\n\ni.icon.facebook.square:before {\n  content: \"\\F082\";\n}\n\ni.icon.fast.backward:before {\n  content: \"\\F049\";\n}\n\ni.icon.fast.forward:before {\n  content: \"\\F050\";\n}\n\ni.icon.fax:before {\n  content: \"\\F1AC\";\n}\n\ni.icon.female:before {\n  content: \"\\F182\";\n}\n\ni.icon.fighter.jet:before {\n  content: \"\\F0FB\";\n}\n\ni.icon.file:before {\n  content: \"\\F15B\";\n}\n\ni.icon.file.alternate:before {\n  content: \"\\F15C\";\n}\n\ni.icon.file.archive:before {\n  content: \"\\F1C6\";\n}\n\ni.icon.file.audio:before {\n  content: \"\\F1C7\";\n}\n\ni.icon.file.code:before {\n  content: \"\\F1C9\";\n}\n\ni.icon.file.excel:before {\n  content: \"\\F1C3\";\n}\n\ni.icon.file.image:before {\n  content: \"\\F1C5\";\n}\n\ni.icon.file.pdf:before {\n  content: \"\\F1C1\";\n}\n\ni.icon.file.powerpoint:before {\n  content: \"\\F1C4\";\n}\n\ni.icon.file.video:before {\n  content: \"\\F1C8\";\n}\n\ni.icon.file.word:before {\n  content: \"\\F1C2\";\n}\n\ni.icon.film:before {\n  content: \"\\F008\";\n}\n\ni.icon.filter:before {\n  content: \"\\F0B0\";\n}\n\ni.icon.fire:before {\n  content: \"\\F06D\";\n}\n\ni.icon.fire.extinguisher:before {\n  content: \"\\F134\";\n}\n\ni.icon.firefox:before {\n  content: \"\\F269\";\n}\n\ni.icon.first.aid:before {\n  content: \"\\F479\";\n}\n\ni.icon.first.order:before {\n  content: \"\\F2B0\";\n}\n\ni.icon.firstdraft:before {\n  content: \"\\F3A1\";\n}\n\ni.icon.flag:before {\n  content: \"\\F024\";\n}\n\ni.icon.flag.checkered:before {\n  content: \"\\F11E\";\n}\n\ni.icon.flask:before {\n  content: \"\\F0C3\";\n}\n\ni.icon.flickr:before {\n  content: \"\\F16E\";\n}\n\ni.icon.flipboard:before {\n  content: \"\\F44D\";\n}\n\ni.icon.fly:before {\n  content: \"\\F417\";\n}\n\ni.icon.folder:before {\n  content: \"\\F07B\";\n}\n\ni.icon.folder.open:before {\n  content: \"\\F07C\";\n}\n\ni.icon.font:before {\n  content: \"\\F031\";\n}\n\ni.icon.font.awesome:before {\n  content: \"\\F2B4\";\n}\n\ni.icon.font.awesome.alternate:before {\n  content: \"\\F35C\";\n}\n\ni.icon.font.awesome.flag:before {\n  content: \"\\F425\";\n}\n\ni.icon.fonticons:before {\n  content: \"\\F280\";\n}\n\ni.icon.fonticons.fi:before {\n  content: \"\\F3A2\";\n}\n\ni.icon.football.ball:before {\n  content: \"\\F44E\";\n}\n\ni.icon.fort.awesome:before {\n  content: \"\\F286\";\n}\n\ni.icon.fort.awesome.alternate:before {\n  content: \"\\F3A3\";\n}\n\ni.icon.forumbee:before {\n  content: \"\\F211\";\n}\n\ni.icon.forward:before {\n  content: \"\\F04E\";\n}\n\ni.icon.foursquare:before {\n  content: \"\\F180\";\n}\n\ni.icon.free.code.camp:before {\n  content: \"\\F2C5\";\n}\n\ni.icon.freebsd:before {\n  content: \"\\F3A4\";\n}\n\ni.icon.frown:before {\n  content: \"\\F119\";\n}\n\ni.icon.futbol:before {\n  content: \"\\F1E3\";\n}\n\ni.icon.gamepad:before {\n  content: \"\\F11B\";\n}\n\ni.icon.gavel:before {\n  content: \"\\F0E3\";\n}\n\ni.icon.gem:before {\n  content: \"\\F3A5\";\n}\n\ni.icon.genderless:before {\n  content: \"\\F22D\";\n}\n\ni.icon.get.pocket:before {\n  content: \"\\F265\";\n}\n\ni.icon.gg:before {\n  content: \"\\F260\";\n}\n\ni.icon.gg.circle:before {\n  content: \"\\F261\";\n}\n\ni.icon.gift:before {\n  content: \"\\F06B\";\n}\n\ni.icon.git:before {\n  content: \"\\F1D3\";\n}\n\ni.icon.git.square:before {\n  content: \"\\F1D2\";\n}\n\ni.icon.github:before {\n  content: \"\\F09B\";\n}\n\ni.icon.github.alternate:before {\n  content: \"\\F113\";\n}\n\ni.icon.github.square:before {\n  content: \"\\F092\";\n}\n\ni.icon.gitkraken:before {\n  content: \"\\F3A6\";\n}\n\ni.icon.gitlab:before {\n  content: \"\\F296\";\n}\n\ni.icon.gitter:before {\n  content: \"\\F426\";\n}\n\ni.icon.glass.martini:before {\n  content: \"\\F000\";\n}\n\ni.icon.glide:before {\n  content: \"\\F2A5\";\n}\n\ni.icon.glide.g:before {\n  content: \"\\F2A6\";\n}\n\ni.icon.globe:before {\n  content: \"\\F0AC\";\n}\n\ni.icon.gofore:before {\n  content: \"\\F3A7\";\n}\n\ni.icon.golf.ball:before {\n  content: \"\\F450\";\n}\n\ni.icon.goodreads:before {\n  content: \"\\F3A8\";\n}\n\ni.icon.goodreads.g:before {\n  content: \"\\F3A9\";\n}\n\ni.icon.google:before {\n  content: \"\\F1A0\";\n}\n\ni.icon.google.drive:before {\n  content: \"\\F3AA\";\n}\n\ni.icon.google.play:before {\n  content: \"\\F3AB\";\n}\n\ni.icon.google.plus:before {\n  content: \"\\F2B3\";\n}\n\ni.icon.google.plus.g:before {\n  content: \"\\F0D5\";\n}\n\ni.icon.google.plus.square:before {\n  content: \"\\F0D4\";\n}\n\ni.icon.google.wallet:before {\n  content: \"\\F1EE\";\n}\n\ni.icon.graduation.cap:before {\n  content: \"\\F19D\";\n}\n\ni.icon.gratipay:before {\n  content: \"\\F184\";\n}\n\ni.icon.grav:before {\n  content: \"\\F2D6\";\n}\n\ni.icon.gripfire:before {\n  content: \"\\F3AC\";\n}\n\ni.icon.grunt:before {\n  content: \"\\F3AD\";\n}\n\ni.icon.gulp:before {\n  content: \"\\F3AE\";\n}\n\ni.icon.h.square:before {\n  content: \"\\F0FD\";\n}\n\ni.icon.hacker.news:before {\n  content: \"\\F1D4\";\n}\n\ni.icon.hacker.news.square:before {\n  content: \"\\F3AF\";\n}\n\ni.icon.hand.lizard:before {\n  content: \"\\F258\";\n}\n\ni.icon.hand.paper:before {\n  content: \"\\F256\";\n}\n\ni.icon.hand.peace:before {\n  content: \"\\F25B\";\n}\n\ni.icon.hand.point.down:before {\n  content: \"\\F0A7\";\n}\n\ni.icon.hand.point.left:before {\n  content: \"\\F0A5\";\n}\n\ni.icon.hand.point.right:before {\n  content: \"\\F0A4\";\n}\n\ni.icon.hand.point.up:before {\n  content: \"\\F0A6\";\n}\n\ni.icon.hand.pointer:before {\n  content: \"\\F25A\";\n}\n\ni.icon.hand.rock:before {\n  content: \"\\F255\";\n}\n\ni.icon.hand.scissors:before {\n  content: \"\\F257\";\n}\n\ni.icon.hand.spock:before {\n  content: \"\\F259\";\n}\n\ni.icon.handshake:before {\n  content: \"\\F2B5\";\n}\n\ni.icon.hashtag:before {\n  content: \"\\F292\";\n}\n\ni.icon.hdd:before {\n  content: \"\\F0A0\";\n}\n\ni.icon.heading:before {\n  content: \"\\F1DC\";\n}\n\ni.icon.headphones:before {\n  content: \"\\F025\";\n}\n\ni.icon.heart:before {\n  content: \"\\F004\";\n}\n\ni.icon.heartbeat:before {\n  content: \"\\F21E\";\n}\n\ni.icon.hips:before {\n  content: \"\\F452\";\n}\n\ni.icon.hire.a.helper:before {\n  content: \"\\F3B0\";\n}\n\ni.icon.history:before {\n  content: \"\\F1DA\";\n}\n\ni.icon.hockey.puck:before {\n  content: \"\\F453\";\n}\n\ni.icon.home:before {\n  content: \"\\F015\";\n}\n\ni.icon.hooli:before {\n  content: \"\\F427\";\n}\n\ni.icon.hospital:before {\n  content: \"\\F0F8\";\n}\n\ni.icon.hospital.symbol:before {\n  content: \"\\F47E\";\n}\n\ni.icon.hotjar:before {\n  content: \"\\F3B1\";\n}\n\ni.icon.hourglass:before {\n  content: \"\\F254\";\n}\n\ni.icon.hourglass.end:before {\n  content: \"\\F253\";\n}\n\ni.icon.hourglass.half:before {\n  content: \"\\F252\";\n}\n\ni.icon.hourglass.start:before {\n  content: \"\\F251\";\n}\n\ni.icon.houzz:before {\n  content: \"\\F27C\";\n}\n\ni.icon.html5:before {\n  content: \"\\F13B\";\n}\n\ni.icon.hubspot:before {\n  content: \"\\F3B2\";\n}\n\ni.icon.i.cursor:before {\n  content: \"\\F246\";\n}\n\ni.icon.id.badge:before {\n  content: \"\\F2C1\";\n}\n\ni.icon.id.card:before {\n  content: \"\\F2C2\";\n}\n\ni.icon.image:before {\n  content: \"\\F03E\";\n}\n\ni.icon.images:before {\n  content: \"\\F302\";\n}\n\ni.icon.imdb:before {\n  content: \"\\F2D8\";\n}\n\ni.icon.inbox:before {\n  content: \"\\F01C\";\n}\n\ni.icon.indent:before {\n  content: \"\\F03C\";\n}\n\ni.icon.industry:before {\n  content: \"\\F275\";\n}\n\ni.icon.info:before {\n  content: \"\\F129\";\n}\n\ni.icon.info.circle:before {\n  content: \"\\F05A\";\n}\n\ni.icon.instagram:before {\n  content: \"\\F16D\";\n}\n\ni.icon.internet.explorer:before {\n  content: \"\\F26B\";\n}\n\ni.icon.ioxhost:before {\n  content: \"\\F208\";\n}\n\ni.icon.italic:before {\n  content: \"\\F033\";\n}\n\ni.icon.itunes:before {\n  content: \"\\F3B4\";\n}\n\ni.icon.itunes.note:before {\n  content: \"\\F3B5\";\n}\n\ni.icon.jenkins:before {\n  content: \"\\F3B6\";\n}\n\ni.icon.joget:before {\n  content: \"\\F3B7\";\n}\n\ni.icon.joomla:before {\n  content: \"\\F1AA\";\n}\n\ni.icon.js:before {\n  content: \"\\F3B8\";\n}\n\ni.icon.js.square:before {\n  content: \"\\F3B9\";\n}\n\ni.icon.jsfiddle:before {\n  content: \"\\F1CC\";\n}\n\ni.icon.key:before {\n  content: \"\\F084\";\n}\n\ni.icon.keyboard:before {\n  content: \"\\F11C\";\n}\n\ni.icon.keycdn:before {\n  content: \"\\F3BA\";\n}\n\ni.icon.kickstarter:before {\n  content: \"\\F3BB\";\n}\n\ni.icon.kickstarter.k:before {\n  content: \"\\F3BC\";\n}\n\ni.icon.korvue:before {\n  content: \"\\F42F\";\n}\n\ni.icon.language:before {\n  content: \"\\F1AB\";\n}\n\ni.icon.laptop:before {\n  content: \"\\F109\";\n}\n\ni.icon.laravel:before {\n  content: \"\\F3BD\";\n}\n\ni.icon.lastfm:before {\n  content: \"\\F202\";\n}\n\ni.icon.lastfm.square:before {\n  content: \"\\F203\";\n}\n\ni.icon.leaf:before {\n  content: \"\\F06C\";\n}\n\ni.icon.leanpub:before {\n  content: \"\\F212\";\n}\n\ni.icon.lemon:before {\n  content: \"\\F094\";\n}\n\ni.icon.less:before {\n  content: \"\\F41D\";\n}\n\ni.icon.level.down.alternate:before {\n  content: \"\\F3BE\";\n}\n\ni.icon.level.up.alternate:before {\n  content: \"\\F3BF\";\n}\n\ni.icon.life.ring:before {\n  content: \"\\F1CD\";\n}\n\ni.icon.lightbulb:before {\n  content: \"\\F0EB\";\n}\n\ni.icon.linechat:before {\n  content: \"\\F3C0\";\n}\n\ni.icon.linkify:before {\n  content: \"\\F0C1\";\n}\n\ni.icon.linkedin:before {\n  content: \"\\F08C\";\n}\n\ni.icon.linkedin.alt:before {\n  content: \"\\F0E1\";\n}\n\ni.icon.linode:before {\n  content: \"\\F2B8\";\n}\n\ni.icon.linux:before {\n  content: \"\\F17C\";\n}\n\ni.icon.lira.sign:before {\n  content: \"\\F195\";\n}\n\ni.icon.list:before {\n  content: \"\\F03A\";\n}\n\ni.icon.list.alternate:before {\n  content: \"\\F022\";\n}\n\ni.icon.list.ol:before {\n  content: \"\\F0CB\";\n}\n\ni.icon.list.ul:before {\n  content: \"\\F0CA\";\n}\n\ni.icon.location.arrow:before {\n  content: \"\\F124\";\n}\n\ni.icon.lock:before {\n  content: \"\\F023\";\n}\n\ni.icon.lock.open:before {\n  content: \"\\F3C1\";\n}\n\ni.icon.long.arrow.alternate.down:before {\n  content: \"\\F309\";\n}\n\ni.icon.long.arrow.alternate.left:before {\n  content: \"\\F30A\";\n}\n\ni.icon.long.arrow.alternate.right:before {\n  content: \"\\F30B\";\n}\n\ni.icon.long.arrow.alternate.up:before {\n  content: \"\\F30C\";\n}\n\ni.icon.low.vision:before {\n  content: \"\\F2A8\";\n}\n\ni.icon.lyft:before {\n  content: \"\\F3C3\";\n}\n\ni.icon.magento:before {\n  content: \"\\F3C4\";\n}\n\ni.icon.magic:before {\n  content: \"\\F0D0\";\n}\n\ni.icon.magnet:before {\n  content: \"\\F076\";\n}\n\ni.icon.male:before {\n  content: \"\\F183\";\n}\n\ni.icon.map:before {\n  content: \"\\F279\";\n}\n\ni.icon.map.marker:before {\n  content: \"\\F041\";\n}\n\ni.icon.map.marker.alternate:before {\n  content: \"\\F3C5\";\n}\n\ni.icon.map.pin:before {\n  content: \"\\F276\";\n}\n\ni.icon.map.signs:before {\n  content: \"\\F277\";\n}\n\ni.icon.mars:before {\n  content: \"\\F222\";\n}\n\ni.icon.mars.double:before {\n  content: \"\\F227\";\n}\n\ni.icon.mars.stroke:before {\n  content: \"\\F229\";\n}\n\ni.icon.mars.stroke.horizontal:before {\n  content: \"\\F22B\";\n}\n\ni.icon.mars.stroke.vertical:before {\n  content: \"\\F22A\";\n}\n\ni.icon.maxcdn:before {\n  content: \"\\F136\";\n}\n\ni.icon.medapps:before {\n  content: \"\\F3C6\";\n}\n\ni.icon.medium:before {\n  content: \"\\F23A\";\n}\n\ni.icon.medium.m:before {\n  content: \"\\F3C7\";\n}\n\ni.icon.medkit:before {\n  content: \"\\F0FA\";\n}\n\ni.icon.medrt:before {\n  content: \"\\F3C8\";\n}\n\ni.icon.meetup:before {\n  content: \"\\F2E0\";\n}\n\ni.icon.meh:before {\n  content: \"\\F11A\";\n}\n\ni.icon.mercury:before {\n  content: \"\\F223\";\n}\n\ni.icon.microchip:before {\n  content: \"\\F2DB\";\n}\n\ni.icon.microphone:before {\n  content: \"\\F130\";\n}\n\ni.icon.microphone.slash:before {\n  content: \"\\F131\";\n}\n\ni.icon.microsoft:before {\n  content: \"\\F3CA\";\n}\n\ni.icon.minus:before {\n  content: \"\\F068\";\n}\n\ni.icon.minus.circle:before {\n  content: \"\\F056\";\n}\n\ni.icon.minus.square:before {\n  content: \"\\F146\";\n}\n\ni.icon.mix:before {\n  content: \"\\F3CB\";\n}\n\ni.icon.mixcloud:before {\n  content: \"\\F289\";\n}\n\ni.icon.mizuni:before {\n  content: \"\\F3CC\";\n}\n\ni.icon.mobile:before {\n  content: \"\\F10B\";\n}\n\ni.icon.mobile.alternate:before {\n  content: \"\\F3CD\";\n}\n\ni.icon.modx:before {\n  content: \"\\F285\";\n}\n\ni.icon.monero:before {\n  content: \"\\F3D0\";\n}\n\ni.icon.money.bill.alternate:before {\n  content: \"\\F3D1\";\n}\n\ni.icon.moon:before {\n  content: \"\\F186\";\n}\n\ni.icon.motorcycle:before {\n  content: \"\\F21C\";\n}\n\ni.icon.mouse.pointer:before {\n  content: \"\\F245\";\n}\n\ni.icon.music:before {\n  content: \"\\F001\";\n}\n\ni.icon.napster:before {\n  content: \"\\F3D2\";\n}\n\ni.icon.neuter:before {\n  content: \"\\F22C\";\n}\n\ni.icon.newspaper:before {\n  content: \"\\F1EA\";\n}\n\ni.icon.nintendo.switch:before {\n  content: \"\\F418\";\n}\n\ni.icon.node:before {\n  content: \"\\F419\";\n}\n\ni.icon.node.js:before {\n  content: \"\\F3D3\";\n}\n\ni.icon.npm:before {\n  content: \"\\F3D4\";\n}\n\ni.icon.ns8:before {\n  content: \"\\F3D5\";\n}\n\ni.icon.nutritionix:before {\n  content: \"\\F3D6\";\n}\n\ni.icon.object.group:before {\n  content: \"\\F247\";\n}\n\ni.icon.object.ungroup:before {\n  content: \"\\F248\";\n}\n\ni.icon.odnoklassniki:before {\n  content: \"\\F263\";\n}\n\ni.icon.odnoklassniki.square:before {\n  content: \"\\F264\";\n}\n\ni.icon.opencart:before {\n  content: \"\\F23D\";\n}\n\ni.icon.openid:before {\n  content: \"\\F19B\";\n}\n\ni.icon.opera:before {\n  content: \"\\F26A\";\n}\n\ni.icon.optin.monster:before {\n  content: \"\\F23C\";\n}\n\ni.icon.osi:before {\n  content: \"\\F41A\";\n}\n\ni.icon.outdent:before {\n  content: \"\\F03B\";\n}\n\ni.icon.page4:before {\n  content: \"\\F3D7\";\n}\n\ni.icon.pagelines:before {\n  content: \"\\F18C\";\n}\n\ni.icon.paint.brush:before {\n  content: \"\\F1FC\";\n}\n\ni.icon.palfed:before {\n  content: \"\\F3D8\";\n}\n\ni.icon.pallet:before {\n  content: \"\\F482\";\n}\n\ni.icon.paper.plane:before {\n  content: \"\\F1D8\";\n}\n\ni.icon.paperclip:before {\n  content: \"\\F0C6\";\n}\n\ni.icon.paragraph:before {\n  content: \"\\F1DD\";\n}\n\ni.icon.paste:before {\n  content: \"\\F0EA\";\n}\n\ni.icon.patreon:before {\n  content: \"\\F3D9\";\n}\n\ni.icon.pause:before {\n  content: \"\\F04C\";\n}\n\ni.icon.pause.circle:before {\n  content: \"\\F28B\";\n}\n\ni.icon.paw:before {\n  content: \"\\F1B0\";\n}\n\ni.icon.paypal:before {\n  content: \"\\F1ED\";\n}\n\ni.icon.pen.square:before {\n  content: \"\\F14B\";\n}\n\ni.icon.pencil.alternate:before {\n  content: \"\\F303\";\n}\n\ni.icon.percent:before {\n  content: \"\\F295\";\n}\n\ni.icon.periscope:before {\n  content: \"\\F3DA\";\n}\n\ni.icon.phabricator:before {\n  content: \"\\F3DB\";\n}\n\ni.icon.phoenix.framework:before {\n  content: \"\\F3DC\";\n}\n\ni.icon.phone:before {\n  content: \"\\F095\";\n}\n\ni.icon.phone.square:before {\n  content: \"\\F098\";\n}\n\ni.icon.phone.volume:before {\n  content: \"\\F2A0\";\n}\n\ni.icon.php:before {\n  content: \"\\F457\";\n}\n\ni.icon.pied.piper:before {\n  content: \"\\F2AE\";\n}\n\ni.icon.pied.piper.alternate:before {\n  content: \"\\F1A8\";\n}\n\ni.icon.pied.piper.pp:before {\n  content: \"\\F1A7\";\n}\n\ni.icon.pills:before {\n  content: \"\\F484\";\n}\n\ni.icon.pinterest:before {\n  content: \"\\F0D2\";\n}\n\ni.icon.pinterest.p:before {\n  content: \"\\F231\";\n}\n\ni.icon.pinterest.square:before {\n  content: \"\\F0D3\";\n}\n\ni.icon.plane:before {\n  content: \"\\F072\";\n}\n\ni.icon.play:before {\n  content: \"\\F04B\";\n}\n\ni.icon.play.circle:before {\n  content: \"\\F144\";\n}\n\ni.icon.playstation:before {\n  content: \"\\F3DF\";\n}\n\ni.icon.plug:before {\n  content: \"\\F1E6\";\n}\n\ni.icon.plus:before {\n  content: \"\\F067\";\n}\n\ni.icon.plus.circle:before {\n  content: \"\\F055\";\n}\n\ni.icon.plus.square:before {\n  content: \"\\F0FE\";\n}\n\ni.icon.podcast:before {\n  content: \"\\F2CE\";\n}\n\ni.icon.pound.sign:before {\n  content: \"\\F154\";\n}\n\ni.icon.power.off:before {\n  content: \"\\F011\";\n}\n\ni.icon.print:before {\n  content: \"\\F02F\";\n}\n\ni.icon.product.hunt:before {\n  content: \"\\F288\";\n}\n\ni.icon.pushed:before {\n  content: \"\\F3E1\";\n}\n\ni.icon.puzzle.piece:before {\n  content: \"\\F12E\";\n}\n\ni.icon.python:before {\n  content: \"\\F3E2\";\n}\n\ni.icon.qq:before {\n  content: \"\\F1D6\";\n}\n\ni.icon.qrcode:before {\n  content: \"\\F029\";\n}\n\ni.icon.question:before {\n  content: \"\\F128\";\n}\n\ni.icon.question.circle:before {\n  content: \"\\F059\";\n}\n\ni.icon.quidditch:before {\n  content: \"\\F458\";\n}\n\ni.icon.quinscape:before {\n  content: \"\\F459\";\n}\n\ni.icon.quora:before {\n  content: \"\\F2C4\";\n}\n\ni.icon.quote.left:before {\n  content: \"\\F10D\";\n}\n\ni.icon.quote.right:before {\n  content: \"\\F10E\";\n}\n\ni.icon.random:before {\n  content: \"\\F074\";\n}\n\ni.icon.ravelry:before {\n  content: \"\\F2D9\";\n}\n\ni.icon.react:before {\n  content: \"\\F41B\";\n}\n\ni.icon.rebel:before {\n  content: \"\\F1D0\";\n}\n\ni.icon.recycle:before {\n  content: \"\\F1B8\";\n}\n\ni.icon.redriver:before {\n  content: \"\\F3E3\";\n}\n\ni.icon.reddit:before {\n  content: \"\\F1A1\";\n}\n\ni.icon.reddit.alien:before {\n  content: \"\\F281\";\n}\n\ni.icon.reddit.square:before {\n  content: \"\\F1A2\";\n}\n\ni.icon.redo:before {\n  content: \"\\F01E\";\n}\n\ni.icon.redo.alternate:before {\n  content: \"\\F2F9\";\n}\n\ni.icon.registered:before {\n  content: \"\\F25D\";\n}\n\ni.icon.rendact:before {\n  content: \"\\F3E4\";\n}\n\ni.icon.renren:before {\n  content: \"\\F18B\";\n}\n\ni.icon.reply:before {\n  content: \"\\F3E5\";\n}\n\ni.icon.reply.all:before {\n  content: \"\\F122\";\n}\n\ni.icon.replyd:before {\n  content: \"\\F3E6\";\n}\n\ni.icon.resolving:before {\n  content: \"\\F3E7\";\n}\n\ni.icon.retweet:before {\n  content: \"\\F079\";\n}\n\ni.icon.road:before {\n  content: \"\\F018\";\n}\n\ni.icon.rocket:before {\n  content: \"\\F135\";\n}\n\ni.icon.rocketchat:before {\n  content: \"\\F3E8\";\n}\n\ni.icon.rockrms:before {\n  content: \"\\F3E9\";\n}\n\ni.icon.rss:before {\n  content: \"\\F09E\";\n}\n\ni.icon.rss.square:before {\n  content: \"\\F143\";\n}\n\ni.icon.ruble.sign:before {\n  content: \"\\F158\";\n}\n\ni.icon.rupee.sign:before {\n  content: \"\\F156\";\n}\n\ni.icon.safari:before {\n  content: \"\\F267\";\n}\n\ni.icon.sass:before {\n  content: \"\\F41E\";\n}\n\ni.icon.save:before {\n  content: \"\\F0C7\";\n}\n\ni.icon.schlix:before {\n  content: \"\\F3EA\";\n}\n\ni.icon.scribd:before {\n  content: \"\\F28A\";\n}\n\ni.icon.search:before {\n  content: \"\\F002\";\n}\n\ni.icon.search.minus:before {\n  content: \"\\F010\";\n}\n\ni.icon.search.plus:before {\n  content: \"\\F00E\";\n}\n\ni.icon.searchengin:before {\n  content: \"\\F3EB\";\n}\n\ni.icon.sellcast:before {\n  content: \"\\F2DA\";\n}\n\ni.icon.sellsy:before {\n  content: \"\\F213\";\n}\n\ni.icon.server:before {\n  content: \"\\F233\";\n}\n\ni.icon.servicestack:before {\n  content: \"\\F3EC\";\n}\n\ni.icon.share:before {\n  content: \"\\F064\";\n}\n\ni.icon.share.alternate:before {\n  content: \"\\F1E0\";\n}\n\ni.icon.share.alternate.square:before {\n  content: \"\\F1E1\";\n}\n\ni.icon.share.square:before {\n  content: \"\\F14D\";\n}\n\ni.icon.shekel.sign:before {\n  content: \"\\F20B\";\n}\n\ni.icon.shield.alternate:before {\n  content: \"\\F3ED\";\n}\n\ni.icon.ship:before {\n  content: \"\\F21A\";\n}\n\ni.icon.shipping.fast:before {\n  content: \"\\F48B\";\n}\n\ni.icon.shirtsinbulk:before {\n  content: \"\\F214\";\n}\n\ni.icon.shopping.bag:before {\n  content: \"\\F290\";\n}\n\ni.icon.shopping.basket:before {\n  content: \"\\F291\";\n}\n\ni.icon.shopping.cart:before {\n  content: \"\\F07A\";\n}\n\ni.icon.shower:before {\n  content: \"\\F2CC\";\n}\n\ni.icon.sign.language:before {\n  content: \"\\F2A7\";\n}\n\ni.icon.signal:before {\n  content: \"\\F012\";\n}\n\ni.icon.simplybuilt:before {\n  content: \"\\F215\";\n}\n\ni.icon.sistrix:before {\n  content: \"\\F3EE\";\n}\n\ni.icon.sitemap:before {\n  content: \"\\F0E8\";\n}\n\ni.icon.skyatlas:before {\n  content: \"\\F216\";\n}\n\ni.icon.skype:before {\n  content: \"\\F17E\";\n}\n\ni.icon.slack:before {\n  content: \"\\F198\";\n}\n\ni.icon.slack.hash:before {\n  content: \"\\F3EF\";\n}\n\ni.icon.sliders.horizontal:before {\n  content: \"\\F1DE\";\n}\n\ni.icon.slideshare:before {\n  content: \"\\F1E7\";\n}\n\ni.icon.smile:before {\n  content: \"\\F118\";\n}\n\ni.icon.snapchat:before {\n  content: \"\\F2AB\";\n}\n\ni.icon.snapchat.ghost:before {\n  content: \"\\F2AC\";\n}\n\ni.icon.snapchat.square:before {\n  content: \"\\F2AD\";\n}\n\ni.icon.snowflake:before {\n  content: \"\\F2DC\";\n}\n\ni.icon.sort:before {\n  content: \"\\F0DC\";\n}\n\ni.icon.sort.alphabet.down:before {\n  content: \"\\F15D\";\n}\n\ni.icon.sort.alphabet.up:before {\n  content: \"\\F15E\";\n}\n\ni.icon.sort.amount.down:before {\n  content: \"\\F160\";\n}\n\ni.icon.sort.amount.up:before {\n  content: \"\\F161\";\n}\n\ni.icon.sort.down:before {\n  content: \"\\F0DD\";\n}\n\ni.icon.sort.numeric.down:before {\n  content: \"\\F162\";\n}\n\ni.icon.sort.numeric.up:before {\n  content: \"\\F163\";\n}\n\ni.icon.sort.up:before {\n  content: \"\\F0DE\";\n}\n\ni.icon.soundcloud:before {\n  content: \"\\F1BE\";\n}\n\ni.icon.space.shuttle:before {\n  content: \"\\F197\";\n}\n\ni.icon.speakap:before {\n  content: \"\\F3F3\";\n}\n\ni.icon.spinner:before {\n  content: \"\\F110\";\n}\n\ni.icon.spotify:before {\n  content: \"\\F1BC\";\n}\n\ni.icon.square:before {\n  content: \"\\F0C8\";\n}\n\ni.icon.square.full:before {\n  content: \"\\F45C\";\n}\n\ni.icon.stack.exchange:before {\n  content: \"\\F18D\";\n}\n\ni.icon.stack.overflow:before {\n  content: \"\\F16C\";\n}\n\ni.icon.star:before {\n  content: \"\\F005\";\n}\n\ni.icon.star.half:before {\n  content: \"\\F089\";\n}\n\ni.icon.staylinked:before {\n  content: \"\\F3F5\";\n}\n\ni.icon.steam:before {\n  content: \"\\F1B6\";\n}\n\ni.icon.steam.square:before {\n  content: \"\\F1B7\";\n}\n\ni.icon.steam.symbol:before {\n  content: \"\\F3F6\";\n}\n\ni.icon.step.backward:before {\n  content: \"\\F048\";\n}\n\ni.icon.step.forward:before {\n  content: \"\\F051\";\n}\n\ni.icon.stethoscope:before {\n  content: \"\\F0F1\";\n}\n\ni.icon.sticker.mule:before {\n  content: \"\\F3F7\";\n}\n\ni.icon.sticky.note:before {\n  content: \"\\F249\";\n}\n\ni.icon.stop:before {\n  content: \"\\F04D\";\n}\n\ni.icon.stop.circle:before {\n  content: \"\\F28D\";\n}\n\ni.icon.stopwatch:before {\n  content: \"\\F2F2\";\n}\n\ni.icon.strava:before {\n  content: \"\\F428\";\n}\n\ni.icon.street.view:before {\n  content: \"\\F21D\";\n}\n\ni.icon.strikethrough:before {\n  content: \"\\F0CC\";\n}\n\ni.icon.stripe:before {\n  content: \"\\F429\";\n}\n\ni.icon.stripe.s:before {\n  content: \"\\F42A\";\n}\n\ni.icon.studiovinari:before {\n  content: \"\\F3F8\";\n}\n\ni.icon.stumbleupon:before {\n  content: \"\\F1A4\";\n}\n\ni.icon.stumbleupon.circle:before {\n  content: \"\\F1A3\";\n}\n\ni.icon.subscript:before {\n  content: \"\\F12C\";\n}\n\ni.icon.subway:before {\n  content: \"\\F239\";\n}\n\ni.icon.suitcase:before {\n  content: \"\\F0F2\";\n}\n\ni.icon.sun:before {\n  content: \"\\F185\";\n}\n\ni.icon.superpowers:before {\n  content: \"\\F2DD\";\n}\n\ni.icon.superscript:before {\n  content: \"\\F12B\";\n}\n\ni.icon.supple:before {\n  content: \"\\F3F9\";\n}\n\ni.icon.sync:before {\n  content: \"\\F021\";\n}\n\ni.icon.sync.alternate:before {\n  content: \"\\F2F1\";\n}\n\ni.icon.syringe:before {\n  content: \"\\F48E\";\n}\n\ni.icon.table:before {\n  content: \"\\F0CE\";\n}\n\ni.icon.table.tennis:before {\n  content: \"\\F45D\";\n}\n\ni.icon.tablet:before {\n  content: \"\\F10A\";\n}\n\ni.icon.tablet.alternate:before {\n  content: \"\\F3FA\";\n}\n\ni.icon.tachometer.alternate:before {\n  content: \"\\F3FD\";\n}\n\ni.icon.tag:before {\n  content: \"\\F02B\";\n}\n\ni.icon.tags:before {\n  content: \"\\F02C\";\n}\n\ni.icon.tasks:before {\n  content: \"\\F0AE\";\n}\n\ni.icon.taxi:before {\n  content: \"\\F1BA\";\n}\n\ni.icon.telegram:before {\n  content: \"\\F2C6\";\n}\n\ni.icon.telegram.plane:before {\n  content: \"\\F3FE\";\n}\n\ni.icon.tencent.weibo:before {\n  content: \"\\F1D5\";\n}\n\ni.icon.terminal:before {\n  content: \"\\F120\";\n}\n\ni.icon.text.height:before {\n  content: \"\\F034\";\n}\n\ni.icon.text.width:before {\n  content: \"\\F035\";\n}\n\ni.icon.th:before {\n  content: \"\\F00A\";\n}\n\ni.icon.th.large:before {\n  content: \"\\F009\";\n}\n\ni.icon.th.list:before {\n  content: \"\\F00B\";\n}\n\ni.icon.themeisle:before {\n  content: \"\\F2B2\";\n}\n\ni.icon.thermometer:before {\n  content: \"\\F491\";\n}\n\ni.icon.thermometer.empty:before {\n  content: \"\\F2CB\";\n}\n\ni.icon.thermometer.full:before {\n  content: \"\\F2C7\";\n}\n\ni.icon.thermometer.half:before {\n  content: \"\\F2C9\";\n}\n\ni.icon.thermometer.quarter:before {\n  content: \"\\F2CA\";\n}\n\ni.icon.thermometer.three.quarters:before {\n  content: \"\\F2C8\";\n}\n\ni.icon.thumbs.down:before {\n  content: \"\\F165\";\n}\n\ni.icon.thumbs.up:before {\n  content: \"\\F164\";\n}\n\ni.icon.thumbtack:before {\n  content: \"\\F08D\";\n}\n\ni.icon.ticket.alternate:before {\n  content: \"\\F3FF\";\n}\n\ni.icon.times:before {\n  content: \"\\F00D\";\n}\n\ni.icon.times.circle:before {\n  content: \"\\F057\";\n}\n\ni.icon.tint:before {\n  content: \"\\F043\";\n}\n\ni.icon.toggle.off:before {\n  content: \"\\F204\";\n}\n\ni.icon.toggle.on:before {\n  content: \"\\F205\";\n}\n\ni.icon.trademark:before {\n  content: \"\\F25C\";\n}\n\ni.icon.train:before {\n  content: \"\\F238\";\n}\n\ni.icon.transgender:before {\n  content: \"\\F224\";\n}\n\ni.icon.transgender.alternate:before {\n  content: \"\\F225\";\n}\n\ni.icon.trash:before {\n  content: \"\\F1F8\";\n}\n\ni.icon.trash.alternate:before {\n  content: \"\\F2ED\";\n}\n\ni.icon.tree:before {\n  content: \"\\F1BB\";\n}\n\ni.icon.trello:before {\n  content: \"\\F181\";\n}\n\ni.icon.tripadvisor:before {\n  content: \"\\F262\";\n}\n\ni.icon.trophy:before {\n  content: \"\\F091\";\n}\n\ni.icon.truck:before {\n  content: \"\\F0D1\";\n}\n\ni.icon.tty:before {\n  content: \"\\F1E4\";\n}\n\ni.icon.tumblr:before {\n  content: \"\\F173\";\n}\n\ni.icon.tumblr.square:before {\n  content: \"\\F174\";\n}\n\ni.icon.tv:before {\n  content: \"\\F26C\";\n}\n\ni.icon.twitch:before {\n  content: \"\\F1E8\";\n}\n\ni.icon.twitter:before {\n  content: \"\\F099\";\n}\n\ni.icon.twitter.square:before {\n  content: \"\\F081\";\n}\n\ni.icon.typo3:before {\n  content: \"\\F42B\";\n}\n\ni.icon.uber:before {\n  content: \"\\F402\";\n}\n\ni.icon.uikit:before {\n  content: \"\\F403\";\n}\n\ni.icon.umbrella:before {\n  content: \"\\F0E9\";\n}\n\ni.icon.underline:before {\n  content: \"\\F0CD\";\n}\n\ni.icon.undo:before {\n  content: \"\\F0E2\";\n}\n\ni.icon.undo.alternate:before {\n  content: \"\\F2EA\";\n}\n\ni.icon.uniregistry:before {\n  content: \"\\F404\";\n}\n\ni.icon.universal.access:before {\n  content: \"\\F29A\";\n}\n\ni.icon.university:before {\n  content: \"\\F19C\";\n}\n\ni.icon.unlink:before {\n  content: \"\\F127\";\n}\n\ni.icon.unlock:before {\n  content: \"\\F09C\";\n}\n\ni.icon.unlock.alternate:before {\n  content: \"\\F13E\";\n}\n\ni.icon.untappd:before {\n  content: \"\\F405\";\n}\n\ni.icon.upload:before {\n  content: \"\\F093\";\n}\n\ni.icon.usb:before {\n  content: \"\\F287\";\n}\n\ni.icon.user:before {\n  content: \"\\F007\";\n}\n\ni.icon.user.circle:before {\n  content: \"\\F2BD\";\n}\n\ni.icon.user.md:before {\n  content: \"\\F0F0\";\n}\n\ni.icon.user.plus:before {\n  content: \"\\F234\";\n}\n\ni.icon.user.secret:before {\n  content: \"\\F21B\";\n}\n\ni.icon.user.times:before {\n  content: \"\\F235\";\n}\n\ni.icon.users:before {\n  content: \"\\F0C0\";\n}\n\ni.icon.ussunnah:before {\n  content: \"\\F407\";\n}\n\ni.icon.utensil.spoon:before {\n  content: \"\\F2E5\";\n}\n\ni.icon.utensils:before {\n  content: \"\\F2E7\";\n}\n\ni.icon.vaadin:before {\n  content: \"\\F408\";\n}\n\ni.icon.venus:before {\n  content: \"\\F221\";\n}\n\ni.icon.venus.double:before {\n  content: \"\\F226\";\n}\n\ni.icon.venus.mars:before {\n  content: \"\\F228\";\n}\n\ni.icon.viacoin:before {\n  content: \"\\F237\";\n}\n\ni.icon.viadeo:before {\n  content: \"\\F2A9\";\n}\n\ni.icon.viadeo.square:before {\n  content: \"\\F2AA\";\n}\n\ni.icon.viber:before {\n  content: \"\\F409\";\n}\n\ni.icon.video:before {\n  content: \"\\F03D\";\n}\n\ni.icon.vimeo:before {\n  content: \"\\F40A\";\n}\n\ni.icon.vimeo.square:before {\n  content: \"\\F194\";\n}\n\ni.icon.vimeo.v:before {\n  content: \"\\F27D\";\n}\n\ni.icon.vine:before {\n  content: \"\\F1CA\";\n}\n\ni.icon.vk:before {\n  content: \"\\F189\";\n}\n\ni.icon.vnv:before {\n  content: \"\\F40B\";\n}\n\ni.icon.volleyball.ball:before {\n  content: \"\\F45F\";\n}\n\ni.icon.volume.down:before {\n  content: \"\\F027\";\n}\n\ni.icon.volume.off:before {\n  content: \"\\F026\";\n}\n\ni.icon.volume.up:before {\n  content: \"\\F028\";\n}\n\ni.icon.vuejs:before {\n  content: \"\\F41F\";\n}\n\ni.icon.warehouse:before {\n  content: \"\\F494\";\n}\n\ni.icon.weibo:before {\n  content: \"\\F18A\";\n}\n\ni.icon.weight:before {\n  content: \"\\F496\";\n}\n\ni.icon.weixin:before {\n  content: \"\\F1D7\";\n}\n\ni.icon.whatsapp:before {\n  content: \"\\F232\";\n}\n\ni.icon.whatsapp.square:before {\n  content: \"\\F40C\";\n}\n\ni.icon.wheelchair:before {\n  content: \"\\F193\";\n}\n\ni.icon.whmcs:before {\n  content: \"\\F40D\";\n}\n\ni.icon.wifi:before {\n  content: \"\\F1EB\";\n}\n\ni.icon.wikipedia.w:before {\n  content: \"\\F266\";\n}\n\ni.icon.window.close:before {\n  content: \"\\F410\";\n}\n\ni.icon.window.maximize:before {\n  content: \"\\F2D0\";\n}\n\ni.icon.window.minimize:before {\n  content: \"\\F2D1\";\n}\n\ni.icon.window.restore:before {\n  content: \"\\F2D2\";\n}\n\ni.icon.windows:before {\n  content: \"\\F17A\";\n}\n\ni.icon.won.sign:before {\n  content: \"\\F159\";\n}\n\ni.icon.wordpress:before {\n  content: \"\\F19A\";\n}\n\ni.icon.wordpress.simple:before {\n  content: \"\\F411\";\n}\n\ni.icon.wpbeginner:before {\n  content: \"\\F297\";\n}\n\ni.icon.wpexplorer:before {\n  content: \"\\F2DE\";\n}\n\ni.icon.wpforms:before {\n  content: \"\\F298\";\n}\n\ni.icon.wrench:before {\n  content: \"\\F0AD\";\n}\n\ni.icon.xbox:before {\n  content: \"\\F412\";\n}\n\ni.icon.xing:before {\n  content: \"\\F168\";\n}\n\ni.icon.xing.square:before {\n  content: \"\\F169\";\n}\n\ni.icon.y.combinator:before {\n  content: \"\\F23B\";\n}\n\ni.icon.yahoo:before {\n  content: \"\\F19E\";\n}\n\ni.icon.yandex:before {\n  content: \"\\F413\";\n}\n\ni.icon.yandex.international:before {\n  content: \"\\F414\";\n}\n\ni.icon.yelp:before {\n  content: \"\\F1E9\";\n}\n\ni.icon.yen.sign:before {\n  content: \"\\F157\";\n}\n\ni.icon.yoast:before {\n  content: \"\\F2B1\";\n}\n\ni.icon.youtube:before {\n  content: \"\\F167\";\n}\n\ni.icon.youtube.square:before {\n  content: \"\\F431\";\n}\n\n/* Aliases */\n\ni.icon.chess.rock:before {\n  content: \"\\F447\";\n}\n\ni.icon.ordered.list:before {\n  content: \"\\F0CB\";\n}\n\ni.icon.unordered.list:before {\n  content: \"\\F0CA\";\n}\n\ni.icon.user.doctor:before {\n  content: \"\\F0F0\";\n}\n\ni.icon.shield:before {\n  content: \"\\F3ED\";\n}\n\ni.icon.puzzle:before {\n  content: \"\\F12E\";\n}\n\ni.icon.credit.card.amazon.pay:before {\n  content: \"\\F42D\";\n}\n\ni.icon.credit.card.american.express:before {\n  content: \"\\F1F3\";\n}\n\ni.icon.credit.card.diners.club:before {\n  content: \"\\F24C\";\n}\n\ni.icon.credit.card.discover:before {\n  content: \"\\F1F2\";\n}\n\ni.icon.credit.card.jcb:before {\n  content: \"\\F24B\";\n}\n\ni.icon.credit.card.mastercard:before {\n  content: \"\\F1F1\";\n}\n\ni.icon.credit.card.paypal:before {\n  content: \"\\F1F4\";\n}\n\ni.icon.credit.card.stripe:before {\n  content: \"\\F1F5\";\n}\n\ni.icon.credit.card.visa:before {\n  content: \"\\F1F0\";\n}\n\ni.icon.add.circle:before {\n  content: \"\\F055\";\n}\n\ni.icon.add.square:before {\n  content: \"\\F0FE\";\n}\n\ni.icon.add.to.calendar:before {\n  content: \"\\F271\";\n}\n\ni.icon.add.to.cart:before {\n  content: \"\\F217\";\n}\n\ni.icon.add.user:before {\n  content: \"\\F234\";\n}\n\ni.icon.add:before {\n  content: \"\\F067\";\n}\n\ni.icon.alarm.mute:before {\n  content: \"\\F1F6\";\n}\n\ni.icon.alarm:before {\n  content: \"\\F0F3\";\n}\n\ni.icon.ald:before {\n  content: \"\\F2A2\";\n}\n\ni.icon.als:before {\n  content: \"\\F2A2\";\n}\n\ni.icon.american.express.card:before {\n  content: \"\\F1F3\";\n}\n\ni.icon.american.express:before {\n  content: \"\\F1F3\";\n}\n\ni.icon.amex:before {\n  content: \"\\F1F3\";\n}\n\ni.icon.announcement:before {\n  content: \"\\F0A1\";\n}\n\ni.icon.area.chart:before {\n  content: \"\\F1FE\";\n}\n\ni.icon.area.graph:before {\n  content: \"\\F1FE\";\n}\n\ni.icon.arrow.down.cart:before {\n  content: \"\\F218\";\n}\n\ni.icon.asexual:before {\n  content: \"\\F22D\";\n}\n\ni.icon.asl.interpreting:before {\n  content: \"\\F2A3\";\n}\n\ni.icon.asl:before {\n  content: \"\\F2A3\";\n}\n\ni.icon.assistive.listening.devices:before {\n  content: \"\\F2A2\";\n}\n\ni.icon.attach:before {\n  content: \"\\F0C6\";\n}\n\ni.icon.attention:before {\n  content: \"\\F06A\";\n}\n\ni.icon.balance:before {\n  content: \"\\F24E\";\n}\n\ni.icon.bar:before {\n  content: \"\\F0FC\";\n}\n\ni.icon.bathtub:before {\n  content: \"\\F2CD\";\n}\n\ni.icon.battery.four:before {\n  content: \"\\F240\";\n}\n\ni.icon.battery.high:before {\n  content: \"\\F241\";\n}\n\ni.icon.battery.low:before {\n  content: \"\\F243\";\n}\n\ni.icon.battery.medium:before {\n  content: \"\\F242\";\n}\n\ni.icon.battery.one:before {\n  content: \"\\F243\";\n}\n\ni.icon.battery.three:before {\n  content: \"\\F241\";\n}\n\ni.icon.battery.two:before {\n  content: \"\\F242\";\n}\n\ni.icon.battery.zero:before {\n  content: \"\\F244\";\n}\n\ni.icon.birthday:before {\n  content: \"\\F1FD\";\n}\n\ni.icon.block.layout:before {\n  content: \"\\F009\";\n}\n\ni.icon.bluetooth.alternative:before {\n  content: \"\\F294\";\n}\n\ni.icon.broken.chain:before {\n  content: \"\\F127\";\n}\n\ni.icon.browser:before {\n  content: \"\\F022\";\n}\n\ni.icon.call.square:before {\n  content: \"\\F098\";\n}\n\ni.icon.call:before {\n  content: \"\\F095\";\n}\n\ni.icon.cancel:before {\n  content: \"\\F00D\";\n}\n\ni.icon.cart:before {\n  content: \"\\F07A\";\n}\n\ni.icon.cc:before {\n  content: \"\\F20A\";\n}\n\ni.icon.chain:before {\n  content: \"\\F0C1\";\n}\n\ni.icon.chat:before {\n  content: \"\\F075\";\n}\n\ni.icon.checked.calendar:before {\n  content: \"\\F274\";\n}\n\ni.icon.checkmark:before {\n  content: \"\\F00C\";\n}\n\ni.icon.circle.notched:before {\n  content: \"\\F1CE\";\n}\n\ni.icon.close:before {\n  content: \"\\F00D\";\n}\n\ni.icon.cny:before {\n  content: \"\\F157\";\n}\n\ni.icon.cocktail:before {\n  content: \"\\F000\";\n}\n\ni.icon.commenting:before {\n  content: \"\\F27A\";\n}\n\ni.icon.computer:before {\n  content: \"\\F108\";\n}\n\ni.icon.configure:before {\n  content: \"\\F0AD\";\n}\n\ni.icon.content:before {\n  content: \"\\F0C9\";\n}\n\ni.icon.deafness:before {\n  content: \"\\F2A4\";\n}\n\ni.icon.delete.calendar:before {\n  content: \"\\F273\";\n}\n\ni.icon.delete:before {\n  content: \"\\F00D\";\n}\n\ni.icon.detective:before {\n  content: \"\\F21B\";\n}\n\ni.icon.diners.club.card:before {\n  content: \"\\F24C\";\n}\n\ni.icon.diners.club:before {\n  content: \"\\F24C\";\n}\n\ni.icon.discover.card:before {\n  content: \"\\F1F2\";\n}\n\ni.icon.discover:before {\n  content: \"\\F1F2\";\n}\n\ni.icon.discussions:before {\n  content: \"\\F086\";\n}\n\ni.icon.doctor:before {\n  content: \"\\F0F0\";\n}\n\ni.icon.dollar:before {\n  content: \"\\F155\";\n}\n\ni.icon.dont:before {\n  content: \"\\F05E\";\n}\n\ni.icon.dribble:before {\n  content: \"\\F17D\";\n}\n\ni.icon.drivers.license:before {\n  content: \"\\F2C2\";\n}\n\ni.icon.dropdown:before {\n  content: \"\\F0D7\";\n}\n\ni.icon.eercast:before {\n  content: \"\\F2DA\";\n}\n\ni.icon.emergency:before {\n  content: \"\\F0F9\";\n}\n\ni.icon.envira.gallery:before {\n  content: \"\\F299\";\n}\n\ni.icon.erase:before {\n  content: \"\\F12D\";\n}\n\ni.icon.eur:before {\n  content: \"\\F153\";\n}\n\ni.icon.euro:before {\n  content: \"\\F153\";\n}\n\ni.icon.eyedropper:before {\n  content: \"\\F1FB\";\n}\n\ni.icon.fa:before {\n  content: \"\\F2B4\";\n}\n\ni.icon.factory:before {\n  content: \"\\F275\";\n}\n\ni.icon.favorite:before {\n  content: \"\\F005\";\n}\n\ni.icon.feed:before {\n  content: \"\\F09E\";\n}\n\ni.icon.female.homosexual:before {\n  content: \"\\F226\";\n}\n\ni.icon.file.text:before {\n  content: \"\\F15C\";\n}\n\ni.icon.find:before {\n  content: \"\\F1E5\";\n}\n\ni.icon.first.aid:before {\n  content: \"\\F0FA\";\n}\n\ni.icon.five.hundred.pixels:before {\n  content: \"\\F26E\";\n}\n\ni.icon.fork:before {\n  content: \"\\F126\";\n}\n\ni.icon.game:before {\n  content: \"\\F11B\";\n}\n\ni.icon.gay:before {\n  content: \"\\F227\";\n}\n\ni.icon.gbp:before {\n  content: \"\\F154\";\n}\n\ni.icon.gittip:before {\n  content: \"\\F184\";\n}\n\ni.icon.google.plus.circle:before {\n  content: \"\\F2B3\";\n}\n\ni.icon.google.plus.official:before {\n  content: \"\\F2B3\";\n}\n\ni.icon.grab:before {\n  content: \"\\F255\";\n}\n\ni.icon.graduation:before {\n  content: \"\\F19D\";\n}\n\ni.icon.grid.layout:before {\n  content: \"\\F00A\";\n}\n\ni.icon.group:before {\n  content: \"\\F0C0\";\n}\n\ni.icon.h:before {\n  content: \"\\F0FD\";\n}\n\ni.icon.hand.victory:before {\n  content: \"\\F25B\";\n}\n\ni.icon.handicap:before {\n  content: \"\\F193\";\n}\n\ni.icon.hard.of.hearing:before {\n  content: \"\\F2A4\";\n}\n\ni.icon.header:before {\n  content: \"\\F1DC\";\n}\n\ni.icon.help.circle:before {\n  content: \"\\F059\";\n}\n\ni.icon.help:before {\n  content: \"\\F128\";\n}\n\ni.icon.heterosexual:before {\n  content: \"\\F228\";\n}\n\ni.icon.hide:before {\n  content: \"\\F070\";\n}\n\ni.icon.hotel:before {\n  content: \"\\F236\";\n}\n\ni.icon.hourglass.four:before {\n  content: \"\\F254\";\n}\n\ni.icon.hourglass.full:before {\n  content: \"\\F254\";\n}\n\ni.icon.hourglass.one:before {\n  content: \"\\F251\";\n}\n\ni.icon.hourglass.three:before {\n  content: \"\\F253\";\n}\n\ni.icon.hourglass.two:before {\n  content: \"\\F252\";\n}\n\ni.icon.idea:before {\n  content: \"\\F0EB\";\n}\n\ni.icon.ils:before {\n  content: \"\\F20B\";\n}\n\ni.icon.in-cart:before {\n  content: \"\\F218\";\n}\n\ni.icon.inr:before {\n  content: \"\\F156\";\n}\n\ni.icon.intergender:before {\n  content: \"\\F224\";\n}\n\ni.icon.intersex:before {\n  content: \"\\F224\";\n}\n\ni.icon.japan.credit.bureau.card:before {\n  content: \"\\F24B\";\n}\n\ni.icon.japan.credit.bureau:before {\n  content: \"\\F24B\";\n}\n\ni.icon.jcb:before {\n  content: \"\\F24B\";\n}\n\ni.icon.jpy:before {\n  content: \"\\F157\";\n}\n\ni.icon.krw:before {\n  content: \"\\F159\";\n}\n\ni.icon.lab:before {\n  content: \"\\F0C3\";\n}\n\ni.icon.law:before {\n  content: \"\\F24E\";\n}\n\ni.icon.legal:before {\n  content: \"\\F0E3\";\n}\n\ni.icon.lesbian:before {\n  content: \"\\F226\";\n}\n\ni.icon.lightning:before {\n  content: \"\\F0E7\";\n}\n\ni.icon.like:before {\n  content: \"\\F004\";\n}\n\ni.icon.line.graph:before {\n  content: \"\\F201\";\n}\n\ni.icon.linkedin.square:before {\n  content: \"\\F08C\";\n}\n\ni.icon.linkify:before {\n  content: \"\\F0C1\";\n}\n\ni.icon.lira:before {\n  content: \"\\F195\";\n}\n\ni.icon.list.layout:before {\n  content: \"\\F00B\";\n}\n\ni.icon.magnify:before {\n  content: \"\\F00E\";\n}\n\ni.icon.mail.forward:before {\n  content: \"\\F064\";\n}\n\ni.icon.mail.square:before {\n  content: \"\\F199\";\n}\n\ni.icon.mail:before {\n  content: \"\\F0E0\";\n}\n\ni.icon.male.homosexual:before {\n  content: \"\\F227\";\n}\n\ni.icon.man:before {\n  content: \"\\F222\";\n}\n\ni.icon.marker:before {\n  content: \"\\F041\";\n}\n\ni.icon.mars.alternate:before {\n  content: \"\\F229\";\n}\n\ni.icon.mars.horizontal:before {\n  content: \"\\F22B\";\n}\n\ni.icon.mars.vertical:before {\n  content: \"\\F22A\";\n}\n\ni.icon.mastercard.card:before {\n  content: \"\\F1F1\";\n}\n\ni.icon.mastercard:before {\n  content: \"\\F1F1\";\n}\n\ni.icon.microsoft.edge:before {\n  content: \"\\F282\";\n}\n\ni.icon.military:before {\n  content: \"\\F0FB\";\n}\n\ni.icon.ms.edge:before {\n  content: \"\\F282\";\n}\n\ni.icon.mute:before {\n  content: \"\\F131\";\n}\n\ni.icon.new.pied.piper:before {\n  content: \"\\F2AE\";\n}\n\ni.icon.non.binary.transgender:before {\n  content: \"\\F223\";\n}\n\ni.icon.numbered.list:before {\n  content: \"\\F0CB\";\n}\n\ni.icon.optinmonster:before {\n  content: \"\\F23C\";\n}\n\ni.icon.options:before {\n  content: \"\\F1DE\";\n}\n\ni.icon.other.gender.horizontal:before {\n  content: \"\\F22B\";\n}\n\ni.icon.other.gender.vertical:before {\n  content: \"\\F22A\";\n}\n\ni.icon.other.gender:before {\n  content: \"\\F229\";\n}\n\ni.icon.payment:before {\n  content: \"\\F09D\";\n}\n\ni.icon.paypal.card:before {\n  content: \"\\F1F4\";\n}\n\ni.icon.pencil.square:before {\n  content: \"\\F14B\";\n}\n\ni.icon.photo:before {\n  content: \"\\F030\";\n}\n\ni.icon.picture:before {\n  content: \"\\F03E\";\n}\n\ni.icon.pie.chart:before {\n  content: \"\\F200\";\n}\n\ni.icon.pie.graph:before {\n  content: \"\\F200\";\n}\n\ni.icon.pied.piper.hat:before {\n  content: \"\\F2AE\";\n}\n\ni.icon.pin:before {\n  content: \"\\F08D\";\n}\n\ni.icon.plus.cart:before {\n  content: \"\\F217\";\n}\n\ni.icon.pocket:before {\n  content: \"\\F265\";\n}\n\ni.icon.point:before {\n  content: \"\\F041\";\n}\n\ni.icon.pointing.down:before {\n  content: \"\\F0A7\";\n}\n\ni.icon.pointing.left:before {\n  content: \"\\F0A5\";\n}\n\ni.icon.pointing.right:before {\n  content: \"\\F0A4\";\n}\n\ni.icon.pointing.up:before {\n  content: \"\\F0A6\";\n}\n\ni.icon.pound:before {\n  content: \"\\F154\";\n}\n\ni.icon.power.cord:before {\n  content: \"\\F1E6\";\n}\n\ni.icon.power:before {\n  content: \"\\F011\";\n}\n\ni.icon.privacy:before {\n  content: \"\\F084\";\n}\n\ni.icon.r.circle:before {\n  content: \"\\F25D\";\n}\n\ni.icon.rain:before {\n  content: \"\\F0E9\";\n}\n\ni.icon.record:before {\n  content: \"\\F03D\";\n}\n\ni.icon.refresh:before {\n  content: \"\\F021\";\n}\n\ni.icon.remove.circle:before {\n  content: \"\\F057\";\n}\n\ni.icon.remove.from.calendar:before {\n  content: \"\\F272\";\n}\n\ni.icon.remove.user:before {\n  content: \"\\F235\";\n}\n\ni.icon.remove:before {\n  content: \"\\F00D\";\n}\n\ni.icon.repeat:before {\n  content: \"\\F01E\";\n}\n\ni.icon.rmb:before {\n  content: \"\\F157\";\n}\n\ni.icon.rouble:before {\n  content: \"\\F158\";\n}\n\ni.icon.rub:before {\n  content: \"\\F158\";\n}\n\ni.icon.ruble:before {\n  content: \"\\F158\";\n}\n\ni.icon.rupee:before {\n  content: \"\\F156\";\n}\n\ni.icon.s15:before {\n  content: \"\\F2CD\";\n}\n\ni.icon.selected.radio:before {\n  content: \"\\F192\";\n}\n\ni.icon.send:before {\n  content: \"\\F1D8\";\n}\n\ni.icon.setting:before {\n  content: \"\\F013\";\n}\n\ni.icon.settings:before {\n  content: \"\\F085\";\n}\n\ni.icon.shekel:before {\n  content: \"\\F20B\";\n}\n\ni.icon.sheqel:before {\n  content: \"\\F20B\";\n}\n\ni.icon.shipping:before {\n  content: \"\\F0D1\";\n}\n\ni.icon.shop:before {\n  content: \"\\F07A\";\n}\n\ni.icon.shuffle:before {\n  content: \"\\F074\";\n}\n\ni.icon.shutdown:before {\n  content: \"\\F011\";\n}\n\ni.icon.sidebar:before {\n  content: \"\\F0C9\";\n}\n\ni.icon.signing:before {\n  content: \"\\F2A7\";\n}\n\ni.icon.signup:before {\n  content: \"\\F044\";\n}\n\ni.icon.sliders:before {\n  content: \"\\F1DE\";\n}\n\ni.icon.soccer:before {\n  content: \"\\F1E3\";\n}\n\ni.icon.sort.alphabet.ascending:before {\n  content: \"\\F15D\";\n}\n\ni.icon.sort.alphabet.descending:before {\n  content: \"\\F15E\";\n}\n\ni.icon.sort.ascending:before {\n  content: \"\\F0DE\";\n}\n\ni.icon.sort.content.ascending:before {\n  content: \"\\F160\";\n}\n\ni.icon.sort.content.descending:before {\n  content: \"\\F161\";\n}\n\ni.icon.sort.descending:before {\n  content: \"\\F0DD\";\n}\n\ni.icon.sort.numeric.ascending:before {\n  content: \"\\F162\";\n}\n\ni.icon.sort.numeric.descending:before {\n  content: \"\\F163\";\n}\n\ni.icon.sound:before {\n  content: \"\\F025\";\n}\n\ni.icon.spy:before {\n  content: \"\\F21B\";\n}\n\ni.icon.stripe.card:before {\n  content: \"\\F1F5\";\n}\n\ni.icon.student:before {\n  content: \"\\F19D\";\n}\n\ni.icon.talk:before {\n  content: \"\\F27A\";\n}\n\ni.icon.target:before {\n  content: \"\\F140\";\n}\n\ni.icon.teletype:before {\n  content: \"\\F1E4\";\n}\n\ni.icon.television:before {\n  content: \"\\F26C\";\n}\n\ni.icon.text.cursor:before {\n  content: \"\\F246\";\n}\n\ni.icon.text.telephone:before {\n  content: \"\\F1E4\";\n}\n\ni.icon.theme.isle:before {\n  content: \"\\F2B2\";\n}\n\ni.icon.theme:before {\n  content: \"\\F043\";\n}\n\ni.icon.thermometer:before {\n  content: \"\\F2C7\";\n}\n\ni.icon.thumb.tack:before {\n  content: \"\\F08D\";\n}\n\ni.icon.time:before {\n  content: \"\\F017\";\n}\n\ni.icon.tm:before {\n  content: \"\\F25C\";\n}\n\ni.icon.toggle.down:before {\n  content: \"\\F150\";\n}\n\ni.icon.toggle.left:before {\n  content: \"\\F191\";\n}\n\ni.icon.toggle.right:before {\n  content: \"\\F152\";\n}\n\ni.icon.toggle.up:before {\n  content: \"\\F151\";\n}\n\ni.icon.translate:before {\n  content: \"\\F1AB\";\n}\n\ni.icon.travel:before {\n  content: \"\\F0B1\";\n}\n\ni.icon.treatment:before {\n  content: \"\\F0F1\";\n}\n\ni.icon.triangle.down:before {\n  content: \"\\F0D7\";\n}\n\ni.icon.triangle.left:before {\n  content: \"\\F0D9\";\n}\n\ni.icon.triangle.right:before {\n  content: \"\\F0DA\";\n}\n\ni.icon.triangle.up:before {\n  content: \"\\F0D8\";\n}\n\ni.icon.try:before {\n  content: \"\\F195\";\n}\n\ni.icon.unhide:before {\n  content: \"\\F06E\";\n}\n\ni.icon.unlinkify:before {\n  content: \"\\F127\";\n}\n\ni.icon.unmute:before {\n  content: \"\\F130\";\n}\n\ni.icon.usd:before {\n  content: \"\\F155\";\n}\n\ni.icon.user.cancel:before {\n  content: \"\\F235\";\n}\n\ni.icon.user.close:before {\n  content: \"\\F235\";\n}\n\ni.icon.user.delete:before {\n  content: \"\\F235\";\n}\n\ni.icon.user.x:before {\n  content: \"\\F235\";\n}\n\ni.icon.vcard:before {\n  content: \"\\F2BB\";\n}\n\ni.icon.video.camera:before {\n  content: \"\\F03D\";\n}\n\ni.icon.video.play:before {\n  content: \"\\F144\";\n}\n\ni.icon.visa.card:before {\n  content: \"\\F1F0\";\n}\n\ni.icon.visa:before {\n  content: \"\\F1F0\";\n}\n\ni.icon.volume.control.phone:before {\n  content: \"\\F2A0\";\n}\n\ni.icon.wait:before {\n  content: \"\\F017\";\n}\n\ni.icon.warning.circle:before {\n  content: \"\\F06A\";\n}\n\ni.icon.warning.sign:before {\n  content: \"\\F071\";\n}\n\ni.icon.warning:before {\n  content: \"\\F12A\";\n}\n\ni.icon.wechat:before {\n  content: \"\\F1D7\";\n}\n\ni.icon.wi-fi:before {\n  content: \"\\F1EB\";\n}\n\ni.icon.wikipedia:before {\n  content: \"\\F266\";\n}\n\ni.icon.winner:before {\n  content: \"\\F091\";\n}\n\ni.icon.wizard:before {\n  content: \"\\F0D0\";\n}\n\ni.icon.woman:before {\n  content: \"\\F221\";\n}\n\ni.icon.won:before {\n  content: \"\\F159\";\n}\n\ni.icon.wordpress.beginner:before {\n  content: \"\\F297\";\n}\n\ni.icon.wordpress.forms:before {\n  content: \"\\F298\";\n}\n\ni.icon.world:before {\n  content: \"\\F0AC\";\n}\n\ni.icon.write.square:before {\n  content: \"\\F14B\";\n}\n\ni.icon.x:before {\n  content: \"\\F00D\";\n}\n\ni.icon.yc:before {\n  content: \"\\F23B\";\n}\n\ni.icon.ycombinator:before {\n  content: \"\\F23B\";\n}\n\ni.icon.yen:before {\n  content: \"\\F157\";\n}\n\ni.icon.zip:before {\n  content: \"\\F187\";\n}\n\ni.icon.zoom-in:before {\n  content: \"\\F00E\";\n}\n\ni.icon.zoom-out:before {\n  content: \"\\F010\";\n}\n\ni.icon.zoom:before {\n  content: \"\\F00E\";\n}\n\ni.icon.bitbucket.square:before {\n  content: \"\\F171\";\n}\n\ni.icon.checkmark.box:before {\n  content: \"\\F14A\";\n}\n\ni.icon.circle.thin:before {\n  content: \"\\F111\";\n}\n\ni.icon.cloud.download:before {\n  content: \"\\F381\";\n}\n\ni.icon.cloud.upload:before {\n  content: \"\\F382\";\n}\n\ni.icon.compose:before {\n  content: \"\\F303\";\n}\n\ni.icon.conversation:before {\n  content: \"\\F086\";\n}\n\ni.icon.credit.card.alternative:before {\n  content: \"\\F09D\";\n}\n\ni.icon.currency:before {\n  content: \"\\F3D1\";\n}\n\ni.icon.dashboard:before {\n  content: \"\\F3FD\";\n}\n\ni.icon.diamond:before {\n  content: \"\\F3A5\";\n}\n\ni.icon.disk:before {\n  content: \"\\F0A0\";\n}\n\ni.icon.exchange:before {\n  content: \"\\F362\";\n}\n\ni.icon.external.share:before {\n  content: \"\\F14D\";\n}\n\ni.icon.external.square:before {\n  content: \"\\F360\";\n}\n\ni.icon.external:before {\n  content: \"\\F35D\";\n}\n\ni.icon.facebook.official:before {\n  content: \"\\F082\";\n}\n\ni.icon.food:before {\n  content: \"\\F2E7\";\n}\n\ni.icon.hourglass.zero:before {\n  content: \"\\F253\";\n}\n\ni.icon.level.down:before {\n  content: \"\\F3BE\";\n}\n\ni.icon.level.up:before {\n  content: \"\\F3BF\";\n}\n\ni.icon.logout:before {\n  content: \"\\F2F5\";\n}\n\ni.icon.meanpath:before {\n  content: \"\\F0C8\";\n}\n\ni.icon.money:before {\n  content: \"\\F3D1\";\n}\n\ni.icon.move:before {\n  content: \"\\F0B2\";\n}\n\ni.icon.pencil:before {\n  content: \"\\F303\";\n}\n\ni.icon.protect:before {\n  content: \"\\F023\";\n}\n\ni.icon.radio:before {\n  content: \"\\F192\";\n}\n\ni.icon.remove.bookmark:before {\n  content: \"\\F02E\";\n}\n\ni.icon.resize.horizontal:before {\n  content: \"\\F337\";\n}\n\ni.icon.resize.vertical:before {\n  content: \"\\F338\";\n}\n\ni.icon.sign-in:before {\n  content: \"\\F2F6\";\n}\n\ni.icon.sign-out:before {\n  content: \"\\F2F5\";\n}\n\ni.icon.spoon:before {\n  content: \"\\F2E5\";\n}\n\ni.icon.star.half.empty:before {\n  content: \"\\F089\";\n}\n\ni.icon.star.half.full:before {\n  content: \"\\F089\";\n}\n\ni.icon.ticket:before {\n  content: \"\\F3FF\";\n}\n\ni.icon.times.rectangle:before {\n  content: \"\\F410\";\n}\n\ni.icon.write:before {\n  content: \"\\F303\";\n}\n\ni.icon.youtube.play:before {\n  content: \"\\F167\";\n}\n\n/*******************************\n        Outline Icons\n*******************************/\n\n/* Outline Icon */\n\n/* Load & Define Icon Font */\n\n@font-face {\n  font-family: 'outline-icons';\n  src: url(" + __webpack_require__(1511) + ");\n  src: url(" + __webpack_require__(1511) + "?#iefix) format('embedded-opentype'), url(" + __webpack_require__(3657) + ") format('woff2'), url(" + __webpack_require__(3656) + ") format('woff'), url(" + __webpack_require__(3655) + ") format('truetype'), url(" + __webpack_require__(3654) + "#icons) format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\n\ni.icon.outline {\n  font-family: 'outline-icons';\n}\n\n/* Icon Definitions */\n\ni.icon.address.book.outline:before {\n  content: \"\\F2B9\";\n}\n\ni.icon.address.card.outline:before {\n  content: \"\\F2BB\";\n}\n\ni.icon.arrow.alternate.circle.down.outline:before {\n  content: \"\\F358\";\n}\n\ni.icon.arrow.alternate.circle.left.outline:before {\n  content: \"\\F359\";\n}\n\ni.icon.arrow.alternate.circle.right.outline:before {\n  content: \"\\F35A\";\n}\n\ni.icon.arrow.alternate.circle.up.outline:before {\n  content: \"\\F35B\";\n}\n\ni.icon.bell.outline:before {\n  content: \"\\F0F3\";\n}\n\ni.icon.bell.slash.outline:before {\n  content: \"\\F1F6\";\n}\n\ni.icon.bookmark.outline:before {\n  content: \"\\F02E\";\n}\n\ni.icon.building.outline:before {\n  content: \"\\F1AD\";\n}\n\ni.icon.calendar.outline:before {\n  content: \"\\F133\";\n}\n\ni.icon.calendar.alternate.outline:before {\n  content: \"\\F073\";\n}\n\ni.icon.calendar.check.outline:before {\n  content: \"\\F274\";\n}\n\ni.icon.calendar.minus.outline:before {\n  content: \"\\F272\";\n}\n\ni.icon.calendar.plus.outline:before {\n  content: \"\\F271\";\n}\n\ni.icon.calendar.times.outline:before {\n  content: \"\\F273\";\n}\n\ni.icon.caret.square.down.outline:before {\n  content: \"\\F150\";\n}\n\ni.icon.caret.square.left.outline:before {\n  content: \"\\F191\";\n}\n\ni.icon.caret.square.right.outline:before {\n  content: \"\\F152\";\n}\n\ni.icon.caret.square.up.outline:before {\n  content: \"\\F151\";\n}\n\ni.icon.chart.bar.outline:before {\n  content: \"\\F080\";\n}\n\ni.icon.check.circle.outline:before {\n  content: \"\\F058\";\n}\n\ni.icon.check.square.outline:before {\n  content: \"\\F14A\";\n}\n\ni.icon.circle.outline:before {\n  content: \"\\F111\";\n}\n\ni.icon.clipboard.outline:before {\n  content: \"\\F328\";\n}\n\ni.icon.clock.outline:before {\n  content: \"\\F017\";\n}\n\ni.icon.clone.outline:before {\n  content: \"\\F24D\";\n}\n\ni.icon.closed.captioning.outline:before {\n  content: \"\\F20A\";\n}\n\ni.icon.comment.outline:before {\n  content: \"\\F075\";\n}\n\ni.icon.comment.alternate.outline:before {\n  content: \"\\F27A\";\n}\n\ni.icon.comments.outline:before {\n  content: \"\\F086\";\n}\n\ni.icon.compass.outline:before {\n  content: \"\\F14E\";\n}\n\ni.icon.copy.outline:before {\n  content: \"\\F0C5\";\n}\n\ni.icon.copyright.outline:before {\n  content: \"\\F1F9\";\n}\n\ni.icon.credit.card.outline:before {\n  content: \"\\F09D\";\n}\n\ni.icon.dot.circle.outline:before {\n  content: \"\\F192\";\n}\n\ni.icon.edit.outline:before {\n  content: \"\\F044\";\n}\n\ni.icon.envelope.outline:before {\n  content: \"\\F0E0\";\n}\n\ni.icon.envelope.open.outline:before {\n  content: \"\\F2B6\";\n}\n\ni.icon.eye.slash.outline:before {\n  content: \"\\F070\";\n}\n\ni.icon.file.outline:before {\n  content: \"\\F15B\";\n}\n\ni.icon.file.alternate.outline:before {\n  content: \"\\F15C\";\n}\n\ni.icon.file.archive.outline:before {\n  content: \"\\F1C6\";\n}\n\ni.icon.file.audio.outline:before {\n  content: \"\\F1C7\";\n}\n\ni.icon.file.code.outline:before {\n  content: \"\\F1C9\";\n}\n\ni.icon.file.excel.outline:before {\n  content: \"\\F1C3\";\n}\n\ni.icon.file.image.outline:before {\n  content: \"\\F1C5\";\n}\n\ni.icon.file.pdf.outline:before {\n  content: \"\\F1C1\";\n}\n\ni.icon.file.powerpoint.outline:before {\n  content: \"\\F1C4\";\n}\n\ni.icon.file.video.outline:before {\n  content: \"\\F1C8\";\n}\n\ni.icon.file.word.outline:before {\n  content: \"\\F1C2\";\n}\n\ni.icon.flag.outline:before {\n  content: \"\\F024\";\n}\n\ni.icon.folder.outline:before {\n  content: \"\\F07B\";\n}\n\ni.icon.folder.open.outline:before {\n  content: \"\\F07C\";\n}\n\ni.icon.frown.outline:before {\n  content: \"\\F119\";\n}\n\ni.icon.futbol.outline:before {\n  content: \"\\F1E3\";\n}\n\ni.icon.gem.outline:before {\n  content: \"\\F3A5\";\n}\n\ni.icon.hand.lizard.outline:before {\n  content: \"\\F258\";\n}\n\ni.icon.hand.paper.outline:before {\n  content: \"\\F256\";\n}\n\ni.icon.hand.peace.outline:before {\n  content: \"\\F25B\";\n}\n\ni.icon.hand.point.down.outline:before {\n  content: \"\\F0A7\";\n}\n\ni.icon.hand.point.left.outline:before {\n  content: \"\\F0A5\";\n}\n\ni.icon.hand.point.right.outline:before {\n  content: \"\\F0A4\";\n}\n\ni.icon.hand.point.up.outline:before {\n  content: \"\\F0A6\";\n}\n\ni.icon.hand.pointer.outline:before {\n  content: \"\\F25A\";\n}\n\ni.icon.hand.rock.outline:before {\n  content: \"\\F255\";\n}\n\ni.icon.hand.scissors.outline:before {\n  content: \"\\F257\";\n}\n\ni.icon.hand.spock.outline:before {\n  content: \"\\F259\";\n}\n\ni.icon.handshake.outline:before {\n  content: \"\\F2B5\";\n}\n\ni.icon.hdd.outline:before {\n  content: \"\\F0A0\";\n}\n\ni.icon.heart.outline:before {\n  content: \"\\F004\";\n}\n\ni.icon.hospital.outline:before {\n  content: \"\\F0F8\";\n}\n\ni.icon.hourglass.outline:before {\n  content: \"\\F254\";\n}\n\ni.icon.id.badge.outline:before {\n  content: \"\\F2C1\";\n}\n\ni.icon.id.card.outline:before {\n  content: \"\\F2C2\";\n}\n\ni.icon.image.outline:before {\n  content: \"\\F03E\";\n}\n\ni.icon.images.outline:before {\n  content: \"\\F302\";\n}\n\ni.icon.keyboard.outline:before {\n  content: \"\\F11C\";\n}\n\ni.icon.lemon.outline:before {\n  content: \"\\F094\";\n}\n\ni.icon.life.ring.outline:before {\n  content: \"\\F1CD\";\n}\n\ni.icon.lightbulb.outline:before {\n  content: \"\\F0EB\";\n}\n\ni.icon.list.alternate.outline:before {\n  content: \"\\F022\";\n}\n\ni.icon.map.outline:before {\n  content: \"\\F279\";\n}\n\ni.icon.meh.outline:before {\n  content: \"\\F11A\";\n}\n\ni.icon.minus.square.outline:before {\n  content: \"\\F146\";\n}\n\ni.icon.money.bill.alternate.outline:before {\n  content: \"\\F3D1\";\n}\n\ni.icon.moon.outline:before {\n  content: \"\\F186\";\n}\n\ni.icon.newspaper.outline:before {\n  content: \"\\F1EA\";\n}\n\ni.icon.object.group.outline:before {\n  content: \"\\F247\";\n}\n\ni.icon.object.ungroup.outline:before {\n  content: \"\\F248\";\n}\n\ni.icon.paper.plane.outline:before {\n  content: \"\\F1D8\";\n}\n\ni.icon.pause.circle.outline:before {\n  content: \"\\F28B\";\n}\n\ni.icon.play.circle.outline:before {\n  content: \"\\F144\";\n}\n\ni.icon.plus.square.outline:before {\n  content: \"\\F0FE\";\n}\n\ni.icon.question.circle.outline:before {\n  content: \"\\F059\";\n}\n\ni.icon.registered.outline:before {\n  content: \"\\F25D\";\n}\n\ni.icon.save.outline:before {\n  content: \"\\F0C7\";\n}\n\ni.icon.share.square.outline:before {\n  content: \"\\F14D\";\n}\n\ni.icon.smile.outline:before {\n  content: \"\\F118\";\n}\n\ni.icon.snowflake.outline:before {\n  content: \"\\F2DC\";\n}\n\ni.icon.square.outline:before {\n  content: \"\\F0C8\";\n}\n\ni.icon.star.outline:before {\n  content: \"\\F005\";\n}\n\ni.icon.star.half.outline:before {\n  content: \"\\F089\";\n}\n\ni.icon.sticky.note.outline:before {\n  content: \"\\F249\";\n}\n\ni.icon.stop.circle.outline:before {\n  content: \"\\F28D\";\n}\n\ni.icon.sun.outline:before {\n  content: \"\\F185\";\n}\n\ni.icon.thumbs.down.outline:before {\n  content: \"\\F165\";\n}\n\ni.icon.thumbs.up.outline:before {\n  content: \"\\F164\";\n}\n\ni.icon.times.circle.outline:before {\n  content: \"\\F057\";\n}\n\ni.icon.trash.alternate.outline:before {\n  content: \"\\F2ED\";\n}\n\ni.icon.user.outline:before {\n  content: \"\\F007\";\n}\n\ni.icon.user.circle.outline:before {\n  content: \"\\F2BD\";\n}\n\ni.icon.window.close.outline:before {\n  content: \"\\F410\";\n}\n\ni.icon.window.maximize.outline:before {\n  content: \"\\F2D0\";\n}\n\ni.icon.window.minimize.outline:before {\n  content: \"\\F2D1\";\n}\n\ni.icon.window.restore.outline:before {\n  content: \"\\F2D2\";\n}\n\n/* Outline Aliases */\n\ni.icon.disk.outline:before {\n  content: \"\\F0A0\";\n}\n\ni.icon.heart.empty, i.icon.star.empty {\n  font-family: 'outline-icons';\n}\n\ni.icon.heart.empty:before {\n  content: \"\\F004\";\n}\n\ni.icon.star.empty:before {\n  content: \"\\F089\";\n}\n\n/*******************************\n           Brand Icons\n*******************************/\n\n/* Load & Define Brand Font */\n\n@font-face {\n  font-family: 'brand-icons';\n  src: url(" + __webpack_require__(1509) + ");\n  src: url(" + __webpack_require__(1509) + "?#iefix) format('embedded-opentype'), url(" + __webpack_require__(3649) + ") format('woff2'), url(" + __webpack_require__(3648) + ") format('woff'), url(" + __webpack_require__(3647) + ") format('truetype'), url(" + __webpack_require__(3646) + "#icons) format('svg');\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-decoration: inherit;\n  text-transform: none;\n}\n\n/* Brand Icon Font Family */\n\ni.icon.\\35 00px, i.icon.accessible.icon, i.icon.accusoft, i.icon.adn, i.icon.adversal, i.icon.affiliatetheme, i.icon.algolia, i.icon.amazon, i.icon.amazon.pay, i.icon.amilia, i.icon.android, i.icon.angellist, i.icon.angrycreative, i.icon.angular, i.icon.app.store, i.icon.app.store.ios, i.icon.apper, i.icon.apple, i.icon.apple.pay, i.icon.asymmetrik, i.icon.audible, i.icon.autoprefixer, i.icon.avianex, i.icon.aviato, i.icon.aws, i.icon.bandcamp, i.icon.behance, i.icon.behance.square, i.icon.bimobject, i.icon.bitbucket, i.icon.bitcoin, i.icon.bity, i.icon.black.tie, i.icon.blackberry, i.icon.blogger, i.icon.blogger.b, i.icon.bluetooth, i.icon.bluetooth.b, i.icon.btc, i.icon.buromobelexperte, i.icon.buysellads, i.icon.cc.amazon.pay, i.icon.cc.amex, i.icon.cc.apple.pay, i.icon.cc.diners.club, i.icon.cc.discover, i.icon.cc.jcb, i.icon.cc.mastercard, i.icon.cc.paypal, i.icon.cc.stripe, i.icon.cc.visa, i.icon.centercode, i.icon.chrome, i.icon.cloudscale, i.icon.cloudsmith, i.icon.cloudversify, i.icon.codepen, i.icon.codiepie, i.icon.connectdevelop, i.icon.contao, i.icon.cpanel, i.icon.creative.commons, i.icon.css3, i.icon.css3.alternate, i.icon.cuttlefish, i.icon.d.and.d, i.icon.dashcube, i.icon.delicious, i.icon.deploydog, i.icon.deskpro, i.icon.deviantart, i.icon.digg, i.icon.digital.ocean, i.icon.discord, i.icon.discourse, i.icon.dochub, i.icon.docker, i.icon.draft2digital, i.icon.dribbble, i.icon.dribbble.square, i.icon.dropbox, i.icon.drupal, i.icon.dyalog, i.icon.earlybirds, i.icon.edge, i.icon.elementor, i.icon.ember, i.icon.empire, i.icon.envira, i.icon.erlang, i.icon.ethereum, i.icon.etsy, i.icon.expeditedssl, i.icon.facebook, i.icon.facebook.f, i.icon.facebook.messenger, i.icon.facebook.square, i.icon.firefox, i.icon.first.order, i.icon.firstdraft, i.icon.flickr, i.icon.flipboard, i.icon.fly, i.icon.font.awesome, i.icon.font.awesome.alternate, i.icon.font.awesome.flag, i.icon.fonticons, i.icon.fonticons.fi, i.icon.fort.awesome, i.icon.fort.awesome.alternate, i.icon.forumbee, i.icon.foursquare, i.icon.free.code.camp, i.icon.freebsd, i.icon.get.pocket, i.icon.gg, i.icon.gg.circle, i.icon.git, i.icon.git.square, i.icon.github, i.icon.github.alternate, i.icon.github.square, i.icon.gitkraken, i.icon.gitlab, i.icon.gitter, i.icon.glide, i.icon.glide.g, i.icon.gofore, i.icon.goodreads, i.icon.goodreads.g, i.icon.google, i.icon.google.drive, i.icon.google.play, i.icon.google.plus, i.icon.google.plus.g, i.icon.google.plus.square, i.icon.google.wallet, i.icon.gratipay, i.icon.grav, i.icon.gripfire, i.icon.grunt, i.icon.gulp, i.icon.hacker.news, i.icon.hacker.news.square, i.icon.hips, i.icon.hire.a.helper, i.icon.hooli, i.icon.hotjar, i.icon.houzz, i.icon.html5, i.icon.hubspot, i.icon.imdb, i.icon.instagram, i.icon.internet.explorer, i.icon.ioxhost, i.icon.itunes, i.icon.itunes.note, i.icon.jenkins, i.icon.joget, i.icon.joomla, i.icon.js, i.icon.js.square, i.icon.jsfiddle, i.icon.keycdn, i.icon.kickstarter, i.icon.kickstarter.k, i.icon.korvue, i.icon.laravel, i.icon.lastfm, i.icon.lastfm.square, i.icon.leanpub, i.icon.less, i.icon.linechat, i.icon.linkedin, i.icon.linkedin.alternate, i.icon.linkedin.in, i.icon.linode, i.icon.linux, i.icon.lyft, i.icon.magento, i.icon.maxcdn, i.icon.medapps, i.icon.medium, i.icon.medium.m, i.icon.medrt, i.icon.meetup, i.icon.microsoft, i.icon.mix, i.icon.mixcloud, i.icon.mizuni, i.icon.modx, i.icon.monero, i.icon.napster, i.icon.nintendo.switch, i.icon.node, i.icon.node.js, i.icon.npm, i.icon.ns8, i.icon.nutritionix, i.icon.odnoklassniki, i.icon.odnoklassniki.square, i.icon.opencart, i.icon.openid, i.icon.opera, i.icon.optin.monster, i.icon.osi, i.icon.page4, i.icon.pagelines, i.icon.palfed, i.icon.patreon, i.icon.paypal, i.icon.periscope, i.icon.phabricator, i.icon.phoenix.framework, i.icon.php, i.icon.pied.piper, i.icon.pied.piper.alternate, i.icon.pied.piper.pp, i.icon.pinterest, i.icon.pinterest.p, i.icon.pinterest.square, i.icon.playstation, i.icon.product.hunt, i.icon.pushed, i.icon.python, i.icon.qq, i.icon.quinscape, i.icon.quora, i.icon.ravelry, i.icon.react, i.icon.rebel, i.icon.redriver, i.icon.reddit, i.icon.reddit.alien, i.icon.reddit.square, i.icon.rendact, i.icon.renren, i.icon.replyd, i.icon.resolving, i.icon.rocketchat, i.icon.rockrms, i.icon.safari, i.icon.sass, i.icon.schlix, i.icon.scribd, i.icon.searchengin, i.icon.sellcast, i.icon.sellsy, i.icon.servicestack, i.icon.shirtsinbulk, i.icon.simplybuilt, i.icon.sistrix, i.icon.skyatlas, i.icon.skype, i.icon.slack, i.icon.slack.hash, i.icon.slideshare, i.icon.snapchat, i.icon.snapchat.ghost, i.icon.snapchat.square, i.icon.soundcloud, i.icon.speakap, i.icon.spotify, i.icon.stack.exchange, i.icon.stack.overflow, i.icon.staylinked, i.icon.steam, i.icon.steam.square, i.icon.steam.symbol, i.icon.sticker.mule, i.icon.strava, i.icon.stripe, i.icon.stripe.s, i.icon.studiovinari, i.icon.stumbleupon, i.icon.stumbleupon.circle, i.icon.superpowers, i.icon.supple, i.icon.telegram, i.icon.telegram.plane, i.icon.tencent.weibo, i.icon.themeisle, i.icon.trello, i.icon.tripadvisor, i.icon.tumblr, i.icon.tumblr.square, i.icon.twitch, i.icon.twitter, i.icon.twitter.square, i.icon.typo3, i.icon.uber, i.icon.uikit, i.icon.uniregistry, i.icon.untappd, i.icon.usb, i.icon.ussunnah, i.icon.vaadin, i.icon.viacoin, i.icon.viadeo, i.icon.viadeo.square, i.icon.viber, i.icon.vimeo, i.icon.vimeo.square, i.icon.vimeo.v, i.icon.vine, i.icon.vk, i.icon.vnv, i.icon.vuejs, i.icon.wechat, i.icon.weibo, i.icon.weixin, i.icon.whatsapp, i.icon.whatsapp.square, i.icon.whmcs, i.icon.wikipedia.w, i.icon.windows, i.icon.wordpress, i.icon.wordpress.simple, i.icon.wpbeginner, i.icon.wpexplorer, i.icon.wpforms, i.icon.xbox, i.icon.xing, i.icon.xing.square, i.icon.y.combinator, i.icon.yahoo, i.icon.yandex, i.icon.yandex.international, i.icon.yelp, i.icon.yoast, i.icon.youtube, i.icon.youtube.square {\n  font-family: 'brand-icons';\n}\n\n/* Brand Icons Ideally Would Be Defined Here */\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Image\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Image\n*******************************/\n\n.ui.image {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 100%;\n  background-color: transparent;\n}\n\nimg.ui.image {\n  display: block;\n}\n\n.ui.image svg, .ui.image img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.hidden.images, .ui.hidden.image {\n  display: none;\n}\n\n.ui.hidden.transition.images, .ui.hidden.transition.image {\n  display: block;\n  visibility: hidden;\n}\n\n.ui.images > .hidden.transition {\n  display: inline-block;\n  visibility: hidden;\n}\n\n.ui.disabled.images, .ui.disabled.image {\n  cursor: default;\n  opacity: 0.45;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n     Inline\n---------------*/\n\n.ui.inline.image, .ui.inline.image svg, .ui.inline.image img {\n  display: inline-block;\n}\n\n/*------------------\n  Vertical Aligned\n-------------------*/\n\n.ui.top.aligned.images .image, .ui.top.aligned.image, .ui.top.aligned.image svg, .ui.top.aligned.image img {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.ui.middle.aligned.images .image, .ui.middle.aligned.image, .ui.middle.aligned.image svg, .ui.middle.aligned.image img {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ui.bottom.aligned.images .image, .ui.bottom.aligned.image, .ui.bottom.aligned.image svg, .ui.bottom.aligned.image img {\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n/*--------------\n     Rounded\n---------------*/\n\n.ui.rounded.images .image, .ui.rounded.image, .ui.rounded.images .image > *, .ui.rounded.image > * {\n  border-radius: 0.3125em;\n}\n\n/*--------------\n    Bordered\n---------------*/\n\n.ui.bordered.images .image, .ui.bordered.images img, .ui.bordered.images svg, .ui.bordered.image img, .ui.bordered.image svg, img.ui.bordered.image {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/*--------------\n    Circular\n---------------*/\n\n.ui.circular.images, .ui.circular.image {\n  overflow: hidden;\n}\n\n.ui.circular.images .image, .ui.circular.image, .ui.circular.images .image > *, .ui.circular.image > * {\n  border-radius: 500rem;\n}\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.images, .ui.fluid.image, .ui.fluid.images img, .ui.fluid.images svg, .ui.fluid.image svg, .ui.fluid.image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n/*--------------\n     Avatar\n---------------*/\n\n.ui.avatar.images .image, .ui.avatar.images img, .ui.avatar.images svg, .ui.avatar.image img, .ui.avatar.image svg, .ui.avatar.image {\n  margin-right: 0.25em;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  border-radius: 500rem;\n}\n\n/*-------------------\n       Spaced\n--------------------*/\n\n.ui.spaced.image {\n  display: inline-block !important;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n.ui[class*=\"left spaced\"].image {\n  margin-left: 0.5em;\n  margin-right: 0em;\n}\n\n.ui[class*=\"right spaced\"].image {\n  margin-left: 0em;\n  margin-right: 0.5em;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.image, .ui.floated.images {\n  float: left;\n  margin-right: 1em;\n  margin-bottom: 1em;\n}\n\n.ui.right.floated.images, .ui.right.floated.image {\n  float: right;\n  margin-right: 0em;\n  margin-bottom: 1em;\n  margin-left: 1em;\n}\n\n.ui.floated.images:last-child, .ui.floated.image:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.centered.images, .ui.centered.image {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.images .image, .ui.mini.images img, .ui.mini.images svg, .ui.mini.image {\n  width: 35px;\n  height: auto;\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.images .image, .ui.tiny.images img, .ui.tiny.images svg, .ui.tiny.image {\n  width: 80px;\n  height: auto;\n  font-size: 0.85714286rem;\n}\n\n.ui.small.images .image, .ui.small.images img, .ui.small.images svg, .ui.small.image {\n  width: 150px;\n  height: auto;\n  font-size: 0.92857143rem;\n}\n\n.ui.medium.images .image, .ui.medium.images img, .ui.medium.images svg, .ui.medium.image {\n  width: 300px;\n  height: auto;\n  font-size: 1rem;\n}\n\n.ui.large.images .image, .ui.large.images img, .ui.large.images svg, .ui.large.image {\n  width: 450px;\n  height: auto;\n  font-size: 1.14285714rem;\n}\n\n.ui.big.images .image, .ui.big.images img, .ui.big.images svg, .ui.big.image {\n  width: 600px;\n  height: auto;\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.images .image, .ui.huge.images img, .ui.huge.images svg, .ui.huge.image {\n  width: 800px;\n  height: auto;\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.images .image, .ui.massive.images img, .ui.massive.images svg, .ui.massive.image {\n  width: 960px;\n  height: auto;\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n              Groups\n*******************************/\n\n.ui.images {\n  font-size: 0em;\n  margin: 0em -0.25rem 0rem;\n}\n\n.ui.images .image, .ui.images > img, .ui.images > svg {\n  display: inline-block;\n  margin: 0em 0.25rem 0.5rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Input\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           Standard\n*******************************/\n\n/*--------------------\n        Inputs\n---------------------*/\n\n.ui.input {\n  position: relative;\n  font-weight: normal;\n  font-style: normal;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.input > input {\n  margin: 0em;\n  max-width: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.21428571em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  padding: 0.67857143em 1em;\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0.21428571rem;\n  transition: box-shadow 0.1s ease, border-color 0.1s ease;\n  box-shadow: none;\n}\n\n/*--------------------\n      Placeholder\n---------------------*/\n\n/* browsers require these rules separate */\n\n.ui.input > input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.input > input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.input > input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n        Disabled\n---------------------*/\n\n.ui.disabled.input, .ui.input:not(.disabled) input[disabled] {\n  opacity: 0.45;\n}\n\n.ui.disabled.input > input, .ui.input:not(.disabled) input[disabled] {\n  pointer-events: none;\n}\n\n/*--------------------\n        Active\n---------------------*/\n\n.ui.input > input:active, .ui.input.down input {\n  border-color: rgba(0, 0, 0, 0.3);\n  background: #FAFAFA;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.loading.input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n\n.ui.loading.loading.input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  -webkit-animation: button-spin 0.6s linear;\n  animation: button-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n/*--------------------\n        Focus\n---------------------*/\n\n.ui.input.focus > input, .ui.input > input:focus {\n  border-color: rgba(0, 0, 0, 0.4);\n  background: #FFFFFF;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n}\n\n.ui.input.focus > input::-webkit-input-placeholder, .ui.input > input:focus::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.ui.input.focus > input::-moz-placeholder, .ui.input > input:focus::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.ui.input.focus > input:-ms-input-placeholder, .ui.input > input:focus:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n/*--------------------\n        Error\n---------------------*/\n\n.ui.input.error > input {\n  background-color: #FFF6F6;\n  border-color: #E0B4B4;\n  color: #9F3A38;\n  box-shadow: none;\n}\n\n/* Error Placeholder */\n\n.ui.input.error > input::-webkit-input-placeholder {\n  color: #e7bdbc;\n}\n\n.ui.input.error > input::-moz-placeholder {\n  color: #e7bdbc;\n}\n\n.ui.input.error > input:-ms-input-placeholder {\n  color: #e7bdbc !important;\n}\n\n/* Focused Error Placeholder */\n\n.ui.input.error > input:focus::-webkit-input-placeholder {\n  color: #da9796;\n}\n\n.ui.input.error > input:focus::-moz-placeholder {\n  color: #da9796;\n}\n\n.ui.input.error > input:focus:-ms-input-placeholder {\n  color: #da9796 !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------------\n      Transparent\n---------------------*/\n\n.ui.transparent.input > input {\n  border-color: transparent !important;\n  background-color: transparent !important;\n  padding: 0em !important;\n  box-shadow: none !important;\n  border-radius: 0px !important;\n}\n\n/* Transparent Icon */\n\n.ui.transparent.icon.input > i.icon {\n  width: 1.1em;\n}\n\n.ui.transparent.icon.input > input {\n  padding-left: 0em !important;\n  padding-right: 2em !important;\n}\n\n.ui.transparent[class*=\"left icon\"].input > input {\n  padding-left: 2em !important;\n  padding-right: 0em !important;\n}\n\n/* Transparent Inverted */\n\n.ui.transparent.inverted.input {\n  color: #FFFFFF;\n}\n\n.ui.transparent.inverted.input > input {\n  color: inherit;\n}\n\n.ui.transparent.inverted.input > input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ui.transparent.inverted.input > input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ui.transparent.inverted.input > input:-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/*--------------------\n         Icon\n---------------------*/\n\n.ui.icon.input > i.icon {\n  cursor: default;\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  top: 0px;\n  right: 0px;\n  margin: 0em;\n  height: 100%;\n  width: 2.67142857em;\n  opacity: 0.5;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n  transition: opacity 0.3s ease;\n}\n\n.ui.icon.input > i.icon:not(.link) {\n  pointer-events: none;\n}\n\n.ui.icon.input > input {\n  padding-right: 2.67142857em !important;\n}\n\n.ui.icon.input > i.icon:before, .ui.icon.input > i.icon:after {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 100%;\n  margin-top: -0.5em;\n}\n\n.ui.icon.input > i.link.icon {\n  cursor: pointer;\n}\n\n.ui.icon.input > i.circular.icon {\n  top: 0.35em;\n  right: 0.5em;\n}\n\n/* Left Icon Input */\n\n.ui[class*=\"left icon\"].input > i.icon {\n  right: auto;\n  left: 1px;\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n.ui[class*=\"left icon\"].input > i.circular.icon {\n  right: auto;\n  left: 0.5em;\n}\n\n.ui[class*=\"left icon\"].input > input {\n  padding-left: 2.67142857em !important;\n  padding-right: 1em !important;\n}\n\n/* Focus */\n\n.ui.icon.input > input:focus ~ i.icon {\n  opacity: 1;\n}\n\n/*--------------------\n        Labeled\n---------------------*/\n\n/* Adjacent Label */\n\n.ui.labeled.input > .label {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  margin: 0;\n  font-size: 1em;\n}\n\n.ui.labeled.input > .label:not(.corner) {\n  padding-top: 0.78571429em;\n  padding-bottom: 0.78571429em;\n}\n\n/* Regular Label on Left */\n\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-left-color: transparent;\n}\n\n.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input:focus {\n  border-left-color: rgba(0, 0, 0, 0.4);\n}\n\n/* Regular Label on Right */\n\n.ui[class*=\"right labeled\"].input > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n\n.ui[class*=\"right labeled\"].input > input + .label {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.ui[class*=\"right labeled\"].input > input:focus {\n  border-right-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Corner Label */\n\n.ui.labeled.input .corner.label {\n  top: 1px;\n  right: 1px;\n  font-size: 0.64285714em;\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n/* Spacing with corner label */\n\n.ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input > input {\n  padding-right: 2.5em !important;\n}\n\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > input {\n  padding-right: 3.25em !important;\n}\n\n.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > .icon {\n  margin-right: 1.25em;\n}\n\n/* Left Labeled */\n\n.ui[class*=\"left corner labeled\"].labeled.input > input {\n  padding-left: 2.5em !important;\n}\n\n.ui[class*=\"left corner labeled\"].icon.input > input {\n  padding-left: 3.25em !important;\n}\n\n.ui[class*=\"left corner labeled\"].icon.input > .icon {\n  margin-left: 1.25em;\n}\n\n/* Corner Label Position  */\n\n.ui.input > .ui.corner.label {\n  top: 1px;\n  right: 1px;\n}\n\n.ui.input > .ui.left.corner.label {\n  right: auto;\n  left: 1px;\n}\n\n/*--------------------\n        Action\n---------------------*/\n\n.ui.action.input > .button, .ui.action.input > .buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.ui.action.input > .button, .ui.action.input > .buttons > .button {\n  padding-top: 0.78571429em;\n  padding-bottom: 0.78571429em;\n  margin: 0;\n}\n\n/* Button on Right */\n\n.ui.action.input:not([class*=\"left action\"]) > input {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-right-color: transparent !important;\n}\n\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:not(:first-child), .ui.action.input:not([class*=\"left action\"]) > .button:not(:first-child), .ui.action.input:not([class*=\"left action\"]) > .buttons:not(:first-child) > .button {\n  border-radius: 0px;\n}\n\n.ui.action.input:not([class*=\"left action\"]) > .dropdown:last-child, .ui.action.input:not([class*=\"left action\"]) > .button:last-child, .ui.action.input:not([class*=\"left action\"]) > .buttons:last-child > .button {\n  border-radius: 0px 0.21428571rem 0.21428571rem 0px;\n}\n\n/* Input Focus */\n\n.ui.action.input:not([class*=\"left action\"]) > input:focus {\n  border-right-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n/* Button on Left */\n\n.ui[class*=\"left action\"].input > input {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  border-left-color: transparent !important;\n}\n\n.ui[class*=\"left action\"].input > .dropdown, .ui[class*=\"left action\"].input > .button, .ui[class*=\"left action\"].input > .buttons > .button {\n  border-radius: 0px;\n}\n\n.ui[class*=\"left action\"].input > .dropdown:first-child, .ui[class*=\"left action\"].input > .button:first-child, .ui[class*=\"left action\"].input > .buttons:first-child > .button {\n  border-radius: 0.21428571rem 0px 0px 0.21428571rem;\n}\n\n/* Input Focus */\n\n.ui[class*=\"left action\"].input > input:focus {\n  border-left-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n/*--------------------\n       Inverted\n---------------------*/\n\n/* Standard */\n\n.ui.inverted.input > input {\n  border: none;\n}\n\n/*--------------------\n        Fluid\n---------------------*/\n\n.ui.fluid.input {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.ui.fluid.input > input {\n  width: 0px !important;\n}\n\n/*--------------------\n        Size\n---------------------*/\n\n.ui.mini.input {\n  font-size: 0.78571429em;\n}\n\n.ui.small.input {\n  font-size: 0.92857143em;\n}\n\n.ui.input {\n  font-size: 1em;\n}\n\n.ui.large.input {\n  font-size: 1.14285714em;\n}\n\n.ui.big.input {\n  font-size: 1.28571429em;\n}\n\n.ui.huge.input {\n  font-size: 1.42857143em;\n}\n\n.ui.massive.input {\n  font-size: 1.71428571em;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Label\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Label\n*******************************/\n\n.ui.label {\n  display: inline-block;\n  line-height: 1;\n  vertical-align: baseline;\n  margin: 0em 0.14285714em;\n  background-color: #E8E8E8;\n  background-image: none;\n  padding: 0.5833em 0.833em;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: none;\n  font-weight: bold;\n  border: 0px solid transparent;\n  border-radius: 0.21428571rem;\n  transition: background 0.1s ease;\n}\n\n.ui.label:first-child {\n  margin-left: 0em;\n}\n\n.ui.label:last-child {\n  margin-right: 0em;\n}\n\n/* Link */\n\na.ui.label {\n  cursor: pointer;\n}\n\n/* Inside Link */\n\n.ui.label > a {\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.5;\n  transition: 0.1s opacity ease;\n}\n\n.ui.label > a:hover {\n  opacity: 1;\n}\n\n/* Image */\n\n.ui.label > img {\n  width: auto !important;\n  vertical-align: middle;\n  height: 2.1666em !important;\n}\n\n/* Icon */\n\n.ui.label > .icon {\n  width: auto;\n  margin: 0em 0.75em 0em 0em;\n}\n\n/* Detail */\n\n.ui.label > .detail {\n  display: inline-block;\n  vertical-align: top;\n  font-weight: bold;\n  margin-left: 1em;\n  opacity: 0.8;\n}\n\n.ui.label > .detail .icon {\n  margin: 0em 0.25em 0em 0em;\n}\n\n/* Removable label */\n\n.ui.label > .close.icon, .ui.label > .delete.icon {\n  cursor: pointer;\n  margin-right: 0em;\n  margin-left: 0.5em;\n  font-size: 0.92857143em;\n  opacity: 0.5;\n  transition: background 0.1s ease;\n}\n\n.ui.label > .delete.icon:hover {\n  opacity: 1;\n}\n\n/*-------------------\n       Group\n--------------------*/\n\n.ui.labels > .label {\n  margin: 0em 0.5em 0.5em 0em;\n}\n\n/*-------------------\n       Coupling\n--------------------*/\n\n.ui.header > .ui.label {\n  margin-top: -0.29165em;\n}\n\n/* Remove border radius on attached segment */\n\n.ui.attached.segment > .ui.top.left.attached.label, .ui.bottom.attached.segment > .ui.top.left.attached.label {\n  border-top-left-radius: 0;\n}\n\n.ui.attached.segment > .ui.top.right.attached.label, .ui.bottom.attached.segment > .ui.top.right.attached.label {\n  border-top-right-radius: 0;\n}\n\n.ui.top.attached.segment > .ui.bottom.left.attached.label {\n  border-bottom-left-radius: 0;\n}\n\n.ui.top.attached.segment > .ui.bottom.right.attached.label {\n  border-bottom-right-radius: 0;\n}\n\n/* Padding on next content after a label */\n\n.ui.top.attached.label:first-child + :not(.attached), .ui.top.attached.label + [class*=\"right floated\"] + * {\n  margin-top: 2rem !important;\n}\n\n.ui.bottom.attached.label:first-child ~ :last-child:not(.attached) {\n  margin-top: 0em;\n  margin-bottom: 2rem !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n.ui.image.label {\n  width: auto !important;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  max-width: 9999px;\n  vertical-align: baseline;\n  text-transform: none;\n  background: #E8E8E8;\n  padding: 0.5833em 0.833em 0.5833em 0.5em;\n  border-radius: 0.21428571rem;\n  box-shadow: none;\n}\n\n.ui.image.label img {\n  display: inline-block;\n  vertical-align: top;\n  height: 2.1666em;\n  margin: -0.5833em 0.5em -0.5833em -0.5em;\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n.ui.image.label .detail {\n  background: rgba(0, 0, 0, 0.1);\n  margin: -0.5833em -0.833em -0.5833em 0.5em;\n  padding: 0.5833em 0.833em;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n/*-------------------\n         Tag\n--------------------*/\n\n.ui.tag.labels .label, .ui.tag.label {\n  margin-left: 1em;\n  position: relative;\n  padding-left: 1.5em;\n  padding-right: 1.5em;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n  transition: none;\n}\n\n.ui.tag.labels .label:before, .ui.tag.label:before {\n  position: absolute;\n  -webkit-transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  top: 50%;\n  right: 100%;\n  content: '';\n  background-color: inherit;\n  background-image: none;\n  width: 1.56em;\n  height: 1.56em;\n  transition: none;\n}\n\n.ui.tag.labels .label:after, .ui.tag.label:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: -0.25em;\n  margin-top: -0.25em;\n  background-color: #FFFFFF !important;\n  width: 0.5em;\n  height: 0.5em;\n  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 500rem;\n}\n\n/*-------------------\n    Corner Label\n--------------------*/\n\n.ui.corner.label {\n  position: absolute;\n  top: 0em;\n  right: 0em;\n  margin: 0em;\n  padding: 0em;\n  text-align: center;\n  border-color: #E8E8E8;\n  width: 4em;\n  height: 4em;\n  z-index: 1;\n  transition: border-color 0.1s ease;\n}\n\n/* Icon Label */\n\n.ui.corner.label {\n  background-color: transparent !important;\n}\n\n.ui.corner.label:after {\n  position: absolute;\n  content: \"\";\n  right: 0em;\n  top: 0em;\n  z-index: -1;\n  width: 0em;\n  height: 0em;\n  background-color: transparent !important;\n  border-top: 0em solid transparent;\n  border-right: 4em solid transparent;\n  border-bottom: 4em solid transparent;\n  border-left: 0em solid transparent;\n  border-right-color: inherit;\n  transition: border-color 0.1s ease;\n}\n\n.ui.corner.label .icon {\n  cursor: default;\n  position: relative;\n  top: 0.64285714em;\n  left: 0.78571429em;\n  font-size: 1.14285714em;\n  margin: 0em;\n}\n\n/* Left Corner */\n\n.ui.left.corner.label, .ui.left.corner.label:after {\n  right: auto;\n  left: 0em;\n}\n\n.ui.left.corner.label:after {\n  border-top: 4em solid transparent;\n  border-right: 4em solid transparent;\n  border-bottom: 0em solid transparent;\n  border-left: 0em solid transparent;\n  border-top-color: inherit;\n}\n\n.ui.left.corner.label .icon {\n  left: -0.78571429em;\n}\n\n/* Segment */\n\n.ui.segment > .ui.corner.label {\n  top: -1px;\n  right: -1px;\n}\n\n.ui.segment > .ui.left.corner.label {\n  right: auto;\n  left: -1px;\n}\n\n/*-------------------\n       Ribbon\n--------------------*/\n\n.ui.ribbon.label {\n  position: relative;\n  margin: 0em;\n  min-width: -webkit-max-content;\n  min-width: -moz-max-content;\n  min-width: max-content;\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n\n.ui.ribbon.label:after {\n  position: absolute;\n  content: '';\n  top: 100%;\n  left: 0%;\n  background-color: transparent !important;\n  border-style: solid;\n  border-width: 0em 1.2em 1.2em 0em;\n  border-color: transparent;\n  border-right-color: inherit;\n  width: 0em;\n  height: 0em;\n}\n\n/* Positioning */\n\n.ui.ribbon.label {\n  left: calc(-1rem - 1.2em);\n  margin-right: -1.2em;\n  padding-left: calc(1rem + 1.2em);\n  padding-right: 1.2em;\n}\n\n.ui[class*=\"right ribbon\"].label {\n  left: calc(100% + 1rem + 1.2em);\n  padding-left: 1.2em;\n  padding-right: calc(1rem + 1.2em);\n}\n\n/* Right Ribbon */\n\n.ui[class*=\"right ribbon\"].label {\n  text-align: left;\n  -webkit-transform: translateX(-100%);\n  transform: translateX(-100%);\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n.ui[class*=\"right ribbon\"].label:after {\n  left: auto;\n  right: 0%;\n  border-style: solid;\n  border-width: 1.2em 1.2em 0em 0em;\n  border-color: transparent;\n  border-top-color: inherit;\n}\n\n/* Inside Table */\n\n.ui.image > .ribbon.label, .ui.card .image > .ribbon.label {\n  position: absolute;\n  top: 1rem;\n}\n\n.ui.card .image > .ui.ribbon.label, .ui.image > .ui.ribbon.label {\n  left: calc(--0.05rem - 1.2em);\n}\n\n.ui.card .image > .ui[class*=\"right ribbon\"].label, .ui.image > .ui[class*=\"right ribbon\"].label {\n  left: calc(100% + -0.05rem + 1.2em);\n  padding-left: 0.833em;\n}\n\n/* Inside Table */\n\n.ui.table td > .ui.ribbon.label {\n  left: calc(-0.78571429em - 1.2em);\n}\n\n.ui.table td > .ui[class*=\"right ribbon\"].label {\n  left: calc(100% + 0.78571429em + 1.2em);\n  padding-left: 0.833em;\n}\n\n/*-------------------\n      Attached\n--------------------*/\n\n.ui[class*=\"top attached\"].label, .ui.attached.label {\n  width: 100%;\n  position: absolute;\n  margin: 0em;\n  top: 0em;\n  left: 0em;\n  padding: 0.75em 1em;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui[class*=\"bottom attached\"].label {\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui[class*=\"top left attached\"].label {\n  width: auto;\n  margin-top: 0em !important;\n  border-radius: 0.21428571rem 0em 0.21428571rem 0em;\n}\n\n.ui[class*=\"top right attached\"].label {\n  width: auto;\n  left: auto;\n  right: 0em;\n  border-radius: 0em 0.21428571rem 0em 0.21428571rem;\n}\n\n.ui[class*=\"bottom left attached\"].label {\n  width: auto;\n  top: auto;\n  bottom: 0em;\n  border-radius: 0em 0.21428571rem 0em 0.21428571rem;\n}\n\n.ui[class*=\"bottom right attached\"].label {\n  top: auto;\n  bottom: 0em;\n  left: auto;\n  right: 0em;\n  width: auto;\n  border-radius: 0.21428571rem 0em 0.21428571rem 0em;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n      Disabled\n--------------------*/\n\n.ui.label.disabled {\n  opacity: 0.5;\n}\n\n/*-------------------\n        Hover\n--------------------*/\n\na.ui.labels .label:hover, a.ui.label:hover {\n  background-color: #E0E0E0;\n  border-color: #E0E0E0;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.labels a.label:hover:before, a.ui.label:hover:before {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*-------------------\n        Active\n--------------------*/\n\n.ui.active.label {\n  background-color: #D0D0D0;\n  border-color: #D0D0D0;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.active.label:before {\n  background-color: #D0D0D0;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*-------------------\n     Active Hover\n--------------------*/\n\na.ui.labels .active.label:hover, a.ui.active.label:hover {\n  background-color: #C8C8C8;\n  border-color: #C8C8C8;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.labels a.active.label:ActiveHover:before, a.ui.active.label:ActiveHover:before {\n  background-color: #C8C8C8;\n  background-image: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*-------------------\n      Visible\n--------------------*/\n\n.ui.labels.visible .label, .ui.label.visible:not(.dropdown) {\n  display: inline-block !important;\n}\n\n/*-------------------\n      Hidden\n--------------------*/\n\n.ui.labels.hidden .label, .ui.label.hidden {\n  display: none !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Colors\n--------------------*/\n\n/*--- Red ---*/\n\n.ui.red.labels .label, .ui.red.label {\n  background-color: #DB2828 !important;\n  border-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.red.labels .label:hover, a.ui.red.label:hover {\n  background-color: #d01919 !important;\n  border-color: #d01919 !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.red.corner.label, .ui.red.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.red.ribbon.label {\n  border-color: #b21e1e !important;\n}\n\n/* Basic */\n\n.ui.basic.red.label {\n  background: none #FFFFFF !important;\n  color: #DB2828 !important;\n  border-color: #DB2828 !important;\n}\n\n.ui.basic.red.labels a.label:hover, a.ui.basic.red.label:hover {\n  background-color: #FFFFFF !important;\n  color: #d01919 !important;\n  border-color: #d01919 !important;\n}\n\n/*--- Orange ---*/\n\n.ui.orange.labels .label, .ui.orange.label {\n  background-color: #FF9F5B !important;\n  border-color: #FF9F5B !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.orange.labels .label:hover, a.ui.orange.label:hover {\n  background-color: #ff9042 !important;\n  border-color: #ff9042 !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.orange.corner.label, .ui.orange.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.orange.ribbon.label {\n  border-color: #ff8128 !important;\n}\n\n/* Basic */\n\n.ui.basic.orange.label {\n  background: none #FFFFFF !important;\n  color: #FF9F5B !important;\n  border-color: #FF9F5B !important;\n}\n\n.ui.basic.orange.labels a.label:hover, a.ui.basic.orange.label:hover {\n  background-color: #FFFFFF !important;\n  color: #ff9042 !important;\n  border-color: #ff9042 !important;\n}\n\n/*--- Yellow ---*/\n\n.ui.yellow.labels .label, .ui.yellow.label {\n  background-color: #F9DC5C !important;\n  border-color: #F9DC5C !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.yellow.labels .label:hover, a.ui.yellow.label:hover {\n  background-color: #ffdb3c !important;\n  border-color: #ffdb3c !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.yellow.corner.label, .ui.yellow.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.yellow.ribbon.label {\n  border-color: #f7d12b !important;\n}\n\n/* Basic */\n\n.ui.basic.yellow.label {\n  background: none #FFFFFF !important;\n  color: #F9DC5C !important;\n  border-color: #F9DC5C !important;\n}\n\n.ui.basic.yellow.labels a.label:hover, a.ui.basic.yellow.label:hover {\n  background-color: #FFFFFF !important;\n  color: #ffdb3c !important;\n  border-color: #ffdb3c !important;\n}\n\n/*--- Olive ---*/\n\n.ui.olive.labels .label, .ui.olive.label {\n  background-color: #B5CC18 !important;\n  border-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.olive.labels .label:hover, a.ui.olive.label:hover {\n  background-color: #a7bd0d !important;\n  border-color: #a7bd0d !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.olive.corner.label, .ui.olive.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.olive.ribbon.label {\n  border-color: #30d071 !important;\n}\n\n/* Basic */\n\n.ui.basic.olive.label {\n  background: none #FFFFFF !important;\n  color: #B5CC18 !important;\n  border-color: #B5CC18 !important;\n}\n\n.ui.basic.olive.labels a.label:hover, a.ui.basic.olive.label:hover {\n  background-color: #FFFFFF !important;\n  color: #a7bd0d !important;\n  border-color: #a7bd0d !important;\n}\n\n/*--- Green ---*/\n\n.ui.green.labels .label, .ui.green.label {\n  background-color: #59D98D !important;\n  border-color: #59D98D !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.green.labels .label:hover, a.ui.green.label:hover {\n  background-color: #3ddb7d !important;\n  border-color: #3ddb7d !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.green.corner.label, .ui.green.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.green.ribbon.label {\n  border-color: #30d071 !important;\n}\n\n/* Basic */\n\n.ui.basic.green.label {\n  background: none #FFFFFF !important;\n  color: #59D98D !important;\n  border-color: #59D98D !important;\n}\n\n.ui.basic.green.labels a.label:hover, a.ui.basic.green.label:hover {\n  background-color: #FFFFFF !important;\n  color: #3ddb7d !important;\n  border-color: #3ddb7d !important;\n}\n\n/*--- Teal ---*/\n\n.ui.teal.labels .label, .ui.teal.label {\n  background-color: #00B5AD !important;\n  border-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.teal.labels .label:hover, a.ui.teal.label:hover {\n  background-color: #009c95 !important;\n  border-color: #009c95 !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.teal.corner.label, .ui.teal.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.teal.ribbon.label {\n  border-color: #00827c !important;\n}\n\n/* Basic */\n\n.ui.basic.teal.label {\n  background: none #FFFFFF !important;\n  color: #00B5AD !important;\n  border-color: #00B5AD !important;\n}\n\n.ui.basic.teal.labels a.label:hover, a.ui.basic.teal.label:hover {\n  background-color: #FFFFFF !important;\n  color: #009c95 !important;\n  border-color: #009c95 !important;\n}\n\n/*--- Blue ---*/\n\n.ui.blue.labels .label, .ui.blue.label {\n  background-color: #2185D0 !important;\n  border-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.blue.labels .label:hover, a.ui.blue.label:hover {\n  background-color: #1678c2 !important;\n  border-color: #1678c2 !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.blue.corner.label, .ui.blue.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.blue.ribbon.label {\n  border-color: #1a69a4 !important;\n}\n\n/* Basic */\n\n.ui.basic.blue.label {\n  background: none #FFFFFF !important;\n  color: #2185D0 !important;\n  border-color: #2185D0 !important;\n}\n\n.ui.basic.blue.labels a.label:hover, a.ui.basic.blue.label:hover {\n  background-color: #FFFFFF !important;\n  color: #1678c2 !important;\n  border-color: #1678c2 !important;\n}\n\n/*--- Violet ---*/\n\n.ui.violet.labels .label, .ui.violet.label {\n  background-color: #6435C9 !important;\n  border-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.violet.labels .label:hover, a.ui.violet.label:hover {\n  background-color: #5829bb !important;\n  border-color: #5829bb !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.violet.corner.label, .ui.violet.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.violet.ribbon.label {\n  border-color: #502aa1 !important;\n}\n\n/* Basic */\n\n.ui.basic.violet.label {\n  background: none #FFFFFF !important;\n  color: #6435C9 !important;\n  border-color: #6435C9 !important;\n}\n\n.ui.basic.violet.labels a.label:hover, a.ui.basic.violet.label:hover {\n  background-color: #FFFFFF !important;\n  color: #5829bb !important;\n  border-color: #5829bb !important;\n}\n\n/*--- Purple ---*/\n\n.ui.purple.labels .label, .ui.purple.label {\n  background-color: #A333C8 !important;\n  border-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.purple.labels .label:hover, a.ui.purple.label:hover {\n  background-color: #9627ba !important;\n  border-color: #9627ba !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.purple.corner.label, .ui.purple.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.purple.ribbon.label {\n  border-color: #82299f !important;\n}\n\n/* Basic */\n\n.ui.basic.purple.label {\n  background: none #FFFFFF !important;\n  color: #A333C8 !important;\n  border-color: #A333C8 !important;\n}\n\n.ui.basic.purple.labels a.label:hover, a.ui.basic.purple.label:hover {\n  background-color: #FFFFFF !important;\n  color: #9627ba !important;\n  border-color: #9627ba !important;\n}\n\n/*--- Pink ---*/\n\n.ui.pink.labels .label, .ui.pink.label {\n  background-color: #E03997 !important;\n  border-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.pink.labels .label:hover, a.ui.pink.label:hover {\n  background-color: #e61a8d !important;\n  border-color: #e61a8d !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.pink.corner.label, .ui.pink.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.pink.ribbon.label {\n  border-color: #c71f7e !important;\n}\n\n/* Basic */\n\n.ui.basic.pink.label {\n  background: none #FFFFFF !important;\n  color: #E03997 !important;\n  border-color: #E03997 !important;\n}\n\n.ui.basic.pink.labels a.label:hover, a.ui.basic.pink.label:hover {\n  background-color: #FFFFFF !important;\n  color: #e61a8d !important;\n  border-color: #e61a8d !important;\n}\n\n/*--- Brown ---*/\n\n.ui.brown.labels .label, .ui.brown.label {\n  background-color: #A5673F !important;\n  border-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.brown.labels .label:hover, a.ui.brown.label:hover {\n  background-color: #975b33 !important;\n  border-color: #975b33 !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.brown.corner.label, .ui.brown.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.brown.ribbon.label {\n  border-color: #805031 !important;\n}\n\n/* Basic */\n\n.ui.basic.brown.label {\n  background: none #FFFFFF !important;\n  color: #A5673F !important;\n  border-color: #A5673F !important;\n}\n\n.ui.basic.brown.labels a.label:hover, a.ui.basic.brown.label:hover {\n  background-color: #FFFFFF !important;\n  color: #975b33 !important;\n  border-color: #975b33 !important;\n}\n\n/*--- Grey ---*/\n\n.ui.grey.labels .label, .ui.grey.label {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n  border-color: rgba(0, 0, 0, 0.4) !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.grey.labels .label:hover, a.ui.grey.label:hover {\n  background-color: rgba(13, 13, 13, 0.4) !important;\n  border-color: rgba(13, 13, 13, 0.4) !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.grey.corner.label, .ui.grey.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.grey.ribbon.label {\n  border-color: #805031 !important;\n}\n\n/* Basic */\n\n.ui.basic.grey.label {\n  background: none #FFFFFF !important;\n  color: rgba(0, 0, 0, 0.4) !important;\n  border-color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.ui.basic.grey.labels a.label:hover, a.ui.basic.grey.label:hover {\n  background-color: #FFFFFF !important;\n  color: rgba(13, 13, 13, 0.4) !important;\n  border-color: rgba(13, 13, 13, 0.4) !important;\n}\n\n/*--- Black ---*/\n\n.ui.black.labels .label, .ui.black.label {\n  background-color: #1B1C1D !important;\n  border-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n\n/* Link */\n\n.ui.black.labels .label:hover, a.ui.black.label:hover {\n  background-color: #27292a !important;\n  border-color: #27292a !important;\n  color: #FFFFFF !important;\n}\n\n/* Corner */\n\n.ui.black.corner.label, .ui.black.corner.label:hover {\n  background-color: transparent !important;\n}\n\n/* Ribbon */\n\n.ui.black.ribbon.label {\n  border-color: #805031 !important;\n}\n\n/* Basic */\n\n.ui.basic.black.label {\n  background: none #FFFFFF !important;\n  color: #1B1C1D !important;\n  border-color: #1B1C1D !important;\n}\n\n.ui.basic.black.labels a.label:hover, a.ui.basic.black.label:hover {\n  background-color: #FFFFFF !important;\n  color: #27292a !important;\n  border-color: #27292a !important;\n}\n\n/*-------------------\n        Basic\n--------------------*/\n\n.ui.basic.label {\n  background: none #FFFFFF;\n  border: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n}\n\n/* Link */\n\na.ui.basic.label:hover {\n  text-decoration: none;\n  background: none #FFFFFF;\n  color: #ff8127;\n  box-shadow: 1px solid #DEDEDF;\n  box-shadow: none;\n}\n\n/* Pointing */\n\n.ui.basic.pointing.label:before {\n  border-color: inherit;\n}\n\n/*-------------------\n       Fluid\n--------------------*/\n\n.ui.label.fluid, .ui.fluid.labels > .label {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.labels .label, .ui.inverted.label {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n/*-------------------\n     Horizontal\n--------------------*/\n\n.ui.horizontal.labels .label, .ui.horizontal.label {\n  margin: 0em 0.5em 0em 0em;\n  padding: 0.4em 0.833em;\n  min-width: 3em;\n  text-align: center;\n}\n\n/*-------------------\n       Circular\n--------------------*/\n\n.ui.circular.labels .label, .ui.circular.label {\n  min-width: 2em;\n  min-height: 2em;\n  padding: 0.5em !important;\n  line-height: 1em;\n  text-align: center;\n  border-radius: 500rem;\n}\n\n.ui.empty.circular.labels .label, .ui.empty.circular.label {\n  min-width: 0em;\n  min-height: 0em;\n  overflow: hidden;\n  width: 0.5em;\n  height: 0.5em;\n  vertical-align: baseline;\n}\n\n/*-------------------\n       Pointing\n--------------------*/\n\n.ui.pointing.label {\n  position: relative;\n}\n\n.ui.attached.pointing.label {\n  position: absolute;\n}\n\n.ui.pointing.label:before {\n  background-color: inherit;\n  background-image: inherit;\n  border-width: none;\n  border-style: solid;\n  border-color: inherit;\n}\n\n/* Arrow */\n\n.ui.pointing.label:before {\n  position: absolute;\n  content: '';\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  background-image: none;\n  z-index: 2;\n  width: 0.6666em;\n  height: 0.6666em;\n  transition: background 0.1s ease;\n}\n\n/*--- Above ---*/\n\n.ui.pointing.label, .ui[class*=\"pointing above\"].label {\n  margin-top: 1em;\n}\n\n.ui.pointing.label:before, .ui[class*=\"pointing above\"].label:before {\n  border-width: 1px 0px 0px 1px;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 0%;\n  left: 50%;\n}\n\n/*--- Below ---*/\n\n.ui[class*=\"bottom pointing\"].label, .ui[class*=\"pointing below\"].label {\n  margin-top: 0em;\n  margin-bottom: 1em;\n}\n\n.ui[class*=\"bottom pointing\"].label:before, .ui[class*=\"pointing below\"].label:before {\n  border-width: 0px 1px 1px 0px;\n  top: auto;\n  right: auto;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  top: 100%;\n  left: 50%;\n}\n\n/*--- Left ---*/\n\n.ui[class*=\"left pointing\"].label {\n  margin-top: 0em;\n  margin-left: 0.6666em;\n}\n\n.ui[class*=\"left pointing\"].label:before {\n  border-width: 0px 0px 1px 1px;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n\n/*--- Right ---*/\n\n.ui[class*=\"right pointing\"].label {\n  margin-top: 0em;\n  margin-right: 0.6666em;\n}\n\n.ui[class*=\"right pointing\"].label:before {\n  border-width: 1px 1px 0px 0px;\n  -webkit-transform: translateX(50%) translateY(-50%) rotate(45deg);\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n}\n\n/* Basic Pointing */\n\n/*--- Above ---*/\n\n.ui.basic.pointing.label:before, .ui.basic[class*=\"pointing above\"].label:before {\n  margin-top: -1px;\n}\n\n/*--- Below ---*/\n\n.ui.basic[class*=\"bottom pointing\"].label:before, .ui.basic[class*=\"pointing below\"].label:before {\n  bottom: auto;\n  top: 100%;\n  margin-top: 1px;\n}\n\n/*--- Left ---*/\n\n.ui.basic[class*=\"left pointing\"].label:before {\n  top: 50%;\n  left: -1px;\n}\n\n/*--- Right ---*/\n\n.ui.basic[class*=\"right pointing\"].label:before {\n  top: 50%;\n  right: -1px;\n}\n\n/*------------------\n   Floating Label\n-------------------*/\n\n.ui.floating.label {\n  position: absolute;\n  z-index: 100;\n  top: -1em;\n  left: 100%;\n  margin: 0em 0em 0em -1.5em !important;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.labels .label, .ui.mini.label {\n  font-size: 0.64285714rem;\n}\n\n.ui.tiny.labels .label, .ui.tiny.label {\n  font-size: 0.71428571rem;\n}\n\n.ui.small.labels .label, .ui.small.label {\n  font-size: 0.78571429rem;\n}\n\n.ui.labels .label, .ui.label {\n  font-size: 0.85714286rem;\n}\n\n.ui.large.labels .label, .ui.large.label {\n  font-size: 1rem;\n}\n\n.ui.big.labels .label, .ui.big.label {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.labels .label, .ui.huge.label {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.labels .label, .ui.massive.label {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - List\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            List\n*******************************/\n\nul.ui.list, ol.ui.list, .ui.list {\n  list-style-type: none;\n  margin: 1em 0em;\n  padding: 0em 0em;\n}\n\nul.ui.list:first-child, ol.ui.list:first-child, .ui.list:first-child {\n  margin-top: 0em;\n  padding-top: 0em;\n}\n\nul.ui.list:last-child, ol.ui.list:last-child, .ui.list:last-child {\n  margin-bottom: 0em;\n  padding-bottom: 0em;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* List Item */\n\nul.ui.list li, ol.ui.list li, .ui.list > .item, .ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  list-style-type: none;\n  list-style-position: outside;\n  padding: 0.21428571em 0em;\n  line-height: 1.14285714em;\n}\n\nul.ui.list > li:first-child:after, ol.ui.list > li:first-child:after, .ui.list > .list > .item, .ui.list > .item:after {\n  content: '';\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\nul.ui.list li:first-child, ol.ui.list li:first-child, .ui.list .list > .item:first-child, .ui.list > .item:first-child {\n  padding-top: 0em;\n}\n\nul.ui.list li:last-child, ol.ui.list li:last-child, .ui.list .list > .item:last-child, .ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n\n/* Child List */\n\nul.ui.list ul, ol.ui.list ol, .ui.list .list {\n  clear: both;\n  margin: 0em;\n  padding: 0.75em 0em 0.25em 0.5em;\n}\n\n/* Child Item */\n\nul.ui.list ul li, ol.ui.list ol li, .ui.list .list > .item {\n  padding: 0.14285714em 0em;\n  line-height: inherit;\n}\n\n/* Icon */\n\n.ui.list .list > .item > i.icon, .ui.list > .item > i.icon {\n  display: table-cell;\n  margin: 0em;\n  padding-top: 0em;\n  padding-right: 0.28571429em;\n  vertical-align: top;\n  transition: color 0.1s ease;\n}\n\n.ui.list .list > .item > i.icon:only-child, .ui.list > .item > i.icon:only-child {\n  display: inline-block;\n  vertical-align: top;\n}\n\n/* Image */\n\n.ui.list .list > .item > .image, .ui.list > .item > .image {\n  display: table-cell;\n  background-color: transparent;\n  margin: 0em;\n  vertical-align: top;\n}\n\n.ui.list .list > .item > .image:not(:only-child):not(img), .ui.list > .item > .image:not(:only-child):not(img) {\n  padding-right: 0.5em;\n}\n\n.ui.list .list > .item > .image img, .ui.list > .item > .image img {\n  vertical-align: top;\n}\n\n.ui.list .list > .item > img.image, .ui.list .list > .item > .image:only-child, .ui.list > .item > img.image, .ui.list > .item > .image:only-child {\n  display: inline-block;\n}\n\n/* Content */\n\n.ui.list .list > .item > .content, .ui.list > .item > .content {\n  line-height: 1.14285714em;\n}\n\n.ui.list .list > .item > .image + .content, .ui.list .list > .item > .icon + .content, .ui.list > .item > .image + .content, .ui.list > .item > .icon + .content {\n  display: table-cell;\n  width: 100%;\n  padding: 0em 0em 0em 0.5em;\n  vertical-align: top;\n}\n\n.ui.list .list > .item > img.image + .content, .ui.list > .item > img.image + .content {\n  display: inline-block;\n  width: auto;\n}\n\n.ui.list .list > .item > .content > .list, .ui.list > .item > .content > .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n\n/* Header */\n\n.ui.list .list > .item .header, .ui.list > .item .header {\n  display: block;\n  margin: 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Description */\n\n.ui.list .list > .item .description, .ui.list > .item .description {\n  display: block;\n  color: rgba(0, 0, 0, 0.7);\n}\n\n/* Child Link */\n\n.ui.list > .item a, .ui.list .list > .item a {\n  cursor: pointer;\n}\n\n/* Linking Item */\n\n.ui.list .list > a.item, .ui.list > a.item {\n  cursor: pointer;\n  color: #FF9F5B;\n}\n\n.ui.list .list > a.item:hover, .ui.list > a.item:hover {\n  color: #ff8127;\n}\n\n/* Linked Item Icons */\n\n.ui.list .list > a.item i.icon, .ui.list > a.item i.icon {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/* Header Link */\n\n.ui.list .list > .item a.header, .ui.list > .item a.header {\n  cursor: pointer;\n  color: #FF9F5B !important;\n}\n\n.ui.list .list > .item a.header:hover, .ui.list > .item a.header:hover {\n  color: #ff8127 !important;\n}\n\n/* Floated Content */\n\n.ui[class*=\"left floated\"].list {\n  float: left;\n}\n\n.ui[class*=\"right floated\"].list {\n  float: right;\n}\n\n.ui.list .list > .item [class*=\"left floated\"], .ui.list > .item [class*=\"left floated\"] {\n  float: left;\n  margin: 0em 1em 0em 0em;\n}\n\n.ui.list .list > .item [class*=\"right floated\"], .ui.list > .item [class*=\"right floated\"] {\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n.ui.menu .ui.list > .item, .ui.menu .ui.list .list > .item {\n  display: list-item;\n  table-layout: fixed;\n  background-color: transparent;\n  list-style-type: none;\n  list-style-position: outside;\n  padding: 0.21428571em 0em;\n  line-height: 1.14285714em;\n}\n\n.ui.menu .ui.list .list > .item:before, .ui.menu .ui.list > .item:before {\n  border: none;\n  background: none;\n}\n\n.ui.menu .ui.list .list > .item:first-child, .ui.menu .ui.list > .item:first-child {\n  padding-top: 0em;\n}\n\n.ui.menu .ui.list .list > .item:last-child, .ui.menu .ui.list > .item:last-child {\n  padding-bottom: 0em;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*-------------------\n      Horizontal\n--------------------*/\n\n.ui.horizontal.list {\n  display: inline-block;\n  font-size: 0em;\n}\n\n.ui.horizontal.list > .item {\n  display: inline-block;\n  margin-left: 1em;\n  font-size: 1rem;\n}\n\n.ui.horizontal.list:not(.celled) > .item:first-child {\n  margin-left: 0em !important;\n  padding-left: 0em !important;\n}\n\n.ui.horizontal.list .list {\n  padding-left: 0em;\n  padding-bottom: 0em;\n}\n\n.ui.horizontal.list > .item > .image, .ui.horizontal.list .list > .item > .image, .ui.horizontal.list > .item > .icon, .ui.horizontal.list .list > .item > .icon, .ui.horizontal.list > .item > .content, .ui.horizontal.list .list > .item > .content {\n  vertical-align: middle;\n}\n\n/* Padding on all elements */\n\n.ui.horizontal.list > .item:first-child, .ui.horizontal.list > .item:last-child {\n  padding-top: 0.21428571em;\n  padding-bottom: 0.21428571em;\n}\n\n/* Horizontal List */\n\n.ui.horizontal.list > .item > i.icon {\n  margin: 0em;\n  padding: 0em 0.25em 0em 0em;\n}\n\n.ui.horizontal.list > .item > .icon, .ui.horizontal.list > .item > .icon + .content {\n  float: none;\n  display: inline-block;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n       Disabled\n--------------------*/\n\n.ui.list .list > .disabled.item, .ui.list > .disabled.item {\n  pointer-events: none;\n  color: rgba(40, 40, 40, 0.3) !important;\n}\n\n.ui.inverted.list .list > .disabled.item, .ui.inverted.list > .disabled.item {\n  color: rgba(225, 225, 225, 0.3) !important;\n}\n\n/*-------------------\n        Hover\n--------------------*/\n\n.ui.list .list > a.item:hover .icon, .ui.list > a.item:hover .icon {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.list .list > a.item > .icon, .ui.inverted.list > a.item > .icon {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ui.inverted.list .list > .item .header, .ui.inverted.list > .item .header {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.inverted.list .list > .item .description, .ui.inverted.list > .item .description {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Item Link */\n\n.ui.inverted.list .list > a.item, .ui.inverted.list > a.item {\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.inverted.list .list > a.item:hover, .ui.inverted.list > a.item:hover {\n  color: #ff8127;\n}\n\n/* Linking Content */\n\n.ui.inverted.list .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.ui.inverted.list .item a:not(.ui):hover {\n  color: #ff8127 !important;\n}\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.list[class*=\"top aligned\"] .image, .ui.list[class*=\"top aligned\"] .content, .ui.list [class*=\"top aligned\"] {\n  vertical-align: top !important;\n}\n\n.ui.list[class*=\"middle aligned\"] .image, .ui.list[class*=\"middle aligned\"] .content, .ui.list [class*=\"middle aligned\"] {\n  vertical-align: middle !important;\n}\n\n.ui.list[class*=\"bottom aligned\"] .image, .ui.list[class*=\"bottom aligned\"] .content, .ui.list [class*=\"bottom aligned\"] {\n  vertical-align: bottom !important;\n}\n\n/*-------------------\n       Link\n--------------------*/\n\n.ui.link.list .item, .ui.link.list a.item, .ui.link.list .item a:not(.ui) {\n  color: rgba(0, 0, 0, 0.4);\n  transition: 0.1s color ease;\n}\n\n.ui.link.list.list a.item:hover, .ui.link.list.list .item a:not(.ui):hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.link.list.list a.item:active, .ui.link.list.list .item a:not(.ui):active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.ui.link.list.list .active.item, .ui.link.list.list .active.item a:not(.ui) {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Inverted */\n\n.ui.inverted.link.list .item, .ui.inverted.link.list a.item, .ui.inverted.link.list .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ui.inverted.link.list.list a.item:hover, .ui.inverted.link.list.list .item a:not(.ui):hover {\n  color: #ffffff;\n}\n\n.ui.inverted.link.list.list a.item:active, .ui.inverted.link.list.list .item a:not(.ui):active {\n  color: #ffffff;\n}\n\n.ui.inverted.link.list.list a.active.item, .ui.inverted.link.list.list .active.item a:not(.ui) {\n  color: #ffffff;\n}\n\n/*-------------------\n      Selection\n--------------------*/\n\n.ui.selection.list .list > .item, .ui.selection.list > .item {\n  cursor: pointer;\n  background: transparent;\n  padding: 0.5em 0.5em;\n  margin: 0em;\n  color: rgba(0, 0, 0, 0.4);\n  border-radius: 0.5em;\n  transition: 0.1s color ease, 0.1s padding-left ease, 0.1s background-color ease;\n}\n\n.ui.selection.list .list > .item:last-child, .ui.selection.list > .item:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.selection.list.list > .item:hover, .ui.selection.list > .item:hover {\n  background: rgba(0, 0, 0, 0.03);\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.selection.list .list > .item:active, .ui.selection.list > .item:active {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.ui.selection.list .list > .item.active, .ui.selection.list > .item.active {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Inverted */\n\n.ui.inverted.selection.list > .item, .ui.inverted.selection.list > .item {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.ui.inverted.selection.list > .item:hover, .ui.inverted.selection.list > .item:hover {\n  background: rgba(255, 255, 255, 0.02);\n  color: #ffffff;\n}\n\n.ui.inverted.selection.list > .item:active, .ui.inverted.selection.list > .item:active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.ui.inverted.selection.list > .item.active, .ui.inverted.selection.list > .item.active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n/* Celled / Divided Selection List */\n\n.ui.celled.selection.list .list > .item, .ui.divided.selection.list .list > .item, .ui.celled.selection.list > .item, .ui.divided.selection.list > .item {\n  border-radius: 0em;\n}\n\n/*-------------------\n       Animated\n--------------------*/\n\n.ui.animated.list > .item {\n  transition: 0.25s color ease 0.1s, 0.25s padding-left ease 0.1s, 0.25s background-color ease 0.1s;\n}\n\n.ui.animated.list:not(.horizontal) > .item:hover {\n  padding-left: 1em;\n}\n\n/*-------------------\n       Fitted\n--------------------*/\n\n.ui.fitted.list:not(.selection) .list > .item, .ui.fitted.list:not(.selection) > .item {\n  padding-left: 0em;\n  padding-right: 0em;\n}\n\n.ui.fitted.selection.list .list > .item, .ui.fitted.selection.list > .item {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n\n/*-------------------\n      Bulleted\n--------------------*/\n\nul.ui.list, .ui.bulleted.list {\n  margin-left: 1.25rem;\n}\n\nul.ui.list li, .ui.bulleted.list .list > .item, .ui.bulleted.list > .item {\n  position: relative;\n}\n\nul.ui.list li:before, .ui.bulleted.list .list > .item:before, .ui.bulleted.list > .item:before {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  top: auto;\n  left: auto;\n  font-weight: normal;\n  margin-left: -1.25rem;\n  content: '\\2022';\n  opacity: 1;\n  color: inherit;\n  vertical-align: top;\n}\n\nul.ui.list li:before, .ui.bulleted.list .list > a.item:before, .ui.bulleted.list > a.item:before {\n  color: rgba(0, 0, 0, 0.8);\n}\n\nul.ui.list ul, .ui.bulleted.list .list {\n  padding-left: 1.25rem;\n}\n\n/* Horizontal Bulleted */\n\nul.ui.horizontal.bulleted.list, .ui.horizontal.bulleted.list {\n  margin-left: 0em;\n}\n\nul.ui.horizontal.bulleted.list li, .ui.horizontal.bulleted.list > .item {\n  margin-left: 1.75rem;\n}\n\nul.ui.horizontal.bulleted.list li:first-child, .ui.horizontal.bulleted.list > .item:first-child {\n  margin-left: 0em;\n}\n\nul.ui.horizontal.bulleted.list li::before, .ui.horizontal.bulleted.list > .item::before {\n  color: rgba(0, 0, 0, 0.8);\n}\n\nul.ui.horizontal.bulleted.list li:first-child::before, .ui.horizontal.bulleted.list > .item:first-child::before {\n  display: none;\n}\n\n/*-------------------\n       Ordered\n--------------------*/\n\nol.ui.list, .ui.ordered.list, .ui.ordered.list .list, ol.ui.list ol {\n  counter-reset: ordered;\n  margin-left: 1.25rem;\n  list-style-type: none;\n}\n\nol.ui.list li, .ui.ordered.list .list > .item, .ui.ordered.list > .item {\n  list-style-type: none;\n  position: relative;\n}\n\nol.ui.list li:before, .ui.ordered.list .list > .item:before, .ui.ordered.list > .item:before {\n  position: absolute;\n  top: auto;\n  left: auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  pointer-events: none;\n  margin-left: -1.25rem;\n  counter-increment: ordered;\n  content: counters(ordered, \".\") \" \";\n  text-align: right;\n  color: rgba(0, 0, 0, 0.8);\n  vertical-align: middle;\n  opacity: 0.8;\n}\n\nol.ui.inverted.list li:before, .ui.ordered.inverted.list .list > .item:before, .ui.ordered.inverted.list > .item:before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Value */\n\n.ui.ordered.list > .list > .item[data-value], .ui.ordered.list > .item[data-value] {\n  content: attr(data-value);\n}\n\nol.ui.list li[value]:before {\n  content: attr(value);\n}\n\n/* Child Lists */\n\nol.ui.list ol, .ui.ordered.list .list {\n  margin-left: 1em;\n}\n\nol.ui.list ol li:before, .ui.ordered.list .list > .item:before {\n  margin-left: -2em;\n}\n\n/* Horizontal Ordered */\n\nol.ui.horizontal.list, .ui.ordered.horizontal.list {\n  margin-left: 0em;\n}\n\nol.ui.horizontal.list li:before, .ui.ordered.horizontal.list .list > .item:before, .ui.ordered.horizontal.list > .item:before {\n  position: static;\n  margin: 0em 0.5em 0em 0em;\n}\n\n/*-------------------\n       Divided\n--------------------*/\n\n.ui.divided.list > .item {\n  border-top: 1px solid #DEDEDF;\n}\n\n.ui.divided.list .list > .item {\n  border-top: none;\n}\n\n.ui.divided.list .item .list > .item {\n  border-top: none;\n}\n\n.ui.divided.list .list > .item:first-child, .ui.divided.list > .item:first-child {\n  border-top: none;\n}\n\n/* Sub Menu */\n\n.ui.divided.list:not(.horizontal) .list > .item:first-child {\n  border-top-width: 1px;\n}\n\n/* Divided bulleted */\n\n.ui.divided.bulleted.list:not(.horizontal), .ui.divided.bulleted.list .list {\n  margin-left: 0em;\n  padding-left: 0em;\n}\n\n.ui.divided.bulleted.list > .item:not(.horizontal) {\n  padding-left: 1.25rem;\n}\n\n/* Divided Ordered */\n\n.ui.divided.ordered.list {\n  margin-left: 0em;\n}\n\n.ui.divided.ordered.list .list > .item, .ui.divided.ordered.list > .item {\n  padding-left: 1.25rem;\n}\n\n.ui.divided.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: 0.21428571em;\n}\n\n.ui.divided.ordered.list .item .list > .item {\n  padding-left: 1em;\n}\n\n/* Divided Selection */\n\n.ui.divided.selection.list .list > .item, .ui.divided.selection.list > .item {\n  margin: 0em;\n  border-radius: 0em;\n}\n\n/* Divided horizontal */\n\n.ui.divided.horizontal.list {\n  margin-left: 0em;\n}\n\n.ui.divided.horizontal.list > .item:not(:first-child) {\n  padding-left: 0.5em;\n}\n\n.ui.divided.horizontal.list > .item:not(:last-child) {\n  padding-right: 0.5em;\n}\n\n.ui.divided.horizontal.list > .item {\n  border-top: none;\n  border-left: 1px solid #DEDEDF;\n  margin: 0em;\n  line-height: 0.6;\n}\n\n.ui.horizontal.divided.list > .item:first-child {\n  border-left: none;\n}\n\n/* Inverted */\n\n.ui.divided.inverted.list > .item, .ui.divided.inverted.list > .list, .ui.divided.inverted.horizontal.list > .item {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n/*-------------------\n        Celled\n--------------------*/\n\n.ui.celled.list > .item, .ui.celled.list > .list {\n  border-top: 1px solid #DEDEDF;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n\n.ui.celled.list > .item:last-child {\n  border-bottom: 1px solid #DEDEDF;\n}\n\n/* Padding on all elements */\n\n.ui.celled.list > .item:first-child, .ui.celled.list > .item:last-child {\n  padding-top: 0.21428571em;\n  padding-bottom: 0.21428571em;\n}\n\n/* Sub Menu */\n\n.ui.celled.list .item .list > .item {\n  border-width: 0px;\n}\n\n.ui.celled.list .list > .item:first-child {\n  border-top-width: 0px;\n}\n\n/* Celled Bulleted */\n\n.ui.celled.bulleted.list {\n  margin-left: 0em;\n}\n\n.ui.celled.bulleted.list .list > .item, .ui.celled.bulleted.list > .item {\n  padding-left: 1.25rem;\n}\n\n.ui.celled.bulleted.list .item .list {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n  padding-bottom: 0.21428571em;\n}\n\n/* Celled Ordered */\n\n.ui.celled.ordered.list {\n  margin-left: 0em;\n}\n\n.ui.celled.ordered.list .list > .item, .ui.celled.ordered.list > .item {\n  padding-left: 1.25rem;\n}\n\n.ui.celled.ordered.list .item .list {\n  margin-left: 0em;\n  margin-right: 0em;\n  padding-bottom: 0.21428571em;\n}\n\n.ui.celled.ordered.list .list > .item {\n  padding-left: 1em;\n}\n\n/* Celled Horizontal */\n\n.ui.horizontal.celled.list {\n  margin-left: 0em;\n}\n\n.ui.horizontal.celled.list .list > .item, .ui.horizontal.celled.list > .item {\n  border-top: none;\n  border-left: 1px solid #DEDEDF;\n  margin: 0em;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  line-height: 0.6;\n}\n\n.ui.horizontal.celled.list .list > .item:last-child, .ui.horizontal.celled.list > .item:last-child {\n  border-bottom: none;\n  border-right: 1px solid #DEDEDF;\n}\n\n/* Inverted */\n\n.ui.celled.inverted.list > .item, .ui.celled.inverted.list > .list {\n  border-color: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.ui.celled.inverted.horizontal.list .list > .item, .ui.celled.inverted.horizontal.list > .item {\n  border-color: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/*-------------------\n       Relaxed\n--------------------*/\n\n.ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: 0.42857143em;\n}\n\n.ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: 0.42857143em;\n}\n\n.ui.horizontal.relaxed.list .list > .item:not(:first-child), .ui.horizontal.relaxed.list > .item:not(:first-child) {\n  padding-left: 1rem;\n}\n\n.ui.horizontal.relaxed.list .list > .item:not(:last-child), .ui.horizontal.relaxed.list > .item:not(:last-child) {\n  padding-right: 1rem;\n}\n\n/* Very Relaxed */\n\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:first-child) {\n  padding-top: 0.85714286em;\n}\n\n.ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:last-child) {\n  padding-bottom: 0.85714286em;\n}\n\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:first-child), .ui.horizontal[class*=\"very relaxed\"].list > .item:not(:first-child) {\n  padding-left: 1.5rem;\n}\n\n.ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:last-child), .ui.horizontal[class*=\"very relaxed\"].list > .item:not(:last-child) {\n  padding-right: 1.5rem;\n}\n\n/*-------------------\n      Sizes\n--------------------*/\n\n.ui.mini.list {\n  font-size: 0.78571429em;\n}\n\n.ui.tiny.list {\n  font-size: 0.85714286em;\n}\n\n.ui.small.list {\n  font-size: 0.92857143em;\n}\n\n.ui.list {\n  font-size: 1em;\n}\n\n.ui.large.list {\n  font-size: 1.14285714em;\n}\n\n.ui.big.list {\n  font-size: 1.28571429em;\n}\n\n.ui.huge.list {\n  font-size: 1.42857143em;\n}\n\n.ui.massive.list {\n  font-size: 1.71428571em;\n}\n\n.ui.mini.horizontal.list .list > .item, .ui.mini.horizontal.list > .item {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.horizontal.list .list > .item, .ui.tiny.horizontal.list > .item {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.horizontal.list .list > .item, .ui.small.horizontal.list > .item {\n  font-size: 0.92857143rem;\n}\n\n.ui.horizontal.list .list > .item, .ui.horizontal.list > .item {\n  font-size: 1rem;\n}\n\n.ui.large.horizontal.list .list > .item, .ui.large.horizontal.list > .item {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.horizontal.list .list > .item, .ui.big.horizontal.list > .item {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.horizontal.list .list > .item, .ui.huge.horizontal.list > .item {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.horizontal.list .list > .item, .ui.massive.horizontal.list > .item {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Loader\n*******************************/\n\n/* Standard Size */\n\n.ui.loader {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: 0px;\n  text-align: center;\n  z-index: 1000;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n}\n\n/* Static Shape */\n\n.ui.loader:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n\n/* Active Shape */\n\n.ui.loader:after {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  -webkit-animation: loader 0.6s linear;\n  animation: loader 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n/* Active Animation */\n\n@-webkit-keyframes loader {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loader {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/* Sizes */\n\n.ui.mini.loader:before, .ui.mini.loader:after {\n  width: 1rem;\n  height: 1rem;\n  margin: 0em 0em 0em -0.5rem;\n}\n\n.ui.tiny.loader:before, .ui.tiny.loader:after {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  margin: 0em 0em 0em -0.57142857rem;\n}\n\n.ui.small.loader:before, .ui.small.loader:after {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  margin: 0em 0em 0em -0.85714286rem;\n}\n\n.ui.loader:before, .ui.loader:after {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  margin: 0em 0em 0em -1.14285714rem;\n}\n\n.ui.large.loader:before, .ui.large.loader:after {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  margin: 0em 0em 0em -1.71428571rem;\n}\n\n.ui.big.loader:before, .ui.big.loader:after {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  margin: 0em 0em 0em -1.85714286rem;\n}\n\n.ui.huge.loader:before, .ui.huge.loader:after {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  margin: 0em 0em 0em -2.07142857rem;\n}\n\n.ui.massive.loader:before, .ui.massive.loader:after {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  margin: 0em 0em 0em -2.28571429rem;\n}\n\n/*-------------------\n      Coupling\n--------------------*/\n\n/* Show inside active dimmer */\n\n.ui.dimmer .loader {\n  display: block;\n}\n\n/* Black Dimmer */\n\n.ui.dimmer .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.dimmer .ui.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.ui.dimmer .ui.loader:after {\n  border-color: #FFFFFF transparent transparent;\n}\n\n/* White Dimmer (Inverted) */\n\n.ui.inverted.dimmer .ui.loader {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.inverted.dimmer .ui.loader:before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.ui.inverted.dimmer .ui.loader:after {\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n        Text\n--------------------*/\n\n.ui.text.loader {\n  width: auto !important;\n  height: auto !important;\n  text-align: center;\n  font-style: normal;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.indeterminate.loader:after {\n  -webkit-animation-direction: reverse;\n          animation-direction: reverse;\n  -webkit-animation-duration: 1.2s;\n  animation-duration: 1.2s;\n}\n\n.ui.loader.active, .ui.loader.visible {\n  display: block;\n}\n\n.ui.loader.disabled, .ui.loader.hidden {\n  display: none;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*-------------------\n        Sizes\n--------------------*/\n\n/* Loader */\n\n.ui.inverted.dimmer .ui.mini.loader, .ui.mini.loader {\n  width: 1rem;\n  height: 1rem;\n  font-size: 0.78571429em;\n}\n\n.ui.inverted.dimmer .ui.tiny.loader, .ui.tiny.loader {\n  width: 1.14285714rem;\n  height: 1.14285714rem;\n  font-size: 0.85714286em;\n}\n\n.ui.inverted.dimmer .ui.small.loader, .ui.small.loader {\n  width: 1.71428571rem;\n  height: 1.71428571rem;\n  font-size: 0.92857143em;\n}\n\n.ui.inverted.dimmer .ui.loader, .ui.loader {\n  width: 2.28571429rem;\n  height: 2.28571429rem;\n  font-size: 1em;\n}\n\n.ui.inverted.dimmer .ui.large.loader, .ui.large.loader {\n  width: 3.42857143rem;\n  height: 3.42857143rem;\n  font-size: 1.14285714em;\n}\n\n.ui.inverted.dimmer .ui.big.loader, .ui.big.loader {\n  width: 3.71428571rem;\n  height: 3.71428571rem;\n  font-size: 1.28571429em;\n}\n\n.ui.inverted.dimmer .ui.huge.loader, .ui.huge.loader {\n  width: 4.14285714rem;\n  height: 4.14285714rem;\n  font-size: 1.42857143em;\n}\n\n.ui.inverted.dimmer .ui.massive.loader, .ui.massive.loader {\n  width: 4.57142857rem;\n  height: 4.57142857rem;\n  font-size: 1.71428571em;\n}\n\n/* Text Loader */\n\n.ui.mini.text.loader {\n  min-width: 1rem;\n  padding-top: 1.78571429rem;\n}\n\n.ui.tiny.text.loader {\n  min-width: 1.14285714rem;\n  padding-top: 1.92857143rem;\n}\n\n.ui.small.text.loader {\n  min-width: 1.71428571rem;\n  padding-top: 2.5rem;\n}\n\n.ui.text.loader {\n  min-width: 2.28571429rem;\n  padding-top: 3.07142857rem;\n}\n\n.ui.large.text.loader {\n  min-width: 3.42857143rem;\n  padding-top: 4.21428571rem;\n}\n\n.ui.big.text.loader {\n  min-width: 3.71428571rem;\n  padding-top: 4.5rem;\n}\n\n.ui.huge.text.loader {\n  min-width: 4.14285714rem;\n  padding-top: 4.92857143rem;\n}\n\n.ui.massive.text.loader {\n  min-width: 4.57142857rem;\n  padding-top: 5.35714286rem;\n}\n\n/*-------------------\n       Inverted\n--------------------*/\n\n.ui.inverted.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.inverted.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.ui.inverted.loader:after {\n  border-top-color: #FFFFFF;\n}\n\n/*-------------------\n       Inline\n--------------------*/\n\n.ui.inline.loader {\n  position: relative;\n  vertical-align: middle;\n  margin: 0em;\n  left: 0em;\n  top: 0em;\n  -webkit-transform: none;\n  transform: none;\n}\n\n.ui.inline.loader.active, .ui.inline.loader.visible {\n  display: inline-block;\n}\n\n/* Centered Inline */\n\n.ui.centered.inline.loader.active, .ui.centered.inline.loader.visible {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Loader\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*-------------------\n      Content\n--------------------*/\n\n.ui.placeholder {\n  position: static;\n  overflow: hidden;\n  -webkit-animation: placeholderShimmer 2s linear;\n  animation: placeholderShimmer 2s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  background-color: #FFFFFF;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.15) 15%, rgba(0, 0, 0, 0.08) 30%);\n  background-size: 1200px 100%;\n  max-width: 30rem;\n}\n\n@-webkit-keyframes placeholderShimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n\n  100% {\n    background-position: 1200px 0;\n  }\n}\n\n@keyframes placeholderShimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n\n  100% {\n    background-position: 1200px 0;\n  }\n}\n\n.ui.placeholder + .ui.placeholder {\n  margin-top: 2rem;\n}\n\n.ui.placeholder + .ui.placeholder {\n  -webkit-animation-delay: 0.15s;\n  animation-delay: 0.15s;\n}\n\n.ui.placeholder + .ui.placeholder + .ui.placeholder {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  -webkit-animation-delay: 0.45s;\n  animation-delay: 0.45s;\n}\n\n.ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n\n.ui.placeholder, .ui.placeholder > :before, .ui.placeholder .image.header:after, .ui.placeholder .line, .ui.placeholder .line:after {\n  background-color: #FFFFFF;\n}\n\n/* Image */\n\n.ui.placeholder .image:not(.header):not(.ui) {\n  height: 100px;\n}\n\n.ui.placeholder .square.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 1/1 aspect ratio */\n  padding-top: 100%;\n}\n\n.ui.placeholder .rectangular.image:not(.header) {\n  height: 0px;\n  overflow: hidden;\n  /* 4/3 aspect ratio */\n  padding-top: 75%;\n}\n\n/* Lines */\n\n.ui.placeholder .line {\n  position: relative;\n  height: 0.85714286em;\n}\n\n.ui.placeholder .line:before, .ui.placeholder .line:after {\n  top: 100%;\n  position: absolute;\n  content: '';\n  background-color: inherit;\n}\n\n.ui.placeholder .line:before {\n  left: 0px;\n}\n\n.ui.placeholder .line:after {\n  right: 0px;\n}\n\n/* Any Lines */\n\n.ui.placeholder .line {\n  margin-bottom: 0.5em;\n}\n\n.ui.placeholder .line:before, .ui.placeholder .line:after {\n  height: 0.5em;\n}\n\n.ui.placeholder .line:not(:first-child) {\n  margin-top: 0.5em;\n}\n\n/* Header Image + 2 Lines */\n\n.ui.placeholder .header {\n  position: relative;\n  overflow: hidden;\n}\n\n/* Line Outdent */\n\n.ui.placeholder .line:nth-child(1):after {\n  width: 0%;\n}\n\n.ui.placeholder .line:nth-child(2):after {\n  width: 50%;\n}\n\n.ui.placeholder .line:nth-child(3):after {\n  width: 10%;\n}\n\n.ui.placeholder .line:nth-child(4):after {\n  width: 35%;\n}\n\n.ui.placeholder .line:nth-child(5):after {\n  width: 65%;\n}\n\n/* Header Line 1 & 2*/\n\n.ui.placeholder .header .line {\n  margin-bottom: 0.64285714em;\n}\n\n.ui.placeholder .header .line:before, .ui.placeholder .header .line:after {\n  height: 0.64285714em;\n}\n\n.ui.placeholder .header .line:not(:first-child) {\n  margin-top: 0.64285714em;\n}\n\n.ui.placeholder .header .line:after {\n  width: 20%;\n}\n\n.ui.placeholder .header .line:nth-child(2):after {\n  width: 60%;\n}\n\n/* Image Header */\n\n.ui.placeholder .image.header .line {\n  margin-left: 3em;\n}\n\n.ui.placeholder .image.header .line:before {\n  width: 0.71428571rem;\n}\n\n.ui.placeholder .image.header:after {\n  display: block;\n  height: 0.85714286em;\n  content: '';\n  margin-left: 3em;\n}\n\n/* Spacing */\n\n.ui.placeholder .image .line:first-child, .ui.placeholder .paragraph .line:first-child, .ui.placeholder .header .line:first-child {\n  height: 0.01px;\n}\n\n.ui.placeholder .image:not(:first-child):before, .ui.placeholder .paragraph:not(:first-child):before, .ui.placeholder .header:not(:first-child):before {\n  height: 1.42857143em;\n  content: '';\n  display: block;\n}\n\n/* Inverted Content Loader */\n\n.ui.inverted.placeholder {\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.14) 15%, rgba(255, 255, 255, 0.08) 30%);\n}\n\n.ui.inverted.placeholder, .ui.inverted.placeholder > :before, .ui.inverted.placeholder .image.header:after, .ui.inverted.placeholder .line, .ui.inverted.placeholder .line:after {\n  background-color: #1B1C1D;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.placeholder .full.line.line.line:after {\n  width: 0%;\n}\n\n.ui.placeholder .very.long.line.line.line:after {\n  width: 10%;\n}\n\n.ui.placeholder .long.line.line.line:after {\n  width: 35%;\n}\n\n.ui.placeholder .medium.line.line.line:after {\n  width: 50%;\n}\n\n.ui.placeholder .short.line.line.line:after {\n  width: 65%;\n}\n\n.ui.placeholder .very.short.line.line.line:after {\n  width: 80%;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.placeholder {\n  max-width: none;\n}\n/*!\n * # Semantic UI 2.4.2 - Rail\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Rails\n*******************************/\n\n.ui.rail {\n  position: absolute;\n  top: 0%;\n  width: 300px;\n  height: 100%;\n}\n\n.ui.left.rail {\n  left: auto;\n  right: 100%;\n  padding: 0em 2rem 0em 0em;\n  margin: 0em 2rem 0em 0em;\n}\n\n.ui.right.rail {\n  left: 100%;\n  right: auto;\n  padding: 0em 0em 0em 2rem;\n  margin: 0em 0em 0em 2rem;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Internal\n---------------*/\n\n.ui.left.internal.rail {\n  left: 0%;\n  right: auto;\n  padding: 0em 0em 0em 2rem;\n  margin: 0em 0em 0em 2rem;\n}\n\n.ui.right.internal.rail {\n  left: auto;\n  right: 0%;\n  padding: 0em 2rem 0em 0em;\n  margin: 0em 2rem 0em 0em;\n}\n\n/*--------------\n    Dividing\n---------------*/\n\n.ui.dividing.rail {\n  width: 302.5px;\n}\n\n.ui.left.dividing.rail {\n  padding: 0em 2.5rem 0em 0em;\n  margin: 0em 2.5rem 0em 0em;\n  border-right: 1px solid #DEDEDF;\n}\n\n.ui.right.dividing.rail {\n  border-left: 1px solid #DEDEDF;\n  padding: 0em 0em 0em 2.5rem;\n  margin: 0em 0em 0em 2.5rem;\n}\n\n/*--------------\n    Distance\n---------------*/\n\n.ui.close.rail {\n  width: calc( 300px  +  1em );\n}\n\n.ui.close.left.rail {\n  padding: 0em 1em 0em 0em;\n  margin: 0em 1em 0em 0em;\n}\n\n.ui.close.right.rail {\n  padding: 0em 0em 0em 1em;\n  margin: 0em 0em 0em 1em;\n}\n\n.ui.very.close.rail {\n  width: calc( 300px  +  0.5em );\n}\n\n.ui.very.close.left.rail {\n  padding: 0em 0.5em 0em 0em;\n  margin: 0em 0.5em 0em 0em;\n}\n\n.ui.very.close.right.rail {\n  padding: 0em 0em 0em 0.5em;\n  margin: 0em 0em 0em 0.5em;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n.ui.attached.left.rail, .ui.attached.right.rail {\n  padding: 0em;\n  margin: 0em;\n}\n\n/*--------------\n     Sizing\n---------------*/\n\n.ui.mini.rail {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.rail {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.rail {\n  font-size: 0.92857143rem;\n}\n\n.ui.rail {\n  font-size: 1rem;\n}\n\n.ui.large.rail {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.rail {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.rail {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.rail {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Reveal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Reveal\n*******************************/\n\n.ui.reveal {\n  display: inherit;\n  position: relative !important;\n  font-size: 0em !important;\n}\n\n.ui.reveal > .visible.content {\n  position: absolute !important;\n  top: 0em !important;\n  left: 0em !important;\n  z-index: 3 !important;\n  transition: all 0.5s ease 0.1s;\n}\n\n.ui.reveal > .hidden.content {\n  position: relative !important;\n  z-index: 2 !important;\n}\n\n/* Make sure hovered element is on top of other reveal */\n\n.ui.active.reveal .visible.content, .ui.reveal:hover .visible.content {\n  z-index: 4 !important;\n}\n\n/*******************************\n              Types\n*******************************/\n\n/*--------------\n      Slide\n---------------*/\n\n.ui.slide.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n\n.ui.slide.reveal > .content {\n  display: block;\n  width: 100%;\n  white-space: normal;\n  float: left;\n  margin: 0em;\n  transition: -webkit-transform 0.5s ease 0.1s;\n  transition: transform 0.5s ease 0.1s;\n  transition: transform 0.5s ease 0.1s, -webkit-transform 0.5s ease 0.1s;\n}\n\n.ui.slide.reveal > .visible.content {\n  position: relative !important;\n}\n\n.ui.slide.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n  -webkit-transform: translateX(100%) !important;\n  transform: translateX(100%) !important;\n}\n\n.ui.slide.active.reveal > .visible.content, .ui.slide.reveal:hover > .visible.content {\n  -webkit-transform: translateX(-100%) !important;\n  transform: translateX(-100%) !important;\n}\n\n.ui.slide.active.reveal > .hidden.content, .ui.slide.reveal:hover > .hidden.content {\n  -webkit-transform: translateX(0%) !important;\n  transform: translateX(0%) !important;\n}\n\n.ui.slide.right.reveal > .visible.content {\n  -webkit-transform: translateX(0%) !important;\n  transform: translateX(0%) !important;\n}\n\n.ui.slide.right.reveal > .hidden.content {\n  -webkit-transform: translateX(-100%) !important;\n  transform: translateX(-100%) !important;\n}\n\n.ui.slide.right.active.reveal > .visible.content, .ui.slide.right.reveal:hover > .visible.content {\n  -webkit-transform: translateX(100%) !important;\n  transform: translateX(100%) !important;\n}\n\n.ui.slide.right.active.reveal > .hidden.content, .ui.slide.right.reveal:hover > .hidden.content {\n  -webkit-transform: translateX(0%) !important;\n  transform: translateX(0%) !important;\n}\n\n.ui.slide.up.reveal > .hidden.content {\n  -webkit-transform: translateY(100%) !important;\n  transform: translateY(100%) !important;\n}\n\n.ui.slide.up.active.reveal > .visible.content, .ui.slide.up.reveal:hover > .visible.content {\n  -webkit-transform: translateY(-100%) !important;\n  transform: translateY(-100%) !important;\n}\n\n.ui.slide.up.active.reveal > .hidden.content, .ui.slide.up.reveal:hover > .hidden.content {\n  -webkit-transform: translateY(0%) !important;\n  transform: translateY(0%) !important;\n}\n\n.ui.slide.down.reveal > .hidden.content {\n  -webkit-transform: translateY(-100%) !important;\n  transform: translateY(-100%) !important;\n}\n\n.ui.slide.down.active.reveal > .visible.content, .ui.slide.down.reveal:hover > .visible.content {\n  -webkit-transform: translateY(100%) !important;\n  transform: translateY(100%) !important;\n}\n\n.ui.slide.down.active.reveal > .hidden.content, .ui.slide.down.reveal:hover > .hidden.content {\n  -webkit-transform: translateY(0%) !important;\n  transform: translateY(0%) !important;\n}\n\n/*--------------\n      Fade\n---------------*/\n\n.ui.fade.reveal > .visible.content {\n  opacity: 1;\n}\n\n.ui.fade.active.reveal > .visible.content, .ui.fade.reveal:hover > .visible.content {\n  opacity: 0;\n}\n\n/*--------------\n      Move\n---------------*/\n\n.ui.move.reveal {\n  position: relative !important;\n  overflow: hidden !important;\n  white-space: nowrap;\n}\n\n.ui.move.reveal > .content {\n  display: block;\n  float: left;\n  white-space: normal;\n  margin: 0em;\n  transition: -webkit-transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;\n  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;\n  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s, -webkit-transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;\n}\n\n.ui.move.reveal > .visible.content {\n  position: relative !important;\n}\n\n.ui.move.reveal > .hidden.content {\n  position: absolute !important;\n  left: 0% !important;\n  width: 100% !important;\n}\n\n.ui.move.active.reveal > .visible.content, .ui.move.reveal:hover > .visible.content {\n  -webkit-transform: translateX(-100%) !important;\n  transform: translateX(-100%) !important;\n}\n\n.ui.move.right.active.reveal > .visible.content, .ui.move.right.reveal:hover > .visible.content {\n  -webkit-transform: translateX(100%) !important;\n  transform: translateX(100%) !important;\n}\n\n.ui.move.up.active.reveal > .visible.content, .ui.move.up.reveal:hover > .visible.content {\n  -webkit-transform: translateY(-100%) !important;\n  transform: translateY(-100%) !important;\n}\n\n.ui.move.down.active.reveal > .visible.content, .ui.move.down.reveal:hover > .visible.content {\n  -webkit-transform: translateY(100%) !important;\n  transform: translateY(100%) !important;\n}\n\n/*--------------\n     Rotate\n---------------*/\n\n.ui.rotate.reveal > .visible.content {\n  transition-duration: 0.5s;\n  -webkit-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n\n.ui.rotate.reveal > .visible.content, .ui.rotate.right.reveal > .visible.content {\n  -webkit-transform-origin: bottom right;\n  transform-origin: bottom right;\n}\n\n.ui.rotate.active.reveal > .visible.content, .ui.rotate.reveal:hover > .visible.content, .ui.rotate.right.active.reveal > .visible.content, .ui.rotate.right.reveal:hover > .visible.content {\n  -webkit-transform: rotate(110deg);\n  transform: rotate(110deg);\n}\n\n.ui.rotate.left.reveal > .visible.content {\n  -webkit-transform-origin: bottom left;\n  transform-origin: bottom left;\n}\n\n.ui.rotate.left.active.reveal > .visible.content, .ui.rotate.left.reveal:hover > .visible.content {\n  -webkit-transform: rotate(-110deg);\n  transform: rotate(-110deg);\n}\n\n/*******************************\n              States\n*******************************/\n\n.ui.disabled.reveal:hover > .visible.visible.content {\n  position: static !important;\n  display: block !important;\n  opacity: 1 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: auto !important;\n  bottom: auto !important;\n  -webkit-transform: none !important;\n  transform: none !important;\n}\n\n.ui.disabled.reveal:hover > .hidden.hidden.content {\n  display: none !important;\n}\n\n/*******************************\n           Coupling\n*******************************/\n\n.ui.reveal > .ui.ribbon.label {\n  z-index: 5;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Visible\n---------------*/\n\n.ui.visible.reveal {\n  overflow: visible;\n}\n\n/*--------------\n     Instant\n---------------*/\n\n.ui.instant.reveal > .content {\n  transition-delay: 0s !important;\n}\n\n/*--------------\n     Sizing\n---------------*/\n\n.ui.reveal > .content {\n  font-size: 1rem !important;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Segment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Segment\n*******************************/\n\n.ui.segment {\n  position: relative;\n  background: #FFFFFF;\n  box-shadow: none;\n  margin: 1rem 0em;\n  padding: 1em 1em;\n  border-radius: 0;\n  border: 1px solid #DEDEDF;\n}\n\n.ui.segment:first-child {\n  margin-top: 0em;\n}\n\n.ui.segment:last-child {\n  margin-bottom: 0em;\n}\n\n/* Vertical */\n\n.ui.vertical.segment {\n  margin: 0em;\n  padding-left: 0em;\n  padding-right: 0em;\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid #DEDEDF;\n}\n\n.ui.vertical.segment:last-child {\n  border-bottom: none;\n}\n\n/*-------------------\n    Loose Coupling\n--------------------*/\n\n/* Header */\n\n.ui.inverted.segment > .ui.header {\n  color: #FFFFFF;\n}\n\n/* Label */\n\n.ui[class*=\"bottom attached\"].segment > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n\n.ui[class*=\"top attached\"].segment > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"top attached\"].label {\n  border-top-left-radius: 0em;\n  border-top-right-radius: 0em;\n}\n\n.ui.attached.segment:not(.top):not(.bottom) > [class*=\"bottom attached\"].label {\n  border-bottom-left-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n\n/* Grid */\n\n.ui.page.grid.segment, .ui.grid > .row > .ui.segment.column, .ui.grid > .ui.segment.column {\n  padding-top: 2em;\n  padding-bottom: 2em;\n}\n\n.ui.grid.segment {\n  margin: 1rem 0em;\n  border-radius: 0;\n}\n\n/* Table */\n\n.ui.basic.table.segment {\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  box-shadow: none;\n}\n\n.ui[class*=\"very basic\"].table.segment {\n  padding: 1em 1em;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n     Placeholder\n--------------------*/\n\n.ui.placeholder.segment {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  max-width: initial;\n  -webkit-animation: none;\n  animation: none;\n  overflow: visible;\n  padding: 1em 1em;\n  min-height: 18rem;\n  background: #F9FAFB;\n  border-color: rgba(34, 36, 38, 0.15);\n  box-shadow: 0px 2px 25px 0 rgba(34, 36, 38, 0.05) inset;\n}\n\n.ui.placeholder.segment .button, .ui.placeholder.segment textarea {\n  display: block;\n}\n\n.ui.placeholder.segment .field, .ui.placeholder.segment textarea, .ui.placeholder.segment > .ui.input, .ui.placeholder.segment .button {\n  max-width: 15rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ui.placeholder.segment .column .button, .ui.placeholder.segment .column .field, .ui.placeholder.segment .column textarea, .ui.placeholder.segment .column > .ui.input {\n  max-width: 15rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ui.placeholder.segment > .inline {\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n      align-self: center;\n}\n\n.ui.placeholder.segment > .inline > .button {\n  display: inline-block;\n  width: auto;\n  margin: 0px 0.35714286rem 0px 0px;\n}\n\n.ui.placeholder.segment > .inline > .button:last-child {\n  margin-right: 0px;\n}\n\n/*-------------------\n        Piled\n--------------------*/\n\n.ui.piled.segments, .ui.piled.segment {\n  margin: 3em 0em;\n  box-shadow: '';\n  z-index: auto;\n}\n\n.ui.piled.segment:first-child {\n  margin-top: 0em;\n}\n\n.ui.piled.segment:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.piled.segments:after, .ui.piled.segments:before, .ui.piled.segment:after, .ui.piled.segment:before {\n  background-color: #FFFFFF;\n  visibility: visible;\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  width: 100%;\n  border: 1px solid #DEDEDF;\n  box-shadow: '';\n}\n\n.ui.piled.segments:before, .ui.piled.segment:before {\n  -webkit-transform: rotate(-1.2deg);\n  transform: rotate(-1.2deg);\n  top: 0;\n  z-index: -2;\n}\n\n.ui.piled.segments:after, .ui.piled.segment:after {\n  -webkit-transform: rotate(1.2deg);\n  transform: rotate(1.2deg);\n  top: 0;\n  z-index: -1;\n}\n\n/* Piled Attached */\n\n.ui[class*=\"top attached\"].piled.segment {\n  margin-top: 3em;\n  margin-bottom: 0em;\n}\n\n.ui.piled.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n.ui.piled.segment[class*=\"bottom attached\"] {\n  margin-top: 0em;\n  margin-bottom: 3em;\n}\n\n.ui.piled.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n       Stacked\n--------------------*/\n\n.ui.stacked.segment {\n  padding-bottom: 1.4em;\n}\n\n.ui.stacked.segments:before, .ui.stacked.segments:after, .ui.stacked.segment:before, .ui.stacked.segment:after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: 0%;\n  border-top: 1px solid #DEDEDF;\n  background: rgba(0, 0, 0, 0.03);\n  width: 100%;\n  height: 6px;\n  visibility: visible;\n}\n\n.ui.stacked.segments:before, .ui.stacked.segment:before {\n  display: none;\n}\n\n/* Add additional page */\n\n.ui.tall.stacked.segments:before, .ui.tall.stacked.segment:before {\n  display: block;\n  bottom: 0px;\n}\n\n/* Inverted */\n\n.ui.stacked.inverted.segments:before, .ui.stacked.inverted.segments:after, .ui.stacked.inverted.segment:before, .ui.stacked.inverted.segment:after {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(34, 36, 38, 0.35);\n}\n\n/*-------------------\n       Padded\n--------------------*/\n\n.ui.padded.segment {\n  padding: 1.5em;\n}\n\n.ui[class*=\"very padded\"].segment {\n  padding: 3em;\n}\n\n/* Padded vertical */\n\n.ui.padded.segment.vertical.segment, .ui[class*=\"very padded\"].vertical.segment {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.segment {\n  display: table;\n}\n\n/* Compact Group */\n\n.ui.compact.segments {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.ui.compact.segments .segment, .ui.segments .compact.segment {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n}\n\n/*-------------------\n       Circular\n--------------------*/\n\n.ui.circular.segment {\n  display: table-cell;\n  padding: 2em;\n  text-align: center;\n  vertical-align: middle;\n  border-radius: 500em;\n}\n\n/*-------------------\n       Raised\n--------------------*/\n\n.ui.raised.segments, .ui.raised.segment {\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n\n/*******************************\n            Groups\n*******************************/\n\n/* Group */\n\n.ui.segments {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  position: relative;\n  margin: 1rem 0em;\n  border: 1px solid #DEDEDF;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.ui.segments:first-child {\n  margin-top: 0em;\n}\n\n.ui.segments:last-child {\n  margin-bottom: 0em;\n}\n\n/* Nested Segment */\n\n.ui.segments > .segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em;\n  width: auto;\n  box-shadow: none;\n  border: none;\n  border-top: 1px solid #DEDEDF;\n}\n\n.ui.segments:not(.horizontal) > .segment:first-child {\n  border-top: none;\n  margin-top: 0em;\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  border-radius: 0 0 0em 0em;\n}\n\n/* Bottom */\n\n.ui.segments:not(.horizontal) > .segment:last-child {\n  top: 0px;\n  bottom: 0px;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  box-shadow: none, none;\n  border-radius: 0em 0em 0 0;\n}\n\n/* Only */\n\n.ui.segments:not(.horizontal) > .segment:only-child {\n  border-radius: 0;\n}\n\n/* Nested Group */\n\n.ui.segments > .ui.segments {\n  border-top: 1px solid #DEDEDF;\n  margin: 1rem 1rem;\n}\n\n.ui.segments > .segments:first-child {\n  border-top: none;\n}\n\n.ui.segments > .segment + .segments:not(.horizontal) {\n  margin-top: 0em;\n}\n\n/* Horizontal Group */\n\n.ui.horizontal.segments {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  background-color: transparent;\n  border-radius: 0px;\n  padding: 0em;\n  background-color: #FFFFFF;\n  box-shadow: none;\n  margin: 1rem 0em;\n  border-radius: 0;\n  border: 1px solid #DEDEDF;\n}\n\n/* Nested Horizontal Group */\n\n.ui.segments > .horizontal.segments {\n  margin: 0em;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-top: 1px solid #DEDEDF;\n}\n\n/* Horizontal Segment */\n\n.ui.horizontal.segments > .segment {\n  -webkit-box-flex: 1;\n  flex: 1 1 auto;\n  -ms-flex: 1 1 0px;\n  /* Solves #2550 MS Flex */\n  margin: 0em;\n  min-width: 0px;\n  background-color: transparent;\n  border-radius: 0px;\n  border: none;\n  box-shadow: none;\n  border-left: 1px solid #DEDEDF;\n}\n\n/* Border Fixes */\n\n.ui.segments > .horizontal.segments:first-child {\n  border-top: none;\n}\n\n.ui.horizontal.segments > .segment:first-child {\n  border-left: none;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n    Disabled\n---------------*/\n\n.ui.disabled.segment {\n  opacity: 0.45;\n  color: rgba(40, 40, 40, 0.3);\n}\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.segment {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n  text-shadow: none !important;\n  color: transparent !important;\n  transition: all 0s linear;\n}\n\n.ui.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: rgba(255, 255, 255, 0.8);\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  z-index: 100;\n}\n\n.ui.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -1.5em 0em 0em -1.5em;\n  width: 3em;\n  height: 3em;\n  -webkit-animation: segment-spin 0.6s linear;\n  animation: segment-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: 101;\n}\n\n@-webkit-keyframes segment-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes segment-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Basic\n--------------------*/\n\n.ui.basic.segment {\n  background: none transparent;\n  box-shadow: none;\n  border: none;\n  border-radius: 0px;\n}\n\n/*-------------------\n       Clearing\n--------------------*/\n\n.ui.clearing.segment:after {\n  content: \".\";\n  display: block;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n\n.ui.red.segment:not(.inverted) {\n  border-top: 2px solid #DB2828 !important;\n}\n\n.ui.inverted.red.segment {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n\n/* Orange */\n\n.ui.orange.segment:not(.inverted) {\n  border-top: 2px solid #FF9F5B;\n}\n\n.ui.inverted.orange.segment {\n  background-color: #FF9F5B !important;\n  color: #FFFFFF !important;\n}\n\n/* Yellow */\n\n.ui.yellow.segment:not(.inverted) {\n  border-top: 2px solid #F9DC5C;\n}\n\n.ui.inverted.yellow.segment {\n  background-color: #F9DC5C !important;\n  color: #FFFFFF !important;\n}\n\n/* Olive */\n\n.ui.olive.segment:not(.inverted) {\n  border-top: 2px solid #B5CC18 !important;\n}\n\n.ui.inverted.olive.segment {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n\n/* Green */\n\n.ui.green.segment:not(.inverted) {\n  border-top: 2px solid #59D98D;\n}\n\n.ui.inverted.green.segment {\n  background-color: #59D98D !important;\n  color: #FFFFFF !important;\n}\n\n/* Teal */\n\n.ui.teal.segment:not(.inverted) {\n  border-top: 2px solid #00B5AD !important;\n}\n\n.ui.inverted.teal.segment {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n\n/* Blue */\n\n.ui.blue.segment:not(.inverted) {\n  border-top: 2px solid #2185D0 !important;\n}\n\n.ui.inverted.blue.segment {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n\n/* Violet */\n\n.ui.violet.segment:not(.inverted) {\n  border-top: 2px solid #6435C9 !important;\n}\n\n.ui.inverted.violet.segment {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n\n/* Purple */\n\n.ui.purple.segment:not(.inverted) {\n  border-top: 2px solid #A333C8 !important;\n}\n\n.ui.inverted.purple.segment {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n\n/* Pink */\n\n.ui.pink.segment:not(.inverted) {\n  border-top: 2px solid #E03997 !important;\n}\n\n.ui.inverted.pink.segment {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n\n/* Brown */\n\n.ui.brown.segment:not(.inverted) {\n  border-top: 2px solid #A5673F !important;\n}\n\n.ui.inverted.brown.segment {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n\n/* Grey */\n\n.ui.grey.segment:not(.inverted) {\n  border-top: 2px solid rgba(0, 0, 0, 0.4);\n}\n\n.ui.inverted.grey.segment {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n  color: #FFFFFF !important;\n}\n\n/* Black */\n\n.ui.black.segment:not(.inverted) {\n  border-top: 2px solid #1B1C1D !important;\n}\n\n.ui.inverted.black.segment {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui[class*=\"left aligned\"].segment {\n  text-align: left;\n}\n\n.ui[class*=\"right aligned\"].segment {\n  text-align: right;\n}\n\n.ui[class*=\"center aligned\"].segment {\n  text-align: center;\n}\n\n/*-------------------\n       Floated\n--------------------*/\n\n.ui.floated.segment, .ui[class*=\"left floated\"].segment {\n  float: left;\n  margin-right: 1em;\n}\n\n.ui[class*=\"right floated\"].segment {\n  float: right;\n  margin-left: 1em;\n}\n\n/*-------------------\n      Inverted\n--------------------*/\n\n.ui.inverted.segment {\n  border: none;\n  box-shadow: none;\n}\n\n.ui.inverted.segment, .ui.primary.inverted.segment {\n  background: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Nested */\n\n.ui.inverted.segment .segment {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.inverted.segment .inverted.segment {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Attached */\n\n.ui.inverted.attached.segment {\n  border-color: #555555;\n}\n\n/*-------------------\n     Emphasis\n--------------------*/\n\n/* Secondary */\n\n.ui.secondary.segment {\n  background: #F3F4F5;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.secondary.inverted.segment {\n  background: #4c4f52 linear-gradient(rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Tertiary */\n\n.ui.tertiary.segment {\n  background: #DCDDDE;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.tertiary.inverted.segment {\n  background: #717579 linear-gradient(rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.35) 100%);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/*-------------------\n      Attached\n--------------------*/\n\n/* Middle */\n\n.ui.attached.segment {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% +  2px );\n  max-width: calc(100% +  2px );\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n}\n\n.ui.attached:not(.message) + .ui.attached.segment:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n\n.ui[class*=\"top attached\"].segment {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1rem;\n  border-radius: 0 0 0em 0em;\n}\n\n.ui.segment[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n\n.ui.segment[class*=\"bottom attached\"] {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1rem;\n  box-shadow: none, none;\n  border-radius: 0em 0em 0 0;\n}\n\n.ui.segment[class*=\"bottom attached\"]:last-child {\n  margin-bottom: 0em;\n}\n\n/*-------------------\n        Size\n--------------------*/\n\n.ui.mini.segments .segment, .ui.mini.segment {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.segments .segment, .ui.tiny.segment {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.segments .segment, .ui.small.segment {\n  font-size: 0.92857143rem;\n}\n\n.ui.segments .segment, .ui.segment {\n  font-size: 1rem;\n}\n\n.ui.large.segments .segment, .ui.large.segment {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.segments .segment, .ui.big.segment {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.segments .segment, .ui.huge.segment {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.segments .segment, .ui.massive.segment {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Step\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Plural\n*******************************/\n\n.ui.steps {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  margin: 1em 0em;\n  background: '';\n  box-shadow: none;\n  line-height: 1.14285714em;\n  border-radius: 0.21428571rem;\n  border: 1px solid #DEDEDF;\n}\n\n/* First Steps */\n\n.ui.steps:first-child {\n  margin-top: 0em;\n}\n\n/* Last Steps */\n\n.ui.steps:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n           Singular\n*******************************/\n\n.ui.steps .step {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  vertical-align: middle;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin: 0em 0em;\n  padding: 1.14285714em 2em;\n  background: #FFFFFF;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n  border-radius: 0em;\n  border: none;\n  border-right: 1px solid #DEDEDF;\n  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;\n}\n\n/* Arrow */\n\n.ui.steps .step:after {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  content: '';\n  top: 50%;\n  right: 0%;\n  border: medium none;\n  background-color: #FFFFFF;\n  width: 1.14285714em;\n  height: 1.14285714em;\n  border-style: solid;\n  border-color: #DEDEDF;\n  border-width: 0px 1px 1px 0px;\n  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;\n  -webkit-transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  transform: translateY(-50%) translateX(50%) rotate(-45deg);\n}\n\n/* First Step */\n\n.ui.steps .step:first-child {\n  padding-left: 2em;\n  border-radius: 0.21428571rem 0em 0em 0.21428571rem;\n}\n\n/* Last Step */\n\n.ui.steps .step:last-child {\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n.ui.steps .step:last-child {\n  border-right: none;\n  margin-right: 0em;\n}\n\n/* Only Step */\n\n.ui.steps .step:only-child {\n  border-radius: 0.21428571rem;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* Title */\n\n.ui.steps .step .title {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1.14285714em;\n  font-weight: bold;\n}\n\n.ui.steps .step > .title {\n  width: 100%;\n}\n\n/* Description */\n\n.ui.steps .step .description {\n  font-weight: normal;\n  font-size: 0.92857143em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.steps .step > .description {\n  width: 100%;\n}\n\n.ui.steps .step .title ~ .description {\n  margin-top: 0.25em;\n}\n\n/* Icon */\n\n.ui.steps .step > .icon {\n  line-height: 1;\n  font-size: 2.5em;\n  margin: 0em 1rem 0em 0em;\n}\n\n.ui.steps .step > .icon, .ui.steps .step > .icon ~ .content {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  -ms-flex-item-align: middle;\n  -ms-grid-row-align: middle;\n  align-self: middle;\n}\n\n.ui.steps .step > .icon ~ .content {\n  -webkit-box-flex: 1 0 auto;\n  -ms-flex-positive: 1 0 auto;\n  flex-grow: 1 0 auto;\n}\n\n/* Horizontal Icon */\n\n.ui.steps:not(.vertical) .step > .icon {\n  width: auto;\n}\n\n/* Link */\n\n.ui.steps .link.step, .ui.steps a.step {\n  cursor: pointer;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n     Ordered\n---------------*/\n\n.ui.ordered.steps {\n  counter-reset: ordered;\n}\n\n.ui.ordered.steps .step:before {\n  display: block;\n  position: static;\n  text-align: center;\n  content: counters(ordered, \".\");\n  -ms-flex-item-align: middle;\n  -ms-grid-row-align: middle;\n  align-self: middle;\n  margin-right: 1rem;\n  font-size: 2.5em;\n  counter-increment: ordered;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.ui.ordered.steps .step > * {\n  display: block;\n  -ms-flex-item-align: middle;\n  -ms-grid-row-align: middle;\n  align-self: middle;\n}\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.steps {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: visible;\n}\n\n.ui.vertical.steps .step {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  border-radius: 0em;\n  padding: 1.14285714em 2em;\n  border-right: none;\n  border-bottom: 1px solid #DEDEDF;\n}\n\n.ui.vertical.steps .step:first-child {\n  padding: 1.14285714em 2em;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.vertical.steps .step:last-child {\n  border-bottom: none;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui.vertical.steps .step:only-child {\n  border-radius: 0.21428571rem;\n}\n\n/* Arrow */\n\n.ui.vertical.steps .step:after {\n  display: none;\n}\n\n.ui.vertical.steps .step:after {\n  top: 50%;\n  right: 0%;\n  border-width: 0px 1px 1px 0px;\n}\n\n.ui.vertical.steps .step:after {\n  display: none;\n}\n\n.ui.vertical.steps .active.step:after {\n  display: block;\n}\n\n.ui.vertical.steps .step:last-child:after {\n  display: none;\n}\n\n.ui.vertical.steps .active.step:last-child:after {\n  display: block;\n}\n\n/*---------------\n    Responsive\n----------------*/\n\n/* Mobile (Default) */\n\n@media only screen and (max-width: 767px) {\n  .ui.steps:not(.unstackable) {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    overflow: visible;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n\n  .ui.steps:not(.unstackable) .step {\n    width: 100% !important;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-radius: 0em;\n    padding: 1.14285714em 2em;\n  }\n\n  .ui.steps:not(.unstackable) .step:first-child {\n    padding: 1.14285714em 2em;\n    border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n  }\n\n  .ui.steps .step:last-child {\n    border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  }\n\n  /* Arrow */\n\n  .ui.steps:not(.unstackable) .step:after {\n    display: none !important;\n  }\n\n  /* Content */\n\n  .ui.steps:not(.unstackable) .step .content {\n    text-align: center;\n  }\n\n  /* Icon */\n\n  .ui.steps:not(.unstackable) .step > .icon, .ui.ordered.steps:not(.unstackable) .step:before {\n    margin: 0em 0em 1rem 0em;\n  }\n}\n\n/*******************************\n             States\n*******************************/\n\n/* Link Hover */\n\n.ui.steps .link.step:hover::after, .ui.steps .link.step:hover, .ui.steps a.step:hover::after, .ui.steps a.step:hover {\n  background: #F9FAFB;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Link Down */\n\n.ui.steps .link.step:active::after, .ui.steps .link.step:active, .ui.steps a.step:active::after, .ui.steps a.step:active {\n  background: #F3F4F5;\n  color: rgba(0, 0, 0, 0.9);\n}\n\n/* Active */\n\n.ui.steps .step.active {\n  cursor: auto;\n  background: #F3F4F5;\n}\n\n.ui.steps .step.active:after {\n  background: #F3F4F5;\n}\n\n.ui.steps .step.active .title {\n  color: #FF9F5B;\n}\n\n.ui.ordered.steps .step.active:before, .ui.steps .active.step .icon {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/* Active Arrow */\n\n.ui.steps .step:after {\n  display: block;\n}\n\n.ui.steps .active.step:after {\n  display: block;\n}\n\n.ui.steps .step:last-child:after {\n  display: none;\n}\n\n.ui.steps .active.step:last-child:after {\n  display: none;\n}\n\n/* Active Hover */\n\n.ui.steps .link.active.step:hover::after, .ui.steps .link.active.step:hover, .ui.steps a.active.step:hover::after, .ui.steps a.active.step:hover {\n  cursor: pointer;\n  background: #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Completed */\n\n.ui.steps .step.completed > .icon:before, .ui.ordered.steps .step.completed:before {\n  color: #59D98D;\n}\n\n/* Disabled */\n\n.ui.steps .disabled.step {\n  cursor: auto;\n  background: #FFFFFF;\n  pointer-events: none;\n}\n\n.ui.steps .disabled.step, .ui.steps .disabled.step .title, .ui.steps .disabled.step .description {\n  color: rgba(40, 40, 40, 0.3);\n}\n\n.ui.steps .disabled.step:after {\n  background: #FFFFFF;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n   Stackable\n---------------*/\n\n/* Tablet Or Below */\n\n@media only screen and (max-width: 991px) {\n  .ui[class*=\"tablet stackable\"].steps {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    overflow: visible;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n\n  /* Steps */\n\n  .ui[class*=\"tablet stackable\"].steps .step {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-radius: 0em;\n    padding: 1.14285714em 2em;\n  }\n\n  .ui[class*=\"tablet stackable\"].steps .step:first-child {\n    padding: 1.14285714em 2em;\n    border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n  }\n\n  .ui[class*=\"tablet stackable\"].steps .step:last-child {\n    border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  }\n\n  /* Arrow */\n\n  .ui[class*=\"tablet stackable\"].steps .step:after {\n    display: none !important;\n  }\n\n  /* Content */\n\n  .ui[class*=\"tablet stackable\"].steps .step .content {\n    text-align: center;\n  }\n\n  /* Icon */\n\n  .ui[class*=\"tablet stackable\"].steps .step > .icon, .ui[class*=\"tablet stackable\"].ordered.steps .step:before {\n    margin: 0em 0em 1rem 0em;\n  }\n}\n\n/*--------------\n      Fluid\n---------------*/\n\n/* Fluid */\n\n.ui.fluid.steps {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n/* Top */\n\n.ui.attached.steps {\n  width: calc(100% + (--1px * 2)) !important;\n  margin: 0em -1px 0;\n  max-width: calc(100% +  2px );\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.attached.steps .step:first-child {\n  border-radius: 0.21428571rem 0em 0em 0em;\n}\n\n.ui.attached.steps .step:last-child {\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n/* Bottom */\n\n.ui.bottom.attached.steps {\n  margin: 0 -1px 0em;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui.bottom.attached.steps .step:first-child {\n  border-radius: 0em 0em 0em 0.21428571rem;\n}\n\n.ui.bottom.attached.steps .step:last-child {\n  border-radius: 0em 0em 0.21428571rem 0em;\n}\n\n/*-------------------\n    Evenly Divided\n--------------------*/\n\n.ui.one.steps, .ui.two.steps, .ui.three.steps, .ui.four.steps, .ui.five.steps, .ui.six.steps, .ui.seven.steps, .ui.eight.steps {\n  width: 100%;\n}\n\n.ui.one.steps > .step, .ui.two.steps > .step, .ui.three.steps > .step, .ui.four.steps > .step, .ui.five.steps > .step, .ui.six.steps > .step, .ui.seven.steps > .step, .ui.eight.steps > .step {\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n}\n\n.ui.one.steps > .step {\n  width: 100%;\n}\n\n.ui.two.steps > .step {\n  width: 50%;\n}\n\n.ui.three.steps > .step {\n  width: 33.333%;\n}\n\n.ui.four.steps > .step {\n  width: 25%;\n}\n\n.ui.five.steps > .step {\n  width: 20%;\n}\n\n.ui.six.steps > .step {\n  width: 16.666%;\n}\n\n.ui.seven.steps > .step {\n  width: 14.285%;\n}\n\n.ui.eight.steps > .step {\n  width: 12.5%;\n}\n\n/*-------------------\n       Sizes\n--------------------*/\n\n.ui.mini.steps .step, .ui.mini.step {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.steps .step, .ui.tiny.step {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.steps .step, .ui.small.step {\n  font-size: 0.92857143rem;\n}\n\n.ui.steps .step, .ui.step {\n  font-size: 1rem;\n}\n\n.ui.large.steps .step, .ui.large.step {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.steps .step, .ui.big.step {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.steps .step, .ui.huge.step {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.steps .step, .ui.massive.step {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Step';\n  src: url(data:application/x-font-ttf;charset=utf-8;;base64,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) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,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) format('woff');\n}\n\n.ui.steps .step.completed > .icon:before, .ui.ordered.steps .step.completed:before {\n  font-family: 'Step';\n  content: '\\E800';\n  /* '' */\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Breadcrumb\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           Breadcrumb\n*******************************/\n\n.ui.breadcrumb {\n  line-height: 1;\n  display: inline-block;\n  margin: 0em 0em;\n  vertical-align: middle;\n}\n\n.ui.breadcrumb:first-child {\n  margin-top: 0em;\n}\n\n.ui.breadcrumb:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n          Content\n*******************************/\n\n/* Divider */\n\n.ui.breadcrumb .divider {\n  display: inline-block;\n  opacity: 0.7;\n  margin: 0em 0.21428571rem 0em;\n  font-size: 0.92857143em;\n  color: rgba(0, 0, 0, 0.4);\n  vertical-align: baseline;\n}\n\n/* Link */\n\n.ui.breadcrumb a {\n  color: #FF9F5B;\n}\n\n.ui.breadcrumb a:hover {\n  color: #ff8127;\n}\n\n/* Icon Divider */\n\n.ui.breadcrumb .icon.divider {\n  font-size: 0.85714286em;\n  vertical-align: baseline;\n}\n\n/* Section */\n\n.ui.breadcrumb a.section {\n  cursor: pointer;\n}\n\n.ui.breadcrumb .section {\n  display: inline-block;\n  margin: 0em;\n  padding: 0em;\n}\n\n/* Loose Coupling */\n\n.ui.breadcrumb.segment {\n  display: inline-block;\n  padding: 0.78571429em 1em;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.breadcrumb .active.section {\n  font-weight: bold;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n.ui.mini.breadcrumb {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.breadcrumb {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.breadcrumb {\n  font-size: 0.92857143rem;\n}\n\n.ui.breadcrumb {\n  font-size: 1rem;\n}\n\n.ui.large.breadcrumb {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.breadcrumb {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.breadcrumb {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.breadcrumb {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Form\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Elements\n*******************************/\n\n/*--------------------\n        Form\n---------------------*/\n\n.ui.form {\n  position: relative;\n  max-width: 100%;\n}\n\n/*--------------------\n        Content\n---------------------*/\n\n.ui.form > p {\n  margin: 1em 0em;\n}\n\n/*--------------------\n        Field\n---------------------*/\n\n.ui.form .field {\n  clear: both;\n  margin: 0em 0em 1em;\n}\n\n.ui.form .field:last-child, .ui.form .fields:last-child .field {\n  margin-bottom: 0em;\n}\n\n.ui.form .fields .field {\n  clear: both;\n  margin: 0em;\n}\n\n/*--------------------\n        Labels\n---------------------*/\n\n.ui.form .field > label {\n  display: block;\n  margin: 0em 0em 0.28571429rem 0em;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 0.92857143em;\n  font-weight: bold;\n  text-transform: none;\n}\n\n/*--------------------\n    Standard Inputs\n---------------------*/\n\n.ui.form textarea, .ui.form input:not([type]), .ui.form input[type=\"date\"], .ui.form input[type=\"datetime-local\"], .ui.form input[type=\"email\"], .ui.form input[type=\"number\"], .ui.form input[type=\"password\"], .ui.form input[type=\"search\"], .ui.form input[type=\"tel\"], .ui.form input[type=\"time\"], .ui.form input[type=\"text\"], .ui.form input[type=\"file\"], .ui.form input[type=\"url\"] {\n  width: 100%;\n  vertical-align: top;\n}\n\n/* Set max height on unusual input */\n\n.ui.form ::-webkit-datetime-edit, .ui.form ::-webkit-inner-spin-button {\n  height: 1.21428571em;\n}\n\n.ui.form input:not([type]), .ui.form input[type=\"date\"], .ui.form input[type=\"datetime-local\"], .ui.form input[type=\"email\"], .ui.form input[type=\"number\"], .ui.form input[type=\"password\"], .ui.form input[type=\"search\"], .ui.form input[type=\"tel\"], .ui.form input[type=\"time\"], .ui.form input[type=\"text\"], .ui.form input[type=\"file\"], .ui.form input[type=\"url\"] {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  line-height: 1.21428571em;\n  padding: 0.67857143em 1em;\n  font-size: 1em;\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0.21428571rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: color 0.1s ease, border-color 0.1s ease;\n}\n\n/* Text Area */\n\n.ui.form textarea {\n  margin: 0em;\n  -webkit-appearance: none;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  padding: 0.78571429em 1em;\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  outline: none;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0.21428571rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: color 0.1s ease, border-color 0.1s ease;\n  font-size: 1em;\n  line-height: 1.2857;\n  resize: vertical;\n}\n\n.ui.form textarea:not([rows]) {\n  height: 12em;\n  min-height: 8em;\n  max-height: 24em;\n}\n\n.ui.form textarea, .ui.form input[type=\"checkbox\"] {\n  vertical-align: top;\n}\n\n/*--------------------------\n  Input w/ attached Button\n---------------------------*/\n\n.ui.form input.attached {\n  width: auto;\n}\n\n/*--------------------\n     Basic Select\n---------------------*/\n\n.ui.form select {\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  border-radius: 0.21428571rem;\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  padding: 0.62em 1em;\n  color: rgba(0, 0, 0, 0.8);\n  transition: color 0.1s ease, border-color 0.1s ease;\n}\n\n/*--------------------\n       Dropdown\n---------------------*/\n\n/* Block */\n\n.ui.form .field > .selection.dropdown {\n  width: 100%;\n}\n\n.ui.form .field > .selection.dropdown > .dropdown.icon {\n  float: right;\n}\n\n/* Inline */\n\n.ui.form .inline.fields .field > .selection.dropdown, .ui.form .inline.field > .selection.dropdown {\n  width: auto;\n}\n\n.ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon, .ui.form .inline.field > .selection.dropdown > .dropdown.icon {\n  float: none;\n}\n\n/*--------------------\n       UI Input\n---------------------*/\n\n/* Block */\n\n.ui.form .field .ui.input, .ui.form .fields .field .ui.input, .ui.form .wide.field .ui.input {\n  width: 100%;\n}\n\n/* Inline  */\n\n.ui.form .inline.fields .field:not(.wide) .ui.input, .ui.form .inline.field:not(.wide) .ui.input {\n  width: auto;\n  vertical-align: middle;\n}\n\n/* Auto Input */\n\n.ui.form .fields .field .ui.input input, .ui.form .field .ui.input input {\n  width: auto;\n}\n\n/* Full Width Input */\n\n.ui.form .ten.fields .ui.input input, .ui.form .nine.fields .ui.input input, .ui.form .eight.fields .ui.input input, .ui.form .seven.fields .ui.input input, .ui.form .six.fields .ui.input input, .ui.form .five.fields .ui.input input, .ui.form .four.fields .ui.input input, .ui.form .three.fields .ui.input input, .ui.form .two.fields .ui.input input, .ui.form .wide.field .ui.input input {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  width: 0px;\n}\n\n/*--------------------\n   Types of Messages\n---------------------*/\n\n.ui.form .success.message, .ui.form .warning.message, .ui.form .error.message {\n  display: none;\n}\n\n/* Assumptions */\n\n.ui.form .message:first-child {\n  margin-top: 0px;\n}\n\n/*--------------------\n   Validation Prompt\n---------------------*/\n\n.ui.form .field .prompt.label {\n  white-space: normal;\n  background: #FFFFFF !important;\n  border: 1px solid #E0B4B4 !important;\n  color: #9F3A38 !important;\n}\n\n.ui.form .inline.fields .field .prompt, .ui.form .inline.field .prompt {\n  vertical-align: top;\n  margin: -0.25em 0em -0.5em 0.5em;\n}\n\n.ui.form .inline.fields .field .prompt:before, .ui.form .inline.field .prompt:before {\n  border-width: 0px 0px 1px 1px;\n  bottom: auto;\n  right: auto;\n  top: 50%;\n  left: 0em;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n      Autofilled\n---------------------*/\n\n.ui.form .field.field input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;\n  border-color: #E5DFA1 !important;\n}\n\n/* Focus */\n\n.ui.form .field.field input:-webkit-autofill:focus {\n  box-shadow: 0px 0px 0px 100px #FFFFF0 inset !important;\n  border-color: #D5C315 !important;\n}\n\n/* Error */\n\n.ui.form .error.error input:-webkit-autofill {\n  box-shadow: 0px 0px 0px 100px #FFFAF0 inset !important;\n  border-color: #E0B4B4 !important;\n}\n\n/*--------------------\n      Placeholder\n---------------------*/\n\n/* browsers require these rules separate */\n\n.ui.form ::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.form :-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.form ::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.form :focus::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.ui.form :focus:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.ui.form :focus::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n/* Error Placeholder */\n\n.ui.form .error ::-webkit-input-placeholder {\n  color: #e7bdbc;\n}\n\n.ui.form .error :-ms-input-placeholder {\n  color: #e7bdbc !important;\n}\n\n.ui.form .error ::-moz-placeholder {\n  color: #e7bdbc;\n}\n\n.ui.form .error :focus::-webkit-input-placeholder {\n  color: #da9796;\n}\n\n.ui.form .error :focus:-ms-input-placeholder {\n  color: #da9796 !important;\n}\n\n.ui.form .error :focus::-moz-placeholder {\n  color: #da9796;\n}\n\n/*--------------------\n        Focus\n---------------------*/\n\n.ui.form input:not([type]):focus, .ui.form input[type=\"date\"]:focus, .ui.form input[type=\"datetime-local\"]:focus, .ui.form input[type=\"email\"]:focus, .ui.form input[type=\"number\"]:focus, .ui.form input[type=\"password\"]:focus, .ui.form input[type=\"search\"]:focus, .ui.form input[type=\"tel\"]:focus, .ui.form input[type=\"time\"]:focus, .ui.form input[type=\"text\"]:focus, .ui.form input[type=\"file\"]:focus, .ui.form input[type=\"url\"]:focus {\n  color: rgba(0, 0, 0, 0.8);\n  border-color: rgba(0, 0, 0, 0.4);\n  border-radius: 0.21428571rem;\n  background: #FFFFFF;\n  box-shadow: 0px 0em 0em 0em rgba(34, 36, 38, 0.35) inset;\n}\n\n.ui.form textarea:focus {\n  color: rgba(0, 0, 0, 0.8);\n  border-color: rgba(0, 0, 0, 0.4);\n  border-radius: 0.21428571rem;\n  background: #FFFFFF;\n  box-shadow: 0px 0em 0em 0em rgba(34, 36, 38, 0.35) inset;\n  -webkit-appearance: none;\n}\n\n/*--------------------\n        Success\n---------------------*/\n\n/* On Form */\n\n.ui.form.success .success.message:not(:empty) {\n  display: block;\n}\n\n.ui.form.success .compact.success.message:not(:empty) {\n  display: inline-block;\n}\n\n.ui.form.success .icon.success.message:not(:empty) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*--------------------\n        Warning\n---------------------*/\n\n/* On Form */\n\n.ui.form.warning .warning.message:not(:empty) {\n  display: block;\n}\n\n.ui.form.warning .compact.warning.message:not(:empty) {\n  display: inline-block;\n}\n\n.ui.form.warning .icon.warning.message:not(:empty) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*--------------------\n        Error\n---------------------*/\n\n/* On Form */\n\n.ui.form.error .error.message:not(:empty) {\n  display: block;\n}\n\n.ui.form.error .compact.error.message:not(:empty) {\n  display: inline-block;\n}\n\n.ui.form.error .icon.error.message:not(:empty) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/* On Field(s) */\n\n.ui.form .fields.error .field label, .ui.form .field.error label, .ui.form .fields.error .field .input, .ui.form .field.error .input {\n  color: #9F3A38;\n}\n\n.ui.form .fields.error .field .corner.label, .ui.form .field.error .corner.label {\n  border-color: #9F3A38;\n  color: #FFFFFF;\n}\n\n.ui.form .fields.error .field textarea, .ui.form .fields.error .field select, .ui.form .fields.error .field input:not([type]), .ui.form .fields.error .field input[type=\"date\"], .ui.form .fields.error .field input[type=\"datetime-local\"], .ui.form .fields.error .field input[type=\"email\"], .ui.form .fields.error .field input[type=\"number\"], .ui.form .fields.error .field input[type=\"password\"], .ui.form .fields.error .field input[type=\"search\"], .ui.form .fields.error .field input[type=\"tel\"], .ui.form .fields.error .field input[type=\"time\"], .ui.form .fields.error .field input[type=\"text\"], .ui.form .fields.error .field input[type=\"file\"], .ui.form .fields.error .field input[type=\"url\"], .ui.form .field.error textarea, .ui.form .field.error select, .ui.form .field.error input:not([type]), .ui.form .field.error input[type=\"date\"], .ui.form .field.error input[type=\"datetime-local\"], .ui.form .field.error input[type=\"email\"], .ui.form .field.error input[type=\"number\"], .ui.form .field.error input[type=\"password\"], .ui.form .field.error input[type=\"search\"], .ui.form .field.error input[type=\"tel\"], .ui.form .field.error input[type=\"time\"], .ui.form .field.error input[type=\"text\"], .ui.form .field.error input[type=\"file\"], .ui.form .field.error input[type=\"url\"] {\n  background: #FFF6F6;\n  border-color: #E0B4B4;\n  color: #9F3A38;\n  border-radius: '';\n  box-shadow: none;\n}\n\n.ui.form .field.error textarea:focus, .ui.form .field.error select:focus, .ui.form .field.error input:not([type]):focus, .ui.form .field.error input[type=\"date\"]:focus, .ui.form .field.error input[type=\"datetime-local\"]:focus, .ui.form .field.error input[type=\"email\"]:focus, .ui.form .field.error input[type=\"number\"]:focus, .ui.form .field.error input[type=\"password\"]:focus, .ui.form .field.error input[type=\"search\"]:focus, .ui.form .field.error input[type=\"tel\"]:focus, .ui.form .field.error input[type=\"time\"]:focus, .ui.form .field.error input[type=\"text\"]:focus, .ui.form .field.error input[type=\"file\"]:focus, .ui.form .field.error input[type=\"url\"]:focus {\n  background: #FFF6F6;\n  border-color: #E0B4B4;\n  color: #9F3A38;\n  -webkit-appearance: none;\n  box-shadow: none;\n}\n\n/* Preserve Native Select Stylings */\n\n.ui.form .field.error select {\n  -webkit-appearance: menulist-button;\n}\n\n/*------------------\n    Dropdown Error\n--------------------*/\n\n.ui.form .fields.error .field .ui.dropdown, .ui.form .fields.error .field .ui.dropdown .item, .ui.form .field.error .ui.dropdown, .ui.form .field.error .ui.dropdown .text, .ui.form .field.error .ui.dropdown .item {\n  background: #FFF6F6;\n  color: #9F3A38;\n}\n\n.ui.form .fields.error .field .ui.dropdown, .ui.form .field.error .ui.dropdown {\n  border-color: #E0B4B4 !important;\n}\n\n.ui.form .fields.error .field .ui.dropdown:hover, .ui.form .field.error .ui.dropdown:hover {\n  border-color: #E0B4B4 !important;\n}\n\n.ui.form .fields.error .field .ui.dropdown:hover .menu, .ui.form .field.error .ui.dropdown:hover .menu {\n  border-color: #E0B4B4;\n}\n\n.ui.form .fields.error .field .ui.multiple.selection.dropdown > .label, .ui.form .field.error .ui.multiple.selection.dropdown > .label {\n  background-color: #EACBCB;\n  color: #9F3A38;\n}\n\n/* Hover */\n\n.ui.form .fields.error .field .ui.dropdown .menu .item:hover, .ui.form .field.error .ui.dropdown .menu .item:hover {\n  background-color: #FBE7E7;\n}\n\n/* Selected */\n\n.ui.form .fields.error .field .ui.dropdown .menu .selected.item, .ui.form .field.error .ui.dropdown .menu .selected.item {\n  background-color: #FBE7E7;\n}\n\n/* Active */\n\n.ui.form .fields.error .field .ui.dropdown .menu .active.item, .ui.form .field.error .ui.dropdown .menu .active.item {\n  background-color: #FDCFCF !important;\n}\n\n/*--------------------\n    Checkbox Error\n---------------------*/\n\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label, .ui.form .field.error .checkbox:not(.toggle):not(.slider) label, .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box, .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {\n  color: #9F3A38;\n}\n\n.ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before, .ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before, .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before, .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {\n  background: #FFF6F6;\n  border-color: #E0B4B4;\n}\n\n.ui.form .fields.error .field .checkbox label:after, .ui.form .field.error .checkbox label:after, .ui.form .fields.error .field .checkbox .box:after, .ui.form .field.error .checkbox .box:after {\n  color: #9F3A38;\n}\n\n/*--------------------\n       Disabled\n---------------------*/\n\n.ui.form .disabled.fields .field, .ui.form .disabled.field, .ui.form .field :disabled {\n  pointer-events: none;\n  opacity: 0.45;\n}\n\n.ui.form .field.disabled > label, .ui.form .fields.disabled > label {\n  opacity: 0.45;\n}\n\n.ui.form .field.disabled :disabled {\n  opacity: 1;\n}\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.form {\n  position: relative;\n  cursor: default;\n  pointer-events: none;\n}\n\n.ui.loading.form:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0%;\n  background: rgba(255, 255, 255, 0.8);\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.ui.loading.form:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -1.5em 0em 0em -1.5em;\n  width: 3em;\n  height: 3em;\n  -webkit-animation: form-spin 0.6s linear;\n  animation: form-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n  visibility: visible;\n  z-index: 101;\n}\n\n@-webkit-keyframes form-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes form-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*******************************\n         Element Types\n*******************************/\n\n/*--------------------\n     Required Field\n---------------------*/\n\n.ui.form .required.fields:not(.grouped) > .field > label:after, .ui.form .required.fields.grouped > label:after, .ui.form .required.field > label:after, .ui.form .required.fields:not(.grouped) > .field > .checkbox:after, .ui.form .required.field > .checkbox:after {\n  margin: -0.2em 0em 0em 0.2em;\n  content: '*';\n  color: #DB2828;\n}\n\n.ui.form .required.fields:not(.grouped) > .field > label:after, .ui.form .required.fields.grouped > label:after, .ui.form .required.field > label:after {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.ui.form .required.fields:not(.grouped) > .field > .checkbox:after, .ui.form .required.field > .checkbox:after {\n  position: absolute;\n  top: 0%;\n  left: 100%;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------------\n    Inverted Colors\n---------------------*/\n\n.ui.inverted.form label, .ui.form .inverted.segment label, .ui.form .inverted.segment .ui.checkbox label, .ui.form .inverted.segment .ui.checkbox .box, .ui.inverted.form .ui.checkbox label, .ui.inverted.form .ui.checkbox .box, .ui.inverted.form .inline.fields > label, .ui.inverted.form .inline.fields .field > label, .ui.inverted.form .inline.fields .field > p, .ui.inverted.form .inline.field > label, .ui.inverted.form .inline.field > p {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Inverted Field */\n\n.ui.inverted.form input:not([type]), .ui.inverted.form input[type=\"date\"], .ui.inverted.form input[type=\"datetime-local\"], .ui.inverted.form input[type=\"email\"], .ui.inverted.form input[type=\"number\"], .ui.inverted.form input[type=\"password\"], .ui.inverted.form input[type=\"search\"], .ui.inverted.form input[type=\"tel\"], .ui.inverted.form input[type=\"time\"], .ui.inverted.form input[type=\"text\"], .ui.inverted.form input[type=\"file\"], .ui.inverted.form input[type=\"url\"] {\n  background: #FFFFFF;\n  border-color: rgba(255, 255, 255, 0.1);\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n}\n\n/*--------------------\n     Field Groups\n---------------------*/\n\n/* Grouped Vertically */\n\n.ui.form .grouped.fields {\n  display: block;\n  margin: 0em 0em 1em;\n}\n\n.ui.form .grouped.fields:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.form .grouped.fields > label {\n  margin: 0em 0em 0.28571429rem 0em;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 0.92857143em;\n  font-weight: bold;\n  text-transform: none;\n}\n\n.ui.form .grouped.fields .field, .ui.form .grouped.inline.fields .field {\n  display: block;\n  margin: 0.5em 0em;\n  padding: 0em;\n}\n\n/*--------------------\n        Fields\n---------------------*/\n\n/* Split fields */\n\n.ui.form .fields {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  margin: 0em -0.5em 1em;\n}\n\n.ui.form .fields > .field {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n\n.ui.form .fields > .field:first-child {\n  border-left: none;\n  box-shadow: none;\n}\n\n/* Other Combinations */\n\n.ui.form .two.fields > .fields, .ui.form .two.fields > .field {\n  width: 50%;\n}\n\n.ui.form .three.fields > .fields, .ui.form .three.fields > .field {\n  width: 33.33333333%;\n}\n\n.ui.form .four.fields > .fields, .ui.form .four.fields > .field {\n  width: 25%;\n}\n\n.ui.form .five.fields > .fields, .ui.form .five.fields > .field {\n  width: 20%;\n}\n\n.ui.form .six.fields > .fields, .ui.form .six.fields > .field {\n  width: 16.66666667%;\n}\n\n.ui.form .seven.fields > .fields, .ui.form .seven.fields > .field {\n  width: 14.28571429%;\n}\n\n.ui.form .eight.fields > .fields, .ui.form .eight.fields > .field {\n  width: 12.5%;\n}\n\n.ui.form .nine.fields > .fields, .ui.form .nine.fields > .field {\n  width: 11.11111111%;\n}\n\n.ui.form .ten.fields > .fields, .ui.form .ten.fields > .field {\n  width: 10%;\n}\n\n/* Swap to full width on mobile */\n\n@media only screen and (max-width: 767px) {\n  .ui.form .fields {\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n\n  .ui[class*=\"equal width\"].form:not(.unstackable) .fields > .field, .ui.form:not(.unstackable) [class*=\"equal width\"].fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {\n    width: 100% !important;\n    margin: 0em 0em 1em;\n  }\n}\n\n/* Sizing Combinations */\n\n.ui.form .fields .wide.field {\n  width: 6.25%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n\n.ui.form .one.wide.field {\n  width: 6.25% !important;\n}\n\n.ui.form .two.wide.field {\n  width: 12.5% !important;\n}\n\n.ui.form .three.wide.field {\n  width: 18.75% !important;\n}\n\n.ui.form .four.wide.field {\n  width: 25% !important;\n}\n\n.ui.form .five.wide.field {\n  width: 31.25% !important;\n}\n\n.ui.form .six.wide.field {\n  width: 37.5% !important;\n}\n\n.ui.form .seven.wide.field {\n  width: 43.75% !important;\n}\n\n.ui.form .eight.wide.field {\n  width: 50% !important;\n}\n\n.ui.form .nine.wide.field {\n  width: 56.25% !important;\n}\n\n.ui.form .ten.wide.field {\n  width: 62.5% !important;\n}\n\n.ui.form .eleven.wide.field {\n  width: 68.75% !important;\n}\n\n.ui.form .twelve.wide.field {\n  width: 75% !important;\n}\n\n.ui.form .thirteen.wide.field {\n  width: 81.25% !important;\n}\n\n.ui.form .fourteen.wide.field {\n  width: 87.5% !important;\n}\n\n.ui.form .fifteen.wide.field {\n  width: 93.75% !important;\n}\n\n.ui.form .sixteen.wide.field {\n  width: 100% !important;\n}\n\n/* Swap to full width on mobile */\n\n@media only screen and (max-width: 767px) {\n  .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields, .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field, .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {\n    width: 100% !important;\n  }\n\n  .ui.form .fields {\n    margin-bottom: 0em;\n  }\n}\n\n/*--------------------\n     Equal Width\n---------------------*/\n\n.ui[class*=\"equal width\"].form .fields > .field, .ui.form [class*=\"equal width\"].fields > .field {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n\n/*--------------------\n    Inline Fields\n---------------------*/\n\n.ui.form .inline.fields {\n  margin: 0em 0em 1em;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ui.form .inline.fields .field {\n  margin: 0em;\n  padding: 0em 1em 0em 0em;\n}\n\n/* Inline Label */\n\n.ui.form .inline.fields > label, .ui.form .inline.fields .field > label, .ui.form .inline.fields .field > p, .ui.form .inline.field > label, .ui.form .inline.field > p {\n  display: inline-block;\n  width: auto;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  vertical-align: baseline;\n  font-size: 0.92857143em;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n  text-transform: none;\n}\n\n/* Grouped Inline Label */\n\n.ui.form .inline.fields > label {\n  margin: 0.035714em 1em 0em 0em;\n}\n\n/* Inline Input */\n\n.ui.form .inline.fields .field > input, .ui.form .inline.fields .field > select, .ui.form .inline.field > input, .ui.form .inline.field > select {\n  display: inline-block;\n  width: auto;\n  margin-top: 0em;\n  margin-bottom: 0em;\n  vertical-align: middle;\n  font-size: 1em;\n}\n\n/* Label */\n\n.ui.form .inline.fields .field > :first-child, .ui.form .inline.field > :first-child {\n  margin: 0em 0.85714286em 0em 0em;\n}\n\n.ui.form .inline.fields .field > :only-child, .ui.form .inline.field > :only-child {\n  margin: 0em;\n}\n\n/* Wide */\n\n.ui.form .inline.fields .wide.field {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ui.form .inline.fields .wide.field > input, .ui.form .inline.fields .wide.field > select {\n  width: 100%;\n}\n\n/*--------------------\n        Sizes\n---------------------*/\n\n.ui.mini.form {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.form {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.form {\n  font-size: 0.92857143rem;\n}\n\n.ui.form {\n  font-size: 1rem;\n}\n\n.ui.large.form {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.form {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.form {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.form {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Grid\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Standard\n*******************************/\n\n.ui.grid {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  padding: 0em;\n}\n\n/*----------------------\n      Remove Gutters\n-----------------------*/\n\n.ui.grid {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n\n.ui.relaxed.grid {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n\n.ui[class*=\"very relaxed\"].grid {\n  margin-left: -2.5rem;\n  margin-right: -2.5rem;\n}\n\n/* Preserve Rows Spacing on Consecutive Grids */\n\n.ui.grid + .grid {\n  margin-top: 1rem;\n}\n\n/*-------------------\n       Columns\n--------------------*/\n\n/* Standard 16 column */\n\n.ui.grid > .column:not(.row), .ui.grid > .row > .column {\n  position: relative;\n  display: inline-block;\n  width: 6.25%;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  vertical-align: top;\n}\n\n.ui.grid > * {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n/*-------------------\n        Rows\n--------------------*/\n\n.ui.grid > .row {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: inherit;\n  -ms-flex-pack: inherit;\n  justify-content: inherit;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100% !important;\n  padding: 0rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n/*-------------------\n       Columns\n--------------------*/\n\n/* Vertical padding when no rows */\n\n.ui.grid > .column:not(.row) {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.ui.grid > .row > .column {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n\n/*-------------------\n      Content\n--------------------*/\n\n.ui.grid > .row > img, .ui.grid > .row > .column > img {\n  max-width: 100%;\n}\n\n/*-------------------\n    Loose Coupling\n--------------------*/\n\n/* Collapse Margin on Consecutive Grid */\n\n.ui.grid > .ui.grid:first-child {\n  margin-top: 0em;\n}\n\n.ui.grid > .ui.grid:last-child {\n  margin-bottom: 0em;\n}\n\n/* Segment inside Aligned Grid */\n\n.ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached), .ui.aligned.grid .column > .segment:not(.compact):not(.attached) {\n  width: 100%;\n}\n\n/* Align Dividers with Gutter */\n\n.ui.grid .row + .ui.divider {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  margin: 1rem 1rem;\n}\n\n.ui.grid .column + .ui.vertical.divider {\n  height: calc(50% - (2rem / 2));\n}\n\n/* Remove Border on Last Horizontal Segment */\n\n.ui.grid > .row > .column:last-child > .horizontal.segment, .ui.grid > .column:last-child > .horizontal.segment {\n  box-shadow: none;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-----------------------\n       Page Grid\n-------------------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.page.grid {\n    width: auto;\n    padding-left: 0em;\n    padding-right: 0em;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 2em;\n    padding-right: 2em;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 3%;\n    padding-right: 3%;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 15%;\n    padding-right: 15%;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.page.grid {\n    width: auto;\n    margin-left: 0em;\n    margin-right: 0em;\n    padding-left: 23%;\n    padding-right: 23%;\n  }\n}\n\n/*-------------------\n     Column Count\n--------------------*/\n\n/* Assume full width with one column */\n\n.ui.grid > .column:only-child, .ui.grid > .row > .column:only-child {\n  width: 100%;\n}\n\n/* Grid Based */\n\n.ui[class*=\"one column\"].grid > .row > .column, .ui[class*=\"one column\"].grid > .column:not(.row) {\n  width: 100%;\n}\n\n.ui[class*=\"two column\"].grid > .row > .column, .ui[class*=\"two column\"].grid > .column:not(.row) {\n  width: 50%;\n}\n\n.ui[class*=\"three column\"].grid > .row > .column, .ui[class*=\"three column\"].grid > .column:not(.row) {\n  width: 33.33333333%;\n}\n\n.ui[class*=\"four column\"].grid > .row > .column, .ui[class*=\"four column\"].grid > .column:not(.row) {\n  width: 25%;\n}\n\n.ui[class*=\"five column\"].grid > .row > .column, .ui[class*=\"five column\"].grid > .column:not(.row) {\n  width: 20%;\n}\n\n.ui[class*=\"six column\"].grid > .row > .column, .ui[class*=\"six column\"].grid > .column:not(.row) {\n  width: 16.66666667%;\n}\n\n.ui[class*=\"seven column\"].grid > .row > .column, .ui[class*=\"seven column\"].grid > .column:not(.row) {\n  width: 14.28571429%;\n}\n\n.ui[class*=\"eight column\"].grid > .row > .column, .ui[class*=\"eight column\"].grid > .column:not(.row) {\n  width: 12.5%;\n}\n\n.ui[class*=\"nine column\"].grid > .row > .column, .ui[class*=\"nine column\"].grid > .column:not(.row) {\n  width: 11.11111111%;\n}\n\n.ui[class*=\"ten column\"].grid > .row > .column, .ui[class*=\"ten column\"].grid > .column:not(.row) {\n  width: 10%;\n}\n\n.ui[class*=\"eleven column\"].grid > .row > .column, .ui[class*=\"eleven column\"].grid > .column:not(.row) {\n  width: 9.09090909%;\n}\n\n.ui[class*=\"twelve column\"].grid > .row > .column, .ui[class*=\"twelve column\"].grid > .column:not(.row) {\n  width: 8.33333333%;\n}\n\n.ui[class*=\"thirteen column\"].grid > .row > .column, .ui[class*=\"thirteen column\"].grid > .column:not(.row) {\n  width: 7.69230769%;\n}\n\n.ui[class*=\"fourteen column\"].grid > .row > .column, .ui[class*=\"fourteen column\"].grid > .column:not(.row) {\n  width: 7.14285714%;\n}\n\n.ui[class*=\"fifteen column\"].grid > .row > .column, .ui[class*=\"fifteen column\"].grid > .column:not(.row) {\n  width: 6.66666667%;\n}\n\n.ui[class*=\"sixteen column\"].grid > .row > .column, .ui[class*=\"sixteen column\"].grid > .column:not(.row) {\n  width: 6.25%;\n}\n\n/* Row Based Overrides */\n\n.ui.grid > [class*=\"one column\"].row > .column {\n  width: 100% !important;\n}\n\n.ui.grid > [class*=\"two column\"].row > .column {\n  width: 50% !important;\n}\n\n.ui.grid > [class*=\"three column\"].row > .column {\n  width: 33.33333333% !important;\n}\n\n.ui.grid > [class*=\"four column\"].row > .column {\n  width: 25% !important;\n}\n\n.ui.grid > [class*=\"five column\"].row > .column {\n  width: 20% !important;\n}\n\n.ui.grid > [class*=\"six column\"].row > .column {\n  width: 16.66666667% !important;\n}\n\n.ui.grid > [class*=\"seven column\"].row > .column {\n  width: 14.28571429% !important;\n}\n\n.ui.grid > [class*=\"eight column\"].row > .column {\n  width: 12.5% !important;\n}\n\n.ui.grid > [class*=\"nine column\"].row > .column {\n  width: 11.11111111% !important;\n}\n\n.ui.grid > [class*=\"ten column\"].row > .column {\n  width: 10% !important;\n}\n\n.ui.grid > [class*=\"eleven column\"].row > .column {\n  width: 9.09090909% !important;\n}\n\n.ui.grid > [class*=\"twelve column\"].row > .column {\n  width: 8.33333333% !important;\n}\n\n.ui.grid > [class*=\"thirteen column\"].row > .column {\n  width: 7.69230769% !important;\n}\n\n.ui.grid > [class*=\"fourteen column\"].row > .column {\n  width: 7.14285714% !important;\n}\n\n.ui.grid > [class*=\"fifteen column\"].row > .column {\n  width: 6.66666667% !important;\n}\n\n.ui.grid > [class*=\"sixteen column\"].row > .column {\n  width: 6.25% !important;\n}\n\n/* Celled Page */\n\n.ui.celled.page.grid {\n  box-shadow: none;\n}\n\n/*-------------------\n    Column Width\n--------------------*/\n\n/* Sizing Combinations */\n\n.ui.grid > .row > [class*=\"one wide\"].column, .ui.grid > .column.row > [class*=\"one wide\"].column, .ui.grid > [class*=\"one wide\"].column, .ui.column.grid > [class*=\"one wide\"].column {\n  width: 6.25% !important;\n}\n\n.ui.grid > .row > [class*=\"two wide\"].column, .ui.grid > .column.row > [class*=\"two wide\"].column, .ui.grid > [class*=\"two wide\"].column, .ui.column.grid > [class*=\"two wide\"].column {\n  width: 12.5% !important;\n}\n\n.ui.grid > .row > [class*=\"three wide\"].column, .ui.grid > .column.row > [class*=\"three wide\"].column, .ui.grid > [class*=\"three wide\"].column, .ui.column.grid > [class*=\"three wide\"].column {\n  width: 18.75% !important;\n}\n\n.ui.grid > .row > [class*=\"four wide\"].column, .ui.grid > .column.row > [class*=\"four wide\"].column, .ui.grid > [class*=\"four wide\"].column, .ui.column.grid > [class*=\"four wide\"].column {\n  width: 25% !important;\n}\n\n.ui.grid > .row > [class*=\"five wide\"].column, .ui.grid > .column.row > [class*=\"five wide\"].column, .ui.grid > [class*=\"five wide\"].column, .ui.column.grid > [class*=\"five wide\"].column {\n  width: 31.25% !important;\n}\n\n.ui.grid > .row > [class*=\"six wide\"].column, .ui.grid > .column.row > [class*=\"six wide\"].column, .ui.grid > [class*=\"six wide\"].column, .ui.column.grid > [class*=\"six wide\"].column {\n  width: 37.5% !important;\n}\n\n.ui.grid > .row > [class*=\"seven wide\"].column, .ui.grid > .column.row > [class*=\"seven wide\"].column, .ui.grid > [class*=\"seven wide\"].column, .ui.column.grid > [class*=\"seven wide\"].column {\n  width: 43.75% !important;\n}\n\n.ui.grid > .row > [class*=\"eight wide\"].column, .ui.grid > .column.row > [class*=\"eight wide\"].column, .ui.grid > [class*=\"eight wide\"].column, .ui.column.grid > [class*=\"eight wide\"].column {\n  width: 50% !important;\n}\n\n.ui.grid > .row > [class*=\"nine wide\"].column, .ui.grid > .column.row > [class*=\"nine wide\"].column, .ui.grid > [class*=\"nine wide\"].column, .ui.column.grid > [class*=\"nine wide\"].column {\n  width: 56.25% !important;\n}\n\n.ui.grid > .row > [class*=\"ten wide\"].column, .ui.grid > .column.row > [class*=\"ten wide\"].column, .ui.grid > [class*=\"ten wide\"].column, .ui.column.grid > [class*=\"ten wide\"].column {\n  width: 62.5% !important;\n}\n\n.ui.grid > .row > [class*=\"eleven wide\"].column, .ui.grid > .column.row > [class*=\"eleven wide\"].column, .ui.grid > [class*=\"eleven wide\"].column, .ui.column.grid > [class*=\"eleven wide\"].column {\n  width: 68.75% !important;\n}\n\n.ui.grid > .row > [class*=\"twelve wide\"].column, .ui.grid > .column.row > [class*=\"twelve wide\"].column, .ui.grid > [class*=\"twelve wide\"].column, .ui.column.grid > [class*=\"twelve wide\"].column {\n  width: 75% !important;\n}\n\n.ui.grid > .row > [class*=\"thirteen wide\"].column, .ui.grid > .column.row > [class*=\"thirteen wide\"].column, .ui.grid > [class*=\"thirteen wide\"].column, .ui.column.grid > [class*=\"thirteen wide\"].column {\n  width: 81.25% !important;\n}\n\n.ui.grid > .row > [class*=\"fourteen wide\"].column, .ui.grid > .column.row > [class*=\"fourteen wide\"].column, .ui.grid > [class*=\"fourteen wide\"].column, .ui.column.grid > [class*=\"fourteen wide\"].column {\n  width: 87.5% !important;\n}\n\n.ui.grid > .row > [class*=\"fifteen wide\"].column, .ui.grid > .column.row > [class*=\"fifteen wide\"].column, .ui.grid > [class*=\"fifteen wide\"].column, .ui.column.grid > [class*=\"fifteen wide\"].column {\n  width: 93.75% !important;\n}\n\n.ui.grid > .row > [class*=\"sixteen wide\"].column, .ui.grid > .column.row > [class*=\"sixteen wide\"].column, .ui.grid > [class*=\"sixteen wide\"].column, .ui.column.grid > [class*=\"sixteen wide\"].column {\n  width: 100% !important;\n}\n\n/*----------------------\n    Width per Device\n-----------------------*/\n\n/* Mobile Sizing Combinations */\n\n@media only screen and (min-width: 320px) and (max-width: 767px) {\n  .ui.grid > .row > [class*=\"one wide mobile\"].column, .ui.grid > .column.row > [class*=\"one wide mobile\"].column, .ui.grid > [class*=\"one wide mobile\"].column, .ui.column.grid > [class*=\"one wide mobile\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide mobile\"].column, .ui.grid > .column.row > [class*=\"two wide mobile\"].column, .ui.grid > [class*=\"two wide mobile\"].column, .ui.column.grid > [class*=\"two wide mobile\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide mobile\"].column, .ui.grid > .column.row > [class*=\"three wide mobile\"].column, .ui.grid > [class*=\"three wide mobile\"].column, .ui.column.grid > [class*=\"three wide mobile\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide mobile\"].column, .ui.grid > .column.row > [class*=\"four wide mobile\"].column, .ui.grid > [class*=\"four wide mobile\"].column, .ui.column.grid > [class*=\"four wide mobile\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide mobile\"].column, .ui.grid > .column.row > [class*=\"five wide mobile\"].column, .ui.grid > [class*=\"five wide mobile\"].column, .ui.column.grid > [class*=\"five wide mobile\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide mobile\"].column, .ui.grid > .column.row > [class*=\"six wide mobile\"].column, .ui.grid > [class*=\"six wide mobile\"].column, .ui.column.grid > [class*=\"six wide mobile\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide mobile\"].column, .ui.grid > .column.row > [class*=\"seven wide mobile\"].column, .ui.grid > [class*=\"seven wide mobile\"].column, .ui.column.grid > [class*=\"seven wide mobile\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide mobile\"].column, .ui.grid > .column.row > [class*=\"eight wide mobile\"].column, .ui.grid > [class*=\"eight wide mobile\"].column, .ui.column.grid > [class*=\"eight wide mobile\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide mobile\"].column, .ui.grid > .column.row > [class*=\"nine wide mobile\"].column, .ui.grid > [class*=\"nine wide mobile\"].column, .ui.column.grid > [class*=\"nine wide mobile\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide mobile\"].column, .ui.grid > .column.row > [class*=\"ten wide mobile\"].column, .ui.grid > [class*=\"ten wide mobile\"].column, .ui.column.grid > [class*=\"ten wide mobile\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide mobile\"].column, .ui.grid > .column.row > [class*=\"eleven wide mobile\"].column, .ui.grid > [class*=\"eleven wide mobile\"].column, .ui.column.grid > [class*=\"eleven wide mobile\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide mobile\"].column, .ui.grid > .column.row > [class*=\"twelve wide mobile\"].column, .ui.grid > [class*=\"twelve wide mobile\"].column, .ui.column.grid > [class*=\"twelve wide mobile\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide mobile\"].column, .ui.grid > .column.row > [class*=\"thirteen wide mobile\"].column, .ui.grid > [class*=\"thirteen wide mobile\"].column, .ui.column.grid > [class*=\"thirteen wide mobile\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide mobile\"].column, .ui.grid > .column.row > [class*=\"fourteen wide mobile\"].column, .ui.grid > [class*=\"fourteen wide mobile\"].column, .ui.column.grid > [class*=\"fourteen wide mobile\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide mobile\"].column, .ui.grid > .column.row > [class*=\"fifteen wide mobile\"].column, .ui.grid > [class*=\"fifteen wide mobile\"].column, .ui.column.grid > [class*=\"fifteen wide mobile\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide mobile\"].column, .ui.grid > .column.row > [class*=\"sixteen wide mobile\"].column, .ui.grid > [class*=\"sixteen wide mobile\"].column, .ui.column.grid > [class*=\"sixteen wide mobile\"].column {\n    width: 100% !important;\n  }\n}\n\n/* Tablet Sizing Combinations */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.grid > .row > [class*=\"one wide tablet\"].column, .ui.grid > .column.row > [class*=\"one wide tablet\"].column, .ui.grid > [class*=\"one wide tablet\"].column, .ui.column.grid > [class*=\"one wide tablet\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide tablet\"].column, .ui.grid > .column.row > [class*=\"two wide tablet\"].column, .ui.grid > [class*=\"two wide tablet\"].column, .ui.column.grid > [class*=\"two wide tablet\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide tablet\"].column, .ui.grid > .column.row > [class*=\"three wide tablet\"].column, .ui.grid > [class*=\"three wide tablet\"].column, .ui.column.grid > [class*=\"three wide tablet\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide tablet\"].column, .ui.grid > .column.row > [class*=\"four wide tablet\"].column, .ui.grid > [class*=\"four wide tablet\"].column, .ui.column.grid > [class*=\"four wide tablet\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide tablet\"].column, .ui.grid > .column.row > [class*=\"five wide tablet\"].column, .ui.grid > [class*=\"five wide tablet\"].column, .ui.column.grid > [class*=\"five wide tablet\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide tablet\"].column, .ui.grid > .column.row > [class*=\"six wide tablet\"].column, .ui.grid > [class*=\"six wide tablet\"].column, .ui.column.grid > [class*=\"six wide tablet\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide tablet\"].column, .ui.grid > .column.row > [class*=\"seven wide tablet\"].column, .ui.grid > [class*=\"seven wide tablet\"].column, .ui.column.grid > [class*=\"seven wide tablet\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide tablet\"].column, .ui.grid > .column.row > [class*=\"eight wide tablet\"].column, .ui.grid > [class*=\"eight wide tablet\"].column, .ui.column.grid > [class*=\"eight wide tablet\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide tablet\"].column, .ui.grid > .column.row > [class*=\"nine wide tablet\"].column, .ui.grid > [class*=\"nine wide tablet\"].column, .ui.column.grid > [class*=\"nine wide tablet\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide tablet\"].column, .ui.grid > .column.row > [class*=\"ten wide tablet\"].column, .ui.grid > [class*=\"ten wide tablet\"].column, .ui.column.grid > [class*=\"ten wide tablet\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide tablet\"].column, .ui.grid > .column.row > [class*=\"eleven wide tablet\"].column, .ui.grid > [class*=\"eleven wide tablet\"].column, .ui.column.grid > [class*=\"eleven wide tablet\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide tablet\"].column, .ui.grid > .column.row > [class*=\"twelve wide tablet\"].column, .ui.grid > [class*=\"twelve wide tablet\"].column, .ui.column.grid > [class*=\"twelve wide tablet\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide tablet\"].column, .ui.grid > .column.row > [class*=\"thirteen wide tablet\"].column, .ui.grid > [class*=\"thirteen wide tablet\"].column, .ui.column.grid > [class*=\"thirteen wide tablet\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide tablet\"].column, .ui.grid > .column.row > [class*=\"fourteen wide tablet\"].column, .ui.grid > [class*=\"fourteen wide tablet\"].column, .ui.column.grid > [class*=\"fourteen wide tablet\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide tablet\"].column, .ui.grid > .column.row > [class*=\"fifteen wide tablet\"].column, .ui.grid > [class*=\"fifteen wide tablet\"].column, .ui.column.grid > [class*=\"fifteen wide tablet\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide tablet\"].column, .ui.grid > .column.row > [class*=\"sixteen wide tablet\"].column, .ui.grid > [class*=\"sixteen wide tablet\"].column, .ui.column.grid > [class*=\"sixteen wide tablet\"].column {\n    width: 100% !important;\n  }\n}\n\n/* Computer/Desktop Sizing Combinations */\n\n@media only screen and (min-width: 992px) {\n  .ui.grid > .row > [class*=\"one wide computer\"].column, .ui.grid > .column.row > [class*=\"one wide computer\"].column, .ui.grid > [class*=\"one wide computer\"].column, .ui.column.grid > [class*=\"one wide computer\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide computer\"].column, .ui.grid > .column.row > [class*=\"two wide computer\"].column, .ui.grid > [class*=\"two wide computer\"].column, .ui.column.grid > [class*=\"two wide computer\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide computer\"].column, .ui.grid > .column.row > [class*=\"three wide computer\"].column, .ui.grid > [class*=\"three wide computer\"].column, .ui.column.grid > [class*=\"three wide computer\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide computer\"].column, .ui.grid > .column.row > [class*=\"four wide computer\"].column, .ui.grid > [class*=\"four wide computer\"].column, .ui.column.grid > [class*=\"four wide computer\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide computer\"].column, .ui.grid > .column.row > [class*=\"five wide computer\"].column, .ui.grid > [class*=\"five wide computer\"].column, .ui.column.grid > [class*=\"five wide computer\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide computer\"].column, .ui.grid > .column.row > [class*=\"six wide computer\"].column, .ui.grid > [class*=\"six wide computer\"].column, .ui.column.grid > [class*=\"six wide computer\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide computer\"].column, .ui.grid > .column.row > [class*=\"seven wide computer\"].column, .ui.grid > [class*=\"seven wide computer\"].column, .ui.column.grid > [class*=\"seven wide computer\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide computer\"].column, .ui.grid > .column.row > [class*=\"eight wide computer\"].column, .ui.grid > [class*=\"eight wide computer\"].column, .ui.column.grid > [class*=\"eight wide computer\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide computer\"].column, .ui.grid > .column.row > [class*=\"nine wide computer\"].column, .ui.grid > [class*=\"nine wide computer\"].column, .ui.column.grid > [class*=\"nine wide computer\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide computer\"].column, .ui.grid > .column.row > [class*=\"ten wide computer\"].column, .ui.grid > [class*=\"ten wide computer\"].column, .ui.column.grid > [class*=\"ten wide computer\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide computer\"].column, .ui.grid > .column.row > [class*=\"eleven wide computer\"].column, .ui.grid > [class*=\"eleven wide computer\"].column, .ui.column.grid > [class*=\"eleven wide computer\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide computer\"].column, .ui.grid > .column.row > [class*=\"twelve wide computer\"].column, .ui.grid > [class*=\"twelve wide computer\"].column, .ui.column.grid > [class*=\"twelve wide computer\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide computer\"].column, .ui.grid > .column.row > [class*=\"thirteen wide computer\"].column, .ui.grid > [class*=\"thirteen wide computer\"].column, .ui.column.grid > [class*=\"thirteen wide computer\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide computer\"].column, .ui.grid > .column.row > [class*=\"fourteen wide computer\"].column, .ui.grid > [class*=\"fourteen wide computer\"].column, .ui.column.grid > [class*=\"fourteen wide computer\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide computer\"].column, .ui.grid > .column.row > [class*=\"fifteen wide computer\"].column, .ui.grid > [class*=\"fifteen wide computer\"].column, .ui.column.grid > [class*=\"fifteen wide computer\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide computer\"].column, .ui.grid > .column.row > [class*=\"sixteen wide computer\"].column, .ui.grid > [class*=\"sixteen wide computer\"].column, .ui.column.grid > [class*=\"sixteen wide computer\"].column {\n    width: 100% !important;\n  }\n}\n\n/* Large Monitor Sizing Combinations */\n\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui.grid > .row > [class*=\"one wide large screen\"].column, .ui.grid > .column.row > [class*=\"one wide large screen\"].column, .ui.grid > [class*=\"one wide large screen\"].column, .ui.column.grid > [class*=\"one wide large screen\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide large screen\"].column, .ui.grid > .column.row > [class*=\"two wide large screen\"].column, .ui.grid > [class*=\"two wide large screen\"].column, .ui.column.grid > [class*=\"two wide large screen\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide large screen\"].column, .ui.grid > .column.row > [class*=\"three wide large screen\"].column, .ui.grid > [class*=\"three wide large screen\"].column, .ui.column.grid > [class*=\"three wide large screen\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide large screen\"].column, .ui.grid > .column.row > [class*=\"four wide large screen\"].column, .ui.grid > [class*=\"four wide large screen\"].column, .ui.column.grid > [class*=\"four wide large screen\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide large screen\"].column, .ui.grid > .column.row > [class*=\"five wide large screen\"].column, .ui.grid > [class*=\"five wide large screen\"].column, .ui.column.grid > [class*=\"five wide large screen\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide large screen\"].column, .ui.grid > .column.row > [class*=\"six wide large screen\"].column, .ui.grid > [class*=\"six wide large screen\"].column, .ui.column.grid > [class*=\"six wide large screen\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide large screen\"].column, .ui.grid > .column.row > [class*=\"seven wide large screen\"].column, .ui.grid > [class*=\"seven wide large screen\"].column, .ui.column.grid > [class*=\"seven wide large screen\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide large screen\"].column, .ui.grid > .column.row > [class*=\"eight wide large screen\"].column, .ui.grid > [class*=\"eight wide large screen\"].column, .ui.column.grid > [class*=\"eight wide large screen\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide large screen\"].column, .ui.grid > .column.row > [class*=\"nine wide large screen\"].column, .ui.grid > [class*=\"nine wide large screen\"].column, .ui.column.grid > [class*=\"nine wide large screen\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide large screen\"].column, .ui.grid > .column.row > [class*=\"ten wide large screen\"].column, .ui.grid > [class*=\"ten wide large screen\"].column, .ui.column.grid > [class*=\"ten wide large screen\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide large screen\"].column, .ui.grid > .column.row > [class*=\"eleven wide large screen\"].column, .ui.grid > [class*=\"eleven wide large screen\"].column, .ui.column.grid > [class*=\"eleven wide large screen\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide large screen\"].column, .ui.grid > .column.row > [class*=\"twelve wide large screen\"].column, .ui.grid > [class*=\"twelve wide large screen\"].column, .ui.column.grid > [class*=\"twelve wide large screen\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide large screen\"].column, .ui.grid > .column.row > [class*=\"thirteen wide large screen\"].column, .ui.grid > [class*=\"thirteen wide large screen\"].column, .ui.column.grid > [class*=\"thirteen wide large screen\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide large screen\"].column, .ui.grid > .column.row > [class*=\"fourteen wide large screen\"].column, .ui.grid > [class*=\"fourteen wide large screen\"].column, .ui.column.grid > [class*=\"fourteen wide large screen\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide large screen\"].column, .ui.grid > .column.row > [class*=\"fifteen wide large screen\"].column, .ui.grid > [class*=\"fifteen wide large screen\"].column, .ui.column.grid > [class*=\"fifteen wide large screen\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide large screen\"].column, .ui.grid > .column.row > [class*=\"sixteen wide large screen\"].column, .ui.grid > [class*=\"sixteen wide large screen\"].column, .ui.column.grid > [class*=\"sixteen wide large screen\"].column {\n    width: 100% !important;\n  }\n}\n\n/* Widescreen Sizing Combinations */\n\n@media only screen and (min-width: 1920px) {\n  .ui.grid > .row > [class*=\"one wide widescreen\"].column, .ui.grid > .column.row > [class*=\"one wide widescreen\"].column, .ui.grid > [class*=\"one wide widescreen\"].column, .ui.column.grid > [class*=\"one wide widescreen\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide widescreen\"].column, .ui.grid > .column.row > [class*=\"two wide widescreen\"].column, .ui.grid > [class*=\"two wide widescreen\"].column, .ui.column.grid > [class*=\"two wide widescreen\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide widescreen\"].column, .ui.grid > .column.row > [class*=\"three wide widescreen\"].column, .ui.grid > [class*=\"three wide widescreen\"].column, .ui.column.grid > [class*=\"three wide widescreen\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide widescreen\"].column, .ui.grid > .column.row > [class*=\"four wide widescreen\"].column, .ui.grid > [class*=\"four wide widescreen\"].column, .ui.column.grid > [class*=\"four wide widescreen\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide widescreen\"].column, .ui.grid > .column.row > [class*=\"five wide widescreen\"].column, .ui.grid > [class*=\"five wide widescreen\"].column, .ui.column.grid > [class*=\"five wide widescreen\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide widescreen\"].column, .ui.grid > .column.row > [class*=\"six wide widescreen\"].column, .ui.grid > [class*=\"six wide widescreen\"].column, .ui.column.grid > [class*=\"six wide widescreen\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide widescreen\"].column, .ui.grid > .column.row > [class*=\"seven wide widescreen\"].column, .ui.grid > [class*=\"seven wide widescreen\"].column, .ui.column.grid > [class*=\"seven wide widescreen\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide widescreen\"].column, .ui.grid > .column.row > [class*=\"eight wide widescreen\"].column, .ui.grid > [class*=\"eight wide widescreen\"].column, .ui.column.grid > [class*=\"eight wide widescreen\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide widescreen\"].column, .ui.grid > .column.row > [class*=\"nine wide widescreen\"].column, .ui.grid > [class*=\"nine wide widescreen\"].column, .ui.column.grid > [class*=\"nine wide widescreen\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide widescreen\"].column, .ui.grid > .column.row > [class*=\"ten wide widescreen\"].column, .ui.grid > [class*=\"ten wide widescreen\"].column, .ui.column.grid > [class*=\"ten wide widescreen\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide widescreen\"].column, .ui.grid > .column.row > [class*=\"eleven wide widescreen\"].column, .ui.grid > [class*=\"eleven wide widescreen\"].column, .ui.column.grid > [class*=\"eleven wide widescreen\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide widescreen\"].column, .ui.grid > .column.row > [class*=\"twelve wide widescreen\"].column, .ui.grid > [class*=\"twelve wide widescreen\"].column, .ui.column.grid > [class*=\"twelve wide widescreen\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide widescreen\"].column, .ui.grid > .column.row > [class*=\"thirteen wide widescreen\"].column, .ui.grid > [class*=\"thirteen wide widescreen\"].column, .ui.column.grid > [class*=\"thirteen wide widescreen\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide widescreen\"].column, .ui.grid > .column.row > [class*=\"fourteen wide widescreen\"].column, .ui.grid > [class*=\"fourteen wide widescreen\"].column, .ui.column.grid > [class*=\"fourteen wide widescreen\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide widescreen\"].column, .ui.grid > .column.row > [class*=\"fifteen wide widescreen\"].column, .ui.grid > [class*=\"fifteen wide widescreen\"].column, .ui.column.grid > [class*=\"fifteen wide widescreen\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide widescreen\"].column, .ui.grid > .column.row > [class*=\"sixteen wide widescreen\"].column, .ui.grid > [class*=\"sixteen wide widescreen\"].column, .ui.column.grid > [class*=\"sixteen wide widescreen\"].column {\n    width: 100% !important;\n  }\n}\n\n/*----------------------\n        Centered\n-----------------------*/\n\n.ui.centered.grid, .ui.centered.grid > .row, .ui.grid > .centered.row {\n  text-align: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.ui.centered.grid > .column:not(.aligned):not(.justified):not(.row), .ui.centered.grid > .row > .column:not(.aligned):not(.justified), .ui.grid .centered.row > .column:not(.aligned):not(.justified) {\n  text-align: left;\n}\n\n.ui.grid > .centered.column, .ui.grid > .row > .centered.column {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*----------------------\n        Relaxed\n-----------------------*/\n\n.ui.relaxed.grid > .column:not(.row), .ui.relaxed.grid > .row > .column, .ui.grid > .relaxed.row > .column {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.ui[class*=\"very relaxed\"].grid > .column:not(.row), .ui[class*=\"very relaxed\"].grid > .row > .column, .ui.grid > [class*=\"very relaxed\"].row > .column {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n\n/* Coupling with UI Divider */\n\n.ui.relaxed.grid .row + .ui.divider, .ui.grid .relaxed.row + .ui.divider {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.ui[class*=\"very relaxed\"].grid .row + .ui.divider, .ui.grid [class*=\"very relaxed\"].row + .ui.divider {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n}\n\n/*----------------------\n        Padded\n-----------------------*/\n\n.ui.padded.grid:not(.vertically):not(.horizontally) {\n  margin: 0em !important;\n}\n\n[class*=\"horizontally padded\"].ui.grid {\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n}\n\n[class*=\"vertically padded\"].ui.grid {\n  margin-top: 0em !important;\n  margin-bottom: 0em !important;\n}\n\n/*----------------------\n       \"Floated\"\n-----------------------*/\n\n.ui.grid [class*=\"left floated\"].column {\n  margin-right: auto;\n}\n\n.ui.grid [class*=\"right floated\"].column {\n  margin-left: auto;\n}\n\n/*----------------------\n        Divided\n-----------------------*/\n\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row), .ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: -1px 0px 0px 0px #DEDEDF;\n}\n\n/* Swap from padding to margin on columns to have dividers align */\n\n.ui[class*=\"vertically divided\"].grid > .column:not(.row), .ui[class*=\"vertically divided\"].grid > .row > .column {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n\n.ui[class*=\"vertically divided\"].grid > .row {\n  margin-top: 0em;\n  margin-bottom: 0em;\n}\n\n/* No divider on first column on row */\n\n.ui.divided.grid:not([class*=\"vertically divided\"]) > .column:first-child, .ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n\n/* No space on top of first row */\n\n.ui[class*=\"vertically divided\"].grid > .row:first-child > .column {\n  margin-top: 0em;\n}\n\n/* Divided Row */\n\n.ui.grid > .divided.row > .column {\n  box-shadow: -1px 0px 0px 0px #DEDEDF;\n}\n\n.ui.grid > .divided.row > .column:first-child {\n  box-shadow: none;\n}\n\n/* Vertically Divided */\n\n.ui[class*=\"vertically divided\"].grid > .row {\n  position: relative;\n}\n\n.ui[class*=\"vertically divided\"].grid > .row:before {\n  position: absolute;\n  content: \"\";\n  top: 0em;\n  left: 0px;\n  width: calc(100% - 2rem);\n  height: 1px;\n  margin: 0% 1rem;\n  box-shadow: 0px -1px 0px 0px #DEDEDF;\n}\n\n/* Padded Horizontally Divided */\n\n[class*=\"horizontally padded\"].ui.divided.grid, .ui.padded.divided.grid:not(.vertically):not(.horizontally) {\n  width: 100%;\n}\n\n/* First Row Vertically Divided */\n\n.ui[class*=\"vertically divided\"].grid > .row:first-child:before {\n  box-shadow: none;\n}\n\n/* Inverted Divided */\n\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row), .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n  box-shadow: -1px 0px 0px 0px rgba(255, 255, 255, 0.1);\n}\n\n.ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row):first-child, .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n  box-shadow: none;\n}\n\n.ui.inverted[class*=\"vertically divided\"].grid > .row:before {\n  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1);\n}\n\n/* Relaxed */\n\n.ui.relaxed[class*=\"vertically divided\"].grid > .row:before {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n  width: calc(100% - 3rem);\n}\n\n.ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid > .row:before {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n  width: calc(100% - 5rem);\n}\n\n/*----------------------\n         Celled\n-----------------------*/\n\n.ui.celled.grid {\n  width: 100%;\n  margin: 1em 0em;\n  box-shadow: 0px 0px 0px 1px #DEDEDF;\n}\n\n.ui.celled.grid > .row {\n  width: 100% !important;\n  margin: 0em;\n  padding: 0em;\n  box-shadow: 0px -1px 0px 0px #DEDEDF;\n}\n\n.ui.celled.grid > .column:not(.row), .ui.celled.grid > .row > .column {\n  box-shadow: -1px 0px 0px 0px #DEDEDF;\n}\n\n.ui.celled.grid > .column:first-child, .ui.celled.grid > .row > .column:first-child {\n  box-shadow: none;\n}\n\n.ui.celled.grid > .column:not(.row), .ui.celled.grid > .row > .column {\n  padding: 1em;\n}\n\n.ui.relaxed.celled.grid > .column:not(.row), .ui.relaxed.celled.grid > .row > .column {\n  padding: 1.5em;\n}\n\n.ui[class*=\"very relaxed\"].celled.grid > .column:not(.row), .ui[class*=\"very relaxed\"].celled.grid > .row > .column {\n  padding: 2em;\n}\n\n/* Internally Celled */\n\n.ui[class*=\"internally celled\"].grid {\n  box-shadow: none;\n  margin: 0em;\n}\n\n.ui[class*=\"internally celled\"].grid > .row:first-child {\n  box-shadow: none;\n}\n\n.ui[class*=\"internally celled\"].grid > .row > .column:first-child {\n  box-shadow: none;\n}\n\n/*----------------------\n   Vertically Aligned\n-----------------------*/\n\n/* Top Aligned */\n\n.ui[class*=\"top aligned\"].grid > .column:not(.row), .ui[class*=\"top aligned\"].grid > .row > .column, .ui.grid > [class*=\"top aligned\"].row > .column, .ui.grid > [class*=\"top aligned\"].column:not(.row), .ui.grid > .row > [class*=\"top aligned\"].column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  vertical-align: top;\n  -ms-flex-item-align: start !important;\n  align-self: flex-start !important;\n}\n\n/* Middle Aligned */\n\n.ui[class*=\"middle aligned\"].grid > .column:not(.row), .ui[class*=\"middle aligned\"].grid > .row > .column, .ui.grid > [class*=\"middle aligned\"].row > .column, .ui.grid > [class*=\"middle aligned\"].column:not(.row), .ui.grid > .row > [class*=\"middle aligned\"].column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  vertical-align: middle;\n  -ms-flex-item-align: center !important;\n  -ms-grid-row-align: center !important;\n  align-self: center !important;\n}\n\n/* Bottom Aligned */\n\n.ui[class*=\"bottom aligned\"].grid > .column:not(.row), .ui[class*=\"bottom aligned\"].grid > .row > .column, .ui.grid > [class*=\"bottom aligned\"].row > .column, .ui.grid > [class*=\"bottom aligned\"].column:not(.row), .ui.grid > .row > [class*=\"bottom aligned\"].column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  vertical-align: bottom;\n  -ms-flex-item-align: end !important;\n  align-self: flex-end !important;\n}\n\n/* Stretched */\n\n.ui.stretched.grid > .row > .column, .ui.stretched.grid > .column, .ui.grid > .stretched.row > .column, .ui.grid > .stretched.column:not(.row), .ui.grid > .row > .stretched.column {\n  display: -webkit-inline-box !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n  -ms-flex-item-align: stretch;\n  align-self: stretch;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.ui.stretched.grid > .row > .column > *, .ui.stretched.grid > .column > *, .ui.grid > .stretched.row > .column > *, .ui.grid > .stretched.column:not(.row) > *, .ui.grid > .row > .stretched.column > * {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n\n/*----------------------\n  Horizontally Centered\n-----------------------*/\n\n/* Left Aligned */\n\n.ui[class*=\"left aligned\"].grid > .column, .ui[class*=\"left aligned\"].grid > .row > .column, .ui.grid > [class*=\"left aligned\"].row > .column, .ui.grid > [class*=\"left aligned\"].column.column, .ui.grid > .row > [class*=\"left aligned\"].column.column {\n  text-align: left;\n  -ms-flex-item-align: inherit;\n  -ms-grid-row-align: inherit;\n  align-self: inherit;\n}\n\n/* Center Aligned */\n\n.ui[class*=\"center aligned\"].grid > .column, .ui[class*=\"center aligned\"].grid > .row > .column, .ui.grid > [class*=\"center aligned\"].row > .column, .ui.grid > [class*=\"center aligned\"].column.column, .ui.grid > .row > [class*=\"center aligned\"].column.column {\n  text-align: center;\n  -ms-flex-item-align: inherit;\n  -ms-grid-row-align: inherit;\n  align-self: inherit;\n}\n\n.ui[class*=\"center aligned\"].grid {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n/* Right Aligned */\n\n.ui[class*=\"right aligned\"].grid > .column, .ui[class*=\"right aligned\"].grid > .row > .column, .ui.grid > [class*=\"right aligned\"].row > .column, .ui.grid > [class*=\"right aligned\"].column.column, .ui.grid > .row > [class*=\"right aligned\"].column.column {\n  text-align: right;\n  -ms-flex-item-align: inherit;\n  -ms-grid-row-align: inherit;\n  align-self: inherit;\n}\n\n/* Justified */\n\n.ui.justified.grid > .column, .ui.justified.grid > .row > .column, .ui.grid > .justified.row > .column, .ui.grid > .justified.column.column, .ui.grid > .row > .justified.column.column {\n  text-align: justify;\n  -webkit-hyphens: auto;\n  -ms-hyphens: auto;\n  hyphens: auto;\n}\n\n/*----------------------\n         Colored\n-----------------------*/\n\n.ui.grid > .row > .red.column, .ui.grid > .row > .orange.column, .ui.grid > .row > .yellow.column, .ui.grid > .row > .olive.column, .ui.grid > .row > .green.column, .ui.grid > .row > .teal.column, .ui.grid > .row > .blue.column, .ui.grid > .row > .violet.column, .ui.grid > .row > .purple.column, .ui.grid > .row > .pink.column, .ui.grid > .row > .brown.column, .ui.grid > .row > .grey.column, .ui.grid > .row > .black.column {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n/* Red */\n\n.ui.grid > .red.row, .ui.grid > .red.column, .ui.grid > .row > .red.column {\n  background-color: #DB2828 !important;\n  color: #FFFFFF;\n}\n\n/* Orange */\n\n.ui.grid > .orange.row, .ui.grid > .orange.column, .ui.grid > .row > .orange.column {\n  background-color: #FF9F5B !important;\n  color: #FFFFFF;\n}\n\n/* Yellow */\n\n.ui.grid > .yellow.row, .ui.grid > .yellow.column, .ui.grid > .row > .yellow.column {\n  background-color: #F9DC5C !important;\n  color: #FFFFFF;\n}\n\n/* Olive */\n\n.ui.grid > .olive.row, .ui.grid > .olive.column, .ui.grid > .row > .olive.column {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF;\n}\n\n/* Green */\n\n.ui.grid > .green.row, .ui.grid > .green.column, .ui.grid > .row > .green.column {\n  background-color: #59D98D !important;\n  color: #FFFFFF;\n}\n\n/* Teal */\n\n.ui.grid > .teal.row, .ui.grid > .teal.column, .ui.grid > .row > .teal.column {\n  background-color: #00B5AD !important;\n  color: #FFFFFF;\n}\n\n/* Blue */\n\n.ui.grid > .blue.row, .ui.grid > .blue.column, .ui.grid > .row > .blue.column {\n  background-color: #2185D0 !important;\n  color: #FFFFFF;\n}\n\n/* Violet */\n\n.ui.grid > .violet.row, .ui.grid > .violet.column, .ui.grid > .row > .violet.column {\n  background-color: #6435C9 !important;\n  color: #FFFFFF;\n}\n\n/* Purple */\n\n.ui.grid > .purple.row, .ui.grid > .purple.column, .ui.grid > .row > .purple.column {\n  background-color: #A333C8 !important;\n  color: #FFFFFF;\n}\n\n/* Pink */\n\n.ui.grid > .pink.row, .ui.grid > .pink.column, .ui.grid > .row > .pink.column {\n  background-color: #E03997 !important;\n  color: #FFFFFF;\n}\n\n/* Brown */\n\n.ui.grid > .brown.row, .ui.grid > .brown.column, .ui.grid > .row > .brown.column {\n  background-color: #A5673F !important;\n  color: #FFFFFF;\n}\n\n/* Grey */\n\n.ui.grid > .grey.row, .ui.grid > .grey.column, .ui.grid > .row > .grey.column {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n  color: #FFFFFF;\n}\n\n/* Black */\n\n.ui.grid > .black.row, .ui.grid > .black.column, .ui.grid > .row > .black.column {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF;\n}\n\n/*----------------------\n      Equal Width\n-----------------------*/\n\n.ui[class*=\"equal width\"].grid > .column:not(.row), .ui[class*=\"equal width\"].grid > .row > .column, .ui.grid > [class*=\"equal width\"].row > .column {\n  display: inline-block;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n\n.ui[class*=\"equal width\"].grid > .wide.column, .ui[class*=\"equal width\"].grid > .row > .wide.column, .ui.grid > [class*=\"equal width\"].row > .wide.column {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n}\n\n/*----------------------\n        Reverse\n-----------------------*/\n\n/* Mobile */\n\n@media only screen and (max-width: 767px) {\n  .ui[class*=\"mobile reversed\"].grid, .ui[class*=\"mobile reversed\"].grid > .row, .ui.grid > [class*=\"mobile reversed\"].row {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n  }\n\n  .ui[class*=\"mobile vertically reversed\"].grid, .ui.stackable[class*=\"mobile reversed\"] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child, .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child, .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n\n  /* Vertically Divided Reversed */\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px #DEDEDF;\n  }\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n\n  /* Celled Reversed */\n\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n/* Tablet */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui[class*=\"tablet reversed\"].grid, .ui[class*=\"tablet reversed\"].grid > .row, .ui.grid > [class*=\"tablet reversed\"].row {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n  }\n\n  .ui[class*=\"tablet vertically reversed\"].grid {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child, .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child, .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n\n  /* Vertically Divided Reversed */\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px #DEDEDF;\n  }\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n\n  /* Celled Reversed */\n\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n/* Computer */\n\n@media only screen and (min-width: 992px) {\n  .ui[class*=\"computer reversed\"].grid, .ui[class*=\"computer reversed\"].grid > .row, .ui.grid > [class*=\"computer reversed\"].row {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n  }\n\n  .ui[class*=\"computer vertically reversed\"].grid {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n  }\n\n  /* Divided Reversed */\n\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child, .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child, .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n    box-shadow: none;\n  }\n\n  /* Vertically Divided Reversed */\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:first-child:before {\n    box-shadow: 0px -1px 0px 0px #DEDEDF;\n  }\n\n  .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:last-child:before {\n    box-shadow: none;\n  }\n\n  /* Celled Reversed */\n\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:first-child {\n    box-shadow: -1px 0px 0px 0px #DEDEDF;\n  }\n\n  .ui[class*=\"computer reversed\"].celled.grid > .row > .column:last-child {\n    box-shadow: none;\n  }\n}\n\n/*-------------------\n      Doubling\n--------------------*/\n\n/* Tablet Only */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.doubling.grid {\n    width: auto;\n  }\n\n  .ui.grid > .doubling.row, .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n\n  .ui.grid > .doubling.row > .column, .ui.doubling.grid > .row > .column {\n    display: inline-block !important;\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n    box-shadow: none !important;\n    margin: 0em;\n  }\n\n  .ui[class*=\"two column\"].doubling.grid > .row > .column, .ui[class*=\"two column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"two column\"].doubling.row.row > .column {\n    width: 100% !important;\n  }\n\n  .ui[class*=\"three column\"].doubling.grid > .row > .column, .ui[class*=\"three column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"three column\"].doubling.row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"four column\"].doubling.grid > .row > .column, .ui[class*=\"four column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"four column\"].doubling.row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"five column\"].doubling.grid > .row > .column, .ui[class*=\"five column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"five column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"six column\"].doubling.grid > .row > .column, .ui[class*=\"six column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"six column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"seven column\"].doubling.grid > .row > .column, .ui[class*=\"seven column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"seven column\"].doubling.row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"eight column\"].doubling.grid > .row > .column, .ui[class*=\"eight column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"eight column\"].doubling.row.row > .column {\n    width: 25% !important;\n  }\n\n  .ui[class*=\"nine column\"].doubling.grid > .row > .column, .ui[class*=\"nine column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"nine column\"].doubling.row.row > .column {\n    width: 25% !important;\n  }\n\n  .ui[class*=\"ten column\"].doubling.grid > .row > .column, .ui[class*=\"ten column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"ten column\"].doubling.row.row > .column {\n    width: 20% !important;\n  }\n\n  .ui[class*=\"eleven column\"].doubling.grid > .row > .column, .ui[class*=\"eleven column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"eleven column\"].doubling.row.row > .column {\n    width: 20% !important;\n  }\n\n  .ui[class*=\"twelve column\"].doubling.grid > .row > .column, .ui[class*=\"twelve column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"twelve column\"].doubling.row.row > .column {\n    width: 16.66666667% !important;\n  }\n\n  .ui[class*=\"thirteen column\"].doubling.grid > .row > .column, .ui[class*=\"thirteen column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"thirteen column\"].doubling.row.row > .column {\n    width: 16.66666667% !important;\n  }\n\n  .ui[class*=\"fourteen column\"].doubling.grid > .row > .column, .ui[class*=\"fourteen column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"fourteen column\"].doubling.row.row > .column {\n    width: 14.28571429% !important;\n  }\n\n  .ui[class*=\"fifteen column\"].doubling.grid > .row > .column, .ui[class*=\"fifteen column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"fifteen column\"].doubling.row.row > .column {\n    width: 14.28571429% !important;\n  }\n\n  .ui[class*=\"sixteen column\"].doubling.grid > .row > .column, .ui[class*=\"sixteen column\"].doubling.grid > .column:not(.row), .ui.grid > [class*=\"sixteen column\"].doubling.row.row > .column {\n    width: 12.5% !important;\n  }\n}\n\n/* Mobile Only */\n\n@media only screen and (max-width: 767px) {\n  .ui.grid > .doubling.row, .ui.doubling.grid > .row {\n    margin: 0em !important;\n    padding: 0em !important;\n  }\n\n  .ui.grid > .doubling.row > .column, .ui.doubling.grid > .row > .column {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n    margin: 0em !important;\n    box-shadow: none !important;\n  }\n\n  .ui[class*=\"two column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"two column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"two column\"].doubling:not(.stackable).row.row > .column {\n    width: 100% !important;\n  }\n\n  .ui[class*=\"three column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"three column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"three column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"four column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"four column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"four column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"five column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"five column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"five column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"six column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"six column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"six column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"seven column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"eight column\"].doubling:not(.stackable).row.row > .column {\n    width: 50% !important;\n  }\n\n  .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"nine column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"ten column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"eleven column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"twelve column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"thirteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 33.33333333% !important;\n  }\n\n  .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"fourteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n\n  .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"fifteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n\n  .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .row > .column, .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .column:not(.row), .ui.grid > [class*=\"sixteen column\"].doubling:not(.stackable).row.row > .column {\n    width: 25% !important;\n  }\n}\n\n/*-------------------\n      Stackable\n--------------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.stackable.grid {\n    width: auto;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n\n  .ui.stackable.grid > .row > .wide.column, .ui.stackable.grid > .wide.column, .ui.stackable.grid > .column.grid > .column, .ui.stackable.grid > .column.row > .column, .ui.stackable.grid > .row > .column, .ui.stackable.grid > .column:not(.row), .ui.grid > .stackable.stackable.row > .column {\n    width: 100% !important;\n    margin: 0em 0em !important;\n    box-shadow: none !important;\n    padding: 1rem 1rem !important;\n  }\n\n  .ui.stackable.grid:not(.vertically) > .row {\n    margin: 0em;\n    padding: 0em;\n  }\n\n  /* Coupling */\n\n  .ui.container > .ui.stackable.grid > .column, .ui.container > .ui.stackable.grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n\n  /* Don't pad inside segment or nested grid */\n\n  .ui.grid .ui.stackable.grid, .ui.segment:not(.vertical) .ui.stackable.page.grid {\n    margin-left: -1rem !important;\n    margin-right: -1rem !important;\n  }\n\n  /* Divided Stackable */\n\n  .ui.stackable.divided.grid > .row:first-child > .column:first-child, .ui.stackable.celled.grid > .row:first-child > .column:first-child, .ui.stackable.divided.grid > .column:not(.row):first-child, .ui.stackable.celled.grid > .column:not(.row):first-child {\n    border-top: none !important;\n  }\n\n  .ui.inverted.stackable.celled.grid > .column:not(.row), .ui.inverted.stackable.divided.grid > .column:not(.row), .ui.inverted.stackable.celled.grid > .row > .column, .ui.inverted.stackable.divided.grid > .row > .column {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .ui.stackable.celled.grid > .column:not(.row), .ui.stackable.divided:not(.vertically).grid > .column:not(.row), .ui.stackable.celled.grid > .row > .column, .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    border-top: 1px solid #DEDEDF;\n    box-shadow: none !important;\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .ui.stackable.celled.grid > .row {\n    box-shadow: none !important;\n  }\n\n  .ui.stackable.divided:not(.vertically).grid > .column:not(.row), .ui.stackable.divided:not(.vertically).grid > .row > .column {\n    padding-left: 0em !important;\n    padding-right: 0em !important;\n  }\n}\n\n/*----------------------\n     Only (Device)\n-----------------------*/\n\n/* These include arbitrary class repetitions for forced specificity */\n\n/* Mobile Only Hide */\n\n@media only screen and (max-width: 767px) {\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.mobile) {\n    display: none !important;\n  }\n\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.mobile) {\n    display: none !important;\n  }\n\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Tablet Only Hide */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet), .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.tablet), .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.tablet), .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.tablet) {\n    display: none !important;\n  }\n\n  .ui[class*=\"computer only\"].grid.grid.grid:not(.tablet), .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.tablet), .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.tablet), .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.tablet) {\n    display: none !important;\n  }\n\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Computer Only Hide */\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n\n  .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Large Screen Only Hide */\n\n@media only screen and (min-width: 1200px) and (max-width: 1919px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n\n  .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile), .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile), .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n    display: none !important;\n  }\n}\n\n/* Widescreen Only Hide */\n\n@media only screen and (min-width: 1920px) {\n  .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n    display: none !important;\n  }\n\n  .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer), .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer), .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n    display: none !important;\n  }\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n\n@media print {\n  /* Hide mobile styles on print layouts */\n\n  .ui[class*=\"mobile only\"].grid.grid.grid, .ui.grid.grid.grid > [class*=\"mobile only\"].row, .ui.grid.grid.grid > [class*=\"mobile only\"].column, .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column {\n    display: none !important;\n  }\n\n  /* Use computer column styles for print media */\n\n  .ui.grid > .row > [class*=\"one wide computer\"].column, .ui.grid > .column.row > [class*=\"one wide computer\"].column, .ui.grid > [class*=\"one wide computer\"].column, .ui.column.grid > [class*=\"one wide computer\"].column {\n    width: 6.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"two wide computer\"].column, .ui.grid > .column.row > [class*=\"two wide computer\"].column, .ui.grid > [class*=\"two wide computer\"].column, .ui.column.grid > [class*=\"two wide computer\"].column {\n    width: 12.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"three wide computer\"].column, .ui.grid > .column.row > [class*=\"three wide computer\"].column, .ui.grid > [class*=\"three wide computer\"].column, .ui.column.grid > [class*=\"three wide computer\"].column {\n    width: 18.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"four wide computer\"].column, .ui.grid > .column.row > [class*=\"four wide computer\"].column, .ui.grid > [class*=\"four wide computer\"].column, .ui.column.grid > [class*=\"four wide computer\"].column {\n    width: 25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"five wide computer\"].column, .ui.grid > .column.row > [class*=\"five wide computer\"].column, .ui.grid > [class*=\"five wide computer\"].column, .ui.column.grid > [class*=\"five wide computer\"].column {\n    width: 31.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"six wide computer\"].column, .ui.grid > .column.row > [class*=\"six wide computer\"].column, .ui.grid > [class*=\"six wide computer\"].column, .ui.column.grid > [class*=\"six wide computer\"].column {\n    width: 37.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"seven wide computer\"].column, .ui.grid > .column.row > [class*=\"seven wide computer\"].column, .ui.grid > [class*=\"seven wide computer\"].column, .ui.column.grid > [class*=\"seven wide computer\"].column {\n    width: 43.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eight wide computer\"].column, .ui.grid > .column.row > [class*=\"eight wide computer\"].column, .ui.grid > [class*=\"eight wide computer\"].column, .ui.column.grid > [class*=\"eight wide computer\"].column {\n    width: 50% !important;\n  }\n\n  .ui.grid > .row > [class*=\"nine wide computer\"].column, .ui.grid > .column.row > [class*=\"nine wide computer\"].column, .ui.grid > [class*=\"nine wide computer\"].column, .ui.column.grid > [class*=\"nine wide computer\"].column {\n    width: 56.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"ten wide computer\"].column, .ui.grid > .column.row > [class*=\"ten wide computer\"].column, .ui.grid > [class*=\"ten wide computer\"].column, .ui.column.grid > [class*=\"ten wide computer\"].column {\n    width: 62.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"eleven wide computer\"].column, .ui.grid > .column.row > [class*=\"eleven wide computer\"].column, .ui.grid > [class*=\"eleven wide computer\"].column, .ui.column.grid > [class*=\"eleven wide computer\"].column {\n    width: 68.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"twelve wide computer\"].column, .ui.grid > .column.row > [class*=\"twelve wide computer\"].column, .ui.grid > [class*=\"twelve wide computer\"].column, .ui.column.grid > [class*=\"twelve wide computer\"].column {\n    width: 75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"thirteen wide computer\"].column, .ui.grid > .column.row > [class*=\"thirteen wide computer\"].column, .ui.grid > [class*=\"thirteen wide computer\"].column, .ui.column.grid > [class*=\"thirteen wide computer\"].column {\n    width: 81.25% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fourteen wide computer\"].column, .ui.grid > .column.row > [class*=\"fourteen wide computer\"].column, .ui.grid > [class*=\"fourteen wide computer\"].column, .ui.column.grid > [class*=\"fourteen wide computer\"].column {\n    width: 87.5% !important;\n  }\n\n  .ui.grid > .row > [class*=\"fifteen wide computer\"].column, .ui.grid > .column.row > [class*=\"fifteen wide computer\"].column, .ui.grid > [class*=\"fifteen wide computer\"].column, .ui.column.grid > [class*=\"fifteen wide computer\"].column {\n    width: 93.75% !important;\n  }\n\n  .ui.grid > .row > [class*=\"sixteen wide computer\"].column, .ui.grid > .column.row > [class*=\"sixteen wide computer\"].column, .ui.grid > [class*=\"sixteen wide computer\"].column, .ui.column.grid > [class*=\"sixteen wide computer\"].column {\n    width: 100% !important;\n  }\n}\n/*\n * # Semantic - Menu\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2015 Contributor\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Menu\n---------------*/\n\n.ui.menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 1rem 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  background: #FFFFFF;\n  font-weight: normal;\n  border: 1px solid #DEDEDF;\n  box-shadow: 0px 1px 2px 0 #DEDEDF;\n  border-radius: 0.21428571rem;\n  min-height: 2.85714286em;\n}\n\n.ui.menu:after {\n  content: '';\n  display: block;\n  height: 0px;\n  clear: both;\n  visibility: hidden;\n}\n\n.ui.menu:first-child {\n  margin-top: 0rem;\n}\n\n.ui.menu:last-child {\n  margin-bottom: 0rem;\n}\n\n/*--------------\n    Sub-Menu\n---------------*/\n\n.ui.menu .menu {\n  margin: 0em;\n}\n\n.ui.menu:not(.vertical) > .menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*--------------\n      Item\n---------------*/\n\n.ui.menu:not(.vertical) .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ui.menu .item {\n  position: relative;\n  vertical-align: middle;\n  line-height: 1;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background: none;\n  padding: 0.92857143em 1.14285714em;\n  text-transform: none;\n  color: rgba(0, 0, 0, 0.8);\n  font-weight: normal;\n  transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;\n}\n\n.ui.menu > .item:first-child {\n  border-radius: 0.21428571rem 0px 0px 0.21428571rem;\n}\n\n/* Border */\n\n.ui.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  right: 0px;\n  height: 100%;\n  width: 1px;\n  background: rgba(34, 36, 38, 0.1);\n}\n\n/*--------------\n  Text Content\n---------------*/\n\n.ui.menu .text.item > *, .ui.menu .item > a:not(.ui), .ui.menu .item > p:only-child {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  line-height: 1.3;\n}\n\n.ui.menu .item > p:first-child {\n  margin-top: 0;\n}\n\n.ui.menu .item > p:last-child {\n  margin-bottom: 0;\n}\n\n/*--------------\n      Icons\n---------------*/\n\n.ui.menu .item > i.icon {\n  opacity: 0.9;\n  float: none;\n  margin: 0em 0.35714286em 0em 0em;\n}\n\n/*--------------\n     Button\n---------------*/\n\n.ui.menu:not(.vertical) .item > .button {\n  position: relative;\n  top: 0em;\n  margin: -0.5em 0em;\n  padding-bottom: 0.78571429em;\n  padding-top: 0.78571429em;\n  font-size: 1em;\n}\n\n/*----------------\n Grid / Container\n-----------------*/\n\n.ui.menu > .grid, .ui.menu > .container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: inherit;\n  -ms-flex-align: inherit;\n  align-items: inherit;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: inherit;\n  flex-direction: inherit;\n}\n\n/*--------------\n     Inputs\n---------------*/\n\n.ui.menu .item > .input {\n  width: 100%;\n}\n\n.ui.menu:not(.vertical) .item > .input {\n  position: relative;\n  top: 0em;\n  margin: -0.5em 0em;\n}\n\n.ui.menu .item > .input input {\n  font-size: 1em;\n  padding-top: 0.57142857em;\n  padding-bottom: 0.57142857em;\n}\n\n/*--------------\n     Header\n---------------*/\n\n.ui.menu .header.item, .ui.vertical.menu .header.item {\n  margin: 0em;\n  background: '';\n  text-transform: normal;\n  font-weight: bold;\n}\n\n.ui.vertical.menu .item > .header:not(.ui) {\n  margin: 0em 0em 0.5em;\n  font-size: 1em;\n  font-weight: bold;\n}\n\n/*--------------\n    Dropdowns\n---------------*/\n\n/* Dropdown Icon */\n\n.ui.menu .item > i.dropdown.icon {\n  padding: 0em;\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n\n/* Menu */\n\n.ui.menu .dropdown.item .menu {\n  min-width: calc(100% - 1px);\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  background: #FFFFFF;\n  margin: 0em 0px 0px;\n  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08);\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n  -ms-flex-direction: column !important;\n  flex-direction: column !important;\n}\n\n/* Menu Items */\n\n.ui.menu .ui.dropdown .menu > .item {\n  margin: 0;\n  text-align: left;\n  font-size: 1em !important;\n  padding: 0.78571429em 1.14285714em !important;\n  background: transparent !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n  text-transform: none !important;\n  font-weight: normal !important;\n  box-shadow: none !important;\n  transition: none !important;\n}\n\n.ui.menu .ui.dropdown .menu > .item:hover {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: #59D98D !important;\n}\n\n.ui.menu .ui.dropdown .menu > .selected.item {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: #59D98D !important;\n}\n\n.ui.menu .ui.dropdown .menu > .active.item {\n  background: rgba(0, 0, 0, 0.03) !important;\n  font-weight: bold !important;\n  color: #59D98D !important;\n}\n\n.ui.menu .ui.dropdown.item .menu .item:not(.filtered) {\n  display: block;\n}\n\n.ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {\n  display: inline-block;\n  font-size: 1em !important;\n  float: none;\n  margin: 0em 0.75em 0em 0em !important;\n}\n\n/* Secondary */\n\n.ui.secondary.menu .dropdown.item > .menu, .ui.text.menu .dropdown.item > .menu {\n  border-radius: 0.21428571rem;\n  margin-top: 0.35714286em;\n}\n\n/* Pointing */\n\n.ui.menu .pointing.dropdown.item .menu {\n  margin-top: 0.75em;\n}\n\n/* Inverted */\n\n.ui.inverted.menu .search.dropdown.item > .search, .ui.inverted.menu .search.dropdown.item > .text {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Vertical */\n\n.ui.vertical.menu .dropdown.item > .icon {\n  float: right;\n  content: \"\\F0DA\";\n  margin-left: 1em;\n}\n\n.ui.vertical.menu .dropdown.item .menu {\n  left: 100%;\n  min-width: 0;\n  margin: 0em 0em 0em 0em;\n  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0em 0.21428571rem 0.21428571rem 0.21428571rem;\n}\n\n.ui.vertical.menu .dropdown.item.upward .menu {\n  bottom: 0;\n}\n\n.ui.vertical.menu .dropdown.item:not(.upward) .menu {\n  top: 0;\n}\n\n.ui.vertical.menu .active.dropdown.item {\n  border-top-right-radius: 0em;\n  border-bottom-right-radius: 0em;\n}\n\n.ui.vertical.menu .dropdown.active.item {\n  box-shadow: none;\n}\n\n/* Evenly Divided */\n\n.ui.item.menu .dropdown .menu .item {\n  width: 100%;\n}\n\n/*--------------\n     Labels\n---------------*/\n\n.ui.menu .item > .label {\n  background: #999999;\n  color: #FFFFFF;\n  margin-left: 1em;\n  padding: 0.3em 0.78571429em;\n}\n\n.ui.vertical.menu .item > .label {\n  background: #999999;\n  color: #FFFFFF;\n  margin-top: -0.15em;\n  margin-bottom: -0.15em;\n  padding: 0.3em 0.78571429em;\n}\n\n.ui.menu .item > .floating.label {\n  padding: 0.3em 0.78571429em;\n}\n\n/*--------------\n     Images\n---------------*/\n\n.ui.menu .item > img:not(.ui) {\n  display: inline-block;\n  vertical-align: middle;\n  margin: -0.3em 0em;\n  width: 2.5em;\n}\n\n.ui.vertical.menu .item > img:not(.ui):only-child {\n  display: block;\n  max-width: 100%;\n  width: auto;\n}\n\n/*******************************\n          Coupling\n*******************************/\n\n/*--------------\n     List\n---------------*/\n\n/* Menu divider shouldnt apply */\n\n.ui.menu .list .item:before {\n  background: none !important;\n}\n\n/*--------------\n     Sidebar\n---------------*/\n\n/* Show vertical dividers below last */\n\n.ui.vertical.sidebar.menu > .item:first-child:before {\n  display: block !important;\n}\n\n.ui.vertical.sidebar.menu > .item::before {\n  top: auto;\n  bottom: 0px;\n}\n\n/*--------------\n    Container\n---------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.menu > .ui.container {\n    width: 100% !important;\n    margin-left: 0em !important;\n    margin-right: 0em !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {\n    border-left: 1px solid rgba(34, 36, 38, 0.1);\n  }\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.link.menu .item:hover, .ui.menu .dropdown.item:hover, .ui.menu .link.item:hover, .ui.menu a.item:hover {\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.03);\n  color: #59D98D;\n}\n\n/*--------------\n     Pressed\n---------------*/\n\n.ui.link.menu .item:active, .ui.menu .link.item:active, .ui.menu a.item:active {\n  background: rgba(0, 0, 0, 0.03);\n  color: #59D98D;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.menu .active.item {\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n  font-weight: normal;\n  box-shadow: none;\n}\n\n.ui.menu .active.item > i.icon {\n  opacity: 1;\n}\n\n/*--------------\n  Active Hover\n---------------*/\n\n.ui.menu .active.item:hover, .ui.vertical.menu .active.item:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n}\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.menu .item.disabled, .ui.menu .item.disabled:hover {\n  cursor: default !important;\n  background-color: transparent !important;\n  color: rgba(40, 40, 40, 0.3) !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*------------------\nFloated Menu / Item\n-------------------*/\n\n/* Left Floated */\n\n.ui.menu:not(.vertical) .left.item, .ui.menu:not(.vertical) :not(.dropdown) > .left.menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: auto !important;\n}\n\n/* Right Floated */\n\n.ui.menu:not(.vertical) .right.item, .ui.menu:not(.vertical) .right.menu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: auto !important;\n}\n\n/* Swapped Borders */\n\n.ui.menu .right.item::before, .ui.menu .right.menu > .item::before {\n  right: auto;\n  left: 0;\n}\n\n/*--------------\n    Vertical\n---------------*/\n\n.ui.vertical.menu {\n  display: block;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 2px 0 #DEDEDF;\n}\n\n/*--- Item ---*/\n\n.ui.vertical.menu .item {\n  display: block;\n  background: none;\n  border-top: none;\n  border-right: none;\n}\n\n.ui.vertical.menu > .item:first-child {\n  border-radius: 0.21428571rem 0.21428571rem 0px 0px;\n}\n\n.ui.vertical.menu > .item:last-child {\n  border-radius: 0px 0px 0.21428571rem 0.21428571rem;\n}\n\n/*--- Label ---*/\n\n.ui.vertical.menu .item > .label {\n  float: right;\n  text-align: center;\n}\n\n/*--- Icon ---*/\n\n.ui.vertical.menu .item > i.icon {\n  width: 1.18em;\n  float: right;\n  margin: 0em 0em 0em 0.5em;\n}\n\n.ui.vertical.menu .item > .label + i.icon {\n  float: none;\n  margin: 0em 0.5em 0em 0em;\n}\n\n/*--- Border ---*/\n\n.ui.vertical.menu .item:before {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 0px;\n  width: 100%;\n  height: 1px;\n  background: rgba(34, 36, 38, 0.1);\n}\n\n.ui.vertical.menu .item:first-child:before {\n  display: none !important;\n}\n\n/*--- Sub Menu ---*/\n\n.ui.vertical.menu .item > .menu {\n  margin: 0.5em -1.14285714em 0em;\n}\n\n.ui.vertical.menu .menu .item {\n  background: none;\n  padding: 0.5em 1.33333333em;\n  font-size: 0.85714286em;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.ui.vertical.menu .item .menu a.item:hover, .ui.vertical.menu .item .menu .link.item:hover {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.vertical.menu .menu .item:before {\n  display: none;\n}\n\n/* Vertical Active */\n\n.ui.vertical.menu .active.item {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 0em;\n  box-shadow: none;\n}\n\n.ui.vertical.menu > .active.item:first-child {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.vertical.menu > .active.item:last-child {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui.vertical.menu > .active.item:only-child {\n  border-radius: 0.21428571rem;\n}\n\n.ui.vertical.menu .active.item .menu .active.item {\n  border-left: none;\n}\n\n.ui.vertical.menu .item .menu .active.item {\n  background-color: transparent;\n  font-weight: bold;\n  color: #59D98D;\n}\n\n/*--------------\n     Tabular\n---------------*/\n\n.ui.tabular.menu {\n  border-radius: 0em;\n  box-shadow: none !important;\n  border: none;\n  background: none transparent;\n  border-bottom: 1px solid #DEDEDF;\n}\n\n.ui.tabular.fluid.menu {\n  width: calc(100% + (1px * 2)) !important;\n}\n\n.ui.tabular.menu .item {\n  background: transparent;\n  border-bottom: none;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-top: 2px solid transparent;\n  padding: 0.92857143em 1.42857143em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.tabular.menu .item:before {\n  display: none;\n}\n\n/* Hover */\n\n.ui.tabular.menu .item:hover {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active */\n\n.ui.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: #59D98D;\n  border-top-width: 1px;\n  border-color: #DEDEDF;\n  font-weight: bold;\n  margin-bottom: -1px;\n  box-shadow: none;\n  border-radius: 0.21428571rem 0.21428571rem 0px 0px !important;\n}\n\n/* Coupling with segment for attachment */\n\n.ui.tabular.menu + .attached:not(.top).segment, .ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {\n  border-top: none;\n  margin-left: 0px;\n  margin-top: 0px;\n  margin-right: 0px;\n  width: 100%;\n}\n\n.top.attached.segment + .ui.bottom.tabular.menu {\n  position: relative;\n  width: calc(100% + (1px * 2));\n  left: -1px;\n}\n\n/* Bottom Vertical Tabular */\n\n.ui.bottom.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-top: 1px solid #DEDEDF;\n}\n\n.ui.bottom.tabular.menu .item {\n  background: none;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: none;\n}\n\n.ui.bottom.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: #59D98D;\n  border-color: #DEDEDF;\n  margin: -1px 0px 0px 0px;\n  border-radius: 0px 0px 0.21428571rem 0.21428571rem !important;\n}\n\n/* Vertical Tabular (Left) */\n\n.ui.vertical.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: 1px solid #DEDEDF;\n}\n\n.ui.vertical.tabular.menu .item {\n  background: none;\n  border-left: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: 1px solid transparent;\n  border-right: none;\n}\n\n.ui.vertical.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: #59D98D;\n  border-color: #DEDEDF;\n  margin: 0px -1px 0px 0px;\n  border-radius: 0.21428571rem 0px 0px 0.21428571rem !important;\n}\n\n/* Vertical Right Tabular */\n\n.ui.vertical.right.tabular.menu {\n  background: none transparent;\n  border-radius: 0em;\n  box-shadow: none !important;\n  border-bottom: none;\n  border-right: none;\n  border-left: 1px solid #DEDEDF;\n}\n\n.ui.vertical.right.tabular.menu .item {\n  background: none;\n  border-right: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  border-top: 1px solid transparent;\n  border-left: none;\n}\n\n.ui.vertical.right.tabular.menu .active.item {\n  background: none #FFFFFF;\n  color: #59D98D;\n  border-color: #DEDEDF;\n  margin: 0px 0px 0px -1px;\n  border-radius: 0px 0.21428571rem 0.21428571rem 0px !important;\n}\n\n/* Dropdown */\n\n.ui.tabular.menu .active.dropdown.item {\n  margin-bottom: 0px;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  border-top: 2px solid transparent;\n  border-bottom: none;\n}\n\n/*--------------\n   Pagination\n---------------*/\n\n.ui.pagination.menu {\n  margin: 0em;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.ui.pagination.menu .item:last-child {\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n.ui.compact.menu .item:last-child {\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n.ui.pagination.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.pagination.menu .item {\n  min-width: 3em;\n  text-align: center;\n}\n\n.ui.pagination.menu .icon.item i.icon {\n  vertical-align: top;\n}\n\n/* Active */\n\n.ui.pagination.menu .active.item {\n  border-top: none;\n  padding-top: 0.92857143em;\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n  box-shadow: none;\n}\n\n/*--------------\n   Secondary\n---------------*/\n\n.ui.secondary.menu {\n  background: none;\n  margin-left: -0.35714286em;\n  margin-right: -0.35714286em;\n  border-radius: 0em;\n  border: none;\n  box-shadow: none;\n}\n\n/* Item */\n\n.ui.secondary.menu .item {\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n  align-self: center;\n  box-shadow: none;\n  border: none;\n  padding: 0.78571429em 0.92857143em;\n  margin: 0em 0.35714286em;\n  background: none;\n  transition: color 0.1s ease;\n  border-radius: 0.21428571rem;\n}\n\n/* No Divider */\n\n.ui.secondary.menu .item:before {\n  display: none !important;\n}\n\n/* Header */\n\n.ui.secondary.menu .header.item {\n  border-radius: 0em;\n  border-right: none;\n  background: none transparent;\n}\n\n/* Image */\n\n.ui.secondary.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n\n/* Hover */\n\n.ui.secondary.menu .dropdown.item:hover, .ui.secondary.menu .link.item:hover, .ui.secondary.menu a.item:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n}\n\n/* Active */\n\n.ui.secondary.menu .active.item {\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n  border-radius: 0.21428571rem;\n}\n\n/* Active Hover */\n\n.ui.secondary.menu .active.item:hover {\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n}\n\n/* Inverted */\n\n.ui.secondary.inverted.menu .link.item, .ui.secondary.inverted.menu a.item {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.ui.secondary.inverted.menu .dropdown.item:hover, .ui.secondary.inverted.menu .link.item:hover, .ui.secondary.inverted.menu a.item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff !important;\n}\n\n.ui.secondary.inverted.menu .active.item {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff !important;\n}\n\n/* Fix item margins */\n\n.ui.secondary.item.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n\n.ui.secondary.item.menu .item:last-child {\n  margin-right: 0em;\n}\n\n.ui.secondary.attached.menu {\n  box-shadow: none;\n}\n\n/* Sub Menu */\n\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu {\n  margin: 0em -0.92857143em;\n}\n\n.ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {\n  margin: 0em;\n  padding: 0.5em 1.33333333em;\n}\n\n/*---------------------\n   Secondary Vertical\n-----------------------*/\n\n.ui.secondary.vertical.menu > .item {\n  border: none;\n  margin: 0em 0em 0.35714286em;\n  border-radius: 0.21428571rem !important;\n}\n\n.ui.secondary.vertical.menu > .header.item {\n  border-radius: 0em;\n}\n\n/* Sub Menu */\n\n.ui.vertical.secondary.menu .item > .menu .item {\n  background-color: transparent;\n}\n\n/* Inverted */\n\n.ui.secondary.inverted.menu {\n  background-color: transparent;\n}\n\n/*---------------------\n   Secondary Pointing\n-----------------------*/\n\n.ui.secondary.pointing.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n  border-bottom: 3px solid #DEDEDF;\n}\n\n.ui.secondary.pointing.menu .item {\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-radius: 0em;\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n  margin: 0em 0em -3px;\n  padding: 0.85714286em 1.71428571em;\n  border-bottom-width: 3px;\n  transition: color 0.1s ease;\n}\n\n/* Item Types */\n\n.ui.secondary.pointing.menu .header.item {\n  color: rgba(0, 0, 0, 0.85) !important;\n}\n\n.ui.secondary.pointing.menu .text.item {\n  box-shadow: none !important;\n}\n\n.ui.secondary.pointing.menu .item:after {\n  display: none;\n}\n\n/* Hover */\n\n.ui.secondary.pointing.menu .dropdown.item:hover, .ui.secondary.pointing.menu .link.item:hover, .ui.secondary.pointing.menu a.item:hover {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Pressed */\n\n.ui.secondary.pointing.menu .dropdown.item:active, .ui.secondary.pointing.menu .link.item:active, .ui.secondary.pointing.menu a.item:active {\n  background-color: transparent;\n  border-color: #DEDEDF;\n}\n\n/* Active */\n\n.ui.secondary.pointing.menu .active.item {\n  background-color: transparent;\n  box-shadow: none;\n  border-color: #59D98D;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active Hover */\n\n.ui.secondary.pointing.menu .active.item:hover {\n  border-color: #59D98D;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active Dropdown */\n\n.ui.secondary.pointing.menu .active.dropdown.item {\n  border-color: transparent;\n}\n\n/* Vertical Pointing */\n\n.ui.secondary.vertical.pointing.menu {\n  border-bottom-width: 0px;\n  border-right-width: 3px;\n  border-right-style: solid;\n  border-right-color: #DEDEDF;\n}\n\n.ui.secondary.vertical.pointing.menu .item {\n  border-bottom: none;\n  border-right-style: solid;\n  border-right-color: transparent;\n  border-radius: 0em !important;\n  margin: 0em -3px 0em 0em;\n  border-right-width: 3px;\n}\n\n/* Vertical Active */\n\n.ui.secondary.vertical.pointing.menu .active.item {\n  border-color: #59D98D;\n}\n\n/* Inverted */\n\n.ui.secondary.inverted.pointing.menu {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.ui.secondary.inverted.pointing.menu {\n  border-width: 3px;\n  border-color: #DEDEDF;\n}\n\n.ui.secondary.inverted.pointing.menu .item {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.secondary.inverted.pointing.menu .header.item {\n  color: #FFFFFF !important;\n}\n\n/* Hover */\n\n.ui.secondary.inverted.pointing.menu .link.item:hover, .ui.secondary.inverted.pointing.menu a.item:hover {\n  color: #59D98D;\n}\n\n/* Active */\n\n.ui.secondary.inverted.pointing.menu .active.item {\n  border-color: #FFFFFF;\n  color: #ffffff;\n}\n\n/*--------------\n    Text Menu\n---------------*/\n\n.ui.text.menu {\n  background: none transparent;\n  border-radius: 0px;\n  box-shadow: none;\n  border: none;\n  margin: 1em -0.5em;\n}\n\n.ui.text.menu .item {\n  border-radius: 0px;\n  box-shadow: none;\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n  align-self: center;\n  margin: 0em 0em;\n  padding: 0.35714286em 0.5em;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.6);\n  transition: opacity 0.1s ease;\n}\n\n/* Border */\n\n.ui.text.menu .item:before, .ui.text.menu .menu .item:before {\n  display: none !important;\n}\n\n/* Header */\n\n.ui.text.menu .header.item {\n  background-color: transparent;\n  opacity: 1;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 0.92857143em;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n/* Image */\n\n.ui.text.menu .item > img:not(.ui) {\n  margin: 0em;\n}\n\n/*--- fluid text ---*/\n\n.ui.text.item.menu .item {\n  margin: 0em;\n}\n\n/*--- vertical text ---*/\n\n.ui.vertical.text.menu {\n  margin: 1em 0em;\n}\n\n.ui.vertical.text.menu:first-child {\n  margin-top: 0rem;\n}\n\n.ui.vertical.text.menu:last-child {\n  margin-bottom: 0rem;\n}\n\n.ui.vertical.text.menu .item {\n  margin: 0.57142857em 0em;\n  padding-left: 0em;\n  padding-right: 0em;\n}\n\n.ui.vertical.text.menu .item > i.icon {\n  float: none;\n  margin: 0em 0.35714286em 0em 0em;\n}\n\n.ui.vertical.text.menu .header.item {\n  margin: 0.57142857em 0em 0.71428571em;\n}\n\n/* Vertical Sub Menu */\n\n.ui.vertical.text.menu .item:not(.dropdown) > .menu {\n  margin: 0em;\n}\n\n.ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {\n  margin: 0em;\n  padding: 0.5em 0em;\n}\n\n/*--- hover ---*/\n\n.ui.text.menu .item:hover {\n  opacity: 1;\n  background-color: transparent;\n}\n\n/*--- active ---*/\n\n.ui.text.menu .active.item {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  font-weight: normal;\n  color: #59D98D;\n}\n\n/*--- active hover ---*/\n\n.ui.text.menu .active.item:hover {\n  background-color: transparent;\n}\n\n/* Disable Bariations */\n\n.ui.text.pointing.menu .active.item:after {\n  box-shadow: none;\n}\n\n.ui.text.attached.menu {\n  box-shadow: none;\n}\n\n/* Inverted */\n\n.ui.inverted.text.menu, .ui.inverted.text.menu .item, .ui.inverted.text.menu .item:hover, .ui.inverted.text.menu .active.item {\n  background-color: transparent !important;\n}\n\n/* Fluid */\n\n.ui.fluid.text.menu {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n\n/*--------------\n    Icon Only\n---------------*/\n\n/* Vertical Menu */\n\n.ui.vertical.icon.menu {\n  display: inline-block;\n  width: auto;\n}\n\n/* Item */\n\n.ui.icon.menu .item {\n  height: auto;\n  text-align: center;\n  color: #1B1C1D;\n}\n\n/* Icon */\n\n.ui.icon.menu .item > .icon:not(.dropdown) {\n  margin: 0;\n  opacity: 1;\n}\n\n/* Icon Gylph */\n\n.ui.icon.menu .icon:before {\n  opacity: 1;\n}\n\n/* (x) Item Icon */\n\n.ui.menu .icon.item > .icon {\n  width: auto;\n  margin: 0em auto;\n}\n\n/* Vertical Icon */\n\n.ui.vertical.icon.menu .item > .icon:not(.dropdown) {\n  display: block;\n  opacity: 1;\n  margin: 0em auto;\n  float: none;\n}\n\n/* Inverted */\n\n.ui.inverted.icon.menu .item {\n  color: #FFFFFF;\n}\n\n/*--------------\n   Labeled Icon\n---------------*/\n\n/* Menu */\n\n.ui.labeled.icon.menu {\n  text-align: center;\n}\n\n/* Item */\n\n.ui.labeled.icon.menu .item {\n  min-width: 6em;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n/* Icon */\n\n.ui.labeled.icon.menu .item > .icon:not(.dropdown) {\n  height: 1em;\n  display: block;\n  font-size: 1.71428571em !important;\n  margin: 0em auto 0.5rem !important;\n}\n\n/* Fluid */\n\n.ui.fluid.labeled.icon.menu > .item {\n  min-width: 0em;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Stackable\n---------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.stackable.menu {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n\n  .ui.stackable.menu .item {\n    width: 100% !important;\n  }\n\n  .ui.stackable.menu .item:before {\n    position: absolute;\n    content: '';\n    top: auto;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    height: 1px;\n    background: rgba(34, 36, 38, 0.1);\n  }\n\n  .ui.stackable.menu .left.menu, .ui.stackable.menu .left.item {\n    margin-right: 0 !important;\n  }\n\n  .ui.stackable.menu .right.menu, .ui.stackable.menu .right.item {\n    margin-left: 0 !important;\n  }\n\n  .ui.stackable.menu .right.menu, .ui.stackable.menu .left.menu {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n}\n\n/*--------------\n     Colors\n---------------*/\n\n/*--- Standard Colors  ---*/\n\n.ui.menu .red.active.item, .ui.red.menu .active.item {\n  border-color: #DB2828 !important;\n  color: #DB2828 !important;\n}\n\n.ui.menu .orange.active.item, .ui.orange.menu .active.item {\n  border-color: #FF9F5B !important;\n  color: #FF9F5B !important;\n}\n\n.ui.menu .yellow.active.item, .ui.yellow.menu .active.item {\n  border-color: #F9DC5C !important;\n  color: #F9DC5C !important;\n}\n\n.ui.menu .olive.active.item, .ui.olive.menu .active.item {\n  border-color: #B5CC18 !important;\n  color: #B5CC18 !important;\n}\n\n.ui.menu .green.active.item, .ui.green.menu .active.item {\n  border-color: #59D98D !important;\n  color: #59D98D !important;\n}\n\n.ui.menu .teal.active.item, .ui.teal.menu .active.item {\n  border-color: #00B5AD !important;\n  color: #00B5AD !important;\n}\n\n.ui.menu .blue.active.item, .ui.blue.menu .active.item {\n  border-color: #2185D0 !important;\n  color: #2185D0 !important;\n}\n\n.ui.menu .violet.active.item, .ui.violet.menu .active.item {\n  border-color: #6435C9 !important;\n  color: #6435C9 !important;\n}\n\n.ui.menu .purple.active.item, .ui.purple.menu .active.item {\n  border-color: #A333C8 !important;\n  color: #A333C8 !important;\n}\n\n.ui.menu .pink.active.item, .ui.pink.menu .active.item {\n  border-color: #E03997 !important;\n  color: #E03997 !important;\n}\n\n.ui.menu .brown.active.item, .ui.brown.menu .active.item {\n  border-color: #A5673F !important;\n  color: #A5673F !important;\n}\n\n.ui.menu .grey.active.item, .ui.grey.menu .active.item {\n  border-color: rgba(0, 0, 0, 0.4) !important;\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.menu {\n  border: 0px solid transparent;\n  background: #1B1C1D;\n  box-shadow: none;\n}\n\n/* Menu Item */\n\n.ui.inverted.menu .item, .ui.inverted.menu .item > a:not(.ui) {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.inverted.menu .item.menu {\n  background: transparent;\n}\n\n/*--- Border ---*/\n\n.ui.inverted.menu .item:before {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.ui.vertical.inverted.menu .item:before {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* Sub Menu */\n\n.ui.vertical.inverted.menu .menu .item, .ui.vertical.inverted.menu .menu .item a:not(.ui) {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Header */\n\n.ui.inverted.menu .header.item {\n  margin: 0em;\n  background: transparent;\n  box-shadow: none;\n}\n\n/* Disabled */\n\n.ui.inverted.menu .item.disabled, .ui.inverted.menu .item.disabled:hover {\n  color: rgba(225, 225, 225, 0.3);\n}\n\n/*--- Hover ---*/\n\n.ui.link.inverted.menu .item:hover, .ui.inverted.menu .dropdown.item:hover, .ui.inverted.menu .link.item:hover, .ui.inverted.menu a.item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.ui.vertical.inverted.menu .item .menu a.item:hover, .ui.vertical.inverted.menu .item .menu .link.item:hover {\n  background: transparent;\n  color: #ffffff;\n}\n\n/*--- Pressed ---*/\n\n.ui.inverted.menu a.item:active, .ui.inverted.menu .link.item:active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n/*--- Active ---*/\n\n.ui.inverted.menu .active.item {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff !important;\n}\n\n.ui.inverted.vertical.menu .item .menu .active.item {\n  background: transparent;\n  color: #FFFFFF;\n}\n\n.ui.inverted.pointing.menu .active.item:after {\n  background: #3D3E3F !important;\n  margin: 0em !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n/*--- Active Hover ---*/\n\n.ui.inverted.menu .active.item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: #FFFFFF !important;\n}\n\n.ui.inverted.pointing.menu .active.item:hover:after {\n  background: #3D3E3F !important;\n}\n\n/*--------------\n     Floated\n---------------*/\n\n.ui.floated.menu {\n  float: left;\n  margin: 0rem 0.5rem 0rem 0rem;\n}\n\n.ui.floated.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.right.floated.menu {\n  float: right;\n  margin: 0rem 0rem 0rem 0.5rem;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Red */\n\n.ui.inverted.menu .red.active.item, .ui.inverted.red.menu {\n  background-color: #DB2828;\n}\n\n.ui.inverted.red.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.red.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Orange */\n\n.ui.inverted.menu .orange.active.item, .ui.inverted.orange.menu {\n  background-color: #FF9F5B;\n}\n\n.ui.inverted.orange.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.orange.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Yellow */\n\n.ui.inverted.menu .yellow.active.item, .ui.inverted.yellow.menu {\n  background-color: #F9DC5C;\n}\n\n.ui.inverted.yellow.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.yellow.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Olive */\n\n.ui.inverted.menu .olive.active.item, .ui.inverted.olive.menu {\n  background-color: #B5CC18;\n}\n\n.ui.inverted.olive.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.olive.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Green */\n\n.ui.inverted.menu .green.active.item, .ui.inverted.green.menu {\n  background-color: #59D98D;\n}\n\n.ui.inverted.green.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.green.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Teal */\n\n.ui.inverted.menu .teal.active.item, .ui.inverted.teal.menu {\n  background-color: #00B5AD;\n}\n\n.ui.inverted.teal.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.teal.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Blue */\n\n.ui.inverted.menu .blue.active.item, .ui.inverted.blue.menu {\n  background-color: #2185D0;\n}\n\n.ui.inverted.blue.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.blue.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Violet */\n\n.ui.inverted.menu .violet.active.item, .ui.inverted.violet.menu {\n  background-color: #6435C9;\n}\n\n.ui.inverted.violet.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.violet.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Purple */\n\n.ui.inverted.menu .purple.active.item, .ui.inverted.purple.menu {\n  background-color: #A333C8;\n}\n\n.ui.inverted.purple.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.purple.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Pink */\n\n.ui.inverted.menu .pink.active.item, .ui.inverted.pink.menu {\n  background-color: #E03997;\n}\n\n.ui.inverted.pink.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.pink.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Brown */\n\n.ui.inverted.menu .brown.active.item, .ui.inverted.brown.menu {\n  background-color: #A5673F;\n}\n\n.ui.inverted.brown.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.brown.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Grey */\n\n.ui.inverted.menu .grey.active.item, .ui.inverted.grey.menu {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.inverted.grey.menu .item:before {\n  background-color: rgba(34, 36, 38, 0.1);\n}\n\n.ui.inverted.grey.menu .active.item {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n/*--------------\n     Fitted\n---------------*/\n\n.ui.fitted.menu .item, .ui.fitted.menu .item .menu .item, .ui.menu .fitted.item {\n  padding: 0em;\n}\n\n.ui.horizontally.fitted.menu .item, .ui.horizontally.fitted.menu .item .menu .item, .ui.menu .horizontally.fitted.item {\n  padding-top: 0.92857143em;\n  padding-bottom: 0.92857143em;\n}\n\n.ui.vertically.fitted.menu .item, .ui.vertically.fitted.menu .item .menu .item, .ui.menu .vertically.fitted.item {\n  padding-left: 1.14285714em;\n  padding-right: 1.14285714em;\n}\n\n/*--------------\n   Borderless\n---------------*/\n\n.ui.borderless.menu .item:before, .ui.borderless.menu .item .menu .item:before, .ui.menu .borderless.item:before {\n  background: none !important;\n}\n\n/*-------------------\n       Compact\n--------------------*/\n\n.ui.compact.menu {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 0em;\n  vertical-align: middle;\n}\n\n.ui.compact.vertical.menu {\n  display: inline-block;\n}\n\n.ui.compact.menu .item:last-child {\n  border-radius: 0em 0.21428571rem 0.21428571rem 0em;\n}\n\n.ui.compact.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.compact.vertical.menu {\n  width: auto !important;\n}\n\n.ui.compact.vertical.menu .item:last-child::before {\n  display: block;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.menu.fluid, .ui.vertical.menu.fluid {\n  width: 100% !important;\n}\n\n/*-------------------\n      Evenly Sized\n--------------------*/\n\n.ui.item.menu, .ui.item.menu .item {\n  width: 100%;\n  padding-left: 0em !important;\n  padding-right: 0em !important;\n  margin-left: 0em !important;\n  margin-right: 0em !important;\n  text-align: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.ui.attached.item.menu {\n  margin: 0em -1px !important;\n}\n\n.ui.item.menu .item:last-child:before {\n  display: none;\n}\n\n.ui.menu.two.item .item {\n  width: 50%;\n}\n\n.ui.menu.three.item .item {\n  width: 33.333%;\n}\n\n.ui.menu.four.item .item {\n  width: 25%;\n}\n\n.ui.menu.five.item .item {\n  width: 20%;\n}\n\n.ui.menu.six.item .item {\n  width: 16.666%;\n}\n\n.ui.menu.seven.item .item {\n  width: 14.285%;\n}\n\n.ui.menu.eight.item .item {\n  width: 12.5%;\n}\n\n.ui.menu.nine.item .item {\n  width: 11.11%;\n}\n\n.ui.menu.ten.item .item {\n  width: 10%;\n}\n\n.ui.menu.eleven.item .item {\n  width: 9.09%;\n}\n\n.ui.menu.twelve.item .item {\n  width: 8.333%;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.menu.fixed {\n  position: fixed;\n  z-index: 101;\n  margin: 0em;\n  width: 100%;\n}\n\n.ui.menu.fixed, .ui.menu.fixed .item:first-child, .ui.menu.fixed .item:last-child {\n  border-radius: 0px !important;\n}\n\n.ui.fixed.menu, .ui[class*=\"top fixed\"].menu {\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n}\n\n.ui[class*=\"top fixed\"].menu {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n\n.ui[class*=\"right fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n  top: 0px;\n  right: 0px;\n  left: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n\n.ui[class*=\"bottom fixed\"].menu {\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  bottom: 0px;\n  left: 0px;\n  top: auto;\n  right: auto;\n}\n\n.ui[class*=\"left fixed\"].menu {\n  border-top: none;\n  border-bottom: none;\n  border-left: none;\n  top: 0px;\n  left: 0px;\n  right: auto;\n  bottom: auto;\n  width: auto;\n  height: 100%;\n}\n\n/* Coupling with Grid */\n\n.ui.fixed.menu + .ui.grid {\n  padding-top: 2.75rem;\n}\n\n/*-------------------\n       Pointing\n--------------------*/\n\n.ui.pointing.menu .item:after {\n  visibility: hidden;\n  position: absolute;\n  content: '';\n  top: 100%;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  background: none;\n  margin: 0.5px 0em 0em;\n  width: 0.57142857em;\n  height: 0.57142857em;\n  border: none;\n  border-bottom: 1px solid #DEDEDF;\n  border-right: 1px solid #DEDEDF;\n  z-index: 2;\n  transition: background 0.1s ease;\n}\n\n.ui.vertical.pointing.menu .item:after {\n  position: absolute;\n  top: 50%;\n  right: 0%;\n  bottom: auto;\n  left: auto;\n  -webkit-transform: translateX(50%) translateY(-50%) rotate(45deg);\n  transform: translateX(50%) translateY(-50%) rotate(45deg);\n  margin: 0em -0.5px 0em 0em;\n  border: none;\n  border-top: 1px solid #DEDEDF;\n  border-right: 1px solid #DEDEDF;\n}\n\n/* Active */\n\n.ui.pointing.menu .active.item:after {\n  visibility: visible;\n}\n\n.ui.pointing.menu .active.dropdown.item:after {\n  visibility: hidden;\n}\n\n/* Don't double up pointers */\n\n.ui.pointing.menu .dropdown.active.item:after, .ui.pointing.menu .active.item .menu .active.item:after {\n  display: none;\n}\n\n/* Colors */\n\n.ui.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n\n.ui.pointing.menu .active.item:after {\n  background-color: #F2F2F2;\n}\n\n.ui.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n\n.ui.vertical.pointing.menu .active.item:hover:after {\n  background-color: #F2F2F2;\n}\n\n.ui.vertical.pointing.menu .active.item:after {\n  background-color: #F2F2F2;\n}\n\n.ui.vertical.pointing.menu .menu .active.item:after {\n  background-color: #FFFFFF;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n/* Middle */\n\n.ui.attached.menu {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% - (-1px * 2));\n  max-width: calc(100% - (-1px * 2));\n  box-shadow: none;\n}\n\n.ui.attached + .ui.attached.menu:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n\n.ui[class*=\"top attached\"].menu {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1rem;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.menu[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n\n.ui[class*=\"bottom attached\"].menu {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1rem;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, none;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui[class*=\"bottom attached\"].menu:last-child {\n  margin-bottom: 0em;\n}\n\n/* Attached Menu Item */\n\n.ui.top.attached.menu > .item:first-child {\n  border-radius: 0.21428571rem 0em 0em 0em;\n}\n\n.ui.bottom.attached.menu > .item:first-child {\n  border-radius: 0em 0em 0em 0.21428571rem;\n}\n\n/* Tabular Attached */\n\n.ui.attached.menu:not(.tabular) {\n  border: 1px solid #DEDEDF;\n}\n\n.ui.attached.inverted.menu {\n  border: none;\n}\n\n.ui.attached.tabular.menu {\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n/* Mini */\n\n.ui.mini.menu {\n  font-size: 0.78571429rem;\n}\n\n.ui.mini.vertical.menu {\n  width: 9rem;\n}\n\n/* Tiny */\n\n.ui.tiny.menu {\n  font-size: 0.85714286rem;\n}\n\n.ui.tiny.vertical.menu {\n  width: 11rem;\n}\n\n/* Small */\n\n.ui.small.menu {\n  font-size: 0.92857143rem;\n}\n\n.ui.small.vertical.menu {\n  width: 13rem;\n}\n\n/* Medium */\n\n.ui.menu {\n  font-size: 1rem;\n}\n\n.ui.vertical.menu {\n  width: 15rem;\n}\n\n/* Large */\n\n.ui.large.menu {\n  font-size: 1.07142857rem;\n}\n\n.ui.large.vertical.menu {\n  width: 18rem;\n}\n\n/* Huge */\n\n.ui.huge.menu {\n  font-size: 1.21428571rem;\n}\n\n.ui.huge.vertical.menu {\n  width: 22rem;\n}\n\n/* Big */\n\n.ui.big.menu {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.vertical.menu {\n  width: 20rem;\n}\n\n/* Massive */\n\n.ui.massive.menu {\n  font-size: 1.28571429rem;\n}\n\n.ui.massive.vertical.menu {\n  width: 25rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Message\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Message\n*******************************/\n\n.ui.message {\n  position: relative;\n  min-height: 1em;\n  margin: 1em 0em;\n  background: #F8F8F9;\n  padding: 1em 1.5em;\n  line-height: 1.4285em;\n  color: rgba(0, 0, 0, 0.8);\n  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;\n  border-radius: 0.21428571rem;\n  box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.message:first-child {\n  margin-top: 0em;\n}\n\n.ui.message:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Content\n---------------*/\n\n/* Header */\n\n.ui.message .header {\n  display: block;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  margin: -0.14285714em 0em 0rem 0em;\n}\n\n/* Default font size */\n\n.ui.message .header:not(.ui) {\n  font-size: 1.14285714em;\n}\n\n/* Paragraph */\n\n.ui.message p {\n  opacity: 0.85;\n  margin: 0.75em 0em;\n}\n\n.ui.message p:first-child {\n  margin-top: 0em;\n}\n\n.ui.message p:last-child {\n  margin-bottom: 0em;\n}\n\n.ui.message .header + p {\n  margin-top: 0.25em;\n}\n\n/* List */\n\n.ui.message .list:not(.ui) {\n  text-align: left;\n  padding: 0em;\n  opacity: 0.85;\n  list-style-position: inside;\n  margin: 0.5em 0em 0em;\n}\n\n.ui.message .list:not(.ui):first-child {\n  margin-top: 0em;\n}\n\n.ui.message .list:not(.ui):last-child {\n  margin-bottom: 0em;\n}\n\n.ui.message .list:not(.ui) li {\n  position: relative;\n  list-style-type: none;\n  margin: 0em 0em 0.3em 1em;\n  padding: 0em;\n}\n\n.ui.message .list:not(.ui) li:before {\n  position: absolute;\n  content: '\\2022';\n  left: -1em;\n  height: 100%;\n  vertical-align: baseline;\n}\n\n.ui.message .list:not(.ui) li:last-child {\n  margin-bottom: 0em;\n}\n\n/* Icon */\n\n.ui.message > .icon {\n  margin-right: 0.6em;\n}\n\n/* Close Icon */\n\n.ui.message > .close.icon {\n  cursor: pointer;\n  position: absolute;\n  margin: 0em;\n  top: 0.78575em;\n  right: 0.5em;\n  opacity: 0.7;\n  transition: opacity 0.1s ease;\n}\n\n.ui.message > .close.icon:hover {\n  opacity: 1;\n}\n\n/* First / Last Element */\n\n.ui.message > :first-child {\n  margin-top: 0em;\n}\n\n.ui.message > :last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n.ui.dropdown .menu > .message {\n  margin: 0px -1px;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n    Visible\n---------------*/\n\n.ui.visible.visible.visible.visible.message {\n  display: block;\n}\n\n.ui.icon.visible.visible.visible.visible.message {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*--------------\n     Hidden\n---------------*/\n\n.ui.hidden.hidden.hidden.hidden.message {\n  display: none;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n    Compact\n---------------*/\n\n.ui.compact.message {\n  display: inline-block;\n}\n\n.ui.compact.icon.message {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n.ui.attached.message {\n  margin-bottom: -1px;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n  box-shadow: 0em 0em 0em 1px #DEDEDF inset;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.ui.attached + .ui.attached.message:not(.top):not(.bottom) {\n  margin-top: -1px;\n  border-radius: 0em;\n}\n\n.ui.bottom.attached.message {\n  margin-top: -1px;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  box-shadow: 0em 0em 0em 1px #DEDEDF inset, 0px 1px 2px 0 #DEDEDF;\n}\n\n.ui.bottom.attached.message:not(:last-child) {\n  margin-bottom: 1em;\n}\n\n.ui.attached.icon.message {\n  width: auto;\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.icon.message {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ui.icon.message > .icon:not(.close) {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n  line-height: 1;\n  vertical-align: middle;\n  font-size: 3em;\n  opacity: 0.8;\n}\n\n.ui.icon.message > .content {\n  display: block;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  vertical-align: middle;\n}\n\n.ui.icon.message .icon:not(.close) + .content {\n  padding-left: 0rem;\n}\n\n.ui.icon.message .circular.icon {\n  width: 1em;\n}\n\n/*--------------\n    Floating\n---------------*/\n\n.ui.floating.message {\n  box-shadow: 0px 0px 0px 1px rgba(34, 36, 38, 0.22) inset, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n\n/*--------------\n     Colors\n---------------*/\n\n.ui.black.message {\n  background-color: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/*--------------\n     Types\n---------------*/\n\n/* Positive */\n\n.ui.positive.message {\n  background-color: #FCFFF5;\n  color: #2C662D;\n}\n\n.ui.positive.message, .ui.attached.positive.message {\n  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.positive.message .header {\n  color: #1A531B;\n}\n\n/* Negative */\n\n.ui.negative.message {\n  background-color: #FFF6F6;\n  color: #9F3A38;\n}\n\n.ui.negative.message, .ui.attached.negative.message {\n  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.negative.message .header {\n  color: #912D2B;\n}\n\n/* Info */\n\n.ui.info.message {\n  background-color: #F8FFFF;\n  color: #276F86;\n}\n\n.ui.info.message, .ui.attached.info.message {\n  box-shadow: 0px 0px 0px 1px #A9D5DE inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.info.message .header {\n  color: #0E566C;\n}\n\n/* Warning */\n\n.ui.warning.message {\n  background-color: #FFFAF3;\n  color: #573A08;\n}\n\n.ui.warning.message, .ui.attached.warning.message {\n  box-shadow: 0px 0px 0px 1px #C9BA9B inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.warning.message .header {\n  color: #794B02;\n}\n\n/* Error */\n\n.ui.error.message {\n  background-color: #FFF6F6;\n  color: #9F3A38;\n}\n\n.ui.error.message, .ui.attached.error.message {\n  box-shadow: 0px 0px 0px 1px #E0B4B4 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.error.message .header {\n  color: #912D2B;\n}\n\n/* Success */\n\n.ui.success.message {\n  background-color: #FCFFF5;\n  color: #2C662D;\n}\n\n.ui.success.message, .ui.attached.success.message {\n  box-shadow: 0px 0px 0px 1px #A3C293 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.success.message .header {\n  color: #1A531B;\n}\n\n/* Colors */\n\n.ui.inverted.message, .ui.black.message {\n  background-color: #1B1C1D;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.red.message {\n  background-color: #FFE8E6;\n  color: #DB2828;\n  box-shadow: 0px 0px 0px 1px #DB2828 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.red.message .header {\n  color: #c82121;\n}\n\n.ui.orange.message {\n  background-color: #FFEDDE;\n  color: #FF9F5B;\n  box-shadow: 0px 0px 0px 1px #FF9F5B inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.orange.message .header {\n  color: #ff9042;\n}\n\n.ui.yellow.message {\n  background-color: #FFF8DB;\n  color: #B58105;\n  box-shadow: 0px 0px 0px 1px #B58105 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.yellow.message .header {\n  color: #9c6f04;\n}\n\n.ui.olive.message {\n  background-color: #FBFDEF;\n  color: #8ABC1E;\n  box-shadow: 0px 0px 0px 1px #8ABC1E inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.olive.message .header {\n  color: #7aa61a;\n}\n\n.ui.green.message {\n  background-color: #E5F9E7;\n  color: #1EBC30;\n  box-shadow: 0px 0px 0px 1px #1EBC30 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.green.message .header {\n  color: #1aa62a;\n}\n\n.ui.teal.message {\n  background-color: #E1F7F7;\n  color: #10A3A3;\n  box-shadow: 0px 0px 0px 1px #10A3A3 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.teal.message .header {\n  color: #0e8c8c;\n}\n\n.ui.blue.message {\n  background-color: #DFF0FF;\n  color: #2185D0;\n  box-shadow: 0px 0px 0px 1px #2185D0 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.blue.message .header {\n  color: #1e77ba;\n}\n\n.ui.violet.message {\n  background-color: #EAE7FF;\n  color: #6435C9;\n  box-shadow: 0px 0px 0px 1px #6435C9 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.violet.message .header {\n  color: #5a30b5;\n}\n\n.ui.purple.message {\n  background-color: #F6E7FF;\n  color: #A333C8;\n  box-shadow: 0px 0px 0px 1px #A333C8 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.purple.message .header {\n  color: #922eb4;\n}\n\n.ui.pink.message {\n  background-color: #FFE3FB;\n  color: #E03997;\n  box-shadow: 0px 0px 0px 1px #E03997 inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.pink.message .header {\n  color: #dd238b;\n}\n\n.ui.brown.message {\n  background-color: #F1E2D3;\n  color: #A5673F;\n  box-shadow: 0px 0px 0px 1px #A5673F inset, 0px 0px 0px 0px rgba(0, 0, 0, 0);\n}\n\n.ui.brown.message .header {\n  color: #935b38;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.message {\n  font-size: 0.78571429em;\n}\n\n.ui.tiny.message {\n  font-size: 0.85714286em;\n}\n\n.ui.small.message {\n  font-size: 0.92857143em;\n}\n\n.ui.message {\n  font-size: 1em;\n}\n\n.ui.large.message {\n  font-size: 1.14285714em;\n}\n\n.ui.big.message {\n  font-size: 1.28571429em;\n}\n\n.ui.huge.message {\n  font-size: 1.42857143em;\n}\n\n.ui.massive.message {\n  font-size: 1.71428571em;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n        Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Table\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Table\n*******************************/\n\n/* Prototype */\n\n.ui.table {\n  width: 100%;\n  background: #FFFFFF;\n  margin: 1em 0em;\n  border: 1px solid #DEDEDF;\n  box-shadow: none;\n  border-radius: 0.21428571rem;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.8);\n  border-collapse: separate;\n  border-spacing: 0px;\n}\n\n.ui.table:first-child {\n  margin-top: 0em;\n}\n\n.ui.table:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n             Parts\n*******************************/\n\n/* Table Content */\n\n.ui.table th, .ui.table td {\n  transition: background 0.1s ease, color 0.1s ease;\n}\n\n/* Headers */\n\n.ui.table thead {\n  box-shadow: none;\n}\n\n.ui.table thead th {\n  cursor: auto;\n  background: #F9FAFB;\n  text-align: inherit;\n  color: rgba(0, 0, 0, 0.8);\n  padding: 0.92857143em 0.78571429em;\n  vertical-align: inherit;\n  font-style: none;\n  font-weight: bold;\n  text-transform: none;\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n  border-left: none;\n}\n\n.ui.table thead tr > th:first-child {\n  border-left: none;\n}\n\n.ui.table thead tr:first-child > th:first-child {\n  border-radius: 0.21428571rem 0em 0em 0em;\n}\n\n.ui.table thead tr:first-child > th:last-child {\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n.ui.table thead tr:first-child > th:only-child {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n/* Footer */\n\n.ui.table tfoot {\n  box-shadow: none;\n}\n\n.ui.table tfoot th {\n  cursor: auto;\n  border-top: 1px solid #DEDEDF;\n  background: #F9FAFB;\n  text-align: inherit;\n  color: rgba(0, 0, 0, 0.8);\n  padding: 0.78571429em 0.78571429em;\n  vertical-align: middle;\n  font-style: normal;\n  font-weight: normal;\n  text-transform: none;\n}\n\n.ui.table tfoot tr > th:first-child {\n  border-left: none;\n}\n\n.ui.table tfoot tr:first-child > th:first-child {\n  border-radius: 0em 0em 0em 0.21428571rem;\n}\n\n.ui.table tfoot tr:first-child > th:last-child {\n  border-radius: 0em 0em 0.21428571rem 0em;\n}\n\n.ui.table tfoot tr:first-child > th:only-child {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n/* Table Row */\n\n.ui.table tr td {\n  border-top: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n.ui.table tr:first-child td {\n  border-top: none;\n}\n\n/* Repeated tbody */\n\n.ui.table tbody + tbody tr:first-child td {\n  border-top: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n/* Table Cells */\n\n.ui.table td {\n  padding: 0.78571429em 0.78571429em;\n  text-align: inherit;\n}\n\n/* Icons */\n\n.ui.table > .icon {\n  vertical-align: baseline;\n}\n\n.ui.table > .icon:only-child {\n  margin: 0em;\n}\n\n/* Table Segment */\n\n.ui.table.segment {\n  padding: 0em;\n}\n\n.ui.table.segment:after {\n  display: none;\n}\n\n.ui.table.segment.stacked:after {\n  display: block;\n}\n\n/* Responsive */\n\n@media only screen and (max-width: 767px) {\n  .ui.table:not(.unstackable) {\n    width: 100%;\n  }\n\n  .ui.table:not(.unstackable) tbody, .ui.table:not(.unstackable) tr, .ui.table:not(.unstackable) tr > th, .ui.table:not(.unstackable) tr > td {\n    width: auto !important;\n    display: block !important;\n  }\n\n  .ui.table:not(.unstackable) {\n    padding: 0em;\n  }\n\n  .ui.table:not(.unstackable) thead {\n    display: block;\n  }\n\n  .ui.table:not(.unstackable) tfoot {\n    display: block;\n  }\n\n  .ui.table:not(.unstackable) tr {\n    padding-top: 1em;\n    padding-bottom: 1em;\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;\n  }\n\n  .ui.table:not(.unstackable) tr > th, .ui.table:not(.unstackable) tr > td {\n    background: none;\n    border: none !important;\n    padding: 0.25em 0.75em !important;\n    box-shadow: none !important;\n  }\n\n  .ui.table:not(.unstackable) th:first-child, .ui.table:not(.unstackable) td:first-child {\n    font-weight: bold;\n  }\n\n  /* Definition Table */\n\n  .ui.definition.table:not(.unstackable) thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n/* UI Image */\n\n.ui.table th .image, .ui.table th .image img, .ui.table td .image, .ui.table td .image img {\n  max-width: none;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n    Complex\n---------------*/\n\n.ui.structured.table {\n  border-collapse: collapse;\n}\n\n.ui.structured.table thead th {\n  border-left: none;\n  border-right: none;\n}\n\n.ui.structured.sortable.table thead th {\n  border-left: 1px solid #DEDEDF;\n  border-right: 1px solid #DEDEDF;\n}\n\n.ui.structured.basic.table th {\n  border-left: none;\n  border-right: none;\n}\n\n.ui.structured.celled.table tr th, .ui.structured.celled.table tr td {\n  border-left: 1px solid rgba(34, 36, 38, 0.1);\n  border-right: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n/*--------------\n   Definition\n---------------*/\n\n.ui.definition.table thead:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: transparent;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.4);\n  box-shadow: -1px -1px 0px 1px #FFFFFF;\n}\n\n.ui.definition.table tfoot:not(.full-width) th:first-child {\n  pointer-events: none;\n  background: transparent;\n  font-weight: rgba(0, 0, 0, 0.4);\n  color: normal;\n  box-shadow: 1px 1px 0px 1px #FFFFFF;\n}\n\n/* Remove Border */\n\n.ui.celled.definition.table thead:not(.full-width) th:first-child {\n  box-shadow: 0px -1px 0px 1px #FFFFFF;\n}\n\n.ui.celled.definition.table tfoot:not(.full-width) th:first-child {\n  box-shadow: 0px 1px 0px 1px #FFFFFF;\n}\n\n/* Highlight Defining Column */\n\n.ui.definition.table tr td:first-child:not(.ignored), .ui.definition.table tr td.definition {\n  background: rgba(0, 0, 0, 0.03);\n  font-weight: bold;\n  color: #59D98D;\n  text-transform: '';\n  box-shadow: '';\n  text-align: '';\n  font-size: 1em;\n  padding-left: '';\n  padding-right: '';\n}\n\n/* Fix 2nd Column */\n\n.ui.definition.table thead:not(.full-width) th:nth-child(2) {\n  border-left: 1px solid #DEDEDF;\n}\n\n.ui.definition.table tfoot:not(.full-width) th:nth-child(2) {\n  border-left: 1px solid #DEDEDF;\n}\n\n.ui.definition.table td:nth-child(2) {\n  border-left: 1px solid #DEDEDF;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n    Positive\n---------------*/\n\n.ui.table tr.positive, .ui.table td.positive {\n  box-shadow: 0px 0px 0px #A3C293 inset;\n}\n\n.ui.table tr.positive, .ui.table td.positive {\n  background: #FCFFF5 !important;\n  color: #2C662D !important;\n}\n\n/*--------------\n     Negative\n---------------*/\n\n.ui.table tr.negative, .ui.table td.negative {\n  box-shadow: 0px 0px 0px #E0B4B4 inset;\n}\n\n.ui.table tr.negative, .ui.table td.negative {\n  background: #FFF6F6 !important;\n  color: #9F3A38 !important;\n}\n\n/*--------------\n      Error\n---------------*/\n\n.ui.table tr.error, .ui.table td.error {\n  box-shadow: 0px 0px 0px #E0B4B4 inset;\n}\n\n.ui.table tr.error, .ui.table td.error {\n  background: #FFF6F6 !important;\n  color: #9F3A38 !important;\n}\n\n/*--------------\n     Warning\n---------------*/\n\n.ui.table tr.warning, .ui.table td.warning {\n  box-shadow: 0px 0px 0px #C9BA9B inset;\n}\n\n.ui.table tr.warning, .ui.table td.warning {\n  background: #FFFAF3 !important;\n  color: #573A08 !important;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.table tr.active, .ui.table td.active {\n  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.8) inset;\n}\n\n.ui.table tr.active, .ui.table td.active {\n  background: #E0E0E0 !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.table tr.disabled td, .ui.table tr td.disabled, .ui.table tr.disabled:hover, .ui.table tr:hover td.disabled {\n  pointer-events: none;\n  color: rgba(40, 40, 40, 0.3);\n}\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n    Stackable\n---------------*/\n\n@media only screen and (max-width: 991px) {\n  .ui[class*=\"tablet stackable\"].table, .ui[class*=\"tablet stackable\"].table tbody, .ui[class*=\"tablet stackable\"].table tr, .ui[class*=\"tablet stackable\"].table tr > th, .ui[class*=\"tablet stackable\"].table tr > td {\n    width: 100% !important;\n    display: block !important;\n  }\n\n  .ui[class*=\"tablet stackable\"].table {\n    padding: 0em;\n  }\n\n  .ui[class*=\"tablet stackable\"].table thead {\n    display: block;\n  }\n\n  .ui[class*=\"tablet stackable\"].table tfoot {\n    display: block;\n  }\n\n  .ui[class*=\"tablet stackable\"].table tr {\n    padding-top: 1em;\n    padding-bottom: 1em;\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;\n  }\n\n  .ui[class*=\"tablet stackable\"].table tr > th, .ui[class*=\"tablet stackable\"].table tr > td {\n    background: none;\n    border: none !important;\n    padding: 0.25em 0.75em;\n    box-shadow: none !important;\n  }\n\n  /* Definition Table */\n\n  .ui.definition[class*=\"tablet stackable\"].table thead th:first-child {\n    box-shadow: none !important;\n  }\n}\n\n/*--------------\n Text Alignment\n---------------*/\n\n.ui.table[class*=\"left aligned\"], .ui.table [class*=\"left aligned\"] {\n  text-align: left;\n}\n\n.ui.table[class*=\"center aligned\"], .ui.table [class*=\"center aligned\"] {\n  text-align: center;\n}\n\n.ui.table[class*=\"right aligned\"], .ui.table [class*=\"right aligned\"] {\n  text-align: right;\n}\n\n/*------------------\n Vertical Alignment\n------------------*/\n\n.ui.table[class*=\"top aligned\"], .ui.table [class*=\"top aligned\"] {\n  vertical-align: top;\n}\n\n.ui.table[class*=\"middle aligned\"], .ui.table [class*=\"middle aligned\"] {\n  vertical-align: middle;\n}\n\n.ui.table[class*=\"bottom aligned\"], .ui.table [class*=\"bottom aligned\"] {\n  vertical-align: bottom;\n}\n\n/*--------------\n    Collapsing\n---------------*/\n\n.ui.table th.collapsing, .ui.table td.collapsing {\n  width: 1px;\n  white-space: nowrap;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.fixed.table {\n  table-layout: fixed;\n}\n\n.ui.fixed.table th, .ui.fixed.table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/*--------------\n   Selectable\n---------------*/\n\n.ui.selectable.table tbody tr:hover, .ui.table tbody tr td.selectable:hover {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: #59D98D !important;\n}\n\n.ui.selectable.inverted.table tbody tr:hover, .ui.inverted.table tbody tr td.selectable:hover {\n  background: rgba(255, 255, 255, 0.08) !important;\n  color: #ffffff !important;\n}\n\n/* Selectable Cell Link */\n\n.ui.table tbody tr td.selectable {\n  padding: 0em;\n}\n\n.ui.table tbody tr td.selectable > a:not(.ui) {\n  display: block;\n  color: inherit;\n  padding: 0.78571429em 0.78571429em;\n}\n\n/* Other States */\n\n.ui.selectable.table tr.error:hover, .ui.table tr td.selectable.error:hover, .ui.selectable.table tr:hover td.error {\n  background: #ffe7e7 !important;\n  color: #943634 !important;\n}\n\n.ui.selectable.table tr.warning:hover, .ui.table tr td.selectable.warning:hover, .ui.selectable.table tr:hover td.warning {\n  background: #fff4e4 !important;\n  color: #493107 !important;\n}\n\n.ui.selectable.table tr.active:hover, .ui.table tr td.selectable.active:hover, .ui.selectable.table tr:hover td.active {\n  background: #E0E0E0 !important;\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n\n.ui.selectable.table tr.positive:hover, .ui.table tr td.selectable.positive:hover, .ui.selectable.table tr:hover td.positive {\n  background: #f7ffe6 !important;\n  color: #275b28 !important;\n}\n\n.ui.selectable.table tr.negative:hover, .ui.table tr td.selectable.negative:hover, .ui.selectable.table tr:hover td.negative {\n  background: #ffe7e7 !important;\n  color: #943634 !important;\n}\n\n/*-------------------\n      Attached\n--------------------*/\n\n/* Middle */\n\n.ui.attached.table {\n  top: 0px;\n  bottom: 0px;\n  border-radius: 0px;\n  margin: 0em -1px;\n  width: calc(100% +  2px );\n  max-width: calc(100% +  2px );\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n}\n\n.ui.attached + .ui.attached.table:not(.top) {\n  border-top: none;\n}\n\n/* Top */\n\n.ui[class*=\"top attached\"].table {\n  bottom: 0px;\n  margin-bottom: 0em;\n  top: 0px;\n  margin-top: 1em;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.table[class*=\"top attached\"]:first-child {\n  margin-top: 0em;\n}\n\n/* Bottom */\n\n.ui[class*=\"bottom attached\"].table {\n  bottom: 0px;\n  margin-top: 0em;\n  top: 0px;\n  margin-bottom: 1em;\n  box-shadow: none, none;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui[class*=\"bottom attached\"].table:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Striped\n---------------*/\n\n/* Table Striping */\n\n.ui.striped.table > tr:nth-child(2n), .ui.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(0, 0, 50, 0.02);\n}\n\n/* Stripes */\n\n.ui.inverted.striped.table > tr:nth-child(2n), .ui.inverted.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n/* Allow striped active hover */\n\n.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {\n  background: #EFEFEF !important;\n  color: #59D98D !important;\n}\n\n/*--------------\n   Single Line\n---------------*/\n\n.ui.table[class*=\"single line\"], .ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n\n.ui.table[class*=\"single line\"], .ui.table [class*=\"single line\"] {\n  white-space: nowrap;\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n\n.ui.red.table {\n  border-top: 0.2em solid #DB2828;\n}\n\n.ui.inverted.red.table {\n  background-color: #DB2828 !important;\n  color: #FFFFFF !important;\n}\n\n/* Orange */\n\n.ui.orange.table {\n  border-top: 0.2em solid #FF9F5B;\n}\n\n.ui.inverted.orange.table {\n  background-color: #FF9F5B !important;\n  color: #FFFFFF !important;\n}\n\n/* Yellow */\n\n.ui.yellow.table {\n  border-top: 0.2em solid #F9DC5C;\n}\n\n.ui.inverted.yellow.table {\n  background-color: #F9DC5C !important;\n  color: #FFFFFF !important;\n}\n\n/* Olive */\n\n.ui.olive.table {\n  border-top: 0.2em solid #B5CC18;\n}\n\n.ui.inverted.olive.table {\n  background-color: #B5CC18 !important;\n  color: #FFFFFF !important;\n}\n\n/* Green */\n\n.ui.green.table {\n  border-top: 0.2em solid #59D98D;\n}\n\n.ui.inverted.green.table {\n  background-color: #59D98D !important;\n  color: #FFFFFF !important;\n}\n\n/* Teal */\n\n.ui.teal.table {\n  border-top: 0.2em solid #00B5AD;\n}\n\n.ui.inverted.teal.table {\n  background-color: #00B5AD !important;\n  color: #FFFFFF !important;\n}\n\n/* Blue */\n\n.ui.blue.table {\n  border-top: 0.2em solid #2185D0;\n}\n\n.ui.inverted.blue.table {\n  background-color: #2185D0 !important;\n  color: #FFFFFF !important;\n}\n\n/* Violet */\n\n.ui.violet.table {\n  border-top: 0.2em solid #6435C9;\n}\n\n.ui.inverted.violet.table {\n  background-color: #6435C9 !important;\n  color: #FFFFFF !important;\n}\n\n/* Purple */\n\n.ui.purple.table {\n  border-top: 0.2em solid #A333C8;\n}\n\n.ui.inverted.purple.table {\n  background-color: #A333C8 !important;\n  color: #FFFFFF !important;\n}\n\n/* Pink */\n\n.ui.pink.table {\n  border-top: 0.2em solid #E03997;\n}\n\n.ui.inverted.pink.table {\n  background-color: #E03997 !important;\n  color: #FFFFFF !important;\n}\n\n/* Brown */\n\n.ui.brown.table {\n  border-top: 0.2em solid #A5673F;\n}\n\n.ui.inverted.brown.table {\n  background-color: #A5673F !important;\n  color: #FFFFFF !important;\n}\n\n/* Grey */\n\n.ui.grey.table {\n  border-top: 0.2em solid rgba(0, 0, 0, 0.4);\n}\n\n.ui.inverted.grey.table {\n  background-color: rgba(0, 0, 0, 0.4) !important;\n  color: #FFFFFF !important;\n}\n\n/* Black */\n\n.ui.black.table {\n  border-top: 0.2em solid #1B1C1D;\n}\n\n.ui.inverted.black.table {\n  background-color: #1B1C1D !important;\n  color: #FFFFFF !important;\n}\n\n/*--------------\n  Column Count\n---------------*/\n\n/* Grid Based */\n\n.ui.one.column.table td {\n  width: 100%;\n}\n\n.ui.two.column.table td {\n  width: 50%;\n}\n\n.ui.three.column.table td {\n  width: 33.33333333%;\n}\n\n.ui.four.column.table td {\n  width: 25%;\n}\n\n.ui.five.column.table td {\n  width: 20%;\n}\n\n.ui.six.column.table td {\n  width: 16.66666667%;\n}\n\n.ui.seven.column.table td {\n  width: 14.28571429%;\n}\n\n.ui.eight.column.table td {\n  width: 12.5%;\n}\n\n.ui.nine.column.table td {\n  width: 11.11111111%;\n}\n\n.ui.ten.column.table td {\n  width: 10%;\n}\n\n.ui.eleven.column.table td {\n  width: 9.09090909%;\n}\n\n.ui.twelve.column.table td {\n  width: 8.33333333%;\n}\n\n.ui.thirteen.column.table td {\n  width: 7.69230769%;\n}\n\n.ui.fourteen.column.table td {\n  width: 7.14285714%;\n}\n\n.ui.fifteen.column.table td {\n  width: 6.66666667%;\n}\n\n.ui.sixteen.column.table td {\n  width: 6.25%;\n}\n\n/* Column Width */\n\n.ui.table th.one.wide, .ui.table td.one.wide {\n  width: 6.25%;\n}\n\n.ui.table th.two.wide, .ui.table td.two.wide {\n  width: 12.5%;\n}\n\n.ui.table th.three.wide, .ui.table td.three.wide {\n  width: 18.75%;\n}\n\n.ui.table th.four.wide, .ui.table td.four.wide {\n  width: 25%;\n}\n\n.ui.table th.five.wide, .ui.table td.five.wide {\n  width: 31.25%;\n}\n\n.ui.table th.six.wide, .ui.table td.six.wide {\n  width: 37.5%;\n}\n\n.ui.table th.seven.wide, .ui.table td.seven.wide {\n  width: 43.75%;\n}\n\n.ui.table th.eight.wide, .ui.table td.eight.wide {\n  width: 50%;\n}\n\n.ui.table th.nine.wide, .ui.table td.nine.wide {\n  width: 56.25%;\n}\n\n.ui.table th.ten.wide, .ui.table td.ten.wide {\n  width: 62.5%;\n}\n\n.ui.table th.eleven.wide, .ui.table td.eleven.wide {\n  width: 68.75%;\n}\n\n.ui.table th.twelve.wide, .ui.table td.twelve.wide {\n  width: 75%;\n}\n\n.ui.table th.thirteen.wide, .ui.table td.thirteen.wide {\n  width: 81.25%;\n}\n\n.ui.table th.fourteen.wide, .ui.table td.fourteen.wide {\n  width: 87.5%;\n}\n\n.ui.table th.fifteen.wide, .ui.table td.fifteen.wide {\n  width: 93.75%;\n}\n\n.ui.table th.sixteen.wide, .ui.table td.sixteen.wide {\n  width: 100%;\n}\n\n/*--------------\n    Sortable\n---------------*/\n\n.ui.sortable.table thead th {\n  cursor: pointer;\n  white-space: nowrap;\n  border-left: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.sortable.table thead th:first-child {\n  border-left: none;\n}\n\n.ui.sortable.table thead th.sorted, .ui.sortable.table thead th.sorted:hover {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ui.sortable.table thead th:after {\n  display: none;\n  font-style: normal;\n  font-weight: normal;\n  text-decoration: inherit;\n  content: '';\n  height: 1em;\n  width: auto;\n  opacity: 0.8;\n  margin: 0em 0em 0em 0.5em;\n  font-family: 'Icons';\n}\n\n.ui.sortable.table thead th.ascending:after {\n  content: '\\F0D8';\n}\n\n.ui.sortable.table thead th.descending:after {\n  content: '\\F0D7';\n}\n\n/* Hover */\n\n.ui.sortable.table th.disabled:hover {\n  cursor: auto;\n  color: rgba(40, 40, 40, 0.3);\n}\n\n.ui.sortable.table thead th:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Sorted */\n\n.ui.sortable.table thead th.sorted {\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n}\n\n.ui.sortable.table thead th.sorted:after {\n  display: inline-block;\n}\n\n/* Sorted Hover */\n\n.ui.sortable.table thead th.sorted:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n}\n\n/* Inverted */\n\n.ui.inverted.sortable.table thead th.sorted {\n  background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  color: #ffffff;\n}\n\n.ui.inverted.sortable.table thead th:hover {\n  background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  color: #ffffff;\n}\n\n.ui.inverted.sortable.table thead th {\n  border-left-color: transparent;\n  border-right-color: transparent;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Text Color */\n\n.ui.inverted.table {\n  background: #333333;\n  color: rgba(255, 255, 255, 0.9);\n  border: none;\n}\n\n.ui.inverted.table th {\n  background-color: rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.1) !important;\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.ui.inverted.table tr td {\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.ui.inverted.table tr.disabled td, .ui.inverted.table tr td.disabled, .ui.inverted.table tr.disabled:hover td, .ui.inverted.table tr:hover td.disabled {\n  pointer-events: none;\n  color: rgba(225, 225, 225, 0.3);\n}\n\n/* Definition */\n\n.ui.inverted.definition.table tfoot:not(.full-width) th:first-child, .ui.inverted.definition.table thead:not(.full-width) th:first-child {\n  background: #FFFFFF;\n}\n\n.ui.inverted.definition.table tr td:first-child {\n  background: rgba(255, 255, 255, 0.02);\n  color: #ffffff;\n}\n\n/*--------------\n   Collapsing\n---------------*/\n\n.ui.collapsing.table {\n  width: auto;\n}\n\n/*--------------\n      Basic\n---------------*/\n\n.ui.basic.table {\n  background: transparent;\n  border: 1px solid #DEDEDF;\n  box-shadow: none;\n}\n\n.ui.basic.table thead, .ui.basic.table tfoot {\n  box-shadow: none;\n}\n\n.ui.basic.table th {\n  background: transparent;\n  border-left: none;\n}\n\n.ui.basic.table tbody tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.ui.basic.table td {\n  background: transparent;\n}\n\n.ui.basic.striped.table tbody tr:nth-child(2n) {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n/* Very Basic */\n\n.ui[class*=\"very basic\"].table {\n  border: none;\n}\n\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th, .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td {\n  padding: '';\n}\n\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:first-child, .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:first-child {\n  padding-left: 0em;\n}\n\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:last-child, .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:last-child {\n  padding-right: 0em;\n}\n\n.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) thead tr:first-child th {\n  padding-top: 0em;\n}\n\n/*--------------\n     Celled\n---------------*/\n\n.ui.celled.table tr th, .ui.celled.table tr td {\n  border-left: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n.ui.celled.table tr th:first-child, .ui.celled.table tr td:first-child {\n  border-left: none;\n}\n\n/*--------------\n     Padded\n---------------*/\n\n.ui.padded.table th {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n\n.ui.padded.table th, .ui.padded.table td {\n  padding: 1em 1em;\n}\n\n/* Very */\n\n.ui[class*=\"very padded\"].table th {\n  padding-left: 1.5em;\n  padding-right: 1.5em;\n}\n\n.ui[class*=\"very padded\"].table td {\n  padding: 1.5em 1.5em;\n}\n\n/*--------------\n     Compact\n---------------*/\n\n.ui.compact.table th {\n  padding-left: 0.7em;\n  padding-right: 0.7em;\n}\n\n.ui.compact.table td {\n  padding: 0.5em 0.7em;\n}\n\n/* Very */\n\n.ui[class*=\"very compact\"].table th {\n  padding-left: 0.6em;\n  padding-right: 0.6em;\n}\n\n.ui[class*=\"very compact\"].table td {\n  padding: 0.4em 0.6em;\n}\n\n/*--------------\n      Sizes\n---------------*/\n\n/* Small */\n\n.ui.small.table {\n  font-size: 0.9em;\n}\n\n/* Standard */\n\n.ui.table {\n  font-size: 1em;\n}\n\n/* Large */\n\n.ui.large.table {\n  font-size: 1.1em;\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Ad\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Copyright 2013 Contributors\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n         Advertisement\n*******************************/\n\n.ui.ad {\n  display: block;\n  overflow: hidden;\n  margin: 1em 0em;\n}\n\n.ui.ad:first-child {\n  margin: 0em;\n}\n\n.ui.ad:last-child {\n  margin: 0em;\n}\n\n.ui.ad iframe {\n  margin: 0em;\n  padding: 0em;\n  border: none;\n  overflow: hidden;\n}\n\n/*--------------\n     Common\n---------------*/\n\n/* Leaderboard */\n\n.ui.leaderboard.ad {\n  width: 728px;\n  height: 90px;\n}\n\n/* Medium Rectangle */\n\n.ui[class*=\"medium rectangle\"].ad {\n  width: 300px;\n  height: 250px;\n}\n\n/* Large Rectangle */\n\n.ui[class*=\"large rectangle\"].ad {\n  width: 336px;\n  height: 280px;\n}\n\n/* Half Page */\n\n.ui[class*=\"half page\"].ad {\n  width: 300px;\n  height: 600px;\n}\n\n/*--------------\n     Square\n---------------*/\n\n/* Square */\n\n.ui.square.ad {\n  width: 250px;\n  height: 250px;\n}\n\n/* Small Square */\n\n.ui[class*=\"small square\"].ad {\n  width: 200px;\n  height: 200px;\n}\n\n/*--------------\n    Rectangle\n---------------*/\n\n/* Small Rectangle */\n\n.ui[class*=\"small rectangle\"].ad {\n  width: 180px;\n  height: 150px;\n}\n\n/* Vertical Rectangle */\n\n.ui[class*=\"vertical rectangle\"].ad {\n  width: 240px;\n  height: 400px;\n}\n\n/*--------------\n     Button\n---------------*/\n\n.ui.button.ad {\n  width: 120px;\n  height: 90px;\n}\n\n.ui[class*=\"square button\"].ad {\n  width: 125px;\n  height: 125px;\n}\n\n.ui[class*=\"small button\"].ad {\n  width: 120px;\n  height: 60px;\n}\n\n/*--------------\n   Skyscrapers\n---------------*/\n\n/* Skyscraper */\n\n.ui.skyscraper.ad {\n  width: 120px;\n  height: 600px;\n}\n\n/* Wide Skyscraper */\n\n.ui[class*=\"wide skyscraper\"].ad {\n  width: 160px;\n}\n\n/*--------------\n     Banners\n---------------*/\n\n/* Banner */\n\n.ui.banner.ad {\n  width: 468px;\n  height: 60px;\n}\n\n/* Vertical Banner */\n\n.ui[class*=\"vertical banner\"].ad {\n  width: 120px;\n  height: 240px;\n}\n\n/* Top Banner */\n\n.ui[class*=\"top banner\"].ad {\n  width: 930px;\n  height: 180px;\n}\n\n/* Half Banner */\n\n.ui[class*=\"half banner\"].ad {\n  width: 234px;\n  height: 60px;\n}\n\n/*--------------\n    Boards\n---------------*/\n\n/* Leaderboard */\n\n.ui[class*=\"large leaderboard\"].ad {\n  width: 970px;\n  height: 90px;\n}\n\n/* Billboard */\n\n.ui.billboard.ad {\n  width: 970px;\n  height: 250px;\n}\n\n/*--------------\n    Panorama\n---------------*/\n\n/* Panorama */\n\n.ui.panorama.ad {\n  width: 980px;\n  height: 120px;\n}\n\n/*--------------\n     Netboard\n---------------*/\n\n/* Netboard */\n\n.ui.netboard.ad {\n  width: 580px;\n  height: 400px;\n}\n\n/*--------------\n     Mobile\n---------------*/\n\n/* Large Mobile Banner */\n\n.ui[class*=\"large mobile banner\"].ad {\n  width: 320px;\n  height: 100px;\n}\n\n/* Mobile Leaderboard */\n\n.ui[class*=\"mobile leaderboard\"].ad {\n  width: 320px;\n  height: 50px;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/* Mobile Sizes */\n\n.ui.mobile.ad {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.mobile.ad {\n    display: block;\n  }\n}\n\n/*******************************\n           Variations\n*******************************/\n\n.ui.centered.ad {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ui.test.ad {\n  position: relative;\n  background: #545454;\n}\n\n.ui.test.ad:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  text-align: center;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  content: 'Ad';\n  color: #FFFFFF;\n  font-size: 1em;\n  font-weight: bold;\n}\n\n.ui.mobile.test.ad:after {\n  font-size: 0.85714286em;\n}\n\n.ui.test.ad[data-text]:after {\n  content: attr(data-text);\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Card\n---------------*/\n\n.ui.cards > .card, .ui.card {\n  max-width: 100%;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 290px;\n  min-height: 0px;\n  background: #FFFFFF;\n  padding: 0em;\n  border: none;\n  border-radius: 0px;\n  box-shadow: 0px 1px 3px 0px #DEDEDF, 0px 0px 0px 1px #DEDEDF;\n  transition: box-shadow 0.1s ease, -webkit-transform 0.1s ease;\n  transition: box-shadow 0.1s ease, transform 0.1s ease;\n  transition: box-shadow 0.1s ease, transform 0.1s ease, -webkit-transform 0.1s ease;\n  z-index: '';\n}\n\n.ui.card {\n  margin: 1em 0em;\n}\n\n.ui.cards > .card a, .ui.card a {\n  cursor: pointer;\n}\n\n.ui.card:first-child {\n  margin-top: 0em;\n}\n\n.ui.card:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Cards\n---------------*/\n\n.ui.cards {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: -0.875em -0.5em;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.ui.cards > .card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0.875em 0.5em;\n  float: none;\n}\n\n/* Clearing */\n\n.ui.cards:after, .ui.card:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n/* Consecutive Card Groups Preserve Row Spacing */\n\n.ui.cards ~ .ui.cards {\n  margin-top: 0.875em;\n}\n\n/*--------------\n  Rounded Edges\n---------------*/\n\n.ui.cards > .card > :first-child, .ui.card > :first-child {\n  border-radius: 0px 0px 0em 0em !important;\n  border-top: none !important;\n}\n\n.ui.cards > .card > :last-child, .ui.card > :last-child {\n  border-radius: 0em 0em 0px 0px !important;\n}\n\n.ui.cards > .card > :only-child, .ui.card > :only-child {\n  border-radius: 0px !important;\n}\n\n/*--------------\n     Images\n---------------*/\n\n.ui.cards > .card > .image, .ui.card > .image {\n  position: relative;\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  padding: 0em;\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.ui.cards > .card > .image > img, .ui.card > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: inherit;\n}\n\n.ui.cards > .card > .image:not(.ui) > img, .ui.card > .image:not(.ui) > img {\n  border: none;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.cards > .card > .content, .ui.card > .content {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  border: none;\n  border-top: 1px solid rgba(34, 36, 38, 0.1);\n  background: none;\n  margin: 0em;\n  padding: 1em 1em;\n  box-shadow: none;\n  font-size: 1em;\n  border-radius: 0em;\n}\n\n.ui.cards > .card > .content:after, .ui.card > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.cards > .card > .content > .header, .ui.card > .content > .header {\n  display: block;\n  margin: '';\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/* Default Header Size */\n\n.ui.cards > .card > .content > .header:not(.ui), .ui.card > .content > .header:not(.ui) {\n  font-weight: bold;\n  font-size: 1.28571429em;\n  margin-top: -0.21425em;\n  line-height: 1.28571429em;\n}\n\n.ui.cards > .card > .content > .meta + .description, .ui.cards > .card > .content > .header + .description, .ui.card > .content > .meta + .description, .ui.card > .content > .header + .description {\n  margin-top: 0.5em;\n}\n\n/*----------------\n Floated Content\n-----------------*/\n\n.ui.cards > .card [class*=\"left floated\"], .ui.card [class*=\"left floated\"] {\n  float: left;\n}\n\n.ui.cards > .card [class*=\"right floated\"], .ui.card [class*=\"right floated\"] {\n  float: right;\n}\n\n/*--------------\n     Aligned\n---------------*/\n\n.ui.cards > .card [class*=\"left aligned\"], .ui.card [class*=\"left aligned\"] {\n  text-align: left;\n}\n\n.ui.cards > .card [class*=\"center aligned\"], .ui.card [class*=\"center aligned\"] {\n  text-align: center;\n}\n\n.ui.cards > .card [class*=\"right aligned\"], .ui.card [class*=\"right aligned\"] {\n  text-align: right;\n}\n\n/*--------------\n  Content Image\n---------------*/\n\n.ui.cards > .card .content img, .ui.card .content img {\n  display: inline-block;\n  vertical-align: middle;\n  width: '';\n}\n\n.ui.cards > .card img.avatar, .ui.cards > .card .avatar img, .ui.card img.avatar, .ui.card .avatar img {\n  width: 2em;\n  height: 2em;\n  border-radius: 500rem;\n}\n\n/*--------------\n   Description\n---------------*/\n\n.ui.cards > .card > .content > .description, .ui.card > .content > .description {\n  clear: both;\n  color: rgba(0, 0, 0, 0.68);\n}\n\n/*--------------\n    Paragraph\n---------------*/\n\n.ui.cards > .card > .content p, .ui.card > .content p {\n  margin: 0em 0em 0.5em;\n}\n\n.ui.cards > .card > .content p:last-child, .ui.card > .content p:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.cards > .card .meta, .ui.card .meta {\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.cards > .card .meta *, .ui.card .meta * {\n  margin-right: 0.3em;\n}\n\n.ui.cards > .card .meta :last-child, .ui.card .meta :last-child {\n  margin-right: 0em;\n}\n\n.ui.cards > .card .meta [class*=\"right floated\"], .ui.card .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: 0.3em;\n}\n\n/*--------------\n      Links\n---------------*/\n\n/* Generic */\n\n.ui.cards > .card > .content a:not(.ui), .ui.card > .content a:not(.ui) {\n  color: '';\n  transition: color 0.1s ease;\n}\n\n.ui.cards > .card > .content a:not(.ui):hover, .ui.card > .content a:not(.ui):hover {\n  color: '';\n}\n\n/* Header */\n\n.ui.cards > .card > .content > a.header, .ui.card > .content > a.header {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.cards > .card > .content > a.header:hover, .ui.card > .content > a.header:hover {\n  color: #ff8127;\n}\n\n/* Meta */\n\n.ui.cards > .card .meta > a:not(.ui), .ui.card .meta > a:not(.ui) {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.cards > .card .meta > a:not(.ui):hover, .ui.card .meta > a:not(.ui):hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n     Buttons\n---------------*/\n\n.ui.cards > .card > .buttons, .ui.card > .buttons, .ui.cards > .card > .button, .ui.card > .button {\n  margin: 0px -1px;\n  width: calc(100% +  2px );\n}\n\n/*--------------\n      Dimmer\n---------------*/\n\n.ui.cards > .card .dimmer, .ui.card .dimmer {\n  background-color: '';\n  z-index: 10;\n}\n\n/*--------------\n     Labels\n---------------*/\n\n/*-----Star----- */\n\n/* Icon */\n\n.ui.cards > .card > .content .star.icon, .ui.card > .content .star.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n\n.ui.cards > .card > .content .star.icon:hover, .ui.card > .content .star.icon:hover {\n  opacity: 1;\n  color: #FFB70A;\n}\n\n.ui.cards > .card > .content .active.star.icon, .ui.card > .content .active.star.icon {\n  color: #FFE623;\n}\n\n/*-----Like----- */\n\n/* Icon */\n\n.ui.cards > .card > .content .like.icon, .ui.card > .content .like.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n\n.ui.cards > .card > .content .like.icon:hover, .ui.card > .content .like.icon:hover {\n  opacity: 1;\n  color: #FF2733;\n}\n\n.ui.cards > .card > .content .active.like.icon, .ui.card > .content .active.like.icon {\n  color: #FF2733;\n}\n\n/*----------------\n  Extra Content\n-----------------*/\n\n.ui.cards > .card > .extra, .ui.card > .extra {\n  max-width: 100%;\n  min-height: 0em !important;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;\n  position: static;\n  background: none;\n  width: auto;\n  margin: 0em 0em;\n  padding: 0.75em 1em;\n  top: 0em;\n  left: 0em;\n  color: rgba(0, 0, 0, 0.4);\n  box-shadow: none;\n  transition: color 0.1s ease;\n}\n\n.ui.cards > .card > .extra a:not(.ui), .ui.card > .extra a:not(.ui) {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.cards > .card > .extra a:not(.ui):hover, .ui.card > .extra a:not(.ui):hover {\n  color: #ff8127;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Raised\n--------------------*/\n\n.ui.raised.cards > .card, .ui.raised.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n\n.ui.raised.cards a.card:hover, .ui.link.cards .raised.card:hover, a.ui.raised.card:hover, .ui.link.raised.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 4px 0px rgba(34, 36, 38, 0.15), 0px 2px 10px 0px rgba(34, 36, 38, 0.25);\n}\n\n.ui.raised.cards > .card, .ui.raised.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n\n/*-------------------\n       Centered\n--------------------*/\n\n.ui.centered.cards {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.ui.centered.card {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*-------------------\n        Fluid\n--------------------*/\n\n.ui.fluid.card {\n  width: 100%;\n  max-width: 9999px;\n}\n\n/*-------------------\n        Link\n--------------------*/\n\n.ui.cards a.card, .ui.link.cards .card, a.ui.card, .ui.link.card {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.ui.cards a.card:hover, .ui.link.cards .card:hover, a.ui.card:hover, .ui.link.card:hover {\n  cursor: pointer;\n  z-index: 5;\n  background: #FFFFFF;\n  border: none;\n  box-shadow: 0px 1px 3px 0px #BCBDBD, 0px 0px 0px 1px #DEDEDF;\n  -webkit-transform: translateY(-3px);\n  transform: translateY(-3px);\n}\n\n/*-------------------\n       Colors\n--------------------*/\n\n/* Red */\n\n.ui.red.cards > .card, .ui.cards > .red.card, .ui.red.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #DB2828, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.red.cards > .card:hover, .ui.cards > .red.card:hover, .ui.red.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #d01919, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Orange */\n\n.ui.orange.cards > .card, .ui.cards > .orange.card, .ui.orange.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #FF9F5B, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.orange.cards > .card:hover, .ui.cards > .orange.card:hover, .ui.orange.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #ff9042, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Yellow */\n\n.ui.yellow.cards > .card, .ui.cards > .yellow.card, .ui.yellow.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #F9DC5C, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.yellow.cards > .card:hover, .ui.cards > .yellow.card:hover, .ui.yellow.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #ffdb3c, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Olive */\n\n.ui.olive.cards > .card, .ui.cards > .olive.card, .ui.olive.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #B5CC18, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.olive.cards > .card:hover, .ui.cards > .olive.card:hover, .ui.olive.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #a7bd0d, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Green */\n\n.ui.green.cards > .card, .ui.cards > .green.card, .ui.green.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #59D98D, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.green.cards > .card:hover, .ui.cards > .green.card:hover, .ui.green.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #3ddb7d, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Teal */\n\n.ui.teal.cards > .card, .ui.cards > .teal.card, .ui.teal.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #00B5AD, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.teal.cards > .card:hover, .ui.cards > .teal.card:hover, .ui.teal.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #009c95, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Blue */\n\n.ui.blue.cards > .card, .ui.cards > .blue.card, .ui.blue.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #2185D0, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.blue.cards > .card:hover, .ui.cards > .blue.card:hover, .ui.blue.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #1678c2, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Violet */\n\n.ui.violet.cards > .card, .ui.cards > .violet.card, .ui.violet.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #6435C9, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.violet.cards > .card:hover, .ui.cards > .violet.card:hover, .ui.violet.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #5829bb, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Purple */\n\n.ui.purple.cards > .card, .ui.cards > .purple.card, .ui.purple.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #A333C8, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.purple.cards > .card:hover, .ui.cards > .purple.card:hover, .ui.purple.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #9627ba, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Pink */\n\n.ui.pink.cards > .card, .ui.cards > .pink.card, .ui.pink.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #E03997, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.pink.cards > .card:hover, .ui.cards > .pink.card:hover, .ui.pink.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #e61a8d, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Brown */\n\n.ui.brown.cards > .card, .ui.cards > .brown.card, .ui.brown.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #A5673F, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.brown.cards > .card:hover, .ui.cards > .brown.card:hover, .ui.brown.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #975b33, 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Grey */\n\n.ui.grey.cards > .card, .ui.cards > .grey.card, .ui.grey.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px rgba(0, 0, 0, 0.4), 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.grey.cards > .card:hover, .ui.cards > .grey.card:hover, .ui.grey.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px rgba(13, 13, 13, 0.4), 0px 1px 3px 0px #BCBDBD;\n}\n\n/* Black */\n\n.ui.black.cards > .card, .ui.cards > .black.card, .ui.black.card {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #1B1C1D, 0px 1px 3px 0px #DEDEDF;\n}\n\n.ui.black.cards > .card:hover, .ui.cards > .black.card:hover, .ui.black.card:hover {\n  box-shadow: 0px 0px 0px 1px #DEDEDF, 0px 2px 0px 0px #27292a, 0px 1px 3px 0px #BCBDBD;\n}\n\n/*--------------\n   Card Count\n---------------*/\n\n.ui.one.cards {\n  margin-left: 0em;\n  margin-right: 0em;\n}\n\n.ui.one.cards > .card {\n  width: 100%;\n}\n\n.ui.two.cards {\n  margin-left: -1em;\n  margin-right: -1em;\n}\n\n.ui.two.cards > .card {\n  width: calc( 50%  -  2em );\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.ui.three.cards {\n  margin-left: -1em;\n  margin-right: -1em;\n}\n\n.ui.three.cards > .card {\n  width: calc( 33.33333333%  -  2em );\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.ui.four.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n\n.ui.four.cards > .card {\n  width: calc( 25%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n\n.ui.five.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n\n.ui.five.cards > .card {\n  width: calc( 20%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n\n.ui.six.cards {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n\n.ui.six.cards > .card {\n  width: calc( 16.66666667%  -  1.5em );\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n}\n\n.ui.seven.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n\n.ui.seven.cards > .card {\n  width: calc( 14.28571429%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n.ui.eight.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n\n.ui.eight.cards > .card {\n  width: calc( 12.5%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  font-size: 11px;\n}\n\n.ui.nine.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n\n.ui.nine.cards > .card {\n  width: calc( 11.11111111%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  font-size: 10px;\n}\n\n.ui.ten.cards {\n  margin-left: -0.5em;\n  margin-right: -0.5em;\n}\n\n.ui.ten.cards > .card {\n  width: calc( 10%  -  1em );\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n/*-------------------\n      Doubling\n--------------------*/\n\n/* Mobile Only */\n\n@media only screen and (max-width: 767px) {\n  .ui.two.doubling.cards {\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n\n  .ui.two.doubling.cards > .card {\n    width: 100%;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n\n  .ui.three.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.three.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.four.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.four.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.five.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.five.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.six.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.six.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.seven.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.seven.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.eight.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.eight.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.nine.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.nine.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.ten.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.ten.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n}\n\n/* Tablet Only */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.two.doubling.cards {\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n\n  .ui.two.doubling.cards > .card {\n    width: 100%;\n    margin-left: 0em;\n    margin-right: 0em;\n  }\n\n  .ui.three.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.three.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.four.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.four.doubling.cards > .card {\n    width: calc( 50%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.five.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.five.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.six.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.six.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.eight.doubling.cards {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  .ui.eight.doubling.cards > .card {\n    width: calc( 33.33333333%  -  2em );\n    margin-left: 1em;\n    margin-right: 1em;\n  }\n\n  .ui.eight.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n\n  .ui.eight.doubling.cards > .card {\n    width: calc( 25%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n\n  .ui.nine.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n\n  .ui.nine.doubling.cards > .card {\n    width: calc( 25%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n\n  .ui.ten.doubling.cards {\n    margin-left: -0.75em;\n    margin-right: -0.75em;\n  }\n\n  .ui.ten.doubling.cards > .card {\n    width: calc( 20%  -  1.5em );\n    margin-left: 0.75em;\n    margin-right: 0.75em;\n  }\n}\n\n/*-------------------\n      Stackable\n--------------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.stackable.cards {\n    display: block !important;\n  }\n\n  .ui.stackable.cards .card:first-child {\n    margin-top: 0em !important;\n  }\n\n  .ui.stackable.cards > .card {\n    display: block !important;\n    height: auto !important;\n    margin: 1em 1em;\n    padding: 0 !important;\n    width: calc( 100%  -  2em ) !important;\n  }\n}\n\n/*--------------\n      Size\n---------------*/\n\n.ui.cards > .card {\n  font-size: 1em;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Comment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n    Comments\n---------------*/\n\n.ui.comments {\n  margin: 1.5em 0em;\n  max-width: 650px;\n}\n\n.ui.comments:first-child {\n  margin-top: 0em;\n}\n\n.ui.comments:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Comment\n---------------*/\n\n.ui.comments .comment {\n  position: relative;\n  background: none;\n  margin: 0.5em 0em 0em;\n  padding: 0.5em 0em 0em;\n  border: none;\n  border-top: none;\n  line-height: 1.2;\n}\n\n.ui.comments .comment:first-child {\n  margin-top: 0em;\n  padding-top: 0em;\n}\n\n/*--------------------\n    Nested Comments\n---------------------*/\n\n.ui.comments .comment .comments {\n  margin: 0em 0em 0.5em 0.5em;\n  padding: 1em 0em 1em 1em;\n}\n\n.ui.comments .comment .comments:before {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n}\n\n.ui.comments .comment .comments .comment {\n  border: none;\n  border-top: none;\n  background: none;\n}\n\n/*--------------\n     Avatar\n---------------*/\n\n.ui.comments .comment .avatar {\n  display: block;\n  width: 2.5em;\n  height: auto;\n  float: left;\n  margin: 0.2em 0em 0em;\n}\n\n.ui.comments .comment img.avatar, .ui.comments .comment .avatar img {\n  display: block;\n  margin: 0em auto;\n  width: 100%;\n  height: 100%;\n  border-radius: 0.25rem;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.comments .comment > .content {\n  display: block;\n}\n\n/* If there is an avatar move content over */\n\n.ui.comments .comment > .avatar ~ .content {\n  margin-left: 3.5em;\n}\n\n/*--------------\n     Author\n---------------*/\n\n.ui.comments .comment .author {\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.8);\n  font-weight: bold;\n}\n\n.ui.comments .comment a.author {\n  cursor: pointer;\n}\n\n.ui.comments .comment a.author:hover {\n  color: #ff8127;\n}\n\n/*--------------\n     Metadata\n---------------*/\n\n.ui.comments .comment .metadata {\n  display: inline-block;\n  margin-left: 0.5em;\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 0.875em;\n}\n\n.ui.comments .comment .metadata > * {\n  display: inline-block;\n  margin: 0em 0.5em 0em 0em;\n}\n\n.ui.comments .comment .metadata > :last-child {\n  margin-right: 0em;\n}\n\n/*--------------------\n     Comment Text\n---------------------*/\n\n.ui.comments .comment .text {\n  margin: 0.25em 0em 0.5em;\n  font-size: 1em;\n  word-wrap: break-word;\n  color: rgba(0, 0, 0, 0.8);\n  line-height: 1.3;\n}\n\n/*--------------------\n     User Actions\n---------------------*/\n\n.ui.comments .comment .actions {\n  font-size: 0.875em;\n}\n\n.ui.comments .comment .actions a {\n  cursor: pointer;\n  display: inline-block;\n  margin: 0em 0.75em 0em 0em;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.comments .comment .actions a:last-child {\n  margin-right: 0em;\n}\n\n.ui.comments .comment .actions a.active, .ui.comments .comment .actions a:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------------\n      Reply Form\n---------------------*/\n\n.ui.comments > .reply.form {\n  margin-top: 1em;\n}\n\n.ui.comments .comment .reply.form {\n  width: 100%;\n  margin-top: 1em;\n}\n\n.ui.comments .reply.form textarea {\n  font-size: 1em;\n  height: 12em;\n}\n\n/*******************************\n            State\n*******************************/\n\n.ui.collapsed.comments, .ui.comments .collapsed.comments, .ui.comments .collapsed.comment {\n  display: none;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------------\n        Threaded\n---------------------*/\n\n.ui.threaded.comments .comment .comments {\n  margin: -1.5em 0 -1em 1.25em;\n  padding: 3em 0em 2em 2.25em;\n  box-shadow: -1px 0px 0px #DEDEDF;\n}\n\n/*--------------------\n        Minimal\n---------------------*/\n\n.ui.minimal.comments .comment .actions {\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  left: auto;\n  transition: opacity 0.2s ease;\n  transition-delay: 0.1s;\n}\n\n.ui.minimal.comments .comment > .content:hover > .actions {\n  opacity: 1;\n}\n\n/*-------------------\n        Sizes\n--------------------*/\n\n.ui.mini.comments {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.comments {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.comments {\n  font-size: 0.92857143rem;\n}\n\n.ui.comments {\n  font-size: 1rem;\n}\n\n.ui.large.comments {\n  font-size: 1.14285714rem;\n}\n\n.ui.big.comments {\n  font-size: 1.28571429rem;\n}\n\n.ui.huge.comments {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.comments {\n  font-size: 1.71428571rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Feed\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n         Activity Feed\n*******************************/\n\n.ui.feed {\n  margin: 1em 0em;\n}\n\n.ui.feed:first-child {\n  margin-top: 0em;\n}\n\n.ui.feed:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* Event */\n\n.ui.feed > .event {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  width: 100%;\n  padding: 0.21428571rem 0em;\n  margin: 0em;\n  background: none;\n  border-top: none;\n}\n\n.ui.feed > .event:first-child {\n  border-top: 0px;\n  padding-top: 0em;\n}\n\n.ui.feed > .event:last-child {\n  padding-bottom: 0em;\n}\n\n/* Event Label */\n\n.ui.feed > .event > .label {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 2.5em;\n  height: auto;\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n  text-align: left;\n}\n\n.ui.feed > .event > .label .icon {\n  opacity: 1;\n  font-size: 1.5em;\n  width: 100%;\n  padding: 0.25em;\n  background: none;\n  border: none;\n  border-radius: none;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.feed > .event > .label img {\n  width: 100%;\n  height: auto;\n  border-radius: 500rem;\n}\n\n.ui.feed > .event > .label + .content {\n  margin: 0.5em 0em 0.35714286em 1.14285714em;\n}\n\n/*--------------\n     Content\n---------------*/\n\n/* Content */\n\n.ui.feed > .event > .content {\n  display: block;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.ui.feed > .event:last-child > .content {\n  padding-bottom: 0em;\n}\n\n/* Link */\n\n.ui.feed > .event > .content a {\n  cursor: pointer;\n}\n\n/*--------------\n      Date\n---------------*/\n\n.ui.feed > .event > .content .date {\n  margin: -0.5rem 0em 0em;\n  padding: 0em;\n  font-weight: normal;\n  font-size: 1em;\n  font-style: normal;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*--------------\n     Summary\n---------------*/\n\n.ui.feed > .event > .content .summary {\n  margin: 0em;\n  font-size: 1em;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Summary Image */\n\n.ui.feed > .event > .content .summary img {\n  display: inline-block;\n  width: auto;\n  height: 10em;\n  margin: -0.25em 0.25em 0em 0em;\n  border-radius: 0.25em;\n  vertical-align: middle;\n}\n\n/*--------------\n      User\n---------------*/\n\n.ui.feed > .event > .content .user {\n  display: inline-block;\n  font-weight: bold;\n  margin-right: 0em;\n  vertical-align: baseline;\n}\n\n.ui.feed > .event > .content .user img {\n  margin: -0.25em 0.25em 0em 0em;\n  width: auto;\n  height: 10em;\n  vertical-align: middle;\n}\n\n/*--------------\n   Inline Date\n---------------*/\n\n/* Date inside Summary */\n\n.ui.feed > .event > .content .summary > .date {\n  display: inline-block;\n  float: none;\n  font-weight: normal;\n  font-size: 0.85714286em;\n  font-style: normal;\n  margin: 0em 0em 0em 0.5em;\n  padding: 0em;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*--------------\n  Extra Summary\n---------------*/\n\n.ui.feed > .event > .content .extra {\n  margin: 0.5em 0em 0em;\n  background: none;\n  padding: 0em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Images */\n\n.ui.feed > .event > .content .extra.images img {\n  display: inline-block;\n  margin: 0em 0.25em 0em 0em;\n  width: 6em;\n}\n\n/* Text */\n\n.ui.feed > .event > .content .extra.text {\n  padding: 0em;\n  border-left: none;\n  font-size: 1em;\n  max-width: 500px;\n  line-height: 1.4285em;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.feed > .event > .content .meta {\n  display: inline-block;\n  font-size: 0.85714286em;\n  margin: 0.5em 0em 0em;\n  background: none;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0em;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.feed > .event > .content .meta > * {\n  position: relative;\n  margin-left: 0.75em;\n}\n\n.ui.feed > .event > .content .meta > *:after {\n  content: '';\n  color: rgba(0, 0, 0, 0.2);\n  top: 0em;\n  left: -1em;\n  opacity: 1;\n  position: absolute;\n  vertical-align: top;\n}\n\n.ui.feed > .event > .content .meta .like {\n  color: '';\n  transition: 0.2s color ease;\n}\n\n.ui.feed > .event > .content .meta .like:hover .icon {\n  color: #FF2733;\n}\n\n.ui.feed > .event > .content .meta .active.like .icon {\n  color: #EF404A;\n}\n\n/* First element */\n\n.ui.feed > .event > .content .meta > :first-child {\n  margin-left: 0em;\n}\n\n.ui.feed > .event > .content .meta > :first-child::after {\n  display: none;\n}\n\n/* Action */\n\n.ui.feed > .event > .content .meta a, .ui.feed > .event > .content .meta > .icon {\n  cursor: pointer;\n  opacity: 1;\n  color: rgba(0, 0, 0, 0.5);\n  transition: color 0.1s ease;\n}\n\n.ui.feed > .event > .content .meta a:hover, .ui.feed > .event > .content .meta a:hover .icon, .ui.feed > .event > .content .meta > .icon:hover {\n  color: #59D98D;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n.ui.small.feed {\n  font-size: 0.92857143rem;\n}\n\n.ui.feed {\n  font-size: 1rem;\n}\n\n.ui.large.feed {\n  font-size: 1.14285714rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Item\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Standard\n*******************************/\n\n/*--------------\n      Item\n---------------*/\n\n.ui.items > .item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 1em 0em;\n  width: 100%;\n  min-height: 0px;\n  background: transparent;\n  padding: 0em;\n  border: none;\n  border-radius: 0rem;\n  box-shadow: none;\n  transition: box-shadow 0.1s ease;\n  z-index: '';\n}\n\n.ui.items > .item a {\n  cursor: pointer;\n}\n\n/*--------------\n      Items\n---------------*/\n\n.ui.items {\n  margin: 1.5em 0em;\n}\n\n.ui.items:first-child {\n  margin-top: 0em !important;\n}\n\n.ui.items:last-child {\n  margin-bottom: 0em !important;\n}\n\n/*--------------\n      Item\n---------------*/\n\n.ui.items > .item:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.items > .item:first-child {\n  margin-top: 0em;\n}\n\n.ui.items > .item:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Images\n---------------*/\n\n.ui.items > .item > .image {\n  position: relative;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  display: block;\n  float: none;\n  margin: 0em;\n  padding: 0em;\n  max-height: '';\n  -ms-flex-item-align: top;\n  -ms-grid-row-align: top;\n  align-self: top;\n}\n\n.ui.items > .item > .image > img {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 0.125rem;\n  border: none;\n}\n\n.ui.items > .item > .image:only-child > img {\n  border-radius: 0rem;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.items > .item > .content {\n  display: block;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  background: none;\n  margin: 0em;\n  padding: 0em;\n  box-shadow: none;\n  font-size: 1em;\n  border: none;\n  border-radius: 0em;\n}\n\n.ui.items > .item > .content:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.items > .item > .image + .content {\n  min-width: 0;\n  width: auto;\n  display: block;\n  margin-left: 0em;\n  -ms-flex-item-align: top;\n  -ms-grid-row-align: top;\n  align-self: top;\n  padding-left: 1.5em;\n}\n\n.ui.items > .item > .content > .header {\n  display: inline-block;\n  margin: -0.21425em 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/* Default Header Size */\n\n.ui.items > .item > .content > .header:not(.ui) {\n  font-size: 1.28571429em;\n}\n\n/*--------------\n     Floated\n---------------*/\n\n.ui.items > .item [class*=\"left floated\"] {\n  float: left;\n}\n\n.ui.items > .item [class*=\"right floated\"] {\n  float: right;\n}\n\n/*--------------\n  Content Image\n---------------*/\n\n.ui.items > .item .content img {\n  -ms-flex-item-align: middle;\n  -ms-grid-row-align: middle;\n  align-self: middle;\n  width: '';\n}\n\n.ui.items > .item img.avatar, .ui.items > .item .avatar img {\n  width: '';\n  height: '';\n  border-radius: 500rem;\n}\n\n/*--------------\n   Description\n---------------*/\n\n.ui.items > .item > .content > .description {\n  margin-top: 0.6em;\n  max-width: auto;\n  font-size: 1em;\n  line-height: 1.4285em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n    Paragraph\n---------------*/\n\n.ui.items > .item > .content p {\n  margin: 0em 0em 0.5em;\n}\n\n.ui.items > .item > .content p:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n      Meta\n---------------*/\n\n.ui.items > .item .meta {\n  margin: 0.5em 0em 0.5em;\n  font-size: 1em;\n  line-height: 1em;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.ui.items > .item .meta * {\n  margin-right: 0.3em;\n}\n\n.ui.items > .item .meta :last-child {\n  margin-right: 0em;\n}\n\n.ui.items > .item .meta [class*=\"right floated\"] {\n  margin-right: 0em;\n  margin-left: 0.3em;\n}\n\n/*--------------\n      Links\n---------------*/\n\n/* Generic */\n\n.ui.items > .item > .content a:not(.ui) {\n  color: '';\n  transition: color 0.1s ease;\n}\n\n.ui.items > .item > .content a:not(.ui):hover {\n  color: '';\n}\n\n/* Header */\n\n.ui.items > .item > .content > a.header {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.items > .item > .content > a.header:hover {\n  color: #ff8127;\n}\n\n/* Meta */\n\n.ui.items > .item .meta > a:not(.ui) {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.items > .item .meta > a:not(.ui):hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n     Labels\n---------------*/\n\n/*-----Star----- */\n\n/* Icon */\n\n.ui.items > .item > .content .favorite.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n\n.ui.items > .item > .content .favorite.icon:hover {\n  opacity: 1;\n  color: #FFB70A;\n}\n\n.ui.items > .item > .content .active.favorite.icon {\n  color: #FFE623;\n}\n\n/*-----Like----- */\n\n/* Icon */\n\n.ui.items > .item > .content .like.icon {\n  cursor: pointer;\n  opacity: 0.75;\n  transition: color 0.1s ease;\n}\n\n.ui.items > .item > .content .like.icon:hover {\n  opacity: 1;\n  color: #FF2733;\n}\n\n.ui.items > .item > .content .active.like.icon {\n  color: #FF2733;\n}\n\n/*----------------\n  Extra Content\n-----------------*/\n\n.ui.items > .item .extra {\n  display: block;\n  position: relative;\n  background: none;\n  margin: 0.5rem 0em 0em;\n  width: 100%;\n  padding: 0em 0em 0em;\n  top: 0em;\n  left: 0em;\n  color: rgba(0, 0, 0, 0.4);\n  box-shadow: none;\n  transition: color 0.1s ease;\n  border-top: none;\n}\n\n.ui.items > .item .extra > * {\n  margin: 0.25rem 0.5rem 0.25rem 0em;\n}\n\n.ui.items > .item .extra > [class*=\"right floated\"] {\n  margin: 0.25rem 0em 0.25rem 0.5rem;\n}\n\n.ui.items > .item .extra:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n/*******************************\n          Responsive\n*******************************/\n\n/* Default Image Width */\n\n.ui.items > .item > .image:not(.ui) {\n  width: 175px;\n}\n\n/* Tablet Only */\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ui.items > .item {\n    margin: 1em 0em;\n  }\n\n  .ui.items > .item > .image:not(.ui) {\n    width: 150px;\n  }\n\n  .ui.items > .item > .image + .content {\n    display: block;\n    padding: 0em 0em 0em 1em;\n  }\n}\n\n/* Mobile Only */\n\n@media only screen and (max-width: 767px) {\n  .ui.items:not(.unstackable) > .item {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin: 2em 0em;\n  }\n\n  .ui.items:not(.unstackable) > .item > .image {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .ui.items:not(.unstackable) > .item > .image, .ui.items:not(.unstackable) > .item > .image > img {\n    max-width: 100% !important;\n    width: auto !important;\n    max-height: 250px !important;\n  }\n\n  .ui.items:not(.unstackable) > .item > .image + .content {\n    display: block;\n    padding: 1.5em 0em 0em;\n  }\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n       Aligned\n--------------------*/\n\n.ui.items > .item > .image + [class*=\"top aligned\"].content {\n  -ms-flex-item-align: start;\n  align-self: flex-start;\n}\n\n.ui.items > .item > .image + [class*=\"middle aligned\"].content {\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n  align-self: center;\n}\n\n.ui.items > .item > .image + [class*=\"bottom aligned\"].content {\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n}\n\n/*--------------\n     Relaxed\n---------------*/\n\n.ui.relaxed.items > .item {\n  margin: 1.5em 0em;\n}\n\n.ui[class*=\"very relaxed\"].items > .item {\n  margin: 2em 0em;\n}\n\n/*-------------------\n      Divided\n--------------------*/\n\n.ui.divided.items > .item {\n  border-top: 1px solid #DEDEDF;\n  margin: 0em;\n  padding: 1em 0em;\n}\n\n.ui.divided.items > .item:first-child {\n  border-top: none;\n  margin-top: 0em !important;\n  padding-top: 0em !important;\n}\n\n.ui.divided.items > .item:last-child {\n  margin-bottom: 0em !important;\n  padding-bottom: 0em !important;\n}\n\n/* Relaxed Divided */\n\n.ui.relaxed.divided.items > .item {\n  margin: 0em;\n  padding: 1.5em 0em;\n}\n\n.ui[class*=\"very relaxed\"].divided.items > .item {\n  margin: 0em;\n  padding: 2em 0em;\n}\n\n/*-------------------\n        Link\n--------------------*/\n\n.ui.items a.item:hover, .ui.link.items > .item:hover {\n  cursor: pointer;\n}\n\n.ui.items a.item:hover .content .header, .ui.link.items > .item:hover .content .header {\n  color: #ff8127;\n}\n\n/*--------------\n      Size\n---------------*/\n\n.ui.items > .item {\n  font-size: 1em;\n}\n\n/*---------------\n   Unstackable\n----------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.unstackable.items > .item > .image, .ui.unstackable.items > .item > .image > img {\n    width: 125px !important;\n  }\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Statistic\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           Statistic\n*******************************/\n\n/* Standalone */\n\n.ui.statistic {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 1em 0em;\n  max-width: auto;\n}\n\n.ui.statistic + .ui.statistic {\n  margin: 0em 0em 0em 1.5em;\n}\n\n.ui.statistic:first-child {\n  margin-top: 0em;\n}\n\n.ui.statistic:last-child {\n  margin-bottom: 0em;\n}\n\n/*******************************\n            Group\n*******************************/\n\n/* Grouped */\n\n.ui.statistics {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.ui.statistics > .statistic {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 0em 1.5em 1em;\n  max-width: auto;\n}\n\n.ui.statistics {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 1em -1.5em -1em;\n}\n\n/* Clearing */\n\n.ui.statistics:after {\n  display: block;\n  content: ' ';\n  height: 0px;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.ui.statistics:first-child {\n  margin-top: 0em;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/*--------------\n      Value\n---------------*/\n\n.ui.statistics .statistic > .value, .ui.statistic > .value {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 4rem;\n  font-weight: normal;\n  line-height: 1em;\n  color: #1B1C1D;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/*--------------\n     Label\n---------------*/\n\n.ui.statistics .statistic > .label, .ui.statistic > .label {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/* Top Label */\n\n.ui.statistics .statistic > .label ~ .value, .ui.statistic > .label ~ .value {\n  margin-top: 0rem;\n}\n\n/* Bottom Label */\n\n.ui.statistics .statistic > .value ~ .label, .ui.statistic > .value ~ .label {\n  margin-top: 0rem;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n   Icon Value\n---------------*/\n\n.ui.statistics .statistic > .value .icon, .ui.statistic > .value .icon {\n  opacity: 1;\n  width: auto;\n  margin: 0em;\n}\n\n/*--------------\n   Text Value\n---------------*/\n\n.ui.statistics .statistic > .text.value, .ui.statistic > .text.value {\n  line-height: 1em;\n  min-height: 2em;\n  font-weight: bold;\n  text-align: center;\n}\n\n.ui.statistics .statistic > .text.value + .label, .ui.statistic > .text.value + .label {\n  text-align: center;\n}\n\n/*--------------\n   Image Value\n---------------*/\n\n.ui.statistics .statistic > .value img, .ui.statistic > .value img {\n  max-height: 3rem;\n  vertical-align: baseline;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n      Count\n---------------*/\n\n.ui.ten.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.ten.statistics .statistic {\n  min-width: 10%;\n  margin: 0em 0em 1em;\n}\n\n.ui.nine.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.nine.statistics .statistic {\n  min-width: 11.11111111%;\n  margin: 0em 0em 1em;\n}\n\n.ui.eight.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.eight.statistics .statistic {\n  min-width: 12.5%;\n  margin: 0em 0em 1em;\n}\n\n.ui.seven.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.seven.statistics .statistic {\n  min-width: 14.28571429%;\n  margin: 0em 0em 1em;\n}\n\n.ui.six.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.six.statistics .statistic {\n  min-width: 16.66666667%;\n  margin: 0em 0em 1em;\n}\n\n.ui.five.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.five.statistics .statistic {\n  min-width: 20%;\n  margin: 0em 0em 1em;\n}\n\n.ui.four.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.four.statistics .statistic {\n  min-width: 25%;\n  margin: 0em 0em 1em;\n}\n\n.ui.three.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.three.statistics .statistic {\n  min-width: 33.33333333%;\n  margin: 0em 0em 1em;\n}\n\n.ui.two.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.two.statistics .statistic {\n  min-width: 50%;\n  margin: 0em 0em 1em;\n}\n\n.ui.one.statistics {\n  margin: 0em 0em -1em;\n}\n\n.ui.one.statistics .statistic {\n  min-width: 100%;\n  margin: 0em 0em 1em;\n}\n\n/*--------------\n   Horizontal\n---------------*/\n\n.ui.horizontal.statistic {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ui.horizontal.statistics {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin: 0em;\n  max-width: none;\n}\n\n.ui.horizontal.statistics .statistic {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  max-width: none;\n  margin: 1em 0em;\n}\n\n.ui.horizontal.statistic > .text.value, .ui.horizontal.statistics > .statistic > .text.value {\n  min-height: 0em !important;\n}\n\n.ui.horizontal.statistics .statistic > .value .icon, .ui.horizontal.statistic > .value .icon {\n  width: 1.18em;\n}\n\n.ui.horizontal.statistics .statistic > .value, .ui.horizontal.statistic > .value {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ui.horizontal.statistics .statistic > .label, .ui.horizontal.statistic > .label {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0em 0em 0em 0.75em;\n}\n\n/*--------------\n     Colors\n---------------*/\n\n.ui.red.statistics .statistic > .value, .ui.statistics .red.statistic > .value, .ui.red.statistic > .value {\n  color: #DB2828;\n}\n\n.ui.orange.statistics .statistic > .value, .ui.statistics .orange.statistic > .value, .ui.orange.statistic > .value {\n  color: #FF9F5B;\n}\n\n.ui.yellow.statistics .statistic > .value, .ui.statistics .yellow.statistic > .value, .ui.yellow.statistic > .value {\n  color: #F9DC5C;\n}\n\n.ui.olive.statistics .statistic > .value, .ui.statistics .olive.statistic > .value, .ui.olive.statistic > .value {\n  color: #B5CC18;\n}\n\n.ui.green.statistics .statistic > .value, .ui.statistics .green.statistic > .value, .ui.green.statistic > .value {\n  color: #59D98D;\n}\n\n.ui.teal.statistics .statistic > .value, .ui.statistics .teal.statistic > .value, .ui.teal.statistic > .value {\n  color: #00B5AD;\n}\n\n.ui.blue.statistics .statistic > .value, .ui.statistics .blue.statistic > .value, .ui.blue.statistic > .value {\n  color: #2185D0;\n}\n\n.ui.violet.statistics .statistic > .value, .ui.statistics .violet.statistic > .value, .ui.violet.statistic > .value {\n  color: #6435C9;\n}\n\n.ui.purple.statistics .statistic > .value, .ui.statistics .purple.statistic > .value, .ui.purple.statistic > .value {\n  color: #A333C8;\n}\n\n.ui.pink.statistics .statistic > .value, .ui.statistics .pink.statistic > .value, .ui.pink.statistic > .value {\n  color: #E03997;\n}\n\n.ui.brown.statistics .statistic > .value, .ui.statistics .brown.statistic > .value, .ui.brown.statistic > .value {\n  color: #A5673F;\n}\n\n.ui.grey.statistics .statistic > .value, .ui.statistics .grey.statistic > .value, .ui.grey.statistic > .value {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.statistics .statistic > .value, .ui.inverted.statistic .value {\n  color: #FFFFFF;\n}\n\n.ui.inverted.statistics .statistic > .label, .ui.inverted.statistic .label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ui.inverted.red.statistics .statistic > .value, .ui.statistics .inverted.red.statistic > .value, .ui.inverted.red.statistic > .value {\n  color: #FF695E;\n}\n\n.ui.inverted.orange.statistics .statistic > .value, .ui.statistics .inverted.orange.statistic > .value, .ui.inverted.orange.statistic > .value {\n  color: #FF851B;\n}\n\n.ui.inverted.yellow.statistics .statistic > .value, .ui.statistics .inverted.yellow.statistic > .value, .ui.inverted.yellow.statistic > .value {\n  color: #FFE21F;\n}\n\n.ui.inverted.olive.statistics .statistic > .value, .ui.statistics .inverted.olive.statistic > .value, .ui.inverted.olive.statistic > .value {\n  color: #D9E778;\n}\n\n.ui.inverted.green.statistics .statistic > .value, .ui.statistics .inverted.green.statistic > .value, .ui.inverted.green.statistic > .value {\n  color: #2ECC40;\n}\n\n.ui.inverted.teal.statistics .statistic > .value, .ui.statistics .inverted.teal.statistic > .value, .ui.inverted.teal.statistic > .value {\n  color: #6DFFFF;\n}\n\n.ui.inverted.blue.statistics .statistic > .value, .ui.statistics .inverted.blue.statistic > .value, .ui.inverted.blue.statistic > .value {\n  color: #54C8FF;\n}\n\n.ui.inverted.violet.statistics .statistic > .value, .ui.statistics .inverted.violet.statistic > .value, .ui.inverted.violet.statistic > .value {\n  color: #A291FB;\n}\n\n.ui.inverted.purple.statistics .statistic > .value, .ui.statistics .inverted.purple.statistic > .value, .ui.inverted.purple.statistic > .value {\n  color: #DC73FF;\n}\n\n.ui.inverted.pink.statistics .statistic > .value, .ui.statistics .inverted.pink.statistic > .value, .ui.inverted.pink.statistic > .value {\n  color: #FF8EDF;\n}\n\n.ui.inverted.brown.statistics .statistic > .value, .ui.statistics .inverted.brown.statistic > .value, .ui.inverted.brown.statistic > .value {\n  color: #D67C1C;\n}\n\n.ui.inverted.grey.statistics .statistic > .value, .ui.statistics .inverted.grey.statistic > .value, .ui.inverted.grey.statistic > .value {\n  color: #DEDEDF;\n}\n\n/*--------------\n    Floated\n---------------*/\n\n.ui[class*=\"left floated\"].statistic {\n  float: left;\n  margin: 0em 2em 1em 0em;\n}\n\n.ui[class*=\"right floated\"].statistic {\n  float: right;\n  margin: 0em 0em 1em 2em;\n}\n\n.ui.floated.statistic:last-child {\n  margin-bottom: 0em;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n/* Mini */\n\n.ui.mini.statistics .statistic > .value, .ui.mini.statistic > .value {\n  font-size: 1.5rem !important;\n}\n\n.ui.mini.horizontal.statistics .statistic > .value, .ui.mini.horizontal.statistic > .value {\n  font-size: 1.5rem !important;\n}\n\n.ui.mini.statistics .statistic > .text.value, .ui.mini.statistic > .text.value {\n  font-size: 1rem !important;\n}\n\n/* Tiny */\n\n.ui.tiny.statistics .statistic > .value, .ui.tiny.statistic > .value {\n  font-size: 2rem !important;\n}\n\n.ui.tiny.horizontal.statistics .statistic > .value, .ui.tiny.horizontal.statistic > .value {\n  font-size: 2rem !important;\n}\n\n.ui.tiny.statistics .statistic > .text.value, .ui.tiny.statistic > .text.value {\n  font-size: 1rem !important;\n}\n\n/* Small */\n\n.ui.small.statistics .statistic > .value, .ui.small.statistic > .value {\n  font-size: 3rem !important;\n}\n\n.ui.small.horizontal.statistics .statistic > .value, .ui.small.horizontal.statistic > .value {\n  font-size: 2rem !important;\n}\n\n.ui.small.statistics .statistic > .text.value, .ui.small.statistic > .text.value {\n  font-size: 1rem !important;\n}\n\n/* Medium */\n\n.ui.statistics .statistic > .value, .ui.statistic > .value {\n  font-size: 4rem !important;\n}\n\n.ui.horizontal.statistics .statistic > .value, .ui.horizontal.statistic > .value {\n  font-size: 3rem !important;\n}\n\n.ui.statistics .statistic > .text.value, .ui.statistic > .text.value {\n  font-size: 2rem !important;\n}\n\n/* Large */\n\n.ui.large.statistics .statistic > .value, .ui.large.statistic > .value {\n  font-size: 5rem !important;\n}\n\n.ui.large.horizontal.statistics .statistic > .value, .ui.large.horizontal.statistic > .value {\n  font-size: 4rem !important;\n}\n\n.ui.large.statistics .statistic > .text.value, .ui.large.statistic > .text.value {\n  font-size: 2.5rem !important;\n}\n\n/* Huge */\n\n.ui.huge.statistics .statistic > .value, .ui.huge.statistic > .value {\n  font-size: 6rem !important;\n}\n\n.ui.huge.horizontal.statistics .statistic > .value, .ui.huge.horizontal.statistic > .value {\n  font-size: 5rem !important;\n}\n\n.ui.huge.statistics .statistic > .text.value, .ui.huge.statistic > .text.value {\n  font-size: 2.5rem !important;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n    User Variable Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Accordion\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Accordion\n*******************************/\n\n.ui.accordion, .ui.accordion .accordion {\n  max-width: 100%;\n}\n\n.ui.accordion .accordion {\n  margin: 1em 0em 0em;\n  padding: 0em;\n}\n\n/* Title */\n\n.ui.accordion .title, .ui.accordion .accordion .title {\n  cursor: pointer;\n}\n\n/* Default Styling */\n\n.ui.accordion .title:not(.ui) {\n  padding: 0.5em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Content */\n\n.ui.accordion .title ~ .content, .ui.accordion .accordion .title ~ .content {\n  display: none;\n}\n\n/* Default Styling */\n\n.ui.accordion:not(.styled) .title ~ .content:not(.ui), .ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {\n  margin: '';\n  padding: 0.5em 0em 1em;\n}\n\n.ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {\n  padding-bottom: 0em;\n}\n\n/* Arrow */\n\n.ui.accordion .title .dropdown.icon, .ui.accordion .accordion .title .dropdown.icon {\n  display: inline-block;\n  float: none;\n  opacity: 1;\n  width: 1.25em;\n  height: 1em;\n  margin: 0em 0.25rem 0em 0rem;\n  padding: 0em;\n  font-size: 1em;\n  transition: opacity 0.1s ease, -webkit-transform 0.1s ease;\n  transition: transform 0.1s ease, opacity 0.1s ease;\n  transition: transform 0.1s ease, opacity 0.1s ease, -webkit-transform 0.1s ease;\n  vertical-align: baseline;\n  -webkit-transform: none;\n  transform: none;\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n/* Menu */\n\n.ui.accordion.menu .item .title {\n  display: block;\n  padding: 0em;\n}\n\n.ui.accordion.menu .item .title > .dropdown.icon {\n  float: right;\n  margin: 0.21425em 0em 0em 1em;\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n/* Header */\n\n.ui.accordion .ui.header .dropdown.icon {\n  font-size: 1em;\n  margin: 0em 0.25rem 0em 0rem;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.accordion .active.title .dropdown.icon, .ui.accordion .accordion .active.title .dropdown.icon {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.ui.accordion.menu .item .active.title > .dropdown.icon {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n     Styled\n---------------*/\n\n.ui.styled.accordion {\n  width: 600px;\n}\n\n.ui.styled.accordion, .ui.styled.accordion .accordion {\n  border-radius: 0.21428571rem;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, 0px 0px 0px 1px #DEDEDF;\n}\n\n.ui.styled.accordion .title, .ui.styled.accordion .accordion .title {\n  margin: 0em;\n  padding: 0.75em 1em;\n  color: rgba(0, 0, 0, 0.4);\n  font-weight: bold;\n  border-top: 1px solid #DEDEDF;\n  transition: background 0.1s ease, color 0.1s ease;\n}\n\n.ui.styled.accordion > .title:first-child, .ui.styled.accordion .accordion .title:first-child {\n  border-top: none;\n}\n\n/* Content */\n\n.ui.styled.accordion .content, .ui.styled.accordion .accordion .content {\n  margin: 0em;\n  padding: 0.5em 1em 1.5em;\n}\n\n.ui.styled.accordion .accordion .content {\n  padding: 0em;\n  padding: 0.5em 1em 1.5em;\n}\n\n/* Hover */\n\n.ui.styled.accordion .title:hover, .ui.styled.accordion .active.title, .ui.styled.accordion .accordion .title:hover, .ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.styled.accordion .accordion .title:hover, .ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Active */\n\n.ui.styled.accordion .active.title {\n  background: transparent;\n  color: #59D98D;\n}\n\n.ui.styled.accordion .accordion .active.title {\n  background: transparent;\n  color: #59D98D;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Active\n---------------*/\n\n.ui.accordion .active.content, .ui.accordion .accordion .active.content {\n  display: block;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.accordion, .ui.fluid.accordion .accordion {\n  width: 100%;\n}\n\n/*--------------\n     Inverted\n---------------*/\n\n.ui.inverted.accordion .title:not(.ui) {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Accordion';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Dropdown Icon */\n\n.ui.accordion .title .dropdown.icon, .ui.accordion .accordion .title .dropdown.icon {\n  font-family: Accordion;\n  line-height: 1;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n.ui.accordion .title .dropdown.icon:before, .ui.accordion .accordion .title .dropdown.icon:before {\n  content: '\\F0DA';\n}\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Checkbox\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           Checkbox\n*******************************/\n\n/*--------------\n    Content\n---------------*/\n\n.ui.checkbox {\n  position: relative;\n  display: inline-block;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  outline: none;\n  vertical-align: baseline;\n  font-style: normal;\n  min-height: 17px;\n  font-size: 1rem;\n  line-height: 17px;\n  min-width: 17px;\n}\n\n/* HTML Checkbox */\n\n.ui.checkbox input[type=\"checkbox\"], .ui.checkbox input[type=\"radio\"] {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  opacity: 0 !important;\n  outline: none;\n  z-index: 3;\n  width: 17px;\n  height: 17px;\n}\n\n/*--------------\n      Box\n---------------*/\n\n.ui.checkbox .box, .ui.checkbox label {\n  cursor: auto;\n  position: relative;\n  display: block;\n  padding-left: 1.85714em;\n  outline: none;\n  font-size: 1em;\n}\n\n.ui.checkbox .box:before, .ui.checkbox label:before {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 17px;\n  height: 17px;\n  content: '';\n  background: #FFFFFF;\n  border-radius: 0.21428571rem;\n  transition: border 0.1s ease, opacity 0.1s ease, box-shadow 0.1s ease, -webkit-transform 0.1s ease;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease, -webkit-transform 0.1s ease;\n  border: 1px solid #DEDEDF;\n}\n\n/*--------------\n    Checkmark\n---------------*/\n\n.ui.checkbox .box:after, .ui.checkbox label:after {\n  position: absolute;\n  font-size: 14px;\n  top: 0px;\n  left: 0px;\n  width: 17px;\n  height: 17px;\n  text-align: center;\n  opacity: 0;\n  color: rgba(0, 0, 0, 0.8);\n  transition: border 0.1s ease, opacity 0.1s ease, box-shadow 0.1s ease, -webkit-transform 0.1s ease;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;\n  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease, -webkit-transform 0.1s ease;\n}\n\n/*--------------\n      Label\n---------------*/\n\n/* Inside */\n\n.ui.checkbox label, .ui.checkbox + label {\n  color: rgba(0, 0, 0, 0.8);\n  transition: color 0.1s ease;\n}\n\n/* Outside */\n\n.ui.checkbox + label {\n  vertical-align: middle;\n}\n\n/*******************************\n           States\n*******************************/\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.checkbox .box:hover::before, .ui.checkbox label:hover::before {\n  background: #FFFFFF;\n  border-color: rgba(34, 36, 38, 0.35);\n}\n\n.ui.checkbox label:hover, .ui.checkbox + label:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n      Down\n---------------*/\n\n.ui.checkbox .box:active::before, .ui.checkbox label:active::before {\n  background: #F9FAFB;\n  border-color: rgba(34, 36, 38, 0.35);\n}\n\n.ui.checkbox .box:active::after, .ui.checkbox label:active::after {\n  color: #59D98D;\n}\n\n.ui.checkbox input:active ~ label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n     Focus\n---------------*/\n\n.ui.checkbox input:focus ~ .box:before, .ui.checkbox input:focus ~ label:before {\n  background: #FFFFFF;\n  border-color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.checkbox input:focus ~ .box:after, .ui.checkbox input:focus ~ label:after {\n  color: #59D98D;\n}\n\n.ui.checkbox input:focus ~ label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.checkbox input:checked ~ .box:before, .ui.checkbox input:checked ~ label:before {\n  background: #FFFFFF;\n  border-color: rgba(34, 36, 38, 0.35);\n}\n\n.ui.checkbox input:checked ~ .box:after, .ui.checkbox input:checked ~ label:after {\n  opacity: 1;\n  color: #59D98D;\n}\n\n/*--------------\n  Indeterminate\n---------------*/\n\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:before, .ui.checkbox input:not([type=radio]):indeterminate ~ label:before {\n  background: #FFFFFF;\n  border-color: rgba(34, 36, 38, 0.35);\n}\n\n.ui.checkbox input:not([type=radio]):indeterminate ~ .box:after, .ui.checkbox input:not([type=radio]):indeterminate ~ label:after {\n  opacity: 1;\n  color: #59D98D;\n}\n\n/*--------------\n  Active Focus\n---------------*/\n\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before, .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before, .ui.checkbox input:checked:focus ~ .box:before, .ui.checkbox input:checked:focus ~ label:before {\n  background: #FFFFFF;\n  border-color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after, .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after, .ui.checkbox input:checked:focus ~ .box:after, .ui.checkbox input:checked:focus ~ label:after {\n  color: #59D98D;\n}\n\n/*--------------\n    Read-Only\n---------------*/\n\n.ui.read-only.checkbox, .ui.read-only.checkbox label {\n  cursor: default;\n}\n\n/*--------------\n     Disabled\n---------------*/\n\n.ui.disabled.checkbox .box:after, .ui.disabled.checkbox label, .ui.checkbox input[disabled] ~ .box:after, .ui.checkbox input[disabled] ~ label {\n  cursor: default !important;\n  opacity: 0.5;\n  color: #000000;\n}\n\n/*--------------\n     Hidden\n---------------*/\n\n/* Initialized checkbox moves input below element\n to prevent manually triggering */\n\n.ui.checkbox input.hidden {\n  z-index: -1;\n}\n\n/* Selectable Label */\n\n.ui.checkbox input.hidden + label {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*--------------\n     Radio\n---------------*/\n\n.ui.radio.checkbox {\n  min-height: 15px;\n}\n\n.ui.radio.checkbox .box, .ui.radio.checkbox label {\n  padding-left: 1.85714em;\n}\n\n/* Box */\n\n.ui.radio.checkbox .box:before, .ui.radio.checkbox label:before {\n  content: '';\n  -webkit-transform: none;\n  transform: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 500rem;\n  top: 1px;\n  left: 0px;\n}\n\n/* Bullet */\n\n.ui.radio.checkbox .box:after, .ui.radio.checkbox label:after {\n  border: none;\n  content: '' !important;\n  width: 15px;\n  height: 15px;\n  line-height: 15px;\n}\n\n/* Radio Checkbox */\n\n.ui.radio.checkbox .box:after, .ui.radio.checkbox label:after {\n  top: 1px;\n  left: 0px;\n  width: 15px;\n  height: 15px;\n  border-radius: 500rem;\n  -webkit-transform: scale(0.46666667);\n  transform: scale(0.46666667);\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n/* Focus */\n\n.ui.radio.checkbox input:focus ~ .box:before, .ui.radio.checkbox input:focus ~ label:before {\n  background-color: #FFFFFF;\n}\n\n.ui.radio.checkbox input:focus ~ .box:after, .ui.radio.checkbox input:focus ~ label:after {\n  background-color: #59D98D;\n}\n\n/* Indeterminate */\n\n.ui.radio.checkbox input:indeterminate ~ .box:after, .ui.radio.checkbox input:indeterminate ~ label:after {\n  opacity: 0;\n}\n\n/* Active */\n\n.ui.radio.checkbox input:checked ~ .box:before, .ui.radio.checkbox input:checked ~ label:before {\n  background-color: #FFFFFF;\n}\n\n.ui.radio.checkbox input:checked ~ .box:after, .ui.radio.checkbox input:checked ~ label:after {\n  background-color: #59D98D;\n}\n\n/* Active Focus */\n\n.ui.radio.checkbox input:focus:checked ~ .box:before, .ui.radio.checkbox input:focus:checked ~ label:before {\n  background-color: #FFFFFF;\n}\n\n.ui.radio.checkbox input:focus:checked ~ .box:after, .ui.radio.checkbox input:focus:checked ~ label:after {\n  background-color: #59D98D;\n}\n\n/*--------------\n     Slider\n---------------*/\n\n.ui.slider.checkbox {\n  min-height: 1.25rem;\n}\n\n/* Input */\n\n.ui.slider.checkbox input {\n  width: 3.5rem;\n  height: 1.25rem;\n}\n\n/* Label */\n\n.ui.slider.checkbox .box, .ui.slider.checkbox label {\n  padding-left: 4.5rem;\n  line-height: 1rem;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/* Line */\n\n.ui.slider.checkbox .box:before, .ui.slider.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  border: none !important;\n  left: 0em;\n  z-index: 1;\n  top: 0.4rem;\n  background-color: rgba(0, 0, 0, 0.05);\n  width: 3.5rem;\n  height: 0.21428571rem;\n  -webkit-transform: none;\n  transform: none;\n  border-radius: 500rem;\n  transition: background 0.3s ease;\n}\n\n/* Handle */\n\n.ui.slider.checkbox .box:after, .ui.slider.checkbox label:after {\n  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n  border: none;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, 0px 0px 0px 1px #DEDEDF inset;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: -0.25rem;\n  left: 0em;\n  -webkit-transform: none;\n  transform: none;\n  border-radius: 500rem;\n  transition: left 0.3s ease;\n}\n\n/* Focus */\n\n.ui.slider.checkbox input:focus ~ .box:before, .ui.slider.checkbox input:focus ~ label:before {\n  background-color: rgba(0, 0, 0, 0.15);\n  border: none;\n}\n\n/* Hover */\n\n.ui.slider.checkbox .box:hover, .ui.slider.checkbox label:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.slider.checkbox .box:hover::before, .ui.slider.checkbox label:hover::before {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* Active */\n\n.ui.slider.checkbox input:checked ~ .box, .ui.slider.checkbox input:checked ~ label {\n  color: #59D98D !important;\n}\n\n.ui.slider.checkbox input:checked ~ .box:before, .ui.slider.checkbox input:checked ~ label:before {\n  background-color: #545454 !important;\n}\n\n.ui.slider.checkbox input:checked ~ .box:after, .ui.slider.checkbox input:checked ~ label:after {\n  left: 2rem;\n}\n\n/* Active Focus */\n\n.ui.slider.checkbox input:focus:checked ~ .box, .ui.slider.checkbox input:focus:checked ~ label {\n  color: #59D98D !important;\n}\n\n.ui.slider.checkbox input:focus:checked ~ .box:before, .ui.slider.checkbox input:focus:checked ~ label:before {\n  background-color: #000000 !important;\n}\n\n/*--------------\n     Toggle\n---------------*/\n\n.ui.toggle.checkbox {\n  min-height: 1.5rem;\n}\n\n/* Input */\n\n.ui.toggle.checkbox input {\n  width: 3.5rem;\n  height: 1.5rem;\n}\n\n/* Label */\n\n.ui.toggle.checkbox .box, .ui.toggle.checkbox label {\n  min-height: 1.5rem;\n  padding-left: 4.5rem;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.toggle.checkbox label {\n  padding-top: 0.15em;\n}\n\n/* Switch */\n\n.ui.toggle.checkbox .box:before, .ui.toggle.checkbox label:before {\n  display: block;\n  position: absolute;\n  content: '';\n  z-index: 1;\n  -webkit-transform: none;\n  transform: none;\n  border: none;\n  top: 0rem;\n  background: rgba(0, 0, 0, 0.05);\n  box-shadow: none;\n  width: 3.5rem;\n  height: 1.5rem;\n  border-radius: 500rem;\n}\n\n/* Handle */\n\n.ui.toggle.checkbox .box:after, .ui.toggle.checkbox label:after {\n  background: #FFFFFF linear-gradient(transparent, rgba(0, 0, 0, 0.05));\n  position: absolute;\n  content: '' !important;\n  opacity: 1;\n  z-index: 2;\n  border: none;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, 0px 0px 0px 1px #DEDEDF inset;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: 0rem;\n  left: 0em;\n  border-radius: 500rem;\n  transition: background 0.3s ease, left 0.3s ease;\n}\n\n.ui.toggle.checkbox input ~ .box:after, .ui.toggle.checkbox input ~ label:after {\n  left: -0.05rem;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, 0px 0px 0px 1px #DEDEDF inset;\n}\n\n/* Focus */\n\n.ui.toggle.checkbox input:focus ~ .box:before, .ui.toggle.checkbox input:focus ~ label:before {\n  background-color: rgba(0, 0, 0, 0.15);\n  border: none;\n}\n\n/* Hover */\n\n.ui.toggle.checkbox .box:hover::before, .ui.toggle.checkbox label:hover::before {\n  background-color: rgba(0, 0, 0, 0.15);\n  border: none;\n}\n\n/* Active */\n\n.ui.toggle.checkbox input:checked ~ .box, .ui.toggle.checkbox input:checked ~ label {\n  color: #000000 !important;\n}\n\n.ui.toggle.checkbox input:checked ~ .box:before, .ui.toggle.checkbox input:checked ~ label:before {\n  background-color: #59D98D !important;\n}\n\n.ui.toggle.checkbox input:checked ~ .box:after, .ui.toggle.checkbox input:checked ~ label:after {\n  left: 2.15rem;\n  box-shadow: 0px 1px 2px 0 #DEDEDF, 0px 0px 0px 1px #DEDEDF inset;\n}\n\n/* Active Focus */\n\n.ui.toggle.checkbox input:focus:checked ~ .box, .ui.toggle.checkbox input:focus:checked ~ label {\n  color: #000000 !important;\n}\n\n.ui.toggle.checkbox input:focus:checked ~ .box:before, .ui.toggle.checkbox input:focus:checked ~ label:before {\n  background-color: #28e173 !important;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n     Fitted\n---------------*/\n\n.ui.fitted.checkbox .box, .ui.fitted.checkbox label {\n  padding-left: 0em !important;\n}\n\n.ui.fitted.toggle.checkbox, .ui.fitted.toggle.checkbox {\n  width: 3.5rem;\n}\n\n.ui.fitted.slider.checkbox, .ui.fitted.slider.checkbox {\n  width: 3.5rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Checkbox';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype');\n}\n\n/* Checkmark */\n\n.ui.checkbox label:after, .ui.checkbox .box:after {\n  font-family: 'Checkbox';\n}\n\n/* Checked */\n\n.ui.checkbox input:checked ~ .box:after, .ui.checkbox input:checked ~ label:after {\n  content: '\\E800';\n}\n\n/* Indeterminate */\n\n.ui.checkbox input:indeterminate ~ .box:after, .ui.checkbox input:indeterminate ~ label:after {\n  font-size: 12px;\n  content: '\\E801';\n}\n\n/*  UTF Reference\n.check:before { content: '\\e800'; }\n.dash:before  { content: '\\e801'; }\n.plus:before { content: '\\e802'; }\n*/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Dimmer\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Dimmer\n*******************************/\n\n.dimmable:not(body) {\n  position: relative;\n}\n\n.ui.dimmer {\n  display: none;\n  position: absolute;\n  top: 0em !important;\n  left: 0em !important;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  padding: 1em;\n  background-color: rgba(0, 0, 0, 0.85);\n  opacity: 0;\n  line-height: 1;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  transition: background-color 0.5s linear;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  will-change: opacity;\n  z-index: 1000;\n}\n\n/* Dimmer Content */\n\n.ui.dimmer > .content {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  color: #FFFFFF;\n}\n\n/* Loose Coupling */\n\n.ui.segment > .ui.dimmer {\n  border-radius: inherit !important;\n}\n\n/* Scrollbars */\n\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n/*******************************\n            States\n*******************************/\n\n/* Animating */\n\n.animating.dimmable:not(body), .dimmed.dimmable:not(body) {\n  overflow: hidden;\n}\n\n/* Animating / Active / Visible */\n\n.dimmed.dimmable > .ui.animating.dimmer, .dimmed.dimmable > .ui.visible.dimmer, .ui.active.dimmer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  opacity: 1;\n}\n\n/* Disabled */\n\n.ui.disabled.dimmer {\n  width: 0 !important;\n  height: 0 !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Legacy\n---------------*/\n\n/* Animating / Active / Visible */\n\n.dimmed.dimmable > .ui.animating.legacy.dimmer, .dimmed.dimmable > .ui.visible.legacy.dimmer, .ui.active.legacy.dimmer {\n  display: block;\n}\n\n/*--------------\n    Alignment\n---------------*/\n\n.ui[class*=\"top aligned\"].dimmer {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.ui[class*=\"bottom aligned\"].dimmer {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n/*--------------\n      Page\n---------------*/\n\n.ui.page.dimmer {\n  position: fixed;\n  -webkit-transform-style: '';\n  transform-style: '';\n  -webkit-perspective: 2000px;\n  perspective: 2000px;\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n}\n\nbody.animating.in.dimmable, body.dimmed.dimmable {\n  overflow: hidden;\n}\n\nbody.dimmable > .dimmer {\n  position: fixed;\n}\n\n/*--------------\n    Blurring\n---------------*/\n\n.blurring.dimmable > :not(.dimmer) {\n  -webkit-filter: blur(0px) grayscale(0);\n  filter: blur(0px) grayscale(0);\n  transition: 800ms -webkit-filter ease;\n  transition: 800ms filter ease;\n  transition: 800ms filter ease, 800ms -webkit-filter ease;\n}\n\n.blurring.dimmed.dimmable > :not(.dimmer) {\n  -webkit-filter: blur(5px) grayscale(0.7);\n  filter: blur(5px) grayscale(0.7);\n}\n\n/* Dimmer Color */\n\n.blurring.dimmable > .dimmer {\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.blurring.dimmable > .inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n/*--------------\n    Aligned\n---------------*/\n\n.ui.dimmer > .top.aligned.content > * {\n  vertical-align: top;\n}\n\n.ui.dimmer > .bottom.aligned.content > * {\n  vertical-align: bottom;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n\n.ui.inverted.dimmer > .content > * {\n  color: #FFFFFF;\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/* Displays without javascript */\n\n.ui.simple.dimmer {\n  display: block;\n  overflow: hidden;\n  opacity: 1;\n  width: 0%;\n  height: 0%;\n  z-index: -100;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.dimmed.dimmable > .ui.simple.dimmer {\n  overflow: visible;\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.85);\n  z-index: 1;\n}\n\n.ui.simple.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0);\n}\n\n.dimmed.dimmable > .ui.simple.inverted.dimmer {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Dropdown\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Dropdown\n*******************************/\n\n.ui.dropdown {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  outline: none;\n  text-align: left;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/*******************************\n            Content\n*******************************/\n\n/*--------------\n      Menu\n---------------*/\n\n.ui.dropdown .menu {\n  cursor: auto;\n  position: absolute;\n  display: none;\n  outline: none;\n  top: 100%;\n  min-width: -webkit-max-content;\n  min-width: -moz-max-content;\n  min-width: max-content;\n  margin: 0em;\n  padding: 0em 0em;\n  background: #FFFFFF;\n  font-size: 1em;\n  text-shadow: none;\n  text-align: left;\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n  border: 1px solid #DEDEDF;\n  border-radius: 0.21428571rem;\n  transition: opacity 0.1s ease;\n  z-index: 11;\n  will-change: transform, opacity;\n}\n\n.ui.dropdown .menu > * {\n  white-space: nowrap;\n}\n\n/*--------------\n  Hidden Input\n---------------*/\n\n.ui.dropdown > input:not(.search):first-child, .ui.dropdown > select {\n  display: none !important;\n}\n\n/*--------------\n Dropdown Icon\n---------------*/\n\n.ui.dropdown > .dropdown.icon {\n  position: relative;\n  width: auto;\n  font-size: 0.85714286em;\n  margin: 0em 0em 0em 1em;\n}\n\n.ui.dropdown .menu > .item .dropdown.icon {\n  width: auto;\n  float: right;\n  margin: 0em 0em 0em 1em;\n}\n\n.ui.dropdown .menu > .item .dropdown.icon + .text {\n  margin-right: 1em;\n}\n\n/*--------------\n      Text\n---------------*/\n\n.ui.dropdown > .text {\n  display: inline-block;\n  transition: none;\n}\n\n/*--------------\n    Menu Item\n---------------*/\n\n.ui.dropdown .menu > .item {\n  position: relative;\n  cursor: pointer;\n  display: block;\n  border: none;\n  height: auto;\n  text-align: left;\n  border-top: none;\n  line-height: 1em;\n  color: rgba(0, 0, 0, 0.8);\n  padding: 0.78571429rem 1.14285714rem !important;\n  font-size: 1rem;\n  text-transform: none;\n  font-weight: normal;\n  box-shadow: none;\n  -webkit-touch-callout: none;\n}\n\n.ui.dropdown .menu > .item:first-child {\n  border-top-width: 0px;\n}\n\n/*--------------\n  Floated Content\n---------------*/\n\n.ui.dropdown > .text > [class*=\"right floated\"], .ui.dropdown .menu .item > [class*=\"right floated\"] {\n  float: right !important;\n  margin-right: 0em !important;\n  margin-left: 1em !important;\n}\n\n.ui.dropdown > .text > [class*=\"left floated\"], .ui.dropdown .menu .item > [class*=\"left floated\"] {\n  float: left !important;\n  margin-left: 0em !important;\n  margin-right: 1em !important;\n}\n\n.ui.dropdown .menu .item > .icon.floated, .ui.dropdown .menu .item > .flag.floated, .ui.dropdown .menu .item > .image.floated, .ui.dropdown .menu .item > img.floated {\n  margin-top: 0em;\n}\n\n/*--------------\n  Menu Divider\n---------------*/\n\n.ui.dropdown .menu > .header {\n  margin: 1rem 0rem 0.75rem;\n  padding: 0em 1.14285714rem;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 0.78571429em;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.ui.dropdown .menu > .divider {\n  border-top: 1px solid rgba(34, 36, 38, 0.1);\n  height: 0em;\n  margin: 0.5em 0em;\n}\n\n.ui.dropdown.dropdown .menu > .input {\n  width: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 1.14285714rem 0.78571429rem;\n  min-width: 10rem;\n}\n\n.ui.dropdown .menu > .header + .input {\n  margin-top: 0em;\n}\n\n.ui.dropdown .menu > .input:not(.transparent) input {\n  padding: 0.5em 1em;\n}\n\n.ui.dropdown .menu > .input:not(.transparent) .button, .ui.dropdown .menu > .input:not(.transparent) .icon, .ui.dropdown .menu > .input:not(.transparent) .label {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n\n/*-----------------\n  Item Description\n-------------------*/\n\n.ui.dropdown > .text > .description, .ui.dropdown .menu > .item > .description {\n  float: right;\n  margin: 0em 0em 0em 1em;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*-----------------\n       Message\n-------------------*/\n\n.ui.dropdown .menu > .message {\n  padding: 0.78571429rem 1.14285714rem;\n  font-weight: normal;\n}\n\n.ui.dropdown .menu > .message:not(.ui) {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*--------------\n    Sub Menu\n---------------*/\n\n.ui.dropdown .menu .menu {\n  top: 0% !important;\n  left: 100%;\n  right: auto;\n  margin: 0em 0em 0em -0.5em !important;\n  border-radius: 0.21428571rem !important;\n  z-index: 21 !important;\n}\n\n/* Hide Arrow */\n\n.ui.dropdown .menu .menu:after {\n  display: none;\n}\n\n/*--------------\n   Sub Elements\n---------------*/\n\n/* Icons / Flags / Labels / Image */\n\n.ui.dropdown > .text > .icon, .ui.dropdown > .text > .label, .ui.dropdown > .text > .flag, .ui.dropdown > .text > img, .ui.dropdown > .text > .image {\n  margin-top: 0em;\n}\n\n.ui.dropdown .menu > .item > .icon, .ui.dropdown .menu > .item > .label, .ui.dropdown .menu > .item > .flag, .ui.dropdown .menu > .item > .image, .ui.dropdown .menu > .item > img {\n  margin-top: 0em;\n}\n\n.ui.dropdown > .text > .icon, .ui.dropdown > .text > .label, .ui.dropdown > .text > .flag, .ui.dropdown > .text > img, .ui.dropdown > .text > .image, .ui.dropdown .menu > .item > .icon, .ui.dropdown .menu > .item > .label, .ui.dropdown .menu > .item > .flag, .ui.dropdown .menu > .item > .image, .ui.dropdown .menu > .item > img {\n  margin-left: 0em;\n  float: none;\n  margin-right: 0.78571429rem;\n}\n\n/*--------------\n     Image\n---------------*/\n\n.ui.dropdown > .text > img, .ui.dropdown > .text > .image, .ui.dropdown .menu > .item > .image, .ui.dropdown .menu > .item > img {\n  display: inline-block;\n  vertical-align: top;\n  width: auto;\n  margin-top: -0.5em;\n  margin-bottom: -0.5em;\n  max-height: 2em;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n/*--------------\n      Menu\n---------------*/\n\n/* Remove Menu Item Divider */\n\n.ui.dropdown .ui.menu > .item:before, .ui.menu .ui.dropdown .menu > .item:before {\n  display: none;\n}\n\n/* Prevent Menu Item Border */\n\n.ui.menu .ui.dropdown .menu .active.item {\n  border-left: none;\n}\n\n/* Automatically float dropdown menu right on last menu item */\n\n.ui.menu .right.menu .dropdown:last-child .menu, .ui.menu .right.dropdown.item .menu, .ui.buttons > .ui.dropdown:last-child .menu {\n  left: auto;\n  right: 0em;\n}\n\n/*--------------\n      Label\n---------------*/\n\n/* Dropdown Menu */\n\n.ui.label.dropdown .menu {\n  min-width: 100%;\n}\n\n/*--------------\n     Button\n---------------*/\n\n/* No Margin On Icon Button */\n\n.ui.dropdown.icon.button > .dropdown.icon {\n  margin: 0em;\n}\n\n.ui.button.dropdown .menu {\n  min-width: 100%;\n}\n\n/*******************************\n              Types\n*******************************/\n\n/*--------------\n    Selection\n---------------*/\n\n/* Displays like a select box */\n\n.ui.selection.dropdown {\n  cursor: pointer;\n  word-wrap: break-word;\n  line-height: 1em;\n  white-space: normal;\n  outline: 0;\n  -webkit-transform: rotateZ(0deg);\n  transform: rotateZ(0deg);\n  min-width: 14em;\n  min-height: 2.71428571em;\n  background: #FFFFFF;\n  display: inline-block;\n  padding: 0.78571429em 2.1em 0.78571429em 1em;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: none;\n  border: 1px solid #DEDEDF;\n  border-radius: 0.21428571rem;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n}\n\n.ui.selection.dropdown.visible, .ui.selection.dropdown.active {\n  z-index: 10;\n}\n\nselect.ui.dropdown {\n  height: 38px;\n  padding: 0.5em;\n  border: 1px solid #DEDEDF;\n  visibility: visible;\n}\n\n.ui.selection.dropdown > .search.icon, .ui.selection.dropdown > .delete.icon, .ui.selection.dropdown > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.21428571em;\n  top: 0.78571429em;\n  right: 1em;\n  z-index: 3;\n  margin: -0.78571429em;\n  padding: 0.91666667em;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n\n/* Compact */\n\n.ui.compact.selection.dropdown {\n  min-width: 0px;\n}\n\n/*  Selection Menu */\n\n.ui.selection.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  border-top-width: 0px !important;\n  width: auto;\n  outline: none;\n  margin: 0px -1px;\n  min-width: calc(100% +  2px );\n  width: calc(100% +  2px );\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n  transition: opacity 0.1s ease;\n}\n\n.ui.selection.dropdown .menu:after, .ui.selection.dropdown .menu:before {\n  display: none;\n}\n\n/*--------------\n    Message\n---------------*/\n\n.ui.selection.dropdown .menu > .message {\n  padding: 0.78571429rem 1.14285714rem;\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.selection.dropdown .menu {\n    max-height: 8.01428571rem;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.selection.dropdown .menu {\n    max-height: 10.68571429rem;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.selection.dropdown .menu {\n    max-height: 16.02857143rem;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.selection.dropdown .menu {\n    max-height: 21.37142857rem;\n  }\n}\n\n/* Menu Item */\n\n.ui.selection.dropdown .menu > .item {\n  border-top: 1px solid #FAFAFA;\n  padding: 0.78571429rem 1.14285714rem !important;\n  white-space: normal;\n  word-wrap: normal;\n}\n\n/* User Item */\n\n.ui.selection.dropdown .menu > .hidden.addition.item {\n  display: none;\n}\n\n/* Hover */\n\n.ui.selection.dropdown:hover {\n  border-color: rgba(34, 36, 38, 0.35);\n  box-shadow: none;\n}\n\n/* Active */\n\n.ui.selection.active.dropdown {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n}\n\n.ui.selection.active.dropdown .menu {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n}\n\n/* Focus */\n\n.ui.selection.dropdown:focus {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: none;\n}\n\n.ui.selection.dropdown:focus .menu {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n}\n\n/* Visible */\n\n.ui.selection.visible.dropdown > .text:not(.default) {\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Visible Hover */\n\n.ui.selection.active.dropdown:hover {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n}\n\n.ui.selection.active.dropdown:hover .menu {\n  border-color: rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 2px 3px 0px #DEDEDF;\n}\n\n/* Dropdown Icon */\n\n.ui.active.selection.dropdown > .dropdown.icon, .ui.visible.selection.dropdown > .dropdown.icon {\n  opacity: '';\n  z-index: 3;\n}\n\n/* Connecting Border */\n\n.ui.active.selection.dropdown {\n  border-bottom-left-radius: 0em !important;\n  border-bottom-right-radius: 0em !important;\n}\n\n/* Empty Connecting Border */\n\n.ui.active.empty.selection.dropdown {\n  border-radius: 0.21428571rem !important;\n  box-shadow: none !important;\n}\n\n.ui.active.empty.selection.dropdown .menu {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/*--------------\n   Searchable\n---------------*/\n\n/* Search Selection */\n\n.ui.search.dropdown {\n  min-width: '';\n}\n\n/* Search Dropdown */\n\n.ui.search.dropdown > input.search {\n  background: none transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  cursor: text;\n  top: 0em;\n  left: 1px;\n  width: 100%;\n  outline: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  padding: inherit;\n}\n\n/* Text Layering */\n\n.ui.search.dropdown > input.search {\n  position: absolute;\n  z-index: 2;\n}\n\n.ui.search.dropdown > .text {\n  cursor: text;\n  position: relative;\n  left: 1px;\n  z-index: 3;\n}\n\n/* Search Selection */\n\n.ui.search.selection.dropdown > input.search {\n  line-height: 1.21428571em;\n  padding: 0.67857143em 2.1em 0.67857143em 1em;\n}\n\n/* Used to size multi select input to character width */\n\n.ui.search.selection.dropdown > span.sizer {\n  line-height: 1.21428571em;\n  padding: 0.67857143em 2.1em 0.67857143em 1em;\n  display: none;\n  white-space: pre;\n}\n\n/* Active/Visible Search */\n\n.ui.search.dropdown.active > input.search, .ui.search.dropdown.visible > input.search {\n  cursor: auto;\n}\n\n.ui.search.dropdown.active > .text, .ui.search.dropdown.visible > .text {\n  pointer-events: none;\n}\n\n/* Filtered Text */\n\n.ui.active.search.dropdown input.search:focus + .text .icon, .ui.active.search.dropdown input.search:focus + .text .flag {\n  opacity: 0.45;\n}\n\n.ui.active.search.dropdown input.search:focus + .text {\n  color: rgba(0, 0, 0, 0.65) !important;\n}\n\n/* Search Menu */\n\n.ui.search.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.search.dropdown .menu {\n    max-height: 8.01428571rem;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.search.dropdown .menu {\n    max-height: 10.68571429rem;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.search.dropdown .menu {\n    max-height: 16.02857143rem;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.search.dropdown .menu {\n    max-height: 21.37142857rem;\n  }\n}\n\n/*--------------\n    Multiple\n---------------*/\n\n/* Multiple Selection */\n\n.ui.multiple.dropdown {\n  padding: 0.22619048em 2.1em 0.22619048em 0.35714286em;\n}\n\n.ui.multiple.dropdown .menu {\n  cursor: auto;\n}\n\n/* Multiple Search Selection */\n\n.ui.multiple.search.dropdown, .ui.multiple.search.dropdown > input.search {\n  cursor: text;\n}\n\n/* Selection Label */\n\n.ui.multiple.dropdown > .label {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n  font-size: 1em;\n  padding: 0.35714286em 0.78571429em;\n  margin: 0.14285714rem 0.28571429rem 0.14285714rem 0em;\n  box-shadow: 0px 0px 0px 1px #DEDEDF inset;\n}\n\n/* Dropdown Icon */\n\n.ui.multiple.dropdown .dropdown.icon {\n  margin: '';\n  padding: '';\n}\n\n/* Text */\n\n.ui.multiple.dropdown > .text {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  line-height: 1.21428571em;\n}\n\n.ui.multiple.dropdown > .label ~ input.search {\n  margin-left: 0.14285714em !important;\n}\n\n.ui.multiple.dropdown > .label ~ .text {\n  display: none;\n}\n\n/*-----------------\n  Multiple Search\n-----------------*/\n\n/* Prompt Text */\n\n.ui.multiple.search.dropdown > .text {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: inherit;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  line-height: 1.21428571em;\n}\n\n.ui.multiple.search.dropdown > .label ~ .text {\n  display: none;\n}\n\n/* Search */\n\n.ui.multiple.search.dropdown > input.search {\n  position: static;\n  padding: 0;\n  max-width: 100%;\n  margin: 0.45238095em 0em 0.45238095em 0.64285714em;\n  width: 2.2em;\n  line-height: 1.21428571em;\n}\n\n/*--------------\n     Inline\n---------------*/\n\n.ui.inline.dropdown {\n  cursor: pointer;\n  display: inline-block;\n  color: inherit;\n}\n\n.ui.inline.dropdown .dropdown.icon {\n  margin: 0em 0.21428571em 0em 0.21428571em;\n  vertical-align: baseline;\n}\n\n.ui.inline.dropdown > .text {\n  font-weight: normal;\n}\n\n.ui.inline.dropdown .menu {\n  cursor: auto;\n  margin-top: 0.21428571em;\n  border-radius: 0.21428571rem;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n        Active\n----------------------*/\n\n/* Menu Item Active */\n\n.ui.dropdown .menu .active.item {\n  background: transparent;\n  font-weight: bold;\n  color: #59D98D;\n  box-shadow: none;\n  z-index: 12;\n}\n\n/*--------------------\n        Hover\n----------------------*/\n\n/* Menu Item Hover */\n\n.ui.dropdown .menu > .item:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #59D98D;\n  z-index: 13;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.dropdown > i.icon {\n  height: 1em !important;\n}\n\n.ui.loading.selection.dropdown > i.icon {\n  padding: 1.5em 1.28571429em !important;\n}\n\n.ui.loading.dropdown > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n\n.ui.loading.dropdown > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  box-shadow: 0px 0px 0px 1px transparent;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  -webkit-animation: dropdown-spin 0.6s linear;\n  animation: dropdown-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n}\n\n/* Coupling */\n\n.ui.loading.dropdown.button > i.icon:before, .ui.loading.dropdown.button > i.icon:after {\n  display: none;\n}\n\n@-webkit-keyframes dropdown-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dropdown-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------\n     Default Text\n----------------------*/\n\n.ui.dropdown:not(.button) > .default.text, .ui.default.dropdown:not(.button) > .text {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.dropdown:not(.button) > input:focus + .default.text, .ui.default.dropdown:not(.button) > input:focus + .text {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n/*--------------------\n        Loading\n----------------------*/\n\n.ui.loading.dropdown > .text {\n  transition: none;\n}\n\n/* Used To Check Position */\n\n.ui.dropdown .loading.menu {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.ui.dropdown > .loading.menu {\n  left: 0px !important;\n  right: auto !important;\n}\n\n.ui.dropdown > .menu .loading.menu {\n  left: 100% !important;\n  right: auto !important;\n}\n\n/*--------------------\n    Keyboard Select\n----------------------*/\n\n/* Selected Item */\n\n.ui.dropdown.selected, .ui.dropdown .menu .selected.item {\n  background: rgba(0, 0, 0, 0.03);\n  color: #59D98D;\n}\n\n/*--------------------\n    Search Filtered\n----------------------*/\n\n/* Filtered Item */\n\n.ui.dropdown > .filtered.text {\n  visibility: hidden;\n}\n\n.ui.dropdown .filtered.item {\n  display: none !important;\n}\n\n/*--------------------\n        Error\n----------------------*/\n\n.ui.dropdown.error, .ui.dropdown.error > .text, .ui.dropdown.error > .default.text {\n  color: #9F3A38;\n}\n\n.ui.selection.dropdown.error {\n  background: #FFF6F6;\n  border-color: #E0B4B4;\n}\n\n.ui.selection.dropdown.error:hover {\n  border-color: #E0B4B4;\n}\n\n.ui.dropdown.error > .menu, .ui.dropdown.error > .menu .menu {\n  border-color: #E0B4B4;\n}\n\n.ui.dropdown.error > .menu > .item {\n  color: #9F3A38;\n}\n\n.ui.multiple.selection.error.dropdown > .label {\n  border-color: #E0B4B4;\n}\n\n/* Item Hover */\n\n.ui.dropdown.error > .menu > .item:hover {\n  background-color: #FFF2F2;\n}\n\n/* Item Active */\n\n.ui.dropdown.error > .menu .active.item {\n  background-color: #FDCFCF;\n}\n\n/*--------------------\n        Clear\n----------------------*/\n\n.ui.dropdown > .clear.dropdown.icon {\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n\n.ui.dropdown > .clear.dropdown.icon:hover {\n  opacity: 1;\n}\n\n/*--------------------\n        Disabled\n----------------------*/\n\n/* Disabled */\n\n.ui.disabled.dropdown, .ui.dropdown .menu > .disabled.item {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.45;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Direction\n---------------*/\n\n/* Flyout Direction */\n\n.ui.dropdown .menu {\n  left: 0px;\n}\n\n/* Default Side (Right) */\n\n.ui.dropdown .right.menu > .menu, .ui.dropdown .menu .right.menu {\n  left: 100% !important;\n  right: auto !important;\n  border-radius: 0.21428571rem !important;\n}\n\n/* Leftward Opening Menu */\n\n.ui.dropdown > .left.menu {\n  left: auto !important;\n  right: 0px !important;\n}\n\n.ui.dropdown > .left.menu .menu, .ui.dropdown .menu .left.menu {\n  left: auto !important;\n  right: 100% !important;\n  border-radius: 0.21428571rem !important;\n}\n\n.ui.dropdown .item .left.dropdown.icon, .ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: left;\n  margin: 0em 0em 0em 0em;\n}\n\n.ui.dropdown .item .left.dropdown.icon, .ui.dropdown .left.menu .item .dropdown.icon {\n  width: auto;\n  float: left;\n  margin: 0em 0em 0em 0em;\n}\n\n.ui.dropdown .item .left.dropdown.icon + .text, .ui.dropdown .left.menu .item .dropdown.icon + .text {\n  margin-left: 1em;\n  margin-right: 0em;\n}\n\n/*--------------\n     Upward\n---------------*/\n\n/* Upward Main Menu */\n\n.ui.upward.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n/* Upward Sub Menu */\n\n.ui.dropdown .upward.menu {\n  top: auto !important;\n  bottom: 0 !important;\n}\n\n/* Active Upward */\n\n.ui.simple.upward.active.dropdown, .ui.simple.upward.dropdown:hover {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em !important;\n}\n\n.ui.upward.dropdown.button:not(.pointing):not(.floating).active {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n/* Selection */\n\n.ui.upward.selection.dropdown .menu {\n  border-top-width: 1px !important;\n  border-bottom-width: 0px !important;\n  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);\n}\n\n.ui.upward.selection.dropdown:hover {\n  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.05);\n}\n\n/* Active Upward */\n\n.ui.active.upward.selection.dropdown {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem !important;\n}\n\n/* Visible Upward */\n\n.ui.upward.selection.dropdown.visible {\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.08);\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem !important;\n}\n\n/* Visible Hover Upward */\n\n.ui.upward.active.selection.dropdown:hover {\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.05);\n}\n\n.ui.upward.active.selection.dropdown:hover .menu {\n  box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.08);\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/*  Selection Menu */\n\n.ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ui.scrolling.dropdown .menu {\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  min-width: 100% !important;\n  width: auto !important;\n}\n\n.ui.dropdown .scrolling.menu {\n  position: static;\n  overflow-y: auto;\n  border: none;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  min-width: 100% !important;\n  width: auto !important;\n  border-top: 1px solid #DEDEDF;\n}\n\n.ui.scrolling.dropdown .menu .item.item.item, .ui.dropdown .scrolling.menu > .item.item.item {\n  border-top: none;\n}\n\n.ui.scrolling.dropdown .menu .item:first-child, .ui.dropdown .scrolling.menu .item:first-child {\n  border-top: none;\n}\n\n.ui.dropdown > .animating.menu .scrolling.menu, .ui.dropdown > .visible.menu .scrolling.menu {\n  display: block;\n}\n\n/* Scrollbar in IE */\n\n@media all and (-ms-high-contrast: none) {\n  .ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n    min-width: calc(100% - 17px);\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n    max-height: 10.28571429rem;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n    max-height: 15.42857143rem;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n    max-height: 20.57142857rem;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.scrolling.dropdown .menu, .ui.dropdown .scrolling.menu {\n    max-height: 20.57142857rem;\n  }\n}\n\n/*--------------\n     Simple\n---------------*/\n\n/* Displays without javascript */\n\n.ui.simple.dropdown .menu:before, .ui.simple.dropdown .menu:after {\n  display: none;\n}\n\n.ui.simple.dropdown .menu {\n  position: absolute;\n  display: block;\n  overflow: hidden;\n  top: -9999px !important;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  transition: opacity 0.1s ease;\n}\n\n.ui.simple.active.dropdown, .ui.simple.dropdown:hover {\n  border-bottom-left-radius: 0em !important;\n  border-bottom-right-radius: 0em !important;\n}\n\n.ui.simple.active.dropdown > .menu, .ui.simple.dropdown:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 100% !important;\n  opacity: 1;\n}\n\n.ui.simple.dropdown > .menu > .item:active > .menu, .ui.simple.dropdown:hover > .menu > .item:hover > .menu {\n  overflow: visible;\n  width: auto;\n  height: auto;\n  top: 0% !important;\n  left: 100% !important;\n  opacity: 1;\n}\n\n.ui.simple.disabled.dropdown:hover .menu {\n  display: none;\n  height: 0px;\n  width: 0px;\n  overflow: hidden;\n}\n\n/* Visible */\n\n.ui.simple.visible.dropdown > .menu {\n  display: block;\n}\n\n/*--------------\n      Fluid\n---------------*/\n\n.ui.fluid.dropdown {\n  display: block;\n  width: 100%;\n  min-width: 0em;\n}\n\n.ui.fluid.dropdown > .dropdown.icon {\n  float: right;\n}\n\n/*--------------\n    Floating\n---------------*/\n\n.ui.floating.dropdown .menu {\n  left: 0;\n  right: auto;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15) !important;\n  border-radius: 0.21428571rem !important;\n}\n\n.ui.floating.dropdown > .menu {\n  margin-top: 0.5em !important;\n  border-radius: 0.21428571rem !important;\n}\n\n/*--------------\n     Pointing\n---------------*/\n\n.ui.pointing.dropdown > .menu {\n  top: 100%;\n  margin-top: 0.78571429rem;\n  border-radius: 0.21428571rem;\n}\n\n.ui.pointing.dropdown > .menu:after {\n  display: block;\n  position: absolute;\n  pointer-events: none;\n  content: '';\n  visibility: visible;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  width: 0.5em;\n  height: 0.5em;\n  box-shadow: -1px -1px 0px 1px #DEDEDF;\n  background: #FFFFFF;\n  z-index: 2;\n}\n\n.ui.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: 50%;\n  margin: 0em 0em 0em -0.25em;\n}\n\n/* Top Left Pointing */\n\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: 1em 0em 0em;\n}\n\n.ui.top.left.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n  margin: 1em 0em 0em;\n}\n\n.ui.top.left.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: 1em;\n  right: auto;\n  margin: 0em;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n/* Top Right Pointing */\n\n.ui.top.right.pointing.dropdown > .menu {\n  top: 100%;\n  bottom: auto;\n  right: 0%;\n  left: auto;\n  margin: 1em 0em 0em;\n}\n\n.ui.top.pointing.dropdown > .left.menu:after, .ui.top.right.pointing.dropdown > .menu:after {\n  top: -0.25em;\n  left: auto !important;\n  right: 1em !important;\n  margin: 0em;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n/* Left Pointing */\n\n.ui.left.pointing.dropdown > .menu {\n  top: 0%;\n  left: 100%;\n  right: auto;\n  margin: 0em 0em 0em 1em;\n}\n\n.ui.left.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: -0.25em;\n  margin: 0em 0em 0em 0em;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {\n  left: auto !important;\n  right: 100% !important;\n  margin: 0em 1em 0em 0em;\n}\n\n.ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {\n  top: 1em;\n  left: auto;\n  right: -0.25em;\n  margin: 0em 0em 0em 0em;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n/* Right Pointing */\n\n.ui.right.pointing.dropdown > .menu {\n  top: 0%;\n  left: auto;\n  right: 100%;\n  margin: 0em 1em 0em 0em;\n}\n\n.ui.right.pointing.dropdown > .menu:after {\n  top: 1em;\n  left: auto;\n  right: -0.25em;\n  margin: 0em 0em 0em 0em;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n/* Bottom Pointing */\n\n.ui.bottom.pointing.dropdown > .menu {\n  top: auto;\n  bottom: 100%;\n  left: 0%;\n  right: auto;\n  margin: 0em 0em 1em;\n}\n\n.ui.bottom.pointing.dropdown > .menu:after {\n  top: auto;\n  bottom: -0.25em;\n  right: auto;\n  margin: 0em;\n  -webkit-transform: rotate(-135deg);\n  transform: rotate(-135deg);\n}\n\n/* Reverse Sub-Menu Direction */\n\n.ui.bottom.pointing.dropdown > .menu .menu {\n  top: auto !important;\n  bottom: 0px !important;\n}\n\n/* Bottom Left */\n\n.ui.bottom.left.pointing.dropdown > .menu {\n  left: 0%;\n  right: auto;\n}\n\n.ui.bottom.left.pointing.dropdown > .menu:after {\n  left: 1em;\n  right: auto;\n}\n\n/* Bottom Right */\n\n.ui.bottom.right.pointing.dropdown > .menu {\n  right: 0%;\n  left: auto;\n}\n\n.ui.bottom.right.pointing.dropdown > .menu:after {\n  left: auto;\n  right: 1em;\n}\n\n/* Upward pointing */\n\n.ui.pointing.upward.dropdown .menu, .ui.top.pointing.upward.dropdown .menu {\n  top: auto !important;\n  bottom: 100% !important;\n  margin: 0em 0em 0.78571429rem;\n  border-radius: 0.21428571rem;\n}\n\n.ui.upward.pointing.dropdown > .menu:after, .ui.upward.top.pointing.dropdown > .menu:after {\n  top: 100%;\n  bottom: auto;\n  box-shadow: 1px 1px 0px 1px #DEDEDF;\n  margin: -0.25em 0em 0em;\n}\n\n/* Right Pointing Upward */\n\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 1em 0em 0em;\n}\n\n.ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 1em 0em;\n  box-shadow: -1px -1px 0px 0px rgba(34, 36, 38, 0.15);\n}\n\n/* Left Pointing Upward */\n\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 0em 1em;\n}\n\n.ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n  top: auto !important;\n  bottom: 0 !important;\n  margin: 0em 0em 1em 0em;\n  box-shadow: -1px -1px 0px 0px rgba(34, 36, 38, 0.15);\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/* Dropdown Carets */\n\n@font-face {\n  font-family: 'Dropdown';\n  src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAVgAA8AAAAACFAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABWAAAABwAAAAchGgaq0dERUYAAAF0AAAAHAAAAB4AJwAPT1MvMgAAAZAAAABDAAAAVnW4TJdjbWFwAAAB1AAAAEsAAAFS8CcaqmN2dCAAAAIgAAAABAAAAAQAEQFEZ2FzcAAAAiQAAAAIAAAACP//AANnbHlmAAACLAAAAQoAAAGkrRHP9WhlYWQAAAM4AAAAMAAAADYPK8YyaGhlYQAAA2gAAAAdAAAAJANCAb1obXR4AAADiAAAACIAAAAiCBkAOGxvY2EAAAOsAAAAFAAAABQBnAIybWF4cAAAA8AAAAAfAAAAIAEVAF5uYW1lAAAD4AAAATAAAAKMFGlj5HBvc3QAAAUQAAAARgAAAHJoedjqd2ViZgAABVgAAAAGAAAABrO7W5UAAAABAAAAANXulPUAAAAA1r4hgAAAAADXu2Q1eNpjYGRgYOABYjEgZmJgBEIOIGYB8xgAA/YAN3jaY2BktGOcwMDKwMI4jTGNgYHBHUp/ZZBkaGFgYGJgZWbACgLSXFMYHFT/fLjFeOD/AQY9xjMMbkBhRpAcAN48DQYAeNpjYGBgZoBgGQZGBhDwAfIYwXwWBgMgzQGETAwMqn8+8H649f8/lHX9//9b7Pzf+fWgusCAkY0BzmUE6gHpQwGMDMMeAACbxg7SAAARAUQAAAAB//8AAnjadZBPSsNAGMXfS+yMqYgOhpSuSlKadmUhiVEhEMQzFF22m17BbbvzCh5BXCUn6EG8gjeQ4DepwYo4i+/ffL95j4EDA+CFC7jQuKyIeVHrI3wkleq9F7XrSInKteOeHdda8bOoaeepSc00NWPz/LRec9G8GabyGtEdF7h19z033GAMTK7zbM42xNEZpzYof0RtQ5CUHAQJ73OtVyutc+3b7Ou//b8XNlsPx3jgjUifABdhEohKJJL5iM5p39uqc7X1+sRQSqmGrUVhlsJ4lpmEUVwyT8SUYtg0P9DyNzPADDs+tjrGV6KRCRfsui3eHcL4/p8ZXvfMlcnEU+CLv7hDykOP+AKTPTxbAAB42mNgZGBgAGKuf5KP4vltvjLIMzGAwLV9ig0g+vruFFMQzdjACOJzMIClARh0CTJ42mNgZGBgPPD/AJD8wgAEjA0MjAyogAMAbOQEAQAAAAC7ABEAAAAAAKoAAAH0AAABgAAAAUAACAFAAAgAwAAXAAAAAAAAACoAKgAqADIAbACGAKAAugDSeNpjYGRgYOBkUGFgYgABEMkFhAwM/xn0QAIADdUBdAB42qWQvUoDQRSFv3GjaISUQaymSmGxJoGAsRC0iPYLsU50Y6IxrvlRtPCJJKUPIBb+PIHv4EN4djKuKAqCDHfmu+feOdwZoMCUAJNbAlYUMzaUlM14jjxbngOq7HnOia89z1Pk1vMCa9x7ztPkzfMyJbPj+ZGi6Xp+omxuPD+zaD7meaFg7mb8GrBqHmhwxoAxlm0uiRkpP9X5m26pKRoMxTGR1D49Dv/Yb/91o6l8qL6eu5n2hZQzn68utR9m3FU2cB4t9cdSLG2utI+44Eh/P9bqKO+oJ/WxmXssj77YkrjasZQD6SFddythk3Wtzrf+UF2p076Udla1VNzsERP3kkjVRKel7mp1udXYcHtZSlV7RfmJe1GiFWveluaeKD5/MuJcSk8Tpm/vvwPIbmJleNpjYGKAAFYG7ICTgYGRiZGZkYWRlZGNkZ2Rg5GTLT2nsiDDEEIZsZfmZRqZujmDaDcDAxcI7WIOpS2gtCWUdgQAZkcSmQAAAAFblbO6AAA=) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.ui.dropdown > .dropdown.icon {\n  font-family: 'Dropdown';\n  line-height: 1;\n  height: 1em;\n  width: 1.23em;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n.ui.dropdown > .dropdown.icon {\n  width: auto;\n}\n\n.ui.dropdown > .dropdown.icon:before {\n  content: '\\F0D7';\n}\n\n/* Sub Menu */\n\n.ui.dropdown .menu .item .dropdown.icon:before {\n  content: '\\F0DA';\n}\n\n.ui.dropdown .item .left.dropdown.icon:before, .ui.dropdown .left.menu .item .dropdown.icon:before {\n  content: \"\\F0D9\";\n}\n\n/* Vertical Menu Dropdown */\n\n.ui.vertical.menu .dropdown.item > .dropdown.icon:before {\n  content: \"\\F0DA\";\n}\n\n.ui.dropdown > .clear.icon:before {\n  content: \"\\F00D\";\n}\n\n/* Icons for Reference (Subsetted in 2.4.0)\n  .dropdown.down:before { content: \"\\f0d7\"; }\n  .dropdown.up:before { content: \"\\f0d8\"; }\n  .dropdown.left:before { content: \"\\f0d9\"; }\n  .dropdown.right:before { content: \"\\f0da\"; }\n  .dropdown.close:before { content: \"\\f00d\"; }\n*/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Video\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Types\n*******************************/\n\n.ui.embed {\n  position: relative;\n  max-width: 100%;\n  height: 0px;\n  overflow: hidden;\n  background: #DEDEDF;\n  padding-bottom: 56.25%;\n}\n\n/*-----------------\n  Embedded Content\n------------------*/\n\n.ui.embed iframe, .ui.embed embed, .ui.embed object {\n  position: absolute;\n  border: none;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  margin: 0em;\n  padding: 0em;\n}\n\n/*-----------------\n      Embed\n------------------*/\n\n.ui.embed > .embed {\n  display: none;\n}\n\n/*--------------\n   Placeholder\n---------------*/\n\n.ui.embed > .placeholder {\n  position: absolute;\n  cursor: pointer;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n}\n\n/*--------------\n      Icon\n---------------*/\n\n.ui.embed > .icon {\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n.ui.embed > .icon:after {\n  position: absolute;\n  top: 0%;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n  content: '';\n  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n  opacity: 0.5;\n  transition: opacity 0.5s ease;\n}\n\n.ui.embed > .icon:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 4;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  color: #FFFFFF;\n  font-size: 6rem;\n  text-shadow: 0px 2px 10px rgba(34, 36, 38, 0.2);\n  transition: opacity 0.5s ease, color 0.5s ease;\n  z-index: 10;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Hover\n---------------*/\n\n.ui.embed .icon:hover:after {\n  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));\n  opacity: 1;\n}\n\n.ui.embed .icon:hover:before {\n  color: #FFFFFF;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.embed > .icon, .ui.active.embed > .placeholder {\n  display: none;\n}\n\n.ui.active.embed > .embed {\n  display: block;\n}\n\n/*******************************\n        Video Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.square.embed {\n  padding-bottom: 100%;\n}\n\n.ui[class*=\"4:3\"].embed {\n  padding-bottom: 75%;\n}\n\n.ui[class*=\"16:9\"].embed {\n  padding-bottom: 56.25%;\n}\n\n.ui[class*=\"21:9\"].embed {\n  padding-bottom: 42.85714286%;\n}\n/*!\n * # Semantic UI 2.4.2 - Modal\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Modal\n*******************************/\n\n.ui.modal {\n  position: absolute;\n  display: none;\n  z-index: 1001;\n  text-align: left;\n  background: #FFFFFF;\n  border: none;\n  box-shadow: 1px 3px 3px 0px rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2);\n  -webkit-transform-origin: 50% 25%;\n  transform-origin: 50% 25%;\n  border-radius: 0.21428571rem;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  will-change: top, left, margin, transform, opacity;\n}\n\n.ui.modal > :first-child:not(.icon), .ui.modal > .icon:first-child + * {\n  border-top-left-radius: 0.21428571rem;\n  border-top-right-radius: 0.21428571rem;\n}\n\n.ui.modal > :last-child {\n  border-bottom-left-radius: 0.21428571rem;\n  border-bottom-right-radius: 0.21428571rem;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/*--------------\n     Close\n---------------*/\n\n.ui.modal > .close {\n  cursor: pointer;\n  position: absolute;\n  top: -2.5rem;\n  right: -2.5rem;\n  z-index: 1;\n  opacity: 0.8;\n  font-size: 1.25em;\n  color: #FFFFFF;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 0.625rem 0rem 0rem 0rem;\n}\n\n.ui.modal > .close:hover {\n  opacity: 1;\n}\n\n/*--------------\n     Header\n---------------*/\n\n.ui.modal > .header {\n  display: block;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  background: #FFFFFF;\n  margin: 0em;\n  padding: 1.25rem 1.5rem;\n  box-shadow: none;\n  color: rgba(0, 0, 0, 0.85);\n  border-bottom: 1px solid #DEDEDF;\n}\n\n.ui.modal > .header:not(.ui) {\n  font-size: 1.42857143rem;\n  line-height: 1.28571429em;\n  font-weight: bold;\n}\n\n/*--------------\n     Content\n---------------*/\n\n.ui.modal > .content {\n  display: block;\n  width: 100%;\n  font-size: 1em;\n  line-height: 1.4;\n  padding: 1.5rem;\n  background: #FFFFFF;\n}\n\n.ui.modal > .image.content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n/* Image */\n\n.ui.modal > .content > .image {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  width: '';\n  -ms-flex-item-align: top;\n  -ms-grid-row-align: top;\n  align-self: top;\n}\n\n.ui.modal > [class*=\"top aligned\"] {\n  -ms-flex-item-align: top;\n  -ms-grid-row-align: top;\n  align-self: top;\n}\n\n.ui.modal > [class*=\"middle aligned\"] {\n  -ms-flex-item-align: middle;\n  -ms-grid-row-align: middle;\n  align-self: middle;\n}\n\n.ui.modal > [class*=\"stretched\"] {\n  -ms-flex-item-align: stretch;\n  -ms-grid-row-align: stretch;\n  align-self: stretch;\n}\n\n/* Description */\n\n.ui.modal > .content > .description {\n  display: block;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  min-width: 0px;\n  -ms-flex-item-align: top;\n  -ms-grid-row-align: top;\n  align-self: top;\n}\n\n.ui.modal > .content > .icon + .description, .ui.modal > .content > .image + .description {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  min-width: '';\n  width: auto;\n  padding-left: 2em;\n}\n\n/*rtl:ignore*/\n\n.ui.modal > .content > .image > i.icon {\n  margin: 0em;\n  opacity: 1;\n  width: auto;\n  line-height: 1;\n  font-size: 8rem;\n}\n\n/*--------------\n     Actions\n---------------*/\n\n.ui.modal > .actions {\n  background: #F9FAFB;\n  padding: 1rem 1rem;\n  border-top: 1px solid #DEDEDF;\n  text-align: right;\n}\n\n.ui.modal .actions > .button {\n  margin-left: 0.75em;\n}\n\n/*-------------------\n       Responsive\n--------------------*/\n\n/* Modal Width */\n\n@media only screen and (max-width: 767px) {\n  .ui.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.modal {\n    width: 88%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.modal {\n    width: 850px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .ui.modal {\n    width: 900px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.modal {\n    width: 950px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n/* Tablet and Mobile */\n\n@media only screen and (max-width: 991px) {\n  .ui.modal > .header {\n    padding-right: 2.25rem;\n  }\n\n  .ui.modal > .close {\n    top: 1.0535rem;\n    right: 1rem;\n    color: rgba(0, 0, 0, 0.8);\n  }\n}\n\n/* Mobile */\n\n@media only screen and (max-width: 767px) {\n  .ui.modal > .header {\n    padding: 0.75rem 1rem !important;\n    padding-right: 2.25rem !important;\n  }\n\n  .ui.modal > .content {\n    display: block;\n    padding: 1rem !important;\n  }\n\n  .ui.modal > .close {\n    top: 0.5rem !important;\n    right: 0.5rem !important;\n  }\n\n  /*rtl:ignore*/\n\n  .ui.modal .image.content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n\n  .ui.modal .content > .image {\n    display: block;\n    max-width: 100%;\n    margin: 0em auto !important;\n    text-align: center;\n    padding: 0rem 0rem 1rem !important;\n  }\n\n  .ui.modal > .content > .image > i.icon {\n    font-size: 5rem;\n    text-align: center;\n  }\n\n  /*rtl:ignore*/\n\n  .ui.modal .content > .description {\n    display: block;\n    width: 100% !important;\n    margin: 0em !important;\n    padding: 1rem 0rem !important;\n    box-shadow: none;\n  }\n\n  /* Let Buttons Stack */\n\n  .ui.modal > .actions {\n    padding: 1rem 1rem 0rem !important;\n  }\n\n  .ui.modal .actions > .buttons, .ui.modal .actions > .button {\n    margin-bottom: 1rem;\n  }\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n.ui.inverted.dimmer > .ui.modal {\n  box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2);\n}\n\n/*******************************\n             Types\n*******************************/\n\n.ui.basic.modal {\n  background-color: transparent;\n  border: none;\n  border-radius: 0em;\n  box-shadow: none !important;\n  color: #FFFFFF;\n}\n\n.ui.basic.modal > .header, .ui.basic.modal > .content, .ui.basic.modal > .actions {\n  background-color: transparent;\n}\n\n.ui.basic.modal > .header {\n  color: #FFFFFF;\n}\n\n.ui.basic.modal > .close {\n  top: 1rem;\n  right: 1.5rem;\n}\n\n.ui.inverted.dimmer > .basic.modal {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.inverted.dimmer > .ui.basic.modal > .header {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/* Resort to margin positioning if legacy */\n\n.ui.legacy.modal, .ui.legacy.page.dimmer > .ui.modal {\n  top: 50%;\n  left: 50%;\n}\n\n.ui.legacy.page.dimmer > .ui.scrolling.modal, .ui.page.dimmer > .ui.scrolling.legacy.modal, .ui.top.aligned.legacy.page.dimmer > .ui.modal, .ui.top.aligned.dimmer > .ui.legacy.modal {\n  top: auto;\n}\n\n/* Tablet and Mobile */\n\n@media only screen and (max-width: 991px) {\n  .ui.basic.modal > .close {\n    color: #FFFFFF;\n  }\n}\n\n/*******************************\n             States\n*******************************/\n\n.ui.loading.modal {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.ui.active.modal {\n  display: block;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n   Top Aligned\n---------------*/\n\n/* Top Aligned Modal */\n\n.modals.dimmer[class*=\"top aligned\"] .modal {\n  margin: 5vh auto;\n}\n\n@media only screen and (max-width: 767px) {\n  .modals.dimmer[class*=\"top aligned\"] .modal {\n    margin: 1rem auto;\n  }\n}\n\n/* Legacy Top Aligned */\n\n.legacy.modals.dimmer[class*=\"top aligned\"] {\n  padding-top: 5vh;\n}\n\n@media only screen and (max-width: 767px) {\n  .legacy.modals.dimmer[class*=\"top aligned\"] {\n    padding-top: 1rem;\n  }\n}\n\n/*--------------\n    Scrolling\n---------------*/\n\n/* Scrolling Dimmer */\n\n.scrolling.dimmable.dimmed {\n  overflow: hidden;\n}\n\n.scrolling.dimmable > .dimmer {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.scrolling.dimmable.dimmed > .dimmer {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrolling.dimmable > .dimmer {\n  position: fixed;\n}\n\n.modals.dimmer .ui.scrolling.modal {\n  margin: 1rem auto;\n}\n\n/* Undetached Scrolling */\n\n.scrolling.undetached.dimmable.dimmed {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrolling.undetached.dimmable.dimmed > .dimmer {\n  overflow: hidden;\n}\n\n.scrolling.undetached.dimmable .ui.scrolling.modal {\n  position: absolute;\n  left: 50%;\n  margin-top: 1rem !important;\n}\n\n/* Scrolling Content */\n\n.ui.modal .scrolling.content {\n  max-height: calc(80vh - 10em);\n  overflow: auto;\n}\n\n/*--------------\n   Full Screen\n---------------*/\n\n.ui.fullscreen.modal {\n  width: 95% !important;\n  margin: 1em auto;\n}\n\n.ui.fullscreen.modal > .header {\n  padding-right: 2.25rem;\n}\n\n.ui.fullscreen.modal > .close {\n  top: 1.0535rem;\n  right: 1rem;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*--------------\n      Size\n---------------*/\n\n.ui.modal {\n  font-size: 1rem;\n}\n\n/* Mini */\n\n.ui.mini.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n\n/* Mini Modal Width */\n\n@media only screen and (max-width: 767px) {\n  .ui.mini.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.mini.modal {\n    width: 35.2%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.mini.modal {\n    width: 340px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .ui.mini.modal {\n    width: 360px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.mini.modal {\n    width: 380px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n/* mini */\n\n.ui.small.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n\n/* Tiny Modal Width */\n\n@media only screen and (max-width: 767px) {\n  .ui.tiny.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.tiny.modal {\n    width: 52.8%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.tiny.modal {\n    width: 510px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .ui.tiny.modal {\n    width: 540px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.tiny.modal {\n    width: 570px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n/* Small */\n\n.ui.small.modal > .header:not(.ui) {\n  font-size: 1.3em;\n}\n\n/* Small Modal Width */\n\n@media only screen and (max-width: 767px) {\n  .ui.small.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.small.modal {\n    width: 70.4%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.small.modal {\n    width: 680px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .ui.small.modal {\n    width: 720px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.small.modal {\n    width: 760px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n/* Large Modal Width */\n\n.ui.large.modal > .header {\n  font-size: 1.6em;\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.large.modal {\n    width: 95%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .ui.large.modal {\n    width: 88%;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .ui.large.modal {\n    width: 1020px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .ui.large.modal {\n    width: 1080px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .ui.large.modal {\n    width: 1140px;\n    margin: 0em 0em 0em 0em;\n  }\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Nag\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Nag\n*******************************/\n\n.ui.nag {\n  display: none;\n  opacity: 0.95;\n  position: relative;\n  top: 0em;\n  left: 0px;\n  z-index: 999;\n  min-height: 0em;\n  width: 100%;\n  margin: 0em;\n  padding: 0.75em 1em;\n  background: #555555;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);\n  font-size: 1rem;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n  transition: 0.2s background ease;\n}\n\na.ui.nag {\n  cursor: pointer;\n}\n\n.ui.nag > .title {\n  display: inline-block;\n  margin: 0em 0.5em;\n  color: #FFFFFF;\n}\n\n.ui.nag > .close.icon {\n  cursor: pointer;\n  opacity: 0.4;\n  position: absolute;\n  top: 50%;\n  right: 1em;\n  font-size: 1em;\n  margin: -0.5em 0em 0em;\n  color: #FFFFFF;\n  transition: opacity 0.2s ease;\n}\n\n/*******************************\n             States\n*******************************/\n\n/* Hover */\n\n.ui.nag:hover {\n  background: #555555;\n  opacity: 1;\n}\n\n.ui.nag .close:hover {\n  opacity: 1;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n     Static\n---------------*/\n\n.ui.overlay.nag {\n  position: absolute;\n  display: block;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.ui.fixed.nag {\n  position: fixed;\n}\n\n/*--------------\n     Bottom\n---------------*/\n\n.ui.bottom.nags, .ui.bottom.nag {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n  top: auto;\n  bottom: 0em;\n}\n\n/*--------------\n     White\n---------------*/\n\n.ui.inverted.nags .nag, .ui.inverted.nag {\n  background-color: #F3F4F5;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.inverted.nags .nag .close, .ui.inverted.nags .nag .title, .ui.inverted.nag .close, .ui.inverted.nag .title {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n/*******************************\n           Groups\n*******************************/\n\n.ui.nags .nag {\n  border-radius: 0em !important;\n}\n\n.ui.nags .nag:last-child {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui.bottom.nags .nag:last-child {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Popup\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Popup\n*******************************/\n\n.ui.popup {\n  display: none;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  /* Fixes content being squished when inline (moz only) */\n  min-width: -webkit-min-content;\n  min-width: -moz-min-content;\n  min-width: min-content;\n  z-index: 1900;\n  border: 1px solid #DEDEDF;\n  line-height: 1.4285em;\n  max-width: 250px;\n  background: #FFFFFF;\n  padding: 0.833em 1em;\n  font-weight: normal;\n  font-style: normal;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0.21428571rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n}\n\n.ui.popup > .header {\n  padding: 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1.14285714em;\n  line-height: 1.2;\n  font-weight: bold;\n}\n\n.ui.popup > .header + .content {\n  padding-top: 0.5em;\n}\n\n.ui.popup:before {\n  position: absolute;\n  content: '';\n  width: 0.71428571em;\n  height: 0.71428571em;\n  background: #FFFFFF;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  z-index: 2;\n  box-shadow: 1px 1px 0px 0px #c4c4c6;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/*--------------\n    Tooltip\n---------------*/\n\n/* Content */\n\n[data-tooltip] {\n  position: relative;\n}\n\n/* Arrow */\n\n[data-tooltip]:before {\n  pointer-events: none;\n  position: absolute;\n  content: '';\n  font-size: 1rem;\n  width: 0.71428571em;\n  height: 0.71428571em;\n  background: #FFFFFF;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  z-index: 2;\n  box-shadow: 1px 1px 0px 0px #c4c4c6;\n}\n\n/* Popup */\n\n[data-tooltip]:after {\n  pointer-events: none;\n  content: attr(data-tooltip);\n  position: absolute;\n  text-transform: none;\n  text-align: left;\n  white-space: nowrap;\n  font-size: 1rem;\n  border: 1px solid #DEDEDF;\n  line-height: 1.4285em;\n  max-width: none;\n  background: #FFFFFF;\n  padding: 0.833em 1em;\n  font-weight: normal;\n  font-style: normal;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: 0.21428571rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n  z-index: 1;\n}\n\n/* Default Position (Top Center) */\n\n[data-tooltip]:not([data-position]):before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: #FFFFFF;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n\n[data-tooltip]:not([data-position]):after {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n\n/* Animation */\n\n[data-tooltip]:before, [data-tooltip]:after {\n  pointer-events: none;\n  visibility: hidden;\n}\n\n[data-tooltip]:before {\n  opacity: 0;\n  -webkit-transform: rotate(45deg) scale(0) !important;\n  transform: rotate(45deg) scale(0) !important;\n  -webkit-transform-origin: center top;\n  transform-origin: center top;\n  transition: all 0.1s ease;\n}\n\n[data-tooltip]:after {\n  opacity: 1;\n  -webkit-transform-origin: center bottom;\n  transform-origin: center bottom;\n  transition: all 0.1s ease;\n}\n\n[data-tooltip]:hover:before, [data-tooltip]:hover:after {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n[data-tooltip]:hover:before {\n  -webkit-transform: rotate(45deg) scale(1) !important;\n  transform: rotate(45deg) scale(1) !important;\n  opacity: 1;\n}\n\n/* Animation Position */\n\n[data-tooltip]:after, [data-tooltip][data-position=\"top center\"]:after, [data-tooltip][data-position=\"bottom center\"]:after {\n  -webkit-transform: translateX(-50%) scale(0) !important;\n  transform: translateX(-50%) scale(0) !important;\n}\n\n[data-tooltip]:hover:after, [data-tooltip][data-position=\"bottom center\"]:hover:after {\n  -webkit-transform: translateX(-50%) scale(1) !important;\n  transform: translateX(-50%) scale(1) !important;\n}\n\n[data-tooltip][data-position=\"left center\"]:after, [data-tooltip][data-position=\"right center\"]:after {\n  -webkit-transform: translateY(-50%) scale(0) !important;\n  transform: translateY(-50%) scale(0) !important;\n}\n\n[data-tooltip][data-position=\"left center\"]:hover:after, [data-tooltip][data-position=\"right center\"]:hover:after {\n  -webkit-transform: translateY(-50%) scale(1) !important;\n  transform: translateY(-50%) scale(1) !important;\n}\n\n[data-tooltip][data-position=\"top left\"]:after, [data-tooltip][data-position=\"top right\"]:after, [data-tooltip][data-position=\"bottom left\"]:after, [data-tooltip][data-position=\"bottom right\"]:after {\n  -webkit-transform: scale(0) !important;\n  transform: scale(0) !important;\n}\n\n[data-tooltip][data-position=\"top left\"]:hover:after, [data-tooltip][data-position=\"top right\"]:hover:after, [data-tooltip][data-position=\"bottom left\"]:hover:after, [data-tooltip][data-position=\"bottom right\"]:hover:after {\n  -webkit-transform: scale(1) !important;\n  transform: scale(1) !important;\n}\n\n/*--------------\n    Inverted\n---------------*/\n\n/* Arrow */\n\n[data-tooltip][data-inverted]:before {\n  box-shadow: none !important;\n}\n\n/* Arrow Position */\n\n[data-tooltip][data-inverted]:before {\n  background: #1B1C1D;\n}\n\n/* Popup  */\n\n[data-tooltip][data-inverted]:after {\n  background: #1B1C1D;\n  color: #FFFFFF;\n  border: none;\n  box-shadow: none;\n}\n\n[data-tooltip][data-inverted]:after .header {\n  background-color: none;\n  color: #FFFFFF;\n}\n\n/*--------------\n    Position\n---------------*/\n\n/* Top Center */\n\n[data-position=\"top center\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 50%;\n  bottom: 100%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  margin-bottom: 0.5em;\n}\n\n[data-position=\"top center\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 50%;\n  background: #FFFFFF;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n\n/* Top Left */\n\n[data-position=\"top left\"][data-tooltip]:after {\n  top: auto;\n  right: auto;\n  left: 0;\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n\n[data-position=\"top left\"][data-tooltip]:before {\n  top: auto;\n  right: auto;\n  bottom: 100%;\n  left: 1em;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n\n/* Top Right */\n\n[data-position=\"top right\"][data-tooltip]:after {\n  top: auto;\n  left: auto;\n  right: 0;\n  bottom: 100%;\n  margin-bottom: 0.5em;\n}\n\n[data-position=\"top right\"][data-tooltip]:before {\n  top: auto;\n  left: auto;\n  bottom: 100%;\n  right: 1em;\n  margin-left: -0.07142857rem;\n  margin-bottom: 0.14285714rem;\n}\n\n/* Bottom Center */\n\n[data-position=\"bottom center\"][data-tooltip]:after {\n  bottom: auto;\n  right: auto;\n  left: 50%;\n  top: 100%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  margin-top: 0.5em;\n}\n\n[data-position=\"bottom center\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: 50%;\n  margin-left: -0.07142857rem;\n  margin-top: 0.14285714rem;\n}\n\n/* Bottom Left */\n\n[data-position=\"bottom left\"][data-tooltip]:after {\n  left: 0;\n  top: 100%;\n  margin-top: 0.5em;\n}\n\n[data-position=\"bottom left\"][data-tooltip]:before {\n  bottom: auto;\n  right: auto;\n  top: 100%;\n  left: 1em;\n  margin-left: -0.07142857rem;\n  margin-top: 0.14285714rem;\n}\n\n/* Bottom Right */\n\n[data-position=\"bottom right\"][data-tooltip]:after {\n  right: 0;\n  top: 100%;\n  margin-top: 0.5em;\n}\n\n[data-position=\"bottom right\"][data-tooltip]:before {\n  bottom: auto;\n  left: auto;\n  top: 100%;\n  right: 1em;\n  margin-left: -0.14285714rem;\n  margin-top: 0.07142857rem;\n}\n\n/* Left Center */\n\n[data-position=\"left center\"][data-tooltip]:after {\n  right: 100%;\n  top: 50%;\n  margin-right: 0.5em;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n[data-position=\"left center\"][data-tooltip]:before {\n  right: 100%;\n  top: 50%;\n  margin-top: -0.14285714rem;\n  margin-right: -0.07142857rem;\n}\n\n/* Right Center */\n\n[data-position=\"right center\"][data-tooltip]:after {\n  left: 100%;\n  top: 50%;\n  margin-left: 0.5em;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n[data-position=\"right center\"][data-tooltip]:before {\n  left: 100%;\n  top: 50%;\n  margin-top: -0.07142857rem;\n  margin-left: 0.14285714rem;\n}\n\n/* Arrow */\n\n[data-position~=\"bottom\"][data-tooltip]:before {\n  background: #FFFFFF;\n  box-shadow: -1px -1px 0px 0px #c4c4c6;\n}\n\n[data-position=\"left center\"][data-tooltip]:before {\n  background: #FFFFFF;\n  box-shadow: 1px -1px 0px 0px #c4c4c6;\n}\n\n[data-position=\"right center\"][data-tooltip]:before {\n  background: #FFFFFF;\n  box-shadow: -1px 1px 0px 0px #c4c4c6;\n}\n\n[data-position~=\"top\"][data-tooltip]:before {\n  background: #FFFFFF;\n}\n\n/* Inverted Arrow Color */\n\n[data-inverted][data-position~=\"bottom\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: -1px -1px 0px 0px #c4c4c6;\n}\n\n[data-inverted][data-position=\"left center\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: 1px -1px 0px 0px #c4c4c6;\n}\n\n[data-inverted][data-position=\"right center\"][data-tooltip]:before {\n  background: #1B1C1D;\n  box-shadow: -1px 1px 0px 0px #c4c4c6;\n}\n\n[data-inverted][data-position~=\"top\"][data-tooltip]:before {\n  background: #1B1C1D;\n}\n\n[data-position~=\"bottom\"][data-tooltip]:before {\n  -webkit-transform-origin: center bottom;\n  transform-origin: center bottom;\n}\n\n[data-position~=\"bottom\"][data-tooltip]:after {\n  -webkit-transform-origin: center top;\n  transform-origin: center top;\n}\n\n[data-position=\"left center\"][data-tooltip]:before {\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n}\n\n[data-position=\"left center\"][data-tooltip]:after {\n  -webkit-transform-origin: right center;\n  transform-origin: right center;\n}\n\n[data-position=\"right center\"][data-tooltip]:before {\n  -webkit-transform-origin: right center;\n  transform-origin: right center;\n}\n\n[data-position=\"right center\"][data-tooltip]:after {\n  -webkit-transform-origin: left center;\n  transform-origin: left center;\n}\n\n/*--------------\n     Spacing\n---------------*/\n\n.ui.popup {\n  margin: 0em;\n}\n\n/* Extending from Top */\n\n.ui.top.popup {\n  margin: 0em 0em 0.71428571em;\n}\n\n.ui.top.left.popup {\n  -webkit-transform-origin: left bottom;\n  transform-origin: left bottom;\n}\n\n.ui.top.center.popup {\n  -webkit-transform-origin: center bottom;\n  transform-origin: center bottom;\n}\n\n.ui.top.right.popup {\n  -webkit-transform-origin: right bottom;\n  transform-origin: right bottom;\n}\n\n/* Extending from Vertical Center */\n\n.ui.left.center.popup {\n  margin: 0em 0.71428571em 0em 0em;\n  -webkit-transform-origin: right 50%;\n  transform-origin: right 50%;\n}\n\n.ui.right.center.popup {\n  margin: 0em 0em 0em 0.71428571em;\n  -webkit-transform-origin: left 50%;\n  transform-origin: left 50%;\n}\n\n/* Extending from Bottom */\n\n.ui.bottom.popup {\n  margin: 0.71428571em 0em 0em;\n}\n\n.ui.bottom.left.popup {\n  -webkit-transform-origin: left top;\n  transform-origin: left top;\n}\n\n.ui.bottom.center.popup {\n  -webkit-transform-origin: center top;\n  transform-origin: center top;\n}\n\n.ui.bottom.right.popup {\n  -webkit-transform-origin: right top;\n  transform-origin: right top;\n}\n\n/*--------------\n     Pointer\n---------------*/\n\n/*--- Below ---*/\n\n.ui.bottom.center.popup:before {\n  margin-left: -0.30714286em;\n  top: -0.30714286em;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  box-shadow: -1px -1px 0px 0px #c4c4c6;\n}\n\n.ui.bottom.left.popup {\n  margin-left: 0em;\n}\n\n/*rtl:rename*/\n\n.ui.bottom.left.popup:before {\n  top: -0.30714286em;\n  left: 1em;\n  right: auto;\n  bottom: auto;\n  margin-left: 0em;\n  box-shadow: -1px -1px 0px 0px #c4c4c6;\n}\n\n.ui.bottom.right.popup {\n  margin-right: 0em;\n}\n\n/*rtl:rename*/\n\n.ui.bottom.right.popup:before {\n  top: -0.30714286em;\n  right: 1em;\n  bottom: auto;\n  left: auto;\n  margin-left: 0em;\n  box-shadow: -1px -1px 0px 0px #c4c4c6;\n}\n\n/*--- Above ---*/\n\n.ui.top.center.popup:before {\n  top: auto;\n  right: auto;\n  bottom: -0.30714286em;\n  left: 50%;\n  margin-left: -0.30714286em;\n}\n\n.ui.top.left.popup {\n  margin-left: 0em;\n}\n\n/*rtl:rename*/\n\n.ui.top.left.popup:before {\n  bottom: -0.30714286em;\n  left: 1em;\n  top: auto;\n  right: auto;\n  margin-left: 0em;\n}\n\n.ui.top.right.popup {\n  margin-right: 0em;\n}\n\n/*rtl:rename*/\n\n.ui.top.right.popup:before {\n  bottom: -0.30714286em;\n  right: 1em;\n  top: auto;\n  left: auto;\n  margin-left: 0em;\n}\n\n/*--- Left Center ---*/\n\n/*rtl:rename*/\n\n.ui.left.center.popup:before {\n  top: 50%;\n  right: -0.30714286em;\n  bottom: auto;\n  left: auto;\n  margin-top: -0.30714286em;\n  box-shadow: 1px -1px 0px 0px #c4c4c6;\n}\n\n/*--- Right Center  ---*/\n\n/*rtl:rename*/\n\n.ui.right.center.popup:before {\n  top: 50%;\n  left: -0.30714286em;\n  bottom: auto;\n  right: auto;\n  margin-top: -0.30714286em;\n  box-shadow: -1px 1px 0px 0px #c4c4c6;\n}\n\n/* Arrow Color By Location */\n\n.ui.bottom.popup:before {\n  background: #FFFFFF;\n}\n\n.ui.right.center.popup:before, .ui.left.center.popup:before {\n  background: #FFFFFF;\n}\n\n.ui.top.popup:before {\n  background: #FFFFFF;\n}\n\n/* Inverted Arrow Color */\n\n.ui.inverted.bottom.popup:before {\n  background: #1B1C1D;\n}\n\n.ui.inverted.right.center.popup:before, .ui.inverted.left.center.popup:before {\n  background: #1B1C1D;\n}\n\n.ui.inverted.top.popup:before {\n  background: #1B1C1D;\n}\n\n/*******************************\n            Coupling\n*******************************/\n\n/* Immediate Nested Grid */\n\n.ui.popup > .ui.grid:not(.padded) {\n  width: calc(100% + 1.75rem);\n  margin: -0.7rem -0.875rem;\n}\n\n/*******************************\n            States\n*******************************/\n\n.ui.loading.popup {\n  display: block;\n  visibility: hidden;\n  z-index: -1;\n}\n\n.ui.animating.popup, .ui.visible.popup {\n  display: block;\n}\n\n.ui.visible.popup {\n  -webkit-transform: translateZ(0px);\n  transform: translateZ(0px);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n/*******************************\n            Variations\n*******************************/\n\n/*--------------\n     Basic\n---------------*/\n\n.ui.basic.popup:before {\n  display: none;\n}\n\n/*--------------\n     Wide\n---------------*/\n\n.ui.wide.popup {\n  max-width: 350px;\n}\n\n.ui[class*=\"very wide\"].popup {\n  max-width: 550px;\n}\n\n@media only screen and (max-width: 767px) {\n  .ui.wide.popup, .ui[class*=\"very wide\"].popup {\n    max-width: 250px;\n  }\n}\n\n/*--------------\n     Fluid\n---------------*/\n\n.ui.fluid.popup {\n  width: 100%;\n  max-width: none;\n}\n\n/*--------------\n     Colors\n---------------*/\n\n/* Inverted colors  */\n\n.ui.inverted.popup {\n  background: #1B1C1D;\n  color: #FFFFFF;\n  border: none;\n  box-shadow: none;\n}\n\n.ui.inverted.popup .header {\n  background-color: none;\n  color: #FFFFFF;\n}\n\n.ui.inverted.popup:before {\n  background-color: #1B1C1D;\n  box-shadow: none !important;\n}\n\n/*--------------\n     Flowing\n---------------*/\n\n.ui.flowing.popup {\n  max-width: none;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.mini.popup {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.popup {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.popup {\n  font-size: 0.92857143rem;\n}\n\n.ui.popup {\n  font-size: 1rem;\n}\n\n.ui.large.popup {\n  font-size: 1.14285714rem;\n}\n\n.ui.huge.popup {\n  font-size: 1.42857143rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Progress Bar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Progress\n*******************************/\n\n.ui.progress {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  border: none;\n  margin: 1em 0em 2.5em;\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 0em;\n  border-radius: 0.21428571rem;\n}\n\n.ui.progress:first-child {\n  margin: 0em 0em 2.5em;\n}\n\n.ui.progress:last-child {\n  margin: 0em 0em 1.5em;\n}\n\n/*******************************\n            Content\n*******************************/\n\n/* Activity Bar */\n\n.ui.progress .bar {\n  display: block;\n  line-height: 1;\n  position: relative;\n  width: 0%;\n  min-width: 2em;\n  background: #888888;\n  border-radius: 0.21428571rem;\n  transition: width 0.1s ease, background-color 0.1s ease;\n}\n\n/* Percent Complete */\n\n.ui.progress .bar > .progress {\n  white-space: nowrap;\n  position: absolute;\n  width: auto;\n  font-size: 0.92857143em;\n  top: 50%;\n  right: 0.5em;\n  left: auto;\n  bottom: auto;\n  color: rgba(255, 255, 255, 0.7);\n  text-shadow: none;\n  margin-top: -0.5em;\n  font-weight: bold;\n  text-align: left;\n}\n\n/* Label */\n\n.ui.progress > .label {\n  position: absolute;\n  width: 100%;\n  font-size: 1em;\n  top: 100%;\n  right: auto;\n  left: 0%;\n  bottom: auto;\n  color: rgba(0, 0, 0, 0.8);\n  font-weight: bold;\n  text-shadow: none;\n  margin-top: 0.2em;\n  text-align: center;\n  transition: color 0.4s ease;\n}\n\n/*******************************\n            Types\n*******************************/\n\n/* Indicating */\n\n.ui.indicating.progress[data-percent^=\"1\"] .bar, .ui.indicating.progress[data-percent^=\"2\"] .bar {\n  background-color: #D95C5C;\n}\n\n.ui.indicating.progress[data-percent^=\"3\"] .bar {\n  background-color: #EFBC72;\n}\n\n.ui.indicating.progress[data-percent^=\"4\"] .bar, .ui.indicating.progress[data-percent^=\"5\"] .bar {\n  background-color: #E6BB48;\n}\n\n.ui.indicating.progress[data-percent^=\"6\"] .bar {\n  background-color: #DDC928;\n}\n\n.ui.indicating.progress[data-percent^=\"7\"] .bar, .ui.indicating.progress[data-percent^=\"8\"] .bar {\n  background-color: #B4D95C;\n}\n\n.ui.indicating.progress[data-percent^=\"9\"] .bar, .ui.indicating.progress[data-percent^=\"100\"] .bar {\n  background-color: #66DA81;\n}\n\n/* Indicating Label */\n\n.ui.indicating.progress[data-percent^=\"1\"] .label, .ui.indicating.progress[data-percent^=\"2\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.indicating.progress[data-percent^=\"3\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.indicating.progress[data-percent^=\"4\"] .label, .ui.indicating.progress[data-percent^=\"5\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.indicating.progress[data-percent^=\"6\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.indicating.progress[data-percent^=\"7\"] .label, .ui.indicating.progress[data-percent^=\"8\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.indicating.progress[data-percent^=\"9\"] .label, .ui.indicating.progress[data-percent^=\"100\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Single Digits */\n\n.ui.indicating.progress[data-percent=\"1\"] .bar, .ui.indicating.progress[data-percent=\"2\"] .bar, .ui.indicating.progress[data-percent=\"3\"] .bar, .ui.indicating.progress[data-percent=\"4\"] .bar, .ui.indicating.progress[data-percent=\"5\"] .bar, .ui.indicating.progress[data-percent=\"6\"] .bar, .ui.indicating.progress[data-percent=\"7\"] .bar, .ui.indicating.progress[data-percent=\"8\"] .bar, .ui.indicating.progress[data-percent=\"9\"] .bar {\n  background-color: #D95C5C;\n}\n\n.ui.indicating.progress[data-percent=\"1\"] .label, .ui.indicating.progress[data-percent=\"2\"] .label, .ui.indicating.progress[data-percent=\"3\"] .label, .ui.indicating.progress[data-percent=\"4\"] .label, .ui.indicating.progress[data-percent=\"5\"] .label, .ui.indicating.progress[data-percent=\"6\"] .label, .ui.indicating.progress[data-percent=\"7\"] .label, .ui.indicating.progress[data-percent=\"8\"] .label, .ui.indicating.progress[data-percent=\"9\"] .label {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* Indicating Success */\n\n.ui.indicating.progress.success .label {\n  color: #1A531B;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n     Success\n---------------*/\n\n.ui.progress.success .bar {\n  background-color: #59D98D !important;\n}\n\n.ui.progress.success .bar, .ui.progress.success .bar::after {\n  -webkit-animation: none !important;\n  animation: none !important;\n}\n\n.ui.progress.success > .label {\n  color: #1A531B;\n}\n\n/*--------------\n     Warning\n---------------*/\n\n.ui.progress.warning .bar {\n  background-color: #F2C037 !important;\n}\n\n.ui.progress.warning .bar, .ui.progress.warning .bar::after {\n  -webkit-animation: none !important;\n  animation: none !important;\n}\n\n.ui.progress.warning > .label {\n  color: #794B02;\n}\n\n/*--------------\n     Error\n---------------*/\n\n.ui.progress.error .bar {\n  background-color: #DB2828 !important;\n}\n\n.ui.progress.error .bar, .ui.progress.error .bar::after {\n  -webkit-animation: none !important;\n  animation: none !important;\n}\n\n.ui.progress.error > .label {\n  color: #912D2B;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.active.progress .bar {\n  position: relative;\n  min-width: 2em;\n}\n\n.ui.active.progress .bar::after {\n  content: '';\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background: #FFFFFF;\n  border-radius: 0.21428571rem;\n  -webkit-animation: progress-active 2s ease infinite;\n  animation: progress-active 2s ease infinite;\n}\n\n@-webkit-keyframes progress-active {\n  0% {\n    opacity: 0.3;\n    width: 0;\n  }\n\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: 0.3;\n    width: 0;\n  }\n\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n\n/*--------------\n    Disabled\n---------------*/\n\n.ui.disabled.progress {\n  opacity: 0.35;\n}\n\n.ui.disabled.progress .bar, .ui.disabled.progress .bar::after {\n  -webkit-animation: none !important;\n  animation: none !important;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*--------------\n    Inverted\n---------------*/\n\n.ui.inverted.progress {\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n}\n\n.ui.inverted.progress .bar {\n  background: #888888;\n}\n\n.ui.inverted.progress .bar > .progress {\n  color: #F9FAFB;\n}\n\n.ui.inverted.progress > .label {\n  color: #FFFFFF;\n}\n\n.ui.inverted.progress.success > .label {\n  color: #59D98D;\n}\n\n.ui.inverted.progress.warning > .label {\n  color: #F2C037;\n}\n\n.ui.inverted.progress.error > .label {\n  color: #DB2828;\n}\n\n/*--------------\n    Attached\n---------------*/\n\n/* bottom attached */\n\n.ui.progress.attached {\n  background: transparent;\n  position: relative;\n  border: none;\n  margin: 0em;\n}\n\n.ui.progress.attached, .ui.progress.attached .bar {\n  display: block;\n  height: 0.2rem;\n  padding: 0px;\n  overflow: hidden;\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n.ui.progress.attached .bar {\n  border-radius: 0em;\n}\n\n/* top attached */\n\n.ui.progress.top.attached, .ui.progress.top.attached .bar {\n  top: 0px;\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.progress.top.attached .bar {\n  border-radius: 0em;\n}\n\n/* Coupling */\n\n.ui.segment > .ui.attached.progress, .ui.card > .ui.attached.progress {\n  position: absolute;\n  top: auto;\n  left: 0;\n  bottom: 100%;\n  width: 100%;\n}\n\n.ui.segment > .ui.bottom.attached.progress, .ui.card > .ui.bottom.attached.progress {\n  top: 100%;\n  bottom: auto;\n}\n\n/*--------------\n     Colors\n---------------*/\n\n/* Red */\n\n.ui.red.progress .bar {\n  background-color: #DB2828;\n}\n\n.ui.red.inverted.progress .bar {\n  background-color: #FF695E;\n}\n\n/* Orange */\n\n.ui.orange.progress .bar {\n  background-color: #FF9F5B;\n}\n\n.ui.orange.inverted.progress .bar {\n  background-color: #FF851B;\n}\n\n/* Yellow */\n\n.ui.yellow.progress .bar {\n  background-color: #F9DC5C;\n}\n\n.ui.yellow.inverted.progress .bar {\n  background-color: #FFE21F;\n}\n\n/* Olive */\n\n.ui.olive.progress .bar {\n  background-color: #B5CC18;\n}\n\n.ui.olive.inverted.progress .bar {\n  background-color: #D9E778;\n}\n\n/* Green */\n\n.ui.green.progress .bar {\n  background-color: #59D98D;\n}\n\n.ui.green.inverted.progress .bar {\n  background-color: #2ECC40;\n}\n\n/* Teal */\n\n.ui.teal.progress .bar {\n  background-color: #00B5AD;\n}\n\n.ui.teal.inverted.progress .bar {\n  background-color: #6DFFFF;\n}\n\n/* Blue */\n\n.ui.blue.progress .bar {\n  background-color: #2185D0;\n}\n\n.ui.blue.inverted.progress .bar {\n  background-color: #54C8FF;\n}\n\n/* Violet */\n\n.ui.violet.progress .bar {\n  background-color: #6435C9;\n}\n\n.ui.violet.inverted.progress .bar {\n  background-color: #A291FB;\n}\n\n/* Purple */\n\n.ui.purple.progress .bar {\n  background-color: #A333C8;\n}\n\n.ui.purple.inverted.progress .bar {\n  background-color: #DC73FF;\n}\n\n/* Pink */\n\n.ui.pink.progress .bar {\n  background-color: #E03997;\n}\n\n.ui.pink.inverted.progress .bar {\n  background-color: #FF8EDF;\n}\n\n/* Brown */\n\n.ui.brown.progress .bar {\n  background-color: #A5673F;\n}\n\n.ui.brown.inverted.progress .bar {\n  background-color: #D67C1C;\n}\n\n/* Grey */\n\n.ui.grey.progress .bar {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.grey.inverted.progress .bar {\n  background-color: #DEDEDF;\n}\n\n/* Black */\n\n.ui.black.progress .bar {\n  background-color: #1B1C1D;\n}\n\n.ui.black.inverted.progress .bar {\n  background-color: #545454;\n}\n\n/*--------------\n     Sizes\n---------------*/\n\n.ui.tiny.progress {\n  font-size: 0.85714286rem;\n}\n\n.ui.tiny.progress .bar {\n  height: 0.5em;\n}\n\n.ui.small.progress {\n  font-size: 0.92857143rem;\n}\n\n.ui.small.progress .bar {\n  height: 1em;\n}\n\n.ui.progress {\n  font-size: 1rem;\n}\n\n.ui.progress .bar {\n  height: 1.75em;\n}\n\n.ui.large.progress {\n  font-size: 1.14285714rem;\n}\n\n.ui.large.progress .bar {\n  height: 2.5em;\n}\n\n.ui.big.progress {\n  font-size: 1.28571429rem;\n}\n\n.ui.big.progress .bar {\n  height: 3.5em;\n}\n\n/*******************************\n            Progress\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Rating\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           Rating\n*******************************/\n\n.ui.rating {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  white-space: nowrap;\n  vertical-align: baseline;\n}\n\n.ui.rating:last-child {\n  margin-right: 0em;\n}\n\n/* Icon */\n\n.ui.rating .icon {\n  padding: 0em;\n  margin: 0em;\n  text-align: center;\n  font-weight: normal;\n  font-style: normal;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  cursor: pointer;\n  width: 1.25em;\n  height: auto;\n  transition: opacity 0.1s ease, background 0.1s ease, text-shadow 0.1s ease, color 0.1s ease;\n}\n\n/*******************************\n             Types\n*******************************/\n\n/*-------------------\n      Standard\n--------------------*/\n\n/* Inactive Icon */\n\n.ui.rating .icon {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n}\n\n/* Active Icon */\n\n.ui.rating .active.icon {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/* Selected Icon */\n\n.ui.rating .icon.selected, .ui.rating .icon.selected.active {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/*-------------------\n        Star\n--------------------*/\n\n/* Inactive */\n\n.ui.star.rating .icon {\n  width: 1.25em;\n  height: auto;\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n  text-shadow: none;\n}\n\n/* Active Star */\n\n.ui.star.rating .active.icon {\n  background: transparent !important;\n  color: #FFE623 !important;\n  text-shadow: 0px -1px 0px #DDC507, -1px 0px 0px #DDC507, 0px 1px 0px #DDC507, 1px 0px 0px #DDC507 !important;\n}\n\n/* Selected Star */\n\n.ui.star.rating .icon.selected, .ui.star.rating .icon.selected.active {\n  background: transparent !important;\n  color: #FFCC00 !important;\n  text-shadow: 0px -1px 0px #E6A200, -1px 0px 0px #E6A200, 0px 1px 0px #E6A200, 1px 0px 0px #E6A200 !important;\n}\n\n/*-------------------\n        Heart\n--------------------*/\n\n.ui.heart.rating .icon {\n  width: 1.4em;\n  height: auto;\n  background: transparent;\n  color: rgba(0, 0, 0, 0.15);\n  text-shadow: none !important;\n}\n\n/* Active Heart */\n\n.ui.heart.rating .active.icon {\n  background: transparent !important;\n  color: #FF6D75 !important;\n  text-shadow: 0px -1px 0px #CD0707, -1px 0px 0px #CD0707, 0px 1px 0px #CD0707, 1px 0px 0px #CD0707 !important;\n}\n\n/* Selected Heart */\n\n.ui.heart.rating .icon.selected, .ui.heart.rating .icon.selected.active {\n  background: transparent !important;\n  color: #FF3000 !important;\n  text-shadow: 0px -1px 0px #AA0101, -1px 0px 0px #AA0101, 0px 1px 0px #AA0101, 1px 0px 0px #AA0101 !important;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*-------------------\n       Disabled\n--------------------*/\n\n/* disabled rating */\n\n.ui.disabled.rating .icon {\n  cursor: default;\n}\n\n/*-------------------\n   User Interactive\n--------------------*/\n\n/* Selected Rating */\n\n.ui.rating.selected .active.icon {\n  opacity: 1;\n}\n\n.ui.rating.selected .icon.selected, .ui.rating .icon.selected {\n  opacity: 1;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.mini.rating {\n  font-size: 0.78571429rem;\n}\n\n.ui.tiny.rating {\n  font-size: 0.85714286rem;\n}\n\n.ui.small.rating {\n  font-size: 0.92857143rem;\n}\n\n.ui.rating {\n  font-size: 1rem;\n}\n\n.ui.large.rating {\n  font-size: 1.14285714rem;\n}\n\n.ui.huge.rating {\n  font-size: 1.42857143rem;\n}\n\n.ui.massive.rating {\n  font-size: 2rem;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n@font-face {\n  font-family: 'Rating';\n  src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,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) format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.ui.rating .icon {\n  font-family: 'Rating';\n  line-height: 1;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  font-weight: normal;\n  font-style: normal;\n  text-align: center;\n}\n\n/* Empty Star */\n\n.ui.rating .icon:before {\n  content: '\\F005';\n}\n\n/* Active Star */\n\n.ui.rating .active.icon:before {\n  content: '\\F005';\n}\n\n/*-------------------\n        Star\n--------------------*/\n\n/* Unfilled Star */\n\n.ui.star.rating .icon:before {\n  content: '\\F005';\n}\n\n/* Active Star */\n\n.ui.star.rating .active.icon:before {\n  content: '\\F005';\n}\n\n/* Partial */\n\n.ui.star.rating .partial.icon:before {\n  content: '\\F006';\n}\n\n.ui.star.rating .partial.icon {\n  content: '\\F005';\n}\n\n/*-------------------\n        Heart\n--------------------*/\n\n/* Empty Heart\n.ui.heart.rating .icon:before {\n  content: '\\f08a';\n}\n*/\n\n.ui.heart.rating .icon:before {\n  content: '\\F004';\n}\n\n/* Active */\n\n.ui.heart.rating .active.icon:before {\n  content: '\\F004';\n}\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Search\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n             Search\n*******************************/\n\n.ui.search {\n  position: relative;\n}\n\n.ui.search > .prompt {\n  margin: 0em;\n  outline: none;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  text-shadow: none;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.21428571em;\n  padding: 0.67857143em 1em;\n  font-size: 1em;\n  background: #FFFFFF;\n  border: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: 0em 0em 0em 0em transparent inset;\n  transition: background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, border-color 0.1s ease;\n}\n\n.ui.search .prompt {\n  border-radius: 500rem;\n}\n\n/*--------------\n     Icon\n---------------*/\n\n.ui.search .prompt ~ .search.icon {\n  cursor: pointer;\n}\n\n/*--------------\n    Results\n---------------*/\n\n.ui.search > .results {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0%;\n  -webkit-transform-origin: center top;\n  transform-origin: center top;\n  white-space: normal;\n  text-align: left;\n  text-transform: none;\n  background: #FFFFFF;\n  margin-top: 0.5em;\n  width: 18em;\n  border-radius: 0.21428571rem;\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12), 0px 2px 10px 0px rgba(34, 36, 38, 0.15);\n  border: 1px solid #DEDEDF;\n  z-index: 998;\n}\n\n.ui.search > .results > :first-child {\n  border-radius: 0.21428571rem 0.21428571rem 0em 0em;\n}\n\n.ui.search > .results > :last-child {\n  border-radius: 0em 0em 0.21428571rem 0.21428571rem;\n}\n\n/*--------------\n    Result\n---------------*/\n\n.ui.search > .results .result {\n  cursor: pointer;\n  display: block;\n  overflow: hidden;\n  font-size: 1em;\n  padding: 0.85714286em 1.14285714em;\n  color: rgba(0, 0, 0, 0.8);\n  line-height: 1.33;\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n.ui.search > .results .result:last-child {\n  border-bottom: none !important;\n}\n\n/* Image */\n\n.ui.search > .results .result .image {\n  float: right;\n  overflow: hidden;\n  background: none;\n  width: 5em;\n  height: 3em;\n  border-radius: 0.25em;\n}\n\n.ui.search > .results .result .image img {\n  display: block;\n  width: auto;\n  height: 100%;\n}\n\n/*--------------\n      Info\n---------------*/\n\n.ui.search > .results .result .image + .content {\n  margin: 0em 6em 0em 0em;\n}\n\n.ui.search > .results .result .title {\n  margin: -0.14285714em 0em 0em;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-weight: bold;\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.search > .results .result .description {\n  margin-top: 0;\n  font-size: 0.92857143em;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ui.search > .results .result .price {\n  float: right;\n  color: #59D98D;\n}\n\n/*--------------\n    Message\n---------------*/\n\n.ui.search > .results > .message {\n  padding: 1em 1em;\n}\n\n.ui.search > .results > .message .header {\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1rem;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.search > .results > .message .description {\n  margin-top: 0.25rem;\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* View All Results */\n\n.ui.search > .results > .action {\n  display: block;\n  border-top: none;\n  background: #F3F4F5;\n  padding: 0.92857143em 1em;\n  color: rgba(0, 0, 0, 0.8);\n  font-weight: bold;\n  text-align: center;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------------\n       Focus\n---------------------*/\n\n.ui.search > .prompt:focus {\n  border-color: rgba(34, 36, 38, 0.35);\n  background: #FFFFFF;\n  color: #59D98D;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.loading.search .input > i.icon:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n\n.ui.loading.search .input > i.icon:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  -webkit-animation: button-spin 0.6s linear;\n  animation: button-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n/*--------------\n      Hover\n---------------*/\n\n.ui.search > .results .result:hover, .ui.category.search > .results .category .result:hover {\n  background: #F9FAFB;\n}\n\n.ui.search .action:hover {\n  background: #E0E0E0;\n}\n\n/*--------------\n      Active\n---------------*/\n\n.ui.category.search > .results .category.active {\n  background: #F3F4F5;\n}\n\n.ui.category.search > .results .category.active > .name {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.ui.search > .results .result.active, .ui.category.search > .results .category .result.active {\n  position: relative;\n  border-left-color: rgba(34, 36, 38, 0.1);\n  background: #F3F4F5;\n  box-shadow: none;\n}\n\n.ui.search > .results .result.active .title {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ui.search > .results .result.active .description {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n/*--------------------\n        Disabled\n----------------------*/\n\n/* Disabled */\n\n.ui.disabled.search {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.45;\n}\n\n/*******************************\n           Types\n*******************************/\n\n/*--------------\n    Selection\n---------------*/\n\n.ui.search.selection .prompt {\n  border-radius: 0.21428571rem;\n}\n\n/* Remove input */\n\n.ui.search.selection > .icon.input > .remove.icon {\n  pointer-events: none;\n  position: absolute;\n  left: auto;\n  opacity: 0;\n  color: '';\n  top: 0em;\n  right: 0em;\n  transition: color 0.1s ease, opacity 0.1s ease;\n}\n\n.ui.search.selection > .icon.input > .active.remove.icon {\n  cursor: pointer;\n  opacity: 0.8;\n  pointer-events: auto;\n}\n\n.ui.search.selection > .icon.input:not([class*=\"left icon\"]) > .icon ~ .remove.icon {\n  right: 1.85714em;\n}\n\n.ui.search.selection > .icon.input > .remove.icon:hover {\n  opacity: 1;\n  color: #DB2828;\n}\n\n/*--------------\n    Category\n---------------*/\n\n.ui.category.search .results {\n  width: 28em;\n}\n\n.ui.category.search .results.animating, .ui.category.search .results.visible {\n  display: table;\n}\n\n/* Category */\n\n.ui.category.search > .results .category {\n  display: table-row;\n  background: #F3F4F5;\n  box-shadow: none;\n  transition: background 0.1s ease, border-color 0.1s ease;\n}\n\n/* Last Category */\n\n.ui.category.search > .results .category:last-child {\n  border-bottom: none;\n}\n\n/* First / Last */\n\n.ui.category.search > .results .category:first-child .name + .result {\n  border-radius: 0em 0.21428571rem 0em 0em;\n}\n\n.ui.category.search > .results .category:last-child .result:last-child {\n  border-radius: 0em 0em 0.21428571rem 0em;\n}\n\n/* Category Result */\n\n.ui.category.search > .results .category .result {\n  background: #FFFFFF;\n  margin-left: 100px;\n  border-left: 1px solid #DEDEDF;\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n  transition: background 0.1s ease, border-color 0.1s ease;\n  padding: 0.85714286em 1.14285714em;\n}\n\n.ui.category.search > .results .category:last-child .result:last-child {\n  border-bottom: none;\n}\n\n/* Category Result Name */\n\n.ui.category.search > .results .category > .name {\n  display: table-cell;\n  text-overflow: ellipsis;\n  width: 100px;\n  white-space: nowrap;\n  background: transparent;\n  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;\n  font-size: 1em;\n  padding: 0.4em 1em;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.4);\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n/* Category Result */\n\n.ui.category.search > .results .category .results {\n  display: table-cell;\n  background: #FFFFFF;\n  border-left: 1px solid rgba(34, 36, 38, 0.15);\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n}\n\n.ui.category.search > .results .category .result {\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1);\n  transition: background 0.1s ease, border-color 0.1s ease;\n  padding: 0.85714286em 1.14285714em;\n}\n\n/*******************************\n           Variations\n*******************************/\n\n/*-------------------\n     Left / Right\n--------------------*/\n\n.ui[class*=\"left aligned\"].search > .results {\n  right: auto;\n  left: 0%;\n}\n\n.ui[class*=\"right aligned\"].search > .results {\n  right: 0%;\n  left: auto;\n}\n\n/*--------------\n    Fluid\n---------------*/\n\n.ui.fluid.search .results {\n  width: 100%;\n}\n\n/*--------------\n      Sizes\n---------------*/\n\n.ui.mini.search {\n  font-size: 0.78571429em;\n}\n\n.ui.small.search {\n  font-size: 0.92857143em;\n}\n\n.ui.search {\n  font-size: 1em;\n}\n\n.ui.large.search {\n  font-size: 1.14285714em;\n}\n\n.ui.big.search {\n  font-size: 1.28571429em;\n}\n\n.ui.huge.search {\n  font-size: 1.42857143em;\n}\n\n.ui.massive.search {\n  font-size: 1.71428571em;\n}\n\n/*--------------\n      Mobile\n---------------*/\n\n@media only screen and (max-width: 767px) {\n  .ui.search .results {\n    max-width: calc(100vw - 2rem);\n  }\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Shape\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n              Shape\n*******************************/\n\n.ui.shape {\n  position: relative;\n  vertical-align: top;\n  display: inline-block;\n  -webkit-perspective: 2000px;\n  perspective: 2000px;\n  transition: left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n}\n\n.ui.shape .sides {\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n\n.ui.shape .side {\n  opacity: 1;\n  width: 100%;\n  margin: 0em !important;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.ui.shape .side {\n  display: none;\n}\n\n.ui.shape .side * {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n}\n\n/*******************************\n             Types\n*******************************/\n\n.ui.cube.shape .side {\n  min-width: 15em;\n  height: 15em;\n  padding: 2em;\n  background-color: #E6E6E6;\n  color: rgba(0, 0, 0, 0.8);\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);\n}\n\n.ui.cube.shape .side > .content {\n  width: 100%;\n  height: 100%;\n  display: table;\n  text-align: center;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.ui.cube.shape .side > .content > div {\n  display: table-cell;\n  vertical-align: middle;\n  font-size: 2em;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n.ui.text.shape.animating .sides {\n  position: static;\n}\n\n.ui.text.shape .side {\n  white-space: nowrap;\n}\n\n.ui.text.shape .side > * {\n  white-space: normal;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------\n    Loading\n---------------*/\n\n.ui.loading.shape {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n}\n\n/*--------------\n    Animating\n---------------*/\n\n.ui.shape .animating.side {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: block;\n  z-index: 100;\n}\n\n.ui.shape .hidden.side {\n  opacity: 0.6;\n}\n\n/*--------------\n      CSS\n---------------*/\n\n.ui.shape.animating .sides {\n  position: absolute;\n}\n\n.ui.shape.animating .sides {\n  transition: left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n}\n\n.ui.shape.animating .side {\n  transition: opacity 0.6s ease-in-out;\n}\n\n/*--------------\n     Active\n---------------*/\n\n.ui.shape .active.side {\n  display: block;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Sidebar\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Sidebar\n*******************************/\n\n/* Sidebar Menu */\n\n.ui.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transition: none;\n  will-change: transform;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  visibility: hidden;\n  -webkit-overflow-scrolling: touch;\n  height: 100% !important;\n  max-height: 100%;\n  border-radius: 0em !important;\n  margin: 0em !important;\n  overflow-y: auto !important;\n  z-index: 102;\n}\n\n/* GPU Layers for Child Elements */\n\n.ui.sidebar > * {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n/*--------------\n   Direction\n---------------*/\n\n.ui.left.sidebar {\n  right: auto;\n  left: 0px;\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0);\n}\n\n.ui.right.sidebar {\n  right: 0px !important;\n  left: auto !important;\n  -webkit-transform: translate3d(100%, 0%, 0);\n  transform: translate3d(100%, 0%, 0);\n}\n\n.ui.top.sidebar, .ui.bottom.sidebar {\n  width: 100% !important;\n  height: auto !important;\n}\n\n.ui.top.sidebar {\n  top: 0px !important;\n  bottom: auto !important;\n  -webkit-transform: translate3d(0, -100%, 0);\n  transform: translate3d(0, -100%, 0);\n}\n\n.ui.bottom.sidebar {\n  top: auto !important;\n  bottom: 0px !important;\n  -webkit-transform: translate3d(0, 100%, 0);\n  transform: translate3d(0, 100%, 0);\n}\n\n/*--------------\n     Pushable\n---------------*/\n\n.pushable {\n  height: 100%;\n  overflow-x: hidden;\n  padding: 0em !important;\n}\n\n/* Whole Page */\n\nbody.pushable {\n  background: #545454 !important;\n}\n\n/* Page Context */\n\n.pushable:not(body) {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.pushable:not(body) > .ui.sidebar, .pushable:not(body) > .fixed, .pushable:not(body) > .pusher:after {\n  position: absolute;\n}\n\n/*--------------\n     Fixed\n---------------*/\n\n.pushable > .fixed {\n  position: fixed;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n  will-change: transform;\n  z-index: 101;\n}\n\n/*--------------\n     Page\n---------------*/\n\n.pushable > .pusher {\n  position: relative;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  overflow: hidden;\n  min-height: 100%;\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n  z-index: 2;\n}\n\nbody.pushable > .pusher {\n  background: #FAFBFA;\n}\n\n/* Pusher should inherit background from context */\n\n.pushable > .pusher {\n  background: inherit;\n}\n\n/*--------------\n     Dimmer\n---------------*/\n\n.pushable > .pusher:after {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  content: '';\n  background-color: rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 500ms;\n  will-change: opacity;\n  z-index: 1000;\n}\n\n/*--------------\n    Coupling\n---------------*/\n\n.ui.sidebar.menu .item {\n  border-radius: 0em !important;\n}\n\n/*******************************\n            States\n*******************************/\n\n/*--------------\n     Dimmed\n---------------*/\n\n.pushable > .pusher.dimmed:after {\n  width: 100% !important;\n  height: 100% !important;\n  opacity: 1 !important;\n}\n\n/*--------------\n    Animating\n---------------*/\n\n.ui.animating.sidebar {\n  visibility: visible;\n}\n\n/*--------------\n     Visible\n---------------*/\n\n.ui.visible.sidebar {\n  visibility: visible;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n/* Shadow Direction */\n\n.ui.left.visible.sidebar, .ui.right.visible.sidebar {\n  box-shadow: 0px 0px 20px #DEDEDF;\n}\n\n.ui.top.visible.sidebar, .ui.bottom.visible.sidebar {\n  box-shadow: 0px 0px 20px #DEDEDF;\n}\n\n/* Visible On Load */\n\n.ui.visible.left.sidebar ~ .fixed, .ui.visible.left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(260px, 0, 0);\n  transform: translate3d(260px, 0, 0);\n}\n\n.ui.visible.right.sidebar ~ .fixed, .ui.visible.right.sidebar ~ .pusher {\n  -webkit-transform: translate3d(-260px, 0, 0);\n  transform: translate3d(-260px, 0, 0);\n}\n\n.ui.visible.top.sidebar ~ .fixed, .ui.visible.top.sidebar ~ .pusher {\n  -webkit-transform: translate3d(0, 36px, 0);\n  transform: translate3d(0, 36px, 0);\n}\n\n.ui.visible.bottom.sidebar ~ .fixed, .ui.visible.bottom.sidebar ~ .pusher {\n  -webkit-transform: translate3d(0, -36px, 0);\n  transform: translate3d(0, -36px, 0);\n}\n\n/* opposite sides visible forces content overlay */\n\n.ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed, .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher, .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed, .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n/*--------------\n       iOS\n---------------*/\n\n/*******************************\n          Variations\n*******************************/\n\n/*--------------\n     Width\n---------------*/\n\n/* Left / Right */\n\n.ui.thin.left.sidebar, .ui.thin.right.sidebar {\n  width: 150px;\n}\n\n.ui[class*=\"very thin\"].left.sidebar, .ui[class*=\"very thin\"].right.sidebar {\n  width: 60px;\n}\n\n.ui.left.sidebar, .ui.right.sidebar {\n  width: 260px;\n}\n\n.ui.wide.left.sidebar, .ui.wide.right.sidebar {\n  width: 350px;\n}\n\n.ui[class*=\"very wide\"].left.sidebar, .ui[class*=\"very wide\"].right.sidebar {\n  width: 475px;\n}\n\n/* Left Visible */\n\n.ui.visible.thin.left.sidebar ~ .fixed, .ui.visible.thin.left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(150px, 0, 0);\n  transform: translate3d(150px, 0, 0);\n}\n\n.ui.visible[class*=\"very thin\"].left.sidebar ~ .fixed, .ui.visible[class*=\"very thin\"].left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(60px, 0, 0);\n  transform: translate3d(60px, 0, 0);\n}\n\n.ui.visible.wide.left.sidebar ~ .fixed, .ui.visible.wide.left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(350px, 0, 0);\n  transform: translate3d(350px, 0, 0);\n}\n\n.ui.visible[class*=\"very wide\"].left.sidebar ~ .fixed, .ui.visible[class*=\"very wide\"].left.sidebar ~ .pusher {\n  -webkit-transform: translate3d(475px, 0, 0);\n  transform: translate3d(475px, 0, 0);\n}\n\n/* Right Visible */\n\n.ui.visible.thin.right.sidebar ~ .fixed, .ui.visible.thin.right.sidebar ~ .pusher {\n  -webkit-transform: translate3d(-150px, 0, 0);\n  transform: translate3d(-150px, 0, 0);\n}\n\n.ui.visible[class*=\"very thin\"].right.sidebar ~ .fixed, .ui.visible[class*=\"very thin\"].right.sidebar ~ .pusher {\n  -webkit-transform: translate3d(-60px, 0, 0);\n  transform: translate3d(-60px, 0, 0);\n}\n\n.ui.visible.wide.right.sidebar ~ .fixed, .ui.visible.wide.right.sidebar ~ .pusher {\n  -webkit-transform: translate3d(-350px, 0, 0);\n  transform: translate3d(-350px, 0, 0);\n}\n\n.ui.visible[class*=\"very wide\"].right.sidebar ~ .fixed, .ui.visible[class*=\"very wide\"].right.sidebar ~ .pusher {\n  -webkit-transform: translate3d(-475px, 0, 0);\n  transform: translate3d(-475px, 0, 0);\n}\n\n/*******************************\n          Animations\n*******************************/\n\n/*--------------\n    Overlay\n---------------*/\n\n/* Set-up */\n\n.ui.overlay.sidebar {\n  z-index: 102;\n}\n\n/* Initial */\n\n.ui.left.overlay.sidebar {\n  -webkit-transform: translate3d(-100%, 0%, 0);\n  transform: translate3d(-100%, 0%, 0);\n}\n\n.ui.right.overlay.sidebar {\n  -webkit-transform: translate3d(100%, 0%, 0);\n  transform: translate3d(100%, 0%, 0);\n}\n\n.ui.top.overlay.sidebar {\n  -webkit-transform: translate3d(0%, -100%, 0);\n  transform: translate3d(0%, -100%, 0);\n}\n\n.ui.bottom.overlay.sidebar {\n  -webkit-transform: translate3d(0%, 100%, 0);\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* Animation */\n\n.animating.ui.overlay.sidebar, .ui.visible.overlay.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n}\n\n/* End - Sidebar */\n\n.ui.visible.left.overlay.sidebar {\n  -webkit-transform: translate3d(0%, 0%, 0);\n  transform: translate3d(0%, 0%, 0);\n}\n\n.ui.visible.right.overlay.sidebar {\n  -webkit-transform: translate3d(0%, 0%, 0);\n  transform: translate3d(0%, 0%, 0);\n}\n\n.ui.visible.top.overlay.sidebar {\n  -webkit-transform: translate3d(0%, 0%, 0);\n  transform: translate3d(0%, 0%, 0);\n}\n\n.ui.visible.bottom.overlay.sidebar {\n  -webkit-transform: translate3d(0%, 0%, 0);\n  transform: translate3d(0%, 0%, 0);\n}\n\n/* End - Pusher */\n\n.ui.visible.overlay.sidebar ~ .fixed, .ui.visible.overlay.sidebar ~ .pusher {\n  -webkit-transform: none !important;\n  transform: none !important;\n}\n\n/*--------------\n      Push\n---------------*/\n\n/* Initial */\n\n.ui.push.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n  z-index: 102;\n}\n\n/* Sidebar - Initial */\n\n.ui.left.push.sidebar {\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0);\n}\n\n.ui.right.push.sidebar {\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0);\n}\n\n.ui.top.push.sidebar {\n  -webkit-transform: translate3d(0%, -100%, 0);\n  transform: translate3d(0%, -100%, 0);\n}\n\n.ui.bottom.push.sidebar {\n  -webkit-transform: translate3d(0%, 100%, 0);\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* End */\n\n.ui.visible.push.sidebar {\n  -webkit-transform: translate3d(0%, 0, 0);\n  transform: translate3d(0%, 0, 0);\n}\n\n/*--------------\n    Uncover\n---------------*/\n\n/* Initial */\n\n.ui.uncover.sidebar {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  z-index: 1;\n}\n\n/* End */\n\n.ui.visible.uncover.sidebar {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n}\n\n/*--------------\n   Slide Along\n---------------*/\n\n/* Initial */\n\n.ui.slide.along.sidebar {\n  z-index: 1;\n}\n\n/* Sidebar - Initial */\n\n.ui.left.slide.along.sidebar {\n  -webkit-transform: translate3d(-50%, 0, 0);\n  transform: translate3d(-50%, 0, 0);\n}\n\n.ui.right.slide.along.sidebar {\n  -webkit-transform: translate3d(50%, 0, 0);\n  transform: translate3d(50%, 0, 0);\n}\n\n.ui.top.slide.along.sidebar {\n  -webkit-transform: translate3d(0, -50%, 0);\n  transform: translate3d(0, -50%, 0);\n}\n\n.ui.bottom.slide.along.sidebar {\n  -webkit-transform: translate3d(0%, 50%, 0);\n  transform: translate3d(0%, 50%, 0);\n}\n\n/* Animation */\n\n.ui.animating.slide.along.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n}\n\n/* End */\n\n.ui.visible.slide.along.sidebar {\n  -webkit-transform: translate3d(0%, 0, 0);\n  transform: translate3d(0%, 0, 0);\n}\n\n/*--------------\n   Slide Out\n---------------*/\n\n/* Initial */\n\n.ui.slide.out.sidebar {\n  z-index: 1;\n}\n\n/* Sidebar - Initial */\n\n.ui.left.slide.out.sidebar {\n  -webkit-transform: translate3d(50%, 0, 0);\n  transform: translate3d(50%, 0, 0);\n}\n\n.ui.right.slide.out.sidebar {\n  -webkit-transform: translate3d(-50%, 0, 0);\n  transform: translate3d(-50%, 0, 0);\n}\n\n.ui.top.slide.out.sidebar {\n  -webkit-transform: translate3d(0%, 50%, 0);\n  transform: translate3d(0%, 50%, 0);\n}\n\n.ui.bottom.slide.out.sidebar {\n  -webkit-transform: translate3d(0%, -50%, 0);\n  transform: translate3d(0%, -50%, 0);\n}\n\n/* Animation */\n\n.ui.animating.slide.out.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n}\n\n/* End */\n\n.ui.visible.slide.out.sidebar {\n  -webkit-transform: translate3d(0%, 0, 0);\n  transform: translate3d(0%, 0, 0);\n}\n\n/*--------------\n   Scale Down\n---------------*/\n\n/* Initial */\n\n.ui.scale.down.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n  z-index: 102;\n}\n\n/* Sidebar - Initial  */\n\n.ui.left.scale.down.sidebar {\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0);\n}\n\n.ui.right.scale.down.sidebar {\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0);\n}\n\n.ui.top.scale.down.sidebar {\n  -webkit-transform: translate3d(0%, -100%, 0);\n  transform: translate3d(0%, -100%, 0);\n}\n\n.ui.bottom.scale.down.sidebar {\n  -webkit-transform: translate3d(0%, 100%, 0);\n  transform: translate3d(0%, 100%, 0);\n}\n\n/* Pusher - Initial */\n\n.ui.scale.down.left.sidebar ~ .pusher {\n  -webkit-transform-origin: 75% 50%;\n  transform-origin: 75% 50%;\n}\n\n.ui.scale.down.right.sidebar ~ .pusher {\n  -webkit-transform-origin: 25% 50%;\n  transform-origin: 25% 50%;\n}\n\n.ui.scale.down.top.sidebar ~ .pusher {\n  -webkit-transform-origin: 50% 75%;\n  transform-origin: 50% 75%;\n}\n\n.ui.scale.down.bottom.sidebar ~ .pusher {\n  -webkit-transform-origin: 50% 25%;\n  transform-origin: 50% 25%;\n}\n\n/* Animation */\n\n.ui.animating.scale.down > .visible.ui.sidebar {\n  transition: -webkit-transform 500ms ease;\n  transition: transform 500ms ease;\n  transition: transform 500ms ease, -webkit-transform 500ms ease;\n}\n\n.ui.visible.scale.down.sidebar ~ .pusher, .ui.animating.scale.down.sidebar ~ .pusher {\n  display: block !important;\n  width: 100%;\n  height: 100%;\n  overflow: hidden !important;\n}\n\n/* End */\n\n.ui.visible.scale.down.sidebar {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.ui.visible.scale.down.sidebar ~ .pusher {\n  -webkit-transform: scale(0.75);\n  transform: scale(0.75);\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Sticky\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n            Sticky\n*******************************/\n\n.ui.sticky {\n  position: static;\n  transition: none;\n  z-index: 800;\n}\n\n/*******************************\n            States\n*******************************/\n\n/* Bound */\n\n.ui.sticky.bound {\n  position: absolute;\n  left: auto;\n  right: auto;\n}\n\n/* Fixed */\n\n.ui.sticky.fixed {\n  position: fixed;\n  left: auto;\n  right: auto;\n}\n\n/* Bound/Fixed Position */\n\n.ui.sticky.bound.top, .ui.sticky.fixed.top {\n  top: 0px;\n  bottom: auto;\n}\n\n.ui.sticky.bound.bottom, .ui.sticky.fixed.bottom {\n  top: auto;\n  bottom: 0px;\n}\n\n/*******************************\n            Types\n*******************************/\n\n.ui.native.sticky {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n}\n\n/*******************************\n         Theme Overrides\n*******************************/\n\n/*******************************\n         Site Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Tab\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n           UI Tabs\n*******************************/\n\n.ui.tab {\n  display: none;\n}\n\n/*******************************\n             States\n*******************************/\n\n/*--------------------\n       Active\n---------------------*/\n\n.ui.tab.active, .ui.tab.open {\n  display: block;\n}\n\n/*--------------------\n       Loading\n---------------------*/\n\n.ui.tab.loading {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  min-height: 250px;\n}\n\n.ui.tab.loading * {\n  position: relative !important;\n  left: -10000px !important;\n}\n\n.ui.tab.loading:before, .ui.tab.loading.segment:before {\n  position: absolute;\n  content: '';\n  top: 100px;\n  left: 50%;\n  margin: -1.25em 0em 0em -1.25em;\n  width: 2.5em;\n  height: 2.5em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.1);\n}\n\n.ui.tab.loading:after, .ui.tab.loading.segment:after {\n  position: absolute;\n  content: '';\n  top: 100px;\n  left: 50%;\n  margin: -1.25em 0em 0em -1.25em;\n  width: 2.5em;\n  height: 2.5em;\n  -webkit-animation: button-spin 0.6s linear;\n  animation: button-spin 0.6s linear;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: rgba(0, 0, 0, 0.4) transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n\n/*******************************\n         Tab Overrides\n*******************************/\n\n/*******************************\n        User Overrides\n*******************************/\n/*!\n * # Semantic UI 2.4.2 - Transition\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */\n\n/*******************************\n          Transitions\n*******************************/\n\n.transition {\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  -webkit-animation-duration: 300ms;\n  animation-duration: 300ms;\n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n/*******************************\n            States\n*******************************/\n\n/* Animating */\n\n.animating.transition {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  visibility: visible !important;\n}\n\n/* Loading */\n\n.loading.transition {\n  position: absolute;\n  top: -99999px;\n  left: -99999px;\n}\n\n/* Hidden */\n\n.hidden.transition {\n  display: none;\n  visibility: hidden;\n}\n\n/* Visible */\n\n.visible.transition {\n  display: block !important;\n  visibility: visible !important;\n  /*  backface-visibility: @backfaceVisibility;\n  transform: @use3DAcceleration;*/\n}\n\n/* Disabled */\n\n.disabled.transition {\n  -webkit-animation-play-state: paused;\n  animation-play-state: paused;\n}\n\n/*******************************\n          Variations\n*******************************/\n\n.looping.transition {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n/*******************************\n          Transitions\n*******************************/\n\n/*\n  Some transitions adapted from Animate CSS\n  https://github.com/daneden/animate.css\n\n  Additional transitions adapted from Glide\n  by Nick Pettit - https://github.com/nickpettit/glide\n*/\n\n/*--------------\n     Browse\n---------------*/\n\n.transition.browse {\n  -webkit-animation-duration: 500ms;\n  animation-duration: 500ms;\n}\n\n.transition.browse.in {\n  -webkit-animation-name: browseIn;\n  animation-name: browseIn;\n}\n\n.transition.browse.out, .transition.browse.left.out {\n  -webkit-animation-name: browseOutLeft;\n  animation-name: browseOutLeft;\n}\n\n.transition.browse.right.out {\n  -webkit-animation-name: browseOutRight;\n  animation-name: browseOutRight;\n}\n\n/* In */\n\n@-webkit-keyframes browseIn {\n  0% {\n    -webkit-transform: scale(0.8) translateZ(0px);\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n  }\n\n  10% {\n    -webkit-transform: scale(0.8) translateZ(0px);\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n    opacity: 0.7;\n  }\n\n  80% {\n    -webkit-transform: scale(1.05) translateZ(0px);\n    transform: scale(1.05) translateZ(0px);\n    opacity: 1;\n    z-index: 999;\n  }\n\n  100% {\n    -webkit-transform: scale(1) translateZ(0px);\n    transform: scale(1) translateZ(0px);\n    z-index: 999;\n  }\n}\n\n@keyframes browseIn {\n  0% {\n    -webkit-transform: scale(0.8) translateZ(0px);\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n  }\n\n  10% {\n    -webkit-transform: scale(0.8) translateZ(0px);\n    transform: scale(0.8) translateZ(0px);\n    z-index: -1;\n    opacity: 0.7;\n  }\n\n  80% {\n    -webkit-transform: scale(1.05) translateZ(0px);\n    transform: scale(1.05) translateZ(0px);\n    opacity: 1;\n    z-index: 999;\n  }\n\n  100% {\n    -webkit-transform: scale(1) translateZ(0px);\n    transform: scale(1) translateZ(0px);\n    z-index: 999;\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes browseOutLeft {\n  0% {\n    z-index: 999;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n\n  50% {\n    z-index: -1;\n    -webkit-transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: -1;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n\n@keyframes browseOutLeft {\n  0% {\n    z-index: 999;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n\n  50% {\n    z-index: -1;\n    -webkit-transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: -1;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes browseOutRight {\n  0% {\n    z-index: 999;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n\n  50% {\n    z-index: 1;\n    -webkit-transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: 1;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n\n@keyframes browseOutRight {\n  0% {\n    z-index: 999;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n  }\n\n  50% {\n    z-index: 1;\n    -webkit-transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: 1;\n    -webkit-transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n    opacity: 0;\n  }\n}\n\n/*--------------\n     Drop\n---------------*/\n\n.drop.transition {\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n  -webkit-animation-duration: 400ms;\n  animation-duration: 400ms;\n  -webkit-animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);\n  animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);\n}\n\n.drop.transition.in {\n  -webkit-animation-name: dropIn;\n  animation-name: dropIn;\n}\n\n.drop.transition.out {\n  -webkit-animation-name: dropOut;\n  animation-name: dropOut;\n}\n\n/* Drop */\n\n@-webkit-keyframes dropIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes dropIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@-webkit-keyframes dropOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n}\n\n@keyframes dropOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n}\n\n/*--------------\n      Fade\n---------------*/\n\n.transition.fade.in {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n.transition[class*=\"fade up\"].in {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n\n.transition[class*=\"fade down\"].in {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n.transition[class*=\"fade left\"].in {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft;\n}\n\n.transition[class*=\"fade right\"].in {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight;\n}\n\n.transition.fade.out {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n.transition[class*=\"fade up\"].out {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n\n.transition[class*=\"fade down\"].out {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n.transition[class*=\"fade left\"].out {\n  -webkit-animation-name: fadeOutLeft;\n  animation-name: fadeOutLeft;\n}\n\n.transition[class*=\"fade right\"].out {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight;\n}\n\n/* In */\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10%);\n    transform: translateY(10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(10%);\n    transform: translateY(10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-10%);\n    transform: translateY(-10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-10%);\n    transform: translateY(-10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n}\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(10%);\n    transform: translateX(10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n}\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(10%);\n    transform: translateX(10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n}\n\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-10%);\n    transform: translateX(-10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n}\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-10%);\n    transform: translateX(-10%);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(5%);\n    transform: translateY(5%);\n  }\n}\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(5%);\n    transform: translateY(5%);\n  }\n}\n\n@-webkit-keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-5%);\n    transform: translateY(-5%);\n  }\n}\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0%);\n    transform: translateY(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-5%);\n    transform: translateY(-5%);\n  }\n}\n\n@-webkit-keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(5%);\n    transform: translateX(5%);\n  }\n}\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(5%);\n    transform: translateX(5%);\n  }\n}\n\n@-webkit-keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-5%);\n    transform: translateX(-5%);\n  }\n}\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-5%);\n    transform: translateX(-5%);\n  }\n}\n\n/*--------------\n     Flips\n---------------*/\n\n.flip.transition.in, .flip.transition.out {\n  -webkit-animation-duration: 600ms;\n  animation-duration: 600ms;\n}\n\n.horizontal.flip.transition.in {\n  -webkit-animation-name: horizontalFlipIn;\n  animation-name: horizontalFlipIn;\n}\n\n.horizontal.flip.transition.out {\n  -webkit-animation-name: horizontalFlipOut;\n  animation-name: horizontalFlipOut;\n}\n\n.vertical.flip.transition.in {\n  -webkit-animation-name: verticalFlipIn;\n  animation-name: verticalFlipIn;\n}\n\n.vertical.flip.transition.out {\n  -webkit-animation-name: verticalFlipOut;\n  animation-name: verticalFlipOut;\n}\n\n/* In */\n\n@-webkit-keyframes horizontalFlipIn {\n  0% {\n    -webkit-transform: perspective(2000px) rotateY(-90deg);\n    transform: perspective(2000px) rotateY(-90deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateY(0deg);\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes horizontalFlipIn {\n  0% {\n    -webkit-transform: perspective(2000px) rotateY(-90deg);\n    transform: perspective(2000px) rotateY(-90deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateY(0deg);\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes verticalFlipIn {\n  0% {\n    -webkit-transform: perspective(2000px) rotateX(-90deg);\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateX(0deg);\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes verticalFlipIn {\n  0% {\n    -webkit-transform: perspective(2000px) rotateX(-90deg);\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateX(0deg);\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes horizontalFlipOut {\n  0% {\n    -webkit-transform: perspective(2000px) rotateY(0deg);\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateY(90deg);\n    transform: perspective(2000px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes horizontalFlipOut {\n  0% {\n    -webkit-transform: perspective(2000px) rotateY(0deg);\n    transform: perspective(2000px) rotateY(0deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateY(90deg);\n    transform: perspective(2000px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes verticalFlipOut {\n  0% {\n    -webkit-transform: perspective(2000px) rotateX(0deg);\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateX(-90deg);\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes verticalFlipOut {\n  0% {\n    -webkit-transform: perspective(2000px) rotateX(0deg);\n    transform: perspective(2000px) rotateX(0deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(2000px) rotateX(-90deg);\n    transform: perspective(2000px) rotateX(-90deg);\n    opacity: 0;\n  }\n}\n\n/*--------------\n      Scale\n---------------*/\n\n.scale.transition.in {\n  -webkit-animation-name: scaleIn;\n  animation-name: scaleIn;\n}\n\n.scale.transition.out {\n  -webkit-animation-name: scaleOut;\n  animation-name: scaleOut;\n}\n\n@-webkit-keyframes scaleIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes scaleOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n  }\n}\n\n@keyframes scaleOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n  }\n}\n\n/*--------------\n      Fly\n---------------*/\n\n/* Inward */\n\n.transition.fly {\n  -webkit-animation-duration: 0.6s;\n  animation-duration: 0.6s;\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.transition.fly.in {\n  -webkit-animation-name: flyIn;\n  animation-name: flyIn;\n}\n\n.transition[class*=\"fly up\"].in {\n  -webkit-animation-name: flyInUp;\n  animation-name: flyInUp;\n}\n\n.transition[class*=\"fly down\"].in {\n  -webkit-animation-name: flyInDown;\n  animation-name: flyInDown;\n}\n\n.transition[class*=\"fly left\"].in {\n  -webkit-animation-name: flyInLeft;\n  animation-name: flyInLeft;\n}\n\n.transition[class*=\"fly right\"].in {\n  -webkit-animation-name: flyInRight;\n  animation-name: flyInRight;\n}\n\n/* Outward */\n\n.transition.fly.out {\n  -webkit-animation-name: flyOut;\n  animation-name: flyOut;\n}\n\n.transition[class*=\"fly up\"].out {\n  -webkit-animation-name: flyOutUp;\n  animation-name: flyOutUp;\n}\n\n.transition[class*=\"fly down\"].out {\n  -webkit-animation-name: flyOutDown;\n  animation-name: flyOutDown;\n}\n\n.transition[class*=\"fly left\"].out {\n  -webkit-animation-name: flyOutLeft;\n  animation-name: flyOutLeft;\n}\n\n.transition[class*=\"fly right\"].out {\n  -webkit-animation-name: flyOutRight;\n  animation-name: flyOutRight;\n}\n\n/* In */\n\n@-webkit-keyframes flyIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n@keyframes flyIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.03, 1.03, 1.03);\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    -webkit-transform: scale3d(0.97, 0.97, 0.97);\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n@-webkit-keyframes flyInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 1500px, 0);\n    transform: translate3d(0, 1500px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes flyInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 1500px, 0);\n    transform: translate3d(0, 1500px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@-webkit-keyframes flyInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -1500px, 0);\n    transform: translate3d(0, -1500px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes flyInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -1500px, 0);\n    transform: translate3d(0, -1500px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 25px, 0);\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, 5px, 0);\n    transform: translate3d(0, 5px, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@-webkit-keyframes flyInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(1500px, 0, 0);\n    transform: translate3d(1500px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes flyInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(1500px, 0, 0);\n    transform: translate3d(1500px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(-25px, 0, 0);\n    transform: translate3d(-25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n    transform: translate3d(-5px, 0, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@-webkit-keyframes flyInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-1500px, 0, 0);\n    transform: translate3d(-1500px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes flyInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-1500px, 0, 0);\n    transform: translate3d(-1500px, 0, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(25px, 0, 0);\n    transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n    transform: translate3d(5px, 0, 0);\n  }\n\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes flyOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%, 55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n\n@keyframes flyOut {\n  20% {\n    -webkit-transform: scale3d(0.9, 0.9, 0.9);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%, 55% {\n    opacity: 1;\n    -webkit-transform: scale3d(1.1, 1.1, 1.1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n\n@-webkit-keyframes flyOutUp {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@keyframes flyOutUp {\n  20% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 2000px, 0);\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n\n@-webkit-keyframes flyOutDown {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@keyframes flyOutDown {\n  20% {\n    -webkit-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 20px, 0);\n    transform: translate3d(0, 20px, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -2000px, 0);\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n\n@-webkit-keyframes flyOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@keyframes flyOutRight {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(20px, 0, 0);\n    transform: translate3d(20px, 0, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(-2000px, 0, 0);\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n\n@-webkit-keyframes flyOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n@keyframes flyOutLeft {\n  20% {\n    opacity: 1;\n    -webkit-transform: translate3d(-20px, 0, 0);\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: translate3d(2000px, 0, 0);\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n\n/*--------------\n     Slide\n---------------*/\n\n.transition.slide.in, .transition[class*=\"slide down\"].in {\n  -webkit-animation-name: slideInY;\n  animation-name: slideInY;\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n}\n\n.transition[class*=\"slide up\"].in {\n  -webkit-animation-name: slideInY;\n  animation-name: slideInY;\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center;\n}\n\n.transition[class*=\"slide left\"].in {\n  -webkit-animation-name: slideInX;\n  animation-name: slideInX;\n  -webkit-transform-origin: center right;\n  transform-origin: center right;\n}\n\n.transition[class*=\"slide right\"].in {\n  -webkit-animation-name: slideInX;\n  animation-name: slideInX;\n  -webkit-transform-origin: center left;\n  transform-origin: center left;\n}\n\n.transition.slide.out, .transition[class*=\"slide down\"].out {\n  -webkit-animation-name: slideOutY;\n  animation-name: slideOutY;\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n}\n\n.transition[class*=\"slide up\"].out {\n  -webkit-animation-name: slideOutY;\n  animation-name: slideOutY;\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center;\n}\n\n.transition[class*=\"slide left\"].out {\n  -webkit-animation-name: slideOutX;\n  animation-name: slideOutX;\n  -webkit-transform-origin: center right;\n  transform-origin: center right;\n}\n\n.transition[class*=\"slide right\"].out {\n  -webkit-animation-name: slideOutX;\n  animation-name: slideOutX;\n  -webkit-transform-origin: center left;\n  transform-origin: center left;\n}\n\n/* In */\n\n@-webkit-keyframes slideInY {\n  0% {\n    opacity: 0;\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n}\n\n@keyframes slideInY {\n  0% {\n    opacity: 0;\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n}\n\n@-webkit-keyframes slideInX {\n  0% {\n    opacity: 0;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n}\n\n@keyframes slideInX {\n  0% {\n    opacity: 0;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes slideOutY {\n  0% {\n    opacity: 1;\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n  }\n}\n\n@keyframes slideOutY {\n  0% {\n    opacity: 1;\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n  }\n}\n\n@-webkit-keyframes slideOutX {\n  0% {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n  }\n}\n\n@keyframes slideOutX {\n  0% {\n    opacity: 1;\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n  }\n}\n\n/*--------------\n     Swing\n---------------*/\n\n.transition.swing {\n  -webkit-animation-duration: 800ms;\n  animation-duration: 800ms;\n}\n\n.transition[class*=\"swing down\"].in {\n  -webkit-animation-name: swingInX;\n  animation-name: swingInX;\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n}\n\n.transition[class*=\"swing up\"].in {\n  -webkit-animation-name: swingInX;\n  animation-name: swingInX;\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center;\n}\n\n.transition[class*=\"swing left\"].in {\n  -webkit-animation-name: swingInY;\n  animation-name: swingInY;\n  -webkit-transform-origin: center right;\n  transform-origin: center right;\n}\n\n.transition[class*=\"swing right\"].in {\n  -webkit-animation-name: swingInY;\n  animation-name: swingInY;\n  -webkit-transform-origin: center left;\n  transform-origin: center left;\n}\n\n.transition.swing.out, .transition[class*=\"swing down\"].out {\n  -webkit-animation-name: swingOutX;\n  animation-name: swingOutX;\n  -webkit-transform-origin: top center;\n  transform-origin: top center;\n}\n\n.transition[class*=\"swing up\"].out {\n  -webkit-animation-name: swingOutX;\n  animation-name: swingOutX;\n  -webkit-transform-origin: bottom center;\n  transform-origin: bottom center;\n}\n\n.transition[class*=\"swing left\"].out {\n  -webkit-animation-name: swingOutY;\n  animation-name: swingOutY;\n  -webkit-transform-origin: center right;\n  transform-origin: center right;\n}\n\n.transition[class*=\"swing right\"].out {\n  -webkit-animation-name: swingOutY;\n  animation-name: swingOutY;\n  -webkit-transform-origin: center left;\n  transform-origin: center left;\n}\n\n/* In */\n\n@-webkit-keyframes swingInX {\n  0% {\n    -webkit-transform: perspective(1000px) rotateX(90deg);\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateX(-30deg);\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateX(15deg);\n    transform: perspective(1000px) rotateX(15deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateX(-7.5deg);\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateX(0deg);\n    transform: perspective(1000px) rotateX(0deg);\n  }\n}\n\n@keyframes swingInX {\n  0% {\n    -webkit-transform: perspective(1000px) rotateX(90deg);\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateX(-30deg);\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateX(15deg);\n    transform: perspective(1000px) rotateX(15deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateX(-7.5deg);\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateX(0deg);\n    transform: perspective(1000px) rotateX(0deg);\n  }\n}\n\n@-webkit-keyframes swingInY {\n  0% {\n    -webkit-transform: perspective(1000px) rotateY(-90deg);\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateY(30deg);\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateY(-17.5deg);\n    transform: perspective(1000px) rotateY(-17.5deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateY(7.5deg);\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateY(0deg);\n    transform: perspective(1000px) rotateY(0deg);\n  }\n}\n\n@keyframes swingInY {\n  0% {\n    -webkit-transform: perspective(1000px) rotateY(-90deg);\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateY(30deg);\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateY(-17.5deg);\n    transform: perspective(1000px) rotateY(-17.5deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateY(7.5deg);\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateY(0deg);\n    transform: perspective(1000px) rotateY(0deg);\n  }\n}\n\n/* Out */\n\n@-webkit-keyframes swingOutX {\n  0% {\n    -webkit-transform: perspective(1000px) rotateX(0deg);\n    transform: perspective(1000px) rotateX(0deg);\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateX(-7.5deg);\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateX(17.5deg);\n    transform: perspective(1000px) rotateX(17.5deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateX(-30deg);\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateX(90deg);\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes swingOutX {\n  0% {\n    -webkit-transform: perspective(1000px) rotateX(0deg);\n    transform: perspective(1000px) rotateX(0deg);\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateX(-7.5deg);\n    transform: perspective(1000px) rotateX(-7.5deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateX(17.5deg);\n    transform: perspective(1000px) rotateX(17.5deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateX(-30deg);\n    transform: perspective(1000px) rotateX(-30deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateX(90deg);\n    transform: perspective(1000px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes swingOutY {\n  0% {\n    -webkit-transform: perspective(1000px) rotateY(0deg);\n    transform: perspective(1000px) rotateY(0deg);\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateY(7.5deg);\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateY(-10deg);\n    transform: perspective(1000px) rotateY(-10deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateY(30deg);\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateY(-90deg);\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n}\n\n@keyframes swingOutY {\n  0% {\n    -webkit-transform: perspective(1000px) rotateY(0deg);\n    transform: perspective(1000px) rotateY(0deg);\n  }\n\n  40% {\n    -webkit-transform: perspective(1000px) rotateY(7.5deg);\n    transform: perspective(1000px) rotateY(7.5deg);\n  }\n\n  60% {\n    -webkit-transform: perspective(1000px) rotateY(-10deg);\n    transform: perspective(1000px) rotateY(-10deg);\n  }\n\n  80% {\n    -webkit-transform: perspective(1000px) rotateY(30deg);\n    transform: perspective(1000px) rotateY(30deg);\n    opacity: 1;\n  }\n\n  100% {\n    -webkit-transform: perspective(1000px) rotateY(-90deg);\n    transform: perspective(1000px) rotateY(-90deg);\n    opacity: 0;\n  }\n}\n\n/*--------------\n      Zoom\n---------------*/\n\n.transition.zoom.in {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n}\n\n.transition.zoom.out {\n  -webkit-animation-name: zoomOut;\n  animation-name: zoomOut;\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@-webkit-keyframes zoomOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n}\n\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n}\n\n/*******************************\n       Static Animations\n*******************************/\n\n/*--------------\n    Emphasis\n---------------*/\n\n.flash.transition {\n  -webkit-animation-duration: 750ms;\n  animation-duration: 750ms;\n  -webkit-animation-name: flash;\n  animation-name: flash;\n}\n\n.shake.transition {\n  -webkit-animation-duration: 750ms;\n  animation-duration: 750ms;\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n.bounce.transition {\n  -webkit-animation-duration: 750ms;\n  animation-duration: 750ms;\n  -webkit-animation-name: bounce;\n  animation-name: bounce;\n}\n\n.tada.transition {\n  -webkit-animation-duration: 750ms;\n  animation-duration: 750ms;\n  -webkit-animation-name: tada;\n  animation-name: tada;\n}\n\n.pulse.transition {\n  -webkit-animation-duration: 500ms;\n  animation-duration: 500ms;\n  -webkit-animation-name: pulse;\n  animation-name: pulse;\n}\n\n.jiggle.transition {\n  -webkit-animation-duration: 750ms;\n  animation-duration: 750ms;\n  -webkit-animation-name: jiggle;\n  animation-name: jiggle;\n}\n\n.transition.glow {\n  -webkit-animation-duration: 2000ms;\n  animation-duration: 2000ms;\n  -webkit-animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n.transition.glow {\n  -webkit-animation-name: glow;\n  animation-name: glow;\n}\n\n/* Flash */\n\n@-webkit-keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1;\n  }\n\n  25%, 75% {\n    opacity: 0;\n  }\n}\n\n@keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1;\n  }\n\n  25%, 75% {\n    opacity: 0;\n  }\n}\n\n/* Shake */\n\n@-webkit-keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translateX(-10px);\n    transform: translateX(-10px);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px);\n  }\n}\n\n@keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translateX(-10px);\n    transform: translateX(-10px);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px);\n  }\n}\n\n/* Bounce */\n\n@-webkit-keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  40% {\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px);\n  }\n\n  60% {\n    -webkit-transform: translateY(-15px);\n    transform: translateY(-15px);\n  }\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  40% {\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px);\n  }\n\n  60% {\n    -webkit-transform: translateY(-15px);\n    transform: translateY(-15px);\n  }\n}\n\n/* Tada */\n\n@-webkit-keyframes tada {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  10%, 20% {\n    -webkit-transform: scale(0.9) rotate(-3deg);\n    transform: scale(0.9) rotate(-3deg);\n  }\n\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale(1.1) rotate(3deg);\n    transform: scale(1.1) rotate(3deg);\n  }\n\n  40%, 60%, 80% {\n    -webkit-transform: scale(1.1) rotate(-3deg);\n    transform: scale(1.1) rotate(-3deg);\n  }\n\n  100% {\n    -webkit-transform: scale(1) rotate(0);\n    transform: scale(1) rotate(0);\n  }\n}\n\n@keyframes tada {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  10%, 20% {\n    -webkit-transform: scale(0.9) rotate(-3deg);\n    transform: scale(0.9) rotate(-3deg);\n  }\n\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale(1.1) rotate(3deg);\n    transform: scale(1.1) rotate(3deg);\n  }\n\n  40%, 60%, 80% {\n    -webkit-transform: scale(1.1) rotate(-3deg);\n    transform: scale(1.1) rotate(-3deg);\n  }\n\n  100% {\n    -webkit-transform: scale(1) rotate(0);\n    transform: scale(1) rotate(0);\n  }\n}\n\n/* Pulse */\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Jiggle */\n\n@-webkit-keyframes jiggle {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1);\n  }\n\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n@keyframes jiggle {\n  0% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n\n  30% {\n    -webkit-transform: scale3d(1.25, 0.75, 1);\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    -webkit-transform: scale3d(0.75, 1.25, 1);\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    -webkit-transform: scale3d(1.15, 0.85, 1);\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    -webkit-transform: scale3d(0.95, 1.05, 1);\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    -webkit-transform: scale3d(1.05, 0.95, 1);\n    transform: scale3d(1.05, 0.95, 1);\n  }\n\n  100% {\n    -webkit-transform: scale3d(1, 1, 1);\n    transform: scale3d(1, 1, 1);\n  }\n}\n\n/* Glow */\n\n@-webkit-keyframes glow {\n  0% {\n    background-color: #FCFCFD;\n  }\n\n  30% {\n    background-color: #FFF6CD;\n  }\n\n  100% {\n    background-color: #FCFCFD;\n  }\n}\n\n@keyframes glow {\n  0% {\n    background-color: #FCFCFD;\n  }\n\n  30% {\n    background-color: #FFF6CD;\n  }\n\n  100% {\n    background-color: #FCFCFD;\n  }\n}\n\n/*******************************\n         Site Overrides\n*******************************/", ""]);

// exports


/***/ }),
/* 3538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n.DayPicker {\n  padding: 0;\n}\n\n.DayPicker-WeekdaysRow {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.DayPicker-WeekdaysRow abbr[title] {\n  text-decoration: none;\n}\n\n.DayPicker-Weekday {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\ndiv.DayPicker {\n  outline: none;\n}\n\ndiv.DayPicker-Body {\n  width: 400px;\n  height: 400px;\n}\n\ndiv.DayPicker-NavBar {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.DayPicker-NavButton.DayPicker-NavButton--next {\n  right: 1em;\n}\n\ndiv.DayPicker-Week {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\ndiv.DayPicker-Day {\n  /* prevents div from resizing when adding/removing border */\n  border: 1px solid transparent;\n  border-radius: 50%;\n  outline: none;\n  padding: 0.25em;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\ndiv.DayPicker-Day--wrapper {\n  width: 2em;\n  height: 2em;\n  margin: auto;\n  padding-top: 1em;\n  border-radius: 50%;\n}\n\ndiv.DayPicker-Month {\n  margin: 0;\n  width: 100%;\n  border-collapse: separate;\n}\n\ndiv.DayPicker-Day--today .DayPicker-Day--wrapper {\n  border: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.8);\n}\n\ndiv.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  background: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n\ndiv.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) .DayPicker-Day--wrapper {\n  border: none;\n  background: rgba(0, 0, 0, 0.2);\n  color: rgba(0, 0, 0, 0.8);\n}\n\ndiv.DayPicker-Day--isTentative .DayPicker-Day--wrapper {\n  background: #FCEDAD;\n}\n\ndiv.DayPicker-Day--isBooked .DayPicker-Day--wrapper {\n  background: #A7E3BA;\n}\n\ndiv.DayPicker-Day--isCanceled .DayPicker-Day--wrapper {\n  background: #ED8482;\n}\n", ""]);

// exports


/***/ }),
/* 3539 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n.background-enter {\n  max-height: 0;\n\toverflow: hidden;\n}\n.background-enter.background-enter-active {\n  max-height: 500px;\n  transition: max-height 500ms ease-in-out;\n}\n.background-leave {\n  max-height: 500px;\n}\n.background-leave.background-leave-active {\n  max-height: 0;\n  transition: max-height 500ms ease-in-out;\n}\n", ""]);

// exports


/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n/*\n// ----------------------------------------------------------------------------\n// Layout\n// ----------------------------------------------------------------------------\n*/\n\n.App__container___3A6uH {\n  min-height: 100vh\n}\n\n@media only screen and (min-width: 992px) {.App__container___3A6uH {\n    margin-top: 2em;\n  }\n  }\n\n// TODO: remove if not being used\n.App__segmentContainer___1eU3n {\n  border: none !important;\n  box-shadow: 0px 1px 0px 0px #DEDEDF, 0px 0px 3px 1px #DEDEDF !important\n}\n\n@media only screen and (max-width: 991px) {// TODO: remove if not being used\n.App__segmentContainer___1eU3n {\n    box-shadow: none !important;\n    padding: 1em 0em !important;\n  }\n  }\n\n.App__mobileTopPadding___1Fw0D // Adds padding to top of page to offset top navigation on mobile\n  @media only screen and (max-width: 991px) {\n  padding-top: 1em;\n}\n\n.App__root___2f6m5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  /* Prevent flickering due to Fastclick.js */\n  -webkit-tap-highlight-color: transparent;\n  /* Enable scroll acceleration for touch devices */\n  -webkit-overflow-scrolling: touch;\n}\n\n@media only screen and (max-width: 991px) {.App__root___2f6m5 {\n    background-color: #ffffff;\n  }\n  }\n\n/*\n// ----------------------------------------------------------------------------\n// Header\n// ----------------------------------------------------------------------------\n*/\n\n.App__header___2XmrZ {\n  background: white;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.App__headerMenuItem___2-AVn {\n  margin-right: 2em !important;\n}\n\n.App__mobileHeader___3L1sc {\n\n  /* Push content up when hidden */\n  /* Necessary because positioning is fixed */\n  margin: -1em 0 !important\n\n  /* Reset margins when header is displayed */\n\n}\n\n@media only screen and (max-width: 991px) {.App__mobileHeader___3L1sc {\n    margin: auto !important;\n    font-size: 1.14285714rem;\n    min-height: 2.85714286em;\n  }\n  }\n\n.App__grey___1vDf9 {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.App__searchIcon___1z_Zr {\n  color: rgba(0, 0, 0, 0.4);\n  padding: 0 1em\n}\n\n.App__searchIcon___1z_Zr:hover {\n    color: #59D98D;\n}\n\n@media only screen and (max-width: 1024px) {.App__searchIcon___1z_Zr:hover {\n      color: rgba(0, 0, 0, 0.4);\n  }\n    }\n\n.App__searchIcon___1z_Zr:hover.App__searchIconActive___Bxlla {\n      color: #59D98D;\n}\n\n.App__searchIconActive___Bxlla {\n  color: #59D98D;\n}\n\n.pt-popover-target .pt-popover.pt-popover-content-sizing {\n  width: auto !important;\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.pt-popover-target .pt-popover.pt-popover-content-sizing .pt-popover-content {\n  max-width: none;\n}\n\n@media only screen and (max-width: 991px) {.ui.menu.topNavMobile a.item.active {\n    color: #59D98D;\n    background: transparent;\n  }.ui.menu.topNavMobile a.item {}.ui.menu.topNavMobile a.item:hover, .ui.menu.topNavMobile a.item:active, .ui.menu.topNavMobile a.item:focus {\n    color: inherit;\n    background: transparent;\n  }\n  }\n\n.App__search___LXusm input {\n  padding-left: 2.67142857em;\n}\n\n/*\n// ----------------------------------------------------------------------------\n// Sidebar\n// ----------------------------------------------------------------------------\n*/\n\n.App__sidebar___1nFJc a {\n  text-transform: uppercase !important;\n}\n\n@media only screen and (max-width: 991px) {.App__sidebar___1nFJc {\n    /* Disable fixed width sidebar on mobile */\n    width: auto !important;\n  }\n  }\n\n.App__mobileSidebar___pBlIb {\n  background: #ffffff;\n}\n\n/*\n// ----------------------------------------------------------------------------\n// Settings\n// ----------------------------------------------------------------------------\n*/\n\n.App__helperText___3E7W3 {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.App__settingsHeading___wWrRE {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.App__settingsLabels___2KSU0 {\n  text-align: right;\n  padding-top: 1.75em\n}\n\n@media only screen and (max-width: 768px) {.App__settingsLabels___2KSU0 {\n    text-align: left;\n  }\n  }\n\n.App__warning___fsgtc {\n  padding-left: 1em;\n}\n\n/*\n// ----------------------------------------------------------------------------\n// UI Elements\n// ----------------------------------------------------------------------------\n*/\n\nimg.App__logo___lGxs0 {\n  margin: 20px 0 40px 0;\n}\n\n.App__actionsMenuSecondaryItem___1Aumc {\n  color: #DEDEDF\n}\n\n.App__actionsMenuSecondaryItem___1Aumc:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n", ""]);

// exports
exports.locals = {
	"container": "App__container___3A6uH",
	"segmentContainer": "App__segmentContainer___1eU3n",
	"mobileTopPadding": "App__mobileTopPadding___1Fw0D",
	"root": "App__root___2f6m5",
	"header": "App__header___2XmrZ",
	"headerMenuItem": "App__headerMenuItem___2-AVn",
	"mobileHeader": "App__mobileHeader___3L1sc",
	"grey": "App__grey___1vDf9",
	"searchIcon": "App__searchIcon___1z_Zr",
	"searchIconActive": "App__searchIconActive___Bxlla",
	"search": "App__search___LXusm",
	"sidebar": "App__sidebar___1nFJc",
	"mobileSidebar": "App__mobileSidebar___pBlIb",
	"helperText": "App__helperText___3E7W3",
	"settingsHeading": "App__settingsHeading___wWrRE",
	"settingsLabels": "App__settingsLabels___2KSU0",
	"warning": "App__warning___fsgtc",
	"logo": "App__logo___lGxs0",
	"actionsMenuSecondaryItem": "App__actionsMenuSecondaryItem___1Aumc"
};

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.PaymentMethods__paymentMethodToggle___35jVA {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin-bottom: 2em;\n  text-align: right;\n}\n\n.PaymentMethods__paymentMethodIndicator___25heK {\n  float: right;\n}\n\n.PaymentMethods__paymentMethodEnabled___3bW5E {\n  color: #59D98D;\n  font-weight: normal;\n}\n\n.PaymentMethods__paymentMethodDisabled___iT_91 {\n  font-weight: normal;\n}\n", ""]);

// exports
exports.locals = {
	"paymentMethodToggle": "PaymentMethods__paymentMethodToggle___35jVA",
	"paymentMethodIndicator": "PaymentMethods__paymentMethodIndicator___25heK",
	"paymentMethodEnabled": "PaymentMethods__paymentMethodEnabled___3bW5E",
	"paymentMethodDisabled": "PaymentMethods__paymentMethodDisabled___iT_91"
};

/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.globalHeaderSearch .ui.icon.input input {\n  background: #F7F8F7 !important;\n  border: none !important;\n  padding-left: 2.67142857em !important;\n  padding-right: 0 !important;\n  padding-top: 0.75em !important;\n  padding-bottom: 0.75em !important;\n  width: 100% !important;\n}\n\n.globalHeaderSearch .ui.icon.input > i.icon {\n  left: 0 !important;\n  right: auto !important;\n}\n\n.globalHeaderSearch.fluid > .ui.icon.input {\n  width: 100% !important;\n  background: #F7F8F7 !important;\n  border-radius: 3px;\n}\n\n.search__cardBorder___2Jl_e {\n  width: 6px;\n  position: absolute;\n  /* Offsets card border */\n  left: -1.1em;\n  top: -1em;\n  bottom: -1em;\n}\n\n.search__cardBorderPrimary___1SDOV {\n  background: #59D98D;\n}\n\n.search__cardBorderTentative___2ef7D {\n  background: #F9DC5C;\n}\n\n.search__cardBorderCanceled___3xnOd {\n  background: #DB2828;\n}\n", ""]);

// exports
exports.locals = {
	"cardBorder": "search__cardBorder___2Jl_e",
	"cardBorderPrimary": "search__cardBorderPrimary___1SDOV search__cardBorder___2Jl_e",
	"cardBorderTentative": "search__cardBorderTentative___2ef7D search__cardBorder___2Jl_e",
	"cardBorderCanceled": "search__cardBorderCanceled___3xnOd search__cardBorder___2Jl_e"
};

/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n.Contract__signatureLine___1z6Od {\n  color: rgba(0, 0, 0, 0.4);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.4);\n  font-size: 2rem;\n  line-height: 1rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  padding-bottom: 0.5rem;\n  position: absolute;\n  bottom: 33%;\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.Contract__card___3-5Ye {\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n  margin: 1rem 0;\n  padding: 1rem;\n}\n\n.Contract__headerButton___LmQtp {\n  padding: 0.5em 1.5em !important;\n}\n\n.Contract__legalNotice___Rcl0N {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  color: rgba(0, 0, 0, 0.4)\n}\n\n@media only screen and (max-width: 768px) {.Contract__legalNotice___Rcl0N {\n    bottom: 0.5rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    pointer-events: none;\n  }\n  }\n\n.Contract__helperText___1_7GP {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Contract__modalCancel___38Ixw {\n  color: rgba(0, 0, 0, 0.4);\n  margin-right: 2em\n}\n\n.Contract__modalCancel___38Ixw:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.Contract__redLink___22Ntl {\n  color: #DB2828\n}\n\n.Contract__redLink___22Ntl:hover {\n    color: #DB2828;\n}\n\n.Contract__sigContainer___1QzwI {\n  border: 1px solid #DEDEDF;\n  position: relative;\n  width: 100%;\n  height: 200px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  /* Prevent grey highlight on holding down signature pad */\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n}\n\n.Contract__signaturePadReset___lAhG1 {\n  color: rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  right: 0.5em;\n  text-align: right;\n  top: 0.5em;\n  padding: 0.5em;\n}\n\n.Contract__signatureError___dw43o {\n  border: 1px solid #DB2828 !important;\n}\n\n.Contract__signatureErrorText___2YIAE {\n  color: #DB2828;\n}\n\n.Contract__signatureBlock___QJHsc {\n  border: 1px solid #DEDEDF;\n  border-left-width: 8px;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 0 1em;\n  transition: border-color ease-in-out .3s;\n}\n\n.Contract__signatureBlockDisabled___3SmHn {\n  border-color: #F7F8F7;\n  color: rgba(0, 0, 0, 0.4);\n  cursor: default;\n}\n\n.Contract__signatureBlockSelected___1cRS9 {\n  border-color: #59D98D;\n}\n\n.Contract__signaturePreview___2zuIv {\n  margin-bottom: 0.5em;\n  margin-top: 1em !important;\n  font-family: 'Allura',cursive;\n  font-size: 3rem;\n  line-height: 3rem;\n}\n\n.Contract__signaturePreviewSample___2cJqA {\n  color: #DEDEDF;\n}\n\n.Contract__signerCount___3Kry3 {\n  font-size: 1rem;\n  text-transform: uppercase;\n}\n\n.Contract__shareSignatureTimestamp___3mK9e {\n  padding: 0 1em 1em 1em;\n}\n\n.Contract__signatureLine___1z6Od {\n  bottom: 33%;\n  left: 1rem;\n  right: 1rem\n}\n\n@media only screen and (max-width: 768px) {.Contract__signatureLine___1z6Od {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  }\n\n.Contract__typeSignatureInput___2GYWB {\n  border: 1px solid #DEDEDF;\n  display: block;\n  width: 100%;\n  height: 200px;\n  font-family: 'Allura',cursive;\n  font-size: 3rem;\n  line-height: 3rem;\n  outline: none;\n  padding: 1rem;\n  padding-top: 4rem;\n  padding-left: 4rem;\n  padding-right: 2rem;\n  transition: 300ms ease all\n}\n\n@media only screen and (max-width: 768px) {.Contract__typeSignatureInput___2GYWB {\n    font-size: 4rem;\n    padding-top: 3rem;\n    padding-left: 3.5rem;\n    padding-right: 1.5rem;\n  }\n  }\n\n.Contract__typeSignatureInput___2GYWB:focus {\n    border-color: rgba(0, 0, 0, 0.65);\n}\n", ""]);

// exports
exports.locals = {
	"signatureLine": "Contract__signatureLine___1z6Od Contract__signatureLine___1z6Od",
	"card": "Contract__card___3-5Ye",
	"headerButton": "Contract__headerButton___LmQtp",
	"legalNotice": "Contract__legalNotice___Rcl0N",
	"helperText": "Contract__helperText___1_7GP",
	"modalCancel": "Contract__modalCancel___38Ixw",
	"redLink": "Contract__redLink___22Ntl",
	"sigContainer": "Contract__sigContainer___1QzwI",
	"signaturePadReset": "Contract__signaturePadReset___lAhG1",
	"signatureError": "Contract__signatureError___dw43o",
	"signatureErrorText": "Contract__signatureErrorText___2YIAE",
	"signatureBlock": "Contract__signatureBlock___QJHsc",
	"signatureBlockDisabled": "Contract__signatureBlockDisabled___3SmHn",
	"signatureBlockSelected": "Contract__signatureBlockSelected___1cRS9 Contract__signatureBlock___QJHsc",
	"signaturePreview": "Contract__signaturePreview___2zuIv",
	"signaturePreviewSample": "Contract__signaturePreviewSample___2cJqA Contract__signaturePreview___2zuIv",
	"signerCount": "Contract__signerCount___3Kry3",
	"shareSignatureTimestamp": "Contract__shareSignatureTimestamp___3mK9e",
	"typeSignatureInput": "Contract__typeSignatureInput___2GYWB"
};

/***/ }),
/* 3544 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n {\n  margin-bottom: 2em;\n}\n\n.headerNav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0 2em;\n  height: 2rem;\n  line-height: 2rem;\n  vertical-align: middle;\n}\n\n.headerNav a.item {\n  color: inherit;\n}\n\n.ui.form .ui.transparent.input input {\n  border: 0;\n}\n\n.Document__actionsMenuDesktop___trWUZ {\n  max-width: 180px\n}\n\n@media print {.Document__actionsMenuDesktop___trWUZ {\n    display: none !important;\n  }\n  }\n\n.Document__actionsMenuTablet___1g5my {\n}\n\n@media print {.Document__actionsMenuTablet___1g5my {\n    display: none !important;\n  }\n  }\n\n.Document__actionButton___59c6Z {\n  background: #FFF !important;\n  margin-left: 2em !important\n}\n\n@media only screen and (max-width: 768px) {.Document__actionButton___59c6Z {\n    display: block !important;\n    margin: 0 auto !important;\n    margin-top: 1em !important;\n  }\n  }\n\n.Document__actionPrompt___3qsJd {\n  bottom: 0;\n  color: #fff;\n  font-size: 1.4em;\n  line-height: 1.4em;\n  left: 0;\n  position: fixed;\n  text-align: center;\n  width: 100%;\n}\n\n.Document__actionPromptDesktop___3pTA4 {\n  background: #59D98D;\n  padding: 2rem;\n}\n\n.Document__actionPromptMobile___3QDEa {\n  border-top: 1px solid #DEDEDF;\n}\n\n.Document__actionPromptCompleted___l5yof {\n  background: #333;\n}\n\n.Document__documentOffset___2v6kG {\n  margin-bottom: 10em !important;\n  margin-top: 2em\n}\n\n@media only screen and (max-width: 768px) {.Document__documentOffset___2v6kG {\n    margin-top: 0;\n    margin-bottom: 3rem;\n  }\n  }\n\n.Document__sidebar___1F54Q {\n  background: #ffffff\n}\n\n@media print {.Document__sidebar___1F54Q {\n    box-shadow: none !important;\n  }\n  }\n\n@media print {\n  .Document__mobileSidebarContent___u_n5- {\n    position: relative !important;\n  }\n\n  .Document__mobileSidebarRoot___3T3Cf {\n    position: relative !important;\n  }\n  .Document__mobileActionMenu___3CV2D {\n    display: none !important;\n  }\n}\n\n.Document__container___3vkzn {\n  margin-bottom: 2em;\n  width: 860px !important\n}\n\n@media only screen and (max-width: 992px) {.Document__container___3vkzn {\n    width: 768px !important;\n  }\n  }\n\n.Document__documentName___2zgX4 {\n  font-size: 1.25rem;\n  padding: 0.5em 0;\n}\n\n.Document__modalSecondaryAction___32rjv {\n  color: rgba(0, 0, 0, 0.4);\n  margin-right: 2em\n}\n\n.Document__modalSecondaryAction___32rjv:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.Document__grey___2m7aN {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Document__saveIndicator___2uFaj {\n  color: #DEDEDF;\n  font-style: italic;\n}\n\n.Document__mobileActionMenu___3CV2D {\n  position: fixed;\n  overflow: auto;\n  width: 100%;\n  max-height: calc(100% - 3.85714em);\n  z-index: 1;\n  background: #fff;\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.Document__mobileActionMenuClose___2nTvd {\n  background: #FAFBFA;\n  border-top: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  text-align: center;\n  padding: 1em;\n  font-size: 1rem\n}\n\n.Document__mobileActionMenuClose___2nTvd:hover {\n    background: #DEDEDF;\n}\n\n.Document__actionMenuItem___5FToC {\n  color: rgba(0, 0, 0, 0.4) !important;\n  cursor: pointer;\n  font-size: 1rem\n}\n\n@media only screen and (max-width: 768px) {.Document__actionMenuItem___5FToC {\n    padding: 1em !important;\n  }\n  }\n\n.Document__titleInput___3NDsA {\n  font-size: 1.25rem !important;\n  border: none !important;\n  outline: none !important;\n  width: 100% !important;\n  padding: 0.5rem !important;\n}\n\n.Document__titleTextArea___b5_O1 {\n  font-weight: normal !important;\n  resize: none !important;\n  border: none !important;\n  outline: none;\n  word-break: break-word;\n  padding: 0 !important;\n  padding-right: 1.5rem !important;\n  width: 100%;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Document__invoiceNumber___22KsV {\n  background: #F7F8F7;\n  text-align: center;\n  border-bottom: 1px solid #DEDEDF;\n  color: rgba(0, 0, 0, 0.4);\n  padding: 1rem;\n}\n\n.Document__alignRight___3lFc1 {\n  text-align: right;\n}\n\n.Document__header___bRNSH {\n  margin-bottom: 2em !important;\n  padding: 0.75em !important\n}\n\n@media print {.Document__header___bRNSH {\n    display: none;\n  }\n  }\n\n.Document__segment___Q46CM {\n}\n\n@media print {.Document__segment___Q46CM {\n    border: none !important;\n  }\n  }\n\n.Document__heading___2rE6f {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.Document__section___3N45B {\n  margin-top: 2em;\n}\n\n.Document__to___3SF07 {\n  color: rgba(0, 0, 0, 0.4);\n  font-weight: normal;\n}\n", ""]);

// exports
exports.locals = {
	"actionsMenuDesktop": "Document__actionsMenuDesktop___trWUZ",
	"actionsMenuTablet": "Document__actionsMenuTablet___1g5my",
	"actionButton": "Document__actionButton___59c6Z",
	"actionPrompt": "Document__actionPrompt___3qsJd",
	"actionPromptDesktop": "Document__actionPromptDesktop___3pTA4 Document__actionPrompt___3qsJd",
	"actionPromptMobile": "Document__actionPromptMobile___3QDEa Document__actionPrompt___3qsJd",
	"actionPromptCompleted": "Document__actionPromptCompleted___l5yof",
	"documentOffset": "Document__documentOffset___2v6kG",
	"sidebar": "Document__sidebar___1F54Q",
	"mobileSidebarContent": "Document__mobileSidebarContent___u_n5-",
	"mobileSidebarRoot": "Document__mobileSidebarRoot___3T3Cf",
	"mobileActionMenu": "Document__mobileActionMenu___3CV2D",
	"container": "Document__container___3vkzn",
	"documentName": "Document__documentName___2zgX4",
	"modalSecondaryAction": "Document__modalSecondaryAction___32rjv",
	"grey": "Document__grey___2m7aN",
	"saveIndicator": "Document__saveIndicator___2uFaj",
	"mobileActionMenuClose": "Document__mobileActionMenuClose___2nTvd",
	"actionMenuItem": "Document__actionMenuItem___5FToC",
	"titleInput": "Document__titleInput___3NDsA",
	"titleTextArea": "Document__titleTextArea___b5_O1",
	"invoiceNumber": "Document__invoiceNumber___22KsV",
	"alignRight": "Document__alignRight___3lFc1",
	"header": "Document__header___bRNSH",
	"segment": "Document__segment___Q46CM",
	"heading": "Document__heading___2rE6f",
	"section": "Document__section___3N45B",
	"to": "Document__to___3SF07"
};

/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 767px) {\n  .Form__desktop___v8wK7 {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .Form__mobile___yh6wP {\n    display: none !important;\n  }\n}\n\n.Form__visible___1WT6o {\n  visibility: visible;\n}\n\n.Form__invisible___2fNQt {\n  visibility: hidden;\n}\n\n.Form__borderGrey___3MJ17 {\n  color: #DEDEDF;\n}\n\n.Form__subtext___QsIZe {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Form__negative___3xRFq {\n  color: #DB2828\n}\n\n.Form__negative___3xRFq:hover {\n    color: #DB2828;\n}\n\n.Form__questionPlaceholder___1dMlb {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Form__delete___2wQlM {\n  color: #DEDEDF;\n  font-size: 1.25em\n}\n\n.Form__delete___2wQlM:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.Form__deleteItemRelative___2HAbv {\n  cursor: pointer;\n}\n\n.Form__deleteItemRelative___2HAbv i {\n  color: #DEDEDF;\n  font-weight: 100;\n  transition: color 0.3s ease-in-out\n}\n\n.Form__deleteItemRelative___2HAbv i:hover, .Form__deleteItemRelative___2HAbv i:focus {\n  color: #DB2828;\n}\n\n.Form__fieldSpacing___3LyNK {\n  margin-bottom: 1em;\n}\n\n.Form__responseField___3j_vG {\n  max-width: 400px;\n}\n\n.Form__fieldDescription___8cvUr {\n  color: rgba(0, 0, 0, 0.4);\n  margin-bottom: 1em;\n  max-width: 600px;\n}\n\n.Form__fieldTitle___vaGlG {\n  margin-bottom: 0.25em;\n}\n\n.Form__handle___3nESS {\n  background-image: radial-gradient(rgba(0, 0, 0, 0.4) 40%, transparent 40%);\n  background-size: 4px 4px;\n  background-position: 100% 0;\n  background-repeat: repeat-y;\n}\n\n.Form__dragHandle___1nrYr {\n  display: inline-block;\n  width: 8px;\n  height: 12px;\n}\n\n.Form__dragHandle___1nrYr::before {\n    background-image: radial-gradient(rgba(0, 0, 0, 0.4) 40%, transparent 40%);\n    background-size: 4px 4px;\n    background-position: 100% 0;\n    background-repeat: repeat-y;\n    content: '';\n    display: block;\n    width: 33%;\n    height: 100%;\n}\n\n.Form__dragHandleContainer___By91V {\n  padding: 3em 1em;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n.Form__noBorderBottom___3c6hk {\n  border-bottom: none;\n}\n\n.Form__noBorderBottom___3c6hk div {\n  border-bottom: none !important;\n}\n\n.Form__changesSaved___2-uD4 {\n  text-align: right;\n  color: rgba(0, 0, 0, 0.4);\n  font-style: italic;\n  margin-right: 2em;\n}\n\n.Form__cancel___38B0A {\n  color: rgba(0, 0, 0, 0.4);\n  margin-left: 1em;\n}\n\n.Form__cancel___38B0A:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "Form__desktop___v8wK7",
	"mobile": "Form__mobile___yh6wP",
	"visible": "Form__visible___1WT6o",
	"invisible": "Form__invisible___2fNQt",
	"borderGrey": "Form__borderGrey___3MJ17",
	"subtext": "Form__subtext___QsIZe",
	"negative": "Form__negative___3xRFq",
	"questionPlaceholder": "Form__questionPlaceholder___1dMlb",
	"delete": "Form__delete___2wQlM",
	"deleteItemRelative": "Form__deleteItemRelative___2HAbv",
	"fieldSpacing": "Form__fieldSpacing___3LyNK",
	"responseField": "Form__responseField___3j_vG",
	"fieldDescription": "Form__fieldDescription___8cvUr",
	"fieldTitle": "Form__fieldTitle___vaGlG",
	"handle": "Form__handle___3nESS",
	"dragHandle": "Form__dragHandle___1nrYr Form__handle___3nESS",
	"dragHandleContainer": "Form__dragHandleContainer___By91V",
	"noBorderBottom": "Form__noBorderBottom___3c6hk",
	"changesSaved": "Form__changesSaved___2-uD4",
	"cancel": "Form__cancel___38B0A"
};

/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Invoice__paymentAmountDescription___2sTRP {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Invoice__rightAlignedField___GLv17 input {\n  text-align: right;\n}\n\n.Invoice__rightAlignedField___GLv17 label {\n  -webkit-transform-origin: right top;\n          transform-origin: right top;\n}\n\n.Invoice__warning___2u6me {\n  color: #DB2828;\n}\n", ""]);

// exports
exports.locals = {
	"paymentAmountDescription": "Invoice__paymentAmountDescription___2sTRP",
	"rightAlignedField": "Invoice__rightAlignedField___GLv17",
	"warning": "Invoice__warning___2u6me"
};

/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.textAlignRight > div > input {\n  text-align: right;\n}\n\n.strong > div > input {\n  font-weight: bold;\n}\n\n.ui.inline.dropdown.strong > .text {\n  font-weight: bold;\n}\n\n.ui.transparent.input > input {\n  border: 0;\n}\n\n.Proposal__description___2jtfa {\n  color: rgba(0, 0, 0, 0.4);\n  white-space: pre-line;\n}\n\n.Proposal__description___2jtfa p {\n  margin: 0 !important;\n}\n\n.Proposal__qtyPrice___2-gA2 {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 0.875em;\n}\n\n.Proposal__itemTotalMobile___1npdq {\n  padding-top: 1em;\n  text-align: right;\n}\n\n.Proposal__noShadow___2aIL2 {\n  box-shadow: none !important;\n}\n\n.Proposal__verticalSpacing___3AYW9 {\n  margin-bottom: 2em;\n}\n\n.Proposal__addService___1YN1G {\n  box-shadow: 0px 2px 2px 0px #DEDEDF, 0px 2px 2px 0px #DEDEDF !important;\n}\n\n.Proposal__libraryItem___3N9cW {\n  cursor: pointer;\n  display: table;\n  vertical-align: middle;\n}\n\n.Proposal__itemSelected___3hOrL {\n  background: #59D98D;\n}\n", ""]);

// exports
exports.locals = {
	"description": "Proposal__description___2jtfa",
	"qtyPrice": "Proposal__qtyPrice___2-gA2",
	"itemTotalMobile": "Proposal__itemTotalMobile___1npdq",
	"noShadow": "Proposal__noShadow___2aIL2",
	"verticalSpacing": "Proposal__verticalSpacing___3AYW9",
	"addService": "Proposal__addService___1YN1G",
	"libraryItem": "Proposal__libraryItem___3N9cW",
	"itemSelected": "Proposal__itemSelected___3hOrL"
};

/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.Share__toField___1mXol input {\n  padding-right: 2.75em !important;\n}\n", ""]);

// exports
exports.locals = {
	"toField": "Share__toField___1mXol"
};

/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Brand__active___12q3g {\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.Brand__header___lTk7I p {\n  margin: 0;\n}\n\n.Brand__headerEdit___1vWy5:hover {\n  opacity: 0.5 !important;\n}\n", ""]);

// exports
exports.locals = {
	"active": "Brand__active___12q3g",
	"header": "Brand__header___lTk7I",
	"headerEdit": "Brand__headerEdit___1vWy5"
};

/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Description__description___g7cgW p {\n  margin: 0;\n}\n\n.Description__placeholder___11SNc {\n  cursor: pointer;\n  padding: 1em\n}\n\n.Description__placeholder___11SNc:hover {\n    background: #FAFBFA;\n}\n\n.Description__editIcon___3Hk2U {\n  color: #DEDEDF;\n  position: absolute;\n  top: 0.5em;\n  right: 1.5em;\n}\n", ""]);

// exports
exports.locals = {
	"description": "Description__description___g7cgW",
	"placeholder": "Description__placeholder___11SNc",
	"editIcon": "Description__editIcon___3Hk2U"
};

/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n@media only screen and (max-width: 767px) {\n  .LineItems__desktop___2WKT8 {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .LineItems__mobile___1qO-d {\n    display: none !important;\n  }\n}\n.LineItems__visible___gbS67 {\n  visibility: visible;\n}\n.LineItems__invisible___2oOZ6 {\n  visibility: hidden;\n}\n.LineItems__borderGrey___1cxIq {\n  color: #DEDEDF;\n}\n.LineItems__subtext___2WSOg {\n  color: rgba(0, 0, 0, 0.4);\n}\n.LineItems__negative___2vR82 {\n  color: #DB2828\n}\n.LineItems__negative___2vR82:hover {\n    color: #DB2828;\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.LineItems__dragHandle___15e5B {\n  content: '....';\n  width: 14px;\n  height: 20px;\n  display: inline-block;\n  overflow: hidden;\n  line-height: 5px;\n  padding: 3px 4px;\n  cursor: -webkit-grab;\n  cursor: grab;\n  vertical-align: middle;\n  margin-top: -1.2em;\n  margin-right: .3em;\n  font-size: 12px;\n  font-family: sans-serif;\n  letter-spacing: 2px;\n  color: #cccccc;\n  text-shadow: 1px 0 1px rgba(0, 0, 0, 0.4)\n}\n\n.LineItems__dragHandle___15e5B::after {\n    content: '.. .. .. ..';\n}\n\n.LineItems__dragHandleContainer___7n4FU {\n  padding: 0.5em;\n  cursor: -webkit-grab;\n  cursor: grab\n}\n\n@media only screen and (min-width: 992px) {.LineItems__dragHandleContainer___7n4FU {\n    visibility: hidden;\n  }\n  }\n\n.LineItems__draggableElement___2xQb5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center\n}\n\n.LineItems__draggableElement___2xQb5:hover .LineItems__dragHandleContainer___7n4FU, .LineItems__draggableElement___2xQb5:active .LineItems__dragHandleContainer___7n4FU {\n  visibility: visible;\n}\n\n.LineItems__inactiveDragHandle___EaFtw {\n}\n\n@media only screen and (min-width: 992px) {.LineItems__inactiveDragHandle___EaFtw {\n    visibility: hidden !important;\n  }\n  }\n", ""]);

// exports
exports.locals = {
	"desktop": "LineItems__desktop___2WKT8",
	"mobile": "LineItems__mobile___1qO-d",
	"visible": "LineItems__visible___gbS67",
	"invisible": "LineItems__invisible___2oOZ6",
	"borderGrey": "LineItems__borderGrey___1cxIq",
	"subtext": "LineItems__subtext___2WSOg",
	"negative": "LineItems__negative___2vR82",
	"dragHandle": "LineItems__dragHandle___15e5B",
	"dragHandleContainer": "LineItems__dragHandleContainer___7n4FU",
	"draggableElement": "LineItems__draggableElement___2xQb5",
	"inactiveDragHandle": "LineItems__inactiveDragHandle___EaFtw"
};

/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Logo__logoIcon___3DU6D {\n  color: #DEDEDF;\n  cursor: pointer;\n}\n\n.Logo__logoActions___3Txhv {\n  font-size: 1.25em;\n}\n", ""]);

// exports
exports.locals = {
	"logoIcon": "Logo__logoIcon___3DU6D",
	"logoActions": "Logo__logoActions___3Txhv"
};

/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Notepad__notepad___3ke27 textarea {\n  background: #FFFCEA !important;\n  border: none !important;\n  box-shadow: 0px 1px 4px 1px #DEDEDF !important;\n  transition: all 0.3s ease-in-out;\n}\n\n.Notepad__notepad___3ke27 textarea:focus, .Notepad__notepad___3ke27 textarea:active {\n  box-shadow: 0px 1px 10px 1px #DEDEDF !important;\n}\n", ""]);

// exports
exports.locals = {
	"notepad": "Notepad__notepad___3ke27"
};

/***/ }),
/* 3554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.Notes__notes___3yf_2 p {\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"notes": "Notes__notes___3yf_2"
};

/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.textAlignCenter input {\n  text-align: center;\n}\n\n.PaymentPlan__altRow___2Kw3V {\n  background: #FAFBFA;\n}\n\n.PaymentPlan__checkbox___1a_13 {\n  font-size: 1em !important;\n  padding: 0.5em;\n}\n\n.PaymentPlan__delete___22Z3Q {\n  position: absolute;\n  top: 1.75em;\n  left: 0.5em;\n  cursor: pointer;\n}\n\n.PaymentPlan__delete___22Z3Q i {\n  color: rgba(0, 0, 0, 0.4);\n  font-weight: 100;\n  transition: color 0.3s ease-in-out\n}\n\n.PaymentPlan__delete___22Z3Q i:hover, .PaymentPlan__delete___22Z3Q i:focus {\n  color: #DB2828;\n}\n\n.PaymentPlan__locked___2X0Ky {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.PaymentPlan__pplanItem___3qY_x {\n  position: relative;\n  padding-left: 2em;\n  padding-right: 2em\n}\n\n@media only screen and (max-width: 768px) {.PaymentPlan__pplanItem___3qY_x {\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n  }\n\n.PaymentPlan__totalError___2XpA6 {\n  color: #DB2828;\n  padding-top: 0.5em;\n  text-align: right;\n}\n", ""]);

// exports
exports.locals = {
	"altRow": "PaymentPlan__altRow___2Kw3V",
	"checkbox": "PaymentPlan__checkbox___1a_13",
	"delete": "PaymentPlan__delete___22Z3Q",
	"locked": "PaymentPlan__locked___2X0Ky",
	"pplanItem": "PaymentPlan__pplanItem___3qY_x",
	"totalError": "PaymentPlan__totalError___2XpA6"
};

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Recipient__active___pSiU0 {\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.Recipient__header___2jFTX p {\n  margin: 0;\n}\n\n.Recipient__headerEdit___1c_IQ:hover {\n  opacity: 0.5 !important;\n}\n", ""]);

// exports
exports.locals = {
	"active": "Recipient__active___pSiU0",
	"header": "Recipient__header___2jFTX",
	"headerEdit": "Recipient__headerEdit___1c_IQ"
};

/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n@media only screen and (max-width: 767px) {\n  .SignatureBlocks__desktop___33R3R {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .SignatureBlocks__mobile___DOdJh {\n    display: none !important;\n  }\n}\n.SignatureBlocks__visible___XFq2j {\n  visibility: visible;\n}\n.SignatureBlocks__invisible___3EIMd {\n  visibility: hidden;\n}\n.SignatureBlocks__borderGrey___ZinPx {\n  color: #DEDEDF;\n}\n.SignatureBlocks__subtext___379m7 {\n  color: rgba(0, 0, 0, 0.4);\n}\n.SignatureBlocks__negative___2gqYS {\n  color: #DB2828\n}\n.SignatureBlocks__negative___2gqYS:hover {\n    color: #DB2828;\n}\n.SignatureBlocks__signatureLine___3dRJK {\n  color: rgba(0, 0, 0, 0.4);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.4);\n  font-size: 2rem;\n  line-height: 1rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  padding-bottom: 0.5rem;\n  position: absolute;\n  bottom: 33%;\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.SignatureBlocks__active___3o-hY {\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.SignatureBlocks__delete___24zD2 {\n  position: absolute;\n  top: 1.5em;\n  left: -2em;\n  cursor: pointer;\n}\n\n.SignatureBlocks__delete___24zD2 i {\n  color: #DEDEDF;\n  font-weight: 100;\n  transition: color 0.3s ease-in-out\n}\n\n.SignatureBlocks__delete___24zD2 i:hover, .SignatureBlocks__delete___24zD2 i:focus {\n  color: #DB2828;\n}\n\n.SignatureBlocks__helpIcon___3VpYz {\n  position: absolute;\n  top: 1.5em;\n  right: -2em;\n  color: #DEDEDF;\n  font-weight: 100;\n  transition: color 0.3s ease-in-out\n}\n\n.SignatureBlocks__helpIcon___3VpYz:hover, .SignatureBlocks__helpIcon___3VpYz:focus {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.SignatureBlocks__signatureBlock___2-zIj p {\n  margin: 0;\n}\n\n.SignatureBlocks__optional___26myN {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.SignatureBlocks__signatureImage___1LDF5 {\n  margin-left: 2rem;\n  position: absolute;\n  left: -1rem;\n  max-width: calc(100% - 1rem);\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transform: translateY(16.5%);\n          transform: translateY(16.5%);\n  bottom: 0;\n}\n\n.SignatureBlocks__signatureText___3CCis {\n  position: absolute;\n  left: 1rem;\n  bottom: calc(33%);\n  -webkit-transform: translateY(0.25em);\n          transform: translateY(0.25em);\n  font-family: 'Allura',cursive;\n  margin-left: 2rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none\n}\n\n@media only screen and (max-width: 768px) {.SignatureBlocks__signatureText___3CCis {\n    margin-left: 1rem;\n  }\n  }\n\n.SignatureBlocks__signatureText___3CCis.SignatureBlocks__signatureTiny___1VDfQ {\n    -webkit-transform: translateY(0.125em);\n            transform: translateY(0.125em);\n}\n\n.SignatureBlocks__signatureContainer___1JaxE {\n  height: 100px;\n  position: relative;\n}\n\n.SignatureBlocks__signatureTimestamp___2uDS5 {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.SignatureBlocks__signatureTiny___1VDfQ {\n  font-size: 2.25rem;\n  line-height: 2.25rem\n}\n\n@media only screen and (max-width: 768px) {.SignatureBlocks__signatureTiny___1VDfQ {\n    font-size: 1.8rem;\n    line-height: 1.8rem;\n  }\n  }\n\n.SignatureBlocks__signatureSmall___UMi6n {\n  font-size: 2.75rem;\n  line-height: 2.75rem\n}\n\n@media only screen and (max-width: 768px) {.SignatureBlocks__signatureSmall___UMi6n {\n    font-size: 2.25rem;\n    line-height: 2.25rem;\n  }\n  }\n\n.SignatureBlocks__signatureLarge___3OebS {\n  font-size: 3rem;\n  line-height: 3rem;\n}\n\n.SignatureBlocks__signatureLine___3dRJK {\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "SignatureBlocks__desktop___33R3R",
	"mobile": "SignatureBlocks__mobile___DOdJh",
	"visible": "SignatureBlocks__visible___XFq2j",
	"invisible": "SignatureBlocks__invisible___3EIMd",
	"borderGrey": "SignatureBlocks__borderGrey___ZinPx",
	"subtext": "SignatureBlocks__subtext___379m7",
	"negative": "SignatureBlocks__negative___2gqYS",
	"signatureLine": "SignatureBlocks__signatureLine___3dRJK SignatureBlocks__signatureLine___3dRJK",
	"active": "SignatureBlocks__active___3o-hY",
	"delete": "SignatureBlocks__delete___24zD2",
	"helpIcon": "SignatureBlocks__helpIcon___3VpYz",
	"signatureBlock": "SignatureBlocks__signatureBlock___2-zIj",
	"optional": "SignatureBlocks__optional___26myN",
	"signatureImage": "SignatureBlocks__signatureImage___1LDF5",
	"signatureText": "SignatureBlocks__signatureText___3CCis",
	"signatureTiny": "SignatureBlocks__signatureTiny___1VDfQ",
	"signatureContainer": "SignatureBlocks__signatureContainer___1JaxE",
	"signatureTimestamp": "SignatureBlocks__signatureTimestamp___2uDS5",
	"signatureSmall": "SignatureBlocks__signatureSmall___UMi6n",
	"signatureLarge": "SignatureBlocks__signatureLarge___3OebS"
};

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.Terms__terms___Gfwqq p {\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"terms": "Terms__terms___Gfwqq"
};

/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n.TermsBuilder__inlineField___2o0ww {\n  max-width: 60px;\n}\n\n.TermsBuilder__inlineField___2o0ww input {\n  text-align: center;\n}\n\n.TermsBuilder__inlineFieldLabel___2Hdur {\n  margin-top: 0.5em;\n  display: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"inlineField": "TermsBuilder__inlineField___2o0ww",
	"inlineFieldLabel": "TermsBuilder__inlineFieldLabel___2Hdur"
};

/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.CardField__focused___IO1lL {\n  background: #FAFBFA;\n}\n\n.CardField__row___2qTwL {\n  padding: 0.2857142857rem !important\n}\n\n@media only screen and (max-width : 768px) {.CardField__row___2qTwL {\n    font-size: 16px !important;\n  }\n  }\n\n.CardField__input___38VSJ {\n  margin-top: 1px !important;\n  outline: none !important;\n}\n\n.CardField__checkboxOffset___hIhaH {\n  margin-top: 2px !important;\n}\n\n.CardField__datetimeOffset___1ZzWi {\n  margin-top: 2px !important;\n}\n\n.CardField__textArea___lyTmA {\n  background: transparent !important;\n  border: none !important;\n  padding: 0em !important;\n  resize: none !important;\n  outline: none !important;\n  width: 100%;\n}\n\n.CardField__descriptionListItem___3qv-6 {\n  padding: 0.5em !important;\n}\n\n.CardField__dropdown___cDYSz > .CardField__menu___1i3mJ {\n  width: 100%;\n}\n\n.CardField__error___3pAQ5 {\n  background: rgba(255, 216, 216, 1);\n}\n\n.CardField__error___3pAQ5.CardField__focused___IO1lL {\n  background: rgb(242, 217, 217);\n}\n\n.CardField__errorMessage___2VrkF {\n  color: rgba(159, 58, 56, 0.8);\n  font-size: 1rem;\n  font-weight: normal;\n}\n\n.cardFieldSelect .menu {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"focused": "CardField__focused___IO1lL",
	"row": "CardField__row___2qTwL",
	"input": "CardField__input___38VSJ",
	"checkboxOffset": "CardField__checkboxOffset___hIhaH",
	"datetimeOffset": "CardField__datetimeOffset___1ZzWi",
	"textArea": "CardField__textArea___lyTmA",
	"descriptionListItem": "CardField__descriptionListItem___3qv-6 CardField__row___2qTwL",
	"dropdown": "CardField__dropdown___cDYSz",
	"menu": "CardField__menu___1i3mJ",
	"error": "CardField__error___3pAQ5",
	"errorMessage": "CardField__errorMessage___2VrkF"
};

/***/ }),
/* 3561 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\ninput[type=\"date\"]:not(.hasValue):focus::before, input[type=\"datetime-local\"]:not(.hasValue):focus::before {\n  content: \"\" !important;\n}\n\ninput[type=\"date\"]:not(.hasValue):focus, input[type=\"datetime-local\"]:not(.hasValue):focus {\n  color: rgba(0, 0, 0, 0.8);\n}\n\ninput[type=\"date\"], input[type=\"datetime-local\"] {}\n\ninput[type=\"date\"]:not(.hasValue), input[type=\"datetime-local\"]:not(.hasValue) {\n  color: #ffffff;\n}\n\ninput[type=\"date\"]:not(.hasValue)::before, input[type=\"datetime-local\"]:not(.hasValue)::before {\n  color: rgba(191, 191, 191, 0.8);\n  content: attr(placeholder);\n}\n", ""]);

// exports


/***/ }),
/* 3562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\ntextarea.EditableText__input___B0V56, input.EditableText__input___B0V56 {\n  margin: -2px;\n  border: 1px solid transparent;\n  outline: none;\n  resize: none\n}\n\ntextarea.EditableText__input___B0V56:hover, textarea.EditableText__input___B0V56:focus, input.EditableText__input___B0V56:hover, input.EditableText__input___B0V56:focus {\n    background: #FAFBFA;\n    border: 1px solid #DEDEDF;\n}\n\n.EditableText__fluid___2QYeY {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"input": "EditableText__input___B0V56",
	"fluid": "EditableText__fluid___2QYeY"
};

/***/ }),
/* 3563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Fab__fab___2-sSQ {\n  box-shadow: 1px 2px 6px 2px #DEDEDF !important\n}\n\n.Fab__fab___2-sSQ:hover {\n    box-shadow: 1px 4px 12px 2px #DEDEDF !important;\n}\n", ""]);

// exports
exports.locals = {
	"fab": "Fab__fab___2-sSQ"
};

/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n.FileIcon__fileTypeIcon___24GSd {\n  display: inline-block;\n  width: 30px;\n  height: 40px;\n  background: #F9F9F9;\n  position: relative;\n  border: 1px solid #E6E6E6;\n  border-radius: 2px;\n  box-shadow: inset 1px 1px 0 0 #ffffff, inset -1px -1px 0 0 #ffffff, inset 0 10px 20px -10px rgba(0,0,0,.05);\n}\n.FileIcon__corner___SA4QA {\n  display: block;\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  width: 0;\n  height: 0;\n  border-left: 10px solid #eeeeee;\n  border-top: 10px solid #ffffff; /*change this color if you want to use it on custom background*/\n  box-shadow:-1px 1px 0px 0 #E6E6E6;\n}\n.FileIcon__type___5J5Bk {\n  background: #777;\n  cursor: default;\n  text-align: center;\n  display: block;\n  position: absolute;\n  bottom: 6px;\n  left: -2px;\n  height: 10px;\n  line-height: 10px;\n  font-size: 6px;\n  color: #fff;\n  border-radius: 3px;\n  width: 20px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports
exports.locals = {
	"fileTypeIcon": "FileIcon__fileTypeIcon___24GSd",
	"corner": "FileIcon__corner___SA4QA",
	"type": "FileIcon__type___5J5Bk"
};

/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W {\n  border-bottom: 2px solid #DEDEDF;\n  border-radius: 2px;\n  padding: 0.25em 0;\n  margin-bottom: 0.25em;\n  transition: 300ms ease border-color;\n}\n\n/* Select Input */\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W input {\n  padding: 0.25em 0 !important;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W div[role=\"listbox\"] {\n  border: none !important;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W .default.text {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W .ui.selection.dropdown {\n  background: transparent;\n  min-width: initial;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W .ui.selection.dropdown .menu {\n  border: none;\n  width: auto;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W .ui.selection.dropdown .dropdown.icon {\n  top: 0.5em;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__isFocused___1xxIv {\n  border-bottom: 2px solid rgba(0, 0, 0, 0.65);\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W label {\n  color: rgba(0, 0, 0, 0.4);\n  cursor: text;\n  display: block;\n  font-size: 0.875em;\n  -webkit-transform-origin: left top;\n          transform-origin: left top;\n  -webkit-transform: scale(1.125) translate3d(0, 18px, 0);\n          transform: scale(1.125) translate3d(0, 18px, 0);\n  transition: 300ms ease all;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W input {\n  width: 100%;\n  border: 0 !important;\n  padding: 0.25rem 0 !important;\n  background: transparent !important;\n  outline: none;\n  transition: 300ms ease all;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__disabled___3TIm4 {\n  border-bottom-style: dotted;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__disabled___3TIm4 input {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__isActive___1gbM4 label, .FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__isFocused___1xxIv label {\n  -webkit-transform: translateY(0%);\n          transform: translateY(0%);\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__isActive___1gbM4.FloatingLabelInput__isFocused___1xxIv label {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__hasError___sFOl3 {\n  border-color: #DB2828;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__hasError___sFOl3.FloatingLabelInput__isActive___1gbM4.FloatingLabelInput__isFocused___1xxIv label {\n  color: #DB2828;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__inline___2j-BU {\n  margin-right: 1em;\n}\n\n.FloatingLabelInput__floatingLabelInput___1ZP1W.FloatingLabelInput__inline___2j-BU.FloatingLabelInput__last___3b5Y6 {\n  margin-right: 0;\n}\n\n.FloatingLabelInput__error___3ddOD {\n  color: #DB2828;\n  font-size: 0.875em;\n}\n\n.FloatingLabelInput__field___wOmDz {\n  margin-bottom: 1em;\n}\n\n.FloatingLabelInput__inlineBlock___12zRm {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.FloatingLabelInput__nativeSelect___3C3-N {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  width: 100%;\n  padding: calc(0.25em + 1px) 0 0.25em 0\n}\n\n.FloatingLabelInput__nativeSelect___3C3-N:focus {\n    outline: none;\n}\n\n.FloatingLabelInput__textarea___2prCd {\n  background: transparent !important;\n  border: 0 !important;\n  outline: 0 !important;\n  padding: 0.25em 0 !important;\n  resize: none !important;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"floatingLabelInput": "FloatingLabelInput__floatingLabelInput___1ZP1W",
	"isFocused": "FloatingLabelInput__isFocused___1xxIv",
	"disabled": "FloatingLabelInput__disabled___3TIm4",
	"isActive": "FloatingLabelInput__isActive___1gbM4",
	"hasError": "FloatingLabelInput__hasError___sFOl3",
	"inline": "FloatingLabelInput__inline___2j-BU",
	"last": "FloatingLabelInput__last___3b5Y6",
	"error": "FloatingLabelInput__error___3ddOD",
	"field": "FloatingLabelInput__field___wOmDz",
	"inlineBlock": "FloatingLabelInput__inlineBlock___12zRm",
	"nativeSelect": "FloatingLabelInput__nativeSelect___3C3-N",
	"textarea": "FloatingLabelInput__textarea___2prCd"
};

/***/ }),
/* 3566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.InputWithSuggestions__suggestions___3fXJ0 {\n  background: white;\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n  margin-top: 0.5em;\n  max-height: 220px;\n  position: absolute;\n  z-index: 1;\n  overflow-y: scroll;\n}\n\n.InputWithSuggestions__title___ZKnuF {\n  font-weight: bold;\n}\n\n.InputWithSuggestions__description___hE8hv {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.InputWithSuggestions__option___zP7PW {\n  border-bottom: 1px solid #DEDEDF;\n  cursor: pointer;\n  padding: 0.75em 1em;\n}\n\n.InputWithSuggestions__selected___23fom {\n  background-color: #FAFBFA;\n}\n", ""]);

// exports
exports.locals = {
	"suggestions": "InputWithSuggestions__suggestions___3fXJ0",
	"title": "InputWithSuggestions__title___ZKnuF",
	"description": "InputWithSuggestions__description___hE8hv",
	"option": "InputWithSuggestions__option___zP7PW",
	"selected": "InputWithSuggestions__selected___23fom"
};

/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.SelectableBlock__cardBorder___qM39J {\n  border-left-width: 8px !important;\n}\n\n.SelectableBlock__selectableBlock___1Orhs {\n  border: 1px solid #DEDEDF;\n  border-radius: 3px;\n  cursor: pointer;\n  padding: 1em;\n  position: relative;\n  transition: border-color ease-in-out .3s;\n}\n\n.SelectableBlock__showIndicator___Cd8rr {\n  padding-left: 67px !important;\n}\n\n.SelectableBlock__checkbox___ATx36 {\n  position: absolute;\n  font-size: 2em;\n  top: 50%;\n  left: 25px;\n  -webkit-transform: translateY(calc(-50% - 2px));\n          transform: translateY(calc(-50% - 2px));\n}\n\n.SelectableBlock__selectableBlockDisabled___yPbuf {\n  border-color: #F7F8F7;\n  color: rgba(0, 0, 0, 0.4);\n  cursor: default;\n}\n\n.SelectableBlock__selectableBlockSelected___3Nv26 {\n  border-color: #59D98D;\n}\n\n.SelectableBlock__grey___1307c {\n  border-color: rgba(0, 0, 0, 0.4);\n}\n", ""]);

// exports
exports.locals = {
	"cardBorder": "SelectableBlock__cardBorder___qM39J",
	"selectableBlock": "SelectableBlock__selectableBlock___1Orhs",
	"showIndicator": "SelectableBlock__showIndicator___Cd8rr",
	"checkbox": "SelectableBlock__checkbox___ATx36",
	"selectableBlockDisabled": "SelectableBlock__selectableBlockDisabled___yPbuf",
	"selectableBlockSelected": "SelectableBlock__selectableBlockSelected___3Nv26 SelectableBlock__selectableBlock___1Orhs",
	"grey": "SelectableBlock__grey___1307c"
};

/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Success__checkmark__circle___r9pH5 {\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n  stroke: #59D98D;\n  fill: none;\n  -webkit-animation: Success__stroke___14zkO .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;\n          animation: Success__stroke___14zkO .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;\n}\n\n.Success__checkmark___31wPD {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: block;\n  stroke-width: 2;\n  stroke: #fff;\n  stroke-miterlimit: 10;\n  margin: 0 auto;\n  box-shadow: inset 0px 0px 0px #59D98D;\n  -webkit-animation: Success__fill___3-BAM .4s ease-in-out .4s forwards, Success__scale___3z321 .3s ease-in-out .9s both;\n          animation: Success__fill___3-BAM .4s ease-in-out .4s forwards, Success__scale___3z321 .3s ease-in-out .9s both;\n}\n\n.Success__checkmark__check___17P4b {\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  -webkit-animation: Success__stroke___14zkO .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards;\n          animation: Success__stroke___14zkO .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards;\n}\n\n@-webkit-keyframes Success__stroke___14zkO {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes Success__stroke___14zkO {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@-webkit-keyframes Success__scale___3z321 {\n  0%, 100% {\n    -webkit-transform: none;\n            transform: none;\n  }\n  50% {\n    -webkit-transform: scale3d(1.1, 1.1, 1);\n            transform: scale3d(1.1, 1.1, 1);\n  }\n}\n\n@keyframes Success__scale___3z321 {\n  0%, 100% {\n    -webkit-transform: none;\n            transform: none;\n  }\n  50% {\n    -webkit-transform: scale3d(1.1, 1.1, 1);\n            transform: scale3d(1.1, 1.1, 1);\n  }\n}\n\n@-webkit-keyframes Success__fill___3-BAM {\n  100% {\n    box-shadow: inset 0px 0px 0px 30px #59D98D;\n  }\n}\n\n@keyframes Success__fill___3-BAM {\n  100% {\n    box-shadow: inset 0px 0px 0px 30px #59D98D;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"checkmark__circle": "Success__checkmark__circle___r9pH5",
	"stroke": "Success__stroke___14zkO",
	"checkmark": "Success__checkmark___31wPD",
	"fill": "Success__fill___3-BAM",
	"scale": "Success__scale___3z321",
	"checkmark__check": "Success__checkmark__check___17P4b"
};

/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.SummaryTotals__divider___37PqY {\n  border-bottom: 1px solid #DEDEDF;\n  margin: 0.5em 0;\n}\n", ""]);

// exports
exports.locals = {
	"divider": "SummaryTotals__divider___37PqY"
};

/***/ }),
/* 3570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.EventCreate__cancel___2E38H {\n  color: #DEDEDF;\n  padding-right: 2em;\n}\n", ""]);

// exports
exports.locals = {
	"cancel": "EventCreate__cancel___2E38H"
};

/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Event__notepad___11AKS textarea {\n  background: #FFFCEA !important;\n  border: none !important;\n  box-shadow: 0px 1px 4px 1px #DEDEDF !important;\n  transition: all 0.3s ease-in-out;\n}\n\n.Event__notepad___11AKS textarea:focus, .Event__notepad___11AKS textarea:active {\n  box-shadow: 0px 1px 10px 1px #DEDEDF !important;\n}\n\n.Event__documentSettingsMenu___3iSSa {\n  color: rgba(0, 0, 0, 0.4);\n  position: absolute;\n  right: 1em;\n  top: 1em;\n}\n\n.Event__negative___20nNA {\n  color: #DB2828 !important;\n}\n\n.Event__cardTitle___c0qr0 {\n  padding-right: 1.25em;\n}\n\n.Event__title___2Ezqe {\n  resize: none !important;\n  font-size: 1.6em !important;\n  line-height: 1.6em !important;\n  padding: 0 !important;\n  border: none !important;\n  outline: none !important;\n  word-break: break-word;\n  width: 100%;\n}\n\n.Event__verticalSpacing___213_z {\n  margin-bottom: 2em;\n}\n\n.Event__statusIndicator___1Wb_o {\n  display: inline-block;\n  border-radius: 50%;\n  min-height: 0.5em;\n  height: 0.5em;\n  width: 0.5em;\n  min-width: 0.5em;\n  margin: 0 0.25em;\n}\n\n.Event__bookedIndicator___3w-Sw {\n  background-color: #21BA45;\n}\n\n.Event__notBookedIndicator___Co7r- {\n  background-color: #FF9F5B;\n}\n\n.Event__canceledIndicator___3FLFI {\n  background-color: #DB2828;\n}\n\n.Event__statusLabel___g9N2R {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Event__statusContainer___3nzC2 {\n  margin-bottom: 1em;\n}\n\n.Event__verticalDivider___1uL44 {\n  border-left: 1px solid #DEDEDF;\n  display: inline-block;\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.Event__publicDates___1Vq7s {\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.4);\n  margin-bottom: 2rem;\n}\n\n.Event__publicDates___1Vq7s i {\n  margin: 0 0.25rem !important;\n}\n\n.Event__headerSection___I_qvk {\n  background: #FFFFFF;\n  padding-bottom: 0;\n  margin-top: 5px;\n  padding-top: 2em;\n  margin-bottom: 3em;\n  position: relative;\n  box-shadow: 0px 2px 3px 0px #DEDEDF, 0px 0px 0px 1px #DEDEDF\n}\n\n.Event__headerSection___I_qvk:before {\n    background: inherit;\n    content: \"\";\n    position: absolute;\n    height: 2px;\n    top: -2px;\n    left: 0;\n    width: 100%;\n}\n\n.Event__subnav___1uDEh {\n  border-bottom: none !important;\n  overflow: hidden;\n}\n\n.Event__subnavItem___1WeZB {\n  margin-top: -1px !important;\n  outline: none !important;\n}\n\n.Event__noOutline___3cVR5 {\n  outline: none !important;\n}\n\n.Event__modalCancel___1K2FM {\n  color: rgba(0, 0, 0, 0.4);\n  margin-right: 2em\n}\n\n.Event__modalCancel___1K2FM:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.Event__menuRight___18ij_ {\n  right: 0 !important;\n  left: auto !important;\n}\n\n.Event__pointer___1AiFN {\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 768px) {\n  .Event__publicDates___1Vq7s {\n    border: none;\n    display: block;\n    margin-left: 0;\n    padding: 0;\n    margin-top: 1em;\n  }\n  .Event__headerSection___I_qvk {\n    padding: 1em;\n  }\n  .Event__statusContainer___3nzC2 {\n    font-size: 1.142857rem !important;\n  }\n  .Event__workspaceCard___2GH9N {\n    width: calc(100% - 2em) !important;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"notepad": "Event__notepad___11AKS",
	"documentSettingsMenu": "Event__documentSettingsMenu___3iSSa",
	"negative": "Event__negative___20nNA",
	"cardTitle": "Event__cardTitle___c0qr0",
	"title": "Event__title___2Ezqe",
	"verticalSpacing": "Event__verticalSpacing___213_z",
	"statusIndicator": "Event__statusIndicator___1Wb_o",
	"bookedIndicator": "Event__bookedIndicator___3w-Sw Event__statusIndicator___1Wb_o",
	"notBookedIndicator": "Event__notBookedIndicator___Co7r- Event__statusIndicator___1Wb_o",
	"canceledIndicator": "Event__canceledIndicator___3FLFI Event__statusIndicator___1Wb_o",
	"statusLabel": "Event__statusLabel___g9N2R",
	"statusContainer": "Event__statusContainer___3nzC2",
	"verticalDivider": "Event__verticalDivider___1uL44",
	"publicDates": "Event__publicDates___1Vq7s",
	"headerSection": "Event__headerSection___I_qvk",
	"subnav": "Event__subnav___1uDEh",
	"subnavItem": "Event__subnavItem___1WeZB",
	"noOutline": "Event__noOutline___3cVR5",
	"modalCancel": "Event__modalCancel___1K2FM",
	"menuRight": "Event__menuRight___18ij_",
	"pointer": "Event__pointer___1AiFN",
	"workspaceCard": "Event__workspaceCard___2GH9N"
};

/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 767px) {\n  .EventSegment__desktop___394dk {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .EventSegment__mobile___3aM5B {\n    display: none !important;\n  }\n}\n\n.EventSegment__visible___3iSNY {\n  visibility: visible;\n}\n\n.EventSegment__invisible___28ew5 {\n  visibility: hidden;\n}\n\n.EventSegment__borderGrey___bQ0kk {\n  color: #DEDEDF;\n}\n\n.EventSegment__subtext___2BNVQ {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.EventSegment__negative___1u0eb {\n  color: #DB2828\n}\n\n.EventSegment__negative___1u0eb:hover {\n    color: #DB2828;\n}\n\n.EventSegment__icon___2X14k {\n  padding: 0.5em 1em 0.5em 0;\n}\n\n.EventSegment__icon___2X14k i {\n  color: #DEDEDF;\n  font-size: 1.71429rem !important;\n}\n\n.EventSegment__secondaryInfo___azPcy {\n  color: rgba(0, 0, 0, 0.4);\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "EventSegment__desktop___394dk",
	"mobile": "EventSegment__mobile___3aM5B",
	"visible": "EventSegment__visible___3iSNY",
	"invisible": "EventSegment__invisible___28ew5",
	"borderGrey": "EventSegment__borderGrey___bQ0kk",
	"subtext": "EventSegment__subtext___2BNVQ",
	"negative": "EventSegment__negative___1u0eb",
	"icon": "EventSegment__icon___2X14k",
	"secondaryInfo": "EventSegment__secondaryInfo___azPcy"
};

/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 768px) {.locationAutocomplete .results > .result .content > div.description {\n    padding: 0 !important;\n  }\n}\n\n.locationAutocomplete {\n  width: 100%;\n}\n\n.locationAutocomplete i.icon {\n  display: none;\n}\n\n.locationAutocomplete .ui.icon.input input {\n  border: none !important;\n  background: transparent !important;\n  padding: 0 !important;\n  width: 100% !important;\n}\n\n.locationAutocomplete.fluid > .ui.icon.input {\n  width: 100% !important;\n}\n", ""]);

// exports


/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.EventList__mobileFilters___1YLEF {\n  padding: 1em 0;\n  margin-top: 1em !important;\n  width: 100%;\n}\n\n.EventList__cardBorder___3ZeHE {\n  width: 6px;\n  position: absolute;\n  /* Offsets card border */\n  left: -1px;\n  top: 0px;\n  bottom: 0px;\n  z-index: 1;\n}\n\n.EventList__cardBorderPrimary___3sbMy {\n  background: #59D98D;\n}\n\n.EventList__cardBorderTentative___1pX9w {\n  background: #F9DC5C;\n}\n\n.EventList__cardBorderCanceled___2Lxii {\n  background: #DB2828;\n}\n\n.EventList__cardDateLabel___Mh9bu {\n  color: rgba(0, 0, 0, 0.8);\n  line-height: 1em;\n  text-transform: uppercase;\n}\n\n.EventList__filter___lSghk {\n  margin: 0 !important;\n}\n\n.EventList__filterActive___2HKUr {\n  color: #59D98D;\n}\n\n.EventList__scrollContainer___1QquC {\n  -webkit-transform: translate3d(0, 0, 0);\n}\n", ""]);

// exports
exports.locals = {
	"mobileFilters": "EventList__mobileFilters___1YLEF",
	"cardBorder": "EventList__cardBorder___3ZeHE",
	"cardBorderPrimary": "EventList__cardBorderPrimary___3sbMy EventList__cardBorder___3ZeHE",
	"cardBorderTentative": "EventList__cardBorderTentative___1pX9w EventList__cardBorder___3ZeHE",
	"cardBorderCanceled": "EventList__cardBorderCanceled___2Lxii EventList__cardBorder___3ZeHE",
	"cardDateLabel": "EventList__cardDateLabel___Mh9bu",
	"filter": "EventList__filter___lSghk",
	"filterActive": "EventList__filterActive___2HKUr",
	"scrollContainer": "EventList__scrollContainer___1QquC"
};

/***/ }),
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Pipelines__eventSettingsMenu___1wLDg {\n  color: rgba(0, 0, 0, 0.4);\n  position: absolute;\n  right: 1em;\n  top: 1em;\n}\n\n.Pipelines__listWrapper___12x45 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.Pipelines__list___1ohQv {\n  background: #F7F8F7;\n  border: 1px solid #DEDEDF;\n  border-radius: 4px;\n  margin-right: 1em;\n  padding: 1em;\n  position: relative;\n  width: 320px;\n  min-width: 320px;\n  max-width: 320px;\n  overflow: auto;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.Pipelines__listMenu___-jIwV {\n  padding: 0.5em;\n  position: absolute;\n  right: 0.5em;\n  top: 0.5em;\n}\n\n.Pipelines__listTitle___2EspB {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.Pipelines__listScrollWrapper___2iUd- {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 4px;\n  overflow-y: auto;\n}\n\n.Pipelines__pipeline___1onLX {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  margin: 1em;\n  margin-bottom: 0;\n  padding-bottom: 1em;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  overflow: hidden;\n  overflow-x: visible;\n}\n\n.Pipelines__pipelineWrapper___3SRyi {\n  height: calc(100vh - 4.571em);\n}\n\n.Pipelines__negative___2oLsD {\n  color: #DB2828 !important;\n}\n\n.Pipelines__modalCancel___NkbgW {\n  color: rgba(0, 0, 0, 0.4) !important;\n  margin-right: 1em;\n}\n", ""]);

// exports
exports.locals = {
	"eventSettingsMenu": "Pipelines__eventSettingsMenu___1wLDg",
	"listWrapper": "Pipelines__listWrapper___12x45",
	"list": "Pipelines__list___1ohQv",
	"listMenu": "Pipelines__listMenu___-jIwV",
	"listTitle": "Pipelines__listTitle___2EspB",
	"listScrollWrapper": "Pipelines__listScrollWrapper___2iUd-",
	"pipeline": "Pipelines__pipeline___1onLX",
	"pipelineWrapper": "Pipelines__pipelineWrapper___3SRyi",
	"negative": "Pipelines__negative___2oLsD",
	"modalCancel": "Pipelines__modalCancel___NkbgW"
};

/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.ContactStyles__active___36Ah9 {\n  box-shadow: 0px 1px 5px 1px #DEDEDF;\n}\n\n.ContactStyles__avatar___1sW2J {\n  position: relative;\n  background: #FFE29D;\n  height: 60px;\n  vertical-align: middle;\n  width: 60px;\n  border-radius: 50%;\n}\n\n.ContactStyles__avatarText___1gwZq {\n  color: #fff;\n  font-family: 'Merriweather', serif;\n  font-size: 2.5rem;\n  position: absolute;\n  top: 32px;\n  left: 30px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  vertical-align: middle;\n}\n\n.ContactStyles__avatarWrapper___1noeH {\n  display: inline-block;\n  padding: 1em 1em 1em 0;\n  box-sizing: border-box;\n}\n\n.ContactStyles__contact___NGDfL {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 1em 3.5em 1em 0;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ContactStyles__hideOverflow___1XuB8 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ContactStyles__label___1jfZA {\n  color: rgba(0, 0, 0, 0.4);\n  margin-bottom: 2em;\n}\n\n\n.ContactStyles__name___3MsuM {\n  font-weight: bold;\n}\n\n.ContactStyles__section___4IV7Y {\n  padding-top: 1em;\n}\n\n.ContactStyles__type___3WTVZ {\n  padding: 0 1em;\n}\n\n.ContactStyles__type___3WTVZ i {\n  color: #DEDEDF;\n  font-size: 1.71429rem !important;\n}\n\n.ContactStyles__editButton___231xA {\n  position: absolute;\n  top: 1em;\n  right: 1em;\n}\n\n.ContactStyles__relation___1o1fA {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.ContactStyles__addRelation___wbbnU {\n  margin-bottom: 1em;\n}\n\n.ContactStyles__label___1jfZA {\n  min-width: 5em !important;\n}\n\n.ContactStyles__expanding___2K7se {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding-right: 1em;\n  word-break: break-word;\n}\n\n.ContactStyles__divider___2nV4B {\n  margin-right: -1em !important;\n}\n\n.ContactStyles__delete___1UpDd {\n  position: absolute;\n  top: 1.5em;\n  left: -2em;\n  cursor: pointer;\n}\n\n.ContactStyles__delete___1UpDd i {\n  color: #DEDEDF;\n  font-weight: 100;\n  transition: color 0.3s ease-in-out\n}\n\n.ContactStyles__delete___1UpDd i:hover, .ContactStyles__delete___1UpDd i:focus {\n  color: #DB2828;\n}\n\n.ContactStyles__cancel___2DKjr {\n  padding-top: 2em;\n  text-align: left;\n}\n\n.ContactStyles__cancel___2DKjr a {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.ContactStyles__description___L7-rF {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"active": "ContactStyles__active___36Ah9",
	"avatar": "ContactStyles__avatar___1sW2J",
	"avatarText": "ContactStyles__avatarText___1gwZq",
	"avatarWrapper": "ContactStyles__avatarWrapper___1noeH",
	"contact": "ContactStyles__contact___NGDfL",
	"hideOverflow": "ContactStyles__hideOverflow___1XuB8 ContactStyles__contact___NGDfL",
	"label": "ContactStyles__label___1jfZA",
	"name": "ContactStyles__name___3MsuM",
	"section": "ContactStyles__section___4IV7Y",
	"type": "ContactStyles__type___3WTVZ",
	"editButton": "ContactStyles__editButton___231xA",
	"relation": "ContactStyles__relation___1o1fA",
	"addRelation": "ContactStyles__addRelation___wbbnU",
	"expanding": "ContactStyles__expanding___2K7se",
	"divider": "ContactStyles__divider___2nV4B",
	"delete": "ContactStyles__delete___1UpDd",
	"cancel": "ContactStyles__cancel___2DKjr",
	"description": "ContactStyles__description___L7-rF"
};

/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.NewDocumentMenu__menu___35Ik_ {\n}\n\n@media only screen and (min-width: 768px) {.NewDocumentMenu__menu___35Ik_ {\n    min-width: 350px;\n  }\n  }\n\n.NewDocumentMenu__icon___3U1HV {\n  padding-right: 1em;\n  width: 40px;\n}\n\n.NewDocumentMenu__item___2YeFC {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 1em 0\n}\n\n.NewDocumentMenu__item___2YeFC:hover .NewDocumentMenu__description___vjlzF, .NewDocumentMenu__item___2YeFC:hover .NewDocumentMenu__title___3Sdul {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.NewDocumentMenu__item___2YeFC:hover .NewDocumentMenu__icon___3U1HV {\n  -webkit-filter: saturate(0);\n          filter: saturate(0);\n}\n\n.NewDocumentMenu__title___3Sdul {\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.NewDocumentMenu__description___vjlzF {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.NewDocumentMenu__blue___3GEGi {\n  color: #6095C9;\n}\n\n.NewDocumentMenu__purple___1IAFL {\n  color: #5848BB;\n}\n\n.NewDocumentMenu__lavender___1BQLq {\n  color: #928AC2;\n}\n\n.NewDocumentMenu__green___1L9zm {\n  color: #7ED18D;\n}\n\n.NewDocumentMenu__orange___2ug_w {\n  color: #CE7C3A;\n}\n\n.NewDocumentMenu__teal___2BJu_ {\n  color: #71AEEA;\n}\n\n.NewDocumentMenu__peach___1CTWD {\n  color: #DF9898;\n}\n", ""]);

// exports
exports.locals = {
	"menu": "NewDocumentMenu__menu___35Ik_",
	"icon": "NewDocumentMenu__icon___3U1HV",
	"item": "NewDocumentMenu__item___2YeFC",
	"description": "NewDocumentMenu__description___vjlzF",
	"title": "NewDocumentMenu__title___3Sdul",
	"blue": "NewDocumentMenu__blue___3GEGi",
	"purple": "NewDocumentMenu__purple___1IAFL",
	"lavender": "NewDocumentMenu__lavender___1BQLq",
	"green": "NewDocumentMenu__green___1L9zm",
	"orange": "NewDocumentMenu__orange___2ug_w",
	"teal": "NewDocumentMenu__teal___2BJu_",
	"peach": "NewDocumentMenu__peach___1CTWD"
};

/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Financial__tableHeader___2KB6d {\n  background: #FAFBFA;\n  border-bottom: 1px solid #DEDEDF;\n  text-transform: uppercase;\n}\n\n.Financial__tableRow___30m4f {\n  cursor: pointer\n}\n\n.Financial__tableRow___30m4f:hover {\n    background-color: #FAFBFA;\n}\n\n.Financial__red___3Rn4P {\n  color: #DB2828;\n}\n\n.Financial__mutedText___3foNv {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Financial__eventTitleMobile___1Y97z {\n  margin-top: 0.5em;\n}\n\n.Financial__paymentSummary___38CzC {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 0.875em;\n  margin-top: 0.5em;\n}\n\n.Financial__statusBlock___1txRo {\n  background: #ffffff;\n  min-height: 100px;\n}\n\n.Financial__statusBlockAmount___3zwol {\n  font-size: 1.875em;\n}\n", ""]);

// exports
exports.locals = {
	"tableHeader": "Financial__tableHeader___2KB6d",
	"tableRow": "Financial__tableRow___30m4f",
	"red": "Financial__red___3Rn4P",
	"mutedText": "Financial__mutedText___3foNv",
	"eventTitleMobile": "Financial__eventTitleMobile___1Y97z Financial__mutedText___3foNv",
	"paymentSummary": "Financial__paymentSummary___38CzC",
	"statusBlock": "Financial__statusBlock___1txRo",
	"statusBlockAmount": "Financial__statusBlockAmount___3zwol"
};

/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n.PaymentsGraph__legend___2ChNM {\n  margin: 1em 0;\n}\n\n.PaymentsGraph__legendLabel___3kdg2 {\n  display: inline-block;\n  border-radius: 50%;\n  min-height: 0.75em;\n  height: 0.75em;\n  width: 0.75em;\n  min-width: 0.75em;\n  margin: 0 0.5em 0 0;\n}\n\n.PaymentsGraph__outstandingLegend___14Sb3 {\n  background-color: #7f98a5;\n}\n\n.PaymentsGraph__paidLegend___1fKrU {\n  background-color: #547687;\n}\n\n.PaymentsGraph__total___2qykJ {\n  font-size: 1.875em;\n  font-weight: normal;\n  margin: 0;\n}\n\n.PaymentsGraph__totalLabel___1esNp {\n  font-weight: normal;\n  margin: 0;\n}\n\n.PaymentsGraph__tooltipNumber___11Mxb {\n  padding-left: 0.5em;\n}\n", ""]);

// exports
exports.locals = {
	"legend": "PaymentsGraph__legend___2ChNM",
	"legendLabel": "PaymentsGraph__legendLabel___3kdg2",
	"outstandingLegend": "PaymentsGraph__outstandingLegend___14Sb3 PaymentsGraph__legendLabel___3kdg2",
	"paidLegend": "PaymentsGraph__paidLegend___1fKrU PaymentsGraph__legendLabel___3kdg2",
	"total": "PaymentsGraph__total___2qykJ",
	"totalLabel": "PaymentsGraph__totalLabel___1esNp",
	"tooltipNumber": "PaymentsGraph__tooltipNumber___11Mxb"
};

/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Leads__icon___oSD9Z {\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 6em;\n  margin-bottom: 0.166666667em;\n}\n\n.Leads__icon___oSD9Z i {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Leads__description___1maGb {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 1.125em;\n}\n\n.Leads__difficult___2zL4n {\n  color: #FF9F5B;\n}\n\n.Leads__easy___1wHam {\n  color: #59D98D;\n}\n\n.Leads__helperText___3lO27 {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Leads__settingsLabels___2FU3g {\n  text-align: right\n}\n\n@media only screen and (max-width: 768px) {.Leads__settingsLabels___2FU3g {\n    text-align: left;\n  }\n  }\n", ""]);

// exports
exports.locals = {
	"icon": "Leads__icon___oSD9Z",
	"description": "Leads__description___1maGb",
	"difficult": "Leads__difficult___2zL4n",
	"easy": "Leads__easy___1wHam",
	"helperText": "Leads__helperText___3lO27",
	"settingsLabels": "Leads__settingsLabels___2FU3g"
};

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 767px) {\n  .AvailabilityChecker__desktop___3ORGT {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .AvailabilityChecker__mobile___2C2XN {\n    display: none !important;\n  }\n}\n\n.AvailabilityChecker__visible___BEI7Q {\n  visibility: visible;\n}\n\n.AvailabilityChecker__invisible___1hJr6 {\n  visibility: hidden;\n}\n\n.AvailabilityChecker__borderGrey___11cXq {\n  color: #DEDEDF;\n}\n\n.AvailabilityChecker__subtext___1KAgZ {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.AvailabilityChecker__negative___9T4gI {\n  color: #DB2828\n}\n\n.AvailabilityChecker__negative___9T4gI:hover {\n    color: #DB2828;\n}\n\n.AvailabilityChecker__calendarIcon___2MIzZ {\n  color: rgba(0, 0, 0, 0.4);\n  padding: 0 1em\n}\n\n.AvailabilityChecker__calendarIcon___2MIzZ:hover {\n    color: #59D98D;\n}\n\n.AvailabilityChecker__calendarIconActive___1Rc0c {\n  color: #59D98D\n}\n\n.AvailabilityChecker__availabilityDetailsDesktop___1vtng {\n  height: 80%;\n  max-height: 600px;\n}\n\n.AvailabilityChecker__cardSection___2fs1E {\n  margin-top: 2em;\n}\n\n.AvailabilityChecker__eventName___4RH7p {\n  color: #59D98D;\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "AvailabilityChecker__desktop___3ORGT",
	"mobile": "AvailabilityChecker__mobile___2C2XN",
	"visible": "AvailabilityChecker__visible___BEI7Q",
	"invisible": "AvailabilityChecker__invisible___1hJr6",
	"borderGrey": "AvailabilityChecker__borderGrey___11cXq",
	"subtext": "AvailabilityChecker__subtext___1KAgZ",
	"negative": "AvailabilityChecker__negative___9T4gI",
	"calendarIcon": "AvailabilityChecker__calendarIcon___2MIzZ",
	"calendarIconActive": "AvailabilityChecker__calendarIconActive___1Rc0c",
	"availabilityDetailsDesktop": "AvailabilityChecker__availabilityDetailsDesktop___1vtng",
	"cardSection": "AvailabilityChecker__cardSection___2fs1E",
	"eventName": "AvailabilityChecker__eventName___4RH7p"
};

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 767px) {\n  .BigCalendar__desktop___2O4iw {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .BigCalendar__mobile___RJnPy {\n    display: none !important;\n  }\n}\n\n.BigCalendar__visible___9voUH {\n  visibility: visible;\n}\n\n.BigCalendar__invisible___qz4rK {\n  visibility: hidden;\n}\n\n.BigCalendar__borderGrey___3cDKj {\n  color: #DEDEDF;\n}\n\n.BigCalendar__subtext___3wfvp {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.BigCalendar__negative___1XQjP {\n  color: #DB2828\n}\n\n.BigCalendar__negative___1XQjP:hover {\n    color: #DB2828;\n}\n\n.rbc-event {\n  background-color: rgba(79, 200, 118, 0.6);\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.rbc-event.rbc-booked {\n  background-color: rgba(79, 200, 118, 0.6);\n}\n\n.rbc-event.rbc-booked.rbc-selected {\n  background-color: rgba(79, 200, 118, 1);\n}\n\n.rbc-event.rbc-canceled {\n  background-color: rgba(219, 40, 40, 0.6);\n}\n\n.rbc-event.rbc-canceled.rbc-selected {\n  background-color: rgba(219, 40, 40, 1);\n}\n\n.rbc-event.rbc-tentative.rbc-selected {\n  background-color: rgba(249, 220, 92, 1);\n}\n\n.rbc-event.rbc-tentative {\n  background-color: rgba(249, 220, 92, 0.6);\n}\n\n.rbc-day-slot .rbc-event {\n  border: 0;\n}\n\n.rbc-calendar {\n  overflow: hidden;\n}\n\n.rbc-time-view {\n  overflow: hidden;\n  border: 1px solid #DEDEDF;\n  border-radius: 3px;\n}\n\n.rbc-time-slot.rbc-label {\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  text-align: right;\n}\n\n.rbc-time-gutter {\n  width: 3.25em;\n}\n\n.rbc-time-gutter .rbc-timeslot-group {\n  border: 0;\n}\n\n.rbc-time-content {\n  margin-bottom: -1px;\n  overflow: visible;\n  border: 0;\n}\n\n.rbc-btn-group > button {\n  outline: none;\n}\n\n.rbc-date-cell a:active, .rbc-date-cell > a:hover {\n  color: #FF9F5B;\n}\n\n.BigCalendar__timepickerIcon___RByYm {\n  color: #DEDEDF;\n  cursor: pointer;\n  font-size: 1.25em !important;\n  margin: 0 !important;\n}\n\n.BigCalendar__timepicker___LezE5 {\n  border-bottom: 1px solid #DEDEDF;\n  border-radius: 3px;\n}\n\n.BigCalendar__selectedDate___1btFC {\n  font-weight: bold;\n  text-align: center;\n}\n\n.BigCalendar__selectedDay___3zd04 {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 1rem;\n  font-weight: lighter;\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.BigCalendar__timepickerPrev___2Sxjf {\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\");\n  float: left;\n  left: 1rem;\n}\n\n.BigCalendar__timepickerNext___2X_8V {\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\");\n  float: right;\n  right: 1rem;\n}\n\n.BigCalendar__timepickerButton___MvPUZ {\n  margin-top: 1rem;\n  height: 1.5rem;\n  width: 1.5em;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "BigCalendar__desktop___2O4iw",
	"mobile": "BigCalendar__mobile___RJnPy",
	"visible": "BigCalendar__visible___9voUH",
	"invisible": "BigCalendar__invisible___qz4rK",
	"borderGrey": "BigCalendar__borderGrey___3cDKj",
	"subtext": "BigCalendar__subtext___3wfvp",
	"negative": "BigCalendar__negative___1XQjP",
	"timepickerIcon": "BigCalendar__timepickerIcon___RByYm",
	"timepicker": "BigCalendar__timepicker___LezE5",
	"selectedDate": "BigCalendar__selectedDate___1btFC",
	"selectedDay": "BigCalendar__selectedDay___3zd04",
	"timepickerPrev": "BigCalendar__timepickerPrev___2Sxjf",
	"timepickerNext": "BigCalendar__timepickerNext___2X_8V",
	"timepickerButton": "BigCalendar__timepickerButton___MvPUZ"
};

/***/ }),
/* 3583 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.dayView .rbc-time-header > .rbc-row > * + * {\n  border: 0;\n}.dayView .rbc-time-header > .rbc-row:first-child {\n  display: none;\n}.dayView .rbc-time-header.rbc-overflowing {\n  border: 0;\n}.dayView .rbc-time-content {\n  box-sizing: content-box;\n  overflow-y: scroll;\n  padding-right: 17px;\n  padding-top: 0.5em;\n}.dayView .rbc-day-slot .rbc-time-slot {\n  margin-right: 0.625em;\n  border-color: #DEDEDF;\n}.dayView .rbc-timeslot-group {\n  border: 0;\n}.dayView .rbc-time-view {\n  border-bottom: 0;\n}\n", ""]);

// exports


/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n@media only screen and (max-width: 767px) {\n  .Dthc__desktop___VdTaQ {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .Dthc__mobile___1c24i {\n    display: none !important;\n  }\n}\n.Dthc__visible___1Junl {\n  visibility: visible;\n}\n.Dthc__invisible___i4k9c {\n  visibility: hidden;\n}\n.Dthc__borderGrey___35hMu {\n  color: #DEDEDF;\n}\n.Dthc__subtext___5KqxR {\n  color: rgba(0, 0, 0, 0.4);\n}\n.Dthc__negative___3tyWV {\n  color: #DB2828\n}\n.Dthc__negative___3tyWV:hover {\n    color: #DB2828;\n}\n\n.Dthc__actionsMenu___ODhPg {\n  display: table;\n  margin-top: 2em;\n  vertical-align: middle;\n}\n\n.Dthc__actionsMenuMiddle____jTlV {\n  padding: 0 2em;\n  text-align: right;\n  width: 99%;\n}\n\n.Dthc__actionsMenuSecondaryItem___G1joN {\n  color: #DEDEDF\n}\n\n.Dthc__actionsMenuSecondaryItem___G1joN:hover {\n    color: rgba(0, 0, 0, 0.4);\n}\n\n.Dthc__hover___3m-zB {\n  background: #FAFBFA;\n  cursor: pointer !important;\n}\n\n.Dthc__cardEdit___28bMm {\n  color: #DEDEDF;\n  cursor: pointer;\n  position: absolute;\n  right: 0.5em;\n  top: 0.5em;\n}\n\n.Dthc__tableCell___3rPs2 {\n  display: table-cell;\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "Dthc__desktop___VdTaQ",
	"mobile": "Dthc__mobile___1c24i",
	"visible": "Dthc__visible___1Junl",
	"invisible": "Dthc__invisible___i4k9c",
	"borderGrey": "Dthc__borderGrey___35hMu",
	"subtext": "Dthc__subtext___5KqxR",
	"negative": "Dthc__negative___3tyWV",
	"actionsMenu": "Dthc__actionsMenu___ODhPg",
	"actionsMenuMiddle": "Dthc__actionsMenuMiddle____jTlV",
	"actionsMenuSecondaryItem": "Dthc__actionsMenuSecondaryItem___G1joN",
	"hover": "Dthc__hover___3m-zB",
	"cardEdit": "Dthc__cardEdit___28bMm",
	"tableCell": "Dthc__tableCell___3rPs2"
};

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n.Modal__mobileModal___3G82t {\n  border-radius: 0 !important;\n  height: 100%;\n  width: 100% !important;\n}\n\n.Modal__mobileModalContent___36G-1 {\n  /* Enable scroll acceleration for touch devices */\n  -webkit-overflow-scrolling: touch;\n  font-size: 1.1428571429rem;\n  overflow-y: scroll;\n  height: 100%;\n  width: 100%;\n  padding: 0 !important;\n}\n\n.Modal__mobileModalBody___3anmZ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 4em 1em 1em 1em;\n  min-height: 100%;\n}\n\n.Modal__scroll___1_KCH {\n  -webkit-overflow-scrolling: auto;\n}\n", ""]);

// exports
exports.locals = {
	"mobileModal": "Modal__mobileModal___3G82t",
	"mobileModalContent": "Modal__mobileModalContent___36G-1",
	"mobileModalBody": "Modal__mobileModalBody___3anmZ",
	"scroll": "Modal__scroll___1_KCH"
};

/***/ }),
/* 3586 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.pt-toast-container {\n  z-index: 1002;\n}\n\n.pt-toast.pt-intent-success {\n  background-color: #59D98D;\n}\n\n@media only screen and (max-width: 991px) {.pt-toast {\n    width: 100%;\n    font-size: 1.125em;\n    padding: 0.5em;\n  }\n  }\n", ""]);

// exports


/***/ }),
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.rc-steps .rc-steps-head-inner > .rc-steps-icon {\n  color: #59D98D;\n}\n\n.rc-steps .rc-steps-item.rc-steps-status-process .rc-steps-head-inner {\n  border-color: #59D98D;\n  background-color: #59D98D;\n}\n\n.rc-steps .rc-steps-item.rc-steps-status-wait .rc-steps-head-inner > .rc-steps-icon {\n  display: none;\n}\n\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-head-inner {\n  border-color: #59D98D;\n}\n\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-head-inner > .rc-steps-icon {\n  color: #59D98D;\n}\n\n.rc-steps .rc-steps-item.rc-steps-status-finish .rc-steps-tail > i {\n  background-color: #59D98D;\n}\n\n.rc-steps.rc-steps-vertical .rc-steps-item {\n  padding-bottom: 20px;\n}\n\n.rc-steps-item .rc-steps-title, .rc-steps-item .rc-steps-head, .rc-steps-item .rc-steps-head-inner {\n  background: inherit;\n  font-weight: normal;\n}\n\n.rc-steps-item .rc-steps-title a, .rc-steps-item .rc-steps-head a, .rc-steps-item .rc-steps-head-inner a {\n  color: inherit;\n}\n", ""]);

// exports


/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.quill *:focus {\n  outline: none;\n}\n\n.TextEditor__label___3dtlk {\n  color: rgba(0, 0, 0, 0.4);\n  margin: 0.5rem 0;\n  font-size: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"label": "TextEditor__label___3dtlk"
};

/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, ".Playlist__recommendation___1VWFG:not(:last-child) {\n    margin-right: 1em;\n}/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n.Playlist__muted___OW6WJ {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.Playlist__thumbnail___3IS2O {\n  background: rgba(255,255,255,1);\n  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(246,246,246,1) 47%, rgba(237,237,237,1) 100%);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.Playlist__thumbnail___3IS2O i {\n    color: rgba(0, 0, 0, 0.4);\n    font-size: 2em;\n}\n.songSearch > .ui.icon.input {\n    width: 100%;\n}\n.songSearch > .ui.icon.input input {\n    border-radius: 3px;\n}\n.songSearch .results .result .content .description {\n    padding: 0 !important;\n}\n\n.Playlist__songCard___UH74n {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0.5em 0;\n}\n\n.Playlist__songDetails___11brQ {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 64px;\n  line-height: 1.25em;\n  padding: 0 1em;\n}\n\n.Playlist__songThumbnail___1Zsyy {\n  height: 64px;\n  width: 64px;\n  line-height: 64px;\n}\n\n.Playlist__songThumbnail___1Zsyy img {\n    width: 64px;\n    height: 64px;\n}\n\n.Playlist__playlistThumbnail___3Mz60 {\n  height: 160px;\n  width: 160px;\n  line-height: 160px;\n}\n\n.Playlist__playlistThumbnail___3Mz60 img {\n    width: 160px;\n    height: 160px;\n}\n\n.Playlist__playlistThumbnailMobile___10UAs {\n  height: 240px;\n  width: 240px;\n  line-height: 240px;\n}\n\n.Playlist__playlistThumbnailMobile___10UAs img {\n    width: 240px;\n    height: 240px;\n}\n\n.Playlist__songAction___3ZC_e {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Playlist__list___1llfL {\n  overflow-y: auto;\n  margin: -1em;\n  padding: 1em;\n  padding-right: 0;\n}\n\n.Playlist__noBoxShadow___yAy4k {\n  box-shadow: none !important;\n}\n\n.Playlist__playlist___2RRQO {\n  max-height: 300px;\n}\n\n.Playlist__songCount___2bfqZ {\n  margin-top: 0.5em;\n}\n\n.Playlist__centered___1YSAA {\n  text-align: center;\n}\n\n.Playlist__playlistLabel___2Nwin {\n  text-transform: uppercase;\n}\n\n.Playlist__recommendation___1VWFG {\n  cursor: pointer;\n  width: 160px;\n  display: inline-block;\n  position: relative;\n}\n\n.Playlist__recommendation___1VWFG > img.Playlist__showOnHover___2GxXz {\n    visibility: hidden;\n}\n\n.Playlist__recommendation___1VWFG:hover > img.Playlist__showOnHover___2GxXz {\n    visibility: visible;\n}\n\n.Playlist__recommendations___1EYfT {\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  padding: 1em 0;\n  -ms-overflow-style: none;\n}\n\n.Playlist__recommendations___1EYfT::-webkit-scrollbar {\n    display: none;\n}\n\n.Playlist__toggleRecommendation___FBTeW {\n  position: absolute !important;\n  bottom: 2.3em;\n  right: 0.5em;\n  z-index: 1;\n  padding: 0.25em;\n}\n\n.Playlist__deleteRecommendation___S0o8C {\n  position: absolute !important;\n  top: -0.75em;\n  right: -0.75em;\n  z-index: 1;\n  padding: 0.25em;\n}\n\n.Playlist__addRecommendation___1lru8 {\n  border-radius: 3px;\n  cursor: pointer;\n  display: inline-block;\n  margin-left: 2px;\n  box-shadow: 1px 1px 6px 1px #DEDEDF;\n  padding: 1em;\n  white-space: initial;\n  vertical-align: top;\n  text-align: center;\n  width: 160px;\n  height: 160px;\n}\n\n.Playlist__addRecommendation___1lru8:hover {\n    box-shadow: 2px 2px 8px 1px #DEDEDF;\n}\n\n.Playlist__recommendationTitle___12LWn {\n  margin-top: 0.5em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.Playlist__playlistOptions___3GokK {\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 1.25em;\n  position: absolute;\n  top: 0;\n  right: 1em;\n  margin-right: -1em;\n}\n\n.Playlist__delete___2yrmR {\n  color: #DB2828 !important;\n}\n\n.Playlist__truncate___3M8KZ {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.Playlist__emptyList___4NGHV {\n  padding-top: 1.5em;\n}\n", ""]);

// exports
exports.locals = {
	"recommendation": "Playlist__recommendation___1VWFG",
	"muted": "Playlist__muted___OW6WJ",
	"thumbnail": "Playlist__thumbnail___3IS2O",
	"songCard": "Playlist__songCard___UH74n",
	"songDetails": "Playlist__songDetails___11brQ",
	"songThumbnail": "Playlist__songThumbnail___1Zsyy Playlist__thumbnail___3IS2O",
	"playlistThumbnail": "Playlist__playlistThumbnail___3Mz60 Playlist__thumbnail___3IS2O",
	"playlistThumbnailMobile": "Playlist__playlistThumbnailMobile___10UAs Playlist__thumbnail___3IS2O",
	"songAction": "Playlist__songAction___3ZC_e",
	"list": "Playlist__list___1llfL",
	"noBoxShadow": "Playlist__noBoxShadow___yAy4k",
	"playlist": "Playlist__playlist___2RRQO Playlist__list___1llfL",
	"songCount": "Playlist__songCount___2bfqZ Playlist__muted___OW6WJ",
	"centered": "Playlist__centered___1YSAA",
	"playlistLabel": "Playlist__playlistLabel___2Nwin",
	"showOnHover": "Playlist__showOnHover___2GxXz",
	"recommendations": "Playlist__recommendations___1EYfT",
	"toggleRecommendation": "Playlist__toggleRecommendation___FBTeW",
	"deleteRecommendation": "Playlist__deleteRecommendation___S0o8C",
	"addRecommendation": "Playlist__addRecommendation___1lru8",
	"recommendationTitle": "Playlist__recommendationTitle___12LWn",
	"playlistOptions": "Playlist__playlistOptions___3GokK",
	"delete": "Playlist__delete___2yrmR",
	"truncate": "Playlist__truncate___3M8KZ",
	"emptyList": "Playlist__emptyList___4NGHV Playlist__muted___OW6WJ Playlist__centered___1YSAA"
};

/***/ }),
/* 3590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* ==========================================================================\n   COLOR\n   ========================================================================== */\n\n@media only screen and (max-width: 767px) {\n  .globals__desktop___3vdzL {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .globals__mobile___1VQHp {\n    display: none !important;\n  }\n}\n\n.globals__visible___2ZzQD {\n  visibility: visible;\n}\n\n.globals__invisible___9ZuSy {\n  visibility: hidden;\n}\n\n.globals__borderGrey___3W6ZT {\n  color: #DEDEDF;\n}\n\n.globals__subtext___GCG7o {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.globals__negative___zjlX2 {\n  color: #DB2828\n}\n\n.globals__negative___zjlX2:hover {\n    color: #DB2828;\n}\n", ""]);

// exports
exports.locals = {
	"desktop": "globals__desktop___3vdzL",
	"mobile": "globals__mobile___1VQHp",
	"visible": "globals__visible___2ZzQD",
	"invisible": "globals__invisible___9ZuSy",
	"borderGrey": "globals__borderGrey___3W6ZT",
	"subtext": "globals__subtext___GCG7o",
	"negative": "globals__negative___zjlX2"
};

/***/ }),
/* 3591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.slide-down-up-enter {\n  opacity: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}.slide-down-up-enter.slide-down-up-enter-active {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  transition: all 300ms ease-in-out;\n}.slide-down-up-leave {\n  opacity: 1;\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n}.slide-down-up-leave.slide-down-up-leave-active {\n  opacity: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n  transition: all 300ms ease-in-out;\n}\n", ""]);

// exports


/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.slide-enter .modal {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}.slide-enter.slide-enter-active .modal {\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}.slide-leave .modal {\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n}.slide-leave.slide-leave-active .modal {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}\n", ""]);

// exports


/***/ }),
/* 3593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css *//**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}/**\n * Remove the margin in all browsers (opinionated).\n */body {\n  margin: 0;\n}/* HTML5 display definitions\n   ========================================================================== *//**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary { /* 1 */\n  display: block;\n}/**\n * Add the correct display in IE 9-.\n */audio, canvas, progress, video {\n  display: inline-block;\n}/**\n * Add the correct display in iOS 4-7.\n */audio:not([controls]) {\n  display: none;\n  height: 0;\n}/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */progress {\n  vertical-align: baseline;\n}/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */template, [hidden] {\n  display: none;\n}/* Links\n   ========================================================================== *//**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */a:active, a:hover {\n  outline-width: 0;\n}/* Text-level semantics\n   ========================================================================== *//**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */b, strong {\n  font-weight: inherit;\n}/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */b, strong {\n  font-weight: bolder;\n}/**\n * Add the correct font style in Android 4.3-.\n */dfn {\n  font-style: italic;\n}/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}/**\n * Add the correct background and color in IE 9-.\n */mark {\n  background-color: #ff0;\n  color: #000;\n}/**\n * Add the correct font size in all browsers.\n */small {\n  font-size: 80%;\n}/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */sub, sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/* Embedded content\n   ========================================================================== *//**\n * Remove the border on images inside links in IE 10-.\n */img {\n  border-style: none;\n}/**\n * Hide the overflow in IE.\n */svg:not(:root) {\n  overflow: hidden;\n}/* Grouping content\n   ========================================================================== *//**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */code, kbd, pre, samp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/**\n * Add the correct margin in IE 8.\n */figure {\n  margin: 1em 40px;\n}/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}/* Forms\n   ========================================================================== *//**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */button, input, optgroup, select, textarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}/**\n * Restore the font weight unset by the previous rule.\n */optgroup {\n  font-weight: bold;\n}/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */button, input { /* 1 */\n  overflow: visible;\n}/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */button, select { /* 1 */\n  text-transform: none;\n}/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */button, html [type=\"button\"], [type=\"reset\"], [type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}/**\n * Remove the inner border and padding in Firefox.\n */button::-moz-focus-inner, [type=\"button\"]::-moz-focus-inner, [type=\"reset\"]::-moz-focus-inner, [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}/**\n * Restore the focus styles unset by the previous rule.\n */button:-moz-focusring, [type=\"button\"]:-moz-focusring, [type=\"reset\"]:-moz-focusring, [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}/**\n * Remove the default vertical scrollbar in IE.\n */textarea {\n  overflow: auto;\n}/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */[type=\"checkbox\"], [type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */[type=\"number\"]::-webkit-inner-spin-button, [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */[type=\"search\"]::-webkit-search-cancel-button, [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}.slide-enter {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}.slide-enter.slide-enter-active {\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}.slide-leave {\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n}.slide-leave.slide-leave-active {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}\n", ""]);

// exports


/***/ }),
/* 3594 */
/***/ (function(module, exports) {

module.exports = {"AED":{"code":"AED","symbol":"د.إ.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AFN":{"code":"AFN","symbol":"؋","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ALL":{"code":"ALL","symbol":"Lek","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AMD":{"code":"AMD","symbol":"֏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ANG":{"code":"ANG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AOA":{"code":"AOA","symbol":"Kz","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ARS":{"code":"ARS","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AUD":{"code":"AUD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AWG":{"code":"AWG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AZN":{"code":"AZN","symbol":"₼","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BAM":{"code":"BAM","symbol":"КМ","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BBD":{"code":"BBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BDT":{"code":"BDT","symbol":"৳","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"BGN":{"code":"BGN","symbol":"лв.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BHD":{"code":"BHD","symbol":"د.ب.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"BIF":{"code":"BIF","symbol":"FBu","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BMD":{"code":"BMD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BND":{"code":"BND","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BOB":{"code":"BOB","symbol":"Bs","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BRL":{"code":"BRL","symbol":"R$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BSD":{"code":"BSD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTC":{"code":"BTC","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTN":{"code":"BTN","symbol":"Nu.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"BWP":{"code":"BWP","symbol":"P","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BYR":{"code":"BYR","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BZD":{"code":"BZD","symbol":"BZ$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CAD":{"code":"CAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CDF":{"code":"CDF","symbol":"FC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CHF":{"code":"CHF","symbol":"CHF","thousandsSeparator":"'","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CLP":{"code":"CLP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CNY":{"code":"CNY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"COP":{"code":"COP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CRC":{"code":"CRC","symbol":"₡","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUC":{"code":"CUC","symbol":"CUC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUP":{"code":"CUP","symbol":"$MN","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CVE":{"code":"CVE","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CZK":{"code":"CZK","symbol":"Kč","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DJF":{"code":"DJF","symbol":"Fdj","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"DKK":{"code":"DKK","symbol":"kr.","thousandsSeparator":"","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DOP":{"code":"DOP","symbol":"RD$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"DZD":{"code":"DZD","symbol":"د.ج.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"EGP":{"code":"EGP","symbol":"ج.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ERN":{"code":"ERN","symbol":"Nfk","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ETB":{"code":"ETB","symbol":"ETB","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"EUR":{"code":"EUR","symbol":"€","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"FJD":{"code":"FJD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"FKP":{"code":"FKP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GBP":{"code":"GBP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GEL":{"code":"GEL","symbol":"Lari","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"GHS":{"code":"GHS","symbol":"₵","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GIP":{"code":"GIP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GMD":{"code":"GMD","symbol":"D","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GNF":{"code":"GNF","symbol":"FG","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"GTQ":{"code":"GTQ","symbol":"Q","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GYD":{"code":"GYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HKD":{"code":"HKD","symbol":"HK$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HNL":{"code":"HNL","symbol":"L.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HRK":{"code":"HRK","symbol":"kn","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HTG":{"code":"HTG","symbol":"G","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HUF":{"code":"HUF","symbol":"Ft","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IDR":{"code":"IDR","symbol":"Rp","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"ILS":{"code":"ILS","symbol":"₪","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"INR":{"code":"INR","symbol":"₹","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"IQD":{"code":"IQD","symbol":"د.ع.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IRR":{"code":"IRR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":"/","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ISK":{"code":"ISK","symbol":"kr.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"JMD":{"code":"JMD","symbol":"J$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"JOD":{"code":"JOD","symbol":"د.ا.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"JPY":{"code":"JPY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KES":{"code":"KES","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KGS":{"code":"KGS","symbol":"сом","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"KHR":{"code":"KHR","symbol":"៛","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KMF":{"code":"KMF","symbol":"CF","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KPW":{"code":"KPW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KRW":{"code":"KRW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KWD":{"code":"KWD","symbol":"د.ك.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"KYD":{"code":"KYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KZT":{"code":"KZT","symbol":"₸","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LAK":{"code":"LAK","symbol":"₭","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"LBP":{"code":"LBP","symbol":"ل.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"LKR":{"code":"LKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"LRD":{"code":"LRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LSL":{"code":"LSL","symbol":"M","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LYD":{"code":"LYD","symbol":"د.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":3},"MAD":{"code":"MAD","symbol":"د.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MDL":{"code":"MDL","symbol":"lei","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MGA":{"code":"MGA","symbol":"Ar","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"MKD":{"code":"MKD","symbol":"ден.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MMK":{"code":"MMK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MNT":{"code":"MNT","symbol":"₮","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MOP":{"code":"MOP","symbol":"MOP$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MRO":{"code":"MRO","symbol":"UM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MTL":{"code":"MTL","symbol":"₤","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MUR":{"code":"MUR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MVR":{"code":"MVR","symbol":"MVR","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"MWK":{"code":"MWK","symbol":"MK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MXN":{"code":"MXN","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MYR":{"code":"MYR","symbol":"RM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MZN":{"code":"MZN","symbol":"MT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"NAD":{"code":"NAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NGN":{"code":"NGN","symbol":"₦","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NIO":{"code":"NIO","symbol":"C$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NOK":{"code":"NOK","symbol":"kr","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NPR":{"code":"NPR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NZD":{"code":"NZD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"OMR":{"code":"OMR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"PAB":{"code":"PAB","symbol":"B/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PEN":{"code":"PEN","symbol":"S/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PGK":{"code":"PGK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PHP":{"code":"PHP","symbol":"₱","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PKR":{"code":"PKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PLN":{"code":"PLN","symbol":"zł","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PYG":{"code":"PYG","symbol":"₲","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"QAR":{"code":"QAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RON":{"code":"RON","symbol":"lei","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RSD":{"code":"RSD","symbol":"Дин.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RUB":{"code":"RUB","symbol":"₽","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RWF":{"code":"RWF","symbol":"RWF","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SAR":{"code":"SAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SBD":{"code":"SBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SCR":{"code":"SCR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDD":{"code":"SDD","symbol":"LSd","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDG":{"code":"SDG","symbol":"£‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SEK":{"code":"SEK","symbol":"kr","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SGD":{"code":"SGD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SHP":{"code":"SHP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SLL":{"code":"SLL","symbol":"Le","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SOS":{"code":"SOS","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SRD":{"code":"SRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"STD":{"code":"STD","symbol":"Db","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SVC":{"code":"SVC","symbol":"₡","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SYP":{"code":"SYP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SZL":{"code":"SZL","symbol":"E","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"THB":{"code":"THB","symbol":"฿","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TJS":{"code":"TJS","symbol":"TJS","thousandsSeparator":" ","decimalSeparator":";","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TMT":{"code":"TMT","symbol":"m","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"TND":{"code":"TND","symbol":"د.ت.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"TOP":{"code":"TOP","symbol":"T$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TRY":{"code":"TRY","symbol":"TL","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TTD":{"code":"TTD","symbol":"TT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TVD":{"code":"TVD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TWD":{"code":"TWD","symbol":"NT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TZS":{"code":"TZS","symbol":"TSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UAH":{"code":"UAH","symbol":"₴","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UGX":{"code":"UGX","symbol":"USh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"USD":{"code":"USD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UYU":{"code":"UYU","symbol":"$U","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"UZS":{"code":"UZS","symbol":"сўм","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VEB":{"code":"VEB","symbol":"Bs.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"VEF":{"code":"VEF","symbol":"Bs. F.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VND":{"code":"VND","symbol":"₫","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"VUV":{"code":"VUV","symbol":"VT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"WST":{"code":"WST","symbol":"WS$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XAF":{"code":"XAF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XCD":{"code":"XCD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XOF":{"code":"XOF","symbol":"F","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XPF":{"code":"XPF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"YER":{"code":"YER","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ZAR":{"code":"ZAR","symbol":"R","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ZMW":{"code":"ZMW","symbol":"ZK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"WON":{"code":"WON","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2}}

/***/ }),
/* 3595 */
/***/ (function(module, exports) {

module.exports = {"de-AT":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"el-GR":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"en-IE":{"symbolOnLeft":true,"thousandsSeparator":",","decimalSeparator":".","spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"es-ES":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"it-IT":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl-NL":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl-BE":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2}}

/***/ }),
/* 3596 */
/***/ (function(module, exports) {

module.exports = {"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 1057,
	"./af.js": 1057,
	"./ar": 1064,
	"./ar-dz": 1058,
	"./ar-dz.js": 1058,
	"./ar-kw": 1059,
	"./ar-kw.js": 1059,
	"./ar-ly": 1060,
	"./ar-ly.js": 1060,
	"./ar-ma": 1061,
	"./ar-ma.js": 1061,
	"./ar-sa": 1062,
	"./ar-sa.js": 1062,
	"./ar-tn": 1063,
	"./ar-tn.js": 1063,
	"./ar.js": 1064,
	"./az": 1065,
	"./az.js": 1065,
	"./be": 1066,
	"./be.js": 1066,
	"./bg": 1067,
	"./bg.js": 1067,
	"./bn": 1068,
	"./bn.js": 1068,
	"./bo": 1069,
	"./bo.js": 1069,
	"./br": 1070,
	"./br.js": 1070,
	"./bs": 1071,
	"./bs.js": 1071,
	"./ca": 1072,
	"./ca.js": 1072,
	"./cs": 1073,
	"./cs.js": 1073,
	"./cv": 1074,
	"./cv.js": 1074,
	"./cy": 1075,
	"./cy.js": 1075,
	"./da": 1076,
	"./da.js": 1076,
	"./de": 1079,
	"./de-at": 1077,
	"./de-at.js": 1077,
	"./de-ch": 1078,
	"./de-ch.js": 1078,
	"./de.js": 1079,
	"./dv": 1080,
	"./dv.js": 1080,
	"./el": 1081,
	"./el.js": 1081,
	"./en-au": 1082,
	"./en-au.js": 1082,
	"./en-ca": 1083,
	"./en-ca.js": 1083,
	"./en-gb": 1084,
	"./en-gb.js": 1084,
	"./en-ie": 1085,
	"./en-ie.js": 1085,
	"./en-nz": 1086,
	"./en-nz.js": 1086,
	"./eo": 1087,
	"./eo.js": 1087,
	"./es": 1089,
	"./es-do": 1088,
	"./es-do.js": 1088,
	"./es.js": 1089,
	"./et": 1090,
	"./et.js": 1090,
	"./eu": 1091,
	"./eu.js": 1091,
	"./fa": 1092,
	"./fa.js": 1092,
	"./fi": 1093,
	"./fi.js": 1093,
	"./fo": 1094,
	"./fo.js": 1094,
	"./fr": 1097,
	"./fr-ca": 1095,
	"./fr-ca.js": 1095,
	"./fr-ch": 1096,
	"./fr-ch.js": 1096,
	"./fr.js": 1097,
	"./fy": 1098,
	"./fy.js": 1098,
	"./gd": 1099,
	"./gd.js": 1099,
	"./gl": 1100,
	"./gl.js": 1100,
	"./gom-latn": 1101,
	"./gom-latn.js": 1101,
	"./he": 1102,
	"./he.js": 1102,
	"./hi": 1103,
	"./hi.js": 1103,
	"./hr": 1104,
	"./hr.js": 1104,
	"./hu": 1105,
	"./hu.js": 1105,
	"./hy-am": 1106,
	"./hy-am.js": 1106,
	"./id": 1107,
	"./id.js": 1107,
	"./is": 1108,
	"./is.js": 1108,
	"./it": 1109,
	"./it.js": 1109,
	"./ja": 1110,
	"./ja.js": 1110,
	"./jv": 1111,
	"./jv.js": 1111,
	"./ka": 1112,
	"./ka.js": 1112,
	"./kk": 1113,
	"./kk.js": 1113,
	"./km": 1114,
	"./km.js": 1114,
	"./kn": 1115,
	"./kn.js": 1115,
	"./ko": 1116,
	"./ko.js": 1116,
	"./ky": 1117,
	"./ky.js": 1117,
	"./lb": 1118,
	"./lb.js": 1118,
	"./lo": 1119,
	"./lo.js": 1119,
	"./lt": 1120,
	"./lt.js": 1120,
	"./lv": 1121,
	"./lv.js": 1121,
	"./me": 1122,
	"./me.js": 1122,
	"./mi": 1123,
	"./mi.js": 1123,
	"./mk": 1124,
	"./mk.js": 1124,
	"./ml": 1125,
	"./ml.js": 1125,
	"./mr": 1126,
	"./mr.js": 1126,
	"./ms": 1128,
	"./ms-my": 1127,
	"./ms-my.js": 1127,
	"./ms.js": 1128,
	"./my": 1129,
	"./my.js": 1129,
	"./nb": 1130,
	"./nb.js": 1130,
	"./ne": 1131,
	"./ne.js": 1131,
	"./nl": 1133,
	"./nl-be": 1132,
	"./nl-be.js": 1132,
	"./nl.js": 1133,
	"./nn": 1134,
	"./nn.js": 1134,
	"./pa-in": 1135,
	"./pa-in.js": 1135,
	"./pl": 1136,
	"./pl.js": 1136,
	"./pt": 1138,
	"./pt-br": 1137,
	"./pt-br.js": 1137,
	"./pt.js": 1138,
	"./ro": 1139,
	"./ro.js": 1139,
	"./ru": 1140,
	"./ru.js": 1140,
	"./sd": 1141,
	"./sd.js": 1141,
	"./se": 1142,
	"./se.js": 1142,
	"./si": 1143,
	"./si.js": 1143,
	"./sk": 1144,
	"./sk.js": 1144,
	"./sl": 1145,
	"./sl.js": 1145,
	"./sq": 1146,
	"./sq.js": 1146,
	"./sr": 1148,
	"./sr-cyrl": 1147,
	"./sr-cyrl.js": 1147,
	"./sr.js": 1148,
	"./ss": 1149,
	"./ss.js": 1149,
	"./sv": 1150,
	"./sv.js": 1150,
	"./sw": 1151,
	"./sw.js": 1151,
	"./ta": 1152,
	"./ta.js": 1152,
	"./te": 1153,
	"./te.js": 1153,
	"./tet": 1154,
	"./tet.js": 1154,
	"./th": 1155,
	"./th.js": 1155,
	"./tl-ph": 1156,
	"./tl-ph.js": 1156,
	"./tlh": 1157,
	"./tlh.js": 1157,
	"./tr": 1158,
	"./tr.js": 1158,
	"./tzl": 1159,
	"./tzl.js": 1159,
	"./tzm": 1161,
	"./tzm-latn": 1160,
	"./tzm-latn.js": 1160,
	"./tzm.js": 1161,
	"./uk": 1162,
	"./uk.js": 1162,
	"./ur": 1163,
	"./ur.js": 1163,
	"./uz": 1165,
	"./uz-latn": 1164,
	"./uz-latn.js": 1164,
	"./uz.js": 1165,
	"./vi": 1166,
	"./vi.js": 1166,
	"./x-pseudo": 1167,
	"./x-pseudo.js": 1167,
	"./yo": 1168,
	"./yo.js": 1168,
	"./zh-cn": 1169,
	"./zh-cn.js": 1169,
	"./zh-hk": 1170,
	"./zh-hk.js": 1170,
	"./zh-tw": 1171,
	"./zh-tw.js": 1171
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3597;

/***/ }),
/* 3598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3531);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js??ref--3-2!./blueprint.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/lib/index.js??ref--3-2!./blueprint.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3532);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./iconfont.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./iconfont.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3533);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3535);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./style.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3536);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./quill.snow.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../postcss-loader/lib/index.js??ref--3-2!./quill.snow.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3603 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3537);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./semantic.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./semantic.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3538);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Calendar.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Calendar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3605 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3541);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentMethods.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentMethods.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3542);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./search.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./search.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3607 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3550);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Description.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Description.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3551);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./LineItems.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./LineItems.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3552);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Logo.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Logo.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3553);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Notepad.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Notepad.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3554);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Notes.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Notes.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3558);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Terms.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Terms.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3562);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EditableText.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EditableText.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3563);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Fab.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Fab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3564);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./FileIcon.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./FileIcon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3567);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SelectableBlock.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SelectableBlock.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3568);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Success.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Success.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3569);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SummaryTotals.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SummaryTotals.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3619 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3570);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventCreate.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventCreate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3572);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventSegment.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./EventSegment.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3573);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./LocationAutocomplete.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./LocationAutocomplete.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3579);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentsGraph.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./PaymentsGraph.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3582);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./BigCalendar.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./BigCalendar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3583);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./DayView.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./DayView.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3586);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./ToastOverrides.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./ToastOverrides.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3587);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Steps.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./Steps.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3588);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./TextEditor.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./TextEditor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3593);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideUpDownTransition.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!../../../node_modules/postcss-loader/lib/index.js??ref--1-2!./SlideUpDownTransition.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/21641a11858547e863d132ca9bf4f7a4.eot";

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/0148ec9e0eca2f004d96763a53cefc28.ttf";

/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/0fdda991a56922059fe815c03180e4d5.woff";

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/05b51a6b50b3ea1fe0c380207f164a53.eot";

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/afe1cf813c6c55312fcca733bd9d234d.ttf";

/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/3a5e388e938cbbbbb4acb90b5cfc2d73.woff";

/***/ }),
/* 3635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAACrCAYAAADRhIbPAAAAAXNSR0IArs4c6QAAIZZJREFUeAHtXQuMXUd5nplz7mvfu87iR2LHjyQOTmIeaRJSoLXDsyEgKDghIgJVVCU0agFRqSBVslOJqqoqtZVaqlJAhBJQ4xQCiagglMQ88yCEEJKQxNmY2Ml6197d+36c1/T7555zfe/du++9j3N2Rl6f15yZf/75zn//+f+ZfziLWJLyiGDfLl/HmHwH4/xqJtnFjLNRXCdw7qnmci7VUcrqkfnXvOk6eB7kZ/5zuUR+VLb8eiSfR9ey62miw6craAWa5bfPp0cGdPnHgM6F7gfP/SOv8WGh8nx6AvoDvjZfB3QFfKw9ZyXwbQ799jxj5qNsZPyBo6e3zB46dEjefvvt7PDhw6o9dXQoNi/nP76cTGHII+890se88m2g9RPA5/lhoFnTuDgHAE5bcvE910j8y4m9H/pxJpPxcrmcPHPmjHz66aclAX+5oI8E0OW9n72eed6/Q37tWJx1+mloOcCN+4t9Wz+dvez9LxQKBZdAPzEx4S0X8KEGOiQ3Z9/57Ofwy/oZgDzUbQktADtKOM87ydG/nHz1B+9JpVI2AO/MzMy4BHioN95i0l10lM51rMwH+Rdx/KwG+ToytqeLkgOx8twXtzz9jduKxeKgECIVi8Xil112mQGyxZEjR4TCRYs2hFYKym9/5u8I5C3apG9FnAMcw/dS/7bPTO15z12u6xaBg7JpmtaJEyecY8eOea10d/oSQpeUTi7l50F4aD/U0DG9twjmMTv/B540H6kMbEkD5NLzPDk6OipHRkbkHXfcwR588MHA4qQoDx1QqtaV0jN64NlbyOsKNbHUsycvv+WjUpqzlUolC8Dnoc5Udu7caYOeBp09fDo6TIga5F2BVe9Vapf2jp449j7H4WOJRGLItu1+x3Hix48fN48ePdqgr4cK6FLeBVVLfrL3OK4p6hYH+vMnbxSCjaH+0Xg8PmgYRsqyrNju3bsFnEw1jSVUQGff/uVBSPNt3WKqrrf3OMDt0vbB2Wde67psBNQNQ6L3Q31JWNZmE4NS+GBhgkYye4/0xSiCW18nzYEmDvTlXrw6O7r3OEBtQU8v41gZGytYjz32mHPffffRoFSGDOj8Gn/aRVNT9eVG5kCsnL4YzqJ+zzMAclY0jL5iMsnL0Nvtffv2qflN4QI6lxfXpiNt5J7VbW/ggOGUNsPIkuJc9HHu9UtppPL5fBE29go8pg6pL+ECOgYcDS3UF5oD4AD37H44RuMAeQraOABvp6RMxPv6mIm5MAIWGC9Ug1H8LCV0z2oOzOOA9GJQXQwpRdx1nSTAnojHvTimBxh9fX0Cg1IWKqDPa6C+oTngcwCeUQBdmrC4xHCM4zpWLpcNDE45JHroVBfdsZoDLTkAiQ6hLQ0hCNOeCQFvlMvCKBRmBfR0LdFbck3fDCMHYC+Hlu5Jw/O44brCGBgA6iHRMe9FS/Qw9qimuTUHMKuRnENwErkC6jmEPOfj4+MMJkYt0VuzTN8NKQcAdJrLxTk8pBw6Op+dnVWeUT0YDWmParIbOYDBpwI0zIx4QLPPY/iDtdFPGugBJ/Qx0hzQQI909+rGBRzQQA84oY+R5oAGeqS7Vzcu4IAGesAJfYw0BzTQI929unEBBzTQA07oY6Q5oIEe6e7VjQs4oIEecEIfI80BDfRId69uXMABDfSAE/oYaQ6EaikdJqedRG9wJlREekxoMARmZhoIpIsPlu5Vo5BharI6kdKP+y+Ca/85869rC1BrAeyrnX0u4H3Q+dUXgys/wL0fSYFqxuInf6oFEUih/ZFwUyVQVz2rBb6v3lck1+fz3/P8F7GIQL2HqafqhWqzMW3Jf50m6tVO6aSZbrXFgGcYnpPkTmmMYSVOQ/4NdLFsoMuTnxpjVukgeHsNk/widN0YzrFsiTqUow+oo6sxNHBS7fVzvV+9rmaqy6deqrsO0OLf95FUQ5FIF1RvSoTp4AIrSowYOhf9zgF6mrPWWK+PGyJH1c9rEKEPA3drQK++V3tdVicIBeTS4lqVv9oKtLd6LYJrlC8waw4l+sCr8YFeo+TnrF7U8al6w+dTwA3AW+U/d91ID0JQVZ8HxfKgvgD3wZsePkHhMh4rOazvFa80OiszSSeWyV0grPzWgJqNcFwS6HLi429mnvw0qxSvB0NivqwKOkgdFWAC8bUY1+blCTqm+aXG+0G3BXWrXoa05swBZurerT+vu73S0xoq/fKWfb3Siprzr7a+ee0+dwMft8lkZTDGKoMsOXchg2jyNiez5fz2R+KT5a2iktveTEYUrxcEunzx1p0A+L9iJ4l3RbHhG7lNgpWHUgPPXy33JtPlyV0PJc9O/R7UmgWxEAVetRyMyuO3vg8g/xWkpQZ5FHp5gTZwrzyS2vLMNdbu4SeYEc8vkC0St+cBXb7w8VuhE9wNkA9HooW6EYtzAOOBROrFK+098RPMMDEGimZqALp84WM3Q4P7PEZbDfej2XTdqnoOxOOnLrd2DD6LYfU5o059hpCf1wAtf3fbZWjLFyHJa2OvkLdNk79CDiQGXnxdZXTsVyt8LRTZFdDVJrSO+2WAvC8UVGsi28MBCLnY+ad2SzN5tj0VdK/UqkSfmPog1JWru0eGrrlXOCBkecQeT77SK/SsFx2+6iL/er0K1OWEnwPx807vZCJWDH9LzrVAyBO3vR7SfP+5W/pso3OAy/KQPdBP0y0ikwRzXG0rj0x3rl9D+LB7zr26fsV2rSRSXd7Ytdp1xT3LAZHKD/YscasgDLP/2KWreE+/EnEOiHhpKEpNhESX41FqkG7L+nCAM5u2SnHXp7Tul0IzpbXtvPv90IMUuJgKzSME9B5ksSZJc2C9OeDb0de7WF2e5kBvcUADvbf6Q1PTJg5ooLeJsVEoNlgyGIW2aKBHoRd1G5bkgAb6kizSGaLAAQ30KPSibsOSHNBAX5JFOkMUOKCBHoVe1G1YkgMa6EuySGeIAgc00KPQi7oNS3JAA31JFukMUeBAB6Iz4Vva9D7GBq9FTNCB3uaZixg+uZ8zNvMt0BnJqA+9zf82Utd+oG/6Y8ZG3trGJqxj0fQhjrwNBSLix8zd61iwLqrbHGi/6kKSPGwpjDSHjccdprf9QO9wg3R1mgOtONB+oJPOG7YURprDxuMO09t+HX3mm2gSFpSHbjDa4Z7Q1bWVA+0HOlkvZv6n+tfWpujCNQcW5kD7VZeF69ZPNAc6xgEN9I6xWlfUTQ5ooHeT+7rujnFAA71jrNYVdZMDGujd5L6uu2Mc0EDvGKt1Rd3kgAZ6N7mv6+4YBzTQO8ZqXVE3OaCB3k3u67o7xgEN9I6xWlfUTQ5ooHeT+7rujnGgA3Nd8C1tei8mdf1+768w6hjbV1mRWgH1M8wbugcF6BVQAReXswlw+4EephVGAed69ahWQL0d1EF46BVQtV6SXFRqFwuctF910at1FmD9Gm5rnjYwzzWS6XM36Jdu/v4F7Zfo5yjQZ5oDbeGAmxg6LYTwd9ETFAQY5zbqstjY2Ji6336JrlfrrH/nap428LTUv/lF/wZATqt8pDRN00smkwrk9Kz9El2tMMLPiR6MNnTOqi4aBqOrKiF6L3Fh58Zf91s0TIEcgt1zXe5RKpfLMhaLyQcffLADQFcrjLCcTgE+enzWLeouB8r9W5+wedxCgBIpBHehtrgC20R7nukmEgrw8sCBA7L9Er27fNC1R5kDXDizW97wEzQR0lxCbfAI6A6AbhsGc5DcyUlT/uQnRzsh0aPMad22bnKgMLLnWCU1nuFcSW4CuY3ziusyS0rbjsfjzvh42bv22kOy/YPRbnJC1x1ZDjip0YnpCw7+FA2kAacHgJOZhezpZQxIy7i2kNxMJkP2Rg10MEGnkHHAi/VPTe664agQJgGcjOYK5DAxFjEYLQDoJdyrAOROLpdTlheto4eskzc6uU588OTk7vd8w4sNlkgv51w68BRXPE8WIbjzuFUwTV7k3LCGh4fdK6+8kj4GPRjd6MAJS/sJrMXBHQ9P7XjrD7iRcAjk+MORVSDUAWyRg6qes22Rh0WxnM1m7f3797u33367aiKXxz9WM6qHpdGazs5wQD41ZjPpxTpT28K12ImRiblXXf1/hZHdryAX8E2SnEOSK30cqopMx2LiLEznZ103PitEJQcbemnfvn2UR2qJvjBv9ZMucoCA6Rj901bfecezm1796+LAhdM+YGlg6UEXVzo5AF5A3iyk+izwPFep8OzAgCyePBm3KpWXPABdgZyaonV04oJOHeOA1feq3+RHL308qFB6HuP+PBVPGI5rpEqlvs1zzExalAdSmgnoJDglSY6BJ1lXJNQVGnTyHO6noZ/Pua6VEWIgD/t5OR5/xfn+9495Bw8erGkrWnUhburUkgPtUF2Kw3t+PLXjbT9EhSRtlYSunpPDB/57ArYPfEI2PcP/eBaAnJVxXgLQsT2JmWHMyViWyHIezw0Pi9KpU6csDEDJElOT5jjXEp2YoFPHOUAYJpDToNIxDG6TR9O/B3B7JOiBcHLrqw/ABbAhydW8c1hbXFhYeM51ZZ7zRE7KbLFSyZRzOduamJjwAPQGkFPrtOrS8T7WFYIDBEQHf1BPeAmghpQm6wmpJeTlVJKcmSbzbJt0coZBpUF54RBy4BCSRdd1i7EYB+CtciIxUJmamnJIkrcCOXG8A0CH81UvpSNerz01zF4kgRjO5KssvtXEg15NA0pRcF3PgpnQAcCVymJDzgthuEA+Jmo55N7HIJNXMAkXf4WKbdsW3Pz2zp073QsuuIAYMk+SBxxq/xQAtZQOy796fUe6gCO9fAyW0hFPw50glGkZkAcpLvKOw9JQUc5CfYF1RUwB0Kfhvp8C4E/D6TmFv2no7WdsOzmTTLI0QJ7r6+srlkqlyuOPP+7AVr4oyIlV7Qe6Xva1/pAMNU/VL5GaUkvqCKwkGFiSs4dn4OiZs+38XCbD5jCPHCZDsqh4aagpGTiAcjMzbqGIBLNh+dFHH7Xvu+8+99ChQ96RI0eU93MxRrcf6IvVrp9tSA5AnEuoKdWDq/TyCqRzGdNqi1gVVDCMvAI0gRrzVUp79+4tzc7OVk6d+rl19OhRUnmWDfCAwe3X0WnZV1j2GQ240uvHCCylg6qCxOk/Gny6WPrmpNNpmoTlHDt2TIn9w4cP1+zg9TZxSPAV91D7ga6X0q24UxZ8oWEwumCu0DwgsENlIbBLB8ZFy9osz5yZkKSKUCNWA+iFGt9+oOuldAvxvufvu7H+acPKnd/zhC6DQK2jL4NJGzXL5K53fUPGUjQoDH3SQA99F7avAXZ8pDC5453/JUUM7vZwJw30cPdfW6mnOSdW/5aZMzve8hUmDPJehjZpoIe269pPOMwhVIksDe8+Nbv1jV+CvRsu+nAmDfRw9lunqCaDCFzw0s6M7XsqvWn/FzjmonSq8vWsRwN9PbkZsbLI9Af1hbyONiZWlc5uvuZH+eHdXwhjMzXQw9hrHaKZVJeqB9ND5CtWAejzM7vefrTSt+UrHSJh3arRQF83Vka1IJpBKGhlj4WxKU2Pzb2y5/3/5iZHEWcwPAlAV4tMw0OxprQjHJCMwI1Zf8pXjyBYND3F5RZc9QXMJsyevOTGv3VjAz/sCDHrUIlgXGbXoRxdRMQ4ILlZZ04UkOoSCyA8WixRwRxwgJ2lX77k3X/lmn2PhaHpAlPVT4SBUE1jZzngsv46jygZWgyS6h5F7sSkQlr0UHD4wNnTu951mzQSz3WWupXXBokufr3y1/QbUeeAw0dfJrWl2k6aaqhW4dNUQw/qiw28lzFnPG8lRydndx78mBTmy73MEwDdDI2e1cuMjBptRbn7Bb9NCuS0VJl2kUgkEljHaXu0hA0fAkJLxPO5/gtfzGx/w58xYdb9CvQWR0Saj93LOMMiU500B6oc8Hi8kBOvJ6ArdYVUFgh3WruJ3SRcb2RkxKMotbQgGX8K7NOpK57Jjr/mzxGjhfT3nktiZOfhHOOxO3uOMk1Q1zhQZBc/7HmClgCRck6RsWBHpz9PgR2xUyRW21NYCbLM2DMzMwjTHM9ltl3zaG7kkk9hqgBW7PdWEliaxHKVbf/IOK8bZfcWkZqaznHAY/H8rLjuEdQYeEVhafGgptCfgNaSdDdt2uQRbigPgZ1W41PwIMuK56a3vfmBwvDOv1loqgCibtVWDXWuVTCTYnGpnDIP/c5jqX/oZMW6rt7kQJpd+12PDVIgfZLokNgUe0UF2CfPKMJN2C4GovLpp58OQksosEOq25Y1S3HJs1Pbr7+nPLTt71u1EPNmYJtX4SxaPW7bPfKMStK3XhIf/ifJY7SDgE4blAMlsevhNL/2GTSfdHPyEtnQVmirlDICCZUNw0AclZJDeAnWc9J8GMr/1FNPkRpj4SMoQdPJTe684asIEvofzawUnJackTUnsOg052jPtZoCQLsCIJSAdZYd+BM4Cp5tT1W61F7mQIVte2pSHvoeaCSQq4lcMCmWIX2xi4SB4PqyhFDMVn9/P0XEIt29lgjsFHaCwE4fA5nay2WRnbz4A//sJkbvrmWkE5RNA1o6q84CbnjatguTiKSGHT9+3C2IK89ImbjpPHn/VwWr7G9brbrgnuJAie98dJLd+L+0VYoPQoqKBZALhGX2KMA+ggwlAPiyhfgqJLkDtaXWjgBHuOEASywWs5lhJPiJi24+svP5O0YNq/AWygyokXcVMbjIksOwKBquKKNWTNtOlESnXQEuuugil3YJKLDLTp/gf3qLxTbdhQFqVwYObWutLriBA1IkCmnxprsn2Qe/C1VCgZxAiEzQ0SXMhBxRannWdQ1smVIsz83N2dPT00oaNxTkXxDYgSUJLCGsnGmR9zSZFOmTe276tBdL/YKyQaySzk/lY92/8Aw4XP3X23pQ39IDDzygKsGAAoEdTUR5HERAvNeAMPFkjM9th3Tf3FYqdOEd5QDGYqUCv+TnU+wD3yyJva8QQEEAmRFJ0sL6xhGhlmdgTpzzPGfOcSqIjSiLUEvsq666CpFtFxaA2KWZpD2HrV2Ojo6qoC34MrzS4I4fD2aOv1maycn82D5442kMQEFDDXxQHj4kWSoWTfxinHJh0Vl38KtwF0Q4EqOvNZG4yNq+XRbzeW5mU298aM590/ND4snXDrAn3xKXZ68QLL8NY2Zs1KtTWDggmWF7vG/GkmMvl8WFx7PiquddN0YRryiEkLKuAAMK5FAnCtCdEVRfzgIWAHpfNpGwyKGognnSO0u1m+Ky+DFZHOCpcv75glucpgpcd2v/2d++A+9nIM1pyxhYcjwH4Z/VB7FUuWt53gBYECduuOEGA3MY4snkeIrz/BAcASPYenoU7cNRDkK6j8TlyW3Cyw0Z3I3j64fJFP/5JeGDaShzpcTFZHp0SP7i3St9b6350Xsyx6/8riU3zXJh0KXylghuQLAFP6++JPMlGr535POtB4AMzkEGutDgQA+d0rPqfZoqUo10SdAirhmEMOzmgCOQJUy84ylNsloOSR56AXosgFrNA7poACc4BczHUeAd1fBqAP1qXYoC9S6eoTeSUBEM0qurOavzV/Acz0AJOg7PpXLnoyKKaKt2kYBKMYf7aQxA80NDQyVEq7UpmCeB2C9q0QPe5cjPYZ0RcDDFoBankAbx0gjowdFJoL34dRC5WIzN4dckTYNYiql444031uhdtJIVPGwAJRGHd/ljjz1moGFxWJFSUKkG43FvCBGmh0HcMLIMIEsK+ZLgFb5KbgDk1EPgWQB3/Bh5XkPZy6UpJZ/dupV96xPLzb9e+dLs6u/M8useB8MJVPTzSx1K0k45ThQYqyBZVpVVw8KysjZkIvA23FjmBdG3VKK2IQ9aRM4gTuZDeDurIMf9IspAWAsK4WxjN+a+bKWSLlBMRDyzfS/ovEHoYnWifAV2Ep7IF9uyZUsKUXIHMOAdAH+BH9yMxUrQ5XNQi3JkmoR+TwPhpRuzWMUtnjVE6kIFoE2yiYkJqsgCEQyTdtDxQ/jqHdpfHY32sNWd2YfnALuXQFsAdg9ij5PTC1MdcIVtaVrUtaxbpvAGydLayZTn+38wy66jfXVodYGScjgnSQcLgQKDsjRUwd76p7sZZ+c++WpLfJC1bFb9R0EOleZkGIvbnKvvL8zyc3Wjc9FG/MMHTIH4pY0hGWKNe7RnZxGfdB6mRACuXCB1BZKcgn+qAPv0HuGjmbbFrgM8IY8L4UmLOFilUqFxIH1kGJAmuQu/Kp7jNsz10GEWK28tzxqATgX5xBHUJIizxsbGMAfZoo7Gh+eQyQlAdwF0E1+kkUC2OFaemLEYF3AsCOpwfJALc50qWSRxVqGPqGOpJHY/NC2vJ0cZdSS1k3RXdD4Nymh7P4Hg9NWdGHBPqQy4v1hq2VnNAIbQqOUD2GrlkbltfpqPfvB6Xqovs/6h43gw4ZE65kKcG7B0MMxZoRI4LCOsYppqp2U4elzsPmGTd1NJcfyqO/hTWCBc1Je53HMfT4x+EQjs27ZtI1STdxX6uY05BUkEGC3ZZJ+nuqDuLLfoFeU7x+Gm19Cn9Iz+BOyiBn5yaPAQ57w/gTZjtqaENJdxzzNiAD8kugvdXskxVSYasmDZTVU1XG4SD+8Z8X50R8PNNl1U+PlPToqPfBOSWmGYnB2oirYOwYCM9scRFKEK8btdeAgNdAhEfBMQAZJ5AFAyqolmerf+VnM59KxVWfXv0DkR2nyv+RoTapvy1MKxSLSRGosmewCbsGH+Q9daaPcAgFe0yIQIXdpBDHLajFaSB3S1IK+nC3USHpRajLkyBnR2Y+vWrfzMmTMskxlyh4ezLjmcyPG0HvXV103ni4KRiENjORrNd+/eLYhArC4xsduAaVkJMx6vmAC0CaCrBJEv8AUw8G3RcpuJqL9+lbj/0iH5xH3199pxbrHzXpg0P/p1GqiRukIbRuGbpp9wgNuDVUCmwfAslhngF8wmNY5+bmsAop/gVolUveb7ZZKPTQmCYl4+yrKSvE1FLvkREP2UaE45tRl954Jeh9STfD7vEsDJ8nbgwIE1SfFmuoJrVK3ADhOkGBwc5KhP4QT1q9mQ6/lhBXUGx3mqS/CAjv6XRbwhwEsA3sMX52BCj8hkTKO/P0vAVgNRQjrp9NitAMTDGLPKFO+fxZZ67U0uH3l5kt/y3wRytM0HOUlyF3tXijR04lncJ0tAtlz2SobhQJc1XbStlgYHYy2BivdqeYITfPsNiX5BmnX6IEO8Beuai6T3g/zLPQb6L1RRhGY+w2Dj9iYnTTk+XvYAcppyq8CNPl4XCd6KLsIT8Yfin+OXoiEL8MXW69ejoWD/YkWSF0Sq/CBKSfnx8XGOr59B96p9nVQupMSKyq0n7ELxn1fEZObR+nvree6yvpmXxYe/7PEx2lqbfsZJGSFPHakp2EpEzMC2O0PnaEcef5VCoQDh5yB+t7VigK2GdpJwq3lvOe8A0BISlaHfJE21pdmr7QbZQnQFeKLn7VBX6utdNSCDQuqJpQ8guL/a4+GPpPczt1TbWXi15bR6z2PJ3CS/+Uu22Ep745DkgmWFJi5xeOZoEyimQI420R46OVo9g3LsiYkJj6altiqz1T2STK3ud/peu8HT6faspb41A3Mtlbd6V078xWuYZ/2q1bO13POYWZ4W7/9yUe46g3ICEyJZVyDZaVc0MQPrFv4YHCWlLKQ4WR/UhlDt/EldS5v0u8vnwKI6+vKL6e2c8Cw6M/ydXyeQA9CkrpBxzsIRM/JYBhYQgNvBn4sB6EBuaCheAtCVk4R+6rVk7O3+XQ510Qc6F94c+8OjOXb5yQDkUFto41bM36CZeUqaz8ZiBs3rAMg57Se/Kk/gchiu83SHA5EHelpedW+aX/1cAHKwGTEEqyAnXRx+lFk4SdIYZ+YsK1fCBE4N8u5gsa21kmkwsinPL//BLD9I+j4wXV01g3N4/zxMQyULC6ksVXs5rCqkk1v+kjCtrkQMFZGV6EW256FpdkPNtQ9AwyHE4eXkOejlALkNVcXATsUii5UzFCW20k7PXMRwE7rmRBLo5NqfFjd9D7PLlCSHqkIz4kiSw61PZkQDDiFDWVegm2Piv2Fhd2KXHGJ64Bk6DC+L4MipLnDtHz9t3HIPWq9AXnXtszIwn8c5QE6LCdgc5nhg7/kYRZWq0NIv+AC0urIsyIQzU6QkusOGXp4Ut9w137WvvJ4Z2ya3vpyDBIdJ0S5A0ldeeukl984776ztVhzObtRUL8WByAAdYY7PnjY+dKdkfWQfV659DDgrcO1DaosMWVdwDpWFZUolt5DPm5iXdVztO7/cVTNLMVM/710OREJ18Vgie5rf+DWHjdIqGXK/01xrTDulgJcGZiIq6wokOcvQ0rDRUVG+9toLbH9yUU+463sXItGgLPRAr7r23/u1CttMq9bV/BV0DUDOaf0j7eYBnZzUFZaGCM9jwlQZE/xt6OQq2pQefEYDyEu1ItRAV659449qrn2Atubax3QWrH0MXPsWHEJWfnh4WM1fAVM0yJdCRsSeh1dHh2t/lh24K+ddVnPto28wSYtivWvXfsRwuubmhBLopFRnsWo/w656Hnp4bZIWbpNDiILtaNf+mqERrQJCqboU+P77Z9iBJ9AVylYOHZwWRTa49qGvzxHotWs/WoBdbWtCJ9FL/KKfTrPrf0YgJ50cSKfgO5DkTLn2YSefxWIguPYNXGvX/mqBEbX3QgV0hDb+5ST7wPfRCbT4UMUKBNgbXPtYgQ/vZzmrXftRg+ra2hMa1cURY7+ZNG65C8AmnZzmpJC60uTat7Rrf214iOzboZDoHu9/7hX24S8gUFISMw9p1T6tWKf4K7Sguc61n9Ku/chCdW0N63mgSx4/gQXNn0M0WIBcIoASV/ECtWt/bR2/0d7uadUFsWZPT4u3fbLsjWOhhFvn9RTwelLoYTaHlUHatb/RULuK9vYu0Dmfm5OXfyTnXDGFCVn+qn1Prdon1z7iByrXPmImadf+Kjp+o73Sm0DHTtaOufWmrHn9cwRyiqONaL2YlRis9SSQ0+IJ7drfaIBdbXt7T0c3mM3c5M0vObc8Aj18hIJ7IsqrBbAjNIVaMYSjiQBDJMl5DpO0SthVTy9oXi0CNsh7vRfACGHvEOLOxAQsxF9PDSHA7Rj6YhgWFtohwUHgXlhabAoCmsFsRNpyxMISOAorp1cIbRDQrqaZvam6oCUAumeaNgXjL7uuCt+M4J+03Yilotxq1/5qunvjvtOTEh3dYUCqxxEcPmWagylEOU4gEjV207ARp9wrEcj1qv2NC9rVtLxXgU6bD5gAcxwSPY7Q1CYtqsARu5wlLGzRbdOCZjRYr9pfTa9vwHd6TnWBQ4hm4dKmrC5AbWPBRHlgYKDg6+MlxPa29Kr9DYjUNTa5A5tTr5xCgF1t+YEdNCQC8HsAuwfjinPppZe6iO3t3X333XrV/srZqt/oNQ5AXaHZiRyr8wWOtT//uufUrV7jn6YnhBwIQB9C0jXJPcSB/wcVEcF9v5uZAQAAAABJRU5ErkJggg=="

/***/ }),
/* 3636 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+bm91bl9jaGVja21hcmtfMjU3MzM3MyBjb3B5PC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJub3VuX2NoZWNrbWFya18yNTczMzczLWNvcHkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMy44OTQwNjI1LDIzLjkwMjgxMjUgQzI5LjM2MjgxMjUsMTguNDM0MDYyNSAyOS4zNjI4MTI1LDkuNTcwMzEyNSAyMy44OTQwNjI1LDQuMTAxNTYyNSBDMTguNDI1MzEyNSwtMS4zNjcxODc1IDkuNTcwMzEyNSwtMS4zNjcxODc1IDQuMTAxNTYyNSw0LjEwMTU2MjUgQy0xLjM2NzE4NzUsOS41NzkwNzEyNSAtMS4zNjcxODc1LDE4LjQzNDA2MjUgNC4xMDE1NjI1LDIzLjkwMjgxMjUgQzkuNTYxNTUzNzUsMjkuMzYyODAzOCAxOC40MjUzMTI1LDI5LjM3MTU2MjUgMjMuODk0MDYyNSwyMy45MDI4MTI1IFoiIGlkPSJQYXRoIiBmaWxsPSIjNTlEOThEIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjI1MTU5NzUsMTQuMjk1MzMgQzcuNTkyODAzNzUsMTMuOTU0MDcxMyA4LjE1MjgyMTI1LDEzLjk1NDA3MTMgOC40OTQwOCwxNC4yOTUzMyBMMTEuMzQ2NTg4OCwxNy4xMzkwOCBMMTkuNTAxNTk3NSw5LjAwMTU4ODc1IEMxOS44NTE1NjI1LDguNjY5MDg4NzUgMjAuNDAyODIxMyw4LjY2OTA4ODc1IDIwLjc0NDA4LDkuMDEwMjk1IEMyMS4wODUzMzg4LDkuMzUxNTUzNzUgMjEuNDg5MTQyNiwxMC4yMTMwMTk1IDIxLjE0Nzg4MzgsMTAuNTU0Mjc4MyBMMTIuMjk5NTI3NywxOS4yNDc4MDM4IEMxMi4xMzMzMzAyLDE5LjQyMjgxMjUgMTEuNTY1MzM4OCwxOS41OTY2MTEgMTEuMzQ2NTg4OCwxOS41OTY2MTEgQzExLjExOTA4LDE5LjU5NjYxMSAxMC41MDYyMTk3LDE5LjQyMjgxMjUgMTAuMzMxMjExLDE5LjI0NzgwMzggTDYuNzQwMDQwNjgsMTUuNzQ3NDc3IEM2LjM5ODc3MzE4LDE1LjQwNjIxODIgNi45MTAzMywxNC42MzY1ODg4IDcuMjUxNTk3NSwxNC4yOTUzMyBaIiBpZD0iUGF0aCIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 3637 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3638 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Y2lyY2xlX3BsdXNfaWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0ibm91bl9QbHVzXzIxNzI4NTMiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJjaXJjbGVfcGx1c19pY29uIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy42MTQ0MzAzLDAuMDA1MzA2NDQyNDMgQzYuMDI2NjE4NDMsMC4yMTM5NjQzNTEgLTAuMDEyMzU5NjEzNCw2LjQxOTc1OTEyIDAsMTMuOTk1Nzc2NiBDLTAuMDExMTc0NDY2MiwxOC45OTUyNjgyIDIuNjU0NzQ5NDksMjMuNjE5NzgzMSA2Ljk5MDk1Nzk1LDI2LjEyMjc2NDIgQzExLjMyNzE2NjQsMjguNjI1NzQ1MyAxNi42NzI4MzM2LDI4LjYyNTc0NTMgMjEuMDA5MDQyLDI2LjEyMjc2NDIgQzI1LjM0NTI1MDUsMjMuNjE5NzgzMSAyOC4wMTExNzQ1LDE4Ljk5NTI2ODIgMjgsMTMuOTk1Nzc2NiBDMjguMDA2MTQzMiwxMC4yMTkyMzgzIDI2LjQ4MDQyNzYsNi42MDEwMjI2OSAyMy43NzA0MDI1LDMuOTY1NDIxOTYgQzIxLjA2MDM3NzQsMS4zMjk4MjEyMyAxNy4zOTY4NDgyLC0wLjA5ODY5Nzc0OTYgMTMuNjE0NDMwMywwLjAwNTMwNjQ0MjQzIEwxMy42MTQ0MzAzLDAuMDA1MzA2NDQyNDMgWiIgaWQ9IlBhdGgiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjAuNSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE0LDYgQzEzLjMwOTYyNSw2IDEyLjc1LDYuNjAyNjcyNjUgMTIuNzUsNy4zNDYxNTI4OCBMMTIuNzUsMTIuMTkyMzE0IEw4LjI1LDEyLjE5MjMxNCBDNy41NTk2MjUsMTIuMTkyMzE0IDcsMTIuNzk0OTg2NyA3LDEzLjUzODQ2NjkgQzcsMTQuMjgxOTQ3MiA3LjU1OTYyNSwxNC44ODQ2MTk4IDguMjUsMTQuODg0NjE5OCBMMTIuNzUsMTQuODg0NjE5OCBMMTIuNzUsMTkuNzMwNzcwMiBDMTIuNzUsMjAuNDc0MjUwNCAxMy4zMDk2MjUsMjEuMDc2OTIzMSAxNCwyMS4wNzY5MjMxIEMxNC42OTAzNzUsMjEuMDc2OTIzMSAxNS4yNSwyMC40NzQyNTA0IDE1LjI1LDE5LjczMDc3MDIgTDE1LjI1LDE0Ljg4NDYxOTggTDE5Ljc1LDE0Ljg4NDYxOTggQzIwLjQ0MDM3NSwxNC44ODQ2MTk4IDIxLDE0LjI4MTk0NzIgMjEsMTMuNTM4NDY2OSBDMjEsMTIuNzk0OTg2NyAyMC40NDAzNzUsMTIuMTkyMzE0IDE5Ljc1LDEyLjE5MjMxNCBMMTUuMjUsMTIuMTkyMzE0IEwxNS4yNSw3LjM0NjE1Mjg4IEMxNS4yNSw2LjYwMjY3MjY1IDE0LjY5MDM3NSw2IDE0LDYgWiIgaWQ9IlBhdGgiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 3639 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3640 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3641 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3642 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/429795eabbc698223fca49b7c0a47c63.svg";

/***/ }),
/* 3644 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3645 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wZW5jaWxfaWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJwZW5jaWxfaWNvbiI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy42MTQ0MzAzLDAuMDA1MzA2NDQyNDMgQzYuMDI2NjE4NDMsMC4yMTM5NjQzNTEgLTAuMDEyMzU5NjEzNCw2LjQxOTc1OTEyIDMuNDYxNTg2NDllLTE2LDEzLjk5NTc3NjYgQy0wLjAxMTE3NDQ2NjIsMTguOTk1MjY4MiAyLjY1NDc0OTQ5LDIzLjYxOTc4MzEgNi45OTA5NTc5NSwyNi4xMjI3NjQyIEMxMS4zMjcxNjY0LDI4LjYyNTc0NTMgMTYuNjcyODMzNiwyOC42MjU3NDUzIDIxLjAwOTA0MiwyNi4xMjI3NjQyIEMyNS4zNDUyNTA1LDIzLjYxOTc4MzEgMjguMDExMTc0NSwxOC45OTUyNjgyIDI4LDEzLjk5NTc3NjYgQzI4LjAwNjE0MzIsMTAuMjE5MjM4MyAyNi40ODA0Mjc2LDYuNjAxMDIyNjkgMjMuNzcwNDAyNSwzLjk2NTQyMTk2IEMyMS4wNjAzNzc0LDEuMzI5ODIxMjMgMTcuMzk2ODQ4MiwtMC4wOTg2OTc3NDk2IDEzLjYxNDQzMDMsMC4wMDUzMDY0NDI0MyBaIiBpZD0iUGF0aCIgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC41Ij48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNy43ODM3ODM4LDcuMDY3NjA2OTMgTDE2LjE2Mzg1MTQsOC42NjU5NDAyNyBMMTkuMzgwMDY3NiwxMS44MzkyNzM2IEwyMSwxMC4yNDA5NDAzIEwxNy43ODM3ODM4LDcuMDY3NjA2OTMgWiBNMTUuNjI1ODQ0Niw5LjE5Njc3MzYgTDguNDA3MDk0NTksMTYuMzE5MjczNiBMMTEuNjIzMzEwOCwxOS40OTI2MDY5IEwxOC44NDIwNjA4LDEyLjM3MDEwNjkgTDE1LjYyNTg0NDYsOS4xOTY3NzM2IFogTTcuOTE2Mzg1MTQsMTYuODk2NzczNiBMNywyMC44ODA5NDAzIEwxMS4wMzgwMDY4LDE5Ljk3Njc3MzYgTDcuOTE2Mzg1MTQsMTYuODk2NzczNiBaIiBpZD0iU2hhcGUiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 3646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/a1a749e89f578a49306ec2b055c073da.svg";

/***/ }),
/* 3647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/c5ebe0b32dc1b5cc449a76c4204d13bb.ttf";

/***/ }),
/* 3648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/a046592bac8f2fd96e994733faf3858c.woff";

/***/ }),
/* 3649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/e8c322de9658cbeb8a774b6624167c2c.woff2";

/***/ }),
/* 3650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/962a1bf31c081691065fe333d9fa8105.svg";

/***/ }),
/* 3651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/b87b9ba532ace76ae9f6edfe9f72ded2.ttf";

/***/ }),
/* 3652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/faff92145777a3cbaf8e7367b4807987.woff";

/***/ }),
/* 3653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/0ab54153eeeca0ce03978cc463b257f7.woff2";

/***/ }),
/* 3654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/82f60bd0b94a1ed68b1e6e309ce2e8c3.svg";

/***/ }),
/* 3655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ad97afd3337e8cda302d10ff5a4026b8.ttf";

/***/ }),
/* 3656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/ef60a4f6c25ef7f39f2d25a748dbecfe.woff";

/***/ }),
/* 3657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/cd6c777f1945164224dee082abaea03a.woff2";

/***/ }),
/* 3658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/9c74e172f87984c48ddf5c8108cabe67.png";

/***/ }),
/* 3659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/105048aa75694a2af519dda70a646cda.svg";

/***/ }),
/* 3660 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3661 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"","unitSeparator":"","allSeparator":"و","base":{"0":"صفر","1":"واحد","2":"اثنان","3":"ثلاثة","4":"أربعة","5":"خمسة","6":"ستة","7":"سبعة","8":"ثمانية","9":"تسعة","10":"عشرة","11":"أحد عشر","12":"إثنا عشر","13":"ثلاثة عشر","14":"أربعة عشر","15":"خمسة عشر","16":"ستة عشر","17":"سبعة عشر","18":"ثمانية عشر","19":"تسعة عشر","20":"عشرون","21":"واحد وعشرون","22":"اثنان وعشرون","23":"ثلاثة وعشرون","24":"أربعة وعشرون","25":"خمسة وعشرون","26":"ستة وعشرون","27":"سبعة وعشرون","28":"ثمانية وعشرون","29":"تسعة وعشرون","30":"ثلاثون","31":"واحد وثلاثون","32":"اثنان وثلاثون","33":"ثلاثة وثلاثون","34":"أربعة وثلاثون","35":"خمسة وثلاثون","36":"ستة وثلاثون","37":"سبعة وثلاثون","38":"ثمانية وثلاثون","39":"تسعة وثلاثون","40":"أربعون","41":"واحد وأربعون","42":"اثنان وأربعون","43":"ثلاثة وأربعون","44":"أربعة وأربعون","45":"خمسة وأربعون","46":"ستة وأربعون","47":"سبعة وأربعون","48":"ثمانية وأربعون","49":"تسعة وأربعون","50":"خمسون","51":"واحد وخمسون","52":"اثنان وخمسون","53":"ثلاثة وخمسون","54":"أربعة وخمسون","55":"خمسة وخمسون","56":"ستة وخمسون","57":"سبعة وخمسون","58":"ثمانية وخمسون","59":"تسعة وخمسون","60":"ستون","61":"واحد وستون","62":"اثنان وستون","63":"ثلاثة وستون","64":"أربعة وستون","65":"خمسة وستون","66":"ستة وستون","67":"سبعة وستون","68":"ثمانية وستون","69":"تسعة وستون","70":"سبعون","71":"واحد وسبعون","72":"اثنان وسبعون","73":"ثلاثة وسبعون","74":"أربعة وسبعون","75":"خمسة وسبعون","76":"ستة وسبعون","77":"سبعة وسبعون","78":"ثمانية وسبعون","79":"تسعة وسبعون","80":"ثمانون","81":"واحد وثمانون","82":"اثنان وثمانون","83":"ثلاثة وثمانون","84":"أربعة وثمانون","85":"خمسة وثمانون","86":"ستة وثمانون","87":"سبعة وثمانون","88":"ثمانية وثمانون","89":"تسعة وثمانون","90":"تسعون","91":"واحد وتسعون","92":"اثنان وتسعون","93":"ثلاثة وتسعون","94":"أربعة وتسعون","95":"خمسة وتسعون","96":"ستة وتسعون","97":"سبعة وتسعون","98":"ثمانية وتسعون","99":"تسعة وتسعون","200":"مائتان","300":"ثلاثمائة","400":"أربعمائة","500":"خمسمائة","600":"ستمائة","700":"سبعمائة","800":"ثمانمائة","900":"تسعمائة"},"units":[{"singular":"مائة","useBaseInstead":true,"useBaseException":[1]},{"singular":"ألف","dual":"ألفان","plural":"آلاف","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"مليون","dual":"مليونان","plural":"ملايين","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"مليار","dual":"ملياران","plural":"ملايير","restrictedPlural":true,"avoidPrefixException":[1,2]},{"singular":"تريليون","avoidPrefixException":[1]},{"singular":"كوادريليون","avoidPrefixException":[1]},{"singular":"كوينتليون","avoidPrefixException":[1]},{"singular":"سكستليون","avoidPrefixException":[1]},{"singular":"سبتيلليون","avoidPrefixException":[1]},{"singular":"أوكتيليون","avoidPrefixException":[1]},{"singular":"نونيلليون","avoidPrefixException":[1]},{"singular":"دشيليون","avoidPrefixException":[1]},{"singular":"أوندشيلليون","avoidPrefixException":[1]},{"singular":"دودشيليون","avoidPrefixException":[1]},{"singular":"تريدشيليون","avoidPrefixException":[1]},{"singular":"كواتوردشيليون","avoidPrefixException":[1]},{"singular":"كويندشيليون","avoidPrefixException":[1]}],"unitExceptions":{}}

/***/ }),
/* 3662 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":{"2":"hundred","3":"thousand","5":"lakh","7":"crore"},"unitExceptions":[]}

/***/ }),
/* 3663 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":["hundred","thousand","million","billion","trillion","quadrillion","quintillion","sextillion","septillion","octillion","nonillion","decillion","undecillion","duodecillion","tredecillion","quattuordecillion","quindecillion"],"unitExceptions":[]}

/***/ }),
/* 3664 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"nulo","1":"unu","2":"du","3":"tri","4":"kvar","5":"kvin","6":"ses","7":"sep","8":"ok","9":"naŭ","10":"dek","20":"dudek","30":"tridek","40":"kvardek","50":"kvindek","60":"sesdek","70":"sepdek","80":"okdek","90":"naŭdek","100":"cent","200":"ducent","300":"tricent","400":"kvarcent","500":"kvincent","600":"sescent","700":"sepcent","800":"okcent","900":"naŭcent"},"units":[{"useBaseInstead":true,"useBaseException":[]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"miliono","plural":"milionoj","avoidPrefixException":[1]},{"singular":"miliardo","plural":"miliardoj","avoidPrefixException":[1]},{"singular":"biliono","plural":"bilionoj","avoidPrefixException":[1]}],"unitExceptions":[]}

/***/ }),
/* 3665 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":" y ","unitSeparator":"","base":{"0":"cero","1":"uno","2":"dos","3":"tres","4":"cuatro","5":"cinco","6":"seis","7":"siete","8":"ocho","9":"nueve","10":"diez","11":"once","12":"doce","13":"trece","14":"catorce","15":"quince","16":"dieciséis","17":"diecisiete","18":"dieciocho","19":"diecinueve","20":"veinte","21":"veintiuno","22":"veintidós","23":"veintitrés","24":"veinticuatro","25":"veinticinco","26":"veintiséis","27":"veintisiete","28":"veintiocho","29":"veintinueve","30":"treinta","40":"cuarenta","50":"cincuenta","60":"sesenta","70":"setenta","80":"ochenta","90":"noventa","100":"cien","200":"doscientos","300":"trescientos","400":"cuatrocientos","500":"quinientos","600":"seiscientos","700":"setecientos","800":"ochocientos","900":"novecientos","1000":"mil"},"unitExceptions":{"1000000":"un millón","1000000000000":"un billón","1000000000000000000":"un trillón","1000000000000000000000000":"un cuatrillones","1000000000000000000000000000000":"un quintillón","1000000000000000000000000000000000000":"un sextillón","1000000000000000000000000000000000000000000":"un septillón","1000000000000000000000000000000000000000000000000":"un octillón","1000000000000000000000000000000000000000000000000000000":"un nonillón","1000000000000000000000000000000000000000000000000000000000000":"un decillón","1000000000000000000000000000000000000000000000000000000000000000000":"un undecillón","1000000000000000000000000000000000000000000000000000000000000000000000000":"un duodecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000":"un tredecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000000000":"un cuatordecillón","1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000":"un quindecillón"},"units":[{"singular":"ciento","useBaseInstead":true,"useBaseException":[1]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"millón","plural":"millones"},{"singular":"billón","plural":"billones"},{"singular":"trillón","plural":"trillones"},{"singular":"cuatrillón","plural":"cuatrillones"},{"singular":"quintillón","plural":"quintillones"},{"singular":"sextillón","plural":"sextillones"},{"singular":"septillón","plural":"septillones"},{"singular":"octillón","plural":"octillones"},{"singular":"nonillón","plural":"nonillones"},{"singular":"decillón","plural":"decillones"},{"singular":"undecillón","plural":"undecillones"},{"singular":"duodecillón","plural":"duodecillones"},{"singular":"tredecillón","plural":"tredecillones"},{"singular":"cuatrodecillón","plural":"cuatrodecillones"},{"singular":"quindecillón","plural":"quindecillones"}]}

/***/ }),
/* 3666 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"","base":{"0":"zéro","1":"un","2":"deux","3":"trois","4":"quatre","5":"cinq","6":"six","7":"sept","8":"huit","9":"neuf","10":"dix","11":"onze","12":"douze","13":"treize","14":"quatorze","15":"quinze","16":"seize","17":"dix-sept","18":"dix-huit","19":"dix-neuf","20":"vingt","30":"trente","40":"quarante","50":"cinquante","60":"soixante","70":"soixante-dix","80":"quatre-vingt","90":"quatre-vingt-dix"},"units":[{"singular":"cent","plural":"cents","avoidInNumberPlural":true,"avoidPrefixException":[1]},{"singular":"mille","avoidPrefixException":[1]},{"singular":"million","plural":"millions"},{"singular":"milliard","plural":"milliards"},{"singular":"billion","plural":"billions"},{"singular":"billiard","plural":"billiards"},{"singular":"trillion","plural":"trillions"},{"singular":"trilliard","plural":"trilliards"},{"singular":"quadrillion","plural":"quadrillions"},{"singular":"quadrilliard","plural":"quadrilliards"},{"singular":"quintillion","plural":"quintillions"},{"singular":"quintilliard","plural":"quintilliards"},{"singular":"sextillion","plural":"sextillions"},{"singular":"sextilliard","plural":"sextilliards"},{"singular":"septillion","plural":"septillions"},{"singular":"septilliard","plural":"septilliards"},{"singular":"octillion","plural":"octillions"}],"unitExceptions":{"21":"vingt et un","31":"trente et un","41":"quarante et un","51":"cinquante et un","61":"soixante et un","71":"soixante et onze","72":"soixante-douze","73":"soixante-treize","74":"soixante-quatorze","75":"soixante-quinze","76":"soixante-seize","77":"soixante-dix-sept","78":"soixante-dix-huit","79":"soixante-dix-neuf","80":"quatre-vingts","91":"quatre-vingt-onze","92":"quatre-vingt-douze","93":"quatre-vingt-treize","94":"quatre-vingt-quatorze","95":"quatre-vingt-quinze","96":"quatre-vingt-seize","97":"quatre-vingt-dix-sept","98":"quatre-vingt-dix-huit","99":"quatre-vingt-dix-neuf"}}

/***/ }),
/* 3667 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":"","unitSeparator":"és ","base":{"0":"nulla","1":"egy","2":"kettő","3":"három","4":"négy","5":"öt","6":"hat","7":"hét","8":"nyolc","9":"kilenc","10":"tíz","11":"tizenegy","12":"tizenkettő","13":"tizenhárom","14":"tizennégy","15":"tizenöt","16":"tizenhat","17":"tizenhét","18":"tizennyolc","19":"tizenkilenc","20":"húsz","21":"huszonegy","22":"huszonkettő","23":"huszonhárom","24":"huszonnégy","25":"huszonöt","26":"huszonhat","27":"huszonhét","28":"huszonnyolc","29":"huszonkilenc","30":"harminc","40":"negyven","50":"ötven","60":"hatvan","70":"hetven","80":"nyolcvan","90":"kilencven","100":"száz","200":"kétszáz","300":"háromszáz","400":"négyszáz","500":"ötszáz","600":"hatszáz","700":"hétszáz","800":"nyolcszáz","900":"kilencszáz","1000":"ezer"},"unitExceptions":{"1":"egy"},"units":[{"singular":"száz","useBaseInstead":true,"useBaseException":[1]},{"singular":"ezer","avoidPrefixException":[1]},{"singular":"millió","avoidPrefixException":[1]},{"singular":"milliárd","avoidPrefixException":[1]},{"singular":"-billió","avoidPrefixException":[1]},{"singular":"billiárd","avoidPrefixException":[1]},{"singular":"trillió","avoidPrefixException":[1]},{"singular":"trilliárd","avoidPrefixException":[1]},{"singular":"kvadrillió","avoidPrefixException":[1]},{"singular":"kvadrilliárd","avoidPrefixException":[1]},{"singular":"kvintillió","avoidPrefixException":[1]},{"singular":"kvintilliárd","avoidPrefixException":[1]},{"singular":"szextillió","avoidPrefixException":[1]},{"singular":"szeptillió","avoidPrefixException":[1]},{"singular":"oktillió","avoidPrefixException":[1]},{"singular":"nonillió","avoidPrefixException":[1]}]}

/***/ }),
/* 3668 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"nol","1":"satu","2":"dua","3":"tiga","4":"empat","5":"lima","6":"enam","7":"tujuh","8":"delapan","9":"sembilan","10":"sepuluh","11":"sebelas","12":"dua belas","13":"tiga belas","14":"empat belas","15":"lima belas","16":"enam belas","17":"tujuh belas","18":"delapan belas","19":"sembilan belas","20":"dua puluh","30":"tiga puluh","40":"empat puluh","50":"lima puluh","60":"enam puluh","70":"tujuh puluh","80":"delapan puluh","90":"sembilan puluh"},"units":[{"singular":"seratus","plural":"ratus","avoidPrefixException":[1]},{"singular":"seribu","plural":"ribu","avoidPrefixException":[1]},"juta","miliar","triliun","kuadiliun"],"unitExceptions":[]}

/***/ }),
/* 3669 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"","unitSeparator":"","generalSeparator":"","wordSeparator":"","base":{"0":"zero","1":"uno","2":"due","3":"tre","4":"quattro","5":"cinque","6":"sei","7":"sette","8":"otto","9":"nove","10":"dieci","11":"undici","12":"dodici","13":"tredici","14":"quattordici","15":"quindici","16":"sedici","17":"diciassette","18":"diciotto","19":"diciannove","20":"venti","21":"ventuno","23":"ventitré","28":"ventotto","30":"trenta","31":"trentuno","33":"trentatré","38":"trentotto","40":"quaranta","41":"quarantuno","43":"quaranta­tré","48":"quarantotto","50":"cinquanta","51":"cinquantuno","53":"cinquantatré","58":"cinquantotto","60":"sessanta","61":"sessantuno","63":"sessanta­tré","68":"sessantotto","70":"settanta","71":"settantuno","73":"settantatré","78":"settantotto","80":"ottanta","81":"ottantuno","83":"ottantatré","88":"ottantotto","90":"novanta","91":"novantuno","93":"novantatré","98":"novantotto","100":"cento","101":"centuno","108":"centootto","180":"centottanta","201":"duecentuno","301":"tre­cent­uno","401":"quattro­cent­uno","501":"cinque­cent­uno","601":"sei­cent­uno","701":"sette­cent­uno","801":"otto­cent­uno","901":"nove­cent­uno"},"unitExceptions":{"1":"un"},"units":[{"singular":"cento","avoidPrefixException":[1]},{"singular":"mille","plural":"mila","avoidPrefixException":[1]},{"singular":"milione","plural":"milioni"},{"singular":"miliardo","plural":"miliardi"},{"singular":"bilione","plural":"bilioni"},{"singular":"biliardo","plural":"biliardi"},{"singular":"trilione","plural":"trilioni"},{"singular":"triliardo","plural":"triliardi"},{"singular":"quadrilione","plural":"quadrilioni"},{"singular":"quadriliardo","plural":"quadriliardi"}]}

/***/ }),
/* 3670 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":" e ","unitSeparator":"e ","andWhenTrailing":true,"base":{"0":"zero","1":"um","2":"dois","3":"três","4":"quatro","5":"cinco","6":"seis","7":"sete","8":"oito","9":"nove","10":"dez","11":"onze","12":"doze","13":"treze","14":"catorze","15":"quinze","16":"dezasseis","17":"dezassete","18":"dezoito","19":"dezanove","20":"vinte","30":"trinta","40":"quarenta","50":"cinquenta","60":"sessenta","70":"setenta","80":"oitenta","90":"noventa","100":"cem","200":"duzentos","300":"trezentos","400":"quatrocentos","500":"quinhentos","600":"seiscentos","700":"setecentos","800":"oitocentos","900":"novecentos","1000":"mil"},"unitExceptions":{"1":"um"},"units":[{"singular":"cento","useBaseInstead":true,"useBaseException":[1],"useBaseExceptionWhenNoTrailingNumbers":true,"andException":true},{"singular":"mil","avoidPrefixException":[1],"andException":true},{"singular":"milhão","plural":"milhões"},{"singular":"bilião","plural":"biliões"},{"singular":"trilião","plural":"triliões"},{"singular":"quadrilião","plural":"quadriliões"},{"singular":"quintilião","plural":"quintiliões"},{"singular":"sextilião","plural":"sextiliões"},{"singular":"septilião","plural":"septiliões"},{"singular":"octilião","plural":"octiliões"},{"singular":"nonilião","plural":"noniliões"},{"singular":"decilião","plural":"deciliões"}]}

/***/ }),
/* 3671 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" e ","unitSeparator":"e ","andWhenTrailing":true,"base":{"0":"zero","1":"um","2":"dois","3":"três","4":"quatro","5":"cinco","6":"seis","7":"sete","8":"oito","9":"nove","10":"dez","11":"onze","12":"doze","13":"treze","14":"catorze","15":"quinze","16":"dezesseis","17":"dezessete","18":"dezoito","19":"dezenove","20":"vinte","30":"trinta","40":"quarenta","50":"cinquenta","60":"sessenta","70":"setenta","80":"oitenta","90":"noventa","100":"cem","200":"duzentos","300":"trezentos","400":"quatrocentos","500":"quinhentos","600":"seiscentos","700":"setecentos","800":"oitocentos","900":"novecentos","1000":"mil"},"unitExceptions":{"1":"um"},"units":[{"singular":"cento","useBaseInstead":true,"useBaseException":[1],"useBaseExceptionWhenNoTrailingNumbers":true,"andException":true},{"singular":"mil","avoidPrefixException":[1],"andException":true},{"singular":"milhão","plural":"milhões"},{"singular":"bilhão","plural":"bilhões"},{"singular":"trilhão","plural":"trilhões"},{"singular":"quadrilhão","plural":"quadrilhão"},{"singular":"quintilhão","plural":"quintilhões"},{"singular":"sextilhão","plural":"sextilhões"},{"singular":"septilhão","plural":"septilhões"},{"singular":"octilhão","plural":"octilhões"},{"singular":"nonilhão","plural":"nonilhões"},{"singular":"decilhão","plural":"decilhões"},{"singular":"undecilhão","plural":"undecilhões"},{"singular":"doudecilhão","plural":"doudecilhões"},{"singular":"tredecilhão","plural":"tredecilhões"}]}

/***/ }),
/* 3672 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"sıfır","1":"bir","2":"iki","3":"üç","4":"dört","5":"beş","6":"altı","7":"yedi","8":"sekiz","9":"dokuz","10":"on","20":"yirmi","30":"otuz","40":"kırk","50":"elli","60":"altmış","70":"yetmiş","80":"seksen","90":"doksan"},"units":[{"singular":"yüz","avoidPrefixException":[1]},{"singular":"bin","avoidPrefixException":[1]},"milyon","milyar","trilyon","katrilyon","kentilyon","sekstilyon","septilyon","oktilyon","nonilyon","desilyon","andesilyon","dodesilyon","tredesilyon","katordesilyon","kendesilyon"],"unitExceptions":[]}

/***/ }),
/* 3673 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"нуль","1":"один","2":"два","3":"три","4":"чотири","5":"п’ять","6":"шість","7":"сім","8":"вісім","9":"дев’ять","10":"десять","11":"одинадцять","12":"дванадцять","13":"тринадцять","14":"чотирнадцять","15":"п’ятнадцять","16":"шістнадцять","17":"сімнадцять","18":"вісімнадцять","19":"дев’ятнадцять","20":"двадцять","30":"тридцять","40":"сорок","50":"п’ятдесят","60":"шістдесят","70":"сімдесят","80":"вісімдесят","90":"дев’яносто","100":"сто","200":"двісті","300":"триста","400":"чотириста","500":"п’ятсот","600":"шістсот","700":"сімсот","800":"вісімсот","900":"дев’ятсот"},"alternativeBase":{"feminine":{"1":"одна","2":"дві"}},"units":[{"useBaseInstead":true,"useBaseException":[]},{"singular":"тисяча","few":"тисячі","plural":"тисяч","useAlternativeBase":"feminine","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"мільйон","few":"мільйони","plural":"мільйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"мільярд","few":"мільярди","plural":"мільярдів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"трильйон","few":"трильйони","plural":"трильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квадрильйон","few":"квадрильйони","plural":"квадрильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квінтильйон","few":"квінтильйони","plural":"квінтильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"секстильйон","few":"секстильйони","plural":"секстильйонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"септілліон","few":"септілліони","plural":"септілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"октілліон","few":"октілліони","plural":"октілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"нонілліон","few":"нонілліони","plural":"нонілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"децілліон","few":"децілліони","plural":"децілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"ундецілліон","few":"ундецілліони","plural":"ундецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"дуодецілліон","few":"дуодецілліони","plural":"дуодецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"тредецілліон","few":"тредецілліони","plural":"тредецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"кватуордецілліон","few":"кватуордецілліони","plural":"кватуордецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]},{"singular":"квіндецілліон","few":"квіндецілліони","plural":"квіндецілліонів","useSingularEnding":true,"useFewEnding":true,"avoidEndingRules":[11,12,13,14,111,112,113,114,211,212,213,214,311,312,313,314,411,412,413,414,511,512,513,514,611,612,613,614,711,712,713,714,811,812,813,814,911,912,913,914]}],"unitExceptions":[]}

/***/ }),
/* 3674 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"và ","base":{"0":"không","1":"một","2":"hai","3":"ba","4":"bốn","5":"năm","6":"sáu","7":"bảy","8":"tám","9":"chín","10":"mười","15":"mười lăm","20":"hai mươi","21":"hai mươi mốt","25":"hai mươi lăm","30":"ba mươi","31":"ba mươi mốt","40":"bốn mươi","41":"bốn mươi mốt","45":"bốn mươi lăm","50":"năm mươi","51":"năm mươi mốt","55":"năm mươi lăm","60":"sáu mươi","61":"sáu mươi mốt","65":"sáu mươi lăm","70":"bảy mươi","71":"bảy mươi mốt","75":"bảy mươi lăm","80":"tám mươi","81":"tám mươi mốt","85":"tám mươi lăm","90":"chín mươi","91":"chín mươi mốt","95":"chín mươi lăm"},"units":["trăm","ngàn","triệu","tỷ","nghìn tỷ"],"unitExceptions":[]}

/***/ }),
/* 3675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1514);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app-85fec58c04b08feb4896.js